
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecbe4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecbe4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e2Upa", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $a39d016bd32aee38$export$ffb0004e005737fa, (v) => $a39d016bd32aee38$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $a39d016bd32aee38$export$34b9dba7ce09269b, (v) => $a39d016bd32aee38$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $a39d016bd32aee38$export$25062201e9e25d76, (v) => $a39d016bd32aee38$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a39d016bd32aee38$export$ffb0004e005737fa;
var $a39d016bd32aee38$export$34b9dba7ce09269b;
var $a39d016bd32aee38$export$25062201e9e25d76;
'use strict';

var $1OEoy = parcelRequire("1OEoy");
var $a39d016bd32aee38$var$k = Symbol.for("react.element"), $a39d016bd32aee38$var$l = Symbol.for("react.fragment"), $a39d016bd32aee38$var$m = Object.prototype.hasOwnProperty, $a39d016bd32aee38$var$n = $1OEoy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a39d016bd32aee38$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a39d016bd32aee38$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$a39d016bd32aee38$var$m.call(a, b) && !$a39d016bd32aee38$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a39d016bd32aee38$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $a39d016bd32aee38$var$n.current
    };
}
$a39d016bd32aee38$export$ffb0004e005737fa = $a39d016bd32aee38$var$l;
$a39d016bd32aee38$export$34b9dba7ce09269b = $a39d016bd32aee38$var$q;
$a39d016bd32aee38$export$25062201e9e25d76 = $a39d016bd32aee38$var$q;

});
parcelRegister("1OEoy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8E0cw"));

});
parcelRegister("8E0cw", function(module, exports) {

$parcel$export(module.exports, "Children", () => $64b2370c3f967be9$export$dca3b0875bd9a954, (v) => $64b2370c3f967be9$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $64b2370c3f967be9$export$16fa2f45be04daa8, (v) => $64b2370c3f967be9$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $64b2370c3f967be9$export$ffb0004e005737fa, (v) => $64b2370c3f967be9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $64b2370c3f967be9$export$e2c29f18771995cb, (v) => $64b2370c3f967be9$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $64b2370c3f967be9$export$221d75b3f55bb0bd, (v) => $64b2370c3f967be9$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $64b2370c3f967be9$export$5f8d39834fd61797, (v) => $64b2370c3f967be9$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $64b2370c3f967be9$export$74bf444e3cd11ea5, (v) => $64b2370c3f967be9$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $64b2370c3f967be9$export$ae55be85d98224ed, (v) => $64b2370c3f967be9$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $64b2370c3f967be9$export$3ba232387fd5d6dd, (v) => $64b2370c3f967be9$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $64b2370c3f967be9$export$e530037191fcd5d7, (v) => $64b2370c3f967be9$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $64b2370c3f967be9$export$fd42f52fd3ae1109, (v) => $64b2370c3f967be9$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $64b2370c3f967be9$export$c8a8987d4410bf2d, (v) => $64b2370c3f967be9$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $64b2370c3f967be9$export$d38cd72104c1f0e9, (v) => $64b2370c3f967be9$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $64b2370c3f967be9$export$7d1e3a5e95ceca43, (v) => $64b2370c3f967be9$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $64b2370c3f967be9$export$257a8862b851cb5b, (v) => $64b2370c3f967be9$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $64b2370c3f967be9$export$a8257692ac88316c, (v) => $64b2370c3f967be9$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $64b2370c3f967be9$export$488013bae63b21da, (v) => $64b2370c3f967be9$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $64b2370c3f967be9$export$7c73462e0d25e514, (v) => $64b2370c3f967be9$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $64b2370c3f967be9$export$7568632d0d33d16d, (v) => $64b2370c3f967be9$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $64b2370c3f967be9$export$88948ce120ea2619, (v) => $64b2370c3f967be9$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $64b2370c3f967be9$export$35808ee640e87ca7, (v) => $64b2370c3f967be9$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $64b2370c3f967be9$export$fae74005e78b1a27, (v) => $64b2370c3f967be9$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $64b2370c3f967be9$export$dc8fbce3eb94dc1e, (v) => $64b2370c3f967be9$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $64b2370c3f967be9$export$6a7bc4e911dc01cf, (v) => $64b2370c3f967be9$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $64b2370c3f967be9$export$6d9c69b0de29b591, (v) => $64b2370c3f967be9$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $64b2370c3f967be9$export$f680877a34711e37, (v) => $64b2370c3f967be9$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $64b2370c3f967be9$export$d5a552a76deda3c2, (v) => $64b2370c3f967be9$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $64b2370c3f967be9$export$aaabe4eda9ed9969, (v) => $64b2370c3f967be9$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $64b2370c3f967be9$export$e5c5a5f917a5871c, (v) => $64b2370c3f967be9$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $64b2370c3f967be9$export$1538c33de8887b59, (v) => $64b2370c3f967be9$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $64b2370c3f967be9$export$13e3392192263954, (v) => $64b2370c3f967be9$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $64b2370c3f967be9$export$b8f5890fc79d6aca, (v) => $64b2370c3f967be9$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $64b2370c3f967be9$export$60241385465d0a34, (v) => $64b2370c3f967be9$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $64b2370c3f967be9$export$306c0aa65ff9ec16, (v) => $64b2370c3f967be9$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $64b2370c3f967be9$export$7b286972b8d8ccbf, (v) => $64b2370c3f967be9$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $64b2370c3f967be9$export$83d89fbfd8236492, (v) => $64b2370c3f967be9$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $64b2370c3f967be9$export$dca3b0875bd9a954;
var $64b2370c3f967be9$export$16fa2f45be04daa8;
var $64b2370c3f967be9$export$ffb0004e005737fa;
var $64b2370c3f967be9$export$e2c29f18771995cb;
var $64b2370c3f967be9$export$221d75b3f55bb0bd;
var $64b2370c3f967be9$export$5f8d39834fd61797;
var $64b2370c3f967be9$export$74bf444e3cd11ea5;
var $64b2370c3f967be9$export$ae55be85d98224ed;
var $64b2370c3f967be9$export$3ba232387fd5d6dd;
var $64b2370c3f967be9$export$e530037191fcd5d7;
var $64b2370c3f967be9$export$fd42f52fd3ae1109;
var $64b2370c3f967be9$export$c8a8987d4410bf2d;
var $64b2370c3f967be9$export$d38cd72104c1f0e9;
var $64b2370c3f967be9$export$7d1e3a5e95ceca43;
var $64b2370c3f967be9$export$257a8862b851cb5b;
var $64b2370c3f967be9$export$a8257692ac88316c;
var $64b2370c3f967be9$export$488013bae63b21da;
var $64b2370c3f967be9$export$7c73462e0d25e514;
var $64b2370c3f967be9$export$7568632d0d33d16d;
var $64b2370c3f967be9$export$88948ce120ea2619;
var $64b2370c3f967be9$export$35808ee640e87ca7;
var $64b2370c3f967be9$export$fae74005e78b1a27;
var $64b2370c3f967be9$export$dc8fbce3eb94dc1e;
var $64b2370c3f967be9$export$6a7bc4e911dc01cf;
var $64b2370c3f967be9$export$6d9c69b0de29b591;
var $64b2370c3f967be9$export$f680877a34711e37;
var $64b2370c3f967be9$export$d5a552a76deda3c2;
var $64b2370c3f967be9$export$aaabe4eda9ed9969;
var $64b2370c3f967be9$export$e5c5a5f917a5871c;
var $64b2370c3f967be9$export$1538c33de8887b59;
var $64b2370c3f967be9$export$13e3392192263954;
var $64b2370c3f967be9$export$b8f5890fc79d6aca;
var $64b2370c3f967be9$export$60241385465d0a34;
var $64b2370c3f967be9$export$306c0aa65ff9ec16;
var $64b2370c3f967be9$export$7b286972b8d8ccbf;
var $64b2370c3f967be9$export$83d89fbfd8236492;
'use strict';
var $64b2370c3f967be9$var$l = Symbol.for("react.element"), $64b2370c3f967be9$var$n = Symbol.for("react.portal"), $64b2370c3f967be9$var$p = Symbol.for("react.fragment"), $64b2370c3f967be9$var$q = Symbol.for("react.strict_mode"), $64b2370c3f967be9$var$r = Symbol.for("react.profiler"), $64b2370c3f967be9$var$t = Symbol.for("react.provider"), $64b2370c3f967be9$var$u = Symbol.for("react.context"), $64b2370c3f967be9$var$v = Symbol.for("react.forward_ref"), $64b2370c3f967be9$var$w = Symbol.for("react.suspense"), $64b2370c3f967be9$var$x = Symbol.for("react.memo"), $64b2370c3f967be9$var$y = Symbol.for("react.lazy"), $64b2370c3f967be9$var$z = Symbol.iterator;
function $64b2370c3f967be9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $64b2370c3f967be9$var$z && a[$64b2370c3f967be9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $64b2370c3f967be9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $64b2370c3f967be9$var$C = Object.assign, $64b2370c3f967be9$var$D = {};
function $64b2370c3f967be9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b2370c3f967be9$var$D;
    this.updater = e || $64b2370c3f967be9$var$B;
}
$64b2370c3f967be9$var$E.prototype.isReactComponent = {};
$64b2370c3f967be9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$64b2370c3f967be9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $64b2370c3f967be9$var$F() {}
$64b2370c3f967be9$var$F.prototype = $64b2370c3f967be9$var$E.prototype;
function $64b2370c3f967be9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b2370c3f967be9$var$D;
    this.updater = e || $64b2370c3f967be9$var$B;
}
var $64b2370c3f967be9$var$H = $64b2370c3f967be9$var$G.prototype = new $64b2370c3f967be9$var$F;
$64b2370c3f967be9$var$H.constructor = $64b2370c3f967be9$var$G;
$64b2370c3f967be9$var$C($64b2370c3f967be9$var$H, $64b2370c3f967be9$var$E.prototype);
$64b2370c3f967be9$var$H.isPureReactComponent = !0;
var $64b2370c3f967be9$var$I = Array.isArray, $64b2370c3f967be9$var$J = Object.prototype.hasOwnProperty, $64b2370c3f967be9$var$K = {
    current: null
}, $64b2370c3f967be9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $64b2370c3f967be9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$64b2370c3f967be9$var$J.call(b, d) && !$64b2370c3f967be9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $64b2370c3f967be9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $64b2370c3f967be9$var$K.current
    };
}
function $64b2370c3f967be9$var$N(a, b) {
    return {
        $$typeof: $64b2370c3f967be9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $64b2370c3f967be9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $64b2370c3f967be9$var$l;
}
function $64b2370c3f967be9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $64b2370c3f967be9$var$P = /\/+/g;
function $64b2370c3f967be9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $64b2370c3f967be9$var$escape("" + a.key) : b.toString(36);
}
function $64b2370c3f967be9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $64b2370c3f967be9$var$l:
                case $64b2370c3f967be9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $64b2370c3f967be9$var$Q(h, 0) : d, $64b2370c3f967be9$var$I(c) ? (e = "", null != a && (e = a.replace($64b2370c3f967be9$var$P, "$&/") + "/"), $64b2370c3f967be9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($64b2370c3f967be9$var$O(c) && (c = $64b2370c3f967be9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($64b2370c3f967be9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($64b2370c3f967be9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $64b2370c3f967be9$var$Q(k, g);
        h += $64b2370c3f967be9$var$R(k, b, e, f, c);
    }
    else if (f = $64b2370c3f967be9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $64b2370c3f967be9$var$Q(k, g++), h += $64b2370c3f967be9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $64b2370c3f967be9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $64b2370c3f967be9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $64b2370c3f967be9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $64b2370c3f967be9$var$U = {
    current: null
}, $64b2370c3f967be9$var$V = {
    transition: null
}, $64b2370c3f967be9$var$W = {
    ReactCurrentDispatcher: $64b2370c3f967be9$var$U,
    ReactCurrentBatchConfig: $64b2370c3f967be9$var$V,
    ReactCurrentOwner: $64b2370c3f967be9$var$K
};
function $64b2370c3f967be9$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$64b2370c3f967be9$export$dca3b0875bd9a954 = {
    map: $64b2370c3f967be9$var$S,
    forEach: function(a, b, e) {
        $64b2370c3f967be9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $64b2370c3f967be9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $64b2370c3f967be9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$64b2370c3f967be9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$64b2370c3f967be9$export$16fa2f45be04daa8 = $64b2370c3f967be9$var$E;
$64b2370c3f967be9$export$ffb0004e005737fa = $64b2370c3f967be9$var$p;
$64b2370c3f967be9$export$e2c29f18771995cb = $64b2370c3f967be9$var$r;
$64b2370c3f967be9$export$221d75b3f55bb0bd = $64b2370c3f967be9$var$G;
$64b2370c3f967be9$export$5f8d39834fd61797 = $64b2370c3f967be9$var$q;
$64b2370c3f967be9$export$74bf444e3cd11ea5 = $64b2370c3f967be9$var$w;
$64b2370c3f967be9$export$ae55be85d98224ed = $64b2370c3f967be9$var$W;
$64b2370c3f967be9$export$3ba232387fd5d6dd = $64b2370c3f967be9$var$X;
$64b2370c3f967be9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $64b2370c3f967be9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $64b2370c3f967be9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$64b2370c3f967be9$var$J.call(b, f) && !$64b2370c3f967be9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $64b2370c3f967be9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$64b2370c3f967be9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $64b2370c3f967be9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $64b2370c3f967be9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$64b2370c3f967be9$export$c8a8987d4410bf2d = $64b2370c3f967be9$var$M;
$64b2370c3f967be9$export$d38cd72104c1f0e9 = function(a) {
    var b = $64b2370c3f967be9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$64b2370c3f967be9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$64b2370c3f967be9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $64b2370c3f967be9$var$v,
        render: a
    };
};
$64b2370c3f967be9$export$a8257692ac88316c = $64b2370c3f967be9$var$O;
$64b2370c3f967be9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $64b2370c3f967be9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $64b2370c3f967be9$var$T
    };
};
$64b2370c3f967be9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $64b2370c3f967be9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$64b2370c3f967be9$export$7568632d0d33d16d = function(a) {
    var b = $64b2370c3f967be9$var$V.transition;
    $64b2370c3f967be9$var$V.transition = {};
    try {
        a();
    } finally{
        $64b2370c3f967be9$var$V.transition = b;
    }
};
$64b2370c3f967be9$export$88948ce120ea2619 = $64b2370c3f967be9$var$X;
$64b2370c3f967be9$export$35808ee640e87ca7 = function(a, b) {
    return $64b2370c3f967be9$var$U.current.useCallback(a, b);
};
$64b2370c3f967be9$export$fae74005e78b1a27 = function(a) {
    return $64b2370c3f967be9$var$U.current.useContext(a);
};
$64b2370c3f967be9$export$dc8fbce3eb94dc1e = function() {};
$64b2370c3f967be9$export$6a7bc4e911dc01cf = function(a) {
    return $64b2370c3f967be9$var$U.current.useDeferredValue(a);
};
$64b2370c3f967be9$export$6d9c69b0de29b591 = function(a, b) {
    return $64b2370c3f967be9$var$U.current.useEffect(a, b);
};
$64b2370c3f967be9$export$f680877a34711e37 = function() {
    return $64b2370c3f967be9$var$U.current.useId();
};
$64b2370c3f967be9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $64b2370c3f967be9$var$U.current.useImperativeHandle(a, b, e);
};
$64b2370c3f967be9$export$aaabe4eda9ed9969 = function(a, b) {
    return $64b2370c3f967be9$var$U.current.useInsertionEffect(a, b);
};
$64b2370c3f967be9$export$e5c5a5f917a5871c = function(a, b) {
    return $64b2370c3f967be9$var$U.current.useLayoutEffect(a, b);
};
$64b2370c3f967be9$export$1538c33de8887b59 = function(a, b) {
    return $64b2370c3f967be9$var$U.current.useMemo(a, b);
};
$64b2370c3f967be9$export$13e3392192263954 = function(a, b, e) {
    return $64b2370c3f967be9$var$U.current.useReducer(a, b, e);
};
$64b2370c3f967be9$export$b8f5890fc79d6aca = function(a) {
    return $64b2370c3f967be9$var$U.current.useRef(a);
};
$64b2370c3f967be9$export$60241385465d0a34 = function(a) {
    return $64b2370c3f967be9$var$U.current.useState(a);
};
$64b2370c3f967be9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $64b2370c3f967be9$var$U.current.useSyncExternalStore(a, b, e);
};
$64b2370c3f967be9$export$7b286972b8d8ccbf = function() {
    return $64b2370c3f967be9$var$U.current.useTransition();
};
$64b2370c3f967be9$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("dllUs", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $9b6e3b5559a9e9a5$export$ae55be85d98224ed, (v) => $9b6e3b5559a9e9a5$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $9b6e3b5559a9e9a5$export$d39a5bbd09211389, (v) => $9b6e3b5559a9e9a5$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $9b6e3b5559a9e9a5$export$882461b6382ed46c, (v) => $9b6e3b5559a9e9a5$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $9b6e3b5559a9e9a5$export$466bfc07425424d5, (v) => $9b6e3b5559a9e9a5$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $9b6e3b5559a9e9a5$export$cd75ccfd720a3cd4, (v) => $9b6e3b5559a9e9a5$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $9b6e3b5559a9e9a5$export$fa8d919ba61d84db, (v) => $9b6e3b5559a9e9a5$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $9b6e3b5559a9e9a5$export$757ceba2d55c277e, (v) => $9b6e3b5559a9e9a5$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $9b6e3b5559a9e9a5$export$b3890eb0ae9dca99, (v) => $9b6e3b5559a9e9a5$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $9b6e3b5559a9e9a5$export$502457920280e6be, (v) => $9b6e3b5559a9e9a5$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $9b6e3b5559a9e9a5$export$c78a37762a8d58e1, (v) => $9b6e3b5559a9e9a5$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $9b6e3b5559a9e9a5$export$dc54d992c10e8a18, (v) => $9b6e3b5559a9e9a5$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $9b6e3b5559a9e9a5$export$83d89fbfd8236492, (v) => $9b6e3b5559a9e9a5$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9b6e3b5559a9e9a5$export$ae55be85d98224ed;
var $9b6e3b5559a9e9a5$export$d39a5bbd09211389;
var $9b6e3b5559a9e9a5$export$882461b6382ed46c;
var $9b6e3b5559a9e9a5$export$466bfc07425424d5;
var $9b6e3b5559a9e9a5$export$cd75ccfd720a3cd4;
var $9b6e3b5559a9e9a5$export$fa8d919ba61d84db;
var $9b6e3b5559a9e9a5$export$757ceba2d55c277e;
var $9b6e3b5559a9e9a5$export$b3890eb0ae9dca99;
var $9b6e3b5559a9e9a5$export$502457920280e6be;
var $9b6e3b5559a9e9a5$export$c78a37762a8d58e1;
var $9b6e3b5559a9e9a5$export$dc54d992c10e8a18;
var $9b6e3b5559a9e9a5$export$83d89fbfd8236492;
'use strict';

var $1OEoy = parcelRequire("1OEoy");

var $fYajP = parcelRequire("fYajP");
function $9b6e3b5559a9e9a5$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9b6e3b5559a9e9a5$var$da = new Set, $9b6e3b5559a9e9a5$var$ea = {};
function $9b6e3b5559a9e9a5$var$fa(a, b) {
    $9b6e3b5559a9e9a5$var$ha(a, b);
    $9b6e3b5559a9e9a5$var$ha(a + "Capture", b);
}
function $9b6e3b5559a9e9a5$var$ha(a, b) {
    $9b6e3b5559a9e9a5$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9b6e3b5559a9e9a5$var$da.add(b[a]);
}
var $9b6e3b5559a9e9a5$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9b6e3b5559a9e9a5$var$ja = Object.prototype.hasOwnProperty, $9b6e3b5559a9e9a5$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9b6e3b5559a9e9a5$var$la = {}, $9b6e3b5559a9e9a5$var$ma = {};
function $9b6e3b5559a9e9a5$var$oa(a) {
    if ($9b6e3b5559a9e9a5$var$ja.call($9b6e3b5559a9e9a5$var$ma, a)) return !0;
    if ($9b6e3b5559a9e9a5$var$ja.call($9b6e3b5559a9e9a5$var$la, a)) return !1;
    if ($9b6e3b5559a9e9a5$var$ka.test(a)) return $9b6e3b5559a9e9a5$var$ma[a] = !0;
    $9b6e3b5559a9e9a5$var$la[a] = !0;
    return !1;
}
function $9b6e3b5559a9e9a5$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9b6e3b5559a9e9a5$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9b6e3b5559a9e9a5$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9b6e3b5559a9e9a5$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9b6e3b5559a9e9a5$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9b6e3b5559a9e9a5$var$z[b] = new $9b6e3b5559a9e9a5$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9b6e3b5559a9e9a5$var$ra = /[\-:]([a-z])/g;
function $9b6e3b5559a9e9a5$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9b6e3b5559a9e9a5$var$ra, $9b6e3b5559a9e9a5$var$sa);
    $9b6e3b5559a9e9a5$var$z[b] = new $9b6e3b5559a9e9a5$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9b6e3b5559a9e9a5$var$ra, $9b6e3b5559a9e9a5$var$sa);
    $9b6e3b5559a9e9a5$var$z[b] = new $9b6e3b5559a9e9a5$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9b6e3b5559a9e9a5$var$ra, $9b6e3b5559a9e9a5$var$sa);
    $9b6e3b5559a9e9a5$var$z[b] = new $9b6e3b5559a9e9a5$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9b6e3b5559a9e9a5$var$z.xlinkHref = new $9b6e3b5559a9e9a5$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9b6e3b5559a9e9a5$var$z[a] = new $9b6e3b5559a9e9a5$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9b6e3b5559a9e9a5$var$ta(a, b, c, d) {
    var e = $9b6e3b5559a9e9a5$var$z.hasOwnProperty(b) ? $9b6e3b5559a9e9a5$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9b6e3b5559a9e9a5$var$qa(b, c, e, d) && (c = null), d || null === e ? $9b6e3b5559a9e9a5$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9b6e3b5559a9e9a5$var$ua = $1OEoy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9b6e3b5559a9e9a5$var$va = Symbol.for("react.element"), $9b6e3b5559a9e9a5$var$wa = Symbol.for("react.portal"), $9b6e3b5559a9e9a5$var$ya = Symbol.for("react.fragment"), $9b6e3b5559a9e9a5$var$za = Symbol.for("react.strict_mode"), $9b6e3b5559a9e9a5$var$Aa = Symbol.for("react.profiler"), $9b6e3b5559a9e9a5$var$Ba = Symbol.for("react.provider"), $9b6e3b5559a9e9a5$var$Ca = Symbol.for("react.context"), $9b6e3b5559a9e9a5$var$Da = Symbol.for("react.forward_ref"), $9b6e3b5559a9e9a5$var$Ea = Symbol.for("react.suspense"), $9b6e3b5559a9e9a5$var$Fa = Symbol.for("react.suspense_list"), $9b6e3b5559a9e9a5$var$Ga = Symbol.for("react.memo"), $9b6e3b5559a9e9a5$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9b6e3b5559a9e9a5$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9b6e3b5559a9e9a5$var$Ja = Symbol.iterator;
function $9b6e3b5559a9e9a5$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9b6e3b5559a9e9a5$var$Ja && a[$9b6e3b5559a9e9a5$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9b6e3b5559a9e9a5$var$A = Object.assign, $9b6e3b5559a9e9a5$var$La;
function $9b6e3b5559a9e9a5$var$Ma(a) {
    if (void 0 === $9b6e3b5559a9e9a5$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9b6e3b5559a9e9a5$var$La = b && b[1] || "";
    }
    return "\n" + $9b6e3b5559a9e9a5$var$La + a;
}
var $9b6e3b5559a9e9a5$var$Na = !1;
function $9b6e3b5559a9e9a5$var$Oa(a, b) {
    if (!a || $9b6e3b5559a9e9a5$var$Na) return "";
    $9b6e3b5559a9e9a5$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9b6e3b5559a9e9a5$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9b6e3b5559a9e9a5$var$Ma(a) : "";
}
function $9b6e3b5559a9e9a5$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9b6e3b5559a9e9a5$var$Ma(a.type);
        case 16:
            return $9b6e3b5559a9e9a5$var$Ma("Lazy");
        case 13:
            return $9b6e3b5559a9e9a5$var$Ma("Suspense");
        case 19:
            return $9b6e3b5559a9e9a5$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9b6e3b5559a9e9a5$var$Oa(a.type, !1), a;
        case 11:
            return a = $9b6e3b5559a9e9a5$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9b6e3b5559a9e9a5$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9b6e3b5559a9e9a5$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9b6e3b5559a9e9a5$var$ya:
            return "Fragment";
        case $9b6e3b5559a9e9a5$var$wa:
            return "Portal";
        case $9b6e3b5559a9e9a5$var$Aa:
            return "Profiler";
        case $9b6e3b5559a9e9a5$var$za:
            return "StrictMode";
        case $9b6e3b5559a9e9a5$var$Ea:
            return "Suspense";
        case $9b6e3b5559a9e9a5$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9b6e3b5559a9e9a5$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9b6e3b5559a9e9a5$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9b6e3b5559a9e9a5$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9b6e3b5559a9e9a5$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9b6e3b5559a9e9a5$var$Qa(a.type) || "Memo";
        case $9b6e3b5559a9e9a5$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9b6e3b5559a9e9a5$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9b6e3b5559a9e9a5$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9b6e3b5559a9e9a5$var$Qa(b);
        case 8:
            return b === $9b6e3b5559a9e9a5$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9b6e3b5559a9e9a5$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9b6e3b5559a9e9a5$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9b6e3b5559a9e9a5$var$Ua(a) {
    var b = $9b6e3b5559a9e9a5$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9b6e3b5559a9e9a5$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9b6e3b5559a9e9a5$var$Ua(a));
}
function $9b6e3b5559a9e9a5$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9b6e3b5559a9e9a5$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9b6e3b5559a9e9a5$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9b6e3b5559a9e9a5$var$Ya(a, b) {
    var c = b.checked;
    return $9b6e3b5559a9e9a5$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9b6e3b5559a9e9a5$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9b6e3b5559a9e9a5$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9b6e3b5559a9e9a5$var$ab(a, b) {
    b = b.checked;
    null != b && $9b6e3b5559a9e9a5$var$ta(a, "checked", b, !1);
}
function $9b6e3b5559a9e9a5$var$bb(a, b) {
    $9b6e3b5559a9e9a5$var$ab(a, b);
    var c = $9b6e3b5559a9e9a5$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9b6e3b5559a9e9a5$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9b6e3b5559a9e9a5$var$cb(a, b.type, $9b6e3b5559a9e9a5$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9b6e3b5559a9e9a5$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9b6e3b5559a9e9a5$var$cb(a, b, c) {
    if ("number" !== b || $9b6e3b5559a9e9a5$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9b6e3b5559a9e9a5$var$eb = Array.isArray;
function $9b6e3b5559a9e9a5$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9b6e3b5559a9e9a5$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9b6e3b5559a9e9a5$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9b6e3b5559a9e9a5$var$p(91));
    return $9b6e3b5559a9e9a5$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9b6e3b5559a9e9a5$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9b6e3b5559a9e9a5$var$p(92));
            if ($9b6e3b5559a9e9a5$var$eb(c)) {
                if (1 < c.length) throw Error($9b6e3b5559a9e9a5$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9b6e3b5559a9e9a5$var$Sa(c)
    };
}
function $9b6e3b5559a9e9a5$var$ib(a, b) {
    var c = $9b6e3b5559a9e9a5$var$Sa(b.value), d = $9b6e3b5559a9e9a5$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9b6e3b5559a9e9a5$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9b6e3b5559a9e9a5$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9b6e3b5559a9e9a5$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9b6e3b5559a9e9a5$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9b6e3b5559a9e9a5$var$mb, $9b6e3b5559a9e9a5$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9b6e3b5559a9e9a5$var$mb = $9b6e3b5559a9e9a5$var$mb || document.createElement("div");
        $9b6e3b5559a9e9a5$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9b6e3b5559a9e9a5$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9b6e3b5559a9e9a5$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9b6e3b5559a9e9a5$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9b6e3b5559a9e9a5$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9b6e3b5559a9e9a5$var$pb).forEach(function(a) {
    $9b6e3b5559a9e9a5$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9b6e3b5559a9e9a5$var$pb[b] = $9b6e3b5559a9e9a5$var$pb[a];
    });
});
function $9b6e3b5559a9e9a5$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9b6e3b5559a9e9a5$var$pb.hasOwnProperty(a) && $9b6e3b5559a9e9a5$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9b6e3b5559a9e9a5$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9b6e3b5559a9e9a5$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9b6e3b5559a9e9a5$var$tb = $9b6e3b5559a9e9a5$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9b6e3b5559a9e9a5$var$ub(a, b) {
    if (b) {
        if ($9b6e3b5559a9e9a5$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9b6e3b5559a9e9a5$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9b6e3b5559a9e9a5$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9b6e3b5559a9e9a5$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9b6e3b5559a9e9a5$var$p(62));
    }
}
function $9b6e3b5559a9e9a5$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9b6e3b5559a9e9a5$var$wb = null;
function $9b6e3b5559a9e9a5$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9b6e3b5559a9e9a5$var$yb = null, $9b6e3b5559a9e9a5$var$zb = null, $9b6e3b5559a9e9a5$var$Ab = null;
function $9b6e3b5559a9e9a5$var$Bb(a) {
    if (a = $9b6e3b5559a9e9a5$var$Cb(a)) {
        if ("function" !== typeof $9b6e3b5559a9e9a5$var$yb) throw Error($9b6e3b5559a9e9a5$var$p(280));
        var b = a.stateNode;
        b && (b = $9b6e3b5559a9e9a5$var$Db(b), $9b6e3b5559a9e9a5$var$yb(a.stateNode, a.type, b));
    }
}
function $9b6e3b5559a9e9a5$var$Eb(a) {
    $9b6e3b5559a9e9a5$var$zb ? $9b6e3b5559a9e9a5$var$Ab ? $9b6e3b5559a9e9a5$var$Ab.push(a) : $9b6e3b5559a9e9a5$var$Ab = [
        a
    ] : $9b6e3b5559a9e9a5$var$zb = a;
}
function $9b6e3b5559a9e9a5$var$Fb() {
    if ($9b6e3b5559a9e9a5$var$zb) {
        var a = $9b6e3b5559a9e9a5$var$zb, b = $9b6e3b5559a9e9a5$var$Ab;
        $9b6e3b5559a9e9a5$var$Ab = $9b6e3b5559a9e9a5$var$zb = null;
        $9b6e3b5559a9e9a5$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9b6e3b5559a9e9a5$var$Bb(b[a]);
    }
}
function $9b6e3b5559a9e9a5$var$Gb(a, b) {
    return a(b);
}
function $9b6e3b5559a9e9a5$var$Hb() {}
var $9b6e3b5559a9e9a5$var$Ib = !1;
function $9b6e3b5559a9e9a5$var$Jb(a, b, c) {
    if ($9b6e3b5559a9e9a5$var$Ib) return a(b, c);
    $9b6e3b5559a9e9a5$var$Ib = !0;
    try {
        return $9b6e3b5559a9e9a5$var$Gb(a, b, c);
    } finally{
        if ($9b6e3b5559a9e9a5$var$Ib = !1, null !== $9b6e3b5559a9e9a5$var$zb || null !== $9b6e3b5559a9e9a5$var$Ab) $9b6e3b5559a9e9a5$var$Hb(), $9b6e3b5559a9e9a5$var$Fb();
    }
}
function $9b6e3b5559a9e9a5$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9b6e3b5559a9e9a5$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9b6e3b5559a9e9a5$var$p(231, b, typeof c));
    return c;
}
var $9b6e3b5559a9e9a5$var$Lb = !1;
if ($9b6e3b5559a9e9a5$var$ia) try {
    var $9b6e3b5559a9e9a5$var$Mb = {};
    Object.defineProperty($9b6e3b5559a9e9a5$var$Mb, "passive", {
        get: function() {
            $9b6e3b5559a9e9a5$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9b6e3b5559a9e9a5$var$Mb, $9b6e3b5559a9e9a5$var$Mb);
    window.removeEventListener("test", $9b6e3b5559a9e9a5$var$Mb, $9b6e3b5559a9e9a5$var$Mb);
} catch (a) {
    $9b6e3b5559a9e9a5$var$Lb = !1;
}
function $9b6e3b5559a9e9a5$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9b6e3b5559a9e9a5$var$Ob = !1, $9b6e3b5559a9e9a5$var$Pb = null, $9b6e3b5559a9e9a5$var$Qb = !1, $9b6e3b5559a9e9a5$var$Rb = null, $9b6e3b5559a9e9a5$var$Sb = {
    onError: function(a) {
        $9b6e3b5559a9e9a5$var$Ob = !0;
        $9b6e3b5559a9e9a5$var$Pb = a;
    }
};
function $9b6e3b5559a9e9a5$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9b6e3b5559a9e9a5$var$Ob = !1;
    $9b6e3b5559a9e9a5$var$Pb = null;
    $9b6e3b5559a9e9a5$var$Nb.apply($9b6e3b5559a9e9a5$var$Sb, arguments);
}
function $9b6e3b5559a9e9a5$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9b6e3b5559a9e9a5$var$Tb.apply(this, arguments);
    if ($9b6e3b5559a9e9a5$var$Ob) {
        if ($9b6e3b5559a9e9a5$var$Ob) {
            var l = $9b6e3b5559a9e9a5$var$Pb;
            $9b6e3b5559a9e9a5$var$Ob = !1;
            $9b6e3b5559a9e9a5$var$Pb = null;
        } else throw Error($9b6e3b5559a9e9a5$var$p(198));
        $9b6e3b5559a9e9a5$var$Qb || ($9b6e3b5559a9e9a5$var$Qb = !0, $9b6e3b5559a9e9a5$var$Rb = l);
    }
}
function $9b6e3b5559a9e9a5$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9b6e3b5559a9e9a5$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9b6e3b5559a9e9a5$var$Xb(a) {
    if ($9b6e3b5559a9e9a5$var$Vb(a) !== a) throw Error($9b6e3b5559a9e9a5$var$p(188));
}
function $9b6e3b5559a9e9a5$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9b6e3b5559a9e9a5$var$Vb(a);
        if (null === b) throw Error($9b6e3b5559a9e9a5$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9b6e3b5559a9e9a5$var$Xb(e), a;
                if (f === d) return $9b6e3b5559a9e9a5$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9b6e3b5559a9e9a5$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9b6e3b5559a9e9a5$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9b6e3b5559a9e9a5$var$p(190));
    }
    if (3 !== c.tag) throw Error($9b6e3b5559a9e9a5$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9b6e3b5559a9e9a5$var$Zb(a) {
    a = $9b6e3b5559a9e9a5$var$Yb(a);
    return null !== a ? $9b6e3b5559a9e9a5$var$$b(a) : null;
}
function $9b6e3b5559a9e9a5$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9b6e3b5559a9e9a5$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9b6e3b5559a9e9a5$var$ac = $fYajP.unstable_scheduleCallback, $9b6e3b5559a9e9a5$var$bc = $fYajP.unstable_cancelCallback, $9b6e3b5559a9e9a5$var$cc = $fYajP.unstable_shouldYield, $9b6e3b5559a9e9a5$var$dc = $fYajP.unstable_requestPaint, $9b6e3b5559a9e9a5$var$B = $fYajP.unstable_now, $9b6e3b5559a9e9a5$var$ec = $fYajP.unstable_getCurrentPriorityLevel, $9b6e3b5559a9e9a5$var$fc = $fYajP.unstable_ImmediatePriority, $9b6e3b5559a9e9a5$var$gc = $fYajP.unstable_UserBlockingPriority, $9b6e3b5559a9e9a5$var$hc = $fYajP.unstable_NormalPriority, $9b6e3b5559a9e9a5$var$ic = $fYajP.unstable_LowPriority, $9b6e3b5559a9e9a5$var$jc = $fYajP.unstable_IdlePriority, $9b6e3b5559a9e9a5$var$kc = null, $9b6e3b5559a9e9a5$var$lc = null;
function $9b6e3b5559a9e9a5$var$mc(a) {
    if ($9b6e3b5559a9e9a5$var$lc && "function" === typeof $9b6e3b5559a9e9a5$var$lc.onCommitFiberRoot) try {
        $9b6e3b5559a9e9a5$var$lc.onCommitFiberRoot($9b6e3b5559a9e9a5$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9b6e3b5559a9e9a5$var$oc = Math.clz32 ? Math.clz32 : $9b6e3b5559a9e9a5$var$nc, $9b6e3b5559a9e9a5$var$pc = Math.log, $9b6e3b5559a9e9a5$var$qc = Math.LN2;
function $9b6e3b5559a9e9a5$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9b6e3b5559a9e9a5$var$pc(a) / $9b6e3b5559a9e9a5$var$qc | 0) | 0;
}
var $9b6e3b5559a9e9a5$var$rc = 64, $9b6e3b5559a9e9a5$var$sc = 4194304;
function $9b6e3b5559a9e9a5$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9b6e3b5559a9e9a5$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9b6e3b5559a9e9a5$var$tc(h) : (f &= g, 0 !== f && (d = $9b6e3b5559a9e9a5$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9b6e3b5559a9e9a5$var$tc(g) : 0 !== f && (d = $9b6e3b5559a9e9a5$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9b6e3b5559a9e9a5$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9b6e3b5559a9e9a5$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9b6e3b5559a9e9a5$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9b6e3b5559a9e9a5$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9b6e3b5559a9e9a5$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9b6e3b5559a9e9a5$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9b6e3b5559a9e9a5$var$yc() {
    var a = $9b6e3b5559a9e9a5$var$rc;
    $9b6e3b5559a9e9a5$var$rc <<= 1;
    0 === ($9b6e3b5559a9e9a5$var$rc & 4194240) && ($9b6e3b5559a9e9a5$var$rc = 64);
    return a;
}
function $9b6e3b5559a9e9a5$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9b6e3b5559a9e9a5$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9b6e3b5559a9e9a5$var$oc(b);
    a[b] = c;
}
function $9b6e3b5559a9e9a5$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9b6e3b5559a9e9a5$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9b6e3b5559a9e9a5$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9b6e3b5559a9e9a5$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9b6e3b5559a9e9a5$var$C = 0;
function $9b6e3b5559a9e9a5$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9b6e3b5559a9e9a5$var$Ec, $9b6e3b5559a9e9a5$var$Fc, $9b6e3b5559a9e9a5$var$Gc, $9b6e3b5559a9e9a5$var$Hc, $9b6e3b5559a9e9a5$var$Ic, $9b6e3b5559a9e9a5$var$Jc = !1, $9b6e3b5559a9e9a5$var$Kc = [], $9b6e3b5559a9e9a5$var$Lc = null, $9b6e3b5559a9e9a5$var$Mc = null, $9b6e3b5559a9e9a5$var$Nc = null, $9b6e3b5559a9e9a5$var$Oc = new Map, $9b6e3b5559a9e9a5$var$Pc = new Map, $9b6e3b5559a9e9a5$var$Qc = [], $9b6e3b5559a9e9a5$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9b6e3b5559a9e9a5$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9b6e3b5559a9e9a5$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9b6e3b5559a9e9a5$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9b6e3b5559a9e9a5$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9b6e3b5559a9e9a5$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9b6e3b5559a9e9a5$var$Pc.delete(b.pointerId);
    }
}
function $9b6e3b5559a9e9a5$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9b6e3b5559a9e9a5$var$Cb(b), null !== b && $9b6e3b5559a9e9a5$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9b6e3b5559a9e9a5$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9b6e3b5559a9e9a5$var$Lc = $9b6e3b5559a9e9a5$var$Tc($9b6e3b5559a9e9a5$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9b6e3b5559a9e9a5$var$Mc = $9b6e3b5559a9e9a5$var$Tc($9b6e3b5559a9e9a5$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9b6e3b5559a9e9a5$var$Nc = $9b6e3b5559a9e9a5$var$Tc($9b6e3b5559a9e9a5$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9b6e3b5559a9e9a5$var$Oc.set(f, $9b6e3b5559a9e9a5$var$Tc($9b6e3b5559a9e9a5$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9b6e3b5559a9e9a5$var$Pc.set(f, $9b6e3b5559a9e9a5$var$Tc($9b6e3b5559a9e9a5$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9b6e3b5559a9e9a5$var$Vc(a) {
    var b = $9b6e3b5559a9e9a5$var$Wc(a.target);
    if (null !== b) {
        var c = $9b6e3b5559a9e9a5$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9b6e3b5559a9e9a5$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9b6e3b5559a9e9a5$var$Ic(a.priority, function() {
                        $9b6e3b5559a9e9a5$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9b6e3b5559a9e9a5$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9b6e3b5559a9e9a5$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9b6e3b5559a9e9a5$var$wb = d;
            c.target.dispatchEvent(d);
            $9b6e3b5559a9e9a5$var$wb = null;
        } else return b = $9b6e3b5559a9e9a5$var$Cb(c), null !== b && $9b6e3b5559a9e9a5$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9b6e3b5559a9e9a5$var$Zc(a, b, c) {
    $9b6e3b5559a9e9a5$var$Xc(a) && c.delete(b);
}
function $9b6e3b5559a9e9a5$var$$c() {
    $9b6e3b5559a9e9a5$var$Jc = !1;
    null !== $9b6e3b5559a9e9a5$var$Lc && $9b6e3b5559a9e9a5$var$Xc($9b6e3b5559a9e9a5$var$Lc) && ($9b6e3b5559a9e9a5$var$Lc = null);
    null !== $9b6e3b5559a9e9a5$var$Mc && $9b6e3b5559a9e9a5$var$Xc($9b6e3b5559a9e9a5$var$Mc) && ($9b6e3b5559a9e9a5$var$Mc = null);
    null !== $9b6e3b5559a9e9a5$var$Nc && $9b6e3b5559a9e9a5$var$Xc($9b6e3b5559a9e9a5$var$Nc) && ($9b6e3b5559a9e9a5$var$Nc = null);
    $9b6e3b5559a9e9a5$var$Oc.forEach($9b6e3b5559a9e9a5$var$Zc);
    $9b6e3b5559a9e9a5$var$Pc.forEach($9b6e3b5559a9e9a5$var$Zc);
}
function $9b6e3b5559a9e9a5$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9b6e3b5559a9e9a5$var$Jc || ($9b6e3b5559a9e9a5$var$Jc = !0, $fYajP.unstable_scheduleCallback($fYajP.unstable_NormalPriority, $9b6e3b5559a9e9a5$var$$c)));
}
function $9b6e3b5559a9e9a5$var$bd(a) {
    function b(b) {
        return $9b6e3b5559a9e9a5$var$ad(b, a);
    }
    if (0 < $9b6e3b5559a9e9a5$var$Kc.length) {
        $9b6e3b5559a9e9a5$var$ad($9b6e3b5559a9e9a5$var$Kc[0], a);
        for(var c = 1; c < $9b6e3b5559a9e9a5$var$Kc.length; c++){
            var d = $9b6e3b5559a9e9a5$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9b6e3b5559a9e9a5$var$Lc && $9b6e3b5559a9e9a5$var$ad($9b6e3b5559a9e9a5$var$Lc, a);
    null !== $9b6e3b5559a9e9a5$var$Mc && $9b6e3b5559a9e9a5$var$ad($9b6e3b5559a9e9a5$var$Mc, a);
    null !== $9b6e3b5559a9e9a5$var$Nc && $9b6e3b5559a9e9a5$var$ad($9b6e3b5559a9e9a5$var$Nc, a);
    $9b6e3b5559a9e9a5$var$Oc.forEach(b);
    $9b6e3b5559a9e9a5$var$Pc.forEach(b);
    for(c = 0; c < $9b6e3b5559a9e9a5$var$Qc.length; c++)d = $9b6e3b5559a9e9a5$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9b6e3b5559a9e9a5$var$Qc.length && (c = $9b6e3b5559a9e9a5$var$Qc[0], null === c.blockedOn);)$9b6e3b5559a9e9a5$var$Vc(c), null === c.blockedOn && $9b6e3b5559a9e9a5$var$Qc.shift();
}
var $9b6e3b5559a9e9a5$var$cd = $9b6e3b5559a9e9a5$var$ua.ReactCurrentBatchConfig, $9b6e3b5559a9e9a5$var$dd = !0;
function $9b6e3b5559a9e9a5$var$ed(a, b, c, d) {
    var e = $9b6e3b5559a9e9a5$var$C, f = $9b6e3b5559a9e9a5$var$cd.transition;
    $9b6e3b5559a9e9a5$var$cd.transition = null;
    try {
        $9b6e3b5559a9e9a5$var$C = 1, $9b6e3b5559a9e9a5$var$fd(a, b, c, d);
    } finally{
        $9b6e3b5559a9e9a5$var$C = e, $9b6e3b5559a9e9a5$var$cd.transition = f;
    }
}
function $9b6e3b5559a9e9a5$var$gd(a, b, c, d) {
    var e = $9b6e3b5559a9e9a5$var$C, f = $9b6e3b5559a9e9a5$var$cd.transition;
    $9b6e3b5559a9e9a5$var$cd.transition = null;
    try {
        $9b6e3b5559a9e9a5$var$C = 4, $9b6e3b5559a9e9a5$var$fd(a, b, c, d);
    } finally{
        $9b6e3b5559a9e9a5$var$C = e, $9b6e3b5559a9e9a5$var$cd.transition = f;
    }
}
function $9b6e3b5559a9e9a5$var$fd(a, b, c, d) {
    if ($9b6e3b5559a9e9a5$var$dd) {
        var e = $9b6e3b5559a9e9a5$var$Yc(a, b, c, d);
        if (null === e) $9b6e3b5559a9e9a5$var$hd(a, b, d, $9b6e3b5559a9e9a5$var$id, c), $9b6e3b5559a9e9a5$var$Sc(a, d);
        else if ($9b6e3b5559a9e9a5$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9b6e3b5559a9e9a5$var$Sc(a, d), b & 4 && -1 < $9b6e3b5559a9e9a5$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9b6e3b5559a9e9a5$var$Cb(e);
                null !== f && $9b6e3b5559a9e9a5$var$Ec(f);
                f = $9b6e3b5559a9e9a5$var$Yc(a, b, c, d);
                null === f && $9b6e3b5559a9e9a5$var$hd(a, b, d, $9b6e3b5559a9e9a5$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9b6e3b5559a9e9a5$var$hd(a, b, d, null, c);
    }
}
var $9b6e3b5559a9e9a5$var$id = null;
function $9b6e3b5559a9e9a5$var$Yc(a, b, c, d) {
    $9b6e3b5559a9e9a5$var$id = null;
    a = $9b6e3b5559a9e9a5$var$xb(d);
    a = $9b6e3b5559a9e9a5$var$Wc(a);
    if (null !== a) {
        if (b = $9b6e3b5559a9e9a5$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9b6e3b5559a9e9a5$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9b6e3b5559a9e9a5$var$id = a;
    return null;
}
function $9b6e3b5559a9e9a5$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9b6e3b5559a9e9a5$var$ec()){
                case $9b6e3b5559a9e9a5$var$fc:
                    return 1;
                case $9b6e3b5559a9e9a5$var$gc:
                    return 4;
                case $9b6e3b5559a9e9a5$var$hc:
                case $9b6e3b5559a9e9a5$var$ic:
                    return 16;
                case $9b6e3b5559a9e9a5$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9b6e3b5559a9e9a5$var$kd = null, $9b6e3b5559a9e9a5$var$ld = null, $9b6e3b5559a9e9a5$var$md = null;
function $9b6e3b5559a9e9a5$var$nd() {
    if ($9b6e3b5559a9e9a5$var$md) return $9b6e3b5559a9e9a5$var$md;
    var a, b = $9b6e3b5559a9e9a5$var$ld, c = b.length, d, e = "value" in $9b6e3b5559a9e9a5$var$kd ? $9b6e3b5559a9e9a5$var$kd.value : $9b6e3b5559a9e9a5$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9b6e3b5559a9e9a5$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9b6e3b5559a9e9a5$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9b6e3b5559a9e9a5$var$pd() {
    return !0;
}
function $9b6e3b5559a9e9a5$var$qd() {
    return !1;
}
function $9b6e3b5559a9e9a5$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9b6e3b5559a9e9a5$var$pd : $9b6e3b5559a9e9a5$var$qd;
        this.isPropagationStopped = $9b6e3b5559a9e9a5$var$qd;
        return this;
    }
    $9b6e3b5559a9e9a5$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9b6e3b5559a9e9a5$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9b6e3b5559a9e9a5$var$pd);
        },
        persist: function() {},
        isPersistent: $9b6e3b5559a9e9a5$var$pd
    });
    return b;
}
var $9b6e3b5559a9e9a5$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9b6e3b5559a9e9a5$var$td = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$sd), $9b6e3b5559a9e9a5$var$ud = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$sd, {
    view: 0,
    detail: 0
}), $9b6e3b5559a9e9a5$var$vd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$ud), $9b6e3b5559a9e9a5$var$wd, $9b6e3b5559a9e9a5$var$xd, $9b6e3b5559a9e9a5$var$yd, $9b6e3b5559a9e9a5$var$Ad = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9b6e3b5559a9e9a5$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9b6e3b5559a9e9a5$var$yd && ($9b6e3b5559a9e9a5$var$yd && "mousemove" === a.type ? ($9b6e3b5559a9e9a5$var$wd = a.screenX - $9b6e3b5559a9e9a5$var$yd.screenX, $9b6e3b5559a9e9a5$var$xd = a.screenY - $9b6e3b5559a9e9a5$var$yd.screenY) : $9b6e3b5559a9e9a5$var$xd = $9b6e3b5559a9e9a5$var$wd = 0, $9b6e3b5559a9e9a5$var$yd = a);
        return $9b6e3b5559a9e9a5$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9b6e3b5559a9e9a5$var$xd;
    }
}), $9b6e3b5559a9e9a5$var$Bd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Ad), $9b6e3b5559a9e9a5$var$Cd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$Ad, {
    dataTransfer: 0
}), $9b6e3b5559a9e9a5$var$Dd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Cd), $9b6e3b5559a9e9a5$var$Ed = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$ud, {
    relatedTarget: 0
}), $9b6e3b5559a9e9a5$var$Fd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Ed), $9b6e3b5559a9e9a5$var$Gd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b6e3b5559a9e9a5$var$Hd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Gd), $9b6e3b5559a9e9a5$var$Id = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9b6e3b5559a9e9a5$var$Jd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Id), $9b6e3b5559a9e9a5$var$Kd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$sd, {
    data: 0
}), $9b6e3b5559a9e9a5$var$Ld = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Kd), $9b6e3b5559a9e9a5$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9b6e3b5559a9e9a5$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9b6e3b5559a9e9a5$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9b6e3b5559a9e9a5$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9b6e3b5559a9e9a5$var$Od[a]) ? !!b[a] : !1;
}
function $9b6e3b5559a9e9a5$var$zd() {
    return $9b6e3b5559a9e9a5$var$Pd;
}
var $9b6e3b5559a9e9a5$var$Qd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9b6e3b5559a9e9a5$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9b6e3b5559a9e9a5$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9b6e3b5559a9e9a5$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9b6e3b5559a9e9a5$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9b6e3b5559a9e9a5$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9b6e3b5559a9e9a5$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9b6e3b5559a9e9a5$var$Rd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Qd), $9b6e3b5559a9e9a5$var$Sd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9b6e3b5559a9e9a5$var$Td = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Sd), $9b6e3b5559a9e9a5$var$Ud = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9b6e3b5559a9e9a5$var$zd
}), $9b6e3b5559a9e9a5$var$Vd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Ud), $9b6e3b5559a9e9a5$var$Wd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b6e3b5559a9e9a5$var$Xd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Wd), $9b6e3b5559a9e9a5$var$Yd = $9b6e3b5559a9e9a5$var$A({}, $9b6e3b5559a9e9a5$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9b6e3b5559a9e9a5$var$Zd = $9b6e3b5559a9e9a5$var$rd($9b6e3b5559a9e9a5$var$Yd), $9b6e3b5559a9e9a5$var$$d = [
    9,
    13,
    27,
    32
], $9b6e3b5559a9e9a5$var$ae = $9b6e3b5559a9e9a5$var$ia && "CompositionEvent" in window, $9b6e3b5559a9e9a5$var$be = null;
$9b6e3b5559a9e9a5$var$ia && "documentMode" in document && ($9b6e3b5559a9e9a5$var$be = document.documentMode);
var $9b6e3b5559a9e9a5$var$ce = $9b6e3b5559a9e9a5$var$ia && "TextEvent" in window && !$9b6e3b5559a9e9a5$var$be, $9b6e3b5559a9e9a5$var$de = $9b6e3b5559a9e9a5$var$ia && (!$9b6e3b5559a9e9a5$var$ae || $9b6e3b5559a9e9a5$var$be && 8 < $9b6e3b5559a9e9a5$var$be && 11 >= $9b6e3b5559a9e9a5$var$be), $9b6e3b5559a9e9a5$var$ee = String.fromCharCode(32), $9b6e3b5559a9e9a5$var$fe = !1;
function $9b6e3b5559a9e9a5$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9b6e3b5559a9e9a5$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9b6e3b5559a9e9a5$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9b6e3b5559a9e9a5$var$ie = !1;
function $9b6e3b5559a9e9a5$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9b6e3b5559a9e9a5$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9b6e3b5559a9e9a5$var$fe = !0;
            return $9b6e3b5559a9e9a5$var$ee;
        case "textInput":
            return a = b.data, a === $9b6e3b5559a9e9a5$var$ee && $9b6e3b5559a9e9a5$var$fe ? null : a;
        default:
            return null;
    }
}
function $9b6e3b5559a9e9a5$var$ke(a, b) {
    if ($9b6e3b5559a9e9a5$var$ie) return "compositionend" === a || !$9b6e3b5559a9e9a5$var$ae && $9b6e3b5559a9e9a5$var$ge(a, b) ? (a = $9b6e3b5559a9e9a5$var$nd(), $9b6e3b5559a9e9a5$var$md = $9b6e3b5559a9e9a5$var$ld = $9b6e3b5559a9e9a5$var$kd = null, $9b6e3b5559a9e9a5$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9b6e3b5559a9e9a5$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9b6e3b5559a9e9a5$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9b6e3b5559a9e9a5$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9b6e3b5559a9e9a5$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9b6e3b5559a9e9a5$var$ne(a, b, c, d) {
    $9b6e3b5559a9e9a5$var$Eb(d);
    b = $9b6e3b5559a9e9a5$var$oe(b, "onChange");
    0 < b.length && (c = new $9b6e3b5559a9e9a5$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9b6e3b5559a9e9a5$var$pe = null, $9b6e3b5559a9e9a5$var$qe = null;
function $9b6e3b5559a9e9a5$var$re(a) {
    $9b6e3b5559a9e9a5$var$se(a, 0);
}
function $9b6e3b5559a9e9a5$var$te(a) {
    var b = $9b6e3b5559a9e9a5$var$ue(a);
    if ($9b6e3b5559a9e9a5$var$Wa(b)) return a;
}
function $9b6e3b5559a9e9a5$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9b6e3b5559a9e9a5$var$we = !1;
if ($9b6e3b5559a9e9a5$var$ia) {
    var $9b6e3b5559a9e9a5$var$xe;
    if ($9b6e3b5559a9e9a5$var$ia) {
        var $9b6e3b5559a9e9a5$var$ye = "oninput" in document;
        if (!$9b6e3b5559a9e9a5$var$ye) {
            var $9b6e3b5559a9e9a5$var$ze = document.createElement("div");
            $9b6e3b5559a9e9a5$var$ze.setAttribute("oninput", "return;");
            $9b6e3b5559a9e9a5$var$ye = "function" === typeof $9b6e3b5559a9e9a5$var$ze.oninput;
        }
        $9b6e3b5559a9e9a5$var$xe = $9b6e3b5559a9e9a5$var$ye;
    } else $9b6e3b5559a9e9a5$var$xe = !1;
    $9b6e3b5559a9e9a5$var$we = $9b6e3b5559a9e9a5$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9b6e3b5559a9e9a5$var$Ae() {
    $9b6e3b5559a9e9a5$var$pe && ($9b6e3b5559a9e9a5$var$pe.detachEvent("onpropertychange", $9b6e3b5559a9e9a5$var$Be), $9b6e3b5559a9e9a5$var$qe = $9b6e3b5559a9e9a5$var$pe = null);
}
function $9b6e3b5559a9e9a5$var$Be(a) {
    if ("value" === a.propertyName && $9b6e3b5559a9e9a5$var$te($9b6e3b5559a9e9a5$var$qe)) {
        var b = [];
        $9b6e3b5559a9e9a5$var$ne(b, $9b6e3b5559a9e9a5$var$qe, a, $9b6e3b5559a9e9a5$var$xb(a));
        $9b6e3b5559a9e9a5$var$Jb($9b6e3b5559a9e9a5$var$re, b);
    }
}
function $9b6e3b5559a9e9a5$var$Ce(a, b, c) {
    "focusin" === a ? ($9b6e3b5559a9e9a5$var$Ae(), $9b6e3b5559a9e9a5$var$pe = b, $9b6e3b5559a9e9a5$var$qe = c, $9b6e3b5559a9e9a5$var$pe.attachEvent("onpropertychange", $9b6e3b5559a9e9a5$var$Be)) : "focusout" === a && $9b6e3b5559a9e9a5$var$Ae();
}
function $9b6e3b5559a9e9a5$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9b6e3b5559a9e9a5$var$te($9b6e3b5559a9e9a5$var$qe);
}
function $9b6e3b5559a9e9a5$var$Ee(a, b) {
    if ("click" === a) return $9b6e3b5559a9e9a5$var$te(b);
}
function $9b6e3b5559a9e9a5$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9b6e3b5559a9e9a5$var$te(b);
}
function $9b6e3b5559a9e9a5$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9b6e3b5559a9e9a5$var$He = "function" === typeof Object.is ? Object.is : $9b6e3b5559a9e9a5$var$Ge;
function $9b6e3b5559a9e9a5$var$Ie(a, b) {
    if ($9b6e3b5559a9e9a5$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9b6e3b5559a9e9a5$var$ja.call(b, e) || !$9b6e3b5559a9e9a5$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9b6e3b5559a9e9a5$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9b6e3b5559a9e9a5$var$Ke(a, b) {
    var c = $9b6e3b5559a9e9a5$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9b6e3b5559a9e9a5$var$Je(c);
    }
}
function $9b6e3b5559a9e9a5$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9b6e3b5559a9e9a5$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9b6e3b5559a9e9a5$var$Me() {
    for(var a = window, b = $9b6e3b5559a9e9a5$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9b6e3b5559a9e9a5$var$Xa(a.document);
    }
    return b;
}
function $9b6e3b5559a9e9a5$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9b6e3b5559a9e9a5$var$Oe(a) {
    var b = $9b6e3b5559a9e9a5$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9b6e3b5559a9e9a5$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9b6e3b5559a9e9a5$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9b6e3b5559a9e9a5$var$Ke(c, f);
                var g = $9b6e3b5559a9e9a5$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9b6e3b5559a9e9a5$var$Pe = $9b6e3b5559a9e9a5$var$ia && "documentMode" in document && 11 >= document.documentMode, $9b6e3b5559a9e9a5$var$Qe = null, $9b6e3b5559a9e9a5$var$Re = null, $9b6e3b5559a9e9a5$var$Se = null, $9b6e3b5559a9e9a5$var$Te = !1;
function $9b6e3b5559a9e9a5$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9b6e3b5559a9e9a5$var$Te || null == $9b6e3b5559a9e9a5$var$Qe || $9b6e3b5559a9e9a5$var$Qe !== $9b6e3b5559a9e9a5$var$Xa(d) || (d = $9b6e3b5559a9e9a5$var$Qe, "selectionStart" in d && $9b6e3b5559a9e9a5$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9b6e3b5559a9e9a5$var$Se && $9b6e3b5559a9e9a5$var$Ie($9b6e3b5559a9e9a5$var$Se, d) || ($9b6e3b5559a9e9a5$var$Se = d, d = $9b6e3b5559a9e9a5$var$oe($9b6e3b5559a9e9a5$var$Re, "onSelect"), 0 < d.length && (b = new $9b6e3b5559a9e9a5$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9b6e3b5559a9e9a5$var$Qe)));
}
function $9b6e3b5559a9e9a5$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9b6e3b5559a9e9a5$var$We = {
    animationend: $9b6e3b5559a9e9a5$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9b6e3b5559a9e9a5$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9b6e3b5559a9e9a5$var$Ve("Animation", "AnimationStart"),
    transitionend: $9b6e3b5559a9e9a5$var$Ve("Transition", "TransitionEnd")
}, $9b6e3b5559a9e9a5$var$Xe = {}, $9b6e3b5559a9e9a5$var$Ye = {};
$9b6e3b5559a9e9a5$var$ia && ($9b6e3b5559a9e9a5$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9b6e3b5559a9e9a5$var$We.animationend.animation, delete $9b6e3b5559a9e9a5$var$We.animationiteration.animation, delete $9b6e3b5559a9e9a5$var$We.animationstart.animation), "TransitionEvent" in window || delete $9b6e3b5559a9e9a5$var$We.transitionend.transition);
function $9b6e3b5559a9e9a5$var$Ze(a) {
    if ($9b6e3b5559a9e9a5$var$Xe[a]) return $9b6e3b5559a9e9a5$var$Xe[a];
    if (!$9b6e3b5559a9e9a5$var$We[a]) return a;
    var b = $9b6e3b5559a9e9a5$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9b6e3b5559a9e9a5$var$Ye) return $9b6e3b5559a9e9a5$var$Xe[a] = b[c];
    return a;
}
var $9b6e3b5559a9e9a5$var$$e = $9b6e3b5559a9e9a5$var$Ze("animationend"), $9b6e3b5559a9e9a5$var$af = $9b6e3b5559a9e9a5$var$Ze("animationiteration"), $9b6e3b5559a9e9a5$var$bf = $9b6e3b5559a9e9a5$var$Ze("animationstart"), $9b6e3b5559a9e9a5$var$cf = $9b6e3b5559a9e9a5$var$Ze("transitionend"), $9b6e3b5559a9e9a5$var$df = new Map, $9b6e3b5559a9e9a5$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9b6e3b5559a9e9a5$var$ff(a, b) {
    $9b6e3b5559a9e9a5$var$df.set(a, b);
    $9b6e3b5559a9e9a5$var$fa(b, [
        a
    ]);
}
for(var $9b6e3b5559a9e9a5$var$gf = 0; $9b6e3b5559a9e9a5$var$gf < $9b6e3b5559a9e9a5$var$ef.length; $9b6e3b5559a9e9a5$var$gf++){
    var $9b6e3b5559a9e9a5$var$hf = $9b6e3b5559a9e9a5$var$ef[$9b6e3b5559a9e9a5$var$gf], $9b6e3b5559a9e9a5$var$jf = $9b6e3b5559a9e9a5$var$hf.toLowerCase(), $9b6e3b5559a9e9a5$var$kf = $9b6e3b5559a9e9a5$var$hf[0].toUpperCase() + $9b6e3b5559a9e9a5$var$hf.slice(1);
    $9b6e3b5559a9e9a5$var$ff($9b6e3b5559a9e9a5$var$jf, "on" + $9b6e3b5559a9e9a5$var$kf);
}
$9b6e3b5559a9e9a5$var$ff($9b6e3b5559a9e9a5$var$$e, "onAnimationEnd");
$9b6e3b5559a9e9a5$var$ff($9b6e3b5559a9e9a5$var$af, "onAnimationIteration");
$9b6e3b5559a9e9a5$var$ff($9b6e3b5559a9e9a5$var$bf, "onAnimationStart");
$9b6e3b5559a9e9a5$var$ff("dblclick", "onDoubleClick");
$9b6e3b5559a9e9a5$var$ff("focusin", "onFocus");
$9b6e3b5559a9e9a5$var$ff("focusout", "onBlur");
$9b6e3b5559a9e9a5$var$ff($9b6e3b5559a9e9a5$var$cf, "onTransitionEnd");
$9b6e3b5559a9e9a5$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9b6e3b5559a9e9a5$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9b6e3b5559a9e9a5$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9b6e3b5559a9e9a5$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9b6e3b5559a9e9a5$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9b6e3b5559a9e9a5$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9b6e3b5559a9e9a5$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9b6e3b5559a9e9a5$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9b6e3b5559a9e9a5$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9b6e3b5559a9e9a5$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9b6e3b5559a9e9a5$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9b6e3b5559a9e9a5$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9b6e3b5559a9e9a5$var$lf));
function $9b6e3b5559a9e9a5$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9b6e3b5559a9e9a5$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9b6e3b5559a9e9a5$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b6e3b5559a9e9a5$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b6e3b5559a9e9a5$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9b6e3b5559a9e9a5$var$Qb) throw a = $9b6e3b5559a9e9a5$var$Rb, $9b6e3b5559a9e9a5$var$Qb = !1, $9b6e3b5559a9e9a5$var$Rb = null, a;
}
function $9b6e3b5559a9e9a5$var$D(a, b) {
    var c = b[$9b6e3b5559a9e9a5$var$of];
    void 0 === c && (c = b[$9b6e3b5559a9e9a5$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9b6e3b5559a9e9a5$var$pf(b, a, 2, !1), c.add(d));
}
function $9b6e3b5559a9e9a5$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9b6e3b5559a9e9a5$var$pf(c, a, d, b);
}
var $9b6e3b5559a9e9a5$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9b6e3b5559a9e9a5$var$sf(a) {
    if (!a[$9b6e3b5559a9e9a5$var$rf]) {
        a[$9b6e3b5559a9e9a5$var$rf] = !0;
        $9b6e3b5559a9e9a5$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9b6e3b5559a9e9a5$var$mf.has(b) || $9b6e3b5559a9e9a5$var$qf(b, !1, a), $9b6e3b5559a9e9a5$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9b6e3b5559a9e9a5$var$rf] || (b[$9b6e3b5559a9e9a5$var$rf] = !0, $9b6e3b5559a9e9a5$var$qf("selectionchange", !1, b));
    }
}
function $9b6e3b5559a9e9a5$var$pf(a, b, c, d) {
    switch($9b6e3b5559a9e9a5$var$jd(b)){
        case 1:
            var e = $9b6e3b5559a9e9a5$var$ed;
            break;
        case 4:
            e = $9b6e3b5559a9e9a5$var$gd;
            break;
        default:
            e = $9b6e3b5559a9e9a5$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9b6e3b5559a9e9a5$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9b6e3b5559a9e9a5$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9b6e3b5559a9e9a5$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9b6e3b5559a9e9a5$var$Jb(function() {
        var d = f, e = $9b6e3b5559a9e9a5$var$xb(c), g = [];
        a: {
            var h = $9b6e3b5559a9e9a5$var$df.get(a);
            if (void 0 !== h) {
                var k = $9b6e3b5559a9e9a5$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9b6e3b5559a9e9a5$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9b6e3b5559a9e9a5$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9b6e3b5559a9e9a5$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9b6e3b5559a9e9a5$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9b6e3b5559a9e9a5$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9b6e3b5559a9e9a5$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9b6e3b5559a9e9a5$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9b6e3b5559a9e9a5$var$Vd;
                        break;
                    case $9b6e3b5559a9e9a5$var$$e:
                    case $9b6e3b5559a9e9a5$var$af:
                    case $9b6e3b5559a9e9a5$var$bf:
                        k = $9b6e3b5559a9e9a5$var$Hd;
                        break;
                    case $9b6e3b5559a9e9a5$var$cf:
                        k = $9b6e3b5559a9e9a5$var$Xd;
                        break;
                    case "scroll":
                        k = $9b6e3b5559a9e9a5$var$vd;
                        break;
                    case "wheel":
                        k = $9b6e3b5559a9e9a5$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9b6e3b5559a9e9a5$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9b6e3b5559a9e9a5$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9b6e3b5559a9e9a5$var$Kb(w, x), null != F && t.push($9b6e3b5559a9e9a5$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9b6e3b5559a9e9a5$var$wb && (n = c.relatedTarget || c.fromElement) && ($9b6e3b5559a9e9a5$var$Wc(n) || n[$9b6e3b5559a9e9a5$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9b6e3b5559a9e9a5$var$Wc(n) : null, null !== n && (J = $9b6e3b5559a9e9a5$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9b6e3b5559a9e9a5$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9b6e3b5559a9e9a5$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9b6e3b5559a9e9a5$var$ue(k);
                        u = null == n ? h : $9b6e3b5559a9e9a5$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9b6e3b5559a9e9a5$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9b6e3b5559a9e9a5$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9b6e3b5559a9e9a5$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9b6e3b5559a9e9a5$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9b6e3b5559a9e9a5$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9b6e3b5559a9e9a5$var$vf(t);
                                x = $9b6e3b5559a9e9a5$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9b6e3b5559a9e9a5$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9b6e3b5559a9e9a5$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9b6e3b5559a9e9a5$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9b6e3b5559a9e9a5$var$ve;
                else if ($9b6e3b5559a9e9a5$var$me(h)) {
                    if ($9b6e3b5559a9e9a5$var$we) na = $9b6e3b5559a9e9a5$var$Fe;
                    else {
                        na = $9b6e3b5559a9e9a5$var$De;
                        var xa = $9b6e3b5559a9e9a5$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9b6e3b5559a9e9a5$var$Ee);
                if (na && (na = na(a, d))) {
                    $9b6e3b5559a9e9a5$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9b6e3b5559a9e9a5$var$cb(h, "number", h.value);
            }
            xa = d ? $9b6e3b5559a9e9a5$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9b6e3b5559a9e9a5$var$me(xa) || "true" === xa.contentEditable) $9b6e3b5559a9e9a5$var$Qe = xa, $9b6e3b5559a9e9a5$var$Re = d, $9b6e3b5559a9e9a5$var$Se = null;
                    break;
                case "focusout":
                    $9b6e3b5559a9e9a5$var$Se = $9b6e3b5559a9e9a5$var$Re = $9b6e3b5559a9e9a5$var$Qe = null;
                    break;
                case "mousedown":
                    $9b6e3b5559a9e9a5$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9b6e3b5559a9e9a5$var$Te = !1;
                    $9b6e3b5559a9e9a5$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9b6e3b5559a9e9a5$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9b6e3b5559a9e9a5$var$Ue(g, c, e);
            }
            var $a;
            if ($9b6e3b5559a9e9a5$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9b6e3b5559a9e9a5$var$ie ? $9b6e3b5559a9e9a5$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9b6e3b5559a9e9a5$var$de && "ko" !== c.locale && ($9b6e3b5559a9e9a5$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9b6e3b5559a9e9a5$var$ie && ($a = $9b6e3b5559a9e9a5$var$nd()) : ($9b6e3b5559a9e9a5$var$kd = e, $9b6e3b5559a9e9a5$var$ld = "value" in $9b6e3b5559a9e9a5$var$kd ? $9b6e3b5559a9e9a5$var$kd.value : $9b6e3b5559a9e9a5$var$kd.textContent, $9b6e3b5559a9e9a5$var$ie = !0)), xa = $9b6e3b5559a9e9a5$var$oe(d, ba), 0 < xa.length && (ba = new $9b6e3b5559a9e9a5$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9b6e3b5559a9e9a5$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9b6e3b5559a9e9a5$var$ce ? $9b6e3b5559a9e9a5$var$je(a, c) : $9b6e3b5559a9e9a5$var$ke(a, c)) d = $9b6e3b5559a9e9a5$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9b6e3b5559a9e9a5$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9b6e3b5559a9e9a5$var$se(g, b);
    });
}
function $9b6e3b5559a9e9a5$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9b6e3b5559a9e9a5$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9b6e3b5559a9e9a5$var$Kb(a, c), null != f && d.unshift($9b6e3b5559a9e9a5$var$tf(a, f, e)), f = $9b6e3b5559a9e9a5$var$Kb(a, b), null != f && d.push($9b6e3b5559a9e9a5$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9b6e3b5559a9e9a5$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9b6e3b5559a9e9a5$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9b6e3b5559a9e9a5$var$Kb(c, f), null != k && g.unshift($9b6e3b5559a9e9a5$var$tf(c, k, h))) : e || (k = $9b6e3b5559a9e9a5$var$Kb(c, f), null != k && g.push($9b6e3b5559a9e9a5$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9b6e3b5559a9e9a5$var$xf = /\r\n?/g, $9b6e3b5559a9e9a5$var$yf = /\u0000|\uFFFD/g;
function $9b6e3b5559a9e9a5$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9b6e3b5559a9e9a5$var$xf, "\n").replace($9b6e3b5559a9e9a5$var$yf, "");
}
function $9b6e3b5559a9e9a5$var$Af(a, b, c) {
    b = $9b6e3b5559a9e9a5$var$zf(b);
    if ($9b6e3b5559a9e9a5$var$zf(a) !== b && c) throw Error($9b6e3b5559a9e9a5$var$p(425));
}
function $9b6e3b5559a9e9a5$var$Bf() {}
var $9b6e3b5559a9e9a5$var$Cf = null, $9b6e3b5559a9e9a5$var$Df = null;
function $9b6e3b5559a9e9a5$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9b6e3b5559a9e9a5$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9b6e3b5559a9e9a5$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9b6e3b5559a9e9a5$var$Hf = "function" === typeof Promise ? Promise : void 0, $9b6e3b5559a9e9a5$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9b6e3b5559a9e9a5$var$Hf ? function(a) {
    return $9b6e3b5559a9e9a5$var$Hf.resolve(null).then(a).catch($9b6e3b5559a9e9a5$var$If);
} : $9b6e3b5559a9e9a5$var$Ff;
function $9b6e3b5559a9e9a5$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9b6e3b5559a9e9a5$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9b6e3b5559a9e9a5$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9b6e3b5559a9e9a5$var$bd(b);
}
function $9b6e3b5559a9e9a5$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9b6e3b5559a9e9a5$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9b6e3b5559a9e9a5$var$Nf = Math.random().toString(36).slice(2), $9b6e3b5559a9e9a5$var$Of = "__reactFiber$" + $9b6e3b5559a9e9a5$var$Nf, $9b6e3b5559a9e9a5$var$Pf = "__reactProps$" + $9b6e3b5559a9e9a5$var$Nf, $9b6e3b5559a9e9a5$var$uf = "__reactContainer$" + $9b6e3b5559a9e9a5$var$Nf, $9b6e3b5559a9e9a5$var$of = "__reactEvents$" + $9b6e3b5559a9e9a5$var$Nf, $9b6e3b5559a9e9a5$var$Qf = "__reactListeners$" + $9b6e3b5559a9e9a5$var$Nf, $9b6e3b5559a9e9a5$var$Rf = "__reactHandles$" + $9b6e3b5559a9e9a5$var$Nf;
function $9b6e3b5559a9e9a5$var$Wc(a) {
    var b = a[$9b6e3b5559a9e9a5$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9b6e3b5559a9e9a5$var$uf] || c[$9b6e3b5559a9e9a5$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9b6e3b5559a9e9a5$var$Mf(a); null !== a;){
                if (c = a[$9b6e3b5559a9e9a5$var$Of]) return c;
                a = $9b6e3b5559a9e9a5$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9b6e3b5559a9e9a5$var$Cb(a) {
    a = a[$9b6e3b5559a9e9a5$var$Of] || a[$9b6e3b5559a9e9a5$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9b6e3b5559a9e9a5$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9b6e3b5559a9e9a5$var$p(33));
}
function $9b6e3b5559a9e9a5$var$Db(a) {
    return a[$9b6e3b5559a9e9a5$var$Pf] || null;
}
var $9b6e3b5559a9e9a5$var$Sf = [], $9b6e3b5559a9e9a5$var$Tf = -1;
function $9b6e3b5559a9e9a5$var$Uf(a) {
    return {
        current: a
    };
}
function $9b6e3b5559a9e9a5$var$E(a) {
    0 > $9b6e3b5559a9e9a5$var$Tf || (a.current = $9b6e3b5559a9e9a5$var$Sf[$9b6e3b5559a9e9a5$var$Tf], $9b6e3b5559a9e9a5$var$Sf[$9b6e3b5559a9e9a5$var$Tf] = null, $9b6e3b5559a9e9a5$var$Tf--);
}
function $9b6e3b5559a9e9a5$var$G(a, b) {
    $9b6e3b5559a9e9a5$var$Tf++;
    $9b6e3b5559a9e9a5$var$Sf[$9b6e3b5559a9e9a5$var$Tf] = a.current;
    a.current = b;
}
var $9b6e3b5559a9e9a5$var$Vf = {}, $9b6e3b5559a9e9a5$var$H = $9b6e3b5559a9e9a5$var$Uf($9b6e3b5559a9e9a5$var$Vf), $9b6e3b5559a9e9a5$var$Wf = $9b6e3b5559a9e9a5$var$Uf(!1), $9b6e3b5559a9e9a5$var$Xf = $9b6e3b5559a9e9a5$var$Vf;
function $9b6e3b5559a9e9a5$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9b6e3b5559a9e9a5$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9b6e3b5559a9e9a5$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9b6e3b5559a9e9a5$var$$f() {
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wf);
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$H);
}
function $9b6e3b5559a9e9a5$var$ag(a, b, c) {
    if ($9b6e3b5559a9e9a5$var$H.current !== $9b6e3b5559a9e9a5$var$Vf) throw Error($9b6e3b5559a9e9a5$var$p(168));
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$H, b);
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$Wf, c);
}
function $9b6e3b5559a9e9a5$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9b6e3b5559a9e9a5$var$p(108, $9b6e3b5559a9e9a5$var$Ra(a) || "Unknown", e));
    return $9b6e3b5559a9e9a5$var$A({}, c, d);
}
function $9b6e3b5559a9e9a5$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9b6e3b5559a9e9a5$var$Vf;
    $9b6e3b5559a9e9a5$var$Xf = $9b6e3b5559a9e9a5$var$H.current;
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$H, a);
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$Wf, $9b6e3b5559a9e9a5$var$Wf.current);
    return !0;
}
function $9b6e3b5559a9e9a5$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9b6e3b5559a9e9a5$var$p(169));
    c ? (a = $9b6e3b5559a9e9a5$var$bg(a, b, $9b6e3b5559a9e9a5$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wf), $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$H), $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$H, a)) : $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wf);
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$Wf, c);
}
var $9b6e3b5559a9e9a5$var$eg = null, $9b6e3b5559a9e9a5$var$fg = !1, $9b6e3b5559a9e9a5$var$gg = !1;
function $9b6e3b5559a9e9a5$var$hg(a) {
    null === $9b6e3b5559a9e9a5$var$eg ? $9b6e3b5559a9e9a5$var$eg = [
        a
    ] : $9b6e3b5559a9e9a5$var$eg.push(a);
}
function $9b6e3b5559a9e9a5$var$ig(a) {
    $9b6e3b5559a9e9a5$var$fg = !0;
    $9b6e3b5559a9e9a5$var$hg(a);
}
function $9b6e3b5559a9e9a5$var$jg() {
    if (!$9b6e3b5559a9e9a5$var$gg && null !== $9b6e3b5559a9e9a5$var$eg) {
        $9b6e3b5559a9e9a5$var$gg = !0;
        var a = 0, b = $9b6e3b5559a9e9a5$var$C;
        try {
            var c = $9b6e3b5559a9e9a5$var$eg;
            for($9b6e3b5559a9e9a5$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9b6e3b5559a9e9a5$var$eg = null;
            $9b6e3b5559a9e9a5$var$fg = !1;
        } catch (e) {
            throw null !== $9b6e3b5559a9e9a5$var$eg && ($9b6e3b5559a9e9a5$var$eg = $9b6e3b5559a9e9a5$var$eg.slice(a + 1)), $9b6e3b5559a9e9a5$var$ac($9b6e3b5559a9e9a5$var$fc, $9b6e3b5559a9e9a5$var$jg), e;
        } finally{
            $9b6e3b5559a9e9a5$var$C = b, $9b6e3b5559a9e9a5$var$gg = !1;
        }
    }
    return null;
}
var $9b6e3b5559a9e9a5$var$kg = [], $9b6e3b5559a9e9a5$var$lg = 0, $9b6e3b5559a9e9a5$var$mg = null, $9b6e3b5559a9e9a5$var$ng = 0, $9b6e3b5559a9e9a5$var$og = [], $9b6e3b5559a9e9a5$var$pg = 0, $9b6e3b5559a9e9a5$var$qg = null, $9b6e3b5559a9e9a5$var$rg = 1, $9b6e3b5559a9e9a5$var$sg = "";
function $9b6e3b5559a9e9a5$var$tg(a, b) {
    $9b6e3b5559a9e9a5$var$kg[$9b6e3b5559a9e9a5$var$lg++] = $9b6e3b5559a9e9a5$var$ng;
    $9b6e3b5559a9e9a5$var$kg[$9b6e3b5559a9e9a5$var$lg++] = $9b6e3b5559a9e9a5$var$mg;
    $9b6e3b5559a9e9a5$var$mg = a;
    $9b6e3b5559a9e9a5$var$ng = b;
}
function $9b6e3b5559a9e9a5$var$ug(a, b, c) {
    $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg++] = $9b6e3b5559a9e9a5$var$rg;
    $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg++] = $9b6e3b5559a9e9a5$var$sg;
    $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg++] = $9b6e3b5559a9e9a5$var$qg;
    $9b6e3b5559a9e9a5$var$qg = a;
    var d = $9b6e3b5559a9e9a5$var$rg;
    a = $9b6e3b5559a9e9a5$var$sg;
    var e = 32 - $9b6e3b5559a9e9a5$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9b6e3b5559a9e9a5$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9b6e3b5559a9e9a5$var$rg = 1 << 32 - $9b6e3b5559a9e9a5$var$oc(b) + e | c << e | d;
        $9b6e3b5559a9e9a5$var$sg = f + a;
    } else $9b6e3b5559a9e9a5$var$rg = 1 << f | c << e | d, $9b6e3b5559a9e9a5$var$sg = a;
}
function $9b6e3b5559a9e9a5$var$vg(a) {
    null !== a.return && ($9b6e3b5559a9e9a5$var$tg(a, 1), $9b6e3b5559a9e9a5$var$ug(a, 1, 0));
}
function $9b6e3b5559a9e9a5$var$wg(a) {
    for(; a === $9b6e3b5559a9e9a5$var$mg;)$9b6e3b5559a9e9a5$var$mg = $9b6e3b5559a9e9a5$var$kg[--$9b6e3b5559a9e9a5$var$lg], $9b6e3b5559a9e9a5$var$kg[$9b6e3b5559a9e9a5$var$lg] = null, $9b6e3b5559a9e9a5$var$ng = $9b6e3b5559a9e9a5$var$kg[--$9b6e3b5559a9e9a5$var$lg], $9b6e3b5559a9e9a5$var$kg[$9b6e3b5559a9e9a5$var$lg] = null;
    for(; a === $9b6e3b5559a9e9a5$var$qg;)$9b6e3b5559a9e9a5$var$qg = $9b6e3b5559a9e9a5$var$og[--$9b6e3b5559a9e9a5$var$pg], $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg] = null, $9b6e3b5559a9e9a5$var$sg = $9b6e3b5559a9e9a5$var$og[--$9b6e3b5559a9e9a5$var$pg], $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg] = null, $9b6e3b5559a9e9a5$var$rg = $9b6e3b5559a9e9a5$var$og[--$9b6e3b5559a9e9a5$var$pg], $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg] = null;
}
var $9b6e3b5559a9e9a5$var$xg = null, $9b6e3b5559a9e9a5$var$yg = null, $9b6e3b5559a9e9a5$var$I = !1, $9b6e3b5559a9e9a5$var$zg = null;
function $9b6e3b5559a9e9a5$var$Ag(a, b) {
    var c = $9b6e3b5559a9e9a5$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9b6e3b5559a9e9a5$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9b6e3b5559a9e9a5$var$xg = a, $9b6e3b5559a9e9a5$var$yg = $9b6e3b5559a9e9a5$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9b6e3b5559a9e9a5$var$xg = a, $9b6e3b5559a9e9a5$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9b6e3b5559a9e9a5$var$qg ? {
                id: $9b6e3b5559a9e9a5$var$rg,
                overflow: $9b6e3b5559a9e9a5$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9b6e3b5559a9e9a5$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9b6e3b5559a9e9a5$var$xg = a, $9b6e3b5559a9e9a5$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9b6e3b5559a9e9a5$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9b6e3b5559a9e9a5$var$Eg(a) {
    if ($9b6e3b5559a9e9a5$var$I) {
        var b = $9b6e3b5559a9e9a5$var$yg;
        if (b) {
            var c = b;
            if (!$9b6e3b5559a9e9a5$var$Cg(a, b)) {
                if ($9b6e3b5559a9e9a5$var$Dg(a)) throw Error($9b6e3b5559a9e9a5$var$p(418));
                b = $9b6e3b5559a9e9a5$var$Lf(c.nextSibling);
                var d = $9b6e3b5559a9e9a5$var$xg;
                b && $9b6e3b5559a9e9a5$var$Cg(a, b) ? $9b6e3b5559a9e9a5$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9b6e3b5559a9e9a5$var$I = !1, $9b6e3b5559a9e9a5$var$xg = a);
            }
        } else {
            if ($9b6e3b5559a9e9a5$var$Dg(a)) throw Error($9b6e3b5559a9e9a5$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9b6e3b5559a9e9a5$var$I = !1;
            $9b6e3b5559a9e9a5$var$xg = a;
        }
    }
}
function $9b6e3b5559a9e9a5$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9b6e3b5559a9e9a5$var$xg = a;
}
function $9b6e3b5559a9e9a5$var$Gg(a) {
    if (a !== $9b6e3b5559a9e9a5$var$xg) return !1;
    if (!$9b6e3b5559a9e9a5$var$I) return $9b6e3b5559a9e9a5$var$Fg(a), $9b6e3b5559a9e9a5$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9b6e3b5559a9e9a5$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9b6e3b5559a9e9a5$var$yg)) {
        if ($9b6e3b5559a9e9a5$var$Dg(a)) throw $9b6e3b5559a9e9a5$var$Hg(), Error($9b6e3b5559a9e9a5$var$p(418));
        for(; b;)$9b6e3b5559a9e9a5$var$Ag(a, b), b = $9b6e3b5559a9e9a5$var$Lf(b.nextSibling);
    }
    $9b6e3b5559a9e9a5$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9b6e3b5559a9e9a5$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9b6e3b5559a9e9a5$var$yg = $9b6e3b5559a9e9a5$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9b6e3b5559a9e9a5$var$yg = null;
        }
    } else $9b6e3b5559a9e9a5$var$yg = $9b6e3b5559a9e9a5$var$xg ? $9b6e3b5559a9e9a5$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9b6e3b5559a9e9a5$var$Hg() {
    for(var a = $9b6e3b5559a9e9a5$var$yg; a;)a = $9b6e3b5559a9e9a5$var$Lf(a.nextSibling);
}
function $9b6e3b5559a9e9a5$var$Ig() {
    $9b6e3b5559a9e9a5$var$yg = $9b6e3b5559a9e9a5$var$xg = null;
    $9b6e3b5559a9e9a5$var$I = !1;
}
function $9b6e3b5559a9e9a5$var$Jg(a) {
    null === $9b6e3b5559a9e9a5$var$zg ? $9b6e3b5559a9e9a5$var$zg = [
        a
    ] : $9b6e3b5559a9e9a5$var$zg.push(a);
}
var $9b6e3b5559a9e9a5$var$Kg = $9b6e3b5559a9e9a5$var$ua.ReactCurrentBatchConfig;
function $9b6e3b5559a9e9a5$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9b6e3b5559a9e9a5$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9b6e3b5559a9e9a5$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9b6e3b5559a9e9a5$var$p(284));
        if (!c._owner) throw Error($9b6e3b5559a9e9a5$var$p(290, a));
    }
    return a;
}
function $9b6e3b5559a9e9a5$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9b6e3b5559a9e9a5$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9b6e3b5559a9e9a5$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $9b6e3b5559a9e9a5$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9b6e3b5559a9e9a5$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9b6e3b5559a9e9a5$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9b6e3b5559a9e9a5$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9b6e3b5559a9e9a5$var$Ha && $9b6e3b5559a9e9a5$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $9b6e3b5559a9e9a5$var$Lg(a, b, c), d.return = a, d;
        d = $9b6e3b5559a9e9a5$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9b6e3b5559a9e9a5$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9b6e3b5559a9e9a5$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9b6e3b5559a9e9a5$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9b6e3b5559a9e9a5$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9b6e3b5559a9e9a5$var$va:
                    return c = $9b6e3b5559a9e9a5$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $9b6e3b5559a9e9a5$var$Lg(a, null, b), c.return = a, c;
                case $9b6e3b5559a9e9a5$var$wa:
                    return b = $9b6e3b5559a9e9a5$var$Sg(b, a.mode, c), b.return = a, b;
                case $9b6e3b5559a9e9a5$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9b6e3b5559a9e9a5$var$eb(b) || $9b6e3b5559a9e9a5$var$Ka(b)) return b = $9b6e3b5559a9e9a5$var$Tg(b, a.mode, c, null), b.return = a, b;
            $9b6e3b5559a9e9a5$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9b6e3b5559a9e9a5$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9b6e3b5559a9e9a5$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9b6e3b5559a9e9a5$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9b6e3b5559a9e9a5$var$eb(c) || $9b6e3b5559a9e9a5$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9b6e3b5559a9e9a5$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9b6e3b5559a9e9a5$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9b6e3b5559a9e9a5$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9b6e3b5559a9e9a5$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9b6e3b5559a9e9a5$var$eb(d) || $9b6e3b5559a9e9a5$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9b6e3b5559a9e9a5$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9b6e3b5559a9e9a5$var$I && $9b6e3b5559a9e9a5$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9b6e3b5559a9e9a5$var$I && $9b6e3b5559a9e9a5$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9b6e3b5559a9e9a5$var$I && $9b6e3b5559a9e9a5$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9b6e3b5559a9e9a5$var$Ka(h);
        if ("function" !== typeof l) throw Error($9b6e3b5559a9e9a5$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9b6e3b5559a9e9a5$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9b6e3b5559a9e9a5$var$I && $9b6e3b5559a9e9a5$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9b6e3b5559a9e9a5$var$I && $9b6e3b5559a9e9a5$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9b6e3b5559a9e9a5$var$I && $9b6e3b5559a9e9a5$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9b6e3b5559a9e9a5$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9b6e3b5559a9e9a5$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9b6e3b5559a9e9a5$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9b6e3b5559a9e9a5$var$Ha && $9b6e3b5559a9e9a5$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9b6e3b5559a9e9a5$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9b6e3b5559a9e9a5$var$ya ? (d = $9b6e3b5559a9e9a5$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9b6e3b5559a9e9a5$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $9b6e3b5559a9e9a5$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9b6e3b5559a9e9a5$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9b6e3b5559a9e9a5$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9b6e3b5559a9e9a5$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9b6e3b5559a9e9a5$var$eb(f)) return n(a, d, f, h);
            if ($9b6e3b5559a9e9a5$var$Ka(f)) return t(a, d, f, h);
            $9b6e3b5559a9e9a5$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9b6e3b5559a9e9a5$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9b6e3b5559a9e9a5$var$Ug = $9b6e3b5559a9e9a5$var$Og(!0), $9b6e3b5559a9e9a5$var$Vg = $9b6e3b5559a9e9a5$var$Og(!1), $9b6e3b5559a9e9a5$var$Wg = $9b6e3b5559a9e9a5$var$Uf(null), $9b6e3b5559a9e9a5$var$Xg = null, $9b6e3b5559a9e9a5$var$Yg = null, $9b6e3b5559a9e9a5$var$Zg = null;
function $9b6e3b5559a9e9a5$var$$g() {
    $9b6e3b5559a9e9a5$var$Zg = $9b6e3b5559a9e9a5$var$Yg = $9b6e3b5559a9e9a5$var$Xg = null;
}
function $9b6e3b5559a9e9a5$var$ah(a) {
    var b = $9b6e3b5559a9e9a5$var$Wg.current;
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wg);
    a._currentValue = b;
}
function $9b6e3b5559a9e9a5$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9b6e3b5559a9e9a5$var$ch(a, b) {
    $9b6e3b5559a9e9a5$var$Xg = a;
    $9b6e3b5559a9e9a5$var$Zg = $9b6e3b5559a9e9a5$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9b6e3b5559a9e9a5$var$dh = !0), a.firstContext = null);
}
function $9b6e3b5559a9e9a5$var$eh(a) {
    var b = a._currentValue;
    if ($9b6e3b5559a9e9a5$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9b6e3b5559a9e9a5$var$Yg) {
            if (null === $9b6e3b5559a9e9a5$var$Xg) throw Error($9b6e3b5559a9e9a5$var$p(308));
            $9b6e3b5559a9e9a5$var$Yg = a;
            $9b6e3b5559a9e9a5$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9b6e3b5559a9e9a5$var$Yg = $9b6e3b5559a9e9a5$var$Yg.next = a;
    }
    return b;
}
var $9b6e3b5559a9e9a5$var$fh = null;
function $9b6e3b5559a9e9a5$var$gh(a) {
    null === $9b6e3b5559a9e9a5$var$fh ? $9b6e3b5559a9e9a5$var$fh = [
        a
    ] : $9b6e3b5559a9e9a5$var$fh.push(a);
}
function $9b6e3b5559a9e9a5$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9b6e3b5559a9e9a5$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9b6e3b5559a9e9a5$var$ih(a, d);
}
function $9b6e3b5559a9e9a5$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9b6e3b5559a9e9a5$var$jh = !1;
function $9b6e3b5559a9e9a5$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9b6e3b5559a9e9a5$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9b6e3b5559a9e9a5$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9b6e3b5559a9e9a5$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9b6e3b5559a9e9a5$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9b6e3b5559a9e9a5$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9b6e3b5559a9e9a5$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9b6e3b5559a9e9a5$var$ih(a, c);
}
function $9b6e3b5559a9e9a5$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b6e3b5559a9e9a5$var$Cc(a, c);
    }
}
function $9b6e3b5559a9e9a5$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9b6e3b5559a9e9a5$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $9b6e3b5559a9e9a5$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9b6e3b5559a9e9a5$var$A({}, q, r);
                            break a;
                        case 2:
                            $9b6e3b5559a9e9a5$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9b6e3b5559a9e9a5$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9b6e3b5559a9e9a5$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9b6e3b5559a9e9a5$var$p(191, e));
            e.call(d);
        }
    }
}
var $9b6e3b5559a9e9a5$var$th = {}, $9b6e3b5559a9e9a5$var$uh = $9b6e3b5559a9e9a5$var$Uf($9b6e3b5559a9e9a5$var$th), $9b6e3b5559a9e9a5$var$vh = $9b6e3b5559a9e9a5$var$Uf($9b6e3b5559a9e9a5$var$th), $9b6e3b5559a9e9a5$var$wh = $9b6e3b5559a9e9a5$var$Uf($9b6e3b5559a9e9a5$var$th);
function $9b6e3b5559a9e9a5$var$xh(a) {
    if (a === $9b6e3b5559a9e9a5$var$th) throw Error($9b6e3b5559a9e9a5$var$p(174));
    return a;
}
function $9b6e3b5559a9e9a5$var$yh(a, b) {
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$wh, b);
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$vh, a);
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$uh, $9b6e3b5559a9e9a5$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9b6e3b5559a9e9a5$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9b6e3b5559a9e9a5$var$lb(b, a);
    }
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$uh);
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$uh, b);
}
function $9b6e3b5559a9e9a5$var$zh() {
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$uh);
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$vh);
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$wh);
}
function $9b6e3b5559a9e9a5$var$Ah(a) {
    $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$wh.current);
    var b = $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$uh.current);
    var c = $9b6e3b5559a9e9a5$var$lb(b, a.type);
    b !== c && ($9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$vh, a), $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$uh, c));
}
function $9b6e3b5559a9e9a5$var$Bh(a) {
    $9b6e3b5559a9e9a5$var$vh.current === a && ($9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$uh), $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$vh));
}
var $9b6e3b5559a9e9a5$var$L = $9b6e3b5559a9e9a5$var$Uf(0);
function $9b6e3b5559a9e9a5$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9b6e3b5559a9e9a5$var$Dh = [];
function $9b6e3b5559a9e9a5$var$Eh() {
    for(var a = 0; a < $9b6e3b5559a9e9a5$var$Dh.length; a++)$9b6e3b5559a9e9a5$var$Dh[a]._workInProgressVersionPrimary = null;
    $9b6e3b5559a9e9a5$var$Dh.length = 0;
}
var $9b6e3b5559a9e9a5$var$Fh = $9b6e3b5559a9e9a5$var$ua.ReactCurrentDispatcher, $9b6e3b5559a9e9a5$var$Gh = $9b6e3b5559a9e9a5$var$ua.ReactCurrentBatchConfig, $9b6e3b5559a9e9a5$var$Hh = 0, $9b6e3b5559a9e9a5$var$M = null, $9b6e3b5559a9e9a5$var$N = null, $9b6e3b5559a9e9a5$var$O = null, $9b6e3b5559a9e9a5$var$Ih = !1, $9b6e3b5559a9e9a5$var$Jh = !1, $9b6e3b5559a9e9a5$var$Kh = 0, $9b6e3b5559a9e9a5$var$Lh = 0;
function $9b6e3b5559a9e9a5$var$P() {
    throw Error($9b6e3b5559a9e9a5$var$p(321));
}
function $9b6e3b5559a9e9a5$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9b6e3b5559a9e9a5$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9b6e3b5559a9e9a5$var$Nh(a, b, c, d, e, f) {
    $9b6e3b5559a9e9a5$var$Hh = f;
    $9b6e3b5559a9e9a5$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9b6e3b5559a9e9a5$var$Fh.current = null === a || null === a.memoizedState ? $9b6e3b5559a9e9a5$var$Oh : $9b6e3b5559a9e9a5$var$Ph;
    a = c(d, e);
    if ($9b6e3b5559a9e9a5$var$Jh) {
        f = 0;
        do {
            $9b6e3b5559a9e9a5$var$Jh = !1;
            $9b6e3b5559a9e9a5$var$Kh = 0;
            if (25 <= f) throw Error($9b6e3b5559a9e9a5$var$p(301));
            f += 1;
            $9b6e3b5559a9e9a5$var$O = $9b6e3b5559a9e9a5$var$N = null;
            b.updateQueue = null;
            $9b6e3b5559a9e9a5$var$Fh.current = $9b6e3b5559a9e9a5$var$Qh;
            a = c(d, e);
        }while ($9b6e3b5559a9e9a5$var$Jh);
    }
    $9b6e3b5559a9e9a5$var$Fh.current = $9b6e3b5559a9e9a5$var$Rh;
    b = null !== $9b6e3b5559a9e9a5$var$N && null !== $9b6e3b5559a9e9a5$var$N.next;
    $9b6e3b5559a9e9a5$var$Hh = 0;
    $9b6e3b5559a9e9a5$var$O = $9b6e3b5559a9e9a5$var$N = $9b6e3b5559a9e9a5$var$M = null;
    $9b6e3b5559a9e9a5$var$Ih = !1;
    if (b) throw Error($9b6e3b5559a9e9a5$var$p(300));
    return a;
}
function $9b6e3b5559a9e9a5$var$Sh() {
    var a = 0 !== $9b6e3b5559a9e9a5$var$Kh;
    $9b6e3b5559a9e9a5$var$Kh = 0;
    return a;
}
function $9b6e3b5559a9e9a5$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9b6e3b5559a9e9a5$var$O ? $9b6e3b5559a9e9a5$var$M.memoizedState = $9b6e3b5559a9e9a5$var$O = a : $9b6e3b5559a9e9a5$var$O = $9b6e3b5559a9e9a5$var$O.next = a;
    return $9b6e3b5559a9e9a5$var$O;
}
function $9b6e3b5559a9e9a5$var$Uh() {
    if (null === $9b6e3b5559a9e9a5$var$N) {
        var a = $9b6e3b5559a9e9a5$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9b6e3b5559a9e9a5$var$N.next;
    var b = null === $9b6e3b5559a9e9a5$var$O ? $9b6e3b5559a9e9a5$var$M.memoizedState : $9b6e3b5559a9e9a5$var$O.next;
    if (null !== b) $9b6e3b5559a9e9a5$var$O = b, $9b6e3b5559a9e9a5$var$N = a;
    else {
        if (null === a) throw Error($9b6e3b5559a9e9a5$var$p(310));
        $9b6e3b5559a9e9a5$var$N = a;
        a = {
            memoizedState: $9b6e3b5559a9e9a5$var$N.memoizedState,
            baseState: $9b6e3b5559a9e9a5$var$N.baseState,
            baseQueue: $9b6e3b5559a9e9a5$var$N.baseQueue,
            queue: $9b6e3b5559a9e9a5$var$N.queue,
            next: null
        };
        null === $9b6e3b5559a9e9a5$var$O ? $9b6e3b5559a9e9a5$var$M.memoizedState = $9b6e3b5559a9e9a5$var$O = a : $9b6e3b5559a9e9a5$var$O = $9b6e3b5559a9e9a5$var$O.next = a;
    }
    return $9b6e3b5559a9e9a5$var$O;
}
function $9b6e3b5559a9e9a5$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9b6e3b5559a9e9a5$var$Wh(a) {
    var b = $9b6e3b5559a9e9a5$var$Uh(), c = b.queue;
    if (null === c) throw Error($9b6e3b5559a9e9a5$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9b6e3b5559a9e9a5$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9b6e3b5559a9e9a5$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9b6e3b5559a9e9a5$var$M.lanes |= m;
                $9b6e3b5559a9e9a5$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9b6e3b5559a9e9a5$var$He(d, b.memoizedState) || ($9b6e3b5559a9e9a5$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9b6e3b5559a9e9a5$var$M.lanes |= f, $9b6e3b5559a9e9a5$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9b6e3b5559a9e9a5$var$Xh(a) {
    var b = $9b6e3b5559a9e9a5$var$Uh(), c = b.queue;
    if (null === c) throw Error($9b6e3b5559a9e9a5$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9b6e3b5559a9e9a5$var$He(f, b.memoizedState) || ($9b6e3b5559a9e9a5$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9b6e3b5559a9e9a5$var$Yh() {}
function $9b6e3b5559a9e9a5$var$Zh(a, b) {
    var c = $9b6e3b5559a9e9a5$var$M, d = $9b6e3b5559a9e9a5$var$Uh(), e = b(), f = !$9b6e3b5559a9e9a5$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9b6e3b5559a9e9a5$var$dh = !0);
    d = d.queue;
    $9b6e3b5559a9e9a5$var$$h($9b6e3b5559a9e9a5$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9b6e3b5559a9e9a5$var$O && $9b6e3b5559a9e9a5$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9b6e3b5559a9e9a5$var$bi(9, $9b6e3b5559a9e9a5$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $9b6e3b5559a9e9a5$var$Q) throw Error($9b6e3b5559a9e9a5$var$p(349));
        0 !== ($9b6e3b5559a9e9a5$var$Hh & 30) || $9b6e3b5559a9e9a5$var$di(c, b, e);
    }
    return e;
}
function $9b6e3b5559a9e9a5$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9b6e3b5559a9e9a5$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b6e3b5559a9e9a5$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9b6e3b5559a9e9a5$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9b6e3b5559a9e9a5$var$ei(b) && $9b6e3b5559a9e9a5$var$fi(a);
}
function $9b6e3b5559a9e9a5$var$ai(a, b, c) {
    return c(function() {
        $9b6e3b5559a9e9a5$var$ei(b) && $9b6e3b5559a9e9a5$var$fi(a);
    });
}
function $9b6e3b5559a9e9a5$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9b6e3b5559a9e9a5$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9b6e3b5559a9e9a5$var$fi(a) {
    var b = $9b6e3b5559a9e9a5$var$ih(a, 1);
    null !== b && $9b6e3b5559a9e9a5$var$gi(b, a, 1, -1);
}
function $9b6e3b5559a9e9a5$var$hi(a) {
    var b = $9b6e3b5559a9e9a5$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9b6e3b5559a9e9a5$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9b6e3b5559a9e9a5$var$ii.bind(null, $9b6e3b5559a9e9a5$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9b6e3b5559a9e9a5$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9b6e3b5559a9e9a5$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b6e3b5559a9e9a5$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9b6e3b5559a9e9a5$var$ji() {
    return $9b6e3b5559a9e9a5$var$Uh().memoizedState;
}
function $9b6e3b5559a9e9a5$var$ki(a, b, c, d) {
    var e = $9b6e3b5559a9e9a5$var$Th();
    $9b6e3b5559a9e9a5$var$M.flags |= a;
    e.memoizedState = $9b6e3b5559a9e9a5$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9b6e3b5559a9e9a5$var$li(a, b, c, d) {
    var e = $9b6e3b5559a9e9a5$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9b6e3b5559a9e9a5$var$N) {
        var g = $9b6e3b5559a9e9a5$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $9b6e3b5559a9e9a5$var$Mh(d, g.deps)) {
            e.memoizedState = $9b6e3b5559a9e9a5$var$bi(b, c, f, d);
            return;
        }
    }
    $9b6e3b5559a9e9a5$var$M.flags |= a;
    e.memoizedState = $9b6e3b5559a9e9a5$var$bi(1 | b, c, f, d);
}
function $9b6e3b5559a9e9a5$var$mi(a, b) {
    return $9b6e3b5559a9e9a5$var$ki(8390656, 8, a, b);
}
function $9b6e3b5559a9e9a5$var$$h(a, b) {
    return $9b6e3b5559a9e9a5$var$li(2048, 8, a, b);
}
function $9b6e3b5559a9e9a5$var$ni(a, b) {
    return $9b6e3b5559a9e9a5$var$li(4, 2, a, b);
}
function $9b6e3b5559a9e9a5$var$oi(a, b) {
    return $9b6e3b5559a9e9a5$var$li(4, 4, a, b);
}
function $9b6e3b5559a9e9a5$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9b6e3b5559a9e9a5$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9b6e3b5559a9e9a5$var$li(4, 4, $9b6e3b5559a9e9a5$var$pi.bind(null, b, a), c);
}
function $9b6e3b5559a9e9a5$var$ri() {}
function $9b6e3b5559a9e9a5$var$si(a, b) {
    var c = $9b6e3b5559a9e9a5$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b6e3b5559a9e9a5$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b6e3b5559a9e9a5$var$ti(a, b) {
    var c = $9b6e3b5559a9e9a5$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b6e3b5559a9e9a5$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b6e3b5559a9e9a5$var$ui(a, b, c) {
    if (0 === ($9b6e3b5559a9e9a5$var$Hh & 21)) return a.baseState && (a.baseState = !1, $9b6e3b5559a9e9a5$var$dh = !0), a.memoizedState = c;
    $9b6e3b5559a9e9a5$var$He(c, b) || (c = $9b6e3b5559a9e9a5$var$yc(), $9b6e3b5559a9e9a5$var$M.lanes |= c, $9b6e3b5559a9e9a5$var$rh |= c, a.baseState = !0);
    return b;
}
function $9b6e3b5559a9e9a5$var$vi(a, b) {
    var c = $9b6e3b5559a9e9a5$var$C;
    $9b6e3b5559a9e9a5$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9b6e3b5559a9e9a5$var$Gh.transition;
    $9b6e3b5559a9e9a5$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9b6e3b5559a9e9a5$var$C = c, $9b6e3b5559a9e9a5$var$Gh.transition = d;
    }
}
function $9b6e3b5559a9e9a5$var$wi() {
    return $9b6e3b5559a9e9a5$var$Uh().memoizedState;
}
function $9b6e3b5559a9e9a5$var$xi(a, b, c) {
    var d = $9b6e3b5559a9e9a5$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b6e3b5559a9e9a5$var$zi(a)) $9b6e3b5559a9e9a5$var$Ai(b, c);
    else if (c = $9b6e3b5559a9e9a5$var$hh(a, b, c, d), null !== c) {
        var e = $9b6e3b5559a9e9a5$var$R();
        $9b6e3b5559a9e9a5$var$gi(c, a, d, e);
        $9b6e3b5559a9e9a5$var$Bi(c, b, d);
    }
}
function $9b6e3b5559a9e9a5$var$ii(a, b, c) {
    var d = $9b6e3b5559a9e9a5$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b6e3b5559a9e9a5$var$zi(a)) $9b6e3b5559a9e9a5$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9b6e3b5559a9e9a5$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9b6e3b5559a9e9a5$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9b6e3b5559a9e9a5$var$hh(a, b, e, d);
        null !== c && (e = $9b6e3b5559a9e9a5$var$R(), $9b6e3b5559a9e9a5$var$gi(c, a, d, e), $9b6e3b5559a9e9a5$var$Bi(c, b, d));
    }
}
function $9b6e3b5559a9e9a5$var$zi(a) {
    var b = a.alternate;
    return a === $9b6e3b5559a9e9a5$var$M || null !== b && b === $9b6e3b5559a9e9a5$var$M;
}
function $9b6e3b5559a9e9a5$var$Ai(a, b) {
    $9b6e3b5559a9e9a5$var$Jh = $9b6e3b5559a9e9a5$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9b6e3b5559a9e9a5$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b6e3b5559a9e9a5$var$Cc(a, c);
    }
}
var $9b6e3b5559a9e9a5$var$Rh = {
    readContext: $9b6e3b5559a9e9a5$var$eh,
    useCallback: $9b6e3b5559a9e9a5$var$P,
    useContext: $9b6e3b5559a9e9a5$var$P,
    useEffect: $9b6e3b5559a9e9a5$var$P,
    useImperativeHandle: $9b6e3b5559a9e9a5$var$P,
    useInsertionEffect: $9b6e3b5559a9e9a5$var$P,
    useLayoutEffect: $9b6e3b5559a9e9a5$var$P,
    useMemo: $9b6e3b5559a9e9a5$var$P,
    useReducer: $9b6e3b5559a9e9a5$var$P,
    useRef: $9b6e3b5559a9e9a5$var$P,
    useState: $9b6e3b5559a9e9a5$var$P,
    useDebugValue: $9b6e3b5559a9e9a5$var$P,
    useDeferredValue: $9b6e3b5559a9e9a5$var$P,
    useTransition: $9b6e3b5559a9e9a5$var$P,
    useMutableSource: $9b6e3b5559a9e9a5$var$P,
    useSyncExternalStore: $9b6e3b5559a9e9a5$var$P,
    useId: $9b6e3b5559a9e9a5$var$P,
    unstable_isNewReconciler: !1
}, $9b6e3b5559a9e9a5$var$Oh = {
    readContext: $9b6e3b5559a9e9a5$var$eh,
    useCallback: function(a, b) {
        $9b6e3b5559a9e9a5$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9b6e3b5559a9e9a5$var$eh,
    useEffect: $9b6e3b5559a9e9a5$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9b6e3b5559a9e9a5$var$ki(4194308, 4, $9b6e3b5559a9e9a5$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9b6e3b5559a9e9a5$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9b6e3b5559a9e9a5$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9b6e3b5559a9e9a5$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9b6e3b5559a9e9a5$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9b6e3b5559a9e9a5$var$xi.bind(null, $9b6e3b5559a9e9a5$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9b6e3b5559a9e9a5$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9b6e3b5559a9e9a5$var$hi,
    useDebugValue: $9b6e3b5559a9e9a5$var$ri,
    useDeferredValue: function(a) {
        return $9b6e3b5559a9e9a5$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $9b6e3b5559a9e9a5$var$hi(!1), b = a[0];
        a = $9b6e3b5559a9e9a5$var$vi.bind(null, a[1]);
        $9b6e3b5559a9e9a5$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9b6e3b5559a9e9a5$var$M, e = $9b6e3b5559a9e9a5$var$Th();
        if ($9b6e3b5559a9e9a5$var$I) {
            if (void 0 === c) throw Error($9b6e3b5559a9e9a5$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9b6e3b5559a9e9a5$var$Q) throw Error($9b6e3b5559a9e9a5$var$p(349));
            0 !== ($9b6e3b5559a9e9a5$var$Hh & 30) || $9b6e3b5559a9e9a5$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9b6e3b5559a9e9a5$var$mi($9b6e3b5559a9e9a5$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9b6e3b5559a9e9a5$var$bi(9, $9b6e3b5559a9e9a5$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9b6e3b5559a9e9a5$var$Th(), b = $9b6e3b5559a9e9a5$var$Q.identifierPrefix;
        if ($9b6e3b5559a9e9a5$var$I) {
            var c = $9b6e3b5559a9e9a5$var$sg;
            var d = $9b6e3b5559a9e9a5$var$rg;
            c = (d & ~(1 << 32 - $9b6e3b5559a9e9a5$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9b6e3b5559a9e9a5$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9b6e3b5559a9e9a5$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9b6e3b5559a9e9a5$var$Ph = {
    readContext: $9b6e3b5559a9e9a5$var$eh,
    useCallback: $9b6e3b5559a9e9a5$var$si,
    useContext: $9b6e3b5559a9e9a5$var$eh,
    useEffect: $9b6e3b5559a9e9a5$var$$h,
    useImperativeHandle: $9b6e3b5559a9e9a5$var$qi,
    useInsertionEffect: $9b6e3b5559a9e9a5$var$ni,
    useLayoutEffect: $9b6e3b5559a9e9a5$var$oi,
    useMemo: $9b6e3b5559a9e9a5$var$ti,
    useReducer: $9b6e3b5559a9e9a5$var$Wh,
    useRef: $9b6e3b5559a9e9a5$var$ji,
    useState: function() {
        return $9b6e3b5559a9e9a5$var$Wh($9b6e3b5559a9e9a5$var$Vh);
    },
    useDebugValue: $9b6e3b5559a9e9a5$var$ri,
    useDeferredValue: function(a) {
        var b = $9b6e3b5559a9e9a5$var$Uh();
        return $9b6e3b5559a9e9a5$var$ui(b, $9b6e3b5559a9e9a5$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b6e3b5559a9e9a5$var$Wh($9b6e3b5559a9e9a5$var$Vh)[0], b = $9b6e3b5559a9e9a5$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b6e3b5559a9e9a5$var$Yh,
    useSyncExternalStore: $9b6e3b5559a9e9a5$var$Zh,
    useId: $9b6e3b5559a9e9a5$var$wi,
    unstable_isNewReconciler: !1
}, $9b6e3b5559a9e9a5$var$Qh = {
    readContext: $9b6e3b5559a9e9a5$var$eh,
    useCallback: $9b6e3b5559a9e9a5$var$si,
    useContext: $9b6e3b5559a9e9a5$var$eh,
    useEffect: $9b6e3b5559a9e9a5$var$$h,
    useImperativeHandle: $9b6e3b5559a9e9a5$var$qi,
    useInsertionEffect: $9b6e3b5559a9e9a5$var$ni,
    useLayoutEffect: $9b6e3b5559a9e9a5$var$oi,
    useMemo: $9b6e3b5559a9e9a5$var$ti,
    useReducer: $9b6e3b5559a9e9a5$var$Xh,
    useRef: $9b6e3b5559a9e9a5$var$ji,
    useState: function() {
        return $9b6e3b5559a9e9a5$var$Xh($9b6e3b5559a9e9a5$var$Vh);
    },
    useDebugValue: $9b6e3b5559a9e9a5$var$ri,
    useDeferredValue: function(a) {
        var b = $9b6e3b5559a9e9a5$var$Uh();
        return null === $9b6e3b5559a9e9a5$var$N ? b.memoizedState = a : $9b6e3b5559a9e9a5$var$ui(b, $9b6e3b5559a9e9a5$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b6e3b5559a9e9a5$var$Xh($9b6e3b5559a9e9a5$var$Vh)[0], b = $9b6e3b5559a9e9a5$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b6e3b5559a9e9a5$var$Yh,
    useSyncExternalStore: $9b6e3b5559a9e9a5$var$Zh,
    useId: $9b6e3b5559a9e9a5$var$wi,
    unstable_isNewReconciler: !1
};
function $9b6e3b5559a9e9a5$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $9b6e3b5559a9e9a5$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9b6e3b5559a9e9a5$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9b6e3b5559a9e9a5$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9b6e3b5559a9e9a5$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9b6e3b5559a9e9a5$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b6e3b5559a9e9a5$var$R(), e = $9b6e3b5559a9e9a5$var$yi(a), f = $9b6e3b5559a9e9a5$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b6e3b5559a9e9a5$var$nh(a, f, e);
        null !== b && ($9b6e3b5559a9e9a5$var$gi(b, a, e, d), $9b6e3b5559a9e9a5$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b6e3b5559a9e9a5$var$R(), e = $9b6e3b5559a9e9a5$var$yi(a), f = $9b6e3b5559a9e9a5$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b6e3b5559a9e9a5$var$nh(a, f, e);
        null !== b && ($9b6e3b5559a9e9a5$var$gi(b, a, e, d), $9b6e3b5559a9e9a5$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9b6e3b5559a9e9a5$var$R(), d = $9b6e3b5559a9e9a5$var$yi(a), e = $9b6e3b5559a9e9a5$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9b6e3b5559a9e9a5$var$nh(a, e, d);
        null !== b && ($9b6e3b5559a9e9a5$var$gi(b, a, d, c), $9b6e3b5559a9e9a5$var$oh(b, a, d));
    }
};
function $9b6e3b5559a9e9a5$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9b6e3b5559a9e9a5$var$Ie(c, d) || !$9b6e3b5559a9e9a5$var$Ie(e, f) : !0;
}
function $9b6e3b5559a9e9a5$var$Gi(a, b, c) {
    var d = !1, e = $9b6e3b5559a9e9a5$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9b6e3b5559a9e9a5$var$eh(f) : (e = $9b6e3b5559a9e9a5$var$Zf(b) ? $9b6e3b5559a9e9a5$var$Xf : $9b6e3b5559a9e9a5$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9b6e3b5559a9e9a5$var$Yf(a, e) : $9b6e3b5559a9e9a5$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9b6e3b5559a9e9a5$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9b6e3b5559a9e9a5$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9b6e3b5559a9e9a5$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $9b6e3b5559a9e9a5$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $9b6e3b5559a9e9a5$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9b6e3b5559a9e9a5$var$eh(f) : (f = $9b6e3b5559a9e9a5$var$Zf(b) ? $9b6e3b5559a9e9a5$var$Xf : $9b6e3b5559a9e9a5$var$H.current, e.context = $9b6e3b5559a9e9a5$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9b6e3b5559a9e9a5$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9b6e3b5559a9e9a5$var$Ei.enqueueReplaceState(e, e.state, null), $9b6e3b5559a9e9a5$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9b6e3b5559a9e9a5$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $9b6e3b5559a9e9a5$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9b6e3b5559a9e9a5$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9b6e3b5559a9e9a5$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9b6e3b5559a9e9a5$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $9b6e3b5559a9e9a5$var$Ni(a, b, c) {
    c = $9b6e3b5559a9e9a5$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9b6e3b5559a9e9a5$var$Oi || ($9b6e3b5559a9e9a5$var$Oi = !0, $9b6e3b5559a9e9a5$var$Pi = d);
        $9b6e3b5559a9e9a5$var$Li(a, b);
    };
    return c;
}
function $9b6e3b5559a9e9a5$var$Qi(a, b, c) {
    c = $9b6e3b5559a9e9a5$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9b6e3b5559a9e9a5$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9b6e3b5559a9e9a5$var$Li(a, b);
        "function" !== typeof d && (null === $9b6e3b5559a9e9a5$var$Ri ? $9b6e3b5559a9e9a5$var$Ri = new Set([
            this
        ]) : $9b6e3b5559a9e9a5$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9b6e3b5559a9e9a5$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9b6e3b5559a9e9a5$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9b6e3b5559a9e9a5$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $9b6e3b5559a9e9a5$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9b6e3b5559a9e9a5$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9b6e3b5559a9e9a5$var$mh(-1, 1), b.tag = 2, $9b6e3b5559a9e9a5$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9b6e3b5559a9e9a5$var$Wi = $9b6e3b5559a9e9a5$var$ua.ReactCurrentOwner, $9b6e3b5559a9e9a5$var$dh = !1;
function $9b6e3b5559a9e9a5$var$Xi(a, b, c, d) {
    b.child = null === a ? $9b6e3b5559a9e9a5$var$Vg(b, null, c, d) : $9b6e3b5559a9e9a5$var$Ug(b, a.child, c, d);
}
function $9b6e3b5559a9e9a5$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9b6e3b5559a9e9a5$var$ch(b, e);
    d = $9b6e3b5559a9e9a5$var$Nh(a, b, c, d, f, e);
    c = $9b6e3b5559a9e9a5$var$Sh();
    if (null !== a && !$9b6e3b5559a9e9a5$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b6e3b5559a9e9a5$var$Zi(a, b, e);
    $9b6e3b5559a9e9a5$var$I && c && $9b6e3b5559a9e9a5$var$vg(b);
    b.flags |= 1;
    $9b6e3b5559a9e9a5$var$Xi(a, b, d, e);
    return b.child;
}
function $9b6e3b5559a9e9a5$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9b6e3b5559a9e9a5$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9b6e3b5559a9e9a5$var$bj(a, b, f, d, e);
        a = $9b6e3b5559a9e9a5$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9b6e3b5559a9e9a5$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9b6e3b5559a9e9a5$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $9b6e3b5559a9e9a5$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9b6e3b5559a9e9a5$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9b6e3b5559a9e9a5$var$Ie(f, d) && a.ref === b.ref) {
            if ($9b6e3b5559a9e9a5$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9b6e3b5559a9e9a5$var$dh = !0);
            else return b.lanes = a.lanes, $9b6e3b5559a9e9a5$var$Zi(a, b, e);
        }
    }
    return $9b6e3b5559a9e9a5$var$cj(a, b, c, d, e);
}
function $9b6e3b5559a9e9a5$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$ej, $9b6e3b5559a9e9a5$var$fj), $9b6e3b5559a9e9a5$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$ej, $9b6e3b5559a9e9a5$var$fj), $9b6e3b5559a9e9a5$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$ej, $9b6e3b5559a9e9a5$var$fj);
            $9b6e3b5559a9e9a5$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$ej, $9b6e3b5559a9e9a5$var$fj), $9b6e3b5559a9e9a5$var$fj |= d;
    $9b6e3b5559a9e9a5$var$Xi(a, b, e, c);
    return b.child;
}
function $9b6e3b5559a9e9a5$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9b6e3b5559a9e9a5$var$cj(a, b, c, d, e) {
    var f = $9b6e3b5559a9e9a5$var$Zf(c) ? $9b6e3b5559a9e9a5$var$Xf : $9b6e3b5559a9e9a5$var$H.current;
    f = $9b6e3b5559a9e9a5$var$Yf(b, f);
    $9b6e3b5559a9e9a5$var$ch(b, e);
    c = $9b6e3b5559a9e9a5$var$Nh(a, b, c, d, f, e);
    d = $9b6e3b5559a9e9a5$var$Sh();
    if (null !== a && !$9b6e3b5559a9e9a5$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b6e3b5559a9e9a5$var$Zi(a, b, e);
    $9b6e3b5559a9e9a5$var$I && d && $9b6e3b5559a9e9a5$var$vg(b);
    b.flags |= 1;
    $9b6e3b5559a9e9a5$var$Xi(a, b, c, e);
    return b.child;
}
function $9b6e3b5559a9e9a5$var$hj(a, b, c, d, e) {
    if ($9b6e3b5559a9e9a5$var$Zf(c)) {
        var f = !0;
        $9b6e3b5559a9e9a5$var$cg(b);
    } else f = !1;
    $9b6e3b5559a9e9a5$var$ch(b, e);
    if (null === b.stateNode) $9b6e3b5559a9e9a5$var$ij(a, b), $9b6e3b5559a9e9a5$var$Gi(b, c, d), $9b6e3b5559a9e9a5$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9b6e3b5559a9e9a5$var$eh(l) : (l = $9b6e3b5559a9e9a5$var$Zf(c) ? $9b6e3b5559a9e9a5$var$Xf : $9b6e3b5559a9e9a5$var$H.current, l = $9b6e3b5559a9e9a5$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9b6e3b5559a9e9a5$var$Hi(b, g, d, l);
        $9b6e3b5559a9e9a5$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $9b6e3b5559a9e9a5$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9b6e3b5559a9e9a5$var$Wf.current || $9b6e3b5559a9e9a5$var$jh ? ("function" === typeof m && ($9b6e3b5559a9e9a5$var$Di(b, c, m, d), k = b.memoizedState), (h = $9b6e3b5559a9e9a5$var$jh || $9b6e3b5559a9e9a5$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9b6e3b5559a9e9a5$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9b6e3b5559a9e9a5$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9b6e3b5559a9e9a5$var$eh(k) : (k = $9b6e3b5559a9e9a5$var$Zf(c) ? $9b6e3b5559a9e9a5$var$Xf : $9b6e3b5559a9e9a5$var$H.current, k = $9b6e3b5559a9e9a5$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9b6e3b5559a9e9a5$var$Hi(b, g, d, k);
        $9b6e3b5559a9e9a5$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $9b6e3b5559a9e9a5$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9b6e3b5559a9e9a5$var$Wf.current || $9b6e3b5559a9e9a5$var$jh ? ("function" === typeof y && ($9b6e3b5559a9e9a5$var$Di(b, c, y, d), n = b.memoizedState), (l = $9b6e3b5559a9e9a5$var$jh || $9b6e3b5559a9e9a5$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9b6e3b5559a9e9a5$var$jj(a, b, c, d, f, e);
}
function $9b6e3b5559a9e9a5$var$jj(a, b, c, d, e, f) {
    $9b6e3b5559a9e9a5$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9b6e3b5559a9e9a5$var$dg(b, c, !1), $9b6e3b5559a9e9a5$var$Zi(a, b, f);
    d = b.stateNode;
    $9b6e3b5559a9e9a5$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9b6e3b5559a9e9a5$var$Ug(b, a.child, null, f), b.child = $9b6e3b5559a9e9a5$var$Ug(b, null, h, f)) : $9b6e3b5559a9e9a5$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9b6e3b5559a9e9a5$var$dg(b, c, !0);
    return b.child;
}
function $9b6e3b5559a9e9a5$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9b6e3b5559a9e9a5$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9b6e3b5559a9e9a5$var$ag(a, b.context, !1);
    $9b6e3b5559a9e9a5$var$yh(a, b.containerInfo);
}
function $9b6e3b5559a9e9a5$var$lj(a, b, c, d, e) {
    $9b6e3b5559a9e9a5$var$Ig();
    $9b6e3b5559a9e9a5$var$Jg(e);
    b.flags |= 256;
    $9b6e3b5559a9e9a5$var$Xi(a, b, c, d);
    return b.child;
}
var $9b6e3b5559a9e9a5$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9b6e3b5559a9e9a5$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9b6e3b5559a9e9a5$var$oj(a, b, c) {
    var d = b.pendingProps, e = $9b6e3b5559a9e9a5$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, e & 1);
    if (null === a) {
        $9b6e3b5559a9e9a5$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9b6e3b5559a9e9a5$var$pj(g, d, 0, null), a = $9b6e3b5559a9e9a5$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9b6e3b5559a9e9a5$var$nj(c), b.memoizedState = $9b6e3b5559a9e9a5$var$mj, a) : $9b6e3b5559a9e9a5$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9b6e3b5559a9e9a5$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9b6e3b5559a9e9a5$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9b6e3b5559a9e9a5$var$Pg(h, f) : (f = $9b6e3b5559a9e9a5$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9b6e3b5559a9e9a5$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9b6e3b5559a9e9a5$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9b6e3b5559a9e9a5$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9b6e3b5559a9e9a5$var$qj(a, b) {
    b = $9b6e3b5559a9e9a5$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9b6e3b5559a9e9a5$var$sj(a, b, c, d) {
    null !== d && $9b6e3b5559a9e9a5$var$Jg(d);
    $9b6e3b5559a9e9a5$var$Ug(b, a.child, null, c);
    a = $9b6e3b5559a9e9a5$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9b6e3b5559a9e9a5$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9b6e3b5559a9e9a5$var$Ki(Error($9b6e3b5559a9e9a5$var$p(422))), $9b6e3b5559a9e9a5$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9b6e3b5559a9e9a5$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9b6e3b5559a9e9a5$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9b6e3b5559a9e9a5$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $9b6e3b5559a9e9a5$var$nj(g);
        b.memoizedState = $9b6e3b5559a9e9a5$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9b6e3b5559a9e9a5$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9b6e3b5559a9e9a5$var$p(419));
        d = $9b6e3b5559a9e9a5$var$Ki(f, d, void 0);
        return $9b6e3b5559a9e9a5$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9b6e3b5559a9e9a5$var$dh || h) {
        d = $9b6e3b5559a9e9a5$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9b6e3b5559a9e9a5$var$ih(a, e), $9b6e3b5559a9e9a5$var$gi(d, a, e, -1));
        }
        $9b6e3b5559a9e9a5$var$tj();
        d = $9b6e3b5559a9e9a5$var$Ki(Error($9b6e3b5559a9e9a5$var$p(421)));
        return $9b6e3b5559a9e9a5$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9b6e3b5559a9e9a5$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9b6e3b5559a9e9a5$var$yg = $9b6e3b5559a9e9a5$var$Lf(e.nextSibling);
    $9b6e3b5559a9e9a5$var$xg = b;
    $9b6e3b5559a9e9a5$var$I = !0;
    $9b6e3b5559a9e9a5$var$zg = null;
    null !== a && ($9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg++] = $9b6e3b5559a9e9a5$var$rg, $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg++] = $9b6e3b5559a9e9a5$var$sg, $9b6e3b5559a9e9a5$var$og[$9b6e3b5559a9e9a5$var$pg++] = $9b6e3b5559a9e9a5$var$qg, $9b6e3b5559a9e9a5$var$rg = a.id, $9b6e3b5559a9e9a5$var$sg = a.overflow, $9b6e3b5559a9e9a5$var$qg = b);
    b = $9b6e3b5559a9e9a5$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9b6e3b5559a9e9a5$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9b6e3b5559a9e9a5$var$bh(a.return, b, c);
}
function $9b6e3b5559a9e9a5$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9b6e3b5559a9e9a5$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9b6e3b5559a9e9a5$var$Xi(a, b, d.children, c);
    d = $9b6e3b5559a9e9a5$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9b6e3b5559a9e9a5$var$vj(a, c, b);
            else if (19 === a.tag) $9b6e3b5559a9e9a5$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9b6e3b5559a9e9a5$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9b6e3b5559a9e9a5$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9b6e3b5559a9e9a5$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9b6e3b5559a9e9a5$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $9b6e3b5559a9e9a5$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9b6e3b5559a9e9a5$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9b6e3b5559a9e9a5$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9b6e3b5559a9e9a5$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9b6e3b5559a9e9a5$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9b6e3b5559a9e9a5$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9b6e3b5559a9e9a5$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9b6e3b5559a9e9a5$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $9b6e3b5559a9e9a5$var$kj(b);
            $9b6e3b5559a9e9a5$var$Ig();
            break;
        case 5:
            $9b6e3b5559a9e9a5$var$Ah(b);
            break;
        case 1:
            $9b6e3b5559a9e9a5$var$Zf(b.type) && $9b6e3b5559a9e9a5$var$cg(b);
            break;
        case 4:
            $9b6e3b5559a9e9a5$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, $9b6e3b5559a9e9a5$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9b6e3b5559a9e9a5$var$oj(a, b, c);
                $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, $9b6e3b5559a9e9a5$var$L.current & 1);
                a = $9b6e3b5559a9e9a5$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, $9b6e3b5559a9e9a5$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9b6e3b5559a9e9a5$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, $9b6e3b5559a9e9a5$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9b6e3b5559a9e9a5$var$dj(a, b, c);
    }
    return $9b6e3b5559a9e9a5$var$Zi(a, b, c);
}
var $9b6e3b5559a9e9a5$var$zj, $9b6e3b5559a9e9a5$var$Aj, $9b6e3b5559a9e9a5$var$Bj, $9b6e3b5559a9e9a5$var$Cj;
$9b6e3b5559a9e9a5$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9b6e3b5559a9e9a5$var$Aj = function() {};
$9b6e3b5559a9e9a5$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9b6e3b5559a9e9a5$var$Ya(a, e);
                d = $9b6e3b5559a9e9a5$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9b6e3b5559a9e9a5$var$A({}, e, {
                    value: void 0
                });
                d = $9b6e3b5559a9e9a5$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9b6e3b5559a9e9a5$var$gb(a, e);
                d = $9b6e3b5559a9e9a5$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9b6e3b5559a9e9a5$var$Bf);
        }
        $9b6e3b5559a9e9a5$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9b6e3b5559a9e9a5$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9b6e3b5559a9e9a5$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9b6e3b5559a9e9a5$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9b6e3b5559a9e9a5$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9b6e3b5559a9e9a5$var$Dj(a, b) {
    if (!$9b6e3b5559a9e9a5$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9b6e3b5559a9e9a5$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9b6e3b5559a9e9a5$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $9b6e3b5559a9e9a5$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9b6e3b5559a9e9a5$var$S(b), null;
        case 1:
            return $9b6e3b5559a9e9a5$var$Zf(b.type) && $9b6e3b5559a9e9a5$var$$f(), $9b6e3b5559a9e9a5$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9b6e3b5559a9e9a5$var$zh();
            $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wf);
            $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$H);
            $9b6e3b5559a9e9a5$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9b6e3b5559a9e9a5$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9b6e3b5559a9e9a5$var$zg && ($9b6e3b5559a9e9a5$var$Fj($9b6e3b5559a9e9a5$var$zg), $9b6e3b5559a9e9a5$var$zg = null));
            $9b6e3b5559a9e9a5$var$Aj(a, b);
            $9b6e3b5559a9e9a5$var$S(b);
            return null;
        case 5:
            $9b6e3b5559a9e9a5$var$Bh(b);
            var e = $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9b6e3b5559a9e9a5$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9b6e3b5559a9e9a5$var$p(166));
                    $9b6e3b5559a9e9a5$var$S(b);
                    return null;
                }
                a = $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$uh.current);
                if ($9b6e3b5559a9e9a5$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9b6e3b5559a9e9a5$var$Of] = b;
                    d[$9b6e3b5559a9e9a5$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9b6e3b5559a9e9a5$var$D("cancel", d);
                            $9b6e3b5559a9e9a5$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9b6e3b5559a9e9a5$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9b6e3b5559a9e9a5$var$lf.length; e++)$9b6e3b5559a9e9a5$var$D($9b6e3b5559a9e9a5$var$lf[e], d);
                            break;
                        case "source":
                            $9b6e3b5559a9e9a5$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9b6e3b5559a9e9a5$var$D("error", d);
                            $9b6e3b5559a9e9a5$var$D("load", d);
                            break;
                        case "details":
                            $9b6e3b5559a9e9a5$var$D("toggle", d);
                            break;
                        case "input":
                            $9b6e3b5559a9e9a5$var$Za(d, f);
                            $9b6e3b5559a9e9a5$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9b6e3b5559a9e9a5$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9b6e3b5559a9e9a5$var$hb(d, f), $9b6e3b5559a9e9a5$var$D("invalid", d);
                    }
                    $9b6e3b5559a9e9a5$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9b6e3b5559a9e9a5$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9b6e3b5559a9e9a5$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9b6e3b5559a9e9a5$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9b6e3b5559a9e9a5$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9b6e3b5559a9e9a5$var$Va(d);
                            $9b6e3b5559a9e9a5$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9b6e3b5559a9e9a5$var$Va(d);
                            $9b6e3b5559a9e9a5$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9b6e3b5559a9e9a5$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9b6e3b5559a9e9a5$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9b6e3b5559a9e9a5$var$Of] = b;
                    a[$9b6e3b5559a9e9a5$var$Pf] = d;
                    $9b6e3b5559a9e9a5$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9b6e3b5559a9e9a5$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9b6e3b5559a9e9a5$var$D("cancel", a);
                                $9b6e3b5559a9e9a5$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9b6e3b5559a9e9a5$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9b6e3b5559a9e9a5$var$lf.length; e++)$9b6e3b5559a9e9a5$var$D($9b6e3b5559a9e9a5$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9b6e3b5559a9e9a5$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9b6e3b5559a9e9a5$var$D("error", a);
                                $9b6e3b5559a9e9a5$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9b6e3b5559a9e9a5$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9b6e3b5559a9e9a5$var$Za(a, d);
                                e = $9b6e3b5559a9e9a5$var$Ya(a, d);
                                $9b6e3b5559a9e9a5$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9b6e3b5559a9e9a5$var$A({}, d, {
                                    value: void 0
                                });
                                $9b6e3b5559a9e9a5$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9b6e3b5559a9e9a5$var$hb(a, d);
                                e = $9b6e3b5559a9e9a5$var$gb(a, d);
                                $9b6e3b5559a9e9a5$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9b6e3b5559a9e9a5$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9b6e3b5559a9e9a5$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9b6e3b5559a9e9a5$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9b6e3b5559a9e9a5$var$ob(a, k) : "number" === typeof k && $9b6e3b5559a9e9a5$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9b6e3b5559a9e9a5$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9b6e3b5559a9e9a5$var$D("scroll", a) : null != k && $9b6e3b5559a9e9a5$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9b6e3b5559a9e9a5$var$Va(a);
                                $9b6e3b5559a9e9a5$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9b6e3b5559a9e9a5$var$Va(a);
                                $9b6e3b5559a9e9a5$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9b6e3b5559a9e9a5$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9b6e3b5559a9e9a5$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9b6e3b5559a9e9a5$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9b6e3b5559a9e9a5$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9b6e3b5559a9e9a5$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9b6e3b5559a9e9a5$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9b6e3b5559a9e9a5$var$p(166));
                c = $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$wh.current);
                $9b6e3b5559a9e9a5$var$xh($9b6e3b5559a9e9a5$var$uh.current);
                if ($9b6e3b5559a9e9a5$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9b6e3b5559a9e9a5$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9b6e3b5559a9e9a5$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9b6e3b5559a9e9a5$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9b6e3b5559a9e9a5$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9b6e3b5559a9e9a5$var$Of] = b, b.stateNode = d;
            }
            $9b6e3b5559a9e9a5$var$S(b);
            return null;
        case 13:
            $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9b6e3b5559a9e9a5$var$I && null !== $9b6e3b5559a9e9a5$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9b6e3b5559a9e9a5$var$Hg(), $9b6e3b5559a9e9a5$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9b6e3b5559a9e9a5$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9b6e3b5559a9e9a5$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9b6e3b5559a9e9a5$var$p(317));
                        f[$9b6e3b5559a9e9a5$var$Of] = b;
                    } else $9b6e3b5559a9e9a5$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9b6e3b5559a9e9a5$var$S(b);
                    f = !1;
                } else null !== $9b6e3b5559a9e9a5$var$zg && ($9b6e3b5559a9e9a5$var$Fj($9b6e3b5559a9e9a5$var$zg), $9b6e3b5559a9e9a5$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9b6e3b5559a9e9a5$var$L.current & 1) ? 0 === $9b6e3b5559a9e9a5$var$T && ($9b6e3b5559a9e9a5$var$T = 3) : $9b6e3b5559a9e9a5$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9b6e3b5559a9e9a5$var$S(b);
            return null;
        case 4:
            return $9b6e3b5559a9e9a5$var$zh(), $9b6e3b5559a9e9a5$var$Aj(a, b), null === a && $9b6e3b5559a9e9a5$var$sf(b.stateNode.containerInfo), $9b6e3b5559a9e9a5$var$S(b), null;
        case 10:
            return $9b6e3b5559a9e9a5$var$ah(b.type._context), $9b6e3b5559a9e9a5$var$S(b), null;
        case 17:
            return $9b6e3b5559a9e9a5$var$Zf(b.type) && $9b6e3b5559a9e9a5$var$$f(), $9b6e3b5559a9e9a5$var$S(b), null;
        case 19:
            $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$L);
            f = b.memoizedState;
            if (null === f) return $9b6e3b5559a9e9a5$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9b6e3b5559a9e9a5$var$Dj(f, !1);
                else {
                    if (0 !== $9b6e3b5559a9e9a5$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9b6e3b5559a9e9a5$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9b6e3b5559a9e9a5$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, $9b6e3b5559a9e9a5$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9b6e3b5559a9e9a5$var$B() > $9b6e3b5559a9e9a5$var$Gj && (b.flags |= 128, d = !0, $9b6e3b5559a9e9a5$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9b6e3b5559a9e9a5$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9b6e3b5559a9e9a5$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9b6e3b5559a9e9a5$var$I) return $9b6e3b5559a9e9a5$var$S(b), null;
                    } else 2 * $9b6e3b5559a9e9a5$var$B() - f.renderingStartTime > $9b6e3b5559a9e9a5$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $9b6e3b5559a9e9a5$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9b6e3b5559a9e9a5$var$B(), b.sibling = null, c = $9b6e3b5559a9e9a5$var$L.current, $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$L, d ? c & 1 | 2 : c & 1), b;
            $9b6e3b5559a9e9a5$var$S(b);
            return null;
        case 22:
        case 23:
            return $9b6e3b5559a9e9a5$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9b6e3b5559a9e9a5$var$fj & 1073741824) && ($9b6e3b5559a9e9a5$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9b6e3b5559a9e9a5$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9b6e3b5559a9e9a5$var$p(156, b.tag));
}
function $9b6e3b5559a9e9a5$var$Ij(a, b) {
    $9b6e3b5559a9e9a5$var$wg(b);
    switch(b.tag){
        case 1:
            return $9b6e3b5559a9e9a5$var$Zf(b.type) && $9b6e3b5559a9e9a5$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9b6e3b5559a9e9a5$var$zh(), $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wf), $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$H), $9b6e3b5559a9e9a5$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9b6e3b5559a9e9a5$var$Bh(b), null;
        case 13:
            $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9b6e3b5559a9e9a5$var$p(340));
                $9b6e3b5559a9e9a5$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$L), null;
        case 4:
            return $9b6e3b5559a9e9a5$var$zh(), null;
        case 10:
            return $9b6e3b5559a9e9a5$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $9b6e3b5559a9e9a5$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9b6e3b5559a9e9a5$var$Jj = !1, $9b6e3b5559a9e9a5$var$U = !1, $9b6e3b5559a9e9a5$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $9b6e3b5559a9e9a5$var$V = null;
function $9b6e3b5559a9e9a5$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9b6e3b5559a9e9a5$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9b6e3b5559a9e9a5$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9b6e3b5559a9e9a5$var$W(a, b, d);
    }
}
var $9b6e3b5559a9e9a5$var$Nj = !1;
function $9b6e3b5559a9e9a5$var$Oj(a, b) {
    $9b6e3b5559a9e9a5$var$Cf = $9b6e3b5559a9e9a5$var$dd;
    a = $9b6e3b5559a9e9a5$var$Me();
    if ($9b6e3b5559a9e9a5$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9b6e3b5559a9e9a5$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9b6e3b5559a9e9a5$var$dd = !1;
    for($9b6e3b5559a9e9a5$var$V = b; null !== $9b6e3b5559a9e9a5$var$V;)if (b = $9b6e3b5559a9e9a5$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9b6e3b5559a9e9a5$var$V = a;
    else for(; null !== $9b6e3b5559a9e9a5$var$V;){
        b = $9b6e3b5559a9e9a5$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9b6e3b5559a9e9a5$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9b6e3b5559a9e9a5$var$p(163));
            }
        } catch (F) {
            $9b6e3b5559a9e9a5$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9b6e3b5559a9e9a5$var$V = a;
            break;
        }
        $9b6e3b5559a9e9a5$var$V = b.return;
    }
    n = $9b6e3b5559a9e9a5$var$Nj;
    $9b6e3b5559a9e9a5$var$Nj = !1;
    return n;
}
function $9b6e3b5559a9e9a5$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9b6e3b5559a9e9a5$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9b6e3b5559a9e9a5$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9b6e3b5559a9e9a5$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9b6e3b5559a9e9a5$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9b6e3b5559a9e9a5$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9b6e3b5559a9e9a5$var$Of], delete b[$9b6e3b5559a9e9a5$var$Pf], delete b[$9b6e3b5559a9e9a5$var$of], delete b[$9b6e3b5559a9e9a5$var$Qf], delete b[$9b6e3b5559a9e9a5$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9b6e3b5559a9e9a5$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9b6e3b5559a9e9a5$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9b6e3b5559a9e9a5$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9b6e3b5559a9e9a5$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9b6e3b5559a9e9a5$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9b6e3b5559a9e9a5$var$Vj(a, b, c), a = a.sibling; null !== a;)$9b6e3b5559a9e9a5$var$Vj(a, b, c), a = a.sibling;
}
function $9b6e3b5559a9e9a5$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9b6e3b5559a9e9a5$var$Wj(a, b, c), a = a.sibling; null !== a;)$9b6e3b5559a9e9a5$var$Wj(a, b, c), a = a.sibling;
}
var $9b6e3b5559a9e9a5$var$X = null, $9b6e3b5559a9e9a5$var$Xj = !1;
function $9b6e3b5559a9e9a5$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$9b6e3b5559a9e9a5$var$Zj(a, b, c), c = c.sibling;
}
function $9b6e3b5559a9e9a5$var$Zj(a, b, c) {
    if ($9b6e3b5559a9e9a5$var$lc && "function" === typeof $9b6e3b5559a9e9a5$var$lc.onCommitFiberUnmount) try {
        $9b6e3b5559a9e9a5$var$lc.onCommitFiberUnmount($9b6e3b5559a9e9a5$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9b6e3b5559a9e9a5$var$U || $9b6e3b5559a9e9a5$var$Lj(c, b);
        case 6:
            var d = $9b6e3b5559a9e9a5$var$X, e = $9b6e3b5559a9e9a5$var$Xj;
            $9b6e3b5559a9e9a5$var$X = null;
            $9b6e3b5559a9e9a5$var$Yj(a, b, c);
            $9b6e3b5559a9e9a5$var$X = d;
            $9b6e3b5559a9e9a5$var$Xj = e;
            null !== $9b6e3b5559a9e9a5$var$X && ($9b6e3b5559a9e9a5$var$Xj ? (a = $9b6e3b5559a9e9a5$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9b6e3b5559a9e9a5$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9b6e3b5559a9e9a5$var$X && ($9b6e3b5559a9e9a5$var$Xj ? (a = $9b6e3b5559a9e9a5$var$X, c = c.stateNode, 8 === a.nodeType ? $9b6e3b5559a9e9a5$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9b6e3b5559a9e9a5$var$Kf(a, c), $9b6e3b5559a9e9a5$var$bd(a)) : $9b6e3b5559a9e9a5$var$Kf($9b6e3b5559a9e9a5$var$X, c.stateNode));
            break;
        case 4:
            d = $9b6e3b5559a9e9a5$var$X;
            e = $9b6e3b5559a9e9a5$var$Xj;
            $9b6e3b5559a9e9a5$var$X = c.stateNode.containerInfo;
            $9b6e3b5559a9e9a5$var$Xj = !0;
            $9b6e3b5559a9e9a5$var$Yj(a, b, c);
            $9b6e3b5559a9e9a5$var$X = d;
            $9b6e3b5559a9e9a5$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9b6e3b5559a9e9a5$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9b6e3b5559a9e9a5$var$Mj(c, b, g) : 0 !== (f & 4) && $9b6e3b5559a9e9a5$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9b6e3b5559a9e9a5$var$Yj(a, b, c);
            break;
        case 1:
            if (!$9b6e3b5559a9e9a5$var$U && ($9b6e3b5559a9e9a5$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9b6e3b5559a9e9a5$var$W(c, b, h);
            }
            $9b6e3b5559a9e9a5$var$Yj(a, b, c);
            break;
        case 21:
            $9b6e3b5559a9e9a5$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9b6e3b5559a9e9a5$var$U = (d = $9b6e3b5559a9e9a5$var$U) || null !== c.memoizedState, $9b6e3b5559a9e9a5$var$Yj(a, b, c), $9b6e3b5559a9e9a5$var$U = d) : $9b6e3b5559a9e9a5$var$Yj(a, b, c);
            break;
        default:
            $9b6e3b5559a9e9a5$var$Yj(a, b, c);
    }
}
function $9b6e3b5559a9e9a5$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9b6e3b5559a9e9a5$var$Kj);
        b.forEach(function(b) {
            var d = $9b6e3b5559a9e9a5$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9b6e3b5559a9e9a5$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9b6e3b5559a9e9a5$var$X = h.stateNode;
                        $9b6e3b5559a9e9a5$var$Xj = !1;
                        break a;
                    case 3:
                        $9b6e3b5559a9e9a5$var$X = h.stateNode.containerInfo;
                        $9b6e3b5559a9e9a5$var$Xj = !0;
                        break a;
                    case 4:
                        $9b6e3b5559a9e9a5$var$X = h.stateNode.containerInfo;
                        $9b6e3b5559a9e9a5$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9b6e3b5559a9e9a5$var$X) throw Error($9b6e3b5559a9e9a5$var$p(160));
            $9b6e3b5559a9e9a5$var$Zj(f, g, e);
            $9b6e3b5559a9e9a5$var$X = null;
            $9b6e3b5559a9e9a5$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9b6e3b5559a9e9a5$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9b6e3b5559a9e9a5$var$dk(b, a), b = b.sibling;
}
function $9b6e3b5559a9e9a5$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            if (d & 4) {
                try {
                    $9b6e3b5559a9e9a5$var$Pj(3, a, a.return), $9b6e3b5559a9e9a5$var$Qj(3, a);
                } catch (t) {
                    $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                }
                try {
                    $9b6e3b5559a9e9a5$var$Pj(5, a, a.return);
                } catch (t) {
                    $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            d & 512 && null !== c && $9b6e3b5559a9e9a5$var$Lj(c, c.return);
            break;
        case 5:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            d & 512 && null !== c && $9b6e3b5559a9e9a5$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9b6e3b5559a9e9a5$var$ob(e, "");
                } catch (t) {
                    $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9b6e3b5559a9e9a5$var$ab(e, f);
                    $9b6e3b5559a9e9a5$var$vb(h, g);
                    var l = $9b6e3b5559a9e9a5$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9b6e3b5559a9e9a5$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9b6e3b5559a9e9a5$var$nb(e, q) : "children" === m ? $9b6e3b5559a9e9a5$var$ob(e, q) : $9b6e3b5559a9e9a5$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9b6e3b5559a9e9a5$var$bb(e, f);
                            break;
                        case "textarea":
                            $9b6e3b5559a9e9a5$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9b6e3b5559a9e9a5$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9b6e3b5559a9e9a5$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9b6e3b5559a9e9a5$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9b6e3b5559a9e9a5$var$Pf] = f;
                } catch (t) {
                    $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9b6e3b5559a9e9a5$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9b6e3b5559a9e9a5$var$bd(b.containerInfo);
            } catch (t) {
                $9b6e3b5559a9e9a5$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            break;
        case 13:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9b6e3b5559a9e9a5$var$fk = $9b6e3b5559a9e9a5$var$B()));
            d & 4 && $9b6e3b5559a9e9a5$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9b6e3b5559a9e9a5$var$U = (l = $9b6e3b5559a9e9a5$var$U) || m, $9b6e3b5559a9e9a5$var$ck(b, a), $9b6e3b5559a9e9a5$var$U = l) : $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9b6e3b5559a9e9a5$var$V = a, m = a.child; null !== m;){
                    for(q = $9b6e3b5559a9e9a5$var$V = m; null !== $9b6e3b5559a9e9a5$var$V;){
                        r = $9b6e3b5559a9e9a5$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9b6e3b5559a9e9a5$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $9b6e3b5559a9e9a5$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9b6e3b5559a9e9a5$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9b6e3b5559a9e9a5$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9b6e3b5559a9e9a5$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9b6e3b5559a9e9a5$var$V = y) : $9b6e3b5559a9e9a5$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9b6e3b5559a9e9a5$var$rb("display", g));
                            } catch (t) {
                                $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9b6e3b5559a9e9a5$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9b6e3b5559a9e9a5$var$ck(b, a);
            $9b6e3b5559a9e9a5$var$ek(a);
            d & 4 && $9b6e3b5559a9e9a5$var$ak(a);
            break;
        case 21:
            break;
        default:
            $9b6e3b5559a9e9a5$var$ck(b, a), $9b6e3b5559a9e9a5$var$ek(a);
    }
}
function $9b6e3b5559a9e9a5$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9b6e3b5559a9e9a5$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9b6e3b5559a9e9a5$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9b6e3b5559a9e9a5$var$ob(e, ""), d.flags &= -33);
                    var f = $9b6e3b5559a9e9a5$var$Uj(a);
                    $9b6e3b5559a9e9a5$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9b6e3b5559a9e9a5$var$Uj(a);
                    $9b6e3b5559a9e9a5$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($9b6e3b5559a9e9a5$var$p(161));
            }
        } catch (k) {
            $9b6e3b5559a9e9a5$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9b6e3b5559a9e9a5$var$hk(a, b, c) {
    $9b6e3b5559a9e9a5$var$V = a;
    $9b6e3b5559a9e9a5$var$ik(a, b, c);
}
function $9b6e3b5559a9e9a5$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9b6e3b5559a9e9a5$var$V;){
        var e = $9b6e3b5559a9e9a5$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9b6e3b5559a9e9a5$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9b6e3b5559a9e9a5$var$U;
                h = $9b6e3b5559a9e9a5$var$Jj;
                var l = $9b6e3b5559a9e9a5$var$U;
                $9b6e3b5559a9e9a5$var$Jj = g;
                if (($9b6e3b5559a9e9a5$var$U = k) && !l) for($9b6e3b5559a9e9a5$var$V = e; null !== $9b6e3b5559a9e9a5$var$V;)g = $9b6e3b5559a9e9a5$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9b6e3b5559a9e9a5$var$jk(e) : null !== k ? (k.return = g, $9b6e3b5559a9e9a5$var$V = k) : $9b6e3b5559a9e9a5$var$jk(e);
                for(; null !== f;)$9b6e3b5559a9e9a5$var$V = f, $9b6e3b5559a9e9a5$var$ik(f, b, c), f = f.sibling;
                $9b6e3b5559a9e9a5$var$V = e;
                $9b6e3b5559a9e9a5$var$Jj = h;
                $9b6e3b5559a9e9a5$var$U = l;
            }
            $9b6e3b5559a9e9a5$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9b6e3b5559a9e9a5$var$V = f) : $9b6e3b5559a9e9a5$var$kk(a, b, c);
    }
}
function $9b6e3b5559a9e9a5$var$kk(a) {
    for(; null !== $9b6e3b5559a9e9a5$var$V;){
        var b = $9b6e3b5559a9e9a5$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9b6e3b5559a9e9a5$var$U || $9b6e3b5559a9e9a5$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9b6e3b5559a9e9a5$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9b6e3b5559a9e9a5$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9b6e3b5559a9e9a5$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9b6e3b5559a9e9a5$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9b6e3b5559a9e9a5$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9b6e3b5559a9e9a5$var$p(163));
                }
                $9b6e3b5559a9e9a5$var$U || b.flags & 512 && $9b6e3b5559a9e9a5$var$Rj(b);
            } catch (r) {
                $9b6e3b5559a9e9a5$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9b6e3b5559a9e9a5$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b6e3b5559a9e9a5$var$V = c;
            break;
        }
        $9b6e3b5559a9e9a5$var$V = b.return;
    }
}
function $9b6e3b5559a9e9a5$var$gk(a) {
    for(; null !== $9b6e3b5559a9e9a5$var$V;){
        var b = $9b6e3b5559a9e9a5$var$V;
        if (b === a) {
            $9b6e3b5559a9e9a5$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b6e3b5559a9e9a5$var$V = c;
            break;
        }
        $9b6e3b5559a9e9a5$var$V = b.return;
    }
}
function $9b6e3b5559a9e9a5$var$jk(a) {
    for(; null !== $9b6e3b5559a9e9a5$var$V;){
        var b = $9b6e3b5559a9e9a5$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9b6e3b5559a9e9a5$var$Qj(4, b);
                    } catch (k) {
                        $9b6e3b5559a9e9a5$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9b6e3b5559a9e9a5$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9b6e3b5559a9e9a5$var$Rj(b);
                    } catch (k) {
                        $9b6e3b5559a9e9a5$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9b6e3b5559a9e9a5$var$Rj(b);
                    } catch (k) {
                        $9b6e3b5559a9e9a5$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9b6e3b5559a9e9a5$var$W(b, b.return, k);
        }
        if (b === a) {
            $9b6e3b5559a9e9a5$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9b6e3b5559a9e9a5$var$V = h;
            break;
        }
        $9b6e3b5559a9e9a5$var$V = b.return;
    }
}
var $9b6e3b5559a9e9a5$var$lk = Math.ceil, $9b6e3b5559a9e9a5$var$mk = $9b6e3b5559a9e9a5$var$ua.ReactCurrentDispatcher, $9b6e3b5559a9e9a5$var$nk = $9b6e3b5559a9e9a5$var$ua.ReactCurrentOwner, $9b6e3b5559a9e9a5$var$ok = $9b6e3b5559a9e9a5$var$ua.ReactCurrentBatchConfig, $9b6e3b5559a9e9a5$var$K = 0, $9b6e3b5559a9e9a5$var$Q = null, $9b6e3b5559a9e9a5$var$Y = null, $9b6e3b5559a9e9a5$var$Z = 0, $9b6e3b5559a9e9a5$var$fj = 0, $9b6e3b5559a9e9a5$var$ej = $9b6e3b5559a9e9a5$var$Uf(0), $9b6e3b5559a9e9a5$var$T = 0, $9b6e3b5559a9e9a5$var$pk = null, $9b6e3b5559a9e9a5$var$rh = 0, $9b6e3b5559a9e9a5$var$qk = 0, $9b6e3b5559a9e9a5$var$rk = 0, $9b6e3b5559a9e9a5$var$sk = null, $9b6e3b5559a9e9a5$var$tk = null, $9b6e3b5559a9e9a5$var$fk = 0, $9b6e3b5559a9e9a5$var$Gj = Infinity, $9b6e3b5559a9e9a5$var$uk = null, $9b6e3b5559a9e9a5$var$Oi = !1, $9b6e3b5559a9e9a5$var$Pi = null, $9b6e3b5559a9e9a5$var$Ri = null, $9b6e3b5559a9e9a5$var$vk = !1, $9b6e3b5559a9e9a5$var$wk = null, $9b6e3b5559a9e9a5$var$xk = 0, $9b6e3b5559a9e9a5$var$yk = 0, $9b6e3b5559a9e9a5$var$zk = null, $9b6e3b5559a9e9a5$var$Ak = -1, $9b6e3b5559a9e9a5$var$Bk = 0;
function $9b6e3b5559a9e9a5$var$R() {
    return 0 !== ($9b6e3b5559a9e9a5$var$K & 6) ? $9b6e3b5559a9e9a5$var$B() : -1 !== $9b6e3b5559a9e9a5$var$Ak ? $9b6e3b5559a9e9a5$var$Ak : $9b6e3b5559a9e9a5$var$Ak = $9b6e3b5559a9e9a5$var$B();
}
function $9b6e3b5559a9e9a5$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9b6e3b5559a9e9a5$var$K & 2) && 0 !== $9b6e3b5559a9e9a5$var$Z) return $9b6e3b5559a9e9a5$var$Z & -$9b6e3b5559a9e9a5$var$Z;
    if (null !== $9b6e3b5559a9e9a5$var$Kg.transition) return 0 === $9b6e3b5559a9e9a5$var$Bk && ($9b6e3b5559a9e9a5$var$Bk = $9b6e3b5559a9e9a5$var$yc()), $9b6e3b5559a9e9a5$var$Bk;
    a = $9b6e3b5559a9e9a5$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9b6e3b5559a9e9a5$var$jd(a.type);
    return a;
}
function $9b6e3b5559a9e9a5$var$gi(a, b, c, d) {
    if (50 < $9b6e3b5559a9e9a5$var$yk) throw $9b6e3b5559a9e9a5$var$yk = 0, $9b6e3b5559a9e9a5$var$zk = null, Error($9b6e3b5559a9e9a5$var$p(185));
    $9b6e3b5559a9e9a5$var$Ac(a, c, d);
    if (0 === ($9b6e3b5559a9e9a5$var$K & 2) || a !== $9b6e3b5559a9e9a5$var$Q) a === $9b6e3b5559a9e9a5$var$Q && (0 === ($9b6e3b5559a9e9a5$var$K & 2) && ($9b6e3b5559a9e9a5$var$qk |= c), 4 === $9b6e3b5559a9e9a5$var$T && $9b6e3b5559a9e9a5$var$Ck(a, $9b6e3b5559a9e9a5$var$Z)), $9b6e3b5559a9e9a5$var$Dk(a, d), 1 === c && 0 === $9b6e3b5559a9e9a5$var$K && 0 === (b.mode & 1) && ($9b6e3b5559a9e9a5$var$Gj = $9b6e3b5559a9e9a5$var$B() + 500, $9b6e3b5559a9e9a5$var$fg && $9b6e3b5559a9e9a5$var$jg());
}
function $9b6e3b5559a9e9a5$var$Dk(a, b) {
    var c = a.callbackNode;
    $9b6e3b5559a9e9a5$var$wc(a, b);
    var d = $9b6e3b5559a9e9a5$var$uc(a, a === $9b6e3b5559a9e9a5$var$Q ? $9b6e3b5559a9e9a5$var$Z : 0);
    if (0 === d) null !== c && $9b6e3b5559a9e9a5$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9b6e3b5559a9e9a5$var$bc(c);
        if (1 === b) 0 === a.tag ? $9b6e3b5559a9e9a5$var$ig($9b6e3b5559a9e9a5$var$Ek.bind(null, a)) : $9b6e3b5559a9e9a5$var$hg($9b6e3b5559a9e9a5$var$Ek.bind(null, a)), $9b6e3b5559a9e9a5$var$Jf(function() {
            0 === ($9b6e3b5559a9e9a5$var$K & 6) && $9b6e3b5559a9e9a5$var$jg();
        }), c = null;
        else {
            switch($9b6e3b5559a9e9a5$var$Dc(d)){
                case 1:
                    c = $9b6e3b5559a9e9a5$var$fc;
                    break;
                case 4:
                    c = $9b6e3b5559a9e9a5$var$gc;
                    break;
                case 16:
                    c = $9b6e3b5559a9e9a5$var$hc;
                    break;
                case 536870912:
                    c = $9b6e3b5559a9e9a5$var$jc;
                    break;
                default:
                    c = $9b6e3b5559a9e9a5$var$hc;
            }
            c = $9b6e3b5559a9e9a5$var$Fk(c, $9b6e3b5559a9e9a5$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9b6e3b5559a9e9a5$var$Gk(a, b) {
    $9b6e3b5559a9e9a5$var$Ak = -1;
    $9b6e3b5559a9e9a5$var$Bk = 0;
    if (0 !== ($9b6e3b5559a9e9a5$var$K & 6)) throw Error($9b6e3b5559a9e9a5$var$p(327));
    var c = a.callbackNode;
    if ($9b6e3b5559a9e9a5$var$Hk() && a.callbackNode !== c) return null;
    var d = $9b6e3b5559a9e9a5$var$uc(a, a === $9b6e3b5559a9e9a5$var$Q ? $9b6e3b5559a9e9a5$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9b6e3b5559a9e9a5$var$Ik(a, d);
    else {
        b = d;
        var e = $9b6e3b5559a9e9a5$var$K;
        $9b6e3b5559a9e9a5$var$K |= 2;
        var f = $9b6e3b5559a9e9a5$var$Jk();
        if ($9b6e3b5559a9e9a5$var$Q !== a || $9b6e3b5559a9e9a5$var$Z !== b) $9b6e3b5559a9e9a5$var$uk = null, $9b6e3b5559a9e9a5$var$Gj = $9b6e3b5559a9e9a5$var$B() + 500, $9b6e3b5559a9e9a5$var$Kk(a, b);
        for(;;)try {
            $9b6e3b5559a9e9a5$var$Lk();
            break;
        } catch (h) {
            $9b6e3b5559a9e9a5$var$Mk(a, h);
        }
        $9b6e3b5559a9e9a5$var$$g();
        $9b6e3b5559a9e9a5$var$mk.current = f;
        $9b6e3b5559a9e9a5$var$K = e;
        null !== $9b6e3b5559a9e9a5$var$Y ? b = 0 : ($9b6e3b5559a9e9a5$var$Q = null, $9b6e3b5559a9e9a5$var$Z = 0, b = $9b6e3b5559a9e9a5$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9b6e3b5559a9e9a5$var$xc(a), 0 !== e && (d = e, b = $9b6e3b5559a9e9a5$var$Nk(a, e)));
        if (1 === b) throw c = $9b6e3b5559a9e9a5$var$pk, $9b6e3b5559a9e9a5$var$Kk(a, 0), $9b6e3b5559a9e9a5$var$Ck(a, d), $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B()), c;
        if (6 === b) $9b6e3b5559a9e9a5$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9b6e3b5559a9e9a5$var$Ok(e) && (b = $9b6e3b5559a9e9a5$var$Ik(a, d), 2 === b && (f = $9b6e3b5559a9e9a5$var$xc(a), 0 !== f && (d = f, b = $9b6e3b5559a9e9a5$var$Nk(a, f))), 1 === b)) throw c = $9b6e3b5559a9e9a5$var$pk, $9b6e3b5559a9e9a5$var$Kk(a, 0), $9b6e3b5559a9e9a5$var$Ck(a, d), $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9b6e3b5559a9e9a5$var$p(345));
                case 2:
                    $9b6e3b5559a9e9a5$var$Pk(a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk);
                    break;
                case 3:
                    $9b6e3b5559a9e9a5$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $9b6e3b5559a9e9a5$var$fk + 500 - $9b6e3b5559a9e9a5$var$B(), 10 < b)) {
                        if (0 !== $9b6e3b5559a9e9a5$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9b6e3b5559a9e9a5$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9b6e3b5559a9e9a5$var$Ff($9b6e3b5559a9e9a5$var$Pk.bind(null, a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk), b);
                        break;
                    }
                    $9b6e3b5559a9e9a5$var$Pk(a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk);
                    break;
                case 4:
                    $9b6e3b5559a9e9a5$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9b6e3b5559a9e9a5$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9b6e3b5559a9e9a5$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9b6e3b5559a9e9a5$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9b6e3b5559a9e9a5$var$Ff($9b6e3b5559a9e9a5$var$Pk.bind(null, a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk), d);
                        break;
                    }
                    $9b6e3b5559a9e9a5$var$Pk(a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk);
                    break;
                case 5:
                    $9b6e3b5559a9e9a5$var$Pk(a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk);
                    break;
                default:
                    throw Error($9b6e3b5559a9e9a5$var$p(329));
            }
        }
    }
    $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B());
    return a.callbackNode === c ? $9b6e3b5559a9e9a5$var$Gk.bind(null, a) : null;
}
function $9b6e3b5559a9e9a5$var$Nk(a, b) {
    var c = $9b6e3b5559a9e9a5$var$sk;
    a.current.memoizedState.isDehydrated && ($9b6e3b5559a9e9a5$var$Kk(a, b).flags |= 256);
    a = $9b6e3b5559a9e9a5$var$Ik(a, b);
    2 !== a && (b = $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$tk = c, null !== b && $9b6e3b5559a9e9a5$var$Fj(b));
    return a;
}
function $9b6e3b5559a9e9a5$var$Fj(a) {
    null === $9b6e3b5559a9e9a5$var$tk ? $9b6e3b5559a9e9a5$var$tk = a : $9b6e3b5559a9e9a5$var$tk.push.apply($9b6e3b5559a9e9a5$var$tk, a);
}
function $9b6e3b5559a9e9a5$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9b6e3b5559a9e9a5$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9b6e3b5559a9e9a5$var$Ck(a, b) {
    b &= ~$9b6e3b5559a9e9a5$var$rk;
    b &= ~$9b6e3b5559a9e9a5$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9b6e3b5559a9e9a5$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9b6e3b5559a9e9a5$var$Ek(a) {
    if (0 !== ($9b6e3b5559a9e9a5$var$K & 6)) throw Error($9b6e3b5559a9e9a5$var$p(327));
    $9b6e3b5559a9e9a5$var$Hk();
    var b = $9b6e3b5559a9e9a5$var$uc(a, 0);
    if (0 === (b & 1)) return $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B()), null;
    var c = $9b6e3b5559a9e9a5$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9b6e3b5559a9e9a5$var$xc(a);
        0 !== d && (b = d, c = $9b6e3b5559a9e9a5$var$Nk(a, d));
    }
    if (1 === c) throw c = $9b6e3b5559a9e9a5$var$pk, $9b6e3b5559a9e9a5$var$Kk(a, 0), $9b6e3b5559a9e9a5$var$Ck(a, b), $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B()), c;
    if (6 === c) throw Error($9b6e3b5559a9e9a5$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9b6e3b5559a9e9a5$var$Pk(a, $9b6e3b5559a9e9a5$var$tk, $9b6e3b5559a9e9a5$var$uk);
    $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B());
    return null;
}
function $9b6e3b5559a9e9a5$var$Qk(a, b) {
    var c = $9b6e3b5559a9e9a5$var$K;
    $9b6e3b5559a9e9a5$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9b6e3b5559a9e9a5$var$K = c, 0 === $9b6e3b5559a9e9a5$var$K && ($9b6e3b5559a9e9a5$var$Gj = $9b6e3b5559a9e9a5$var$B() + 500, $9b6e3b5559a9e9a5$var$fg && $9b6e3b5559a9e9a5$var$jg());
    }
}
function $9b6e3b5559a9e9a5$var$Rk(a) {
    null !== $9b6e3b5559a9e9a5$var$wk && 0 === $9b6e3b5559a9e9a5$var$wk.tag && 0 === ($9b6e3b5559a9e9a5$var$K & 6) && $9b6e3b5559a9e9a5$var$Hk();
    var b = $9b6e3b5559a9e9a5$var$K;
    $9b6e3b5559a9e9a5$var$K |= 1;
    var c = $9b6e3b5559a9e9a5$var$ok.transition, d = $9b6e3b5559a9e9a5$var$C;
    try {
        if ($9b6e3b5559a9e9a5$var$ok.transition = null, $9b6e3b5559a9e9a5$var$C = 1, a) return a();
    } finally{
        $9b6e3b5559a9e9a5$var$C = d, $9b6e3b5559a9e9a5$var$ok.transition = c, $9b6e3b5559a9e9a5$var$K = b, 0 === ($9b6e3b5559a9e9a5$var$K & 6) && $9b6e3b5559a9e9a5$var$jg();
    }
}
function $9b6e3b5559a9e9a5$var$Hj() {
    $9b6e3b5559a9e9a5$var$fj = $9b6e3b5559a9e9a5$var$ej.current;
    $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$ej);
}
function $9b6e3b5559a9e9a5$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9b6e3b5559a9e9a5$var$Gf(c));
    if (null !== $9b6e3b5559a9e9a5$var$Y) for(c = $9b6e3b5559a9e9a5$var$Y.return; null !== c;){
        var d = c;
        $9b6e3b5559a9e9a5$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9b6e3b5559a9e9a5$var$$f();
                break;
            case 3:
                $9b6e3b5559a9e9a5$var$zh();
                $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$Wf);
                $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$H);
                $9b6e3b5559a9e9a5$var$Eh();
                break;
            case 5:
                $9b6e3b5559a9e9a5$var$Bh(d);
                break;
            case 4:
                $9b6e3b5559a9e9a5$var$zh();
                break;
            case 13:
                $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$L);
                break;
            case 19:
                $9b6e3b5559a9e9a5$var$E($9b6e3b5559a9e9a5$var$L);
                break;
            case 10:
                $9b6e3b5559a9e9a5$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $9b6e3b5559a9e9a5$var$Hj();
        }
        c = c.return;
    }
    $9b6e3b5559a9e9a5$var$Q = a;
    $9b6e3b5559a9e9a5$var$Y = a = $9b6e3b5559a9e9a5$var$Pg(a.current, null);
    $9b6e3b5559a9e9a5$var$Z = $9b6e3b5559a9e9a5$var$fj = b;
    $9b6e3b5559a9e9a5$var$T = 0;
    $9b6e3b5559a9e9a5$var$pk = null;
    $9b6e3b5559a9e9a5$var$rk = $9b6e3b5559a9e9a5$var$qk = $9b6e3b5559a9e9a5$var$rh = 0;
    $9b6e3b5559a9e9a5$var$tk = $9b6e3b5559a9e9a5$var$sk = null;
    if (null !== $9b6e3b5559a9e9a5$var$fh) {
        for(b = 0; b < $9b6e3b5559a9e9a5$var$fh.length; b++)if (c = $9b6e3b5559a9e9a5$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9b6e3b5559a9e9a5$var$fh = null;
    }
    return a;
}
function $9b6e3b5559a9e9a5$var$Mk(a, b) {
    do {
        var c = $9b6e3b5559a9e9a5$var$Y;
        try {
            $9b6e3b5559a9e9a5$var$$g();
            $9b6e3b5559a9e9a5$var$Fh.current = $9b6e3b5559a9e9a5$var$Rh;
            if ($9b6e3b5559a9e9a5$var$Ih) {
                for(var d = $9b6e3b5559a9e9a5$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9b6e3b5559a9e9a5$var$Ih = !1;
            }
            $9b6e3b5559a9e9a5$var$Hh = 0;
            $9b6e3b5559a9e9a5$var$O = $9b6e3b5559a9e9a5$var$N = $9b6e3b5559a9e9a5$var$M = null;
            $9b6e3b5559a9e9a5$var$Jh = !1;
            $9b6e3b5559a9e9a5$var$Kh = 0;
            $9b6e3b5559a9e9a5$var$nk.current = null;
            if (null === c || null === c.return) {
                $9b6e3b5559a9e9a5$var$T = 1;
                $9b6e3b5559a9e9a5$var$pk = b;
                $9b6e3b5559a9e9a5$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9b6e3b5559a9e9a5$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9b6e3b5559a9e9a5$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9b6e3b5559a9e9a5$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $9b6e3b5559a9e9a5$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9b6e3b5559a9e9a5$var$Si(f, l, b);
                            $9b6e3b5559a9e9a5$var$tj();
                            break a;
                        }
                        k = Error($9b6e3b5559a9e9a5$var$p(426));
                    }
                } else if ($9b6e3b5559a9e9a5$var$I && h.mode & 1) {
                    var J = $9b6e3b5559a9e9a5$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9b6e3b5559a9e9a5$var$Vi(J, g, h, f, b);
                        $9b6e3b5559a9e9a5$var$Jg($9b6e3b5559a9e9a5$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $9b6e3b5559a9e9a5$var$Ji(k, h);
                4 !== $9b6e3b5559a9e9a5$var$T && ($9b6e3b5559a9e9a5$var$T = 2);
                null === $9b6e3b5559a9e9a5$var$sk ? $9b6e3b5559a9e9a5$var$sk = [
                    f
                ] : $9b6e3b5559a9e9a5$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9b6e3b5559a9e9a5$var$Ni(f, k, b);
                            $9b6e3b5559a9e9a5$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9b6e3b5559a9e9a5$var$Ri || !$9b6e3b5559a9e9a5$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9b6e3b5559a9e9a5$var$Qi(f, h, b);
                                $9b6e3b5559a9e9a5$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9b6e3b5559a9e9a5$var$Sk(c);
        } catch (na) {
            b = na;
            $9b6e3b5559a9e9a5$var$Y === c && null !== c && ($9b6e3b5559a9e9a5$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9b6e3b5559a9e9a5$var$Jk() {
    var a = $9b6e3b5559a9e9a5$var$mk.current;
    $9b6e3b5559a9e9a5$var$mk.current = $9b6e3b5559a9e9a5$var$Rh;
    return null === a ? $9b6e3b5559a9e9a5$var$Rh : a;
}
function $9b6e3b5559a9e9a5$var$tj() {
    if (0 === $9b6e3b5559a9e9a5$var$T || 3 === $9b6e3b5559a9e9a5$var$T || 2 === $9b6e3b5559a9e9a5$var$T) $9b6e3b5559a9e9a5$var$T = 4;
    null === $9b6e3b5559a9e9a5$var$Q || 0 === ($9b6e3b5559a9e9a5$var$rh & 268435455) && 0 === ($9b6e3b5559a9e9a5$var$qk & 268435455) || $9b6e3b5559a9e9a5$var$Ck($9b6e3b5559a9e9a5$var$Q, $9b6e3b5559a9e9a5$var$Z);
}
function $9b6e3b5559a9e9a5$var$Ik(a, b) {
    var c = $9b6e3b5559a9e9a5$var$K;
    $9b6e3b5559a9e9a5$var$K |= 2;
    var d = $9b6e3b5559a9e9a5$var$Jk();
    if ($9b6e3b5559a9e9a5$var$Q !== a || $9b6e3b5559a9e9a5$var$Z !== b) $9b6e3b5559a9e9a5$var$uk = null, $9b6e3b5559a9e9a5$var$Kk(a, b);
    for(;;)try {
        $9b6e3b5559a9e9a5$var$Tk();
        break;
    } catch (e) {
        $9b6e3b5559a9e9a5$var$Mk(a, e);
    }
    $9b6e3b5559a9e9a5$var$$g();
    $9b6e3b5559a9e9a5$var$K = c;
    $9b6e3b5559a9e9a5$var$mk.current = d;
    if (null !== $9b6e3b5559a9e9a5$var$Y) throw Error($9b6e3b5559a9e9a5$var$p(261));
    $9b6e3b5559a9e9a5$var$Q = null;
    $9b6e3b5559a9e9a5$var$Z = 0;
    return $9b6e3b5559a9e9a5$var$T;
}
function $9b6e3b5559a9e9a5$var$Tk() {
    for(; null !== $9b6e3b5559a9e9a5$var$Y;)$9b6e3b5559a9e9a5$var$Uk($9b6e3b5559a9e9a5$var$Y);
}
function $9b6e3b5559a9e9a5$var$Lk() {
    for(; null !== $9b6e3b5559a9e9a5$var$Y && !$9b6e3b5559a9e9a5$var$cc();)$9b6e3b5559a9e9a5$var$Uk($9b6e3b5559a9e9a5$var$Y);
}
function $9b6e3b5559a9e9a5$var$Uk(a) {
    var b = $9b6e3b5559a9e9a5$var$Vk(a.alternate, a, $9b6e3b5559a9e9a5$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9b6e3b5559a9e9a5$var$Sk(a) : $9b6e3b5559a9e9a5$var$Y = b;
    $9b6e3b5559a9e9a5$var$nk.current = null;
}
function $9b6e3b5559a9e9a5$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9b6e3b5559a9e9a5$var$Ej(c, b, $9b6e3b5559a9e9a5$var$fj), null !== c) {
                $9b6e3b5559a9e9a5$var$Y = c;
                return;
            }
        } else {
            c = $9b6e3b5559a9e9a5$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9b6e3b5559a9e9a5$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9b6e3b5559a9e9a5$var$T = 6;
                $9b6e3b5559a9e9a5$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9b6e3b5559a9e9a5$var$Y = b;
            return;
        }
        $9b6e3b5559a9e9a5$var$Y = b = a;
    }while (null !== b);
    0 === $9b6e3b5559a9e9a5$var$T && ($9b6e3b5559a9e9a5$var$T = 5);
}
function $9b6e3b5559a9e9a5$var$Pk(a, b, c) {
    var d = $9b6e3b5559a9e9a5$var$C, e = $9b6e3b5559a9e9a5$var$ok.transition;
    try {
        $9b6e3b5559a9e9a5$var$ok.transition = null, $9b6e3b5559a9e9a5$var$C = 1, $9b6e3b5559a9e9a5$var$Wk(a, b, c, d);
    } finally{
        $9b6e3b5559a9e9a5$var$ok.transition = e, $9b6e3b5559a9e9a5$var$C = d;
    }
    return null;
}
function $9b6e3b5559a9e9a5$var$Wk(a, b, c, d) {
    do $9b6e3b5559a9e9a5$var$Hk();
    while (null !== $9b6e3b5559a9e9a5$var$wk);
    if (0 !== ($9b6e3b5559a9e9a5$var$K & 6)) throw Error($9b6e3b5559a9e9a5$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9b6e3b5559a9e9a5$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9b6e3b5559a9e9a5$var$Bc(a, f);
    a === $9b6e3b5559a9e9a5$var$Q && ($9b6e3b5559a9e9a5$var$Y = $9b6e3b5559a9e9a5$var$Q = null, $9b6e3b5559a9e9a5$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9b6e3b5559a9e9a5$var$vk || ($9b6e3b5559a9e9a5$var$vk = !0, $9b6e3b5559a9e9a5$var$Fk($9b6e3b5559a9e9a5$var$hc, function() {
        $9b6e3b5559a9e9a5$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9b6e3b5559a9e9a5$var$ok.transition;
        $9b6e3b5559a9e9a5$var$ok.transition = null;
        var g = $9b6e3b5559a9e9a5$var$C;
        $9b6e3b5559a9e9a5$var$C = 1;
        var h = $9b6e3b5559a9e9a5$var$K;
        $9b6e3b5559a9e9a5$var$K |= 4;
        $9b6e3b5559a9e9a5$var$nk.current = null;
        $9b6e3b5559a9e9a5$var$Oj(a, c);
        $9b6e3b5559a9e9a5$var$dk(c, a);
        $9b6e3b5559a9e9a5$var$Oe($9b6e3b5559a9e9a5$var$Df);
        $9b6e3b5559a9e9a5$var$dd = !!$9b6e3b5559a9e9a5$var$Cf;
        $9b6e3b5559a9e9a5$var$Df = $9b6e3b5559a9e9a5$var$Cf = null;
        a.current = c;
        $9b6e3b5559a9e9a5$var$hk(c, a, e);
        $9b6e3b5559a9e9a5$var$dc();
        $9b6e3b5559a9e9a5$var$K = h;
        $9b6e3b5559a9e9a5$var$C = g;
        $9b6e3b5559a9e9a5$var$ok.transition = f;
    } else a.current = c;
    $9b6e3b5559a9e9a5$var$vk && ($9b6e3b5559a9e9a5$var$vk = !1, $9b6e3b5559a9e9a5$var$wk = a, $9b6e3b5559a9e9a5$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($9b6e3b5559a9e9a5$var$Ri = null);
    $9b6e3b5559a9e9a5$var$mc(c.stateNode, d);
    $9b6e3b5559a9e9a5$var$Dk(a, $9b6e3b5559a9e9a5$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9b6e3b5559a9e9a5$var$Oi) throw $9b6e3b5559a9e9a5$var$Oi = !1, a = $9b6e3b5559a9e9a5$var$Pi, $9b6e3b5559a9e9a5$var$Pi = null, a;
    0 !== ($9b6e3b5559a9e9a5$var$xk & 1) && 0 !== a.tag && $9b6e3b5559a9e9a5$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9b6e3b5559a9e9a5$var$zk ? $9b6e3b5559a9e9a5$var$yk++ : ($9b6e3b5559a9e9a5$var$yk = 0, $9b6e3b5559a9e9a5$var$zk = a) : $9b6e3b5559a9e9a5$var$yk = 0;
    $9b6e3b5559a9e9a5$var$jg();
    return null;
}
function $9b6e3b5559a9e9a5$var$Hk() {
    if (null !== $9b6e3b5559a9e9a5$var$wk) {
        var a = $9b6e3b5559a9e9a5$var$Dc($9b6e3b5559a9e9a5$var$xk), b = $9b6e3b5559a9e9a5$var$ok.transition, c = $9b6e3b5559a9e9a5$var$C;
        try {
            $9b6e3b5559a9e9a5$var$ok.transition = null;
            $9b6e3b5559a9e9a5$var$C = 16 > a ? 16 : a;
            if (null === $9b6e3b5559a9e9a5$var$wk) var d = !1;
            else {
                a = $9b6e3b5559a9e9a5$var$wk;
                $9b6e3b5559a9e9a5$var$wk = null;
                $9b6e3b5559a9e9a5$var$xk = 0;
                if (0 !== ($9b6e3b5559a9e9a5$var$K & 6)) throw Error($9b6e3b5559a9e9a5$var$p(331));
                var e = $9b6e3b5559a9e9a5$var$K;
                $9b6e3b5559a9e9a5$var$K |= 4;
                for($9b6e3b5559a9e9a5$var$V = a.current; null !== $9b6e3b5559a9e9a5$var$V;){
                    var f = $9b6e3b5559a9e9a5$var$V, g = f.child;
                    if (0 !== ($9b6e3b5559a9e9a5$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9b6e3b5559a9e9a5$var$V = l; null !== $9b6e3b5559a9e9a5$var$V;){
                                    var m = $9b6e3b5559a9e9a5$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9b6e3b5559a9e9a5$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9b6e3b5559a9e9a5$var$V = q;
                                    else for(; null !== $9b6e3b5559a9e9a5$var$V;){
                                        m = $9b6e3b5559a9e9a5$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9b6e3b5559a9e9a5$var$Sj(m);
                                        if (m === l) {
                                            $9b6e3b5559a9e9a5$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9b6e3b5559a9e9a5$var$V = r;
                                            break;
                                        }
                                        $9b6e3b5559a9e9a5$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9b6e3b5559a9e9a5$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9b6e3b5559a9e9a5$var$V = g;
                    else b: for(; null !== $9b6e3b5559a9e9a5$var$V;){
                        f = $9b6e3b5559a9e9a5$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9b6e3b5559a9e9a5$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9b6e3b5559a9e9a5$var$V = x;
                            break b;
                        }
                        $9b6e3b5559a9e9a5$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9b6e3b5559a9e9a5$var$V = w; null !== $9b6e3b5559a9e9a5$var$V;){
                    g = $9b6e3b5559a9e9a5$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9b6e3b5559a9e9a5$var$V = u;
                    else b: for(g = w; null !== $9b6e3b5559a9e9a5$var$V;){
                        h = $9b6e3b5559a9e9a5$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9b6e3b5559a9e9a5$var$Qj(9, h);
                            }
                        } catch (na) {
                            $9b6e3b5559a9e9a5$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9b6e3b5559a9e9a5$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9b6e3b5559a9e9a5$var$V = F;
                            break b;
                        }
                        $9b6e3b5559a9e9a5$var$V = h.return;
                    }
                }
                $9b6e3b5559a9e9a5$var$K = e;
                $9b6e3b5559a9e9a5$var$jg();
                if ($9b6e3b5559a9e9a5$var$lc && "function" === typeof $9b6e3b5559a9e9a5$var$lc.onPostCommitFiberRoot) try {
                    $9b6e3b5559a9e9a5$var$lc.onPostCommitFiberRoot($9b6e3b5559a9e9a5$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9b6e3b5559a9e9a5$var$C = c, $9b6e3b5559a9e9a5$var$ok.transition = b;
        }
    }
    return !1;
}
function $9b6e3b5559a9e9a5$var$Xk(a, b, c) {
    b = $9b6e3b5559a9e9a5$var$Ji(c, b);
    b = $9b6e3b5559a9e9a5$var$Ni(a, b, 1);
    a = $9b6e3b5559a9e9a5$var$nh(a, b, 1);
    b = $9b6e3b5559a9e9a5$var$R();
    null !== a && ($9b6e3b5559a9e9a5$var$Ac(a, 1, b), $9b6e3b5559a9e9a5$var$Dk(a, b));
}
function $9b6e3b5559a9e9a5$var$W(a, b, c) {
    if (3 === a.tag) $9b6e3b5559a9e9a5$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9b6e3b5559a9e9a5$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9b6e3b5559a9e9a5$var$Ri || !$9b6e3b5559a9e9a5$var$Ri.has(d))) {
                a = $9b6e3b5559a9e9a5$var$Ji(c, a);
                a = $9b6e3b5559a9e9a5$var$Qi(b, a, 1);
                b = $9b6e3b5559a9e9a5$var$nh(b, a, 1);
                a = $9b6e3b5559a9e9a5$var$R();
                null !== b && ($9b6e3b5559a9e9a5$var$Ac(b, 1, a), $9b6e3b5559a9e9a5$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9b6e3b5559a9e9a5$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9b6e3b5559a9e9a5$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $9b6e3b5559a9e9a5$var$Q === a && ($9b6e3b5559a9e9a5$var$Z & c) === c && (4 === $9b6e3b5559a9e9a5$var$T || 3 === $9b6e3b5559a9e9a5$var$T && ($9b6e3b5559a9e9a5$var$Z & 130023424) === $9b6e3b5559a9e9a5$var$Z && 500 > $9b6e3b5559a9e9a5$var$B() - $9b6e3b5559a9e9a5$var$fk ? $9b6e3b5559a9e9a5$var$Kk(a, 0) : $9b6e3b5559a9e9a5$var$rk |= c);
    $9b6e3b5559a9e9a5$var$Dk(a, b);
}
function $9b6e3b5559a9e9a5$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9b6e3b5559a9e9a5$var$sc, $9b6e3b5559a9e9a5$var$sc <<= 1, 0 === ($9b6e3b5559a9e9a5$var$sc & 130023424) && ($9b6e3b5559a9e9a5$var$sc = 4194304)));
    var c = $9b6e3b5559a9e9a5$var$R();
    a = $9b6e3b5559a9e9a5$var$ih(a, b);
    null !== a && ($9b6e3b5559a9e9a5$var$Ac(a, b, c), $9b6e3b5559a9e9a5$var$Dk(a, c));
}
function $9b6e3b5559a9e9a5$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9b6e3b5559a9e9a5$var$Yk(a, c);
}
function $9b6e3b5559a9e9a5$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9b6e3b5559a9e9a5$var$p(314));
    }
    null !== d && d.delete(b);
    $9b6e3b5559a9e9a5$var$Yk(a, c);
}
var $9b6e3b5559a9e9a5$var$Vk;
$9b6e3b5559a9e9a5$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9b6e3b5559a9e9a5$var$Wf.current) $9b6e3b5559a9e9a5$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9b6e3b5559a9e9a5$var$dh = !1, $9b6e3b5559a9e9a5$var$yj(a, b, c);
            $9b6e3b5559a9e9a5$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9b6e3b5559a9e9a5$var$dh = !1, $9b6e3b5559a9e9a5$var$I && 0 !== (b.flags & 1048576) && $9b6e3b5559a9e9a5$var$ug(b, $9b6e3b5559a9e9a5$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9b6e3b5559a9e9a5$var$ij(a, b);
            a = b.pendingProps;
            var e = $9b6e3b5559a9e9a5$var$Yf(b, $9b6e3b5559a9e9a5$var$H.current);
            $9b6e3b5559a9e9a5$var$ch(b, c);
            e = $9b6e3b5559a9e9a5$var$Nh(null, b, d, a, e, c);
            var f = $9b6e3b5559a9e9a5$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9b6e3b5559a9e9a5$var$Zf(d) ? (f = !0, $9b6e3b5559a9e9a5$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9b6e3b5559a9e9a5$var$kh(b), e.updater = $9b6e3b5559a9e9a5$var$Ei, b.stateNode = e, e._reactInternals = b, $9b6e3b5559a9e9a5$var$Ii(b, d, a, c), b = $9b6e3b5559a9e9a5$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $9b6e3b5559a9e9a5$var$I && f && $9b6e3b5559a9e9a5$var$vg(b), $9b6e3b5559a9e9a5$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9b6e3b5559a9e9a5$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9b6e3b5559a9e9a5$var$Zk(d);
                a = $9b6e3b5559a9e9a5$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $9b6e3b5559a9e9a5$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9b6e3b5559a9e9a5$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9b6e3b5559a9e9a5$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9b6e3b5559a9e9a5$var$$i(null, b, d, $9b6e3b5559a9e9a5$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($9b6e3b5559a9e9a5$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b6e3b5559a9e9a5$var$Ci(d, e), $9b6e3b5559a9e9a5$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b6e3b5559a9e9a5$var$Ci(d, e), $9b6e3b5559a9e9a5$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $9b6e3b5559a9e9a5$var$kj(b);
                if (null === a) throw Error($9b6e3b5559a9e9a5$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9b6e3b5559a9e9a5$var$lh(a, b);
                $9b6e3b5559a9e9a5$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9b6e3b5559a9e9a5$var$Ji(Error($9b6e3b5559a9e9a5$var$p(423)), b);
                        b = $9b6e3b5559a9e9a5$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9b6e3b5559a9e9a5$var$Ji(Error($9b6e3b5559a9e9a5$var$p(424)), b);
                        b = $9b6e3b5559a9e9a5$var$lj(a, b, d, c, e);
                        break a;
                    } else for($9b6e3b5559a9e9a5$var$yg = $9b6e3b5559a9e9a5$var$Lf(b.stateNode.containerInfo.firstChild), $9b6e3b5559a9e9a5$var$xg = b, $9b6e3b5559a9e9a5$var$I = !0, $9b6e3b5559a9e9a5$var$zg = null, c = $9b6e3b5559a9e9a5$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9b6e3b5559a9e9a5$var$Ig();
                    if (d === e) {
                        b = $9b6e3b5559a9e9a5$var$Zi(a, b, c);
                        break a;
                    }
                    $9b6e3b5559a9e9a5$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9b6e3b5559a9e9a5$var$Ah(b), null === a && $9b6e3b5559a9e9a5$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9b6e3b5559a9e9a5$var$Ef(d, e) ? g = null : null !== f && $9b6e3b5559a9e9a5$var$Ef(d, f) && (b.flags |= 32), $9b6e3b5559a9e9a5$var$gj(a, b), $9b6e3b5559a9e9a5$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $9b6e3b5559a9e9a5$var$Eg(b), null;
        case 13:
            return $9b6e3b5559a9e9a5$var$oj(a, b, c);
        case 4:
            return $9b6e3b5559a9e9a5$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9b6e3b5559a9e9a5$var$Ug(b, null, d, c) : $9b6e3b5559a9e9a5$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b6e3b5559a9e9a5$var$Ci(d, e), $9b6e3b5559a9e9a5$var$Yi(a, b, d, e, c);
        case 7:
            return $9b6e3b5559a9e9a5$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9b6e3b5559a9e9a5$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9b6e3b5559a9e9a5$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9b6e3b5559a9e9a5$var$G($9b6e3b5559a9e9a5$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9b6e3b5559a9e9a5$var$He(f.value, g)) {
                        if (f.children === e.children && !$9b6e3b5559a9e9a5$var$Wf.current) {
                            b = $9b6e3b5559a9e9a5$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9b6e3b5559a9e9a5$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9b6e3b5559a9e9a5$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9b6e3b5559a9e9a5$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9b6e3b5559a9e9a5$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9b6e3b5559a9e9a5$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9b6e3b5559a9e9a5$var$ch(b, c), e = $9b6e3b5559a9e9a5$var$eh(e), d = d(e), b.flags |= 1, $9b6e3b5559a9e9a5$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9b6e3b5559a9e9a5$var$Ci(d, b.pendingProps), e = $9b6e3b5559a9e9a5$var$Ci(d.type, e), $9b6e3b5559a9e9a5$var$$i(a, b, d, e, c);
        case 15:
            return $9b6e3b5559a9e9a5$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b6e3b5559a9e9a5$var$Ci(d, e), $9b6e3b5559a9e9a5$var$ij(a, b), b.tag = 1, $9b6e3b5559a9e9a5$var$Zf(d) ? (a = !0, $9b6e3b5559a9e9a5$var$cg(b)) : a = !1, $9b6e3b5559a9e9a5$var$ch(b, c), $9b6e3b5559a9e9a5$var$Gi(b, d, e), $9b6e3b5559a9e9a5$var$Ii(b, d, e, c), $9b6e3b5559a9e9a5$var$jj(null, b, d, !0, a, c);
        case 19:
            return $9b6e3b5559a9e9a5$var$xj(a, b, c);
        case 22:
            return $9b6e3b5559a9e9a5$var$dj(a, b, c);
    }
    throw Error($9b6e3b5559a9e9a5$var$p(156, b.tag));
};
function $9b6e3b5559a9e9a5$var$Fk(a, b) {
    return $9b6e3b5559a9e9a5$var$ac(a, b);
}
function $9b6e3b5559a9e9a5$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9b6e3b5559a9e9a5$var$Bg(a, b, c, d) {
    return new $9b6e3b5559a9e9a5$var$$k(a, b, c, d);
}
function $9b6e3b5559a9e9a5$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9b6e3b5559a9e9a5$var$Zk(a) {
    if ("function" === typeof a) return $9b6e3b5559a9e9a5$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9b6e3b5559a9e9a5$var$Da) return 11;
        if (a === $9b6e3b5559a9e9a5$var$Ga) return 14;
    }
    return 2;
}
function $9b6e3b5559a9e9a5$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $9b6e3b5559a9e9a5$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9b6e3b5559a9e9a5$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9b6e3b5559a9e9a5$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9b6e3b5559a9e9a5$var$ya:
            return $9b6e3b5559a9e9a5$var$Tg(c.children, e, f, b);
        case $9b6e3b5559a9e9a5$var$za:
            g = 8;
            e |= 8;
            break;
        case $9b6e3b5559a9e9a5$var$Aa:
            return a = $9b6e3b5559a9e9a5$var$Bg(12, c, b, e | 2), a.elementType = $9b6e3b5559a9e9a5$var$Aa, a.lanes = f, a;
        case $9b6e3b5559a9e9a5$var$Ea:
            return a = $9b6e3b5559a9e9a5$var$Bg(13, c, b, e), a.elementType = $9b6e3b5559a9e9a5$var$Ea, a.lanes = f, a;
        case $9b6e3b5559a9e9a5$var$Fa:
            return a = $9b6e3b5559a9e9a5$var$Bg(19, c, b, e), a.elementType = $9b6e3b5559a9e9a5$var$Fa, a.lanes = f, a;
        case $9b6e3b5559a9e9a5$var$Ia:
            return $9b6e3b5559a9e9a5$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9b6e3b5559a9e9a5$var$Ba:
                    g = 10;
                    break a;
                case $9b6e3b5559a9e9a5$var$Ca:
                    g = 9;
                    break a;
                case $9b6e3b5559a9e9a5$var$Da:
                    g = 11;
                    break a;
                case $9b6e3b5559a9e9a5$var$Ga:
                    g = 14;
                    break a;
                case $9b6e3b5559a9e9a5$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9b6e3b5559a9e9a5$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9b6e3b5559a9e9a5$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9b6e3b5559a9e9a5$var$Tg(a, b, c, d) {
    a = $9b6e3b5559a9e9a5$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9b6e3b5559a9e9a5$var$pj(a, b, c, d) {
    a = $9b6e3b5559a9e9a5$var$Bg(22, a, d, b);
    a.elementType = $9b6e3b5559a9e9a5$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9b6e3b5559a9e9a5$var$Qg(a, b, c) {
    a = $9b6e3b5559a9e9a5$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9b6e3b5559a9e9a5$var$Sg(a, b, c) {
    b = $9b6e3b5559a9e9a5$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9b6e3b5559a9e9a5$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9b6e3b5559a9e9a5$var$zc(0);
    this.expirationTimes = $9b6e3b5559a9e9a5$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9b6e3b5559a9e9a5$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9b6e3b5559a9e9a5$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $9b6e3b5559a9e9a5$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9b6e3b5559a9e9a5$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9b6e3b5559a9e9a5$var$kh(f);
    return a;
}
function $9b6e3b5559a9e9a5$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9b6e3b5559a9e9a5$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9b6e3b5559a9e9a5$var$dl(a) {
    if (!a) return $9b6e3b5559a9e9a5$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9b6e3b5559a9e9a5$var$Vb(a) !== a || 1 !== a.tag) throw Error($9b6e3b5559a9e9a5$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9b6e3b5559a9e9a5$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9b6e3b5559a9e9a5$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9b6e3b5559a9e9a5$var$Zf(c)) return $9b6e3b5559a9e9a5$var$bg(a, c, b);
    }
    return b;
}
function $9b6e3b5559a9e9a5$var$el(a, b, c, d, e, f, g, h, k) {
    a = $9b6e3b5559a9e9a5$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $9b6e3b5559a9e9a5$var$dl(null);
    c = a.current;
    d = $9b6e3b5559a9e9a5$var$R();
    e = $9b6e3b5559a9e9a5$var$yi(c);
    f = $9b6e3b5559a9e9a5$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9b6e3b5559a9e9a5$var$nh(c, f, e);
    a.current.lanes = e;
    $9b6e3b5559a9e9a5$var$Ac(a, e, d);
    $9b6e3b5559a9e9a5$var$Dk(a, d);
    return a;
}
function $9b6e3b5559a9e9a5$var$fl(a, b, c, d) {
    var e = b.current, f = $9b6e3b5559a9e9a5$var$R(), g = $9b6e3b5559a9e9a5$var$yi(e);
    c = $9b6e3b5559a9e9a5$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9b6e3b5559a9e9a5$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9b6e3b5559a9e9a5$var$nh(e, b, g);
    null !== a && ($9b6e3b5559a9e9a5$var$gi(a, e, g, f), $9b6e3b5559a9e9a5$var$oh(a, e, g));
    return g;
}
function $9b6e3b5559a9e9a5$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9b6e3b5559a9e9a5$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9b6e3b5559a9e9a5$var$il(a, b) {
    $9b6e3b5559a9e9a5$var$hl(a, b);
    (a = a.alternate) && $9b6e3b5559a9e9a5$var$hl(a, b);
}
function $9b6e3b5559a9e9a5$var$jl() {
    return null;
}
var $9b6e3b5559a9e9a5$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9b6e3b5559a9e9a5$var$ll(a) {
    this._internalRoot = a;
}
$9b6e3b5559a9e9a5$var$ml.prototype.render = $9b6e3b5559a9e9a5$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9b6e3b5559a9e9a5$var$p(409));
    $9b6e3b5559a9e9a5$var$fl(a, b, null, null);
};
$9b6e3b5559a9e9a5$var$ml.prototype.unmount = $9b6e3b5559a9e9a5$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9b6e3b5559a9e9a5$var$Rk(function() {
            $9b6e3b5559a9e9a5$var$fl(null, a, null, null);
        });
        b[$9b6e3b5559a9e9a5$var$uf] = null;
    }
};
function $9b6e3b5559a9e9a5$var$ml(a) {
    this._internalRoot = a;
}
$9b6e3b5559a9e9a5$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9b6e3b5559a9e9a5$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9b6e3b5559a9e9a5$var$Qc.length && 0 !== b && b < $9b6e3b5559a9e9a5$var$Qc[c].priority; c++);
        $9b6e3b5559a9e9a5$var$Qc.splice(c, 0, a);
        0 === c && $9b6e3b5559a9e9a5$var$Vc(a);
    }
};
function $9b6e3b5559a9e9a5$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9b6e3b5559a9e9a5$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9b6e3b5559a9e9a5$var$pl() {}
function $9b6e3b5559a9e9a5$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9b6e3b5559a9e9a5$var$gl(g);
                f.call(a);
            };
        }
        var g = $9b6e3b5559a9e9a5$var$el(b, d, a, 0, null, !1, !1, "", $9b6e3b5559a9e9a5$var$pl);
        a._reactRootContainer = g;
        a[$9b6e3b5559a9e9a5$var$uf] = g.current;
        $9b6e3b5559a9e9a5$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9b6e3b5559a9e9a5$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9b6e3b5559a9e9a5$var$gl(k);
            h.call(a);
        };
    }
    var k = $9b6e3b5559a9e9a5$var$bl(a, 0, !1, null, null, !1, !1, "", $9b6e3b5559a9e9a5$var$pl);
    a._reactRootContainer = k;
    a[$9b6e3b5559a9e9a5$var$uf] = k.current;
    $9b6e3b5559a9e9a5$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9b6e3b5559a9e9a5$var$Rk(function() {
        $9b6e3b5559a9e9a5$var$fl(b, k, c, d);
    });
    return k;
}
function $9b6e3b5559a9e9a5$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9b6e3b5559a9e9a5$var$gl(g);
                h.call(a);
            };
        }
        $9b6e3b5559a9e9a5$var$fl(b, g, a, e);
    } else g = $9b6e3b5559a9e9a5$var$ql(c, b, a, e, d);
    return $9b6e3b5559a9e9a5$var$gl(g);
}
$9b6e3b5559a9e9a5$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9b6e3b5559a9e9a5$var$tc(b.pendingLanes);
                0 !== c && ($9b6e3b5559a9e9a5$var$Cc(b, c | 1), $9b6e3b5559a9e9a5$var$Dk(b, $9b6e3b5559a9e9a5$var$B()), 0 === ($9b6e3b5559a9e9a5$var$K & 6) && ($9b6e3b5559a9e9a5$var$Gj = $9b6e3b5559a9e9a5$var$B() + 500, $9b6e3b5559a9e9a5$var$jg()));
            }
            break;
        case 13:
            $9b6e3b5559a9e9a5$var$Rk(function() {
                var b = $9b6e3b5559a9e9a5$var$ih(a, 1);
                if (null !== b) {
                    var c = $9b6e3b5559a9e9a5$var$R();
                    $9b6e3b5559a9e9a5$var$gi(b, a, 1, c);
                }
            }), $9b6e3b5559a9e9a5$var$il(a, 1);
    }
};
$9b6e3b5559a9e9a5$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9b6e3b5559a9e9a5$var$ih(a, 134217728);
        if (null !== b) {
            var c = $9b6e3b5559a9e9a5$var$R();
            $9b6e3b5559a9e9a5$var$gi(b, a, 134217728, c);
        }
        $9b6e3b5559a9e9a5$var$il(a, 134217728);
    }
};
$9b6e3b5559a9e9a5$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9b6e3b5559a9e9a5$var$yi(a), c = $9b6e3b5559a9e9a5$var$ih(a, b);
        if (null !== c) {
            var d = $9b6e3b5559a9e9a5$var$R();
            $9b6e3b5559a9e9a5$var$gi(c, a, b, d);
        }
        $9b6e3b5559a9e9a5$var$il(a, b);
    }
};
$9b6e3b5559a9e9a5$var$Hc = function() {
    return $9b6e3b5559a9e9a5$var$C;
};
$9b6e3b5559a9e9a5$var$Ic = function(a, b) {
    var c = $9b6e3b5559a9e9a5$var$C;
    try {
        return $9b6e3b5559a9e9a5$var$C = a, b();
    } finally{
        $9b6e3b5559a9e9a5$var$C = c;
    }
};
$9b6e3b5559a9e9a5$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9b6e3b5559a9e9a5$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9b6e3b5559a9e9a5$var$Db(d);
                        if (!e) throw Error($9b6e3b5559a9e9a5$var$p(90));
                        $9b6e3b5559a9e9a5$var$Wa(d);
                        $9b6e3b5559a9e9a5$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9b6e3b5559a9e9a5$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9b6e3b5559a9e9a5$var$fb(a, !!c.multiple, b, !1);
    }
};
$9b6e3b5559a9e9a5$var$Gb = $9b6e3b5559a9e9a5$var$Qk;
$9b6e3b5559a9e9a5$var$Hb = $9b6e3b5559a9e9a5$var$Rk;
var $9b6e3b5559a9e9a5$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $9b6e3b5559a9e9a5$var$Cb,
        $9b6e3b5559a9e9a5$var$ue,
        $9b6e3b5559a9e9a5$var$Db,
        $9b6e3b5559a9e9a5$var$Eb,
        $9b6e3b5559a9e9a5$var$Fb,
        $9b6e3b5559a9e9a5$var$Qk
    ]
}, $9b6e3b5559a9e9a5$var$tl = {
    findFiberByHostInstance: $9b6e3b5559a9e9a5$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $9b6e3b5559a9e9a5$var$ul = {
    bundleType: $9b6e3b5559a9e9a5$var$tl.bundleType,
    version: $9b6e3b5559a9e9a5$var$tl.version,
    rendererPackageName: $9b6e3b5559a9e9a5$var$tl.rendererPackageName,
    rendererConfig: $9b6e3b5559a9e9a5$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9b6e3b5559a9e9a5$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9b6e3b5559a9e9a5$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9b6e3b5559a9e9a5$var$tl.findFiberByHostInstance || $9b6e3b5559a9e9a5$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9b6e3b5559a9e9a5$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9b6e3b5559a9e9a5$var$vl.isDisabled && $9b6e3b5559a9e9a5$var$vl.supportsFiber) try {
        $9b6e3b5559a9e9a5$var$kc = $9b6e3b5559a9e9a5$var$vl.inject($9b6e3b5559a9e9a5$var$ul), $9b6e3b5559a9e9a5$var$lc = $9b6e3b5559a9e9a5$var$vl;
    } catch (a) {}
}
$9b6e3b5559a9e9a5$export$ae55be85d98224ed = $9b6e3b5559a9e9a5$var$sl;
$9b6e3b5559a9e9a5$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9b6e3b5559a9e9a5$var$nl(b)) throw Error($9b6e3b5559a9e9a5$var$p(200));
    return $9b6e3b5559a9e9a5$var$cl(a, b, null, c);
};
$9b6e3b5559a9e9a5$export$882461b6382ed46c = function(a, b) {
    if (!$9b6e3b5559a9e9a5$var$nl(a)) throw Error($9b6e3b5559a9e9a5$var$p(299));
    var c = !1, d = "", e = $9b6e3b5559a9e9a5$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9b6e3b5559a9e9a5$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$9b6e3b5559a9e9a5$var$uf] = b.current;
    $9b6e3b5559a9e9a5$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9b6e3b5559a9e9a5$var$ll(b);
};
$9b6e3b5559a9e9a5$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9b6e3b5559a9e9a5$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9b6e3b5559a9e9a5$var$p(268, a));
    }
    a = $9b6e3b5559a9e9a5$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9b6e3b5559a9e9a5$export$cd75ccfd720a3cd4 = function(a) {
    return $9b6e3b5559a9e9a5$var$Rk(a);
};
$9b6e3b5559a9e9a5$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9b6e3b5559a9e9a5$var$ol(b)) throw Error($9b6e3b5559a9e9a5$var$p(200));
    return $9b6e3b5559a9e9a5$var$rl(null, a, b, !0, c);
};
$9b6e3b5559a9e9a5$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9b6e3b5559a9e9a5$var$nl(a)) throw Error($9b6e3b5559a9e9a5$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9b6e3b5559a9e9a5$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9b6e3b5559a9e9a5$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9b6e3b5559a9e9a5$var$uf] = b.current;
    $9b6e3b5559a9e9a5$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9b6e3b5559a9e9a5$var$ml(b);
};
$9b6e3b5559a9e9a5$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9b6e3b5559a9e9a5$var$ol(b)) throw Error($9b6e3b5559a9e9a5$var$p(200));
    return $9b6e3b5559a9e9a5$var$rl(null, a, b, !1, c);
};
$9b6e3b5559a9e9a5$export$502457920280e6be = function(a) {
    if (!$9b6e3b5559a9e9a5$var$ol(a)) throw Error($9b6e3b5559a9e9a5$var$p(40));
    return a._reactRootContainer ? ($9b6e3b5559a9e9a5$var$Rk(function() {
        $9b6e3b5559a9e9a5$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9b6e3b5559a9e9a5$var$uf] = null;
        });
    }), !0) : !1;
};
$9b6e3b5559a9e9a5$export$c78a37762a8d58e1 = $9b6e3b5559a9e9a5$var$Qk;
$9b6e3b5559a9e9a5$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9b6e3b5559a9e9a5$var$ol(c)) throw Error($9b6e3b5559a9e9a5$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9b6e3b5559a9e9a5$var$p(38));
    return $9b6e3b5559a9e9a5$var$rl(a, b, c, !1, d);
};
$9b6e3b5559a9e9a5$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fYajP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("02NR8"));

});
parcelRegister("02NR8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $0086dc5fbe11e099$export$c4744153514ff05d, (v) => $0086dc5fbe11e099$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $0086dc5fbe11e099$export$3e506c1ccc9cc1a7, (v) => $0086dc5fbe11e099$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $0086dc5fbe11e099$export$e26fe2ed2fa76875, (v) => $0086dc5fbe11e099$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $0086dc5fbe11e099$export$502329bbf4b505b1, (v) => $0086dc5fbe11e099$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $0086dc5fbe11e099$export$6e3807111c4874c4, (v) => $0086dc5fbe11e099$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $0086dc5fbe11e099$export$c27134553091fb3a, (v) => $0086dc5fbe11e099$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $0086dc5fbe11e099$export$33ee1acdc04fd2a2, (v) => $0086dc5fbe11e099$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $0086dc5fbe11e099$export$b00a404bbd5edef2, (v) => $0086dc5fbe11e099$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $0086dc5fbe11e099$export$8352ce38b91d0c62, (v) => $0086dc5fbe11e099$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $0086dc5fbe11e099$export$d66a1c1c77bd778b, (v) => $0086dc5fbe11e099$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $0086dc5fbe11e099$export$d3dfb8e4810cb555, (v) => $0086dc5fbe11e099$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $0086dc5fbe11e099$export$839f9183b0465a69, (v) => $0086dc5fbe11e099$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $0086dc5fbe11e099$export$72fdf0e06517287b, (v) => $0086dc5fbe11e099$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $0086dc5fbe11e099$export$4b844e58a3e414b4, (v) => $0086dc5fbe11e099$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $0086dc5fbe11e099$export$816d2913ae6b83b1, (v) => $0086dc5fbe11e099$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $0086dc5fbe11e099$export$61bcfe829111a1d0, (v) => $0086dc5fbe11e099$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $0086dc5fbe11e099$export$7ee8c9beb337bc3f, (v) => $0086dc5fbe11e099$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $0086dc5fbe11e099$export$b5836b71941fa3ed, (v) => $0086dc5fbe11e099$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $0086dc5fbe11e099$export$cf845f2c119da08a, (v) => $0086dc5fbe11e099$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0086dc5fbe11e099$export$c4744153514ff05d;
var $0086dc5fbe11e099$export$3e506c1ccc9cc1a7;
var $0086dc5fbe11e099$export$e26fe2ed2fa76875;
var $0086dc5fbe11e099$export$502329bbf4b505b1;
var $0086dc5fbe11e099$export$6e3807111c4874c4;
var $0086dc5fbe11e099$export$c27134553091fb3a;
var $0086dc5fbe11e099$export$33ee1acdc04fd2a2;
var $0086dc5fbe11e099$export$b00a404bbd5edef2;
var $0086dc5fbe11e099$export$8352ce38b91d0c62;
var $0086dc5fbe11e099$export$d66a1c1c77bd778b;
var $0086dc5fbe11e099$export$d3dfb8e4810cb555;
var $0086dc5fbe11e099$export$839f9183b0465a69;
var $0086dc5fbe11e099$export$72fdf0e06517287b;
var $0086dc5fbe11e099$export$4b844e58a3e414b4;
var $0086dc5fbe11e099$export$816d2913ae6b83b1;
var $0086dc5fbe11e099$export$61bcfe829111a1d0;
var $0086dc5fbe11e099$export$7ee8c9beb337bc3f;
var $0086dc5fbe11e099$export$b5836b71941fa3ed;
var $0086dc5fbe11e099$export$cf845f2c119da08a;
'use strict';
function $0086dc5fbe11e099$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $0086dc5fbe11e099$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $0086dc5fbe11e099$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $0086dc5fbe11e099$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $0086dc5fbe11e099$var$g(C, c)) n < e && 0 > $0086dc5fbe11e099$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $0086dc5fbe11e099$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $0086dc5fbe11e099$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $0086dc5fbe11e099$var$l = performance;
    $0086dc5fbe11e099$export$c4744153514ff05d = function() {
        return $0086dc5fbe11e099$var$l.now();
    };
} else {
    var $0086dc5fbe11e099$var$p = Date, $0086dc5fbe11e099$var$q = $0086dc5fbe11e099$var$p.now();
    $0086dc5fbe11e099$export$c4744153514ff05d = function() {
        return $0086dc5fbe11e099$var$p.now() - $0086dc5fbe11e099$var$q;
    };
}
var $0086dc5fbe11e099$var$r = [], $0086dc5fbe11e099$var$t = [], $0086dc5fbe11e099$var$u = 1, $0086dc5fbe11e099$var$v = null, $0086dc5fbe11e099$var$y = 3, $0086dc5fbe11e099$var$z = !1, $0086dc5fbe11e099$var$A = !1, $0086dc5fbe11e099$var$B = !1, $0086dc5fbe11e099$var$D = "function" === typeof setTimeout ? setTimeout : null, $0086dc5fbe11e099$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $0086dc5fbe11e099$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $0086dc5fbe11e099$var$G(a) {
    for(var b = $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$t); null !== b;){
        if (null === b.callback) $0086dc5fbe11e099$var$k($0086dc5fbe11e099$var$t);
        else if (b.startTime <= a) $0086dc5fbe11e099$var$k($0086dc5fbe11e099$var$t), b.sortIndex = b.expirationTime, $0086dc5fbe11e099$var$f($0086dc5fbe11e099$var$r, b);
        else break;
        b = $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$t);
    }
}
function $0086dc5fbe11e099$var$H(a) {
    $0086dc5fbe11e099$var$B = !1;
    $0086dc5fbe11e099$var$G(a);
    if (!$0086dc5fbe11e099$var$A) {
        if (null !== $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$r)) $0086dc5fbe11e099$var$A = !0, $0086dc5fbe11e099$var$I($0086dc5fbe11e099$var$J);
        else {
            var b = $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$t);
            null !== b && $0086dc5fbe11e099$var$K($0086dc5fbe11e099$var$H, b.startTime - a);
        }
    }
}
function $0086dc5fbe11e099$var$J(a, b) {
    $0086dc5fbe11e099$var$A = !1;
    $0086dc5fbe11e099$var$B && ($0086dc5fbe11e099$var$B = !1, $0086dc5fbe11e099$var$E($0086dc5fbe11e099$var$L), $0086dc5fbe11e099$var$L = -1);
    $0086dc5fbe11e099$var$z = !0;
    var c = $0086dc5fbe11e099$var$y;
    try {
        $0086dc5fbe11e099$var$G(b);
        for($0086dc5fbe11e099$var$v = $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$r); null !== $0086dc5fbe11e099$var$v && (!($0086dc5fbe11e099$var$v.expirationTime > b) || a && !$0086dc5fbe11e099$var$M());){
            var d = $0086dc5fbe11e099$var$v.callback;
            if ("function" === typeof d) {
                $0086dc5fbe11e099$var$v.callback = null;
                $0086dc5fbe11e099$var$y = $0086dc5fbe11e099$var$v.priorityLevel;
                var e = d($0086dc5fbe11e099$var$v.expirationTime <= b);
                b = $0086dc5fbe11e099$export$c4744153514ff05d();
                "function" === typeof e ? $0086dc5fbe11e099$var$v.callback = e : $0086dc5fbe11e099$var$v === $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$r) && $0086dc5fbe11e099$var$k($0086dc5fbe11e099$var$r);
                $0086dc5fbe11e099$var$G(b);
            } else $0086dc5fbe11e099$var$k($0086dc5fbe11e099$var$r);
            $0086dc5fbe11e099$var$v = $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$r);
        }
        if (null !== $0086dc5fbe11e099$var$v) var w = !0;
        else {
            var m = $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$t);
            null !== m && $0086dc5fbe11e099$var$K($0086dc5fbe11e099$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $0086dc5fbe11e099$var$v = null, $0086dc5fbe11e099$var$y = c, $0086dc5fbe11e099$var$z = !1;
    }
}
var $0086dc5fbe11e099$var$N = !1, $0086dc5fbe11e099$var$O = null, $0086dc5fbe11e099$var$L = -1, $0086dc5fbe11e099$var$P = 5, $0086dc5fbe11e099$var$Q = -1;
function $0086dc5fbe11e099$var$M() {
    return $0086dc5fbe11e099$export$c4744153514ff05d() - $0086dc5fbe11e099$var$Q < $0086dc5fbe11e099$var$P ? !1 : !0;
}
function $0086dc5fbe11e099$var$R() {
    if (null !== $0086dc5fbe11e099$var$O) {
        var a = $0086dc5fbe11e099$export$c4744153514ff05d();
        $0086dc5fbe11e099$var$Q = a;
        var b = !0;
        try {
            b = $0086dc5fbe11e099$var$O(!0, a);
        } finally{
            b ? $0086dc5fbe11e099$var$S() : ($0086dc5fbe11e099$var$N = !1, $0086dc5fbe11e099$var$O = null);
        }
    } else $0086dc5fbe11e099$var$N = !1;
}
var $0086dc5fbe11e099$var$S;
if ("function" === typeof $0086dc5fbe11e099$var$F) $0086dc5fbe11e099$var$S = function() {
    $0086dc5fbe11e099$var$F($0086dc5fbe11e099$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $0086dc5fbe11e099$var$T = new MessageChannel, $0086dc5fbe11e099$var$U = $0086dc5fbe11e099$var$T.port2;
    $0086dc5fbe11e099$var$T.port1.onmessage = $0086dc5fbe11e099$var$R;
    $0086dc5fbe11e099$var$S = function() {
        $0086dc5fbe11e099$var$U.postMessage(null);
    };
} else $0086dc5fbe11e099$var$S = function() {
    $0086dc5fbe11e099$var$D($0086dc5fbe11e099$var$R, 0);
};
function $0086dc5fbe11e099$var$I(a) {
    $0086dc5fbe11e099$var$O = a;
    $0086dc5fbe11e099$var$N || ($0086dc5fbe11e099$var$N = !0, $0086dc5fbe11e099$var$S());
}
function $0086dc5fbe11e099$var$K(a, b) {
    $0086dc5fbe11e099$var$L = $0086dc5fbe11e099$var$D(function() {
        a($0086dc5fbe11e099$export$c4744153514ff05d());
    }, b);
}
$0086dc5fbe11e099$export$3e506c1ccc9cc1a7 = 5;
$0086dc5fbe11e099$export$e26fe2ed2fa76875 = 1;
$0086dc5fbe11e099$export$502329bbf4b505b1 = 4;
$0086dc5fbe11e099$export$6e3807111c4874c4 = 3;
$0086dc5fbe11e099$export$c27134553091fb3a = null;
$0086dc5fbe11e099$export$33ee1acdc04fd2a2 = 2;
$0086dc5fbe11e099$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$0086dc5fbe11e099$export$8352ce38b91d0c62 = function() {
    $0086dc5fbe11e099$var$A || $0086dc5fbe11e099$var$z || ($0086dc5fbe11e099$var$A = !0, $0086dc5fbe11e099$var$I($0086dc5fbe11e099$var$J));
};
$0086dc5fbe11e099$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $0086dc5fbe11e099$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$0086dc5fbe11e099$export$d3dfb8e4810cb555 = function() {
    return $0086dc5fbe11e099$var$y;
};
$0086dc5fbe11e099$export$839f9183b0465a69 = function() {
    return $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$r);
};
$0086dc5fbe11e099$export$72fdf0e06517287b = function(a) {
    switch($0086dc5fbe11e099$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $0086dc5fbe11e099$var$y;
    }
    var c = $0086dc5fbe11e099$var$y;
    $0086dc5fbe11e099$var$y = b;
    try {
        return a();
    } finally{
        $0086dc5fbe11e099$var$y = c;
    }
};
$0086dc5fbe11e099$export$4b844e58a3e414b4 = function() {};
$0086dc5fbe11e099$export$816d2913ae6b83b1 = function() {};
$0086dc5fbe11e099$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $0086dc5fbe11e099$var$y;
    $0086dc5fbe11e099$var$y = a;
    try {
        return b();
    } finally{
        $0086dc5fbe11e099$var$y = c;
    }
};
$0086dc5fbe11e099$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $0086dc5fbe11e099$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $0086dc5fbe11e099$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $0086dc5fbe11e099$var$f($0086dc5fbe11e099$var$t, a), null === $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$r) && a === $0086dc5fbe11e099$var$h($0086dc5fbe11e099$var$t) && ($0086dc5fbe11e099$var$B ? ($0086dc5fbe11e099$var$E($0086dc5fbe11e099$var$L), $0086dc5fbe11e099$var$L = -1) : $0086dc5fbe11e099$var$B = !0, $0086dc5fbe11e099$var$K($0086dc5fbe11e099$var$H, c - d))) : (a.sortIndex = e, $0086dc5fbe11e099$var$f($0086dc5fbe11e099$var$r, a), $0086dc5fbe11e099$var$A || $0086dc5fbe11e099$var$z || ($0086dc5fbe11e099$var$A = !0, $0086dc5fbe11e099$var$I($0086dc5fbe11e099$var$J)));
    return a;
};
$0086dc5fbe11e099$export$b5836b71941fa3ed = $0086dc5fbe11e099$var$M;
$0086dc5fbe11e099$export$cf845f2c119da08a = function(a) {
    var b = $0086dc5fbe11e099$var$y;
    return function() {
        var c = $0086dc5fbe11e099$var$y;
        $0086dc5fbe11e099$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $0086dc5fbe11e099$var$y = c;
        }
    };
};

});



var $7a9adcfb845e594f$exports = {};
'use strict';

$7a9adcfb845e594f$exports = (parcelRequire("e2Upa"));


parcelRequire("1OEoy");
var $bb1dc4e9d49b5eb9$exports = {};

$parcel$export($bb1dc4e9d49b5eb9$exports, "createRoot", () => $bb1dc4e9d49b5eb9$export$882461b6382ed46c, (v) => $bb1dc4e9d49b5eb9$export$882461b6382ed46c = v);
$parcel$export($bb1dc4e9d49b5eb9$exports, "hydrateRoot", () => $bb1dc4e9d49b5eb9$export$757ceba2d55c277e, (v) => $bb1dc4e9d49b5eb9$export$757ceba2d55c277e = v);
var $bb1dc4e9d49b5eb9$export$882461b6382ed46c;
var $bb1dc4e9d49b5eb9$export$757ceba2d55c277e;
'use strict';
var $4ed43828a92c8386$exports = {};
'use strict';
function $4ed43828a92c8386$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4ed43828a92c8386$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4ed43828a92c8386$var$checkDCE();

$4ed43828a92c8386$exports = (parcelRequire("dllUs"));


var $bb1dc4e9d49b5eb9$var$i;
$bb1dc4e9d49b5eb9$export$882461b6382ed46c = $4ed43828a92c8386$exports.createRoot;
$bb1dc4e9d49b5eb9$export$757ceba2d55c277e = $4ed43828a92c8386$exports.hydrateRoot;


// App.js — marketing site shell

parcelRequire("1OEoy");



var $8266fa2b825a51ed$exports = {};

$parcel$export($8266fa2b825a51ed$exports, "IcAdd", () => $c7ecb6c6b4eb0727$export$27c4cbfb69a3e993);
$parcel$export($8266fa2b825a51ed$exports, "IcAddCircle", () => $6db879c1e09419b1$export$869af20d98048fdb);
$parcel$export($8266fa2b825a51ed$exports, "IcBarcode", () => $691044b0c34a7be6$export$a8e06849d04b5a6f);
$parcel$export($8266fa2b825a51ed$exports, "IcCalendar", () => $b13d2d402156a367$export$50599049b1f53719);
$parcel$export($8266fa2b825a51ed$exports, "IcCamera", () => $e2129836ebb52354$export$7e1befdbe52b3f32);
$parcel$export($8266fa2b825a51ed$exports, "IcCloseRemove", () => $6d68c299e9b46980$export$464f071bbd2cc5e5);
$parcel$export($8266fa2b825a51ed$exports, "IcConfirm", () => $99bdee47485fe43e$export$5753b5c18d35b7d0);
$parcel$export($8266fa2b825a51ed$exports, "IcCopy", () => $6419e697a0b924d8$export$d1bc6c264a68b09f);
$parcel$export($8266fa2b825a51ed$exports, "IcDownload", () => $96bc7f4d773a3e18$export$bb264a5644c93858);
$parcel$export($8266fa2b825a51ed$exports, "IcDownloads", () => $cbe53877f32ba0ff$export$7123f6ef4f453bfb);
$parcel$export($8266fa2b825a51ed$exports, "IcEdit", () => $e8050ad4c20fbd86$export$16866440f7f6c8dd);
$parcel$export($8266fa2b825a51ed$exports, "IcEditPen", () => $42c62b6a9ba5592f$export$55e8bf91189d440f);
$parcel$export($8266fa2b825a51ed$exports, "IcExport", () => $98a9500513f6ec1b$export$aca4755275c34537);
$parcel$export($8266fa2b825a51ed$exports, "IcFavorite", () => $a43bbac2ff101f65$export$cf9fe37d44aabb87);
$parcel$export($8266fa2b825a51ed$exports, "IcFilter", () => $814886bba6b1775a$export$26f46b9510140fcc);
$parcel$export($8266fa2b825a51ed$exports, "IcFlipCamera", () => $1df6d8e8ced21f82$export$f368e7c219601d0);
$parcel$export($8266fa2b825a51ed$exports, "IcForward", () => $747ccbe9daf0d6c0$export$78755581f96e0e89);
$parcel$export($8266fa2b825a51ed$exports, "IcFullscreenMode", () => $7eca50cd4239afef$export$bbb3e4be3b42bb9e);
$parcel$export($8266fa2b825a51ed$exports, "IcFullscreenModeOff", () => $17cfc90ae2de9172$export$65093953efbe81ce);
$parcel$export($8266fa2b825a51ed$exports, "IcImport", () => $20e9efde520c82f9$export$78b80e1f11d67211);
$parcel$export($8266fa2b825a51ed$exports, "IcLike", () => $67343847fd4d9baa$export$cbfc8e31e81d3925);
$parcel$export($8266fa2b825a51ed$exports, "IcMinimise", () => $e7e1fa10613e9848$export$28b4ffe30999880e);
$parcel$export($8266fa2b825a51ed$exports, "IcMinus", () => $794b0a9750aaf327$export$a112cdf9589f07b2);
$parcel$export($8266fa2b825a51ed$exports, "IcNotification", () => $6b80c1adff0f72e0$export$c69b4469075788f4);
$parcel$export($8266fa2b825a51ed$exports, "IcNotificationOff", () => $606a0fd28bc83369$export$184395fb225b1980);
$parcel$export($8266fa2b825a51ed$exports, "IcOpenWith", () => $e1392849da8d8cbc$export$8d8d10bea6cba17d);
$parcel$export($8266fa2b825a51ed$exports, "IcPaste", () => $54da603b76b9da9c$export$3ff4a916a5aef516);
$parcel$export($8266fa2b825a51ed$exports, "IcQrCode", () => $2718b73830c48ae3$export$b085f0ec027ff450);
$parcel$export($8266fa2b825a51ed$exports, "IcReply", () => $ca4a967fc5e1d34b$export$d8f8141123df49e9);
$parcel$export($8266fa2b825a51ed$exports, "IcReplyAll", () => $7fc5a8e99fd2c896$export$ee5a0a2b44c8bf7b);
$parcel$export($8266fa2b825a51ed$exports, "IcScanQrCode", () => $2bea6d457db8b4b4$export$b8634ccdc50979ab);
$parcel$export($8266fa2b825a51ed$exports, "IcSendMessage", () => $7df4d67d54324bf8$export$ea9aaa46ca2083e7);
$parcel$export($8266fa2b825a51ed$exports, "IcShare", () => $48a8893aeeee3d9c$export$d7bcdec678388771);
$parcel$export($8266fa2b825a51ed$exports, "IcSort", () => $625204e6f1a6410e$export$d802d08b192014d8);
$parcel$export($8266fa2b825a51ed$exports, "IcSwap", () => $71c5d87ca29e6de0$export$7d8d98dd3a766908);
$parcel$export($8266fa2b825a51ed$exports, "IcTag", () => $3686c16bf0cf1931$export$af82b8856b912f54);
$parcel$export($8266fa2b825a51ed$exports, "IcTime", () => $4047e04dc4873055$export$7f3df200d95b839b);
$parcel$export($8266fa2b825a51ed$exports, "IcTrash", () => $471b08974f7a128d$export$f4fff73cae16f2b9);
$parcel$export($8266fa2b825a51ed$exports, "IcUpload", () => $35c5404c6d8f57ee$export$7a525547346e73a);
$parcel$export($8266fa2b825a51ed$exports, "IcUpload1", () => $c2b1662e5a2e4dc7$export$904ccf4b059cd9b2);
$parcel$export($8266fa2b825a51ed$exports, "IcUploads", () => $df596e52606e517e$export$6a26d7605291833e);
$parcel$export($8266fa2b825a51ed$exports, "IcVisible", () => $7090174eb9addde4$export$fd7adc84612ab6c3);
$parcel$export($8266fa2b825a51ed$exports, "IcVisibleOff", () => $98a62f720950dd41$export$2deae51be13efc65);
$parcel$export($8266fa2b825a51ed$exports, "IcCard", () => $aa96d2fe3998f4fe$export$d4c35c8bf2c76a77);
$parcel$export($8266fa2b825a51ed$exports, "IcCart", () => $14ef6ea76ef49465$export$c7056e444d073e5f);
$parcel$export($8266fa2b825a51ed$exports, "IcCcv", () => $92edf326d99c1b79$export$626a5c1c628bf04f);
$parcel$export($8266fa2b825a51ed$exports, "IcJiopay", () => $151a046508ce2d0f$export$ba660c68f7598614);
$parcel$export($8266fa2b825a51ed$exports, "IcRupee", () => $7e38ccbfe608a2c6$export$39cc7d72735656c0);
$parcel$export($8266fa2b825a51ed$exports, "IcRupeeCoin", () => $d508e383127c2099$export$300912d25f93283a);
$parcel$export($8266fa2b825a51ed$exports, "IcLock", () => $0175d553cb151df2$export$445280d67fff5a51);
$parcel$export($8266fa2b825a51ed$exports, "IcAlert", () => $3f5cfec34b132e68$export$eb2e66ed6f7f4580);
$parcel$export($8266fa2b825a51ed$exports, "IcError", () => $1c9354d0d60fcfed$export$7e7b259dce3cfe53);
$parcel$export($8266fa2b825a51ed$exports, "IcErrorColored", () => $f0c43238eeefce3e$export$ed1619aa732c6643);
$parcel$export($8266fa2b825a51ed$exports, "IcExclamation", () => $9eab183eb59aa25c$export$58992a8aa3d7330d);
$parcel$export($8266fa2b825a51ed$exports, "IcHelp", () => $4902c677c0575784$export$efe9dd4bbd32421a);
$parcel$export($8266fa2b825a51ed$exports, "IcInfo", () => $8944871133dad5b7$export$556fe0871d9b7899);
$parcel$export($8266fa2b825a51ed$exports, "IcMessageSend", () => $cdf1a650bff6bf19$export$cc2840fa1985b883);
$parcel$export($8266fa2b825a51ed$exports, "IcSmileyHappy", () => $a95d9682fc4c9e06$export$f528a1ee477aaf33);
$parcel$export($8266fa2b825a51ed$exports, "IcSmileyUnhappy", () => $a459cbc5e7ada433$export$b675dff6d0b6c0c8);
$parcel$export($8266fa2b825a51ed$exports, "IcStar", () => $3607434377c99614$export$e5c12eca07fe7b2d);
$parcel$export($8266fa2b825a51ed$exports, "IcSuccess", () => $044eb39f59e3c768$export$13b8539f4be0c);
$parcel$export($8266fa2b825a51ed$exports, "IcSuccessColored", () => $a80d6d0eaf25f114$export$50c1b72d39add9);
$parcel$export($8266fa2b825a51ed$exports, "IcWarning", () => $e2a4237d1a3a760e$export$ff711dd56629d4f5);
$parcel$export($8266fa2b825a51ed$exports, "IcWarningColored", () => $9802b0598e6eade4$export$47407925ae9f1f0e);
$parcel$export($8266fa2b825a51ed$exports, "IcJioDot", () => $04fc5138b12d9c4c$export$faf9e552d710fc5c);
$parcel$export($8266fa2b825a51ed$exports, "IcJioDotExclude", () => $d2d28755d5ad7779$export$b15d2693bd1dee35);
$parcel$export($8266fa2b825a51ed$exports, "IcJioDotJiofinanceColoured", () => $9ce4cb0b2f9af6e2$export$3d9cd62ef287ff59);
$parcel$export($8266fa2b825a51ed$exports, "IcLocation", () => $6b25bcc26768ed00$export$d586aed94de44e82);
$parcel$export($8266fa2b825a51ed$exports, "IcLocationOff", () => $27bb06ea2a133495$export$8fe68ed1b5ac245c);
$parcel$export($8266fa2b825a51ed$exports, "IcMap", () => $1bdf61761478cf0f$export$af0a72b1e9c547c5);
$parcel$export($8266fa2b825a51ed$exports, "IcMyLocation", () => $82721b8275f2c860$export$51e681bf0729a333);
$parcel$export($8266fa2b825a51ed$exports, "IcBrokenImage", () => $d7d0ad31bc9eab74$export$58f9be5875231b2);
$parcel$export($8266fa2b825a51ed$exports, "IcImage", () => $2f0551663e33dca4$export$4736cab3fc47e2fb);
$parcel$export($8266fa2b825a51ed$exports, "IcMic", () => $8b88f021ab770504$export$c1c61a3da2c48ae4);
$parcel$export($8266fa2b825a51ed$exports, "IcMicOff", () => $a5853f803d552460$export$4f5b8d1e98c25c06);
$parcel$export($8266fa2b825a51ed$exports, "IcPause", () => $62493db4f6ef3ca5$export$1eb29c5f2b0051d3);
$parcel$export($8266fa2b825a51ed$exports, "IcPlay", () => $2257b9c2d70e9d81$export$a93378bd68e53d32);
$parcel$export($8266fa2b825a51ed$exports, "IcAppSwitcher", () => $0094dacb13fcf2c4$export$af0536a50732761b);
$parcel$export($8266fa2b825a51ed$exports, "IcArrowBack", () => $d915ff7f98751614$export$aed2803299c2cf67);
$parcel$export($8266fa2b825a51ed$exports, "IcArrowNext", () => $a3134278bf70d277$export$a1075cdfac2f932);
$parcel$export($8266fa2b825a51ed$exports, "IcBack", () => $4032b58bf1d5d7fe$export$740276c76f223dd4);
$parcel$export($8266fa2b825a51ed$exports, "IcBurgerMenu", () => $cc6848bbab622908$export$3bb087c30947880a);
$parcel$export($8266fa2b825a51ed$exports, "IcChevronDown", () => $ba8f011ee84a4198$export$ec7db1c418c1ec5a);
$parcel$export($8266fa2b825a51ed$exports, "IcChevronLeft", () => $0ccf729272393be8$export$8203b8a87ae185f);
$parcel$export($8266fa2b825a51ed$exports, "IcChevronRight", () => $ce50cd91d91f3ae0$export$a477256bf52ac2f7);
$parcel$export($8266fa2b825a51ed$exports, "IcChevronUp", () => $820b24444175a496$export$acd925e63e14000f);
$parcel$export($8266fa2b825a51ed$exports, "IcClose", () => $d3033cfe8927e2c5$export$48672c81f0c3f574);
$parcel$export($8266fa2b825a51ed$exports, "IcFirstpage", () => $0f67a5a3d97e81e5$export$885ccec48f920b92);
$parcel$export($8266fa2b825a51ed$exports, "IcHome", () => $de50ab7a6c97ce62$export$10426ed6ef0ab637);
$parcel$export($8266fa2b825a51ed$exports, "IcLastpage", () => $9615fde781fa655e$export$1093b8f29e1cf10c);
$parcel$export($8266fa2b825a51ed$exports, "IcLogin", () => $4a7261da942522da$export$a883bfa83ec843c8);
$parcel$export($8266fa2b825a51ed$exports, "IcLogout", () => $e7902526201c79a0$export$5c4cc728e7726d4e);
$parcel$export($8266fa2b825a51ed$exports, "IcMoreHorizontal", () => $4effb7c98fe0d40c$export$f6c2e7c657f578c5);
$parcel$export($8266fa2b825a51ed$exports, "IcMoreVertical", () => $1a905b1845db701d$export$76eade3e6c39fefd);
$parcel$export($8266fa2b825a51ed$exports, "IcNext", () => $75c74d0c8e1efe40$export$17beb55fda7072f9);
$parcel$export($8266fa2b825a51ed$exports, "IcSearch", () => $ae6e96cf340a1d1b$export$6da2c307edd95198);
$parcel$export($8266fa2b825a51ed$exports, "IcSettings", () => $d70a770cb3158481$export$f7d6d35bb50c6222);
$parcel$export($8266fa2b825a51ed$exports, "IcProfile", () => $5b77d69d5620f0fd$export$8c6932a2fedd46e4);
$parcel$export($8266fa2b825a51ed$exports, "IcUser", () => $c8f36c5b30a998b4$export$255f0ef2dfc5eb49);

const $c7ecb6c6b4eb0727$export$27c4cbfb69a3e993 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20 11h-7V4a1 1 0 00-2 0v7H4a1 1 0 000 2h7v7a1 1 0 002 0v-7h7a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $6db879c1e09419b1$export$869af20d98048fdb = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 11h-3v3a1 1 0 01-2 0v-3H8a1 1 0 010-2h3V8a1 1 0 012 0v3h3a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $691044b0c34a7be6$export$a8e06849d04b5a6f = (v)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M7 20H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zM8 7a1 1 0 00-1 1v8a1 1 0 102 0V8a1 1 0 00-1-1zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm9-1a1 1 0 00-1 1v8a1 1 0 002 0V8a1 1 0 00-1-1zm9 9a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zm-4 0V8a1 1 0 00-2 0v8a1 1 0 002 0z",
            fill: "currentColor"
        })
    });



const $b13d2d402156a367$export$50599049b1f53719 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M18 3h-1a1 1 0 00-2 0H9a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-4.5 14a1 1 0 01-2 0v-3.59l-.29.3a1.004 1.004 0 11-1.42-1.42l2-2a.999.999 0 011.09-.21 1 1 0 01.62.92v6zM19 7H5V6a1 1 0 011-1h1a1 1 0 002 0h6a1 1 0 002 0h1a1 1 0 011 1v1z",
            fill: "currentColor"
        })
    });



const $e2129836ebb52354$export$7e1befdbe52b3f32 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M19 7h-.9a1 1 0 01-.84-.47l-1-1.6a2 2 0 00-1.7-.93H9.44a2 2 0 00-1.69.93l-1 1.6A1 1 0 015.9 7H5a3 3 0 00-3 3v7a3 3 0 003 3h14a3 3 0 003-3v-7a3 3 0 00-3-3zm-7 9a3 3 0 110-5.999A3 3 0 0112 16z",
            fill: "currentColor"
        })
    });



const $6d68c299e9b46980$export$464f071bbd2cc5e5 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
            fill: "currentColor"
        })
    });



const $99bdee47485fe43e$export$5753b5c18d35b7d0 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
            fill: "currentColor"
        })
    });



const $6419e697a0b924d8$export$d1bc6c264a68b09f = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M13 8H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-8a3 3 0 00-3-3zm6-6h-8a3 3 0 00-3 3v1h5a5 5 0 015 5v5h1a3 3 0 003-3V5a3 3 0 00-3-3z",
            fill: "currentColor"
        })
    });



const $96bc7f4d773a3e18$export$bb264a5644c93858 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M16 20H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zM16.71 10.29a.996.996 0 00-1.41 0l-2.29 2.29V4.99c0-.55-.45-1-1-1s-1 .45-1 1v7.59l-2.29-2.29a.996.996 0 10-1.41 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41h-.02z",
            fill: "currentColor"
        })
    });



const $cbe53877f32ba0ff$export$7123f6ef4f453bfb = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M22 12a10 10 0 10-20 0 10 10 0 0020 0zm-10.71 4.71l-3-3a1.001 1.001 0 01.325-1.639 1 1 0 011.095.219l1.29 1.3V8a1 1 0 012 0v5.59l1.29-1.3a1.004 1.004 0 111.42 1.42l-3 3a1 1 0 01-.33.21 1 1 0 01-.76 0 1.001 1.001 0 01-.33-.21z",
            fill: "currentColor"
        })
    });



const $e8050ad4c20fbd86$export$16866440f7f6c8dd = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M11.06 10.82l-.62.62A1.51 1.51 0 0010 12.5V14h1.5a1.51 1.51 0 001.06-.44l.62-.62 7.38-7.38a1.5 1.5 0 10-2.12-2.12l-7.38 7.38zM11.5 16H8v-3.5A3.49 3.49 0 019 10l7-7H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V8l-7 7a3.487 3.487 0 01-2.5 1z",
            fill: "currentColor"
        })
    });



const $42c62b6a9ba5592f$export$55e8bf91189d440f = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M19.5 4.5a3.54 3.54 0 00-5 0l-.29.29 5 5 .29-.29a3.54 3.54 0 000-5zm-13.95 9a3 3 0 00-.76 1.3l-1 3.65a1.5 1.5 0 001.81 1.81l3.65-1.05a3 3 0 001.3-.76l7.24-7.24-5-5-7.24 7.29z",
            fill: "currentColor"
        })
    });



const $98a9500513f6ec1b$export$aca4755275c34537 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M9.71 6.71L11 5.41V16a1 1 0 102 0V5.41l1.29 1.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-3-3a1 1 0 00-1.42 0l-3 3a1.004 1.004 0 001.42 1.42zM20 12a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1v-6a1 1 0 00-2 0v6a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $a43bbac2ff101f65$export$cf9fe37d44aabb87 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M15.6 4A5.6 5.6 0 0012 5.46 5.6 5.6 0 008.4 4 5.36 5.36 0 003 9.44c0 3.37 2.63 6.43 7.16 10.56l.49.45a2 2 0 002.7 0l.49-.44C18.37 15.86 21 12.8 21 9.44A5.36 5.36 0 0015.6 4z",
            fill: "currentColor"
        })
    });



const $814886bba6b1775a$export$26f46b9510140fcc = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M17 11H7a1 1 0 000 2h10a1 1 0 000-2zm-3 6h-4a1 1 0 000 2h4a1 1 0 000-2zm6-12H4a1 1 0 000 2h16a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $1df6d8e8ced21f82$export$f368e7c219601d0 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.12 7.88A2.99 2.99 0 0019 7h-.9c-.17 0-.34-.05-.48-.13a.908.908 0 01-.36-.34l-1-1.6c-.19-.29-.44-.52-.73-.69-.3-.16-.64-.24-.97-.24H9.44c-.34 0-.67.08-.97.25-.29.16-.54.39-.72.68l-1 1.6c-.09.14-.22.26-.37.34-.15.09-.31.13-.48.13H5c-.8 0-1.56.31-2.13.88C2.3 8.45 2 9.2 2 10v7c0 .79.31 1.56.87 2.12.57.56 1.33.88 2.13.88h14c.79 0 1.55-.32 2.12-.88.56-.56.88-1.33.88-2.12v-7c0-.8-.32-1.56-.88-2.12zM8 16c-.26 0-.51-.1-.71-.29l-2-2A.996.996 0 116.7 12.3l.33.33c.2-2.58 2.33-4.62 4.96-4.62.39 0 .8.06 1.25.17.53.14.85.68.72 1.22-.14.54-.69.85-1.22.72a3.16 3.16 0 00-.75-.11c-1.5 0-2.73 1.1-2.95 2.54l.25-.25a.996.996 0 111.41 1.41l-2 2c-.2.2-.45.29-.71.29H8zm10.71-2.29c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-.33-.33C16.76 15.96 14.63 18 12 18c-.39 0-.8-.06-1.25-.17-.53-.14-.85-.68-.72-1.22.14-.54.68-.85 1.22-.72.29.07.52.11.75.11 1.5 0 2.73-1.1 2.95-2.54l-.25.25a.996.996 0 11-1.41-1.41l2-2a.996.996 0 011.41 0l2 2c.39.39.39 1.02 0 1.41h.01z",
            fill: "currentColor"
        })
    });



const $747ccbe9daf0d6c0$export$78755581f96e0e89 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.41 9.59l-5-5a2 2 0 00-2.18-.44A2 2 0 0013 6v2S2.75 9.86 2 19.84A1.09 1.09 0 003.07 21a1.08 1.08 0 001-.78C4.68 18.39 6.67 14 13 14v2a2 2 0 001.23 1.85 2 2 0 002.18-.44l5-5a2 2 0 000-2.82z",
            fill: "currentColor"
        })
    });



const $7eca50cd4239afef$export$bbb3e4be3b42bb9e = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.92 13.38c-.15.37-.52.62-.92.62H9c-.55 0-1-.45-1-1v-3c0-.4.24-.77.62-.92.38-.16.8-.07 1.09.22l3 3c.29.29.37.72.22 1.09l-.01-.01zM16 12c0 .4-.24.77-.62.92a.995.995 0 01-1.09-.21l-3-3c-.29-.29-.37-.72-.22-1.09.15-.37.52-.62.92-.62h3c.55 0 1 .45 1 1v3H16z",
            fill: "currentColor"
        })
    });



const $17cfc90ae2de9172$export$65093953efbe81ce = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-.5 14.5c0 .4-.24.77-.62.92a.995.995 0 01-1.09-.21l-3-3c-.29-.29-.37-.72-.22-1.09.15-.37.52-.62.92-.62h3c.55 0 1 .45 1 1v3h.01zm5.92-5.62c-.15.37-.52.62-.92.62h-3c-.55 0-1-.45-1-1v-3c0-.4.24-.77.62-.92.38-.16.8-.07 1.09.22l3 3c.29.29.37.72.22 1.09l-.01-.01z",
            fill: "currentColor"
        })
    });



const $20e9efde520c82f9$export$78b80e1f11d67211 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M11.29 16.71a1.002 1.002 0 001.42 0l3-3a1.004 1.004 0 10-1.42-1.42L13 13.59V3a1 1 0 00-2 0v10.59l-1.29-1.3a1.004 1.004 0 10-1.42 1.42l3 3zM20 12a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1v-6a1 1 0 10-2 0v6a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1z",
            fill: "currentColor"
        })
    });



const $67343847fd4d9baa$export$cbfc8e31e81d3925 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M3 11v7a2 2 0 002 2h2V9H5a2 2 0 00-2 2zm17.24-1A3 3 0 0018 9h-4V5.08a2 2 0 00-3.94-.57l-1 4A2.12 2.12 0 009 9v11h8.44a3 3 0 003-2.67l.55-5a2.999 2.999 0 00-.75-2.33z",
            fill: "currentColor"
        })
    });



const $e7e1fa10613e9848$export$28b4ffe30999880e = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 11H8a1 1 0 010-2h8a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $794b0a9750aaf327$export$a112cdf9589f07b2 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M3.293 11.293A1 1 0 014 11h16a1 1 0 010 2H4a1 1 0 01-.707-1.707z",
            fill: "currentColor"
        })
    });



const $6b80c1adff0f72e0$export$c69b4469075788f4 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21 16h-1v-6a8 8 0 00-16 0v6H3a1 1 0 000 2h18a1 1 0 000-2zm-9 6a3 3 0 003-3H9a3 3 0 003 3z",
            fill: "currentColor"
        })
    });



const $606a0fd28bc83369$export$184395fb225b1980 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a8 8 0 00-8 8v5.76L16.42 3.34A7.89 7.89 0 0012 2zm9 14h-1v-6a8.001 8.001 0 00-.89-3.66L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49L7.44 18H21a1 1 0 100-2zm-9 6a3 3 0 003-3H9a3 3 0 003 3z",
            fill: "currentColor"
        })
    });



const $e1392849da8d8cbc$export$8d8d10bea6cba17d = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20 11a1 1 0 00-1 1v6a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h6a1 1 0 100-2H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3v-6a1 1 0 00-1-1zm.92-7.38a1 1 0 00-.54-.54A1 1 0 0020 3h-4a1 1 0 100 2h1.59l-6.3 6.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219L19 6.41V8a1 1 0 002 0V4a1.001 1.001 0 00-.08-.38z",
            fill: "currentColor"
        })
    });



const $54da603b76b9da9c$export$3ff4a916a5aef516 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M19 2h-8a3 3 0 00-3 3v3H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-3h3a3 3 0 003-3V5a3 3 0 00-3-3zm1 11a1 1 0 01-1 1h-3v-3a3 3 0 00-3-3h-3V5a1 1 0 011-1h8a1 1 0 011 1v8z",
            fill: "currentColor"
        })
    });



const $2718b73830c48ae3$export$b085f0ec027ff450 = (h)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M7 15H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm5-6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm7-6h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 9h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2zm14 2h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm1 8h-7v-6c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1h7v6c0 1.1.9 2 2 2h7c.55 0 1-.45 1-1s-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $ca4a967fc5e1d34b$export$d8f8141123df49e9 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M2.59 9.59l5-5a2 2 0 012.18-.44A2 2 0 0111 6v2s10.25 1.86 11 11.84A1.09 1.09 0 0120.93 21a1.08 1.08 0 01-1-.78C19.32 18.39 17.33 14 11 14v2a2 2 0 01-1.23 1.85 2 2 0 01-2.18-.44l-5-5a2 2 0 010-2.82z",
            fill: "currentColor"
        })
    });



const $7fc5a8e99fd2c896$export$ee5a0a2b44c8bf7b = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M11 9V7a2 2 0 00-1.23-1.85 2 2 0 00-2.18.44l-5 5a2 2 0 000 2.82l5 5a2 2 0 002.18.44A2 2 0 0011 17v-2c6.33 0 8.32 4.39 8.85 6.22a1.08 1.08 0 001 .78A1.09 1.09 0 0022 20.84C21.25 10.86 11 9 11 9zm2-2v.44a16.37 16.37 0 019 6.81v-.14c-.57-7.63-8.41-9-8.41-9V3.53A1.53 1.53 0 0011 2.45l-.76.76c.1 0 .21 0 .31.09A4 4 0 0113 7z",
            fill: "currentColor"
        })
    });



const $2bea6d457db8b4b4$export$b8634ccdc50979ab = (h)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...h,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M6 7v2a1 1 0 001 1h2a1 1 0 001-1V7a1 1 0 00-1-1H7a1 1 0 00-1 1zM3 8a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 000-2H5a3 3 0 00-3 3v2a1 1 0 001 1zm9 2a1 1 0 001-1V7a1 1 0 00-2 0v2a1 1 0 001 1zm3 5h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zm0-5h2a1 1 0 001-1V7a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zm6 6a1 1 0 00-1 1v2a1 1 0 01-1 1h-2a1 1 0 000 2h2a3 3 0 003-3v-2a1 1 0 00-1-1zM19 2h-2a1 1 0 100 2h2a1 1 0 011 1v2a1 1 0 002 0V5a3 3 0 00-3-3zm-1 15a1 1 0 00-1-1h-4v-4a1 1 0 00-1-1H7a1 1 0 000 2h4v4a1 1 0 001 1h5a1 1 0 001-1zm-9-3H7a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1zm-2 6H5a1 1 0 01-1-1v-2a1 1 0 10-2 0v2a3 3 0 003 3h2a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $7df4d67d54324bf8$export$ea9aaa46ca2083e7 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M19.79 10.16l-14-6A2 2 0 005 4a2 2 0 00-1.965 2.398 2 2 0 00.355.792L6.76 12l-3.35 4.79a2 2 0 002.38 3.05l14-6a2 2 0 000-3.68z",
            fill: "currentColor"
        })
    });



const $48a8893aeeee3d9c$export$d7bcdec678388771 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M18 15a3 3 0 00-2.15.91L8 12.27c.005-.09.005-.18 0-.27.005-.09.005-.18 0-.27l7.88-3.64A3 3 0 1015 6c-.005.09-.005.18 0 .27L7.15 9.91a3 3 0 100 4.18L15 17.73c-.005.09-.005.18 0 .27a3 3 0 103-3z",
            fill: "currentColor"
        })
    });



const $625204e6f1a6410e$export$d802d08b192014d8 = (a)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M10.29 14.29L8 16.59V6a1 1 0 00-2 0v10.59l-2.29-2.3a1.004 1.004 0 00-1.42 1.42l4 4a.998.998 0 001.42 0l4-4a1 1 0 000-1.42 1.002 1.002 0 00-1.42 0zm11.42-6l-4-4a1 1 0 00-1.42 0l-4 4a1 1 0 00.326 1.639 1 1 0 001.094-.22L16 7.41V18a1 1 0 102 0V7.41l2.29 2.3a1.004 1.004 0 001.42-1.42z",
            fill: "currentColor"
        })
    });



const $71c5d87ca29e6de0$export$7d8d98dd3a766908 = (a)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M9 12a1.002 1.002 0 001.006-1 1 1 0 00-.296-.71L7.41 8H18a1 1 0 100-2H7.41l2.3-2.29a1.004 1.004 0 10-1.42-1.42l-4 4a1 1 0 000 1.42l4 4A1 1 0 009 12zm10.71 4.29l-4-4a1 1 0 00-1.42 0 1 1 0 000 1.42l2.3 2.29H6a1 1 0 100 2h10.59l-2.3 2.29a1.004 1.004 0 101.42 1.42l4-4a.999.999 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $3686c16bf0cf1931$export$af82b8856b912f54 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M22 10.53l-.7-5.24a3 3 0 00-2.59-2.59L13.47 2a3 3 0 00-2.5.86L2.88 11a3 3 0 000 4.24l5.91 5.91a3 3 0 004.24 0L21.12 13a3.052 3.052 0 00.88-2.47zM16.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $4047e04dc4873055$export$7f3df200d95b839b = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm1 11a1 1 0 01-1 1H9a1 1 0 010-2h2V9a1 1 0 012 0v4z",
            fill: "currentColor"
        })
    });



const $471b08974f7a128d$export$f4fff73cae16f2b9 = (v)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...v,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20 6h-2V5a3 3 0 00-3-3H9a3 3 0 00-3 3v1H4a1 1 0 000 2h1v11a3 3 0 003 3h8a3 3 0 003-3V8h1a1 1 0 100-2zM9 18a1 1 0 11-2 0v-7a1 1 0 112 0v7zm4 0a1 1 0 01-2 0v-7a1 1 0 012 0v7zm4 0a1 1 0 01-2 0v-7a1 1 0 012 0v7zM8 5a1 1 0 011-1h6a1 1 0 011 1v1H8V5z",
            fill: "currentColor"
        })
    });



const $35c5404c6d8f57ee$export$7a525547346e73a = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M7.71 8.71L11 5.41V17a1 1 0 102 0V5.41l3.29 3.3a.999.999 0 001.42 0 1.001 1.001 0 000-1.42l-5-5a1 1 0 00-1.42 0l-5 5a1.004 1.004 0 101.42 1.42zM17 20H7a1 1 0 000 2h10a1 1 0 100-2z",
            fill: "currentColor"
        })
    });



const $c2b1662e5a2e4dc7$export$904ccf4b059cd9b2 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M17 9h-1a1 1 0 100 2h1a1 1 0 011 1v7a1 1 0 01-1 1H7a1 1 0 01-1-1v-7a1 1 0 011-1h1a1 1 0 100-2H7a3 3 0 00-3 3v7a3 3 0 003 3h10a3 3 0 003-3v-7a3 3 0 00-3-3zM9.71 6.71L11 5.41V16a1 1 0 102 0V5.41l1.29 1.3a1 1 0 001.639-.325 1 1 0 00-.219-1.095l-3-3a1 1 0 00-1.42 0l-3 3a1.004 1.004 0 001.42 1.42z",
            fill: "currentColor"
        })
    });



const $df596e52606e517e$export$6a26d7605291833e = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M2 12a10 10 0 1020 0 10 10 0 00-20 0zm10.71-4.71l3 3a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L13 10.41V16a1 1 0 01-2 0v-5.59l-1.29 1.3a1.004 1.004 0 11-1.42-1.42l3-3a1 1 0 01.33-.21 1 1 0 01.76 0 1 1 0 01.33.21z",
            fill: "currentColor"
        })
    });



const $7090174eb9addde4$export$fd7adc84612ab6c3 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.69 10.74A10.87 10.87 0 0012 5a10.87 10.87 0 00-9.69 5.74 2.74 2.74 0 000 2.52A10.87 10.87 0 0012 19a10.87 10.87 0 009.69-5.74 2.74 2.74 0 000-2.52zm-9.1 4.2a3 3 0 11-1.183-5.881 3 3 0 011.183 5.881z",
            fill: "currentColor"
        })
    });



const $98a62f720950dd41$export$2deae51be13efc65 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.69 10.74A10.539 10.539 0 0018.41 7l-3.7 3.69a3 3 0 01-4 4L20.49 5a1.052 1.052 0 00-.342-1.719A1.053 1.053 0 0019 3.51L3.51 19a1.052 1.052 0 001.148 1.718c.128-.053.244-.13.342-.228L7.42 18c1.439.652 3 .993 4.58 1a10.87 10.87 0 009.69-5.74 2.74 2.74 0 000-2.52zm-7.23-5.45A11 11 0 0012 5a10.87 10.87 0 00-9.69 5.74 2.74 2.74 0 000 2.52c.469.889 1.061 1.707 1.76 2.43l10.39-10.4z",
            fill: "currentColor"
        })
    });



const $aa96d2fe3998f4fe$export$d4c35c8bf2c76a77 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v2h20V7a2 2 0 00-2-2zM2 17a2 2 0 002 2h16a2 2 0 002-2v-6H2v6zm3-2h3a1 1 0 010 2H5a1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $14ef6ea76ef49465$export$c7056e444d073e5f = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M8.5 19a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm4.12-12.17A2 2 0 0020 6H6.58l-.41-1.52A2 2 0 004.23 3H3a1 1 0 000 2h1.23l2.83 10.48A2 2 0 009 17h8.67a2 2 0 001.89-1.37l2.34-7a2 2 0 00-.28-1.8z",
            fill: "currentColor"
        })
    });



const $92edf326d99c1b79$export$626a5c1c628bf04f = (a)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20 5H4a2 2 0 00-2 2v2h20V7a2 2 0 00-2-2zM2 17a2 2 0 002 2h16a2 2 0 002-2v-6H2v6zm17-4a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2zm-3 0a1 1 0 110 2 1 1 0 010-2z",
            fill: "currentColor"
        })
    });



const $151a046508ce2d0f$export$ba660c68f7598614 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 5.523-4.477 10-10 10-4.478 0-8.268-2.943-9.542-7H6a1 1 0 100-2H2.05a10.118 10.118 0 010-2H14a1 1 0 100-2H2.458c.22-.703.517-1.373.88-2H11a1 1 0 100-2H4.859A9.97 9.97 0 0112 2c5.523 0 10 4.477 10 10z",
            fill: "currentColor"
        })
    });



const $7e38ccbfe608a2c6$export$39cc7d72735656c0 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M17 8h-2.1c-.15-.74-.47-1.42-.91-2H17c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h3a3 3 0 012.82 2H7c-.55 0-1 .45-1 1s.45 1 1 1h5.83a3.001 3.001 0 01-2.81 2H7s-.07 0-.11.01h-.05c-.05 0-.09.02-.14.03-.02 0-.03 0-.05.01-.04.02-.09.04-.13.06-.02 0-.03.02-.05.03-.04.02-.08.05-.11.08-.02.01-.03.02-.05.04l-.1.1c0 .01-.02.02-.03.03v.01c-.03.04-.05.08-.07.12l-.03.06c-.01.03-.03.07-.04.1 0 .03-.02.06-.03.09 0 .03 0 .05-.01.08 0 .04-.01.08-.01.12v.07c0 .04 0 .09.01.13 0 .02.01.04.02.06.01.04.02.08.04.13 0 .02.02.04.02.05.02.04.04.08.07.12 0 .01.02.03.03.04.03.04.06.08.09.11.01.01.02.02.04.03.03.02.05.05.08.07l8 6c.18.14.39.2.6.2.3 0 .6-.14.8-.4.33-.44.24-1.07-.2-1.4l-5.6-4.2c2.41 0 4.43-1.72 4.9-4h2.1c.55 0 1-.45 1-1s-.45-1-1-1L17 8z",
            fill: "currentColor"
        })
    });



const $d508e383127c2099$export$300912d25f93283a = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm4 8a1 1 0 010 2h-1.14a4 4 0 01-2.61 2.78l2.26 1.36a1 1 0 01-1.02 1.72l-5-3s-.06-.06-.09-.08a.67.67 0 01-.15-.14l-.11-.15a1 1 0 01-.08-.18 1.18 1.18 0 010-.2L8 14v-.07a1.29 1.29 0 010-.19c.017-.065.04-.129.07-.19v-.06c0-.06.06-.06.08-.09a.91.91 0 01.3-.26l.16-.08h.21L9 13h2a2 2 0 001.72-1H8a1 1 0 010-2h4.72A2 2 0 0011 9H8a1 1 0 010-2h8a1 1 0 110 2h-1.56c.187.312.328.649.42 1H16z",
            fill: "currentColor"
        })
    });



const $0175d553cb151df2$export$445280d67fff5a51 = (a)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M17 7h-1V6a4 4 0 10-8 0v1H7a3 3 0 00-3 3v9a3 3 0 003 3h10a3 3 0 003-3v-9a3 3 0 00-3-3zm-5 9a2 2 0 110-4 2 2 0 010 4zm2-9h-4V6a2 2 0 114 0v1z",
            fill: "currentColor"
        })
    });



const $3f5cfec34b132e68$export$eb2e66ed6f7f4580 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.74 18l-8-14a2 2 0 00-3.48 0l-8 14A2 2 0 004 21h16a2 2 0 001.74-3zM11 7a1 1 0 012 0v6a1 1 0 11-2 0V7zm1 12a1.5 1.5 0 110-2.999 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $1c9354d0d60fcfed$export$7e7b259dce3cfe53 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
            fill: "currentColor"
        })
    });



const $f0c43238eeefce3e$export$ed1619aa732c6643 = (i)=>(0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7a9adcfb845e594f$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.71 12.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219L12 13.41l-2.29 2.3a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29-2.3-2.29a1.004 1.004 0 011.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 011.42 1.42L13.41 12l2.3 2.29z",
                fill: "#F50031"
            })
        ]
    });



const $9eab183eb59aa25c$export$58992a8aa3d7330d = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 17a1 1 0 001-1V3a1 1 0 00-2 0v13a1 1 0 001 1zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $4902c677c0575784$export$efe9dd4bbd32421a = (c)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12.095 1.617c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5zm.685 14.378a.73.73 0 01-.723.732h-.055a.728.728 0 01-.722-.732v-.035a.73.73 0 01.722-.733h.055c.398 0 .723.328.723.733v.035zm1.28-4.213c-.34.38-.748.705-1.04 1.125-.153.22-.163.185-.258.443-.077.21-.03.5-.14.705-.177.33-.545.427-.895.28-.41-.175-.472-.588-.445-.985.03-.453.1-.645.325-1.048.215-.382.533-.69.835-1 .51-.522 1.28-1.435.448-2.067-.733-.558-1.728-.145-1.925.715-.09.392-.22.732-.613.862-.292.098-.605.028-.787-.222-.48-.658.137-1.835.625-2.32 1.247-1.243 3.74-.938 4.415.767l-.008-.017c-.017-.04-.025-.065-.027-.073.002.01.015.04.027.073l.008.017.032.085c-.005-.012-.017-.047-.032-.082.395.987.147 1.97-.545 2.742z",
            fill: "currentColor"
        })
    });



const $8944871133dad5b7$export$556fe0871d9b7899 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm2 12h-4a1 1 0 010-2h1v-3h-1a1 1 0 010-2h2a1 1 0 011 1v4h1a1 1 0 010 2z",
            fill: "currentColor"
        })
    });



const $cdf1a650bff6bf19$export$cc2840fa1985b883 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M9 19a1.002 1.002 0 01-.71-.29l-5-5a1.004 1.004 0 111.42-1.42L9 16.59l10.29-10.3a1.004 1.004 0 111.42 1.42l-11 11A1 1 0 019 19z",
            fill: "currentColor"
        })
    });



const $a95d9682fc4c9e06$export$f528a1ee477aaf33 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.58 7.16a5.77 5.77 0 01-.78 1 .472.472 0 01-.06.09 5.617 5.617 0 01-.7.59 5.769 5.769 0 01-1.95.94h-.16a4.515 4.515 0 01-.53.11H11.12a4.515 4.515 0 01-.53-.11h-.16a5.769 5.769 0 01-1.95-.94 5.614 5.614 0 01-.7-.59.47.47 0 01-.06-.09 5.771 5.771 0 01-.78-1 1 1 0 111.67-1.06c.183.292.401.561.65.8.149.14.31.268.48.38l.1.07a4.14 4.14 0 004.32 0l.1-.07c.17-.112.332-.24.48-.38a4.21 4.21 0 00.65-.8 1 1 0 111.69 1.06z",
            fill: "currentColor"
        })
    });



const $a459cbc5e7ada433$export$b675dff6d0b6c0c8 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm3.5 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8.26 8.85a1 1 0 01-1.37-.32 4 4 0 00-6.78 0 1 1 0 11-1.69-1.06 6 6 0 0110.16 0 1.002 1.002 0 01-.32 1.38z",
            fill: "currentColor"
        })
    });



const $3607434377c99614$export$e5c12eca07fe7b2d = (c)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.37 9.61a1.964 1.964 0 00-.58-.856 1.896 1.896 0 00-.94-.428l-4.235-.646-1.899-4.087a1.963 1.963 0 00-.702-.798 1.917 1.917 0 00-1.016-.295c-.361 0-.712.105-1.016.295a1.85 1.85 0 00-.703.798L8.38 7.68l-4.273.646c-.342.057-.674.2-.94.428a1.964 1.964 0 00-.58.855 1.91 1.91 0 00.447 1.901l3.124 3.213-.74 4.553c-.058.351-.01.712.123 1.036.133.323.36.608.655.817.313.238.703.37 1.102.38.332 0 .655-.076.95-.237l3.788-2.091 3.788 2.09c.285.162.618.248.95.238a1.9 1.9 0 001.101-.351c.285-.21.513-.485.655-.818.133-.323.181-.684.124-1.036l-.74-4.552 3.123-3.213c.228-.257.37-.58.437-.922a1.91 1.91 0 00-.104-1.008z",
            fill: "currentColor"
        })
    });



const $044eb39f59e3c768$export$13b8539f4be0c = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z",
            fill: "currentColor"
        })
    });



const $a80d6d0eaf25f114$export$50c1b72d39add9 = (i)=>(0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7a9adcfb845e594f$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm5.21 7.71l-6 6a1.002 1.002 0 01-1.42 0l-3-3a1.003 1.003 0 111.42-1.42l2.29 2.3 5.29-5.3a1.004 1.004 0 011.42 1.42z",
                fill: "#25AB21"
            })
        ]
    });



const $e2a4237d1a3a760e$export$ff711dd56629d4f5 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 4.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
            fill: "currentColor"
        })
    });



const $9802b0598e6eade4$export$47407925ae9f1f0e = (i)=>(0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7a9adcfb845e594f$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10,
                fill: "#fff"
            }),
            (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M12 2a10 10 0 100 20 10 10 0 000-20zm-1 4.5a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
                fill: "#F06D0F"
            })
        ]
    });



const $04fc5138b12d9c4c$export$faf9e552d710fc5c = (l)=>(0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: [
            (0, $7a9adcfb845e594f$exports.jsxs)("g", {
                clipPath: "url(#ic_jio_dot_svg__clip0_5207_79934)",
                children: [
                    (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        rx: 12,
                        fill: "#3535F3"
                    }),
                    (0, $7a9adcfb845e594f$exports.jsx)("path", {
                        d: "M8.478 7.237h-.4c-.76 0-1.174.428-1.174 1.285v4.129c0 1.063-.359 1.436-1.201 1.436-.663 0-1.202-.29-1.63-.815-.041-.055-.91.36-.91 1.381 0 1.105 1.034 1.782 2.955 1.782 2.333 0 3.563-1.174 3.563-3.742V8.521c-.002-.856-.416-1.285-1.203-1.285zm9.3 2.017c-2.265 0-3.77 1.436-3.77 3.577 0 2.196 1.45 3.605 3.728 3.605 2.265 0 3.756-1.409 3.756-3.59.001-2.156-1.477-3.592-3.714-3.592zm-.028 5.15c-.884 0-1.491-.648-1.491-1.574 0-.91.622-1.56 1.491-1.56.87 0 1.491.65 1.491 1.574 0 .898-.634 1.56-1.49 1.56zm-5.656-5.082h-.277c-.676 0-1.187.318-1.187 1.285v4.419c0 .98.497 1.285 1.215 1.285h.277c.676 0 1.16-.332 1.16-1.285v-4.42c0-.993-.47-1.284-1.188-1.284zm-.152-3.203c-.856 0-1.395.484-1.395 1.243 0 .773.553 1.256 1.436 1.256.857 0 1.395-.483 1.395-1.256s-.552-1.243-1.436-1.243z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: (0, $7a9adcfb845e594f$exports.jsx)("clipPath", {
                    id: "ic_jio_dot_svg__clip0_5207_79934",
                    children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $d2d28755d5ad7779$export$b15d2693bd1dee35 = (i)=>(0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [
            (0, $7a9adcfb845e594f$exports.jsx)("g", {
                clipPath: "url(#ic_jio_dot_exclude_svg__clip0_7826_127526)",
                children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
                    d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12 12-5.372 12-12S18.627 0 12 0zM9.68 12.693c0 2.568-1.23 3.742-3.564 3.742-1.92 0-2.955-.677-2.955-1.781 0-1.023.87-1.437.91-1.382.429.525.967.815 1.63.815.843 0 1.202-.373 1.202-1.436v-4.13c0-.855.414-1.284 1.173-1.284h.4c.788 0 1.202.429 1.202 1.285l.001 4.17zm3.601 2.333c0 .953-.483 1.285-1.16 1.285h-.277c-.718 0-1.215-.304-1.215-1.285v-4.418c0-.968.511-1.285 1.187-1.285h.277c.718 0 1.187.29 1.187 1.285l.001 4.418zm-1.298-6.407c-.883 0-1.436-.484-1.436-1.257 0-.76.539-1.243 1.395-1.243.884 0 1.436.47 1.436 1.243 0 .774-.538 1.257-1.395 1.257zm5.753 7.816c-2.279 0-3.728-1.409-3.728-3.605 0-2.14 1.505-3.576 3.77-3.576 2.237 0 3.715 1.436 3.715 3.59 0 2.182-1.493 3.591-3.757 3.591zm.014-5.165c-.87 0-1.491.65-1.491 1.56 0 .926.607 1.575 1.491 1.575.856 0 1.492-.663 1.492-1.56 0-.926-.622-1.575-1.492-1.575z",
                    fill: "#3535F3"
                })
            }),
            (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: (0, $7a9adcfb845e594f$exports.jsx)("clipPath", {
                    id: "ic_jio_dot_exclude_svg__clip0_7826_127526",
                    children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });



const $9ce4cb0b2f9af6e2$export$3d9cd62ef287ff59 = (_)=>(0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ..._,
        children: [
            (0, $7a9adcfb845e594f$exports.jsxs)("g", {
                clipPath: "url(#ic_jio_dot_jiofinance_coloured_svg__clip0_51184_147799)",
                children: [
                    (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                        width: 24,
                        height: 24,
                        rx: 12,
                        fill: "url(#ic_jio_dot_jiofinance_coloured_svg__paint0_linear_51184_147799)"
                    }),
                    (0, $7a9adcfb845e594f$exports.jsx)("path", {
                        d: "M8.478 7.237h-.4c-.76 0-1.174.428-1.174 1.285v4.129c0 1.063-.359 1.436-1.201 1.436-.663 0-1.202-.29-1.63-.815-.041-.055-.91.36-.91 1.381 0 1.105 1.034 1.782 2.955 1.782 2.333 0 3.563-1.174 3.563-3.742V8.521c-.002-.856-.416-1.285-1.203-1.285zm9.3 2.017c-2.265 0-3.77 1.436-3.77 3.577 0 2.196 1.45 3.605 3.728 3.605 2.265 0 3.756-1.409 3.756-3.59.001-2.156-1.477-3.592-3.714-3.592zm-.028 5.15c-.884 0-1.491-.648-1.491-1.574 0-.91.622-1.56 1.491-1.56.87 0 1.491.65 1.491 1.574 0 .898-.634 1.56-1.49 1.56zm-5.656-5.082h-.277c-.676 0-1.187.318-1.187 1.285v4.419c0 .98.497 1.285 1.215 1.285h.277c.676 0 1.16-.332 1.16-1.285v-4.42c0-.993-.47-1.284-1.188-1.284zm-.152-3.203c-.856 0-1.395.484-1.395 1.243 0 .773.553 1.256 1.436 1.256.857 0 1.395-.483 1.395-1.256s-.552-1.243-1.436-1.243z",
                        fill: "#fff"
                    })
                ]
            }),
            (0, $7a9adcfb845e594f$exports.jsxs)("defs", {
                children: [
                    (0, $7a9adcfb845e594f$exports.jsxs)("linearGradient", {
                        id: "ic_jio_dot_jiofinance_coloured_svg__paint0_linear_51184_147799",
                        x1: .045,
                        y1: .045,
                        x2: 24.027,
                        y2: 24.027,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                                offset: .08,
                                stopColor: "#F3B561"
                            }),
                            (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                                offset: .45,
                                stopColor: "#F6C586"
                            }),
                            (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#C78724"
                            })
                        ]
                    }),
                    (0, $7a9adcfb845e594f$exports.jsx)("clipPath", {
                        id: "ic_jio_dot_jiofinance_coloured_svg__clip0_51184_147799",
                        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    })
                ]
            })
        ]
    });



const $6b25bcc26768ed00$export$d586aed94de44e82 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a7.82 7.82 0 00-8 7.6c0 5.08 5.91 11.14 6.59 11.81a2 2 0 002.82 0C14.09 20.74 20 14.68 20 9.6A7.82 7.82 0 0012 2zm0 11a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $27bb06ea2a133495$export$8fe68ed1b5ac245c = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20.49 3.51a1.001 1.001 0 00-1.45 0L3.51 19A1.054 1.054 0 105 20.49l2.6-2.61a33.48 33.48 0 003 3.53 2 2 0 002.82 0C14.09 20.74 20 14.68 20 9.6c-.001-1.16-.282-2.302-.82-3.33L20.49 5a1.001 1.001 0 000-1.49zM9.08 10.67A2.93 2.93 0 019 10a3 3 0 013-3c.225.001.45.028.67.08l3.79-3.78A8.21 8.21 0 0012 2a7.82 7.82 0 00-8 7.6 10.84 10.84 0 001.36 4.79l3.72-3.72z",
            fill: "currentColor"
        })
    });



const $1bdf61761478cf0f$export$af0a72b1e9c547c5 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M2 4.91v8.71a3 3 0 001 2.28L7.81 20c.202.17.437.295.69.37V6.64L4.37 3.69A1.5 1.5 0 002 4.91zm19.12 3.21l-4-4a2.069 2.069 0 00-.58-.4V16.5l2.94 2.94A1.5 1.5 0 0022 18.38v-8.14a3 3 0 00-.88-2.12zM9.5 6.71V20.4c.277-.043.54-.15.77-.31l5.23-3.73V3.52a2.08 2.08 0 00-.83.24L9.5 6.71z",
            fill: "currentColor"
        })
    });



const $82721b8275f2c860$export$51e681bf0729a333 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M19.32 2.17L3.14 9.29a1.9 1.9 0 00.62 3.64l6.77.54.54 6.77a1.9 1.9 0 003.64.62l7.12-16.18a1.9 1.9 0 00-2.51-2.51z",
            fill: "currentColor"
        })
    });



const $d7d0ad31bc9eab74$export$58f9be5875231b2 = (c)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...c,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M6 9.5c0 .83.67 1.5 1.5 1.5S9 10.33 9 9.5 8.33 8 7.5 8 6 8.67 6 9.5zM19 4h-5.4l-2.31 2h7.7c.55 0 1 .45 1 1v6.7l-3.83-3.45c-.38-.34-.96-.34-1.34 0l-2.01 1.83.54.9a1 1 0 01-.22 1.28l-2.08 1.73 2.08 1.73c.23.19.36.47.36.77 0 .3-.13.58-.36.77l-.88.73h6.74c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3H19zM8.5 16c0-.3.13-.58.36-.77l.85-.71-1.57-1.3c-.38-.31-.93-.3-1.3.02L4 15.76V7c0-.55.45-1 1-1h3.24l2.31-2H5C3.35 4 2 5.35 2 7v10c0 1.65 1.35 3 3 3h4.14l1.8-1.5-2.08-1.73A.992.992 0 018.5 16z",
            fill: "currentColor"
        })
    });



const $2f0551663e33dca4$export$4736cab3fc47e2fb = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M8.5 7a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 9.09l-2.79-2.8a1 1 0 00-1.42 0l-4.29 4.3-1.29-1.3a1 1 0 00-1.42 0L5 15.09V6a1 1 0 011-1h12a1 1 0 011 1v6.09z",
            fill: "currentColor"
        })
    });



const $8b88f021ab770504$export$c1c61a3da2c48ae4 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 15a3 3 0 003-3V5a3 3 0 00-6 0v7a3 3 0 003 3zm6-5a1 1 0 00-1 1v1a5 5 0 11-10 0v-1a1 1 0 10-2 0v1a7 7 0 1014 0v-1a1 1 0 00-1-1zm-3 10H9a1 1 0 000 2h6a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $a5853f803d552460$export$4f5b8d1e98c25c06 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M7.07 12.69A5.2 5.2 0 017 12v-1a1 1 0 10-2 0v1a7 7 0 00.41 2.34l1.66-1.65zM12 2a3 3 0 00-3 3v5.76l6-6A3 3 0 0012 2zm3 18H9a1 1 0 000 2h6a1 1 0 100-2zm-3-5a3 3 0 003-3v-1.56L20.49 5a1.055 1.055 0 00-.745-1.799A1.053 1.053 0 0019 3.51L3.51 19A1.055 1.055 0 005 20.49l2.87-2.88A7 7 0 0019 12v-1a1 1 0 00-2 0v1a5 5 0 01-7.73 4.18l1.46-1.47A3 3 0 0012 15z",
            fill: "currentColor"
        })
    });



const $62493db4f6ef3ca5$export$1eb29c5f2b0051d3 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M8.5 4A1.5 1.5 0 007 5.5v13a1.5 1.5 0 003 0v-13A1.5 1.5 0 008.5 4zm7 0A1.5 1.5 0 0014 5.5v13a1.5 1.5 0 103 0v-13A1.5 1.5 0 0015.5 4z",
            fill: "currentColor"
        })
    });



const $2257b9c2d70e9d81$export$a93378bd68e53d32 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M19.15 10.36l-10-7A2 2 0 008 3a1.88 1.88 0 00-.92.23A2 2 0 006 5v14a2 2 0 001.08 1.77c.282.154.599.233.92.23a2 2 0 001.15-.36l10-7a2 2 0 000-3.28z",
            fill: "currentColor"
        })
    });



const $0094dacb13fcf2c4$export$af0536a50732761b = (s)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...s,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5 17c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
            fill: "currentColor"
        })
    });



const $d915ff7f98751614$export$aed2803299c2cf67 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M2.29 12.71l6 6a1.004 1.004 0 101.42-1.42L5.41 13H21a1 1 0 100-2H5.41l4.3-4.29a1 1 0 000-1.42 1 1 0 00-1.42 0l-6 6a1 1 0 000 1.42z",
            fill: "currentColor"
        })
    });



const $a3134278bf70d277$export$a1075cdfac2f932 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.71 11.29l-6-6a1.004 1.004 0 10-1.42 1.42l4.3 4.29H3a1 1 0 100 2h15.59l-4.3 4.29a1 1 0 000 1.42 1.002 1.002 0 001.42 0l6-6a1.002 1.002 0 000-1.42z",
            fill: "currentColor"
        })
    });



const $4032b58bf1d5d7fe$export$740276c76f223dd4 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M15 20a1.003 1.003 0 01-.71-.29l-7-7a1 1 0 010-1.42l7-7a1.005 1.005 0 011.42 1.42L9.41 12l6.3 6.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
            fill: "currentColor"
        })
    });



const $cc6848bbab622908$export$3bb087c30947880a = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M4 7h16a1 1 0 100-2H4a1 1 0 000 2zm16 10H4a1 1 0 000 2h16a1 1 0 000-2zm0-6H4a1 1 0 000 2h16a1 1 0 000-2z",
            fill: "currentColor"
        })
    });



const $ba8f011ee84a4198$export$ec7db1c418c1ec5a = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 15a1.002 1.002 0 01-.71-.29l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 111.42 1.42l-4 4A1.001 1.001 0 0112 15z",
            fill: "currentColor"
        })
    });



const $0ccf729272393be8$export$8203b8a87ae185f = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M14 17a1.003 1.003 0 01-.71-.29l-4-4a1 1 0 010-1.42l4-4a1.005 1.005 0 011.42 1.42L11.41 12l3.3 3.29a.997.997 0 01.219 1.095.999.999 0 01-.93.615z",
            fill: "currentColor"
        })
    });



const $ce50cd91d91f3ae0$export$a477256bf52ac2f7 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M10 17a1.002 1.002 0 01-1.006-1 1 1 0 01.296-.71l3.3-3.29-3.3-3.29a1.004 1.004 0 011.42-1.42l4 4a.997.997 0 01.219 1.095.999.999 0 01-.22.325l-4 4A1 1 0 0110 17z",
            fill: "currentColor"
        })
    });



const $820b24444175a496$export$acd925e63e14000f = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M16 15a.998.998 0 01-.71-.29L12 11.41l-3.29 3.3a1.004 1.004 0 01-1.42-1.42l4-4a.999.999 0 011.42 0l4 4A1.001 1.001 0 0116 15z",
            fill: "currentColor"
        })
    });



const $d3033cfe8927e2c5$export$48672c81f0c3f574 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M13.41 12l6.3-6.29a1.004 1.004 0 00-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 10-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 000 1.42 1 1 0 001.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 001.639-.325 1 1 0 00-.22-1.095L13.41 12z",
            fill: "currentColor"
        })
    });



const $0f67a5a3d97e81e5$export$885ccec48f920b92 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M7 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1zm5.41 8l6.29-6.29a.996.996 0 10-1.41-1.41l-7 7a.996.996 0 000 1.41l7 7c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41l-6.29-6.29-.01-.01z",
            fill: "currentColor"
        })
    });



const $de50ab7a6c97ce62$export$10426ed6ef0ab637 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M21.47 9.31L13.85 2.7a2.8 2.8 0 00-3.7 0L2.53 9.31A1.53 1.53 0 003.45 12H4v7a3 3 0 003 3h3v-6h4v6h3a3 3 0 003-3v-7h.55a1.53 1.53 0 00.92-2.69z",
            fill: "currentColor"
        })
    });



const $9615fde781fa655e$export$1093b8f29e1cf10c = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M6.71 4.29A.996.996 0 105.3 5.7l6.29 6.29-6.29 6.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l7-7a.996.996 0 000-1.41L6.71 4.29zM17 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z",
            fill: "currentColor"
        })
    });



const $4a7261da942522da$export$a883bfa83ec843c8 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M10.29 14.29a1.002 1.002 0 00.325 1.639 1 1 0 001.095-.219l3-3a1.002 1.002 0 000-1.42l-3-3a1.004 1.004 0 00-1.42 1.42l1.3 1.29H3a1 1 0 000 2h8.59l-1.3 1.29zM12 2a10.06 10.06 0 00-8.09 4.13 1 1 0 00.575 1.565A1 1 0 005.53 7.31a8 8 0 110 9.38 1.002 1.002 0 10-1.62 1.18A10 10 0 1012 2z",
            fill: "currentColor"
        })
    });



const $e7902526201c79a0$export$5c4cc728e7726d4e = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M17.87 3.91a1 1 0 00-1.58.966 1 1 0 00.4.654 8 8 0 11-9.38 0 1.002 1.002 0 00-1.18-1.62 10 10 0 1011.74 0zM12 8a1 1 0 001-1V3a1 1 0 00-2 0v4a1 1 0 001 1z",
            fill: "currentColor"
        })
    });



const $4effb7c98fe0d40c$export$f6c2e7c657f578c5 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M5.5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $1a905b1845db701d$export$76eade3e6c39fefd = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0-6.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
            fill: "currentColor"
        })
    });



const $75c74d0c8e1efe40$export$17beb55fda7072f9 = (r)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M9 20a1.002 1.002 0 01-1.006-1 1 1 0 01.296-.71l6.3-6.29-6.3-6.29a1.004 1.004 0 011.42-1.42l7 7a.997.997 0 01.219 1.095.999.999 0 01-.22.325l-7 7A1 1 0 019 20z",
            fill: "currentColor"
        })
    });



const $ae6e96cf340a1d1b$export$6da2c307edd95198 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M10.004 2a7 7 0 015.6 11.19l6.11 6.1a1.002 1.002 0 01-.325 1.639.999.999 0 01-1.095-.219l-6.1-6.11A7 7 0 1110.004 2zm0 12a5 5 0 100-10 5 5 0 000 10z",
            fill: "currentColor"
        })
    });



const $d70a770cb3158481$export$f7d6d35bb50c6222 = (a)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...a,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M20.43 13.4L19 12.58v-1.16l1.43-.82a2 2 0 00.73-2.73l-1-1.74a2 2 0 00-2.73-.73l-1.18.68-.25.15-1-.58V4a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.65l-.25.14-.75.44-.25-.15-1.18-.68a2 2 0 00-2.73.73l-1 1.74a2 2 0 00.73 2.73l1.43.82v1.16l-1.43.82a2 2 0 00-.73 2.73l1 1.74a2 2 0 002.73.73L8 17.77l1 .58V20a2 2 0 002 2h2a2 2 0 002-2v-1.65l1-.58 1.43.83a2 2 0 002.73-.73l1-1.74a2 2 0 00-.73-2.73zM12 15a3 3 0 110-6 3 3 0 010 6z",
            fill: "currentColor"
        })
    });



const $5b77d69d5620f0fd$export$8c6932a2fedd46e4 = (l)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...l,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 6a4 4 0 11-8 0 4 4 0 018 0zm4 10.5c0 3.038-3.582 5.5-8 5.5s-8-2.462-8-5.5S7.582 11 12 11s8 2.462 8 5.5z",
            fill: "currentColor"
        })
    });



const $c8f36c5b30a998b4$export$255f0ef2dfc5eb49 = (o)=>(0, $7a9adcfb845e594f$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...o,
        children: (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a3 3 0 110 6 3 3 0 010-6zm0 14a8 8 0 01-6.54-3.41C6.46 15.08 9 14 12 14s5.54 1.08 6.54 2.59A8 8 0 0112 20z",
            fill: "currentColor"
        })
    });




function $a996a90891ec663e$export$629a2bd3f5a49ecc(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) {
        const newArray = [];
        for(let i = 0; i < obj.length; i++)newArray[i] = $a996a90891ec663e$export$629a2bd3f5a49ecc(obj[i]);
        return newArray;
    }
    const newObj = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $a996a90891ec663e$export$629a2bd3f5a49ecc(obj[key]);
    return newObj;
}
function $a996a90891ec663e$export$79b2f7037acddd43(collection, iteratee) {
    if (Array.isArray(collection)) for (const item of collection)iteratee(item);
    else {
        const keys = Object.keys(collection);
        for (const key of keys)iteratee(collection[key], key);
    }
}
const $a996a90891ec663e$export$b460b275d6c6aa0 = (object, predicate)=>{
    if (typeof predicate !== "function") throw new TypeError("Predicate must be a function");
    const result = {};
    for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key], key)) result[key] = object[key];
    return result;
};
const $a996a90891ec663e$export$30a06c8d3562193f = (obj, props)=>{
    obj = {
        ...obj
    };
    props.forEach((prop)=>delete obj[prop]);
    return obj;
};
const $a996a90891ec663e$export$d7a617dda645b4e3 = (obj, check)=>{
    obj = {
        ...obj
    };
    Object.entries(obj).forEach(([key, value])=>check(value, key) && delete obj[key]);
    return obj;
};
const $a996a90891ec663e$export$3988ae62b71be9a3 = (obj, path, defValue)=>{
    if (!path) return void 0;
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    const result = pathArray?.reduce((prevObj, key)=>prevObj && prevObj[key], obj);
    return result === void 0 ? defValue : result;
};
const $a996a90891ec663e$export$2cbec9495984f5d9 = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
const $a996a90891ec663e$export$61fc7d43ac8f84b0 = (fn, wait, immediate = false)=>{
    let timeoutId;
    return function(...args) {
        const later = ()=>{
            timeoutId = null;
            if (!immediate) fn.apply(this, args);
        };
        const callNow = immediate && !timeoutId;
        timeoutId !== null && clearTimeout(timeoutId);
        timeoutId = setTimeout(later, wait);
        if (callNow) fn.apply(this, args);
    };
};
const $a996a90891ec663e$export$5fe300a9008e2bfc = (value)=>value.replace(/[{}]/g, "");
const $a996a90891ec663e$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(value, max));
function $a996a90891ec663e$export$4950aa0f605343fb(base, ...rest) {
    let second;
    rest = rest.filter(Boolean);
    if (rest.length > 1) {
        const [first, ...others] = rest;
        second = $a996a90891ec663e$export$4950aa0f605343fb(first, ...others);
    } else if (rest.length === 1) second = rest[0];
    else return base;
    return $a996a90891ec663e$var$mergeObject(base, second);
}
function $a996a90891ec663e$var$mergeObject(base, second) {
    const merged = {};
    const keys = [
        ...Object.keys(base),
        ...Object.keys(second)
    ];
    for (const key of keys){
        if (!(key in second)) merged[key] = base[key];
        else if (!(key in base)) merged[key] = second[key];
        else merged[key] = $a996a90891ec663e$var$mergeValues(base[key], second[key]);
    }
    return merged;
}
function $a996a90891ec663e$var$mergeValues(base, second) {
    if ($a996a90891ec663e$var$isObject(base) && $a996a90891ec663e$var$isObject(second)) return $a996a90891ec663e$var$mergeObject(base, second);
    return second;
}
function $a996a90891ec663e$var$isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
const $a996a90891ec663e$export$1839ba460459a826 = (s)=>s?.replace(/./, (m)=>m.toUpperCase());
const $a996a90891ec663e$export$8a7688a96d852767 = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : $a996a90891ec663e$export$1839ba460459a826(segment)).join("");
const $a996a90891ec663e$export$26c6f48841fe1a8a = (s, separator = "-")=>s.split(separator).map($a996a90891ec663e$export$1839ba460459a826).join("");
const $a996a90891ec663e$export$3e672a90535a3744 = (inputString)=>inputString.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/([0-9])([a-zA-Z])/g, "$1-$2").replace(/([a-zA-Z])([0-9])/g, "$1-$2").replace(/\s+/g, "-").toLowerCase();
function $a996a90891ec663e$export$848d71df1f759bc(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16) / 255,
        g: parseInt(result[2], 16) / 255,
        b: parseInt(result[3], 16) / 255
    } : {
        r: 0,
        g: 0,
        b: 0
    };
}
function $a996a90891ec663e$export$b7d58db314e0ac27(obj) {
    return globalThis.structuredClone ? globalThis.structuredClone(obj) : JSON.parse(JSON.stringify(obj));
}
const $a996a90891ec663e$export$feae9a740c003485 = (string)=>{
    return string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map((word)=>word.toLowerCase()).join("_");
};


var $5a49bb477e7b5f89$var$buffer = {};
var $5a49bb477e7b5f89$var$base64Js = {};
$5a49bb477e7b5f89$var$base64Js.byteLength = $5a49bb477e7b5f89$var$byteLength;
$5a49bb477e7b5f89$var$base64Js.toByteArray = $5a49bb477e7b5f89$var$toByteArray;
$5a49bb477e7b5f89$var$base64Js.fromByteArray = $5a49bb477e7b5f89$var$fromByteArray;
var $5a49bb477e7b5f89$var$lookup = [];
var $5a49bb477e7b5f89$var$revLookup = [];
var $5a49bb477e7b5f89$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $5a49bb477e7b5f89$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $5a49bb477e7b5f89$var$i = 0, $5a49bb477e7b5f89$var$len = $5a49bb477e7b5f89$var$code.length; $5a49bb477e7b5f89$var$i < $5a49bb477e7b5f89$var$len; ++$5a49bb477e7b5f89$var$i){
    $5a49bb477e7b5f89$var$lookup[$5a49bb477e7b5f89$var$i] = $5a49bb477e7b5f89$var$code[$5a49bb477e7b5f89$var$i];
    $5a49bb477e7b5f89$var$revLookup[$5a49bb477e7b5f89$var$code.charCodeAt($5a49bb477e7b5f89$var$i)] = $5a49bb477e7b5f89$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a49bb477e7b5f89$var$revLookup['-'.charCodeAt(0)] = 62;
$5a49bb477e7b5f89$var$revLookup['_'.charCodeAt(0)] = 63;
function $5a49bb477e7b5f89$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a49bb477e7b5f89$var$byteLength(b64) {
    var lens = $5a49bb477e7b5f89$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a49bb477e7b5f89$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a49bb477e7b5f89$var$toByteArray(b64) {
    var tmp;
    var lens = $5a49bb477e7b5f89$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a49bb477e7b5f89$var$Arr($5a49bb477e7b5f89$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i)] << 18 | $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i)] << 2 | $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i)] << 10 | $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a49bb477e7b5f89$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a49bb477e7b5f89$var$tripletToBase64(num) {
    return $5a49bb477e7b5f89$var$lookup[num >> 18 & 0x3F] + $5a49bb477e7b5f89$var$lookup[num >> 12 & 0x3F] + $5a49bb477e7b5f89$var$lookup[num >> 6 & 0x3F] + $5a49bb477e7b5f89$var$lookup[num & 0x3F];
}
function $5a49bb477e7b5f89$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a49bb477e7b5f89$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $5a49bb477e7b5f89$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a49bb477e7b5f89$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a49bb477e7b5f89$var$lookup[tmp >> 2] + $5a49bb477e7b5f89$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a49bb477e7b5f89$var$lookup[tmp >> 10] + $5a49bb477e7b5f89$var$lookup[tmp >> 4 & 0x3F] + $5a49bb477e7b5f89$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $5a49bb477e7b5f89$var$ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ $5a49bb477e7b5f89$var$ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5a49bb477e7b5f89$var$ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    const base64 = $5a49bb477e7b5f89$var$base64Js;
    const ieee754$1 = $5a49bb477e7b5f89$var$ieee754;
    const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
     ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    const K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    const { Uint8Array: GlobalUint8Array, ArrayBuffer: GlobalArrayBuffer, SharedArrayBuffer: GlobalSharedArrayBuffer } = globalThis;
    /**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            const arr = new GlobalUint8Array(1);
            const proto = {
                foo: function() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, GlobalUint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, 'parent', {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, 'offset', {
        enumerable: true,
        get: function() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
        // Return an augmented `Uint8Array` instance
        const buf = new GlobalUint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === 'string') return fromString(value, encodingOrOffset);
        if (GlobalArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, GlobalArrayBuffer) || value && isInstance(value.buffer, GlobalArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof GlobalSharedArrayBuffer !== 'undefined' && (isInstance(value, GlobalSharedArrayBuffer) || value && isInstance(value.buffer, GlobalSharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        const b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    };
    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, GlobalUint8Array.prototype);
    Object.setPrototypeOf(Buffer, GlobalUint8Array);
    function assertSize(size) {
        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        const length = byteLength(string, encoding) | 0;
        let buf = createBuffer(length);
        const actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        const length = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length);
        for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, GlobalUint8Array)) {
            const copy = new GlobalUint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        let buf;
        if (byteOffset === undefined && length === undefined) buf = new GlobalUint8Array(array);
        else if (length === undefined) buf = new GlobalUint8Array(array, byteOffset);
        else buf = new GlobalUint8Array(array, byteOffset, length);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            const len = checked(obj.length) | 0;
            const buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
        ;
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, GlobalUint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, GlobalUint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        let x = a.length;
        let y = b.length;
        for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        let i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        const buffer = Buffer.allocUnsafe(length);
        let pos = 0;
        for(i = 0; i < list.length; ++i){
            let buf = list[i];
            if (isInstance(buf, GlobalUint8Array)) {
                if (pos + buf.length > buffer.length) {
                    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                    buf.copy(buffer, pos);
                } else GlobalUint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (GlobalArrayBuffer.isView(string) || isInstance(string, GlobalArrayBuffer)) return string.byteLength;
        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        // Use a for loop to avoid recursion
        let loweredCase = false;
        for(;;)switch(encoding){
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                ;
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        let loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return '';
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return '';
        // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return '';
        if (!encoding) encoding = 'utf8';
        while(true)switch(encoding){
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    }
    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        const i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for(let i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for(let i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        const length = this.length;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        let str = '';
        const max = exports.INSPECT_MAX_BYTES;
        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
        if (this.length > max) str += ' ... ';
        return '<Buffer ' + str + '>';
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, GlobalUint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === 'string') val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === 'number') {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof GlobalUint8Array.prototype.indexOf === 'function') {
                if (dir) return GlobalUint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return GlobalUint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        let i;
        if (dir) {
            let foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                let found = true;
                for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        const strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        let i;
        for(i = 0; i < length; ++i){
            const parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
        const remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        if (!encoding) encoding = 'utf8';
        let loweredCase = false;
        for(;;)switch(encoding){
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
            case 'latin1':
            case 'binary':
                return asciiWrite(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i = start;
        while(i < end){
            const firstByte = buf[i];
            let codePoint = null;
            let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                let secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    const MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
        ;
        // Decode in chunks to avoid "call stack size exceeded".
        let res = '';
        let i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        let ret = '';
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        let ret = '';
        end = Math.min(buf.length, end);
        for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        let out = '';
        for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        const bytes = buf.slice(start, end);
        let res = '';
        // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        const newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset + --byteLength];
        let mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let val = this[offset];
        let mul = 1;
        let i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        let i = byteLength;
        let mul = 1;
        let val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24); // Overflow
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, 'offset');
        const first = this[offset];
        const last = this[offset + 7];
        if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
        const val = (first << 24) + // Overflow
        this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
    });
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let mul = 1;
        let i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            const maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        let i = byteLength - 1;
        let mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
        checkIntBI(value, min, max, buf, offset, 7);
        let lo = Number(value & BigInt(0xffffffff));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
    }
    Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
    });
    Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
    });
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            const limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        let i = byteLength - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
    });
    Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
        if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
        if (end < 0) throw new RangeError('sourceEnd out of bounds');
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        const len = end - start;
        if (this === target && typeof GlobalUint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else GlobalUint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === 'string') {
            if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
            if (val.length === 1) {
                const code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === 'number') val = val & 255;
        else if (typeof val === 'boolean') val = Number(val);
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        let i;
        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
        else {
            const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            const len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // CUSTOM ERRORS
    // =============
    // Simplified versions from Node, changed for Buffer-only usage
    const errors = {};
    function E(sym, getMessage, Base) {
        errors[sym] = class NodeError extends Base {
            constructor(){
                super();
                Object.defineProperty(this, 'message', {
                    value: getMessage.apply(this, arguments),
                    writable: true,
                    configurable: true
                });
                // Add the error code to the name to include it in the stack trace.
                this.name = `${this.name} [${sym}]`;
                // Access the stack to generate the error message including the error code
                // from the name.
                this.stack; // eslint-disable-line no-unused-expressions
                // Reset the name to the actual name.
                delete this.name;
            }
            get code() {
                return sym;
            }
            set code(value) {
                Object.defineProperty(this, 'code', {
                    configurable: true,
                    enumerable: true,
                    value: value,
                    writable: true
                });
            }
            toString() {
                return `${this.name} [${sym}]: ${this.message}`;
            }
        };
    }
    E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
        if (name) return `${name} is outside of buffer bounds`;
        return 'Attempt to access memory outside buffer bounds';
    }, RangeError);
    E('ERR_INVALID_ARG_TYPE', function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
    }, TypeError);
    E('ERR_OUT_OF_RANGE', function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
        else if (typeof input === 'bigint') {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
            received += 'n';
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
    }, RangeError);
    function addNumericalSeparator(val) {
        let res = '';
        let i = val.length;
        const start = val[0] === '-' ? 1 : 0;
        for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
        return `${val.slice(0, i)}${res}`;
    }
    // CHECK FUNCTIONS
    // ===============
    function checkBounds(buf, offset, byteLength) {
        validateNumber(offset, 'offset');
        if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
    }
    function checkIntBI(value, min, max, buf, offset, byteLength) {
        if (value > max || value < min) {
            const n = typeof min === 'bigint' ? 'n' : '';
            let range;
            if (byteLength > 3) {
                if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
                else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
            } else range = `>= ${min}${n} and <= ${max}${n}`;
            throw new errors.ERR_OUT_OF_RANGE('value', range, value);
        }
        checkBounds(buf, offset, byteLength);
    }
    function validateNumber(value, name) {
        if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
    }
    function boundsError(value, length, type) {
        if (Math.floor(value) !== value) {
            validateNumber(value, type);
            throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
        }
        if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
    }
    // HELPER FUNCTIONS
    // ================
    const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split('=')[0];
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, '');
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return '';
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + '=';
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        let codePoint;
        const length = string.length;
        let leadSurrogate = null;
        const bytes = [];
        for(let i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error('Invalid code point');
        }
        return bytes;
    }
    function asciiToBytes(str) {
        const byteArray = [];
        for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for(let i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        let i;
        for(i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj // eslint-disable-line no-self-compare
        ;
    }
    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    const hexSliceLookupTable = function() {
        const alphabet = '0123456789abcdef';
        const table = new Array(256);
        for(let i = 0; i < 16; ++i){
            const i16 = i * 16;
            for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
    // Return not function with Error if BigInt not supported
    function defineBigIntMethod(fn) {
        return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
        throw new Error('BigInt not supported');
    }
})($5a49bb477e7b5f89$var$buffer);
const $5a49bb477e7b5f89$var$Buffer = $5a49bb477e7b5f89$var$buffer.Buffer;
const $5a49bb477e7b5f89$var$container = {
    display: "flex",
    outline: "none",
    gap: "0px",
    "flex-direction": "row",
    width: "fit-content",
    height: "fit-content",
    "border-style": "solid",
    "border-width": "0px",
    "padding-top": "0px",
    "padding-right": "0px",
    "padding-bottom": "0px",
    "padding-left": "0px",
    opacity: "100",
    "background-color": "transparent",
    "box-sizing": "border-box",
    "border-radius": "0px",
    "flex-shrink": "initial"
};
const $5a49bb477e7b5f89$var$input = {
    "border-style": "solid",
    "border-width": "0px"
};
const $5a49bb477e7b5f89$var$text = {
    display: "inline",
    "text-align": "start",
    "text-decoration": "none"
};
const $5a49bb477e7b5f89$var$icon = {
    display: "flex"
};
const $5a49bb477e7b5f89$var$loader = {
    display: "inline-block"
};
const $5a49bb477e7b5f89$var$image = {
    display: "block",
    width: "100%"
};
const $5a49bb477e7b5f89$var$slot = {
    display: "flex"
};
const $5a49bb477e7b5f89$export$bb974f6f0c330fb = {
    container: $5a49bb477e7b5f89$var$container,
    input: $5a49bb477e7b5f89$var$input,
    text: $5a49bb477e7b5f89$var$text,
    icon: $5a49bb477e7b5f89$var$icon,
    loader: $5a49bb477e7b5f89$var$loader,
    image: $5a49bb477e7b5f89$var$image,
    slot: $5a49bb477e7b5f89$var$slot
};
const $5a49bb477e7b5f89$var$layerDefaults$1 = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    container: $5a49bb477e7b5f89$var$container,
    default: $5a49bb477e7b5f89$export$bb974f6f0c330fb,
    icon: $5a49bb477e7b5f89$var$icon,
    image: $5a49bb477e7b5f89$var$image,
    input: $5a49bb477e7b5f89$var$input,
    loader: $5a49bb477e7b5f89$var$loader,
    slot: $5a49bb477e7b5f89$var$slot,
    text: $5a49bb477e7b5f89$var$text
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $5a49bb477e7b5f89$var$prefixMap = {
    "background-color": "bg",
    color: "text",
    "border-color": "stroke"
};
const $5a49bb477e7b5f89$var$colorClassRuleHandler = (rule, ruleVal, tokens)=>{
    if (!$5a49bb477e7b5f89$export$859883d4ec9c7db4.brandResolverFn) return;
    if (typeof ruleVal === "object") {
        console.warn("Object values are not supported");
        return;
    }
    const resolved = $5a49bb477e7b5f89$export$859883d4ec9c7db4.brandResolverFn(rule, ruleVal, tokens, false);
    const prefix = $5a49bb477e7b5f89$var$prefixMap[rule];
    if (resolved?.value === "transparent") return `${prefix}-transparent`;
    const scale = resolved?.key?.split(".")[1];
    if (scale) {
        const klass = `${prefix}-${tokens["appearance"]}-${scale}`;
        return klass;
    }
    return void 0;
};
const $5a49bb477e7b5f89$export$e9552252b443446 = {
    "background-color": $5a49bb477e7b5f89$var$colorClassRuleHandler,
    color: $5a49bb477e7b5f89$var$colorClassRuleHandler,
    "border-color": $5a49bb477e7b5f89$var$colorClassRuleHandler,
    "font-size": ()=>null,
    "line-height": ()=>null,
    "letter-spacing": ()=>null,
    "font-weight": ()=>null
};
const $5a49bb477e7b5f89$var$defaults = $5a49bb477e7b5f89$var$layerDefaults$1;
const $5a49bb477e7b5f89$var$tokenSuffixShortKey = {
    default: "d",
    hover: "h",
    focus: "f",
    active: "a",
    visited: "v"
};
const $5a49bb477e7b5f89$var$tokenRuleShortKey = {
    "align-items": "al-it",
    "aspect-ratio": "as-rt",
    "background-color": "bg-cl",
    "blur-radius": "bl-rd",
    "border-color": "br-cl",
    "border-radius": "br-rd",
    "border-style": "br-st",
    "border-width": "br-wd",
    "border-top-width": "brt-wd",
    "border-right-width": "brr-wd",
    "border-bottom-width": "brb-wd",
    "border-left-width": "brl-w",
    "border-top-color": "brt-cl",
    "border-right-color": "brr-cl",
    "border-bottom-color": "brb-cl",
    "border-left-color": "brl-cl",
    "border-top-left-radius": "brtl-r",
    "border-top-right-radius": "brtr-r",
    "border-bottom-right-radius": "brbr-r",
    "border-bottom-left-radius": "brbl-r",
    bottom: "bt",
    "box-shadow": "bx-sh",
    "box-sizing": "bx-sz",
    color: "cl",
    cursor: "cur",
    display: "dis",
    flex: "fx",
    "flex-direction": "fx-dr",
    "font-family": "fo-fm",
    "font-size": "fo-sz",
    "font-weight": "fo-wt",
    gap: "gp",
    height: "ht",
    "justify-content": "js-ct",
    left: "lt",
    "letter-spacing": "lt-sp",
    "line-height": "ln-ht",
    "max-height": "mx-ht",
    "max-width": "mx-wd",
    "min-height": "mn-ht",
    "min-width": "mn-wd",
    opacity: "op",
    outline: "ol",
    overflow: "ov",
    "padding-bottom": "pd-b",
    "padding-left": "pd-l",
    "padding-right": "pd-r",
    "padding-top": "pd-t",
    "pointer-events": "pe",
    position: "pos",
    right: "rt",
    rotate: "rot",
    "text-align": "tx-al",
    "text-decoration": "tx-dc",
    "text-overflow": "tx-ol",
    "text-transform": "tx-tf",
    "object-fit": "oj-ft",
    "object-position": "oj-ps",
    size: "sz",
    up: "up",
    width: "wd",
    "z-index": "zi"
};
function $5a49bb477e7b5f89$export$92b70e511152790f(layerName) {
    return layerName.split("-").pop();
}
function $5a49bb477e7b5f89$export$82c717ab02da3bac(componentName, layerName) {
    return `${componentName}-${layerName}`;
}
function $5a49bb477e7b5f89$export$31e4419873013369(hierarchy) {
    const root = hierarchy;
    if (typeof root === "object") return Object.keys(root)[0];
    return "";
}
function $5a49bb477e7b5f89$export$8bf78da42833d414(hierarchy) {
    if (typeof hierarchy === "string") return [
        hierarchy
    ];
    const root = $5a49bb477e7b5f89$export$31e4419873013369(hierarchy);
    const layers = [
        root
    ];
    const children = hierarchy[root] ?? [];
    for (const child of children)layers.push(...$5a49bb477e7b5f89$export$8bf78da42833d414(child));
    return layers;
}
function $5a49bb477e7b5f89$export$ce4be320c9b7d5be(json) {
    const base = (0, $a996a90891ec663e$export$b7d58db314e0ac27)(json.base);
    for(const prop in json.variant){
        const propObj = json.variant[prop];
        for(const key in propObj){
            const variant = propObj[key];
            for(const layer in variant)base[layer] = $5a49bb477e7b5f89$var$handleInvariantBaseMap(base[layer], variant[layer]);
        }
    }
    for(const layer in json.api.data || {}){
        for (const apiItem of Object.keys(json.api.data?.[layer] || {}))if (base[layer]?.[apiItem]) delete base[layer][apiItem];
    }
    const combinations = $5a49bb477e7b5f89$var$getAllCombinations({}, json);
    for(const layer in combinations)base[layer] = $5a49bb477e7b5f89$var$handleInvariantBaseMap(base[layer], combinations[layer]);
    for(const layer in base)for(const key in base[layer]){
        const value = base[layer][key];
        if (String(value).includes("&color")) delete base[layer][key];
    }
    return base;
}
function $5a49bb477e7b5f89$var$handleInvariantBaseMap(baseItem, variantItem) {
    const { behavior: variantBehavior, ...variantBaseMap } = variantItem;
    if (!baseItem) return baseItem;
    const { behavior: behavior, ...baseMap } = baseItem;
    baseItem = $5a49bb477e7b5f89$var$removeVariantProps(baseMap, variantBaseMap);
    if (!behavior || !variantBehavior) return behavior ? {
        ...baseItem,
        behavior: behavior
    } : baseItem;
    for(const pseudo in variantBehavior){
        const pseudoBaseMap = behavior?.[pseudo];
        if (!pseudoBaseMap) continue;
        const pseudoVariantBaseMap = variantBehavior[pseudo];
        behavior[pseudo] = $5a49bb477e7b5f89$var$removeVariantProps(pseudoBaseMap, pseudoVariantBaseMap);
    }
    return behavior ? {
        ...baseItem,
        behavior: behavior
    } : baseItem;
}
function $5a49bb477e7b5f89$var$removeVariantProps(baseMap, variantBaseMap) {
    if (!baseMap) return baseMap;
    for(const property in variantBaseMap){
        const value = variantBaseMap[property];
        if (typeof value === "object" && !Array.isArray(value)) {
            baseMap[property] = $5a49bb477e7b5f89$var$removeVariantProps(baseMap[property], value);
            continue;
        }
        if (property in baseMap) delete baseMap[property];
    }
    function handleObject(baseMap2) {
        for(const property in baseMap2){
            const value = baseMap2[property];
            if (!value) continue;
            if (typeof value === "string") {
                if (value.includes("&") || value.includes("%")) delete baseMap2[property];
            } else if (typeof value === "object" && !Array.isArray(value)) handleObject(value);
        }
    }
    handleObject(baseMap);
    return baseMap;
}
const $5a49bb477e7b5f89$export$c1260eec73bdf31d = (componentName, layer)=>`j-${componentName}-${layer}`;
const $5a49bb477e7b5f89$export$437bd2c771393299 = (componentName, layer, rule, includeComponentName)=>{
    const shortRule = $5a49bb477e7b5f89$var$tokenRuleShortKey[rule] || rule;
    const layerKey = $5a49bb477e7b5f89$export$92b70e511152790f(layer);
    if (!includeComponentName || layerKey !== "container") return `--${layer}-${shortRule}`;
    return `--${componentName.toLowerCase()}--${layer}-${shortRule}`;
};
const $5a49bb477e7b5f89$export$246d3e180f7f2ea = (componentName, layer, rule, includeComponentName, pseudo)=>{
    const cssVar = $5a49bb477e7b5f89$export$437bd2c771393299(componentName, layer, rule, includeComponentName);
    if (pseudo) return `${cssVar}-${$5a49bb477e7b5f89$var$tokenSuffixShortKey[pseudo] || pseudo}`;
    return cssVar;
};
const $5a49bb477e7b5f89$export$2ee1162feea7fbb0 = (componentName, layer, rule, value, isInvariant, pseudo, tokens)=>{
    return $5a49bb477e7b5f89$var$createStyleRule(componentName, layer, rule, [
        rule
    ], value, isInvariant, pseudo, tokens);
};
const $5a49bb477e7b5f89$export$e8ddbfc1e3d5162b = (componentName, layer, rule, variables, value, isInvariant, pseudo, tokens)=>{
    return $5a49bb477e7b5f89$var$createStyleRule(componentName, layer, rule, variables, value, isInvariant, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$RULE_DEFAULTS = {
    translate: "0px",
    rotate: "0deg",
    scale: "1",
    "border-top-width": "0px",
    "border-right-width": "0px",
    "border-bottom-width": "0px",
    "border-left-width": "0px"
};
function $5a49bb477e7b5f89$var$createStyleRule(componentName, layer, rule, variables, value, isInvariant, pseudo, tokens) {
    const left = rule;
    const right = variables.map((variable, index)=>{
        const ruleDef = $5a49bb477e7b5f89$var$RULE_DEFAULTS[rule];
        const variableValue = Array.isArray(value) ? value[index] : value;
        const baseCssVar = $5a49bb477e7b5f89$export$437bd2c771393299(componentName, layer, variable, tokens?.["brandVersion"] === "jio-v2");
        if (tokens && isInvariant && typeof variableValue !== "object") {
            const resolved = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, variableValue, tokens);
            if (resolved) return resolved;
        }
        if (tokens && typeof variableValue !== "object") {
            const resolved = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, variableValue, tokens);
            if (resolved) {
                if (ruleDef && resolved.includes("var(")) {
                    const innermostVar = /var\(\s*--[^,)]+\)/;
                    const resolvedWithDefault = resolved.replace(innermostVar, (match)=>`${match.slice(0, -1)}, ${ruleDef})`);
                    return `var(${baseCssVar}, ${resolvedWithDefault})`;
                }
                return `var(${baseCssVar}, ${resolved})`;
            }
        }
        const cssVar = ruleDef ? `var(${baseCssVar}, ${ruleDef})` : `var(${baseCssVar})`;
        return pseudo ? `var(${$5a49bb477e7b5f89$export$246d3e180f7f2ea(componentName, layer, variable, tokens?.["brandVersion"] === "jio-v2", pseudo)}, ${cssVar})` : cssVar;
    }).join(" ");
    return {
        [left]: right
    };
}
function $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens) {
    return {
        [$5a49bb477e7b5f89$export$246d3e180f7f2ea(componentName, layer, rule, tokens?.["brandVersion"] === "jio-v2" && !pseudo, pseudo)]: value?.toString()
    };
}
function $5a49bb477e7b5f89$export$6ebbb579f04445e(componentName, layer, rule, ruleVal, pseudo, layerMap, tokens) {
    if (rule in $5a49bb477e7b5f89$export$95994f4e1548c018) return $5a49bb477e7b5f89$export$95994f4e1548c018[rule](componentName, layer, rule, ruleVal, pseudo, layerMap, tokens);
    return {};
}
function $5a49bb477e7b5f89$export$a8136d362b12b985(rule, ruleVal, tokens, pseudo) {
    if (rule in $5a49bb477e7b5f89$export$e9552252b443446) return $5a49bb477e7b5f89$export$e9552252b443446[rule](rule, ruleVal, tokens, pseudo);
    return void 0;
}
const $5a49bb477e7b5f89$export$875845b80e4c01b3 = (layer, length = 1)=>layer.split("-").map((x, index, arr)=>index !== arr.length - 1 ? x.slice(0, length) : x).filter(Boolean).join("-");
function $5a49bb477e7b5f89$export$43447905499a2c3e(componentName, layer, layerMap, invariantsMap, layerShortKey, pseudo, tokens) {
    const newTokens = {
        ...tokens
    };
    Object.keys(invariantsMap || {}).forEach((key2)=>{
        if (key2 in newTokens) newTokens[key2] = invariantsMap?.[key2]?.toString() ?? newTokens[key2];
    });
    const brandDefaults = $5a49bb477e7b5f89$export$859883d4ec9c7db4.defaults ?? {};
    const layerCSSVars = {};
    const layerClasses = [];
    const key = !pseudo && $5a49bb477e7b5f89$export$92b70e511152790f(layer);
    if (newTokens && newTokens?.["brandVersion"] === "jio-v2") {
        if (key && brandDefaults[key]) layerMap = (0, $a996a90891ec663e$export$4950aa0f605343fb)(brandDefaults[key] ?? {}, layerMap);
    } else if (key && ($5a49bb477e7b5f89$var$defaults[key] || brandDefaults[key])) layerMap = (0, $a996a90891ec663e$export$4950aa0f605343fb)($5a49bb477e7b5f89$var$defaults[key] ?? {}, brandDefaults[key] ?? {}, layerMap);
    for(const rule in layerMap){
        if (invariantsMap?.[rule]) continue;
        const useClasses = rule in $5a49bb477e7b5f89$export$e9552252b443446 && newTokens && newTokens?.["brandVersion"] === "jio-v2" && // String(layerMap[rule]).includes('&') &&
        !pseudo;
        if (useClasses) {
            const klass = $5a49bb477e7b5f89$export$a8136d362b12b985(rule, layerMap[rule], newTokens);
            if (klass) {
                layerClasses.push(klass);
                continue;
            }
            if (klass === null) continue;
        }
        Object.assign(layerCSSVars, $5a49bb477e7b5f89$export$6ebbb579f04445e(componentName, layerShortKey, rule, layerMap[rule], pseudo, layerMap, tokens));
    }
    return {
        styles: layerCSSVars,
        classes: layerClasses
    };
}
const $5a49bb477e7b5f89$export$beb192a6dc60a1a7 = [
    "appearance",
    "surface",
    "strokeSurface",
    "color",
    "background-color",
    "border-color",
    "fill"
];
function $5a49bb477e7b5f89$export$5cc69797806ce5c5(tokens, baseMap) {
    const colorProperty = Object.keys(baseMap || {}).find((key)=>key.endsWith("color") && !key.includes("border"));
    const borderColorProperty = Object.keys(baseMap || {}).find((key)=>key.includes("border"));
    const colorToken = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(String(baseMap?.[colorProperty ?? ""]) || "");
    const borderColorToken = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(String(baseMap?.[borderColorProperty ?? ""]) || "");
    const surface = colorToken?.split("_")?.[2];
    const strokeSurface = borderColorToken?.split("_")?.[2];
    const baseSurface = baseMap?.["surface"]?.toString();
    const baseStrokeSurface = baseMap?.["strokeSurface"]?.toString();
    const newTokens = {
        ...tokens,
        surface: baseSurface || surface || tokens["surface"],
        strokeSurface: baseStrokeSurface || strokeSurface || tokens["strokeSurface"]
    };
    if (tokens?.["brandVersion"] === "jio-v2" && $5a49bb477e7b5f89$export$859883d4ec9c7db4.updateFlatTokens) {
        const updatedTokens = $5a49bb477e7b5f89$export$859883d4ec9c7db4.updateFlatTokens({
            ...newTokens
        });
        updatedTokens["parentScale"] = newTokens["scale"];
        return updatedTokens;
    }
    return newTokens;
}
function $5a49bb477e7b5f89$export$8c51a6ab64fc75e8(component, base, variant, config) {
    for(const prop in variant)if (prop in component) {
        const propValues = Object.keys(variant[prop]);
        const matchIndex = propValues.indexOf($5a49bb477e7b5f89$var$getProp(component, prop));
        if (matchIndex > -1) base = (0, $a996a90891ec663e$export$4950aa0f605343fb)(base, variant[prop][propValues[matchIndex]]);
    } else base = (0, $a996a90891ec663e$export$4950aa0f605343fb)(base, variant[prop][String(config?.[0]?.values?.[0])]);
    return base;
}
function $5a49bb477e7b5f89$var$getProp(component, prop) {
    return Object(component)[prop]?.toString?.() ?? "";
}
function $5a49bb477e7b5f89$export$376823fb52709d2f(component, base, combinations, combinationConfigs, config) {
    combinationConfigs.forEach((combinationConfig, configIndex)=>{
        let partialCombination = combinations[configIndex];
        for (const prop of combinationConfig){
            if (prop in component && component[prop] !== void 0) partialCombination = partialCombination[$5a49bb477e7b5f89$var$getProp(component, prop)];
            else {
                const defaultValue = config?.[prop].values?.[0];
                if (typeof defaultValue !== "undefined") partialCombination = partialCombination[defaultValue.toString()];
            }
            if (!partialCombination) break;
        }
        base = (0, $a996a90891ec663e$export$4950aa0f605343fb)(base, partialCombination);
    });
    return base;
}
function $5a49bb477e7b5f89$export$14c44c1e95c03f0a(json) {
    let combined = {
        ...json.base
    };
    for(const prop in json.variant){
        const propObj = json.variant[prop];
        for(const key in propObj)combined = $5a49bb477e7b5f89$var$mergeWithBooleanAnd(combined, propObj[key]);
    }
    combined = $5a49bb477e7b5f89$var$getAllCombinations(combined, json);
    combined = $5a49bb477e7b5f89$var$combineBehaviors(combined);
    return combined;
}
function $5a49bb477e7b5f89$var$mergeWithBooleanAnd(base, second) {
    const merged = {};
    const keys = [
        ...Object.keys(base),
        ...Object.keys(second)
    ];
    for (const key of keys){
        if (!(key in second)) merged[key] = base[key];
        else if (!(key in base)) merged[key] = second[key];
        else merged[key] = $5a49bb477e7b5f89$var$mergeValues(base[key], second[key]);
    }
    return merged;
}
function $5a49bb477e7b5f89$var$mergeValues(base, second) {
    if ($5a49bb477e7b5f89$var$isObject(base) && $5a49bb477e7b5f89$var$isObject(second)) return $5a49bb477e7b5f89$var$mergeWithBooleanAnd(base, second);
    else if ($5a49bb477e7b5f89$var$isArray(base) && $5a49bb477e7b5f89$var$isArray(second)) return [
        ...base,
        ...second
    ];
    else if (typeof base === "boolean" && typeof second === "boolean") return base && second;
    return second;
}
function $5a49bb477e7b5f89$var$isObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function $5a49bb477e7b5f89$var$isArray(value) {
    return Array.isArray(value);
}
function $5a49bb477e7b5f89$var$getAllCombinations(combined, json) {
    const { combination: combination, combination_config: combination_config } = json;
    if (combination && combination_config) for(let index = 0; index < combination_config.length; index++){
        const config = combination_config[index];
        const comb = combination[index];
        combined = (0, $a996a90891ec663e$export$4950aa0f605343fb)(combined, $5a49bb477e7b5f89$var$getCombination(comb, config));
    }
    return combined;
}
function $5a49bb477e7b5f89$var$combineBehaviors(combined) {
    for(const layer in combined){
        let baseMap = combined[layer];
        for(const pseudo in baseMap.behavior)baseMap = (0, $a996a90891ec663e$export$4950aa0f605343fb)(baseMap, baseMap.behavior[pseudo]);
        combined[layer] = baseMap;
    }
    return combined;
}
function $5a49bb477e7b5f89$var$getCombination(currentCombination, configKeys) {
    if (configKeys.length === 0) return {};
    else if (configKeys.length === 1) {
        const bases = Object.values(currentCombination);
        return (0, $a996a90891ec663e$export$4950aa0f605343fb)(bases[0], ...bases.slice(1));
    }
    const remainingKeys = configKeys.slice(1);
    const combinations = Object.values(currentCombination);
    let result = {};
    for (const comb of combinations){
        const base = $5a49bb477e7b5f89$var$getCombination(comb, remainingKeys);
        result = (0, $a996a90891ec663e$export$4950aa0f605343fb)(result, base);
    }
    return result;
}
const $5a49bb477e7b5f89$var$BufferConverter = (value)=>{
    return $5a49bb477e7b5f89$var$Buffer.from(value, "base64").toString("utf-8");
};
const $5a49bb477e7b5f89$export$9cc362b209501dfe = (value)=>{
    if (!value) return {};
    const converter = typeof window === "undefined" ? $5a49bb477e7b5f89$var$BufferConverter : window.atob;
    const objectString = converter(value);
    return JSON.parse(objectString || "{}");
};
const $5a49bb477e7b5f89$export$b46037aad3580cfb = (value)=>{
    return window.btoa(JSON.stringify(value));
};
const $5a49bb477e7b5f89$export$2b19bce00ae0a812 = /%([A-Za-z]+)/;
function $5a49bb477e7b5f89$export$61b94149aeb1f59(api) {
    const config = api.config;
    const data = api.data;
    const defaultProps = {};
    for(const key in config){
        const item = config[key];
        if (item.values) {
            const index = item.defaultIndex ?? 0;
            const value = item.values[index] ?? item.values[0];
            if (value) defaultProps[key] = value;
        }
    }
    for(const layer in data){
        const datum = data[layer];
        for(const key in datum){
            const item = datum[key];
            if (item.values) {
                const index = item.defaultIndex ?? 0;
                const value = item.values[index] ?? item.values[0];
                if (value) defaultProps[key] = value;
            }
        }
    }
    return defaultProps;
}
function $5a49bb477e7b5f89$export$2ea6a22288ddba23(api) {
    const { data: data, config: config } = api;
    if (config?.["appearance"]) {
        const item = config["appearance"];
        if (item.defaultIndex) return item.values?.[item.defaultIndex].toString() ?? item.values?.[0].toString() ?? "auto";
    } else for(const layer in data){
        const datum = data[layer];
        for(const key in datum){
            const item = datum[key];
            if (item.name === "appearance" && item.type === "enum") return item.values?.[0]?.toString() ?? "auto";
        }
    }
    return "auto";
}
function $5a49bb477e7b5f89$export$bdcbab1cb38db489(val) {
    return typeof val === "string" && /{.*}/.test(val);
}
const $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    return $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$lineHeightCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    if (tokens?.["brandVersion"] === "jio-v2" && !String(value).endsWith("%")) value = `calc(${value} * 1%)`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$colorCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    const originalValue = value;
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    if (String(originalValue).includes("elevated")) {
        const bgVarItems = String(value).split(",");
        const [bgColor, shadowColor, x1, y1, r1, x2, y2, r2, borderColor, borderWidth] = String(bgVarItems[1] || value).split(";");
        return {
            ...$5a49bb477e7b5f89$export$c52007b28a606662(component, layer, rule, bgColor, pseudo, tokens),
            ...borderWidth ? $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, "border-width", `${borderWidth}px`, pseudo, tokens) : {},
            ...x1 || x2 || y1 || y2 || r1 || r2 ? $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, "box-shadow", `${x1}px ${y1}px ${r1}px ${shadowColor}, ${x2}px ${y2}px ${r2}px ${shadowColor}`, pseudo, tokens) : {},
            ...$5a49bb477e7b5f89$export$c52007b28a606662(component, layer, "border-color", `${borderColor}`, pseudo, tokens)
        };
    }
    return $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$isCSSVar = (value)=>value.startsWith("var(--");
const $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler = (component, layer, rule, value, pseudo, _, tokens)=>{
    const supportedValues = [
        "100%",
        "fit-content",
        "max",
        "min",
        "intrinsicSize.max",
        "intrinsicSize.min"
    ];
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    const layerParts = layer.split("-");
    const baseLayer = layerParts[layerParts.length - 1];
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    if (!supportedValues.includes(value) && !$5a49bb477e7b5f89$var$isCSSVar(value)) {
        if (isNaN(parseFloat(value))) value = $5a49bb477e7b5f89$export$bb974f6f0c330fb[baseLayer]?.[rule];
    }
    if (value === "max") value = "100%";
    if (value === "min") value = "fit-content";
    if (value === "intrinsicSize.max") value = "unset";
    return $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$borderGradientColorCSSVarRuleHandler = (component, layer, _, value, pseudo)=>{
    if (typeof value === "object") return $5a49bb477e7b5f89$var$handleBorderGradientColorObject(component, layer, "border-image", value, pseudo);
    return $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(component, layer, "border-image", value, pseudo);
};
const $5a49bb477e7b5f89$var$backgroundGradientColorCSSVarRuleHandler = (component, layer, _, value, pseudo)=>{
    if (typeof value === "object") return $5a49bb477e7b5f89$var$handleBackgroundGradientColorObject(component, layer, "background-image", value, pseudo);
    return $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(component, layer, "background-image", value, pseudo);
};
const $5a49bb477e7b5f89$var$handleBackgroundGradientColorObject = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    const { type: type, colors: colors, angle: angle } = ruleVal;
    const colorStops = Array.from(colors).join(",");
    if (type === "radial") {
        const resolvedValue = `radial-gradient(circle, ${colorStops})`;
        return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
    } else if (type === "linear") {
        const degAngle = $5a49bb477e7b5f89$export$95c38a73fd251991("rotate", angle ?? 180);
        const resolvedValue = `linear-gradient(${degAngle}, ${colorStops})`;
        return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
    }
    console.warn("Unknown background gradient in", componentName, layer);
    return {};
};
const $5a49bb477e7b5f89$var$handleBorderGradientColorObject = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    const { type: type, colors: colors, width: width } = ruleVal;
    const typeMap = {
        radial: "radial-gradient",
        linear: "linear-gradient"
    };
    const colorStops = colors.join(",");
    const resolvedValue = `${typeMap[type]}(circle,${colorStops}) ${width}`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, resolvedValue, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$sizeCSSVarRuleHandler = (component, layer, _rule, value, pseudo, layerMap, tokens)=>({
        ...$5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(component, layer, "height", value, pseudo, layerMap, tokens),
        ...$5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler(component, layer, "width", value, pseudo, layerMap, tokens)
    });
const $5a49bb477e7b5f89$var$boxShadowCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, layerMap, tokens)=>{
    if (typeof ruleVal === "object") return $5a49bb477e7b5f89$var$handleBoxShadowObject(componentName, layer, rule, ruleVal, pseudo, tokens);
    return $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(componentName, layer, rule, ruleVal, pseudo, layerMap, tokens);
};
const $5a49bb477e7b5f89$var$boxShadowOrderedKeys = [
    "x",
    "y",
    "blur",
    "spread",
    "color"
];
const $5a49bb477e7b5f89$var$BOX_SHADOW_RULE_MAP = {
    x: "padding",
    y: "padding",
    blur: "padding",
    spread: "padding",
    color: "color"
};
function $5a49bb477e7b5f89$var$handleBoxShadowObject(componentName, layer, rule, ruleVal, pseudo, tokens) {
    const values = [];
    for (const key of $5a49bb477e7b5f89$var$boxShadowOrderedKeys){
        if (!(key in ruleVal)) continue;
        const value = ruleVal[key];
        const rule2 = $5a49bb477e7b5f89$var$BOX_SHADOW_RULE_MAP[key];
        const resolved = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule2, value, tokens);
        values.push(resolved);
    }
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, values.join(" "), pseudo, tokens);
}
const $5a49bb477e7b5f89$var$flexDirectionCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    const result = {};
    let position = "static";
    if (value.includes("stack")) {
        value = "row";
        position = "relative";
    }
    Object.assign(result, $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens), $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, "position", position, pseudo, tokens));
    return result;
};
const $5a49bb477e7b5f89$var$borderWidthCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _, tokens)=>{
    if (typeof ruleVal === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    ruleVal = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, ruleVal, tokens);
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, ruleVal, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$blurRadiusCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>{
    if (rule === "blur-radius") rule = "filter";
    else rule = "backdrop-filter";
    if (typeof ruleVal === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    ruleVal = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, ruleVal, tokens);
    ruleVal = `blur(${ruleVal})`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, "filter", ruleVal, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$borderRulesMap = {
    "border-radius": [
        "border-top-left-radius",
        "border-top-right-radius",
        "border-bottom-right-radius",
        "border-bottom-left-radius"
    ],
    "border-width": [
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width"
    ],
    "border-color": [
        "border-top-color",
        "border-right-color",
        "border-bottom-color",
        "border-left-color"
    ]
};
function $5a49bb477e7b5f89$var$getBorderRules(rule) {
    return $5a49bb477e7b5f89$var$borderRulesMap[rule] || [];
}
const $5a49bb477e7b5f89$var$borderCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, _layerMap, tokens)=>$5a49bb477e7b5f89$var$getBorderRules(rule).map((r)=>{
        if (typeof ruleVal === "object") {
            console.warn("Cannot process Object directly");
            return {};
        }
        ruleVal = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, ruleVal, tokens);
        return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, r, ruleVal, pseudo, tokens);
    }).reduce((a, b)=>({
            ...a,
            ...b
        }), {});
const $5a49bb477e7b5f89$var$zIndexCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    let position = "static";
    const num = parseInt(value);
    if (num !== 0) position = "absolute";
    return {
        ...$5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens),
        ...$5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, "position", position, pseudo, tokens)
    };
};
const $5a49bb477e7b5f89$var$disabledCSSVarRuleHandler = (component, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2("pointer-events", value, tokens);
    value = !value || value === "false" ? "auto" : "none";
    return $5a49bb477e7b5f89$export$c52007b28a606662(component, layer, "pointer-events", value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$paddingCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    const paddingValue = $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
    const direction = rule.split("-")[1];
    const borderWidthRule = `border-${direction}-width`;
    const borderWidthValue = layerMap?.[borderWidthRule] || layerMap?.["border-width"];
    if (borderWidthValue) {
        const borderWidthCSSVar = $5a49bb477e7b5f89$var$borderWidthCSSVarRuleHandler(componentName, layer, borderWidthRule, borderWidthValue, pseudo, layerMap, tokens);
        const val = Object.values(borderWidthCSSVar)[0];
        if (val) {
            const key = Object.keys(paddingValue)[0];
            paddingValue[key] = `calc(${paddingValue[key]} - ${val})`;
        }
    }
    return paddingValue;
};
const $5a49bb477e7b5f89$var$buttonVectorRuleMap = {
    "fill-color": "color",
    "stroke-color": "color"
};
const $5a49bb477e7b5f89$var$skeletonRuleMap = {
    "primary-color": "color",
    "secondary-color": "color"
};
const $5a49bb477e7b5f89$var$inputRuleMap = {
    "inactive-color": "color",
    "active-color": "color",
    "ball-size": "height",
    "ball-color": "color",
    "ball-border-color": "color",
    "ball-border-width": "border-width",
    "track-height": "height",
    "placeholder-color": "color",
    "placeholder-font-family": "font-family",
    "placeholder-font-size": "font-size",
    "placeholder-line-height": "line-height",
    "placeholder-letter-spacing": "letter-spacing",
    "placeholder-font-weight": "font-weight",
    "input-color": "color",
    "input-font-family": "font-family",
    "input-font-size": "font-size",
    "input-line-height": "line-height",
    "input-letter-spacing": "letter-spacing",
    "input-font-weight": "font-weight",
    "resize-color": "color",
    "cursor-color": "color"
};
const $5a49bb477e7b5f89$var$inputCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2($5a49bb477e7b5f89$var$inputRuleMap[rule], value, tokens);
    if (rule === "input-line-height") return $5a49bb477e7b5f89$var$lineHeightCSSVarRuleHandler(componentName, layer, rule, value, pseudo, _, tokens);
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$buttonVectorCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2($5a49bb477e7b5f89$var$buttonVectorRuleMap[rule], value, tokens);
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, `--${rule}`, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$cursorCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>$5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(componentName, layer, "cursor", value, pseudo, layerMap, tokens);
const $5a49bb477e7b5f89$var$skeletonCSSVarRuleHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2($5a49bb477e7b5f89$var$skeletonRuleMap[rule], value, tokens);
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$transitonTimingFunctionHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    value = `cubic-bezier${value}`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$transitonDurationHandler = (componentName, layer, rule, value, pseudo, _layerMap, tokens)=>{
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    rule = "transition-duration";
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$transformCSSVarRuleHandler = (componentName, layer, rule, ruleVal, pseudo, layerMap, tokens)=>{
    const [ruleName, direction] = rule.split("-");
    if (!direction) return $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(componentName, layer, ruleName, ruleVal, pseudo, layerMap, tokens);
    if (direction) {
        if (typeof ruleVal === "object") {
            console.warn("Cannot process Object directly");
            return {};
        }
        ruleVal = $5a49bb477e7b5f89$export$37bc2ce5722481d2(ruleName, ruleVal, tokens);
        if (ruleName === "rotate") ruleVal = `${direction} ${ruleVal}`;
        return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, ruleVal, pseudo, tokens);
    }
    return {};
};
const $5a49bb477e7b5f89$var$TRANSITION_PROPERTY_MAP = {
    "translate-x": "translate",
    "translate-y": "translate",
    "translate-z": "translate",
    "scale-x": "scale",
    "scale-y": "scale",
    "scale-z": "scale",
    "rotate-x": "rotate",
    "rotate-y": "rotate",
    "rotate-z": "rotate"
};
const $5a49bb477e7b5f89$var$transitionCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>{
    if (typeof value !== "object" || !value) {
        console.warn("Transition needs to be object.");
        return {};
    }
    const { property: property, duration: duration, "timing-function": timingFunction, delay: delay } = value;
    const result = {};
    if (property) {
        const props = Array().concat(property);
        Object.assign(result, $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(componentName, layer, "transition-property", props.map((prop)=>$5a49bb477e7b5f89$var$TRANSITION_PROPERTY_MAP[prop] ?? prop).join(", "), pseudo, layerMap, tokens));
    }
    if (duration) Object.assign(result, $5a49bb477e7b5f89$var$transitonDurationHandler(componentName, layer, "transition-duration", duration, pseudo, layerMap, tokens));
    if (timingFunction) Object.assign(result, $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(componentName, layer, "transition-timing-function", timingFunction, pseudo, layerMap, tokens));
    if (delay) Object.assign(result, $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler(componentName, layer, "transition-delay", delay, pseudo, layerMap, tokens));
    return result;
};
const $5a49bb477e7b5f89$var$clipFirstHalfCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    const rule = "clip-path";
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value);
    const baseVar = $5a49bb477e7b5f89$export$437bd2c771393299(componentName, layer, "--clip-value", tokens?.["brandVersion"] === "jio-v2");
    if (value) value = `inset(0 var(${baseVar}, 0) 0 0)`;
    else value = `inset(0 0 0 var(${baseVar}, 0))`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$clipValueCSSVarRuleHandler = (componentName, layer, _rule, value, pseudo, layerMap, tokens)=>{
    const rule = "clip-path";
    if (typeof value === "object") {
        console.warn("Cannot process Object directly");
        return {};
    }
    value = $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens);
    const clipFirstHalf = layerMap?.["clip-first-half"];
    if (clipFirstHalf) value = `inset(0 ${value ?? 0} 0 0)`;
    else value = `inset(0 0 0 ${value ?? 0})`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, rule, value, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$linearGradientOpacityHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (!Array.isArray(value)) {
        console.warn("Invalid color format", value);
        return {};
    }
    const cssVars = value.map((value2, i)=>{
        const numberValue = value2.split("%")[0];
        const decimalValue = parseFloat(numberValue) + "%";
        return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, "linear-gradient-opacity-" + i, decimalValue, pseudo, tokens);
    });
    return cssVars.reduce((acc, cssVar)=>({
            ...acc,
            ...cssVar
        }), {});
};
const $5a49bb477e7b5f89$var$linearGradientHandler = (componentName, layer, _rule, value, pseudo, _layerMap, tokens)=>{
    if (!Array.isArray(value)) {
        console.warn("Invalid color format", value);
        return {};
    }
    const colors = value.map((value2, i)=>{
        const color = $5a49bb477e7b5f89$export$6a176e754d54672("color", value2, tokens || {});
        const opacity = `var(--${componentName.toLowerCase()}--${layer}-linear-gradient-opacity-${i})`;
        if (color.startsWith("oklch")) return `oklch(from ${color} l c h / ${opacity})`;
        const { r: r, g: g, b: b } = (0, $a996a90891ec663e$export$848d71df1f759bc)(color);
        return `rgba(${r},${g},${b}, )`;
    });
    const endCSSVar = `var(--${componentName.toLowerCase()}--${layer}-linear-gradient-end,bottom)`;
    const gradient = `linear-gradient(to ${endCSSVar},${colors.join(",")} )`;
    return $5a49bb477e7b5f89$export$c52007b28a606662(componentName, layer, "background-image", gradient, pseudo, tokens);
};
const $5a49bb477e7b5f89$var$transitionCSSVarRules = {
    "transition-timing-function": $5a49bb477e7b5f89$var$transitonTimingFunctionHandler,
    "transition-duration": $5a49bb477e7b5f89$var$transitonDurationHandler,
    "transition-property": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "transition-delay": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    transition: $5a49bb477e7b5f89$var$transitionCSSVarRuleHandler,
    "enter-animation-duration": $5a49bb477e7b5f89$var$transitonDurationHandler,
    "exit-animation-duration": $5a49bb477e7b5f89$var$transitonDurationHandler,
    "animation-duration": $5a49bb477e7b5f89$var$transitonDurationHandler
};
const $5a49bb477e7b5f89$var$inputCSSVarRules = {
    "inactive-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "active-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "ball-size": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "ball-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "ball-border-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "ball-border-width": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "track-height": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "placeholder-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "placeholder-font-family": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "placeholder-font-size": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "placeholder-line-height": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "placeholder-letter-spacing": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "placeholder-font-weight": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "input-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "input-font-family": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "input-font-size": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "input-line-height": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "input-letter-spacing": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "input-font-weight": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "resize-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler,
    "cursor-color": $5a49bb477e7b5f89$var$inputCSSVarRuleHandler
};
const $5a49bb477e7b5f89$var$skeletonCSSVarRules = {
    "primary-color": $5a49bb477e7b5f89$var$skeletonCSSVarRuleHandler,
    "secondary-color": $5a49bb477e7b5f89$var$skeletonCSSVarRuleHandler
};
const $5a49bb477e7b5f89$var$buttonVectorCSSVarRules = {
    "fill-color": $5a49bb477e7b5f89$var$buttonVectorCSSVarRuleHandler,
    "stroke-color": $5a49bb477e7b5f89$var$buttonVectorCSSVarRuleHandler
};
const $5a49bb477e7b5f89$var$clipCSSVarRules = {
    "clip-first-half": $5a49bb477e7b5f89$var$clipFirstHalfCSSVarRuleHandler,
    "clip-value": $5a49bb477e7b5f89$var$clipValueCSSVarRuleHandler
};
const $5a49bb477e7b5f89$export$95994f4e1548c018 = {
    "align-items": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "aspect-ratio": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "background-blur": $5a49bb477e7b5f89$var$blurRadiusCSSVarRuleHandler,
    "background-gradient-color": $5a49bb477e7b5f89$var$backgroundGradientColorCSSVarRuleHandler,
    "background-image": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "background-repeat": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "blur-radius": $5a49bb477e7b5f89$var$blurRadiusCSSVarRuleHandler,
    "border-color": $5a49bb477e7b5f89$var$borderCSSVarRuleHandler,
    "border-radius": $5a49bb477e7b5f89$var$borderCSSVarRuleHandler,
    "border-style": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-width": $5a49bb477e7b5f89$var$borderCSSVarRuleHandler,
    "border-top-width": $5a49bb477e7b5f89$var$borderWidthCSSVarRuleHandler,
    "border-right-width": $5a49bb477e7b5f89$var$borderWidthCSSVarRuleHandler,
    "border-bottom-width": $5a49bb477e7b5f89$var$borderWidthCSSVarRuleHandler,
    "border-left-width": $5a49bb477e7b5f89$var$borderWidthCSSVarRuleHandler,
    "border-top-color": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-right-color": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-bottom-color": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-left-color": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-gradient-color": $5a49bb477e7b5f89$var$borderGradientColorCSSVarRuleHandler,
    "border-top-left-radius": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-top-right-radius": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-bottom-right-radius": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "border-bottom-left-radius": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    bottom: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "box-shadow": $5a49bb477e7b5f89$var$boxShadowCSSVarRuleHandler,
    "box-sizing": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    cursor: $5a49bb477e7b5f89$var$cursorCSSVarRuleHandler,
    display: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    disabled: $5a49bb477e7b5f89$var$disabledCSSVarRuleHandler,
    flex: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "flex-shrink": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "flex-direction": $5a49bb477e7b5f89$var$flexDirectionCSSVarRuleHandler,
    "flex-wrap": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "font-family": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "font-size": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "font-weight": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    gap: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    height: $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler,
    "justify-content": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    left: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "letter-spacing": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "line-height": $5a49bb477e7b5f89$var$lineHeightCSSVarRuleHandler,
    "max-height": $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler,
    "max-width": $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler,
    "min-height": $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler,
    "min-width": $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler,
    opacity: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    outline: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    overflow: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "padding-bottom": $5a49bb477e7b5f89$var$paddingCSSVarRuleHandler,
    "padding-left": $5a49bb477e7b5f89$var$paddingCSSVarRuleHandler,
    "padding-right": $5a49bb477e7b5f89$var$paddingCSSVarRuleHandler,
    "padding-top": $5a49bb477e7b5f89$var$paddingCSSVarRuleHandler,
    "pointer-events": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    position: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    right: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    rotate: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "rotate-x": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "rotate-y": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "rotate-z": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    translate: $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "translate-x": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "translate-y": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "translate-z": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    scale: $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "scale-x": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "scale-y": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "scale-z": $5a49bb477e7b5f89$var$transformCSSVarRuleHandler,
    "text-align": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "text-decoration": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "text-overflow": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "text-transform": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "object-fit": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "object-position": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    size: $5a49bb477e7b5f89$var$sizeCSSVarRuleHandler,
    up: $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "web-cursor": $5a49bb477e7b5f89$var$cursorCSSVarRuleHandler,
    width: $5a49bb477e7b5f89$var$dimensionsCSSVarRuleHandler,
    "z-index": $5a49bb477e7b5f89$var$zIndexCSSVarRuleHandler,
    "linear-gradient-start": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "linear-gradient-end": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    "linear-gradient-colors": $5a49bb477e7b5f89$var$linearGradientHandler,
    "linear-gradient-opacity": $5a49bb477e7b5f89$var$linearGradientOpacityHandler,
    ...$5a49bb477e7b5f89$var$inputCSSVarRules,
    ...$5a49bb477e7b5f89$var$skeletonCSSVarRules,
    ...$5a49bb477e7b5f89$var$transitionCSSVarRules,
    ...$5a49bb477e7b5f89$var$buttonVectorCSSVarRules,
    ...$5a49bb477e7b5f89$var$clipCSSVarRules,
    "font-style": $5a49bb477e7b5f89$var$defaultCSSVarRuleHandler,
    color: $5a49bb477e7b5f89$var$colorCSSVarRuleHandler,
    "background-color": $5a49bb477e7b5f89$var$colorCSSVarRuleHandler
};
function $5a49bb477e7b5f89$export$37bc2ce5722481d2(rule, value, tokens) {
    if (value?.toString().includes("&")) return $5a49bb477e7b5f89$export$6a176e754d54672(rule, String(value), tokens || {});
    if ($5a49bb477e7b5f89$export$bdcbab1cb38db489(value)) value = $5a49bb477e7b5f89$export$6404fd1becf96b61(rule, value);
    else value = $5a49bb477e7b5f89$export$95c38a73fd251991(rule, value);
    return value;
}
const $5a49bb477e7b5f89$export$585f0f7ef40c9f0 = (tokenString)=>`--${(0, $a996a90891ec663e$export$3e672a90535a3744)((0, $a996a90891ec663e$export$5fe300a9008e2bfc)(tokenString.replace(/\./g, "-")))}`;
class $5a49bb477e7b5f89$var$Color {
    color;
    colorInstance;
    alpha = 1;
    constructor(color, alpha = 1){
        this.color = color;
        this.alpha = alpha;
        if (!this.colorInstance) this.colorInstance = new $5a49bb477e7b5f89$var$Color(color);
    }
    to(format) {
        console.info(format);
        return this.colorInstance;
    }
    toString(data) {
        console.info(data);
        return this.color;
    }
    mix(color, value) {
        console.info(color, value);
        return this.colorInstance;
    }
}
const $5a49bb477e7b5f89$var$alphaColorModifier = (hexColor, alpha)=>{
    let color = new $5a49bb477e7b5f89$var$Color(hexColor);
    color = color.to("hsl");
    color.alpha = Math.max(0, Math.min(1, Number(alpha)));
    const newColor = new $5a49bb477e7b5f89$var$Color(color.toString({
        inGamut: true,
        precision: 3
    }));
    return newColor.to("srgb").toString({
        format: "hex"
    });
};
const $5a49bb477e7b5f89$var$mixColorModifier = (firstColor, secondColor, parameter)=>{
    const color = new $5a49bb477e7b5f89$var$Color(firstColor);
    const mixColor = new $5a49bb477e7b5f89$var$Color(secondColor.toString());
    const mixValue = Math.max(0, Math.min(1, Number(parameter)));
    const newColor = new $5a49bb477e7b5f89$var$Color(color.mix(mixColor, mixValue).toString({}));
    return newColor.to("srgb").toString({
        format: "hex"
    });
};
const $5a49bb477e7b5f89$var$COLOR_MODIFIER_MAP = {
    alpha: $5a49bb477e7b5f89$var$alphaColorModifier,
    mix: $5a49bb477e7b5f89$var$mixColorModifier
};
const $5a49bb477e7b5f89$var$functionRegex = /(\w+)\(([\w.# ,-]+)\)/;
const $5a49bb477e7b5f89$var$mulRegex = /(-?[\d.]+)\*(-?[\d.]+)/;
const $5a49bb477e7b5f89$var$divRegex = /(-?[\d.]+)\/(-?[\d.]+)/;
const $5a49bb477e7b5f89$var$addRegex = /(-?[\d.]+)\+(-?[\d.]+)/;
const $5a49bb477e7b5f89$var$subRegex = /(-?[\d.]+)-(-?[\d.]+)/;
const $5a49bb477e7b5f89$var$expRegex = /(-?[\d.]+)\^(-?[\d.]+)/;
const $5a49bb477e7b5f89$var$parensRegex = /\((-?[\d.]+)\)/;
function $5a49bb477e7b5f89$var$colorModify(args) {
    const [type, ...values] = args;
    try {
        return $5a49bb477e7b5f89$var$COLOR_MODIFIER_MAP[type](...values);
    } catch (e) {
        console.warn("wrong input for type in colorModifier: ", type);
        return "";
    }
}
const $5a49bb477e7b5f89$var$functionMap = {
    floor: ([value])=>Math.floor(parseFloat(value)).toString(),
    round: ([value])=>Math.round(parseFloat(value)).toString(),
    min: (args)=>Math.min(...args.map(parseFloat)).toString(),
    max: (args)=>Math.max(...args.map(parseFloat)).toString(),
    colorModify: $5a49bb477e7b5f89$var$colorModify
};
const $5a49bb477e7b5f89$var$operators = [
    [
        $5a49bb477e7b5f89$var$expRegex,
        (first, second)=>(parseFloat(first) ** parseFloat(second)).toString()
    ],
    [
        $5a49bb477e7b5f89$var$mulRegex,
        (first, second)=>(parseFloat(first) * parseFloat(second)).toString()
    ],
    [
        $5a49bb477e7b5f89$var$divRegex,
        (first, second)=>(parseFloat(first) / parseFloat(second)).toString()
    ],
    [
        $5a49bb477e7b5f89$var$addRegex,
        (first, second)=>(parseFloat(first) + parseFloat(second)).toString()
    ],
    [
        $5a49bb477e7b5f89$var$subRegex,
        (first, second)=>(parseFloat(first) - parseFloat(second)).toString()
    ],
    [
        $5a49bb477e7b5f89$var$functionRegex,
        (name, argsString)=>{
            if (name in $5a49bb477e7b5f89$var$functionMap) return $5a49bb477e7b5f89$var$functionMap[name](argsString.split(","));
            return "";
        }
    ],
    [
        $5a49bb477e7b5f89$var$parensRegex,
        (value)=>value
    ]
];
function $5a49bb477e7b5f89$var$parseMaths(key) {
    if (!$5a49bb477e7b5f89$var$operators.find(([op])=>op.test(key))) return key;
    let value = key.replace(/[ ']/g, "");
    let operator;
    while(operator = $5a49bb477e7b5f89$var$operators.find(([op])=>op.test(value))){
        const [op, callback] = operator;
        const match = value.match(op);
        if (match) {
            const left = match[1];
            const right = match[2];
            const replacement = callback(left, right);
            const replaced = value.replace(op, replacement);
            if (replaced === "") break;
            value = replaced.replace(/ /g, "");
        }
    }
    return value;
}
const $5a49bb477e7b5f89$var$colorJsons = [
    "color"
];
const $5a49bb477e7b5f89$var$borderRadiusJsons = [
    "borderRadius"
];
const $5a49bb477e7b5f89$var$sizeJsons = [
    "sizing",
    "layout"
];
const $5a49bb477e7b5f89$var$borderWidthJsons = [
    "borderWidth",
    ...$5a49bb477e7b5f89$var$sizeJsons
];
const $5a49bb477e7b5f89$var$letterSpacingJSONs = [
    "letterSpacing",
    "typography"
];
const $5a49bb477e7b5f89$var$fontSizeJsons = [
    "fontSizes"
];
const $5a49bb477e7b5f89$var$lineHeightJsons = [
    "lineHeights",
    "typography"
];
const $5a49bb477e7b5f89$var$fontFamilyJsons = [
    "fontFamilies",
    "typography"
];
const $5a49bb477e7b5f89$var$fontWeightJsons = [
    "fontWeights",
    "typography"
];
const $5a49bb477e7b5f89$var$spacingJsons = [
    "spacing"
];
const $5a49bb477e7b5f89$var$otherJsons = [
    "layout"
];
const $5a49bb477e7b5f89$var$opacityJsons = [
    "opacity"
];
const $5a49bb477e7b5f89$var$shadowsJsons = [
    "shadows"
];
const $5a49bb477e7b5f89$var$textDecorationJsons = [
    "textDecoration"
];
const $5a49bb477e7b5f89$var$textTransformJsons = [
    "textCase"
];
const $5a49bb477e7b5f89$var$transitionDurationJSONs = [
    "transitionsDuration"
];
const $5a49bb477e7b5f89$var$transitionTimingFunctionJSONs = [
    "transitions"
];
const $5a49bb477e7b5f89$export$a8c2fb75d5b0e0e = {
    "background-color": $5a49bb477e7b5f89$var$colorJsons,
    "background-image": $5a49bb477e7b5f89$var$colorJsons,
    "border-color": $5a49bb477e7b5f89$var$colorJsons,
    "border-top-color": $5a49bb477e7b5f89$var$colorJsons,
    "border-right-color": $5a49bb477e7b5f89$var$colorJsons,
    "border-bottom-color": $5a49bb477e7b5f89$var$colorJsons,
    "border-left-color": $5a49bb477e7b5f89$var$colorJsons,
    color: $5a49bb477e7b5f89$var$colorJsons,
    "border-radius": $5a49bb477e7b5f89$var$borderRadiusJsons,
    "border-top-left-radius": $5a49bb477e7b5f89$var$borderRadiusJsons,
    "border-top-right-radius": $5a49bb477e7b5f89$var$borderRadiusJsons,
    "border-bottom-right-radius": $5a49bb477e7b5f89$var$borderRadiusJsons,
    "border-bottom-left-radius": $5a49bb477e7b5f89$var$borderRadiusJsons,
    "border-width": $5a49bb477e7b5f89$var$borderWidthJsons,
    "border-top-width": $5a49bb477e7b5f89$var$borderWidthJsons,
    "border-right-width": $5a49bb477e7b5f89$var$borderWidthJsons,
    "border-bottom-width": $5a49bb477e7b5f89$var$borderWidthJsons,
    "border-left-width": $5a49bb477e7b5f89$var$borderWidthJsons,
    "blur-radius": $5a49bb477e7b5f89$var$sizeJsons,
    filter: $5a49bb477e7b5f89$var$sizeJsons,
    height: $5a49bb477e7b5f89$var$sizeJsons,
    "max-height": $5a49bb477e7b5f89$var$sizeJsons,
    "min-height": $5a49bb477e7b5f89$var$sizeJsons,
    width: $5a49bb477e7b5f89$var$sizeJsons,
    "max-width": $5a49bb477e7b5f89$var$sizeJsons,
    "min-width": $5a49bb477e7b5f89$var$sizeJsons,
    size: $5a49bb477e7b5f89$var$sizeJsons,
    "font-size": $5a49bb477e7b5f89$var$fontSizeJsons,
    "line-height": $5a49bb477e7b5f89$var$lineHeightJsons,
    "font-family": $5a49bb477e7b5f89$var$fontFamilyJsons,
    "font-weight": $5a49bb477e7b5f89$var$fontWeightJsons,
    gap: $5a49bb477e7b5f89$var$spacingJsons,
    padding: $5a49bb477e7b5f89$var$spacingJsons,
    "padding-left": $5a49bb477e7b5f89$var$spacingJsons,
    "padding-right": $5a49bb477e7b5f89$var$spacingJsons,
    "padding-top": $5a49bb477e7b5f89$var$spacingJsons,
    "padding-bottom": $5a49bb477e7b5f89$var$spacingJsons,
    "box-shadow": $5a49bb477e7b5f89$var$shadowsJsons,
    "text-decoration": $5a49bb477e7b5f89$var$textDecorationJsons,
    opacity: $5a49bb477e7b5f89$var$opacityJsons,
    "aspect-ratio": $5a49bb477e7b5f89$var$otherJsons,
    "flex-direction": $5a49bb477e7b5f89$var$otherJsons,
    "align-items": $5a49bb477e7b5f89$var$otherJsons,
    "justify-content": $5a49bb477e7b5f89$var$otherJsons,
    display: $5a49bb477e7b5f89$var$otherJsons,
    "font-style": $5a49bb477e7b5f89$var$otherJsons,
    outline: $5a49bb477e7b5f89$var$otherJsons,
    "text-align": $5a49bb477e7b5f89$var$otherJsons,
    rotate: $5a49bb477e7b5f89$var$otherJsons,
    "letter-spacing": $5a49bb477e7b5f89$var$letterSpacingJSONs,
    "border-gradient-color": $5a49bb477e7b5f89$var$colorJsons,
    "linear-gradient-colors": $5a49bb477e7b5f89$var$colorJsons,
    "text-transform": $5a49bb477e7b5f89$var$textTransformJsons,
    "enter-animation-duration": $5a49bb477e7b5f89$var$transitionDurationJSONs,
    "exit-animation-duration": $5a49bb477e7b5f89$var$transitionDurationJSONs,
    "transition-timing-function": $5a49bb477e7b5f89$var$transitionTimingFunctionJSONs,
    "transition-duration": $5a49bb477e7b5f89$var$transitionDurationJSONs,
    "transition-property": $5a49bb477e7b5f89$var$otherJsons
};
const $5a49bb477e7b5f89$var$RN_TOKEN_OVERRIDES = {
    "{label.3xs.lineheight}": "110.00000238418579"
};
class $5a49bb477e7b5f89$export$859883d4ec9c7db4 {
    static constants = {};
    static defaults;
    static fetchTokenMemo = {};
    static switchablesMemo = {};
    static componentTokensMemo = {};
    static brandSwitchableFn;
    static updateFlatTokens;
    static brandResolverFn;
    static brandComponentFn;
    static getDensityMap;
    static getColorsMap;
    static getSwitchables(tokens) {
        const tokensKey = JSON.stringify(tokens);
        const switchables = this.switchablesMemo[tokensKey] ?? this.brandSwitchableFn?.(tokens) ?? {};
        this.switchablesMemo[tokensKey] = switchables;
        return switchables;
    }
    /**
   * Use this to register the brand provided by the user
   * @param brand The brand object to register
   */ static registerBrand(brand) {
        this.constants = brand.tokens;
        this.defaults = brand.defaults;
        this.brandSwitchableFn = brand.getSwitchableTokens;
        this.brandComponentFn = brand.getComponentTokens;
        this.brandResolverFn = brand.brandResolverFn;
        this.updateFlatTokens = brand.updateFlatTokens;
        this.getDensityMap = brand.getDensityMap;
        this.getColorsMap = brand.getColorsMap;
        this.fetchTokenMemo = {};
        this.switchablesMemo = {};
        this.componentTokensMemo = {};
    }
    static registerAdditionalTokens(tokens) {
        this.constants["extras"] = tokens;
    }
    static getValue(rule, key, tokens, forceValue) {
        if ($5a49bb477e7b5f89$export$859883d4ec9c7db4.brandResolverFn && String(key).includes("&")) {
            const { value: brandValue, key: brandKey } = $5a49bb477e7b5f89$export$859883d4ec9c7db4.brandResolverFn(rule, key, tokens || {}, forceValue) ?? {};
            if (brandKey) {
                if (!forceValue) return `var(${$5a49bb477e7b5f89$export$585f0f7ef40c9f0(brandKey.replace(/f-(\d+)/, "f-m$1"))})`;
                return brandValue;
            }
            if (typeof brandValue !== "undefined") return $5a49bb477e7b5f89$export$95c38a73fd251991(rule, brandValue);
        }
        const [jsonKey, ...fallbacks] = $5a49bb477e7b5f89$export$a8c2fb75d5b0e0e[rule] ?? [];
        if (!jsonKey) return void 0;
        let json = this.constants[jsonKey];
        const switchables = this.getSwitchables(tokens);
        if (!json) json = switchables?.[jsonKey];
        if (this.constants["extras"]) fallbacks.push("extras");
        let value = json?.[key];
        if (value === void 0) for (const fallback2 of fallbacks){
            json = this.constants[fallback2] ?? switchables?.[fallback2];
            value = json?.[key];
            if (value !== void 0) break;
        }
        return value;
    }
    static getComponentToken(key, metaCompName) {
        key = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(key);
        if (metaCompName in this.componentTokensMemo) return this.componentTokensMemo[metaCompName]?.[key];
        const compTokens = this.brandComponentFn?.(metaCompName);
        this.componentTokensMemo[metaCompName] = compTokens;
        return compTokens?.[key];
    }
    static getApplicableTokens(tokens) {
        const switchables = this.getSwitchables(tokens);
        const merged = (0, $a996a90891ec663e$export$4950aa0f605343fb)(this.constants, switchables);
        const tokenKeys = Object.keys(tokens);
        const result = {};
        for(const folderKey in merged){
            const folder = merged[folderKey];
            const filtered = Object.entries(folder || {}).reduce((acc, [key, value])=>{
                if (typeof value === "string" && tokenKeys.some((token)=>value.includes(`$${token}`))) acc[key] = value;
                return acc;
            }, {});
            result[folderKey] = filtered;
        }
        return result;
    }
}
const $5a49bb477e7b5f89$var$assignTypes = {
    sizing: "size",
    spacing: "padding",
    "font-families": "font-family",
    "font-sizes": "font-size",
    "font-weights": "font-weight",
    "line-heights": "line-height",
    "text-case": "text-transform",
    "transitions-duration": "transition-duration",
    transitions: "transition-timing-function",
    typography: "font-family",
    lineHeights: "line-height",
    fontFamilies: "font-family",
    letterSpacing: "letter-spacing",
    fontWeights: "font-weight",
    fontSizes: "font-size",
    textCase: "text-transform",
    platform: "size"
};
function $5a49bb477e7b5f89$export$c59eaf4f26921ab2(folder, key, tokens) {
    const rule = $5a49bb477e7b5f89$var$assignTypes[folder] ?? folder;
    return $5a49bb477e7b5f89$export$6a176e754d54672(rule, key, tokens);
}
function $5a49bb477e7b5f89$export$6a176e754d54672(rule, key, tokens, forceValue = false) {
    const memoKey = $5a49bb477e7b5f89$var$getMemoKey(rule, key, tokens);
    if (memoKey in $5a49bb477e7b5f89$export$859883d4ec9c7db4.fetchTokenMemo) return $5a49bb477e7b5f89$export$859883d4ec9c7db4.fetchTokenMemo[memoKey];
    let raw = $5a49bb477e7b5f89$var$parseKey(rule, key, tokens, forceValue);
    if ($5a49bb477e7b5f89$var$RN_TOKEN_OVERRIDES[key]) raw = $5a49bb477e7b5f89$var$RN_TOKEN_OVERRIDES[key];
    let value = String(key)?.includes("column") ? raw : $5a49bb477e7b5f89$export$95c38a73fd251991(rule, raw);
    if (rule === "line-height" && tokens?.["brandVersion"] === "jio-v2") value = value.replace("px", "%");
    if ($5a49bb477e7b5f89$export$a8c2fb75d5b0e0e[rule]?.includes("sizing")) {
        value = value === "max" ? "100%" : value;
        value = value === "min" ? "100%" : value;
        value = value === "negativeMax" ? "-100%" : value;
        value = value === "intrinsicSize.max" ? "max-content" : value;
    }
    if (rule?.includes("transition-timing-function")) value = `cubic-bezier(${value})`;
    $5a49bb477e7b5f89$export$859883d4ec9c7db4.fetchTokenMemo[memoKey] = value;
    return value;
}
const $5a49bb477e7b5f89$var$getNestedFallbacks = (variables)=>{
    if (variables.length > 1) return `var(${variables[0]}, ${$5a49bb477e7b5f89$var$getNestedFallbacks(variables.slice(1))})`;
    return `var(${variables[0]})`;
};
function $5a49bb477e7b5f89$export$6404fd1becf96b61(rule, key) {
    const jsons = $5a49bb477e7b5f89$export$a8c2fb75d5b0e0e[rule] ?? $5a49bb477e7b5f89$var$otherJsons;
    return $5a49bb477e7b5f89$var$getNestedFallbacks(jsons.map((json)=>$5a49bb477e7b5f89$export$585f0f7ef40c9f0(json ? `${json}-${key}` : key)));
}
const $5a49bb477e7b5f89$var$tokenReg = /{([\w\-.$]+)}/;
const $5a49bb477e7b5f89$var$pureTokenReg = /^{([&%?\w\-.]+)}$/;
const $5a49bb477e7b5f89$var$pureTokenRegWithSwitchable = /^{([&%?\w\-.$]+)}$/;
const $5a49bb477e7b5f89$var$pureValue = /^[[\],\w\d?%\-. #$]+$/;
function $5a49bb477e7b5f89$var$getMemoKey(rule, key, tokens) {
    return rule + key + JSON.stringify(tokens);
}
function $5a49bb477e7b5f89$var$parseKey(rule, key, tokens, forceValue) {
    let value;
    if ($5a49bb477e7b5f89$var$pureTokenReg.test(key)) {
        key = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(key);
        value = $5a49bb477e7b5f89$export$859883d4ec9c7db4.getValue(rule, key, tokens, forceValue);
    } else if ($5a49bb477e7b5f89$var$pureTokenRegWithSwitchable.test(key)) {
        key = $5a49bb477e7b5f89$var$replaceTokens((0, $a996a90891ec663e$export$5fe300a9008e2bfc)(key), tokens);
        value = $5a49bb477e7b5f89$export$859883d4ec9c7db4.getValue(rule, key, tokens, forceValue);
    } else value = key;
    if (value === void 0) {
        if (key.includes("typography")) return key;
        return "";
    } else if (typeof value !== "string") return value.toString();
    if ($5a49bb477e7b5f89$var$pureTokenReg.test(value)) return $5a49bb477e7b5f89$var$parseKey(rule, value, tokens, forceValue);
    if ($5a49bb477e7b5f89$var$pureTokenRegWithSwitchable.test(value)) {
        if (Object.keys(tokens).length === 0) {
            console.warn(`No tokens provided, cannot resolve ${key}, ${value}`);
            return "";
        }
        const switched = $5a49bb477e7b5f89$var$replaceTokens(value, tokens);
        return $5a49bb477e7b5f89$var$parseKey(rule, switched, tokens, forceValue);
    }
    if ($5a49bb477e7b5f89$var$tokenReg.test(value)) value = $5a49bb477e7b5f89$var$handleNonPureTokens(rule, value, tokens, forceValue);
    if ($5a49bb477e7b5f89$var$pureValue.test(value) || value.startsWith("color-mix")) return value;
    const mathParsed = $5a49bb477e7b5f89$var$parseMaths(value);
    return mathParsed;
}
function $5a49bb477e7b5f89$var$handleNonPureTokens(rule, value, tokens, forceValue) {
    let match;
    while(match = $5a49bb477e7b5f89$var$tokenReg.exec(value)){
        const replacement = $5a49bb477e7b5f89$var$parseKey(rule, match[0], tokens, forceValue);
        value = value.replace($5a49bb477e7b5f89$var$tokenReg, replacement);
    }
    return value;
}
const $5a49bb477e7b5f89$var$UNITS_MAP = {
    filter: "px",
    "backdrop-filter": "px",
    "background-blur": "px",
    "blur-radius": "px",
    "border-radius": "px",
    "border-top-left-radius": "px",
    "border-top-right-radius": "px",
    "border-bottom-right-radius": "px",
    "border-bottom-left-radius": "px",
    "border-width": "px",
    "border-top-width": "px",
    "border-right-width": "px",
    "border-bottom-width": "px",
    "border-left-width": "px",
    height: "px",
    width: "px",
    size: "px",
    "font-size": "px",
    "line-height": "px",
    gap: "px",
    padding: "px",
    "padding-left": "px",
    "padding-right": "px",
    "padding-top": "px",
    "padding-bottom": "px",
    "letter-spacing": "px",
    outline: "%",
    rotate: "deg",
    "transition-duration": "ms",
    "transition-delay": "ms",
    "exit-animation-duration": "ms",
    "enter-animation-duration": "ms",
    "animation-duration": "ms"
};
const $5a49bb477e7b5f89$var$unitRules = Object.keys($5a49bb477e7b5f89$var$UNITS_MAP);
const $5a49bb477e7b5f89$export$fe0319385f0cf5a7 = [
    "px",
    "%",
    "deg",
    "vw",
    "em",
    "rem",
    "vh",
    "ms"
];
function $5a49bb477e7b5f89$var$needsUnits(value, match) {
    const notString = typeof value !== "string";
    const noMatch = !match;
    if (notString || noMatch) return Boolean(match);
    const isNotNumber = isNaN(parseInt(value));
    const hasUnits = $5a49bb477e7b5f89$export$fe0319385f0cf5a7.some((unit)=>value.includes(unit));
    return !(isNotNumber || hasUnits);
}
function $5a49bb477e7b5f89$export$95c38a73fd251991(rule, value) {
    const match = $5a49bb477e7b5f89$var$unitRules.find((unit)=>rule.includes(unit)) ?? "";
    if ($5a49bb477e7b5f89$var$needsUnits(value, match)) return `${value}${$5a49bb477e7b5f89$var$UNITS_MAP[match]}`;
    return value.toString();
}
const $5a49bb477e7b5f89$var$fallback = {
    lang: "en",
    platform: "desktop"
};
function $5a49bb477e7b5f89$var$replaceTokens(key, tokens) {
    tokens = {
        ...$5a49bb477e7b5f89$var$fallback,
        ...tokens
    };
    return Object.entries(tokens).filter(([, value])=>value).reduce((key2, [token, value])=>{
        return key2.replace(RegExp(`\\$${token}`, "g"), value.toString());
    }, key);
}
const $5a49bb477e7b5f89$var$permittedKeys = /* @__PURE__ */ new Set([
    "slot_layers",
    "hidden",
    "show",
    "behavior",
    "value",
    "web-tag"
]);
function $5a49bb477e7b5f89$var$getAllRequiredBaseLayers(base, props, getAllAmpersandTokenLayers = false, getPercentageTokens = []) {
    const hiddenLayers = {};
    for(const layer in base){
        const layerObj = base[layer];
        const layerKey = $5a49bb477e7b5f89$export$92b70e511152790f(layer);
        for(const key in layerObj){
            const value = layerObj[key];
            if (typeof value !== "string") {
                hiddenLayers[layer] ??= {};
                hiddenLayers[layer][key] = value;
                continue;
            }
            const hasAmpersandKey = typeof value === "string" && value.includes("&") && (value.includes("stroke") || key.includes("color") || key.includes("fill"));
            const hasPercentKey = typeof value === "string" && value.includes("%");
            const matchedKey = hasPercentKey && value.match($5a49bb477e7b5f89$export$2b19bce00ae0a812)?.[1];
            const hasPercentToken = matchedKey && getPercentageTokens.includes(matchedKey);
            if (getAllAmpersandTokenLayers && hasAmpersandKey || hasPercentToken || $5a49bb477e7b5f89$var$permittedKeys.has(key) || layerKey?.startsWith("jds_") || // include all molecule layers
            layerKey?.endsWith("arc")) {
                hiddenLayers[layer] ??= {};
                hiddenLayers[layer][key] = hasPercentKey ? $5a49bb477e7b5f89$export$cf44b2f1c9caafc4(value, props) : value;
            }
        }
    }
    return hiddenLayers;
}
function $5a49bb477e7b5f89$export$cf44b2f1c9caafc4(value, props) {
    const match = value.match($5a49bb477e7b5f89$export$2b19bce00ae0a812);
    if (!match) return value;
    const key = match[1];
    const replacement = props[key];
    if (replacement === void 0) return value;
    return value.replace(`%${key}`, replacement?.toString() ?? "");
}
function $5a49bb477e7b5f89$export$e025e4ac3d283105(component, json, config = {
    transformer: false,
    getAmpersandTokens: false,
    getAllBaseLayers: true,
    getPercentageTokens: []
}) {
    const { transformer: transformer = false, getAllBaseLayers: getAllBaseLayers = false, getAmpersandTokens: getAmpersandTokens = false, getPercentageTokens: getPercentageTokens = [] } = config;
    let base = getAllBaseLayers ? (0, $a996a90891ec663e$export$b7d58db314e0ac27)(json.base) : $5a49bb477e7b5f89$var$getAllRequiredBaseLayers((0, $a996a90891ec663e$export$b7d58db314e0ac27)(json.base), component, getAmpersandTokens, getPercentageTokens);
    base = $5a49bb477e7b5f89$export$8c51a6ab64fc75e8(component, base, json.variant, json.api.config);
    if (json.combination && json.combination_config) base = $5a49bb477e7b5f89$export$376823fb52709d2f(component, base, json.combination, json.combination_config, json.api.config);
    base = $5a49bb477e7b5f89$export$2918ee16067fdfba(base, json.metadata?.["name"]);
    return json.api.data && !transformer ? $5a49bb477e7b5f89$var$removeNoDataLayers(base, component, json.api.data) : base;
}
function $5a49bb477e7b5f89$var$removeNoDataLayers(base, component, data) {
    for(const layer in base){
        if (base[layer]["hidden"]) continue;
        const layerType = $5a49bb477e7b5f89$export$92b70e511152790f(layer);
        const datum = data[layer];
        if (layerType === "icon" || layerType === "text" || layerType === "image") {
            const value = datum?.["value"];
            const name = value?.name;
            if (!name || name.includes(".")) continue;
            const val = component[value.name] || base[layer]["value"];
            if (val === void 0 || val === null || val === "") base[layer]["hidden"] = true;
        }
    }
    return base;
}
function $5a49bb477e7b5f89$export$a1a0a7262a295961(componentName, base, hierarchy, invariants = {}, tokens) {
    const layerKeySet = /* @__PURE__ */ new Set();
    return $5a49bb477e7b5f89$var$drawComponentHierarchy(componentName, hierarchy, base, invariants, layerKeySet, tokens);
}
function $5a49bb477e7b5f89$var$drawComponentHierarchy(componentName, hierarchy, base, invariants, layerKeySet, tokens) {
    const root = $5a49bb477e7b5f89$export$31e4419873013369(hierarchy) || hierarchy;
    if ($5a49bb477e7b5f89$export$859883d4ec9c7db4.updateFlatTokens && tokens && tokens?.["brandVersion"] === "jio-v2" && // layerKey === 'container' && // not sure
    Object.keys(base[root] ?? {}).some((key)=>$5a49bb477e7b5f89$export$beb192a6dc60a1a7.includes(key))) tokens = $5a49bb477e7b5f89$export$5cc69797806ce5c5(tokens, base[root]);
    const children = typeof hierarchy === "string" ? [] : hierarchy[root];
    const { styles: rootVars, classes: rootClasses } = $5a49bb477e7b5f89$var$drawComponentBase(componentName, root, base[root], invariants[root], tokens);
    if (children?.length) {
        const childrenVars = {};
        const childrenClasses = {};
        let hasVisibleChildren = false;
        for (const child of children){
            const childRoot = typeof child === "string" ? child : $5a49bb477e7b5f89$export$31e4419873013369(child);
            if (typeof child === "string") {
                let newTokens = tokens;
                if ($5a49bb477e7b5f89$export$859883d4ec9c7db4.updateFlatTokens && tokens && tokens?.["brandVersion"] === "jio-v2" && // layerKey === 'container' && // not sure
                Object.keys(base[childRoot] ?? {}).some((key)=>$5a49bb477e7b5f89$export$beb192a6dc60a1a7.includes(key))) newTokens = $5a49bb477e7b5f89$export$5cc69797806ce5c5(tokens, base[childRoot]);
                const visible = !base[child]?.["hidden"];
                hasVisibleChildren ||= visible;
                const childVars = $5a49bb477e7b5f89$var$drawComponentBase(componentName, child, base[child], invariants[child], newTokens);
                Object.assign(childrenVars, childVars.styles);
                Object.assign(childrenClasses, childVars.classes);
            } else {
                const childLayer = $5a49bb477e7b5f89$export$31e4419873013369(child);
                const childVars = $5a49bb477e7b5f89$var$drawComponentHierarchy(componentName, child, base, invariants, layerKeySet, tokens);
                const visible = !base[childLayer]?.["hidden"];
                hasVisibleChildren ||= visible;
                Object.assign(childrenVars, childVars.styles);
                Object.assign(childrenClasses, childVars.classes);
            }
        }
        const combinedVars = {
            ...rootVars,
            ...childrenVars
        };
        const combinedClasses = {
            ...rootClasses,
            ...childrenClasses
        };
        base[root] ??= {};
        if (hasVisibleChildren || base[root]["show"]) return {
            styles: combinedVars,
            classes: combinedClasses
        };
        base[root]["hidden"] = true;
        return {
            styles: combinedVars,
            classes: combinedClasses
        };
    }
    return {
        styles: rootVars,
        classes: rootClasses
    };
}
function $5a49bb477e7b5f89$var$drawComponentBase(componentName, layer, baseMap, invariantsMap, tokens) {
    if (!baseMap) return {
        styles: {},
        classes: {}
    };
    const baseCSSVars = {};
    const baseClasses = {};
    const { behavior: behavior = {}, ...layerObj } = baseMap;
    const layerKey = $5a49bb477e7b5f89$export$92b70e511152790f(layer);
    const isV3 = tokens?.["brandVersion"] === "jio-v2";
    const { styles: layerStyle, classes: layerClasses } = $5a49bb477e7b5f89$export$43447905499a2c3e(componentName, layer, layerObj, isV3 ? invariantsMap : {}, layer, void 0, tokens);
    if (isV3 && layerKey && [
        "icon",
        "text",
        "jds_text2",
        "jds_icon2",
        "container",
        "jds_container2"
    ].includes(layerKey)) {
        behavior["hover"] = behavior["hover"] || {};
        behavior["active"] = behavior["active"] || {};
        if (layerKey === "icon" || layerKey === "text" || layerKey === "jds_text2" || layerKey === "jds_icon2") {
            if (layerObj["color"]) {
                behavior["hover"]["color"] = layerObj["color"];
                behavior["active"]["color"] = layerObj["color"];
            }
        } else {
            if (layerObj["background-color"]) {
                behavior["hover"]["background-color"] = layerObj["background-color"];
                behavior["active"]["background-color"] = layerObj["background-color"];
            }
            if (layerObj["border-color"]) {
                behavior["hover"]["border-color"] = layerObj["border-color"];
                behavior["active"]["border-color"] = layerObj["border-color"];
            }
        }
    }
    Object.assign(baseCSSVars, layerStyle);
    baseClasses[layer] = layerClasses;
    for(const pseudo in behavior){
        const merged = (0, $a996a90891ec663e$export$4950aa0f605343fb)(layerObj, behavior[pseudo]);
        const behaviorInvariants = invariantsMap?.behavior?.[pseudo];
        const { styles: pseudoLayerStyle, classes: pseudoLayerClasses } = $5a49bb477e7b5f89$export$43447905499a2c3e(componentName, layer, isV3 ? behavior[pseudo] : merged, isV3 ? behaviorInvariants : void 0, layer, pseudo, tokens ? {
            ...tokens,
            state: pseudo
        } : void 0);
        Object.assign(baseCSSVars, pseudoLayerStyle);
        baseClasses[layer] = baseClasses[layer].concat(pseudoLayerClasses);
    }
    return {
        styles: baseCSSVars,
        classes: baseClasses
    };
}
const $5a49bb477e7b5f89$export$d72eddc0980b68c9 = (custom)=>{
    const [, base64] = custom?.split("--") || [];
    const convertedCustom = $5a49bb477e7b5f89$export$9cc362b209501dfe(base64);
    return convertedCustom;
};
function $5a49bb477e7b5f89$var$withComponentTokensHelper(baseMap, metaCompName, fallback) {
    for(const key in baseMap){
        const value = baseMap[key];
        if (typeof value === "object") baseMap[key] = $5a49bb477e7b5f89$var$withComponentTokensHelper(baseMap[key], metaCompName, fallback);
        else if (typeof value === "string") {
            const replacement = metaCompName ? $5a49bb477e7b5f89$export$859883d4ec9c7db4.getComponentToken(value, metaCompName) : void 0;
            let icon, text;
            if (fallback === "icon") icon = $5a49bb477e7b5f89$export$859883d4ec9c7db4.getComponentToken(value, "JDSIcon");
            else if (fallback === "text") text = $5a49bb477e7b5f89$export$859883d4ec9c7db4.getComponentToken(value, "JDSText");
            baseMap[key] = replacement ?? icon ?? text ?? value;
        }
    }
    return baseMap;
}
function $5a49bb477e7b5f89$export$2918ee16067fdfba(base, metaCompName) {
    for(const layer in base){
        const baseMap = base[layer];
        const fallback = layer.includes("icon") ? "icon" : layer.includes("text") ? "text" : void 0;
        base[layer] = $5a49bb477e7b5f89$var$withComponentTokensHelper(baseMap, metaCompName, fallback);
    }
    return base;
}
function $5a49bb477e7b5f89$export$d785cbf77f40ae28(func, details) {
    const start = performance.now();
    const result = func();
    const end = performance.now();
    setTimeout(()=>{
        console.log(`Time Taken${details ? ` for ${details}` : ""}: ${end - start}`);
    });
    return result;
}
const $5a49bb477e7b5f89$export$b81511b7d77b08 = (reference, defaultValues)=>{
    Object.keys(defaultValues).forEach((prop)=>{
        if (reference[prop] === void 0) reference[prop] = defaultValues[prop];
    });
    return reference;
};
const $5a49bb477e7b5f89$export$460dbca19df1617d = (hex)=>{
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{8})$/;
    return hexRegex.test(hex);
};




const $5bc9639ae0326803$var$crimson = {
    "crimson.100": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 8.873419280265287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 12.816158124839067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 17.879308557844908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "crimson.900": {
            contrast: 20.86889538110057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.1000": {
            contrast: 24.841138749445182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "crimson.1100": {
            contrast: 28.89606289883126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "crimson.1200": {
            contrast: 33.605776673427265,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 65.5
        },
        "crimson.1300": {
            contrast: 38.306027679116184,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 60.5
        },
        "crimson.1400": {
            contrast: 42.64514951811362,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 56.5
        },
        "crimson.1500": {
            contrast: 47.47529732205652,
            lc60: 100,
            lc45: 96.5,
            lc30: 76.5,
            lc10: 53
        },
        "crimson.1600": {
            contrast: 52.56370163199136,
            lc60: 100,
            lc45: 90.5,
            lc30: 72,
            lc10: 50
        },
        "crimson.1700": {
            contrast: 57.72965128501034,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 47
        },
        "crimson.1800": {
            contrast: 63.023347963082365,
            lc60: 97,
            lc45: 81,
            lc30: 64.5,
            lc10: 45
        },
        "crimson.1900": {
            contrast: 68.85804401615995,
            lc60: 91.5,
            lc45: 77,
            lc30: 61,
            lc10: 42.5
        },
        "crimson.2000": {
            contrast: 74.85090888815226,
            lc60: 87,
            lc45: 73,
            lc30: 58,
            lc10: 40.5
        },
        "crimson.2100": {
            contrast: 81.22304524651815,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 87.52099208798967,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "crimson.2300": {
            contrast: 94.18208733230342,
            lc60: 75.5,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "crimson.2400": {
            contrast: 101.14994627278368,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "crimson.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "crimson.200": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 8.410581638478499,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 12.35332048305228,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 17.41647091605812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "crimson.900": {
            contrast: 20.406057739313784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "crimson.1000": {
            contrast: 24.37830110765839,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "crimson.1100": {
            contrast: 28.433225257044466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "crimson.1200": {
            contrast: 33.14293903164047,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 61
        },
        "crimson.1300": {
            contrast: 37.84319003732939,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 56.5
        },
        "crimson.1400": {
            contrast: 42.18231187632683,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 53
        },
        "crimson.1500": {
            contrast: 47.012459680269735,
            lc60: 100,
            lc45: 97,
            lc30: 75,
            lc10: 49.5
        },
        "crimson.1600": {
            contrast: 52.10086399020456,
            lc60: 100,
            lc45: 91,
            lc30: 70,
            lc10: 46.5
        },
        "crimson.1700": {
            contrast: 57.26681364322354,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 44
        },
        "crimson.1800": {
            contrast: 62.56051032129558,
            lc60: 97,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 41
        },
        "crimson.1900": {
            contrast: 68.39520637437315,
            lc60: 91.5,
            lc45: 76,
            lc30: 59,
            lc10: 39.5
        },
        "crimson.2000": {
            contrast: 74.38807124636547,
            lc60: 87,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "crimson.2100": {
            contrast: 80.76020760473138,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35.5
        },
        "crimson.2200": {
            contrast: 87.05815444620288,
            lc60: 78,
            lc45: 65,
            lc30: 50.5,
            lc10: 34
        },
        "crimson.2300": {
            contrast: 93.71924969051662,
            lc60: 74.5,
            lc45: 62,
            lc30: 48.5,
            lc10: 32.5
        },
        "crimson.2400": {
            contrast: 100.6871086309969,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 31
        },
        "crimson.2500": {
            contrast: 107.42189554131167,
            lc60: 68,
            lc45: 56.5,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "crimson.300": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 10.912292294581205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 15.975442727587048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "crimson.900": {
            contrast: 18.965029550842708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "crimson.1000": {
            contrast: 22.937272919187315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "crimson.1100": {
            contrast: 26.992197068573386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "crimson.1200": {
            contrast: 31.701910843169394,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 60.5
        },
        "crimson.1300": {
            contrast: 36.40216184885831,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 55
        },
        "crimson.1400": {
            contrast: 40.74128368785575,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 51.5
        },
        "crimson.1500": {
            contrast: 45.571431491798656,
            lc60: 100,
            lc45: 99,
            lc30: 75.5,
            lc10: 48
        },
        "crimson.1600": {
            contrast: 50.659835801733486,
            lc60: 100,
            lc45: 92,
            lc30: 70,
            lc10: 45
        },
        "crimson.1700": {
            contrast: 55.82578545475248,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42.5
        },
        "crimson.1800": {
            contrast: 61.1194821328245,
            lc60: 98.5,
            lc45: 81,
            lc30: 62.5,
            lc10: 40.5
        },
        "crimson.1900": {
            contrast: 66.95417818590208,
            lc60: 93,
            lc45: 76.5,
            lc30: 59,
            lc10: 38.5
        },
        "crimson.2000": {
            contrast: 72.94704305789439,
            lc60: 87.5,
            lc45: 72.5,
            lc30: 56,
            lc10: 36.5
        },
        "crimson.2100": {
            contrast: 79.31917941626028,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 35
        },
        "crimson.2200": {
            contrast: 85.6171262577318,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33
        },
        "crimson.2300": {
            contrast: 92.27822150204555,
            lc60: 75,
            lc45: 62.5,
            lc30: 48,
            lc10: 32
        },
        "crimson.2400": {
            contrast: 99.2460804425258,
            lc60: 72,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "crimson.2500": {
            contrast: 105.9808673528406,
            lc60: 69,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "crimson.400": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 9.07788575268778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 14.141036185693622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 17.130623008949286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "crimson.1000": {
            contrast: 21.102866377293893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "crimson.1100": {
            contrast: 25.157790526679968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "crimson.1200": {
            contrast: 29.867504301275975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "crimson.1300": {
            contrast: 34.56775530696489,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 55.5
        },
        "crimson.1400": {
            contrast: 38.906877145962326,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 51
        },
        "crimson.1500": {
            contrast: 43.73702494990523,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "crimson.1600": {
            contrast: 48.82542925984006,
            lc60: 100,
            lc45: 94,
            lc30: 71,
            lc10: 44.5
        },
        "crimson.1700": {
            contrast: 53.99137891285905,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 42
        },
        "crimson.1800": {
            contrast: 59.28507559093108,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 40
        },
        "crimson.1900": {
            contrast: 65.11977164400867,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 59,
            lc10: 37.5
        },
        "crimson.2000": {
            contrast: 71.11263651600098,
            lc60: 89,
            lc45: 73.5,
            lc30: 56,
            lc10: 36
        },
        "crimson.2100": {
            contrast: 77.48477287436687,
            lc60: 84,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 34
        },
        "crimson.2200": {
            contrast: 83.78271971583838,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 33
        },
        "crimson.2300": {
            contrast: 90.44381496015214,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "crimson.2400": {
            contrast: 97.41167390063238,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30
        },
        "crimson.2500": {
            contrast: 104.14646081094719,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29
        }
    },
    "crimson.500": {
        "crimson.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 11.436692150355107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 14.42627897361077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 18.398522341955378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "crimson.1100": {
            contrast: 22.453446491341452,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "crimson.1200": {
            contrast: 27.163160265937456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "crimson.1300": {
            contrast: 31.863411271626376,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 57
        },
        "crimson.1400": {
            contrast: 36.20253311062381,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52.5
        },
        "crimson.1500": {
            contrast: 41.03268091456672,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48.5
        },
        "crimson.1600": {
            contrast: 46.12108522450155,
            lc60: 100,
            lc45: 98,
            lc30: 73.5,
            lc10: 45.5
        },
        "crimson.1700": {
            contrast: 51.28703487752053,
            lc60: 100,
            lc45: 91,
            lc30: 69,
            lc10: 43
        },
        "crimson.1800": {
            contrast: 56.580731555592564,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 40.5
        },
        "crimson.1900": {
            contrast: 62.41542760867015,
            lc60: 97,
            lc45: 80,
            lc30: 61,
            lc10: 38.5
        },
        "crimson.2000": {
            contrast: 68.40829248066245,
            lc60: 91.5,
            lc45: 75.5,
            lc30: 57.5,
            lc10: 36.5
        },
        "crimson.2100": {
            contrast: 74.78042883902836,
            lc60: 86,
            lc45: 71,
            lc30: 54.5,
            lc10: 35
        },
        "crimson.2200": {
            contrast: 81.07837568049987,
            lc60: 82,
            lc45: 67.5,
            lc30: 52,
            lc10: 33
        },
        "crimson.2300": {
            contrast: 87.73947092481362,
            lc60: 77.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32
        },
        "crimson.2400": {
            contrast: 94.70732986529387,
            lc60: 74,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 30.5
        },
        "crimson.2500": {
            contrast: 101.44211677560865,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        }
    },
    "crimson.600": {
        "crimson.100": {
            contrast: 10.28111424463956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 9.661057815952624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 7.783968931682822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 7.707446820700143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 10.697033643955805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 14.669277012300416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 18.724201161686494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.1200": {
            contrast: 23.4339149362825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "crimson.1300": {
            contrast: 28.134165941971418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "crimson.1400": {
            contrast: 32.47328778096885,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 56.5
        },
        "crimson.1500": {
            contrast: 37.30343558491176,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 52
        },
        "crimson.1600": {
            contrast: 42.39183989484658,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 48
        },
        "crimson.1700": {
            contrast: 47.55778954786557,
            lc60: 100,
            lc45: 96,
            lc30: 73,
            lc10: 45
        },
        "crimson.1800": {
            contrast: 52.851486225937606,
            lc60: 100,
            lc45: 89.5,
            lc30: 68,
            lc10: 42.5
        },
        "crimson.1900": {
            contrast: 58.68618227901518,
            lc60: 100,
            lc45: 83.5,
            lc30: 63.5,
            lc10: 40.5
        },
        "crimson.2000": {
            contrast: 64.6790471510075,
            lc60: 95,
            lc45: 78.5,
            lc30: 60,
            lc10: 38.5
        },
        "crimson.2100": {
            contrast: 71.05118350937339,
            lc60: 89.5,
            lc45: 74,
            lc30: 57,
            lc10: 36.5
        },
        "crimson.2200": {
            contrast: 77.3491303508449,
            lc60: 84.5,
            lc45: 70,
            lc30: 54,
            lc10: 35
        },
        "crimson.2300": {
            contrast: 84.01022559515864,
            lc60: 80,
            lc45: 66.5,
            lc30: 51.5,
            lc10: 33.5
        },
        "crimson.2400": {
            contrast: 90.9780845356389,
            lc60: 76.5,
            lc45: 63.5,
            lc30: 49,
            lc10: 32
        },
        "crimson.2500": {
            contrast: 97.7128714459537,
            lc60: 73,
            lc45: 60.5,
            lc30: 47,
            lc10: 30.5
        }
    },
    "crimson.700": {
        "crimson.100": {
            contrast: 14.564400026875028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.200": {
            contrast: 13.944343598188091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.300": {
            contrast: 12.067254713918288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.400": {
            contrast: 9.765839376449522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 10.900198008585498,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 14.955122157971573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 19.66483593256758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "crimson.1300": {
            contrast: 24.3650869382565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "crimson.1400": {
            contrast: 28.704208777253932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "crimson.1500": {
            contrast: 33.53435658119684,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 57
        },
        "crimson.1600": {
            contrast: 38.62276089113166,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 52
        },
        "crimson.1700": {
            contrast: 43.78871054415065,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 48.5
        },
        "crimson.1800": {
            contrast: 49.08240722222268,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 45.5
        },
        "crimson.1900": {
            contrast: 54.91710327530026,
            lc60: 100,
            lc45: 87.5,
            lc30: 67,
            lc10: 43
        },
        "crimson.2000": {
            contrast: 60.90996814729258,
            lc60: 99,
            lc45: 82,
            lc30: 63.5,
            lc10: 40.5
        },
        "crimson.2100": {
            contrast: 67.28210450565848,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 73.58005134713,
            lc60: 87.5,
            lc45: 73,
            lc30: 56.5,
            lc10: 36.5
        },
        "crimson.2300": {
            contrast: 80.24114659144374,
            lc60: 83,
            lc45: 69.5,
            lc30: 54,
            lc10: 35
        },
        "crimson.2400": {
            contrast: 87.209005531924,
            lc60: 79,
            lc45: 65.5,
            lc30: 51,
            lc10: 33.5
        },
        "crimson.2500": {
            contrast: 93.94379244223879,
            lc60: 75,
            lc45: 63,
            lc30: 49,
            lc10: 32
        }
    },
    "crimson.800": {
        "crimson.100": {
            contrast: 19.94098547041679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "crimson.200": {
            contrast: 19.320929041729855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "crimson.300": {
            contrast: 17.443840157460055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "crimson.400": {
            contrast: 15.142424819991284,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "crimson.500": {
            contrast: 11.876471970729515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 7.5471148870613405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 10.059533424846354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 14.769247199442361,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 19.46949820513128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "crimson.1400": {
            contrast: 23.808620044128716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "crimson.1500": {
            contrast: 28.638767848071616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "crimson.1600": {
            contrast: 33.72717215800645,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 58.5
        },
        "crimson.1700": {
            contrast: 38.89312181102543,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 53.5
        },
        "crimson.1800": {
            contrast: 44.18681848909746,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 49.5
        },
        "crimson.1900": {
            contrast: 50.02151454217504,
            lc60: 100,
            lc45: 93.5,
            lc30: 72.5,
            lc10: 46.5
        },
        "crimson.2000": {
            contrast: 56.01437941416737,
            lc60: 100,
            lc45: 87,
            lc30: 67.5,
            lc10: 44
        },
        "crimson.2100": {
            contrast: 62.38651577253326,
            lc60: 97.5,
            lc45: 81.5,
            lc30: 63.5,
            lc10: 41.5
        },
        "crimson.2200": {
            contrast: 68.68446261400477,
            lc60: 91.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 39.5
        },
        "crimson.2300": {
            contrast: 75.34555785831853,
            lc60: 87,
            lc45: 73,
            lc30: 57,
            lc10: 37.5
        },
        "crimson.2400": {
            contrast: 82.31341679879878,
            lc60: 82,
            lc45: 69,
            lc30: 54,
            lc10: 36
        },
        "crimson.2500": {
            contrast: 89.04820370911357,
            lc60: 78.5,
            lc45: 66,
            lc30: 51.5,
            lc10: 34.5
        }
    },
    "crimson.900": {
        "crimson.100": {
            contrast: 23.06267702072904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "crimson.200": {
            contrast: 22.442620592042104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.300": {
            contrast: 20.5655317077723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "crimson.400": {
            contrast: 18.264116370303533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "crimson.500": {
            contrast: 14.998163521041766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.600": {
            contrast: 10.668806437373588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 11.854215050625646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 16.554466056314563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "crimson.1400": {
            contrast: 20.893587895312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "crimson.1500": {
            contrast: 25.723735699254902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "crimson.1600": {
            contrast: 30.812140009189736,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 58
        },
        "crimson.1700": {
            contrast: 35.978089662208724,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 52.5
        },
        "crimson.1800": {
            contrast: 41.271786340280755,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 47.5
        },
        "crimson.1900": {
            contrast: 47.10648239335833,
            lc60: 100,
            lc45: 96.5,
            lc30: 73,
            lc10: 44
        },
        "crimson.2000": {
            contrast: 53.09934726535065,
            lc60: 100,
            lc45: 89,
            lc30: 67,
            lc10: 41
        },
        "crimson.2100": {
            contrast: 59.47148362371654,
            lc60: 100,
            lc45: 82.5,
            lc30: 62.5,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 65.76943046518805,
            lc60: 93.5,
            lc45: 77,
            lc30: 58.5,
            lc10: 36.5
        },
        "crimson.2300": {
            contrast: 72.43052570950181,
            lc60: 88,
            lc45: 72,
            lc30: 55,
            lc10: 34
        },
        "crimson.2400": {
            contrast: 79.39838464998206,
            lc60: 83,
            lc45: 68,
            lc30: 52,
            lc10: 32.5
        },
        "crimson.2500": {
            contrast: 86.13317156029684,
            lc60: 78.5,
            lc45: 64.5,
            lc30: 49,
            lc10: 31
        }
    },
    "crimson.1000": {
        "crimson.100": {
            contrast: 27.15947311121527,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "crimson.200": {
            contrast: 26.539416682528337,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "crimson.300": {
            contrast: 24.66232779825854,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.400": {
            contrast: 22.36091246078977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "crimson.500": {
            contrast: 19.094959611528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "crimson.600": {
            contrast: 14.765602527859825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.700": {
            contrast: 10.537954568108884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 7.957004859172027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 12.657255864860945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 16.996377703858382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "crimson.1500": {
            contrast: 21.826525507801286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "crimson.1600": {
            contrast: 26.91492981773611,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "crimson.1700": {
            contrast: 32.0808794707551,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 56
        },
        "crimson.1800": {
            contrast: 37.374576148827124,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 49.5
        },
        "crimson.1900": {
            contrast: 43.2092722019047,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 45
        },
        "crimson.2000": {
            contrast: 49.20213707389702,
            lc60: 100,
            lc45: 94,
            lc30: 69.5,
            lc10: 41.5
        },
        "crimson.2100": {
            contrast: 55.57427343226292,
            lc60: 100,
            lc45: 86,
            lc30: 64.5,
            lc10: 38.5
        },
        "crimson.2200": {
            contrast: 61.872220273734435,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 35.5
        },
        "crimson.2300": {
            contrast: 68.53331551804818,
            lc60: 91,
            lc45: 74.5,
            lc30: 55.5,
            lc10: 33.5
        },
        "crimson.2400": {
            contrast: 75.50117445852844,
            lc60: 85,
            lc45: 69.5,
            lc30: 52.5,
            lc10: 31.5
        },
        "crimson.2500": {
            contrast: 82.23596136884322,
            lc60: 80,
            lc45: 65.5,
            lc30: 49.5,
            lc10: 30
        }
    },
    "crimson.1100": {
        "crimson.100": {
            contrast: 31.289292158582988,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 34.5
        },
        "crimson.200": {
            contrast: 30.669235729896055,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 40
        },
        "crimson.300": {
            contrast: 28.79214684562626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "crimson.400": {
            contrast: 26.490731508157484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "crimson.500": {
            contrast: 23.22477865889572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "crimson.600": {
            contrast: 18.89542157522754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "crimson.700": {
            contrast: 14.667773615476602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.800": {
            contrast: 9.34084147325128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 8.653843271393521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 12.992965110390958,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 17.823112914333862,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "crimson.1600": {
            contrast: 22.911517224268692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "crimson.1700": {
            contrast: 28.077466877287677,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "crimson.1800": {
            contrast: 33.37116355535971,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 53.5
        },
        "crimson.1900": {
            contrast: 39.20585960843728,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47.5
        },
        "crimson.2000": {
            contrast: 45.198724480429604,
            lc60: 100,
            lc45: 99.5,
            lc30: 74,
            lc10: 43.5
        },
        "crimson.2100": {
            contrast: 51.5708608387955,
            lc60: 100,
            lc45: 90.5,
            lc30: 67,
            lc10: 39.5
        },
        "crimson.2200": {
            contrast: 57.86880768026701,
            lc60: 100,
            lc45: 83,
            lc30: 61.5,
            lc10: 37
        },
        "crimson.2300": {
            contrast: 64.52990292458077,
            lc60: 95,
            lc45: 77,
            lc30: 57,
            lc10: 34
        },
        "crimson.2400": {
            contrast: 71.49776186506102,
            lc60: 88,
            lc45: 71.5,
            lc30: 53,
            lc10: 31.5
        },
        "crimson.2500": {
            contrast: 78.2325487753758,
            lc60: 82.5,
            lc45: 67.5,
            lc30: 50.5,
            lc10: 30
        }
    },
    "crimson.1200": {
        "crimson.100": {
            contrast: 36.028451790740164,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30
        },
        "crimson.200": {
            contrast: 35.40839536205323,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34.5
        },
        "crimson.300": {
            contrast: 33.53130647778343,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 38.5
        },
        "crimson.400": {
            contrast: 31.229891140314663,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 43.5
        },
        "crimson.500": {
            contrast: 27.96393829105289,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "crimson.600": {
            contrast: 23.634581207384716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.700": {
            contrast: 19.406933247633777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "crimson.800": {
            contrast: 14.080001105408455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.900": {
            contrast: 10.978446632868891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 8.314935550892837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 13.14508335483574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 18.23348766477057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.1700": {
            contrast: 23.399437317789555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "crimson.1800": {
            contrast: 28.69313399586158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.1900": {
            contrast: 34.527830048939165,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "crimson.2000": {
            contrast: 40.520694920931476,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 46
        },
        "crimson.2100": {
            contrast: 46.892831279297376,
            lc60: 100,
            lc45: 97,
            lc30: 71,
            lc10: 41.5
        },
        "crimson.2200": {
            contrast: 53.19077812076889,
            lc60: 100,
            lc45: 88.5,
            lc30: 65,
            lc10: 38
        },
        "crimson.2300": {
            contrast: 59.85187336508264,
            lc60: 100,
            lc45: 81,
            lc30: 60,
            lc10: 34.5
        },
        "crimson.2400": {
            contrast: 66.8197323055629,
            lc60: 92.5,
            lc45: 74.5,
            lc30: 55,
            lc10: 32.5
        },
        "crimson.2500": {
            contrast: 73.55451921587768,
            lc60: 86,
            lc45: 70,
            lc30: 51.5,
            lc10: 30.5
        }
    },
    "crimson.1300": {
        "crimson.100": {
            contrast: 40.704046820658334,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "crimson.200": {
            contrast: 40.083990391971405,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30.5
        },
        "crimson.300": {
            contrast: 38.2069015077016,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "crimson.400": {
            contrast: 35.905486170232834,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 37.5
        },
        "crimson.500": {
            contrast: 32.63953332097106,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 42.5
        },
        "crimson.600": {
            contrast: 28.310176237302887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "crimson.700": {
            contrast: 24.082528277551948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "crimson.800": {
            contrast: 18.755596135326627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "crimson.900": {
            contrast: 15.654041662787064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "crimson.1000": {
            contrast: 11.575276451208042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1100": {
            contrast: 7.455008089412709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 8.449554031263077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 13.537958341197903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 18.70390799421689,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "crimson.1800": {
            contrast: 23.997604672288922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "crimson.1900": {
            contrast: 29.832300725366494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "crimson.2000": {
            contrast: 35.82516559735882,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 50
        },
        "crimson.2100": {
            contrast: 42.19730195572471,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44.5
        },
        "crimson.2200": {
            contrast: 48.495248797196226,
            lc60: 100,
            lc45: 94,
            lc30: 69.5,
            lc10: 40
        },
        "crimson.2300": {
            contrast: 55.15634404150996,
            lc60: 100,
            lc45: 86,
            lc30: 63.5,
            lc10: 37
        },
        "crimson.2400": {
            contrast: 62.124202981990216,
            lc60: 97.5,
            lc45: 78.5,
            lc30: 58,
            lc10: 33.5
        },
        "crimson.2500": {
            contrast: 68.858989892305,
            lc60: 90.5,
            lc45: 73,
            lc30: 53.5,
            lc10: 31
        }
    },
    "crimson.1400": {
        "crimson.100": {
            contrast: 44.97792069372642,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "crimson.200": {
            contrast: 44.35786426503949,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 28
        },
        "crimson.300": {
            contrast: 42.480775380769686,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "crimson.400": {
            contrast: 40.17936004330092,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33
        },
        "crimson.500": {
            contrast: 36.91340719403915,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 36.5
        },
        "crimson.600": {
            contrast: 32.584050110370974,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 41
        },
        "crimson.700": {
            contrast: 28.35640215062003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "crimson.800": {
            contrast: 23.02947000839471,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "crimson.900": {
            contrast: 19.927915535855146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "crimson.1000": {
            contrast: 15.849150324276124,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "crimson.1100": {
            contrast: 11.728881962480791,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 9.181707732453779,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 14.347657385472765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 19.641354063544796,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "crimson.1900": {
            contrast: 25.476050116622368,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "crimson.2000": {
            contrast: 31.46891498861469,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 55
        },
        "crimson.2100": {
            contrast: 37.84105134698058,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 47.5
        },
        "crimson.2200": {
            contrast: 44.13899818845209,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42.5
        },
        "crimson.2300": {
            contrast: 50.80009343276585,
            lc60: 100,
            lc45: 91,
            lc30: 66.5,
            lc10: 38
        },
        "crimson.2400": {
            contrast: 57.7679523732461,
            lc60: 100,
            lc45: 82.5,
            lc30: 60,
            lc10: 34.5
        },
        "crimson.2500": {
            contrast: 64.50273928356089,
            lc60: 94.5,
            lc45: 76,
            lc30: 55.5,
            lc10: 32.5
        }
    },
    "crimson.1500": {
        "crimson.100": {
            contrast: 49.69242551709676,
            lc60: 100,
            lc45: 73,
            lc30: 45,
            lc10: 22.5
        },
        "crimson.200": {
            contrast: 49.072369088409815,
            lc60: 100,
            lc45: 80.5,
            lc30: 50,
            lc10: 25
        },
        "crimson.300": {
            contrast: 47.19528020414002,
            lc60: 100,
            lc45: 89.5,
            lc30: 54,
            lc10: 27
        },
        "crimson.400": {
            contrast: 44.89386486667125,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 29
        },
        "crimson.500": {
            contrast: 41.627912017409486,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31.5
        },
        "crimson.600": {
            contrast: 37.29855493374131,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35
        },
        "crimson.700": {
            contrast: 33.07090697399037,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 39.5
        },
        "crimson.800": {
            contrast: 27.743974831765044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "crimson.900": {
            contrast: 24.642420359225483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "crimson.1000": {
            contrast: 20.56365514764646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "crimson.1100": {
            contrast: 16.44338678585113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "crimson.1200": {
            contrast: 11.70566692746402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 9.476372175681222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 14.770068853753251,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 20.60476490683083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "crimson.2000": {
            contrast: 26.597629778823144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "crimson.2100": {
            contrast: 32.96976613718904,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 52.5
        },
        "crimson.2200": {
            contrast: 39.267712978660555,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 45.5
        },
        "crimson.2300": {
            contrast: 45.9288082229743,
            lc60: 100,
            lc45: 98.5,
            lc30: 71.5,
            lc10: 40.5
        },
        "crimson.2400": {
            contrast: 52.89666716345456,
            lc60: 100,
            lc45: 88,
            lc30: 64,
            lc10: 36.5
        },
        "crimson.2500": {
            contrast: 59.63145407376934,
            lc60: 100,
            lc45: 80,
            lc30: 58,
            lc10: 33
        }
    },
    "crimson.1600": {
        "crimson.100": {
            contrast: 54.61473069151117,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 21
        },
        "crimson.200": {
            contrast: 53.99467426282424,
            lc60: 100,
            lc45: 70.5,
            lc30: 45,
            lc10: 22.5
        },
        "crimson.300": {
            contrast: 52.11758537855443,
            lc60: 100,
            lc45: 76.5,
            lc30: 48,
            lc10: 24
        },
        "crimson.400": {
            contrast: 49.81617004108566,
            lc60: 100,
            lc45: 83.5,
            lc30: 52,
            lc10: 26
        },
        "crimson.500": {
            contrast: 46.5502171918239,
            lc60: 100,
            lc45: 94,
            lc30: 56,
            lc10: 28
        },
        "crimson.600": {
            contrast: 42.22086010815572,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "crimson.700": {
            contrast: 37.99321214840477,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 33
        },
        "crimson.800": {
            contrast: 32.666280006179456,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 38
        },
        "crimson.900": {
            contrast: 29.56472553363989,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "crimson.1000": {
            contrast: 25.48596032206087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "crimson.1100": {
            contrast: 21.36569196026554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "crimson.1200": {
            contrast: 16.627972101878434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "crimson.1300": {
            contrast: 11.944835353435893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1400": {
            contrast: 7.657003568757423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 9.615301954011654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 15.449998007089233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "crimson.2000": {
            contrast: 21.442862879081552,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "crimson.2100": {
            contrast: 27.81499923744744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.2200": {
            contrast: 34.11294607891895,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 51
        },
        "crimson.2300": {
            contrast: 40.7740413232327,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44
        },
        "crimson.2400": {
            contrast: 47.741900263712964,
            lc60: 100,
            lc45: 95,
            lc30: 68.5,
            lc10: 38.5
        },
        "crimson.2500": {
            contrast: 54.47668717402774,
            lc60: 100,
            lc45: 85.5,
            lc30: 61.5,
            lc10: 34.5
        }
    },
    "crimson.1700": {
        "crimson.100": {
            contrast: 59.56993459153078,
            lc60: 100,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "crimson.200": {
            contrast: 58.94987816284385,
            lc60: 100,
            lc45: 63.5,
            lc30: 41,
            lc10: 20.5
        },
        "crimson.300": {
            contrast: 57.07278927857404,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "crimson.400": {
            contrast: 54.77137394110528,
            lc60: 100,
            lc45: 73.5,
            lc30: 46,
            lc10: 23
        },
        "crimson.500": {
            contrast: 51.50542109184351,
            lc60: 100,
            lc45: 80,
            lc30: 49.5,
            lc10: 24.5
        },
        "crimson.600": {
            contrast: 47.17606400817533,
            lc60: 100,
            lc45: 91.5,
            lc30: 54,
            lc10: 26.5
        },
        "crimson.700": {
            contrast: 42.94841604842439,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 28.5
        },
        "crimson.800": {
            contrast: 37.62148390619907,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 32
        },
        "crimson.900": {
            contrast: 34.5199294336595,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 38
        },
        "crimson.1000": {
            contrast: 30.441164222080484,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 45.5
        },
        "crimson.1100": {
            contrast: 26.320895860285148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.1200": {
            contrast: 21.583176001898046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "crimson.1300": {
            contrast: 16.900039253455507,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "crimson.1400": {
            contrast: 12.612207468777036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1500": {
            contrast: 7.8751409622927815,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 10.194483618654008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 16.187348490646325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "crimson.2100": {
            contrast: 22.55948484901222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "crimson.2200": {
            contrast: 28.857431690483732,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "crimson.2300": {
            contrast: 35.51852693479748,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        },
        "crimson.2400": {
            contrast: 42.48638587527774,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        },
        "crimson.2500": {
            contrast: 49.221172785592515,
            lc60: 100,
            lc45: 92.5,
            lc30: 66.5,
            lc10: 36.5
        }
    },
    "crimson.1800": {
        "crimson.100": {
            contrast: 64.60756131060131,
            lc60: 77.5,
            lc45: 54,
            lc30: 35,
            lc10: 17.5
        },
        "crimson.200": {
            contrast: 63.98750488191437,
            lc60: 84,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19
        },
        "crimson.300": {
            contrast: 62.110415997644566,
            lc60: 91,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "crimson.400": {
            contrast: 59.80900066017581,
            lc60: 100,
            lc45: 65.5,
            lc30: 42,
            lc10: 21
        },
        "crimson.500": {
            contrast: 56.54304781091404,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "crimson.600": {
            contrast: 52.213690727245854,
            lc60: 100,
            lc45: 78,
            lc30: 47.5,
            lc10: 24
        },
        "crimson.700": {
            contrast: 47.98604276749492,
            lc60: 100,
            lc45: 88.5,
            lc30: 51.5,
            lc10: 25.5
        },
        "crimson.800": {
            contrast: 42.65911062526959,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 27.5
        },
        "crimson.900": {
            contrast: 39.55755615273003,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33
        },
        "crimson.1000": {
            contrast: 35.47879094115101,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 38
        },
        "crimson.1100": {
            contrast: 31.358522579355675,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 44
        },
        "crimson.1200": {
            contrast: 26.620802720968566,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "crimson.1300": {
            contrast: 21.937665972526034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "crimson.1400": {
            contrast: 17.649834187847564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "crimson.1500": {
            contrast: 12.912767681363308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1600": {
            contrast: 7.959519679146858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 10.780474727547496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 17.152611085913392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "crimson.2200": {
            contrast: 23.450557927384903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "crimson.2300": {
            contrast: 30.11165317169865,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "crimson.2400": {
            contrast: 37.07951211217891,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46
        },
        "crimson.2500": {
            contrast: 43.81429902249369,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        }
    },
    "crimson.1900": {
        "crimson.100": {
            contrast: 70.11700780773035,
            lc60: 69,
            lc45: 49.5,
            lc30: 32,
            lc10: 16.5
        },
        "crimson.200": {
            contrast: 69.49695137904341,
            lc60: 74,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.300": {
            contrast: 67.6198624947736,
            lc60: 78.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "crimson.400": {
            contrast: 65.31844715730483,
            lc60: 84,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "crimson.500": {
            contrast: 62.05249430804307,
            lc60: 93,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "crimson.600": {
            contrast: 57.72313722437489,
            lc60: 100,
            lc45: 67,
            lc30: 42,
            lc10: 21
        },
        "crimson.700": {
            contrast: 53.495489264623956,
            lc60: 100,
            lc45: 73.5,
            lc30: 45,
            lc10: 22.5
        },
        "crimson.800": {
            contrast: 48.168557122398624,
            lc60: 100,
            lc45: 86,
            lc30: 49,
            lc10: 24
        },
        "crimson.900": {
            contrast: 45.06700264985906,
            lc60: 100,
            lc45: 99,
            lc30: 57.5,
            lc10: 28
        },
        "crimson.1000": {
            contrast: 40.98823743828004,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32.5
        },
        "crimson.1100": {
            contrast: 36.867969076484705,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 37
        },
        "crimson.1200": {
            contrast: 32.1302492180976,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 43
        },
        "crimson.1300": {
            contrast: 27.44711246965506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "crimson.1400": {
            contrast: 23.159280684976594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "crimson.1500": {
            contrast: 18.42221417849234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "crimson.1600": {
            contrast: 13.46896617627589,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1700": {
            contrast: 8.475573877408028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 11.169954961436938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 17.467901802908443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "crimson.2300": {
            contrast: 24.128997047222196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "crimson.2400": {
            contrast: 31.096855987702448,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53
        },
        "crimson.2500": {
            contrast: 37.83164289801723,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45
        }
    },
    "crimson.2000": {
        "crimson.100": {
            contrast: 75.73275897548362,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15
        },
        "crimson.200": {
            contrast: 75.11270254679668,
            lc60: 67,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "crimson.300": {
            contrast: 73.23561366252687,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "crimson.400": {
            contrast: 70.93419832505812,
            lc60: 74.5,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "crimson.500": {
            contrast: 67.66824547579635,
            lc60: 80,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "crimson.600": {
            contrast: 63.33888839212817,
            lc60: 88.5,
            lc45: 59,
            lc30: 38,
            lc10: 19
        },
        "crimson.700": {
            contrast: 59.11124043237722,
            lc60: 100,
            lc45: 64,
            lc30: 40,
            lc10: 20
        },
        "crimson.800": {
            contrast: 53.784308290151905,
            lc60: 100,
            lc45: 71,
            lc30: 42.5,
            lc10: 21
        },
        "crimson.900": {
            contrast: 50.68275381761234,
            lc60: 100,
            lc45: 81.5,
            lc30: 49.5,
            lc10: 25
        },
        "crimson.1000": {
            contrast: 46.60398860603331,
            lc60: 100,
            lc45: 94,
            lc30: 56.5,
            lc10: 28.5
        },
        "crimson.1100": {
            contrast: 42.48372024423798,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 31.5
        },
        "crimson.1200": {
            contrast: 37.74600038585088,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36.5
        },
        "crimson.1300": {
            contrast: 33.062863637408334,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 42
        },
        "crimson.1400": {
            contrast: 28.775031852729864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "crimson.1500": {
            contrast: 24.037965346245613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "crimson.1600": {
            contrast: 19.084717344029162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "crimson.1700": {
            contrast: 14.091325045161302,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1800": {
            contrast: 9.008159767006592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 11.299560623034882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 17.96065586734863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.2400": {
            contrast: 24.92851480782889,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "crimson.2500": {
            contrast: 31.66330171814367,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52
        }
    },
    "crimson.2100": {
        "crimson.100": {
            contrast: 81.65997887413087,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "crimson.200": {
            contrast: 81.03992244544392,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "crimson.300": {
            contrast: 79.16283356117412,
            lc60: 64,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "crimson.400": {
            contrast: 76.86141822370537,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "crimson.500": {
            contrast: 73.59546537444358,
            lc60: 70.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "crimson.600": {
            contrast: 69.26610829077542,
            lc60: 76,
            lc45: 53,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.700": {
            contrast: 65.03846033102447,
            lc60: 83.5,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18
        },
        "crimson.800": {
            contrast: 59.71152818879914,
            lc60: 100,
            lc45: 60.5,
            lc30: 38,
            lc10: 19
        },
        "crimson.900": {
            contrast: 56.60997371625959,
            lc60: 100,
            lc45: 69.5,
            lc30: 43.5,
            lc10: 22
        },
        "crimson.1000": {
            contrast: 52.53120850468056,
            lc60: 100,
            lc45: 79,
            lc30: 48.5,
            lc10: 24.5
        },
        "crimson.1100": {
            contrast: 48.41094014288523,
            lc60: 100,
            lc45: 89,
            lc30: 54.5,
            lc10: 27
        },
        "crimson.1200": {
            contrast: 43.67322028449813,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "crimson.1300": {
            contrast: 38.990083536055586,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 35
        },
        "crimson.1400": {
            contrast: 34.70225175137712,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 40.5
        },
        "crimson.1500": {
            contrast: 29.96518524489286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "crimson.1600": {
            contrast: 25.011937242676407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "crimson.1700": {
            contrast: 20.018544943808553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "crimson.1800": {
            contrast: 14.935379665653844,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.1900": {
            contrast: 9.368919849383493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 11.377674339747957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 18.345533280228214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "crimson.2500": {
            contrast: 25.08032019054299,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        }
    },
    "crimson.2200": {
        "crimson.100": {
            contrast: 87.47716229120596,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "crimson.200": {
            contrast: 86.857105862519,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "crimson.300": {
            contrast: 84.98001697824921,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "crimson.400": {
            contrast: 82.67860164078046,
            lc60: 61,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "crimson.500": {
            contrast: 79.41264879151869,
            lc60: 63.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "crimson.600": {
            contrast: 75.0832917078505,
            lc60: 67.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16
        },
        "crimson.700": {
            contrast: 70.85564374809957,
            lc60: 72,
            lc45: 50,
            lc30: 32,
            lc10: 16.5
        },
        "crimson.800": {
            contrast: 65.52871160587424,
            lc60: 80.5,
            lc45: 53.5,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.900": {
            contrast: 62.42715713333467,
            lc60: 92,
            lc45: 61,
            lc30: 39,
            lc10: 20
        },
        "crimson.1000": {
            contrast: 58.34839192175566,
            lc60: 100,
            lc45: 68,
            lc30: 43,
            lc10: 22
        },
        "crimson.1100": {
            contrast: 54.228123559960316,
            lc60: 100,
            lc45: 76,
            lc30: 47.5,
            lc10: 24
        },
        "crimson.1200": {
            contrast: 49.490403701573214,
            lc60: 100,
            lc45: 87,
            lc30: 54,
            lc10: 27
        },
        "crimson.1300": {
            contrast: 44.80726695313068,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "crimson.1400": {
            contrast: 40.519435168452205,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "crimson.1500": {
            contrast: 35.78236866196795,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 39.5
        },
        "crimson.1600": {
            contrast: 30.829120659751503,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 47.5
        },
        "crimson.1700": {
            contrast: 25.835728360883635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "crimson.1800": {
            contrast: 20.752563082728933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "crimson.1900": {
            contrast: 15.186103266458584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "crimson.2000": {
            contrast: 9.505012778783492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 11.816294383937038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 18.551081294251816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        }
    },
    "crimson.2300": {
        "crimson.100": {
            contrast: 93.58872827911867,
            lc60: 50,
            lc45: 37,
            lc30: 24.5,
            lc10: 12.5
        },
        "crimson.200": {
            contrast: 92.96867185043173,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "crimson.300": {
            contrast: 91.09158296616192,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "crimson.400": {
            contrast: 88.79016762869317,
            lc60: 56,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "crimson.500": {
            contrast: 85.52421477943139,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "crimson.600": {
            contrast: 81.19485769576322,
            lc60: 61,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "crimson.700": {
            contrast: 76.96720973601228,
            lc60: 64,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "crimson.800": {
            contrast: 71.64027759378695,
            lc60: 69.5,
            lc45: 48,
            lc30: 31,
            lc10: 16
        },
        "crimson.900": {
            contrast: 68.53872312124739,
            lc60: 78.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "crimson.1000": {
            contrast: 64.45995790966836,
            lc60: 87.5,
            lc45: 60,
            lc30: 38.5,
            lc10: 20
        },
        "crimson.1100": {
            contrast: 60.339689547873036,
            lc60: 98.5,
            lc45: 66,
            lc30: 42,
            lc10: 21.5
        },
        "crimson.1200": {
            contrast: 55.60196968948592,
            lc60: 100,
            lc45: 74,
            lc30: 46.5,
            lc10: 24
        },
        "crimson.1300": {
            contrast: 50.91883294104339,
            lc60: 100,
            lc45: 84,
            lc30: 52,
            lc10: 26.5
        },
        "crimson.1400": {
            contrast: 46.631001156364924,
            lc60: 100,
            lc45: 95,
            lc30: 58.5,
            lc10: 29
        },
        "crimson.1500": {
            contrast: 41.89393464988066,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33
        },
        "crimson.1600": {
            contrast: 36.94068664766421,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 39
        },
        "crimson.1700": {
            contrast: 31.94729434879635,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 47
        },
        "crimson.1800": {
            contrast: 26.864129070641646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "crimson.1900": {
            contrast: 21.297669254371296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "crimson.2000": {
            contrast: 15.616578766696204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "crimson.2100": {
            contrast: 9.61301041103883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 11.62220753722709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "crimson.2400": {
        "crimson.100": {
            contrast: 99.93986350811063,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "crimson.200": {
            contrast: 99.31980707942368,
            lc60: 48.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "crimson.300": {
            contrast: 97.44271819515387,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 13
        },
        "crimson.400": {
            contrast: 95.14130285768513,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "crimson.500": {
            contrast: 91.87535000842334,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "crimson.600": {
            contrast: 87.54599292475517,
            lc60: 55.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "crimson.700": {
            contrast: 83.31834496500423,
            lc60: 57.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "crimson.800": {
            contrast: 77.9914128227789,
            lc60: 61,
            lc45: 43.5,
            lc30: 28,
            lc10: 14.5
        },
        "crimson.900": {
            contrast: 74.88985835023935,
            lc60: 69,
            lc45: 49,
            lc30: 31.5,
            lc10: 16.5
        },
        "crimson.1000": {
            contrast: 70.81109313866033,
            lc60: 76,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 18
        },
        "crimson.1100": {
            contrast: 66.690824776865,
            lc60: 84,
            lc45: 58,
            lc30: 37.5,
            lc10: 19.5
        },
        "crimson.1200": {
            contrast: 61.953104918477884,
            lc60: 95,
            lc45: 65,
            lc30: 41.5,
            lc10: 21.5
        },
        "crimson.1300": {
            contrast: 57.26996817003535,
            lc60: 100,
            lc45: 71.5,
            lc30: 45.5,
            lc10: 23
        },
        "crimson.1400": {
            contrast: 52.98213638535687,
            lc60: 100,
            lc45: 80,
            lc30: 51,
            lc10: 26
        },
        "crimson.1500": {
            contrast: 48.24506987887261,
            lc60: 100,
            lc45: 91,
            lc30: 57,
            lc10: 29
        },
        "crimson.1600": {
            contrast: 43.291821876656165,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 33.5
        },
        "crimson.1700": {
            contrast: 38.298429577788305,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38.5
        },
        "crimson.1800": {
            contrast: 33.2152642996336,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 44.5
        },
        "crimson.1900": {
            contrast: 27.64880448336325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "crimson.2000": {
            contrast: 21.96771399568816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "crimson.2100": {
            contrast: 15.964145640030786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "crimson.2200": {
            contrast: 10.06512520752201,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "crimson.2500": {
        "crimson.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "crimson.200": {
            contrast: 105.42061678400168,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "crimson.300": {
            contrast: 103.54352789973187,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "crimson.400": {
            contrast: 101.2421125622631,
            lc60: 48,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12
        },
        "crimson.500": {
            contrast: 97.97615971300132,
            lc60: 49.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "crimson.600": {
            contrast: 93.64680262933315,
            lc60: 51,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "crimson.700": {
            contrast: 89.4191546695822,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "crimson.800": {
            contrast: 84.09222252735688,
            lc60: 55.5,
            lc45: 40,
            lc30: 26,
            lc10: 13.5
        },
        "crimson.900": {
            contrast: 80.99066805481733,
            lc60: 62,
            lc45: 44.5,
            lc30: 29,
            lc10: 15.5
        },
        "crimson.1000": {
            contrast: 76.9119028432383,
            lc60: 68,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "crimson.1100": {
            contrast: 72.79163448144297,
            lc60: 74,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "crimson.1200": {
            contrast: 68.05391462305586,
            lc60: 81.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "crimson.1300": {
            contrast: 63.37077787461332,
            lc60: 91.5,
            lc45: 63.5,
            lc30: 41,
            lc10: 21.5
        },
        "crimson.1400": {
            contrast: 59.08294608993485,
            lc60: 100,
            lc45: 69.5,
            lc30: 45,
            lc10: 23
        },
        "crimson.1500": {
            contrast: 54.345879583450596,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 25.5
        },
        "crimson.1600": {
            contrast: 49.392631581234134,
            lc60: 100,
            lc45: 88.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "crimson.1700": {
            contrast: 44.399239282366274,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 33
        },
        "crimson.1800": {
            contrast: 39.31607400421157,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38
        },
        "crimson.1900": {
            contrast: 33.74961418794122,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 45
        },
        "crimson.2000": {
            contrast: 28.06852370026613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "crimson.2100": {
            contrast: 22.06495534460876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "crimson.2200": {
            contrast: 16.16593491209998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "crimson.2300": {
            contrast: 9.961472820262385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "crimson.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$neutral = {
    "neutral.100": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 8.366961173586047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 12.590250558615693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 17.197013373984785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "neutral.900": {
            contrast: 21.75428542494453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "neutral.1000": {
            contrast: 26.008308993672237,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "neutral.1100": {
            contrast: 30.457434854569943,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 69
        },
        "neutral.1200": {
            contrast: 35.570239665269995,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 63
        },
        "neutral.1300": {
            contrast: 40.54254276837638,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 58.5
        },
        "neutral.1400": {
            contrast: 45.07757728949064,
            lc60: 100,
            lc45: 99.5,
            lc30: 79,
            lc10: 55
        },
        "neutral.1500": {
            contrast: 49.81784515925999,
            lc60: 100,
            lc45: 93.5,
            lc30: 74,
            lc10: 52
        },
        "neutral.1600": {
            contrast: 55.01058726445677,
            lc60: 100,
            lc45: 88.5,
            lc30: 70,
            lc10: 49
        },
        "neutral.1700": {
            contrast: 60.069832282190475,
            lc60: 99.5,
            lc45: 83.5,
            lc30: 66,
            lc10: 46.5
        },
        "neutral.1800": {
            contrast: 65.09775711428387,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 44
        },
        "neutral.1900": {
            contrast: 70.82938054154853,
            lc60: 90,
            lc45: 76,
            lc30: 60,
            lc10: 42
        },
        "neutral.2000": {
            contrast: 76.70501676428657,
            lc60: 86,
            lc45: 72,
            lc30: 57,
            lc10: 40
        },
        "neutral.2100": {
            contrast: 82.28243165168517,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "neutral.2200": {
            contrast: 88.4255523763984,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 52,
            lc10: 36.5
        },
        "neutral.2300": {
            contrast: 94.8846536000372,
            lc60: 75,
            lc45: 63,
            lc30: 49.5,
            lc10: 35
        },
        "neutral.2400": {
            contrast: 101.3437952081248,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33.5
        },
        "neutral.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "neutral.200": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 8.09484159898223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 12.318130984011875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 16.924893799380968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "neutral.900": {
            contrast: 21.482165850340717,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "neutral.1000": {
            contrast: 25.736189419068417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "neutral.1100": {
            contrast: 30.185315279966122,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 65.5
        },
        "neutral.1200": {
            contrast: 35.298120090666174,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 59.5
        },
        "neutral.1300": {
            contrast: 40.27042319377256,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 54.5
        },
        "neutral.1400": {
            contrast: 44.80545771488682,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 51
        },
        "neutral.1500": {
            contrast: 49.54572558465616,
            lc60: 100,
            lc45: 94,
            lc30: 72.5,
            lc10: 47.5
        },
        "neutral.1600": {
            contrast: 54.738467689852946,
            lc60: 100,
            lc45: 88,
            lc30: 68,
            lc10: 44.5
        },
        "neutral.1700": {
            contrast: 59.79771270758665,
            lc60: 100,
            lc45: 83,
            lc30: 64,
            lc10: 42
        },
        "neutral.1800": {
            contrast: 64.82563753968003,
            lc60: 95,
            lc45: 78.5,
            lc30: 60.5,
            lc10: 40
        },
        "neutral.1900": {
            contrast: 70.55726096694471,
            lc60: 89.5,
            lc45: 74.5,
            lc30: 57.5,
            lc10: 38
        },
        "neutral.2000": {
            contrast: 76.43289718968275,
            lc60: 85,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 36
        },
        "neutral.2100": {
            contrast: 82.01031207708137,
            lc60: 81,
            lc45: 67.5,
            lc30: 52,
            lc10: 34
        },
        "neutral.2200": {
            contrast: 88.15343280179458,
            lc60: 77.5,
            lc45: 64,
            lc30: 49.5,
            lc10: 32.5
        },
        "neutral.2300": {
            contrast: 94.61253402543338,
            lc60: 74,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        },
        "neutral.2400": {
            contrast: 101.071675633521,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 29.5
        },
        "neutral.2500": {
            contrast: 107.61261360849466,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "neutral.300": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 11.153597938371501,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 15.760360753740594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "neutral.900": {
            contrast: 20.31763280470034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "neutral.1000": {
            contrast: 24.57165637342805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "neutral.1100": {
            contrast: 29.020782234325747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "neutral.1200": {
            contrast: 34.13358704502579,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 57
        },
        "neutral.1300": {
            contrast: 39.10589014813218,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 52
        },
        "neutral.1400": {
            contrast: 43.640924669246445,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 48
        },
        "neutral.1500": {
            contrast: 48.38119253901579,
            lc60: 100,
            lc45: 95,
            lc30: 71,
            lc10: 44.5
        },
        "neutral.1600": {
            contrast: 53.57393464421257,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "neutral.1700": {
            contrast: 58.633179661946265,
            lc60: 100,
            lc45: 82.5,
            lc30: 62.5,
            lc10: 39
        },
        "neutral.1800": {
            contrast: 63.66110449403967,
            lc60: 95.5,
            lc45: 78,
            lc30: 59,
            lc10: 37
        },
        "neutral.1900": {
            contrast: 69.39272792130434,
            lc60: 90,
            lc45: 73.5,
            lc30: 55.5,
            lc10: 35
        },
        "neutral.2000": {
            contrast: 75.26836414404238,
            lc60: 85,
            lc45: 69.5,
            lc30: 52.5,
            lc10: 33
        },
        "neutral.2100": {
            contrast: 80.84577903144098,
            lc60: 81,
            lc45: 66,
            lc30: 49.5,
            lc10: 31
        },
        "neutral.2200": {
            contrast: 86.9888997561542,
            lc60: 77,
            lc45: 62.5,
            lc30: 47,
            lc10: 29.5
        },
        "neutral.2300": {
            contrast: 93.448000979793,
            lc60: 73,
            lc45: 59.5,
            lc30: 44.5,
            lc10: 28
        },
        "neutral.2400": {
            contrast: 99.9071425878806,
            lc60: 69.5,
            lc45: 57,
            lc30: 42.5,
            lc10: 27
        },
        "neutral.2500": {
            contrast: 106.44808056285429,
            lc60: 66.5,
            lc45: 54.5,
            lc30: 41,
            lc10: 25.5
        }
    },
    "neutral.400": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 9.502937171776669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 14.109699987145763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 18.66697203810551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "neutral.1000": {
            contrast: 22.920995606833213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "neutral.1100": {
            contrast: 27.37012146773091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "neutral.1200": {
            contrast: 32.48292627843096,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 57
        },
        "neutral.1300": {
            contrast: 37.45522938153735,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 50.5
        },
        "neutral.1400": {
            contrast: 41.99026390265161,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 46.5
        },
        "neutral.1500": {
            contrast: 46.73053177242096,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 43
        },
        "neutral.1600": {
            contrast: 51.92327387761774,
            lc60: 100,
            lc45: 89.5,
            lc30: 66.5,
            lc10: 40
        },
        "neutral.1700": {
            contrast: 56.98251889535144,
            lc60: 100,
            lc45: 83.5,
            lc30: 62,
            lc10: 37.5
        },
        "neutral.1800": {
            contrast: 62.01044372744483,
            lc60: 97.5,
            lc45: 78.5,
            lc30: 58,
            lc10: 35
        },
        "neutral.1900": {
            contrast: 67.7420671547095,
            lc60: 91,
            lc45: 73.5,
            lc30: 54.5,
            lc10: 33
        },
        "neutral.2000": {
            contrast: 73.61770337744754,
            lc60: 86,
            lc45: 69,
            lc30: 51,
            lc10: 31
        },
        "neutral.2100": {
            contrast: 79.19511826484614,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 48.5,
            lc10: 29
        },
        "neutral.2200": {
            contrast: 85.33823898955937,
            lc60: 77,
            lc45: 62,
            lc30: 46,
            lc10: 27.5
        },
        "neutral.2300": {
            contrast: 91.79734021319817,
            lc60: 73,
            lc45: 59,
            lc30: 43.5,
            lc10: 26
        },
        "neutral.2400": {
            contrast: 98.25648182128576,
            lc60: 69.5,
            lc45: 56,
            lc30: 41.5,
            lc10: 25
        },
        "neutral.2500": {
            contrast: 104.79741979625945,
            lc60: 66.5,
            lc45: 53.5,
            lc30: 39.5,
            lc10: 23.5
        }
    },
    "neutral.500": {
        "neutral.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 11.375354131407011,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 15.93262618236676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "neutral.1000": {
            contrast: 20.186649751094464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "neutral.1100": {
            contrast: 24.63577561199217,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "neutral.1200": {
            contrast: 29.74858042269221,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.1300": {
            contrast: 34.7208835257986,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51
        },
        "neutral.1400": {
            contrast: 39.25591804691286,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 46
        },
        "neutral.1500": {
            contrast: 43.99618591668221,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42.5
        },
        "neutral.1600": {
            contrast: 49.188928021878986,
            lc60: 100,
            lc45: 93.5,
            lc30: 67.5,
            lc10: 38.5
        },
        "neutral.1700": {
            contrast: 54.24817303961269,
            lc60: 100,
            lc45: 86,
            lc30: 63,
            lc10: 36
        },
        "neutral.1800": {
            contrast: 59.27609787170608,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 33.5
        },
        "neutral.1900": {
            contrast: 65.00772129897075,
            lc60: 94,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 31
        },
        "neutral.2000": {
            contrast: 70.88335752170879,
            lc60: 88,
            lc45: 70.5,
            lc30: 51,
            lc10: 29
        },
        "neutral.2100": {
            contrast: 76.46077240910739,
            lc60: 83,
            lc45: 66.5,
            lc30: 48,
            lc10: 27.5
        },
        "neutral.2200": {
            contrast: 82.60389313382062,
            lc60: 78,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 26
        },
        "neutral.2300": {
            contrast: 89.06299435745942,
            lc60: 74,
            lc45: 59,
            lc30: 43,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 95.52213596554702,
            lc60: 70,
            lc45: 56,
            lc30: 40.5,
            lc10: 23.5
        },
        "neutral.2500": {
            contrast: 102.0630739405207,
            lc60: 66.5,
            lc45: 53,
            lc30: 38.5,
            lc10: 22
        }
    },
    "neutral.600": {
        "neutral.100": {
            contrast: 9.723504986922668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 9.357781370612631,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 7.827148071570118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 7.506068813666074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 12.063340864625822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 16.317364433353525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "neutral.1100": {
            contrast: 20.766490294251234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "neutral.1200": {
            contrast: 25.87929510495128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "neutral.1300": {
            contrast: 30.851598208057666,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 55
        },
        "neutral.1400": {
            contrast: 35.38663272917193,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 49
        },
        "neutral.1500": {
            contrast: 40.126900598941276,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44.5
        },
        "neutral.1600": {
            contrast: 45.319642704138055,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 40.5
        },
        "neutral.1700": {
            contrast: 50.378887721871756,
            lc60: 100,
            lc45: 91.5,
            lc30: 65.5,
            lc10: 37
        },
        "neutral.1800": {
            contrast: 55.406812553965146,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 34.5
        },
        "neutral.1900": {
            contrast: 61.13843598122982,
            lc60: 98.5,
            lc45: 78,
            lc30: 56,
            lc10: 32
        },
        "neutral.2000": {
            contrast: 67.01407220396786,
            lc60: 91.5,
            lc45: 72.5,
            lc30: 52,
            lc10: 29.5
        },
        "neutral.2100": {
            contrast: 72.59148709136646,
            lc60: 86,
            lc45: 68.5,
            lc30: 49,
            lc10: 28
        },
        "neutral.2200": {
            contrast: 78.73460781607969,
            lc60: 80.5,
            lc45: 64,
            lc30: 46,
            lc10: 26
        },
        "neutral.2300": {
            contrast: 85.19370903971848,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 91.65285064780608,
            lc60: 71.5,
            lc45: 57,
            lc30: 41,
            lc10: 23
        },
        "neutral.2500": {
            contrast: 98.19378862277975,
            lc60: 67.5,
            lc45: 54,
            lc30: 39,
            lc10: 22
        }
    },
    "neutral.700": {
        "neutral.100": {
            contrast: 14.321495386167626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.200": {
            contrast: 13.955771769857591,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.300": {
            contrast: 12.425138470815078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.400": {
            contrast: 10.330193175904926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 8.030413837942493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 12.284437406670198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 16.733563267567906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "neutral.1200": {
            contrast: 21.846368078267954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "neutral.1300": {
            contrast: 26.818671181374338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "neutral.1400": {
            contrast: 31.3537057024886,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53.5
        },
        "neutral.1500": {
            contrast: 36.093973572257944,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 47.5
        },
        "neutral.1600": {
            contrast: 41.28671567745472,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "neutral.1700": {
            contrast: 46.345960695188424,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38.5
        },
        "neutral.1800": {
            contrast: 51.373885527281814,
            lc60: 100,
            lc45: 89.5,
            lc30: 64,
            lc10: 35.5
        },
        "neutral.1900": {
            contrast: 57.105508954546494,
            lc60: 100,
            lc45: 82,
            lc30: 58.5,
            lc10: 32.5
        },
        "neutral.2000": {
            contrast: 62.981145177284525,
            lc60: 95.5,
            lc45: 75.5,
            lc30: 54,
            lc10: 30
        },
        "neutral.2100": {
            contrast: 68.55856006468314,
            lc60: 89.5,
            lc45: 70.5,
            lc30: 50.5,
            lc10: 28
        },
        "neutral.2200": {
            contrast: 74.70168078939636,
            lc60: 83.5,
            lc45: 66,
            lc30: 47,
            lc10: 26.5
        },
        "neutral.2300": {
            contrast: 81.16078201303515,
            lc60: 78,
            lc45: 61.5,
            lc30: 44,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 87.61992362112275,
            lc60: 73.5,
            lc45: 58,
            lc30: 41.5,
            lc10: 23
        },
        "neutral.2500": {
            contrast: 94.16086159609642,
            lc60: 69.5,
            lc45: 55,
            lc30: 39,
            lc10: 22
        }
    },
    "neutral.800": {
        "neutral.100": {
            contrast: 19.22340923915762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "neutral.200": {
            contrast: 18.85768562284758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "neutral.300": {
            contrast: 17.327052323805066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "neutral.400": {
            contrast: 15.232107028894914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "neutral.500": {
            contrast: 11.897803001867507,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.600": {
            contrast: 7.378681199683134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 7.83467396184593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 12.283799822743635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 17.396604633443683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "neutral.1300": {
            contrast: 22.368907736550074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.1400": {
            contrast: 26.903942257664326,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "neutral.1500": {
            contrast: 31.64421012743367,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52
        },
        "neutral.1600": {
            contrast: 36.83695223263045,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "neutral.1700": {
            contrast: 41.89619725036415,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 41
        },
        "neutral.1800": {
            contrast: 46.924122082457544,
            lc60: 100,
            lc45: 96,
            lc30: 68.5,
            lc10: 37
        },
        "neutral.1900": {
            contrast: 52.655745509722216,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 33.5
        },
        "neutral.2000": {
            contrast: 58.531381732460254,
            lc60: 100,
            lc45: 80,
            lc30: 57,
            lc10: 30.5
        },
        "neutral.2100": {
            contrast: 64.10879661985885,
            lc60: 94.5,
            lc45: 74,
            lc30: 53,
            lc10: 28.5
        },
        "neutral.2200": {
            contrast: 70.25191734457208,
            lc60: 87.5,
            lc45: 68.5,
            lc30: 49,
            lc10: 26.5
        },
        "neutral.2300": {
            contrast: 76.71101856821087,
            lc60: 81.5,
            lc45: 64,
            lc30: 45.5,
            lc10: 24.5
        },
        "neutral.2400": {
            contrast: 83.17016017629848,
            lc60: 76.5,
            lc45: 60,
            lc30: 42.5,
            lc10: 23
        },
        "neutral.2500": {
            contrast: 89.71109815127215,
            lc60: 72,
            lc45: 56.5,
            lc30: 40,
            lc10: 21.5
        }
    },
    "neutral.900": {
        "neutral.100": {
            contrast: 23.98060782356903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "neutral.200": {
            contrast: 23.614884207258992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "neutral.300": {
            contrast: 22.08425090821648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.400": {
            contrast: 19.98930561330633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "neutral.500": {
            contrast: 16.65500158627892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "neutral.600": {
            contrast: 12.135879784094547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.700": {
            contrast: 7.599251407367317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 7.839476216193154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 12.952281026893203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 17.92458412999959,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "neutral.1400": {
            contrast: 22.459618651113853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "neutral.1500": {
            contrast: 27.199886520883194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "neutral.1600": {
            contrast: 32.39262862607997,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 50.5
        },
        "neutral.1700": {
            contrast: 37.45187364381367,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 44.5
        },
        "neutral.1800": {
            contrast: 42.47979847590707,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 40
        },
        "neutral.1900": {
            contrast: 48.21142190317174,
            lc60: 100,
            lc45: 94,
            lc30: 66,
            lc10: 36
        },
        "neutral.2000": {
            contrast: 54.08705812590977,
            lc60: 100,
            lc45: 85.5,
            lc30: 60,
            lc10: 32.5
        },
        "neutral.2100": {
            contrast: 59.66447301330838,
            lc60: 100,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 30
        },
        "neutral.2200": {
            contrast: 65.80759373802161,
            lc60: 92,
            lc45: 72.5,
            lc30: 51,
            lc10: 27.5
        },
        "neutral.2300": {
            contrast: 72.2666949616604,
            lc60: 85.5,
            lc45: 67,
            lc30: 47,
            lc10: 25.5
        },
        "neutral.2400": {
            contrast: 78.725836569748,
            lc60: 79.5,
            lc45: 62.5,
            lc30: 44,
            lc10: 23.5
        },
        "neutral.2500": {
            contrast: 85.26677454472167,
            lc60: 74.5,
            lc45: 58.5,
            lc30: 41,
            lc10: 22
        }
    },
    "neutral.1000": {
        "neutral.100": {
            contrast: 28.353289001218197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 37.5
        },
        "neutral.200": {
            contrast: 27.98756538490817,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43
        },
        "neutral.300": {
            contrast: 26.456932085865652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "neutral.400": {
            contrast: 24.361986790955502,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.500": {
            contrast: 21.027682763928095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "neutral.600": {
            contrast: 16.508560961743722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "neutral.700": {
            contrast: 11.97193258501649,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 8.771587525825433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 13.74389062893182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 18.27892515004608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "neutral.1500": {
            contrast: 23.01919301981543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "neutral.1600": {
            contrast: 28.211935125012204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "neutral.1700": {
            contrast: 33.271180142745905,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 49
        },
        "neutral.1800": {
            contrast: 38.299104974839295,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 43.5
        },
        "neutral.1900": {
            contrast: 44.030728402103975,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 38.5
        },
        "neutral.2000": {
            contrast: 49.90636462484201,
            lc60: 100,
            lc45: 91,
            lc30: 64,
            lc10: 34.5
        },
        "neutral.2100": {
            contrast: 55.483779512240616,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 31.5
        },
        "neutral.2200": {
            contrast: 61.626900236953844,
            lc60: 97.5,
            lc45: 76,
            lc30: 53.5,
            lc10: 28.5
        },
        "neutral.2300": {
            contrast: 68.08600146059263,
            lc60: 90,
            lc45: 70,
            lc30: 49.5,
            lc10: 26.5
        },
        "neutral.2400": {
            contrast: 74.54514306868023,
            lc60: 83,
            lc45: 65,
            lc30: 45.5,
            lc10: 24.5
        },
        "neutral.2500": {
            contrast: 81.0860810436539,
            lc60: 77.5,
            lc45: 60.5,
            lc30: 42.5,
            lc10: 22.5
        }
    },
    "neutral.1100": {
        "neutral.100": {
            contrast: 32.866886229088514,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 33
        },
        "neutral.200": {
            contrast: 32.50116261277849,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 37
        },
        "neutral.300": {
            contrast: 30.970529313735966,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 42.5
        },
        "neutral.400": {
            contrast: 28.87558401882582,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "neutral.500": {
            contrast: 25.54127999179841,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.600": {
            contrast: 21.02215818961404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "neutral.700": {
            contrast: 16.48552981288681,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "neutral.800": {
            contrast: 11.630531118675375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 9.34267537902383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 13.877709900138091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 18.617977769907437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "neutral.1600": {
            contrast: 23.810719875104216,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "neutral.1700": {
            contrast: 28.869964892837913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "neutral.1800": {
            contrast: 33.897889724931304,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 48.5
        },
        "neutral.1900": {
            contrast: 39.62951315219598,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 42
        },
        "neutral.2000": {
            contrast: 45.50514937493402,
            lc60: 100,
            lc45: 99,
            lc30: 69.5,
            lc10: 37
        },
        "neutral.2100": {
            contrast: 51.08256426233262,
            lc60: 100,
            lc45: 89,
            lc30: 63,
            lc10: 33.5
        },
        "neutral.2200": {
            contrast: 57.22568498704585,
            lc60: 100,
            lc45: 81,
            lc30: 57,
            lc10: 30.5
        },
        "neutral.2300": {
            contrast: 63.68478621068464,
            lc60: 95,
            lc45: 73.5,
            lc30: 52,
            lc10: 27.5
        },
        "neutral.2400": {
            contrast: 70.14392781877223,
            lc60: 87.5,
            lc45: 68,
            lc30: 48,
            lc10: 25.5
        },
        "neutral.2500": {
            contrast: 76.68486579374591,
            lc60: 81,
            lc45: 63,
            lc30: 44,
            lc10: 23.5
        }
    },
    "neutral.1200": {
        "neutral.100": {
            contrast: 37.98878267466405,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 28.5
        },
        "neutral.200": {
            contrast: 37.62305905835402,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32
        },
        "neutral.300": {
            contrast: 36.0924257593115,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36
        },
        "neutral.400": {
            contrast: 33.997480464401356,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 40.5
        },
        "neutral.500": {
            contrast: 30.663176437373945,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47
        },
        "neutral.600": {
            contrast: 26.144054635189573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "neutral.700": {
            contrast: 21.607426258462343,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "neutral.800": {
            contrast: 16.75242756425091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "neutral.900": {
            contrast: 12.02568051006633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1000": {
            contrast: 7.669803890143571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 8.787971827874784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 13.528239697644128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 18.720981802840907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "neutral.1700": {
            contrast: 23.780226820574608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "neutral.1800": {
            contrast: 28.808151652668002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "neutral.1900": {
            contrast: 34.539775079932674,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 47.5
        },
        "neutral.2000": {
            contrast: 40.41541130267071,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 41
        },
        "neutral.2100": {
            contrast: 45.992826190069316,
            lc60: 100,
            lc45: 98,
            lc30: 68.5,
            lc10: 36.5
        },
        "neutral.2200": {
            contrast: 52.13594691478254,
            lc60: 100,
            lc45: 87.5,
            lc30: 61.5,
            lc10: 33
        },
        "neutral.2300": {
            contrast: 58.59504813842135,
            lc60: 100,
            lc45: 79.5,
            lc30: 55.5,
            lc10: 29.5
        },
        "neutral.2400": {
            contrast: 65.05418974650894,
            lc60: 93,
            lc45: 72.5,
            lc30: 50.5,
            lc10: 27
        },
        "neutral.2500": {
            contrast: 71.5951277214826,
            lc60: 85.5,
            lc45: 66.5,
            lc30: 46.5,
            lc10: 24.5
        }
    },
    "neutral.1300": {
        "neutral.100": {
            contrast: 42.91174078787491,
            lc60: 100,
            lc45: 100,
            lc30: 52.5,
            lc10: 26
        },
        "neutral.200": {
            contrast: 42.546017171564884,
            lc60: 100,
            lc45: 100,
            lc30: 57.5,
            lc10: 28.5
        },
        "neutral.300": {
            contrast: 41.015383872522364,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "neutral.400": {
            contrast: 38.92043857761222,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 35.5
        },
        "neutral.500": {
            contrast: 35.58613455058481,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41
        },
        "neutral.600": {
            contrast: 31.067012748400437,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 48
        },
        "neutral.700": {
            contrast: 26.530384371673204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.800": {
            contrast: 21.67538567746177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.900": {
            contrast: 16.948638623277194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "neutral.1000": {
            contrast: 12.592762003354432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1100": {
            contrast: 8.086664277932398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 8.549209382359349,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 13.741951487556129,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 18.80119650528983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "neutral.1800": {
            contrast: 23.82912133738322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "neutral.1900": {
            contrast: 29.560744764647893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "neutral.2000": {
            contrast: 35.43638098738593,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46
        },
        "neutral.2100": {
            contrast: 41.013795874784535,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 40.5
        },
        "neutral.2200": {
            contrast: 47.15691659949776,
            lc60: 100,
            lc45: 95.5,
            lc30: 66,
            lc10: 35.5
        },
        "neutral.2300": {
            contrast: 53.61601782313655,
            lc60: 100,
            lc45: 85.5,
            lc30: 59,
            lc10: 32
        },
        "neutral.2400": {
            contrast: 60.07515943122416,
            lc60: 99.5,
            lc45: 77.5,
            lc30: 53.5,
            lc10: 29
        },
        "neutral.2500": {
            contrast: 66.61609740619781,
            lc60: 91,
            lc45: 70.5,
            lc30: 49,
            lc10: 26.5
        }
    },
    "neutral.1400": {
        "neutral.100": {
            contrast: 47.35749537902972,
            lc60: 100,
            lc45: 80,
            lc30: 47,
            lc10: 23.5
        },
        "neutral.200": {
            contrast: 46.991771762719694,
            lc60: 100,
            lc45: 87.5,
            lc30: 51.5,
            lc10: 26
        },
        "neutral.300": {
            contrast: 45.46113846367717,
            lc60: 100,
            lc45: 97.5,
            lc30: 57.5,
            lc10: 29
        },
        "neutral.400": {
            contrast: 43.366193168767026,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "neutral.500": {
            contrast: 40.03188914173961,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "neutral.600": {
            contrast: 35.51276733955524,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "neutral.700": {
            contrast: 30.976138962828013,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 48.5
        },
        "neutral.800": {
            contrast: 26.121140268616582,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.900": {
            contrast: 21.394393214432004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "neutral.1000": {
            contrast: 17.038516594509243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "neutral.1100": {
            contrast: 12.53241886908721,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1200": {
            contrast: 7.408274634352259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 9.178230530289554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 14.237475548023257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 19.26540038011665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "neutral.1900": {
            contrast: 24.99702380738132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "neutral.2000": {
            contrast: 30.87266003011936,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 51.5
        },
        "neutral.2100": {
            contrast: 36.45007491751796,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 44.5
        },
        "neutral.2200": {
            contrast: 42.59319564223119,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 38.5
        },
        "neutral.2300": {
            contrast: 49.052296865869984,
            lc60: 100,
            lc45: 92,
            lc30: 64.5,
            lc10: 34
        },
        "neutral.2400": {
            contrast: 55.51143847395758,
            lc60: 100,
            lc45: 82.5,
            lc30: 57.5,
            lc10: 30.5
        },
        "neutral.2500": {
            contrast: 62.05237644893125,
            lc60: 96.5,
            lc45: 74.5,
            lc30: 52,
            lc10: 27.5
        }
    },
    "neutral.1500": {
        "neutral.100": {
            contrast: 51.963878834425,
            lc60: 100,
            lc45: 68.5,
            lc30: 43,
            lc10: 21.5
        },
        "neutral.200": {
            contrast: 51.59815521811497,
            lc60: 100,
            lc45: 74.5,
            lc30: 47,
            lc10: 23.5
        },
        "neutral.300": {
            contrast: 50.067521919072455,
            lc60: 100,
            lc45: 82.5,
            lc30: 52,
            lc10: 26
        },
        "neutral.400": {
            contrast: 47.9725766241623,
            lc60: 100,
            lc45: 90,
            lc30: 57,
            lc10: 28.5
        },
        "neutral.500": {
            contrast: 44.63827259713489,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32
        },
        "neutral.600": {
            contrast: 40.11915079495052,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 36.5
        },
        "neutral.700": {
            contrast: 35.58252241822329,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 42
        },
        "neutral.800": {
            contrast: 30.727523724011856,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 49
        },
        "neutral.900": {
            contrast: 26.000776669827275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.1000": {
            contrast: 21.644900049904518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.1100": {
            contrast: 17.138802324482484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "neutral.1200": {
            contrast: 12.014658089747535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 9.44626656217838,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 14.47419139427177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 20.205814821536446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "neutral.2000": {
            contrast: 26.081451044274484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "neutral.2100": {
            contrast: 31.658865931673084,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 49.5
        },
        "neutral.2200": {
            contrast: 37.80198665638631,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 42.5
        },
        "neutral.2300": {
            contrast: 44.26108788002511,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 37
        },
        "neutral.2400": {
            contrast: 50.720229488112714,
            lc60: 100,
            lc45: 90,
            lc30: 62,
            lc10: 32.5
        },
        "neutral.2500": {
            contrast: 57.26116746308637,
            lc60: 100,
            lc45: 80.5,
            lc30: 56,
            lc10: 29
        }
    },
    "neutral.1600": {
        "neutral.100": {
            contrast: 56.96684150006792,
            lc60: 100,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "neutral.200": {
            contrast: 56.60111788375788,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "neutral.300": {
            contrast: 55.07048458471536,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 23.5
        },
        "neutral.400": {
            contrast: 52.975539289805205,
            lc60: 100,
            lc45: 79.5,
            lc30: 51,
            lc10: 25.5
        },
        "neutral.500": {
            contrast: 49.641235262777805,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 28.5
        },
        "neutral.600": {
            contrast: 45.12211346059343,
            lc60: 100,
            lc45: 99.5,
            lc30: 63.5,
            lc10: 32
        },
        "neutral.700": {
            contrast: 40.5854850838662,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "neutral.800": {
            contrast: 35.73048638965477,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 42
        },
        "neutral.900": {
            contrast: 31.003739335470186,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 49
        },
        "neutral.1000": {
            contrast: 26.647862715547426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.1100": {
            contrast: 22.141764990125395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "neutral.1200": {
            contrast: 17.017620755390446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "neutral.1300": {
            contrast: 12.082846362317998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1400": {
            contrast: 7.619053637141171,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 9.203078261628805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 14.934701688893481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 20.810337911631517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "neutral.2100": {
            contrast: 26.387752799030118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.2200": {
            contrast: 32.530873523743345,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 49.5
        },
        "neutral.2300": {
            contrast: 38.98997474738214,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 42
        },
        "neutral.2400": {
            contrast: 45.44911635546974,
            lc60: 100,
            lc45: 99,
            lc30: 68,
            lc10: 36.5
        },
        "neutral.2500": {
            contrast: 51.9900543304434,
            lc60: 100,
            lc45: 87.5,
            lc30: 60.5,
            lc10: 32.5
        }
    },
    "neutral.1700": {
        "neutral.100": {
            contrast: 61.80171081707244,
            lc60: 85,
            lc45: 56.5,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.200": {
            contrast: 61.4359872007624,
            lc60: 91.5,
            lc45: 61,
            lc30: 39,
            lc10: 20
        },
        "neutral.300": {
            contrast: 59.905353901719884,
            lc60: 100,
            lc45: 66.5,
            lc30: 43,
            lc10: 22
        },
        "neutral.400": {
            contrast: 57.81040860680974,
            lc60: 100,
            lc45: 72,
            lc30: 46,
            lc10: 24
        },
        "neutral.500": {
            contrast: 54.47610457978232,
            lc60: 100,
            lc45: 79.5,
            lc30: 51,
            lc10: 26
        },
        "neutral.600": {
            contrast: 49.95698277759794,
            lc60: 100,
            lc45: 88,
            lc30: 57,
            lc10: 29
        },
        "neutral.700": {
            contrast: 45.42035440087072,
            lc60: 100,
            lc45: 98.5,
            lc30: 63.5,
            lc10: 33
        },
        "neutral.800": {
            contrast: 40.56535570665929,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 37.5
        },
        "neutral.900": {
            contrast: 35.838608652474704,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 42.5
        },
        "neutral.1000": {
            contrast: 31.482732032551947,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 49
        },
        "neutral.1100": {
            contrast: 26.976634307129917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "neutral.1200": {
            contrast: 21.85249007239497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "neutral.1300": {
            contrast: 16.91771567932252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "neutral.1400": {
            contrast: 12.453922954145694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1500": {
            contrast: 7.822086097911382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 9.778180122855087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 15.653816345593125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "neutral.2100": {
            contrast: 21.23123123299173,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "neutral.2200": {
            contrast: 27.374351957704953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.2300": {
            contrast: 33.83345318134375,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 47
        },
        "neutral.2400": {
            contrast: 40.29259478943135,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 40
        },
        "neutral.2500": {
            contrast: 46.833532764405014,
            lc60: 100,
            lc45: 96.5,
            lc30: 66.5,
            lc10: 35
        }
    },
    "neutral.1800": {
        "neutral.100": {
            contrast: 66.5713033333199,
            lc60: 73.5,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "neutral.200": {
            contrast: 66.20557971700987,
            lc60: 79,
            lc45: 56,
            lc30: 36.5,
            lc10: 18.5
        },
        "neutral.300": {
            contrast: 64.67494641796735,
            lc60: 86,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "neutral.400": {
            contrast: 62.580001123057194,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "neutral.500": {
            contrast: 59.245697096029794,
            lc60: 100,
            lc45: 72,
            lc30: 47,
            lc10: 24
        },
        "neutral.600": {
            contrast: 54.72657529384543,
            lc60: 100,
            lc45: 79.5,
            lc30: 52,
            lc10: 26.5
        },
        "neutral.700": {
            contrast: 50.18994691711819,
            lc60: 100,
            lc45: 88.5,
            lc30: 57.5,
            lc10: 29.5
        },
        "neutral.800": {
            contrast: 45.33494822290676,
            lc60: 100,
            lc45: 99,
            lc30: 64.5,
            lc10: 33
        },
        "neutral.900": {
            contrast: 40.608201168722175,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 37
        },
        "neutral.1000": {
            contrast: 36.252324548799415,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "neutral.1100": {
            contrast: 31.746226823377384,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 48.5
        },
        "neutral.1200": {
            contrast: 26.62208258864243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "neutral.1300": {
            contrast: 21.687308195569983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "neutral.1400": {
            contrast: 17.22351547039316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "neutral.1500": {
            contrast: 12.591678614158846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1600": {
            contrast: 7.55387140575656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 10.510265432804895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 16.0876803202035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "neutral.2200": {
            contrast: 22.230801044916724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "neutral.2300": {
            contrast: 28.689902268555517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "neutral.2400": {
            contrast: 35.14904387664311,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 46.5
        },
        "neutral.2500": {
            contrast: 41.68998185161678,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 39.5
        }
    },
    "neutral.1900": {
        "neutral.100": {
            contrast: 71.96892761421948,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "neutral.200": {
            contrast: 71.60320399790945,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "neutral.300": {
            contrast: 70.07257069886693,
            lc60: 77.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.400": {
            contrast: 67.97762540395678,
            lc60: 83,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 20
        },
        "neutral.500": {
            contrast: 64.64332137692938,
            lc60: 90.5,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.600": {
            contrast: 60.124199574745,
            lc60: 99.5,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "neutral.700": {
            contrast: 55.58757119801777,
            lc60: 100,
            lc45: 78.5,
            lc30: 51,
            lc10: 26
        },
        "neutral.800": {
            contrast: 50.73257250380634,
            lc60: 100,
            lc45: 87.5,
            lc30: 56.5,
            lc10: 29
        },
        "neutral.900": {
            contrast: 46.00582544962176,
            lc60: 100,
            lc45: 97,
            lc30: 63.5,
            lc10: 32.5
        },
        "neutral.1000": {
            contrast: 41.649948829699,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 36.5
        },
        "neutral.1100": {
            contrast: 37.14385110427696,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 41
        },
        "neutral.1200": {
            contrast: 32.01970686954201,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 47.5
        },
        "neutral.1300": {
            contrast: 27.084932476469564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "neutral.1400": {
            contrast: 22.621139751292738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "neutral.1500": {
            contrast: 17.98930289505843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "neutral.1600": {
            contrast: 12.95149568665614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1700": {
            contrast: 8.076349554670522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 10.202825603179782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 16.345946327893007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "neutral.2300": {
            contrast: 22.8050475515318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "neutral.2400": {
            contrast: 29.264189159619402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "neutral.2500": {
            contrast: 35.805127134593064,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 45
        }
    },
    "neutral.2000": {
        "neutral.100": {
            contrast: 77.46191663690823,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.200": {
            contrast: 77.09619302059821,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "neutral.300": {
            contrast: 75.56555972155569,
            lc60: 71,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.400": {
            contrast: 73.47061442664553,
            lc60: 75.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.500": {
            contrast: 70.13631039961811,
            lc60: 82,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "neutral.600": {
            contrast: 65.61718859743375,
            lc60: 89.5,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.700": {
            contrast: 61.080560220706516,
            lc60: 98,
            lc45: 71,
            lc30: 46.5,
            lc10: 24
        },
        "neutral.800": {
            contrast: 56.225561526495085,
            lc60: 100,
            lc45: 78,
            lc30: 51,
            lc10: 26.5
        },
        "neutral.900": {
            contrast: 51.49881447231051,
            lc60: 100,
            lc45: 86,
            lc30: 56.5,
            lc10: 29
        },
        "neutral.1000": {
            contrast: 47.142937852387746,
            lc60: 100,
            lc45: 95,
            lc30: 62,
            lc10: 32
        },
        "neutral.1100": {
            contrast: 42.63684012696571,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 36
        },
        "neutral.1200": {
            contrast: 37.51269589223077,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 41
        },
        "neutral.1300": {
            contrast: 32.577921499158315,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 47.5
        },
        "neutral.1400": {
            contrast: 28.114128773981484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "neutral.1500": {
            contrast: 23.482291917747176,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "neutral.1600": {
            contrast: 18.444484709344888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "neutral.1700": {
            contrast: 13.569338577359272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1800": {
            contrast: 8.754091024606884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 10.291164375544643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 16.75026559918344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "neutral.2400": {
            contrast: 23.209407207271042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "neutral.2500": {
            contrast: 29.750345182244704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "neutral.2100": {
        "neutral.100": {
            contrast: 82.64126048899873,
            lc60: 57,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "neutral.200": {
            contrast: 82.27553687268868,
            lc60: 61,
            lc45: 44.5,
            lc30: 29,
            lc10: 15.5
        },
        "neutral.300": {
            contrast: 80.74490357364617,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "neutral.400": {
            contrast: 78.64995827873601,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.500": {
            contrast: 75.31565425170861,
            lc60: 75,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.600": {
            contrast: 70.79653244952424,
            lc60: 81.5,
            lc45: 59,
            lc30: 39,
            lc10: 20
        },
        "neutral.700": {
            contrast: 66.259904072797,
            lc60: 88.5,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.800": {
            contrast: 61.404905378585575,
            lc60: 97,
            lc45: 70.5,
            lc30: 46.5,
            lc10: 24
        },
        "neutral.900": {
            contrast: 56.67815832440098,
            lc60: 100,
            lc45: 77.5,
            lc30: 51,
            lc10: 26
        },
        "neutral.1000": {
            contrast: 52.322281704478236,
            lc60: 100,
            lc45: 84.5,
            lc30: 56,
            lc10: 28.5
        },
        "neutral.1100": {
            contrast: 47.81618397905619,
            lc60: 100,
            lc45: 93,
            lc30: 61.5,
            lc10: 31.5
        },
        "neutral.1200": {
            contrast: 42.69203974432125,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35.5
        },
        "neutral.1300": {
            contrast: 37.7572653512488,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 40.5
        },
        "neutral.1400": {
            contrast: 33.293472626071974,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 46.5
        },
        "neutral.1500": {
            contrast: 28.661635769837662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "neutral.1600": {
            contrast: 23.623828561435374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "neutral.1700": {
            contrast: 18.748682429449758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "neutral.1800": {
            contrast: 13.93343487669737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.1900": {
            contrast: 8.477516123124515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 10.983498250605415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 17.442639858693013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "neutral.2500": {
            contrast: 23.98357783366668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        }
    },
    "neutral.2200": {
        "neutral.100": {
            contrast: 88.3095044885901,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "neutral.200": {
            contrast: 87.94378087228006,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "neutral.300": {
            contrast: 86.41314757323754,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "neutral.400": {
            contrast: 84.31820227832739,
            lc60: 64,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "neutral.500": {
            contrast: 80.98389825129998,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.600": {
            contrast: 76.46477644911562,
            lc60: 74.5,
            lc45: 54.5,
            lc30: 36,
            lc10: 18.5
        },
        "neutral.700": {
            contrast: 71.92814807238838,
            lc60: 80.5,
            lc45: 59,
            lc30: 39,
            lc10: 20
        },
        "neutral.800": {
            contrast: 67.07314937817695,
            lc60: 87.5,
            lc45: 64,
            lc30: 42.5,
            lc10: 22
        },
        "neutral.900": {
            contrast: 62.34640232399236,
            lc60: 95.5,
            lc45: 70,
            lc30: 46,
            lc10: 24
        },
        "neutral.1000": {
            contrast: 57.990525704069604,
            lc60: 100,
            lc45: 76,
            lc30: 50,
            lc10: 26
        },
        "neutral.1100": {
            contrast: 53.484427978647574,
            lc60: 100,
            lc45: 83,
            lc30: 55,
            lc10: 28.5
        },
        "neutral.1200": {
            contrast: 48.360283743912625,
            lc60: 100,
            lc45: 92.5,
            lc30: 61.5,
            lc10: 32
        },
        "neutral.1300": {
            contrast: 43.42550935084017,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "neutral.1400": {
            contrast: 38.96171662566334,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 40
        },
        "neutral.1500": {
            contrast: 34.329879769429034,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 45.5
        },
        "neutral.1600": {
            contrast: 29.292072561026743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "neutral.1700": {
            contrast: 24.416926429041133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "neutral.1800": {
            contrast: 19.601678876288744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "neutral.1900": {
            contrast: 14.145760122715888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2000": {
            contrast: 8.586685335948916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 11.07058191625551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 17.61151989122917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        }
    },
    "neutral.2300": {
        "neutral.100": {
            contrast: 94.23100016377755,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "neutral.200": {
            contrast: 93.8652765474675,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "neutral.300": {
            contrast: 92.33464324842498,
            lc60: 56,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "neutral.400": {
            contrast: 90.23969795351483,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.500": {
            contrast: 86.90539392648743,
            lc60: 63.5,
            lc45: 47,
            lc30: 31,
            lc10: 16.5
        },
        "neutral.600": {
            contrast: 82.38627212430306,
            lc60: 68.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "neutral.700": {
            contrast: 77.84964374757583,
            lc60: 73.5,
            lc45: 54,
            lc30: 36,
            lc10: 19
        },
        "neutral.800": {
            contrast: 72.9946450533644,
            lc60: 79.5,
            lc45: 58.5,
            lc30: 39,
            lc10: 20.5
        },
        "neutral.900": {
            contrast: 68.26789799917981,
            lc60: 86,
            lc45: 63.5,
            lc30: 42,
            lc10: 22
        },
        "neutral.1000": {
            contrast: 63.912021379257055,
            lc60: 93,
            lc45: 68.5,
            lc30: 45.5,
            lc10: 24
        },
        "neutral.1100": {
            contrast: 59.40592365383501,
            lc60: 100,
            lc45: 74.5,
            lc30: 49.5,
            lc10: 26
        },
        "neutral.1200": {
            contrast: 54.28177941910006,
            lc60: 100,
            lc45: 82,
            lc30: 54.5,
            lc10: 28.5
        },
        "neutral.1300": {
            contrast: 49.34700502602761,
            lc60: 100,
            lc45: 91,
            lc30: 60.5,
            lc10: 32
        },
        "neutral.1400": {
            contrast: 44.88321230085079,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 35
        },
        "neutral.1500": {
            contrast: 40.251375444616485,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 39.5
        },
        "neutral.1600": {
            contrast: 35.21356823621419,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 45
        },
        "neutral.1700": {
            contrast: 30.338422104228574,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 52.5
        },
        "neutral.1800": {
            contrast: 25.523174551476185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "neutral.1900": {
            contrast: 20.067255797903332,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "neutral.2000": {
            contrast: 14.508181011136362,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2100": {
            contrast: 9.260663491357151,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 10.89007226952084,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "neutral.2400": {
        "neutral.100": {
            contrast: 100.11597231997993,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "neutral.200": {
            contrast: 99.75024870366987,
            lc60: 49.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "neutral.300": {
            contrast: 98.21961540462738,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "neutral.400": {
            contrast: 96.1246701097172,
            lc60: 55,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "neutral.500": {
            contrast: 92.7903660826898,
            lc60: 59,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.600": {
            contrast: 88.27124428050543,
            lc60: 63,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "neutral.700": {
            contrast: 83.73461590377819,
            lc60: 67.5,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "neutral.800": {
            contrast: 78.87961720956676,
            lc60: 72.5,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "neutral.900": {
            contrast: 74.15287015538217,
            lc60: 78,
            lc45: 57.5,
            lc30: 38.5,
            lc10: 20
        },
        "neutral.1000": {
            contrast: 69.79699353545942,
            lc60: 84,
            lc45: 62,
            lc30: 41.5,
            lc10: 21.5
        },
        "neutral.1100": {
            contrast: 65.29089581003738,
            lc60: 90.5,
            lc45: 67,
            lc30: 44.5,
            lc10: 23
        },
        "neutral.1200": {
            contrast: 60.166751575302435,
            lc60: 99.5,
            lc45: 73,
            lc30: 49,
            lc10: 25.5
        },
        "neutral.1300": {
            contrast: 55.23197718222998,
            lc60: 100,
            lc45: 80,
            lc30: 53.5,
            lc10: 28
        },
        "neutral.1400": {
            contrast: 50.76818445705317,
            lc60: 100,
            lc45: 88,
            lc30: 58.5,
            lc10: 30.5
        },
        "neutral.1500": {
            contrast: 46.13634760081886,
            lc60: 100,
            lc45: 97,
            lc30: 64.5,
            lc10: 34
        },
        "neutral.1600": {
            contrast: 41.09854039241657,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 38
        },
        "neutral.1700": {
            contrast: 36.22339426043094,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 43.5
        },
        "neutral.1800": {
            contrast: 31.408146707678558,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 50
        },
        "neutral.1900": {
            contrast: 25.952227954105705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.2000": {
            contrast: 20.393153167338735,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "neutral.2100": {
            contrast: 15.145635647559525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "neutral.2200": {
            contrast: 9.39664766018005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "neutral.2500": {
        "neutral.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "neutral.200": {
            contrast: 105.67494959637858,
            lc60: 46,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "neutral.300": {
            contrast: 104.14431629733605,
            lc60: 49,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "neutral.400": {
            contrast: 102.0493710024259,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "neutral.500": {
            contrast: 98.71506697539849,
            lc60: 55,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "neutral.600": {
            contrast: 94.19594517321411,
            lc60: 58.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "neutral.700": {
            contrast: 89.65931679648688,
            lc60: 62.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "neutral.800": {
            contrast: 84.80431810227545,
            lc60: 67,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "neutral.900": {
            contrast: 80.07757104809086,
            lc60: 72,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "neutral.1000": {
            contrast: 75.72169442816812,
            lc60: 77,
            lc45: 57,
            lc30: 38,
            lc10: 20
        },
        "neutral.1100": {
            contrast: 71.21559670274607,
            lc60: 82.5,
            lc45: 61,
            lc30: 40.5,
            lc10: 21.5
        },
        "neutral.1200": {
            contrast: 66.09145246801113,
            lc60: 90,
            lc45: 66.5,
            lc30: 44,
            lc10: 23.5
        },
        "neutral.1300": {
            contrast: 61.15667807493866,
            lc60: 97.5,
            lc45: 72.5,
            lc30: 48,
            lc10: 25.5
        },
        "neutral.1400": {
            contrast: 56.692885349761845,
            lc60: 100,
            lc45: 78.5,
            lc30: 52,
            lc10: 27.5
        },
        "neutral.1500": {
            contrast: 52.06104849352754,
            lc60: 100,
            lc45: 86,
            lc30: 57,
            lc10: 30
        },
        "neutral.1600": {
            contrast: 47.02324128512525,
            lc60: 100,
            lc45: 95.5,
            lc30: 63.5,
            lc10: 33.5
        },
        "neutral.1700": {
            contrast: 42.14809515313963,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 37.5
        },
        "neutral.1800": {
            contrast: 37.33284760038724,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 42.5
        },
        "neutral.1900": {
            contrast: 31.87692884681439,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 50
        },
        "neutral.2000": {
            contrast: 26.31785406004742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "neutral.2100": {
            contrast: 21.070336540268208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "neutral.2200": {
            contrast: 15.321348552888736,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "neutral.2300": {
            contrast: 9.309043917434105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "neutral.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$green = {
    "green.100": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 9.65156398319264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 14.439676789537712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 19.276479420763838,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "green.900": {
            contrast: 24.051226631961406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "green.1000": {
            contrast: 28.700385904081855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "green.1100": {
            contrast: 33.56306405222742,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 65
        },
        "green.1200": {
            contrast: 38.63108155525363,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 60
        },
        "green.1300": {
            contrast: 44.328938152235104,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 55.5
        },
        "green.1400": {
            contrast: 48.71789679229603,
            lc60: 100,
            lc45: 95,
            lc30: 75,
            lc10: 52.5
        },
        "green.1500": {
            contrast: 53.31173160825175,
            lc60: 100,
            lc45: 90.5,
            lc30: 71.5,
            lc10: 49.5
        },
        "green.1600": {
            contrast: 58.099909128157826,
            lc60: 100,
            lc45: 85.5,
            lc30: 67.5,
            lc10: 47
        },
        "green.1700": {
            contrast: 63.53722434966376,
            lc60: 96,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "green.1800": {
            contrast: 69.13945750584531,
            lc60: 91.5,
            lc45: 76.5,
            lc30: 61,
            lc10: 42.5
        },
        "green.1900": {
            contrast: 74.49510458475933,
            lc60: 87.5,
            lc45: 73,
            lc30: 58,
            lc10: 40.5
        },
        "green.2000": {
            contrast: 79.87687819652875,
            lc60: 83.5,
            lc45: 70,
            lc30: 55.5,
            lc10: 39
        },
        "green.2100": {
            contrast: 85.68674018781846,
            lc60: 80,
            lc45: 67,
            lc30: 53.5,
            lc10: 37
        },
        "green.2200": {
            contrast: 91.43785535455999,
            lc60: 77,
            lc45: 64.5,
            lc30: 51,
            lc10: 35.5
        },
        "green.2300": {
            contrast: 97.07887582529496,
            lc60: 74,
            lc45: 62,
            lc30: 49,
            lc10: 34
        },
        "green.2400": {
            contrast: 102.71647949316747,
            lc60: 71.5,
            lc45: 60,
            lc30: 47.5,
            lc10: 33
        },
        "green.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "green.200": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 9.232381345373856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 14.020494151718927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 18.857296782945056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "green.900": {
            contrast: 23.632043994142624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.1000": {
            contrast: 28.281203266263066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "green.1100": {
            contrast: 33.14388141440863,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 61
        },
        "green.1200": {
            contrast: 38.21189891743485,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 55.5
        },
        "green.1300": {
            contrast: 43.90975551441632,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 50.5
        },
        "green.1400": {
            contrast: 48.29871415447725,
            lc60: 100,
            lc45: 95,
            lc30: 73,
            lc10: 48
        },
        "green.1500": {
            contrast: 52.89254897043296,
            lc60: 100,
            lc45: 90,
            lc30: 69,
            lc10: 45.5
        },
        "green.1600": {
            contrast: 57.680726490339026,
            lc60: 100,
            lc45: 85,
            lc30: 65,
            lc10: 42.5
        },
        "green.1700": {
            contrast: 63.11804171184497,
            lc60: 96.5,
            lc45: 79.5,
            lc30: 61.5,
            lc10: 40
        },
        "green.1800": {
            contrast: 68.72027486802652,
            lc60: 91,
            lc45: 75,
            lc30: 58,
            lc10: 38
        },
        "green.1900": {
            contrast: 74.07592194694054,
            lc60: 87,
            lc45: 72,
            lc30: 55.5,
            lc10: 36
        },
        "green.2000": {
            contrast: 79.45769555870996,
            lc60: 82.5,
            lc45: 68,
            lc30: 53,
            lc10: 34.5
        },
        "green.2100": {
            contrast: 85.26755754999967,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33
        },
        "green.2200": {
            contrast: 91.01867271674121,
            lc60: 75.5,
            lc45: 62.5,
            lc30: 48,
            lc10: 31.5
        },
        "green.2300": {
            contrast: 96.65969318747617,
            lc60: 72.5,
            lc45: 60,
            lc30: 46,
            lc10: 30.5
        },
        "green.2400": {
            contrast: 102.29729685534868,
            lc60: 70,
            lc45: 58,
            lc30: 44.5,
            lc10: 29.5
        },
        "green.2500": {
            contrast: 107.46555054527968,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "green.300": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 7.8510404699223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 12.63915327626737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 17.4759559074935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "green.900": {
            contrast: 22.250703118691067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.1000": {
            contrast: 26.899862390811506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1100": {
            contrast: 31.76254053895708,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 59
        },
        "green.1200": {
            contrast: 36.830558041983295,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 53
        },
        "green.1300": {
            contrast: 42.52841463896477,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 48
        },
        "green.1400": {
            contrast: 46.91737327902569,
            lc60: 100,
            lc45: 96.5,
            lc30: 73,
            lc10: 45
        },
        "green.1500": {
            contrast: 51.511208094981406,
            lc60: 100,
            lc45: 91,
            lc30: 68,
            lc10: 42
        },
        "green.1600": {
            contrast: 56.299385614887484,
            lc60: 100,
            lc45: 85,
            lc30: 64,
            lc10: 40
        },
        "green.1700": {
            contrast: 61.736700836393425,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 37
        },
        "green.1800": {
            contrast: 67.33893399257498,
            lc60: 91.5,
            lc45: 75,
            lc30: 56.5,
            lc10: 35
        },
        "green.1900": {
            contrast: 72.69458107148898,
            lc60: 87,
            lc45: 71,
            lc30: 53,
            lc10: 33
        },
        "green.2000": {
            contrast: 78.07635468325842,
            lc60: 83,
            lc45: 67.5,
            lc30: 51,
            lc10: 32
        },
        "green.2100": {
            contrast: 83.88621667454812,
            lc60: 78.5,
            lc45: 64.5,
            lc30: 48.5,
            lc10: 30
        },
        "green.2200": {
            contrast: 89.63733184128965,
            lc60: 75,
            lc45: 61.5,
            lc30: 46,
            lc10: 28.5
        },
        "green.2300": {
            contrast: 95.27835231202462,
            lc60: 72,
            lc45: 59,
            lc30: 44.5,
            lc10: 27.5
        },
        "green.2400": {
            contrast: 100.91595597989713,
            lc60: 69,
            lc45: 56.5,
            lc30: 43,
            lc10: 26.5
        },
        "green.2500": {
            contrast: 106.08420966982813,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26
        }
    },
    "green.400": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 10.607220346182219,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 15.44402297740835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "green.900": {
            contrast: 20.218770188605916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "green.1000": {
            contrast: 24.867929460726366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1100": {
            contrast: 29.730607608871924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "green.1200": {
            contrast: 34.79862511189814,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 52.5
        },
        "green.1300": {
            contrast: 40.496481708879614,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 47
        },
        "green.1400": {
            contrast: 44.885440348940534,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 43.5
        },
        "green.1500": {
            contrast: 49.47927516489625,
            lc60: 100,
            lc45: 93,
            lc30: 68,
            lc10: 40.5
        },
        "green.1600": {
            contrast: 54.26745268480233,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 38
        },
        "green.1700": {
            contrast: 59.70476790630826,
            lc60: 100,
            lc45: 81,
            lc30: 59.5,
            lc10: 35
        },
        "green.1800": {
            contrast: 65.30700106248982,
            lc60: 93.5,
            lc45: 75.5,
            lc30: 55.5,
            lc10: 33
        },
        "green.1900": {
            contrast: 70.66264814140382,
            lc60: 88.5,
            lc45: 71,
            lc30: 52.5,
            lc10: 31.5
        },
        "green.2000": {
            contrast: 76.04442175317327,
            lc60: 83.5,
            lc45: 67.5,
            lc30: 50,
            lc10: 30
        },
        "green.2100": {
            contrast: 81.85428374446296,
            lc60: 79,
            lc45: 64,
            lc30: 47.5,
            lc10: 28
        },
        "green.2200": {
            contrast: 87.60539891120449,
            lc60: 75.5,
            lc45: 61,
            lc30: 45,
            lc10: 27
        },
        "green.2300": {
            contrast: 93.24641938193948,
            lc60: 72,
            lc45: 58.5,
            lc30: 43,
            lc10: 26
        },
        "green.2400": {
            contrast: 98.88402304981196,
            lc60: 69.5,
            lc45: 56,
            lc30: 41.5,
            lc10: 25
        },
        "green.2500": {
            contrast: 104.05227673974298,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "green.500": {
        "green.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 7.6512273907677715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 12.4880300219939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 17.26277723319147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "green.1000": {
            contrast: 21.911936505311918,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "green.1100": {
            contrast: 26.77461465345748,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "green.1200": {
            contrast: 31.842632156483695,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54
        },
        "green.1300": {
            contrast: 37.54048875346517,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 47.5
        },
        "green.1400": {
            contrast: 41.92944739352609,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43.5
        },
        "green.1500": {
            contrast: 46.523282209481806,
            lc60: 100,
            lc45: 97,
            lc30: 70.5,
            lc10: 40.5
        },
        "green.1600": {
            contrast: 51.311459729387884,
            lc60: 100,
            lc45: 90,
            lc30: 65.5,
            lc10: 37.5
        },
        "green.1700": {
            contrast: 56.74877495089382,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 35
        },
        "green.1800": {
            contrast: 62.35100810707538,
            lc60: 97,
            lc45: 77,
            lc30: 56.5,
            lc10: 32
        },
        "green.1900": {
            contrast: 67.70665518598939,
            lc60: 91,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "green.2000": {
            contrast: 73.08842879775882,
            lc60: 86,
            lc45: 69,
            lc30: 50,
            lc10: 29
        },
        "green.2100": {
            contrast: 78.89829078904852,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 27.5
        },
        "green.2200": {
            contrast: 84.64940595579004,
            lc60: 77,
            lc45: 61.5,
            lc30: 45,
            lc10: 26
        },
        "green.2300": {
            contrast: 90.29042642652503,
            lc60: 73,
            lc45: 59,
            lc30: 43,
            lc10: 25.5
        },
        "green.2400": {
            contrast: 95.92803009439751,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 24.5
        },
        "green.2500": {
            contrast: 101.09628378432853,
            lc60: 68,
            lc45: 55,
            lc30: 40.5,
            lc10: 24
        }
    },
    "green.600": {
        "green.100": {
            contrast: 11.13432494707484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.200": {
            contrast: 10.572346229643648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.300": {
            contrast: 8.769487489070388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 8.364190146184654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 13.138937357382222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 17.788096629502668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "green.1100": {
            contrast: 22.650774777648234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "green.1200": {
            contrast: 27.71879228067445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "green.1300": {
            contrast: 33.416648877655916,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 51
        },
        "green.1400": {
            contrast: 37.805607517716844,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "green.1500": {
            contrast: 42.39944233367255,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42.5
        },
        "green.1600": {
            contrast: 47.18761985357863,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 39
        },
        "green.1700": {
            contrast: 52.624935075084565,
            lc60: 100,
            lc45: 88,
            lc30: 63.5,
            lc10: 36
        },
        "green.1800": {
            contrast: 58.22716823126613,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 32.5
        },
        "green.1900": {
            contrast: 63.58281531018014,
            lc60: 95.5,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "green.2000": {
            contrast: 68.96458892194957,
            lc60: 89.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "green.2100": {
            contrast: 74.77445091323926,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "green.2200": {
            contrast: 80.52556607998079,
            lc60: 79.5,
            lc45: 63.5,
            lc30: 46,
            lc10: 26
        },
        "green.2300": {
            contrast: 86.16658655071578,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 44,
            lc10: 25
        },
        "green.2400": {
            contrast: 91.80419021858826,
            lc60: 72,
            lc45: 58,
            lc30: 42,
            lc10: 24
        },
        "green.2500": {
            contrast: 96.97244390851927,
            lc60: 69.5,
            lc45: 56,
            lc30: 41,
            lc10: 23.5
        }
    },
    "green.700": {
        "green.100": {
            contrast: 16.30203662974804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "green.200": {
            contrast: 15.740057912316855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "green.300": {
            contrast: 13.937199171743591,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.400": {
            contrast: 11.38744490258874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.500": {
            contrast: 7.828500745282087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 8.54668054497581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 13.195839817096255,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 18.058517965241823,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "green.1200": {
            contrast: 23.126535468268035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "green.1300": {
            contrast: 28.824392065249505,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1400": {
            contrast: 33.21335070531043,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51
        },
        "green.1500": {
            contrast: 37.80718552126615,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "green.1600": {
            contrast: 42.59536304117223,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        },
        "green.1700": {
            contrast: 48.03267826267816,
            lc60: 100,
            lc45: 95,
            lc30: 67.5,
            lc10: 37.5
        },
        "green.1800": {
            contrast: 53.63491141885972,
            lc60: 100,
            lc45: 86.5,
            lc30: 62,
            lc10: 34.5
        },
        "green.1900": {
            contrast: 58.99055849777374,
            lc60: 100,
            lc45: 80,
            lc30: 57,
            lc10: 32
        },
        "green.2000": {
            contrast: 64.37233210954317,
            lc60: 94.5,
            lc45: 75,
            lc30: 53.5,
            lc10: 30
        },
        "green.2100": {
            contrast: 70.18219410083286,
            lc60: 88,
            lc45: 69.5,
            lc30: 50,
            lc10: 28
        },
        "green.2200": {
            contrast: 75.93330926757437,
            lc60: 82.5,
            lc45: 66,
            lc30: 47,
            lc10: 26.5
        },
        "green.2300": {
            contrast: 81.57432973830937,
            lc60: 78.5,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        },
        "green.2400": {
            contrast: 87.21193340618186,
            lc60: 75,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 24.5
        },
        "green.2500": {
            contrast: 92.38018709611286,
            lc60: 72,
            lc45: 57.5,
            lc30: 42,
            lc10: 24
        }
    },
    "green.800": {
        "green.100": {
            contrast: 21.404313928498926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "green.200": {
            contrast: 20.842335211067734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "green.300": {
            contrast: 19.039476470494474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "green.400": {
            contrast: 16.489722201339625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "green.500": {
            contrast: 12.93077804403297,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.600": {
            contrast: 8.16961024915516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 8.503591147675941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 13.366269295821509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 18.434286798847722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "green.1300": {
            contrast: 24.132143395829196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "green.1400": {
            contrast: 28.521102035890117,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1500": {
            contrast: 33.114936851845826,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "green.1600": {
            contrast: 37.903114371751904,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 45.5
        },
        "green.1700": {
            contrast: 43.340429593257845,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "green.1800": {
            contrast: 48.9426627494394,
            lc60: 100,
            lc45: 93,
            lc30: 66.5,
            lc10: 36
        },
        "green.1900": {
            contrast: 54.29830982835341,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 33
        },
        "green.2000": {
            contrast: 59.68008344012284,
            lc60: 100,
            lc45: 79.5,
            lc30: 56.5,
            lc10: 31
        },
        "green.2100": {
            contrast: 65.48994543141255,
            lc60: 92.5,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 29
        },
        "green.2200": {
            contrast: 71.24106059815406,
            lc60: 87,
            lc45: 69,
            lc30: 49,
            lc10: 27
        },
        "green.2300": {
            contrast: 76.88208106888905,
            lc60: 82.5,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "green.2400": {
            contrast: 82.51968473676155,
            lc60: 78,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        },
        "green.2500": {
            contrast: 87.68793842669254,
            lc60: 74.5,
            lc45: 60,
            lc30: 43,
            lc10: 24.5
        }
    },
    "green.900": {
        "green.100": {
            contrast: 26.349062378359804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39.5
        },
        "green.200": {
            contrast: 25.787083660928616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "green.300": {
            contrast: 23.98422492035536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.400": {
            contrast: 21.43447065120051,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "green.500": {
            contrast: 17.875526493893858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "green.600": {
            contrast: 13.114358699016046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.700": {
            contrast: 8.008205274418536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 8.691318134148899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 13.759335637175116,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 19.457192234156587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "green.1400": {
            contrast: 23.84615087421751,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1500": {
            contrast: 28.43998569017322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1600": {
            contrast: 33.228163210079295,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "green.1700": {
            contrast: 38.66547843158523,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 43.5
        },
        "green.1800": {
            contrast: 44.2677115877668,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39
        },
        "green.1900": {
            contrast: 49.62335866668081,
            lc60: 100,
            lc45: 91.5,
            lc30: 65,
            lc10: 35.5
        },
        "green.2000": {
            contrast: 55.00513227845023,
            lc60: 100,
            lc45: 84.5,
            lc30: 60.5,
            lc10: 33
        },
        "green.2100": {
            contrast: 60.81499426973993,
            lc60: 98.5,
            lc45: 78,
            lc30: 55.5,
            lc10: 30.5
        },
        "green.2200": {
            contrast: 66.56610943648145,
            lc60: 91.5,
            lc45: 73,
            lc30: 51.5,
            lc10: 28.5
        },
        "green.2300": {
            contrast: 72.20712990721644,
            lc60: 86,
            lc45: 68.5,
            lc30: 49,
            lc10: 27
        },
        "green.2400": {
            contrast: 77.84473357508894,
            lc60: 81.5,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "green.2500": {
            contrast: 83.01298726501993,
            lc60: 78,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        }
    },
    "green.1000": {
        "green.100": {
            contrast: 31.091107726238086,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 34.5
        },
        "green.200": {
            contrast: 30.529129008806898,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 40
        },
        "green.300": {
            contrast: 28.726270268233637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "green.400": {
            contrast: 26.17651599907879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "green.500": {
            contrast: 22.61757184177214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "green.600": {
            contrast: 17.85640404689433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "green.700": {
            contrast: 12.750250622296818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.800": {
            contrast: 7.689499906647697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 9.172626187354888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 14.870482784336359,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 19.259441424397288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "green.1500": {
            contrast: 23.853276240352997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1600": {
            contrast: 28.641453760259072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1700": {
            contrast: 34.07876898176501,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49
        },
        "green.1800": {
            contrast: 39.68100213794657,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 43
        },
        "green.1900": {
            contrast: 45.03664921686058,
            lc60: 100,
            lc45: 99.5,
            lc30: 70,
            lc10: 39
        },
        "green.2000": {
            contrast: 50.41842282863001,
            lc60: 100,
            lc45: 90.5,
            lc30: 64.5,
            lc10: 35
        },
        "green.2100": {
            contrast: 56.22828481991971,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 32.5
        },
        "green.2200": {
            contrast: 61.97939998666124,
            lc60: 97,
            lc45: 77,
            lc30: 54.5,
            lc10: 30.5
        },
        "green.2300": {
            contrast: 67.62042045739621,
            lc60: 91,
            lc45: 72,
            lc30: 51.5,
            lc10: 28.5
        },
        "green.2400": {
            contrast: 73.2580241252687,
            lc60: 85.5,
            lc45: 68,
            lc30: 49,
            lc10: 27.5
        },
        "green.2500": {
            contrast: 78.42627781519971,
            lc60: 81.5,
            lc45: 65,
            lc30: 47,
            lc10: 27
        }
    },
    "green.1100": {
        "green.100": {
            contrast: 35.985726351734044,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30
        },
        "green.200": {
            contrast: 35.423747634302856,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34.5
        },
        "green.300": {
            contrast: 33.62088889372959,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 39.5
        },
        "green.400": {
            contrast: 31.071134624574743,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 45.5
        },
        "green.500": {
            contrast: 27.512190467268088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "green.600": {
            contrast: 22.751022672390278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "green.700": {
            contrast: 17.64486924779277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "green.800": {
            contrast: 12.584118532143648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.900": {
            contrast: 7.664507650445833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 10.04127529615729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 14.430233936218215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 19.02406875217393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "green.1600": {
            contrast: 23.812246272080003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1700": {
            contrast: 29.24956149358594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1800": {
            contrast: 34.8517946497675,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "green.1900": {
            contrast: 40.20744172868151,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 42.5
        },
        "green.2000": {
            contrast: 45.58921534045094,
            lc60: 100,
            lc45: 98.5,
            lc30: 70,
            lc10: 38.5
        },
        "green.2100": {
            contrast: 51.39907733174064,
            lc60: 100,
            lc45: 89.5,
            lc30: 63,
            lc10: 35
        },
        "green.2200": {
            contrast: 57.15019249848217,
            lc60: 100,
            lc45: 82,
            lc30: 59,
            lc10: 32
        },
        "green.2300": {
            contrast: 62.79121296921715,
            lc60: 96.5,
            lc45: 76.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "green.2400": {
            contrast: 68.42881663708964,
            lc60: 90,
            lc45: 71.5,
            lc30: 52,
            lc10: 29
        },
        "green.2500": {
            contrast: 73.59707032702065,
            lc60: 85.5,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        }
    },
    "green.1200": {
        "green.100": {
            contrast: 41.02556777925482,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 27
        },
        "green.200": {
            contrast: 40.46358906182363,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 31
        },
        "green.300": {
            contrast: 38.66073032125038,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "green.400": {
            contrast: 36.11097605209553,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "green.500": {
            contrast: 32.55203189478887,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45.5
        },
        "green.600": {
            contrast: 27.79086409991106,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "green.700": {
            contrast: 22.684710675313553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "green.800": {
            contrast: 17.623959959664433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "green.900": {
            contrast: 12.704349077966615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1000": {
            contrast: 7.974438920971948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 9.366505646080434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 13.960340462036147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 18.748517981942225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "green.1700": {
            contrast: 24.185833203448162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "green.1800": {
            contrast: 29.788066359629717,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "green.1900": {
            contrast: 35.14371343854373,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 47.5
        },
        "green.2000": {
            contrast: 40.52548705031316,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42
        },
        "green.2100": {
            contrast: 46.33534904160286,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38
        },
        "green.2200": {
            contrast: 52.08646420834439,
            lc60: 100,
            lc45: 88.5,
            lc30: 63.5,
            lc10: 35
        },
        "green.2300": {
            contrast: 57.72748467907937,
            lc60: 100,
            lc45: 81.5,
            lc30: 58.5,
            lc10: 32
        },
        "green.2400": {
            contrast: 63.36508834695186,
            lc60: 95.5,
            lc45: 76,
            lc30: 55,
            lc10: 31
        },
        "green.2500": {
            contrast: 68.53334203688286,
            lc60: 90,
            lc45: 72,
            lc30: 52.5,
            lc10: 30
        }
    },
    "green.1300": {
        "green.100": {
            contrast: 46.626313068761974,
            lc60: 100,
            lc45: 83,
            lc30: 48.5,
            lc10: 24
        },
        "green.200": {
            contrast: 46.064334351330785,
            lc60: 100,
            lc45: 92.5,
            lc30: 53.5,
            lc10: 27
        },
        "green.300": {
            contrast: 44.26147561075753,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "green.400": {
            contrast: 41.711721341602676,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33.5
        },
        "green.500": {
            contrast: 38.15277718429602,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38
        },
        "green.600": {
            contrast: 33.39160938941821,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 44.5
        },
        "green.700": {
            contrast: 28.2854559648207,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "green.800": {
            contrast: 23.22470524917158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "green.900": {
            contrast: 18.305094367473764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "green.1000": {
            contrast: 13.5751842104791,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1100": {
            contrast: 8.682309228712569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 8.234146936597506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 13.022324456503586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 18.459639678009523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "green.1800": {
            contrast: 24.06187283419108,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "green.1900": {
            contrast: 29.41751991310509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "green.2000": {
            contrast: 34.79929352487452,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49
        },
        "green.2100": {
            contrast: 40.60915551616422,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43.5
        },
        "green.2200": {
            contrast: 46.36027068290575,
            lc60: 100,
            lc45: 97.5,
            lc30: 70,
            lc10: 38.5
        },
        "green.2300": {
            contrast: 52.00129115364073,
            lc60: 100,
            lc45: 88.5,
            lc30: 64.5,
            lc10: 36
        },
        "green.2400": {
            contrast: 57.63889482151322,
            lc60: 100,
            lc45: 82.5,
            lc30: 60,
            lc10: 33.5
        },
        "green.2500": {
            contrast: 62.807148511444225,
            lc60: 96.5,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 32.5
        }
    },
    "green.1400": {
        "green.100": {
            contrast: 50.898483623972304,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "green.200": {
            contrast: 50.336504906541116,
            lc60: 100,
            lc45: 78,
            lc30: 49,
            lc10: 24.5
        },
        "green.300": {
            contrast: 48.53364616596786,
            lc60: 100,
            lc45: 87,
            lc30: 54.5,
            lc10: 27.5
        },
        "green.400": {
            contrast: 45.983891896813006,
            lc60: 100,
            lc45: 96.5,
            lc30: 60.5,
            lc10: 30.5
        },
        "green.500": {
            contrast: 42.42494773950635,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34
        },
        "green.600": {
            contrast: 37.66377994462854,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 39.5
        },
        "green.700": {
            contrast: 32.55762652003103,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 46
        },
        "green.800": {
            contrast: 27.496875804381908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.900": {
            contrast: 22.577264922684094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1000": {
            contrast: 17.847354765689428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "green.1100": {
            contrast: 12.954479783922897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1200": {
            contrast: 7.906244094606428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 8.589927363441449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 14.027242584947386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 19.629475741128942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "green.1900": {
            contrast: 24.985122820042957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "green.2000": {
            contrast: 30.366896431812386,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "green.2100": {
            contrast: 36.17675842310208,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "green.2200": {
            contrast: 41.927873589843614,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "green.2300": {
            contrast: 47.56889406057859,
            lc60: 100,
            lc45: 95,
            lc30: 68,
            lc10: 37.5
        },
        "green.2400": {
            contrast: 53.20649772845108,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 35
        },
        "green.2500": {
            contrast: 58.37475141838209,
            lc60: 100,
            lc45: 81,
            lc30: 59,
            lc10: 33.5
        }
    },
    "green.1500": {
        "green.100": {
            contrast: 55.33477703583771,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "green.200": {
            contrast: 54.772798318406515,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "green.300": {
            contrast: 52.96993957783326,
            lc60: 100,
            lc45: 77.5,
            lc30: 49.5,
            lc10: 25
        },
        "green.400": {
            contrast: 50.42018530867841,
            lc60: 100,
            lc45: 85.5,
            lc30: 54.5,
            lc10: 27.5
        },
        "green.500": {
            contrast: 46.86124115137175,
            lc60: 100,
            lc45: 95.5,
            lc30: 60.5,
            lc10: 31
        },
        "green.600": {
            contrast: 42.100073356493944,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "green.700": {
            contrast: 36.99391993189643,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 39.5
        },
        "green.800": {
            contrast: 31.933169216247308,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46.5
        },
        "green.900": {
            contrast: 27.013558334549494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1000": {
            contrast: 22.28364817755483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1100": {
            contrast: 17.3907731957883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "green.1200": {
            contrast: 12.342537506471828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 9.369520308151529,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 14.971753464333087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 20.327400543247098,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.2000": {
            contrast: 25.709174155016523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "green.2100": {
            contrast: 31.519036146306224,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "green.2200": {
            contrast: 37.270151313047755,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "green.2300": {
            contrast: 42.911171783782734,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40
        },
        "green.2400": {
            contrast: 48.548775451655224,
            lc60: 100,
            lc45: 93.5,
            lc30: 67,
            lc10: 36.5
        },
        "green.2500": {
            contrast: 53.717029141586224,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 35.5
        }
    },
    "green.1600": {
        "green.100": {
            contrast: 59.92356095479333,
            lc60: 100,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "green.200": {
            contrast: 59.36158223736213,
            lc60: 100,
            lc45: 64,
            lc30: 41.5,
            lc10: 21
        },
        "green.300": {
            contrast: 57.55872349678888,
            lc60: 100,
            lc45: 70,
            lc30: 45.5,
            lc10: 23
        },
        "green.400": {
            contrast: 55.00896922763402,
            lc60: 100,
            lc45: 77,
            lc30: 49,
            lc10: 25.5
        },
        "green.500": {
            contrast: 51.450025070327364,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 28
        },
        "green.600": {
            contrast: 46.68885727544956,
            lc60: 100,
            lc45: 95,
            lc30: 61,
            lc10: 30.5
        },
        "green.700": {
            contrast: 41.58270385085204,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "green.800": {
            contrast: 36.52195313520292,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41
        },
        "green.900": {
            contrast: 31.60234225350511,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 48
        },
        "green.1000": {
            contrast: 26.87243209651044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "green.1100": {
            contrast: 21.979557114743915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "green.1200": {
            contrast: 16.931321425427445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "green.1300": {
            contrast: 11.31037665561974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 10.098408436608056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 15.454055515522066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "green.2000": {
            contrast: 20.835829127291497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "green.2100": {
            contrast: 26.645691118581194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "green.2200": {
            contrast: 32.39680628532272,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 50.5
        },
        "green.2300": {
            contrast: 38.0378267560577,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 44.5
        },
        "green.2400": {
            contrast: 43.675430423930194,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "green.2500": {
            contrast: 48.843684113861194,
            lc60: 100,
            lc45: 93.5,
            lc30: 67,
            lc10: 37
        }
    },
    "green.1700": {
        "green.100": {
            contrast: 65.094547924645,
            lc60: 76.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 17.5
        },
        "green.200": {
            contrast: 64.5325692072138,
            lc60: 83.5,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "green.300": {
            contrast: 62.729710466640555,
            lc60: 91.5,
            lc45: 64,
            lc30: 41,
            lc10: 21
        },
        "green.400": {
            contrast: 60.17995619748569,
            lc60: 99.5,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "green.500": {
            contrast: 56.62101204017904,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25.5
        },
        "green.600": {
            contrast: 51.859844245301225,
            lc60: 100,
            lc45: 84.5,
            lc30: 55,
            lc10: 27.5
        },
        "green.700": {
            contrast: 46.75369082070372,
            lc60: 100,
            lc45: 96,
            lc30: 61.5,
            lc10: 31
        },
        "green.800": {
            contrast: 41.692940105054596,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35.5
        },
        "green.900": {
            contrast: 36.77332922335678,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 41
        },
        "green.1000": {
            contrast: 32.04341906636211,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 46.5
        },
        "green.1100": {
            contrast: 27.150544084595584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1200": {
            contrast: 22.102308395279117,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "green.1300": {
            contrast: 16.48136362547141,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "green.1400": {
            contrast: 12.186789321663008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1500": {
            contrast: 7.721336414894712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 9.898714533619705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 15.280488145389134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "green.2100": {
            contrast: 21.090350136678833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "green.2200": {
            contrast: 26.84146530342036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "green.2300": {
            contrast: 32.482485774155336,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 52
        },
        "green.2400": {
            contrast: 38.12008944202783,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 44.5
        },
        "green.2500": {
            contrast: 43.28834313195883,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        }
    },
    "green.1800": {
        "green.100": {
            contrast: 70.38165981613783,
            lc60: 69,
            lc45: 49.5,
            lc30: 32,
            lc10: 16.5
        },
        "green.200": {
            contrast: 69.81968109870664,
            lc60: 74.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "green.300": {
            contrast: 68.01682235813338,
            lc60: 81,
            lc45: 58,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.400": {
            contrast: 65.46706808897852,
            lc60: 88,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "green.500": {
            contrast: 61.908123931671874,
            lc60: 95.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 23
        },
        "green.600": {
            contrast: 57.14695613679407,
            lc60: 100,
            lc45: 75.5,
            lc30: 48.5,
            lc10: 25.5
        },
        "green.700": {
            contrast: 52.04080271219655,
            lc60: 100,
            lc45: 84,
            lc30: 54.5,
            lc10: 28
        },
        "green.800": {
            contrast: 46.98005199654743,
            lc60: 100,
            lc45: 94.5,
            lc30: 61.5,
            lc10: 31.5
        },
        "green.900": {
            contrast: 42.06044111484962,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35.5
        },
        "green.1000": {
            contrast: 37.330530957854954,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 39.5
        },
        "green.1100": {
            contrast: 32.43765597608842,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46.5
        },
        "green.1200": {
            contrast: 27.389420286771948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "green.1300": {
            contrast: 21.768475516964248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "green.1400": {
            contrast: 17.473901213155845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "green.1500": {
            contrast: 13.008448306387551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1600": {
            contrast: 8.383618124643718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 9.534653616047915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 15.344515607337614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "green.2200": {
            contrast: 21.095630774079144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "green.2300": {
            contrast: 26.73665124481412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "green.2400": {
            contrast: 32.37425491268661,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 52.5
        },
        "green.2500": {
            contrast: 37.542508602617616,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 47
        }
    },
    "green.1900": {
        "green.100": {
            contrast: 75.4004968954039,
            lc60: 63.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "green.200": {
            contrast: 74.8385181779727,
            lc60: 69,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "green.300": {
            contrast: 73.03565943739945,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "green.400": {
            contrast: 70.48590516824459,
            lc60: 80,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.500": {
            contrast: 66.92696101093793,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "green.600": {
            contrast: 62.16579321606013,
            lc60: 95.5,
            lc45: 68,
            lc30: 45,
            lc10: 23
        },
        "green.700": {
            contrast: 57.05963979146262,
            lc60: 100,
            lc45: 76,
            lc30: 49.5,
            lc10: 25
        },
        "green.800": {
            contrast: 51.998889075813494,
            lc60: 100,
            lc45: 84.5,
            lc30: 55.5,
            lc10: 28
        },
        "green.900": {
            contrast: 47.07927819411568,
            lc60: 100,
            lc45: 94.5,
            lc30: 61,
            lc10: 31.5
        },
        "green.1000": {
            contrast: 42.34936803712102,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "green.1100": {
            contrast: 37.456493055354485,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40
        },
        "green.1200": {
            contrast: 32.408257366038015,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46.5
        },
        "green.1300": {
            contrast: 26.787312596230308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "green.1400": {
            contrast: 22.492738292421908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "green.1500": {
            contrast: 18.027285385653613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "green.1600": {
            contrast: 13.402455203909783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1700": {
            contrast: 8.184167526094559,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 9.832165243954776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 15.583280410696307,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "green.2300": {
            contrast: 21.224300881431287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "green.2400": {
            contrast: 26.861904549303777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "green.2500": {
            contrast: 32.03015823923478,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54
        }
    },
    "green.2000": {
        "green.100": {
            contrast: 80.41139510306854,
            lc60: 59,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "green.200": {
            contrast: 79.84941638563734,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "green.300": {
            contrast: 78.04655764506407,
            lc60: 68.5,
            lc45: 49.5,
            lc30: 33,
            lc10: 16.5
        },
        "green.400": {
            contrast: 75.49680337590922,
            lc60: 73.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "green.500": {
            contrast: 71.93785921860257,
            lc60: 79.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.600": {
            contrast: 67.17669142372476,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21.5
        },
        "green.700": {
            contrast: 62.070537999127254,
            lc60: 96,
            lc45: 68.5,
            lc30: 45,
            lc10: 23
        },
        "green.800": {
            contrast: 57.00978728347813,
            lc60: 100,
            lc45: 76.5,
            lc30: 49.5,
            lc10: 25.5
        },
        "green.900": {
            contrast: 52.09017640178032,
            lc60: 100,
            lc45: 84.5,
            lc30: 55,
            lc10: 28.5
        },
        "green.1000": {
            contrast: 47.360266244785656,
            lc60: 100,
            lc45: 94.5,
            lc30: 60.5,
            lc10: 31
        },
        "green.1100": {
            contrast: 42.467391263019124,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "green.1200": {
            contrast: 37.41915557370265,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "green.1300": {
            contrast: 31.798210803894943,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 46
        },
        "green.1400": {
            contrast: 27.503636500086543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "green.1500": {
            contrast: 23.038183593318248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "green.1600": {
            contrast: 18.41335341157442,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "green.1700": {
            contrast: 13.195065733759195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1800": {
            contrast: 7.852764673802079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 10.026148398370468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 15.667168869105444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "green.2400": {
            contrast: 21.30477253697794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "green.2500": {
            contrast: 26.473026226908935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        }
    },
    "green.2100": {
        "green.100": {
            contrast: 85.7869543288261,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "green.200": {
            contrast: 85.2249756113949,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "green.300": {
            contrast: 83.42211687082163,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "green.400": {
            contrast: 80.87236260166678,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 16.5
        },
        "green.500": {
            contrast: 77.31341844436012,
            lc60: 72.5,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "green.600": {
            contrast: 72.55225064948232,
            lc60: 78.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.700": {
            contrast: 67.44609722488481,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "green.800": {
            contrast: 62.38534650923568,
            lc60: 95,
            lc45: 68.5,
            lc30: 45,
            lc10: 23.5
        },
        "green.900": {
            contrast: 57.46573562753788,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25
        },
        "green.1000": {
            contrast: 52.735825470543205,
            lc60: 100,
            lc45: 83,
            lc30: 53.5,
            lc10: 27.5
        },
        "green.1100": {
            contrast: 47.84295048877668,
            lc60: 100,
            lc45: 93,
            lc30: 60,
            lc10: 30.5
        },
        "green.1200": {
            contrast: 42.7947147994602,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "green.1300": {
            contrast: 37.1737700296525,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 39.5
        },
        "green.1400": {
            contrast: 32.8791957258441,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45.5
        },
        "green.1500": {
            contrast: 28.413742819075804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "green.1600": {
            contrast: 23.788912637331975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "green.1700": {
            contrast: 18.570624959516753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "green.1800": {
            contrast: 13.228323899559635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.1900": {
            contrast: 8.151126911833156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 9.649098275988903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 15.286701943861397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "green.2500": {
            contrast: 20.454955633792398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        }
    },
    "green.2200": {
        "green.100": {
            contrast: 91.0758022454034,
            lc60: 52,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "green.200": {
            contrast: 90.5138235279722,
            lc60: 55,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "green.300": {
            contrast: 88.71096478739892,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "green.400": {
            contrast: 86.16121051824408,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "green.500": {
            contrast: 82.60226636093743,
            lc60: 67,
            lc45: 48.5,
            lc30: 32.5,
            lc10: 17
        },
        "green.600": {
            contrast: 77.84109856605961,
            lc60: 72.5,
            lc45: 52.5,
            lc30: 35,
            lc10: 18.5
        },
        "green.700": {
            contrast: 72.7349451414621,
            lc60: 79,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "green.800": {
            contrast: 67.674194425813,
            lc60: 86,
            lc45: 62.5,
            lc30: 41,
            lc10: 21.5
        },
        "green.900": {
            contrast: 62.754583544115185,
            lc60: 94.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 23
        },
        "green.1000": {
            contrast: 58.02467338712051,
            lc60: 100,
            lc45: 74.5,
            lc30: 48.5,
            lc10: 25
        },
        "green.1100": {
            contrast: 53.13179840535398,
            lc60: 100,
            lc45: 82,
            lc30: 53,
            lc10: 27
        },
        "green.1200": {
            contrast: 48.083562716037505,
            lc60: 100,
            lc45: 92.5,
            lc30: 59,
            lc10: 30.5
        },
        "green.1300": {
            contrast: 42.462617946229805,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34
        },
        "green.1400": {
            contrast: 38.1680436424214,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 39
        },
        "green.1500": {
            contrast: 33.70259073565311,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 45
        },
        "green.1600": {
            contrast: 29.077760553909275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "green.1700": {
            contrast: 23.859472876094053,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "green.1800": {
            contrast: 18.517171816136937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "green.1900": {
            contrast: 13.439974828410458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2000": {
            contrast: 8.365356996907144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 9.311289841035693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 14.479543530966692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "green.2300": {
        "green.100": {
            contrast: 96.23414575538301,
            lc60: 49,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "green.200": {
            contrast: 95.67216703795182,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "green.300": {
            contrast: 93.86930829737857,
            lc60: 55,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "green.400": {
            contrast: 91.3195540282237,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "green.500": {
            contrast: 87.76060987091707,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "green.600": {
            contrast: 82.99944207603926,
            lc60: 67,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "green.700": {
            contrast: 77.89328865144172,
            lc60: 72,
            lc45: 52.5,
            lc30: 35,
            lc10: 18
        },
        "green.800": {
            contrast: 72.83253793579262,
            lc60: 78,
            lc45: 57,
            lc30: 38,
            lc10: 19.5
        },
        "green.900": {
            contrast: 67.91292705409481,
            lc60: 85,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "green.1000": {
            contrast: 63.18301689710013,
            lc60: 93.5,
            lc45: 67,
            lc30: 44,
            lc10: 22.5
        },
        "green.1100": {
            contrast: 58.29014191533361,
            lc60: 100,
            lc45: 73.5,
            lc30: 47.5,
            lc10: 24
        },
        "green.1200": {
            contrast: 53.241906226017136,
            lc60: 100,
            lc45: 81.5,
            lc30: 53,
            lc10: 27
        },
        "green.1300": {
            contrast: 47.62096145620943,
            lc60: 100,
            lc45: 93,
            lc30: 58.5,
            lc10: 30
        },
        "green.1400": {
            contrast: 43.326387152401026,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34
        },
        "green.1500": {
            contrast: 38.860934245632734,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38.5
        },
        "green.1600": {
            contrast: 34.2361040638889,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 44.5
        },
        "green.1700": {
            contrast: 29.017816386073676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "green.1800": {
            contrast: 23.67551532611656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "green.1900": {
            contrast: 18.598318338390087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "green.2000": {
            contrast: 13.523700506886769,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2100": {
            contrast: 8.07407327730191,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 8.601921953002076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "green.2400": {
        "green.100": {
            contrast: 101.36215905381283,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 11.5
        },
        "green.200": {
            contrast: 100.80018033638163,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "green.300": {
            contrast: 98.99732159580836,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "green.400": {
            contrast: 96.4475673266535,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "green.500": {
            contrast: 92.88862316934686,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "green.600": {
            contrast: 88.12745537446904,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "green.700": {
            contrast: 83.02130194987153,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "green.800": {
            contrast: 77.96055123422241,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "green.900": {
            contrast: 73.0409403525246,
            lc60: 77.5,
            lc45: 56,
            lc30: 37,
            lc10: 19
        },
        "green.1000": {
            contrast: 68.31103019552992,
            lc60: 84.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "green.1100": {
            contrast: 63.41815521376339,
            lc60: 93,
            lc45: 65.5,
            lc30: 43,
            lc10: 22.5
        },
        "green.1200": {
            contrast: 58.36991952444692,
            lc60: 100,
            lc45: 72.5,
            lc30: 47,
            lc10: 24.5
        },
        "green.1300": {
            contrast: 52.74897475463922,
            lc60: 100,
            lc45: 82,
            lc30: 52,
            lc10: 26.5
        },
        "green.1400": {
            contrast: 48.454400450830825,
            lc60: 100,
            lc45: 91.5,
            lc30: 58,
            lc10: 30
        },
        "green.1500": {
            contrast: 43.988947544062526,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33.5
        },
        "green.1600": {
            contrast: 39.364117362318694,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "green.1700": {
            contrast: 34.14582968450347,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 43.5
        },
        "green.1800": {
            contrast: 28.803528624546352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "green.1900": {
            contrast: 23.72633163681988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "green.2000": {
            contrast: 18.651713805316565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "green.2100": {
            contrast: 13.202086575731704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2200": {
            contrast: 7.8349121706460485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "green.2500": {
        "green.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "green.200": {
            contrast: 105.47869449525741,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "green.300": {
            contrast: 103.67583575468416,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "green.400": {
            contrast: 101.12608148552931,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13.5
        },
        "green.500": {
            contrast: 97.56713732822263,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "green.600": {
            contrast: 92.80596953334484,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "green.700": {
            contrast: 87.69981610874731,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "green.800": {
            contrast: 82.63906539309819,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32.5,
            lc10: 17
        },
        "green.900": {
            contrast: 77.71945451140037,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 18
        },
        "green.1000": {
            contrast: 72.98954435440572,
            lc60: 77,
            lc45: 55,
            lc30: 36.5,
            lc10: 18.5
        },
        "green.1100": {
            contrast: 68.09666937263918,
            lc60: 84,
            lc45: 60,
            lc30: 39,
            lc10: 20
        },
        "green.1200": {
            contrast: 63.04843368332271,
            lc60: 93.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "green.1300": {
            contrast: 57.42748891351501,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23.5
        },
        "green.1400": {
            contrast: 53.1329146097066,
            lc60: 100,
            lc45: 81,
            lc30: 51.5,
            lc10: 26
        },
        "green.1500": {
            contrast: 48.66746170293831,
            lc60: 100,
            lc45: 90.5,
            lc30: 57,
            lc10: 29.5
        },
        "green.1600": {
            contrast: 44.04263152119448,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32.5
        },
        "green.1700": {
            contrast: 38.82434384337925,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "green.1800": {
            contrast: 33.48204278342214,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 43.5
        },
        "green.1900": {
            contrast: 28.40484579569566,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "green.2000": {
            contrast: 23.33022796419235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "green.2100": {
            contrast: 17.880600734607487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "green.2200": {
            contrast: 12.513426329521835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "green.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$marigold = {
    "marigold.100": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 8.31173919905272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 12.249290357639028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 16.850597778297637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "marigold.900": {
            contrast: 21.239794632782882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "marigold.1000": {
            contrast: 25.469335012469536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "marigold.1100": {
            contrast: 29.984389748738426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "marigold.1200": {
            contrast: 34.69349350296007,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 64
        },
        "marigold.1300": {
            contrast: 39.59015208938245,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 59
        },
        "marigold.1400": {
            contrast: 44.1237579629117,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 55.5
        },
        "marigold.1500": {
            contrast: 49.06497859262817,
            lc60: 100,
            lc45: 95,
            lc30: 75,
            lc10: 52
        },
        "marigold.1600": {
            contrast: 53.771616286078284,
            lc60: 100,
            lc45: 89.5,
            lc30: 71,
            lc10: 49.5
        },
        "marigold.1700": {
            contrast: 58.71201126305032,
            lc60: 100,
            lc45: 85,
            lc30: 67,
            lc10: 47
        },
        "marigold.1800": {
            contrast: 65.4196142981686,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 44
        },
        "marigold.1900": {
            contrast: 69.9792972944084,
            lc60: 90.5,
            lc45: 76,
            lc30: 60.5,
            lc10: 42
        },
        "marigold.2000": {
            contrast: 76.10305974263872,
            lc60: 86,
            lc45: 72.5,
            lc30: 57,
            lc10: 39.5
        },
        "marigold.2100": {
            contrast: 82.18449988388986,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "marigold.2200": {
            contrast: 88.4288225801912,
            lc60: 78.5,
            lc45: 66,
            lc30: 52,
            lc10: 36
        },
        "marigold.2300": {
            contrast: 94.90500952190216,
            lc60: 75,
            lc45: 63,
            lc30: 50,
            lc10: 34.5
        },
        "marigold.2400": {
            contrast: 101.52379614543689,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33
        },
        "marigold.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "marigold.200": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 7.984669838744956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 11.922220997331264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 16.523528417989873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "marigold.900": {
            contrast: 20.912725272475114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1000": {
            contrast: 25.142265652161772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "marigold.1100": {
            contrast: 29.65732038843065,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "marigold.1200": {
            contrast: 34.3664241426523,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 60.5
        },
        "marigold.1300": {
            contrast: 39.26308272907469,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 55.5
        },
        "marigold.1400": {
            contrast: 43.796688602603936,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 51.5
        },
        "marigold.1500": {
            contrast: 48.7379092323204,
            lc60: 100,
            lc45: 94.5,
            lc30: 73,
            lc10: 48
        },
        "marigold.1600": {
            contrast: 53.44454692577052,
            lc60: 100,
            lc45: 89,
            lc30: 69,
            lc10: 45.5
        },
        "marigold.1700": {
            contrast: 58.38494190274256,
            lc60: 100,
            lc45: 84,
            lc30: 65,
            lc10: 43
        },
        "marigold.1800": {
            contrast: 65.09254493786084,
            lc60: 94.5,
            lc45: 78.5,
            lc30: 60.5,
            lc10: 40
        },
        "marigold.1900": {
            contrast: 69.65222793410064,
            lc60: 90.5,
            lc45: 74.5,
            lc30: 57.5,
            lc10: 38
        },
        "marigold.2000": {
            contrast: 75.77599038233096,
            lc60: 85.5,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 36
        },
        "marigold.2100": {
            contrast: 81.85743052358208,
            lc60: 81.5,
            lc45: 67,
            lc30: 52,
            lc10: 34.5
        },
        "marigold.2200": {
            contrast: 88.10175321988342,
            lc60: 77,
            lc45: 64,
            lc30: 49.5,
            lc10: 32.5
        },
        "marigold.2300": {
            contrast: 94.5779401615944,
            lc60: 74,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        },
        "marigold.2400": {
            contrast: 101.19672678512912,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45.5,
            lc10: 30
        },
        "marigold.2500": {
            contrast: 107.5576638227907,
            lc60: 67.5,
            lc45: 56.5,
            lc30: 43.5,
            lc10: 29
        }
    },
    "marigold.300": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 10.784797913503352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 15.38610533416196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "marigold.900": {
            contrast: 19.775302188647203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1000": {
            contrast: 24.00484256833386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "marigold.1100": {
            contrast: 28.519897304602747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "marigold.1200": {
            contrast: 33.22900105882438,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 58
        },
        "marigold.1300": {
            contrast: 38.12565964524677,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 52.5
        },
        "marigold.1400": {
            contrast: 42.65926551877602,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 49
        },
        "marigold.1500": {
            contrast: 47.60048614849249,
            lc60: 100,
            lc45: 96,
            lc30: 72.5,
            lc10: 45
        },
        "marigold.1600": {
            contrast: 52.307123841942605,
            lc60: 100,
            lc45: 89.5,
            lc30: 68,
            lc10: 42
        },
        "marigold.1700": {
            contrast: 57.24751881891464,
            lc60: 100,
            lc45: 84.5,
            lc30: 63.5,
            lc10: 39.5
        },
        "marigold.1800": {
            contrast: 63.95512185403292,
            lc60: 95.5,
            lc45: 78,
            lc30: 58.5,
            lc10: 36.5
        },
        "marigold.1900": {
            contrast: 68.51480485027271,
            lc60: 91,
            lc45: 74.5,
            lc30: 56,
            lc10: 35.5
        },
        "marigold.2000": {
            contrast: 74.63856729850305,
            lc60: 85.5,
            lc45: 70,
            lc30: 52.5,
            lc10: 33
        },
        "marigold.2100": {
            contrast: 80.72000743975417,
            lc60: 81,
            lc45: 66.5,
            lc30: 50.5,
            lc10: 31.5
        },
        "marigold.2200": {
            contrast: 86.96433013605551,
            lc60: 77,
            lc45: 63,
            lc30: 47.5,
            lc10: 30
        },
        "marigold.2300": {
            contrast: 93.44051707776649,
            lc60: 73,
            lc45: 60,
            lc30: 45.5,
            lc10: 28.5
        },
        "marigold.2400": {
            contrast: 100.0593037013012,
            lc60: 70,
            lc45: 57,
            lc30: 43.5,
            lc10: 27.5
        },
        "marigold.2500": {
            contrast: 106.42024073896279,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26.5
        }
    },
    "marigold.400": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 9.088367644302132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 13.689675064960738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 18.078871919445984,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "marigold.1000": {
            contrast: 22.308412299132637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "marigold.1100": {
            contrast: 26.823467035401528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "marigold.1200": {
            contrast: 31.532570789623165,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 57.5
        },
        "marigold.1300": {
            contrast: 36.429229376045555,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 51.5
        },
        "marigold.1400": {
            contrast: 40.962835249574795,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 47.5
        },
        "marigold.1500": {
            contrast: 45.90405587929127,
            lc60: 100,
            lc45: 98.5,
            lc30: 73,
            lc10: 43.5
        },
        "marigold.1600": {
            contrast: 50.61069357274138,
            lc60: 100,
            lc45: 91.5,
            lc30: 67.5,
            lc10: 40.5
        },
        "marigold.1700": {
            contrast: 55.55108854971343,
            lc60: 100,
            lc45: 85.5,
            lc30: 63,
            lc10: 38
        },
        "marigold.1800": {
            contrast: 62.258691584831695,
            lc60: 97,
            lc45: 78.5,
            lc30: 58,
            lc10: 35
        },
        "marigold.1900": {
            contrast: 66.8183745810715,
            lc60: 92,
            lc45: 74.5,
            lc30: 55,
            lc10: 33
        },
        "marigold.2000": {
            contrast: 72.94213702930182,
            lc60: 86.5,
            lc45: 70,
            lc30: 52,
            lc10: 31.5
        },
        "marigold.2100": {
            contrast: 79.02357717055295,
            lc60: 81.5,
            lc45: 66,
            lc30: 49,
            lc10: 29.5
        },
        "marigold.2200": {
            contrast: 85.2678998668543,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 46.5,
            lc10: 28
        },
        "marigold.2300": {
            contrast: 91.74408680856526,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 44.5,
            lc10: 27
        },
        "marigold.2400": {
            contrast: 98.36287343209999,
            lc60: 70,
            lc45: 56.5,
            lc30: 42,
            lc10: 25.5
        },
        "marigold.2500": {
            contrast: 104.72381046976157,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "marigold.500": {
        "marigold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 11.022159001868282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 15.411355856353525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "marigold.1000": {
            contrast: 19.64089623604018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "marigold.1100": {
            contrast: 24.155950972309068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "marigold.1200": {
            contrast: 28.865054726530705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.1300": {
            contrast: 33.76171331295309,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 52.5
        },
        "marigold.1400": {
            contrast: 38.29531918648234,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 47.5
        },
        "marigold.1500": {
            contrast: 43.236539816198814,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 43
        },
        "marigold.1600": {
            contrast: 47.943177509648926,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 39.5
        },
        "marigold.1700": {
            contrast: 52.88357248662096,
            lc60: 100,
            lc45: 88,
            lc30: 64,
            lc10: 37
        },
        "marigold.1800": {
            contrast: 59.59117552173924,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 33.5
        },
        "marigold.1900": {
            contrast: 64.15085851797903,
            lc60: 95,
            lc45: 76,
            lc30: 55.5,
            lc10: 32
        },
        "marigold.2000": {
            contrast: 70.27462096620935,
            lc60: 88.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 30
        },
        "marigold.2100": {
            contrast: 76.35606110746049,
            lc60: 83,
            lc45: 66.5,
            lc30: 48.5,
            lc10: 28
        },
        "marigold.2200": {
            contrast: 82.60038380376183,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 26.5
        },
        "marigold.2300": {
            contrast: 89.0765707454728,
            lc60: 74,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 25.5
        },
        "marigold.2400": {
            contrast: 95.69535736900751,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 24.5
        },
        "marigold.2500": {
            contrast: 102.0562944066691,
            lc60: 67,
            lc45: 54,
            lc30: 39.5,
            lc10: 23
        }
    },
    "marigold.600": {
        "marigold.100": {
            contrast: 9.662592703199044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 9.223428069237556,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 7.730243268761812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 11.601238491615925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 15.830778871302575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "marigold.1100": {
            contrast: 20.345833607571464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "marigold.1200": {
            contrast: 25.0549373617931,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "marigold.1300": {
            contrast: 29.951595948215488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "marigold.1400": {
            contrast: 34.48520182174474,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 50.5
        },
        "marigold.1500": {
            contrast: 39.42642245146121,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 45
        },
        "marigold.1600": {
            contrast: 44.133060144911326,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 41
        },
        "marigold.1700": {
            contrast: 49.073455121883356,
            lc60: 100,
            lc45: 93.5,
            lc30: 66.5,
            lc10: 38
        },
        "marigold.1800": {
            contrast: 55.78105815700164,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 34.5
        },
        "marigold.1900": {
            contrast: 60.34074115324143,
            lc60: 99.5,
            lc45: 79,
            lc30: 56.5,
            lc10: 32
        },
        "marigold.2000": {
            contrast: 66.46450360147176,
            lc60: 92,
            lc45: 73,
            lc30: 53,
            lc10: 30
        },
        "marigold.2100": {
            contrast: 72.54594374272288,
            lc60: 86,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        },
        "marigold.2200": {
            contrast: 78.79026643902422,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 26.5
        },
        "marigold.2300": {
            contrast: 85.2664533807352,
            lc60: 76,
            lc45: 60.5,
            lc30: 44,
            lc10: 25
        },
        "marigold.2400": {
            contrast: 91.8852400042699,
            lc60: 71.5,
            lc45: 57.5,
            lc30: 42,
            lc10: 24
        },
        "marigold.2500": {
            contrast: 98.24617704193149,
            lc60: 68.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 23
        }
    },
    "marigold.700": {
        "marigold.100": {
            contrast: 13.95434251979194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.200": {
            contrast: 13.51517788583045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.300": {
            contrast: 12.021993085354707,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.400": {
            contrast: 9.871275038765075,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 7.8433028991888945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 12.07284327887555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 16.58789801514444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "marigold.1200": {
            contrast: 21.297001769366076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "marigold.1300": {
            contrast: 26.193660355788456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "marigold.1400": {
            contrast: 30.727266229317706,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54.5
        },
        "marigold.1500": {
            contrast: 35.66848685903418,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        },
        "marigold.1600": {
            contrast: 40.375124552484294,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43
        },
        "marigold.1700": {
            contrast: 45.315519529456324,
            lc60: 100,
            lc45: 99,
            lc30: 71,
            lc10: 39.5
        },
        "marigold.1800": {
            contrast: 52.02312256457461,
            lc60: 100,
            lc45: 88.5,
            lc30: 63,
            lc10: 35.5
        },
        "marigold.1900": {
            contrast: 56.5828055608144,
            lc60: 100,
            lc45: 82.5,
            lc30: 59,
            lc10: 32.5
        },
        "marigold.2000": {
            contrast: 62.70656800904473,
            lc60: 96.5,
            lc45: 76.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "marigold.2100": {
            contrast: 68.78800815029585,
            lc60: 89.5,
            lc45: 71,
            lc30: 51,
            lc10: 28.5
        },
        "marigold.2200": {
            contrast: 75.03233084659719,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 47.5,
            lc10: 26.5
        },
        "marigold.2300": {
            contrast: 81.50851778830817,
            lc60: 78.5,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        },
        "marigold.2400": {
            contrast: 88.12730441184289,
            lc60: 74,
            lc45: 59,
            lc30: 42.5,
            lc10: 24
        },
        "marigold.2500": {
            contrast: 94.48824144950446,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 40.5,
            lc10: 23
        }
    },
    "marigold.800": {
        "marigold.100": {
            contrast: 18.858305718680445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "marigold.200": {
            contrast: 18.419141084718955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "marigold.300": {
            contrast: 16.925956284243213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.400": {
            contrast: 14.775238237653584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.500": {
            contrast: 11.524599853794628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 7.631907953236415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 12.146962689505303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 16.85606644372694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "marigold.1300": {
            contrast: 21.75272503014933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.1400": {
            contrast: 26.28633090367857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "marigold.1500": {
            contrast: 31.227551533395047,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 53
        },
        "marigold.1600": {
            contrast: 35.93418922684516,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 47
        },
        "marigold.1700": {
            contrast: 40.8745842038172,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42
        },
        "marigold.1800": {
            contrast: 47.58218723893547,
            lc60: 100,
            lc45: 95,
            lc30: 67.5,
            lc10: 37
        },
        "marigold.1900": {
            contrast: 52.14187023517527,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35
        },
        "marigold.2000": {
            contrast: 58.2656326834056,
            lc60: 100,
            lc45: 80.5,
            lc30: 57,
            lc10: 31.5
        },
        "marigold.2100": {
            contrast: 64.34707282465672,
            lc60: 94,
            lc45: 74,
            lc30: 53,
            lc10: 29.5
        },
        "marigold.2200": {
            contrast: 70.59139552095807,
            lc60: 87.5,
            lc45: 69.5,
            lc30: 49.5,
            lc10: 27.5
        },
        "marigold.2300": {
            contrast: 77.06758246266904,
            lc60: 81.5,
            lc45: 64.5,
            lc30: 46.5,
            lc10: 26
        },
        "marigold.2400": {
            contrast: 83.68636908620375,
            lc60: 77,
            lc45: 61,
            lc30: 43.5,
            lc10: 24.5
        },
        "marigold.2500": {
            contrast: 90.04730612386534,
            lc60: 72.5,
            lc45: 57.5,
            lc30: 41.5,
            lc10: 23
        }
    },
    "marigold.900": {
        "marigold.100": {
            contrast: 23.44755732039726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "marigold.200": {
            contrast: 23.008392686435766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "marigold.300": {
            contrast: 21.515207885960024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "marigold.400": {
            contrast: 19.364489839370393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "marigold.500": {
            contrast: 16.113851455511437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "marigold.600": {
            contrast: 11.662798115433892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.700": {
            contrast: 7.4291195326659345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 7.870050115891451,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 12.579153870113089,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 17.475812456535476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "marigold.1400": {
            contrast: 22.009418330064726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.1500": {
            contrast: 26.95063895978119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.1600": {
            contrast: 31.657276653231314,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 51.5
        },
        "marigold.1700": {
            contrast: 36.59767163020335,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "marigold.1800": {
            contrast: 43.305274665321626,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 39.5
        },
        "marigold.1900": {
            contrast: 47.86495766156141,
            lc60: 100,
            lc45: 94.5,
            lc30: 66.5,
            lc10: 36.5
        },
        "marigold.2000": {
            contrast: 53.98872010979174,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 33
        },
        "marigold.2100": {
            contrast: 60.07016025104288,
            lc60: 99.5,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 31
        },
        "marigold.2200": {
            contrast: 66.31448294734422,
            lc60: 92,
            lc45: 73,
            lc30: 52,
            lc10: 28
        },
        "marigold.2300": {
            contrast: 72.79066988905518,
            lc60: 85.5,
            lc45: 68,
            lc30: 48,
            lc10: 27
        },
        "marigold.2400": {
            contrast: 79.4094565125899,
            lc60: 80,
            lc45: 63,
            lc30: 45,
            lc10: 25
        },
        "marigold.2500": {
            contrast: 85.77039355025148,
            lc60: 75,
            lc45: 59.5,
            lc30: 43,
            lc10: 23.5
        }
    },
    "marigold.1000": {
        "marigold.100": {
            contrast: 27.802541687172578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "marigold.200": {
            contrast: 27.363377053211096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "marigold.300": {
            contrast: 25.870192252735347,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "marigold.400": {
            contrast: 23.719474206145723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.500": {
            contrast: 20.468835822286767,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "marigold.600": {
            contrast: 16.017782482209224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "marigold.700": {
            contrast: 11.784103899441261,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 8.4260870035389,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 13.322745589961288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 17.856351463490537,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "marigold.1500": {
            contrast: 22.797572093207005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "marigold.1600": {
            contrast: 27.504209786657125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "marigold.1700": {
            contrast: 32.44460476362916,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 49.5
        },
        "marigold.1800": {
            contrast: 39.15220779874743,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43
        },
        "marigold.1900": {
            contrast: 43.71189079498723,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39
        },
        "marigold.2000": {
            contrast: 49.83565324321756,
            lc60: 100,
            lc45: 91.5,
            lc30: 64.5,
            lc10: 35.5
        },
        "marigold.2100": {
            contrast: 55.917093384468686,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 32.5
        },
        "marigold.2200": {
            contrast: 62.16141608077002,
            lc60: 97,
            lc45: 76.5,
            lc30: 54.5,
            lc10: 30
        },
        "marigold.2300": {
            contrast: 68.637603022481,
            lc60: 89.5,
            lc45: 71,
            lc30: 50.5,
            lc10: 28
        },
        "marigold.2400": {
            contrast: 75.25638964601572,
            lc60: 83.5,
            lc45: 66,
            lc30: 47,
            lc10: 26
        },
        "marigold.2500": {
            contrast: 81.61732668367728,
            lc60: 78,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        }
    },
    "marigold.1100": {
        "marigold.100": {
            contrast: 32.389627430872565,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 33.5
        },
        "marigold.200": {
            contrast: 31.950462796911083,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 37.5
        },
        "marigold.300": {
            contrast: 30.457277996435334,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 43
        },
        "marigold.400": {
            contrast: 28.306559949845706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49.5
        },
        "marigold.500": {
            contrast: 25.05592156598675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.600": {
            contrast: 20.604868225909208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "marigold.700": {
            contrast: 16.37118964314125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "marigold.800": {
            contrast: 11.515458996341588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 8.85952652607723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 13.39313239960648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 18.33435302932295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1600": {
            contrast: 23.040990722773067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "marigold.1700": {
            contrast: 27.981385699745097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "marigold.1800": {
            contrast: 34.68898873486337,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "marigold.1900": {
            contrast: 39.248671731103165,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 42.5
        },
        "marigold.2000": {
            contrast: 45.372434179333496,
            lc60: 100,
            lc45: 99,
            lc30: 69.5,
            lc10: 37.5
        },
        "marigold.2100": {
            contrast: 51.453874320584625,
            lc60: 100,
            lc45: 89,
            lc30: 62.5,
            lc10: 34
        },
        "marigold.2200": {
            contrast: 57.69819701688596,
            lc60: 100,
            lc45: 81.5,
            lc30: 57.5,
            lc10: 31.5
        },
        "marigold.2300": {
            contrast: 64.17438395859695,
            lc60: 94,
            lc45: 74,
            lc30: 53,
            lc10: 29
        },
        "marigold.2400": {
            contrast: 70.79317058213167,
            lc60: 87,
            lc45: 69.5,
            lc30: 49.5,
            lc10: 27
        },
        "marigold.2500": {
            contrast: 77.15410761979324,
            lc60: 81.5,
            lc45: 65,
            lc30: 46,
            lc10: 25.5
        }
    },
    "marigold.1200": {
        "marigold.100": {
            contrast: 37.115011023217825,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 29.5
        },
        "marigold.200": {
            contrast: 36.67584638925634,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33
        },
        "marigold.300": {
            contrast: 35.1826615887806,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 37
        },
        "marigold.400": {
            contrast: 33.031943542190966,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 42
        },
        "marigold.500": {
            contrast: 29.78130515833201,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49.5
        },
        "marigold.600": {
            contrast: 25.330251818254464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.700": {
            contrast: 21.096573235486506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "marigold.800": {
            contrast: 16.240842588686846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "marigold.900": {
            contrast: 11.682210261326572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1000": {
            contrast: 7.345203541280688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 8.709200203002029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 13.650420832718499,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 18.35705852616862,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "marigold.1700": {
            contrast: 23.297453503140648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "marigold.1800": {
            contrast: 30.005056538258923,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53
        },
        "marigold.1900": {
            contrast: 34.56473953449872,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "marigold.2000": {
            contrast: 40.68850198272905,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 41
        },
        "marigold.2100": {
            contrast: 46.76994212398017,
            lc60: 100,
            lc45: 96,
            lc30: 68,
            lc10: 37
        },
        "marigold.2200": {
            contrast: 53.01426482028152,
            lc60: 100,
            lc45: 87,
            lc30: 61.5,
            lc10: 34
        },
        "marigold.2300": {
            contrast: 59.49045176199249,
            lc60: 100,
            lc45: 79.5,
            lc30: 56.5,
            lc10: 31
        },
        "marigold.2400": {
            contrast: 66.10923838552722,
            lc60: 92,
            lc45: 73,
            lc30: 52,
            lc10: 28.5
        },
        "marigold.2500": {
            contrast: 72.47017542318878,
            lc60: 86,
            lc45: 68,
            lc30: 48.5,
            lc10: 26.5
        }
    },
    "marigold.1300": {
        "marigold.100": {
            contrast: 41.97290435051576,
            lc60: 100,
            lc45: 100,
            lc30: 53,
            lc10: 26.5
        },
        "marigold.200": {
            contrast: 41.53373971655428,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29
        },
        "marigold.300": {
            contrast: 40.04055491607853,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "marigold.400": {
            contrast: 37.8898368694889,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "marigold.500": {
            contrast: 34.63919848562995,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 42
        },
        "marigold.600": {
            contrast: 30.188145145552404,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 49.5
        },
        "marigold.700": {
            contrast: 25.95446656278444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "marigold.800": {
            contrast: 21.098735915984783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.900": {
            contrast: 16.540103588624508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "marigold.1000": {
            contrast: 12.203096868578625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1100": {
            contrast: 7.624732529700753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 8.752100120734898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 13.458737814185016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 18.39913279115705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "marigold.1800": {
            contrast: 25.106735826275322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "marigold.1900": {
            contrast: 29.666418822515116,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "marigold.2000": {
            contrast: 35.79018127074545,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 46
        },
        "marigold.2100": {
            contrast: 41.87162141199657,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 41
        },
        "marigold.2200": {
            contrast: 48.11594410829792,
            lc60: 100,
            lc45: 94.5,
            lc30: 66.5,
            lc10: 37
        },
        "marigold.2300": {
            contrast: 54.59213105000889,
            lc60: 100,
            lc45: 85,
            lc30: 60.5,
            lc10: 33.5
        },
        "marigold.2400": {
            contrast: 61.2109176735436,
            lc60: 98,
            lc45: 77.5,
            lc30: 55.5,
            lc10: 30.5
        },
        "marigold.2500": {
            contrast: 67.57185471120518,
            lc60: 90.5,
            lc45: 72,
            lc30: 51.5,
            lc10: 28.5
        }
    },
    "marigold.1400": {
        "marigold.100": {
            contrast: 46.425734526265295,
            lc60: 100,
            lc45: 83.5,
            lc30: 48.5,
            lc10: 24
        },
        "marigold.200": {
            contrast: 45.98656989230381,
            lc60: 100,
            lc45: 92.5,
            lc30: 53,
            lc10: 26.5
        },
        "marigold.300": {
            contrast: 44.49338509182807,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 29.5
        },
        "marigold.400": {
            contrast: 42.342667045238436,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "marigold.500": {
            contrast: 39.09202866137948,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "marigold.600": {
            contrast: 34.64097532130193,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 42
        },
        "marigold.700": {
            contrast: 30.407296738533972,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 49.5
        },
        "marigold.800": {
            contrast: 25.551566091734312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.900": {
            contrast: 20.99293376437404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.1000": {
            contrast: 16.65592704432816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "marigold.1100": {
            contrast: 12.07756270545029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1200": {
            contrast: 7.3514239792295255,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 8.900798383588713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 13.841193360560746,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 20.548796395679023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "marigold.1900": {
            contrast: 25.108479391918813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "marigold.2000": {
            contrast: 31.232241840149143,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 52
        },
        "marigold.2100": {
            contrast: 37.31368198140027,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "marigold.2200": {
            contrast: 43.55800467770161,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "marigold.2300": {
            contrast: 50.03419161941258,
            lc60: 100,
            lc45: 91,
            lc30: 65,
            lc10: 35.5
        },
        "marigold.2400": {
            contrast: 56.65297824294729,
            lc60: 100,
            lc45: 82.5,
            lc30: 59,
            lc10: 33
        },
        "marigold.2500": {
            contrast: 63.01391528060888,
            lc60: 96.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        }
    },
    "marigold.1500": {
        "marigold.100": {
            contrast: 51.23488381948847,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22
        },
        "marigold.200": {
            contrast: 50.79571918552699,
            lc60: 100,
            lc45: 76.5,
            lc30: 48,
            lc10: 24
        },
        "marigold.300": {
            contrast: 49.302534385051246,
            lc60: 100,
            lc45: 84.5,
            lc30: 53,
            lc10: 26.5
        },
        "marigold.400": {
            contrast: 47.151816338461614,
            lc60: 100,
            lc45: 92.5,
            lc30: 58,
            lc10: 29
        },
        "marigold.500": {
            contrast: 43.90117795460266,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "marigold.600": {
            contrast: 39.450124614525116,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37
        },
        "marigold.700": {
            contrast: 35.21644603175715,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "marigold.800": {
            contrast: 30.360715384957487,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50
        },
        "marigold.900": {
            contrast: 25.80208305759722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "marigold.1000": {
            contrast: 21.465076337551338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.1100": {
            contrast: 16.88671199867347,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "marigold.1200": {
            contrast: 12.160573272452705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 8.850760774088632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 15.558363809206908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "marigold.1900": {
            contrast: 20.1180468054467,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "marigold.2000": {
            contrast: 26.24180925367703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "marigold.2100": {
            contrast: 32.323249394928155,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51
        },
        "marigold.2200": {
            contrast: 38.56757209122949,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "marigold.2300": {
            contrast: 45.043759032940464,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 39.5
        },
        "marigold.2400": {
            contrast: 51.66254565647518,
            lc60: 100,
            lc45: 89,
            lc30: 63,
            lc10: 35.5
        },
        "marigold.2500": {
            contrast: 58.02348269413676,
            lc60: 100,
            lc45: 81.5,
            lc30: 58.5,
            lc10: 32.5
        }
    },
    "marigold.1600": {
        "marigold.100": {
            contrast: 55.77702163296222,
            lc60: 100,
            lc45: 63,
            lc30: 40,
            lc10: 20
        },
        "marigold.200": {
            contrast: 55.337856999000735,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 22.5
        },
        "marigold.300": {
            contrast: 53.84467219852499,
            lc60: 100,
            lc45: 75.5,
            lc30: 48,
            lc10: 24.5
        },
        "marigold.400": {
            contrast: 51.69395415193536,
            lc60: 100,
            lc45: 82,
            lc30: 52.5,
            lc10: 26.5
        },
        "marigold.500": {
            contrast: 48.4433157680764,
            lc60: 100,
            lc45: 91,
            lc30: 58,
            lc10: 29.5
        },
        "marigold.600": {
            contrast: 43.99226242799886,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 33.5
        },
        "marigold.700": {
            contrast: 39.7585838452309,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37
        },
        "marigold.800": {
            contrast: 34.90285319843123,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43
        },
        "marigold.900": {
            contrast: 30.344220871070966,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50
        },
        "marigold.1000": {
            contrast: 26.00721415102508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "marigold.1100": {
            contrast: 21.428849812147213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "marigold.1200": {
            contrast: 16.702711085926445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "marigold.1300": {
            contrast: 11.834801178465948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1400": {
            contrast: 7.365323785246145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 10.784646618748637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 15.344329614988428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2000": {
            contrast: 21.46809206321876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "marigold.2100": {
            contrast: 27.549532204469884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.2200": {
            contrast: 33.79385490077122,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "marigold.2300": {
            contrast: 40.27004184248219,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43
        },
        "marigold.2400": {
            contrast: 46.88882846601691,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 38.5
        },
        "marigold.2500": {
            contrast: 53.24976550367849,
            lc60: 100,
            lc45: 87.5,
            lc30: 63,
            lc10: 34.5
        }
    },
    "marigold.1700": {
        "marigold.100": {
            contrast: 60.50773626357404,
            lc60: 91,
            lc45: 57.5,
            lc30: 37,
            lc10: 19
        },
        "marigold.200": {
            contrast: 60.068571629612556,
            lc60: 99,
            lc45: 63,
            lc30: 40.5,
            lc10: 20.5
        },
        "marigold.300": {
            contrast: 58.5753868291368,
            lc60: 100,
            lc45: 68,
            lc30: 44,
            lc10: 22.5
        },
        "marigold.400": {
            contrast: 56.42466878254717,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24.5
        },
        "marigold.500": {
            contrast: 53.174030398688224,
            lc60: 100,
            lc45: 81.5,
            lc30: 52.5,
            lc10: 27
        },
        "marigold.600": {
            contrast: 48.722977058610674,
            lc60: 100,
            lc45: 90.5,
            lc30: 58.5,
            lc10: 30
        },
        "marigold.700": {
            contrast: 44.489298475842716,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "marigold.800": {
            contrast: 39.633567829043045,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 38
        },
        "marigold.900": {
            contrast: 35.07493550168278,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43
        },
        "marigold.1000": {
            contrast: 30.737928781636896,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 50
        },
        "marigold.1100": {
            contrast: 26.159564442759027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "marigold.1200": {
            contrast: 21.433425716538267,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.1300": {
            contrast: 16.565515809077766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "marigold.1400": {
            contrast: 12.096038415857963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 10.31396151422643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 16.43772396245676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "marigold.2100": {
            contrast: 22.519164103707887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "marigold.2200": {
            contrast: 28.76348680000923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "marigold.2300": {
            contrast: 35.239673741720196,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48.5
        },
        "marigold.2400": {
            contrast: 41.85846036525491,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42.5
        },
        "marigold.2500": {
            contrast: 48.2193974029165,
            lc60: 100,
            lc45: 94,
            lc30: 68,
            lc10: 38
        }
    },
    "marigold.1800": {
        "marigold.100": {
            contrast: 66.87548992963627,
            lc60: 73,
            lc45: 52,
            lc30: 33.5,
            lc10: 17
        },
        "marigold.200": {
            contrast: 66.43632529567478,
            lc60: 79,
            lc45: 56,
            lc30: 36,
            lc10: 18.5
        },
        "marigold.300": {
            contrast: 64.94314049519903,
            lc60: 85.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "marigold.400": {
            contrast: 62.7924224486094,
            lc60: 92,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "marigold.500": {
            contrast: 59.541784064750445,
            lc60: 100,
            lc45: 71,
            lc30: 46,
            lc10: 23.5
        },
        "marigold.600": {
            contrast: 55.090730724672895,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "marigold.700": {
            contrast: 50.857052141904944,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 29
        },
        "marigold.800": {
            contrast: 46.00132149510527,
            lc60: 100,
            lc45: 97,
            lc30: 63.5,
            lc10: 32
        },
        "marigold.900": {
            contrast: 41.44268916774501,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 36.5
        },
        "marigold.1000": {
            contrast: 37.105682447699124,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 41
        },
        "marigold.1100": {
            contrast: 32.52731810882125,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 47
        },
        "marigold.1200": {
            contrast: 27.801179382600488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "marigold.1300": {
            contrast: 22.93326947513999,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "marigold.1400": {
            contrast: 18.463792081920186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "marigold.1500": {
            contrast: 13.629325064874278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1600": {
            contrast: 9.05681386497683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 9.578437050084764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 15.659877191335895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "marigold.2200": {
            contrast: 21.904199887637237,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "marigold.2300": {
            contrast: 28.380386829348197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.2400": {
            contrast: 34.999173452882914,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49
        },
        "marigold.2500": {
            contrast: 41.3601104905445,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43
        }
    },
    "marigold.1900": {
        "marigold.100": {
            contrast: 71.17090949876933,
            lc60: 68,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "marigold.200": {
            contrast: 70.73174486480784,
            lc60: 73,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "marigold.300": {
            contrast: 69.23856006433209,
            lc60: 78.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "marigold.400": {
            contrast: 67.08784201774246,
            lc60: 84.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "marigold.500": {
            contrast: 63.83720363388351,
            lc60: 92,
            lc45: 66,
            lc30: 43,
            lc10: 22
        },
        "marigold.600": {
            contrast: 59.38615029380596,
            lc60: 100,
            lc45: 72.5,
            lc30: 47,
            lc10: 24
        },
        "marigold.700": {
            contrast: 55.152471711038,
            lc60: 100,
            lc45: 79,
            lc30: 51.5,
            lc10: 26.5
        },
        "marigold.800": {
            contrast: 50.29674106423834,
            lc60: 100,
            lc45: 88,
            lc30: 57,
            lc10: 29
        },
        "marigold.900": {
            contrast: 45.73810873687806,
            lc60: 100,
            lc45: 98,
            lc30: 63.5,
            lc10: 33
        },
        "marigold.1000": {
            contrast: 41.40110201683218,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 36
        },
        "marigold.1100": {
            contrast: 36.822737677954315,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 41
        },
        "marigold.1200": {
            contrast: 32.09659895173355,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 47.5
        },
        "marigold.1300": {
            contrast: 27.228689044273047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "marigold.1400": {
            contrast: 22.75921165105325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "marigold.1500": {
            contrast: 17.92474463400734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "marigold.1600": {
            contrast: 13.352233434109891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1700": {
            contrast: 8.58369477165104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 10.979083490170826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 17.223406186472168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "marigold.2300": {
            contrast: 23.699593128183135,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "marigold.2400": {
            contrast: 30.31837975171785,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56
        },
        "marigold.2500": {
            contrast: 36.679316789379435,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47
        }
    },
    "marigold.2000": {
        "marigold.100": {
            contrast: 76.90094085814016,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "marigold.200": {
            contrast: 76.46177622417866,
            lc60: 66.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16.5
        },
        "marigold.300": {
            contrast: 74.96859142370292,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "marigold.400": {
            contrast: 72.81787337711329,
            lc60: 76,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "marigold.500": {
            contrast: 69.56723499325435,
            lc60: 82.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "marigold.600": {
            contrast: 65.1161816531768,
            lc60: 90,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "marigold.700": {
            contrast: 60.88250307040883,
            lc60: 98,
            lc45: 70.5,
            lc30: 46,
            lc10: 24
        },
        "marigold.800": {
            contrast: 56.026772423609174,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "marigold.900": {
            contrast: 51.4681400962489,
            lc60: 100,
            lc45: 86,
            lc30: 55.5,
            lc10: 29
        },
        "marigold.1000": {
            contrast: 47.13113337620302,
            lc60: 100,
            lc45: 94.5,
            lc30: 62,
            lc10: 32
        },
        "marigold.1100": {
            contrast: 42.55276903732514,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "marigold.1200": {
            contrast: 37.82663031110438,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40
        },
        "marigold.1300": {
            contrast: 32.95872040364388,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 46
        },
        "marigold.1400": {
            contrast: 28.489243010424076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "marigold.1500": {
            contrast: 23.65477599337817,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "marigold.1600": {
            contrast: 19.082264793480725,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "marigold.1700": {
            contrast: 14.313726131021873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1800": {
            contrast: 7.885826387843456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 10.915726941543506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 17.391913883254475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "marigold.2400": {
            contrast: 24.01070050678919,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "marigold.2500": {
            contrast: 30.37163754445077,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        }
    },
    "marigold.2100": {
        "marigold.100": {
            contrast: 82.5505968237916,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14
        },
        "marigold.200": {
            contrast: 82.11143218983011,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "marigold.300": {
            contrast: 80.61824738935437,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "marigold.400": {
            contrast: 78.46752934276473,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17
        },
        "marigold.500": {
            contrast: 75.21689095890578,
            lc60: 75,
            lc45: 54.5,
            lc30: 36,
            lc10: 18.5
        },
        "marigold.600": {
            contrast: 70.76583761882824,
            lc60: 81,
            lc45: 58.5,
            lc30: 39,
            lc10: 20
        },
        "marigold.700": {
            contrast: 66.53215903606029,
            lc60: 87.5,
            lc45: 63.5,
            lc30: 41.5,
            lc10: 21.5
        },
        "marigold.800": {
            contrast: 61.67642838926062,
            lc60: 96.5,
            lc45: 69.5,
            lc30: 46,
            lc10: 24
        },
        "marigold.900": {
            contrast: 57.117796061900336,
            lc60: 100,
            lc45: 76,
            lc30: 50,
            lc10: 25.5
        },
        "marigold.1000": {
            contrast: 52.78078934185446,
            lc60: 100,
            lc45: 83,
            lc30: 54.5,
            lc10: 28
        },
        "marigold.1100": {
            contrast: 48.20242500297659,
            lc60: 100,
            lc45: 92,
            lc30: 60,
            lc10: 31
        },
        "marigold.1200": {
            contrast: 43.47628627675583,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "marigold.1300": {
            contrast: 38.60837636929532,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 39
        },
        "marigold.1400": {
            contrast: 34.138898976075524,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 44.5
        },
        "marigold.1500": {
            contrast: 29.304431959029614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "marigold.1600": {
            contrast: 24.731920759132166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "marigold.1700": {
            contrast: 19.963382096673314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "marigold.1800": {
            contrast: 13.5354823534949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.1900": {
            contrast: 9.193914800042483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 11.105265995822885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 17.724052619357604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "marigold.2500": {
            contrast: 24.084989657019186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        }
    },
    "marigold.2200": {
        "marigold.100": {
            contrast: 88.31251220415398,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "marigold.200": {
            contrast: 87.87334757019248,
            lc60: 56.5,
            lc45: 41,
            lc30: 27.5,
            lc10: 14
        },
        "marigold.300": {
            contrast: 86.38016276971673,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "marigold.400": {
            contrast: 84.2294447231271,
            lc60: 64,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "marigold.500": {
            contrast: 80.97880633926815,
            lc60: 68.5,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "marigold.600": {
            contrast: 76.52775299919061,
            lc60: 73.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "marigold.700": {
            contrast: 72.29407441642266,
            lc60: 79,
            lc45: 57.5,
            lc30: 38,
            lc10: 19.5
        },
        "marigold.800": {
            contrast: 67.43834376962299,
            lc60: 86.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "marigold.900": {
            contrast: 62.87971144226272,
            lc60: 94.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 23
        },
        "marigold.1000": {
            contrast: 58.54270472221683,
            lc60: 100,
            lc45: 73.5,
            lc30: 48,
            lc10: 25.5
        },
        "marigold.1100": {
            contrast: 53.96434038333896,
            lc60: 100,
            lc45: 81,
            lc30: 52.5,
            lc10: 27
        },
        "marigold.1200": {
            contrast: 49.238201657118196,
            lc60: 100,
            lc45: 90,
            lc30: 58.5,
            lc10: 30
        },
        "marigold.1300": {
            contrast: 44.370291749657696,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33.5
        },
        "marigold.1400": {
            contrast: 39.9008143564379,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37
        },
        "marigold.1500": {
            contrast: 35.06634733939199,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 42.5
        },
        "marigold.1600": {
            contrast: 30.49383613949454,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 49
        },
        "marigold.1700": {
            contrast: 25.725297477035685,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "marigold.1800": {
            contrast: 19.29739773385727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "marigold.1900": {
            contrast: 14.955830180404856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2000": {
            contrast: 9.157717754014937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 11.247185320587324,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 17.60812235824891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        }
    },
    "marigold.2300": {
        "marigold.100": {
            contrast: 94.24960267741133,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "marigold.200": {
            contrast: 93.81043804344985,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "marigold.300": {
            contrast: 92.3172532429741,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "marigold.400": {
            contrast: 90.16653519638447,
            lc60: 59,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "marigold.500": {
            contrast: 86.91589681252552,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "marigold.600": {
            contrast: 82.46484347244798,
            lc60: 67,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "marigold.700": {
            contrast: 78.23116488968003,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "marigold.800": {
            contrast: 73.37543424288036,
            lc60: 78,
            lc45: 56.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "marigold.900": {
            contrast: 68.81680191552007,
            lc60: 84.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 21
        },
        "marigold.1000": {
            contrast: 64.4797951954742,
            lc60: 91,
            lc45: 66,
            lc30: 43,
            lc10: 22.5
        },
        "marigold.1100": {
            contrast: 59.901430856596335,
            lc60: 100,
            lc45: 71.5,
            lc30: 47,
            lc10: 24.5
        },
        "marigold.1200": {
            contrast: 55.17529213037557,
            lc60: 100,
            lc45: 78.5,
            lc30: 51,
            lc10: 26.5
        },
        "marigold.1300": {
            contrast: 50.30738222291507,
            lc60: 100,
            lc45: 87.5,
            lc30: 56.5,
            lc10: 29
        },
        "marigold.1400": {
            contrast: 45.83790482969526,
            lc60: 100,
            lc45: 97.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "marigold.1500": {
            contrast: 41.00343781264935,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "marigold.1600": {
            contrast: 36.430926612751904,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 41
        },
        "marigold.1700": {
            contrast: 31.662387950293052,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 46
        },
        "marigold.1800": {
            contrast: 25.234488207114637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "marigold.1900": {
            contrast: 20.892920653662223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.2000": {
            contrast: 15.094808227272305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2100": {
            contrast: 9.371170032514646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 10.868855943374408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "marigold.2400": {
        "marigold.100": {
            contrast: 100.27947290908156,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "marigold.200": {
            contrast: 99.84030827512008,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "marigold.300": {
            contrast: 98.34712347464432,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "marigold.400": {
            contrast: 96.1964054280547,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "marigold.500": {
            contrast: 92.94576704419575,
            lc60: 58,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 15
        },
        "marigold.600": {
            contrast: 88.4947137041182,
            lc60: 62,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "marigold.700": {
            contrast: 84.26103512135023,
            lc60: 66,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "marigold.800": {
            contrast: 79.40530447455058,
            lc60: 71,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "marigold.900": {
            contrast: 74.8466721471903,
            lc60: 76,
            lc45: 55.5,
            lc30: 37,
            lc10: 19
        },
        "marigold.1000": {
            contrast: 70.50966542714441,
            lc60: 81.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "marigold.1100": {
            contrast: 65.93130108826655,
            lc60: 88.5,
            lc45: 64,
            lc30: 42,
            lc10: 22
        },
        "marigold.1200": {
            contrast: 61.20516236204578,
            lc60: 97,
            lc45: 69.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "marigold.1300": {
            contrast: 56.33725245458528,
            lc60: 100,
            lc45: 76.5,
            lc30: 49.5,
            lc10: 26
        },
        "marigold.1400": {
            contrast: 51.867775061365485,
            lc60: 100,
            lc45: 84,
            lc30: 54.5,
            lc10: 28
        },
        "marigold.1500": {
            contrast: 47.033308044319575,
            lc60: 100,
            lc45: 94.5,
            lc30: 60.5,
            lc10: 31
        },
        "marigold.1600": {
            contrast: 42.46079684442213,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "marigold.1700": {
            contrast: 37.692258181963275,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 38
        },
        "marigold.1800": {
            contrast: 31.264358438784857,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 47.5
        },
        "marigold.1900": {
            contrast: 26.922790885332443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "marigold.2000": {
            contrast: 21.12467845894253,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "marigold.2100": {
            contrast: 15.401040264184868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2200": {
            contrast: 9.557096051606745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "marigold.2500": {
        "marigold.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "marigold.200": {
            contrast: 105.60150857872712,
            lc60: 46,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "marigold.300": {
            contrast: 104.10832377825136,
            lc60: 48.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "marigold.400": {
            contrast: 101.95760573166174,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "marigold.500": {
            contrast: 98.70696734780276,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "marigold.600": {
            contrast: 94.25591400772524,
            lc60: 57.5,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 15
        },
        "marigold.700": {
            contrast: 90.02223542495727,
            lc60: 61,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "marigold.800": {
            contrast: 85.1665047781576,
            lc60: 65,
            lc45: 48,
            lc30: 32,
            lc10: 16.5
        },
        "marigold.900": {
            contrast: 80.60787245079733,
            lc60: 69.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 18
        },
        "marigold.1000": {
            contrast: 76.27086573075145,
            lc60: 74,
            lc45: 54,
            lc30: 36,
            lc10: 19
        },
        "marigold.1100": {
            contrast: 71.69250139187359,
            lc60: 80,
            lc45: 58,
            lc30: 38.5,
            lc10: 20
        },
        "marigold.1200": {
            contrast: 66.96636266565282,
            lc60: 87,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "marigold.1300": {
            contrast: 62.09845275819232,
            lc60: 95,
            lc45: 68,
            lc30: 44.5,
            lc10: 23.5
        },
        "marigold.1400": {
            contrast: 57.62897536497251,
            lc60: 100,
            lc45: 74,
            lc30: 48,
            lc10: 25
        },
        "marigold.1500": {
            contrast: 52.79450834792661,
            lc60: 100,
            lc45: 82.5,
            lc30: 52.5,
            lc10: 27.5
        },
        "marigold.1600": {
            contrast: 48.22199714802916,
            lc60: 100,
            lc45: 92,
            lc30: 58.5,
            lc10: 30
        },
        "marigold.1700": {
            contrast: 43.45345848557031,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33.5
        },
        "marigold.1800": {
            contrast: 37.02555874239189,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 39.5
        },
        "marigold.1900": {
            contrast: 32.68399118893947,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45.5
        },
        "marigold.2000": {
            contrast: 26.88587876254956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "marigold.2100": {
            contrast: 21.1622405677919,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "marigold.2200": {
            contrast: 15.318296355213779,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "marigold.2300": {
            contrast: 9.29014612648781,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "marigold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$orange = {
    "orange.100": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 8.075873581658634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 12.150668498133674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 16.695149017978974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "orange.900": {
            contrast: 21.02213922368927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "orange.1000": {
            contrast: 25.233026527246516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "orange.1100": {
            contrast: 29.640505142740587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "orange.1200": {
            contrast: 34.23571041575511,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 64.5
        },
        "orange.1300": {
            contrast: 39.20781801855704,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 59.5
        },
        "orange.1400": {
            contrast: 43.508208043077055,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 56
        },
        "orange.1500": {
            contrast: 48.352381967684664,
            lc60: 100,
            lc45: 95.5,
            lc30: 75.5,
            lc10: 52.5
        },
        "orange.1600": {
            contrast: 51.460489800053075,
            lc60: 100,
            lc45: 92,
            lc30: 73,
            lc10: 50.5
        },
        "orange.1700": {
            contrast: 56.25177927596776,
            lc60: 100,
            lc45: 87,
            lc30: 69,
            lc10: 48
        },
        "orange.1800": {
            contrast: 63.03332280701394,
            lc60: 97,
            lc45: 81.5,
            lc30: 64.5,
            lc10: 45
        },
        "orange.1900": {
            contrast: 69.51942763834877,
            lc60: 91,
            lc45: 76.5,
            lc30: 60.5,
            lc10: 42.5
        },
        "orange.2000": {
            contrast: 75.35873133307595,
            lc60: 87,
            lc45: 73,
            lc30: 57.5,
            lc10: 40
        },
        "orange.2100": {
            contrast: 81.56506167439983,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "orange.2200": {
            contrast: 87.73630939720172,
            lc60: 78.5,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "orange.2300": {
            contrast: 94.1572936264026,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "orange.2400": {
            contrast: 100.87823369975094,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "orange.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "orange.200": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 7.715142203439404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 11.789937119914445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 16.334417639759742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "orange.900": {
            contrast: 20.661407845470038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "orange.1000": {
            contrast: 24.872295149027288,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "orange.1100": {
            contrast: 29.279773764521348,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "orange.1200": {
            contrast: 33.87497903753588,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 60.5
        },
        "orange.1300": {
            contrast: 38.84708664033781,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 55.5
        },
        "orange.1400": {
            contrast: 43.14747666485782,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 51.5
        },
        "orange.1500": {
            contrast: 47.99165058946543,
            lc60: 100,
            lc45: 95.5,
            lc30: 74,
            lc10: 48.5
        },
        "orange.1600": {
            contrast: 51.09975842183384,
            lc60: 100,
            lc45: 91.5,
            lc30: 71,
            lc10: 46.5
        },
        "orange.1700": {
            contrast: 55.891047897748535,
            lc60: 100,
            lc45: 86.5,
            lc30: 66.5,
            lc10: 44
        },
        "orange.1800": {
            contrast: 62.672591428794696,
            lc60: 97,
            lc45: 80.5,
            lc30: 62,
            lc10: 40.5
        },
        "orange.1900": {
            contrast: 69.15869626012953,
            lc60: 91,
            lc45: 75.5,
            lc30: 58,
            lc10: 38.5
        },
        "orange.2000": {
            contrast: 74.99799995485672,
            lc60: 86,
            lc45: 71.5,
            lc30: 55.5,
            lc10: 36.5
        },
        "orange.2100": {
            contrast: 81.2043302961806,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 52.5,
            lc10: 35
        },
        "orange.2200": {
            contrast: 87.37557801898251,
            lc60: 78,
            lc45: 64.5,
            lc30: 50,
            lc10: 33
        },
        "orange.2300": {
            contrast: 93.79656224818336,
            lc60: 74,
            lc45: 61.5,
            lc30: 48,
            lc10: 31.5
        },
        "orange.2400": {
            contrast: 100.51750232153171,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 30.5
        },
        "orange.2500": {
            contrast: 107.52400180487925,
            lc60: 68,
            lc45: 56.5,
            lc30: 43.5,
            lc10: 29
        }
    },
    "orange.300": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 10.694082337750405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 15.238562857595703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.900": {
            contrast: 19.565553063305995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "orange.1000": {
            contrast: 23.77644036686325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.1100": {
            contrast: 28.18391898235731,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "orange.1200": {
            contrast: 32.77912425537183,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 58.5
        },
        "orange.1300": {
            contrast: 37.75123185817377,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 53
        },
        "orange.1400": {
            contrast: 42.05162188269378,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 49
        },
        "orange.1500": {
            contrast: 46.89579580730138,
            lc60: 100,
            lc45: 97,
            lc30: 73,
            lc10: 46
        },
        "orange.1600": {
            contrast: 50.0039036396698,
            lc60: 100,
            lc45: 92.5,
            lc30: 69.5,
            lc10: 43.5
        },
        "orange.1700": {
            contrast: 54.79519311558448,
            lc60: 100,
            lc45: 87,
            lc30: 65.5,
            lc10: 41
        },
        "orange.1800": {
            contrast: 61.57673664663066,
            lc60: 98,
            lc45: 80,
            lc30: 60.5,
            lc10: 38.5
        },
        "orange.1900": {
            contrast: 68.06284147796549,
            lc60: 91.5,
            lc45: 74.5,
            lc30: 56.5,
            lc10: 35.5
        },
        "orange.2000": {
            contrast: 73.90214517269268,
            lc60: 86,
            lc45: 71,
            lc30: 53.5,
            lc10: 34
        },
        "orange.2100": {
            contrast: 80.10847551401655,
            lc60: 81.5,
            lc45: 67,
            lc30: 50.5,
            lc10: 32.5
        },
        "orange.2200": {
            contrast: 86.27972323681846,
            lc60: 77.5,
            lc45: 64,
            lc30: 48,
            lc10: 30.5
        },
        "orange.2300": {
            contrast: 92.70070746601932,
            lc60: 74,
            lc45: 61,
            lc30: 46,
            lc10: 29
        },
        "orange.2400": {
            contrast: 99.42164753936765,
            lc60: 70.5,
            lc45: 58,
            lc30: 44,
            lc10: 28
        },
        "orange.2500": {
            contrast: 106.4281470227152,
            lc60: 67,
            lc45: 55.5,
            lc30: 42,
            lc10: 27
        }
    },
    "orange.400": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 8.975066682250308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 13.519547202095605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 17.8465374078059,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "orange.1000": {
            contrast: 22.05742471136315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "orange.1100": {
            contrast: 26.464903326857215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "orange.1200": {
            contrast: 31.06010859987174,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 58
        },
        "orange.1300": {
            contrast: 36.03221620267367,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52
        },
        "orange.1400": {
            contrast: 40.332606227193686,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "orange.1500": {
            contrast: 45.176780151801296,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 44
        },
        "orange.1600": {
            contrast: 48.2848879841697,
            lc60: 100,
            lc45: 94.5,
            lc30: 70,
            lc10: 42
        },
        "orange.1700": {
            contrast: 53.076177460084395,
            lc60: 100,
            lc45: 88.5,
            lc30: 65.5,
            lc10: 39
        },
        "orange.1800": {
            contrast: 59.857720991130556,
            lc60: 100,
            lc45: 81,
            lc30: 60,
            lc10: 36
        },
        "orange.1900": {
            contrast: 66.34382582246539,
            lc60: 92.5,
            lc45: 75.5,
            lc30: 56,
            lc10: 33.5
        },
        "orange.2000": {
            contrast: 72.18312951719258,
            lc60: 87,
            lc45: 70.5,
            lc30: 53,
            lc10: 32
        },
        "orange.2100": {
            contrast: 78.38945985851647,
            lc60: 82,
            lc45: 66.5,
            lc30: 49.5,
            lc10: 30.5
        },
        "orange.2200": {
            contrast: 84.56070758131837,
            lc60: 78,
            lc45: 63.5,
            lc30: 47.5,
            lc10: 29
        },
        "orange.2300": {
            contrast: 90.98169181051924,
            lc60: 74,
            lc45: 60,
            lc30: 45,
            lc10: 27.5
        },
        "orange.2400": {
            contrast: 97.70263188386755,
            lc60: 70.5,
            lc45: 57.5,
            lc30: 43,
            lc10: 26.5
        },
        "orange.2500": {
            contrast: 104.7091313672151,
            lc60: 67,
            lc45: 54.5,
            lc30: 41,
            lc10: 25
        }
    },
    "orange.500": {
        "orange.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 10.867181945079492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 15.194172150789786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.1000": {
            contrast: 19.40505945434704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "orange.1100": {
            contrast: 23.812538069841104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "orange.1200": {
            contrast: 28.40774334285563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.1300": {
            contrast: 33.37985094565756,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 53
        },
        "orange.1400": {
            contrast: 37.68024097017757,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 48
        },
        "orange.1500": {
            contrast: 42.52441489478518,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43.5
        },
        "orange.1600": {
            contrast: 45.63252272715359,
            lc60: 100,
            lc45: 99,
            lc30: 72,
            lc10: 41.5
        },
        "orange.1700": {
            contrast: 50.42381220306829,
            lc60: 100,
            lc45: 91.5,
            lc30: 66.5,
            lc10: 38.5
        },
        "orange.1800": {
            contrast: 57.20535573411445,
            lc60: 100,
            lc45: 83,
            lc30: 60.5,
            lc10: 35.5
        },
        "orange.1900": {
            contrast: 63.69146056544929,
            lc60: 95.5,
            lc45: 76.5,
            lc30: 56,
            lc10: 32.5
        },
        "orange.2000": {
            contrast: 69.53076426017647,
            lc60: 89.5,
            lc45: 72,
            lc30: 52.5,
            lc10: 31
        },
        "orange.2100": {
            contrast: 75.73709460150036,
            lc60: 84,
            lc45: 67.5,
            lc30: 49.5,
            lc10: 29
        },
        "orange.2200": {
            contrast: 81.90834232430225,
            lc60: 79,
            lc45: 64,
            lc30: 46.5,
            lc10: 28
        },
        "orange.2300": {
            contrast: 88.32932655350312,
            lc60: 75,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26.5
        },
        "orange.2400": {
            contrast: 95.05026662685144,
            lc60: 71,
            lc45: 57.5,
            lc30: 42,
            lc10: 25
        },
        "orange.2500": {
            contrast: 102.05676611019898,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 24
        }
    },
    "orange.600": {
        "orange.100": {
            contrast: 9.40216725946286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 8.91807859056306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 7.480036832289944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 11.607236284541017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 15.81812358809827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "orange.1100": {
            contrast: 20.225602203592334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "orange.1200": {
            contrast: 24.820807476606863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "orange.1300": {
            contrast: 29.79291507940879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "orange.1400": {
            contrast: 34.0933051039288,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "orange.1500": {
            contrast: 38.93747902853641,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 45.5
        },
        "orange.1600": {
            contrast: 42.04558686090482,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43
        },
        "orange.1700": {
            contrast: 46.83687633681951,
            lc60: 100,
            lc45: 97,
            lc30: 69.5,
            lc10: 39.5
        },
        "orange.1800": {
            contrast: 53.61841986786568,
            lc60: 100,
            lc45: 87,
            lc30: 63,
            lc10: 35.5
        },
        "orange.1900": {
            contrast: 60.104524699200525,
            lc60: 99.5,
            lc45: 79.5,
            lc30: 58,
            lc10: 33
        },
        "orange.2000": {
            contrast: 65.9438283939277,
            lc60: 93,
            lc45: 74.5,
            lc30: 54.5,
            lc10: 31
        },
        "orange.2100": {
            contrast: 72.15015873525158,
            lc60: 87,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "orange.2200": {
            contrast: 78.32140645805349,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 48,
            lc10: 27.5
        },
        "orange.2300": {
            contrast: 84.74239068725434,
            lc60: 77,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "orange.2400": {
            contrast: 91.46333076060267,
            lc60: 72.5,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 25
        },
        "orange.2500": {
            contrast: 98.46983024395021,
            lc60: 69,
            lc45: 55.5,
            lc30: 40.5,
            lc10: 24
        }
    },
    "orange.700": {
        "orange.100": {
            contrast: 13.848021976937272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.200": {
            contrast: 13.36393330803747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.300": {
            contrast: 11.925891549764355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.400": {
            contrast: 9.746669911529459,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 7.720286682838301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 11.931173986395551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 16.338652601889617,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.1200": {
            contrast: 20.933857874904145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "orange.1300": {
            contrast: 25.90596547770608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "orange.1400": {
            contrast: 30.206355502226078,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55.5
        },
        "orange.1500": {
            contrast: 35.05052942683369,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49
        },
        "orange.1600": {
            contrast: 38.1586372592021,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 45
        },
        "orange.1700": {
            contrast: 42.94992673511679,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41
        },
        "orange.1800": {
            contrast: 49.73147026616297,
            lc60: 100,
            lc45: 92,
            lc30: 66.5,
            lc10: 37
        },
        "orange.1900": {
            contrast: 56.21757509749779,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 34
        },
        "orange.2000": {
            contrast: 62.05687879222498,
            lc60: 97,
            lc45: 77.5,
            lc30: 56,
            lc10: 31.5
        },
        "orange.2100": {
            contrast: 68.26320913354887,
            lc60: 90,
            lc45: 72,
            lc30: 52,
            lc10: 29.5
        },
        "orange.2200": {
            contrast: 74.43445685635076,
            lc60: 84.5,
            lc45: 68,
            lc30: 49,
            lc10: 28
        },
        "orange.2300": {
            contrast: 80.85544108555163,
            lc60: 79.5,
            lc45: 63.5,
            lc30: 46,
            lc10: 26.5
        },
        "orange.2400": {
            contrast: 87.57638115889995,
            lc60: 75,
            lc45: 60,
            lc30: 43.5,
            lc10: 25
        },
        "orange.2500": {
            contrast: 94.58288064224749,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 23.5
        }
    },
    "orange.800": {
        "orange.100": {
            contrast: 18.6942981939604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "orange.200": {
            contrast: 18.2102095250606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "orange.300": {
            contrast: 16.772167766787483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "orange.400": {
            contrast: 14.592946128552587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.500": {
            contrast: 11.361155857855568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 7.546388186112997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 11.953866801607063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 16.549072074621588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "orange.1300": {
            contrast: 21.521179677423522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.1400": {
            contrast: 25.82156970194353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "orange.1500": {
            contrast: 30.665743626551134,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 54
        },
        "orange.1600": {
            contrast: 33.77385145891955,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 49.5
        },
        "orange.1700": {
            contrast: 38.56514093483424,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "orange.1800": {
            contrast: 45.34668446588041,
            lc60: 100,
            lc45: 99,
            lc30: 70.5,
            lc10: 39.5
        },
        "orange.1900": {
            contrast: 51.83278929721526,
            lc60: 100,
            lc45: 89,
            lc30: 63.5,
            lc10: 35.5
        },
        "orange.2000": {
            contrast: 57.67209299194243,
            lc60: 100,
            lc45: 81.5,
            lc30: 58.5,
            lc10: 33
        },
        "orange.2100": {
            contrast: 63.87842333326632,
            lc60: 95,
            lc45: 75.5,
            lc30: 54,
            lc10: 31
        },
        "orange.2200": {
            contrast: 70.04967105606819,
            lc60: 88,
            lc45: 70.5,
            lc30: 50.5,
            lc10: 29
        },
        "orange.2300": {
            contrast: 76.47065528526909,
            lc60: 82.5,
            lc45: 66,
            lc30: 48,
            lc10: 27.5
        },
        "orange.2400": {
            contrast: 83.1915953586174,
            lc60: 77.5,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "orange.2500": {
            contrast: 90.19809484196493,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24
        }
    },
    "orange.900": {
        "orange.100": {
            contrast: 23.221759058276245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "orange.200": {
            contrast: 22.737670389376444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "orange.300": {
            contrast: 21.299628631103328,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "orange.400": {
            contrast: 19.120406992868435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "orange.500": {
            contrast: 15.888616722171417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "orange.600": {
            contrast: 11.693349759077847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.700": {
            contrast: 7.308395465159122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 7.739084179235942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 12.334289452250468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 17.3063970550524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "orange.1400": {
            contrast: 21.606787079572413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.1500": {
            contrast: 26.45096100418002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "orange.1600": {
            contrast: 29.55906883654843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "orange.1700": {
            contrast: 34.35035831246312,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 48.5
        },
        "orange.1800": {
            contrast: 41.1319018435093,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        },
        "orange.1900": {
            contrast: 47.618006674844125,
            lc60: 100,
            lc45: 95.5,
            lc30: 68,
            lc10: 38
        },
        "orange.2000": {
            contrast: 53.45731036957131,
            lc60: 100,
            lc45: 86.5,
            lc30: 62,
            lc10: 34.5
        },
        "orange.2100": {
            contrast: 59.663640710895194,
            lc60: 100,
            lc45: 79.5,
            lc30: 57.5,
            lc10: 32
        },
        "orange.2200": {
            contrast: 65.83488843369709,
            lc60: 92.5,
            lc45: 73.5,
            lc30: 53,
            lc10: 30
        },
        "orange.2300": {
            contrast: 72.25587266289796,
            lc60: 86,
            lc45: 69,
            lc30: 49.5,
            lc10: 28
        },
        "orange.2400": {
            contrast: 78.97681273624629,
            lc60: 80.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 26.5
        },
        "orange.2500": {
            contrast: 85.98331221959381,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 25
        }
    },
    "orange.1000": {
        "orange.100": {
            contrast: 27.560785244775293,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "orange.200": {
            contrast: 27.0766965758755,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "orange.300": {
            contrast: 25.63865481760238,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "orange.400": {
            contrast: 23.459433179367487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.500": {
            contrast: 20.22764290867047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.600": {
            contrast: 16.0323759455769,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.700": {
            contrast: 11.647421651658174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 8.201086127649619,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 13.173193730451551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 17.473583754971564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "orange.1500": {
            contrast: 22.317757679579167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "orange.1600": {
            contrast: 25.42586551194758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "orange.1700": {
            contrast: 30.217154987862273,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "orange.1800": {
            contrast: 36.99869851890844,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 45.5
        },
        "orange.1900": {
            contrast: 43.484803350243276,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        },
        "orange.2000": {
            contrast: 49.32410704497047,
            lc60: 100,
            lc45: 93,
            lc30: 66.5,
            lc10: 37
        },
        "orange.2100": {
            contrast: 55.53043738629434,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 33.5
        },
        "orange.2200": {
            contrast: 61.70168510909624,
            lc60: 98,
            lc45: 77.5,
            lc30: 56,
            lc10: 31
        },
        "orange.2300": {
            contrast: 68.12266933829711,
            lc60: 90,
            lc45: 72,
            lc30: 52,
            lc10: 29
        },
        "orange.2400": {
            contrast: 74.84360941164545,
            lc60: 84,
            lc45: 67.5,
            lc30: 48.5,
            lc10: 27
        },
        "orange.2500": {
            contrast: 81.85010889499297,
            lc60: 78.5,
            lc45: 63,
            lc30: 45,
            lc10: 25.5
        }
    },
    "orange.1100": {
        "orange.100": {
            contrast: 32.04229998359682,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 33.5
        },
        "orange.200": {
            contrast: 31.558211314697026,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 38.5
        },
        "orange.300": {
            contrast: 30.12016955642391,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 44
        },
        "orange.400": {
            contrast: 27.940947918189014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "orange.500": {
            contrast: 24.709157647492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.600": {
            contrast: 20.51389068439843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.700": {
            contrast: 16.128936390479705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.800": {
            contrast: 11.330800215403771,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 8.818125736199514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 13.118515760719527,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 17.96268968532713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "orange.1600": {
            contrast: 21.070797517695546,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "orange.1700": {
            contrast: 25.862086993610234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "orange.1800": {
            contrast: 32.64363052465641,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "orange.1900": {
            contrast: 39.129735355991244,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "orange.2000": {
            contrast: 44.96903905071842,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 40
        },
        "orange.2100": {
            contrast: 51.1753693920423,
            lc60: 100,
            lc45: 89.5,
            lc30: 64.5,
            lc10: 36
        },
        "orange.2200": {
            contrast: 57.3466171148442,
            lc60: 100,
            lc45: 82,
            lc30: 59,
            lc10: 33
        },
        "orange.2300": {
            contrast: 63.767601344045076,
            lc60: 95,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        },
        "orange.2400": {
            contrast: 70.4885414173934,
            lc60: 87.5,
            lc45: 70,
            lc30: 50.5,
            lc10: 28.5
        },
        "orange.2500": {
            contrast: 77.49504090074093,
            lc60: 82,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 27
        }
    },
    "orange.1200": {
        "orange.100": {
            contrast: 36.658061044497195,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 29.5
        },
        "orange.200": {
            contrast: 36.173972375597394,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "orange.300": {
            contrast: 34.73593061732427,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 37.5
        },
        "orange.400": {
            contrast: 32.556708979089386,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 43
        },
        "orange.500": {
            contrast: 29.324918708392367,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "orange.600": {
            contrast: 25.129651745298798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "orange.700": {
            contrast: 20.744697451380073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "orange.800": {
            contrast: 15.946561276304141,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "orange.900": {
            contrast: 11.449845736086095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 8.550186396090345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 13.39436032069795,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 16.502468153066363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "orange.1700": {
            contrast: 21.29375762898105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.1800": {
            contrast: 28.075301160027223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "orange.1900": {
            contrast: 34.56140599136206,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 48.5
        },
        "orange.2000": {
            contrast: 40.40070968608924,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 43.5
        },
        "orange.2100": {
            contrast: 46.60704002741312,
            lc60: 100,
            lc45: 97,
            lc30: 69.5,
            lc10: 39
        },
        "orange.2200": {
            contrast: 52.778287750215014,
            lc60: 100,
            lc45: 87.5,
            lc30: 63.5,
            lc10: 35
        },
        "orange.2300": {
            contrast: 59.19927197941588,
            lc60: 100,
            lc45: 80.5,
            lc30: 58,
            lc10: 32.5
        },
        "orange.2400": {
            contrast: 65.92021205276423,
            lc60: 92.5,
            lc45: 74,
            lc30: 53.5,
            lc10: 30
        },
        "orange.2500": {
            contrast: 72.92671153611175,
            lc60: 86,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        }
    },
    "orange.1300": {
        "orange.100": {
            contrast: 41.595480885569195,
            lc60: 100,
            lc45: 100,
            lc30: 53.5,
            lc10: 26.5
        },
        "orange.200": {
            contrast: 41.1113922166694,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "orange.300": {
            contrast: 39.67335045839628,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33
        },
        "orange.400": {
            contrast: 37.494128820161386,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37
        },
        "orange.500": {
            contrast: 34.26233854946437,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 42
        },
        "orange.600": {
            contrast: 30.067071586370798,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 49.5
        },
        "orange.700": {
            contrast: 25.682117292452073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "orange.800": {
            contrast: 20.883981117376145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "orange.900": {
            contrast: 16.3872655771581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "orange.1000": {
            contrast: 12.066690481342974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1100": {
            contrast: 7.5943155506857245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 8.422919200436333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 11.531027032804747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 16.322316508719435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "orange.1800": {
            contrast: 23.103860039765607,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "orange.1900": {
            contrast: 29.589964871100445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "orange.2000": {
            contrast: 35.42926856582763,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48.5
        },
        "orange.2100": {
            contrast: 41.635598907151504,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42.5
        },
        "orange.2200": {
            contrast: 47.806846629953405,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 38.5
        },
        "orange.2300": {
            contrast: 54.22783085915427,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 35.5
        },
        "orange.2400": {
            contrast: 60.9487709325026,
            lc60: 98.5,
            lc45: 79,
            lc30: 57.5,
            lc10: 32
        },
        "orange.2500": {
            contrast: 67.95527041585014,
            lc60: 91,
            lc45: 73,
            lc30: 52.5,
            lc10: 30
        }
    },
    "orange.1400": {
        "orange.100": {
            contrast: 45.8235125665224,
            lc60: 100,
            lc45: 87,
            lc30: 49,
            lc10: 24.5
        },
        "orange.200": {
            contrast: 45.3394238976226,
            lc60: 100,
            lc45: 96.5,
            lc30: 54,
            lc10: 27
        },
        "orange.300": {
            contrast: 43.90138213934948,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "orange.400": {
            contrast: 41.722160501114594,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "orange.500": {
            contrast: 38.490370230417575,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "orange.600": {
            contrast: 34.29510326732401,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 43
        },
        "orange.700": {
            contrast: 29.91014897340528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "orange.800": {
            contrast: 25.112012798329346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "orange.900": {
            contrast: 20.615297258111305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "orange.1000": {
            contrast: 16.29472216229618,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "orange.1100": {
            contrast: 11.822347231638933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 12.001025319733266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 18.78256885077944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "orange.1900": {
            contrast: 25.268673682114272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "orange.2000": {
            contrast: 31.107977376841454,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 55.5
        },
        "orange.2100": {
            contrast: 37.31430771816534,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 48
        },
        "orange.2200": {
            contrast: 43.48555544096723,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "orange.2300": {
            contrast: 49.9065396701681,
            lc60: 100,
            lc45: 92,
            lc30: 67,
            lc10: 38.5
        },
        "orange.2400": {
            contrast: 56.62747974351643,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 34.5
        },
        "orange.2500": {
            contrast: 63.63397922686396,
            lc60: 95,
            lc45: 76.5,
            lc30: 55.5,
            lc10: 32
        }
    },
    "orange.1500": {
        "orange.100": {
            contrast: 50.543994820474026,
            lc60: 100,
            lc45: 71.5,
            lc30: 44,
            lc10: 22
        },
        "orange.200": {
            contrast: 50.05990615157423,
            lc60: 100,
            lc45: 78.5,
            lc30: 48.5,
            lc10: 25
        },
        "orange.300": {
            contrast: 48.62186439330111,
            lc60: 100,
            lc45: 86,
            lc30: 53.5,
            lc10: 27
        },
        "orange.400": {
            contrast: 46.44264275506621,
            lc60: 100,
            lc45: 94.5,
            lc30: 59,
            lc10: 29.5
        },
        "orange.500": {
            contrast: 43.21085248436919,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "orange.600": {
            contrast: 39.015585521275625,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "orange.700": {
            contrast: 34.63063122735689,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "orange.800": {
            contrast: 29.832495052280965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "orange.900": {
            contrast: 25.335779512062924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "orange.1000": {
            contrast: 21.015204416247798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "orange.1100": {
            contrast: 16.54282948559055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "orange.1200": {
            contrast: 11.927109442285428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 13.893148848240292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 20.37925367957513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "orange.2000": {
            contrast: 26.21855737430231,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "orange.2100": {
            contrast: 32.42488771562619,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 54.5
        },
        "orange.2200": {
            contrast: 38.596135438428085,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47
        },
        "orange.2300": {
            contrast: 45.01711966762896,
            lc60: 100,
            lc45: 99.5,
            lc30: 73,
            lc10: 41.5
        },
        "orange.2400": {
            contrast: 51.738059740977285,
            lc60: 100,
            lc45: 89.5,
            lc30: 66,
            lc10: 38
        },
        "orange.2500": {
            contrast: 58.7445592243248,
            lc60: 100,
            lc45: 82,
            lc30: 60,
            lc10: 34.5
        }
    },
    "orange.1600": {
        "orange.100": {
            contrast: 53.5511639894776,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "orange.200": {
            contrast: 53.06707532057781,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23
        },
        "orange.300": {
            contrast: 51.629033562304684,
            lc60: 100,
            lc45: 79,
            lc30: 50,
            lc10: 25
        },
        "orange.400": {
            contrast: 49.4498119240698,
            lc60: 100,
            lc45: 86.5,
            lc30: 55,
            lc10: 27.5
        },
        "orange.500": {
            contrast: 46.21802165337278,
            lc60: 100,
            lc45: 96.5,
            lc30: 61,
            lc10: 30.5
        },
        "orange.600": {
            contrast: 42.02275469027921,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "orange.700": {
            contrast: 37.63780039636048,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 39
        },
        "orange.800": {
            contrast: 32.83966422128455,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45.5
        },
        "orange.900": {
            contrast: 28.342948681066503,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "orange.1000": {
            contrast: 24.022373585251387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "orange.1100": {
            contrast: 19.549998654594138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "orange.1200": {
            contrast: 14.934278611289015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1300": {
            contrast: 9.987459438422675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 10.744781397262864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 17.230886228597704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "orange.2000": {
            contrast: 23.070189923324882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "orange.2100": {
            contrast: 29.27652026464876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "orange.2200": {
            contrast: 35.44776798745065,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49.5
        },
        "orange.2300": {
            contrast: 41.86875221665153,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44.5
        },
        "orange.2400": {
            contrast: 48.58969228999985,
            lc60: 100,
            lc45: 94,
            lc30: 68.5,
            lc10: 39.5
        },
        "orange.2500": {
            contrast: 55.59619177334738,
            lc60: 100,
            lc45: 84.5,
            lc30: 61.5,
            lc10: 35.5
        }
    },
    "orange.1700": {
        "orange.100": {
            contrast: 58.156456295737414,
            lc60: 100,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "orange.200": {
            contrast: 57.6723676268376,
            lc60: 100,
            lc45: 65.5,
            lc30: 42,
            lc10: 21.5
        },
        "orange.300": {
            contrast: 56.23432586856448,
            lc60: 100,
            lc45: 71.5,
            lc30: 46,
            lc10: 23
        },
        "orange.400": {
            contrast: 54.05510423032959,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 25
        },
        "orange.500": {
            contrast: 50.82331395963258,
            lc60: 100,
            lc45: 85.5,
            lc30: 55,
            lc10: 27.5
        },
        "orange.600": {
            contrast: 46.628046996539005,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 31
        },
        "orange.700": {
            contrast: 42.243092702620274,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "orange.800": {
            contrast: 37.44495652754435,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 40
        },
        "orange.900": {
            contrast: 32.94824098732631,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 45.5
        },
        "orange.1000": {
            contrast: 28.627665891511178,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "orange.1100": {
            contrast: 24.155290960853932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "orange.1200": {
            contrast: 19.539570917548808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "orange.1300": {
            contrast: 14.59275174468247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1400": {
            contrast: 10.349626413494454,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 12.361539916228232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 18.200843610955413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "orange.2100": {
            contrast: 24.40717395227929,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "orange.2200": {
            contrast: 30.578421675081184,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 56
        },
        "orange.2300": {
            contrast: 36.99940590428206,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 48
        },
        "orange.2400": {
            contrast: 43.72034597763038,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42
        },
        "orange.2500": {
            contrast: 50.72684546097791,
            lc60: 100,
            lc45: 90.5,
            lc30: 65.5,
            lc10: 37
        }
    },
    "orange.1800": {
        "orange.100": {
            contrast: 64.61701752335,
            lc60: 77.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "orange.200": {
            contrast: 64.13292885445018,
            lc60: 84,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "orange.300": {
            contrast: 62.69488709617708,
            lc60: 90.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "orange.400": {
            contrast: 60.51566545794218,
            lc60: 98,
            lc45: 67.5,
            lc30: 44,
            lc10: 22
        },
        "orange.500": {
            contrast: 57.28387518724516,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24.5
        },
        "orange.600": {
            contrast: 53.08860822415159,
            lc60: 100,
            lc45: 82,
            lc30: 52.5,
            lc10: 26.5
        },
        "orange.700": {
            contrast: 48.70365393023287,
            lc60: 100,
            lc45: 90.5,
            lc30: 58.5,
            lc10: 29.5
        },
        "orange.800": {
            contrast: 43.90551775515694,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "orange.900": {
            contrast: 39.408802214938895,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "orange.1000": {
            contrast: 35.088227119123765,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "orange.1100": {
            contrast: 30.61585218846652,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 49
        },
        "orange.1200": {
            contrast: 26.0001321451614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "orange.1300": {
            contrast: 21.05331297229506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "orange.1400": {
            contrast: 16.810187641107042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "orange.1500": {
            contrast: 12.065824282347354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1600": {
            contrast: 9.03983739201478,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 11.278089649106912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 17.48441999043079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "orange.2200": {
            contrast: 23.65566771323269,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "orange.2300": {
            contrast: 30.076651942433557,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55.5
        },
        "orange.2400": {
            contrast: 36.79759201578188,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 47
        },
        "orange.2500": {
            contrast: 43.80409149912941,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40.5
        }
    },
    "orange.1900": {
        "orange.100": {
            contrast: 70.73884640056399,
            lc60: 68.5,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "orange.200": {
            contrast: 70.25475773166417,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "orange.300": {
            contrast: 68.81671597339107,
            lc60: 79,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "orange.400": {
            contrast: 66.63749433515616,
            lc60: 85,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "orange.500": {
            contrast: 63.405704064459144,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "orange.600": {
            contrast: 59.21043710136558,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "orange.700": {
            contrast: 54.82548280744686,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "orange.800": {
            contrast: 50.02734663237093,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 29
        },
        "orange.900": {
            contrast: 45.53063109215288,
            lc60: 100,
            lc45: 98.5,
            lc30: 63.5,
            lc10: 32.5
        },
        "orange.1000": {
            contrast: 41.21005599633775,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35.5
        },
        "orange.1100": {
            contrast: 36.737681065680505,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "orange.1200": {
            contrast: 32.12196102237538,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46
        },
        "orange.1300": {
            contrast: 27.175141849509043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "orange.1400": {
            contrast: 22.932016518321028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "orange.1500": {
            contrast: 18.187653159561336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "orange.1600": {
            contrast: 15.161666269228766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "orange.1700": {
            contrast: 10.522472949582998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 10.83235919288982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 17.00360691569172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "orange.2300": {
            contrast: 23.424591144892588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "orange.2400": {
            contrast: 30.14553121824091,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "orange.2500": {
            contrast: 37.152030701588444,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46
        }
    },
    "orange.2000": {
        "orange.100": {
            contrast: 76.20673619493331,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "orange.200": {
            contrast: 75.7226475260335,
            lc60: 67,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "orange.300": {
            contrast: 74.28460576776038,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "orange.400": {
            contrast: 72.10538412952549,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "orange.500": {
            contrast: 68.87359385882847,
            lc60: 83,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "orange.600": {
            contrast: 64.67832689573491,
            lc60: 90.5,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "orange.700": {
            contrast: 60.29337260181619,
            lc60: 99.5,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "orange.800": {
            contrast: 55.495236426740256,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "orange.900": {
            contrast: 50.9985208865222,
            lc60: 100,
            lc45: 85.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "orange.1000": {
            contrast: 46.677945790707085,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 31
        },
        "orange.1100": {
            contrast: 42.20557086004983,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 35
        },
        "orange.1200": {
            contrast: 37.58985081674471,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 39
        },
        "orange.1300": {
            contrast: 32.643031643878366,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 44.5
        },
        "orange.1400": {
            contrast: 28.399906312690355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "orange.1500": {
            contrast: 23.655542953930667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "orange.1600": {
            contrast: 20.62955606359809,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "orange.1700": {
            contrast: 15.990362743952327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "orange.1800": {
            contrast: 9.4725892241505,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 10.991146131891913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 17.412130361092785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "orange.2400": {
            contrast: 24.13307043444111,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "orange.2500": {
            contrast: 31.139569917788634,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53.5
        }
    },
    "orange.2100": {
        "orange.100": {
            contrast: 81.97690489555734,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "orange.200": {
            contrast: 81.49281622665752,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15.5
        },
        "orange.300": {
            contrast: 80.05477446838441,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "orange.400": {
            contrast: 77.87555283014952,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "orange.500": {
            contrast: 74.6437625594525,
            lc60: 75,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "orange.600": {
            contrast: 70.44849559635892,
            lc60: 81,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "orange.700": {
            contrast: 66.06354130244021,
            lc60: 88,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "orange.800": {
            contrast: 61.26540512736428,
            lc60: 97,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "orange.900": {
            contrast: 56.768689587146234,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25.5
        },
        "orange.1000": {
            contrast: 52.44811449133111,
            lc60: 100,
            lc45: 82.5,
            lc30: 53.5,
            lc10: 27
        },
        "orange.1100": {
            contrast: 47.97573956067386,
            lc60: 100,
            lc45: 92.5,
            lc30: 58.5,
            lc10: 30
        },
        "orange.1200": {
            contrast: 43.360019517368734,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "orange.1300": {
            contrast: 38.4132003445024,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37
        },
        "orange.1400": {
            contrast: 34.17007501331438,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 41.5
        },
        "orange.1500": {
            contrast: 29.425711654554693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "orange.1600": {
            contrast: 26.399724764222114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "orange.1700": {
            contrast: 21.760531444576355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "orange.1800": {
            contrast: 15.242757924774525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.1900": {
            contrast: 9.057122145442587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 10.998874050400298,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 17.719814123748623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "orange.2500": {
            contrast: 24.726313607096152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        }
    },
    "orange.2200": {
        "orange.100": {
            contrast: 87.67535943583144,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "orange.200": {
            contrast: 87.19127076693162,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "orange.300": {
            contrast: 85.75322900865852,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "orange.400": {
            contrast: 83.57400737042362,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "orange.500": {
            contrast: 80.3422170997266,
            lc60: 68.5,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "orange.600": {
            contrast: 76.14695013663304,
            lc60: 73.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "orange.700": {
            contrast: 71.76199584271431,
            lc60: 79.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "orange.800": {
            contrast: 66.96385966763839,
            lc60: 86.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "orange.900": {
            contrast: 62.46714412742034,
            lc60: 94.5,
            lc45: 67.5,
            lc30: 44,
            lc10: 22.5
        },
        "orange.1000": {
            contrast: 58.146569031605225,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 24.5
        },
        "orange.1100": {
            contrast: 53.67419410094796,
            lc60: 100,
            lc45: 80.5,
            lc30: 51.5,
            lc10: 26
        },
        "orange.1200": {
            contrast: 49.05847405764284,
            lc60: 100,
            lc45: 89.5,
            lc30: 57,
            lc10: 28.5
        },
        "orange.1300": {
            contrast: 44.1116548847765,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "orange.1400": {
            contrast: 39.86852955358848,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35.5
        },
        "orange.1500": {
            contrast: 35.124166194828796,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40
        },
        "orange.1600": {
            contrast: 32.09817930449622,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 44.5
        },
        "orange.1700": {
            contrast: 27.458985984850454,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "orange.1800": {
            contrast: 20.94121246504863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "orange.1900": {
            contrast: 14.75557668571669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2000": {
            contrast: 9.223399781665726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 11.32097266867248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 18.32747215202001,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        }
    },
    "orange.2300": {
        "orange.100": {
            contrast: 93.56605443752673,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "orange.200": {
            contrast: 93.08196576862692,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "orange.300": {
            contrast: 91.6439240103538,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "orange.400": {
            contrast: 89.46470237211891,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "orange.500": {
            contrast: 86.23291210142189,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "orange.600": {
            contrast: 82.03764513832833,
            lc60: 67,
            lc45: 49,
            lc30: 32,
            lc10: 17
        },
        "orange.700": {
            contrast: 77.6526908444096,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "orange.800": {
            contrast: 72.85455466933367,
            lc60: 77.5,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "orange.900": {
            contrast: 68.35783912911562,
            lc60: 84,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "orange.1000": {
            contrast: 64.03726403330049,
            lc60: 91.5,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "orange.1100": {
            contrast: 59.56488910264325,
            lc60: 100,
            lc45: 70.5,
            lc30: 46,
            lc10: 23.5
        },
        "orange.1200": {
            contrast: 54.94916905933812,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25.5
        },
        "orange.1300": {
            contrast: 50.002349886471784,
            lc60: 100,
            lc45: 87.5,
            lc30: 55,
            lc10: 28
        },
        "orange.1400": {
            contrast: 45.75922455528377,
            lc60: 100,
            lc45: 97.5,
            lc30: 60.5,
            lc10: 30.5
        },
        "orange.1500": {
            contrast: 41.01486119652408,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33.5
        },
        "orange.1600": {
            contrast: 37.98887430619151,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37
        },
        "orange.1700": {
            contrast: 33.34968098654574,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 43.5
        },
        "orange.1800": {
            contrast: 26.831907466743914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "orange.1900": {
            contrast: 20.64627168741198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "orange.2000": {
            contrast: 15.114094783361018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.2100": {
            contrast: 9.269124175155836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 11.648040216374653,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "orange.2400": {
        "orange.100": {
            contrast: 99.69296490513103,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "orange.200": {
            contrast: 99.20887623623122,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "orange.300": {
            contrast: 97.7708344779581,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "orange.400": {
            contrast: 95.59161283972321,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "orange.500": {
            contrast: 92.35982256902619,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "orange.600": {
            contrast: 88.16455560593262,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 30,
            lc10: 15.5
        },
        "orange.700": {
            contrast: 83.77960131201391,
            lc60: 65.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16.5
        },
        "orange.800": {
            contrast: 78.98146513693798,
            lc60: 70.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "orange.900": {
            contrast: 74.48474959671992,
            lc60: 75.5,
            lc45: 55,
            lc30: 36,
            lc10: 19
        },
        "orange.1000": {
            contrast: 70.16417450090479,
            lc60: 81.5,
            lc45: 58.5,
            lc30: 38.5,
            lc10: 20
        },
        "orange.1100": {
            contrast: 65.69179957024754,
            lc60: 88.5,
            lc45: 63,
            lc30: 41,
            lc10: 21.5
        },
        "orange.1200": {
            contrast: 61.07607952694243,
            lc60: 97.5,
            lc45: 68,
            lc30: 44.5,
            lc10: 22.5
        },
        "orange.1300": {
            contrast: 56.129260354076095,
            lc60: 100,
            lc45: 75.5,
            lc30: 48,
            lc10: 25
        },
        "orange.1400": {
            contrast: 51.886135022888084,
            lc60: 100,
            lc45: 82.5,
            lc30: 52,
            lc10: 27
        },
        "orange.1500": {
            contrast: 47.141771664128385,
            lc60: 100,
            lc45: 93.5,
            lc30: 57.5,
            lc10: 29
        },
        "orange.1600": {
            contrast: 44.115784773795816,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31
        },
        "orange.1700": {
            contrast: 39.476591454150046,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 36
        },
        "orange.1800": {
            contrast: 32.95881793434822,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 44.5
        },
        "orange.1900": {
            contrast: 26.77318215501628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "orange.2000": {
            contrast: 21.241005250965316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "orange.2100": {
            contrast: 15.396034642760137,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "orange.2200": {
            contrast: 9.617125771345696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "orange.2500": {
        "orange.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "orange.200": {
            contrast: 105.5565845437888,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "orange.300": {
            contrast: 104.11854278551569,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "orange.400": {
            contrast: 101.9393211472808,
            lc60: 50.5,
            lc45: 37,
            lc30: 25,
            lc10: 13
        },
        "orange.500": {
            contrast: 98.70753087658376,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "orange.600": {
            contrast: 94.51226391349019,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "orange.700": {
            contrast: 90.12730961957148,
            lc60: 60,
            lc45: 44,
            lc30: 29.5,
            lc10: 15.5
        },
        "orange.800": {
            contrast: 85.32917344449554,
            lc60: 64,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "orange.900": {
            contrast: 80.83245790427749,
            lc60: 68.5,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "orange.1000": {
            contrast: 76.51188280846236,
            lc60: 72.5,
            lc45: 52.5,
            lc30: 35,
            lc10: 18.5
        },
        "orange.1100": {
            contrast: 72.03950787780511,
            lc60: 78.5,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "orange.1200": {
            contrast: 67.42378783449999,
            lc60: 85,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "orange.1300": {
            contrast: 62.476968661633656,
            lc60: 94,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 22
        },
        "orange.1400": {
            contrast: 58.233843330445644,
            lc60: 100,
            lc45: 71.5,
            lc30: 46,
            lc10: 23.5
        },
        "orange.1500": {
            contrast: 53.48947997168595,
            lc60: 100,
            lc45: 79,
            lc30: 50,
            lc10: 25.5
        },
        "orange.1600": {
            contrast: 50.46349308135337,
            lc60: 100,
            lc45: 85.5,
            lc30: 53.5,
            lc10: 27
        },
        "orange.1700": {
            contrast: 45.82429976170761,
            lc60: 100,
            lc45: 97.5,
            lc30: 61.5,
            lc10: 31
        },
        "orange.1800": {
            contrast: 39.306526241905786,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37.5
        },
        "orange.1900": {
            contrast: 33.12089046257384,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 45.5
        },
        "orange.2000": {
            contrast: 27.588713558522883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "orange.2100": {
            contrast: 21.743742950317703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "orange.2200": {
            contrast: 15.964834078903262,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "orange.2300": {
            contrast: 9.984503886760745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "orange.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$pink = {
    "pink.100": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 8.52191564180787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 12.407266976937958,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 16.80924616780218,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "pink.900": {
            contrast: 21.060860930907968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1000": {
            contrast: 24.823143439913068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "pink.1100": {
            contrast: 30.736866618948493,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 68.5
        },
        "pink.1200": {
            contrast: 33.18894431585209,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 65.5
        },
        "pink.1300": {
            contrast: 37.588924368545065,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 61
        },
        "pink.1400": {
            contrast: 41.86581670425226,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 57
        },
        "pink.1500": {
            contrast: 46.41426197242764,
            lc60: 100,
            lc45: 98,
            lc30: 77.5,
            lc10: 54
        },
        "pink.1600": {
            contrast: 51.24201123803706,
            lc60: 100,
            lc45: 92.5,
            lc30: 73,
            lc10: 51
        },
        "pink.1700": {
            contrast: 56.75804881315566,
            lc60: 100,
            lc45: 87,
            lc30: 68.5,
            lc10: 48
        },
        "pink.1800": {
            contrast: 62.366992621062245,
            lc60: 97.5,
            lc45: 82,
            lc30: 64.5,
            lc10: 45
        },
        "pink.1900": {
            contrast: 68.41485420594044,
            lc60: 92,
            lc45: 77.5,
            lc30: 61,
            lc10: 42.5
        },
        "pink.2000": {
            contrast: 74.34377672926571,
            lc60: 87.5,
            lc45: 73.5,
            lc30: 58,
            lc10: 40.5
        },
        "pink.2100": {
            contrast: 80.72355771413858,
            lc60: 83,
            lc45: 70,
            lc30: 55,
            lc10: 38.5
        },
        "pink.2200": {
            contrast: 87.11282503205602,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "pink.2300": {
            contrast: 93.85322876797147,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "pink.2400": {
            contrast: 100.92578873905642,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "pink.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "pink.200": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 8.169627483251848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 12.054978818381933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 16.456958009246158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "pink.900": {
            contrast: 20.70857277235195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "pink.1000": {
            contrast: 24.470855281357043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "pink.1100": {
            contrast: 30.38457846039247,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 65
        },
        "pink.1200": {
            contrast: 32.83665615729607,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 62
        },
        "pink.1300": {
            contrast: 37.236636209989044,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 57
        },
        "pink.1400": {
            contrast: 41.51352854569624,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 53.5
        },
        "pink.1500": {
            contrast: 46.06197381387162,
            lc60: 100,
            lc45: 98,
            lc30: 75.5,
            lc10: 49.5
        },
        "pink.1600": {
            contrast: 50.88972307948102,
            lc60: 100,
            lc45: 92,
            lc30: 71,
            lc10: 46.5
        },
        "pink.1700": {
            contrast: 56.405760654599646,
            lc60: 100,
            lc45: 86,
            lc30: 66.5,
            lc10: 44
        },
        "pink.1800": {
            contrast: 62.014704462506224,
            lc60: 98,
            lc45: 81,
            lc30: 62.5,
            lc10: 41
        },
        "pink.1900": {
            contrast: 68.06256604738444,
            lc60: 92,
            lc45: 76,
            lc30: 59,
            lc10: 39
        },
        "pink.2000": {
            contrast: 73.99148857070969,
            lc60: 87,
            lc45: 72,
            lc30: 56,
            lc10: 37
        },
        "pink.2100": {
            contrast: 80.37126955558256,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "pink.2200": {
            contrast: 86.76053687350002,
            lc60: 78,
            lc45: 65,
            lc30: 50.5,
            lc10: 33.5
        },
        "pink.2300": {
            contrast: 93.50094060941547,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 32
        },
        "pink.2400": {
            contrast: 100.57350058050041,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "pink.2500": {
            contrast: 107.53244502454244,
            lc60: 68,
            lc45: 56.5,
            lc30: 44,
            lc10: 29
        }
    },
    "pink.300": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 10.77041311089608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 15.1723923017603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99.5
        },
        "pink.900": {
            contrast: 19.424007064866093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1000": {
            contrast: 23.186289573871193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "pink.1100": {
            contrast: 29.10001275290662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "pink.1200": {
            contrast: 31.552090449810215,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 60
        },
        "pink.1300": {
            contrast: 35.95207050250319,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 54.5
        },
        "pink.1400": {
            contrast: 40.228962838210386,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 50.5
        },
        "pink.1500": {
            contrast: 44.777408106385764,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 47.5
        },
        "pink.1600": {
            contrast: 49.60515737199517,
            lc60: 100,
            lc45: 93.5,
            lc30: 70.5,
            lc10: 45
        },
        "pink.1700": {
            contrast: 55.121194947113786,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42
        },
        "pink.1800": {
            contrast: 60.73013875502037,
            lc60: 99,
            lc45: 81.5,
            lc30: 62,
            lc10: 39.5
        },
        "pink.1900": {
            contrast: 66.77800033989857,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 58,
            lc10: 37.5
        },
        "pink.2000": {
            contrast: 72.70692286322384,
            lc60: 87.5,
            lc45: 72,
            lc30: 55,
            lc10: 35.5
        },
        "pink.2100": {
            contrast: 79.08670384809669,
            lc60: 83,
            lc45: 68,
            lc30: 52.5,
            lc10: 34
        },
        "pink.2200": {
            contrast: 85.47597116601415,
            lc60: 78.5,
            lc45: 65,
            lc30: 49.5,
            lc10: 32.5
        },
        "pink.2300": {
            contrast: 92.2163749019296,
            lc60: 74.5,
            lc45: 62,
            lc30: 47.5,
            lc10: 31
        },
        "pink.2400": {
            contrast: 99.28893487301454,
            lc60: 71.5,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        },
        "pink.2500": {
            contrast: 106.24787931705659,
            lc60: 68,
            lc45: 56.5,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "pink.400": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 8.872015901151324,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 13.273995092015545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 17.52560985512133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "pink.1000": {
            contrast: 21.28789236412644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "pink.1100": {
            contrast: 27.20161554316186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "pink.1200": {
            contrast: 29.653693240065458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "pink.1300": {
            contrast: 34.05367329275843,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 54.5
        },
        "pink.1400": {
            contrast: 38.33056562846563,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 50
        },
        "pink.1500": {
            contrast: 42.879010896641006,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 46.5
        },
        "pink.1600": {
            contrast: 47.70676016225042,
            lc60: 100,
            lc45: 95.5,
            lc30: 72,
            lc10: 44
        },
        "pink.1700": {
            contrast: 53.222797737369035,
            lc60: 100,
            lc45: 89,
            lc30: 67,
            lc10: 41.5
        },
        "pink.1800": {
            contrast: 58.831741545275605,
            lc60: 100,
            lc45: 83,
            lc30: 63,
            lc10: 39.5
        },
        "pink.1900": {
            contrast: 64.87960313015381,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 59,
            lc10: 37
        },
        "pink.2000": {
            contrast: 70.80852565347907,
            lc60: 89,
            lc45: 73.5,
            lc30: 56,
            lc10: 35.5
        },
        "pink.2100": {
            contrast: 77.18830663835195,
            lc60: 84,
            lc45: 69.5,
            lc30: 53,
            lc10: 34
        },
        "pink.2200": {
            contrast: 83.5775739562694,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 32.5
        },
        "pink.2300": {
            contrast: 90.31797769218485,
            lc60: 76,
            lc45: 63,
            lc30: 48,
            lc10: 31
        },
        "pink.2400": {
            contrast: 97.39053766326978,
            lc60: 72,
            lc45: 59.5,
            lc30: 46,
            lc10: 30
        },
        "pink.2500": {
            contrast: 104.34948210731183,
            lc60: 69,
            lc45: 57,
            lc30: 44,
            lc10: 28.5
        }
    },
    "pink.500": {
        "pink.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 10.675410675210081,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 14.927025438315871,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 18.68930794732097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1100": {
            contrast: 24.6030311263564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "pink.1200": {
            contrast: 27.055108823259992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.1300": {
            contrast: 31.45508887595297,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 55.5
        },
        "pink.1400": {
            contrast: 35.73198121166016,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 51
        },
        "pink.1500": {
            contrast: 40.28042647983554,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 47
        },
        "pink.1600": {
            contrast: 45.10817574544495,
            lc60: 100,
            lc45: 99.5,
            lc30: 74,
            lc10: 44.5
        },
        "pink.1700": {
            contrast: 50.62421332056356,
            lc60: 100,
            lc45: 92,
            lc30: 68.5,
            lc10: 42
        },
        "pink.1800": {
            contrast: 56.233157128470154,
            lc60: 100,
            lc45: 85.5,
            lc30: 64.5,
            lc10: 39.5
        },
        "pink.1900": {
            contrast: 62.281018713348345,
            lc60: 97,
            lc45: 80,
            lc30: 60.5,
            lc10: 37.5
        },
        "pink.2000": {
            contrast: 68.2099412366736,
            lc60: 91.5,
            lc45: 75,
            lc30: 57,
            lc10: 35.5
        },
        "pink.2100": {
            contrast: 74.58972222154647,
            lc60: 86,
            lc45: 71,
            lc30: 54,
            lc10: 34
        },
        "pink.2200": {
            contrast: 80.97898953946392,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 51.5,
            lc10: 32.5
        },
        "pink.2300": {
            contrast: 87.71939327537939,
            lc60: 77.5,
            lc45: 64,
            lc30: 49,
            lc10: 31.5
        },
        "pink.2400": {
            contrast: 94.79195324646432,
            lc60: 74,
            lc45: 61,
            lc30: 47,
            lc10: 30
        },
        "pink.2500": {
            contrast: 101.75089769050636,
            lc60: 70,
            lc45: 58,
            lc30: 44.5,
            lc10: 29
        }
    },
    "pink.600": {
        "pink.100": {
            contrast: 9.894306924753202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 9.421481604228262,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 7.739677532346192,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 11.222861433606946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 14.985143942612044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 20.89886712164747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "pink.1200": {
            contrast: 23.35094481855107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "pink.1300": {
            contrast: 27.750924871244038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "pink.1400": {
            contrast: 32.027817206951234,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54.5
        },
        "pink.1500": {
            contrast: 36.57626247512661,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 50
        },
        "pink.1600": {
            contrast: 41.40401174073602,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 47
        },
        "pink.1700": {
            contrast: 46.920049315854634,
            lc60: 100,
            lc45: 97,
            lc30: 72.5,
            lc10: 44
        },
        "pink.1800": {
            contrast: 52.52899312376121,
            lc60: 100,
            lc45: 89.5,
            lc30: 67.5,
            lc10: 41.5
        },
        "pink.1900": {
            contrast: 58.576854708639424,
            lc60: 100,
            lc45: 83.5,
            lc30: 63,
            lc10: 39
        },
        "pink.2000": {
            contrast: 64.50577723196467,
            lc60: 95,
            lc45: 78,
            lc30: 59.5,
            lc10: 37
        },
        "pink.2100": {
            contrast: 70.88555821683755,
            lc60: 89,
            lc45: 73.5,
            lc30: 56,
            lc10: 35.5
        },
        "pink.2200": {
            contrast: 77.27482553475501,
            lc60: 84.5,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 34
        },
        "pink.2300": {
            contrast: 84.01522927067045,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 32.5
        },
        "pink.2400": {
            contrast: 91.08778924175539,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31
        },
        "pink.2500": {
            contrast: 98.04673368579742,
            lc60: 72.5,
            lc45: 60,
            lc30: 46,
            lc10: 30
        }
    },
    "pink.700": {
        "pink.100": {
            contrast: 14.124536233205937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.200": {
            contrast: 13.651710912680995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.300": {
            contrast: 11.969906840798924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.400": {
            contrast: 9.576733555993563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 7.512720979195531,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 11.27500348820063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 17.188726667236057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "pink.1200": {
            contrast: 19.640804364139658,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "pink.1300": {
            contrast: 24.04078441683263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.1400": {
            contrast: 28.31767675253982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "pink.1500": {
            contrast: 32.8661220207152,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 54
        },
        "pink.1600": {
            contrast: 37.693871286324615,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 50
        },
        "pink.1700": {
            contrast: 43.209908861443225,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 47
        },
        "pink.1800": {
            contrast: 48.81885266934981,
            lc60: 100,
            lc45: 94,
            lc30: 71.5,
            lc10: 44
        },
        "pink.1900": {
            contrast: 54.86671425422801,
            lc60: 100,
            lc45: 87,
            lc30: 66.5,
            lc10: 41
        },
        "pink.2000": {
            contrast: 60.79563677755328,
            lc60: 99,
            lc45: 81.5,
            lc30: 62,
            lc10: 39
        },
        "pink.2100": {
            contrast: 67.17541776242614,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 58.5,
            lc10: 37
        },
        "pink.2200": {
            contrast: 73.5646850803436,
            lc60: 87,
            lc45: 72.5,
            lc30: 55.5,
            lc10: 35
        },
        "pink.2300": {
            contrast: 80.30508881625904,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 52.5,
            lc10: 33.5
        },
        "pink.2400": {
            contrast: 87.37764878734397,
            lc60: 78.5,
            lc45: 65,
            lc30: 50,
            lc10: 32.5
        },
        "pink.2500": {
            contrast: 94.33659323138602,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 31
        }
    },
    "pink.800": {
        "pink.100": {
            contrast: 18.814687870981235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "pink.200": {
            contrast: 18.341862550456295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.300": {
            contrast: 16.660058478574225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "pink.400": {
            contrast: 14.266885193768864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.500": {
            contrast: 11.116868444622616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 12.939556367081382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 15.391634063984982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "pink.1300": {
            contrast: 19.791614116677955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "pink.1400": {
            contrast: 24.06850645238515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.1500": {
            contrast: 28.616951720560525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "pink.1600": {
            contrast: 33.444700986169934,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 55
        },
        "pink.1700": {
            contrast: 38.96073856128855,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 51
        },
        "pink.1800": {
            contrast: 44.56968236919513,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "pink.1900": {
            contrast: 50.61754395407333,
            lc60: 100,
            lc45: 92,
            lc30: 70.5,
            lc10: 44.5
        },
        "pink.2000": {
            contrast: 56.546466477398596,
            lc60: 100,
            lc45: 86,
            lc30: 66,
            lc10: 42
        },
        "pink.2100": {
            contrast: 62.92624746227147,
            lc60: 97,
            lc45: 80.5,
            lc30: 62,
            lc10: 39.5
        },
        "pink.2200": {
            contrast: 69.31551478018892,
            lc60: 91,
            lc45: 75.5,
            lc30: 58.5,
            lc10: 37.5
        },
        "pink.2300": {
            contrast: 76.05591851610436,
            lc60: 86,
            lc45: 71.5,
            lc30: 55.5,
            lc10: 36
        },
        "pink.2400": {
            contrast: 83.12847848718931,
            lc60: 81,
            lc45: 67.5,
            lc30: 52.5,
            lc10: 34.5
        },
        "pink.2500": {
            contrast: 90.08742293123136,
            lc60: 77,
            lc45: 64.5,
            lc30: 50,
            lc10: 32.5
        }
    },
    "pink.900": {
        "pink.100": {
            contrast: 23.261942186407257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "pink.200": {
            contrast: 22.78911686588231,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "pink.300": {
            contrast: 21.10731279400024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "pink.400": {
            contrast: 18.71413950919488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "pink.500": {
            contrast: 15.564122760048631,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "pink.600": {
            contrast: 11.249038066044692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 8.797572655226773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 11.249650352130372,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 15.649630404823345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "pink.1400": {
            contrast: 19.92652274053054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "pink.1500": {
            contrast: 24.47496800870592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.1600": {
            contrast: 29.302717274315327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "pink.1700": {
            contrast: 34.818754849433944,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 56
        },
        "pink.1800": {
            contrast: 40.42769865734052,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 51.5
        },
        "pink.1900": {
            contrast: 46.47556024221873,
            lc60: 100,
            lc45: 97.5,
            lc30: 75.5,
            lc10: 48
        },
        "pink.2000": {
            contrast: 52.40448276554398,
            lc60: 100,
            lc45: 90.5,
            lc30: 70,
            lc10: 45.5
        },
        "pink.2100": {
            contrast: 58.784263750416855,
            lc60: 100,
            lc45: 84.5,
            lc30: 66,
            lc10: 42.5
        },
        "pink.2200": {
            contrast: 65.17353106833431,
            lc60: 95,
            lc45: 79,
            lc30: 62,
            lc10: 40.5
        },
        "pink.2300": {
            contrast: 71.91393480424976,
            lc60: 89.5,
            lc45: 74.5,
            lc30: 58.5,
            lc10: 38.5
        },
        "pink.2400": {
            contrast: 78.98649477533469,
            lc60: 84,
            lc45: 70.5,
            lc30: 55.5,
            lc10: 36.5
        },
        "pink.2500": {
            contrast: 85.94543921937674,
            lc60: 80,
            lc45: 67,
            lc30: 53,
            lc10: 35
        }
    },
    "pink.1000": {
        "pink.100": {
            contrast: 27.14103327770957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39
        },
        "pink.200": {
            contrast: 26.668207957184638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "pink.300": {
            contrast: 24.98640388530257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "pink.400": {
            contrast: 22.5932306004972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "pink.500": {
            contrast: 19.443213851350954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "pink.600": {
            contrast: 15.128129157347017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.700": {
            contrast: 10.954377948687641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 7.557885020226979,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 11.957865072919951,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 16.234757408627146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "pink.1500": {
            contrast: 20.783202676802524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "pink.1600": {
            contrast: 25.61095194241193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.1700": {
            contrast: 31.126989517530546,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 62
        },
        "pink.1800": {
            contrast: 36.735933325437124,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 56.5
        },
        "pink.1900": {
            contrast: 42.78379491031533,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52
        },
        "pink.2000": {
            contrast: 48.712717433640584,
            lc60: 100,
            lc45: 95,
            lc30: 74.5,
            lc10: 48.5
        },
        "pink.2100": {
            contrast: 55.09249841851344,
            lc60: 100,
            lc45: 88,
            lc30: 69,
            lc10: 45.5
        },
        "pink.2200": {
            contrast: 61.4817657364309,
            lc60: 98.5,
            lc45: 83,
            lc30: 64.5,
            lc10: 43
        },
        "pink.2300": {
            contrast: 68.22216947234637,
            lc60: 92.5,
            lc45: 77.5,
            lc30: 61.5,
            lc10: 41
        },
        "pink.2400": {
            contrast: 75.29472944343128,
            lc60: 87,
            lc45: 73.5,
            lc30: 58,
            lc10: 38.5
        },
        "pink.2500": {
            contrast: 82.25367388747333,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 54.5,
            lc10: 36.5
        }
    },
    "pink.1100": {
        "pink.100": {
            contrast: 33.14852601612051,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 32.5
        },
        "pink.200": {
            contrast: 32.67570069559557,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 37
        },
        "pink.300": {
            contrast: 30.993896623713503,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 43
        },
        "pink.400": {
            contrast: 28.60072333890814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "pink.500": {
            contrast: 25.45070658976189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "pink.600": {
            contrast: 21.135621895757954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "pink.700": {
            contrast: 16.961870687098575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "pink.800": {
            contrast: 12.317621098050543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 7.900345529595314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 10.388625925718948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 14.937071193894328,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 19.76482045950374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "pink.1700": {
            contrast: 25.28085803462235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "pink.1800": {
            contrast: 30.88980184252893,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 66
        },
        "pink.1900": {
            contrast: 36.93766342740714,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 59
        },
        "pink.2000": {
            contrast: 42.86658595073239,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 55
        },
        "pink.2100": {
            contrast: 49.24636693560526,
            lc60: 100,
            lc45: 95,
            lc30: 75.5,
            lc10: 51
        },
        "pink.2200": {
            contrast: 55.635634253522724,
            lc60: 100,
            lc45: 88,
            lc30: 70,
            lc10: 48.5
        },
        "pink.2300": {
            contrast: 62.376037989438146,
            lc60: 98,
            lc45: 82.5,
            lc30: 66,
            lc10: 45
        },
        "pink.2400": {
            contrast: 69.4485979605231,
            lc60: 91.5,
            lc45: 78,
            lc30: 62,
            lc10: 42.5
        },
        "pink.2500": {
            contrast: 76.40754240456515,
            lc60: 87,
            lc45: 73.5,
            lc30: 59,
            lc10: 40.5
        }
    },
    "pink.1200": {
        "pink.100": {
            contrast: 35.611303520731845,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 30.5
        },
        "pink.200": {
            contrast: 35.138478200206904,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 34.5
        },
        "pink.300": {
            contrast: 33.456674128324835,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 40
        },
        "pink.400": {
            contrast: 31.06350084351948,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 45
        },
        "pink.500": {
            contrast: 27.913484094373224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "pink.600": {
            contrast: 23.598399400369292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "pink.700": {
            contrast: 19.424648191709913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "pink.800": {
            contrast: 14.780398602661881,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.900": {
            contrast: 10.36312303420665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 7.950763941922776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 12.499209210098156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 17.326958475707563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "pink.1700": {
            contrast: 22.842996050826176,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "pink.1800": {
            contrast: 28.451939858732757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "pink.1900": {
            contrast: 34.49980144361096,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 58.5
        },
        "pink.2000": {
            contrast: 40.42872396693622,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 53.5
        },
        "pink.2100": {
            contrast: 46.80850495180909,
            lc60: 100,
            lc45: 97,
            lc30: 75.5,
            lc10: 49
        },
        "pink.2200": {
            contrast: 53.19777226972654,
            lc60: 100,
            lc45: 90,
            lc30: 70,
            lc10: 45.5
        },
        "pink.2300": {
            contrast: 59.938176005641985,
            lc60: 100,
            lc45: 83.5,
            lc30: 65,
            lc10: 42
        },
        "pink.2400": {
            contrast: 67.01073597672692,
            lc60: 93,
            lc45: 78,
            lc30: 61,
            lc10: 39.5
        },
        "pink.2500": {
            contrast: 73.96968042076897,
            lc60: 88,
            lc45: 73.5,
            lc30: 57,
            lc10: 37.5
        }
    },
    "pink.1300": {
        "pink.100": {
            contrast: 39.993929380418464,
            lc60: 100,
            lc45: 100,
            lc30: 56,
            lc10: 27.5
        },
        "pink.200": {
            contrast: 39.521104059893524,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "pink.300": {
            contrast: 37.839299988011454,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35
        },
        "pink.400": {
            contrast: 35.44612670320609,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 39.5
        },
        "pink.500": {
            contrast: 32.296109954059844,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 44.5
        },
        "pink.600": {
            contrast: 27.9810252600559,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "pink.700": {
            contrast: 23.80727405139653,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.800": {
            contrast: 19.163024462348496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "pink.900": {
            contrast: 14.745748893893266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1000": {
            contrast: 10.88353751965882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 8.106523520844656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 12.934272786454065,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 18.45031036157268,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "pink.1800": {
            contrast: 24.059254169479257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "pink.1900": {
            contrast: 30.107115754357462,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 62
        },
        "pink.2000": {
            contrast: 36.03603827768272,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 55.5
        },
        "pink.2100": {
            contrast: 42.41581926255559,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 49.5
        },
        "pink.2200": {
            contrast: 48.805086580473045,
            lc60: 100,
            lc45: 94.5,
            lc30: 72,
            lc10: 45.5
        },
        "pink.2300": {
            contrast: 55.54549031638849,
            lc60: 100,
            lc45: 86.5,
            lc30: 66.5,
            lc10: 41.5
        },
        "pink.2400": {
            contrast: 62.61805028747342,
            lc60: 97,
            lc45: 80.5,
            lc30: 61.5,
            lc10: 38.5
        },
        "pink.2500": {
            contrast: 69.57699473151547,
            lc60: 90.5,
            lc45: 75,
            lc30: 57.5,
            lc10: 36
        }
    },
    "pink.1400": {
        "pink.100": {
            contrast: 44.2131152740578,
            lc60: 100,
            lc45: 100,
            lc30: 50.5,
            lc10: 25
        },
        "pink.200": {
            contrast: 43.74028995353286,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28
        },
        "pink.300": {
            contrast: 42.05848588165079,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "pink.400": {
            contrast: 39.665312596845425,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34.5
        },
        "pink.500": {
            contrast: 36.51529584769918,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38.5
        },
        "pink.600": {
            contrast: 32.20021115369524,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 44.5
        },
        "pink.700": {
            contrast: 28.026459945035864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "pink.800": {
            contrast: 23.38221035598783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.900": {
            contrast: 18.9649347875326,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "pink.1000": {
            contrast: 15.102723413298156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.1100": {
            contrast: 9.106561156101405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 8.643859887501003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 14.159897462619616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 19.768841270526195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "pink.1900": {
            contrast: 25.8167028554044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.2000": {
            contrast: 31.74562537872966,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 59.5
        },
        "pink.2100": {
            contrast: 38.12540636360253,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 52.5
        },
        "pink.2200": {
            contrast: 44.51467368151999,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 47.5
        },
        "pink.2300": {
            contrast: 51.25507741743542,
            lc60: 100,
            lc45: 91.5,
            lc30: 69.5,
            lc10: 43
        },
        "pink.2400": {
            contrast: 58.32763738852036,
            lc60: 100,
            lc45: 84,
            lc30: 64,
            lc10: 39.5
        },
        "pink.2500": {
            contrast: 65.2865818325624,
            lc60: 94.5,
            lc45: 78,
            lc30: 59,
            lc10: 36.5
        }
    },
    "pink.1500": {
        "pink.100": {
            contrast: 48.660450306100266,
            lc60: 100,
            lc45: 75.5,
            lc30: 46,
            lc10: 23
        },
        "pink.200": {
            contrast: 48.187624985575326,
            lc60: 100,
            lc45: 84,
            lc30: 51,
            lc10: 25.5
        },
        "pink.300": {
            contrast: 46.50582091369326,
            lc60: 100,
            lc45: 93,
            lc30: 56,
            lc10: 28
        },
        "pink.400": {
            contrast: 44.1126476288879,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 30.5
        },
        "pink.500": {
            contrast: 40.96263087974165,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 34
        },
        "pink.600": {
            contrast: 36.64754618573771,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "pink.700": {
            contrast: 32.473794977078335,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 43.5
        },
        "pink.800": {
            contrast: 27.8295453880303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "pink.900": {
            contrast: 23.412269819575073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "pink.1000": {
            contrast: 19.550058445340632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "pink.1100": {
            contrast: 13.553896188143879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1200": {
            contrast: 11.091094324937181,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 9.576733292249832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 15.185677100156415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.1900": {
            contrast: 21.23353868503462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "pink.2000": {
            contrast: 27.162461208359872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "pink.2100": {
            contrast: 33.542242193232745,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 55.5
        },
        "pink.2200": {
            contrast: 39.931509511150196,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 49
        },
        "pink.2300": {
            contrast: 46.671913247065646,
            lc60: 100,
            lc45: 97.5,
            lc30: 72.5,
            lc10: 44
        },
        "pink.2400": {
            contrast: 53.74447321815058,
            lc60: 100,
            lc45: 88.5,
            lc30: 66,
            lc10: 40
        },
        "pink.2500": {
            contrast: 60.70341766219263,
            lc60: 99,
            lc45: 80.5,
            lc30: 60.5,
            lc10: 36.5
        }
    },
    "pink.1600": {
        "pink.100": {
            contrast: 53.340303824956806,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "pink.200": {
            contrast: 52.867478504431865,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23.5
        },
        "pink.300": {
            contrast: 51.18567443254979,
            lc60: 100,
            lc45: 79.5,
            lc30: 50,
            lc10: 25
        },
        "pink.400": {
            contrast: 48.79250114774444,
            lc60: 100,
            lc45: 87,
            lc30: 54,
            lc10: 27
        },
        "pink.500": {
            contrast: 45.642484398598185,
            lc60: 100,
            lc45: 97.5,
            lc30: 59.5,
            lc10: 29.5
        },
        "pink.600": {
            contrast: 41.32739970459424,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "pink.700": {
            contrast: 37.15364849593487,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36
        },
        "pink.800": {
            contrast: 32.50939890688683,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 40.5
        },
        "pink.900": {
            contrast: 28.092123338431602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "pink.1000": {
            contrast: 24.22991196419716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "pink.1100": {
            contrast: 18.23374970700041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "pink.1200": {
            contrast: 15.770947843793712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "pink.1300": {
            contrast: 11.382209031042581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 10.300033891051388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 16.347895475929594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "pink.2000": {
            contrast: 22.276817999254853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "pink.2100": {
            contrast: 28.65659898412772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "pink.2200": {
            contrast: 35.04586630204518,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51
        },
        "pink.2300": {
            contrast: 41.78627003796062,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 45
        },
        "pink.2400": {
            contrast: 48.85883000904555,
            lc60: 100,
            lc45: 93.5,
            lc30: 68.5,
            lc10: 40
        },
        "pink.2500": {
            contrast: 55.8177744530876,
            lc60: 100,
            lc45: 84.5,
            lc30: 62,
            lc10: 36
        }
    },
    "pink.1700": {
        "pink.100": {
            contrast: 58.64102792513084,
            lc60: 100,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "pink.200": {
            contrast: 58.16820260460589,
            lc60: 100,
            lc45: 65,
            lc30: 41.5,
            lc10: 21
        },
        "pink.300": {
            contrast: 56.48639853272384,
            lc60: 100,
            lc45: 70,
            lc30: 45,
            lc10: 22.5
        },
        "pink.400": {
            contrast: 54.093225247918475,
            lc60: 100,
            lc45: 75,
            lc30: 47.5,
            lc10: 24
        },
        "pink.500": {
            contrast: 50.94320849877222,
            lc60: 100,
            lc45: 83,
            lc30: 51.5,
            lc10: 25.5
        },
        "pink.600": {
            contrast: 46.62812380476828,
            lc60: 100,
            lc45: 94.5,
            lc30: 56.5,
            lc10: 28
        },
        "pink.700": {
            contrast: 42.454372596108904,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30.5
        },
        "pink.800": {
            contrast: 37.81012300706087,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 33.5
        },
        "pink.900": {
            contrast: 33.392847438605635,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 37
        },
        "pink.1000": {
            contrast: 29.530636064371198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41.5
        },
        "pink.1100": {
            contrast: 23.534473807174447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "pink.1200": {
            contrast: 21.071671943967747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "pink.1300": {
            contrast: 16.68293313121662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "pink.1400": {
            contrast: 12.45107321527737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1500": {
            contrast: 7.983760096756151,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 10.74136572635437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 16.67028824967963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "pink.2100": {
            contrast: 23.0500692345525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "pink.2200": {
            contrast: 29.439336552469953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "pink.2300": {
            contrast: 36.179740288385396,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48.5
        },
        "pink.2400": {
            contrast: 43.25230025947033,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42.5
        },
        "pink.2500": {
            contrast: 50.21124470351238,
            lc60: 100,
            lc45: 91.5,
            lc30: 66,
            lc10: 37.5
        }
    },
    "pink.1800": {
        "pink.100": {
            contrast: 63.98504128605945,
            lc60: 79,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "pink.200": {
            contrast: 63.5122159655345,
            lc60: 85,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "pink.300": {
            contrast: 61.830411893652446,
            lc60: 92.5,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "pink.400": {
            contrast: 59.43723860884709,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "pink.500": {
            contrast: 56.28722185970083,
            lc60: 100,
            lc45: 72,
            lc30: 45.5,
            lc10: 22.5
        },
        "pink.600": {
            contrast: 51.972137165696886,
            lc60: 100,
            lc45: 80,
            lc30: 49.5,
            lc10: 25
        },
        "pink.700": {
            contrast: 47.79838595703752,
            lc60: 100,
            lc45: 90,
            lc30: 53.5,
            lc10: 26.5
        },
        "pink.800": {
            contrast: 43.15413636798948,
            lc60: 100,
            lc45: 100,
            lc30: 59,
            lc10: 28.5
        },
        "pink.900": {
            contrast: 38.73686079953425,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 31
        },
        "pink.1000": {
            contrast: 34.87464942529981,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 34
        },
        "pink.1100": {
            contrast: 28.878487168103057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "pink.1200": {
            contrast: 26.415685304896357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "pink.1300": {
            contrast: 22.026946492145232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "pink.1400": {
            contrast: 17.795086576205982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "pink.1500": {
            contrast: 13.327773457684764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1600": {
            contrast: 8.62012847643698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 10.944851388049603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 17.324632372922473,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "pink.2200": {
            contrast: 23.71389969083993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.2300": {
            contrast: 30.45430342675537,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 55.5
        },
        "pink.2400": {
            contrast: 37.5268633978403,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 46.5
        },
        "pink.2500": {
            contrast: 44.485807841882355,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40.5
        }
    },
    "pink.1900": {
        "pink.100": {
            contrast: 69.70002005610566,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "pink.200": {
            contrast: 69.22719473558071,
            lc60: 74.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 17.5
        },
        "pink.300": {
            contrast: 67.54539066369865,
            lc60: 79.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.400": {
            contrast: 65.15221737889328,
            lc60: 85,
            lc45: 59,
            lc30: 38,
            lc10: 19.5
        },
        "pink.500": {
            contrast: 62.00220062974704,
            lc60: 94,
            lc45: 63,
            lc30: 40.5,
            lc10: 20.5
        },
        "pink.600": {
            contrast: 57.687115935743094,
            lc60: 100,
            lc45: 69,
            lc30: 43,
            lc10: 22
        },
        "pink.700": {
            contrast: 53.513364727083726,
            lc60: 100,
            lc45: 75,
            lc30: 46,
            lc10: 23
        },
        "pink.800": {
            contrast: 48.86911513803569,
            lc60: 100,
            lc45: 86,
            lc30: 50.5,
            lc10: 24.5
        },
        "pink.900": {
            contrast: 44.45183956958046,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 26.5
        },
        "pink.1000": {
            contrast: 40.58962819534601,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 28
        },
        "pink.1100": {
            contrast: 34.59346593814926,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 31
        },
        "pink.1200": {
            contrast: 32.13066407494256,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 37
        },
        "pink.1300": {
            contrast: 27.74192526219143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "pink.1400": {
            contrast: 23.510065346252187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "pink.1500": {
            contrast: 19.04275222773097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "pink.1600": {
            contrast: 14.335107246483187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1700": {
            contrast: 8.995165050599168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 11.125709972429872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 17.51497729034733,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "pink.2300": {
            contrast: 24.25538102626277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "pink.2400": {
            contrast: 31.327940997347703,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 53.5
        },
        "pink.2500": {
            contrast: 38.28688544138975,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        }
    },
    "pink.2000": {
        "pink.100": {
            contrast: 75.2591388438285,
            lc60: 64,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "pink.200": {
            contrast: 74.78631352330355,
            lc60: 68,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "pink.300": {
            contrast: 73.10450945142149,
            lc60: 71.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17
        },
        "pink.400": {
            contrast: 70.71133616661614,
            lc60: 75,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 18
        },
        "pink.500": {
            contrast: 67.56131941746987,
            lc60: 81,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "pink.600": {
            contrast: 63.24623472346593,
            lc60: 90,
            lc45: 60.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "pink.700": {
            contrast: 59.072483514806564,
            lc60: 100,
            lc45: 65.5,
            lc30: 41,
            lc10: 20.5
        },
        "pink.800": {
            contrast: 54.42823392575852,
            lc60: 100,
            lc45: 71.5,
            lc30: 43.5,
            lc10: 22
        },
        "pink.900": {
            contrast: 50.0109583573033,
            lc60: 100,
            lc45: 80,
            lc30: 46.5,
            lc10: 23
        },
        "pink.1000": {
            contrast: 46.148746983068854,
            lc60: 100,
            lc45: 94,
            lc30: 50.5,
            lc10: 24.5
        },
        "pink.1100": {
            contrast: 40.1525847258721,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 26
        },
        "pink.1200": {
            contrast: 37.6897828626654,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 31
        },
        "pink.1300": {
            contrast: 33.301044049914275,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 36.5
        },
        "pink.1400": {
            contrast: 29.06918413397503,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "pink.1500": {
            contrast: 24.60187101545381,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "pink.1600": {
            contrast: 19.894226034206028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "pink.1700": {
            contrast: 14.554283838322007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1800": {
            contrast: 9.163037526896305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 11.414254858205751,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 18.154658594121198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "pink.2400": {
            contrast: 25.227218565206133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "pink.2500": {
            contrast: 32.186163009248176,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51
        }
    },
    "pink.2100": {
        "pink.100": {
            contrast: 81.19691789907402,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "pink.200": {
            contrast: 80.72409257854906,
            lc60: 62,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "pink.300": {
            contrast: 79.042288506667,
            lc60: 65,
            lc45: 47,
            lc30: 30.5,
            lc10: 16
        },
        "pink.400": {
            contrast: 76.64911522186165,
            lc60: 67.5,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "pink.500": {
            contrast: 73.4990984727154,
            lc60: 71.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "pink.600": {
            contrast: 69.18401377871145,
            lc60: 77.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "pink.700": {
            contrast: 65.01026257005208,
            lc60: 85,
            lc45: 57,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.800": {
            contrast: 60.36601298100403,
            lc60: 98,
            lc45: 61.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "pink.900": {
            contrast: 55.94873741254882,
            lc60: 100,
            lc45: 67,
            lc30: 41,
            lc10: 20.5
        },
        "pink.1000": {
            contrast: 52.086526038314375,
            lc60: 100,
            lc45: 73,
            lc30: 43,
            lc10: 21.5
        },
        "pink.1100": {
            contrast: 46.090363781117624,
            lc60: 100,
            lc45: 91.5,
            lc30: 47.5,
            lc10: 22.5
        },
        "pink.1200": {
            contrast: 43.627561917910924,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 26
        },
        "pink.1300": {
            contrast: 39.238823105159796,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 30.5
        },
        "pink.1400": {
            contrast: 35.00696318922055,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 35.5
        },
        "pink.1500": {
            contrast: 30.539650070699327,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 43.5
        },
        "pink.1600": {
            contrast: 25.832005089451542,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "pink.1700": {
            contrast: 20.492062893567528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "pink.1800": {
            contrast: 15.100816582141825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "pink.1900": {
            contrast: 9.327413566081605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 11.56569339463902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 18.638253365723955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "pink.2500": {
            contrast: 25.597197809765998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        }
    },
    "pink.2200": {
        "pink.100": {
            contrast: 87.10132798309273,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "pink.200": {
            contrast: 86.62850266256777,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "pink.300": {
            contrast: 84.94669859068573,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "pink.400": {
            contrast: 82.55352530588034,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "pink.500": {
            contrast: 79.40350855673411,
            lc60: 64.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "pink.600": {
            contrast: 75.08842386273015,
            lc60: 68.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 16
        },
        "pink.700": {
            contrast: 70.91467265407077,
            lc60: 73.5,
            lc45: 51,
            lc30: 33,
            lc10: 17
        },
        "pink.800": {
            contrast: 66.27042306502274,
            lc60: 80.5,
            lc45: 54.5,
            lc30: 35,
            lc10: 17.5
        },
        "pink.900": {
            contrast: 61.853147496567516,
            lc60: 91.5,
            lc45: 58,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.1000": {
            contrast: 57.99093612233308,
            lc60: 100,
            lc45: 62,
            lc30: 38,
            lc10: 19
        },
        "pink.1100": {
            contrast: 51.994773865136324,
            lc60: 100,
            lc45: 69.5,
            lc30: 40.5,
            lc10: 20
        },
        "pink.1200": {
            contrast: 49.531972001929624,
            lc60: 100,
            lc45: 81,
            lc30: 46.5,
            lc10: 23
        },
        "pink.1300": {
            contrast: 45.143233189178495,
            lc60: 100,
            lc45: 99,
            lc30: 54.5,
            lc10: 26.5
        },
        "pink.1400": {
            contrast: 40.91137327323925,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30
        },
        "pink.1500": {
            contrast: 36.44406015471803,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 35
        },
        "pink.1600": {
            contrast: 31.73641517347025,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 43.5
        },
        "pink.1700": {
            contrast: 26.396472977586228,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "pink.1800": {
            contrast: 21.005226666160528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "pink.1900": {
            contrast: 15.23182365010031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "pink.2000": {
            contrast: 9.608578663501428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 12.015954023526632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 18.97489846756868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        }
    },
    "pink.2300": {
        "pink.100": {
            contrast: 93.28794298184863,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "pink.200": {
            contrast: 92.81511766132368,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "pink.300": {
            contrast: 91.13331358944163,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "pink.400": {
            contrast: 88.74014030463626,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "pink.500": {
            contrast: 85.59012355549001,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "pink.600": {
            contrast: 81.27503886148607,
            lc60: 62,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "pink.700": {
            contrast: 77.10128765282668,
            lc60: 65.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "pink.800": {
            contrast: 72.45703806377865,
            lc60: 70,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "pink.900": {
            contrast: 68.03976249532343,
            lc60: 75.5,
            lc45: 51,
            lc30: 32.5,
            lc10: 17
        },
        "pink.1000": {
            contrast: 64.17755112108898,
            lc60: 83,
            lc45: 54,
            lc30: 34,
            lc10: 17.5
        },
        "pink.1100": {
            contrast: 58.18138886389224,
            lc60: 100,
            lc45: 59,
            lc30: 36,
            lc10: 18
        },
        "pink.1200": {
            contrast: 55.718587000685524,
            lc60: 100,
            lc45: 66.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "pink.1300": {
            contrast: 51.3298481879344,
            lc60: 100,
            lc45: 78.5,
            lc30: 47,
            lc10: 23.5
        },
        "pink.1400": {
            contrast: 47.09798827199516,
            lc60: 100,
            lc45: 91.5,
            lc30: 52.5,
            lc10: 26
        },
        "pink.1500": {
            contrast: 42.63067515347394,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 30
        },
        "pink.1600": {
            contrast: 37.923030172226156,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36.5
        },
        "pink.1700": {
            contrast: 32.58308797634214,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 44.5
        },
        "pink.1800": {
            contrast: 27.19184166491643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "pink.1900": {
            contrast: 21.41843864885622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "pink.2000": {
            contrast: 15.795193662257336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "pink.2100": {
            contrast: 9.781512424332313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 11.964821667346046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "pink.2400": {
        "pink.100": {
            contrast: 99.73618138843224,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "pink.200": {
            contrast: 99.2633560679073,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "pink.300": {
            contrast: 97.58155199602524,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "pink.400": {
            contrast: 95.18837871121988,
            lc60: 52,
            lc45: 37.5,
            lc30: 25.5,
            lc10: 13
        },
        "pink.500": {
            contrast: 92.03836196207362,
            lc60: 53.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "pink.600": {
            contrast: 87.72327726806968,
            lc60: 56,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "pink.700": {
            contrast: 83.54952605941031,
            lc60: 58.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "pink.800": {
            contrast: 78.90527647036228,
            lc60: 62,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "pink.900": {
            contrast: 74.48800090190704,
            lc60: 65.5,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "pink.1000": {
            contrast: 70.6257895276726,
            lc60: 70,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "pink.1100": {
            contrast: 64.62962727047585,
            lc60: 79.5,
            lc45: 51,
            lc30: 32.5,
            lc10: 16.5
        },
        "pink.1200": {
            contrast: 62.16682540726916,
            lc60: 90.5,
            lc45: 57,
            lc30: 36,
            lc10: 18
        },
        "pink.1300": {
            contrast: 57.778086594518015,
            lc60: 100,
            lc45: 65.5,
            lc30: 41,
            lc10: 20.5
        },
        "pink.1400": {
            contrast: 53.54622667857877,
            lc60: 100,
            lc45: 74.5,
            lc30: 45.5,
            lc10: 22.5
        },
        "pink.1500": {
            contrast: 49.07891356005756,
            lc60: 100,
            lc45: 86.5,
            lc30: 52,
            lc10: 26
        },
        "pink.1600": {
            contrast: 44.37126857880977,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31
        },
        "pink.1700": {
            contrast: 39.031326382925755,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37
        },
        "pink.1800": {
            contrast: 33.64008007150005,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 44.5
        },
        "pink.1900": {
            contrast: 27.86667705543983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "pink.2000": {
            contrast: 22.24343206884095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "pink.2100": {
            contrast: 16.229750830915926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "pink.2200": {
            contrast: 10.242763067476183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "pink.2500": {
        "pink.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "pink.200": {
            contrast: 105.56784789216367,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "pink.300": {
            contrast: 103.8860438202816,
            lc60: 47.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12.5
        },
        "pink.400": {
            contrast: 101.49287053547624,
            lc60: 48,
            lc45: 35,
            lc30: 23.5,
            lc10: 12
        },
        "pink.500": {
            contrast: 98.34285378632998,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "pink.600": {
            contrast: 94.02776909232603,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "pink.700": {
            contrast: 89.85401788366664,
            lc60: 53.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "pink.800": {
            contrast: 85.20976829461861,
            lc60: 56,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "pink.900": {
            contrast: 80.79249272616339,
            lc60: 58.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "pink.1000": {
            contrast: 76.93028135192895,
            lc60: 61.5,
            lc45: 43.5,
            lc30: 28,
            lc10: 14.5
        },
        "pink.1100": {
            contrast: 70.9341190947322,
            lc60: 67,
            lc45: 45.5,
            lc30: 29,
            lc10: 15
        },
        "pink.1200": {
            contrast: 68.4713172315255,
            lc60: 75,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "pink.1300": {
            contrast: 64.08257841877437,
            lc60: 86.5,
            lc45: 57.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "pink.1400": {
            contrast: 59.85071850283512,
            lc60: 100,
            lc45: 64,
            lc30: 40,
            lc10: 20.5
        },
        "pink.1500": {
            contrast: 55.38340538431391,
            lc60: 100,
            lc45: 72.5,
            lc30: 45,
            lc10: 23
        },
        "pink.1600": {
            contrast: 50.675760403066114,
            lc60: 100,
            lc45: 85,
            lc30: 53,
            lc10: 27
        },
        "pink.1700": {
            contrast: 45.3358182071821,
            lc60: 100,
            lc45: 98.5,
            lc30: 62,
            lc10: 31.5
        },
        "pink.1800": {
            contrast: 39.9445718957564,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 37
        },
        "pink.1900": {
            contrast: 34.17116887969618,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 44.5
        },
        "pink.2000": {
            contrast: 28.547923893097295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "pink.2100": {
            contrast: 22.534242655172275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "pink.2200": {
            contrast: 16.54725489173253,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "pink.2300": {
            contrast: 10.266989491669868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "pink.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$purple = {
    "purple.100": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 8.053459220444278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 11.810635871538256,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 16.408706518046316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "purple.900": {
            contrast: 19.52743424233644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "purple.1000": {
            contrast: 23.529303945592357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "purple.1100": {
            contrast: 27.933795878367583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "purple.1200": {
            contrast: 32.50432517762015,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 66
        },
        "purple.1300": {
            contrast: 37.75780143481969,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 61
        },
        "purple.1400": {
            contrast: 42.35950880803199,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 57
        },
        "purple.1500": {
            contrast: 47.6052907298007,
            lc60: 100,
            lc45: 96.5,
            lc30: 76.5,
            lc10: 53
        },
        "purple.1600": {
            contrast: 52.517142752061666,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "purple.1700": {
            contrast: 58.210780126896026,
            lc60: 100,
            lc45: 85.5,
            lc30: 68,
            lc10: 47
        },
        "purple.1800": {
            contrast: 63.50601675848413,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "purple.1900": {
            contrast: 69.4199867476389,
            lc60: 91.5,
            lc45: 76.5,
            lc30: 60.5,
            lc10: 42
        },
        "purple.2000": {
            contrast: 75.32242584011826,
            lc60: 86.5,
            lc45: 73,
            lc30: 57.5,
            lc10: 40
        },
        "purple.2100": {
            contrast: 81.43971855715829,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "purple.2200": {
            contrast: 87.7624963227358,
            lc60: 79,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "purple.2300": {
            contrast: 94.28242921926659,
            lc60: 75.5,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "purple.2400": {
            contrast: 100.99207161507782,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "purple.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "purple.200": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 7.535774029891567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 11.292950680985545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 15.891021327493608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "purple.900": {
            contrast: 19.00974905178373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "purple.1000": {
            contrast: 23.011618755039645,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "purple.1100": {
            contrast: 27.41611068781487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "purple.1200": {
            contrast: 31.986639987067438,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 63
        },
        "purple.1300": {
            contrast: 37.24011624426697,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 58
        },
        "purple.1400": {
            contrast: 41.84182361747928,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 54
        },
        "purple.1500": {
            contrast: 47.08760553924798,
            lc60: 100,
            lc45: 97,
            lc30: 75,
            lc10: 50.5
        },
        "purple.1600": {
            contrast: 51.999457561508954,
            lc60: 100,
            lc45: 91,
            lc30: 71,
            lc10: 47.5
        },
        "purple.1700": {
            contrast: 57.693094936343314,
            lc60: 100,
            lc45: 85,
            lc30: 66.5,
            lc10: 44.5
        },
        "purple.1800": {
            contrast: 62.988331567931425,
            lc60: 96.5,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 42
        },
        "purple.1900": {
            contrast: 68.9023015570862,
            lc60: 91.5,
            lc45: 76,
            lc30: 59.5,
            lc10: 40
        },
        "purple.2000": {
            contrast: 74.80474064956555,
            lc60: 86.5,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 38
        },
        "purple.2100": {
            contrast: 80.92203336660559,
            lc60: 82,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 36
        },
        "purple.2200": {
            contrast: 87.24481113218309,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34.5
        },
        "purple.2300": {
            contrast: 93.76474402871389,
            lc60: 75,
            lc45: 62.5,
            lc30: 49,
            lc10: 33
        },
        "purple.2400": {
            contrast: 100.47438642452511,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "purple.2500": {
            contrast: 107.36704799254578,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "purple.300": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 10.109456473073763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 14.707527119581822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 17.826254843871943,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "purple.1000": {
            contrast: 21.828124547127867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "purple.1100": {
            contrast: 26.232616479903086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "purple.1200": {
            contrast: 30.80314577915566,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 62.5
        },
        "purple.1300": {
            contrast: 36.05662203635519,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 56.5
        },
        "purple.1400": {
            contrast: 40.6583294095675,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 53
        },
        "purple.1500": {
            contrast: 45.9041113313362,
            lc60: 100,
            lc45: 98.5,
            lc30: 75.5,
            lc10: 49
        },
        "purple.1600": {
            contrast: 50.81596335359717,
            lc60: 100,
            lc45: 92.5,
            lc30: 71,
            lc10: 46.5
        },
        "purple.1700": {
            contrast: 56.50960072843153,
            lc60: 100,
            lc45: 86,
            lc30: 66.5,
            lc10: 43
        },
        "purple.1800": {
            contrast: 61.80483736001964,
            lc60: 97.5,
            lc45: 81,
            lc30: 62.5,
            lc10: 41
        },
        "purple.1900": {
            contrast: 67.71880734917441,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 59,
            lc10: 39
        },
        "purple.2000": {
            contrast: 73.62124644165377,
            lc60: 87,
            lc45: 72.5,
            lc30: 56,
            lc10: 37
        },
        "purple.2100": {
            contrast: 79.7385391586938,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 53,
            lc10: 35.5
        },
        "purple.2200": {
            contrast: 86.0613169242713,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 92.5812498208021,
            lc60: 75.5,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 32
        },
        "purple.2400": {
            contrast: 99.29089221661333,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 106.18355378463397,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "purple.400": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 8.367769199767029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 12.965839846275088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 16.08456757056521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "purple.1000": {
            contrast: 20.08643727382113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "purple.1100": {
            contrast: 24.49092920659636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "purple.1200": {
            contrast: 29.06145850584892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "purple.1300": {
            contrast: 34.314934763048456,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 57
        },
        "purple.1400": {
            contrast: 38.91664213626076,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 53
        },
        "purple.1500": {
            contrast: 44.162424058029465,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 49
        },
        "purple.1600": {
            contrast: 49.07427608029044,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 46
        },
        "purple.1700": {
            contrast: 54.767913455124784,
            lc60: 100,
            lc45: 87.5,
            lc30: 67,
            lc10: 43
        },
        "purple.1800": {
            contrast: 60.06315008671289,
            lc60: 99.5,
            lc45: 82.5,
            lc30: 63.5,
            lc10: 40.5
        },
        "purple.1900": {
            contrast: 65.97712007586767,
            lc60: 93.5,
            lc45: 77.5,
            lc30: 59.5,
            lc10: 39
        },
        "purple.2000": {
            contrast: 71.87955916834701,
            lc60: 88.5,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 36.5
        },
        "purple.2100": {
            contrast: 77.99685188538706,
            lc60: 84,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 35
        },
        "purple.2200": {
            contrast: 84.31962965096456,
            lc60: 80,
            lc45: 66,
            lc30: 51,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 90.83956254749536,
            lc60: 75.5,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "purple.2400": {
            contrast: 97.54920494330658,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 104.44186651132723,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29
        }
    },
    "purple.500": {
        "purple.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 10.56193980918392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 13.680667533474045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 17.682537236729964,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "purple.1100": {
            contrast: 22.087029169505193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "purple.1200": {
            contrast: 26.65755846875776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "purple.1300": {
            contrast: 31.911034725957293,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 59.5
        },
        "purple.1400": {
            contrast: 36.5127420991696,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 55
        },
        "purple.1500": {
            contrast: 41.7585240209383,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 50.5
        },
        "purple.1600": {
            contrast: 46.67037604319927,
            lc60: 100,
            lc45: 97.5,
            lc30: 74.5,
            lc10: 47.5
        },
        "purple.1700": {
            contrast: 52.36401341803363,
            lc60: 100,
            lc45: 90.5,
            lc30: 69,
            lc10: 44
        },
        "purple.1800": {
            contrast: 57.65925004962173,
            lc60: 100,
            lc45: 84.5,
            lc30: 64.5,
            lc10: 41.5
        },
        "purple.1900": {
            contrast: 63.57322003877651,
            lc60: 96,
            lc45: 79.5,
            lc30: 61,
            lc10: 39
        },
        "purple.2000": {
            contrast: 69.47565913125587,
            lc60: 90.5,
            lc45: 75,
            lc30: 57.5,
            lc10: 37
        },
        "purple.2100": {
            contrast: 75.5929518482959,
            lc60: 85.5,
            lc45: 71,
            lc30: 54.5,
            lc10: 35.5
        },
        "purple.2200": {
            contrast: 81.9157296138734,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 51.5,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 88.4356625104042,
            lc60: 77.5,
            lc45: 64,
            lc30: 49.5,
            lc10: 32
        },
        "purple.2400": {
            contrast: 95.14530490621542,
            lc60: 73.5,
            lc45: 61,
            lc30: 47,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 102.03796647423609,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 29
        }
    },
    "purple.600": {
        "purple.100": {
            contrast: 9.377397279489102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 8.684486664539167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 10.133775805337763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 14.135645508593687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 18.540137441368916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "purple.1200": {
            contrast: 23.11066674062148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "purple.1300": {
            contrast: 28.364142997821013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "purple.1400": {
            contrast: 32.96585037103332,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 59
        },
        "purple.1500": {
            contrast: 38.21163229280202,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 54
        },
        "purple.1600": {
            contrast: 43.12348431506299,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 50
        },
        "purple.1700": {
            contrast: 48.81712168989735,
            lc60: 100,
            lc45: 94.5,
            lc30: 73,
            lc10: 46.5
        },
        "purple.1800": {
            contrast: 54.11235832148545,
            lc60: 100,
            lc45: 88.5,
            lc30: 68.5,
            lc10: 44
        },
        "purple.1900": {
            contrast: 60.02632831064022,
            lc60: 99.5,
            lc45: 83,
            lc30: 64,
            lc10: 41
        },
        "purple.2000": {
            contrast: 65.9287674031196,
            lc60: 94,
            lc45: 78,
            lc30: 60,
            lc10: 39
        },
        "purple.2100": {
            contrast: 72.04606012015962,
            lc60: 88.5,
            lc45: 73.5,
            lc30: 57,
            lc10: 36.5
        },
        "purple.2200": {
            contrast: 78.36883788573711,
            lc60: 84,
            lc45: 70,
            lc30: 54,
            lc10: 35
        },
        "purple.2300": {
            contrast: 84.88877078226793,
            lc60: 79.5,
            lc45: 66,
            lc30: 51,
            lc10: 33
        },
        "purple.2400": {
            contrast: 91.59841317807914,
            lc60: 75.5,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "purple.2500": {
            contrast: 98.49107474609978,
            lc60: 72,
            lc45: 60,
            lc30: 46.5,
            lc10: 30
        }
    },
    "purple.700": {
        "purple.100": {
            contrast: 13.481017345375879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.200": {
            contrast: 12.788106730425945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.300": {
            contrast: 11.243673357583425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.400": {
            contrast: 9.047618773663691,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 10.553562063361957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 14.958053996137185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 19.52858329538975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "purple.1300": {
            contrast: 24.782059552589285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "purple.1400": {
            contrast: 29.383766925801584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "purple.1500": {
            contrast: 34.6295488475703,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 59
        },
        "purple.1600": {
            contrast: 39.541400869831264,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 54.5
        },
        "purple.1700": {
            contrast: 45.23503824466562,
            lc60: 100,
            lc45: 99.5,
            lc30: 77.5,
            lc10: 50
        },
        "purple.1800": {
            contrast: 50.53027487625372,
            lc60: 100,
            lc45: 92.5,
            lc30: 72,
            lc10: 46.5
        },
        "purple.1900": {
            contrast: 56.4442448654085,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 43.5
        },
        "purple.2000": {
            contrast: 62.34668395788785,
            lc60: 97.5,
            lc45: 81,
            lc30: 63,
            lc10: 41
        },
        "purple.2100": {
            contrast: 68.46397667492788,
            lc60: 92,
            lc45: 76.5,
            lc30: 59.5,
            lc10: 38.5
        },
        "purple.2200": {
            contrast: 74.78675444050539,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 36.5
        },
        "purple.2300": {
            contrast: 81.30668733703618,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "purple.2400": {
            contrast: 88.01632973284741,
            lc60: 78,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33
        },
        "purple.2500": {
            contrast: 94.90899130086805,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 31.5
        }
    },
    "purple.800": {
        "purple.100": {
            contrast: 18.39180063926081,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "purple.200": {
            contrast: 17.698890024310877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "purple.300": {
            contrast: 16.154456651468358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "purple.400": {
            contrast: 13.958402067548628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.500": {
            contrast: 11.036201731264297,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 10.524882620165357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 15.095411919417923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "purple.1300": {
            contrast: 20.348888176617457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "purple.1400": {
            contrast: 24.950595549829764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "purple.1500": {
            contrast: 30.196377471598467,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 61
        },
        "purple.1600": {
            contrast: 35.10822949385943,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 55.5
        },
        "purple.1700": {
            contrast: 40.80186686869379,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 49.5
        },
        "purple.1800": {
            contrast: 46.0971035002819,
            lc60: 100,
            lc45: 98,
            lc30: 74,
            lc10: 46.5
        },
        "purple.1900": {
            contrast: 52.011073489436676,
            lc60: 100,
            lc45: 90.5,
            lc30: 69,
            lc10: 42.5
        },
        "purple.2000": {
            contrast: 57.913512581916024,
            lc60: 100,
            lc45: 84.5,
            lc30: 63.5,
            lc10: 39.5
        },
        "purple.2100": {
            contrast: 64.03080529895607,
            lc60: 95.5,
            lc45: 78.5,
            lc30: 59.5,
            lc10: 37
        },
        "purple.2200": {
            contrast: 70.35358306453355,
            lc60: 89.5,
            lc45: 73.5,
            lc30: 55.5,
            lc10: 34.5
        },
        "purple.2300": {
            contrast: 76.87351596106436,
            lc60: 84,
            lc45: 69,
            lc30: 52.5,
            lc10: 32.5
        },
        "purple.2400": {
            contrast: 83.58315835687559,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 49.5,
            lc10: 31
        },
        "purple.2500": {
            contrast: 90.47581992489624,
            lc60: 75.5,
            lc45: 62,
            lc30: 47,
            lc10: 29.5
        }
    },
    "purple.900": {
        "purple.100": {
            contrast: 21.666314473251372,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "purple.200": {
            contrast: 20.973403858301438,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "purple.300": {
            contrast: 19.42897048545892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "purple.400": {
            contrast: 17.232915901539187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "purple.500": {
            contrast: 14.310715565254858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.600": {
            contrast: 10.162283955397486,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 7.492285289881891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 12.062814589134454,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 17.316290846333988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "purple.1400": {
            contrast: 21.9179982195463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "purple.1500": {
            contrast: 27.163780141315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "purple.1600": {
            contrast: 32.07563216357596,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 56.5
        },
        "purple.1700": {
            contrast: 37.76926953841032,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 50.5
        },
        "purple.1800": {
            contrast: 43.06450616999843,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 46
        },
        "purple.1900": {
            contrast: 48.9784761591532,
            lc60: 100,
            lc45: 94,
            lc30: 70,
            lc10: 41.5
        },
        "purple.2000": {
            contrast: 54.88091525163256,
            lc60: 100,
            lc45: 86.5,
            lc30: 64.5,
            lc10: 38.5
        },
        "purple.2100": {
            contrast: 60.99820796867259,
            lc60: 98.5,
            lc45: 80,
            lc30: 59.5,
            lc10: 35.5
        },
        "purple.2200": {
            contrast: 67.32098573425009,
            lc60: 92,
            lc45: 74.5,
            lc30: 55.5,
            lc10: 33
        },
        "purple.2300": {
            contrast: 73.84091863078089,
            lc60: 86,
            lc45: 70,
            lc30: 52,
            lc10: 31
        },
        "purple.2400": {
            contrast: 80.55056102659212,
            lc60: 80.5,
            lc45: 66,
            lc30: 49,
            lc10: 29
        },
        "purple.2500": {
            contrast: 87.44322259461276,
            lc60: 76,
            lc45: 62,
            lc30: 46,
            lc10: 27.5
        }
    },
    "purple.1000": {
        "purple.100": {
            contrast: 25.812470949963128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41
        },
        "purple.200": {
            contrast: 25.119560335013198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "purple.300": {
            contrast: 23.575126962170682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "purple.400": {
            contrast: 21.379072378250953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "purple.500": {
            contrast: 18.456872041966623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "purple.600": {
            contrast: 14.308440432109249,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.700": {
            contrast: 10.261739193150937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 8.14544923024596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 13.398925487445496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 18.0006328606578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "purple.1500": {
            contrast: 23.24641478242651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "purple.1600": {
            contrast: 28.15826680468747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "purple.1700": {
            contrast: 33.85190417952183,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 53
        },
        "purple.1800": {
            contrast: 39.147140811109935,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47.5
        },
        "purple.1900": {
            contrast: 45.0611108002647,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 42.5
        },
        "purple.2000": {
            contrast: 50.96354989274406,
            lc60: 100,
            lc45: 91,
            lc30: 67,
            lc10: 39
        },
        "purple.2100": {
            contrast: 57.0808426097841,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 36
        },
        "purple.2200": {
            contrast: 63.40362037536159,
            lc60: 96,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 33
        },
        "purple.2300": {
            contrast: 69.9235532718924,
            lc60: 89,
            lc45: 72,
            lc30: 53,
            lc10: 31
        },
        "purple.2400": {
            contrast: 76.63319566770362,
            lc60: 83.5,
            lc45: 67.5,
            lc30: 49,
            lc10: 29
        },
        "purple.2500": {
            contrast: 83.52585723572426,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 27
        }
    },
    "purple.1100": {
        "purple.100": {
            contrast: 30.313649551273635,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 35
        },
        "purple.200": {
            contrast: 29.620738936323704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "purple.300": {
            contrast: 28.07630556348118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "purple.400": {
            contrast: 25.880250979561453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "purple.500": {
            contrast: 22.95805064327713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "purple.600": {
            contrast: 18.809619033419757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "purple.700": {
            contrast: 14.762917794461442,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.800": {
            contrast: 9.902130966426673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 9.057794621502895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 13.659501994715201,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 18.905283916483906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "purple.1600": {
            contrast: 23.817135938744872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "purple.1700": {
            contrast: 29.51077331357923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "purple.1800": {
            contrast: 34.80600994516734,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51
        },
        "purple.1900": {
            contrast: 40.71997993432211,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 45.5
        },
        "purple.2000": {
            contrast: 46.62241902680147,
            lc60: 100,
            lc45: 97,
            lc30: 70.5,
            lc10: 41
        },
        "purple.2100": {
            contrast: 52.7397117438415,
            lc60: 100,
            lc45: 88.5,
            lc30: 64.5,
            lc10: 37
        },
        "purple.2200": {
            contrast: 59.062489509418995,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 33.5
        },
        "purple.2300": {
            contrast: 65.58242240594979,
            lc60: 93,
            lc45: 74.5,
            lc30: 54.5,
            lc10: 31
        },
        "purple.2400": {
            contrast: 72.29206480176103,
            lc60: 86.5,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "purple.2500": {
            contrast: 79.18472636978167,
            lc60: 80.5,
            lc45: 65,
            lc30: 47,
            lc10: 27
        }
    },
    "purple.1200": {
        "purple.100": {
            contrast: 34.92523364687459,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 31
        },
        "purple.200": {
            contrast: 34.23232303192466,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 35
        },
        "purple.300": {
            contrast: 32.68788965908213,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 38.5
        },
        "purple.400": {
            contrast: 30.491835075162406,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 42.5
        },
        "purple.500": {
            contrast: 27.569634738878072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "purple.600": {
            contrast: 23.421203129020704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "purple.700": {
            contrast: 19.374501890062394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "purple.800": {
            contrast: 14.513715062027623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.900": {
            contrast: 11.263307965368623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 9.125867223942423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 14.371649145711126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 19.283501167972094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "purple.1700": {
            contrast: 24.977138542806458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "purple.1800": {
            contrast: 30.27237517439456,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56
        },
        "purple.1900": {
            contrast: 36.186345163549326,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48
        },
        "purple.2000": {
            contrast: 42.08878425602868,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 43
        },
        "purple.2100": {
            contrast: 48.206076973068726,
            lc60: 100,
            lc45: 94.5,
            lc30: 68,
            lc10: 38.5
        },
        "purple.2200": {
            contrast: 54.52885473864622,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 35
        },
        "purple.2300": {
            contrast: 61.04878763517703,
            lc60: 98,
            lc45: 78.5,
            lc30: 56.5,
            lc10: 32
        },
        "purple.2400": {
            contrast: 67.75843003098824,
            lc60: 90.5,
            lc45: 72,
            lc30: 52,
            lc10: 29
        },
        "purple.2500": {
            contrast: 74.6510915990089,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 27
        }
    },
    "purple.1300": {
        "purple.100": {
            contrast: 40.161262120171884,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27.5
        },
        "purple.200": {
            contrast: 39.46835150522195,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30.5
        },
        "purple.300": {
            contrast: 37.923918132379434,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33
        },
        "purple.400": {
            contrast: 35.72786354845971,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 36
        },
        "purple.500": {
            contrast: 32.80566321217538,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 40
        },
        "purple.600": {
            contrast: 28.657231602318014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "purple.700": {
            contrast: 24.610530363359697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "purple.800": {
            contrast: 19.749743535324924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "purple.900": {
            contrast: 16.499336438665928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "purple.1000": {
            contrast: 12.374554872690672,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1100": {
            contrast: 7.886340335305032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 9.128513871500772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 14.040365893761741,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 19.7340032685961,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "purple.1800": {
            contrast: 25.0292399001842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "purple.1900": {
            contrast: 30.943209889338974,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 54
        },
        "purple.2000": {
            contrast: 36.84564898181833,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47
        },
        "purple.2100": {
            contrast: 42.962941698858366,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41.5
        },
        "purple.2200": {
            contrast: 49.285719464435864,
            lc60: 100,
            lc45: 92.5,
            lc30: 66.5,
            lc10: 36.5
        },
        "purple.2300": {
            contrast: 55.805652360966675,
            lc60: 100,
            lc45: 84,
            lc30: 60,
            lc10: 33
        },
        "purple.2400": {
            contrast: 62.515294756777884,
            lc60: 96.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        },
        "purple.2500": {
            contrast: 69.40795632479853,
            lc60: 89,
            lc45: 70,
            lc30: 50,
            lc10: 28
        }
    },
    "purple.1400": {
        "purple.100": {
            contrast: 44.69774288703743,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "purple.200": {
            contrast: 44.0048322720875,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "purple.300": {
            contrast: 42.46039889924498,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "purple.400": {
            contrast: 40.264344315325246,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31
        },
        "purple.500": {
            contrast: 37.34214397904092,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34
        },
        "purple.600": {
            contrast: 33.19371236918355,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 37.5
        },
        "purple.700": {
            contrast: 29.147011130225238,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "purple.800": {
            contrast: 24.286224302190465,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "purple.900": {
            contrast: 21.03581720553147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "purple.1000": {
            contrast: 16.911035639556214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "purple.1100": {
            contrast: 12.422821102170573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1200": {
            contrast: 7.814719579886963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 9.422513362341569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 15.116150737175927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "purple.1800": {
            contrast: 20.411387368764032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "purple.1900": {
            contrast: 26.3253573579188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "purple.2000": {
            contrast: 32.22779645039815,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 51
        },
        "purple.2100": {
            contrast: 38.34508916743819,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 44.5
        },
        "purple.2200": {
            contrast: 44.667866933015695,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 39
        },
        "purple.2300": {
            contrast: 51.1877998295465,
            lc60: 100,
            lc45: 89.5,
            lc30: 63.5,
            lc10: 35
        },
        "purple.2400": {
            contrast: 57.89744222535771,
            lc60: 100,
            lc45: 81,
            lc30: 57.5,
            lc10: 31.5
        },
        "purple.2500": {
            contrast: 64.79010379337835,
            lc60: 93.5,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 29
        }
    },
    "purple.1500": {
        "purple.100": {
            contrast: 49.81872189887193,
            lc60: 100,
            lc45: 72.5,
            lc30: 45,
            lc10: 22.5
        },
        "purple.200": {
            contrast: 49.125811283922005,
            lc60: 100,
            lc45: 79.5,
            lc30: 48.5,
            lc10: 24.5
        },
        "purple.300": {
            contrast: 47.58137791107948,
            lc60: 100,
            lc45: 87,
            lc30: 52,
            lc10: 26
        },
        "purple.400": {
            contrast: 45.38532332715975,
            lc60: 100,
            lc45: 97.5,
            lc30: 56,
            lc10: 27.5
        },
        "purple.500": {
            contrast: 42.463122990875426,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 29
        },
        "purple.600": {
            contrast: 38.31469138101806,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 32
        },
        "purple.700": {
            contrast: 34.267990142059745,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 35
        },
        "purple.800": {
            contrast: 29.407203314024976,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "purple.900": {
            contrast: 26.156796217365972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "purple.1000": {
            contrast: 22.032014651390718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "purple.1100": {
            contrast: 17.54380011400508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "purple.1200": {
            contrast: 12.93569859172147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1300": {
            contrast: 7.692914605228348,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 9.826097686260754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 15.121334317848861,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "purple.1900": {
            contrast: 21.03530430700363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "purple.2000": {
            contrast: 26.937743399482983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "purple.2100": {
            contrast: 33.05503611652302,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 49.5
        },
        "purple.2200": {
            contrast: 39.37781388210052,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 42.5
        },
        "purple.2300": {
            contrast: 45.89774677863132,
            lc60: 100,
            lc45: 98,
            lc30: 69,
            lc10: 37
        },
        "purple.2400": {
            contrast: 52.607389174442545,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 33
        },
        "purple.2500": {
            contrast: 59.50005074246319,
            lc60: 100,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 30
        }
    },
    "purple.1600": {
        "purple.100": {
            contrast: 54.569884313017525,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 21
        },
        "purple.200": {
            contrast: 53.87697369806759,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22.5
        },
        "purple.300": {
            contrast: 52.332540325225075,
            lc60: 100,
            lc45: 74.5,
            lc30: 46.5,
            lc10: 23
        },
        "purple.400": {
            contrast: 50.13648574130535,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "purple.500": {
            contrast: 47.214285405021016,
            lc60: 100,
            lc45: 91,
            lc30: 53.5,
            lc10: 26.5
        },
        "purple.600": {
            contrast: 43.06585379516365,
            lc60: 100,
            lc45: 100,
            lc30: 58.5,
            lc10: 28
        },
        "purple.700": {
            contrast: 39.019152556205334,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 30
        },
        "purple.800": {
            contrast: 34.15836572817056,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 37.5
        },
        "purple.900": {
            contrast: 30.907958631511562,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 44
        },
        "purple.1000": {
            contrast: 26.7831770655363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "purple.1100": {
            contrast: 22.294962528150666,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "purple.1200": {
            contrast: 17.68686100586706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "purple.1300": {
            contrast: 12.444077019373937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1400": {
            contrast: 7.893445064351509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 10.145237955553077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 16.059207944707847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "purple.2000": {
            contrast: 21.961647037187202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "purple.2100": {
            contrast: 28.078939754227232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "purple.2200": {
            contrast: 34.401717519804734,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 48
        },
        "purple.2300": {
            contrast: 40.92165041633554,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 40.5
        },
        "purple.2400": {
            contrast: 47.631292812146754,
            lc60: 100,
            lc45: 95,
            lc30: 67,
            lc10: 35.5
        },
        "purple.2500": {
            contrast: 54.5239543801674,
            lc60: 100,
            lc45: 85,
            lc30: 59.5,
            lc10: 31.5
        }
    },
    "purple.1700": {
        "purple.100": {
            contrast: 60.029413343156726,
            lc60: 97,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "purple.200": {
            contrast: 59.33650272820679,
            lc60: 100,
            lc45: 62,
            lc30: 40,
            lc10: 20.5
        },
        "purple.300": {
            contrast: 57.79206935536426,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "purple.400": {
            contrast: 55.59601477144454,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "purple.500": {
            contrast: 52.6738144351602,
            lc60: 100,
            lc45: 76,
            lc30: 47,
            lc10: 23.5
        },
        "purple.600": {
            contrast: 48.525382825302835,
            lc60: 100,
            lc45: 85.5,
            lc30: 50,
            lc10: 25
        },
        "purple.700": {
            contrast: 44.47868158634452,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 26
        },
        "purple.800": {
            contrast: 39.61789475830975,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32
        },
        "purple.900": {
            contrast: 36.36748766165075,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 37
        },
        "purple.1000": {
            contrast: 32.242706095675494,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 42.5
        },
        "purple.1100": {
            contrast: 27.754491558289857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "purple.1200": {
            contrast: 23.146390036006245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "purple.1300": {
            contrast: 17.903606049513126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "purple.1400": {
            contrast: 13.3529740944907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1500": {
            contrast: 8.20762113435153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 10.265880941862038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 16.16832003434139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "purple.2100": {
            contrast: 22.285612751381425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "purple.2200": {
            contrast: 28.608390516958927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "purple.2300": {
            contrast: 35.128323413489724,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 47
        },
        "purple.2400": {
            contrast: 41.83796580930095,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "purple.2500": {
            contrast: 48.73062737732159,
            lc60: 100,
            lc45: 93,
            lc30: 65,
            lc10: 35.5
        }
    },
    "purple.1800": {
        "purple.100": {
            contrast: 65.06498328445505,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "purple.200": {
            contrast: 64.37207266950512,
            lc60: 82,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "purple.300": {
            contrast: 62.82763929666258,
            lc60: 87.5,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "purple.400": {
            contrast: 60.63158471274286,
            lc60: 96.5,
            lc45: 62.5,
            lc30: 40,
            lc10: 20
        },
        "purple.500": {
            contrast: 57.70938437645854,
            lc60: 100,
            lc45: 67,
            lc30: 42.5,
            lc10: 21
        },
        "purple.600": {
            contrast: 53.56095276660117,
            lc60: 100,
            lc45: 73,
            lc30: 45,
            lc10: 22.5
        },
        "purple.700": {
            contrast: 49.51425152764285,
            lc60: 100,
            lc45: 81.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "purple.800": {
            contrast: 44.65346469960808,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28
        },
        "purple.900": {
            contrast: 41.403057602949076,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "purple.1000": {
            contrast: 37.27827603697382,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 37
        },
        "purple.1100": {
            contrast: 32.790061499588184,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 43
        },
        "purple.1200": {
            contrast: 28.181959977304572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "purple.1300": {
            contrast: 22.93917599081146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "purple.1400": {
            contrast: 18.388544035789028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "purple.1500": {
            contrast: 13.24319107564986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1600": {
            contrast: 8.462102227062191,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 10.757982334916344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 16.87527505195638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "purple.2200": {
            contrast: 23.198052817533878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "purple.2300": {
            contrast: 29.71798571406468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "purple.2400": {
            contrast: 36.4276281098759,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "purple.2500": {
            contrast: 43.32028967789655,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39
        }
    },
    "purple.1900": {
        "purple.100": {
            contrast: 70.64538493793631,
            lc60: 68.5,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "purple.200": {
            contrast: 69.95247432298638,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "purple.300": {
            contrast: 68.40804095014386,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "purple.400": {
            contrast: 66.21198636622412,
            lc60: 81.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "purple.500": {
            contrast: 63.2897860299398,
            lc60: 88.5,
            lc45: 59.5,
            lc30: 38,
            lc10: 19
        },
        "purple.600": {
            contrast: 59.141354420082436,
            lc60: 100,
            lc45: 63.5,
            lc30: 40,
            lc10: 20
        },
        "purple.700": {
            contrast: 55.09465318112412,
            lc60: 100,
            lc45: 68.5,
            lc30: 42,
            lc10: 21.5
        },
        "purple.800": {
            contrast: 50.233866353089354,
            lc60: 100,
            lc45: 82.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "purple.900": {
            contrast: 46.98345925643035,
            lc60: 100,
            lc45: 93,
            lc30: 55.5,
            lc10: 27.5
        },
        "purple.1000": {
            contrast: 42.858677690455096,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 31.5
        },
        "purple.1100": {
            contrast: 38.37046315306946,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 36.5
        },
        "purple.1200": {
            contrast: 33.76236163078584,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 42
        },
        "purple.1300": {
            contrast: 28.51957764429272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "purple.1400": {
            contrast: 23.968945689270296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "purple.1500": {
            contrast: 18.82359272913113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "purple.1600": {
            contrast: 14.042503880543459,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1700": {
            contrast: 8.540591965229336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 10.809216113830642,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 17.131993879408142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "purple.2300": {
            contrast: 23.65192677593895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "purple.2400": {
            contrast: 30.361569171750162,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 52
        },
        "purple.2500": {
            contrast: 37.25423073977081,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 43.5
        }
    },
    "purple.2000": {
        "purple.100": {
            contrast: 76.1728598910314,
            lc60: 63,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "purple.200": {
            contrast: 75.47994927608146,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "purple.300": {
            contrast: 73.93551590323894,
            lc60: 69,
            lc45: 49,
            lc30: 32.5,
            lc10: 16.5
        },
        "purple.400": {
            contrast: 71.7394613193192,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "purple.500": {
            contrast: 68.81726098303488,
            lc60: 77,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "purple.600": {
            contrast: 64.66882937317752,
            lc60: 84.5,
            lc45: 57,
            lc30: 36.5,
            lc10: 18.5
        },
        "purple.700": {
            contrast: 60.6221281342192,
            lc60: 97,
            lc45: 60.5,
            lc30: 38,
            lc10: 19
        },
        "purple.800": {
            contrast: 55.761341306184434,
            lc60: 100,
            lc45: 70.5,
            lc30: 44,
            lc10: 22
        },
        "purple.900": {
            contrast: 52.51093420952543,
            lc60: 100,
            lc45: 79.5,
            lc30: 49.5,
            lc10: 25
        },
        "purple.1000": {
            contrast: 48.386152643550176,
            lc60: 100,
            lc45: 90,
            lc30: 55.5,
            lc10: 28
        },
        "purple.1100": {
            contrast: 43.89793810616454,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31.5
        },
        "purple.1200": {
            contrast: 39.28983658388092,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 35.5
        },
        "purple.1300": {
            contrast: 34.047052597387804,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43
        },
        "purple.1400": {
            contrast: 29.49642064236538,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "purple.1500": {
            contrast: 24.35106768222621,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "purple.1600": {
            contrast: 19.56997883363854,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "purple.1700": {
            contrast: 14.068066918324416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1800": {
            contrast: 8.98638481245433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 11.054781204417097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 17.5747141009479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "purple.2400": {
            contrast: 24.28435649675912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "purple.2500": {
            contrast: 31.177018064779766,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 52
        }
    },
    "purple.2100": {
        "purple.100": {
            contrast: 81.86077089183266,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "purple.200": {
            contrast: 81.16786027688272,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "purple.300": {
            contrast: 79.6234269040402,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "purple.400": {
            contrast: 77.42737232012047,
            lc60: 65.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "purple.500": {
            contrast: 74.50517198383614,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "purple.600": {
            contrast: 70.35674037397878,
            lc60: 73.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "purple.700": {
            contrast: 66.31003913502046,
            lc60: 80,
            lc45: 54,
            lc30: 34.5,
            lc10: 17.5
        },
        "purple.800": {
            contrast: 61.44925230698569,
            lc60: 95,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "purple.900": {
            contrast: 58.1988452103267,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22.5
        },
        "purple.1000": {
            contrast: 54.07406364435143,
            lc60: 100,
            lc45: 77.5,
            lc30: 49,
            lc10: 24.5
        },
        "purple.1100": {
            contrast: 49.585849106965796,
            lc60: 100,
            lc45: 87.5,
            lc30: 55,
            lc10: 28
        },
        "purple.1200": {
            contrast: 44.977747584682184,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31.5
        },
        "purple.1300": {
            contrast: 39.73496359818906,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 37
        },
        "purple.1400": {
            contrast: 35.18433164316663,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42
        },
        "purple.1500": {
            contrast: 30.038978683027462,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50.5
        },
        "purple.1600": {
            contrast: 25.257889834439794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "purple.1700": {
            contrast: 19.755977919125673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "purple.1800": {
            contrast: 14.67429581325559,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.1900": {
            contrast: 9.035490112059588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 11.253754715966668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 17.963397111777883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "purple.2500": {
            contrast: 24.856058679798533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        }
    },
    "purple.2200": {
        "purple.100": {
            contrast: 87.69946120099071,
            lc60: 54,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "purple.200": {
            contrast: 87.00655058604077,
            lc60: 56,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "purple.300": {
            contrast: 85.46211721319825,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "purple.400": {
            contrast: 83.26606262927852,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "purple.500": {
            contrast: 80.3438622929942,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "purple.600": {
            contrast: 76.19543068313683,
            lc60: 66,
            lc45: 47,
            lc30: 30.5,
            lc10: 15.5
        },
        "purple.700": {
            contrast: 72.14872944417851,
            lc60: 70,
            lc45: 49,
            lc30: 31.5,
            lc10: 16.5
        },
        "purple.800": {
            contrast: 67.28794261614375,
            lc60: 81,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "purple.900": {
            contrast: 64.03753551948475,
            lc60: 89.5,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "purple.1000": {
            contrast: 59.91275395350949,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "purple.1100": {
            contrast: 55.42453941612385,
            lc60: 100,
            lc45: 76,
            lc30: 48.5,
            lc10: 25
        },
        "purple.1200": {
            contrast: 50.81643789384024,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 27.5
        },
        "purple.1300": {
            contrast: 45.57365390734712,
            lc60: 100,
            lc45: 98.5,
            lc30: 62,
            lc10: 31.5
        },
        "purple.1400": {
            contrast: 41.0230219523247,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 36
        },
        "purple.1500": {
            contrast: 35.87766899218553,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42.5
        },
        "purple.1600": {
            contrast: 31.09658014359785,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 50
        },
        "purple.1700": {
            contrast: 25.59466822828373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "purple.1800": {
            contrast: 20.512986122413647,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "purple.1900": {
            contrast: 14.874180421217648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2000": {
            contrast: 9.281796348163947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 11.407613510150133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 18.30027507817078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        }
    },
    "purple.2300": {
        "purple.100": {
            contrast: 93.68048538669683,
            lc60: 50,
            lc45: 37,
            lc30: 24,
            lc10: 12.5
        },
        "purple.200": {
            contrast: 92.98757477174689,
            lc60: 52,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "purple.300": {
            contrast: 91.44314139890437,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "purple.400": {
            contrast: 89.24708681498464,
            lc60: 55.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "purple.500": {
            contrast: 86.32488647870032,
            lc60: 57,
            lc45: 41.5,
            lc30: 27,
            lc10: 14.5
        },
        "purple.600": {
            contrast: 82.17645486884295,
            lc60: 60,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "purple.700": {
            contrast: 78.12975362988463,
            lc60: 62.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "purple.800": {
            contrast: 73.26896680184987,
            lc60: 71.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "purple.900": {
            contrast: 70.01855970519087,
            lc60: 78.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "purple.1000": {
            contrast: 65.89377813921561,
            lc60: 86.5,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "purple.1100": {
            contrast: 61.40556360182997,
            lc60: 96.5,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "purple.1200": {
            contrast: 56.79746207954636,
            lc60: 100,
            lc45: 75,
            lc30: 48,
            lc10: 25
        },
        "purple.1300": {
            contrast: 51.55467809305324,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 28
        },
        "purple.1400": {
            contrast: 47.004046138030816,
            lc60: 100,
            lc45: 95,
            lc30: 61,
            lc10: 31.5
        },
        "purple.1500": {
            contrast: 41.858693177891645,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 36.5
        },
        "purple.1600": {
            contrast: 37.07760432930397,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "purple.1700": {
            contrast: 31.57569241398985,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 48.5
        },
        "purple.1800": {
            contrast: 26.494010308119766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "purple.1900": {
            contrast: 20.855204606923767,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "purple.2000": {
            contrast: 15.262820533870064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "purple.2100": {
            contrast: 9.501262171653087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 11.517657696811284,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "purple.2400": {
        "purple.100": {
            contrast: 99.79641402523757,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "purple.200": {
            contrast: 99.10350341028763,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "purple.300": {
            contrast: 97.5590700374451,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "purple.400": {
            contrast: 95.36301545352536,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "purple.500": {
            contrast: 92.44081511724104,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "purple.600": {
            contrast: 88.29238350738368,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "purple.700": {
            contrast: 84.24568226842536,
            lc60: 57,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "purple.800": {
            contrast: 79.3848954403906,
            lc60: 64.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "purple.900": {
            contrast: 76.1344883437316,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "purple.1000": {
            contrast: 72.00970677775634,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "purple.1100": {
            contrast: 67.52149224037069,
            lc60: 84.5,
            lc45: 60,
            lc30: 39.5,
            lc10: 20.5
        },
        "purple.1200": {
            contrast: 62.91339071808709,
            lc60: 93.5,
            lc45: 66.5,
            lc30: 43,
            lc10: 22
        },
        "purple.1300": {
            contrast: 57.67060673159396,
            lc60: 100,
            lc45: 74,
            lc30: 48,
            lc10: 25
        },
        "purple.1400": {
            contrast: 53.11997477657153,
            lc60: 100,
            lc45: 82,
            lc30: 53.5,
            lc10: 27.5
        },
        "purple.1500": {
            contrast: 47.974621816432375,
            lc60: 100,
            lc45: 93,
            lc30: 61,
            lc10: 31.5
        },
        "purple.1600": {
            contrast: 43.1935329678447,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35.5
        },
        "purple.1700": {
            contrast: 37.69162105253057,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 41.5
        },
        "purple.1800": {
            contrast: 32.60993894666049,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 48
        },
        "purple.1900": {
            contrast: 26.97113324546449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "purple.2000": {
            contrast: 21.378749172410792,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "purple.2100": {
            contrast: 15.617190810193812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "purple.2200": {
            contrast: 9.696119515373018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "purple.2500": {
        "purple.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "purple.200": {
            contrast: 105.34776259773868,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 11.5
        },
        "purple.300": {
            contrast: 103.80332922489615,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "purple.400": {
            contrast: 101.60727464097643,
            lc60: 48,
            lc45: 35,
            lc30: 23.5,
            lc10: 12
        },
        "purple.500": {
            contrast: 98.68507430469208,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "purple.600": {
            contrast: 94.53664269483471,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "purple.700": {
            contrast: 90.4899414558764,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25,
            lc10: 13.5
        },
        "purple.800": {
            contrast: 85.62915462784163,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "purple.900": {
            contrast: 82.37874753118264,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "purple.1000": {
            contrast: 78.25396596520737,
            lc60: 69,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "purple.1100": {
            contrast: 73.76575142782174,
            lc60: 75.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "purple.1200": {
            contrast: 69.15764990553814,
            lc60: 83,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "purple.1300": {
            contrast: 63.914865919045006,
            lc60: 92,
            lc45: 65.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "purple.1400": {
            contrast: 59.364233964022574,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "purple.1500": {
            contrast: 54.2188810038834,
            lc60: 100,
            lc45: 81,
            lc30: 53.5,
            lc10: 27.5
        },
        "purple.1600": {
            contrast: 49.43779215529573,
            lc60: 100,
            lc45: 90,
            lc30: 59,
            lc10: 31
        },
        "purple.1700": {
            contrast: 43.935880239981614,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 35.5
        },
        "purple.1800": {
            contrast: 38.85419813411153,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 40.5
        },
        "purple.1900": {
            contrast: 33.21539243291552,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 47
        },
        "purple.2000": {
            contrast: 27.623008359861828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "purple.2100": {
            contrast: 21.86144999764485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "purple.2200": {
            contrast: 15.940378702824058,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "purple.2300": {
            contrast: 9.868269147861264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "purple.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$red = {
    "red.100": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 8.99933938517341,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 12.930704354893956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 17.357706246932928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "red.900": {
            contrast: 21.632519677872935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "red.1000": {
            contrast: 25.680706835622473,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "red.1100": {
            contrast: 30.63441828497517,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 68.5
        },
        "red.1200": {
            contrast: 33.88419632536158,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 65
        },
        "red.1300": {
            contrast: 38.23891487899771,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 60.5
        },
        "red.1400": {
            contrast: 42.612635485696096,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 56.5
        },
        "red.1500": {
            contrast: 47.22659056120414,
            lc60: 100,
            lc45: 97,
            lc30: 77,
            lc10: 53.5
        },
        "red.1600": {
            contrast: 52.40904212149671,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "red.1700": {
            contrast: 57.71491570011832,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 47.5
        },
        "red.1800": {
            contrast: 63.42516777646263,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "red.1900": {
            contrast: 69.00897938603612,
            lc60: 91.5,
            lc45: 77,
            lc30: 61,
            lc10: 42.5
        },
        "red.2000": {
            contrast: 75.04546607253786,
            lc60: 87,
            lc45: 73,
            lc30: 57.5,
            lc10: 40.5
        },
        "red.2100": {
            contrast: 81.46753817732639,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38.5
        },
        "red.2200": {
            contrast: 87.43842011894479,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "red.2300": {
            contrast: 94.0948932484666,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "red.2400": {
            contrast: 101.10402380615125,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "red.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "red.200": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 8.433072911527068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 12.364437881247618,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 16.791439773286584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "red.900": {
            contrast: 21.066253204226594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "red.1000": {
            contrast: 25.114440361976133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "red.1100": {
            contrast: 30.068151811328818,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 65
        },
        "red.1200": {
            contrast: 33.31792985171524,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 60.5
        },
        "red.1300": {
            contrast: 37.67264840535137,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 56.5
        },
        "red.1400": {
            contrast: 42.046369012049745,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52.5
        },
        "red.1500": {
            contrast: 46.66032408755779,
            lc60: 100,
            lc45: 97.5,
            lc30: 75,
            lc10: 49.5
        },
        "red.1600": {
            contrast: 51.84277564785037,
            lc60: 100,
            lc45: 91,
            lc30: 70.5,
            lc10: 46.5
        },
        "red.1700": {
            contrast: 57.14864922647197,
            lc60: 100,
            lc45: 85.5,
            lc30: 66.5,
            lc10: 44
        },
        "red.1800": {
            contrast: 62.858901302816285,
            lc60: 97,
            lc45: 80.5,
            lc30: 62,
            lc10: 41.5
        },
        "red.1900": {
            contrast: 68.44271291238978,
            lc60: 92,
            lc45: 76,
            lc30: 59,
            lc10: 39.5
        },
        "red.2000": {
            contrast: 74.47919959889153,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "red.2100": {
            contrast: 80.90127170368004,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 36
        },
        "red.2200": {
            contrast: 86.87215364529845,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34.5
        },
        "red.2300": {
            contrast: 93.52862677482025,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 33
        },
        "red.2400": {
            contrast: 100.5377573325049,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "red.2500": {
            contrast: 107.31846670945214,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "red.300": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 11.025690046624122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 15.452691938663094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "red.900": {
            contrast: 19.7275053696031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "red.1000": {
            contrast: 23.77569252735264,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "red.1100": {
            contrast: 28.729403976705335,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "red.1200": {
            contrast: 31.979182017091745,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 59
        },
        "red.1300": {
            contrast: 36.33390057072787,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 54.5
        },
        "red.1400": {
            contrast: 40.707621177426255,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 50.5
        },
        "red.1500": {
            contrast: 45.32157625293431,
            lc60: 100,
            lc45: 99,
            lc30: 75,
            lc10: 47.5
        },
        "red.1600": {
            contrast: 50.50402781322687,
            lc60: 100,
            lc45: 92.5,
            lc30: 70.5,
            lc10: 45
        },
        "red.1700": {
            contrast: 55.80990139184847,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42.5
        },
        "red.1800": {
            contrast: 61.52015346819278,
            lc60: 98,
            lc45: 81,
            lc30: 62,
            lc10: 40
        },
        "red.1900": {
            contrast: 67.10396507776628,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 59,
            lc10: 38
        },
        "red.2000": {
            contrast: 73.14045176426802,
            lc60: 87.5,
            lc45: 72.5,
            lc30: 56,
            lc10: 36.5
        },
        "red.2100": {
            contrast: 79.56252386905655,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "red.2200": {
            contrast: 85.53340581067495,
            lc60: 79,
            lc45: 65.5,
            lc30: 51,
            lc10: 33
        },
        "red.2300": {
            contrast: 92.18987894019676,
            lc60: 75.5,
            lc45: 62.5,
            lc30: 48,
            lc10: 32
        },
        "red.2400": {
            contrast: 99.19900949788139,
            lc60: 72,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "red.2500": {
            contrast: 105.97971887482862,
            lc60: 69,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "red.400": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 9.202599496828487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 13.629601388867457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 17.904414819807464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "red.1000": {
            contrast: 21.952601977557006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "red.1100": {
            contrast: 26.90631342690969,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "red.1200": {
            contrast: 30.156091467296115,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 59.5
        },
        "red.1300": {
            contrast: 34.51081002093224,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 54
        },
        "red.1400": {
            contrast: 38.88453062763062,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 50.5
        },
        "red.1500": {
            contrast: 43.49848570313866,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47
        },
        "red.1600": {
            contrast: 48.68093726343125,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 44.5
        },
        "red.1700": {
            contrast: 53.98681084205285,
            lc60: 100,
            lc45: 88,
            lc30: 67,
            lc10: 42
        },
        "red.1800": {
            contrast: 59.69706291839716,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 40
        },
        "red.1900": {
            contrast: 65.28087452797064,
            lc60: 94,
            lc45: 78,
            lc30: 59.5,
            lc10: 38
        },
        "red.2000": {
            contrast: 71.3173612144724,
            lc60: 88.5,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 36
        },
        "red.2100": {
            contrast: 77.73943331926093,
            lc60: 84,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 34.5
        },
        "red.2200": {
            contrast: 83.71031526087933,
            lc60: 80,
            lc45: 66.5,
            lc30: 51,
            lc10: 33
        },
        "red.2300": {
            contrast: 90.36678839040113,
            lc60: 76.5,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "red.2400": {
            contrast: 97.37591894808575,
            lc60: 72.5,
            lc45: 60.5,
            lc30: 46.5,
            lc10: 30.5
        },
        "red.2500": {
            contrast: 104.15662832503301,
            lc60: 69.5,
            lc45: 58,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "red.500": {
        "red.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 10.943910852663585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 15.218724283603596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "red.1000": {
            contrast: 19.266911441353134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "red.1100": {
            contrast: 24.220622890705826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "red.1200": {
            contrast: 27.470400931092236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "red.1300": {
            contrast: 31.825119484728358,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 55.5
        },
        "red.1400": {
            contrast: 36.198840091426746,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 51
        },
        "red.1500": {
            contrast: 40.8127951669348,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "red.1600": {
            contrast: 45.99524672722736,
            lc60: 100,
            lc45: 98,
            lc30: 73.5,
            lc10: 45
        },
        "red.1700": {
            contrast: 51.30112030584897,
            lc60: 100,
            lc45: 91,
            lc30: 69,
            lc10: 42.5
        },
        "red.1800": {
            contrast: 57.01137238219328,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 40.5
        },
        "red.1900": {
            contrast: 62.59518399176677,
            lc60: 97,
            lc45: 80,
            lc30: 60.5,
            lc10: 38.5
        },
        "red.2000": {
            contrast: 68.63167067826852,
            lc60: 91.5,
            lc45: 75,
            lc30: 57.5,
            lc10: 36.5
        },
        "red.2100": {
            contrast: 75.05374278305705,
            lc60: 86,
            lc45: 71,
            lc30: 54.5,
            lc10: 35
        },
        "red.2200": {
            contrast: 81.02462472467545,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 52,
            lc10: 33.5
        },
        "red.2300": {
            contrast: 87.68109785419725,
            lc60: 77.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32
        },
        "red.2400": {
            contrast: 94.69022841188189,
            lc60: 74,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 30.5
        },
        "red.2500": {
            contrast: 101.47093778882912,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        }
    },
    "red.600": {
        "red.100": {
            contrast: 10.419466771446096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 9.662129880528576,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 7.920852864967563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 11.340964896610387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 15.389152054359922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "red.1100": {
            contrast: 20.342863503712614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "red.1200": {
            contrast: 23.59264154409903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "red.1300": {
            contrast: 27.947360097735153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "red.1400": {
            contrast: 32.321080704433534,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 55
        },
        "red.1500": {
            contrast: 36.935035779941586,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 51.5
        },
        "red.1600": {
            contrast: 42.117487340234156,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 48
        },
        "red.1700": {
            contrast: 47.423360918855764,
            lc60: 100,
            lc45: 96.5,
            lc30: 73,
            lc10: 45.5
        },
        "red.1800": {
            contrast: 53.133612995200075,
            lc60: 100,
            lc45: 89,
            lc30: 68,
            lc10: 43
        },
        "red.1900": {
            contrast: 58.71742460477357,
            lc60: 100,
            lc45: 83.5,
            lc30: 64,
            lc10: 41
        },
        "red.2000": {
            contrast: 64.75391129127532,
            lc60: 94.5,
            lc45: 78.5,
            lc30: 60,
            lc10: 38.5
        },
        "red.2100": {
            contrast: 71.17598339606384,
            lc60: 89.5,
            lc45: 74,
            lc30: 57,
            lc10: 37
        },
        "red.2200": {
            contrast: 77.14686533768224,
            lc60: 84.5,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 35.5
        },
        "red.2300": {
            contrast: 83.80333846720406,
            lc60: 80,
            lc45: 67,
            lc30: 51.5,
            lc10: 33.5
        },
        "red.2400": {
            contrast: 90.81246902488868,
            lc60: 76.5,
            lc45: 63.5,
            lc30: 49.5,
            lc10: 32.5
        },
        "red.2500": {
            contrast: 97.59317840183591,
            lc60: 73,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        }
    },
    "red.700": {
        "red.100": {
            contrast: 14.687457263790904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.200": {
            contrast: 13.93012037287339,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.300": {
            contrast: 12.188843357312374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.400": {
            contrast: 9.901433795732675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 7.581466224482787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 11.629653382232325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 16.58336483158502,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "red.1200": {
            contrast: 19.833142871971436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "red.1300": {
            contrast: 24.187861425607558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "red.1400": {
            contrast: 28.56158203230594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "red.1500": {
            contrast: 33.17553710781399,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 56
        },
        "red.1600": {
            contrast: 38.35798866810656,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 51.5
        },
        "red.1700": {
            contrast: 43.663862246728165,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 48.5
        },
        "red.1800": {
            contrast: 49.37411432307247,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 45
        },
        "red.1900": {
            contrast: 54.957925932645956,
            lc60: 100,
            lc45: 87.5,
            lc30: 67,
            lc10: 43
        },
        "red.2000": {
            contrast: 60.99441261914771,
            lc60: 99,
            lc45: 82,
            lc30: 63.5,
            lc10: 40.5
        },
        "red.2100": {
            contrast: 67.41648472393624,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 38.5
        },
        "red.2200": {
            contrast: 73.38736666555464,
            lc60: 88,
            lc45: 73,
            lc30: 57,
            lc10: 37
        },
        "red.2300": {
            contrast: 80.04383979507645,
            lc60: 83,
            lc45: 69.5,
            lc30: 54,
            lc10: 35
        },
        "red.2400": {
            contrast: 87.05297035276108,
            lc60: 79,
            lc45: 66,
            lc30: 51.5,
            lc10: 34
        },
        "red.2500": {
            contrast: 93.8336797297083,
            lc60: 75.5,
            lc45: 63,
            lc30: 49,
            lc10: 32.5
        }
    },
    "red.800": {
        "red.100": {
            contrast: 19.3925922789712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "red.200": {
            contrast: 18.635255388053682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "red.300": {
            contrast: 16.893978372492665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "red.400": {
            contrast: 14.606568810912965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.500": {
            contrast: 11.36224481612181,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 7.3510316560069215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 12.304743105359616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 15.554521145746032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "red.1300": {
            contrast: 19.90923969938215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "red.1400": {
            contrast: 24.28296030608054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "red.1500": {
            contrast: 28.896915381588585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "red.1600": {
            contrast: 34.079366941881155,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 56.5
        },
        "red.1700": {
            contrast: 39.385240520502755,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 52.5
        },
        "red.1800": {
            contrast: 45.09549259684707,
            lc60: 100,
            lc45: 99.5,
            lc30: 76.5,
            lc10: 49
        },
        "red.1900": {
            contrast: 50.67930420642056,
            lc60: 100,
            lc45: 92.5,
            lc30: 71.5,
            lc10: 46.5
        },
        "red.2000": {
            contrast: 56.7157908929223,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 43.5
        },
        "red.2100": {
            contrast: 63.13786299771083,
            lc60: 96.5,
            lc45: 81,
            lc30: 63,
            lc10: 41
        },
        "red.2200": {
            contrast: 69.10874493932924,
            lc60: 91.5,
            lc45: 76.5,
            lc30: 60,
            lc10: 39.5
        },
        "red.2300": {
            contrast: 75.76521806885104,
            lc60: 86.5,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "red.2400": {
            contrast: 82.77434862653567,
            lc60: 82,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 36
        },
        "red.2500": {
            contrast: 89.5550580034829,
            lc60: 78,
            lc45: 65.5,
            lc30: 51.5,
            lc10: 34.5
        }
    },
    "red.900": {
        "red.100": {
            contrast: 23.854536174256044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "red.200": {
            contrast: 23.097199283338522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "red.300": {
            contrast: 21.355922267777512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "red.400": {
            contrast: 19.068512706197815,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "red.500": {
            contrast: 15.82418871140666,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "red.600": {
            contrast: 11.324367017935957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 8.135693293499893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 11.385471333886308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 15.740189887522432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "red.1400": {
            contrast: 20.113910494220814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "red.1500": {
            contrast: 24.727865569728866,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "red.1600": {
            contrast: 29.910317130021436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "red.1700": {
            contrast: 35.21619070864303,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 58.5
        },
        "red.1800": {
            contrast: 40.92644278498735,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 54
        },
        "red.1900": {
            contrast: 46.51025439456084,
            lc60: 100,
            lc45: 97.5,
            lc30: 76.5,
            lc10: 50.5
        },
        "red.2000": {
            contrast: 52.546741081062585,
            lc60: 100,
            lc45: 91,
            lc30: 71.5,
            lc10: 47
        },
        "red.2100": {
            contrast: 58.96881318585112,
            lc60: 100,
            lc45: 85,
            lc30: 67,
            lc10: 44.5
        },
        "red.2200": {
            contrast: 64.93969512746952,
            lc60: 95.5,
            lc45: 80.5,
            lc30: 63,
            lc10: 42.5
        },
        "red.2300": {
            contrast: 71.59616825699132,
            lc60: 90,
            lc45: 75.5,
            lc30: 60,
            lc10: 40.5
        },
        "red.2400": {
            contrast: 78.60529881467595,
            lc60: 85,
            lc45: 71.5,
            lc30: 57,
            lc10: 38
        },
        "red.2500": {
            contrast: 85.38600819162319,
            lc60: 81,
            lc45: 68.5,
            lc30: 54,
            lc10: 36.5
        }
    },
    "red.1000": {
        "red.100": {
            contrast: 28.018638267451436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "red.200": {
            contrast: 27.261301376533915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "red.300": {
            contrast: 25.520024360972904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "red.400": {
            contrast: 23.23261479939321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "red.500": {
            contrast: 19.98829080460205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "red.600": {
            contrast: 15.488469111131353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "red.700": {
            contrast: 11.275434181577907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 7.408500730239681,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 11.763219283875806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 16.13693989057419,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "red.1500": {
            contrast: 20.750894966082235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "red.1600": {
            contrast: 25.933346526374805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "red.1700": {
            contrast: 31.239220104996406,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 64.5
        },
        "red.1800": {
            contrast: 36.949472181340724,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 58.5
        },
        "red.1900": {
            contrast: 42.53328379091421,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 54.5
        },
        "red.2000": {
            contrast: 48.569770477415965,
            lc60: 100,
            lc45: 95,
            lc30: 75.5,
            lc10: 51
        },
        "red.2100": {
            contrast: 54.991842582204484,
            lc60: 100,
            lc45: 89,
            lc30: 70.5,
            lc10: 47.5
        },
        "red.2200": {
            contrast: 60.962724523822885,
            lc60: 98.5,
            lc45: 84,
            lc30: 66.5,
            lc10: 45.5
        },
        "red.2300": {
            contrast: 67.6191976533447,
            lc60: 93,
            lc45: 78.5,
            lc30: 63,
            lc10: 43
        },
        "red.2400": {
            contrast: 74.62832821102933,
            lc60: 88,
            lc45: 74.5,
            lc30: 59.5,
            lc10: 41
        },
        "red.2500": {
            contrast: 81.40903758797656,
            lc60: 83.5,
            lc45: 71,
            lc30: 56.5,
            lc10: 39
        }
    },
    "red.1100": {
        "red.100": {
            contrast: 33.04529223024395,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 32.5
        },
        "red.200": {
            contrast: 32.28795533932644,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 38.5
        },
        "red.300": {
            contrast: 30.54667832376542,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 44
        },
        "red.400": {
            contrast: 28.259268762185723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "red.500": {
            contrast: 25.014944767394564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "red.600": {
            contrast: 20.515123073923867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "red.700": {
            contrast: 16.302088144370426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "red.800": {
            contrast: 11.641076171253259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 11.23713190037604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 15.851086975884087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "red.1600": {
            contrast: 21.03353853617666,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "red.1700": {
            contrast: 26.33941211479826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "red.1800": {
            contrast: 32.049664191142575,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 66
        },
        "red.1900": {
            contrast: 37.63347580071606,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 60.5
        },
        "red.2000": {
            contrast: 43.66996248721781,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 56
        },
        "red.2100": {
            contrast: 50.09203459200634,
            lc60: 100,
            lc45: 94,
            lc30: 75.5,
            lc10: 52
        },
        "red.2200": {
            contrast: 56.062916533624744,
            lc60: 100,
            lc45: 88,
            lc30: 71,
            lc10: 49
        },
        "red.2300": {
            contrast: 62.71938966314655,
            lc60: 97.5,
            lc45: 83,
            lc30: 66.5,
            lc10: 46
        },
        "red.2400": {
            contrast: 69.72852022083119,
            lc60: 91.5,
            lc45: 78,
            lc30: 63,
            lc10: 44
        },
        "red.2500": {
            contrast: 76.5092295977784,
            lc60: 87,
            lc45: 74,
            lc30: 59.5,
            lc10: 41.5
        }
    },
    "red.1200": {
        "red.100": {
            contrast: 36.30684628696691,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30
        },
        "red.200": {
            contrast: 35.54950939604939,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 35
        },
        "red.300": {
            contrast: 33.80823238048838,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 39.5
        },
        "red.400": {
            contrast: 31.520822818908677,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 44.5
        },
        "red.500": {
            contrast: 28.276498824117525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "red.600": {
            contrast: 23.776677130646824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "red.700": {
            contrast: 19.56364220109338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "red.800": {
            contrast: 14.902630227976216,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.900": {
            contrast: 10.46917995090649,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 8.005000508282569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 12.618955583790617,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 17.80140714408319,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "red.1700": {
            contrast: 23.10728072270479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "red.1800": {
            contrast: 28.8175327990491,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "red.1900": {
            contrast: 34.40134440862259,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 59
        },
        "red.2000": {
            contrast: 40.43783109512434,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 54
        },
        "red.2100": {
            contrast: 46.859903199912864,
            lc60: 100,
            lc45: 97,
            lc30: 75.5,
            lc10: 49
        },
        "red.2200": {
            contrast: 52.830785141531265,
            lc60: 100,
            lc45: 90.5,
            lc30: 70.5,
            lc10: 46
        },
        "red.2300": {
            contrast: 59.48725827105308,
            lc60: 100,
            lc45: 84,
            lc30: 65.5,
            lc10: 43
        },
        "red.2400": {
            contrast: 66.49638882873771,
            lc60: 93.5,
            lc45: 78.5,
            lc30: 61,
            lc10: 40.5
        },
        "red.2500": {
            contrast: 73.27709820568494,
            lc60: 88,
            lc45: 73.5,
            lc30: 58,
            lc10: 38
        }
    },
    "red.1300": {
        "red.100": {
            contrast: 40.63763514279447,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "red.200": {
            contrast: 39.88029825187696,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "red.300": {
            contrast: 38.13902123631594,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 34.5
        },
        "red.400": {
            contrast: 35.85161167473625,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "red.500": {
            contrast: 32.60728767994509,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 44
        },
        "red.600": {
            contrast: 28.107465986474388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "red.700": {
            contrast: 23.894431056920947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "red.800": {
            contrast: 19.233419083803778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "red.900": {
            contrast: 14.799968806734057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1000": {
            contrast: 10.652367335510668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 8.268068375600706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 13.45051993589328,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 18.75639351451488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "red.1800": {
            contrast: 24.466645590859194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "red.1900": {
            contrast: 30.050457200432685,
            lc60: 100,
            lc45: 100,
            lc30: 99.5,
            lc10: 62.5
        },
        "red.2000": {
            contrast: 36.08694388693443,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 55
        },
        "red.2100": {
            contrast: 42.509015991722954,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 49.5
        },
        "red.2200": {
            contrast: 48.479897933341356,
            lc60: 100,
            lc45: 95,
            lc30: 72.5,
            lc10: 45.5
        },
        "red.2300": {
            contrast: 55.13637106286316,
            lc60: 100,
            lc45: 87,
            lc30: 66.5,
            lc10: 42
        },
        "red.2400": {
            contrast: 62.14550162054779,
            lc60: 97.5,
            lc45: 80.5,
            lc30: 61.5,
            lc10: 39
        },
        "red.2500": {
            contrast: 68.92621099749502,
            lc60: 91,
            lc45: 75.5,
            lc30: 57.5,
            lc10: 36.5
        }
    },
    "red.1400": {
        "red.100": {
            contrast: 44.946036522850406,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "red.200": {
            contrast: 44.188699631932884,
            lc60: 100,
            lc45: 100,
            lc30: 56,
            lc10: 27.5
        },
        "red.300": {
            contrast: 42.447422616371874,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "red.400": {
            contrast: 40.16001305479218,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34
        },
        "red.500": {
            contrast: 36.91568906000102,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 37.5
        },
        "red.600": {
            contrast: 32.41586736653032,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 43
        },
        "red.700": {
            contrast: 28.202832436976877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "red.800": {
            contrast: 23.541820463859718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "red.900": {
            contrast: 19.10837018678999,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "red.1000": {
            contrast: 14.960768715566603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1100": {
            contrast: 9.942660755291852,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 9.059762589121176,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 14.365636167742778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 20.075888244087093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "red.1900": {
            contrast: 25.659699853660577,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "red.2000": {
            contrast: 31.696186540162323,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 58
        },
        "red.2100": {
            contrast: 38.118258644950856,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 51
        },
        "red.2200": {
            contrast: 44.08914058656925,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 47
        },
        "red.2300": {
            contrast: 50.745613716091064,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 42.5
        },
        "red.2400": {
            contrast: 57.75474427377569,
            lc60: 100,
            lc45: 83.5,
            lc30: 63,
            lc10: 39
        },
        "red.2500": {
            contrast: 64.53545365072291,
            lc60: 95,
            lc45: 77.5,
            lc30: 58.5,
            lc10: 36
        }
    },
    "red.1500": {
        "red.100": {
            contrast: 49.45070930374808,
            lc60: 100,
            lc45: 73.5,
            lc30: 45,
            lc10: 22.5
        },
        "red.200": {
            contrast: 48.69337241283056,
            lc60: 100,
            lc45: 82.5,
            lc30: 50.5,
            lc10: 25.5
        },
        "red.300": {
            contrast: 46.952095397269545,
            lc60: 100,
            lc45: 91,
            lc30: 55,
            lc10: 27.5
        },
        "red.400": {
            contrast: 44.66468583568985,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "red.500": {
            contrast: 41.42036184089869,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "red.600": {
            contrast: 36.92054014742799,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36.5
        },
        "red.700": {
            contrast: 32.70750521787454,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 40.5
        },
        "red.800": {
            contrast: 28.046493244757375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "red.900": {
            contrast: 23.61304296768766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "red.1000": {
            contrast: 19.46544149646427,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "red.1100": {
            contrast: 14.447333536189522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1200": {
            contrast: 11.185347106501414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 9.712997844921208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 15.42324992126552,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "red.1900": {
            contrast: 21.00706153083901,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "red.2000": {
            contrast: 27.043548217340753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "red.2100": {
            contrast: 33.46562032212928,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 53.5
        },
        "red.2200": {
            contrast: 39.436502263747684,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 47.5
        },
        "red.2300": {
            contrast: 46.09297539326949,
            lc60: 100,
            lc45: 98,
            lc30: 72,
            lc10: 42.5
        },
        "red.2400": {
            contrast: 53.102105950954126,
            lc60: 100,
            lc45: 88,
            lc30: 65,
            lc10: 38
        },
        "red.2500": {
            contrast: 59.88281532790135,
            lc60: 100,
            lc45: 80.5,
            lc30: 59.5,
            lc10: 35
        }
    },
    "red.1600": {
        "red.100": {
            contrast: 54.46574648098434,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 21
        },
        "red.200": {
            contrast: 53.70840959006682,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 22.5
        },
        "red.300": {
            contrast: 51.967132574505804,
            lc60: 100,
            lc45: 77,
            lc30: 48.5,
            lc10: 24.5
        },
        "red.400": {
            contrast: 49.67972301292611,
            lc60: 100,
            lc45: 84,
            lc30: 52,
            lc10: 26
        },
        "red.500": {
            contrast: 46.43539901813495,
            lc60: 100,
            lc45: 95,
            lc30: 57,
            lc10: 28
        },
        "red.600": {
            contrast: 41.93557732466425,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 30.5
        },
        "red.700": {
            contrast: 37.7225423951108,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34
        },
        "red.800": {
            contrast: 33.06153042199364,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 38
        },
        "red.900": {
            contrast: 28.628080144923917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "red.1000": {
            contrast: 24.48047867370053,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "red.1100": {
            contrast: 19.46237071342578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "red.1200": {
            contrast: 16.200384283737673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "red.1300": {
            contrast: 11.862428132724254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1400": {
            contrast: 7.540031197718705,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 10.174127193441942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 15.757938803015433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "red.2000": {
            contrast: 21.794425489517177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "red.2100": {
            contrast: 28.2164975943057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "red.2200": {
            contrast: 34.18737953592411,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51
        },
        "red.2300": {
            contrast: 40.843852665445915,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44
        },
        "red.2400": {
            contrast: 47.85298322313054,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 39
        },
        "red.2500": {
            contrast: 54.63369260007778,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 35
        }
    },
    "red.1700": {
        "red.100": {
            contrast: 59.55585680987468,
            lc60: 100,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "red.200": {
            contrast: 58.79851991895717,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 21
        },
        "red.300": {
            contrast: 57.057242903396144,
            lc60: 100,
            lc45: 68.5,
            lc30: 43.5,
            lc10: 22
        },
        "red.400": {
            contrast: 54.76983334181645,
            lc60: 100,
            lc45: 73.5,
            lc30: 46,
            lc10: 23
        },
        "red.500": {
            contrast: 51.52550934702529,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 25
        },
        "red.600": {
            contrast: 47.02568765355459,
            lc60: 100,
            lc45: 92.5,
            lc30: 54,
            lc10: 26.5
        },
        "red.700": {
            contrast: 42.81265272400115,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29
        },
        "red.800": {
            contrast: 38.15164075088398,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 31.5
        },
        "red.900": {
            contrast: 33.71819047381426,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 35
        },
        "red.1000": {
            contrast: 29.570589002590868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39
        },
        "red.1100": {
            contrast: 24.552481042316124,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1200": {
            contrast: 21.290494612628017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "red.1300": {
            contrast: 16.952538461614594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "red.1400": {
            contrast: 12.630141526609048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1500": {
            contrast: 8.104109454916973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 10.360440159577571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 16.396926846079314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "red.2100": {
            contrast: 22.818998950867844,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "red.2200": {
            contrast: 28.78988089248624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.2300": {
            contrast: 35.44635402200805,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 48.5
        },
        "red.2400": {
            contrast: 42.45548457969268,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 42
        },
        "red.2500": {
            contrast: 49.23619395663991,
            lc60: 100,
            lc45: 92.5,
            lc30: 66.5,
            lc10: 37
        }
    },
    "red.1800": {
        "red.100": {
            contrast: 64.98838470124927,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "red.200": {
            contrast: 64.23104781033176,
            lc60: 83,
            lc45: 57.5,
            lc30: 37,
            lc10: 19
        },
        "red.300": {
            contrast: 62.489770794770735,
            lc60: 90,
            lc45: 61,
            lc30: 39,
            lc10: 20
        },
        "red.400": {
            contrast: 60.202361233191034,
            lc60: 99,
            lc45: 64,
            lc30: 41,
            lc10: 20.5
        },
        "red.500": {
            contrast: 56.95803723839988,
            lc60: 100,
            lc45: 69.5,
            lc30: 44,
            lc10: 22
        },
        "red.600": {
            contrast: 52.458215544929175,
            lc60: 100,
            lc45: 77,
            lc30: 47,
            lc10: 23
        },
        "red.700": {
            contrast: 48.24518061537574,
            lc60: 100,
            lc45: 87.5,
            lc30: 51,
            lc10: 25
        },
        "red.800": {
            contrast: 43.58416864225856,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 27
        },
        "red.900": {
            contrast: 39.150718365188844,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 29
        },
        "red.1000": {
            contrast: 35.003116893965455,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 31.5
        },
        "red.1100": {
            contrast: 29.985008933690704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 35
        },
        "red.1200": {
            contrast: 26.723022504002596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1300": {
            contrast: 22.385066352989178,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "red.1400": {
            contrast: 18.06266941798363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "red.1500": {
            contrast: 13.536637346291558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1600": {
            contrast: 8.49036883823636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 10.563782723538734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 16.98585482832726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "red.2200": {
            contrast: 22.956736769945664,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "red.2300": {
            contrast: 29.613209899467467,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "red.2400": {
            contrast: 36.622340457152106,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 47
        },
        "red.2500": {
            contrast: 43.40304983409933,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40.5
        }
    },
    "red.1900": {
        "red.100": {
            contrast: 70.2589651322685,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "red.200": {
            contrast: 69.50162824135099,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "red.300": {
            contrast: 67.76035122578996,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "red.400": {
            contrast: 65.47294166421027,
            lc60: 83.5,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "red.500": {
            contrast: 62.228617669419116,
            lc60: 92.5,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "red.600": {
            contrast: 57.72879597594841,
            lc60: 100,
            lc45: 66.5,
            lc30: 41.5,
            lc10: 21
        },
        "red.700": {
            contrast: 53.51576104639497,
            lc60: 100,
            lc45: 73.5,
            lc30: 45,
            lc10: 22.5
        },
        "red.800": {
            contrast: 48.854749073277794,
            lc60: 100,
            lc45: 84,
            lc30: 48.5,
            lc10: 23.5
        },
        "red.900": {
            contrast: 44.42129879620808,
            lc60: 100,
            lc45: 100,
            lc30: 52.5,
            lc10: 25.5
        },
        "red.1000": {
            contrast: 40.27369732498469,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 26.5
        },
        "red.1100": {
            contrast: 35.25558936470994,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 29.5
        },
        "red.1200": {
            contrast: 31.99360293502183,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 36
        },
        "red.1300": {
            contrast: 27.655646784008407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1400": {
            contrast: 23.333249849002865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.1500": {
            contrast: 18.807217777310793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "red.1600": {
            contrast: 13.760949269255592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1700": {
            contrast: 8.631726983321062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 11.259378005882581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 17.230259947500983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "red.2300": {
            contrast: 23.88673307702279,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "red.2400": {
            contrast: 30.89586363470742,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54
        },
        "red.2500": {
            contrast: 37.67657301165465,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45.5
        }
    },
    "red.2000": {
        "red.100": {
            contrast: 75.91438325955498,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15
        },
        "red.200": {
            contrast: 75.15704636863747,
            lc60: 66.5,
            lc45: 48,
            lc30: 31,
            lc10: 16
        },
        "red.300": {
            contrast: 73.41576935307646,
            lc60: 70,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "red.400": {
            contrast: 71.12835979149675,
            lc60: 74,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "red.500": {
            contrast: 67.8840357967056,
            lc60: 79.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "red.600": {
            contrast: 63.384214103234896,
            lc60: 88.5,
            lc45: 58.5,
            lc30: 37.5,
            lc10: 19
        },
        "red.700": {
            contrast: 59.17117917368145,
            lc60: 100,
            lc45: 63.5,
            lc30: 39.5,
            lc10: 20
        },
        "red.800": {
            contrast: 54.51016720056428,
            lc60: 100,
            lc45: 69.5,
            lc30: 42.5,
            lc10: 21
        },
        "red.900": {
            contrast: 50.07671692349456,
            lc60: 100,
            lc45: 78,
            lc30: 45,
            lc10: 22
        },
        "red.1000": {
            contrast: 45.929115452271176,
            lc60: 100,
            lc45: 92.5,
            lc30: 48.5,
            lc10: 23
        },
        "red.1100": {
            contrast: 40.91100749199642,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 25
        },
        "red.1200": {
            contrast: 37.64902106230832,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 30.5
        },
        "red.1300": {
            contrast: 33.3110649112949,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 36.5
        },
        "red.1400": {
            contrast: 28.988667976289346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "red.1500": {
            contrast: 24.462635904597278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.1600": {
            contrast: 19.41636739654208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "red.1700": {
            contrast: 14.287145110607547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1800": {
            contrast: 8.805256211202222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 11.016354997655123,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 17.67282812717693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "red.2400": {
            contrast: 24.681958684861563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "red.2500": {
            contrast: 31.462668061808785,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 52.5
        }
    },
    "red.2100": {
        "red.100": {
            contrast: 81.88654795859196,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "red.200": {
            contrast: 81.12921106767445,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "red.300": {
            contrast: 79.38793405211342,
            lc60: 63.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "red.400": {
            contrast: 77.10052449053373,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "red.500": {
            contrast: 73.85620049574257,
            lc60: 70,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "red.600": {
            contrast: 69.35637880227188,
            lc60: 75.5,
            lc45: 52,
            lc30: 34,
            lc10: 17.5
        },
        "red.700": {
            contrast: 65.14334387271843,
            lc60: 83,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18
        },
        "red.800": {
            contrast: 60.48233189960126,
            lc60: 97,
            lc45: 60,
            lc30: 37,
            lc10: 18.5
        },
        "red.900": {
            contrast: 56.048881622531546,
            lc60: 100,
            lc45: 64.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "red.1000": {
            contrast: 51.90128015130815,
            lc60: 100,
            lc45: 70.5,
            lc30: 41.5,
            lc10: 20.5
        },
        "red.1100": {
            contrast: 46.883172191033395,
            lc60: 100,
            lc45: 85,
            lc30: 45,
            lc10: 22
        },
        "red.1200": {
            contrast: 43.621185761345295,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 26
        },
        "red.1300": {
            contrast: 39.28322961033187,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 31
        },
        "red.1400": {
            contrast: 34.96083267532632,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 36.5
        },
        "red.1500": {
            contrast: 30.434800603634248,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 45
        },
        "red.1600": {
            contrast: 25.388532095579052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "red.1700": {
            contrast: 20.259309809644524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "red.1800": {
            contrast: 14.777420910239197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.1900": {
            contrast: 9.451967677721187,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 11.037422896539361,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 18.046553454223993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "red.2500": {
            contrast: 24.82726283117122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        }
    },
    "red.2200": {
        "red.100": {
            contrast: 87.40114403344587,
            lc60: 54,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "red.200": {
            contrast: 86.64380714252835,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "red.300": {
            contrast: 84.90253012696733,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "red.400": {
            contrast: 82.61512056538764,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "red.500": {
            contrast: 79.37079657059648,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "red.600": {
            contrast: 74.87097487712579,
            lc60: 67.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "red.700": {
            contrast: 70.65793994757233,
            lc60: 72.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "red.800": {
            contrast: 65.99692797445516,
            lc60: 79.5,
            lc45: 53,
            lc30: 34,
            lc10: 17.5
        },
        "red.900": {
            contrast: 61.56347769738545,
            lc60: 91.5,
            lc45: 56.5,
            lc30: 35,
            lc10: 18
        },
        "red.1000": {
            contrast: 57.415876226162055,
            lc60: 100,
            lc45: 60,
            lc30: 37,
            lc10: 18.5
        },
        "red.1100": {
            contrast: 52.397768265887315,
            lc60: 100,
            lc45: 67.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "red.1200": {
            contrast: 49.1357818361992,
            lc60: 100,
            lc45: 81,
            lc30: 46.5,
            lc10: 23
        },
        "red.1300": {
            contrast: 44.797825685185785,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27
        },
        "red.1400": {
            contrast: 40.47542875018023,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31.5
        },
        "red.1500": {
            contrast: 35.949396678488164,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38
        },
        "red.1600": {
            contrast: 30.903128170432964,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 46.5
        },
        "red.1700": {
            contrast: 25.773905884498433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "red.1800": {
            contrast: 20.29201698509311,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "red.1900": {
            contrast: 14.966563752575096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2000": {
            contrast: 9.245140827215032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 11.856117122041399,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 18.636826498988626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        }
    },
    "red.2300": {
        "red.100": {
            contrast: 93.50898689665044,
            lc60: 50,
            lc45: 37,
            lc30: 24.5,
            lc10: 12.5
        },
        "red.200": {
            contrast: 92.75165000573293,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "red.300": {
            contrast: 91.0103729901719,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "red.400": {
            contrast: 88.72296342859222,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "red.500": {
            contrast: 85.47863943380105,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "red.600": {
            contrast: 80.97881774033036,
            lc60: 60.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "red.700": {
            contrast: 76.76578281077691,
            lc60: 64,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "red.800": {
            contrast: 72.10477083765974,
            lc60: 68.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "red.900": {
            contrast: 67.67132056059002,
            lc60: 74,
            lc45: 50,
            lc30: 31.5,
            lc10: 16.5
        },
        "red.1000": {
            contrast: 63.52371908936664,
            lc60: 82.5,
            lc45: 52.5,
            lc30: 33,
            lc10: 17
        },
        "red.1100": {
            contrast: 58.50561112909188,
            lc60: 100,
            lc45: 57,
            lc30: 35,
            lc10: 17.5
        },
        "red.1200": {
            contrast: 55.24362469940378,
            lc60: 100,
            lc45: 67,
            lc30: 40.5,
            lc10: 20
        },
        "red.1300": {
            contrast: 50.90566854839036,
            lc60: 100,
            lc45: 79.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "red.1400": {
            contrast: 46.58327161338481,
            lc60: 100,
            lc45: 93.5,
            lc30: 54.5,
            lc10: 27
        },
        "red.1500": {
            contrast: 42.05723954169273,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "red.1600": {
            contrast: 37.01097103363754,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38.5
        },
        "red.1700": {
            contrast: 31.881748747703003,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46.5
        },
        "red.1800": {
            contrast: 26.39985984829768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "red.1900": {
            contrast: 21.07440661577967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "red.2000": {
            contrast: 15.352983690419606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "red.2100": {
            contrast: 9.303637697126597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 11.713054096587616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "red.2400": {
        "red.100": {
            contrast: 99.89813913449495,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "red.200": {
            contrast: 99.14080224357743,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12.5
        },
        "red.300": {
            contrast: 97.39952522801642,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 13
        },
        "red.400": {
            contrast: 95.11211566643671,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "red.500": {
            contrast: 91.86779167164556,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "red.600": {
            contrast: 87.36796997817487,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "red.700": {
            contrast: 83.15493504862141,
            lc60: 57.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "red.800": {
            contrast: 78.49392307550424,
            lc60: 61,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "red.900": {
            contrast: 74.06047279843453,
            lc60: 64.5,
            lc45: 45,
            lc30: 29,
            lc10: 15
        },
        "red.1000": {
            contrast: 69.91287132721114,
            lc60: 68.5,
            lc45: 46.5,
            lc30: 30,
            lc10: 15.5
        },
        "red.1100": {
            contrast: 64.89476336693639,
            lc60: 76.5,
            lc45: 50,
            lc30: 31,
            lc10: 16
        },
        "red.1200": {
            contrast: 61.63277693724829,
            lc60: 91.5,
            lc45: 57.5,
            lc30: 36,
            lc10: 18.5
        },
        "red.1300": {
            contrast: 57.29482078623486,
            lc60: 100,
            lc45: 66.5,
            lc30: 41.5,
            lc10: 21
        },
        "red.1400": {
            contrast: 52.97242385122931,
            lc60: 100,
            lc45: 76.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "red.1500": {
            contrast: 48.44639177953724,
            lc60: 100,
            lc45: 89.5,
            lc30: 55,
            lc10: 27.5
        },
        "red.1600": {
            contrast: 43.40012327148204,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "red.1700": {
            contrast: 38.270900985547506,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38
        },
        "red.1800": {
            contrast: 32.789012086142186,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 45.5
        },
        "red.1900": {
            contrast: 27.46355885362417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "red.2000": {
            contrast: 21.74213592826411,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "red.2100": {
            contrast: 15.692789934971103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "red.2200": {
            contrast: 10.100530819754026,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "red.2500": {
        "red.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "red.200": {
            contrast: 105.28333632177109,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 11.5
        },
        "red.300": {
            contrast: 103.54205930621008,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "red.400": {
            contrast: 101.25464974463038,
            lc60: 48,
            lc45: 35,
            lc30: 23.5,
            lc10: 12
        },
        "red.500": {
            contrast: 98.0103257498392,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "red.600": {
            contrast: 93.5105040563685,
            lc60: 51,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "red.700": {
            contrast: 89.29746912681506,
            lc60: 52.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "red.800": {
            contrast: 84.6364571536979,
            lc60: 55.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "red.900": {
            contrast: 80.20300687662817,
            lc60: 57.5,
            lc45: 41,
            lc30: 26.5,
            lc10: 13.5
        },
        "red.1000": {
            contrast: 76.05540540540478,
            lc60: 60.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14
        },
        "red.1100": {
            contrast: 71.03729744513004,
            lc60: 65,
            lc45: 44.5,
            lc30: 28.5,
            lc10: 15
        },
        "red.1200": {
            contrast: 67.77531101544193,
            lc60: 75.5,
            lc45: 51,
            lc30: 32.5,
            lc10: 16.5
        },
        "red.1300": {
            contrast: 63.4373548644285,
            lc60: 88.5,
            lc45: 58,
            lc30: 37,
            lc10: 18.5
        },
        "red.1400": {
            contrast: 59.11495792942295,
            lc60: 100,
            lc45: 66,
            lc30: 41.5,
            lc10: 21.5
        },
        "red.1500": {
            contrast: 54.58892585773087,
            lc60: 100,
            lc45: 76,
            lc30: 48,
            lc10: 24.5
        },
        "red.1600": {
            contrast: 49.54265734967569,
            lc60: 100,
            lc45: 88,
            lc30: 55.5,
            lc10: 28.5
        },
        "red.1700": {
            contrast: 44.41343506374116,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 33
        },
        "red.1800": {
            contrast: 38.93154616433583,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38.5
        },
        "red.1900": {
            contrast: 33.60609293181782,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 45.5
        },
        "red.2000": {
            contrast: 27.88467000645775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "red.2100": {
            contrast: 21.835324013164747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "red.2200": {
            contrast: 16.243064897947672,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "red.2300": {
            contrast: 10.04247011649673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "red.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$sky = {
    "sky.100": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 9.149152113849798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 13.22591958736922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 18.321682611742762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "sky.900": {
            contrast: 22.974953695318813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "sky.1000": {
            contrast: 28.40326762085162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "sky.1100": {
            contrast: 31.756110235907652,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 67.5
        },
        "sky.1200": {
            contrast: 36.69480218103717,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 62
        },
        "sky.1300": {
            contrast: 41.82328180856772,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 57.5
        },
        "sky.1400": {
            contrast: 46.26443100249285,
            lc60: 100,
            lc45: 98,
            lc30: 77.5,
            lc10: 54
        },
        "sky.1500": {
            contrast: 50.89300517046439,
            lc60: 100,
            lc45: 93,
            lc30: 73.5,
            lc10: 51
        },
        "sky.1600": {
            contrast: 56.113986390955894,
            lc60: 100,
            lc45: 87,
            lc30: 69,
            lc10: 48.5
        },
        "sky.1700": {
            contrast: 61.12225576253696,
            lc60: 98.5,
            lc45: 83,
            lc30: 66,
            lc10: 45.5
        },
        "sky.1800": {
            contrast: 66.2781059649632,
            lc60: 94,
            lc45: 79,
            lc30: 62,
            lc10: 43.5
        },
        "sky.1900": {
            contrast: 71.63512417330111,
            lc60: 89.5,
            lc45: 75,
            lc30: 59.5,
            lc10: 41.5
        },
        "sky.2000": {
            contrast: 77.29425361038213,
            lc60: 85.5,
            lc45: 71.5,
            lc30: 56.5,
            lc10: 39.5
        },
        "sky.2100": {
            contrast: 83.31405476069837,
            lc60: 81.5,
            lc45: 68.5,
            lc30: 54,
            lc10: 37.5
        },
        "sky.2200": {
            contrast: 89.21310152266025,
            lc60: 78,
            lc45: 65.5,
            lc30: 52,
            lc10: 36
        },
        "sky.2300": {
            contrast: 95.17679401555318,
            lc60: 75,
            lc45: 63,
            lc30: 49.5,
            lc10: 34.5
        },
        "sky.2400": {
            contrast: 101.50253619428344,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33
        },
        "sky.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "sky.200": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 8.777028014574894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 12.853795488094317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 17.94955851246786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "sky.900": {
            contrast: 22.602829596043907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "sky.1000": {
            contrast: 28.031143521576713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "sky.1100": {
            contrast: 31.383986136632746,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 64
        },
        "sky.1200": {
            contrast: 36.322678081762255,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 58
        },
        "sky.1300": {
            contrast: 41.451157709292815,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 53.5
        },
        "sky.1400": {
            contrast: 45.89230690321794,
            lc60: 100,
            lc45: 98.5,
            lc30: 76,
            lc10: 50
        },
        "sky.1500": {
            contrast: 50.520881071189486,
            lc60: 100,
            lc45: 92.5,
            lc30: 71.5,
            lc10: 47
        },
        "sky.1600": {
            contrast: 55.741862291681,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 44
        },
        "sky.1700": {
            contrast: 60.75013166326205,
            lc60: 99,
            lc45: 82,
            lc30: 63,
            lc10: 41.5
        },
        "sky.1800": {
            contrast: 65.9059818656883,
            lc60: 94,
            lc45: 77.5,
            lc30: 59.5,
            lc10: 39.5
        },
        "sky.1900": {
            contrast: 71.2630000740262,
            lc60: 89,
            lc45: 73.5,
            lc30: 57,
            lc10: 37.5
        },
        "sky.2000": {
            contrast: 76.92212951110722,
            lc60: 84.5,
            lc45: 70,
            lc30: 54.5,
            lc10: 35.5
        },
        "sky.2100": {
            contrast: 82.94193066142347,
            lc60: 80.5,
            lc45: 67,
            lc30: 51.5,
            lc10: 34
        },
        "sky.2200": {
            contrast: 88.84097742338535,
            lc60: 77,
            lc45: 64,
            lc30: 49,
            lc10: 32.5
        },
        "sky.2300": {
            contrast: 94.80466991627829,
            lc60: 73.5,
            lc45: 61,
            lc30: 47.5,
            lc10: 31
        },
        "sky.2400": {
            contrast: 101.13041209500852,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 29.5
        },
        "sky.2500": {
            contrast: 107.51260908382356,
            lc60: 68,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "sky.300": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 7.545766678539813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 11.622534152059236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 16.718297176432777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "sky.900": {
            contrast: 21.37156826000883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "sky.1000": {
            contrast: 26.79988218554163,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "sky.1100": {
            contrast: 30.152724800597664,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 62
        },
        "sky.1200": {
            contrast: 35.09141674572718,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 55.5
        },
        "sky.1300": {
            contrast: 40.21989637325773,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 50.5
        },
        "sky.1400": {
            contrast: 44.66104556718286,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 47
        },
        "sky.1500": {
            contrast: 49.2896197351544,
            lc60: 100,
            lc45: 93.5,
            lc30: 70.5,
            lc10: 44
        },
        "sky.1600": {
            contrast: 54.51060095564591,
            lc60: 100,
            lc45: 87.5,
            lc30: 66,
            lc10: 41
        },
        "sky.1700": {
            contrast: 59.51887032722697,
            lc60: 100,
            lc45: 82,
            lc30: 62,
            lc10: 38.5
        },
        "sky.1800": {
            contrast: 64.6747205296532,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 58,
            lc10: 36.5
        },
        "sky.1900": {
            contrast: 70.0317387379911,
            lc60: 89,
            lc45: 73.5,
            lc30: 55,
            lc10: 34.5
        },
        "sky.2000": {
            contrast: 75.69086817507214,
            lc60: 85,
            lc45: 69,
            lc30: 52.5,
            lc10: 33
        },
        "sky.2100": {
            contrast: 81.71066932538838,
            lc60: 80.5,
            lc45: 66,
            lc30: 49.5,
            lc10: 31.5
        },
        "sky.2200": {
            contrast: 87.60971608735026,
            lc60: 76.5,
            lc45: 63,
            lc30: 47.5,
            lc10: 29.5
        },
        "sky.2300": {
            contrast: 93.5734085802432,
            lc60: 73.5,
            lc45: 60,
            lc30: 45,
            lc10: 28.5
        },
        "sky.2400": {
            contrast: 99.89915075897343,
            lc60: 70,
            lc45: 57.5,
            lc30: 43.5,
            lc10: 27.5
        },
        "sky.2500": {
            contrast: 106.28134774778847,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26.5
        }
    },
    "sky.400": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 9.68980179361858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 14.78556481799212,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 19.43883590156817,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "sky.1000": {
            contrast: 24.867149827100977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "sky.1100": {
            contrast: 28.219992442157004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "sky.1200": {
            contrast: 33.15868438728652,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 55
        },
        "sky.1300": {
            contrast: 38.28716401481707,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 49.5
        },
        "sky.1400": {
            contrast: 42.7283132087422,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 45.5
        },
        "sky.1500": {
            contrast: 47.35688737671374,
            lc60: 100,
            lc45: 96,
            lc30: 71,
            lc10: 42
        },
        "sky.1600": {
            contrast: 52.577868597205246,
            lc60: 100,
            lc45: 89,
            lc30: 65.5,
            lc10: 39
        },
        "sky.1700": {
            contrast: 57.58613796878631,
            lc60: 100,
            lc45: 83,
            lc30: 61.5,
            lc10: 36.5
        },
        "sky.1800": {
            contrast: 62.74198817121255,
            lc60: 96.5,
            lc45: 78,
            lc30: 58,
            lc10: 34.5
        },
        "sky.1900": {
            contrast: 68.09900637955046,
            lc60: 91,
            lc45: 73.5,
            lc30: 54.5,
            lc10: 32.5
        },
        "sky.2000": {
            contrast: 73.75813581663148,
            lc60: 85.5,
            lc45: 69.5,
            lc30: 51.5,
            lc10: 31
        },
        "sky.2100": {
            contrast: 79.77793696694772,
            lc60: 81,
            lc45: 66,
            lc30: 48.5,
            lc10: 29.5
        },
        "sky.2200": {
            contrast: 85.6769837289096,
            lc60: 77,
            lc45: 62.5,
            lc30: 46.5,
            lc10: 28
        },
        "sky.2300": {
            contrast: 91.64067622180254,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 44,
            lc10: 27
        },
        "sky.2400": {
            contrast: 97.96641840053279,
            lc60: 70,
            lc45: 57,
            lc30: 42.5,
            lc10: 26
        },
        "sky.2500": {
            contrast: 104.34861538934783,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "sky.500": {
        "sky.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 11.987368271314027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 16.640639354890077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "sky.1000": {
            contrast: 22.068953280422885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "sky.1100": {
            contrast: 25.421795895478915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "sky.1200": {
            contrast: 30.360487840608428,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 57
        },
        "sky.1300": {
            contrast: 35.48896746813898,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 51
        },
        "sky.1400": {
            contrast: 39.930116662064115,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 46.5
        },
        "sky.1500": {
            contrast: 44.558690830035644,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 42.5
        },
        "sky.1600": {
            contrast: 49.779672050527154,
            lc60: 100,
            lc45: 92,
            lc30: 67,
            lc10: 39
        },
        "sky.1700": {
            contrast: 54.78794142210822,
            lc60: 100,
            lc45: 85.5,
            lc30: 62,
            lc10: 36.5
        },
        "sky.1800": {
            contrast: 59.94379162453446,
            lc60: 100,
            lc45: 80,
            lc30: 58.5,
            lc10: 34
        },
        "sky.1900": {
            contrast: 65.30080983287236,
            lc60: 93.5,
            lc45: 75,
            lc30: 54.5,
            lc10: 32
        },
        "sky.2000": {
            contrast: 70.95993926995338,
            lc60: 88,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 30.5
        },
        "sky.2100": {
            contrast: 76.97974042026962,
            lc60: 83,
            lc45: 66.5,
            lc30: 49,
            lc10: 28.5
        },
        "sky.2200": {
            contrast: 82.87878718223152,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 27
        },
        "sky.2300": {
            contrast: 88.84247967512445,
            lc60: 74.5,
            lc45: 60,
            lc30: 44,
            lc10: 26
        },
        "sky.2400": {
            contrast: 95.16822185385469,
            lc60: 71,
            lc45: 57.5,
            lc30: 42,
            lc10: 24.5
        },
        "sky.2500": {
            contrast: 101.55041884266973,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 23.5
        }
    },
    "sky.600": {
        "sky.100": {
            contrast: 10.583925744965377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.200": {
            contrast: 10.084643971197993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 8.472383760283089,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 7.887660878756858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 12.540931962332907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 17.969245887865714,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "sky.1100": {
            contrast: 21.322088502921748,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "sky.1200": {
            contrast: 26.260780448051257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "sky.1300": {
            contrast: 31.389260075581817,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 54.5
        },
        "sky.1400": {
            contrast: 35.830409269506944,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 49
        },
        "sky.1500": {
            contrast: 40.45898343747848,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44.5
        },
        "sky.1600": {
            contrast: 45.67996465796999,
            lc60: 100,
            lc45: 98.5,
            lc30: 71,
            lc10: 40.5
        },
        "sky.1700": {
            contrast: 50.68823402955105,
            lc60: 100,
            lc45: 91,
            lc30: 65.5,
            lc10: 37.5
        },
        "sky.1800": {
            contrast: 55.8440842319773,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 35
        },
        "sky.1900": {
            contrast: 61.20110244031519,
            lc60: 98,
            lc45: 78.5,
            lc30: 56.5,
            lc10: 32.5
        },
        "sky.2000": {
            contrast: 66.86023187739622,
            lc60: 92,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "sky.2100": {
            contrast: 72.88003302771246,
            lc60: 86,
            lc45: 69,
            lc30: 50,
            lc10: 28.5
        },
        "sky.2200": {
            contrast: 78.77907978967434,
            lc60: 81,
            lc45: 65,
            lc30: 47.5,
            lc10: 27
        },
        "sky.2300": {
            contrast: 84.74277228256727,
            lc60: 77,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "sky.2400": {
            contrast: 91.06851446129753,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24.5
        },
        "sky.2500": {
            contrast: 97.45071145011256,
            lc60: 69.5,
            lc45: 56,
            lc30: 41,
            lc10: 23.5
        }
    },
    "sky.700": {
        "sky.100": {
            contrast: 15.004278631008988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "sky.200": {
            contrast: 14.504996857241604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.300": {
            contrast: 12.8927366463267,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.400": {
            contrast: 10.45540354455369,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 8.639964034139625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 14.068277959672432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 17.421120574728466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.1200": {
            contrast: 22.35981251985798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "sky.1300": {
            contrast: 27.48829214738853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "sky.1400": {
            contrast: 31.929441341313662,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 53
        },
        "sky.1500": {
            contrast: 36.5580155092852,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 47.5
        },
        "sky.1600": {
            contrast: 41.77899672977671,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42.5
        },
        "sky.1700": {
            contrast: 46.787266101357766,
            lc60: 100,
            lc45: 96.5,
            lc30: 69,
            lc10: 39
        },
        "sky.1800": {
            contrast: 51.94311630378401,
            lc60: 100,
            lc45: 89,
            lc30: 64,
            lc10: 36
        },
        "sky.1900": {
            contrast: 57.3001345121219,
            lc60: 100,
            lc45: 82.5,
            lc30: 59,
            lc10: 33
        },
        "sky.2000": {
            contrast: 62.95926394920293,
            lc60: 96,
            lc45: 76.5,
            lc30: 55,
            lc10: 31
        },
        "sky.2100": {
            contrast: 68.97906509951916,
            lc60: 89.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "sky.2200": {
            contrast: 74.87811186148106,
            lc60: 84,
            lc45: 67.5,
            lc30: 48.5,
            lc10: 27.5
        },
        "sky.2300": {
            contrast: 80.84180435437399,
            lc60: 79,
            lc45: 63.5,
            lc30: 46.5,
            lc10: 26
        },
        "sky.2400": {
            contrast: 87.16754653310424,
            lc60: 75,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 25
        },
        "sky.2500": {
            contrast: 93.54974352191925,
            lc60: 71.5,
            lc45: 57,
            lc30: 41.5,
            lc10: 23.5
        }
    },
    "sky.800": {
        "sky.100": {
            contrast: 20.40517670923636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "sky.200": {
            contrast: 19.90589493546898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "sky.300": {
            contrast: 18.293634724554074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "sky.400": {
            contrast: 15.856301622781062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "sky.500": {
            contrast: 12.469114544972692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.600": {
            contrast: 7.712966279404795,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 9.136453471507103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 12.489296086563137,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 17.42798803169265,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "sky.1300": {
            contrast: 22.556467659223202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "sky.1400": {
            contrast: 26.997616853148333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "sky.1500": {
            contrast: 31.626191021119865,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "sky.1600": {
            contrast: 36.84717224161138,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 46.5
        },
        "sky.1700": {
            contrast: 41.85544161319243,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42
        },
        "sky.1800": {
            contrast: 47.011291815618684,
            lc60: 100,
            lc45: 96.5,
            lc30: 69,
            lc10: 39
        },
        "sky.1900": {
            contrast: 52.368310023956575,
            lc60: 100,
            lc45: 88.5,
            lc30: 63.5,
            lc10: 35.5
        },
        "sky.2000": {
            contrast: 58.02743946103761,
            lc60: 100,
            lc45: 81.5,
            lc30: 58,
            lc10: 33
        },
        "sky.2100": {
            contrast: 64.04724061135386,
            lc60: 94.5,
            lc45: 75,
            lc30: 54,
            lc10: 30.5
        },
        "sky.2200": {
            contrast: 69.94628737331574,
            lc60: 88.5,
            lc45: 70.5,
            lc30: 51,
            lc10: 29
        },
        "sky.2300": {
            contrast: 75.90997986620867,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 48,
            lc10: 27
        },
        "sky.2400": {
            contrast: 82.2357220449389,
            lc60: 78.5,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 25.5
        },
        "sky.2500": {
            contrast: 88.61791903375395,
            lc60: 74,
            lc45: 59.5,
            lc30: 43,
            lc10: 24.5
        }
    },
    "sky.900": {
        "sky.100": {
            contrast: 25.241538044251115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41.5
        },
        "sky.200": {
            contrast: 24.74225627048374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "sky.300": {
            contrast: 23.129996059568832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "sky.400": {
            contrast: 20.69266295779582,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "sky.500": {
            contrast: 17.30547587998745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "sky.600": {
            contrast: 12.549327614419553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.700": {
            contrast: 8.184989951310602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 7.941490903165999,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 12.88018284829551,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 18.008662475826064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "sky.1400": {
            contrast: 22.4498116697512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.1500": {
            contrast: 27.078385837722728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "sky.1600": {
            contrast: 32.29936705821424,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51
        },
        "sky.1700": {
            contrast: 37.3076364297953,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46.5
        },
        "sky.1800": {
            contrast: 42.46348663222154,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "sky.1900": {
            contrast: 47.820504840559444,
            lc60: 100,
            lc45: 95,
            lc30: 67.5,
            lc10: 38
        },
        "sky.2000": {
            contrast: 53.479634277640464,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 35
        },
        "sky.2100": {
            contrast: 59.499435427956705,
            lc60: 100,
            lc45: 79.5,
            lc30: 57,
            lc10: 32
        },
        "sky.2200": {
            contrast: 65.3984821899186,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 53.5,
            lc10: 30
        },
        "sky.2300": {
            contrast: 71.36217468281151,
            lc60: 87,
            lc45: 69.5,
            lc30: 50,
            lc10: 28
        },
        "sky.2400": {
            contrast: 77.68791686154177,
            lc60: 81.5,
            lc45: 65,
            lc30: 47,
            lc10: 26.5
        },
        "sky.2500": {
            contrast: 84.0701138503568,
            lc60: 77,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 25
        }
    },
    "sky.1000": {
        "sky.100": {
            contrast: 30.789975740814036,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 35
        },
        "sky.200": {
            contrast: 30.290693967046657,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 40
        },
        "sky.300": {
            contrast: 28.67843375613175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "sky.400": {
            contrast: 26.24110065435874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "sky.500": {
            contrast: 22.853913576550376,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "sky.600": {
            contrast: 18.097765310982474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "sky.700": {
            contrast: 13.733427647873524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.800": {
            contrast: 8.380704403256651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 7.530406484133222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 12.658886111663778,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 17.10003530558891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.1500": {
            contrast: 21.728609473560443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "sky.1600": {
            contrast: 26.94959069405195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "sky.1700": {
            contrast: 31.95786006563301,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52.5
        },
        "sky.1800": {
            contrast: 37.11371026805925,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46.5
        },
        "sky.1900": {
            contrast: 42.470728476397156,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        },
        "sky.2000": {
            contrast: 48.12985791347817,
            lc60: 100,
            lc45: 94.5,
            lc30: 67.5,
            lc10: 37.5
        },
        "sky.2100": {
            contrast: 54.14965906379442,
            lc60: 100,
            lc45: 85.5,
            lc30: 62,
            lc10: 34
        },
        "sky.2200": {
            contrast: 60.04870582575631,
            lc60: 99.5,
            lc45: 79.5,
            lc30: 57,
            lc10: 31.5
        },
        "sky.2300": {
            contrast: 66.01239831864925,
            lc60: 92.5,
            lc45: 74,
            lc30: 53,
            lc10: 30
        },
        "sky.2400": {
            contrast: 72.33814049737947,
            lc60: 86.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 28.5
        },
        "sky.2500": {
            contrast: 78.72033748619451,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 27
        }
    },
    "sky.1100": {
        "sky.100": {
            contrast: 34.174085101830954,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 31.5
        },
        "sky.200": {
            contrast: 33.674803328063575,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 36.5
        },
        "sky.300": {
            contrast: 32.062543117148664,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 41.5
        },
        "sky.400": {
            contrast: 29.625210015375657,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "sky.500": {
            contrast: 26.23802293756729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.600": {
            contrast: 21.481874671999392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.700": {
            contrast: 17.117537008890444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.800": {
            contrast: 11.764813764273569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 9.33368065342138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 13.774829847346512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 18.403404015318046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "sky.1600": {
            contrast: 23.624385235809562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "sky.1700": {
            contrast: 28.632654607390613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.1800": {
            contrast: 33.78850480981686,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 49
        },
        "sky.1900": {
            contrast: 39.14552301815476,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43.5
        },
        "sky.2000": {
            contrast: 44.804652455235775,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 38.5
        },
        "sky.2100": {
            contrast: 50.82445360555202,
            lc60: 100,
            lc45: 90.5,
            lc30: 64.5,
            lc10: 35
        },
        "sky.2200": {
            contrast: 56.723500367513914,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 32.5
        },
        "sky.2300": {
            contrast: 62.68719286040684,
            lc60: 96.5,
            lc45: 77,
            lc30: 54.5,
            lc10: 30.5
        },
        "sky.2400": {
            contrast: 69.01293503913709,
            lc60: 89,
            lc45: 71,
            lc30: 50.5,
            lc10: 28
        },
        "sky.2500": {
            contrast: 75.39513202795212,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 47.5,
            lc10: 26
        }
    },
    "sky.1200": {
        "sky.100": {
            contrast: 39.10693439076658,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28
        },
        "sky.200": {
            contrast: 38.60765261699921,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 31.5
        },
        "sky.300": {
            contrast: 36.99539240608431,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 35.5
        },
        "sky.400": {
            contrast: 34.55805930431129,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 40.5
        },
        "sky.500": {
            contrast: 31.170872226502922,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 47
        },
        "sky.600": {
            contrast: 26.414723960935028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "sky.700": {
            contrast: 22.050386297826073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "sky.800": {
            contrast: 16.6976630532092,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "sky.900": {
            contrast: 11.888780393295361,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 8.85113955721624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 13.479713725187773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 18.700694945679285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "sky.1700": {
            contrast: 23.708964317260342,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "sky.1800": {
            contrast: 28.864814519686583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.1900": {
            contrast: 34.22183272802449,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 48.5
        },
        "sky.2000": {
            contrast: 39.8809621651055,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 42.5
        },
        "sky.2100": {
            contrast: 45.90076331542175,
            lc60: 100,
            lc45: 98,
            lc30: 69.5,
            lc10: 38.5
        },
        "sky.2200": {
            contrast: 51.79981007738365,
            lc60: 100,
            lc45: 88.5,
            lc30: 63.5,
            lc10: 34.5
        },
        "sky.2300": {
            contrast: 57.76350257027657,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 31.5
        },
        "sky.2400": {
            contrast: 64.08924474900681,
            lc60: 94.5,
            lc45: 74.5,
            lc30: 53.5,
            lc10: 29.5
        },
        "sky.2500": {
            contrast: 70.47144173782185,
            lc60: 87.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 27.5
        }
    },
    "sky.1300": {
        "sky.100": {
            contrast: 44.17133883222164,
            lc60: 100,
            lc45: 100,
            lc30: 51,
            lc10: 25.5
        },
        "sky.200": {
            contrast: 43.672057058454264,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28.5
        },
        "sky.300": {
            contrast: 42.05979684753936,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31.5
        },
        "sky.400": {
            contrast: 39.62246374576635,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "sky.500": {
            contrast: 36.23527666795798,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "sky.600": {
            contrast: 31.479128402390078,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 47.5
        },
        "sky.700": {
            contrast: 27.11479073928113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "sky.800": {
            contrast: 21.76206749466426,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.900": {
            contrast: 16.95318483475042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "sky.1000": {
            contrast: 11.420890419857724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1100": {
            contrast: 8.039526857141329,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 8.337617214292242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 13.558598434783756,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 18.56686780636481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "sky.1800": {
            contrast: 23.72271800879106,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "sky.1900": {
            contrast: 29.079736217128954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "sky.2000": {
            contrast: 34.738865654209974,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 47.5
        },
        "sky.2100": {
            contrast: 40.75866680452622,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 41.5
        },
        "sky.2200": {
            contrast: 46.65771356648811,
            lc60: 100,
            lc45: 96.5,
            lc30: 68.5,
            lc10: 37.5
        },
        "sky.2300": {
            contrast: 52.62140605938104,
            lc60: 100,
            lc45: 88,
            lc30: 62,
            lc10: 34
        },
        "sky.2400": {
            contrast: 58.94714823811128,
            lc60: 100,
            lc45: 79.5,
            lc30: 57,
            lc10: 31
        },
        "sky.2500": {
            contrast: 65.32934522692632,
            lc60: 93,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 29
        }
    },
    "sky.1400": {
        "sky.100": {
            contrast: 48.5145612995213,
            lc60: 100,
            lc45: 76,
            lc30: 46,
            lc10: 23.5
        },
        "sky.200": {
            contrast: 48.01527952575392,
            lc60: 100,
            lc45: 84,
            lc30: 51,
            lc10: 26
        },
        "sky.300": {
            contrast: 46.403019314839014,
            lc60: 100,
            lc45: 93,
            lc30: 56.5,
            lc10: 28.5
        },
        "sky.400": {
            contrast: 43.965686213066,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 32
        },
        "sky.500": {
            contrast: 40.57849913525763,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "sky.600": {
            contrast: 35.822350869689735,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40.5
        },
        "sky.700": {
            contrast: 31.45801320658078,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 46.5
        },
        "sky.800": {
            contrast: 26.105289961963912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.900": {
            contrast: 21.29640730205007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.1000": {
            contrast: 15.764112887157374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "sky.1100": {
            contrast: 12.382749324440978,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1200": {
            contrast: 7.445299141244038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 9.083961119813793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 14.092230491394849,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 19.248080693821095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "sky.1900": {
            contrast: 24.605098902158993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "sky.2000": {
            contrast: 30.264228339240013,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "sky.2100": {
            contrast: 36.28402948955626,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 46
        },
        "sky.2200": {
            contrast: 42.183076251518145,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 40.5
        },
        "sky.2300": {
            contrast: 48.146768744411084,
            lc60: 100,
            lc45: 94,
            lc30: 66.5,
            lc10: 36.5
        },
        "sky.2400": {
            contrast: 54.472510923141314,
            lc60: 100,
            lc45: 85.5,
            lc30: 60.5,
            lc10: 33.5
        },
        "sky.2500": {
            contrast: 60.85470791195635,
            lc60: 98.5,
            lc45: 77.5,
            lc30: 55.5,
            lc10: 30.5
        }
    },
    "sky.1500": {
        "sky.100": {
            contrast: 53.00330625892802,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "sky.200": {
            contrast: 52.50402448516064,
            lc60: 100,
            lc45: 73.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "sky.300": {
            contrast: 50.89176427424573,
            lc60: 100,
            lc45: 80.5,
            lc30: 51,
            lc10: 26
        },
        "sky.400": {
            contrast: 48.454431172472724,
            lc60: 100,
            lc45: 89,
            lc30: 56.5,
            lc10: 28.5
        },
        "sky.500": {
            contrast: 45.067244094664346,
            lc60: 100,
            lc45: 99.5,
            lc30: 63,
            lc10: 31.5
        },
        "sky.600": {
            contrast: 40.31109582909645,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 35.5
        },
        "sky.700": {
            contrast: 35.946758165987504,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40.5
        },
        "sky.800": {
            contrast: 30.59403492137062,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 48.5
        },
        "sky.900": {
            contrast: 25.78515226145679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "sky.1000": {
            contrast: 20.252857846564094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "sky.1100": {
            contrast: 16.8714942838477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "sky.1200": {
            contrast: 11.934044100650757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 9.409176955918861,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 14.565027158345107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 19.922045366683005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "sky.2000": {
            contrast: 25.58117480376402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "sky.2100": {
            contrast: 31.60097595408027,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 51.5
        },
        "sky.2200": {
            contrast: 37.50002271604216,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "sky.2300": {
            contrast: 43.46371520893509,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        },
        "sky.2400": {
            contrast: 49.78945738766534,
            lc60: 100,
            lc45: 91.5,
            lc30: 65,
            lc10: 36
        },
        "sky.2500": {
            contrast: 56.17165437648036,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 32.5
        }
    },
    "sky.1600": {
        "sky.100": {
            contrast: 58.02450320770176,
            lc60: 100,
            lc45: 60,
            lc30: 39,
            lc10: 19.5
        },
        "sky.200": {
            contrast: 57.52522143393437,
            lc60: 100,
            lc45: 66,
            lc30: 42.5,
            lc10: 21.5
        },
        "sky.300": {
            contrast: 55.91296122301947,
            lc60: 100,
            lc45: 72,
            lc30: 46.5,
            lc10: 23.5
        },
        "sky.400": {
            contrast: 53.475628121246466,
            lc60: 100,
            lc45: 79,
            lc30: 50.5,
            lc10: 26
        },
        "sky.500": {
            contrast: 50.088441043438095,
            lc60: 100,
            lc45: 87,
            lc30: 55.5,
            lc10: 28.5
        },
        "sky.600": {
            contrast: 45.332292777870194,
            lc60: 100,
            lc45: 99.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "sky.700": {
            contrast: 40.967955114761246,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "sky.800": {
            contrast: 35.61523187014436,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "sky.900": {
            contrast: 30.806349210230533,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 48.5
        },
        "sky.1000": {
            contrast: 25.274054795337836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "sky.1100": {
            contrast: 21.89269123262144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "sky.1200": {
            contrast: 16.9552410494245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "sky.1300": {
            contrast: 11.876481245443346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1400": {
            contrast: 7.51388196494123,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 9.260515844566703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 14.617534052904603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 20.276663489985623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "sky.2100": {
            contrast: 26.296464640301863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "sky.2200": {
            contrast: 32.195511402263755,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51.5
        },
        "sky.2300": {
            contrast: 38.15920389515669,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 45
        },
        "sky.2400": {
            contrast: 44.484946073886924,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 39.5
        },
        "sky.2500": {
            contrast: 50.867143062701956,
            lc60: 100,
            lc45: 90,
            lc30: 64,
            lc10: 35
        }
    },
    "sky.1700": {
        "sky.100": {
            contrast: 62.8028794055255,
            lc60: 82,
            lc45: 55.5,
            lc30: 36,
            lc10: 18
        },
        "sky.200": {
            contrast: 62.3035976317581,
            lc60: 89,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "sky.300": {
            contrast: 60.691337420843205,
            lc60: 97,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "sky.400": {
            contrast: 58.2540043190702,
            lc60: 100,
            lc45: 71,
            lc30: 45.5,
            lc10: 23.5
        },
        "sky.500": {
            contrast: 54.86681724126182,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 26
        },
        "sky.600": {
            contrast: 50.110668975693926,
            lc60: 100,
            lc45: 87.5,
            lc30: 56,
            lc10: 28
        },
        "sky.700": {
            contrast: 45.74633131258498,
            lc60: 100,
            lc45: 97.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "sky.800": {
            contrast: 40.3936080679681,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "sky.900": {
            contrast: 35.58472540805426,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 41.5
        },
        "sky.1000": {
            contrast: 30.052430993161565,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 49.5
        },
        "sky.1100": {
            contrast: 26.671067430445174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "sky.1200": {
            contrast: 21.733617247248233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "sky.1300": {
            contrast: 16.65485744326708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "sky.1400": {
            contrast: 12.292258162764961,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1500": {
            contrast: 7.777185997545259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 9.50881585399975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 15.16794529108077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "sky.2100": {
            contrast: 21.187746441397014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "sky.2200": {
            contrast: 27.086793203358905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "sky.2300": {
            contrast: 33.05048569625183,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "sky.2400": {
            contrast: 39.37622787498207,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 43
        },
        "sky.2500": {
            contrast: 45.75842486379711,
            lc60: 100,
            lc45: 98,
            lc30: 69.5,
            lc10: 38
        }
    },
    "sky.1800": {
        "sky.100": {
            contrast: 67.68620284112733,
            lc60: 72,
            lc45: 51,
            lc30: 33,
            lc10: 17
        },
        "sky.200": {
            contrast: 67.18692106735993,
            lc60: 78,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "sky.300": {
            contrast: 65.57466085644504,
            lc60: 84.5,
            lc45: 60,
            lc30: 39,
            lc10: 20
        },
        "sky.400": {
            contrast: 63.13732775467202,
            lc60: 91.5,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "sky.500": {
            contrast: 59.75014067686365,
            lc60: 100,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "sky.600": {
            contrast: 54.99399241129576,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "sky.700": {
            contrast: 50.6296547481868,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 28
        },
        "sky.800": {
            contrast: 45.27693150356993,
            lc60: 100,
            lc45: 99.5,
            lc30: 63.5,
            lc10: 32
        },
        "sky.900": {
            contrast: 40.4680488436561,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36.5
        },
        "sky.1000": {
            contrast: 34.935754428763396,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 41.5
        },
        "sky.1100": {
            contrast: 31.554390866047,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 47.5
        },
        "sky.1200": {
            contrast: 26.61694068285006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.1300": {
            contrast: 21.53818087886891,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "sky.1400": {
            contrast: 17.175581598366794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "sky.1500": {
            contrast: 12.66050943314709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1600": {
            contrast: 7.602836130106433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 9.889412533567329,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 15.909213683883575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "sky.2200": {
            contrast: 21.808260445845466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "sky.2300": {
            contrast: 27.77195293873839,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "sky.2400": {
            contrast: 34.09769511746863,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 49
        },
        "sky.2500": {
            contrast: 40.479892106283664,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42
        }
    },
    "sky.1900": {
        "sky.100": {
            contrast: 72.72453441078027,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "sky.200": {
            contrast: 72.22525263701287,
            lc60: 71.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "sky.300": {
            contrast: 70.61299242609796,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "sky.400": {
            contrast: 68.17565932432495,
            lc60: 83,
            lc45: 59,
            lc30: 38.5,
            lc10: 19.5
        },
        "sky.500": {
            contrast: 64.78847224651658,
            lc60: 90,
            lc45: 64,
            lc30: 41.5,
            lc10: 21.5
        },
        "sky.600": {
            contrast: 60.03232398094869,
            lc60: 99.5,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "sky.700": {
            contrast: 55.667986317839734,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 26
        },
        "sky.800": {
            contrast: 50.31526307322286,
            lc60: 100,
            lc45: 87.5,
            lc30: 56,
            lc10: 28.5
        },
        "sky.900": {
            contrast: 45.506380413309024,
            lc60: 100,
            lc45: 98,
            lc30: 62.5,
            lc10: 32
        },
        "sky.1000": {
            contrast: 39.97408599841633,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 37
        },
        "sky.1100": {
            contrast: 36.59272243569993,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40.5
        },
        "sky.1200": {
            contrast: 31.655272252502993,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 47.5
        },
        "sky.1300": {
            contrast: 26.57651244852184,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.1400": {
            contrast: 22.213913168019722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "sky.1500": {
            contrast: 17.69884100280002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "sky.1600": {
            contrast: 12.641167699759364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1700": {
            contrast: 7.821678931058876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 10.405424443020955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 16.304471204982846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "sky.2300": {
            contrast: 22.268163697875774,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "sky.2400": {
            contrast: 28.593905876606012,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "sky.2500": {
            contrast: 34.97610286542105,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        }
    },
    "sky.2000": {
        "sky.100": {
            contrast: 78.01065618060473,
            lc60: 61,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "sky.200": {
            contrast: 77.51137440683733,
            lc60: 65.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "sky.300": {
            contrast: 75.89911419592244,
            lc60: 70.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "sky.400": {
            contrast: 73.46178109414943,
            lc60: 75.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "sky.500": {
            contrast: 70.07459401634105,
            lc60: 81,
            lc45: 58.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "sky.600": {
            contrast: 65.31844575077315,
            lc60: 89,
            lc45: 64,
            lc30: 41.5,
            lc10: 21.5
        },
        "sky.700": {
            contrast: 60.954108087664196,
            lc60: 98,
            lc45: 69.5,
            lc30: 45,
            lc10: 23.5
        },
        "sky.800": {
            contrast: 55.60138484304733,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25.5
        },
        "sky.900": {
            contrast: 50.79250218313349,
            lc60: 100,
            lc45: 86,
            lc30: 55.5,
            lc10: 28.5
        },
        "sky.1000": {
            contrast: 45.26020776824079,
            lc60: 100,
            lc45: 99,
            lc30: 63,
            lc10: 32
        },
        "sky.1100": {
            contrast: 41.878844205524395,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "sky.1200": {
            contrast: 36.94139402232746,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "sky.1300": {
            contrast: 31.862634218346304,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 47.5
        },
        "sky.1400": {
            contrast: 27.500034937844188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "sky.1500": {
            contrast: 22.98496277262449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "sky.1600": {
            contrast: 17.92728946958383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "sky.1700": {
            contrast: 13.10780070088334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1800": {
            contrast: 8.176451999839793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 10.470338243665692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 16.434030736558622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "sky.2400": {
            contrast: 22.759772915288863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "sky.2500": {
            contrast: 29.14196990410389,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        }
    },
    "sky.2100": {
        "sky.100": {
            contrast: 83.59573246170248,
            lc60: 56.5,
            lc45: 41,
            lc30: 27.5,
            lc10: 14
        },
        "sky.200": {
            contrast: 83.09645068793509,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "sky.300": {
            contrast: 81.48419047702019,
            lc60: 64.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "sky.400": {
            contrast: 79.04685737524719,
            lc60: 68.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "sky.500": {
            contrast: 75.65967029743881,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "sky.600": {
            contrast: 70.9035220318709,
            lc60: 80.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "sky.700": {
            contrast: 66.53918436876197,
            lc60: 87.5,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "sky.800": {
            contrast: 61.186461124145076,
            lc60: 97,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "sky.900": {
            contrast: 56.37757846423125,
            lc60: 100,
            lc45: 76,
            lc30: 49.5,
            lc10: 25
        },
        "sky.1000": {
            contrast: 50.845284049338545,
            lc60: 100,
            lc45: 85.5,
            lc30: 54.5,
            lc10: 28
        },
        "sky.1100": {
            contrast: 47.46392048662214,
            lc60: 100,
            lc45: 94,
            lc30: 60.5,
            lc10: 31
        },
        "sky.1200": {
            contrast: 42.526470303425214,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "sky.1300": {
            contrast: 37.44771049944406,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 40
        },
        "sky.1400": {
            contrast: 33.08511121894194,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 46
        },
        "sky.1500": {
            contrast: 28.570039053722233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "sky.1600": {
            contrast: 23.51236575068158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "sky.1700": {
            contrast: 18.692876981981094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "sky.1800": {
            contrast: 13.761528280937549,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.1900": {
            contrast: 8.667685075665933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 10.207027135643521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 16.53276931437376,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "sky.2500": {
            contrast: 22.91496630318879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        }
    },
    "sky.2200": {
        "sky.100": {
            contrast: 89.03354985546635,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "sky.200": {
            contrast: 88.53426808169897,
            lc60: 56,
            lc45: 41,
            lc30: 27.5,
            lc10: 14.5
        },
        "sky.300": {
            contrast: 86.92200787078406,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "sky.400": {
            contrast: 84.48467476901105,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "sky.500": {
            contrast: 81.09748769120269,
            lc60: 67.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "sky.600": {
            contrast: 76.34133942563479,
            lc60: 73.5,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "sky.700": {
            contrast: 71.97700176252584,
            lc60: 79,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "sky.800": {
            contrast: 66.62427851790895,
            lc60: 87,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "sky.900": {
            contrast: 61.815395857995114,
            lc60: 96,
            lc45: 68,
            lc30: 44.5,
            lc10: 22.5
        },
        "sky.1000": {
            contrast: 56.283101443102424,
            lc60: 100,
            lc45: 76,
            lc30: 49,
            lc10: 25
        },
        "sky.1100": {
            contrast: 52.90173788038602,
            lc60: 100,
            lc45: 82,
            lc30: 53,
            lc10: 27.5
        },
        "sky.1200": {
            contrast: 47.96428769718909,
            lc60: 100,
            lc45: 92.5,
            lc30: 60,
            lc10: 30.5
        },
        "sky.1300": {
            contrast: 42.88552789320793,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "sky.1400": {
            contrast: 38.52292861270581,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 39.5
        },
        "sky.1500": {
            contrast: 34.00785644748611,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 45
        },
        "sky.1600": {
            contrast: 28.95018314444545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "sky.1700": {
            contrast: 24.13069437574497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "sky.1800": {
            contrast: 19.199345674701423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "sky.1900": {
            contrast: 14.105502469429808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2000": {
            contrast: 8.755031533052625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 10.410945831755496,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 16.79314282057053,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        }
    },
    "sky.2300": {
        "sky.100": {
            contrast: 94.49794161093563,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "sky.200": {
            contrast: 93.99865983716825,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "sky.300": {
            contrast: 92.38639962625335,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14.5
        },
        "sky.400": {
            contrast: 89.94906652448033,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "sky.500": {
            contrast: 86.56187944667197,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16
        },
        "sky.600": {
            contrast: 81.80573118110405,
            lc60: 67,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "sky.700": {
            contrast: 77.44139351799511,
            lc60: 72,
            lc45: 52.5,
            lc30: 34,
            lc10: 18
        },
        "sky.800": {
            contrast: 72.08867027337823,
            lc60: 78.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "sky.900": {
            contrast: 67.27978761346439,
            lc60: 85.5,
            lc45: 61.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "sky.1000": {
            contrast: 61.7474931985717,
            lc60: 96,
            lc45: 67.5,
            lc30: 44,
            lc10: 22.5
        },
        "sky.1100": {
            contrast: 58.366129635855316,
            lc60: 100,
            lc45: 73,
            lc30: 47.5,
            lc10: 24.5
        },
        "sky.1200": {
            contrast: 53.428679452658365,
            lc60: 100,
            lc45: 81.5,
            lc30: 53,
            lc10: 27.5
        },
        "sky.1300": {
            contrast: 48.34991964867721,
            lc60: 100,
            lc45: 91.5,
            lc30: 59,
            lc10: 30.5
        },
        "sky.1400": {
            contrast: 43.98732036817509,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 34
        },
        "sky.1500": {
            contrast: 39.47224820295539,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 38
        },
        "sky.1600": {
            contrast: 34.41457489991473,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 44
        },
        "sky.1700": {
            contrast: 29.595086131214245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "sky.1800": {
            contrast: 24.663737430170706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "sky.1900": {
            contrast: 19.569894224899087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "sky.2000": {
            contrast: 14.219423288521904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2100": {
            contrast: 8.559975567535291,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 10.585563856697522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "sky.2400": {
        "sky.100": {
            contrast: 100.26016319661417,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "sky.200": {
            contrast: 99.76088142284677,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "sky.300": {
            contrast: 98.14862121193187,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "sky.400": {
            contrast: 95.71128811015886,
            lc60: 54.5,
            lc45: 40,
            lc30: 27,
            lc10: 14
        },
        "sky.500": {
            contrast: 92.3241010323505,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "sky.600": {
            contrast: 87.5679527667826,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "sky.700": {
            contrast: 83.20361510367364,
            lc60: 65.5,
            lc45: 48,
            lc30: 32,
            lc10: 16.5
        },
        "sky.800": {
            contrast: 77.85089185905677,
            lc60: 72,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "sky.900": {
            contrast: 73.04200919914294,
            lc60: 77.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "sky.1000": {
            contrast: 67.50971478425024,
            lc60: 85,
            lc45: 61,
            lc30: 39.5,
            lc10: 20.5
        },
        "sky.1100": {
            contrast: 64.12835122153383,
            lc60: 92,
            lc45: 65.5,
            lc30: 43,
            lc10: 22
        },
        "sky.1200": {
            contrast: 59.190901038336904,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "sky.1300": {
            contrast: 54.11214123435575,
            lc60: 100,
            lc45: 80.5,
            lc30: 52.5,
            lc10: 27
        },
        "sky.1400": {
            contrast: 49.74954195385363,
            lc60: 100,
            lc45: 89,
            lc30: 57,
            lc10: 30
        },
        "sky.1500": {
            contrast: 45.23446978863393,
            lc60: 100,
            lc45: 99,
            lc30: 63.5,
            lc10: 33.5
        },
        "sky.1600": {
            contrast: 40.17679648559327,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "sky.1700": {
            contrast: 35.357307716892784,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "sky.1800": {
            contrast: 30.425959015849237,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 50
        },
        "sky.1900": {
            contrast: 25.332115810577623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "sky.2000": {
            contrast: 19.98164487420044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "sky.2100": {
            contrast: 14.322197153213828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2200": {
            contrast: 8.806036006423868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "sky.2500": {
        "sky.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "sky.200": {
            contrast: 105.54139143892122,
            lc60: 46,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "sky.300": {
            contrast: 103.92913122800631,
            lc60: 48.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "sky.400": {
            contrast: 101.4917981262333,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "sky.500": {
            contrast: 98.10461104842493,
            lc60: 54,
            lc45: 39.5,
            lc30: 26.5,
            lc10: 14
        },
        "sky.600": {
            contrast: 93.34846278285703,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "sky.700": {
            contrast: 88.98412511974807,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "sky.800": {
            contrast: 83.63140187513119,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "sky.900": {
            contrast: 78.82251921521737,
            lc60: 70.5,
            lc45: 51,
            lc30: 34,
            lc10: 17.5
        },
        "sky.1000": {
            contrast: 73.29022480032467,
            lc60: 76.5,
            lc45: 55,
            lc30: 36.5,
            lc10: 18.5
        },
        "sky.1100": {
            contrast: 69.90886123760826,
            lc60: 82,
            lc45: 59,
            lc30: 38.5,
            lc10: 20.5
        },
        "sky.1200": {
            contrast: 64.97141105441133,
            lc60: 90.5,
            lc45: 65,
            lc30: 42.5,
            lc10: 22
        },
        "sky.1300": {
            contrast: 59.89265125043018,
            lc60: 100,
            lc45: 71.5,
            lc30: 47,
            lc10: 24.5
        },
        "sky.1400": {
            contrast: 55.53005196992806,
            lc60: 100,
            lc45: 78.5,
            lc30: 51.5,
            lc10: 26.5
        },
        "sky.1500": {
            contrast: 51.01497980470836,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 29
        },
        "sky.1600": {
            contrast: 45.9573065016677,
            lc60: 100,
            lc45: 97.5,
            lc30: 62.5,
            lc10: 33
        },
        "sky.1700": {
            contrast: 41.137817732967214,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 37
        },
        "sky.1800": {
            contrast: 36.20646903192367,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "sky.1900": {
            contrast: 31.112625826652053,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 49
        },
        "sky.2000": {
            contrast: 25.762154890274868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "sky.2100": {
            contrast: 20.10270716928826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "sky.2200": {
            contrast: 14.586546022498299,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2300": {
            contrast: 9.037859435618984,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "sky.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$navi = {
    "navi.100": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 8.117362957694422,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 12.066030444495398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 16.830010840240035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "navi.900": {
            contrast: 21.298899048368988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "navi.1000": {
            contrast: 25.488342881294844,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "navi.1100": {
            contrast: 29.948174361125236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "navi.1200": {
            contrast: 34.94529181270277,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 63.5
        },
        "navi.1300": {
            contrast: 40.072008919266096,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 59
        },
        "navi.1400": {
            contrast: 44.67740436172771,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 55
        },
        "navi.1500": {
            contrast: 49.42843483919055,
            lc60: 100,
            lc45: 94,
            lc30: 74.5,
            lc10: 52
        },
        "navi.1600": {
            contrast: 54.54239220109749,
            lc60: 100,
            lc45: 89,
            lc30: 70.5,
            lc10: 49
        },
        "navi.1700": {
            contrast: 59.62025504187709,
            lc60: 100,
            lc45: 84,
            lc30: 66.5,
            lc10: 46.5
        },
        "navi.1800": {
            contrast: 65.35876306373056,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 43.5
        },
        "navi.1900": {
            contrast: 70.84264329389485,
            lc60: 90,
            lc45: 75.5,
            lc30: 59.5,
            lc10: 42
        },
        "navi.2000": {
            contrast: 76.54055396842463,
            lc60: 86,
            lc45: 72.5,
            lc30: 57,
            lc10: 40
        },
        "navi.2100": {
            contrast: 82.55763905828711,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "navi.2200": {
            contrast: 88.66270486383215,
            lc60: 78.5,
            lc45: 66,
            lc30: 52,
            lc10: 36.5
        },
        "navi.2300": {
            contrast: 94.62567466648164,
            lc60: 75,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "navi.2400": {
            contrast: 101.09702089769303,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "navi.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "navi.200": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 7.573085993167397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 11.521753479968375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 16.285733875713007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "navi.900": {
            contrast: 20.754622083841966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1000": {
            contrast: 24.944065916767823,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "navi.1100": {
            contrast: 29.403897396598204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "navi.1200": {
            contrast: 34.401014848175734,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 61
        },
        "navi.1300": {
            contrast: 39.52773195473907,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 56.5
        },
        "navi.1400": {
            contrast: 44.13312739720068,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 52.5
        },
        "navi.1500": {
            contrast: 48.884157874663515,
            lc60: 100,
            lc45: 95,
            lc30: 73.5,
            lc10: 49.5
        },
        "navi.1600": {
            contrast: 53.99811523657046,
            lc60: 100,
            lc45: 89,
            lc30: 69,
            lc10: 46.5
        },
        "navi.1700": {
            contrast: 59.075978077350065,
            lc60: 100,
            lc45: 84,
            lc30: 65.5,
            lc10: 44
        },
        "navi.1800": {
            contrast: 64.81448609920353,
            lc60: 95,
            lc45: 79,
            lc30: 61.5,
            lc10: 42
        },
        "navi.1900": {
            contrast: 70.29836632936784,
            lc60: 90,
            lc45: 75,
            lc30: 58.5,
            lc10: 39.5
        },
        "navi.2000": {
            contrast: 75.9962770038976,
            lc60: 85.5,
            lc45: 71.5,
            lc30: 56,
            lc10: 37.5
        },
        "navi.2100": {
            contrast: 82.01336209376008,
            lc60: 81.5,
            lc45: 68,
            lc30: 53.5,
            lc10: 36
        },
        "navi.2200": {
            contrast: 88.11842789930513,
            lc60: 78,
            lc45: 65,
            lc30: 51,
            lc10: 34.5
        },
        "navi.2300": {
            contrast: 94.08139770195461,
            lc60: 75,
            lc45: 62.5,
            lc30: 49,
            lc10: 33
        },
        "navi.2400": {
            contrast: 100.55274393316603,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 47,
            lc10: 31.5
        },
        "navi.2500": {
            contrast: 107.34045621857145,
            lc60: 68.5,
            lc45: 57.5,
            lc30: 45,
            lc10: 30.5
        }
    },
    "navi.300": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 10.068729426559408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 14.832709822304041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 19.301598030432995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "navi.1000": {
            contrast: 23.491041863358856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "navi.1100": {
            contrast: 27.950873343189237,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.1200": {
            contrast: 32.94799079476677,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 62.5
        },
        "navi.1300": {
            contrast: 38.0747079013301,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 57
        },
        "navi.1400": {
            contrast: 42.68010334379171,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 53
        },
        "navi.1500": {
            contrast: 47.43113382125455,
            lc60: 100,
            lc45: 96.5,
            lc30: 75,
            lc10: 50
        },
        "navi.1600": {
            contrast: 52.545091183161496,
            lc60: 100,
            lc45: 90,
            lc30: 70.5,
            lc10: 47
        },
        "navi.1700": {
            contrast: 57.6229540239411,
            lc60: 100,
            lc45: 85,
            lc30: 66.5,
            lc10: 44.5
        },
        "navi.1800": {
            contrast: 63.36146204579457,
            lc60: 96,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 42
        },
        "navi.1900": {
            contrast: 68.84534227595887,
            lc60: 91,
            lc45: 76.5,
            lc30: 59.5,
            lc10: 40
        },
        "navi.2000": {
            contrast: 74.54325295048862,
            lc60: 87,
            lc45: 72.5,
            lc30: 57,
            lc10: 38
        },
        "navi.2100": {
            contrast: 80.56033804035111,
            lc60: 82.5,
            lc45: 69,
            lc30: 54,
            lc10: 36.5
        },
        "navi.2200": {
            contrast: 86.66540384589615,
            lc60: 79,
            lc45: 66,
            lc30: 51.5,
            lc10: 35
        },
        "navi.2300": {
            contrast: 92.62837364854563,
            lc60: 75.5,
            lc45: 63,
            lc30: 49.5,
            lc10: 33.5
        },
        "navi.2400": {
            contrast: 99.09971987975702,
            lc60: 72.5,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 32
        },
        "navi.2500": {
            contrast: 105.88743216516248,
            lc60: 69.5,
            lc45: 58,
            lc30: 45.5,
            lc10: 31
        }
    },
    "navi.400": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 8.134743128338974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 12.898723524083607,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 17.36761173221256,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.1000": {
            contrast: 21.557055565138423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "navi.1100": {
            contrast: 26.016887044968804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "navi.1200": {
            contrast: 31.014004496546338,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 65
        },
        "navi.1300": {
            contrast: 36.14072160310967,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 59
        },
        "navi.1400": {
            contrast: 40.74611704557128,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 55
        },
        "navi.1500": {
            contrast: 45.49714752303412,
            lc60: 100,
            lc45: 99.5,
            lc30: 77.5,
            lc10: 51.5
        },
        "navi.1600": {
            contrast: 50.611104884941064,
            lc60: 100,
            lc45: 93,
            lc30: 72,
            lc10: 48.5
        },
        "navi.1700": {
            contrast: 55.68896772572065,
            lc60: 100,
            lc45: 87.5,
            lc30: 68,
            lc10: 45.5
        },
        "navi.1800": {
            contrast: 61.427475747574135,
            lc60: 98.5,
            lc45: 82.5,
            lc30: 64.5,
            lc10: 43
        },
        "navi.1900": {
            contrast: 66.91135597773842,
            lc60: 93.5,
            lc45: 78,
            lc30: 61,
            lc10: 41.5
        },
        "navi.2000": {
            contrast: 72.60926665226819,
            lc60: 88.5,
            lc45: 74.5,
            lc30: 58,
            lc10: 39
        },
        "navi.2100": {
            contrast: 78.62635174213068,
            lc60: 84,
            lc45: 70.5,
            lc30: 55,
            lc10: 37.5
        },
        "navi.2200": {
            contrast: 84.73141754767572,
            lc60: 80.5,
            lc45: 67,
            lc30: 52.5,
            lc10: 36
        },
        "navi.2300": {
            contrast: 90.6943873503252,
            lc60: 77,
            lc45: 64.5,
            lc30: 50.5,
            lc10: 34.5
        },
        "navi.2400": {
            contrast: 97.16573358153659,
            lc60: 74,
            lc45: 61.5,
            lc30: 48.5,
            lc10: 33
        },
        "navi.2500": {
            contrast: 103.95344586694205,
            lc60: 70.5,
            lc45: 59,
            lc30: 46.5,
            lc10: 31.5
        }
    },
    "navi.500": {
        "navi.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 10.897457621003316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 15.366345829132266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "navi.1000": {
            contrast: 19.555789662058125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1100": {
            contrast: 24.015621141888513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "navi.1200": {
            contrast: 29.012738593466047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "navi.1300": {
            contrast: 34.13945570002937,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 56
        },
        "navi.1400": {
            contrast: 38.74485114249098,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 51.5
        },
        "navi.1500": {
            contrast: 43.49588161995383,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "navi.1600": {
            contrast: 48.609838981860776,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 44
        },
        "navi.1700": {
            contrast: 53.68770182264036,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "navi.1800": {
            contrast: 59.42620984449385,
            lc60: 100,
            lc45: 82.5,
            lc30: 62.5,
            lc10: 38.5
        },
        "navi.1900": {
            contrast: 64.91009007465814,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 58.5,
            lc10: 36.5
        },
        "navi.2000": {
            contrast: 70.60800074918791,
            lc60: 89.5,
            lc45: 73,
            lc30: 55.5,
            lc10: 34.5
        },
        "navi.2100": {
            contrast: 76.62508583905037,
            lc60: 84,
            lc45: 69.5,
            lc30: 52.5,
            lc10: 33
        },
        "navi.2200": {
            contrast: 82.73015164459542,
            lc60: 80,
            lc45: 66,
            lc30: 49.5,
            lc10: 31
        },
        "navi.2300": {
            contrast: 88.69312144724492,
            lc60: 76.5,
            lc45: 62.5,
            lc30: 47.5,
            lc10: 30
        },
        "navi.2400": {
            contrast: 95.1644676784563,
            lc60: 72.5,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        },
        "navi.2500": {
            contrast: 101.95217996386174,
            lc60: 69.5,
            lc45: 57,
            lc30: 43.5,
            lc10: 27
        }
    },
    "navi.600": {
        "navi.100": {
            contrast: 9.448006942622463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 8.719819476675008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 7.375779672220194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 11.84466788034915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 16.034111713275006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "navi.1100": {
            contrast: 20.493943193105395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "navi.1200": {
            contrast: 25.49106064468292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "navi.1300": {
            contrast: 30.617777751246255,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 57.5
        },
        "navi.1400": {
            contrast: 35.223173193707865,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 52
        },
        "navi.1500": {
            contrast: 39.974203671170706,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "navi.1600": {
            contrast: 45.08816103307765,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 43.5
        },
        "navi.1700": {
            contrast: 50.16602387385725,
            lc60: 100,
            lc45: 92,
            lc30: 68,
            lc10: 40.5
        },
        "navi.1800": {
            contrast: 55.90453189571072,
            lc60: 100,
            lc45: 85,
            lc30: 63,
            lc10: 37.5
        },
        "navi.1900": {
            contrast: 61.388412125875014,
            lc60: 98,
            lc45: 79.5,
            lc30: 59,
            lc10: 35
        },
        "navi.2000": {
            contrast: 67.08632280040479,
            lc60: 92,
            lc45: 74.5,
            lc30: 55.5,
            lc10: 33
        },
        "navi.2100": {
            contrast: 73.10340789026726,
            lc60: 86.5,
            lc45: 70,
            lc30: 52,
            lc10: 31.5
        },
        "navi.2200": {
            contrast: 79.2084736958123,
            lc60: 82,
            lc45: 66.5,
            lc30: 49,
            lc10: 30
        },
        "navi.2300": {
            contrast: 85.1714434984618,
            lc60: 77.5,
            lc45: 63,
            lc30: 47,
            lc10: 28.5
        },
        "navi.2400": {
            contrast: 91.64278972967318,
            lc60: 73.5,
            lc45: 60,
            lc30: 44.5,
            lc10: 27
        },
        "navi.2500": {
            contrast: 98.43050201507863,
            lc60: 70,
            lc45: 57,
            lc30: 42.5,
            lc10: 25.5
        }
    },
    "navi.700": {
        "navi.100": {
            contrast: 13.756732557462406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.200": {
            contrast: 13.028545091514951,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.300": {
            contrast: 11.140235573968946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.400": {
            contrast: 8.720584413191661,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 8.078246897948546,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 12.267690730874406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 16.72752221070479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "navi.1200": {
            contrast: 21.724639662282325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "navi.1300": {
            contrast: 26.85135676884565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "navi.1400": {
            contrast: 31.45675221130726,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 55
        },
        "navi.1500": {
            contrast: 36.2077826887701,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 49
        },
        "navi.1600": {
            contrast: 41.32174005067705,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 45
        },
        "navi.1700": {
            contrast: 46.399602891456645,
            lc60: 100,
            lc45: 97.5,
            lc30: 71.5,
            lc10: 41
        },
        "navi.1800": {
            contrast: 52.13811091331012,
            lc60: 100,
            lc45: 89,
            lc30: 65,
            lc10: 38
        },
        "navi.1900": {
            contrast: 57.62199114347442,
            lc60: 100,
            lc45: 82.5,
            lc30: 60.5,
            lc10: 35.5
        },
        "navi.2000": {
            contrast: 63.319901818004176,
            lc60: 96,
            lc45: 77,
            lc30: 56.5,
            lc10: 33
        },
        "navi.2100": {
            contrast: 69.33698690786665,
            lc60: 89.5,
            lc45: 72,
            lc30: 52.5,
            lc10: 31
        },
        "navi.2200": {
            contrast: 75.4420527134117,
            lc60: 84,
            lc45: 67.5,
            lc30: 49.5,
            lc10: 29
        },
        "navi.2300": {
            contrast: 81.4050225160612,
            lc60: 79.5,
            lc45: 64,
            lc30: 47,
            lc10: 27.5
        },
        "navi.2400": {
            contrast: 87.87636874727258,
            lc60: 75,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26
        },
        "navi.2500": {
            contrast: 94.664081032678,
            lc60: 71.5,
            lc45: 57.5,
            lc30: 42.5,
            lc10: 24.5
        }
    },
    "navi.800": {
        "navi.100": {
            contrast: 18.836591483186453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "navi.200": {
            contrast: 18.108404017238993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.300": {
            contrast: 16.220094499692987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "navi.400": {
            contrast: 13.800443338915708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.500": {
            contrast: 11.378589739596547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 7.670888449502023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 12.13071992933241,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 17.12783738090994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "navi.1300": {
            contrast: 22.254554487473275,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "navi.1400": {
            contrast: 26.859949929934874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "navi.1500": {
            contrast: 31.610980407397722,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 53.5
        },
        "navi.1600": {
            contrast: 36.72493776930467,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 48
        },
        "navi.1700": {
            contrast: 41.80280061008426,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43
        },
        "navi.1800": {
            contrast: 47.54130863193774,
            lc60: 100,
            lc45: 95.5,
            lc30: 69,
            lc10: 39
        },
        "navi.1900": {
            contrast: 53.025188862102034,
            lc60: 100,
            lc45: 88,
            lc30: 64,
            lc10: 36
        },
        "navi.2000": {
            contrast: 58.72309953663181,
            lc60: 100,
            lc45: 81,
            lc30: 59,
            lc10: 33.5
        },
        "navi.2100": {
            contrast: 64.74018462649428,
            lc60: 94,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 31.5
        },
        "navi.2200": {
            contrast: 70.84525043203932,
            lc60: 87.5,
            lc45: 70.5,
            lc30: 51,
            lc10: 29
        },
        "navi.2300": {
            contrast: 76.80822023468882,
            lc60: 82.5,
            lc45: 66.5,
            lc30: 48,
            lc10: 27.5
        },
        "navi.2400": {
            contrast: 83.2795664659002,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 26
        },
        "navi.2500": {
            contrast: 90.06727875130564,
            lc60: 73.5,
            lc45: 59,
            lc30: 43,
            lc10: 24.5
        }
    },
    "navi.900": {
        "navi.100": {
            contrast: 23.508842861871777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "navi.200": {
            contrast: 22.780655395924317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "navi.300": {
            contrast: 20.89234587837832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "navi.400": {
            contrast: 18.47269471760103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "navi.500": {
            contrast: 16.050841118281873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "navi.600": {
            contrast: 11.935316199708154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.700": {
            contrast: 7.685691245675312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 7.776002395080944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 12.773119846658476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 17.899836953221808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "navi.1400": {
            contrast: 22.505232395683414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "navi.1500": {
            contrast: 27.25626287314625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "navi.1600": {
            contrast: 32.370220235053196,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 52.5
        },
        "navi.1700": {
            contrast: 37.44808307583279,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46.5
        },
        "navi.1800": {
            contrast: 43.186591097686275,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41
        },
        "navi.1900": {
            contrast: 48.67047132785057,
            lc60: 100,
            lc45: 93.5,
            lc30: 67,
            lc10: 38
        },
        "navi.2000": {
            contrast: 54.36838200238032,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 34.5
        },
        "navi.2100": {
            contrast: 60.385467092242806,
            lc60: 99.5,
            lc45: 79,
            lc30: 57,
            lc10: 32
        },
        "navi.2200": {
            contrast: 66.49053289778784,
            lc60: 92,
            lc45: 73.5,
            lc30: 53,
            lc10: 30
        },
        "navi.2300": {
            contrast: 72.45350270043735,
            lc60: 86,
            lc45: 68.5,
            lc30: 49.5,
            lc10: 28
        },
        "navi.2400": {
            contrast: 78.92484893164874,
            lc60: 80.5,
            lc45: 64.5,
            lc30: 46.5,
            lc10: 26
        },
        "navi.2500": {
            contrast: 85.71256121705416,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 24.5
        }
    },
    "navi.1000": {
        "navi.100": {
            contrast: 27.821980148968773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "navi.200": {
            contrast: 27.093792683021316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "navi.300": {
            contrast: 25.205483165475318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "navi.400": {
            contrast: 22.785832004698033,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "navi.500": {
            contrast: 20.363978405378873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "navi.600": {
            contrast: 16.248453486805154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "navi.700": {
            contrast: 11.998828532772313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 8.659157415616473,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 13.785874522179808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 18.391269964641413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "navi.1500": {
            contrast: 23.142300442104254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.1600": {
            contrast: 28.2562578040112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "navi.1700": {
            contrast: 33.334120644790794,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "navi.1800": {
            contrast: 39.07262866664427,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "navi.1900": {
            contrast: 44.556508896808566,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 39.5
        },
        "navi.2000": {
            contrast: 50.254419571338325,
            lc60: 100,
            lc45: 91,
            lc30: 65,
            lc10: 36.5
        },
        "navi.2100": {
            contrast: 56.27150466120081,
            lc60: 100,
            lc45: 83,
            lc30: 59.5,
            lc10: 33.5
        },
        "navi.2200": {
            contrast: 62.37657046674586,
            lc60: 97,
            lc45: 76.5,
            lc30: 55,
            lc10: 31
        },
        "navi.2300": {
            contrast: 68.33954026939534,
            lc60: 90,
            lc45: 71.5,
            lc30: 51,
            lc10: 29
        },
        "navi.2400": {
            contrast: 74.81088650060673,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 47.5,
            lc10: 27
        },
        "navi.2500": {
            contrast: 81.59859878601218,
            lc60: 78.5,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        }
    },
    "navi.1100": {
        "navi.100": {
            contrast: 32.353064604462645,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 33.5
        },
        "navi.200": {
            contrast: 31.62487713851519,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 37
        },
        "navi.300": {
            contrast: 29.736567620969183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "navi.400": {
            contrast: 27.316916460191898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43
        },
        "navi.500": {
            contrast: 24.895062860872745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "navi.600": {
            contrast: 20.779537942299022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "navi.700": {
            contrast: 16.529912988266183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.800": {
            contrast: 11.500434166203636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 9.37729536175571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 13.982690804217315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 18.733721281680157,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1600": {
            contrast: 23.847678643587102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "navi.1700": {
            contrast: 28.925541484366697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "navi.1800": {
            contrast: 34.664049506220174,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49
        },
        "navi.1900": {
            contrast: 40.14792973638447,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 43.5
        },
        "navi.2000": {
            contrast: 45.845840410914235,
            lc60: 100,
            lc45: 98,
            lc30: 70,
            lc10: 39
        },
        "navi.2100": {
            contrast: 51.86292550077671,
            lc60: 100,
            lc45: 89,
            lc30: 63.5,
            lc10: 35
        },
        "navi.2200": {
            contrast: 57.96799130632175,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 32
        },
        "navi.2300": {
            contrast: 63.93096110897124,
            lc60: 94.5,
            lc45: 75,
            lc30: 53.5,
            lc10: 29.5
        },
        "navi.2400": {
            contrast: 70.40230734018263,
            lc60: 87.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 27.5
        },
        "navi.2500": {
            contrast: 77.19001962558806,
            lc60: 81.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 25.5
        }
    },
    "navi.1200": {
        "navi.100": {
            contrast: 37.36613934681494,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29
        },
        "navi.200": {
            contrast: 36.63795188086748,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "navi.300": {
            contrast: 34.749642363321485,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 34.5
        },
        "navi.400": {
            contrast: 32.32999120254419,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 36
        },
        "navi.500": {
            contrast: 29.908137603225043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "navi.600": {
            contrast: 25.792612684651324,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "navi.700": {
            contrast: 21.54298773061848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.800": {
            contrast: 16.513508908555934,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "navi.900": {
            contrast: 11.872377236834671,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1000": {
            contrast: 7.576951585408179,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 9.011628339273287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 13.762658816736128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 18.876616178643072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "navi.1700": {
            contrast: 23.954479019422674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "navi.1800": {
            contrast: 29.692987041276147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "navi.1900": {
            contrast: 35.17686727144044,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 47.5
        },
        "navi.2000": {
            contrast: 40.8747779459702,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42
        },
        "navi.2100": {
            contrast: 46.891863035832685,
            lc60: 100,
            lc45: 96,
            lc30: 68.5,
            lc10: 37.5
        },
        "navi.2200": {
            contrast: 52.99692884137772,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 34
        },
        "navi.2300": {
            contrast: 58.95989864402722,
            lc60: 100,
            lc45: 80,
            lc30: 57,
            lc10: 31
        },
        "navi.2400": {
            contrast: 65.4312448752386,
            lc60: 93,
            lc45: 73.5,
            lc30: 52,
            lc10: 28.5
        },
        "navi.2500": {
            contrast: 72.21895716064404,
            lc60: 86,
            lc45: 68,
            lc30: 48,
            lc10: 26.5
        }
    },
    "navi.1300": {
        "navi.100": {
            contrast: 42.44813765708673,
            lc60: 100,
            lc45: 100,
            lc30: 52.5,
            lc10: 26
        },
        "navi.200": {
            contrast: 41.719950191139276,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 28.5
        },
        "navi.300": {
            contrast: 39.83164067359328,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 29.5
        },
        "navi.400": {
            contrast: 37.41198951281599,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 31.5
        },
        "navi.500": {
            contrast: 34.990135913496836,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 37.5
        },
        "navi.600": {
            contrast: 30.874610994923113,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 45.5
        },
        "navi.700": {
            contrast: 26.62498604089027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "navi.800": {
            contrast: 21.595507218827727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.900": {
            contrast: 16.954375547106466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "navi.1000": {
            contrast: 12.65894989567997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1100": {
            contrast: 8.136497395440909,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 8.632115407678041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 13.746072769584986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 18.823935610364583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "navi.1800": {
            contrast: 24.56244363221806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "navi.1900": {
            contrast: 30.04632386238235,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54
        },
        "navi.2000": {
            contrast: 35.74423453691212,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46.5
        },
        "navi.2100": {
            contrast: 41.76131962677459,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "navi.2200": {
            contrast: 47.86638543231964,
            lc60: 100,
            lc45: 95,
            lc30: 66.5,
            lc10: 36
        },
        "navi.2300": {
            contrast: 53.829355234969135,
            lc60: 100,
            lc45: 85.5,
            lc30: 60.5,
            lc10: 33
        },
        "navi.2400": {
            contrast: 60.300701466180506,
            lc60: 99.5,
            lc45: 78.5,
            lc30: 55,
            lc10: 30
        },
        "navi.2500": {
            contrast: 67.08841375158596,
            lc60: 91,
            lc45: 71.5,
            lc30: 50.5,
            lc10: 27.5
        }
    },
    "navi.1400": {
        "navi.100": {
            contrast: 46.96678341959484,
            lc60: 100,
            lc45: 81.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "navi.200": {
            contrast: 46.23859595364739,
            lc60: 100,
            lc45: 90,
            lc30: 51.5,
            lc10: 26
        },
        "navi.300": {
            contrast: 44.350286436101385,
            lc60: 100,
            lc45: 100,
            lc30: 54.5,
            lc10: 27
        },
        "navi.400": {
            contrast: 41.9306352753241,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28
        },
        "navi.500": {
            contrast: 39.50878167600494,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 33.5
        },
        "navi.600": {
            contrast: 35.393256757431224,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 39
        },
        "navi.700": {
            contrast: 31.14363180339838,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 46.5
        },
        "navi.800": {
            contrast: 26.114152981335835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "navi.900": {
            contrast: 21.473021309614577,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "navi.1000": {
            contrast: 17.177595658188082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "navi.1100": {
            contrast: 12.65514315794902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1200": {
            contrast: 7.641048080056478,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 9.113553593248822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 14.19141643402842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 19.9299244558819,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "navi.1900": {
            contrast: 25.413804686046188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "navi.2000": {
            contrast: 31.111715360575953,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 52
        },
        "navi.2100": {
            contrast: 37.12880045043843,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        },
        "navi.2200": {
            contrast: 43.23386625598348,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 39.5
        },
        "navi.2300": {
            contrast: 49.19683605863297,
            lc60: 100,
            lc45: 92.5,
            lc30: 65,
            lc10: 35.5
        },
        "navi.2400": {
            contrast: 55.668182289844346,
            lc60: 100,
            lc45: 83.5,
            lc30: 58.5,
            lc10: 32
        },
        "navi.2500": {
            contrast: 62.45589457524979,
            lc60: 96.5,
            lc45: 76,
            lc30: 53.5,
            lc10: 29
        }
    },
    "navi.1500": {
        "navi.100": {
            contrast: 51.58693513150306,
            lc60: 100,
            lc45: 69,
            lc30: 43.5,
            lc10: 22
        },
        "navi.200": {
            contrast: 50.85874766555561,
            lc60: 100,
            lc45: 75,
            lc30: 47,
            lc10: 23.5
        },
        "navi.300": {
            contrast: 48.970438148009606,
            lc60: 100,
            lc45: 80,
            lc30: 49,
            lc10: 24.5
        },
        "navi.400": {
            contrast: 46.550786987232314,
            lc60: 100,
            lc45: 89,
            lc30: 50.5,
            lc10: 25
        },
        "navi.500": {
            contrast: 44.128933387913165,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "navi.600": {
            contrast: 40.013408469339446,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34
        },
        "navi.700": {
            contrast: 35.7637835153066,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 39.5
        },
        "navi.800": {
            contrast: 30.734304693244052,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47
        },
        "navi.900": {
            contrast: 26.09317302152279,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "navi.1000": {
            contrast: 21.797747370096303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "navi.1100": {
            contrast: 17.27529486985724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "navi.1200": {
            contrast: 12.261199791964698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 9.391049252181395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 15.129557274034871,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "navi.1900": {
            contrast: 20.613437504199165,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "navi.2000": {
            contrast: 26.311348178728927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "navi.2100": {
            contrast: 32.328433268591404,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "navi.2200": {
            contrast: 38.43349907413645,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 43.5
        },
        "navi.2300": {
            contrast: 44.396468876785946,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38.5
        },
        "navi.2400": {
            contrast: 50.86781510799733,
            lc60: 100,
            lc45: 90,
            lc30: 63,
            lc10: 34.5
        },
        "navi.2500": {
            contrast: 57.655527393402764,
            lc60: 100,
            lc45: 80.5,
            lc30: 56.5,
            lc10: 31
        }
    },
    "navi.1600": {
        "navi.100": {
            contrast: 56.51749705760878,
            lc60: 100,
            lc45: 62,
            lc30: 39.5,
            lc10: 20
        },
        "navi.200": {
            contrast: 55.789309591661315,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21
        },
        "navi.300": {
            contrast: 53.90100007411532,
            lc60: 100,
            lc45: 70,
            lc30: 43.5,
            lc10: 22
        },
        "navi.400": {
            contrast: 51.48134891333803,
            lc60: 100,
            lc45: 74.5,
            lc30: 45.5,
            lc10: 22.5
        },
        "navi.500": {
            contrast: 49.059495314018875,
            lc60: 100,
            lc45: 86.5,
            lc30: 53,
            lc10: 26
        },
        "navi.600": {
            contrast: 44.943970395445156,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "navi.700": {
            contrast: 40.69434544141231,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34.5
        },
        "navi.800": {
            contrast: 35.664866619349766,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40.5
        },
        "navi.900": {
            contrast: 31.0237349476285,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47
        },
        "navi.1000": {
            contrast: 26.728309296202006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "navi.1100": {
            contrast: 22.20585679596295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.1200": {
            contrast: 17.19176171807041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "navi.1300": {
            contrast: 12.098595124801244,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1400": {
            contrast: 7.562271041681537,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 9.94026338949691,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 15.424143619661205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "navi.2000": {
            contrast: 21.122054294190967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "navi.2100": {
            contrast: 27.13913938405344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "navi.2200": {
            contrast: 33.24420518959849,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 49.5
        },
        "navi.2300": {
            contrast: 39.20717499224798,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 42.5
        },
        "navi.2400": {
            contrast: 45.67852122345936,
            lc60: 100,
            lc45: 98.5,
            lc30: 69,
            lc10: 37
        },
        "navi.2500": {
            contrast: 52.4662335088648,
            lc60: 100,
            lc45: 87,
            lc30: 61.5,
            lc10: 33
        }
    },
    "navi.1700": {
        "navi.100": {
            contrast: 61.37356034001633,
            lc60: 86.5,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "navi.200": {
            contrast: 60.64537287406886,
            lc60: 94,
            lc45: 60.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "navi.300": {
            contrast: 58.75706335652286,
            lc60: 100,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "navi.400": {
            contrast: 56.337412195745586,
            lc60: 100,
            lc45: 65,
            lc30: 41,
            lc10: 20.5
        },
        "navi.500": {
            contrast: 53.915558596426415,
            lc60: 100,
            lc45: 76,
            lc30: 47.5,
            lc10: 23.5
        },
        "navi.600": {
            contrast: 49.800033677852696,
            lc60: 100,
            lc45: 86.5,
            lc30: 54,
            lc10: 27
        },
        "navi.700": {
            contrast: 45.55040872381986,
            lc60: 100,
            lc45: 98,
            lc30: 61,
            lc10: 30.5
        },
        "navi.800": {
            contrast: 40.52092990175731,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "navi.900": {
            contrast: 35.879798230036045,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40.5
        },
        "navi.1000": {
            contrast: 31.584372578609553,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 46.5
        },
        "navi.1100": {
            contrast: 27.061920078370495,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "navi.1200": {
            contrast: 22.047825000477957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "navi.1300": {
            contrast: 16.954658407208793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "navi.1400": {
            contrast: 12.418334324089084,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1500": {
            contrast: 7.77320798930115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 10.2504591682515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 15.948369842781263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "navi.2100": {
            contrast: 21.965454932643738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "navi.2200": {
            contrast: 28.07052073818878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "navi.2300": {
            contrast: 34.03349054083827,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 48.5
        },
        "navi.2400": {
            contrast: 40.50483677204966,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        },
        "navi.2500": {
            contrast: 47.2925490574551,
            lc60: 100,
            lc45: 95.5,
            lc30: 66.5,
            lc10: 36.5
        }
    },
    "navi.1800": {
        "navi.100": {
            contrast: 66.8179897177483,
            lc60: 73.5,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "navi.200": {
            contrast: 66.08980225180083,
            lc60: 78,
            lc45: 54.5,
            lc30: 35.5,
            lc10: 18
        },
        "navi.300": {
            contrast: 64.20149273425484,
            lc60: 82,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "navi.400": {
            contrast: 61.78184157347756,
            lc60: 89,
            lc45: 58,
            lc30: 37,
            lc10: 19
        },
        "navi.500": {
            contrast: 59.35998797415839,
            lc60: 100,
            lc45: 66.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "navi.600": {
            contrast: 55.24446305558468,
            lc60: 100,
            lc45: 75.5,
            lc30: 47.5,
            lc10: 24
        },
        "navi.700": {
            contrast: 50.994838101551835,
            lc60: 100,
            lc45: 84.5,
            lc30: 53.5,
            lc10: 27
        },
        "navi.800": {
            contrast: 45.965359279489284,
            lc60: 100,
            lc45: 97.5,
            lc30: 60.5,
            lc10: 31
        },
        "navi.900": {
            contrast: 41.32422760776802,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "navi.1000": {
            contrast: 37.028801956341525,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "navi.1100": {
            contrast: 32.50634945610247,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 46
        },
        "navi.1200": {
            contrast: 27.492254378209925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "navi.1300": {
            contrast: 22.399087784940765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "navi.1400": {
            contrast: 17.862763701821056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "navi.1500": {
            contrast: 13.217637367033122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1600": {
            contrast: 8.253323471450594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 10.078303208726341,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 16.095388298588816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "navi.2200": {
            contrast: 22.20045410413386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "navi.2300": {
            contrast: 28.163423906783354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "navi.2400": {
            contrast: 34.634770137994735,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48
        },
        "navi.2500": {
            contrast: 41.42248242340017,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        }
    },
    "navi.1900": {
        "navi.100": {
            contrast: 71.98137127848554,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "navi.200": {
            contrast: 71.25318381253808,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 16.5
        },
        "navi.300": {
            contrast: 69.36487429499208,
            lc60: 73,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "navi.400": {
            contrast: 66.9452231342148,
            lc60: 76.5,
            lc45: 53,
            lc30: 34,
            lc10: 17.5
        },
        "navi.500": {
            contrast: 64.52336953489562,
            lc60: 87,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "navi.600": {
            contrast: 60.4078446163219,
            lc60: 99,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "navi.700": {
            contrast: 56.15821966228906,
            lc60: 100,
            lc45: 75,
            lc30: 48,
            lc10: 24.5
        },
        "navi.800": {
            contrast: 51.12874084022651,
            lc60: 100,
            lc45: 85,
            lc30: 54,
            lc10: 27.5
        },
        "navi.900": {
            contrast: 46.48760916850526,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 31
        },
        "navi.1000": {
            contrast: 42.19218351707876,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34.5
        },
        "navi.1100": {
            contrast: 37.669731016839705,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38.5
        },
        "navi.1200": {
            contrast: 32.655635938947164,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45.5
        },
        "navi.1300": {
            contrast: 27.562469345677997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "navi.1400": {
            contrast: 23.02614526255829,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "navi.1500": {
            contrast: 18.381018927770356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "navi.1600": {
            contrast: 13.416705032187831,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1700": {
            contrast: 8.520760278567115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 10.464390440009636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 16.569456245554683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "navi.2300": {
            contrast: 22.532426048204172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "navi.2400": {
            contrast: 29.00377227941555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "navi.2500": {
            contrast: 35.79148456482099,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46.5
        }
    },
    "navi.2000": {
        "navi.100": {
            contrast: 77.3086897650424,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "navi.200": {
            contrast: 76.58050229909496,
            lc60: 64.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "navi.300": {
            contrast: 74.69219278154894,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "navi.400": {
            contrast: 72.27254162077166,
            lc60: 68.5,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16
        },
        "navi.500": {
            contrast: 69.8506880214525,
            lc60: 77.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "navi.600": {
            contrast: 65.73516310287877,
            lc60: 86.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "navi.700": {
            contrast: 61.48553814884594,
            lc60: 96,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "navi.800": {
            contrast: 56.45605932678339,
            lc60: 100,
            lc45: 75,
            lc30: 48,
            lc10: 24.5
        },
        "navi.900": {
            contrast: 51.81492765506213,
            lc60: 100,
            lc45: 84,
            lc30: 53.5,
            lc10: 27.5
        },
        "navi.1000": {
            contrast: 47.51950200363564,
            lc60: 100,
            lc45: 93.5,
            lc30: 60,
            lc10: 30.5
        },
        "navi.1100": {
            contrast: 42.997049503396575,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34
        },
        "navi.1200": {
            contrast: 37.982954425504026,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 39.5
        },
        "navi.1300": {
            contrast: 32.889787832234866,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 46
        },
        "navi.1400": {
            contrast: 28.35346374911516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "navi.1500": {
            contrast: 23.708337414327225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "navi.1600": {
            contrast: 18.744023518744697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "navi.1700": {
            contrast: 13.848078765123983,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1800": {
            contrast: 8.3516636377119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 10.698084096706562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 16.66105389935605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.2400": {
            contrast: 23.132400130567436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "navi.2500": {
            contrast: 29.92011241597287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "navi.2100": {
        "navi.100": {
            contrast: 82.89599110873581,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "navi.200": {
            contrast: 82.16780364278834,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "navi.300": {
            contrast: 80.27949412524235,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "navi.400": {
            contrast: 77.85984296446506,
            lc60: 62.5,
            lc45: 45,
            lc30: 29,
            lc10: 15
        },
        "navi.500": {
            contrast: 75.43798936514591,
            lc60: 70,
            lc45: 50,
            lc30: 33,
            lc10: 17
        },
        "navi.600": {
            contrast: 71.32246444657218,
            lc60: 77,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "navi.700": {
            contrast: 67.07283949253934,
            lc60: 85.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20.5
        },
        "navi.800": {
            contrast: 62.04336067047679,
            lc60: 95,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "navi.900": {
            contrast: 57.40222899875553,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "navi.1000": {
            contrast: 53.106803347329034,
            lc60: 100,
            lc45: 81.5,
            lc30: 53,
            lc10: 27
        },
        "navi.1100": {
            contrast: 48.58435084708997,
            lc60: 100,
            lc45: 91,
            lc30: 58.5,
            lc10: 30.5
        },
        "navi.1200": {
            contrast: 43.57025576919744,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 34.5
        },
        "navi.1300": {
            contrast: 38.47708917592828,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38.5
        },
        "navi.1400": {
            contrast: 33.94076509280856,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 45
        },
        "navi.1500": {
            contrast: 29.29563875802063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "navi.1600": {
            contrast: 24.331324862438105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "navi.1700": {
            contrast: 19.435380108817387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "navi.1800": {
            contrast: 13.938964981405306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.1900": {
            contrast: 8.719660906931836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 10.439503187790814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 16.9108494190022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "navi.2500": {
            contrast: 23.698561704407638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        }
    },
    "navi.2200": {
        "navi.100": {
            contrast: 88.52759546049491,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "navi.200": {
            contrast: 87.79940799454745,
            lc60: 55,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "navi.300": {
            contrast: 85.91109847700145,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "navi.400": {
            contrast: 83.49144731622417,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "navi.500": {
            contrast: 81.069593716905,
            lc60: 64,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "navi.600": {
            contrast: 76.95406879833128,
            lc60: 70,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "navi.700": {
            contrast: 72.70444384429844,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "navi.800": {
            contrast: 67.6749650222359,
            lc60: 85,
            lc45: 60.5,
            lc30: 40,
            lc10: 20.5
        },
        "navi.900": {
            contrast: 63.03383335051463,
            lc60: 93.5,
            lc45: 66.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "navi.1000": {
            contrast: 58.73840769908812,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "navi.1100": {
            contrast: 54.21595519884907,
            lc60: 100,
            lc45: 80.5,
            lc30: 52,
            lc10: 27
        },
        "navi.1200": {
            contrast: 49.20186012095653,
            lc60: 100,
            lc45: 89.5,
            lc30: 58,
            lc10: 30
        },
        "navi.1300": {
            contrast: 44.108693527687365,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 34
        },
        "navi.1400": {
            contrast: 39.572369444567656,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "navi.1500": {
            contrast: 34.927243109779724,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "navi.1600": {
            contrast: 29.9629292141972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "navi.1700": {
            contrast: 25.06698446057648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "navi.1800": {
            contrast: 19.570569333164396,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "navi.1900": {
            contrast: 14.351265258690932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2000": {
            contrast: 8.95993517829224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 10.577406575736358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 17.3651188611418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        }
    },
    "navi.2300": {
        "navi.100": {
            contrast: 93.99429732830377,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "navi.200": {
            contrast: 93.26610986235633,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "navi.300": {
            contrast: 91.37780034481032,
            lc60: 52.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "navi.400": {
            contrast: 88.95814918403303,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "navi.500": {
            contrast: 86.53629558471387,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "navi.600": {
            contrast: 82.42077066614014,
            lc60: 64,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "navi.700": {
            contrast: 78.17114571210732,
            lc60: 70,
            lc45: 51,
            lc30: 33,
            lc10: 17
        },
        "navi.800": {
            contrast: 73.14166689004476,
            lc60: 77,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 19
        },
        "navi.900": {
            contrast: 68.5005352183235,
            lc60: 84,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "navi.1000": {
            contrast: 64.205109566897,
            lc60: 91.5,
            lc45: 65.5,
            lc30: 43,
            lc10: 22
        },
        "navi.1100": {
            contrast: 59.68265706665795,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "navi.1200": {
            contrast: 54.668561988765404,
            lc60: 100,
            lc45: 80,
            lc30: 52,
            lc10: 26.5
        },
        "navi.1300": {
            contrast: 49.57539539549624,
            lc60: 100,
            lc45: 89.5,
            lc30: 57.5,
            lc10: 30
        },
        "navi.1400": {
            contrast: 45.039071312376535,
            lc60: 100,
            lc45: 99.5,
            lc30: 64.5,
            lc10: 33.5
        },
        "navi.1500": {
            contrast: 40.393944977588596,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "navi.1600": {
            contrast: 35.42963108200607,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 43.5
        },
        "navi.1700": {
            contrast: 30.533686328385357,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 50.5
        },
        "navi.1800": {
            contrast: 25.037271200973272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "navi.1900": {
            contrast: 19.817967126499806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "navi.2000": {
            contrast: 14.426637046101115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2100": {
            contrast: 8.765736302952277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 11.159979652178965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "navi.2400": {
        "navi.100": {
            contrast: 99.89177625879418,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "navi.200": {
            contrast: 99.16358879284671,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12.5
        },
        "navi.300": {
            contrast: 97.27527927530072,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "navi.400": {
            contrast: 94.85562811452344,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "navi.500": {
            contrast: 92.43377451520428,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "navi.600": {
            contrast: 88.31824959663057,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "navi.700": {
            contrast: 84.06862464259771,
            lc60: 64,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "navi.800": {
            contrast: 79.03914582053517,
            lc60: 70,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "navi.900": {
            contrast: 74.3980141488139,
            lc60: 76,
            lc45: 55,
            lc30: 36.5,
            lc10: 19
        },
        "navi.1000": {
            contrast: 70.10258849738742,
            lc60: 82,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "navi.1100": {
            contrast: 65.58013599714835,
            lc60: 89,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "navi.1200": {
            contrast: 60.56604091925581,
            lc60: 98.5,
            lc45: 71,
            lc30: 46.5,
            lc10: 24
        },
        "navi.1300": {
            contrast: 55.472874325986645,
            lc60: 100,
            lc45: 78.5,
            lc30: 51.5,
            lc10: 26.5
        },
        "navi.1400": {
            contrast: 50.93655024286694,
            lc60: 100,
            lc45: 86.5,
            lc30: 56.5,
            lc10: 29.5
        },
        "navi.1500": {
            contrast: 46.291423908079004,
            lc60: 100,
            lc45: 97,
            lc30: 63,
            lc10: 32.5
        },
        "navi.1600": {
            contrast: 41.327110012496476,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36.5
        },
        "navi.1700": {
            contrast: 36.43116525887576,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "navi.1800": {
            contrast: 30.93475013146368,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 50
        },
        "navi.1900": {
            contrast: 25.71544605699021,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "navi.2000": {
            contrast: 20.32411597659152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "navi.2100": {
            contrast: 14.663215233442683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2200": {
            contrast: 8.951130795251263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "navi.2500": {
        "navi.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "navi.200": {
            contrast: 105.31248574674115,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "navi.300": {
            contrast: 103.42417622919515,
            lc60: 46,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "navi.400": {
            contrast: 101.00452506841786,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "navi.500": {
            contrast: 98.58267146909868,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "navi.600": {
            contrast: 94.46714655052496,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "navi.700": {
            contrast: 90.21752159649213,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "navi.800": {
            contrast: 85.18804277442959,
            lc60: 64,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "navi.900": {
            contrast: 80.54691110270832,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "navi.1000": {
            contrast: 76.25148545128182,
            lc60: 74,
            lc45: 54,
            lc30: 36,
            lc10: 18.5
        },
        "navi.1100": {
            contrast: 71.72903295104277,
            lc60: 80,
            lc45: 58,
            lc30: 38.5,
            lc10: 20
        },
        "navi.1200": {
            contrast: 66.71493787315022,
            lc60: 87.5,
            lc45: 63.5,
            lc30: 42,
            lc10: 22
        },
        "navi.1300": {
            contrast: 61.62177127988105,
            lc60: 97,
            lc45: 69.5,
            lc30: 45.5,
            lc10: 24
        },
        "navi.1400": {
            contrast: 57.08544719676135,
            lc60: 100,
            lc45: 76,
            lc30: 50,
            lc10: 26.5
        },
        "navi.1500": {
            contrast: 52.44032086197342,
            lc60: 100,
            lc45: 84,
            lc30: 55,
            lc10: 29
        },
        "navi.1600": {
            contrast: 47.47600696639089,
            lc60: 100,
            lc45: 93.5,
            lc30: 61.5,
            lc10: 32.5
        },
        "navi.1700": {
            contrast: 42.58006221277017,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 36.5
        },
        "navi.1800": {
            contrast: 37.08364708535809,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 42.5
        },
        "navi.1900": {
            contrast: 31.86434301088462,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 50
        },
        "navi.2000": {
            contrast: 26.47301293048593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "navi.2100": {
            contrast: 20.812112187337096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "navi.2200": {
            contrast: 15.100027749145676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "navi.2300": {
            contrast: 9.54949856452588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "navi.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$violet = {
    "violet.100": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 8.021621128930056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 12.006175363982127,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 16.065937446174292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "violet.900": {
            contrast: 20.037516239409438,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "violet.1000": {
            contrast: 23.872988444421463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "violet.1100": {
            contrast: 28.028856617201274,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "violet.1200": {
            contrast: 31.091523963561556,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 68
        },
        "violet.1300": {
            contrast: 37.183276434356074,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 61.5
        },
        "violet.1400": {
            contrast: 41.51381154923055,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 57.5
        },
        "violet.1500": {
            contrast: 46.256587787092165,
            lc60: 100,
            lc45: 98,
            lc30: 77.5,
            lc10: 54
        },
        "violet.1600": {
            contrast: 51.069545281052505,
            lc60: 100,
            lc45: 92.5,
            lc30: 73,
            lc10: 51
        },
        "violet.1700": {
            contrast: 56.310645079484935,
            lc60: 100,
            lc45: 87,
            lc30: 69,
            lc10: 48
        },
        "violet.1800": {
            contrast: 61.83943680712674,
            lc60: 98,
            lc45: 82,
            lc30: 65,
            lc10: 45.5
        },
        "violet.1900": {
            contrast: 67.52003819106858,
            lc60: 93,
            lc45: 78,
            lc30: 61.5,
            lc10: 43
        },
        "violet.2000": {
            contrast: 73.36696865003674,
            lc60: 88,
            lc45: 74,
            lc30: 58.5,
            lc10: 40.5
        },
        "violet.2100": {
            contrast: 80.08752353583577,
            lc60: 83.5,
            lc45: 70,
            lc30: 55.5,
            lc10: 38.5
        },
        "violet.2200": {
            contrast: 86.69457023589052,
            lc60: 79,
            lc45: 66.5,
            lc30: 52.5,
            lc10: 36.5
        },
        "violet.2300": {
            contrast: 93.35009452127872,
            lc60: 76,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "violet.2400": {
            contrast: 100.85853646693488,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "violet.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "violet.200": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 7.643877448650843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 11.628431683702917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 15.688193765895084,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "violet.900": {
            contrast: 19.65977255913023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "violet.1000": {
            contrast: 23.495244764142257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "violet.1100": {
            contrast: 27.65111293692207,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.1200": {
            contrast: 30.71378028328235,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 64.5
        },
        "violet.1300": {
            contrast: 36.805532754076864,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 57.5
        },
        "violet.1400": {
            contrast: 41.13606786895134,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 54
        },
        "violet.1500": {
            contrast: 45.878844106812956,
            lc60: 100,
            lc45: 98.5,
            lc30: 76,
            lc10: 50
        },
        "violet.1600": {
            contrast: 50.6918016007733,
            lc60: 100,
            lc45: 92.5,
            lc30: 71,
            lc10: 47
        },
        "violet.1700": {
            contrast: 55.93290139920571,
            lc60: 100,
            lc45: 86.5,
            lc30: 67,
            lc10: 44
        },
        "violet.1800": {
            contrast: 61.461693126847514,
            lc60: 98,
            lc45: 81.5,
            lc30: 63,
            lc10: 41.5
        },
        "violet.1900": {
            contrast: 67.14229451078936,
            lc60: 93,
            lc45: 77,
            lc30: 59.5,
            lc10: 39.5
        },
        "violet.2000": {
            contrast: 72.98922496975752,
            lc60: 88,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "violet.2100": {
            contrast: 79.70977985555656,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 35.5
        },
        "violet.2200": {
            contrast: 86.3168265556113,
            lc60: 78.5,
            lc45: 65,
            lc30: 50.5,
            lc10: 33.5
        },
        "violet.2300": {
            contrast: 92.97235084099951,
            lc60: 75,
            lc45: 62,
            lc30: 48.5,
            lc10: 32
        },
        "violet.2400": {
            contrast: 100.48079278665567,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 31
        },
        "violet.2500": {
            contrast: 107.50698950281925,
            lc60: 68,
            lc45: 56.5,
            lc30: 44,
            lc10: 29.5
        }
    },
    "violet.300": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 10.472732160746734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 14.532494242938899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 18.504073036174045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "violet.1000": {
            contrast: 22.339545241186073,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "violet.1100": {
            contrast: 26.495413413965878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "violet.1200": {
            contrast: 29.55808076032616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "violet.1300": {
            contrast: 35.64983323112068,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 55.5
        },
        "violet.1400": {
            contrast: 39.98036834599515,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 51.5
        },
        "violet.1500": {
            contrast: 44.723144583856765,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 48
        },
        "violet.1600": {
            contrast: 49.53610207781711,
            lc60: 100,
            lc45: 93.5,
            lc30: 71,
            lc10: 44.5
        },
        "violet.1700": {
            contrast: 54.777201876249535,
            lc60: 100,
            lc45: 87,
            lc30: 66,
            lc10: 42
        },
        "violet.1800": {
            contrast: 60.30599360389134,
            lc60: 99.5,
            lc45: 81.5,
            lc30: 62,
            lc10: 39.5
        },
        "violet.1900": {
            contrast: 65.98659498783319,
            lc60: 93.5,
            lc45: 76.5,
            lc30: 58.5,
            lc10: 37.5
        },
        "violet.2000": {
            contrast: 71.83352544680133,
            lc60: 88,
            lc45: 72.5,
            lc30: 55,
            lc10: 35
        },
        "violet.2100": {
            contrast: 78.55408033260038,
            lc60: 83,
            lc45: 68.5,
            lc30: 52,
            lc10: 33.5
        },
        "violet.2200": {
            contrast: 85.16112703265513,
            lc60: 78.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32
        },
        "violet.2300": {
            contrast: 91.81665131804333,
            lc60: 75,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 30.5
        },
        "violet.2400": {
            contrast: 99.32509326369949,
            lc60: 71,
            lc45: 59,
            lc30: 45,
            lc10: 29
        },
        "violet.2500": {
            contrast: 106.35128997986307,
            lc60: 68,
            lc45: 56,
            lc30: 43,
            lc10: 28
        }
    },
    "violet.400": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 8.828133340852434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 12.887895423044599,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 16.859474216279743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "violet.1000": {
            contrast: 20.69494642129177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "violet.1100": {
            contrast: 24.850814594071583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.1200": {
            contrast: 27.91348194043186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "violet.1300": {
            contrast: 34.005234411226375,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 54.5
        },
        "violet.1400": {
            contrast: 38.335769526100854,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 50.5
        },
        "violet.1500": {
            contrast: 43.07854576396247,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 46.5
        },
        "violet.1600": {
            contrast: 47.89150325792281,
            lc60: 100,
            lc45: 95.5,
            lc30: 71,
            lc10: 43.5
        },
        "violet.1700": {
            contrast: 53.13260305635523,
            lc60: 100,
            lc45: 88.5,
            lc30: 66,
            lc10: 40.5
        },
        "violet.1800": {
            contrast: 58.66139478399703,
            lc60: 100,
            lc45: 82.5,
            lc30: 62,
            lc10: 38
        },
        "violet.1900": {
            contrast: 64.34199616793887,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 58,
            lc10: 36
        },
        "violet.2000": {
            contrast: 70.18892662690703,
            lc60: 89.5,
            lc45: 73,
            lc30: 55,
            lc10: 34
        },
        "violet.2100": {
            contrast: 76.90948151270608,
            lc60: 84,
            lc45: 68.5,
            lc30: 52,
            lc10: 32.5
        },
        "violet.2200": {
            contrast: 83.51652821276083,
            lc60: 79.5,
            lc45: 65,
            lc30: 49,
            lc10: 31
        },
        "violet.2300": {
            contrast: 90.17205249814903,
            lc60: 75.5,
            lc45: 62,
            lc30: 47,
            lc10: 30
        },
        "violet.2400": {
            contrast: 97.68049444380519,
            lc60: 71.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 28.5
        },
        "violet.2500": {
            contrast: 104.70669115996878,
            lc60: 68.5,
            lc45: 56,
            lc30: 43,
            lc10: 27
        }
    },
    "violet.500": {
        "violet.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 10.369185866552453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 14.3407646597876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 18.176236864799627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "violet.1100": {
            contrast: 22.33210503757944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "violet.1200": {
            contrast: 25.394772383939717,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "violet.1300": {
            contrast: 31.48652485473423,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 56.5
        },
        "violet.1400": {
            contrast: 35.817059969608714,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 51.5
        },
        "violet.1500": {
            contrast: 40.559836207470326,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 47.5
        },
        "violet.1600": {
            contrast: 45.372793701430666,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 44
        },
        "violet.1700": {
            contrast: 50.61389349986308,
            lc60: 100,
            lc45: 91.5,
            lc30: 68,
            lc10: 41
        },
        "violet.1800": {
            contrast: 56.142685227504884,
            lc60: 100,
            lc45: 85,
            lc30: 63.5,
            lc10: 38
        },
        "violet.1900": {
            contrast: 61.823286611446726,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 36
        },
        "violet.2000": {
            contrast: 67.67021707041489,
            lc60: 91.5,
            lc45: 74.5,
            lc30: 56,
            lc10: 34
        },
        "violet.2100": {
            contrast: 74.39077195621394,
            lc60: 86,
            lc45: 70,
            lc30: 52.5,
            lc10: 32.5
        },
        "violet.2200": {
            contrast: 80.99781865626868,
            lc60: 81,
            lc45: 66.5,
            lc30: 50,
            lc10: 31
        },
        "violet.2300": {
            contrast: 87.65334294165687,
            lc60: 77,
            lc45: 63,
            lc30: 47.5,
            lc10: 30
        },
        "violet.2400": {
            contrast: 95.16178488731303,
            lc60: 73,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        },
        "violet.2500": {
            contrast: 102.18798160347662,
            lc60: 69.5,
            lc45: 57,
            lc30: 43.5,
            lc10: 27.5
        }
    },
    "violet.600": {
        "violet.100": {
            contrast: 9.342206669233615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 8.835432807002402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 7.320823165487382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 10.674031391903888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 14.509503596915915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 18.665371769695728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "violet.1200": {
            contrast: 21.72803911605601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "violet.1300": {
            contrast: 27.819791586850524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.1400": {
            contrast: 32.15032670172499,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 55.5
        },
        "violet.1500": {
            contrast: 36.89310293958661,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 50.5
        },
        "violet.1600": {
            contrast: 41.70606043354695,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 46.5
        },
        "violet.1700": {
            contrast: 46.947160231979375,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 43
        },
        "violet.1800": {
            contrast: 52.475951959621185,
            lc60: 100,
            lc45: 89.5,
            lc30: 67,
            lc10: 40
        },
        "violet.1900": {
            contrast: 58.15655334356302,
            lc60: 100,
            lc45: 83,
            lc30: 62.5,
            lc10: 38
        },
        "violet.2000": {
            contrast: 64.00348380253118,
            lc60: 95.5,
            lc45: 78,
            lc30: 58.5,
            lc10: 36
        },
        "violet.2100": {
            contrast: 70.72403868833021,
            lc60: 89.5,
            lc45: 73,
            lc30: 55.5,
            lc10: 34
        },
        "violet.2200": {
            contrast: 77.33108538838496,
            lc60: 83.5,
            lc45: 69,
            lc30: 52,
            lc10: 32.5
        },
        "violet.2300": {
            contrast: 83.98660967377317,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 49.5,
            lc10: 31.5
        },
        "violet.2400": {
            contrast: 91.49505161942932,
            lc60: 75.5,
            lc45: 62,
            lc30: 47.5,
            lc10: 30
        },
        "violet.2500": {
            contrast: 98.52124833559292,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        }
    },
    "violet.700": {
        "violet.100": {
            contrast: 13.692148886430402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.200": {
            contrast: 13.185375024199194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.300": {
            contrast: 11.670765382684174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.400": {
            contrast: 9.587757736082855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 10.709749262533172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 14.865617435312984,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 17.928284781673263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "violet.1300": {
            contrast: 24.020037252467784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "violet.1400": {
            contrast: 28.350572367342252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.1500": {
            contrast: 33.093348605203865,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 55.5
        },
        "violet.1600": {
            contrast: 37.90630609916421,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 50.5
        },
        "violet.1700": {
            contrast: 43.14740589759663,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 46.5
        },
        "violet.1800": {
            contrast: 48.67619762523844,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 43
        },
        "violet.1900": {
            contrast: 54.35679900918028,
            lc60: 100,
            lc45: 87.5,
            lc30: 66,
            lc10: 41
        },
        "violet.2000": {
            contrast: 60.20372946814844,
            lc60: 99.5,
            lc45: 82,
            lc30: 62,
            lc10: 38.5
        },
        "violet.2100": {
            contrast: 66.92428435394747,
            lc60: 92.5,
            lc45: 76.5,
            lc30: 58,
            lc10: 36.5
        },
        "violet.2200": {
            contrast: 73.53133105400222,
            lc60: 87,
            lc45: 72,
            lc30: 55,
            lc10: 35
        },
        "violet.2300": {
            contrast: 80.18685533939043,
            lc60: 82.5,
            lc45: 68,
            lc30: 52.5,
            lc10: 33.5
        },
        "violet.2400": {
            contrast: 87.69529728504658,
            lc60: 78,
            lc45: 64.5,
            lc30: 50,
            lc10: 32
        },
        "violet.2500": {
            contrast: 94.72149400121016,
            lc60: 74,
            lc45: 62,
            lc30: 48,
            lc10: 31
        }
    },
    "violet.800": {
        "violet.100": {
            contrast: 18.029329360355387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "violet.200": {
            contrast: 17.522555498124174,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "violet.300": {
            contrast: 16.00794585660915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "violet.400": {
            contrast: 13.92493821000784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.500": {
            contrast: 10.853084051845965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 10.952056078249075,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 14.014723424609357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 20.10647589540387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "violet.1400": {
            contrast: 24.43701101027835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.1500": {
            contrast: 29.179787248139956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "violet.1600": {
            contrast: 33.99274474210031,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 53.5
        },
        "violet.1700": {
            contrast: 39.23384454053272,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 49
        },
        "violet.1800": {
            contrast: 44.76263626817453,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 45
        },
        "violet.1900": {
            contrast: 50.443237652116366,
            lc60: 100,
            lc45: 92,
            lc30: 69,
            lc10: 42
        },
        "violet.2000": {
            contrast: 56.290168111084526,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 39
        },
        "violet.2100": {
            contrast: 63.01072299688357,
            lc60: 96.5,
            lc45: 79,
            lc30: 60,
            lc10: 37
        },
        "violet.2200": {
            contrast: 69.61776969693832,
            lc60: 90.5,
            lc45: 74.5,
            lc30: 56.5,
            lc10: 35.5
        },
        "violet.2300": {
            contrast: 76.27329398232654,
            lc60: 85,
            lc45: 70,
            lc30: 53.5,
            lc10: 33.5
        },
        "violet.2400": {
            contrast: 83.78173592798267,
            lc60: 80,
            lc45: 66,
            lc30: 50.5,
            lc10: 32
        },
        "violet.2500": {
            contrast: 90.80793264414626,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31
        }
    },
    "violet.900": {
        "violet.100": {
            contrast: 22.198086017927906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "violet.200": {
            contrast: 21.691312155696696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "violet.300": {
            contrast: 20.176702514181674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "violet.400": {
            contrast: 18.093694867580357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "violet.500": {
            contrast: 15.021840709418482,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "violet.600": {
            contrast: 10.72868926629143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 10.15225642621907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 16.244008897013586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "violet.1400": {
            contrast: 20.57454401188806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "violet.1500": {
            contrast: 25.31732024974967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "violet.1600": {
            contrast: 30.13027774371002,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 57.5
        },
        "violet.1700": {
            contrast: 35.37137754214244,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 51
        },
        "violet.1800": {
            contrast: 40.90016926978425,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 46.5
        },
        "violet.1900": {
            contrast: 46.580770653726084,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 42.5
        },
        "violet.2000": {
            contrast: 52.427701112694244,
            lc60: 100,
            lc45: 89,
            lc30: 66.5,
            lc10: 39
        },
        "violet.2100": {
            contrast: 59.14825599849328,
            lc60: 100,
            lc45: 82,
            lc30: 61.5,
            lc10: 37
        },
        "violet.2200": {
            contrast: 65.75530269854804,
            lc60: 93.5,
            lc45: 76.5,
            lc30: 57.5,
            lc10: 34.5
        },
        "violet.2300": {
            contrast: 72.41082698393623,
            lc60: 87.5,
            lc45: 71.5,
            lc30: 54,
            lc10: 33
        },
        "violet.2400": {
            contrast: 79.91926892959239,
            lc60: 82,
            lc45: 67,
            lc30: 50.5,
            lc10: 31
        },
        "violet.2500": {
            contrast: 86.94546564575597,
            lc60: 77.5,
            lc45: 63.5,
            lc30: 48,
            lc10: 30
        }
    },
    "violet.1000": {
        "violet.100": {
            contrast: 26.165916569642583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "violet.200": {
            contrast: 25.659142707411377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "violet.300": {
            contrast: 24.144533065896358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "violet.400": {
            contrast: 22.06152541929504,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "violet.500": {
            contrast: 18.989671261133168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "violet.600": {
            contrast: 14.696519818006115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.700": {
            contrast: 10.40658228792826,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 12.486725829610535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 16.817260944485014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "violet.1500": {
            contrast: 21.560037182346623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "violet.1600": {
            contrast: 26.372994676306966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "violet.1700": {
            contrast: 31.61409447473939,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 55.5
        },
        "violet.1800": {
            contrast: 37.1428862023812,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 49
        },
        "violet.1900": {
            contrast: 42.82348758632303,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 45
        },
        "violet.2000": {
            contrast: 48.6704180452912,
            lc60: 100,
            lc45: 94.5,
            lc30: 69.5,
            lc10: 41
        },
        "violet.2100": {
            contrast: 55.39097293109023,
            lc60: 100,
            lc45: 86,
            lc30: 64,
            lc10: 38.5
        },
        "violet.2200": {
            contrast: 61.998019631144984,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59,
            lc10: 35.5
        },
        "violet.2300": {
            contrast: 68.6535439165332,
            lc60: 91,
            lc45: 74,
            lc30: 56,
            lc10: 33.5
        },
        "violet.2400": {
            contrast: 76.16198586218934,
            lc60: 84.5,
            lc45: 69,
            lc30: 52,
            lc10: 31.5
        },
        "violet.2500": {
            contrast: 83.18818257835292,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 49,
            lc10: 30
        }
    },
    "violet.1100": {
        "violet.100": {
            contrast: 30.410149252266887,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 35
        },
        "violet.200": {
            contrast: 29.90337539003568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "violet.300": {
            contrast: 28.38876574852066,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "violet.400": {
            contrast: 26.305758101919345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "violet.500": {
            contrast: 23.23390394375747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "violet.600": {
            contrast: 18.94075250063042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "violet.700": {
            contrast: 14.650814970552565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.800": {
            contrast: 10.35800563063397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 8.38926295921561,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 12.719798074090088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 17.4625743119517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "violet.1600": {
            contrast: 22.275531805912046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "violet.1700": {
            contrast: 27.51663160434446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "violet.1800": {
            contrast: 33.04542333198627,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 53.5
        },
        "violet.1900": {
            contrast: 38.72602471592811,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 47.5
        },
        "violet.2000": {
            contrast: 44.572955174896265,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 43.5
        },
        "violet.2100": {
            contrast: 51.293510060695304,
            lc60: 100,
            lc45: 90.5,
            lc30: 67.5,
            lc10: 40
        },
        "violet.2200": {
            contrast: 57.90055676075006,
            lc60: 100,
            lc45: 83.5,
            lc30: 62,
            lc10: 37
        },
        "violet.2300": {
            contrast: 64.55608104613826,
            lc60: 94.5,
            lc45: 77.5,
            lc30: 57.5,
            lc10: 34.5
        },
        "violet.2400": {
            contrast: 72.0645229917944,
            lc60: 88,
            lc45: 71.5,
            lc30: 53.5,
            lc10: 32.5
        },
        "violet.2500": {
            contrast: 79.09071970795799,
            lc60: 82,
            lc45: 67.5,
            lc30: 50.5,
            lc10: 30.5
        }
    },
    "violet.1200": {
        "violet.100": {
            contrast: 33.50568852249586,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 32
        },
        "violet.200": {
            contrast: 32.99891466026465,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 37
        },
        "violet.300": {
            contrast: 31.48430501874963,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 41.5
        },
        "violet.400": {
            contrast: 29.401297372148317,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "violet.500": {
            contrast: 26.329443213986437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "violet.600": {
            contrast: 22.036291770859386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "violet.700": {
            contrast: 17.746354240781535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "violet.800": {
            contrast: 13.45354490086294,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.900": {
            contrast: 9.315280532169856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 9.684492937970388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 14.427269175832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 19.240226669792342,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "violet.1700": {
            contrast: 24.481326468224765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "violet.1800": {
            contrast: 30.01011819586657,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56.5
        },
        "violet.1900": {
            contrast: 35.6907195798084,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 49.5
        },
        "violet.2000": {
            contrast: 41.53765003877656,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 45
        },
        "violet.2100": {
            contrast: 48.25820492457561,
            lc60: 100,
            lc45: 94.5,
            lc30: 69.5,
            lc10: 41
        },
        "violet.2200": {
            contrast: 54.86525162463036,
            lc60: 100,
            lc45: 86.5,
            lc30: 63.5,
            lc10: 37.5
        },
        "violet.2300": {
            contrast: 61.52077591001856,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59,
            lc10: 34.5
        },
        "violet.2400": {
            contrast: 69.0292178556747,
            lc60: 90.5,
            lc45: 73.5,
            lc30: 54.5,
            lc10: 32.5
        },
        "violet.2500": {
            contrast: 76.05541457183828,
            lc60: 84,
            lc45: 68.5,
            lc30: 51,
            lc10: 30.5
        }
    },
    "violet.1300": {
        "violet.100": {
            contrast: 39.591734741741945,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 27.5
        },
        "violet.200": {
            contrast: 39.084960879510746,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "violet.300": {
            contrast: 37.570351237995716,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35
        },
        "violet.400": {
            contrast: 35.487343591394406,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 38.5
        },
        "violet.500": {
            contrast: 32.41548943323252,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 44
        },
        "violet.600": {
            contrast: 28.12233799010548,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "violet.700": {
            contrast: 23.83240046002762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "violet.800": {
            contrast: 19.53959112010903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "violet.900": {
            contrast: 15.401326751415947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "violet.1000": {
            contrast: 11.452968825583081,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 8.354755466683784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 13.167712960644126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 18.408812759076547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "violet.1800": {
            contrast: 23.93760448671836,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "violet.1900": {
            contrast: 29.61820587066019,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "violet.2000": {
            contrast: 35.46513632962835,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 50
        },
        "violet.2100": {
            contrast: 42.18569121542739,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44.5
        },
        "violet.2200": {
            contrast: 48.79273791548214,
            lc60: 100,
            lc45: 93.5,
            lc30: 69,
            lc10: 40
        },
        "violet.2300": {
            contrast: 55.448262200870346,
            lc60: 100,
            lc45: 85.5,
            lc30: 63,
            lc10: 36.5
        },
        "violet.2400": {
            contrast: 62.9567041465265,
            lc60: 96.5,
            lc45: 78,
            lc30: 57.5,
            lc10: 33.5
        },
        "violet.2500": {
            contrast: 69.98290086269007,
            lc60: 89.5,
            lc45: 72.5,
            lc30: 53,
            lc10: 31.5
        }
    },
    "violet.1400": {
        "violet.100": {
            contrast: 43.86727862082987,
            lc60: 100,
            lc45: 100,
            lc30: 51,
            lc10: 25
        },
        "violet.200": {
            contrast: 43.360504758598665,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28.5
        },
        "violet.300": {
            contrast: 41.84589511708365,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31
        },
        "violet.400": {
            contrast: 39.76288747048233,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 34
        },
        "violet.500": {
            contrast: 36.69103331232046,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38
        },
        "violet.600": {
            contrast: 32.397881869193405,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 43
        },
        "violet.700": {
            contrast: 28.107944339115548,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "violet.800": {
            contrast: 23.81513499919696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "violet.900": {
            contrast: 19.676870630503878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "violet.1000": {
            contrast: 15.72851270467101,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "violet.1100": {
            contrast: 11.496027613379777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1200": {
            contrast: 8.403718163962488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 8.825234698038331,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 14.066334496470754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 19.595126224112562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "violet.1900": {
            contrast: 25.275727608054392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "violet.2000": {
            contrast: 31.122658067022552,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 55
        },
        "violet.2100": {
            contrast: 37.843212952821595,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 47.5
        },
        "violet.2200": {
            contrast: 44.45025965287635,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41.5
        },
        "violet.2300": {
            contrast: 51.10578393826455,
            lc60: 100,
            lc45: 90.5,
            lc30: 66,
            lc10: 38.5
        },
        "violet.2400": {
            contrast: 58.61422588392069,
            lc60: 100,
            lc45: 81.5,
            lc30: 60,
            lc10: 35
        },
        "violet.2500": {
            contrast: 65.64042260008429,
            lc60: 93,
            lc45: 75,
            lc30: 55.5,
            lc10: 32
        }
    },
    "violet.1500": {
        "violet.100": {
            contrast: 48.506923323029724,
            lc60: 100,
            lc45: 76,
            lc30: 46,
            lc10: 23
        },
        "violet.200": {
            contrast: 48.000149460798525,
            lc60: 100,
            lc45: 84,
            lc30: 51,
            lc10: 25.5
        },
        "violet.300": {
            contrast: 46.4855398192835,
            lc60: 100,
            lc45: 93,
            lc30: 56,
            lc10: 28
        },
        "violet.400": {
            contrast: 44.402532172682186,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "violet.500": {
            contrast: 41.330678014520316,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33
        },
        "violet.600": {
            contrast: 37.03752657139326,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 37
        },
        "violet.700": {
            contrast: 32.74758904131541,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 41
        },
        "violet.800": {
            contrast: 28.45477970139681,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "violet.900": {
            contrast: 24.316515332703734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "violet.1000": {
            contrast: 20.368157406870864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "violet.1100": {
            contrast: 16.135672315579633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "violet.1200": {
            contrast: 13.043362866162344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 9.288538836565156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 14.817330564206966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 20.4979319481488,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "violet.2000": {
            contrast: 26.344862407116953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.2100": {
            contrast: 33.065417292916,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 52.5
        },
        "violet.2200": {
            contrast: 39.672463992970755,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 45
        },
        "violet.2300": {
            contrast: 46.32798827835895,
            lc60: 100,
            lc45: 98,
            lc30: 71,
            lc10: 41
        },
        "violet.2400": {
            contrast: 53.836430224015096,
            lc60: 100,
            lc45: 87,
            lc30: 63.5,
            lc10: 36
        },
        "violet.2500": {
            contrast: 60.86262694017868,
            lc60: 99,
            lc45: 79.5,
            lc30: 58,
            lc10: 33.5
        }
    },
    "violet.1600": {
        "violet.100": {
            contrast: 53.173796904693006,
            lc60: 100,
            lc45: 66.5,
            lc30: 42,
            lc10: 21
        },
        "violet.200": {
            contrast: 52.6670230424618,
            lc60: 100,
            lc45: 73,
            lc30: 46.5,
            lc10: 23
        },
        "violet.300": {
            contrast: 51.15241340094677,
            lc60: 100,
            lc45: 79.5,
            lc30: 50,
            lc10: 25
        },
        "violet.400": {
            contrast: 49.06940575434546,
            lc60: 100,
            lc45: 86.5,
            lc30: 54,
            lc10: 27
        },
        "violet.500": {
            contrast: 45.997551596183584,
            lc60: 100,
            lc45: 97,
            lc30: 59.5,
            lc10: 29.5
        },
        "violet.600": {
            contrast: 41.70440015305654,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32.5
        },
        "violet.700": {
            contrast: 37.414462622978675,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 35.5
        },
        "violet.800": {
            contrast: 33.121653283060084,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 41
        },
        "violet.900": {
            contrast: 28.983388914367005,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "violet.1000": {
            contrast: 25.035030988534135,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "violet.1100": {
            contrast: 20.802545897242908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "violet.1200": {
            contrast: 17.71023644782562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "violet.1300": {
            contrast: 11.618766712211052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1400": {
            contrast: 7.330954681947145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 9.947365576015867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 15.627966959957707,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "violet.2000": {
            contrast: 21.474897418925863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "violet.2100": {
            contrast: 28.195452304724906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "violet.2200": {
            contrast: 34.802499004779655,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49.5
        },
        "violet.2300": {
            contrast: 41.45802329016786,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 43.5
        },
        "violet.2400": {
            contrast: 48.96646523582401,
            lc60: 100,
            lc45: 93,
            lc30: 68,
            lc10: 38.5
        },
        "violet.2500": {
            contrast: 55.9926619519876,
            lc60: 100,
            lc45: 84,
            lc30: 61,
            lc10: 35.5
        }
    },
    "violet.1700": {
        "violet.100": {
            contrast: 58.21281870508499,
            lc60: 100,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "violet.200": {
            contrast: 57.706044842853764,
            lc60: 100,
            lc45: 65.5,
            lc30: 42,
            lc10: 21.5
        },
        "violet.300": {
            contrast: 56.19143520133875,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 23
        },
        "violet.400": {
            contrast: 54.10842755473744,
            lc60: 100,
            lc45: 76,
            lc30: 48.5,
            lc10: 24.5
        },
        "violet.500": {
            contrast: 51.036573396575555,
            lc60: 100,
            lc45: 83.5,
            lc30: 52.5,
            lc10: 26.5
        },
        "violet.600": {
            contrast: 46.74342195344851,
            lc60: 100,
            lc45: 94,
            lc30: 57,
            lc10: 28.5
        },
        "violet.700": {
            contrast: 42.45348442337066,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "violet.800": {
            contrast: 38.16067508345206,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34.5
        },
        "violet.900": {
            contrast: 34.022410714758976,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 41
        },
        "violet.1000": {
            contrast: 30.074052788926114,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 47
        },
        "violet.1100": {
            contrast: 25.841567697634883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "violet.1200": {
            contrast: 22.749258248217593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "violet.1300": {
            contrast: 16.657788512603027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "violet.1400": {
            contrast: 12.369976482339121,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1500": {
            contrast: 7.709874915442032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 10.30221006355485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 16.14914052252301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "violet.2100": {
            contrast: 22.869695408322052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "violet.2200": {
            contrast: 29.476742108376797,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "violet.2300": {
            contrast: 36.132266393765,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48
        },
        "violet.2400": {
            contrast: 43.64070833942115,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42
        },
        "violet.2500": {
            contrast: 50.666905055584735,
            lc60: 100,
            lc45: 91,
            lc30: 65.5,
            lc10: 37
        }
    },
    "violet.1800": {
        "violet.100": {
            contrast: 63.484262667268275,
            lc60: 80,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "violet.200": {
            contrast: 62.97748880503706,
            lc60: 86.5,
            lc45: 59,
            lc30: 38.5,
            lc10: 19.5
        },
        "violet.300": {
            contrast: 61.46287916352203,
            lc60: 94,
            lc45: 63.5,
            lc30: 41,
            lc10: 21
        },
        "violet.400": {
            contrast: 59.37987151692074,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "violet.500": {
            contrast: 56.30801735875885,
            lc60: 100,
            lc45: 73,
            lc30: 46.5,
            lc10: 23.5
        },
        "violet.600": {
            contrast: 52.0148659156318,
            lc60: 100,
            lc45: 80.5,
            lc30: 50,
            lc10: 25
        },
        "violet.700": {
            contrast: 47.724928385553945,
            lc60: 100,
            lc45: 90.5,
            lc30: 54.5,
            lc10: 27
        },
        "violet.800": {
            contrast: 43.43211904563535,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "violet.900": {
            contrast: 39.29385467694227,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35
        },
        "violet.1000": {
            contrast: 35.34549675110941,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 38.5
        },
        "violet.1100": {
            contrast: 31.113011659818174,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 45
        },
        "violet.1200": {
            contrast: 28.020702210400884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "violet.1300": {
            contrast: 21.92923247478632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "violet.1400": {
            contrast: 17.641420444522414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "violet.1500": {
            contrast: 12.981318877625322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1600": {
            contrast: 8.28695873681906,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 10.507553403153514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 17.228108288952555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "violet.2200": {
            contrast: 23.83515498900731,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "violet.2300": {
            contrast: 30.490679274395504,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 56
        },
        "violet.2400": {
            contrast: 37.999121220051656,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "violet.2500": {
            contrast: 45.025317936215245,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 40
        }
    },
    "violet.1900": {
        "violet.100": {
            contrast: 68.85737373885154,
            lc60: 70.5,
            lc45: 50,
            lc30: 33,
            lc10: 16.5
        },
        "violet.200": {
            contrast: 68.35059987662032,
            lc60: 75.5,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "violet.300": {
            contrast: 66.8359902351053,
            lc60: 81.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19
        },
        "violet.400": {
            contrast: 64.752982588504,
            lc60: 87,
            lc45: 61,
            lc30: 39.5,
            lc10: 20.5
        },
        "violet.500": {
            contrast: 61.68112843034211,
            lc60: 95.5,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "violet.600": {
            contrast: 57.38797698721506,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "violet.700": {
            contrast: 53.098039457137205,
            lc60: 100,
            lc45: 76.5,
            lc30: 47.5,
            lc10: 24
        },
        "violet.800": {
            contrast: 48.80523011721861,
            lc60: 100,
            lc45: 87.5,
            lc30: 52.5,
            lc10: 26
        },
        "violet.900": {
            contrast: 44.66696574852553,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "violet.1000": {
            contrast: 40.71860782269267,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33
        },
        "violet.1100": {
            contrast: 36.48612273140143,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 37
        },
        "violet.1200": {
            contrast: 33.393813281984144,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 42
        },
        "violet.1300": {
            contrast: 27.302343546369574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "violet.1400": {
            contrast: 23.01453151610567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "violet.1500": {
            contrast: 18.35442994920858,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "violet.1600": {
            contrast: 13.66006980840232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1700": {
            contrast: 8.584186376537756,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 11.408426769727722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 18.01547346978247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "violet.2300": {
            contrast: 24.670997755170674,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "violet.2400": {
            contrast: 32.179439700826826,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52.5
        },
        "violet.2500": {
            contrast: 39.2056364169904,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        }
    },
    "violet.2000": {
        "violet.100": {
            contrast: 74.34606353178759,
            lc60: 64.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "violet.200": {
            contrast: 73.83928966955638,
            lc60: 69,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "violet.300": {
            contrast: 72.32468002804136,
            lc60: 73,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "violet.400": {
            contrast: 70.24167238144004,
            lc60: 78,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "violet.500": {
            contrast: 67.16981822327817,
            lc60: 83.5,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "violet.600": {
            contrast: 62.87666678015111,
            lc60: 92,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "violet.700": {
            contrast: 58.58672925007327,
            lc60: 100,
            lc45: 66.5,
            lc30: 42,
            lc10: 21
        },
        "violet.800": {
            contrast: 54.29391991015468,
            lc60: 100,
            lc45: 74.5,
            lc30: 46.5,
            lc10: 23
        },
        "violet.900": {
            contrast: 50.155655541461584,
            lc60: 100,
            lc45: 85,
            lc30: 52.5,
            lc10: 26
        },
        "violet.1000": {
            contrast: 46.207297615628725,
            lc60: 100,
            lc45: 95.5,
            lc30: 58,
            lc10: 29
        },
        "violet.1100": {
            contrast: 41.97481252433749,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 32
        },
        "violet.1200": {
            contrast: 38.8825030749202,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "violet.1300": {
            contrast: 32.79103333930563,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 43.5
        },
        "violet.1400": {
            contrast: 28.503221309041727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "violet.1500": {
            contrast: 23.84311974214464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "violet.1600": {
            contrast: 19.148759601338377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "violet.1700": {
            contrast: 14.072876169473814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1800": {
            contrast: 8.755479217640099,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 12.002654515511463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 18.658178800899663,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "violet.2400": {
            contrast: 26.166620746555814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "violet.2500": {
            contrast: 33.19281746271939,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51.5
        }
    },
    "violet.2100": {
        "violet.100": {
            contrast: 80.60689492891142,
            lc60: 59,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "violet.200": {
            contrast: 80.1001210666802,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "violet.300": {
            contrast: 78.58551142516518,
            lc60: 66,
            lc45: 48,
            lc30: 31,
            lc10: 16.5
        },
        "violet.400": {
            contrast: 76.50250377856386,
            lc60: 69.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "violet.500": {
            contrast: 73.430649620402,
            lc60: 73,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "violet.600": {
            contrast: 69.13749817727495,
            lc60: 79,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "violet.700": {
            contrast: 64.84756064719708,
            lc60: 86,
            lc45: 58,
            lc30: 37,
            lc10: 19
        },
        "violet.800": {
            contrast: 60.5547513072785,
            lc60: 97.5,
            lc45: 64,
            lc30: 40.5,
            lc10: 20.5
        },
        "violet.900": {
            contrast: 56.41648693858542,
            lc60: 100,
            lc45: 71.5,
            lc30: 45,
            lc10: 22.5
        },
        "violet.1000": {
            contrast: 52.46812901275255,
            lc60: 100,
            lc45: 79,
            lc30: 49,
            lc10: 25
        },
        "violet.1100": {
            contrast: 48.23564392146131,
            lc60: 100,
            lc45: 90,
            lc30: 55,
            lc10: 27
        },
        "violet.1200": {
            contrast: 45.143334472044025,
            lc60: 100,
            lc45: 99,
            lc30: 60,
            lc10: 29.5
        },
        "violet.1300": {
            contrast: 39.05186473642946,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 35.5
        },
        "violet.1400": {
            contrast: 34.76405270616555,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41
        },
        "violet.1500": {
            contrast: 30.103951139268464,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 48
        },
        "violet.1600": {
            contrast: 25.4095909984622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "violet.1700": {
            contrast: 20.33370756659764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "violet.1800": {
            contrast: 15.016310614763922,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "violet.1900": {
            contrast: 9.589142171112659,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 11.72052910430258,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 19.22897104995873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "violet.2500": {
            contrast: 26.255167766122312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        }
    },
    "violet.2200": {
        "violet.100": {
            contrast: 86.71603979783785,
            lc60: 54.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "violet.200": {
            contrast: 86.20926593560662,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "violet.300": {
            contrast: 84.6946562940916,
            lc60: 60,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "violet.400": {
            contrast: 82.6116486474903,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "violet.500": {
            contrast: 79.53979448932841,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "violet.600": {
            contrast: 75.24664304620137,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "violet.700": {
            contrast: 70.95670551612352,
            lc60: 74,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "violet.800": {
            contrast: 66.66389617620493,
            lc60: 82.5,
            lc45: 56,
            lc30: 36,
            lc10: 18
        },
        "violet.900": {
            contrast: 62.525631807511836,
            lc60: 93,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "violet.1000": {
            contrast: 58.57727388167897,
            lc60: 100,
            lc45: 68,
            lc30: 43,
            lc10: 22
        },
        "violet.1100": {
            contrast: 54.344788790387746,
            lc60: 100,
            lc45: 76,
            lc30: 47.5,
            lc10: 23.5
        },
        "violet.1200": {
            contrast: 51.252479340970446,
            lc60: 100,
            lc45: 83,
            lc30: 51.5,
            lc10: 26
        },
        "violet.1300": {
            contrast: 45.161009605355886,
            lc60: 100,
            lc45: 98.5,
            lc30: 60.5,
            lc10: 30
        },
        "violet.1400": {
            contrast: 40.87319757509197,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33.5
        },
        "violet.1500": {
            contrast: 36.21309600819489,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 39
        },
        "violet.1600": {
            contrast: 31.518735867388624,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 45.5
        },
        "violet.1700": {
            contrast: 26.44285243552406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "violet.1800": {
            contrast: 21.12545548369035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "violet.1900": {
            contrast: 15.698287040039085,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "violet.2000": {
            contrast: 10.147371225897578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 12.382900319849988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 19.40909703601357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        }
    },
    "violet.2300": {
        "violet.100": {
            contrast: 92.8275737152036,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "violet.200": {
            contrast: 92.32079985297239,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "violet.300": {
            contrast: 90.80619021145736,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "violet.400": {
            contrast: 88.72318256485605,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "violet.500": {
            contrast: 85.65132840669418,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "violet.600": {
            contrast: 81.35817696356712,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "violet.700": {
            contrast: 77.06823943348925,
            lc60: 65.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "violet.800": {
            contrast: 72.77543009357068,
            lc60: 71.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "violet.900": {
            contrast: 68.63716572487758,
            lc60: 80,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "violet.1000": {
            contrast: 64.68880779904472,
            lc60: 87.5,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "violet.1100": {
            contrast: 60.45632270775349,
            lc60: 98.5,
            lc45: 65,
            lc30: 41.5,
            lc10: 21
        },
        "violet.1200": {
            contrast: 57.3640132583362,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 23
        },
        "violet.1300": {
            contrast: 51.272543522721634,
            lc60: 100,
            lc45: 83,
            lc30: 51.5,
            lc10: 26
        },
        "violet.1400": {
            contrast: 46.984731492457726,
            lc60: 100,
            lc45: 93.5,
            lc30: 58,
            lc10: 29
        },
        "violet.1500": {
            contrast: 42.324629925560636,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33
        },
        "violet.1600": {
            contrast: 37.630269784754375,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38
        },
        "violet.1700": {
            contrast: 32.554386352889814,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 45
        },
        "violet.1800": {
            contrast: 27.236989401056093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "violet.1900": {
            contrast: 21.809820957404835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "violet.2000": {
            contrast: 16.25890514326333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "violet.2100": {
            contrast: 9.91903651105554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 12.488895525162208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "violet.2400": {
        "violet.100": {
            contrast: 99.6750641519469,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "violet.200": {
            contrast: 99.16829028971567,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "violet.300": {
            contrast: 97.65368064820065,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "violet.400": {
            contrast: 95.57067300159935,
            lc60: 52.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "violet.500": {
            contrast: 92.49881884343748,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "violet.600": {
            contrast: 88.20566740031042,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "violet.700": {
            contrast: 83.91572987023257,
            lc60: 58.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "violet.800": {
            contrast: 79.62292053031398,
            lc60: 63,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "violet.900": {
            contrast: 75.48465616162089,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32,
            lc10: 16.5
        },
        "violet.1000": {
            contrast: 71.53629823578802,
            lc60: 75,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "violet.1100": {
            contrast: 67.3038131444968,
            lc60: 82,
            lc45: 57,
            lc30: 37,
            lc10: 19
        },
        "violet.1200": {
            contrast: 64.2115036950795,
            lc60: 89.5,
            lc45: 61,
            lc30: 39.5,
            lc10: 20.5
        },
        "violet.1300": {
            contrast: 58.120033959464934,
            lc60: 100,
            lc45: 70,
            lc30: 44.5,
            lc10: 23
        },
        "violet.1400": {
            contrast: 53.832221929201026,
            lc60: 100,
            lc45: 78,
            lc30: 49.5,
            lc10: 25.5
        },
        "violet.1500": {
            contrast: 49.17212036230394,
            lc60: 100,
            lc45: 88.5,
            lc30: 55,
            lc10: 28
        },
        "violet.1600": {
            contrast: 44.477760221497675,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31.5
        },
        "violet.1700": {
            contrast: 39.401876789633114,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 36.5
        },
        "violet.1800": {
            contrast: 34.08447983779939,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43.5
        },
        "violet.1900": {
            contrast: 28.65731139414813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "violet.2000": {
            contrast: 23.106395580006627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "violet.2100": {
            contrast: 16.766526947798837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "violet.2200": {
            contrast: 10.572529730735928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "violet.2500": {
        "violet.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "violet.200": {
            contrast: 105.53389935045739,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "violet.300": {
            contrast: 104.01928970894237,
            lc60: 47.5,
            lc45: 35,
            lc30: 23,
            lc10: 12.5
        },
        "violet.400": {
            contrast: 101.93628206234106,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "violet.500": {
            contrast: 98.86442790417917,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "violet.600": {
            contrast: 94.57127646105212,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "violet.700": {
            contrast: 90.28133893097427,
            lc60: 53.5,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "violet.800": {
            contrast: 85.98852959105568,
            lc60: 57,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "violet.900": {
            contrast: 81.8502652223626,
            lc60: 62,
            lc45: 45,
            lc30: 29.5,
            lc10: 15
        },
        "violet.1000": {
            contrast: 77.90190729652973,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "violet.1100": {
            contrast: 73.66942220523849,
            lc60: 72,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "violet.1200": {
            contrast: 70.5771127558212,
            lc60: 77,
            lc45: 54.5,
            lc30: 35,
            lc10: 18.5
        },
        "violet.1300": {
            contrast: 64.48564302020664,
            lc60: 88.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "violet.1400": {
            contrast: 60.19783098994272,
            lc60: 99,
            lc45: 67.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "violet.1500": {
            contrast: 55.53772942304563,
            lc60: 100,
            lc45: 75.5,
            lc30: 48,
            lc10: 24.5
        },
        "violet.1600": {
            contrast: 50.84336928223938,
            lc60: 100,
            lc45: 85,
            lc30: 54,
            lc10: 27.5
        },
        "violet.1700": {
            contrast: 45.76748585037481,
            lc60: 100,
            lc45: 97,
            lc30: 61,
            lc10: 31.5
        },
        "violet.1800": {
            contrast: 40.4500888985411,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 36
        },
        "violet.1900": {
            contrast: 35.022920454889835,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 42.5
        },
        "violet.2000": {
            contrast: 29.472004640748327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "violet.2100": {
            contrast: 23.13213600854054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "violet.2200": {
            contrast: 16.93813879147763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "violet.2300": {
            contrast: 10.73456899674881,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "violet.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$gold = {
    "gold.100": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 7.785550668996548,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 10.411236051605243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 13.179506008308781,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 16.845986470147956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "gold.1100": {
            contrast: 20.71272606513296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "gold.1200": {
            contrast: 24.890785881104247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.1300": {
            contrast: 29.260943471116736,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "gold.1400": {
            contrast: 33.940757946530596,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 61
        },
        "gold.1500": {
            contrast: 38.80945032155926,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 55.5
        },
        "gold.1600": {
            contrast: 44.67929937976691,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 51
        },
        "gold.1700": {
            contrast: 50.95906187848522,
            lc60: 100,
            lc45: 92,
            lc30: 70.5,
            lc10: 46.5
        },
        "gold.1800": {
            contrast: 56.7740696646039,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 43.5
        },
        "gold.1900": {
            contrast: 63.54357080763432,
            lc60: 96.5,
            lc45: 79.5,
            lc30: 61,
            lc10: 40.5
        },
        "gold.2000": {
            contrast: 72.3996648377026,
            lc60: 88,
            lc45: 73,
            lc30: 56,
            lc10: 37
        },
        "gold.2100": {
            contrast: 81.75057557426906,
            lc60: 81,
            lc45: 67,
            lc30: 52,
            lc10: 34
        },
        "gold.2200": {
            contrast: 90.18314865828478,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "gold.2300": {
            contrast: 96.71134704009945,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30.5
        },
        "gold.2400": {
            contrast: 101.59505486353697,
            lc60: 70,
            lc45: 58,
            lc30: 45,
            lc10: 29.5
        },
        "gold.2500": {
            contrast: 107.56173245542702,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "gold.200": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 9.713984711141816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 12.48225466784535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 16.14873512968453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "gold.1100": {
            contrast: 20.01547472466953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "gold.1200": {
            contrast: 24.19353454064082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "gold.1300": {
            contrast: 28.56369213065331,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.1400": {
            contrast: 33.24350660606717,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 59
        },
        "gold.1500": {
            contrast: 38.11219898109583,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 53.5
        },
        "gold.1600": {
            contrast: 43.98204803930348,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 48.5
        },
        "gold.1700": {
            contrast: 50.2618105380218,
            lc60: 100,
            lc45: 92.5,
            lc30: 70,
            lc10: 44
        },
        "gold.1800": {
            contrast: 56.076818324140476,
            lc60: 100,
            lc45: 85.5,
            lc30: 65,
            lc10: 41
        },
        "gold.1900": {
            contrast: 62.8463194671709,
            lc60: 96.5,
            lc45: 79.5,
            lc30: 60,
            lc10: 38
        },
        "gold.2000": {
            contrast: 71.70241349723918,
            lc60: 88,
            lc45: 72,
            lc30: 55,
            lc10: 34.5
        },
        "gold.2100": {
            contrast: 81.05332423380564,
            lc60: 81,
            lc45: 66.5,
            lc30: 50.5,
            lc10: 32
        },
        "gold.2200": {
            contrast: 89.48589731782135,
            lc60: 75.5,
            lc45: 62,
            lc30: 47,
            lc10: 29.5
        },
        "gold.2300": {
            contrast: 96.01409569963603,
            lc60: 72,
            lc45: 59,
            lc30: 45,
            lc10: 28.5
        },
        "gold.2400": {
            contrast: 100.89780352307356,
            lc60: 69.5,
            lc45: 57,
            lc30: 43.5,
            lc10: 27.5
        },
        "gold.2500": {
            contrast: 106.86448111496358,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26.5
        }
    },
    "gold.300": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 8.703887990655074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 11.472157947358607,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 15.138638409197785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "gold.1100": {
            contrast: 19.005378004182788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "gold.1200": {
            contrast: 23.183437820154076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "gold.1300": {
            contrast: 27.553595410166565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "gold.1400": {
            contrast: 32.23340988558043,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 58.5
        },
        "gold.1500": {
            contrast: 37.10210226060909,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 53
        },
        "gold.1600": {
            contrast: 42.97195131881674,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 47.5
        },
        "gold.1700": {
            contrast: 49.25171381753505,
            lc60: 100,
            lc45: 93.5,
            lc30: 70,
            lc10: 43
        },
        "gold.1800": {
            contrast: 55.06672160365373,
            lc60: 100,
            lc45: 86,
            lc30: 64.5,
            lc10: 39.5
        },
        "gold.1900": {
            contrast: 61.83622274668416,
            lc60: 97.5,
            lc45: 79.5,
            lc30: 59.5,
            lc10: 36.5
        },
        "gold.2000": {
            contrast: 70.69231677675243,
            lc60: 89,
            lc45: 72,
            lc30: 54,
            lc10: 33
        },
        "gold.2100": {
            contrast: 80.04322751331891,
            lc60: 81,
            lc45: 66,
            lc30: 49.5,
            lc10: 30.5
        },
        "gold.2200": {
            contrast: 88.47580059733463,
            lc60: 75.5,
            lc45: 61.5,
            lc30: 46,
            lc10: 28.5
        },
        "gold.2300": {
            contrast: 95.00399897914929,
            lc60: 72,
            lc45: 58,
            lc30: 43.5,
            lc10: 27
        },
        "gold.2400": {
            contrast: 99.88770680258679,
            lc60: 69.5,
            lc45: 56.5,
            lc30: 42.5,
            lc10: 26
        },
        "gold.2500": {
            contrast: 105.85438439447685,
            lc60: 66.5,
            lc45: 54,
            lc30: 40.5,
            lc10: 25
        }
    },
    "gold.400": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 9.884341245437644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 13.550821707276825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 17.417561302261827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "gold.1200": {
            contrast: 21.59562111823311,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "gold.1300": {
            contrast: 25.965778708245608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.1400": {
            contrast: 30.64559318365947,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 58.5
        },
        "gold.1500": {
            contrast: 35.51428555868813,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 52.5
        },
        "gold.1600": {
            contrast: 41.384134616895786,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 46.5
        },
        "gold.1700": {
            contrast: 47.6638971156141,
            lc60: 100,
            lc45: 95.5,
            lc30: 70,
            lc10: 42
        },
        "gold.1800": {
            contrast: 53.47890490173277,
            lc60: 100,
            lc45: 87.5,
            lc30: 64.5,
            lc10: 38.5
        },
        "gold.1900": {
            contrast: 60.24840604476319,
            lc60: 99.5,
            lc45: 80,
            lc30: 59,
            lc10: 35
        },
        "gold.2000": {
            contrast: 69.10450007483148,
            lc60: 89.5,
            lc45: 72.5,
            lc30: 53,
            lc10: 32
        },
        "gold.2100": {
            contrast: 78.45541081139794,
            lc60: 81.5,
            lc45: 66,
            lc30: 48.5,
            lc10: 29
        },
        "gold.2200": {
            contrast: 86.88798389541365,
            lc60: 75.5,
            lc45: 61,
            lc30: 45,
            lc10: 26.5
        },
        "gold.2300": {
            contrast: 93.41618227722833,
            lc60: 72,
            lc45: 58,
            lc30: 42.5,
            lc10: 25.5
        },
        "gold.2400": {
            contrast: 98.29989010066583,
            lc60: 69.5,
            lc45: 56,
            lc30: 41.5,
            lc10: 24.5
        },
        "gold.2500": {
            contrast: 104.2665676925559,
            lc60: 66.5,
            lc45: 53.5,
            lc30: 39.5,
            lc10: 23.5
        }
    },
    "gold.500": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 8.19902399640118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 11.865504458240359,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 15.732244053225362,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "gold.1200": {
            contrast: 19.91030386919665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "gold.1300": {
            contrast: 24.280461459209143,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "gold.1400": {
            contrast: 28.96027593462301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "gold.1500": {
            contrast: 33.828968309651664,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 52.5
        },
        "gold.1600": {
            contrast: 39.69881736785932,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 46.5
        },
        "gold.1700": {
            contrast: 45.97857986657762,
            lc60: 100,
            lc45: 98.5,
            lc30: 71.5,
            lc10: 41.5
        },
        "gold.1800": {
            contrast: 51.7935876526963,
            lc60: 100,
            lc45: 89.5,
            lc30: 65.5,
            lc10: 37.5
        },
        "gold.1900": {
            contrast: 58.56308879572673,
            lc60: 100,
            lc45: 81.5,
            lc30: 59.5,
            lc10: 34.5
        },
        "gold.2000": {
            contrast: 67.419182825795,
            lc60: 91,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "gold.2100": {
            contrast: 76.77009356236148,
            lc60: 83,
            lc45: 66,
            lc30: 48,
            lc10: 28
        },
        "gold.2200": {
            contrast: 85.2026666463772,
            lc60: 76.5,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 26
        },
        "gold.2300": {
            contrast: 91.73086502819186,
            lc60: 72.5,
            lc45: 58,
            lc30: 42,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 96.61457285162936,
            lc60: 69.5,
            lc45: 56,
            lc30: 40.5,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 102.58125044351942,
            lc60: 66.5,
            lc45: 53.5,
            lc30: 39,
            lc10: 22.5
        }
    },
    "gold.600": {
        "gold.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 9.767508838565709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 13.634248433550711,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 17.812308249521998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "gold.1300": {
            contrast: 22.18246583953449,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "gold.1400": {
            contrast: 26.862280314948357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.1500": {
            contrast: 31.730972689977015,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54.5
        },
        "gold.1600": {
            contrast: 37.600821748184664,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 47.5
        },
        "gold.1700": {
            contrast: 43.88058424690297,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 42
        },
        "gold.1800": {
            contrast: 49.695592033021654,
            lc60: 100,
            lc45: 92,
            lc30: 66.5,
            lc10: 38
        },
        "gold.1900": {
            contrast: 56.46509317605207,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 34.5
        },
        "gold.2000": {
            contrast: 65.32118720612036,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 54,
            lc10: 31
        },
        "gold.2100": {
            contrast: 74.67209794268682,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 28
        },
        "gold.2200": {
            contrast: 83.10467102670253,
            lc60: 77.5,
            lc45: 62,
            lc30: 45,
            lc10: 26
        },
        "gold.2300": {
            contrast: 89.6328694085172,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24
        },
        "gold.2400": {
            contrast: 94.51657723195473,
            lc60: 70.5,
            lc45: 56.5,
            lc30: 40.5,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 100.48325482384477,
            lc60: 67.5,
            lc45: 53.5,
            lc30: 39,
            lc10: 22.5
        }
    },
    "gold.700": {
        "gold.100": {
            contrast: 9.004541108755134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 8.083385813679946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 7.723109068446339,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 11.58984866343134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 15.767908479402628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "gold.1300": {
            contrast: 20.13806606941512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1400": {
            contrast: 24.81788054482898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.1500": {
            contrast: 29.68657291985764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "gold.1600": {
            contrast: 35.556421978065295,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 49
        },
        "gold.1700": {
            contrast: 41.8361844767836,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 43
        },
        "gold.1800": {
            contrast: 47.651192262902285,
            lc60: 100,
            lc45: 95,
            lc30: 68,
            lc10: 38.5
        },
        "gold.1900": {
            contrast: 54.420693405932695,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 34.5
        },
        "gold.2000": {
            contrast: 63.27678743600098,
            lc60: 95.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30.5
        },
        "gold.2100": {
            contrast: 72.62769817256745,
            lc60: 86,
            lc45: 68,
            lc30: 49,
            lc10: 27.5
        },
        "gold.2200": {
            contrast: 81.06027125658316,
            lc60: 79,
            lc45: 62.5,
            lc30: 45,
            lc10: 25.5
        },
        "gold.2300": {
            contrast: 87.58846963839785,
            lc60: 74,
            lc45: 59,
            lc30: 42.5,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 92.47217746183536,
            lc60: 71.5,
            lc45: 56.5,
            lc30: 41,
            lc10: 23
        },
        "gold.2500": {
            contrast: 98.43885505372538,
            lc60: 68,
            lc45: 54,
            lc30: 39,
            lc10: 22
        }
    },
    "gold.800": {
        "gold.100": {
            contrast: 11.88098967719541,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 10.959834382120222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 9.656070663983199,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 7.6644007917479575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 9.09031378418412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 13.268373600155408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 17.6385311901679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "gold.1400": {
            contrast: 22.318345665581766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "gold.1500": {
            contrast: 27.187038040610425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "gold.1600": {
            contrast: 33.05688709881807,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51.5
        },
        "gold.1700": {
            contrast: 39.336649597536386,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        },
        "gold.1800": {
            contrast: 45.15165738365506,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 40
        },
        "gold.1900": {
            contrast: 51.92115852668549,
            lc60: 100,
            lc45: 89,
            lc30: 63.5,
            lc10: 35.5
        },
        "gold.2000": {
            contrast: 60.777252556753766,
            lc60: 98.5,
            lc45: 78.5,
            lc30: 56,
            lc10: 31.5
        },
        "gold.2100": {
            contrast: 70.12816329332023,
            lc60: 88,
            lc45: 70,
            lc30: 50,
            lc10: 27.5
        },
        "gold.2200": {
            contrast: 78.56073637733594,
            lc60: 80.5,
            lc45: 64,
            lc30: 45.5,
            lc10: 25.5
        },
        "gold.2300": {
            contrast: 85.08893475915062,
            lc60: 75.5,
            lc45: 60,
            lc30: 43,
            lc10: 24
        },
        "gold.2400": {
            contrast: 89.97264258258814,
            lc60: 72.5,
            lc45: 57.5,
            lc30: 41.5,
            lc10: 23
        },
        "gold.2500": {
            contrast: 95.93932017447815,
            lc60: 69,
            lc45: 54.5,
            lc30: 39,
            lc10: 22
        }
    },
    "gold.900": {
        "gold.100": {
            contrast: 14.86695266296418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.200": {
            contrast: 13.945797367888993,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.300": {
            contrast: 12.64203364975197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.400": {
            contrast: 10.650363777516727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 8.596363877225265,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 10.612586709252971,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 14.982744299265462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 19.66255877467933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1500": {
            contrast: 24.531251149707987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.1600": {
            contrast: 30.401100207915636,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        },
        "gold.1700": {
            contrast: 36.680862706633945,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "gold.1800": {
            contrast: 42.49587049275262,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        },
        "gold.1900": {
            contrast: 49.26537163578305,
            lc60: 100,
            lc45: 92.5,
            lc30: 66,
            lc10: 36.5
        },
        "gold.2000": {
            contrast: 58.12146566585133,
            lc60: 100,
            lc45: 80.5,
            lc30: 57.5,
            lc10: 32
        },
        "gold.2100": {
            contrast: 67.4723764024178,
            lc60: 90.5,
            lc45: 72,
            lc30: 51,
            lc10: 28.5
        },
        "gold.2200": {
            contrast: 75.90494948643351,
            lc60: 82.5,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "gold.2300": {
            contrast: 82.43314786824817,
            lc60: 77.5,
            lc45: 61.5,
            lc30: 43.5,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 87.31685569168569,
            lc60: 74,
            lc45: 58.5,
            lc30: 42,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 93.28353328357574,
            lc60: 70.5,
            lc45: 55.5,
            lc30: 39.5,
            lc10: 22
        }
    },
    "gold.1000": {
        "gold.100": {
            contrast: 18.760159336742753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.200": {
            contrast: 17.839004041667565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "gold.300": {
            contrast: 16.53524032353054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "gold.400": {
            contrast: 14.543570451295295,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.500": {
            contrast: 12.489570551003833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.600": {
            contrast: 9.999460579932002,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 7.629945295943609,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 11.437518549476378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 16.117333024890243,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "gold.1500": {
            contrast: 20.9860253999189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.1600": {
            contrast: 26.85587445812655,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "gold.1700": {
            contrast: 33.13563695684486,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 49.5
        },
        "gold.1800": {
            contrast: 38.95064474296354,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43.5
        },
        "gold.1900": {
            contrast: 45.720145885993965,
            lc60: 100,
            lc45: 98,
            lc30: 70,
            lc10: 38
        },
        "gold.2000": {
            contrast: 54.57623991606224,
            lc60: 100,
            lc45: 84.5,
            lc30: 60,
            lc10: 32.5
        },
        "gold.2100": {
            contrast: 63.927150652628704,
            lc60: 94.5,
            lc45: 74.5,
            lc30: 52.5,
            lc10: 28.5
        },
        "gold.2200": {
            contrast: 72.35972373664443,
            lc60: 85.5,
            lc45: 67.5,
            lc30: 48,
            lc10: 26
        },
        "gold.2300": {
            contrast: 78.8879221184591,
            lc60: 80,
            lc45: 63,
            lc30: 45,
            lc10: 24.5
        },
        "gold.2400": {
            contrast: 83.77162994189662,
            lc60: 76,
            lc45: 60,
            lc30: 43,
            lc10: 23.5
        },
        "gold.2500": {
            contrast: 89.73830753378664,
            lc60: 72,
            lc45: 56.5,
            lc30: 40.5,
            lc10: 22.5
        }
    },
    "gold.1100": {
        "gold.100": {
            contrast: 22.802128643639016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "gold.200": {
            contrast: 21.880973348563828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "gold.300": {
            contrast: 20.577209630426804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.400": {
            contrast: 18.585539758191562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "gold.500": {
            contrast: 16.5315398579001,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "gold.600": {
            contrast: 14.041429886828269,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.700": {
            contrast: 11.671914602839875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.800": {
            contrast: 8.836783352759912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 7.669233777729581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 12.349048253143447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 17.217740628172105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "gold.1600": {
            contrast: 23.087589686379758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "gold.1700": {
            contrast: 29.36735218509806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "gold.1800": {
            contrast: 35.18235997121674,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 47.5
        },
        "gold.1900": {
            contrast: 41.951861114247166,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40
        },
        "gold.2000": {
            contrast: 50.80795514431545,
            lc60: 100,
            lc45: 90,
            lc30: 63.5,
            lc10: 34.5
        },
        "gold.2100": {
            contrast: 60.158865880881905,
            lc60: 99.5,
            lc45: 78,
            lc30: 55,
            lc10: 30
        },
        "gold.2200": {
            contrast: 68.59143896489762,
            lc60: 89,
            lc45: 70,
            lc30: 49.5,
            lc10: 27
        },
        "gold.2300": {
            contrast: 75.11963734671231,
            lc60: 83,
            lc45: 65,
            lc30: 46.5,
            lc10: 25
        },
        "gold.2400": {
            contrast: 80.00334517014981,
            lc60: 78.5,
            lc45: 62,
            lc30: 44,
            lc10: 24
        },
        "gold.2500": {
            contrast: 85.97002276203985,
            lc60: 74.5,
            lc45: 58.5,
            lc30: 41.5,
            lc10: 22.5
        }
    },
    "gold.1200": {
        "gold.100": {
            contrast: 27.10736258117122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "gold.200": {
            contrast: 26.186207286096035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "gold.300": {
            contrast: 24.882443567959015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "gold.400": {
            contrast: 22.89077369572377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "gold.500": {
            contrast: 20.836773795432308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "gold.600": {
            contrast: 18.346663824360476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "gold.700": {
            contrast: 15.977148540372083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "gold.800": {
            contrast: 13.142017290292118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.900": {
            contrast: 10.191323808433959,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 8.24808347101446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 13.116775846043119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 18.98662490425077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "gold.1700": {
            contrast: 25.266387402969077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.1800": {
            contrast: 31.081395189087758,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 51.5
        },
        "gold.1900": {
            contrast: 37.850896332118175,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 43.5
        },
        "gold.2000": {
            contrast: 46.70699036218647,
            lc60: 100,
            lc45: 97,
            lc30: 68,
            lc10: 37
        },
        "gold.2100": {
            contrast: 56.05790109875293,
            lc60: 100,
            lc45: 82.5,
            lc30: 58,
            lc10: 31.5
        },
        "gold.2200": {
            contrast: 64.49047418276864,
            lc60: 93.5,
            lc45: 73.5,
            lc30: 52,
            lc10: 28
        },
        "gold.2300": {
            contrast: 71.01867256458331,
            lc60: 87,
            lc45: 68,
            lc30: 48,
            lc10: 26
        },
        "gold.2400": {
            contrast: 75.90238038802084,
            lc60: 82,
            lc45: 64,
            lc30: 45.5,
            lc10: 25
        },
        "gold.2500": {
            contrast: 81.86905797991085,
            lc60: 77.5,
            lc45: 60.5,
            lc30: 42.5,
            lc10: 23.5
        }
    },
    "gold.1300": {
        "gold.100": {
            contrast: 31.551410458994344,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 38
        },
        "gold.200": {
            contrast: 30.630255163919152,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 41.5
        },
        "gold.300": {
            contrast: 29.326491445782132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "gold.400": {
            contrast: 27.334821573546886,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "gold.500": {
            contrast: 25.280821673255428,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "gold.600": {
            contrast: 22.790711702183593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "gold.700": {
            contrast: 20.421196418195205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "gold.800": {
            contrast: 17.58606516811524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "gold.900": {
            contrast: 14.635371686257079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1000": {
            contrast: 10.778072668904015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 8.79881913527373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 14.668668193481379,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 20.94843069219969,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "gold.1800": {
            contrast: 26.76343847831837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "gold.1900": {
            contrast: 33.53293962134879,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 48
        },
        "gold.2000": {
            contrast: 42.38903365141707,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 39.5
        },
        "gold.2100": {
            contrast: 51.73994438798354,
            lc60: 100,
            lc45: 88,
            lc30: 62,
            lc10: 33.5
        },
        "gold.2200": {
            contrast: 60.17251747199926,
            lc60: 99.5,
            lc45: 77.5,
            lc30: 55,
            lc10: 29.5
        },
        "gold.2300": {
            contrast: 66.70071585381392,
            lc60: 91.5,
            lc45: 71,
            lc30: 50.5,
            lc10: 27
        },
        "gold.2400": {
            contrast: 71.58442367725144,
            lc60: 86,
            lc45: 68,
            lc30: 47.5,
            lc10: 26
        },
        "gold.2500": {
            contrast: 77.55110126914147,
            lc60: 80.5,
            lc45: 63,
            lc30: 44.5,
            lc10: 24
        }
    },
    "gold.1400": {
        "gold.100": {
            contrast: 36.25234119834072,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 33.5
        },
        "gold.200": {
            contrast: 35.33118590326552,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 36.5
        },
        "gold.300": {
            contrast: 34.02742218512851,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 40
        },
        "gold.400": {
            contrast: 32.035752312893266,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 44
        },
        "gold.500": {
            contrast: 29.981752412601796,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "gold.600": {
            contrast: 27.49164244152997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "gold.700": {
            contrast: 25.122127157541573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "gold.800": {
            contrast: 22.286995907461613,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "gold.900": {
            contrast: 19.336302425603453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1000": {
            contrast: 15.479003408250389,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "gold.1100": {
            contrast: 11.463832892021403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 10.01631378169067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 16.29607628040898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "gold.1800": {
            contrast: 22.11108406652766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "gold.1900": {
            contrast: 28.88058520955808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "gold.2000": {
            contrast: 37.73667923962636,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 43.5
        },
        "gold.2100": {
            contrast: 47.08758997619283,
            lc60: 100,
            lc45: 96,
            lc30: 67,
            lc10: 36
        },
        "gold.2200": {
            contrast: 55.52016306020854,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 31.5
        },
        "gold.2300": {
            contrast: 62.048361442023214,
            lc60: 97,
            lc45: 75.5,
            lc30: 53.5,
            lc10: 29
        },
        "gold.2400": {
            contrast: 66.93206926546073,
            lc60: 91,
            lc45: 71,
            lc30: 50.5,
            lc10: 27
        },
        "gold.2500": {
            contrast: 72.89874685735076,
            lc60: 85,
            lc45: 66.5,
            lc30: 47,
            lc10: 25.5
        }
    },
    "gold.1500": {
        "gold.100": {
            contrast: 41.087314199091885,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "gold.200": {
            contrast: 40.16615890401669,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32
        },
        "gold.300": {
            contrast: 38.86239518587967,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 34.5
        },
        "gold.400": {
            contrast: 36.87072531364443,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38
        },
        "gold.500": {
            contrast: 34.81672541335296,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 41
        },
        "gold.600": {
            contrast: 32.32661544228113,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 45
        },
        "gold.700": {
            contrast: 29.957100158292743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "gold.800": {
            contrast: 27.121968908212775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "gold.900": {
            contrast: 24.17127542635462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.1000": {
            contrast: 20.313976409001555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.1100": {
            contrast: 16.29880589277257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "gold.1200": {
            contrast: 12.011884949274659,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1300": {
            contrast: 7.57698042660461,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 11.428161600883074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 17.243169387001757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "gold.1900": {
            contrast: 24.012670530032175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "gold.2000": {
            contrast: 32.86876456010046,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 49
        },
        "gold.2100": {
            contrast: 42.21967529666693,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40
        },
        "gold.2200": {
            contrast: 50.65224838068264,
            lc60: 100,
            lc45: 90,
            lc30: 63,
            lc10: 34
        },
        "gold.2300": {
            contrast: 57.180446762497304,
            lc60: 100,
            lc45: 81,
            lc30: 57,
            lc10: 30.5
        },
        "gold.2400": {
            contrast: 62.06415458593483,
            lc60: 97,
            lc45: 75.5,
            lc30: 53.5,
            lc10: 29
        },
        "gold.2500": {
            contrast: 68.03083217782485,
            lc60: 90,
            lc45: 70.5,
            lc30: 49.5,
            lc10: 26.5
        }
    },
    "gold.1600": {
        "gold.100": {
            contrast: 46.85028912132791,
            lc60: 100,
            lc45: 88.5,
            lc30: 52,
            lc10: 26.5
        },
        "gold.200": {
            contrast: 45.929133826252716,
            lc60: 100,
            lc45: 95,
            lc30: 56,
            lc10: 28
        },
        "gold.300": {
            contrast: 44.625370108115696,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 30
        },
        "gold.400": {
            contrast: 42.633700235880454,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "gold.500": {
            contrast: 40.57970033558899,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35
        },
        "gold.600": {
            contrast: 38.08959036451716,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38
        },
        "gold.700": {
            contrast: 35.720075080528765,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41
        },
        "gold.800": {
            contrast: 32.8849438304488,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 45
        },
        "gold.900": {
            contrast: 29.934250348590634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "gold.1000": {
            contrast: 26.076951331237574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "gold.1100": {
            contrast: 22.061780815008593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "gold.1200": {
            contrast: 17.77485987151068,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "gold.1300": {
            contrast: 13.339955348840633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1400": {
            contrast: 8.6390968577471,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 11.340631802622761,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 18.11013294565318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "gold.2000": {
            contrast: 26.96622697572146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "gold.2100": {
            contrast: 36.31713771228793,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 44.5
        },
        "gold.2200": {
            contrast: 44.749710796303646,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 37.5
        },
        "gold.2300": {
            contrast: 51.27790917811831,
            lc60: 100,
            lc45: 89,
            lc30: 62.5,
            lc10: 34
        },
        "gold.2400": {
            contrast: 56.16161700155582,
            lc60: 100,
            lc45: 82.5,
            lc30: 58,
            lc10: 31
        },
        "gold.2500": {
            contrast: 62.128294593445865,
            lc60: 97,
            lc45: 76,
            lc30: 53,
            lc10: 29
        }
    },
    "gold.1700": {
        "gold.100": {
            contrast: 52.945232970151736,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 23
        },
        "gold.200": {
            contrast: 52.02407767507654,
            lc60: 100,
            lc45: 77.5,
            lc30: 49,
            lc10: 24.5
        },
        "gold.300": {
            contrast: 50.72031395693952,
            lc60: 100,
            lc45: 82.5,
            lc30: 52.5,
            lc10: 26
        },
        "gold.400": {
            contrast: 48.72864408470428,
            lc60: 100,
            lc45: 88.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "gold.500": {
            contrast: 46.67464418441282,
            lc60: 100,
            lc45: 95.5,
            lc30: 60.5,
            lc10: 30.5
        },
        "gold.600": {
            contrast: 44.18453421334099,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "gold.700": {
            contrast: 41.81501892935259,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 35
        },
        "gold.800": {
            contrast: 38.97988767927263,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "gold.900": {
            contrast: 36.02919419741447,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "gold.1000": {
            contrast: 32.1718951800614,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 47
        },
        "gold.1100": {
            contrast: 28.15672466383242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "gold.1200": {
            contrast: 23.869803720334513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "gold.1300": {
            contrast: 19.434899197664464,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "gold.1400": {
            contrast: 14.73404070657093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1500": {
            contrast: 9.889904490630755,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 11.758995444549308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 20.615089474617594,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "gold.2100": {
            contrast: 29.966000211184056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "gold.2200": {
            contrast: 38.398573295199775,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 43
        },
        "gold.2300": {
            contrast: 44.92677167701444,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38.5
        },
        "gold.2400": {
            contrast: 49.810479500451954,
            lc60: 100,
            lc45: 91.5,
            lc30: 65,
            lc10: 34.5
        },
        "gold.2500": {
            contrast: 55.77715709234199,
            lc60: 100,
            lc45: 83,
            lc30: 58.5,
            lc10: 31.5
        }
    },
    "gold.1800": {
        "gold.100": {
            contrast: 58.53157692829172,
            lc60: 100,
            lc45: 64.5,
            lc30: 41.5,
            lc10: 21
        },
        "gold.200": {
            contrast: 57.61042163321651,
            lc60: 100,
            lc45: 68.5,
            lc30: 44,
            lc10: 22
        },
        "gold.300": {
            contrast: 56.3066579150795,
            lc60: 100,
            lc45: 72.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "gold.400": {
            contrast: 54.314988042844256,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25
        },
        "gold.500": {
            contrast: 52.26098814255279,
            lc60: 100,
            lc45: 83,
            lc30: 53.5,
            lc10: 26.5
        },
        "gold.600": {
            contrast: 49.77087817148096,
            lc60: 100,
            lc45: 88,
            lc30: 57,
            lc10: 28.5
        },
        "gold.700": {
            contrast: 47.40136288749257,
            lc60: 100,
            lc45: 94,
            lc30: 60.5,
            lc10: 30.5
        },
        "gold.800": {
            contrast: 44.5662316374126,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "gold.900": {
            contrast: 41.61553815555444,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "gold.1000": {
            contrast: 37.758239138201375,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "gold.1100": {
            contrast: 33.74306862197239,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 44.5
        },
        "gold.1200": {
            contrast: 29.45614767847448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "gold.1300": {
            contrast: 25.021243155804434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "gold.1400": {
            contrast: 20.320384664710904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "gold.1500": {
            contrast: 15.476248448770729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "gold.1600": {
            contrast: 9.691346991968725,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 14.703794466028942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 24.054705202595407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "gold.2200": {
            contrast: 32.487278286611115,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 51
        },
        "gold.2300": {
            contrast: 39.015476668425784,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 43.5
        },
        "gold.2400": {
            contrast: 43.8991844918633,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 39.5
        },
        "gold.2500": {
            contrast: 49.865862083753335,
            lc60: 100,
            lc45: 92,
            lc30: 65,
            lc10: 35.5
        }
    },
    "gold.1900": {
        "gold.100": {
            contrast: 64.97274687999605,
            lc60: 82,
            lc45: 57.5,
            lc30: 37,
            lc10: 19
        },
        "gold.200": {
            contrast: 64.05159158492086,
            lc60: 87,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "gold.300": {
            contrast: 62.747827866783844,
            lc60: 91.5,
            lc45: 64,
            lc30: 41.5,
            lc10: 21
        },
        "gold.400": {
            contrast: 60.75615799454861,
            lc60: 98,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "gold.500": {
            contrast: 58.70215809425714,
            lc60: 100,
            lc45: 72.5,
            lc30: 47,
            lc10: 24
        },
        "gold.600": {
            contrast: 56.21204812318531,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 25.5
        },
        "gold.700": {
            contrast: 53.84253283919692,
            lc60: 100,
            lc45: 80.5,
            lc30: 52.5,
            lc10: 26.5
        },
        "gold.800": {
            contrast: 51.00740158911695,
            lc60: 100,
            lc45: 86,
            lc30: 56,
            lc10: 28.5
        },
        "gold.900": {
            contrast: 48.05670810725879,
            lc60: 100,
            lc45: 92.5,
            lc30: 60,
            lc10: 30.5
        },
        "gold.1000": {
            contrast: 44.19940908990572,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 33.5
        },
        "gold.1100": {
            contrast: 40.184238573676744,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "gold.1200": {
            contrast: 35.89731763017883,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 42
        },
        "gold.1300": {
            contrast: 31.462413107508784,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 48
        },
        "gold.1400": {
            contrast: 26.76155461641525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "gold.1500": {
            contrast: 21.917418400475082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "gold.1600": {
            contrast: 16.132516943673075,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "gold.1700": {
            contrast: 10.002647901948967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 7.78908765341868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 17.13999838998515,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "gold.2200": {
            contrast: 25.572571474000856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "gold.2300": {
            contrast: 32.10076985581553,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52
        },
        "gold.2400": {
            contrast: 36.98447767925304,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 45.5
        },
        "gold.2500": {
            contrast: 42.95115527114307,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40
        }
    },
    "gold.2000": {
        "gold.100": {
            contrast: 73.30947334912055,
            lc60: 70,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "gold.200": {
            contrast: 72.38831805404537,
            lc60: 74,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "gold.300": {
            contrast: 71.08455433590835,
            lc60: 77.5,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 19
        },
        "gold.400": {
            contrast: 69.09288446367312,
            lc60: 82,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "gold.500": {
            contrast: 67.03888456338164,
            lc60: 86,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "gold.600": {
            contrast: 64.54877459230981,
            lc60: 91.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 22
        },
        "gold.700": {
            contrast: 62.17925930832141,
            lc60: 95.5,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "gold.800": {
            contrast: 59.34412805824145,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "gold.900": {
            contrast: 56.393434576383285,
            lc60: 100,
            lc45: 77,
            lc30: 50.5,
            lc10: 26
        },
        "gold.1000": {
            contrast: 52.536135559030214,
            lc60: 100,
            lc45: 84,
            lc30: 55,
            lc10: 28
        },
        "gold.1100": {
            contrast: 48.520965042801244,
            lc60: 100,
            lc45: 91.5,
            lc30: 60,
            lc10: 30.5
        },
        "gold.1200": {
            contrast: 44.234044099303325,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 34.5
        },
        "gold.1300": {
            contrast: 39.79913957663328,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38.5
        },
        "gold.1400": {
            contrast: 35.098281085539746,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "gold.1500": {
            contrast: 30.254144869599575,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 51.5
        },
        "gold.1600": {
            contrast: 24.469243412797574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "gold.1700": {
            contrast: 18.339374371073465,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "gold.1800": {
            contrast: 12.71141729943098,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 8.045323229888272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 16.477896313903987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "gold.2300": {
            contrast: 23.00609469571865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "gold.2400": {
            contrast: 27.889802519156166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "gold.2500": {
            contrast: 33.8564801110462,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49.5
        }
    },
    "gold.2100": {
        "gold.100": {
            contrast: 82.01416235796822,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "gold.200": {
            contrast: 81.09300706289302,
            lc60: 64.5,
            lc45: 47,
            lc30: 30.5,
            lc10: 16
        },
        "gold.300": {
            contrast: 79.789243344756,
            lc60: 67.5,
            lc45: 49,
            lc30: 32,
            lc10: 17
        },
        "gold.400": {
            contrast: 77.79757347252077,
            lc60: 71,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "gold.500": {
            contrast: 75.7435735722293,
            lc60: 74.5,
            lc45: 54.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "gold.600": {
            contrast: 73.25346360115746,
            lc60: 78,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "gold.700": {
            contrast: 70.88394831716907,
            lc60: 81.5,
            lc45: 59,
            lc30: 39,
            lc10: 20
        },
        "gold.800": {
            contrast: 68.0488170670891,
            lc60: 85.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "gold.900": {
            contrast: 65.09812358523095,
            lc60: 90.5,
            lc45: 66,
            lc30: 43,
            lc10: 22.5
        },
        "gold.1000": {
            contrast: 61.24082456787788,
            lc60: 97,
            lc45: 71,
            lc30: 46,
            lc10: 24
        },
        "gold.1100": {
            contrast: 57.2256540516489,
            lc60: 100,
            lc45: 76,
            lc30: 50.5,
            lc10: 26
        },
        "gold.1200": {
            contrast: 52.938733108150984,
            lc60: 100,
            lc45: 83.5,
            lc30: 55,
            lc10: 29
        },
        "gold.1300": {
            contrast: 48.50382858548093,
            lc60: 100,
            lc45: 92,
            lc30: 61,
            lc10: 31.5
        },
        "gold.1400": {
            contrast: 43.802970094387405,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 35
        },
        "gold.1500": {
            contrast: 38.95883387844723,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 40
        },
        "gold.1600": {
            contrast: 33.173932421645226,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 46
        },
        "gold.1700": {
            contrast: 27.04406337992112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "gold.1800": {
            contrast: 21.416106308278636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "gold.1900": {
            contrast: 14.916564860409013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 13.349462976676351,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 18.233170800113868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "gold.2500": {
            contrast: 24.1998483920039,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        }
    },
    "gold.2200": {
        "gold.100": {
            contrast: 89.78734923224421,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "gold.200": {
            contrast: 88.86619393716902,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "gold.300": {
            contrast: 87.562430219032,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "gold.400": {
            contrast: 85.57076034679676,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "gold.500": {
            contrast: 83.51676044650529,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "gold.600": {
            contrast: 81.02665047543346,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "gold.700": {
            contrast: 78.65713519144506,
            lc60: 72,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "gold.800": {
            contrast: 75.8220039413651,
            lc60: 75.5,
            lc45: 55,
            lc30: 36.5,
            lc10: 19
        },
        "gold.900": {
            contrast: 72.87131045950693,
            lc60: 79,
            lc45: 57.5,
            lc30: 38.5,
            lc10: 20
        },
        "gold.1000": {
            contrast: 69.01401144215387,
            lc60: 84.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "gold.1100": {
            contrast: 64.9988409259249,
            lc60: 91,
            lc45: 66.5,
            lc30: 43.5,
            lc10: 22.5
        },
        "gold.1200": {
            contrast: 60.71191998242698,
            lc60: 98.5,
            lc45: 72,
            lc30: 47,
            lc10: 24.5
        },
        "gold.1300": {
            contrast: 56.27701545975693,
            lc60: 100,
            lc45: 77.5,
            lc30: 51.5,
            lc10: 26.5
        },
        "gold.1400": {
            contrast: 51.5761569686634,
            lc60: 100,
            lc45: 86,
            lc30: 57,
            lc10: 29.5
        },
        "gold.1500": {
            contrast: 46.73202075272322,
            lc60: 100,
            lc45: 96,
            lc30: 62.5,
            lc10: 32
        },
        "gold.1600": {
            contrast: 40.94711929592122,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 37.5
        },
        "gold.1700": {
            contrast: 34.81725025419711,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 44
        },
        "gold.1800": {
            contrast: 29.189293182554625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "gold.1900": {
            contrast: 22.689751734685007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "gold.2000": {
            contrast: 14.262436988231949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 9.482093665310536,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 15.448771257200569,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        }
    },
    "gold.2300": {
        "gold.100": {
            contrast: 95.7598051056606,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "gold.200": {
            contrast: 94.83864981058541,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "gold.300": {
            contrast: 93.53488609244839,
            lc60: 56,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "gold.400": {
            contrast: 91.54321622021315,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "gold.500": {
            contrast: 89.48921631992168,
            lc60: 61,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "gold.600": {
            contrast: 86.99910634884985,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16.5
        },
        "gold.700": {
            contrast: 84.62959106486146,
            lc60: 66,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "gold.800": {
            contrast: 81.79445981478149,
            lc60: 69,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "gold.900": {
            contrast: 78.84376633292334,
            lc60: 72.5,
            lc45: 53,
            lc30: 35,
            lc10: 18.5
        },
        "gold.1000": {
            contrast: 74.98646731557027,
            lc60: 76.5,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "gold.1100": {
            contrast: 70.97129679934129,
            lc60: 82,
            lc45: 60,
            lc30: 40,
            lc10: 21
        },
        "gold.1200": {
            contrast: 66.68437585584338,
            lc60: 88.5,
            lc45: 65,
            lc30: 43,
            lc10: 22
        },
        "gold.1300": {
            contrast: 62.249471333173325,
            lc60: 95.5,
            lc45: 69.5,
            lc30: 46,
            lc10: 24
        },
        "gold.1400": {
            contrast: 57.54861284207979,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 26
        },
        "gold.1500": {
            contrast: 52.704476626139616,
            lc60: 100,
            lc45: 83.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "gold.1600": {
            contrast: 46.91957516933761,
            lc60: 100,
            lc45: 95,
            lc30: 62.5,
            lc10: 32.5
        },
        "gold.1700": {
            contrast: 40.789706127613506,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 37
        },
        "gold.1800": {
            contrast: 35.16174905597102,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "gold.1900": {
            contrast: 28.662207608101397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "gold.2000": {
            contrast: 20.234892861648344,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "gold.2100": {
            contrast: 11.419210012587461,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 8.648379700766737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "gold.2400": {
        "gold.100": {
            contrast: 100.20376752577316,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "gold.200": {
            contrast: 99.28261223069795,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "gold.300": {
            contrast: 97.97884851256093,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "gold.400": {
            contrast: 95.98717864032568,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14.5
        },
        "gold.500": {
            contrast: 93.93317874003422,
            lc60: 58,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "gold.600": {
            contrast: 91.44306876896239,
            lc60: 60,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "gold.700": {
            contrast: 89.073553484974,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16
        },
        "gold.800": {
            contrast: 86.23842223489403,
            lc60: 65,
            lc45: 47.5,
            lc30: 32,
            lc10: 16.5
        },
        "gold.900": {
            contrast: 83.28772875303586,
            lc60: 67.5,
            lc45: 50,
            lc30: 33,
            lc10: 17.5
        },
        "gold.1000": {
            contrast: 79.43042973568281,
            lc60: 72,
            lc45: 53,
            lc30: 35,
            lc10: 18.5
        },
        "gold.1100": {
            contrast: 75.41525921945382,
            lc60: 76.5,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "gold.1200": {
            contrast: 71.12833827595591,
            lc60: 82,
            lc45: 60,
            lc30: 40,
            lc10: 21
        },
        "gold.1300": {
            contrast: 66.69343375328586,
            lc60: 88.5,
            lc45: 65,
            lc30: 43,
            lc10: 22
        },
        "gold.1400": {
            contrast: 61.99257526219233,
            lc60: 96,
            lc45: 70,
            lc30: 46.5,
            lc10: 24
        },
        "gold.1500": {
            contrast: 57.14843904625215,
            lc60: 100,
            lc45: 76.5,
            lc30: 50.5,
            lc10: 26.5
        },
        "gold.1600": {
            contrast: 51.36353758945015,
            lc60: 100,
            lc45: 86,
            lc30: 56.5,
            lc10: 29
        },
        "gold.1700": {
            contrast: 45.23366854772604,
            lc60: 100,
            lc45: 99,
            lc30: 64.5,
            lc10: 33.5
        },
        "gold.1800": {
            contrast: 39.605711476083556,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "gold.1900": {
            contrast: 33.10617002821393,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 45.5
        },
        "gold.2000": {
            contrast: 24.678855281760878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "gold.2100": {
            contrast: 15.863172432699995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "gold.2200": {
            contrast: 7.977986019953469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "gold.2500": {
        "gold.100": {
            contrast: 105.60694178022172,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "gold.200": {
            contrast: 104.68578648514652,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "gold.300": {
            contrast: 103.3820227670095,
            lc60: 50,
            lc45: 37,
            lc30: 25,
            lc10: 13
        },
        "gold.400": {
            contrast: 101.39035289477427,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 26,
            lc10: 13.5
        },
        "gold.500": {
            contrast: 99.3363529944828,
            lc60: 54,
            lc45: 40,
            lc30: 27,
            lc10: 14
        },
        "gold.600": {
            contrast: 96.84624302341095,
            lc60: 56,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "gold.700": {
            contrast: 94.47672773942256,
            lc60: 58,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "gold.800": {
            contrast: 91.64159648934259,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 16
        },
        "gold.900": {
            contrast: 88.69090300748444,
            lc60: 63,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "gold.1000": {
            contrast: 84.83360399013137,
            lc60: 66.5,
            lc45: 49,
            lc30: 33,
            lc10: 17.5
        },
        "gold.1100": {
            contrast: 80.81843347390239,
            lc60: 70.5,
            lc45: 52,
            lc30: 35,
            lc10: 18.5
        },
        "gold.1200": {
            contrast: 76.53151253040447,
            lc60: 75.5,
            lc45: 55.5,
            lc30: 37,
            lc10: 19.5
        },
        "gold.1300": {
            contrast: 72.09660800773443,
            lc60: 81,
            lc45: 59,
            lc30: 39.5,
            lc10: 20.5
        },
        "gold.1400": {
            contrast: 67.39574951664089,
            lc60: 87,
            lc45: 63.5,
            lc30: 42.5,
            lc10: 22
        },
        "gold.1500": {
            contrast: 62.55161330070072,
            lc60: 95,
            lc45: 69,
            lc30: 46,
            lc10: 24
        },
        "gold.1600": {
            contrast: 56.76671184389872,
            lc60: 100,
            lc45: 77,
            lc30: 50.5,
            lc10: 26.5
        },
        "gold.1700": {
            contrast: 50.636842802174606,
            lc60: 100,
            lc45: 87,
            lc30: 57,
            lc10: 29.5
        },
        "gold.1800": {
            contrast: 45.00888573053212,
            lc60: 100,
            lc45: 99,
            lc30: 65,
            lc10: 33.5
        },
        "gold.1900": {
            contrast: 38.5093442826625,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 39
        },
        "gold.2000": {
            contrast: 30.082029536209443,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 51.5
        },
        "gold.2100": {
            contrast: 21.266346687148562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "gold.2200": {
            contrast: 13.381160274402035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2300": {
            contrast: 7.31501975489734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "gold.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$warning = {
    "warning.100": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 8.076176467005913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 12.114639140804615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 16.645836476141334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "warning.900": {
            contrast: 20.96305106382024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "warning.1000": {
            contrast: 25.152865974978724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "warning.1100": {
            contrast: 29.527966263116458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "warning.1200": {
            contrast: 34.08694731467085,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 64.5
        },
        "warning.1300": {
            contrast: 39.04100268180725,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 59.5
        },
        "warning.1400": {
            contrast: 45.31369943532885,
            lc60: 100,
            lc45: 99.5,
            lc30: 78.5,
            lc10: 54.5
        },
        "warning.1500": {
            contrast: 47.86228105607289,
            lc60: 100,
            lc45: 96.5,
            lc30: 76,
            lc10: 53
        },
        "warning.1600": {
            contrast: 52.6589417057721,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "warning.1700": {
            contrast: 58.07600698190595,
            lc60: 100,
            lc45: 85.5,
            lc30: 68,
            lc10: 47
        },
        "warning.1800": {
            contrast: 63.604068912099486,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "warning.1900": {
            contrast: 69.32878210382822,
            lc60: 91.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 42.5
        },
        "warning.2000": {
            contrast: 75.12056576657689,
            lc60: 86.5,
            lc45: 73,
            lc30: 58,
            lc10: 40.5
        },
        "warning.2100": {
            contrast: 81.29331994715598,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "warning.2200": {
            contrast: 87.81113485871532,
            lc60: 78.5,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "warning.2300": {
            contrast: 94.23961406073825,
            lc60: 75,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "warning.2400": {
            contrast: 100.92288292979201,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "warning.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "warning.200": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 7.68740429807305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 11.725866971871755,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 16.25706430720847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "warning.900": {
            contrast: 20.57427889488738,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "warning.1000": {
            contrast: 24.76409380604586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "warning.1100": {
            contrast: 29.13919409418359,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "warning.1200": {
            contrast: 33.698175145737984,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 61
        },
        "warning.1300": {
            contrast: 38.65223051287438,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 55.5
        },
        "warning.1400": {
            contrast: 44.92492726639598,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 50.5
        },
        "warning.1500": {
            contrast: 47.473508887140014,
            lc60: 100,
            lc45: 96.5,
            lc30: 74.5,
            lc10: 49
        },
        "warning.1600": {
            contrast: 52.27016953683924,
            lc60: 100,
            lc45: 90.5,
            lc30: 70,
            lc10: 46
        },
        "warning.1700": {
            contrast: 57.687234812973074,
            lc60: 100,
            lc45: 85,
            lc30: 65.5,
            lc10: 43
        },
        "warning.1800": {
            contrast: 63.215296743166626,
            lc60: 96.5,
            lc45: 80,
            lc30: 61.5,
            lc10: 41
        },
        "warning.1900": {
            contrast: 68.94000993489536,
            lc60: 91,
            lc45: 75.5,
            lc30: 58.5,
            lc10: 38.5
        },
        "warning.2000": {
            contrast: 74.73179359764403,
            lc60: 86.5,
            lc45: 72,
            lc30: 55.5,
            lc10: 37
        },
        "warning.2100": {
            contrast: 80.90454777822312,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 35
        },
        "warning.2200": {
            contrast: 87.42236268978246,
            lc60: 78,
            lc45: 64.5,
            lc30: 50,
            lc10: 33.5
        },
        "warning.2300": {
            contrast: 93.85084189180539,
            lc60: 74.5,
            lc45: 62,
            lc30: 48,
            lc10: 32
        },
        "warning.2400": {
            contrast: 100.53411076085916,
            lc60: 71,
            lc45: 59.5,
            lc30: 46,
            lc10: 30.5
        },
        "warning.2500": {
            contrast: 107.4959610141656,
            lc60: 68,
            lc45: 56.5,
            lc30: 44,
            lc10: 29.5
        }
    },
    "warning.300": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 10.589945645837314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 15.121142981174032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "warning.900": {
            contrast: 19.43835756885294,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "warning.1000": {
            contrast: 23.62817248001142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "warning.1100": {
            contrast: 28.003272768149152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "warning.1200": {
            contrast: 32.56225381970354,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 59
        },
        "warning.1300": {
            contrast: 37.51630918683994,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 53.5
        },
        "warning.1400": {
            contrast: 43.78900594036155,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 48
        },
        "warning.1500": {
            contrast: 46.33758756110558,
            lc60: 100,
            lc45: 98,
            lc30: 73.5,
            lc10: 46
        },
        "warning.1600": {
            contrast: 51.1342482108048,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 43
        },
        "warning.1700": {
            contrast: 56.551313486938646,
            lc60: 100,
            lc45: 85,
            lc30: 64,
            lc10: 40.5
        },
        "warning.1800": {
            contrast: 62.07937541713219,
            lc60: 97.5,
            lc45: 80,
            lc30: 60,
            lc10: 38
        },
        "warning.1900": {
            contrast: 67.80408860886091,
            lc60: 92,
            lc45: 75,
            lc30: 57,
            lc10: 35.5
        },
        "warning.2000": {
            contrast: 73.59587227160958,
            lc60: 86.5,
            lc45: 71,
            lc30: 53.5,
            lc10: 34
        },
        "warning.2100": {
            contrast: 79.76862645218867,
            lc60: 81.5,
            lc45: 67,
            lc30: 51,
            lc10: 32.5
        },
        "warning.2200": {
            contrast: 86.28644136374803,
            lc60: 77.5,
            lc45: 64,
            lc30: 48.5,
            lc10: 31
        },
        "warning.2300": {
            contrast: 92.71492056577094,
            lc60: 74,
            lc45: 61,
            lc30: 46,
            lc10: 29.5
        },
        "warning.2400": {
            contrast: 99.39818943482472,
            lc60: 70.5,
            lc45: 58,
            lc30: 44,
            lc10: 28.5
        },
        "warning.2500": {
            contrast: 106.36003968813117,
            lc60: 67.5,
            lc45: 55.5,
            lc30: 42,
            lc10: 27
        }
    },
    "warning.400": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 8.920475480177435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 13.451672815514154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 17.768887403193062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "warning.1000": {
            contrast: 21.95870231435154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "warning.1100": {
            contrast: 26.33380260248927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "warning.1200": {
            contrast: 30.892783654043665,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 58.5
        },
        "warning.1300": {
            contrast: 35.84683902118007,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52.5
        },
        "warning.1400": {
            contrast: 42.119535774701674,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 46.5
        },
        "warning.1500": {
            contrast: 44.66811739544569,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 44.5
        },
        "warning.1600": {
            contrast: 49.46477804514492,
            lc60: 100,
            lc45: 93,
            lc30: 68.5,
            lc10: 41.5
        },
        "warning.1700": {
            contrast: 54.88184332127876,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 38.5
        },
        "warning.1800": {
            contrast: 60.40990525147231,
            lc60: 99.5,
            lc45: 80.5,
            lc30: 60,
            lc10: 36.5
        },
        "warning.1900": {
            contrast: 66.13461844320103,
            lc60: 92.5,
            lc45: 75.5,
            lc30: 56,
            lc10: 34
        },
        "warning.2000": {
            contrast: 71.92640210594969,
            lc60: 87.5,
            lc45: 71,
            lc30: 53,
            lc10: 32.5
        },
        "warning.2100": {
            contrast: 78.09915628652878,
            lc60: 82.5,
            lc45: 67,
            lc30: 50,
            lc10: 30.5
        },
        "warning.2200": {
            contrast: 84.61697119808814,
            lc60: 78,
            lc45: 63.5,
            lc30: 47.5,
            lc10: 29
        },
        "warning.2300": {
            contrast: 91.04545040011106,
            lc60: 74,
            lc45: 60.5,
            lc30: 45.5,
            lc10: 28
        },
        "warning.2400": {
            contrast: 97.72871926916481,
            lc60: 70.5,
            lc45: 57.5,
            lc30: 43,
            lc10: 26.5
        },
        "warning.2500": {
            contrast: 104.69056952247129,
            lc60: 67,
            lc45: 55,
            lc30: 41,
            lc10: 25.5
        }
    },
    "warning.500": {
        "warning.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 10.917745555101257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 15.234960142780166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "warning.1000": {
            contrast: 19.424775053938646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "warning.1100": {
            contrast: 23.79987534207638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "warning.1200": {
            contrast: 28.35885639363077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "warning.1300": {
            contrast: 33.312911760767165,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 53
        },
        "warning.1400": {
            contrast: 39.58560851428877,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 46.5
        },
        "warning.1500": {
            contrast: 42.1341901350328,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 44.5
        },
        "warning.1600": {
            contrast: 46.93085078473202,
            lc60: 100,
            lc45: 96.5,
            lc30: 70.5,
            lc10: 41
        },
        "warning.1700": {
            contrast: 52.34791606086586,
            lc60: 100,
            lc45: 89,
            lc30: 64.5,
            lc10: 37.5
        },
        "warning.1800": {
            contrast: 57.875977991059415,
            lc60: 100,
            lc45: 82.5,
            lc30: 60.5,
            lc10: 35
        },
        "warning.1900": {
            contrast: 63.60069118278814,
            lc60: 95.5,
            lc45: 76.5,
            lc30: 56,
            lc10: 33
        },
        "warning.2000": {
            contrast: 69.3924748455368,
            lc60: 89.5,
            lc45: 72.5,
            lc30: 53,
            lc10: 31
        },
        "warning.2100": {
            contrast: 75.56522902611589,
            lc60: 84,
            lc45: 67.5,
            lc30: 49.5,
            lc10: 29.5
        },
        "warning.2200": {
            contrast: 82.08304393767524,
            lc60: 79.5,
            lc45: 64,
            lc30: 47,
            lc10: 28
        },
        "warning.2300": {
            contrast: 88.51152313969817,
            lc60: 75,
            lc45: 60.5,
            lc30: 45,
            lc10: 26.5
        },
        "warning.2400": {
            contrast: 95.19479200875193,
            lc60: 71.5,
            lc45: 57.5,
            lc30: 42.5,
            lc10: 25.5
        },
        "warning.2500": {
            contrast: 102.15664226205838,
            lc60: 67.5,
            lc45: 55,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "warning.600": {
        "warning.100": {
            contrast: 9.402501950355903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 8.88102875217364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 7.392408184487195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 11.547861036510485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 15.737675947668963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "warning.1100": {
            contrast: 20.112776235806695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "warning.1200": {
            contrast: 24.67175728736109,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "warning.1300": {
            contrast: 29.625812654497487,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "warning.1400": {
            contrast: 35.898509408019095,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48.5
        },
        "warning.1500": {
            contrast: 38.44709102876311,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 46
        },
        "warning.1600": {
            contrast: 43.24375167846233,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 42
        },
        "warning.1700": {
            contrast: 48.66081695459618,
            lc60: 100,
            lc45: 93.5,
            lc30: 67.5,
            lc10: 38.5
        },
        "warning.1800": {
            contrast: 54.18887888478972,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 36
        },
        "warning.1900": {
            contrast: 59.913592076518455,
            lc60: 100,
            lc45: 79.5,
            lc30: 58,
            lc10: 33.5
        },
        "warning.2000": {
            contrast: 65.70537573926711,
            lc60: 93,
            lc45: 74.5,
            lc30: 54,
            lc10: 31.5
        },
        "warning.2100": {
            contrast: 71.8781299198462,
            lc60: 87,
            lc45: 70,
            lc30: 51.5,
            lc10: 29.5
        },
        "warning.2200": {
            contrast: 78.39594483140556,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 48,
            lc10: 28
        },
        "warning.2300": {
            contrast: 84.82442403342849,
            lc60: 77,
            lc45: 62,
            lc30: 45.5,
            lc10: 26.5
        },
        "warning.2400": {
            contrast: 91.50769290248223,
            lc60: 73,
            lc45: 58.5,
            lc30: 43,
            lc10: 25.5
        },
        "warning.2500": {
            contrast: 98.4695431557887,
            lc60: 69,
            lc45: 56,
            lc30: 41,
            lc10: 24
        }
    },
    "warning.700": {
        "warning.100": {
            contrast: 13.80916623157784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.200": {
            contrast: 13.287693033395579,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.300": {
            contrast: 11.799072465709134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.400": {
            contrast: 9.684700333739459,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 7.6957667405983035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 11.885581651756782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 16.260681939894514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "warning.1200": {
            contrast: 20.819662991448908,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "warning.1300": {
            contrast: 25.773718358585306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "warning.1400": {
            contrast: 32.046415112106914,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 52.5
        },
        "warning.1500": {
            contrast: 34.59499673285094,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49.5
        },
        "warning.1600": {
            contrast: 39.39165738255016,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44.5
        },
        "warning.1700": {
            contrast: 44.808722658684,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40.5
        },
        "warning.1800": {
            contrast: 50.33678458887755,
            lc60: 100,
            lc45: 91,
            lc30: 66,
            lc10: 37
        },
        "warning.1900": {
            contrast: 56.06149778060626,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 34.5
        },
        "warning.2000": {
            contrast: 61.85328144335494,
            lc60: 97,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 32
        },
        "warning.2100": {
            contrast: 68.02603562393404,
            lc60: 91,
            lc45: 72.5,
            lc30: 52.5,
            lc10: 30
        },
        "warning.2200": {
            contrast: 74.54385053549338,
            lc60: 84.5,
            lc45: 68,
            lc30: 49,
            lc10: 28.5
        },
        "warning.2300": {
            contrast: 80.97232973751629,
            lc60: 79.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 27
        },
        "warning.2400": {
            contrast: 87.65559860657005,
            lc60: 75,
            lc45: 60,
            lc30: 44,
            lc10: 25.5
        },
        "warning.2500": {
            contrast: 94.6174488598765,
            lc60: 71,
            lc45: 57,
            lc30: 41.5,
            lc10: 24.5
        }
    },
    "warning.800": {
        "warning.100": {
            contrast: 18.64224801352612,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "warning.200": {
            contrast: 18.120774815343857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "warning.300": {
            contrast: 16.632154247657414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "warning.400": {
            contrast: 14.517782115687735,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.500": {
            contrast: 11.428504487673887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 7.514051513006318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 11.889151801144049,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 16.448132852698443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "warning.1300": {
            contrast: 21.40218821983484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.1400": {
            contrast: 27.674884973356445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "warning.1500": {
            contrast: 30.223466594100472,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        },
        "warning.1600": {
            contrast: 35.02012724379969,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 48
        },
        "warning.1700": {
            contrast: 40.43719251993353,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 42.5
        },
        "warning.1800": {
            contrast: 45.96525445012708,
            lc60: 100,
            lc45: 98,
            lc30: 70,
            lc10: 39
        },
        "warning.1900": {
            contrast: 51.6899676418558,
            lc60: 100,
            lc45: 89.5,
            lc30: 64,
            lc10: 36
        },
        "warning.2000": {
            contrast: 57.48175130460448,
            lc60: 100,
            lc45: 82,
            lc30: 59.5,
            lc10: 33.5
        },
        "warning.2100": {
            contrast: 63.65450548518356,
            lc60: 95,
            lc45: 76,
            lc30: 55,
            lc10: 31
        },
        "warning.2200": {
            contrast: 70.17232039674292,
            lc60: 88.5,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 29.5
        },
        "warning.2300": {
            contrast: 76.60079959876583,
            lc60: 83,
            lc45: 66.5,
            lc30: 48,
            lc10: 27.5
        },
        "warning.2400": {
            contrast: 83.2840684678196,
            lc60: 78,
            lc45: 62,
            lc30: 45.5,
            lc10: 26
        },
        "warning.2500": {
            contrast: 90.24591872112605,
            lc60: 73.5,
            lc45: 59,
            lc30: 43,
            lc10: 24.5
        }
    },
    "warning.900": {
        "warning.100": {
            contrast: 23.160430116561816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "warning.200": {
            contrast: 22.638956918379556,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "warning.300": {
            contrast: 21.150336350693113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "warning.400": {
            contrast: 19.035964218723432,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "warning.500": {
            contrast: 15.946686590709588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "warning.600": {
            contrast: 11.631691408074396,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 7.684333317586469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 12.243314369140862,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 17.19736973627726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "warning.1400": {
            contrast: 23.470066489798867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "warning.1500": {
            contrast: 26.01864811054289,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "warning.1600": {
            contrast: 30.815308760242115,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 53.5
        },
        "warning.1700": {
            contrast: 36.23237403637596,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47
        },
        "warning.1800": {
            contrast: 41.7604359665695,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        },
        "warning.1900": {
            contrast: 47.48514915829822,
            lc60: 100,
            lc45: 95.5,
            lc30: 68,
            lc10: 38
        },
        "warning.2000": {
            contrast: 53.2769328210469,
            lc60: 100,
            lc45: 87,
            lc30: 62.5,
            lc10: 35
        },
        "warning.2100": {
            contrast: 59.44968700162598,
            lc60: 100,
            lc45: 80,
            lc30: 57.5,
            lc10: 32.5
        },
        "warning.2200": {
            contrast: 65.96750191318534,
            lc60: 92.5,
            lc45: 74,
            lc30: 53.5,
            lc10: 30.5
        },
        "warning.2300": {
            contrast: 72.39598111520826,
            lc60: 86.5,
            lc45: 69,
            lc30: 50.5,
            lc10: 28.5
        },
        "warning.2400": {
            contrast: 79.079249984262,
            lc60: 81,
            lc45: 65,
            lc30: 47,
            lc10: 27
        },
        "warning.2500": {
            contrast: 86.04110023756847,
            lc60: 76,
            lc45: 61,
            lc30: 44.5,
            lc10: 25.5
        }
    },
    "warning.1000": {
        "warning.100": {
            contrast: 27.478736635250712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "warning.200": {
            contrast: 26.957263437068452,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "warning.300": {
            contrast: 25.468642869382013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "warning.400": {
            contrast: 23.35427073741233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "warning.500": {
            contrast: 20.26499310939849,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.600": {
            contrast: 15.949997926763299,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "warning.700": {
            contrast: 11.603771018857925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 8.13126814396516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 13.08532351110156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 19.358020264623164,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "warning.1500": {
            contrast: 21.90660188536719,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "warning.1600": {
            contrast: 26.703262535066408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "warning.1700": {
            contrast: 32.12032781120025,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 51
        },
        "warning.1800": {
            contrast: 37.6483897413938,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45.5
        },
        "warning.1900": {
            contrast: 43.37310293312252,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41
        },
        "warning.2000": {
            contrast: 49.164886595871195,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 37.5
        },
        "warning.2100": {
            contrast: 55.33764077645027,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 34.5
        },
        "warning.2200": {
            contrast: 61.85545568800964,
            lc60: 97,
            lc45: 78,
            lc30: 56,
            lc10: 31.5
        },
        "warning.2300": {
            contrast: 68.28393489003255,
            lc60: 90.5,
            lc45: 72,
            lc30: 52.5,
            lc10: 29.5
        },
        "warning.2400": {
            contrast: 74.96720375908632,
            lc60: 84.5,
            lc45: 67,
            lc30: 49,
            lc10: 28
        },
        "warning.2500": {
            contrast: 81.92905401239278,
            lc60: 79,
            lc45: 63,
            lc30: 46,
            lc10: 26.5
        }
    },
    "warning.1100": {
        "warning.100": {
            contrast: 31.92856433334461,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 33.5
        },
        "warning.200": {
            contrast: 31.40709113516235,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 38.5
        },
        "warning.300": {
            contrast: 29.918470567475907,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "warning.400": {
            contrast: 27.80409843550623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "warning.500": {
            contrast: 24.714820807492384,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "warning.600": {
            contrast: 20.399825624857197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "warning.700": {
            contrast: 16.05359871695182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "warning.800": {
            contrast: 11.268686108234965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 8.762849056339771,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 15.035545809861379,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "warning.1500": {
            contrast: 17.584127430605406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "warning.1600": {
            contrast: 22.38078808030463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "warning.1700": {
            contrast: 27.797853356438463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "warning.1800": {
            contrast: 33.32591528663201,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "warning.1900": {
            contrast: 39.050628478360736,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "warning.2000": {
            contrast: 44.842412141109406,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 40
        },
        "warning.2100": {
            contrast: 51.01516632168849,
            lc60: 100,
            lc45: 90,
            lc30: 65,
            lc10: 36.5
        },
        "warning.2200": {
            contrast: 57.532981233247845,
            lc60: 100,
            lc45: 82,
            lc30: 59.5,
            lc10: 34
        },
        "warning.2300": {
            contrast: 63.961460435270766,
            lc60: 95,
            lc45: 76,
            lc30: 55,
            lc10: 31.5
        },
        "warning.2400": {
            contrast: 70.64472930432453,
            lc60: 88,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 29
        },
        "warning.2500": {
            contrast: 77.60657955763098,
            lc60: 82,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 27.5
        }
    },
    "warning.1200": {
        "warning.100": {
            contrast: 36.50946091033647,
            lc60: 100,
            lc45: 100,
            lc30: 61.5,
            lc10: 30
        },
        "warning.200": {
            contrast: 35.987987712154215,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "warning.300": {
            contrast: 34.49936714446777,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38.5
        },
        "warning.400": {
            contrast: 32.38499501249809,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 43
        },
        "warning.500": {
            contrast: 29.29571738448424,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "warning.600": {
            contrast: 24.980722201849055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "warning.700": {
            contrast: 20.634495293943683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.800": {
            contrast: 15.849582685226823,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "warning.900": {
            contrast: 11.362240127064155,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 10.503981858874445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 13.05256347961847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 17.849224129317694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "warning.1700": {
            contrast: 23.26628940545153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.1800": {
            contrast: 28.79435133564508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "warning.1900": {
            contrast: 34.5190645273738,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49.5
        },
        "warning.2000": {
            contrast: 40.31084819012247,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44
        },
        "warning.2100": {
            contrast: 46.48360237070156,
            lc60: 100,
            lc45: 97.5,
            lc30: 70,
            lc10: 39.5
        },
        "warning.2200": {
            contrast: 53.00141728226091,
            lc60: 100,
            lc45: 88,
            lc30: 63.5,
            lc10: 36
        },
        "warning.2300": {
            contrast: 59.42989648428384,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 33
        },
        "warning.2400": {
            contrast: 66.11316535333759,
            lc60: 93,
            lc45: 74.5,
            lc30: 54,
            lc10: 31
        },
        "warning.2500": {
            contrast: 73.07501560664406,
            lc60: 86,
            lc45: 69,
            lc30: 50.5,
            lc10: 29
        }
    },
    "warning.1300": {
        "warning.100": {
            contrast: 41.43071166870881,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 27
        },
        "warning.200": {
            contrast: 40.909238470526546,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "warning.300": {
            contrast: 39.42061790284011,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33.5
        },
        "warning.400": {
            contrast: 37.306245770870426,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "warning.500": {
            contrast: 34.21696814285658,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 42.5
        },
        "warning.600": {
            contrast: 29.90197296022139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "warning.700": {
            contrast: 25.55574605231602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "warning.800": {
            contrast: 20.770833443599162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "warning.900": {
            contrast: 16.283490885436493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "warning.1000": {
            contrast: 11.983712296762016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1100": {
            contrast: 7.543165211494446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 8.1000565962939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 12.89671724599312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 18.31378252212696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "warning.1800": {
            contrast: 23.84184445232051,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.1900": {
            contrast: 29.56655764404923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "warning.2000": {
            contrast: 35.3583413067979,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 49.5
        },
        "warning.2100": {
            contrast: 41.53109548737699,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 43.5
        },
        "warning.2200": {
            contrast: 48.04891039893634,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 39.5
        },
        "warning.2300": {
            contrast: 54.477389600959256,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 36
        },
        "warning.2400": {
            contrast: 61.16065847001302,
            lc60: 98,
            lc45: 79.5,
            lc30: 57.5,
            lc10: 33.5
        },
        "warning.2500": {
            contrast: 68.12250872331947,
            lc60: 90.5,
            lc45: 73.5,
            lc30: 53.5,
            lc10: 30.5
        }
    },
    "warning.1400": {
        "warning.100": {
            contrast: 47.58789631538573,
            lc60: 100,
            lc45: 79,
            lc30: 47,
            lc10: 23.5
        },
        "warning.200": {
            contrast: 47.06642311720347,
            lc60: 100,
            lc45: 87.5,
            lc30: 52,
            lc10: 26
        },
        "warning.300": {
            contrast: 45.577802549517024,
            lc60: 100,
            lc45: 97,
            lc30: 57.5,
            lc10: 28.5
        },
        "warning.400": {
            contrast: 43.46343041754735,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "warning.500": {
            contrast: 40.374152789533504,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 35.5
        },
        "warning.600": {
            contrast: 36.05915760689831,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41
        },
        "warning.700": {
            contrast: 31.712930698992942,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 47
        },
        "warning.800": {
            contrast: 26.92801809027608,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "warning.900": {
            contrast: 22.440675532113417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "warning.1000": {
            contrast: 18.14089694343894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "warning.1100": {
            contrast: 13.700349858171368,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1200": {
            contrast: 9.119747619410825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 12.005482581691783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 17.53354451188533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "warning.1900": {
            contrast: 23.258257703614056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "warning.2000": {
            contrast: 29.050041366362723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "warning.2100": {
            contrast: 35.22279554694181,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 51
        },
        "warning.2200": {
            contrast: 41.740610458501166,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44
        },
        "warning.2300": {
            contrast: 48.16908966052408,
            lc60: 100,
            lc45: 95,
            lc30: 69.5,
            lc10: 40
        },
        "warning.2400": {
            contrast: 54.85235852957784,
            lc60: 100,
            lc45: 86,
            lc30: 63,
            lc10: 36
        },
        "warning.2500": {
            contrast: 61.81420878288429,
            lc60: 97.5,
            lc45: 78.5,
            lc30: 57.5,
            lc10: 33
        }
    },
    "warning.1500": {
        "warning.100": {
            contrast: 50.06831644897465,
            lc60: 100,
            lc45: 72,
            lc30: 44.5,
            lc10: 22.5
        },
        "warning.200": {
            contrast: 49.54684325079239,
            lc60: 100,
            lc45: 79.5,
            lc30: 49.5,
            lc10: 25
        },
        "warning.300": {
            contrast: 48.05822268310595,
            lc60: 100,
            lc45: 88,
            lc30: 54.5,
            lc10: 27.5
        },
        "warning.400": {
            contrast: 45.94385055113627,
            lc60: 100,
            lc45: 96,
            lc30: 59.5,
            lc10: 30
        },
        "warning.500": {
            contrast: 42.854572923122426,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 33.5
        },
        "warning.600": {
            contrast: 38.53957774048723,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38
        },
        "warning.700": {
            contrast: 34.193350832581864,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43.5
        },
        "warning.800": {
            contrast: 29.408438223865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "warning.900": {
            contrast: 24.92109566570234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "warning.1000": {
            contrast: 20.62131707702786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "warning.1100": {
            contrast: 16.18076999176029,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "warning.1200": {
            contrast: 11.600167752999749,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 9.431501624836848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 14.959563555030398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 20.68427674675912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "warning.2000": {
            contrast: 26.476060409507784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "warning.2100": {
            contrast: 32.64881459008687,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 53
        },
        "warning.2200": {
            contrast: 39.16662950164623,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 46.5
        },
        "warning.2300": {
            contrast: 45.59510870366915,
            lc60: 100,
            lc45: 98.5,
            lc30: 72,
            lc10: 41.5
        },
        "warning.2400": {
            contrast: 52.2783775727229,
            lc60: 100,
            lc45: 89,
            lc30: 64.5,
            lc10: 37
        },
        "warning.2500": {
            contrast: 59.240227826029354,
            lc60: 100,
            lc45: 81,
            lc30: 59.5,
            lc10: 34.5
        }
    },
    "warning.1600": {
        "warning.100": {
            contrast: 54.70645697771091,
            lc60: 100,
            lc45: 64,
            lc30: 41,
            lc10: 20.5
        },
        "warning.200": {
            contrast: 54.184983779528636,
            lc60: 100,
            lc45: 70.5,
            lc30: 45,
            lc10: 22.5
        },
        "warning.300": {
            contrast: 52.696363211842204,
            lc60: 100,
            lc45: 77,
            lc30: 49.5,
            lc10: 24.5
        },
        "warning.400": {
            contrast: 50.58199107987252,
            lc60: 100,
            lc45: 84,
            lc30: 53.5,
            lc10: 27
        },
        "warning.500": {
            contrast: 47.49271345185867,
            lc60: 100,
            lc45: 93,
            lc30: 59,
            lc10: 30
        },
        "warning.600": {
            contrast: 43.17771826922348,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 33.5
        },
        "warning.700": {
            contrast: 38.83149136131811,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "warning.800": {
            contrast: 34.04657875260125,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 44
        },
        "warning.900": {
            contrast: 29.559236194438583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "warning.1000": {
            contrast: 25.25945760576411,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "warning.1100": {
            contrast: 20.81891052049654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "warning.1200": {
            contrast: 16.238308281735996,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "warning.1300": {
            contrast: 11.307982442798581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 10.0993282374133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 15.82404142914202,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "warning.2000": {
            contrast: 21.615825091890688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "warning.2100": {
            contrast: 27.788579272469775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "warning.2200": {
            contrast: 34.30639418402913,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "warning.2300": {
            contrast: 40.73487338605205,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 45
        },
        "warning.2400": {
            contrast: 47.41814225510581,
            lc60: 100,
            lc45: 96,
            lc30: 69.5,
            lc10: 39.5
        },
        "warning.2500": {
            contrast: 54.379992508412265,
            lc60: 100,
            lc45: 86,
            lc30: 62.5,
            lc10: 35.5
        }
    },
    "warning.1700": {
        "warning.100": {
            contrast: 59.90073843013375,
            lc60: 100,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "warning.200": {
            contrast: 59.379265231951486,
            lc60: 100,
            lc45: 63.5,
            lc30: 41,
            lc10: 20.5
        },
        "warning.300": {
            contrast: 57.89064466426505,
            lc60: 100,
            lc45: 68.5,
            lc30: 44,
            lc10: 22
        },
        "warning.400": {
            contrast: 55.776272532295366,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "warning.500": {
            contrast: 52.68699490428151,
            lc60: 100,
            lc45: 82,
            lc30: 52.5,
            lc10: 26.5
        },
        "warning.600": {
            contrast: 48.37199972164633,
            lc60: 100,
            lc45: 91.5,
            lc30: 58.5,
            lc10: 30
        },
        "warning.700": {
            contrast: 44.02577281374096,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "warning.800": {
            contrast: 39.24086020502409,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "warning.900": {
            contrast: 34.753517646861425,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 43
        },
        "warning.1000": {
            contrast: 30.45373905818695,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 50
        },
        "warning.1100": {
            contrast: 26.01319197291938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "warning.1200": {
            contrast: 21.432589734158842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "warning.1300": {
            contrast: 16.502263895221425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "warning.1400": {
            contrast: 10.321435529914694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1500": {
            contrast: 7.8279493764634545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 10.312105156542245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 16.103888819290916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "warning.2100": {
            contrast: 22.276642999870003,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "warning.2200": {
            contrast: 28.794457911429355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "warning.2300": {
            contrast: 35.222937113452275,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 49
        },
        "warning.2400": {
            contrast: 41.90620598250604,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42.5
        },
        "warning.2500": {
            contrast: 48.86805623581248,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 37.5
        }
    },
    "warning.1800": {
        "warning.100": {
            contrast: 65.15786908391841,
            lc60: 76,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "warning.200": {
            contrast: 64.63639588573615,
            lc60: 82.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19
        },
        "warning.300": {
            contrast: 63.14777531804972,
            lc60: 89.5,
            lc45: 62.5,
            lc30: 40,
            lc10: 20.5
        },
        "warning.400": {
            contrast: 61.03340318608004,
            lc60: 96.5,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "warning.500": {
            contrast: 57.94412555806618,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 24
        },
        "warning.600": {
            contrast: 53.629130375431004,
            lc60: 100,
            lc45: 80.5,
            lc30: 52,
            lc10: 26.5
        },
        "warning.700": {
            contrast: 49.28290346752562,
            lc60: 100,
            lc45: 89.5,
            lc30: 57.5,
            lc10: 29
        },
        "warning.800": {
            contrast: 44.49799085880876,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "warning.900": {
            contrast: 40.010648300646096,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 36.5
        },
        "warning.1000": {
            contrast: 35.71086971197162,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "warning.1100": {
            contrast: 31.27032262670405,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 48
        },
        "warning.1200": {
            contrast: 26.689720387943506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "warning.1300": {
            contrast: 21.759394549006096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.1400": {
            contrast: 15.578566183699364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "warning.1500": {
            contrast: 13.085080030248122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1600": {
            contrast: 8.41745672854894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 10.455746031433813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 16.628500212012902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "warning.2200": {
            contrast: 23.146315123572254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "warning.2300": {
            contrast: 29.57479432559517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "warning.2400": {
            contrast: 36.25806319464893,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47.5
        },
        "warning.2500": {
            contrast: 43.219913447955385,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 41
        }
    },
    "warning.1900": {
        "warning.100": {
            contrast: 70.55965400385227,
            lc60: 68.5,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "warning.200": {
            contrast: 70.03818080567001,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "warning.300": {
            contrast: 68.54956023798357,
            lc60: 79,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "warning.400": {
            contrast: 66.4351881060139,
            lc60: 85,
            lc45: 60.5,
            lc30: 39.5,
            lc10: 20
        },
        "warning.500": {
            contrast: 63.34591047800004,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 42.5,
            lc10: 22
        },
        "warning.600": {
            contrast: 59.03091529536486,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "warning.700": {
            contrast: 54.68468838745948,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "warning.800": {
            contrast: 49.89977577874263,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 28.5
        },
        "warning.900": {
            contrast: 45.412433220579956,
            lc60: 100,
            lc45: 98.5,
            lc30: 63,
            lc10: 31.5
        },
        "warning.1000": {
            contrast: 41.112654631905485,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "warning.1100": {
            contrast: 36.67210754663791,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40
        },
        "warning.1200": {
            contrast: 32.09150530787737,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 45.5
        },
        "warning.1300": {
            contrast: 27.16117946893995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "warning.1400": {
            contrast: 20.980351103633225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "warning.1500": {
            contrast: 18.486864950181985,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "warning.1600": {
            contrast: 13.819241648482802,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1700": {
            contrast: 8.584628255304406,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 10.756547043836825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 17.274361955396184,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "warning.2300": {
            contrast: 23.7028411574191,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "warning.2400": {
            contrast: 30.386110026472856,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "warning.2500": {
            contrast: 37.347960279779315,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46
        }
    },
    "warning.2000": {
        "warning.100": {
            contrast: 75.98447953710291,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "warning.200": {
            contrast: 75.46300633892065,
            lc60: 67,
            lc45: 48.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "warning.300": {
            contrast: 73.97438577123421,
            lc60: 72,
            lc45: 52,
            lc30: 34,
            lc10: 17.5
        },
        "warning.400": {
            contrast: 71.86001363926454,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 18.5
        },
        "warning.500": {
            contrast: 68.77073601125068,
            lc60: 82.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "warning.600": {
            contrast: 64.45574082861549,
            lc60: 90.5,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "warning.700": {
            contrast: 60.109513920710114,
            lc60: 99.5,
            lc45: 70,
            lc30: 45.5,
            lc10: 23.5
        },
        "warning.800": {
            contrast: 55.32460131199326,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 26
        },
        "warning.900": {
            contrast: 50.837258753830596,
            lc60: 100,
            lc45: 86,
            lc30: 55,
            lc10: 28
        },
        "warning.1000": {
            contrast: 46.53748016515611,
            lc60: 100,
            lc45: 95.5,
            lc30: 61,
            lc10: 30.5
        },
        "warning.1100": {
            contrast: 42.096933079888544,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 34.5
        },
        "warning.1200": {
            contrast: 37.516330841128,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 38
        },
        "warning.1300": {
            contrast: 32.58600500219059,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 43.5
        },
        "warning.1400": {
            contrast: 26.40517663688386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "warning.1500": {
            contrast: 23.911690483432622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "warning.1600": {
            contrast: 19.244067181733435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "warning.1700": {
            contrast: 14.00945378855504,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1800": {
            contrast: 8.704207912997726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 11.311618277258479,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 17.740097479281395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "warning.2400": {
            contrast: 24.423366348335154,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "warning.2500": {
            contrast: 31.38521660164161,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 52.5
        }
    },
    "warning.2100": {
        "warning.100": {
            contrast: 81.72510799471475,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "warning.200": {
            contrast: 81.20363479653248,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "warning.300": {
            contrast: 79.71501422884604,
            lc60: 65.5,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "warning.400": {
            contrast: 77.60064209687637,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "warning.500": {
            contrast: 74.51136446886252,
            lc60: 74.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "warning.600": {
            contrast: 70.19636928622732,
            lc60: 81,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "warning.700": {
            contrast: 65.85014237832196,
            lc60: 88,
            lc45: 63,
            lc30: 41,
            lc10: 21.5
        },
        "warning.800": {
            contrast: 61.065229769605104,
            lc60: 97.5,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "warning.900": {
            contrast: 56.57788721144244,
            lc60: 100,
            lc45: 75.5,
            lc30: 48.5,
            lc10: 25
        },
        "warning.1000": {
            contrast: 52.27810862276796,
            lc60: 100,
            lc45: 82.5,
            lc30: 53.5,
            lc10: 27
        },
        "warning.1100": {
            contrast: 47.837561537500385,
            lc60: 100,
            lc45: 92.5,
            lc30: 58,
            lc10: 29.5
        },
        "warning.1200": {
            contrast: 43.256959298739844,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "warning.1300": {
            contrast: 38.32663345980243,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37
        },
        "warning.1400": {
            contrast: 32.1458050944957,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 43.5
        },
        "warning.1500": {
            contrast: 29.65231894104446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "warning.1600": {
            contrast: 24.984695639345276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "warning.1700": {
            contrast: 19.750082246166876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "warning.1800": {
            contrast: 14.444836370609565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.1900": {
            contrast: 8.986510828330127,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 11.362468196447809,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 18.04573706550157,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "warning.2500": {
            contrast: 25.00758731880802,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        }
    },
    "warning.2200": {
        "warning.100": {
            contrast: 87.7442251181507,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "warning.200": {
            contrast: 87.22275191996843,
            lc60: 56.5,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "warning.300": {
            contrast: 85.73413135228199,
            lc60: 60,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "warning.400": {
            contrast: 83.61975922031232,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "warning.500": {
            contrast: 80.53048159229846,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "warning.600": {
            contrast: 76.21548640966328,
            lc60: 73,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "warning.700": {
            contrast: 71.8692595017579,
            lc60: 79,
            lc45: 56.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "warning.800": {
            contrast: 67.08434689304104,
            lc60: 86,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "warning.900": {
            contrast: 62.59700433487838,
            lc60: 94,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "warning.1000": {
            contrast: 58.29722574620389,
            lc60: 100,
            lc45: 72.5,
            lc30: 46.5,
            lc10: 24
        },
        "warning.1100": {
            contrast: 53.85667866093633,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 25.5
        },
        "warning.1200": {
            contrast: 49.276076422175784,
            lc60: 100,
            lc45: 88.5,
            lc30: 55.5,
            lc10: 28
        },
        "warning.1300": {
            contrast: 44.34575058323837,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31.5
        },
        "warning.1400": {
            contrast: 38.16492221793164,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "warning.1500": {
            contrast: 35.6714360644804,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 39
        },
        "warning.1600": {
            contrast: 31.00381276278122,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 46
        },
        "warning.1700": {
            contrast: 25.76919936960282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "warning.1800": {
            contrast: 20.463953494045512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "warning.1900": {
            contrast: 15.005627951766071,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "warning.2000": {
            contrast: 9.517263311264056,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 11.287909106239669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 18.249759359546125,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        }
    },
    "warning.2300": {
        "warning.100": {
            contrast: 93.64133437755066,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "warning.200": {
            contrast: 93.1198611793684,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "warning.300": {
            contrast: 91.63124061168195,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "warning.400": {
            contrast: 89.51686847971227,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "warning.500": {
            contrast: 86.42759085169843,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "warning.600": {
            contrast: 82.11259566906325,
            lc60: 66.5,
            lc45: 48,
            lc30: 32,
            lc10: 16.5
        },
        "warning.700": {
            contrast: 77.76636876115785,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "warning.800": {
            contrast: 72.981456152441,
            lc60: 77,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 19
        },
        "warning.900": {
            contrast: 68.49411359427833,
            lc60: 83.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20
        },
        "warning.1000": {
            contrast: 64.19433500560385,
            lc60: 91,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "warning.1100": {
            contrast: 59.753787920336286,
            lc60: 100,
            lc45: 70,
            lc30: 45.5,
            lc10: 23.5
        },
        "warning.1200": {
            contrast: 55.17318568157575,
            lc60: 100,
            lc45: 76.5,
            lc30: 49,
            lc10: 25.5
        },
        "warning.1300": {
            contrast: 50.24285984263833,
            lc60: 100,
            lc45: 86,
            lc30: 53.5,
            lc10: 27.5
        },
        "warning.1400": {
            contrast: 44.0620314773316,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31
        },
        "warning.1500": {
            contrast: 41.568545323880365,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33.5
        },
        "warning.1600": {
            contrast: 36.900922022181184,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38
        },
        "warning.1700": {
            contrast: 31.66630862900278,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 45.5
        },
        "warning.1800": {
            contrast: 26.36106275344547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "warning.1900": {
            contrast: 20.902737211166034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "warning.2000": {
            contrast: 15.41437257066402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "warning.2100": {
            contrast: 9.599608181694656,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 11.562268977404988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "warning.2400": {
        "warning.100": {
            contrast: 99.73354073616065,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "warning.200": {
            contrast: 99.21206753797837,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "warning.300": {
            contrast: 97.72344697029193,
            lc60: 51.5,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "warning.400": {
            contrast: 95.60907483832224,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "warning.500": {
            contrast: 92.5197972103084,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 15
        },
        "warning.600": {
            contrast: 88.20480202767321,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "warning.700": {
            contrast: 83.85857511976785,
            lc60: 65,
            lc45: 47,
            lc30: 31.5,
            lc10: 16
        },
        "warning.800": {
            contrast: 79.07366251105098,
            lc60: 70,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "warning.900": {
            contrast: 74.58631995288832,
            lc60: 75,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "warning.1000": {
            contrast: 70.28654136421383,
            lc60: 81,
            lc45: 58,
            lc30: 38,
            lc10: 20
        },
        "warning.1100": {
            contrast: 65.84599427894628,
            lc60: 87.5,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "warning.1200": {
            contrast: 61.26539204018573,
            lc60: 97,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "warning.1300": {
            contrast: 56.33506620124831,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24.5
        },
        "warning.1400": {
            contrast: 50.154237835941586,
            lc60: 100,
            lc45: 86,
            lc30: 53.5,
            lc10: 27
        },
        "warning.1500": {
            contrast: 47.66075168249034,
            lc60: 100,
            lc45: 92.5,
            lc30: 57,
            lc10: 28.5
        },
        "warning.1600": {
            contrast: 42.993128380791156,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 32.5
        },
        "warning.1700": {
            contrast: 37.758514987612756,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 38.5
        },
        "warning.1800": {
            contrast: 32.453269112055445,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46
        },
        "warning.1900": {
            contrast: 26.99494356977601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "warning.2000": {
            contrast: 21.506578929273996,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "warning.2100": {
            contrast: 15.69181454030463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "warning.2200": {
            contrast: 9.58782525991452,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "warning.2500": {
        "warning.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "warning.200": {
            contrast: 105.51920001450634,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "warning.300": {
            contrast: 104.0305794468199,
            lc60: 48,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "warning.400": {
            contrast: 101.91620731485023,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "warning.500": {
            contrast: 98.82692968683637,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "warning.600": {
            contrast: 94.51193450420118,
            lc60: 56,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14.5
        },
        "warning.700": {
            contrast: 90.1657075962958,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "warning.800": {
            contrast: 85.38079498757895,
            lc60: 63.5,
            lc45: 46,
            lc30: 31,
            lc10: 16
        },
        "warning.900": {
            contrast: 80.89345242941627,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "warning.1000": {
            contrast: 76.5936738407418,
            lc60: 72,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "warning.1100": {
            contrast: 72.15312675547422,
            lc60: 77.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "warning.1200": {
            contrast: 67.57252451671368,
            lc60: 84.5,
            lc45: 60,
            lc30: 39,
            lc10: 20
        },
        "warning.1300": {
            contrast: 62.64219867777627,
            lc60: 93.5,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "warning.1400": {
            contrast: 56.46137031246954,
            lc60: 100,
            lc45: 73.5,
            lc30: 46.5,
            lc10: 24
        },
        "warning.1500": {
            contrast: 53.9678841590183,
            lc60: 100,
            lc45: 78,
            lc30: 49.5,
            lc10: 25
        },
        "warning.1600": {
            contrast: 49.30026085731911,
            lc60: 100,
            lc45: 88.5,
            lc30: 56,
            lc10: 28.5
        },
        "warning.1700": {
            contrast: 44.06564746414072,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "warning.1800": {
            contrast: 38.760401588583406,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38
        },
        "warning.1900": {
            contrast: 33.30207604630397,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 45.5
        },
        "warning.2000": {
            contrast: 27.81371140580195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "warning.2100": {
            contrast: 21.99894701683259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "warning.2200": {
            contrast: 15.89495773644248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "warning.2300": {
            contrast: 9.908037562505259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "warning.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$mint = {
    "mint.100": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 9.480470919659547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 13.728143049701533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 18.6603994332892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "mint.900": {
            contrast: 23.55135388448177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "mint.1000": {
            contrast: 27.909479174916974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.1100": {
            contrast: 32.881832495712736,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 66
        },
        "mint.1200": {
            contrast: 37.631006101409845,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 61
        },
        "mint.1300": {
            contrast: 43.01190489727612,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 56.5
        },
        "mint.1400": {
            contrast: 48.12126610136416,
            lc60: 100,
            lc45: 96,
            lc30: 76,
            lc10: 52.5
        },
        "mint.1500": {
            contrast: 52.500126426363224,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "mint.1600": {
            contrast: 55.458574806556285,
            lc60: 100,
            lc45: 88,
            lc30: 69.5,
            lc10: 48.5
        },
        "mint.1700": {
            contrast: 61.23230513200103,
            lc60: 98.5,
            lc45: 82.5,
            lc30: 65.5,
            lc10: 45.5
        },
        "mint.1800": {
            contrast: 67.2440162676256,
            lc60: 93,
            lc45: 78.5,
            lc30: 62,
            lc10: 43.5
        },
        "mint.1900": {
            contrast: 73.6735924939767,
            lc60: 88,
            lc45: 74,
            lc30: 58.5,
            lc10: 40.5
        },
        "mint.2000": {
            contrast: 79.20035863628493,
            lc60: 84,
            lc45: 70.5,
            lc30: 55.5,
            lc10: 39
        },
        "mint.2100": {
            contrast: 84.95957988643967,
            lc60: 80.5,
            lc45: 67.5,
            lc30: 53.5,
            lc10: 37
        },
        "mint.2200": {
            contrast: 90.46871497721347,
            lc60: 77,
            lc45: 65,
            lc30: 51.5,
            lc10: 36
        },
        "mint.2300": {
            contrast: 96.36179494230913,
            lc60: 74,
            lc45: 62.5,
            lc30: 49.5,
            lc10: 34
        },
        "mint.2400": {
            contrast: 102.34319828009501,
            lc60: 71.5,
            lc45: 60,
            lc30: 47.5,
            lc10: 33
        },
        "mint.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "mint.200": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 9.079668034096198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 13.327340164138182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 18.259596547725852,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "mint.900": {
            contrast: 23.15055099891842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "mint.1000": {
            contrast: 27.508676289353616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "mint.1100": {
            contrast: 32.48102961014938,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 62
        },
        "mint.1200": {
            contrast: 37.230203215846494,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 56.5
        },
        "mint.1300": {
            contrast: 42.61110201171277,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52
        },
        "mint.1400": {
            contrast: 47.7204632158008,
            lc60: 100,
            lc45: 96,
            lc30: 74,
            lc10: 48
        },
        "mint.1500": {
            contrast: 52.09932354079987,
            lc60: 100,
            lc45: 91,
            lc30: 69.5,
            lc10: 45.5
        },
        "mint.1600": {
            contrast: 55.05777192099293,
            lc60: 100,
            lc45: 87,
            lc30: 67,
            lc10: 44
        },
        "mint.1700": {
            contrast: 60.83150224643767,
            lc60: 99,
            lc45: 81.5,
            lc30: 63,
            lc10: 41
        },
        "mint.1800": {
            contrast: 66.84321338206225,
            lc60: 92.5,
            lc45: 77,
            lc30: 59,
            lc10: 39
        },
        "mint.1900": {
            contrast: 73.27278960841335,
            lc60: 87,
            lc45: 72.5,
            lc30: 55.5,
            lc10: 36.5
        },
        "mint.2000": {
            contrast: 78.79955575072157,
            lc60: 83,
            lc45: 68.5,
            lc30: 53,
            lc10: 34.5
        },
        "mint.2100": {
            contrast: 84.55877700087633,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "mint.2200": {
            contrast: 90.06791209165011,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "mint.2300": {
            contrast: 95.96099205674578,
            lc60: 73,
            lc45: 60.5,
            lc30: 46.5,
            lc10: 30.5
        },
        "mint.2400": {
            contrast: 101.94239539453164,
            lc60: 70,
            lc45: 58,
            lc30: 45,
            lc10: 29.5
        },
        "mint.2500": {
            contrast: 107.48393029753511,
            lc60: 67.5,
            lc45: 56,
            lc30: 43,
            lc10: 28.5
        }
    },
    "mint.300": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 7.7760683574008045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 12.023740487442788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 16.955996871030457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "mint.900": {
            contrast: 21.846951322223028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "mint.1000": {
            contrast: 26.205076612658225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.1100": {
            contrast: 31.177429933453986,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 60
        },
        "mint.1200": {
            contrast: 35.9266035391511,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 54.5
        },
        "mint.1300": {
            contrast: 41.30750233501737,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 49.5
        },
        "mint.1400": {
            contrast: 46.416863539105414,
            lc60: 100,
            lc45: 97,
            lc30: 73.5,
            lc10: 45.5
        },
        "mint.1500": {
            contrast: 50.79572386410448,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 42.5
        },
        "mint.1600": {
            contrast: 53.754172244297536,
            lc60: 100,
            lc45: 87.5,
            lc30: 66.5,
            lc10: 41
        },
        "mint.1700": {
            contrast: 59.52790256974229,
            lc60: 100,
            lc45: 82,
            lc30: 61.5,
            lc10: 38
        },
        "mint.1800": {
            contrast: 65.53961370536685,
            lc60: 94,
            lc45: 76,
            lc30: 57.5,
            lc10: 36
        },
        "mint.1900": {
            contrast: 71.96918993171796,
            lc60: 87.5,
            lc45: 71.5,
            lc30: 54,
            lc10: 33.5
        },
        "mint.2000": {
            contrast: 77.49595607402618,
            lc60: 83,
            lc45: 68,
            lc30: 51,
            lc10: 31.5
        },
        "mint.2100": {
            contrast: 83.25517732418093,
            lc60: 79,
            lc45: 64.5,
            lc30: 48.5,
            lc10: 30.5
        },
        "mint.2200": {
            contrast: 88.76431241495473,
            lc60: 75.5,
            lc45: 62,
            lc30: 46.5,
            lc10: 29
        },
        "mint.2300": {
            contrast: 94.65739238005038,
            lc60: 72.5,
            lc45: 59,
            lc30: 44.5,
            lc10: 28
        },
        "mint.2400": {
            contrast: 100.63879571783627,
            lc60: 69.5,
            lc45: 57,
            lc30: 43,
            lc10: 27
        },
        "mint.2500": {
            contrast: 106.18033062083974,
            lc60: 67,
            lc45: 55,
            lc30: 41.5,
            lc10: 26
        }
    },
    "mint.400": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 10.137711616240896,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 15.069967999828565,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "mint.900": {
            contrast: 19.960922451021133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "mint.1000": {
            contrast: 24.319047741456338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "mint.1100": {
            contrast: 29.2914010622521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "mint.1200": {
            contrast: 34.040574667949215,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 53.5
        },
        "mint.1300": {
            contrast: 39.42147346381548,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 48
        },
        "mint.1400": {
            contrast: 44.53083466790353,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 44
        },
        "mint.1500": {
            contrast: 48.90969499290259,
            lc60: 100,
            lc45: 93.5,
            lc30: 69,
            lc10: 41
        },
        "mint.1600": {
            contrast: 51.86814337309564,
            lc60: 100,
            lc45: 89.5,
            lc30: 66,
            lc10: 39
        },
        "mint.1700": {
            contrast: 57.641873698540394,
            lc60: 100,
            lc45: 83,
            lc30: 61.5,
            lc10: 36.5
        },
        "mint.1800": {
            contrast: 63.653584834164946,
            lc60: 96,
            lc45: 76.5,
            lc30: 56.5,
            lc10: 34
        },
        "mint.1900": {
            contrast: 70.08316106051605,
            lc60: 89,
            lc45: 72,
            lc30: 53,
            lc10: 31.5
        },
        "mint.2000": {
            contrast: 75.60992720282428,
            lc60: 84,
            lc45: 68,
            lc30: 50.5,
            lc10: 30
        },
        "mint.2100": {
            contrast: 81.36914845297903,
            lc60: 79.5,
            lc45: 64.5,
            lc30: 47.5,
            lc10: 28.5
        },
        "mint.2200": {
            contrast: 86.87828354375281,
            lc60: 76,
            lc45: 61.5,
            lc30: 45.5,
            lc10: 27.5
        },
        "mint.2300": {
            contrast: 92.7713635088485,
            lc60: 72.5,
            lc45: 58.5,
            lc30: 43.5,
            lc10: 26
        },
        "mint.2400": {
            contrast: 98.75276684663436,
            lc60: 69.5,
            lc45: 56,
            lc30: 42,
            lc10: 25
        },
        "mint.2500": {
            contrast: 104.29430174963782,
            lc60: 67,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24.5
        }
    },
    "mint.500": {
        "mint.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 12.12765648337992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 17.01861093457249,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "mint.1000": {
            contrast: 21.376736225007694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "mint.1100": {
            contrast: 26.34908954580345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "mint.1200": {
            contrast: 31.098263151500564,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 55.5
        },
        "mint.1300": {
            contrast: 36.47916194736683,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 49
        },
        "mint.1400": {
            contrast: 41.58852315145488,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 44
        },
        "mint.1500": {
            contrast: 45.96738347645394,
            lc60: 100,
            lc45: 97.5,
            lc30: 71,
            lc10: 40.5
        },
        "mint.1600": {
            contrast: 48.925831856646994,
            lc60: 100,
            lc45: 93,
            lc30: 68,
            lc10: 38.5
        },
        "mint.1700": {
            contrast: 54.699562182091746,
            lc60: 100,
            lc45: 85.5,
            lc30: 62.5,
            lc10: 35.5
        },
        "mint.1800": {
            contrast: 60.711273317716305,
            lc60: 98.5,
            lc45: 79.5,
            lc30: 57,
            lc10: 33
        },
        "mint.1900": {
            contrast: 67.14084954406742,
            lc60: 91.5,
            lc45: 73,
            lc30: 53,
            lc10: 30.5
        },
        "mint.2000": {
            contrast: 72.66761568637564,
            lc60: 86,
            lc45: 68.5,
            lc30: 50,
            lc10: 29
        },
        "mint.2100": {
            contrast: 78.42683693653039,
            lc60: 81.5,
            lc45: 65,
            lc30: 47.5,
            lc10: 27
        },
        "mint.2200": {
            contrast: 83.93597202730419,
            lc60: 77.5,
            lc45: 62,
            lc30: 45.5,
            lc10: 26.5
        },
        "mint.2300": {
            contrast: 89.82905199239984,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 25
        },
        "mint.2400": {
            contrast: 95.81045533018572,
            lc60: 70,
            lc45: 56.5,
            lc30: 41,
            lc10: 24
        },
        "mint.2500": {
            contrast: 101.3519902331892,
            lc60: 68,
            lc45: 54.5,
            lc30: 40,
            lc10: 23.5
        }
    },
    "mint.600": {
        "mint.100": {
            contrast: 10.94708342402034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.200": {
            contrast: 10.409581048946102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.300": {
            contrast: 8.705598230195875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 7.911065039365277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 12.802019490557845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 17.160144780993047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "mint.1100": {
            contrast: 22.132498101788812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.1200": {
            contrast: 26.88167170748593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.1300": {
            contrast: 32.26257050335219,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 52.5
        },
        "mint.1400": {
            contrast: 37.371931707440226,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 46.5
        },
        "mint.1500": {
            contrast: 41.75079203243929,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42.5
        },
        "mint.1600": {
            contrast: 44.70924041263235,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 40.5
        },
        "mint.1700": {
            contrast: 50.48297073807709,
            lc60: 100,
            lc45: 91,
            lc30: 65,
            lc10: 36.5
        },
        "mint.1800": {
            contrast: 56.49468187370166,
            lc60: 100,
            lc45: 83,
            lc30: 60,
            lc10: 33.5
        },
        "mint.1900": {
            contrast: 62.92425810005277,
            lc60: 96,
            lc45: 76.5,
            lc30: 55,
            lc10: 31
        },
        "mint.2000": {
            contrast: 68.45102424236099,
            lc60: 89.5,
            lc45: 71.5,
            lc30: 51.5,
            lc10: 29.5
        },
        "mint.2100": {
            contrast: 74.21024549251575,
            lc60: 84.5,
            lc45: 67.5,
            lc30: 48,
            lc10: 27
        },
        "mint.2200": {
            contrast: 79.71938058328954,
            lc60: 80,
            lc45: 63.5,
            lc30: 46,
            lc10: 26
        },
        "mint.2300": {
            contrast: 85.6124605483852,
            lc60: 76,
            lc45: 60.5,
            lc30: 44,
            lc10: 25.5
        },
        "mint.2400": {
            contrast: 91.59386388617106,
            lc60: 72,
            lc45: 58,
            lc30: 42,
            lc10: 24
        },
        "mint.2500": {
            contrast: 97.13539878917453,
            lc60: 69.5,
            lc45: 56,
            lc30: 40.5,
            lc10: 23
        }
    },
    "mint.700": {
        "mint.100": {
            contrast: 15.542188323314349,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "mint.200": {
            contrast: 15.004685948240107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "mint.300": {
            contrast: 13.300703129489886,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.400": {
            contrast: 10.926142507296307,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.500": {
            contrast: 7.370912928084773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 8.732848355408564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 13.090973645843768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 18.06332696663953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "mint.1200": {
            contrast: 22.812500572336646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "mint.1300": {
            contrast: 28.19339936820291,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "mint.1400": {
            contrast: 33.30276057229095,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 50.5
        },
        "mint.1500": {
            contrast: 37.68162089729002,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 45.5
        },
        "mint.1600": {
            contrast: 40.64006927748307,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42.5
        },
        "mint.1700": {
            contrast: 46.41379960292782,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38.5
        },
        "mint.1800": {
            contrast: 52.42551073855238,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35
        },
        "mint.1900": {
            contrast: 58.8550869649035,
            lc60: 100,
            lc45: 80.5,
            lc30: 57,
            lc10: 32
        },
        "mint.2000": {
            contrast: 64.38185310721173,
            lc60: 94.5,
            lc45: 74.5,
            lc30: 53.5,
            lc10: 30
        },
        "mint.2100": {
            contrast: 70.14107435736646,
            lc60: 88,
            lc45: 70,
            lc30: 49.5,
            lc10: 27.5
        },
        "mint.2200": {
            contrast: 75.65020944814025,
            lc60: 83,
            lc45: 66,
            lc30: 47,
            lc10: 26.5
        },
        "mint.2300": {
            contrast: 81.54328941323593,
            lc60: 78.5,
            lc45: 62,
            lc30: 45,
            lc10: 25.5
        },
        "mint.2400": {
            contrast: 87.52469275102179,
            lc60: 74.5,
            lc45: 59.5,
            lc30: 43,
            lc10: 24
        },
        "mint.2500": {
            contrast: 93.06622765402525,
            lc60: 71.5,
            lc45: 57,
            lc30: 41,
            lc10: 24
        }
    },
    "mint.800": {
        "mint.100": {
            contrast: 20.760048407004177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "mint.200": {
            contrast: 20.222546031929937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "mint.300": {
            contrast: 18.518563213179714,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "mint.400": {
            contrast: 16.14400259098614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "mint.500": {
            contrast: 12.588773011774604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.600": {
            contrast: 7.7099284586560834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 8.312949554431304,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 13.285302875227067,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 18.034476480924184,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "mint.1300": {
            contrast: 23.41537527679045,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "mint.1400": {
            contrast: 28.52473648087848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "mint.1500": {
            contrast: 32.90359680587755,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 49.5
        },
        "mint.1600": {
            contrast: 35.86204518607061,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 46
        },
        "mint.1700": {
            contrast: 41.635775511515355,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 41
        },
        "mint.1800": {
            contrast: 47.647486647139914,
            lc60: 100,
            lc45: 94.5,
            lc30: 67.5,
            lc10: 36.5
        },
        "mint.1900": {
            contrast: 54.07706287349102,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 33
        },
        "mint.2000": {
            contrast: 59.60382901579925,
            lc60: 100,
            lc45: 79,
            lc30: 56,
            lc10: 31
        },
        "mint.2100": {
            contrast: 65.363050265954,
            lc60: 93,
            lc45: 73.5,
            lc30: 52,
            lc10: 29
        },
        "mint.2200": {
            contrast: 70.87218535672778,
            lc60: 87.5,
            lc45: 69,
            lc30: 49.5,
            lc10: 27
        },
        "mint.2300": {
            contrast: 76.76526532182346,
            lc60: 82,
            lc45: 65,
            lc30: 46.5,
            lc10: 26
        },
        "mint.2400": {
            contrast: 82.74666865960933,
            lc60: 77.5,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        },
        "mint.2500": {
            contrast: 88.2882035626128,
            lc60: 74,
            lc45: 59,
            lc30: 43,
            lc10: 24
        }
    },
    "mint.900": {
        "mint.100": {
            contrast: 25.835158995897917,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40.5
        },
        "mint.200": {
            contrast: 25.297656620823677,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "mint.300": {
            contrast: 23.593673802073457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.400": {
            contrast: 21.219113179879884,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "mint.500": {
            contrast: 17.66388360066835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "mint.600": {
            contrast: 12.785039047549827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.700": {
            contrast: 8.24642890808001,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 8.501297848886177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 13.250471454583293,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 18.631370250449557,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "mint.1400": {
            contrast: 23.740731454537602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "mint.1500": {
            contrast: 28.119591779536663,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.1600": {
            contrast: 31.07804015972972,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 52
        },
        "mint.1700": {
            contrast: 36.85177048517447,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 45
        },
        "mint.1800": {
            contrast: 42.863481620799035,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 39.5
        },
        "mint.1900": {
            contrast: 49.29305784715014,
            lc60: 100,
            lc45: 92.5,
            lc30: 65,
            lc10: 35.5
        },
        "mint.2000": {
            contrast: 54.819823989458364,
            lc60: 100,
            lc45: 84.5,
            lc30: 60,
            lc10: 32.5
        },
        "mint.2100": {
            contrast: 60.579045239613116,
            lc60: 99.5,
            lc45: 78,
            lc30: 55,
            lc10: 30.5
        },
        "mint.2200": {
            contrast: 66.0881803303869,
            lc60: 92.5,
            lc45: 73,
            lc30: 51.5,
            lc10: 28.5
        },
        "mint.2300": {
            contrast: 71.98126029548257,
            lc60: 86.5,
            lc45: 68.5,
            lc30: 48.5,
            lc10: 27
        },
        "mint.2400": {
            contrast: 77.96266363326843,
            lc60: 81.5,
            lc45: 64.5,
            lc30: 46,
            lc10: 26
        },
        "mint.2500": {
            contrast: 83.5041985362719,
            lc60: 77.5,
            lc45: 62,
            lc30: 44.5,
            lc10: 25
        }
    },
    "mint.1000": {
        "mint.100": {
            contrast: 30.288960573689145,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 35.5
        },
        "mint.200": {
            contrast: 29.751458198614905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41
        },
        "mint.300": {
            contrast: 28.047475379864682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "mint.400": {
            contrast: 25.672914757671112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "mint.500": {
            contrast: 22.117685178459574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "mint.600": {
            contrast: 17.238840625341055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "mint.700": {
            contrast: 12.700230485871236,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.800": {
            contrast: 7.527303372199682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 8.955044318520242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 14.33594311438651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 19.44530431847455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "mint.1500": {
            contrast: 23.824164643473615,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "mint.1600": {
            contrast: 26.78261302366667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "mint.1700": {
            contrast: 32.556343349111415,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "mint.1800": {
            contrast: 38.56805448473598,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 43.5
        },
        "mint.1900": {
            contrast: 44.99763071108709,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38
        },
        "mint.2000": {
            contrast: 50.52439685339532,
            lc60: 100,
            lc45: 90.5,
            lc30: 64,
            lc10: 34
        },
        "mint.2100": {
            contrast: 56.28361810355006,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 31.5
        },
        "mint.2200": {
            contrast: 61.79275319432384,
            lc60: 97.5,
            lc45: 77,
            lc30: 55,
            lc10: 30
        },
        "mint.2300": {
            contrast: 67.68583315941953,
            lc60: 90.5,
            lc45: 71.5,
            lc30: 51.5,
            lc10: 28.5
        },
        "mint.2400": {
            contrast: 73.6672364972054,
            lc60: 85,
            lc45: 67.5,
            lc30: 48.5,
            lc10: 26.5
        },
        "mint.2500": {
            contrast: 79.20877140020886,
            lc60: 80.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 26.5
        }
    },
    "mint.1100": {
        "mint.100": {
            contrast: 35.303685160653096,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 31
        },
        "mint.200": {
            contrast: 34.76618278557886,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35
        },
        "mint.300": {
            contrast: 33.062199966828636,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 40
        },
        "mint.400": {
            contrast: 30.687639344635066,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 46
        },
        "mint.500": {
            contrast: 27.132409765423525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "mint.600": {
            contrast: 22.25356521230501,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "mint.700": {
            contrast: 17.71495507283519,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "mint.800": {
            contrast: 12.542027959163635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.900": {
            contrast: 7.494380865910956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 9.402596537787913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 14.511957741875955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 18.890818066875024,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "mint.1600": {
            contrast: 21.84926644706808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "mint.1700": {
            contrast: 27.622996772512824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "mint.1800": {
            contrast: 33.63470790813739,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 48.5
        },
        "mint.1900": {
            contrast: 40.064284134488496,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42
        },
        "mint.2000": {
            contrast: 45.59105027679672,
            lc60: 100,
            lc45: 98.5,
            lc30: 69.5,
            lc10: 37.5
        },
        "mint.2100": {
            contrast: 51.350271526951474,
            lc60: 100,
            lc45: 89,
            lc30: 63,
            lc10: 34.5
        },
        "mint.2200": {
            contrast: 56.85940661772526,
            lc60: 100,
            lc45: 82,
            lc30: 58.5,
            lc10: 31.5
        },
        "mint.2300": {
            contrast: 62.752486582820936,
            lc60: 96.5,
            lc45: 76,
            lc30: 54.5,
            lc10: 30
        },
        "mint.2400": {
            contrast: 68.7338899206068,
            lc60: 90,
            lc45: 71,
            lc30: 51,
            lc10: 28.5
        },
        "mint.2500": {
            contrast: 74.27542482361027,
            lc60: 85,
            lc45: 68,
            lc30: 48.5,
            lc10: 27.5
        }
    },
    "mint.1200": {
        "mint.100": {
            contrast: 40.03563213360987,
            lc60: 100,
            lc45: 100,
            lc30: 56,
            lc10: 28
        },
        "mint.200": {
            contrast: 39.49812975853563,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "mint.300": {
            contrast: 37.79414693978541,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 35.5
        },
        "mint.400": {
            contrast: 35.419586317591836,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 40
        },
        "mint.500": {
            contrast: 31.8643567383803,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 46.5
        },
        "mint.600": {
            contrast: 26.985512185261783,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "mint.700": {
            contrast: 22.446902045791965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.800": {
            contrast: 17.27397493212041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "mint.900": {
            contrast: 12.226327838867729,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1000": {
            contrast: 7.7853550139353676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 9.771408664977043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 14.150268989976109,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 17.108717370169167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "mint.1700": {
            contrast: 22.882447695613912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.1800": {
            contrast: 28.894158831238475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "mint.1900": {
            contrast: 35.32373505758958,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 47
        },
        "mint.2000": {
            contrast: 40.850501199897806,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 41.5
        },
        "mint.2100": {
            contrast: 46.60972245005256,
            lc60: 100,
            lc45: 97,
            lc30: 68.5,
            lc10: 37
        },
        "mint.2200": {
            contrast: 52.11885754082635,
            lc60: 100,
            lc45: 88.5,
            lc30: 63,
            lc10: 34.5
        },
        "mint.2300": {
            contrast: 58.01193750592202,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 32
        },
        "mint.2400": {
            contrast: 63.99334084370788,
            lc60: 94.5,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 30
        },
        "mint.2500": {
            contrast: 69.53487574671135,
            lc60: 89,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        }
    },
    "mint.1300": {
        "mint.100": {
            contrast: 45.337429153235036,
            lc60: 100,
            lc45: 91.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "mint.200": {
            contrast: 44.799926778160795,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27.5
        },
        "mint.300": {
            contrast: 43.095943959410576,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30.5
        },
        "mint.400": {
            contrast: 40.721383337217,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "mint.500": {
            contrast: 37.166153758005464,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39
        },
        "mint.600": {
            contrast: 32.28730920488695,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 45.5
        },
        "mint.700": {
            contrast: 27.748699065417128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "mint.800": {
            contrast: 22.575771951745573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "mint.900": {
            contrast: 17.528124858492895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "mint.1000": {
            contrast: 13.087152033560532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1100": {
            contrast: 8.075833414890916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 8.749044442646568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 11.707492822839624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 17.48122314828437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "mint.1800": {
            contrast: 23.492934283908937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "mint.1900": {
            contrast: 29.922510510260043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.2000": {
            contrast: 35.449276652568265,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 47
        },
        "mint.2100": {
            contrast: 41.20849790272302,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 41
        },
        "mint.2200": {
            contrast: 46.717632993496814,
            lc60: 100,
            lc45: 96.5,
            lc30: 68.5,
            lc10: 38
        },
        "mint.2300": {
            contrast: 52.61071295859247,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35.5
        },
        "mint.2400": {
            contrast: 58.592116296378336,
            lc60: 100,
            lc45: 81,
            lc30: 58.5,
            lc10: 32.5
        },
        "mint.2500": {
            contrast: 64.1336511993818,
            lc60: 95,
            lc45: 76,
            lc30: 55,
            lc10: 31.5
        }
    },
    "mint.1400": {
        "mint.100": {
            contrast: 50.31973199864909,
            lc60: 100,
            lc45: 71.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "mint.200": {
            contrast: 49.78222962357486,
            lc60: 100,
            lc45: 79.5,
            lc30: 49.5,
            lc10: 25
        },
        "mint.300": {
            contrast: 48.07824680482463,
            lc60: 100,
            lc45: 88,
            lc30: 55,
            lc10: 27.5
        },
        "mint.400": {
            contrast: 45.70368618263105,
            lc60: 100,
            lc45: 97,
            lc30: 60.5,
            lc10: 30.5
        },
        "mint.500": {
            contrast: 42.14845660341952,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 34
        },
        "mint.600": {
            contrast: 37.269612050301006,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "mint.700": {
            contrast: 32.73100191083118,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45.5
        },
        "mint.800": {
            contrast: 27.558074797159627,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.900": {
            contrast: 22.510427703906945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "mint.1000": {
            contrast: 18.069454878974586,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "mint.1100": {
            contrast: 13.05813626030497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1200": {
            contrast: 8.31984078384158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 12.325899591766953,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 18.337610727391517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "mint.1900": {
            contrast: 24.767186953742623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "mint.2000": {
            contrast: 30.293953096050846,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "mint.2100": {
            contrast: 36.053174346205594,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 46.5
        },
        "mint.2200": {
            contrast: 41.56230943697939,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "mint.2300": {
            contrast: 47.455389402075056,
            lc60: 100,
            lc45: 95,
            lc30: 69,
            lc10: 38.5
        },
        "mint.2400": {
            contrast: 53.43679273986092,
            lc60: 100,
            lc45: 87,
            lc30: 63.5,
            lc10: 35.5
        },
        "mint.2500": {
            contrast: 58.97832764286439,
            lc60: 100,
            lc45: 81.5,
            lc30: 60,
            lc10: 33.5
        }
    },
    "mint.1500": {
        "mint.100": {
            contrast: 54.55349301201987,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 20.5
        },
        "mint.200": {
            contrast: 54.015990636945624,
            lc60: 100,
            lc45: 71,
            lc30: 45.5,
            lc10: 23
        },
        "mint.300": {
            contrast: 52.312007818195404,
            lc60: 100,
            lc45: 78.5,
            lc30: 50,
            lc10: 25
        },
        "mint.400": {
            contrast: 49.93744719600183,
            lc60: 100,
            lc45: 86,
            lc30: 55,
            lc10: 27.5
        },
        "mint.500": {
            contrast: 46.382217616790285,
            lc60: 100,
            lc45: 96,
            lc30: 61.5,
            lc10: 30.5
        },
        "mint.600": {
            contrast: 41.50337306367177,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "mint.700": {
            contrast: 36.96476292420195,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40
        },
        "mint.800": {
            contrast: 31.791835810530394,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 47
        },
        "mint.900": {
            contrast: 26.744188717277716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.1000": {
            contrast: 22.303215892345353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "mint.1100": {
            contrast: 17.291897273675737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "mint.1200": {
            contrast: 12.55360179721235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 7.888801080521635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 13.900512216146199,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 20.330088442497303,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "mint.2000": {
            contrast: 25.85685458480553,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2100": {
            contrast: 31.616075834960277,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 52.5
        },
        "mint.2200": {
            contrast: 37.12521092573407,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 45.5
        },
        "mint.2300": {
            contrast: 43.01829089082973,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41.5
        },
        "mint.2400": {
            contrast: 48.999694228615596,
            lc60: 100,
            lc45: 93.5,
            lc30: 67.5,
            lc10: 37.5
        },
        "mint.2500": {
            contrast: 54.54122913161906,
            lc60: 100,
            lc45: 85.5,
            lc30: 63,
            lc10: 35
        }
    },
    "mint.1600": {
        "mint.100": {
            contrast: 57.39648027702011,
            lc60: 100,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 20
        },
        "mint.200": {
            contrast: 56.85897790194587,
            lc60: 100,
            lc45: 67,
            lc30: 43,
            lc10: 22
        },
        "mint.300": {
            contrast: 55.154995083195644,
            lc60: 100,
            lc45: 73.5,
            lc30: 47.5,
            lc10: 24
        },
        "mint.400": {
            contrast: 52.780434461002066,
            lc60: 100,
            lc45: 80,
            lc30: 52,
            lc10: 26.5
        },
        "mint.500": {
            contrast: 49.22520488179054,
            lc60: 100,
            lc45: 89,
            lc30: 57.5,
            lc10: 29.5
        },
        "mint.600": {
            contrast: 44.34636032867202,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "mint.700": {
            contrast: 39.8077501892022,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "mint.800": {
            contrast: 34.63482307553065,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 44
        },
        "mint.900": {
            contrast: 29.587175982277962,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "mint.1000": {
            contrast: 25.1462031573456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.1100": {
            contrast: 20.134884538675987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "mint.1200": {
            contrast: 15.396589062212595,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "mint.1300": {
            contrast: 10.07778139388712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 10.893545085204604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 17.32312131155571,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "mint.2000": {
            contrast: 22.849887453863936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "mint.2100": {
            contrast: 28.609108704018688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "mint.2200": {
            contrast: 34.11824379479248,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 49.5
        },
        "mint.2300": {
            contrast: 40.01132375988814,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44
        },
        "mint.2400": {
            contrast: 45.992727097674006,
            lc60: 100,
            lc45: 98,
            lc30: 70.5,
            lc10: 40
        },
        "mint.2500": {
            contrast: 51.534262000677465,
            lc60: 100,
            lc45: 90.5,
            lc30: 65.5,
            lc10: 38
        }
    },
    "mint.1700": {
        "mint.100": {
            contrast: 62.90748120982007,
            lc60: 81.5,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "mint.200": {
            contrast: 62.36997883474583,
            lc60: 89,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "mint.300": {
            contrast: 60.6659960159956,
            lc60: 97,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "mint.400": {
            contrast: 58.291435393802026,
            lc60: 100,
            lc45: 72,
            lc30: 46,
            lc10: 24
        },
        "mint.500": {
            contrast: 54.7362058145905,
            lc60: 100,
            lc45: 79,
            lc30: 51,
            lc10: 26
        },
        "mint.600": {
            contrast: 49.85736126147198,
            lc60: 100,
            lc45: 89,
            lc30: 57,
            lc10: 29.5
        },
        "mint.700": {
            contrast: 45.31875112200216,
            lc60: 100,
            lc45: 99.5,
            lc30: 64,
            lc10: 33
        },
        "mint.800": {
            contrast: 40.14582400833061,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 38
        },
        "mint.900": {
            contrast: 35.09817691507792,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 42.5
        },
        "mint.1000": {
            contrast: 30.657204090145555,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 49
        },
        "mint.1100": {
            contrast: 25.645885471475943,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "mint.1200": {
            contrast: 20.907589995012554,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.1300": {
            contrast: 15.588782326687078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "mint.1400": {
            contrast: 10.581844589888226,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 11.434815497741054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 16.96158164004928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "mint.2100": {
            contrast: 22.72080289020403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "mint.2200": {
            contrast: 28.22993798097782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "mint.2300": {
            contrast: 34.12301794607348,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49.5
        },
        "mint.2400": {
            contrast: 40.104421283859345,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 44.5
        },
        "mint.2500": {
            contrast: 45.64595618686281,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 41
        }
    },
    "mint.1800": {
        "mint.100": {
            contrast: 68.59724499616141,
            lc60: 71,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 17
        },
        "mint.200": {
            contrast: 68.05974262108718,
            lc60: 77,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "mint.300": {
            contrast: 66.35575980233695,
            lc60: 83.5,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 20
        },
        "mint.400": {
            contrast: 63.98119918014336,
            lc60: 90,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "mint.500": {
            contrast: 60.425969600931836,
            lc60: 98.5,
            lc45: 70.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "mint.600": {
            contrast: 55.54712504781332,
            lc60: 100,
            lc45: 77.5,
            lc30: 51,
            lc10: 26
        },
        "mint.700": {
            contrast: 51.00851490834351,
            lc60: 100,
            lc45: 86,
            lc30: 56.5,
            lc10: 29
        },
        "mint.800": {
            contrast: 45.835587794671945,
            lc60: 100,
            lc45: 97.5,
            lc30: 64,
            lc10: 33
        },
        "mint.900": {
            contrast: 40.78794070141926,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 36.5
        },
        "mint.1000": {
            contrast: 36.3469678764869,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41.5
        },
        "mint.1100": {
            contrast: 31.335649257817284,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 48.5
        },
        "mint.1200": {
            contrast: 26.597353781353895,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "mint.1300": {
            contrast: 21.278546113028423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "mint.1400": {
            contrast: 16.27160837622957,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "mint.1500": {
            contrast: 12.010869933583818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1600": {
            contrast: 9.146850751137842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 10.804558255759336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 16.563779505914088,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "mint.2200": {
            contrast: 22.07291459668788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72
        },
        "mint.2300": {
            contrast: 27.965994561783543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "mint.2400": {
            contrast: 33.9473978995694,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "mint.2500": {
            contrast: 39.48893280257287,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 45.5
        }
    },
    "mint.1900": {
        "mint.100": {
            contrast: 74.63279773458746,
            lc60: 64.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "mint.200": {
            contrast: 74.09529535951322,
            lc60: 69.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "mint.300": {
            contrast: 72.39131254076298,
            lc60: 75,
            lc45: 54,
            lc30: 35.5,
            lc10: 18
        },
        "mint.400": {
            contrast: 70.0167519185694,
            lc60: 80.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "mint.500": {
            contrast: 66.46152233935787,
            lc60: 87.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "mint.600": {
            contrast: 61.58267778623935,
            lc60: 96.5,
            lc45: 69,
            lc30: 45,
            lc10: 23.5
        },
        "mint.700": {
            contrast: 57.044067646769534,
            lc60: 100,
            lc45: 76,
            lc30: 49.5,
            lc10: 26
        },
        "mint.800": {
            contrast: 51.87114053309798,
            lc60: 100,
            lc45: 85,
            lc30: 55.5,
            lc10: 28
        },
        "mint.900": {
            contrast: 46.8234934398453,
            lc60: 100,
            lc45: 95.5,
            lc30: 62,
            lc10: 31.5
        },
        "mint.1000": {
            contrast: 42.382520614912934,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35.5
        },
        "mint.1100": {
            contrast: 37.37120199624332,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40.5
        },
        "mint.1200": {
            contrast: 32.63290651977992,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 47
        },
        "mint.1300": {
            contrast: 27.31409885145445,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.1400": {
            contrast: 22.307161114655603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "mint.1500": {
            contrast: 18.04642267200985,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "mint.1600": {
            contrast: 15.182403489563875,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "mint.1700": {
            contrast: 9.624373971937883,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 9.951735544010331,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 15.460870634784122,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "mint.2300": {
            contrast: 21.353950599879784,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "mint.2400": {
            contrast: 27.335353937665648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2500": {
            contrast: 32.87688884066911,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 54
        }
    },
    "mint.2000": {
        "mint.100": {
            contrast: 79.78320356621668,
            lc60: 59.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "mint.200": {
            contrast: 79.24570119114244,
            lc60: 64.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 15.5
        },
        "mint.300": {
            contrast: 77.54171837239221,
            lc60: 69,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "mint.400": {
            contrast: 75.16715775019864,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "mint.500": {
            contrast: 71.6119281709871,
            lc60: 80,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "mint.600": {
            contrast: 66.73308361786859,
            lc60: 87.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "mint.700": {
            contrast: 62.19447347839877,
            lc60: 95,
            lc45: 69,
            lc30: 45.5,
            lc10: 23.5
        },
        "mint.800": {
            contrast: 57.021546364727214,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 26
        },
        "mint.900": {
            contrast: 51.97389927147454,
            lc60: 100,
            lc45: 84.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "mint.1000": {
            contrast: 47.53292644654218,
            lc60: 100,
            lc45: 93.5,
            lc30: 61.5,
            lc10: 31.5
        },
        "mint.1100": {
            contrast: 42.52160782787256,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "mint.1200": {
            contrast: 37.783312351409165,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40.5
        },
        "mint.1300": {
            contrast: 32.46450468308369,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 46
        },
        "mint.1400": {
            contrast: 27.45756694628484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "mint.1500": {
            contrast: 23.196828503639093,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "mint.1600": {
            contrast: 20.332809321193114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "mint.1700": {
            contrast: 14.774779803567123,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1800": {
            contrast: 9.028356768949337,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 9.756518685674374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 15.649598650770036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "mint.2400": {
            contrast: 21.631001988555905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "mint.2500": {
            contrast: 27.17253689155936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        }
    },
    "mint.2100": {
        "mint.100": {
            contrast: 85.1159964267422,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "mint.200": {
            contrast: 84.57849405166796,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "mint.300": {
            contrast: 82.87451123291773,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 15.5
        },
        "mint.400": {
            contrast: 80.49995061072414,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "mint.500": {
            contrast: 76.94472103151261,
            lc60: 73,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "mint.600": {
            contrast: 72.0658764783941,
            lc60: 79.5,
            lc45: 57.5,
            lc30: 38,
            lc10: 20
        },
        "mint.700": {
            contrast: 67.52726633892429,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 41,
            lc10: 21.5
        },
        "mint.800": {
            contrast: 62.35433922525273,
            lc60: 95,
            lc45: 69,
            lc30: 45.5,
            lc10: 23
        },
        "mint.900": {
            contrast: 57.30669213200006,
            lc60: 100,
            lc45: 75.5,
            lc30: 49.5,
            lc10: 25.5
        },
        "mint.1000": {
            contrast: 52.865719307067685,
            lc60: 100,
            lc45: 83,
            lc30: 54.5,
            lc10: 28
        },
        "mint.1100": {
            contrast: 47.854400688398066,
            lc60: 100,
            lc45: 93,
            lc30: 60.5,
            lc10: 31
        },
        "mint.1200": {
            contrast: 43.11610521193468,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "mint.1300": {
            contrast: 37.797297543609204,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40
        },
        "mint.1400": {
            contrast: 32.79035980681035,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 45
        },
        "mint.1500": {
            contrast: 28.529621364164605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "mint.1600": {
            contrast: 25.665602181718626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "mint.1700": {
            contrast: 20.107572664092636,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "mint.1800": {
            contrast: 14.361149629474848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.1900": {
            contrast: 8.25715722285998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 9.686271093108601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 15.667674430894468,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "mint.2500": {
            contrast: 21.20920933389793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        }
    },
    "mint.2200": {
        "mint.100": {
            contrast: 90.18672274297299,
            lc60: 52,
            lc45: 38,
            lc30: 25,
            lc10: 13
        },
        "mint.200": {
            contrast: 89.64922036789875,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "mint.300": {
            contrast: 87.94523754914852,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "mint.400": {
            contrast: 85.57067692695493,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "mint.500": {
            contrast: 82.0154473477434,
            lc60: 67,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "mint.600": {
            contrast: 77.13660279462489,
            lc60: 73.5,
            lc45: 53,
            lc30: 35,
            lc10: 18.5
        },
        "mint.700": {
            contrast: 72.59799265515508,
            lc60: 79,
            lc45: 57.5,
            lc30: 38,
            lc10: 19.5
        },
        "mint.800": {
            contrast: 67.42506554148352,
            lc60: 86.5,
            lc45: 62.5,
            lc30: 41,
            lc10: 21.5
        },
        "mint.900": {
            contrast: 62.37741844823083,
            lc60: 95.5,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 23.5
        },
        "mint.1000": {
            contrast: 57.93644562329847,
            lc60: 100,
            lc45: 74.5,
            lc30: 49,
            lc10: 25
        },
        "mint.1100": {
            contrast: 52.925127004628855,
            lc60: 100,
            lc45: 83,
            lc30: 53.5,
            lc10: 28
        },
        "mint.1200": {
            contrast: 48.18683152816546,
            lc60: 100,
            lc45: 92,
            lc30: 59.5,
            lc10: 30
        },
        "mint.1300": {
            contrast: 42.86802385983999,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "mint.1400": {
            contrast: 37.86108612304114,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 38.5
        },
        "mint.1500": {
            contrast: 33.60034768039539,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 44
        },
        "mint.1600": {
            contrast: 30.736328497949412,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 49
        },
        "mint.1700": {
            contrast: 25.178298980323422,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "mint.1800": {
            contrast: 19.431875945705638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "mint.1900": {
            contrast: 13.32788353909077,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2000": {
            contrast: 8.112745158537605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 9.946168905087852,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 15.487703808091313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        }
    },
    "mint.2300": {
        "mint.100": {
            contrast: 95.57996718000533,
            lc60: 49,
            lc45: 36,
            lc30: 23.5,
            lc10: 12.5
        },
        "mint.200": {
            contrast: 95.04246480493109,
            lc60: 52.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "mint.300": {
            contrast: 93.33848198618085,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "mint.400": {
            contrast: 90.96392136398728,
            lc60: 58.5,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "mint.500": {
            contrast: 87.40869178477575,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 16
        },
        "mint.600": {
            contrast: 82.52984723165723,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "mint.700": {
            contrast: 77.99123709218742,
            lc60: 72,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "mint.800": {
            contrast: 72.81830997851586,
            lc60: 78.5,
            lc45: 57,
            lc30: 37.5,
            lc10: 20
        },
        "mint.900": {
            contrast: 67.77066288526316,
            lc60: 86,
            lc45: 62,
            lc30: 40.5,
            lc10: 21
        },
        "mint.1000": {
            contrast: 63.32969006033081,
            lc60: 93.5,
            lc45: 67,
            lc30: 44,
            lc10: 23
        },
        "mint.1100": {
            contrast: 58.3183714416612,
            lc60: 100,
            lc45: 73,
            lc30: 48,
            lc10: 24.5
        },
        "mint.1200": {
            contrast: 53.58007596519781,
            lc60: 100,
            lc45: 81.5,
            lc30: 52.5,
            lc10: 27
        },
        "mint.1300": {
            contrast: 48.26126829687233,
            lc60: 100,
            lc45: 91,
            lc30: 58.5,
            lc10: 30
        },
        "mint.1400": {
            contrast: 43.25433056007348,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "mint.1500": {
            contrast: 38.99359211742773,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "mint.1600": {
            contrast: 36.12957293498175,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 40.5
        },
        "mint.1700": {
            contrast: 30.571543417355763,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 48
        },
        "mint.1800": {
            contrast: 24.82512038273798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "mint.1900": {
            contrast: 18.721127976123107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "mint.2000": {
            contrast: 13.505989595569945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2100": {
            contrast: 8.100409077088306,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 9.349960366753612,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "mint.2400": {
        "mint.100": {
            contrast: 101.02342835624228,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "mint.200": {
            contrast: 100.48592598116804,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "mint.300": {
            contrast: 98.78194316241779,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "mint.400": {
            contrast: 96.4073825402242,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "mint.500": {
            contrast: 92.85215296101268,
            lc60: 57.5,
            lc45: 42.5,
            lc30: 28.5,
            lc10: 15
        },
        "mint.600": {
            contrast: 87.97330840789415,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "mint.700": {
            contrast: 83.43469826842434,
            lc60: 66.5,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "mint.800": {
            contrast: 78.26177115475278,
            lc60: 72,
            lc45: 52,
            lc30: 34.5,
            lc10: 18
        },
        "mint.900": {
            contrast: 73.2141240615001,
            lc60: 78,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "mint.1000": {
            contrast: 68.77315123656774,
            lc60: 83.5,
            lc45: 60.5,
            lc30: 40,
            lc10: 20.5
        },
        "mint.1100": {
            contrast: 63.761832617898115,
            lc60: 92.5,
            lc45: 65.5,
            lc30: 43,
            lc10: 22.5
        },
        "mint.1200": {
            contrast: 59.02353714143474,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 24
        },
        "mint.1300": {
            contrast: 53.70472947310926,
            lc60: 100,
            lc45: 80,
            lc30: 51,
            lc10: 26
        },
        "mint.1400": {
            contrast: 48.6977917363104,
            lc60: 100,
            lc45: 90.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "mint.1500": {
            contrast: 44.437053293664654,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "mint.1600": {
            contrast: 41.573034111218675,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34.5
        },
        "mint.1700": {
            contrast: 36.015004593592685,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 40
        },
        "mint.1800": {
            contrast: 30.2685815589749,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 48
        },
        "mint.1900": {
            contrast: 24.164589152360037,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2000": {
            contrast: 18.94945077180687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "mint.2100": {
            contrast: 13.54387025332523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2200": {
            contrast: 8.398793595681086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "mint.2500": {
        "mint.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "mint.200": {
            contrast: 105.50317083761438,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "mint.300": {
            contrast: 103.79918801886414,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "mint.400": {
            contrast: 101.42462739667056,
            lc60: 51.5,
            lc45: 37.5,
            lc30: 25,
            lc10: 13.5
        },
        "mint.500": {
            contrast: 97.86939781745902,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "mint.600": {
            contrast: 92.9905532643405,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "mint.700": {
            contrast: 88.45194312487068,
            lc60: 61.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "mint.800": {
            contrast: 83.27901601119912,
            lc60: 66.5,
            lc45: 48,
            lc30: 32,
            lc10: 17
        },
        "mint.900": {
            contrast: 78.23136891794645,
            lc60: 71,
            lc45: 52,
            lc30: 34,
            lc10: 18
        },
        "mint.1000": {
            contrast: 73.79039609301408,
            lc60: 76.5,
            lc45: 55.5,
            lc30: 36.5,
            lc10: 18.5
        },
        "mint.1100": {
            contrast: 68.77907747434446,
            lc60: 83,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "mint.1200": {
            contrast: 64.04078199788108,
            lc60: 92,
            lc45: 64.5,
            lc30: 42,
            lc10: 21.5
        },
        "mint.1300": {
            contrast: 58.72197432955561,
            lc60: 100,
            lc45: 71,
            lc30: 45.5,
            lc10: 23.5
        },
        "mint.1400": {
            contrast: 53.715036592756746,
            lc60: 100,
            lc45: 79,
            lc30: 49.5,
            lc10: 25.5
        },
        "mint.1500": {
            contrast: 49.454298150111,
            lc60: 100,
            lc45: 88.5,
            lc30: 55,
            lc10: 28.5
        },
        "mint.1600": {
            contrast: 46.59027896766502,
            lc60: 100,
            lc45: 94.5,
            lc30: 58.5,
            lc10: 29.5
        },
        "mint.1700": {
            contrast: 41.03224945003903,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "mint.1800": {
            contrast: 35.28582641542125,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40
        },
        "mint.1900": {
            contrast: 29.18183400880638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "mint.2000": {
            contrast: 23.966695628253213,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "mint.2100": {
            contrast: 18.561115109771578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "mint.2200": {
            contrast: 13.416038452127433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2300": {
            contrast: 7.938506181199497,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "mint.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$negative = {
    "negative.100": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 8.858041284614874,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 12.791498070046686,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 17.221272923749474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "negative.900": {
            contrast: 21.509851438930742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "negative.1000": {
            contrast: 25.56157036127881,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.1100": {
            contrast: 29.800614311126942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "negative.1200": {
            contrast: 35.20346068108589,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 63.5
        },
        "negative.1300": {
            contrast: 38.5347780100951,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 60.5
        },
        "negative.1400": {
            contrast: 42.60954031789987,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 57
        },
        "negative.1500": {
            contrast: 47.24732667747278,
            lc60: 100,
            lc45: 97,
            lc30: 77,
            lc10: 53.5
        },
        "negative.1600": {
            contrast: 52.36263284181245,
            lc60: 100,
            lc45: 91,
            lc30: 72,
            lc10: 50
        },
        "negative.1700": {
            contrast: 57.63719359842978,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 47
        },
        "negative.1800": {
            contrast: 63.12093302842009,
            lc60: 97,
            lc45: 81.5,
            lc30: 64.5,
            lc10: 44.5
        },
        "negative.1900": {
            contrast: 69.016780808529,
            lc60: 91.5,
            lc45: 77,
            lc30: 61,
            lc10: 42.5
        },
        "negative.2000": {
            contrast: 74.9150630272176,
            lc60: 87,
            lc45: 73.5,
            lc30: 58,
            lc10: 40
        },
        "negative.2100": {
            contrast: 81.4063209386647,
            lc60: 82.5,
            lc45: 69.5,
            lc30: 55,
            lc10: 38
        },
        "negative.2200": {
            contrast: 87.81825720622926,
            lc60: 78.5,
            lc45: 66,
            lc30: 52.5,
            lc10: 36.5
        },
        "negative.2300": {
            contrast: 94.06194075214171,
            lc60: 75.5,
            lc45: 63.5,
            lc30: 50,
            lc10: 35
        },
        "negative.2400": {
            contrast: 101.21944681618791,
            lc60: 72,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 33.5
        },
        "negative.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "negative.200": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 8.329638774416665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 12.263095559848477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 16.692870413551265,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "negative.900": {
            contrast: 20.981448928732533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "negative.1000": {
            contrast: 25.033167851080606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "negative.1100": {
            contrast: 29.272211800928737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "negative.1200": {
            contrast: 34.67505817088769,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 59
        },
        "negative.1300": {
            contrast: 38.00637549989689,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 56
        },
        "negative.1400": {
            contrast: 42.081137807701666,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 52.5
        },
        "negative.1500": {
            contrast: 46.718924167274565,
            lc60: 100,
            lc45: 97.5,
            lc30: 74.5,
            lc10: 49
        },
        "negative.1600": {
            contrast: 51.834230331614236,
            lc60: 100,
            lc45: 91,
            lc30: 70,
            lc10: 46.5
        },
        "negative.1700": {
            contrast: 57.10879108823157,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 44
        },
        "negative.1800": {
            contrast: 62.592530518221864,
            lc60: 97,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 41.5
        },
        "negative.1900": {
            contrast: 68.48837829833079,
            lc60: 91.5,
            lc45: 76,
            lc30: 59,
            lc10: 39
        },
        "negative.2000": {
            contrast: 74.3866605170194,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "negative.2100": {
            contrast: 80.87791842846649,
            lc60: 82,
            lc45: 68.5,
            lc30: 53,
            lc10: 36
        },
        "negative.2200": {
            contrast: 87.28985469603106,
            lc60: 78,
            lc45: 65,
            lc30: 50.5,
            lc10: 34
        },
        "negative.2300": {
            contrast: 93.53353824194349,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 33
        },
        "negative.2400": {
            contrast: 100.69104430598968,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "negative.2500": {
            contrast: 107.35633067290024,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "negative.300": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 10.888541479345054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 15.318316333047843,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "negative.900": {
            contrast: 19.60689484822911,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "negative.1000": {
            contrast: 23.658613770577183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "negative.1100": {
            contrast: 27.897657720425308,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "negative.1200": {
            contrast: 33.30050409038426,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 57
        },
        "negative.1300": {
            contrast: 36.63182141939346,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 54
        },
        "negative.1400": {
            contrast: 40.70658372719823,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 50.5
        },
        "negative.1500": {
            contrast: 45.34437008677114,
            lc60: 100,
            lc45: 99,
            lc30: 75,
            lc10: 47.5
        },
        "negative.1600": {
            contrast: 50.45967625111082,
            lc60: 100,
            lc45: 92.5,
            lc30: 70,
            lc10: 44.5
        },
        "negative.1700": {
            contrast: 55.73423700772815,
            lc60: 100,
            lc45: 86.5,
            lc30: 66,
            lc10: 42.5
        },
        "negative.1800": {
            contrast: 61.21797643771845,
            lc60: 98.5,
            lc45: 81.5,
            lc30: 62,
            lc10: 40.5
        },
        "negative.1900": {
            contrast: 67.11382421782737,
            lc60: 92.5,
            lc45: 77,
            lc30: 59,
            lc10: 38.5
        },
        "negative.2000": {
            contrast: 73.01210643651596,
            lc60: 87.5,
            lc45: 72.5,
            lc30: 56,
            lc10: 37
        },
        "negative.2100": {
            contrast: 79.50336434796307,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 34.5
        },
        "negative.2200": {
            contrast: 85.91530061552763,
            lc60: 79,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "negative.2300": {
            contrast: 92.15898416144007,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 32
        },
        "negative.2400": {
            contrast: 99.31649022548625,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31
        },
        "negative.2500": {
            contrast: 105.98177659239683,
            lc60: 69,
            lc45: 57,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "negative.400": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 9.05705529045204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 13.486830144154824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 17.775408659336094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "negative.1000": {
            contrast: 21.827127581684167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "negative.1100": {
            contrast: 26.06617153153229,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "negative.1200": {
            contrast: 31.46901790149124,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 57.5
        },
        "negative.1300": {
            contrast: 34.800335230500444,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 53
        },
        "negative.1400": {
            contrast: 38.87509753830521,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 50
        },
        "negative.1500": {
            contrast: 43.512883897878126,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47
        },
        "negative.1600": {
            contrast: 48.628190062217804,
            lc60: 100,
            lc45: 94.5,
            lc30: 71,
            lc10: 44.5
        },
        "negative.1700": {
            contrast: 53.90275081883513,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "negative.1800": {
            contrast: 59.38649024882543,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 39.5
        },
        "negative.1900": {
            contrast: 65.28233802893436,
            lc60: 94,
            lc45: 78,
            lc30: 59,
            lc10: 37.5
        },
        "negative.2000": {
            contrast: 71.18062024762295,
            lc60: 89,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 36
        },
        "negative.2100": {
            contrast: 77.67187815907006,
            lc60: 84,
            lc45: 69.5,
            lc30: 53,
            lc10: 34.5
        },
        "negative.2200": {
            contrast: 84.0838144266346,
            lc60: 79.5,
            lc45: 66,
            lc30: 50.5,
            lc10: 33
        },
        "negative.2300": {
            contrast: 90.32749797254705,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 31.5
        },
        "negative.2400": {
            contrast: 97.48500403659325,
            lc60: 72.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 30
        },
        "negative.2500": {
            contrast: 104.15029040350383,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29
        }
    },
    "negative.500": {
        "negative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 10.789857796462519,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 15.078436311643785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1000": {
            contrast: 19.130155233991864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "negative.1100": {
            contrast: 23.369199183839992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "negative.1200": {
            contrast: 28.772045553798936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "negative.1300": {
            contrast: 32.10336288280814,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 54.5
        },
        "negative.1400": {
            contrast: 36.17812519061292,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 51.5
        },
        "negative.1500": {
            contrast: 40.81591155018582,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 48
        },
        "negative.1600": {
            contrast: 45.931217714525495,
            lc60: 100,
            lc45: 98.5,
            lc30: 73.5,
            lc10: 45
        },
        "negative.1700": {
            contrast: 51.20577847114283,
            lc60: 100,
            lc45: 91.5,
            lc30: 69,
            lc10: 43
        },
        "negative.1800": {
            contrast: 56.68951790113312,
            lc60: 100,
            lc45: 85,
            lc30: 64.5,
            lc10: 40.5
        },
        "negative.1900": {
            contrast: 62.585365681242045,
            lc60: 97,
            lc45: 79.5,
            lc30: 61,
            lc10: 38.5
        },
        "negative.2000": {
            contrast: 68.48364789993063,
            lc60: 91.5,
            lc45: 75.5,
            lc30: 58,
            lc10: 36.5
        },
        "negative.2100": {
            contrast: 74.97490581137775,
            lc60: 86,
            lc45: 71.5,
            lc30: 54.5,
            lc10: 35
        },
        "negative.2200": {
            contrast: 81.3868420789423,
            lc60: 81.5,
            lc45: 67.5,
            lc30: 52,
            lc10: 33.5
        },
        "negative.2300": {
            contrast: 87.63052562485474,
            lc60: 77.5,
            lc45: 64.5,
            lc30: 49.5,
            lc10: 32.5
        },
        "negative.2400": {
            contrast: 94.78803168890092,
            lc60: 74,
            lc45: 61.5,
            lc30: 47.5,
            lc10: 31
        },
        "negative.2500": {
            contrast: 101.45331805581151,
            lc60: 71,
            lc45: 59,
            lc30: 45.5,
            lc10: 29.5
        }
    },
    "negative.600": {
        "negative.100": {
            contrast: 10.264210249605032,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 9.55707843590558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 7.768227636409695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 11.352603892090698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 15.404322814438775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "negative.1100": {
            contrast: 19.643366764286903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "negative.1200": {
            contrast: 25.04621313424585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "negative.1300": {
            contrast: 28.377530463255052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "negative.1400": {
            contrast: 32.452292771059824,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 55
        },
        "negative.1500": {
            contrast: 37.09007913063273,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 51.5
        },
        "negative.1600": {
            contrast: 42.20538529497241,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 47.5
        },
        "negative.1700": {
            contrast: 47.479946051589735,
            lc60: 100,
            lc45: 96.5,
            lc30: 72.5,
            lc10: 44.5
        },
        "negative.1800": {
            contrast: 52.963685481580036,
            lc60: 100,
            lc45: 89.5,
            lc30: 68,
            lc10: 42.5
        },
        "negative.1900": {
            contrast: 58.85953326168896,
            lc60: 100,
            lc45: 83.5,
            lc30: 64,
            lc10: 40.5
        },
        "negative.2000": {
            contrast: 64.75781548037756,
            lc60: 94.5,
            lc45: 78.5,
            lc30: 60,
            lc10: 38.5
        },
        "negative.2100": {
            contrast: 71.24907339182465,
            lc60: 89,
            lc45: 74,
            lc30: 57,
            lc10: 36.5
        },
        "negative.2200": {
            contrast: 77.66100965938921,
            lc60: 84.5,
            lc45: 70,
            lc30: 54,
            lc10: 35
        },
        "negative.2300": {
            contrast: 83.90469320530165,
            lc60: 80,
            lc45: 66.5,
            lc30: 51.5,
            lc10: 33.5
        },
        "negative.2400": {
            contrast: 91.06219926934783,
            lc60: 76,
            lc45: 63.5,
            lc30: 49,
            lc10: 32
        },
        "negative.2500": {
            contrast: 97.72748563625841,
            lc60: 73,
            lc45: 60.5,
            lc30: 47,
            lc10: 30.5
        }
    },
    "negative.700": {
        "negative.100": {
            contrast: 14.537898269828217,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.200": {
            contrast: 13.830766456128766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.300": {
            contrast: 12.041915656632879,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.400": {
            contrast: 9.744059489512878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 7.5926120739504634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 11.644330996298539,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 15.883374946146667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "negative.1200": {
            contrast: 21.286221316105618,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "negative.1300": {
            contrast: 24.61753864511482,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "negative.1400": {
            contrast: 28.69230095291959,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "negative.1500": {
            contrast: 33.3300873124925,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 55.5
        },
        "negative.1600": {
            contrast: 38.445393476832166,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 51.5
        },
        "negative.1700": {
            contrast: 43.7199542334495,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 48.5
        },
        "negative.1800": {
            contrast: 49.20369366343979,
            lc60: 100,
            lc45: 94,
            lc30: 72,
            lc10: 45
        },
        "negative.1900": {
            contrast: 55.099541443548716,
            lc60: 100,
            lc45: 87,
            lc30: 67.5,
            lc10: 42.5
        },
        "negative.2000": {
            contrast: 60.997823662237316,
            lc60: 99,
            lc45: 82,
            lc30: 63.5,
            lc10: 41
        },
        "negative.2100": {
            contrast: 67.48908157368442,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 39
        },
        "negative.2200": {
            contrast: 73.90101784124899,
            lc60: 87.5,
            lc45: 73,
            lc30: 56.5,
            lc10: 36.5
        },
        "negative.2300": {
            contrast: 80.14470138716142,
            lc60: 83,
            lc45: 69.5,
            lc30: 54,
            lc10: 35
        },
        "negative.2400": {
            contrast: 87.30220745120761,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 33.5
        },
        "negative.2500": {
            contrast: 93.96749381811817,
            lc60: 75,
            lc45: 63,
            lc30: 49,
            lc10: 32
        }
    },
    "negative.800": {
        "negative.100": {
            contrast: 19.248957750358333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "negative.200": {
            contrast: 18.54182593665888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "negative.300": {
            contrast: 16.752975137162995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "negative.400": {
            contrast: 14.455118970042994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.500": {
            contrast: 11.1977214105761,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 7.364381520827498,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 11.603425470675626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 17.006271840634575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "negative.1300": {
            contrast: 20.33758916964378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "negative.1400": {
            contrast: 24.41235147744855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "negative.1500": {
            contrast: 29.050137837021456,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "negative.1600": {
            contrast: 34.16544400136113,
            lc60: 100,
            lc45: 100,
            lc30: 91,
            lc10: 57
        },
        "negative.1700": {
            contrast: 39.44000475797846,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 52.5
        },
        "negative.1800": {
            contrast: 44.923744187968765,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 49
        },
        "negative.1900": {
            contrast: 50.81959196807768,
            lc60: 100,
            lc45: 92.5,
            lc30: 71.5,
            lc10: 46
        },
        "negative.2000": {
            contrast: 56.717874186766274,
            lc60: 100,
            lc45: 86,
            lc30: 67,
            lc10: 44
        },
        "negative.2100": {
            contrast: 63.209132098213374,
            lc60: 96.5,
            lc45: 80.5,
            lc30: 63.5,
            lc10: 41.5
        },
        "negative.2200": {
            contrast: 69.62106836577794,
            lc60: 91,
            lc45: 76.5,
            lc30: 59.5,
            lc10: 39.5
        },
        "negative.2300": {
            contrast: 75.86475191169038,
            lc60: 86.5,
            lc45: 72.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "negative.2400": {
            contrast: 83.02225797573655,
            lc60: 81.5,
            lc45: 68.5,
            lc30: 54,
            lc10: 36
        },
        "negative.2500": {
            contrast: 89.68754434264713,
            lc60: 78,
            lc45: 65.5,
            lc30: 51.5,
            lc10: 34.5
        }
    },
    "negative.900": {
        "negative.100": {
            contrast: 23.727475970548138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "negative.200": {
            contrast: 23.020344156848687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "negative.300": {
            contrast: 21.2314933573528,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "negative.400": {
            contrast: 18.933637190232798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.500": {
            contrast: 15.676239630765904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "negative.600": {
            contrast: 11.350257166162592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 7.421981093700541,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 12.82482746365949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 16.156144792668695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "negative.1400": {
            contrast: 20.230907100473466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "negative.1500": {
            contrast: 24.868693460046373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "negative.1600": {
            contrast: 29.983999624386048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "negative.1700": {
            contrast: 35.25856038100338,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 58
        },
        "negative.1800": {
            contrast: 40.74229981099368,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 53.5
        },
        "negative.1900": {
            contrast: 46.6381475911026,
            lc60: 100,
            lc45: 97.5,
            lc30: 76,
            lc10: 50
        },
        "negative.2000": {
            contrast: 52.536429809791194,
            lc60: 100,
            lc45: 91,
            lc30: 71,
            lc10: 47
        },
        "negative.2100": {
            contrast: 59.027687721238294,
            lc60: 100,
            lc45: 85,
            lc30: 66.5,
            lc10: 44.5
        },
        "negative.2200": {
            contrast: 65.43962398880286,
            lc60: 94.5,
            lc45: 80,
            lc30: 62.5,
            lc10: 42
        },
        "negative.2300": {
            contrast: 71.6833075347153,
            lc60: 89.5,
            lc45: 75.5,
            lc30: 59.5,
            lc10: 39.5
        },
        "negative.2400": {
            contrast: 78.84081359876149,
            lc60: 84.5,
            lc45: 71.5,
            lc30: 56.5,
            lc10: 37.5
        },
        "negative.2500": {
            contrast: 85.50609996567205,
            lc60: 80.5,
            lc45: 68,
            lc30: 53.5,
            lc10: 36
        }
    },
    "negative.1000": {
        "negative.100": {
            contrast: 27.89685591242272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38
        },
        "negative.200": {
            contrast: 27.18972409872327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "negative.300": {
            contrast: 25.400873299227385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "negative.400": {
            contrast: 23.103017132107386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "negative.500": {
            contrast: 19.845619572640494,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "negative.600": {
            contrast: 15.519637108037182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "negative.700": {
            contrast: 11.301542165206785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 8.845172296312935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 12.17648962532214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 16.251251933126913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94.5
        },
        "negative.1500": {
            contrast: 20.88903829269982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "negative.1600": {
            contrast: 26.00434445703949,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "negative.1700": {
            contrast: 31.27890521365682,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 64.5
        },
        "negative.1800": {
            contrast: 36.76264464364712,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 59
        },
        "negative.1900": {
            contrast: 42.658492423756044,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 54.5
        },
        "negative.2000": {
            contrast: 48.556774642444644,
            lc60: 100,
            lc45: 95,
            lc30: 76,
            lc10: 51.5
        },
        "negative.2100": {
            contrast: 55.048032553891744,
            lc60: 100,
            lc45: 88.5,
            lc30: 70.5,
            lc10: 48
        },
        "negative.2200": {
            contrast: 61.4599688214563,
            lc60: 98.5,
            lc45: 83.5,
            lc30: 66,
            lc10: 45.5
        },
        "negative.2300": {
            contrast: 67.70365236736875,
            lc60: 93,
            lc45: 79,
            lc30: 63,
            lc10: 43
        },
        "negative.2400": {
            contrast: 74.86115843141494,
            lc60: 87.5,
            lc45: 74.5,
            lc30: 59,
            lc10: 40.5
        },
        "negative.2500": {
            contrast: 81.5264447983255,
            lc60: 83.5,
            lc45: 70.5,
            lc30: 56.5,
            lc10: 38.5
        }
    },
    "negative.1100": {
        "negative.100": {
            contrast: 32.20405213364943,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 33.5
        },
        "negative.200": {
            contrast: 31.49692031994997,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 39.5
        },
        "negative.300": {
            contrast: 29.708069520454096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "negative.400": {
            contrast: 27.41021335333409,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "negative.500": {
            contrast: 24.152815793867198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "negative.600": {
            contrast: 19.826833329263888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.700": {
            contrast: 15.60873838643349,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "negative.800": {
            contrast: 10.942349355511041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 7.98637031236004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 12.06113262016481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 16.69891897973772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "negative.1600": {
            contrast: 21.814225144077394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "negative.1700": {
            contrast: 27.088785900694724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "negative.1800": {
            contrast: 32.572525330685025,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 65.5
        },
        "negative.1900": {
            contrast: 38.46837311079394,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 60
        },
        "negative.2000": {
            contrast: 44.36665532948254,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 55.5
        },
        "negative.2100": {
            contrast: 50.85791324092964,
            lc60: 100,
            lc45: 93,
            lc30: 74.5,
            lc10: 51.5
        },
        "negative.2200": {
            contrast: 57.26984950849421,
            lc60: 100,
            lc45: 87,
            lc30: 70,
            lc10: 49
        },
        "negative.2300": {
            contrast: 63.51353305440664,
            lc60: 96.5,
            lc45: 82.5,
            lc30: 66,
            lc10: 46
        },
        "negative.2400": {
            contrast: 70.67103911845282,
            lc60: 91,
            lc45: 77.5,
            lc30: 62.5,
            lc10: 43.5
        },
        "negative.2500": {
            contrast: 77.3363254853634,
            lc60: 86,
            lc45: 73.5,
            lc30: 59,
            lc10: 41.5
        }
    },
    "negative.1200": {
        "negative.100": {
            contrast: 37.62346659507132,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29
        },
        "negative.200": {
            contrast: 36.916334781371866,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 33.5
        },
        "negative.300": {
            contrast: 35.12748398187599,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38
        },
        "negative.400": {
            contrast: 32.82962781475599,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 43
        },
        "negative.500": {
            contrast: 29.57223025528909,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49.5
        },
        "negative.600": {
            contrast: 25.24624779068578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "negative.700": {
            contrast: 21.028152847855385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "negative.800": {
            contrast: 16.361763816932935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "negative.900": {
            contrast: 11.912210675514318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1000": {
            contrast: 7.759625428967292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 11.323899104898977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 16.439205269238652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "negative.1700": {
            contrast: 21.713766025855982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "negative.1800": {
            contrast: 27.197505455846283,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "negative.1900": {
            contrast: 33.093353235955206,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 68
        },
        "negative.2000": {
            contrast: 38.9916354546438,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 62.5
        },
        "negative.2100": {
            contrast: 45.482893366090906,
            lc60: 100,
            lc45: 99,
            lc30: 80.5,
            lc10: 58
        },
        "negative.2200": {
            contrast: 51.89482963365546,
            lc60: 100,
            lc45: 92.5,
            lc30: 75.5,
            lc10: 54
        },
        "negative.2300": {
            contrast: 58.13851317956791,
            lc60: 100,
            lc45: 87.5,
            lc30: 71,
            lc10: 51
        },
        "negative.2400": {
            contrast: 65.29601924361408,
            lc60: 95.5,
            lc45: 82,
            lc30: 66.5,
            lc10: 48
        },
        "negative.2500": {
            contrast: 71.96130561052466,
            lc60: 90.5,
            lc45: 77.5,
            lc30: 63.5,
            lc10: 45
        }
    },
    "negative.1300": {
        "negative.100": {
            contrast: 40.9303345658432,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 27
        },
        "negative.200": {
            contrast: 40.22320275214374,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 31
        },
        "negative.300": {
            contrast: 38.43435195264786,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 34.5
        },
        "negative.400": {
            contrast: 36.136495785527856,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "negative.500": {
            contrast: 32.87909822606096,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 44
        },
        "negative.600": {
            contrast: 28.553115761457654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "negative.700": {
            contrast: 24.33502081862726,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "negative.800": {
            contrast: 19.66863178770481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "negative.900": {
            contrast: 15.21907864628619,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1000": {
            contrast: 11.066493399739164,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 7.992427024942238,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 13.107733189281912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 18.382293945899242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "negative.1800": {
            contrast: 23.866033375889543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "negative.1900": {
            contrast: 29.76188115599846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "negative.2000": {
            contrast: 35.66016337468706,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 61
        },
        "negative.2100": {
            contrast: 42.15142128613416,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 55
        },
        "negative.2200": {
            contrast: 48.56335755369873,
            lc60: 100,
            lc45: 95.5,
            lc30: 75.5,
            lc10: 50.5
        },
        "negative.2300": {
            contrast: 54.80704109961116,
            lc60: 100,
            lc45: 88.5,
            lc30: 70.5,
            lc10: 47
        },
        "negative.2400": {
            contrast: 61.96454716365734,
            lc60: 98,
            lc45: 82.5,
            lc30: 65,
            lc10: 43.5
        },
        "negative.2500": {
            contrast: 68.62983353056792,
            lc60: 92,
            lc45: 77.5,
            lc30: 61,
            lc10: 40.5
        }
    },
    "negative.1400": {
        "negative.100": {
            contrast: 44.94300120731152,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 25
        },
        "negative.200": {
            contrast: 44.23586939361208,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28
        },
        "negative.300": {
            contrast: 42.44701859411618,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31
        },
        "negative.400": {
            contrast: 40.149162426996185,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "negative.500": {
            contrast: 36.89176486752929,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 37.5
        },
        "negative.600": {
            contrast: 32.56578240292598,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 43
        },
        "negative.700": {
            contrast: 28.34768746009558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "negative.800": {
            contrast: 23.681298429173133,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "negative.900": {
            contrast: 19.231745287754517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "negative.1000": {
            contrast: 15.07916004120749,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1100": {
            contrast: 10.780239861234142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 9.016467493016602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 14.29102824963393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 19.774767679624233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "negative.1900": {
            contrast: 25.670615459733153,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "negative.2000": {
            contrast: 31.56889767842175,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 59.5
        },
        "negative.2100": {
            contrast: 38.06015558986885,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 52
        },
        "negative.2200": {
            contrast: 44.47209185743341,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 46.5
        },
        "negative.2300": {
            contrast: 50.71577540334585,
            lc60: 100,
            lc45: 92,
            lc30: 69.5,
            lc10: 42.5
        },
        "negative.2400": {
            contrast: 57.87328146739205,
            lc60: 100,
            lc45: 84,
            lc30: 63.5,
            lc10: 39
        },
        "negative.2500": {
            contrast: 64.53856783430261,
            lc60: 95,
            lc45: 78,
            lc30: 58.5,
            lc10: 36
        }
    },
    "negative.1500": {
        "negative.100": {
            contrast: 49.47086673863442,
            lc60: 100,
            lc45: 73.5,
            lc30: 45.5,
            lc10: 22.5
        },
        "negative.200": {
            contrast: 48.763734924934965,
            lc60: 100,
            lc45: 82,
            lc30: 50.5,
            lc10: 25
        },
        "negative.300": {
            contrast: 46.97488412543909,
            lc60: 100,
            lc45: 91,
            lc30: 55,
            lc10: 27.5
        },
        "negative.400": {
            contrast: 44.67702795831908,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "negative.500": {
            contrast: 41.419630398852185,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 32.5
        },
        "negative.600": {
            contrast: 37.09364793424888,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36
        },
        "negative.700": {
            contrast: 32.87555299141848,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 41
        },
        "negative.800": {
            contrast: 28.209163960496035,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "negative.900": {
            contrast: 23.759610819077416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "negative.1000": {
            contrast: 19.607025572530393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "negative.1100": {
            contrast: 15.308105392557044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "negative.1200": {
            contrast: 9.88747455932878,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 9.61432046979816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 15.098059899788463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "negative.1900": {
            contrast: 20.993907679897383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "negative.2000": {
            contrast: 26.89218989858598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "negative.2100": {
            contrast: 33.383447810033076,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 54
        },
        "negative.2200": {
            contrast: 39.795384077597646,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 47
        },
        "negative.2300": {
            contrast: 46.039067623510086,
            lc60: 100,
            lc45: 98,
            lc30: 72.5,
            lc10: 42.5
        },
        "negative.2400": {
            contrast: 53.19657368755627,
            lc60: 100,
            lc45: 88.5,
            lc30: 65.5,
            lc10: 38.5
        },
        "negative.2500": {
            contrast: 59.86186005446683,
            lc60: 100,
            lc45: 81,
            lc30: 59.5,
            lc10: 34.5
        }
    },
    "negative.1600": {
        "negative.100": {
            contrast: 54.42103278265055,
            lc60: 100,
            lc45: 64.5,
            lc30: 41,
            lc10: 20.5
        },
        "negative.200": {
            contrast: 53.71390096895109,
            lc60: 100,
            lc45: 71,
            lc30: 45,
            lc10: 23
        },
        "negative.300": {
            contrast: 51.92505016945521,
            lc60: 100,
            lc45: 77,
            lc30: 48.5,
            lc10: 24.5
        },
        "negative.400": {
            contrast: 49.62719400233521,
            lc60: 100,
            lc45: 84.5,
            lc30: 52.5,
            lc10: 26
        },
        "negative.500": {
            contrast: 46.369796442868314,
            lc60: 100,
            lc45: 95,
            lc30: 57,
            lc10: 28
        },
        "negative.600": {
            contrast: 42.043813978265,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 30.5
        },
        "negative.700": {
            contrast: 37.82571903543461,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 34
        },
        "negative.800": {
            contrast: 33.15933000451216,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 38
        },
        "negative.900": {
            contrast: 28.709776863093534,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43
        },
        "negative.1000": {
            contrast: 24.55719161654651,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "negative.1100": {
            contrast: 20.258271436573164,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "negative.1200": {
            contrast: 14.837640603344898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1300": {
            contrast: 11.52427425418139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1400": {
            contrast: 7.4983649507893215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 9.91700175954254,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 15.812849539651461,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "negative.2000": {
            contrast: 21.71113175834006,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "negative.2100": {
            contrast: 28.20238966978716,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "negative.2200": {
            contrast: 34.61432593735172,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51.5
        },
        "negative.2300": {
            contrast: 40.858009483264155,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 45
        },
        "negative.2400": {
            contrast: 48.015515547310336,
            lc60: 100,
            lc45: 95.5,
            lc30: 69.5,
            lc10: 39
        },
        "negative.2500": {
            contrast: 54.68080191422091,
            lc60: 100,
            lc45: 86,
            lc30: 62.5,
            lc10: 35.5
        }
    },
    "negative.1700": {
        "negative.100": {
            contrast: 59.48159905210023,
            lc60: 100,
            lc45: 59,
            lc30: 38,
            lc10: 19
        },
        "negative.200": {
            contrast: 58.774467238400774,
            lc60: 100,
            lc45: 63.5,
            lc30: 41,
            lc10: 20.5
        },
        "negative.300": {
            contrast: 56.9856164389049,
            lc60: 100,
            lc45: 68,
            lc30: 43.5,
            lc10: 22
        },
        "negative.400": {
            contrast: 54.68776027178489,
            lc60: 100,
            lc45: 74,
            lc30: 46.5,
            lc10: 23.5
        },
        "negative.500": {
            contrast: 51.430362712318,
            lc60: 100,
            lc45: 80.5,
            lc30: 50,
            lc10: 25
        },
        "negative.600": {
            contrast: 47.10438024771469,
            lc60: 100,
            lc45: 92.5,
            lc30: 54.5,
            lc10: 27
        },
        "negative.700": {
            contrast: 42.88628530488429,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "negative.800": {
            contrast: 38.21989627396184,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 32
        },
        "negative.900": {
            contrast: 33.770343132543225,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 35.5
        },
        "negative.1000": {
            contrast: 29.617757885996195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 38.5
        },
        "negative.1100": {
            contrast: 25.31883770602285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44
        },
        "negative.1200": {
            contrast: 19.898206872794585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "negative.1300": {
            contrast: 16.58484052363108,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "negative.1400": {
            contrast: 12.558931220239009,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1500": {
            contrast: 8.009584041842754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 10.447467216225325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 16.345749434913923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "negative.2100": {
            contrast: 22.83700734636103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "negative.2200": {
            contrast: 29.248943613925587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "negative.2300": {
            contrast: 35.49262715983802,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 48.5
        },
        "negative.2400": {
            contrast: 42.650133223884204,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "negative.2500": {
            contrast: 49.31541959079478,
            lc60: 100,
            lc45: 92.5,
            lc30: 67,
            lc10: 37
        }
    },
    "negative.1800": {
        "negative.100": {
            contrast: 64.70006687729004,
            lc60: 77,
            lc45: 53.5,
            lc30: 35,
            lc10: 17.5
        },
        "negative.200": {
            contrast: 63.992935063590586,
            lc60: 83.5,
            lc45: 58,
            lc30: 37,
            lc10: 19
        },
        "negative.300": {
            contrast: 62.2040842640947,
            lc60: 90.5,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "negative.400": {
            contrast: 59.9062280969747,
            lc60: 100,
            lc45: 65,
            lc30: 41.5,
            lc10: 21
        },
        "negative.500": {
            contrast: 56.64883053750781,
            lc60: 100,
            lc45: 70,
            lc30: 44,
            lc10: 22
        },
        "negative.600": {
            contrast: 52.322848072904506,
            lc60: 100,
            lc45: 78,
            lc30: 47.5,
            lc10: 24
        },
        "negative.700": {
            contrast: 48.10475313007411,
            lc60: 100,
            lc45: 88.5,
            lc30: 51.5,
            lc10: 25.5
        },
        "negative.800": {
            contrast: 43.438364099151656,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 27
        },
        "negative.900": {
            contrast: 38.98881095773304,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 29.5
        },
        "negative.1000": {
            contrast: 34.83622571118601,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 31.5
        },
        "negative.1100": {
            contrast: 30.53730553121266,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 34.5
        },
        "negative.1200": {
            contrast: 25.116674697984397,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 39
        },
        "negative.1300": {
            contrast: 21.80330834882089,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "negative.1400": {
            contrast: 17.777399045428822,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "negative.1500": {
            contrast: 13.228051867032564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1600": {
            contrast: 8.247076062150803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 10.744764411200961,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 17.236022322648065,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "negative.2200": {
            contrast: 23.647958590212628,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "negative.2300": {
            contrast: 29.891642136125057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "negative.2400": {
            contrast: 37.049148200171246,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 47
        },
        "negative.2500": {
            contrast: 43.71443456708182,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40
        }
    },
    "negative.1900": {
        "negative.100": {
            contrast: 70.26630175434997,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 16.5
        },
        "negative.200": {
            contrast: 69.5591699406505,
            lc60: 73.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "negative.300": {
            contrast: 67.77031914115463,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "negative.400": {
            contrast: 65.47246297403463,
            lc60: 84,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "negative.500": {
            contrast: 62.21506541456774,
            lc60: 92.5,
            lc45: 61.5,
            lc30: 39,
            lc10: 20
        },
        "negative.600": {
            contrast: 57.88908294996443,
            lc60: 100,
            lc45: 66.5,
            lc30: 42,
            lc10: 21
        },
        "negative.700": {
            contrast: 53.670988007134035,
            lc60: 100,
            lc45: 73,
            lc30: 44.5,
            lc10: 22.5
        },
        "negative.800": {
            contrast: 49.004598976211575,
            lc60: 100,
            lc45: 82.5,
            lc30: 48,
            lc10: 23.5
        },
        "negative.900": {
            contrast: 44.55504583479296,
            lc60: 100,
            lc45: 100,
            lc30: 53,
            lc10: 25
        },
        "negative.1000": {
            contrast: 40.40246058824594,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 26.5
        },
        "negative.1100": {
            contrast: 36.103540408272586,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 28.5
        },
        "negative.1200": {
            contrast: 30.682909575044327,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 31.5
        },
        "negative.1300": {
            contrast: 27.369543225880815,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "negative.1400": {
            contrast: 23.343633922488745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "negative.1500": {
            contrast: 18.794286744092492,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "negative.1600": {
            contrast: 13.813310939210732,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1700": {
            contrast: 8.71394291539785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 11.19014523325457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 17.602081500819132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "negative.2300": {
            contrast: 23.845765046731568,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "negative.2400": {
            contrast: 31.003271110777753,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54
        },
        "negative.2500": {
            contrast: 37.668557477688324,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45
        }
    },
    "negative.2000": {
        "negative.100": {
            contrast: 75.79265322568037,
            lc60: 63,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "negative.200": {
            contrast: 75.08552141198092,
            lc60: 66.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "negative.300": {
            contrast: 73.29667061248503,
            lc60: 70,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 16.5
        },
        "negative.400": {
            contrast: 70.99881444536503,
            lc60: 74,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "negative.500": {
            contrast: 67.74141688589813,
            lc60: 79.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "negative.600": {
            contrast: 63.415434421294826,
            lc60: 88.5,
            lc45: 59,
            lc30: 37.5,
            lc10: 19
        },
        "negative.700": {
            contrast: 59.19733947846444,
            lc60: 100,
            lc45: 63.5,
            lc30: 40,
            lc10: 20
        },
        "negative.800": {
            contrast: 54.53095044754199,
            lc60: 100,
            lc45: 69,
            lc30: 42,
            lc10: 21
        },
        "negative.900": {
            contrast: 50.081397306123364,
            lc60: 100,
            lc45: 78,
            lc30: 45.5,
            lc10: 22
        },
        "negative.1000": {
            contrast: 45.92881205957634,
            lc60: 100,
            lc45: 92,
            lc30: 48,
            lc10: 23
        },
        "negative.1100": {
            contrast: 41.62989187960299,
            lc60: 100,
            lc45: 100,
            lc30: 52,
            lc10: 24
        },
        "negative.1200": {
            contrast: 36.20926104637473,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 26
        },
        "negative.1300": {
            contrast: 32.89589469721121,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 33
        },
        "negative.1400": {
            contrast: 28.869985393819146,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 44.5
        },
        "negative.1500": {
            contrast: 24.320638215422893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "negative.1600": {
            contrast: 19.33966241054113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "negative.1700": {
            contrast: 14.24029438672825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1800": {
            contrast: 8.974651911406676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 11.530670494838283,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 17.77435404075072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "negative.2400": {
            contrast: 24.9318601047969,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "negative.2500": {
            contrast: 31.59714647170747,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52
        }
    },
    "negative.2100": {
        "negative.100": {
            contrast: 81.82982432380616,
            lc60: 58,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "negative.200": {
            contrast: 81.1226925101067,
            lc60: 61,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "negative.300": {
            contrast: 79.33384171061081,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "negative.400": {
            contrast: 77.03598554349081,
            lc60: 66.5,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16
        },
        "negative.500": {
            contrast: 73.77858798402393,
            lc60: 70,
            lc45: 49.5,
            lc30: 32,
            lc10: 17
        },
        "negative.600": {
            contrast: 69.45260551942062,
            lc60: 75.5,
            lc45: 52.5,
            lc30: 34,
            lc10: 17.5
        },
        "negative.700": {
            contrast: 65.23451057659022,
            lc60: 83,
            lc45: 55.5,
            lc30: 35.5,
            lc10: 18
        },
        "negative.800": {
            contrast: 60.56812154566777,
            lc60: 97,
            lc45: 59.5,
            lc30: 37,
            lc10: 19
        },
        "negative.900": {
            contrast: 56.11856840424916,
            lc60: 100,
            lc45: 64.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "negative.1000": {
            contrast: 51.96598315770212,
            lc60: 100,
            lc45: 70.5,
            lc30: 41,
            lc10: 20.5
        },
        "negative.1100": {
            contrast: 47.66706297772878,
            lc60: 100,
            lc45: 80.5,
            lc30: 44.5,
            lc10: 21.5
        },
        "negative.1200": {
            contrast: 42.24643214450051,
            lc60: 100,
            lc45: 100,
            lc30: 48,
            lc10: 23
        },
        "negative.1300": {
            contrast: 38.933065795337,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 27.5
        },
        "negative.1400": {
            contrast: 34.90715649194493,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 36
        },
        "negative.1500": {
            contrast: 30.357809313548678,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 45
        },
        "negative.1600": {
            contrast: 25.37683350866692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "negative.1700": {
            contrast: 20.277465484854037,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "negative.1800": {
            contrast: 15.011823009532463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "negative.1900": {
            contrast: 9.3878264674419,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 11.067835250593195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 18.22534131463938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "negative.2500": {
            contrast: 24.89062768154995,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        }
    },
    "negative.2200": {
        "negative.100": {
            contrast: 87.7507799004434,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "negative.200": {
            contrast: 87.04364808674396,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "negative.300": {
            contrast: 85.25479728724807,
            lc60: 58,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "negative.400": {
            contrast: 82.95694112012806,
            lc60: 60.5,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "negative.500": {
            contrast: 79.69954356066117,
            lc60: 63.5,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "negative.600": {
            contrast: 75.37356109605786,
            lc60: 67,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "negative.700": {
            contrast: 71.15546615322745,
            lc60: 71.5,
            lc45: 50,
            lc30: 32,
            lc10: 16.5
        },
        "negative.800": {
            contrast: 66.489077122305,
            lc60: 78,
            lc45: 52.5,
            lc30: 33.5,
            lc10: 17
        },
        "negative.900": {
            contrast: 62.03952398088639,
            lc60: 89.5,
            lc45: 56,
            lc30: 35,
            lc10: 17.5
        },
        "negative.1000": {
            contrast: 57.88693873433937,
            lc60: 100,
            lc45: 59.5,
            lc30: 36.5,
            lc10: 18
        },
        "negative.1100": {
            contrast: 53.58801855436602,
            lc60: 100,
            lc45: 64.5,
            lc30: 38,
            lc10: 19
        },
        "negative.1200": {
            contrast: 48.16738772113776,
            lc60: 100,
            lc45: 75,
            lc30: 41,
            lc10: 20
        },
        "negative.1300": {
            contrast: 44.85402137197425,
            lc60: 100,
            lc45: 100,
            lc30: 50,
            lc10: 24
        },
        "negative.1400": {
            contrast: 40.82811206858218,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 30.5
        },
        "negative.1500": {
            contrast: 36.27876489018592,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 37
        },
        "negative.1600": {
            contrast: 31.29778908530416,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 45
        },
        "negative.1700": {
            contrast: 26.198421061491278,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "negative.1800": {
            contrast: 20.93277858616971,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "negative.1900": {
            contrast: 15.308782044079145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "negative.2000": {
            contrast: 9.718001731863753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 11.57707565502799,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 18.24236202193856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        }
    },
    "negative.2300": {
        "negative.100": {
            contrast: 93.47884918645065,
            lc60: 50,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 12.5
        },
        "negative.200": {
            contrast: 92.77171737275118,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "negative.300": {
            contrast: 90.98286657325531,
            lc60: 54,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "negative.400": {
            contrast: 88.6850104061353,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 26.5,
            lc10: 14
        },
        "negative.500": {
            contrast: 85.42761284666841,
            lc60: 57.5,
            lc45: 42,
            lc30: 27.5,
            lc10: 14.5
        },
        "negative.600": {
            contrast: 81.1016303820651,
            lc60: 61,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "negative.700": {
            contrast: 76.8835354392347,
            lc60: 64,
            lc45: 45.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "negative.800": {
            contrast: 72.21714640831226,
            lc60: 68,
            lc45: 47,
            lc30: 30.5,
            lc10: 15.5
        },
        "negative.900": {
            contrast: 67.76759326689364,
            lc60: 74,
            lc45: 50,
            lc30: 32,
            lc10: 16.5
        },
        "negative.1000": {
            contrast: 63.61500802034661,
            lc60: 82,
            lc45: 52.5,
            lc30: 33,
            lc10: 16.5
        },
        "negative.1100": {
            contrast: 59.31608784037326,
            lc60: 100,
            lc45: 55,
            lc30: 34,
            lc10: 17
        },
        "negative.1200": {
            contrast: 53.895457007145,
            lc60: 100,
            lc45: 60.5,
            lc30: 36,
            lc10: 18
        },
        "negative.1300": {
            contrast: 50.58209065798148,
            lc60: 100,
            lc45: 74.5,
            lc30: 43,
            lc10: 21.5
        },
        "negative.1400": {
            contrast: 46.55618135458941,
            lc60: 100,
            lc45: 93.5,
            lc30: 54.5,
            lc10: 26.5
        },
        "negative.1500": {
            contrast: 42.00683417619316,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 31.5
        },
        "negative.1600": {
            contrast: 37.0258583713114,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38
        },
        "negative.1700": {
            contrast: 31.926490347498515,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 45.5
        },
        "negative.1800": {
            contrast: 26.660847872176944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "negative.1900": {
            contrast: 21.036851330086385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "negative.2000": {
            contrast: 15.446071017870992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "negative.2100": {
            contrast: 9.330991254531366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 11.747385945300524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "negative.2400": {
        "negative.100": {
            contrast: 100.00300723447944,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "negative.200": {
            contrast: 99.29587542077996,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12.5
        },
        "negative.300": {
            contrast: 97.5070246212841,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "negative.400": {
            contrast: 95.20916845416409,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "negative.500": {
            contrast: 91.95177089469719,
            lc60: 53,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "negative.600": {
            contrast: 87.62578843009389,
            lc60: 55.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 13.5
        },
        "negative.700": {
            contrast: 83.40769348726349,
            lc60: 57.5,
            lc45: 41.5,
            lc30: 27,
            lc10: 14
        },
        "negative.800": {
            contrast: 78.74130445634104,
            lc60: 60.5,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "negative.900": {
            contrast: 74.29175131492242,
            lc60: 64.5,
            lc45: 45,
            lc30: 29,
            lc10: 15
        },
        "negative.1000": {
            contrast: 70.13916606837539,
            lc60: 68.5,
            lc45: 46.5,
            lc30: 29.5,
            lc10: 15
        },
        "negative.1100": {
            contrast: 65.84024588840205,
            lc60: 74,
            lc45: 48.5,
            lc30: 31,
            lc10: 15.5
        },
        "negative.1200": {
            contrast: 60.41961505517378,
            lc60: 92.5,
            lc45: 52,
            lc30: 32,
            lc10: 16
        },
        "negative.1300": {
            contrast: 57.10624870601026,
            lc60: 100,
            lc45: 61.5,
            lc30: 38,
            lc10: 19
        },
        "negative.1400": {
            contrast: 53.08033940261821,
            lc60: 100,
            lc45: 76,
            lc30: 46.5,
            lc10: 23.5
        },
        "negative.1500": {
            contrast: 48.53099222422195,
            lc60: 100,
            lc45: 89,
            lc30: 55,
            lc10: 27.5
        },
        "negative.1600": {
            contrast: 43.55001641934018,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "negative.1700": {
            contrast: 38.4506483955273,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 37.5
        },
        "negative.1800": {
            contrast: 33.18500592020573,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 44.5
        },
        "negative.1900": {
            contrast: 27.561009378115166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "negative.2000": {
            contrast: 21.970229065899776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "negative.2100": {
            contrast: 15.85514930256015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "negative.2200": {
            contrast: 9.8506407323477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "negative.2500": {
        "negative.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "negative.200": {
            contrast: 105.33354139898915,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "negative.300": {
            contrast: 103.54469059949326,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "negative.400": {
            contrast: 101.24683443237326,
            lc60: 48,
            lc45: 35.5,
            lc30: 23.5,
            lc10: 12
        },
        "negative.500": {
            contrast: 97.98943687290637,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "negative.600": {
            contrast: 93.66345440830305,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "negative.700": {
            contrast: 89.44535946547266,
            lc60: 53,
            lc45: 38.5,
            lc30: 25,
            lc10: 13.5
        },
        "negative.800": {
            contrast: 84.77897043455022,
            lc60: 55,
            lc45: 39.5,
            lc30: 26,
            lc10: 13.5
        },
        "negative.900": {
            contrast: 80.32941729313158,
            lc60: 58,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "negative.1000": {
            contrast: 76.17683204658456,
            lc60: 60.5,
            lc45: 42.5,
            lc30: 27.5,
            lc10: 14
        },
        "negative.1100": {
            contrast: 71.87791186661121,
            lc60: 64,
            lc45: 44,
            lc30: 28.5,
            lc10: 14.5
        },
        "negative.1200": {
            contrast: 66.45728103338296,
            lc60: 70.5,
            lc45: 46,
            lc30: 29.5,
            lc10: 15
        },
        "negative.1300": {
            contrast: 63.14391468421944,
            lc60: 85,
            lc45: 54.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "negative.1400": {
            contrast: 59.11800538082736,
            lc60: 100,
            lc45: 66,
            lc30: 41.5,
            lc10: 21
        },
        "negative.1500": {
            contrast: 54.568658202431116,
            lc60: 100,
            lc45: 76.5,
            lc30: 48,
            lc10: 24.5
        },
        "negative.1600": {
            contrast: 49.58768239754935,
            lc60: 100,
            lc45: 87.5,
            lc30: 55.5,
            lc10: 28.5
        },
        "negative.1700": {
            contrast: 44.48831437373647,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32.5
        },
        "negative.1800": {
            contrast: 39.222671898414895,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38.5
        },
        "negative.1900": {
            contrast: 33.598675356324335,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 45.5
        },
        "negative.2000": {
            contrast: 28.007895044108942,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "negative.2100": {
            contrast: 21.89281528076932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "negative.2200": {
            contrast: 15.888306710556868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "negative.2300": {
            contrast: 10.073082194784567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "negative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$positive = {
    "positive.100": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 9.81515493613894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 14.542304567260175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 19.67730972117696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "positive.900": {
            contrast: 24.425831449014833,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "positive.1000": {
            contrast: 29.04007089665641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "positive.1100": {
            contrast: 33.86653657253203,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 65
        },
        "positive.1200": {
            contrast: 38.93918752533884,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 60
        },
        "positive.1300": {
            contrast: 45.28230277245376,
            lc60: 100,
            lc45: 99.5,
            lc30: 78.5,
            lc10: 55
        },
        "positive.1400": {
            contrast: 48.723370107696674,
            lc60: 100,
            lc45: 95,
            lc30: 75.5,
            lc10: 52.5
        },
        "positive.1500": {
            contrast: 53.76068620910945,
            lc60: 100,
            lc45: 90,
            lc30: 71,
            lc10: 49.5
        },
        "positive.1600": {
            contrast: 58.24489471818557,
            lc60: 100,
            lc45: 85,
            lc30: 67.5,
            lc10: 47
        },
        "positive.1700": {
            contrast: 63.407928083748274,
            lc60: 96.5,
            lc45: 81,
            lc30: 64,
            lc10: 44.5
        },
        "positive.1800": {
            contrast: 68.51582279169143,
            lc60: 92,
            lc45: 77.5,
            lc30: 61,
            lc10: 42.5
        },
        "positive.1900": {
            contrast: 73.93667684103768,
            lc60: 88,
            lc45: 73.5,
            lc30: 58.5,
            lc10: 40.5
        },
        "positive.2000": {
            contrast: 79.21537147213381,
            lc60: 84,
            lc45: 70.5,
            lc30: 56,
            lc10: 39
        },
        "positive.2100": {
            contrast: 84.84193775682745,
            lc60: 80.5,
            lc45: 67.5,
            lc30: 53.5,
            lc10: 37.5
        },
        "positive.2200": {
            contrast: 90.41261085799682,
            lc60: 77,
            lc45: 65,
            lc30: 51.5,
            lc10: 35.5
        },
        "positive.2300": {
            contrast: 95.96647147481355,
            lc60: 74.5,
            lc45: 62.5,
            lc30: 49.5,
            lc10: 34.5
        },
        "positive.2400": {
            contrast: 101.90172545161896,
            lc60: 71.5,
            lc45: 60,
            lc30: 48,
            lc10: 33
        },
        "positive.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "positive.200": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 9.476969714564074,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 14.20411934568531,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 19.339124499602097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "positive.900": {
            contrast: 24.087646227439965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "positive.1000": {
            contrast: 28.701885675081545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1100": {
            contrast: 33.52835135095715,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 61.5
        },
        "positive.1200": {
            contrast: 38.60100230376396,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 56
        },
        "positive.1300": {
            contrast: 44.944117550878886,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 50.5
        },
        "positive.1400": {
            contrast: 48.3851848861218,
            lc60: 100,
            lc45: 95,
            lc30: 73.5,
            lc10: 48
        },
        "positive.1500": {
            contrast: 53.42250098753458,
            lc60: 100,
            lc45: 89,
            lc30: 68.5,
            lc10: 45.5
        },
        "positive.1600": {
            contrast: 57.90670949661071,
            lc60: 100,
            lc45: 84.5,
            lc30: 65,
            lc10: 43
        },
        "positive.1700": {
            contrast: 63.069742862173406,
            lc60: 96.5,
            lc45: 80,
            lc30: 61.5,
            lc10: 41
        },
        "positive.1800": {
            contrast: 68.17763757011657,
            lc60: 92,
            lc45: 75.5,
            lc30: 58.5,
            lc10: 38.5
        },
        "positive.1900": {
            contrast: 73.59849161946282,
            lc60: 87.5,
            lc45: 72,
            lc30: 55.5,
            lc10: 36.5
        },
        "positive.2000": {
            contrast: 78.87718625055894,
            lc60: 83,
            lc45: 69,
            lc30: 53,
            lc10: 35
        },
        "positive.2100": {
            contrast: 84.50375253525257,
            lc60: 79.5,
            lc45: 65.5,
            lc30: 50.5,
            lc10: 33.5
        },
        "positive.2200": {
            contrast: 90.07442563642195,
            lc60: 76,
            lc45: 63,
            lc30: 48.5,
            lc10: 32
        },
        "positive.2300": {
            contrast: 95.62828625323867,
            lc60: 73,
            lc45: 60.5,
            lc30: 46.5,
            lc10: 31
        },
        "positive.2400": {
            contrast: 101.56354023004408,
            lc60: 70,
            lc45: 58.5,
            lc30: 45,
            lc10: 29.5
        },
        "positive.2500": {
            contrast: 107.54654796152361,
            lc60: 67.5,
            lc45: 56,
            lc30: 43,
            lc10: 28.5
        }
    },
    "positive.300": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 8.195453043788138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 12.92260267490937,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 18.057607828826157,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "positive.900": {
            contrast: 22.806129556664025,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "positive.1000": {
            contrast: 27.420369004305606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "positive.1100": {
            contrast: 32.246834680181216,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 59.5
        },
        "positive.1200": {
            contrast: 37.319485632988034,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 53.5
        },
        "positive.1300": {
            contrast: 43.66260088010295,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 47.5
        },
        "positive.1400": {
            contrast: 47.10366821534587,
            lc60: 100,
            lc45: 96.5,
            lc30: 72.5,
            lc10: 45.5
        },
        "positive.1500": {
            contrast: 52.14098431675864,
            lc60: 100,
            lc45: 90,
            lc30: 67.5,
            lc10: 42
        },
        "positive.1600": {
            contrast: 56.625192825834766,
            lc60: 100,
            lc45: 85,
            lc30: 63.5,
            lc10: 39.5
        },
        "positive.1700": {
            contrast: 61.78822619139748,
            lc60: 97.5,
            lc45: 80,
            lc30: 60,
            lc10: 37
        },
        "positive.1800": {
            contrast: 66.89612089934064,
            lc60: 92.5,
            lc45: 75,
            lc30: 56.5,
            lc10: 35.5
        },
        "positive.1900": {
            contrast: 72.31697494868689,
            lc60: 87.5,
            lc45: 71.5,
            lc30: 53.5,
            lc10: 33.5
        },
        "positive.2000": {
            contrast: 77.595669579783,
            lc60: 83,
            lc45: 68,
            lc30: 51,
            lc10: 31.5
        },
        "positive.2100": {
            contrast: 83.22223586447664,
            lc60: 79.5,
            lc45: 64.5,
            lc30: 49,
            lc10: 30.5
        },
        "positive.2200": {
            contrast: 88.79290896564602,
            lc60: 75.5,
            lc45: 61.5,
            lc30: 46.5,
            lc10: 29
        },
        "positive.2300": {
            contrast: 94.34676958246274,
            lc60: 72.5,
            lc45: 59.5,
            lc30: 44.5,
            lc10: 28
        },
        "positive.2400": {
            contrast: 100.28202355926814,
            lc60: 69.5,
            lc45: 57,
            lc30: 43,
            lc10: 27
        },
        "positive.2500": {
            contrast: 106.26503129074767,
            lc60: 67,
            lc45: 54.5,
            lc30: 41,
            lc10: 26
        }
    },
    "positive.400": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 10.860049654422863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 15.995054808339646,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "positive.900": {
            contrast: 20.743576536177518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "positive.1000": {
            contrast: 25.357815983819094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "positive.1100": {
            contrast: 30.184281659694705,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 59.5
        },
        "positive.1200": {
            contrast: 35.256932612501515,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 53
        },
        "positive.1300": {
            contrast: 41.60004785961644,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 46
        },
        "positive.1400": {
            contrast: 45.04111519485935,
            lc60: 100,
            lc45: 99.5,
            lc30: 73.5,
            lc10: 43.5
        },
        "positive.1500": {
            contrast: 50.07843129627213,
            lc60: 100,
            lc45: 92.5,
            lc30: 67.5,
            lc10: 40.5
        },
        "positive.1600": {
            contrast: 54.562639805348255,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 37.5
        },
        "positive.1700": {
            contrast: 59.725673170910966,
            lc60: 100,
            lc45: 80.5,
            lc30: 59.5,
            lc10: 35.5
        },
        "positive.1800": {
            contrast: 64.83356787885413,
            lc60: 94,
            lc45: 76,
            lc30: 56,
            lc10: 33
        },
        "positive.1900": {
            contrast: 70.25442192820036,
            lc60: 88.5,
            lc45: 71.5,
            lc30: 53,
            lc10: 31.5
        },
        "positive.2000": {
            contrast: 75.5331165592965,
            lc60: 84,
            lc45: 68,
            lc30: 50.5,
            lc10: 30
        },
        "positive.2100": {
            contrast: 81.15968284399013,
            lc60: 80,
            lc45: 64.5,
            lc30: 47.5,
            lc10: 28
        },
        "positive.2200": {
            contrast: 86.73035594515952,
            lc60: 76.5,
            lc45: 61.5,
            lc30: 45.5,
            lc10: 27.5
        },
        "positive.2300": {
            contrast: 92.28421656197622,
            lc60: 73,
            lc45: 59,
            lc30: 43.5,
            lc10: 26
        },
        "positive.2400": {
            contrast: 98.21947053878162,
            lc60: 69.5,
            lc45: 56.5,
            lc30: 41.5,
            lc10: 25
        },
        "positive.2500": {
            contrast: 104.20247827026114,
            lc60: 67,
            lc45: 54,
            lc30: 40,
            lc10: 24
        }
    },
    "positive.500": {
        "positive.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 7.8042912635796835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 12.939296417496472,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 17.68781814533434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "positive.1000": {
            contrast: 22.302057592975924,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "positive.1100": {
            contrast: 27.128523268851534,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "positive.1200": {
            contrast: 32.20117422165834,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 54
        },
        "positive.1300": {
            contrast: 38.544289468773265,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 47
        },
        "positive.1400": {
            contrast: 41.985356804016185,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 44
        },
        "positive.1500": {
            contrast: 47.022672905428955,
            lc60: 100,
            lc45: 96,
            lc30: 70,
            lc10: 40
        },
        "positive.1600": {
            contrast: 51.50688141450508,
            lc60: 100,
            lc45: 89.5,
            lc30: 65,
            lc10: 37.5
        },
        "positive.1700": {
            contrast: 56.6699147800678,
            lc60: 100,
            lc45: 83.5,
            lc30: 60,
            lc10: 35
        },
        "positive.1800": {
            contrast: 61.77780948801096,
            lc60: 97.5,
            lc45: 78,
            lc30: 56.5,
            lc10: 32.5
        },
        "positive.1900": {
            contrast: 67.19866353735719,
            lc60: 91.5,
            lc45: 73,
            lc30: 53.5,
            lc10: 31
        },
        "positive.2000": {
            contrast: 72.47735816845334,
            lc60: 86,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "positive.2100": {
            contrast: 78.10392445314696,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 28
        },
        "positive.2200": {
            contrast: 83.67459755431634,
            lc60: 77.5,
            lc45: 62,
            lc30: 45.5,
            lc10: 26.5
        },
        "positive.2300": {
            contrast: 89.22845817113304,
            lc60: 74,
            lc45: 59.5,
            lc30: 43.5,
            lc10: 25
        },
        "positive.2400": {
            contrast: 95.16371214793845,
            lc60: 71,
            lc45: 56.5,
            lc30: 42,
            lc10: 24.5
        },
        "positive.2500": {
            contrast: 101.14671987941797,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40,
            lc10: 23.5
        }
    },
    "positive.600": {
        "positive.100": {
            contrast: 11.313172454626057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.200": {
            contrast: 10.859167541132283,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.300": {
            contrast: 9.180620186678388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 8.609130780523708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 13.357652508361578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 17.971891956003162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "positive.1100": {
            contrast: 22.798357631878773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "positive.1200": {
            contrast: 27.871008584685576,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "positive.1300": {
            contrast: 34.2141238318005,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49.5
        },
        "positive.1400": {
            contrast: 37.65519116704342,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 46
        },
        "positive.1500": {
            contrast: 42.69250726845619,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42
        },
        "positive.1600": {
            contrast: 47.176715777532316,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 39
        },
        "positive.1700": {
            contrast: 52.33974914309503,
            lc60: 100,
            lc45: 88.5,
            lc30: 64,
            lc10: 35.5
        },
        "positive.1800": {
            contrast: 57.44764385103819,
            lc60: 100,
            lc45: 82.5,
            lc30: 59.5,
            lc10: 33.5
        },
        "positive.1900": {
            contrast: 62.868497900384426,
            lc60: 96,
            lc45: 76.5,
            lc30: 55.5,
            lc10: 31.5
        },
        "positive.2000": {
            contrast: 68.14719253148056,
            lc60: 90,
            lc45: 72,
            lc30: 52,
            lc10: 29.5
        },
        "positive.2100": {
            contrast: 73.77375881617418,
            lc60: 85,
            lc45: 67.5,
            lc30: 49,
            lc10: 28
        },
        "positive.2200": {
            contrast: 79.34443191734356,
            lc60: 80.5,
            lc45: 64.5,
            lc30: 46.5,
            lc10: 26.5
        },
        "positive.2300": {
            contrast: 84.89829253416028,
            lc60: 76.5,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 25.5
        },
        "positive.2400": {
            contrast: 90.83354651096568,
            lc60: 73,
            lc45: 58.5,
            lc30: 42.5,
            lc10: 24.5
        },
        "positive.2500": {
            contrast: 96.8165542424452,
            lc60: 69.5,
            lc45: 56,
            lc30: 40.5,
            lc10: 24
        }
    },
    "positive.700": {
        "positive.100": {
            contrast: 16.411421032138183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "positive.200": {
            contrast: 15.957416118644405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "positive.300": {
            contrast: 14.278868764190507,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.400": {
            contrast: 11.681960757807062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.500": {
            contrast: 7.99742913160079,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 8.822238772246363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 13.436478219887945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 18.26294389576356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "positive.1200": {
            contrast: 23.335594848570366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1300": {
            contrast: 29.67871009568529,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.1400": {
            contrast: 33.1197774309282,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51
        },
        "positive.1500": {
            contrast: 38.15709353234098,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        },
        "positive.1600": {
            contrast: 42.641302041417106,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41
        },
        "positive.1700": {
            contrast: 47.80433540697982,
            lc60: 100,
            lc45: 95,
            lc30: 68,
            lc10: 37.5
        },
        "positive.1800": {
            contrast: 52.91223011492298,
            lc60: 100,
            lc45: 87.5,
            lc30: 62.5,
            lc10: 35
        },
        "positive.1900": {
            contrast: 58.33308416426921,
            lc60: 100,
            lc45: 81,
            lc30: 58,
            lc10: 33
        },
        "positive.2000": {
            contrast: 63.611778795365346,
            lc60: 95,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 30.5
        },
        "positive.2100": {
            contrast: 69.23834508005898,
            lc60: 89,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "positive.2200": {
            contrast: 74.80901818122835,
            lc60: 84,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "positive.2300": {
            contrast: 80.36287879804507,
            lc60: 80,
            lc45: 63.5,
            lc30: 46,
            lc10: 26
        },
        "positive.2400": {
            contrast: 86.29813277485047,
            lc60: 75.5,
            lc45: 60.5,
            lc30: 43.5,
            lc10: 25.5
        },
        "positive.2500": {
            contrast: 92.28114050632999,
            lc60: 72.5,
            lc45: 58,
            lc30: 42,
            lc10: 24
        }
    },
    "positive.800": {
        "positive.100": {
            contrast: 21.82266822486706,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47.5
        },
        "positive.200": {
            contrast: 21.368663311373286,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.300": {
            contrast: 19.69011595691939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.400": {
            contrast: 17.093207950535938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "positive.500": {
            contrast: 13.408676324329669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.600": {
            contrast: 8.411625491682994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 8.452355531236847,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 13.278821207112463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 18.351472159919272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "positive.1300": {
            contrast: 24.694587407034195,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "positive.1400": {
            contrast: 28.135654742277104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "positive.1500": {
            contrast: 33.17297084368989,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "positive.1600": {
            contrast: 37.65717935276601,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        },
        "positive.1700": {
            contrast: 42.82021271832871,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        },
        "positive.1800": {
            contrast: 47.92810742627188,
            lc60: 100,
            lc45: 94.5,
            lc30: 68,
            lc10: 37.5
        },
        "positive.1900": {
            contrast: 53.34896147561812,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 34.5
        },
        "positive.2000": {
            contrast: 58.62765610671424,
            lc60: 100,
            lc45: 81,
            lc30: 57.5,
            lc10: 32.5
        },
        "positive.2100": {
            contrast: 64.25422239140788,
            lc60: 94.5,
            lc45: 75,
            lc30: 54.5,
            lc10: 30
        },
        "positive.2200": {
            contrast: 69.82489549257726,
            lc60: 89,
            lc45: 71,
            lc30: 51.5,
            lc10: 28.5
        },
        "positive.2300": {
            contrast: 75.37875610939398,
            lc60: 83.5,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "positive.2400": {
            contrast: 81.31401008619937,
            lc60: 79,
            lc45: 63,
            lc30: 46,
            lc10: 26
        },
        "positive.2500": {
            contrast: 87.29701781767889,
            lc60: 75,
            lc45: 60.5,
            lc30: 44,
            lc10: 25.5
        }
    },
    "positive.900": {
        "positive.100": {
            contrast: 26.73364115847448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "positive.200": {
            contrast: 26.279636244980708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "positive.300": {
            contrast: 24.601088890526814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "positive.400": {
            contrast: 22.004180884143366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "positive.500": {
            contrast: 18.319649257937098,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "positive.600": {
            contrast: 13.322598425290424,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.700": {
            contrast: 8.284476220572042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 8.626418127703598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 13.699069080510407,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 20.042184327625332,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.1400": {
            contrast: 23.483251662868245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1500": {
            contrast: 28.520567764281026,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "positive.1600": {
            contrast: 33.004776273357145,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 51
        },
        "positive.1700": {
            contrast: 38.167809638919856,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        },
        "positive.1800": {
            contrast: 43.275704346863016,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 40.5
        },
        "positive.1900": {
            contrast: 48.696558396209255,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 37
        },
        "positive.2000": {
            contrast: 53.97525302730538,
            lc60: 100,
            lc45: 86,
            lc30: 62,
            lc10: 35
        },
        "positive.2100": {
            contrast: 59.601819311999016,
            lc60: 100,
            lc45: 80,
            lc30: 57.5,
            lc10: 32.5
        },
        "positive.2200": {
            contrast: 65.1724924131684,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 54.5,
            lc10: 30
        },
        "positive.2300": {
            contrast: 70.7263530299851,
            lc60: 88,
            lc45: 70.5,
            lc30: 51.5,
            lc10: 29
        },
        "positive.2400": {
            contrast: 76.6616070067905,
            lc60: 83,
            lc45: 66.5,
            lc30: 48.5,
            lc10: 28
        },
        "positive.2500": {
            contrast: 82.64461473827002,
            lc60: 78.5,
            lc45: 63,
            lc30: 46,
            lc10: 26
        }
    },
    "positive.1000": {
        "positive.100": {
            contrast: 31.435077008065083,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 34
        },
        "positive.200": {
            contrast: 30.98107209457131,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 38.5
        },
        "positive.300": {
            contrast: 29.302524740117413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45
        },
        "positive.400": {
            contrast: 26.705616733733965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "positive.500": {
            contrast: 23.021085107527703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "positive.600": {
            contrast: 18.024034274881025,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "positive.700": {
            contrast: 12.985912070162644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.800": {
            contrast: 7.61778213593393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 9.144395225657597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 15.48751047277252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        },
        "positive.1400": {
            contrast: 18.928577808015433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "positive.1500": {
            contrast: 23.965893909428214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.1600": {
            contrast: 28.45010241850433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "positive.1700": {
            contrast: 33.61313578406704,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 50.5
        },
        "positive.1800": {
            contrast: 38.7210304920102,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 44.5
        },
        "positive.1900": {
            contrast: 44.14188454135644,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 40
        },
        "positive.2000": {
            contrast: 49.42057917245257,
            lc60: 100,
            lc45: 93,
            lc30: 66.5,
            lc10: 37
        },
        "positive.2100": {
            contrast: 55.04714545714619,
            lc60: 100,
            lc45: 85.5,
            lc30: 61,
            lc10: 34.5
        },
        "positive.2200": {
            contrast: 60.61781855831557,
            lc60: 99.5,
            lc45: 79,
            lc30: 57.5,
            lc10: 32.5
        },
        "positive.2300": {
            contrast: 66.1716791751323,
            lc60: 92.5,
            lc45: 74.5,
            lc30: 54,
            lc10: 30.5
        },
        "positive.2400": {
            contrast: 72.1069331519377,
            lc60: 86.5,
            lc45: 69.5,
            lc30: 51,
            lc10: 29
        },
        "positive.2500": {
            contrast: 78.08994088341721,
            lc60: 82,
            lc45: 66,
            lc30: 48.5,
            lc10: 28
        }
    },
    "positive.1100": {
        "positive.100": {
            contrast: 36.2891937130518,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 30
        },
        "positive.200": {
            contrast: 35.835188799558026,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 33.5
        },
        "positive.300": {
            contrast: 34.15664144510413,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 38
        },
        "positive.400": {
            contrast: 31.559733438720684,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 44
        },
        "positive.500": {
            contrast: 27.875201812514412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "positive.600": {
            contrast: 22.878150979867737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "positive.700": {
            contrast: 17.840028775149356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "positive.800": {
            contrast: 12.471898840920643,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.900": {
            contrast: 7.584794977246144,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 10.692266987789296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 14.133334323032209,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 19.170650424444986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "positive.1600": {
            contrast: 23.65485893352111,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1700": {
            contrast: 28.817892299083812,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "positive.1800": {
            contrast: 33.92578700702698,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "positive.1900": {
            contrast: 39.346641056373215,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "positive.2000": {
            contrast: 44.625335687469345,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        },
        "positive.2100": {
            contrast: 50.25190197216298,
            lc60: 100,
            lc45: 91.5,
            lc30: 66,
            lc10: 37
        },
        "positive.2200": {
            contrast: 55.82257507333236,
            lc60: 100,
            lc45: 84.5,
            lc30: 60.5,
            lc10: 34.5
        },
        "positive.2300": {
            contrast: 61.376435690149066,
            lc60: 98.5,
            lc45: 78.5,
            lc30: 57,
            lc10: 32
        },
        "positive.2400": {
            contrast: 67.31168966695446,
            lc60: 91.5,
            lc45: 73.5,
            lc30: 53.5,
            lc10: 30.5
        },
        "positive.2500": {
            contrast: 73.294697398434,
            lc60: 86,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29.5
        }
    },
    "positive.1200": {
        "positive.100": {
            contrast: 41.33011641631036,
            lc60: 100,
            lc45: 100,
            lc30: 54,
            lc10: 27
        },
        "positive.200": {
            contrast: 40.876111502816585,
            lc60: 100,
            lc45: 100,
            lc30: 60.5,
            lc10: 30
        },
        "positive.300": {
            contrast: 39.19756414836269,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 33.5
        },
        "positive.400": {
            contrast: 36.600656141979236,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 38.5
        },
        "positive.500": {
            contrast: 32.91612451577297,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 44.5
        },
        "positive.600": {
            contrast: 27.919073683126292,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "positive.700": {
            contrast: 22.880951478407916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.800": {
            contrast: 17.512821544179204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "positive.900": {
            contrast: 12.625717680504703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1000": {
            contrast: 7.935483404787509,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 9.063204280158864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 14.100520381571641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 18.584728890647764,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "positive.1700": {
            contrast: 23.74776225621047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1800": {
            contrast: 28.85565696415363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "positive.1900": {
            contrast: 34.27651101349987,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 49
        },
        "positive.2000": {
            contrast: 39.555205644596,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 44
        },
        "positive.2100": {
            contrast: 45.18177192928963,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 40
        },
        "positive.2200": {
            contrast: 50.752445030459015,
            lc60: 100,
            lc45: 91,
            lc30: 66,
            lc10: 37
        },
        "positive.2300": {
            contrast: 56.30630564727572,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 34
        },
        "positive.2400": {
            contrast: 62.241559624081134,
            lc60: 97,
            lc45: 78,
            lc30: 56.5,
            lc10: 32
        },
        "positive.2500": {
            contrast: 68.22456735556064,
            lc60: 90.5,
            lc45: 72.5,
            lc30: 53.5,
            lc10: 30
        }
    },
    "positive.1300": {
        "positive.100": {
            contrast: 47.557266300568834,
            lc60: 100,
            lc45: 79,
            lc30: 47,
            lc10: 23.5
        },
        "positive.200": {
            contrast: 47.103261387075065,
            lc60: 100,
            lc45: 87,
            lc30: 52.5,
            lc10: 26
        },
        "positive.300": {
            contrast: 45.42471403262117,
            lc60: 100,
            lc45: 98,
            lc30: 58.5,
            lc10: 29
        },
        "positive.400": {
            contrast: 42.82780602623772,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 32.5
        },
        "positive.500": {
            contrast: 39.143274400031444,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37
        },
        "positive.600": {
            contrast: 34.14622356738477,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 43.5
        },
        "positive.700": {
            contrast: 29.108101362666396,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "positive.800": {
            contrast: 23.73997142843768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "positive.900": {
            contrast: 18.85286756476318,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "positive.1000": {
            contrast: 14.162633289045987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1100": {
            contrast: 9.30957086785094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 7.721833515608051,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 12.206042024684171,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 17.36907539024688,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "positive.1800": {
            contrast: 22.476970098190044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "positive.1900": {
            contrast: 27.897824147536276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "positive.2000": {
            contrast: 33.176518778632406,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51.5
        },
        "positive.2100": {
            contrast: 38.80308506332604,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        },
        "positive.2200": {
            contrast: 44.37375816449542,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 40.5
        },
        "positive.2300": {
            contrast: 49.927618781312134,
            lc60: 100,
            lc45: 92,
            lc30: 65.5,
            lc10: 37
        },
        "positive.2400": {
            contrast: 55.86287275811753,
            lc60: 100,
            lc45: 84,
            lc30: 60.5,
            lc10: 34
        },
        "positive.2500": {
            contrast: 61.84588048959706,
            lc60: 97.5,
            lc45: 78,
            lc30: 56.5,
            lc10: 32.5
        }
    },
    "positive.1400": {
        "positive.100": {
            contrast: 50.903790091423396,
            lc60: 100,
            lc45: 70.5,
            lc30: 44,
            lc10: 22
        },
        "positive.200": {
            contrast: 50.44978517792962,
            lc60: 100,
            lc45: 77,
            lc30: 48,
            lc10: 24
        },
        "positive.300": {
            contrast: 48.77123782347572,
            lc60: 100,
            lc45: 85.5,
            lc30: 53.5,
            lc10: 27
        },
        "positive.400": {
            contrast: 46.17432981709228,
            lc60: 100,
            lc45: 95.5,
            lc30: 59.5,
            lc10: 30
        },
        "positive.500": {
            contrast: 42.489798190886006,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34
        },
        "positive.600": {
            contrast: 37.49274735823933,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 39.5
        },
        "positive.700": {
            contrast: 32.45462515352096,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46
        },
        "positive.800": {
            contrast: 27.08649521929224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "positive.900": {
            contrast: 22.19939135561774,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "positive.1000": {
            contrast: 17.509157079900547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "positive.1100": {
            contrast: 12.6560946587055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1200": {
            contrast: 7.60618730003871,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 8.729374445355425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 13.892407810918131,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 19.000302518861297,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "positive.1900": {
            contrast: 24.421156568207532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.2000": {
            contrast: 29.699851199303662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "positive.2100": {
            contrast: 35.32641748399729,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        },
        "positive.2200": {
            contrast: 40.89709058516667,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43.5
        },
        "positive.2300": {
            contrast: 46.450951201983386,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 38.5
        },
        "positive.2400": {
            contrast: 52.38620517878878,
            lc60: 100,
            lc45: 88,
            lc30: 63.5,
            lc10: 36
        },
        "positive.2500": {
            contrast: 58.369212910268296,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 33
        }
    },
    "positive.1500": {
        "positive.100": {
            contrast: 55.76651463002552,
            lc60: 100,
            lc45: 63,
            lc30: 40.5,
            lc10: 20
        },
        "positive.200": {
            contrast: 55.31250971653176,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 22
        },
        "positive.300": {
            contrast: 53.633962362077845,
            lc60: 100,
            lc45: 76.5,
            lc30: 49,
            lc10: 24.5
        },
        "positive.400": {
            contrast: 51.0370543556944,
            lc60: 100,
            lc45: 84,
            lc30: 53.5,
            lc10: 27
        },
        "positive.500": {
            contrast: 47.352522729488136,
            lc60: 100,
            lc45: 94,
            lc30: 59.5,
            lc10: 30.5
        },
        "positive.600": {
            contrast: 42.35547189684146,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35
        },
        "positive.700": {
            contrast: 37.31734969212308,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 40
        },
        "positive.800": {
            contrast: 31.949219757894365,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 46.5
        },
        "positive.900": {
            contrast: 27.06211589421986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.1000": {
            contrast: 22.371881618502673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "positive.1100": {
            contrast: 17.518819197307625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "positive.1200": {
            contrast: 12.468911838640834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 8.784067876642803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 13.891962584585965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 19.312816633932204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "positive.2000": {
            contrast: 24.591511265028334,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "positive.2100": {
            contrast: 30.21807754972196,
            lc60: 100,
            lc45: 100,
            lc30: 98.5,
            lc10: 54.5
        },
        "positive.2200": {
            contrast: 35.788750650891345,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 48
        },
        "positive.2300": {
            contrast: 41.34261126770806,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "positive.2400": {
            contrast: 47.27786524451346,
            lc60: 100,
            lc45: 96,
            lc30: 69,
            lc10: 38.5
        },
        "positive.2500": {
            contrast: 53.26087297599298,
            lc60: 100,
            lc45: 87,
            lc30: 63,
            lc10: 35.5
        }
    },
    "positive.1600": {
        "positive.100": {
            contrast: 60.061980173423,
            lc60: 96.5,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "positive.200": {
            contrast: 59.60797525992923,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "positive.300": {
            contrast: 57.92942790547533,
            lc60: 100,
            lc45: 69.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "positive.400": {
            contrast: 55.33251989909188,
            lc60: 100,
            lc45: 76.5,
            lc30: 49,
            lc10: 25
        },
        "positive.500": {
            contrast: 51.64798827288561,
            lc60: 100,
            lc45: 84.5,
            lc30: 54.5,
            lc10: 27.5
        },
        "positive.600": {
            contrast: 46.650937440238934,
            lc60: 100,
            lc45: 96,
            lc30: 61,
            lc10: 31.5
        },
        "positive.700": {
            contrast: 41.612815235520564,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "positive.800": {
            contrast: 36.24468530129184,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 41
        },
        "positive.900": {
            contrast: 31.357581437617345,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 47
        },
        "positive.1000": {
            contrast: 26.66734716190015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "positive.1100": {
            contrast: 21.814284740705105,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "positive.1200": {
            contrast: 16.76437738203831,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "positive.1300": {
            contrast: 10.51345638895863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 9.32692795353633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 14.74778200288257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 20.026476633978703,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.2100": {
            contrast: 25.653042918672327,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "positive.2200": {
            contrast: 31.223716019841707,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 54
        },
        "positive.2300": {
            contrast: 36.777576636658424,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "positive.2400": {
            contrast: 42.71283061346382,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 41.5
        },
        "positive.2500": {
            contrast: 48.69583834494334,
            lc60: 100,
            lc45: 94,
            lc30: 67.5,
            lc10: 38
        }
    },
    "positive.1700": {
        "positive.100": {
            contrast: 64.9720502205043,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "positive.200": {
            contrast: 64.51804530701052,
            lc60: 83,
            lc45: 58,
            lc30: 37.5,
            lc10: 19
        },
        "positive.300": {
            contrast: 62.83949795255662,
            lc60: 91,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "positive.400": {
            contrast: 60.242589946173176,
            lc60: 99,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "positive.500": {
            contrast: 56.5580583199669,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25.5
        },
        "positive.600": {
            contrast: 51.56100748732023,
            lc60: 100,
            lc45: 85,
            lc30: 55.5,
            lc10: 27.5
        },
        "positive.700": {
            contrast: 46.52288528260185,
            lc60: 100,
            lc45: 95.5,
            lc30: 62,
            lc10: 31.5
        },
        "positive.800": {
            contrast: 41.154755348373136,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "positive.900": {
            contrast: 36.26765148469863,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 41
        },
        "positive.1000": {
            contrast: 31.57741720898144,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 46.5
        },
        "positive.1100": {
            contrast: 26.724354787786393,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "positive.1200": {
            contrast: 21.674447429119606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "positive.1300": {
            contrast: 15.423526436039925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "positive.1400": {
            contrast: 12.05895377343102,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 9.472640108639443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 14.751334739735574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 20.377901024429203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "positive.2200": {
            contrast: 25.948574125598583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "positive.2300": {
            contrast: 31.502434742415293,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 53
        },
        "positive.2400": {
            contrast: 37.437688719220695,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46.5
        },
        "positive.2500": {
            contrast: 43.42069645070022,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 40.5
        }
    },
    "positive.1800": {
        "positive.100": {
            contrast: 69.79504028161581,
            lc60: 69.5,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "positive.200": {
            contrast: 69.34103536812202,
            lc60: 75,
            lc45: 54,
            lc30: 35,
            lc10: 18
        },
        "positive.300": {
            contrast: 67.66248801366814,
            lc60: 81.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "positive.400": {
            contrast: 65.06558000728468,
            lc60: 88.5,
            lc45: 63.5,
            lc30: 41,
            lc10: 21
        },
        "positive.500": {
            contrast: 61.38104838107841,
            lc60: 97,
            lc45: 69,
            lc30: 45,
            lc10: 23.5
        },
        "positive.600": {
            contrast: 56.38399754843174,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 25.5
        },
        "positive.700": {
            contrast: 51.34587534371337,
            lc60: 100,
            lc45: 85,
            lc30: 55,
            lc10: 28.5
        },
        "positive.800": {
            contrast: 45.97774540948464,
            lc60: 100,
            lc45: 97.5,
            lc30: 62,
            lc10: 31.5
        },
        "positive.900": {
            contrast: 41.09064154581014,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 35
        },
        "positive.1000": {
            contrast: 36.40040727009295,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "positive.1100": {
            contrast: 31.5473448488979,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 46
        },
        "positive.1200": {
            contrast: 26.497437490231114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "positive.1300": {
            contrast: 20.246516497151433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "positive.1400": {
            contrast: 16.881943834542525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "positive.1500": {
            contrast: 11.98694836241252,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1600": {
            contrast: 7.657403325613138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 9.513820754927512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 15.140387039621139,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "positive.2200": {
            contrast: 20.711060140790522,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.2300": {
            contrast: 26.26492075760723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "positive.2400": {
            contrast: 32.20017473441263,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 52.5
        },
        "positive.2500": {
            contrast: 38.18318246589215,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 46
        }
    },
    "positive.1900": {
        "positive.100": {
            contrast: 74.8787316996483,
            lc60: 64,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "positive.200": {
            contrast: 74.42472678615452,
            lc60: 69,
            lc45: 50,
            lc30: 32.5,
            lc10: 16.5
        },
        "positive.300": {
            contrast: 72.74617943170063,
            lc60: 74.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "positive.400": {
            contrast: 70.14927142531717,
            lc60: 80.5,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "positive.500": {
            contrast: 66.4647397991109,
            lc60: 87.5,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "positive.600": {
            contrast: 61.46768896646424,
            lc60: 96.5,
            lc45: 69.5,
            lc30: 45,
            lc10: 23
        },
        "positive.700": {
            contrast: 56.42956676174585,
            lc60: 100,
            lc45: 76.5,
            lc30: 49.5,
            lc10: 25
        },
        "positive.800": {
            contrast: 51.061436827517134,
            lc60: 100,
            lc45: 86,
            lc30: 55,
            lc10: 28.5
        },
        "positive.900": {
            contrast: 46.17433296384264,
            lc60: 100,
            lc45: 96.5,
            lc30: 61.5,
            lc10: 31.5
        },
        "positive.1000": {
            contrast: 41.48409868812544,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 34.5
        },
        "positive.1100": {
            contrast: 36.631036266930394,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40
        },
        "positive.1200": {
            contrast: 31.581128908263604,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 46
        },
        "positive.1300": {
            contrast: 25.330207915183923,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "positive.1400": {
            contrast: 21.965635252575023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "positive.1500": {
            contrast: 17.070639780445017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "positive.1600": {
            contrast: 12.74109474364563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1700": {
            contrast: 7.786098762416592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 9.562978696034136,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 15.133651797203518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "positive.2300": {
            contrast: 20.687512414020233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "positive.2400": {
            contrast: 26.622766390825632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "positive.2500": {
            contrast: 32.60577412230516,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 52
        }
    },
    "positive.2000": {
        "positive.100": {
            contrast: 79.79714915796265,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 14.5
        },
        "positive.200": {
            contrast: 79.34314424446887,
            lc60: 64,
            lc45: 46,
            lc30: 30.5,
            lc10: 15.5
        },
        "positive.300": {
            contrast: 77.66459689001496,
            lc60: 69,
            lc45: 50,
            lc30: 32.5,
            lc10: 17
        },
        "positive.400": {
            contrast: 75.06768888363152,
            lc60: 74,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "positive.500": {
            contrast: 71.38315725742524,
            lc60: 80,
            lc45: 58,
            lc30: 38,
            lc10: 19.5
        },
        "positive.600": {
            contrast: 66.38610642477859,
            lc60: 87.5,
            lc45: 63,
            lc30: 41.5,
            lc10: 21.5
        },
        "positive.700": {
            contrast: 61.347984220060205,
            lc60: 97,
            lc45: 69,
            lc30: 45.5,
            lc10: 23
        },
        "positive.800": {
            contrast: 55.979854285831486,
            lc60: 100,
            lc45: 77,
            lc30: 50,
            lc10: 25.5
        },
        "positive.900": {
            contrast: 51.09275042215698,
            lc60: 100,
            lc45: 85.5,
            lc30: 54.5,
            lc10: 28.5
        },
        "positive.1000": {
            contrast: 46.402516146439794,
            lc60: 100,
            lc45: 96,
            lc30: 60.5,
            lc10: 31
        },
        "positive.1100": {
            contrast: 41.549453725244746,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34
        },
        "positive.1200": {
            contrast: 36.49954636657795,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 40
        },
        "positive.1300": {
            contrast: 30.24862537349827,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 48.5
        },
        "positive.1400": {
            contrast: 26.884052710889367,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "positive.1500": {
            contrast: 21.98905723875936,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "positive.1600": {
            contrast: 17.659512201959977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "positive.1700": {
            contrast: 12.704516220730941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1800": {
            contrast: 7.831587465434431,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 9.684894432467082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 15.238755049283794,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "positive.2400": {
            contrast: 21.174009026089198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "positive.2500": {
            contrast: 27.157016757568712,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        }
    },
    "positive.2100": {
        "positive.100": {
            contrast: 85.0073982655697,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "positive.200": {
            contrast: 84.55339335207593,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "positive.300": {
            contrast: 82.87484599762203,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "positive.400": {
            contrast: 80.27793799123859,
            lc60: 68,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "positive.500": {
            contrast: 76.59340636503231,
            lc60: 73.5,
            lc45: 53,
            lc30: 35,
            lc10: 18
        },
        "positive.600": {
            contrast: 71.59635553238564,
            lc60: 79.5,
            lc45: 58,
            lc30: 38,
            lc10: 20
        },
        "positive.700": {
            contrast: 66.55823332766727,
            lc60: 87.5,
            lc45: 63,
            lc30: 41,
            lc10: 21
        },
        "positive.800": {
            contrast: 61.19010339343854,
            lc60: 97,
            lc45: 69.5,
            lc30: 45,
            lc10: 23
        },
        "positive.900": {
            contrast: 56.302999529764044,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25
        },
        "positive.1000": {
            contrast: 51.612765254046856,
            lc60: 100,
            lc45: 84.5,
            lc30: 53.5,
            lc10: 27.5
        },
        "positive.1100": {
            contrast: 46.75970283285181,
            lc60: 100,
            lc45: 95,
            lc30: 60.5,
            lc10: 30.5
        },
        "positive.1200": {
            contrast: 41.70979547418502,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 34
        },
        "positive.1300": {
            contrast: 35.45887448110533,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "positive.1400": {
            contrast: 32.094301818496426,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 46
        },
        "positive.1500": {
            contrast: 27.199306346366427,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "positive.1600": {
            contrast: 22.869761309567046,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.1700": {
            contrast: 17.914765328338007,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "positive.1800": {
            contrast: 13.041836573041495,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.1900": {
            contrast: 7.899663312594904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 9.412945683424805,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 15.348199660230208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96.5
        },
        "positive.2500": {
            contrast: 21.33120739170973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        }
    },
    "positive.2200": {
        "positive.100": {
            contrast: 90.13522703779137,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "positive.200": {
            contrast: 89.68122212429759,
            lc60: 55.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "positive.300": {
            contrast: 88.0026747698437,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "positive.400": {
            contrast: 85.40576676346025,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "positive.500": {
            contrast: 81.72123513725397,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "positive.600": {
            contrast: 76.7241843046073,
            lc60: 73,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "positive.700": {
            contrast: 71.68606209988891,
            lc60: 80,
            lc45: 57.5,
            lc30: 38,
            lc10: 19.5
        },
        "positive.800": {
            contrast: 66.3179321656602,
            lc60: 87.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "positive.900": {
            contrast: 61.4308283019857,
            lc60: 97,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "positive.1000": {
            contrast: 56.74059402626851,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "positive.1100": {
            contrast: 51.887531605073455,
            lc60: 100,
            lc45: 83.5,
            lc30: 53,
            lc10: 27
        },
        "positive.1200": {
            contrast: 46.83762424640667,
            lc60: 100,
            lc45: 94.5,
            lc30: 60,
            lc10: 30
        },
        "positive.1300": {
            contrast: 40.58670325332699,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 35.5
        },
        "positive.1400": {
            contrast: 37.22213059071808,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 38.5
        },
        "positive.1500": {
            contrast: 32.327135118588075,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 46
        },
        "positive.1600": {
            contrast: 27.997590081788694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        },
        "positive.1700": {
            contrast: 23.042594100559658,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.1800": {
            contrast: 18.169665345263148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "positive.1900": {
            contrast: 13.027492084816556,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2000": {
            contrast: 8.047121016003276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 9.56304414108474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 15.546051872564263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 96
        }
    },
    "positive.2300": {
        "positive.100": {
            contrast: 95.21913219519756,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "positive.200": {
            contrast: 94.7651272817038,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "positive.300": {
            contrast: 93.08657992724989,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "positive.400": {
            contrast: 90.48967192086644,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "positive.500": {
            contrast: 86.80514029466016,
            lc60: 63,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "positive.600": {
            contrast: 81.80808946201351,
            lc60: 67.5,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "positive.700": {
            contrast: 76.76996725729512,
            lc60: 72.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 18.5
        },
        "positive.800": {
            contrast: 71.4018373230664,
            lc60: 80,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "positive.900": {
            contrast: 66.51473345939189,
            lc60: 86.5,
            lc45: 62,
            lc30: 40,
            lc10: 21
        },
        "positive.1000": {
            contrast: 61.82449918367471,
            lc60: 96,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "positive.1100": {
            contrast: 56.971436762479655,
            lc60: 100,
            lc45: 74,
            lc30: 47.5,
            lc10: 24
        },
        "positive.1200": {
            contrast: 51.92152940381287,
            lc60: 100,
            lc45: 83.5,
            lc30: 53,
            lc10: 27
        },
        "positive.1300": {
            contrast: 45.670608410733195,
            lc60: 100,
            lc45: 98,
            lc30: 62,
            lc10: 31
        },
        "positive.1400": {
            contrast: 42.30603574812429,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 34.5
        },
        "positive.1500": {
            contrast: 37.41104027599428,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 38.5
        },
        "positive.1600": {
            contrast: 33.08149523919489,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 45
        },
        "positive.1700": {
            contrast: 28.126499257965857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "positive.1800": {
            contrast: 23.253570502669348,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.1900": {
            contrast: 18.11139724222276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "positive.2000": {
            contrast: 13.131026173409483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2100": {
            contrast: 7.849710800194935,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 9.762242403476714,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "positive.2400": {
        "positive.100": {
            contrast: 100.6226721112042,
            lc60: 46.5,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "positive.200": {
            contrast: 100.16866719771042,
            lc60: 49.5,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "positive.300": {
            contrast: 98.49011984325652,
            lc60: 52,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13
        },
        "positive.400": {
            contrast: 95.89321183687306,
            lc60: 55,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "positive.500": {
            contrast: 92.2086802106668,
            lc60: 58,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "positive.600": {
            contrast: 87.21162937802013,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16
        },
        "positive.700": {
            contrast: 82.17350717330174,
            lc60: 67,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "positive.800": {
            contrast: 76.80537723907302,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18
        },
        "positive.900": {
            contrast: 71.91827337539853,
            lc60: 78.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "positive.1000": {
            contrast: 67.22803909968134,
            lc60: 85,
            lc45: 60.5,
            lc30: 39,
            lc10: 20.5
        },
        "positive.1100": {
            contrast: 62.374976678486284,
            lc60: 94.5,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "positive.1200": {
            contrast: 57.3250693198195,
            lc60: 100,
            lc45: 73.5,
            lc30: 47,
            lc10: 23.5
        },
        "positive.1300": {
            contrast: 51.07414832673981,
            lc60: 100,
            lc45: 85.5,
            lc30: 54,
            lc10: 27.5
        },
        "positive.1400": {
            contrast: 47.70957566413091,
            lc60: 100,
            lc45: 92,
            lc30: 58.5,
            lc10: 29.5
        },
        "positive.1500": {
            contrast: 42.8145801920009,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 34
        },
        "positive.1600": {
            contrast: 38.485035155201516,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 38
        },
        "positive.1700": {
            contrast: 33.53003917397248,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 44.5
        },
        "positive.1800": {
            contrast: 28.657110418675973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "positive.1900": {
            contrast: 23.514937158229383,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "positive.2000": {
            contrast: 18.534566089416103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "positive.2100": {
            contrast: 13.25325071620156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2200": {
            contrast: 8.050312407977803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "positive.2500": {
        "positive.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "positive.200": {
            contrast: 105.58666829919483,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "positive.300": {
            contrast: 103.90812094474093,
            lc60: 49,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "positive.400": {
            contrast: 101.3112129383575,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "positive.500": {
            contrast: 97.6266813121512,
            lc60: 54.5,
            lc45: 40,
            lc30: 27,
            lc10: 14
        },
        "positive.600": {
            contrast: 92.62963047950453,
            lc60: 58,
            lc45: 43,
            lc30: 28.5,
            lc10: 15
        },
        "positive.700": {
            contrast: 87.59150827478615,
            lc60: 62,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "positive.800": {
            contrast: 82.22337834055745,
            lc60: 66,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "positive.900": {
            contrast: 77.33627447688292,
            lc60: 71,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "positive.1000": {
            contrast: 72.64604020116575,
            lc60: 76.5,
            lc45: 54.5,
            lc30: 35.5,
            lc10: 18.5
        },
        "positive.1100": {
            contrast: 67.79297777997068,
            lc60: 84,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 20
        },
        "positive.1200": {
            contrast: 62.743070421303905,
            lc60: 93,
            lc45: 65.5,
            lc30: 42,
            lc10: 21.5
        },
        "positive.1300": {
            contrast: 56.492149428224224,
            lc60: 100,
            lc45: 74.5,
            lc30: 48,
            lc10: 24.5
        },
        "positive.1400": {
            contrast: 53.127576765615316,
            lc60: 100,
            lc45: 81,
            lc30: 51.5,
            lc10: 26.5
        },
        "positive.1500": {
            contrast: 48.23258129348531,
            lc60: 100,
            lc45: 91.5,
            lc30: 57.5,
            lc10: 29.5
        },
        "positive.1600": {
            contrast: 43.90303625668593,
            lc60: 100,
            lc45: 100,
            lc30: 65,
            lc10: 33
        },
        "positive.1700": {
            contrast: 38.94804027545689,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 37.5
        },
        "positive.1800": {
            contrast: 34.07511152016038,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 44
        },
        "positive.1900": {
            contrast: 28.932938259713787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "positive.2000": {
            contrast: 23.952567190900513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "positive.2100": {
            contrast: 18.671251817685967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "positive.2200": {
            contrast: 13.46831350946221,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2300": {
            contrast: 8.305142526869119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "positive.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$reliance = {
    "reliance.100": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 7.856643854144956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 10.835876369540113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 14.461056514547963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 18.825147752500566,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "reliance.1000": {
            contrast: 24.024746134650535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "reliance.1100": {
            contrast: 28.705247513560998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "reliance.1200": {
            contrast: 34.50998246018645,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 64.5
        },
        "reliance.1300": {
            contrast: 39.6611094790222,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 59
        },
        "reliance.1400": {
            contrast: 44.4883124407606,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 55.5
        },
        "reliance.1500": {
            contrast: 49.367323646410895,
            lc60: 100,
            lc45: 94,
            lc30: 74.5,
            lc10: 52
        },
        "reliance.1600": {
            contrast: 54.46688804543418,
            lc60: 100,
            lc45: 89,
            lc30: 70.5,
            lc10: 49
        },
        "reliance.1700": {
            contrast: 59.53586860247893,
            lc60: 100,
            lc45: 84,
            lc30: 67,
            lc10: 46.5
        },
        "reliance.1800": {
            contrast: 65.26618283360766,
            lc60: 94.5,
            lc45: 79.5,
            lc30: 63,
            lc10: 44
        },
        "reliance.1900": {
            contrast: 70.74266391151131,
            lc60: 90.5,
            lc45: 75.5,
            lc30: 60,
            lc10: 42
        },
        "reliance.2000": {
            contrast: 76.54055396842463,
            lc60: 86,
            lc45: 72.5,
            lc30: 57,
            lc10: 40
        },
        "reliance.2100": {
            contrast: 82.55763905828711,
            lc60: 82,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "reliance.2200": {
            contrast: 88.66270486383215,
            lc60: 78.5,
            lc45: 66,
            lc30: 52,
            lc10: 36.5
        },
        "reliance.2300": {
            contrast: 94.62567466648164,
            lc60: 75,
            lc45: 63,
            lc30: 50,
            lc10: 35
        },
        "reliance.2400": {
            contrast: 101.09702089769303,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "reliance.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "reliance.200": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 7.341036864282781,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 10.320269379677939,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 13.945449524685788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 18.30954076263839,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "reliance.1000": {
            contrast: 23.509139144788357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "reliance.1100": {
            contrast: 28.189640523698824,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "reliance.1200": {
            contrast: 33.99437547032427,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 61
        },
        "reliance.1300": {
            contrast: 39.14550248916002,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 56
        },
        "reliance.1400": {
            contrast: 43.97270545089843,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 52.5
        },
        "reliance.1500": {
            contrast: 48.851716656548724,
            lc60: 100,
            lc45: 94.5,
            lc30: 73.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 53.951281055572,
            lc60: 100,
            lc45: 88.5,
            lc30: 69,
            lc10: 46
        },
        "reliance.1700": {
            contrast: 59.02026161261675,
            lc60: 100,
            lc45: 84,
            lc30: 65,
            lc10: 44
        },
        "reliance.1800": {
            contrast: 64.75057584374548,
            lc60: 95,
            lc45: 79,
            lc30: 61.5,
            lc10: 41
        },
        "reliance.1900": {
            contrast: 70.22705692164915,
            lc60: 90,
            lc45: 75,
            lc30: 58.5,
            lc10: 39.5
        },
        "reliance.2000": {
            contrast: 76.02494697856244,
            lc60: 85.5,
            lc45: 71.5,
            lc30: 55.5,
            lc10: 37.5
        },
        "reliance.2100": {
            contrast: 82.04203206842493,
            lc60: 81.5,
            lc45: 68,
            lc30: 53,
            lc10: 35.5
        },
        "reliance.2200": {
            contrast: 88.14709787396997,
            lc60: 77.5,
            lc45: 65,
            lc30: 50.5,
            lc10: 34
        },
        "reliance.2300": {
            contrast: 94.11006767661945,
            lc60: 74.5,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 32.5
        },
        "reliance.2400": {
            contrast: 100.58141390783086,
            lc60: 71.5,
            lc45: 59.5,
            lc30: 46.5,
            lc10: 31.5
        },
        "reliance.2500": {
            contrast: 107.36912619323628,
            lc60: 68.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 30
        }
    },
    "reliance.300": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 8.95440937668147,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 12.579589521689321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 16.94368075964193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "reliance.1000": {
            contrast: 22.14327914179189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "reliance.1100": {
            contrast: 26.82378052070235,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "reliance.1200": {
            contrast: 32.6285154673278,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 62
        },
        "reliance.1300": {
            contrast: 37.77964248616355,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 56
        },
        "reliance.1400": {
            contrast: 42.606845447901954,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 52.5
        },
        "reliance.1500": {
            contrast: 47.48585665355225,
            lc60: 100,
            lc45: 96.5,
            lc30: 74.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 52.58542105257553,
            lc60: 100,
            lc45: 90,
            lc30: 70,
            lc10: 46
        },
        "reliance.1700": {
            contrast: 57.65440160962028,
            lc60: 100,
            lc45: 85.5,
            lc30: 65.5,
            lc10: 43.5
        },
        "reliance.1800": {
            contrast: 63.38471584074901,
            lc60: 96,
            lc45: 80,
            lc30: 62,
            lc10: 41
        },
        "reliance.1900": {
            contrast: 68.86119691865267,
            lc60: 91,
            lc45: 76,
            lc30: 59,
            lc10: 39
        },
        "reliance.2000": {
            contrast: 74.65908697556598,
            lc60: 86.5,
            lc45: 72,
            lc30: 56,
            lc10: 37.5
        },
        "reliance.2100": {
            contrast: 80.67617206542846,
            lc60: 82.5,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 35.5
        },
        "reliance.2200": {
            contrast: 86.7812378709735,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34
        },
        "reliance.2300": {
            contrast: 92.744207673623,
            lc60: 75,
            lc45: 63,
            lc30: 49,
            lc10: 32.5
        },
        "reliance.2400": {
            contrast: 99.21555390483438,
            lc60: 72,
            lc45: 60,
            lc30: 47,
            lc10: 31.5
        },
        "reliance.2500": {
            contrast: 106.00326619023983,
            lc60: 69,
            lc45: 57.5,
            lc30: 45,
            lc10: 30
        }
    },
    "reliance.400": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 10.883582980947978,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 15.247674218900581,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "reliance.1000": {
            contrast: 20.44727260105055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "reliance.1100": {
            contrast: 25.12777397996101,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "reliance.1200": {
            contrast: 30.932508926586454,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 62
        },
        "reliance.1300": {
            contrast: 36.08363594542221,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 56.5
        },
        "reliance.1400": {
            contrast: 40.91083890716061,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 52.5
        },
        "reliance.1500": {
            contrast: 45.78985011281091,
            lc60: 100,
            lc45: 98.5,
            lc30: 75.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 50.88941451183418,
            lc60: 100,
            lc45: 92,
            lc30: 71,
            lc10: 45.5
        },
        "reliance.1700": {
            contrast: 55.95839506887893,
            lc60: 100,
            lc45: 86.5,
            lc30: 66.5,
            lc10: 43.5
        },
        "reliance.1800": {
            contrast: 61.68870930000766,
            lc60: 97.5,
            lc45: 81,
            lc30: 62.5,
            lc10: 40.5
        },
        "reliance.1900": {
            contrast: 67.16519037791133,
            lc60: 92.5,
            lc45: 77,
            lc30: 59.5,
            lc10: 38.5
        },
        "reliance.2000": {
            contrast: 72.96308043482463,
            lc60: 87.5,
            lc45: 73,
            lc30: 56.5,
            lc10: 37
        },
        "reliance.2100": {
            contrast: 78.98016552468711,
            lc60: 83.5,
            lc45: 69.5,
            lc30: 53.5,
            lc10: 35
        },
        "reliance.2200": {
            contrast: 85.08523133023216,
            lc60: 79.5,
            lc45: 66,
            lc30: 51,
            lc10: 33.5
        },
        "reliance.2300": {
            contrast: 91.04820113288164,
            lc60: 76,
            lc45: 63,
            lc30: 49,
            lc10: 32
        },
        "reliance.2400": {
            contrast: 97.51954736409304,
            lc60: 72.5,
            lc45: 60,
            lc30: 47,
            lc10: 30.5
        },
        "reliance.2500": {
            contrast: 104.30725964949848,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44.5,
            lc10: 29.5
        }
    },
    "reliance.500": {
        "reliance.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 8.517088332861753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 12.881179570814357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 18.080777952964322,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "reliance.1100": {
            contrast: 22.761279331874785,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "reliance.1200": {
            contrast: 28.56601427850023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1300": {
            contrast: 33.717141297335985,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 56.5
        },
        "reliance.1400": {
            contrast: 38.544344259074386,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 52
        },
        "reliance.1500": {
            contrast: 43.423355464724686,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 47.5
        },
        "reliance.1600": {
            contrast: 48.52291986374796,
            lc60: 100,
            lc45: 94.5,
            lc30: 71.5,
            lc10: 44.5
        },
        "reliance.1700": {
            contrast: 53.591900420792705,
            lc60: 100,
            lc45: 88.5,
            lc30: 66.5,
            lc10: 42
        },
        "reliance.1800": {
            contrast: 59.322214651921435,
            lc60: 100,
            lc45: 82.5,
            lc30: 63,
            lc10: 39
        },
        "reliance.1900": {
            contrast: 64.79869572982511,
            lc60: 95,
            lc45: 78,
            lc30: 59,
            lc10: 37
        },
        "reliance.2000": {
            contrast: 70.5965857867384,
            lc60: 89.5,
            lc45: 73.5,
            lc30: 56,
            lc10: 35.5
        },
        "reliance.2100": {
            contrast: 76.61367087660088,
            lc60: 84.5,
            lc45: 69.5,
            lc30: 53,
            lc10: 33.5
        },
        "reliance.2200": {
            contrast: 82.71873668214593,
            lc60: 80,
            lc45: 66,
            lc30: 50,
            lc10: 32
        },
        "reliance.2300": {
            contrast: 88.68170648479541,
            lc60: 76.5,
            lc45: 63,
            lc30: 48,
            lc10: 30.5
        },
        "reliance.2400": {
            contrast: 95.1530527160068,
            lc60: 73,
            lc45: 60,
            lc30: 46,
            lc10: 29
        },
        "reliance.2500": {
            contrast: 101.94076500141225,
            lc60: 69.5,
            lc45: 57.5,
            lc30: 44,
            lc10: 28
        }
    },
    "reliance.600": {
        "reliance.100": {
            contrast: 9.159734176051897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 8.469581752447437,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 9.617962314912052,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 14.817560697062019,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 19.498062075972484,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "reliance.1200": {
            contrast: 25.30279702259793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "reliance.1300": {
            contrast: 30.453924041433684,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 59.5
        },
        "reliance.1400": {
            contrast: 35.28112700317209,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 54
        },
        "reliance.1500": {
            contrast: 40.16013820882238,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 49
        },
        "reliance.1600": {
            contrast: 45.25970260784566,
            lc60: 100,
            lc45: 99.5,
            lc30: 74.5,
            lc10: 45.5
        },
        "reliance.1700": {
            contrast: 50.32868316489041,
            lc60: 100,
            lc45: 92,
            lc30: 69,
            lc10: 42
        },
        "reliance.1800": {
            contrast: 56.05899739601914,
            lc60: 100,
            lc45: 85.5,
            lc30: 64.5,
            lc10: 39.5
        },
        "reliance.1900": {
            contrast: 61.5354784739228,
            lc60: 98,
            lc45: 80,
            lc30: 60.5,
            lc10: 37
        },
        "reliance.2000": {
            contrast: 67.33336853083611,
            lc60: 92,
            lc45: 75,
            lc30: 57,
            lc10: 35
        },
        "reliance.2100": {
            contrast: 73.35045362069859,
            lc60: 86.5,
            lc45: 71,
            lc30: 53.5,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 79.45551942624363,
            lc60: 82,
            lc45: 67,
            lc30: 51,
            lc10: 31.5
        },
        "reliance.2300": {
            contrast: 85.41848922889312,
            lc60: 78.5,
            lc45: 64,
            lc30: 48.5,
            lc10: 30.5
        },
        "reliance.2400": {
            contrast: 91.8898354601045,
            lc60: 74.5,
            lc45: 61,
            lc30: 46,
            lc10: 29
        },
        "reliance.2500": {
            contrast: 98.67754774550995,
            lc60: 70.5,
            lc45: 58,
            lc30: 44,
            lc10: 27.5
        }
    },
    "reliance.700": {
        "reliance.100": {
            contrast: 12.425150850610489,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.200": {
            contrast: 11.734998427006033,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.300": {
            contrast: 9.956655422166113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 7.825124480429977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 11.98217678016585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 16.662678159076314,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "reliance.1200": {
            contrast: 22.467413105701763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "reliance.1300": {
            contrast: 27.61854012453751,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1400": {
            contrast: 32.44574308627592,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 56.5
        },
        "reliance.1500": {
            contrast: 37.32475429192621,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 50.5
        },
        "reliance.1600": {
            contrast: 42.424318690949484,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 47
        },
        "reliance.1700": {
            contrast: 47.49329924799424,
            lc60: 100,
            lc45: 96,
            lc30: 71.5,
            lc10: 43
        },
        "reliance.1800": {
            contrast: 53.22361347912297,
            lc60: 100,
            lc45: 88.5,
            lc30: 66.5,
            lc10: 39.5
        },
        "reliance.1900": {
            contrast: 58.70009455702663,
            lc60: 100,
            lc45: 82.5,
            lc30: 62,
            lc10: 37.5
        },
        "reliance.2000": {
            contrast: 64.49798461393993,
            lc60: 95,
            lc45: 77.5,
            lc30: 58,
            lc10: 35.5
        },
        "reliance.2100": {
            contrast: 70.51506970380241,
            lc60: 89,
            lc45: 72.5,
            lc30: 54.5,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 76.62013550934745,
            lc60: 84,
            lc45: 68.5,
            lc30: 51.5,
            lc10: 31.5
        },
        "reliance.2300": {
            contrast: 82.58310531199696,
            lc60: 80,
            lc45: 65,
            lc30: 49,
            lc10: 30
        },
        "reliance.2400": {
            contrast: 89.05445154320834,
            lc60: 76,
            lc45: 61.5,
            lc30: 46.5,
            lc10: 28.5
        },
        "reliance.2500": {
            contrast: 95.84216382861376,
            lc60: 71.5,
            lc45: 58.5,
            lc30: 44,
            lc10: 27
        }
    },
    "reliance.800": {
        "reliance.100": {
            contrast: 16.32482826475614,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "reliance.200": {
            contrast: 15.63467584115168,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90
        },
        "reliance.300": {
            contrast: 13.856332836311763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.400": {
            contrast: 11.724801894575629,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.500": {
            contrast: 8.853209290266378,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 8.499568335620138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 13.180069714530601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 18.98480466115605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "reliance.1300": {
            contrast: 24.135931679991803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "reliance.1400": {
            contrast: 28.963134641730203,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "reliance.1500": {
            contrast: 33.8421458473805,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 53.5
        },
        "reliance.1600": {
            contrast: 38.94171024640378,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 48
        },
        "reliance.1700": {
            contrast: 44.010690803448526,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 44.5
        },
        "reliance.1800": {
            contrast: 49.741005034577256,
            lc60: 100,
            lc45: 93,
            lc30: 68.5,
            lc10: 40.5
        },
        "reliance.1900": {
            contrast: 55.21748611248092,
            lc60: 100,
            lc45: 86,
            lc30: 63.5,
            lc10: 37.5
        },
        "reliance.2000": {
            contrast: 61.01537616939423,
            lc60: 98.5,
            lc45: 79.5,
            lc30: 59,
            lc10: 35
        },
        "reliance.2100": {
            contrast: 67.0324612592567,
            lc60: 92,
            lc45: 74.5,
            lc30: 55,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 73.13752706480174,
            lc60: 86,
            lc45: 70,
            lc30: 52,
            lc10: 31
        },
        "reliance.2300": {
            contrast: 79.10049686745124,
            lc60: 81.5,
            lc45: 66.5,
            lc30: 49,
            lc10: 29.5
        },
        "reliance.2400": {
            contrast: 85.57184309866263,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 46.5,
            lc10: 28
        },
        "reliance.2500": {
            contrast: 92.35955538406806,
            lc60: 73.5,
            lc45: 59.5,
            lc30: 44,
            lc10: 26.5
        }
    },
    "reliance.900": {
        "reliance.100": {
            contrast: 20.932484243351336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "reliance.200": {
            contrast: 20.242331819746877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "reliance.300": {
            contrast: 18.46398881490696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "reliance.400": {
            contrast: 16.33245787317082,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86.5
        },
        "reliance.500": {
            contrast: 13.460865268861575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.600": {
            contrast: 9.642652374995965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 8.948268689246776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 14.753003635872226,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 19.904130654707977,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "reliance.1400": {
            contrast: 24.73133361644638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "reliance.1500": {
            contrast: 29.610344822096675,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "reliance.1600": {
            contrast: 34.70990922111995,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 51.5
        },
        "reliance.1700": {
            contrast: 39.7788897781647,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 46
        },
        "reliance.1800": {
            contrast: 45.50920400929343,
            lc60: 100,
            lc45: 98.5,
            lc30: 72.5,
            lc10: 41.5
        },
        "reliance.1900": {
            contrast: 50.9856850871971,
            lc60: 100,
            lc45: 91,
            lc30: 66.5,
            lc10: 38
        },
        "reliance.2000": {
            contrast: 56.7835751441104,
            lc60: 100,
            lc45: 83.5,
            lc30: 61,
            lc10: 35
        },
        "reliance.2100": {
            contrast: 62.800660233972884,
            lc60: 96.5,
            lc45: 77.5,
            lc30: 57,
            lc10: 33
        },
        "reliance.2200": {
            contrast: 68.90572603951793,
            lc60: 90,
            lc45: 72.5,
            lc30: 53,
            lc10: 31
        },
        "reliance.2300": {
            contrast: 74.86869584216741,
            lc60: 84.5,
            lc45: 68,
            lc30: 50,
            lc10: 29.5
        },
        "reliance.2400": {
            contrast: 81.3400420733788,
            lc60: 79.5,
            lc45: 64,
            lc30: 47,
            lc10: 27.5
        },
        "reliance.2500": {
            contrast: 88.12775435878424,
            lc60: 75,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26
        }
    },
    "reliance.1000": {
        "reliance.100": {
            contrast: 26.32185940334617,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 40
        },
        "reliance.200": {
            contrast: 25.631706979741715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 47
        },
        "reliance.300": {
            contrast: 23.8533639749018,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "reliance.400": {
            contrast: 21.721833033165662,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "reliance.500": {
            contrast: 18.850240428856416,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "reliance.600": {
            contrast: 15.032027534990808,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "reliance.700": {
            contrast: 11.813788892071228,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.800": {
            contrast: 7.958435699012307,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 9.664268140783633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 14.815395159619385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 19.64259812135779,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "reliance.1500": {
            contrast: 24.521609327008083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1600": {
            contrast: 29.62117372603136,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "reliance.1700": {
            contrast: 34.690154283076104,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 50.5
        },
        "reliance.1800": {
            contrast: 40.420468514204835,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 45
        },
        "reliance.1900": {
            contrast: 45.8969495921085,
            lc60: 100,
            lc45: 98.5,
            lc30: 71,
            lc10: 41
        },
        "reliance.2000": {
            contrast: 51.69483964902181,
            lc60: 100,
            lc45: 90,
            lc30: 65,
            lc10: 37
        },
        "reliance.2100": {
            contrast: 57.71192473888428,
            lc60: 100,
            lc45: 82,
            lc30: 59.5,
            lc10: 34.5
        },
        "reliance.2200": {
            contrast: 63.81699054442933,
            lc60: 95,
            lc45: 76,
            lc30: 55.5,
            lc10: 31.5
        },
        "reliance.2300": {
            contrast: 69.77996034707881,
            lc60: 89,
            lc45: 71,
            lc30: 52,
            lc10: 29.5
        },
        "reliance.2400": {
            contrast: 76.2513065782902,
            lc60: 83.5,
            lc45: 66.5,
            lc30: 48.5,
            lc10: 28
        },
        "reliance.2500": {
            contrast: 83.03901886369565,
            lc60: 77.5,
            lc45: 62.5,
            lc30: 45.5,
            lc10: 26
        }
    },
    "reliance.1100": {
        "reliance.100": {
            contrast: 31.096032936607216,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 34
        },
        "reliance.200": {
            contrast: 30.40588051300276,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 39.5
        },
        "reliance.300": {
            contrast: 28.627537508162842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 43.5
        },
        "reliance.400": {
            contrast: 26.496006566426704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "reliance.500": {
            contrast: 23.624413962117462,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "reliance.600": {
            contrast: 19.80620106825185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "reliance.700": {
            contrast: 16.58796242533227,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "reliance.800": {
            contrast: 12.73260923227335,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.900": {
            contrast: 8.16311965898063,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 10.197841535704175,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 15.02504449744258,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "reliance.1500": {
            contrast: 19.904055703092872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "reliance.1600": {
            contrast: 25.003620102116148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "reliance.1700": {
            contrast: 30.072600659160898,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 56
        },
        "reliance.1800": {
            contrast: 35.80291489028963,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 48.5
        },
        "reliance.1900": {
            contrast: 41.27939596819329,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 43.5
        },
        "reliance.2000": {
            contrast: 47.0772860251066,
            lc60: 100,
            lc45: 96.5,
            lc30: 69.5,
            lc10: 39
        },
        "reliance.2100": {
            contrast: 53.09437111496907,
            lc60: 100,
            lc45: 88,
            lc30: 63,
            lc10: 35.5
        },
        "reliance.2200": {
            contrast: 59.19943692051412,
            lc60: 100,
            lc45: 80.5,
            lc30: 58,
            lc10: 32.5
        },
        "reliance.2300": {
            contrast: 65.16240672316361,
            lc60: 93.5,
            lc45: 74.5,
            lc30: 54,
            lc10: 30.5
        },
        "reliance.2400": {
            contrast: 71.63375295437501,
            lc60: 86.5,
            lc45: 69,
            lc30: 50,
            lc10: 28.5
        },
        "reliance.2500": {
            contrast: 78.42146523978043,
            lc60: 81,
            lc45: 64.5,
            lc30: 47,
            lc10: 26.5
        }
    },
    "reliance.1200": {
        "reliance.100": {
            contrast: 36.93189382981721,
            lc60: 100,
            lc45: 100,
            lc30: 61,
            lc10: 30
        },
        "reliance.200": {
            contrast: 36.24174140621276,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 33
        },
        "reliance.300": {
            contrast: 34.46339840137284,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 36
        },
        "reliance.400": {
            contrast: 32.331867459636705,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 39.5
        },
        "reliance.500": {
            contrast: 29.460274855327455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46
        },
        "reliance.600": {
            contrast: 25.64206196146185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "reliance.700": {
            contrast: 22.423823318542272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "reliance.800": {
            contrast: 18.56847012548335,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "reliance.900": {
            contrast: 13.998980552190632,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1000": {
            contrast: 8.637776269582023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 9.256795765804524,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 14.135806971454818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 19.235371370478095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "reliance.1700": {
            contrast: 24.304351927522845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1800": {
            contrast: 30.034666158651568,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 55
        },
        "reliance.1900": {
            contrast: 35.51114723655523,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48.5
        },
        "reliance.2000": {
            contrast: 41.30903729346854,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "reliance.2100": {
            contrast: 47.32612238333102,
            lc60: 100,
            lc45: 95.5,
            lc30: 68.5,
            lc10: 38
        },
        "reliance.2200": {
            contrast: 53.431188188876064,
            lc60: 100,
            lc45: 87,
            lc30: 62,
            lc10: 34.5
        },
        "reliance.2300": {
            contrast: 59.39415799152555,
            lc60: 100,
            lc45: 79.5,
            lc30: 57.5,
            lc10: 32
        },
        "reliance.2400": {
            contrast: 65.86550422273693,
            lc60: 92.5,
            lc45: 73.5,
            lc30: 53,
            lc10: 29.5
        },
        "reliance.2500": {
            contrast: 72.65321650814238,
            lc60: 85.5,
            lc45: 68,
            lc30: 49,
            lc10: 27
        }
    },
    "reliance.1300": {
        "reliance.100": {
            contrast: 42.04291669605252,
            lc60: 100,
            lc45: 100,
            lc30: 53.5,
            lc10: 26
        },
        "reliance.200": {
            contrast: 41.35276427244807,
            lc60: 100,
            lc45: 100,
            lc30: 58.5,
            lc10: 29
        },
        "reliance.300": {
            contrast: 39.57442126760816,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31
        },
        "reliance.400": {
            contrast: 37.44289032587202,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 33.5
        },
        "reliance.500": {
            contrast: 34.57129772156277,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 38.5
        },
        "reliance.600": {
            contrast: 30.75308482769716,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 44.5
        },
        "reliance.700": {
            contrast: 27.534846184777585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "reliance.800": {
            contrast: 23.67949299171866,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "reliance.900": {
            contrast: 19.110003418425944,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "reliance.1000": {
            contrast: 13.748799135817336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1100": {
            contrast: 8.986869667605193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 8.983269929958148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 14.082834328981427,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 19.151814886026173,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "reliance.1800": {
            contrast: 24.882129117154903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "reliance.1900": {
            contrast: 30.358610195058567,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 54.5
        },
        "reliance.2000": {
            contrast: 36.15650025197187,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 47
        },
        "reliance.2100": {
            contrast: 42.173585341834354,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 41.5
        },
        "reliance.2200": {
            contrast: 48.27865114737939,
            lc60: 100,
            lc45: 94,
            lc30: 67,
            lc10: 37
        },
        "reliance.2300": {
            contrast: 54.24162095002889,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 34
        },
        "reliance.2400": {
            contrast: 60.71296718124027,
            lc60: 99,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 31
        },
        "reliance.2500": {
            contrast: 67.5006794666457,
            lc60: 90.5,
            lc45: 72,
            lc30: 51,
            lc10: 28.5
        }
    },
    "reliance.1400": {
        "reliance.100": {
            contrast: 46.78205852633386,
            lc60: 100,
            lc45: 82,
            lc30: 47.5,
            lc10: 24
        },
        "reliance.200": {
            contrast: 46.09190610272941,
            lc60: 100,
            lc45: 91.5,
            lc30: 52,
            lc10: 26
        },
        "reliance.300": {
            contrast: 44.31356309788949,
            lc60: 100,
            lc45: 100,
            lc30: 55.5,
            lc10: 27
        },
        "reliance.400": {
            contrast: 42.182032156153355,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29
        },
        "reliance.500": {
            contrast: 39.310439551844105,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 33
        },
        "reliance.600": {
            contrast: 35.492226657978506,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38
        },
        "reliance.700": {
            contrast: 32.27398801505892,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 42
        },
        "reliance.800": {
            contrast: 28.418634821999994,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "reliance.900": {
            contrast: 23.849145248707284,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "reliance.1000": {
            contrast: 18.487940966098677,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "reliance.1100": {
            contrast: 13.726011497886532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1200": {
            contrast: 7.891065589828031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 9.228668612881291,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 14.297649169926038,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 20.02796340105477,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "reliance.1900": {
            contrast: 25.504444478958433,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.2000": {
            contrast: 31.30233453587174,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 53
        },
        "reliance.2100": {
            contrast: 37.31941962573421,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 45.5
        },
        "reliance.2200": {
            contrast: 43.42448543127926,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 40
        },
        "reliance.2300": {
            contrast: 49.38745523392875,
            lc60: 100,
            lc45: 92.5,
            lc30: 65.5,
            lc10: 36
        },
        "reliance.2400": {
            contrast: 55.85880146514013,
            lc60: 100,
            lc45: 83.5,
            lc30: 59,
            lc10: 32.5
        },
        "reliance.2500": {
            contrast: 62.64651375054557,
            lc60: 96.5,
            lc45: 75.5,
            lc30: 54,
            lc10: 29.5
        }
    },
    "reliance.1500": {
        "reliance.100": {
            contrast: 51.52775718343,
            lc60: 100,
            lc45: 69,
            lc30: 43.5,
            lc10: 22
        },
        "reliance.200": {
            contrast: 50.83760475982554,
            lc60: 100,
            lc45: 75,
            lc30: 47,
            lc10: 23.5
        },
        "reliance.300": {
            contrast: 49.05926175498563,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 24.5
        },
        "reliance.400": {
            contrast: 46.92773081324949,
            lc60: 100,
            lc45: 89.5,
            lc30: 53,
            lc10: 26
        },
        "reliance.500": {
            contrast: 44.05613820894024,
            lc60: 100,
            lc45: 100,
            lc30: 59.5,
            lc10: 29.5
        },
        "reliance.600": {
            contrast: 40.23792531507463,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 32.5
        },
        "reliance.700": {
            contrast: 37.01968667215505,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 36.5
        },
        "reliance.800": {
            contrast: 33.164333479096136,
            lc60: 100,
            lc45: 100,
            lc30: 87.5,
            lc10: 42
        },
        "reliance.900": {
            contrast: 28.594843905803412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50
        },
        "reliance.1000": {
            contrast: 23.233639623194804,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1100": {
            contrast: 18.471710154982667,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "reliance.1200": {
            contrast: 12.636764246924162,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1300": {
            contrast: 7.515316105721745,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 9.368538641061267,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 15.098852872189997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "reliance.1900": {
            contrast: 20.575333950093665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "reliance.2000": {
            contrast: 26.373224007006968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "reliance.2100": {
            contrast: 32.390309096869444,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 50.5
        },
        "reliance.2200": {
            contrast: 38.49537490241449,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 43.5
        },
        "reliance.2300": {
            contrast: 44.45834470506398,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 38.5
        },
        "reliance.2400": {
            contrast: 50.929690936275364,
            lc60: 100,
            lc45: 89.5,
            lc30: 63,
            lc10: 34.5
        },
        "reliance.2500": {
            contrast: 57.7174032216808,
            lc60: 100,
            lc45: 80.5,
            lc30: 56.5,
            lc10: 31
        }
    },
    "reliance.1600": {
        "reliance.100": {
            contrast: 56.44500150838022,
            lc60: 100,
            lc45: 62.5,
            lc30: 40,
            lc10: 20
        },
        "reliance.200": {
            contrast: 55.754849084775756,
            lc60: 100,
            lc45: 67,
            lc30: 43,
            lc10: 21.5
        },
        "reliance.300": {
            contrast: 53.976506079935845,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22
        },
        "reliance.400": {
            contrast: 51.844975138199715,
            lc60: 100,
            lc45: 76.5,
            lc30: 47.5,
            lc10: 23.5
        },
        "reliance.500": {
            contrast: 48.973382533890465,
            lc60: 100,
            lc45: 86.5,
            lc30: 52.5,
            lc10: 26
        },
        "reliance.600": {
            contrast: 45.15516964002485,
            lc60: 100,
            lc45: 99,
            lc30: 58.5,
            lc10: 29
        },
        "reliance.700": {
            contrast: 41.93693099710528,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 31.5
        },
        "reliance.800": {
            contrast: 38.081577804046354,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35.5
        },
        "reliance.900": {
            contrast: 33.51208823075364,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 42.5
        },
        "reliance.1000": {
            contrast: 28.15088394814503,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "reliance.1100": {
            contrast: 23.388954479932885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "reliance.1200": {
            contrast: 17.554008571874384,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "reliance.1300": {
            contrast: 12.432560430671966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1400": {
            contrast: 7.675357656130545,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 9.924458269298043,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 15.400939347201708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "reliance.2000": {
            contrast: 21.198829404115013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "reliance.2100": {
            contrast: 27.21591449397749,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "reliance.2200": {
            contrast: 33.32098029952253,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 49.5
        },
        "reliance.2300": {
            contrast: 39.28395010217202,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 43
        },
        "reliance.2400": {
            contrast: 45.755296333383406,
            lc60: 100,
            lc45: 98,
            lc30: 69,
            lc10: 38
        },
        "reliance.2500": {
            contrast: 52.543008618788846,
            lc60: 100,
            lc45: 87,
            lc30: 61.5,
            lc10: 33.5
        }
    },
    "reliance.1700": {
        "reliance.100": {
            contrast: 61.293164208485074,
            lc60: 87,
            lc45: 57,
            lc30: 36.5,
            lc10: 19
        },
        "reliance.200": {
            contrast: 60.603011784880614,
            lc60: 94.5,
            lc45: 61,
            lc30: 39,
            lc10: 19.5
        },
        "reliance.300": {
            contrast: 58.8246687800407,
            lc60: 100,
            lc45: 63.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "reliance.400": {
            contrast: 56.693137838304565,
            lc60: 100,
            lc45: 67.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "reliance.500": {
            contrast: 53.821545233995316,
            lc60: 100,
            lc45: 75.5,
            lc30: 47,
            lc10: 23.5
        },
        "reliance.600": {
            contrast: 50.0033323401297,
            lc60: 100,
            lc45: 84,
            lc30: 51.5,
            lc10: 26
        },
        "reliance.700": {
            contrast: 46.78509369721013,
            lc60: 100,
            lc45: 94,
            lc30: 56.5,
            lc10: 28.5
        },
        "reliance.800": {
            contrast: 42.92974050415121,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "reliance.900": {
            contrast: 38.36025093085849,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "reliance.1000": {
            contrast: 32.99904664824988,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 44
        },
        "reliance.1100": {
            contrast: 28.237117180037735,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "reliance.1200": {
            contrast: 22.402171271979242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1300": {
            contrast: 17.28072313077682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "reliance.1400": {
            contrast: 12.523520356235398,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1500": {
            contrast: 7.752351505892483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 10.236621052631692,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 16.034511109544997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "reliance.2100": {
            contrast: 22.051596199407474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "reliance.2200": {
            contrast: 28.156662004952516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "reliance.2300": {
            contrast: 34.119631807602005,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 48
        },
        "reliance.2400": {
            contrast: 40.59097803881339,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 41.5
        },
        "reliance.2500": {
            contrast: 47.37869032421883,
            lc60: 100,
            lc45: 95.5,
            lc30: 66.5,
            lc10: 36
        }
    },
    "reliance.1800": {
        "reliance.100": {
            contrast: 66.7304987086115,
            lc60: 73.5,
            lc45: 52,
            lc30: 34,
            lc10: 17
        },
        "reliance.200": {
            contrast: 66.04034628500705,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18.5
        },
        "reliance.300": {
            contrast: 64.26200328016714,
            lc60: 83,
            lc45: 57.5,
            lc30: 36.5,
            lc10: 19
        },
        "reliance.400": {
            contrast: 62.130472338431,
            lc60: 90,
            lc45: 60,
            lc30: 38.5,
            lc10: 19.5
        },
        "reliance.500": {
            contrast: 59.25887973412174,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 21
        },
        "reliance.600": {
            contrast: 55.440666840256135,
            lc60: 100,
            lc45: 73,
            lc30: 45.5,
            lc10: 23
        },
        "reliance.700": {
            contrast: 52.222428197336555,
            lc60: 100,
            lc45: 80,
            lc30: 50,
            lc10: 25
        },
        "reliance.800": {
            contrast: 48.36707500427765,
            lc60: 100,
            lc45: 90,
            lc30: 55,
            lc10: 28
        },
        "reliance.900": {
            contrast: 43.797585430984924,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "reliance.1000": {
            contrast: 38.43638114837631,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36.5
        },
        "reliance.1100": {
            contrast: 33.67445168016417,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 42.5
        },
        "reliance.1200": {
            contrast: 27.83950577210567,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52.5
        },
        "reliance.1300": {
            contrast: 22.718057630903253,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "reliance.1400": {
            contrast: 17.96085485636183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "reliance.1500": {
            contrast: 13.189686006018913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1600": {
            contrast: 8.238874713159186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 10.173192129493366,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 16.190277219355846,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "reliance.2200": {
            contrast: 22.295343024900887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "reliance.2300": {
            contrast: 28.258312827550373,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "reliance.2400": {
            contrast: 34.72965905876176,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 47.5
        },
        "reliance.2500": {
            contrast: 41.517371344167195,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 40.5
        }
    },
    "reliance.1900": {
        "reliance.100": {
            contrast: 71.887561358508,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "reliance.200": {
            contrast: 71.19740893490354,
            lc60: 71,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "reliance.300": {
            contrast: 69.41906593006362,
            lc60: 74,
            lc45: 52,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.400": {
            contrast: 67.2875349883275,
            lc60: 78.5,
            lc45: 55,
            lc30: 35.5,
            lc10: 18
        },
        "reliance.500": {
            contrast: 64.41594238401824,
            lc60: 87,
            lc45: 59.5,
            lc30: 38.5,
            lc10: 19.5
        },
        "reliance.600": {
            contrast: 60.59772949015263,
            lc60: 98,
            lc45: 65,
            lc30: 41.5,
            lc10: 21.5
        },
        "reliance.700": {
            contrast: 57.37949084723305,
            lc60: 100,
            lc45: 70.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "reliance.800": {
            contrast: 53.52413765417413,
            lc60: 100,
            lc45: 78,
            lc30: 49.5,
            lc10: 25
        },
        "reliance.900": {
            contrast: 48.95464808088141,
            lc60: 100,
            lc45: 89,
            lc30: 55.5,
            lc10: 28
        },
        "reliance.1000": {
            contrast: 43.5934437982728,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 32.5
        },
        "reliance.1100": {
            contrast: 38.831514330060664,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 37
        },
        "reliance.1200": {
            contrast: 32.996568422002156,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 44
        },
        "reliance.1300": {
            contrast: 27.87512028079974,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "reliance.1400": {
            contrast: 23.11791750625832,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "reliance.1500": {
            contrast: 18.346748655915405,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "reliance.1600": {
            contrast: 13.395937363055676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1700": {
            contrast: 8.508057847409232,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 10.567230217370186,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 16.67229602291523,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "reliance.2300": {
            contrast: 22.635265825564723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "reliance.2400": {
            contrast: 29.106612056776104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "reliance.2500": {
            contrast: 35.89432434218154,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 46.5
        }
    },
    "reliance.2000": {
        "reliance.100": {
            contrast: 77.3086897650424,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "reliance.200": {
            contrast: 76.61853734143794,
            lc60: 65,
            lc45: 47,
            lc30: 30.5,
            lc10: 16
        },
        "reliance.300": {
            contrast: 74.84019433659803,
            lc60: 67,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "reliance.400": {
            contrast: 72.7086633948619,
            lc60: 70.5,
            lc45: 50.5,
            lc30: 32.5,
            lc10: 17
        },
        "reliance.500": {
            contrast: 69.83707079055263,
            lc60: 77,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "reliance.600": {
            contrast: 66.01885789668704,
            lc60: 84.5,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "reliance.700": {
            contrast: 62.80061925376745,
            lc60: 92,
            lc45: 63,
            lc30: 40.5,
            lc10: 21
        },
        "reliance.800": {
            contrast: 58.94526606070853,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 22.5
        },
        "reliance.900": {
            contrast: 54.37577648741582,
            lc60: 100,
            lc45: 77,
            lc30: 49,
            lc10: 25.5
        },
        "reliance.1000": {
            contrast: 49.01457220480721,
            lc60: 100,
            lc45: 89,
            lc30: 56,
            lc10: 28.5
        },
        "reliance.1100": {
            contrast: 44.252642736595064,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32.5
        },
        "reliance.1200": {
            contrast: 38.41769682853656,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 38
        },
        "reliance.1300": {
            contrast: 33.29624868733415,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 44.5
        },
        "reliance.1400": {
            contrast: 28.53904591279272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "reliance.1500": {
            contrast: 23.76787706244981,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "reliance.1600": {
            contrast: 18.81706576959008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "reliance.1700": {
            contrast: 13.929186253943637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1800": {
            contrast: 8.440048003314446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 10.698084096706562,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 16.66105389935605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "reliance.2400": {
            contrast: 23.132400130567436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "reliance.2500": {
            contrast: 29.92011241597287,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "reliance.2100": {
        "reliance.100": {
            contrast: 82.89599110873581,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "reliance.200": {
            contrast: 82.20583868513135,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "reliance.300": {
            contrast: 80.42749568029143,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "reliance.400": {
            contrast: 78.2959647385553,
            lc60: 64.5,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "reliance.500": {
            contrast: 75.42437213424604,
            lc60: 69.5,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "reliance.600": {
            contrast: 71.60615924038044,
            lc60: 75,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "reliance.700": {
            contrast: 68.38792059746086,
            lc60: 80.5,
            lc45: 57,
            lc30: 36.5,
            lc10: 19
        },
        "reliance.800": {
            contrast: 64.53256740440195,
            lc60: 88.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "reliance.900": {
            contrast: 59.963077831109224,
            lc60: 100,
            lc45: 69,
            lc30: 44,
            lc10: 23
        },
        "reliance.1000": {
            contrast: 54.60187354850061,
            lc60: 100,
            lc45: 78,
            lc30: 50,
            lc10: 25.5
        },
        "reliance.1100": {
            contrast: 49.83994408028847,
            lc60: 100,
            lc45: 88,
            lc30: 56,
            lc10: 28.5
        },
        "reliance.1200": {
            contrast: 44.00499817222997,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 33
        },
        "reliance.1300": {
            contrast: 38.88355003102755,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 38
        },
        "reliance.1400": {
            contrast: 34.12634725648613,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 44.5
        },
        "reliance.1500": {
            contrast: 29.35517840614321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "reliance.1600": {
            contrast: 24.404367113283485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "reliance.1700": {
            contrast: 19.51648759763704,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "reliance.1800": {
            contrast: 14.027349347007853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.1900": {
            contrast: 8.814541763707792,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 10.439503187790814,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 16.9108494190022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "reliance.2500": {
            contrast: 23.698561704407638,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        }
    },
    "reliance.2200": {
        "reliance.100": {
            contrast: 88.52759546049491,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "reliance.200": {
            contrast: 87.83744303689043,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14
        },
        "reliance.300": {
            contrast: 86.05910003205052,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "reliance.400": {
            contrast: 83.92756909031439,
            lc60: 59,
            lc45: 43,
            lc30: 28,
            lc10: 14.5
        },
        "reliance.500": {
            contrast: 81.05597648600514,
            lc60: 63,
            lc45: 46,
            lc30: 30,
            lc10: 15.5
        },
        "reliance.600": {
            contrast: 77.23776359213953,
            lc60: 68,
            lc45: 48.5,
            lc30: 32,
            lc10: 16.5
        },
        "reliance.700": {
            contrast: 74.01952494921996,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.800": {
            contrast: 70.16417175616104,
            lc60: 79,
            lc45: 56,
            lc30: 36,
            lc10: 18.5
        },
        "reliance.900": {
            contrast: 65.59468218286831,
            lc60: 87.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "reliance.1000": {
            contrast: 60.2334779002597,
            lc60: 99.5,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "reliance.1100": {
            contrast: 55.47154843204757,
            lc60: 100,
            lc45: 76.5,
            lc30: 50,
            lc10: 25.5
        },
        "reliance.1200": {
            contrast: 49.63660252398906,
            lc60: 100,
            lc45: 88,
            lc30: 56.5,
            lc10: 29
        },
        "reliance.1300": {
            contrast: 44.51515438278664,
            lc60: 100,
            lc45: 100,
            lc30: 64.5,
            lc10: 33
        },
        "reliance.1400": {
            contrast: 39.75795160824522,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 37.5
        },
        "reliance.1500": {
            contrast: 34.986782757902304,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 43.5
        },
        "reliance.1600": {
            contrast: 30.03597146504258,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 51.5
        },
        "reliance.1700": {
            contrast: 25.148091949396132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "reliance.1800": {
            contrast: 19.658953698766947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "reliance.1900": {
            contrast: 14.446146115466888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2000": {
            contrast: 8.95993517829224,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 10.577406575736358,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 17.3651188611418,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        }
    },
    "reliance.2300": {
        "reliance.100": {
            contrast: 93.99429732830377,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "reliance.200": {
            contrast: 93.30414490469931,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13
        },
        "reliance.300": {
            contrast: 91.5258018998594,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "reliance.400": {
            contrast: 89.39427095812327,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "reliance.500": {
            contrast: 86.52267835381402,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "reliance.600": {
            contrast: 82.70446545994841,
            lc60: 62,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "reliance.700": {
            contrast: 79.48622681702882,
            lc60: 66,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "reliance.800": {
            contrast: 75.6308736239699,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.900": {
            contrast: 71.06138405067719,
            lc60: 79,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "reliance.1000": {
            contrast: 65.70017976806858,
            lc60: 87.5,
            lc45: 62,
            lc30: 41,
            lc10: 21
        },
        "reliance.1100": {
            contrast: 60.938250299856435,
            lc60: 98,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 23
        },
        "reliance.1200": {
            contrast: 55.103304391797934,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 26
        },
        "reliance.1300": {
            contrast: 49.98185625059553,
            lc60: 100,
            lc45: 87.5,
            lc30: 57,
            lc10: 29
        },
        "reliance.1400": {
            contrast: 45.224653476054094,
            lc60: 100,
            lc45: 99,
            lc30: 64.5,
            lc10: 33
        },
        "reliance.1500": {
            contrast: 40.45348462571118,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 37.5
        },
        "reliance.1600": {
            contrast: 35.50267333285145,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 43.5
        },
        "reliance.1700": {
            contrast: 30.614793817205012,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 50.5
        },
        "reliance.1800": {
            contrast: 25.125655566575816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "reliance.1900": {
            contrast: 19.91284798327576,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "reliance.2000": {
            contrast: 14.426637046101115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2100": {
            contrast: 8.765736302952277,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 11.159979652178965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "reliance.2400": {
        "reliance.100": {
            contrast: 99.89177625879418,
            lc60: 47,
            lc45: 34.5,
            lc30: 23,
            lc10: 12
        },
        "reliance.200": {
            contrast: 99.20162383518972,
            lc60: 48.5,
            lc45: 35.5,
            lc30: 24,
            lc10: 12.5
        },
        "reliance.300": {
            contrast: 97.4232808303498,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "reliance.400": {
            contrast: 95.29174988861368,
            lc60: 51,
            lc45: 37,
            lc30: 25,
            lc10: 13
        },
        "reliance.500": {
            contrast: 92.42015728430442,
            lc60: 54,
            lc45: 39.5,
            lc30: 26.5,
            lc10: 13.5
        },
        "reliance.600": {
            contrast: 88.60194439043882,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 14.5
        },
        "reliance.700": {
            contrast: 85.38370574751923,
            lc60: 60.5,
            lc45: 44,
            lc30: 29,
            lc10: 15
        },
        "reliance.800": {
            contrast: 81.52835255446031,
            lc60: 65,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "reliance.900": {
            contrast: 76.9588629811676,
            lc60: 71,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "reliance.1000": {
            contrast: 71.59765869855899,
            lc60: 79,
            lc45: 56,
            lc30: 37,
            lc10: 19.5
        },
        "reliance.1100": {
            contrast: 66.83572923034684,
            lc60: 86,
            lc45: 62,
            lc30: 40,
            lc10: 21
        },
        "reliance.1200": {
            contrast: 61.00078332228834,
            lc60: 98,
            lc45: 69.5,
            lc30: 45,
            lc10: 23.5
        },
        "reliance.1300": {
            contrast: 55.87933518108592,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 26
        },
        "reliance.1400": {
            contrast: 51.12213240654451,
            lc60: 100,
            lc45: 86.5,
            lc30: 56,
            lc10: 29
        },
        "reliance.1500": {
            contrast: 46.350963556201584,
            lc60: 100,
            lc45: 96.5,
            lc30: 63,
            lc10: 32
        },
        "reliance.1600": {
            contrast: 41.40015226334185,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36.5
        },
        "reliance.1700": {
            contrast: 36.51227274769541,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 42
        },
        "reliance.1800": {
            contrast: 31.023134497066224,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 50
        },
        "reliance.1900": {
            contrast: 25.81032691376616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "reliance.2000": {
            contrast: 20.32411597659152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75.5
        },
        "reliance.2100": {
            contrast: 14.663215233442683,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2200": {
            contrast: 8.951130795251263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "reliance.2500": {
        "reliance.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "reliance.200": {
            contrast: 105.35052078908413,
            lc60: 45.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 11.5
        },
        "reliance.300": {
            contrast: 103.57217778424423,
            lc60: 46,
            lc45: 34,
            lc30: 22.5,
            lc10: 12
        },
        "reliance.400": {
            contrast: 101.44064684250809,
            lc60: 47.5,
            lc45: 35,
            lc30: 23.5,
            lc10: 12.5
        },
        "reliance.500": {
            contrast: 98.56905423819883,
            lc60: 50.5,
            lc45: 37,
            lc30: 24.5,
            lc10: 13
        },
        "reliance.600": {
            contrast: 94.75084134433322,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13.5
        },
        "reliance.700": {
            contrast: 91.53260270141365,
            lc60: 56,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "reliance.800": {
            contrast: 87.67724950835472,
            lc60: 59.5,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "reliance.900": {
            contrast: 83.107759935062,
            lc60: 64.5,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "reliance.1000": {
            contrast: 77.7465556524534,
            lc60: 71,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "reliance.1100": {
            contrast: 72.98462618424125,
            lc60: 77,
            lc45: 56,
            lc30: 37,
            lc10: 19
        },
        "reliance.1200": {
            contrast: 67.14968027618275,
            lc60: 86,
            lc45: 62,
            lc30: 41,
            lc10: 21.5
        },
        "reliance.1300": {
            contrast: 62.028232134980335,
            lc60: 95.5,
            lc45: 68.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "reliance.1400": {
            contrast: 57.27102936043892,
            lc60: 100,
            lc45: 75.5,
            lc30: 50,
            lc10: 26
        },
        "reliance.1500": {
            contrast: 52.499860510096,
            lc60: 100,
            lc45: 83.5,
            lc30: 55,
            lc10: 29
        },
        "reliance.1600": {
            contrast: 47.54904921723627,
            lc60: 100,
            lc45: 93.5,
            lc30: 61.5,
            lc10: 32.5
        },
        "reliance.1700": {
            contrast: 42.66116970158983,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 36.5
        },
        "reliance.1800": {
            contrast: 37.17203145096064,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 42.5
        },
        "reliance.1900": {
            contrast: 31.959223867660576,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 49
        },
        "reliance.2000": {
            contrast: 26.47301293048593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "reliance.2100": {
            contrast: 20.812112187337096,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "reliance.2200": {
            contrast: 15.100027749145676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "reliance.2300": {
            contrast: 9.54949856452588,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "reliance.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$informative = {
    "informative.100": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 8.789175117329142,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 13.19911114934481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 17.805967000186975,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "informative.900": {
            contrast: 22.52800707966106,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "informative.1000": {
            contrast: 26.809005202443558,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "informative.1100": {
            contrast: 31.27864705676512,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 68
        },
        "informative.1200": {
            contrast: 36.28144539710574,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 62.5
        },
        "informative.1300": {
            contrast: 41.486392369038164,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 57.5
        },
        "informative.1400": {
            contrast: 45.9163990580774,
            lc60: 100,
            lc45: 99,
            lc30: 78,
            lc10: 54.5
        },
        "informative.1500": {
            contrast: 50.467845606301665,
            lc60: 100,
            lc45: 93.5,
            lc30: 73.5,
            lc10: 51.5
        },
        "informative.1600": {
            contrast: 55.39654801148147,
            lc60: 100,
            lc45: 88,
            lc30: 69.5,
            lc10: 48.5
        },
        "informative.1700": {
            contrast: 60.694150090667186,
            lc60: 99,
            lc45: 83,
            lc30: 66,
            lc10: 46
        },
        "informative.1800": {
            contrast: 65.81007794340718,
            lc60: 94.5,
            lc45: 79,
            lc30: 62.5,
            lc10: 44
        },
        "informative.1900": {
            contrast: 71.20477956197155,
            lc60: 89.5,
            lc45: 75.5,
            lc30: 59.5,
            lc10: 41.5
        },
        "informative.2000": {
            contrast: 76.87813201102341,
            lc60: 85.5,
            lc45: 72,
            lc30: 57,
            lc10: 39.5
        },
        "informative.2100": {
            contrast: 82.6664854845638,
            lc60: 81.5,
            lc45: 69,
            lc30: 54.5,
            lc10: 38
        },
        "informative.2200": {
            contrast: 88.8231770943698,
            lc60: 78,
            lc45: 66,
            lc30: 52,
            lc10: 36
        },
        "informative.2300": {
            contrast: 94.95831913195244,
            lc60: 75,
            lc45: 63,
            lc30: 49.5,
            lc10: 34.5
        },
        "informative.2400": {
            contrast: 101.41680411074985,
            lc60: 72,
            lc45: 60.5,
            lc30: 48,
            lc10: 33.5
        },
        "informative.2500": {
            contrast: 107.88473318309848,
            lc60: 69,
            lc45: 58,
            lc30: 46,
            lc10: 32
        }
    },
    "informative.200": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 8.416343169173128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 12.826279201188798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 17.433135052030956,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "informative.900": {
            contrast: 22.155175131505047,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "informative.1000": {
            contrast: 26.43617325428754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "informative.1100": {
            contrast: 30.905815108609104,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 64
        },
        "informative.1200": {
            contrast: 35.90861344894972,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 58.5
        },
        "informative.1300": {
            contrast: 41.11356042088215,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 53.5
        },
        "informative.1400": {
            contrast: 45.543567109921376,
            lc60: 100,
            lc45: 98.5,
            lc30: 76.5,
            lc10: 49.5
        },
        "informative.1500": {
            contrast: 50.095013658145646,
            lc60: 100,
            lc45: 93,
            lc30: 72,
            lc10: 47
        },
        "informative.1600": {
            contrast: 55.02371606332546,
            lc60: 100,
            lc45: 87.5,
            lc30: 67.5,
            lc10: 44
        },
        "informative.1700": {
            contrast: 60.32131814251118,
            lc60: 99.5,
            lc45: 82.5,
            lc30: 63.5,
            lc10: 42
        },
        "informative.1800": {
            contrast: 65.43724599525117,
            lc60: 94.5,
            lc45: 78,
            lc30: 60,
            lc10: 40
        },
        "informative.1900": {
            contrast: 70.83194761381554,
            lc60: 89.5,
            lc45: 74,
            lc30: 57,
            lc10: 38
        },
        "informative.2000": {
            contrast: 76.5053000628674,
            lc60: 85,
            lc45: 70.5,
            lc30: 54.5,
            lc10: 35.5
        },
        "informative.2100": {
            contrast: 82.29365353640779,
            lc60: 81,
            lc45: 67.5,
            lc30: 51.5,
            lc10: 34
        },
        "informative.2200": {
            contrast: 88.45034514621379,
            lc60: 77,
            lc45: 64,
            lc30: 49.5,
            lc10: 32.5
        },
        "informative.2300": {
            contrast: 94.58548718379642,
            lc60: 74,
            lc45: 61,
            lc30: 47.5,
            lc10: 31.5
        },
        "informative.2400": {
            contrast: 101.04397216259385,
            lc60: 70.5,
            lc45: 58.5,
            lc30: 45,
            lc10: 30
        },
        "informative.2500": {
            contrast: 107.51190123494246,
            lc60: 67.5,
            lc45: 56,
            lc30: 43.5,
            lc10: 28.5
        }
    },
    "informative.300": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 11.546815857768037,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 16.153671708610197,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "informative.900": {
            contrast: 20.875711788084285,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "informative.1000": {
            contrast: 25.156709910866777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "informative.1100": {
            contrast: 29.626351765188343,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "informative.1200": {
            contrast: 34.629150105528964,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 56.5
        },
        "informative.1300": {
            contrast: 39.83409707746139,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 51
        },
        "informative.1400": {
            contrast: 44.26410376650062,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 47.5
        },
        "informative.1500": {
            contrast: 48.81555031472489,
            lc60: 100,
            lc45: 94,
            lc30: 71,
            lc10: 44
        },
        "informative.1600": {
            contrast: 53.74425271990469,
            lc60: 100,
            lc45: 88,
            lc30: 66.5,
            lc10: 41.5
        },
        "informative.1700": {
            contrast: 59.04185479909042,
            lc60: 100,
            lc45: 82.5,
            lc30: 62,
            lc10: 39
        },
        "informative.1800": {
            contrast: 64.1577826518304,
            lc60: 95,
            lc45: 78,
            lc30: 58.5,
            lc10: 36.5
        },
        "informative.1900": {
            contrast: 69.55248427039477,
            lc60: 90,
            lc45: 73.5,
            lc30: 55.5,
            lc10: 34.5
        },
        "informative.2000": {
            contrast: 75.22583671944663,
            lc60: 85,
            lc45: 70,
            lc30: 53,
            lc10: 33
        },
        "informative.2100": {
            contrast: 81.01419019298703,
            lc60: 81,
            lc45: 66.5,
            lc30: 50.5,
            lc10: 31.5
        },
        "informative.2200": {
            contrast: 87.17088180279303,
            lc60: 77,
            lc45: 63,
            lc30: 47.5,
            lc10: 30
        },
        "informative.2300": {
            contrast: 93.30602384037564,
            lc60: 73.5,
            lc45: 60.5,
            lc30: 45.5,
            lc10: 28.5
        },
        "informative.2400": {
            contrast: 99.76450881917306,
            lc60: 70,
            lc45: 57.5,
            lc30: 43.5,
            lc10: 27.5
        },
        "informative.2500": {
            contrast: 106.2324378915217,
            lc60: 67.5,
            lc45: 55,
            lc30: 42,
            lc10: 26.5
        }
    },
    "informative.400": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 9.712492240346851,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 14.319348091189013,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 19.0413881706631,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "informative.1000": {
            contrast: 23.322386293445593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.1100": {
            contrast: 27.792028147767155,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "informative.1200": {
            contrast: 32.79482648810777,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 55.5
        },
        "informative.1300": {
            contrast: 37.999773460040196,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 49.5
        },
        "informative.1400": {
            contrast: 42.429780149079434,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 46
        },
        "informative.1500": {
            contrast: 46.9812266973037,
            lc60: 100,
            lc45: 96.5,
            lc30: 71.5,
            lc10: 42.5
        },
        "informative.1600": {
            contrast: 51.909929102483495,
            lc60: 100,
            lc45: 89.5,
            lc30: 66.5,
            lc10: 40
        },
        "informative.1700": {
            contrast: 57.207531181669225,
            lc60: 100,
            lc45: 83.5,
            lc30: 62,
            lc10: 37
        },
        "informative.1800": {
            contrast: 62.32345903440921,
            lc60: 97,
            lc45: 78.5,
            lc30: 58,
            lc10: 35
        },
        "informative.1900": {
            contrast: 67.71816065297358,
            lc60: 91.5,
            lc45: 74,
            lc30: 54.5,
            lc10: 33
        },
        "informative.2000": {
            contrast: 73.39151310202544,
            lc60: 86,
            lc45: 70,
            lc30: 52,
            lc10: 31
        },
        "informative.2100": {
            contrast: 79.17986657556582,
            lc60: 81.5,
            lc45: 66.5,
            lc30: 49,
            lc10: 29.5
        },
        "informative.2200": {
            contrast: 85.33655818537184,
            lc60: 77.5,
            lc45: 63,
            lc30: 47,
            lc10: 28
        },
        "informative.2300": {
            contrast: 91.47170022295447,
            lc60: 73.5,
            lc45: 60,
            lc30: 44.5,
            lc10: 27
        },
        "informative.2400": {
            contrast: 97.93018520175187,
            lc60: 70.5,
            lc45: 57.5,
            lc30: 42.5,
            lc10: 26
        },
        "informative.2500": {
            contrast: 104.39811427410051,
            lc60: 67,
            lc45: 54.5,
            lc30: 41,
            lc10: 24.5
        }
    },
    "informative.500": {
        "informative.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 11.63856099915965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 16.36060107863374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "informative.1000": {
            contrast: 20.641599201416234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "informative.1100": {
            contrast: 25.111241055737793,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "informative.1200": {
            contrast: 30.11403939607841,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 57
        },
        "informative.1300": {
            contrast: 35.31898636801084,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 50.5
        },
        "informative.1400": {
            contrast: 39.74899305705007,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 46
        },
        "informative.1500": {
            contrast: 44.300439605274335,
            lc60: 100,
            lc45: 100,
            lc30: 73,
            lc10: 42.5
        },
        "informative.1600": {
            contrast: 49.22914201045414,
            lc60: 100,
            lc45: 92.5,
            lc30: 68,
            lc10: 39
        },
        "informative.1700": {
            contrast: 54.52674408963987,
            lc60: 100,
            lc45: 86.5,
            lc30: 62.5,
            lc10: 37
        },
        "informative.1800": {
            contrast: 59.642671942379856,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 34.5
        },
        "informative.1900": {
            contrast: 65.03737356094422,
            lc60: 94,
            lc45: 75.5,
            lc30: 55.5,
            lc10: 32.5
        },
        "informative.2000": {
            contrast: 70.71072600999608,
            lc60: 88,
            lc45: 71,
            lc30: 52,
            lc10: 30.5
        },
        "informative.2100": {
            contrast: 76.49907948353646,
            lc60: 83.5,
            lc45: 67,
            lc30: 49,
            lc10: 29
        },
        "informative.2200": {
            contrast: 82.65577109334248,
            lc60: 78.5,
            lc45: 63.5,
            lc30: 46.5,
            lc10: 27.5
        },
        "informative.2300": {
            contrast: 88.79091313092509,
            lc60: 74.5,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 26
        },
        "informative.2400": {
            contrast: 95.2493981097225,
            lc60: 71,
            lc45: 57,
            lc30: 42.5,
            lc10: 25
        },
        "informative.2500": {
            contrast: 101.71732718207113,
            lc60: 67.5,
            lc45: 54.5,
            lc30: 40.5,
            lc10: 24
        }
    },
    "informative.600": {
        "informative.100": {
            contrast: 10.188489672952905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 9.688264111838475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 8.013992774415113,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 7.714156207965457,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 12.436196287439543,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 16.71719441022204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "informative.1100": {
            contrast: 21.186836264543604,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "informative.1200": {
            contrast: 26.189634604884223,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "informative.1300": {
            contrast: 31.39458157681665,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 54
        },
        "informative.1400": {
            contrast: 35.82458826585588,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48.5
        },
        "informative.1500": {
            contrast: 40.37603481408014,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 44
        },
        "informative.1600": {
            contrast: 45.304737219259955,
            lc60: 100,
            lc45: 99.5,
            lc30: 71.5,
            lc10: 41
        },
        "informative.1700": {
            contrast: 50.60233929844568,
            lc60: 100,
            lc45: 91,
            lc30: 66.5,
            lc10: 37.5
        },
        "informative.1800": {
            contrast: 55.718267151185664,
            lc60: 100,
            lc45: 84.5,
            lc30: 61.5,
            lc10: 35
        },
        "informative.1900": {
            contrast: 61.11296876975003,
            lc60: 98.5,
            lc45: 79,
            lc30: 57.5,
            lc10: 33
        },
        "informative.2000": {
            contrast: 66.78632121880189,
            lc60: 92,
            lc45: 74,
            lc30: 54,
            lc10: 31
        },
        "informative.2100": {
            contrast: 72.57467469234228,
            lc60: 86.5,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29.5
        },
        "informative.2200": {
            contrast: 78.73136630214829,
            lc60: 81,
            lc45: 65,
            lc30: 48,
            lc10: 27.5
        },
        "informative.2300": {
            contrast: 84.8665083397309,
            lc60: 77,
            lc45: 62,
            lc30: 45.5,
            lc10: 26
        },
        "informative.2400": {
            contrast: 91.32499331852831,
            lc60: 73,
            lc45: 58.5,
            lc30: 43,
            lc10: 25
        },
        "informative.2500": {
            contrast: 97.79292239087695,
            lc60: 69.5,
            lc45: 56,
            lc30: 41,
            lc10: 23.5
        }
    },
    "informative.700": {
        "informative.100": {
            contrast: 14.975527567308877,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.200": {
            contrast: 14.475302006194447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.300": {
            contrast: 12.801030668771086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.400": {
            contrast: 10.487924981675182,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 8.218810316676842,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 12.499808439459336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 16.969450293780902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "informative.1200": {
            contrast: 21.97224863412152,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.1300": {
            contrast: 27.177195606053946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "informative.1400": {
            contrast: 31.607202295093177,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "informative.1500": {
            contrast: 36.15864884331744,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 47.5
        },
        "informative.1600": {
            contrast: 41.08735124849724,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 43.5
        },
        "informative.1700": {
            contrast: 46.384953327682965,
            lc60: 100,
            lc45: 97.5,
            lc30: 69.5,
            lc10: 39.5
        },
        "informative.1800": {
            contrast: 51.500881180422965,
            lc60: 100,
            lc45: 89.5,
            lc30: 65,
            lc10: 36.5
        },
        "informative.1900": {
            contrast: 56.895582798987334,
            lc60: 100,
            lc45: 83,
            lc30: 60.5,
            lc10: 34.5
        },
        "informative.2000": {
            contrast: 62.568935248039196,
            lc60: 96.5,
            lc45: 77.5,
            lc30: 56,
            lc10: 32
        },
        "informative.2100": {
            contrast: 68.35728872157956,
            lc60: 90,
            lc45: 72.5,
            lc30: 52.5,
            lc10: 30
        },
        "informative.2200": {
            contrast: 74.51398033138558,
            lc60: 85,
            lc45: 68,
            lc30: 49.5,
            lc10: 28
        },
        "informative.2300": {
            contrast: 80.64912236896821,
            lc60: 79.5,
            lc45: 64,
            lc30: 46.5,
            lc10: 26.5
        },
        "informative.2400": {
            contrast: 87.10760734776561,
            lc60: 75,
            lc45: 60,
            lc30: 44,
            lc10: 25
        },
        "informative.2500": {
            contrast: 93.57553642011423,
            lc60: 71,
            lc45: 57,
            lc30: 42,
            lc10: 24
        }
    },
    "informative.800": {
        "informative.100": {
            contrast: 19.863947162983855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "informative.200": {
            contrast: 19.363721601869425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63.5
        },
        "informative.300": {
            contrast: 17.689450264446062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78
        },
        "informative.400": {
            contrast: 15.37634457735016,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "informative.500": {
            contrast: 12.126191027012329,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.600": {
            contrast: 7.561315757785272,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 8.043776078991547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 12.513417933313114,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 17.516216273653733,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "informative.1300": {
            contrast: 22.72116324558616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "informative.1400": {
            contrast: 27.151169934625386,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "informative.1500": {
            contrast: 31.70261648284965,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "informative.1600": {
            contrast: 36.63131888802946,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 47.5
        },
        "informative.1700": {
            contrast: 41.928920967215184,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 42
        },
        "informative.1800": {
            contrast: 47.04484881995518,
            lc60: 100,
            lc45: 96.5,
            lc30: 69.5,
            lc10: 39
        },
        "informative.1900": {
            contrast: 52.43955043851955,
            lc60: 100,
            lc45: 88.5,
            lc30: 64,
            lc10: 36
        },
        "informative.2000": {
            contrast: 58.11290288757141,
            lc60: 100,
            lc45: 82,
            lc30: 59,
            lc10: 33.5
        },
        "informative.2100": {
            contrast: 63.90125636111179,
            lc60: 94.5,
            lc45: 76,
            lc30: 55,
            lc10: 31
        },
        "informative.2200": {
            contrast: 70.0579479709178,
            lc60: 88.5,
            lc45: 71,
            lc30: 51.5,
            lc10: 29
        },
        "informative.2300": {
            contrast: 76.19309000850042,
            lc60: 83,
            lc45: 67,
            lc30: 48.5,
            lc10: 27.5
        },
        "informative.2400": {
            contrast: 82.65157498729782,
            lc60: 78.5,
            lc45: 63,
            lc30: 45.5,
            lc10: 26
        },
        "informative.2500": {
            contrast: 89.11950405964645,
            lc60: 74,
            lc45: 59.5,
            lc30: 43,
            lc10: 24.5
        }
    },
    "informative.900": {
        "informative.100": {
            contrast: 24.780455241038943,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "informative.200": {
            contrast: 24.28022967992451,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "informative.300": {
            contrast: 22.60595834250115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "informative.400": {
            contrast: 20.292852655405248,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.500": {
            contrast: 17.04269910506742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "informative.600": {
            contrast: 12.477823835840363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.700": {
            contrast: 7.752345847717625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 7.902471473996404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 12.905269814337023,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 18.110216786269447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "informative.1400": {
            contrast: 22.540223475308682,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1500": {
            contrast: 27.09167002353294,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "informative.1600": {
            contrast: 32.02037242871275,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 52.5
        },
        "informative.1700": {
            contrast: 37.31797450789847,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 46
        },
        "informative.1800": {
            contrast: 42.433902360638456,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 42.5
        },
        "informative.1900": {
            contrast: 47.82860397920283,
            lc60: 100,
            lc45: 95,
            lc30: 68.5,
            lc10: 38.5
        },
        "informative.2000": {
            contrast: 53.501956428254694,
            lc60: 100,
            lc45: 87,
            lc30: 63,
            lc10: 35.5
        },
        "informative.2100": {
            contrast: 59.29030990179507,
            lc60: 100,
            lc45: 80.5,
            lc30: 58.5,
            lc10: 32.5
        },
        "informative.2200": {
            contrast: 65.44700151160107,
            lc60: 93,
            lc45: 74.5,
            lc30: 54,
            lc10: 30.5
        },
        "informative.2300": {
            contrast: 71.58214354918371,
            lc60: 87.5,
            lc45: 70,
            lc30: 50.5,
            lc10: 29
        },
        "informative.2400": {
            contrast: 78.04062852798111,
            lc60: 81.5,
            lc45: 65.5,
            lc30: 47.5,
            lc10: 27
        },
        "informative.2500": {
            contrast: 84.50855760032974,
            lc60: 77,
            lc45: 61.5,
            lc30: 44.5,
            lc10: 25.5
        }
    },
    "informative.1000": {
        "informative.100": {
            contrast: 29.16983067219658,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 37
        },
        "informative.200": {
            contrast: 28.66960511108215,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42
        },
        "informative.300": {
            contrast: 26.995333773658786,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 49
        },
        "informative.400": {
            contrast: 24.682228086562887,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "informative.500": {
            contrast: 21.43207453622506,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "informative.600": {
            contrast: 16.867199266998004,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "informative.700": {
            contrast: 12.141721278875266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 8.692783610690435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 13.897730582622861,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 18.327737271662095,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "informative.1500": {
            contrast: 22.879183819886357,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1600": {
            contrast: 27.807886225066163,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59
        },
        "informative.1700": {
            contrast: 33.105488304251885,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 51
        },
        "informative.1800": {
            contrast: 38.22141615699188,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 45.5
        },
        "informative.1900": {
            contrast: 43.61611777555625,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41.5
        },
        "informative.2000": {
            contrast: 49.2894702246081,
            lc60: 100,
            lc45: 93,
            lc30: 67,
            lc10: 38
        },
        "informative.2100": {
            contrast: 55.077823698148485,
            lc60: 100,
            lc45: 85.5,
            lc30: 62,
            lc10: 35
        },
        "informative.2200": {
            contrast: 61.234515307954496,
            lc60: 98.5,
            lc45: 78.5,
            lc30: 57,
            lc10: 32
        },
        "informative.2300": {
            contrast: 67.36965734553712,
            lc60: 91.5,
            lc45: 73,
            lc30: 53,
            lc10: 29.5
        },
        "informative.2400": {
            contrast: 73.82814232433452,
            lc60: 85,
            lc45: 68,
            lc30: 49.5,
            lc10: 28
        },
        "informative.2500": {
            contrast: 80.29607139668316,
            lc60: 80,
            lc45: 63.5,
            lc30: 46.5,
            lc10: 26
        }
    },
    "informative.1100": {
        "informative.100": {
            contrast: 33.69400044721556,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 32
        },
        "informative.200": {
            contrast: 33.19377488610113,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 36.5
        },
        "informative.300": {
            contrast: 31.519503548677775,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 42
        },
        "informative.400": {
            contrast: 29.206397861581866,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48
        },
        "informative.500": {
            contrast: 25.956244311244042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.600": {
            contrast: 21.391369042016986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.700": {
            contrast: 16.66589105389425,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "informative.800": {
            contrast: 11.822015493836727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 9.471219716160597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 13.901226405199829,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 18.45267295342409,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "informative.1600": {
            contrast: 23.381375358603897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "informative.1700": {
            contrast: 28.678977437789616,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.1800": {
            contrast: 33.79490529052961,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 50.5
        },
        "informative.1900": {
            contrast: 39.189606909093975,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 46
        },
        "informative.2000": {
            contrast: 44.862959358145844,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 41
        },
        "informative.2100": {
            contrast: 50.651312831686226,
            lc60: 100,
            lc45: 91,
            lc30: 66,
            lc10: 37.5
        },
        "informative.2200": {
            contrast: 56.80800444149223,
            lc60: 100,
            lc45: 83,
            lc30: 60.5,
            lc10: 34
        },
        "informative.2300": {
            contrast: 62.943146479074855,
            lc60: 96,
            lc45: 77,
            lc30: 56,
            lc10: 31.5
        },
        "informative.2400": {
            contrast: 69.40163145787226,
            lc60: 89.5,
            lc45: 72,
            lc30: 52,
            lc10: 30
        },
        "informative.2500": {
            contrast: 75.8695605302209,
            lc60: 83.5,
            lc45: 67,
            lc30: 49,
            lc10: 28
        }
    },
    "informative.1200": {
        "informative.100": {
            contrast: 38.69626839442489,
            lc60: 100,
            lc45: 100,
            lc30: 58,
            lc10: 28.5
        },
        "informative.200": {
            contrast: 38.19604283331046,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 32
        },
        "informative.300": {
            contrast: 36.521771495887094,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 36.5
        },
        "informative.400": {
            contrast: 34.208665808791196,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 41
        },
        "informative.500": {
            contrast: 30.958512258453357,
            lc60: 100,
            lc45: 100,
            lc30: 96.5,
            lc10: 47.5
        },
        "informative.600": {
            contrast: 26.393636989226305,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.700": {
            contrast: 21.668159001103575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.800": {
            contrast: 16.82428344104605,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "informative.900": {
            contrast: 11.937148119873466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1000": {
            contrast: 7.562811417963229,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 8.916310245674413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 13.467756793898678,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 18.396459199078482,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "informative.1700": {
            contrast: 23.694061278264204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "informative.1800": {
            contrast: 28.809989131004194,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.1900": {
            contrast: 34.20469074956856,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 51.5
        },
        "informative.2000": {
            contrast: 39.878043198620425,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 46
        },
        "informative.2100": {
            contrast: 45.66639667216081,
            lc60: 100,
            lc45: 98.5,
            lc30: 72.5,
            lc10: 41
        },
        "informative.2200": {
            contrast: 51.82308828196681,
            lc60: 100,
            lc45: 89.5,
            lc30: 65.5,
            lc10: 37
        },
        "informative.2300": {
            contrast: 57.95823031954944,
            lc60: 100,
            lc45: 82,
            lc30: 60,
            lc10: 34
        },
        "informative.2400": {
            contrast: 64.41671529834684,
            lc60: 95,
            lc45: 76.5,
            lc30: 55,
            lc10: 31.5
        },
        "informative.2500": {
            contrast: 70.88464437069547,
            lc60: 88,
            lc45: 70.5,
            lc30: 52,
            lc10: 29.5
        }
    },
    "informative.1300": {
        "informative.100": {
            contrast: 43.84032956971635,
            lc60: 100,
            lc45: 100,
            lc30: 51,
            lc10: 25
        },
        "informative.200": {
            contrast: 43.34010400860192,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28.5
        },
        "informative.300": {
            contrast: 41.66583267117856,
            lc60: 100,
            lc45: 100,
            lc30: 64,
            lc10: 32
        },
        "informative.400": {
            contrast: 39.35272698408266,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 35.5
        },
        "informative.500": {
            contrast: 36.10257343374483,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "informative.600": {
            contrast: 31.537698164517774,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 47
        },
        "informative.700": {
            contrast: 26.812220176395034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.800": {
            contrast: 21.968344616337514,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "informative.900": {
            contrast: 17.081209295164932,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "informative.1000": {
            contrast: 12.706872593254696,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1100": {
            contrast: 8.188517386508193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 8.251091887444913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 13.179794292624722,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 18.477396371810443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "informative.1800": {
            contrast: 23.593324224550436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1900": {
            contrast: 28.9880258431148,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "informative.2000": {
            contrast: 34.66137829216666,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 52
        },
        "informative.2100": {
            contrast: 40.44973176570704,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 45.5
        },
        "informative.2200": {
            contrast: 46.60642337551305,
            lc60: 100,
            lc45: 97,
            lc30: 72,
            lc10: 41
        },
        "informative.2300": {
            contrast: 52.74156541309568,
            lc60: 100,
            lc45: 88.5,
            lc30: 65,
            lc10: 38
        },
        "informative.2400": {
            contrast: 59.200050391893086,
            lc60: 100,
            lc45: 81.5,
            lc30: 60,
            lc10: 34.5
        },
        "informative.2500": {
            contrast: 65.66797946424171,
            lc60: 93,
            lc45: 75,
            lc30: 55,
            lc10: 31.5
        }
    },
    "informative.1400": {
        "informative.100": {
            contrast: 48.17552977613624,
            lc60: 100,
            lc45: 77,
            lc30: 46.5,
            lc10: 23
        },
        "informative.200": {
            contrast: 47.67530421502181,
            lc60: 100,
            lc45: 85.5,
            lc30: 51.5,
            lc10: 26
        },
        "informative.300": {
            contrast: 46.00103287759844,
            lc60: 100,
            lc45: 95.5,
            lc30: 57.5,
            lc10: 29
        },
        "informative.400": {
            contrast: 43.68792719050254,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 32
        },
        "informative.500": {
            contrast: 40.43777364016471,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.600": {
            contrast: 35.872898370937655,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "informative.700": {
            contrast: 31.147420382814918,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 48.5
        },
        "informative.800": {
            contrast: 26.303544822757395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57.5
        },
        "informative.900": {
            contrast: 21.416409501584816,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.1000": {
            contrast: 17.042072799674578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.1100": {
            contrast: 12.523717592928078,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1200": {
            contrast: 7.517683463488603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 8.717863440809701,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 14.015465519995423,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 19.131393372735417,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "informative.1900": {
            contrast: 24.526094991299782,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "informative.2000": {
            contrast: 30.19944744035164,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 58.5
        },
        "informative.2100": {
            contrast: 35.98780091389202,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 50.5
        },
        "informative.2200": {
            contrast: 42.14449252369803,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 44.5
        },
        "informative.2300": {
            contrast: 48.27963456128066,
            lc60: 100,
            lc45: 94.5,
            lc30: 69.5,
            lc10: 40.5
        },
        "informative.2400": {
            contrast: 54.73811954007807,
            lc60: 100,
            lc45: 86.5,
            lc30: 63.5,
            lc10: 37
        },
        "informative.2500": {
            contrast: 61.20604861242669,
            lc60: 98.5,
            lc45: 79.5,
            lc30: 58,
            lc10: 33.5
        }
    },
    "informative.1500": {
        "informative.100": {
            contrast: 52.59250549408462,
            lc60: 100,
            lc45: 67.5,
            lc30: 42.5,
            lc10: 21.5
        },
        "informative.200": {
            contrast: 52.092279932970186,
            lc60: 100,
            lc45: 74,
            lc30: 47,
            lc10: 23.5
        },
        "informative.300": {
            contrast: 50.41800859554682,
            lc60: 100,
            lc45: 81.5,
            lc30: 52,
            lc10: 26
        },
        "informative.400": {
            contrast: 48.10490290845093,
            lc60: 100,
            lc45: 89.5,
            lc30: 57,
            lc10: 28.5
        },
        "informative.500": {
            contrast: 44.8547493581131,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "informative.600": {
            contrast: 40.28987408888604,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.700": {
            contrast: 35.564396100763304,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 41.5
        },
        "informative.800": {
            contrast: 30.72052054070578,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 48.5
        },
        "informative.900": {
            contrast: 25.8333852195332,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.1000": {
            contrast: 21.459048517622968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "informative.1100": {
            contrast: 16.940693310876465,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.1200": {
            contrast: 11.934659181436992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 9.412026509514765,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 14.52795436225476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 19.92265598081913,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "informative.2000": {
            contrast: 25.596008429870988,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "informative.2100": {
            contrast: 31.384361903411367,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 54
        },
        "informative.2200": {
            contrast: 37.54105351321738,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 46.5
        },
        "informative.2300": {
            contrast: 43.6761955508,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 41
        },
        "informative.2400": {
            contrast: 50.13468052959741,
            lc60: 100,
            lc45: 91.5,
            lc30: 65.5,
            lc10: 36.5
        },
        "informative.2500": {
            contrast: 56.60260960194603,
            lc60: 100,
            lc45: 83,
            lc30: 59.5,
            lc10: 33
        }
    },
    "informative.1600": {
        "informative.100": {
            contrast: 57.33701207889255,
            lc60: 100,
            lc45: 61.5,
            lc30: 39.5,
            lc10: 19.5
        },
        "informative.200": {
            contrast: 56.836786517778116,
            lc60: 100,
            lc45: 66.5,
            lc30: 43,
            lc10: 21.5
        },
        "informative.300": {
            contrast: 55.162515180354745,
            lc60: 100,
            lc45: 73,
            lc30: 47,
            lc10: 23.5
        },
        "informative.400": {
            contrast: 52.84940949325885,
            lc60: 100,
            lc45: 80,
            lc30: 51.5,
            lc10: 25.5
        },
        "informative.500": {
            contrast: 49.59925594292102,
            lc60: 100,
            lc45: 88.5,
            lc30: 56.5,
            lc10: 28.5
        },
        "informative.600": {
            contrast: 45.03438067369396,
            lc60: 100,
            lc45: 99.5,
            lc30: 63,
            lc10: 31.5
        },
        "informative.700": {
            contrast: 40.30890268557122,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36
        },
        "informative.800": {
            contrast: 35.4650271255137,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 41.5
        },
        "informative.900": {
            contrast: 30.577891804341117,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 48.5
        },
        "informative.1000": {
            contrast: 26.203555102430876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.1100": {
            contrast: 21.685199895684377,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "informative.1200": {
            contrast: 16.679165766244903,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "informative.1300": {
            contrast: 11.521216592084413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 9.522723777040563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 14.91742539560493,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 20.59077784465679,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "informative.2100": {
            contrast: 26.379131318197167,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61.5
        },
        "informative.2200": {
            contrast: 32.53582292800318,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 51.5
        },
        "informative.2300": {
            contrast: 38.6709649655858,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44.5
        },
        "informative.2400": {
            contrast: 45.12944994438321,
            lc60: 100,
            lc45: 99.5,
            lc30: 71,
            lc10: 39
        },
        "informative.2500": {
            contrast: 51.597379016731836,
            lc60: 100,
            lc45: 89.5,
            lc30: 64,
            lc10: 34.5
        }
    },
    "informative.1700": {
        "informative.100": {
            contrast: 62.395807560879526,
            lc60: 83,
            lc45: 56,
            lc30: 36,
            lc10: 18.5
        },
        "informative.200": {
            contrast: 61.895581999765085,
            lc60: 90.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "informative.300": {
            contrast: 60.22131066234172,
            lc60: 99,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "informative.400": {
            contrast: 57.908204975245816,
            lc60: 100,
            lc45: 71.5,
            lc30: 46.5,
            lc10: 23.5
        },
        "informative.500": {
            contrast: 54.65805142490798,
            lc60: 100,
            lc45: 78.5,
            lc30: 50.5,
            lc10: 25.5
        },
        "informative.600": {
            contrast: 50.09317615568093,
            lc60: 100,
            lc45: 87.5,
            lc30: 56,
            lc10: 28
        },
        "informative.700": {
            contrast: 45.367698167558196,
            lc60: 100,
            lc45: 98.5,
            lc30: 63,
            lc10: 31.5
        },
        "informative.800": {
            contrast: 40.52382260750067,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.900": {
            contrast: 35.63668728632809,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 41
        },
        "informative.1000": {
            contrast: 31.262350584417852,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 47
        },
        "informative.1100": {
            contrast: 26.743995377671354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "informative.1200": {
            contrast: 21.73796124823188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67
        },
        "informative.1300": {
            contrast: 16.580012074071387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.1400": {
            contrast: 12.225952223689408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1500": {
            contrast: 7.783578035685222,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 9.515903475087338,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 15.1892559241392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98
        },
        "informative.2100": {
            contrast: 20.977609397679583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "informative.2200": {
            contrast: 27.134301007485583,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "informative.2300": {
            contrast: 33.269443045068215,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "informative.2400": {
            contrast: 39.727928023865616,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 43.5
        },
        "informative.2500": {
            contrast: 46.19585709621424,
            lc60: 100,
            lc45: 97.5,
            lc30: 68.5,
            lc10: 38
        }
    },
    "informative.1800": {
        "informative.100": {
            contrast: 67.24433865357481,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "informative.200": {
            contrast: 66.7441130924604,
            lc60: 78.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "informative.300": {
            contrast: 65.06984175503703,
            lc60: 85.5,
            lc45: 60.5,
            lc30: 39,
            lc10: 20
        },
        "informative.400": {
            contrast: 62.75673606794112,
            lc60: 92,
            lc45: 65,
            lc30: 42,
            lc10: 21.5
        },
        "informative.500": {
            contrast: 59.50658251760329,
            lc60: 100,
            lc45: 71,
            lc30: 46,
            lc10: 23
        },
        "informative.600": {
            contrast: 54.94170724837624,
            lc60: 100,
            lc45: 78,
            lc30: 50.5,
            lc10: 25.5
        },
        "informative.700": {
            contrast: 50.2162292602535,
            lc60: 100,
            lc45: 87,
            lc30: 55.5,
            lc10: 28.5
        },
        "informative.800": {
            contrast: 45.37235370019598,
            lc60: 100,
            lc45: 98.5,
            lc30: 62.5,
            lc10: 31.5
        },
        "informative.900": {
            contrast: 40.485218379023394,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.1000": {
            contrast: 36.110881677113156,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 40.5
        },
        "informative.1100": {
            contrast: 31.592526470366657,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 46
        },
        "informative.1200": {
            contrast: 26.58649234092718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "informative.1300": {
            contrast: 21.42854316676669,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "informative.1400": {
            contrast: 17.07448331638471,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "informative.1500": {
            contrast: 12.632109128380526,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1600": {
            contrast: 7.85387567082525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 9.953226818426856,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 15.741580291967239,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "informative.2200": {
            contrast: 21.898271901773246,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "informative.2300": {
            contrast: 28.033413939355867,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "informative.2400": {
            contrast: 34.491898918153275,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 49
        },
        "informative.2500": {
            contrast: 40.9598279905019,
            lc60: 100,
            lc45: 100,
            lc30: 76,
            lc10: 42
        }
    },
    "informative.1900": {
        "informative.100": {
            contrast: 72.3210624798527,
            lc60: 66.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16
        },
        "informative.200": {
            contrast: 71.82083691873827,
            lc60: 71.5,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 17
        },
        "informative.300": {
            contrast: 70.14656558131489,
            lc60: 77.5,
            lc45: 55.5,
            lc30: 36,
            lc10: 18.5
        },
        "informative.400": {
            contrast: 67.83345989421899,
            lc60: 83.5,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "informative.500": {
            contrast: 64.58330634388115,
            lc60: 90,
            lc45: 64,
            lc30: 41.5,
            lc10: 21.5
        },
        "informative.600": {
            contrast: 60.0184310746541,
            lc60: 99.5,
            lc45: 70,
            lc30: 45.5,
            lc10: 23.5
        },
        "informative.700": {
            contrast: 55.29295308653137,
            lc60: 100,
            lc45: 77.5,
            lc30: 50,
            lc10: 25.5
        },
        "informative.800": {
            contrast: 50.44907752647384,
            lc60: 100,
            lc45: 86.5,
            lc30: 55,
            lc10: 28
        },
        "informative.900": {
            contrast: 45.56194220530126,
            lc60: 100,
            lc45: 98,
            lc30: 62,
            lc10: 31.5
        },
        "informative.1000": {
            contrast: 41.187605503391026,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "informative.1100": {
            contrast: 36.66925029664452,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 38.5
        },
        "informative.1200": {
            contrast: 31.66321616720505,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 44.5
        },
        "informative.1300": {
            contrast: 26.505266993044557,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "informative.1400": {
            contrast: 22.151207142662578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "informative.1500": {
            contrast: 17.708832954658394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "informative.1600": {
            contrast: 12.930599497103115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1700": {
            contrast: 7.829013464145687,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 10.200685875845952,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 16.35737748565196,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "informative.2300": {
            contrast: 22.492519523234584,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "informative.2400": {
            contrast: 28.951004502031992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "informative.2500": {
            contrast: 35.41893357438061,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 47
        }
    },
    "informative.2000": {
        "informative.100": {
            contrast: 77.62317302718502,
            lc60: 61.5,
            lc45: 44.5,
            lc30: 29,
            lc10: 15
        },
        "informative.200": {
            contrast: 77.12294746607058,
            lc60: 66,
            lc45: 47.5,
            lc30: 31,
            lc10: 16
        },
        "informative.300": {
            contrast: 75.44867612864722,
            lc60: 70.5,
            lc45: 51,
            lc30: 33.5,
            lc10: 17
        },
        "informative.400": {
            contrast: 73.13557044155132,
            lc60: 75.5,
            lc45: 54,
            lc30: 35.5,
            lc10: 18.5
        },
        "informative.500": {
            contrast: 69.88541689121348,
            lc60: 81,
            lc45: 58.5,
            lc30: 38,
            lc10: 19.5
        },
        "informative.600": {
            contrast: 65.32054162198642,
            lc60: 89,
            lc45: 63.5,
            lc30: 41.5,
            lc10: 21.5
        },
        "informative.700": {
            contrast: 60.5950636338637,
            lc60: 98.5,
            lc45: 69,
            lc30: 45,
            lc10: 23
        },
        "informative.800": {
            contrast: 55.75118807380617,
            lc60: 100,
            lc45: 77,
            lc30: 49.5,
            lc10: 25
        },
        "informative.900": {
            contrast: 50.86405275263359,
            lc60: 100,
            lc45: 85.5,
            lc30: 55,
            lc10: 28
        },
        "informative.1000": {
            contrast: 46.48971605072335,
            lc60: 100,
            lc45: 95.5,
            lc30: 60.5,
            lc10: 30
        },
        "informative.1100": {
            contrast: 41.97136084397685,
            lc60: 100,
            lc45: 100,
            lc30: 67.5,
            lc10: 33.5
        },
        "informative.1200": {
            contrast: 36.965326714537376,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 38
        },
        "informative.1300": {
            contrast: 31.807377540376887,
            lc60: 100,
            lc45: 100,
            lc30: 93,
            lc10: 43
        },
        "informative.1400": {
            contrast: 27.453317689994904,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "informative.1500": {
            contrast: 23.01094350199072,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "informative.1600": {
            contrast: 18.232710044435443,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82
        },
        "informative.1700": {
            contrast: 13.131124011478015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1800": {
            contrast: 8.235418198061641,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 10.510072717989086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 16.645214755571715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "informative.2400": {
            contrast: 23.10369973436912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "informative.2500": {
            contrast: 29.571628806717744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54
        }
    },
    "informative.2100": {
        "informative.100": {
            contrast: 82.99671769955278,
            lc60: 57,
            lc45: 41.5,
            lc30: 27.5,
            lc10: 14
        },
        "informative.200": {
            contrast: 82.49649213843836,
            lc60: 61,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15
        },
        "informative.300": {
            contrast: 80.82222080101498,
            lc60: 65,
            lc45: 47,
            lc30: 31,
            lc10: 16
        },
        "informative.400": {
            contrast: 78.50911511391908,
            lc60: 69,
            lc45: 50.5,
            lc30: 33,
            lc10: 17
        },
        "informative.500": {
            contrast: 75.25896156358125,
            lc60: 74,
            lc45: 53.5,
            lc30: 35,
            lc10: 18
        },
        "informative.600": {
            contrast: 70.6940862943542,
            lc60: 80.5,
            lc45: 58,
            lc30: 37.5,
            lc10: 19.5
        },
        "informative.700": {
            contrast: 65.96860830623146,
            lc60: 88,
            lc45: 62.5,
            lc30: 41,
            lc10: 21
        },
        "informative.800": {
            contrast: 61.12473274617394,
            lc60: 97,
            lc45: 68.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "informative.900": {
            contrast: 56.237597425001354,
            lc60: 100,
            lc45: 75.5,
            lc30: 49,
            lc10: 25
        },
        "informative.1000": {
            contrast: 51.86326072309112,
            lc60: 100,
            lc45: 83.5,
            lc30: 53,
            lc10: 27
        },
        "informative.1100": {
            contrast: 47.34490551634462,
            lc60: 100,
            lc45: 93,
            lc30: 58,
            lc10: 29
        },
        "informative.1200": {
            contrast: 42.33887138690514,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 33
        },
        "informative.1300": {
            contrast: 37.18092221274465,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 36.5
        },
        "informative.1400": {
            contrast: 32.82686236236267,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 41.5
        },
        "informative.1500": {
            contrast: 28.38448817435848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "informative.1600": {
            contrast: 23.606254716803207,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "informative.1700": {
            contrast: 18.50466868384578,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "informative.1800": {
            contrast: 13.608962870429403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.1900": {
            contrast: 8.476801753369585,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 10.659409989612062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 17.11789496840947,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "informative.2500": {
            contrast: 23.585824040758094,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        }
    },
    "informative.2200": {
        "informative.100": {
            contrast: 88.67513951268116,
            lc60: 53,
            lc45: 39,
            lc30: 25.5,
            lc10: 13
        },
        "informative.200": {
            contrast: 88.17491395156671,
            lc60: 56.5,
            lc45: 41,
            lc30: 27,
            lc10: 14
        },
        "informative.300": {
            contrast: 86.50064261414336,
            lc60: 60,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "informative.400": {
            contrast: 84.18753692704745,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 30.5,
            lc10: 16
        },
        "informative.500": {
            contrast: 80.93738337670962,
            lc60: 67.5,
            lc45: 49,
            lc30: 32.5,
            lc10: 16.5
        },
        "informative.600": {
            contrast: 76.37250810748256,
            lc60: 72.5,
            lc45: 53,
            lc30: 34.5,
            lc10: 18
        },
        "informative.700": {
            contrast: 71.64703011935983,
            lc60: 79,
            lc45: 57,
            lc30: 37.5,
            lc10: 19.5
        },
        "informative.800": {
            contrast: 66.80315455930231,
            lc60: 86.5,
            lc45: 61.5,
            lc30: 40,
            lc10: 20.5
        },
        "informative.900": {
            contrast: 61.916019238129714,
            lc60: 95.5,
            lc45: 67,
            lc30: 43.5,
            lc10: 22.5
        },
        "informative.1000": {
            contrast: 57.541682536219476,
            lc60: 100,
            lc45: 73.5,
            lc30: 47,
            lc10: 24.5
        },
        "informative.1100": {
            contrast: 53.02332732947298,
            lc60: 100,
            lc45: 80.5,
            lc30: 51,
            lc10: 25.5
        },
        "informative.1200": {
            contrast: 48.01729320003351,
            lc60: 100,
            lc45: 92,
            lc30: 57,
            lc10: 28.5
        },
        "informative.1300": {
            contrast: 42.85934402587302,
            lc60: 100,
            lc45: 100,
            lc30: 63.5,
            lc10: 31.5
        },
        "informative.1400": {
            contrast: 38.505284175491035,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 35
        },
        "informative.1500": {
            contrast: 34.06290998748685,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 42
        },
        "informative.1600": {
            contrast: 29.284676529931573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51.5
        },
        "informative.1700": {
            contrast: 24.18309049697415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "informative.1800": {
            contrast: 19.287384683557775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "informative.1900": {
            contrast: 14.155223566497954,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2000": {
            contrast: 8.789025361613835,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 10.730442486383982,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 17.19837155873261,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        }
    },
    "informative.2300": {
        "informative.100": {
            contrast: 94.29831861213405,
            lc60: 50,
            lc45: 36.5,
            lc30: 24,
            lc10: 12.5
        },
        "informative.200": {
            contrast: 93.79809305101962,
            lc60: 52.5,
            lc45: 38.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "informative.300": {
            contrast: 92.12382171359627,
            lc60: 56,
            lc45: 40.5,
            lc30: 27.5,
            lc10: 14
        },
        "informative.400": {
            contrast: 89.81071602650036,
            lc60: 59,
            lc45: 43,
            lc30: 28.5,
            lc10: 14.5
        },
        "informative.500": {
            contrast: 86.56056247616253,
            lc60: 62,
            lc45: 45.5,
            lc30: 30,
            lc10: 15.5
        },
        "informative.600": {
            contrast: 81.99568720693547,
            lc60: 67,
            lc45: 48.5,
            lc30: 32,
            lc10: 17
        },
        "informative.700": {
            contrast: 77.27020921881274,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 17.5
        },
        "informative.800": {
            contrast: 72.4263336587552,
            lc60: 77.5,
            lc45: 56,
            lc30: 37,
            lc10: 19
        },
        "informative.900": {
            contrast: 67.53919833758263,
            lc60: 85.5,
            lc45: 61,
            lc30: 39.5,
            lc10: 20
        },
        "informative.1000": {
            contrast: 63.164861635672395,
            lc60: 93,
            lc45: 66,
            lc30: 42.5,
            lc10: 22
        },
        "informative.1100": {
            contrast: 58.646506428925896,
            lc60: 100,
            lc45: 71.5,
            lc30: 45.5,
            lc10: 23.5
        },
        "informative.1200": {
            contrast: 53.64047229948642,
            lc60: 100,
            lc45: 79,
            lc30: 50,
            lc10: 25
        },
        "informative.1300": {
            contrast: 48.482523125325926,
            lc60: 100,
            lc45: 89.5,
            lc30: 55,
            lc10: 27.5
        },
        "informative.1400": {
            contrast: 44.12846327494395,
            lc60: 100,
            lc45: 100,
            lc30: 62.5,
            lc10: 30.5
        },
        "informative.1500": {
            contrast: 39.686089086939766,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 36.5
        },
        "informative.1600": {
            contrast: 34.907855629384485,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 42.5
        },
        "informative.1700": {
            contrast: 29.806269596427054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 50.5
        },
        "informative.1800": {
            contrast: 24.910563783010684,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 61
        },
        "informative.1900": {
            contrast: 19.778402665950864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "informative.2000": {
            contrast: 14.412204461066743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2100": {
            contrast: 8.967645921269916,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 10.813292062104379,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "informative.2400": {
        "informative.100": {
            contrast: 100.18229182589755,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 22.5,
            lc10: 12
        },
        "informative.200": {
            contrast: 99.68206626478312,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "informative.300": {
            contrast: 98.00779492735975,
            lc60: 52,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "informative.400": {
            contrast: 95.69468924026386,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "informative.500": {
            contrast: 92.44453568992603,
            lc60: 57.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 14.5
        },
        "informative.600": {
            contrast: 87.87966042069895,
            lc60: 61.5,
            lc45: 45,
            lc30: 30,
            lc10: 15.5
        },
        "informative.700": {
            contrast: 83.15418243257623,
            lc60: 65.5,
            lc45: 48,
            lc30: 31.5,
            lc10: 16.5
        },
        "informative.800": {
            contrast: 78.31030687251871,
            lc60: 70.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 17.5
        },
        "informative.900": {
            contrast: 73.42317155134612,
            lc60: 76.5,
            lc45: 55,
            lc30: 36,
            lc10: 19
        },
        "informative.1000": {
            contrast: 69.04883484943588,
            lc60: 83,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "informative.1100": {
            contrast: 64.53047964268939,
            lc60: 90.5,
            lc45: 63.5,
            lc30: 41.5,
            lc10: 21
        },
        "informative.1200": {
            contrast: 59.5244455132499,
            lc60: 100,
            lc45: 69,
            lc30: 44.5,
            lc10: 23
        },
        "informative.1300": {
            contrast: 54.36649633908942,
            lc60: 100,
            lc45: 77.5,
            lc30: 48.5,
            lc10: 25
        },
        "informative.1400": {
            contrast: 50.012436488707436,
            lc60: 100,
            lc45: 86.5,
            lc30: 53.5,
            lc10: 27
        },
        "informative.1500": {
            contrast: 45.57006230070325,
            lc60: 100,
            lc45: 98,
            lc30: 62,
            lc10: 31.5
        },
        "informative.1600": {
            contrast: 40.79182884314797,
            lc60: 100,
            lc45: 100,
            lc30: 71.5,
            lc10: 36
        },
        "informative.1700": {
            contrast: 35.69024281019054,
            lc60: 100,
            lc45: 100,
            lc30: 83,
            lc10: 42
        },
        "informative.1800": {
            contrast: 30.79453699677417,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 50
        },
        "informative.1900": {
            contrast: 25.66237587971435,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "informative.2000": {
            contrast: 20.296177674830233,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "informative.2100": {
            contrast: 14.851619135033403,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2200": {
            contrast: 9.09191217998789,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "informative.2500": {
        "informative.100": {
            contrast: 106.04067321268862,
            lc60: 44,
            lc45: 32.5,
            lc30: 21.5,
            lc10: 11.5
        },
        "informative.200": {
            contrast: 105.54044765157417,
            lc60: 46.5,
            lc45: 34,
            lc30: 23,
            lc10: 12
        },
        "informative.300": {
            contrast: 103.8661763141508,
            lc60: 49,
            lc45: 36,
            lc30: 24,
            lc10: 12.5
        },
        "informative.400": {
            contrast: 101.55307062705492,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13
        },
        "informative.500": {
            contrast: 98.30291707671707,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26.5,
            lc10: 14
        },
        "informative.600": {
            contrast: 93.73804180749002,
            lc60: 57,
            lc45: 41.5,
            lc30: 28,
            lc10: 15
        },
        "informative.700": {
            contrast: 89.01256381936727,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "informative.800": {
            contrast: 84.16868825930975,
            lc60: 65,
            lc45: 47.5,
            lc30: 31.5,
            lc10: 16.5
        },
        "informative.900": {
            contrast: 79.28155293813718,
            lc60: 69.5,
            lc45: 50.5,
            lc30: 33.5,
            lc10: 17.5
        },
        "informative.1000": {
            contrast: 74.90721623622693,
            lc60: 74.5,
            lc45: 54,
            lc30: 35,
            lc10: 18.5
        },
        "informative.1100": {
            contrast: 70.38886102948044,
            lc60: 80.5,
            lc45: 57.5,
            lc30: 37.5,
            lc10: 19.5
        },
        "informative.1200": {
            contrast: 65.38282690004095,
            lc60: 88.5,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 20.5
        },
        "informative.1300": {
            contrast: 60.22487772588047,
            lc60: 99.5,
            lc45: 68,
            lc30: 43.5,
            lc10: 22.5
        },
        "informative.1400": {
            contrast: 55.87081787549848,
            lc60: 100,
            lc45: 75,
            lc30: 47.5,
            lc10: 24
        },
        "informative.1500": {
            contrast: 51.428443687494294,
            lc60: 100,
            lc45: 85,
            lc30: 54.5,
            lc10: 27.5
        },
        "informative.1600": {
            contrast: 46.65021022993902,
            lc60: 100,
            lc45: 95.5,
            lc30: 61.5,
            lc10: 32
        },
        "informative.1700": {
            contrast: 41.54862419698159,
            lc60: 100,
            lc45: 100,
            lc30: 70,
            lc10: 36.5
        },
        "informative.1800": {
            contrast: 36.65291838356522,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 42
        },
        "informative.1900": {
            contrast: 31.5207572665054,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 49
        },
        "informative.2000": {
            contrast: 26.15455906162128,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "informative.2100": {
            contrast: 20.710000521824455,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "informative.2200": {
            contrast: 14.95029356677894,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2300": {
            contrast: 9.240656633742825,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "informative.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$saffron = {
    "saffron.100": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 8.205958711184731,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 12.113108637724752,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 16.633727584296626,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.900": {
            contrast: 20.908441233185744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 24.90836850969926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 29.457057936650845,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 33.81788700107938,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 38.743681696936314,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 43.13600665861986,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 47.2890601243057,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 50.94750665750751,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 56.127798583200864,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 62.462115284182275,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 69.20816602253419,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 75.264142360225,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 81.3198294326547,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 87.76147265475224,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 94.28870844287997,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 101.1273587637044,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 107.88473318309848,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.200": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 7.817146543639872,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 11.724296470179892,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 16.244915416751766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.900": {
            contrast: 20.519629065640885,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 24.5195563421544,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 29.06824576910598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 33.429074833534514,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 38.35486952939145,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 42.747194491075,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 46.900247956760836,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 50.558694489962654,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 55.738986415656,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 62.07330311663741,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 68.81935385498934,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 74.87533019268014,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 80.93101726510984,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 87.37266048720738,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 93.89989627533511,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 100.73854659615955,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 107.4959210155536,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.300": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 10.578764393236876,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 15.099383339808748,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 19.37409698869787,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 23.374024265211382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 27.922713692162965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 32.2835427565915,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 37.20933745244843,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 41.60166241413198,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 45.75471587981782,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 49.41316241301964,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 54.59345433871299,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 60.9277710396944,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 67.67382177804632,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 73.72979811573713,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 79.78548518816683,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 86.22712841026437,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 92.7543641983921,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 99.59301451921652,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 106.35038893861059,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.400": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 8.902428989613027,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 13.423047936184899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 17.69776158507402,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1000": {
            contrast: 21.697688861587533,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 26.24637828853912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 30.607207352967652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 35.53300204882458,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 39.92532701050813,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 44.07838047619396,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 47.736827009395775,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 52.91711893508912,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 59.25143563607054,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 65.99748637442246,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 72.05346271211327,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 78.10914978454296,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 84.5507930066405,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 91.07802879476823,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 97.91667911559266,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 104.67405353498674,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.500": {
        "saffron.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 10.891490192102504,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 15.166203840991624,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 19.166131117505138,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1100": {
            contrast: 23.714820544456725,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 28.075649608885257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 33.001444304742186,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 37.393769266425736,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 41.54682273211157,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 45.20526926531338,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 50.38556119100674,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 56.71987789198815,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 63.46592863034006,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 69.52190496803087,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 75.57759204046057,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 82.01923526255811,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 88.54647105068584,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 95.38512137151028,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 102.14249579090435,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.600": {
        "saffron.100": {
            contrast: 9.545849040790229,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 9.024322539958622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 7.523303064209955,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 11.370210638607345,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 15.370137915120857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 19.918827342072444,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 24.279656406500973,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 29.205451102357905,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 33.597776064041454,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 37.75082952972729,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 41.40927606292911,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 46.589567988622456,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 52.923884689603874,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 59.66993542795579,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 65.7259117656466,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 71.78159883807629,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 78.22324206017383,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 84.75047784830156,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 91.58912816912598,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 98.34650258852005,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.700": {
        "saffron.100": {
            contrast: 13.807515500965204,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.200": {
            contrast: 13.285989000133593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.300": {
            contrast: 11.784969524384925,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.400": {
            contrast: 9.66249005740771,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 7.642625271653635,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 11.642552548167151,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 16.191241975118732,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1200": {
            contrast: 20.55207103954727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 25.477865735404198,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 29.87019069708775,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 34.02324416277359,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 37.681690695975405,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 42.86198262166875,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 49.19629932265016,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 55.94235006100209,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 61.998326398692896,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 68.05401347112259,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 74.49565669322013,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 81.02289248134785,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 87.8615428021723,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 94.61891722156635,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.800": {
        "saffron.100": {
            contrast: 18.629465215516948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87.5
        },
        "saffron.200": {
            contrast: 18.107938714685336,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "saffron.300": {
            contrast: 16.606919238936673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "saffron.400": {
            contrast: 14.484439771959453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.500": {
            contrast: 11.398800307475469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 11.829986053200466,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 16.190815117629,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1300": {
            contrast: 21.11660981348593,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 25.50893477516948,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 29.661988240855315,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 33.320434774057134,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 38.50072669975047,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 44.83504340073189,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 51.58109413908382,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 57.637070476774625,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 63.692757549204316,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 70.13440077130187,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 76.6616365594296,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 83.50028688025402,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 90.25766129964808,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.900": {
        "saffron.100": {
            contrast: 23.103737817974853,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "saffron.200": {
            contrast: 22.58221131714325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "saffron.300": {
            contrast: 21.08119184139458,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "saffron.400": {
            contrast: 18.958712374417363,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "saffron.500": {
            contrast: 15.873072909933375,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.600": {
            contrast: 11.43390371714214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 7.666827793522563,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 12.027656857951097,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 16.953451553808026,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1400": {
            contrast: 21.34577651549158,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 25.498829981177412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 29.157276514379227,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 34.337568440072566,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 40.671885141053984,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 47.4179358794059,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 53.47391221709671,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 59.5295992895264,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 65.97124251162396,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 72.49847829975168,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 79.33712862057611,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 86.09450303997018,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1000": {
        "saffron.100": {
            contrast: 27.22835442382979,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 75
        },
        "saffron.200": {
            contrast: 26.706827922998183,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.300": {
            contrast: 25.205808447249517,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "saffron.400": {
            contrast: 23.083328980272302,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 87
        },
        "saffron.500": {
            contrast: 19.997689515788316,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "saffron.600": {
            contrast: 15.55852032299708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.700": {
            contrast: 11.355020063318946,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 8.10293751671828,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 13.02873221257521,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 17.421057174258763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1500": {
            contrast: 21.5741106399446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 25.232557173146414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 30.412849098839757,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 36.747165799821175,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 43.493216538173094,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 49.5491928758639,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 55.60487994829359,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 62.04652317039114,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 68.57375895851887,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 75.4124092793433,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 82.16978369873736,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1100": {
        "saffron.100": {
            contrast: 31.856884105760113,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 70.5
        },
        "saffron.200": {
            contrast: 31.335357604928504,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 73.5
        },
        "saffron.300": {
            contrast: 29.834338129179837,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "saffron.400": {
            contrast: 27.71185866220262,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81
        },
        "saffron.500": {
            contrast: 24.626219197718637,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "saffron.600": {
            contrast: 20.187050004927404,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "saffron.700": {
            contrast: 15.98354974524927,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.800": {
            contrast: 11.209683135574998,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 8.535797432094762,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 12.928122393778313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 17.08117585946415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1600": {
            contrast: 20.739622392665968,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 25.91991431835931,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 32.25423101934072,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 39.00028175769265,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 45.05625809538345,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 51.11194516781315,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 57.55358838991068,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 64.08082417803841,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 70.91947449886284,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 77.67684891825691,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1200": {
        "saffron.100": {
            contrast: 36.24056001456831,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 66
        },
        "saffron.200": {
            contrast: 35.7190335137367,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 69
        },
        "saffron.300": {
            contrast: 34.218014037988034,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 72
        },
        "saffron.400": {
            contrast: 32.095534571010816,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 75.5
        },
        "saffron.500": {
            contrast: 29.009895106526834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "saffron.600": {
            contrast: 24.5707259137356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "saffron.700": {
            contrast: 20.367225654057467,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        },
        "saffron.800": {
            contrast: 15.593359044383192,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.900": {
            contrast: 11.14972048706388,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 8.59445166702448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 12.747505132710312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 16.405951665912134,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1700": {
            contrast: 21.586243591605474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 27.920560292586888,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 34.66661103093881,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 40.72258736862962,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 46.77827444105931,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 53.219917663156856,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 59.747153451284575,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 66.585803772109,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 73.34317819150307,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1300": {
        "saffron.100": {
            contrast: 41.13689131859541,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 61.5
        },
        "saffron.200": {
            contrast: 40.6153648177638,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 64.5
        },
        "saffron.300": {
            contrast: 39.11434534201514,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 67.5
        },
        "saffron.400": {
            contrast: 36.991865875037924,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 70.5
        },
        "saffron.500": {
            contrast: 33.90622641055393,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 74.5
        },
        "saffron.600": {
            contrast: 29.467057217762697,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.700": {
            contrast: 25.263556958084564,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.800": {
            contrast: 20.489690348410296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "saffron.900": {
            contrast: 16.046051791090978,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99.5
        },
        "saffron.1000": {
            contrast: 11.939467189696282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1100": {
            contrast: 7.320948523907246,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 7.82483634075353,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 11.483282873955346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 16.663574799648693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1800": {
            contrast: 22.997891500630104,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 29.743942238982022,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 35.79991857667283,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 41.85560564910252,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 48.29724887120007,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 54.82448465932779,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 61.66313498015222,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 68.42050939954629,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1400": {
        "saffron.100": {
            contrast: 45.459019821791514,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 58
        },
        "saffron.200": {
            contrast: 44.9374933209599,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 60.5
        },
        "saffron.300": {
            contrast: 43.436473845211246,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 63
        },
        "saffron.400": {
            contrast: 41.31399437823403,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 66
        },
        "saffron.500": {
            contrast: 38.22835491375004,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 69.5
        },
        "saffron.600": {
            contrast: 33.789185720958805,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 73.5
        },
        "saffron.700": {
            contrast: 29.585685461280676,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.800": {
            contrast: 24.8118188516064,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.900": {
            contrast: 20.368180294287086,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "saffron.1000": {
            contrast: 16.261595692892385,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "saffron.1100": {
            contrast: 11.643077027103354,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 12.25179526022898,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 18.586111961210392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.1900": {
            contrast: 25.33216269956231,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 31.388139037253115,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 37.44382610968281,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 43.88546933178035,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 50.412705119908075,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 57.25135544073251,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 64.00872986012658,
            lc60: 0,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1500": {
        "saffron.100": {
            contrast: 49.51143323537025,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 54.5
        },
        "saffron.200": {
            contrast: 48.98990673453865,
            lc60: 100,
            lc45: 89.5,
            lc30: 71,
            lc10: 56.5
        },
        "saffron.300": {
            contrast: 47.48888725878998,
            lc60: 100,
            lc45: 95,
            lc30: 74.5,
            lc10: 59
        },
        "saffron.400": {
            contrast: 45.36640779181276,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 61.5
        },
        "saffron.500": {
            contrast: 42.28076832732878,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 65
        },
        "saffron.600": {
            contrast: 37.84159913453754,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 69.5
        },
        "saffron.700": {
            contrast: 33.63809887485941,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 73.5
        },
        "saffron.800": {
            contrast: 28.864232265185137,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 78.5
        },
        "saffron.900": {
            contrast: 24.420593707865827,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.1000": {
            contrast: 20.314009106471126,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "saffron.1100": {
            contrast: 15.695490440682091,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1200": {
            contrast: 11.312409945800603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 8.06274973831791,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 14.397066439299325,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 21.143117177651245,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 27.19909351534205,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 33.25478058777174,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 39.69642380986929,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 46.223659597997006,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 53.06230991882145,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 59.81968433821551,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1600": {
        "saffron.100": {
            contrast: 53.055945599098465,
            lc60: 100,
            lc45: 80.5,
            lc30: 64.5,
            lc10: 51.5
        },
        "saffron.200": {
            contrast: 52.53441909826686,
            lc60: 100,
            lc45: 84,
            lc30: 67.5,
            lc10: 53.5
        },
        "saffron.300": {
            contrast: 51.033399622518196,
            lc60: 100,
            lc45: 88,
            lc30: 70.5,
            lc10: 55.5
        },
        "saffron.400": {
            contrast: 48.910920155540985,
            lc60: 100,
            lc45: 93.5,
            lc30: 73.5,
            lc10: 58.5
        },
        "saffron.500": {
            contrast: 45.82528069105699,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 61
        },
        "saffron.600": {
            contrast: 41.38611149826576,
            lc60: 100,
            lc45: 100,
            lc30: 83.5,
            lc10: 65
        },
        "saffron.700": {
            contrast: 37.182611238587626,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 68.5
        },
        "saffron.800": {
            contrast: 32.40874462891335,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 73.5
        },
        "saffron.900": {
            contrast: 27.965106071594036,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.1000": {
            contrast: 23.858521470199342,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.1100": {
            contrast: 19.24000280441031,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "saffron.1200": {
            contrast: 14.85692230952882,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1300": {
            contrast: 9.952088675651899,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 10.693780769877446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 17.439831508229364,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2000": {
            contrast: 23.495807845920165,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 29.551494918349864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 35.99313814044741,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 42.520373928575125,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 49.35902424939956,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 56.116398668793636,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1700": {
        "saffron.100": {
            contrast: 58.037731299858706,
            lc60: 100,
            lc45: 74.5,
            lc30: 60,
            lc10: 47
        },
        "saffron.200": {
            contrast: 57.51620479902711,
            lc60: 100,
            lc45: 78,
            lc30: 62.5,
            lc10: 49.5
        },
        "saffron.300": {
            contrast: 56.01518532327843,
            lc60: 100,
            lc45: 82,
            lc30: 65.5,
            lc10: 51.5
        },
        "saffron.400": {
            contrast: 53.89270585630121,
            lc60: 100,
            lc45: 86,
            lc30: 68.5,
            lc10: 53.5
        },
        "saffron.500": {
            contrast: 50.80706639181722,
            lc60: 100,
            lc45: 91.5,
            lc30: 72,
            lc10: 56.5
        },
        "saffron.600": {
            contrast: 46.36789719902599,
            lc60: 100,
            lc45: 99,
            lc30: 77,
            lc10: 59.5
        },
        "saffron.700": {
            contrast: 42.16439693934786,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 63
        },
        "saffron.800": {
            contrast: 37.39053032967358,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 67.5
        },
        "saffron.900": {
            contrast: 32.94689177235427,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 71.5
        },
        "saffron.1000": {
            contrast: 28.840307170959573,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "saffron.1100": {
            contrast: 24.22178850517054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83
        },
        "saffron.1200": {
            contrast: 19.838708010289054,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "saffron.1300": {
            contrast: 14.933874376412131,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1400": {
            contrast: 10.596936985148508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 12.176513317425282,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 18.232489655116087,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2100": {
            contrast: 24.28817672754579,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 30.72981994964333,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 37.25705573777105,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 44.09570605859548,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 50.85308047798954,
            lc60: 100,
            lc45: 0,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1800": {
        "saffron.100": {
            contrast: 64.07529599672435,
            lc60: 86.5,
            lc45: 68.5,
            lc30: 55,
            lc10: 42.5
        },
        "saffron.200": {
            contrast: 63.553769495892745,
            lc60: 90.5,
            lc45: 71.5,
            lc30: 57,
            lc10: 44.5
        },
        "saffron.300": {
            contrast: 62.05275002014407,
            lc60: 96.5,
            lc45: 75,
            lc30: 59.5,
            lc10: 46
        },
        "saffron.400": {
            contrast: 59.93027055316686,
            lc60: 100,
            lc45: 78.5,
            lc30: 62,
            lc10: 48
        },
        "saffron.500": {
            contrast: 56.844631088682874,
            lc60: 100,
            lc45: 82.5,
            lc30: 65.5,
            lc10: 50.5
        },
        "saffron.600": {
            contrast: 52.405461895891634,
            lc60: 100,
            lc45: 89,
            lc30: 69.5,
            lc10: 53.5
        },
        "saffron.700": {
            contrast: 48.2019616362135,
            lc60: 100,
            lc45: 95.5,
            lc30: 74,
            lc10: 56.5
        },
        "saffron.800": {
            contrast: 43.42809502653922,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 60
        },
        "saffron.900": {
            contrast: 38.984456469219914,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 64.5
        },
        "saffron.1000": {
            contrast: 34.87787186782521,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 68
        },
        "saffron.1100": {
            contrast: 30.259353202036177,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "saffron.1200": {
            contrast: 25.87627270715469,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "saffron.1300": {
            contrast: 20.97143907327777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "saffron.1400": {
            contrast: 16.63450168201415,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97.5
        },
        "saffron.1500": {
            contrast: 12.562492287989132,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1600": {
            contrast: 8.996618397751483,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 11.767917454184392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 17.82360452661409,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2200": {
            contrast: 24.265247748711634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 30.792483536839356,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 37.631133857663784,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 44.38850827705785,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.1900": {
        "saffron.100": {
            contrast: 70.44626137415935,
            lc60: 77,
            lc45: 62.5,
            lc30: 49.5,
            lc10: 37.5
        },
        "saffron.200": {
            contrast: 69.92473487332774,
            lc60: 81,
            lc45: 65,
            lc30: 51.5,
            lc10: 39
        },
        "saffron.300": {
            contrast: 68.42371539757906,
            lc60: 85,
            lc45: 68,
            lc30: 53.5,
            lc10: 40.5
        },
        "saffron.400": {
            contrast: 66.30123593060185,
            lc60: 89.5,
            lc45: 71,
            lc30: 56,
            lc10: 42.5
        },
        "saffron.500": {
            contrast: 63.21559646611787,
            lc60: 95.5,
            lc45: 75,
            lc30: 59,
            lc10: 44.5
        },
        "saffron.600": {
            contrast: 58.776427273326625,
            lc60: 100,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 47.5
        },
        "saffron.700": {
            contrast: 54.572927013648496,
            lc60: 100,
            lc45: 85.5,
            lc30: 66,
            lc10: 49.5
        },
        "saffron.800": {
            contrast: 49.79906040397422,
            lc60: 100,
            lc45: 92.5,
            lc30: 70.5,
            lc10: 53
        },
        "saffron.900": {
            contrast: 45.355421846654906,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 56
        },
        "saffron.1000": {
            contrast: 41.24883724526021,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 59
        },
        "saffron.1100": {
            contrast: 36.63031857947118,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 63
        },
        "saffron.1200": {
            contrast: 32.24723808458968,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 68
        },
        "saffron.1300": {
            contrast: 27.342404450712763,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "saffron.1400": {
            contrast: 23.005467059449145,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 82.5
        },
        "saffron.1500": {
            contrast: 18.93345766542413,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "saffron.1600": {
            contrast: 15.36758377518648,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1700": {
            contrast: 10.349561158063475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 10.907003308105049,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 17.34864653020259,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2300": {
            contrast: 23.875882318330312,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 30.714532639154747,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 37.47190705854881,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.2000": {
        "saffron.100": {
            contrast: 76.11847308355877,
            lc60: 71.5,
            lc45: 57,
            lc30: 44.5,
            lc10: 33.5
        },
        "saffron.200": {
            contrast: 75.59694658272717,
            lc60: 74.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 34.5
        },
        "saffron.300": {
            contrast: 74.0959271069785,
            lc60: 78,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 36
        },
        "saffron.400": {
            contrast: 71.97344764000128,
            lc60: 82,
            lc45: 65,
            lc30: 50.5,
            lc10: 37.5
        },
        "saffron.500": {
            contrast: 68.88780817551729,
            lc60: 86.5,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 39
        },
        "saffron.600": {
            contrast: 64.44863898272605,
            lc60: 93.5,
            lc45: 73.5,
            lc30: 56.5,
            lc10: 42
        },
        "saffron.700": {
            contrast: 60.24513872304792,
            lc60: 100,
            lc45: 77.5,
            lc30: 59.5,
            lc10: 44
        },
        "saffron.800": {
            contrast: 55.47127211337364,
            lc60: 100,
            lc45: 83,
            lc30: 63.5,
            lc10: 46.5
        },
        "saffron.900": {
            contrast: 51.02763355605433,
            lc60: 100,
            lc45: 90,
            lc30: 68,
            lc10: 49.5
        },
        "saffron.1000": {
            contrast: 46.92104895465963,
            lc60: 100,
            lc45: 97.5,
            lc30: 72,
            lc10: 51.5
        },
        "saffron.1100": {
            contrast: 42.3025302888706,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 55.5
        },
        "saffron.1200": {
            contrast: 37.919449793989116,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 59
        },
        "saffron.1300": {
            contrast: 33.01461616011218,
            lc60: 100,
            lc45: 100,
            lc30: 94,
            lc10: 64.5
        },
        "saffron.1400": {
            contrast: 28.67767876884857,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "saffron.1500": {
            contrast: 24.60566937482355,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "saffron.1600": {
            contrast: 21.039795484585902,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "saffron.1700": {
            contrast: 16.0217728674629,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 99
        },
        "saffron.1800": {
            contrast: 9.931256367156,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 11.113873700885266,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 17.641109489012987,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2400": {
            contrast: 24.47975980983742,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 31.237134229231483,
            lc60: 100,
            lc45: 100,
            lc30: 0,
            lc10: 0
        }
    },
    "saffron.2100": {
        "saffron.100": {
            contrast: 81.74967511411249,
            lc60: 66,
            lc45: 52.5,
            lc30: 40.5,
            lc10: 29
        },
        "saffron.200": {
            contrast: 81.22814861328088,
            lc60: 68.5,
            lc45: 54.5,
            lc30: 42.5,
            lc10: 30
        },
        "saffron.300": {
            contrast: 79.72712913753222,
            lc60: 71.5,
            lc45: 57,
            lc30: 44,
            lc10: 31.5
        },
        "saffron.400": {
            contrast: 77.604649670555,
            lc60: 75,
            lc45: 59.5,
            lc30: 46,
            lc10: 33
        },
        "saffron.500": {
            contrast: 74.51901020607103,
            lc60: 79.5,
            lc45: 62.5,
            lc30: 48,
            lc10: 34.5
        },
        "saffron.600": {
            contrast: 70.07984101327979,
            lc60: 85,
            lc45: 66.5,
            lc30: 51,
            lc10: 36
        },
        "saffron.700": {
            contrast: 65.87634075360165,
            lc60: 91,
            lc45: 70.5,
            lc30: 53.5,
            lc10: 38.5
        },
        "saffron.800": {
            contrast: 61.10247414392737,
            lc60: 99.5,
            lc45: 75,
            lc30: 57,
            lc10: 40.5
        },
        "saffron.900": {
            contrast: 56.65883558660805,
            lc60: 100,
            lc45: 81,
            lc30: 60.5,
            lc10: 43
        },
        "saffron.1000": {
            contrast: 52.552250985213355,
            lc60: 100,
            lc45: 86.5,
            lc30: 64,
            lc10: 45.5
        },
        "saffron.1100": {
            contrast: 47.93373231942433,
            lc60: 100,
            lc45: 95,
            lc30: 68.5,
            lc10: 48
        },
        "saffron.1200": {
            contrast: 43.55065182454283,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 51.5
        },
        "saffron.1300": {
            contrast: 38.64581819066591,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 55
        },
        "saffron.1400": {
            contrast: 34.30888079940229,
            lc60: 100,
            lc45: 100,
            lc30: 90.5,
            lc10: 60
        },
        "saffron.1500": {
            contrast: 30.236871405377276,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66
        },
        "saffron.1600": {
            contrast: 26.67099751513963,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "saffron.1700": {
            contrast: 21.652974898016623,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85
        },
        "saffron.1800": {
            contrast: 15.562458397709728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.1900": {
            contrast: 9.125728049146474,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 11.384125070473159,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 18.222775391297592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        },
        "saffron.2500": {
            contrast: 24.980149810691657,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        }
    },
    "saffron.2200": {
        "saffron.100": {
            contrast: 87.69851905582422,
            lc60: 60.5,
            lc45: 47.5,
            lc30: 35.5,
            lc10: 24.5
        },
        "saffron.200": {
            contrast: 87.17699255499261,
            lc60: 63,
            lc45: 49.5,
            lc30: 37,
            lc10: 26
        },
        "saffron.300": {
            contrast: 85.67597307924393,
            lc60: 66,
            lc45: 51.5,
            lc30: 39,
            lc10: 27
        },
        "saffron.400": {
            contrast: 83.55349361226672,
            lc60: 69,
            lc45: 54,
            lc30: 40.5,
            lc10: 28
        },
        "saffron.500": {
            contrast: 80.46785414778273,
            lc60: 72.5,
            lc45: 57,
            lc30: 42.5,
            lc10: 29.5
        },
        "saffron.600": {
            contrast: 76.0286849549915,
            lc60: 77,
            lc45: 60,
            lc30: 45,
            lc10: 31.5
        },
        "saffron.700": {
            contrast: 71.82518469531337,
            lc60: 82,
            lc45: 63.5,
            lc30: 47.5,
            lc10: 32.5
        },
        "saffron.800": {
            contrast: 67.05131808563908,
            lc60: 89,
            lc45: 68,
            lc30: 50,
            lc10: 34.5
        },
        "saffron.900": {
            contrast: 62.60767952831977,
            lc60: 96.5,
            lc45: 72.5,
            lc30: 53.5,
            lc10: 36.5
        },
        "saffron.1000": {
            contrast: 58.50109492692509,
            lc60: 100,
            lc45: 77,
            lc30: 56.5,
            lc10: 38.5
        },
        "saffron.1100": {
            contrast: 53.88257626113605,
            lc60: 100,
            lc45: 83.5,
            lc30: 60.5,
            lc10: 40.5
        },
        "saffron.1200": {
            contrast: 49.499495766254554,
            lc60: 100,
            lc45: 91.5,
            lc30: 64.5,
            lc10: 43
        },
        "saffron.1300": {
            contrast: 44.594662132377636,
            lc60: 100,
            lc45: 100,
            lc30: 70.5,
            lc10: 46
        },
        "saffron.1400": {
            contrast: 40.25772474111402,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 50.5
        },
        "saffron.1500": {
            contrast: 36.185715347089,
            lc60: 100,
            lc45: 100,
            lc30: 85.5,
            lc10: 55
        },
        "saffron.1600": {
            contrast: 32.61984145685135,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 61.5
        },
        "saffron.1700": {
            contrast: 27.60181883972834,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "saffron.1800": {
            contrast: 21.511302339421448,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "saffron.1900": {
            contrast: 15.074571990858193,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2000": {
            contrast: 9.335912372586346,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 11.543963821165606,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 18.30133824055967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 0
        }
    },
    "saffron.2300": {
        "saffron.100": {
            contrast: 93.68622709435557,
            lc60: 55,
            lc45: 42.5,
            lc30: 31.5,
            lc10: 20.5
        },
        "saffron.200": {
            contrast: 93.16470059352396,
            lc60: 57,
            lc45: 44.5,
            lc30: 32.5,
            lc10: 21
        },
        "saffron.300": {
            contrast: 91.6636811177753,
            lc60: 60,
            lc45: 46,
            lc30: 33.5,
            lc10: 22.5
        },
        "saffron.400": {
            contrast: 89.54120165079809,
            lc60: 62.5,
            lc45: 48.5,
            lc30: 35,
            lc10: 23
        },
        "saffron.500": {
            contrast: 86.45556218631411,
            lc60: 66,
            lc45: 50.5,
            lc30: 37,
            lc10: 24.5
        },
        "saffron.600": {
            contrast: 82.01639299352286,
            lc60: 70,
            lc45: 54,
            lc30: 39.5,
            lc10: 26
        },
        "saffron.700": {
            contrast: 77.81289273384473,
            lc60: 74.5,
            lc45: 57,
            lc30: 41,
            lc10: 27
        },
        "saffron.800": {
            contrast: 73.03902612417045,
            lc60: 80,
            lc45: 60.5,
            lc30: 44,
            lc10: 28.5
        },
        "saffron.900": {
            contrast: 68.59538756685114,
            lc60: 86,
            lc45: 64.5,
            lc30: 46,
            lc10: 30
        },
        "saffron.1000": {
            contrast: 64.48880296545644,
            lc60: 92.5,
            lc45: 68,
            lc30: 48.5,
            lc10: 31.5
        },
        "saffron.1100": {
            contrast: 59.87028429966741,
            lc60: 100,
            lc45: 73.5,
            lc30: 52,
            lc10: 33.5
        },
        "saffron.1200": {
            contrast: 55.48720380478592,
            lc60: 100,
            lc45: 79.5,
            lc30: 55.5,
            lc10: 35.5
        },
        "saffron.1300": {
            contrast: 50.582370170908995,
            lc60: 100,
            lc45: 88,
            lc30: 60.5,
            lc10: 38
        },
        "saffron.1400": {
            contrast: 46.24543277964538,
            lc60: 100,
            lc45: 99,
            lc30: 66,
            lc10: 41
        },
        "saffron.1500": {
            contrast: 42.17342338562035,
            lc60: 100,
            lc45: 100,
            lc30: 72.5,
            lc10: 44.5
        },
        "saffron.1600": {
            contrast: 38.607549495382706,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 49.5
        },
        "saffron.1700": {
            contrast: 33.589526878259704,
            lc60: 100,
            lc45: 100,
            lc30: 92.5,
            lc10: 57
        },
        "saffron.1800": {
            contrast: 27.499010377952803,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "saffron.1900": {
            contrast: 21.062280029389555,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "saffron.2000": {
            contrast: 15.323620411117709,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2100": {
            contrast: 9.619601914171115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 11.511114978516723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "saffron.2400": {
        "saffron.100": {
            contrast: 99.91934109687449,
            lc60: 49.5,
            lc45: 38,
            lc30: 26.5,
            lc10: 16
        },
        "saffron.200": {
            contrast: 99.3978145960429,
            lc60: 52,
            lc45: 39,
            lc30: 28,
            lc10: 17
        },
        "saffron.300": {
            contrast: 97.89679512029423,
            lc60: 54,
            lc45: 41,
            lc30: 29,
            lc10: 17.5
        },
        "saffron.400": {
            contrast: 95.774315653317,
            lc60: 56.5,
            lc45: 43,
            lc30: 30,
            lc10: 18.5
        },
        "saffron.500": {
            contrast: 92.68867618883303,
            lc60: 59.5,
            lc45: 45,
            lc30: 31.5,
            lc10: 19
        },
        "saffron.600": {
            contrast: 88.24950699604179,
            lc60: 63,
            lc45: 48,
            lc30: 33.5,
            lc10: 20.5
        },
        "saffron.700": {
            contrast: 84.04600673636365,
            lc60: 67,
            lc45: 50,
            lc30: 35,
            lc10: 21
        },
        "saffron.800": {
            contrast: 79.27214012668938,
            lc60: 71.5,
            lc45: 53.5,
            lc30: 37,
            lc10: 22.5
        },
        "saffron.900": {
            contrast: 74.82850156937005,
            lc60: 76.5,
            lc45: 56.5,
            lc30: 39.5,
            lc10: 23.5
        },
        "saffron.1000": {
            contrast: 70.72191696797537,
            lc60: 81.5,
            lc45: 60,
            lc30: 41.5,
            lc10: 25
        },
        "saffron.1100": {
            contrast: 66.10339830218633,
            lc60: 89,
            lc45: 64.5,
            lc30: 44,
            lc10: 26
        },
        "saffron.1200": {
            contrast: 61.72031780730484,
            lc60: 98.5,
            lc45: 69,
            lc30: 46.5,
            lc10: 28
        },
        "saffron.1300": {
            contrast: 56.81548417342792,
            lc60: 100,
            lc45: 75.5,
            lc30: 50.5,
            lc10: 29.5
        },
        "saffron.1400": {
            contrast: 52.4785467821643,
            lc60: 100,
            lc45: 83,
            lc30: 55,
            lc10: 32
        },
        "saffron.1500": {
            contrast: 48.406537388139284,
            lc60: 100,
            lc45: 93,
            lc30: 60,
            lc10: 35
        },
        "saffron.1600": {
            contrast: 44.84066349790163,
            lc60: 100,
            lc45: 100,
            lc30: 66.5,
            lc10: 39
        },
        "saffron.1700": {
            contrast: 39.82264088077863,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 44.5
        },
        "saffron.1800": {
            contrast: 33.73212438047173,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 53.5
        },
        "saffron.1900": {
            contrast: 27.295394031908476,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "saffron.2000": {
            contrast: 21.556734413636633,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "saffron.2100": {
            contrast: 15.852715916690041,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2200": {
            contrast: 9.82000255699912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "saffron.2500": {
        "saffron.100": {
            contrast: 106.04067321268862,
            lc60: 44.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "saffron.200": {
            contrast: 105.519146711857,
            lc60: 46.5,
            lc45: 34.5,
            lc30: 23,
            lc10: 12.5
        },
        "saffron.300": {
            contrast: 104.01812723610833,
            lc60: 48.5,
            lc45: 36,
            lc30: 24.5,
            lc10: 13.5
        },
        "saffron.400": {
            contrast: 101.89564776913112,
            lc60: 50.5,
            lc45: 37.5,
            lc30: 25.5,
            lc10: 13.5
        },
        "saffron.500": {
            contrast: 98.81000830464711,
            lc60: 53.5,
            lc45: 39.5,
            lc30: 26,
            lc10: 14
        },
        "saffron.600": {
            contrast: 94.37083911185587,
            lc60: 57,
            lc45: 42,
            lc30: 28,
            lc10: 15
        },
        "saffron.700": {
            contrast: 90.16733885217775,
            lc60: 59.5,
            lc45: 44,
            lc30: 29.5,
            lc10: 15.5
        },
        "saffron.800": {
            contrast: 85.39347224250348,
            lc60: 63.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 17
        },
        "saffron.900": {
            contrast: 80.94983368518417,
            lc60: 68,
            lc45: 49.5,
            lc30: 33,
            lc10: 17.5
        },
        "saffron.1000": {
            contrast: 76.84324908378946,
            lc60: 72,
            lc45: 52.5,
            lc30: 34.5,
            lc10: 18.5
        },
        "saffron.1100": {
            contrast: 72.22473041800043,
            lc60: 78,
            lc45: 55.5,
            lc30: 37,
            lc10: 20
        },
        "saffron.1200": {
            contrast: 67.84164992311895,
            lc60: 84.5,
            lc45: 59.5,
            lc30: 39,
            lc10: 20.5
        },
        "saffron.1300": {
            contrast: 62.936816289242024,
            lc60: 95,
            lc45: 64.5,
            lc30: 41.5,
            lc10: 22
        },
        "saffron.1400": {
            contrast: 58.59987889797841,
            lc60: 100,
            lc45: 70.5,
            lc30: 45,
            lc10: 24
        },
        "saffron.1500": {
            contrast: 54.527869503953376,
            lc60: 100,
            lc45: 77.5,
            lc30: 49.5,
            lc10: 26
        },
        "saffron.1600": {
            contrast: 50.96199561371573,
            lc60: 100,
            lc45: 86.5,
            lc30: 55,
            lc10: 28.5
        },
        "saffron.1700": {
            contrast: 45.94397299659273,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 33
        },
        "saffron.1800": {
            contrast: 39.85345649628583,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 39
        },
        "saffron.1900": {
            contrast: 33.41672614772258,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 48
        },
        "saffron.2000": {
            contrast: 27.678066529450728,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "saffron.2100": {
            contrast: 21.974048032504136,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "saffron.2200": {
            contrast: 15.941334672813214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2300": {
            contrast: 9.86243687133773,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "saffron.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$indigo = {
    "indigo.100": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 7.965790458130313,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 10.960749645107665,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 15.227361556657664,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 19.431619565456952,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 90.5
        },
        "indigo.1000": {
            contrast: 24.306344103782838,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1100": {
            contrast: 28.783423858063788,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "indigo.1200": {
            contrast: 33.7168335008944,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 67
        },
        "indigo.1300": {
            contrast: 38.76624143351852,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 62
        },
        "indigo.1400": {
            contrast: 43.573253064410636,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 57.5
        },
        "indigo.1500": {
            contrast: 48.572018151285654,
            lc60: 100,
            lc45: 97,
            lc30: 77,
            lc10: 54.5
        },
        "indigo.1600": {
            contrast: 53.35908012142506,
            lc60: 100,
            lc45: 91,
            lc30: 72.5,
            lc10: 51
        },
        "indigo.1700": {
            contrast: 58.855334330346864,
            lc60: 100,
            lc45: 86,
            lc30: 68,
            lc10: 48
        },
        "indigo.1800": {
            contrast: 64.6119568907903,
            lc60: 96,
            lc45: 81,
            lc30: 64.5,
            lc10: 45.5
        },
        "indigo.1900": {
            contrast: 70.2106627378178,
            lc60: 91.5,
            lc45: 77,
            lc30: 61.5,
            lc10: 43
        },
        "indigo.2000": {
            contrast: 76.01333066880579,
            lc60: 87,
            lc45: 73.5,
            lc30: 58.5,
            lc10: 41
        },
        "indigo.2100": {
            contrast: 82.13497683707338,
            lc60: 83,
            lc45: 69.5,
            lc30: 55.5,
            lc10: 39
        },
        "indigo.2200": {
            contrast: 88.32330207932317,
            lc60: 79,
            lc45: 66.5,
            lc30: 53.5,
            lc10: 37.5
        },
        "indigo.2300": {
            contrast: 94.36985908929962,
            lc60: 76,
            lc45: 64,
            lc30: 51,
            lc10: 36
        },
        "indigo.2400": {
            contrast: 101.03966032678929,
            lc60: 73,
            lc45: 61.5,
            lc30: 48.5,
            lc10: 34.5
        },
        "indigo.2500": {
            contrast: 107.88473318309848,
            lc60: 69.5,
            lc45: 59,
            lc30: 46.5,
            lc10: 33
        }
    },
    "indigo.200": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 7.39595363701525,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 10.3909128239926,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 14.657524735542601,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 18.86178274434189,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "indigo.1000": {
            contrast: 23.73650728266777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "indigo.1100": {
            contrast: 28.213587036948724,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "indigo.1200": {
            contrast: 33.14699667977934,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 65
        },
        "indigo.1300": {
            contrast: 38.196404612403455,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 59.5
        },
        "indigo.1400": {
            contrast: 43.00341624329557,
            lc60: 100,
            lc45: 100,
            lc30: 81,
            lc10: 55
        },
        "indigo.1500": {
            contrast: 48.00218133017059,
            lc60: 100,
            lc45: 97,
            lc30: 76.5,
            lc10: 52
        },
        "indigo.1600": {
            contrast: 52.78924330031,
            lc60: 100,
            lc45: 91.5,
            lc30: 71.5,
            lc10: 49
        },
        "indigo.1700": {
            contrast: 58.285497509231796,
            lc60: 100,
            lc45: 86,
            lc30: 67.5,
            lc10: 46
        },
        "indigo.1800": {
            contrast: 64.04212006967522,
            lc60: 97,
            lc45: 81,
            lc30: 64,
            lc10: 43.5
        },
        "indigo.1900": {
            contrast: 69.64082591670274,
            lc60: 91.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 41.5
        },
        "indigo.2000": {
            contrast: 75.44349384769072,
            lc60: 87,
            lc45: 73,
            lc30: 57,
            lc10: 39.5
        },
        "indigo.2100": {
            contrast: 81.56514001595832,
            lc60: 83,
            lc45: 69.5,
            lc30: 55,
            lc10: 37.5
        },
        "indigo.2200": {
            contrast: 87.75346525820812,
            lc60: 79,
            lc45: 66,
            lc30: 52,
            lc10: 36
        },
        "indigo.2300": {
            contrast: 93.80002226818455,
            lc60: 76,
            lc45: 63.5,
            lc30: 50,
            lc10: 34.5
        },
        "indigo.2400": {
            contrast: 100.46982350567421,
            lc60: 72.5,
            lc45: 60.5,
            lc30: 48,
            lc10: 33
        },
        "indigo.2500": {
            contrast: 107.31489636198341,
            lc60: 69.5,
            lc45: 58,
            lc30: 46,
            lc10: 31.5
        }
    },
    "indigo.300": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 9.17526408625352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 13.441875997803518,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 17.64613400660281,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 94
        },
        "indigo.1000": {
            contrast: 22.520858544928693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1100": {
            contrast: 26.99793829920964,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "indigo.1200": {
            contrast: 31.931347942040254,
            lc60: 100,
            lc45: 100,
            lc30: 98,
            lc10: 64.5
        },
        "indigo.1300": {
            contrast: 36.980755874664375,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 59
        },
        "indigo.1400": {
            contrast: 41.78776750555648,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 55
        },
        "indigo.1500": {
            contrast: 46.7865325924315,
            lc60: 100,
            lc45: 99,
            lc30: 77,
            lc10: 51.5
        },
        "indigo.1600": {
            contrast: 51.57359456257091,
            lc60: 100,
            lc45: 92.5,
            lc30: 72.5,
            lc10: 48.5
        },
        "indigo.1700": {
            contrast: 57.06984877149273,
            lc60: 100,
            lc45: 87,
            lc30: 68,
            lc10: 45.5
        },
        "indigo.1800": {
            contrast: 62.82647133193615,
            lc60: 98,
            lc45: 81.5,
            lc30: 64,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 68.42517717896366,
            lc60: 92.5,
            lc45: 77,
            lc30: 60.5,
            lc10: 40.5
        },
        "indigo.2000": {
            contrast: 74.22784510995164,
            lc60: 88,
            lc45: 73.5,
            lc30: 57,
            lc10: 39
        },
        "indigo.2100": {
            contrast: 80.34949127821923,
            lc60: 83.5,
            lc45: 69.5,
            lc30: 54.5,
            lc10: 37
        },
        "indigo.2200": {
            contrast: 86.53781652046904,
            lc60: 79.5,
            lc45: 66,
            lc30: 52,
            lc10: 35
        },
        "indigo.2300": {
            contrast: 92.58437353044549,
            lc60: 76,
            lc45: 63.5,
            lc30: 49.5,
            lc10: 34
        },
        "indigo.2400": {
            contrast: 99.25417476793513,
            lc60: 73,
            lc45: 60.5,
            lc30: 47.5,
            lc10: 32.5
        },
        "indigo.2500": {
            contrast: 106.09924762424431,
            lc60: 69.5,
            lc45: 58.5,
            lc30: 46,
            lc10: 31
        }
    },
    "indigo.400": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 7.45674346986753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 11.72335538141753,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 15.927613390216818,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 20.802337928542702,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84.5
        },
        "indigo.1100": {
            contrast: 25.279417682823652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74.5
        },
        "indigo.1200": {
            contrast: 30.212827325654263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "indigo.1300": {
            contrast: 35.26223525827839,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 60.5
        },
        "indigo.1400": {
            contrast: 40.06924688917049,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 55.5
        },
        "indigo.1500": {
            contrast: 45.06801197604551,
            lc60: 100,
            lc45: 100,
            lc30: 78.5,
            lc10: 52
        },
        "indigo.1600": {
            contrast: 49.85507394618492,
            lc60: 100,
            lc45: 95,
            lc30: 73.5,
            lc10: 48.5
        },
        "indigo.1700": {
            contrast: 55.35132815510673,
            lc60: 100,
            lc45: 88.5,
            lc30: 69,
            lc10: 46
        },
        "indigo.1800": {
            contrast: 61.10795071555015,
            lc60: 99.5,
            lc45: 83,
            lc30: 64.5,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 66.70665656257766,
            lc60: 94,
            lc45: 78.5,
            lc30: 61,
            lc10: 41
        },
        "indigo.2000": {
            contrast: 72.50932449356566,
            lc60: 89,
            lc45: 74,
            lc30: 58,
            lc10: 39
        },
        "indigo.2100": {
            contrast: 78.63097066183325,
            lc60: 84.5,
            lc45: 70.5,
            lc30: 55,
            lc10: 37
        },
        "indigo.2200": {
            contrast: 84.81929590408303,
            lc60: 80.5,
            lc45: 67.5,
            lc30: 52.5,
            lc10: 35
        },
        "indigo.2300": {
            contrast: 90.86585291405949,
            lc60: 77,
            lc45: 64.5,
            lc30: 50,
            lc10: 34
        },
        "indigo.2400": {
            contrast: 97.53565415154914,
            lc60: 73.5,
            lc45: 61.5,
            lc30: 48,
            lc10: 32.5
        },
        "indigo.2500": {
            contrast: 104.38072700785834,
            lc60: 70.5,
            lc45: 59,
            lc30: 46,
            lc10: 31
        }
    },
    "indigo.500": {
        "indigo.100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 9.24011191888848,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 13.444369927687772,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 18.319094466013652,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91.5
        },
        "indigo.1100": {
            contrast: 22.796174220294603,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "indigo.1200": {
            contrast: 27.729583863125214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "indigo.1300": {
            contrast: 32.77899179574933,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 63
        },
        "indigo.1400": {
            contrast: 37.58600342664144,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 58
        },
        "indigo.1500": {
            contrast: 42.584768513516465,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 53.5
        },
        "indigo.1600": {
            contrast: 47.37183048365588,
            lc60: 100,
            lc45: 98,
            lc30: 76,
            lc10: 50.5
        },
        "indigo.1700": {
            contrast: 52.868084692577675,
            lc60: 100,
            lc45: 91,
            lc30: 71,
            lc10: 47
        },
        "indigo.1800": {
            contrast: 58.6247072530211,
            lc60: 100,
            lc45: 85.5,
            lc30: 66.5,
            lc10: 44.5
        },
        "indigo.1900": {
            contrast: 64.2234131000486,
            lc60: 96.5,
            lc45: 80.5,
            lc30: 62.5,
            lc10: 41.5
        },
        "indigo.2000": {
            contrast: 70.0260810310366,
            lc60: 91.5,
            lc45: 76,
            lc30: 59,
            lc10: 39.5
        },
        "indigo.2100": {
            contrast: 76.1477271993042,
            lc60: 86,
            lc45: 72,
            lc30: 56.5,
            lc10: 37.5
        },
        "indigo.2200": {
            contrast: 82.33605244155399,
            lc60: 82,
            lc45: 68.5,
            lc30: 53.5,
            lc10: 36
        },
        "indigo.2300": {
            contrast: 88.38260945153044,
            lc60: 78.5,
            lc45: 65.5,
            lc30: 51,
            lc10: 34
        },
        "indigo.2400": {
            contrast: 95.05241068902009,
            lc60: 75,
            lc45: 62.5,
            lc30: 48.5,
            lc10: 33
        },
        "indigo.2500": {
            contrast: 101.89748354532928,
            lc60: 71.5,
            lc45: 60,
            lc30: 46.5,
            lc10: 31.5
        }
    },
    "indigo.600": {
        "indigo.100": {
            contrast: 9.280478554779798,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 8.518410662217246,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 10.121038607271057,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 14.995763145596941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 19.47284289987789,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88.5
        },
        "indigo.1200": {
            contrast: 24.406252542708508,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "indigo.1300": {
            contrast: 29.455660475332625,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68.5
        },
        "indigo.1400": {
            contrast: 34.262672106224734,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 62.5
        },
        "indigo.1500": {
            contrast: 39.26143719309975,
            lc60: 100,
            lc45: 100,
            lc30: 86,
            lc10: 57.5
        },
        "indigo.1600": {
            contrast: 44.04849916323917,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 53.5
        },
        "indigo.1700": {
            contrast: 49.54475337216097,
            lc60: 100,
            lc45: 95,
            lc30: 74.5,
            lc10: 49.5
        },
        "indigo.1800": {
            contrast: 55.3013759326044,
            lc60: 100,
            lc45: 89,
            lc30: 69.5,
            lc10: 46.5
        },
        "indigo.1900": {
            contrast: 60.90008177963189,
            lc60: 100,
            lc45: 84,
            lc30: 65.5,
            lc10: 44
        },
        "indigo.2000": {
            contrast: 66.7027497106199,
            lc60: 94.5,
            lc45: 79,
            lc30: 61.5,
            lc10: 42
        },
        "indigo.2100": {
            contrast: 72.82439587888747,
            lc60: 89,
            lc45: 74.5,
            lc30: 58.5,
            lc10: 39
        },
        "indigo.2200": {
            contrast: 79.01272112113728,
            lc60: 84.5,
            lc45: 71,
            lc30: 55.5,
            lc10: 37
        },
        "indigo.2300": {
            contrast: 85.05927813111373,
            lc60: 80.5,
            lc45: 68,
            lc30: 53,
            lc10: 35.5
        },
        "indigo.2400": {
            contrast: 91.7290793686034,
            lc60: 77,
            lc45: 64.5,
            lc30: 50.5,
            lc10: 34
        },
        "indigo.2500": {
            contrast: 98.57415222491255,
            lc60: 73.5,
            lc45: 61.5,
            lc30: 48,
            lc10: 32.5
        }
    },
    "indigo.700": {
        "indigo.100": {
            contrast: 12.560735953191033,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.200": {
            contrast: 11.798668060628481,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.300": {
            contrast: 10.215178151515806,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 8.051604289706225,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 12.144370959402966,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 16.62145071368392,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 97
        },
        "indigo.1200": {
            contrast: 21.554860356514535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79.5
        },
        "indigo.1300": {
            contrast: 26.60426828913865,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "indigo.1400": {
            contrast: 31.41127992003076,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 61
        },
        "indigo.1500": {
            contrast: 36.410045006905776,
            lc60: 100,
            lc45: 100,
            lc30: 89,
            lc10: 55
        },
        "indigo.1600": {
            contrast: 41.197106977045195,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 50.5
        },
        "indigo.1700": {
            contrast: 46.693361185967,
            lc60: 100,
            lc45: 99,
            lc30: 74.5,
            lc10: 46
        },
        "indigo.1800": {
            contrast: 52.449983746410425,
            lc60: 100,
            lc45: 90.5,
            lc30: 68.5,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 58.04868959343793,
            lc60: 100,
            lc45: 84.5,
            lc30: 64,
            lc10: 40
        },
        "indigo.2000": {
            contrast: 63.851357524425914,
            lc60: 96.5,
            lc45: 79,
            lc30: 59.5,
            lc10: 37.5
        },
        "indigo.2100": {
            contrast: 69.97300369269351,
            lc60: 90.5,
            lc45: 74,
            lc30: 56,
            lc10: 35
        },
        "indigo.2200": {
            contrast: 76.16132893494331,
            lc60: 85.5,
            lc45: 70,
            lc30: 53,
            lc10: 33.5
        },
        "indigo.2300": {
            contrast: 82.20788594491975,
            lc60: 80.5,
            lc45: 66.5,
            lc30: 50,
            lc10: 31.5
        },
        "indigo.2400": {
            contrast: 88.8776871824094,
            lc60: 77,
            lc45: 62.5,
            lc30: 48,
            lc10: 29.5
        },
        "indigo.2500": {
            contrast: 95.72276003871859,
            lc60: 73,
            lc45: 59.5,
            lc30: 45.5,
            lc10: 28.5
        }
    },
    "indigo.800": {
        "indigo.100": {
            contrast: 17.14024638478992,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "indigo.200": {
            contrast: 16.37817849222737,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "indigo.300": {
            contrast: 14.794688583114693,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.400": {
            contrast: 12.631114721305112,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.500": {
            contrast: 9.61701428337734,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 8.040994817103062,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 12.518074571384014,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 17.45148421421463,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "indigo.1300": {
            contrast: 22.500892146838744,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76.5
        },
        "indigo.1400": {
            contrast: 27.307903777730854,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65.5
        },
        "indigo.1500": {
            contrast: 32.306668864605875,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 58
        },
        "indigo.1600": {
            contrast: 37.09373083474529,
            lc60: 100,
            lc45: 100,
            lc30: 87,
            lc10: 52
        },
        "indigo.1700": {
            contrast: 42.58998504366709,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 47
        },
        "indigo.1800": {
            contrast: 48.34660760411052,
            lc60: 100,
            lc45: 96.5,
            lc30: 71.5,
            lc10: 43
        },
        "indigo.1900": {
            contrast: 53.94531345113802,
            lc60: 100,
            lc45: 88.5,
            lc30: 66,
            lc10: 40
        },
        "indigo.2000": {
            contrast: 59.747981382126014,
            lc60: 100,
            lc45: 82.5,
            lc30: 61,
            lc10: 37
        },
        "indigo.2100": {
            contrast: 65.8696275503936,
            lc60: 94,
            lc45: 76,
            lc30: 57,
            lc10: 34.5
        },
        "indigo.2200": {
            contrast: 72.05795279264339,
            lc60: 88,
            lc45: 71.5,
            lc30: 53.5,
            lc10: 32
        },
        "indigo.2300": {
            contrast: 78.10450980261984,
            lc60: 83,
            lc45: 67.5,
            lc30: 50,
            lc10: 30.5
        },
        "indigo.2400": {
            contrast: 84.77431104010951,
            lc60: 78.5,
            lc45: 63.5,
            lc30: 47,
            lc10: 28.5
        },
        "indigo.2500": {
            contrast: 91.61938389641868,
            lc60: 73.5,
            lc45: 60.5,
            lc30: 44.5,
            lc10: 27
        }
    },
    "indigo.900": {
        "indigo.100": {
            contrast: 21.566311949215986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 52
        },
        "indigo.200": {
            contrast: 20.804244056653438,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.300": {
            contrast: 19.22075414754076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "indigo.400": {
            contrast: 17.05718028573118,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "indigo.500": {
            contrast: 14.043079847803408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.600": {
            contrast: 10.15766350772622,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 8.43535963535486,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 13.368769278185475,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 18.418177210809596,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89
        },
        "indigo.1400": {
            contrast: 23.2251888417017,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "indigo.1500": {
            contrast: 28.223953928576723,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.1600": {
            contrast: 33.01101589871613,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 55.5
        },
        "indigo.1700": {
            contrast: 38.507270107637936,
            lc60: 100,
            lc45: 100,
            lc30: 84,
            lc10: 49.5
        },
        "indigo.1800": {
            contrast: 44.26389266808136,
            lc60: 100,
            lc45: 100,
            lc30: 75.5,
            lc10: 44.5
        },
        "indigo.1900": {
            contrast: 49.86259851510887,
            lc60: 100,
            lc45: 93.5,
            lc30: 69.5,
            lc10: 40.5
        },
        "indigo.2000": {
            contrast: 55.665266446096865,
            lc60: 100,
            lc45: 86,
            lc30: 63,
            lc10: 37
        },
        "indigo.2100": {
            contrast: 61.78691261436444,
            lc60: 99,
            lc45: 80,
            lc30: 58.5,
            lc10: 34.5
        },
        "indigo.2200": {
            contrast: 67.97523785661424,
            lc60: 91.5,
            lc45: 74,
            lc30: 54,
            lc10: 32
        },
        "indigo.2300": {
            contrast: 74.0217948665907,
            lc60: 86,
            lc45: 69.5,
            lc30: 51,
            lc10: 30
        },
        "indigo.2400": {
            contrast: 80.69159610408036,
            lc60: 80.5,
            lc45: 65,
            lc30: 48,
            lc10: 28
        },
        "indigo.2500": {
            contrast: 87.53666896038953,
            lc60: 76,
            lc45: 61,
            lc30: 45,
            lc10: 26.5
        }
    },
    "indigo.1000": {
        "indigo.100": {
            contrast: 26.611022274641694,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "indigo.200": {
            contrast: 25.84895438207915,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 48.5
        },
        "indigo.300": {
            contrast: 24.26546447296647,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 54.5
        },
        "indigo.400": {
            contrast: 22.101890611156893,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.500": {
            contrast: 19.08779017322912,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77
        },
        "indigo.600": {
            contrast: 15.202373833151931,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.700": {
            contrast: 11.969115301809119,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.800": {
            contrast: 7.439985326275321,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 8.59423836931789,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 13.643646301942008,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 18.45065793283412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "indigo.1500": {
            contrast: 23.44942301970914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 72.5
        },
        "indigo.1600": {
            contrast: 28.23648498984855,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "indigo.1700": {
            contrast: 33.73273919877035,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 53.5
        },
        "indigo.1800": {
            contrast: 39.48936175921378,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 48
        },
        "indigo.1900": {
            contrast: 45.08806760624128,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 43
        },
        "indigo.2000": {
            contrast: 50.89073553722927,
            lc60: 100,
            lc45: 91.5,
            lc30: 67,
            lc10: 39
        },
        "indigo.2100": {
            contrast: 57.01238170549687,
            lc60: 100,
            lc45: 84.5,
            lc30: 61,
            lc10: 35.5
        },
        "indigo.2200": {
            contrast: 63.20070694774667,
            lc60: 97,
            lc45: 77.5,
            lc30: 56.5,
            lc10: 33
        },
        "indigo.2300": {
            contrast: 69.2472639577231,
            lc60: 90,
            lc45: 72,
            lc30: 52.5,
            lc10: 30
        },
        "indigo.2400": {
            contrast: 75.91706519521276,
            lc60: 84.5,
            lc45: 67,
            lc30: 49,
            lc10: 28.5
        },
        "indigo.2500": {
            contrast: 82.76213805152194,
            lc60: 79,
            lc45: 63,
            lc30: 46,
            lc10: 26
        }
    },
    "indigo.1100": {
        "indigo.100": {
            contrast: 31.175222873440244,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 37
        },
        "indigo.200": {
            contrast: 30.4131549808777,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 41
        },
        "indigo.300": {
            contrast: 28.82966507176502,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 45.5
        },
        "indigo.400": {
            contrast: 26.666091209955447,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 51
        },
        "indigo.500": {
            contrast: 23.651990772027673,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "indigo.600": {
            contrast: 19.766574431950485,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "indigo.700": {
            contrast: 16.53331590060767,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95.5
        },
        "indigo.800": {
            contrast: 12.004185925073873,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.900": {
            contrast: 7.612662326682296,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 9.225581168206972,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 14.032592799099083,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 19.031357885974103,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "indigo.1600": {
            contrast: 23.81841985611352,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "indigo.1700": {
            contrast: 29.31467406503532,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60
        },
        "indigo.1800": {
            contrast: 35.071296625478745,
            lc60: 100,
            lc45: 100,
            lc30: 89.5,
            lc10: 51.5
        },
        "indigo.1900": {
            contrast: 40.67000247250625,
            lc60: 100,
            lc45: 100,
            lc30: 79.5,
            lc10: 45.5
        },
        "indigo.2000": {
            contrast: 46.472670403494234,
            lc60: 100,
            lc45: 99,
            lc30: 71.5,
            lc10: 41
        },
        "indigo.2100": {
            contrast: 52.59431657176182,
            lc60: 100,
            lc45: 89.5,
            lc30: 65,
            lc10: 37
        },
        "indigo.2200": {
            contrast: 58.78264181401162,
            lc60: 100,
            lc45: 81.5,
            lc30: 59,
            lc10: 34
        },
        "indigo.2300": {
            contrast: 64.82919882398808,
            lc60: 95,
            lc45: 75.5,
            lc30: 54.5,
            lc10: 31.5
        },
        "indigo.2400": {
            contrast: 71.49900006147773,
            lc60: 88,
            lc45: 69.5,
            lc30: 50.5,
            lc10: 29
        },
        "indigo.2500": {
            contrast: 78.3440729177869,
            lc60: 81.5,
            lc45: 65,
            lc30: 47,
            lc10: 27.5
        }
    },
    "indigo.1200": {
        "indigo.100": {
            contrast: 36.139521150700006,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 32
        },
        "indigo.200": {
            contrast: 35.37745325813746,
            lc60: 100,
            lc45: 100,
            lc30: 73.5,
            lc10: 35.5
        },
        "indigo.300": {
            contrast: 33.79396334902478,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 38.5
        },
        "indigo.400": {
            contrast: 31.6303894872152,
            lc60: 100,
            lc45: 100,
            lc30: 95,
            lc10: 42.5
        },
        "indigo.500": {
            contrast: 28.61628904928743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 46.5
        },
        "indigo.600": {
            contrast: 24.730872709210242,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53.5
        },
        "indigo.700": {
            contrast: 21.49761417786743,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "indigo.800": {
            contrast: 16.968484202333634,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93.5
        },
        "indigo.900": {
            contrast: 12.576960603942055,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1000": {
            contrast: 7.557303600581419,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 9.132391854293516,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 14.131156941168538,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 18.91821891130795,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 86
        },
        "indigo.1700": {
            contrast: 24.414473120229754,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        },
        "indigo.1800": {
            contrast: 30.171095680673172,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.1900": {
            contrast: 35.76980152770068,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 49.5
        },
        "indigo.2000": {
            contrast: 41.57246945868867,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 44
        },
        "indigo.2100": {
            contrast: 47.694115626956254,
            lc60: 100,
            lc45: 96.5,
            lc30: 69.5,
            lc10: 39
        },
        "indigo.2200": {
            contrast: 53.882440869206064,
            lc60: 100,
            lc45: 87.5,
            lc30: 63,
            lc10: 35.5
        },
        "indigo.2300": {
            contrast: 59.928997879182496,
            lc60: 100,
            lc45: 80.5,
            lc30: 57,
            lc10: 32.5
        },
        "indigo.2400": {
            contrast: 66.59879911667215,
            lc60: 93,
            lc45: 73.5,
            lc30: 52.5,
            lc10: 30
        },
        "indigo.2500": {
            contrast: 73.44387197298134,
            lc60: 86,
            lc45: 68,
            lc30: 48.5,
            lc10: 28
        }
    },
    "indigo.1300": {
        "indigo.100": {
            contrast: 41.159192030825025,
            lc60: 100,
            lc45: 100,
            lc30: 56.5,
            lc10: 28.5
        },
        "indigo.200": {
            contrast: 40.39712413826248,
            lc60: 100,
            lc45: 100,
            lc30: 62,
            lc10: 31
        },
        "indigo.300": {
            contrast: 38.8136342291498,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 33.5
        },
        "indigo.400": {
            contrast: 36.650060367340224,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 36
        },
        "indigo.500": {
            contrast: 33.63595992941245,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 39
        },
        "indigo.600": {
            contrast: 29.75054358933526,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 42.5
        },
        "indigo.700": {
            contrast: 26.517285057992453,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "indigo.800": {
            contrast: 21.988155082458654,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "indigo.900": {
            contrast: 17.59663148406708,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 89.5
        },
        "indigo.1000": {
            contrast: 12.57697448070644,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1100": {
            contrast: 8.02406674170401,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 9.085186400991255,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 13.872248371130668,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 19.36850258005247,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 84
        },
        "indigo.1800": {
            contrast: 25.12512514049589,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 66.5
        },
        "indigo.1900": {
            contrast: 30.7238309875234,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "indigo.2000": {
            contrast: 36.52649891851139,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48.5
        },
        "indigo.2100": {
            contrast: 42.648145086778975,
            lc60: 100,
            lc45: 100,
            lc30: 76.5,
            lc10: 42.5
        },
        "indigo.2200": {
            contrast: 48.83647032902878,
            lc60: 100,
            lc45: 94.5,
            lc30: 68,
            lc10: 38
        },
        "indigo.2300": {
            contrast: 54.88302733900522,
            lc60: 100,
            lc45: 86,
            lc30: 61,
            lc10: 35
        },
        "indigo.2400": {
            contrast: 61.552828576494875,
            lc60: 99,
            lc45: 78.5,
            lc30: 55.5,
            lc10: 31.5
        },
        "indigo.2500": {
            contrast: 68.39790143280406,
            lc60: 90.5,
            lc45: 71.5,
            lc30: 51.5,
            lc10: 28
        }
    },
    "indigo.1400": {
        "indigo.100": {
            contrast: 45.887183234924365,
            lc60: 100,
            lc45: 100,
            lc30: 50.5,
            lc10: 26
        },
        "indigo.200": {
            contrast: 45.125115342361816,
            lc60: 100,
            lc45: 100,
            lc30: 55,
            lc10: 28
        },
        "indigo.300": {
            contrast: 43.54162543324914,
            lc60: 100,
            lc45: 100,
            lc30: 58.5,
            lc10: 29.5
        },
        "indigo.400": {
            contrast: 41.37805157143956,
            lc60: 100,
            lc45: 100,
            lc30: 63,
            lc10: 31.5
        },
        "indigo.500": {
            contrast: 38.36395113351179,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 33.5
        },
        "indigo.600": {
            contrast: 34.4785347934346,
            lc60: 100,
            lc45: 100,
            lc30: 80.5,
            lc10: 36.5
        },
        "indigo.700": {
            contrast: 31.245276262091785,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 45.5
        },
        "indigo.800": {
            contrast: 26.716146286557986,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.900": {
            contrast: 22.324622688166414,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69.5
        },
        "indigo.1000": {
            contrast: 17.304965684805776,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 93
        },
        "indigo.1100": {
            contrast: 12.752057945803347,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1200": {
            contrast: 7.789275621441768,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 9.042821652172387,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 14.539075861094188,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 20.29569842153761,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 81.5
        },
        "indigo.1900": {
            contrast: 25.894404268565115,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64.5
        },
        "indigo.2000": {
            contrast: 31.697072199553105,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 54
        },
        "indigo.2100": {
            contrast: 37.8187183678207,
            lc60: 100,
            lc45: 100,
            lc30: 84.5,
            lc10: 46.5
        },
        "indigo.2200": {
            contrast: 44.0070436100705,
            lc60: 100,
            lc45: 100,
            lc30: 74,
            lc10: 41
        },
        "indigo.2300": {
            contrast: 50.05360062004694,
            lc60: 100,
            lc45: 93.5,
            lc30: 65.5,
            lc10: 37
        },
        "indigo.2400": {
            contrast: 56.7234018575366,
            lc60: 100,
            lc45: 83,
            lc30: 59,
            lc10: 33.5
        },
        "indigo.2500": {
            contrast: 63.56847471384577,
            lc60: 96,
            lc45: 75.5,
            lc30: 53.5,
            lc10: 30
        }
    },
    "indigo.1500": {
        "indigo.100": {
            contrast: 50.75703302421763,
            lc60: 100,
            lc45: 73,
            lc30: 46,
            lc10: 24
        },
        "indigo.200": {
            contrast: 49.99496513165508,
            lc60: 100,
            lc45: 79,
            lc30: 48.5,
            lc10: 25
        },
        "indigo.300": {
            contrast: 48.4114752225424,
            lc60: 100,
            lc45: 86.5,
            lc30: 52,
            lc10: 26.5
        },
        "indigo.400": {
            contrast: 46.24790136073282,
            lc60: 100,
            lc45: 98,
            lc30: 55,
            lc10: 28
        },
        "indigo.500": {
            contrast: 43.233800922805045,
            lc60: 100,
            lc45: 100,
            lc30: 60,
            lc10: 29.5
        },
        "indigo.600": {
            contrast: 39.34838458272786,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 31.5
        },
        "indigo.700": {
            contrast: 36.11512605138504,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 39
        },
        "indigo.800": {
            contrast: 31.58599607585124,
            lc60: 100,
            lc45: 100,
            lc30: 97,
            lc10: 47
        },
        "indigo.900": {
            contrast: 27.19447247745967,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.1000": {
            contrast: 22.174815474099034,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71
        },
        "indigo.1100": {
            contrast: 17.621907735096602,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 91
        },
        "indigo.1200": {
            contrast: 12.659125410735028,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1300": {
            contrast: 7.630815978866819,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 9.49295890280301,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 15.249581463246434,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 20.84828731027394,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 79
        },
        "indigo.2000": {
            contrast: 26.650955241261933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "indigo.2100": {
            contrast: 32.772601409529514,
            lc60: 100,
            lc45: 100,
            lc30: 94.5,
            lc10: 53.5
        },
        "indigo.2200": {
            contrast: 38.96092665177932,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 46
        },
        "indigo.2300": {
            contrast: 45.00748366175576,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 39.5
        },
        "indigo.2400": {
            contrast: 51.67728489924542,
            lc60: 100,
            lc45: 90,
            lc30: 64.5,
            lc10: 35
        },
        "indigo.2500": {
            contrast: 58.52235775555461,
            lc60: 100,
            lc45: 81,
            lc30: 57.5,
            lc10: 31.5
        }
    },
    "indigo.1600": {
        "indigo.100": {
            contrast: 55.38032462523653,
            lc60: 100,
            lc45: 65,
            lc30: 42,
            lc10: 22
        },
        "indigo.200": {
            contrast: 54.61825673267398,
            lc60: 100,
            lc45: 69.5,
            lc30: 44.5,
            lc10: 23
        },
        "indigo.300": {
            contrast: 53.0347668235613,
            lc60: 100,
            lc45: 74.5,
            lc30: 47,
            lc10: 24
        },
        "indigo.400": {
            contrast: 50.871192961751724,
            lc60: 100,
            lc45: 80.5,
            lc30: 49.5,
            lc10: 25
        },
        "indigo.500": {
            contrast: 47.857092523823944,
            lc60: 100,
            lc45: 91,
            lc30: 53,
            lc10: 26.5
        },
        "indigo.600": {
            contrast: 43.97167618374675,
            lc60: 100,
            lc45: 100,
            lc30: 57,
            lc10: 28.5
        },
        "indigo.700": {
            contrast: 40.738417652403946,
            lc60: 100,
            lc45: 100,
            lc30: 69,
            lc10: 34.5
        },
        "indigo.800": {
            contrast: 36.20928767687015,
            lc60: 100,
            lc45: 100,
            lc30: 81.5,
            lc10: 40.5
        },
        "indigo.900": {
            contrast: 31.817764078478568,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 47.5
        },
        "indigo.1000": {
            contrast: 26.798107075117933,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "indigo.1100": {
            contrast: 22.245199336115505,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 71.5
        },
        "indigo.1200": {
            contrast: 17.282417011753928,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "indigo.1300": {
            contrast: 12.25410757988572,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1400": {
            contrast: 7.509550016252639,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 10.396152674279941,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 15.994858521307446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 21.797526452295436,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 76
        },
        "indigo.2100": {
            contrast: 27.919172620563025,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 60.5
        },
        "indigo.2200": {
            contrast: 34.10749786281283,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 50.5
        },
        "indigo.2300": {
            contrast: 40.15405487278927,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 44
        },
        "indigo.2400": {
            contrast: 46.823856110278925,
            lc60: 100,
            lc45: 98,
            lc30: 69.5,
            lc10: 38.5
        },
        "indigo.2500": {
            contrast: 53.668928966588105,
            lc60: 100,
            lc45: 87.5,
            lc30: 61.5,
            lc10: 34
        }
    },
    "indigo.1700": {
        "indigo.100": {
            contrast: 60.64444299892975,
            lc60: 100,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "indigo.200": {
            contrast: 59.882375106367206,
            lc60: 100,
            lc45: 62.5,
            lc30: 40.5,
            lc10: 21
        },
        "indigo.300": {
            contrast: 58.29888519725452,
            lc60: 100,
            lc45: 66,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.400": {
            contrast: 56.135311335444946,
            lc60: 100,
            lc45: 69.5,
            lc30: 44.5,
            lc10: 22.5
        },
        "indigo.500": {
            contrast: 53.121210897517166,
            lc60: 100,
            lc45: 75.5,
            lc30: 46.5,
            lc10: 24
        },
        "indigo.600": {
            contrast: 49.23579455743998,
            lc60: 100,
            lc45: 84.5,
            lc30: 49.5,
            lc10: 25
        },
        "indigo.700": {
            contrast: 46.00253602609717,
            lc60: 100,
            lc45: 99.5,
            lc30: 59,
            lc10: 30
        },
        "indigo.800": {
            contrast: 41.47340605056337,
            lc60: 100,
            lc45: 100,
            lc30: 69.5,
            lc10: 35
        },
        "indigo.900": {
            contrast: 37.0818824521718,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40
        },
        "indigo.1000": {
            contrast: 32.062225448811155,
            lc60: 100,
            lc45: 100,
            lc30: 95.5,
            lc10: 48
        },
        "indigo.1100": {
            contrast: 27.509317709808727,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 57
        },
        "indigo.1200": {
            contrast: 22.54653538544715,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "indigo.1300": {
            contrast: 17.518225953578945,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "indigo.1400": {
            contrast: 12.773668389945863,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1500": {
            contrast: 7.878968209636864,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 10.399109569631598,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 16.201777500619592,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "indigo.2100": {
            contrast: 22.32342366888718,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 74
        },
        "indigo.2200": {
            contrast: 28.51174891113698,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 59.5
        },
        "indigo.2300": {
            contrast: 34.55830592111342,
            lc60: 100,
            lc45: 100,
            lc30: 90,
            lc10: 50.5
        },
        "indigo.2400": {
            contrast: 41.22810715860308,
            lc60: 100,
            lc45: 100,
            lc30: 77,
            lc10: 42.5
        },
        "indigo.2500": {
            contrast: 48.07318001491227,
            lc60: 100,
            lc45: 95.5,
            lc30: 67.5,
            lc10: 37
        }
    },
    "indigo.1800": {
        "indigo.100": {
            contrast: 66.11192226121287,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "indigo.200": {
            contrast: 65.34985436865031,
            lc60: 81,
            lc45: 56.5,
            lc30: 37,
            lc10: 19
        },
        "indigo.300": {
            contrast: 63.76636445953763,
            lc60: 87,
            lc45: 59,
            lc30: 38.5,
            lc10: 20
        },
        "indigo.400": {
            contrast: 61.60279059772805,
            lc60: 96.5,
            lc45: 62,
            lc30: 39.5,
            lc10: 20.5
        },
        "indigo.500": {
            contrast: 58.58869015980027,
            lc60: 100,
            lc45: 66,
            lc30: 42,
            lc10: 22
        },
        "indigo.600": {
            contrast: 54.70327381972309,
            lc60: 100,
            lc45: 71,
            lc30: 44.5,
            lc10: 22.5
        },
        "indigo.700": {
            contrast: 51.470015288380274,
            lc60: 100,
            lc45: 83.5,
            lc30: 51.5,
            lc10: 27
        },
        "indigo.800": {
            contrast: 46.940885312846476,
            lc60: 100,
            lc45: 97,
            lc30: 59.5,
            lc10: 31
        },
        "indigo.900": {
            contrast: 42.5493617144549,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "indigo.1000": {
            contrast: 37.52970471109426,
            lc60: 100,
            lc45: 100,
            lc30: 80,
            lc10: 40.5
        },
        "indigo.1100": {
            contrast: 32.97679697209183,
            lc60: 100,
            lc45: 100,
            lc30: 93.5,
            lc10: 47
        },
        "indigo.1200": {
            contrast: 28.014014647730257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        },
        "indigo.1300": {
            contrast: 22.985705215862048,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70
        },
        "indigo.1400": {
            contrast: 18.24114765222897,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 88
        },
        "indigo.1500": {
            contrast: 13.34644747191997,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1600": {
            contrast: 8.69283409343919,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 10.316339182597575,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 16.437985350865166,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 98.5
        },
        "indigo.2200": {
            contrast: 22.626310593114965,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73.5
        },
        "indigo.2300": {
            contrast: 28.672867603091408,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58.5
        },
        "indigo.2400": {
            contrast: 35.34266884058106,
            lc60: 100,
            lc45: 100,
            lc30: 88,
            lc10: 48
        },
        "indigo.2500": {
            contrast: 42.18774169689024,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 41
        }
    },
    "indigo.1900": {
        "indigo.100": {
            contrast: 71.38818953602593,
            lc60: 69,
            lc45: 49.5,
            lc30: 32.5,
            lc10: 17
        },
        "indigo.200": {
            contrast: 70.62612164346338,
            lc60: 72.5,
            lc45: 51.5,
            lc30: 34,
            lc10: 18
        },
        "indigo.300": {
            contrast: 69.0426317343507,
            lc60: 76.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "indigo.400": {
            contrast: 66.87905787254113,
            lc60: 81,
            lc45: 56.5,
            lc30: 36.5,
            lc10: 19
        },
        "indigo.500": {
            contrast: 63.864957434613345,
            lc60: 88.5,
            lc45: 59,
            lc30: 38,
            lc10: 20
        },
        "indigo.600": {
            contrast: 59.97954109453616,
            lc60: 100,
            lc45: 62.5,
            lc30: 39.5,
            lc10: 20.5
        },
        "indigo.700": {
            contrast: 56.74628256319334,
            lc60: 100,
            lc45: 72.5,
            lc30: 46,
            lc10: 24
        },
        "indigo.800": {
            contrast: 52.21715258765954,
            lc60: 100,
            lc45: 83.5,
            lc30: 52.5,
            lc10: 28
        },
        "indigo.900": {
            contrast: 47.825628989267976,
            lc60: 100,
            lc45: 94.5,
            lc30: 59.5,
            lc10: 31
        },
        "indigo.1000": {
            contrast: 42.805971985907334,
            lc60: 100,
            lc45: 100,
            lc30: 68.5,
            lc10: 35.5
        },
        "indigo.1100": {
            contrast: 38.253064246904906,
            lc60: 100,
            lc45: 100,
            lc30: 79,
            lc10: 40.5
        },
        "indigo.1200": {
            contrast: 33.29028192254333,
            lc60: 100,
            lc45: 100,
            lc30: 92,
            lc10: 47.5
        },
        "indigo.1300": {
            contrast: 28.26197249067512,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56
        },
        "indigo.1400": {
            contrast: 23.517414927042044,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 68
        },
        "indigo.1500": {
            contrast: 18.622714746733042,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 85.5
        },
        "indigo.1600": {
            contrast: 13.969101368252263,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1700": {
            contrast: 8.663085532059107,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 10.691680589058214,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 16.880005831308015,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "indigo.2300": {
            contrast: 22.92656284128446,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 73
        },
        "indigo.2400": {
            contrast: 29.59636407877412,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 58
        },
        "indigo.2500": {
            contrast: 36.441436935083296,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 48
        }
    },
    "indigo.2000": {
        "indigo.100": {
            contrast: 76.81728656680659,
            lc60: 63.5,
            lc45: 46,
            lc30: 30.5,
            lc10: 16
        },
        "indigo.200": {
            contrast: 76.05521867424403,
            lc60: 66,
            lc45: 48,
            lc30: 31.5,
            lc10: 17
        },
        "indigo.300": {
            contrast: 74.47172876513135,
            lc60: 69,
            lc45: 49.5,
            lc30: 33,
            lc10: 17
        },
        "indigo.400": {
            contrast: 72.30815490332176,
            lc60: 72,
            lc45: 51.5,
            lc30: 33.5,
            lc10: 18
        },
        "indigo.500": {
            contrast: 69.294054465394,
            lc60: 77,
            lc45: 53.5,
            lc30: 35,
            lc10: 18.5
        },
        "indigo.600": {
            contrast: 65.40863812531683,
            lc60: 83.5,
            lc45: 56,
            lc30: 36.5,
            lc10: 19
        },
        "indigo.700": {
            contrast: 62.175379593974014,
            lc60: 96,
            lc45: 65,
            lc30: 42.5,
            lc10: 21.5
        },
        "indigo.800": {
            contrast: 57.6462496184402,
            lc60: 100,
            lc45: 73.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "indigo.900": {
            contrast: 53.25472602004863,
            lc60: 100,
            lc45: 82.5,
            lc30: 52.5,
            lc10: 27.5
        },
        "indigo.1000": {
            contrast: 48.235069016687994,
            lc60: 100,
            lc45: 94.5,
            lc30: 59.5,
            lc10: 31.5
        },
        "indigo.1100": {
            contrast: 43.68216127768556,
            lc60: 100,
            lc45: 100,
            lc30: 68,
            lc10: 35
        },
        "indigo.1200": {
            contrast: 38.71937895332398,
            lc60: 100,
            lc45: 100,
            lc30: 78,
            lc10: 40.5
        },
        "indigo.1300": {
            contrast: 33.69106952145577,
            lc60: 100,
            lc45: 100,
            lc30: 91.5,
            lc10: 47.5
        },
        "indigo.1400": {
            contrast: 28.94651195782269,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55.5
        },
        "indigo.1500": {
            contrast: 24.051811777513695,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 67.5
        },
        "indigo.1600": {
            contrast: 19.398198399032914,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 83.5
        },
        "indigo.1700": {
            contrast: 14.092182562839758,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1800": {
            contrast: 8.573484569355495,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 10.902798874835268,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 16.949355884811713,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 95
        },
        "indigo.2400": {
            contrast: 23.619157122301374,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 70.5
        },
        "indigo.2500": {
            contrast: 30.464229978610547,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 56.5
        }
    },
    "indigo.2100": {
        "indigo.100": {
            contrast: 82.50474547456749,
            lc60: 58.5,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "indigo.200": {
            contrast: 81.74267758200493,
            lc60: 60.5,
            lc45: 44.5,
            lc30: 29.5,
            lc10: 15.5
        },
        "indigo.300": {
            contrast: 80.15918767289224,
            lc60: 63,
            lc45: 46,
            lc30: 30,
            lc10: 16
        },
        "indigo.400": {
            contrast: 77.99561381108268,
            lc60: 65.5,
            lc45: 47,
            lc30: 31,
            lc10: 16.5
        },
        "indigo.500": {
            contrast: 74.9815133731549,
            lc60: 69,
            lc45: 49,
            lc30: 32,
            lc10: 17
        },
        "indigo.600": {
            contrast: 71.09609703307771,
            lc60: 73,
            lc45: 51,
            lc30: 33.5,
            lc10: 17.5
        },
        "indigo.700": {
            contrast: 67.86283850173488,
            lc60: 83,
            lc45: 58.5,
            lc30: 38,
            lc10: 20
        },
        "indigo.800": {
            contrast: 63.33370852620109,
            lc60: 94,
            lc45: 66,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.900": {
            contrast: 58.94218492780953,
            lc60: 100,
            lc45: 72.5,
            lc30: 47.5,
            lc10: 24.5
        },
        "indigo.1000": {
            contrast: 53.92252792444889,
            lc60: 100,
            lc45: 82,
            lc30: 53.5,
            lc10: 28
        },
        "indigo.1100": {
            contrast: 49.369620185446465,
            lc60: 100,
            lc45: 91.5,
            lc30: 59,
            lc10: 31.5
        },
        "indigo.1200": {
            contrast: 44.40683786108488,
            lc60: 100,
            lc45: 100,
            lc30: 67,
            lc10: 35.5
        },
        "indigo.1300": {
            contrast: 39.37852842921667,
            lc60: 100,
            lc45: 100,
            lc30: 77.5,
            lc10: 40.5
        },
        "indigo.1400": {
            contrast: 34.63397086558359,
            lc60: 100,
            lc45: 100,
            lc30: 88.5,
            lc10: 46.5
        },
        "indigo.1500": {
            contrast: 29.739270685274587,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 55
        },
        "indigo.1600": {
            contrast: 25.085657306793813,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 65
        },
        "indigo.1700": {
            contrast: 19.779641470600655,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1800": {
            contrast: 14.260943477116395,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.1900": {
            contrast: 8.928335238256185,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 10.621396365388938,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 17.291197602878597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92.5
        },
        "indigo.2500": {
            contrast: 24.136270459187774,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 69
        }
    },
    "indigo.2200": {
        "indigo.100": {
            contrast: 88.21545639709896,
            lc60: 54.5,
            lc45: 40,
            lc30: 26.5,
            lc10: 14.5
        },
        "indigo.200": {
            contrast: 87.4533885045364,
            lc60: 56.5,
            lc45: 41,
            lc30: 27.5,
            lc10: 15
        },
        "indigo.300": {
            contrast: 85.86989859542373,
            lc60: 58,
            lc45: 42.5,
            lc30: 28,
            lc10: 15
        },
        "indigo.400": {
            contrast: 83.70632473361415,
            lc60: 60,
            lc45: 43.5,
            lc30: 29,
            lc10: 15
        },
        "indigo.500": {
            contrast: 80.69222429568637,
            lc60: 62.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 15.5
        },
        "indigo.600": {
            contrast: 76.80680795560917,
            lc60: 65.5,
            lc45: 46.5,
            lc30: 31,
            lc10: 16
        },
        "indigo.700": {
            contrast: 73.57354942426637,
            lc60: 74.5,
            lc45: 53.5,
            lc30: 35,
            lc10: 19
        },
        "indigo.800": {
            contrast: 69.04441944873257,
            lc60: 83.5,
            lc45: 59,
            lc30: 39,
            lc10: 20.5
        },
        "indigo.900": {
            contrast: 64.65289585034101,
            lc60: 91.5,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.1000": {
            contrast: 59.633238846980355,
            lc60: 100,
            lc45: 73,
            lc30: 48,
            lc10: 25.5
        },
        "indigo.1100": {
            contrast: 55.08033110797793,
            lc60: 100,
            lc45: 80,
            lc30: 52.5,
            lc10: 28
        },
        "indigo.1200": {
            contrast: 50.11754878361635,
            lc60: 100,
            lc45: 89.5,
            lc30: 59,
            lc10: 31.5
        },
        "indigo.1300": {
            contrast: 45.08923935174815,
            lc60: 100,
            lc45: 100,
            lc30: 66,
            lc10: 35
        },
        "indigo.1400": {
            contrast: 40.34468178811507,
            lc60: 100,
            lc45: 100,
            lc30: 75,
            lc10: 40
        },
        "indigo.1500": {
            contrast: 35.449981607806066,
            lc60: 100,
            lc45: 100,
            lc30: 86.5,
            lc10: 46
        },
        "indigo.1600": {
            contrast: 30.79636822932529,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 53
        },
        "indigo.1700": {
            contrast: 25.490352393132127,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 63
        },
        "indigo.1800": {
            contrast: 19.971654399647868,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80.5
        },
        "indigo.1900": {
            contrast: 14.639046160787661,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2000": {
            contrast: 9.145361659451574,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 10.872675696661076,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 17.717748552970257,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 92
        }
    },
    "indigo.2300": {
        "indigo.100": {
            contrast: 93.76042793347862,
            lc60: 51,
            lc45: 37.5,
            lc30: 25,
            lc10: 13.5
        },
        "indigo.200": {
            contrast: 92.99836004091607,
            lc60: 53,
            lc45: 39,
            lc30: 26,
            lc10: 13.5
        },
        "indigo.300": {
            contrast: 91.4148701318034,
            lc60: 54,
            lc45: 40,
            lc30: 26.5,
            lc10: 14
        },
        "indigo.400": {
            contrast: 89.25129626999383,
            lc60: 55.5,
            lc45: 40.5,
            lc30: 27,
            lc10: 14.5
        },
        "indigo.500": {
            contrast: 86.23719583206604,
            lc60: 57.5,
            lc45: 42,
            lc30: 28,
            lc10: 15
        },
        "indigo.600": {
            contrast: 82.35177949198885,
            lc60: 60,
            lc45: 43.5,
            lc30: 28.5,
            lc10: 15
        },
        "indigo.700": {
            contrast: 79.11852096064604,
            lc60: 68,
            lc45: 49,
            lc30: 32.5,
            lc10: 17
        },
        "indigo.800": {
            contrast: 74.58939098511225,
            lc60: 75,
            lc45: 54.5,
            lc30: 36,
            lc10: 19
        },
        "indigo.900": {
            contrast: 70.19786738672067,
            lc60: 82.5,
            lc45: 59,
            lc30: 39,
            lc10: 20.5
        },
        "indigo.1000": {
            contrast: 65.17821038336002,
            lc60: 91.5,
            lc45: 65.5,
            lc30: 43,
            lc10: 23
        },
        "indigo.1100": {
            contrast: 60.6253026443576,
            lc60: 100,
            lc45: 71.5,
            lc30: 47.5,
            lc10: 25
        },
        "indigo.1200": {
            contrast: 55.66252031999602,
            lc60: 100,
            lc45: 79.5,
            lc30: 52.5,
            lc10: 28
        },
        "indigo.1300": {
            contrast: 50.63421088812782,
            lc60: 100,
            lc45: 89.5,
            lc30: 59,
            lc10: 31.5
        },
        "indigo.1400": {
            contrast: 45.88965332449474,
            lc60: 100,
            lc45: 100,
            lc30: 65.5,
            lc10: 35
        },
        "indigo.1500": {
            contrast: 40.994953144185736,
            lc60: 100,
            lc45: 100,
            lc30: 74.5,
            lc10: 39.5
        },
        "indigo.1600": {
            contrast: 36.34133976570496,
            lc60: 100,
            lc45: 100,
            lc30: 85,
            lc10: 45.5
        },
        "indigo.1700": {
            contrast: 31.035323929511797,
            lc60: 100,
            lc45: 100,
            lc30: 99,
            lc10: 53.5
        },
        "indigo.1800": {
            contrast: 25.516625936027538,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 64
        },
        "indigo.1900": {
            contrast: 20.18401769716733,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 80
        },
        "indigo.2000": {
            contrast: 14.690333195831244,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2100": {
            contrast: 8.928473300615382,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 11.426557231477766,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "indigo.2400": {
        "indigo.100": {
            contrast: 99.8396566589299,
            lc60: 48,
            lc45: 35,
            lc30: 24,
            lc10: 12.5
        },
        "indigo.200": {
            contrast: 99.07758876636736,
            lc60: 49,
            lc45: 36,
            lc30: 24.5,
            lc10: 13
        },
        "indigo.300": {
            contrast: 97.49409885725467,
            lc60: 50.5,
            lc45: 37,
            lc30: 25,
            lc10: 13.5
        },
        "indigo.400": {
            contrast: 95.3305249954451,
            lc60: 51.5,
            lc45: 38,
            lc30: 25.5,
            lc10: 13.5
        },
        "indigo.500": {
            contrast: 92.31642455751731,
            lc60: 53.5,
            lc45: 39,
            lc30: 26,
            lc10: 14
        },
        "indigo.600": {
            contrast: 88.43100821744012,
            lc60: 55,
            lc45: 40,
            lc30: 26.5,
            lc10: 14.5
        },
        "indigo.700": {
            contrast: 85.19774968609731,
            lc60: 61.5,
            lc45: 45,
            lc30: 29.5,
            lc10: 16
        },
        "indigo.800": {
            contrast: 80.66861971056352,
            lc60: 68,
            lc45: 49.5,
            lc30: 33,
            lc10: 17.5
        },
        "indigo.900": {
            contrast: 76.27709611217195,
            lc60: 74,
            lc45: 53.5,
            lc30: 35.5,
            lc10: 19
        },
        "indigo.1000": {
            contrast: 71.2574391088113,
            lc60: 81,
            lc45: 59,
            lc30: 39,
            lc10: 20.5
        },
        "indigo.1100": {
            contrast: 66.70453136980888,
            lc60: 89,
            lc45: 64.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.1200": {
            contrast: 61.74174904544729,
            lc60: 98,
            lc45: 71,
            lc30: 47,
            lc10: 25
        },
        "indigo.1300": {
            contrast: 56.713439613579084,
            lc60: 100,
            lc45: 78.5,
            lc30: 51.5,
            lc10: 27.5
        },
        "indigo.1400": {
            contrast: 51.96888204994601,
            lc60: 100,
            lc45: 86.5,
            lc30: 57,
            lc10: 30.5
        },
        "indigo.1500": {
            contrast: 47.074181869637,
            lc60: 100,
            lc45: 97,
            lc30: 64.5,
            lc10: 34
        },
        "indigo.1600": {
            contrast: 42.42056849115623,
            lc60: 100,
            lc45: 100,
            lc30: 72,
            lc10: 38.5
        },
        "indigo.1700": {
            contrast: 37.11455265496307,
            lc60: 100,
            lc45: 100,
            lc30: 82.5,
            lc10: 44.5
        },
        "indigo.1800": {
            contrast: 31.595854661478807,
            lc60: 100,
            lc45: 100,
            lc30: 97.5,
            lc10: 52.5
        },
        "indigo.1900": {
            contrast: 26.263246422618597,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62.5
        },
        "indigo.2000": {
            contrast: 20.769561921282513,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "indigo.2100": {
            contrast: 15.007702026066653,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2200": {
            contrast: 9.215770139924672,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    },
    "indigo.2500": {
        "indigo.100": {
            contrast: 106.04067321268862,
            lc60: 44.5,
            lc45: 33.5,
            lc30: 22.5,
            lc10: 12
        },
        "indigo.200": {
            contrast: 105.27860532012605,
            lc60: 46,
            lc45: 34,
            lc30: 23,
            lc10: 12.5
        },
        "indigo.300": {
            contrast: 103.69511541101338,
            lc60: 47,
            lc45: 35,
            lc30: 23.5,
            lc10: 12.5
        },
        "indigo.400": {
            contrast: 101.53154154920381,
            lc60: 48,
            lc45: 35.5,
            lc30: 24,
            lc10: 13
        },
        "indigo.500": {
            contrast: 98.51744111127601,
            lc60: 49.5,
            lc45: 36.5,
            lc30: 24.5,
            lc10: 13.5
        },
        "indigo.600": {
            contrast: 94.63202477119881,
            lc60: 51,
            lc45: 37,
            lc30: 25,
            lc10: 13.5
        },
        "indigo.700": {
            contrast: 91.39876623985602,
            lc60: 57,
            lc45: 42,
            lc30: 28,
            lc10: 15
        },
        "indigo.800": {
            contrast: 86.86963626432221,
            lc60: 62.5,
            lc45: 45.5,
            lc30: 30.5,
            lc10: 16.5
        },
        "indigo.900": {
            contrast: 82.47811266593065,
            lc60: 67,
            lc45: 49.5,
            lc30: 33,
            lc10: 18
        },
        "indigo.1000": {
            contrast: 77.45845566256999,
            lc60: 73.5,
            lc45: 53.5,
            lc30: 36,
            lc10: 19.5
        },
        "indigo.1100": {
            contrast: 72.90554792356757,
            lc60: 79.5,
            lc45: 58,
            lc30: 39,
            lc10: 21
        },
        "indigo.1200": {
            contrast: 67.94276559920598,
            lc60: 87.5,
            lc45: 63.5,
            lc30: 42.5,
            lc10: 22.5
        },
        "indigo.1300": {
            contrast: 62.91445616733778,
            lc60: 96.5,
            lc45: 69.5,
            lc30: 46.5,
            lc10: 25.5
        },
        "indigo.1400": {
            contrast: 58.16989860370471,
            lc60: 100,
            lc45: 76.5,
            lc30: 51,
            lc10: 27.5
        },
        "indigo.1500": {
            contrast: 53.27519842339571,
            lc60: 100,
            lc45: 85,
            lc30: 56,
            lc10: 30
        },
        "indigo.1600": {
            contrast: 48.62158504491493,
            lc60: 100,
            lc45: 94,
            lc30: 62.5,
            lc10: 33.5
        },
        "indigo.1700": {
            contrast: 43.31556920872177,
            lc60: 100,
            lc45: 100,
            lc30: 71,
            lc10: 38
        },
        "indigo.1800": {
            contrast: 37.7968712152375,
            lc60: 100,
            lc45: 100,
            lc30: 82,
            lc10: 44
        },
        "indigo.1900": {
            contrast: 32.46426297637729,
            lc60: 100,
            lc45: 100,
            lc30: 96,
            lc10: 51.5
        },
        "indigo.2000": {
            contrast: 26.970578475041208,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 62
        },
        "indigo.2100": {
            contrast: 21.20871857982535,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 77.5
        },
        "indigo.2200": {
            contrast: 15.41678669368337,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2300": {
            contrast: 9.787065069774279,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2400": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        },
        "indigo.2500": {
            contrast: 0,
            lc60: 100,
            lc45: 100,
            lc30: 100,
            lc10: 100
        }
    }
};
const $5bc9639ae0326803$var$contrast = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    crimson: $5bc9639ae0326803$var$crimson,
    gold: $5bc9639ae0326803$var$gold,
    green: $5bc9639ae0326803$var$green,
    indigo: $5bc9639ae0326803$var$indigo,
    informative: $5bc9639ae0326803$var$informative,
    marigold: $5bc9639ae0326803$var$marigold,
    mint: $5bc9639ae0326803$var$mint,
    navi: $5bc9639ae0326803$var$navi,
    negative: $5bc9639ae0326803$var$negative,
    neutral: $5bc9639ae0326803$var$neutral,
    orange: $5bc9639ae0326803$var$orange,
    pink: $5bc9639ae0326803$var$pink,
    positive: $5bc9639ae0326803$var$positive,
    purple: $5bc9639ae0326803$var$purple,
    red: $5bc9639ae0326803$var$red,
    reliance: $5bc9639ae0326803$var$reliance,
    saffron: $5bc9639ae0326803$var$saffron,
    sky: $5bc9639ae0326803$var$sky,
    violet: $5bc9639ae0326803$var$violet,
    warning: $5bc9639ae0326803$var$warning
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $5bc9639ae0326803$var$brand = {
    density: {
        compact: {
            min: 14,
            max: 18,
            advanced: {
                c1: 1,
                c2: 1.1,
                c3: 1.13
            }
        },
        "default": {
            min: 16,
            max: 20,
            advanced: {
                c1: 2,
                c2: 1.125,
                c3: 1.185
            }
        },
        open: {
            min: 17,
            max: 22,
            advanced: {
                c1: 3,
                c2: 1.15,
                c3: 1.195
            }
        }
    },
    typography: {
        display: {
            m: 6
        },
        headline: {
            m: 2
        },
        title: {
            m: 0
        },
        label: {
            m: 0
        },
        body: {
            m: 0
        },
        paragraph: {
            m: 0
        },
        font: {
            family: ""
        }
    },
    spacing: {
        component: {
            m: -2
        },
        pattern: {
            m: 0
        },
        layout: {
            m: 6
        }
    },
    gap: {
        component: {
            m: -2
        },
        pattern: {
            m: 0
        },
        layout: {
            m: 6
        }
    },
    shape: {
        component: {
            m: -2
        },
        pattern: {
            m: 0
        },
        layout: {
            m: 6
        }
    },
    dimension: {
        stroke: {
            m: 0
        }
    },
    motion: {
        duration: {
            m: -1
        },
        offset: {
            m: -5
        }
    }
};
const $5bc9639ae0326803$var$foundation = {
    step: {
        surface: {
            minimal: 1,
            minimalDecreased: -1,
            subtle: 2,
            subtleDecreased: -2,
            moderate: 3,
            moderateDecreased: -3
        },
        mode: {
            dim: 3
        },
        event: {
            hover: 1,
            active: 2
        }
    },
    contrast: {
        surface: {
            bold: 45,
            boldA11y: 60,
            heavy: 60
        },
        content: {
            moderate: 60,
            heavy: 60
        },
        stroke: {
            minimal: 10,
            moderate: 30,
            heavy: 60,
            bold: 60
        }
    },
    baseValue: {
        dimension: {
            stroke: 1
        },
        motion: {
            reduced: 100,
            discreet: 200,
            expressive: 300
        }
    },
    scaleFactor: {
        spacing: {
            pattern: 2,
            layout: 2,
            component: 1
        },
        gap: {
            pattern: 2,
            layout: 2,
            component: 1
        },
        shape: {
            pattern: 2,
            layout: 2,
            component: 1
        },
        typography: {
            display: 1,
            headline: 2,
            title: 2,
            label: 1,
            body: 1,
            paragraph: 1
        },
        motion: {
            duration: 1,
            offset: 2
        }
    }
};
const $5bc9639ae0326803$var$colors = {
    "candy.100": "oklch(0% 0 0)",
    "candy.200": "oklch(15.95% 0.0508 10.51)",
    "candy.300": "oklch(21.93% 0.0786 9.87)",
    "candy.400": "oklch(27.05% 0.1022 9.86)",
    "candy.500": "oklch(31.96% 0.1215 9.4)",
    "candy.600": "oklch(37.07% 0.1419 9.58)",
    "candy.700": "oklch(41.42% 0.1619 9.38)",
    "candy.800": "oklch(46.1% 0.1823 9.74)",
    "candy.900": "oklch(50.03% 0.1944 9.75)",
    "candy.1000": "oklch(53.54% 0.2041 9.88)",
    "candy.1100": "oklch(57.03% 0.2138 9.64)",
    "candy.1200": "oklch(60.5% 0.2202 9.63)",
    "candy.1300": "oklch(63% 0.2222 9.8)",
    "candy.1400": "oklch(65.87% 0.2232 9.68)",
    "candy.1500": "oklch(69% 0.206 9.59)",
    "candy.1600": "oklch(72.54% 0.175 9.98)",
    "candy.1700": "oklch(75.49% 0.1516 9.67)",
    "candy.1800": "oklch(79.08% 0.1244 9.67)",
    "candy.1900": "oklch(82.02% 0.1036 9.82)",
    "candy.2000": "oklch(85.11% 0.0832 9.65)",
    "candy.2100": "oklch(87.93% 0.0657 9.1)",
    "candy.2200": "oklch(91% 0.0474 9.98)",
    "candy.2300": "oklch(93.89% 0.0301 7.52)",
    "candy.2400": "oklch(96.97% 0.0153 7.48)",
    "candy.2500": "oklch(100% 0 118.64)",
    "candy.base": "1400",
    "candy.light": "1700",
    "candy.midnight": "1300",
    "cobalt.100": "oklch(0% 0 0)",
    "cobalt.200": "oklch(16% 0.08 270.67)",
    "cobalt.300": "oklch(22.02% 0.142 270.67)",
    "cobalt.400": "oklch(26.97% 0.175 270.67)",
    "cobalt.500": "oklch(31.97% 0.208 270.67)",
    "cobalt.600": "oklch(37.01% 0.241 270.67)",
    "cobalt.700": "oklch(41.46% 0.258 270.67)",
    "cobalt.800": "oklch(45% 0.264 270.67)",
    "cobalt.900": "oklch(48.72% 0.2679 270.67)",
    "cobalt.1000": "oklch(52.4% 0.265 270.67)",
    "cobalt.1100": "oklch(56% 0.242 270.67)",
    "cobalt.1200": "oklch(60% 0.217 270.67)",
    "cobalt.1300": "oklch(64.02% 0.192 270.67)",
    "cobalt.1400": "oklch(67.01% 0.174 270.67)",
    "cobalt.1500": "oklch(70.02% 0.156 270.67)",
    "cobalt.1600": "oklch(72.98% 0.139 270.67)",
    "cobalt.1700": "oklch(75.99% 0.122 270.67)",
    "cobalt.1800": "oklch(79.01% 0.105 270.67)",
    "cobalt.1900": "oklch(82.01% 0.089 270.67)",
    "cobalt.2000": "oklch(84.98% 0.073 270.67)",
    "cobalt.2100": "oklch(88.01% 0.058 270.67)",
    "cobalt.2200": "oklch(91.01% 0.043 270.67)",
    "cobalt.2300": "oklch(93.98% 0.028 270.67)",
    "cobalt.2400": "oklch(97.01% 0.014 270.67)",
    "cobalt.2500": "oklch(100% 0 137.33)",
    "cobalt.base": "1300",
    "cobalt.light": "1400",
    "cobalt.midnight": "1200",
    "coral.100": "oklch(0% 0 0)",
    "coral.200": "oklch(15.86% 0.0576 33.53)",
    "coral.300": "oklch(22.03% 0.0789 34.13)",
    "coral.400": "oklch(27% 0.0968 34.13)",
    "coral.500": "oklch(32.01% 0.1114 34.18)",
    "coral.600": "oklch(36.9% 0.1306 33.92)",
    "coral.700": "oklch(41.46% 0.1452 34.03)",
    "coral.800": "oklch(45.94% 0.1565 34.09)",
    "coral.900": "oklch(50.11% 0.1693 34.01)",
    "coral.1000": "oklch(53.55% 0.1799 34.16)",
    "coral.1100": "oklch(56.9% 0.1881 33.97)",
    "coral.1200": "oklch(60.49% 0.1914 34.27)",
    "coral.1300": "oklch(64.06% 0.1918 34.17)",
    "coral.1400": "oklch(67.08% 0.1922 34.17)",
    "coral.1500": "oklch(69.96% 0.1934 34.06)",
    "coral.1600": "oklch(73% 0.168 33.69)",
    "coral.1700": "oklch(75.99% 0.145 33.81)",
    "coral.1800": "oklch(79.08% 0.1227 34.56)",
    "coral.1900": "oklch(82.01% 0.1024 34.15)",
    "coral.2000": "oklch(84.97% 0.0813 33.84)",
    "coral.2100": "oklch(88.01% 0.0645 33.86)",
    "coral.2200": "oklch(90.96% 0.0456 33.15)",
    "coral.2300": "oklch(94.11% 0.0302 35.49)",
    "coral.2400": "oklch(97.05% 0.0146 33.07)",
    "coral.2500": "oklch(100% 0 118.64)",
    "coral.base": "1500",
    "coral.light": "1800",
    "coral.midnight": "1200",
    "crimson.100": "oklch(0% 0 0)",
    "crimson.200": "oklch(16.04% 0.052 22.18)",
    "crimson.300": "oklch(22.01% 0.0887 22.07)",
    "crimson.400": "oklch(27.1% 0.1078 22.49)",
    "crimson.500": "oklch(32% 0.1289 22.07)",
    "crimson.600": "oklch(37.02% 0.1492 22.16)",
    "crimson.700": "oklch(41.47% 0.1671 22.02)",
    "crimson.800": "oklch(46.6% 0.1878 22.26)",
    "crimson.900": "oklch(49.93% 0.1858 22.03)",
    "crimson.1000": "oklch(53.55% 0.1863 22.47)",
    "crimson.1100": "oklch(56.94% 0.1862 22.35)",
    "crimson.1200": "oklch(60.59% 0.1862 22.16)",
    "crimson.1300": "oklch(64% 0.1856 22.19)",
    "crimson.1400": "oklch(66.95% 0.1793 22.48)",
    "crimson.1500": "oklch(70.03% 0.1654 22.28)",
    "crimson.1600": "oklch(73.1% 0.1522 22.46)",
    "crimson.1700": "oklch(76.05% 0.1364 22.39)",
    "crimson.1800": "oklch(78.96% 0.1216 22)",
    "crimson.1900": "oklch(81.98% 0.101 22.46)",
    "crimson.2000": "oklch(84.98% 0.0817 21.69)",
    "crimson.2100": "oklch(88.05% 0.0631 22.05)",
    "crimson.2200": "oklch(91% 0.0463 22.96)",
    "crimson.2300": "oklch(94.03% 0.0299 22.78)",
    "crimson.2400": "oklch(97.11% 0.0141 22.76)",
    "crimson.2500": "oklch(100% 0 118.64)",
    "crimson.base": "800",
    "crimson.light": "1100",
    "crimson.midnight": "700",
    "emerald.100": "oklch(0% 0 0)",
    "emerald.200": "oklch(16.01% 0.0195 170.26)",
    "emerald.300": "oklch(22.13% 0.0341 171.93)",
    "emerald.400": "oklch(27.05% 0.048 172.46)",
    "emerald.500": "oklch(32.06% 0.0624 171.57)",
    "emerald.600": "oklch(37.11% 0.072 171.24)",
    "emerald.700": "oklch(41.38% 0.0793 172.77)",
    "emerald.800": "oklch(46.06% 0.0897 171.6)",
    "emerald.900": "oklch(50.09% 0.0972 171.94)",
    "emerald.1000": "oklch(53.46% 0.1032 171.85)",
    "emerald.1100": "oklch(57.04% 0.1102 172.03)",
    "emerald.1200": "oklch(60.56% 0.1171 172.18)",
    "emerald.1300": "oklch(64.08% 0.123 172.17)",
    "emerald.1400": "oklch(66.6% 0.129 172.08)",
    "emerald.1500": "oklch(69.89% 0.1317 172.21)",
    "emerald.1600": "oklch(72.96% 0.1322 171.98)",
    "emerald.1700": "oklch(75.88% 0.1295 172.48)",
    "emerald.1800": "oklch(79.11% 0.1263 172.27)",
    "emerald.1900": "oklch(81.92% 0.1196 172.02)",
    "emerald.2000": "oklch(85.06% 0.1122 172.34)",
    "emerald.2100": "oklch(87.9% 0.0999 172.33)",
    "emerald.2200": "oklch(90.95% 0.0843 172.28)",
    "emerald.2300": "oklch(94.02% 0.0646 171.71)",
    "emerald.2400": "oklch(97.01% 0.0376 171.58)",
    "emerald.2500": "oklch(100% 0 118.64)",
    "emerald.base": "1400",
    "emerald.light": "1600",
    "emerald.midnight": "1300",
    "gold.100": "oklch(0% 0 0)",
    "gold.200": "oklch(15.87% 0.0156 74.03)",
    "gold.300": "oklch(22.16% 0.0302 76.28)",
    "gold.400": "oklch(26.88% 0.0415 74.85)",
    "gold.500": "oklch(32.04% 0.0521 76.3)",
    "gold.600": "oklch(36.88% 0.0634 74.65)",
    "gold.700": "oklch(41.55% 0.0761 74.64)",
    "gold.800": "oklch(45.99% 0.0862 74.66)",
    "gold.900": "oklch(49.99% 0.0962 74.73)",
    "gold.1000": "oklch(53.46% 0.1041 74.84)",
    "gold.1100": "oklch(56.88% 0.1117 74.92)",
    "gold.1200": "oklch(60.46% 0.1176 75.19)",
    "gold.1300": "oklch(64.12% 0.1244 75.06)",
    "gold.1400": "oklch(66.97% 0.1297 75.08)",
    "gold.1500": "oklch(70.02% 0.1322 74.91)",
    "gold.1600": "oklch(72.94% 0.1339 75.12)",
    "gold.1700": "oklch(75.81% 0.1407 75.03)",
    "gold.1800": "oklch(78.97% 0.1319 74.53)",
    "gold.1900": "oklch(82.04% 0.1282 75.64)",
    "gold.2000": "oklch(84.96% 0.1214 75.09)",
    "gold.2100": "oklch(87.96% 0.1008 74.55)",
    "gold.2200": "oklch(91.03% 0.0738 74.61)",
    "gold.2300": "oklch(93.95% 0.0484 74.2)",
    "gold.2400": "oklch(96.95% 0.0237 73.62)",
    "gold.2500": "oklch(100% 0 118.64)",
    "gold.base": "1700",
    "gold.light": "1800",
    "gold.midnight": "1600",
    "grape.100": "oklch(0% 0 0)",
    "grape.200": "oklch(16% 0.074 325.04)",
    "grape.300": "oklch(21.94% 0.102 325.42)",
    "grape.400": "oklch(26.91% 0.125 325.57)",
    "grape.500": "oklch(31.98% 0.149 325.5)",
    "grape.600": "oklch(36.97% 0.172 325.54)",
    "grape.700": "oklch(40.83% 0.1901 325.87)",
    "grape.800": "oklch(45% 0.19 325.75)",
    "grape.900": "oklch(49.59% 0.19 326.02)",
    "grape.1000": "oklch(53.62% 0.19 325.94)",
    "grape.1100": "oklch(56.92% 0.19 325.83)",
    "grape.1200": "oklch(60.49% 0.19 325.78)",
    "grape.1300": "oklch(63.99% 0.19 326.08)",
    "grape.1400": "oklch(67.02% 0.19 325.98)",
    "grape.1500": "oklch(70.02% 0.19 325.82)",
    "grape.1600": "oklch(73.01% 0.19 326.03)",
    "grape.1700": "oklch(75.91% 0.182 325.86)",
    "grape.1800": "oklch(78.94% 0.176 326.06)",
    "grape.1900": "oklch(81.92% 0.16 325.82)",
    "grape.2000": "oklch(84.95% 0.139 325.56)",
    "grape.2100": "oklch(87.98% 0.11 325.82)",
    "grape.2200": "oklch(90.89% 0.081 325.49)",
    "grape.2300": "oklch(93.95% 0.054 326)",
    "grape.2400": "oklch(96.94% 0.027 325.78)",
    "grape.2500": "oklch(100% 0 137.33)",
    "grape.base": "700",
    "grape.light": "1000",
    "grape.midnight": "600",
    "green.100": "oklch(0% 0 0)",
    "green.200": "oklch(16.07% 0.0398 151.11)",
    "green.300": "oklch(22.08% 0.0571 152.8)",
    "green.400": "oklch(27.14% 0.0694 152.56)",
    "green.500": "oklch(31.92% 0.0818 152.75)",
    "green.600": "oklch(36.87% 0.0941 153.1)",
    "green.700": "oklch(41.62% 0.1072 152.96)",
    "green.800": "oklch(45.99% 0.118 152.86)",
    "green.900": "oklch(49.9% 0.1289 152.86)",
    "green.1000": "oklch(53.47% 0.1379 152.94)",
    "green.1100": "oklch(56.99% 0.1467 153)",
    "green.1200": "oklch(60.47% 0.155 152.94)",
    "green.1300": "oklch(64.14% 0.1653 152.96)",
    "green.1400": "oklch(67.09% 0.1621 152.98)",
    "green.1500": "oklch(69.97% 0.1603 152.83)",
    "green.1600": "oklch(72.88% 0.1574 152.95)",
    "green.1700": "oklch(76.02% 0.1558 152.86)",
    "green.1800": "oklch(79.14% 0.1542 152.78)",
    "green.1900": "oklch(82.06% 0.1504 152.58)",
    "green.2000": "oklch(84.98% 0.1398 152.67)",
    "green.2100": "oklch(88.06% 0.1265 152.48)",
    "green.2200": "oklch(91.08% 0.1086 152.7)",
    "green.2300": "oklch(94.08% 0.0818 152.13)",
    "green.2400": "oklch(97.13% 0.0452 152.19)",
    "green.2500": "oklch(100% 0 118.64)",
    "green.base": "1300",
    "green.light": "1600",
    "green.midnight": "1200",
    "indigo.100": "oklch(0% 0 0)",
    "indigo.200": "oklch(15.97% 0.096 280.85)",
    "indigo.300": "oklch(21.9% 0.1318 280.75)",
    "indigo.400": "oklch(26.95% 0.1621 280.77)",
    "indigo.500": "oklch(31.99% 0.192 281.12)",
    "indigo.600": "oklch(36.75% 0.2209 280.93)",
    "indigo.700": "oklch(41% 0.22 281.11)",
    "indigo.800": "oklch(45.54% 0.2208 281.08)",
    "indigo.900": "oklch(49.45% 0.2196 281)",
    "indigo.1000": "oklch(53.53% 0.2135 280.99)",
    "indigo.1100": "oklch(57% 0.2078 280.99)",
    "indigo.1200": "oklch(60.54% 0.1977 280.68)",
    "indigo.1300": "oklch(63.96% 0.1856 281.18)",
    "indigo.1400": "oklch(67.04% 0.1736 281.02)",
    "indigo.1500": "oklch(70.08% 0.1601 280.65)",
    "indigo.1600": "oklch(72.89% 0.1436 280.9)",
    "indigo.1700": "oklch(75.98% 0.1257 280.97)",
    "indigo.1800": "oklch(79.12% 0.1078 280.72)",
    "indigo.1900": "oklch(82.07% 0.0915 280.75)",
    "indigo.2000": "oklch(85.04% 0.0753 280.53)",
    "indigo.2100": "oklch(88.08% 0.0594 280.93)",
    "indigo.2200": "oklch(91.05% 0.0438 279.85)",
    "indigo.2300": "oklch(93.91% 0.0297 281.67)",
    "indigo.2400": "oklch(96.96% 0.0147 281.96)",
    "indigo.2500": "oklch(100% 0 118.64)",
    "indigo.base": "600",
    "indigo.light": "900",
    "indigo.midnight": "500",
    "informative.100": "oklch(0% 0 0)",
    "informative.200": "oklch(16% 0.041 249.22)",
    "informative.300": "oklch(22.02% 0.06 249.22)",
    "informative.400": "oklch(26.97% 0.074 249.22)",
    "informative.500": "oklch(31.97% 0.088 249.22)",
    "informative.600": "oklch(37.01% 0.103 249.22)",
    "informative.700": "oklch(41.46% 0.114 249.22)",
    "informative.800": "oklch(46% 0.127 249.22)",
    "informative.900": "oklch(49.97% 0.138 249.22)",
    "informative.1000": "oklch(53.5% 0.147 249.22)",
    "informative.1100": "oklch(57% 0.157 249.22)",
    "informative.1200": "oklch(60.49% 0.167 249.22)",
    "informative.1300": "oklch(64.02% 0.177 249.22)",
    "informative.1400": "oklch(66.98% 0.1827 249.22)",
    "informative.1500": "oklch(70.02% 0.164 249.22)",
    "informative.1600": "oklch(72.98% 0.146 249.22)",
    "informative.1700": "oklch(75.99% 0.128 249.22)",
    "informative.1800": "oklch(79.01% 0.108 249.22)",
    "informative.1900": "oklch(82.01% 0.089 249.22)",
    "informative.2000": "oklch(84.98% 0.072 249.22)",
    "informative.2100": "oklch(88.01% 0.055 249.22)",
    "informative.2200": "oklch(91.01% 0.038 249.22)",
    "informative.2300": "oklch(93.98% 0.024 249.22)",
    "informative.2400": "oklch(97.01% 0.01 249.22)",
    "informative.2500": "oklch(100% 0 137.33)",
    "informative.base": "1400",
    "informative.light": "1500",
    "informative.midnight": "1300",
    "lotus.100": "oklch(0% 0 0)",
    "lotus.200": "oklch(15.78% 0.063 342.19)",
    "lotus.300": "oklch(22.04% 0.0946 342.79)",
    "lotus.400": "oklch(26.99% 0.1163 341.75)",
    "lotus.500": "oklch(31.92% 0.1361 342.35)",
    "lotus.600": "oklch(37.04% 0.1559 342.12)",
    "lotus.700": "oklch(41.47% 0.178 341.89)",
    "lotus.800": "oklch(46.08% 0.1968 342.57)",
    "lotus.900": "oklch(49.97% 0.2151 342.16)",
    "lotus.1000": "oklch(53.57% 0.2304 342.28)",
    "lotus.1100": "oklch(56.97% 0.2378 342.12)",
    "lotus.1200": "oklch(60.52% 0.2482 342.42)",
    "lotus.1300": "oklch(64.13% 0.2553 342.25)",
    "lotus.1400": "oklch(66.99% 0.2502 342.41)",
    "lotus.1500": "oklch(70% 0.2417 342.17)",
    "lotus.1600": "oklch(72.97% 0.2207 342.29)",
    "lotus.1700": "oklch(76.04% 0.189 342.2)",
    "lotus.1800": "oklch(78.99% 0.1604 342.1)",
    "lotus.1900": "oklch(82.06% 0.1322 342.21)",
    "lotus.2000": "oklch(85.01% 0.1069 342.38)",
    "lotus.2100": "oklch(87.96% 0.0839 341.96)",
    "lotus.2200": "oklch(91.01% 0.0611 341.7)",
    "lotus.2300": "oklch(93.91% 0.0396 342.79)",
    "lotus.2400": "oklch(96.95% 0.0199 340.69)",
    "lotus.2500": "oklch(100% 0 118.64)",
    "lotus.base": "1400",
    "lotus.light": "1500",
    "lotus.midnight": "1300",
    "marigold.100": "oklch(0% 0 0)",
    "marigold.200": "oklch(16.09% 0.0327 64.2)",
    "marigold.300": "oklch(22.08% 0.0481 63.47)",
    "marigold.400": "oklch(26.98% 0.0596 64.23)",
    "marigold.500": "oklch(32.11% 0.069 67.19)",
    "marigold.600": "oklch(37.12% 0.0808 66.69)",
    "marigold.700": "oklch(41.42% 0.092 64.77)",
    "marigold.800": "oklch(45.96% 0.1024 63.13)",
    "marigold.900": "oklch(49.93% 0.112 62.44)",
    "marigold.1000": "oklch(53.49% 0.1215 61.81)",
    "marigold.1100": "oklch(57.04% 0.129 62.1)",
    "marigold.1200": "oklch(60.53% 0.1367 62.54)",
    "marigold.1300": "oklch(63.98% 0.1442 62.84)",
    "marigold.1400": "oklch(66.99% 0.1496 64.33)",
    "marigold.1500": "oklch(70.09% 0.1522 67.27)",
    "marigold.1600": "oklch(72.98% 0.1584 67.44)",
    "marigold.1700": "oklch(75.86% 0.1617 69.58)",
    "marigold.1800": "oklch(79.49% 0.1607 75.3)",
    "marigold.1900": "oklch(81.97% 0.1528 75.07)",
    "marigold.2000": "oklch(85.08% 0.1355 77.48)",
    "marigold.2100": "oklch(88.03% 0.1139 81.16)",
    "marigold.2200": "oklch(91.01% 0.092 84.47)",
    "marigold.2300": "oklch(94% 0.0638 89.57)",
    "marigold.2400": "oklch(97.09% 0.0329 89.85)",
    "marigold.2500": "oklch(100% 0 118.64)",
    "marigold.base": "1800",
    "marigold.light": "2100",
    "marigold.midnight": "1500",
    "mint.100": "oklch(0% 0 0)",
    "mint.200": "oklch(16.09% 0.0275 194.77)",
    "mint.300": "oklch(22.05% 0.0376 194.77)",
    "mint.400": "oklch(26.91% 0.0459 194.76)",
    "mint.500": "oklch(31.93% 0.054 194.79)",
    "mint.600": "oklch(37.04% 0.0632 194.76)",
    "mint.700": "oklch(41.41% 0.0697 194.79)",
    "mint.800": "oklch(45.91% 0.0778 194.78)",
    "mint.900": "oklch(50.01% 0.0849 194.78)",
    "mint.1000": "oklch(53.41% 0.0908 194.78)",
    "mint.1100": "oklch(57.07% 0.0971 194.77)",
    "mint.1200": "oklch(60.36% 0.1027 194.77)",
    "mint.1300": "oklch(63.91% 0.1088 194.77)",
    "mint.1400": "oklch(67.13% 0.1142 194.77)",
    "mint.1500": "oklch(69.87% 0.1159 194.83)",
    "mint.1600": "oklch(71.63% 0.1181 194.84)",
    "mint.1700": "oklch(75.03% 0.1181 194.93)",
    "mint.1800": "oklch(78.42% 0.1178 195.02)",
    "mint.1900": "oklch(81.96% 0.1138 194.46)",
    "mint.2000": "oklch(84.9% 0.1098 194.55)",
    "mint.2100": "oklch(87.98% 0.0979 194.72)",
    "mint.2200": "oklch(90.94% 0.0781 194.86)",
    "mint.2300": "oklch(94.02% 0.0575 194.87)",
    "mint.2400": "oklch(97.1% 0.0331 194.32)",
    "mint.2500": "oklch(100% 0 118.64)",
    "mint.base": "1600",
    "mint.light": "1900",
    "mint.midnight": "1500",
    "navi.100": "oklch(0% 0 0)",
    "navi.200": "oklch(16.09% 0.093 265.66)",
    "navi.300": "oklch(22.02% 0.148 264.76)",
    "navi.400": "oklch(27.08% 0.1859 264.96)",
    "navi.500": "oklch(32.06% 0.1855 265.01)",
    "navi.600": "oklch(37% 0.1869 264.99)",
    "navi.700": "oklch(41.4% 0.1857 265.09)",
    "navi.800": "oklch(46.08% 0.1862 265.01)",
    "navi.900": "oklch(50.05% 0.1835 265.02)",
    "navi.1000": "oklch(53.5% 0.1821 265.14)",
    "navi.1100": "oklch(56.95% 0.1806 265.2)",
    "navi.1200": "oklch(60.57% 0.1763 265.1)",
    "navi.1300": "oklch(64.05% 0.1693 264.72)",
    "navi.1400": "oklch(67.05% 0.1617 265.08)",
    "navi.1500": "oklch(70.03% 0.1545 265.11)",
    "navi.1600": "oklch(73.05% 0.1388 264.63)",
    "navi.1700": "oklch(75.96% 0.1223 265.13)",
    "navi.1800": "oklch(79.14% 0.1049 264.95)",
    "navi.1900": "oklch(82.07% 0.0891 264.8)",
    "navi.2000": "oklch(85.04% 0.0735 264.44)",
    "navi.2100": "oklch(88.07% 0.0579 264.7)",
    "navi.2200": "oklch(91.06% 0.0429 263.69)",
    "navi.2300": "oklch(93.93% 0.0287 266.37)",
    "navi.2400": "oklch(96.92% 0.0144 264.5)",
    "navi.2500": "oklch(100% 0 118.64)",
    "navi.base": "700",
    "navi.light": "1000",
    "navi.midnight": "600",
    "negative.100": "oklch(0% 0 0)",
    "negative.200": "oklch(15.92% 0.0602 24.54)",
    "negative.300": "oklch(21.98% 0.0888 23.18)",
    "negative.400": "oklch(27.07% 0.108 23.71)",
    "negative.500": "oklch(31.96% 0.1291 23.51)",
    "negative.600": "oklch(37.04% 0.1489 23.52)",
    "negative.700": "oklch(41.46% 0.1669 23.53)",
    "negative.800": "oklch(45.94% 0.1856 23.54)",
    "negative.900": "oklch(50.01% 0.2013 23.62)",
    "negative.1000": "oklch(53.5% 0.2162 23.6)",
    "negative.1100": "oklch(57.02% 0.2301 23.5)",
    "negative.1200": "oklch(61.19% 0.2472 23.53)",
    "negative.1300": "oklch(64.05% 0.2453 23.56)",
    "negative.1400": "oklch(67.06% 0.2169 23.57)",
    "negative.1500": "oklch(70.03% 0.1907 23.39)",
    "negative.1600": "oklch(73.07% 0.1656 23.73)",
    "negative.1700": "oklch(76.04% 0.1427 23.55)",
    "negative.1800": "oklch(78.98% 0.1194 23.23)",
    "negative.1900": "oklch(82% 0.0952 24.09)",
    "negative.2000": "oklch(84.93% 0.0748 23.84)",
    "negative.2100": "oklch(88.07% 0.0562 23.7)",
    "negative.2200": "oklch(91.06% 0.0394 23.71)",
    "negative.2300": "oklch(93.9% 0.0243 23.85)",
    "negative.2400": "oklch(97.09% 0.0098 25.08)",
    "negative.2500": "oklch(100% 0 118.64)",
    "negative.base": "1400",
    "negative.light": "1500",
    "negative.midnight": "600",
    "neutral.100": "oklch(0% 0 0)",
    "neutral.200": "oklch(15.93% 0.0065 270.98)",
    "neutral.300": "oklch(22.13% 0.0066 258.36)",
    "neutral.400": "oklch(26.87% 0.0097 268.31)",
    "neutral.500": "oklch(32.05% 0.0115 264.4)",
    "neutral.600": "oklch(37.04% 0.0131 261.74)",
    "neutral.700": "oklch(41.53% 0.0164 262.31)",
    "neutral.800": "oklch(45.96% 0.0174 264.39)",
    "neutral.900": "oklch(49.97% 0.0166 268.34)",
    "neutral.1000": "oklch(53.44% 0.0149 266.61)",
    "neutral.1100": "oklch(56.85% 0.0132 264.46)",
    "neutral.1200": "oklch(60.55% 0.0116 261.78)",
    "neutral.1300": "oklch(63.98% 0.011 267.31)",
    "neutral.1400": "oklch(66.96% 0.0109 267.32)",
    "neutral.1500": "oklch(69.95% 0.009 271.28)",
    "neutral.1600": "oklch(73.07% 0.008 260.73)",
    "neutral.1700": "oklch(76.03% 0.0074 268.53)",
    "neutral.1800": "oklch(78.85% 0.006 264.53)",
    "neutral.1900": "oklch(81.96% 0.0047 258.33)",
    "neutral.2000": "oklch(85.04% 0.0035 247.86)",
    "neutral.2100": "oklch(87.9% 0.003 264.53)",
    "neutral.2200": "oklch(90.92% 0.0017 247.84)",
    "neutral.2300": "oklch(94.04% 0.0013 286.37)",
    "neutral.2400": "oklch(97.04% 0.0013 286.37)",
    "neutral.2500": "oklch(100% 0 118.64)",
    "neutral.base": "200",
    "neutral.light": "300",
    "neutral.midnight": "100",
    "olive.100": "oklch(0% 0 0)",
    "olive.200": "oklch(16% 0.0441 146.75)",
    "olive.300": "oklch(21.97% 0.0642 147.64)",
    "olive.400": "oklch(27% 0.078 147.45)",
    "olive.500": "oklch(32.05% 0.0938 147.56)",
    "olive.600": "oklch(37% 0.1065 147.96)",
    "olive.700": "oklch(41.41% 0.1198 148.02)",
    "olive.800": "oklch(46.05% 0.1327 148.05)",
    "olive.900": "oklch(49.96% 0.144 148.16)",
    "olive.1000": "oklch(54.7% 0.1559 148.53)",
    "olive.1100": "oklch(57.04% 0.1541 148.59)",
    "olive.1200": "oklch(60.38% 0.152 148.16)",
    "olive.1300": "oklch(63.98% 0.1495 148.22)",
    "olive.1400": "oklch(67.1% 0.1509 147.87)",
    "olive.1500": "oklch(70.03% 0.1482 147.87)",
    "olive.1600": "oklch(72.96% 0.1453 147.8)",
    "olive.1700": "oklch(75.93% 0.1417 147.44)",
    "olive.1800": "oklch(78.94% 0.1358 147.6)",
    "olive.1900": "oklch(82.05% 0.1286 147.2)",
    "olive.2000": "oklch(84.98% 0.1178 147.42)",
    "olive.2100": "oklch(88.06% 0.1045 147.33)",
    "olive.2200": "oklch(91.04% 0.0878 147.2)",
    "olive.2300": "oklch(94.01% 0.0661 147)",
    "olive.2400": "oklch(97.06% 0.0384 147.64)",
    "olive.2500": "oklch(100% 0 118.64)",
    "olive.base": "1000",
    "olive.light": "1200",
    "olive.midnight": "900",
    "orange.100": "oklch(0% 0 0)",
    "orange.200": "oklch(16.15% 0.0379 50.75)",
    "orange.300": "oklch(21.91% 0.0565 51.77)",
    "orange.400": "oklch(26.97% 0.07 51.34)",
    "orange.500": "oklch(32.15% 0.0831 51.61)",
    "orange.600": "oklch(36.96% 0.0965 50.87)",
    "orange.700": "oklch(41.46% 0.1064 51.72)",
    "orange.800": "oklch(46% 0.1191 51.17)",
    "orange.900": "oklch(49.94% 0.1304 50.9)",
    "orange.1000": "oklch(53.51% 0.1393 51.11)",
    "orange.1100": "oklch(57.03% 0.1481 51.29)",
    "orange.1200": "oklch(60.49% 0.1566 51.37)",
    "orange.1300": "oklch(64.05% 0.166 51.27)",
    "orange.1400": "oklch(66.98% 0.1734 51.49)",
    "orange.1500": "oklch(70.15% 0.1824 51.19)",
    "orange.1600": "oklch(72.1% 0.1803 51.26)",
    "orange.1700": "oklch(74.97% 0.163 51.09)",
    "orange.1800": "oklch(78.6% 0.139 51.51)",
    "orange.1900": "oklch(82.06% 0.1132 51.53)",
    "orange.2000": "oklch(85.01% 0.0917 51.03)",
    "orange.2100": "oklch(88.04% 0.0716 51.46)",
    "orange.2200": "oklch(90.97% 0.0521 49.98)",
    "orange.2300": "oklch(93.93% 0.0343 50.21)",
    "orange.2400": "oklch(96.95% 0.0169 50.44)",
    "orange.2500": "oklch(100% 0 118.64)",
    "orange.base": "1600",
    "orange.light": "1900",
    "orange.midnight": "1300",
    "peach.100": "oklch(0% 0 0)",
    "peach.200": "oklch(15.84% 0.0409 51.83)",
    "peach.300": "oklch(22.1% 0.0599 48.33)",
    "peach.400": "oklch(26.97% 0.0741 47.45)",
    "peach.500": "oklch(31.97% 0.0879 47.43)",
    "peach.600": "oklch(36.97% 0.102 47.02)",
    "peach.700": "oklch(41.46% 0.1137 47.14)",
    "peach.800": "oklch(46% 0.126 47.19)",
    "peach.900": "oklch(49.97% 0.1343 47.02)",
    "peach.1000": "oklch(53.56% 0.1421 46.73)",
    "peach.1100": "oklch(56.97% 0.146 46.59)",
    "peach.1200": "oklch(60.49% 0.149 46.13)",
    "peach.1300": "oklch(64.02% 0.149 46.18)",
    "peach.1400": "oklch(67.07% 0.1498 46.69)",
    "peach.1500": "oklch(69.96% 0.15 46.55)",
    "peach.1600": "oklch(73.08% 0.1518 46.22)",
    "peach.1700": "oklch(76.07% 0.146 46.46)",
    "peach.1800": "oklch(78.91% 0.132 47.06)",
    "peach.1900": "oklch(82% 0.109 47.02)",
    "peach.2000": "oklch(85.11% 0.0885 47.65)",
    "peach.2100": "oklch(87.94% 0.0694 46.53)",
    "peach.2200": "oklch(91.02% 0.0507 47.5)",
    "peach.2300": "oklch(93.98% 0.0329 46.4)",
    "peach.2400": "oklch(96.97% 0.0162 46.57)",
    "peach.2500": "oklch(100% 0 118.64)",
    "peach.base": "1600",
    "peach.light": "1900",
    "peach.midnight": "1300",
    "peacock.100": "oklch(0% 0 0)",
    "peacock.200": "oklch(15.91% 0.0134 177.8)",
    "peacock.300": "oklch(22.04% 0.0283 179.48)",
    "peacock.400": "oklch(26.82% 0.0378 181.06)",
    "peacock.500": "oklch(32.05% 0.0485 180.32)",
    "peacock.600": "oklch(37.11% 0.0584 179.81)",
    "peacock.700": "oklch(41.38% 0.066 180.43)",
    "peacock.800": "oklch(45.9% 0.0734 180.97)",
    "peacock.900": "oklch(50% 0.0801 180.13)",
    "peacock.1000": "oklch(53.38% 0.086 180.3)",
    "peacock.1100": "oklch(57.12% 0.0905 180.32)",
    "peacock.1200": "oklch(60.51% 0.0942 180.22)",
    "peacock.1300": "oklch(63.88% 0.0974 180.94)",
    "peacock.1400": "oklch(67.1% 0.1025 180.13)",
    "peacock.1500": "oklch(69.96% 0.1022 180.33)",
    "peacock.1600": "oklch(73.41% 0.1074 180.43)",
    "peacock.1700": "oklch(76.06% 0.1043 180.25)",
    "peacock.1800": "oklch(79.11% 0.1046 180.5)",
    "peacock.1900": "oklch(82% 0.1021 180.38)",
    "peacock.2000": "oklch(85.01% 0.0975 180.76)",
    "peacock.2100": "oklch(87.92% 0.0894 180.62)",
    "peacock.2200": "oklch(90.93% 0.0795 181.06)",
    "peacock.2300": "oklch(94.04% 0.0638 180.27)",
    "peacock.2400": "oklch(97% 0.0418 179.87)",
    "peacock.2500": "oklch(100% 0 118.64)",
    "peacock.base": "1600",
    "peacock.light": "1700",
    "peacock.midnight": "1500",
    "pink.100": "oklch(0% 0 0)",
    "pink.200": "oklch(15.97% 0.0432 349.21)",
    "pink.300": "oklch(22.01% 0.0817 351.21)",
    "pink.400": "oklch(26.93% 0.112 350.76)",
    "pink.500": "oklch(31.95% 0.1329 350.82)",
    "pink.600": "oklch(37.08% 0.1534 350.72)",
    "pink.700": "oklch(41.51% 0.1719 350.94)",
    "pink.800": "oklch(46.05% 0.1909 350.95)",
    "pink.900": "oklch(50.05% 0.2082 350.79)",
    "pink.1000": "oklch(53.43% 0.222 350.72)",
    "pink.1100": "oklch(58.28% 0.2425 350.72)",
    "pink.1200": "oklch(60.46% 0.242 350.51)",
    "pink.1300": "oklch(63.95% 0.2402 350.8)",
    "pink.1400": "oklch(67.02% 0.24 350.61)",
    "pink.1500": "oklch(70.05% 0.227 350.84)",
    "pink.1600": "oklch(72.93% 0.1986 350.82)",
    "pink.1700": "oklch(76.02% 0.17 350.63)",
    "pink.1800": "oklch(79.01% 0.1436 350.88)",
    "pink.1900": "oklch(82.09% 0.1185 350.83)",
    "pink.2000": "oklch(85.01% 0.0965 350.54)",
    "pink.2100": "oklch(88.03% 0.0747 350.54)",
    "pink.2200": "oklch(90.97% 0.0548 350.43)",
    "pink.2300": "oklch(93.98% 0.0353 350.87)",
    "pink.2400": "oklch(97.06% 0.0164 353.63)",
    "pink.2500": "oklch(100% 0 118.64)",
    "pink.base": "1100",
    "pink.light": "1400",
    "pink.midnight": "1000",
    "positive.100": "oklch(0% 0 0)",
    "positive.200": "oklch(16.13% 0.0228 141.37)",
    "positive.300": "oklch(22.07% 0.0464 141.91)",
    "positive.400": "oklch(27.13% 0.0709 142.4)",
    "positive.500": "oklch(31.97% 0.0944 142.49)",
    "positive.600": "oklch(37.03% 0.1162 142.5)",
    "positive.700": "oklch(41.6% 0.1362 142.54)",
    "positive.800": "oklch(46.11% 0.1543 142.49)",
    "positive.900": "oklch(49.92% 0.1698 142.49)",
    "positive.1000": "oklch(53.44% 0.1818 142.49)",
    "positive.1100": "oklch(56.96% 0.1917 142.5)",
    "positive.1200": "oklch(60.49% 0.1999 142.48)",
    "positive.1300": "oklch(64.72% 0.204 142.5)",
    "positive.1400": "oklch(66.97% 0.202 142.48)",
    "positive.1500": "oklch(70.1% 0.2002 142.55)",
    "positive.1600": "oklch(72.86% 0.1917 142.52)",
    "positive.1700": "oklch(75.92% 0.1839 142.44)",
    "positive.1800": "oklch(78.89% 0.17 142.46)",
    "positive.1900": "oklch(81.96% 0.1538 142.67)",
    "positive.2000": "oklch(84.9% 0.1355 142.35)",
    "positive.2100": "oklch(87.95% 0.1146 142.45)",
    "positive.2200": "oklch(90.93% 0.09 142.46)",
    "positive.2300": "oklch(93.87% 0.0618 142.21)",
    "positive.2400": "oklch(96.94% 0.0324 142.49)",
    "positive.2500": "oklch(100% 0 118.64)",
    "positive.base": "1500",
    "positive.light": "1600",
    "positive.midnight": "800",
    "purple.100": "oklch(0% 0 0)",
    "purple.200": "oklch(16.05% 0.0872 296.68)",
    "purple.300": "oklch(21.92% 0.12 295.49)",
    "purple.400": "oklch(27.07% 0.1477 296.11)",
    "purple.500": "oklch(31.97% 0.175 295.54)",
    "purple.600": "oklch(37.04% 0.2024 295.91)",
    "purple.700": "oklch(41.5% 0.2269 295.76)",
    "purple.800": "oklch(46.83% 0.2417 295.88)",
    "purple.900": "oklch(49.93% 0.24 295.79)",
    "purple.1000": "oklch(53.47% 0.239 295.9)",
    "purple.1100": "oklch(57.08% 0.238 295.97)",
    "purple.1200": "oklch(60.55% 0.23 296.01)",
    "purple.1300": "oklch(64.03% 0.217 296.09)",
    "purple.1400": "oklch(66.92% 0.198 295.83)",
    "purple.1500": "oklch(70.08% 0.178 296)",
    "purple.1600": "oklch(72.91% 0.158 295.91)",
    "purple.1700": "oklch(76.06% 0.138 295.74)",
    "purple.1800": "oklch(78.92% 0.1206 295.95)",
    "purple.1900": "oklch(81.99% 0.1014 295.56)",
    "purple.2000": "oklch(84.97% 0.0839 296.03)",
    "purple.2100": "oklch(87.97% 0.0666 296.46)",
    "purple.2200": "oklch(90.97% 0.0496 296.85)",
    "purple.2300": "oklch(93.98% 0.0327 297.21)",
    "purple.2400": "oklch(96.99% 0.0162 297.52)",
    "purple.2500": "oklch(100% 0 118.64)",
    "purple.base": "800",
    "purple.light": "1100",
    "purple.midnight": "700",
    "red.100": "oklch(0% 0 0)",
    "red.200": "oklch(15.93% 0.0641 20.03)",
    "red.300": "oklch(22.02% 0.0886 21.01)",
    "red.400": "oklch(26.88% 0.1098 27.84)",
    "red.500": "oklch(31.93% 0.1294 27.8)",
    "red.600": "oklch(37.07% 0.1515 27.91)",
    "red.700": "oklch(41.53% 0.1691 27.82)",
    "red.800": "oklch(46.06% 0.1872 27.86)",
    "red.900": "oklch(50.01% 0.204 27.98)",
    "red.1000": "oklch(53.57% 0.2182 27.95)",
    "red.1100": "oklch(57.68% 0.2341 27.91)",
    "red.1200": "oklch(60.48% 0.232 27.85)",
    "red.1300": "oklch(64% 0.226 27.87)",
    "red.1400": "oklch(67% 0.215 27.86)",
    "red.1500": "oklch(69.95% 0.191 27.82)",
    "red.1600": "oklch(73.04% 0.1661 27.9)",
    "red.1700": "oklch(76.03% 0.143 28.07)",
    "red.1800": "oklch(79.11% 0.1208 28.12)",
    "red.1900": "oklch(82.01% 0.101 27.66)",
    "red.2000": "oklch(85.03% 0.0815 27.28)",
    "red.2100": "oklch(88.13% 0.0629 28.11)",
    "red.2200": "oklch(90.94% 0.0467 26.21)",
    "red.2300": "oklch(93.97% 0.0303 27.75)",
    "red.2400": "oklch(97.08% 0.0143 28.01)",
    "red.2500": "oklch(100% 0 118.64)",
    "red.base": "1100",
    "red.light": "1400",
    "red.midnight": "800",
    "reliance.100": "oklch(0% 0 0)",
    "reliance.200": "oklch(16.06% 0.0879 263.69)",
    "reliance.300": "oklch(21.99% 0.1407 264.22)",
    "reliance.400": "oklch(26.97% 0.172 264.53)",
    "reliance.500": "oklch(31.94% 0.1904 264.3)",
    "reliance.600": "oklch(36.55% 0.208 264.33)",
    "reliance.700": "oklch(40.1% 0.218 264.38)",
    "reliance.800": "oklch(43.92% 0.2209 264.39)",
    "reliance.900": "oklch(48.1% 0.219 264.36)",
    "reliance.1000": "oklch(52.45% 0.217 264.53)",
    "reliance.1100": "oklch(56.07% 0.214 264.3)",
    "reliance.1200": "oklch(60.44% 0.205 264.4)",
    "reliance.1300": "oklch(63.88% 0.192 264.5)",
    "reliance.1400": "oklch(66.96% 0.1725 264.6)",
    "reliance.1500": "oklch(69.97% 0.1565 264.58)",
    "reliance.1600": "oklch(72.99% 0.1392 264.26)",
    "reliance.1700": "oklch(75.91% 0.1227 264.7)",
    "reliance.1800": "oklch(79.08% 0.1052 264.44)",
    "reliance.1900": "oklch(82.01% 0.0895 264.19)",
    "reliance.2000": "oklch(85.04% 0.0735 264.44)",
    "reliance.2100": "oklch(88.07% 0.0579 264.7)",
    "reliance.2200": "oklch(91.06% 0.0429 263.69)",
    "reliance.2300": "oklch(93.93% 0.0287 266.37)",
    "reliance.2400": "oklch(96.92% 0.0144 264.5)",
    "reliance.2500": "oklch(100% 0 118.64)",
    "reliance.base": "700",
    "reliance.light": "1100",
    "reliance.midnight": "600",
    "sand.100": "oklch(0% 0 0)",
    "sand.200": "oklch(16.01% 0.0209 58.51)",
    "sand.300": "oklch(22% 0.0348 55.04)",
    "sand.400": "oklch(26.91% 0.046 57.17)",
    "sand.500": "oklch(31.88% 0.0538 57.36)",
    "sand.600": "oklch(36.92% 0.0643 56.67)",
    "sand.700": "oklch(41.52% 0.0722 57.59)",
    "sand.800": "oklch(46.03% 0.0786 57.03)",
    "sand.900": "oklch(49.96% 0.0839 57.07)",
    "sand.1000": "oklch(53.5% 0.0885 56.48)",
    "sand.1100": "oklch(56.94% 0.0893 56.95)",
    "sand.1200": "oklch(60.48% 0.0905 56.26)",
    "sand.1300": "oklch(64.05% 0.0902 57.16)",
    "sand.1400": "oklch(67.07% 0.0904 56.87)",
    "sand.1500": "oklch(69.95% 0.0896 57.04)",
    "sand.1600": "oklch(72.92% 0.0898 56.69)",
    "sand.1700": "oklch(75.61% 0.0925 57.06)",
    "sand.1800": "oklch(78.95% 0.09 57.09)",
    "sand.1900": "oklch(82% 0.0832 57.29)",
    "sand.2000": "oklch(84.93% 0.0784 56.35)",
    "sand.2100": "oklch(88.01% 0.0682 57.35)",
    "sand.2200": "oklch(91.05% 0.0557 57.35)",
    "sand.2300": "oklch(94.05% 0.0365 58.05)",
    "sand.2400": "oklch(96.92% 0.0177 53.99)",
    "sand.2500": "oklch(100% 0 118.64)",
    "sand.base": "1700",
    "sand.light": "1800",
    "sand.midnight": "1600",
    "scarlet.100": "oklch(0% 0 0)",
    "scarlet.200": "oklch(15.96% 0.0527 28.72)",
    "scarlet.300": "oklch(21.88% 0.0898 29.25)",
    "scarlet.400": "oklch(26.95% 0.1093 29.62)",
    "scarlet.500": "oklch(32.04% 0.1315 29.24)",
    "scarlet.600": "oklch(37.09% 0.1514 29.11)",
    "scarlet.700": "oklch(41.44% 0.17 29.24)",
    "scarlet.800": "oklch(46.01% 0.1878 29.25)",
    "scarlet.900": "oklch(49.94% 0.2049 29.23)",
    "scarlet.1000": "oklch(52.1% 0.2138 29.24)",
    "scarlet.1100": "oklch(55.05% 0.2119 29.23)",
    "scarlet.1200": "oklch(59.41% 0.2097 29.29)",
    "scarlet.1300": "oklch(63.11% 0.206 29.26)",
    "scarlet.1400": "oklch(66.52% 0.1976 29.4)",
    "scarlet.1500": "oklch(70.01% 0.1865 29.12)",
    "scarlet.1600": "oklch(72.99% 0.1667 29.1)",
    "scarlet.1700": "oklch(75.99% 0.1435 29.05)",
    "scarlet.1800": "oklch(79.07% 0.1213 29.31)",
    "scarlet.1900": "oklch(81.97% 0.1015 29.11)",
    "scarlet.2000": "oklch(84.89% 0.0809 29.21)",
    "scarlet.2100": "oklch(88.11% 0.0631 29.28)",
    "scarlet.2200": "oklch(91.1% 0.046 29.64)",
    "scarlet.2300": "oklch(93.97% 0.0303 27.75)",
    "scarlet.2400": "oklch(97.05% 0.0146 33.07)",
    "scarlet.2500": "oklch(100% 0 118.64)",
    "scarlet.base": "1000",
    "scarlet.light": "1300",
    "scarlet.midnight": "900",
    "sky.100": "oklch(0% 0 0)",
    "sky.200": "oklch(16% 0.035 237.96)",
    "sky.300": "oklch(22.02% 0.048 237.96)",
    "sky.400": "oklch(26.97% 0.06 237.96)",
    "sky.500": "oklch(31.97% 0.07 237.96)",
    "sky.600": "oklch(37.01% 0.082 237.96)",
    "sky.700": "oklch(41.46% 0.092 237.96)",
    "sky.800": "oklch(46% 0.102 237.96)",
    "sky.900": "oklch(49.97% 0.11 237.96)",
    "sky.1000": "oklch(54.36% 0.1205 237.96)",
    "sky.1100": "oklch(57% 0.12 237.96)",
    "sky.1200": "oklch(60.49% 0.12 237.96)",
    "sky.1300": "oklch(64.02% 0.12 237.96)",
    "sky.1400": "oklch(67.01% 0.12 237.96)",
    "sky.1500": "oklch(70.02% 0.118 237.96)",
    "sky.1600": "oklch(72.98% 0.114 237.96)",
    "sky.1700": "oklch(75.99% 0.108 237.96)",
    "sky.1800": "oklch(79% 0.102 237.96)",
    "sky.1900": "oklch(82.01% 0.094 237.96)",
    "sky.2000": "oklch(84.98% 0.084 237.96)",
    "sky.2100": "oklch(88.01% 0.066 237.96)",
    "sky.2200": "oklch(91.01% 0.049 237.96)",
    "sky.2300": "oklch(93.98% 0.032 237.96)",
    "sky.2400": "oklch(97.01% 0.016 237.96)",
    "sky.2500": "oklch(100% 0 137.33)",
    "sky.base": "1000",
    "sky.light": "1300",
    "sky.midnight": "900",
    "tulip.100": "oklch(0% 0 0)",
    "tulip.200": "oklch(16.01% 0.056 20.35)",
    "tulip.300": "oklch(22.02% 0.0819 20.54)",
    "tulip.400": "oklch(27.01% 0.1026 19.78)",
    "tulip.500": "oklch(31.92% 0.1208 19.84)",
    "tulip.600": "oklch(37% 0.1408 20.01)",
    "tulip.700": "oklch(41.4% 0.1565 19.99)",
    "tulip.800": "oklch(45.98% 0.1747 19.95)",
    "tulip.900": "oklch(50.06% 0.1906 20.09)",
    "tulip.1000": "oklch(53.54% 0.2032 20.03)",
    "tulip.1100": "oklch(57.56% 0.2124 19.88)",
    "tulip.1200": "oklch(60.96% 0.219 20.13)",
    "tulip.1300": "oklch(65.25% 0.2219 20)",
    "tulip.1400": "oklch(67.66% 0.2122 20.02)",
    "tulip.1500": "oklch(70.06% 0.1911 20.18)",
    "tulip.1600": "oklch(73.07% 0.1661 20.29)",
    "tulip.1700": "oklch(76.02% 0.1432 19.95)",
    "tulip.1800": "oklch(78.98% 0.1177 20.03)",
    "tulip.1900": "oklch(82.03% 0.097 20.15)",
    "tulip.2000": "oklch(84.92% 0.0768 19.79)",
    "tulip.2100": "oklch(87.91% 0.0606 19.63)",
    "tulip.2200": "oklch(91.06% 0.0427 21.54)",
    "tulip.2300": "oklch(93.97% 0.0287 20.33)",
    "tulip.2400": "oklch(97.03% 0.013 23.19)",
    "tulip.2500": "oklch(100% 0 118.64)",
    "tulip.base": "1300",
    "tulip.light": "1600",
    "tulip.midnight": "1200",
    "violet.100": "oklch(0% 0 0)",
    "violet.200": "oklch(16.08% 0.0544 327.75)",
    "violet.300": "oklch(22.06% 0.0866 326.98)",
    "violet.400": "oklch(26.97% 0.1113 326.57)",
    "violet.500": "oklch(31.97% 0.1399 326.45)",
    "violet.600": "oklch(36.95% 0.1675 326.87)",
    "violet.700": "oklch(41.41% 0.1919 326.73)",
    "violet.800": "oklch(45.93% 0.2075 326.84)",
    "violet.900": "oklch(49.97% 0.2155 326.83)",
    "violet.1000": "oklch(53.46% 0.2257 326.87)",
    "violet.1100": "oklch(57% 0.2345 326.9)",
    "violet.1200": "oklch(59.45% 0.2336 326.81)",
    "violet.1300": "oklch(64.01% 0.236 326.73)",
    "violet.1400": "oklch(66.99% 0.2317 326.62)",
    "violet.1500": "oklch(70.07% 0.2234 327.05)",
    "violet.1600": "oklch(73.02% 0.2139 326.59)",
    "violet.1700": "oklch(76.04% 0.1994 327)",
    "violet.1800": "oklch(79.08% 0.1845 326.81)",
    "violet.1900": "oklch(82.03% 0.1634 326.94)",
    "violet.2000": "oklch(84.95% 0.1444 326.76)",
    "violet.2100": "oklch(88.05% 0.1107 326.97)",
    "violet.2200": "oklch(91.01% 0.0812 326.88)",
    "violet.2300": "oklch(93.91% 0.0535 326.96)",
    "violet.2400": "oklch(97.1% 0.0244 327.79)",
    "violet.2500": "oklch(100% 0 118.64)",
    "violet.base": "1200",
    "violet.light": "1500",
    "violet.midnight": "1100",
    "warning.100": "oklch(0% 0 0)",
    "warning.200": "oklch(16% 0.0448 46.21)",
    "warning.300": "oklch(22.1% 0.0599 48.33)",
    "warning.400": "oklch(26.97% 0.0741 47.45)",
    "warning.500": "oklch(31.97% 0.0879 47.43)",
    "warning.600": "oklch(36.97% 0.1022 47.02)",
    "warning.700": "oklch(41.46% 0.1137 47.14)",
    "warning.800": "oklch(46% 0.1263 47.19)",
    "warning.900": "oklch(49.95% 0.1373 47.2)",
    "warning.1000": "oklch(53.52% 0.1459 47.56)",
    "warning.1100": "oklch(57.03% 0.1564 47.39)",
    "warning.1200": "oklch(60.5% 0.1667 47.14)",
    "warning.1300": "oklch(64.05% 0.1761 47.4)",
    "warning.1400": "oklch(68.31% 0.1835 47.45)",
    "warning.1500": "oklch(69.95% 0.1814 47.35)",
    "warning.1600": "oklch(72.88% 0.171 47.42)",
    "warning.1700": "oklch(76.01% 0.1547 47.33)",
    "warning.1800": "oklch(79.02% 0.1315 47.25)",
    "warning.1900": "oklch(82% 0.1095 47.02)",
    "warning.2000": "oklch(84.93% 0.0891 46.58)",
    "warning.2100": "oklch(87.94% 0.0694 46.53)",
    "warning.2200": "oklch(91.02% 0.0507 47.5)",
    "warning.2300": "oklch(93.98% 0.0329 46.4)",
    "warning.2400": "oklch(96.97% 0.0162 46.57)",
    "warning.2500": "oklch(100% 0 118.64)",
    "warning.base": "1600",
    "warning.light": "1700",
    "warning.midnight": "900",
    "yellow.100": "oklch(0% 0 0)",
    "yellow.200": "oklch(16% 0.028 93.94)",
    "yellow.300": "oklch(22.02% 0.045 93.94)",
    "yellow.400": "oklch(26.97% 0.055 93.94)",
    "yellow.500": "oklch(31.97% 0.065 93.94)",
    "yellow.600": "oklch(37.01% 0.075 93.94)",
    "yellow.700": "oklch(41.46% 0.085 93.94)",
    "yellow.800": "oklch(46% 0.094 93.94)",
    "yellow.900": "oklch(49.97% 0.102 93.94)",
    "yellow.1000": "oklch(53.5% 0.109 93.94)",
    "yellow.1100": "oklch(57% 0.116 93.94)",
    "yellow.1200": "oklch(60.49% 0.123 93.94)",
    "yellow.1300": "oklch(64.02% 0.131 93.94)",
    "yellow.1400": "oklch(67.01% 0.137 93.94)",
    "yellow.1500": "oklch(70.02% 0.143 93.94)",
    "yellow.1600": "oklch(72.98% 0.149 93.94)",
    "yellow.1700": "oklch(75.99% 0.155 93.94)",
    "yellow.1800": "oklch(79.5% 0.158 93.94)",
    "yellow.1900": "oklch(82.5% 0.159 93.94)",
    "yellow.2000": "oklch(86% 0.16 93.94)",
    "yellow.2100": "oklch(89.32% 0.1612 93.94)",
    "yellow.2200": "oklch(91.3% 0.131 93.94)",
    "yellow.2300": "oklch(93.98% 0.091 93.94)",
    "yellow.2400": "oklch(97.01% 0.045 93.94)",
    "yellow.2500": "oklch(100% 0 137.33)",
    "yellow.base": "1300",
    "yellow.light": "1400",
    "yellow.midnight": "1200",
    "saffron.100": "oklch(0% 0 0)",
    "saffron.200": "oklch(16.04% 0.043 41.91)",
    "saffron.300": "oklch(21.97% 0.065 42.74)",
    "saffron.400": "oklch(26.89% 0.081 41.77)",
    "saffron.500": "oklch(31.93% 0.097 41.62)",
    "saffron.600": "oklch(37.10% 0.112 41.55)",
    "saffron.700": "oklch(41.46% 0.126 41.45)",
    "saffron.800": "oklch(46.03% 0.140 41.40)",
    "saffron.900": "oklch(49.98% 0.151 41.60)",
    "saffron.1000": "oklch(53.43% 0.162 41.42)",
    "saffron.1100": "oklch(57.11% 0.173 41.48)",
    "saffron.1200": "oklch(60.45% 0.184 41.41)",
    "saffron.1300": "oklch(64.03% 0.195 41.32)",
    "saffron.1400": "oklch(67.05% 0.198 41.63)",
    "saffron.1500": "oklch(69.80% 0.200 41.49)",
    "saffron.1600": "oklch(72.01% 0.181 41.55)",
    "saffron.1700": "oklch(75.00% 0.157 41.31)",
    "saffron.1800": "oklch(78.47% 0.130 40.94)",
    "saffron.1900": "oklch(82.00% 0.105 40.89)",
    "saffron.2000": "oklch(84.99% 0.080 41.78)",
    "saffron.2100": "oklch(87.93% 0.060 41.56)",
    "saffron.2200": "oklch(90.96% 0.040 41.03)",
    "saffron.2300": "oklch(93.97% 0.025 42.10)",
    "saffron.2400": "oklch(97.03% 0.011 39.44)",
    "saffron.2500": "oklch(100.00% 0.000 0)",
    "saffron.base": "1500",
    "saffron.light": "1600",
    "saffron.midnight": "1400"
};
const $5bc9639ae0326803$var$config$1 = {
    brand: $5bc9639ae0326803$var$brand,
    foundation: $5bc9639ae0326803$var$foundation,
    colors: $5bc9639ae0326803$var$colors
};
const $5bc9639ae0326803$var$surfaceAliases = {
    "subtle-": "subtleDecreased",
    "moderate-": "moderateDecreased",
    "minimal-": "minimalDecreased"
};
function $5bc9639ae0326803$export$1630fb55fe6ce943(appearance, scale = 25, surface, boldOption = "delta", mode = "light") {
    let color = appearance;
    const surfaceScale = $5bc9639ae0326803$var$config$1.foundation.step.surface[$5bc9639ae0326803$var$surfaceAliases[surface] || surface];
    const surfaceConrast = $5bc9639ae0326803$var$config$1.foundation.contrast.surface[surface];
    const isMidnight = appearance?.includes("midnight");
    color = $5bc9639ae0326803$var$replaceMidnight(color);
    const contrast1 = $5bc9639ae0326803$var$getContrast(color, scale, 2);
    const contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, 25);
    const isForward = contrast2 > contrast1;
    switch(surface){
        case "default":
            scale = mode === "dark" ? 2 : 25;
            break;
        case "ghost":
            return scale;
        case "minimal":
            if (isForward) scale += surfaceScale;
            else scale -= surfaceScale;
            break;
        case "minimal-":
            if (scale <= 1) scale = scale - surfaceScale;
            else if (scale >= 25) scale = scale + surfaceScale;
            else if (isForward) scale += surfaceScale;
            else scale -= surfaceScale;
            break;
        case "subtle":
            scale = isForward ? scale + surfaceScale : scale - surfaceScale;
            break;
        case "subtle-":
            if (scale <= 2) scale = scale - surfaceScale;
            else if (scale >= 24) scale = scale + surfaceScale;
            else isForward ? scale += surfaceScale : scale -= surfaceScale;
            break;
        case "moderate":
            isForward ? scale += surfaceScale : scale -= surfaceScale;
            break;
        case "moderate-":
            if (scale <= 3) scale = scale - surfaceScale;
            else if (scale >= 23) scale = scale + surfaceScale;
            else isForward ? scale += surfaceScale : scale -= surfaceScale;
            break;
        case "bold":
            {
                const baseScale = $5bc9639ae0326803$var$getAdjustedBaseScale(scale, color, isMidnight);
                let contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                if (contrast >= surfaceConrast) scale = baseScale;
                else {
                    if (boldOption === "contrast") {
                        if (scale >= 3 && scale <= 24) while(contrast < surfaceConrast){
                            if (isForward && baseScale === 25 || !isForward && baseScale === 1) break;
                            scale += isForward ? 1 : -1;
                            contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                        }
                        else scale = baseScale;
                    } else if (boldOption === "white") {
                        if (scale >= 3 && scale <= 6) scale += 7;
                        else if (scale >= 7 && scale <= 18) scale = 25;
                        else if (scale >= 19 && scale <= 24) scale -= 7;
                        else scale = baseScale;
                    } else {
                        if (scale >= 3 && scale <= 10) scale += 7;
                        else if (scale >= 11 && scale <= 24) scale -= 7;
                        else scale = baseScale;
                    }
                }
            }
            break;
        case "boldA11y":
            {
                let baseScale = $5bc9639ae0326803$var$getAdjustedBaseScale(scale, color, isMidnight);
                let contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                if (!(contrast >= surfaceConrast)) while(contrast < surfaceConrast){
                    if (isForward && baseScale === 25 || !isForward && baseScale === 1) break;
                    baseScale += isForward ? 1 : -1;
                    contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                }
                scale = baseScale;
            }
            break;
        case "heavy":
            {
                const newScale = isForward ? 18 : 6;
                const contrast = $5bc9639ae0326803$var$getContrast(color, scale, newScale);
                if (contrast >= surfaceConrast) scale = newScale;
                else scale = $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, newScale, contrast, surfaceConrast, isForward);
            }
            break;
        case "contrasting":
            scale = isForward ? 25 : 2;
            break;
        case "black":
            scale = 1;
            break;
        case "elevatedHigh":
            {
                const baseScale = $5bc9639ae0326803$var$getAdjustedBaseScale(scale, color, isMidnight);
                const contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                if (contrast >= 45) scale = baseScale;
                else {
                    if (scale >= 3 && scale <= 24) scale += 7;
                    else if (scale >= 11 && scale <= 24) scale -= 7;
                    else if (scale >= 11 && scale <= 24) scale -= 7;
                    else scale = baseScale;
                }
            }
            break;
        case "elevatedMedium":
            if (scale >= 1 && scale <= 12) {
                const newScale = scale + 4;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else if (scale >= 13 && scale <= 24) {
                const newScale = scale + 3;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else {
                const newScale = scale + 1;
                scale = newScale > 25 ? scale - 2 : newScale;
            }
            break;
        case "elevatedLow":
            if (scale >= 1 && scale <= 12) {
                const newScale = scale + 2;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else if (scale >= 13 && scale <= 24) {
                const newScale = scale + 1;
                scale = newScale > 25 ? scale - 2 : newScale;
            } else {
                const newScale = scale + 1;
                scale = newScale > 25 ? scale - 2 : newScale;
            }
            break;
        default:
            scale += 0;
    }
    return $5bc9639ae0326803$var$clamp(scale, 1, 25);
}
function $5bc9639ae0326803$var$getSurfaceColor(appearance, scale, parentScale = 25, surface = "ghost", mode = "light", state = "idle") {
    if (surface === "ghost") return {
        scales: {
            [scale || 0]: 0
        },
        surfaceType: "surface"
    };
    const stateStep = $5bc9639ae0326803$var$config$1.foundation.step.event[state];
    const color = $5bc9639ae0326803$var$replaceMidnight(appearance);
    const contrast1 = $5bc9639ae0326803$var$getContrast(color, scale, 2);
    const contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, 25);
    const isForward = contrast2 > contrast1;
    if (state && state !== "idle" && surface !== "black") {
        const contrast = $5bc9639ae0326803$var$getContrast(color, parentScale, scale);
        let ghostStep = 1;
        let boldStep = 1;
        if (contrast < 60) boldStep = 2;
        if (contrast > 60) boldStep = 3;
        ghostStep *= stateStep;
        boldStep *= stateStep;
        switch(surface){
            case "ghost":
            case "minimal":
            case "subtle":
            case "moderate":
                scale = isForward ? scale + ghostStep : scale - ghostStep;
                break;
            case "bold":
            case "boldA11y":
            case "heavy":
            case "contrasting":
                if (Math.abs(scale - boldStep) < 3) scale += boldStep;
                else scale -= boldStep;
                break;
        }
    }
    let newColor = $5bc9639ae0326803$var$getColor(color, scale);
    if (surface.includes("elevated")) {
        const surfaceParts = surface.split("elevated");
        newColor = [
            newColor,
            $5bc9639ae0326803$var$getElevatedShadow(surfaceParts[1] || "Medium", mode, appearance)
        ].join(";");
    }
    return {
        surfaceType: "surface",
        color: newColor,
        scales: {
            [scale || 0]: 100
        }
    };
}
const $5bc9639ae0326803$var$getElevatedShadow = (type, mode, appearance)=>{
    let shadows = [];
    let color = $5bc9639ae0326803$var$getColor(appearance, mode === "dark" ? 1 : 2);
    const borderColor = $5bc9639ae0326803$var$applyAlpha($5bc9639ae0326803$var$getColor(appearance, 25), 10);
    switch(type?.toLowerCase() || ""){
        case "high":
            color = $5bc9639ae0326803$var$applyAlpha(color, 16);
            shadows = [
                color ?? "",
                "0",
                "16",
                "32",
                "0",
                "16",
                "48"
            ];
            break;
        case "medium":
            color = $5bc9639ae0326803$var$applyAlpha(color, 12);
            shadows = [
                color ?? "",
                "0",
                "12",
                "24",
                "0",
                "16",
                "48"
            ];
            break;
        case "low":
            color = $5bc9639ae0326803$var$applyAlpha(color, 8);
            shadows = [
                color ?? "",
                "0",
                "12",
                "24",
                "0",
                "16",
                "48"
            ];
    }
    shadows.push(...[
        borderColor ?? "",
        mode === "dark" ? "1" : "0"
    ]);
    return shadows.join(";");
};
function $5bc9639ae0326803$var$getContentColor(type, appearance = "primary", scale = 25, surface, state = "idle", tinted = true) {
    if (surface === "none") return {
        scales: {}
    };
    if (surface === "ghost") return {
        scales: {
            [scale]: 0
        }
    };
    const surfaceContrast = $5bc9639ae0326803$var$config$1.foundation.contrast[type]?.[surface];
    const isMidnight = appearance.includes("midnight");
    const color = appearance.replace("_midnight", "");
    let contrast1 = $5bc9639ae0326803$var$getContrast(color, scale, 1);
    let contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, 25);
    let isForward = contrast2 > contrast1;
    contrast1 = $5bc9639ae0326803$var$getContrast(color, scale, 1);
    contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, 25);
    isForward = contrast2 > contrast1;
    switch(surface){
        case "contrasting":
            switch(state){
                case "hover":
                    if (tinted) {
                        const idle = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, surface, "idle", tinted);
                        const active = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, surface, "active", tinted);
                        return {
                            scales: {
                                ...idle.scales,
                                ...active.scales
                            }
                        };
                    }
                    return $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "heavy", "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "moderate", "idle", tinted);
                default:
                    if (tinted) {
                        const highScale = isForward ? 25 : 2;
                        let mediumScale = scale;
                        const baseScale = $5bc9639ae0326803$var$getScale(color, isMidnight);
                        const contrast = $5bc9639ae0326803$var$getContrast(color, mediumScale, baseScale);
                        if (contrast >= 60) mediumScale = baseScale;
                        else {
                            const offset = $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, baseScale, $5bc9639ae0326803$var$getContrast(color, baseScale, baseScale), 60, isForward);
                            if (isForward && Math.abs(baseScale - offset) > 5) mediumScale = 25;
                            else mediumScale = offset;
                        }
                        scale = $5bc9639ae0326803$var$clamp(Math.floor((1 + (highScale + mediumScale)) / 2), 1, 25);
                        return {
                            scales: {
                                [scale]: 100
                            }
                        };
                    }
                    scale = isForward ? 25 : 2;
                    return {
                        scales: {
                            [scale]: 100
                        }
                    };
            }
        case "heavy":
            switch(state){
                case "hover":
                    {
                        const idle = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, surface, "idle", tinted);
                        const active = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, surface, "active", tinted);
                        return {
                            scales: {
                                ...idle.scales,
                                ...active.scales
                            }
                        };
                    }
                case "active":
                    if (tinted) {
                        const low = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "moderate", "idle", true);
                        const medium = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "heavy", "idle", true);
                        const high = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "contrasting", "idle", true);
                        if (Object.keys(medium.scales)[0] === Object.keys(high.scales)[0]) return low;
                        return high;
                    }
                    return $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "moderate", "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const baseScale = $5bc9639ae0326803$var$getScale(color, isMidnight);
                            const contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                            if (contrast >= surfaceContrast) scale = baseScale;
                            else {
                                const offset = $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, baseScale, contrast, surfaceContrast, isForward);
                                if (isForward && Math.abs(baseScale - offset) > 5) scale = 25;
                                else scale = offset;
                            }
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const opacity = $5bc9639ae0326803$var$getOpacity(color, scale, isForward ? 24 : 2, surfaceContrast);
                        const newHexColor = isForward ? 24 : 2;
                        const high = isForward ? 24 : 2;
                        const low = $5bc9639ae0326803$var$applyAlpha($5bc9639ae0326803$var$getColor(color, newHexColor), opacity);
                        return {
                            scales: {},
                            color: $5bc9639ae0326803$export$72a85c3a80ccc403($5bc9639ae0326803$var$getColor(color, high), low)
                        };
                    }
            }
        case "moderate":
            switch(state){
                case "hover":
                    if (tinted) {
                        const idle = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, surface, "idle", tinted);
                        const active = $5bc9639ae0326803$var$getContentColor(type, appearance, scale, surface, "active", tinted);
                        return {
                            scales: {
                                ...idle.scales,
                                ...active.scales
                            }
                        };
                    }
                    return $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "heavy", "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getContentColor(type, appearance, scale, "contrasting", "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const contrast = $5bc9639ae0326803$var$getContrast(color, scale, scale);
                            const offset = $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, scale, contrast, surfaceContrast, isForward);
                            scale = offset;
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const newScale = isForward ? 23 : 2;
                        const opacity = $5bc9639ae0326803$var$getOpacity(color, scale, newScale, surfaceContrast);
                        scale = newScale;
                        return {
                            scales: {
                                [newScale]: opacity
                            }
                        };
                    }
            }
        default:
            return {
                scales: {
                    [scale]: 100
                }
            };
    }
}
function $5bc9639ae0326803$var$getStrokeColor(appearance, scale, surface, mode = "light", state = "idle", tinted = true) {
    if (surface === "ghost") return {
        scales: {
            [scale || 0]: 0
        },
        color: "transparent"
    };
    const surfaceContrast = $5bc9639ae0326803$var$config$1.foundation.contrast["stroke"][surface] || 60;
    const isMidnight = appearance.includes("midnight");
    const color = appearance.replace("_midnight", "");
    let contrast1 = $5bc9639ae0326803$var$getContrast(color, scale, 1);
    let contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, 25);
    let isForward = contrast2 > contrast1;
    contrast1 = $5bc9639ae0326803$var$getContrast(color, scale, 1);
    contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, 25);
    isForward = contrast2 > contrast1;
    switch(surface){
        case "contrasting":
            switch(state){
                case "hover":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "heavy", mode, "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                default:
                    scale = isForward ? 25 : 2;
                    return {
                        scales: {
                            [scale]: 100
                        }
                    };
            }
        case "heavy":
            switch(state){
                case "hover":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "moderate", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const highScale = isForward ? 25 : 2;
                            const baseScale = $5bc9639ae0326803$var$getScale(color, isMidnight);
                            scale = Math.ceil((highScale + baseScale) / 2);
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const contrastingColor = isForward ? 25 : 2;
                        const moderateColor = isForward ? 22 : 3;
                        scale = isForward ? 22 : 3;
                        return {
                            scales: {
                                [contrastingColor]: 66,
                                [moderateColor]: 33
                            }
                        };
                    }
            }
        case "bold":
            switch(state){
                case "hover":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "heavy", mode, "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "contrasting", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            const baseScale = $5bc9639ae0326803$var$getScale(color, isMidnight);
                            const contrast = $5bc9639ae0326803$var$getContrast(color, scale, baseScale);
                            if (contrast >= 60) scale = baseScale;
                            else scale = $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, baseScale, contrast, 60, isForward);
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const contrastingColor = isForward ? 25 : 2;
                        const opacity = $5bc9639ae0326803$var$getOpacity(color, scale, isForward ? 22 : 3, 30);
                        const moderateColor = isForward ? 22 : 3;
                        scale = isForward ? 22 : 3;
                        return {
                            scales: {
                                [contrastingColor]: 33,
                                [moderateColor]: opacity
                            }
                        };
                    }
            }
        case "moderate":
            switch(state){
                case "hover":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "heavy", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            let boldScale = $5bc9639ae0326803$var$getScale(color, isMidnight);
                            const contrast = $5bc9639ae0326803$var$getContrast(color, scale, boldScale);
                            boldScale = $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, boldScale, contrast, 60, isForward);
                            const minimalScale = isForward ? scale + 2 : scale - 2;
                            scale = Math.floor((minimalScale + boldScale) / 2);
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const newScale = isForward ? 22 : 3;
                        const opacity = $5bc9639ae0326803$var$getOpacity(color, scale, newScale, surfaceContrast);
                        scale = newScale;
                        return {
                            scales: {
                                [newScale]: opacity
                            }
                        };
                    }
            }
        case "minimal":
            switch(state){
                case "hover":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "moderate", mode, "idle", tinted);
                case "active":
                    return $5bc9639ae0326803$var$getStrokeColor(appearance, scale, "bold", mode, "idle", tinted);
                default:
                    {
                        if (tinted) {
                            scale = isForward ? scale + 2 : scale - 2;
                            return {
                                scales: {
                                    [scale]: 100
                                }
                            };
                        }
                        const newScale = isForward ? 21 : 4;
                        const opacity = $5bc9639ae0326803$var$getOpacity(color, scale, newScale, surfaceContrast);
                        return {
                            scales: {
                                [newScale]: opacity
                            }
                        };
                    }
            }
    }
    return {
        scales: {}
    };
}
const $5bc9639ae0326803$var$GlassSurfaceConfig = {
    minimal: {
        default: 18,
        hover: 14,
        pressed: 10
    },
    subtle: {
        default: 14,
        hover: 10,
        pressed: 6
    },
    moderate: {
        default: 10,
        hover: 6,
        pressed: 2
    },
    heavy: {
        default: 6,
        hover: 10,
        pressed: 14
    }
};
function $5bc9639ae0326803$var$calculatePercentages(scale) {
    const minValue = 1;
    const maxValue = 25;
    const clampedValue = Math.min(Math.max(scale, minValue), maxValue);
    const normalizedValue = (maxValue - clampedValue) / (maxValue - minValue);
    const transparency = normalizedValue;
    const blur = Math.round(normalizedValue * 200);
    const saturation = Math.round(normalizedValue * 100 + 100);
    return {
        transparency: transparency,
        blur: blur,
        saturation: saturation / 100
    };
}
const $5bc9639ae0326803$var$getGlassSurface = (surface, state = "default", mode = "light", appearance = "navi")=>{
    let scale = $5bc9639ae0326803$var$GlassSurfaceConfig[surface][state];
    const tbs = $5bc9639ae0326803$var$calculatePercentages(scale);
    if (mode === "dark") scale = -scale;
    return {
        color: `glass--scale=${scale}-appearance=${appearance}-blur=${tbs.blur}-saturation=${tbs.saturation}-transparency=${tbs.transparency}`
    };
};
function $5bc9639ae0326803$var$resolveColorByType(color, tokens = {}) {
    const [_, surfaceType, surfaceFromToken, tinted] = color.split("_");
    let { scale: scale = 25, surface: surface, mode: mode, parentScale: parentScale = 25, strokeSurface: strokeSurface } = tokens;
    const state = tokens.state;
    surface = surfaceFromToken || surface;
    if (surfaceType === "stroke") strokeSurface = surfaceFromToken || strokeSurface;
    switch(surfaceType){
        case "surface":
            return $5bc9639ae0326803$var$getSurfaceColor(tokens.appearance, parseInt(scale), parseInt(parentScale), surface, mode, state);
        case "stroke":
            return {
                surfaceType: surfaceType,
                ...$5bc9639ae0326803$var$getStrokeColor(tokens.appearance, parseInt(scale), strokeSurface, mode, state, tinted === "tinted") || {}
            };
        case "glass":
            return $5bc9639ae0326803$var$getGlassSurface(tokens.surface, tokens.state, tokens.mode, tokens.appearance);
        default:
            return {
                surfaceType: surfaceType,
                ...$5bc9639ae0326803$var$getContentColor(surfaceType, tokens.appearance, parseInt(parentScale), surface, state, tinted === "tinted") || ""
            };
    }
}
const $5bc9639ae0326803$var$updateAppearanceAccent = (values)=>{
    if (values.accent) {
        if (values.parentAppearance === "neutral" && values.currentAppearance === "auto") return values.accent;
    }
    return values.appearance;
};
const $5bc9639ae0326803$var$updateFlatTokens = (tokens)=>{
    tokens.appearance = tokens.appearance || "primary";
    const appearance = $5bc9639ae0326803$export$37b637165f0c11db(tokens);
    const parentScale = parseInt(tokens.scale);
    tokens.scale = String($5bc9639ae0326803$export$1630fb55fe6ce943(appearance, parentScale, tokens.surface, void 0, tokens.mode));
    tokens.appearance = $5bc9639ae0326803$var$updateAppearanceAccent(tokens);
    tokens["brandVersion"] = "jio-v2";
    return tokens;
};
const $5bc9639ae0326803$var$contrastDict = $5bc9639ae0326803$var$contrast;
const $5bc9639ae0326803$var$convertStringOklchToObject = (color)=>{
    if (!color) return;
    const values = color.replace("oklch", "").replace(/^\(|\)$/gm, "");
    const [L, C, H, _, opacity = "1"] = values.split(" ");
    return {
        lightness: parseFloat(L.replace("%", "")),
        chroma: parseFloat(C),
        hue: parseFloat(H),
        alpha: parseFloat(opacity)
    };
};
function $5bc9639ae0326803$export$72a85c3a80ccc403(color1Oklch, color2Oklch, amountToMix1 = 50, amountToMix2 = 50) {
    const color1 = $5bc9639ae0326803$var$convertStringOklchToObject(color1Oklch);
    const color2 = $5bc9639ae0326803$var$convertStringOklchToObject(color2Oklch);
    if (!color1 || !color2) return;
    const weight1 = amountToMix1 / (amountToMix1 + amountToMix2);
    const weight2 = amountToMix2 / (amountToMix1 + amountToMix2);
    const mixedLightness = color1.lightness * weight1 + color2.lightness * weight2;
    const mixedChroma = color1.chroma * weight1 + color2.chroma * weight2;
    const mixedAlpha = color1.alpha * weight1 + color2.alpha * weight2;
    const hueDifference = Math.abs(color1.hue - color2.hue);
    let mixedHue;
    if (hueDifference > Math.PI) {
        const adjustedHue1 = color1.hue > color2.hue ? color1.hue - 2 * Math.PI : color1.hue;
        const adjustedHue2 = color2.hue > color1.hue ? color2.hue - 2 * Math.PI : color2.hue;
        mixedHue = adjustedHue1 * weight1 + adjustedHue2 * weight2;
    } else mixedHue = color1.hue * weight1 + color2.hue * weight2;
    const finalHue = mixedHue >= 0 ? mixedHue : mixedHue + 2 * Math.PI;
    return `oklch(${mixedLightness}% ${mixedChroma} ${finalHue} / ${mixedAlpha})`;
}
function $5bc9639ae0326803$var$converOpacityToHex(opacity) {
    return Math.round(opacity / 100 * 255).toString(16).padStart(2, "0");
}
function $5bc9639ae0326803$var$applyAlpha(color, opacity) {
    if (!color) {
        console.warn("Color is nil");
        return;
    }
    const opacityValue = Math.max(0, Math.min(100, opacity));
    const alpha = opacityValue / 100;
    if (color.startsWith("#")) return color + $5bc9639ae0326803$var$converOpacityToHex(alpha);
    const colorParts = color.replace("oklch", "").replace(/^\(|\)$/gm, "").split(" ");
    if (colorParts.length < 3) return;
    colorParts[2] = colorParts[2] + " / " + alpha;
    return `oklch(${colorParts.slice(0, 3).join(" ")})`;
}
function $5bc9639ae0326803$var$getContrast(color, _bgScale, _fgScale) {
    if (!_bgScale || !_fgScale) return 45;
    const _background = [
        color,
        $5bc9639ae0326803$var$clamp(_bgScale, 1, 25) * 100
    ].join(".");
    const _foreground = [
        color,
        $5bc9639ae0326803$var$clamp(_fgScale, 1, 25) * 100
    ].join(".");
    try {
        return $5bc9639ae0326803$var$contrastDict[color][_background][_foreground].contrast;
    } catch (error) {}
    return 45;
}
function $5bc9639ae0326803$var$getColor(color, scale) {
    if (typeof scale === "number") scale = scale * 100;
    const oklch = $5bc9639ae0326803$var$config$1.colors[`${color}.${scale}`];
    if ([
        "base",
        "midnight",
        "light"
    ].includes(scale)) return oklch;
    if (!oklch) return "";
    return oklch;
}
function $5bc9639ae0326803$var$replaceMidnight(color) {
    return color?.replace(/(_|\.)midnight/gm, "");
}
function $5bc9639ae0326803$var$getScale(color, midnight) {
    let scale = 0;
    color = $5bc9639ae0326803$var$replaceMidnight(color);
    if (midnight) scale = parseInt($5bc9639ae0326803$var$getColor(color, "midnight")) / 100 || 12;
    else scale = parseInt($5bc9639ae0326803$var$getColor(color, "base")) / 100 || 13;
    return scale;
}
function $5bc9639ae0326803$var$getOpacity(color, background, foreground, breakpoint) {
    const config2 = $5bc9639ae0326803$var$contrast[color];
    const _background = `${color}.${background * 100}`;
    const _foreground = `${color}.${foreground * 100}`;
    if (!config2 || !_background || !_foreground) return 1;
    try {
        return config2[_background][_foreground]["lc" + breakpoint];
    } catch (error) {
        return 100;
    }
}
function $5bc9639ae0326803$export$37b637165f0c11db(tokens = {}) {
    let { appearance: appearance = "primary" } = tokens;
    appearance = $5bc9639ae0326803$var$updateAppearanceAccent(tokens);
    return [
        "primary",
        "secondary",
        "sparkle"
    ].includes(appearance) ? tokens[appearance] || tokens["primary"] || "navi" : appearance || tokens?.["appearance"];
}
const $5bc9639ae0326803$var$clamp = (value, min, max)=>Math.max(min, Math.min(value, max));
function $5bc9639ae0326803$var$getAdjustedBaseScale(scale, color, isMidnight) {
    let baseScale = $5bc9639ae0326803$var$getScale(color, isMidnight);
    if (color === "grey") {
        if (scale <= 13) baseScale = 25;
        else baseScale = 2;
    } else if (scale <= 13) {
        if (baseScale >= 1 && baseScale <= 6) baseScale = baseScale + 3;
        else if (baseScale >= 7 && baseScale <= 12) baseScale = baseScale + 2;
        else if (baseScale >= 13 && baseScale <= 18) baseScale = baseScale + 1;
    }
    return baseScale;
}
function $5bc9639ae0326803$var$getAdjustedContrastScale(color, scale, newScale, contrast2, surfaceContrast, isForward) {
    while(contrast2 < surfaceContrast){
        if (isForward && newScale === 25 || !isForward && newScale === 1) break;
        newScale += isForward ? 1 : -1;
        contrast2 = $5bc9639ae0326803$var$getContrast(color, scale, newScale);
    }
    return newScale;
}
const $5bc9639ae0326803$var$convertScalesToVars = ({ scales: scales }, tokens, key, originalAppearance, color, surfaceType, colorAppearance = "navi", forceValue)=>{
    if (surfaceType === "surface") {
        if (Object.keys(scales).find((item)=>scales[parseInt(item)] === 0 || parseInt(item) === 0)) return {
            value: "transparent"
        };
        return {
            key: Object.keys(scales).map((scale)=>[
                    originalAppearance.split("_")[0],
                    parseInt(scale) * 100
                ].join(".")).join("."),
            value: color
        };
    }
    if (!Object.keys(scales).length) return {
        key: key
    };
    if (Object.keys(scales).length === 1) {
        const key2 = Object.keys(scales)[0];
        if (!key2) return {
            value: "transparent"
        };
        const opacity = scales[parseInt(key2)] ?? 100;
        const color2 = $5bc9639ae0326803$var$getColor(colorAppearance, parseInt(key2) || 0);
        if (opacity === 0) return {
            value: "transparent"
        };
        if (opacity === 100) return {
            value: color2,
            key: [
                originalAppearance.split("_")[0],
                parseInt(key2) * 100
            ].join(".")
        };
        if (forceValue) {
            const oklch = $5bc9639ae0326803$var$getColor(colorAppearance, parseInt(key2) || 25)?.replace(")", `/ ${opacity / 100})`);
            return {
                value: oklch
            };
        }
        return {
            // value: `color-mix(in oklch,${
            //   color ?? 'transparent'
            // } ${opacity}%, transparent ${100 - opacity}%)`,
            value: `oklch(from ${color2} l c h / ${opacity}%)`
        };
    }
    return {
        value: `color-mix(in oklch,${Object.entries(scales).map(([scale, opacity])=>[
                $5bc9639ae0326803$var$getColor(tokens["appearance"].split("_")[0], parseInt(scale)),
                opacity + "%"
            ].join(" ")).join(",")})`
    };
};
const $5bc9639ae0326803$var$border_none = "0";
const $5bc9639ae0326803$var$border_thinner = "0.5";
const $5bc9639ae0326803$var$border_thin = "1";
const $5bc9639ae0326803$var$border_normal = "2";
const $5bc9639ae0326803$var$border_thick = "3";
const $5bc9639ae0326803$var$border_focus = "4";
const $5bc9639ae0326803$var$borderWidth = {
    border_none: $5bc9639ae0326803$var$border_none,
    border_thinner: $5bc9639ae0326803$var$border_thinner,
    border_thin: $5bc9639ae0326803$var$border_thin,
    border_normal: $5bc9639ae0326803$var$border_normal,
    border_thick: $5bc9639ae0326803$var$border_thick,
    border_focus: $5bc9639ae0326803$var$border_focus
};
const $5bc9639ae0326803$var$config = $5bc9639ae0326803$var$config$1;
const $5bc9639ae0326803$var$densityPointDict = $5bc9639ae0326803$var$config.brand.density;
const $5bc9639ae0326803$var$scaleFactorJSON = $5bc9639ae0326803$var$config$1.foundation.scaleFactor;
class $5bc9639ae0326803$export$ce6a82d4287db7b3 {
    static getDimension(value, density = "default", maxWidth = 360, needsValue = false, indexLimit = "12", version = "3.0.5") {
        const [type, family, baseSize, apiSize, mult = "x1"] = value.split("_");
        let index = 0;
        let dimensionScale = false;
        dimensionScale = (type === "spacing" || type === "gap" || value.startsWith("f")) && version.startsWith("3.1.");
        if (value.startsWith("f")) {
            const index2 = parseInt(value.split("f").pop() || "0");
            const apiSize2 = value.split("_")[1];
            const mult2 = value.split("_")[2];
            if (apiSize2) {
                const scaleFactor = parseInt(mult2.slice(1)) || 1;
                const newSize = this.calculateSize(apiSize2, scaleFactor, dimensionScale);
                const newIndex = index2 + newSize;
                if (needsValue || indexLimit && newIndex > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, newIndex);
                return {
                    key: `f${newIndex}`,
                    value: 0
                };
            }
            if (needsValue || indexLimit && index2 > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, index2);
            return {
                key: `f${index2}`,
                value: 0
            };
        }
        if (type === "stroke") return $5bc9639ae0326803$export$ce6a82d4287db7b3.getStroke(family, dimensionScale);
        const base = $5bc9639ae0326803$var$config.brand?.[type]?.[family]?.["m"];
        const baseScaleFactor = this.getScaleFactor(type, family);
        const sizeMaping = this.calculateSize(baseSize, baseScaleFactor, dimensionScale) || 0;
        const sizeOffset = typeof base === "string" ? parseInt(base) : base;
        if (!apiSize) {
            index = dimensionScale ? sizeMaping : sizeMaping + sizeOffset;
            if (needsValue || indexLimit && index > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, index);
            return {
                key: `f${index}`,
                value: 0
            };
        }
        const multiplier = parseInt(mult.slice(1)) || 1;
        const newSizeMaping = this.addSize(baseSize, apiSize, baseScaleFactor, multiplier, dimensionScale);
        index = dimensionScale ? newSizeMaping : newSizeMaping + sizeOffset;
        if (needsValue || indexLimit && index > parseInt(indexLimit)) return this.getCalculatedValue(density, maxWidth, index);
        return {
            key: `f${index}`,
            value: 0
        };
    }
    static getScaleFactor(type = "spacing", family = "component") {
        return $5bc9639ae0326803$var$scaleFactorJSON[type]?.[family] ?? 1;
    }
    static getFraction(index) {
        const newIndex = Math.abs(index);
        const clamped = Math.min(7, Math.max(0, newIndex));
        const fractionConstant = 1 / 7;
        return clamped * fractionConstant;
    }
    static getLerp(a, b, t) {
        return a + t * (b - a);
    }
    static getCalculatedValue(density = "default", maxWidth = 360, index) {
        const x = maxWidth || 360;
        const min = $5bc9639ae0326803$var$densityPointDict[density]?.["min"];
        const max = $5bc9639ae0326803$var$densityPointDict[density]?.["max"];
        const breakPointMin = 360;
        const breakPointMax = 1920;
        if (!min || !max) return {
            value: 0
        };
        const fluid = this.getFluid(min, max, breakPointMin, breakPointMax, x);
        if (index >= 0) {
            const min2 = $5bc9639ae0326803$var$densityPointDict[density]?.advanced?.["c2"] ?? 0;
            const max2 = $5bc9639ae0326803$var$densityPointDict[density]?.advanced?.["c3"] ?? 0;
            const base = this.getFluid(min2, max2, breakPointMin, breakPointMax, x);
            const power = Math.pow(base, index);
            return {
                value: Math.round(fluid * power)
            };
        }
        const b = $5bc9639ae0326803$var$densityPointDict[density]?.advanced?.["c1"] ?? 0;
        const t = this.getFraction(index);
        const lerp = this.getLerp(fluid, b, t);
        return {
            value: Math.round(lerp)
        };
    }
    static getFluid(minSize, maxSize, minViewport, maxViewport, viewport) {
        const fontV = 100 * (maxSize - minSize) / (maxViewport - minViewport);
        const fontR = (minViewport * maxSize - maxViewport * minSize) / (minViewport - maxViewport);
        const fluid = viewport / 100 * fontV + fontR;
        const clamped = Math.min(maxSize, Math.max(minSize, fluid));
        return clamped;
    }
    static calculateSize(size, scaleFactor = 1, dimensionScale) {
        if (!size) return 0;
        const sizeRegex = /\d*(xs|s|m|l|xl)/;
        const nsString = size.toLowerCase();
        const results = nsString.match(sizeRegex);
        if (!results) return 0;
        const multiplierString = nsString.replace(results[1], "") || "1";
        const baseSizeString = results[1];
        const multiplier = parseFloat(multiplierString) ?? 1;
        const baseSize = baseSizeString || "m";
        const dynamicSize = dimensionScale ? this.getDynamicSize2(baseSize, multiplier, scaleFactor) : this.getDynamicSize(baseSize, multiplier, scaleFactor);
        return dynamicSize;
    }
    static addSize(baseSize, apiSize, baseFactor, scaleFactor, dimensionScale) {
        const newBaseSize = this.calculateSize(baseSize, baseFactor, dimensionScale);
        const newSize = this.calculateSize(apiSize, scaleFactor, dimensionScale);
        return newBaseSize + newSize;
    }
    static getDynamicSize2(baseSize, multiplier, scaleFactor) {
        switch(baseSize){
            case "m":
                return 0;
            case "s":
                return -1 * (scaleFactor + 1);
            case "xs":
                return -((1 + multiplier) * scaleFactor) - 2;
            case "l":
                return 1 * (scaleFactor + 1);
            case "xl":
                return (1 + multiplier) * (scaleFactor + 1);
        }
    }
    static getDynamicSize(baseSize, multiplier, scaleFactor) {
        switch(baseSize){
            case "m":
                return 0;
            case "s":
                return -1 * scaleFactor;
            case "xs":
                return -(1 + multiplier) * scaleFactor;
            case "l":
                return 1 * scaleFactor;
            case "xl":
                return (1 + multiplier) * scaleFactor;
        }
    }
    static getStroke(size, dimensionScale) {
        const calculatedSize = this.calculateSize(size, 1, dimensionScale);
        return {
            value: this.getStrokeValue(calculatedSize)
        };
    }
    static getStrokeValue(index) {
        const base = $5bc9639ae0326803$var$config$1.foundation.baseValue.dimension.stroke;
        return $5bc9639ae0326803$var$getGPseriesValue(base, 1.5, index);
    }
}
function $5bc9639ae0326803$var$getGPseriesValue(base, ratio, index) {
    const offset = Math.pow(ratio, index);
    return base * offset;
}
const $5bc9639ae0326803$var$fValueMap = {
    "--fluid-b": "calc(var(--dp-c1) * 1px)",
    // unit
    "--fontV-a": "calc(100 * ((var(--dp-max) - var(--dp-min)) / (1920 - 360)))",
    // unitless
    "--fontR-a": "calc(((360 * var(--dp-max)) - (1920 * var(--dp-min))) / (360 - 1920))",
    // unitless
    "--pre-fluid-a": "calc(var(--fontV-a) * 1vw + var(--fontR-a) * 1px)",
    // unit
    "--fluid-a": "min(max(calc(var(--dp-min) * 1px), var(--pre-fluid-a)), calc(var(--dp-max) * 1px))",
    // unit
    "--fontV-base": "calc(100 * ((var(--dp-c3) - var(--dp-c2)) / (1920 - 360)))",
    // unitless
    "--fontR-base": "calc(((360 * var(--dp-c3)) - (1920 * var(--dp-c2))) / (360 - 1920))",
    // unitless
    "--pre-fluid-base": "calc(var(--fontV-base) * 1vw + var(--fontR-base) * 1px)",
    // unit
    "--pre-base": "min(max(calc(var(--dp-c2) * 1px), var(--pre-fluid-base)), calc(var(--dp-c3) * 1px))",
    // unit
    "--base": "var(--dp-c2)",
    // unitless ; default value
    "--f-0": "var(--fluid-a)",
    // unit
    "--f-1": "calc(var(--f-0) * var(--base))",
    // unit
    "--f-2": "calc(var(--f-1) * var(--base))",
    // unit
    "--f-3": "calc(var(--f-2) * var(--base))",
    // unit
    "--f-4": "calc(var(--f-3) * var(--base))",
    // unit
    "--f-5": "calc(var(--f-4) * var(--base))",
    // unit
    "--f-6": "calc(var(--f-5) * var(--base))",
    // unit
    "--f-7": "calc(var(--f-6) * var(--base))",
    // unit
    "--f-8": "calc(var(--f-7) * var(--base))",
    // unit
    "--f-9": "calc(var(--f-8) * var(--base))",
    // unit
    "--f-10": "calc(var(--f-9) * var(--base))",
    // unit
    "--f-11": "calc(var(--f-10) * var(--base))",
    // unit
    "--f-12": "calc(var(--f-11) * var(--base))",
    // unit
    "--f-m-0": "var(--fluid-a)",
    // unit
    "--f-m-1": "calc((var(--fluid-a) + (1 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-2": "calc((var(--fluid-a) + (2 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-3": "calc((var(--fluid-a) + (3 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-4": "calc((var(--fluid-a) + (4 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-5": "calc((var(--fluid-a) + (5 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-6": "calc((var(--fluid-a) + (6 * (var(--fluid-b) - var(--fluid-a)) / 7)))",
    // unit
    "--f-m-7": "var(--fluid-b)",
    // unit
    "--f-m-8": "0"
};
function $5bc9639ae0326803$var$getDensityMap(density) {
    const densityData = $5bc9639ae0326803$var$densityPointDict[density];
    const c1 = densityData.advanced?.c1 ?? 0;
    const c2 = densityData.advanced?.c2 ?? 0;
    const c3 = densityData.advanced?.c3 ?? 0;
    const min = densityData.min;
    const max = densityData.max;
    return {
        "--dp-c1": String(c1),
        "--dp-c2": String(c2),
        "--dp-c3": String(c3),
        "--dp-min": String(min),
        "--dp-max": String(max),
        ...$5bc9639ae0326803$var$fValueMap
    };
}
function $5bc9639ae0326803$var$getColorToken(token) {
    return $5bc9639ae0326803$var$config$1.colors[token];
}
const $5bc9639ae0326803$var$feedbackColors = [
    "positive",
    "negative",
    "warning",
    "informative"
];
const $5bc9639ae0326803$var$scales = [
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
    "1000",
    "1100",
    "1200",
    "1300",
    "1400",
    "1500",
    "1600",
    "1700",
    "1800",
    "1900",
    "2000",
    "2100",
    "2200",
    "2300",
    "2400",
    "2500"
];
function $5bc9639ae0326803$var$getColorsMap(tokens, addFeedbackColors = false) {
    const result = {};
    const { primary: primary, secondary: secondary, sparkle: sparkle } = tokens;
    let themeColors = {
        primary: primary,
        secondary: secondary,
        sparkle: sparkle
    };
    if (addFeedbackColors) themeColors = {
        ...themeColors,
        neutral: "neutral",
        ...Object.fromEntries($5bc9639ae0326803$var$feedbackColors.map((f)=>[
                f,
                f
            ]))
    };
    const colors = Object.keys(themeColors);
    for (const color of colors)for (const scale of $5bc9639ae0326803$var$scales){
        const colorToken = `${themeColors[color].split("_")[0]}.${scale}`;
        const colorVar = `--${color}-${scale}`;
        if (scale === "100") {
            if (addFeedbackColors) result[colorVar] = "var(--black)";
            continue;
        } else if (scale === "2500") {
            if (addFeedbackColors) result[colorVar] = "var(--white)";
            continue;
        }
        result[colorVar] = $5bc9639ae0326803$var$getColorToken?.(colorToken) || "transparent";
    }
    if (addFeedbackColors) result["--transparent"] = "transparent";
    return result;
}
function $5bc9639ae0326803$var$brandResolverFn(type, key, tokens, forceValue = false) {
    key = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(key).replace("&", "");
    switch(type){
        case "fill":
        case "color":
        case "background-color":
        case "border-color":
            {
                const appearance = $5bc9639ae0326803$export$37b637165f0c11db(tokens);
                const newTokens = {
                    ...tokens,
                    appearance: appearance
                };
                const { scales: scales2 = {}, surfaceType: surfaceType, color: color } = $5bc9639ae0326803$var$resolveColorByType(key, newTokens);
                if (key.includes("elevated")) return {
                    value: color
                };
                if (!Object.keys(scales2).length) return {
                    value: color
                };
                if (color?.startsWith("glass")) return {
                    value: color
                };
                const resolvedScales = $5bc9639ae0326803$var$convertScalesToVars({
                    scales: scales2
                }, newTokens, key, tokens?.["appearance"] ?? "primary", color, surfaceType, appearance, forceValue);
                if (forceValue) {
                    if (resolvedScales.key) {
                        const [_, scale] = resolvedScales.key.split(".");
                        const key2 = `${$5bc9639ae0326803$var$replaceMidnight(appearance)}.${scale}`;
                        return {
                            value: $5bc9639ae0326803$var$getColorToken(key2)
                        };
                    }
                }
                return resolvedScales;
            }
        case "transition-duration":
            return {
                value: "var(--transitions-duration-medium)"
            };
        case "transition-timing-function":
            return {
                value: "var(--transitions-ease-joyful)"
            };
        case "transition-delay":
            return {
                value: "0"
            };
        default:
            {
                const resolved = $5bc9639ae0326803$export$ce6a82d4287db7b3.getDimension(key, tokens["density"], parseInt(tokens["maxWidth"]), forceValue, tokens.indexLimit, tokens.version);
                if (!resolved) return void 0;
                return {
                    key: forceValue ? void 0 : resolved.key,
                    value: resolved ? `${resolved.value}px` : key
                };
            }
    }
}
const $5bc9639ae0326803$var$surface = "{&color_surface}";
const $5bc9639ae0326803$var$content = "{&color_content}";
const $5bc9639ae0326803$var$stroke = "{&color_stroke}";
const $5bc9639ae0326803$var$color = {
    surface: $5bc9639ae0326803$var$surface,
    content: $5bc9639ae0326803$var$content,
    stroke: $5bc9639ae0326803$var$stroke
};
function $5bc9639ae0326803$var$getComponentTokens(componentName) {
    const GENERATED_JSON_MAP = {};
    return GENERATED_JSON_MAP[componentName];
}
const $5bc9639ae0326803$var$layout = {
    "flexDirection.row": "row",
    "flexDirection.column": "column",
    "flexDirection.stack": "stack",
    "alignItems.start": "flex-start",
    "alignItems.center": "center",
    "alignItems.end": "flex-end",
    "alignItems.spaceBetween": "space-between",
    "alignItems.spaceAround": "space-around",
    "alignItems.spaceEvenly": "space-evenly",
    "alignItems.stretch": "stretch",
    "justifyContent.start": "flex-start",
    "justifyContent.center": "center",
    "justifyContent.end": "flex-end",
    "justifyContent.spaceBetween": "space-between",
    "justifyContent.spaceAround": "space-around",
    "justifyContent.spaceEvenly": "space-evenly",
    "textAlign.start": "start",
    "textAlign.center": "center",
    "textAlign.end": "end",
    "textAlign.justify": "justify",
    "aspect_ratio.1.1": "1",
    "aspect_ratio.3.4": "0.75",
    "aspect_ratio.4.3": "1.33",
    "aspect_ratio.4.5": "0.8",
    "aspect_ratio.5.4": "1.25",
    "aspect_ratio.9.16": "0.56",
    "aspect_ratio.16.9": "1.77",
    "aspect_ratio.2_75.1": "2.75",
    "size.max": "max",
    "size.min": "min",
    "size.negativeMax": "negativeMax",
    "intrinsicSize.min": "intrinsicSize.min",
    "intrinsicSize.max": "intrinsicSize.max",
    "zIndex-1": 1,
    "size.fit": "fit-content"
};
const $5bc9639ae0326803$var$opacity = {
    "opacity.invisible": "0%",
    "opacity.disabled": "30%",
    "opacity.half": "50%",
    "opacity.enabled": "100%"
};
const $5bc9639ae0326803$var$spacing = {
    "grid.margin": "{grid.margin.$platform}",
    "grid.gutter": "{grid.gutter.$platform}",
    "grid.margin.mobile": "{grid.margin.mobile.$density}",
    "grid.margin.tablet": "{grid.margin.tablet.$density}",
    "grid.gutter.mobile": "{grid.gutter.mobile.$density}",
    "grid.gutter.tablet": "{grid.gutter.tablet.$density}",
    "grid.columns.mobile": 4,
    "grid.columns.tablet": 8,
    "screensize.desktop": 1440,
    "grid.margin.desktop": "{grid.margin.desktop.$density}",
    "grid.gutter.desktop": "{grid.gutter.desktop.$density}",
    "grid.columns.desktop": 12,
    "grid.columns": "{grid.columns.$platform}",
    "grid.margin.mobile.open": "{&f2}",
    "grid.margin.mobile.default": "{&f0}",
    "grid.margin.mobile.compact": "{&f0}",
    "grid.gutter.mobile.open": "{&f-2}",
    "grid.gutter.mobile.default": "{&f-4}",
    "grid.gutter.mobile.compact": "{&f-5}",
    "grid.margin.desktop.open": "{&f7}",
    "grid.margin.desktop.default": "{&f6}",
    "grid.margin.desktop.compact": "{&f5}",
    "grid.gutter.desktop.open": "{&f1}",
    "grid.gutter.desktop.default": "{&f0}",
    "grid.gutter.desktop.compact": "{&f-1}",
    "grid.margin.tablet.open": "{&f7}",
    "grid.margin.tablet.default": "{&f6}",
    "grid.margin.tablet.compact": "{&f5}",
    "grid.gutter.tablet.open": "{&f1}",
    "grid.gutter.tablet.default": "{&f0}",
    "grid.gutter.tablet.compact": "{&f-1}"
};
const $5bc9639ae0326803$var$easeRapid = "0.35, 0, 0.5, 1";
const $5bc9639ae0326803$var$easeQuick = "0.35, 0, 0.25, 1";
const $5bc9639ae0326803$var$easeJoyful = "0.35, 1.3, 0.3, 1";
const $5bc9639ae0326803$var$easeEntrance = "0, 0, 0.1, 1";
const $5bc9639ae0326803$var$easeExit = "0.35, 0, 0.8, 1";
const $5bc9639ae0326803$var$easeJoyfulEntrance = "0.15, 1.3, 0.3, 1";
const $5bc9639ae0326803$var$easeJoyfulExit = "0.7, -0.1, 0.6, 0.1";
const $5bc9639ae0326803$var$transitions = {
    easeRapid: $5bc9639ae0326803$var$easeRapid,
    easeQuick: $5bc9639ae0326803$var$easeQuick,
    easeJoyful: $5bc9639ae0326803$var$easeJoyful,
    easeEntrance: $5bc9639ae0326803$var$easeEntrance,
    easeExit: $5bc9639ae0326803$var$easeExit,
    easeJoyfulEntrance: $5bc9639ae0326803$var$easeJoyfulEntrance,
    easeJoyfulExit: $5bc9639ae0326803$var$easeJoyfulExit
};
const $5bc9639ae0326803$var$rapid = "300";
const $5bc9639ae0326803$var$medium = "500";
const $5bc9639ae0326803$var$slow = "1000";
const $5bc9639ae0326803$var$transitionsDuration = {
    rapid: $5bc9639ae0326803$var$rapid,
    medium: $5bc9639ae0326803$var$medium,
    slow: $5bc9639ae0326803$var$slow
};
const $5bc9639ae0326803$var$fontFamilies = {
    "typography.fontfamily": "JioType Var"
};
const $5bc9639ae0326803$var$lineHeights = {
    "display.l.lineheight": 100,
    "display.m.lineheight": 100,
    "display.s.lineheight": 100,
    "display.xs.lineheight": 100,
    "display.2xs.lineheight": 100,
    "headline.l.lineheight": 100,
    "headline.m.lineheight": 100,
    "headline.s.lineheight": 100,
    "headline.xs.lineheight": 100,
    "headline.2xs.lineheight": 100,
    "headline.3xs.lineheight": 100,
    "title.l.lineheight": 110.00000238418579,
    "title.m.lineheight": 110.00000238418579,
    "title.s.lineheight": 110.00000238418579,
    "title.xs.lineheight": 110.00000238418579,
    "title.2xs.lineheight": 110.00000238418579,
    "title.3xs.lineheight": 110.00000238418579,
    "body.l.lineheight": 120,
    "body.m.lineheight": 120,
    "body.s.lineheight": 120,
    "body.xs.lineheight": 120,
    "body.2xs.lineheight": 120,
    "body.3xs.lineheight": 120,
    "label.l.lineheight": 100,
    "label.m.lineheight": 100,
    "label.s.lineheight": 100,
    "label.xs.lineheight": 100,
    "label.2xs.lineheight": 100,
    "label.3xs.lineheight": 100
};
const $5bc9639ae0326803$var$fontWeights = {
    "typography.fontweight.display": 900,
    "typography.fontweight.headline": 900,
    "typography.fontweight.titlemediumsmall": 750,
    "typography.fontweight.headlinemediumsmall": 850,
    "typography.fontweight.title": 800,
    "typography.fontweight.bodylow": 400,
    "typography.fontweight.bodymedium": 500,
    "typography.fontweight.bodyhigh": 700,
    "typography.fontweight.labelhigh": 700,
    "typography.fontweight.labelmedium": 500
};
const $5bc9639ae0326803$var$letterSpacing = {
    "display.l.letterspacing": 0,
    "display.m.letterspacing": 0,
    "display.s.letterspacing": 0,
    "display.xs.letterspacing": 0,
    "display.2xs.letterspacing": 0,
    "headline.l.letterspacing": 0,
    "headline.m.letterspacing": 0,
    "headline.s.letterspacing": 0,
    "headline.xs.letterspacing": 0,
    "headline.2xs.letterspacing": 0,
    "headline.3xs.letterspacing": 0,
    "title.m.letterspacing": 0,
    "title.l.letterspacing": 0,
    "title.s.letterspacing": 0,
    "title.xs.letterspacing": 0,
    "title.2xs.letterspacing": 0,
    "title.3xs.letterspacing": 0,
    "body.l.letterspacing": 0,
    "body.m.letterspacing": 0,
    "body.s.letterspacing": 0,
    "body.xs.letterspacing": 0,
    "body.2xs.letterspacing": 0,
    "body.3xs.letterspacing": 0,
    "label.l.letterspacing": 0,
    "label.m.letterspacing": 0,
    "label.s.letterspacing": 0,
    "label.xs.letterspacing": 0,
    "label.2xs.letterspacing": 0,
    "label.3xs.letterspacing": 0
};
const $5bc9639ae0326803$var$defaults = {
    image: {
        width: "fit-content"
    }
};
const $5bc9639ae0326803$export$6ad93df59e712c43 = {
    tokens: {
        color: {
            ...$5bc9639ae0326803$var$color,
            ...$5bc9639ae0326803$var$config$1.colors
        },
        spacing: $5bc9639ae0326803$var$spacing,
        fontFamilies: $5bc9639ae0326803$var$fontFamilies,
        borderWidth: $5bc9639ae0326803$var$borderWidth,
        layout: $5bc9639ae0326803$var$layout,
        opacity: $5bc9639ae0326803$var$opacity,
        lineHeights: $5bc9639ae0326803$var$lineHeights,
        transitions: $5bc9639ae0326803$var$transitions,
        transitionsDuration: $5bc9639ae0326803$var$transitionsDuration,
        fontWeights: $5bc9639ae0326803$var$fontWeights,
        letterSpacing: $5bc9639ae0326803$var$letterSpacing
    },
    defaults: $5bc9639ae0326803$var$defaults,
    getComponentTokens: $5bc9639ae0326803$var$getComponentTokens,
    brandResolverFn: $5bc9639ae0326803$var$brandResolverFn,
    updateFlatTokens: $5bc9639ae0326803$var$updateFlatTokens,
    getDensityMap: $5bc9639ae0326803$var$getDensityMap,
    getColorsMap: $5bc9639ae0326803$var$getColorsMap
};
const $5bc9639ae0326803$export$616d0e83e98f2255 = [
    {
        name: "JioMeet",
        primaryColor: "orange",
        secondaryColor: "purple",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Express",
        primaryColor: "navi_midnight",
        secondaryColor: "red",
        sparkleColor: "pink"
    },
    {
        name: "JioSnap",
        primaryColor: "violet",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioMart Digital Partner",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioTrue5G",
        primaryColor: "navi_midnight",
        secondaryColor: "orange",
        sparkleColor: "reliance"
    },
    {
        name: "JioNetVelocity",
        primaryColor: "reliance",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioSociety",
        primaryColor: "violet_midnight",
        secondaryColor: "mint",
        sparkleColor: "orange"
    },
    {
        name: "JioVideoCall",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioSwitch",
        primaryColor: "reliance_midnight",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "DSP",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioPhotos",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioPay",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioTranslate",
        primaryColor: "pink_midnight",
        secondaryColor: "marigold",
        sparkleColor: "purple"
    },
    {
        name: "JioTV",
        primaryColor: "crimson",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioGames",
        primaryColor: "green",
        secondaryColor: "mint_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JustDial",
        primaryColor: "sky",
        secondaryColor: "orange",
        sparkleColor: "mint"
    },
    {
        name: "JioTVplus",
        primaryColor: "crimson",
        secondaryColor: "marigold",
        sparkleColor: "red"
    },
    {
        name: "JioHealthHub",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "red"
    },
    {
        name: "JioGlobal",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioSaavn",
        primaryColor: "mint",
        secondaryColor: "sky",
        sparkleColor: "navi"
    },
    {
        name: "JioEvents",
        primaryColor: "mint",
        secondaryColor: "purple",
        sparkleColor: "pink"
    },
    {
        name: "JioFit",
        primaryColor: "Orange",
        secondaryColor: "Purple",
        sparkleColor: "Mint"
    },
    {
        name: "JioMarket",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "orange"
    },
    {
        name: "JioAssist",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "mint"
    },
    {
        name: "JioChannels",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioBase",
        primaryColor: "navi",
        secondaryColor: "marigold",
        sparkleColor: "mint"
    },
    {
        name: "JioCloud",
        primaryColor: "sky",
        secondaryColor: "mint",
        sparkleColor: "marigold"
    },
    {
        name: "JioAds",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioKrishi",
        primaryColor: "green_midnight",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioCinema",
        primaryColor: "pink",
        secondaryColor: "violet_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioMart Digital Business",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "MyJio",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioGlass",
        primaryColor: "crimson",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioDive",
        primaryColor: "purple",
        secondaryColor: "mint",
        sparkleColor: "sky"
    },
    {
        name: "JioCall",
        primaryColor: "green",
        secondaryColor: "violet",
        sparkleColor: "navi"
    },
    {
        name: "JioEngage",
        primaryColor: "violet_midnight",
        secondaryColor: "red",
        sparkleColor: "marigold"
    },
    {
        name: "JioCX",
        primaryColor: "purple",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioFinance",
        primaryColor: "gold",
        secondaryColor: "orange_midnight",
        sparkleColor: "sky_midnight"
    },
    {
        name: "JioPos",
        primaryColor: "mint",
        secondaryColor: "red_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioNews",
        primaryColor: "crimson",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Digital",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioID",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "green"
    },
    {
        name: "JioHome",
        primaryColor: "sky",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioMart",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioMart Partner",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioGauSamridhhi",
        primaryColor: "orange",
        secondaryColor: "green_midnight",
        sparkleColor: "pink_midnight"
    },
    {
        name: "JioWallet",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioJoin",
        primaryColor: "green",
        secondaryColor: "purple",
        sparkleColor: "marigold"
    },
    {
        name: "JioSecure",
        primaryColor: "mint",
        secondaryColor: "reliance_midnight",
        sparkleColor: "sky_light"
    },
    {
        name: "JioCare",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "pink"
    },
    {
        name: "JioSphere",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioChat",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioCloud PC",
        primaryColor: "sky",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "jio com",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioWave",
        primaryColor: "purple",
        secondaryColor: "sky",
        sparkleColor: "mint"
    },
    {
        name: "JioWorkspace",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "reliance"
    },
    {
        name: "JioFacility",
        primaryColor: "indigo",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "MyJio1",
        primaryColor: "indigo",
        secondaryColor: "saffron",
        sparkleColor: "green"
    },
    {
        name: "JioMessages",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioBusiness",
        primaryColor: "purple",
        secondaryColor: "reliance",
        sparkleColor: "mint"
    }
];
const $5bc9639ae0326803$var$camelCase = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $5bc9639ae0326803$var$clearModeFromColor = (color)=>{
    return color.replace(/_(light|dark|dim)+/i, "");
};
const $5bc9639ae0326803$var$transformThemeName = (name)=>name.split("-").map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $5bc9639ae0326803$var$normalizedThemeData = $5bc9639ae0326803$export$616d0e83e98f2255.map((data)=>({
        ...data,
        name: $5bc9639ae0326803$var$transformThemeName(data.name)
    }));
const $5bc9639ae0326803$export$e330aa996edc4437 = (theme)=>{
    const normalizedTheme = $5bc9639ae0326803$var$transformThemeName(theme);
    const currentTheme = $5bc9639ae0326803$var$normalizedThemeData.find((data)=>$5bc9639ae0326803$var$camelCase(normalizedTheme) === $5bc9639ae0326803$var$camelCase(data.name));
    let colors = {
        primary: $5bc9639ae0326803$export$616d0e83e98f2255[0].primaryColor,
        secondary: $5bc9639ae0326803$export$616d0e83e98f2255[0].secondaryColor,
        sparkle: $5bc9639ae0326803$export$616d0e83e98f2255[0].sparkleColor,
        neutral: "neutral"
    };
    if (currentTheme) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor, sparkleColor: sparkleColor } = currentTheme;
        colors = {
            primary: primaryColor?.toLowerCase(),
            secondary: secondaryColor?.toLowerCase(),
            sparkle: sparkleColor?.toLowerCase(),
            neutral: "neutral"
        };
    }
    colors.primary = $5bc9639ae0326803$var$clearModeFromColor(colors.primary);
    colors.secondary = $5bc9639ae0326803$var$clearModeFromColor(colors.secondary);
    colors.sparkle = $5bc9639ae0326803$var$clearModeFromColor(colors.sparkle);
    return colors;
};




var $1OEoy = parcelRequire("1OEoy");

const $52d4442770cfd938$var$xSmall = "2";
const $52d4442770cfd938$var$small = "4";
const $52d4442770cfd938$var$medium$1 = "8";
const $52d4442770cfd938$var$large = "16";
const $52d4442770cfd938$var$xl$2 = "24";
const $52d4442770cfd938$var$xxl$2 = "32";
const $52d4442770cfd938$var$pill = "25000";
const $52d4442770cfd938$var$none = "0";
const $52d4442770cfd938$var$custom_1$3 = "12";
const $52d4442770cfd938$var$custom_2$3 = "48";
const $52d4442770cfd938$var$custom_3$2 = "250";
const $52d4442770cfd938$var$borderRadius = {
    xSmall: $52d4442770cfd938$var$xSmall,
    small: $52d4442770cfd938$var$small,
    medium: $52d4442770cfd938$var$medium$1,
    large: $52d4442770cfd938$var$large,
    xl: $52d4442770cfd938$var$xl$2,
    xxl: $52d4442770cfd938$var$xxl$2,
    pill: $52d4442770cfd938$var$pill,
    none: $52d4442770cfd938$var$none,
    custom_1: $52d4442770cfd938$var$custom_1$3,
    custom_2: $52d4442770cfd938$var$custom_2$3,
    custom_3: $52d4442770cfd938$var$custom_3$2
};
const $52d4442770cfd938$var$border_none = "0";
const $52d4442770cfd938$var$border_thin = "1";
const $52d4442770cfd938$var$border_normal = "2";
const $52d4442770cfd938$var$border_thick = "3";
const $52d4442770cfd938$var$border_focus = "4";
const $52d4442770cfd938$var$borderWidth = {
    border_none: $52d4442770cfd938$var$border_none,
    border_thin: $52d4442770cfd938$var$border_thin,
    border_normal: $52d4442770cfd938$var$border_normal,
    border_thick: $52d4442770cfd938$var$border_thick,
    border_focus: $52d4442770cfd938$var$border_focus
};
const $52d4442770cfd938$var$primary20 = "{color.$mode.$primary.20}";
const $52d4442770cfd938$var$primary30 = "{color.$mode.$primary.30}";
const $52d4442770cfd938$var$primary40 = "{color.$mode.$primary.40}";
const $52d4442770cfd938$var$primary50 = "{color.$mode.$primary.50}";
const $52d4442770cfd938$var$primary60 = "{color.$mode.$primary.60}";
const $52d4442770cfd938$var$primary70 = "{color.$mode.$primary.70}";
const $52d4442770cfd938$var$primary80 = "{color.$mode.$primary.80}";
const $52d4442770cfd938$var$primaryInverse = "{color.$mode.$primary.inverse}";
const $52d4442770cfd938$var$primaryBackground = "{color.$mode.$primary.background}";
const $52d4442770cfd938$var$primaryGrey100 = "{color.$mode.$primary.grey.100}";
const $52d4442770cfd938$var$primaryGrey80 = "{color.$mode.$primary.grey.80}";
const $52d4442770cfd938$var$primaryGrey60 = "{color.$mode.$primary.grey.60}";
const $52d4442770cfd938$var$primaryGrey40 = "{color.$mode.$primary.grey.40}";
const $52d4442770cfd938$var$primaryGrey20 = "{color.$mode.$primary.grey.20}";
const $52d4442770cfd938$var$secondary20 = "{color.$mode.$secondary.20}";
const $52d4442770cfd938$var$secondary30 = "{color.$mode.$secondary.30}";
const $52d4442770cfd938$var$secondary40 = "{color.$mode.$secondary.40}";
const $52d4442770cfd938$var$secondary50 = "{color.$mode.$secondary.50}";
const $52d4442770cfd938$var$secondary60 = "{color.$mode.$secondary.60}";
const $52d4442770cfd938$var$secondary70 = "{color.$mode.$secondary.70}";
const $52d4442770cfd938$var$secondary80 = "{color.$mode.$secondary.80}";
const $52d4442770cfd938$var$secondaryInverse = "{color.$mode.$secondary.inverse}";
const $52d4442770cfd938$var$secondaryBackground = "{color.$mode.$secondary.background}";
const $52d4442770cfd938$var$secondaryGrey100 = "{color.$mode.$secondary.grey.100}";
const $52d4442770cfd938$var$secondaryGrey80 = "{color.$mode.$secondary.grey.80}";
const $52d4442770cfd938$var$secondaryGrey60 = "{color.$mode.$secondary.grey.60}";
const $52d4442770cfd938$var$secondaryGrey40 = "{color.$mode.$secondary.grey.40}";
const $52d4442770cfd938$var$secondaryGrey20 = "{color.$mode.$secondary.grey.20}";
const $52d4442770cfd938$var$sparkle20 = "{color.$mode.$sparkle.20}";
const $52d4442770cfd938$var$sparkle30 = "{color.$mode.$sparkle.30}";
const $52d4442770cfd938$var$sparkle40 = "{color.$mode.$sparkle.40}";
const $52d4442770cfd938$var$sparkle50 = "{color.$mode.$sparkle.50}";
const $52d4442770cfd938$var$sparkle60 = "{color.$mode.$sparkle.60}";
const $52d4442770cfd938$var$sparkle70 = "{color.$mode.$sparkle.70}";
const $52d4442770cfd938$var$sparkle80 = "{color.$mode.$sparkle.80}";
const $52d4442770cfd938$var$sparkleInverse = "{color.$mode.$sparkle.inverse}";
const $52d4442770cfd938$var$sparkleBackground = "{color.$mode.$sparkle.background}";
const $52d4442770cfd938$var$sparkleGrey100 = "{color.$mode.$sparkle.grey.100}";
const $52d4442770cfd938$var$sparkleGrey80 = "{color.$mode.$sparkle.grey.80}";
const $52d4442770cfd938$var$sparkleGrey60 = "{color.$mode.$sparkle.grey.60}";
const $52d4442770cfd938$var$sparkleGrey40 = "{color.$mode.$sparkle.grey.40}";
const $52d4442770cfd938$var$sparkleGrey20 = "{color.$mode.$sparkle.grey.20}";
const $52d4442770cfd938$var$feedbackError80 = "{color.$mode.feedback.error.80}";
const $52d4442770cfd938$var$feedbackError70 = "{color.$mode.feedback.error.70}";
const $52d4442770cfd938$var$feedbackError60 = "{color.$mode.feedback.error.60}";
const $52d4442770cfd938$var$feedbackError50 = "{color.$mode.feedback.error.50}";
const $52d4442770cfd938$var$feedbackError40 = "{color.$mode.feedback.error.40}";
const $52d4442770cfd938$var$feedbackError30 = "{color.$mode.feedback.error.30}";
const $52d4442770cfd938$var$feedbackError20 = "{color.$mode.feedback.error.20}";
const $52d4442770cfd938$var$feedbackWarning80 = "{color.$mode.feedback.warning.80}";
const $52d4442770cfd938$var$feedbackWarning70 = "{color.$mode.feedback.warning.70}";
const $52d4442770cfd938$var$feedbackWarning60 = "{color.$mode.feedback.warning.60}";
const $52d4442770cfd938$var$feedbackWarning50 = "{color.$mode.feedback.warning.50}";
const $52d4442770cfd938$var$feedbackWarning40 = "{color.$mode.feedback.warning.40}";
const $52d4442770cfd938$var$feedbackWarning30 = "{color.$mode.feedback.warning.30}";
const $52d4442770cfd938$var$feedbackWarning20 = "{color.$mode.feedback.warning.20}";
const $52d4442770cfd938$var$feedbackSuccess80 = "{color.$mode.feedback.success.80}";
const $52d4442770cfd938$var$feedbackSuccess70 = "{color.$mode.feedback.success.70}";
const $52d4442770cfd938$var$feedbackSuccess60 = "{color.$mode.feedback.success.60}";
const $52d4442770cfd938$var$feedbackSuccess50 = "{color.$mode.feedback.success.50}";
const $52d4442770cfd938$var$feedbackSuccess40 = "{color.$mode.feedback.success.40}";
const $52d4442770cfd938$var$feedbackSuccess30 = "{color.$mode.feedback.success.30}";
const $52d4442770cfd938$var$feedbackSuccess20 = "{color.$mode.feedback.success.20}";
const $52d4442770cfd938$var$elevation1 = "{elevation1.$mode}";
const $52d4442770cfd938$var$custom_color_1 = "";
const $52d4442770cfd938$var$custom_color_2 = "#75757580";
const $52d4442770cfd938$var$custom_color_3 = "#000000D9";
const $52d4442770cfd938$var$custom_color_4 = "#75757580";
const $52d4442770cfd938$var$custom_color_5 = "#00000029";
const $52d4442770cfd938$var$custom_color_6 = "#14151775";
const $52d4442770cfd938$var$custom_dark_primary_40 = "{color.dark.$primary.40}";
const $52d4442770cfd938$var$custom_dark_primary_60 = "{color.dark.$primary.60}";
const $52d4442770cfd938$var$custom_dark_primary_grey_80 = "{color.dark.$primary.grey.80}";
const $52d4442770cfd938$var$custom_dark_primary_grey_100 = "{color.dark.$primary.grey.100}";
const $52d4442770cfd938$var$color = {
    primary20: $52d4442770cfd938$var$primary20,
    primary30: $52d4442770cfd938$var$primary30,
    primary40: $52d4442770cfd938$var$primary40,
    primary50: $52d4442770cfd938$var$primary50,
    primary60: $52d4442770cfd938$var$primary60,
    primary70: $52d4442770cfd938$var$primary70,
    primary80: $52d4442770cfd938$var$primary80,
    primaryInverse: $52d4442770cfd938$var$primaryInverse,
    primaryBackground: $52d4442770cfd938$var$primaryBackground,
    primaryGrey100: $52d4442770cfd938$var$primaryGrey100,
    primaryGrey80: $52d4442770cfd938$var$primaryGrey80,
    primaryGrey60: $52d4442770cfd938$var$primaryGrey60,
    primaryGrey40: $52d4442770cfd938$var$primaryGrey40,
    primaryGrey20: $52d4442770cfd938$var$primaryGrey20,
    secondary20: $52d4442770cfd938$var$secondary20,
    secondary30: $52d4442770cfd938$var$secondary30,
    secondary40: $52d4442770cfd938$var$secondary40,
    secondary50: $52d4442770cfd938$var$secondary50,
    secondary60: $52d4442770cfd938$var$secondary60,
    secondary70: $52d4442770cfd938$var$secondary70,
    secondary80: $52d4442770cfd938$var$secondary80,
    secondaryInverse: $52d4442770cfd938$var$secondaryInverse,
    secondaryBackground: $52d4442770cfd938$var$secondaryBackground,
    secondaryGrey100: $52d4442770cfd938$var$secondaryGrey100,
    secondaryGrey80: $52d4442770cfd938$var$secondaryGrey80,
    secondaryGrey60: $52d4442770cfd938$var$secondaryGrey60,
    secondaryGrey40: $52d4442770cfd938$var$secondaryGrey40,
    secondaryGrey20: $52d4442770cfd938$var$secondaryGrey20,
    sparkle20: $52d4442770cfd938$var$sparkle20,
    sparkle30: $52d4442770cfd938$var$sparkle30,
    sparkle40: $52d4442770cfd938$var$sparkle40,
    sparkle50: $52d4442770cfd938$var$sparkle50,
    sparkle60: $52d4442770cfd938$var$sparkle60,
    sparkle70: $52d4442770cfd938$var$sparkle70,
    sparkle80: $52d4442770cfd938$var$sparkle80,
    sparkleInverse: $52d4442770cfd938$var$sparkleInverse,
    sparkleBackground: $52d4442770cfd938$var$sparkleBackground,
    sparkleGrey100: $52d4442770cfd938$var$sparkleGrey100,
    sparkleGrey80: $52d4442770cfd938$var$sparkleGrey80,
    sparkleGrey60: $52d4442770cfd938$var$sparkleGrey60,
    sparkleGrey40: $52d4442770cfd938$var$sparkleGrey40,
    sparkleGrey20: $52d4442770cfd938$var$sparkleGrey20,
    "global.white": "{color.$mode.white}",
    "global.black": "{color.$mode.black}",
    "global.transparent": "transparent",
    feedbackError80: $52d4442770cfd938$var$feedbackError80,
    feedbackError70: $52d4442770cfd938$var$feedbackError70,
    feedbackError60: $52d4442770cfd938$var$feedbackError60,
    feedbackError50: $52d4442770cfd938$var$feedbackError50,
    feedbackError40: $52d4442770cfd938$var$feedbackError40,
    feedbackError30: $52d4442770cfd938$var$feedbackError30,
    feedbackError20: $52d4442770cfd938$var$feedbackError20,
    feedbackWarning80: $52d4442770cfd938$var$feedbackWarning80,
    feedbackWarning70: $52d4442770cfd938$var$feedbackWarning70,
    feedbackWarning60: $52d4442770cfd938$var$feedbackWarning60,
    feedbackWarning50: $52d4442770cfd938$var$feedbackWarning50,
    feedbackWarning40: $52d4442770cfd938$var$feedbackWarning40,
    feedbackWarning30: $52d4442770cfd938$var$feedbackWarning30,
    feedbackWarning20: $52d4442770cfd938$var$feedbackWarning20,
    feedbackSuccess80: $52d4442770cfd938$var$feedbackSuccess80,
    feedbackSuccess70: $52d4442770cfd938$var$feedbackSuccess70,
    feedbackSuccess60: $52d4442770cfd938$var$feedbackSuccess60,
    feedbackSuccess50: $52d4442770cfd938$var$feedbackSuccess50,
    feedbackSuccess40: $52d4442770cfd938$var$feedbackSuccess40,
    feedbackSuccess30: $52d4442770cfd938$var$feedbackSuccess30,
    feedbackSuccess20: $52d4442770cfd938$var$feedbackSuccess20,
    "color.bold.crimson_midnight.20": "#f98ba133",
    "color.bold.crimson_midnight.30": "#f98ba166",
    "color.bold.crimson_midnight.40": "#f98ba199",
    "color.bold.crimson_midnight.50": "#f98ba1ff",
    "color.bold.crimson_midnight.60": "#fbb7c0ff",
    "color.bold.crimson_midnight.70": "#fdd2d8ff",
    "color.bold.crimson_midnight.80": "#feecefff",
    "color.bold.crimson_midnight.inverse": "#38000cff",
    "color.bold.crimson_midnight.background": "#700017ff",
    "color.bold.crimson_midnight.grey.100": "#ffffffff",
    "color.bold.crimson_midnight.grey.80": "#ffffffc7",
    "color.bold.crimson_midnight.grey.60": "#ffffff87",
    "color.bold.crimson_midnight.grey.40": "#ffffff4f",
    "color.bold.crimson_midnight.grey.20": "#ffffff1f",
    "color.dark.crimson_midnight.20": "#3a0611ff",
    "color.dark.crimson_midnight.30": "#600a1cff",
    "color.dark.crimson_midnight.40": "#870f28ff",
    "color.dark.crimson_midnight.50": "#c11539ff",
    "color.dark.crimson_midnight.60": "#d45b74ff",
    "color.dark.crimson_midnight.70": "#e396a6ff",
    "color.dark.crimson_midnight.80": "#f3d0d7ff",
    "color.dark.crimson_midnight.inverse": "#ffffffff",
    "color.dark.crimson_midnight.background": "#141414ff",
    "color.dark.crimson_midnight.grey.100": "#ffffffff",
    "color.dark.crimson_midnight.grey.80": "#ffffffc7",
    "color.dark.crimson_midnight.grey.60": "#a1a1a1ff",
    "color.dark.crimson_midnight.grey.40": "#5a5a5aff",
    "color.dark.crimson_midnight.grey.20": "#2b2b2bff",
    "color.light.crimson_midnight.20": "#f7e5e9ff",
    "color.light.crimson_midnight.30": "#f98ba1ff",
    "color.light.crimson_midnight.40": "#aa0023ff",
    "color.light.crimson_midnight.50": "#700017ff",
    "color.light.crimson_midnight.60": "#4e0010ff",
    "color.light.crimson_midnight.70": "#38000cff",
    "color.light.crimson_midnight.80": "#220007ff",
    "color.light.crimson_midnight.inverse": "#ffffffff",
    "color.light.crimson_midnight.background": "#ffffffff",
    "color.light.crimson_midnight.grey.100": "#141414ff",
    "color.light.crimson_midnight.grey.80": "#000000a6",
    "color.light.crimson_midnight.grey.60": "#b5b5b5ff",
    "color.light.crimson_midnight.grey.40": "#e0e0e0ff",
    "color.light.crimson_midnight.grey.20": "#f5f5f5ff",
    "color.bold.crimson.20": "#f98ba133",
    "color.bold.crimson.30": "#f98ba166",
    "color.bold.crimson.40": "#f98ba199",
    "color.bold.crimson.50": "#f98ba1ff",
    "color.bold.crimson.60": "#fbc0cbff",
    "color.bold.crimson.70": "#fddae1ff",
    "color.bold.crimson.80": "#feedf0ff",
    "color.bold.crimson.inverse": "#4d0010ff",
    "color.bold.crimson.background": "#aa0023ff",
    "color.bold.crimson.grey.100": "#ffffffff",
    "color.bold.crimson.grey.80": "#ffffffc7",
    "color.bold.crimson.grey.60": "#ffffff87",
    "color.bold.crimson.grey.40": "#ffffff4f",
    "color.bold.crimson.grey.20": "#ffffff1f",
    "color.dark.crimson.20": "#3a0611ff",
    "color.dark.crimson.30": "#600a1cff",
    "color.dark.crimson.40": "#870f28ff",
    "color.dark.crimson.50": "#c11539ff",
    "color.dark.crimson.60": "#d45b74ff",
    "color.dark.crimson.70": "#e396a6ff",
    "color.dark.crimson.80": "#f3d0d7ff",
    "color.dark.crimson.inverse": "#ffffffff",
    "color.dark.crimson.background": "#141414ff",
    "color.dark.crimson.grey.100": "#ffffffff",
    "color.dark.crimson.grey.80": "#ffffffc7",
    "color.dark.crimson.grey.60": "#a1a1a1ff",
    "color.dark.crimson.grey.40": "#5a5a5aff",
    "color.dark.crimson.grey.20": "#2b2b2bff",
    "color.light.crimson.20": "#f7e5e9ff",
    "color.light.crimson.30": "#f98ba1ff",
    "color.light.crimson.40": "#ed617fff",
    "color.light.crimson.50": "#aa0023ff",
    "color.light.crimson.60": "#700017ff",
    "color.light.crimson.70": "#4d0010ff",
    "color.light.crimson.80": "#2a0009ff",
    "color.light.crimson.inverse": "#ffffffff",
    "color.light.crimson.background": "#ffffffff",
    "color.light.crimson.grey.100": "#141414ff",
    "color.light.crimson.grey.80": "#000000a6",
    "color.light.crimson.grey.60": "#b5b5b5ff",
    "color.light.crimson.grey.40": "#e0e0e0ff",
    "color.light.crimson.grey.20": "#f5f5f5ff",
    "color.bold.green_midnight.20": "#94f6c533",
    "color.bold.green_midnight.30": "#94f6c566",
    "color.bold.green_midnight.40": "#94f6c599",
    "color.bold.green_midnight.50": "#94f6c5ff",
    "color.bold.green_midnight.60": "#c5fadfff",
    "color.bold.green_midnight.70": "#dcfcebff",
    "color.bold.green_midnight.80": "#f3fef8ff",
    "color.bold.green_midnight.inverse": "#013a1eff",
    "color.bold.green_midnight.background": "#03753cff",
    "color.bold.green_midnight.grey.100": "#ffffffff",
    "color.bold.green_midnight.grey.80": "#ffffffd4",
    "color.bold.green_midnight.grey.60": "#ffffff87",
    "color.bold.green_midnight.grey.40": "#ffffff4f",
    "color.bold.green_midnight.grey.20": "#ffffff1f",
    "color.dark.green_midnight.20": "#06371fff",
    "color.dark.green_midnight.30": "#0a5c33ff",
    "color.dark.green_midnight.40": "#0e8147ff",
    "color.dark.green_midnight.50": "#14b866ff",
    "color.dark.green_midnight.60": "#5acd94ff",
    "color.dark.green_midnight.70": "#95dfbaff",
    "color.dark.green_midnight.80": "#d0f1e0ff",
    "color.dark.green_midnight.inverse": "#06371fff",
    "color.dark.green_midnight.background": "#141414ff",
    "color.dark.green_midnight.grey.100": "#ffffffff",
    "color.dark.green_midnight.grey.80": "#ffffffc7",
    "color.dark.green_midnight.grey.60": "#a1a1a1ff",
    "color.dark.green_midnight.grey.40": "#5a5a5aff",
    "color.dark.green_midnight.grey.20": "#2b2b2bff",
    "color.light.green_midnight.20": "#e5f7eeff",
    "color.light.green_midnight.30": "#94f6c5ff",
    "color.light.green_midnight.40": "#00b259ff",
    "color.light.green_midnight.50": "#03753cff",
    "color.light.green_midnight.60": "#02522aff",
    "color.light.green_midnight.70": "#013a1eff",
    "color.light.green_midnight.80": "#012312ff",
    "color.light.green_midnight.inverse": "#ffffffff",
    "color.light.green_midnight.background": "#ffffffff",
    "color.light.green_midnight.grey.100": "#141414ff",
    "color.light.green_midnight.grey.80": "#000000a6",
    "color.light.green_midnight.grey.60": "#b5b5b5ff",
    "color.light.green_midnight.grey.40": "#e0e0e0ff",
    "color.light.green_midnight.grey.20": "#f5f5f5ff",
    "color.bold.green.20": "#00502833",
    "color.bold.green.30": "#00502866",
    "color.bold.green.40": "#00502899",
    "color.bold.green.50": "#005028ff",
    "color.bold.green.60": "#003b1dff",
    "color.bold.green.70": "#002613ff",
    "color.bold.green.80": "#00170cff",
    "color.bold.green.inverse": "#e5f7eeff",
    "color.bold.green.background": "#00b259ff",
    "color.bold.green.grey.100": "#002d16ff",
    "color.bold.green.grey.80": "#002d16e3",
    "color.bold.green.grey.60": "#002d1687",
    "color.bold.green.grey.40": "#002d164d",
    "color.bold.green.grey.20": "#002d161f",
    "color.dark.green.20": "#06371fff",
    "color.dark.green.30": "#0a5c33ff",
    "color.dark.green.40": "#0e8147ff",
    "color.dark.green.50": "#14b866ff",
    "color.dark.green.60": "#5acd94ff",
    "color.dark.green.70": "#95dfbaff",
    "color.dark.green.80": "#d0f1e0ff",
    "color.dark.green.inverse": "#06371fff",
    "color.dark.green.background": "#141414ff",
    "color.dark.green.grey.100": "#ffffffff",
    "color.dark.green.grey.80": "#ffffffc7",
    "color.dark.green.grey.60": "#a1a1a1ff",
    "color.dark.green.grey.40": "#5a5a5aff",
    "color.dark.green.grey.20": "#2b2b2bff",
    "color.light.green.20": "#e5f7eeff",
    "color.light.green.30": "#94f6c5ff",
    "color.light.green.40": "#10d974ff",
    "color.light.green.50": "#00b259ff",
    "color.light.green.60": "#03753cff",
    "color.light.green.70": "#005028ff",
    "color.light.green.80": "#002d16ff",
    "color.light.green.inverse": "#002d16ff",
    "color.light.green.background": "#ffffffff",
    "color.light.green.grey.100": "#141414ff",
    "color.light.green.grey.80": "#000000a6",
    "color.light.green.grey.60": "#b5b5b5ff",
    "color.light.green.grey.40": "#e0e0e0ff",
    "color.light.green.grey.20": "#f5f5f5ff",
    "color.bold.marigold_midnight.20": "#ffe3ae33",
    "color.bold.marigold_midnight.30": "#ffe3ae66",
    "color.bold.marigold_midnight.40": "#ffe3ae99",
    "color.bold.marigold_midnight.50": "#ffe3aeff",
    "color.bold.marigold_midnight.60": "#ffffffff",
    "color.bold.marigold_midnight.70": "#ffffffff",
    "color.bold.marigold_midnight.80": "#ffffffff",
    "color.bold.marigold_midnight.inverse": "#401d0cff",
    "color.bold.marigold_midnight.background": "#ac660cff",
    "color.bold.marigold_midnight.grey.100": "#ffffffff",
    "color.bold.marigold_midnight.grey.80": "#ffffffff",
    "color.bold.marigold_midnight.grey.60": "#ffffff87",
    "color.bold.marigold_midnight.grey.40": "#ffffff4f",
    "color.bold.marigold_midnight.grey.20": "#ffffff1f",
    "color.dark.marigold_midnight.20": "#3c2e16ff",
    "color.dark.marigold_midnight.30": "#675228ff",
    "color.dark.marigold_midnight.40": "#8d713aff",
    "color.dark.marigold_midnight.50": "#f9be53ff",
    "color.dark.marigold_midnight.60": "#fbd187ff",
    "color.dark.marigold_midnight.70": "#fce2b2ff",
    "color.dark.marigold_midnight.80": "#fef2ddff",
    "color.dark.marigold_midnight.inverse": "#3c2e16ff",
    "color.dark.marigold_midnight.background": "#141414ff",
    "color.dark.marigold_midnight.grey.100": "#ffffffff",
    "color.dark.marigold_midnight.grey.80": "#ffffffc7",
    "color.dark.marigold_midnight.grey.60": "#a1a1a1ff",
    "color.dark.marigold_midnight.grey.40": "#5a5a5aff",
    "color.dark.marigold_midnight.grey.20": "#2b2b2bff",
    "color.light.marigold_midnight.20": "#fef7e9ff",
    "color.light.marigold_midnight.30": "#ffe3aeff",
    "color.light.marigold_midnight.40": "#ffd947ff",
    "color.light.marigold_midnight.50": "#ac660cff",
    "color.light.marigold_midnight.60": "#7f4b10ff",
    "color.light.marigold_midnight.70": "#401d0cff",
    "color.light.marigold_midnight.80": "#341709ff",
    "color.light.marigold_midnight.inverse": "#ffffffff",
    "color.light.marigold_midnight.background": "#ffffffff",
    "color.light.marigold_midnight.grey.100": "#141414ff",
    "color.light.marigold_midnight.grey.80": "#000000a6",
    "color.light.marigold_midnight.grey.60": "#b5b5b5ff",
    "color.light.marigold_midnight.grey.40": "#e0e0e0ff",
    "color.light.marigold_midnight.grey.20": "#f5f5f5ff",
    "color.bold.marigold.20": "#92551b33",
    "color.bold.marigold.30": "#92551b66",
    "color.bold.marigold.40": "#92551b99",
    "color.bold.marigold.50": "#8a3200ff",
    "color.bold.marigold.60": "#5e2200ff",
    "color.bold.marigold.70": "#3d1600ff",
    "color.bold.marigold.80": "#2e1100ff",
    "color.bold.marigold.inverse": "#fef7e9ff",
    "color.bold.marigold.background": "#f7ab20ff",
    "color.bold.marigold.grey.100": "#401d0cff",
    "color.bold.marigold.grey.80": "#401d0cc7",
    "color.bold.marigold.grey.60": "#401d0c87",
    "color.bold.marigold.grey.40": "#401d0c4d",
    "color.bold.marigold.grey.20": "#401d0c1f",
    "color.dark.marigold.20": "#3c2e16ff",
    "color.dark.marigold.30": "#675228ff",
    "color.dark.marigold.40": "#8d713aff",
    "color.dark.marigold.50": "#f9be53ff",
    "color.dark.marigold.60": "#fbd187ff",
    "color.dark.marigold.70": "#fce2b2ff",
    "color.dark.marigold.80": "#fef2ddff",
    "color.dark.marigold.inverse": "#3c2e16ff",
    "color.dark.marigold.background": "#141414ff",
    "color.dark.marigold.grey.100": "#ffffffff",
    "color.dark.marigold.grey.80": "#ffffffc7",
    "color.dark.marigold.grey.60": "#a1a1a1ff",
    "color.dark.marigold.grey.40": "#5a5a5aff",
    "color.dark.marigold.grey.20": "#2b2b2bff",
    "color.light.marigold.20": "#fef7e9ff",
    "color.light.marigold.30": "#ffe3aeff",
    "color.light.marigold.40": "#ffd947ff",
    "color.light.marigold.50": "#f7ab20ff",
    "color.light.marigold.60": "#ac660cff",
    "color.light.marigold.70": "#7f4b10ff",
    "color.light.marigold.80": "#401d0cff",
    "color.light.marigold.inverse": "#401d0cff",
    "color.light.marigold.background": "#ffffffff",
    "color.light.marigold.grey.100": "#141414ff",
    "color.light.marigold.grey.80": "#000000a6",
    "color.light.marigold.grey.60": "#b5b5b5ff",
    "color.light.marigold.grey.40": "#e0e0e0ff",
    "color.light.marigold.grey.20": "#f5f5f5ff",
    "color.bold.mint_midnight.20": "#a7f6e933",
    "color.bold.mint_midnight.30": "#a7f6e966",
    "color.bold.mint_midnight.40": "#a7f6e999",
    "color.bold.mint_midnight.50": "#a7f6e9ff",
    "color.bold.mint_midnight.60": "#c9f9f1ff",
    "color.bold.mint_midnight.70": "#e0fcf7ff",
    "color.bold.mint_midnight.80": "#f3fefcff",
    "color.bold.mint_midnight.inverse": "#0f3e3aff",
    "color.bold.mint_midnight.background": "#1e7b74ff",
    "color.bold.mint_midnight.grey.100": "#ffffffff",
    "color.bold.mint_midnight.grey.80": "#ffffffe8",
    "color.bold.mint_midnight.grey.60": "#ffffff87",
    "color.bold.mint_midnight.grey.40": "#ffffff4f",
    "color.bold.mint_midnight.grey.20": "#ffffff1f",
    "color.dark.mint_midnight.20": "#1a413bff",
    "color.dark.mint_midnight.30": "#245a51ff",
    "color.dark.mint_midnight.40": "#348376ff",
    "color.dark.mint_midnight.50": "#58dac5ff",
    "color.dark.mint_midnight.60": "#8ae5d6ff",
    "color.dark.mint_midnight.70": "#b4eee5ff",
    "color.dark.mint_midnight.80": "#def8f3ff",
    "color.dark.mint_midnight.inverse": "#1a413bff",
    "color.dark.mint_midnight.background": "#141414ff",
    "color.dark.mint_midnight.grey.100": "#ffffffff",
    "color.dark.mint_midnight.grey.80": "#ffffffc7",
    "color.dark.mint_midnight.grey.60": "#a1a1a1ff",
    "color.dark.mint_midnight.grey.40": "#5a5a5aff",
    "color.dark.mint_midnight.grey.20": "#2b2b2bff",
    "color.light.mint_midnight.20": "#e8faf7ff",
    "color.light.mint_midnight.30": "#a7f6e9ff",
    "color.light.mint_midnight.40": "#1eccb0ff",
    "color.light.mint_midnight.50": "#1e7b74ff",
    "color.light.mint_midnight.60": "#155651ff",
    "color.light.mint_midnight.70": "#0f3e3aff",
    "color.light.mint_midnight.80": "#092523ff",
    "color.light.mint_midnight.inverse": "#ffffffff",
    "color.light.mint_midnight.background": "#ffffffff",
    "color.light.mint_midnight.grey.100": "#141414ff",
    "color.light.mint_midnight.grey.80": "#000000a6",
    "color.light.mint_midnight.grey.60": "#b5b5b5ff",
    "color.light.mint_midnight.grey.40": "#e0e0e0ff",
    "color.light.mint_midnight.grey.20": "#f5f5f5ff",
    "color.bold.mint.20": "#0e5c4f33",
    "color.bold.mint.30": "#0e5c4f66",
    "color.bold.mint.40": "#0e5c4f99",
    "color.bold.mint.50": "#0e5c4fff",
    "color.bold.mint.60": "#0a493fff",
    "color.bold.mint.70": "#07362eff",
    "color.bold.mint.80": "#052923ff",
    "color.bold.mint.inverse": "#e8faf7ff",
    "color.bold.mint.background": "#1eccb0ff",
    "color.bold.mint.grey.100": "#08332cff",
    "color.bold.mint.grey.80": "#08332ccf",
    "color.bold.mint.grey.60": "#08332c87",
    "color.bold.mint.grey.40": "#08332c4d",
    "color.bold.mint.grey.20": "#08332c1f",
    "color.dark.mint.20": "#1a413bff",
    "color.dark.mint.30": "#245a51ff",
    "color.dark.mint.40": "#348376ff",
    "color.dark.mint.50": "#58dac5ff",
    "color.dark.mint.60": "#8ae5d6ff",
    "color.dark.mint.70": "#b4eee5ff",
    "color.dark.mint.80": "#def8f3ff",
    "color.dark.mint.inverse": "#1a413bff",
    "color.dark.mint.background": "#141414ff",
    "color.dark.mint.grey.100": "#ffffffff",
    "color.dark.mint.grey.80": "#ffffffc7",
    "color.dark.mint.grey.60": "#a1a1a1ff",
    "color.dark.mint.grey.40": "#5a5a5aff",
    "color.dark.mint.grey.20": "#2b2b2bff",
    "color.light.mint.20": "#e8faf7ff",
    "color.light.mint.30": "#a7f6e9ff",
    "color.light.mint.40": "#7aebd9ff",
    "color.light.mint.50": "#1eccb0ff",
    "color.light.mint.60": "#1e7b74ff",
    "color.light.mint.70": "#0e5c4fff",
    "color.light.mint.80": "#08332cff",
    "color.light.mint.inverse": "#08332cff",
    "color.light.mint.background": "#ffffffff",
    "color.light.mint.grey.100": "#141414ff",
    "color.light.mint.grey.80": "#000000a6",
    "color.light.mint.grey.60": "#b5b5b5ff",
    "color.light.mint.grey.40": "#e0e0e0ff",
    "color.light.mint.grey.20": "#f5f5f5ff",
    "color.bold.navi_midnight.20": "#9999ff33",
    "color.bold.navi_midnight.30": "#9999ff66",
    "color.bold.navi_midnight.40": "#9999ff99",
    "color.bold.navi_midnight.50": "#9999ffff",
    "color.bold.navi_midnight.60": "#b9b9ffff",
    "color.bold.navi_midnight.70": "#ddddffff",
    "color.bold.navi_midnight.80": "#ffffffff",
    "color.bold.navi_midnight.inverse": "#00004aff",
    "color.bold.navi_midnight.background": "#000093ff",
    "color.bold.navi_midnight.grey.100": "#ffffffff",
    "color.bold.navi_midnight.grey.80": "#ffffffc7",
    "color.bold.navi_midnight.grey.60": "#ffffff87",
    "color.bold.navi_midnight.grey.40": "#ffffff4f",
    "color.bold.navi_midnight.grey.20": "#ffffff1f",
    "color.dark.navi_midnight.20": "#16164bff",
    "color.dark.navi_midnight.30": "#24247dff",
    "color.dark.navi_midnight.40": "#3232aeff",
    "color.dark.navi_midnight.50": "#4848f9ff",
    "color.dark.navi_midnight.60": "#7f7ffbff",
    "color.dark.navi_midnight.70": "#adadfcff",
    "color.dark.navi_midnight.80": "#dadafeff",
    "color.dark.navi_midnight.inverse": "#ffffffff",
    "color.dark.navi_midnight.background": "#141414ff",
    "color.dark.navi_midnight.grey.100": "#ffffffff",
    "color.dark.navi_midnight.grey.80": "#ffffffc7",
    "color.dark.navi_midnight.grey.60": "#a1a1a1ff",
    "color.dark.navi_midnight.grey.40": "#5a5a5aff",
    "color.dark.navi_midnight.grey.20": "#2b2b2bff",
    "color.light.navi_midnight.20": "#e8e8fcff",
    "color.light.navi_midnight.30": "#9999ffff",
    "color.light.navi_midnight.40": "#3535f3ff",
    "color.light.navi_midnight.50": "#000093ff",
    "color.light.navi_midnight.60": "#000067ff",
    "color.light.navi_midnight.70": "#00004aff",
    "color.light.navi_midnight.80": "#00002cff",
    "color.light.navi_midnight.inverse": "#ffffffff",
    "color.light.navi_midnight.background": "#ffffffff",
    "color.light.navi_midnight.grey.100": "#141414ff",
    "color.light.navi_midnight.grey.80": "#000000a6",
    "color.light.navi_midnight.grey.60": "#b5b5b5ff",
    "color.light.navi_midnight.grey.40": "#e0e0e0ff",
    "color.light.navi_midnight.grey.20": "#f5f5f5ff",
    "color.bold.navi.20": "#9999ff33",
    "color.bold.navi.30": "#9999ff66",
    "color.bold.navi.40": "#9999ff99",
    "color.bold.navi.50": "#9999ffff",
    "color.bold.navi.60": "#ceceffff",
    "color.bold.navi.70": "#ddddffff",
    "color.bold.navi.80": "#fafaffff",
    "color.bold.navi.inverse": "#00004cff",
    "color.bold.navi.background": "#3535f3ff",
    "color.bold.navi.grey.100": "#ffffffff",
    "color.bold.navi.grey.80": "#ffffffc7",
    "color.bold.navi.grey.60": "#ffffff87",
    "color.bold.navi.grey.40": "#ffffff4f",
    "color.bold.navi.grey.20": "#ffffff1f",
    "color.dark.navi.20": "#16164bff",
    "color.dark.navi.30": "#24247dff",
    "color.dark.navi.40": "#3232aeff",
    "color.dark.navi.50": "#4848f9ff",
    "color.dark.navi.60": "#7f7ffbff",
    "color.dark.navi.70": "#adadfcff",
    "color.dark.navi.80": "#dadafeff",
    "color.dark.navi.inverse": "#ffffffff",
    "color.dark.navi.background": "#141414ff",
    "color.dark.navi.grey.100": "#ffffffff",
    "color.dark.navi.grey.80": "#ffffffc7",
    "color.dark.navi.grey.60": "#a1a1a1ff",
    "color.dark.navi.grey.40": "#5a5a5aff",
    "color.dark.navi.grey.20": "#2b2b2bff",
    "color.light.navi.20": "#e8e8fcff",
    "color.light.navi.30": "#9999ffff",
    "color.light.navi.40": "#6464ffff",
    "color.light.navi.50": "#3535f3ff",
    "color.light.navi.60": "#000093ff",
    "color.light.navi.70": "#00004cff",
    "color.light.navi.80": "#010029ff",
    "color.light.navi.inverse": "#ffffffff",
    "color.light.navi.background": "#ffffffff",
    "color.light.navi.grey.100": "#141414ff",
    "color.light.navi.grey.80": "#000000a6",
    "color.light.navi.grey.60": "#b5b5b5ff",
    "color.light.navi.grey.40": "#e0e0e0ff",
    "color.light.navi.grey.20": "#f5f5f5ff",
    "color.bold.orange_midnight.20": "#ffd2ad33",
    "color.bold.orange_midnight.30": "#ffd2ad66",
    "color.bold.orange_midnight.40": "#ffd2ad99",
    "color.bold.orange_midnight.50": "#ffd2adff",
    "color.bold.orange_midnight.60": "#ffead9ff",
    "color.bold.orange_midnight.70": "#fff5eeff",
    "color.bold.orange_midnight.80": "#ffffffff",
    "color.bold.orange_midnight.inverse": "#661f00ff",
    "color.bold.orange_midnight.background": "#cd3d00ff",
    "color.bold.orange_midnight.grey.100": "#ffffffff",
    "color.bold.orange_midnight.grey.80": "#fffffffc",
    "color.bold.orange_midnight.grey.60": "#ffffff87",
    "color.bold.orange_midnight.grey.40": "#ffffff4f",
    "color.bold.orange_midnight.grey.20": "#ffffff1f",
    "color.dark.orange_midnight.20": "#492b13ff",
    "color.dark.orange_midnight.30": "#7a471fff",
    "color.dark.orange_midnight.40": "#ab642bff",
    "color.dark.orange_midnight.50": "#f48f3eff",
    "color.dark.orange_midnight.60": "#f7b178ff",
    "color.dark.orange_midnight.70": "#facda8ff",
    "color.dark.orange_midnight.80": "#fde9d8ff",
    "color.dark.orange_midnight.inverse": "#492b13ff",
    "color.dark.orange_midnight.background": "#141414ff",
    "color.dark.orange_midnight.grey.100": "#ffffffff",
    "color.dark.orange_midnight.grey.80": "#ffffffc7",
    "color.dark.orange_midnight.grey.60": "#a1a1a1ff",
    "color.dark.orange_midnight.grey.40": "#5a5a5aff",
    "color.dark.orange_midnight.grey.20": "#2b2b2bff",
    "color.light.orange_midnight.20": "#fef2e9ff",
    "color.light.orange_midnight.30": "#ffd2adff",
    "color.light.orange_midnight.40": "#fa7d19ff",
    "color.light.orange_midnight.50": "#cd3d00ff",
    "color.light.orange_midnight.60": "#902b00ff",
    "color.light.orange_midnight.70": "#661f00ff",
    "color.light.orange_midnight.80": "#3d1200ff",
    "color.light.orange_midnight.inverse": "#ffffffff",
    "color.light.orange_midnight.background": "#ffffffff",
    "color.light.orange_midnight.grey.100": "#141414ff",
    "color.light.orange_midnight.grey.80": "#000000a6",
    "color.light.orange_midnight.grey.60": "#b5b5b5ff",
    "color.light.orange_midnight.grey.40": "#e0e0e0ff",
    "color.light.orange_midnight.grey.20": "#f5f5f5ff",
    "color.bold.orange.20": "#7b160433",
    "color.bold.orange.30": "#7b160466",
    "color.bold.orange.40": "#7b160499",
    "color.bold.orange.50": "#7b1604ff",
    "color.bold.orange.60": "#5c1700ff",
    "color.bold.orange.70": "#3d0f00ff",
    "color.bold.orange.80": "#2e0b00ff",
    "color.bold.orange.inverse": "#fef2e9ff",
    "color.bold.orange.background": "#fa7d19ff",
    "color.bold.orange.grey.100": "#46070bff",
    "color.bold.orange.grey.80": "#46070bcf",
    "color.bold.orange.grey.60": "#46070b87",
    "color.bold.orange.grey.40": "#46070b4f",
    "color.bold.orange.grey.20": "#46070b33",
    "color.dark.orange.20": "#492b13ff",
    "color.dark.orange.30": "#7a471fff",
    "color.dark.orange.40": "#ab642bff",
    "color.dark.orange.50": "#f48f3eff",
    "color.dark.orange.60": "#f7b178ff",
    "color.dark.orange.70": "#facda8ff",
    "color.dark.orange.80": "#fde9d8ff",
    "color.dark.orange.inverse": "#492b13ff",
    "color.dark.orange.background": "#141414ff",
    "color.dark.orange.grey.100": "#ffffffff",
    "color.dark.orange.grey.80": "#ffffffc7",
    "color.dark.orange.grey.60": "#a1a1a1ff",
    "color.dark.orange.grey.40": "#5a5a5aff",
    "color.dark.orange.grey.20": "#2b2b2bff",
    "color.light.orange.20": "#fef2e9ff",
    "color.light.orange.30": "#ffd2adff",
    "color.light.orange.40": "#ffaa66ff",
    "color.light.orange.50": "#fa7d19ff",
    "color.light.orange.60": "#cd3d00ff",
    "color.light.orange.70": "#7b1604ff",
    "color.light.orange.80": "#46070bff",
    "color.light.orange.inverse": "#46070bff",
    "color.light.orange.background": "#ffffffff",
    "color.light.orange.grey.100": "#141414ff",
    "color.light.orange.grey.80": "#000000a6",
    "color.light.orange.grey.60": "#b5b5b5ff",
    "color.light.orange.grey.40": "#e0e0e0ff",
    "color.light.orange.grey.20": "#f5f5f5ff",
    "color.bold.pink_midnight.20": "#ff99db33",
    "color.bold.pink_midnight.30": "#ff99db66",
    "color.bold.pink_midnight.40": "#ff99db99",
    "color.bold.pink_midnight.50": "#ff99dbff",
    "color.bold.pink_midnight.60": "#ffbfe9ff",
    "color.bold.pink_midnight.70": "#ffeaf8ff",
    "color.bold.pink_midnight.80": "#fff6fcff",
    "color.bold.pink_midnight.inverse": "#47002fff",
    "color.bold.pink_midnight.background": "#8f005dff",
    "color.bold.pink_midnight.grey.100": "#ffffffff",
    "color.bold.pink_midnight.grey.80": "#ffffffc7",
    "color.bold.pink_midnight.grey.60": "#ffffff87",
    "color.bold.pink_midnight.grey.40": "#ffffff4f",
    "color.bold.pink_midnight.grey.20": "#ffffff1f",
    "color.dark.pink_midnight.20": "#360023ff",
    "color.dark.pink_midnight.30": "#62003fff",
    "color.dark.pink_midnight.40": "#8f005dff",
    "color.dark.pink_midnight.50": "#d9008dff",
    "color.dark.pink_midnight.60": "#ff6dccff",
    "color.dark.pink_midnight.70": "#ff99dbff",
    "color.dark.pink_midnight.80": "#fbe5f4ff",
    "color.dark.pink_midnight.inverse": "#ffffffff",
    "color.dark.pink_midnight.background": "#141414ff",
    "color.dark.pink_midnight.grey.100": "#ffffffff",
    "color.dark.pink_midnight.grey.80": "#ffffffc7",
    "color.dark.pink_midnight.grey.60": "#a1a1a1ff",
    "color.dark.pink_midnight.grey.40": "#5a5a5aff",
    "color.dark.pink_midnight.grey.20": "#2b2b2bff",
    "color.light.pink_midnight.20": "#fbe5f4ff",
    "color.light.pink_midnight.30": "#ff99dbff",
    "color.light.pink_midnight.40": "#d9008dff",
    "color.light.pink_midnight.50": "#8f005dff",
    "color.light.pink_midnight.60": "#640041ff",
    "color.light.pink_midnight.70": "#47002fff",
    "color.light.pink_midnight.80": "#2b001cff",
    "color.light.pink_midnight.inverse": "#ffffffff",
    "color.light.pink_midnight.background": "#ffffffff",
    "color.light.pink_midnight.grey.100": "#141414ff",
    "color.light.pink_midnight.grey.80": "#000000a6",
    "color.light.pink_midnight.grey.60": "#b5b5b5ff",
    "color.light.pink_midnight.grey.40": "#e0e0e0ff",
    "color.light.pink_midnight.grey.20": "#f5f5f5ff",
    "color.bold.pink.20": "#ff99db33",
    "color.bold.pink.30": "#ff99db66",
    "color.bold.pink.40": "#ff99db99",
    "color.bold.pink.50": "#ff99dbff",
    "color.bold.pink.60": "#fff7fcff",
    "color.bold.pink.70": "#ffffffff",
    "color.bold.pink.80": "#ffffffff",
    "color.bold.pink.inverse": "#62003fff",
    "color.bold.pink.background": "#d9008dff",
    "color.bold.pink.grey.100": "#ffffffff",
    "color.bold.pink.grey.80": "#fffffff5",
    "color.bold.pink.grey.60": "#ffffff87",
    "color.bold.pink.grey.40": "#ffffff4f",
    "color.bold.pink.grey.20": "#ffffff1f",
    "color.dark.pink.20": "#360023ff",
    "color.dark.pink.30": "#62003fff",
    "color.dark.pink.40": "#8f005dff",
    "color.dark.pink.50": "#d9008dff",
    "color.dark.pink.60": "#ff6dccff",
    "color.dark.pink.70": "#ff99dbff",
    "color.dark.pink.80": "#fbe5f4ff",
    "color.dark.pink.inverse": "#ffffffff",
    "color.dark.pink.background": "#141414ff",
    "color.dark.pink.grey.100": "#ffffffff",
    "color.dark.pink.grey.80": "#ffffffc7",
    "color.dark.pink.grey.60": "#a1a1a1ff",
    "color.dark.pink.grey.40": "#5a5a5aff",
    "color.dark.pink.grey.20": "#2b2b2bff",
    "color.light.pink.20": "#fbe5f4ff",
    "color.light.pink.30": "#ff99dbff",
    "color.light.pink.40": "#ff6dccff",
    "color.light.pink.50": "#d9008dff",
    "color.light.pink.60": "#8f005dff",
    "color.light.pink.70": "#62003fff",
    "color.light.pink.80": "#360023ff",
    "color.light.pink.inverse": "#ffffffff",
    "color.light.pink.background": "#ffffffff",
    "color.light.pink.grey.100": "#141414ff",
    "color.light.pink.grey.80": "#000000a6",
    "color.light.pink.grey.60": "#b5b5b5ff",
    "color.light.pink.grey.40": "#e0e0e0ff",
    "color.light.pink.grey.20": "#f5f5f5ff",
    "color.bold.purple_midnight.20": "#cba2fa33",
    "color.bold.purple_midnight.30": "#cba2fa66",
    "color.bold.purple_midnight.40": "#cba2fa99",
    "color.bold.purple_midnight.50": "#cba2faff",
    "color.bold.purple_midnight.60": "#e4cffcff",
    "color.bold.purple_midnight.70": "#eee1fdff",
    "color.bold.purple_midnight.80": "#fbf9ffff",
    "color.bold.purple_midnight.inverse": "#1f0042ff",
    "color.bold.purple_midnight.background": "#3e0084ff",
    "color.bold.purple_midnight.grey.100": "#ffffffff",
    "color.bold.purple_midnight.grey.80": "#ffffffc7",
    "color.bold.purple_midnight.grey.60": "#ffffff87",
    "color.bold.purple_midnight.grey.40": "#ffffff4f",
    "color.bold.purple_midnight.grey.20": "#ffffff1f",
    "color.dark.purple_midnight.20": "#281240ff",
    "color.dark.purple_midnight.30": "#421f6bff",
    "color.dark.purple_midnight.40": "#5d2b96ff",
    "color.dark.purple_midnight.50": "#853dd6ff",
    "color.dark.purple_midnight.60": "#aa77e2ff",
    "color.dark.purple_midnight.70": "#c8a8edff",
    "color.dark.purple_midnight.80": "#e7d8f7ff",
    "color.dark.purple_midnight.inverse": "#ffffffff",
    "color.dark.purple_midnight.background": "#141414ff",
    "color.dark.purple_midnight.grey.100": "#ffffffff",
    "color.dark.purple_midnight.grey.80": "#ffffffc7",
    "color.dark.purple_midnight.grey.60": "#a1a1a1ff",
    "color.dark.purple_midnight.grey.40": "#5a5a5aff",
    "color.dark.purple_midnight.grey.20": "#2b2b2bff",
    "color.light.purple_midnight.20": "#f0e8faff",
    "color.light.purple_midnight.30": "#cba2faff",
    "color.light.purple_midnight.40": "#6d17ceff",
    "color.light.purple_midnight.50": "#3e0084ff",
    "color.light.purple_midnight.60": "#2b005cff",
    "color.light.purple_midnight.70": "#1f0042ff",
    "color.light.purple_midnight.80": "#130028ff",
    "color.light.purple_midnight.inverse": "#ffffffff",
    "color.light.purple_midnight.background": "#ffffffff",
    "color.light.purple_midnight.grey.100": "#141414ff",
    "color.light.purple_midnight.grey.80": "#000000a6",
    "color.light.purple_midnight.grey.60": "#b5b5b5ff",
    "color.light.purple_midnight.grey.40": "#e0e0e0ff",
    "color.light.purple_midnight.grey.20": "#f5f5f5ff",
    "color.bold.purple.20": "#cba2fa33",
    "color.bold.purple.30": "#cba2fa66",
    "color.bold.purple.40": "#cba2fa99",
    "color.bold.purple.50": "#cba2faff",
    "color.bold.purple.60": "#dbbefbff",
    "color.bold.purple.70": "#e4cffcff",
    "color.bold.purple.80": "#ecddfdff",
    "color.bold.purple.inverse": "#310a5dff",
    "color.bold.purple.background": "#6d17ceff",
    "color.bold.purple.grey.100": "#ffffffff",
    "color.bold.purple.grey.80": "#ffffffc7",
    "color.bold.purple.grey.60": "#ffffff87",
    "color.bold.purple.grey.40": "#ffffff4f",
    "color.bold.purple.grey.20": "#ffffff1f",
    "color.dark.purple.20": "#281240ff",
    "color.dark.purple.30": "#421f6bff",
    "color.dark.purple.40": "#5d2b96ff",
    "color.dark.purple.50": "#853dd6ff",
    "color.dark.purple.60": "#aa77e2ff",
    "color.dark.purple.70": "#c8a8edff",
    "color.dark.purple.80": "#e7d8f7ff",
    "color.dark.purple.inverse": "#ffffffff",
    "color.dark.purple.background": "#141414ff",
    "color.dark.purple.grey.100": "#ffffffff",
    "color.dark.purple.grey.80": "#ffffffc7",
    "color.dark.purple.grey.60": "#a1a1a1ff",
    "color.dark.purple.grey.40": "#5a5a5aff",
    "color.dark.purple.grey.20": "#2b2b2bff",
    "color.light.purple.20": "#f0e8faff",
    "color.light.purple.30": "#cba2faff",
    "color.light.purple.40": "#a680ffff",
    "color.light.purple.50": "#6d17ceff",
    "color.light.purple.60": "#3e0084ff",
    "color.light.purple.70": "#310a5dff",
    "color.light.purple.80": "#1b0633ff",
    "color.light.purple.inverse": "#ffffffff",
    "color.light.purple.background": "#ffffffff",
    "color.light.purple.grey.100": "#141414ff",
    "color.light.purple.grey.80": "#000000a6",
    "color.light.purple.grey.60": "#b5b5b5ff",
    "color.light.purple.grey.40": "#e0e0e0ff",
    "color.light.purple.grey.20": "#f5f5f5ff",
    "color.bold.red_midnight.20": "#ff9da333",
    "color.bold.red_midnight.30": "#ff9da366",
    "color.bold.red_midnight.40": "#ff9da399",
    "color.bold.red_midnight.50": "#ff9da3ff",
    "color.bold.red_midnight.60": "#ffccd1ff",
    "color.bold.red_midnight.70": "#ffe5e8ff",
    "color.bold.red_midnight.80": "#fff4f5ff",
    "color.bold.red_midnight.inverse": "#540000ff",
    "color.bold.red_midnight.background": "#a80000ff",
    "color.bold.red_midnight.grey.100": "#ffffffff",
    "color.bold.red_midnight.grey.80": "#ffffffc7",
    "color.bold.red_midnight.grey.60": "#ffffff87",
    "color.bold.red_midnight.grey.40": "#ffffff4f",
    "color.bold.red_midnight.grey.20": "#ffffff1f",
    "color.dark.red_midnight.20": "#430c10ff",
    "color.dark.red_midnight.30": "#70141aff",
    "color.dark.red_midnight.40": "#9d1d24ff",
    "color.dark.red_midnight.50": "#e02934ff",
    "color.dark.red_midnight.60": "#e96971ff",
    "color.dark.red_midnight.70": "#f19fa4ff",
    "color.dark.red_midnight.80": "#f9d4d6ff",
    "color.dark.red_midnight.inverse": "#ffffffff",
    "color.dark.red_midnight.background": "#141414ff",
    "color.dark.red_midnight.grey.100": "#ffffffff",
    "color.dark.red_midnight.grey.80": "#ffffffc7",
    "color.dark.red_midnight.grey.60": "#a1a1a1ff",
    "color.dark.red_midnight.grey.40": "#5a5a5aff",
    "color.dark.red_midnight.grey.20": "#2b2b2bff",
    "color.light.red_midnight.20": "#fce6e7ff",
    "color.light.red_midnight.30": "#ff9da3ff",
    "color.light.red_midnight.40": "#e30513ff",
    "color.light.red_midnight.50": "#a80000ff",
    "color.light.red_midnight.60": "#760000ff",
    "color.light.red_midnight.70": "#540000ff",
    "color.light.red_midnight.80": "#320000ff",
    "color.light.red_midnight.inverse": "#ffffffff",
    "color.light.red_midnight.background": "#ffffffff",
    "color.light.red_midnight.grey.100": "#141414ff",
    "color.light.red_midnight.grey.80": "#000000a6",
    "color.light.red_midnight.grey.60": "#b5b5b5ff",
    "color.light.red_midnight.grey.40": "#e0e0e0ff",
    "color.light.red_midnight.grey.20": "#f5f5f5ff",
    "color.bold.red.20": "#ff9da333",
    "color.bold.red.30": "#ff9da366",
    "color.bold.red.40": "#ff9da399",
    "color.bold.red.50": "#ff9da3ff",
    "color.bold.red.60": "#fff6f7ff",
    "color.bold.red.70": "#ffffffff",
    "color.bold.red.80": "#ffffffff",
    "color.bold.red.inverse": "#660209ff",
    "color.bold.red.background": "#e30513ff",
    "color.bold.red.grey.100": "#ffffffff",
    "color.bold.red.grey.80": "#fffffff5",
    "color.bold.red.grey.60": "#ffffff87",
    "color.bold.red.grey.40": "#ffffff4f",
    "color.bold.red.grey.20": "#ffffff1f",
    "color.dark.red.20": "#430c10ff",
    "color.dark.red.30": "#70141aff",
    "color.dark.red.40": "#9d1d24ff",
    "color.dark.red.50": "#e02934ff",
    "color.dark.red.60": "#e96971ff",
    "color.dark.red.70": "#f19fa4ff",
    "color.dark.red.80": "#f9d4d6ff",
    "color.dark.red.inverse": "#ffffffff",
    "color.dark.red.background": "#141414ff",
    "color.dark.red.grey.100": "#ffffffff",
    "color.dark.red.grey.80": "#ffffffc7",
    "color.dark.red.grey.60": "#a1a1a1ff",
    "color.dark.red.grey.40": "#5a5a5aff",
    "color.dark.red.grey.20": "#2b2b2bff",
    "color.light.red.20": "#fce6e7ff",
    "color.light.red.30": "#ff9da3ff",
    "color.light.red.40": "#fc6770ff",
    "color.light.red.50": "#e30513ff",
    "color.light.red.60": "#a80000ff",
    "color.light.red.70": "#660209ff",
    "color.light.red.80": "#390105ff",
    "color.light.red.inverse": "#ffffffff",
    "color.light.red.background": "#ffffffff",
    "color.light.red.grey.100": "#141414ff",
    "color.light.red.grey.80": "#000000a6",
    "color.light.red.grey.60": "#b5b5b5ff",
    "color.light.red.grey.40": "#e0e0e0ff",
    "color.light.red.grey.20": "#f5f5f5ff",
    "color.bold.reliance_midnight.20": "#9eb5fa33",
    "color.bold.reliance_midnight.30": "#9eb5fa66",
    "color.bold.reliance_midnight.40": "#9eb5fa99",
    "color.bold.reliance_midnight.50": "#9eb5faff",
    "color.bold.reliance_midnight.60": "#c7d4fcff",
    "color.bold.reliance_midnight.70": "#dce4fdff",
    "color.bold.reliance_midnight.80": "#f3f5feff",
    "color.bold.reliance_midnight.inverse": "#051442ff",
    "color.bold.reliance_midnight.background": "#0a2885ff",
    "color.bold.reliance_midnight.grey.100": "#ffffffff",
    "color.bold.reliance_midnight.grey.80": "#ffffffc7",
    "color.bold.reliance_midnight.grey.60": "#ffffff87",
    "color.bold.reliance_midnight.grey.40": "#ffffff4f",
    "color.bold.reliance_midnight.grey.20": "#ffffff1f",
    "color.dark.reliance_midnight.20": "#051444ff",
    "color.dark.reliance_midnight.30": "#092272ff",
    "color.dark.reliance_midnight.40": "#0c30a0ff",
    "color.dark.reliance_midnight.50": "#1144e4ff",
    "color.dark.reliance_midnight.60": "#587cecff",
    "color.dark.reliance_midnight.70": "#94abf3ff",
    "color.dark.reliance_midnight.80": "#cfdafaff",
    "color.dark.reliance_midnight.inverse": "#ffffffff",
    "color.dark.reliance_midnight.background": "#141414ff",
    "color.dark.reliance_midnight.grey.100": "#ffffffff",
    "color.dark.reliance_midnight.grey.80": "#ffffffc7",
    "color.dark.reliance_midnight.grey.60": "#a1a1a1ff",
    "color.dark.reliance_midnight.grey.40": "#5a5a5aff",
    "color.dark.reliance_midnight.grey.20": "#2b2b2bff",
    "color.light.reliance_midnight.20": "#e7ebf8ff",
    "color.light.reliance_midnight.30": "#9eb5faff",
    "color.light.reliance_midnight.40": "#0f3cc9ff",
    "color.light.reliance_midnight.50": "#0a2885ff",
    "color.light.reliance_midnight.60": "#071c5dff",
    "color.light.reliance_midnight.70": "#051442ff",
    "color.light.reliance_midnight.80": "#030c28ff",
    "color.light.reliance_midnight.inverse": "#ffffffff",
    "color.light.reliance_midnight.background": "#ffffffff",
    "color.light.reliance_midnight.grey.100": "#141414ff",
    "color.light.reliance_midnight.grey.80": "#000000a6",
    "color.light.reliance_midnight.grey.60": "#b5b5b5ff",
    "color.light.reliance_midnight.grey.40": "#e0e0e0ff",
    "color.light.reliance_midnight.grey.20": "#f5f5f5ff",
    "color.bold.reliance.20": "#9eb5fa33",
    "color.bold.reliance.30": "#9eb5fa66",
    "color.bold.reliance.40": "#9eb5fa99",
    "color.bold.reliance.50": "#9eb5faff",
    "color.bold.reliance.60": "#becefbff",
    "color.bold.reliance.70": "#d0dcfdff",
    "color.bold.reliance.80": "#e8eefeff",
    "color.bold.reliance.inverse": "#061951ff",
    "color.bold.reliance.background": "#0f3cc9ff",
    "color.bold.reliance.grey.100": "#ffffffff",
    "color.bold.reliance.grey.80": "#ffffffc7",
    "color.bold.reliance.grey.60": "#ffffff87",
    "color.bold.reliance.grey.40": "#ffffff4f",
    "color.bold.reliance.grey.20": "#ffffff1f",
    "color.dark.reliance.20": "#051444ff",
    "color.dark.reliance.30": "#092272ff",
    "color.dark.reliance.40": "#0c30a0ff",
    "color.dark.reliance.50": "#1144e4ff",
    "color.dark.reliance.60": "#587cecff",
    "color.dark.reliance.70": "#94abf3ff",
    "color.dark.reliance.80": "#cfdafaff",
    "color.dark.reliance.inverse": "#ffffffff",
    "color.dark.reliance.background": "#141414ff",
    "color.dark.reliance.grey.100": "#ffffffff",
    "color.dark.reliance.grey.80": "#ffffffc7",
    "color.dark.reliance.grey.60": "#a1a1a1ff",
    "color.dark.reliance.grey.40": "#5a5a5aff",
    "color.dark.reliance.grey.20": "#2b2b2bff",
    "color.light.reliance.20": "#e7ebf8ff",
    "color.light.reliance.30": "#9eb5faff",
    "color.light.reliance.40": "#6789f4ff",
    "color.light.reliance.50": "#0f3cc9ff",
    "color.light.reliance.60": "#0a2885ff",
    "color.light.reliance.70": "#061951ff",
    "color.light.reliance.80": "#070e21ff",
    "color.light.reliance.inverse": "#ffffffff",
    "color.light.reliance.background": "#ffffffff",
    "color.light.reliance.grey.100": "#141414ff",
    "color.light.reliance.grey.80": "#000000a6",
    "color.light.reliance.grey.60": "#b5b5b5ff",
    "color.light.reliance.grey.40": "#e0e0e0ff",
    "color.light.reliance.grey.20": "#f5f5f5ff",
    "color.bold.sky_midnight.20": "#89dcff33",
    "color.bold.sky_midnight.30": "#89dcff66",
    "color.bold.sky_midnight.40": "#89dcff99",
    "color.bold.sky_midnight.50": "#89dcffff",
    "color.bold.sky_midnight.60": "#bceaffff",
    "color.bold.sky_midnight.70": "#d4f2ffff",
    "color.bold.sky_midnight.80": "#f2fbffff",
    "color.bold.sky_midnight.inverse": "#062939ff",
    "color.bold.sky_midnight.background": "#0c5273ff",
    "color.bold.sky_midnight.grey.100": "#ffffffff",
    "color.bold.sky_midnight.grey.80": "#ffffffc7",
    "color.bold.sky_midnight.grey.60": "#ffffff87",
    "color.bold.sky_midnight.grey.40": "#ffffff4f",
    "color.bold.sky_midnight.grey.20": "#ffffff1f",
    "color.dark.sky_midnight.20": "#002b3dff",
    "color.dark.sky_midnight.30": "#004766ff",
    "color.dark.sky_midnight.40": "#00638fff",
    "color.dark.sky_midnight.50": "#007fadff",
    "color.dark.sky_midnight.60": "#4ca5c6ff",
    "color.dark.sky_midnight.70": "#8cc5daff",
    "color.dark.sky_midnight.80": "#cce5efff",
    "color.dark.sky_midnight.inverse": "#ffffffff",
    "color.dark.sky_midnight.background": "#141414ff",
    "color.dark.sky_midnight.grey.100": "#ffffffff",
    "color.dark.sky_midnight.grey.80": "#ffffffc7",
    "color.dark.sky_midnight.grey.60": "#a1a1a1ff",
    "color.dark.sky_midnight.grey.40": "#5a5a5aff",
    "color.dark.sky_midnight.grey.20": "#2b2b2bff",
    "color.light.sky_midnight.20": "#e5f1f7ff",
    "color.light.sky_midnight.30": "#89dcffff",
    "color.light.sky_midnight.40": "#0078adff",
    "color.light.sky_midnight.50": "#0c5273ff",
    "color.light.sky_midnight.60": "#083950ff",
    "color.light.sky_midnight.70": "#062939ff",
    "color.light.sky_midnight.80": "#041922ff",
    "color.light.sky_midnight.inverse": "#ffffffff",
    "color.light.sky_midnight.background": "#ffffffff",
    "color.light.sky_midnight.grey.100": "#141414ff",
    "color.light.sky_midnight.grey.80": "#000000a6",
    "color.light.sky_midnight.grey.60": "#b5b5b5ff",
    "color.light.sky_midnight.grey.40": "#e0e0e0ff",
    "color.light.sky_midnight.grey.20": "#f5f5f5ff",
    "color.bold.sky.20": "#89dcff33",
    "color.bold.sky.30": "#89dcff66",
    "color.bold.sky.40": "#89dcff99",
    "color.bold.sky.50": "#89dcffff",
    "color.bold.sky.60": "#eefaffff",
    "color.bold.sky.70": "#ffffffff",
    "color.bold.sky.80": "#ffffffff",
    "color.bold.sky.inverse": "#00364eff",
    "color.bold.sky.background": "#0078adff",
    "color.bold.sky.grey.100": "#ffffffff",
    "color.bold.sky.grey.80": "#fffffff0",
    "color.bold.sky.grey.60": "#ffffff87",
    "color.bold.sky.grey.40": "#ffffff4f",
    "color.bold.sky.grey.20": "#ffffff1f",
    "color.dark.sky.20": "#002b3dff",
    "color.dark.sky.30": "#004766ff",
    "color.dark.sky.40": "#00638fff",
    "color.dark.sky.50": "#007fadff",
    "color.dark.sky.60": "#4ca5c6ff",
    "color.dark.sky.70": "#8cc5daff",
    "color.dark.sky.80": "#cce5efff",
    "color.dark.sky.inverse": "#ffffffff",
    "color.dark.sky.background": "#141414ff",
    "color.dark.sky.grey.100": "#ffffffff",
    "color.dark.sky.grey.80": "#ffffffc7",
    "color.dark.sky.grey.60": "#a1a1a1ff",
    "color.dark.sky.grey.40": "#5a5a5aff",
    "color.dark.sky.grey.20": "#2b2b2bff",
    "color.light.sky.20": "#e5f1f7ff",
    "color.light.sky.30": "#89dcffff",
    "color.light.sky.40": "#67c3efff",
    "color.light.sky.50": "#0078adff",
    "color.light.sky.60": "#0c5273ff",
    "color.light.sky.70": "#00364eff",
    "color.light.sky.80": "#001e2bff",
    "color.light.sky.inverse": "#ffffffff",
    "color.light.sky.background": "#ffffffff",
    "color.light.sky.grey.100": "#141414ff",
    "color.light.sky.grey.80": "#000000a6",
    "color.light.sky.grey.60": "#b5b5b5ff",
    "color.light.sky.grey.40": "#e0e0e0ff",
    "color.light.sky.grey.20": "#f5f5f5ff",
    "color.bold.violet_midnight.20": "#f7a8fa33",
    "color.bold.violet_midnight.30": "#f7a8fa66",
    "color.bold.violet_midnight.40": "#f7a8fa99",
    "color.bold.violet_midnight.50": "#f7a8faff",
    "color.bold.violet_midnight.60": "#fbd1fcff",
    "color.bold.violet_midnight.70": "#fbd3fcff",
    "color.bold.violet_midnight.80": "#fef3feff",
    "color.bold.violet_midnight.inverse": "#3d0040ff",
    "color.bold.violet_midnight.background": "#79007fff",
    "color.bold.violet_midnight.grey.100": "#ffffffff",
    "color.bold.violet_midnight.grey.80": "#ffffffc7",
    "color.bold.violet_midnight.grey.60": "#ffffff87",
    "color.bold.violet_midnight.grey.40": "#ffffff4f",
    "color.bold.violet_midnight.grey.20": "#ffffff1f",
    "color.dark.violet_midnight.20": "#300d31ff",
    "color.dark.violet_midnight.30": "#571859ff",
    "color.dark.violet_midnight.40": "#79007fff",
    "color.dark.violet_midnight.50": "#c135c5ff",
    "color.dark.violet_midnight.60": "#f680f9ff",
    "color.dark.violet_midnight.70": "#f7a8faff",
    "color.dark.violet_midnight.80": "#f9ebf9ff",
    "color.dark.violet_midnight.inverse": "#ffffffff",
    "color.dark.violet_midnight.background": "#141414ff",
    "color.dark.violet_midnight.grey.100": "#ffffffff",
    "color.dark.violet_midnight.grey.80": "#ffffffc7",
    "color.dark.violet_midnight.grey.60": "#a1a1a1ff",
    "color.dark.violet_midnight.grey.40": "#5a5a5aff",
    "color.dark.violet_midnight.grey.20": "#2b2b2bff",
    "color.light.violet_midnight.20": "#f9ebf9ff",
    "color.light.violet_midnight.30": "#f7a8faff",
    "color.light.violet_midnight.40": "#c135c5ff",
    "color.light.violet_midnight.50": "#79007fff",
    "color.light.violet_midnight.60": "#550059ff",
    "color.light.violet_midnight.70": "#3d0040ff",
    "color.light.violet_midnight.80": "#240026ff",
    "color.light.violet_midnight.inverse": "#ffffffff",
    "color.light.violet_midnight.background": "#ffffffff",
    "color.light.violet_midnight.grey.100": "#141414ff",
    "color.light.violet_midnight.grey.80": "#000000a6",
    "color.light.violet_midnight.grey.60": "#b5b5b5ff",
    "color.light.violet_midnight.grey.40": "#e0e0e0ff",
    "color.light.violet_midnight.grey.20": "#f5f5f5ff",
    "color.bold.violet.20": "#f7a8fa33",
    "color.bold.violet.30": "#f7a8fa66",
    "color.bold.violet.40": "#f7a8fa99",
    "color.bold.violet.50": "#f7a8faff",
    "color.bold.violet.60": "#fefdffff",
    "color.bold.violet.70": "#ffffffff",
    "color.bold.violet.80": "#ffffffff",
    "color.bold.violet.inverse": "#571859ff",
    "color.bold.violet.background": "#c135c5ff",
    "color.bold.violet.grey.100": "#ffffffff",
    "color.bold.violet.grey.80": "#fffffffc",
    "color.bold.violet.grey.60": "#ffffff87",
    "color.bold.violet.grey.40": "#ffffff4f",
    "color.bold.violet.grey.20": "#ffffff1f",
    "color.dark.violet.20": "#300d31ff",
    "color.dark.violet.30": "#571859ff",
    "color.dark.violet.40": "#79007fff",
    "color.dark.violet.50": "#c135c5ff",
    "color.dark.violet.60": "#f680f9ff",
    "color.dark.violet.70": "#f7a8faff",
    "color.dark.violet.80": "#f9ebf9ff",
    "color.dark.violet.inverse": "#ffffffff",
    "color.dark.violet.background": "#141414ff",
    "color.dark.violet.grey.100": "#ffffffff",
    "color.dark.violet.grey.80": "#ffffffc7",
    "color.dark.violet.grey.60": "#a1a1a1ff",
    "color.dark.violet.grey.40": "#5a5a5aff",
    "color.dark.violet.grey.20": "#2b2b2bff",
    "color.light.violet.20": "#f9ebf9ff",
    "color.light.violet.30": "#f7a8faff",
    "color.light.violet.40": "#f680f9ff",
    "color.light.violet.50": "#c135c5ff",
    "color.light.violet.60": "#79007fff",
    "color.light.violet.70": "#571859ff",
    "color.light.violet.80": "#300d31ff",
    "color.light.violet.inverse": "#ffffffff",
    "color.light.violet.background": "#ffffffff",
    "color.light.violet.grey.100": "#141414ff",
    "color.light.violet.grey.80": "#000000a6",
    "color.light.violet.grey.60": "#b5b5b5ff",
    "color.light.violet.grey.40": "#e0e0e0ff",
    "color.light.violet.grey.20": "#f5f5f5ff",
    "color.light.feedback.error.80": "#3e0006ff",
    "color.light.feedback.error.70": "#6a000fff",
    "color.light.feedback.error.60": "#cd0027ff",
    "color.light.feedback.error.50": "#fa2F40ff",
    "color.light.feedback.error.40": "#fe9993ff",
    "color.light.feedback.error.30": "#ffCFCBff",
    "color.light.feedback.error.20": "#fff1F0ff",
    "color.light.feedback.warning.80": "#321304ff",
    "color.light.feedback.warning.70": "#582309ff",
    "color.light.feedback.warning.60": "#b04914ff",
    "color.light.feedback.warning.50": "#f06d0fff",
    "color.light.feedback.warning.40": "#fC9E6dff",
    "color.light.feedback.warning.30": "#FCD3BFff",
    "color.light.feedback.warning.20": "#fff2ecff",
    "color.light.feedback.success.80": "#0e540cff",
    "color.light.feedback.success.70": "#136c11ff",
    "color.light.feedback.success.60": "#1a8417ff",
    "color.light.feedback.success.50": "#25ab21ff",
    "color.light.feedback.success.40": "#85ce7fff",
    "color.light.feedback.success.30": "#c8e7c5ff",
    "color.light.feedback.success.20": "#eff8eeff",
    "color.light.white": "#ffffff",
    "color.light.black": "#141414",
    "color.dark.white": "#ffffff",
    "color.dark.black": "#141414",
    "color.bold.white": "#ffffff",
    "color.bold.black": "#141414",
    "color.bold.feedback.error.80": "#FFE1DEff",
    "color.bold.feedback.error.70": "#FFCFCBff",
    "color.bold.feedback.error.60": "#FFBEB9ff",
    "color.bold.feedback.error.50": "#FEABA6ff",
    "color.bold.feedback.error.40": "#FE9993ff",
    "color.bold.feedback.error.30": "#FF847Fff",
    "color.bold.feedback.error.20": "#FF6E6Cff",
    "color.bold.feedback.warning.80": "#FFF2ECff",
    "color.bold.feedback.warning.70": "#FEE3D6ff",
    "color.bold.feedback.warning.60": "#FCD3BFff",
    "color.bold.feedback.warning.50": "#FBC2A6ff",
    "color.bold.feedback.warning.40": "#FBB08Aff",
    "color.bold.feedback.warning.30": "#FC9E6Dff",
    "color.bold.feedback.warning.20": "#FB8C50ff",
    "color.bold.feedback.success.80": "#DCF0DAff",
    "color.bold.feedback.success.70": "#C8E7C5ff",
    "color.bold.feedback.success.60": "#B4DEAFff",
    "color.bold.feedback.success.50": "#9CD696ff",
    "color.bold.feedback.success.40": "#85CE7Fff",
    "color.bold.feedback.success.30": "#6CC765ff",
    "color.bold.feedback.success.20": "#54BE4Eff",
    "color.dark.feedback.error.80": "#fff1f0ff",
    "color.dark.feedback.error.70": "#ffe1deff",
    "color.dark.feedback.error.60": "#feaba6ff",
    "color.dark.feedback.error.50": "#ff5256ff",
    "color.dark.feedback.error.40": "#df042cff",
    "color.dark.feedback.error.30": "#770113ff",
    "color.dark.feedback.error.20": "#4F0109ff",
    "color.dark.feedback.warning.80": "#fff2ecff",
    "color.dark.feedback.warning.70": "#ffd6c2ff",
    "color.dark.feedback.warning.60": "#fbb08Aff",
    "color.dark.feedback.warning.50": "#f87a2eff",
    "color.dark.feedback.warning.40": "#c05016ff",
    "color.dark.feedback.warning.30": "#66270aff",
    "color.dark.feedback.warning.20": "#401a07ff",
    "color.dark.feedback.success.80": "#EFF8EEff",
    "color.dark.feedback.success.70": "#DCF0DAff",
    "color.dark.feedback.success.60": "#9CD696ff",
    "color.dark.feedback.success.50": "#3EB438ff",
    "color.dark.feedback.success.40": "#1D901Aff",
    "color.dark.feedback.success.30": "#167814ff",
    "color.dark.feedback.success.20": "#105F0Eff",
    "color.light.gold.20": "#f9f6efFF",
    "color.dark.gold.20": "#3f3721FF",
    "color.bold.gold.20": "#211d14FF",
    "color.light.gold.30": "#f4ead4FF",
    "color.dark.gold.30": "#746640FF",
    "color.bold.gold.30": "#3f3721FF",
    "color.light.gold.40": "#f0deb2FF",
    "color.dark.gold.40": "#a18e5bFF",
    "color.bold.gold.40": "#746640FF",
    "color.light.gold.50": "#c9b273FF",
    "color.dark.gold.50": "#d2ba78FF",
    "color.bold.gold.50": "#a18e5bFF",
    "color.light.gold.60": "#968454FF",
    "color.dark.gold.60": "#f0deb2FF",
    "color.bold.gold.60": "#f0deb2FF",
    "color.light.gold.70": "#6a5d3aFF",
    "color.dark.gold.70": "#f4ead4FF",
    "color.bold.gold.70": "#f4ead4FF",
    "color.light.gold.80": "#352e1dFF",
    "color.dark.gold.80": "#f9f6efFF",
    "color.bold.gold.80": "#f9f6efFF",
    "color.light.gold.grey.20": "#f5f5f5FF",
    "color.dark.gold.grey.20": "#2b2b2bFF",
    "color.bold.gold.grey.20": "#ffffff1F",
    "color.light.gold.grey.40": "#e0e0e0FF",
    "color.dark.gold.grey.40": "#5a5a5aFF",
    "color.bold.gold.grey.40": "#ffffff52",
    "color.light.gold.grey.60": "#b5b5b5FF",
    "color.dark.gold.grey.60": "#a1a1a1FF",
    "color.bold.gold.grey.60": "#ffffff87",
    "color.light.gold.grey.80": "#000000A6",
    "color.dark.gold.grey.80": "#ffffffC7",
    "color.bold.gold.grey.80": "#ffffffC7",
    "color.light.gold.grey.100": "#141414FF",
    "color.dark.gold.grey.100": "#ffffffFF",
    "color.bold.gold.grey.100": "#ffffffFF",
    "color.light.gold.background": "#ffffffFF",
    "color.dark.gold.background": "#141414FF",
    "color.bold.gold.background": "#c9b273FF",
    "color.light.gold.inverse": "#352e1dFF",
    "color.dark.gold.inverse": "#3f3721FF",
    "color.bold.gold.inverse": "#211d14FF",
    "color.light.rose.20": "#fcf5f5FF",
    "color.dark.rose.20": "#2e070aFF",
    "color.bold.rose.20": "#4e0b19FF",
    "color.light.rose.30": "#fad8d8FF",
    "color.dark.rose.30": "#700b25FF",
    "color.bold.rose.30": "#d8214fFF",
    "color.light.rose.40": "#f9c9caFF",
    "color.dark.rose.40": "#c61d48FF",
    "color.bold.rose.40": "#f8536eFF",
    "color.light.rose.50": "#fa969dFF",
    "color.dark.rose.50": "#f8536eFF",
    "color.bold.rose.50": "#f96e7eFF",
    "color.light.rose.60": "#f96e7eFF",
    "color.dark.rose.60": "#fba5aaFF",
    "color.bold.rose.60": "#fab6b9FF",
    "color.light.rose.70": "#720c26FF",
    "color.dark.rose.70": "#fad7d8FF",
    "color.bold.rose.70": "#fad7d8FF",
    "color.light.rose.80": "#3d0912FF",
    "color.dark.rose.80": "#fae6e7FF",
    "color.bold.rose.80": "#fcf5f5FF",
    "color.light.rose.grey.20": "#f5f5f5FF",
    "color.dark.rose.grey.20": "#2b2b2bFF",
    "color.bold.rose.grey.20": "#ffffff1F",
    "color.light.rose.grey.40": "#e0e0e0FF",
    "color.dark.rose.grey.40": "#5a5a5aFF",
    "color.bold.rose.grey.40": "#ffffff52",
    "color.light.rose.grey.60": "#b5b5b5FF",
    "color.dark.rose.grey.60": "#a1a1a1FF",
    "color.bold.rose.grey.60": "#ffffff87",
    "color.light.rose.grey.80": "#000000A6",
    "color.dark.rose.grey.80": "#ffffffC7",
    "color.bold.rose.grey.80": "#ffffffC7",
    "color.light.rose.grey.100": "#141414FF",
    "color.dark.rose.grey.100": "#ffffffFF",
    "color.bold.rose.grey.100": "#ffffffFF",
    "color.light.rose.background": "#3d0912FF",
    "color.dark.rose.background": "#141414FF",
    "color.bold.rose.background": "#141414FF",
    "color.light.rose.inverse": "#3d0912FF",
    "color.dark.rose.inverse": "#ffffffFF",
    "color.bold.rose.inverse": "#2e070aFF",
    "color.light.warm_gold.20": "#FEF7EF",
    "color.light.warm_gold.30": "#F9D4A9",
    "color.light.warm_gold.40": "#F3B561",
    "color.light.warm_gold.50": "#E39B2B",
    "color.light.warm_gold.60": "#9B6817",
    "color.light.warm_gold.70": "#67440C",
    "color.light.warm_gold.80": "#312109",
    "color.light.warm_gold.grey.20": "#F5F5F5",
    "color.light.warm_gold.grey.40": "#E0E0E0",
    "color.light.warm_gold.grey.60": "#B5B5B5",
    "color.light.warm_gold.grey.80": "#000000A5",
    "color.light.warm_gold.grey.100": "#141414",
    "color.light.warm_gold.background": "#FFFFFF",
    "color.light.warm_gold.inverse": "#312109",
    "color.dark.warm_gold.20": "#312109",
    "color.dark.warm_gold.30": "#67440C",
    "color.dark.warm_gold.40": "#A8711A",
    "color.dark.warm_gold.50": "#EFA73D",
    "color.dark.warm_gold.60": "#F6C586",
    "color.dark.warm_gold.70": "#FCE7D0",
    "color.dark.warm_gold.80": "#FDFDFD",
    "color.dark.warm_gold.grey.20": "#2B2B2B",
    "color.dark.warm_gold.grey.40": "#5A5A5A",
    "color.dark.warm_gold.grey.60": "#A1A1A1",
    "color.dark.warm_gold.grey.80": "#FFFFFFC7",
    "color.dark.warm_gold.grey.100": "#FFFFFF",
    "color.dark.warm_gold.background": "#120C04",
    "color.dark.warm_gold.inverse": "#312109",
    "color.bold.warm_gold.20": "#EFA73D",
    "color.bold.warm_gold.30": "#C78724",
    "color.bold.warm_gold.40": "#8E5F15",
    "color.bold.warm_gold.50": "#67440C",
    "color.bold.warm_gold.60": "#452D09",
    "color.bold.warm_gold.70": "#312109",
    "color.bold.warm_gold.80": "#241908",
    "color.bold.warm_gold.grey.20": "#401D0C1E",
    "color.bold.warm_gold.grey.40": "#401D0C4D",
    "color.bold.warm_gold.grey.60": "#401D0C87",
    "color.bold.warm_gold.grey.80": "#401D0CBF",
    "color.bold.warm_gold.grey.100": "#401D0C",
    "color.bold.warm_gold.background": "#E39B2B",
    "color.bold.warm_gold.inverse": "#FEF7EF",
    elevation1: $52d4442770cfd938$var$elevation1,
    "elevation1.light": "{color.light.$primary.background}",
    "elevation1.dark": "{color.dark.$primary.grey.20}",
    "elevation1.bold": "{color.bold.$primary.background}",
    custom_color_1: $52d4442770cfd938$var$custom_color_1,
    custom_color_2: $52d4442770cfd938$var$custom_color_2,
    custom_color_3: $52d4442770cfd938$var$custom_color_3,
    custom_color_4: $52d4442770cfd938$var$custom_color_4,
    custom_color_5: $52d4442770cfd938$var$custom_color_5,
    custom_color_6: $52d4442770cfd938$var$custom_color_6,
    custom_dark_primary_40: $52d4442770cfd938$var$custom_dark_primary_40,
    custom_dark_primary_60: $52d4442770cfd938$var$custom_dark_primary_60,
    custom_dark_primary_grey_80: $52d4442770cfd938$var$custom_dark_primary_grey_80,
    custom_dark_primary_grey_100: $52d4442770cfd938$var$custom_dark_primary_grey_100
};
const $52d4442770cfd938$var$headingXl$4 = "{$lang.$platform.headingXl}";
const $52d4442770cfd938$var$headingL$4 = "{$lang.$platform.headingL}";
const $52d4442770cfd938$var$headingM$4 = "{$lang.$platform.headingM}";
const $52d4442770cfd938$var$headingS$4 = "{$lang.$platform.headingS}";
const $52d4442770cfd938$var$headingXs$4 = "{$lang.$platform.headingXs}";
const $52d4442770cfd938$var$headingXxs$4 = "{$lang.$platform.headingXxs}";
const $52d4442770cfd938$var$overline$5 = "{$lang.$platform.overline}";
const $52d4442770cfd938$var$bodyL$4 = "{$lang.$platform.bodyL}";
const $52d4442770cfd938$var$bodyLBold$4 = "{$lang.$platform.bodyLBold}";
const $52d4442770cfd938$var$bodyLLink$4 = "{$lang.$platform.bodyLLink}";
const $52d4442770cfd938$var$bodyM$4 = "{$lang.$platform.bodyM}";
const $52d4442770cfd938$var$bodyMBold$4 = "{$lang.$platform.bodyMBold}";
const $52d4442770cfd938$var$bodyMLink$4 = "{$lang.$platform.bodyMLink}";
const $52d4442770cfd938$var$bodyS$4 = "{$lang.$platform.bodyS}";
const $52d4442770cfd938$var$bodySBold$4 = "{$lang.$platform.bodySBold}";
const $52d4442770cfd938$var$bodySLink$4 = "{$lang.$platform.bodySLink}";
const $52d4442770cfd938$var$bodyXs$4 = "{$lang.$platform.bodyXs}";
const $52d4442770cfd938$var$bodyXsBold$4 = "{$lang.$platform.bodyXsBold}";
const $52d4442770cfd938$var$bodyXsLink$4 = "{$lang.$platform.bodyXsLink}";
const $52d4442770cfd938$var$bodyXxs$4 = "{$lang.$platform.bodyXxs}";
const $52d4442770cfd938$var$bodyXxsBold$4 = "{$lang.$platform.bodyXxsBold}";
const $52d4442770cfd938$var$bodyXxsLink$4 = "{$lang.$platform.bodyXxsLink}";
const $52d4442770cfd938$var$body3xs$4 = "{$lang.$platform.body3xs}";
const $52d4442770cfd938$var$body3xsBold$4 = "{$lang.$platform.body3xsBold}";
const $52d4442770cfd938$var$body3xsLink$4 = "{$lang.$platform.body3xsLink}";
const $52d4442770cfd938$var$listTitle$4 = "{$lang.$platform.listTitle}";
const $52d4442770cfd938$var$button$4 = "{$lang.$platform.button}";
const $52d4442770cfd938$var$code$4 = "{$lang.$platform.code}";
const $52d4442770cfd938$var$fontFamilies = {
    "as.desktop.headingXl": "Noto Sans",
    "as.desktop.headingL": "Noto Sans",
    "as.desktop.headingM": "Noto Sans",
    "as.desktop.headingS": "Noto Sans",
    "as.desktop.headingXs": "Noto Sans",
    "as.desktop.headingXxs": "Noto Sans",
    "as.desktop.overline": "Noto Sans",
    "as.desktop.bodyL": "Noto Sans",
    "as.desktop.bodyLBold": "Noto Sans",
    "as.desktop.bodyLLink": "Noto Sans",
    "as.desktop.bodyM": "Noto Sans",
    "as.desktop.bodyMBold": "Noto Sans",
    "as.desktop.bodyMLink": "Noto Sans",
    "as.desktop.bodyS": "Noto Sans",
    "as.desktop.bodySBold": "Noto Sans",
    "as.desktop.bodySLink": "Noto Sans",
    "as.desktop.bodyXs": "Noto Sans",
    "as.desktop.bodyXsBold": "Noto Sans",
    "as.desktop.bodyXsLink": "Noto Sans",
    "as.desktop.bodyXxs": "Noto Sans",
    "as.desktop.bodyXxsBold": "Noto Sans",
    "as.desktop.bodyXxsLink": "Noto Sans",
    "as.desktop.body3xs": "Noto Sans",
    "as.desktop.body3xsBold": "Noto Sans",
    "as.desktop.body3xsLink": "Noto Sans",
    "as.desktop.listTitle": "Noto Sans",
    "as.desktop.button": "Noto Sans",
    "as.desktop.code": "JetBrains Mono",
    "as.mobile.headingXl": "Noto Sans",
    "as.mobile.headingL": "Noto Sans",
    "as.mobile.headingM": "Noto Sans",
    "as.mobile.headingS": "Noto Sans",
    "as.mobile.headingXs": "Noto Sans",
    "as.mobile.headingXxs": "Noto Sans",
    "as.mobile.overline": "Noto Sans",
    "as.mobile.bodyL": "Noto Sans",
    "as.mobile.bodyLBold": "Noto Sans",
    "as.mobile.bodyLLink": "Noto Sans",
    "as.mobile.bodyM": "Noto Sans",
    "as.mobile.bodyMBold": "Noto Sans",
    "as.mobile.bodyMLink": "Noto Sans",
    "as.mobile.bodyS": "Noto Sans",
    "as.mobile.bodySBold": "Noto Sans",
    "as.mobile.bodySLink": "Noto Sans",
    "as.mobile.bodyXs": "Noto Sans",
    "as.mobile.bodyXsBold": "Noto Sans",
    "as.mobile.bodyXsLink": "Noto Sans",
    "as.mobile.bodyXxs": "Noto Sans",
    "as.mobile.bodyXxsBold": "Noto Sans",
    "as.mobile.bodyXxsLink": "Noto Sans",
    "as.mobile.body3xs": "Noto Sans",
    "as.mobile.body3xsBold": "Noto Sans",
    "as.mobile.body3xsLink": "Noto Sans",
    "as.mobile.listTitle": "Noto Sans",
    "as.mobile.button": "Noto Sans",
    "as.mobile.code": "JetBrains Mono",
    "bn.desktop.headingXl": "Noto Sans Bengali",
    "bn.desktop.headingL": "Noto Sans Bengali",
    "bn.desktop.headingM": "Noto Sans Bengali",
    "bn.desktop.headingS": "Noto Sans Bengali",
    "bn.desktop.headingXs": "Noto Sans Bengali",
    "bn.desktop.headingXxs": "Noto Sans Bengali",
    "bn.desktop.overline": "Noto Sans Bengali",
    "bn.desktop.bodyL": "Noto Sans Bengali",
    "bn.desktop.bodyLBold": "Noto Sans Bengali",
    "bn.desktop.bodyLLink": "Noto Sans Bengali",
    "bn.desktop.bodyM": "Noto Sans Bengali",
    "bn.desktop.bodyMBold": "Noto Sans Bengali",
    "bn.desktop.bodyMLink": "Noto Sans Bengali",
    "bn.desktop.bodyS": "Noto Sans Bengali",
    "bn.desktop.bodySBold": "Noto Sans Bengali",
    "bn.desktop.bodySLink": "Noto Sans Bengali",
    "bn.desktop.bodyXs": "Noto Sans Bengali",
    "bn.desktop.bodyXsBold": "Noto Sans Bengali",
    "bn.desktop.bodyXsLink": "Noto Sans Bengali",
    "bn.desktop.bodyXxs": "Noto Sans Bengali",
    "bn.desktop.bodyXxsBold": "Noto Sans Bengali",
    "bn.desktop.bodyXxsLink": "Noto Sans Bengali",
    "bn.desktop.body3xs": "Noto Sans Bengali",
    "bn.desktop.body3xsBold": "Noto Sans Bengali",
    "bn.desktop.body3xsLink": "Noto Sans Bengali",
    "bn.desktop.listTitle": "Noto Sans Bengali",
    "bn.desktop.button": "Noto Sans Bengali",
    "bn.desktop.code": "JetBrains Mono",
    "bn.mobile.headingXl": "Noto Sans Bengali",
    "bn.mobile.headingL": "Noto Sans Bengali",
    "bn.mobile.headingM": "Noto Sans Bengali",
    "bn.mobile.headingS": "Noto Sans Bengali",
    "bn.mobile.headingXs": "Noto Sans Bengali",
    "bn.mobile.headingXxs": "Noto Sans Bengali",
    "bn.mobile.overline": "Noto Sans Bengali",
    "bn.mobile.bodyL": "Noto Sans Bengali",
    "bn.mobile.bodyLBold": "Noto Sans Bengali",
    "bn.mobile.bodyLLink": "Noto Sans Bengali",
    "bn.mobile.bodyM": "Noto Sans Bengali",
    "bn.mobile.bodyMBold": "Noto Sans Bengali",
    "bn.mobile.bodyMLink": "Noto Sans Bengali",
    "bn.mobile.bodyS": "Noto Sans Bengali",
    "bn.mobile.bodySBold": "Noto Sans Bengali",
    "bn.mobile.bodySLink": "Noto Sans Bengali",
    "bn.mobile.bodyXs": "Noto Sans Bengali",
    "bn.mobile.bodyXsBold": "Noto Sans Bengali",
    "bn.mobile.bodyXsLink": "Noto Sans Bengali",
    "bn.mobile.bodyXxs": "Noto Sans Bengali",
    "bn.mobile.bodyXxsBold": "Noto Sans Bengali",
    "bn.mobile.bodyXxsLink": "Noto Sans Bengali",
    "bn.mobile.body3xs": "Noto Sans Bengali",
    "bn.mobile.body3xsBold": "Noto Sans Bengali",
    "bn.mobile.body3xsLink": "Noto Sans Bengali",
    "bn.mobile.listTitle": "Noto Sans Bengali",
    "bn.mobile.button": "Noto Sans Bengali",
    "bn.mobile.code": "JetBrains Mono",
    "en.desktop.headingXl": "JioType Black",
    "en.desktop.headingL": "JioType Black",
    "en.desktop.headingM": "JioType Black",
    "en.desktop.headingS": "JioType Black",
    "en.desktop.headingXs": "JioType Black",
    "en.desktop.headingXxs": "JioType Black",
    "en.desktop.overline": "JioType Bold",
    "en.desktop.bodyL": "JioType Medium",
    "en.desktop.bodyLBold": "JioType Bold",
    "en.desktop.bodyLLink": "JioType Bold",
    "en.desktop.bodyM": "JioType Medium",
    "en.desktop.bodyMBold": "JioType Bold",
    "en.desktop.bodyMLink": "JioType Bold",
    "en.desktop.bodyS": "JioType Medium",
    "en.desktop.bodySBold": "JioType Bold",
    "en.desktop.bodySLink": "JioType Bold",
    "en.desktop.bodyXs": "JioType Medium",
    "en.desktop.bodyXsBold": "JioType Bold",
    "en.desktop.bodyXsLink": "JioType Bold",
    "en.desktop.bodyXxs": "JioType Medium",
    "en.desktop.bodyXxsBold": "JioType Bold",
    "en.desktop.bodyXxsLink": "JioType Bold",
    "en.desktop.body3xs": "JioType Medium",
    "en.desktop.body3xsBold": "JioType Bold",
    "en.desktop.body3xsLink": "JioType Bold",
    "en.desktop.listTitle": "JioType Medium",
    "en.desktop.button": "JioType Bold",
    "en.desktop.code": "JetBrains Mono",
    "en.mobile.headingXl": "JioType Black",
    "en.mobile.headingL": "JioType Black",
    "en.mobile.headingM": "JioType Black",
    "en.mobile.headingS": "JioType Black",
    "en.mobile.headingXs": "JioType Black",
    "en.mobile.headingXxs": "JioType Black",
    "en.mobile.overline": "JioType Bold",
    "en.mobile.bodyL": "JioType Medium",
    "en.mobile.bodyLBold": "JioType Bold",
    "en.mobile.bodyLLink": "JioType Bold",
    "en.mobile.bodyM": "JioType Medium",
    "en.mobile.bodyMBold": "JioType Bold",
    "en.mobile.bodyMLink": "JioType Bold",
    "en.mobile.bodyS": "JioType Medium",
    "en.mobile.bodySBold": "JioType Bold",
    "en.mobile.bodySLink": "JioType Bold",
    "en.mobile.bodyXs": "JioType Medium",
    "en.mobile.bodyXsBold": "JioType Bold",
    "en.mobile.bodyXsLink": "JioType Bold",
    "en.mobile.bodyXxs": "JioType Medium",
    "en.mobile.bodyXxsBold": "JioType Bold",
    "en.mobile.bodyXxsLink": "JioType Bold",
    "en.mobile.body3xs": "JioType Medium",
    "en.mobile.body3xsBold": "JioType Bold",
    "en.mobile.body3xsLink": "JioType Bold",
    "en.mobile.listTitle": "JioType Medium",
    "en.mobile.button": "JioType Bold",
    "en.mobile.code": "JetBrains Mono",
    "gu.desktop.headingXl": "Noto Sans Gujarati",
    "gu.desktop.headingL": "Noto Sans Gujarati",
    "gu.desktop.headingM": "Noto Sans Gujarati",
    "gu.desktop.headingS": "Noto Sans Gujarati",
    "gu.desktop.headingXs": "Noto Sans Gujarati",
    "gu.desktop.headingXxs": "Noto Sans Gujarati",
    "gu.desktop.overline": "Noto Sans Gujarati",
    "gu.desktop.bodyL": "Noto Sans Gujarati",
    "gu.desktop.bodyLBold": "Noto Sans Gujarati",
    "gu.desktop.bodyLLink": "Noto Sans Gujarati",
    "gu.desktop.bodyM": "Noto Sans Gujarati",
    "gu.desktop.bodyMBold": "Noto Sans Gujarati",
    "gu.desktop.bodyMLink": "Noto Sans Gujarati",
    "gu.desktop.bodyS": "Noto Sans Gujarati",
    "gu.desktop.bodySBold": "Noto Sans Gujarati",
    "gu.desktop.bodySLink": "Noto Sans Gujarati",
    "gu.desktop.bodyXs": "Noto Sans Gujarati",
    "gu.desktop.bodyXsBold": "Noto Sans Gujarati",
    "gu.desktop.bodyXsLink": "Noto Sans Gujarati",
    "gu.desktop.bodyXxs": "Noto Sans Gujarati",
    "gu.desktop.bodyXxsBold": "Noto Sans Gujarati",
    "gu.desktop.bodyXxsLink": "Noto Sans Gujarati",
    "gu.desktop.body3xs": "Noto Sans Gujarati",
    "gu.desktop.body3xsBold": "Noto Sans Gujarati",
    "gu.desktop.body3xsLink": "Noto Sans Gujarati",
    "gu.desktop.listTitle": "Noto Sans Gujarati",
    "gu.desktop.button": "Noto Sans Gujarati",
    "gu.desktop.code": "JetBrains Mono",
    "gu.mobile.headingXl": "Noto Sans Gujarati",
    "gu.mobile.headingL": "Noto Sans Gujarati",
    "gu.mobile.headingM": "Noto Sans Gujarati",
    "gu.mobile.headingS": "Noto Sans Gujarati",
    "gu.mobile.headingXs": "Noto Sans Gujarati",
    "gu.mobile.headingXxs": "Noto Sans Gujarati",
    "gu.mobile.overline": "Noto Sans Gujarati",
    "gu.mobile.bodyL": "Noto Sans Gujarati",
    "gu.mobile.bodyLBold": "Noto Sans Gujarati",
    "gu.mobile.bodyLLink": "Noto Sans Gujarati",
    "gu.mobile.bodyM": "Noto Sans Gujarati",
    "gu.mobile.bodyMBold": "Noto Sans Gujarati",
    "gu.mobile.bodyMLink": "Noto Sans Gujarati",
    "gu.mobile.bodyS": "Noto Sans Gujarati",
    "gu.mobile.bodySBold": "Noto Sans Gujarati",
    "gu.mobile.bodySLink": "Noto Sans Gujarati",
    "gu.mobile.bodyXs": "Noto Sans Gujarati",
    "gu.mobile.bodyXsBold": "Noto Sans Gujarati",
    "gu.mobile.bodyXsLink": "Noto Sans Gujarati",
    "gu.mobile.bodyXxs": "Noto Sans Gujarati",
    "gu.mobile.bodyXxsBold": "Noto Sans Gujarati",
    "gu.mobile.bodyXxsLink": "Noto Sans Gujarati",
    "gu.mobile.body3xs": "Noto Sans Gujarati",
    "gu.mobile.body3xsBold": "Noto Sans Gujarati",
    "gu.mobile.body3xsLink": "Noto Sans Gujarati",
    "gu.mobile.listTitle": "Noto Sans Gujarati",
    "gu.mobile.button": "Noto Sans Gujarati",
    "gu.mobile.code": "JetBrains Mono",
    "hi.desktop.headingXl": "Noto Sans",
    "hi.desktop.headingL": "Noto Sans",
    "hi.desktop.headingM": "Noto Sans",
    "hi.desktop.headingS": "Noto Sans",
    "hi.desktop.headingXs": "Noto Sans",
    "hi.desktop.headingXxs": "Noto Sans",
    "hi.desktop.overline": "Noto Sans Bengali",
    "hi.desktop.bodyL": "Noto Sans",
    "hi.desktop.bodyLBold": "Noto Sans",
    "hi.desktop.bodyLLink": "Noto Sans",
    "hi.desktop.bodyM": "Noto Sans",
    "hi.desktop.bodyMBold": "Noto Sans",
    "hi.desktop.bodyMLink": "Noto Sans",
    "hi.desktop.bodyS": "Noto Sans",
    "hi.desktop.bodySBold": "Noto Sans",
    "hi.desktop.bodySLink": "Noto Sans",
    "hi.desktop.bodyXs": "Noto Sans",
    "hi.desktop.bodyXsBold": "Noto Sans",
    "hi.desktop.bodyXsLink": "Noto Sans",
    "hi.desktop.bodyXxs": "Noto Sans",
    "hi.desktop.bodyXxsBold": "Noto Sans",
    "hi.desktop.bodyXxsLink": "Noto Sans",
    "hi.desktop.body3xs": "Noto Sans",
    "hi.desktop.body3xsBold": "Noto Sans",
    "hi.desktop.body3xsLink": "Noto Sans",
    "hi.desktop.listTitle": "Noto Sans",
    "hi.desktop.button": "Noto Sans",
    "hi.desktop.code": "JetBrains Mono",
    "hi.mobile.headingXl": "Noto Sans",
    "hi.mobile.headingL": "Noto Sans",
    "hi.mobile.headingM": "Noto Sans",
    "hi.mobile.headingS": "Noto Sans",
    "hi.mobile.headingXs": "Noto Sans",
    "hi.mobile.headingXxs": "Noto Sans",
    "hi.mobile.overline": "Noto Sans",
    "hi.mobile.bodyL": "Noto Sans",
    "hi.mobile.bodyLBold": "Noto Sans",
    "hi.mobile.bodyLLink": "Noto Sans",
    "hi.mobile.bodyM": "Noto Sans",
    "hi.mobile.bodyMBold": "Noto Sans",
    "hi.mobile.bodyMLink": "Noto Sans",
    "hi.mobile.bodyS": "Noto Sans",
    "hi.mobile.bodySBold": "Noto Sans",
    "hi.mobile.bodySLink": "Noto Sans",
    "hi.mobile.bodyXs": "Noto Sans",
    "hi.mobile.bodyXsBold": "Noto Sans",
    "hi.mobile.bodyXsLink": "Noto Sans",
    "hi.mobile.bodyXxs": "Noto Sans",
    "hi.mobile.bodyXxsBold": "Noto Sans",
    "hi.mobile.bodyXxsLink": "Noto Sans",
    "hi.mobile.body3xs": "Noto Sans",
    "hi.mobile.body3xsBold": "Noto Sans",
    "hi.mobile.body3xsLink": "Noto Sans",
    "hi.mobile.listTitle": "Noto Sans",
    "hi.mobile.button": "Noto Sans",
    "hi.mobile.code": "JetBrains Mono",
    "kn.desktop.headingXl": "Noto Sans Kannada",
    "kn.desktop.headingL": "Noto Sans Kannada",
    "kn.desktop.headingM": "Noto Sans Kannada",
    "kn.desktop.headingS": "Noto Sans Kannada",
    "kn.desktop.headingXs": "Noto Sans Kannada",
    "kn.desktop.headingXxs": "Noto Sans Kannada",
    "kn.desktop.overline": "Noto Sans Kannada",
    "kn.desktop.bodyL": "Noto Sans Kannada",
    "kn.desktop.bodyLBold": "Noto Sans Kannada",
    "kn.desktop.bodyLLink": "Noto Sans Kannada",
    "kn.desktop.bodyM": "Noto Sans Kannada",
    "kn.desktop.bodyMBold": "Noto Sans Kannada",
    "kn.desktop.bodyMLink": "Noto Sans Kannada",
    "kn.desktop.bodyS": "Noto Sans Kannada",
    "kn.desktop.bodySBold": "Noto Sans Kannada",
    "kn.desktop.bodySLink": "Noto Sans Kannada",
    "kn.desktop.bodyXs": "Noto Sans Kannada",
    "kn.desktop.bodyXsBold": "Noto Sans Kannada",
    "kn.desktop.bodyXsLink": "Noto Sans Kannada",
    "kn.desktop.bodyXxs": "Noto Sans Kannada",
    "kn.desktop.bodyXxsBold": "Noto Sans Kannada",
    "kn.desktop.bodyXxsLink": "Noto Sans Kannada",
    "kn.desktop.body3xs": "Noto Sans Kannada",
    "kn.desktop.body3xsBold": "Noto Sans Kannada",
    "kn.desktop.body3xsLink": "Noto Sans Kannada",
    "kn.desktop.listTitle": "Noto Sans Kannada",
    "kn.desktop.button": "Noto Sans Kannada",
    "kn.desktop.code": "JetBrains Mono",
    "kn.mobile.headingXl": "Noto Sans Kannada",
    "kn.mobile.headingL": "Noto Sans Kannada",
    "kn.mobile.headingM": "Noto Sans Kannada",
    "kn.mobile.headingS": "Noto Sans Kannada",
    "kn.mobile.headingXs": "Noto Sans Kannada",
    "kn.mobile.headingXxs": "Noto Sans Kannada",
    "kn.mobile.overline": "Noto Sans Kannada",
    "kn.mobile.bodyL": "Noto Sans Kannada",
    "kn.mobile.bodyLBold": "Noto Sans Kannada",
    "kn.mobile.bodyLLink": "Noto Sans Kannada",
    "kn.mobile.bodyM": "Noto Sans Kannada",
    "kn.mobile.bodyMBold": "Noto Sans Kannada",
    "kn.mobile.bodyMLink": "Noto Sans Kannada",
    "kn.mobile.bodyS": "Noto Sans Kannada",
    "kn.mobile.bodySBold": "Noto Sans Kannada",
    "kn.mobile.bodySLink": "Noto Sans Kannada",
    "kn.mobile.bodyXs": "Noto Sans Kannada",
    "kn.mobile.bodyXsBold": "Noto Sans Kannada",
    "kn.mobile.bodyXsLink": "Noto Sans Kannada",
    "kn.mobile.bodyXxs": "Noto Sans Kannada",
    "kn.mobile.bodyXxsBold": "Noto Sans Kannada",
    "kn.mobile.bodyXxsLink": "Noto Sans Kannada",
    "kn.mobile.body3xs": "Noto Sans Kannada",
    "kn.mobile.body3xsBold": "Noto Sans Kannada",
    "kn.mobile.body3xsLink": "Noto Sans Kannada",
    "kn.mobile.listTitle": "Noto Sans Kannada",
    "kn.mobile.button": "Noto Sans Kannada",
    "kn.mobile.code": "JetBrains Mono",
    "ml.desktop.headingXl": "Noto Sans Malayalam",
    "ml.desktop.headingL": "Noto Sans Malayalam",
    "ml.desktop.headingM": "Noto Sans Malayalam",
    "ml.desktop.headingS": "Noto Sans Malayalam",
    "ml.desktop.headingXs": "Noto Sans Malayalam",
    "ml.desktop.headingXxs": "Noto Sans Malayalam",
    "ml.desktop.overline": "Noto Sans Malayalam",
    "ml.desktop.bodyL": "Noto Sans Malayalam",
    "ml.desktop.bodyLBold": "Noto Sans Malayalam",
    "ml.desktop.bodyLLink": "Noto Sans Malayalam",
    "ml.desktop.bodyM": "Noto Sans Malayalam",
    "ml.desktop.bodyMBold": "Noto Sans Malayalam",
    "ml.desktop.bodyMLink": "Noto Sans Malayalam",
    "ml.desktop.bodyS": "Noto Sans Malayalam",
    "ml.desktop.bodySBold": "Noto Sans Malayalam",
    "ml.desktop.bodySLink": "Noto Sans Malayalam",
    "ml.desktop.bodyXs": "Noto Sans Malayalam",
    "ml.desktop.bodyXsBold": "Noto Sans Malayalam",
    "ml.desktop.bodyXsLink": "Noto Sans Malayalam",
    "ml.desktop.bodyXxs": "Noto Sans Malayalam",
    "ml.desktop.bodyXxsBold": "Noto Sans Malayalam",
    "ml.desktop.bodyXxsLink": "Noto Sans Malayalam",
    "ml.desktop.body3xs": "Noto Sans Malayalam",
    "ml.desktop.body3xsBold": "Noto Sans Malayalam",
    "ml.desktop.body3xsLink": "Noto Sans Malayalam",
    "ml.desktop.listTitle": "Noto Sans Malayalam",
    "ml.desktop.button": "Noto Sans Malayalam",
    "ml.desktop.code": "JetBrains Mono",
    "ml.mobile.headingXl": "Noto Sans Malayalam",
    "ml.mobile.headingL": "Noto Sans Malayalam",
    "ml.mobile.headingM": "Noto Sans Malayalam",
    "ml.mobile.headingS": "Noto Sans Malayalam",
    "ml.mobile.headingXs": "Noto Sans Malayalam",
    "ml.mobile.headingXxs": "Noto Sans Malayalam",
    "ml.mobile.overline": "Noto Sans Malayalam",
    "ml.mobile.bodyL": "Noto Sans Malayalam",
    "ml.mobile.bodyLBold": "Noto Sans Malayalam",
    "ml.mobile.bodyLLink": "Noto Sans Malayalam",
    "ml.mobile.bodyM": "Noto Sans Malayalam",
    "ml.mobile.bodyMBold": "Noto Sans Malayalam",
    "ml.mobile.bodyMLink": "Noto Sans Malayalam",
    "ml.mobile.bodyS": "Noto Sans Malayalam",
    "ml.mobile.bodySBold": "Noto Sans Malayalam",
    "ml.mobile.bodySLink": "Noto Sans Malayalam",
    "ml.mobile.bodyXs": "Noto Sans Malayalam",
    "ml.mobile.bodyXsBold": "Noto Sans Malayalam",
    "ml.mobile.bodyXsLink": "Noto Sans Malayalam",
    "ml.mobile.bodyXxs": "Noto Sans Malayalam",
    "ml.mobile.bodyXxsBold": "Noto Sans Malayalam",
    "ml.mobile.bodyXxsLink": "Noto Sans Malayalam",
    "ml.mobile.body3xs": "Noto Sans Malayalam",
    "ml.mobile.body3xsBold": "Noto Sans Malayalam",
    "ml.mobile.body3xsLink": "Noto Sans Malayalam",
    "ml.mobile.listTitle": "Noto Sans Malayalam",
    "ml.mobile.button": "Noto Sans Malayalam",
    "ml.mobile.code": "JetBrains Mono",
    "mr.desktop.headingXl": "Noto Sans",
    "mr.desktop.headingL": "Noto Sans",
    "mr.desktop.headingM": "Noto Sans",
    "mr.desktop.headingS": "Noto Sans",
    "mr.desktop.headingXs": "Noto Sans",
    "mr.desktop.headingXxs": "Noto Sans",
    "mr.desktop.overline": "Noto Sans",
    "mr.desktop.bodyL": "Noto Sans",
    "mr.desktop.bodyLBold": "Noto Sans",
    "mr.desktop.bodyLLink": "Noto Sans",
    "mr.desktop.bodyM": "Noto Sans",
    "mr.desktop.bodyMBold": "Noto Sans",
    "mr.desktop.bodyMLink": "Noto Sans",
    "mr.desktop.bodyS": "Noto Sans",
    "mr.desktop.bodySBold": "Noto Sans",
    "mr.desktop.bodySLink": "Noto Sans",
    "mr.desktop.bodyXs": "Noto Sans",
    "mr.desktop.bodyXsBold": "Noto Sans",
    "mr.desktop.bodyXsLink": "Noto Sans",
    "mr.desktop.bodyXxs": "Noto Sans",
    "mr.desktop.bodyXxsBold": "Noto Sans",
    "mr.desktop.bodyXxsLink": "Noto Sans",
    "mr.desktop.body3xs": "Noto Sans",
    "mr.desktop.body3xsBold": "Noto Sans",
    "mr.desktop.body3xsLink": "Noto Sans",
    "mr.desktop.listTitle": "Noto Sans",
    "mr.desktop.button": "Noto Sans",
    "mr.desktop.code": "JetBrains Mono",
    "mr.mobile.headingXl": "Noto Sans",
    "mr.mobile.headingL": "Noto Sans",
    "mr.mobile.headingM": "Noto Sans",
    "mr.mobile.headingS": "Noto Sans",
    "mr.mobile.headingXs": "Noto Sans",
    "mr.mobile.headingXxs": "Noto Sans",
    "mr.mobile.overline": "Noto Sans Oriya",
    "mr.mobile.bodyL": "Noto Sans",
    "mr.mobile.bodyLBold": "Noto Sans",
    "mr.mobile.bodyLLink": "Noto Sans",
    "mr.mobile.bodyM": "Noto Sans",
    "mr.mobile.bodyMBold": "Noto Sans",
    "mr.mobile.bodyMLink": "Noto Sans",
    "mr.mobile.bodyS": "Noto Sans",
    "mr.mobile.bodySBold": "Noto Sans",
    "mr.mobile.bodySLink": "Noto Sans",
    "mr.mobile.bodyXs": "Noto Sans",
    "mr.mobile.bodyXsBold": "Noto Sans",
    "mr.mobile.bodyXsLink": "Noto Sans",
    "mr.mobile.bodyXxs": "Noto Sans",
    "mr.mobile.bodyXxsBold": "Noto Sans",
    "mr.mobile.bodyXxsLink": "Noto Sans",
    "mr.mobile.body3xs": "Noto Sans",
    "mr.mobile.body3xsBold": "Noto Sans",
    "mr.mobile.body3xsLink": "Noto Sans",
    "mr.mobile.listTitle": "Noto Sans",
    "mr.mobile.button": "Noto Sans",
    "mr.mobile.code": "JetBrains Mono",
    "or.desktop.headingXl": "Noto Sans Oriya",
    "or.desktop.headingL": "Noto Sans Oriya",
    "or.desktop.headingM": "Noto Sans Oriya",
    "or.desktop.headingS": "Noto Sans Oriya",
    "or.desktop.headingXs": "Noto Sans Oriya",
    "or.desktop.headingXxs": "Noto Sans Oriya",
    "or.desktop.overline": "Noto Sans Oriya",
    "or.desktop.bodyL": "Noto Sans Oriya",
    "or.desktop.bodyLBold": "Noto Sans Oriya",
    "or.desktop.bodyLLink": "Noto Sans Oriya",
    "or.desktop.bodyM": "Noto Sans Oriya",
    "or.desktop.bodyMBold": "Noto Sans Oriya",
    "or.desktop.bodyMLink": "Noto Sans Oriya",
    "or.desktop.bodyS": "Noto Sans Oriya",
    "or.desktop.bodySBold": "Noto Sans Oriya",
    "or.desktop.bodySLink": "Noto Sans Oriya",
    "or.desktop.bodyXs": "Noto Sans Oriya",
    "or.desktop.bodyXsBold": "Noto Sans Oriya",
    "or.desktop.bodyXsLink": "Noto Sans Oriya",
    "or.desktop.bodyXxs": "Noto Sans Oriya",
    "or.desktop.bodyXxsBold": "Noto Sans Oriya",
    "or.desktop.bodyXxsLink": "Noto Sans Oriya",
    "or.desktop.body3xs": "Noto Sans Oriya",
    "or.desktop.body3xsBold": "Noto Sans Oriya",
    "or.desktop.body3xsLink": "Noto Sans Oriya",
    "or.desktop.listTitle": "Noto Sans Oriya",
    "or.desktop.button": "Noto Sans Oriya",
    "or.desktop.code": "JetBrains Mono",
    "or.mobile.headingXl": "Noto Sans Oriya",
    "or.mobile.headingL": "Noto Sans Oriya",
    "or.mobile.headingM": "Noto Sans Oriya",
    "or.mobile.headingS": "Noto Sans Oriya",
    "or.mobile.headingXs": "Noto Sans Oriya",
    "or.mobile.headingXxs": "Noto Sans Oriya",
    "or.mobile.overline": "Noto Sans Oriya",
    "or.mobile.bodyL": "Noto Sans Oriya",
    "or.mobile.bodyLBold": "Noto Sans Oriya",
    "or.mobile.bodyLLink": "Noto Sans Oriya",
    "or.mobile.bodyM": "Noto Sans Oriya",
    "or.mobile.bodyMBold": "Noto Sans Oriya",
    "or.mobile.bodyMLink": "Noto Sans Oriya",
    "or.mobile.bodyS": "Noto Sans Oriya",
    "or.mobile.bodySBold": "Noto Sans Oriya",
    "or.mobile.bodySLink": "Noto Sans Oriya",
    "or.mobile.bodyXs": "Noto Sans Oriya",
    "or.mobile.bodyXsBold": "Noto Sans Oriya",
    "or.mobile.bodyXsLink": "Noto Sans Oriya",
    "or.mobile.bodyXxs": "Noto Sans Oriya",
    "or.mobile.bodyXxsBold": "Noto Sans Oriya",
    "or.mobile.bodyXxsLink": "Noto Sans Oriya",
    "or.mobile.body3xs": "Noto Sans Oriya",
    "or.mobile.body3xsBold": "Noto Sans Oriya",
    "or.mobile.body3xsLink": "Noto Sans Oriya",
    "or.mobile.listTitle": "Noto Sans Oriya",
    "or.mobile.button": "Noto Sans Oriya",
    "or.mobile.code": "JetBrains Mono",
    "pa.desktop.headingXl": "Noto Sans Gurmukhi",
    "pa.desktop.headingL": "Noto Sans Gurmukhi",
    "pa.desktop.headingM": "Noto Sans Gurmukhi",
    "pa.desktop.headingS": "Noto Sans Gurmukhi",
    "pa.desktop.headingXs": "Noto Sans Gurmukhi",
    "pa.desktop.headingXxs": "Noto Sans Gurmukhi",
    "pa.desktop.overline": "Noto Sans Gurmukhi",
    "pa.desktop.bodyL": "Noto Sans Gurmukhi",
    "pa.desktop.bodyLBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyLLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyM": "Noto Sans Gurmukhi",
    "pa.desktop.bodyMBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyMLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyS": "Noto Sans Gurmukhi",
    "pa.desktop.bodySBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodySLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXs": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXsBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXsLink": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxs": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxsBold": "Noto Sans Gurmukhi",
    "pa.desktop.bodyXxsLink": "Noto Sans Gurmukhi",
    "pa.desktop.body3xs": "Noto Sans Gurmukhi",
    "pa.desktop.body3xsBold": "Noto Sans Gurmukhi",
    "pa.desktop.body3xsLink": "Noto Sans Gurmukhi",
    "pa.desktop.listTitle": "Noto Sans Gurmukhi",
    "pa.desktop.button": "Noto Sans Gurmukhi",
    "pa.desktop.code": "JetBrains Mono",
    "pa.mobile.headingXl": "Noto Sans Gurmukhi",
    "pa.mobile.headingL": "Noto Sans Gurmukhi",
    "pa.mobile.headingM": "Noto Sans Gurmukhi",
    "pa.mobile.headingS": "Noto Sans Gurmukhi",
    "pa.mobile.headingXs": "Noto Sans Gurmukhi",
    "pa.mobile.headingXxs": "Noto Sans Gurmukhi",
    "pa.mobile.overline": "Noto Sans Gurmukhi",
    "pa.mobile.bodyL": "Noto Sans Gurmukhi",
    "pa.mobile.bodyLBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyLLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyM": "Noto Sans Gurmukhi",
    "pa.mobile.bodyMBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyMLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyS": "Noto Sans Gurmukhi",
    "pa.mobile.bodySBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodySLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXs": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXsBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXsLink": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxs": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxsBold": "Noto Sans Gurmukhi",
    "pa.mobile.bodyXxsLink": "Noto Sans Gurmukhi",
    "pa.mobile.body3xs": "Noto Sans Gurmukhi",
    "pa.mobile.body3xsBold": "Noto Sans Gurmukhi",
    "pa.mobile.body3xsLink": "Noto Sans Gurmukhi",
    "pa.mobile.listTitle": "Noto Sans Gurmukhi",
    "pa.mobile.button": "Noto Sans Gurmukhi",
    "pa.mobile.code": "JetBrains Mono",
    "ta.desktop.headingXl": "Noto Sans Tamil",
    "ta.desktop.headingL": "Noto Sans Tamil",
    "ta.desktop.headingM": "Noto Sans Tamil",
    "ta.desktop.headingS": "Noto Sans Tamil",
    "ta.desktop.headingXs": "Noto Sans Tamil",
    "ta.desktop.headingXxs": "Noto Sans Tamil",
    "ta.desktop.overline": "Noto Sans Tamil",
    "ta.desktop.bodyL": "Noto Sans Tamil",
    "ta.desktop.bodyLBold": "Noto Sans Tamil",
    "ta.desktop.bodyLLink": "Noto Sans Tamil",
    "ta.desktop.bodyM": "Noto Sans Tamil",
    "ta.desktop.bodyMBold": "Noto Sans Tamil",
    "ta.desktop.bodyMLink": "Noto Sans Tamil",
    "ta.desktop.bodyS": "Noto Sans Tamil",
    "ta.desktop.bodySBold": "Noto Sans Tamil",
    "ta.desktop.bodySLink": "Noto Sans Tamil",
    "ta.desktop.bodyXs": "Noto Sans Tamil",
    "ta.desktop.bodyXsBold": "Noto Sans Tamil",
    "ta.desktop.bodyXsLink": "Noto Sans Tamil",
    "ta.desktop.bodyXxs": "Noto Sans Tamil",
    "ta.desktop.bodyXxsBold": "Noto Sans Tamil",
    "ta.desktop.bodyXxsLink": "Noto Sans Tamil",
    "ta.desktop.body3xs": "Noto Sans Tamil",
    "ta.desktop.body3xsBold": "Noto Sans Tamil",
    "ta.desktop.body3xsLink": "Noto Sans Tamil",
    "ta.desktop.listTitle": "Noto Sans Tamil",
    "ta.desktop.button": "Noto Sans Tamil",
    "ta.desktop.code": "JetBrains Mono",
    "ta.mobile.headingXl": "Noto Sans Tamil",
    "ta.mobile.headingL": "Noto Sans Tamil",
    "ta.mobile.headingM": "Noto Sans Tamil",
    "ta.mobile.headingS": "Noto Sans Tamil",
    "ta.mobile.headingXs": "Noto Sans Tamil",
    "ta.mobile.headingXxs": "Noto Sans Tamil",
    "ta.mobile.overline": "Noto Sans Tamil",
    "ta.mobile.bodyL": "Noto Sans Tamil",
    "ta.mobile.bodyLBold": "Noto Sans Tamil",
    "ta.mobile.bodyLLink": "Noto Sans Tamil",
    "ta.mobile.bodyM": "Noto Sans Tamil",
    "ta.mobile.bodyMBold": "Noto Sans Tamil",
    "ta.mobile.bodyMLink": "Noto Sans Tamil",
    "ta.mobile.bodyS": "Noto Sans Tamil",
    "ta.mobile.bodySBold": "Noto Sans Tamil",
    "ta.mobile.bodySLink": "Noto Sans Tamil",
    "ta.mobile.bodyXs": "Noto Sans Tamil",
    "ta.mobile.bodyXsBold": "Noto Sans Tamil",
    "ta.mobile.bodyXsLink": "Noto Sans Tamil",
    "ta.mobile.bodyXxs": "Noto Sans Tamil",
    "ta.mobile.bodyXxsBold": "Noto Sans Tamil",
    "ta.mobile.bodyXxsLink": "Noto Sans Tamil",
    "ta.mobile.body3xs": "Noto Sans Tamil",
    "ta.mobile.body3xsBold": "Noto Sans Tamil",
    "ta.mobile.body3xsLink": "Noto Sans Tamil",
    "ta.mobile.listTitle": "Noto Sans Tamil",
    "ta.mobile.button": "Noto Sans Tamil",
    "ta.mobile.code": "JetBrains Mono",
    "te.desktop.headingXl": "Noto Sans Telugu",
    "te.desktop.headingL": "Noto Sans Telugu",
    "te.desktop.headingM": "Noto Sans Telugu",
    "te.desktop.headingS": "Noto Sans Telugu",
    "te.desktop.headingXs": "Noto Sans Telugu",
    "te.desktop.headingXxs": "Noto Sans Telugu",
    "te.desktop.overline": "Noto Sans Telugu",
    "te.desktop.bodyL": "Noto Sans Telugu",
    "te.desktop.bodyLBold": "Noto Sans Telugu",
    "te.desktop.bodyLLink": "Noto Sans Telugu",
    "te.desktop.bodyM": "Noto Sans Telugu",
    "te.desktop.bodyMBold": "Noto Sans Telugu",
    "te.desktop.bodyMLink": "Noto Sans Telugu",
    "te.desktop.bodyS": "Noto Sans Telugu",
    "te.desktop.bodySBold": "Noto Sans Telugu",
    "te.desktop.bodySLink": "Noto Sans Telugu",
    "te.desktop.bodyXs": "Noto Sans Telugu",
    "te.desktop.bodyXsBold": "Noto Sans Telugu",
    "te.desktop.bodyXsLink": "Noto Sans Telugu",
    "te.desktop.bodyXxs": "Noto Sans Telugu",
    "te.desktop.bodyXxsBold": "Noto Sans Telugu",
    "te.desktop.bodyXxsLink": "Noto Sans Telugu",
    "te.desktop.body3xs": "Noto Sans Telugu",
    "te.desktop.body3xsBold": "Noto Sans Telugu",
    "te.desktop.body3xsLink": "Noto Sans Telugu",
    "te.desktop.listTitle": "Noto Sans Telugu",
    "te.desktop.button": "Noto Sans Telugu",
    "te.desktop.code": "JetBrains Mono",
    "te.mobile.headingXl": "Noto Sans Telugu",
    "te.mobile.headingL": "Noto Sans Telugu",
    "te.mobile.headingM": "Noto Sans Telugu",
    "te.mobile.headingS": "Noto Sans Telugu",
    "te.mobile.headingXs": "Noto Sans Telugu",
    "te.mobile.headingXxs": "Noto Sans Telugu",
    "te.mobile.overline": "Noto Sans Telugu",
    "te.mobile.bodyL": "Noto Sans Telugu",
    "te.mobile.bodyLBold": "Noto Sans Telugu",
    "te.mobile.bodyLLink": "Noto Sans Telugu",
    "te.mobile.bodyM": "Noto Sans Telugu",
    "te.mobile.bodyMBold": "Noto Sans Telugu",
    "te.mobile.bodyMLink": "Noto Sans Telugu",
    "te.mobile.bodyS": "Noto Sans Telugu",
    "te.mobile.bodySBold": "Noto Sans Telugu",
    "te.mobile.bodySLink": "Noto Sans Telugu",
    "te.mobile.bodyXs": "Noto Sans Telugu",
    "te.mobile.bodyXsBold": "Noto Sans Telugu",
    "te.mobile.bodyXsLink": "Noto Sans Telugu",
    "te.mobile.bodyXxs": "Noto Sans Telugu",
    "te.mobile.bodyXxsBold": "Noto Sans Telugu",
    "te.mobile.bodyXxsLink": "Noto Sans Telugu",
    "te.mobile.body3xs": "Noto Sans Telugu",
    "te.mobile.body3xsBold": "Noto Sans Telugu",
    "te.mobile.body3xsLink": "Noto Sans Telugu",
    "te.mobile.listTitle": "Noto Sans Telugu",
    "te.mobile.button": "Noto Sans Telugu",
    "te.mobile.code": "JetBrains Mono",
    headingXl: $52d4442770cfd938$var$headingXl$4,
    headingL: $52d4442770cfd938$var$headingL$4,
    headingM: $52d4442770cfd938$var$headingM$4,
    headingS: $52d4442770cfd938$var$headingS$4,
    headingXs: $52d4442770cfd938$var$headingXs$4,
    headingXxs: $52d4442770cfd938$var$headingXxs$4,
    overline: $52d4442770cfd938$var$overline$5,
    bodyL: $52d4442770cfd938$var$bodyL$4,
    bodyLBold: $52d4442770cfd938$var$bodyLBold$4,
    bodyLLink: $52d4442770cfd938$var$bodyLLink$4,
    bodyM: $52d4442770cfd938$var$bodyM$4,
    bodyMBold: $52d4442770cfd938$var$bodyMBold$4,
    bodyMLink: $52d4442770cfd938$var$bodyMLink$4,
    bodyS: $52d4442770cfd938$var$bodyS$4,
    bodySBold: $52d4442770cfd938$var$bodySBold$4,
    bodySLink: $52d4442770cfd938$var$bodySLink$4,
    bodyXs: $52d4442770cfd938$var$bodyXs$4,
    bodyXsBold: $52d4442770cfd938$var$bodyXsBold$4,
    bodyXsLink: $52d4442770cfd938$var$bodyXsLink$4,
    bodyXxs: $52d4442770cfd938$var$bodyXxs$4,
    bodyXxsBold: $52d4442770cfd938$var$bodyXxsBold$4,
    bodyXxsLink: $52d4442770cfd938$var$bodyXxsLink$4,
    body3xs: $52d4442770cfd938$var$body3xs$4,
    body3xsBold: $52d4442770cfd938$var$body3xsBold$4,
    body3xsLink: $52d4442770cfd938$var$body3xsLink$4,
    listTitle: $52d4442770cfd938$var$listTitle$4,
    button: $52d4442770cfd938$var$button$4,
    code: $52d4442770cfd938$var$code$4
};
const $52d4442770cfd938$var$headingXl$3 = "{$lang.$platform.headingXl}";
const $52d4442770cfd938$var$headingL$3 = "{$lang.$platform.headingL}";
const $52d4442770cfd938$var$headingM$3 = "{$lang.$platform.headingM}";
const $52d4442770cfd938$var$headingS$3 = "{$lang.$platform.headingS}";
const $52d4442770cfd938$var$headingXs$3 = "{$lang.$platform.headingXs}";
const $52d4442770cfd938$var$headingXxs$3 = "{$lang.$platform.headingXxs}";
const $52d4442770cfd938$var$overline$4 = "{$lang.$platform.overline}";
const $52d4442770cfd938$var$bodyL$3 = "{$lang.$platform.bodyL}";
const $52d4442770cfd938$var$bodyLBold$3 = "{$lang.$platform.bodyLBold}";
const $52d4442770cfd938$var$bodyLLink$3 = "{$lang.$platform.bodyLLink}";
const $52d4442770cfd938$var$bodyM$3 = "{$lang.$platform.bodyM}";
const $52d4442770cfd938$var$bodyMBold$3 = "{$lang.$platform.bodyMBold}";
const $52d4442770cfd938$var$bodyMLink$3 = "{$lang.$platform.bodyMLink}";
const $52d4442770cfd938$var$bodyS$3 = "{$lang.$platform.bodyS}";
const $52d4442770cfd938$var$bodySBold$3 = "{$lang.$platform.bodySBold}";
const $52d4442770cfd938$var$bodySLink$3 = "{$lang.$platform.bodySLink}";
const $52d4442770cfd938$var$bodyXs$3 = "{$lang.$platform.bodyXs}";
const $52d4442770cfd938$var$bodyXsBold$3 = "{$lang.$platform.bodyXsBold}";
const $52d4442770cfd938$var$bodyXsLink$3 = "{$lang.$platform.bodyXsLink}";
const $52d4442770cfd938$var$bodyXxs$3 = "{$lang.$platform.bodyXxs}";
const $52d4442770cfd938$var$bodyXxsBold$3 = "{$lang.$platform.bodyXxsBold}";
const $52d4442770cfd938$var$bodyXxsLink$3 = "{$lang.$platform.bodyXxsLink}";
const $52d4442770cfd938$var$body3xs$3 = "{$lang.$platform.body3xs}";
const $52d4442770cfd938$var$body3xsBold$3 = "{$lang.$platform.body3xsBold}";
const $52d4442770cfd938$var$body3xsLink$3 = "{$lang.$platform.body3xsLink}";
const $52d4442770cfd938$var$listTitle$3 = "{$lang.$platform.listTitle}";
const $52d4442770cfd938$var$button$3 = "{$lang.$platform.button}";
const $52d4442770cfd938$var$code$3 = "{$lang.$platform.code}";
const $52d4442770cfd938$var$fontSizes = {
    "as.desktop.headingXl": 88,
    "as.desktop.headingL": 64,
    "as.desktop.headingM": 40,
    "as.desktop.headingS": 32,
    "as.desktop.headingXs": 24,
    "as.desktop.headingXxs": 16,
    "as.desktop.overline": 12,
    "as.desktop.bodyL": 24,
    "as.desktop.bodyLBold": 24,
    "as.desktop.bodyLLink": 24,
    "as.desktop.bodyM": 18,
    "as.desktop.bodyMBold": 18,
    "as.desktop.bodyMLink": 18,
    "as.desktop.bodyS": 16,
    "as.desktop.bodySBold": 16,
    "as.desktop.bodySLink": 16,
    "as.desktop.bodyXs": 14,
    "as.desktop.bodyXsBold": 14,
    "as.desktop.bodyXsLink": 14,
    "as.desktop.bodyXxs": 12,
    "as.desktop.bodyXxsBold": 12,
    "as.desktop.bodyXxsLink": 12,
    "as.desktop.body3xs": 11,
    "as.desktop.body3xsBold": 11,
    "as.desktop.body3xsLink": 11,
    "as.desktop.listTitle": 16,
    "as.desktop.button": 16,
    "as.desktop.code": 12,
    "as.mobile.headingXl": 64,
    "as.mobile.headingL": 48,
    "as.mobile.headingM": 40,
    "as.mobile.headingS": 32,
    "as.mobile.headingXs": 24,
    "as.mobile.headingXxs": 16,
    "as.mobile.overline": 12,
    "as.mobile.bodyL": 24,
    "as.mobile.bodyLBold": 24,
    "as.mobile.bodyLLink": 24,
    "as.mobile.bodyM": 18,
    "as.mobile.bodyMBold": 18,
    "as.mobile.bodyMLink": 18,
    "as.mobile.bodyS": 16,
    "as.mobile.bodySBold": 16,
    "as.mobile.bodySLink": 16,
    "as.mobile.bodyXs": 14,
    "as.mobile.bodyXsBold": 14,
    "as.mobile.bodyXsLink": 14,
    "as.mobile.bodyXxs": 12,
    "as.mobile.bodyXxsBold": 12,
    "as.mobile.bodyXxsLink": 12,
    "as.mobile.body3xs": 11,
    "as.mobile.body3xsBold": 11,
    "as.mobile.body3xsLink": 11,
    "as.mobile.listTitle": 16,
    "as.mobile.button": 16,
    "as.mobile.code": 12,
    "bn.desktop.headingXl": 88,
    "bn.desktop.headingL": 64,
    "bn.desktop.headingM": 40,
    "bn.desktop.headingS": 32,
    "bn.desktop.headingXs": 24,
    "bn.desktop.headingXxs": 16,
    "bn.desktop.overline": 12,
    "bn.desktop.bodyL": 24,
    "bn.desktop.bodyLBold": 24,
    "bn.desktop.bodyLLink": 24,
    "bn.desktop.bodyM": 18,
    "bn.desktop.bodyMBold": 18,
    "bn.desktop.bodyMLink": 18,
    "bn.desktop.bodyS": 16,
    "bn.desktop.bodySBold": 16,
    "bn.desktop.bodySLink": 16,
    "bn.desktop.bodyXs": 14,
    "bn.desktop.bodyXsBold": 14,
    "bn.desktop.bodyXsLink": 14,
    "bn.desktop.bodyXxs": 12,
    "bn.desktop.bodyXxsBold": 12,
    "bn.desktop.bodyXxsLink": 12,
    "bn.desktop.body3xs": 11,
    "bn.desktop.body3xsBold": 11,
    "bn.desktop.body3xsLink": 11,
    "bn.desktop.listTitle": 16,
    "bn.desktop.button": 16,
    "bn.desktop.code": 12,
    "bn.mobile.headingXl": 64,
    "bn.mobile.headingL": 48,
    "bn.mobile.headingM": 40,
    "bn.mobile.headingS": 32,
    "bn.mobile.headingXs": 24,
    "bn.mobile.headingXxs": 16,
    "bn.mobile.overline": 12,
    "bn.mobile.bodyL": 24,
    "bn.mobile.bodyLBold": 24,
    "bn.mobile.bodyLLink": 24,
    "bn.mobile.bodyM": 18,
    "bn.mobile.bodyMBold": 18,
    "bn.mobile.bodyMLink": 18,
    "bn.mobile.bodyS": 16,
    "bn.mobile.bodySBold": 16,
    "bn.mobile.bodySLink": 16,
    "bn.mobile.bodyXs": 14,
    "bn.mobile.bodyXsBold": 14,
    "bn.mobile.bodyXsLink": 14,
    "bn.mobile.bodyXxs": 12,
    "bn.mobile.bodyXxsBold": 12,
    "bn.mobile.bodyXxsLink": 12,
    "bn.mobile.body3xs": 11,
    "bn.mobile.body3xsBold": 11,
    "bn.mobile.body3xsLink": 11,
    "bn.mobile.listTitle": 16,
    "bn.mobile.button": 16,
    "bn.mobile.code": 12,
    "en.desktop.headingXl": 88,
    "en.desktop.headingL": 64,
    "en.desktop.headingM": 40,
    "en.desktop.headingS": 32,
    "en.desktop.headingXs": 24,
    "en.desktop.headingXxs": 16,
    "en.desktop.overline": 12,
    "en.desktop.bodyL": 24,
    "en.desktop.bodyLBold": 24,
    "en.desktop.bodyLLink": 24,
    "en.desktop.bodyM": 18,
    "en.desktop.bodyMBold": 18,
    "en.desktop.bodyMLink": 18,
    "en.desktop.bodyS": 16,
    "en.desktop.bodySBold": 16,
    "en.desktop.bodySLink": 16,
    "en.desktop.bodyXs": 14,
    "en.desktop.bodyXsBold": 14,
    "en.desktop.bodyXsLink": 14,
    "en.desktop.bodyXxs": 12,
    "en.desktop.bodyXxsBold": 12,
    "en.desktop.bodyXxsLink": 12,
    "en.desktop.body3xs": 11,
    "en.desktop.body3xsBold": 11,
    "en.desktop.body3xsLink": 11,
    "en.desktop.listTitle": 16,
    "en.desktop.button": 16,
    "en.desktop.code": 12,
    "en.mobile.headingXl": 64,
    "en.mobile.headingL": 48,
    "en.mobile.headingM": 40,
    "en.mobile.headingS": 32,
    "en.mobile.headingXs": 24,
    "en.mobile.headingXxs": 16,
    "en.mobile.overline": 12,
    "en.mobile.bodyL": 24,
    "en.mobile.bodyLBold": 24,
    "en.mobile.bodyLLink": 24,
    "en.mobile.bodyM": 18,
    "en.mobile.bodyMBold": 18,
    "en.mobile.bodyMLink": 18,
    "en.mobile.bodyS": 16,
    "en.mobile.bodySBold": 16,
    "en.mobile.bodySLink": 16,
    "en.mobile.bodyXs": 14,
    "en.mobile.bodyXsBold": 14,
    "en.mobile.bodyXsLink": 14,
    "en.mobile.bodyXxs": 12,
    "en.mobile.bodyXxsBold": 12,
    "en.mobile.bodyXxsLink": 12,
    "en.mobile.body3xs": 11,
    "en.mobile.body3xsBold": 11,
    "en.mobile.body3xsLink": 11,
    "en.mobile.listTitle": 16,
    "en.mobile.button": 16,
    "en.mobile.code": 12,
    "gu.desktop.headingXl": 88,
    "gu.desktop.headingL": 64,
    "gu.desktop.headingM": 40,
    "gu.desktop.headingS": 32,
    "gu.desktop.headingXs": 24,
    "gu.desktop.headingXxs": 16,
    "gu.desktop.overline": 12,
    "gu.desktop.bodyL": 24,
    "gu.desktop.bodyLBold": 24,
    "gu.desktop.bodyLLink": 24,
    "gu.desktop.bodyM": 18,
    "gu.desktop.bodyMBold": 18,
    "gu.desktop.bodyMLink": 18,
    "gu.desktop.bodyS": 16,
    "gu.desktop.bodySBold": 16,
    "gu.desktop.bodySLink": 16,
    "gu.desktop.bodyXs": 14,
    "gu.desktop.bodyXsBold": 14,
    "gu.desktop.bodyXsLink": 14,
    "gu.desktop.bodyXxs": 12,
    "gu.desktop.bodyXxsBold": 12,
    "gu.desktop.bodyXxsLink": 12,
    "gu.desktop.body3xs": 11,
    "gu.desktop.body3xsBold": 11,
    "gu.desktop.body3xsLink": 11,
    "gu.desktop.listTitle": 16,
    "gu.desktop.button": 16,
    "gu.desktop.code": 12,
    "gu.mobile.headingXl": 64,
    "gu.mobile.headingL": 48,
    "gu.mobile.headingM": 40,
    "gu.mobile.headingS": 32,
    "gu.mobile.headingXs": 24,
    "gu.mobile.headingXxs": 16,
    "gu.mobile.overline": 12,
    "gu.mobile.bodyL": 24,
    "gu.mobile.bodyLBold": 24,
    "gu.mobile.bodyLLink": 24,
    "gu.mobile.bodyM": 18,
    "gu.mobile.bodyMBold": 18,
    "gu.mobile.bodyMLink": 18,
    "gu.mobile.bodyS": 16,
    "gu.mobile.bodySBold": 16,
    "gu.mobile.bodySLink": 16,
    "gu.mobile.bodyXs": 14,
    "gu.mobile.bodyXsBold": 14,
    "gu.mobile.bodyXsLink": 14,
    "gu.mobile.bodyXxs": 12,
    "gu.mobile.bodyXxsBold": 12,
    "gu.mobile.bodyXxsLink": 12,
    "gu.mobile.body3xs": 11,
    "gu.mobile.body3xsBold": 11,
    "gu.mobile.body3xsLink": 11,
    "gu.mobile.listTitle": 16,
    "gu.mobile.button": 16,
    "gu.mobile.code": 12,
    "hi.desktop.headingXl": 88,
    "hi.desktop.headingL": 64,
    "hi.desktop.headingM": 40,
    "hi.desktop.headingS": 32,
    "hi.desktop.headingXs": 24,
    "hi.desktop.headingXxs": 16,
    "hi.desktop.overline": 12,
    "hi.desktop.bodyL": 24,
    "hi.desktop.bodyLBold": 24,
    "hi.desktop.bodyLLink": 24,
    "hi.desktop.bodyM": 18,
    "hi.desktop.bodyMBold": 18,
    "hi.desktop.bodyMLink": 18,
    "hi.desktop.bodyS": 16,
    "hi.desktop.bodySBold": 16,
    "hi.desktop.bodySLink": 16,
    "hi.desktop.bodyXs": 14,
    "hi.desktop.bodyXsBold": 14,
    "hi.desktop.bodyXsLink": 14,
    "hi.desktop.bodyXxs": 12,
    "hi.desktop.bodyXxsBold": 12,
    "hi.desktop.bodyXxsLink": 12,
    "hi.desktop.body3xs": 11,
    "hi.desktop.body3xsBold": 11,
    "hi.desktop.body3xsLink": 11,
    "hi.desktop.listTitle": 16,
    "hi.desktop.button": 16,
    "hi.desktop.code": 12,
    "hi.mobile.headingXl": 64,
    "hi.mobile.headingL": 48,
    "hi.mobile.headingM": 40,
    "hi.mobile.headingS": 32,
    "hi.mobile.headingXs": 24,
    "hi.mobile.headingXxs": 16,
    "hi.mobile.overline": 12,
    "hi.mobile.bodyL": 24,
    "hi.mobile.bodyLBold": 24,
    "hi.mobile.bodyLLink": 24,
    "hi.mobile.bodyM": 18,
    "hi.mobile.bodyMBold": 18,
    "hi.mobile.bodyMLink": 18,
    "hi.mobile.bodyS": 16,
    "hi.mobile.bodySBold": 16,
    "hi.mobile.bodySLink": 16,
    "hi.mobile.bodyXs": 14,
    "hi.mobile.bodyXsBold": 14,
    "hi.mobile.bodyXsLink": 14,
    "hi.mobile.bodyXxs": 12,
    "hi.mobile.bodyXxsBold": 12,
    "hi.mobile.bodyXxsLink": 12,
    "hi.mobile.body3xs": 11,
    "hi.mobile.body3xsBold": 11,
    "hi.mobile.body3xsLink": 11,
    "hi.mobile.listTitle": 16,
    "hi.mobile.button": 16,
    "hi.mobile.code": 12,
    "kn.desktop.headingXl": 88,
    "kn.desktop.headingL": 64,
    "kn.desktop.headingM": 40,
    "kn.desktop.headingS": 32,
    "kn.desktop.headingXs": 24,
    "kn.desktop.headingXxs": 16,
    "kn.desktop.overline": 12,
    "kn.desktop.bodyL": 24,
    "kn.desktop.bodyLBold": 24,
    "kn.desktop.bodyLLink": 24,
    "kn.desktop.bodyM": 18,
    "kn.desktop.bodyMBold": 18,
    "kn.desktop.bodyMLink": 18,
    "kn.desktop.bodyS": 16,
    "kn.desktop.bodySBold": 16,
    "kn.desktop.bodySLink": 16,
    "kn.desktop.bodyXs": 14,
    "kn.desktop.bodyXsBold": 14,
    "kn.desktop.bodyXsLink": 14,
    "kn.desktop.bodyXxs": 12,
    "kn.desktop.bodyXxsBold": 12,
    "kn.desktop.bodyXxsLink": 12,
    "kn.desktop.body3xs": 11,
    "kn.desktop.body3xsBold": 11,
    "kn.desktop.body3xsLink": 11,
    "kn.desktop.listTitle": 16,
    "kn.desktop.button": 16,
    "kn.desktop.code": 12,
    "kn.mobile.headingXl": 64,
    "kn.mobile.headingL": 48,
    "kn.mobile.headingM": 40,
    "kn.mobile.headingS": 32,
    "kn.mobile.headingXs": 24,
    "kn.mobile.headingXxs": 16,
    "kn.mobile.overline": 12,
    "kn.mobile.bodyL": 24,
    "kn.mobile.bodyLBold": 24,
    "kn.mobile.bodyLLink": 24,
    "kn.mobile.bodyM": 18,
    "kn.mobile.bodyMBold": 18,
    "kn.mobile.bodyMLink": 18,
    "kn.mobile.bodyS": 16,
    "kn.mobile.bodySBold": 16,
    "kn.mobile.bodySLink": 16,
    "kn.mobile.bodyXs": 14,
    "kn.mobile.bodyXsBold": 14,
    "kn.mobile.bodyXsLink": 14,
    "kn.mobile.bodyXxs": 12,
    "kn.mobile.bodyXxsBold": 12,
    "kn.mobile.bodyXxsLink": 12,
    "kn.mobile.body3xs": 11,
    "kn.mobile.body3xsBold": 11,
    "kn.mobile.body3xsLink": 11,
    "kn.mobile.listTitle": 16,
    "kn.mobile.button": 16,
    "kn.mobile.code": 12,
    "ml.desktop.headingXl": 88,
    "ml.desktop.headingL": 64,
    "ml.desktop.headingM": 40,
    "ml.desktop.headingS": 32,
    "ml.desktop.headingXs": 24,
    "ml.desktop.headingXxs": 16,
    "ml.desktop.overline": 12,
    "ml.desktop.bodyL": 24,
    "ml.desktop.bodyLBold": 24,
    "ml.desktop.bodyLLink": 24,
    "ml.desktop.bodyM": 18,
    "ml.desktop.bodyMBold": 18,
    "ml.desktop.bodyMLink": 18,
    "ml.desktop.bodyS": 16,
    "ml.desktop.bodySBold": 16,
    "ml.desktop.bodySLink": 16,
    "ml.desktop.bodyXs": 14,
    "ml.desktop.bodyXsBold": 14,
    "ml.desktop.bodyXsLink": 14,
    "ml.desktop.bodyXxs": 12,
    "ml.desktop.bodyXxsBold": 12,
    "ml.desktop.bodyXxsLink": 12,
    "ml.desktop.body3xs": 11,
    "ml.desktop.body3xsBold": 11,
    "ml.desktop.body3xsLink": 11,
    "ml.desktop.listTitle": 16,
    "ml.desktop.button": 16,
    "ml.desktop.code": 12,
    "ml.mobile.headingXl": 64,
    "ml.mobile.headingL": 48,
    "ml.mobile.headingM": 40,
    "ml.mobile.headingS": 32,
    "ml.mobile.headingXs": 24,
    "ml.mobile.headingXxs": 16,
    "ml.mobile.overline": 12,
    "ml.mobile.bodyL": 24,
    "ml.mobile.bodyLBold": 24,
    "ml.mobile.bodyLLink": 24,
    "ml.mobile.bodyM": 18,
    "ml.mobile.bodyMBold": 18,
    "ml.mobile.bodyMLink": 18,
    "ml.mobile.bodyS": 16,
    "ml.mobile.bodySBold": 16,
    "ml.mobile.bodySLink": 16,
    "ml.mobile.bodyXs": 14,
    "ml.mobile.bodyXsBold": 14,
    "ml.mobile.bodyXsLink": 14,
    "ml.mobile.bodyXxs": 12,
    "ml.mobile.bodyXxsBold": 12,
    "ml.mobile.bodyXxsLink": 12,
    "ml.mobile.body3xs": 11,
    "ml.mobile.body3xsBold": 11,
    "ml.mobile.body3xsLink": 11,
    "ml.mobile.listTitle": 16,
    "ml.mobile.button": 16,
    "ml.mobile.code": 12,
    "mr.desktop.headingXl": 88,
    "mr.desktop.headingL": 64,
    "mr.desktop.headingM": 40,
    "mr.desktop.headingS": 32,
    "mr.desktop.headingXs": 24,
    "mr.desktop.headingXxs": 16,
    "mr.desktop.overline": 12,
    "mr.desktop.bodyL": 24,
    "mr.desktop.bodyLBold": 24,
    "mr.desktop.bodyLLink": 24,
    "mr.desktop.bodyM": 18,
    "mr.desktop.bodyMBold": 18,
    "mr.desktop.bodyMLink": 18,
    "mr.desktop.bodyS": 16,
    "mr.desktop.bodySBold": 16,
    "mr.desktop.bodySLink": 16,
    "mr.desktop.bodyXs": 14,
    "mr.desktop.bodyXsBold": 14,
    "mr.desktop.bodyXsLink": 14,
    "mr.desktop.bodyXxs": 12,
    "mr.desktop.bodyXxsBold": 12,
    "mr.desktop.bodyXxsLink": 12,
    "mr.desktop.body3xs": 11,
    "mr.desktop.body3xsBold": 11,
    "mr.desktop.body3xsLink": 11,
    "mr.desktop.listTitle": 16,
    "mr.desktop.button": 16,
    "mr.desktop.code": 12,
    "mr.mobile.headingXl": 64,
    "mr.mobile.headingL": 48,
    "mr.mobile.headingM": 40,
    "mr.mobile.headingS": 32,
    "mr.mobile.headingXs": 24,
    "mr.mobile.headingXxs": 16,
    "mr.mobile.overline": 12,
    "mr.mobile.bodyL": 24,
    "mr.mobile.bodyLBold": 24,
    "mr.mobile.bodyLLink": 24,
    "mr.mobile.bodyM": 18,
    "mr.mobile.bodyMBold": 18,
    "mr.mobile.bodyMLink": 18,
    "mr.mobile.bodyS": 16,
    "mr.mobile.bodySBold": 16,
    "mr.mobile.bodySLink": 16,
    "mr.mobile.bodyXs": 14,
    "mr.mobile.bodyXsBold": 14,
    "mr.mobile.bodyXsLink": 14,
    "mr.mobile.bodyXxs": 12,
    "mr.mobile.bodyXxsBold": 12,
    "mr.mobile.bodyXxsLink": 12,
    "mr.mobile.body3xs": 11,
    "mr.mobile.body3xsBold": 11,
    "mr.mobile.body3xsLink": 11,
    "mr.mobile.listTitle": 16,
    "mr.mobile.button": 16,
    "mr.mobile.code": 12,
    "or.desktop.headingXl": 88,
    "or.desktop.headingL": 64,
    "or.desktop.headingM": 40,
    "or.desktop.headingS": 32,
    "or.desktop.headingXs": 24,
    "or.desktop.headingXxs": 16,
    "or.desktop.overline": 12,
    "or.desktop.bodyL": 24,
    "or.desktop.bodyLBold": 24,
    "or.desktop.bodyLLink": 24,
    "or.desktop.bodyM": 18,
    "or.desktop.bodyMBold": 18,
    "or.desktop.bodyMLink": 18,
    "or.desktop.bodyS": 16,
    "or.desktop.bodySBold": 16,
    "or.desktop.bodySLink": 16,
    "or.desktop.bodyXs": 14,
    "or.desktop.bodyXsBold": 14,
    "or.desktop.bodyXsLink": 14,
    "or.desktop.bodyXxs": 12,
    "or.desktop.bodyXxsBold": 12,
    "or.desktop.bodyXxsLink": 12,
    "or.desktop.body3xs": 11,
    "or.desktop.body3xsBold": 11,
    "or.desktop.body3xsLink": 11,
    "or.desktop.listTitle": 16,
    "or.desktop.button": 16,
    "or.desktop.code": 12,
    "or.mobile.headingXl": 64,
    "or.mobile.headingL": 48,
    "or.mobile.headingM": 40,
    "or.mobile.headingS": 32,
    "or.mobile.headingXs": 24,
    "or.mobile.headingXxs": 16,
    "or.mobile.overline": 12,
    "or.mobile.bodyL": 24,
    "or.mobile.bodyLBold": 24,
    "or.mobile.bodyLLink": 24,
    "or.mobile.bodyM": 18,
    "or.mobile.bodyMBold": 18,
    "or.mobile.bodyMLink": 18,
    "or.mobile.bodyS": 16,
    "or.mobile.bodySBold": 16,
    "or.mobile.bodySLink": 16,
    "or.mobile.bodyXs": 14,
    "or.mobile.bodyXsBold": 14,
    "or.mobile.bodyXsLink": 14,
    "or.mobile.bodyXxs": 12,
    "or.mobile.bodyXxsBold": 12,
    "or.mobile.bodyXxsLink": 12,
    "or.mobile.body3xs": 11,
    "or.mobile.body3xsBold": 11,
    "or.mobile.body3xsLink": 11,
    "or.mobile.listTitle": 16,
    "or.mobile.button": 16,
    "or.mobile.code": 12,
    "pa.desktop.headingXl": 88,
    "pa.desktop.headingL": 64,
    "pa.desktop.headingM": 40,
    "pa.desktop.headingS": 32,
    "pa.desktop.headingXs": 24,
    "pa.desktop.headingXxs": 16,
    "pa.desktop.overline": 12,
    "pa.desktop.bodyL": 24,
    "pa.desktop.bodyLBold": 24,
    "pa.desktop.bodyLLink": 24,
    "pa.desktop.bodyM": 18,
    "pa.desktop.bodyMBold": 18,
    "pa.desktop.bodyMLink": 18,
    "pa.desktop.bodyS": 16,
    "pa.desktop.bodySBold": 16,
    "pa.desktop.bodySLink": 16,
    "pa.desktop.bodyXs": 14,
    "pa.desktop.bodyXsBold": 14,
    "pa.desktop.bodyXsLink": 14,
    "pa.desktop.bodyXxs": 12,
    "pa.desktop.bodyXxsBold": 12,
    "pa.desktop.bodyXxsLink": 12,
    "pa.desktop.body3xs": 11,
    "pa.desktop.body3xsBold": 11,
    "pa.desktop.body3xsLink": 11,
    "pa.desktop.listTitle": 16,
    "pa.desktop.button": 16,
    "pa.desktop.code": 12,
    "pa.mobile.headingXl": 64,
    "pa.mobile.headingL": 48,
    "pa.mobile.headingM": 40,
    "pa.mobile.headingS": 32,
    "pa.mobile.headingXs": 24,
    "pa.mobile.headingXxs": 16,
    "pa.mobile.overline": 12,
    "pa.mobile.bodyL": 24,
    "pa.mobile.bodyLBold": 24,
    "pa.mobile.bodyLLink": 24,
    "pa.mobile.bodyM": 18,
    "pa.mobile.bodyMBold": 18,
    "pa.mobile.bodyMLink": 18,
    "pa.mobile.bodyS": 16,
    "pa.mobile.bodySBold": 16,
    "pa.mobile.bodySLink": 16,
    "pa.mobile.bodyXs": 14,
    "pa.mobile.bodyXsBold": 14,
    "pa.mobile.bodyXsLink": 14,
    "pa.mobile.bodyXxs": 12,
    "pa.mobile.bodyXxsBold": 12,
    "pa.mobile.bodyXxsLink": 12,
    "pa.mobile.body3xs": 11,
    "pa.mobile.body3xsBold": 11,
    "pa.mobile.body3xsLink": 11,
    "pa.mobile.listTitle": 16,
    "pa.mobile.button": 16,
    "pa.mobile.code": 12,
    "ta.desktop.headingXl": 88,
    "ta.desktop.headingL": 64,
    "ta.desktop.headingM": 40,
    "ta.desktop.headingS": 32,
    "ta.desktop.headingXs": 24,
    "ta.desktop.headingXxs": 16,
    "ta.desktop.overline": 12,
    "ta.desktop.bodyL": 24,
    "ta.desktop.bodyLBold": 24,
    "ta.desktop.bodyLLink": 24,
    "ta.desktop.bodyM": 18,
    "ta.desktop.bodyMBold": 18,
    "ta.desktop.bodyMLink": 18,
    "ta.desktop.bodyS": 16,
    "ta.desktop.bodySBold": 16,
    "ta.desktop.bodySLink": 16,
    "ta.desktop.bodyXs": 14,
    "ta.desktop.bodyXsBold": 14,
    "ta.desktop.bodyXsLink": 14,
    "ta.desktop.bodyXxs": 12,
    "ta.desktop.bodyXxsBold": 12,
    "ta.desktop.bodyXxsLink": 12,
    "ta.desktop.body3xs": 11,
    "ta.desktop.body3xsBold": 11,
    "ta.desktop.body3xsLink": 11,
    "ta.desktop.listTitle": 16,
    "ta.desktop.button": 16,
    "ta.desktop.code": 12,
    "ta.mobile.headingXl": 64,
    "ta.mobile.headingL": 48,
    "ta.mobile.headingM": 40,
    "ta.mobile.headingS": 32,
    "ta.mobile.headingXs": 24,
    "ta.mobile.headingXxs": 16,
    "ta.mobile.overline": 12,
    "ta.mobile.bodyL": 24,
    "ta.mobile.bodyLBold": 24,
    "ta.mobile.bodyLLink": 24,
    "ta.mobile.bodyM": 18,
    "ta.mobile.bodyMBold": 18,
    "ta.mobile.bodyMLink": 18,
    "ta.mobile.bodyS": 16,
    "ta.mobile.bodySBold": 16,
    "ta.mobile.bodySLink": 16,
    "ta.mobile.bodyXs": 14,
    "ta.mobile.bodyXsBold": 14,
    "ta.mobile.bodyXsLink": 14,
    "ta.mobile.bodyXxs": 12,
    "ta.mobile.bodyXxsBold": 12,
    "ta.mobile.bodyXxsLink": 12,
    "ta.mobile.body3xs": 11,
    "ta.mobile.body3xsBold": 11,
    "ta.mobile.body3xsLink": 11,
    "ta.mobile.listTitle": 16,
    "ta.mobile.button": 16,
    "ta.mobile.code": 12,
    "te.desktop.headingXl": 88,
    "te.desktop.headingL": 64,
    "te.desktop.headingM": 40,
    "te.desktop.headingS": 32,
    "te.desktop.headingXs": 24,
    "te.desktop.headingXxs": 16,
    "te.desktop.overline": 12,
    "te.desktop.bodyL": 24,
    "te.desktop.bodyLBold": 24,
    "te.desktop.bodyLLink": 24,
    "te.desktop.bodyM": 18,
    "te.desktop.bodyMBold": 18,
    "te.desktop.bodyMLink": 18,
    "te.desktop.bodyS": 16,
    "te.desktop.bodySBold": 16,
    "te.desktop.bodySLink": 16,
    "te.desktop.bodyXs": 14,
    "te.desktop.bodyXsBold": 14,
    "te.desktop.bodyXsLink": 14,
    "te.desktop.bodyXxs": 12,
    "te.desktop.bodyXxsBold": 12,
    "te.desktop.bodyXxsLink": 12,
    "te.desktop.body3xs": 11,
    "te.desktop.body3xsBold": 11,
    "te.desktop.body3xsLink": 11,
    "te.desktop.listTitle": 16,
    "te.desktop.button": 16,
    "te.desktop.code": 12,
    "te.mobile.headingXl": 64,
    "te.mobile.headingL": 48,
    "te.mobile.headingM": 40,
    "te.mobile.headingS": 32,
    "te.mobile.headingXs": 24,
    "te.mobile.headingXxs": 16,
    "te.mobile.overline": 12,
    "te.mobile.bodyL": 24,
    "te.mobile.bodyLBold": 24,
    "te.mobile.bodyLLink": 24,
    "te.mobile.bodyM": 18,
    "te.mobile.bodyMBold": 18,
    "te.mobile.bodyMLink": 18,
    "te.mobile.bodyS": 16,
    "te.mobile.bodySBold": 16,
    "te.mobile.bodySLink": 16,
    "te.mobile.bodyXs": 14,
    "te.mobile.bodyXsBold": 14,
    "te.mobile.bodyXsLink": 14,
    "te.mobile.bodyXxs": 12,
    "te.mobile.bodyXxsBold": 12,
    "te.mobile.bodyXxsLink": 12,
    "te.mobile.body3xs": 11,
    "te.mobile.body3xsBold": 11,
    "te.mobile.body3xsLink": 11,
    "te.mobile.listTitle": 16,
    "te.mobile.button": 16,
    "te.mobile.code": 12,
    headingXl: $52d4442770cfd938$var$headingXl$3,
    headingL: $52d4442770cfd938$var$headingL$3,
    headingM: $52d4442770cfd938$var$headingM$3,
    headingS: $52d4442770cfd938$var$headingS$3,
    headingXs: $52d4442770cfd938$var$headingXs$3,
    headingXxs: $52d4442770cfd938$var$headingXxs$3,
    overline: $52d4442770cfd938$var$overline$4,
    bodyL: $52d4442770cfd938$var$bodyL$3,
    bodyLBold: $52d4442770cfd938$var$bodyLBold$3,
    bodyLLink: $52d4442770cfd938$var$bodyLLink$3,
    bodyM: $52d4442770cfd938$var$bodyM$3,
    bodyMBold: $52d4442770cfd938$var$bodyMBold$3,
    bodyMLink: $52d4442770cfd938$var$bodyMLink$3,
    bodyS: $52d4442770cfd938$var$bodyS$3,
    bodySBold: $52d4442770cfd938$var$bodySBold$3,
    bodySLink: $52d4442770cfd938$var$bodySLink$3,
    bodyXs: $52d4442770cfd938$var$bodyXs$3,
    bodyXsBold: $52d4442770cfd938$var$bodyXsBold$3,
    bodyXsLink: $52d4442770cfd938$var$bodyXsLink$3,
    bodyXxs: $52d4442770cfd938$var$bodyXxs$3,
    bodyXxsBold: $52d4442770cfd938$var$bodyXxsBold$3,
    bodyXxsLink: $52d4442770cfd938$var$bodyXxsLink$3,
    body3xs: $52d4442770cfd938$var$body3xs$3,
    body3xsBold: $52d4442770cfd938$var$body3xsBold$3,
    body3xsLink: $52d4442770cfd938$var$body3xsLink$3,
    listTitle: $52d4442770cfd938$var$listTitle$3,
    button: $52d4442770cfd938$var$button$3,
    code: $52d4442770cfd938$var$code$3
};
const $52d4442770cfd938$var$headingXl$2 = "{$lang.$platform.headingXl}";
const $52d4442770cfd938$var$headingL$2 = "{$lang.$platform.headingL}";
const $52d4442770cfd938$var$headingM$2 = "{$lang.$platform.headingM}";
const $52d4442770cfd938$var$headingS$2 = "{$lang.$platform.headingS}";
const $52d4442770cfd938$var$headingXs$2 = "{$lang.$platform.headingXs}";
const $52d4442770cfd938$var$headingXxs$2 = "{$lang.$platform.headingXxs}";
const $52d4442770cfd938$var$overline$3 = "{$lang.$platform.overline}";
const $52d4442770cfd938$var$bodyL$2 = "{$lang.$platform.bodyL}";
const $52d4442770cfd938$var$bodyLBold$2 = "{$lang.$platform.bodyLBold}";
const $52d4442770cfd938$var$bodyLLink$2 = "{$lang.$platform.bodyLLink}";
const $52d4442770cfd938$var$bodyM$2 = "{$lang.$platform.bodyM}";
const $52d4442770cfd938$var$bodyMBold$2 = "{$lang.$platform.bodyMBold}";
const $52d4442770cfd938$var$bodyMLink$2 = "{$lang.$platform.bodyMLink}";
const $52d4442770cfd938$var$bodyS$2 = "{$lang.$platform.bodyS}";
const $52d4442770cfd938$var$bodySBold$2 = "{$lang.$platform.bodySBold}";
const $52d4442770cfd938$var$bodySLink$2 = "{$lang.$platform.bodySLink}";
const $52d4442770cfd938$var$bodyXs$2 = "{$lang.$platform.bodyXs}";
const $52d4442770cfd938$var$bodyXsBold$2 = "{$lang.$platform.bodyXsBold}";
const $52d4442770cfd938$var$bodyXsLink$2 = "{$lang.$platform.bodyXsLink}";
const $52d4442770cfd938$var$bodyXxs$2 = "{$lang.$platform.bodyXxs}";
const $52d4442770cfd938$var$bodyXxsBold$2 = "{$lang.$platform.bodyXxsBold}";
const $52d4442770cfd938$var$bodyXxsLink$2 = "{$lang.$platform.bodyXxsLink}";
const $52d4442770cfd938$var$body3xs$2 = "{$lang.$platform.body3xs}";
const $52d4442770cfd938$var$body3xsBold$2 = "{$lang.$platform.body3xsBold}";
const $52d4442770cfd938$var$body3xsLink$2 = "{$lang.$platform.body3xsLink}";
const $52d4442770cfd938$var$listTitle$2 = "{$lang.$platform.listTitle}";
const $52d4442770cfd938$var$button$2 = "{$lang.$platform.button}";
const $52d4442770cfd938$var$code$2 = "{$lang.$platform.code}";
const $52d4442770cfd938$var$fontWeights = {
    "400": "400",
    "500": "500",
    "700": "700",
    "800": "800",
    "900": "900",
    "avatar.font.weight": "700",
    "badge.font.weight": "700",
    "button.font.weight": "700",
    "as.desktop.headingXl": 700,
    "as.desktop.headingL": 700,
    "as.desktop.headingM": 700,
    "as.desktop.headingS": 700,
    "as.desktop.headingXs": 700,
    "as.desktop.headingXxs": 700,
    "as.desktop.overline": 700,
    "as.desktop.bodyL": 400,
    "as.desktop.bodyLBold": 700,
    "as.desktop.bodyLLink": 700,
    "as.desktop.bodyM": 400,
    "as.desktop.bodyMBold": 700,
    "as.desktop.bodyMLink": 700,
    "as.desktop.bodyS": 400,
    "as.desktop.bodySBold": 700,
    "as.desktop.bodySLink": 700,
    "as.desktop.bodyXs": 400,
    "as.desktop.bodyXsBold": 700,
    "as.desktop.bodyXsLink": 700,
    "as.desktop.bodyXxs": 400,
    "as.desktop.bodyXxsBold": 700,
    "as.desktop.bodyXxsLink": 700,
    "as.desktop.body3xs": 400,
    "as.desktop.body3xsBold": 700,
    "as.desktop.body3xsLink": 700,
    "as.desktop.listTitle": 400,
    "as.desktop.button": 700,
    "as.desktop.code": 500,
    "as.mobile.headingXl": 700,
    "as.mobile.headingL": 700,
    "as.mobile.headingM": 700,
    "as.mobile.headingS": 700,
    "as.mobile.headingXs": 700,
    "as.mobile.headingXxs": 700,
    "as.mobile.overline": 700,
    "as.mobile.bodyL": 400,
    "as.mobile.bodyLBold": 700,
    "as.mobile.bodyLLink": 700,
    "as.mobile.bodyM": 400,
    "as.mobile.bodyMBold": 700,
    "as.mobile.bodyMLink": 700,
    "as.mobile.bodyS": 400,
    "as.mobile.bodySBold": 700,
    "as.mobile.bodySLink": 700,
    "as.mobile.bodyXs": 400,
    "as.mobile.bodyXsBold": 700,
    "as.mobile.bodyXsLink": 700,
    "as.mobile.bodyXxs": 400,
    "as.mobile.bodyXxsBold": 700,
    "as.mobile.bodyXxsLink": 700,
    "as.mobile.body3xs": 400,
    "as.mobile.body3xsBold": 700,
    "as.mobile.body3xsLink": 700,
    "as.mobile.listTitle": 400,
    "as.mobile.button": 700,
    "as.mobile.code": 500,
    "bn.desktop.headingXl": 700,
    "bn.desktop.headingL": 700,
    "bn.desktop.headingM": 700,
    "bn.desktop.headingS": 700,
    "bn.desktop.headingXs": 700,
    "bn.desktop.headingXxs": 700,
    "bn.desktop.overline": 700,
    "bn.desktop.bodyL": 400,
    "bn.desktop.bodyLBold": 700,
    "bn.desktop.bodyLLink": 700,
    "bn.desktop.bodyM": 400,
    "bn.desktop.bodyMBold": 700,
    "bn.desktop.bodyMLink": 700,
    "bn.desktop.bodyS": 400,
    "bn.desktop.bodySBold": 700,
    "bn.desktop.bodySLink": 700,
    "bn.desktop.bodyXs": 400,
    "bn.desktop.bodyXsBold": 700,
    "bn.desktop.bodyXsLink": 700,
    "bn.desktop.bodyXxs": 400,
    "bn.desktop.bodyXxsBold": 700,
    "bn.desktop.bodyXxsLink": 700,
    "bn.desktop.body3xs": 400,
    "bn.desktop.body3xsBold": 700,
    "bn.desktop.body3xsLink": 700,
    "bn.desktop.listTitle": 400,
    "bn.desktop.button": 700,
    "bn.desktop.code": 500,
    "bn.mobile.headingXl": 700,
    "bn.mobile.headingL": 700,
    "bn.mobile.headingM": 700,
    "bn.mobile.headingS": 700,
    "bn.mobile.headingXs": 700,
    "bn.mobile.headingXxs": 700,
    "bn.mobile.overline": 700,
    "bn.mobile.bodyL": 400,
    "bn.mobile.bodyLBold": 700,
    "bn.mobile.bodyLLink": 700,
    "bn.mobile.bodyM": 400,
    "bn.mobile.bodyMBold": 700,
    "bn.mobile.bodyMLink": 700,
    "bn.mobile.bodyS": 400,
    "bn.mobile.bodySBold": 700,
    "bn.mobile.bodySLink": 700,
    "bn.mobile.bodyXs": 400,
    "bn.mobile.bodyXsBold": 700,
    "bn.mobile.bodyXsLink": 700,
    "bn.mobile.bodyXxs": 400,
    "bn.mobile.bodyXxsBold": 700,
    "bn.mobile.bodyXxsLink": 700,
    "bn.mobile.body3xs": 400,
    "bn.mobile.body3xsBold": 700,
    "bn.mobile.body3xsLink": 700,
    "bn.mobile.listTitle": 400,
    "bn.mobile.button": 700,
    "bn.mobile.code": 500,
    "en.desktop.headingXl": 900,
    "en.desktop.headingL": 900,
    "en.desktop.headingM": 900,
    "en.desktop.headingS": 900,
    "en.desktop.headingXs": 900,
    "en.desktop.headingXxs": 900,
    "en.desktop.overline": 700,
    "en.desktop.bodyL": 500,
    "en.desktop.bodyLBold": 700,
    "en.desktop.bodyLLink": 700,
    "en.desktop.bodyM": 500,
    "en.desktop.bodyMBold": 700,
    "en.desktop.bodyMLink": 700,
    "en.desktop.bodyS": 500,
    "en.desktop.bodySBold": 700,
    "en.desktop.bodySLink": 700,
    "en.desktop.bodyXs": 500,
    "en.desktop.bodyXsBold": 700,
    "en.desktop.bodyXsLink": 700,
    "en.desktop.bodyXxs": 500,
    "en.desktop.bodyXxsBold": 700,
    "en.desktop.bodyXxsLink": 700,
    "en.desktop.body3xs": 500,
    "en.desktop.body3xsBold": 700,
    "en.desktop.body3xsLink": 700,
    "en.desktop.listTitle": 500,
    "en.desktop.button": 700,
    "en.desktop.code": 500,
    "en.mobile.headingXl": 900,
    "en.mobile.headingL": 900,
    "en.mobile.headingM": 900,
    "en.mobile.headingS": 900,
    "en.mobile.headingXs": 900,
    "en.mobile.headingXxs": 900,
    "en.mobile.overline": 700,
    "en.mobile.bodyL": 500,
    "en.mobile.bodyLBold": 700,
    "en.mobile.bodyLLink": 700,
    "en.mobile.bodyM": 500,
    "en.mobile.bodyMBold": 700,
    "en.mobile.bodyMLink": 700,
    "en.mobile.bodyS": 500,
    "en.mobile.bodySBold": 700,
    "en.mobile.bodySLink": 700,
    "en.mobile.bodyXs": 500,
    "en.mobile.bodyXsBold": 700,
    "en.mobile.bodyXsLink": 700,
    "en.mobile.bodyXxs": 500,
    "en.mobile.bodyXxsBold": 700,
    "en.mobile.bodyXxsLink": 700,
    "en.mobile.body3xs": 500,
    "en.mobile.body3xsBold": 700,
    "en.mobile.body3xsLink": 700,
    "en.mobile.listTitle": 500,
    "en.mobile.button": 700,
    "en.mobile.code": 500,
    "gu.desktop.headingXl": 700,
    "gu.desktop.headingL": 700,
    "gu.desktop.headingM": 700,
    "gu.desktop.headingS": 700,
    "gu.desktop.headingXs": 700,
    "gu.desktop.headingXxs": 700,
    "gu.desktop.overline": 700,
    "gu.desktop.bodyL": 400,
    "gu.desktop.bodyLBold": 700,
    "gu.desktop.bodyLLink": 700,
    "gu.desktop.bodyM": 400,
    "gu.desktop.bodyMBold": 700,
    "gu.desktop.bodyMLink": 700,
    "gu.desktop.bodyS": 400,
    "gu.desktop.bodySBold": 700,
    "gu.desktop.bodySLink": 700,
    "gu.desktop.bodyXs": 400,
    "gu.desktop.bodyXsBold": 700,
    "gu.desktop.bodyXsLink": 700,
    "gu.desktop.bodyXxs": 400,
    "gu.desktop.bodyXxsBold": 700,
    "gu.desktop.bodyXxsLink": 700,
    "gu.desktop.body3xs": 400,
    "gu.desktop.body3xsBold": 700,
    "gu.desktop.body3xsLink": 700,
    "gu.desktop.listTitle": 400,
    "gu.desktop.button": 700,
    "gu.desktop.code": 500,
    "gu.mobile.headingXl": 700,
    "gu.mobile.headingL": 700,
    "gu.mobile.headingM": 700,
    "gu.mobile.headingS": 700,
    "gu.mobile.headingXs": 700,
    "gu.mobile.headingXxs": 700,
    "gu.mobile.overline": 700,
    "gu.mobile.bodyL": 400,
    "gu.mobile.bodyLBold": 700,
    "gu.mobile.bodyLLink": 700,
    "gu.mobile.bodyM": 400,
    "gu.mobile.bodyMBold": 700,
    "gu.mobile.bodyMLink": 700,
    "gu.mobile.bodyS": 400,
    "gu.mobile.bodySBold": 700,
    "gu.mobile.bodySLink": 700,
    "gu.mobile.bodyXs": 400,
    "gu.mobile.bodyXsBold": 700,
    "gu.mobile.bodyXsLink": 700,
    "gu.mobile.bodyXxs": 400,
    "gu.mobile.bodyXxsBold": 700,
    "gu.mobile.bodyXxsLink": 700,
    "gu.mobile.body3xs": 400,
    "gu.mobile.body3xsBold": 700,
    "gu.mobile.body3xsLink": 700,
    "gu.mobile.listTitle": 400,
    "gu.mobile.button": 700,
    "gu.mobile.code": 500,
    "hi.desktop.headingXl": 700,
    "hi.desktop.headingL": 700,
    "hi.desktop.headingM": 700,
    "hi.desktop.headingS": 700,
    "hi.desktop.headingXs": 700,
    "hi.desktop.headingXxs": 700,
    "hi.desktop.overline": 700,
    "hi.desktop.bodyL": 400,
    "hi.desktop.bodyLBold": 700,
    "hi.desktop.bodyLLink": 700,
    "hi.desktop.bodyM": 400,
    "hi.desktop.bodyMBold": 700,
    "hi.desktop.bodyMLink": 700,
    "hi.desktop.bodyS": 400,
    "hi.desktop.bodySBold": 700,
    "hi.desktop.bodySLink": 700,
    "hi.desktop.bodyXs": 400,
    "hi.desktop.bodyXsBold": 700,
    "hi.desktop.bodyXsLink": 700,
    "hi.desktop.bodyXxs": 400,
    "hi.desktop.bodyXxsBold": 700,
    "hi.desktop.bodyXxsLink": 700,
    "hi.desktop.body3xs": 400,
    "hi.desktop.body3xsBold": 700,
    "hi.desktop.body3xsLink": 700,
    "hi.desktop.listTitle": 400,
    "hi.desktop.button": 700,
    "hi.desktop.code": 500,
    "hi.mobile.headingXl": 700,
    "hi.mobile.headingL": 700,
    "hi.mobile.headingM": 700,
    "hi.mobile.headingS": 700,
    "hi.mobile.headingXs": 700,
    "hi.mobile.headingXxs": 700,
    "hi.mobile.overline": 700,
    "hi.mobile.bodyL": 400,
    "hi.mobile.bodyLBold": 700,
    "hi.mobile.bodyLLink": 700,
    "hi.mobile.bodyM": 400,
    "hi.mobile.bodyMBold": 700,
    "hi.mobile.bodyMLink": 700,
    "hi.mobile.bodyS": 400,
    "hi.mobile.bodySBold": 700,
    "hi.mobile.bodySLink": 700,
    "hi.mobile.bodyXs": 400,
    "hi.mobile.bodyXsBold": 700,
    "hi.mobile.bodyXsLink": 700,
    "hi.mobile.bodyXxs": 400,
    "hi.mobile.bodyXxsBold": 700,
    "hi.mobile.bodyXxsLink": 700,
    "hi.mobile.body3xs": 400,
    "hi.mobile.body3xsBold": 700,
    "hi.mobile.body3xsLink": 700,
    "hi.mobile.listTitle": 400,
    "hi.mobile.button": 700,
    "hi.mobile.code": 500,
    "kn.desktop.headingXl": 700,
    "kn.desktop.headingL": 700,
    "kn.desktop.headingM": 700,
    "kn.desktop.headingS": 700,
    "kn.desktop.headingXs": 700,
    "kn.desktop.headingXxs": 700,
    "kn.desktop.overline": 700,
    "kn.desktop.bodyL": 400,
    "kn.desktop.bodyLBold": 700,
    "kn.desktop.bodyLLink": 700,
    "kn.desktop.bodyM": 400,
    "kn.desktop.bodyMBold": 700,
    "kn.desktop.bodyMLink": 700,
    "kn.desktop.bodyS": 400,
    "kn.desktop.bodySBold": 700,
    "kn.desktop.bodySLink": 700,
    "kn.desktop.bodyXs": 400,
    "kn.desktop.bodyXsBold": 700,
    "kn.desktop.bodyXsLink": 700,
    "kn.desktop.bodyXxs": 400,
    "kn.desktop.bodyXxsBold": 700,
    "kn.desktop.bodyXxsLink": 700,
    "kn.desktop.body3xs": 400,
    "kn.desktop.body3xsBold": 700,
    "kn.desktop.body3xsLink": 700,
    "kn.desktop.listTitle": 400,
    "kn.desktop.button": 700,
    "kn.desktop.code": 500,
    "kn.mobile.headingXl": 700,
    "kn.mobile.headingL": 700,
    "kn.mobile.headingM": 700,
    "kn.mobile.headingS": 700,
    "kn.mobile.headingXs": 700,
    "kn.mobile.headingXxs": 700,
    "kn.mobile.overline": 700,
    "kn.mobile.bodyL": 400,
    "kn.mobile.bodyLBold": 700,
    "kn.mobile.bodyLLink": 700,
    "kn.mobile.bodyM": 400,
    "kn.mobile.bodyMBold": 700,
    "kn.mobile.bodyMLink": 700,
    "kn.mobile.bodyS": 400,
    "kn.mobile.bodySBold": 700,
    "kn.mobile.bodySLink": 700,
    "kn.mobile.bodyXs": 400,
    "kn.mobile.bodyXsBold": 700,
    "kn.mobile.bodyXsLink": 700,
    "kn.mobile.bodyXxs": 400,
    "kn.mobile.bodyXxsBold": 700,
    "kn.mobile.bodyXxsLink": 700,
    "kn.mobile.body3xs": 400,
    "kn.mobile.body3xsBold": 700,
    "kn.mobile.body3xsLink": 700,
    "kn.mobile.listTitle": 400,
    "kn.mobile.button": 700,
    "kn.mobile.code": 500,
    "ml.desktop.headingXl": 700,
    "ml.desktop.headingL": 700,
    "ml.desktop.headingM": 700,
    "ml.desktop.headingS": 700,
    "ml.desktop.headingXs": 700,
    "ml.desktop.headingXxs": 700,
    "ml.desktop.overline": 700,
    "ml.desktop.bodyL": 400,
    "ml.desktop.bodyLBold": 700,
    "ml.desktop.bodyLLink": 700,
    "ml.desktop.bodyM": 400,
    "ml.desktop.bodyMBold": 700,
    "ml.desktop.bodyMLink": 700,
    "ml.desktop.bodyS": 400,
    "ml.desktop.bodySBold": 700,
    "ml.desktop.bodySLink": 700,
    "ml.desktop.bodyXs": 400,
    "ml.desktop.bodyXsBold": 700,
    "ml.desktop.bodyXsLink": 700,
    "ml.desktop.bodyXxs": 400,
    "ml.desktop.bodyXxsBold": 700,
    "ml.desktop.bodyXxsLink": 700,
    "ml.desktop.body3xs": 400,
    "ml.desktop.body3xsBold": 700,
    "ml.desktop.body3xsLink": 700,
    "ml.desktop.listTitle": 400,
    "ml.desktop.button": 700,
    "ml.desktop.code": 500,
    "ml.mobile.headingXl": 700,
    "ml.mobile.headingL": 700,
    "ml.mobile.headingM": 700,
    "ml.mobile.headingS": 700,
    "ml.mobile.headingXs": 700,
    "ml.mobile.headingXxs": 700,
    "ml.mobile.overline": 700,
    "ml.mobile.bodyL": 400,
    "ml.mobile.bodyLBold": 700,
    "ml.mobile.bodyLLink": 700,
    "ml.mobile.bodyM": 400,
    "ml.mobile.bodyMBold": 700,
    "ml.mobile.bodyMLink": 700,
    "ml.mobile.bodyS": 400,
    "ml.mobile.bodySBold": 700,
    "ml.mobile.bodySLink": 700,
    "ml.mobile.bodyXs": 400,
    "ml.mobile.bodyXsBold": 700,
    "ml.mobile.bodyXsLink": 700,
    "ml.mobile.bodyXxs": 400,
    "ml.mobile.bodyXxsBold": 700,
    "ml.mobile.bodyXxsLink": 700,
    "ml.mobile.body3xs": 400,
    "ml.mobile.body3xsBold": 700,
    "ml.mobile.body3xsLink": 700,
    "ml.mobile.listTitle": 400,
    "ml.mobile.button": 700,
    "ml.mobile.code": 500,
    "mr.desktop.headingXl": 700,
    "mr.desktop.headingL": 700,
    "mr.desktop.headingM": 700,
    "mr.desktop.headingS": 700,
    "mr.desktop.headingXs": 700,
    "mr.desktop.headingXxs": 700,
    "mr.desktop.overline": 700,
    "mr.desktop.bodyL": 400,
    "mr.desktop.bodyLBold": 700,
    "mr.desktop.bodyLLink": 700,
    "mr.desktop.bodyM": 400,
    "mr.desktop.bodyMBold": 700,
    "mr.desktop.bodyMLink": 700,
    "mr.desktop.bodyS": 400,
    "mr.desktop.bodySBold": 700,
    "mr.desktop.bodySLink": 700,
    "mr.desktop.bodyXs": 400,
    "mr.desktop.bodyXsBold": 700,
    "mr.desktop.bodyXsLink": 700,
    "mr.desktop.bodyXxs": 400,
    "mr.desktop.bodyXxsBold": 700,
    "mr.desktop.bodyXxsLink": 700,
    "mr.desktop.body3xs": 400,
    "mr.desktop.body3xsBold": 700,
    "mr.desktop.body3xsLink": 700,
    "mr.desktop.listTitle": 400,
    "mr.desktop.button": 700,
    "mr.desktop.code": 500,
    "mr.mobile.headingXl": 700,
    "mr.mobile.headingL": 700,
    "mr.mobile.headingM": 700,
    "mr.mobile.headingS": 700,
    "mr.mobile.headingXs": 700,
    "mr.mobile.headingXxs": 700,
    "mr.mobile.overline": 700,
    "mr.mobile.bodyL": 400,
    "mr.mobile.bodyLBold": 700,
    "mr.mobile.bodyLLink": 700,
    "mr.mobile.bodyM": 400,
    "mr.mobile.bodyMBold": 700,
    "mr.mobile.bodyMLink": 700,
    "mr.mobile.bodyS": 400,
    "mr.mobile.bodySBold": 700,
    "mr.mobile.bodySLink": 700,
    "mr.mobile.bodyXs": 400,
    "mr.mobile.bodyXsBold": 700,
    "mr.mobile.bodyXsLink": 700,
    "mr.mobile.bodyXxs": 400,
    "mr.mobile.bodyXxsBold": 700,
    "mr.mobile.bodyXxsLink": 700,
    "mr.mobile.body3xs": 400,
    "mr.mobile.body3xsBold": 700,
    "mr.mobile.body3xsLink": 700,
    "mr.mobile.listTitle": 400,
    "mr.mobile.button": 700,
    "mr.mobile.code": 500,
    "or.desktop.headingXl": 700,
    "or.desktop.headingL": 700,
    "or.desktop.headingM": 700,
    "or.desktop.headingS": 700,
    "or.desktop.headingXs": 700,
    "or.desktop.headingXxs": 700,
    "or.desktop.overline": 700,
    "or.desktop.bodyL": 400,
    "or.desktop.bodyLBold": 700,
    "or.desktop.bodyLLink": 700,
    "or.desktop.bodyM": 400,
    "or.desktop.bodyMBold": 700,
    "or.desktop.bodyMLink": 700,
    "or.desktop.bodyS": 400,
    "or.desktop.bodySBold": 700,
    "or.desktop.bodySLink": 700,
    "or.desktop.bodyXs": 400,
    "or.desktop.bodyXsBold": 700,
    "or.desktop.bodyXsLink": 700,
    "or.desktop.bodyXxs": 400,
    "or.desktop.bodyXxsBold": 700,
    "or.desktop.bodyXxsLink": 700,
    "or.desktop.body3xs": 400,
    "or.desktop.body3xsBold": 700,
    "or.desktop.body3xsLink": 700,
    "or.desktop.listTitle": 400,
    "or.desktop.button": 700,
    "or.desktop.code": 500,
    "or.mobile.headingXl": 700,
    "or.mobile.headingL": 700,
    "or.mobile.headingM": 700,
    "or.mobile.headingS": 700,
    "or.mobile.headingXs": 700,
    "or.mobile.headingXxs": 700,
    "or.mobile.overline": 700,
    "or.mobile.bodyL": 400,
    "or.mobile.bodyLBold": 700,
    "or.mobile.bodyLLink": 700,
    "or.mobile.bodyM": 400,
    "or.mobile.bodyMBold": 700,
    "or.mobile.bodyMLink": 700,
    "or.mobile.bodyS": 400,
    "or.mobile.bodySBold": 700,
    "or.mobile.bodySLink": 700,
    "or.mobile.bodyXs": 400,
    "or.mobile.bodyXsBold": 700,
    "or.mobile.bodyXsLink": 700,
    "or.mobile.bodyXxs": 400,
    "or.mobile.bodyXxsBold": 700,
    "or.mobile.bodyXxsLink": 700,
    "or.mobile.body3xs": 400,
    "or.mobile.body3xsBold": 700,
    "or.mobile.body3xsLink": 700,
    "or.mobile.listTitle": 400,
    "or.mobile.button": 700,
    "or.mobile.code": 500,
    "pa.desktop.headingXl": 700,
    "pa.desktop.headingL": 700,
    "pa.desktop.headingM": 700,
    "pa.desktop.headingS": 700,
    "pa.desktop.headingXs": 700,
    "pa.desktop.headingXxs": 700,
    "pa.desktop.overline": 700,
    "pa.desktop.bodyL": 400,
    "pa.desktop.bodyLBold": 700,
    "pa.desktop.bodyLLink": 700,
    "pa.desktop.bodyM": 400,
    "pa.desktop.bodyMBold": 700,
    "pa.desktop.bodyMLink": 700,
    "pa.desktop.bodyS": 400,
    "pa.desktop.bodySBold": 700,
    "pa.desktop.bodySLink": 700,
    "pa.desktop.bodyXs": 400,
    "pa.desktop.bodyXsBold": 700,
    "pa.desktop.bodyXsLink": 700,
    "pa.desktop.bodyXxs": 400,
    "pa.desktop.bodyXxsBold": 700,
    "pa.desktop.bodyXxsLink": 700,
    "pa.desktop.body3xs": 400,
    "pa.desktop.body3xsBold": 700,
    "pa.desktop.body3xsLink": 700,
    "pa.desktop.listTitle": 400,
    "pa.desktop.button": 700,
    "pa.desktop.code": 500,
    "pa.mobile.headingXl": 700,
    "pa.mobile.headingL": 700,
    "pa.mobile.headingM": 700,
    "pa.mobile.headingS": 700,
    "pa.mobile.headingXs": 700,
    "pa.mobile.headingXxs": 700,
    "pa.mobile.overline": 700,
    "pa.mobile.bodyL": 400,
    "pa.mobile.bodyLBold": 700,
    "pa.mobile.bodyLLink": 700,
    "pa.mobile.bodyM": 400,
    "pa.mobile.bodyMBold": 700,
    "pa.mobile.bodyMLink": 700,
    "pa.mobile.bodyS": 400,
    "pa.mobile.bodySBold": 700,
    "pa.mobile.bodySLink": 700,
    "pa.mobile.bodyXs": 400,
    "pa.mobile.bodyXsBold": 700,
    "pa.mobile.bodyXsLink": 700,
    "pa.mobile.bodyXxs": 400,
    "pa.mobile.bodyXxsBold": 700,
    "pa.mobile.bodyXxsLink": 700,
    "pa.mobile.body3xs": 400,
    "pa.mobile.body3xsBold": 700,
    "pa.mobile.body3xsLink": 700,
    "pa.mobile.listTitle": 400,
    "pa.mobile.button": 700,
    "pa.mobile.code": 500,
    "ta.desktop.headingXl": 700,
    "ta.desktop.headingL": 700,
    "ta.desktop.headingM": 700,
    "ta.desktop.headingS": 700,
    "ta.desktop.headingXs": 700,
    "ta.desktop.headingXxs": 700,
    "ta.desktop.overline": 700,
    "ta.desktop.bodyL": 400,
    "ta.desktop.bodyLBold": 700,
    "ta.desktop.bodyLLink": 700,
    "ta.desktop.bodyM": 400,
    "ta.desktop.bodyMBold": 700,
    "ta.desktop.bodyMLink": 700,
    "ta.desktop.bodyS": 400,
    "ta.desktop.bodySBold": 700,
    "ta.desktop.bodySLink": 700,
    "ta.desktop.bodyXs": 400,
    "ta.desktop.bodyXsBold": 700,
    "ta.desktop.bodyXsLink": 700,
    "ta.desktop.bodyXxs": 400,
    "ta.desktop.bodyXxsBold": 700,
    "ta.desktop.bodyXxsLink": 700,
    "ta.desktop.body3xs": 400,
    "ta.desktop.body3xsBold": 700,
    "ta.desktop.body3xsLink": 700,
    "ta.desktop.listTitle": 400,
    "ta.desktop.button": 700,
    "ta.desktop.code": 500,
    "ta.mobile.headingXl": 700,
    "ta.mobile.headingL": 700,
    "ta.mobile.headingM": 700,
    "ta.mobile.headingS": 700,
    "ta.mobile.headingXs": 700,
    "ta.mobile.headingXxs": 700,
    "ta.mobile.overline": 700,
    "ta.mobile.bodyL": 400,
    "ta.mobile.bodyLBold": 700,
    "ta.mobile.bodyLLink": 700,
    "ta.mobile.bodyM": 400,
    "ta.mobile.bodyMBold": 700,
    "ta.mobile.bodyMLink": 700,
    "ta.mobile.bodyS": 400,
    "ta.mobile.bodySBold": 700,
    "ta.mobile.bodySLink": 700,
    "ta.mobile.bodyXs": 400,
    "ta.mobile.bodyXsBold": 700,
    "ta.mobile.bodyXsLink": 700,
    "ta.mobile.bodyXxs": 400,
    "ta.mobile.bodyXxsBold": 700,
    "ta.mobile.bodyXxsLink": 700,
    "ta.mobile.body3xs": 400,
    "ta.mobile.body3xsBold": 700,
    "ta.mobile.body3xsLink": 700,
    "ta.mobile.listTitle": 400,
    "ta.mobile.button": 700,
    "ta.mobile.code": 500,
    "te.desktop.headingXl": 700,
    "te.desktop.headingL": 700,
    "te.desktop.headingM": 700,
    "te.desktop.headingS": 700,
    "te.desktop.headingXs": 700,
    "te.desktop.headingXxs": 700,
    "te.desktop.overline": 700,
    "te.desktop.bodyL": 400,
    "te.desktop.bodyLBold": 700,
    "te.desktop.bodyLLink": 700,
    "te.desktop.bodyM": 400,
    "te.desktop.bodyMBold": 700,
    "te.desktop.bodyMLink": 700,
    "te.desktop.bodyS": 400,
    "te.desktop.bodySBold": 700,
    "te.desktop.bodySLink": 700,
    "te.desktop.bodyXs": 400,
    "te.desktop.bodyXsBold": 700,
    "te.desktop.bodyXsLink": 700,
    "te.desktop.bodyXxs": 400,
    "te.desktop.bodyXxsBold": 700,
    "te.desktop.bodyXxsLink": 700,
    "te.desktop.body3xs": 400,
    "te.desktop.body3xsBold": 700,
    "te.desktop.body3xsLink": 700,
    "te.desktop.listTitle": 400,
    "te.desktop.button": 700,
    "te.desktop.code": 500,
    "te.mobile.headingXl": 700,
    "te.mobile.headingL": 700,
    "te.mobile.headingM": 700,
    "te.mobile.headingS": 700,
    "te.mobile.headingXs": 700,
    "te.mobile.headingXxs": 700,
    "te.mobile.overline": 700,
    "te.mobile.bodyL": 400,
    "te.mobile.bodyLBold": 700,
    "te.mobile.bodyLLink": 700,
    "te.mobile.bodyM": 400,
    "te.mobile.bodyMBold": 700,
    "te.mobile.bodyMLink": 700,
    "te.mobile.bodyS": 400,
    "te.mobile.bodySBold": 700,
    "te.mobile.bodySLink": 700,
    "te.mobile.bodyXs": 400,
    "te.mobile.bodyXsBold": 700,
    "te.mobile.bodyXsLink": 700,
    "te.mobile.bodyXxs": 400,
    "te.mobile.bodyXxsBold": 700,
    "te.mobile.bodyXxsLink": 700,
    "te.mobile.body3xs": 400,
    "te.mobile.body3xsBold": 700,
    "te.mobile.body3xsLink": 700,
    "te.mobile.listTitle": 400,
    "te.mobile.button": 700,
    "te.mobile.code": 500,
    headingXl: $52d4442770cfd938$var$headingXl$2,
    headingL: $52d4442770cfd938$var$headingL$2,
    headingM: $52d4442770cfd938$var$headingM$2,
    headingS: $52d4442770cfd938$var$headingS$2,
    headingXs: $52d4442770cfd938$var$headingXs$2,
    headingXxs: $52d4442770cfd938$var$headingXxs$2,
    overline: $52d4442770cfd938$var$overline$3,
    bodyL: $52d4442770cfd938$var$bodyL$2,
    bodyLBold: $52d4442770cfd938$var$bodyLBold$2,
    bodyLLink: $52d4442770cfd938$var$bodyLLink$2,
    bodyM: $52d4442770cfd938$var$bodyM$2,
    bodyMBold: $52d4442770cfd938$var$bodyMBold$2,
    bodyMLink: $52d4442770cfd938$var$bodyMLink$2,
    bodyS: $52d4442770cfd938$var$bodyS$2,
    bodySBold: $52d4442770cfd938$var$bodySBold$2,
    bodySLink: $52d4442770cfd938$var$bodySLink$2,
    bodyXs: $52d4442770cfd938$var$bodyXs$2,
    bodyXsBold: $52d4442770cfd938$var$bodyXsBold$2,
    bodyXsLink: $52d4442770cfd938$var$bodyXsLink$2,
    bodyXxs: $52d4442770cfd938$var$bodyXxs$2,
    bodyXxsBold: $52d4442770cfd938$var$bodyXxsBold$2,
    bodyXxsLink: $52d4442770cfd938$var$bodyXxsLink$2,
    body3xs: $52d4442770cfd938$var$body3xs$2,
    body3xsBold: $52d4442770cfd938$var$body3xsBold$2,
    body3xsLink: $52d4442770cfd938$var$body3xsLink$2,
    listTitle: $52d4442770cfd938$var$listTitle$2,
    button: $52d4442770cfd938$var$button$2,
    code: $52d4442770cfd938$var$code$2
};
const $52d4442770cfd938$var$JSON_MAP$1 = {
    "JDSActionButton": {
        "a_0": "{global.transparent}",
        "a_1": "{opacity.enabled}",
        "a_2": "{flexDirection.stack}",
        "a_3": "{alignItems.center}",
        "a_4": "{justifyContent.center}",
        "a_5": "{pill}",
        "a_6": "{primary50}",
        "a_7": "{flexDirection.row}",
        "a_8": "{alignItems.center}",
        "a_9": "{justifyContent.center}",
        "a_10": "{pill}",
        "a_11": "{xs}",
        "a_12": "{base}",
        "a_13": "{xs}",
        "a_14": "{base}",
        "a_15": "{xs}",
        "a_16": "{primary30}",
        "a_17": "{primary60}",
        "a_18": "{border_focus}",
        "a_19": "{primary60}",
        "a_20": "{primary50}",
        "a_21": "{global.transparent}",
        "a_22": "{primaryGrey40}",
        "a_23": "{border_focus}",
        "a_24": "{border_none}",
        "a_25": "{opacity.enabled}",
        "a_26": "{m}",
        "a_27": "{m}",
        "a_28": "{primaryInverse}",
        "a_29": "{primary70}",
        "a_30": "{primaryInverse}",
        "a_31": "{m}",
        "a_32": "{primaryInverse}",
        "a_33": "{primary70}",
        "a_34": "{primaryInverse}",
        "a_35": "{xxs}",
        "a_36": "{s}",
        "a_37": "{xxs}",
        "a_38": "{s}",
        "a_39": "{xxs}",
        "a_40": "{base}",
        "a_41": "{base}",
        "a_42": "{m}",
        "a_43": "{s}",
        "a_44": "{m}",
        "a_45": "{s}",
        "a_46": "{m}",
        "a_47": "{xs}",
        "a_48": "{m}",
        "a_49": "{m}",
        "a_50": "{m}",
        "a_51": "{base}",
        "a_52": "{l}",
        "a_53": "{base}",
        "a_54": "{l}",
        "a_55": "{xs}",
        "a_56": "{l}",
        "a_57": "{l}",
        "a_58": "{xxl}",
        "a_59": "{opacity.disabled}",
        "a_60": "{opacity.invisible}",
        "a_61": "{opacity.invisible}",
        "a_62": "{opacity.invisible}",
        "a_63": "{opacity.disabled}",
        "a_64": "{opacity.enabled}",
        "a_65": "{global.transparent}",
        "a_66": "{border_thin}",
        "a_67": "{primaryGrey60}",
        "a_68": "{primary20}",
        "a_69": "{primary30}",
        "a_70": "{border_focus}",
        "a_71": "{primary60}",
        "a_72": "{primary60}",
        "a_73": "{primary60}",
        "a_74": "{primary70}",
        "a_75": "{primary60}",
        "a_76": "{primary60}",
        "a_77": "{primary70}",
        "a_78": "{custom_5}",
        "a_79": "{custom_5}",
        "a_80": "{custom_5}",
        "a_81": "{custom_5}",
        "a_82": "{global.transparent}",
        "a_83": "{primary20}",
        "a_84": "{primary30}",
        "a_85": "{border_focus}",
        "a_86": "{custom_1}",
        "a_87": "{primary60}",
        "a_88": "{primary60}",
        "a_89": "{primary50}",
        "a_90": "{primary70}",
        "a_91": "{primary60}",
        "a_92": "{primary50}",
        "a_93": "{primary70}",
        "a_94": "{feedbackSuccess50}",
        "a_95": "{feedbackSuccess20}",
        "a_96": "{feedbackSuccess80}",
        "a_97": "{primary60}",
        "a_98": "{global.white}",
        "a_99": "{feedbackSuccess80}",
        "a_100": "{primaryBackground}",
        "a_101": "{global.white}",
        "a_102": "{feedbackSuccess80}",
        "a_103": "{primaryBackground}",
        "a_104": "{global.transparent}",
        "a_105": "{border_thin}",
        "a_106": "{primaryGrey60}",
        "a_107": "{feedbackSuccess20}",
        "a_108": "{feedbackSuccess80}",
        "a_109": "{primary60}",
        "a_110": "{feedbackSuccess80}",
        "a_111": "{feedbackSuccess80}",
        "a_112": "{primaryBackground}",
        "a_113": "{feedbackSuccess80}",
        "a_114": "{feedbackSuccess80}",
        "a_115": "{primaryBackground}",
        "a_116": "{global.transparent}",
        "a_117": "{custom_1}",
        "a_118": "{feedbackSuccess20}",
        "a_119": "{feedbackSuccess80}",
        "a_120": "{primary60}",
        "a_121": "{feedbackSuccess80}",
        "a_122": "{feedbackSuccess50}",
        "a_123": "{primaryGrey100}",
        "a_124": "{feedbackSuccess80}",
        "a_125": "{feedbackSuccess50}",
        "a_126": "{primaryGrey100}",
        "a_127": "{custom_5}",
        "a_128": "{custom_5}",
        "a_129": "{feedbackError50}",
        "a_130": "{feedbackError20}",
        "a_131": "{feedbackError80}",
        "a_132": "{primary60}",
        "a_133": "{global.white}",
        "a_134": "{feedbackError80}",
        "a_135": "{primaryBackground}",
        "a_136": "{global.white}",
        "a_137": "{feedbackError80}",
        "a_138": "{primaryBackground}",
        "a_139": "{global.transparent}",
        "a_140": "{border_thin}",
        "a_141": "{primaryGrey60}",
        "a_142": "{feedbackError20}",
        "a_143": "{feedbackError80}",
        "a_144": "{primary60}",
        "a_145": "{feedbackError80}",
        "a_146": "{feedbackError80}",
        "a_147": "{primaryBackground}",
        "a_148": "{feedbackError80}",
        "a_149": "{feedbackError80}",
        "a_150": "{primaryBackground}",
        "a_151": "{global.transparent}",
        "a_152": "{pill}",
        "a_153": "{feedbackError20}",
        "a_154": "{feedbackError80}",
        "a_155": "{primary60}",
        "a_156": "{feedbackError80}",
        "a_157": "{feedbackError50}",
        "a_158": "{primaryGrey100}",
        "a_159": "{feedbackError80}",
        "a_160": "{feedbackError50}",
        "a_161": "{primaryGrey100}",
        "a_162": "{custom_5}",
        "a_163": "{custom_5}",
        "a_164": "{primaryBackground}",
        "a_165": "{primary20}",
        "a_166": "{primary30}",
        "a_167": "{primary50}",
        "a_168": "{primaryGrey100}",
        "a_169": "{primaryGrey100}",
        "a_170": "{primaryGrey100}",
        "a_171": "{primaryGrey100}",
        "a_172": "{primaryGrey100}",
        "a_173": "{primaryGrey100}",
        "a_174": "{global.transparent}",
        "a_175": "{border_thin}",
        "a_176": "{primaryGrey60}",
        "a_177": "{primary20}",
        "a_178": "{primary30}",
        "a_179": "{border_focus}",
        "a_180": "{primary50}",
        "a_181": "{primaryBackground}",
        "a_182": "{primaryGrey100}",
        "a_183": "{primaryGrey100}",
        "a_184": "{primaryBackground}",
        "a_185": "{primaryGrey100}",
        "a_186": "{primaryGrey100}",
        "a_187": "{global.transparent}",
        "a_188": "{pill}",
        "a_189": "{primary20}",
        "a_190": "{primary30}",
        "a_191": "{border_focus}",
        "a_192": "{primary50}",
        "a_193": "{primaryBackground}",
        "a_194": "{primaryGrey100}",
        "a_195": "{primaryGrey100}",
        "a_196": "{primaryBackground}",
        "a_197": "{primaryGrey100}",
        "a_198": "{primaryGrey100}",
        "a_199": "{base}",
        "a_200": "{base}",
        "a_201": "{m}",
        "a_202": "{m}",
        "a_203": "{l}",
        "a_204": "{l}",
        "a_205": "{size.max}",
        "a_206": "{size.max}"
    },
    "JDSAvatar": {
        "a_0": "{xl}",
        "a_1": "{xl}",
        "a_2": "{flexDirection.row}",
        "a_3": "{justifyContent.center}",
        "a_4": "{alignItems.center}",
        "a_5": "{primary20}",
        "a_6": "{pill}",
        "a_7": "{border_none}",
        "a_8": "{primary80}",
        "a_9": "{m}",
        "a_10": "{m}",
        "a_11": "{l}",
        "a_12": "{l}",
        "a_13": "{xxl}",
        "a_14": "{xxl}",
        "a_15": "{custom_1}",
        "a_16": "{custom_1}",
        "a_17": "{opacity.enabled}",
        "a_18": "{opacity.disabled}",
        "a_19": "{sparkle20}",
        "a_20": "{border_focus}",
        "a_21": "{sparkle40}",
        "a_22": "{border_focus}",
        "a_23": "{sparkle40}",
        "a_24": "{opacity.disabled}",
        "a_25": "{border_focus}",
        "a_26": "{opacity.disabled}"
    },
    "JDSAvatarV2Default": {
        "a_0": "{xl}",
        "a_1": "{xl}",
        "a_2": "{flexDirection.row}",
        "a_3": "{justifyContent.center}",
        "a_4": "{alignItems.center}",
        "a_5": "{primary20}",
        "a_6": "{pill}",
        "a_7": "{border_none}",
        "a_8": "{primary60}",
        "a_9": "{opacity.enabled}",
        "a_10": "{primary30}",
        "a_11": "{border_focus}",
        "a_12": "{custom_3}",
        "a_13": "{primary60}",
        "a_14": "{primary50}",
        "a_15": "{primary70}",
        "a_16": "{m}",
        "a_17": "{m}",
        "a_18": "{l}",
        "a_19": "{l}",
        "a_20": "{xxl}",
        "a_21": "{xxl}",
        "a_22": "{custom_11}",
        "a_23": "{custom_11}",
        "a_24": "{custom_1}",
        "a_25": "{custom_1}",
        "a_26": "{base}",
        "a_27": "{m}",
        "a_28": "{l}",
        "a_29": "{xl}",
        "a_30": "{xxl}",
        "a_31": "{opacity.disabled}",
        "a_32": "{sparkle20}",
        "a_33": "{opacity.disabled}",
        "a_34": "{primaryBackground}",
        "a_35": "{opacity.disabled}",
        "a_36": "{primaryGrey80}"
    },
    "JDSAccordionList": {
        "a_0": "{flexDirection.column}",
        "a_1": "{size.max}",
        "a_2": "{flexDirection.column}",
        "a_3": "{size.max}"
    },
    "JDSMobileBottomSheet": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.end}",
        "m_3": "{size.max}",
        "m_4": "{custom_color_3}",
        "m_5": "{opacity.invisible}",
        "m_6": "{medium}",
        "m_7": "{easeEntrance}",
        "m_8": "{global.transparent}",
        "m_9": "{global.transparent}",
        "m_10": "{opacity.enabled}",
        "m_11": "{easeExit}"
    },
    "JDSMobileBottomSheetInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.end}",
        "m_2": "{alignItems.end}",
        "m_3": "{size.max}",
        "m_4": "{flexDirection.column}",
        "m_5": "{justifyContent.start}",
        "m_6": "{primaryBackground}",
        "m_7": "{alignItems.start}",
        "m_8": "{xl}",
        "m_9": "{xl}",
        "m_10": "{size.max}",
        "m_11": "{size.max}",
        "m_12": "{medium}",
        "m_13": "{easeEntrance}",
        "m_14": "{flexDirection.row}",
        "m_15": "{justifyContent.end}",
        "m_16": "{alignItems.center}",
        "m_17": "{size.max}",
        "m_18": "{xxs}",
        "m_19": "{xxs}",
        "m_20": "{xs}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": 1,
        "m_24": 1,
        "m_25": "{base}",
        "m_26": "{flexDirection.column}",
        "m_27": "{justifyContent.start}",
        "m_28": "{alignItems.start}",
        "m_29": "{m}",
        "m_30": "{m}",
        "m_31": "{size.max}",
        "m_32": "{xs}",
        "m_33": "{m}",
        "m_34": "{flexDirection.column}",
        "m_35": "{base}",
        "m_36": "{size.max}",
        "m_37": "{m}",
        "m_38": "{m}",
        "m_39": "{flexDirection.column}",
        "m_40": "{justifyContent.start}",
        "m_41": "{alignItems.start}",
        "m_42": "{primaryBackground}",
        "m_43": "{xl}",
        "m_44": "{xl}",
        "m_45": "{m}",
        "m_46": "{m}",
        "m_47": "{m}",
        "m_48": "{m}",
        "m_49": "{size.max}",
        "m_50": "{size.max}",
        "m_51": "{medium}",
        "m_52": "{easeEntrance}",
        "m_53": 0,
        "m_54": 4,
        "m_55": 24,
        "m_56": 0,
        "m_57": "{custom_color_5}",
        "m_58": 0,
        "m_59": "{m}",
        "m_60": 0,
        "m_61": "{size.max}"
    },
    "JDSBadge": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xxs}",
        "b_4": "{xs}",
        "b_5": "{xs}",
        "b_6": "{xxs}",
        "b_7": "{xxs}",
        "b_8": "{sparkle60}",
        "b_9": "{medium}",
        "b_10": "{base}",
        "b_11": "{sparkleGrey20}",
        "b_12": "{justifyContent.start}",
        "b_13": "{alignItems.start}",
        "b_14": "{bodySBold}",
        "b_15": "{bodySBold}",
        "b_16": "{bodySBold}",
        "b_17": "{bodySBold}",
        "b_18": "{bodySBold}",
        "b_19": "{sparkleGrey20}",
        "b_20": "{text-case.uppercase}",
        "b_21": "{pill}",
        "b_22": "{custom_color_2}",
        "b_23": "{xxs}",
        "b_24": "{xxs}",
        "b_25": "{s}",
        "b_26": "{xxs}",
        "b_27": "{xs}",
        "b_28": "{bodyMBold}",
        "b_29": "{bodyMBold}",
        "b_30": "{bodyMBold}",
        "b_31": "{bodyMBold}",
        "b_32": "{bodyMBold}",
        "b_33": "{global.white}",
        "b_34": "{m}",
        "b_35": "{custom_color_1}",
        "b_36": "{small}",
        "b_37": "{s}",
        "b_38": "{bodyXxsBold}",
        "b_39": "{bodyXxsBold}",
        "b_40": "{bodyXxsBold}",
        "b_41": "{bodyXxsBold}",
        "b_42": "{bodyXxsBold}",
        "b_43": "{s}",
        "b_44": "{s}",
        "b_45": "{xs}",
        "b_46": "{m}",
        "b_47": "{bodyLBold}",
        "b_48": "{bodyLBold}",
        "b_49": "{bodyLBold}",
        "b_50": "{bodyLBold}",
        "b_51": "{bodyLBold}"
    },
    "JDSBadgeV2Brand": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{primary50}",
        "b_4": "{xxs}",
        "b_5": "{pill}",
        "b_6": "{xs}",
        "b_7": "{s}",
        "b_8": "{xxs}",
        "b_9": "{xxs}",
        "b_10": "{pill}",
        "b_11": "{custom_18}",
        "b_12": "{medium}",
        "b_13": "{medium}",
        "b_14": "{medium}",
        "b_15": "{medium}",
        "b_16": "{small}",
        "b_17": "{xxs}",
        "b_18": "{xxs}",
        "b_19": "{custom_5}",
        "b_20": "{custom_5}",
        "b_21": "{s}",
        "b_22": "{xxs}",
        "b_23": "{xs}",
        "b_24": "{custom_4}",
        "b_25": "{custom_4}",
        "b_26": "{s}",
        "b_27": "{xxs}",
        "b_28": "{xs}",
        "b_29": "{custom_4}",
        "b_30": "{custom_4}",
        "b_31": "{base}",
        "b_32": "{xxs}",
        "b_33": "{xs}",
        "b_34": "{xxs}",
        "b_35": "{xxs}",
        "b_36": "{custom_18}",
        "b_37": "{xs}",
        "b_38": "{custom_3}",
        "b_39": "{primary60}",
        "b_40": "{custom_5}",
        "b_41": "{custom_5}",
        "b_42": "{custom_5}",
        "b_43": "{base}",
        "b_44": "{custom_5}",
        "b_45": "{custom_18}",
        "b_46": "{custom_5}",
        "b_47": "{m}",
        "b_48": "{custom_5}",
        "b_49": "{custom_3}",
        "b_50": "{custom_5}",
        "b_51": "{l}",
        "b_52": "{custom_5}",
        "b_53": "{xl}",
        "b_54": "{small}",
        "b_55": "{custom_5}",
        "b_56": "{base}",
        "b_57": "{small}",
        "b_58": "{small}",
        "b_59": "{custom_5}",
        "b_60": "{custom_18}",
        "b_61": "{small}",
        "b_62": "{small}",
        "b_63": "{custom_5}",
        "b_64": "{m}",
        "b_65": "{small}",
        "b_66": "{small}",
        "b_67": "{custom_5}",
        "b_68": "{custom_3}",
        "b_69": "{small}",
        "b_70": "{l}",
        "b_71": "{xl}",
        "b_72": "{medium}",
        "b_73": "{small}",
        "b_74": "{small}",
        "b_75": "{xxs}",
        "b_76": "{small}",
        "b_77": "{xxs}",
        "b_78": "{xs}",
        "b_79": "{base}",
        "b_80": "{xs}",
        "b_81": "{small}",
        "b_82": "{xs}"
    },
    "JDSBadgeV2Information": {
        "b_0": "{small}",
        "b_1": "{alignItems.center}",
        "b_2": "{flexDirection.row}",
        "b_3": "{justifyContent.center}",
        "b_4": "{alignItems.center}",
        "b_5": "{sparkle60}",
        "b_6": "{xxs}",
        "b_7": "{small}",
        "b_8": "{xxs}",
        "b_9": "{xs}",
        "b_10": "{custom_4}",
        "b_11": "{custom_4}",
        "b_12": "{flexDirection.row}",
        "b_13": "{justifyContent.center}",
        "b_14": "{alignItems.center}",
        "b_15": "{base}",
        "b_16": "{primaryBackground}",
        "b_17": "{base}",
        "b_18": "{flexDirection.row}",
        "b_19": "{justifyContent.center}",
        "b_20": "{alignItems.center}",
        "b_21": "{base}",
        "b_22": "{secondary60}",
        "b_23": "{secondary60}",
        "b_24": "{primaryBackground}",
        "b_25": "{xxs}",
        "b_26": "{custom_5}",
        "b_27": "{custom_5}",
        "b_28": "{s}",
        "b_29": "{s}",
        "b_30": "{s}",
        "b_31": "{xxs}",
        "b_32": "{custom_5}",
        "b_33": "{custom_5}",
        "b_34": "{s}",
        "b_35": "{s}",
        "b_36": "{s}",
        "b_37": "{xxs}",
        "b_38": "{custom_5}",
        "b_39": "{custom_5}",
        "b_40": "{s}",
        "b_41": "{s}",
        "b_42": "{s}",
        "b_43": "{xs}",
        "b_44": "{xxs}",
        "b_45": "{xxs}",
        "b_46": "{medium}",
        "b_47": "{medium}",
        "b_48": "{xs}",
        "b_49": "{xxs}",
        "b_50": "{xxs}",
        "b_51": "{custom_18}",
        "b_52": "{custom_18}",
        "b_53": "{custom_18}",
        "b_54": "{medium}",
        "b_55": "{medium}",
        "b_56": "{xs}",
        "b_57": "{s}",
        "b_58": "{xxs}",
        "b_59": "{xxs}",
        "b_60": "{custom_3}",
        "b_61": "{custom_3}",
        "b_62": "{custom_3}",
        "b_63": "{feedbackSuccess50}",
        "b_64": "{feedbackSuccess50}",
        "b_65": "{feedbackWarning50}",
        "b_66": "{feedbackWarning50}",
        "b_67": "{feedbackError50}",
        "b_68": "{feedbackError50}",
        "b_69": "{primaryGrey80}",
        "b_70": "{global.transparent}",
        "b_71": "{custom_16}",
        "b_72": "{primaryBackground}",
        "b_73": "{custom_5}",
        "b_74": "{xs}",
        "b_75": "{xs}",
        "b_76": "{custom_5}",
        "b_77": "{s}",
        "b_78": "{s}",
        "b_79": "{custom_5}",
        "b_80": "{base}",
        "b_81": "{base}",
        "b_82": "{custom_5}",
        "b_83": "{custom_5}",
        "b_84": "{custom_5}",
        "b_85": "{custom_5}",
        "b_86": "{custom_5}",
        "b_87": "{custom_18}",
        "b_88": "{custom_18}",
        "b_89": "{m}",
        "b_90": "{m}",
        "b_91": "{custom_3}",
        "b_92": "{custom_3}",
        "b_93": "{l}",
        "b_94": "{l}",
        "b_95": "{xl}",
        "b_96": "{xl}",
        "b_97": "{pill}",
        "b_98": "{pill}",
        "b_99": "{custom_5}",
        "b_100": "{s}",
        "b_101": "{pill}",
        "b_102": "{xs}",
        "b_103": "{pill}",
        "b_104": "{pill}",
        "b_105": "{custom_5}",
        "b_106": "{s}",
        "b_107": "{pill}",
        "b_108": "{xs}",
        "b_109": "{pill}",
        "b_110": "{custom_5}",
        "b_111": "{base}",
        "b_112": "{pill}",
        "b_113": "{custom_19}",
        "b_114": "{pill}",
        "b_115": "{custom_5}",
        "b_116": "{custom_18}",
        "b_117": "{pill}",
        "b_118": "{s}",
        "b_119": "{pill}",
        "b_120": "{custom_5}",
        "b_121": "{m}",
        "b_122": "{pill}",
        "b_123": "{base}",
        "b_124": "{pill}",
        "b_125": "{custom_5}",
        "b_126": "{custom_3}",
        "b_127": "{pill}",
        "b_128": "{base}",
        "b_129": "{pill}",
        "b_130": "{custom_5}",
        "b_131": "{l}",
        "b_132": "{pill}",
        "b_133": "{custom_18}",
        "b_134": "{pill}",
        "b_135": "{custom_5}",
        "b_136": "{xl}",
        "b_137": "{pill}",
        "b_138": "{m}",
        "b_139": "{small}",
        "b_140": "{small}",
        "b_141": "{custom_5}",
        "b_142": "{s}",
        "b_143": "{small}",
        "b_144": "{xs}",
        "b_145": "{small}",
        "b_146": "{custom_5}",
        "b_147": "{s}",
        "b_148": "{small}",
        "b_149": "{xs}",
        "b_150": "{small}",
        "b_151": "{custom_5}",
        "b_152": "{base}",
        "b_153": "{small}",
        "b_154": "{custom_19}",
        "b_155": "{small}",
        "b_156": "{custom_5}",
        "b_157": "{custom_18}",
        "b_158": "{small}",
        "b_159": "{s}",
        "b_160": "{small}",
        "b_161": "{custom_5}",
        "b_162": "{m}",
        "b_163": "{small}",
        "b_164": "{base}",
        "b_165": "{small}",
        "b_166": "{custom_5}",
        "b_167": "{custom_3}",
        "b_168": "{small}",
        "b_169": "{base}",
        "b_170": "{medium}",
        "b_171": "{custom_5}",
        "b_172": "{l}",
        "b_173": "{medium}",
        "b_174": "{custom_18}",
        "b_175": "{custom_1}",
        "b_176": "{custom_5}",
        "b_177": "{xl}",
        "b_178": "{custom_1}",
        "b_179": "{m}",
        "b_180": "{base}",
        "b_181": "{base}",
        "b_182": "{base}",
        "b_183": "{custom_18}",
        "b_184": "{xs}",
        "b_185": "{m}",
        "b_186": "{xs}",
        "b_187": "{custom_3}",
        "b_188": "{l}",
        "b_189": "{xl}",
        "b_190": "{s}",
        "b_191": "{base}",
        "b_192": "{base}",
        "b_193": "{base}",
        "b_194": "{custom_18}",
        "b_195": "{m}",
        "b_196": "{custom_3}",
        "b_197": "{l}",
        "b_198": "{xl}",
        "b_199": "{base}",
        "b_200": "{base}",
        "b_201": "{base}",
        "b_202": "{custom_18}",
        "b_203": "{m}",
        "b_204": "{custom_3}",
        "b_205": "{l}",
        "b_206": "{xl}",
        "b_207": "{sparkle20}",
        "b_208": "{sparkle20}",
        "b_209": "{sparkle60}",
        "b_210": "{feedbackSuccess20}",
        "b_211": "{feedbackSuccess20}",
        "b_212": "{feedbackSuccess50}",
        "b_213": "{feedbackWarning20}",
        "b_214": "{feedbackWarning20}",
        "b_215": "{feedbackWarning50}",
        "b_216": "{feedbackError20}",
        "b_217": "{feedbackError20}",
        "b_218": "{feedbackError50}",
        "b_219": "{primaryGrey20}",
        "b_220": "{primaryGrey20}",
        "b_221": "{primaryGrey80}",
        "b_222": "{global.transparent}",
        "b_223": "{global.transparent}",
        "b_224": "{sparkle60}",
        "b_225": "{global.transparent}",
        "b_226": "{global.transparent}",
        "b_227": "{feedbackSuccess50}",
        "b_228": "{global.transparent}",
        "b_229": "{global.transparent}",
        "b_230": "{feedbackWarning50}",
        "b_231": "{global.transparent}",
        "b_232": "{global.transparent}",
        "b_233": "{feedbackError50}",
        "b_234": "{global.transparent}",
        "b_235": "{global.transparent}",
        "b_236": "{primaryGrey80}",
        "b_237": "{global.transparent}",
        "b_238": "{global.transparent}",
        "b_239": "{sparkle60}",
        "b_240": "{global.transparent}",
        "b_241": "{global.transparent}",
        "b_242": "{feedbackSuccess50}",
        "b_243": "{global.transparent}",
        "b_244": "{global.transparent}",
        "b_245": "{feedbackWarning50}",
        "b_246": "{global.transparent}",
        "b_247": "{global.transparent}",
        "b_248": "{feedbackError50}",
        "b_249": "{global.transparent}",
        "b_250": "{global.transparent}",
        "b_251": "{primaryGrey80}",
        "b_252": "{custom_4}",
        "b_253": "{custom_4}",
        "b_254": "{custom_4}",
        "b_255": "{custom_16}",
        "b_256": "{custom_16}",
        "b_257": "{custom_16}",
        "b_258": "{xxs}",
        "b_259": "{custom_4}",
        "b_260": "{custom_4}",
        "b_261": "{global.transparent}",
        "b_262": "{global.transparent}",
        "b_263": "{secondary60}",
        "b_264": "{global.transparent}",
        "b_265": "{global.tansparent}",
        "b_266": "{secondary60}",
        "b_267": "{secondary20}",
        "b_268": "{secondary20}",
        "b_269": "{secondary60}",
        "b_270": "{global.transparent}",
        "b_271": "{custom_5}"
    },
    "JDSBadgeV2Notification": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xs}",
        "b_4": "{xs}",
        "b_5": "{feedbackError50}",
        "b_6": "{pill}",
        "b_7": "{custom_5}",
        "b_8": "{global.transparent}",
        "b_9": "{primaryBackground}",
        "b_10": "{custom_4}",
        "b_11": "{s}",
        "b_12": "{s}",
        "b_13": "{base}",
        "b_14": "{base}",
        "b_15": "{custom_4}",
        "b_16": "{custom_18}",
        "b_17": "{custom_18}",
        "b_18": "{custom_4}",
        "b_19": "{m}",
        "b_20": "{m}",
        "b_21": "{custom_16}",
        "b_22": "{custom_3}",
        "b_23": "{custom_3}",
        "b_24": "{custom_16}",
        "b_25": "{l}",
        "b_26": "{l}",
        "b_27": "{custom_16}",
        "b_28": "{xl}",
        "b_29": "{xl}",
        "b_30": "{xxs}",
        "b_31": "{custom_1}",
        "b_32": "{base}",
        "b_33": "{base}",
        "b_34": "{base}",
        "b_35": "{base}",
        "b_36": "{base}",
        "b_37": "{base}",
        "b_38": "{custom_18}",
        "b_39": "{custom_18}",
        "b_40": "{m}",
        "b_41": "{m}",
        "b_42": "{custom_3}",
        "b_43": "{custom_3}",
        "b_44": "{l}",
        "b_45": "{l}",
        "b_46": "{xl}",
        "b_47": "{xl}",
        "b_48": "{base}",
        "b_49": "{small}",
        "b_50": "{xxs}",
        "b_51": "{xxs}",
        "b_52": "{base}",
        "b_53": "{small}",
        "b_54": "{xxs}",
        "b_55": "{xxs}",
        "b_56": "{base}",
        "b_57": "{small}",
        "b_58": "{xxs}",
        "b_59": "{xxs}",
        "b_60": "{custom_18}",
        "b_61": "{small}",
        "b_62": "{custom_18}",
        "b_63": "{custom_18}",
        "b_64": "{m}",
        "b_65": "{small}",
        "b_66": "{custom_18}",
        "b_67": "{custom_18}",
        "b_68": "{custom_3}",
        "b_69": "{small}",
        "b_70": "{custom_18}",
        "b_71": "{custom_18}",
        "b_72": "{l}",
        "b_73": "{medium}",
        "b_74": "{xs}",
        "b_75": "{xs}",
        "b_76": "{xl}",
        "b_77": "{medium}",
        "b_78": "{xs}",
        "b_79": "{xs}",
        "b_80": "{custom_4}"
    },
    "JDSBadgeV2Status": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.center}",
        "b_2": "{alignItems.center}",
        "b_3": "{xs}",
        "b_4": "{flexDirection.row}",
        "b_5": "{justifyContent.center}",
        "b_6": "{alignItems.center}",
        "b_7": "{m}",
        "b_8": "{pill}",
        "b_9": "{feedbackSuccess50}",
        "b_10": "{global.white}",
        "b_11": "{base}",
        "b_12": "{s}",
        "b_13": "{s}",
        "b_14": "{small}",
        "b_15": "{xs}",
        "b_16": "{xs}",
        "b_17": "{small}",
        "b_18": "{xs}",
        "b_19": "{xs}",
        "b_20": "{s}",
        "b_21": "{small}",
        "b_22": "{xs}",
        "b_23": "{xs}",
        "b_24": "{base}",
        "b_25": "{s}",
        "b_26": "{l}",
        "b_27": "{m}",
        "b_28": "{xl}",
        "b_29": "{custom_3}",
        "b_30": "{feedbackError50}",
        "b_31": "{feedbackWarning50}",
        "b_32": "{primaryGrey60}",
        "b_33": "{primaryBackground}",
        "b_34": "{primaryBackground}",
        "b_35": "{xs}",
        "b_36": "{base}",
        "b_37": "{m}",
        "b_38": "{l}",
        "b_39": "{xs}",
        "b_40": "{base}",
        "b_41": "{m}",
        "b_42": "{l}",
        "b_43": "{m}",
        "b_44": "{base}",
        "b_45": "{m}",
        "b_46": "{base}",
        "b_47": "{medium}",
        "b_48": "{medium}",
        "b_49": "{xs}",
        "b_50": "{medium}",
        "b_51": "{base}",
        "b_52": "{medium}",
        "b_53": "{m}",
        "b_54": "{l}",
        "b_55": "{medium}",
        "b_56": "{base}",
        "b_57": "{s}",
        "b_58": "{medium}",
        "b_59": "{m}",
        "b_60": "{base}",
        "b_61": "{feedbackSuccess50}",
        "b_62": "{feedbackError50}",
        "b_63": "{feedbackWarning50}",
        "b_64": "{primaryGrey60}",
        "b_65": "{feedbackSuccess50}",
        "b_66": "{global.white}",
        "b_67": "{feedbackError50}",
        "b_68": "{global.white}",
        "b_69": "{feedbackWarning50}",
        "b_70": "{global.white}",
        "b_71": "{primaryGrey60}",
        "b_72": "{global.white}",
        "b_73": "{feedbackSuccess50}",
        "b_74": "{global.white}",
        "b_75": "{feedbackSuccess50}",
        "b_76": "{feedbackError50}",
        "b_77": "{global.white}",
        "b_78": "{feedbackError50}",
        "b_79": "{feedbackWarning50}",
        "b_80": "{global.white}",
        "b_81": "{feedbackWarning50}",
        "b_82": "{primaryGrey60}",
        "b_83": "{global.white}",
        "b_84": "{primaryGrey60}",
        "b_85": "{border_normal}",
        "b_86": "{border_normal}",
        "b_87": "{border_thick}",
        "b_88": "{border_thick}",
        "b_89": "{border_thick}",
        "b_90": "{border_normal}",
        "b_91": "{border_normal}",
        "b_92": "{border_thick}",
        "b_93": "{border_thick}",
        "b_94": "{border_thick}",
        "b_95": "{border_normal}",
        "b_96": "{border_normal}",
        "b_97": "{border_thick}",
        "b_98": "{border_thick}",
        "b_99": "{border_thick}"
    },
    "JDSBaseIcon": {
        "b_0": "{base}",
        "b_1": "{primary50}",
        "b_2": "{primary30}",
        "b_3": "{primary60}",
        "b_4": "{primary70}",
        "b_5": "{primaryBackground}",
        "b_6": "{secondary50}",
        "b_7": "{sparkle50}",
        "b_8": "{primaryGrey60}",
        "b_9": "{primaryGrey80}",
        "b_10": "{primaryGrey100}",
        "b_11": "{feedbackSuccess50}",
        "b_12": "{feedbackError50}",
        "b_13": "{feedbackWarning50}",
        "b_14": "{global.white}",
        "b_15": "{custom_color_1}"
    },
    "JDSDesktopBottomSheet": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.end}",
        "d_2": "{alignItems.end}",
        "d_3": "{custom_color_3}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{primaryBackground}",
        "d_8": "{alignItems.start}",
        "d_9": "{xl}",
        "d_10": "{xl}",
        "d_11": "{flexDirection.row}",
        "d_12": "{justifyContent.end}",
        "d_13": "{alignItems.center}",
        "d_14": "{size.max}",
        "d_15": "{xxs}",
        "d_16": "{xxs}",
        "d_17": "{xs}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{flexDirection.column}",
        "d_21": "{justifyContent.start}",
        "d_22": "{alignItems.start}",
        "d_23": "{m}",
        "d_24": "{m}",
        "d_25": "{size.max}",
        "d_26": "{xs}",
        "d_27": "{m}",
        "d_28": "{flexDirection.column}",
        "d_29": "{base}",
        "d_30": "{size.max}",
        "d_31": "{m}",
        "d_32": "{m}",
        "d_33": "{base}",
        "d_34": "{custom_color_5}"
    },
    "JDSDesktopBottomSheetInternal": {
        "d_0": "{flexDirection.stack}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.start}",
        "d_4": "{primaryBackground}",
        "d_5": "{xl}",
        "d_6": "{xl}",
        "d_7": "{m}",
        "d_8": "{m}",
        "d_9": "{m}",
        "d_10": "{m}",
        "d_11": "{custom_28}",
        "d_12": "{size.max}",
        "d_13": "{justifyContent.end}",
        "d_14": "{alignItems.end}",
        "d_15": "{custom_28}",
        "d_16": "{size.max}",
        "d_17": "{medium}",
        "d_18": "{easeEntrance}",
        "d_19": "{flexDirection.row}",
        "d_20": "{justifyContent.end}",
        "d_21": "{alignItems.end}",
        "d_22": "{custom_color_3}",
        "d_23": "{size.max}",
        "d_24": "{flexDirection.column}",
        "d_25": "{justifyContent.start}",
        "d_26": "{primaryBackground}",
        "d_27": "{alignItems.start}",
        "d_28": "{xl}",
        "d_29": "{xl}",
        "d_30": "{flexDirection.row}",
        "d_31": "{justifyContent.end}",
        "d_32": "{alignItems.center}",
        "d_33": "{size.max}",
        "d_34": "{xxs}",
        "d_35": "{xxs}",
        "d_36": "{xs}",
        "d_37": "{s}",
        "d_38": "{s}",
        "d_39": "{flexDirection.column}",
        "d_40": "{justifyContent.start}",
        "d_41": "{alignItems.start}",
        "d_42": "{m}",
        "d_43": "{m}",
        "d_44": "{size.max}",
        "d_45": "{xs}",
        "d_46": "{m}",
        "d_47": "{flexDirection.column}",
        "d_48": "{base}",
        "d_49": "{size.max}",
        "d_50": "{m}",
        "d_51": "{m}",
        "d_52": "{base}",
        "d_53": "{custom_color_5}",
        "d_54": "{bottomsheet_padding_right}",
        "d_55": "{opacity.invisible}",
        "d_56": "{medium}",
        "d_57": "{easeEntrance}",
        "d_58": "{global.transparent}",
        "d_59": "{global.transparent}",
        "d_60": "{opacity.enabled}",
        "d_61": "{easeExit}"
    },
    "JDSBreadcrumbs": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.start}",
        "b_2": "{alignItems.start}",
        "b_3": "{m}",
        "b_4": "{flexDirection.row}",
        "b_5": "{justifyContent.start}",
        "b_6": "{alignItems.start}"
    },
    "JDSCarousel": {
        "c_0": "{flexDirection.column}",
        "c_1": "{justifyContent.center}",
        "c_2": "{alignItems.center}",
        "c_3": "{base}",
        "c_4": "{size.max}",
        "c_5": "{size.max}",
        "c_6": "{flexDirection.row}",
        "c_7": "{justifyContent.spaceBetween}",
        "c_8": "{alignItems.center}",
        "c_9": "{base}",
        "c_10": "{size.max}",
        "c_11": "{size.max}",
        "c_12": "{flexDirection.row}",
        "c_13": "{justifyContent.start}",
        "c_14": "{alignItems.center}",
        "c_15": "{base}",
        "c_16": "{xs}",
        "c_17": "{xs}",
        "c_18": "{flexDirection.column}",
        "c_19": "{justifyContent.center}",
        "c_20": "{alignItems.start}",
        "c_21": "{flexDirection.stack}",
        "c_22": "{justifyContent.center}",
        "c_23": "{alignItems.center}",
        "c_24": "{flexDirection.row}",
        "c_25": "{justifyContent.start}",
        "c_26": "{alignItems.start}",
        "c_27": "{size.max}",
        "c_28": "{flexDirection.row}",
        "c_29": "{justifyContent.end}",
        "c_30": "{alignItems.start}",
        "c_31": "{s}",
        "c_32": "{xs}",
        "c_33": "{xs}",
        "c_34": "{xs}"
    },
    "JDSCarouselPagination": {
        "c_0": "{flexDirection.row}",
        "c_1": "{justifyContent.center}",
        "c_2": "{alignItems.center}",
        "c_3": "{s}",
        "c_4": "{xs}",
        "c_5": "{size.max}",
        "c_6": "{xs}",
        "c_7": "{xs}"
    },
    "JDSButton": {
        "b_0": "{opacity.enabled}",
        "b_1": "{primary50}",
        "b_2": "{flexDirection.row}",
        "b_3": "{alignItems.center}",
        "b_4": "{justifyContent.center}",
        "b_5": "{pill}",
        "b_6": "0",
        "b_7": "",
        "b_8": "{xs}",
        "b_9": 0,
        "b_10": "{primary60}",
        "b_11": "{primary60}",
        "b_12": "{border_focus}",
        "b_13": "{primary80}",
        "b_14": "{flexDirection.row}",
        "b_15": "{alignItems.center}",
        "b_16": "{justifyContent.start}",
        "b_17": "{xs}",
        "b_18": "{primaryInverse}",
        "b_19": "{global.transparent}",
        "b_20": "{border_focus}",
        "b_21": "{opacity.enabled}",
        "b_22": "{base}",
        "b_23": "{m}",
        "b_24": "{primaryInverse}",
        "b_25": "{m}",
        "b_26": "{primaryInverse}",
        "b_27": "{size.max}",
        "b_28": "{justifyContent.spaceBetween}",
        "b_29": "{opacity.disabled}",
        "b_30": "{primary30}",
        "b_31": "{primary30}",
        "b_32": "{feedbackError20}",
        "b_33": "{feedbackError50}",
        "b_34": "{feedbackError80}",
        "b_35": "{feedbackError50}",
        "b_36": "{feedbackError80}",
        "b_37": "{feedbackError80}",
        "b_38": "{global.white}",
        "b_39": "{feedbackError20}",
        "b_40": "{global.white}",
        "b_41": "{feedbackError80}",
        "b_42": "{feedbackError20}",
        "b_43": "{feedbackSuccess20}",
        "b_44": "{feedbackSuccess50}",
        "b_45": "{feedbackSuccess80}",
        "b_46": "{feedbackSuccess50}",
        "b_47": "{feedbackSuccess80}",
        "b_48": "{feedbackSuccess80}",
        "b_49": "{global.white}",
        "b_50": "{feedbackSuccess20}",
        "b_51": "{feedbackSuccess80}",
        "b_52": "{global.white}",
        "b_53": "{feedbackSuccess20}",
        "b_54": "{global.transparent}",
        "b_55": "{border_thin}",
        "b_56": "{primaryGrey40}",
        "b_57": "{primary60}",
        "b_58": "{global.transparent}",
        "b_59": "{primary20}",
        "b_60": "{primary60}",
        "b_61": "{primary80}",
        "b_62": "{primary60}",
        "b_63": "{primary60}",
        "b_64": "{primary60}",
        "b_65": "{global.transparent}",
        "b_66": "{border_thin}",
        "b_67": "{primaryGrey40}",
        "b_68": "{feedbackError20}",
        "b_69": "{feedbackError80}",
        "b_70": "{feedbackError50}",
        "b_71": "{border_focus}",
        "b_72": "{feedbackError80}",
        "b_73": "{feedbackError80}",
        "b_74": "{feedbackError80}",
        "b_75": "{global.transparent}",
        "b_76": "{border_thin}",
        "b_77": "{primaryGrey40}",
        "b_78": "{feedbackSuccess20}",
        "b_79": "{feedbackSuccess80}",
        "b_80": "{feedbackSuccess50}",
        "b_81": "{border_focus}",
        "b_82": "{feedbackSuccess80}",
        "b_83": "{feedbackSuccess80}",
        "b_84": "{feedbackSuccess80}",
        "b_85": "{global.transparent}",
        "b_86": "{primary20}",
        "b_87": "{primary30}",
        "b_88": "{primary80}",
        "b_89": "{primary20}",
        "b_90": "{primary60}",
        "b_91": "{primary60}",
        "b_92": "{primary60}",
        "b_93": "{global.transparent}",
        "b_94": "{feedbackError20}",
        "b_95": "{feedbackError80}",
        "b_96": "{feedbackError50}",
        "b_97": "{border_focus}",
        "b_98": "{feedbackError20}",
        "b_99": "{feedbackError80}",
        "b_100": "{feedbackError80}",
        "b_101": "{feedbackError80}",
        "b_102": "{global.transparent}",
        "b_103": "{feedbackSuccess20}",
        "b_104": "{feedbackSuccess50}",
        "b_105": "{border_focus}",
        "b_106": "{feedbackSuccess80}",
        "b_107": "{feedbackSuccess80}",
        "b_108": "{feedbackSuccess80}",
        "b_109": "{xxs}",
        "b_110": "{base}",
        "b_111": "{xxs}",
        "b_112": "{base}",
        "b_113": "{base}",
        "b_114": "{base}",
        "b_115": "{base}",
        "b_116": "{s}",
        "b_117": "{base}",
        "b_118": "{s}",
        "b_119": "{base}",
        "b_120": "{m}",
        "b_121": "{m}",
        "b_122": "{m}",
        "b_123": "{base}",
        "b_124": "{m}",
        "b_125": "{base}",
        "b_126": "{m}",
        "b_127": "{m}",
        "b_128": "{m}",
        "b_129": "{m}",
        "b_130": "{l}",
        "b_131": "{l}",
        "b_132": "{base}",
        "b_133": "{base}",
        "b_134": "{base}",
        "b_135": "{xxl}",
        "b_136": "{xxl}",
        "b_137": "{m}",
        "b_138": "{m}",
        "b_139": "{m}",
        "b_140": "{m}",
        "b_141": "{m}",
        "b_142": "{m}",
        "b_143": "{justifyContent.center}",
        "b_144": "{justifyContent.center}",
        "b_145": "{justifyContent.center}",
        "b_146": "{justifyContent.center}",
        "b_147": "{justifyContent.center}"
    },
    "JDSCarouselPaginationItem": {
        "c_0": "{s}",
        "c_1": "{s}",
        "c_2": "{primary60}",
        "c_3": "{opacity.disabled}",
        "c_4": "{pill}",
        "c_5": "{primary40}",
        "c_6": "{opacity.enabled}",
        "c_7": "{primary60}",
        "c_8": "{opacity.enabled}",
        "c_9": "{xs}",
        "c_10": "{opacity.enabled}",
        "c_11": "{primary70}",
        "c_12": "{primary70}",
        "c_13": "{s}",
        "c_14": "{xs}",
        "c_15": "{xs}",
        "c_16": "{custom_15}",
        "c_17": "{custom_15}",
        "c_18": "{xs}",
        "c_19": "{custom_15}",
        "c_20": "{custom_15}",
        "c_21": "{xxs}",
        "c_22": "{xxs}",
        "c_23": "{m}",
        "c_24": "{m}",
        "c_25": "{m}",
        "c_26": "{l}",
        "c_27": "{l}",
        "c_28": "{l}"
    },
    "JDSCarouselSlide": {
        "c_0": "{size.max}",
        "c_1": "{small}",
        "c_2": "{size.max}"
    },
    "JDSCheckbox": {
        "c_0": "{flexDirection.column}",
        "c_1": "{justifyContent.start}",
        "c_2": "{alignItems.start}",
        "c_3": "{xs}",
        "c_4": "{flexDirection.row}",
        "c_5": "{justifyContent.start}",
        "c_6": "{alignItems.center}",
        "c_7": "{xs}",
        "c_8": "{m}",
        "c_9": "{m}",
        "c_10": "{flexDirection.row}",
        "c_11": "{justifyContent.center}",
        "c_12": "{alignItems.center}",
        "c_13": "{global.transparent}",
        "c_14": "{small}",
        "c_15": "{border_thin}",
        "c_16": "{primaryGrey80}",
        "c_17": "{primary40}",
        "c_18": "{primary60}",
        "c_19": "{border_focus}",
        "c_20": "{primary60}",
        "c_21": "{base}",
        "c_22": "{textAlign.start}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{xxs}",
        "c_26": "{s}",
        "c_27": "ic_confirm",
        "c_28": "{primary50}",
        "c_29": "{primary40}",
        "c_30": "{primary60}",
        "c_31": "{primaryInverse}",
        "c_32": "ic_minus",
        "c_33": "{primary50}",
        "c_34": "{primary40}",
        "c_35": "{primary50}",
        "c_36": "{primaryInverse}",
        "c_37": "{opacity.disabled}",
        "c_38": "{opacity.enabled}"
    },
    "JDSContentBlock": {
        "c_0": "{flexDirection.column}",
        "c_1": "{alignItems.start}",
        "c_2": "{justifyContent.start}",
        "c_3": "{size.max}",
        "c_4": "{flexDirection.column}",
        "c_5": "{alignItems.start}",
        "c_6": "{justifyContent.start}",
        "c_7": "{size.max}",
        "c_8": "{xs}",
        "c_9": "{xxs}",
        "c_10": "{m}",
        "c_11": "{m}",
        "c_12": "{flexDirection.row}",
        "c_13": "{size.max}",
        "c_14": "{xs}",
        "c_15": "{s}",
        "c_16": "{s}",
        "c_17": "{s}",
        "c_18": "{s}",
        "c_19": "{base}",
        "c_20": "{base}",
        "c_21": "{l}",
        "c_22": "{s}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{l}",
        "c_26": "{s}",
        "c_27": "{flexDirection.column}",
        "c_28": "{size.max}",
        "c_29": "{size.max}",
        "c_30": "{base}",
        "c_31": "{m}",
        "c_32": "{m}",
        "c_33": "{flexDirection.row}",
        "c_34": "{justifyContent.spaceBetween}",
        "c_35": "{alignItems.center}",
        "c_36": "{flexDirection.row}",
        "c_37": "{justifyContent.end}",
        "c_38": "{alignItems.center}"
    },
    "JDSDatepickerButton": {
        "d_0": "{xxl}",
        "d_1": "{custom_9}",
        "d_2": "{pill}",
        "d_3": "{global.transparent}",
        "d_4": "{border_thin}",
        "d_5": "{primaryGrey40}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}",
        "d_9": "{xs}",
        "d_10": "{base}",
        "d_11": "{base}",
        "d_12": "{primary60}",
        "d_13": "{primaryGrey100}",
        "d_14": "{border_focus}",
        "d_15": "{primary60}",
        "d_16": "{primary20}",
        "d_17": "{primary20}",
        "d_18": "{primary60}",
        "d_19": "{border_none}",
        "d_20": "{opacity.disabled}",
        "d_21": "{border_none}"
    },
    "JDSContentCard": {
        "c_0": "{size.max}",
        "c_1": "{xl}",
        "c_2": "{flexDirection.column}",
        "c_3": "{justifyContent.start}",
        "c_4": "{alignItems.start}",
        "c_5": "{primaryBackground}",
        "c_6": "{justifyContent.start}",
        "c_7": "{alignItems.start}",
        "c_8": "{size.max}",
        "c_9": "{base}",
        "c_10": "{base}",
        "c_11": "{base}",
        "c_12": "{justifyContent.start}",
        "c_13": "{alignItems.start}",
        "c_14": "{size.max}",
        "c_15": "{base}",
        "c_16": "{base}",
        "c_17": "{base}",
        "c_18": "{flexDirection.column}",
        "c_19": "{size.max}",
        "c_20": "{justifyContent.start}",
        "c_21": "{alignItems.start}",
        "c_22": "{base}",
        "c_23": "{base}",
        "c_24": "{base}",
        "c_25": "{base}",
        "c_26": "{base}",
        "c_27": "{base}",
        "c_28": "{base}",
        "c_29": "{base}",
        "c_30": "{base}",
        "c_31": "{base}",
        "c_32": "{flexDirection.row}",
        "c_33": "{custom_10}",
        "c_34": "{size.max}",
        "c_35": "{base}",
        "c_36": "{base}",
        "c_37": "{flexDirection.row}",
        "c_38": "{size.max}"
    },
    "JDSDatepickerCalendarButton": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.center}",
        "d_2": "{alignItems.center}",
        "d_3": "{custom_7}",
        "d_4": "{m}",
        "d_5": "{size.max}",
        "d_6": "{xxl}",
        "d_7": "{m}",
        "d_8": "{flexDirection.row}",
        "d_9": "{justifyContent.center}",
        "d_10": "{alignItems.center}",
        "d_11": "{xxl}",
        "d_12": "{intrinsicSize.min}",
        "d_13": "{xxl}",
        "d_14": "{pill}",
        "d_15": "{primaryGrey100}",
        "d_16": "{global.transparent}",
        "d_17": "{primary20}",
        "d_18": "{primary40}",
        "d_19": "{primary20}",
        "d_20": "{border_focus}",
        "d_21": "{primary50}",
        "d_22": "{primary20}",
        "d_23": "{opacity.disabled}",
        "d_24": "{base}",
        "d_25": "{base}"
    },
    "JDSDatepickerCalendar": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{s}",
        "d_4": "{flexDirection.column}"
    },
    "JDSDatepickerCalendarRow": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{size.max}"
    },
    "JDSAccordion": {
        "a_0": "{flexDirection.column}",
        "a_1": "{size.max}",
        "a_2": "{flexDirection.row}",
        "a_3": "{alignItems.center}",
        "a_4": "{justifyContent.start}",
        "a_5": "{size.max}",
        "a_6": "{xxs}",
        "a_7": "{s}",
        "a_8": "{flexDirection.column}",
        "a_9": "{justifyContent.start}",
        "a_10": "{alignItems.start}",
        "a_11": "{xxs}",
        "a_12": "0",
        "a_13": "{size.max}",
        "a_14": "{size.max}",
        "a_15": "{opacity.enabled}",
        "a_16": "{base}",
        "a_17": "{opacity.disabled}",
        "a_18": "ic_minus",
        "a_19": "ic_add",
        "a_20": "ic_chevron_up",
        "a_21": "ic_chevron_down"
    },
    "JDSDatepickerCalendarHeader": {
        "d_0": "{flexDirection.row}",
        "d_1": "{justifyContent.center}",
        "d_2": "{alignItems.center}",
        "d_3": "{size.max}"
    },
    "JDSDatepickerDesktop": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{opacity.invisible}",
        "d_4": "{primaryBackground}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{alignItems.center}",
        "d_8": "{xl}",
        "d_9": "{flexDirection.row}",
        "d_10": "{justifyContent.end}",
        "d_11": "{alignItems.center}",
        "d_12": "{xs}",
        "d_13": "{s}",
        "d_14": "{xs}",
        "d_15": "{s}",
        "d_16": "{custom_6}",
        "d_17": "{m}",
        "d_18": "{m}",
        "d_19": "{flexDirection.column}",
        "d_20": "{justifyContent.start}",
        "d_21": "{alignItems.center}",
        "d_22": "{m}",
        "d_23": "{flexDirection.column}",
        "d_24": "{justifyContent.start}",
        "d_25": "{alignItems.center}",
        "d_26": "{size.max}",
        "d_27": "{size.max}",
        "d_28": "{m}",
        "d_29": "{m}",
        "d_30": "{m}",
        "d_31": "{opacity.enabled}",
        "d_32": "{justifyContent.spaceBetween}",
        "d_33": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerDesktopInternal": {
        "d_0": "{flexDirection.column}",
        "d_1": "{justifyContent.start}",
        "d_2": "{alignItems.center}",
        "d_3": "{opacity.invisible}",
        "d_4": "{primaryBackground}",
        "d_5": "{flexDirection.column}",
        "d_6": "{justifyContent.start}",
        "d_7": "{alignItems.center}",
        "d_8": "{xl}",
        "d_9": "{flexDirection.row}",
        "d_10": "{justifyContent.end}",
        "d_11": "{alignItems.center}",
        "d_12": "{xs}",
        "d_13": "{s}",
        "d_14": "{xs}",
        "d_15": "{s}",
        "d_16": "{custom_6}",
        "d_17": "{m}",
        "d_18": "{m}",
        "d_19": "{flexDirection.column}",
        "d_20": "{justifyContent.start}",
        "d_21": "{alignItems.center}",
        "d_22": "{m}",
        "d_23": "{flexDirection.column}",
        "d_24": "{justifyContent.start}",
        "d_25": "{alignItems.center}",
        "d_26": "{size.max}",
        "d_27": "{size.max}",
        "d_28": "{m}",
        "d_29": "{m}",
        "d_30": "{m}",
        "d_31": "{opacity.enabled}",
        "d_32": "{justifyContent.spaceBetween}",
        "d_33": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerHeader": {
        "d_0": "{size.max}",
        "d_1": "{xxl}",
        "d_2": "{flexDirection.row}",
        "d_3": "{justifyContent.spaceBetween}",
        "d_4": "{alignItems.center}",
        "d_5": "{xxl}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}",
        "d_9": "{s}"
    },
    "JDSDatepickerYearView": {
        "d_0": "{flexDirection.column}",
        "d_1": "{size.max}",
        "d_2": "{alignItems.center}"
    },
    "JDSDatepickerMonthView": {
        "d_0": "{flexDirection.column}",
        "d_1": "{custom_8}",
        "d_2": "{size.max}",
        "d_3": "{alignItems.center}"
    },
    "JDSDatepickerMobile": {
        "d_0": "{primaryBackground}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.center}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.row}",
        "d_6": "{justifyContent.end}",
        "d_7": "{alignItems.center}",
        "d_8": "{xs}",
        "d_9": "{xs}",
        "d_10": "{s}",
        "d_11": "{s}",
        "d_12": "{size.max}",
        "d_13": "{flexDirection.column}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.center}",
        "d_16": "{m}",
        "d_17": "{s}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{s}",
        "d_21": "{m}",
        "d_22": "{s}",
        "d_23": "{s}",
        "d_24": "{s}",
        "d_25": "{s}",
        "d_26": "{m}",
        "d_27": "{flexDirection.column}",
        "d_28": "{s}",
        "d_29": "{justifyContent.start}",
        "d_30": "{alignItems.center}",
        "d_31": "{size.max}",
        "d_32": "{m}",
        "d_33": "{m}",
        "d_34": "{flexDirection.column}",
        "d_35": "{justifyContent.start}",
        "d_36": "{alignItems.center}",
        "d_37": "{s}",
        "d_38": "{size.max}",
        "d_39": "{justifyContent.spaceBetween}",
        "d_40": "{justifyContent.spaceBetween}"
    },
    "JDSDatepickerMobileInteral": {
        "d_0": "{primaryBackground}",
        "d_1": "{flexDirection.column}",
        "d_2": "{justifyContent.start}",
        "d_3": "{alignItems.center}",
        "d_4": "{size.max}",
        "d_5": "{flexDirection.row}",
        "d_6": "{justifyContent.end}",
        "d_7": "{alignItems.center}",
        "d_8": "{xs}",
        "d_9": "{xs}",
        "d_10": "{s}",
        "d_11": "{s}",
        "d_12": "{size.max}",
        "d_13": "{flexDirection.column}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.center}",
        "d_16": "{m}",
        "d_17": "{s}",
        "d_18": "{s}",
        "d_19": "{s}",
        "d_20": "{s}",
        "d_21": "{m}",
        "d_22": "{s}",
        "d_23": "{s}",
        "d_24": "{s}",
        "d_25": "{s}",
        "d_26": "{m}",
        "d_27": "{flexDirection.column}",
        "d_28": "{s}",
        "d_29": "{justifyContent.start}",
        "d_30": "{alignItems.center}",
        "d_31": "{size.max}",
        "d_32": "{m}",
        "d_33": "{m}",
        "d_34": "{flexDirection.column}",
        "d_35": "{justifyContent.start}",
        "d_36": "{alignItems.center}",
        "d_37": "{s}",
        "d_38": "{size.max}",
        "d_39": "{justifyContent.spaceBetween}",
        "d_40": "{justifyContent.spaceBetween}"
    },
    "JDSDivider": {
        "d_0": "{global.transparent}",
        "d_1": "{flexDirection.row}",
        "d_2": "{justifyContent.center}",
        "d_3": "{alignItems.center}",
        "d_4": "{xs}",
        "d_5": "{s}",
        "d_6": "{s}",
        "d_7": "{s}",
        "d_8": "{s}",
        "d_9": "{custom_5}",
        "d_10": "{custom_5}",
        "d_11": "{flexDirection.row}",
        "d_12": "{primaryGrey40}",
        "d_13": "{pill}",
        "d_14": "{custom_5}",
        "d_15": "{custom_5}",
        "d_16": "{flexDirection.row}",
        "d_17": "{primaryGrey40}",
        "d_18": "{pill}",
        "d_19": "{sparkle50}",
        "d_20": "{sparkle50}",
        "d_21": "{size.max}",
        "d_22": "{size.max}",
        "d_23": "{flexDirection.column}",
        "d_24": "{flexDirection.column}",
        "d_25": "{flexDirection.column}",
        "d_26": "{base}",
        "d_27": "{base}",
        "d_28": "{base}",
        "d_29": "{base}",
        "d_30": "{base}",
        "d_31": "{base}",
        "d_32": "{base}",
        "d_33": "{base}",
        "d_34": "{base}",
        "d_35": "{base}",
        "d_36": "{base}",
        "d_37": "{base}",
        "d_38": "{m}",
        "d_39": "{m}",
        "d_40": "{m}",
        "d_41": "{m}",
        "d_42": "{m}",
        "d_43": "{m}",
        "d_44": "{m}",
        "d_45": "{m}",
        "d_46": "{m}",
        "d_47": "{m}",
        "d_48": "{m}",
        "d_49": "{m}",
        "d_50": "{xs}",
        "d_51": "{xs}",
        "d_52": "{xs}",
        "d_53": "{xs}",
        "d_54": "{xs}",
        "d_55": "{xs}",
        "d_56": "{xs}",
        "d_57": "{xs}",
        "d_58": "{xs}",
        "d_59": "{xs}",
        "d_60": "{xs}",
        "d_61": "{xs}",
        "d_62": "{xxs}",
        "d_63": "{xxs}",
        "d_64": "{xxs}",
        "d_65": "{xxs}",
        "d_66": "{xxs}",
        "d_67": "{xxs}",
        "d_68": "{xxs}",
        "d_69": "{xxs}",
        "d_70": "{xxs}",
        "d_71": "{xxs}",
        "d_72": "{xxs}",
        "d_73": "{xxs}",
        "d_74": "{xxl}",
        "d_75": "{xxl}",
        "d_76": "{xxl}",
        "d_77": "{xxl}",
        "d_78": "{xxl}",
        "d_79": "{xxl}",
        "d_80": "{xxl}",
        "d_81": "{xxl}",
        "d_82": "{xxl}",
        "d_83": "{xxl}",
        "d_84": "{xxl}",
        "d_85": "{xxl}",
        "d_86": "{xl}",
        "d_87": "{xl}",
        "d_88": "{xl}",
        "d_89": "{xl}",
        "d_90": "{xl}",
        "d_91": "{xl}",
        "d_92": "{xl}",
        "d_93": "{xl}",
        "d_94": "{xl}",
        "d_95": "{xl}",
        "d_96": "{xl}",
        "d_97": "{xl}",
        "d_98": "{l}",
        "d_99": "{l}",
        "d_100": "{l}",
        "d_101": "{l}",
        "d_102": "{l}",
        "d_103": "{l}",
        "d_104": "{l}",
        "d_105": "{l}",
        "d_106": "{l}",
        "d_107": "{l}",
        "d_108": "{l}",
        "d_109": "{l}",
        "d_110": "{huge}",
        "d_111": "{huge}",
        "d_112": "{huge}",
        "d_113": "{huge}",
        "d_114": "{huge}",
        "d_115": "{huge}",
        "d_116": "{huge}",
        "d_117": "{huge}",
        "d_118": "{huge}",
        "d_119": "{huge}",
        "d_120": "{huge}",
        "d_121": "{huge}",
        "d_122": "{massive}",
        "d_123": "{massive}",
        "d_124": "{massive}",
        "d_125": "{massive}",
        "d_126": "{massive}",
        "d_127": "{massive}",
        "d_128": "{massive}",
        "d_129": "{massive}",
        "d_130": "{massive}",
        "d_131": "{massive}",
        "d_132": "{massive}",
        "d_133": "{massive}"
    },
    "JDSDatepickerViewButton": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{justifyContent.center}",
        "d_3": "{alignItems.center}",
        "d_4": "{xxl}",
        "d_5": "{custom_7}",
        "d_6": "{flexDirection.row}",
        "d_7": "{justifyContent.center}",
        "d_8": "{alignItems.center}"
    },
    "JDSFAB": {
        "f_0": "{flexDirection.stack}",
        "f_1": "{justifyContent.end}",
        "f_2": "{alignItems.end}",
        "f_3": "{size.max}",
        "f_4": "{base}",
        "f_5": "{base}",
        "f_6": "{secondary50}",
        "f_7": "{flexDirection.row}",
        "f_8": "{justifyContent.center}",
        "f_9": "{alignItems.center}",
        "f_10": "{xs}",
        "f_11": "{pill}",
        "f_12": "{base}",
        "f_13": "{m}",
        "f_14": "{m}",
        "f_15": "{base}",
        "f_16": "{primary80}",
        "f_17": "{border_none}",
        "f_18": "{secondary60}",
        "f_19": "{secondary60}",
        "f_20": "{secondary60}",
        "f_21": "{border_focus}",
        "f_22": "{m}",
        "f_23": "{secondaryInverse}",
        "f_24": "{pill}",
        "f_25": "{secondary30}",
        "f_26": "{base}",
        "f_27": "{base}"
    },
    "JDSFABInternal": {
        "f_0": "{flexDirection.stack}",
        "f_1": "{justifyContent.end}",
        "f_2": "{alignItems.end}",
        "f_3": "{size.max}",
        "f_4": "{base}",
        "f_5": "{base}",
        "f_6": "{secondary50}",
        "f_7": "{flexDirection.row}",
        "f_8": "{justifyContent.center}",
        "f_9": "{alignItems.center}",
        "f_10": "{xs}",
        "f_11": "{pill}",
        "f_12": "{base}",
        "f_13": "{m}",
        "f_14": "{m}",
        "f_15": "{base}",
        "f_16": "{primary80}",
        "f_17": "{border_none}",
        "f_18": "{secondary60}",
        "f_19": "{secondary60}",
        "f_20": "{secondary60}",
        "f_21": "{border_focus}",
        "f_22": "{m}",
        "f_23": "{secondaryInverse}",
        "f_24": "{pill}",
        "f_25": "{secondary30}",
        "f_26": "{base}",
        "f_27": "{base}"
    },
    "JDSDropdown": {
        "d_0": "{flexDirection.column}",
        "d_1": "{xxs}",
        "d_2": "{size.max}",
        "d_3": "{justifyContent.start}",
        "d_4": "{alignItems.start}",
        "d_5": "{flexDirection.stack}",
        "d_6": "{size.max}",
        "d_7": "{alignItems.end}",
        "d_8": "{justifyContent.start}",
        "d_9": "{xxs}",
        "d_10": "{flexDirection.row}",
        "d_11": "{xs}",
        "d_12": "{flexDirection.row}",
        "d_13": "{justifyContent.end}",
        "d_14": "{size.max}",
        "d_15": "{alignItems.center}",
        "d_16": "{flexDirection.column}",
        "d_17": "{size.max}",
        "d_18": "{alignItems.center}",
        "d_19": "{size.max}",
        "d_20": "{primaryGrey100}",
        "d_21": "{primary50}",
        "d_22": "{primary50}",
        "d_23": "{primary50}",
        "d_24": "{border_thin}",
        "d_25": "{primaryGrey60}",
        "d_26": "{medium}",
        "d_27": "{custom_17}",
        "d_28": "{custom_17}",
        "d_29": "{s}",
        "d_30": "{xs}",
        "d_31": "{primartGrey60}",
        "d_32": "{white}",
        "d_33": "{white}",
        "d_34": "{m}",
        "d_35": "{primaryGrey80}",
        "d_36": "{opacity.disabled}",
        "d_37": "{opacity.enabled}",
        "d_38": "{feedbackSuccess50}",
        "d_39": "{feedbackSuccess50}",
        "d_40": "{feedbackSuccess50}",
        "d_41": "{feedbackSuccess50}",
        "d_42": "{feedbackError50}",
        "d_43": "{feedbackError50}",
        "d_44": "{feedbackError50}",
        "d_45": "{feedbackError50}",
        "d_46": "{feedbackWarning50}",
        "d_47": "{feedbackWarning50}",
        "d_48": "{feedbackWarning50}",
        "d_49": "{feedbackWarning50}",
        "d_50": "{primaryGrey20}",
        "d_51": "{xl}",
        "d_52": "{alignItems.start}",
        "d_53": "{alignItems.start}",
        "d_54": "{alignItems.end}",
        "d_55": "{l}",
        "d_56": "{alignItems.end}",
        "d_57": "{s}",
        "d_58": "{primary60}"
    },
    "JDSDropdownMenu": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{flexDirection.column}",
        "d_4": "{large}",
        "d_5": "{xs}",
        "d_6": "{xs}",
        "d_7": "{base}",
        "d_8": "{base}",
        "d_9": "{base}",
        "d_10": "{custom_color_5}",
        "d_11": "{size.max}",
        "d_12": "{size.max}",
        "d_13": "{size.max}",
        "d_14": "{size.max}",
        "d_15": "{size.max}",
        "d_16": "{opacity.invisible}",
        "d_17": "{opacity.enabled}"
    },
    "JDSDropdownMenuInternal": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{flexDirection.column}",
        "d_4": "{large}",
        "d_5": "{xs}",
        "d_6": "{xs}",
        "d_7": "{base}",
        "d_8": "{base}",
        "d_9": "{base}",
        "d_10": "{custom_color_5}",
        "d_11": "{size.max}",
        "d_12": "{size.max}",
        "d_13": "{size.max}",
        "d_14": "{size.max}",
        "d_15": "{size.max}",
        "d_16": "{opacity.invisible}",
        "d_17": "{opacity.enabled}"
    },
    "JDSDropdownMenuItem": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{flexDirection.column}",
        "d_3": "{s}",
        "d_4": "{primaryGrey20}",
        "d_5": "{primaryBackground}",
        "d_6": "{primary50}",
        "d_7": "{primaryGrey100}",
        "d_8": "{xs}",
        "d_9": "{base}",
        "d_10": "{xs}",
        "d_11": "{base}",
        "d_12": "{primary50}",
        "d_13": "{primary50}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.start}",
        "d_16": "{alignItems.center}",
        "d_17": "{alignItems.start}",
        "d_18": "{primary60}",
        "d_19": "{m}",
        "d_20": "{primaryInverse}",
        "d_21": "{primaryInverse}",
        "d_22": "{opacity.disabled}",
        "d_23": "{small}",
        "d_24": "{size.max}"
    },
    "JDSDropdownMenuItemMobile": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.row}",
        "d_2": "{flexDirection.column}",
        "d_3": "{s}",
        "d_4": "{primaryGrey20}",
        "d_5": "{primaryBackground}",
        "d_6": "{primary50}",
        "d_7": "{primaryGrey100}",
        "d_8": "{xs}",
        "d_9": "{base}",
        "d_10": "{xs}",
        "d_11": "{base}",
        "d_12": "{primary50}",
        "d_13": "{primary50}",
        "d_14": "{justifyContent.start}",
        "d_15": "{alignItems.start}",
        "d_16": "{alignItems.center}",
        "d_17": "{alignItems.start}",
        "d_18": "{primary60}",
        "d_19": "{m}",
        "d_20": "{primaryInverse}",
        "d_21": "{primaryInverse}",
        "d_22": "{opacity.disabled}",
        "d_23": "{small}",
        "d_24": "{size.max}"
    },
    "JDSDropdownMenuGroup": {
        "d_0": "{size.max}",
        "d_1": "{flexDirection.column}",
        "d_2": "{flexDirection.column}",
        "d_3": "{xs}",
        "d_4": "{base}",
        "d_5": "{base}",
        "d_6": "{size.max}",
        "d_7": "{primaryGrey20}",
        "d_8": "{size.max}"
    },
    "JDSDropdownMenuSubMenu": {
        "d_0": "{global.transparent}",
        "d_1": "{primaryGrey20}",
        "d_2": "{flexDirection.column}",
        "d_3": "{large}",
        "d_4": "{xs}",
        "d_5": "{xs}",
        "d_6": "{custom_color_5}",
        "d_7": "{size.max}",
        "d_8": "{size.max}",
        "d_9": "{opacity.invisible}",
        "d_10": "{opacity.enabled}"
    },
    "JDSFeedbackBlock": {
        "f_0": "{flexDirection.row}",
        "f_1": "{justifyContent.center}",
        "f_2": "{alignItems.center}",
        "f_3": "{xs}",
        "f_4": "{alignItems.start}",
        "f_5": "{flexDirection.row}",
        "f_6": "{justifyContent.center}",
        "f_7": "{alignItems.center}",
        "f_8": "{m}",
        "f_9": "{m}",
        "f_10": "{custom_18}",
        "f_11": "{base}"
    },
    "JDSBottomFooterLinkItem": {
        "b_0": "{base}"
    },
    "JDSFooterIconLinks": {
        "f_0": "{base}",
        "f_1": "{flexDirection.column}",
        "f_2": "{alignItems.start}",
        "f_3": "{flexDirection.row}",
        "f_4": "{base}"
    },
    "JDSFooter": {
        "f_0": "{flexDirection.column}",
        "f_1": "{alignItems.center}",
        "f_2": "{size.max}",
        "f_3": "{primaryGrey20}",
        "f_4": "{flexDirection.row}",
        "f_5": "{justifyContent.spaceBetween}",
        "f_6": "{alignItems.start}",
        "f_7": "{base}",
        "f_8": "{size.max}",
        "f_9": "{xl}",
        "f_10": "{xl}",
        "f_11": "{huge}",
        "f_12": "{huge}",
        "f_13": "{xs}",
        "f_14": "{flexDirection.column}",
        "f_15": "{l}",
        "f_16": "{flexDirection.column}",
        "f_17": "{alignItems.start}",
        "f_18": "{size.max}",
        "f_19": "{size.max}",
        "f_20": "{size.max}",
        "f_21": "{m}",
        "f_22": "{flexDirection.column}",
        "f_23": "{justifyContent.start}",
        "f_24": "{m}",
        "f_25": "{xl}",
        "f_26": "{m}",
        "f_27": "{m}",
        "f_28": "{custom_17}"
    },
    "JDSBottomFooter": {
        "b_0": "{flexDirection.row}",
        "b_1": "{justifyContent.spaceBetween}",
        "b_2": "{alignItems.center}",
        "b_3": "{base}",
        "b_4": "{huge}",
        "b_5": "{base}",
        "b_6": "{huge}",
        "b_7": "{global.transparent}",
        "b_8": "{base}",
        "b_9": "{flexDirection.row}",
        "b_10": "{alignItems.center}",
        "b_11": "{alignItems.center}",
        "b_12": "{size.max}",
        "b_13": "{flexDirection.column}",
        "b_14": "{justifyContent.start}",
        "b_15": "{alignItems.start}",
        "b_16": "{m}",
        "b_17": "{m}",
        "b_18": "{m}",
        "b_19": "{base}",
        "b_20": "{flexDirection.column}",
        "b_21": "{alignItems.start}",
        "b_22": "{base}"
    },
    "JDSFooterLinksGrid": {
        "f_0": "{flexDirection.row}",
        "f_1": "{size.max}",
        "f_2": "{base}"
    },
    "JDSFooterLinks": {
        "f_0": "{flexDirection.column}",
        "f_1": "{alignItems.start}",
        "f_2": "{size.max}",
        "f_3": "{size.max}",
        "f_4": "{xs}",
        "f_5": "{xs}",
        "f_6": "{flexDirection.column}",
        "f_7": "{justifyContent.start}",
        "f_8": "{alignItems.start}",
        "f_9": "{global.transparent}",
        "f_10": "{primaryGrey40}",
        "f_11": "{xs}",
        "f_12": "{xs}",
        "f_13": "{s}",
        "f_14": "{size.max}",
        "f_15": "{flexDirection.column}"
    },
    "JDSIcon": {
        "icon_0": "{global.transparent}",
        "icon_1": "{pill}",
        "icon_2": "{m}",
        "icon_3": "{justifyContent.center}",
        "icon_4": "{alignItems.center}",
        "icon_5": "{m}",
        "icon_6": "{custom_color_1}",
        "icon_7": "{primary50}",
        "icon_8": "{primary30}",
        "icon_9": "{primary60}",
        "icon_10": "{primary70}",
        "icon_11": "{primaryBackground}",
        "icon_12": "{secondary50}",
        "icon_13": "{sparkle50}",
        "icon_14": "{primaryGrey60}",
        "icon_15": "{primaryGrey80}",
        "icon_16": "{primaryGrey100}",
        "icon_17": "{feedbackSuccess50}",
        "icon_18": "{feedbackError50}",
        "icon_19": "{feedbackWarning50}",
        "icon_20": "{global.white}",
        "icon_21": "{base}",
        "icon_22": "{base}",
        "icon_23": "{l}",
        "icon_24": "{l}",
        "icon_25": "{xl}",
        "icon_26": "{xl}",
        "icon_27": "{xxl}",
        "icon_28": "{xxl}",
        "icon_29": "{size.max}",
        "icon_30": "{size.max}",
        "icon_31": "{primary20}",
        "icon_32": "{primary20}",
        "icon_33": "{primary20}",
        "icon_34": "{primary20}",
        "icon_35": "{primary20}",
        "icon_36": "{secondary20}",
        "icon_37": "{sparkle20}",
        "icon_38": "{primaryGrey20}",
        "icon_39": "{primaryGrey20}",
        "icon_40": "{primaryGrey20}",
        "icon_41": "{primary20}",
        "icon_42": "{feedbackSuccess20}",
        "icon_43": "{feedbackError20}",
        "icon_44": "{feedbackWarning20}",
        "icon_45": "{primary50}",
        "icon_46": "{primaryInverse}",
        "icon_47": "{primary30}",
        "icon_48": "{primary30}",
        "icon_49": "{primary60}",
        "icon_50": "{primaryInverse}",
        "icon_51": "{primary70}",
        "icon_52": "{primaryInverse}",
        "icon_53": "{primaryBackground}",
        "icon_54": "{primaryInverse}",
        "icon_55": "{secondary50}",
        "icon_56": "{secondaryInverse}",
        "icon_57": "{sparkle50}",
        "icon_58": "{sparkleInverse}",
        "icon_59": "{primaryGrey60}",
        "icon_60": "{primaryInverse}",
        "icon_61": "{primaryGrey80}",
        "icon_62": "{primaryInverse}",
        "icon_63": "{primaryGrey100}",
        "icon_64": "{primaryInverse}",
        "icon_65": "{global.white}",
        "icon_66": "{global.white}",
        "icon_67": "{feedbackSuccess50}",
        "icon_68": "{primaryInverse}",
        "icon_69": "{feedbackError50}",
        "icon_70": "{primaryInverse}",
        "icon_71": "{feedbackWarning50}",
        "icon_72": "{primaryInverse}",
        "icon_73": "{m}",
        "icon_74": "{base}",
        "icon_75": "{base}",
        "icon_76": "{global.transparent}",
        "icon_77": "{base}",
        "icon_78": "{l}",
        "icon_79": "{m}",
        "icon_80": "{xl}",
        "icon_81": "{custom_3}",
        "icon_82": "{xxl}",
        "icon_83": "{l}",
        "icon_84": "{global.transparent}",
        "icon_85": "{primary50}",
        "icon_86": "{global.transparent}",
        "icon_87": "{primary30}",
        "icon_88": "{global.transparent}",
        "icon_89": "{primary60}",
        "icon_90": "{global.transparent}",
        "icon_91": "{primary70}",
        "icon_92": "{global.transparent}",
        "icon_93": "{primaryBackground}",
        "icon_94": "{global.transparent}",
        "icon_95": "{secondary50}",
        "icon_96": "{global.transparent}",
        "icon_97": "{sparkle50}",
        "icon_98": "{global.transparent}",
        "icon_99": "{primaryGrey60}",
        "icon_100": "{global.transparent}",
        "icon_101": "{primaryGrey80}",
        "icon_102": "{global.transparent}",
        "icon_103": "{primaryGrey100}",
        "icon_104": "{global.transparent}",
        "icon_105": "{global.white}",
        "icon_106": "{global.transparent}",
        "icon_107": "{feedbackSuccess50}",
        "icon_108": "{global.transparent}",
        "icon_109": "{feedbackError50}",
        "icon_110": "{global.transparent}",
        "icon_111": "{feedbackWarning50}",
        "icon_112": "{m}",
        "icon_113": "{base}",
        "icon_114": "{base}",
        "icon_115": "{base}",
        "icon_116": "{l}",
        "icon_117": "{m}",
        "icon_118": "{xl}",
        "icon_119": "{custom_3}",
        "icon_120": "{xxl}",
        "icon_121": "{l}",
        "icon_122": "{m}",
        "icon_123": "{m}",
        "icon_124": "{m}",
        "icon_125": "{m}",
        "icon_126": "{m}",
        "icon_127": "{m}",
        "icon_128": "{m}",
        "icon_129": "{m}",
        "icon_130": "{m}",
        "icon_131": "{m}",
        "icon_132": "{m}",
        "icon_133": "{m}",
        "icon_134": "{l}",
        "icon_135": "{l}",
        "icon_136": "{l}",
        "icon_137": "{l}",
        "icon_138": "{l}",
        "icon_139": "{l}",
        "icon_140": "{l}",
        "icon_141": "{l}",
        "icon_142": "{l}",
        "icon_143": "{l}",
        "icon_144": "{l}",
        "icon_145": "{l}",
        "icon_146": "{xl}",
        "icon_147": "{xl}",
        "icon_148": "{xl}",
        "icon_149": "{xl}",
        "icon_150": "{xl}",
        "icon_151": "{xl}",
        "icon_152": "{xl}",
        "icon_153": "{xl}",
        "icon_154": "{xl}",
        "icon_155": "{xl}",
        "icon_156": "{xl}",
        "icon_157": "{xl}",
        "icon_158": "{xxl}",
        "icon_159": "{xxl}",
        "icon_160": "{xxl}",
        "icon_161": "{xxl}",
        "icon_162": "{xxl}",
        "icon_163": "{xxl}",
        "icon_164": "{xxl}",
        "icon_165": "{xxl}",
        "icon_166": "{xxl}",
        "icon_167": "{xxl}",
        "icon_168": "{xxl}",
        "icon_169": "{xxl}",
        "icon_170": "{primaryInverse}",
        "icon_171": "{secondaryInverse}",
        "icon_172": "{sparkleInverse}",
        "icon_173": "{global.white}"
    },
    "JDSFooterMarketLinks": {
        "f_0": "{base}",
        "f_1": "{flexDirection.column}",
        "f_2": "{alignItems.start}",
        "f_3": "{flexDirection.row}",
        "f_4": "{alignItems.center}",
        "f_5": "{base}"
    },
    "JDSImage": {
        "i_0": "{global.transparent}",
        "i_1": "{flexDirection.stack}",
        "i_2": "{justifyContent.center}",
        "i_3": "{alignItems.center}",
        "i_4": "{size.min}",
        "i_5": "{size.min}",
        "i_6": "{xl}",
        "i_7": "{aspect_ratio.1.1}",
        "i_8": "{xl}",
        "i_9": "{size.max}",
        "i_10": "{size.max}",
        "i_11": "{l}",
        "i_12": "{primaryGrey80}",
        "i_13": "{size.max}",
        "i_14": "{aspect_ratio.1.1}",
        "i_15": "{size.max}",
        "i_16": "{size.max}",
        "i_17": "{primaryGrey20}",
        "i_18": "{opacity.invisible}",
        "i_19": "{primaryGrey20}",
        "i_20": "{opacity.invisible}",
        "i_21": "{primaryGrey20}",
        "i_22": "{opacity.invisible}",
        "i_23": "{aspect_ratio.4.3}",
        "i_24": "{aspect_ratio.4.3}",
        "i_25": "{aspect_ratio.4.3}",
        "i_26": "{aspect_ratio.4.3}",
        "i_27": "{aspect_ratio.5.4}",
        "i_28": "{aspect_ratio.5.4}",
        "i_29": "{aspect_ratio.5.4}",
        "i_30": "{aspect_ratio.5.4}",
        "i_31": "{aspect_ratio.16.9}",
        "i_32": "{aspect_ratio.16.9}",
        "i_33": "{aspect_ratio.16.9}",
        "i_34": "{aspect_ratio.16.9}",
        "i_35": "{aspect_ratio.4.5}",
        "i_36": "{aspect_ratio.4.5}",
        "i_37": "{aspect_ratio.4.5}",
        "i_38": "{aspect_ratio.4.5}",
        "i_39": "{aspect_ratio.3.4}",
        "i_40": "{aspect_ratio.3.4}",
        "i_41": "{aspect_ratio.3.4}",
        "i_42": "{aspect_ratio.3.4}",
        "i_43": "{aspect_ratio.9.16}",
        "i_44": "{aspect_ratio.9.16}",
        "i_45": "{aspect_ratio.9.16}",
        "i_46": "{aspect_ratio.9.16}",
        "i_47": "{aspect_ratio.2_75.1}",
        "i_48": "{aspect_ratio.2_75.1}",
        "i_49": "{aspect_ratio.2_75.1}",
        "i_50": "{aspect_ratio.2_75.1}"
    },
    "JDSInput": {
        "i_0": "{textAlign.start}",
        "i_1": "{primaryGrey60}",
        "i_2": "{bodyS}",
        "i_3": "{bodyS}",
        "i_4": "{bodyS}",
        "i_5": "{bodyS}",
        "i_6": "{bodyS}",
        "i_7": "{primaryGrey100}",
        "i_8": "{bodyS}",
        "i_9": "{bodyS}",
        "i_10": "{bodyS}",
        "i_11": "{bodyS}",
        "i_12": "{bodyS}",
        "i_13": "{primaryGrey100}",
        "i_14": "{size.max}",
        "i_15": "{opacity.disabled}",
        "i_16": "{textAlign.center}",
        "i_17": "{textAlign.end}",
        "i_18": "{textAlign.justify}",
        "i_19": "{bodyL}",
        "i_20": "{bodyL}",
        "i_21": "{bodyL}",
        "i_22": "{bodyL}",
        "i_23": "{bodyL}",
        "i_24": "{bodyL}",
        "i_25": "{bodyL}",
        "i_26": "{bodyL}",
        "i_27": "{primary80}",
        "i_28": "{primary70}",
        "i_29": "{primary60}",
        "i_30": "{primary50}",
        "i_31": "{primary40}",
        "i_32": "{primary30}",
        "i_33": "{primary20}",
        "i_34": "{primaryInverse}",
        "i_35": "{primaryBackground}",
        "i_36": "{primaryGrey100}",
        "i_37": "{primaryGrey80}",
        "i_38": "{primaryGrey60}",
        "i_39": "{primaryGrey40}",
        "i_40": "{primaryGrey20}",
        "i_41": "{secondary80}",
        "i_42": "{secondary70}",
        "i_43": "{secondary60}",
        "i_44": "{secondary50}",
        "i_45": "{secondary40}",
        "i_46": "{secondary30}",
        "i_47": "{secondary20}",
        "i_48": "{secondaryInverse}",
        "i_49": "{secondaryBackground}",
        "i_50": "{secondaryGrey100}",
        "i_51": "{secondaryGrey80}",
        "i_52": "{secondaryGrey60}",
        "i_53": "{secondaryGrey40}",
        "i_54": "{secondaryGrey20}",
        "i_55": "{sparkle80}",
        "i_56": "{sparkle70}",
        "i_57": "{sparkle60}",
        "i_58": "{sparkle50}",
        "i_59": "{sparkle40}",
        "i_60": "{sparkle30}",
        "i_61": "{sparkle20}",
        "i_62": "{sparkleInverse}",
        "i_63": "{sparkleBackground}",
        "i_64": "{sparkleGrey100}",
        "i_65": "{sparkleGrey80}",
        "i_66": "{sparkleGrey60}",
        "i_67": "{sparkleGrey40}",
        "i_68": "{sparkleGrey20}",
        "i_69": "{feedbackError80}",
        "i_70": "{feedbackError50}",
        "i_71": "{feedbackError20}",
        "i_72": "{feedbackWarning80}",
        "i_73": "{feedbackWarning50}",
        "i_74": "{feedbackWarning20}",
        "i_75": "{feedbackSuccess80}",
        "i_76": "{feedbackSuccess50}",
        "i_77": "{feedbackSuccess20}",
        "i_78": "{global.white}",
        "i_79": "{global.black}",
        "i_80": "{global.transparent}"
    },
    "JDSInputCodeItem": {
        "i_0": "{flexDirection.column}",
        "i_1": "{justifyContent.center}",
        "i_2": "{alignItems.center}",
        "i_3": "{xs}",
        "i_4": "{size.max}",
        "i_5": "{size.max}",
        "i_6": "{flexDirection.column}",
        "i_7": "{justifyContent.center}",
        "i_8": "{alignItems.center}",
        "i_9": "{size.max}",
        "i_10": "{custom_1}",
        "i_11": "{custom_1}",
        "i_12": "{size.max}",
        "i_13": "{custom_4}",
        "i_14": "{primaryGrey100}",
        "i_15": "{custom_2}",
        "i_16": "{primary50}",
        "i_17": "{primary50}",
        "i_18": "{primary50}",
        "i_19": "{feedbackSuccess50}",
        "i_20": "{feedbackError50}",
        "i_21": "{feedbackWarning50}",
        "i_22": "{primary60}"
    },
    "JDSInputDate": {
        "i_0": "{flexDirection.column}",
        "i_1": "{alignItems.start}",
        "i_2": "{xs}",
        "i_3": "{size.max}",
        "i_4": "{flexDirection.row}",
        "i_5": "{size.max}",
        "i_6": "{alignItems.center}",
        "i_7": "{flexDirection.column}",
        "i_8": "{size.max}",
        "i_9": "{alignItems.start}",
        "i_10": "{size.max}",
        "i_11": "{s}",
        "i_12": "{alignItems.stretch}",
        "i_13": "{flexDirection.column}",
        "i_14": "{xs}",
        "i_15": "{alignItems.start}",
        "i_16": "{textAlign.start}",
        "i_17": "{size.max}",
        "i_18": "{size.max}",
        "i_19": "{primaryGrey80}",
        "i_20": "{primaryGrey60}",
        "i_21": "{flexDirection.column}",
        "i_22": "{xs}",
        "i_23": "{alignItems.start}",
        "i_24": "{textAlign.start}",
        "i_25": "{size.max}",
        "i_26": "{size.max}",
        "i_27": "{primaryGrey80}",
        "i_28": "{primaryGrey60}",
        "i_29": "{flexDirection.column}",
        "i_30": "{xs}",
        "i_31": "{alignItems.start}",
        "i_32": "{textAlign.start}",
        "i_33": "{size.max}",
        "i_34": "{size.max}",
        "i_35": "{primaryGrey80}",
        "i_36": "{justifyContent.center}",
        "i_37": "{alignItems.center}",
        "i_38": "{flexDirection.column}",
        "i_39": "{alignItems.start}",
        "i_40": "{xs}",
        "i_41": "{size.max}",
        "i_42": "{opacity.disabled}",
        "i_43": "{opacity.disabled}",
        "i_44": "{feedbackError50}",
        "i_45": "{feedbackError50}",
        "i_46": "{feedbackError50}",
        "i_47": "{feedbackError50}",
        "i_48": "{feedbackError50}",
        "i_49": "{feedbackError50}"
    },
    "JDSLink": {
        "l_0": "{global.transparent}",
        "l_1": "{flexDirection.row}",
        "l_2": "{justifyContent.center}",
        "l_3": "{alignItems.center}",
        "l_4": "{small}",
        "l_5": "{border_normal}",
        "l_6": "{primary60}",
        "l_7": "{primary30}",
        "l_8": "{text-decoration.underline}",
        "l_9": "{text-decoration.underline}",
        "l_10": "{text-decoration.underline}",
        "l_11": "{text-decoration.none}",
        "l_12": "{text-decoration.underline}"
    },
    "JDSFileUploader": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{xs}",
        "f_5": "{opacity.enabled}"
    },
    "JDSFileUploaderControl": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{xxs}",
        "f_4": "{size.max}",
        "f_5": "{opacity.enabled}",
        "f_6": "{flexDirection.row}",
        "f_7": "{justifyContent.start}",
        "f_8": "{alignItems.center}",
        "f_9": "{xxs}"
    },
    "JDSFileUploaderItem": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{flexDirection.row}",
        "f_7": "{justifyContent.spaceBetween}",
        "f_8": "{alignItems.center}",
        "f_9": "{xs}",
        "f_10": "{s}",
        "f_11": "{size.max}",
        "f_12": "{flexDirection.row}",
        "f_13": "{justifyContent.start}",
        "f_14": "{alignItems.center}",
        "f_15": "{xs}",
        "f_16": "{alignItems.center}"
    },
    "JDSFileUploaderList": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{large}"
    },
    "JDSFileUploaderPanel": {
        "f_0": "{flexDirection.column}",
        "f_1": "{justifyContent.start}",
        "f_2": "{alignItems.start}",
        "f_3": "{size.max}",
        "f_4": "{opacity.enabled}",
        "f_5": "{primaryGrey20}",
        "f_6": "{large}",
        "f_7": "{xs}",
        "f_8": "{xs}",
        "f_9": "{xs}",
        "f_10": "{xs}",
        "f_11": "{s}",
        "f_12": "{s}",
        "f_13": "{size.max}"
    },
    "JDSMenuBlock": {
        "m_0": "{global.transparent}",
        "m_1": "{flexDirection.stack}",
        "m_2": "{base}",
        "m_3": "{base}",
        "m_4": "{size.max}",
        "m_5": "{intrinsicSize.max}",
        "m_6": "{primaryBackground}",
        "m_7": "{flexDirection.column}",
        "m_8": "{medium}",
        "m_9": "{size.max}"
    },
    "JDSMenuBlockInternal": {
        "m_0": "{global.transparent}",
        "m_1": "{flexDirection.stack}",
        "m_2": "{base}",
        "m_3": "{base}",
        "m_4": "{size.max}",
        "m_5": "{intrinsicSize.max}",
        "m_6": "{primaryBackground}",
        "m_7": "{flexDirection.column}",
        "m_8": "{medium}",
        "m_9": "{size.max}"
    },
    "JDSListBlock": {
        "l_0": "{flexDirection.column}",
        "l_1": "{size.max}",
        "l_2": "{justifyContent.start}",
        "l_3": "{alignItems.start}",
        "l_4": "{xs}",
        "l_5": "{xs}",
        "l_6": "{xs}",
        "l_7": "{flexDirection.row}",
        "l_8": "{size.max}",
        "l_9": "{base}",
        "l_10": "{justifyContent.start}",
        "l_11": "{alignItems.center}",
        "l_12": "{flexDirection.column}",
        "l_13": "{xxs}",
        "l_14": "{justifyContent.start}",
        "l_15": "{alignItems.start}",
        "l_16": "{flexDirection.row}",
        "l_17": "{size.max}",
        "l_18": "{justifyContent.spaceBetween}",
        "l_19": "{alignItems.center}",
        "l_20": "{s}",
        "l_21": "{flexDirection.row}",
        "l_22": "{justifyContent.start}",
        "l_23": "{alignItems.center}",
        "l_24": "{s}",
        "l_25": "{flexDirection.row}",
        "l_26": "{size.max}",
        "l_27": "{justifyContent.spaceBetween}",
        "l_28": "{alignItems.center}",
        "l_29": "{s}",
        "l_30": "{flexDirection.row}",
        "l_31": "{justifyContent.start}",
        "l_32": "{alignItems.center}",
        "l_33": "{s}",
        "l_34": "{flexDirection.row}",
        "l_35": "{size.max}",
        "l_36": "{justifyContent.spaceBetween}",
        "l_37": "{alignItems.center}",
        "l_38": "{s}",
        "l_39": "{flexDirection.row}",
        "l_40": "{justifyContent.start}",
        "l_41": "{alignItems.center}",
        "l_42": "{s}",
        "l_43": "{s}",
        "l_44": "{xxs}",
        "l_45": "{alignItems.start}"
    },
    "JDSInputField": {
        "i_0": "{flexDirection.column}",
        "i_1": "{xxs}",
        "i_2": "{size.max}",
        "i_3": "{justifyContent.start}",
        "i_4": "{alignItems.start}",
        "i_5": "{flexDirection.stack}",
        "i_6": "{size.max}",
        "i_7": "{alignItems.end}",
        "i_8": "{justifyContent.start}",
        "i_9": "{xxs}",
        "i_10": "{flexDirection.row}",
        "i_11": "{justifyContent.start}",
        "i_12": "{size.max}",
        "i_13": "{xs}",
        "i_14": "{alignItems.center}",
        "i_15": "{m}",
        "i_16": "{primaryGrey80}",
        "i_17": "{textAlign.start}",
        "i_18": "{m}",
        "i_19": "{primaryGrey80}",
        "i_20": "{primary60}",
        "i_21": "{flexDirection.column}",
        "i_22": "{size.max}",
        "i_23": "{alignItems.center}",
        "i_24": "{size.max}",
        "i_25": "{primaryGrey80}",
        "i_26": "{primary50}",
        "i_27": "{primary60}",
        "i_28": "{primary60}",
        "i_29": "{opacity.disabled}",
        "i_30": "{opacity.enabled}",
        "i_31": "{feedbackSuccess50}",
        "i_32": "{feedbackSuccess50}",
        "i_33": "{feedbackSuccess50}",
        "i_34": "{feedbackSuccess50}",
        "i_35": "{feedbackError50}",
        "i_36": "{feedbackError50}",
        "i_37": "{feedbackError50}",
        "i_38": "{feedbackError50}",
        "i_39": "{feedbackWarning50}",
        "i_40": "{feedbackWarning50}",
        "i_41": "{feedbackWarning50}",
        "i_42": "{feedbackWarning50}",
        "i_43": "{alignItems.start}",
        "i_44": "{alignItems.start}",
        "i_45": "{alignItems.end}",
        "i_46": "{l}",
        "i_47": "{alignItems.end}",
        "i_48": "{primary60}"
    },
    "JDSInputFieldV2": {
        "i_0": "{s}",
        "i_1": "{flexDirection.column}",
        "i_2": "{size.max}",
        "i_3": "{justifyContent.start}",
        "i_4": "{alignItems.start}",
        "i_5": "{opacity.enabled}",
        "i_6": "{flexDirection.row}",
        "i_7": "{justifyContent.start}",
        "i_8": "{alignItems.center}",
        "i_9": "{xxs}",
        "i_10": "{xs}",
        "i_11": "{xs}",
        "i_12": "{xxs}",
        "i_13": "{flexDirection.row}",
        "i_14": "{justifyContent.start}",
        "i_15": "{alignItems.center}",
        "i_16": "{size.max}",
        "i_17": "{xl}",
        "i_18": "{xs}",
        "i_19": "{xs}",
        "i_20": "{xs}",
        "i_21": "{xs}",
        "i_22": "{xs}",
        "i_23": "{border_thin}",
        "i_24": "{primaryGrey60}",
        "i_25": "{primaryGrey40}",
        "i_26": "{medium}",
        "i_27": "{primary50}",
        "i_28": "{primary60}",
        "i_29": "{primary60}",
        "i_30": "{textAlign.start}",
        "i_31": 1,
        "i_32": "{flexDirection.column}",
        "i_33": "{justifyContent.start}",
        "i_34": "{alignItems.start}",
        "i_35": "{xxs}",
        "i_36": "{xxs}",
        "i_37": "{xs}",
        "i_38": "{xs}",
        "i_39": "{xxs}",
        "i_40": "{flexDirection.row}",
        "i_41": "{justifyContent.start}",
        "i_42": "{alignItems.center}",
        "i_43": "{xs}",
        "i_44": "{xs}",
        "i_45": "{opacity.disabled}",
        "i_46": "{feedbackSuccess50}",
        "i_47": "{feedbackSuccess50}",
        "i_48": "{feedbackSuccess50}",
        "i_49": "{feedbackSuccess50}",
        "i_50": "{feedbackError50}",
        "i_51": "{feedbackError50}",
        "i_52": "{feedbackError50}",
        "i_53": "{feedbackError50}",
        "i_54": "{feedbackWarning50}",
        "i_55": "{feedbackWarning50}",
        "i_56": "{feedbackWarning50}",
        "i_57": "{feedbackWarning50}",
        "i_58": "{l}",
        "i_59": "{xxs}",
        "i_60": "{xxs}",
        "i_61": "{xxl}",
        "i_62": "{s}",
        "i_63": "{s}",
        "i_64": "{s}",
        "i_65": "{xs}",
        "i_66": "{xs}"
    },
    "JDSModalDesktop": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{opacity.invisible}",
        "m_2": "{opacity.enabled}",
        "m_3": "{justifyContent.center}",
        "m_4": "{alignItems.center}",
        "m_5": "{size.max}",
        "m_6": "{size.max}",
        "m_7": "{global.black}",
        "m_8": "{custom_2}",
        "m_9": "{flexDirection.column}",
        "m_10": "{justifyContent.start}",
        "m_11": "{alignItems.start}",
        "m_12": "{xxl}",
        "m_13": "{primaryBackground}",
        "m_14": "{size.max}",
        "m_15": "{flexDirection.row}",
        "m_16": "{justifyContent.end}",
        "m_17": "{alignItems.center}",
        "m_18": "{size.max}",
        "m_19": "{s}",
        "m_20": "{s}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": "{flexDirection.column}",
        "m_24": "{justifyContent.start}",
        "m_25": "{alignItems.start}",
        "m_26": "{l}",
        "m_27": "{l}",
        "m_28": "{l}",
        "m_29": "{size.max}",
        "m_30": "auto",
        "m_31": "auto",
        "m_32": "{flexDirection.row}",
        "m_33": "{justifyContent.start}",
        "m_34": "{alignItems.center}",
        "m_35": "{size.max}",
        "m_36": "{base}",
        "m_37": "{size.max}",
        "m_38": "auto",
        "m_39": "{size.max}",
        "m_40": "{justifyContent.end}",
        "m_41": "{alignItems.start}",
        "m_42": "{flexDirection.row}",
        "m_43": "{s}",
        "m_44": "{base}",
        "m_45": "{flexDirection.column}",
        "m_46": "{justifyContent.start}",
        "m_47": "{alignItems.start}",
        "m_48": "{xxl}",
        "m_49": "{primaryBackground}",
        "m_50": "{l}",
        "m_51": "{l}",
        "m_52": "{l}",
        "m_53": "{l}",
        "m_54": "{size.max}",
        "m_55": "{size.max}",
        "m_56": "{justifyContent.end}",
        "m_57": "{justifyContent.center}",
        "m_58": "{m}",
        "m_59": "{m}",
        "m_60": "{m}",
        "m_61": "{l}",
        "m_62": "{l}"
    },
    "JDSModalDesktopInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{opacity.invisible}",
        "m_5": "{medium}",
        "m_6": "{easeEntrance}",
        "m_7": "{size.max}",
        "m_8": "{global.black}",
        "m_9": "{custom_2}",
        "m_10": "{flexDirection.column}",
        "m_11": "{justifyContent.start}",
        "m_12": "{alignItems.start}",
        "m_13": "{xxl}",
        "m_14": "{elevation1}",
        "m_15": "{custom_27}",
        "m_16": "{size.max}",
        "m_17": "{flexDirection.row}",
        "m_18": "{justifyContent.end}",
        "m_19": "{alignItems.center}",
        "m_20": "{size.max}",
        "m_21": "{s}",
        "m_22": "{s}",
        "m_23": "{s}",
        "m_24": "{s}",
        "m_25": "{flexDirection.column}",
        "m_26": "{justifyContent.start}",
        "m_27": "{alignItems.start}",
        "m_28": "{l}",
        "m_29": "{l}",
        "m_30": "{l}",
        "m_31": "{size.max}",
        "m_32": "auto",
        "m_33": "auto",
        "m_34": "{flexDirection.row}",
        "m_35": "{justifyContent.start}",
        "m_36": "{alignItems.center}",
        "m_37": "{size.max}",
        "m_38": "{base}",
        "m_39": "{size.max}",
        "m_40": "auto",
        "m_41": "{size.max}",
        "m_42": "{justifyContent.end}",
        "m_43": "{alignItems.start}",
        "m_44": "{flexDirection.row}",
        "m_45": "{s}",
        "m_46": "{base}",
        "m_47": "{flexDirection.column}",
        "m_48": "{justifyContent.start}",
        "m_49": "{alignItems.start}",
        "m_50": "{xxl}",
        "m_51": "{primaryBackground}",
        "m_52": "{l}",
        "m_53": "{l}",
        "m_54": "{l}",
        "m_55": "{l}",
        "m_56": "80%",
        "m_57": "80%",
        "m_58": "{justifyContent.end}",
        "m_59": "{justifyContent.center}",
        "m_60": "{m}",
        "m_61": "{m}",
        "m_62": "{m}",
        "m_63": "{l}",
        "m_64": "{l}",
        "m_65": "{opacity.enabled}",
        "m_66": "{easeExit}",
        "m_67": "{custom_27}",
        "m_68": "{modal_desktop_comibation_medium_width}",
        "m_69": "{modal_desktop_combination_small_width}",
        "m_70": "{modal_desktop_combination_small_width}"
    },
    "JDSMenuBlockItem": {
        "m_0": "{opacity.enabled}",
        "m_1": "{global.transparent}",
        "m_2": "{size.max}",
        "m_3": "{global.transparent}",
        "m_4": "{size.max}",
        "m_5": "{xs}",
        "m_6": "{base}",
        "m_7": "{xs}",
        "m_8": "{base}",
        "m_9": "{flexDirection.row}",
        "m_10": "{alignItems.center}",
        "m_11": "{justifyContent.spaceBetween}",
        "m_12": "{global.transparent}",
        "m_13": "{primaryGrey20}",
        "m_14": "{primary60}",
        "m_15": "{small}",
        "m_16": "{size.max}",
        "m_17": "{xs}",
        "m_18": "{base}",
        "m_19": "{xs}",
        "m_20": "{base}",
        "m_21": "{size.max}",
        "m_22": "{alignItems.center}",
        "m_23": "{justifyContent.start}",
        "m_24": "{xs}",
        "m_25": "{flexDirection.row}",
        "m_26": "{alignItems.center}",
        "m_27": "{primaryGrey20}",
        "m_28": "{opacity.disabled}",
        "m_29": "{xxl}"
    },
    "JDSModalMobile": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{opacity.invisible}",
        "m_5": "{medium}",
        "m_6": "{easeEntrance}",
        "m_7": "{opacity.enabled}",
        "m_8": "{easeExit}"
    },
    "JDSModalMobileInternal": {
        "m_0": "{flexDirection.stack}",
        "m_1": "{justifyContent.center}",
        "m_2": "{alignItems.center}",
        "m_3": "{size.max}",
        "m_4": "{size.max}",
        "m_5": "{global.black}",
        "m_6": "{custom_2}",
        "m_7": "{flexDirection.column}",
        "m_8": "{justifyContent.start}",
        "m_9": "{alignItems.start}",
        "m_10": "{xl}",
        "m_11": "{size.max}",
        "m_12": "{custom_31}",
        "m_13": "{elevation1}",
        "m_14": "{flexDirection.row}",
        "m_15": "{justifyContent.center}",
        "m_16": "{alignItems.center}",
        "m_17": "{xl}",
        "m_18": "{size.max}",
        "m_19": "{size.max}",
        "m_20": "{m}",
        "m_21": "{m}",
        "m_22": "{m}",
        "m_23": "{m}",
        "m_24": "{flexDirection.row}",
        "m_25": "{justifyContent.end}",
        "m_26": "{alignItems.center}",
        "m_27": "{size.max}",
        "m_28": "{s}",
        "m_29": "{s}",
        "m_30": "{s}",
        "m_31": "{s}",
        "m_32": "{flexDirection.column}",
        "m_33": "{justifyContent.start}",
        "m_34": "{alignItems.start}",
        "m_35": "{size.max}",
        "m_36": "{l}",
        "m_37": "{l}",
        "m_38": "{l}",
        "m_39": "auto",
        "m_40": "{flexDirection.row}",
        "m_41": "{justifyContent.start}",
        "m_42": "{alignItems.center}",
        "m_43": "{size.max}",
        "m_44": "{base}",
        "m_45": "{alignItems.start}",
        "m_46": "{size.max}",
        "m_47": "auto",
        "m_48": "{flexDirection.column}",
        "m_49": "{size.max}",
        "m_50": "{justifyContent.start}",
        "m_51": "{alignItems.start}",
        "m_52": "{flexDirection.column}",
        "m_53": "{s}",
        "m_54": "{base}",
        "m_55": "{flexDirection.column}",
        "m_56": "{justifyContent.start}",
        "m_57": "{alignItems.start}",
        "m_58": "{xl}",
        "m_59": "{elevation1}",
        "m_60": "{l}",
        "m_61": "{l}",
        "m_62": "{l}",
        "m_63": "{l}",
        "m_64": "{size.max}",
        "m_65": "{justifyContent.end}",
        "m_66": "{justifyContent.center}",
        "m_67": "{m}",
        "m_68": "{m}",
        "m_69": "{m}",
        "m_70": "{l}",
        "m_71": "{l}",
        "m_72": "{opacity.enabled}",
        "m_73": "{easeExit}"
    },
    "JDSHeaderDesktop": {
        "h_0": "{size.max}",
        "h_1": "{flexDirection.column}",
        "h_2": "{flexDirection.row}",
        "h_3": "{justifyContent.start}",
        "h_4": "{alignItems.center}",
        "h_5": "{xs}",
        "h_6": "{size.max}",
        "h_7": "{primary50}",
        "h_8": "{flexDirection.row}",
        "h_9": "{justifyContent.spaceBetween}",
        "h_10": "{alignItems.center}",
        "h_11": "{xxl}",
        "h_12": "{s}",
        "h_13": "{xxl}",
        "h_14": "{s}",
        "h_15": "{base}",
        "h_16": "{custom_16}",
        "h_17": "{flexDirection.row}",
        "h_18": "{justifyContent.start}",
        "h_19": "{alignItems.center}",
        "h_20": "{base}",
        "h_21": "{flexDirection.row}",
        "h_22": "{justifyContent.center}",
        "h_23": "{alignItems.center}",
        "h_24": "{xs}",
        "h_25": "{flexDirection.row}",
        "h_26": "{justifyContent.center}",
        "h_27": "{alignItems.center}",
        "h_28": "{xs}",
        "h_29": "{flexDirection.row}",
        "h_30": "{justifyContent.start}",
        "h_31": "{alignItems.center}",
        "h_32": "{l}",
        "h_33": "{huge}",
        "h_34": "{flexDirection.row}",
        "h_35": "{justifyContent.end}",
        "h_36": "{alignItems.center}",
        "h_37": "{s}",
        "h_38": "{flexDirection.row}",
        "h_39": "{justifyContent.end}",
        "h_40": "{alignItems.center}",
        "h_41": "{s}",
        "h_42": "{size.max}",
        "h_43": "{flexDirection.row}",
        "h_44": "{justifyContent.center}",
        "h_45": "{alignItems.center}",
        "h_46": "{s}",
        "h_47": "{size.max}",
        "h_48": "{huge}",
        "h_49": "{s}",
        "h_50": "{s}",
        "h_51": "{s}",
        "h_52": "{xs}",
        "h_53": "{xs}",
        "h_54": "{xs}",
        "h_55": "{size.max}",
        "h_56": "{justifyContent.spaceBetween}",
        "h_57": "{size.max}",
        "h_58": "{intrinsicSize.max}",
        "h_59": "{justifyContent.spaceBetween}"
    },
    "JDSBottomNavigation": {
        "b_0": "{size.max}",
        "b_1": "{flexDirection.row}",
        "b_2": "{justifyContent.center}",
        "b_3": "{alignItems.center}",
        "b_4": "{primaryBackground}",
        "b_5": "{m}",
        "b_6": "{base}",
        "b_7": "{m}",
        "b_8": "{base}",
        "b_9": "{m}",
        "b_10": 0,
        "b_11": -1,
        "b_12": 0,
        "b_13": 0,
        "b_14": 1,
        "b_15": "{primaryGrey40}"
    },
    "JDSBottomNavigationItem": {
        "b_0": "{size.max}",
        "b_1": "{flexDirection.column}",
        "b_2": "{justifyContent.center}",
        "b_3": "{alignItems.center}",
        "b_4": "{xxs}",
        "b_5": "{opacity.disabled}",
        "b_6": "{opacity.enabled}"
    },
    "JDSMegaMenu": {
        "m_0": "{flexDirection.row}",
        "m_1": "{size.max}",
        "m_2": "{flexDirection.row}",
        "m_3": "{justifyContent.start}",
        "m_4": "{alignItems.start}",
        "m_5": "{primaryBackground}",
        "m_6": "{m}",
        "m_7": "{m}",
        "m_8": "{xxl}",
        "m_9": "{xxl}",
        "m_10": "{base}"
    },
    "JDSMegaMenuInternal": {
        "m_0": "{flexDirection.row}",
        "m_1": "{size.max}",
        "m_2": "{flexDirection.row}",
        "m_3": "{justifyContent.start}",
        "m_4": "{alignItems.start}",
        "m_5": "{primaryBackground}",
        "m_6": "{m}",
        "m_7": "{m}",
        "m_8": "{xxl}",
        "m_9": "{xxl}",
        "m_10": "{base}"
    },
    "JDSHeaderMobile": {
        "h_0": "{size.max}",
        "h_1": "{flexDirection.column}",
        "h_2": "{size.max}",
        "h_3": "{size.max}",
        "h_4": "{primary50}",
        "h_5": "{flexDirection.row}",
        "h_6": "{justifyContent.spaceBetween}",
        "h_7": "{alignItems.center}",
        "h_8": "{s}",
        "h_9": "{xs}",
        "h_10": "{s}",
        "h_11": "{xs}",
        "h_12": "{base}",
        "h_13": "{huge}",
        "h_14": "{flexDirection.row}",
        "h_15": "{justifyContent.start}",
        "h_16": "{alignItems.center}",
        "h_17": "{base}",
        "h_18": "{flexDirection.row}",
        "h_19": "{justifyContent.start}",
        "h_20": "{alignItems.center}",
        "h_21": "{xs}",
        "h_22": "{flexDirection.row}",
        "h_23": "{justifyContent.center}",
        "h_24": "{alignItems.center}",
        "h_25": "{xs}",
        "h_26": "{flexDirection.row}",
        "h_27": "{justifyContent.start}",
        "h_28": "{alignItems.center}",
        "h_29": "{l}",
        "h_30": "{huge}",
        "h_31": "{flexDirection.row}",
        "h_32": "{justifyContent.end}",
        "h_33": "{alignItems.center}",
        "h_34": "{s}",
        "h_35": "{flexDirection.row}",
        "h_36": "{justifyContent.end}",
        "h_37": "{alignItems.center}",
        "h_38": "{s}",
        "h_39": "{flexDirection.row}",
        "h_40": "{justifyContent.center}",
        "h_41": "{alignItems.center}",
        "h_42": "{s}",
        "h_43": "{s}",
        "h_44": "{s}",
        "h_45": "{xxs}",
        "h_46": "{xs}",
        "h_47": "{xs}",
        "h_48": "{xs}",
        "h_49": "{intrinsicSize.max}",
        "h_50": "{m}"
    },
    "JDSMegaMenuItem": {
        "m_0": "{flexDirection.row}",
        "m_1": "{justifyContent.start}",
        "m_2": "{alignItems.start}",
        "m_3": "{xs}",
        "m_4": "{xs}"
    },
    "JDSTextarea": {
        "t_0": "{flexDirection.column}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{xxs}",
        "t_4": "{size.max}",
        "t_5": "{flexDirection.stack}",
        "t_6": "{size.max}",
        "t_7": "{xxs}",
        "t_8": "{justifyContent.start}",
        "t_9": "{alignItems.end}",
        "t_10": "{flexDirection.row}",
        "t_11": "{justifyContent.start}",
        "t_12": "{size.max}",
        "t_13": "{alignItems.center}",
        "t_14": "{textAlign.start}",
        "t_15": "{primaryGrey60}",
        "t_16": "{bodyS}",
        "t_17": "{bodyS}",
        "t_18": "{bodyS}",
        "t_19": "{bodyS}",
        "t_20": "{bodyS}",
        "t_21": "{primaryGrey100}",
        "t_22": "{bodyS}",
        "t_23": "{bodyS}",
        "t_24": "{bodyS}",
        "t_25": "{bodyS}",
        "t_26": "{bodyS}",
        "t_27": "{primaryGrey100}",
        "t_28": "{primaryGrey100}",
        "t_29": "{size.max}",
        "t_30": "{primary50}",
        "t_31": "{primary60}",
        "t_32": "{primary60}",
        "t_33": "{flexDirection.column}",
        "t_34": "{size.max}",
        "t_35": "{alignItems.center}",
        "t_36": "{size.max}",
        "t_37": "{primaryGrey100}",
        "t_38": "{primary50}",
        "t_39": "{primary60}",
        "t_40": "{primary60}",
        "t_41": "{opacity.disabled}",
        "t_42": "{opacity.enabled}",
        "t_43": "{border_thin}",
        "t_44": "{primaryGrey60}",
        "t_45": "{custom_17}",
        "t_46": "{medium}",
        "t_47": "{custom_17}",
        "t_48": "{base}",
        "t_49": "{s}",
        "t_50": "{feedbackSuccess50}",
        "t_51": "{feedbackSuccess50}",
        "t_52": "{feedbackSuccess50}",
        "t_53": "{feedbackSuccess50}",
        "t_54": "{feedbackSuccess50}",
        "t_55": "{feedbackSuccess50}",
        "t_56": "{feedbackSuccess50}",
        "t_57": "{feedbackSuccess50}",
        "t_58": "{feedbackError50}",
        "t_59": "{feedbackError50}",
        "t_60": "{feedbackError50}",
        "t_61": "{feedbackError50}",
        "t_62": "{feedbackError50}",
        "t_63": "{feedbackError50}",
        "t_64": "{feedbackError50}",
        "t_65": "{feedbackError50}",
        "t_66": "{feedbackWarning50}",
        "t_67": "{feedbackWarning50}",
        "t_68": "{feedbackWarning50}",
        "t_69": "{feedbackWarning50}",
        "t_70": "{feedbackWarning50}",
        "t_71": "{feedbackWarning50}",
        "t_72": "{feedbackWarning50}",
        "t_73": "{feedbackWarning50}",
        "t_74": "{alignItems.start}",
        "t_75": "{primary60}",
        "t_76": "{primary60}",
        "t_77": "{primaryGrey40}",
        "t_78": "{primaryGrey60}",
        "t_79": "{primaryGrey80}"
    },
    "JDSSidePanelItem": {
        "s_0": "{xl}",
        "s_1": "{xs}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.spaceBetween}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.row}",
        "s_7": "{justifyContent.start}",
        "s_8": "{alignItems.center}",
        "s_9": "{base}",
        "s_10": "{s}",
        "s_11": "{s}"
    },
    "JDSMegaMenuBlock": {
        "m_0": "{flexDirection.column}",
        "m_1": "{justifyContent.start}",
        "m_2": "{alignItems.start}",
        "m_3": "{base}",
        "m_4": "{flexDirection.column}",
        "m_5": "{justifyContent.start}",
        "m_6": "{alignItems.start}",
        "m_7": "{xs}"
    },
    "JDSNotificationButton": {
        "n_0": "{xxs}",
        "n_1": "{base}",
        "n_2": "{xxs}",
        "n_3": "{base}",
        "n_4": "{global.transparent}",
        "n_5": "{primaryGrey60}",
        "n_6": "{primary20}",
        "n_7": "{primary30}",
        "n_8": "{primary50}",
        "n_9": "{opacity.disabled}",
        "n_10": "{primary30}",
        "n_11": "{primary40}",
        "n_12": "{primary30}",
        "n_13": "{primary20}",
        "n_14": "{base}",
        "n_15": "{xs}",
        "n_16": "{xs}",
        "n_17": "{xs}",
        "n_18": "{xs}"
    },
    "JDSNotificationBanner": {
        "n_0": "{custom_11}",
        "n_1": "{size.max}",
        "n_2": "{flexDirection.column}",
        "n_3": "{justifyContent.center}",
        "n_4": "{alignItems.center}",
        "n_5": "{base}",
        "n_6": "{base}",
        "n_7": "{base}",
        "n_8": "{base}",
        "n_9": "{base}",
        "n_10": "{large}",
        "n_11": "{primaryGrey20}",
        "n_12": "{flexDirection.row}",
        "n_13": "{justifyContent.start}",
        "n_14": "{alignItems.start}",
        "n_15": "{size.max}",
        "n_16": "{s}",
        "n_17": "{justifyContent.start}",
        "n_18": "{alignItems.start}",
        "n_19": "{flexDirection.column}",
        "n_20": "{xxs}",
        "n_21": "{flexDirection.row}",
        "n_22": "{xs}",
        "n_23": "{size.max}",
        "n_24": "{flexDirection.row}",
        "n_25": "{justifyContent.end}",
        "n_26": "{alignItems.center}",
        "n_27": "{alignItems.center}",
        "n_28": "{custom_3}",
        "n_29": "{custom_3}",
        "n_30": "{m}",
        "n_31": "{m}",
        "n_32": "{l}",
        "n_33": "{l}"
    },
    "JDSNudgeContainer": {
        "n_0": "{flexDirection.stack}",
        "n_1": "{size.max}",
        "n_2": "{base}",
        "n_3": "{base}",
        "n_4": "{base}",
        "n_5": "{base}",
        "n_6": "{flexDirection.column}",
        "n_7": "{justifyContent.start}",
        "n_8": "{alignItems.end}",
        "n_9": "{size.max}",
        "n_10": "{xs}"
    },
    "JDSToastContainer": {
        "t_0": "{flexDirection.stack}",
        "t_1": "{size.max}",
        "t_2": "{base}",
        "t_3": "{base}",
        "t_4": "{base}",
        "t_5": "{base}",
        "t_6": "{flexDirection.column}",
        "t_7": "{justifyContent.end}",
        "t_8": "{alignItems.start}",
        "t_9": "{size.max}",
        "t_10": "{xs}"
    },
    "JDSToast": {
        "t_0": "{size.max}",
        "t_1": "{size.max}",
        "t_2": "{xl}",
        "t_3": "{primaryGrey80}",
        "t_4": "{flexDirection.column}",
        "t_5": "{base}",
        "t_6": "{base}",
        "t_7": "{base}",
        "t_8": "{base}",
        "t_9": "{base}",
        "t_10": "{s}",
        "t_11": "{size.max}",
        "t_12": "{flexDirection.row}",
        "t_13": "{justifyContent.start}",
        "t_14": "{alignItems.center}",
        "t_15": "{flexDirection.column}",
        "t_16": "{justifyContent.start}",
        "t_17": "{alignItems.start}",
        "t_18": "{xxs}",
        "t_19": "{size.max}",
        "t_20": "{s}",
        "t_21": "{flexDirection.row}",
        "t_22": "{justifyContent.end}",
        "t_23": "{custom_13}",
        "t_24": "{custom_14}"
    },
    "JDSNudge": {
        "n_0": "{size.max}",
        "n_1": "{size.max}",
        "n_2": "{xl}",
        "n_3": "{primaryGrey80}",
        "n_4": "{flexDirection.column}",
        "n_5": "{base}",
        "n_6": "{base}",
        "n_7": "{base}",
        "n_8": "{base}",
        "n_9": "{base}",
        "n_10": "{s}",
        "n_11": "{size.max}",
        "n_12": "{flexDirection.row}",
        "n_13": "{justifyContent.start}",
        "n_14": "{alignItems.center}",
        "n_15": "{flexDirection.column}",
        "n_16": "{justifyContent.start}",
        "n_17": "{alignItems.start}",
        "n_18": "{s}",
        "n_19": "{size.max}",
        "n_20": "{s}",
        "n_21": "{flexDirection.row}",
        "n_22": "{justifyContent.end}",
        "n_23": "{custom_13}",
        "n_24": "{custom_14}"
    },
    "JDSPagination": {
        "p_0": "{global.transparent}",
        "p_1": "{flexDirection.row}",
        "p_2": "{alignItems.center}",
        "p_3": "{alignItems.center}",
        "p_4": "{custom_25}",
        "p_5": "{custom_25}",
        "p_6": "{size.max}",
        "p_7": "{xxl}",
        "p_8": "{flexDirection.row}",
        "p_9": "{flexDirection.row}",
        "p_10": "{xxs}",
        "p_11": "{base}",
        "p_12": "{base}"
    },
    "JDSPromoCard": {
        "p_0": "{global.white}",
        "p_1": "{flexDirection.column}",
        "p_2": "{size.max}",
        "p_3": "{justifyContent.start}",
        "p_4": "{alignItems.start}",
        "p_5": "{xl}",
        "p_6": "{flexDirection.column}",
        "p_7": "{alignItems.start}",
        "p_8": "{justifyContent.start}",
        "p_9": "{size.max}",
        "p_10": "{xl}",
        "p_11": "{primaryBackground}",
        "p_12": "{flexDirection.row}",
        "p_13": "{alignItems.stretch}",
        "p_14": "{justifyContent.start}",
        "p_15": "{size.max}",
        "p_16": "{xl}",
        "p_17": "{intrinsicSize.max}",
        "p_18": "{primaryBackground}",
        "p_19": "{flexDirection.row}",
        "p_20": "{alignItems.start}",
        "p_21": "{justifyContent.start}",
        "p_22": "{size.max}",
        "p_23": "{primaryBackground}",
        "p_24": "{xl}",
        "p_25": "{xl}",
        "p_26": "{m}",
        "p_27": "{m}",
        "p_28": "{m}",
        "p_29": "{flexDirection.row}",
        "p_30": "{alignItems.start}",
        "p_31": "{justifyContent.start}",
        "p_32": "{size.max}",
        "p_33": "{primaryBackground}",
        "p_34": "{m}",
        "p_35": "{m}",
        "p_36": "{m}",
        "p_37": "{m}",
        "p_38": "{size.max}",
        "p_39": "{flexDirection.stack}",
        "p_40": "{alignItems.end}",
        "p_41": "{size.max}",
        "p_42": "{flexDirection.stack}",
        "p_43": "{alignItems.center}",
        "p_44": "{justifyContent.start}",
        "p_45": "{size.max}",
        "p_46": "{primaryBackground}",
        "p_47": "{size.max}",
        "p_48": "{xl}",
        "p_49": "{primaryBackground}",
        "p_50": "{size.max}",
        "p_51": "{xl}",
        "p_52": "{primaryBackground}",
        "p_53": "{size.max}",
        "p_54": "{justifyContent.spaceBetween}",
        "p_55": "{alignItems.center}",
        "p_56": "{flexDirection.row}",
        "p_57": "{base}",
        "p_58": "{m}",
        "p_59": "{m}",
        "p_60": "{base}",
        "p_61": "{base}",
        "p_62": "{l}",
        "p_63": "{l}",
        "p_64": "{l}",
        "p_65": "{l}",
        "p_66": "{l}",
        "p_67": "{l}",
        "p_68": "{l}",
        "p_69": "{l}"
    },
    "JDSSidePanel": {
        "s_0": "{size.max}",
        "s_1": "{size.max}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.start}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.column}",
        "s_7": "{primaryBackground}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{flexDirection.column}",
        "s_11": "{justifyContent.start}",
        "s_12": "{alignItems.center}",
        "s_13": "{m}",
        "s_14": "{m}",
        "s_15": "{m}",
        "s_16": "{primary50}",
        "s_17": "{s}",
        "s_18": "{s}",
        "s_19": "{m}",
        "s_20": "{m}",
        "s_21": "{size.max}",
        "s_22": "{justifyContent.spaceBetween}",
        "s_23": "{alignItems.center}",
        "s_24": "{flexDirection.row}",
        "s_25": "{s}",
        "s_26": "{alignItems.center}",
        "s_27": "{justifyContent.end}",
        "s_28": "{size.max}",
        "s_29": "{size.max}",
        "s_30": 376
    },
    "JDSSidePanelInternal": {
        "s_0": "{size.max}",
        "s_1": "{size.max}",
        "s_2": "{flexDirection.row}",
        "s_3": "{justifyContent.start}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{flexDirection.column}",
        "s_7": "{primaryBackground}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{flexDirection.column}",
        "s_11": "{justifyContent.start}",
        "s_12": "{alignItems.center}",
        "s_13": "{m}",
        "s_14": "{m}",
        "s_15": "{m}",
        "s_16": "{primary50}",
        "s_17": "{s}",
        "s_18": "{s}",
        "s_19": "{m}",
        "s_20": "{m}",
        "s_21": "{size.max}",
        "s_22": "{justifyContent.spaceBetween}",
        "s_23": "{alignItems.center}",
        "s_24": "{flexDirection.row}",
        "s_25": "{s}",
        "s_26": "{alignItems.center}",
        "s_27": "{justifyContent.end}",
        "s_28": "{size.max}",
        "s_29": "{size.max}",
        "s_30": 376
    },
    "JDSProgressBar": {
        "p_0": "{flexDirection.column}",
        "p_1": "{justifyContent.center}",
        "p_2": "{alignItems.start}",
        "p_3": "{base}",
        "p_4": "{size.max}",
        "p_5": "{global.transparent}",
        "p_6": "{global.transparent}",
        "p_7": "{flexDirection.row}",
        "p_8": "{justifyContent.spaceBetween}",
        "p_9": "{alignItems.center}",
        "p_10": "{size.max}",
        "p_11": "{m}",
        "p_12": "{primaryGrey40}",
        "p_13": "{xs}",
        "p_14": "{size.max}",
        "p_15": "{flexDirection.row}",
        "p_16": "{justifyContent.start}",
        "p_17": "{alignItems.start}",
        "p_18": "{pill}",
        "p_19": "{primary50}",
        "p_20": "{xs}",
        "p_21": "{pill}",
        "p_22": "{xs}",
        "p_23": "{flexDirection.stack}",
        "p_24": "{primaryGrey40}",
        "p_25": "{xs}",
        "p_26": "{size.max}",
        "p_27": "{pill}",
        "p_28": "{size.max}",
        "p_29": "{size.max}",
        "p_30": "{massive}",
        "p_31": "{primary50}",
        "p_32": "{pill}",
        "p_33": "{feedbackSuccess50}",
        "p_34": "{feedbackSuccess50}",
        "p_35": "{feedbackError50}",
        "p_36": "{feedbackError50}",
        "p_37": "{feedbackWarning50}",
        "p_38": "{feedbackWarning50}",
        "p_39": "{justifyContent.center}"
    },
    "JDSSearchBox": {
        "s_0": "{primaryGrey20}",
        "s_1": "{flexDirection.row}",
        "s_2": "{justifyContent.start}",
        "s_3": "{alignItems.center}",
        "s_4": "{s}",
        "s_5": "{s}",
        "s_6": "{size.max}",
        "s_7": "{xl}",
        "s_8": "{pill}",
        "s_9": "{s}",
        "s_10": "{opacity.enabled}",
        "s_11": "{primary60}",
        "s_12": "{border_focus}",
        "s_13": "{primaryGrey40}",
        "s_14": "{textAlign.start}",
        "s_15": "{primaryGrey100}",
        "s_16": "{bodyS}",
        "s_17": "{bodyS}",
        "s_18": "{bodyS}",
        "s_19": "{bodyS}",
        "s_20": "{bodyS}",
        "s_21": "{primaryGrey100}",
        "s_22": "{bodyS}",
        "s_23": "{bodyS}",
        "s_24": "{bodyS}",
        "s_25": "{bodyS}",
        "s_26": "{bodyS}",
        "s_27": "{primary60}",
        "s_28": "{primary60}",
        "s_29": "{primary60}",
        "s_30": "{primary60}",
        "s_31": "{flexDirection.row}",
        "s_32": "{justifyContent.center}",
        "s_33": "{alignItems.center}",
        "s_34": "{m}",
        "s_35": "{primaryGrey100}",
        "s_36": "{primary60}",
        "s_37": "{primary60}",
        "s_38": "{primaryGrey80}",
        "s_39": "{flexDirection.row}",
        "s_40": "{justifyContent.center}",
        "s_41": "{alignItems.center}",
        "s_42": "{m}",
        "s_43": "{primary60}",
        "s_44": "{primary60}",
        "s_45": "{primary60}",
        "s_46": "{primaryGrey100}",
        "s_47": "{primary60}",
        "s_48": "{primary80}",
        "s_49": "{primary70}",
        "s_50": "{primaryBackground}",
        "s_51": "{primary30}",
        "s_52": "{primary30}",
        "s_53": "{primaryBackground}",
        "s_54": "{primary30}",
        "s_55": "{primary30}",
        "s_56": "{primaryBackground}",
        "s_57": "{primary40}",
        "s_58": "{primary30}",
        "s_59": "{primary30}",
        "s_60": "{primaryBackground}",
        "s_61": "{primaryGrey60}",
        "s_62": "{primary50}",
        "s_63": "{primary80}",
        "s_64": "{primary60}",
        "s_65": "{border_thin}",
        "s_66": "{border_focus}",
        "s_67": "{primaryGrey100}",
        "s_68": "{primary60}",
        "s_69": "{primaryGrey100}",
        "s_70": "{primaryGrey100}",
        "s_71": "{primary60}",
        "s_72": "{primary60}",
        "s_73": "{primaryGrey100}",
        "s_74": "{primary60}",
        "s_75": "{primary60}",
        "s_76": "{opacity.disabled}",
        "s_77": "{primaryGrey80}",
        "s_78": "{primary30}",
        "s_79": "{primaryGrey60}",
        "s_80": "{primaryGrey80}",
        "s_81": "{primary60}"
    },
    "JDSPaginationButton": {
        "p_0": "{xxl}",
        "p_1": "{justifyContent.center}",
        "p_2": "{alignItems.center}",
        "p_3": "{global.transparent}",
        "p_4": "{flexDirection.row}",
        "p_5": "{justifyContent.center}",
        "p_6": "{alignItems.center}",
        "p_7": "{pill}",
        "p_8": "{l}",
        "p_9": "{l}",
        "p_10": "{opacity.enabled}",
        "p_11": "{xs}",
        "p_12": "{primary80}",
        "p_13": "{primary20}",
        "p_14": "{primary30}",
        "p_15": "{border_focus}",
        "p_16": "{primary70}",
        "p_17": "{global.transparent}"
    },
    "JDSSearchResultItem": {
        "s_0": "{flexDirection.row}",
        "s_1": "{base}",
        "s_2": "{xs}",
        "s_3": "{xs}",
        "s_4": "{alignItems.center}",
        "s_5": "{size.max}",
        "s_6": "{primaryGrey20}",
        "s_7": "{primaryGrey20}",
        "s_8": "{primaryGrey20}",
        "s_9": "{l}",
        "s_10": "{primaryGrey80}",
        "s_11": "{flexDirection.row}",
        "s_12": "{justifyContent.start}",
        "s_13": "{alignItems.center}"
    },
    "JDSSearchResultText": {},
    "JDSRadioButton": {
        "r_0": "{flexDirection.column}",
        "r_1": "{justifyContent.start}",
        "r_2": "{alignItems.start}",
        "r_3": "{xs}",
        "r_4": "{flexDirection.row}",
        "r_5": "{justifyContent.start}",
        "r_6": "{alignItems.center}",
        "r_7": "{xs}",
        "r_8": "{m}",
        "r_9": "{m}",
        "r_10": "{flexDirection.row}",
        "r_11": "{justifyContent.center}",
        "r_12": "{alignItems.center}",
        "r_13": "{global.transparent}",
        "r_14": "{pill}",
        "r_15": "{primaryGrey80}",
        "r_16": "{border_thin}",
        "r_17": "{border_none}",
        "r_18": "{primary40}",
        "r_19": "{primary60}",
        "r_20": "{primary60}",
        "r_21": "{s}",
        "r_22": "{s}",
        "r_23": "{pill}",
        "r_24": "{textAlign.start}",
        "r_25": "{base}",
        "r_26": "{base}",
        "r_27": "{xxs}",
        "r_28": "{xs}",
        "r_29": "{xs}",
        "r_30": "{primary50}",
        "r_31": "{primary40}",
        "r_32": "{primary60}",
        "r_33": "{primary50}",
        "r_34": "{primaryInverse}",
        "r_35": "{opacity.disabled}",
        "r_36": "{opacity.enabled}",
        "r_37": "{global.white}",
        "r_38": "{global.white}",
        "r_39": "{global.white}"
    },
    "JDSSelector": {
        "s_0": "{flexDirection.stack}",
        "s_1": "{opacity.enabled}",
        "s_2": "{alignItems.center}",
        "s_3": "{justifyContent.center}",
        "s_4": "{pill}",
        "s_5": "{xxs}",
        "s_6": "{xxs}",
        "s_7": "{xxs}",
        "s_8": "{xxs}",
        "s_9": "{xxs}",
        "s_10": "{xxs}",
        "s_11": "{xxs}",
        "s_12": "{xxs}",
        "s_13": "{primaryGrey20}",
        "s_14": "{pill}",
        "s_15": "{xxs}",
        "s_16": "{flexDirection.row}",
        "s_17": "{size.max}",
        "s_18": "{intrinsicSize.max}",
        "s_19": "{justifyContent.start}",
        "s_20": "{alignItems.center}",
        "s_21": "{primary50}",
        "s_22": "{pill}",
        "s_23": "{size.max}",
        "s_24": "{size.max}",
        "s_25": "{primary50}"
    },
    "JDSSelectorItem": {
        "s_0": "{opacity.enabled}",
        "s_1": "{global.transparent}",
        "s_2": "{flexDirection.row}",
        "s_3": "{alignItems.center}",
        "s_4": "{justifyContent.center}",
        "s_5": "{pill}",
        "s_6": "{xs}",
        "s_7": "{xs}",
        "s_8": "{base}",
        "s_9": "{xs}",
        "s_10": "{base}",
        "s_11": "{primary20}",
        "s_12": "{xxs}",
        "s_13": "{primary60}",
        "s_14": "{primary20}",
        "s_15": "{primary30}",
        "s_16": "{m}",
        "s_17": "{primary60}",
        "s_18": "{primary50}",
        "s_19": "{primary60}",
        "s_20": "{primary60}",
        "s_21": "{primary50}",
        "s_22": "{primaryInverse}",
        "s_23": "{primary30}",
        "s_24": "{flexDirection.column}",
        "s_25": "{size.max}",
        "s_26": "{opacity.disabled}",
        "s_27": "{xxs}"
    },
    "JDSSearchResults": {
        "s_0": "{global.transparent}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{justifyContent.center}",
        "s_3": "{size.max}",
        "s_4": "{global.transparent}",
        "s_5": "{primaryBackground}",
        "s_6": "{flexDirection.column}",
        "s_7": "{alignItems.center}",
        "s_8": "{base}",
        "s_9": "{base}",
        "s_10": "{base}",
        "s_11": "{base}",
        "s_12": "{base}",
        "s_13": "{size.max}",
        "s_14": "{size.max}",
        "s_15": "{flexDirection.column}",
        "s_16": "{alignItems.center}",
        "s_17": "{flexDirection.row}",
        "s_18": "{justifyContent.spaceBetween}",
        "s_19": "{alignItems.start}",
        "s_20": "{size.max}",
        "s_21": "{flexDirection.column}",
        "s_22": "{alignItems.start}",
        "s_23": "{base}",
        "s_24": "{size.max}",
        "s_25": "{xl}"
    },
    "JDSSearchResultsInternal": {
        "s_0": "{global.transparent}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{justifyContent.center}",
        "s_3": "{size.max}",
        "s_4": "{global.transparent}",
        "s_5": "{primaryBackground}",
        "s_6": "{flexDirection.column}",
        "s_7": "{alignItems.center}",
        "s_8": "{base}",
        "s_9": "{base}",
        "s_10": "{base}",
        "s_11": "{base}",
        "s_12": "{base}",
        "s_13": "{size.max}",
        "s_14": "{size.max}",
        "s_15": "{flexDirection.column}",
        "s_16": "{alignItems.center}",
        "s_17": "{flexDirection.row}",
        "s_18": "{justifyContent.spaceBetween}",
        "s_19": "{alignItems.start}",
        "s_20": "{size.max}",
        "s_21": "{flexDirection.column}",
        "s_22": "{alignItems.start}",
        "s_23": "{base}",
        "s_24": "{size.max}",
        "s_25": "{xl}"
    },
    "JDSSkeleton": {
        "s_0": "{primaryGrey20}",
        "s_1": "{primaryGrey20}",
        "s_2": "{primaryGrey40}",
        "s_3": "{pill}",
        "s_4": "{xxl}",
        "s_5": "{pill}",
        "s_6": "{pill}",
        "s_7": "{base}",
        "s_8": "{xl}",
        "s_9": "{xxl}",
        "s_10": "{size.max}",
        "s_11": "{size.max}"
    },
    "JDSServiceCard": {
        "s_0": "{flexDirection.stack}",
        "s_1": "{flexDirection.stack}",
        "s_2": "{size.max}",
        "s_3": "{size.max}",
        "s_4": "{justifyContent.start}",
        "s_5": "{justifyContent.start}",
        "s_6": "{alignItems.start}",
        "s_7": "{xl}",
        "s_8": "{size.max}",
        "s_9": "{size.max}",
        "s_10": "{xl}",
        "s_11": "{aspect_ratio.16.9}",
        "s_12": "{flexDirection.column}",
        "s_13": "{size.max}",
        "s_14": "{justifyContent.start}",
        "s_15": "{alignItems.start}",
        "s_16": "{flexDirection.row}",
        "s_17": "{justifyContent.start}",
        "s_18": "{alignItems.start}",
        "s_19": "{size.max}",
        "s_20": "{size.max}",
        "s_21": "{base}",
        "s_22": "{base}",
        "s_23": "{custom_color_4}",
        "s_24": "{size.max}",
        "s_25": "{base}",
        "s_26": "{base}",
        "s_27": "{base}",
        "s_28": "{base}",
        "s_29": "{size.max}",
        "s_30": "{aspect_ratio.1.1}",
        "s_31": "{aspect_ratio.4.3}",
        "s_32": "{aspect_ratio.4.5}"
    },
    "JDSNotificationIconButton": {
        "n_0": "{l}",
        "n_1": "{l}",
        "n_2": "{justifyContent.center}",
        "n_3": "{alignItems.center}",
        "n_4": "{global.transparent}",
        "n_5": "{global.transparent}",
        "n_6": "{primary30}",
        "n_7": "{primary40}",
        "n_8": "{primary30}",
        "n_9": "{primary50}",
        "n_10": "{base}",
        "n_11": "{primary20}",
        "n_12": "{opacity.disabled}"
    },
    "JDSSpinner": {
        "s_0": "{global.transparent}",
        "s_1": "{base}",
        "s_2": "{justifyContent.center}",
        "s_3": "{alignItems.center}",
        "s_4": "{flexDirection.row}",
        "s_5": "{xxl}",
        "s_6": "{flexDirection.stack}",
        "s_7": "{justifyContent.center}",
        "s_8": "{alignItems.center}",
        "s_9": "{size.max}",
        "s_10": "{primaryGrey40}",
        "s_11": "{m}",
        "s_12": "{xs}",
        "s_13": 0,
        "s_14": 360,
        "s_15": "{primary50}",
        "s_16": "{m}",
        "s_17": "{xs}",
        "s_18": 0,
        "s_19": 120,
        "s_20": "1000",
        "s_21": "{primary50}",
        "s_22": "{m}",
        "s_23": "{xs}",
        "s_24": 0,
        "s_25": 360,
        "s_26": "300",
        "s_27": "1300",
        "s_28": "{secondary50}",
        "s_29": "{m}",
        "s_30": "{xs}",
        "s_31": 0,
        "s_32": 360,
        "s_33": "150",
        "s_34": "1300",
        "s_35": "{sparkle50}",
        "s_36": "{m}",
        "s_37": "{xs}",
        "s_38": 0,
        "s_39": 360,
        "s_40": "1300",
        "s_41": "{flexDirection.column}",
        "s_42": "{s}",
        "s_43": "{m}",
        "s_44": "{xxs}",
        "s_45": "{s}",
        "s_46": "{xxs}",
        "s_47": "{s}",
        "s_48": "{xxs}",
        "s_49": "{s}",
        "s_50": "{xxs}",
        "s_51": "{s}",
        "s_52": "{xxs}",
        "s_53": "{s}",
        "s_54": "{primaryGrey80}",
        "s_55": "{flexDirection.row}"
    },
    "JDSSelectorButton": {
        "s_0": "{primary50}",
        "s_1": "{flexDirection.row}",
        "s_2": "{justifyContent.center}",
        "s_3": "{alignItems.center}",
        "s_4": "{pill}",
        "s_5": "{xs}",
        "s_6": "{xs}",
        "s_7": "{base}",
        "s_8": "{base}",
        "s_9": "{border_none}",
        "s_10": "{xs}",
        "s_11": "{opacity.enabled}",
        "s_12": "{primary30}",
        "s_13": "{primary60}",
        "s_14": "{border_focus}",
        "s_15": "{primary60}",
        "s_16": "{m}",
        "s_17": "{primaryInverse}",
        "s_18": "{primary70}",
        "s_19": "{m}",
        "s_20": "{primaryInverse}",
        "s_21": "{primary70}",
        "s_22": "{opacity.disabled}",
        "s_23": "{primary60}",
        "s_24": "{primary50}",
        "s_25": "{primary70}",
        "s_26": "{primary70}",
        "s_27": "{global.transparent}",
        "s_28": "{border_thin}",
        "s_29": "{primaryGrey60}",
        "s_30": "{primary20}",
        "s_31": "{primary60}",
        "s_32": "{primary20}",
        "s_33": "{border_focus}",
        "s_34": "{primary60}",
        "s_35": "{primary60}",
        "s_36": "{primary60}",
        "s_37": "{primary20}",
        "s_38": "{border_thin}",
        "s_39": "{primaryGrey60}",
        "s_40": "{primary60}",
        "s_41": "{primary30}",
        "s_42": "{border_focus}",
        "s_43": "{primary60}",
        "s_44": "{primary60}",
        "s_45": "{primary70}",
        "s_46": "{primary60}",
        "s_47": "{primary70}",
        "s_48": "{primary20}",
        "s_49": "{primary20}",
        "s_50": "{primary60}",
        "s_51": "{border_thin}",
        "s_52": "{primary30}",
        "s_53": "{border_focus}",
        "s_54": "{primary60}",
        "s_55": "{primary60}",
        "s_56": "{primary70}",
        "s_57": "{primary60}",
        "s_58": "{primary60}",
        "s_59": "{primary70}",
        "s_60": "{primary60}",
        "s_61": "{global.transparent}",
        "s_62": "{border_thin}",
        "s_63": "{primary60}",
        "s_64": "{primary20}",
        "s_65": "{primary20}",
        "s_66": "{primary60}",
        "s_67": "{primary60}",
        "s_68": "{primary60}",
        "s_69": "{primary60}",
        "s_70": "{primary60}",
        "s_71": "{primary60}",
        "s_72": "{global.transparent}",
        "s_73": "{border_focus}",
        "s_74": "{primary60}",
        "s_75": "{global.transparent}",
        "s_76": "{global.transparent}",
        "s_77": "{primary70}",
        "s_78": "{primary60}",
        "s_79": "{primary80}",
        "s_80": "{primary70}",
        "s_81": "{primary60}",
        "s_82": "{primary80}",
        "s_83": "{global.transparent}",
        "s_84": "{global.transparent}",
        "s_85": "{global.transparent}",
        "s_86": "{primary60}",
        "s_87": "{primary50}",
        "s_88": "{primary70}",
        "s_89": "{primary60}",
        "s_90": "{primary50}",
        "s_91": "{primary70}",
        "s_92": "{primaryGrey80}",
        "s_93": "{primary30}",
        "s_94": "{primary50}",
        "s_95": "{border_focus}",
        "s_96": "{primary60}",
        "s_97": "{primaryBackground}",
        "s_98": "{primary70}",
        "s_99": "{primaryInverse}",
        "s_100": "{primaryBackground}",
        "s_101": "{primary70}",
        "s_102": "{primaryInverse}",
        "s_103": "{global.transparent}",
        "s_104": "{border_thin}",
        "s_105": "{primaryGrey60}",
        "s_106": "{primary20}",
        "s_107": "{primary60}",
        "s_108": "{primary20}",
        "s_109": "{border_focus}",
        "s_110": "{primary60}",
        "s_111": "{primaryGrey80}",
        "s_112": "{primaryGrey80}",
        "s_113": "{primary20}",
        "s_114": "{primaryGrey60}",
        "s_115": "{primary60}",
        "s_116": "{primary30}",
        "s_117": "{border_focus}",
        "s_118": "{primary60}",
        "s_119": "{primary60}",
        "s_120": "{primary70}",
        "s_121": "{primary60}",
        "s_122": "{primary70}",
        "s_123": "{primary20}",
        "s_124": "{primary60}",
        "s_125": "{border_thin}",
        "s_126": "{primary30}",
        "s_127": "{border_focus}",
        "s_128": "{primary60}",
        "s_129": "{primary60}",
        "s_130": "{primary70}",
        "s_131": "{primary60}",
        "s_132": "{primary70}",
        "s_133": "{global.transparent}",
        "s_134": "{primary60}",
        "s_135": "{border_thin}",
        "s_136": "{primary20}",
        "s_137": "{primary20}",
        "s_138": "{border_focus}",
        "s_139": "{primary60}",
        "s_140": "{primaryGrey80}",
        "s_141": "{primary60}",
        "s_142": "{primary60}",
        "s_143": "{primaryGrey80}",
        "s_144": "{primary60}",
        "s_145": "{primary60}",
        "s_146": "{global.transparent}",
        "s_147": "{global.transparent}",
        "s_148": "{border_focus}",
        "s_149": "{primary60}",
        "s_150": "{primary60}",
        "s_151": "{primary50}",
        "s_152": "{primary80}",
        "s_153": "{primary60}",
        "s_154": "{primary50}",
        "s_155": "{primary80}",
        "s_156": "{global.transparent}",
        "s_157": "{global.transparent}",
        "s_158": "{border_focus}",
        "s_159": "{primary60}",
        "s_160": "{primaryGrey80}",
        "s_161": "{primary50}",
        "s_162": "{primary60}",
        "s_163": "{primaryGrey80}",
        "s_164": "{primary50}",
        "s_165": "{primary60}",
        "s_166": "{primaryBackground}",
        "s_167": "{primary30}",
        "s_168": "{primary50}",
        "s_169": "{border_focus}",
        "s_170": "{primary50}",
        "s_171": "{primaryGrey100}",
        "s_172": "{primaryGrey100}",
        "s_173": "{primaryGrey100}",
        "s_174": "{primaryInverse}",
        "s_175": "{primaryGrey100}",
        "s_176": "{primaryGrey100}",
        "s_177": "{primaryGrey100}",
        "s_178": "{primaryInverse}",
        "s_179": "{primary50}",
        "s_180": "{primary30}",
        "s_181": "{primary60}",
        "s_182": "{primary50}",
        "s_183": "{border_focus}",
        "s_184": "{primary40}",
        "s_185": "{primaryInverse}",
        "s_186": "{primaryGrey100}",
        "s_187": "{primaryInverse}",
        "s_188": "{primaryGrey100}",
        "s_189": "{global.transparent}",
        "s_190": "{border_thin}",
        "s_191": "{primaryGrey60}",
        "s_192": "{primary30}",
        "s_193": "{primary50}",
        "s_194": "{primary30}",
        "s_195": "{border_focus}",
        "s_196": "{primary50}",
        "s_197": "{primaryBackground}",
        "s_198": "{primaryGrey100}",
        "s_199": "{primaryGrey100}",
        "s_200": "{primaryBackground}",
        "s_201": "{primaryGrey100}",
        "s_202": "{primaryGrey100}",
        "s_203": "{primary30}",
        "s_204": "{primaryGrey60}",
        "s_205": "{primary50}",
        "s_206": "{primary50}",
        "s_207": "{border_focus}",
        "s_208": "{primary50}",
        "s_209": "{primaryGrey100}",
        "s_210": "{primaryInverse}",
        "s_211": "{primaryGrey100}",
        "s_212": "{primaryInverse}",
        "s_213": "{global.transparent}",
        "s_214": "{primary30}",
        "s_215": "{primary50}",
        "s_216": "{primary30}",
        "s_217": "{border_focus}",
        "s_218": "{primary50}",
        "s_219": "{primaryBackground}",
        "s_220": "{primaryGrey100}",
        "s_221": "{primaryGrey100}",
        "s_222": "{primaryBackground}",
        "s_223": "{primaryGrey100}",
        "s_224": "{primaryGrey100}",
        "s_225": "{primary30}",
        "s_226": "{primary50}",
        "s_227": "{border_focus}",
        "s_228": "{primary50}",
        "s_229": "{primary50}",
        "s_230": "{primaryGrey100}",
        "s_231": "{primaryInverse}",
        "s_232": "{primaryGrey100}",
        "s_233": "{primaryInverse}",
        "s_234": "{global.transparent}",
        "s_235": "{border_focus}",
        "s_236": "{primary50}",
        "s_237": "{global.transparent}",
        "s_238": "{global.transparent}",
        "s_239": "{primaryBackground}",
        "s_240": "{primary20}",
        "s_241": "{primary30}",
        "s_242": "{primaryBackground}",
        "s_243": "{primary20}",
        "s_244": "{primary30}",
        "s_245": "{global.transparent}",
        "s_246": "{border_focus}",
        "s_247": "{primary50}",
        "s_248": "{global.transparent}",
        "s_249": "{global.transparent}",
        "s_250": "{primary30}",
        "s_251": "{primary20}",
        "s_252": "{primary30}",
        "s_253": "{primary30}",
        "s_254": "{primary30}",
        "s_255": "{primary20}",
        "s_256": "{primary30}",
        "s_257": "{primary30}",
        "s_258": "{xxs}",
        "s_259": "{xxs}",
        "s_260": "{xs}",
        "s_261": "{xs}",
        "s_262": "{s}",
        "s_263": "{s}",
        "s_264": "{base}",
        "s_265": "{base}",
        "s_266": "{xxs}",
        "s_267": "{xxs}",
        "s_268": "{base}",
        "s_269": "{base}",
        "s_270": "{s}",
        "s_271": "{m}",
        "s_272": "{s}",
        "s_273": "{m}",
        "s_274": "{m}",
        "s_275": "{m}",
        "s_276": "{base}",
        "s_277": "{l}",
        "s_278": "{base}",
        "s_279": "{l}",
        "s_280": "{l}",
        "s_281": "{l}",
        "s_282": "{l}",
        "s_283": "{l}",
        "s_284": "{base}",
        "s_285": "{xl}",
        "s_286": "{xl}",
        "s_287": "{xxl}",
        "s_288": "{xxl}",
        "s_289": "{m}",
        "s_290": "{huge}",
        "s_291": "{huge}",
        "s_292": "{l}",
        "s_293": "{size.max}",
        "s_294": "{justifyContent.spaceBetween}",
        "s_295": "{primary60}",
        "s_296": "{primary60}"
    },
    "JDSSlider": {
        "s_0": "{flexDirection.column}",
        "s_1": "{justifyContent.start}",
        "s_2": "{alignItems.start}",
        "s_3": "{size.max}",
        "s_4": "{xs}",
        "s_5": "{flexDirection.row}",
        "s_6": "{justifyContent.start}",
        "s_7": "{alignItems.center}",
        "s_8": "{size.max}",
        "s_9": "{xs}",
        "s_10": "{justifyContent.start}",
        "s_11": "{alignItems.center}",
        "s_12": "{alignItems.center}",
        "s_13": "{xs}",
        "s_14": "{xs}",
        "s_15": "{border_thin}",
        "s_16": "{primaryGrey80}",
        "s_17": "{medium}",
        "s_18": "{size.max}",
        "s_19": "{xxs}",
        "s_20": "{primaryGrey40}",
        "s_21": "{primary50}",
        "s_22": "{primary50}",
        "s_23": "{primary80}",
        "s_24": "{small}",
        "s_25": "{primary60}",
        "s_26": "{primary60}",
        "s_27": "{primary60}",
        "s_28": "{border_focus}",
        "s_29": "{flexDirection.row}",
        "s_30": "{justifyContent.spaceBetween}",
        "s_31": "{alignItems.center}",
        "s_32": "{size.max}",
        "s_33": "{feedbackSuccess50}",
        "s_34": "{feedbackError50}",
        "s_35": "{feedbackWarning50}",
        "s_36": "{opacity.disabled}",
        "s_37": "{primary50}",
        "s_38": "{primary50}",
        "s_39": "{primary50}"
    },
    "JDSStepperDot": {
        "s_0": "{global.transparent}",
        "s_1": "{border_thin}",
        "s_2": "{sparkleGrey60}",
        "s_3": "{l}",
        "s_4": "{l}",
        "s_5": "{justifyContent.center}",
        "s_6": "{alignItems.center}",
        "s_7": "{pill}",
        "s_8": "{sparkleGrey60}",
        "s_9": "{base}",
        "s_10": "{sparkle60}",
        "s_11": "{base}",
        "s_12": "{sparkleGrey60}",
        "s_13": "{xs}",
        "s_14": "{xs}",
        "s_15": "{pill}",
        "s_16": "{sparkle50}",
        "s_17": "{sparkle50}",
        "s_18": "{sparkleInverse}",
        "s_19": "{sparkleInverse}",
        "s_20": "{sparkle20}",
        "s_21": "{sparkle50}",
        "s_22": "{l}",
        "s_23": "{l}",
        "s_24": "{sparkle60}",
        "s_25": "{sparkle60}",
        "s_26": "{opacity.disabled}"
    },
    "JDSHorizontalStepItem": {
        "h_0": "{flexDirection.column}",
        "h_1": "{alignItems.center}",
        "h_2": "{justifyContent.start}",
        "h_3": "{size.max}",
        "h_4": "{xs}",
        "h_5": "{flexDirection.row}",
        "h_6": "{size.max}",
        "h_7": "{alignItems.center}",
        "h_8": "{xs}",
        "h_9": "{xs}",
        "h_10": "{xs}",
        "h_11": "{opacity.enabled}",
        "h_12": "{opacity.enabled}",
        "h_13": "{opacity.invisible}",
        "h_14": "{opacity.invisible}"
    },
    "JDSVerticalStepItem": {
        "v_0": "{flexDirection.column}",
        "v_1": "{justifyContent.start}",
        "v_2": "{alignItems.start}",
        "v_3": "{xs}",
        "v_4": "{size.max}",
        "v_5": "{opacity.enabled}",
        "v_6": "{flexDirection.row}",
        "v_7": "{justifyContent.start}",
        "v_8": "{alignItems.center}",
        "v_9": "{intrinsicSize.max}",
        "v_10": "{flexDirection.row}",
        "v_11": "{justifyContent.start}",
        "v_12": "{alignItems.stretch}",
        "v_13": "{l}",
        "v_14": "{custom_23}",
        "v_15": "{flexDirection.row}",
        "v_16": "{justifyContent.start}",
        "v_17": "{alignItems.center}",
        "v_18": "{base}",
        "v_19": "0",
        "v_20": "0",
        "v_21": "{custom_24}",
        "v_22": "{xs}",
        "v_23": "{m}",
        "v_24": "{opacity.invisible}"
    },
    "JDSTableCell": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.center}",
        "t_3": "{global.transparent}",
        "t_4": "{base}",
        "t_5": "{base}",
        "t_6": "{base}",
        "t_7": "{base}",
        "t_8": "{primaryGrey40}",
        "t_9": "{size.max}",
        "t_10": "{xs}",
        "t_11": "{xs}",
        "t_12": "{xs}",
        "t_13": "{xs}",
        "t_14": "{primaryGrey40}",
        "t_15": 1,
        "t_16": "{primary50}",
        "t_17": "{primary60}",
        "t_18": "{primaryGrey20}",
        "t_19": 1,
        "t_20": 4,
        "t_21": 0
    },
    "JDSTableBody": {
        "t_0": "{size.max}",
        "t_1": "{flexDirection.row}",
        "t_2": "{size.max}"
    },
    "JDSTableRow": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{size.max}"
    },
    "JDSTabBar": {
        "t_0": "{flexDirection.stack}",
        "t_1": "{size.max}",
        "t_2": "{size.max}",
        "t_3": "{justifyContent.start}",
        "t_4": "{alignItems.end}",
        "t_5": "{size.max}",
        "t_6": "{opacity.enabled}",
        "t_7": "{global.transparent}",
        "t_8": "{alignItems.center}",
        "t_9": "{justifyContent.start}",
        "t_10": "{xxs}",
        "t_11": "{flexDirection.row}",
        "t_12": "{flexDirection.row}",
        "t_13": "{justifyContent.start}",
        "t_14": "{alignItems.center}",
        "t_15": "{size.max}",
        "t_16": "{pill}",
        "t_17": "{primary50}",
        "t_18": "{xxs}",
        "t_19": "{size.max}",
        "t_20": "{justifyContent.center}",
        "t_21": "{primary60}",
        "t_22": "{xxl}",
        "t_23": "{xxl}",
        "t_24": "{custom_dark_primary_60}",
        "t_25": "{m}",
        "t_26": "{m}"
    },
    "JDSVerticalStepper": {
        "v_0": "{flexDirection.column}",
        "v_1": "{justifyContent.start}",
        "v_2": "{alignItems.start}",
        "v_3": "{size.max}",
        "v_4": "{xs}"
    },
    "JDSTabItem": {
        "t_0": "{global.transparent}",
        "t_1": "{flexDirection.column}",
        "t_2": "{alignItems.center}",
        "t_3": "{justifyContent.center}",
        "t_4": "{xxl}",
        "t_5": "{intrinsicSize.max}",
        "t_6": "{intrinsicSize.max}",
        "t_7": "{flexDirection.row}",
        "t_8": "{alignItems.center}",
        "t_9": "{justifyContent.center}",
        "t_10": "{xs}",
        "t_11": "{s}",
        "t_12": "{s}",
        "t_13": "{xs}",
        "t_14": "{xs}",
        "t_15": "{border_normal}",
        "t_16": "{primary80}",
        "t_17": "{large}",
        "t_18": "{m}",
        "t_19": "{primaryGrey80}",
        "t_20": "{primaryGrey100}",
        "t_21": "{primary60}",
        "t_22": "{primaryGrey80}",
        "t_23": "{bodyS}",
        "t_24": "{bodyS}",
        "t_25": "{bodyS}",
        "t_26": "{bodyS}",
        "t_27": "{bodyS}",
        "t_28": "{primary60}",
        "t_29": "{global.transparent}",
        "t_30": "{xxs}",
        "t_31": "{size.max}",
        "t_32": "{pill}",
        "t_33": "{opacity.enabled}",
        "t_34": "{opacity.disabled}",
        "t_35": "{primaryGrey100}",
        "t_36": "{primary60}",
        "t_37": "{custom_dark_primary_40}",
        "t_38": "{custom_dark_primary_60}",
        "t_39": "{custom_dark_primary_grey_100}",
        "t_40": "{custom_dark_primary_grey_80}",
        "t_41": "{custom_dark_primary_grey_100}",
        "t_42": "{custom_dark_primary_grey_100}",
        "t_43": "{custom_dark_primary_grey_80}",
        "t_44": "{custom_dark_primary_grey_100}",
        "t_45": "{primaryGrey100}",
        "t_46": "{primaryGrey100}"
    },
    "JDSTabsDesktop": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{size.max}",
        "t_3": "{flexDirection.row}",
        "t_4": "{size.max}",
        "t_5": "{alignItems.center}",
        "t_6": "{size.max}",
        "t_7": "{base}",
        "t_8": "{primary60}"
    },
    "JDSTag": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.center}",
        "t_3": "{xxs}",
        "t_4": "{s}",
        "t_5": "{s}",
        "t_6": "{xxs}",
        "t_7": "{xxs}",
        "t_8": "{global.transparent}",
        "t_9": "{pill}",
        "t_10": "{border_thin}",
        "t_11": "{primaryGrey80}",
        "t_12": "{primaryGrey80}",
        "t_13": "{sparkle20}",
        "t_14": "{sparkle80}",
        "t_15": "{border_focus}",
        "t_16": "{base}",
        "t_17": "{primaryGrey100}",
        "t_18": "{sparkle80}",
        "t_19": "{sparkle80}",
        "t_20": "{sparkle80}",
        "t_21": "{border_none}",
        "t_22": "{primaryGrey80}",
        "t_23": "{sparkle20}",
        "t_24": "{sparkle30}",
        "t_25": "{global.transparent}",
        "t_26": "{primaryGrey40}",
        "t_27": "{sparkle30}",
        "t_28": "{sparkle80}",
        "t_29": "{opacity.disabled}",
        "t_30": "{opacity.enabled}",
        "t_31": "{custom_4}",
        "t_32": "{xs}",
        "t_33": "{xs}",
        "t_34": "{custom_4}"
    },
    "JDSHorizontalStepper": {
        "h_0": "{stepper_horizontal}",
        "h_1": "{flexDirection.column}",
        "h_2": "{size.max}",
        "h_3": "{flexDirection.row}",
        "h_4": "{justifyContent.center}",
        "h_5": "{alignItems.center}",
        "h_6": "{size.max}",
        "h_7": "{l}",
        "h_8": "{l}",
        "h_9": "{size.max}",
        "h_10": "{flexDirection.row}",
        "h_11": "{justifyContent.start}",
        "h_12": "{alignItems.center}"
    },
    "JDSTable": {
        "t_0": "{flexDirection.column}",
        "t_1": "{size.max}",
        "t_2": "{medium}",
        "t_3": "{border_thin}",
        "t_4": "{primaryGrey40}",
        "t_5": "{size.max}",
        "t_6": "{alignItems.start}",
        "t_7": "{base}",
        "t_8": "{base}",
        "t_9": "{base}",
        "t_10": "{base}",
        "t_11": "{xs}",
        "t_12": "{xs}",
        "t_13": "{xs}",
        "t_14": "{xs}"
    },
    "JDSToggle": {
        "t_0": "{flexDirection.column}",
        "t_1": "{flexDirection.column}",
        "t_2": "{justifyContent.start}",
        "t_3": "{alignItems.start}",
        "t_4": "{xs}",
        "t_5": "{flexDirection.row}",
        "t_6": "{justifyContent.start}",
        "t_7": "{alignItems.center}",
        "t_8": "{xs}",
        "t_9": "{custom_2}",
        "t_10": "{m}",
        "t_11": "{flexDirection.row}",
        "t_12": "{justifyContent.start}",
        "t_13": "{alignItems.center}",
        "t_14": "{xxs}",
        "t_15": "{xxs}",
        "t_16": "{global.transparent}",
        "t_17": "{pill}",
        "t_18": "{border_thin}",
        "t_19": "{primaryGrey80}",
        "t_20": "{primary40}",
        "t_21": "{primary60}",
        "t_22": "{xxs}",
        "t_23": "{primary60}",
        "t_24": "{border_none}",
        "t_25": "{base}",
        "t_26": "{base}",
        "t_27": "{primaryGrey80}",
        "t_28": "{pill}",
        "t_29": "{textAlign.start}",
        "t_30": "{custom_3}",
        "t_31": "{base}",
        "t_32": "{xxs}",
        "t_33": "{xs}",
        "t_34": "{xs}",
        "t_35": "{justifyContent.end}",
        "t_36": "{primary50}",
        "t_37": "{border_none}",
        "t_38": "{primary40}",
        "t_39": "{primary60}",
        "t_40": "{primaryInverse}",
        "t_41": "{opacity.disabled}",
        "t_42": "{opacity.enabled}"
    },
    "JDSText": {
        "text_0": "{primary60}",
        "text_1": "{bodyS}",
        "text_2": "{primaryGrey100}",
        "text_3": "{bodyS}",
        "text_4": "{bodyS}",
        "text_5": "{bodyS}",
        "text_6": "{bodyS}",
        "text_7": "{text-decoration.none}",
        "text_8": "{text-case.none}",
        "text_9": "{text-decoration.underline}",
        "text_10": "{text-decoration.line-through}",
        "text_11": "{text-decoration.overline}",
        "text_12": "{primary80}",
        "text_13": "{primary70}",
        "text_14": "{primary60}",
        "text_15": "{primary50}",
        "text_16": "{primary40}",
        "text_17": "{primary30}",
        "text_18": "{primary20}",
        "text_19": "{primaryInverse}",
        "text_20": "{primaryBackground}",
        "text_21": "{primaryGrey100}",
        "text_22": "{primaryGrey80}",
        "text_23": "{primaryGrey60}",
        "text_24": "{primaryGrey40}",
        "text_25": "{primaryGrey20}",
        "text_26": "{secondary80}",
        "text_27": "{secondary70}",
        "text_28": "{secondary60}",
        "text_29": "{secondary50}",
        "text_30": "{secondary40}",
        "text_31": "{secondary30}",
        "text_32": "{secondary20}",
        "text_33": "{secondaryInverse}",
        "text_34": "{secondaryBackground}",
        "text_35": "{secondaryGrey100}",
        "text_36": "{secondaryGrey80}",
        "text_37": "{secondaryGrey60}",
        "text_38": "{secondaryGrey40}",
        "text_39": "{secondaryGrey20}",
        "text_40": "{sparkle80}",
        "text_41": "{sparkle70}",
        "text_42": "{sparkle60}",
        "text_43": "{sparkle50}",
        "text_44": "{sparkle40}",
        "text_45": "{sparkle30}",
        "text_46": "{sparkle20}",
        "text_47": "{sparkleInverse}",
        "text_48": "{sparkleBackground}",
        "text_49": "{sparkleGrey100}",
        "text_50": "{sparkleGrey80}",
        "text_51": "{sparkleGrey60}",
        "text_52": "{sparkleGrey40}",
        "text_53": "{sparkleGrey20}",
        "text_54": "{feedbackError80}",
        "text_55": "{feedbackError50}",
        "text_56": "{feedbackError20}",
        "text_57": "{feedbackWarning80}",
        "text_58": "{feedbackWarning50}",
        "text_59": "{feedbackWarning20}",
        "text_60": "{feedbackSuccess80}",
        "text_61": "{feedbackSuccess50}",
        "text_62": "{feedbackSuccess20}",
        "text_63": "{global.white}",
        "text_64": "{global.black}",
        "text_65": "{global.transparent}",
        "text_66": "{headingXl}",
        "text_67": "{headingXl}",
        "text_68": "{headingXl}",
        "text_69": "{headingXl}",
        "text_70": "{headingXl}",
        "text_71": "{headingL}",
        "text_72": "{headingL}",
        "text_73": "{headingL}",
        "text_74": "{headingL}",
        "text_75": "{headingL}",
        "text_76": "{headingM}",
        "text_77": "{headingM}",
        "text_78": "{headingM}",
        "text_79": "{headingM}",
        "text_80": "{headingM}",
        "text_81": "{headingS}",
        "text_82": "{headingS}",
        "text_83": "{headingS}",
        "text_84": "{headingS}",
        "text_85": "{headingS}",
        "text_86": "{headingXs}",
        "text_87": "{headingXs}",
        "text_88": "{headingXs}",
        "text_89": "{headingXs}",
        "text_90": "{headingXs}",
        "text_91": "{headingXxs}",
        "text_92": "{headingXxs}",
        "text_93": "{headingXxs}",
        "text_94": "{headingXxs}",
        "text_95": "{headingXxs}",
        "text_96": "{overline}",
        "text_97": "{overline}",
        "text_98": "{overline}",
        "text_99": "{overline}",
        "text_100": "{overline}",
        "text_101": "{overline}",
        "text_102": "{bodyL}",
        "text_103": "{bodyL}",
        "text_104": "{bodyL}",
        "text_105": "{bodyL}",
        "text_106": "{bodyL}",
        "text_107": "{bodyLBold}",
        "text_108": "{bodyLBold}",
        "text_109": "{bodyLBold}",
        "text_110": "{bodyLBold}",
        "text_111": "{bodyLBold}",
        "text_112": "{bodyLLink}",
        "text_113": "{bodyLLink}",
        "text_114": "{bodyLLink}",
        "text_115": "{bodyLLink}",
        "text_116": "{bodyLLink}",
        "text_117": "{bodyM}",
        "text_118": "{bodyM}",
        "text_119": "{bodyM}",
        "text_120": "{bodyM}",
        "text_121": "{bodyM}",
        "text_122": "{bodyMBold}",
        "text_123": "{bodyMBold}",
        "text_124": "{bodyMBold}",
        "text_125": "{bodyMBold}",
        "text_126": "{bodyMBold}",
        "text_127": "{bodyMLink}",
        "text_128": "{bodyMLink}",
        "text_129": "{bodyMLink}",
        "text_130": "{bodyMLink}",
        "text_131": "{bodyMLink}",
        "text_132": "{bodyS}",
        "text_133": "{bodyS}",
        "text_134": "{bodyS}",
        "text_135": "{bodyS}",
        "text_136": "{bodyS}",
        "text_137": "{bodySBold}",
        "text_138": "{bodySBold}",
        "text_139": "{bodySBold}",
        "text_140": "{bodySBold}",
        "text_141": "{bodySBold}",
        "text_142": "{bodySLink}",
        "text_143": "{bodySLink}",
        "text_144": "{bodySLink}",
        "text_145": "{bodySLink}",
        "text_146": "{bodySLink}",
        "text_147": "{bodyXs}",
        "text_148": "{bodyXs}",
        "text_149": "{bodyXs}",
        "text_150": "{bodyXs}",
        "text_151": "{bodyXs}",
        "text_152": "{bodyXsBold}",
        "text_153": "{bodyXsBold}",
        "text_154": "{bodyXsBold}",
        "text_155": "{bodyXsBold}",
        "text_156": "{bodyXsBold}",
        "text_157": "{bodyXsLink}",
        "text_158": "{bodyXsLink}",
        "text_159": "{bodyXsLink}",
        "text_160": "{bodyXsLink}",
        "text_161": "{bodyXsLink}",
        "text_162": "{bodyXs}",
        "text_163": "{bodyXs}",
        "text_164": "{bodyS}",
        "text_165": "{bodyXs}",
        "text_166": "{bodyXs}",
        "text_167": "{bodyXxs}",
        "text_168": "{bodyXxs}",
        "text_169": "{bodyXxs}",
        "text_170": "{bodyXxs}",
        "text_171": "{bodyXxs}",
        "text_172": "{bodyXxsBold}",
        "text_173": "{bodyXxsBold}",
        "text_174": "{bodyXxsBold}",
        "text_175": "{bodyXxsBold}",
        "text_176": "{bodyXxsBold}",
        "text_177": "{bodyXxsLink}",
        "text_178": "{bodyXxsLink}",
        "text_179": "{bodyXxsLink}",
        "text_180": "{bodyXxsLink}",
        "text_181": "{bodyXxsLink}",
        "text_182": "{body3xs}",
        "text_183": "{body3xs}",
        "text_184": "{body3xs}",
        "text_185": "{body3xs}",
        "text_186": "{body3xs}",
        "text_187": "{body3xsBold}",
        "text_188": "{body3xsBold}",
        "text_189": "{body3xsBold}",
        "text_190": "{body3xsBold}",
        "text_191": "{body3xsBold}",
        "text_192": "{body3xsLink}",
        "text_193": "{body3xsLink}",
        "text_194": "{body3xsLink}",
        "text_195": "{body3xsLink}",
        "text_196": "{body3xsLink}",
        "text_197": "{listTitle}",
        "text_198": "{listTitle}",
        "text_199": "{listTitle}",
        "text_200": "{listTitle}",
        "text_201": "{listTitle}",
        "text_202": "{button}",
        "text_203": "{button}",
        "text_204": "{button}",
        "text_205": "{button}",
        "text_206": "{button}",
        "text_207": "{code}",
        "text_208": "{code}",
        "text_209": "{code}",
        "text_210": "{code}",
        "text_211": "{code}",
        "text_212": "{bodyS}",
        "text_213": "{bodyS}",
        "text_214": "{bodyS}",
        "text_215": "{bodyS}",
        "text_216": "{bodyS}"
    },
    "JDSTooltip": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{flexDirection.row}",
        "t_4": "{justifyContent.start}",
        "t_5": "{alignItems.center}",
        "t_6": "hidden",
        "t_7": "{medium}",
        "t_8": "{border_thin}",
        "t_9": "{primaryGrey100}",
        "t_10": "{primaryGrey100}",
        "t_11": "{primaryGrey100}",
        "t_12": "{base}",
        "t_13": "{base}",
        "t_14": "{xs}",
        "t_15": "{xs}",
        "t_16": "{alignItems.start}",
        "t_17": "{xs}",
        "t_18": "{alignItems.end}",
        "t_19": "{xs}",
        "t_20": "{alignItems.start}",
        "t_21": "{xs}",
        "t_22": "{alignItems.end}",
        "t_23": "{xs}",
        "t_24": "{flexDirection.column}",
        "t_25": "{alignItems.center}",
        "t_26": "{flexDirection.column}",
        "t_27": "{alignItems.start}",
        "t_28": "{xs}",
        "t_29": "{flexDirection.column}",
        "t_30": "{alignItems.end}",
        "t_31": "{xs}",
        "t_32": "{flexDirection.column}",
        "t_33": "{alignItems.center}",
        "t_34": "{flexDirection.column}",
        "t_35": "{alignItems.start}",
        "t_36": "{xs}",
        "t_37": "{flexDirection.column}",
        "t_38": "{alignItems.end}",
        "t_39": "{xs}",
        "t_40": "{xl}",
        "t_41": "{alignItems.center}"
    },
    "JDSTooltipInternal": {
        "t_0": "{flexDirection.row}",
        "t_1": "{justifyContent.start}",
        "t_2": "{alignItems.start}",
        "t_3": "{flexDirection.row}",
        "t_4": "{justifyContent.start}",
        "t_5": "{alignItems.center}",
        "t_6": "hidden",
        "t_7": "{medium}",
        "t_8": "{border_thin}",
        "t_9": "{primaryGrey100}",
        "t_10": "{primaryGrey100}",
        "t_11": "{primaryGrey100}",
        "t_12": "{base}",
        "t_13": "{base}",
        "t_14": "{xs}",
        "t_15": "{xs}",
        "t_16": "{alignItems.start}",
        "t_17": "{xs}",
        "t_18": "{alignItems.end}",
        "t_19": "{xs}",
        "t_20": "{alignItems.start}",
        "t_21": "{xs}",
        "t_22": "{alignItems.end}",
        "t_23": "{xs}",
        "t_24": "{flexDirection.column}",
        "t_25": "{alignItems.center}",
        "t_26": "{flexDirection.column}",
        "t_27": "{alignItems.start}",
        "t_28": "{xs}",
        "t_29": "{flexDirection.column}",
        "t_30": "{alignItems.end}",
        "t_31": "{xs}",
        "t_32": "{flexDirection.column}",
        "t_33": "{alignItems.center}",
        "t_34": "{flexDirection.column}",
        "t_35": "{alignItems.start}",
        "t_36": "{xs}",
        "t_37": "{flexDirection.column}",
        "t_38": "{alignItems.end}",
        "t_39": "{xs}",
        "t_40": "{xl}",
        "t_41": "{alignItems.center}"
    },
    "JDSInputCode": {
        "i_0": "{flexDirection.column}",
        "i_1": "{justifyContent.start}",
        "i_2": "{alignItems.start}",
        "i_3": "{size.max}",
        "i_4": "{xs}",
        "i_5": "{flexDirection.row}",
        "i_6": "{justifyContent.center}",
        "i_7": "{alignItems.center}",
        "i_8": "{size.max}",
        "i_9": "{xs}",
        "i_10": "{opacity.disabled}",
        "i_11": "{opacity.enabled}"
    },
    "JDSRatingBar": {
        "r_0": "{flexDirection.column}",
        "r_1": "{alignItems.start}",
        "r_2": "{justifyContent.start}",
        "r_3": "{xxs}",
        "r_4": "{flexDirection.row}",
        "a_5": "{alignItems.center}",
        "r_6": "{justifyContent.start}",
        "r_7": "{xs}",
        "r_8": "{flexDirection.row}",
        "r_9": "{xxs}",
        "r_10": "{xs}",
        "r_11": "{alignItems.center}",
        "r_12": "{alignItems.center}",
        "r_13": "{opacity.disabled}",
        "r_14": "{xxs}",
        "r_15": "{xxs}",
        "r_16": "{xs}",
        "r_17": "{xs}",
        "r_18": "{xs}",
        "r_19": "{xs}",
        "r_20": "{xxs}",
        "r_21": "{xxs}",
        "r_22": "{xs}",
        "r_23": "{xs}",
        "r_24": "{xs}",
        "r_25": "{xs}",
        "r_26": "{alignItems.center}"
    },
    "JDSRatingBarItem": {
        "r_0": "{flexDirection.stack}",
        "r_1": "{border_focus}",
        "r_2": "{primary60}",
        "r_3": "{m}",
        "r_4": "{m}",
        "r_5": "{xl}",
        "r_6": "{xl}",
        "r_7": "{opacity.disabled}",
        "r_8": "{primaryGrey60}",
        "r_9": "{primaryGrey60}",
        "r_10": "{primaryGrey60}",
        "r_11": "{primaryGrey60}",
        "r_12": "{primaryGrey80}",
        "r_13": "{primaryGrey80}",
        "r_14": "{primaryGrey80}",
        "r_15": "{primaryGrey80}",
        "r_16": "{border_focus}",
        "r_17": "{border_focus}",
        "r_18": "{primary60}",
        "r_19": "{primary60}",
        "r_20": "{primaryGrey60}",
        "r_21": "{primaryGrey60}",
        "r_22": "{primary50}",
        "r_23": "{primary50}",
        "r_24": "{primary70}",
        "r_25": "{primary70}",
        "r_26": "{primary60}",
        "r_27": "{primary60}",
        "r_28": "{border_focus}",
        "r_29": "{border_focus}",
        "r_30": "{primary60}",
        "r_31": "{primary60}",
        "r_32": "{primary50}",
        "r_33": "{primary50}",
        "r_34": "{primary70}",
        "r_35": "{primary70}",
        "r_36": "{primary70}",
        "r_37": "{primary70}",
        "r_38": "{primaryGrey80}",
        "r_39": "{primaryGrey60}"
    }
};
function $52d4442770cfd938$var$getComponentTokens(componentName) {
    return $52d4442770cfd938$var$JSON_MAP$1[componentName];
}
const $52d4442770cfd938$var$layout = {
    "flexDirection.row": "row",
    "flexDirection.column": "column",
    "flexDirection.stack": "stack",
    "alignItems.start": "flex-start",
    "alignItems.center": "center",
    "alignItems.end": "flex-end",
    "alignItems.spaceBetween": "space-between",
    "alignItems.spaceAround": "space-around",
    "alignItems.spaceEvenly": "space-evenly",
    "alignItems.stretch": "stretch",
    "justifyContent.start": "flex-start",
    "justifyContent.center": "center",
    "justifyContent.end": "flex-end",
    "justifyContent.spaceBetween": "space-between",
    "justifyContent.spaceAround": "space-around",
    "justifyContent.spaceEvenly": "space-evenly",
    "textAlign.start": "start",
    "textAlign.center": "center",
    "textAlign.end": "end",
    "textAlign.justify": "justify",
    "aspect_ratio.1.1": "1",
    "aspect_ratio.3.4": "0.75",
    "aspect_ratio.4.3": "1.33",
    "aspect_ratio.4.5": "0.8",
    "aspect_ratio.5.4": "1.25",
    "aspect_ratio.9.16": "0.56",
    "aspect_ratio.16.9": "1.77",
    "aspect_ratio.2_75.1": "2.75",
    "size.max": "max",
    "size.min": "min",
    "size.negativeMax": "negativeMax",
    "intrinsicSize.min": "intrinsicSize.min",
    "intrinsicSize.max": "intrinsicSize.max",
    "zIndex-1": 1,
    "size.fit": "fit-content"
};
const $52d4442770cfd938$var$headingXl$1 = "{$lang.$platform.headingXl}";
const $52d4442770cfd938$var$headingL$1 = "{$lang.$platform.headingL}";
const $52d4442770cfd938$var$headingM$1 = "{$lang.$platform.headingM}";
const $52d4442770cfd938$var$headingS$1 = "{$lang.$platform.headingS}";
const $52d4442770cfd938$var$headingXs$1 = "{$lang.$platform.headingXs}";
const $52d4442770cfd938$var$headingXxs$1 = "{$lang.$platform.headingXxs}";
const $52d4442770cfd938$var$overline$2 = "{$lang.$platform.overline}";
const $52d4442770cfd938$var$bodyL$1 = "{$lang.$platform.bodyL}";
const $52d4442770cfd938$var$bodyLBold$1 = "{$lang.$platform.bodyLBold}";
const $52d4442770cfd938$var$bodyLLink$1 = "{$lang.$platform.bodyLLink}";
const $52d4442770cfd938$var$bodyM$1 = "{$lang.$platform.bodyM}";
const $52d4442770cfd938$var$bodyMBold$1 = "{$lang.$platform.bodyMBold}";
const $52d4442770cfd938$var$bodyMLink$1 = "{$lang.$platform.bodyMLink}";
const $52d4442770cfd938$var$bodyS$1 = "{$lang.$platform.bodyS}";
const $52d4442770cfd938$var$bodySBold$1 = "{$lang.$platform.bodySBold}";
const $52d4442770cfd938$var$bodySLink$1 = "{$lang.$platform.bodySLink}";
const $52d4442770cfd938$var$bodyXs$1 = "{$lang.$platform.bodyXs}";
const $52d4442770cfd938$var$bodyXsBold$1 = "{$lang.$platform.bodyXsBold}";
const $52d4442770cfd938$var$bodyXsLink$1 = "{$lang.$platform.bodyXsLink}";
const $52d4442770cfd938$var$bodyXxs$1 = "{$lang.$platform.bodyXxs}";
const $52d4442770cfd938$var$bodyXxsBold$1 = "{$lang.$platform.bodyXxsBold}";
const $52d4442770cfd938$var$bodyXxsLink$1 = "{$lang.$platform.bodyXxsLink}";
const $52d4442770cfd938$var$body3xs$1 = "{$lang.$platform.body3xs}";
const $52d4442770cfd938$var$body3xsBold$1 = "{$lang.$platform.body3xsBold}";
const $52d4442770cfd938$var$body3xsLink$1 = "{$lang.$platform.body3xsLink}";
const $52d4442770cfd938$var$listTitle$1 = "{$lang.$platform.listTitle}";
const $52d4442770cfd938$var$button$1 = "{$lang.$platform.button}";
const $52d4442770cfd938$var$code$1 = "{$lang.$platform.code}";
const $52d4442770cfd938$var$letterSpacing = {
    "letter-spacing.0": "0",
    "as.desktop.headingXl": -2.6399999999999997,
    "as.desktop.headingL": -1.92,
    "as.desktop.headingM": -1.2,
    "as.desktop.headingS": -0.96,
    "as.desktop.headingXs": -0.72,
    "as.desktop.headingXxs": -0.48,
    "as.desktop.overline": -0.06,
    "as.desktop.bodyL": -0.12,
    "as.desktop.bodyLBold": -0.12,
    "as.desktop.bodyLLink": -0.12,
    "as.desktop.bodyM": -0.09,
    "as.desktop.bodyMBold": -0.09,
    "as.desktop.bodyMLink": -0.09,
    "as.desktop.bodyS": -0.08,
    "as.desktop.bodySBold": -0.08,
    "as.desktop.bodySLink": -0.08,
    "as.desktop.bodyXs": -0.07,
    "as.desktop.bodyXsBold": -0.07,
    "as.desktop.bodyXsLink": -0.07,
    "as.desktop.bodyXxs": -0.06,
    "as.desktop.bodyXxsBold": -0.06,
    "as.desktop.bodyXxsLink": -0.06,
    "as.desktop.body3xs": -0.055,
    "as.desktop.body3xsBold": -0.055,
    "as.desktop.body3xsLink": -0.055,
    "as.desktop.listTitle": -0.08,
    "as.desktop.button": -0.08,
    "as.desktop.code": 0,
    "as.mobile.headingXl": -1.92,
    "as.mobile.headingL": -1.44,
    "as.mobile.headingM": -1.2,
    "as.mobile.headingS": -0.96,
    "as.mobile.headingXs": -0.72,
    "as.mobile.headingXxs": -0.48,
    "as.mobile.overline": -0.06,
    "as.mobile.bodyL": -0.12,
    "as.mobile.bodyLBold": -0.12,
    "as.mobile.bodyLLink": -0.12,
    "as.mobile.bodyM": -0.09,
    "as.mobile.bodyMBold": -0.09,
    "as.mobile.bodyMLink": -0.09,
    "as.mobile.bodyS": 0.08,
    "as.mobile.bodySBold": -0.08,
    "as.mobile.bodySLink": -0.08,
    "as.mobile.bodyXs": -0.07,
    "as.mobile.bodyXsBold": -0.07,
    "as.mobile.bodyXsLink": -0.07,
    "as.mobile.bodyXxs": -0.06,
    "as.mobile.bodyXxsBold": -0.06,
    "as.mobile.bodyXxsLink": -0.06,
    "as.mobile.body3xs": -0.055,
    "as.mobile.body3xsBold": -0.055,
    "as.mobile.body3xsLink": -0.055,
    "as.mobile.listTitle": -0.08,
    "as.mobile.button": -0.08,
    "as.mobile.code": 0,
    "bn.desktop.headingXl": -2.6399999999999997,
    "bn.desktop.headingL": -1.92,
    "bn.desktop.headingM": -1.2,
    "bn.desktop.headingS": -0.96,
    "bn.desktop.headingXs": -0.72,
    "bn.desktop.headingXxs": -0.48,
    "bn.desktop.overline": -0.06,
    "bn.desktop.bodyL": -0.12,
    "bn.desktop.bodyLBold": -0.12,
    "bn.desktop.bodyLLink": -0.12,
    "bn.desktop.bodyM": -0.09,
    "bn.desktop.bodyMBold": -0.09,
    "bn.desktop.bodyMLink": -0.09,
    "bn.desktop.bodyS": -0.08,
    "bn.desktop.bodySBold": -0.08,
    "bn.desktop.bodySLink": -0.08,
    "bn.desktop.bodyXs": -0.07,
    "bn.desktop.bodyXsBold": -0.07,
    "bn.desktop.bodyXsLink": -0.07,
    "bn.desktop.bodyXxs": -0.06,
    "bn.desktop.bodyXxsBold": -0.06,
    "bn.desktop.bodyXxsLink": -0.06,
    "bn.desktop.body3xs": -0.055,
    "bn.desktop.body3xsBold": -0.055,
    "bn.desktop.body3xsLink": -0.055,
    "bn.desktop.listTitle": -0.08,
    "bn.desktop.button": -0.08,
    "bn.desktop.code": 0,
    "bn.mobile.headingXl": -1.92,
    "bn.mobile.headingL": -1.44,
    "bn.mobile.headingM": -1.2,
    "bn.mobile.headingS": -0.96,
    "bn.mobile.headingXs": -0.72,
    "bn.mobile.headingXxs": -0.48,
    "bn.mobile.overline": -0.06,
    "bn.mobile.bodyL": -0.12,
    "bn.mobile.bodyLBold": -0.12,
    "bn.mobile.bodyLLink": -0.12,
    "bn.mobile.bodyM": -0.09,
    "bn.mobile.bodyMBold": -0.09,
    "bn.mobile.bodyMLink": -0.09,
    "bn.mobile.bodyS": 0.08,
    "bn.mobile.bodySBold": -0.08,
    "bn.mobile.bodySLink": -0.08,
    "bn.mobile.bodyXs": -0.07,
    "bn.mobile.bodyXsBold": -0.07,
    "bn.mobile.bodyXsLink": -0.07,
    "bn.mobile.bodyXxs": -0.06,
    "bn.mobile.bodyXxsBold": -0.06,
    "bn.mobile.bodyXxsLink": -0.06,
    "bn.mobile.body3xs": -0.055,
    "bn.mobile.body3xsBold": -0.055,
    "bn.mobile.body3xsLink": -0.055,
    "bn.mobile.listTitle": -0.08,
    "bn.mobile.button": -0.08,
    "bn.mobile.code": 0,
    "en.desktop.headingXl": -2.6399999999999997,
    "en.desktop.headingL": -1.92,
    "en.desktop.headingM": -1.2,
    "en.desktop.headingS": -0.96,
    "en.desktop.headingXs": -0.72,
    "en.desktop.headingXxs": -0.48,
    "en.desktop.overline": 0.06,
    "en.desktop.bodyL": -0.12,
    "en.desktop.bodyLBold": -0.12,
    "en.desktop.bodyLLink": -0.12,
    "en.desktop.bodyM": -0.09,
    "en.desktop.bodyMBold": -0.09,
    "en.desktop.bodyMLink": -0.09,
    "en.desktop.bodyS": -0.08,
    "en.desktop.bodySBold": -0.08,
    "en.desktop.bodySLink": -0.08,
    "en.desktop.bodyXs": -0.07,
    "en.desktop.bodyXsBold": -0.07,
    "en.desktop.bodyXsLink": -0.07,
    "en.desktop.bodyXxs": -0.06,
    "en.desktop.bodyXxsBold": -0.06,
    "en.desktop.bodyXxsLink": -0.06,
    "en.desktop.body3xs": -0.055,
    "en.desktop.body3xsBold": -0.055,
    "en.desktop.body3xsLink": -0.055,
    "en.desktop.listTitle": -0.08,
    "en.desktop.button": -0.08,
    "en.desktop.code": 0,
    "en.mobile.headingXl": -1.92,
    "en.mobile.headingL": -1.44,
    "en.mobile.headingM": -1.2,
    "en.mobile.headingS": -0.96,
    "en.mobile.headingXs": -0.72,
    "en.mobile.headingXxs": -0.48,
    "en.mobile.overline": 0.06,
    "en.mobile.bodyL": -0.12,
    "en.mobile.bodyLBold": -0.12,
    "en.mobile.bodyLLink": -0.12,
    "en.mobile.bodyM": -0.09,
    "en.mobile.bodyMBold": -0.09,
    "en.mobile.bodyMLink": -0.09,
    "en.mobile.bodyS": -0.08,
    "en.mobile.bodySBold": -0.08,
    "en.mobile.bodySLink": -0.08,
    "en.mobile.bodyXs": -0.07,
    "en.mobile.bodyXsBold": -0.07,
    "en.mobile.bodyXsLink": -0.07,
    "en.mobile.bodyXxs": -0.06,
    "en.mobile.bodyXxsBold": -0.06,
    "en.mobile.bodyXxsLink": -0.06,
    "en.mobile.body3xs": -0.055,
    "en.mobile.body3xsBold": -0.055,
    "en.mobile.body3xsLink": -0.055,
    "en.mobile.listTitle": -0.08,
    "en.mobile.button": -0.08,
    "en.mobile.code": 0,
    "gu.desktop.headingXl": -2.6399999999999997,
    "gu.desktop.headingL": -1.92,
    "gu.desktop.headingM": -1.2,
    "gu.desktop.headingS": -0.96,
    "gu.desktop.headingXs": -0.72,
    "gu.desktop.headingXxs": -0.48,
    "gu.desktop.overline": -0.06,
    "gu.desktop.bodyL": -0.12,
    "gu.desktop.bodyLBold": -0.12,
    "gu.desktop.bodyLLink": -0.12,
    "gu.desktop.bodyM": -0.09,
    "gu.desktop.bodyMBold": -0.09,
    "gu.desktop.bodyMLink": -0.09,
    "gu.desktop.bodyS": -0.08,
    "gu.desktop.bodySBold": -0.08,
    "gu.desktop.bodySLink": -0.08,
    "gu.desktop.bodyXs": -0.07,
    "gu.desktop.bodyXsBold": -0.07,
    "gu.desktop.bodyXsLink": -0.07,
    "gu.desktop.bodyXxs": -0.06,
    "gu.desktop.bodyXxsBold": -0.06,
    "gu.desktop.bodyXxsLink": -0.06,
    "gu.desktop.body3xs": -0.055,
    "gu.desktop.body3xsBold": -0.055,
    "gu.desktop.body3xsLink": -0.055,
    "gu.desktop.listTitle": -0.08,
    "gu.desktop.button": -0.08,
    "gu.desktop.code": 0,
    "gu.mobile.headingXl": -1.92,
    "gu.mobile.headingL": -1.44,
    "gu.mobile.headingM": -1.2,
    "gu.mobile.headingS": -0.96,
    "gu.mobile.headingXs": -0.72,
    "gu.mobile.headingXxs": -0.48,
    "gu.mobile.overline": -0.06,
    "gu.mobile.bodyL": -0.12,
    "gu.mobile.bodyLBold": -0.12,
    "gu.mobile.bodyLLink": -0.12,
    "gu.mobile.bodyM": -0.09,
    "gu.mobile.bodyMBold": -0.09,
    "gu.mobile.bodyMLink": -0.09,
    "gu.mobile.bodyS": 0.08,
    "gu.mobile.bodySBold": -0.08,
    "gu.mobile.bodySLink": -0.08,
    "gu.mobile.bodyXs": -0.07,
    "gu.mobile.bodyXsBold": -0.07,
    "gu.mobile.bodyXsLink": -0.07,
    "gu.mobile.bodyXxs": -0.06,
    "gu.mobile.bodyXxsBold": -0.06,
    "gu.mobile.bodyXxsLink": -0.06,
    "gu.mobile.body3xs": -0.055,
    "gu.mobile.body3xsBold": -0.055,
    "gu.mobile.body3xsLink": -0.055,
    "gu.mobile.listTitle": -0.08,
    "gu.mobile.button": -0.08,
    "gu.mobile.code": 0,
    "hi.desktop.headingXl": -2.6399999999999997,
    "hi.desktop.headingL": -1.92,
    "hi.desktop.headingM": -1.2,
    "hi.desktop.headingS": -0.96,
    "hi.desktop.headingXs": -0.72,
    "hi.desktop.headingXxs": -0.48,
    "hi.desktop.overline": -0.06,
    "hi.desktop.bodyL": -0.12,
    "hi.desktop.bodyLBold": -0.12,
    "hi.desktop.bodyLLink": -0.12,
    "hi.desktop.bodyM": -0.09,
    "hi.desktop.bodyMBold": -0.09,
    "hi.desktop.bodyMLink": -0.09,
    "hi.desktop.bodyS": -0.08,
    "hi.desktop.bodySBold": -0.08,
    "hi.desktop.bodySLink": -0.08,
    "hi.desktop.bodyXs": -0.07,
    "hi.desktop.bodyXsBold": -0.07,
    "hi.desktop.bodyXsLink": -0.07,
    "hi.desktop.bodyXxs": -0.06,
    "hi.desktop.bodyXxsBold": -0.06,
    "hi.desktop.bodyXxsLink": -0.06,
    "hi.desktop.body3xs": -0.055,
    "hi.desktop.body3xsBold": -0.055,
    "hi.desktop.body3xsLink": -0.055,
    "hi.desktop.listTitle": -0.08,
    "hi.desktop.button": -0.08,
    "hi.desktop.code": 0,
    "hi.mobile.headingXl": -1.92,
    "hi.mobile.headingL": -1.44,
    "hi.mobile.headingM": -1.2,
    "hi.mobile.headingS": -0.96,
    "hi.mobile.headingXs": -0.72,
    "hi.mobile.headingXxs": -0.48,
    "hi.mobile.overline": -0.06,
    "hi.mobile.bodyL": -0.12,
    "hi.mobile.bodyLBold": -0.12,
    "hi.mobile.bodyLLink": -0.12,
    "hi.mobile.bodyM": -0.09,
    "hi.mobile.bodyMBold": -0.09,
    "hi.mobile.bodyMLink": -0.09,
    "hi.mobile.bodyS": 0.08,
    "hi.mobile.bodySBold": -0.08,
    "hi.mobile.bodySLink": -0.08,
    "hi.mobile.bodyXs": -0.07,
    "hi.mobile.bodyXsBold": -0.07,
    "hi.mobile.bodyXsLink": -0.07,
    "hi.mobile.bodyXxs": -0.06,
    "hi.mobile.bodyXxsBold": -0.06,
    "hi.mobile.bodyXxsLink": -0.06,
    "hi.mobile.body3xs": -0.055,
    "hi.mobile.body3xsBold": -0.055,
    "hi.mobile.body3xsLink": -0.055,
    "hi.mobile.listTitle": -0.08,
    "hi.mobile.button": -0.08,
    "hi.mobile.code": 0,
    "kn.desktop.headingXl": -2.6399999999999997,
    "kn.desktop.headingL": -1.92,
    "kn.desktop.headingM": -1.2,
    "kn.desktop.headingS": -0.96,
    "kn.desktop.headingXs": -0.72,
    "kn.desktop.headingXxs": -0.48,
    "kn.desktop.overline": -0.06,
    "kn.desktop.bodyL": -0.12,
    "kn.desktop.bodyLBold": -0.12,
    "kn.desktop.bodyLLink": -0.12,
    "kn.desktop.bodyM": -0.09,
    "kn.desktop.bodyMBold": -0.09,
    "kn.desktop.bodyMLink": -0.09,
    "kn.desktop.bodyS": -0.08,
    "kn.desktop.bodySBold": -0.08,
    "kn.desktop.bodySLink": -0.08,
    "kn.desktop.bodyXs": -0.07,
    "kn.desktop.bodyXsBold": -0.07,
    "kn.desktop.bodyXsLink": -0.07,
    "kn.desktop.bodyXxs": -0.06,
    "kn.desktop.bodyXxsBold": -0.06,
    "kn.desktop.bodyXxsLink": -0.06,
    "kn.desktop.body3xs": -0.055,
    "kn.desktop.body3xsBold": -0.055,
    "kn.desktop.body3xsLink": -0.055,
    "kn.desktop.listTitle": -0.08,
    "kn.desktop.button": -0.08,
    "kn.desktop.code": 0,
    "kn.mobile.headingXl": -1.92,
    "kn.mobile.headingL": -1.44,
    "kn.mobile.headingM": -1.2,
    "kn.mobile.headingS": -0.96,
    "kn.mobile.headingXs": -0.72,
    "kn.mobile.headingXxs": -0.48,
    "kn.mobile.overline": -0.06,
    "kn.mobile.bodyL": -0.12,
    "kn.mobile.bodyLBold": -0.12,
    "kn.mobile.bodyLLink": -0.12,
    "kn.mobile.bodyM": -0.09,
    "kn.mobile.bodyMBold": -0.09,
    "kn.mobile.bodyMLink": -0.09,
    "kn.mobile.bodyS": 0.08,
    "kn.mobile.bodySBold": -0.08,
    "kn.mobile.bodySLink": -0.08,
    "kn.mobile.bodyXs": -0.07,
    "kn.mobile.bodyXsBold": -0.07,
    "kn.mobile.bodyXsLink": -0.07,
    "kn.mobile.bodyXxs": -0.06,
    "kn.mobile.bodyXxsBold": -0.06,
    "kn.mobile.bodyXxsLink": -0.06,
    "kn.mobile.body3xs": -0.055,
    "kn.mobile.body3xsBold": -0.055,
    "kn.mobile.body3xsLink": -0.055,
    "kn.mobile.listTitle": -0.08,
    "kn.mobile.button": -0.08,
    "kn.mobile.code": 0,
    "ml.desktop.headingXl": -2.6399999999999997,
    "ml.desktop.headingL": -1.92,
    "ml.desktop.headingM": -1.2,
    "ml.desktop.headingS": -0.96,
    "ml.desktop.headingXs": -0.72,
    "ml.desktop.headingXxs": -0.48,
    "ml.desktop.overline": -0.06,
    "ml.desktop.bodyL": -0.12,
    "ml.desktop.bodyLBold": -0.12,
    "ml.desktop.bodyLLink": -0.12,
    "ml.desktop.bodyM": -0.09,
    "ml.desktop.bodyMBold": -0.09,
    "ml.desktop.bodyMLink": -0.09,
    "ml.desktop.bodyS": -0.08,
    "ml.desktop.bodySBold": -0.08,
    "ml.desktop.bodySLink": -0.08,
    "ml.desktop.bodyXs": -0.07,
    "ml.desktop.bodyXsBold": -0.07,
    "ml.desktop.bodyXsLink": -0.07,
    "ml.desktop.bodyXxs": -0.06,
    "ml.desktop.bodyXxsBold": -0.06,
    "ml.desktop.bodyXxsLink": -0.06,
    "ml.desktop.body3xs": -0.055,
    "ml.desktop.body3xsBold": -0.055,
    "ml.desktop.body3xsLink": -0.055,
    "ml.desktop.listTitle": -0.08,
    "ml.desktop.button": -0.08,
    "ml.desktop.code": 0,
    "ml.mobile.headingXl": -1.92,
    "ml.mobile.headingL": -1.44,
    "ml.mobile.headingM": -1.2,
    "ml.mobile.headingS": -0.96,
    "ml.mobile.headingXs": -0.72,
    "ml.mobile.headingXxs": -0.48,
    "ml.mobile.overline": -0.06,
    "ml.mobile.bodyL": -0.12,
    "ml.mobile.bodyLBold": -0.12,
    "ml.mobile.bodyLLink": -0.12,
    "ml.mobile.bodyM": -0.09,
    "ml.mobile.bodyMBold": -0.09,
    "ml.mobile.bodyMLink": -0.09,
    "ml.mobile.bodyS": 0.08,
    "ml.mobile.bodySBold": -0.08,
    "ml.mobile.bodySLink": -0.08,
    "ml.mobile.bodyXs": -0.07,
    "ml.mobile.bodyXsBold": -0.07,
    "ml.mobile.bodyXsLink": -0.07,
    "ml.mobile.bodyXxs": -0.06,
    "ml.mobile.bodyXxsBold": -0.06,
    "ml.mobile.bodyXxsLink": -0.06,
    "ml.mobile.body3xs": -0.055,
    "ml.mobile.body3xsBold": -0.055,
    "ml.mobile.body3xsLink": -0.055,
    "ml.mobile.listTitle": -0.08,
    "ml.mobile.button": -0.08,
    "ml.mobile.code": 0,
    "mr.desktop.headingXl": -2.6399999999999997,
    "mr.desktop.headingL": -1.92,
    "mr.desktop.headingM": -1.2,
    "mr.desktop.headingS": -0.96,
    "mr.desktop.headingXs": -0.72,
    "mr.desktop.headingXxs": -0.48,
    "mr.desktop.overline": -0.06,
    "mr.desktop.bodyL": -0.12,
    "mr.desktop.bodyLBold": -0.12,
    "mr.desktop.bodyLLink": -0.12,
    "mr.desktop.bodyM": -0.09,
    "mr.desktop.bodyMBold": -0.09,
    "mr.desktop.bodyMLink": -0.09,
    "mr.desktop.bodyS": -0.08,
    "mr.desktop.bodySBold": -0.08,
    "mr.desktop.bodySLink": -0.08,
    "mr.desktop.bodyXs": -0.07,
    "mr.desktop.bodyXsBold": -0.07,
    "mr.desktop.bodyXsLink": -0.07,
    "mr.desktop.bodyXxs": -0.06,
    "mr.desktop.bodyXxsBold": -0.06,
    "mr.desktop.bodyXxsLink": -0.06,
    "mr.desktop.body3xs": -0.055,
    "mr.desktop.body3xsBold": -0.055,
    "mr.desktop.body3xsLink": -0.055,
    "mr.desktop.listTitle": -0.08,
    "mr.desktop.button": -0.08,
    "mr.desktop.code": 0,
    "mr.mobile.headingXl": -1.92,
    "mr.mobile.headingL": -1.44,
    "mr.mobile.headingM": -1.2,
    "mr.mobile.headingS": -0.96,
    "mr.mobile.headingXs": -0.72,
    "mr.mobile.headingXxs": -0.48,
    "mr.mobile.overline": -0.06,
    "mr.mobile.bodyL": -0.12,
    "mr.mobile.bodyLBold": -0.12,
    "mr.mobile.bodyLLink": -0.12,
    "mr.mobile.bodyM": -0.09,
    "mr.mobile.bodyMBold": -0.09,
    "mr.mobile.bodyMLink": -0.09,
    "mr.mobile.bodyS": 0.08,
    "mr.mobile.bodySBold": -0.08,
    "mr.mobile.bodySLink": -0.08,
    "mr.mobile.bodyXs": -0.07,
    "mr.mobile.bodyXsBold": -0.07,
    "mr.mobile.bodyXsLink": -0.07,
    "mr.mobile.bodyXxs": -0.06,
    "mr.mobile.bodyXxsBold": -0.06,
    "mr.mobile.bodyXxsLink": -0.06,
    "mr.mobile.body3xs": -0.055,
    "mr.mobile.body3xsBold": -0.055,
    "mr.mobile.body3xsLink": -0.055,
    "mr.mobile.listTitle": -0.08,
    "mr.mobile.button": -0.08,
    "mr.mobile.code": 0,
    "or.desktop.headingXl": -2.6399999999999997,
    "or.desktop.headingL": -1.92,
    "or.desktop.headingM": -1.2,
    "or.desktop.headingS": -0.96,
    "or.desktop.headingXs": -0.72,
    "or.desktop.headingXxs": -0.48,
    "or.desktop.overline": -0.06,
    "or.desktop.bodyL": -0.12,
    "or.desktop.bodyLBold": -0.12,
    "or.desktop.bodyLLink": -0.12,
    "or.desktop.bodyM": -0.09,
    "or.desktop.bodyMBold": -0.09,
    "or.desktop.bodyMLink": -0.09,
    "or.desktop.bodyS": -0.08,
    "or.desktop.bodySBold": -0.08,
    "or.desktop.bodySLink": -0.08,
    "or.desktop.bodyXs": -0.07,
    "or.desktop.bodyXsBold": -0.07,
    "or.desktop.bodyXsLink": -0.07,
    "or.desktop.bodyXxs": -0.06,
    "or.desktop.bodyXxsBold": -0.06,
    "or.desktop.bodyXxsLink": -0.06,
    "or.desktop.body3xs": -0.055,
    "or.desktop.body3xsBold": -0.055,
    "or.desktop.body3xsLink": -0.055,
    "or.desktop.listTitle": -0.08,
    "or.desktop.button": -0.08,
    "or.desktop.code": 0,
    "or.mobile.headingXl": -1.92,
    "or.mobile.headingL": -1.44,
    "or.mobile.headingM": -1.2,
    "or.mobile.headingS": -0.96,
    "or.mobile.headingXs": -0.72,
    "or.mobile.headingXxs": -0.48,
    "or.mobile.overline": -0.06,
    "or.mobile.bodyL": -0.12,
    "or.mobile.bodyLBold": -0.12,
    "or.mobile.bodyLLink": -0.12,
    "or.mobile.bodyM": -0.09,
    "or.mobile.bodyMBold": -0.09,
    "or.mobile.bodyMLink": -0.09,
    "or.mobile.bodyS": 0.08,
    "or.mobile.bodySBold": -0.08,
    "or.mobile.bodySLink": -0.08,
    "or.mobile.bodyXs": -0.07,
    "or.mobile.bodyXsBold": -0.07,
    "or.mobile.bodyXsLink": -0.07,
    "or.mobile.bodyXxs": -0.06,
    "or.mobile.bodyXxsBold": -0.06,
    "or.mobile.bodyXxsLink": -0.06,
    "or.mobile.body3xs": -0.055,
    "or.mobile.body3xsBold": -0.055,
    "or.mobile.body3xsLink": -0.055,
    "or.mobile.listTitle": -0.08,
    "or.mobile.button": -0.08,
    "or.mobile.code": 0,
    "pa.desktop.headingXl": -2.6399999999999997,
    "pa.desktop.headingL": -1.92,
    "pa.desktop.headingM": -1.2,
    "pa.desktop.headingS": -0.96,
    "pa.desktop.headingXs": -0.72,
    "pa.desktop.headingXxs": -0.48,
    "pa.desktop.overline": -0.06,
    "pa.desktop.bodyL": -0.12,
    "pa.desktop.bodyLBold": -0.12,
    "pa.desktop.bodyLLink": -0.12,
    "pa.desktop.bodyM": -0.09,
    "pa.desktop.bodyMBold": -0.09,
    "pa.desktop.bodyMLink": -0.09,
    "pa.desktop.bodyS": -0.08,
    "pa.desktop.bodySBold": -0.08,
    "pa.desktop.bodySLink": -0.08,
    "pa.desktop.bodyXs": -0.07,
    "pa.desktop.bodyXsBold": -0.07,
    "pa.desktop.bodyXsLink": -0.07,
    "pa.desktop.bodyXxs": -0.06,
    "pa.desktop.bodyXxsBold": -0.06,
    "pa.desktop.bodyXxsLink": -0.06,
    "pa.desktop.body3xs": -0.055,
    "pa.desktop.body3xsBold": -0.055,
    "pa.desktop.body3xsLink": -0.055,
    "pa.desktop.listTitle": -0.08,
    "pa.desktop.button": -0.08,
    "pa.desktop.code": 0,
    "pa.mobile.headingXl": -1.92,
    "pa.mobile.headingL": -1.44,
    "pa.mobile.headingM": -1.2,
    "pa.mobile.headingS": -0.96,
    "pa.mobile.headingXs": -0.72,
    "pa.mobile.headingXxs": -0.48,
    "pa.mobile.overline": -0.06,
    "pa.mobile.bodyL": -0.12,
    "pa.mobile.bodyLBold": -0.12,
    "pa.mobile.bodyLLink": -0.12,
    "pa.mobile.bodyM": -0.09,
    "pa.mobile.bodyMBold": -0.09,
    "pa.mobile.bodyMLink": -0.09,
    "pa.mobile.bodyS": 0.08,
    "pa.mobile.bodySBold": -0.08,
    "pa.mobile.bodySLink": -0.08,
    "pa.mobile.bodyXs": -0.07,
    "pa.mobile.bodyXsBold": -0.07,
    "pa.mobile.bodyXsLink": -0.07,
    "pa.mobile.bodyXxs": -0.06,
    "pa.mobile.bodyXxsBold": -0.06,
    "pa.mobile.bodyXxsLink": -0.06,
    "pa.mobile.body3xs": -0.055,
    "pa.mobile.body3xsBold": -0.055,
    "pa.mobile.body3xsLink": -0.055,
    "pa.mobile.listTitle": -0.08,
    "pa.mobile.button": -0.08,
    "pa.mobile.code": 0,
    "ta.desktop.headingXl": -2.6399999999999997,
    "ta.desktop.headingL": -1.92,
    "ta.desktop.headingM": -1.2,
    "ta.desktop.headingS": -0.96,
    "ta.desktop.headingXs": -0.72,
    "ta.desktop.headingXxs": -0.48,
    "ta.desktop.overline": -0.06,
    "ta.desktop.bodyL": -0.12,
    "ta.desktop.bodyLBold": -0.12,
    "ta.desktop.bodyLLink": -0.12,
    "ta.desktop.bodyM": -0.09,
    "ta.desktop.bodyMBold": -0.09,
    "ta.desktop.bodyMLink": -0.09,
    "ta.desktop.bodyS": -0.08,
    "ta.desktop.bodySBold": -0.08,
    "ta.desktop.bodySLink": -0.08,
    "ta.desktop.bodyXs": -0.07,
    "ta.desktop.bodyXsBold": -0.07,
    "ta.desktop.bodyXsLink": -0.07,
    "ta.desktop.bodyXxs": -0.06,
    "ta.desktop.bodyXxsBold": -0.06,
    "ta.desktop.bodyXxsLink": -0.06,
    "ta.desktop.body3xs": -0.055,
    "ta.desktop.body3xsBold": -0.055,
    "ta.desktop.body3xsLink": -0.055,
    "ta.desktop.listTitle": -0.08,
    "ta.desktop.button": -0.08,
    "ta.desktop.code": 0,
    "ta.mobile.headingXl": -1.92,
    "ta.mobile.headingL": -1.44,
    "ta.mobile.headingM": -1.2,
    "ta.mobile.headingS": -0.96,
    "ta.mobile.headingXs": -0.72,
    "ta.mobile.headingXxs": -0.48,
    "ta.mobile.overline": -0.06,
    "ta.mobile.bodyL": -0.12,
    "ta.mobile.bodyLBold": -0.12,
    "ta.mobile.bodyLLink": -0.12,
    "ta.mobile.bodyM": -0.09,
    "ta.mobile.bodyMBold": -0.09,
    "ta.mobile.bodyMLink": -0.09,
    "ta.mobile.bodyS": 0.08,
    "ta.mobile.bodySBold": -0.08,
    "ta.mobile.bodySLink": -0.08,
    "ta.mobile.bodyXs": -0.07,
    "ta.mobile.bodyXsBold": -0.07,
    "ta.mobile.bodyXsLink": -0.07,
    "ta.mobile.bodyXxs": -0.06,
    "ta.mobile.bodyXxsBold": -0.06,
    "ta.mobile.bodyXxsLink": -0.06,
    "ta.mobile.body3xs": -0.055,
    "ta.mobile.body3xsBold": -0.055,
    "ta.mobile.body3xsLink": -0.055,
    "ta.mobile.listTitle": -0.08,
    "ta.mobile.button": -0.08,
    "ta.mobile.code": 0,
    "te.desktop.headingXl": -2.6399999999999997,
    "te.desktop.headingL": -1.92,
    "te.desktop.headingM": -1.2,
    "te.desktop.headingS": -0.96,
    "te.desktop.headingXs": -0.72,
    "te.desktop.headingXxs": -0.48,
    "te.desktop.overline": -0.06,
    "te.desktop.bodyL": -0.12,
    "te.desktop.bodyLBold": -0.12,
    "te.desktop.bodyLLink": -0.12,
    "te.desktop.bodyM": -0.09,
    "te.desktop.bodyMBold": -0.09,
    "te.desktop.bodyMLink": -0.09,
    "te.desktop.bodyS": -0.08,
    "te.desktop.bodySBold": -0.08,
    "te.desktop.bodySLink": -0.08,
    "te.desktop.bodyXs": -0.07,
    "te.desktop.bodyXsBold": -0.07,
    "te.desktop.bodyXsLink": -0.07,
    "te.desktop.bodyXxs": -0.06,
    "te.desktop.bodyXxsBold": -0.06,
    "te.desktop.bodyXxsLink": -0.06,
    "te.desktop.body3xs": -0.055,
    "te.desktop.body3xsBold": -0.055,
    "te.desktop.body3xsLink": -0.055,
    "te.desktop.listTitle": -0.08,
    "te.desktop.button": -0.08,
    "te.desktop.code": 0,
    "te.mobile.headingXl": -1.92,
    "te.mobile.headingL": -1.44,
    "te.mobile.headingM": -1.2,
    "te.mobile.headingS": -0.96,
    "te.mobile.headingXs": -0.72,
    "te.mobile.headingXxs": -0.48,
    "te.mobile.overline": -0.06,
    "te.mobile.bodyL": -0.12,
    "te.mobile.bodyLBold": -0.12,
    "te.mobile.bodyLLink": -0.12,
    "te.mobile.bodyM": -0.09,
    "te.mobile.bodyMBold": -0.09,
    "te.mobile.bodyMLink": -0.09,
    "te.mobile.bodyS": 0.08,
    "te.mobile.bodySBold": -0.08,
    "te.mobile.bodySLink": -0.08,
    "te.mobile.bodyXs": -0.07,
    "te.mobile.bodyXsBold": -0.07,
    "te.mobile.bodyXsLink": -0.07,
    "te.mobile.bodyXxs": -0.06,
    "te.mobile.bodyXxsBold": -0.06,
    "te.mobile.bodyXxsLink": -0.06,
    "te.mobile.body3xs": -0.055,
    "te.mobile.body3xsBold": -0.055,
    "te.mobile.body3xsLink": -0.055,
    "te.mobile.listTitle": -0.08,
    "te.mobile.button": -0.08,
    "te.mobile.code": 0,
    headingXl: $52d4442770cfd938$var$headingXl$1,
    headingL: $52d4442770cfd938$var$headingL$1,
    headingM: $52d4442770cfd938$var$headingM$1,
    headingS: $52d4442770cfd938$var$headingS$1,
    headingXs: $52d4442770cfd938$var$headingXs$1,
    headingXxs: $52d4442770cfd938$var$headingXxs$1,
    overline: $52d4442770cfd938$var$overline$2,
    bodyL: $52d4442770cfd938$var$bodyL$1,
    bodyLBold: $52d4442770cfd938$var$bodyLBold$1,
    bodyLLink: $52d4442770cfd938$var$bodyLLink$1,
    bodyM: $52d4442770cfd938$var$bodyM$1,
    bodyMBold: $52d4442770cfd938$var$bodyMBold$1,
    bodyMLink: $52d4442770cfd938$var$bodyMLink$1,
    bodyS: $52d4442770cfd938$var$bodyS$1,
    bodySBold: $52d4442770cfd938$var$bodySBold$1,
    bodySLink: $52d4442770cfd938$var$bodySLink$1,
    bodyXs: $52d4442770cfd938$var$bodyXs$1,
    bodyXsBold: $52d4442770cfd938$var$bodyXsBold$1,
    bodyXsLink: $52d4442770cfd938$var$bodyXsLink$1,
    bodyXxs: $52d4442770cfd938$var$bodyXxs$1,
    bodyXxsBold: $52d4442770cfd938$var$bodyXxsBold$1,
    bodyXxsLink: $52d4442770cfd938$var$bodyXxsLink$1,
    body3xs: $52d4442770cfd938$var$body3xs$1,
    body3xsBold: $52d4442770cfd938$var$body3xsBold$1,
    body3xsLink: $52d4442770cfd938$var$body3xsLink$1,
    listTitle: $52d4442770cfd938$var$listTitle$1,
    button: $52d4442770cfd938$var$button$1,
    code: $52d4442770cfd938$var$code$1
};
const $52d4442770cfd938$var$headingXl = "{$lang.$platform.headingXl}";
const $52d4442770cfd938$var$headingL = "{$lang.$platform.headingL}";
const $52d4442770cfd938$var$headingM = "{$lang.$platform.headingM}";
const $52d4442770cfd938$var$headingS = "{$lang.$platform.headingS}";
const $52d4442770cfd938$var$headingXs = "{$lang.$platform.headingXs}";
const $52d4442770cfd938$var$headingXxs = "{$lang.$platform.headingXxs}";
const $52d4442770cfd938$var$overline$1 = "{$lang.$platform.overline}";
const $52d4442770cfd938$var$bodyL = "{$lang.$platform.bodyL}";
const $52d4442770cfd938$var$bodyLBold = "{$lang.$platform.bodyLBold}";
const $52d4442770cfd938$var$bodyLLink = "{$lang.$platform.bodyLLink}";
const $52d4442770cfd938$var$bodyM = "{$lang.$platform.bodyM}";
const $52d4442770cfd938$var$bodyMBold = "{$lang.$platform.bodyMBold}";
const $52d4442770cfd938$var$bodyMLink = "{$lang.$platform.bodyMLink}";
const $52d4442770cfd938$var$bodyS = "{$lang.$platform.bodyS}";
const $52d4442770cfd938$var$bodySBold = "{$lang.$platform.bodySBold}";
const $52d4442770cfd938$var$bodySLink = "{$lang.$platform.bodySLink}";
const $52d4442770cfd938$var$bodyXs = "{$lang.$platform.bodyXs}";
const $52d4442770cfd938$var$bodyXsBold = "{$lang.$platform.bodyXsBold}";
const $52d4442770cfd938$var$bodyXsLink = "{$lang.$platform.bodyXsLink}";
const $52d4442770cfd938$var$bodyXxs = "{$lang.$platform.bodyXxs}";
const $52d4442770cfd938$var$bodyXxsBold = "{$lang.$platform.bodyXxsBold}";
const $52d4442770cfd938$var$bodyXxsLink = "{$lang.$platform.bodyXxsLink}";
const $52d4442770cfd938$var$body3xs = "{$lang.$platform.body3xs}";
const $52d4442770cfd938$var$body3xsBold = "{$lang.$platform.body3xsBold}";
const $52d4442770cfd938$var$body3xsLink = "{$lang.$platform.body3xsLink}";
const $52d4442770cfd938$var$listTitle = "{$lang.$platform.listTitle}";
const $52d4442770cfd938$var$button = "{$lang.$platform.button}";
const $52d4442770cfd938$var$code = "{$lang.$platform.code}";
const $52d4442770cfd938$var$lineHeights = {
    "as.desktop.headingXl": 92,
    "as.desktop.headingL": 68,
    "as.desktop.headingM": 44,
    "as.desktop.headingS": 36,
    "as.desktop.headingXs": 32,
    "as.desktop.headingXxs": 24,
    "as.desktop.overline": 16,
    "as.desktop.bodyL": 28,
    "as.desktop.bodyLBold": 28,
    "as.desktop.bodyLLink": 28,
    "as.desktop.bodyM": 24,
    "as.desktop.bodyMBold": 24,
    "as.desktop.bodyMLink": 24,
    "as.desktop.bodyS": 24,
    "as.desktop.bodySBold": 24,
    "as.desktop.bodySLink": 24,
    "as.desktop.bodyXs": 16,
    "as.desktop.bodyXsBold": 16,
    "as.desktop.bodyXsLink": 16,
    "as.desktop.bodyXxs": 16,
    "as.desktop.bodyXxsBold": 20,
    "as.desktop.bodyXxsLink": 16,
    "as.desktop.body3xs": 14,
    "as.desktop.body3xsBold": 14,
    "as.desktop.body3xsLink": 14,
    "as.desktop.listTitle": 20,
    "as.desktop.button": 24,
    "as.desktop.code": 16,
    "as.mobile.headingXl": 68,
    "as.mobile.headingL": 52,
    "as.mobile.headingM": 44,
    "as.mobile.headingS": 36,
    "as.mobile.headingXs": 32,
    "as.mobile.headingXxs": 24,
    "as.mobile.overline": 16,
    "as.mobile.bodyL": 32,
    "as.mobile.bodyLBold": 32,
    "as.mobile.bodyLLink": 32,
    "as.mobile.bodyM": 24,
    "as.mobile.bodyMBold": 24,
    "as.mobile.bodyMLink": 24,
    "as.mobile.bodyS": 24,
    "as.mobile.bodySBold": 24,
    "as.mobile.bodySLink": 24,
    "as.mobile.bodyXs": 16,
    "as.mobile.bodyXsBold": 16,
    "as.mobile.bodyXsLink": 16,
    "as.mobile.bodyXxs": 16,
    "as.mobile.bodyXxsBold": 16,
    "as.mobile.bodyXxsLink": 16,
    "as.mobile.body3xs": 14,
    "as.mobile.body3xsBold": 14,
    "as.mobile.body3xsLink": 14,
    "as.mobile.listTitle": 20,
    "as.mobile.button": 24,
    "as.mobile.code": 16,
    "bn.desktop.headingXl": 92,
    "bn.desktop.headingL": 68,
    "bn.desktop.headingM": 44,
    "bn.desktop.headingS": 36,
    "bn.desktop.headingXs": 32,
    "bn.desktop.headingXxs": 24,
    "bn.desktop.overline": 16,
    "bn.desktop.bodyL": 28,
    "bn.desktop.bodyLBold": 28,
    "bn.desktop.bodyLLink": 28,
    "bn.desktop.bodyM": 24,
    "bn.desktop.bodyMBold": 24,
    "bn.desktop.bodyMLink": 24,
    "bn.desktop.bodyS": 24,
    "bn.desktop.bodySBold": 24,
    "bn.desktop.bodySLink": 24,
    "bn.desktop.bodyXs": 16,
    "bn.desktop.bodyXsBold": 16,
    "bn.desktop.bodyXsLink": 16,
    "bn.desktop.bodyXxs": 16,
    "bn.desktop.bodyXxsBold": 16,
    "bn.desktop.bodyXxsLink": 16,
    "bn.desktop.body3xs": 14,
    "bn.desktop.body3xsBold": 14,
    "bn.desktop.body3xsLink": 14,
    "bn.desktop.listTitle": 20,
    "bn.desktop.button": 24,
    "bn.desktop.code": 16,
    "bn.mobile.headingXl": 68,
    "bn.mobile.headingL": 52,
    "bn.mobile.headingM": 44,
    "bn.mobile.headingS": 36,
    "bn.mobile.headingXs": 32,
    "bn.mobile.headingXxs": 24,
    "bn.mobile.overline": 16,
    "bn.mobile.bodyL": 32,
    "bn.mobile.bodyLBold": 32,
    "bn.mobile.bodyLLink": 32,
    "bn.mobile.bodyM": 24,
    "bn.mobile.bodyMBold": 24,
    "bn.mobile.bodyMLink": 24,
    "bn.mobile.bodyS": 24,
    "bn.mobile.bodySBold": 24,
    "bn.mobile.bodySLink": 24,
    "bn.mobile.bodyXs": 16,
    "bn.mobile.bodyXsBold": 16,
    "bn.mobile.bodyXsLink": 16,
    "bn.mobile.bodyXxs": 16,
    "bn.mobile.bodyXxsBold": 16,
    "bn.mobile.bodyXxsLink": 16,
    "bn.mobile.body3xs": 14,
    "bn.mobile.body3xsBold": 14,
    "bn.mobile.body3xsLink": 14,
    "bn.mobile.listTitle": 20,
    "bn.mobile.button": 24,
    "bn.mobile.code": 16,
    "en.desktop.headingXl": 88,
    "en.desktop.headingL": 64,
    "en.desktop.headingM": 40,
    "en.desktop.headingS": 32,
    "en.desktop.headingXs": 28,
    "en.desktop.headingXxs": 20,
    "en.desktop.overline": 16,
    "en.desktop.bodyL": 32,
    "en.desktop.bodyLBold": 32,
    "en.desktop.bodyLLink": 32,
    "en.desktop.bodyM": 24,
    "en.desktop.bodyMBold": 24,
    "en.desktop.bodyMLink": 24,
    "en.desktop.bodyS": 24,
    "en.desktop.bodySBold": 24,
    "en.desktop.bodySLink": 24,
    "en.desktop.bodyXs": 20,
    "en.desktop.bodyXsBold": 20,
    "en.desktop.bodyXsLink": 20,
    "en.desktop.bodyXxs": 16,
    "en.desktop.bodyXxsBold": 16,
    "en.desktop.bodyXxsLink": 16,
    "en.desktop.body3xs": 14,
    "en.desktop.body3xsBold": 14,
    "en.desktop.body3xsLink": 14,
    "en.desktop.listTitle": 20,
    "en.desktop.button": 24,
    "en.desktop.code": 16,
    "en.mobile.headingXl": 64,
    "en.mobile.headingL": 48,
    "en.mobile.headingM": 40,
    "en.mobile.headingS": 32,
    "en.mobile.headingXs": 28,
    "en.mobile.headingXxs": 20,
    "en.mobile.overline": 16,
    "en.mobile.bodyL": 32,
    "en.mobile.bodyLBold": 32,
    "en.mobile.bodyLLink": 32,
    "en.mobile.bodyM": 24,
    "en.mobile.bodyMBold": 24,
    "en.mobile.bodyMLink": 24,
    "en.mobile.bodyS": 24,
    "en.mobile.bodySBold": 24,
    "en.mobile.bodySLink": 24,
    "en.mobile.bodyXs": 20,
    "en.mobile.bodyXsBold": 20,
    "en.mobile.bodyXsLink": 20,
    "en.mobile.bodyXxs": 16,
    "en.mobile.bodyXxsBold": 16,
    "en.mobile.bodyXxsLink": 16,
    "en.mobile.body3xs": 14,
    "en.mobile.body3xsBold": 14,
    "en.mobile.body3xsLink": 14,
    "en.mobile.listTitle": 20,
    "en.mobile.button": 24,
    "en.mobile.code": 16,
    "gu.desktop.headingXl": 112,
    "gu.desktop.headingL": 88,
    "gu.desktop.headingM": 64,
    "gu.desktop.headingS": 44,
    "gu.desktop.headingXs": 32,
    "gu.desktop.headingXxs": 24,
    "gu.desktop.overline": 16,
    "gu.desktop.bodyL": 28,
    "gu.desktop.bodyLBold": 28,
    "gu.desktop.bodyLLink": 28,
    "gu.desktop.bodyM": 24,
    "gu.desktop.bodyMBold": 24,
    "gu.desktop.bodyMLink": 24,
    "gu.desktop.bodyS": 24,
    "gu.desktop.bodySBold": 24,
    "gu.desktop.bodySLink": 24,
    "gu.desktop.bodyXs": 20,
    "gu.desktop.bodyXsBold": 16,
    "gu.desktop.bodyXsLink": 16,
    "gu.desktop.bodyXxs": 16,
    "gu.desktop.bodyXxsBold": 16,
    "gu.desktop.bodyXxsLink": 16,
    "gu.desktop.body3xs": 14,
    "gu.desktop.body3xsBold": 14,
    "gu.desktop.body3xsLink": 14,
    "gu.desktop.listTitle": 20,
    "gu.desktop.button": 24,
    "gu.desktop.code": 16,
    "gu.mobile.headingXl": 68,
    "gu.mobile.headingL": 52,
    "gu.mobile.headingM": 44,
    "gu.mobile.headingS": 36,
    "gu.mobile.headingXs": 32,
    "gu.mobile.headingXxs": 24,
    "gu.mobile.overline": 16,
    "gu.mobile.bodyL": 32,
    "gu.mobile.bodyLBold": 32,
    "gu.mobile.bodyLLink": 32,
    "gu.mobile.bodyM": 24,
    "gu.mobile.bodyMBold": 24,
    "gu.mobile.bodyMLink": 24,
    "gu.mobile.bodyS": 24,
    "gu.mobile.bodySBold": 24,
    "gu.mobile.bodySLink": 24,
    "gu.mobile.bodyXs": 16,
    "gu.mobile.bodyXsBold": 16,
    "gu.mobile.bodyXsLink": 16,
    "gu.mobile.bodyXxs": 16,
    "gu.mobile.bodyXxsBold": 16,
    "gu.mobile.bodyXxsLink": 16,
    "gu.mobile.body3xs": 14,
    "gu.mobile.body3xsBold": 14,
    "gu.mobile.body3xsLink": 14,
    "gu.mobile.listTitle": 20,
    "gu.mobile.button": 24,
    "gu.mobile.code": 16,
    "hi.desktop.headingXl": 92,
    "hi.desktop.headingL": 68,
    "hi.desktop.headingM": 44,
    "hi.desktop.headingS": 36,
    "hi.desktop.headingXs": 32,
    "hi.desktop.headingXxs": 24,
    "hi.desktop.overline": 16,
    "hi.desktop.bodyL": 28,
    "hi.desktop.bodyLBold": 28,
    "hi.desktop.bodyLLink": 28,
    "hi.desktop.bodyM": 24,
    "hi.desktop.bodyMBold": 24,
    "hi.desktop.bodyMLink": 24,
    "hi.desktop.bodyS": 24,
    "hi.desktop.bodySBold": 24,
    "hi.desktop.bodySLink": 24,
    "hi.desktop.bodyXs": 16,
    "hi.desktop.bodyXsBold": 16,
    "hi.desktop.bodyXsLink": 16,
    "hi.desktop.bodyXxs": 16,
    "hi.desktop.bodyXxsBold": 20,
    "hi.desktop.bodyXxsLink": 16,
    "hi.desktop.body3xs": 14,
    "hi.desktop.body3xsBold": 14,
    "hi.desktop.body3xsLink": 14,
    "hi.desktop.listTitle": 20,
    "hi.desktop.button": 24,
    "hi.desktop.code": 16,
    "hi.mobile.headingXl": 68,
    "hi.mobile.headingL": 52,
    "hi.mobile.headingM": 44,
    "hi.mobile.headingS": 36,
    "hi.mobile.headingXs": 32,
    "hi.mobile.headingXxs": 24,
    "hi.mobile.overline": 16,
    "hi.mobile.bodyL": 32,
    "hi.mobile.bodyLBold": 32,
    "hi.mobile.bodyLLink": 32,
    "hi.mobile.bodyM": 24,
    "hi.mobile.bodyMBold": 24,
    "hi.mobile.bodyMLink": 24,
    "hi.mobile.bodyS": 24,
    "hi.mobile.bodySBold": 24,
    "hi.mobile.bodySLink": 24,
    "hi.mobile.bodyXs": 16,
    "hi.mobile.bodyXsBold": 16,
    "hi.mobile.bodyXsLink": 16,
    "hi.mobile.bodyXxs": 16,
    "hi.mobile.bodyXxsBold": 16,
    "hi.mobile.bodyXxsLink": 16,
    "hi.mobile.body3xs": 14,
    "hi.mobile.body3xsBold": 14,
    "hi.mobile.body3xsLink": 14,
    "hi.mobile.listTitle": 20,
    "hi.mobile.button": 24,
    "hi.mobile.code": 16,
    "kn.desktop.headingXl": 112,
    "kn.desktop.headingL": 88,
    "kn.desktop.headingM": 64,
    "kn.desktop.headingS": 44,
    "kn.desktop.headingXs": 32,
    "kn.desktop.headingXxs": 24,
    "kn.desktop.overline": 16,
    "kn.desktop.bodyL": 28,
    "kn.desktop.bodyLBold": 28,
    "kn.desktop.bodyLLink": 28,
    "kn.desktop.bodyM": 24,
    "kn.desktop.bodyMBold": 24,
    "kn.desktop.bodyMLink": 24,
    "kn.desktop.bodyS": 24,
    "kn.desktop.bodySBold": 24,
    "kn.desktop.bodySLink": 24,
    "kn.desktop.bodyXs": 20,
    "kn.desktop.bodyXsBold": 16,
    "kn.desktop.bodyXsLink": 16,
    "kn.desktop.bodyXxs": 16,
    "kn.desktop.bodyXxsBold": 16,
    "kn.desktop.bodyXxsLink": 16,
    "kn.desktop.body3xs": 14,
    "kn.desktop.body3xsBold": 14,
    "kn.desktop.body3xsLink": 14,
    "kn.desktop.listTitle": 20,
    "kn.desktop.button": 24,
    "kn.desktop.code": 16,
    "kn.mobile.headingXl": 68,
    "kn.mobile.headingL": 52,
    "kn.mobile.headingM": 44,
    "kn.mobile.headingS": 36,
    "kn.mobile.headingXs": 32,
    "kn.mobile.headingXxs": 24,
    "kn.mobile.overline": 16,
    "kn.mobile.bodyL": 32,
    "kn.mobile.bodyLBold": 32,
    "kn.mobile.bodyLLink": 32,
    "kn.mobile.bodyM": 24,
    "kn.mobile.bodyMBold": 24,
    "kn.mobile.bodyMLink": 24,
    "kn.mobile.bodyS": 24,
    "kn.mobile.bodySBold": 24,
    "kn.mobile.bodySLink": 24,
    "kn.mobile.bodyXs": 16,
    "kn.mobile.bodyXsBold": 16,
    "kn.mobile.bodyXsLink": 16,
    "kn.mobile.bodyXxs": 16,
    "kn.mobile.bodyXxsBold": 16,
    "kn.mobile.bodyXxsLink": 16,
    "kn.mobile.body3xs": 14,
    "kn.mobile.body3xsBold": 14,
    "kn.mobile.body3xsLink": 14,
    "kn.mobile.listTitle": 20,
    "kn.mobile.button": 24,
    "kn.mobile.code": 16,
    "ml.desktop.headingXl": 92,
    "ml.desktop.headingL": 68,
    "ml.desktop.headingM": 44,
    "ml.desktop.headingS": 36,
    "ml.desktop.headingXs": 32,
    "ml.desktop.headingXxs": 24,
    "ml.desktop.overline": 16,
    "ml.desktop.bodyL": 28,
    "ml.desktop.bodyLBold": 28,
    "ml.desktop.bodyLLink": 28,
    "ml.desktop.bodyM": 24,
    "ml.desktop.bodyMBold": 24,
    "ml.desktop.bodyMLink": 24,
    "ml.desktop.bodyS": 24,
    "ml.desktop.bodySBold": 24,
    "ml.desktop.bodySLink": 24,
    "ml.desktop.bodyXs": 20,
    "ml.desktop.bodyXsBold": 16,
    "ml.desktop.bodyXsLink": 16,
    "ml.desktop.bodyXxs": 16,
    "ml.desktop.bodyXxsBold": 16,
    "ml.desktop.bodyXxsLink": 16,
    "ml.desktop.body3xs": 14,
    "ml.desktop.body3xsBold": 14,
    "ml.desktop.body3xsLink": 14,
    "ml.desktop.listTitle": 20,
    "ml.desktop.button": 24,
    "ml.desktop.code": 16,
    "ml.mobile.headingXl": 68,
    "ml.mobile.headingL": 52,
    "ml.mobile.headingM": 44,
    "ml.mobile.headingS": 36,
    "ml.mobile.headingXs": 32,
    "ml.mobile.headingXxs": 24,
    "ml.mobile.overline": 16,
    "ml.mobile.bodyL": 32,
    "ml.mobile.bodyLBold": 32,
    "ml.mobile.bodyLLink": 32,
    "ml.mobile.bodyM": 24,
    "ml.mobile.bodyMBold": 24,
    "ml.mobile.bodyMLink": 24,
    "ml.mobile.bodyS": 24,
    "ml.mobile.bodySBold": 24,
    "ml.mobile.bodySLink": 24,
    "ml.mobile.bodyXs": 16,
    "ml.mobile.bodyXsBold": 16,
    "ml.mobile.bodyXsLink": 16,
    "ml.mobile.bodyXxs": 16,
    "ml.mobile.bodyXxsBold": 16,
    "ml.mobile.bodyXxsLink": 16,
    "ml.mobile.body3xs": 14,
    "ml.mobile.body3xsBold": 14,
    "ml.mobile.body3xsLink": 14,
    "ml.mobile.listTitle": 20,
    "ml.mobile.button": 24,
    "ml.mobile.code": 16,
    "mr.desktop.headingXl": 92,
    "mr.desktop.headingL": 68,
    "mr.desktop.headingM": 44,
    "mr.desktop.headingS": 36,
    "mr.desktop.headingXs": 32,
    "mr.desktop.headingXxs": 24,
    "mr.desktop.overline": 16,
    "mr.desktop.bodyL": 28,
    "mr.desktop.bodyLBold": 28,
    "mr.desktop.bodyLLink": 28,
    "mr.desktop.bodyM": 24,
    "mr.desktop.bodyMBold": 24,
    "mr.desktop.bodyMLink": 24,
    "mr.desktop.bodyS": 24,
    "mr.desktop.bodySBold": 24,
    "mr.desktop.bodySLink": 24,
    "mr.desktop.bodyXs": 16,
    "mr.desktop.bodyXsBold": 16,
    "mr.desktop.bodyXsLink": 16,
    "mr.desktop.bodyXxs": 16,
    "mr.desktop.bodyXxsBold": 16,
    "mr.desktop.bodyXxsLink": 16,
    "mr.desktop.body3xs": 14,
    "mr.desktop.body3xsBold": 14,
    "mr.desktop.body3xsLink": 14,
    "mr.desktop.listTitle": 20,
    "mr.desktop.button": 24,
    "mr.desktop.code": 16,
    "mr.mobile.headingXl": 68,
    "mr.mobile.headingL": 52,
    "mr.mobile.headingM": 44,
    "mr.mobile.headingS": 36,
    "mr.mobile.headingXs": 32,
    "mr.mobile.headingXxs": 24,
    "mr.mobile.overline": 16,
    "mr.mobile.bodyL": 32,
    "mr.mobile.bodyLBold": 32,
    "mr.mobile.bodyLLink": 32,
    "mr.mobile.bodyM": 24,
    "mr.mobile.bodyMBold": 24,
    "mr.mobile.bodyMLink": 24,
    "mr.mobile.bodyS": 24,
    "mr.mobile.bodySBold": 24,
    "mr.mobile.bodySLink": 24,
    "mr.mobile.bodyXs": 16,
    "mr.mobile.bodyXsBold": 16,
    "mr.mobile.bodyXsLink": 16,
    "mr.mobile.bodyXxs": 16,
    "mr.mobile.bodyXxsBold": 16,
    "mr.mobile.bodyXxsLink": 16,
    "mr.mobile.body3xs": 14,
    "mr.mobile.body3xsBold": 14,
    "mr.mobile.body3xsLink": 14,
    "mr.mobile.listTitle": 20,
    "mr.mobile.button": 24,
    "mr.mobile.code": 16,
    "or.desktop.headingXl": 92,
    "or.desktop.headingL": 68,
    "or.desktop.headingM": 44,
    "or.desktop.headingS": 36,
    "or.desktop.headingXs": 32,
    "or.desktop.headingXxs": 24,
    "or.desktop.overline": 16,
    "or.desktop.bodyL": 28,
    "or.desktop.bodyLBold": 28,
    "or.desktop.bodyLLink": 28,
    "or.desktop.bodyM": 24,
    "or.desktop.bodyMBold": 24,
    "or.desktop.bodyMLink": 24,
    "or.desktop.bodyS": 24,
    "or.desktop.bodySBold": 24,
    "or.desktop.bodySLink": 24,
    "or.desktop.bodyXs": 16,
    "or.desktop.bodyXsBold": 16,
    "or.desktop.bodyXsLink": 16,
    "or.desktop.bodyXxs": 16,
    "or.desktop.bodyXxsBold": 16,
    "or.desktop.bodyXxsLink": 16,
    "or.desktop.body3xs": 14,
    "or.desktop.body3xsBold": 14,
    "or.desktop.body3xsLink": 14,
    "or.desktop.listTitle": 20,
    "or.desktop.button": 24,
    "or.desktop.code": 16,
    "or.mobile.headingXl": 68,
    "or.mobile.headingL": 52,
    "or.mobile.headingM": 44,
    "or.mobile.headingS": 36,
    "or.mobile.headingXs": 32,
    "or.mobile.headingXxs": 24,
    "or.mobile.overline": 16,
    "or.mobile.bodyL": 32,
    "or.mobile.bodyLBold": 32,
    "or.mobile.bodyLLink": 32,
    "or.mobile.bodyM": 24,
    "or.mobile.bodyMBold": 24,
    "or.mobile.bodyMLink": 24,
    "or.mobile.bodyS": 24,
    "or.mobile.bodySBold": 24,
    "or.mobile.bodySLink": 24,
    "or.mobile.bodyXs": 16,
    "or.mobile.bodyXsBold": 16,
    "or.mobile.bodyXsLink": 16,
    "or.mobile.bodyXxs": 16,
    "or.mobile.bodyXxsBold": 16,
    "or.mobile.bodyXxsLink": 16,
    "or.mobile.body3xs": 14,
    "or.mobile.body3xsBold": 14,
    "or.mobile.body3xsLink": 14,
    "or.mobile.listTitle": 20,
    "or.mobile.button": 24,
    "or.mobile.code": 16,
    "pa.desktop.headingXl": 92,
    "pa.desktop.headingL": 68,
    "pa.desktop.headingM": 44,
    "pa.desktop.headingS": 36,
    "pa.desktop.headingXs": 32,
    "pa.desktop.headingXxs": 24,
    "pa.desktop.overline": 16,
    "pa.desktop.bodyL": 28,
    "pa.desktop.bodyLBold": 28,
    "pa.desktop.bodyLLink": 28,
    "pa.desktop.bodyM": 24,
    "pa.desktop.bodyMBold": 24,
    "pa.desktop.bodyMLink": 24,
    "pa.desktop.bodyS": 24,
    "pa.desktop.bodySBold": 24,
    "pa.desktop.bodySLink": 24,
    "pa.desktop.bodyXs": 20,
    "pa.desktop.bodyXsBold": 16,
    "pa.desktop.bodyXsLink": 16,
    "pa.desktop.bodyXxs": 16,
    "pa.desktop.bodyXxsBold": 16,
    "pa.desktop.bodyXxsLink": 16,
    "pa.desktop.body3xs": 14,
    "pa.desktop.body3xsBold": 14,
    "pa.desktop.body3xsLink": 14,
    "pa.desktop.listTitle": 20,
    "pa.desktop.button": 24,
    "pa.desktop.code": 16,
    "pa.mobile.headingXl": 68,
    "pa.mobile.headingL": 52,
    "pa.mobile.headingM": 44,
    "pa.mobile.headingS": 36,
    "pa.mobile.headingXs": 32,
    "pa.mobile.headingXxs": 24,
    "pa.mobile.overline": 16,
    "pa.mobile.bodyL": 32,
    "pa.mobile.bodyLBold": 32,
    "pa.mobile.bodyLLink": 32,
    "pa.mobile.bodyM": 24,
    "pa.mobile.bodyMBold": 24,
    "pa.mobile.bodyMLink": 24,
    "pa.mobile.bodyS": 24,
    "pa.mobile.bodySBold": 24,
    "pa.mobile.bodySLink": 24,
    "pa.mobile.bodyXs": 16,
    "pa.mobile.bodyXsBold": 16,
    "pa.mobile.bodyXsLink": 16,
    "pa.mobile.bodyXxs": 16,
    "pa.mobile.bodyXxsBold": 16,
    "pa.mobile.bodyXxsLink": 16,
    "pa.mobile.body3xs": 14,
    "pa.mobile.body3xsBold": 14,
    "pa.mobile.body3xsLink": 14,
    "pa.mobile.listTitle": 20,
    "pa.mobile.button": 24,
    "pa.mobile.code": 16,
    "ta.desktop.headingXl": 112,
    "ta.desktop.headingL": 88,
    "ta.desktop.headingM": 64,
    "ta.desktop.headingS": 44,
    "ta.desktop.headingXs": 32,
    "ta.desktop.headingXxs": 24,
    "ta.desktop.overline": 16,
    "ta.desktop.bodyL": 28,
    "ta.desktop.bodyLBold": 28,
    "ta.desktop.bodyLLink": 28,
    "ta.desktop.bodyM": 24,
    "ta.desktop.bodyMBold": 24,
    "ta.desktop.bodyMLink": 24,
    "ta.desktop.bodyS": 24,
    "ta.desktop.bodySBold": 24,
    "ta.desktop.bodySLink": 24,
    "ta.desktop.bodyXs": 16,
    "ta.desktop.bodyXsBold": 16,
    "ta.desktop.bodyXsLink": 16,
    "ta.desktop.bodyXxs": 16,
    "ta.desktop.bodyXxsBold": 16,
    "ta.desktop.bodyXxsLink": 16,
    "ta.desktop.body3xs": 14,
    "ta.desktop.body3xsBold": 14,
    "ta.desktop.body3xsLink": 14,
    "ta.desktop.listTitle": 20,
    "ta.desktop.button": 24,
    "ta.desktop.code": 16,
    "ta.mobile.headingXl": 68,
    "ta.mobile.headingL": 52,
    "ta.mobile.headingM": 44,
    "ta.mobile.headingS": 36,
    "ta.mobile.headingXs": 32,
    "ta.mobile.headingXxs": 24,
    "ta.mobile.overline": 16,
    "ta.mobile.bodyL": 32,
    "ta.mobile.bodyLBold": 32,
    "ta.mobile.bodyLLink": 32,
    "ta.mobile.bodyM": 24,
    "ta.mobile.bodyMBold": 24,
    "ta.mobile.bodyMLink": 24,
    "ta.mobile.bodyS": 24,
    "ta.mobile.bodySBold": 24,
    "ta.mobile.bodySLink": 24,
    "ta.mobile.bodyXs": 20,
    "ta.mobile.bodyXsBold": 16,
    "ta.mobile.bodyXsLink": 16,
    "ta.mobile.bodyXxs": 16,
    "ta.mobile.bodyXxsBold": 16,
    "ta.mobile.bodyXxsLink": 16,
    "ta.mobile.body3xs": 14,
    "ta.mobile.body3xsBold": 14,
    "ta.mobile.body3xsLink": 14,
    "ta.mobile.listTitle": 20,
    "ta.mobile.button": 24,
    "ta.mobile.code": 16,
    "te.desktop.headingXl": 92,
    "te.desktop.headingL": 68,
    "te.desktop.headingM": 44,
    "te.desktop.headingS": 36,
    "te.desktop.headingXs": 32,
    "te.desktop.headingXxs": 24,
    "te.desktop.overline": 16,
    "te.desktop.bodyL": 28,
    "te.desktop.bodyLBold": 28,
    "te.desktop.bodyLLink": 28,
    "te.desktop.bodyM": 24,
    "te.desktop.bodyMBold": 24,
    "te.desktop.bodyMLink": 24,
    "te.desktop.bodyS": 24,
    "te.desktop.bodySBold": 24,
    "te.desktop.bodySLink": 24,
    "te.desktop.bodyXs": 16,
    "te.desktop.bodyXsBold": 16,
    "te.desktop.bodyXsLink": 16,
    "te.desktop.bodyXxs": 16,
    "te.desktop.bodyXxsBold": 16,
    "te.desktop.bodyXxsLink": 16,
    "te.desktop.body3xs": 14,
    "te.desktop.body3xsBold": 14,
    "te.desktop.body3xsLink": 14,
    "te.desktop.listTitle": 20,
    "te.desktop.button": 24,
    "te.desktop.code": 16,
    "te.mobile.headingXl": 68,
    "te.mobile.headingL": 52,
    "te.mobile.headingM": 44,
    "te.mobile.headingS": 36,
    "te.mobile.headingXs": 32,
    "te.mobile.headingXxs": 24,
    "te.mobile.overline": 16,
    "te.mobile.bodyL": 32,
    "te.mobile.bodyLBold": 32,
    "te.mobile.bodyLLink": 32,
    "te.mobile.bodyM": 24,
    "te.mobile.bodyMBold": 24,
    "te.mobile.bodyMLink": 24,
    "te.mobile.bodyS": 24,
    "te.mobile.bodySBold": 24,
    "te.mobile.bodySLink": 24,
    "te.mobile.bodyXs": 16,
    "te.mobile.bodyXsBold": 16,
    "te.mobile.bodyXsLink": 16,
    "te.mobile.bodyXxs": 16,
    "te.mobile.bodyXxsBold": 16,
    "te.mobile.bodyXxsLink": 16,
    "te.mobile.body3xs": 14,
    "te.mobile.body3xsBold": 14,
    "te.mobile.body3xsLink": 14,
    "te.mobile.listTitle": 20,
    "te.mobile.button": 24,
    "te.mobile.code": 16,
    headingXl: $52d4442770cfd938$var$headingXl,
    headingL: $52d4442770cfd938$var$headingL,
    headingM: $52d4442770cfd938$var$headingM,
    headingS: $52d4442770cfd938$var$headingS,
    headingXs: $52d4442770cfd938$var$headingXs,
    headingXxs: $52d4442770cfd938$var$headingXxs,
    overline: $52d4442770cfd938$var$overline$1,
    bodyL: $52d4442770cfd938$var$bodyL,
    bodyLBold: $52d4442770cfd938$var$bodyLBold,
    bodyLLink: $52d4442770cfd938$var$bodyLLink,
    bodyM: $52d4442770cfd938$var$bodyM,
    bodyMBold: $52d4442770cfd938$var$bodyMBold,
    bodyMLink: $52d4442770cfd938$var$bodyMLink,
    bodyS: $52d4442770cfd938$var$bodyS,
    bodySBold: $52d4442770cfd938$var$bodySBold,
    bodySLink: $52d4442770cfd938$var$bodySLink,
    bodyXs: $52d4442770cfd938$var$bodyXs,
    bodyXsBold: $52d4442770cfd938$var$bodyXsBold,
    bodyXsLink: $52d4442770cfd938$var$bodyXsLink,
    bodyXxs: $52d4442770cfd938$var$bodyXxs,
    bodyXxsBold: $52d4442770cfd938$var$bodyXxsBold,
    bodyXxsLink: $52d4442770cfd938$var$bodyXxsLink,
    body3xs: $52d4442770cfd938$var$body3xs,
    body3xsBold: $52d4442770cfd938$var$body3xsBold,
    body3xsLink: $52d4442770cfd938$var$body3xsLink,
    listTitle: $52d4442770cfd938$var$listTitle,
    button: $52d4442770cfd938$var$button,
    code: $52d4442770cfd938$var$code
};
const $52d4442770cfd938$var$custom_1$2 = "85%";
const $52d4442770cfd938$var$custom_2$2 = "80%";
const $52d4442770cfd938$var$opacity = {
    "opacity.invisible": "0%",
    "opacity.disabled": "30%",
    "opacity.enabled": "100%",
    custom_1: $52d4442770cfd938$var$custom_1$2,
    custom_2: $52d4442770cfd938$var$custom_2$2
};
const $52d4442770cfd938$var$paragraphSpacing = {
    "paragraph-spacing.0": "0"
};
const $52d4442770cfd938$var$semantic = {
    "color.bold.default.description": "Used for default focus and disable backgrounds",
    "color.bold.emphasised.description": "Used for hover bg",
    "color.bold.muted.description": "Used as fg on dissabled",
    "color.bold.subtle.description": "Used for the fg on pressed",
    "color.bold.discreet.description": "Used as fg on hover",
    "color.bold.on-bold.description": "Used on the default fg",
    "color.bold.disabled.description": "Used on the default fg"
};
const $52d4442770cfd938$var$shadows = {
    "box-shadow.1.true": "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
    "box-shadow.false": "none"
};
const $52d4442770cfd938$var$xxs$1 = "4";
const $52d4442770cfd938$var$xs$1 = "8";
const $52d4442770cfd938$var$s$1 = "12";
const $52d4442770cfd938$var$base$1 = "16";
const $52d4442770cfd938$var$m$1 = "24";
const $52d4442770cfd938$var$l$1 = "32";
const $52d4442770cfd938$var$xl$1 = "40";
const $52d4442770cfd938$var$xxl$1 = "48";
const $52d4442770cfd938$var$huge$1 = "64";
const $52d4442770cfd938$var$massive$1 = "80";
const $52d4442770cfd938$var$custom_1$1 = "120";
const $52d4442770cfd938$var$custom_2$1 = "44";
const $52d4442770cfd938$var$custom_3$1 = "28";
const $52d4442770cfd938$var$custom_4$1 = "2";
const $52d4442770cfd938$var$custom_5$1 = "1";
const $52d4442770cfd938$var$custom_6$1 = "384";
const $52d4442770cfd938$var$custom_7$1 = "156";
const $52d4442770cfd938$var$custom_8$1 = "300";
const $52d4442770cfd938$var$custom_9$1 = "102";
const $52d4442770cfd938$var$custom_10$1 = "184";
const $52d4442770cfd938$var$custom_11$1 = "56";
const $52d4442770cfd938$var$custom_12$1 = "280";
const $52d4442770cfd938$var$custom_13$1 = "312";
const $52d4442770cfd938$var$custom_14$1 = "384";
const $52d4442770cfd938$var$custom_15$1 = "6";
const $52d4442770cfd938$var$custom_16$1 = "72";
const $52d4442770cfd938$var$custom_17$1 = "560";
const $52d4442770cfd938$var$custom_18$1 = "20";
const $52d4442770cfd938$var$custom_19$1 = "10";
const $52d4442770cfd938$var$custom_20$1 = "9";
const $52d4442770cfd938$var$custom_21$1 = "15";
const $52d4442770cfd938$var$custom_22$1 = "17";
const $52d4442770cfd938$var$custom_23$1 = "7";
const $52d4442770cfd938$var$custom_24$1 = "13";
const $52d4442770cfd938$var$custom_25$1 = "18";
const $52d4442770cfd938$var$custom_26 = "27";
const $52d4442770cfd938$var$custom_27 = "584";
const $52d4442770cfd938$var$custom_28 = "331";
const $52d4442770cfd938$var$custom_29 = "33";
const $52d4442770cfd938$var$custom_30 = "23";
const $52d4442770cfd938$var$custom_31 = "592";
const $52d4442770cfd938$var$sizing = {
    xxs: $52d4442770cfd938$var$xxs$1,
    xs: $52d4442770cfd938$var$xs$1,
    s: $52d4442770cfd938$var$s$1,
    base: $52d4442770cfd938$var$base$1,
    m: $52d4442770cfd938$var$m$1,
    l: $52d4442770cfd938$var$l$1,
    xl: $52d4442770cfd938$var$xl$1,
    xxl: $52d4442770cfd938$var$xxl$1,
    huge: $52d4442770cfd938$var$huge$1,
    massive: $52d4442770cfd938$var$massive$1,
    custom_1: $52d4442770cfd938$var$custom_1$1,
    custom_2: $52d4442770cfd938$var$custom_2$1,
    custom_3: $52d4442770cfd938$var$custom_3$1,
    custom_4: $52d4442770cfd938$var$custom_4$1,
    custom_5: $52d4442770cfd938$var$custom_5$1,
    custom_6: $52d4442770cfd938$var$custom_6$1,
    custom_7: $52d4442770cfd938$var$custom_7$1,
    custom_8: $52d4442770cfd938$var$custom_8$1,
    custom_9: $52d4442770cfd938$var$custom_9$1,
    custom_10: $52d4442770cfd938$var$custom_10$1,
    custom_11: $52d4442770cfd938$var$custom_11$1,
    custom_12: $52d4442770cfd938$var$custom_12$1,
    custom_13: $52d4442770cfd938$var$custom_13$1,
    custom_14: $52d4442770cfd938$var$custom_14$1,
    custom_15: $52d4442770cfd938$var$custom_15$1,
    custom_16: $52d4442770cfd938$var$custom_16$1,
    custom_17: $52d4442770cfd938$var$custom_17$1,
    custom_18: $52d4442770cfd938$var$custom_18$1,
    custom_19: $52d4442770cfd938$var$custom_19$1,
    custom_20: $52d4442770cfd938$var$custom_20$1,
    custom_21: $52d4442770cfd938$var$custom_21$1,
    custom_22: $52d4442770cfd938$var$custom_22$1,
    custom_23: $52d4442770cfd938$var$custom_23$1,
    custom_24: $52d4442770cfd938$var$custom_24$1,
    custom_25: $52d4442770cfd938$var$custom_25$1,
    custom_26: $52d4442770cfd938$var$custom_26,
    custom_27: $52d4442770cfd938$var$custom_27,
    custom_28: $52d4442770cfd938$var$custom_28,
    custom_29: $52d4442770cfd938$var$custom_29,
    custom_30: $52d4442770cfd938$var$custom_30,
    custom_31: $52d4442770cfd938$var$custom_31
};
const $52d4442770cfd938$var$xxs = "4";
const $52d4442770cfd938$var$xs = "8";
const $52d4442770cfd938$var$s = "12";
const $52d4442770cfd938$var$base = "16";
const $52d4442770cfd938$var$m = "24";
const $52d4442770cfd938$var$l = "32";
const $52d4442770cfd938$var$xl = "40";
const $52d4442770cfd938$var$xxl = "48";
const $52d4442770cfd938$var$huge = "64";
const $52d4442770cfd938$var$massive = "80";
const $52d4442770cfd938$var$custom_1 = "1";
const $52d4442770cfd938$var$stepper_horizontal = "{$platform.stepper_horizontal}";
const $52d4442770cfd938$var$custom_2 = "11";
const $52d4442770cfd938$var$custom_3 = "128";
const $52d4442770cfd938$var$custom_4 = "2";
const $52d4442770cfd938$var$custom_5 = "0";
const $52d4442770cfd938$var$custom_6 = "84";
const $52d4442770cfd938$var$custom_7 = "88";
const $52d4442770cfd938$var$custom_8 = "42";
const $52d4442770cfd938$var$custom_9 = "10";
const $52d4442770cfd938$var$custom_10 = "38";
const $52d4442770cfd938$var$custom_11 = "26";
const $52d4442770cfd938$var$custom_12 = "30";
const $52d4442770cfd938$var$custom_13 = "22";
const $52d4442770cfd938$var$custom_14 = "28";
const $52d4442770cfd938$var$custom_15 = "20";
const $52d4442770cfd938$var$custom_16 = "3";
const $52d4442770cfd938$var$custom_17 = "5";
const $52d4442770cfd938$var$custom_18 = "6";
const $52d4442770cfd938$var$custom_19 = "56";
const $52d4442770cfd938$var$custom_20 = "46";
const $52d4442770cfd938$var$custom_21 = "110";
const $52d4442770cfd938$var$custom_22 = "114";
const $52d4442770cfd938$var$custom_23 = "15";
const $52d4442770cfd938$var$custom_24 = "31";
const $52d4442770cfd938$var$custom_25 = "17";
const $52d4442770cfd938$var$bottomsheet_padding_right = "90";
const $52d4442770cfd938$var$spacing = {
    xxs: $52d4442770cfd938$var$xxs,
    xs: $52d4442770cfd938$var$xs,
    s: $52d4442770cfd938$var$s,
    base: $52d4442770cfd938$var$base,
    m: $52d4442770cfd938$var$m,
    l: $52d4442770cfd938$var$l,
    xl: $52d4442770cfd938$var$xl,
    xxl: $52d4442770cfd938$var$xxl,
    huge: $52d4442770cfd938$var$huge,
    massive: $52d4442770cfd938$var$massive,
    custom_1: $52d4442770cfd938$var$custom_1,
    "desktop.stepper_horizontal": "{massive}",
    "tablet.stepper_horizontal": "{m}",
    "mobile.stepper_horizontal": "{m}",
    stepper_horizontal: $52d4442770cfd938$var$stepper_horizontal,
    custom_2: $52d4442770cfd938$var$custom_2,
    custom_3: $52d4442770cfd938$var$custom_3,
    custom_4: $52d4442770cfd938$var$custom_4,
    custom_5: $52d4442770cfd938$var$custom_5,
    custom_6: $52d4442770cfd938$var$custom_6,
    custom_7: $52d4442770cfd938$var$custom_7,
    custom_8: $52d4442770cfd938$var$custom_8,
    custom_9: $52d4442770cfd938$var$custom_9,
    custom_10: $52d4442770cfd938$var$custom_10,
    custom_11: $52d4442770cfd938$var$custom_11,
    custom_12: $52d4442770cfd938$var$custom_12,
    custom_13: $52d4442770cfd938$var$custom_13,
    custom_14: $52d4442770cfd938$var$custom_14,
    custom_15: $52d4442770cfd938$var$custom_15,
    custom_16: $52d4442770cfd938$var$custom_16,
    custom_17: $52d4442770cfd938$var$custom_17,
    custom_18: $52d4442770cfd938$var$custom_18,
    custom_19: $52d4442770cfd938$var$custom_19,
    custom_20: $52d4442770cfd938$var$custom_20,
    custom_21: $52d4442770cfd938$var$custom_21,
    custom_22: $52d4442770cfd938$var$custom_22,
    custom_23: $52d4442770cfd938$var$custom_23,
    custom_24: $52d4442770cfd938$var$custom_24,
    custom_25: $52d4442770cfd938$var$custom_25,
    bottomsheet_padding_right: $52d4442770cfd938$var$bottomsheet_padding_right
};
const $52d4442770cfd938$var$overline = "{$lang.$platform.overline}";
const $52d4442770cfd938$var$textCase = {
    "text-case.none": "none",
    "text-case.uppercase": "uppercase",
    "text-case.lowercase": "lowercase",
    "text-case.capitalize": "capitalize",
    "as.desktop.overline": "uppercase",
    "as.mobile.overline": "uppercase",
    "bn.desktop.overline": "uppercase",
    "bn.mobile.overline": "uppercase",
    "en.desktop.overline": "uppercase",
    "en.mobile.overline": "uppercase",
    "gu.desktop.overline": "uppercase",
    "gu.mobile.overline": "uppercase",
    "hi.desktop.overline": "uppercase",
    "hi.mobile.overline": "uppercase",
    "kn.desktop.overline": "uppercase",
    "kn.mobile.overline": "uppercase",
    "ml.desktop.overline": "uppercase",
    "mr.desktop.overline": "uppercase",
    "mr.mobile.overline": "uppercase",
    "or.desktop.overline": "uppercase",
    "pa.desktop.overline": "uppercase",
    "pa.mobile.overline": "uppercase",
    "ta.desktop.overline": "uppercase",
    "ta.mobile.overline": "uppercase",
    "te.desktop.overline": "uppercase",
    "te.mobile.overline": "uppercase",
    overline: $52d4442770cfd938$var$overline
};
const $52d4442770cfd938$var$textDecoration = {
    "text-decoration.none": "none",
    "text-decoration.underline": "underline",
    "text-decoration.line-through": "line-through",
    "text-decoration.overline": "overline",
    "max.lines.1": "1",
    "text-overflow.ellipsis": "ellipsis"
};
const $52d4442770cfd938$var$easeRapid = "0.35, 0, 0.5, 1";
const $52d4442770cfd938$var$easeQuick = "0.35, 0, 0.25, 1";
const $52d4442770cfd938$var$easeJoyful = "0.35, 1.3, 0.3, 1";
const $52d4442770cfd938$var$easeEntrance = "0, 0, 0.1, 1";
const $52d4442770cfd938$var$easeExit = "0.35, 0, 0.8, 1";
const $52d4442770cfd938$var$easeJoyfulEntrance = "0.15, 1.3, 0.3, 1";
const $52d4442770cfd938$var$easeJoyfulExit = "0.7, -0.1, 0.6, 0.1";
const $52d4442770cfd938$var$easeJoyfulentrance = "0.15, 1.3, 0.3, 1";
const $52d4442770cfd938$var$easeJoyfulexit = "0.7, -0.1, 0.6, 0.1";
const $52d4442770cfd938$var$transitions = {
    easeRapid: $52d4442770cfd938$var$easeRapid,
    easeQuick: $52d4442770cfd938$var$easeQuick,
    easeJoyful: $52d4442770cfd938$var$easeJoyful,
    easeEntrance: $52d4442770cfd938$var$easeEntrance,
    easeExit: $52d4442770cfd938$var$easeExit,
    easeJoyfulEntrance: $52d4442770cfd938$var$easeJoyfulEntrance,
    easeJoyfulExit: $52d4442770cfd938$var$easeJoyfulExit,
    easeJoyfulentrance: $52d4442770cfd938$var$easeJoyfulentrance,
    easeJoyfulexit: $52d4442770cfd938$var$easeJoyfulexit
};
const $52d4442770cfd938$var$rapid = "300";
const $52d4442770cfd938$var$medium = "500";
const $52d4442770cfd938$var$slow = "1000";
const $52d4442770cfd938$var$transitionsDuration = {
    rapid: $52d4442770cfd938$var$rapid,
    medium: $52d4442770cfd938$var$medium,
    slow: $52d4442770cfd938$var$slow
};
const $52d4442770cfd938$var$typography = {};
const $52d4442770cfd938$export$6ad93df59e712c43 = {
    tokens: {
        borderRadius: $52d4442770cfd938$var$borderRadius,
        borderWidth: $52d4442770cfd938$var$borderWidth,
        color: $52d4442770cfd938$var$color,
        fontFamilies: $52d4442770cfd938$var$fontFamilies,
        fontSizes: $52d4442770cfd938$var$fontSizes,
        fontWeights: $52d4442770cfd938$var$fontWeights,
        letterSpacing: $52d4442770cfd938$var$letterSpacing,
        lineHeights: $52d4442770cfd938$var$lineHeights,
        opacity: $52d4442770cfd938$var$opacity,
        paragraphSpacing: $52d4442770cfd938$var$paragraphSpacing,
        semantic: $52d4442770cfd938$var$semantic,
        sizing: $52d4442770cfd938$var$sizing,
        spacing: $52d4442770cfd938$var$spacing,
        textCase: $52d4442770cfd938$var$textCase,
        textDecoration: $52d4442770cfd938$var$textDecoration,
        typography: $52d4442770cfd938$var$typography,
        layout: $52d4442770cfd938$var$layout,
        shadows: $52d4442770cfd938$var$shadows,
        transitions: $52d4442770cfd938$var$transitions,
        transitionsDuration: $52d4442770cfd938$var$transitionsDuration
    },
    getComponentTokens: $52d4442770cfd938$var$getComponentTokens
};
const $52d4442770cfd938$var$accordionlist_base_container_width = "{size.max}";
const $52d4442770cfd938$var$AccordionListTokens = {
    "accordionlist_base_root-container_flex-direction": "{flexDirection.column}",
    "accordionlist_base_root-container_width": "{size.max}",
    "accordionlist_base_container_flex-direction": "{flexDirection.column}",
    accordionlist_base_container_width: $52d4442770cfd938$var$accordionlist_base_container_width
};
const $52d4442770cfd938$var$avatar_base_container_width$1 = "{xl}";
const $52d4442770cfd938$var$avatar_base_container_height$1 = "{xl}";
const $52d4442770cfd938$var$avatar_variant_size_small_container_width$1 = "{l}";
const $52d4442770cfd938$var$avatar_variant_size_small_container_height$1 = "{l}";
const $52d4442770cfd938$var$avatar_variant_size_large_container_width$1 = "{xxl}";
const $52d4442770cfd938$var$avatar_variant_size_large_container_height$1 = "{xxl}";
const $52d4442770cfd938$var$avatar_base_container_opacity$1 = "{opacity.enabled}";
const $52d4442770cfd938$var$avatar_variant_disabled_true_container_opacity$1 = "{opacity.disabled}";
const $52d4442770cfd938$var$avatar_combination_true_image_container_behavior_hover_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$avatar_combination_true_image_container_behavior_focus_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$AvatarTokens = {
    avatar_base_container_width: $52d4442770cfd938$var$avatar_base_container_width$1,
    avatar_base_container_height: $52d4442770cfd938$var$avatar_base_container_height$1,
    "avatar_base_container_flex-direction": "{flexDirection.row}",
    "avatar_base_container_justify-content": "{justifyContent.center}",
    "avatar_base_container_align-items": "{alignItems.center}",
    "avatar_base_container_background-color": "{primary20}",
    "avatar_base_container_border-radius": "{pill}",
    "avatar_base_container_border-width": "{border_none}",
    "avatar_base_container_border-color": "{primary80}",
    "avatar_variant_size_xtra-small_container_width": "{m}",
    "avatar_variant_size_xtra-small_container_height": "{m}",
    avatar_variant_size_small_container_width: $52d4442770cfd938$var$avatar_variant_size_small_container_width$1,
    avatar_variant_size_small_container_height: $52d4442770cfd938$var$avatar_variant_size_small_container_height$1,
    avatar_variant_size_large_container_width: $52d4442770cfd938$var$avatar_variant_size_large_container_width$1,
    avatar_variant_size_large_container_height: $52d4442770cfd938$var$avatar_variant_size_large_container_height$1,
    "avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
    "avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
    avatar_base_container_opacity: $52d4442770cfd938$var$avatar_base_container_opacity$1,
    avatar_variant_disabled_true_container_opacity: $52d4442770cfd938$var$avatar_variant_disabled_true_container_opacity$1,
    "avatar_variant_kind_initials_container_background-color": "{sparkle20}",
    "avatar_combination_true_icon_container_behavior_focus_border-width": "{border_focus}",
    "avatar_combination_true_initials_container_behavior_hover_background-color": "{sparkle40}",
    "avatar_combination_true_initials_container_behavior_focus_border-width": "{border_focus}",
    "avatar_combination_true_initials_container_behavior_focus_background-color": "{sparkle40}",
    avatar_combination_true_image_container_behavior_hover_opacity: $52d4442770cfd938$var$avatar_combination_true_image_container_behavior_hover_opacity,
    "avatar_combination_true_image_container_behavior_focus_border-width": "{border_focus}",
    avatar_combination_true_image_container_behavior_focus_opacity: $52d4442770cfd938$var$avatar_combination_true_image_container_behavior_focus_opacity
};
const $52d4442770cfd938$var$avatar_base_container_width = "{xl}";
const $52d4442770cfd938$var$avatar_base_container_height = "{xl}";
const $52d4442770cfd938$var$avatar_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$avatar_base_icon_size = "{custom_3}";
const $52d4442770cfd938$var$avatar_base_icon_color = "{primary60}";
const $52d4442770cfd938$var$avatar_base_icon_behavior_hover_color = "{primary50}";
const $52d4442770cfd938$var$avatar_base_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$avatar_variant_size_small_container_width = "{l}";
const $52d4442770cfd938$var$avatar_variant_size_small_container_height = "{l}";
const $52d4442770cfd938$var$avatar_variant_size_large_container_width = "{xxl}";
const $52d4442770cfd938$var$avatar_variant_size_large_container_height = "{xxl}";
const $52d4442770cfd938$var$avatar_variant_size_small_icon_size = "{m}";
const $52d4442770cfd938$var$avatar_variant_size_large_icon_size = "{l}";
const $52d4442770cfd938$var$avatar_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$avatar_variant_kind_image_jds_image_behavior_hover_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$avatar_variant_kind_image_jds_image_behavior_active_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$AvatarV2DefaultTokens = {
    avatar_base_container_width: $52d4442770cfd938$var$avatar_base_container_width,
    avatar_base_container_height: $52d4442770cfd938$var$avatar_base_container_height,
    "avatar_base_container_flex-direction": "{flexDirection.row}",
    "avatar_base_container_justify-content": "{justifyContent.center}",
    "avatar_base_container_align-items": "{alignItems.center}",
    "avatar_base_container_background-color": "{primary20}",
    "avatar_base_container_border-radius": "{pill}",
    "avatar_base_container_border-width": "{border_none}",
    "avatar_base_container_border-color": "{primary60}",
    avatar_base_container_opacity: $52d4442770cfd938$var$avatar_base_container_opacity,
    "avatar_base_container_behavior_active_background-color": "{primary30}",
    "avatar_base_container_behavior_focus_border-width": "{border_focus}",
    avatar_base_icon_size: $52d4442770cfd938$var$avatar_base_icon_size,
    avatar_base_icon_color: $52d4442770cfd938$var$avatar_base_icon_color,
    avatar_base_icon_behavior_hover_color: $52d4442770cfd938$var$avatar_base_icon_behavior_hover_color,
    avatar_base_icon_behavior_active_color: $52d4442770cfd938$var$avatar_base_icon_behavior_active_color,
    "avatar_variant_size_xtra-small_container_width": "{m}",
    "avatar_variant_size_xtra-small_container_height": "{m}",
    avatar_variant_size_small_container_width: $52d4442770cfd938$var$avatar_variant_size_small_container_width,
    avatar_variant_size_small_container_height: $52d4442770cfd938$var$avatar_variant_size_small_container_height,
    avatar_variant_size_large_container_width: $52d4442770cfd938$var$avatar_variant_size_large_container_width,
    avatar_variant_size_large_container_height: $52d4442770cfd938$var$avatar_variant_size_large_container_height,
    "avatar_variant_size_xtra-large_container_width": "{custom_11}",
    "avatar_variant_size_xtra-large_container_height": "{custom_11}",
    "avatar_variant_size_xtra-xtra-large_container_width": "{custom_1}",
    "avatar_variant_size_xtra-xtra-large_container_height": "{custom_1}",
    "avatar_variant_size_xtra-small_icon_size": "{base}",
    avatar_variant_size_small_icon_size: $52d4442770cfd938$var$avatar_variant_size_small_icon_size,
    avatar_variant_size_large_icon_size: $52d4442770cfd938$var$avatar_variant_size_large_icon_size,
    "avatar_variant_size_xtra-large_icon_size": "{xl}",
    "avatar_variant_size_xtra-xtra-large_icon_size": "{xxl}",
    avatar_variant_disabled_true_container_opacity: $52d4442770cfd938$var$avatar_variant_disabled_true_container_opacity,
    "avatar_variant_kind_initials_container_background-color": "{sparkle20}",
    avatar_variant_kind_image_jds_image_behavior_hover_opacity: $52d4442770cfd938$var$avatar_variant_kind_image_jds_image_behavior_hover_opacity,
    "avatar_variant_kind_image_container_behavior_hover_background-color": "{primaryBackground}",
    avatar_variant_kind_image_jds_image_behavior_active_opacity: $52d4442770cfd938$var$avatar_variant_kind_image_jds_image_behavior_active_opacity,
    "avatar_variant_kind_image_container_behavior_active_background-color": "{primaryGrey80}"
};
const $52d4442770cfd938$var$actionbutton_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$actionbutton_base_loader_color = "{primary50}";
const $52d4442770cfd938$var$actionbutton_base_loader_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$actionbutton_base_loader_size = "{m}";
const $52d4442770cfd938$var$actionbutton_variant_size_small_loader_size = "{m}";
const $52d4442770cfd938$var$actionbutton_variant_size_large_loader_size = "{m}";
const $52d4442770cfd938$var$actionbutton_variant_state_loading_jds_text_opacity = "{opacity.invisible}";
const $52d4442770cfd938$var$actionbutton_combination_false_small_loader_size = "{base}";
const $52d4442770cfd938$var$actionbutton_combination_false_large_loader_size = "{m}";
const $52d4442770cfd938$var$actionbutton_combination_true_true_container_width = "{size.max}";
const $52d4442770cfd938$var$ActionButtonTokens = {
    "actionbutton_base_container_background-color": "{global.transparent}",
    actionbutton_base_container_opacity: $52d4442770cfd938$var$actionbutton_base_container_opacity,
    "actionbutton_base_container_flex-direction": "{flexDirection.stack}",
    "actionbutton_base_container_align-items": "{alignItems.center}",
    "actionbutton_base_container_justify-content": "{justifyContent.center}",
    "actionbutton_base_container_border-radius": "{pill}",
    "actionbutton_base_inner-container_background-color": "{primary50}",
    "actionbutton_base_inner-container_flex-direction": "{flexDirection.row}",
    "actionbutton_base_inner-container_align-items": "{alignItems.center}",
    "actionbutton_base_inner-container_justify-content": "{justifyContent.center}",
    "actionbutton_base_inner-container_border-radius": "{pill}",
    "actionbutton_base_inner-container_padding-top": "{xs}",
    "actionbutton_base_inner-container_padding-right": "{base}",
    "actionbutton_base_inner-container_padding-bottom": "{xs}",
    "actionbutton_base_inner-container_padding-left": "{base}",
    "actionbutton_base_inner-container_gap": "{xs}",
    "actionbutton_base_inner-container_behavior_hover_background-color": "{primary30}",
    "actionbutton_base_inner-container_behavior_active_background-color": "{primary60}",
    "actionbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_base_inner-container_behavior_focus_border-color": "{primary60}",
    actionbutton_base_loader_color: $52d4442770cfd938$var$actionbutton_base_loader_color,
    "actionbutton_base_loader_background-color": "{global.transparent}",
    "actionbutton_base_loader_track-color": "{primaryGrey40}",
    "actionbutton_base_loader_border-width": "{border_focus}",
    "actionbutton_base_inner-container_border-width": "{border_none}",
    actionbutton_base_loader_opacity: $52d4442770cfd938$var$actionbutton_base_loader_opacity,
    actionbutton_base_loader_size: $52d4442770cfd938$var$actionbutton_base_loader_size,
    "actionbutton_base_left-icon_size": "{m}",
    "actionbutton_base_left-icon_color": "{primaryInverse}",
    "actionbutton_base_left-icon_behavior_hover_color": "{primary70}",
    "actionbutton_base_left-icon_behavior_active_color": "{primaryInverse}",
    "actionbutton_base_right-icon_size": "{m}",
    "actionbutton_base_right-icon_color": "{primaryInverse}",
    "actionbutton_base_right-icon_behavior_hover_color": "{primary70}",
    "actionbutton_base_right-icon_behavior_active_color": "{primaryInverse}",
    "actionbutton_variant_size_small_inner-container_padding-top": "{xxs}",
    "actionbutton_variant_size_small_inner-container_padding-right": "{s}",
    "actionbutton_variant_size_small_inner-container_padding-bottom": "{xxs}",
    "actionbutton_variant_size_small_inner-container_padding-left": "{s}",
    "actionbutton_variant_size_small_inner-container_gap": "{xxs}",
    "actionbutton_variant_size_small_left-icon_size": "{base}",
    "actionbutton_variant_size_small_right-icon_size": "{base}",
    actionbutton_variant_size_small_loader_size: $52d4442770cfd938$var$actionbutton_variant_size_small_loader_size,
    "actionbutton_variant_size_large_inner-container_padding-top": "{s}",
    "actionbutton_variant_size_large_inner-container_padding-left": "{m}",
    "actionbutton_variant_size_large_inner-container_padding-bottom": "{s}",
    "actionbutton_variant_size_large_inner-container_padding-right": "{m}",
    "actionbutton_variant_size_large_inner-container_gap": "{xs}",
    "actionbutton_variant_size_large_left-icon_size": "{m}",
    "actionbutton_variant_size_large_right-icon_size": "{m}",
    actionbutton_variant_size_large_loader_size: $52d4442770cfd938$var$actionbutton_variant_size_large_loader_size,
    "actionbutton_variant_size_extra-large_inner-container_padding-top": "{base}",
    "actionbutton_variant_size_extra-large_inner-container_padding-right": "{l}",
    "actionbutton_variant_size_extra-large_inner-container_padding-bottom": "{base}",
    "actionbutton_variant_size_extra-large_inner-container_padding-left": "{l}",
    "actionbutton_variant_size_extra-large_inner-container_gap": "{xs}",
    "actionbutton_variant_size_extra-large_left-icon_size": "{l}",
    "actionbutton_variant_size_extra-large_right-icon_size": "{l}",
    "actionbutton_variant_size_extra-large_loader_size": "{xxl}",
    "actionbutton_variant_state_loading_inner-container_opacity": "{opacity.disabled}",
    "actionbutton_variant_state_loading_left-icon_opacity": "{opacity.invisible}",
    "actionbutton_variant_state_loading_right-icon_opacity": "{opacity.invisible}",
    actionbutton_variant_state_loading_jds_text_opacity: $52d4442770cfd938$var$actionbutton_variant_state_loading_jds_text_opacity,
    "actionbutton_variant_state_disabled_inner-container_opacity": "{opacity.disabled}",
    "actionbutton_base_inner-container_opacity": "{opacity.enabled}",
    "actionbutton_combination_normal_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_normal_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_normal_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_normal_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_behavior_hover_color": "{primary60}",
    "actionbutton_combination_normal_secondary_left-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_secondary_right-icon_color": "{primary60}",
    "actionbutton_combination_normal_secondary_right-icon_behavior_hover_color": "{primary60}",
    "actionbutton_combination_normal_secondary_right-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_normal_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_positive_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_positive_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_normal_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-radius": "{custom_1}",
    "actionbutton_combination_normal_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_normal_tertiary_left-icon_color": "{primary60}",
    "actionbutton_combination_normal_tertiary_left-icon_behavior_hover_color": "{primary50}",
    "actionbutton_combination_normal_tertiary_left-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_normal_tertiary_right-icon_color": "{primary60}",
    "actionbutton_combination_normal_tertiary_right-icon_behavior_hover_color": "{primary50}",
    "actionbutton_combination_normal_tertiary_right-icon_behavior_active_color": "{primary70}",
    "actionbutton_combination_positive_primary_inner-container_background-color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_primary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_primary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_primary_left-icon_color": "{global.white}",
    "actionbutton_combination_positive_primary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_primary_right-icon_color": "{global.white}",
    "actionbutton_combination_positive_primary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_primary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_positive_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_positive_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_secondary_left-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_left-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_secondary_right-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_right-icon_behavior_hover_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_secondary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_positive_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_positive_tertiary_inner-container_border-radius": "{custom_1}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_hover_background-color": "{feedbackSuccess20}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_active_background-color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_positive_tertiary_left-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_left-icon_behavior_hover_color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_positive_tertiary_right-icon_color": "{feedbackSuccess80}",
    "actionbutton_combination_positive_tertiary_right-icon_behavior_hover_color": "{feedbackSuccess50}",
    "actionbutton_combination_positive_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_negative_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_negative_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_negative_primary_inner-container_background-color": "{feedbackError50}",
    "actionbutton_combination_negative_primary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_primary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_primary_left-icon_color": "{global.white}",
    "actionbutton_combination_negative_primary_left-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_primary_right-icon_color": "{global.white}",
    "actionbutton_combination_negative_primary_right-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_primary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_negative_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_negative_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_secondary_left-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_left-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_left-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_secondary_right-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_right-icon_behavior_hover_color": "{feedbackError80}",
    "actionbutton_combination_negative_secondary_right-icon_behavior_active_color": "{primaryBackground}",
    "actionbutton_combination_negative_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_negative_tertiary_inner-container_border-radius": "{pill}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_hover_background-color": "{feedbackError20}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_active_background-color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_inner-container_behavior_focus_border-color": "{primary60}",
    "actionbutton_combination_negative_tertiary_left-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_left-icon_behavior_hover_color": "{feedbackError50}",
    "actionbutton_combination_negative_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_negative_tertiary_right-icon_color": "{feedbackError80}",
    "actionbutton_combination_negative_tertiary_right-icon_behavior_hover_color": "{feedbackError50}",
    "actionbutton_combination_negative_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_inner-container_padding-left": "{custom_5}",
    "actionbutton_combination_contrast_tertiary_inner-container_padding-right": "{custom_5}",
    "actionbutton_combination_contrast_primary_inner-container_background-color": "{primaryBackground}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_primary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_primary_left-icon_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_primary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_contrast_secondary_inner-container_border-width": "{border_thin}",
    "actionbutton_combination_contrast_secondary_inner-container_border-color": "{primaryGrey60}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_contrast_secondary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_secondary_left-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_secondary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_right-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_secondary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_secondary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_inner-container_background-color": "{global.transparent}",
    "actionbutton_combination_contrast_tertiary_inner-container_border-radius": "{pill}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_hover_background-color": "{primary20}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_active_background-color": "{primary30}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-width": "{border_focus}",
    "actionbutton_combination_contrast_tertiary_inner-container_behavior_focus_border-color": "{primary50}",
    "actionbutton_combination_contrast_tertiary_left-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_tertiary_left-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_left-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_right-icon_color": "{primaryBackground}",
    "actionbutton_combination_contrast_tertiary_right-icon_behavior_hover_color": "{primaryGrey100}",
    "actionbutton_combination_contrast_tertiary_right-icon_behavior_active_color": "{primaryGrey100}",
    "actionbutton_combination_false_small_left-icon_size": "{base}",
    actionbutton_combination_false_small_loader_size: $52d4442770cfd938$var$actionbutton_combination_false_small_loader_size,
    "actionbutton_combination_false_large_left-icon_size": "{m}",
    actionbutton_combination_false_large_loader_size: $52d4442770cfd938$var$actionbutton_combination_false_large_loader_size,
    "actionbutton_combination_false_extra-large_left-icon_size": "{l}",
    "actionbutton_combination_false_extra-large_loader_size": "{l}",
    actionbutton_combination_true_true_container_width: $52d4442770cfd938$var$actionbutton_combination_true_true_container_width,
    "actionbutton_combination_true_true_inner-container_width": "{size.max}"
};
const $52d4442770cfd938$var$accordion_base_container_width = "{size.max}";
const $52d4442770cfd938$var$accordion_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$accordion_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$accordion_combination_plus_true_jds_button_icon = "ic_minus";
const $52d4442770cfd938$var$accordion_combination_plus_false_jds_button_icon = "ic_add";
const $52d4442770cfd938$var$accordion_combination_chevron_true_jds_button_icon = "ic_chevron_up";
const $52d4442770cfd938$var$accordion_combination_chevron_false_jds_button_icon = "ic_chevron_down";
const $52d4442770cfd938$var$AccordionTokens = {
    "accordion_base_container_flex-direction": "{flexDirection.column}",
    accordion_base_container_width: $52d4442770cfd938$var$accordion_base_container_width,
    "accordion_base_accordion-header-container_flex-direction": "{flexDirection.row}",
    "accordion_base_accordion-header-container_align-items": "{alignItems.center}",
    "accordion_base_accordion-header-container_justify-content": "{justifyContent.start}",
    "accordion_base_accordion-header-container_width": "{size.max}",
    "accordion_base_accordion-header-container_padding-top": "{xxs}",
    "accordion_base_accordion-header-container_gap": "{s}",
    "accordion_base_text-container_flex-direction": "{flexDirection.column}",
    "accordion_base_text-container_justify-content": "{justifyContent.start}",
    "accordion_base_text-container_align-items": "{alignItems.start}",
    "accordion_base_text-container_gap": "{xxs}",
    "accordion_base_children-container_padding-top": "0",
    "accordion_base_children-container_width": "{size.max}",
    "accordion_base_child-content-container_width": "{size.max}",
    accordion_base_container_opacity: $52d4442770cfd938$var$accordion_base_container_opacity,
    "accordion_variant_expandedPanel_true_children-container_padding-top": "{base}",
    accordion_variant_disabled_true_container_opacity: $52d4442770cfd938$var$accordion_variant_disabled_true_container_opacity,
    accordion_combination_plus_true_jds_button_icon: $52d4442770cfd938$var$accordion_combination_plus_true_jds_button_icon,
    accordion_combination_plus_false_jds_button_icon: $52d4442770cfd938$var$accordion_combination_plus_false_jds_button_icon,
    accordion_combination_chevron_true_jds_button_icon: $52d4442770cfd938$var$accordion_combination_chevron_true_jds_button_icon,
    accordion_combination_chevron_false_jds_button_icon: $52d4442770cfd938$var$accordion_combination_chevron_false_jds_button_icon
};
const $52d4442770cfd938$var$badge_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$badge_base_icon_size = "{base}";
const $52d4442770cfd938$var$badge_base_icon_color = "{sparkleGrey20}";
const $52d4442770cfd938$var$badge_base_text_color = "{sparkleGrey20}";
const $52d4442770cfd938$var$badge_variant_kind_service_container_gap = "{xs}";
const $52d4442770cfd938$var$badge_variant_kind_service_text_color = "{global.white}";
const $52d4442770cfd938$var$badge_variant_kind_service_icon_size = "{m}";
const $52d4442770cfd938$var$badge_variant_kind_service_icon_color = "{custom_color_1}";
const $52d4442770cfd938$var$badge_combination_normal_small_icon_size = "{s}";
const $52d4442770cfd938$var$badge_combination_normal_large_container_gap = "{xs}";
const $52d4442770cfd938$var$badge_combination_normal_large_icon_size = "{m}";
const $52d4442770cfd938$var$BadgeTokens = {
    "badge_base_container_flex-direction": "{flexDirection.row}",
    "badge_base_container_justify-content": "{justifyContent.center}",
    "badge_base_container_align-items": "{alignItems.center}",
    "badge_base_container_padding-top": "{xxs}",
    "badge_base_container_padding-left": "{xs}",
    "badge_base_container_padding-right": "{xs}",
    "badge_base_container_padding-bottom": "{xxs}",
    badge_base_container_gap: $52d4442770cfd938$var$badge_base_container_gap,
    "badge_base_container_background-color": "{sparkle60}",
    "badge_base_container_border-radius": "{medium}",
    badge_base_icon_size: $52d4442770cfd938$var$badge_base_icon_size,
    badge_base_icon_color: $52d4442770cfd938$var$badge_base_icon_color,
    "badge_base_icon_justify-content": "{justifyContent.start}",
    "badge_base_icon_align-items": "{alignItems.start}",
    "badge_base_text_font-family": "{bodySBold}",
    "badge_base_text_font-size": "{bodySBold}",
    "badge_base_text_line-height": "{bodySBold}",
    "badge_base_text_letter-spacing": "{bodySBold}",
    "badge_base_text_font-weight": "{bodySBold}",
    badge_base_text_color: $52d4442770cfd938$var$badge_base_text_color,
    "badge_base_text_text-transform": "{text-case.uppercase}",
    "badge_variant_kind_service_container_border-radius": "{pill}",
    "badge_variant_kind_service_container_background-color": "{custom_color_2}",
    "badge_variant_kind_service_container_padding-top": "{xxs}",
    "badge_variant_kind_service_container_padding-left": "{xxs}",
    "badge_variant_kind_service_container_padding-right": "{s}",
    "badge_variant_kind_service_container_padding-bottom": "{xxs}",
    badge_variant_kind_service_container_gap: $52d4442770cfd938$var$badge_variant_kind_service_container_gap,
    "badge_variant_kind_service_text_font-family": "{bodyMBold}",
    "badge_variant_kind_service_text_font-size": "{bodyMBold}",
    "badge_variant_kind_service_text_line-height": "{bodyMBold}",
    "badge_variant_kind_service_text_letter-spacing": "{bodyMBold}",
    "badge_variant_kind_service_text_font-weight": "{bodyMBold}",
    badge_variant_kind_service_text_color: $52d4442770cfd938$var$badge_variant_kind_service_text_color,
    badge_variant_kind_service_icon_size: $52d4442770cfd938$var$badge_variant_kind_service_icon_size,
    badge_variant_kind_service_icon_color: $52d4442770cfd938$var$badge_variant_kind_service_icon_color,
    "badge_combination_normal_small_container_border-radius": "{small}",
    badge_combination_normal_small_icon_size: $52d4442770cfd938$var$badge_combination_normal_small_icon_size,
    "badge_combination_normal_small_text_font-family": "{bodyXxsBold}",
    "badge_combination_normal_small_text_font-size": "{bodyXxsBold}",
    "badge_combination_normal_small_text_line-height": "{bodyXxsBold}",
    "badge_combination_normal_small_text_letter-spacing": "{bodyXxsBold}",
    "badge_combination_normal_small_text_font-weight": "{bodyXxsBold}",
    "badge_combination_normal_large_container_padding-left": "{s}",
    "badge_combination_normal_large_container_padding-right": "{s}",
    badge_combination_normal_large_container_gap: $52d4442770cfd938$var$badge_combination_normal_large_container_gap,
    badge_combination_normal_large_icon_size: $52d4442770cfd938$var$badge_combination_normal_large_icon_size,
    "badge_combination_normal_large_text_font-family": "{bodyLBold}",
    "badge_combination_normal_large_text_font-size": "{bodyLBold}",
    "badge_combination_normal_large_text_line-height": "{bodyLBold}",
    "badge_combination_normal_large_text_letter-spacing": "{bodyLBold}",
    "badge_combination_normal_large_text_font-weight": "{bodyLBold}"
};
const $52d4442770cfd938$var$badgev2brand_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$badgev2brand_variant_kind_circle_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2brand_variant_kind_square_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2brand_combination_circle_medium_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2brand_combination_circle_large_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2brand_combination_square_medium_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2brand_combination_square_large_container_padding = "{custom_5}";
const $52d4442770cfd938$var$BadgeV2BrandTokens = {
    "badgev2brand_base_container_flex-direction": "{flexDirection.row}",
    "badgev2brand_base_container_justify-content": "{justifyContent.center}",
    "badgev2brand_base_container_align-items": "{alignItems.center}",
    "badgev2brand_base_container_background-color": "{primary50}",
    badgev2brand_base_container_gap: $52d4442770cfd938$var$badgev2brand_base_container_gap,
    "badgev2brand_base_container_border-radius": "{pill}",
    "badgev2brand_base_container_padding-left": "{xs}",
    "badgev2brand_base_container_padding-right": "{s}",
    "badgev2brand_base_container_padding-top": "{xxs}",
    "badgev2brand_base_container_padding-bottom": "{xxs}",
    "badgev2brand_base_image-container_border-radius": "{pill}",
    "badgev2brand_base_image-container_size": "{custom_18}",
    "badgev2brand_variant_kind_square_image-container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square_brand-jds_image_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-label_container_border-radius": "{medium}",
    "badgev2brand_variant_kind_square-label_image-container_border-radius": "{small}",
    "badgev2brand_variant_size_medium_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_medium_container_padding-right": "{xxs}",
    "badgev2brand_variant_size_medium_container_padding-top": "{custom_5}",
    "badgev2brand_variant_size_medium_container_padding-bottom": "{custom_5}",
    "badgev2brand_variant_size_medium_image-container_size": "{s}",
    "badgev2brand_variant_size_large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_large_container_padding-top": "{custom_4}",
    "badgev2brand_variant_size_large_container_padding-bottom": "{custom_4}",
    "badgev2brand_variant_size_large_image-container_size": "{s}",
    "badgev2brand_variant_size_xtra-large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_xtra-large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_xtra-large_container_padding-top": "{custom_4}",
    "badgev2brand_variant_size_xtra-large_container_padding-bottom": "{custom_4}",
    "badgev2brand_variant_size_xtra-large_image-container_size": "{base}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-left": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-top": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_container_padding-bottom": "{xxs}",
    "badgev2brand_variant_size_xtra-xtra-large_image-container_size": "{custom_18}",
    "badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xs}",
    "badgev2brand_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_variant_emphasis_bold_container_background-color": "{primary60}",
    badgev2brand_variant_kind_circle_container_padding: $52d4442770cfd938$var$badgev2brand_variant_kind_circle_container_padding,
    badgev2brand_variant_kind_square_container_padding: $52d4442770cfd938$var$badgev2brand_variant_kind_square_container_padding,
    badgev2brand_combination_circle_medium_container_padding: $52d4442770cfd938$var$badgev2brand_combination_circle_medium_container_padding,
    "badgev2brand_combination_circle_medium_image-container_size": "{base}",
    badgev2brand_combination_circle_large_container_padding: $52d4442770cfd938$var$badgev2brand_combination_circle_large_container_padding,
    "badgev2brand_combination_circle_large_image-container_size": "{custom_18}",
    "badgev2brand_combination_circle_xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-large_image-container_size": "{m}",
    "badgev2brand_combination_circle_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-large_image-container_size": "{l}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_circle_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
    "badgev2brand_combination_square_medium_container_border-radius": "{small}",
    badgev2brand_combination_square_medium_container_padding: $52d4442770cfd938$var$badgev2brand_combination_square_medium_container_padding,
    "badgev2brand_combination_square_medium_image-container_size": "{base}",
    "badgev2brand_combination_square_medium_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_large_container_border-radius": "{small}",
    badgev2brand_combination_square_large_container_padding: $52d4442770cfd938$var$badgev2brand_combination_square_large_container_padding,
    "badgev2brand_combination_square_large_image-container_size": "{custom_18}",
    "badgev2brand_combination_square_large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_square_xtra-large_image-container_size": "{m}",
    "badgev2brand_combination_square_xtra-large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2brand_combination_square_xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2brand_combination_square_xtra-xtra-large_image-container_border-radius": "{small}",
    "badgev2brand_combination_square_xtra-xtra-xtra-large_image-container_size": "{l}",
    "badgev2brand_combination_square_xtra-xtra-xtra-xtra-large_image-container_size": "{xl}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_image-container_border-radius": "{medium}",
    "badgev2brand_combination_square-label_medium_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_large_container_padding-right": "{xxs}",
    "badgev2brand_combination_square-label_xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_xtra-large_container_padding-right": "{xxs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_image-container_size": "{base}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2brand_combination_square-label_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2brand_combination_square-label_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}"
};
const $52d4442770cfd938$var$badgev2information_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$badgev2information_base_icon_color = "{primaryBackground}";
const $52d4442770cfd938$var$badgev2information_base_icon_size = "{base}";
const $52d4442770cfd938$var$badgev2information_variant_color_secondary_icon_color = "{primaryBackground}";
const $52d4442770cfd938$var$badgev2information_variant_size_small_icon_size = "{s}";
const $52d4442770cfd938$var$badgev2information_variant_size_medium_icon_size = "{s}";
const $52d4442770cfd938$var$badgev2information_variant_border_true_container_padding = "{custom_16}";
const $52d4442770cfd938$var$badgev2information_combination_icon_small_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2information_combination_icon_small_icon_size = "{s}";
const $52d4442770cfd938$var$badgev2information_combination_icon_medium_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2information_combination_icon_medium_icon_size = "{base}";
const $52d4442770cfd938$var$badgev2information_combination_icon_large_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2information_combination_icon_large_icon_size = "{custom_18}";
const $52d4442770cfd938$var$badgev2information_combination_label_small_container_size = "{base}";
const $52d4442770cfd938$var$badgev2information_combination_label_medium_container_size = "{base}";
const $52d4442770cfd938$var$badgev2information_combination_label_large_container_size = "{custom_18}";
const $52d4442770cfd938$var$badgev2information_combination_subtle_default_icon_color = "{sparkle60}";
const $52d4442770cfd938$var$badgev2information_combination_subtle_positive_icon_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$badgev2information_combination_subtle_warning_icon_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$badgev2information_combination_subtle_negative_icon_color = "{feedbackError50}";
const $52d4442770cfd938$var$badgev2information_combination_subtle_neutral_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$badgev2information_combination_icon_bold_default_icon_color = "{sparkle60}";
const $52d4442770cfd938$var$badgev2information_combination_icon_bold_positive_icon_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$badgev2information_combination_icon_bold_warning_icon_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$badgev2information_combination_icon_bold_negative_icon_color = "{feedbackError50}";
const $52d4442770cfd938$var$badgev2information_combination_icon_bold_neutral_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$badgev2information_combination_icon_subtle_default_icon_color = "{sparkle60}";
const $52d4442770cfd938$var$badgev2information_combination_icon_subtle_positive_icon_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$badgev2information_combination_icon_subtle_warning_icon_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$badgev2information_combination_icon_subtle_negative_icon_color = "{feedbackError50}";
const $52d4442770cfd938$var$badgev2information_combination_icon_subtle_neutral_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$badgev2information_combination_true_small_container_padding = "{custom_4}";
const $52d4442770cfd938$var$badgev2information_combination_true_medium_container_padding = "{custom_4}";
const $52d4442770cfd938$var$badgev2information_combination_true_large_container_padding = "{custom_16}";
const $52d4442770cfd938$var$badgev2information_combination_icon_subtle_secondary_icon_color = "{secondary60}";
const $52d4442770cfd938$var$badgev2information_combination_icon_bold_secondary_icon_color = "{secondary60}";
const $52d4442770cfd938$var$badgev2information_combination_subtle_secondary_icon_color = "{secondary60}";
const $52d4442770cfd938$var$badgev2information_combination_true_icon_container_padding = "{custom_5}";
const $52d4442770cfd938$var$BadgeV2InformationTokens = {
    "badgev2information_base_outer-container_border-radius": "{small}",
    "badgev2information_base_outer-container_align-items": "{alignItems.center}",
    "badgev2information_base_container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_container_justify-content": "{justifyContent.center}",
    "badgev2information_base_container_align-items": "{alignItems.center}",
    "badgev2information_base_container_background-color": "{sparkle60}",
    badgev2information_base_container_gap: $52d4442770cfd938$var$badgev2information_base_container_gap,
    "badgev2information_base_container_border-radius": "{small}",
    "badgev2information_base_container_padding-left": "{xxs}",
    "badgev2information_base_container_padding-right": "{xs}",
    "badgev2information_base_container_padding-top": "{custom_4}",
    "badgev2information_base_container_padding-bottom": "{custom_4}",
    "badgev2information_base_icon-container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_icon-container_justify-content": "{justifyContent.center}",
    "badgev2information_base_icon-container_align-items": "{alignItems.center}",
    "badgev2information_base_icon-container_size": "{base}",
    badgev2information_base_icon_color: $52d4442770cfd938$var$badgev2information_base_icon_color,
    badgev2information_base_icon_size: $52d4442770cfd938$var$badgev2information_base_icon_size,
    "badgev2information_base_image-container_flex-direction": "{flexDirection.row}",
    "badgev2information_base_image-container_justify-content": "{justifyContent.center}",
    "badgev2information_base_image-container_align-items": "{alignItems.center}",
    "badgev2information_base_image-container_size": "{base}",
    "badgev2information_variant_color_secondary_container_background-color": "{secondary60}",
    "badgev2information_variant_color_secondary_icon-container_background-color": "{secondary60}",
    badgev2information_variant_color_secondary_icon_color: $52d4442770cfd938$var$badgev2information_variant_color_secondary_icon_color,
    "badgev2information_variant_size_xtra-small_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_xtra-small_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_xtra-small_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_xtra-small_icon-container_size": "{s}",
    "badgev2information_variant_size_xtra-small_icon_size": "{s}",
    "badgev2information_variant_size_xtra-small_image-container_size": "{s}",
    "badgev2information_variant_size_small_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_small_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_small_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_small_icon-container_size": "{s}",
    badgev2information_variant_size_small_icon_size: $52d4442770cfd938$var$badgev2information_variant_size_small_icon_size,
    "badgev2information_variant_size_small_image-container_size": "{s}",
    "badgev2information_variant_size_medium_inner-container_padding-right": "{xxs}",
    "badgev2information_variant_size_medium_inner-container_padding-top": "{custom_5}",
    "badgev2information_variant_size_medium_inner-container_padding-bottom": "{custom_5}",
    "badgev2information_variant_size_medium_icon-container_size": "{s}",
    badgev2information_variant_size_medium_icon_size: $52d4442770cfd938$var$badgev2information_variant_size_medium_icon_size,
    "badgev2information_variant_size_medium_image-container_size": "{s}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_icon-container_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-large_image-container_size": "{custom_18}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_border-radius": "{medium}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-right": "{s}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-top": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_inner-container_padding-bottom": "{xxs}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_icon_size": "{custom_3}",
    "badgev2information_variant_size_xtra-xtra-xtra-xtra-large_image-container_size": "{custom_3}",
    "badgev2information_variant_color_positive_container_background-color": "{feedbackSuccess50}",
    "badgev2information_variant_color_positive_icon-container_background-color": "{feedbackSuccess50}",
    "badgev2information_variant_color_warning_container_background-color": "{feedbackWarning50}",
    "badgev2information_variant_color_warning_icon-container_background-color": "{feedbackWarning50}",
    "badgev2information_variant_color_negative_container_background-color": "{feedbackError50}",
    "badgev2information_variant_color_negative_icon-container_background-color": "{feedbackError50}",
    "badgev2information_variant_color_neutral_container_background-color": "{primaryGrey80}",
    "badgev2information_variant_color_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_variant_border_true_container_padding: $52d4442770cfd938$var$badgev2information_variant_border_true_container_padding,
    "badgev2information_variant_border_true_container_border-color": "{primaryBackground}",
    "badgev2information_combination_icon_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-small_icon-container_size": "{xs}",
    "badgev2information_combination_icon_xtra-small_icon_size": "{xs}",
    badgev2information_combination_icon_small_container_padding: $52d4442770cfd938$var$badgev2information_combination_icon_small_container_padding,
    "badgev2information_combination_icon_small_icon-container_size": "{s}",
    badgev2information_combination_icon_small_icon_size: $52d4442770cfd938$var$badgev2information_combination_icon_small_icon_size,
    badgev2information_combination_icon_medium_container_padding: $52d4442770cfd938$var$badgev2information_combination_icon_medium_container_padding,
    "badgev2information_combination_icon_medium_icon-container_size": "{base}",
    badgev2information_combination_icon_medium_icon_size: $52d4442770cfd938$var$badgev2information_combination_icon_medium_icon_size,
    badgev2information_combination_icon_large_container_padding: $52d4442770cfd938$var$badgev2information_combination_icon_large_container_padding,
    "badgev2information_combination_icon_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon_large_icon-container_size": "{custom_18}",
    badgev2information_combination_icon_large_icon_size: $52d4442770cfd938$var$badgev2information_combination_icon_large_icon_size,
    "badgev2information_combination_icon_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon_xtra-large_icon_size": "{m}",
    "badgev2information_combination_icon_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon_xtra-xtra-large_icon_size": "{custom_3}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon_xtra-xtra-xtra-large_icon_size": "{l}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon_xtra-xtra-xtra-xtra-large_icon_size": "{xl}",
    "badgev2information_combination_icon-circle_xtra-small_outer-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-small_icon-container_size": "{s}",
    "badgev2information_combination_icon-circle_xtra-small_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-small_icon_size": "{xs}",
    "badgev2information_combination_icon-circle_small_outer-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_small_icon-container_size": "{s}",
    "badgev2information_combination_icon-circle_small_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_small_icon_size": "{xs}",
    "badgev2information_combination_icon-circle_medium_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_medium_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_medium_icon-container_size": "{base}",
    "badgev2information_combination_icon-circle_medium_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_medium_icon_size": "{custom_19}",
    "badgev2information_combination_icon-circle_large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_large_icon-container_size": "{custom_18}",
    "badgev2information_combination_icon-circle_large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_large_icon_size": "{s}",
    "badgev2information_combination_icon-circle_xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon-circle_xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{pill}",
    "badgev2information_combination_icon-circle_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
    "badgev2information_combination_icon-square_xtra-small_outer-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-small_icon-container_size": "{s}",
    "badgev2information_combination_icon-square_xtra-small_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-small_icon_size": "{xs}",
    "badgev2information_combination_icon-square_small_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_small_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_small_icon-container_size": "{s}",
    "badgev2information_combination_icon-square_small_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_small_icon_size": "{xs}",
    "badgev2information_combination_icon-square_medium_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_medium_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_medium_icon-container_size": "{base}",
    "badgev2information_combination_icon-square_medium_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_medium_icon_size": "{custom_19}",
    "badgev2information_combination_icon-square_large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_large_icon-container_size": "{custom_18}",
    "badgev2information_combination_icon-square_large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_large_icon_size": "{s}",
    "badgev2information_combination_icon-square_xtra-large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-large_icon-container_size": "{m}",
    "badgev2information_combination_icon-square_xtra-large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-square_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon-container_size": "{custom_3}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon-container_border-radius": "{small}",
    "badgev2information_combination_icon-square_xtra-xtra-large_icon_size": "{base}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_size": "{l}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon-container_border-radius": "{medium}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-large_icon_size": "{custom_18}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_border-radius": "{custom_1}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_container_padding": "{custom_5}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_size": "{xl}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon-container_border-radius": "{custom_1}",
    "badgev2information_combination_icon-square_xtra-xtra-xtra-xtra-large_icon_size": "{m}",
    "badgev2information_combination_label_xtra-small_container_size": "{base}",
    badgev2information_combination_label_small_container_size: $52d4442770cfd938$var$badgev2information_combination_label_small_container_size,
    badgev2information_combination_label_medium_container_size: $52d4442770cfd938$var$badgev2information_combination_label_medium_container_size,
    badgev2information_combination_label_large_container_size: $52d4442770cfd938$var$badgev2information_combination_label_large_container_size,
    "badgev2information_combination_label_large_inner-container_padding-left": "{xs}",
    "badgev2information_combination_label_xtra-large_container_size": "{m}",
    "badgev2information_combination_label_xtra-large_inner-container_padding-left": "{xs}",
    "badgev2information_combination_label_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_label_xtra-xtra-xtra-xtra-large_inner-container_padding-left": "{s}",
    "badgev2information_combination_label-icon_xtra-small_container_size": "{base}",
    "badgev2information_combination_label-icon_small_container_size": "{base}",
    "badgev2information_combination_label-icon_medium_container_size": "{base}",
    "badgev2information_combination_label-icon_large_container_size": "{custom_18}",
    "badgev2information_combination_label-icon_xtra-large_container_size": "{m}",
    "badgev2information_combination_label-icon_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label-icon_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label-icon_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_label-image_xtra-small_container_size": "{base}",
    "badgev2information_combination_label-image_small_container_size": "{base}",
    "badgev2information_combination_label-image_medium_container_size": "{base}",
    "badgev2information_combination_label-image_large_container_size": "{custom_18}",
    "badgev2information_combination_label-image_xtra-large_container_size": "{m}",
    "badgev2information_combination_label-image_xtra-xtra-large_container_size": "{custom_3}",
    "badgev2information_combination_label-image_xtra-xtra-xtra-large_container_size": "{l}",
    "badgev2information_combination_label-image_xtra-xtra-xtra-xtra-large_container_size": "{xl}",
    "badgev2information_combination_subtle_default_container_background-color": "{sparkle20}",
    "badgev2information_combination_subtle_default_icon-container_background-color": "{sparkle20}",
    badgev2information_combination_subtle_default_icon_color: $52d4442770cfd938$var$badgev2information_combination_subtle_default_icon_color,
    "badgev2information_combination_subtle_positive_container_background-color": "{feedbackSuccess20}",
    "badgev2information_combination_subtle_positive_icon-container_background-color": "{feedbackSuccess20}",
    badgev2information_combination_subtle_positive_icon_color: $52d4442770cfd938$var$badgev2information_combination_subtle_positive_icon_color,
    "badgev2information_combination_subtle_warning_container_background-color": "{feedbackWarning20}",
    "badgev2information_combination_subtle_warning_icon-container_background-color": "{feedbackWarning20}",
    badgev2information_combination_subtle_warning_icon_color: $52d4442770cfd938$var$badgev2information_combination_subtle_warning_icon_color,
    "badgev2information_combination_subtle_negative_container_background-color": "{feedbackError20}",
    "badgev2information_combination_subtle_negative_icon-container_background-color": "{feedbackError20}",
    badgev2information_combination_subtle_negative_icon_color: $52d4442770cfd938$var$badgev2information_combination_subtle_negative_icon_color,
    "badgev2information_combination_subtle_neutral_container_background-color": "{primaryGrey20}",
    "badgev2information_combination_subtle_neutral_icon-container_background-color": "{primaryGrey20}",
    badgev2information_combination_subtle_neutral_icon_color: $52d4442770cfd938$var$badgev2information_combination_subtle_neutral_icon_color,
    "badgev2information_combination_icon_bold_default_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_default_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_default_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_bold_default_icon_color,
    "badgev2information_combination_icon_bold_positive_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_positive_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_positive_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_bold_positive_icon_color,
    "badgev2information_combination_icon_bold_warning_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_warning_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_warning_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_bold_warning_icon_color,
    "badgev2information_combination_icon_bold_negative_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_negative_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_negative_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_bold_negative_icon_color,
    "badgev2information_combination_icon_bold_neutral_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_bold_neutral_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_bold_neutral_icon_color,
    "badgev2information_combination_icon_subtle_default_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_default_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_default_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_subtle_default_icon_color,
    "badgev2information_combination_icon_subtle_positive_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_positive_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_positive_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_subtle_positive_icon_color,
    "badgev2information_combination_icon_subtle_warning_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_warning_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_warning_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_subtle_warning_icon_color,
    "badgev2information_combination_icon_subtle_negative_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_negative_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_negative_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_subtle_negative_icon_color,
    "badgev2information_combination_icon_subtle_neutral_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_neutral_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_neutral_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_subtle_neutral_icon_color,
    "badgev2information_combination_true_xtra-small_container_padding": "{custom_4}",
    badgev2information_combination_true_small_container_padding: $52d4442770cfd938$var$badgev2information_combination_true_small_container_padding,
    badgev2information_combination_true_medium_container_padding: $52d4442770cfd938$var$badgev2information_combination_true_medium_container_padding,
    badgev2information_combination_true_large_container_padding: $52d4442770cfd938$var$badgev2information_combination_true_large_container_padding,
    "badgev2information_combination_true_xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2information_combination_true_xtra-xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2information_combination_true_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
    "badgev2information_combination_true_icon-circle_large_container_padding": "{custom_4}",
    "badgev2information_combination_true_icon-square_large_container_padding": "{custom_4}",
    "badgev2information_combination_icon_subtle_secondary_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_subtle_secondary_icon-container_background-color": "{global.transparent}",
    badgev2information_combination_icon_subtle_secondary_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_subtle_secondary_icon_color,
    "badgev2information_combination_icon_bold_secondary_container_background-color": "{global.transparent}",
    "badgev2information_combination_icon_bold_secondary_icon-container_background-color": "{global.tansparent}",
    badgev2information_combination_icon_bold_secondary_icon_color: $52d4442770cfd938$var$badgev2information_combination_icon_bold_secondary_icon_color,
    "badgev2information_combination_subtle_secondary_container_background-color": "{secondary20}",
    "badgev2information_combination_subtle_secondary_icon-container_background-color": "{secondary20}",
    badgev2information_combination_subtle_secondary_icon_color: $52d4442770cfd938$var$badgev2information_combination_subtle_secondary_icon_color,
    "badgev2information_combination_true_icon_container_border-color": "{global.transparent}",
    badgev2information_combination_true_icon_container_padding: $52d4442770cfd938$var$badgev2information_combination_true_icon_container_padding
};
const $52d4442770cfd938$var$badgev2notification_base_container_width = "{xs}";
const $52d4442770cfd938$var$badgev2notification_base_container_height = "{xs}";
const $52d4442770cfd938$var$badgev2notification_base_container_padding = "{custom_5}";
const $52d4442770cfd938$var$badgev2notification_variant_size_small_container_padding = "{custom_4}";
const $52d4442770cfd938$var$badgev2notification_variant_size_small_container_width = "{s}";
const $52d4442770cfd938$var$badgev2notification_variant_size_small_container_height = "{s}";
const $52d4442770cfd938$var$badgev2notification_variant_size_medium_container_width = "{base}";
const $52d4442770cfd938$var$badgev2notification_variant_size_medium_container_height = "{base}";
const $52d4442770cfd938$var$badgev2notification_variant_size_medium_container_padding = "{custom_4}";
const $52d4442770cfd938$var$badgev2notification_variant_size_large_container_width = "{custom_18}";
const $52d4442770cfd938$var$badgev2notification_variant_size_large_container_height = "{custom_18}";
const $52d4442770cfd938$var$badgev2notification_variant_size_large_container_padding = "{custom_4}";
const $52d4442770cfd938$var$badgev2notification_variant_border_true_container_padding = "{custom_1}";
const $52d4442770cfd938$var$badgev2notification_combination_number_small_container_width = "{base}";
const $52d4442770cfd938$var$badgev2notification_combination_number_small_container_height = "{base}";
const $52d4442770cfd938$var$badgev2notification_combination_number_medium_container_width = "{base}";
const $52d4442770cfd938$var$badgev2notification_combination_number_medium_container_height = "{base}";
const $52d4442770cfd938$var$badgev2notification_combination_number_large_container_width = "{custom_18}";
const $52d4442770cfd938$var$badgev2notification_combination_number_large_container_height = "{custom_18}";
const $52d4442770cfd938$var$BadgeV2NotificationTokens = {
    "badgev2notification_base_container_flex-direction": "{flexDirection.row}",
    "badgev2notification_base_container_justify-content": "{justifyContent.center}",
    "badgev2notification_base_container_align-items": "{alignItems.center}",
    badgev2notification_base_container_width: $52d4442770cfd938$var$badgev2notification_base_container_width,
    badgev2notification_base_container_height: $52d4442770cfd938$var$badgev2notification_base_container_height,
    "badgev2notification_base_container_background-color": "{feedbackError50}",
    "badgev2notification_base_container_border-radius": "{pill}",
    badgev2notification_base_container_padding: $52d4442770cfd938$var$badgev2notification_base_container_padding,
    "badgev2notification_base_container_border-color": "{global.transparent}",
    "badgev2notification_variant_border_true_container_border-color": "{primaryBackground}",
    badgev2notification_variant_size_small_container_padding: $52d4442770cfd938$var$badgev2notification_variant_size_small_container_padding,
    badgev2notification_variant_size_small_container_width: $52d4442770cfd938$var$badgev2notification_variant_size_small_container_width,
    badgev2notification_variant_size_small_container_height: $52d4442770cfd938$var$badgev2notification_variant_size_small_container_height,
    badgev2notification_variant_size_medium_container_width: $52d4442770cfd938$var$badgev2notification_variant_size_medium_container_width,
    badgev2notification_variant_size_medium_container_height: $52d4442770cfd938$var$badgev2notification_variant_size_medium_container_height,
    badgev2notification_variant_size_medium_container_padding: $52d4442770cfd938$var$badgev2notification_variant_size_medium_container_padding,
    badgev2notification_variant_size_large_container_width: $52d4442770cfd938$var$badgev2notification_variant_size_large_container_width,
    badgev2notification_variant_size_large_container_height: $52d4442770cfd938$var$badgev2notification_variant_size_large_container_height,
    badgev2notification_variant_size_large_container_padding: $52d4442770cfd938$var$badgev2notification_variant_size_large_container_padding,
    "badgev2notification_variant_size_xtra-large_container_width": "{m}",
    "badgev2notification_variant_size_xtra-large_container_height": "{m}",
    "badgev2notification_variant_size_xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-large_container_width": "{custom_3}",
    "badgev2notification_variant_size_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_variant_size_xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_width": "{l}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_variant_size_xtra-xtra-xtra-large_container_padding": "{custom_16}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_variant_size_xtra-xtra-xtra-xtra-large_container_padding": "{xxs}",
    badgev2notification_variant_border_true_container_padding: $52d4442770cfd938$var$badgev2notification_variant_border_true_container_padding,
    "badgev2notification_combination_number_xtra-small_container_width": "{base}",
    "badgev2notification_combination_number_xtra-small_container_height": "{base}",
    badgev2notification_combination_number_small_container_width: $52d4442770cfd938$var$badgev2notification_combination_number_small_container_width,
    badgev2notification_combination_number_small_container_height: $52d4442770cfd938$var$badgev2notification_combination_number_small_container_height,
    badgev2notification_combination_number_medium_container_width: $52d4442770cfd938$var$badgev2notification_combination_number_medium_container_width,
    badgev2notification_combination_number_medium_container_height: $52d4442770cfd938$var$badgev2notification_combination_number_medium_container_height,
    badgev2notification_combination_number_large_container_width: $52d4442770cfd938$var$badgev2notification_combination_number_large_container_width,
    badgev2notification_combination_number_large_container_height: $52d4442770cfd938$var$badgev2notification_combination_number_large_container_height,
    "badgev2notification_combination_number_xtra-large_container_width": "{m}",
    "badgev2notification_combination_number_xtra-large_container_height": "{m}",
    "badgev2notification_combination_number_xtra-xtra-large_container_width": "{custom_3}",
    "badgev2notification_combination_number_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_combination_number_xtra-xtra-xtra-large_container_width": "{l}",
    "badgev2notification_combination_number_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_width": "{xl}",
    "badgev2notification_combination_number_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_combination_number-symbol_xtra-small_container_height": "{base}",
    "badgev2notification_combination_number-symbol_xtra-small_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-small_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_xtra-small_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_small_container_height": "{base}",
    "badgev2notification_combination_number-symbol_small_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_small_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_small_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_medium_container_height": "{base}",
    "badgev2notification_combination_number-symbol_medium_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_medium_container_padding-left": "{xxs}",
    "badgev2notification_combination_number-symbol_medium_container_padding-right": "{xxs}",
    "badgev2notification_combination_number-symbol_large_container_height": "{custom_18}",
    "badgev2notification_combination_number-symbol_large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-large_container_height": "{m}",
    "badgev2notification_combination_number-symbol_xtra-large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_height": "{custom_3}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_border-radius": "{small}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-left": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-large_container_padding-right": "{custom_18}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_height": "{l}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_height": "{xl}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_border-radius": "{medium}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-left": "{xs}",
    "badgev2notification_combination_number-symbol_xtra-xtra-xtra-xtra-large_container_padding-right": "{xs}",
    "badgev2notification_combination_true_number_xtra-small_container_padding": "{custom_4}"
};
const $52d4442770cfd938$var$badgev2status_base_container_gap = "{xs}";
const $52d4442770cfd938$var$BadgeV2StatusTokens = {
    "badgev2status_base_container_flex-direction": "{flexDirection.row}",
    "badgev2status_base_container_justify-content": "{justifyContent.center}",
    "badgev2status_base_container_align-items": "{alignItems.center}",
    badgev2status_base_container_gap: $52d4442770cfd938$var$badgev2status_base_container_gap,
    "badgev2status_base_status-container_flex-direction": "{flexDirection.row}",
    "badgev2status_base_status-container_justify-content": "{justifyContent.center}",
    "badgev2status_base_status-container_align-items": "{alignItems.center}",
    "badgev2status_base_status-container_size": "{m}",
    "badgev2status_base_status-container_border-radius": "{pill}",
    "badgev2status_base_status-container_background-color": "{feedbackSuccess50}",
    "badgev2status_base_status-icon_color": "{global.white}",
    "badgev2status_base_status-icon_size": "{base}",
    "badgev2status_variant_kind_dot_status-container_size": "{s}",
    "badgev2status_variant_kind_dot-label_status-container_size": "{s}",
    "badgev2status_variant_kind_label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_label-container_container_padding-right": "{xs}",
    "badgev2status_variant_kind_dot-label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_dot-label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_dot-label-container_container_padding-right": "{xs}",
    "badgev2status_variant_kind_dot-label-container_status-container_size": "{s}",
    "badgev2status_variant_kind_icon-label-container_container_border-radius": "{small}",
    "badgev2status_variant_kind_icon-label-container_container_padding-left": "{xs}",
    "badgev2status_variant_kind_icon-label-container_container_padding-right": "{xs}",
    "badgev2status_variant_size_xtra-small_status-container_size": "{base}",
    "badgev2status_variant_size_xtra-small_status-icon_size": "{s}",
    "badgev2status_variant_size_medium_status-container_size": "{l}",
    "badgev2status_variant_size_medium_status-icon_size": "{m}",
    "badgev2status_variant_size_large_status-container_size": "{xl}",
    "badgev2status_variant_size_large_status-icon_size": "{custom_3}",
    "badgev2status_variant_status_error_status-container_background-color": "{feedbackError50}",
    "badgev2status_variant_status_warning_status-container_background-color": "{feedbackWarning50}",
    "badgev2status_variant_status_disabled_status-container_background-color": "{primaryGrey60}",
    "badgev2status_variant_border_true_container_border-color": "{primaryBackground}",
    "badgev2status_variant_border_true_status-container_border-color": "{primaryBackground}",
    "badgev2status_combination_dot_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot_medium_status-container_size": "{base}",
    "badgev2status_combination_dot_large_status-container_size": "{m}",
    "badgev2status_combination_dot_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_dot-label_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot-label_medium_status-container_size": "{base}",
    "badgev2status_combination_dot-label_large_status-container_size": "{m}",
    "badgev2status_combination_dot-label_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_icon-label_medium_status-container_size": "{m}",
    "badgev2status_combination_icon-label_medium_status-icon_size": "{base}",
    "badgev2status_combination_icon-label_large_status-container_size": "{m}",
    "badgev2status_combination_icon-label_large_status-icon_size": "{base}",
    "badgev2status_combination_label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_xtra-small_status-container_size": "{xs}",
    "badgev2status_combination_dot-label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_medium_status-container_size": "{base}",
    "badgev2status_combination_dot-label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_dot-label-container_large_status-container_size": "{m}",
    "badgev2status_combination_dot-label-container_xtra-large_status-container_size": "{l}",
    "badgev2status_combination_icon-label-container_medium_container_border-radius": "{medium}",
    "badgev2status_combination_icon-label-container_medium_status-container_size": "{base}",
    "badgev2status_combination_icon-label-container_medium_status-icon_size": "{s}",
    "badgev2status_combination_icon-label-container_large_container_border-radius": "{medium}",
    "badgev2status_combination_icon-label-container_large_status-container_size": "{m}",
    "badgev2status_combination_icon-label-container_large_status-icon_size": "{base}",
    "badgev2status_combination_label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_dot-label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_dot-label-container_success_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_dot-label-container_error_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_dot-label-container_warning_status-container_background-color": "{global.white}",
    "badgev2status_combination_dot-label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_dot-label-container_disabled_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_success_container_background-color": "{feedbackSuccess50}",
    "badgev2status_combination_icon-label-container_success_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_success_status-icon_color": "{feedbackSuccess50}",
    "badgev2status_combination_icon-label-container_error_container_background-color": "{feedbackError50}",
    "badgev2status_combination_icon-label-container_error_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_error_status-icon_color": "{feedbackError50}",
    "badgev2status_combination_icon-label-container_warning_container_background-color": "{feedbackWarning50}",
    "badgev2status_combination_icon-label-container_warning_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_warning_status-icon_color": "{feedbackWarning50}",
    "badgev2status_combination_icon-label-container_disabled_container_background-color": "{primaryGrey60}",
    "badgev2status_combination_icon-label-container_disabled_status-container_background-color": "{global.white}",
    "badgev2status_combination_icon-label-container_disabled_status-icon_color": "{primaryGrey60}",
    "badgev2status_combination_true_dot_xtra-small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_dot_small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_dot_medium_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_dot_large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_dot_xtra-large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_xtra-small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_icon_small_status-container_border-width": "{border_normal}",
    "badgev2status_combination_true_icon_medium_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_icon_xtra-large_status-container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_xtra-small_container_border-width": "{border_normal}",
    "badgev2status_combination_true_label-container_small_container_border-width": "{border_normal}",
    "badgev2status_combination_true_label-container_medium_container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_large_container_border-width": "{border_thick}",
    "badgev2status_combination_true_label-container_xtra-large_container_border-width": "{border_thick}"
};
const $52d4442770cfd938$var$breadcrumbs_base_container_height = "{m}";
const $52d4442770cfd938$var$BreadcrumbsTokens = {
    "breadcrumbs_base_container_flex-direction": "{flexDirection.row}",
    "breadcrumbs_base_container_justify-content": "{justifyContent.start}",
    "breadcrumbs_base_container_align-items": "{alignItems.start}",
    breadcrumbs_base_container_height: $52d4442770cfd938$var$breadcrumbs_base_container_height,
    "breadcrumbs_base_link-container_flex-direction": "{flexDirection.row}",
    "breadcrumbs_base_link-container_justify-content": "{justifyContent.start}",
    "breadcrumbs_base_link-container_align-items": "{alignItems.start}"
};
const $52d4442770cfd938$var$MobileBottomSheetTokens = {
    "mobilebottomsheet_base_popup-container_flex-direction": "{flexDirection.stack}",
    "mobilebottomsheet_base_popup-container_justify-content": "{justifyContent.center}",
    "mobilebottomsheet_base_popup-container_align-items": "{alignItems.end}",
    "mobilebottomsheet_base_popup-container_size": "{size.max}",
    "mobilebottomsheet_base_popup-container_background-color": "{custom_color_3}",
    "mobilebottomsheet_base_popup-container_opacity": "{opacity.invisible}",
    "mobilebottomsheet_base_popup-container_transition_duration": "{medium}",
    "mobilebottomsheet_base_popup-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheet_variant_kind_passive_popup_background-color": "{global.transparent}",
    "mobilebottomsheet_variant_kind_passive_popup-container_background-color": "{global.transparent}",
    "mobilebottomsheet_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "mobilebottomsheet_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $52d4442770cfd938$var$mobilebottomsheetinternal_base_container_width = "{size.max}";
const $52d4442770cfd938$var$MobileBottomSheetInternalTokens = {
    "mobilebottomsheetinternal_base_container_flex-direction": "{flexDirection.stack}",
    "mobilebottomsheetinternal_base_container_justify-content": "{justifyContent.end}",
    "mobilebottomsheetinternal_base_container_align-items": "{alignItems.end}",
    mobilebottomsheetinternal_base_container_width: $52d4442770cfd938$var$mobilebottomsheetinternal_base_container_width,
    "mobilebottomsheetinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_root-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_root-container_background-color": "{primaryBackground}",
    "mobilebottomsheetinternal_base_root-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_root-container_border-top-left-radius": "{xl}",
    "mobilebottomsheetinternal_base_root-container_border-top-right-radius": "{xl}",
    "mobilebottomsheetinternal_base_root-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_root-container_translate-y": "{size.max}",
    "mobilebottomsheetinternal_base_root-container_transition_duration": "{medium}",
    "mobilebottomsheetinternal_base_root-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheetinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "mobilebottomsheetinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "mobilebottomsheetinternal_base_cancel-container_align-items": "{alignItems.center}",
    "mobilebottomsheetinternal_base_cancel-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_cancel-container_padding-top": "{xxs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-bottom": "{xxs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-left": "{xs}",
    "mobilebottomsheetinternal_base_cancel-container_padding-right": "{s}",
    "mobilebottomsheetinternal_base_cancel-container_gap": "{s}",
    "mobilebottomsheetinternal_base_back-container_flex": 1,
    "mobilebottomsheetinternal_base_empty-container_flex": 1,
    "mobilebottomsheetinternal_base_step-jds_text_padding-right": "{base}",
    "mobilebottomsheetinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_vertical-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_vertical-container_padding-left": "{m}",
    "mobilebottomsheetinternal_base_vertical-container_padding-right": "{m}",
    "mobilebottomsheetinternal_base_vertical-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_title-jds_text_padding-bottom": "{xs}",
    "mobilebottomsheetinternal_base_description-jds_text_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_cta-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_cta-container_gap": "{base}",
    "mobilebottomsheetinternal_base_cta-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_cta-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_cta-container_padding-top": "{m}",
    "mobilebottomsheetinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "mobilebottomsheetinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "mobilebottomsheetinternal_base_custom-container_align-items": "{alignItems.start}",
    "mobilebottomsheetinternal_base_custom-container_background-color": "{primaryBackground}",
    "mobilebottomsheetinternal_base_custom-container_border-top-left-radius": "{xl}",
    "mobilebottomsheetinternal_base_custom-container_border-top-right-radius": "{xl}",
    "mobilebottomsheetinternal_base_custom-container_padding-left": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-right": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-top": "{m}",
    "mobilebottomsheetinternal_base_custom-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_base_custom-container_width": "{size.max}",
    "mobilebottomsheetinternal_base_custom-container_translate-y": "{size.max}",
    "mobilebottomsheetinternal_base_custom-container_transition_duration": "{medium}",
    "mobilebottomsheetinternal_base_custom-container_transition_timing-function": "{easeEntrance}",
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_x": 0,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_y": 4,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_blur": 24,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_spread": 0,
    "mobilebottomsheetinternal_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}",
    "mobilebottomsheetinternal_variant_close_false_root-container_translate-y": 0,
    "mobilebottomsheetinternal_variant__noButton_true_root-container_padding-bottom": "{m}",
    "mobilebottomsheetinternal_combination_false_true_custom-container_translate-y": 0,
    "mobilebottomsheetinternal_combination_false_true_root-container_translate-y": "{size.max}"
};
const $52d4442770cfd938$var$DesktopBottomSheetInternalTokens = {
    "desktopbottomsheetinternal_base_container_flex-direction": "{flexDirection.stack}",
    "desktopbottomsheetinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_custom-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_custom-container_background-color": "{primaryBackground}",
    "desktopbottomsheetinternal_base_custom-container_border-top-left-radius": "{xl}",
    "desktopbottomsheetinternal_base_custom-container_border-top-right-radius": "{xl}",
    "desktopbottomsheetinternal_base_custom-container_padding-left": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-right": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-top": "{m}",
    "desktopbottomsheetinternal_base_custom-container_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_custom-container_width": "{custom_28}",
    "desktopbottomsheetinternal_base_custom-container_translate-y": "{size.max}",
    "desktopbottomsheetinternal_base_container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_container_align-items": "{alignItems.end}",
    "desktopbottomsheetinternal_base_root-container_width": "{custom_28}",
    "desktopbottomsheetinternal_base_root-container_translate-y": "{size.max}",
    "desktopbottomsheetinternal_base_root-container_transition_duration": "{medium}",
    "desktopbottomsheetinternal_base_root-container_transition_timing-function": "{easeEntrance}",
    "desktopbottomsheetinternal_base_popup-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheetinternal_base_popup-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_popup-container_align-items": "{alignItems.end}",
    "desktopbottomsheetinternal_base_popup-container_background-color": "{custom_color_3}",
    "desktopbottomsheetinternal_base_popup-container_size": "{size.max}",
    "desktopbottomsheetinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_root-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_root-container_background-color": "{primaryBackground}",
    "desktopbottomsheetinternal_base_root-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_root-container_border-top-left-radius": "{xl}",
    "desktopbottomsheetinternal_base_root-container_border-top-right-radius": "{xl}",
    "desktopbottomsheetinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheetinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheetinternal_base_cancel-container_align-items": "{alignItems.center}",
    "desktopbottomsheetinternal_base_cancel-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_cancel-container_padding-top": "{xxs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-bottom": "{xxs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-left": "{xs}",
    "desktopbottomsheetinternal_base_cancel-container_padding-right": "{s}",
    "desktopbottomsheetinternal_base_cancel-container_gap": "{s}",
    "desktopbottomsheetinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheetinternal_base_vertical-container_align-items": "{alignItems.start}",
    "desktopbottomsheetinternal_base_vertical-container_padding-left": "{m}",
    "desktopbottomsheetinternal_base_vertical-container_padding-right": "{m}",
    "desktopbottomsheetinternal_base_vertical-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_title-jds_text_padding-bottom": "{xs}",
    "desktopbottomsheetinternal_base_description-jds_text_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_cta-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheetinternal_base_cta-container_gap": "{base}",
    "desktopbottomsheetinternal_base_cta-container_width": "{size.max}",
    "desktopbottomsheetinternal_base_cta-container_padding-bottom": "{m}",
    "desktopbottomsheetinternal_base_cta-container_padding-top": "{m}",
    "desktopbottomsheetinternal_base_step-jds_text_padding-right": "{base}",
    "desktopbottomsheetinternal_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}",
    "desktopbottomsheetinternal_base_popup-container_padding-right": "{bottomsheet_padding_right}",
    "desktopbottomsheetinternal_base_popup-container_opacity": "{opacity.invisible}",
    "desktopbottomsheetinternal_base_popup-container_transition_duration": "{medium}",
    "desktopbottomsheetinternal_base_popup-container_transition_timing-function": "{easeEntrance}",
    "desktopbottomsheetinternal_variant_kind_passive_popup_background-color": "{global.transparent}",
    "desktopbottomsheetinternal_variant_kind_passive_popup-container_background-color": "{global.transparent}",
    "desktopbottomsheetinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "desktopbottomsheetinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $52d4442770cfd938$var$DesktopBottomSheetTokens = {
    "desktopbottomsheet_base_popup-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheet_base_popup-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheet_base_popup-container_align-items": "{alignItems.end}",
    "desktopbottomsheet_base_popup-container_background-color": "{custom_color_3}",
    "desktopbottomsheet_base_popup-container_size": "{size.max}",
    "desktopbottomsheet_base_root-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_root-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheet_base_root-container_background-color": "{primaryBackground}",
    "desktopbottomsheet_base_root-container_align-items": "{alignItems.start}",
    "desktopbottomsheet_base_root-container_border-top-left-radius": "{xl}",
    "desktopbottomsheet_base_root-container_border-top-right-radius": "{xl}",
    "desktopbottomsheet_base_cancel-container_flex-direction": "{flexDirection.row}",
    "desktopbottomsheet_base_cancel-container_justify-content": "{justifyContent.end}",
    "desktopbottomsheet_base_cancel-container_align-items": "{alignItems.center}",
    "desktopbottomsheet_base_cancel-container_width": "{size.max}",
    "desktopbottomsheet_base_cancel-container_padding-top": "{xxs}",
    "desktopbottomsheet_base_cancel-container_padding-bottom": "{xxs}",
    "desktopbottomsheet_base_cancel-container_padding-left": "{xs}",
    "desktopbottomsheet_base_cancel-container_padding-right": "{s}",
    "desktopbottomsheet_base_cancel-container_gap": "{s}",
    "desktopbottomsheet_base_vertical-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_vertical-container_justify-content": "{justifyContent.start}",
    "desktopbottomsheet_base_vertical-container_align-items": "{alignItems.start}",
    "desktopbottomsheet_base_vertical-container_padding-left": "{m}",
    "desktopbottomsheet_base_vertical-container_padding-right": "{m}",
    "desktopbottomsheet_base_vertical-container_width": "{size.max}",
    "desktopbottomsheet_base_title-jds_text_padding-bottom": "{xs}",
    "desktopbottomsheet_base_description-jds_text_padding-bottom": "{m}",
    "desktopbottomsheet_base_cta-container_flex-direction": "{flexDirection.column}",
    "desktopbottomsheet_base_cta-container_gap": "{base}",
    "desktopbottomsheet_base_cta-container_width": "{size.max}",
    "desktopbottomsheet_base_cta-container_padding-bottom": "{m}",
    "desktopbottomsheet_base_cta-container_padding-top": "{m}",
    "desktopbottomsheet_base_step-jds_text_padding-right": "{base}",
    "desktopbottomsheet_variant_kind_passive_root-container_box-shadow_color": "{custom_color_5}"
};
const $52d4442770cfd938$var$carousel_base_container_gap = "{base}";
const $52d4442770cfd938$var$carousel_base_container_width = "{size.max}";
const $52d4442770cfd938$var$carousel_variant_density_condensed_container_gap = "{xs}";
const $52d4442770cfd938$var$CarouselTokens = {
    "carousel_base_container_flex-direction": "{flexDirection.column}",
    "carousel_base_container_justify-content": "{justifyContent.center}",
    "carousel_base_container_align-items": "{alignItems.center}",
    carousel_base_container_gap: $52d4442770cfd938$var$carousel_base_container_gap,
    carousel_base_container_width: $52d4442770cfd938$var$carousel_base_container_width,
    "carousel_base_slider-container_width": "{size.max}",
    "carousel_base_control-container_flex-direction": "{flexDirection.row}",
    "carousel_base_control-container_justify-content": "{justifyContent.spaceBetween}",
    "carousel_base_control-container_align-items": "{alignItems.center}",
    "carousel_base_control-container_gap": "{base}",
    "carousel_base_control-container_width": "{size.max}",
    "carousel_base_left-container_max-width": "{size.max}",
    "carousel_base_left-container_flex-direction": "{flexDirection.row}",
    "carousel_base_left-container_justify-content": "{justifyContent.start}",
    "carousel_base_left-container_align-items": "{alignItems.center}",
    "carousel_base_left-container_gap": "{base}",
    "carousel_base_left-container_padding-top": "{xs}",
    "carousel_base_left-container_padding-bottom": "{xs}",
    "carousel_base_prefix-container_flex-direction": "{flexDirection.column}",
    "carousel_base_prefix-container_justify-content": "{justifyContent.center}",
    "carousel_base_prefix-container_align-items": "{alignItems.start}",
    "carousel_base_progress-container_flex-direction": "{flexDirection.stack}",
    "carousel_base_progress-container_justify-content": "{justifyContent.center}",
    "carousel_base_progress-container_align-items": "{alignItems.center}",
    "carousel_base_inner-container_flex-direction": "{flexDirection.row}",
    "carousel_base_inner-container_justify-content": "{justifyContent.start}",
    "carousel_base_inner-container_align-items": "{alignItems.start}",
    "carousel_base_right-container_max-width": "{size.max}",
    "carousel_base_right-container_flex-direction": "{flexDirection.row}",
    "carousel_base_right-container_justify-content": "{justifyContent.end}",
    "carousel_base_right-container_align-items": "{alignItems.start}",
    "carousel_base_right-container_gap": "{s}",
    "carousel_base_right-container_padding-top": "{xs}",
    "carousel_base_right-container_padding-bottom": "{xs}",
    carousel_variant_density_condensed_container_gap: $52d4442770cfd938$var$carousel_variant_density_condensed_container_gap
};
const $52d4442770cfd938$var$carouselpaginationitem_base_container_width = "{s}";
const $52d4442770cfd938$var$carouselpaginationitem_base_container_height = "{s}";
const $52d4442770cfd938$var$carouselpaginationitem_base_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$carouselpaginationitem_base_container_behavior_hover_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$carouselpaginationitem_base_container_behavior_active_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$carouselpaginationitem_variant_density_condensed_container_height = "{xs}";
const $52d4442770cfd938$var$carouselpaginationitem_variant_active_true_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_normal_container_width = "{s}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width = "{xs}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height = "{xs}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width = "{custom_15}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height = "{custom_15}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_normal_container_width = "{xs}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width = "{custom_15}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height = "{custom_15}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width = "{xxs}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height = "{xxs}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_true_normal_container_width = "{m}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width = "{m}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width = "{m}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_true_normal_container_width = "{l}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width = "{l}";
const $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width = "{l}";
const $52d4442770cfd938$var$CarouselPaginationItemTokens = {
    carouselpaginationitem_base_container_width: $52d4442770cfd938$var$carouselpaginationitem_base_container_width,
    carouselpaginationitem_base_container_height: $52d4442770cfd938$var$carouselpaginationitem_base_container_height,
    "carouselpaginationitem_base_container_background-color": "{primary60}",
    carouselpaginationitem_base_container_opacity: $52d4442770cfd938$var$carouselpaginationitem_base_container_opacity,
    "carouselpaginationitem_base_container_border-radius": "{pill}",
    "carouselpaginationitem_base_container_behavior_hover_background-color": "{primary40}",
    carouselpaginationitem_base_container_behavior_hover_opacity: $52d4442770cfd938$var$carouselpaginationitem_base_container_behavior_hover_opacity,
    "carouselpaginationitem_base_container_behavior_active_background-color": "{primary60}",
    carouselpaginationitem_base_container_behavior_active_opacity: $52d4442770cfd938$var$carouselpaginationitem_base_container_behavior_active_opacity,
    carouselpaginationitem_variant_density_condensed_container_height: $52d4442770cfd938$var$carouselpaginationitem_variant_density_condensed_container_height,
    carouselpaginationitem_variant_active_true_container_opacity: $52d4442770cfd938$var$carouselpaginationitem_variant_active_true_container_opacity,
    "carouselpaginationitem_variant_active_true_container_behavior_hover_background-color": "{primary70}",
    "carouselpaginationitem_variant_active_true_container_behavior_active_background-color": "{primary70}",
    carouselpaginationitem_combination_relaxed_false_normal_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_normal_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_large_container_height,
    carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_width,
    carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_false_tail_dot_small_container_height,
    carouselpaginationitem_combination_condensed_false_normal_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_normal_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_large_container_height,
    carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_width,
    carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_false_tail_dot_small_container_height,
    carouselpaginationitem_combination_condensed_true_normal_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_true_normal_container_width,
    carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_true_tail_dot_large_container_width,
    carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_condensed_true_tail_dot_small_container_width,
    carouselpaginationitem_combination_relaxed_true_normal_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_true_normal_container_width,
    carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_true_tail_dot_large_container_width,
    carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width: $52d4442770cfd938$var$carouselpaginationitem_combination_relaxed_true_tail_dot_small_container_width
};
const $52d4442770cfd938$var$carouselpagination_base_container_gap = "{s}";
const $52d4442770cfd938$var$carouselpagination_base_container_width = "{size.max}";
const $52d4442770cfd938$var$carouselpagination_variant_density_condensed_container_gap = "{xs}";
const $52d4442770cfd938$var$CarouselPaginationTokens = {
    "carouselpagination_base_container_flex-direction": "{flexDirection.row}",
    "carouselpagination_base_container_justify-content": "{justifyContent.center}",
    "carouselpagination_base_container_align-items": "{alignItems.center}",
    carouselpagination_base_container_gap: $52d4442770cfd938$var$carouselpagination_base_container_gap,
    "carouselpagination_base_container_padding-top": "{xs}",
    carouselpagination_base_container_width: $52d4442770cfd938$var$carouselpagination_base_container_width,
    "carouselpagination_base_container_padding-bottom": "{xs}",
    carouselpagination_variant_density_condensed_container_gap: $52d4442770cfd938$var$carouselpagination_variant_density_condensed_container_gap
};
const $52d4442770cfd938$var$button_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$button_base_container_gap = "{xs}";
const $52d4442770cfd938$var$button_base_loader_color = "{primaryInverse}";
const $52d4442770cfd938$var$button_base_loader_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$button_base_loader_size = "{base}";
const $52d4442770cfd938$var$button_variant_fullWidth_true_container_width = "{size.max}";
const $52d4442770cfd938$var$button_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$button_combination_primary_destructive_loader_color = "{feedbackError80}";
const $52d4442770cfd938$var$button_combination_primary_positive_loader_color = "{feedbackSuccess80}";
const $52d4442770cfd938$var$button_combination_secondary_normal_loader_color = "{primary60}";
const $52d4442770cfd938$var$button_combination_secondary_destructive_loader_color = "{feedbackError80}";
const $52d4442770cfd938$var$button_combination_secondary_positive_loader_color = "{feedbackSuccess80}";
const $52d4442770cfd938$var$button_combination_tertiary_normal_loader_color = "{primary60}";
const $52d4442770cfd938$var$button_combination_tertiary_destructive_loader_color = "{feedbackError80}";
const $52d4442770cfd938$var$button_combination_tertiary_positive_loader_color = "{feedbackSuccess80}";
const $52d4442770cfd938$var$button_combination_true_small_loader_size = "{base}";
const $52d4442770cfd938$var$button_combination_true_medium_loader_size = "{m}";
const $52d4442770cfd938$var$button_combination_true_large_loader_size = "{m}";
const $52d4442770cfd938$var$button_combination_false_small_loader_size = "{base}";
const $52d4442770cfd938$var$button_combination_false_medium_loader_size = "{m}";
const $52d4442770cfd938$var$button_combination_false_large_loader_size = "{m}";
const $52d4442770cfd938$var$ButtonTokens = {
    button_base_container_opacity: $52d4442770cfd938$var$button_base_container_opacity,
    "button_base_container_background-color": "{primary50}",
    "button_base_container_flex-direction": "{flexDirection.row}",
    "button_base_container_align-items": "{alignItems.center}",
    "button_base_container_justify-content": "{justifyContent.center}",
    "button_base_container_border-radius": "{pill}",
    "button_base_container_border-width": "0",
    "button_base_container_border-color": "",
    button_base_container_gap: $52d4442770cfd938$var$button_base_container_gap,
    "button_combination_tertiary_normal_container_border-width": 0,
    "button_base_container_behavior_hover_background-color": "{primary60}",
    "button_base_container_behavior_active_background-color": "{primary60}",
    "button_base_container_behavior_focus_border-width": "{border_focus}",
    "button_base_container_behavior_focus_border-color": "{primary80}",
    "button_base_left-container_flex-direction": "{flexDirection.row}",
    "button_base_left-container_align-items": "{alignItems.center}",
    "button_base_left-container_justify-content": "{justifyContent.start}",
    "button_base_left-container_gap": "{xs}",
    button_base_loader_color: $52d4442770cfd938$var$button_base_loader_color,
    "button_base_loader_background-color": "{global.transparent}",
    "button_base_loader_border-width": "{border_focus}",
    button_base_loader_opacity: $52d4442770cfd938$var$button_base_loader_opacity,
    button_base_loader_size: $52d4442770cfd938$var$button_base_loader_size,
    "button_base_left-icon_size": "{m}",
    "button_base_left-icon_color": "{primaryInverse}",
    "button_base_right-icon_size": "{m}",
    "button_base_right-icon_color": "{primaryInverse}",
    button_variant_fullWidth_true_container_width: $52d4442770cfd938$var$button_variant_fullWidth_true_container_width,
    "button_variant_fullWidth_true_container_justify-content": "{justifyContent.spaceBetween}",
    button_variant_disabled_true_container_opacity: $52d4442770cfd938$var$button_variant_disabled_true_container_opacity,
    "button_combination_primary_normal_left-icon_behavior_active_color": "{primary30}",
    "button_combination_primary_normal_right-icon_behavior_active_color": "{primary30}",
    "button_combination_primary_destructive_container_background-color": "{feedbackError20}",
    "button_combination_primary_destructive_container_behavior_hover_background-color": "{feedbackError50}",
    "button_combination_primary_destructive_container_behavior_active_background-color": "{feedbackError80}",
    "button_combination_primary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    button_combination_primary_destructive_loader_color: $52d4442770cfd938$var$button_combination_primary_destructive_loader_color,
    "button_combination_primary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_primary_destructive_left-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_destructive_left-icon_behavior_active_color": "{feedbackError20}",
    "button_combination_primary_destructive_right-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_primary_destructive_right-icon_behavior_active_color": "{feedbackError20}",
    "button_combination_primary_positive_container_background-color": "{feedbackSuccess20}",
    "button_combination_primary_positive_container_behavior_hover_background-color": "{feedbackSuccess50}",
    "button_combination_primary_positive_container_behavior_active_background-color": "{feedbackSuccess80}",
    "button_combination_primary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    button_combination_primary_positive_loader_color: $52d4442770cfd938$var$button_combination_primary_positive_loader_color,
    "button_combination_primary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_primary_positive_left-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_positive_left-icon_behavior_active_color": "{feedbackSuccess20}",
    "button_combination_primary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_primary_positive_right-icon_behavior_hover_color": "{global.white}",
    "button_combination_primary_positive_right-icon_behavior_active_color": "{feedbackSuccess20}",
    "button_combination_secondary_normal_container_background-color": "{global.transparent}",
    "button_combination_secondary_normal_container_border-width": "{border_thin}",
    "button_combination_secondary_normal_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_normal_container_behavior_hover_border-color": "{primary60}",
    "button_combination_secondary_normal_container_behavior_hover_background-color": "{global.transparent}",
    "button_combination_secondary_normal_container_behavior_active_background-color": "{primary20}",
    "button_combination_secondary_normal_container_behavior_active_border-color": "{primary60}",
    "button_combination_secondary_normal_container_behavior_focus_border-color": "{primary80}",
    button_combination_secondary_normal_loader_color: $52d4442770cfd938$var$button_combination_secondary_normal_loader_color,
    "button_combination_secondary_normal_left-icon_color": "{primary60}",
    "button_combination_secondary_normal_right-icon_color": "{primary60}",
    "button_combination_secondary_destructive_container_background-color": "{global.transparent}",
    "button_combination_secondary_destructive_container_border-width": "{border_thin}",
    "button_combination_secondary_destructive_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_destructive_container_behavior_active_background-color": "{feedbackError20}",
    "button_combination_secondary_destructive_container_behavior_active_border-color": "{feedbackError80}",
    "button_combination_secondary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    "button_combination_secondary_destructive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_secondary_destructive_loader_color: $52d4442770cfd938$var$button_combination_secondary_destructive_loader_color,
    "button_combination_secondary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_secondary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_secondary_positive_container_background-color": "{global.transparent}",
    "button_combination_secondary_positive_container_border-width": "{border_thin}",
    "button_combination_secondary_positive_container_border-color": "{primaryGrey40}",
    "button_combination_secondary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
    "button_combination_secondary_positive_container_behavior_active_border-color": "{feedbackSuccess80}",
    "button_combination_secondary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    "button_combination_secondary_positive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_secondary_positive_loader_color: $52d4442770cfd938$var$button_combination_secondary_positive_loader_color,
    "button_combination_secondary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_secondary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_tertiary_normal_container_background-color": "{global.transparent}",
    "button_combination_tertiary_normal_container_behavior_hover_background-color": "{primary20}",
    "button_combination_tertiary_normal_container_behavior_active_background-color": "{primary30}",
    "button_combination_tertiary_normal_container_behavior_focus_border-color": "{primary80}",
    "button_combination_tertiary_normal_container_behavior_focus_background-color": "{primary20}",
    button_combination_tertiary_normal_loader_color: $52d4442770cfd938$var$button_combination_tertiary_normal_loader_color,
    "button_combination_tertiary_normal_left-icon_color": "{primary60}",
    "button_combination_tertiary_normal_right-icon_color": "{primary60}",
    "button_combination_tertiary_destructive_container_background-color": "{global.transparent}",
    "button_combination_tertiary_destructive_container_behavior_hover_background-color": "{feedbackError20}",
    "button_combination_tertiary_destructive_container_behavior_active_background-color": "{feedbackError80}",
    "button_combination_tertiary_destructive_container_behavior_focus_border-color": "{feedbackError50}",
    "button_combination_tertiary_destructive_container_behavior_focus_border-width": "{border_focus}",
    "button_combination_tertiary_destructive_container_behavior_focus_background-color": "{feedbackError20}",
    button_combination_tertiary_destructive_loader_color: $52d4442770cfd938$var$button_combination_tertiary_destructive_loader_color,
    "button_combination_tertiary_destructive_left-icon_color": "{feedbackError80}",
    "button_combination_tertiary_destructive_right-icon_color": "{feedbackError80}",
    "button_combination_tertiary_positive_container_background-color": "{global.transparent}",
    "button_combination_tertiary_positive_container_behavior_active_background-color": "{feedbackSuccess20}",
    "button_combination_tertiary_positive_container_behavior_focus_border-color": "{feedbackSuccess50}",
    "button_combination_tertiary_positive_container_behavior_focus_border-width": "{border_focus}",
    button_combination_tertiary_positive_loader_color: $52d4442770cfd938$var$button_combination_tertiary_positive_loader_color,
    "button_combination_tertiary_positive_left-icon_color": "{feedbackSuccess80}",
    "button_combination_tertiary_positive_right-icon_color": "{feedbackSuccess80}",
    "button_combination_true_small_container_padding-top": "{xxs}",
    "button_combination_true_small_container_padding-right": "{base}",
    "button_combination_true_small_container_padding-bottom": "{xxs}",
    "button_combination_true_small_container_padding-left": "{base}",
    "button_combination_true_small_left-icon_size": "{base}",
    "button_combination_true_small_right-icon_size": "{base}",
    button_combination_true_small_loader_size: $52d4442770cfd938$var$button_combination_true_small_loader_size,
    "button_combination_true_medium_container_padding-top": "{s}",
    "button_combination_true_medium_container_padding-right": "{base}",
    "button_combination_true_medium_container_padding-bottom": "{s}",
    "button_combination_true_medium_container_padding-left": "{base}",
    "button_combination_true_medium_left-icon_size": "{m}",
    "button_combination_true_medium_right-icon_size": "{m}",
    button_combination_true_medium_loader_size: $52d4442770cfd938$var$button_combination_true_medium_loader_size,
    "button_combination_true_large_container_padding-top": "{base}",
    "button_combination_true_large_container_padding-left": "{m}",
    "button_combination_true_large_container_padding-bottom": "{base}",
    "button_combination_true_large_container_padding-right": "{m}",
    "button_combination_true_large_left-icon_size": "{m}",
    "button_combination_true_large_right-icon_size": "{m}",
    button_combination_true_large_loader_size: $52d4442770cfd938$var$button_combination_true_large_loader_size,
    "button_combination_false_small_container_min-height": "{l}",
    "button_combination_false_small_container_min-width": "{l}",
    "button_combination_false_small_left-icon_size": "{base}",
    "button_combination_false_small_right-icon_size": "{base}",
    button_combination_false_small_loader_size: $52d4442770cfd938$var$button_combination_false_small_loader_size,
    "button_combination_false_medium_container_min-height": "{xxl}",
    "button_combination_false_medium_container_min-width": "{xxl}",
    "button_combination_false_medium_left-icon_size": "{m}",
    "button_combination_false_medium_right-icon_size": "{m}",
    button_combination_false_medium_loader_size: $52d4442770cfd938$var$button_combination_false_medium_loader_size,
    "button_combination_false_large_left-icon_size": "{m}",
    "button_combination_false_large_right-icon_size": "{m}",
    button_combination_false_large_loader_size: $52d4442770cfd938$var$button_combination_false_large_loader_size,
    "button_combination_true_true_true_false_false_container_justify-content": "{justifyContent.center}",
    "button_combination_true_true_true_false_true_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_false_true_false_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_false_false_true_container_justify-content": "{justifyContent.center}",
    "button_combination_true_false_true_true_false_container_justify-content": "{justifyContent.center}"
};
const $52d4442770cfd938$var$ContentCardTokens = {
    "contentcard_base_root-container_width": "{size.max}",
    "contentcard_base_root-container_border-radius": "{xl}",
    "contentcard_base_root-container_flex-direction": "{flexDirection.column}",
    "contentcard_base_root-container_justify-content": "{justifyContent.start}",
    "contentcard_base_root-container_align-items": "{alignItems.start}",
    "contentcard_base_root-container_background-color": "{primaryBackground}",
    "contentcard_base_header-container_justify-content": "{justifyContent.start}",
    "contentcard_base_header-container_align-items": "{alignItems.start}",
    "contentcard_base_header-container_width": "{size.max}",
    "contentcard_base_header-container_padding-left": "{base}",
    "contentcard_base_header-container_padding-right": "{base}",
    "contentcard_base_header-container_padding-top": "{base}",
    "contentcard_base_children-container_justify-content": "{justifyContent.start}",
    "contentcard_base_children-container_align-items": "{alignItems.start}",
    "contentcard_base_children-container_width": "{size.max}",
    "contentcard_base_children-container_padding-left": "{base}",
    "contentcard_base_children-container_padding-right": "{base}",
    "contentcard_base_children-container_padding-bottom": "{base}",
    "contentcard_base_image-content-container_flex-direction": "{flexDirection.column}",
    "contentcard_base_image-content-container_width": "{size.max}",
    "contentcard_base_image-content-container_justify-content": "{justifyContent.start}",
    "contentcard_base_image-content-container_align-items": "{alignItems.start}",
    "contentcard_base_image-content-container_padding-top": "{base}",
    "contentcard_base_image-content-container_padding-bottom": "{base}",
    "contentcard_base_jds_content_block_padding-left": "{base}",
    "contentcard_base_jds_content_block_padding-right": "{base}",
    "contentcard_base_jds_content_block_padding-top": "{base}",
    "contentcard_base_footer-jds_text_padding-left": "{base}",
    "contentcard_base_footer-jds_text_padding-right": "{base}",
    "contentcard_base_footer-jds_text_padding-bottom": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_padding-left": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_padding-top": "{base}",
    "contentcard_combination_true_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
    "contentcard_combination_true_vertical_root-container_width": "{custom_10}",
    "contentcard_combination_false_horizontal_root-container_width": "{size.max}",
    "contentcard_combination_false_horizontal_image-content-container_padding-left": "{base}",
    "contentcard_combination_false_horizontal_image-content-container_padding-top": "{base}",
    "contentcard_combination_false_horizontal_image-content-container_flex-direction": "{flexDirection.row}",
    "contentcard_combination_true_vertical_mobile_root-container_width": "{size.max}"
};
const $52d4442770cfd938$var$carouselslide_base_container_width = "{size.max}";
const $52d4442770cfd938$var$carouselslide_base_jds_image_width = "{size.max}";
const $52d4442770cfd938$var$CarouselSlideTokens = {
    carouselslide_base_container_width: $52d4442770cfd938$var$carouselslide_base_container_width,
    "carouselslide_base_container_border-radius": "{small}",
    carouselslide_base_jds_image_width: $52d4442770cfd938$var$carouselslide_base_jds_image_width
};
const $52d4442770cfd938$var$ContentBlockTokens = {
    "contentblock_base_root-container_flex-direction": "{flexDirection.column}",
    "contentblock_base_root-container_align-items": "{alignItems.start}",
    "contentblock_base_root-container_justify-content": "{justifyContent.start}",
    "contentblock_base_root-container_width": "{size.max}",
    "contentblock_base_inner-container_flex-direction": "{flexDirection.column}",
    "contentblock_base_inner-container_align-items": "{alignItems.start}",
    "contentblock_base_inner-container_justify-content": "{justifyContent.start}",
    "contentblock_base_inner-container_width": "{size.max}",
    "contentblock_base_caption-container_padding-bottom": "{xs}",
    "contentblock_base_title-jds_text_padding-bottom": "{xxs}",
    "contentblock_base_description-jds_text_padding-bottom": "{m}",
    "contentblock_base_children-container_padding-bottom": "{m}",
    "contentblock_base_button-container_flex-direction": "{flexDirection.row}",
    "contentblock_base_button-container_width": "{size.max}",
    "contentblock_base_button-container_gap": "{xs}",
    "contentblock_variant_size_small_title-jds_text_padding-bottom": "{s}",
    "contentblock_variant_size_medium_caption-container_padding-bottom": "{s}",
    "contentblock_variant_size_medium_title-jds_text_padding-bottom": "{s}",
    "contentblock_variant_size_medium_button-container_gap": "{s}",
    "contentblock_variant_size_large_caption-container_padding-bottom": "{base}",
    "contentblock_variant_size_large_title-jds_text_padding-bottom": "{base}",
    "contentblock_variant_size_large_children-container_padding-bottom": "{l}",
    "contentblock_variant_size_large_button-container_gap": "{s}",
    "contentblock_variant_size_xtra-large_caption-container_padding-bottom": "{base}",
    "contentblock_variant_size_xtra-large_title-jds_text_padding-bottom": "{base}",
    "contentblock_variant_size_xtra-large_children-container_padding-bottom": "{l}",
    "contentblock_variant_size_xtra-large_button-container_gap": "{s}",
    "contentblock_variant_ctaWrap_vertical_button-container_flex-direction": "{flexDirection.column}",
    "contentblock_variant_singleButton_false_inner-container_width": "{size.max}",
    "contentblock_variant_singleButton_false_button-container_width": "{size.max}",
    "contentblock_combination_desktop_medium_title-jds_text_padding-bottom": "{base}",
    "contentblock_combination_desktop_large_title-jds_text_padding-bottom": "{m}",
    "contentblock_combination_desktop_xtra-large_title-jds_text_padding-bottom": "{m}",
    "contentblock_combination_true_xtra-xtra-small_root-container_flex-direction": "{flexDirection.row}",
    "contentblock_combination_true_xtra-xtra-small_root-container_justify-content": "{justifyContent.spaceBetween}",
    "contentblock_combination_true_xtra-xtra-small_root-container_align-items": "{alignItems.center}",
    "contentblock_combination_true_xtra-xtra-small_button-container_flex-direction": "{flexDirection.row}",
    "contentblock_combination_true_xtra-xtra-small_button-container_justify-content": "{justifyContent.end}",
    "contentblock_combination_true_xtra-xtra-small_button-container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$CheckboxTokens = {
    "checkbox_base_vertical-container_flex-direction": "{flexDirection.column}",
    "checkbox_base_vertical-container_justify-content": "{justifyContent.start}",
    "checkbox_base_vertical-container_align-items": "{alignItems.start}",
    "checkbox_base_vertical-container_gap": "{xs}",
    "checkbox_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "checkbox_base_horizontal-container_justify-content": "{justifyContent.start}",
    "checkbox_base_horizontal-container_align-items": "{alignItems.center}",
    "checkbox_base_horizontal-container_gap": "{xs}",
    "checkbox_base_control-container_min-width": "{m}",
    "checkbox_base_control-container_min-height": "{m}",
    "checkbox_base_control-container_flex-direction": "{flexDirection.row}",
    "checkbox_base_control-container_justify-content": "{justifyContent.center}",
    "checkbox_base_control-container_align-items": "{alignItems.center}",
    "checkbox_base_control-container_background-color": "{global.transparent}",
    "checkbox_base_control-container_border-radius": "{small}",
    "checkbox_base_control-container_border-width": "{border_thin}",
    "checkbox_base_control-container_border-color": "{primaryGrey80}",
    "checkbox_base_control-container_behavior_hover_border-color": "{primary40}",
    "checkbox_base_control-container_behavior_active_border-color": "{primary60}",
    "checkbox_base_control-container_behavior_focus_border-width": "{border_focus}",
    "checkbox_base_control-container_behavior_focus_border-color": "{primary60}",
    "checkbox_base_control-icon_size": "{base}",
    "checkbox_base_label-jds_text_text-align": "{textAlign.start}",
    "checkbox_variant_size_small_control-container_min-width": "{base}",
    "checkbox_variant_size_small_control-container_min-height": "{base}",
    "checkbox_variant_size_small_vertical-container_gap": "{xxs}",
    "checkbox_variant_size_small_control-icon_size": "{s}",
    "checkbox_variant_checked_true_control-icon_value": "ic_confirm",
    "checkbox_variant_checked_true_control-container_background-color": "{primary50}",
    "checkbox_variant_checked_true_control-container_behavior_hover_background-color": "{primary40}",
    "checkbox_variant_checked_true_control-container_behavior_active_background-color": "{primary60}",
    "checkbox_variant_checked_true_control-icon_color": "{primaryInverse}",
    "checkbox_variant_indeterminate_true_control-icon_value": "ic_minus",
    "checkbox_variant_indeterminate_true_control-container_background-color": "{primary50}",
    "checkbox_variant_indeterminate_true_control-container_behavior_hover_background-color": "{primary40}",
    "checkbox_variant_indeterminate_true_control-container_behavior_focus_background-color": "{primary50}",
    "checkbox_variant_indeterminate_true_control-icon_color": "{primaryInverse}",
    "checkbox_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "checkbox_base_vertical-container_opacity": "{opacity.enabled}"
};
const $52d4442770cfd938$var$datepickercalendarbutton_base_container_width = "{custom_7}";
const $52d4442770cfd938$var$datepickercalendarbutton_button_container_width = "{m}";
const $52d4442770cfd938$var$datepickercalendarbutton_base_container_height = "{xxl}";
const $52d4442770cfd938$var$datepickercalendarbutton_button_container_height = "{m}";
const $52d4442770cfd938$var$datepickercalendarbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$DatepickerCalendarButtonTokens = {
    "datepickercalendarbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickercalendarbutton_base_container_align-items": "{alignItems.center}",
    datepickercalendarbutton_base_container_width: $52d4442770cfd938$var$datepickercalendarbutton_base_container_width,
    datepickercalendarbutton_button_container_width: $52d4442770cfd938$var$datepickercalendarbutton_button_container_width,
    "datepickercalendarbutton_base_root-container_max_width": "{size.max}",
    datepickercalendarbutton_base_container_height: $52d4442770cfd938$var$datepickercalendarbutton_base_container_height,
    datepickercalendarbutton_button_container_height: $52d4442770cfd938$var$datepickercalendarbutton_button_container_height,
    "datepickercalendarbutton_base_button-container_flex-direction": "{flexDirection.row}",
    "datepickercalendarbutton_base_button-container_justify-content": "{justifyContent.center}",
    "datepickercalendarbutton_base_button-container_align-items": "{alignItems.center}",
    "datepickercalendarbutton_base_button-container_width": "{xxl}",
    "datepickercalendarbutton_base_button-container_instrinsic_width": "{intrinsicSize.min}",
    "datepickercalendarbutton_base_button-container_height": "{xxl}",
    "datepickercalendarbutton_base_button-container_border-radius": "{pill}",
    "datepickercalendarbutton_base_button-container_border-color": "{primaryGrey100}",
    "datepickercalendarbutton_base_button-container_background-color": "{global.transparent}",
    "datepickercalendarbutton_base_button-container_behavior_hover_background-color": "{primary20}",
    "datepickercalendarbutton_base_button-container_behavior_active_background-color": "{primary40}",
    "datepickercalendarbutton_base_button-container_behavior_focus_background-color": "{primary20}",
    "datepickercalendarbutton_base_button-container_behavior_focus_border-width": "{border_focus}",
    "datepickercalendarbutton_variant_state_selected_button-container_background-color": "{primary50}",
    "datepickercalendarbutton_variant_state_current_button-container_background-color": "{primary20}",
    datepickercalendarbutton_variant_disabled_true_container_opacity: $52d4442770cfd938$var$datepickercalendarbutton_variant_disabled_true_container_opacity,
    "datepickerbutton_base_container_padding-right": "{base}",
    "datepickerbutton_base_container_padding-left": "{base}"
};
const $52d4442770cfd938$var$datepickerbutton_base_container_height = "{xxl}";
const $52d4442770cfd938$var$datepickerbutton_base_container_gap = "{xs}";
const $52d4442770cfd938$var$datepickerbutton_variant_state_disabled_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$DatepickerButtonTokens = {
    datepickerbutton_base_container_height: $52d4442770cfd938$var$datepickerbutton_base_container_height,
    "datepickerbutton_base_container_max-width": "{custom_9}",
    "datepickerbutton_base_container_border-radius": "{pill}",
    "datepickerbutton_base_container_background-color": "{global.transparent}",
    "datepickerbutton_base_container_border-width": "{border_thin}",
    "datepickerbutton_base_container_border-color": "{primaryGrey40}",
    "datepickerbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickerbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickerbutton_base_container_align-items": "{alignItems.center}",
    datepickerbutton_base_container_gap: $52d4442770cfd938$var$datepickerbutton_base_container_gap,
    "datepickerbutton_base_container_padding-right": "{base}",
    "datepickerbutton_base_container_padding-left": "{base}",
    "datepickerbutton_base_container_behavior_hover_border-color": "{primary60}",
    "datepickerbutton_base_container_behavior_focus_border-color": "{primaryGrey100}",
    "datepickerbutton_base_container_behavior_focus_border-width": "{border_focus}",
    "datepickerbutton_base_container_behavior_active_border-color": "{primary60}",
    "datepickerbutton_base_container_behavior_active_background-color": "{primary20}",
    "datepickerbutton_variant_state_selected_container_background-color": "{primary20}",
    "datepickerbutton_variant_state_selected_container_border-color": "{primary60}",
    "datepickerbutton_variant_state_disabled_container_border-width": "{border_none}",
    datepickerbutton_variant_state_disabled_container_opacity: $52d4442770cfd938$var$datepickerbutton_variant_state_disabled_container_opacity,
    "datepickerbutton_variant_state_text_only_container_border-width": "{border_none}"
};
const $52d4442770cfd938$var$datepickercalendar_base_container_gap = "{s}";
const $52d4442770cfd938$var$DatepickerCalendarTokens = {
    "datepickercalendar_base_container_flex-direction": "{flexDirection.column}",
    "datepickercalendar_base_container_justify-content": "{justifyContent.start}",
    "datepickercalendar_base_container_align-items": "{alignItems.center}",
    datepickercalendar_base_container_gap: $52d4442770cfd938$var$datepickercalendar_base_container_gap,
    "datepickercalendar_base_rows-container_flex-direction": "{flexDirection.column}"
};
const $52d4442770cfd938$var$datepickerheader_base_container_width = "{size.max}";
const $52d4442770cfd938$var$datepickerheader_base_container_height = "{xxl}";
const $52d4442770cfd938$var$DatepickerHeaderTokens = {
    datepickerheader_base_container_width: $52d4442770cfd938$var$datepickerheader_base_container_width,
    datepickerheader_base_container_height: $52d4442770cfd938$var$datepickerheader_base_container_height,
    "datepickerheader_base_container_flex-direction": "{flexDirection.row}",
    "datepickerheader_base_container_justify-content": "{justifyContent.spaceBetween}",
    "datepickerheader_base_container_align-items": "{alignItems.center}",
    "datepickerheader_base_inner-container_height": "{xxl}",
    "datepickerheader_base_inner-container_flex-direction": "{flexDirection.row}",
    "datepickerheader_base_inner-container_justify-content": "{justifyContent.center}",
    "datepickerheader_base_inner-container_align-items": "{alignItems.center}",
    "datepickerheader_base_inner-container_gap": "{s}"
};
const $52d4442770cfd938$var$datepickerdesktop_base_container_opacity = "{opacity.invisible}";
const $52d4442770cfd938$var$datapickerdesktop_variant_open_true_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$DatepickerDesktopTokens = {
    "datepickerdesktop_base_popup-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_popup-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_popup-container_align-items": "{alignItems.center}",
    datepickerdesktop_base_container_opacity: $52d4442770cfd938$var$datepickerdesktop_base_container_opacity,
    "datepickerdesktop_base_container_background-color": "{primaryBackground}",
    "datepickerdesktop_base_container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_container_border-radius": "{xl}",
    "datepickerdesktop_base_top-container_flex-direction": "{flexDirection.row}",
    "datepickerdesktop_base_top-container_justify-content": "{justifyContent.end}",
    "datepickerdesktop_base_top-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_top-container_padding-top": "{xs}",
    "datepickerdesktop_base_top-container_padding-right": "{s}",
    "datepickerdesktop_base_top-container_padding-bottom": "{xs}",
    "datepickerdesktop_base_top-container_padding-left": "{s}",
    "datepickerdesktop_base_top-container_width": "{custom_6}",
    "datepickerdesktop_base_jds_datepicker_header_padding-right": "{m}",
    "datepickerdesktop_base_jds_datepicker_header_padding-left": "{m}",
    "datepickerdesktop_base_controls-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_controls-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_controls-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_controls-container_gap": "{m}",
    "datepickerdesktop_base_calender-view-container_flex-direction": "{flexDirection.column}",
    "datepickerdesktop_base_calender-view-container_justify-content": "{justifyContent.start}",
    "datepickerdesktop_base_calender-view-container_align-items": "{alignItems.center}",
    "datepickerdesktop_base_calender-view-container_height": "{size.max}",
    "datepickerdesktop_base_calender-view-container_width": "{size.max}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-right": "{m}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-left": "{m}",
    "datepickerdesktop_base_jds_datepicker_calendar_padding-bottom": "{m}",
    datapickerdesktop_variant_open_true_container_opacity: $52d4442770cfd938$var$datapickerdesktop_variant_open_true_container_opacity,
    "datepickerdesktop_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
    "datepickerdesktop_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};
const $52d4442770cfd938$var$datepickercalendarrow_base_container_width = "{size.max}";
const $52d4442770cfd938$var$DatepickerCalendarRowTokens = {
    "datepickercalendarrow_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarrow_base_container_justify-content": "{justifyContent.start}",
    "datepickercalendarrow_base_container_align-items": "{alignItems.center}",
    datepickercalendarrow_base_container_width: $52d4442770cfd938$var$datepickercalendarrow_base_container_width
};
const $52d4442770cfd938$var$datepickerviewbutton_base_container_height = "{xxl}";
const $52d4442770cfd938$var$datepickerviewbutton_base_container_width = "{custom_7}";
const $52d4442770cfd938$var$DatepickerViewButtonTokens = {
    "datepickerviewbutton_base_root-container_width": "{size.max}",
    "datepickerviewbutton_base_root-container_flex-direction": "{flexDirection.row}",
    "datepickerviewbutton_base_root-container_justify-content": "{justifyContent.center}",
    "datepickerviewbutton_base_root-container_align-items": "{alignItems.center}",
    datepickerviewbutton_base_container_height: $52d4442770cfd938$var$datepickerviewbutton_base_container_height,
    datepickerviewbutton_base_container_width: $52d4442770cfd938$var$datepickerviewbutton_base_container_width,
    "datepickerviewbutton_base_container_flex-direction": "{flexDirection.row}",
    "datepickerviewbutton_base_container_justify-content": "{justifyContent.center}",
    "datepickerviewbutton_base_container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$datepickercalendarheader_base_container_width = "{size.max}";
const $52d4442770cfd938$var$DatepickerCalendarHeaderTokens = {
    "datepickercalendarheader_base_container_flex-direction": "{flexDirection.row}",
    "datepickercalendarheader_base_container_justify-content": "{justifyContent.center}",
    "datepickercalendarheader_base_container_align-items": "{alignItems.center}",
    datepickercalendarheader_base_container_width: $52d4442770cfd938$var$datepickercalendarheader_base_container_width
};
const $52d4442770cfd938$var$datepickeryearview_base_container_width = "{size.max}";
const $52d4442770cfd938$var$DatepickerYearViewTokens = {
    "datepickeryearview_base_container_flex-direction": "{flexDirection.column}",
    datepickeryearview_base_container_width: $52d4442770cfd938$var$datepickeryearview_base_container_width,
    "datepickeryearview_base_container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$datepickermobile_base_container_size = "{size.max}";
const $52d4442770cfd938$var$DatepickerMobileTokens = {
    "datepickermobile_base_container_background-color": "{primaryBackground}",
    "datepickermobile_base_container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_container_align-items": "{alignItems.center}",
    datepickermobile_base_container_size: $52d4442770cfd938$var$datepickermobile_base_container_size,
    "datepickermobile_base_top-container_flex-direction": "{flexDirection.row}",
    "datepickermobile_base_top-container_justify-content": "{justifyContent.end}",
    "datepickermobile_base_top-container_align-items": "{alignItems.center}",
    "datepickermobile_base_top-container_padding-top": "{xs}",
    "datepickermobile_base_top-container_padding-bottom": "{xs}",
    "datepickermobile_base_top-container_padding-left": "{s}",
    "datepickermobile_base_top-container_padding-right": "{s}",
    "datepickermobile_base_top-container_width": "{size.max}",
    "datepickermobile_base_controls-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_controls-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_controls-container_align-items": "{alignItems.center}",
    "datepickermobile_base_controls-container_gap": "{m}",
    "datepickermobile_base_jds_datepicker_header_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_header_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_calendar_padding-bottom": "{m}",
    "datepickermobile_base_jds_datepicker_month_view_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_month_view_padding-right": "{s}",
    "datepickermobile_base_jds_datepicker_year_view_padding-left": "{s}",
    "datepickermobile_base_jds_datepicker_year_view_padding-right": "{s}",
    "datepickermobile_base_confirmation-container_padding-bottom": "{m}",
    "datepickermobile_base_confirmation-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_confirmation-container_gap": "{s}",
    "datepickermobile_base_confirmation-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_confirmation-container_align-items": "{alignItems.center}",
    "datepickermobile_base_confirmation-container_width": "{size.max}",
    "datepickermobile_base_confirmation-group-container_padding-right": "{m}",
    "datepickermobile_base_confirmation-group-container_padding-left": "{m}",
    "datepickermobile_base_confirmation-group-container_flex-direction": "{flexDirection.column}",
    "datepickermobile_base_confirmation-group-container_justify-content": "{justifyContent.start}",
    "datepickermobile_base_confirmation-group-container_align-items": "{alignItems.center}",
    "datepickermobile_base_confirmation-group-container_gap": "{s}",
    "datepickermobile_base_confirmation-group-container_width": "{size.max}",
    "datepickermobile_variant_state_month_view_top-container_justify-content": "{justifyContent.spaceBetween}",
    "datepickermobile_variant_state_year_view_top-container_justify-content": "{justifyContent.spaceBetween}"
};
const $52d4442770cfd938$var$datepickermonthview_base_container_height = "{custom_8}";
const $52d4442770cfd938$var$datepickermonthview_base_container_width = "{size.max}";
const $52d4442770cfd938$var$DatepickerMonthViewTokens = {
    "datepickermonthview_base_container_flex-direction": "{flexDirection.column}",
    datepickermonthview_base_container_height: $52d4442770cfd938$var$datepickermonthview_base_container_height,
    datepickermonthview_base_container_width: $52d4442770cfd938$var$datepickermonthview_base_container_width,
    "datepickermonthview_base_container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$dropdownmenu_base_jds_search_box_width = "{size.max}";
const $52d4442770cfd938$var$DropdownMenuTokens = {
    "dropdownmenu_base_popup_background-color": "{global.transparent}",
    "dropdownmenu_base_menu-container_background_color": "{primaryGrey20}",
    "dropdownmenu_base_menu-container_flex-direction": "{flexDirection.column}",
    "dropdownmenu_base_menu-group-container_flex-direction": "{flexDirection.column}",
    "dropdownmenu_base_menu-container_border-radius": "{large}",
    "dropdownmenu_base_menu-group-container_padding-top": "{xs}",
    "dropdownmenu_base_menu-group-container_padding-bottom": "{xs}",
    "dropdownmenu_base_search-container_padding-top": "{base}",
    "dropdownmenu_base_search-container_padding-left": "{base}",
    "dropdownmenu_base_search-container_padding-right": "{base}",
    "dropdownmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
    "dropdownmenu_base_search-container_width": "{size.max}",
    dropdownmenu_base_jds_search_box_width: $52d4442770cfd938$var$dropdownmenu_base_jds_search_box_width,
    "dropdownmenu_base_menu-group-container_width": "{size.max}",
    "dropdownmenu_variant__menuFullScreen_true_popup-container_size": "{size.max}",
    "dropdownmenu_variant__menuFullScreen_true_menu-container_size": "{size.max}",
    "dropdownmenu_base_menu-container_opacity": "{opacity.invisible}",
    "dropdownmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};
const $52d4442770cfd938$var$dropdownmenuitem_base_container_width = "{size.max}";
const $52d4442770cfd938$var$dropdownmenuitem_base_container_gap = "{s}";
const $52d4442770cfd938$var$dropdownmenuitem_base_icon_color = "{primary60}";
const $52d4442770cfd938$var$dropdownmenuitem_base_icon_size = "{m}";
const $52d4442770cfd938$var$dropdownmenuitem_base_icon_behaviour_active_color = "{primaryInverse}";
const $52d4442770cfd938$var$dropdownmenuitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$DropdownMenuItemTokens = {
    dropdownmenuitem_base_container_width: $52d4442770cfd938$var$dropdownmenuitem_base_container_width,
    "dropdownmenuitem_base_container_flex-direction": "{flexDirection.row}",
    "dropdownmenuitem_base_content-container_flex-direction": "{flexDirection.column}",
    dropdownmenuitem_base_container_gap: $52d4442770cfd938$var$dropdownmenuitem_base_container_gap,
    "dropdownmenuitem_base_container_background-color": "{primaryGrey20}",
    "dropdownmenuitem_base_container_behavior_hover_background-color": "{primaryBackground}",
    "dropdownmenuitem_base_container_behavior_active_background-color": "{primary50}",
    "dropdownmenuitem_base_label-jds_text_behavior_color": "{primaryGrey100}",
    "dropdownmenuitem_base_container_padding-top": "{xs}",
    "dropdownmenuitem_base_container_padding-right": "{base}",
    "dropdownmenuitem_base_container_padding-bottom": "{xs}",
    "dropdownmenuitem_base_container_padding-left": "{base}",
    "dropdownmenuitem_variant_selected_true_container_background-color": "{primary50}",
    "dropdownmenuitem_variant_selected_true_container_behavior_active_background-color": "{primary50}",
    "dropdownmenuitem_base_content-container_justify-content": "{justifyContent.start}",
    "dropdownmenuitem_base_content-container_align-items": "{alignItems.start}",
    "dropdownmenuitem_base_container_align-items": "{alignItems.center}",
    "dropdownmenuitem_base_prefix-container_align-self": "{alignItems.start}",
    dropdownmenuitem_base_icon_color: $52d4442770cfd938$var$dropdownmenuitem_base_icon_color,
    dropdownmenuitem_base_icon_size: $52d4442770cfd938$var$dropdownmenuitem_base_icon_size,
    dropdownmenuitem_base_icon_behaviour_active_color: $52d4442770cfd938$var$dropdownmenuitem_base_icon_behaviour_active_color,
    "dropdownmenuitem_variant_selected_true_icon-color": "{primaryInverse}",
    dropdownmenuitem_variant_disabled_true_container_opacity: $52d4442770cfd938$var$dropdownmenuitem_variant_disabled_true_container_opacity,
    "dropdownmenuitem_base_container_behavior_focus_border-radius": "{small}",
    "dropdownmenuitem_base_root-container_width": "{size.max}"
};
const $52d4442770cfd938$var$dropdownmenugroup_base_container_width = "{size.max}";
const $52d4442770cfd938$var$DropdownMenuGroupTokens = {
    dropdownmenugroup_base_container_width: $52d4442770cfd938$var$dropdownmenugroup_base_container_width,
    "dropdownmenugroup_base_container_flex-direction": "{flexDirection.column}",
    "dropdownmenugroup_base_menu-item-container_flex-direction": "{flexDirection.column}",
    "dropdownmenugroup_base_label-container_padding-top": "{xs}",
    "dropdownmenugroup_base_label-container_padding-left": "{base}",
    "dropdownmenugroup_base_label-container_padding-right": "{base}",
    "dropdownmenugroup_base_label-container_width": "{size.max}",
    "dropdownmenugroup_base_container_background-color": "{primaryGrey20}",
    "dropdownmenugroup_base_menu-item-container_width": "{size.max}"
};
const $52d4442770cfd938$var$DropdownMenuSubMenuTokens = {
    "dropdownmenusubmenu_base_popup_background-color": "{global.transparent}",
    "dropdownmenusubmenu_base_menu-container_background_color": "{primaryGrey20}",
    "dropdownmenusubmenu_base_menu-container_flex-direction": "{flexDirection.column}",
    "dropdownmenusubmenu_base_menu-container_border-radius": "{large}",
    "dropdownmenusubmenu_base_menu-container_padding-top": "{xs}",
    "dropdownmenusubmenu_base_menu-container_padding-bottom": "{xs}",
    "dropdownmenusubmenu_base_menu-container_box-shadow_color": "{custom_color_5}",
    "dropdownmenu_variant__platform_mobile_popup-container_size": "{size.max}",
    "dropdownmenu_variant__platform_mobile_menu-container_size": "{size.max}",
    "dropdownmenusubmenu_base_menu-container_opacity": "{opacity.invisible}",
    "dropdownmenusubmenu_variant__menuContainerVisible_true_menu-container_opacity": "{opacity.enabled}"
};
const $52d4442770cfd938$var$bottomfooter_base_container_background = "{global.transparent}";
const $52d4442770cfd938$var$bottomfooter_variant__platform_desktop_container_width = "{size.max}";
const $52d4442770cfd938$var$bottomfooter_variant__platform_mobile_container_gap = "{base}";
const $52d4442770cfd938$var$BottomFooterTokens = {
    "bottomfooter_base_container_flex-direction": "{flexDirection.row}",
    "bottomfooter_base_container_justify-content": "{justifyContent.spaceBetween}",
    "bottomfooter_base_container_align-items": "{alignItems.center}",
    "bottomfooter_base_container_padding-top": "{base}",
    "bottomfooter_base_container_padding-right": "{huge}",
    "bottomfooter_base_container_padding-bottom": "{base}",
    "bottomfooter_base_container_padding-left": "{huge}",
    bottomfooter_base_container_background: $52d4442770cfd938$var$bottomfooter_base_container_background,
    "bottomfooter_base_copyright-container_gap": "{base}",
    "bottomfooter_base_copyright-container_flex-direction": "{flexDirection.row}",
    "bottomfooter_base_copyright-container_align-items": "{alignItems.center}",
    "bottomfooter_base_informational-links-container_align-items": "{alignItems.center}",
    bottomfooter_variant__platform_desktop_container_width: $52d4442770cfd938$var$bottomfooter_variant__platform_desktop_container_width,
    "bottomfooter_variant__platform_mobile_container_flex-direction": "{flexDirection.column}",
    "bottomfooter_variant__platform_mobile_container_justify-content": "{justifyContent.start}",
    "bottomfooter_variant__platform_mobile_container_align-items": "{alignItems.start}",
    "bottomfooter_variant__platform_mobile_container_padding-right": "{m}",
    "bottomfooter_variant__platform_mobile_container_padding-bottom": "{m}",
    "bottomfooter_variant__platform_mobile_container_padding-left": "{m}",
    bottomfooter_variant__platform_mobile_container_gap: $52d4442770cfd938$var$bottomfooter_variant__platform_mobile_container_gap,
    "bottomfooter_variant__platform_mobile_copyright-container_flex-direction": "{flexDirection.column}",
    "bottomfooter_variant__platform_mobile_copyright-container_align-items": "{alignItems.start}",
    "bottomfooter_variant__platform_mobile_copyright-container_gap": "{base}"
};
const $52d4442770cfd938$var$divider_base_container_gap = "{xs}";
const $52d4442770cfd938$var$divider_variant_orientation_horizontal_container_width = "{size.max}";
const $52d4442770cfd938$var$divider_variant_orientation_vertical_container_height = "{size.max}";
const $52d4442770cfd938$var$DividerTokens = {
    "divider_base_container_background-color": "{global.transparent}",
    "divider_base_container_flex-direction": "{flexDirection.row}",
    "divider_base_container_justify-content": "{justifyContent.center}",
    "divider_base_container_align-items": "{alignItems.center}",
    divider_base_container_gap: $52d4442770cfd938$var$divider_base_container_gap,
    "divider_base_container_padding-left": "{s}",
    "divider_base_container_padding-right": "{s}",
    "divider_base_container_padding-top": "{s}",
    "divider_base_container_padding-bottom": "{s}",
    "divider_base_start-container_min-height": "{custom_5}",
    "divider_base_start-container_min-width": "{custom_5}",
    "divider_base_start-container_flex-direction": "{flexDirection.row}",
    "divider_base_start-container_background-color": "{primaryGrey40}",
    "divider_base_start-container_border-radius": "{pill}",
    "divider_base_end-container_min-height": "{custom_5}",
    "divider_base_end-container_min-width": "{custom_5}",
    "divider_base_end-container_flex-direction": "{flexDirection.row}",
    "divider_base_end-container_background-color": "{primaryGrey40}",
    "divider_base_end-container_border-radius": "{pill}",
    "divider_variant_variant_stepper_start-container_background-color": "{sparkle50}",
    "divider_variant_variant_stepper_end-container_background-color": "{sparkle50}",
    divider_variant_orientation_horizontal_container_width: $52d4442770cfd938$var$divider_variant_orientation_horizontal_container_width,
    divider_variant_orientation_vertical_container_height: $52d4442770cfd938$var$divider_variant_orientation_vertical_container_height,
    "divider_variant_orientation_vertical_container_flex-direction": "{flexDirection.column}",
    "divider_variant_orientation_vertical_start-container_flex-direction": "{flexDirection.column}",
    "divider_variant_orientation_vertical_end-container_flex-direction": "{flexDirection.column}",
    "divider_combination_base_all_container_padding-left": "{base}",
    "divider_combination_base_all_container_padding-right": "{base}",
    "divider_combination_base_all_container_padding-top": "{base}",
    "divider_combination_base_all_container_padding-bottom": "{base}",
    "divider_combination_base_left_container_padding-left": "{base}",
    "divider_combination_base_right_container_padding-right": "{base}",
    "divider_combination_base_top_container_padding-top": "{base}",
    "divider_combination_base_bottom_container_padding-bottom": "{base}",
    "divider_combination_base_vertical_container_padding-top": "{base}",
    "divider_combination_base_vertical_container_padding-bottom": "{base}",
    "divider_combination_base_horizontal_container_padding-left": "{base}",
    "divider_combination_base_horizontal_container_padding-right": "{base}",
    "divider_combination_medium_all_container_padding-left": "{m}",
    "divider_combination_medium_all_container_padding-right": "{m}",
    "divider_combination_medium_all_container_padding-top": "{m}",
    "divider_combination_medium_all_container_padding-bottom": "{m}",
    "divider_combination_medium_left_container_padding-left": "{m}",
    "divider_combination_medium_right_container_padding-right": "{m}",
    "divider_combination_medium_top_container_padding-top": "{m}",
    "divider_combination_medium_bottom_container_padding-bottom": "{m}",
    "divider_combination_medium_vertical_container_padding-top": "{m}",
    "divider_combination_medium_vertical_container_padding-bottom": "{m}",
    "divider_combination_medium_horizontal_container_padding-left": "{m}",
    "divider_combination_medium_horizontal_container_padding-right": "{m}",
    "divider_combination_xtra-small_all_container_padding-left": "{xs}",
    "divider_combination_xtra-small_all_container_padding-right": "{xs}",
    "divider_combination_xtra-small_all_container_padding-top": "{xs}",
    "divider_combination_xtra-small_all_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_left_container_padding-left": "{xs}",
    "divider_combination_xtra-small_right_container_padding-right": "{xs}",
    "divider_combination_xtra-small_top_container_padding-top": "{xs}",
    "divider_combination_xtra-small_bottom_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_vertical_container_padding-top": "{xs}",
    "divider_combination_xtra-small_vertical_container_padding-bottom": "{xs}",
    "divider_combination_xtra-small_horizontal_container_padding-left": "{xs}",
    "divider_combination_xtra-small_horizontal_container_padding-right": "{xs}",
    "divider_combination_xtra-xtra-small_all_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-right": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_all_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_left_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_right_container_padding-right": "{xxs}",
    "divider_combination_xtra-xtra-small_top_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_bottom_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_vertical_container_padding-top": "{xxs}",
    "divider_combination_xtra-xtra-small_vertical_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-small_horizontal_container_padding-left": "{xxs}",
    "divider_combination_xtra-xtra-small_horizontal_container_padding-bottom": "{xxs}",
    "divider_combination_xtra-xtra-large_all_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-right": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_all_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_left_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_right_container_padding-right": "{xxl}",
    "divider_combination_xtra-xtra-large_top_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_bottom_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_vertical_container_padding-top": "{xxl}",
    "divider_combination_xtra-xtra-large_vertical_container_padding-bottom": "{xxl}",
    "divider_combination_xtra-xtra-large_horizontal_container_padding-left": "{xxl}",
    "divider_combination_xtra-xtra-large_horizontal_container_padding-right": "{xxl}",
    "divider_combination_xtra-large_all_container_padding-left": "{xl}",
    "divider_combination_xtra-large_all_container_padding-right": "{xl}",
    "divider_combination_xtra-large_all_container_padding-top": "{xl}",
    "divider_combination_xtra-large_all_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_left_container_padding-left": "{xl}",
    "divider_combination_xtra-large_right_container_padding-right": "{xl}",
    "divider_combination_xtra-large_top_container_padding-top": "{xl}",
    "divider_combination_xtra-large_bottom_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_vertical_container_padding-top": "{xl}",
    "divider_combination_xtra-large_vertical_container_padding-bottom": "{xl}",
    "divider_combination_xtra-large_horizontal_container_padding-left": "{xl}",
    "divider_combination_xtra-large_horizontal_container_padding-right": "{xl}",
    "divider_combination_large_all_container_padding-left": "{l}",
    "divider_combination_large_all_container_padding-right": "{l}",
    "divider_combination_large_all_container_padding-top": "{l}",
    "divider_combination_large_all_container_padding-bottom": "{l}",
    "divider_combination_large_left_container_padding-left": "{l}",
    "divider_combination_large_right_container_padding-right": "{l}",
    "divider_combination_large_top_container_padding-top": "{l}",
    "divider_combination_large_bottom_container_padding-bottom": "{l}",
    "divider_combination_large_vertical_container_padding-top": "{l}",
    "divider_combination_large_vertical_container_padding-bottom": "{l}",
    "divider_combination_large_horizontal_container_padding-left": "{l}",
    "divider_combination_large_horizontal_container_padding-right": "{l}",
    "divider_combination_huge_all_container_padding-left": "{huge}",
    "divider_combination_huge_all_container_padding-right": "{huge}",
    "divider_combination_huge_all_container_padding-top": "{huge}",
    "divider_combination_huge_all_container_padding-bottom": "{huge}",
    "divider_combination_huge_left_container_padding-left": "{huge}",
    "divider_combination_huge_right_container_padding-right": "{huge}",
    "divider_combination_huge_top_container_padding-top": "{huge}",
    "divider_combination_huge_bottom_container_padding-bottom": "{huge}",
    "divider_combination_huge_vertical_container_padding-top": "{huge}",
    "divider_combination_huge_vertical_container_padding-bottom": "{huge}",
    "divider_combination_huge_horizontal_container_padding-left": "{huge}",
    "divider_combination_huge_horizontal_container_padding-right": "{huge}",
    "divider_combination_massive_all_container_padding-left": "{massive}",
    "divider_combination_massive_all_container_padding-right": "{massive}",
    "divider_combination_massive_all_container_padding-top": "{massive}",
    "divider_combination_massive_all_container_padding-bottom": "{massive}",
    "divider_combination_massive_left_container_padding-left": "{massive}",
    "divider_combination_massive_right_container_padding-right": "{massive}",
    "divider_combination_massive_top_container_padding-top": "{massive}",
    "divider_combination_massive_bottom_container_padding-bottom": "{massive}",
    "divider_combination_massive_vertical_container_padding-top": "{massive}",
    "divider_combination_massive_vertical_container_padding-bottom": "{massive}",
    "divider_combination_massive_horizontal_container_padding-left": "{massive}",
    "divider_combination_massive_horizontal_container_padding-right": "{massive}"
};
const $52d4442770cfd938$var$fab_base_container_gap = "{xs}";
const $52d4442770cfd938$var$fab_base_icon_size = "{m}";
const $52d4442770cfd938$var$fab_base_icon_color = "{secondaryInverse}";
const $52d4442770cfd938$var$fab_base_icon_behavior_active_color = "{secondary30}";
const $52d4442770cfd938$var$FABTokens = {
    "fab_base_popup-container_flex-direction": "{flexDirection.stack}",
    "fab_base_popup-container_justify-content": "{justifyContent.end}",
    "fab_base_popup-container_align-items": "{alignItems.end}",
    "fab_base_popup-container_size": "{size.max}",
    "fab_base_popup-container_padding-right": "{base}",
    "fab_base_popup-container_padding-bottom": "{base}",
    "fab_base_container_background-color": "{secondary50}",
    "fab_base_container_flex-direction": "{flexDirection.row}",
    "fab_base_container_justify-content": "{justifyContent.center}",
    "fab_base_container_align-items": "{alignItems.center}",
    fab_base_container_gap: $52d4442770cfd938$var$fab_base_container_gap,
    "fab_base_container_border-radius": "{pill}",
    "fab_base_container_padding-top": "{base}",
    "fab_base_container_padding-left": "{m}",
    "fab_base_container_padding-right": "{m}",
    "fab_base_container_padding-bottom": "{base}",
    "fab_base_container_border-color": "{primary80}",
    "fab_base_container_border-width": "{border_none}",
    "fab_base_container_behavior_hover_background-color": "{secondary60}",
    "fab_base_container_behavior_active_background-color": "{secondary60}",
    "fab_base_container_behavior_focus_background-color": "{secondary60}",
    "fab_base_container_behavior_focus_border-width": "{border_focus}",
    fab_base_icon_size: $52d4442770cfd938$var$fab_base_icon_size,
    fab_base_icon_color: $52d4442770cfd938$var$fab_base_icon_color,
    "fab_base_icon_border-radius": "{pill}",
    fab_base_icon_behavior_active_color: $52d4442770cfd938$var$fab_base_icon_behavior_active_color,
    "fab_variant_extend_false_container_padding-left": "{base}",
    "fab_variant_extend_false_container_padding-right": "{base}"
};
const $52d4442770cfd938$var$feedbackblock_base_container_gap = "{xs}";
const $52d4442770cfd938$var$feedbackblock_base_icon_size = "{m}";
const $52d4442770cfd938$var$feedbackblock_variant_size_s_icon_size = "{base}";
const $52d4442770cfd938$var$FeedbackBlockTokens = {
    "feedbackblock_base_container_flex-direction": "{flexDirection.row}",
    "feedbackblock_base_container_justify-content": "{justifyContent.center}",
    "feedbackblock_base_container_align-items": "{alignItems.center}",
    feedbackblock_base_container_gap: $52d4442770cfd938$var$feedbackblock_base_container_gap,
    "feedbackblock_variant_alignment_top_container_align-items": "{alignItems.start}",
    "feedbackblock_base_icon-flex-direction": "{flexDirection.row}",
    "feedbackblock_base_icon-container_justify-content": "{justifyContent.center}",
    "feedbackblock_base_icon-container_align-items": "{alignItems.center}",
    "feedbackblock_base_icon-container_height": "{m}",
    feedbackblock_base_icon_size: $52d4442770cfd938$var$feedbackblock_base_icon_size,
    "feedbackblock_variant_size_s_icon-container_height": "{custom_18}",
    feedbackblock_variant_size_s_icon_size: $52d4442770cfd938$var$feedbackblock_variant_size_s_icon_size
};
const $52d4442770cfd938$var$dropdown_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$dropdown_base_container_width = "{size.max}";
const $52d4442770cfd938$var$dropdown_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$dropdown_base_conatiner_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$DropdownTokens = {
    "dropdown_base_container_flex-direction": "{flexDirection.column}",
    dropdown_base_container_gap: $52d4442770cfd938$var$dropdown_base_container_gap,
    dropdown_base_container_width: $52d4442770cfd938$var$dropdown_base_container_width,
    "dropdown_base_container_justify-content": "{justifyContent.start}",
    "dropdown_base_container_align-items": "{alignItems.start}",
    "dropdown_base_field-container_flex-direction": "{flexDirection.stack}",
    "dropdown_base_field-container_width": "{size.max}",
    "dropdown_base_field-container_align-items": "{alignItems.end}",
    "dropdown_base_field-container_justify-content": "{justifyContent.start}",
    "dropdown_base_field-container_padding-bottom": "{xxs}",
    "dropdown_base_text-container_flex-direction": "{flexDirection.row}",
    "dropdown_base_text-container_gap": "{xs}",
    "dropdown_base_select-container_flex-direction": "{flexDirection.row}",
    "dropdown_base_select-container_justify-content": "{justifyContent.end}",
    "dropdown_base_select-container_width": "{size.max}",
    "dropdown_base_select-container_align-items": "{alignItems.center}",
    "dropdown_base_active-line-container_flex-direction": "{flexDirection.column}",
    "dropdown_base_active-line-container_width": "{size.max}",
    "dropdown_base_active-line-container_align-items": "{alignItems.center}",
    "dropdown_base_feedback-container_width": "{size.max}",
    "dropdown_base_feedback-container_background-color": "{primaryGrey100}",
    "dropdown_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "dropdown_base_feedback-container_behavior_focus_background-color": "{primary50}",
    "dropdown_base_feedback-container_behavior_active_background-color": "{primary50}",
    "dropdown_variant_border_true-select-container_border-width": "{border_thin}",
    "dropdown_variant_border_true-select-container_border-color": "{primaryGrey60}",
    "dropdown_variant_border_true-select-container_border-radius": "{medium}",
    "dropdown_variant_border_true-select-container_padding-top": "{custom_17}",
    "dropdown_variant_border_true-select-container_padding-bottom": "{custom_17}",
    "dropdown_variant_border_true-select-container_padding-left": "{s}",
    "dropdown_variant_border_true-select-container_padding-right": "{xs}",
    "dropdown_variant_border_true-select-container_behavior_hover_background-color": "{primartGrey60}",
    "dropdown_variant_border_true-select-container_behavior_focus_background-color": "{white}",
    "dropdown_variant_border_true-select-container_behavior_active_background-color": "{white}",
    "dropdown_base_prefix-icon_size": "{m}",
    "dropdown_base_prefix-icon_color": "{primaryGrey80}",
    dropdown_variant_disabled_true_container_opacity: $52d4442770cfd938$var$dropdown_variant_disabled_true_container_opacity,
    dropdown_base_conatiner_opacity: $52d4442770cfd938$var$dropdown_base_conatiner_opacity,
    "dropdown_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "dropdown_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "dropdown_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "dropdown_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "dropdown_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "dropdown_variant_border_true-select-container_background-color": "{primaryGrey20}",
    "dropdown_variant_border_true-select-container_height": "{xl}",
    "dropdown_combination_true_true_field-container_align-items": "{alignItems.start}",
    "dropdown_combination_true_false_field-container_align-items": "{alignItems.start}",
    "dropdown_combination_false_true_field-container_align-items": "{alignItems.end}",
    "dropdown_combination_false_true_label-jds_text_padding-left": "{l}",
    "dropdown_combination_false_false_field-container_align-items": "{alignItems.end}",
    "dropdown_combination_false_true_select-container_padding-left": "{s}",
    "dropdown_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $52d4442770cfd938$var$bottomfooterlinkitem_base_container_gap = "{base}";
const $52d4442770cfd938$var$BottomFooterLinkItemTokens = {
    bottomfooterlinkitem_base_container_gap: $52d4442770cfd938$var$bottomfooterlinkitem_base_container_gap
};
const $52d4442770cfd938$var$footer_base_container_size = "{size.max}";
const $52d4442770cfd938$var$FooterTokens = {
    "footer_base_container_flex-direction": "{flexDirection.column}",
    "footer_base_container_align-items": "{alignItems.center}",
    footer_base_container_size: $52d4442770cfd938$var$footer_base_container_size,
    "footer_base_container_background-color": "{primaryGrey20}",
    "footer_base_main-container_flex-direction": "{flexDirection.row}",
    "footer_base_main-container_justify-content": "{justifyContent.spaceBetween}",
    "footer_base_main-container_align-items": "{alignItems.start}",
    "footer_base_main-container_gap": "{base}",
    "footer_base_main-container_size": "{size.max}",
    "footer_base_main-container_padding-top": "{xl}",
    "footer_base_main-container_padding-bottom": "{xl}",
    "footer_base_main-container_padding-left": "{huge}",
    "footer_base_main-container_padding-right": "{huge}",
    "footer_base_social-links-container_padding-top": "{xs}",
    "footer_base_social-links-container_flex-direction": "{flexDirection.column}",
    "footer_base_social-links-container_gap": "{l}",
    "footer_base_bottom-container_flex-direction": "{flexDirection.column}",
    "footer_base_bottom-container_align-items": "{alignItems.start}",
    "footer_base_bottom-container_width": "{size.max}",
    "footer_base_content-container_width": "{size.max}",
    "footer_base_content-slot_width": "{size.max}",
    "footer_variant__platform_mobile_bottom-container_gap": "{m}",
    "footer_variant__platform_mobile_main-container_flex-direction": "{flexDirection.column}",
    "footer_variant__platform_mobile_main-container_justify-content": "{justifyContent.start}",
    "footer_variant__platform_mobile_main-container_padding-top": "{m}",
    "footer_variant__platform_mobile_main-container_padding-bottom": "{xl}",
    "footer_variant__platform_mobile_main-container_padding-left": "{m}",
    "footer_variant__platform_mobile_main-container_padding-right": "{m}",
    "footer_base_social-links-container_width": "{custom_17}"
};
const $52d4442770cfd938$var$footerlinksgrid_base_container_size = "{size.max}";
const $52d4442770cfd938$var$footerlinksgrid_base_container_gap = "{base}";
const $52d4442770cfd938$var$FooterLinksGridTokens = {
    "footerlinksgrid_base_container_flex-direction": "{flexDirection.row}",
    footerlinksgrid_base_container_size: $52d4442770cfd938$var$footerlinksgrid_base_container_size,
    footerlinksgrid_base_container_gap: $52d4442770cfd938$var$footerlinksgrid_base_container_gap
};
const $52d4442770cfd938$var$footericonlinks_base_container_gap = "{base}";
const $52d4442770cfd938$var$FooterIconLinksTokens = {
    footericonlinks_base_container_gap: $52d4442770cfd938$var$footericonlinks_base_container_gap,
    "footericonlinks_base_container_flex-direction": "{flexDirection.column}",
    "footericonlinks_base_container_align-items": "{alignItems.start}",
    "footericonlinks_base_icons-container_flex-direction": "{flexDirection.row}",
    "footericonlinks_base_icons-container_gap": "{base}"
};
const $52d4442770cfd938$var$footermarketlinks_base_container_gap = "{base}";
const $52d4442770cfd938$var$FooterMarketLinksTokens = {
    footermarketlinks_base_container_gap: $52d4442770cfd938$var$footermarketlinks_base_container_gap,
    "footermarketlinks_base_container_flex-direction": "{flexDirection.column}",
    "footermarketlinks_base_container_align-items": "{alignItems.start}",
    "footermarketlinks_base_assets-container_flex-direction": "{flexDirection.row}",
    "footermarketlinks_base_assets-container_align-items": "{alignItems.center}",
    "footermarketlinks_base_assets-container_gap": "{base}"
};
const $52d4442770cfd938$var$footerlinks_base_container_size = "{size.max}";
const $52d4442770cfd938$var$FooterLinksTokens = {
    "footerlinks_base_container_flex-direction": "{flexDirection.column}",
    "footerlinks_base_container_align-items": "{alignItems.start}",
    footerlinks_base_container_size: $52d4442770cfd938$var$footerlinks_base_container_size,
    "footerlinks_base_link-item-container_size": "{size.max}",
    "footerlinks_base_link-item-container_padding-top": "{xs}",
    "footerlinks_base_link-item-container_padding-bottom": "{xs}",
    "footerlinks_base_link-item-container_flex-direction": "{flexDirection.column}",
    "footerlinks_base_link-item-container_justify-content": "{justifyContent.start}",
    "footerlinks_base_link-item-container_align-items": "{alignItems.start}",
    "footerlinks_base_link-item-container_background-color": "{global.transparent}",
    "footerlinks_base_link-item-container_behavior_hover_background-color": "{primaryGrey40}",
    "footerlinks_base_title-jds_text_padding-top": "{xs}",
    "footerlinks_base_title-jds_text_padding-bottom": "{xs}",
    "footerlinks_base_links-container_padding-top": "{s}",
    "footerlinks_base_links-container_size": "{size.max}",
    "footerlinks_base_links-container_flex-direction": "{flexDirection.column}"
};
const $52d4442770cfd938$var$BaseIconTokens = {
    "base-icon_base_icon_size": "{base}",
    "base-icon_base_icon_color": "{primary50}",
    "base-icon_variant_color_primary_30_icon_color": "{primary30}",
    "base-icon_variant_color_primary_60_icon_color": "{primary60}",
    "base-icon_variant_color_primary_70_icon_color": "{primary70}",
    "base-icon_variant_color_primary_background_icon_color": "{primaryBackground}",
    "base-icon_variant_color_secondary_50_icon_color": "{secondary50}",
    "base-icon_variant_color_sparkle_50_icon_color": "{sparkle50}",
    "base-icon_variant_color_primary_grey_60_icon_color": "{primaryGrey60}",
    "base-icon_variant_color_primary_grey_80_icon_color": "{primaryGrey80}",
    "base-icon_variant_color_primary_grey_100_icon_color": "{primaryGrey100}",
    "base-icon_variant_color_feedback_success_icon_color": "{feedbackSuccess50}",
    "base-icon_variant_color_feedback_error_icon_color": "{feedbackError50}",
    "base-icon_variant_color_feedback_warning_icon_color": "{feedbackWarning50}",
    "base-icon_variant_color_white_icon_color": "{global.white}",
    "base-icon_variant_color_none_icon_color": "{custom_color_1}"
};
const $52d4442770cfd938$var$icon_base_container_size = "{m}";
const $52d4442770cfd938$var$icon_base_icon_size = "{m}";
const $52d4442770cfd938$var$icon_base_icon_color = "{custom_color_1}";
const $52d4442770cfd938$var$icon_variant_color_primary_50_icon_color = "{primary50}";
const $52d4442770cfd938$var$icon_variant_color_primary_30_icon_color = "{primary30}";
const $52d4442770cfd938$var$icon_variant_color_primary_60_icon_color = "{primary60}";
const $52d4442770cfd938$var$icon_variant_color_primary_70_icon_color = "{primary70}";
const $52d4442770cfd938$var$icon_variant_color_primary_background_icon_color = "{primaryBackground}";
const $52d4442770cfd938$var$icon_variant_color_secondary_50_icon_color = "{secondary50}";
const $52d4442770cfd938$var$icon_variant_color_sparkle_50_icon_color = "{sparkle50}";
const $52d4442770cfd938$var$icon_variant_color_primary_grey_60_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$icon_variant_color_primary_grey_80_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$icon_variant_color_primary_grey_100_icon_color = "{primaryGrey100}";
const $52d4442770cfd938$var$icon_variant_color_feedback_success_icon_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$icon_variant_color_feedback_error_icon_color = "{feedbackError50}";
const $52d4442770cfd938$var$icon_variant_color_feedback_warning_icon_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$icon_variant_color_white_icon_color = "{global.white}";
const $52d4442770cfd938$var$icon_variant_size_small_container_size = "{base}";
const $52d4442770cfd938$var$icon_variant_size_small_icon_size = "{base}";
const $52d4442770cfd938$var$icon_variant_size_large_container_size = "{l}";
const $52d4442770cfd938$var$icon_variant_size_large_icon_size = "{l}";
const $52d4442770cfd938$var$icon_variant_size_fill_container_size = "{size.max}";
const $52d4442770cfd938$var$icon_variant_size_fill_icon_size = "{size.max}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_50_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_30_icon_color = "{primary30}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_60_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_70_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_background_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_secondary_50_icon_color = "{secondaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_sparkle_50_icon_color = "{sparkleInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_grey_60_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_grey_80_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_primary_grey_100_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_white_icon_color = "{global.white}";
const $52d4442770cfd938$var$icon_combination_background_bold_feedback_success_50_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_feedback_error_50_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_background_bold_feedback_warning_50_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_medium_background_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_icon_size = "{base}";
const $52d4442770cfd938$var$icon_combination_small_background_container_size = "{base}";
const $52d4442770cfd938$var$icon_combination_small_background_icon_size = "{base}";
const $52d4442770cfd938$var$icon_combination_large_background_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_50_icon_color = "{primary50}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_30_icon_color = "{primary30}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_60_icon_color = "{primary60}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_70_icon_color = "{primary70}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_background_icon_color = "{primaryBackground}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_secondary_50_icon_color = "{secondary50}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_sparkle_50_icon_color = "{sparkle50}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_grey_60_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_grey_80_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_primary_grey_100_icon_color = "{primaryGrey100}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_white_icon_color = "{global.white}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_feedback_success_50_icon_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_feedback_error_50_icon_color = "{feedbackError50}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_feedback_warning_50_icon_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_icon_size = "{base}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_container_size = "{base}";
const $52d4442770cfd938$var$icon_combination_small_background_bold_icon_size = "{base}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_feedback_success_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_feedback_error_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_feedback_warning_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_feedback_success_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_feedback_error_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_feedback_warning_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_success_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_error_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_warning_container_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_success_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_error_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_warning_icon_size = "{m}";
const $52d4442770cfd938$var$icon_combination_large_background_feedback_success_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_feedback_error_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_feedback_warning_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_feedback_success_icon_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_feedback_error_icon_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_feedback_warning_icon_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_success_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_error_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_warning_container_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_success_icon_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_error_icon_size = "{l}";
const $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_warning_icon_size = "{l}";
const $52d4442770cfd938$var$icon_combination_inverse_primary_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$icon_combination_inverse_secondary_icon_color = "{secondaryInverse}";
const $52d4442770cfd938$var$icon_combination_inverse_sparkle_icon_color = "{sparkleInverse}";
const $52d4442770cfd938$var$icon_combination_inverse_feedback_icon_color = "{global.white}";
const $52d4442770cfd938$var$IconTokens = {
    "icon_base_container_background-color": "{global.transparent}",
    "icon_base_container_border-radius": "{pill}",
    icon_base_container_size: $52d4442770cfd938$var$icon_base_container_size,
    "icon_base_container_justify-content": "{justifyContent.center}",
    "icon_base_container_align-items": "{alignItems.center}",
    icon_base_icon_size: $52d4442770cfd938$var$icon_base_icon_size,
    icon_base_icon_color: $52d4442770cfd938$var$icon_base_icon_color,
    icon_variant_color_primary_50_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_50_icon_color,
    icon_variant_color_primary_30_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_30_icon_color,
    icon_variant_color_primary_60_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_60_icon_color,
    icon_variant_color_primary_70_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_70_icon_color,
    icon_variant_color_primary_background_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_background_icon_color,
    icon_variant_color_secondary_50_icon_color: $52d4442770cfd938$var$icon_variant_color_secondary_50_icon_color,
    icon_variant_color_sparkle_50_icon_color: $52d4442770cfd938$var$icon_variant_color_sparkle_50_icon_color,
    icon_variant_color_primary_grey_60_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_grey_60_icon_color,
    icon_variant_color_primary_grey_80_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_grey_80_icon_color,
    icon_variant_color_primary_grey_100_icon_color: $52d4442770cfd938$var$icon_variant_color_primary_grey_100_icon_color,
    icon_variant_color_feedback_success_icon_color: $52d4442770cfd938$var$icon_variant_color_feedback_success_icon_color,
    icon_variant_color_feedback_error_icon_color: $52d4442770cfd938$var$icon_variant_color_feedback_error_icon_color,
    icon_variant_color_feedback_warning_icon_color: $52d4442770cfd938$var$icon_variant_color_feedback_warning_icon_color,
    icon_variant_color_white_icon_color: $52d4442770cfd938$var$icon_variant_color_white_icon_color,
    icon_variant_size_small_container_size: $52d4442770cfd938$var$icon_variant_size_small_container_size,
    icon_variant_size_small_icon_size: $52d4442770cfd938$var$icon_variant_size_small_icon_size,
    icon_variant_size_large_container_size: $52d4442770cfd938$var$icon_variant_size_large_container_size,
    icon_variant_size_large_icon_size: $52d4442770cfd938$var$icon_variant_size_large_icon_size,
    "icon_variant_size_xtra-large_container_size": "{xl}",
    "icon_variant_size_xtra-large_icon_size": "{xl}",
    "icon_variant_size_xtra-xtra-large_container_size": "{xxl}",
    "icon_variant_size_xtra-xtra-large_icon_size": "{xxl}",
    icon_variant_size_fill_container_size: $52d4442770cfd938$var$icon_variant_size_fill_container_size,
    icon_variant_size_fill_icon_size: $52d4442770cfd938$var$icon_variant_size_fill_icon_size,
    "icon_combination_background_primary_50_container_background-color": "{primary20}",
    "icon_combination_background_primary_30_container_background-color": "{primary20}",
    "icon_combination_background_primary_60_container_background-color": "{primary20}",
    "icon_combination_background_primary_70_container_background-color": "{primary20}",
    "icon_combination_background_primary_background_container_background-color": "{primary20}",
    "icon_combination_background_secondary_50_container_background-color": "{secondary20}",
    "icon_combination_background_sparkle_50_container_background-color": "{sparkle20}",
    "icon_combination_background_primary_grey_60_container_background-color": "{primaryGrey20}",
    "icon_combination_background_primary_grey_80_container_background-color": "{primaryGrey20}",
    "icon_combination_background_primary_grey_100_container_background-color": "{primaryGrey20}",
    "icon_combination_background_white_container_background-color": "{primary20}",
    "icon_combination_background_feedback_success_50_container_background-color": "{feedbackSuccess20}",
    "icon_combination_background_feedback_error_50_container_background-color": "{feedbackError20}",
    "icon_combination_background_feedback_warning_50_container_background-color": "{feedbackWarning20}",
    "icon_combination_background_bold_primary_50_container_background-color": "{primary50}",
    icon_combination_background_bold_primary_50_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_50_icon_color,
    "icon_combination_background_bold_primary_30_container_background-color": "{primary30}",
    icon_combination_background_bold_primary_30_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_30_icon_color,
    "icon_combination_background_bold_primary_60_container_background-color": "{primary60}",
    icon_combination_background_bold_primary_60_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_60_icon_color,
    "icon_combination_background_bold_primary_70_container_background-color": "{primary70}",
    icon_combination_background_bold_primary_70_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_70_icon_color,
    "icon_combination_background_bold_primary_background_container_background-color": "{primaryBackground}",
    icon_combination_background_bold_primary_background_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_background_icon_color,
    "icon_combination_background_bold_secondary_50_container_background-color": "{secondary50}",
    icon_combination_background_bold_secondary_50_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_secondary_50_icon_color,
    "icon_combination_background_bold_sparkle_50_container_background-color": "{sparkle50}",
    icon_combination_background_bold_sparkle_50_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_sparkle_50_icon_color,
    "icon_combination_background_bold_primary_grey_60_container_background-color": "{primaryGrey60}",
    icon_combination_background_bold_primary_grey_60_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_grey_60_icon_color,
    "icon_combination_background_bold_primary_grey_80_container_background-color": "{primaryGrey80}",
    icon_combination_background_bold_primary_grey_80_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_grey_80_icon_color,
    "icon_combination_background_bold_primary_grey_100_container_background-color": "{primaryGrey100}",
    icon_combination_background_bold_primary_grey_100_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_primary_grey_100_icon_color,
    "icon_combination_background_bold_white_container_background-color": "{global.white}",
    icon_combination_background_bold_white_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_white_icon_color,
    "icon_combination_background_bold_feedback_success_50_container_background-color": "{feedbackSuccess50}",
    icon_combination_background_bold_feedback_success_50_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_feedback_success_50_icon_color,
    "icon_combination_background_bold_feedback_error_50_container_background-color": "{feedbackError50}",
    icon_combination_background_bold_feedback_error_50_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_feedback_error_50_icon_color,
    "icon_combination_background_bold_feedback_warning_50_container_background-color": "{feedbackWarning50}",
    icon_combination_background_bold_feedback_warning_50_icon_color: $52d4442770cfd938$var$icon_combination_background_bold_feedback_warning_50_icon_color,
    icon_combination_medium_background_container_size: $52d4442770cfd938$var$icon_combination_medium_background_container_size,
    icon_combination_medium_background_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_icon_size,
    icon_combination_small_background_container_size: $52d4442770cfd938$var$icon_combination_small_background_container_size,
    "icon_combination_small_background_container_background-color": "{global.transparent}",
    icon_combination_small_background_icon_size: $52d4442770cfd938$var$icon_combination_small_background_icon_size,
    icon_combination_large_background_container_size: $52d4442770cfd938$var$icon_combination_large_background_container_size,
    icon_combination_large_background_icon_size: $52d4442770cfd938$var$icon_combination_large_background_icon_size,
    "icon_combination_xtra-large_background_container_size": "{xl}",
    "icon_combination_xtra-large_background_icon_size": "{custom_3}",
    "icon_combination_xtra-xtra-large_background_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_icon_size": "{l}",
    "icon_combination_small_background_bold_primary_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_50_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_50_icon_color,
    "icon_combination_small_background_bold_primary_30_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_30_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_30_icon_color,
    "icon_combination_small_background_bold_primary_60_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_60_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_60_icon_color,
    "icon_combination_small_background_bold_primary_70_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_70_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_70_icon_color,
    "icon_combination_small_background_bold_primary_background_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_background_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_background_icon_color,
    "icon_combination_small_background_bold_secondary_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_secondary_50_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_secondary_50_icon_color,
    "icon_combination_small_background_bold_sparkle_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_sparkle_50_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_sparkle_50_icon_color,
    "icon_combination_small_background_bold_primary_grey_60_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_60_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_grey_60_icon_color,
    "icon_combination_small_background_bold_primary_grey_80_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_80_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_grey_80_icon_color,
    "icon_combination_small_background_bold_primary_grey_100_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_primary_grey_100_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_primary_grey_100_icon_color,
    "icon_combination_small_background_bold_white_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_white_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_white_icon_color,
    "icon_combination_small_background_bold_feedback_success_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_success_50_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_feedback_success_50_icon_color,
    "icon_combination_small_background_bold_feedback_error_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_error_50_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_feedback_error_50_icon_color,
    "icon_combination_small_background_bold_feedback_warning_50_container_background-color": "{global.transparent}",
    icon_combination_small_background_bold_feedback_warning_50_icon_color: $52d4442770cfd938$var$icon_combination_small_background_bold_feedback_warning_50_icon_color,
    icon_combination_medium_background_bold_container_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_container_size,
    icon_combination_medium_background_bold_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_icon_size,
    icon_combination_small_background_bold_container_size: $52d4442770cfd938$var$icon_combination_small_background_bold_container_size,
    icon_combination_small_background_bold_icon_size: $52d4442770cfd938$var$icon_combination_small_background_bold_icon_size,
    icon_combination_large_background_bold_container_size: $52d4442770cfd938$var$icon_combination_large_background_bold_container_size,
    icon_combination_large_background_bold_icon_size: $52d4442770cfd938$var$icon_combination_large_background_bold_icon_size,
    "icon_combination_xtra-large_background_bold_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_icon_size": "{custom_3}",
    "icon_combination_xtra-xtra-large_background_bold_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_icon_size": "{l}",
    icon_combination_medium_background_feedback_success_container_size: $52d4442770cfd938$var$icon_combination_medium_background_feedback_success_container_size,
    icon_combination_medium_background_feedback_error_container_size: $52d4442770cfd938$var$icon_combination_medium_background_feedback_error_container_size,
    icon_combination_medium_background_feedback_warning_container_size: $52d4442770cfd938$var$icon_combination_medium_background_feedback_warning_container_size,
    icon_combination_medium_background_feedback_success_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_feedback_success_icon_size,
    icon_combination_medium_background_feedback_error_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_feedback_error_icon_size,
    icon_combination_medium_background_feedback_warning_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_feedback_warning_icon_size,
    icon_combination_medium_background_bold_feedback_success_container_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_success_container_size,
    icon_combination_medium_background_bold_feedback_error_container_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_error_container_size,
    icon_combination_medium_background_bold_feedback_warning_container_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_warning_container_size,
    icon_combination_medium_background_bold_feedback_success_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_success_icon_size,
    icon_combination_medium_background_bold_feedback_error_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_error_icon_size,
    icon_combination_medium_background_bold_feedback_warning_icon_size: $52d4442770cfd938$var$icon_combination_medium_background_bold_feedback_warning_icon_size,
    icon_combination_large_background_feedback_success_container_size: $52d4442770cfd938$var$icon_combination_large_background_feedback_success_container_size,
    icon_combination_large_background_feedback_error_container_size: $52d4442770cfd938$var$icon_combination_large_background_feedback_error_container_size,
    icon_combination_large_background_feedback_warning_container_size: $52d4442770cfd938$var$icon_combination_large_background_feedback_warning_container_size,
    icon_combination_large_background_feedback_success_icon_size: $52d4442770cfd938$var$icon_combination_large_background_feedback_success_icon_size,
    icon_combination_large_background_feedback_error_icon_size: $52d4442770cfd938$var$icon_combination_large_background_feedback_error_icon_size,
    icon_combination_large_background_feedback_warning_icon_size: $52d4442770cfd938$var$icon_combination_large_background_feedback_warning_icon_size,
    icon_combination_large_background_bold_feedback_success_container_size: $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_success_container_size,
    icon_combination_large_background_bold_feedback_error_container_size: $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_error_container_size,
    icon_combination_large_background_bold_feedback_warning_container_size: $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_warning_container_size,
    icon_combination_large_background_bold_feedback_success_icon_size: $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_success_icon_size,
    icon_combination_large_background_bold_feedback_error_icon_size: $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_error_icon_size,
    icon_combination_large_background_bold_feedback_warning_icon_size: $52d4442770cfd938$var$icon_combination_large_background_bold_feedback_warning_icon_size,
    "icon_combination_xtra-large_background_feedback_success_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_error_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_warning_container_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_success_icon_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_error_icon_size": "{xl}",
    "icon_combination_xtra-large_background_feedback_warning_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_success_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_error_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_warning_container_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_success_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_error_icon_size": "{xl}",
    "icon_combination_xtra-large_background_bold_feedback_warning_icon_size": "{xl}",
    "icon_combination_xtra-xtra-large_background_feedback_success_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_error_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_warning_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_success_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_error_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_feedback_warning_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_success_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_error_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_warning_container_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_success_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_error_icon_size": "{xxl}",
    "icon_combination_xtra-xtra-large_background_bold_feedback_warning_icon_size": "{xxl}",
    icon_combination_inverse_primary_icon_color: $52d4442770cfd938$var$icon_combination_inverse_primary_icon_color,
    icon_combination_inverse_secondary_icon_color: $52d4442770cfd938$var$icon_combination_inverse_secondary_icon_color,
    icon_combination_inverse_sparkle_icon_color: $52d4442770cfd938$var$icon_combination_inverse_sparkle_icon_color,
    icon_combination_inverse_feedback_icon_color: $52d4442770cfd938$var$icon_combination_inverse_feedback_icon_color
};
const $52d4442770cfd938$var$image_base_container_width = "{size.min}";
const $52d4442770cfd938$var$image_base_container_height = "{size.min}";
const $52d4442770cfd938$var$image_base_image_width = "{size.max}";
const $52d4442770cfd938$var$image_base_lottie_size = "{size.max}";
const $52d4442770cfd938$var$image_base_icon_size = "{l}";
const $52d4442770cfd938$var$image_base_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$image_variant_state_loading_image_opacity = "{opacity.invisible}";
const $52d4442770cfd938$var$image_variant_state_empty_image_opacity = "{opacity.invisible}";
const $52d4442770cfd938$var$image_variant_state_error_image_opacity = "{opacity.invisible}";
const $52d4442770cfd938$var$ImageTokens = {
    "image_base_container_background-color": "{global.transparent}",
    "image_base_container_flex-direction": "{flexDirection.stack}",
    "image_base_container_justify-content": "{justifyContent.center}",
    "image_base_container_align-items": "{alignItems.center}",
    image_base_container_width: $52d4442770cfd938$var$image_base_container_width,
    image_base_container_height: $52d4442770cfd938$var$image_base_container_height,
    "image_base_container_border-radius": "{xl}",
    "image_base_image_aspect-ratio": "{aspect_ratio.1.1}",
    "image_base_image_border-radius": "{xl}",
    image_base_image_width: $52d4442770cfd938$var$image_base_image_width,
    image_base_lottie_size: $52d4442770cfd938$var$image_base_lottie_size,
    image_base_icon_size: $52d4442770cfd938$var$image_base_icon_size,
    image_base_icon_color: $52d4442770cfd938$var$image_base_icon_color,
    "image_base_provider-slot_width": "{size.max}",
    "image_base_skeleton-container_aspect-ratio": "{aspect_ratio.1.1}",
    "image_base_skeleton-container_width": "{size.max}",
    "image_base_skeleton-slot_size": "{size.max}",
    "image_variant_state_loading_container_background-color": "{primaryGrey20}",
    image_variant_state_loading_image_opacity: $52d4442770cfd938$var$image_variant_state_loading_image_opacity,
    "image_variant_state_empty_container_background-color": "{primaryGrey20}",
    image_variant_state_empty_image_opacity: $52d4442770cfd938$var$image_variant_state_empty_image_opacity,
    "image_variant_state_error_container_background-color": "{primaryGrey20}",
    image_variant_state_error_image_opacity: $52d4442770cfd938$var$image_variant_state_error_image_opacity,
    "image_combination_horizontal_4_3_true_image_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_false_image_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_4_3_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.3}",
    "image_combination_horizontal_5_4_true_image_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_false_image_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_5_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.5.4}",
    "image_combination_horizontal_16_9_true_image_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_true_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_false_image_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_horizontal_16_9_false_skeleton-container_aspect-ratio": "{aspect_ratio.16.9}",
    "image_combination_vertical_4_5_true_image_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_true_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_false_image_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_4_5_false_skeleton-container_aspect-ratio": "{aspect_ratio.4.5}",
    "image_combination_vertical_3_4_true_image_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_true_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_false_image_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_3_4_false_skeleton-container_aspect-ratio": "{aspect_ratio.3.4}",
    "image_combination_vertical_9_16_true_image_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_true_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_false_image_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_vertical_9_16_false_skeleton-container_aspect-ratio": "{aspect_ratio.9.16}",
    "image_combination_horizontal_2_75__1_true_image_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_true_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_false_image_aspect-ratio": "{aspect_ratio.2_75.1}",
    "image_combination_horizontal_2_75__1_false_skeleton-container_aspect-ratio": "{aspect_ratio.2_75.1}"
};
const $52d4442770cfd938$var$inputcode_base_container_width = "{size.max}";
const $52d4442770cfd938$var$inputcode_base_container_gap = "{xs}";
const $52d4442770cfd938$var$inputcode_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$inputcode_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$InputCodeTokens = {
    "inputcode_base_container_flex-direction": "{flexDirection.column}",
    "inputcode_base_container_justify-content": "{justifyContent.start}",
    "inputcode_base_container_align-items": "{alignItems.start}",
    inputcode_base_container_width: $52d4442770cfd938$var$inputcode_base_container_width,
    inputcode_base_container_gap: $52d4442770cfd938$var$inputcode_base_container_gap,
    "inputcode_base_field-container_flex-direction": "{flexDirection.row}",
    "inputcode_base_field-container_justify-content": "{justifyContent.center}",
    "inputcode_base_field-container_align-items": "{alignItems.center}",
    "inputcode_base_field-container_width": "{size.max}",
    "inputcode_base_field-container_gap": "{xs}",
    inputcode_variant_disabled_true_container_opacity: $52d4442770cfd938$var$inputcode_variant_disabled_true_container_opacity,
    inputcode_base_container_opacity: $52d4442770cfd938$var$inputcode_base_container_opacity
};
const $52d4442770cfd938$var$input_base_input_width = "{size.max}";
const $52d4442770cfd938$var$input_variant_disabled_true_input_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$input_variant_color_primary_80_input_text_color = "{primary80}";
const $52d4442770cfd938$var$input_variant_color_primary_70_input_text_color = "{primary70}";
const $52d4442770cfd938$var$input_variant_color_primary_60_input_text_color = "{primary60}";
const $52d4442770cfd938$var$input_variant_color_primary_50_input_text_color = "{primary50}";
const $52d4442770cfd938$var$input_variant_color_primary_40_input_text_color = "{primary40}";
const $52d4442770cfd938$var$input_variant_color_primary_30_input_text_color = "{primary30}";
const $52d4442770cfd938$var$input_variant_color_primary_20_input_text_color = "{primary20}";
const $52d4442770cfd938$var$input_variant_color_primary_inverse_input_text_color = "{primaryInverse}";
const $52d4442770cfd938$var$input_variant_color_primary_background_input_text_color = "{primaryBackground}";
const $52d4442770cfd938$var$input_variant_color_primary_grey_100_input_text_color = "{primaryGrey100}";
const $52d4442770cfd938$var$input_variant_color_primary_grey_80_input_text_color = "{primaryGrey80}";
const $52d4442770cfd938$var$input_variant_color_primary_grey_60_input_text_color = "{primaryGrey60}";
const $52d4442770cfd938$var$input_variant_color_primary_grey_40_input_text_color = "{primaryGrey40}";
const $52d4442770cfd938$var$input_variant_color_primary_grey_20_input_text_color = "{primaryGrey20}";
const $52d4442770cfd938$var$input_variant_color_secondary_80_input_text_color = "{secondary80}";
const $52d4442770cfd938$var$input_variant_color_secondary_70_input_text_color = "{secondary70}";
const $52d4442770cfd938$var$input_variant_color_secondary_60_input_text_color = "{secondary60}";
const $52d4442770cfd938$var$input_variant_color_secondary_50_input_text_color = "{secondary50}";
const $52d4442770cfd938$var$input_variant_color_secondary_40_input_text_color = "{secondary40}";
const $52d4442770cfd938$var$input_variant_color_secondary_30_input_text_color = "{secondary30}";
const $52d4442770cfd938$var$input_variant_color_secondary_20_input_text_color = "{secondary20}";
const $52d4442770cfd938$var$input_variant_color_secondary_inverse_input_text_color = "{secondaryInverse}";
const $52d4442770cfd938$var$input_variant_color_secondary_background_input_text_color = "{secondaryBackground}";
const $52d4442770cfd938$var$input_variant_color_secondary_grey_100_input_text_color = "{secondaryGrey100}";
const $52d4442770cfd938$var$input_variant_color_secondary_grey_80_input_text_color = "{secondaryGrey80}";
const $52d4442770cfd938$var$input_variant_color_secondary_grey_60_input_text_color = "{secondaryGrey60}";
const $52d4442770cfd938$var$input_variant_color_secondary_grey_40_input_text_color = "{secondaryGrey40}";
const $52d4442770cfd938$var$input_variant_color_secondary_grey_20_input_text_color = "{secondaryGrey20}";
const $52d4442770cfd938$var$input_variant_color_sparkle_80_input_text_color = "{sparkle80}";
const $52d4442770cfd938$var$input_variant_color_sparkle_70_input_text_color = "{sparkle70}";
const $52d4442770cfd938$var$input_variant_color_sparkle_60_input_text_color = "{sparkle60}";
const $52d4442770cfd938$var$input_variant_color_sparkle_50_input_text_color = "{sparkle50}";
const $52d4442770cfd938$var$input_variant_color_sparkle_40_input_text_color = "{sparkle40}";
const $52d4442770cfd938$var$input_variant_color_sparkle_30_input_text_color = "{sparkle30}";
const $52d4442770cfd938$var$input_variant_color_sparkle_20_input_text_color = "{sparkle20}";
const $52d4442770cfd938$var$input_variant_color_sparkle_inverse_input_text_color = "{sparkleInverse}";
const $52d4442770cfd938$var$input_variant_color_sparkle_background_input_text_color = "{sparkleBackground}";
const $52d4442770cfd938$var$input_variant_color_sparkle_grey_100_input_text_color = "{sparkleGrey100}";
const $52d4442770cfd938$var$input_variant_color_sparkle_grey_80_input_text_color = "{sparkleGrey80}";
const $52d4442770cfd938$var$input_variant_color_sparkle_grey_60_input_text_color = "{sparkleGrey60}";
const $52d4442770cfd938$var$input_variant_color_sparkle_grey_40_input_text_color = "{sparkleGrey40}";
const $52d4442770cfd938$var$input_variant_color_sparkle_grey_20_input_text_color = "{sparkleGrey20}";
const $52d4442770cfd938$var$input_variant_color_feedback_error_80_input_text_color = "{feedbackError80}";
const $52d4442770cfd938$var$input_variant_color_feedback_error_50_input_text_color = "{feedbackError50}";
const $52d4442770cfd938$var$input_variant_color_feedback_error_20_input_text_color = "{feedbackError20}";
const $52d4442770cfd938$var$input_variant_color_feedback_warning_80_input_text_color = "{feedbackWarning80}";
const $52d4442770cfd938$var$input_variant_color_feedback_warning_50_input_text_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$input_variant_color_feedback_warning_20_input_text_color = "{feedbackWarning20}";
const $52d4442770cfd938$var$input_variant_color_feedback_success_80_input_text_color = "{feedbackSuccess80}";
const $52d4442770cfd938$var$input_variant_color_feedback_success_50_input_text_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$input_variant_color_feedback_success_20_input_text_color = "{feedbackSuccess20}";
const $52d4442770cfd938$var$input_variant_color_white_input_text_color = "{global.white}";
const $52d4442770cfd938$var$input_variant_color_black_input_text_color = "{global.black}";
const $52d4442770cfd938$var$input_variant_color_transparent_input_text_color = "{global.transparent}";
const $52d4442770cfd938$var$InputTokens = {
    "input_base_input_text-align": "{textAlign.start}",
    "input_base_input_placeholder-color": "{primaryGrey60}",
    "input_base_input_placeholder-font-family": "{bodyS}",
    "input_base_input_placeholder-font-size": "{bodyS}",
    "input_base_input_placeholder-font-weight": "{bodyS}",
    "input_base_input_placeholder-line-height": "{bodyS}",
    "input_base_input_placeholder-letter-spacing": "{bodyS}",
    "input_base_input_input-color": "{primaryGrey100}",
    "input_base_input_input-font-family": "{bodyS}",
    "input_base_input_input-font-size": "{bodyS}",
    "input_base_input_input-font-weight": "{bodyS}",
    "input_base_input_input-line-height": "{bodyS}",
    "input_base_input_input-letter-spacing": "{bodyS}",
    "input_base_input_cursor-color": "{primaryGrey100}",
    input_base_input_width: $52d4442770cfd938$var$input_base_input_width,
    input_variant_disabled_true_input_opacity: $52d4442770cfd938$var$input_variant_disabled_true_input_opacity,
    "input_variant_textAlign_center_input_text-align": "{textAlign.center}",
    "input_variant_textAlign_end_input_text-align": "{textAlign.end}",
    "input_variant_textAlign_justify_input_text-align": "{textAlign.justify}",
    "input_variant_textSize_large_input_placeholder-font-family": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-font-size": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-line-height": "{bodyL}",
    "input_variant_textSize_large_input_placeholder-font-weight": "{bodyL}",
    "input_variant_textSize_large_input_input-font-family": "{bodyL}",
    "input_variant_textSize_large_input_input-font-size": "{bodyL}",
    "input_variant_textSize_large_input_input-line-height": "{bodyL}",
    "input_variant_textSize_large_input_input-font-weight": "{bodyL}",
    input_variant_color_primary_80_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_80_input_text_color,
    input_variant_color_primary_70_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_70_input_text_color,
    input_variant_color_primary_60_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_60_input_text_color,
    input_variant_color_primary_50_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_50_input_text_color,
    input_variant_color_primary_40_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_40_input_text_color,
    input_variant_color_primary_30_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_30_input_text_color,
    input_variant_color_primary_20_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_20_input_text_color,
    input_variant_color_primary_inverse_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_inverse_input_text_color,
    input_variant_color_primary_background_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_background_input_text_color,
    input_variant_color_primary_grey_100_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_grey_100_input_text_color,
    input_variant_color_primary_grey_80_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_grey_80_input_text_color,
    input_variant_color_primary_grey_60_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_grey_60_input_text_color,
    input_variant_color_primary_grey_40_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_grey_40_input_text_color,
    input_variant_color_primary_grey_20_input_text_color: $52d4442770cfd938$var$input_variant_color_primary_grey_20_input_text_color,
    input_variant_color_secondary_80_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_80_input_text_color,
    input_variant_color_secondary_70_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_70_input_text_color,
    input_variant_color_secondary_60_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_60_input_text_color,
    input_variant_color_secondary_50_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_50_input_text_color,
    input_variant_color_secondary_40_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_40_input_text_color,
    input_variant_color_secondary_30_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_30_input_text_color,
    input_variant_color_secondary_20_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_20_input_text_color,
    input_variant_color_secondary_inverse_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_inverse_input_text_color,
    input_variant_color_secondary_background_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_background_input_text_color,
    input_variant_color_secondary_grey_100_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_grey_100_input_text_color,
    input_variant_color_secondary_grey_80_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_grey_80_input_text_color,
    input_variant_color_secondary_grey_60_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_grey_60_input_text_color,
    input_variant_color_secondary_grey_40_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_grey_40_input_text_color,
    input_variant_color_secondary_grey_20_input_text_color: $52d4442770cfd938$var$input_variant_color_secondary_grey_20_input_text_color,
    input_variant_color_sparkle_80_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_80_input_text_color,
    input_variant_color_sparkle_70_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_70_input_text_color,
    input_variant_color_sparkle_60_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_60_input_text_color,
    input_variant_color_sparkle_50_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_50_input_text_color,
    input_variant_color_sparkle_40_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_40_input_text_color,
    input_variant_color_sparkle_30_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_30_input_text_color,
    input_variant_color_sparkle_20_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_20_input_text_color,
    input_variant_color_sparkle_inverse_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_inverse_input_text_color,
    input_variant_color_sparkle_background_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_background_input_text_color,
    input_variant_color_sparkle_grey_100_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_grey_100_input_text_color,
    input_variant_color_sparkle_grey_80_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_grey_80_input_text_color,
    input_variant_color_sparkle_grey_60_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_grey_60_input_text_color,
    input_variant_color_sparkle_grey_40_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_grey_40_input_text_color,
    input_variant_color_sparkle_grey_20_input_text_color: $52d4442770cfd938$var$input_variant_color_sparkle_grey_20_input_text_color,
    input_variant_color_feedback_error_80_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_error_80_input_text_color,
    input_variant_color_feedback_error_50_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_error_50_input_text_color,
    input_variant_color_feedback_error_20_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_error_20_input_text_color,
    input_variant_color_feedback_warning_80_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_warning_80_input_text_color,
    input_variant_color_feedback_warning_50_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_warning_50_input_text_color,
    input_variant_color_feedback_warning_20_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_warning_20_input_text_color,
    input_variant_color_feedback_success_80_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_success_80_input_text_color,
    input_variant_color_feedback_success_50_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_success_50_input_text_color,
    input_variant_color_feedback_success_20_input_text_color: $52d4442770cfd938$var$input_variant_color_feedback_success_20_input_text_color,
    input_variant_color_white_input_text_color: $52d4442770cfd938$var$input_variant_color_white_input_text_color,
    input_variant_color_black_input_text_color: $52d4442770cfd938$var$input_variant_color_black_input_text_color,
    input_variant_color_transparent_input_text_color: $52d4442770cfd938$var$input_variant_color_transparent_input_text_color
};
const $52d4442770cfd938$var$inputdate_base_container_gap = "{xs}";
const $52d4442770cfd938$var$inputdate_base_container_width = "{size.max}";
const $52d4442770cfd938$var$inputdate_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$InputDateTokens = {
    "inputdate_base_container_flex-direction": "{flexDirection.column}",
    "inputdate_base_container_align-items": "{alignItems.start}",
    inputdate_base_container_gap: $52d4442770cfd938$var$inputdate_base_container_gap,
    inputdate_base_container_width: $52d4442770cfd938$var$inputdate_base_container_width,
    "inputdate_base_outer-container_flex-direction": "{flexDirection.row}",
    "inputdate_base_outer-container_width": "{size.max}",
    "inputdate_base_outer-container_align-items": "{alignItems.center}",
    "inputdate_base_field-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_field-container_width": "{size.max}",
    "inputdate_base_field-container_align-items": "{alignItems.start}",
    "inputdate_base_input-container_width": "{size.max}",
    "inputdate_base_input-container_gap": "{s}",
    "inputdate_base_input-container_align-items": "{alignItems.stretch}",
    "inputdate_base_dd-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_dd-container_gap": "{xs}",
    "inputdate_base_dd-container_align-items": "{alignItems.start}",
    "inputdate_base_dd-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_dd-active-line-container_width": "{size.max}",
    "inputdate_base_dd-feedback-container_width": "{size.max}",
    "inputdate_base_dd-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_left-slash-container_background-color": "{primaryGrey60}",
    "inputdate_base_mm-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_mm-container_gap": "{xs}",
    "inputdate_base_mm-container_align-items": "{alignItems.start}",
    "inputdate_base_mm-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_mm-active-line-container_width": "{size.max}",
    "inputdate_base_mm-feedback-container_width": "{size.max}",
    "inputdate_base_mm-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_right-slash-container_background-color": "{primaryGrey60}",
    "inputdate_base_yy-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_yy-container_gap": "{xs}",
    "inputdate_base_yy-container_align-items": "{alignItems.start}",
    "inputdate_base_yy-jds_input_textAlign": "{textAlign.start}",
    "inputdate_base_yy-active-line-container_width": "{size.max}",
    "inputdate_base_yy-feedback-container_width": "{size.max}",
    "inputdate_base_yy-feedback-container_background-color": "{primaryGrey80}",
    "inputdate_base_calendar-container_justify-content": "{justifyContent.center}",
    "inputdate_base_calendar-container_align-items": "{alignItems.center}",
    "inputdate_base_bottom-container_flex-direction": "{flexDirection.column}",
    "inputdate_base_bottom-container_align-items": "{alignItems.start}",
    "inputdate_base_bottom-container_gap": "{xs}",
    "inputdate_base_bottom-container_width": "{size.max}",
    inputdate_variant_disabled_true_container_opacity: $52d4442770cfd938$var$inputdate_variant_disabled_true_container_opacity,
    "inputdate_variant_disabled_true_bottom-container_opacity": "{opacity.disabled}",
    "inputdate_variant_error_true_dd-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_error_true_mm-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_error_true_yy-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_ddError_true_dd-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_mmError_true_mm-feedback-container_background-color": "{feedbackError50}",
    "inputdate_variant_yyError_true_yy-feedback-container_background-color": "{feedbackError50}"
};
const $52d4442770cfd938$var$inputcodeitem_base_jds_input_width = "{size.max}";
const $52d4442770cfd938$var$InputCodeItemTokens = {
    "inputcodeitem_base_input-container_flex-direction": "{flexDirection.column}",
    "inputcodeitem_base_input-container_justify-content": "{justifyContent.center}",
    "inputcodeitem_base_input-container_align-items": "{alignItems.center}",
    "inputcodeitem_base_input-container_gap": "{xs}",
    "inputcodeitem_base_input-container_input_width": "{size.max}",
    inputcodeitem_base_jds_input_width: $52d4442770cfd938$var$inputcodeitem_base_jds_input_width,
    "inputcodeitem_base_active-line-container_flex-direction": "{flexDirection.column}",
    "inputcodeitem_base_active-line-container_justify-content": "{justifyContent.center}",
    "inputcodeitem_base_active-line-container_align-items": "{alignItems.center}",
    "inputcodeitem_base_active-line-container_width": "{size.max}",
    "inputcodeitem_base_active-line-container_padding-top": "{custom_1}",
    "inputcodeitem_base_active-line-container_padding-bottom": "{custom_1}",
    "inputcodeitem_base_feedback-container_width": "{size.max}",
    "inputcodeitem_base_feedback-container_height": "{custom_4}",
    "inputcodeitem_base_feedback-container_background-color": "{primaryGrey100}",
    "inputcodeitem_base_feedback-container_border-radius": "{custom_2}",
    "inputcodeitem_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "inputcodeitem_base_feedback-container_behavior_focus_background-color": "{primary50}",
    "inputcodeitem_base_feedback-container_behavior_active_background-color": "{primary50}",
    "inputcodeitem_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "inputcodeitem_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "inputcodeitem_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "inputcodeitem_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $52d4442770cfd938$var$fileuploader_base_container_width = "{size.max}";
const $52d4442770cfd938$var$fileuploader_base_container_gap = "{xs}";
const $52d4442770cfd938$var$fileuploader_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$FileUploaderTokens = {
    "fileuploader_base_container_flex-direction": "{flexDirection.column}",
    "fileuploader_base_container_justify-content": "{justifyContent.start}",
    "fileuploader_base_container_align-items": "{alignItems.start}",
    fileuploader_base_container_width: $52d4442770cfd938$var$fileuploader_base_container_width,
    fileuploader_base_container_gap: $52d4442770cfd938$var$fileuploader_base_container_gap,
    fileuploader_base_container_opacity: $52d4442770cfd938$var$fileuploader_base_container_opacity
};
const $52d4442770cfd938$var$fileuploadercontrol_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$fileuploadercontrol_base_container_width = "{size.max}";
const $52d4442770cfd938$var$fileuploadercontrol_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$FileUploaderControlTokens = {
    "fileuploadercontrol_base_container_flex-direction": "{flexDirection.column}",
    "fileuploadercontrol_base_container_justify-content": "{justifyContent.start}",
    "fileuploadercontrol_base_container_align-items": "{alignItems.start}",
    fileuploadercontrol_base_container_gap: $52d4442770cfd938$var$fileuploadercontrol_base_container_gap,
    fileuploadercontrol_base_container_width: $52d4442770cfd938$var$fileuploadercontrol_base_container_width,
    fileuploadercontrol_base_container_opacity: $52d4442770cfd938$var$fileuploadercontrol_base_container_opacity,
    "fileuploadercontrol_base_label-container_flex-direction": "{flexDirection.row}",
    "fileuploadercontrol_base_label-container_justify-content": "{justifyContent.start}",
    "fileuploadercontrol_base_label-container_align-items": "{alignItems.center}",
    "fileuploadercontrol_base_label-container_gap": "{xxs}"
};
const $52d4442770cfd938$var$fileuploaderitem_base_container_width = "{size.max}";
const $52d4442770cfd938$var$fileuploaderitem_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$FileUploaderItemTokens = {
    "fileuploaderitem_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderitem_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderitem_base_container_align-items": "{alignItems.start}",
    fileuploaderitem_base_container_width: $52d4442770cfd938$var$fileuploaderitem_base_container_width,
    fileuploaderitem_base_container_opacity: $52d4442770cfd938$var$fileuploaderitem_base_container_opacity,
    "fileuploaderitem_base_container_background-color": "{primaryGrey20}",
    "fileuploaderitem_base_file-container_flex-direction": "{flexDirection.row}",
    "fileuploaderitem_base_file-container_justify-content": "{justifyContent.spaceBetween}",
    "fileuploaderitem_base_file-container_align-items": "{alignItems.center}",
    "fileuploaderitem_base_file-container_gap": "{xs}",
    "fileuploaderitem_base_file-container_padding-left": "{s}",
    "fileuploaderitem_base_file-container_width": "{size.max}",
    "fileuploaderitem_base_state-container_flex-direction": "{flexDirection.row}",
    "fileuploaderitem_base_state-container_justify-content": "{justifyContent.start}",
    "fileuploaderitem_base_state-container_align-items": "{alignItems.center}",
    "fileuploaderitem_base_state-container_gap": "{xs}",
    "fileuploaderitem_base_button-container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$fileuploaderlist_base_container_width = "{size.max}";
const $52d4442770cfd938$var$fileuploaderlist_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$FileUploaderListTokens = {
    "fileuploaderlist_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderlist_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderlist_base_container_align-items": "{alignItems.start}",
    fileuploaderlist_base_container_width: $52d4442770cfd938$var$fileuploaderlist_base_container_width,
    fileuploaderlist_base_container_opacity: $52d4442770cfd938$var$fileuploaderlist_base_container_opacity,
    "fileuploaderlist_base_container_background-color": "{primaryGrey20}",
    "fileuploaderlist_base_container_border-radius": "{large}"
};
const $52d4442770cfd938$var$fileuploaderpanel_base_container_width = "{size.max}";
const $52d4442770cfd938$var$fileuploaderpanel_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$FileUploaderPanelTokens = {
    "fileuploaderpanel_base_container_flex-direction": "{flexDirection.column}",
    "fileuploaderpanel_base_container_justify-content": "{justifyContent.start}",
    "fileuploaderpanel_base_container_align-items": "{alignItems.start}",
    fileuploaderpanel_base_container_width: $52d4442770cfd938$var$fileuploaderpanel_base_container_width,
    fileuploaderpanel_base_container_opacity: $52d4442770cfd938$var$fileuploaderpanel_base_container_opacity,
    "fileuploaderpanel_base_container_background-color": "{primaryGrey20}",
    "fileuploaderpanel_base_container_border-radius": "{large}",
    "fileuploaderpanel_base_container_padding-top": "{xs}",
    "fileuploaderpanel_base_container_padding-bottom": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-top": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-bottom": "{xs}",
    "fileuploaderpanel_base_inner-container_padding-left": "{s}",
    "fileuploaderpanel_base_inner-container_padding-right": "{s}",
    "fileuploaderpanel_base_inner-container_width": "{size.max}"
};
const $52d4442770cfd938$var$textarea_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$textarea_base_container_width = "{size.max}";
const $52d4442770cfd938$var$textarea_base_input_width = "{size.max}";
const $52d4442770cfd938$var$textarea_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$textarea_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$TextareaTokens = {
    "textarea_base_container_flex-direction": "{flexDirection.column}",
    "textarea_base_container_justify-content": "{justifyContent.start}",
    "textarea_base_container_align-items": "{alignItems.start}",
    textarea_base_container_gap: $52d4442770cfd938$var$textarea_base_container_gap,
    textarea_base_container_width: $52d4442770cfd938$var$textarea_base_container_width,
    "textarea_base_field-container_flex-direction": "{flexDirection.stack}",
    "textarea_base_field-container_width": "{size.max}",
    "textarea_base_field-container_padding-bottom": "{xxs}",
    "textarea_base_field-container_justify-content": "{justifyContent.start}",
    "textarea_base_field-container_align-items": "{alignItems.end}",
    "textarea_base_input-container_flex-direction": "{flexDirection.row}",
    "textarea_base_input-container_justify-content": "{justifyContent.start}",
    "textarea_base_input-container_width": "{size.max}",
    "textarea_base_input-container_align-items": "{alignItems.center}",
    "textarea_base_input_text-align": "{textAlign.start}",
    "textarea_base_input_placeholder-color": "{primaryGrey60}",
    "textarea_base_input_placeholder-font-family": "{bodyS}",
    "textarea_base_input_placeholder-font-size": "{bodyS}",
    "textarea_base_input_placeholder-line-height": "{bodyS}",
    "textarea_base_input_placeholder-letter-spacing": "{bodyS}",
    "textarea_base_input_placeholder-font-weight": "{bodyS}",
    "textarea_base_input_input-color": "{primaryGrey100}",
    "textarea_base_input_input-font-family": "{bodyS}",
    "textarea_base_input_input-font-size": "{bodyS}",
    "textarea_base_input_input-line-height": "{bodyS}",
    "textarea_base_input_input-letter-spacing": "{bodyS}",
    "textarea_base_input_input-font-weight": "{bodyS}",
    "textarea_base_input_resize-color": "{primaryGrey100}",
    "textarea_base_input_cursor-color": "{primaryGrey100}",
    textarea_base_input_width: $52d4442770cfd938$var$textarea_base_input_width,
    "textarea_base_input_behavior_hover_resize-color": "{primary50}",
    "textarea_base_input_behavior_focus_resize-color": "{primary60}",
    "textarea_base_input_behavior_active_resize-color": "{primary60}",
    "textarea_base_active-line-container_flex-direction": "{flexDirection.column}",
    "textarea_base_active-line-container_width": "{size.max}",
    "textarea_base_active-line-container_align-items": "{alignItems.center}",
    "textarea_base_feedback-container_width": "{size.max}",
    "textarea_base_feedback-container_background-color": "{primaryGrey100}",
    "textarea_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "textarea_base_feedback-container_behavior_focus_background-color": "{primary60}",
    "textarea_base_feedback-container_behavior_active_background-color": "{primary60}",
    textarea_variant_disabled_true_container_opacity: $52d4442770cfd938$var$textarea_variant_disabled_true_container_opacity,
    textarea_base_container_opacity: $52d4442770cfd938$var$textarea_base_container_opacity,
    "textarea_variant_border_true-input-container_border-width": "{border_thin}",
    "textarea_variant_border_true-input-container_background-color": "{primaryGrey60}",
    "textarea_variant_border_true-input-container_padding-top": "{custom_17}",
    "textarea_variant_border_true-input-container_border-radius": "{medium}",
    "textarea_variant_border_true-input-container_padding-bottom": "{custom_17}",
    "textarea_variant_border_true-input-container_padding-left": "{base}",
    "textarea_variant_border_true-input-container_padding-right": "{s}",
    "textarea_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_hover_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_focus_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_success_input_behavior_active_resize-color": "{feedbackSuccess50}",
    "textarea_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "textarea_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "textarea_variant_state_error_input_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_hover_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_focus_resize-color": "{feedbackError50}",
    "textarea_variant_state_error_input_behavior_active_resize-color": "{feedbackError50}",
    "textarea_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_hover_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_focus_resize-color": "{feedbackWarning50}",
    "textarea_variant_state_warning_input_behavior_active_resize-color": "{feedbackWarning50}",
    "textarea_variant__labelFocus_true_field-container_align-items": "{alignItems.start}",
    "textarea_combination_none_true_feedback-container_background-color": "{primary60}",
    "textarea_combination_none_true_input_resize-color": "{primary60}",
    "textarea_combination_true_true_field-container_border-color": "{primaryGrey40}",
    "textarea_combination_true_true_input_resize-color": "{primaryGrey60}",
    "textarea_combination_true_true_input_input-color": "{primaryGrey80}"
};
const $52d4442770cfd938$var$LinkTokens = {
    "link_base_container_background-color": "{global.transparent}",
    "link_base_container_flex-direction": "{flexDirection.row}",
    "link_base_container_justify-content": "{justifyContent.center}",
    "link_base_container_align-items": "{alignItems.center}",
    "link_base_container_behavior_focus_border-radius": "{small}",
    "link_base_container_behavior_focus_border-width": "{border_normal}",
    "link_base_container_behavior_focus_border-color": "{primary60}",
    "link_variant_kind_header_container_behavior_focus_border-color": "{primary30}",
    "link_variant_kind_submenu_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_header_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_rich_text_jds_text_text-decoration": "{text-decoration.underline}",
    "link_variant_kind_rich_text_jds_text_behavior_hover_text-decoration": "{text-decoration.none}",
    "link_combination_default_none_jds_text_behavior_hover_text-decoration": "{text-decoration.underline}"
};
const $52d4442770cfd938$var$menublock_base_container_width = "{intrinsicSize.max}";
const $52d4442770cfd938$var$MenuBlockTokens = {
    "menublock_base_popup_background-color": "{global.transparent}",
    "menublock_base_popup-container_flex-direction": "{flexDirection.stack}",
    "menublock_base_popup-container_padding-right": "{base}",
    "menublock_base_popup-container_padding-bottom": "{base}",
    "menublock_base_popup-container_width": "{size.max}",
    menublock_base_container_width: $52d4442770cfd938$var$menublock_base_container_width,
    "menublock_base_container_background-color": "{primaryBackground}",
    "menublock_base_container_flex-direction": "{flexDirection.column}",
    "menublock_base_container_border-radius": "{medium}",
    "menublock_base_popup-container_max-height": "{size.max}"
};
const $52d4442770cfd938$var$inputfield_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$inputfield_base_container_width = "{size.max}";
const $52d4442770cfd938$var$inputfield_base_jds_input_textAlign = "{textAlign.start}";
const $52d4442770cfd938$var$inputfield_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$inputfield_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$InputFieldTokens = {
    "inputfield_base_container_flex-direction": "{flexDirection.column}",
    inputfield_base_container_gap: $52d4442770cfd938$var$inputfield_base_container_gap,
    inputfield_base_container_width: $52d4442770cfd938$var$inputfield_base_container_width,
    "inputfield_base_container_justify-content": "{justifyContent.start}",
    "inputfield_base_container_align-items": "{alignItems.start}",
    "inputfield_base_field-container_flex-direction": "{flexDirection.stack}",
    "inputfield_base_field-container_width": "{size.max}",
    "inputfield_base_field-container_align-items": "{alignItems.end}",
    "inputfield_base_field-container_justify-content": "{justifyContent.start}",
    "inputfield_base_field-container_padding-bottom": "{xxs}",
    "inputfield_base_input-container_flex-direction": "{flexDirection.row}",
    "inputfield_base_input-container_justify-content": "{justifyContent.start}",
    "inputfield_base_input-container_width": "{size.max}",
    "inputfield_base_input-container_gap": "{xs}",
    "inputfield_base_input-container_align-items": "{alignItems.center}",
    "inputfield_base_prefix-icon_size": "{m}",
    "inputfield_base_prefix-icon_color": "{primaryGrey80}",
    inputfield_base_jds_input_textAlign: $52d4442770cfd938$var$inputfield_base_jds_input_textAlign,
    "inputfield_base_suffix-icon_size": "{m}",
    "inputfield_base_suffix-icon_color": "{primaryGrey80}",
    "inputfield_base_suffix-icon_behavior_hover_color": "{primary60}",
    "inputfield_base_active-line-container_flex-direction": "{flexDirection.column}",
    "inputfield_base_active-line-container_width": "{size.max}",
    "inputfield_base_active-line-container_align-items": "{alignItems.center}",
    "inputfield_base_feedback-container_width": "{size.max}",
    "inputfield_base_feedback-container_background-color": "{primaryGrey80}",
    "inputfield_base_feedback-container_behavior_hover_background-color": "{primary50}",
    "inputfield_base_feedback-container_behavior_focus_background-color": "{primary60}",
    "inputfield_base_feedback-container_behavior_active_background-color": "{primary60}",
    inputfield_variant_disabled_true_container_opacity: $52d4442770cfd938$var$inputfield_variant_disabled_true_container_opacity,
    inputfield_base_container_opacity: $52d4442770cfd938$var$inputfield_base_container_opacity,
    "inputfield_variant_state_success_feedback-container_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_hover_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_focus_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_success_feedback-container_behavior_active_background-color": "{feedbackSuccess50}",
    "inputfield_variant_state_error_feedback-container_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_hover_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_focus_background-color": "{feedbackError50}",
    "inputfield_variant_state_error_feedback-container_behavior_active_background-color": "{feedbackError50}",
    "inputfield_variant_state_warning_feedback-container_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_hover_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_focus_background-color": "{feedbackWarning50}",
    "inputfield_variant_state_warning_feedback-container_behavior_active_background-color": "{feedbackWarning50}",
    "inputfield_combination_true_true_field-container_align-items": "{alignItems.start}",
    "inputfield_combination_true_false_field-container_align-items": "{alignItems.start}",
    "inputfield_combination_false_true_field-container_align-items": "{alignItems.end}",
    "inputfield_combination_false_true_input_label-jds_text_padding-left": "{l}",
    "inputfield_combination_false_false_field-container_align-items": "{alignItems.end}",
    "inputfield_combination_none_true_feedback-container_background-color": "{primary60}"
};
const $52d4442770cfd938$var$inputfieldv2_base_container_width = "{size.max}";
const $52d4442770cfd938$var$inputfieldv2_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$inputfieldv2_base_jds_input_textAlign = "{textAlign.start}";
const $52d4442770cfd938$var$inputfieldv2_base_jds_input_flex = 1;
const $52d4442770cfd938$var$inputfieldv2_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$InputFieldV2Tokens = {
    "inputfieldv2_variant_noPrefix_input-container_padding-left": "{s}",
    "inputfieldv2_base_container_flex-direction": "{flexDirection.column}",
    inputfieldv2_base_container_width: $52d4442770cfd938$var$inputfieldv2_base_container_width,
    "inputfieldv2_base_container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_container_align-items": "{alignItems.start}",
    inputfieldv2_base_container_opacity: $52d4442770cfd938$var$inputfieldv2_base_container_opacity,
    "inputfieldv2_base_label-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_label-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_label-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_label-container_gap": "{xxs}",
    "inputfieldv2_base_label-container_padding-left": "{xs}",
    "inputfieldv2_base_label-container_padding-right": "{xs}",
    "inputfieldv2_base_label-container_padding-bottom": "{xxs}",
    "inputfieldv2_base_input-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_input-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_input-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_input-container_width": "{size.max}",
    "inputfieldv2_base_input-container_height": "{xl}",
    "inputfieldv2_base_input-container_gap": "{xs}",
    "inputfieldv2_base_input-container_padding-left": "{xs}",
    "inputfieldv2_base_input-container_padding-right": "{xs}",
    "inputfieldv2_base_input-container_padding-top": "{xs}",
    "inputfieldv2_base_input-container_padding-bottom": "{xs}",
    "inputfieldv2_base_input-container_border-width": "{border_thin}",
    "inputfieldv2_base_input-container_border-color": "{primaryGrey60}",
    "inputfieldv2_variant_readOnly_true_input-container_border-color": "{primaryGrey40}",
    "inputfieldv2_base_input-container_border-radius": "{medium}",
    "inputfieldv2_base_input-container_behavior_hover_border-color": "{primary50}",
    "inputfieldv2_base_input-container_behavior_active_border-color": "{primary60}",
    "inputfieldv2_base_input-container_behavior_focus_border-color": "{primary60}",
    inputfieldv2_base_jds_input_textAlign: $52d4442770cfd938$var$inputfieldv2_base_jds_input_textAlign,
    inputfieldv2_base_jds_input_flex: $52d4442770cfd938$var$inputfieldv2_base_jds_input_flex,
    "inputfieldv2_base_helper-container_flex-direction": "{flexDirection.column}",
    "inputfieldv2_base_helper-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_helper-container_align-items": "{alignItems.start}",
    "inputfieldv2_base_helper-container_gap": "{xxs}",
    "inputfieldv2_base_dynamic-container_gap": "{xxs}",
    "inputfieldv2_base_helper-container_padding-left": "{xs}",
    "inputfieldv2_base_helper-container_padding-right": "{xs}",
    "inputfieldv2_base_helper-container_padding-top": "{xxs}",
    "inputfieldv2_base_dynamic-container_flex-direction": "{flexDirection.row}",
    "inputfieldv2_base_dynamic-container_justify-content": "{justifyContent.start}",
    "inputfieldv2_base_dynamic-container_align-items": "{alignItems.center}",
    "inputfieldv2_base_dynamic-container_padding-left": "{xs}",
    "inputfieldv2_base_dynamic-container_padding-right": "{xs}",
    inputfieldv2_variant_disabled_true_container_opacity: $52d4442770cfd938$var$inputfieldv2_variant_disabled_true_container_opacity,
    "inputfieldv2_variant_state_success_input-container_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_hover_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_focus_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_success_input-container_behavior_active_border-color": "{feedbackSuccess50}",
    "inputfieldv2_variant_state_error_input-container_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_hover_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_focus_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_error_input-container_behavior_active_border-color": "{feedbackError50}",
    "inputfieldv2_variant_state_warning_input-container_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_hover_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_focus_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_state_warning_input-container_behavior_active_border-color": "{feedbackWarning50}",
    "inputfieldv2_variant_size_small_input-container_height": "{l}",
    "inputfieldv2_variant_size_small_input-container_padding-top": "{xxs}",
    "inputfieldv2_variant_size_small_input-container_padding-bottom": "{xxs}",
    "inputfieldv2_variant_size_large_input-container_height": "{xxl}",
    "inputfieldv2_variant_size_large_input-container_gap": "{s}",
    "inputfieldv2_variant_size_large_input-container_padding-top": "{s}",
    "inputfieldv2_variant_size_large_input-container_padding-bottom": "{s}",
    "inputfieldv2_variant_size_large_helper-container_gap": "{xs}",
    "inputfieldv2_variant_size_large_helper-container_padding-top": "{xs}"
};
const $52d4442770cfd938$var$menublockitem_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$menublockitem_base_container_width = "{size.max}";
const $52d4442770cfd938$var$menublockitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$MenuBlockItemTokens = {
    menublockitem_base_container_opacity: $52d4442770cfd938$var$menublockitem_base_container_opacity,
    "menublockitem_base_container_background-color": "{global.transparent}",
    menublockitem_base_container_width: $52d4442770cfd938$var$menublockitem_base_container_width,
    "menublockitem_base_entry-container_background-color": "{global.transparent}",
    "menublockitem_base_entry-container_width": "{size.max}",
    "menublockitem_base_entry-container_padding-top": "{xs}",
    "menublockitem_base_entry-container_padding-right": "{base}",
    "menublockitem_base_entry-container_padding-bottom": "{xs}",
    "menublockitem_base_entry-container_padding-left": "{base}",
    "menublockitem_base_entry-container_flex-direction": "{flexDirection.row}",
    "menublockitem_base_entry-container_align-items": "{alignItems.center}",
    "menublockitem_base_entry-container_justify-content": "{justifyContent.spaceBetween}",
    "menublockitem_base_entry-container_border-color": "{global.transparent}",
    "menublockitem_base_entry-container_behavior_hover_background-color": "{primaryGrey20}",
    "menublockitem_base_entry-container_behavior_focus_border-color": "{primary60}",
    "menublockitem_base_entry-container_behavior_focus_border-radius": "{small}",
    "menublockitem_base_divider-container_width": "{size.max}",
    "menublockitem_base_heading-container_padding-top": "{xs}",
    "menublockitem_base_heading-container_padding-right": "{base}",
    "menublockitem_base_heading-container_padding-bottom": "{xs}",
    "menublockitem_base_heading-container_padding-left": "{base}",
    "menublockitem_base_heading-container_width": "{size.max}",
    "menublockitem_base_heading-container_align-items": "{alignItems.center}",
    "menublockitem_base_heading-container_justify-content": "{justifyContent.start}",
    "menublockitem_base_left-container_gap": "{xs}",
    "menublockitem_base_left-container_flex-direction": "{flexDirection.row}",
    "menublockitem_base_left-container_align-items": "{alignItems.center}",
    "menublockitem_variant_selected_true_container_background-color": "{primaryGrey20}",
    menublockitem_variant_disabled_true_container_opacity: $52d4442770cfd938$var$menublockitem_variant_disabled_true_container_opacity,
    "menublockitem_variant_hasIcon_true_heading-container_padding-left": "{xxl}"
};
const $52d4442770cfd938$var$ListBlockTokens = {
    "listblock_base_root-container_flex-direction": "{flexDirection.column}",
    "listblock_base_root-container_width": "{size.max}",
    "listblock_base_root-container_justify-content": "{justifyContent.start}",
    "listblock_base_root-container_align-items": "{alignItems.start}",
    "listblock_base_root-container_gap": "{xs}",
    "listblock_base_root-container_padding-top": "{xs}",
    "listblock_base_root-container_padding-bottom": "{xs}",
    "listblock_base_main-container_flex-direction": "{flexDirection.row}",
    "listblock_base_main-container_width": "{size.max}",
    "listblock_base_main-container_gap": "{base}",
    "listblock_base_main-container_justify-content": "{justifyContent.start}",
    "listblock_base_main-container_align-items": "{alignItems.center}",
    "listblock_base_block-container_flex-direction": "{flexDirection.column}",
    "listblock_base_block-container_gap": "{xxs}",
    "listblock_base_block-container_justify-content": "{justifyContent.start}",
    "listblock_base_block-container_align-items": "{alignItems.start}",
    "listblock_base_caption-container_flex-direction": "{flexDirection.row}",
    "listblock_base_caption-container_width": "{size.max}",
    "listblock_base_caption-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_caption-container_align-items": "{alignItems.center}",
    "listblock_base_caption-container_gap": "{s}",
    "listblock_base_inner-caption-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-caption-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-caption-container_align-items": "{alignItems.center}",
    "listblock_base_inner-caption-container_gap": "{s}",
    "listblock_base_title-container_flex-direction": "{flexDirection.row}",
    "listblock_base_title-container_width": "{size.max}",
    "listblock_base_title-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_title-container_align-items": "{alignItems.center}",
    "listblock_base_title-container_gap": "{s}",
    "listblock_base_inner-title-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-title-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-title-container_align-items": "{alignItems.center}",
    "listblock_base_inner-title-container_gap": "{s}",
    "listblock_base_helper-container_flex-direction": "{flexDirection.row}",
    "listblock_base_helper-container_width": "{size.max}",
    "listblock_base_helper-container_justify-content": "{justifyContent.spaceBetween}",
    "listblock_base_helper-container_align-items": "{alignItems.center}",
    "listblock_base_helper-container_gap": "{s}",
    "listblock_base_inner-helper-container_flex-direction": "{flexDirection.row}",
    "listblock_base_inner-helper-container_justify-content": "{justifyContent.start}",
    "listblock_base_inner-helper-container_align-items": "{alignItems.center}",
    "listblock_base_inner-helper-container_gap": "{s}",
    "listblock_variant_spacing_small_main-container_gap": "{s}",
    "listblock_variant_spacing_small_root-container_gap": "{xxs}",
    "listblock_variant_verticalAlignment_top_main-container_align-items": "{alignItems.start}"
};
const $52d4442770cfd938$var$bottomnavigation_base_container_width = "{size.max}";
const $52d4442770cfd938$var$bottomnavigation_base_container_gap = "{m}";
const $52d4442770cfd938$var$bottomnavigation_base_jds_bottom_navigation_item_flex = 1;
const $52d4442770cfd938$var$BottomNavigationTokens = {
    bottomnavigation_base_container_width: $52d4442770cfd938$var$bottomnavigation_base_container_width,
    "bottomnavigation_base_container_flex-direction": "{flexDirection.row}",
    "bottomnavigation_base_container_justify-content": "{justifyContent.center}",
    "bottomnavigation_base_container_align-items": "{alignItems.center}",
    "bottomnavigation_base_container_background-color": "{primaryBackground}",
    "bottomnavigation_base_container_padding-left": "{m}",
    "bottomnavigation_base_container_padding-top": "{base}",
    "bottomnavigation_base_container_padding-right": "{m}",
    "bottomnavigation_base_container_padding-bottom": "{base}",
    bottomnavigation_base_container_gap: $52d4442770cfd938$var$bottomnavigation_base_container_gap,
    "bottomnavigation_base_container_box-shadow_x": 0,
    "bottomnavigation_base_container_box-shadow_y": -1,
    "bottomnavigation_base_container_box-shadow_blur": 0,
    "bottomnavigation_base_container_box-shadow_spread": 0,
    bottomnavigation_base_jds_bottom_navigation_item_flex: $52d4442770cfd938$var$bottomnavigation_base_jds_bottom_navigation_item_flex,
    "bottomnavigation_base_container_box-shadow_color": "{primaryGrey40}"
};
const $52d4442770cfd938$var$ModalDesktopTokens = {
    "modaldesktop_base_popup-container_flex-direction": "{flexDirection.stack}",
    "modaldesktop_base_popup-container_opacity": "{opacity.invisible}",
    "modaldesktop_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modaldesktop_base_popup-container_justify-content": "{justifyContent.center}",
    "modaldesktop_base_popup-container_align-items": "{alignItems.center}",
    "modaldesktop_base_popup-container_size": "{size.max}",
    "modaldesktop_base_overlay-container_size": "{size.max}",
    "modaldesktop_base_overlay-container_background-color": "{global.black}",
    "modaldesktop_base_overlay-container_opacity": "{custom_2}",
    "modaldesktop_base_root-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_root-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_root-container_align-items": "{alignItems.start}",
    "modaldesktop_base_root-container_border-radius": "{xxl}",
    "modaldesktop_base_root-container_background-color": "{primaryBackground}",
    "modaldesktop_base_root-container_max-height": "{size.max}",
    "modaldesktop_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_cancel-container_justify-content": "{justifyContent.end}",
    "modaldesktop_base_cancel-container_align-items": "{alignItems.center}",
    "modaldesktop_base_cancel-container_width": "{size.max}",
    "modaldesktop_base_cancel-container_padding-top": "{s}",
    "modaldesktop_base_cancel-container_padding-bottom": "{s}",
    "modaldesktop_base_cancel-container_padding-left": "{s}",
    "modaldesktop_base_cancel-container_padding-right": "{s}",
    "modaldesktop_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_vertical-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_vertical-container_align-items": "{alignItems.start}",
    "modaldesktop_base_vertical-container_padding-left": "{l}",
    "modaldesktop_base_vertical-container_padding-right": "{l}",
    "modaldesktop_base_vertical-container_padding-bottom": "{l}",
    "modaldesktop_base_vertical-container_width": "{size.max}",
    "modaldesktop_base_vertical-container_overflow": "auto",
    "modaldesktop_base_custom-container_overflow": "auto",
    "modaldesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_header-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_header-container_align-items": "{alignItems.center}",
    "modaldesktop_base_header-container_width": "{size.max}",
    "modaldesktop_base_header-container_padding-bottom": "{base}",
    "modaldesktop_base_children-container_width": "{size.max}",
    "modaldesktop_base_children-container_overflow": "auto",
    "modaldesktop_base_button-container_width": "{size.max}",
    "modaldesktop_base_button-container_justify-content": "{justifyContent.end}",
    "modaldesktop_base_button-container_align-items": "{alignItems.start}",
    "modaldesktop_base_button-container_flex-direction": "{flexDirection.row}",
    "modaldesktop_base_button-container_gap": "{s}",
    "modaldesktop_base_button-container_padding-top": "{base}",
    "modaldesktop_base_custom-container_flex-direction": "{flexDirection.column}",
    "modaldesktop_base_custom-container_justify-content": "{justifyContent.start}",
    "modaldesktop_base_custom-container_align-items": "{alignItems.start}",
    "modaldesktop_base_custom-container_border-radius": "{xxl}",
    "modaldesktop_base_custom-container_background-color": "{primaryBackground}",
    "modaldesktop_base_custom-container_padding-left": "{l}",
    "modaldesktop_base_custom-container_padding-right": "{l}",
    "modaldesktop_base_custom-container_padding-top": "{l}",
    "modaldesktop_base_custom-container_padding-bottom": "{l}",
    "modaldesktop_base_custom-container_width": "{size.max}",
    "modaldesktop_base_custom-container_max-height": "{size.max}",
    "modaldesktop_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modaldesktop_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modaldesktop_variant_size_small_vertical-container_padding-left": "{m}",
    "modaldesktop_variant_size_small_vertical-container_padding-right": "{m}",
    "modaldesktop_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modaldesktop_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modaldesktop_combination_acknowledgement_false_vertical-container_padding-top": "{l}"
};
const $52d4442770cfd938$var$modaldesktopinternal_base_container_size = "{size.max}";
const $52d4442770cfd938$var$ModalDesktopInternalTokens = {
    "modaldesktopinternal_base_container_flex-direction": "{flexDirection.stack}",
    "modaldesktopinternal_base_container_justify-content": "{justifyContent.center}",
    "modaldesktopinternal_base_container_align-items": "{alignItems.center}",
    modaldesktopinternal_base_container_size: $52d4442770cfd938$var$modaldesktopinternal_base_container_size,
    "modaldesktopinternal_base_popup-container_opacity": "{opacity.invisible}",
    "modaldesktopinternal_base_popup-container_transition_duration": "{medium}",
    "modaldesktopinternal_base_popup-container_transition_timing-function": "{easeEntrance}",
    "modaldesktopinternal_base_overlay-container_size": "{size.max}",
    "modaldesktopinternal_base_overlay-container_background-color": "{global.black}",
    "modaldesktopinternal_base_overlay-container_opacity": "{custom_2}",
    "modaldesktopinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_root-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_root-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_root-container_border-radius": "{xxl}",
    "modaldesktopinternal_base_root-container_background-color": "{elevation1}",
    "modaldesktopinternal_base_root-container_width": "{custom_27}",
    "modaldesktopinternal_base_root-container_max-height": "{size.max}",
    "modaldesktopinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_base_cancel-container_align-items": "{alignItems.center}",
    "modaldesktopinternal_base_cancel-container_width": "{size.max}",
    "modaldesktopinternal_base_cancel-container_padding-top": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-bottom": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-left": "{s}",
    "modaldesktopinternal_base_cancel-container_padding-right": "{s}",
    "modaldesktopinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_vertical-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_vertical-container_padding-left": "{l}",
    "modaldesktopinternal_base_vertical-container_padding-right": "{l}",
    "modaldesktopinternal_base_vertical-container_padding-bottom": "{l}",
    "modaldesktopinternal_base_vertical-container_width": "{size.max}",
    "modaldesktopinternal_base_vertical-container_overflow": "auto",
    "modaldesktopinternal_base_custom-container_overflow": "auto",
    "modaldesktopinternal_base_header-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_header-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_header-container_align-items": "{alignItems.center}",
    "modaldesktopinternal_base_header-container_width": "{size.max}",
    "modaldesktopinternal_base_header-container_padding-bottom": "{base}",
    "modaldesktopinternal_base_children-container_width": "{size.max}",
    "modaldesktopinternal_base_children-container_overflow": "auto",
    "modaldesktopinternal_base_button-container_width": "{size.max}",
    "modaldesktopinternal_base_button-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_base_button-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_button-container_flex-direction": "{flexDirection.row}",
    "modaldesktopinternal_base_button-container_gap": "{s}",
    "modaldesktopinternal_base_button-container_padding-top": "{base}",
    "modaldesktopinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "modaldesktopinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "modaldesktopinternal_base_custom-container_align-items": "{alignItems.start}",
    "modaldesktopinternal_base_custom-container_border-radius": "{xxl}",
    "modaldesktopinternal_base_custom-container_background-color": "{primaryBackground}",
    "modaldesktopinternal_base_custom-container_padding-left": "{l}",
    "modaldesktopinternal_base_custom-container_padding-right": "{l}",
    "modaldesktopinternal_base_custom-container_padding-top": "{l}",
    "modaldesktopinternal_base_custom-container_padding-bottom": "{l}",
    "modaldesktopinternal_base_custom-container_max-width": "80%",
    "modaldesktopinternal_base_custom-container_max-height": "80%",
    "modaldesktopinternal_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modaldesktopinternal_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-left": "{m}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-right": "{m}",
    "modaldesktopinternal_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modaldesktopinternal_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modaldesktopinternal_combination_acknowledgement_false_vertical-container_padding-top": "{l}",
    "modaldesktopinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modaldesktopinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}",
    "modaldesktopinternal_combination_medium_desktop_root-container_width": "{custom_27}",
    "modaldesktopinternal_combination_medium_tablet_root-container_width": "{modal_desktop_comibation_medium_width}",
    "modaldesktopinternal_combination_small_desktop_root-container_width": "{modal_desktop_combination_small_width}",
    "modaldesktopinternal_combination_small_tablet_root-container_width": "{modal_desktop_combination_small_width}"
};
const $52d4442770cfd938$var$bottomnavigationitem_base_container_width = "{size.max}";
const $52d4442770cfd938$var$bottomnavigationitem_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$bottomnavigationitem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$bottomnavigationitem_variant_enabled_true_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$BottomNavigationItemTokens = {
    bottomnavigationitem_base_container_width: $52d4442770cfd938$var$bottomnavigationitem_base_container_width,
    "bottomnavigationitem_base_container_flex-direction": "{flexDirection.column}",
    "bottomnavigationitem_base_container_justify-content": "{justifyContent.center}",
    "bottomnavigationitem_base_container_align-items": "{alignItems.center}",
    bottomnavigationitem_base_container_gap: $52d4442770cfd938$var$bottomnavigationitem_base_container_gap,
    bottomnavigationitem_variant_disabled_true_container_opacity: $52d4442770cfd938$var$bottomnavigationitem_variant_disabled_true_container_opacity,
    bottomnavigationitem_variant_enabled_true_container_opacity: $52d4442770cfd938$var$bottomnavigationitem_variant_enabled_true_container_opacity
};
const $52d4442770cfd938$var$ModalMobileTokens = {
    "modalmobile_base_popup-container_flex-direction": "{flexDirection.stack}",
    "modalmobile_base_popup-container_justify-content": "{justifyContent.center}",
    "modalmobile_base_popup-container_align-items": "{alignItems.center}",
    "modalmobile_base_popup-container_size": "{size.max}",
    "modalmobile_base_popup-container_opacity": "{opacity.invisible}",
    "modalmobile_base_popup-container_transition_duration": "{medium}",
    "modalmobile_base_popup-container_transition_timing-function": "{easeEntrance}",
    "modalmobile_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modalmobile_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $52d4442770cfd938$var$modalmobileinternal_base_container_size = "{size.max}";
const $52d4442770cfd938$var$ModalMobileInternalTokens = {
    "modalmobileinternal_base_container_flex-direction": "{flexDirection.stack}",
    "modalmobileinternal_base_container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_base_container_align-items": "{alignItems.center}",
    modalmobileinternal_base_container_size: $52d4442770cfd938$var$modalmobileinternal_base_container_size,
    "modalmobileinternal_base_overlay-container_size": "{size.max}",
    "modalmobileinternal_base_overlay-container_background-color": "{global.black}",
    "modalmobileinternal_base_overlay-container_opacity": "{custom_2}",
    "modalmobileinternal_base_root-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_root-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_root-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_root-container_border-radius": "{xl}",
    "modalmobileinternal_base_root-container_width": "{size.max}",
    "modalmobileinternal_base_root-container_max-height": "{custom_31}",
    "modalmobileinternal_base_root-container_background-color": "{elevation1}",
    "modalmobileinternal_base_outer-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_outer-container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_base_outer-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_outer-container_border-radius": "{xl}",
    "modalmobileinternal_base_outer-container_width": "{size.max}",
    "modalmobileinternal_base_outer-container_max-height": "{size.max}",
    "modalmobileinternal_base_outer-container_padding-top": "{m}",
    "modalmobileinternal_base_outer-container_padding-bottom": "{m}",
    "modalmobileinternal_base_outer-container_padding-left": "{m}",
    "modalmobileinternal_base_outer-container_padding-right": "{m}",
    "modalmobileinternal_base_cancel-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_cancel-container_justify-content": "{justifyContent.end}",
    "modalmobileinternal_base_cancel-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_cancel-container_width": "{size.max}",
    "modalmobileinternal_base_cancel-container_padding-top": "{s}",
    "modalmobileinternal_base_cancel-container_padding-bottom": "{s}",
    "modalmobileinternal_base_cancel-container_padding-left": "{s}",
    "modalmobileinternal_base_cancel-container_padding-right": "{s}",
    "modalmobileinternal_base_vertical-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_vertical-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_vertical-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_vertical-container_width": "{size.max}",
    "modalmobileinternal_base_vertical-container_padding-left": "{l}",
    "modalmobileinternal_base_vertical-container_padding-right": "{l}",
    "modalmobileinternal_base_vertical-container_padding-bottom": "{l}",
    "modalmobileinternal_base_vertical-container_overflow": "auto",
    "modalmobileinternal_base_header-container_flex-direction": "{flexDirection.row}",
    "modalmobileinternal_base_header-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_header-container_align-items": "{alignItems.center}",
    "modalmobileinternal_base_header-container_width": "{size.max}",
    "modalmobileinternal_base_header-container_padding-bottom": "{base}",
    "modalmobileinternal_base_children-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_children-container_width": "{size.max}",
    "modalmobileinternal_base_children-container_overflow": "auto",
    "modalmobileinternal_base_children-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_button-container_width": "{size.max}",
    "modalmobileinternal_base_button-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_button-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_button-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_button-container_gap": "{s}",
    "modalmobileinternal_base_button-container_padding-top": "{base}",
    "modalmobileinternal_base_custom-container_flex-direction": "{flexDirection.column}",
    "modalmobileinternal_base_custom-container_justify-content": "{justifyContent.start}",
    "modalmobileinternal_base_custom-container_align-items": "{alignItems.start}",
    "modalmobileinternal_base_custom-container_border-radius": "{xl}",
    "modalmobileinternal_base_custom-container_background-color": "{elevation1}",
    "modalmobileinternal_base_custom-container_padding-left": "{l}",
    "modalmobileinternal_base_custom-container_padding-right": "{l}",
    "modalmobileinternal_base_custom-container_padding-top": "{l}",
    "modalmobileinternal_base_custom-container_padding-bottom": "{l}",
    "modalmobileinternal_base_custom-container_width": "{size.max}",
    "modalmobileinternal_variant_headerAlignment_right_header-container_justify-content": "{justifyContent.end}",
    "modalmobileinternal_variant_headerAlignment_center_header-container_justify-content": "{justifyContent.center}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-left": "{m}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-right": "{m}",
    "modalmobileinternal_variant_size_small_vertical-container_padding-bottom": "{m}",
    "modalmobileinternal_combination_dialog_false_vertical-container_padding-top": "{l}",
    "modalmobileinternal_combination_acknowledgement_false_vertical-container_padding-top": "{l}",
    "modalmobileinternal_variant_close_false_popup-container_opacity": "{opacity.enabled}",
    "modalmobileinternal_variant_close_false_popup-container_transition_timing-function": "{easeExit}"
};
const $52d4442770cfd938$var$headermobile_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const $52d4442770cfd938$var$HeaderMobileTokens = {
    "headermobile_base_container_min-width": "{size.max}",
    "headermobile_base_container_flex-direction": "{flexDirection.column}",
    "headermobile_base_header-container_min-width": "{size.max}",
    "headermobile_base_header-container_width": "{size.max}",
    "headermobile_base_header-container_background-color": "{primary50}",
    "headermobile_base_header-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "headermobile_base_header-container_align-items": "{alignItems.center}",
    "headermobile_base_header-container_padding-left": "{s}",
    "headermobile_base_header-container_padding-top": "{xs}",
    "headermobile_base_header-container_padding-right": "{s}",
    "headermobile_base_header-container_padding-bottom": "{xs}",
    "headermobile_base_header-container_gap": "{base}",
    "headermobile_base_header-container_height": "{huge}",
    "headermobile_base_left-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_left-container_justify-content": "{justifyContent.start}",
    "headermobile_base_left-container_align-items": "{alignItems.center}",
    "headermobile_base_left-container_gap": "{base}",
    "headermobile_base_prefix-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_prefix-container_justify-content": "{justifyContent.start}",
    "headermobile_base_prefix-container_align-items": "{alignItems.center}",
    "headermobile_base_prefix-container_gap": "{xs}",
    "headermobile_base_logo-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_logo-container_justify-content": "{justifyContent.center}",
    "headermobile_base_logo-container_align-items": "{alignItems.center}",
    "headermobile_base_logo-container_gap": "{xs}",
    "headermobile_base_links-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_links-container_justify-content": "{justifyContent.start}",
    "headermobile_base_links-container_align-items": "{alignItems.center}",
    "headermobile_base_links-container_gap": "{l}",
    "headermobile_base_links-container_padding-left": "{huge}",
    "headermobile_base_right-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_right-container_justify-content": "{justifyContent.end}",
    "headermobile_base_right-container_align-items": "{alignItems.center}",
    "headermobile_base_right-container_gap": "{s}",
    "headermobile_base_suffix-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_suffix-container_justify-content": "{justifyContent.end}",
    "headermobile_base_suffix-container_align-items": "{alignItems.center}",
    "headermobile_base_suffix-container_gap": "{s}",
    "headermobile_base_icon-links-container_flex-direction": "{flexDirection.row}",
    "headermobile_base_icon-links-container_justify-content": "{justifyContent.center}",
    "headermobile_base_icon-links-container_align-items": "{alignItems.center}",
    "headermobile_base_icon-links-container_gap": "{s}",
    "headermobile_variant__platform_mobile_header-container_padding-left": "{s}",
    "headermobile_variant__platform_mobile_header-container_padding-right": "{s}",
    "headermobile_variant__platform_mobile_header-container_gap": "{xxs}",
    "headermobile_variant__platform_mobile_left-container_gap": "{xs}",
    "headermobile_variant__platform_mobile_right-container_gap": "{xs}",
    "headermobile_variant__platform_mobile_suffix-container_gap": "{xs}",
    headermobile_variant_fullWidth_false_container_width: $52d4442770cfd938$var$headermobile_variant_fullWidth_false_container_width,
    "headermobile_variant__platform_mobile__isPrefixButtonMissing_true_header-container_padding-left": "{m}"
};
const $52d4442770cfd938$var$megamenu_base_container_width = "{size.max}";
const $52d4442770cfd938$var$megamenu_base_container_gap = "{base}";
const $52d4442770cfd938$var$MegaMenuTokens = {
    "megamenu_base_popup-container_flex-direction": "{flexDirection.row}",
    megamenu_base_container_width: $52d4442770cfd938$var$megamenu_base_container_width,
    "megamenu_base_container_flex-direction": "{flexDirection.row}",
    "megamenu_base_container_justify-content": "{justifyContent.start}",
    "megamenu_base_container_align-items": "{alignItems.start}",
    "megamenu_base_container_background-color": "{primaryBackground}",
    "megamenu_base_container_padding-top": "{m}",
    "megamenu_base_container_padding-bottom": "{m}",
    "megamenu_base_container_padding-right": "{xxl}",
    "megamenu_base_container_padding-left": "{xxl}",
    megamenu_base_container_gap: $52d4442770cfd938$var$megamenu_base_container_gap
};
const $52d4442770cfd938$var$megamenublock_base_container_gap = "{base}";
const $52d4442770cfd938$var$MegaMenuBlockTokens = {
    "megamenublock_base_container_flex-direction": "{flexDirection.column}",
    "megamenublock_base_container_justify-content": "{justifyContent.start}",
    "megamenublock_base_container_align-items": "{alignItems.start}",
    megamenublock_base_container_gap: $52d4442770cfd938$var$megamenublock_base_container_gap,
    "megamenublock_base_links-container_flex-direction": "{flexDirection.column}",
    "megamenublock_base_links-container_justify-content": "{justifyContent.start}",
    "megamenublock_base_links-container_align-items": "{alignItems.start}",
    "megamenublock_base_heading-jds_text_padding-top": "{xs}"
};
const $52d4442770cfd938$var$headerdesktop_base_header_container_height = "{custom_16}";
const $52d4442770cfd938$var$headerdesktop_base_jds_search_box_width = "{size.max}";
const $52d4442770cfd938$var$headerdesktop_variant__platform_mobile_header_container_height = "{huge}";
const $52d4442770cfd938$var$headerdesktop_variant_variant_active_search_jds_search_box_width = "{size.max}";
const $52d4442770cfd938$var$headerdesktop_variant_fullWidth_false_container_width = "{intrinsicSize.max}";
const $52d4442770cfd938$var$HeaderDesktopTokens = {
    "headerdesktop_base_container_min-width": "{size.max}",
    "headerdesktop_base_container_flex-direction": "{flexDirection.column}",
    "headerdesktop_base_prefix-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_prefix-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_prefix-container_align-items": "{alignItems.center}",
    "headerdesktop_base_prefix-container_gap": "{xs}",
    "headerdesktop_base_header-container_min-width": "{size.max}",
    "headerdesktop_base_header-container_background-color": "{primary50}",
    "headerdesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "headerdesktop_base_header-container_align-items": "{alignItems.center}",
    "headerdesktop_base_header-container_padding-left": "{xxl}",
    "headerdesktop_base_header-container_padding-top": "{s}",
    "headerdesktop_base_header-container_padding-right": "{xxl}",
    "headerdesktop_base_header-container_padding-bottom": "{s}",
    "headerdesktop_base_header-container_gap": "{base}",
    headerdesktop_base_header_container_height: $52d4442770cfd938$var$headerdesktop_base_header_container_height,
    "headerdesktop_base_left-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_left-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_left-container_align-items": "{alignItems.center}",
    "headerdesktop_base_left-container_gap": "{base}",
    "headerdesktop_base_logo-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_logo-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_logo-container_align-items": "{alignItems.center}",
    "headerdesktop_base_logo-container_gap": "{xs}",
    "headerdesktop_base_profile-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_profile-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_profile-container_align-items": "{alignItems.center}",
    "headerdesktop_base_profile-container_gap": "{xs}",
    "headerdesktop_base_links-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_links-container_justify-content": "{justifyContent.start}",
    "headerdesktop_base_links-container_align-items": "{alignItems.center}",
    "headerdesktop_base_links-container_gap": "{l}",
    "headerdesktop_base_links-container_padding-left": "{huge}",
    "headerdesktop_base_right-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_right-container_justify-content": "{justifyContent.end}",
    "headerdesktop_base_right-container_align-items": "{alignItems.center}",
    "headerdesktop_base_right-container_gap": "{s}",
    "headerdesktop_base_suffix-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_suffix-container_justify-content": "{justifyContent.end}",
    "headerdesktop_base_suffix-container_align-items": "{alignItems.center}",
    "headerdesktop_base_suffix-container_gap": "{s}",
    "headerdesktop_base_suffix-container_width": "{size.max}",
    "headerdesktop_base_icon-links-container_flex-direction": "{flexDirection.row}",
    "headerdesktop_base_icon-links-container_justify-content": "{justifyContent.center}",
    "headerdesktop_base_icon-links-container_align-items": "{alignItems.center}",
    "headerdesktop_base_icon-links-container_gap": "{s}",
    headerdesktop_base_jds_search_box_width: $52d4442770cfd938$var$headerdesktop_base_jds_search_box_width,
    headerdesktop_variant__platform_mobile_header_container_height: $52d4442770cfd938$var$headerdesktop_variant__platform_mobile_header_container_height,
    "headerdesktop_variant__platform_mobile_header-container_padding-left": "{s}",
    "headerdesktop_variant__platform_mobile_header-container_padding-right": "{s}",
    "headerdesktop_variant__platform_mobile_header-container_gap": "{s}",
    "headerdesktop_variant__platform_mobile_left-container_gap": "{xs}",
    "headerdesktop_variant__platform_mobile_right-container_gap": "{xs}",
    "headerdesktop_variant__platform_mobile_suffix-container_gap": "{xs}",
    "headerdesktop_variant_variant_default_left-container_width": "{size.max}",
    "headerdesktop_variant_variant_active_search_header-container_justify-content": "{justifyContent.spaceBetween}",
    headerdesktop_variant_variant_active_search_jds_search_box_width: $52d4442770cfd938$var$headerdesktop_variant_variant_active_search_jds_search_box_width,
    headerdesktop_variant_fullWidth_false_container_width: $52d4442770cfd938$var$headerdesktop_variant_fullWidth_false_container_width,
    "headerdesktop_combinaton_mobile_false_header-container_justify-content": "{justifyContent.spaceBetween}"
};
const $52d4442770cfd938$var$sidepanel_base_container_height = "{size.max}";
const $52d4442770cfd938$var$sidepanel_combination_true_desktop_container_width = "{size.max}";
const $52d4442770cfd938$var$sidepanel_combination_true_mobile_container_width = "{size.max}";
const $52d4442770cfd938$var$sidepanel_combination_false_mobile_container_width = 376;
const $52d4442770cfd938$var$SidePanelTokens = {
    "sidepanel_base_popup-container_height": "{size.max}",
    "sidepanel_base_popup-container_width": "{size.max}",
    "sidepanel_base_popup-container_flex-direction": "{flexDirection.row}",
    "sidepanel_base_popup-container_justify-content": "{justifyContent.start}",
    "sidepanel_base_popup-container_align-items": "{alignItems.center}",
    sidepanel_base_container_height: $52d4442770cfd938$var$sidepanel_base_container_height,
    "sidepanel_base_container_flex-direction": "{flexDirection.column}",
    "sidepanel_base_container_background-color": "{primaryBackground}",
    "sidepanel_base_section-container_height": "{size.max}",
    "sidepanel_base_section-container_width": "{size.max}",
    "sidepanel_base_section-container_flex-direction": "{flexDirection.column}",
    "sidepanel_base_section-container_justify-content": "{justifyContent.start}",
    "sidepanel_base_section-container_align-items": "{alignItems.center}",
    "sidepanel_base_section-container_padding-left": "{m}",
    "sidepanel_base_section-container_padding-top": "{m}",
    "sidepanel_base_section-container_padding-right": "{m}",
    "sidepanel_base_header-container_background-color": "{primary50}",
    "sidepanel_base_header-container_padding-top": "{s}",
    "sidepanel_base_header-container_padding-bottom": "{s}",
    "sidepanel_base_header-container_padding-right": "{m}",
    "sidepanel_base_header-container_padding-left": "{m}",
    "sidepanel_base_header-container_width": "{size.max}",
    "sidepanel_base_header-container_justify-content": "{justifyContent.spaceBetween}",
    "sidepanel_base_header-container_align-items": "{alignItems.center}",
    "sidepanel_base_left-container_flex-direction": "{flexDirection.row}",
    "sidepanel_base_left-container_gap": "{s}",
    "sidepanel_base_left-container_align-items": "{alignItems.center}",
    "sidepanel_variant_direction_right_popup-container_justify-content": "{justifyContent.end}",
    sidepanel_combination_true_desktop_container_width: $52d4442770cfd938$var$sidepanel_combination_true_desktop_container_width,
    sidepanel_combination_true_mobile_container_width: $52d4442770cfd938$var$sidepanel_combination_true_mobile_container_width,
    sidepanel_combination_false_mobile_container_width: $52d4442770cfd938$var$sidepanel_combination_false_mobile_container_width
};
const $52d4442770cfd938$var$MegaMenuItemTokens = {
    "megamenuitem_base_container_flex-direction": "{flexDirection.row}",
    "megamenuitem_base_container_justify-content": "{justifyContent.start}",
    "megamenuitem_base_container_align-items": "{alignItems.start}",
    "megamenuitem_base_container_padding-top": "{xs}",
    "megamenuitem_base_container_padding-bottom": "{xs}"
};
const $52d4442770cfd938$var$sidepanelitem_base_container_width = "{size.max}";
const $52d4442770cfd938$var$SidePanelItemTokens = {
    "sidepanelitem_base_heading-jds_text_padding-top": "{xl}",
    "sidepanelitem_base_heading-jds_text_padding-bottom": "{xs}",
    "sidepanelitem_base_container_flex-direction": "{flexDirection.row}",
    "sidepanelitem_base_container_justify-content": "{justifyContent.spaceBetween}",
    "sidepanelitem_base_container_align-items": "{alignItems.center}",
    sidepanelitem_base_container_width: $52d4442770cfd938$var$sidepanelitem_base_container_width,
    "sidepanelitem_base_inner-container_flex-direction": "{flexDirection.row}",
    "sidepanelitem_base_inner-container_justify-content": "{justifyContent.start}",
    "sidepanelitem_base_inner-container_align-items": "{alignItems.center}",
    "sidepanelitem_base_inner-container_gap": "{base}",
    "sidepanelitem_base_inner-container_padding-top": "{s}",
    "sidepanelitem_base_inner-container_padding-bottom": "{s}"
};
const $52d4442770cfd938$var$NotificationBannerTokens = {
    "notificationbanner_base_root-container_min-height": "{custom_11}",
    "notificationbanner_base_root-container_width": "{size.max}",
    "notificationbanner_base_root-container_flex-direction": "{flexDirection.column}",
    "notificationbanner_base_root-container_justify-content": "{justifyContent.center}",
    "notificationbanner_base_root-container_align-items": "{alignItems.center}",
    "notificationbanner_base_root-container_padding-top": "{base}",
    "notificationbanner_base_root-container_padding-right": "{base}",
    "notificationbanner_base_root-container_padding-bottom": "{base}",
    "notificationbanner_base_root-container_padding-left": "{base}",
    "notificationbanner_base_root-container_gap": "{base}",
    "notificationbanner_base_root-container_border-radius": "{large}",
    "notificationbanner_base_root-container_background-color": "{primaryGrey20}",
    "notificationbanner_base_main-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_main-container_justify-content": "{justifyContent.start}",
    "notificationbanner_base_main-container_align-items": "{alignItems.start}",
    "notificationbanner_base_main-container_width": "{size.max}",
    "notificationbanner_base_main-container_gap": "{s}",
    "notificationbanner_base_text-container_justify-content": "{justifyContent.start}",
    "notificationbanner_base_text-container_align-items": "{alignItems.start}",
    "notificationbanner_base_text-container_flex-direction": "{flexDirection.column}",
    "notificationbanner_base_text-container_gap": "{xxs}",
    "notificationbanner_base_button-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_button-container_gap": "{xs}",
    "notificationbanner_base_bottom-container_width": "{size.max}",
    "notificationbanner_base_bottom-container_flex-direction": "{flexDirection.row}",
    "notificationbanner_base_bottom-container_justify-content": "{justifyContent.end}",
    "notificationbanner_base_bottom-container_align-items": "{alignItems.center}",
    "notificationbanner_variant__hasDescription_false_main-container_align-items": "{alignItems.center}",
    "notificationbanner_combination_true_desktop_root-container_padding-left": "{custom_3}",
    "notificationbanner_combination_true_desktop_root-container_padding-right": "{custom_3}",
    "notificationbanner_combination_true_mobile_root-container_padding-left": "{m}",
    "notificationbanner_combination_true_mobile_root-container_padding-right": "{m}",
    "notificationbanner_combination_true_tablet_root-container_padding-left": "{l}",
    "notificationbanner_combination_true_tablet_root-container_padding-right": "{l}"
};
const $52d4442770cfd938$var$notificationbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$notificationbutton_base_icon_color = "{primary20}";
const $52d4442770cfd938$var$notificationbutton_base_icon_size = "{base}";
const $52d4442770cfd938$var$NotificationButtonTokens = {
    "notificationbutton_base_container_padding-top": "{xxs}",
    "notificationbutton_base_container_padding-right": "{base}",
    "notificationbutton_base_container_padding-bottom": "{xxs}",
    "notificationbutton_base_container_padding-left": "{base}",
    "notificationbutton_base_container_background-color": "{global.transparent}",
    "notificationbutton_base_container_border-color": "{primaryGrey60}",
    "notificationbutton_base_container_behavior_hover_border-color": "{primary20}",
    "notificationbutton_base_container_behavior_active_background-color": "{primary30}",
    "notificationbutton_base_container_behavior_focus_border-color": "{primary50}",
    notificationbutton_variant_isDisabled_true_container_opacity: $52d4442770cfd938$var$notificationbutton_variant_isDisabled_true_container_opacity,
    "notificationbutton_variant_kind_tertiary_container_behavior_hover_background-color": "{primary30}",
    "notificationbutton_variant_kind_tertiary_container_behavior_active_background-color": "{primary40}",
    "notificationbutton_variant_kind_tertiary_container_behavior_focus_background-color": "{primary30}",
    notificationbutton_base_icon_color: $52d4442770cfd938$var$notificationbutton_base_icon_color,
    notificationbutton_base_icon_size: $52d4442770cfd938$var$notificationbutton_base_icon_size,
    "notificationbutton_variant__hasLabel_false_container_padding-top": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-bottom": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-left": "{xs}",
    "notificationbutton_variant__hasLabel_false_container_padding-right": "{xs}"
};
const $52d4442770cfd938$var$notificationiconbutton_base_container_height = "{l}";
const $52d4442770cfd938$var$notificationiconbutton_base_container_width = "{l}";
const $52d4442770cfd938$var$notificationiconbutton_base_icon_size = "{base}";
const $52d4442770cfd938$var$notificationiconbutton_base_icon_color = "{primary20}";
const $52d4442770cfd938$var$notificationiconbutton_variant_isDisabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$NotificationIconButtonTokens = {
    notificationiconbutton_base_container_height: $52d4442770cfd938$var$notificationiconbutton_base_container_height,
    notificationiconbutton_base_container_width: $52d4442770cfd938$var$notificationiconbutton_base_container_width,
    "notificationiconbutton_base_container_justify-content": "{justifyContent.center}",
    "notificationiconbutton_base_container_align-items": "{alignItems.center}",
    "notificationiconbutton_base_container_background-color": "{global.transparent}",
    "notificationiconbutton_base_container_border-color": "{global.transparent}",
    "notificationiconbutton_base_container_behavior_hover_background-color": "{primary30}",
    "notificationiconbutton_base_container_behavior_active_background-color": "{primary40}",
    "notificationiconbutton_base_container_behavior_focus_background-color": "{primary30}",
    "notificationiconbutton_base_container_behavior_focus_border-color": "{primary50}",
    notificationiconbutton_base_icon_size: $52d4442770cfd938$var$notificationiconbutton_base_icon_size,
    notificationiconbutton_base_icon_color: $52d4442770cfd938$var$notificationiconbutton_base_icon_color,
    notificationiconbutton_variant_isDisabled_true_container_opacity: $52d4442770cfd938$var$notificationiconbutton_variant_isDisabled_true_container_opacity
};
const $52d4442770cfd938$var$NudgeTokens = {
    "nudge_base_root-container_width": "{size.max}",
    "nudge_base_root-container_max-width": "{size.max}",
    "nudge_base_root-container_border-radius": "{xl}",
    "nudge_base_root-container_background-color": "{primaryGrey80}",
    "nudge_base_root-container_flex-direction": "{flexDirection.column}",
    "nudge_base_root-container_gap": "{base}",
    "nudge_base_root-container_padding-top": "{base}",
    "nudge_base_root-container_padding-right": "{base}",
    "nudge_base_root-container_padding-bottom": "{base}",
    "nudge_base_root-container_padding-left": "{base}",
    "nudge_base_base-container_gap": "{s}",
    "nudge_base_base-container_width": "{size.max}",
    "nudge_base_base-container_flex-direction": "{flexDirection.row}",
    "nudge_base_base-container_justify-content": "{justifyContent.start}",
    "nudge_base_base-container_align-items": "{alignItems.center}",
    "nudge_base_center-container_flex-direction": "{flexDirection.column}",
    "nudge_base_center-container_justify-content": "{justifyContent.start}",
    "nudge_base_center-container_align-items": "{alignItems.start}",
    "nudge_base_center-container_gap": "{s}",
    "nudge_base_buttons-container_width": "{size.max}",
    "nudge_base_buttons-container_gap": "{s}",
    "nudge_base_buttons-container_flex-direction": "{flexDirection.row}",
    "nudge_base_buttons-container_justify-content": "{justifyContent.end}",
    "nudge_variant__platform_tablet_root-container_max-width": "{custom_13}",
    "nudge_variant__platform_desktop_root-container_max-width": "{custom_14}"
};
const $52d4442770cfd938$var$ToastTokens = {
    "toast_base_root-container_width": "{size.max}",
    "toast_base_root-container_max-width": "{size.max}",
    "toast_base_root-container_border-radius": "{xl}",
    "toast_base_root-container_background-color": "{primaryGrey80}",
    "toast_base_root-container_flex-direction": "{flexDirection.column}",
    "toast_base_root-container_gap": "{base}",
    "toast_base_root-container_padding-top": "{base}",
    "toast_base_root-container_padding-right": "{base}",
    "toast_base_root-container_padding-bottom": "{base}",
    "toast_base_root-container_padding-left": "{base}",
    "toast_base_base-container_gap": "{s}",
    "toast_base_base-container_width": "{size.max}",
    "toast_base_base-container_flex-direction": "{flexDirection.row}",
    "toast_base_base-container_justify-content": "{justifyContent.start}",
    "toast_base_base-container_align-items": "{alignItems.center}",
    "toast_base_center-container_flex-direction": "{flexDirection.column}",
    "toast_base_center-container_justify-content": "{justifyContent.start}",
    "toast_base_center-container_align-items": "{alignItems.start}",
    "toast_base_center-container_gap": "{xxs}",
    "toast_base_buttons-container_width": "{size.max}",
    "toast_base_buttons-container_gap": "{s}",
    "toast_base_buttons-container_flex-direction": "{flexDirection.row}",
    "toast_base_buttons-container_justify-content": "{justifyContent.end}",
    "toast_variant__platform_tablet_root-container_max-width": "{custom_13}",
    "toast_variant__platform_desktop_root-container_max-width": "{custom_14}"
};
const $52d4442770cfd938$var$NudgeContainerTokens = {
    "nudgecontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
    "nudgecontainer_base_popup-container_size": "{size.max}",
    "nudgecontainer_base_popup-container_padding-top": "{base}",
    "nudgecontainer_base_popup-container_padding-right": "{base}",
    "nudgecontainer_base_popup-container_padding-bottom": "{base}",
    "nudgecontainer_base_popup-container_padding-left": "{base}",
    "nudgecontainer_base_root-container_flex-direction": "{flexDirection.column}",
    "nudgecontainer_base_root-container_justify-content": "{justifyContent.start}",
    "nudgecontainer_base_root-container_align-items": "{alignItems.end}",
    "nudgecontainer_base_root-container_size": "{size.max}",
    "nudgecontainer_base_root-container_gap": "{xs}"
};
const $52d4442770cfd938$var$ToastContainerTokens = {
    "toastcontainer_base_popup-container_flex-direction": "{flexDirection.stack}",
    "toastcontainer_base_popup-container_size": "{size.max}",
    "toastcontainer_base_popup-container_padding-top": "{base}",
    "toastcontainer_base_popup-container_padding-right": "{base}",
    "toastcontainer_base_popup-container_padding-bottom": "{base}",
    "toastcontainer_base_popup-container_padding-left": "{base}",
    "toastcontainer_base_root-container_flex-direction": "{flexDirection.column}",
    "toastcontainer_base_root-container_justify-content": "{justifyContent.end}",
    "toastcontainer_base_root-container_align-items": "{alignItems.start}",
    "toastcontainer_base_root-container_size": "{size.max}",
    "toastcontainer_base_root-container_gap": "{xs}"
};
const $52d4442770cfd938$var$progressbar_base_container_gap = "{base}";
const $52d4442770cfd938$var$progressbar_base_container_width = "{size.max}";
const $52d4442770cfd938$var$ProgressBarTokens = {
    "progressbar_base_container_flex-direction": "{flexDirection.column}",
    "progressbar_base_container_justify-content": "{justifyContent.center}",
    "progressbar_base_container_align-items": "{alignItems.start}",
    progressbar_base_container_gap: $52d4442770cfd938$var$progressbar_base_container_gap,
    progressbar_base_container_width: $52d4442770cfd938$var$progressbar_base_container_width,
    "progressbar_base_container_background-color": "{global.transparent}",
    "progressbar_base_top-container_background-color": "{global.transparent}",
    "progressbar_base_top-container_flex-direction": "{flexDirection.row}",
    "progressbar_base_top-container_justify-content": "{justifyContent.spaceBetween}",
    "progressbar_base_top-container_align-items": "{alignItems.center}",
    "progressbar_base_top-container_width": "{size.max}",
    "progressbar_base_top-container_gap": "{m}",
    "progressbar_base_determinate-container_background-color": "{primaryGrey40}",
    "progressbar_base_determinate-container_height": "{xs}",
    "progressbar_base_determinate-container_width": "{size.max}",
    "progressbar_base_determinate-container_flex-direction": "{flexDirection.row}",
    "progressbar_base_determinate-container_justify-content": "{justifyContent.start}",
    "progressbar_base_determinate-container_align-items": "{alignItems.start}",
    "progressbar_base_determinate-container_border-radius": "{pill}",
    "progressbar_base_active-container_background-color": "{primary50}",
    "progressbar_base_active-container_height": "{xs}",
    "progressbar_base_active-container_border-radius": "{pill}",
    "progressbar_base_invisible-container_height": "{xs}",
    "progressbar_base_indeterminate-container_flex-direction": "{flexDirection.stack}",
    "progressbar_base_indeterminate-container_background-color": "{primaryGrey40}",
    "progressbar_base_indeterminate-container_height": "{xs}",
    "progressbar_base_indeterminate-container_width": "{size.max}",
    "progressbar_base_indeterminate-container_border-radius": "{pill}",
    "progressbar_base_track-container_height": "{size.max}",
    "progressbar_base_active-animatedContainer_height": "{size.max}",
    "progressbar_base_active-animatedContainer_width": "{massive}",
    "progressbar_base_active-animatedContainer_background-color": "{primary50}",
    "progressbar_base_active-animatedContainer_border-radius": "{pill}",
    "progressbar_variant_state_success_active-container_background-color": "{feedbackSuccess50}",
    "progressbar_variant_state_success_active-animatedContainer_background-color": "{feedbackSuccess50}",
    "progressbar_variant_state_error_active-container_background-color": "{feedbackError50}",
    "progressbar_variant_state_error_active-animatedContainer_background-color": "{feedbackError50}",
    "progressbar_variant_state_warning_active-container_background-color": "{feedbackWarning50}",
    "progressbar_variant_state_warning_active-animatedContainer_background-color": "{feedbackWarning50}",
    "progressbar_variant_labelPosition_center_top-container_justify-content": "{justifyContent.center}"
};
const $52d4442770cfd938$var$pagination_base_container_width = "{size.max}";
const $52d4442770cfd938$var$PaginationTokens = {
    "pagination_base_container_background-color": "{global.transparent}",
    "pagination_base_container_flex-direction": "{flexDirection.row}",
    "pagination_base_container_justify-content": "{alignItems.center}",
    "pagination_base_container_align-items": "{alignItems.center}",
    "pagination_base_container_padding-left": "{custom_25}",
    "pagination_base_container_padding-right": "{custom_25}",
    pagination_base_container_width: $52d4442770cfd938$var$pagination_base_container_width,
    "pagination_base_container_min-height": "{xxl}",
    "pagination_base_basic-container_flex-direction": "{flexDirection.row}",
    "pagination_base_compact-container_flex-direction": "{flexDirection.row}",
    "pagination_base_compact-container_gap": "{xxs}",
    "pagination_base_compact-container_padding-left": "{base}",
    "pagination_base_compact-container_padding-right": "{base}"
};
const $52d4442770cfd938$var$PromoCardTokens = {
    "promocard_base_root-container_background-color": "{global.white}",
    "promocard_base_root-container_flex-direction": "{flexDirection.column}",
    "promocard_base_root-container_width": "{size.max}",
    "promocard_base_root-container_justify-content": "{justifyContent.start}",
    "promocard_base_root-container_align-items": "{alignItems.start}",
    "promocard_base_root-container_border-radius": "{xl}",
    "promocard_base_vertical-container_flex-direction": "{flexDirection.column}",
    "promocard_base_vertical-container_align-items": "{alignItems.start}",
    "promocard_base_vertical-container_justify-content": "{justifyContent.start}",
    "promocard_base_vertical-container_width": "{size.max}",
    "promocard_base_vertical-container_border-radius": "{xl}",
    "promocard_base_vertical-container_background-color": "{primaryBackground}",
    "promocard_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "promocard_base_horizontal-container_align-items": "{alignItems.stretch}",
    "promocard_base_horizontal-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-container_width": "{size.max}",
    "promocard_base_horizontal-container_border-radius": "{xl}",
    "promocard_base_horizontal-container_height": "{intrinsicSize.max}",
    "promocard_base_horizontal-container_background-color": "{primaryBackground}",
    "promocard_base_vertical-content-container_flex-direction": "{flexDirection.row}",
    "promocard_base_vertical-content-container_align-items": "{alignItems.start}",
    "promocard_base_vertical-content-container_justify-content": "{justifyContent.start}",
    "promocard_base_vertical-content-container_width": "{size.max}",
    "promocard_base_vertical-content-container_background-color": "{primaryBackground}",
    "promocard_base_vertical-content-container_border-bottom-left-radius": "{xl}",
    "promocard_base_vertical-content-container_border-bottom-right-radius": "{xl}",
    "promocard_base_vertical-content-container_padding-right": "{m}",
    "promocard_base_vertical-content-container_padding-bottom": "{m}",
    "promocard_base_vertical-content-container_padding-left": "{m}",
    "promocard_base_horizontal-content-container_flex-direction": "{flexDirection.row}",
    "promocard_base_horizontal-content-container_align-items": "{alignItems.start}",
    "promocard_base_horizontal-content-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-content-container_height": "{size.max}",
    "promocard_base_horizontal-content-container_background-color": "{primaryBackground}",
    "promocard_base_horizontal-content-container_padding-top": "{m}",
    "promocard_base_horizontal-content-container_padding-right": "{m}",
    "promocard_base_horizontal-content-container_padding-bottom": "{m}",
    "promocard_base_horizontal-content-container_padding-left": "{m}",
    "promocard_base_vertical-image-container_width": "{size.max}",
    "promocard_base_vertical-image-container_flex-direction": "{flexDirection.stack}",
    "promocard_base_vertical-image-container_align-items": "{alignItems.end}",
    "promocard_base_horizontal-image-container_height": "{size.max}",
    "promocard_base_horizontal-image-container_flex-direction": "{flexDirection.stack}",
    "promocard_base_horizontal-image-container_align-items": "{alignItems.center}",
    "promocard_base_horizontal-image-container_justify-content": "{justifyContent.start}",
    "promocard_base_horizontal-image_height": "{size.max}",
    "promocard_base_vertical-promoCardArc_color": "{primaryBackground}",
    "promocard_base_vertical-promoCardArc_width": "{size.max}",
    "promocard_base_vertical-promoCardArc_height": "{xl}",
    "promocard_base_horizontal-promoCardArc_color": "{primaryBackground}",
    "promocard_base_horizontal-promoCardArc_height": "{size.max}",
    "promocard_base_horizontal-promoCardArc_width": "{xl}",
    "promocard_base_footer-container_color": "{primaryBackground}",
    "promocard_base_footer-container_width": "{size.max}",
    "promocard_base_footer-container_justify-content": "{justifyContent.spaceBetween}",
    "promocard_base_footer-container_align-items": "{alignItems.center}",
    "promocard_base_footer-container_flex-direction": "{flexDirection.row}",
    "promocard_base_footer-container_gap": "{base}",
    "promocard_base_footer-container_padding-left": "{m}",
    "promocard_base_footer-container_padding-right": "{m}",
    "promocard_base_footer-container_padding-top": "{base}",
    "promocard_base_footer-container_padding-bottom": "{base}",
    "promocard_variant_size_medium_horizontal-content-container_padding-top": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-right": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-bottom": "{l}",
    "promocard_variant_size_medium_horizontal-content-container_padding-left": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-top": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-right": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-bottom": "{l}",
    "promocard_variant_size_large_horizontal-content-container_padding-left": "{l}"
};
const $52d4442770cfd938$var$searchresultitem_base_container_gap = "{base}";
const $52d4442770cfd938$var$searchresultitem_base_container_width = "{size.max}";
const $52d4442770cfd938$var$searchresultitem_base_icon_size = "{l}";
const $52d4442770cfd938$var$searchresultitem_base_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$SearchResultItemTokens = {
    "searchresultitem_base_container_flex-direction": "{flexDirection.row}",
    searchresultitem_base_container_gap: $52d4442770cfd938$var$searchresultitem_base_container_gap,
    "searchresultitem_base_container_padding-top": "{xs}",
    "searchresultitem_base_container_padding-bottom": "{xs}",
    "searchresultitem_base_container_align-items": "{alignItems.center}",
    searchresultitem_base_container_width: $52d4442770cfd938$var$searchresultitem_base_container_width,
    "searchresultitem_base_container_behavior_hover_background-color": "{primaryGrey20}",
    "searchresultitem_base_container_behavior_active_background-color": "{primaryGrey20}",
    "searchresultitem_base_container_behavior_focus_background-color": "{primaryGrey20}",
    searchresultitem_base_icon_size: $52d4442770cfd938$var$searchresultitem_base_icon_size,
    searchresultitem_base_icon_color: $52d4442770cfd938$var$searchresultitem_base_icon_color,
    "searchresultitem_base_text-container_flex-direction": "{flexDirection.row}",
    "searchresultitem_base_text-container_justify-content": "{justifyContent.start}",
    "searchresultitem_base_text-container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$SearchResultTextTokens = {};
const $52d4442770cfd938$var$searchresults_base_container_width = "{size.max}";
const $52d4442770cfd938$var$SearchResultsTokens = {
    "searchresults_base_popup_background-color": "{global.transparent}",
    "searchresults_base_popup-container_flex-direction": "{flexDirection.stack}",
    "searchresults_base_popup-container_justify-content": "{justifyContent.center}",
    "searchresults_base_popup-container_width": "{size.max}",
    "searchresults_base_popup-container_background-color": "{global.transparent}",
    "searchresults_base_root-container_background-color": "{primaryBackground}",
    "searchresults_base_root-container_flex-direction": "{flexDirection.column}",
    "searchresults_base_root-container_align-items": "{alignItems.center}",
    "searchresults_base_root-container_padding-top": "{base}",
    "searchresults_base_root-container_padding-right": "{base}",
    "searchresults_base_root-container_padding-bottom": "{base}",
    "searchresults_base_root-container_padding-left": "{base}",
    "searchresults_base_root-container_gap": "{base}",
    "searchresults_base_root-container_width": "{size.max}",
    searchresults_base_container_width: $52d4442770cfd938$var$searchresults_base_container_width,
    "searchresults_base_container_flex-direction": "{flexDirection.column}",
    "searchresults_base_container_align-items": "{alignItems.center}",
    "searchresults_base_heading-container_flex-direction": "{flexDirection.row}",
    "searchresults_base_heading-container_justify-content": "{justifyContent.spaceBetween}",
    "searchresults_base_heading-container_align-items": "{alignItems.start}",
    "searchresults_base_heading-container_width": "{size.max}",
    "searchresults_base_results-container_flex-direction": "{flexDirection.column}",
    "searchresults_base_results-container_align-items": "{alignItems.start}",
    "searchresults_base_results-container_gap": "{base}",
    "searchresults_base_results-container_width": "{size.max}",
    "searchresults_variant_appearance_box_root-container_border-radius": "{xl}"
};
const $52d4442770cfd938$var$RadioButtonTokens = {
    "radiobutton_base_vertical-container_flex-direction": "{flexDirection.column}",
    "radiobutton_base_vertical-container_justify-content": "{justifyContent.start}",
    "radiobutton_base_vertical-container_align-items": "{alignItems.start}",
    "radiobutton_base_vertical-container_gap": "{xs}",
    "radiobutton_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "radiobutton_base_horizontal-container_justify-content": "{justifyContent.start}",
    "radiobutton_base_horizontal-container_align-items": "{alignItems.center}",
    "radiobutton_base_horizontal-container_gap": "{xs}",
    "radiobutton_base_outer-container_min-width": "{m}",
    "radiobutton_base_outer-container_min-height": "{m}",
    "radiobutton_base_outer-container_flex-direction": "{flexDirection.row}",
    "radiobutton_base_outer-container_justify-content": "{justifyContent.center}",
    "radiobutton_base_outer-container_align-items": "{alignItems.center}",
    "radiobutton_base_outer-container_background-color": "{global.transparent}",
    "radiobutton_base_outer-container_border-radius": "{pill}",
    "radiobutton_base_outer-container_border-color": "{primaryGrey80}",
    "radiobutton_base_outer-container_border-width": "{border_thin}",
    "radiobutton_variant_checked_true_outer-container_border-width": "{border_none}",
    "radiobutton_base_outer-container_behavior_hover_border-color": "{primary40}",
    "radiobutton_base_outer-container_behavior_active_border-color": "{primary60}",
    "radiobutton_base_outer-container_behavior_focus_border-color": "{primary60}",
    "radiobutton_base_inner-container_min-width": "{s}",
    "radiobutton_base_inner-container_min-height": "{s}",
    "radiobutton_base_inner-container_border-radius": "{pill}",
    "radiobutton_base_label-jds_text_text-align": "{textAlign.start}",
    "radiobutton_variant_size_small_outer-container_min-width": "{base}",
    "radiobutton_variant_size_small_outer-container_min-height": "{base}",
    "radiobutton_variant_size_small_vertical-container_gap": "{xxs}",
    "radiobutton_variant_size_small_inner-container_min-width": "{xs}",
    "radiobutton_variant_size_small_inner-container_min-height": "{xs}",
    "radiobutton_variant_checked_true_outer-container_background-color": "{primary50}",
    "radiobutton_variant_checked_true_outer-container_behavior_hover_background-color": "{primary40}",
    "radiobutton_variant_checked_true_outer-container_behavior_active_background-color": "{primary60}",
    "radiobutton_variant_checked_true_outer-container_behavior_focus_background-color": "{primary50}",
    "radiobutton_variant_checked_true_inner-container_background-color": "{primaryInverse}",
    "radiobutton_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "radiobutton_base_vertical-container_opacity": "{opacity.enabled}",
    "radiobutton_combination_true_success_inner-container_background-color": "{global.white}",
    "radiobutton_combination_true_error_inner-container_background-color": "{global.white}",
    "radiobutton_combination_true_warning_inner-container_background-color": "{global.white}"
};
const $52d4442770cfd938$var$skeleton_variant_shape_heading_container_height = "{xxl}";
const $52d4442770cfd938$var$skeleton_variant_shape_paragraph_container_height = "{base}";
const $52d4442770cfd938$var$skeleton_variant_shape_custom_container_width = "{size.max}";
const $52d4442770cfd938$var$skeleton_variant_shape_custom_container_height = "{size.max}";
const $52d4442770cfd938$var$SkeletonTokens = {
    "skeleton_base_container_background-color": "{primaryGrey20}",
    "skeleton_base_skeletonLoader_primary-color": "{primaryGrey20}",
    "skeleton_base_skeletonLoader_secondary-color": "{primaryGrey40}",
    "skeleton_variant_shape_circle_container_border-radius": "{pill}",
    skeleton_variant_shape_heading_container_height: $52d4442770cfd938$var$skeleton_variant_shape_heading_container_height,
    "skeleton_variant_shape_heading_container_border-radius": "{pill}",
    "skeleton_variant_shape_paragraph_container_border-radius": "{pill}",
    skeleton_variant_shape_paragraph_container_height: $52d4442770cfd938$var$skeleton_variant_shape_paragraph_container_height,
    "skeleton_variant_shape_rectangle_container_border-radius": "{xl}",
    "skeleton_variant_shape_square_container_border-radius": "{xxl}",
    skeleton_variant_shape_custom_container_width: $52d4442770cfd938$var$skeleton_variant_shape_custom_container_width,
    skeleton_variant_shape_custom_container_height: $52d4442770cfd938$var$skeleton_variant_shape_custom_container_height
};
const $52d4442770cfd938$var$selector_variant_stretch_true_container_width = "{size.max}";
const $52d4442770cfd938$var$SelectorTokens = {
    "selector_base_container_flex-direction": "{flexDirection.stack}",
    "selector_base_selector-container_opacity": "{opacity.enabled}",
    "selector_base_selector-container_align-items": "{alignItems.center}",
    "selector_base_selector-container_justify-content": "{justifyContent.center}",
    "selector_base_selector-container_border-radius": "{pill}",
    "selector_base_selector-container_padding-top": "{xxs}",
    "selector_base_selector-container_padding-right": "{xxs}",
    "selector_base_selector-container_padding-bottom": "{xxs}",
    "selector_base_selector-container_padding-left": "{xxs}",
    "selector_base_outer-container_padding-top": "{xxs}",
    "selector_base_outer-container_padding-right": "{xxs}",
    "selector_base_outer-container_padding-bottom": "{xxs}",
    "selector_base_outer-container_padding-left": "{xxs}",
    "selector_base_outer-container_background-color": "{primaryGrey20}",
    "selector_base_outer-container_border-radius": "{pill}",
    "selector_base_selector-container_gap": "{xxs}",
    "selector_base_selector-container_flex-direction": "{flexDirection.row}",
    "selector_base_outer-container_width": "{size.max}",
    "selector_base_outer-container_height": "{intrinsicSize.max}",
    "selector_base_outer-container_justify-content": "{justifyContent.start}",
    "selector_base_outer-container_align-items": "{alignItems.center}",
    "selector_base_inner-container_background-color": "{primary50}",
    "selector_base_inner-container_border-radius": "{pill}",
    selector_variant_stretch_true_container_width: $52d4442770cfd938$var$selector_variant_stretch_true_container_width,
    "selector_variant_stretch_true_selector-container_width": "{size.max}",
    "selector_variant__animating_true_inner-container_background-color": "{primary50}"
};
const $52d4442770cfd938$var$selectoritem_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$selectoritem_base_container_gap = "{xs}";
const $52d4442770cfd938$var$selectoritem_base_icon_size = "{m}";
const $52d4442770cfd938$var$selectoritem_base_icon_color = "{primary60}";
const $52d4442770cfd938$var$selectoritem_variant_selected_true_icon_color = "{primaryInverse}";
const $52d4442770cfd938$var$selectoritem_variant_selected_true_icon_behavior_active_color = "{primary30}";
const $52d4442770cfd938$var$selectoritem_variant_stretch_true_container_width = "{size.max}";
const $52d4442770cfd938$var$selectoritem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$selectoritem_variant_wrap_vertical_container_gap = "{xxs}";
const $52d4442770cfd938$var$SelectorItemTokens = {
    selectoritem_base_container_opacity: $52d4442770cfd938$var$selectoritem_base_container_opacity,
    "selectoritem_base_container_background-color": "{global.transparent}",
    "selectoritem_base_container_flex-direction": "{flexDirection.row}",
    "selectoritem_base_container_align-items": "{alignItems.center}",
    "selectoritem_base_container_justify-content": "{justifyContent.center}",
    "selectoritem_base_container_border-radius": "{pill}",
    selectoritem_base_container_gap: $52d4442770cfd938$var$selectoritem_base_container_gap,
    "selectoritem_base_container_padding-top": "{xs}",
    "selectoritem_base_container_padding-right": "{base}",
    "selectoritem_base_container_padding-bottom": "{xs}",
    "selectoritem_base_container_padding-left": "{base}",
    "selectoritem_base_container_behavior_focus_background-color": "{primary20}",
    "selectoritem_base_container_behavior_focus_box-shadow_spread": "{xxs}",
    "selectoritem_base_container_behavior_focus_box-shadow_color": "{primary60}",
    "selectoritem_base_container_behavior_hover_background-color": "{primary20}",
    "selectoritem_base_container_behavior_active_background-color": "{primary30}",
    selectoritem_base_icon_size: $52d4442770cfd938$var$selectoritem_base_icon_size,
    selectoritem_base_icon_color: $52d4442770cfd938$var$selectoritem_base_icon_color,
    "selectoritem_variant_selected_true_container_background-color": "{primary50}",
    "selectoritem_variant_selected_true_container_behavior_hover_background-color": "{primary60}",
    "selectoritem_variant_selected_true_container_behavior_active_background-color": "{primary60}",
    "selectoritem_variant_selected_true_container_behavior_focus_background-color": "{primary50}",
    selectoritem_variant_selected_true_icon_color: $52d4442770cfd938$var$selectoritem_variant_selected_true_icon_color,
    selectoritem_variant_selected_true_icon_behavior_active_color: $52d4442770cfd938$var$selectoritem_variant_selected_true_icon_behavior_active_color,
    "selectoritem_variant_wrap_vertical_container_flex-direction": "{flexDirection.column}",
    selectoritem_variant_stretch_true_container_width: $52d4442770cfd938$var$selectoritem_variant_stretch_true_container_width,
    selectoritem_variant_disabled_true_container_opacity: $52d4442770cfd938$var$selectoritem_variant_disabled_true_container_opacity,
    selectoritem_variant_wrap_vertical_container_gap: $52d4442770cfd938$var$selectoritem_variant_wrap_vertical_container_gap
};
const $52d4442770cfd938$var$servicecard_base_jds_content_block_width = "{size.max}";
const $52d4442770cfd938$var$ServiceCardTokens = {
    "servicecard_base_root-container_flex-direction": "{flexDirection.stack}",
    "servicecard_base_inner-stack-container_flex-direction": "{flexDirection.stack}",
    "servicecard_base_root-container_size": "{size.max}",
    "servicecard_base_inner-stack-container_size": "{size.max}",
    "servicecard_base_root-container_justify-content": "{justifyContent.start}",
    "servicecard_base_inner-stack-container_justify-content": "{justifyContent.start}",
    "servicecard_base_root-container_align-items": "{alignItems.start}",
    "servicecard_base_root-container_border-radius": "{xl}",
    "servicecard_base_blur-image_height": "{size.max}",
    "servicecard_base_blur-image_width": "{size.max}",
    "servicecard_base_blur-image_blur-radius": "{xl}",
    "servicecard_base_blur-image_aspect-ratio": "{aspect_ratio.16.9}",
    "servicecard_base_internal-vertical-container_flex-direction": "{flexDirection.column}",
    "servicecard_base_internal-vertical-container_size": "{size.max}",
    "servicecard_base_internal-vertical-container_justify-content": "{justifyContent.start}",
    "servicecard_base_internal-vertical-container_align-items": "{alignItems.start}",
    "servicecard_base_image-container_flex-direction": "{flexDirection.row}",
    "servicecard_base_image-container_justify-content": "{justifyContent.start}",
    "servicecard_base_image-container_align-items": "{alignItems.start}",
    "servicecard_base_image-container_height": "{size.max}",
    "servicecard_base_image-container_width": "{size.max}",
    "servicecard_base_jds_badge_padding-top": "{base}",
    "servicecard_base_jds_badge_padding-left": "{base}",
    "servicecard_base_content-block-container_background-color": "{custom_color_4}",
    "servicecard_base_content-block-container_width": "{size.max}",
    "servicecard_base_content-block-container_padding-top": "{base}",
    "servicecard_base_content-block-container_padding-bottom": "{base}",
    "servicecard_base_content-block-container_padding-left": "{base}",
    "servicecard_base_content-block-container_padding-right": "{base}",
    servicecard_base_jds_content_block_width: $52d4442770cfd938$var$servicecard_base_jds_content_block_width,
    "servicecard_variant_imageRatio_square_blur_image_aspect-ratio": "{aspect_ratio.1.1}",
    "servicecard_variant_imageRatio_landscape_blur_image_aspect-ratio": "{aspect_ratio.4.3}",
    "servicecard_variant_imageRatio_portrait_blur_image_aspect-ratio": "{aspect_ratio.4.5}"
};
const $52d4442770cfd938$var$slider_base_container_width = "{size.max}";
const $52d4442770cfd938$var$slider_base_container_gap = "{xs}";
const $52d4442770cfd938$var$slider_base_slider_width = "{size.max}";
const $52d4442770cfd938$var$slider_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$SliderTokens = {
    "slider_base_container_flex-direction": "{flexDirection.column}",
    "slider_base_container_justify-content": "{justifyContent.start}",
    "slider_base_container_align-items": "{alignItems.start}",
    slider_base_container_width: $52d4442770cfd938$var$slider_base_container_width,
    slider_base_container_gap: $52d4442770cfd938$var$slider_base_container_gap,
    "slider_base_top-container_flex-direction": "{flexDirection.row}",
    "slider_base_top-container_justify-content": "{justifyContent.start}",
    "slider_base_top-container_align-items": "{alignItems.center}",
    "slider_base_top-container_width": "{size.max}",
    "slider_base_top-container_gap": "{xs}",
    "slider_base_label-jds_text_justify-content": "{justifyContent.start}",
    "slider_base_label-jds_text_align-items": "{alignItems.center}",
    "slider_base_inner-container_align-items": "{alignItems.center}",
    "slider_base_inner-container_padding-left": "{xs}",
    "slider_base_inner-container_padding-right": "{xs}",
    "slider_base_inner-container_border-width": "{border_thin}",
    "slider_base_inner-container_border-color": "{primaryGrey80}",
    "slider_base_inner-container_border-radius": "{medium}",
    slider_base_slider_width: $52d4442770cfd938$var$slider_base_slider_width,
    "slider_base_slider_track-height": "{xxs}",
    "slider_base_slider_inactive-color": "{primaryGrey40}",
    "slider_base_slider_active-color": "{primary50}",
    "slider_base_slider_ball-color": "{primary50}",
    "slider_base_slider_ball-border-color": "{primary80}",
    "slider_base_slider_border-radius": "{small}",
    "slider_base_slider_behavior_hover_ball-color": "{primary60}",
    "slider_base_slider_behavior_active_active-color": "{primary60}",
    "slider_base_slider_behavior_active_ball-color": "{primary60}",
    "slider_base_slider_behavior_focus_ball-border-width": "{border_focus}",
    "slider_base_bottom-container_flex-direction": "{flexDirection.row}",
    "slider_base_bottom-container_justify-content": "{justifyContent.spaceBetween}",
    "slider_base_bottom-container_align-items": "{alignItems.center}",
    "slider_base_bottom-container_width": "{size.max}",
    "slider_variant_state_success_inner-container_border-color": "{feedbackSuccess50}",
    "slider_variant_state_error_inner-container_border-color": "{feedbackError50}",
    "slider_variant_state_warning_inner-container_border-color": "{feedbackWarning50}",
    slider_variant_disabled_true_container_opacity: $52d4442770cfd938$var$slider_variant_disabled_true_container_opacity,
    "slider_variant_disabled_true_slider_behavior_hover_ball-color": "{primary50}",
    "slider_variant_disabled_true_slider_behavior_active_active-color": "{primary50}",
    "slider_variant_disabled_true_slider_behavior_active_ball-color": "{primary50}"
};
const $52d4442770cfd938$var$paginationbutton_base_container_size = "{xxl}";
const $52d4442770cfd938$var$PaginationButtonTokens = {
    paginationbutton_base_container_size: $52d4442770cfd938$var$paginationbutton_base_container_size,
    "paginationbutton_base_container_justify-content": "{justifyContent.center}",
    "paginationbutton_base_container_align-items": "{alignItems.center}",
    "paginationbutton_base_inner-container_background-color": "{global.transparent}",
    "paginationbutton_base_inner-container_flex-direction": "{flexDirection.row}",
    "paginationbutton_base_inner-container_justify-content": "{justifyContent.center}",
    "paginationbutton_base_inner-container_align-items": "{alignItems.center}",
    "paginationbutton_base_inner-container_border-radius": "{pill}",
    "paginationbutton_base_inner-container_width": "{l}",
    "paginationbutton_base_inner-container_height": "{l}",
    "paginationbutton_base_inner-container_opacity": "{opacity.enabled}",
    "paginationbutton_base_inner-container_gap": "{xs}",
    "paginationbutton_base_inner-container_border-color": "{primary80}",
    "paginationbutton_base_inner-container_behavior_hover_background-color": "{primary20}",
    "paginationbutton_base_inner-container_behavior_active_background-color": "{primary30}",
    "paginationbutton_base_inner-container_behavior_focus_border-width": "{border_focus}",
    "paginationbutton_variant_state_selected_inner-container_background-color": "{primary70}",
    "paginationbutton_variant_state_ellipsis_inner-container_background-color": "{global.transparent}"
};
const $52d4442770cfd938$var$searchbox_base_container_width = "{size.max}";
const $52d4442770cfd938$var$searchbox_base_container_height = "{xl}";
const $52d4442770cfd938$var$searchbox_base_container_gap = "{s}";
const $52d4442770cfd938$var$searchbox_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$searchbox_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$SearchBoxTokens = {
    "searchbox_base_container_background-color": "{primaryGrey20}",
    "searchbox_base_container_flex-direction": "{flexDirection.row}",
    "searchbox_base_container_justify-content": "{justifyContent.start}",
    "searchbox_base_container_align-items": "{alignItems.center}",
    "searchbox_base_container_padding-right": "{s}",
    "searchbox_base_container_padding-left": "{s}",
    searchbox_base_container_width: $52d4442770cfd938$var$searchbox_base_container_width,
    searchbox_base_container_height: $52d4442770cfd938$var$searchbox_base_container_height,
    "searchbox_base_container_border-radius": "{pill}",
    searchbox_base_container_gap: $52d4442770cfd938$var$searchbox_base_container_gap,
    searchbox_base_container_opacity: $52d4442770cfd938$var$searchbox_base_container_opacity,
    "searchbox_base_container_behavior_focus_border-color": "{primary60}",
    "searchbox_base_container_behavior_focus_border-width": "{border_focus}",
    "searchbox_base_container_behavior_active_background-color": "{primaryGrey40}",
    "searchbox_base_input_text-align": "{textAlign.start}",
    "searchbox_base_input_placeholder-color": "{primaryGrey100}",
    "searchbox_base_input_placeholder-font-family": "{bodyS}",
    "searchbox_base_input_placeholder-font-size": "{bodyS}",
    "searchbox_base_input_placeholder-line-height": "{bodyS}",
    "searchbox_base_input_placeholder-letter-spacing": "{bodyS}",
    "searchbox_base_input_placeholder-font-weight": "{bodyS}",
    "searchbox_base_input_input-color": "{primaryGrey100}",
    "searchbox_base_input_input-font-family": "{bodyS}",
    "searchbox_base_input_input-font-size": "{bodyS}",
    "searchbox_base_input_input-line-height": "{bodyS}",
    "searchbox_base_input_input-letter-spacing": "{bodyS}",
    "searchbox_base_input_input-font-weight": "{bodyS}",
    "searchbox_base_input_cursor-color": "{primary60}",
    "searchbox_base_input_behavior_hover_placeholder-color": "{primary60}",
    "searchbox_base_input_behavior_focus_placeholder-color": "{primary60}",
    "searchbox_base_input_behavior_active_placeholder-color": "{primary60}",
    "searchbox_base_prefix-container_flex-direction": "{flexDirection.row}",
    "searchbox_base_prefix-container_justify-content": "{justifyContent.center}",
    "searchbox_base_prefix-container_align-items": "{alignItems.center}",
    "searchbox_base_prefix-icon_size": "{m}",
    "searchbox_base_prefix-icon_color": "{primaryGrey100}",
    "searchbox_base_prefix-icon_behavior_hover_color": "{primary60}",
    "searchbox_base_prefix-icon_behavior_focus_color": "{primary60}",
    "searchbox_base_prefix-icon_behavior_active_color": "{primaryGrey80}",
    "searchbox_base_suffix-container_flex-direction": "{flexDirection.row}",
    "searchbox_base_suffix-container_justify-content": "{justifyContent.center}",
    "searchbox_base_suffix-container_align-items": "{alignItems.center}",
    "searchbox_base_suffix-icon_size": "{m}",
    "searchbox_base_suffix-icon_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_hover_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_focus_color": "{primary60}",
    "searchbox_base_suffix-icon_behavior_active_color": "{primaryGrey100}",
    "searchbox_variant_kind_header_container_background-color": "{primary60}",
    "searchbox_variant_kind_header_container_behavior_focus_border-color": "{primary80}",
    "searchbox_variant_kind_header_container_behavior_active_background-color": "{primary70}",
    "searchbox_variant_kind_header_prefix-icon_color": "{primaryBackground}",
    "searchbox_variant_kind_header_prefix-icon_behavior_hover_color": "{primary30}",
    "searchbox_variant_kind_header_prefix-icon_behavior_active_color": "{primary30}",
    "searchbox_variant_kind_header_suffix-icon_color": "{primaryBackground}",
    "searchbox_variant_kind_header_suffix-icon_behavior_hover_color": "{primary30}",
    "searchbox_variant_kind_header_suffix-icon_behavior_active_color": "{primary30}",
    "searchbox_variant_kind_header_input_input-color": "{primaryBackground}",
    "searchbox_variant_kind_header_input_placeholder-color": "{primary40}",
    "searchbox_variant_kind_header_input_cursor-color": "{primary30}",
    "searchbox_variant_kind_header_input_behavior_hover_placeholder-color": "{primary30}",
    "searchbox_variant_kind_light_background_container_background-color": "{primaryBackground}",
    "searchbox_variant_kind_light_background_container_border-color": "{primaryGrey60}",
    "searchbox_variant_kind_light_background_container_behavior_hover_border-color": "{primary50}",
    "searchbox_variant_kind_light_background_container_behavior_focus_border-color": "{primary80}",
    "searchbox_variant_kind_light_background_container_behavior_active_border-color": "{primary60}",
    "searchbox_variant_kind_light_background_container_border-width": "{border_thin}",
    "searchbox_variant_kind_light_background_container_behavior_focus_border-width": "{border_focus}",
    "searchbox_variant_kind_light_background_input_input-color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_input_cursor-color": "{primary60}",
    "searchbox_variant_kind_light_background_input_behavior_active_placeholder-color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_prefix-icon_color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_hover_color": "{primary60}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_focus_color": "{primary60}",
    "searchbox_variant_kind_light_background_prefix-icon_behavior_active_color": "{primaryGrey100}",
    "searchbox_variant_kind_light_background_suffix-icon_color": "{primary60}",
    "searchbox_variant_kind_light_background_suffix-icon_behavior_active_color": "{primary60}",
    searchbox_variant_disabled_true_container_opacity: $52d4442770cfd938$var$searchbox_variant_disabled_true_container_opacity,
    "searchbox_variant__isValueEmpty_false_suffix-icon_color": "{primaryGrey80}",
    "searchbox_combination_header_false_suffix-icon_color": "{primary30}",
    "searchbox_variant__inputFocus_true_input_placeholder-color": "{primaryGrey60}",
    "searchbox_combination_light_background_false_suffix-icon_color": "{primaryGrey80}",
    "searchbox_combination_light_background_true_container_border-color": "{primary60}"
};
const $52d4442770cfd938$var$spinner_base_container_gap = "{base}";
const $52d4442770cfd938$var$spinner_variant_size_small_container_gap = "{s}";
const $52d4442770cfd938$var$SpinnerTokens = {
    "spinner_base_container_background-color": "{global.transparent}",
    spinner_base_container_gap: $52d4442770cfd938$var$spinner_base_container_gap,
    "spinner_base_container_justify-content": "{justifyContent.center}",
    "spinner_base_container_align-items": "{alignItems.center}",
    "spinner_base_container_flex-direction": "{flexDirection.row}",
    "spinner_base_spinner-container_size": "{xxl}",
    "spinner_base_arc-container_flex-direction": "{flexDirection.stack}",
    "spinner_base_arc-container_justify-content": "{justifyContent.center}",
    "spinner_base_arc-container_align-items": "{alignItems.center}",
    "spinner_base_arc-container_size": "{size.max}",
    "spinner_base_base-arc_fill": "{primaryGrey40}",
    "spinner_base_base-arc_radius": "{m}",
    "spinner_base_base-arc_arcWidth": "{xs}",
    "spinner_base_base-arc_start": 0,
    "spinner_base_base-arc_end": 360,
    "spinner_base_normal-arc_fill": "{primary50}",
    "spinner_base_normal-arc_radius": "{m}",
    "spinner_base_normal-arc_arcWidth": "{xs}",
    "spinner_base_normal-arc_start": 0,
    "spinner_base_normal-arc_end": 120,
    "spinner_base_normal-arc_animation-duration": "1000",
    "spinner_base_first-arc_fill": "{primary50}",
    "spinner_base_first-arc_radius": "{m}",
    "spinner_base_first-arc_arcWidth": "{xs}",
    "spinner_base_first-arc_start": 0,
    "spinner_base_first-arc_end": 360,
    "spinner_base_first-arc_animation-delay": "300",
    "spinner_base_first-arc_animation-duration": "1300",
    "spinner_base_second-arc_fill": "{secondary50}",
    "spinner_base_second-arc_radius": "{m}",
    "spinner_base_second-arc_arcWidth": "{xs}",
    "spinner_base_second-arc_start": 0,
    "spinner_base_second-arc_end": 360,
    "spinner_base_second-arc_animation-delay": "150",
    "spinner_base_second-arc_animation-duration": "1300",
    "spinner_base_third-arc_fill": "{sparkle50}",
    "spinner_base_third-arc_radius": "{m}",
    "spinner_base_third-arc_arcWidth": "{xs}",
    "spinner_base_third-arc_start": 0,
    "spinner_base_third-arc_end": 360,
    "spinner_base_third-arc_animation-duration": "1300",
    "spinner_variant_labelPosition_bottom_container_flex-direction": "{flexDirection.column}",
    spinner_variant_size_small_container_gap: $52d4442770cfd938$var$spinner_variant_size_small_container_gap,
    "spinner_variant_size_small_spinner-container_size": "{m}",
    "spinner_variant_size_small_base-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_base-arc_radius": "{s}",
    "spinner_variant_size_small_normal-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_normal-arc_radius": "{s}",
    "spinner_variant_size_small_first-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_first-arc_radius": "{s}",
    "spinner_variant_size_small_second-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_second-arc_radius": "{s}",
    "spinner_variant_size_small_third-arc_arcWidth": "{xxs}",
    "spinner_variant_size_small_third-arc_radius": "{s}",
    "spinner_combination_false_inline_normal-arc_fill": "{primaryGrey80}",
    "spinner_combination_small_bottom_container_flex-direction": "{flexDirection.row}"
};
const $52d4442770cfd938$var$selectorbutton_base_container_gap = "{xs}";
const $52d4442770cfd938$var$selectorbutton_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$selectorbutton_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$selectorbutton_combination_false_small_container_width = "{l}";
const $52d4442770cfd938$var$selectorbutton_combination_false_small_container_height = "{l}";
const $52d4442770cfd938$var$selectorbutton_combination_false_medium_container_width = "{xl}";
const $52d4442770cfd938$var$selectorbutton_combination_false_medium_container_height = "{xl}";
const $52d4442770cfd938$var$selectorbutton_combination_false_large_container_width = "{xxl}";
const $52d4442770cfd938$var$selectorbutton_combination_false_large_container_height = "{xxl}";
const $52d4442770cfd938$var$selectorbutton_combination_false_extra_large_container_width = "{huge}";
const $52d4442770cfd938$var$selectorbutton_combination_false_extra_large_container_height = "{huge}";
const $52d4442770cfd938$var$selectorbutton_combination_true_true_container_width = "{size.max}";
const $52d4442770cfd938$var$SelectorButtonTokens = {
    "selectorbutton_base_container_background-color": "{primary50}",
    "selectorbutton_base_container_flex-direction": "{flexDirection.row}",
    "selectorbutton_base_container_justify-content": "{justifyContent.center}",
    "selectorbutton_base_container_align-items": "{alignItems.center}",
    "selectorbutton_base_container_border-radius": "{pill}",
    "selectorbutton_base_container_padding-bottom": "{xs}",
    "selectorbutton_base_container_padding-top": "{xs}",
    "selectorbutton_base_container_padding-left": "{base}",
    "selectorbutton_base_container_padding-right": "{base}",
    "selectorbutton_base_container_border-width": "{border_none}",
    selectorbutton_base_container_gap: $52d4442770cfd938$var$selectorbutton_base_container_gap,
    selectorbutton_base_container_opacity: $52d4442770cfd938$var$selectorbutton_base_container_opacity,
    "selectorbutton_base_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_base_container_behavior_active_background-color": "{primary60}",
    "selectorbutton_base_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_base_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_base_left-icon_size": "{m}",
    "selectorbutton_base_left-icon_color": "{primaryInverse}",
    "selectorbutton_base_left-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_base_right-icon_size": "{m}",
    "selectorbutton_base_right-icon_color": "{primaryInverse}",
    "selectorbutton_base_right-icon_behavior_hover_color": "{primary70}",
    selectorbutton_variant_disabled_true_container_opacity: $52d4442770cfd938$var$selectorbutton_variant_disabled_true_container_opacity,
    "selectorbutton_combination_normal_primary_true_container_background-color": "{primary60}",
    "selectorbutton_combination_normal_primary_true_container_behavior_hover_background-color": "{primary50}",
    "selectorbutton_combination_normal_primary_true_container_behavior_active_background-color": "{primary70}",
    "selectorbutton_combination_normal_primary_true_container_behavior_focus_border-color": "{primary70}",
    "selectorbutton_combination_normal_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_normal_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_secondary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_normal_secondary_true_container_border-width": "{border_thin}",
    "selectorbutton_combination_normal_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_secondary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_secondary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_secondary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_tertiary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_true_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_false_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_normal_tertiary_narrow_false_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_color": "{primary60}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_normal_tertiary_narrow_false_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_container_background-color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_primary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_hover_color": "{primary70}",
    "selectorbutton_combination_grey_scale_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_grey_scale_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_secondary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_secondary_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_secondary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_secondary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_secondary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_left-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_true_right-icon_behavior_active_color": "{primary70}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_border-width": "{border_thin}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_hover_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_active_background-color": "{primary20}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_left-icon_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_false_right-icon_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_left-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_true_right-icon_behavior_active_color": "{primary80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_container_behavior_focus_border-color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_left-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_color": "{primaryGrey80}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary50}",
    "selectorbutton_combination_grey_scale_tertiary_narrow_false_right-icon_behavior_active_color": "{primary60}",
    "selectorbutton_combination_contrast_primary_false_container_background-color": "{primaryBackground}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_primary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_false_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_focus_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_false_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_focus_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_false_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_container_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_active_background-color": "{primary60}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_background-color": "{primary50}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_primary_true_container_behavior_focus_border-color": "{primary40}",
    "selectorbutton_combination_contrast_primary_true_left-icon_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_primary_true_right-icon_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_primary_true_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_secondary_false_container_border-width": "{border_thin}",
    "selectorbutton_combination_contrast_secondary_false_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_secondary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_left-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_false_right-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_container_background-color": "{primary30}",
    "selectorbutton_combination_contrast_secondary_true_container_border-color": "{primaryGrey60}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_secondary_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_secondary_true_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_left-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_secondary_true_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_secondary_true_right-icon_behavior_active_color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_active_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_left-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_hover_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_false_right-icon_behavior_active_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_container_background-color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_hover_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_container_behavior_active_background-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_true_left-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_left-icon_behavior_active_background-color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_true_right-icon_color": "{primaryGrey100}",
    "selectorbutton_combination_contrast_tertiary_true_right-icon_behavior_active_background-color": "{primaryInverse}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_left-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_color": "{primaryBackground}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_false_right-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-width": "{border_focus}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_focus_border-color": "{primary50}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_hover_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_container_behavior_active_background-color": "{global.transparent}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_left-icon_behavior_focus_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_hover_color": "{primary20}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_active_color": "{primary30}",
    "selectorbutton_combination_contrast_tertiary_narrow_true_right-icon_behavior_focus_color": "{primary30}",
    "selectorbutton_combination_tertiary_narrow_small_container_padding-bottom": "{xxs}",
    "selectorbutton_combination_tertiary_narrow_small_container_padding-top": "{xxs}",
    "selectorbutton_combination_tertiary_narrow_medium_container_padding-bottom": "{xs}",
    "selectorbutton_combination_tertiary_narrow_medium_container_padding-top": "{xs}",
    "selectorbutton_combination_tertiary_narrow_large_container_padding-bottom": "{s}",
    "selectorbutton_combination_tertiary_narrow_large_container_padding-top": "{s}",
    "selectorbutton_combination_tertiary_narrow_extra_large_container_padding-bottom": "{base}",
    "selectorbutton_combination_tertiary_narrow_extra_large_container_padding-top": "{base}",
    "selectorbutton_combination_true_small_container_padding-top": "{xxs}",
    "selectorbutton_combination_true_small_container_padding-bottom": "{xxs}",
    "selectorbutton_combination_true_small_left-icon_size": "{base}",
    "selectorbutton_combination_true_small_right-icon_size": "{base}",
    "selectorbutton_combination_true_large_container_padding-top": "{s}",
    "selectorbutton_combination_true_large_container_padding-left": "{m}",
    "selectorbutton_combination_true_large_container_padding-bottom": "{s}",
    "selectorbutton_combination_true_large_container_padding-right": "{m}",
    "selectorbutton_combination_true_large_left-icon_size": "{m}",
    "selectorbutton_combination_true_large_right-icon_size": "{m}",
    "selectorbutton_combination_true_extra_large_container_padding-top": "{base}",
    "selectorbutton_combination_true_extra_large_container_padding-right": "{l}",
    "selectorbutton_combination_true_extra_large_container_padding-bottom": "{base}",
    "selectorbutton_combination_true_extra_large_container_padding-left": "{l}",
    "selectorbutton_combination_true_extra_large_left-icon_size": "{l}",
    "selectorbutton_combination_true_extra_large_right-icon_size": "{l}",
    selectorbutton_combination_false_small_container_width: $52d4442770cfd938$var$selectorbutton_combination_false_small_container_width,
    selectorbutton_combination_false_small_container_height: $52d4442770cfd938$var$selectorbutton_combination_false_small_container_height,
    "selectorbutton_combination_false_small_left-icon_size": "{base}",
    selectorbutton_combination_false_medium_container_width: $52d4442770cfd938$var$selectorbutton_combination_false_medium_container_width,
    selectorbutton_combination_false_medium_container_height: $52d4442770cfd938$var$selectorbutton_combination_false_medium_container_height,
    selectorbutton_combination_false_large_container_width: $52d4442770cfd938$var$selectorbutton_combination_false_large_container_width,
    selectorbutton_combination_false_large_container_height: $52d4442770cfd938$var$selectorbutton_combination_false_large_container_height,
    "selectorbutton_combination_false_large_left-icon_size": "{m}",
    selectorbutton_combination_false_extra_large_container_width: $52d4442770cfd938$var$selectorbutton_combination_false_extra_large_container_width,
    selectorbutton_combination_false_extra_large_container_height: $52d4442770cfd938$var$selectorbutton_combination_false_extra_large_container_height,
    "selectorbutton_combination_false_extra_large_left-icon_size": "{l}",
    selectorbutton_combination_true_true_container_width: $52d4442770cfd938$var$selectorbutton_combination_true_true_container_width,
    "selectorbutton_combination_true_true_container_justify-content": "{justifyContent.spaceBetween}",
    "selectorbutton_combination_grey_scale_secondary_false_left-icon_behavior_hover_color": "{primary60}",
    "selectorbutton_combination_grey_scale_secondary_false_right-icon_behavior_hover_color": "{primary60}"
};
const $52d4442770cfd938$var$HorizontalStepItemTokens = {
    "horizontalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
    "horizontalstepitem_base_stepper-outer-container_align-items": "{alignItems.center}",
    "horizontalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
    "horizontalstepitem_base_stepper-outer-container_size": "{size.max}",
    "horizontalstepitem_base_stepper-outer-container_gap": "{xs}",
    "horizontalstepitem_base_stepper-inner-container_flex-direction": "{flexDirection.row}",
    "horizontalstepitem_base_stepper-inner-container_width": "{size.max}",
    "horizontalstepitem_base_stepper-inner-container_align-items": "{alignItems.center}",
    "horizontalstepitem_base_stepper-inner-container_gap": "{xs}",
    "horizontalstepitem_base_label-jds_text_padding-right": "{xs}",
    "horizontalstepitem_base_label-jds_text_padding-left": "{xs}",
    "horizontalstepitem_base_start-jds_divider_opacity": "{opacity.enabled}",
    "horizontalstepitem_base_end-jds_divider_opacity": "{opacity.enabled}",
    "horizontalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}",
    "horizontalstepitem_variant_direction_end_start-jds_divider_opacity": "{opacity.invisible}"
};
const $52d4442770cfd938$var$stepperdot_base_icon_color = "{sparkleGrey60}";
const $52d4442770cfd938$var$stepperdot_base_icon_size = "{base}";
const $52d4442770cfd938$var$stepperdot_combination_warning_active_icon_color = "{sparkle60}";
const $52d4442770cfd938$var$stepperdot_combination_warning_complete_icon_color = "{sparkle60}";
const $52d4442770cfd938$var$StepperDotTokens = {
    "stepperdot_base_step-icon-container_background-color": "{global.transparent}",
    "stepperdot_base_step-icon-container_border-width": "{border_thin}",
    "stepperdot_base_step-icon-container_border-color": "{sparkleGrey60}",
    "stepperdot_base_step-icon-container_min-height": "{l}",
    "stepperdot_base_step-icon-container_min-width": "{l}",
    "stepperdot_base_step-icon-container_justify-content": "{justifyContent.center}",
    "stepperdot_base_step-icon-container_align-items": "{alignItems.center}",
    "stepperdot_base_step-icon-container_border-radius": "{pill}",
    stepperdot_base_icon_color: $52d4442770cfd938$var$stepperdot_base_icon_color,
    stepperdot_base_icon_size: $52d4442770cfd938$var$stepperdot_base_icon_size,
    "stepperdot_base_complete-icon_color": "{sparkle60}",
    "stepperdot_base_complete-icon_size": "{base}",
    "stepperdot_base_dot-container_background-color": "{sparkleGrey60}",
    "stepperdot_base_dot-container_width": "{xs}",
    "stepperdot_base_dot-container_height": "{xs}",
    "stepperdot_base_dot-container_border-radius": "{pill}",
    "stepperdot_variant_state_active_step-icon-container_background-color": "{sparkle50}",
    "stepperdot_variant_state_active_step-icon-container_border-color": "{sparkle50}",
    "stepperdot_variant_state_active_icon-color": "{sparkleInverse}",
    "stepperdot_variant_state_active_dot-container_background-color": "{sparkleInverse}",
    "stepperdot_variant_state_complete_step-icon-container_background-color": "{sparkle20}",
    "stepperdot_variant_state_complete_step-icon-container_border-color": "{sparkle50}",
    "stepperdot_variant_itemsType_icon_step-icon-container_height": "{l}",
    "stepperdot_variant_itemsType_icon_step-icon-container_width": "{l}",
    stepperdot_combination_warning_active_icon_color: $52d4442770cfd938$var$stepperdot_combination_warning_active_icon_color,
    stepperdot_combination_warning_complete_icon_color: $52d4442770cfd938$var$stepperdot_combination_warning_complete_icon_color,
    "stepperdot_variant_state_disabled_step-icon-container_opacity": "{opacity.disabled}"
};
const $52d4442770cfd938$var$VerticalStepItemTokens = {
    "verticalstepitem_base_stepper-outer-container_flex-direction": "{flexDirection.column}",
    "verticalstepitem_base_stepper-outer-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_stepper-outer-container_align-items": "{alignItems.start}",
    "verticalstepitem_base_stepper-outer-container_gap": "{xs}",
    "verticalstepitem_base_stepper-outer-container_size": "{size.max}",
    "verticalstepitem_base_end-container_opacity": "{opacity.enabled}",
    "verticalstepitem_base_content-child-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_content-child-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_content-child-container_align-items": "{alignItems.center}",
    "verticalstepitem_base_step-indicator-container_height": "{intrinsicSize.max}",
    "verticalstepitem_base_step-indicator-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_step-indicator-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_step-indicator-container_align-items": "{alignItems.stretch}",
    "verticalstepitem_base_step-indicator-container_min-height": "{l}",
    "verticalstepitem_base_step-indicator-container_padding-left": "{custom_23}",
    "verticalstepitem_base_step-dot-container_flex-direction": "{flexDirection.row}",
    "verticalstepitem_base_step-dot-container_justify-content": "{justifyContent.start}",
    "verticalstepitem_base_step-dot-container_align-items": "{alignItems.center}",
    "verticalstepitem_base_step-dot-container_gap": "{base}",
    "verticalstepitem_base_content-container_padding-top": "0",
    "verticalstepitem_base_content-container_padding-bottom": "0",
    "verticalstepitem_base_content-container_padding-left": "{custom_24}",
    "verticalstepitem__hideChild_true_content-container_padding-top": "{xs}",
    "verticalstepitem__hideChild_true_content-container_padding-bottom": "{m}",
    "verticalstepitem_variant_direction_start_end-jds_divider_opacity": "{opacity.invisible}"
};
const $52d4442770cfd938$var$verticalstepper_base_container_size = "{size.max}";
const $52d4442770cfd938$var$verticalstepper_base_container_gap = "{xs}";
const $52d4442770cfd938$var$VerticalStepperTokens = {
    "verticalstepper_base_container_flex-direction": "{flexDirection.column}",
    "verticalstepper_base_container_justify-content": "{justifyContent.start}",
    "verticalstepper_base_container_align-items": "{alignItems.start}",
    verticalstepper_base_container_size: $52d4442770cfd938$var$verticalstepper_base_container_size,
    verticalstepper_base_container_gap: $52d4442770cfd938$var$verticalstepper_base_container_gap
};
const $52d4442770cfd938$var$horizontalstepper_base_container_gap = "{stepper_horizontal}";
const $52d4442770cfd938$var$horizontalstepper_base_container_size = "{size.max}";
const $52d4442770cfd938$var$HorizontalStepperTokens = {
    horizontalstepper_base_container_gap: $52d4442770cfd938$var$horizontalstepper_base_container_gap,
    "horizontalstepper_base_container_flex-direction": "{flexDirection.column}",
    horizontalstepper_base_container_size: $52d4442770cfd938$var$horizontalstepper_base_container_size,
    "horizontalstepper_base_step-indicator-container_flex-direction": "{flexDirection.row}",
    "horizontalstepper_base_step-indicator-container_justify-content": "{justifyContent.center}",
    "horizontalstepper_base_step-indicator-container_align-items": "{alignItems.center}",
    "horizontalstepper_base_step-indicator-container_size": "{size.max}",
    "horizontalstepper_base_step-indicator-container_padding-left": "{l}",
    "horizontalstepper_base_step-indicator-container_padding-right": "{l}",
    "horizontalstepper_base_stepper-children-container_size": "{size.max}",
    "horizontalstepper_base_stepper-children-container_flex-direction": "{flexDirection.row}",
    "horizontalstepper_base_stepper-children-container_justify-content": "{justifyContent.start}",
    "horizontalstepper_base_stepper-children-container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$tablebody_base_container_width = "{size.max}";
const $52d4442770cfd938$var$tablebody_variant_fullWidth_container_width = "{size.max}";
const $52d4442770cfd938$var$TableBodyTokens = {
    tablebody_base_container_width: $52d4442770cfd938$var$tablebody_base_container_width,
    "tablebody_base_container_flex-direction": "{flexDirection.row}",
    tablebody_variant_fullWidth_container_width: $52d4442770cfd938$var$tablebody_variant_fullWidth_container_width
};
const $52d4442770cfd938$var$table_base_container_width = "{size.max}";
const $52d4442770cfd938$var$table_variant_fullWidth_container_width = "{size.max}";
const $52d4442770cfd938$var$TableTokens = {
    "table_base_container_flex-direction": "{flexDirection.column}",
    table_base_container_width: $52d4442770cfd938$var$table_base_container_width,
    "table_base_container_border-radius": "{medium}",
    "table_base_container_border-width": "{border_thin}",
    "table_base_container_border-color": "{primaryGrey40}",
    table_variant_fullWidth_container_width: $52d4442770cfd938$var$table_variant_fullWidth_container_width,
    "table_base_container_align-items": "{alignItems.start}",
    "table_base_footer-jds_text_padding-left": "{base}",
    "table_base_footer-jds_text_padding-right": "{base}",
    "table_base_footer-jds_text_padding-top": "{base}",
    "table_base_footer-jds_text_padding-bottom": "{base}",
    "table_variant_density_condensed_footer-jds_text_padding-left": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-right": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-top": "{xs}",
    "table_variant_density_condensed_footer-jds_text_padding-bottom": "{xs}"
};
const $52d4442770cfd938$var$tablerow_base_container_width = "{size.max}";
const $52d4442770cfd938$var$tablerow_variant_fullWidth_container_width = "{size.max}";
const $52d4442770cfd938$var$TableRowTokens = {
    "tablerow_base_container_flex-direction": "{flexDirection.column}",
    tablerow_base_container_width: $52d4442770cfd938$var$tablerow_base_container_width,
    tablerow_variant_fullWidth_container_width: $52d4442770cfd938$var$tablerow_variant_fullWidth_container_width
};
const $52d4442770cfd938$var$tablecell_base_container_width = "{size.max}";
const $52d4442770cfd938$var$TableCellTokens = {
    "tablecell_base_container_flex-direction": "{flexDirection.row}",
    "tablecell_base_container_justify-content": "{justifyContent.start}",
    "tablecell_base_container_align-items": "{alignItems.center}",
    "tablecell_base_container_background-color": "{global.transparent}",
    "tablecell_base_container_padding-left": "{base}",
    "tablecell_base_container_padding-right": "{base}",
    "tablecell_base_container_padding-top": "{base}",
    "tablecell_base_container_padding-bottom": "{base}",
    "tablecell_base_container_border-color": "{primaryGrey40}",
    tablecell_base_container_width: $52d4442770cfd938$var$tablecell_base_container_width,
    "tablecell_variant_density_condensed_container_padding-left": "{xs}",
    "tablecell_variant_density_condensed_container_padding-right": "{xs}",
    "tablecell_variant_density_condensed_container_padding-top": "{xs}",
    "tablecell_variant_density_condensed_container_padding-bottom": "{xs}",
    "tablecell_variant_columnDivider_true_container_border-color": "{primaryGrey40}",
    "tablecell_variant_columnDivider_true_container_border-right-width": 1,
    "tablecell_combination_header_true_container_background-color": "{primary50}",
    "tablecell_combination_header_true_container_border-color": "{primary60}",
    "tablecell_combination_cell_true_container_background-color": "{primaryGrey20}",
    "tablecell_combination_header_true_container_border-bottom-width": 1,
    "tablecell_combination_header_false_container_border-bottom-width": 4,
    "tablecell_combination_cell_true_container_border-bottom-width": 0
};
const $52d4442770cfd938$var$tabbar_base_container_width = "{size.max}";
const $52d4442770cfd938$var$TabBarTokens = {
    "tabbar_base_container_flex-direction": "{flexDirection.stack}",
    tabbar_base_container_width: $52d4442770cfd938$var$tabbar_base_container_width,
    "tabbar_base_indicator-container_width": "{size.max}",
    "tabbar_base_container_justify-content": "{justifyContent.start}",
    "tabbar_base_container_align-items": "{alignItems.end}",
    "tabbar_base_tab-container_width": "{size.max}",
    "tabbar_base_tab-container_opacity": "{opacity.enabled}",
    "tabbar_base_tab-container_background-color": "{global.transparent}",
    "tabbar_base_tab-container_align-items": "{alignItems.center}",
    "tabbar_base_tab-container_justify-content": "{justifyContent.start}",
    "tabbar_base_tab-container_gap": "{xxs}",
    "tabbar_base_tab-container_flex-direction": "{flexDirection.row}",
    "tabbar_base_outer-container_flex-direction": "{flexDirection.row}",
    "tabbar_base_outer-container_justify-content": "{justifyContent.start}",
    "tabbar_base_outer-container_align-items": "{alignItems.center}",
    "tabbar_base_outer-container_width": "{size.max}",
    "tabbar_base_inner-container_border-radius": "{pill}",
    "tabbar_base_inner-container_background-color": "{primary50}",
    "tabbar_base_inner-container_height": "{xxs}",
    "tabbar_variant_overflow_fit_tab-container_width": "{size.max}",
    "tabbar_variant_overflow_fit_tab-container_justify-content": "{justifyContent.center}",
    "tabbar_variant_appearance_tab_bar_tab-container_background-color": "{primary60}",
    "tabbar_variant_appearance_tab_bar_tab-container_padding-right": "{xxl}",
    "tabbar_variant_appearance_tab_bar_tab-container_padding-left": "{xxl}",
    "tabbar_variant_appearance_tab_bar_inner-container_background-color": "{custom_dark_primary_60}",
    "tabbar_combination_mobile_tab_bar_tab-container_padding-right": "{m}",
    "tabbar_combination_mobile_tab_bar_tab-container_padding-left": "{m}"
};
const $52d4442770cfd938$var$tag_base_container_gap = "{xxs}";
const $52d4442770cfd938$var$tag_base_icon_size = "{base}";
const $52d4442770cfd938$var$tag_base_icon_color = "{primaryGrey100}";
const $52d4442770cfd938$var$tag_base_icon_behavior_hover_color = "{sparkle80}";
const $52d4442770cfd938$var$tag_base_icon_behavior_active_color = "{sparkle80}";
const $52d4442770cfd938$var$tag_base_icon_behavior_focus_color = "{sparkle80}";
const $52d4442770cfd938$var$tag_variant_active_true_icon_color = "{sparkle80}";
const $52d4442770cfd938$var$tag_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$tag_base_container_opacity = "{opacity.enabled}";
const $52d4442770cfd938$var$TagTokens = {
    "tag_base_container_flex-direction": "{flexDirection.row}",
    "tag_base_container_justify-content": "{justifyContent.start}",
    "tag_base_container_align-items": "{alignItems.center}",
    "tag_base_container_padding-top": "{xxs}",
    "tag_base_container_padding-left": "{s}",
    "tag_base_container_padding-right": "{s}",
    "tag_base_container_padding-bottom": "{xxs}",
    tag_base_container_gap: $52d4442770cfd938$var$tag_base_container_gap,
    "tag_base_container_background-color": "{global.transparent}",
    "tag_base_container_border-radius": "{pill}",
    "tag_base_container_border-width": "{border_thin}",
    "tag_base_container_border-color": "{primaryGrey80}",
    "tag_base_container_behavior_hover_border-color": "{primaryGrey80}",
    "tag_base_container_behavior_active_border-color": "{sparkle20}",
    "tag_base_container_behavior_focus_border-color": "{sparkle80}",
    "tag_base_container_behavior_focus_border-width": "{border_focus}",
    tag_base_icon_size: $52d4442770cfd938$var$tag_base_icon_size,
    tag_base_icon_color: $52d4442770cfd938$var$tag_base_icon_color,
    tag_base_icon_behavior_hover_color: $52d4442770cfd938$var$tag_base_icon_behavior_hover_color,
    tag_base_icon_behavior_active_color: $52d4442770cfd938$var$tag_base_icon_behavior_active_color,
    tag_base_icon_behavior_focus_color: $52d4442770cfd938$var$tag_base_icon_behavior_focus_color,
    "tag_variant_active_true_container_border-width": "{border_none}",
    "tag_variant_active_true_container_border-color": "{primaryGrey80}",
    "tag_variant_active_true_container_background-color": "{sparkle20}",
    "tag_variant_active_true_container_behavior_hover_background-color": "{sparkle30}",
    "tag_variant_active_true_container_behavior_active_background-color": "{global.transparent}",
    "tag_variant_active_true_container_behavior_active_border-color": "{primaryGrey40}",
    "tag_variant_active_true_container_behavior_focus_background-color": "{sparkle30}",
    tag_variant_active_true_icon_color: $52d4442770cfd938$var$tag_variant_active_true_icon_color,
    tag_variant_disabled_true_container_opacity: $52d4442770cfd938$var$tag_variant_disabled_true_container_opacity,
    tag_base_container_opacity: $52d4442770cfd938$var$tag_base_container_opacity,
    "tag_variant_size_small_container_padding-top": "{custom_4}",
    "tag_variant_size_small_container_padding-left": "{xs}",
    "tag_variant_size_small_container_padding-right": "{xs}",
    "tag_variant_size_small_container_padding-bottom": "{custom_4}"
};
const $52d4442770cfd938$var$tabsdesktop_base_container_width = "{size.max}";
const $52d4442770cfd938$var$tabsdesktop_base_jds_tab_bar_width = "{size.max}";
const $52d4442770cfd938$var$TabsDesktopTokens = {
    "tabsdesktop_base_container_flex-direction": "{flexDirection.column}",
    tabsdesktop_base_container_width: $52d4442770cfd938$var$tabsdesktop_base_container_width,
    tabsdesktop_base_jds_tab_bar_width: $52d4442770cfd938$var$tabsdesktop_base_jds_tab_bar_width,
    "tabsdesktop_base_header-container_flex-direction": "{flexDirection.row}",
    "tabsdesktop_base_header-container_width": "{size.max}",
    "tabsdesktop_base_header-container_align-items": "{alignItems.center}",
    "tabsdesktop_base_tablist-container_width": "{size.max}",
    "tabsdesktop_variant_overflow_arrows_header-container_gap": "{base}",
    "tabsdesktop_variant_appearance_tab_bar_header-container_background-color": "{primary60}"
};
const $52d4442770cfd938$var$tabitem_base_container_gap = "{xs}";
const $52d4442770cfd938$var$tabitem_base_icon_size = "{m}";
const $52d4442770cfd938$var$tabitem_base_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$tabitem_base_icon_behavior_hover_color = "{primaryGrey100}";
const $52d4442770cfd938$var$tabitem_base_icon_behavior_active_color = "{primary60}";
const $52d4442770cfd938$var$tabitem_base_text_color = "{primaryGrey80}";
const $52d4442770cfd938$var$tabitem_base_text_behavior_hover_color = "{primary60}";
const $52d4442770cfd938$var$tabitem_variant_appearance_normal_text_behavior_hover_color = "{primaryGrey100}";
const $52d4442770cfd938$var$tabitem_variant_appearance_normal_text_behavior_active_color = "{primary60}";
const $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_icon_color = "{custom_dark_primary_grey_100}";
const $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_icon_behavior_hover_color = "{custom_dark_primary_grey_80}";
const $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_icon_behavior_active_color = "{custom_dark_primary_grey_100}";
const $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_text_color = "{custom_dark_primary_grey_100}";
const $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_text_behavior_hover_color = "{custom_dark_primary_grey_80}";
const $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_text_behavior_active_color = "{custom_dark_primary_grey_100}";
const $52d4442770cfd938$var$tabitem_combination_active_normal_icon_color = "{primaryGrey100}";
const $52d4442770cfd938$var$tabitem_combination_active_normal_text_color = "{primaryGrey100}";
const $52d4442770cfd938$var$TabItemTokens = {
    "tabitem_base_outer-container_background-color": "{global.transparent}",
    "tabitem_base_outer-container_flex-direction": "{flexDirection.column}",
    "tabitem_base_outer-container_align-items": "{alignItems.center}",
    "tabitem_base_outer-container_justify-content": "{justifyContent.center}",
    "tabitem_base_outer-container_min-height": "{xxl}",
    "tabitem_base_outer-container_width": "{intrinsicSize.max}",
    "tabitem_base_outer-container_height": "{intrinsicSize.max}",
    "tabitem_base_container_flex-direction": "{flexDirection.row}",
    "tabitem_base_container_align-items": "{alignItems.center}",
    "tabitem_base_container_justify-content": "{justifyContent.center}",
    tabitem_base_container_gap: $52d4442770cfd938$var$tabitem_base_container_gap,
    "tabitem_base_container_padding-top": "{s}",
    "tabitem_base_container_padding-bottom": "{s}",
    "tabitem_base_container_padding-right": "{xs}",
    "tabitem_base_container_padding-left": "{xs}",
    "tabitem_base_container_behavior_focus_border-width": "{border_normal}",
    "tabitem_base_container_behavior_focus_border-color": "{primary80}",
    "tabitem_base_container_behavior_focus_border-radius": "{large}",
    tabitem_base_icon_size: $52d4442770cfd938$var$tabitem_base_icon_size,
    tabitem_base_icon_color: $52d4442770cfd938$var$tabitem_base_icon_color,
    tabitem_base_icon_behavior_hover_color: $52d4442770cfd938$var$tabitem_base_icon_behavior_hover_color,
    tabitem_base_icon_behavior_active_color: $52d4442770cfd938$var$tabitem_base_icon_behavior_active_color,
    tabitem_base_text_color: $52d4442770cfd938$var$tabitem_base_text_color,
    "tabitem_base_text_font-size": "{bodyS}",
    "tabitem_base_text_font-family": "{bodyS}",
    "tabitem_base_text_font-weight": "{bodyS}",
    "tabitem_base_text_line-height": "{bodyS}",
    "tabitem_base_text_letter-spacing": "{bodyS}",
    tabitem_base_text_behavior_hover_color: $52d4442770cfd938$var$tabitem_base_text_behavior_hover_color,
    "tabitem_base_indicator-container_background-color": "{global.transparent}",
    "tabitem_base_indicator-container_height": "{xxs}",
    "tabitem_base_indicator-container_width": "{size.max}",
    "tabitem_base_indicator-container_border-radius": "{pill}",
    "tabitem_base_outer-container_opacity": "{opacity.enabled}",
    "tabitem_variant_disabled_true_outer-container_opacity": "{opacity.disabled}",
    tabitem_variant_appearance_normal_text_behavior_hover_color: $52d4442770cfd938$var$tabitem_variant_appearance_normal_text_behavior_hover_color,
    tabitem_variant_appearance_normal_text_behavior_active_color: $52d4442770cfd938$var$tabitem_variant_appearance_normal_text_behavior_active_color,
    "tabitem_variant_appearance_tab_bar_container_behavior_active_background-color": "{custom_dark_primary_40}",
    "tabitem_variant_appearance_tab_bar_container_behavior_focus_border-color": "{custom_dark_primary_60}",
    tabitem_variant_appearance_tab_bar_icon_color: $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_icon_color,
    tabitem_variant_appearance_tab_bar_icon_behavior_hover_color: $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_icon_behavior_hover_color,
    tabitem_variant_appearance_tab_bar_icon_behavior_active_color: $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_icon_behavior_active_color,
    tabitem_variant_appearance_tab_bar_text_color: $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_text_color,
    tabitem_variant_appearance_tab_bar_text_behavior_hover_color: $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_text_behavior_hover_color,
    tabitem_variant_appearance_tab_bar_text_behavior_active_color: $52d4442770cfd938$var$tabitem_variant_appearance_tab_bar_text_behavior_active_color,
    tabitem_combination_active_normal_icon_color: $52d4442770cfd938$var$tabitem_combination_active_normal_icon_color,
    tabitem_combination_active_normal_text_color: $52d4442770cfd938$var$tabitem_combination_active_normal_text_color
};
const $52d4442770cfd938$var$TooltipTokens = {
    "tooltip_base_popup-container_flex-direction": "{flexDirection.row}",
    "tooltip_base_popup-container_justify-content": "{justifyContent.start}",
    "tooltip_base_popup-container_align-items": "{alignItems.start}",
    "tooltip_base_root-container_flex-direction": "{flexDirection.row}",
    "tooltip_base_root-container_justify-content": "{justifyContent.start}",
    "tooltip_base_root-container_align-items": "{alignItems.center}",
    "tooltip_base_root-container_overflow": "hidden",
    "tooltip_base_text-container_border-radius": "{medium}",
    "tooltip_base_text-container_border-width": "{border_thin}",
    "tooltip_base_text-container_background-color": "{primaryGrey100}",
    "tooltip_base_start-tooltip_color": "{primaryGrey100}",
    "tooltip_base_end-tooltip_color": "{primaryGrey100}",
    "tooltip_base_text-container_padding-left": "{base}",
    "tooltip_base_text-container_padding-right": "{base}",
    "tooltip_base_text-container_padding-top": "{xs}",
    "tooltip_base_text-container_padding-bottom": "{xs}",
    "tooltip_variant_position_right_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_right_start_start-tooltip_padding-top": "{xs}",
    "tooltip_variant_position_right_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_right_end_start-tooltip_padding-bottom": "{xs}",
    "tooltip_variant_position_left_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_left_start_end-tooltip_padding-top": "{xs}",
    "tooltip_variant_position_left_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_left_end_end-tooltip_padding-bottom": "{xs}",
    "tooltip_variant_position_top_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_root-container_align-items": "{alignItems.center}",
    "tooltip_variant_position_top_start_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_top_start_end-tooltip_padding-left": "{xs}",
    "tooltip_variant_position_top_end_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_top_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_top_end_end-tooltip_padding-right": "{xs}",
    "tooltip_variant_position_bottom_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_root-container_align-items": "{alignItems.center}",
    "tooltip_variant_position_bottom_start_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_start_root-container_align-items": "{alignItems.start}",
    "tooltip_variant_position_bottom_start_start-tooltip_padding-left": "{xs}",
    "tooltip_variant_position_bottom_end_root-container_flex-direction": "{flexDirection.column}",
    "tooltip_variant_position_bottom_end_root-container_align-items": "{alignItems.end}",
    "tooltip_variant_position_bottom_end_start-tooltip_padding-right": "{xs}",
    "tooltip_base_text-container_min-height": "{xl}",
    "tooltip_base_text-container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$ToggleTokens = {
    "toggle_base_prefix-icon-container_flex-direction": "{flexDirection.column}",
    "toggle_base_vertical-container_flex-direction": "{flexDirection.column}",
    "toggle_base_vertical-container_justify-content": "{justifyContent.start}",
    "toggle_base_vertical-container_align-items": "{alignItems.start}",
    "toggle_base_vertical-container_gap": "{xs}",
    "toggle_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "toggle_base_horizontal-container_justify-content": "{justifyContent.start}",
    "toggle_base_horizontal-container_align-items": "{alignItems.center}",
    "toggle_base_horizontal-container_gap": "{xs}",
    "toggle_base_pill-container_min-width": "{custom_2}",
    "toggle_base_pill-container_min-height": "{m}",
    "toggle_base_pill-container_flex-direction": "{flexDirection.row}",
    "toggle_base_pill-container_justify-content": "{justifyContent.start}",
    "toggle_base_pill-container_align-items": "{alignItems.center}",
    "toggle_base_pill-container_padding-left": "{xxs}",
    "toggle_base_pill-container_padding-right": "{xxs}",
    "toggle_base_pill-container_background-color": "{global.transparent}",
    "toggle_base_pill-container_border-radius": "{pill}",
    "toggle_base_pill-container_border-width": "{border_thin}",
    "toggle_base_pill-container_border-color": "{primaryGrey80}",
    "toggle_base_pill-container_behavior_hover_border-color": "{primary40}",
    "toggle_base_pill-container_behavior_active_border-color": "{primary60}",
    "toggle_base_pill-container_behavior_focus_box-shadow_spread": "{xxs}",
    "toggle_base_pill-container_behavior_focus_box-shadow_color": "{primary60}",
    "toggle_base_pill-container_behavior_focus_border-width": "{border_none}",
    "toggle_base_ball-container_min-width": "{base}",
    "toggle_base_ball-container_min-height": "{base}",
    "toggle_base_ball-container_background-color": "{primaryGrey80}",
    "toggle_base_ball-container_border-radius": "{pill}",
    "toggle_base_left-jds_text_text-align": "{textAlign.start}",
    "toggle_variant_size_small_pill-container_min-width": "{custom_3}",
    "toggle_variant_size_small_pill-container_min-height": "{base}",
    "toggle_variant_size_small_vertical-container_gap": "{xxs}",
    "toggle_variant_size_small_ball-container_min-width": "{xs}",
    "toggle_variant_size_small_ball-container_min-height": "{xs}",
    "toggle_variant_checked_true_pill-container_justify-content": "{justifyContent.end}",
    "toggle_variant_checked_true_pill-container_background-color": "{primary50}",
    "toggle_variant_checked_true_pill-container_border-width": "{border_none}",
    "toggle_variant_checked_true_pill-container_behavior_hover_background-color": "{primary40}",
    "toggle_variant_checked_true_pill-container_behavior_active_background-color": "{primary60}",
    "toggle_variant_checked_true_ball-container_background-color": "{primaryInverse}",
    "toggle_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "toggle_base_vertical-container_opacity": "{opacity.enabled}"
};
const $52d4442770cfd938$var$text_link_color = "{primary60}";
const $52d4442770cfd938$var$text_base_text_color = "{primaryGrey100}";
const $52d4442770cfd938$var$text_variant_color_primary_80_text_color = "{primary80}";
const $52d4442770cfd938$var$text_variant_color_primary_70_text_color = "{primary70}";
const $52d4442770cfd938$var$text_variant_color_primary_60_text_color = "{primary60}";
const $52d4442770cfd938$var$text_variant_color_primary_50_text_color = "{primary50}";
const $52d4442770cfd938$var$text_variant_color_primary_40_text_color = "{primary40}";
const $52d4442770cfd938$var$text_variant_color_primary_30_text_color = "{primary30}";
const $52d4442770cfd938$var$text_variant_color_primary_20_text_color = "{primary20}";
const $52d4442770cfd938$var$text_variant_color_primary_inverse_text_color = "{primaryInverse}";
const $52d4442770cfd938$var$text_variant_color_primary_background_text_color = "{primaryBackground}";
const $52d4442770cfd938$var$text_variant_color_primary_grey_100_text_color = "{primaryGrey100}";
const $52d4442770cfd938$var$text_variant_color_primary_grey_80_text_color = "{primaryGrey80}";
const $52d4442770cfd938$var$text_variant_color_primary_grey_60_text_color = "{primaryGrey60}";
const $52d4442770cfd938$var$text_variant_color_primary_grey_40_text_color = "{primaryGrey40}";
const $52d4442770cfd938$var$text_variant_color_primary_grey_20_text_color = "{primaryGrey20}";
const $52d4442770cfd938$var$text_variant_color_secondary_80_text_color = "{secondary80}";
const $52d4442770cfd938$var$text_variant_color_secondary_70_text_color = "{secondary70}";
const $52d4442770cfd938$var$text_variant_color_secondary_60_text_color = "{secondary60}";
const $52d4442770cfd938$var$text_variant_color_secondary_50_text_color = "{secondary50}";
const $52d4442770cfd938$var$text_variant_color_secondary_40_text_color = "{secondary40}";
const $52d4442770cfd938$var$text_variant_color_secondary_30_text_color = "{secondary30}";
const $52d4442770cfd938$var$text_variant_color_secondary_20_text_color = "{secondary20}";
const $52d4442770cfd938$var$text_variant_color_secondary_inverse_text_color = "{secondaryInverse}";
const $52d4442770cfd938$var$text_variant_color_secondary_background_text_color = "{secondaryBackground}";
const $52d4442770cfd938$var$text_variant_color_secondary_grey_100_text_color = "{secondaryGrey100}";
const $52d4442770cfd938$var$text_variant_color_secondary_grey_80_text_color = "{secondaryGrey80}";
const $52d4442770cfd938$var$text_variant_color_secondary_grey_60_text_color = "{secondaryGrey60}";
const $52d4442770cfd938$var$text_variant_color_secondary_grey_40_text_color = "{secondaryGrey40}";
const $52d4442770cfd938$var$text_variant_color_secondary_grey_20_text_color = "{secondaryGrey20}";
const $52d4442770cfd938$var$text_variant_color_sparkle_80_text_color = "{sparkle80}";
const $52d4442770cfd938$var$text_variant_color_sparkle_70_text_color = "{sparkle70}";
const $52d4442770cfd938$var$text_variant_color_sparkle_60_text_color = "{sparkle60}";
const $52d4442770cfd938$var$text_variant_color_sparkle_50_text_color = "{sparkle50}";
const $52d4442770cfd938$var$text_variant_color_sparkle_40_text_color = "{sparkle40}";
const $52d4442770cfd938$var$text_variant_color_sparkle_30_text_color = "{sparkle30}";
const $52d4442770cfd938$var$text_variant_color_sparkle_20_text_color = "{sparkle20}";
const $52d4442770cfd938$var$text_variant_color_sparkle_inverse_text_color = "{sparkleInverse}";
const $52d4442770cfd938$var$text_variant_color_sparkle_background_text_color = "{sparkleBackground}";
const $52d4442770cfd938$var$text_variant_color_sparkle_grey_100_text_color = "{sparkleGrey100}";
const $52d4442770cfd938$var$text_variant_color_sparkle_grey_80_text_color = "{sparkleGrey80}";
const $52d4442770cfd938$var$text_variant_color_sparkle_grey_60_text_color = "{sparkleGrey60}";
const $52d4442770cfd938$var$text_variant_color_sparkle_grey_40_text_color = "{sparkleGrey40}";
const $52d4442770cfd938$var$text_variant_color_sparkle_grey_20_text_color = "{sparkleGrey20}";
const $52d4442770cfd938$var$text_variant_color_feedback_error_80_text_color = "{feedbackError80}";
const $52d4442770cfd938$var$text_variant_color_feedback_error_50_text_color = "{feedbackError50}";
const $52d4442770cfd938$var$text_variant_color_feedback_error_20_text_color = "{feedbackError20}";
const $52d4442770cfd938$var$text_variant_color_feedback_warning_80_text_color = "{feedbackWarning80}";
const $52d4442770cfd938$var$text_variant_color_feedback_warning_50_text_color = "{feedbackWarning50}";
const $52d4442770cfd938$var$text_variant_color_feedback_warning_20_text_color = "{feedbackWarning20}";
const $52d4442770cfd938$var$text_variant_color_feedback_success_80_text_color = "{feedbackSuccess80}";
const $52d4442770cfd938$var$text_variant_color_feedback_success_50_text_color = "{feedbackSuccess50}";
const $52d4442770cfd938$var$text_variant_color_feedback_success_20_text_color = "{feedbackSuccess20}";
const $52d4442770cfd938$var$text_variant_color_white_text_color = "{global.white}";
const $52d4442770cfd938$var$text_variant_color_black_text_color = "{global.black}";
const $52d4442770cfd938$var$text_variant_color_transparent_text_color = "{global.transparent}";
const $52d4442770cfd938$var$TextTokens = {
    text_link_color: $52d4442770cfd938$var$text_link_color,
    "text_base_text_font-family": "{bodyS}",
    text_base_text_color: $52d4442770cfd938$var$text_base_text_color,
    "text_base_text_font-size": "{bodyS}",
    "text_base_text_line-height": "{bodyS}",
    "text_base_text_letter-spacing": "{bodyS}",
    "text_base_text_font-weight": "{bodyS}",
    "text_base_text_text-decoration": "{text-decoration.none}",
    "text_base_text_text-transform": "{text-case.none}",
    "text_variant_textDecoration_underline_text_text-decoration": "{text-decoration.underline}",
    "text_variant_textDecoration_line-through_text_text-decoration": "{text-decoration.line-through}",
    "text_variant_textDecoration_overline_text_text-decoration": "{text-decoration.overline}",
    text_variant_color_primary_80_text_color: $52d4442770cfd938$var$text_variant_color_primary_80_text_color,
    text_variant_color_primary_70_text_color: $52d4442770cfd938$var$text_variant_color_primary_70_text_color,
    text_variant_color_primary_60_text_color: $52d4442770cfd938$var$text_variant_color_primary_60_text_color,
    text_variant_color_primary_50_text_color: $52d4442770cfd938$var$text_variant_color_primary_50_text_color,
    text_variant_color_primary_40_text_color: $52d4442770cfd938$var$text_variant_color_primary_40_text_color,
    text_variant_color_primary_30_text_color: $52d4442770cfd938$var$text_variant_color_primary_30_text_color,
    text_variant_color_primary_20_text_color: $52d4442770cfd938$var$text_variant_color_primary_20_text_color,
    text_variant_color_primary_inverse_text_color: $52d4442770cfd938$var$text_variant_color_primary_inverse_text_color,
    text_variant_color_primary_background_text_color: $52d4442770cfd938$var$text_variant_color_primary_background_text_color,
    text_variant_color_primary_grey_100_text_color: $52d4442770cfd938$var$text_variant_color_primary_grey_100_text_color,
    text_variant_color_primary_grey_80_text_color: $52d4442770cfd938$var$text_variant_color_primary_grey_80_text_color,
    text_variant_color_primary_grey_60_text_color: $52d4442770cfd938$var$text_variant_color_primary_grey_60_text_color,
    text_variant_color_primary_grey_40_text_color: $52d4442770cfd938$var$text_variant_color_primary_grey_40_text_color,
    text_variant_color_primary_grey_20_text_color: $52d4442770cfd938$var$text_variant_color_primary_grey_20_text_color,
    text_variant_color_secondary_80_text_color: $52d4442770cfd938$var$text_variant_color_secondary_80_text_color,
    text_variant_color_secondary_70_text_color: $52d4442770cfd938$var$text_variant_color_secondary_70_text_color,
    text_variant_color_secondary_60_text_color: $52d4442770cfd938$var$text_variant_color_secondary_60_text_color,
    text_variant_color_secondary_50_text_color: $52d4442770cfd938$var$text_variant_color_secondary_50_text_color,
    text_variant_color_secondary_40_text_color: $52d4442770cfd938$var$text_variant_color_secondary_40_text_color,
    text_variant_color_secondary_30_text_color: $52d4442770cfd938$var$text_variant_color_secondary_30_text_color,
    text_variant_color_secondary_20_text_color: $52d4442770cfd938$var$text_variant_color_secondary_20_text_color,
    text_variant_color_secondary_inverse_text_color: $52d4442770cfd938$var$text_variant_color_secondary_inverse_text_color,
    text_variant_color_secondary_background_text_color: $52d4442770cfd938$var$text_variant_color_secondary_background_text_color,
    text_variant_color_secondary_grey_100_text_color: $52d4442770cfd938$var$text_variant_color_secondary_grey_100_text_color,
    text_variant_color_secondary_grey_80_text_color: $52d4442770cfd938$var$text_variant_color_secondary_grey_80_text_color,
    text_variant_color_secondary_grey_60_text_color: $52d4442770cfd938$var$text_variant_color_secondary_grey_60_text_color,
    text_variant_color_secondary_grey_40_text_color: $52d4442770cfd938$var$text_variant_color_secondary_grey_40_text_color,
    text_variant_color_secondary_grey_20_text_color: $52d4442770cfd938$var$text_variant_color_secondary_grey_20_text_color,
    text_variant_color_sparkle_80_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_80_text_color,
    text_variant_color_sparkle_70_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_70_text_color,
    text_variant_color_sparkle_60_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_60_text_color,
    text_variant_color_sparkle_50_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_50_text_color,
    text_variant_color_sparkle_40_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_40_text_color,
    text_variant_color_sparkle_30_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_30_text_color,
    text_variant_color_sparkle_20_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_20_text_color,
    text_variant_color_sparkle_inverse_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_inverse_text_color,
    text_variant_color_sparkle_background_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_background_text_color,
    text_variant_color_sparkle_grey_100_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_grey_100_text_color,
    text_variant_color_sparkle_grey_80_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_grey_80_text_color,
    text_variant_color_sparkle_grey_60_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_grey_60_text_color,
    text_variant_color_sparkle_grey_40_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_grey_40_text_color,
    text_variant_color_sparkle_grey_20_text_color: $52d4442770cfd938$var$text_variant_color_sparkle_grey_20_text_color,
    text_variant_color_feedback_error_80_text_color: $52d4442770cfd938$var$text_variant_color_feedback_error_80_text_color,
    text_variant_color_feedback_error_50_text_color: $52d4442770cfd938$var$text_variant_color_feedback_error_50_text_color,
    text_variant_color_feedback_error_20_text_color: $52d4442770cfd938$var$text_variant_color_feedback_error_20_text_color,
    text_variant_color_feedback_warning_80_text_color: $52d4442770cfd938$var$text_variant_color_feedback_warning_80_text_color,
    text_variant_color_feedback_warning_50_text_color: $52d4442770cfd938$var$text_variant_color_feedback_warning_50_text_color,
    text_variant_color_feedback_warning_20_text_color: $52d4442770cfd938$var$text_variant_color_feedback_warning_20_text_color,
    text_variant_color_feedback_success_80_text_color: $52d4442770cfd938$var$text_variant_color_feedback_success_80_text_color,
    text_variant_color_feedback_success_50_text_color: $52d4442770cfd938$var$text_variant_color_feedback_success_50_text_color,
    text_variant_color_feedback_success_20_text_color: $52d4442770cfd938$var$text_variant_color_feedback_success_20_text_color,
    text_variant_color_white_text_color: $52d4442770cfd938$var$text_variant_color_white_text_color,
    text_variant_color_black_text_color: $52d4442770cfd938$var$text_variant_color_black_text_color,
    text_variant_color_transparent_text_color: $52d4442770cfd938$var$text_variant_color_transparent_text_color,
    "text_variant_appearance_heading_xl_text_font-size": "{headingXl}",
    "text_variant_appearance_heading_xl_text_font-family": "{headingXl}",
    "text_variant_appearance_heading_xl_text_line-height": "{headingXl}",
    "text_variant_appearance_heading_xl_text_letter-spacing": "{headingXl}",
    "text_variant_appearance_heading_xl_text_font-weight": "{headingXl}",
    "text_variant_appearance_heading_l_text_font-size": "{headingL}",
    "text_variant_appearance_heading_l_text_font-family": "{headingL}",
    "text_variant_appearance_heading_l_text_line-height": "{headingL}",
    "text_variant_appearance_heading_l_text_letter-spacing": "{headingL}",
    "text_variant_appearance_heading_l_text_font-weight": "{headingL}",
    "text_variant_appearance_heading_m_text_font-size": "{headingM}",
    "text_variant_appearance_heading_m_text_font-family": "{headingM}",
    "text_variant_appearance_heading_m_text_line-height": "{headingM}",
    "text_variant_appearance_heading_m_text_letter-spacing": "{headingM}",
    "text_variant_appearance_heading_m_text_font-weight": "{headingM}",
    "text_variant_appearance_heading_s_text_font-size": "{headingS}",
    "text_variant_appearance_heading_s_text_font-family": "{headingS}",
    "text_variant_appearance_heading_s_text_line-height": "{headingS}",
    "text_variant_appearance_heading_s_text_letter-spacing": "{headingS}",
    "text_variant_appearance_heading_s_text_font-weight": "{headingS}",
    "text_variant_appearance_heading_xs_text_font-size": "{headingXs}",
    "text_variant_appearance_heading_xs_text_font-family": "{headingXs}",
    "text_variant_appearance_heading_xs_text_line-height": "{headingXs}",
    "text_variant_appearance_heading_xs_text_letter-spacing": "{headingXs}",
    "text_variant_appearance_heading_xs_text_font-weight": "{headingXs}",
    "text_variant_appearance_heading_xxs_text_font-size": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_font-family": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_line-height": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_letter-spacing": "{headingXxs}",
    "text_variant_appearance_heading_xxs_text_font-weight": "{headingXxs}",
    "text_variant_appearance_overline_text_font-size": "{overline}",
    "text_variant_appearance_overline_text_font-family": "{overline}",
    "text_variant_appearance_overline_text_line-height": "{overline}",
    "text_variant_appearance_overline_text_letter-spacing": "{overline}",
    "text_variant_appearance_overline_text_font-weight": "{overline}",
    "text_variant_appearance_overline_text_text-transform": "{overline}",
    "text_variant_appearance_body_l_text_font-size": "{bodyL}",
    "text_variant_appearance_body_l_text_font-family": "{bodyL}",
    "text_variant_appearance_body_l_text_line-height": "{bodyL}",
    "text_variant_appearance_body_l_text_letter-spacing": "{bodyL}",
    "text_variant_appearance_body_l_text_font-weight": "{bodyL}",
    "text_variant_appearance_body_l_bold_text_font-size": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_font-family": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_line-height": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_letter-spacing": "{bodyLBold}",
    "text_variant_appearance_body_l_bold_text_font-weight": "{bodyLBold}",
    "text_variant_appearance_body_l_link_text_font-size": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_font-family": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_line-height": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_letter-spacing": "{bodyLLink}",
    "text_variant_appearance_body_l_link_text_font-weight": "{bodyLLink}",
    "text_variant_appearance_body_m_text_font-size": "{bodyM}",
    "text_variant_appearance_body_m_text_font-family": "{bodyM}",
    "text_variant_appearance_body_m_text_line-height": "{bodyM}",
    "text_variant_appearance_body_m_text_letter-spacing": "{bodyM}",
    "text_variant_appearance_body_m_text_font-weight": "{bodyM}",
    "text_variant_appearance_body_m_bold_text_font-size": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_font-family": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_line-height": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_letter-spacing": "{bodyMBold}",
    "text_variant_appearance_body_m_bold_text_font-weight": "{bodyMBold}",
    "text_variant_appearance_body_m_link_text_font-size": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_font-family": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_line-height": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_letter-spacing": "{bodyMLink}",
    "text_variant_appearance_body_m_link_text_font-weight": "{bodyMLink}",
    "text_variant_appearance_body_s_text_font-size": "{bodyS}",
    "text_variant_appearance_body_s_text_font-family": "{bodyS}",
    "text_variant_appearance_body_s_text_line-height": "{bodyS}",
    "text_variant_appearance_body_s_text_letter-spacing": "{bodyS}",
    "text_variant_appearance_body_s_text_font-weight": "{bodyS}",
    "text_variant_appearance_body_s_bold_text_font-size": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_font-family": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_line-height": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_letter-spacing": "{bodySBold}",
    "text_variant_appearance_body_s_bold_text_font-weight": "{bodySBold}",
    "text_variant_appearance_body_s_link_text_font-size": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_font-family": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_line-height": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_letter-spacing": "{bodySLink}",
    "text_variant_appearance_body_s_link_text_font-weight": "{bodySLink}",
    "text_variant_appearance_body_xs_text_font-size": "{bodyXs}",
    "text_variant_appearance_body_xs_text_font-family": "{bodyXs}",
    "text_variant_appearance_body_xs_text_line-height": "{bodyXs}",
    "text_variant_appearance_body_xs_text_letter-spacing": "{bodyXs}",
    "text_variant_appearance_body_xs_text_font-weight": "{bodyXs}",
    "text_variant_appearance_body_xs_bold_text_font-size": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_font-family": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_line-height": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_letter-spacing": "{bodyXsBold}",
    "text_variant_appearance_body_xs_bold_text_font-weight": "{bodyXsBold}",
    "text_variant_appearance_body_xs_link_text_font-size": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_font-family": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_line-height": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_letter-spacing": "{bodyXsLink}",
    "text_variant_appearance_body_xs_link_text_font-weight": "{bodyXsLink}",
    "text_variant_appearance_body_xs_caps_text_font-family": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_line-height": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_text-transform": "{bodyS}",
    "text_variant_appearance_body_xs_caps_text_letter-spacing": "{bodyXs}",
    "text_variant_appearance_body_xs_caps_text_font-weight": "{bodyXs}",
    "text_variant_appearance_body_xxs_text_font-size": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_font-family": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_line-height": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_letter-spacing": "{bodyXxs}",
    "text_variant_appearance_body_xxs_text_font-weight": "{bodyXxs}",
    "text_variant_appearance_body_xxs_bold_text_font-size": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_font-family": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_line-height": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_letter-spacing": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_bold_text_font-weight": "{bodyXxsBold}",
    "text_variant_appearance_body_xxs_link_text_font-size": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_font-family": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_line-height": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_letter-spacing": "{bodyXxsLink}",
    "text_variant_appearance_body_xxs_link_text_font-weight": "{bodyXxsLink}",
    "text_variant_appearance_body_3xs_text_font-size": "{body3xs}",
    "text_variant_appearance_body_3xs_text_font-family": "{body3xs}",
    "text_variant_appearance_body_3xs_text_line-height": "{body3xs}",
    "text_variant_appearance_body_3xs_text_letter-spacing": "{body3xs}",
    "text_variant_appearance_body_3xs_text_font-weight": "{body3xs}",
    "text_variant_appearance_body_3xs_bold_text_font-size": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_font-family": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_line-height": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_letter-spacing": "{body3xsBold}",
    "text_variant_appearance_body_3xs_bold_text_font-weight": "{body3xsBold}",
    "text_variant_appearance_body_3xs_link_text_font-size": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_font-family": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_line-height": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_letter-spacing": "{body3xsLink}",
    "text_variant_appearance_body_3xs_link_text_font-weight": "{body3xsLink}",
    "text_variant_appearance_list_title_text_font-size": "{listTitle}",
    "text_variant_appearance_list_title_text_font-family": "{listTitle}",
    "text_variant_appearance_list_title_text_line-height": "{listTitle}",
    "text_variant_appearance_list_title_text_letter-spacing": "{listTitle}",
    "text_variant_appearance_list_title_text_font-weight": "{listTitle}",
    "text_variant_appearance_button_text_font-size": "{button}",
    "text_variant_appearance_button_text_font-family": "{button}",
    "text_variant_appearance_button_text_line-height": "{button}",
    "text_variant_appearance_button_text_letter-spacing": "{button}",
    "text_variant_appearance_button_text_font-weight": "{button}",
    "text_variant_appearance_code_text_font-size": "{code}",
    "text_variant_appearance_code_text_font-family": "{code}",
    "text_variant_appearance_code_text_line-height": "{code}",
    "text_variant_appearance_code_text_letter-spacing": "{code}",
    "text_variant_appearance_code_text_font-weight": "{code}",
    "text_variant_appearance_body_s_regular_para_text_font-size": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_line-height": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_letter-spacing": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_font-weight": "{bodyS}",
    "text_variant_appearance_body_s_regular_para_text_font-family": "{bodyS}"
};
const $52d4442770cfd938$var$RatingBarTokens = {
    "ratingbar_base_vertical-container_flex-direction": "{flexDirection.column}",
    "ratingbar_base_vertical-container_align-items": "{alignItems.start}",
    "ratingbar_base_vertical-container_justify-content": "{justifyContent.start}",
    "ratingbar_base_vertical-container_gap": "{xxs}",
    "ratingbar_base_horizontal-container_flex-direction": "{flexDirection.row}",
    "align-items": "{alignItems.center}",
    "ratingbar_base_horizontal-container_justify-content": "{justifyContent.start}",
    "ratingbar_base_horizontal-container_gap": "{xs}",
    "ratingbar_base_rating-bar-container_flex-direction": "{flexDirection.row}",
    "ratingbar_variant_size_small_vertical-container_gap": "{xxs}",
    "ratingbar_variant_size_small_horizontal-container_gap": "{xs}",
    "ratingbar_variant_labelPosition_bottom_center_vertical-container_align-items": "{alignItems.center}",
    "ratingbar_variant_labelPosition_top_center_vertical-container_align-items": "{alignItems.center}",
    "ratingbar_variant_disabled_true_vertical-container_opacity": "{opacity.disabled}",
    "ratingbar_combination_read_only_expanded_small_horizontal-container_gap": "{xxs}",
    "ratingbar_combination_read_only_expanded_small_vertical-container_gap": "{xxs}",
    "ratingbar_combination_read_only_expanded_medium_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_medium_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_large_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_expanded_large_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_small_horizontal-container_gap": "{xxs}",
    "ratingbar_combination_read_only_compact_small_vertical-container_gap": "{xxs}",
    "ratingbar_combination_read_only_compact_medium_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_medium_horizontal-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_large_vertical-container_gap": "{xs}",
    "ratingbar_combination_read_only_compact_large_horizontal-container_gap": "{xs}",
    "ratingbar_base_horizontal-container_align-items": "{alignItems.center}"
};
const $52d4442770cfd938$var$ratingBarItem_variant_size_small_start_icon_size = "{m}";
const $52d4442770cfd938$var$ratingBarItem_variant_size_small_end_icon_size = "{m}";
const $52d4442770cfd938$var$ratingBarItem_variant_size_large_start_icon_size = "{xl}";
const $52d4442770cfd938$var$ratingBarItem_variant_size_large_end_icon_size = "{xl}";
const $52d4442770cfd938$var$ratingBarItem_variant_disabled_true_container_opacity = "{opacity.disabled}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color = "{primary50}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color = "{primary50}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color = "{primary60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color = "{primary60}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color = "{primary50}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color = "{primary50}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color = "{primary70}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color = "{primaryGrey80}";
const $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color = "{primaryGrey60}";
const $52d4442770cfd938$var$RatingBarItemTokens = {
    "ratingBarItem_base_container_flex-direction": "{flexDirection.stack}",
    "ratingBarItem_base_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_base_container_behavior_focus_border-color": "{primary60}",
    ratingBarItem_variant_size_small_start_icon_size: $52d4442770cfd938$var$ratingBarItem_variant_size_small_start_icon_size,
    ratingBarItem_variant_size_small_end_icon_size: $52d4442770cfd938$var$ratingBarItem_variant_size_small_end_icon_size,
    ratingBarItem_variant_size_large_start_icon_size: $52d4442770cfd938$var$ratingBarItem_variant_size_large_start_icon_size,
    ratingBarItem_variant_size_large_end_icon_size: $52d4442770cfd938$var$ratingBarItem_variant_size_large_end_icon_size,
    ratingBarItem_variant_disabled_true_container_opacity: $52d4442770cfd938$var$ratingBarItem_variant_disabled_true_container_opacity,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_false_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_false_true_true_end_icon_color,
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_container_behavior_focus_border-color": "{primary60}",
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_false_false_end_icon_behavior_active_color,
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-color": "{primary60}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_container_behavior_focus_border-width": "{border_focus}",
    "ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_container_behavior_focus_border-width": "{border_focus}",
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_false_end_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_start_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isActive_isHovered_true_true_true_end_icon_behavior_active_color,
    ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_start_icon_color,
    ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color: $52d4442770cfd938$var$ratingBarItem_combination_isInteractive_isHalfRated_false_true_end_icon_color
};
const $52d4442770cfd938$export$a744e0ee3d364193 = {
    JDSActionButton: $52d4442770cfd938$var$ActionButtonTokens,
    JDSAvatar: $52d4442770cfd938$var$AvatarTokens,
    JDSAvatarV2Default: $52d4442770cfd938$var$AvatarV2DefaultTokens,
    JDSAccordionList: $52d4442770cfd938$var$AccordionListTokens,
    JDSMobileBottomSheet: $52d4442770cfd938$var$MobileBottomSheetTokens,
    JDSMobileBottomSheetInternal: $52d4442770cfd938$var$MobileBottomSheetInternalTokens,
    JDSBadge: $52d4442770cfd938$var$BadgeTokens,
    JDSBadgeV2Brand: $52d4442770cfd938$var$BadgeV2BrandTokens,
    JDSBadgeV2Information: $52d4442770cfd938$var$BadgeV2InformationTokens,
    JDSBadgeV2Notification: $52d4442770cfd938$var$BadgeV2NotificationTokens,
    JDSBadgeV2Status: $52d4442770cfd938$var$BadgeV2StatusTokens,
    JDSBaseIcon: $52d4442770cfd938$var$BaseIconTokens,
    JDSDesktopBottomSheet: $52d4442770cfd938$var$DesktopBottomSheetTokens,
    JDSDesktopBottomSheetInternal: $52d4442770cfd938$var$DesktopBottomSheetInternalTokens,
    JDSBreadcrumbs: $52d4442770cfd938$var$BreadcrumbsTokens,
    JDSCarousel: $52d4442770cfd938$var$CarouselTokens,
    JDSCarouselPagination: $52d4442770cfd938$var$CarouselPaginationTokens,
    JDSButton: $52d4442770cfd938$var$ButtonTokens,
    JDSCarouselPaginationItem: $52d4442770cfd938$var$CarouselPaginationItemTokens,
    JDSCarouselSlide: $52d4442770cfd938$var$CarouselSlideTokens,
    JDSCheckbox: $52d4442770cfd938$var$CheckboxTokens,
    JDSContentBlock: $52d4442770cfd938$var$ContentBlockTokens,
    JDSDatepickerButton: $52d4442770cfd938$var$DatepickerButtonTokens,
    JDSContentCard: $52d4442770cfd938$var$ContentCardTokens,
    JDSDatepickerCalendarButton: $52d4442770cfd938$var$DatepickerCalendarButtonTokens,
    JDSDatepickerCalendar: $52d4442770cfd938$var$DatepickerCalendarTokens,
    JDSDatepickerCalendarRow: $52d4442770cfd938$var$DatepickerCalendarRowTokens,
    JDSAccordion: $52d4442770cfd938$var$AccordionTokens,
    JDSDatepickerCalendarHeader: $52d4442770cfd938$var$DatepickerCalendarHeaderTokens,
    JDSDatepickerDesktop: $52d4442770cfd938$var$DatepickerDesktopTokens,
    JDSDatepickerDesktopInternal: $52d4442770cfd938$var$DatepickerDesktopTokens,
    JDSDatepickerHeader: $52d4442770cfd938$var$DatepickerHeaderTokens,
    JDSDatepickerYearView: $52d4442770cfd938$var$DatepickerYearViewTokens,
    JDSDatepickerMonthView: $52d4442770cfd938$var$DatepickerMonthViewTokens,
    JDSDatepickerMobile: $52d4442770cfd938$var$DatepickerMobileTokens,
    JDSDatepickerMobileInteral: $52d4442770cfd938$var$DatepickerMobileTokens,
    JDSDivider: $52d4442770cfd938$var$DividerTokens,
    JDSDatepickerViewButton: $52d4442770cfd938$var$DatepickerViewButtonTokens,
    JDSFAB: $52d4442770cfd938$var$FABTokens,
    JDSFABInternal: $52d4442770cfd938$var$FABTokens,
    JDSDropdown: $52d4442770cfd938$var$DropdownTokens,
    JDSDropdownMenu: $52d4442770cfd938$var$DropdownMenuTokens,
    JDSDropdownMenuInternal: $52d4442770cfd938$var$DropdownMenuTokens,
    JDSDropdownMenuItem: $52d4442770cfd938$var$DropdownMenuItemTokens,
    JDSDropdownMenuItemMobile: $52d4442770cfd938$var$DropdownMenuItemTokens,
    JDSDropdownMenuGroup: $52d4442770cfd938$var$DropdownMenuGroupTokens,
    JDSDropdownMenuSubMenu: $52d4442770cfd938$var$DropdownMenuSubMenuTokens,
    JDSFeedbackBlock: $52d4442770cfd938$var$FeedbackBlockTokens,
    JDSBottomFooterLinkItem: $52d4442770cfd938$var$BottomFooterLinkItemTokens,
    JDSFooterIconLinks: $52d4442770cfd938$var$FooterIconLinksTokens,
    JDSFooter: $52d4442770cfd938$var$FooterTokens,
    JDSBottomFooter: $52d4442770cfd938$var$BottomFooterTokens,
    JDSFooterLinksGrid: $52d4442770cfd938$var$FooterLinksGridTokens,
    JDSFooterLinks: $52d4442770cfd938$var$FooterLinksTokens,
    JDSIcon: $52d4442770cfd938$var$IconTokens,
    JDSFooterMarketLinks: $52d4442770cfd938$var$FooterMarketLinksTokens,
    JDSImage: $52d4442770cfd938$var$ImageTokens,
    JDSInput: $52d4442770cfd938$var$InputTokens,
    JDSInputCodeItem: $52d4442770cfd938$var$InputCodeItemTokens,
    JDSInputDate: $52d4442770cfd938$var$InputDateTokens,
    JDSLink: $52d4442770cfd938$var$LinkTokens,
    JDSFileUploader: $52d4442770cfd938$var$FileUploaderTokens,
    JDSFileUploaderControl: $52d4442770cfd938$var$FileUploaderControlTokens,
    JDSFileUploaderItem: $52d4442770cfd938$var$FileUploaderItemTokens,
    JDSFileUploaderList: $52d4442770cfd938$var$FileUploaderListTokens,
    JDSFileUploaderPanel: $52d4442770cfd938$var$FileUploaderPanelTokens,
    JDSMenuBlock: $52d4442770cfd938$var$MenuBlockTokens,
    JDSMenuBlockInternal: $52d4442770cfd938$var$MenuBlockTokens,
    JDSListBlock: $52d4442770cfd938$var$ListBlockTokens,
    JDSInputField: $52d4442770cfd938$var$InputFieldTokens,
    JDSInputFieldV2: $52d4442770cfd938$var$InputFieldV2Tokens,
    JDSModalDesktop: $52d4442770cfd938$var$ModalDesktopTokens,
    JDSModalDesktopInternal: $52d4442770cfd938$var$ModalDesktopInternalTokens,
    JDSMenuBlockItem: $52d4442770cfd938$var$MenuBlockItemTokens,
    JDSModalMobile: $52d4442770cfd938$var$ModalMobileTokens,
    JDSModalMobileInternal: $52d4442770cfd938$var$ModalMobileInternalTokens,
    JDSHeaderDesktop: $52d4442770cfd938$var$HeaderDesktopTokens,
    JDSBottomNavigation: $52d4442770cfd938$var$BottomNavigationTokens,
    JDSBottomNavigationItem: $52d4442770cfd938$var$BottomNavigationItemTokens,
    JDSMegaMenu: $52d4442770cfd938$var$MegaMenuTokens,
    JDSMegaMenuInternal: $52d4442770cfd938$var$MegaMenuTokens,
    JDSHeaderMobile: $52d4442770cfd938$var$HeaderMobileTokens,
    JDSMegaMenuItem: $52d4442770cfd938$var$MegaMenuItemTokens,
    JDSTextarea: $52d4442770cfd938$var$TextareaTokens,
    JDSSidePanelItem: $52d4442770cfd938$var$SidePanelItemTokens,
    JDSMegaMenuBlock: $52d4442770cfd938$var$MegaMenuBlockTokens,
    JDSNotificationButton: $52d4442770cfd938$var$NotificationButtonTokens,
    JDSNotificationBanner: $52d4442770cfd938$var$NotificationBannerTokens,
    JDSNudgeContainer: $52d4442770cfd938$var$NudgeContainerTokens,
    JDSToastContainer: $52d4442770cfd938$var$ToastContainerTokens,
    JDSToast: $52d4442770cfd938$var$ToastTokens,
    JDSNudge: $52d4442770cfd938$var$NudgeTokens,
    JDSPagination: $52d4442770cfd938$var$PaginationTokens,
    JDSPromoCard: $52d4442770cfd938$var$PromoCardTokens,
    JDSSidePanel: $52d4442770cfd938$var$SidePanelTokens,
    JDSSidePanelInternal: $52d4442770cfd938$var$SidePanelTokens,
    JDSProgressBar: $52d4442770cfd938$var$ProgressBarTokens,
    JDSSearchBox: $52d4442770cfd938$var$SearchBoxTokens,
    JDSPaginationButton: $52d4442770cfd938$var$PaginationButtonTokens,
    JDSSearchResultItem: $52d4442770cfd938$var$SearchResultItemTokens,
    JDSSearchResultText: $52d4442770cfd938$var$SearchResultTextTokens,
    JDSRadioButton: $52d4442770cfd938$var$RadioButtonTokens,
    JDSSelector: $52d4442770cfd938$var$SelectorTokens,
    JDSSelectorItem: $52d4442770cfd938$var$SelectorItemTokens,
    JDSSearchResults: $52d4442770cfd938$var$SearchResultsTokens,
    JDSSearchResultsInternal: $52d4442770cfd938$var$SearchResultsTokens,
    JDSSkeleton: $52d4442770cfd938$var$SkeletonTokens,
    JDSServiceCard: $52d4442770cfd938$var$ServiceCardTokens,
    JDSNotificationIconButton: $52d4442770cfd938$var$NotificationIconButtonTokens,
    JDSSpinner: $52d4442770cfd938$var$SpinnerTokens,
    JDSSelectorButton: $52d4442770cfd938$var$SelectorButtonTokens,
    JDSSlider: $52d4442770cfd938$var$SliderTokens,
    JDSStepperDot: $52d4442770cfd938$var$StepperDotTokens,
    JDSHorizontalStepItem: $52d4442770cfd938$var$HorizontalStepItemTokens,
    JDSVerticalStepItem: $52d4442770cfd938$var$VerticalStepItemTokens,
    JDSTableCell: $52d4442770cfd938$var$TableCellTokens,
    JDSTableBody: $52d4442770cfd938$var$TableBodyTokens,
    JDSTableRow: $52d4442770cfd938$var$TableRowTokens,
    JDSTabBar: $52d4442770cfd938$var$TabBarTokens,
    JDSVerticalStepper: $52d4442770cfd938$var$VerticalStepperTokens,
    JDSTabItem: $52d4442770cfd938$var$TabItemTokens,
    JDSTabsDesktop: $52d4442770cfd938$var$TabsDesktopTokens,
    JDSTag: $52d4442770cfd938$var$TagTokens,
    JDSHorizontalStepper: $52d4442770cfd938$var$HorizontalStepperTokens,
    JDSTable: $52d4442770cfd938$var$TableTokens,
    JDSToggle: $52d4442770cfd938$var$ToggleTokens,
    JDSText: $52d4442770cfd938$var$TextTokens,
    JDSTooltip: $52d4442770cfd938$var$TooltipTokens,
    JDSTooltipInternal: $52d4442770cfd938$var$TooltipTokens,
    JDSInputCode: $52d4442770cfd938$var$InputCodeTokens,
    JDSRatingBar: $52d4442770cfd938$var$RatingBarTokens,
    JDSRatingBarItem: $52d4442770cfd938$var$RatingBarItemTokens
};
const $52d4442770cfd938$export$616d0e83e98f2255 = [
    {
        name: "JioMeet",
        primaryColor: "orange",
        secondaryColor: "purple",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Express",
        primaryColor: "navi_midnight",
        secondaryColor: "red",
        sparkleColor: "pink"
    },
    {
        name: "JioSnap",
        primaryColor: "violet",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioMart Digital Partner",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioTrue5G",
        primaryColor: "navi_midnight",
        secondaryColor: "orange",
        sparkleColor: "reliance"
    },
    {
        name: "JioNetVelocity",
        primaryColor: "reliance",
        secondaryColor: "marigold",
        sparkleColor: "green"
    },
    {
        name: "JioSociety",
        primaryColor: "violet_midnight",
        secondaryColor: "mint",
        sparkleColor: "orange"
    },
    {
        name: "JioVideoCall",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioSwitch",
        primaryColor: "reliance_midnight",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "DSP",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioPhotos",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioPay",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioTranslate",
        primaryColor: "pink_midnight",
        secondaryColor: "marigold",
        sparkleColor: "purple"
    },
    {
        name: "JioTV",
        primaryColor: "crimson",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioGames",
        primaryColor: "green",
        secondaryColor: "mint_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JustDial",
        primaryColor: "sky",
        secondaryColor: "orange",
        sparkleColor: "mint"
    },
    {
        name: "JioTVplus",
        primaryColor: "crimson",
        secondaryColor: "marigold",
        sparkleColor: "red"
    },
    {
        name: "JioHealthHub",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "red"
    },
    {
        name: "JioGlobal",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "sky"
    },
    {
        name: "JioSaavn",
        primaryColor: "mint",
        secondaryColor: "sky",
        sparkleColor: "navi"
    },
    {
        name: "JioEvents",
        primaryColor: "mint",
        secondaryColor: "purple",
        sparkleColor: "pink"
    },
    {
        name: "JioFit",
        primaryColor: "Orange",
        secondaryColor: "Purple",
        sparkleColor: "Mint"
    },
    {
        name: "JioMarket",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "orange"
    },
    {
        name: "JioAssist",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "mint"
    },
    {
        name: "JioChannels",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "pink"
    },
    {
        name: "JioBase",
        primaryColor: "navi",
        secondaryColor: "marigold",
        sparkleColor: "mint"
    },
    {
        name: "JioCloud",
        primaryColor: "sky",
        secondaryColor: "mint",
        sparkleColor: "marigold"
    },
    {
        name: "JioAds",
        primaryColor: "navi",
        secondaryColor: "red",
        sparkleColor: "sky"
    },
    {
        name: "JioKrishi",
        primaryColor: "green_midnight",
        secondaryColor: "orange",
        sparkleColor: "marigold"
    },
    {
        name: "JioCinema",
        primaryColor: "pink",
        secondaryColor: "violet_midnight",
        sparkleColor: "marigold"
    },
    {
        name: "JioMart Digital Business",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "MyJio",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioGlass",
        primaryColor: "crimson",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioDive",
        primaryColor: "purple",
        secondaryColor: "mint",
        sparkleColor: "sky"
    },
    {
        name: "JioCall",
        primaryColor: "green",
        secondaryColor: "violet",
        sparkleColor: "navi"
    },
    {
        name: "JioEngage",
        primaryColor: "violet_midnight",
        secondaryColor: "red",
        sparkleColor: "marigold"
    },
    {
        name: "JioCX",
        primaryColor: "purple",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioFinance",
        primaryColor: "gold",
        secondaryColor: "orange_midnight",
        sparkleColor: "sky_midnight"
    },
    {
        name: "JioPos",
        primaryColor: "mint",
        secondaryColor: "red_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioNews",
        primaryColor: "crimson",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioMart Digital",
        primaryColor: "purple_midnight",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioID",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "green"
    },
    {
        name: "JioHome",
        primaryColor: "sky",
        secondaryColor: "purple_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioMart",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioMart Partner",
        primaryColor: "sky",
        secondaryColor: "red",
        sparkleColor: "green"
    },
    {
        name: "JioGauSamridhhi",
        primaryColor: "orange",
        secondaryColor: "green_midnight",
        sparkleColor: "pink_midnight"
    },
    {
        name: "JioWallet",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioJoin",
        primaryColor: "green",
        secondaryColor: "purple",
        sparkleColor: "marigold"
    },
    {
        name: "JioSecure",
        primaryColor: "mint",
        secondaryColor: "reliance_midnight",
        sparkleColor: "sky_light"
    },
    {
        name: "JioCare",
        primaryColor: "reliance",
        secondaryColor: "navi",
        sparkleColor: "pink"
    },
    {
        name: "JioSphere",
        primaryColor: "mint",
        secondaryColor: "sky_midnight",
        sparkleColor: "orange"
    },
    {
        name: "JioChat",
        primaryColor: "navi",
        secondaryColor: "orange",
        sparkleColor: "sky"
    },
    {
        name: "JioCloud PC",
        primaryColor: "sky",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "jio com",
        primaryColor: "reliance",
        secondaryColor: "navi_midnight",
        sparkleColor: "sky"
    },
    {
        name: "JioWave",
        primaryColor: "purple",
        secondaryColor: "sky",
        sparkleColor: "mint"
    },
    {
        name: "JioWorkspace",
        primaryColor: "purple",
        secondaryColor: "marigold",
        sparkleColor: "reliance"
    },
    {
        name: "JioFacility",
        primaryColor: "indigo",
        secondaryColor: "marigold",
        sparkleColor: "orange"
    },
    {
        name: "MyJio1",
        primaryColor: "indigo",
        secondaryColor: "saffron",
        sparkleColor: "green"
    }
];
const $52d4442770cfd938$var$camelCase = (s, separator = "-")=>s.split(separator).map((segment, index)=>index === 0 ? segment : segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $52d4442770cfd938$var$clearModeFromColor = (color)=>{
    return color.replace(/_(light|dark|dim)+/i, "");
};
const $52d4442770cfd938$var$transformThemeName = (name)=>name.split("-").map((segment)=>segment.charAt(0).toUpperCase() + segment.slice(1)).join("");
const $52d4442770cfd938$var$normalizedThemeData = $52d4442770cfd938$export$616d0e83e98f2255.map((data)=>({
        ...data,
        name: $52d4442770cfd938$var$transformThemeName(data.name)
    }));
const $52d4442770cfd938$export$e330aa996edc4437 = (theme)=>{
    const normalizedTheme = $52d4442770cfd938$var$transformThemeName(theme);
    const currentTheme = $52d4442770cfd938$var$normalizedThemeData.find((data)=>$52d4442770cfd938$var$camelCase(normalizedTheme) === $52d4442770cfd938$var$camelCase(data.name));
    let colors = {
        primary: $52d4442770cfd938$export$616d0e83e98f2255[0].primaryColor,
        secondary: $52d4442770cfd938$export$616d0e83e98f2255[0].secondaryColor,
        sparkle: $52d4442770cfd938$export$616d0e83e98f2255[0].sparkleColor,
        neutral: "neutral"
    };
    if (currentTheme) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor, sparkleColor: sparkleColor } = currentTheme;
        colors = {
            primary: primaryColor?.toLowerCase(),
            secondary: secondaryColor?.toLowerCase(),
            sparkle: sparkleColor?.toLowerCase(),
            neutral: "neutral"
        };
    }
    colors.primary = $52d4442770cfd938$var$clearModeFromColor(colors.primary);
    colors.secondary = $52d4442770cfd938$var$clearModeFromColor(colors.secondary);
    colors.sparkle = $52d4442770cfd938$var$clearModeFromColor(colors.sparkle);
    return colors;
};



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $136d40cdb268fe10$export$a143d493d941bafc;
var $136d40cdb268fe10$export$e4cf37d7f6fb9e0a;
var $136d40cdb268fe10$export$f99ded8fe4b79145;
var $136d40cdb268fe10$export$599f31c3813fae4d;
'use strict';
var $e0eed84d5498f6e4$export$a48f0734ac7c2329;
var $e0eed84d5498f6e4$export$d622b2ad8d90c771;
var $e0eed84d5498f6e4$export$6100ba28696e12de;
'use strict';
$e0eed84d5498f6e4$export$a48f0734ac7c2329 = $e0eed84d5498f6e4$var$byteLength;
$e0eed84d5498f6e4$export$d622b2ad8d90c771 = $e0eed84d5498f6e4$var$toByteArray;
$e0eed84d5498f6e4$export$6100ba28696e12de = $e0eed84d5498f6e4$var$fromByteArray;
var $e0eed84d5498f6e4$var$lookup = [];
var $e0eed84d5498f6e4$var$revLookup = [];
var $e0eed84d5498f6e4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e0eed84d5498f6e4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e0eed84d5498f6e4$var$i = 0, $e0eed84d5498f6e4$var$len = $e0eed84d5498f6e4$var$code.length; $e0eed84d5498f6e4$var$i < $e0eed84d5498f6e4$var$len; ++$e0eed84d5498f6e4$var$i){
    $e0eed84d5498f6e4$var$lookup[$e0eed84d5498f6e4$var$i] = $e0eed84d5498f6e4$var$code[$e0eed84d5498f6e4$var$i];
    $e0eed84d5498f6e4$var$revLookup[$e0eed84d5498f6e4$var$code.charCodeAt($e0eed84d5498f6e4$var$i)] = $e0eed84d5498f6e4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e0eed84d5498f6e4$var$revLookup['-'.charCodeAt(0)] = 62;
$e0eed84d5498f6e4$var$revLookup['_'.charCodeAt(0)] = 63;
function $e0eed84d5498f6e4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e0eed84d5498f6e4$var$byteLength(b64) {
    var lens = $e0eed84d5498f6e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e0eed84d5498f6e4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e0eed84d5498f6e4$var$toByteArray(b64) {
    var tmp;
    var lens = $e0eed84d5498f6e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e0eed84d5498f6e4$var$Arr($e0eed84d5498f6e4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 18 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 2 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 10 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e0eed84d5498f6e4$var$tripletToBase64(num) {
    return $e0eed84d5498f6e4$var$lookup[num >> 18 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num >> 12 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num >> 6 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num & 0x3F];
}
function $e0eed84d5498f6e4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e0eed84d5498f6e4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e0eed84d5498f6e4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e0eed84d5498f6e4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e0eed84d5498f6e4$var$lookup[tmp >> 2] + $e0eed84d5498f6e4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e0eed84d5498f6e4$var$lookup[tmp >> 10] + $e0eed84d5498f6e4$var$lookup[tmp >> 4 & 0x3F] + $e0eed84d5498f6e4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8ad9a3380a876530$export$aafa59e2e03f2942;
var $8ad9a3380a876530$export$68d8715fc104d294;
$8ad9a3380a876530$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8ad9a3380a876530$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $136d40cdb268fe10$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$136d40cdb268fe10$export$a143d493d941bafc = $136d40cdb268fe10$var$Buffer;
$136d40cdb268fe10$export$e4cf37d7f6fb9e0a = $136d40cdb268fe10$var$SlowBuffer;
$136d40cdb268fe10$export$f99ded8fe4b79145 = 50;
const $136d40cdb268fe10$var$K_MAX_LENGTH = 0x7fffffff;
$136d40cdb268fe10$export$599f31c3813fae4d = $136d40cdb268fe10$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $136d40cdb268fe10$var$Buffer.TYPED_ARRAY_SUPPORT = $136d40cdb268fe10$var$typedArraySupport();
if (!$136d40cdb268fe10$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $136d40cdb268fe10$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($136d40cdb268fe10$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$136d40cdb268fe10$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($136d40cdb268fe10$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$136d40cdb268fe10$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $136d40cdb268fe10$var$createBuffer(length) {
    if (length > $136d40cdb268fe10$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $136d40cdb268fe10$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $136d40cdb268fe10$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $136d40cdb268fe10$var$allocUnsafe(arg);
    }
    return $136d40cdb268fe10$var$from(arg, encodingOrOffset, length);
}
$136d40cdb268fe10$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $136d40cdb268fe10$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $136d40cdb268fe10$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $136d40cdb268fe10$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($136d40cdb268fe10$var$isInstance(value, ArrayBuffer) || value && $136d40cdb268fe10$var$isInstance(value.buffer, ArrayBuffer)) return $136d40cdb268fe10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($136d40cdb268fe10$var$isInstance(value, SharedArrayBuffer) || value && $136d40cdb268fe10$var$isInstance(value.buffer, SharedArrayBuffer))) return $136d40cdb268fe10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $136d40cdb268fe10$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $136d40cdb268fe10$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $136d40cdb268fe10$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $136d40cdb268fe10$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $136d40cdb268fe10$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($136d40cdb268fe10$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($136d40cdb268fe10$var$Buffer, Uint8Array);
function $136d40cdb268fe10$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $136d40cdb268fe10$var$alloc(size, fill, encoding) {
    $136d40cdb268fe10$var$assertSize(size);
    if (size <= 0) return $136d40cdb268fe10$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $136d40cdb268fe10$var$createBuffer(size).fill(fill, encoding) : $136d40cdb268fe10$var$createBuffer(size).fill(fill);
    return $136d40cdb268fe10$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $136d40cdb268fe10$var$Buffer.alloc = function(size, fill, encoding) {
    return $136d40cdb268fe10$var$alloc(size, fill, encoding);
};
function $136d40cdb268fe10$var$allocUnsafe(size) {
    $136d40cdb268fe10$var$assertSize(size);
    return $136d40cdb268fe10$var$createBuffer(size < 0 ? 0 : $136d40cdb268fe10$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $136d40cdb268fe10$var$Buffer.allocUnsafe = function(size) {
    return $136d40cdb268fe10$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $136d40cdb268fe10$var$Buffer.allocUnsafeSlow = function(size) {
    return $136d40cdb268fe10$var$allocUnsafe(size);
};
function $136d40cdb268fe10$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$136d40cdb268fe10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $136d40cdb268fe10$var$byteLength(string, encoding) | 0;
    let buf = $136d40cdb268fe10$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $136d40cdb268fe10$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $136d40cdb268fe10$var$checked(array.length) | 0;
    const buf = $136d40cdb268fe10$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $136d40cdb268fe10$var$fromArrayView(arrayView) {
    if ($136d40cdb268fe10$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $136d40cdb268fe10$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $136d40cdb268fe10$var$fromArrayLike(arrayView);
}
function $136d40cdb268fe10$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $136d40cdb268fe10$var$Buffer.prototype);
    return buf;
}
function $136d40cdb268fe10$var$fromObject(obj) {
    if ($136d40cdb268fe10$var$Buffer.isBuffer(obj)) {
        const len = $136d40cdb268fe10$var$checked(obj.length) | 0;
        const buf = $136d40cdb268fe10$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $136d40cdb268fe10$var$numberIsNaN(obj.length)) return $136d40cdb268fe10$var$createBuffer(0);
        return $136d40cdb268fe10$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $136d40cdb268fe10$var$fromArrayLike(obj.data);
}
function $136d40cdb268fe10$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $136d40cdb268fe10$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $136d40cdb268fe10$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $136d40cdb268fe10$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $136d40cdb268fe10$var$Buffer.alloc(+length);
}
$136d40cdb268fe10$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $136d40cdb268fe10$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$136d40cdb268fe10$var$Buffer.compare = function compare(a, b) {
    if ($136d40cdb268fe10$var$isInstance(a, Uint8Array)) a = $136d40cdb268fe10$var$Buffer.from(a, a.offset, a.byteLength);
    if ($136d40cdb268fe10$var$isInstance(b, Uint8Array)) b = $136d40cdb268fe10$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(a) || !$136d40cdb268fe10$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$136d40cdb268fe10$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$136d40cdb268fe10$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $136d40cdb268fe10$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $136d40cdb268fe10$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($136d40cdb268fe10$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) buf = $136d40cdb268fe10$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $136d40cdb268fe10$var$byteLength(string, encoding) {
    if ($136d40cdb268fe10$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $136d40cdb268fe10$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $136d40cdb268fe10$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $136d40cdb268fe10$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$136d40cdb268fe10$var$Buffer.byteLength = $136d40cdb268fe10$var$byteLength;
function $136d40cdb268fe10$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $136d40cdb268fe10$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8Slice(this, start, end);
        case 'ascii':
            return $136d40cdb268fe10$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $136d40cdb268fe10$var$latin1Slice(this, start, end);
        case 'base64':
            return $136d40cdb268fe10$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $136d40cdb268fe10$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$136d40cdb268fe10$var$Buffer.prototype._isBuffer = true;
function $136d40cdb268fe10$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$136d40cdb268fe10$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$136d40cdb268fe10$var$swap(this, i, i + 1);
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $136d40cdb268fe10$var$swap(this, i, i + 3);
        $136d40cdb268fe10$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $136d40cdb268fe10$var$swap(this, i, i + 7);
        $136d40cdb268fe10$var$swap(this, i + 1, i + 6);
        $136d40cdb268fe10$var$swap(this, i + 2, i + 5);
        $136d40cdb268fe10$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $136d40cdb268fe10$var$utf8Slice(this, 0, length);
    return $136d40cdb268fe10$var$slowToString.apply(this, arguments);
};
$136d40cdb268fe10$var$Buffer.prototype.toLocaleString = $136d40cdb268fe10$var$Buffer.prototype.toString;
$136d40cdb268fe10$var$Buffer.prototype.equals = function equals(b) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $136d40cdb268fe10$var$Buffer.compare(this, b) === 0;
};
$136d40cdb268fe10$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $136d40cdb268fe10$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($136d40cdb268fe10$var$customInspectSymbol) $136d40cdb268fe10$var$Buffer.prototype[$136d40cdb268fe10$var$customInspectSymbol] = $136d40cdb268fe10$var$Buffer.prototype.inspect;
$136d40cdb268fe10$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($136d40cdb268fe10$var$isInstance(target, Uint8Array)) target = $136d40cdb268fe10$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $136d40cdb268fe10$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($136d40cdb268fe10$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $136d40cdb268fe10$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($136d40cdb268fe10$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $136d40cdb268fe10$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $136d40cdb268fe10$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $136d40cdb268fe10$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$136d40cdb268fe10$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$136d40cdb268fe10$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $136d40cdb268fe10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$136d40cdb268fe10$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $136d40cdb268fe10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $136d40cdb268fe10$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($136d40cdb268fe10$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $136d40cdb268fe10$var$utf8Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $136d40cdb268fe10$var$asciiWrite(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$asciiToBytes(string), buf, offset, length);
}
function $136d40cdb268fe10$var$base64Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$base64ToBytes(string), buf, offset, length);
}
function $136d40cdb268fe10$var$ucs2Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$136d40cdb268fe10$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $136d40cdb268fe10$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $136d40cdb268fe10$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $136d40cdb268fe10$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $136d40cdb268fe10$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$136d40cdb268fe10$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $136d40cdb268fe10$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e0eed84d5498f6e4$export$6100ba28696e12de(buf);
    else return $e0eed84d5498f6e4$export$6100ba28696e12de(buf.slice(start, end));
}
function $136d40cdb268fe10$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $136d40cdb268fe10$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $136d40cdb268fe10$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $136d40cdb268fe10$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $136d40cdb268fe10$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $136d40cdb268fe10$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $136d40cdb268fe10$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $136d40cdb268fe10$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$136d40cdb268fe10$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $136d40cdb268fe10$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $136d40cdb268fe10$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$136d40cdb268fe10$var$Buffer.prototype.readUintLE = $136d40cdb268fe10$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readUintBE = $136d40cdb268fe10$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint8 = $136d40cdb268fe10$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$136d40cdb268fe10$var$Buffer.prototype.readUint16LE = $136d40cdb268fe10$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint16BE = $136d40cdb268fe10$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$136d40cdb268fe10$var$Buffer.prototype.readUint32LE = $136d40cdb268fe10$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint32BE = $136d40cdb268fe10$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$136d40cdb268fe10$var$Buffer.prototype.readBigUInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$136d40cdb268fe10$var$Buffer.prototype.readBigUInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$136d40cdb268fe10$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$136d40cdb268fe10$var$Buffer.prototype.readBigInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$136d40cdb268fe10$var$Buffer.prototype.readBigInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$136d40cdb268fe10$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$136d40cdb268fe10$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$136d40cdb268fe10$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 8, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$136d40cdb268fe10$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 8, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $136d40cdb268fe10$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$136d40cdb268fe10$var$Buffer.prototype.writeUintLE = $136d40cdb268fe10$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUintBE = $136d40cdb268fe10$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint8 = $136d40cdb268fe10$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint16LE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint16BE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint32LE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint32BE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $136d40cdb268fe10$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $136d40cdb268fe10$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$136d40cdb268fe10$var$Buffer.prototype.writeBigUInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeBigUInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeBigInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeBigInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $136d40cdb268fe10$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8ad9a3380a876530$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$136d40cdb268fe10$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeFloat(this, value, offset, true, noAssert);
};
$136d40cdb268fe10$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeFloat(this, value, offset, false, noAssert);
};
function $136d40cdb268fe10$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8ad9a3380a876530$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$136d40cdb268fe10$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeDouble(this, value, offset, true, noAssert);
};
$136d40cdb268fe10$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$136d40cdb268fe10$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$136d40cdb268fe10$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$136d40cdb268fe10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $136d40cdb268fe10$var$Buffer.isBuffer(val) ? val : $136d40cdb268fe10$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $136d40cdb268fe10$var$errors = {};
function $136d40cdb268fe10$var$E(sym, getMessage, Base) {
    $136d40cdb268fe10$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$136d40cdb268fe10$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$136d40cdb268fe10$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$136d40cdb268fe10$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $136d40cdb268fe10$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $136d40cdb268fe10$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $136d40cdb268fe10$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $136d40cdb268fe10$var$checkBounds(buf, offset, byteLength) {
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $136d40cdb268fe10$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $136d40cdb268fe10$var$checkBounds(buf, offset, byteLength);
}
function $136d40cdb268fe10$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $136d40cdb268fe10$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $136d40cdb268fe10$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $136d40cdb268fe10$var$validateNumber(value, type);
        throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $136d40cdb268fe10$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $136d40cdb268fe10$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $136d40cdb268fe10$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($136d40cdb268fe10$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $136d40cdb268fe10$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $136d40cdb268fe10$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $136d40cdb268fe10$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $136d40cdb268fe10$var$base64ToBytes(str) {
    return $e0eed84d5498f6e4$export$d622b2ad8d90c771($136d40cdb268fe10$var$base64clean(str));
}
function $136d40cdb268fe10$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $136d40cdb268fe10$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $136d40cdb268fe10$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $136d40cdb268fe10$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $136d40cdb268fe10$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $136d40cdb268fe10$var$BufferBigIntNotDefined : fn;
}
function $136d40cdb268fe10$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $ddff9b86434e3f59$require$Buffer = $136d40cdb268fe10$export$a143d493d941bafc;
const $ddff9b86434e3f59$var$index = '';
const $ddff9b86434e3f59$export$1ec1d45228a8d241 = [
    "primary",
    "secondary",
    "sparkle",
    "theme",
    "mode",
    "surface",
    "scale",
    "emphasis",
    "appearance",
    "strokeSurface",
    "accent"
];
let $ddff9b86434e3f59$var$defaultTokenValues = {
    theme: "MyJio",
    mode: "light",
    scale: 25,
    density: "default",
    lang: "en",
    platform: "mobile",
    appearance: "neutral",
    surface: "default"
};
function $ddff9b86434e3f59$export$d239735146a56826(value) {
    $ddff9b86434e3f59$var$defaultTokenValues = {
        ...$ddff9b86434e3f59$var$defaultTokenValues,
        ...value,
        ...(0, $5bc9639ae0326803$export$e330aa996edc4437)(value.theme || $ddff9b86434e3f59$var$defaultTokenValues.theme)
    };
}
function $ddff9b86434e3f59$export$dfce236e857ed8b0() {
    return {
        ...$ddff9b86434e3f59$var$defaultTokenValues,
        ...(0, $5bc9639ae0326803$export$e330aa996edc4437)($ddff9b86434e3f59$var$defaultTokenValues.theme)
    };
}
const $ddff9b86434e3f59$var$EVENTS_MAP = {
    onClick: "onClick",
    onFocus: "onFocus",
    onBlur: "onBlur",
    onHover: "onMouseEnter",
    onChange: "onChange",
    onHoverEnd: "onMouseLeave",
    onKeydown: "onKeyDown",
    onKeyup: "onKeyUp",
    onInvalid: "onInvalid",
    onLoad: "onLoad",
    onError: "onError",
    onPaste: "onPaste",
    onScroll: "onScroll",
    onSwipeLeft: [
        "onPointerDown",
        "onPointerMove",
        "onPointerUp",
        "onPointerOut",
        "onDragStart",
        "onDragEnd"
    ]
};
const $ddff9b86434e3f59$var$filterInvalidValue = (v)=>{
    if (typeof v === "undefined") return false;
    if (v === "") return false;
    if (v === null) return false;
    return true;
};
function $ddff9b86434e3f59$var$getEventName(key) {
    const match = Object.keys($ddff9b86434e3f59$var$EVENTS_MAP).find((evt)=>key === evt);
    const matchedEvent = $ddff9b86434e3f59$var$EVENTS_MAP[match];
    return matchedEvent;
}
const $ddff9b86434e3f59$var$internalLayerPrefixes = [
    "jds",
    "tooltip"
];
const $ddff9b86434e3f59$var$processConfigAPI = (config, values, layerProps)=>{
    if (!values) return {};
    const finalData = {};
    Object.entries(config || {}).forEach(([name, item])=>{
        const resolvedConfigValues = item.values || [];
        if (!layerProps?.[name]) {
            if (!resolvedConfigValues.includes(values[name])) {
                if ($ddff9b86434e3f59$var$filterInvalidValue(resolvedConfigValues[0])) finalData[name] = resolvedConfigValues[0];
            } else if ($ddff9b86434e3f59$var$filterInvalidValue(values[name])) finalData[name] = values[name];
        }
    });
    return finalData;
};
const $ddff9b86434e3f59$var$acceptedInternalProps = [
    "internalIndex",
    "layerRefs",
    "className",
    "internalClasses",
    "tabIndex",
    "slideIndex"
];
const $ddff9b86434e3f59$var$processDataAPI = (api, currentLayer, values)=>{
    if (!currentLayer) return {};
    const processData = {};
    const processChildren = {};
    const processedEvents = {};
    let processedA11y = {};
    const { data: data = {}, events: events, children: children = {} } = api;
    if (children[currentLayer]) processChildren[currentLayer] = values[children[currentLayer].name];
    const currentDataItem = data[currentLayer];
    Object.entries(currentDataItem || {}).forEach(([name, { name: propName = "" }])=>{
        const currentName = propName.slice(propName.lastIndexOf(".") + 1, propName.length);
        const value = (0, $a996a90891ec663e$export$3988ae62b71be9a3)(values, propName, void 0) || (0, $a996a90891ec663e$export$3988ae62b71be9a3)(values, currentName, void 0);
        if (typeof value !== "undefined") processData[name] = value;
    });
    if (events) {
        const currentEventItem = events[currentLayer];
        if (currentEventItem) Object.entries(currentEventItem).forEach(([internalName, valueName])=>{
            const eventMapItem = $ddff9b86434e3f59$var$getEventName(internalName);
            const resolvedName = typeof valueName === "string" ? valueName : valueName.name;
            if (!Array.isArray(eventMapItem)) {
                const baseLayer = $ddff9b86434e3f59$var$getBaseLayerName(currentLayer);
                const key = baseLayer.startsWith("jds_") ? internalName : eventMapItem;
                if (!key) return;
                processedEvents[key] = values[resolvedName] || values[eventMapItem];
            } else {
                eventMapItem.forEach((item)=>{
                    if (item) processedEvents[item] = values[item];
                });
                if (internalName) processedEvents[internalName] = values[resolvedName];
            }
        });
    }
    if (api.a11y) processedA11y = $ddff9b86434e3f59$var$processA11yData(api.a11y, currentLayer, values);
    $ddff9b86434e3f59$var$acceptedInternalProps.map((item)=>{
        if (item in values) processData[item] = values[item];
    });
    return {
        processData: processData,
        processedEvents: processedEvents,
        processedA11y: processedA11y,
        processedChildren: processChildren
    };
};
const $ddff9b86434e3f59$var$processA11yData = (data, layer, api)=>{
    if (!data[layer]) return {};
    const { properties: properties } = data[layer];
    if (!properties) return {};
    const processed = {};
    Object.entries(properties).forEach(([internalProperty, property])=>{
        if (typeof property === "string") {
            const normalisedProperty = property.slice(property.lastIndexOf(".") + 1, property.length);
            processed[internalProperty] = api[normalisedProperty];
        } else {
            const { name: name, value: value, prop: prop } = property;
            const normalisedName = name?.slice(name.lastIndexOf(".") + 1, name.length);
            const defaultValue = api[prop || ""] || value;
            processed[internalProperty] = api[normalisedName] || defaultValue;
        }
    });
    return processed;
};
const $ddff9b86434e3f59$var$validateProp = (prop)=>{
    if (typeof prop === "undefined") return false;
    if (prop === null) return false;
    if (prop === "") return false;
    return true;
};
const $ddff9b86434e3f59$var$mergeStyleProperties = (props, uiTokens, data, layerProps)=>{
    const modifiedStyles = (0, $a996a90891ec663e$export$629a2bd3f5a49ecc)(uiTokens);
    Object.entries(data || {}).forEach(([layer, properties])=>{
        Object.entries(properties).forEach(([internalName, { name: name }])=>{
            modifiedStyles[layer] = modifiedStyles[layer] || {};
            if ($ddff9b86434e3f59$var$validateProp(props[name])) {
                if (name in (0, $5a49bb477e7b5f89$export$95994f4e1548c018)) {
                    if (!layerProps[layer] || !(name in layerProps[layer]) || $ddff9b86434e3f59$export$1ec1d45228a8d241.includes(name)) modifiedStyles[layer][name] = props[name];
                    else delete modifiedStyles[layer][name];
                } else delete modifiedStyles[layer][name];
                if (internalName in (0, $5a49bb477e7b5f89$export$95994f4e1548c018)) {
                    if (!layerProps[layer] || !(internalName in layerProps[layer])) modifiedStyles[layer][internalName] = props[name];
                    else delete modifiedStyles[layer][internalName];
                } else delete modifiedStyles[layer][internalName];
            }
        });
    });
    return modifiedStyles;
};
const $ddff9b86434e3f59$var$allowedLayerProps = [
    "disabled",
    "transition"
];
const $ddff9b86434e3f59$var$seperateComponentLayerProps = (styles = {}, props)=>{
    const layerProps = {};
    Object.entries(styles).forEach(([currentlayer, currentStyles])=>{
        const layerElements = currentlayer.split("-");
        const layerName = layerElements[layerElements.length - 1];
        if (!layerProps[currentlayer]) layerProps[currentlayer] = {};
        const isInternalLayer = $ddff9b86434e3f59$var$internalLayerPrefixes.find((i)=>layerName.startsWith(i));
        if (isInternalLayer) Object.entries(currentStyles || {}).forEach(([property, value])=>{
            layerProps[currentlayer][property] = value;
        });
        if (styles.value) layerProps[currentlayer].value = currentStyles.value;
        Object.entries(currentStyles).forEach(([property, value])=>{
            if (!(property in (0, $5a49bb477e7b5f89$export$95994f4e1548c018))) {
                if (!(currentlayer in layerProps)) layerProps[currentlayer] = {};
                layerProps[currentlayer][property] = value;
            } else if ($ddff9b86434e3f59$var$allowedLayerProps.includes(property)) layerProps[currentlayer][property] = value;
        });
    });
    return {
        layerProps: layerProps,
        styles: styles
    };
};
const $ddff9b86434e3f59$var$BufferConverter = (value)=>{
    return $ddff9b86434e3f59$require$Buffer.from(value, "base64").toString("utf-8");
};
const $ddff9b86434e3f59$var$convertBase64ToObject = (value)=>{
    if (!value) return {};
    const converter = typeof window === "undefined" ? $ddff9b86434e3f59$var$BufferConverter : window.atob;
    const objectString = converter(value);
    return JSON.parse(objectString || "{}");
};
const $ddff9b86434e3f59$var$classNames = (...classes)=>classes.filter(Boolean).join(" ");
const $ddff9b86434e3f59$export$d72eddc0980b68c9 = (custom)=>{
    const base64 = custom.includes("--") ? (custom?.split("--") || [])[1] : custom;
    const convertedCustom = $ddff9b86434e3f59$var$convertBase64ToObject(base64);
    return convertedCustom;
};
const $ddff9b86434e3f59$var$getBaseLayerName = (layer = "")=>{
    const parts = layer.split("-");
    return parts[parts.length - 1];
};
const $ddff9b86434e3f59$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(value, max));
const $ddff9b86434e3f59$export$9382739d0e79620f = (props)=>{
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        style: props.style,
        className: $ddff9b86434e3f59$var$classNames(props.className, "progress-animateContainer")
    });
};
function $ddff9b86434e3f59$var$polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}
function $ddff9b86434e3f59$var$describeArc(x, y, radius, startAngle, endAngle) {
    const start = $ddff9b86434e3f59$var$polarToCartesian(x, y, radius, endAngle);
    const end = $ddff9b86434e3f59$var$polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    const d = [
        "M",
        start.x,
        start.y,
        "A",
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
    ].join(" ");
    return d;
}
function $ddff9b86434e3f59$var$getColorVariable(val, tokens = {}) {
    if (typeof val === "string") {
        if (val.match(/[{}]/)) {
            if (val.includes("&")) tokens = (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).updateFlatTokens({
                ...tokens,
                surface: val.split("_")[2].replace("}", "")
            });
            return (0, $5a49bb477e7b5f89$export$6a176e754d54672)("color", val, tokens);
        }
    }
    return val.toString();
}
function $ddff9b86434e3f59$var$getValue(val, rule, tokens = {}) {
    if (typeof val === "string") {
        if (val.match(/[{}]/)) return (0, $5a49bb477e7b5f89$export$6a176e754d54672)(rule, val, tokens);
    }
    return (0, $5a49bb477e7b5f89$export$95c38a73fd251991)(rule, val);
}
const $ddff9b86434e3f59$export$6ef80ffb606dd232 = ({ radius: radius = 0, start: start = 0, end: end = 0, fill: fill, className: className, arcWidth: arcWidth = 10, "animation-delay": animationDelay = "0ms", layer: layer, animate: animate, ...rest })=>{
    start = parseInt($ddff9b86434e3f59$var$getValue(start, "rotate"), 10);
    end = parseInt($ddff9b86434e3f59$var$getValue(end, "rotate"), 10);
    radius = parseInt($ddff9b86434e3f59$var$getValue(radius, "width"), 10);
    arcWidth = parseInt($ddff9b86434e3f59$var$getValue(arcWidth, "width"), 10);
    animationDelay = $ddff9b86434e3f59$var$getValue(animationDelay, "transition-delay");
    animationDelay = animationDelay.includes("ms") ? animationDelay : animationDelay + "ms";
    const strokeWidth = end - start === 0 ? 0 : arcWidth / 2;
    const diameter = radius * 2;
    const halfRadius = radius / 2;
    const circumference = 2 * Math.PI * halfRadius;
    const percent = end / 360 * 100;
    const dash = percent * circumference / 100;
    const midRadius = radius + strokeWidth;
    const durationKey = Object.keys(rest.style || {}).find((key)=>key.endsWith("transition-duration"));
    const variables = {
        "--diameter": diameter,
        "--rotate": `-${end}deg`,
        "--fill-color": $ddff9b86434e3f59$var$getColorVariable(fill || "currentcolor", $ddff9b86434e3f59$export$f34d637a75323a1e()),
        "--animation-delay": animationDelay,
        "--animation-duration": rest.style?.[durationKey] || (rest["animation-duration"] || 2.5) + "s",
        "--offset": animate ? "100px" : `${dash}px ${circumference - dash}px`,
        "--end": end * Math.PI / 180,
        "--start": start * Math.PI / 180,
        "--start-anim-offset": `${circumference}px`,
        "--end-anim-offset": `-${circumference}px`
    };
    const animateClass = animate ? "jds-spinner-circle-animate" : "";
    const arc = (0, $1OEoy.useMemo)(()=>{
        return $ddff9b86434e3f59$var$describeArc(midRadius / 2, midRadius / 2, radius / 2, start, end);
    }, [
        start,
        end,
        midRadius
    ]);
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: $ddff9b86434e3f59$var$classNames(className, animateClass),
        style: {
            width: diameter,
            height: diameter,
            ...variables
        },
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
            className: $ddff9b86434e3f59$var$classNames("jds-spinner-circle", `circle-${layer}`, animate ? "animate" : ""),
            viewBox: `0 0 ${radius + arcWidth / 2} ${radius + arcWidth / 2}`,
            children: Math.abs(end - start) === 360 || animate ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("circle", {
                fill: "none",
                stroke: variables["--fill-color"],
                r: halfRadius,
                cx: midRadius / 2,
                cy: midRadius / 2,
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            }) : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: arc,
                strokeLinecap: "round",
                className: $ddff9b86434e3f59$var$classNames(animate ? "animated" : ""),
                strokeWidth: strokeWidth,
                stroke: variables["--fill-color"],
                fill: "none",
                "data-dimension": `${end}-${start}-${end - start}`
            })
        })
    });
};
const $ddff9b86434e3f59$var$unsafeProps = [
    "height",
    "padding",
    "opacity",
    "translate-y",
    "translate-x",
    "max-height"
];
const $ddff9b86434e3f59$export$31627395a3b18e54 = (props)=>{
    const [internalHidden, setInternalHidden] = (0, $1OEoy.useState)(!props.animatedProperties?.length);
    (0, $1OEoy.useEffect)(()=>{
        if (!props.hidden) setInternalHidden(false);
    }, [
        props.hidden
    ]);
    const hasProperties = $ddff9b86434e3f59$var$unsafeProps.some((property)=>props.animatedProperties?.includes(property));
    if (props.hidden) {
        if (!props.animatedProperties?.length) return null;
        if (!internalHidden) {
            if (!hasProperties) return null;
            return props.children || null;
        }
        if (hasProperties) return props.children;
        return null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).cloneElement(props.children || /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $7a9adcfb845e594f$exports.Fragment), {}), {
        onTransitionEnd: (ev)=>{
            if (props.hidden) setInternalHidden(true);
        }
    });
};
const $ddff9b86434e3f59$var$registeredIcons = {
    ...$8266fa2b825a51ed$exports
};
const $ddff9b86434e3f59$export$99b432e1290ef823 = (icons)=>{
    Object.assign($ddff9b86434e3f59$var$registeredIcons, icons);
};
const $ddff9b86434e3f59$export$d824b604106683ab = (icons)=>Object.keys(icons).filter((icon)=>typeof icons[icon] === "function");
const $ddff9b86434e3f59$export$75b0b37acc90e887 = (ic)=>{
    if (typeof ic === "string") {
        const NewIcon = $ddff9b86434e3f59$var$registeredIcons[ic];
        if (!NewIcon) return null;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(NewIcon, {});
    }
    return ic;
};
const $ddff9b86434e3f59$export$f04a61298a47a40f = ({ value: value, events: events, style: style, layer: layer, className: className, role: role, _isLottieVisible: _isLottieVisible, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, ...rest })=>{
    const stringIcon = typeof value === "string";
    const camelCaseIcon = !stringIcon ? value : (0, $a996a90891ec663e$export$26c6f48841fe1a8a)(value || "", "_");
    const icon = $ddff9b86434e3f59$export$75b0b37acc90e887(camelCaseIcon);
    if (!value) return null;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$31627395a3b18e54, {
        hidden: [
            true,
            "true"
        ].includes(rest.hidden),
        animatedProperties: rest.transition?.property,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).isValidElement(icon) && (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).cloneElement(icon, {
            "data-testid": rest?.["data-testid"] || "icon-root",
            className: $ddff9b86434e3f59$var$classNames("icon-atom", className),
            ...events,
            style: style,
            "data-iconname": stringIcon ? value?.toLowerCase() : void 0,
            "data-hidden": rest.hidden,
            "data-transition": Boolean(rest.transition),
            role: role,
            "aria-label": ariaLabel,
            "aria-describedby": ariaDescribedby
        })
    });
};
const $ddff9b86434e3f59$export$f5b8910cec6cf069 = (props)=>{
    const { disabled: disabled, className: className, children: children, type: type = "text", internalIndex: internalIndex, root: root, rootRef: rootRef, textAlign: textAlign, events: events = {}, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, "aria-invalid": ariaInvalid, "aria-required": _ariaRequired, "aria-placeholder": _ariaPlaceholder, _childrenProps: _childrenProps, processedA11y: processedA11y, textSize: textSize, layerRefs: layerRefs, isContainerFocusable: isContainerFocusable, componentTag: componentTag, ...rest } = props;
    const combinedStyles = {
        ...rest?.style,
        textAlign: textAlign
    };
    const commonProps = {
        ...events,
        ...rest,
        style: combinedStyles,
        disabled: disabled,
        maxLength: rest["max-length"],
        value: rest.value
    };
    switch(type.toLowerCase()){
        case "textarea":
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "text-area-wrapper",
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("textarea", {
                    ref: layerRefs?.[rest.layer],
                    ...commonProps,
                    className: $ddff9b86434e3f59$var$classNames("jds-input-atom", className, "jds-textarea-atom"),
                    "aria-label": ariaLabel,
                    "aria-describedby": ariaDescribedby,
                    "aria-invalid": ariaInvalid,
                    "aria-required": _ariaRequired,
                    "aria-placeholder": _ariaPlaceholder
                })
            });
        case "phone":
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                ...commonProps,
                value: commonProps.value ? String(commonProps.value).slice(0, commonProps["max-length"]) : props.value,
                maxLength: void 0,
                ref: layerRefs?.[rest.layer],
                type: "tel",
                className: $ddff9b86434e3f59$var$classNames("jds-input-atom", className)
            });
        default:
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                ...commonProps,
                value: commonProps.value ? String(commonProps.value).slice(0, commonProps["max-length"]) : props.value,
                maxLength: void 0,
                type: type,
                ref: layerRefs?.[rest.layer],
                className: $ddff9b86434e3f59$var$classNames("jds-input-atom", className),
                "aria-label": ariaLabel,
                "aria-describedby": ariaDescribedby,
                "aria-invalid": ariaInvalid,
                "aria-required": _ariaRequired,
                "aria-placeholder": _ariaPlaceholder
            });
    }
};
const $ddff9b86434e3f59$export$3b0d6d7590275603 = (props)=>{
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        "data-testid": "loader-root",
        ...props,
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$var$Spinner, {})
    });
};
const $ddff9b86434e3f59$var$Spinner = ()=>{
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
        className: "j-spinner",
        children: [
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
                className: "circle circle-0",
                viewBox: "0 0 28 28",
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("circle", {
                    "data-testid": "spinner-circle-icon",
                    fill: "none",
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    cx: "14",
                    cy: "14",
                    r: "12"
                })
            }),
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
                className: "circle circle-1",
                viewBox: "0 0 28 28",
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("circle", {
                    "data-testid": "spinner-circle-icon",
                    fill: "none",
                    strokeWidth: "4",
                    strokeLinecap: "round",
                    cx: "14",
                    cy: "14",
                    r: "12"
                })
            })
        ]
    });
};
const $ddff9b86434e3f59$var$WINDOW = typeof window === "object" && window || void 0;
const $ddff9b86434e3f59$var$defaultBreakpoints = {
    xmobile: 323,
    mobile: 619,
    tablet: 991,
    desktop: 992,
    widescreen: 1280,
    hd: 1920
};
class $ddff9b86434e3f59$var$Devices {
    static withSizes(breakpoints) {
        this.breakpoints = Object.assign(this.breakpoints, breakpoints);
        return this;
    }
    /**
   * is width xmobile and below
   */ static isXMobile() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.xmobile;
    }
    /**
   * is width mobile and below. returns true even on xmobile
   */ static isMobile() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.mobile;
    }
    /**
   * is width above mobile and below desktop
   */ static isTabletOnly() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
    }
    /**
   * is width less than tablet? returns true even on mobile and xmobile
   */ static isTablet() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet;
    }
    /**
   * is width greater than tablet?
   */ static isDesktop() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 1e3;
        return width >= this.breakpoints.tablet;
    }
    /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */ static isWidescreen() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.widescreen;
    }
    /**
   * is width greater than or equal to HD.
   */ static isHD() {
        const width = $ddff9b86434e3f59$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.hd;
    }
    /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */ static useMedia() {
        const queries = [
            `(max-width: ${this.breakpoints.xmobile}px)`,
            `(max-width: ${this.breakpoints.mobile}px)`,
            `(max-width: ${this.breakpoints.tablet}px)`,
            `(min-width: ${this.breakpoints.desktop}px)`,
            `(min-width: ${this.breakpoints.widescreen}px)`,
            `(min-width: ${this.breakpoints.hd}px)`
        ];
        const mediaQueryLists = queries.map((q)=>$ddff9b86434e3f59$var$WINDOW?.matchMedia && $ddff9b86434e3f59$var$WINDOW.matchMedia(q));
        const getValue = ()=>{
            const matchedResults = mediaQueryLists.map((mql)=>mql?.matches);
            const valObj = {
                xmobile: false,
                mobile: false,
                tablet: false,
                desktop: false,
                widescreen: false,
                hd: false
            };
            Object.keys(this.breakpoints).forEach((key, i)=>{
                valObj[key] = matchedResults[i];
            });
            return valObj;
        };
        const [value, setValue] = (0, $1OEoy.useState)(getValue);
        (0, $1OEoy.useEffect)(()=>{
            const handler = ()=>setValue(getValue);
            mediaQueryLists.forEach((mql)=>mql?.addListener(handler));
            return ()=>mediaQueryLists.forEach((mql)=>mql?.removeListener(handler));
        }, []);
        return value;
    }
}
$ddff9b86434e3f59$var$Devices.breakpoints = $ddff9b86434e3f59$var$defaultBreakpoints;
const $ddff9b86434e3f59$var$layersWithStyleAttr = [
    "button",
    "div"
];
const $ddff9b86434e3f59$var$filterUniqueTokens = (newTokens, existingTokens)=>{
    if (newTokens._source === "popup") return newTokens;
    return (0, $a996a90891ec663e$export$b460b275d6c6aa0)(newTokens, (value, key)=>!(key in existingTokens) || existingTokens[key] !== value);
};
const $ddff9b86434e3f59$var$resolvePlatform = (exisintPlatform)=>{
    const platform = $ddff9b86434e3f59$var$Devices.useMedia();
    if (platform.desktop || platform.widescreen || platform.hd) return "desktop";
    if (platform.tablet) return "tablet";
    return "mobile";
};
const $ddff9b86434e3f59$export$3e90a26ba68b9c65 = (0, $1OEoy.createContext)({});
const $ddff9b86434e3f59$var$registerBrandAndFetchTokenVars = (value, existingTokens, brandTokens)=>{
    const defaultTokenValues = $ddff9b86434e3f59$export$dfce236e857ed8b0();
    const mode = value.mode || existingTokens.mode || defaultTokenValues.mode;
    let tokens$1 = {
        scale: existingTokens.scale || (mode === "dark" ? 2 : 25),
        ...defaultTokenValues,
        ...existingTokens,
        parentAppearance: existingTokens.appearance,
        currentAppearance: value.appearance || "auto",
        surface: value.surface || "ghost",
        ...(0, $5bc9639ae0326803$export$e330aa996edc4437)(value.theme || existingTokens.theme || defaultTokenValues.theme),
        ...Object.fromEntries(Object.entries(value).filter(([_, v])=>v !== "auto"))
    };
    if (!tokens$1._registered || brandTokens) {
        (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).registerBrand(brandTokens || (0, $52d4442770cfd938$export$6ad93df59e712c43));
        tokens$1._registered = true;
    }
    if ((0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).updateFlatTokens) {
        tokens$1 = (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).updateFlatTokens(tokens$1);
        tokens$1.parentScale = existingTokens.scale;
    }
    const equalThemeTokens = $ddff9b86434e3f59$export$1ec1d45228a8d241.every((key)=>existingTokens[key] === value[key]);
    const entries = [];
    if (!(equalThemeTokens && !(value._source === "popup"))) {
        const mergedTokens = {
            ...defaultTokenValues,
            ...(0, $5bc9639ae0326803$export$e330aa996edc4437)(existingTokens.theme || defaultTokenValues.theme),
            ...existingTokens
        };
        const uniqueTokens = $ddff9b86434e3f59$var$filterUniqueTokens(tokens$1, mergedTokens);
        if ((0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).brandResolverFn) {
            if ([
                "density"
            ].some((item)=>uniqueTokens[item])) {
                const densityMap = (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).getDensityMap?.(tokens$1.density ?? "default") ?? {};
                entries.push(...Object.entries(densityMap));
            }
            if ([
                "theme"
            ].some((item)=>uniqueTokens[item])) {
                const colorMap = (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).getColorsMap({
                    primary: tokens$1.primary,
                    secondary: tokens$1.secondary,
                    sparkle: tokens$1.sparkle
                });
                entries.push(...Object.entries(colorMap));
            }
        } else {
            const applicableTokens = (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).getApplicableTokens(uniqueTokens);
            Object.entries(applicableTokens).forEach(([folderKey, folder])=>Object.entries(folder).forEach(([key, value2])=>{
                    entries.push([
                        (0, $5a49bb477e7b5f89$export$585f0f7ef40c9f0)(`${folderKey}-${key}`),
                        (0, $5a49bb477e7b5f89$export$bdcbab1cb38db489)(value2) ? (0, $5a49bb477e7b5f89$export$c59eaf4f26921ab2)(folderKey, value2, tokens$1) : (0, $5a49bb477e7b5f89$export$95c38a73fd251991)(folderKey, value2)
                    ]);
                }));
        }
    }
    const styles = Object.fromEntries(entries);
    return {
        styles: styles,
        tokens: tokens$1
    };
};
const $ddff9b86434e3f59$export$e5cf4eff53e7947d = ({ value: value, children: children, tokens: brandTokens })=>{
    const defaultTokenValues = $ddff9b86434e3f59$export$dfce236e857ed8b0();
    const rootRef = (0, $1OEoy.useRef)();
    const timeoutRef = (0, $1OEoy.useRef)();
    value ??= defaultTokenValues;
    const existingTokens = (0, $1OEoy.useContext)($ddff9b86434e3f59$export$3e90a26ba68b9c65);
    value.platform = $ddff9b86434e3f59$var$resolvePlatform(value.platform || existingTokens.platform);
    const { styles: styles, tokens: tokens } = (0, $1OEoy.useMemo)(()=>$ddff9b86434e3f59$var$registerBrandAndFetchTokenVars(value, existingTokens, brandTokens), [
        value,
        brandTokens
    ]);
    const isRootProvider = !Object.keys(existingTokens).length;
    (0, $1OEoy.useEffect)(()=>{
        function listener() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                const root = rootRef.current;
                if (root) {
                    const { padding: padding } = getComputedStyle(root);
                    const base = parseFloat(padding);
                    root.style.setProperty("--base", base.toString());
                }
            }, 100);
        }
        if (isRootProvider && tokens?.["brandVersion"] === "jio-v2") {
            window.addEventListener("resize", listener);
            listener();
        }
        return ()=>{
            if (isRootProvider && tokens?.["brandVersion"] === "jio-v2") window.removeEventListener("resize", listener);
        };
    }, [
        tokens?.["brandVersion"],
        isRootProvider
    ]);
    if (!("brandVersion" in tokens) || tokens?.["brandVersion"] !== "jio-v2") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        style: {
            ...styles,
            display: "contents"
        },
        className: "tokens",
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$3e90a26ba68b9c65.Provider, {
            value: {
                ...tokens
            },
            children: children
        })
    });
    if (isRootProvider) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: "tokens-provider v3",
        style: {
            display: "contents",
            padding: "var(--pre-base)",
            ...tokens.maxWidth ? {
                "--viewport": tokens.maxWidth / 100 + "px"
            } : {},
            ...styles
        },
        ref: rootRef,
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$3e90a26ba68b9c65.Provider, {
            value: {
                ...tokens
            },
            children: children
        })
    });
    const newChildren = !Object.keys(styles).length ? children : (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).Children.map(children, (child)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).isValidElement(child)) {
            if ($ddff9b86434e3f59$var$layersWithStyleAttr.includes(typeof child.type === "string" ? child.type : child.type.name) && !isRootProvider) return (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).cloneElement(child, {
                ...child.props,
                style: {
                    ...child.props.style,
                    ...styles
                }
            });
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "tokens-provider",
                style: {
                    ...styles,
                    display: "contents"
                },
                children: child
            });
        }
        return child;
    });
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$3e90a26ba68b9c65.Provider, {
        value: {
            ...tokens
        },
        children: newChildren
    });
};
function $ddff9b86434e3f59$export$f34d637a75323a1e() {
    const tokenValues = (0, $1OEoy.useContext)($ddff9b86434e3f59$export$3e90a26ba68b9c65);
    if (tokenValues === void 0) throw new Error("useTokenValues must be used within a TokenProvider");
    return tokenValues;
}
const $ddff9b86434e3f59$export$31dcd79391e423fe = (value, type)=>{
    const tokens = (0, $1OEoy.useContext)($ddff9b86434e3f59$export$3e90a26ba68b9c65);
    if (tokens === void 0) throw new Error("Please wrap your app in a TokenProvider");
    return (0, $5a49bb477e7b5f89$export$6a176e754d54672)(type, value, tokens);
};
function $ddff9b86434e3f59$var$CustomPortal({ children: children }) {
    const [mounted, setMounted] = (0, $1OEoy.useState)(false);
    (0, $1OEoy.useEffect)(()=>{
        setMounted(true);
    }, []);
    return mounted && typeof window !== "undefined" ? (0, $4ed43828a92c8386$exports.createPortal)(children, document.body) : null;
}
const $ddff9b86434e3f59$export$129a32eedafa97c5 = ({ children: children, className: className, style: style, events: events, rootRef: rootRef, layer: layer, ...rest })=>{
    const { alignment: alignment = "top-start", priority: priority } = rest;
    const x = rest.offsetX;
    const y = rest.offsetY;
    const left = alignment.includes("start") && x ? `${x}px` : void 0;
    const right = alignment.includes("end") && x ? `${x}px` : void 0;
    const top = alignment.includes("top") && y ? `${y}px` : void 0;
    const bottom = alignment.includes("bottom") && y ? `${y}px` : void 0;
    const styles = {
        backgroundColor: rest["background-color"],
        pointerEvents: rest.passive ? "none" : "auto",
        "--popup-priority": priority,
        "--popup-left": left,
        "--popup-right": right,
        "--popup-top": top,
        "--popup-bottom": bottom
    };
    const tokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    if (tokens.fromPlugin) return children;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$var$CustomPortal, {
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$e5cf4eff53e7947d, {
            value: {
                ...tokens,
                _source: "popup"
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$31627395a3b18e54, {
                hidden: rest.hidden,
                animatedProperties: rest.transition?.property,
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                    "data-testid": rest?.["data-testid"],
                    ref: rootRef,
                    style: {
                        ...styles,
                        ...style,
                        pointerEvents: !rest.passive ? "auto" : "none",
                        touchAction: events?.onClick || !rest.passive ? "auto" : "none"
                    },
                    className: $ddff9b86434e3f59$var$classNames("jds-popup-layer", className),
                    ...events,
                    onClick: (ev)=>{
                        if (events?.onClick) ev.stopPropagation();
                        events?.onClick?.(ev);
                    },
                    children: children
                })
            })
        })
    });
};
const $ddff9b86434e3f59$export$d50980d2cec56085 = ({ layer: layer, style: style, className: className, ...rest })=>{
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: $ddff9b86434e3f59$var$classNames("skeleton-animate-loader-container", className),
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
            "data-testid": rest["data-testid"],
            style: style
        })
    });
};
const $ddff9b86434e3f59$var$getTokenValue = (type, tokens, value)=>{
    if (!value) return "";
    return (0, $5a49bb477e7b5f89$export$6404fd1becf96b61)(type, value.toString() || "");
};
function $ddff9b86434e3f59$export$1947d5eba3dbedea(value = 0, min = 0, max = 100) {
    const offset = value - min;
    const range = max - min;
    const ratio = offset / range;
    const percentage = (1 - ratio) * 100;
    return Math.round(percentage);
}
function $ddff9b86434e3f59$export$762ec5ce8fb56ed0(value, step = 1, min = 0, max = 100) {
    if (typeof value !== "number") return min;
    step = step > 0 ? step : 1;
    const clamped = $ddff9b86434e3f59$export$7d15b64cf5a3a4c4(value, min, max);
    return Math.round((clamped - min) / step) * step + min;
}
const $ddff9b86434e3f59$export$472062a354075cee = ({ min: min = 0, max: max = 100, "aria-label": ariaLabel, "aria-describedby": ariaDescribedby, "aria-valuenow": _ariaValuenow, "aria-valuemin": _ariaValuemin, "aria-valuemax": _ariaValuemax, ...props })=>{
    const tokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    const ballProperties = {
        "--ball-color": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props["ball-color"]),
        "--ball-color--active": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props?.behavior.active["ball-color-active"]),
        "--ball-color--hover": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props?.behavior.hover["ball-color-active"]),
        "--ball-size": $ddff9b86434e3f59$var$getTokenValue("width", tokens, props["ball-size"]),
        "--ball-border-width": $ddff9b86434e3f59$var$getTokenValue("width", tokens, props["ball-border-width"]),
        "--ball-border-color": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props["ball-border-color"]),
        "--active-color": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props["active-color"]),
        "--active-color--active": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props?.behavior.active["active-color-active"]),
        "--inactive-color": $ddff9b86434e3f59$var$getTokenValue("color", tokens, props["inactive-color"])
    };
    const requiredValue = $ddff9b86434e3f59$export$762ec5ce8fb56ed0(props.value, props.step, min, max) || 0;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("input", {
        type: "range",
        step: props.step,
        value: requiredValue,
        min: min,
        max: max,
        size: 2,
        onChange: props.onChange,
        className: [
            props.className,
            "jds-slider-atom"
        ].join(" "),
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-valuenow": _ariaValuenow,
        "aria-valuemin": _ariaValuemin,
        "aria-valuemax": _ariaValuemax,
        style: {
            ...props.style,
            ...ballProperties,
            height: $ddff9b86434e3f59$var$getTokenValue("height", tokens, props["track-height"]),
            "--progress": `${$ddff9b86434e3f59$export$1947d5eba3dbedea(requiredValue, min, max)}%`
        }
    });
};
const $ddff9b86434e3f59$var$alignClasses = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
    justify: "text-justify"
};
const $ddff9b86434e3f59$var$textAlignmentVariable = "--text-tx-al";
const $ddff9b86434e3f59$export$5f1af8db9871e1d6 = ({ value: value, events: { onTextLayout: onTextLayout, ...restEvents } = {}, className: className, style: style, layer: layer, textType: textType = "div", role: role, "aria-describedby": ariaDescribedby, ...rest })=>{
    if (typeof value === "undefined" || value === "") return null;
    const currentStyle = typeof style === "object" ? {
        ...style
    } : {};
    const Type = textType?.trim() === "" ? "div" : textType;
    const maxLines = Number(rest["max-lines"]) || 0;
    const maxLineClass = maxLines > 0 && "multi-line";
    const align = currentStyle[$ddff9b86434e3f59$var$textAlignmentVariable];
    const alignClass = align ? $ddff9b86434e3f59$var$alignClasses[align] ?? "" : "";
    currentStyle["--max-lines"] = maxLines || void 0;
    if (alignClass) delete currentStyle[$ddff9b86434e3f59$var$textAlignmentVariable];
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$31627395a3b18e54, {
        hidden: [
            "true",
            true
        ].includes(rest.hidden),
        animatedProperties: rest.transition?.property,
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Type, {
            className: $ddff9b86434e3f59$var$classNames("text-atom", className, maxLineClass, alignClass),
            style: currentStyle,
            ...restEvents,
            "data-testid": rest["data-testid"],
            "aria-describedby": ariaDescribedby,
            role: role,
            children: value
        })
    });
};
const $ddff9b86434e3f59$export$379139ebc1c2b235 = (props)=>{
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("textarea", {
        ...props,
        className: "jds-input-textarea-atom"
    });
};
const $ddff9b86434e3f59$var$VerticalTip = (props)=>{
    const { processedA11y: processedA11y, isContainerFocusable: isContainerFocusable, internalIndex: internalIndex, _childrenProps: _childrenProps, svgClassName: svgClassName, ...svgProps } = props;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: props.className,
        style: {
            boxSizing: "content-box",
            background: "transparent"
        },
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
            ...svgProps,
            className: svgClassName,
            width: "8",
            height: "24",
            viewBox: "0 0 8 24",
            fill: props["background-color"],
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                id: "Vector 5",
                d: "M6.87661 14.4244L2.7121 18.1471C0.97557 19.6994 -9.59586e-08 21.8047 0 24L-1.04907e-06 -2.38419e-07C-9.53115e-07 2.19528 0.975566 4.30064 2.71209 5.85293L6.87661 9.57563C8.37446 10.9146 8.37446 13.0854 6.87661 14.4244Z"
            })
        })
    });
};
const $ddff9b86434e3f59$var$HorizontalTip = (props)=>{
    const { processedA11y: processedA11y, isContainerFocusable: isContainerFocusable, internalIndex: internalIndex, _childrenProps: _childrenProps, svgClassName: svgClassName, ...svgProps } = props;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: props.className,
        style: {
            display: "flex",
            flexDirection: "column",
            background: "transparent"
        },
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
            ...svgProps,
            className: svgClassName,
            width: "24",
            height: "8",
            viewBox: "0 0 24 8",
            fill: props["background-color"],
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                id: "Vector 5",
                d: "M14.4244 1.12338L18.1471 5.2879C19.6994 7.02443 21.8047 8 24 8L-2.38419e-07 8C2.19528 8 4.30064 7.02443 5.85294 5.28791L9.57564 1.12339C10.9146 -0.374462 13.0854 -0.374465 14.4244 1.12338Z"
            })
        })
    });
};
const $ddff9b86434e3f59$var$svgDirectionConfig = {
    vertical: $ddff9b86434e3f59$var$VerticalTip,
    horizontal: $ddff9b86434e3f59$var$HorizontalTip
};
const $ddff9b86434e3f59$export$c92c6401b52a9298 = (props)=>{
    const { position: position = "right", className: className } = props;
    const positionPrefix = position.split("_")?.[0].toLowerCase();
    const tipClass = `j_tooltip-tip-${positionPrefix}`;
    const direction = [
        "top",
        "bottom"
    ].includes(positionPrefix) ? "horizontal" : "vertical";
    const Component = $ddff9b86434e3f59$var$svgDirectionConfig[direction];
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
        ...props,
        className: className,
        svgClassName: tipClass
    });
};
const $ddff9b86434e3f59$var$focusableSelectors = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"])',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];
const $ddff9b86434e3f59$var$isVisible = (element)=>{
    return element.offsetWidth || element.offsetHeight || element.getClientRects().length;
};
const $ddff9b86434e3f59$var$getFocusableChildren = (root)=>{
    if (!root) return null;
    const elements = [];
    root.querySelectorAll($ddff9b86434e3f59$var$focusableSelectors.join(",")).forEach((ele)=>elements.push(ele));
    return elements.filter($ddff9b86434e3f59$var$isVisible);
};
const $ddff9b86434e3f59$export$31e8f018cc5f8f35 = (props)=>{
    const ref = (0, $1OEoy.useRef)(null);
    const { trap: trap, children: children, ...rest } = props;
    const [lastFocus, setLastFocus] = (0, $1OEoy.useState)(()=>trap ? document.activeElement : null);
    (0, $1OEoy.useEffect)(()=>{
        return ()=>{
            lastFocus && lastFocus.focus?.();
        };
    }, []);
    const trapTabKey = (element, event)=>{
        const focusableChildren = $ddff9b86434e3f59$var$getFocusableChildren(element);
        if (!focusableChildren) return;
        const focusedItemIndex = document.activeElement ? focusableChildren.indexOf(document.activeElement) : -1;
        const lastIndex = focusableChildren.length - 1;
        const withShift = event.shiftKey;
        if (withShift && focusedItemIndex === 0) {
            focusableChildren?.[lastIndex]?.focus?.();
            event.preventDefault();
        } else if (!withShift && focusedItemIndex === lastIndex) {
            focusableChildren?.[0]?.focus?.();
            event.preventDefault();
        }
    };
    const moveFocusIn = ()=>{
        if (!$ddff9b86434e3f59$var$getFocusableChildren(ref.current)?.includes(document?.activeElement)) {
            const target = ref?.current?.querySelector("[autofocus]") || $ddff9b86434e3f59$var$getFocusableChildren(ref.current)?.[0];
            requestAnimationFrame(()=>{
                target && target?.focus?.();
            });
        }
    };
    (0, $1OEoy.useEffect)(()=>{
        if (trap) {
            setLastFocus(document.activeElement);
            moveFocusIn();
        } else lastFocus && lastFocus.focus?.();
    }, [
        trap
    ]);
    (0, $1OEoy.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (trap) {
                if (event.key === "Tab") trapTabKey(ref?.current, event);
            }
        };
        document.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        ref,
        lastFocus,
        trap
    ]);
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        style: {
            display: "contents"
        },
        ref: ref,
        ...rest,
        children: children
    });
};
$ddff9b86434e3f59$export$31e8f018cc5f8f35.displayName = "TrapFocus";
$ddff9b86434e3f59$export$31e8f018cc5f8f35.defaultProps = {
    trap: false
};
const $ddff9b86434e3f59$var$filterInternalEvents = (events)=>{
    const internalEvents = [
        "onSwipeLeft",
        "onSwipeRight",
        "onSwipeUp",
        "onSwipeDown",
        "onPinch",
        "onRotate",
        "onLongPress",
        "onDoubleTap"
    ];
    const filteredEvents = {};
    Object.entries(events).forEach(([key, handler])=>{
        if (!internalEvents.includes(key)) filteredEvents[key] = handler;
    });
    return filteredEvents;
};
const $ddff9b86434e3f59$var$resolveDisabled = (disabled)=>{
    if (typeof disabled === "object") return false;
    return disabled;
};
const $ddff9b86434e3f59$var$disabledStyles = {
    cursor: "not-allowed",
    pointerEvents: "none",
    userSelect: "none"
};
const $ddff9b86434e3f59$export$42a852a2b6b56249 = (props)=>{
    const { children: children, elementRef: elementRef, events: events = {}, className: className, style: style, disabled: disabled, passive: passive, target: target, href: href, title: title, internalIndex: internalIndex, isContainerFocusable: isContainerFocusable, root: root, rootRef: rootRef, show: show, componentTag: componentTag, ...rest } = props;
    const hasFocus = Boolean(isContainerFocusable && events?.onClick);
    const tokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    const isJioV2 = tokens?.["brandVersion"] === "jio-v2";
    const isButton = className.includes("j-JDSButton-container") || className.includes("j-JDSButton2-container");
    const POINTER_CURSOR_CLASSES = [
        "j-JDSButton-container",
        "j-JDSLink-container",
        "j-JDSActionButton-inner-container",
        "j-JDSTabItem-container"
    ];
    const Element = String(componentTag) === "undefined" && String(props["web-tag"]) === "undefined" ? isButton ? "button" : "div" : props["web-tag"] || componentTag;
    if (!show && (!children || Array.isArray(children) && children.every((c)=>c === null))) return null;
    const resolvedDisabled = $ddff9b86434e3f59$var$resolveDisabled(disabled);
    const shouldHavePointerCursor = POINTER_CURSOR_CLASSES.some((cls)=>className?.includes(cls));
    const filteredEvents = $ddff9b86434e3f59$var$filterInternalEvents(events);
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$31627395a3b18e54, {
        hidden: [
            true,
            "true"
        ].includes(props.hidden),
        animatedProperties: rest.transition?.property,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).createElement(Element, {
            ...filteredEvents,
            type: rest.type,
            "data-testid": rest?.["data-testid"],
            "data-index": internalIndex,
            className: $ddff9b86434e3f59$var$classNames(className, hasFocus ? "hasFocus" : "", hasFocus && isJioV2 ? "engine-container" : ""),
            ref: elementRef || rootRef,
            disabled: resolvedDisabled,
            onKeyDown: (ev)=>{
                if (document.activeElement === ev.target && ev.target.tagName !== "BUTTON") {
                    if (ev.key === "Enter" || ev.key === " ") {
                        const event = new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true
                        });
                        ev.target.dispatchEvent(event);
                    }
                }
                props.onKeyDown?.(ev);
            },
            title: title,
            style: {
                ...style,
                overflow: props["overflow"],
                touchAction: passive ? "none" : void 0,
                cursor: shouldHavePointerCursor ? "pointer" : events.onClick ? "default" : void 0,
                ...resolvedDisabled ? $ddff9b86434e3f59$var$disabledStyles : void 0
            },
            tabIndex: props.tabIndex ?? (disabled ? -1 : hasFocus ? 0 : void 0),
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            "aria-describedby": props["aria-describedby"],
            "aria-disabled": props["aria-disabled"],
            role: props.role,
            "aria-checked": props["aria-checked"],
            "aria-orientation": props["aria-orientation"],
            "aria-current": props["aria-current"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-valuemin": props["aria-valuemin"],
            "aria-valuemax": props["aria-valuemax"],
            "aria-valuenow": props["aria-valuenow"],
            "aria-busy": props["aria-busy"],
            "aria-valuetext": props["aria-valuetext"],
            "aria-selected": props["aria-selected"],
            "aria-pressed": props["aria-pressed"],
            "aria-hidden": props["aria-hidden"],
            "aria-modal": props["aria-modal"],
            "aria-haspopup": props["aria-haspopup"],
            "aria-live": props["aria-live"]
        }, children)
    });
};
const $ddff9b86434e3f59$export$3e431a229df88919 = (props)=>{
    const { value: value, semantics: semantics, events: events, internalIndex: internalIndex, processedA11y: processedA11y, imageFocus: imageFocus, aspectRatio: aspectRatio, _childrenProps: _childrenProps, _isLottieVisible: _isLottieVisible, isContainerFocusable: isContainerFocusable, roundedCorner: roundedCorner, contentScale: contentScale, ...props_ } = props;
    const tokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    const [src, setSrc] = (0, $1OEoy.useState)(value);
    const handleError = ()=>{
        if (tokens?.["brandVersion"] === "jio-v2") setSrc("https://picsum.photos/seed/picsum/200/300");
    };
    const formatImageName = (imagePath = value || "")=>{
        const parts = imagePath.split("/");
        const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
        if (imageName) {
            const formattedName = imageName.replace(/\..*$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
            return formattedName;
        }
        return "Image name not found";
    };
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("img", {
        "data-testid": "image-root",
        alt: semantics || formatImageName(src),
        src: src,
        onError: handleError,
        ...props_,
        ...events,
        style: {
            ...props_.style,
            width: tokens?.["brandVersion"] === "jio-v2" ? props_.width : "100%",
            opacity: !value ? 0 : void 0
        }
    });
};
const $ddff9b86434e3f59$export$a6c7ac8248d6e38a = (props)=>{
    const { children: children, events: events, className: className, style: style, layer: layer, ...rest } = props;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("a", {
        ...events,
        className: className,
        style: style,
        "data-testid": rest?.["data-testid"],
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).Children.map(props.children, (item)=>item && (0, $1OEoy.cloneElement)(item))
    });
};
const $ddff9b86434e3f59$var$PromoCardArc = (props)=>{
    const { orientation: orientation, style: style, className: className } = props;
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            ...style
        },
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M0,0 L0,5 C1,3 1,-3 0,-5 L0,0",
            fill: "currentcolor"
        })
    });
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            ...style
        },
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M0,0 L0,10 C1,3 1,-3 0,-10 L0,0",
            fill: "currentcolor",
            style: {
                transform: "rotate(270deg) translateX(-100%) translateY(50%"
            }
        })
    });
};
const $ddff9b86434e3f59$var$addV2TagToCompLayer = (tokens, layer)=>{
    if (!layer) return layer;
    if (tokens?.["brandVersion"] === "jio-v2") {
        if (!layer.endsWith("2")) return layer + "2";
    }
    return layer;
};
const $ddff9b86434e3f59$var$RenderComponent = (Comp, props, componentsMap)=>{
    const tokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    const comp = $ddff9b86434e3f59$var$addV2TagToCompLayer(tokens, Comp?.component);
    if (comp && componentsMap?.[comp]) Comp = (0, $1OEoy.createElement)(componentsMap?.[comp](), Comp.props);
    if (Array.isArray(Comp)) return Comp.map((C)=>{
        if (!C.component) return $ddff9b86434e3f59$var$RenderComponent(C, {
            ...C.props,
            ...props
        }, componentsMap);
        const comp2 = $ddff9b86434e3f59$var$addV2TagToCompLayer(tokens, C?.component);
        return $ddff9b86434e3f59$var$RenderComponent(comp2, {
            ...C.props,
            ...props
        }, componentsMap);
    });
    if (!(0, $1OEoy.isValidElement)(Comp)) return null;
    const compName = $ddff9b86434e3f59$var$getComponentName(Comp);
    const { slot_layers: slot_layers, ...newProps } = props ?? {};
    const { lock_all: lock_all, ...slotProps } = slot_layers?.[compName] ?? slot_layers?.[compName + "2"] ?? {};
    for(const prop in slotProps){
        const arr = [].concat(slotProps[prop]);
        const value = Comp.props[prop];
        if (arr.includes(value)) newProps[prop] = value;
        else {
            newProps[prop] = arr[0];
            value !== void 0 && console.warn(`Invalid property on ${compName} for ${prop} - currently ${value}. Value must be one of [${arr.join()}]`);
        }
    }
    if (lock_all) return (0, $1OEoy.createElement)(Comp.type, {
        ...Comp.props,
        ...newProps
    });
    return (0, $1OEoy.cloneElement)(Comp, {
        ...Comp.props,
        ...newProps
    });
};
const $ddff9b86434e3f59$var$removeBrandPrefixes = (name)=>{
    const PREFIXES = [
        "jds_"
    ];
    let currentName = name;
    PREFIXES.forEach((prefix)=>{
        currentName = currentName.replace(prefix, "");
    });
    return currentName;
};
const $ddff9b86434e3f59$var$getComponentName = (Comp)=>{
    if (!Comp) return "";
    if (Comp?.type?.slotName) return Comp?.type?.slotName?.replace(/\d+$/, "");
    if (Comp?.slotName) return Comp?.slotName?.replace(/\d+$/, "");
    return Comp?.type?.displayName ?? Comp?.displayName ?? "";
};
const $ddff9b86434e3f59$export$8c6ed5c666ac1360 = ({ _childrenProps: _childrenProps, layer: layer, events: events, className: className, style: style = {}, disabled: disabled, slot_layers: slot_layers, ...rest })=>{
    const { api: children, props: props } = _childrenProps;
    if (!children?.[layer]?.name) return null;
    const Comp = props?.[children?.[layer]?.name];
    if (!Comp) return null;
    const hasStyle = Boolean(Object.keys(style || {}).length);
    const _accepts = children?.[layer]?.accepts.map((item)=>item.replace(/\d+$/, ""));
    const acceptedArrayItems = [];
    _accepts?.forEach((item)=>{
        if (typeof item === "string") acceptedArrayItems.push($ddff9b86434e3f59$var$removeBrandPrefixes(item.toLowerCase()).replace(/\d+$/, ""));
        if (Array.isArray(item)) item.map((item2)=>acceptedArrayItems.push($ddff9b86434e3f59$var$removeBrandPrefixes(item2?.toLowerCase()).replace(/\d+$/, "")));
        return acceptedArrayItems;
    });
    const shouldComponentRender = (Comp2)=>{
        if (Comp2.component) Comp2 = $ddff9b86434e3f59$var$RenderComponent(Comp2, Comp2.props, _childrenProps?.componentsMap || {});
        const CompName = $ddff9b86434e3f59$var$getComponentName(Comp2);
        const should = acceptedArrayItems.includes(CompName?.toLowerCase()) || _accepts.includes(CompName?.toLowerCase().replace(/\d+$/, "")) || [
            "any",
            "template",
            "Any"
        ].includes(_accepts[0]);
        if (!should) console.warn("Did not render", {
            Comp: Comp2,
            CompName: CompName,
            acceptedArrayItems: acceptedArrayItems,
            _accepts: _accepts
        });
        return should;
    };
    const isReactElement = (obj)=>obj?.$$typeof === Symbol.for("react.element");
    const isArrayOfReactElements = (obj)=>Array.isArray(obj) && obj.every(isReactElement);
    if (!isReactElement(Comp) && !isArrayOfReactElements(Comp)) console.warn("not a react element", Comp);
    if (Comp.type !== Symbol.for("react.fragment") && (0, $1OEoy.isValidElement)(Comp)) {
        if (shouldComponentRender(Comp)) {
            if (!hasStyle) return $ddff9b86434e3f59$var$RenderComponent(Comp, {
                ...events,
                ...Comp.props,
                style: {
                    ...rest["style"],
                    ...Comp?.props?.style
                },
                slot_layers: slot_layers
            }, _childrenProps?.componentsMap || {});
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: $ddff9b86434e3f59$var$RenderComponent(Comp, {
                    ...events,
                    ...Comp.props,
                    style: {
                        ...rest["style"],
                        ...Comp?.props?.style
                    },
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {})
            });
        }
    }
    if (Array.isArray(Comp)) {
        if (children?.[layer]?.max) {
            if (!hasStyle) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $7a9adcfb845e594f$exports.Fragment), {
                children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map((Item, i)=>$ddff9b86434e3f59$var$RenderComponent(Item, {
                        key: $ddff9b86434e3f59$var$getComponentName(Item) + i,
                        ...events,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: Comp.slice(0, children?.[layer]?.max).filter(shouldComponentRender).map((Item, i)=>$ddff9b86434e3f59$var$RenderComponent(Item, {
                        key: $ddff9b86434e3f59$var$getComponentName(Item) + i,
                        ...events,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
        }
        if (!hasStyle) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $7a9adcfb845e594f$exports.Fragment), {
            children: Comp.filter(shouldComponentRender).map((Item, i)=>$ddff9b86434e3f59$var$RenderComponent(Item, {
                    key: $ddff9b86434e3f59$var$getComponentName(Item) + i,
                    ...events,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {}))
        });
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
            className: className,
            style: {
                ...style,
                display: "contents",
                pointerEvents: disabled ? "none" : void 0
            },
            children: Comp.filter(shouldComponentRender).map((Item, i)=>$ddff9b86434e3f59$var$RenderComponent(Item, {
                    key: $ddff9b86434e3f59$var$getComponentName(Item) + i,
                    ...events,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {}))
        });
    }
    const renderFragment = (Comp2)=>{
        let ComponentChildren;
        if (children?.[layer]?.max || Array.isArray(Comp2.props.children)) {
            ComponentChildren = Comp2.props.children.slice?.(0, children?.[layer]?.max).map((item)=>{
                if (item?.type === Symbol.for("react.fragment")) return renderFragment(item);
                else if (item) return shouldComponentRender(item) && $ddff9b86434e3f59$var$RenderComponent(item, {
                    ...item.props,
                    slot_layers: slot_layers
                }, _childrenProps?.componentsMap || {});
                return null;
            });
            if (!hasStyle) return ComponentChildren;
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: className,
                style: {
                    ...style,
                    display: "contents",
                    pointerEvents: disabled ? "none" : void 0
                },
                children: ComponentChildren.map((child)=>shouldComponentRender(child) && $ddff9b86434e3f59$var$RenderComponent(child, {
                        ...child.props,
                        slot_layers: slot_layers
                    }, _childrenProps?.componentsMap || {}))
            });
        }
        ComponentChildren = Comp2.props.children;
        return ComponentChildren.map((child)=>shouldComponentRender(child) && $ddff9b86434e3f59$var$RenderComponent(child, {
                ...child.props,
                slot_layers: slot_layers
            }, _childrenProps?.componentsMap || {}));
    };
    if (typeof Comp === "object" && Comp.type === Symbol.for("react.fragment")) return renderFragment(Comp);
    return null;
};
const $ddff9b86434e3f59$var$ButtonVector = (props)=>{
    const transformAngle = props.direction !== "reversed" ? 180 : 0;
    const borderClass = props["border-type"] === "solid" ? "solid-border" : "none";
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        className: $ddff9b86434e3f59$var$classNames(props.className, borderClass, "sw-btn-vector"),
        style: {
            ...props.style,
            transform: `rotate(${transformAngle}deg)`
        },
        preserveAspectRatio: "none",
        viewBox: "0 0 40 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("mask", {
                id: "path-1-inside-1_23_23",
                fill: "red",
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                    d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0"
                })
            }),
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                className: "inside",
                d: "M0 56H12.53C12.53 56 24.19 55.81 28.54 41.98C32.44 30.4 37.86 28.35 40 28C37.86 27.64 32.45 25.6 28.54 14.02C24.19 0.190001 12.53 0 12.53 0H0",
                fill: "currentcolor"
            }),
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M12.53 56V57H12.5381L12.5463 56.9999L12.53 56ZM28.54 41.98L27.5923 41.6608L27.5891 41.6704L27.5861 41.68L28.54 41.98ZM40 28L40.1614 28.9869L40.1659 27.0139L40 28ZM28.54 14.02L27.5861 14.32L27.5892 14.33L27.5926 14.3399L28.54 14.02ZM12.53 0L12.5463 -0.999867L12.5381 -1H12.53V0ZM0 57H12.53V55H0V57ZM12.53 56C12.5463 56.9999 12.5469 56.9999 12.5476 56.9998C12.5479 56.9998 12.5486 56.9998 12.5491 56.9998C12.5503 56.9998 12.5516 56.9998 12.5531 56.9997C12.556 56.9997 12.5597 56.9996 12.5641 56.9995C12.5729 56.9993 12.5844 56.9989 12.5988 56.9984C12.6274 56.9974 12.6671 56.9957 12.7171 56.993C12.8171 56.9875 12.9588 56.9776 13.1374 56.96C13.4946 56.9249 14.0005 56.8588 14.6173 56.7345C15.8497 56.4863 17.5338 56.004 19.3606 55.0658C23.038 53.1773 27.2325 49.47 29.4939 42.28L27.5861 41.68C25.4975 48.32 21.687 51.6227 18.4469 53.2867C16.815 54.1248 15.3121 54.5544 14.2224 54.7739C13.6781 54.8836 13.2391 54.9404 12.9416 54.9696C12.7929 54.9843 12.6799 54.992 12.6069 54.996C12.5705 54.998 12.5441 54.9991 12.5284 54.9997C12.5205 54.9999 12.5153 55.0001 12.5128 55.0001C12.5116 55.0002 12.5111 55.0002 12.5112 55.0002C12.5113 55.0002 12.5115 55.0002 12.5119 55.0002C12.5121 55.0002 12.5126 55.0002 12.5127 55.0001C12.5132 55.0001 12.5137 55.0001 12.53 56ZM29.4877 42.2992C33.2983 30.9845 38.4683 29.2638 40.1614 28.9869L39.8386 27.0131C37.2517 27.4362 31.5817 29.8155 27.5923 41.6608L29.4877 42.2992ZM40.1659 27.0139C38.4677 26.7282 33.3074 25.0135 29.4874 13.7001L27.5926 14.3399C31.5926 26.1865 37.2523 28.5518 39.8341 28.9861L40.1659 27.0139ZM29.4939 13.72C27.2325 6.53004 23.038 2.82274 19.3606 0.934197C17.5338 -0.00395302 15.8497 -0.486254 14.6173 -0.734524C14.0005 -0.858788 13.4946 -0.924878 13.1374 -0.960018C12.9588 -0.977597 12.8171 -0.987457 12.7171 -0.992973C12.6671 -0.995731 12.6274 -0.997405 12.5988 -0.998413C12.5844 -0.998918 12.5729 -0.999256 12.5641 -0.999481C12.5597 -0.999594 12.556 -0.999678 12.5531 -0.99974C12.5516 -0.999771 12.5503 -0.999796 12.5491 -0.999817C12.5486 -0.999828 12.5479 -0.999841 12.5476 -0.999846C12.5469 -0.999857 12.5463 -0.999867 12.53 0C12.5137 0.999867 12.5132 0.999858 12.5127 0.99985C12.5126 0.999848 12.5121 0.99984 12.5119 0.999836C12.5115 0.999829 12.5113 0.999824 12.5112 0.999822C12.5111 0.999819 12.5116 0.99983 12.5128 0.999862C12.5153 0.999925 12.5205 1.00007 12.5284 1.00035C12.5441 1.0009 12.5705 1.00198 12.6069 1.00399C12.6799 1.00801 12.7929 1.01574 12.9416 1.03037C13.2391 1.05964 13.6781 1.11644 14.2224 1.22609C15.3121 1.44563 16.815 1.8752 18.4469 2.7133C21.687 4.37726 25.4975 7.67996 27.5861 14.32L29.4939 13.72ZM12.53 -1H0V1H12.53V-1Z",
                fill: "url(#paint0_angular_23_23)",
                mask: "url(#path-1-inside-1_23_23)"
            }),
            props["border-type"] === "gradient" && /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)("radialGradient", {
                    id: "paint0_angular_23_23",
                    cx: "0",
                    cy: "0",
                    r: "1",
                    gradientUnits: "userSpaceOnUse",
                    gradientTransform: "translate(38.5 51.5) rotate(154.464) scale(70.402 85.8467)",
                    children: [
                        /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "0.0165174",
                            stopColor: "#EAB872"
                        }),
                        /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "0.280935",
                            stopColor: "#63371D"
                        }),
                        /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "0.563131",
                            stopColor: "#FFEAC2"
                        }),
                        /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "0.796371",
                            stopColor: "#AE824E"
                        })
                    ]
                })
            })
        ]
    });
};
const $ddff9b86434e3f59$var$atomsMap = {
    container: $ddff9b86434e3f59$export$42a852a2b6b56249,
    text: $ddff9b86434e3f59$export$5f1af8db9871e1d6,
    icon: $ddff9b86434e3f59$export$f04a61298a47a40f,
    image: $ddff9b86434e3f59$export$3e431a229df88919,
    slider: $ddff9b86434e3f59$export$472062a354075cee,
    animatedContainer: $ddff9b86434e3f59$export$9382739d0e79620f,
    loader: $ddff9b86434e3f59$export$3b0d6d7590275603,
    link: $ddff9b86434e3f59$export$a6c7ac8248d6e38a,
    popup: $ddff9b86434e3f59$export$129a32eedafa97c5,
    textarea: $ddff9b86434e3f59$export$379139ebc1c2b235,
    tooltip: $ddff9b86434e3f59$export$c92c6401b52a9298,
    input: $ddff9b86434e3f59$export$f5b8910cec6cf069,
    promoCardArc: $ddff9b86434e3f59$var$PromoCardArc,
    arc: $ddff9b86434e3f59$export$6ef80ffb606dd232,
    slot: $ddff9b86434e3f59$export$8c6ed5c666ac1360,
    skeletonLoader: $ddff9b86434e3f59$export$d50980d2cec56085,
    button_vector: $ddff9b86434e3f59$var$ButtonVector
};
const $ddff9b86434e3f59$export$595884dc072315a0 = (layer)=>{
    const baseLayerName = $ddff9b86434e3f59$var$getBaseLayerName(layer);
    return Object.keys($ddff9b86434e3f59$var$atomsMap).includes(baseLayerName);
};
const $ddff9b86434e3f59$export$60e54eaca7e7fb38 = (componentProperties, props, componentName = "component", componentsMap, _custom = {}, parentRuntime)=>{
    const runtime = parentRuntime || props.runtime;
    const { hierarchy: hierarchy, api: api, ...rest } = componentProperties;
    const { componentTag: componentTag, ...restProps } = props;
    const customMergedJSON = (0, $a996a90891ec663e$export$4950aa0f605343fb)({
        api: api,
        ...rest
    }, _custom);
    const defaultProps = (0, $5a49bb477e7b5f89$export$61b94149aeb1f59)(customMergedJSON.api);
    const invariants = (0, $5a49bb477e7b5f89$export$ce4be320c9b7d5be)(customMergedJSON);
    const normalisedProperties = $ddff9b86434e3f59$var$processConfigAPI(api?.config, props);
    const mergedProps = {
        ...restProps,
        ...normalisedProperties
    };
    const flatTokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    const propTokens = (0, $a996a90891ec663e$export$b460b275d6c6aa0)(mergedProps, (v, k)=>$ddff9b86434e3f59$export$1ec1d45228a8d241.includes(k) && v !== "auto");
    const getPercentageTokens = Object.keys(defaultProps).filter((key)=>props[key] !== defaultProps[key]);
    const defaultSwitchables = $ddff9b86434e3f59$export$dfce236e857ed8b0();
    const hasDifferentTokens = Object.keys((0, $a996a90891ec663e$export$b460b275d6c6aa0)(propTokens, (v, k)=>v !== defaultSwitchables[k])).length > 0;
    const shouldIncludeAmpersand = getPercentageTokens.length > 0 && hasDifferentTokens || Object.values(customMergedJSON.base).some((item)=>Object.keys(item).some((key)=>key.endsWith("color") || key === "fill"));
    const config = (0, $5a49bb477e7b5f89$export$859883d4ec9c7db4).brandResolverFn && !runtime ? {
        getAmpersandTokens: shouldIncludeAmpersand,
        getPercentageTokens: getPercentageTokens,
        getAllBaseLayers: false,
        transformer: false
    } : void 0;
    const uiTokens = (0, $5a49bb477e7b5f89$export$e025e4ac3d283105)(mergedProps, (0, $a996a90891ec663e$export$629a2bd3f5a49ecc)(customMergedJSON), config);
    const { layerProps: layerProps, styles: styles_ } = $ddff9b86434e3f59$var$seperateComponentLayerProps(uiTokens);
    const { hierarchy: hierarchy_, styles: styles } = $ddff9b86434e3f59$var$hiddenFilter({
        hierarchy_: hierarchy,
        styles_: styles_,
        api: api,
        props: mergedProps
    });
    const propMergedStyles = $ddff9b86434e3f59$var$mergeStyleProperties(mergedProps, styles, api.data, layerProps);
    const drawnComponent = (0, $5a49bb477e7b5f89$export$a1a0a7262a295961)(componentName, propMergedStyles, hierarchy, invariants, {
        ...flatTokens,
        ...propTokens
    });
    return $ddff9b86434e3f59$var$renderComponent({
        currentLayer: hierarchy_,
        api: api,
        props: mergedProps,
        componentName: customMergedJSON?.metadata?.name || componentName,
        children: api.children,
        componentsMap: componentsMap,
        base: propMergedStyles,
        layerProps: layerProps,
        internalIndex: props.internalIndex,
        root: true,
        componentTag: componentTag,
        drawnComponent: drawnComponent,
        runtime: runtime,
        tokens: flatTokens
    });
};
const $ddff9b86434e3f59$var$ComponentWithTokens = ({ children: children, base: base, layer: layer, propTokens: propTokens, runtime: runtime })=>{
    const tokens = $ddff9b86434e3f59$export$f34d637a75323a1e();
    if (runtime && // !['text', 'icon'].some((key) => layer.endsWith(key)) &&
    !layer.includes("jds_")) return (0, $1OEoy.cloneElement)(children, {
        style: Object.fromEntries(Object.entries(base[layer] || {}).map(([key, value])=>[
                key,
                (0, $5a49bb477e7b5f89$export$6a176e754d54672)(key, value, tokens)
            ]))
    });
    if (tokens.brandVersion !== "jio-v2") {
        if (Object.keys(tokens).some((key)=>key in base[layer])) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$e5cf4eff53e7947d, {
            value: (0, $a996a90891ec663e$export$b460b275d6c6aa0)(base[layer], (v, k)=>$ddff9b86434e3f59$export$1ec1d45228a8d241.includes(k)),
            children: children
        });
        return children;
    }
    const colorKeys = [
        "appearance",
        "surface",
        "strokeSurface",
        "color",
        "background-color",
        "border-color",
        "fill"
    ];
    if (tokens?.["brandVersion"] !== "jio-v2" || (!base[layer] || !colorKeys.some((k)=>base[layer]?.[k])) && !Object.keys(propTokens || {}).length || layer.endsWith("slot")) return children;
    const colorProperty = Object.keys(base[layer] || {}).find((key)=>key.endsWith("color") && !key.includes("border"));
    const borderColorProperty = Object.keys(base[layer] || {}).find((key)=>key.includes("border"));
    const colorToken = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(String(base[layer]?.[colorProperty]) || "");
    const borderColorToken = (0, $a996a90891ec663e$export$5fe300a9008e2bfc)(String(base[layer]?.[borderColorProperty]) || "");
    const surface = colorToken?.split("_")?.[2];
    const strokeSurface = borderColorToken?.split("_")?.[2];
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$export$e5cf4eff53e7947d, {
        value: {
            ...(0, $a996a90891ec663e$export$b460b275d6c6aa0)(base[layer], (v, k)=>$ddff9b86434e3f59$export$1ec1d45228a8d241.includes(k)),
            ...propTokens,
            surface: base[layer]?.surface?.toString() || surface || "ghost",
            strokeSurface: base[layer]?.strokeSurface?.toString() || strokeSurface || void 0
        },
        children: children
    });
};
const $ddff9b86434e3f59$var$renderComponent = ({ currentLayer: currentLayer, api: api, props: props, componentName: componentName, children: children, componentsMap: componentsMap, base: base, layerProps: layerProps, internalIndex: internalIndex, root: root, componentTag: componentTag, drawnComponent: drawnComponent, runtime: runtime, tokens: tokens })=>{
    const isV2 = tokens?.["brandVersion"] === "jio-v2";
    if (typeof currentLayer === "string") {
        const CurrentComp = $ddff9b86434e3f59$var$getCompFromKey(currentLayer, componentsMap);
        const { processData: processData, processedEvents: processedEvents, processedA11y: processedA11y } = $ddff9b86434e3f59$var$processDataAPI(api, currentLayer, props);
        const drawnClasses = drawnComponent.classes[currentLayer] ?? [];
        const drawnStyles = drawnComponent.styles;
        if (CurrentComp) {
            const processedConfigAPI = $ddff9b86434e3f59$var$processConfigAPI(api?.config, props);
            const newProps = (0, $a996a90891ec663e$export$4950aa0f605343fb)(processedConfigAPI, layerProps?.[currentLayer], processData, {
                events: processedEvents
            }, processedA11y);
            const className = (0, $5a49bb477e7b5f89$export$c1260eec73bdf31d)(componentName, currentLayer);
            const isAtomicLayer = $ddff9b86434e3f59$export$595884dc072315a0(currentLayer);
            const Component = /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(CurrentComp, {
                layer: currentLayer,
                "data-testid": (0, $5a49bb477e7b5f89$export$82c717ab02da3bac)(componentName, currentLayer),
                _childrenProps: {
                    api: children,
                    props: props,
                    componentsMap: componentsMap
                },
                disabled: props.disabled || layerProps?.[currentLayer]?.["disabled"],
                ...newProps,
                runtime: runtime && !currentLayer.includes("jds_"),
                ...newProps.events,
                isContainerFocusable: $ddff9b86434e3f59$var$getIsContainerFocusable(api, currentLayer),
                className: $ddff9b86434e3f59$export$595884dc072315a0 && isV2 ? $ddff9b86434e3f59$var$classNames(className, ...drawnClasses, newProps.className) : !Object.keys(base).length ? "" : className,
                style: root ? drawnStyles : void 0,
                internalIndex: internalIndex || 0,
                processedA11y: processedA11y
            }, currentLayer);
            if (!(0, $1OEoy.isValidElement)(Component)) return null;
            if (!isAtomicLayer) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                style: {
                    display: "contents",
                    ...root ? drawnStyles : {}
                },
                className: className,
                children: Component
            }, currentLayer);
            if (currentLayer.endsWith("slot")) {
                if (props?.[children?.[currentLayer]?.name]) return Component;
                return null;
            }
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$var$ComponentWithTokens, {
                base: base,
                layer: currentLayer,
                runtime: runtime,
                propTokens: (0, $a996a90891ec663e$export$b460b275d6c6aa0)(newProps, (v, k)=>$ddff9b86434e3f59$export$1ec1d45228a8d241.includes(k) && v !== "auto"),
                children: Component
            }, currentLayer);
        }
    } else if (typeof currentLayer === "object" && !Array.isArray(currentLayer)) return Object.keys(currentLayer).map((layer)=>{
        const drawnClasses = drawnComponent.classes[layer] ?? [];
        const drawnStyles = drawnComponent.styles;
        const CurrentComp = $ddff9b86434e3f59$var$getCompFromKey(layer, componentsMap);
        const { processData: processData, processedEvents: processedEvents, processedA11y: processedA11y } = $ddff9b86434e3f59$var$processDataAPI(api, layer, props) || {};
        if (CurrentComp) {
            const processedConfigAPI = $ddff9b86434e3f59$var$processConfigAPI(api?.config, props);
            const newProps = {
                ...processedConfigAPI,
                ...layerProps?.[layer],
                ...processData,
                ...processedEvents,
                ...processedA11y,
                style: root ? props.style : void 0,
                componentTag: root ? componentTag : void 0,
                rootRef: root ? props.rootRef : void 0
            };
            const listName = api.data?.[layer]?.["value"]?.name;
            const arrayData = api.data?.[layer]?.["value"]?.type === "list" ? props[listName] : void 0;
            const className = (0, $5a49bb477e7b5f89$export$c1260eec73bdf31d)(componentName, layer);
            return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($ddff9b86434e3f59$var$ComponentWithTokens, {
                base: base,
                layer: layer,
                runtime: runtime,
                propTokens: (0, $a996a90891ec663e$export$b460b275d6c6aa0)(newProps, (v, k)=>$ddff9b86434e3f59$export$1ec1d45228a8d241.includes(k) && v !== "auto"),
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(CurrentComp, {
                    "data-testid": (0, $5a49bb477e7b5f89$export$82c717ab02da3bac)(componentName, layer),
                    ...newProps,
                    layer: layer,
                    runtime: runtime && !layer.includes("jds_"),
                    className: $ddff9b86434e3f59$var$classNames(className, !root ? "" : newProps.className, ...isV2 ? drawnClasses : []),
                    isContainerFocusable: $ddff9b86434e3f59$var$getIsContainerFocusable(api, layer),
                    style: root ? {
                        ...props.style ?? {},
                        ...drawnStyles
                    } : void 0,
                    events: processedEvents,
                    disabled: props.disabled || layerProps?.[layer]?.["disabled"],
                    internalIndex: internalIndex,
                    processedA11y: processedA11y,
                    children: arrayData ? arrayData?.map((valueItem, i)=>{
                        return $ddff9b86434e3f59$var$renderComponent({
                            currentLayer: currentLayer[layer],
                            api: api,
                            props: {
                                ...props,
                                ...valueItem,
                                internalIndex: i
                            },
                            componentName: componentName,
                            children: children,
                            componentsMap: componentsMap,
                            base: base,
                            layerProps: layerProps,
                            internalIndex: valueItem.internalIndex || i,
                            drawnComponent: drawnComponent,
                            runtime: runtime,
                            tokens: tokens
                        });
                    }) : $ddff9b86434e3f59$var$renderComponent({
                        currentLayer: currentLayer[layer],
                        api: api,
                        props: {
                            ...props
                        },
                        componentName: componentName,
                        children: children,
                        componentsMap: componentsMap,
                        base: base,
                        layerProps: layerProps,
                        internalIndex: internalIndex,
                        drawnComponent: drawnComponent,
                        runtime: runtime,
                        tokens: tokens
                    })
                }, layer)
            }, layer);
        }
        return null;
    });
    else if (typeof currentLayer === "object" && Array.isArray(currentLayer)) return currentLayer.map((child)=>{
        return $ddff9b86434e3f59$var$renderComponent({
            currentLayer: child,
            api: api,
            props: props,
            componentName: componentName,
            children: children,
            componentsMap: componentsMap,
            base: base,
            layerProps: layerProps,
            internalIndex: internalIndex,
            drawnComponent: drawnComponent,
            runtime: runtime,
            tokens: tokens
        });
    });
    return null;
};
const $ddff9b86434e3f59$var$getCompFromKey = (obj, componentsMap)=>{
    const layerName = $ddff9b86434e3f59$var$getBaseLayerName(obj);
    if (componentsMap && componentsMap[layerName]) try {
        return componentsMap[layerName]?.() || null;
    } catch (error) {
        return null;
    }
    if ($ddff9b86434e3f59$export$595884dc072315a0(layerName)) return $ddff9b86434e3f59$var$atomsMap[layerName] || null;
    return null;
};
const $ddff9b86434e3f59$var$excludedLayers = [
    "input",
    "container",
    "arc",
    "slider",
    "loader",
    "button_vector",
    "skeletonLoader"
];
const $ddff9b86434e3f59$var$hasProps = (layerName = "", api, props, styles)=>{
    if ($ddff9b86434e3f59$var$excludedLayers.some((layer)=>layerName.endsWith(layer))) return true;
    const apiLayers = api.data?.[layerName];
    const childlayers = api.children?.[layerName];
    if (!apiLayers && !childlayers && Object.values(apiLayers || {}).every(({ type: type })=>type === "boolean")) return true;
    const hasChildren = Boolean(props?.[childlayers?.name]);
    const hasData = Object.values(apiLayers || {}).some(({ name: name })=>![
            void 0,
            null,
            ""
        ].includes(props[name]) || ![
            void 0,
            null,
            ""
        ].includes(styles?.[layerName]?.[name]) || name.includes("."));
    const hasBaseProps = Object.keys((styles || {})[layerName] || {}).filter((key)=>Object.values(apiLayers || {}).find(({ name: name })=>name === key))?.length;
    if (!hasData && hasBaseProps) return true;
    if (!hasData && !(hasChildren && childlayers)) return false;
    return true;
};
const $ddff9b86434e3f59$var$hiddenFilter = ({ hierarchy_: hierarchy_, styles_: styles_, api: api, props: props })=>{
    const hiddenLayers = [];
    const styles = Object.entries(styles_).reduce((acc, [layerName, styleProps])=>{
        if ($ddff9b86434e3f59$var$isHidden(styleProps.hidden) && !styleProps?.["transition"]) hiddenLayers.push(layerName);
        else acc[layerName] = styleProps;
        return acc;
    }, {});
    const hierarchy = $ddff9b86434e3f59$var$filterHierarchy(hierarchy_, hiddenLayers, api, props, styles);
    return {
        hierarchy: hierarchy,
        styles: styles
    };
};
const $ddff9b86434e3f59$var$isHidden = (hidden)=>{
    if (typeof hidden === "string") return hidden.includes("true");
    return Boolean(hidden);
};
const $ddff9b86434e3f59$var$isLayerHidden = (layer, hiddenLayers)=>{
    return hiddenLayers.includes(layer);
};
const $ddff9b86434e3f59$var$filterHierarchy = (hierarchy, hiddenLayers, api, props, styles)=>{
    if (typeof hierarchy === "string" && !$ddff9b86434e3f59$var$isLayerHidden(hierarchy, hiddenLayers) && $ddff9b86434e3f59$var$hasProps(hierarchy, api, props, styles)) return hierarchy;
    else if (typeof hierarchy === "object" && !Array.isArray(hierarchy)) {
        const end = Object.keys(hierarchy).filter((key)=>{
            return !$ddff9b86434e3f59$var$isLayerHidden(key, hiddenLayers) && $ddff9b86434e3f59$var$hasProps(key, api, props);
        }).reduce((res, key)=>{
            res[key] = $ddff9b86434e3f59$var$filterHierarchy(hierarchy[key], hiddenLayers, api, props, styles);
            return res;
        }, {});
        return end;
    } else if (typeof hierarchy === "object" && Array.isArray(hierarchy)) {
        const res = [];
        hierarchy.forEach((key)=>{
            res.push($ddff9b86434e3f59$var$filterHierarchy(key, hiddenLayers, api, props, styles));
        });
        return res.filter((r)=>Object.keys(r).length).flat();
    }
    return {};
};
function $ddff9b86434e3f59$var$getIsContainerFocusable(api, layer) {
    const clickEvent = api.events?.[layer]?.onClick;
    if (layer.includes("popup")) return false;
    if (layer.includes("button")) return true;
    if (!layer.includes("container")) return false;
    if (clickEvent) {
        const name = typeof clickEvent === "string" ? clickEvent : clickEvent.name;
        return !name.startsWith("_");
    }
}
const $ddff9b86434e3f59$var$English$6 = {
    of: "of"
};
const $ddff9b86434e3f59$var$Hindi$6 = {
    of: "\u0915\u093E"
};
const $ddff9b86434e3f59$var$Marathi$6 = {
    of: "\u091A\u094D\u092F\u093E"
};
const $ddff9b86434e3f59$var$Gujarati$6 = {
    of: "\u0AA8\u0ABE"
};
const $ddff9b86434e3f59$var$Punjabi$6 = {
    of: "\u0A26\u0A47"
};
const $ddff9b86434e3f59$var$Bengali$6 = {
    of: "\u098F\u09B0"
};
const $ddff9b86434e3f59$var$Tamil$6 = {
    of: "\u0B87\u0BA9\u0BCD"
};
const $ddff9b86434e3f59$var$Telugu$6 = {
    of: "\u0C2F\u0C4A\u0C15\u0C4D\u0C15"
};
const $ddff9b86434e3f59$var$Kannada$6 = {
    of: "\u0CA8"
};
const $ddff9b86434e3f59$var$Assamese$6 = {
    of: "\u09F0"
};
const $ddff9b86434e3f59$var$Malayalam$6 = {
    of: "\u0D2F\u0D41\u0D1F\u0D46"
};
const $ddff9b86434e3f59$var$Oriya$6 = {
    of: "\u0B30"
};
const $ddff9b86434e3f59$var$of = {
    English: $ddff9b86434e3f59$var$English$6,
    Hindi: $ddff9b86434e3f59$var$Hindi$6,
    Marathi: $ddff9b86434e3f59$var$Marathi$6,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$6,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$6,
    Bengali: $ddff9b86434e3f59$var$Bengali$6,
    Tamil: $ddff9b86434e3f59$var$Tamil$6,
    Telugu: $ddff9b86434e3f59$var$Telugu$6,
    Kannada: $ddff9b86434e3f59$var$Kannada$6,
    Assamese: $ddff9b86434e3f59$var$Assamese$6,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$6,
    Oriya: $ddff9b86434e3f59$var$Oriya$6
};
const $ddff9b86434e3f59$var$ofData = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    Assamese: $ddff9b86434e3f59$var$Assamese$6,
    Bengali: $ddff9b86434e3f59$var$Bengali$6,
    English: $ddff9b86434e3f59$var$English$6,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$6,
    Hindi: $ddff9b86434e3f59$var$Hindi$6,
    Kannada: $ddff9b86434e3f59$var$Kannada$6,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$6,
    Marathi: $ddff9b86434e3f59$var$Marathi$6,
    Oriya: $ddff9b86434e3f59$var$Oriya$6,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$6,
    Tamil: $ddff9b86434e3f59$var$Tamil$6,
    Telugu: $ddff9b86434e3f59$var$Telugu$6,
    default: $ddff9b86434e3f59$var$of
}, Symbol.toStringTag, {
    value: 'Module'
}));
const $ddff9b86434e3f59$var$English$5 = {
    ConfirmButton: "Confirm"
};
const $ddff9b86434e3f59$var$Hindi$5 = {
    ConfirmButton: "\u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902"
};
const $ddff9b86434e3f59$var$Marathi$5 = {
    ConfirmButton: "\u092A\u0941\u0937\u094D\u091F\u0940"
};
const $ddff9b86434e3f59$var$Gujarati$5 = {
    ConfirmButton: "\u0AAA\u0AC1\u0AB7\u0ACD\u0A9F\u0ABF \u0A95\u0AB0\u0ACB"
};
const $ddff9b86434e3f59$var$Punjabi$5 = {
    ConfirmButton: "\u0A2A\u0A41\u0A38\u0A3C\u0A1F\u0A40 \u0A15\u0A30\u0A4B"
};
const $ddff9b86434e3f59$var$Bengali$5 = {
    ConfirmButton: "\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8"
};
const $ddff9b86434e3f59$var$Tamil$5 = {
    ConfirmButton: "\u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD"
};
const $ddff9b86434e3f59$var$Telugu$5 = {
    ConfirmButton: "\u0C28\u0C3F\u0C30\u0C4D\u0C27\u0C3E\u0C30\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F"
};
const $ddff9b86434e3f59$var$Kannada$5 = {
    ConfirmButton: "\u0CA6\u0CC3\u0CA2\u0CC0\u0C95\u0CB0\u0CBF\u0CB8\u0CBF"
};
const $ddff9b86434e3f59$var$Assamese$5 = {
    ConfirmButton: "\u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4"
};
const $ddff9b86434e3f59$var$Malayalam$5 = {
    ConfirmButton: "\u0D38\u0D4D\u0D25\u0D3F\u0D30\u0D40\u0D15\u0D30\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15"
};
const $ddff9b86434e3f59$var$Oriya$5 = {
    ConfirmButton: "\u0B28\u0B3F\u0B36\u0B4D\u0B1A\u0B3F\u0B24 \u0B15\u0B30\u0B28\u0B4D\u0B24\u0B41 |"
};
const $ddff9b86434e3f59$var$confirmButtonData = {
    English: $ddff9b86434e3f59$var$English$5,
    Hindi: $ddff9b86434e3f59$var$Hindi$5,
    Marathi: $ddff9b86434e3f59$var$Marathi$5,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$5,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$5,
    Bengali: $ddff9b86434e3f59$var$Bengali$5,
    Tamil: $ddff9b86434e3f59$var$Tamil$5,
    Telugu: $ddff9b86434e3f59$var$Telugu$5,
    Kannada: $ddff9b86434e3f59$var$Kannada$5,
    Assamese: $ddff9b86434e3f59$var$Assamese$5,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$5,
    Oriya: $ddff9b86434e3f59$var$Oriya$5
};
const $ddff9b86434e3f59$var$as = "Assamese";
const $ddff9b86434e3f59$var$bn = "Bengali";
const $ddff9b86434e3f59$var$en = "English";
const $ddff9b86434e3f59$var$gu = "Gujarati";
const $ddff9b86434e3f59$var$hi = "Hindi";
const $ddff9b86434e3f59$var$kn = "Kannada";
const $ddff9b86434e3f59$var$ml = "Malayalam";
const $ddff9b86434e3f59$var$mr = "Marathi";
const $ddff9b86434e3f59$var$or = "Oriya";
const $ddff9b86434e3f59$var$pa = "Punjabi";
const $ddff9b86434e3f59$var$ta = "Tamil";
const $ddff9b86434e3f59$var$te = "Telugu";
const $ddff9b86434e3f59$var$localeLanguageData = {
    as: $ddff9b86434e3f59$var$as,
    bn: $ddff9b86434e3f59$var$bn,
    en: $ddff9b86434e3f59$var$en,
    gu: $ddff9b86434e3f59$var$gu,
    hi: $ddff9b86434e3f59$var$hi,
    kn: $ddff9b86434e3f59$var$kn,
    ml: $ddff9b86434e3f59$var$ml,
    mr: $ddff9b86434e3f59$var$mr,
    or: $ddff9b86434e3f59$var$or,
    pa: $ddff9b86434e3f59$var$pa,
    ta: $ddff9b86434e3f59$var$ta,
    te: $ddff9b86434e3f59$var$te
};
const $ddff9b86434e3f59$var$English$4 = {
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    five: "5",
    six: "6",
    seven: "7",
    eight: "8",
    nine: "9",
    ten: "10",
    eleven: "11",
    twelve: "12",
    thirteen: "13",
    fourteen: "14",
    fifteen: "15",
    sixteen: "16",
    seventeen: "17",
    eighteen: "18",
    nineteen: "19",
    twenty: "20",
    twenty_one: "21",
    twenty_two: "22",
    twenty_three: "23",
    twenty_four: "24",
    twenty_five: "25",
    twenty_six: "26",
    twenty_seven: "27",
    twenty_eight: "28",
    twenty_nine: "29",
    thirty: "30",
    thirty_one: "31"
};
const $ddff9b86434e3f59$var$Hindi$4 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F",
    ten: "\u0967\u0966",
    eleven: "\u0967\u0967",
    twelve: "\u0967\u0968",
    thirteen: "\u0967\u0969",
    fourteen: "\u0967\u096A",
    fifteen: "\u0967\u096B",
    sixteen: "\u0967\u096C",
    seventeen: "\u0967\u096D",
    eighteen: "\u0967\u096E",
    nineteen: "\u0967\u096F",
    twenty: "\u0968\u0966",
    twenty_one: "\u0968\u0967",
    twenty_two: "\u0968\u0968",
    twenty_three: "\u0968\u0969",
    twenty_four: "\u0968\u096A",
    twenty_five: "\u0968\u096B",
    twenty_six: "\u0968\u096C",
    twenty_seven: "\u0968\u096D",
    twenty_eight: "\u0968\u096E",
    twenty_nine: "\u0968\u096F",
    thirty: "\u0969\u0966",
    thirty_one: "\u0969\u0967"
};
const $ddff9b86434e3f59$var$Marathi$4 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F",
    ten: "\u0967\u0966",
    eleven: "\u0967\u0967",
    twelve: "\u0967\u0968",
    thirteen: "\u0967\u0969",
    fourteen: "\u0967\u096A",
    fifteen: "\u0967\u096B",
    sixteen: "\u0967\u096C",
    seventeen: "\u0967\u096D",
    eighteen: "\u0967\u096E",
    nineteen: "\u0967\u096F",
    twenty: "\u0968\u0966",
    twenty_one: "\u0968\u0967",
    twenty_two: "\u0968\u0968",
    twenty_three: "\u0968\u0969",
    twenty_four: "\u0968\u096A",
    twenty_five: "\u0968\u096B",
    twenty_six: "\u0968\u096C",
    twenty_seven: "\u0968\u096D",
    twenty_eight: "\u0968\u096E",
    twenty_nine: "\u0968\u096F",
    thirty: "\u0969\u0966",
    thirty_one: "\u0969\u0967"
};
const $ddff9b86434e3f59$var$Gujarati$4 = {
    zero: "\u0AE6",
    one: "\u0AE7",
    two: "\u0AE8",
    three: "\u0AE9",
    four: "\u0AEA",
    five: "\u0AEB",
    six: "\u0AEC",
    seven: "\u0AED",
    eight: "\u0AEE",
    nine: "\u0AEF",
    ten: "\u0AE7\u0AE6",
    eleven: "\u0AE7\u0AE7",
    twelve: "\u0AE7\u0AE8",
    thirteen: "\u0AE7\u0AE9",
    fourteen: "\u0AE7\u0AEA",
    fifteen: "\u0AE7\u0AEB",
    sixteen: "\u0AE7\u0AEC",
    seventeen: "\u0AE7\u0AED",
    eighteen: "\u0AE7\u0AEE",
    nineteen: "\u0AE7\u0AEF",
    twenty: "\u0AE8\u0AE6",
    twenty_one: "\u0AE8\u0AE7",
    twenty_two: "\u0AE8\u0AE8",
    twenty_three: "\u0AE8\u0AE9",
    twenty_four: "\u0AE8\u0AEA",
    twenty_five: "\u0AE8\u0AEB",
    twenty_six: "\u0AE8\u0AEC",
    twenty_seven: "\u0AE8\u0AED",
    twenty_eight: "\u0AE8\u0AEE",
    twenty_nine: "\u0AE8\u0AEF",
    thirty: "\u0AE9\u0AE6",
    thirty_one: "\u0AE9\u0AE7"
};
const $ddff9b86434e3f59$var$Punjabi$4 = {
    zero: "\u0A66",
    one: "\u0A67",
    two: "\u0A68",
    three: "\u0A69",
    four: "\u0A6A",
    five: "\u0A6B",
    six: "\u0A6C",
    seven: "\u0A6D",
    eight: "\u0A6E",
    nine: "\u0A6F",
    ten: "\u0A67\u0A66",
    eleven: "\u0A67\u0A67",
    twelve: "\u0A67\u0A68",
    thirteen: "\u0A67\u0A69",
    fourteen: "\u0A67\u0A6A",
    fifteen: "\u0A67\u0A6B",
    sixteen: "\u0A67\u0A6C",
    seventeen: "\u0A67\u0A6D",
    eighteen: "\u0A67\u0A6E",
    nineteen: "\u0A67\u0A6F",
    twenty: "\u0A68\u0A66",
    twenty_one: "\u0A68\u0A67",
    twenty_two: "\u0A68\u0A68",
    twenty_three: "\u0A68\u0A69",
    twenty_four: "\u0A68\u0A6A",
    twenty_five: "\u0A68\u0A6B",
    twenty_six: "\u0A68\u0A6C",
    twenty_seven: "\u0A68\u0A6D",
    twenty_eight: "\u0A68\u0A6E",
    twenty_nine: "\u0A68\u0A6F",
    thirty: "\u0A69\u0A66",
    thirty_one: "\u0A69\u0A67"
};
const $ddff9b86434e3f59$var$Bengali$4 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF",
    ten: "\u09E7\u09E6",
    eleven: "\u09E7\u09E7",
    twelve: "\u09E7\u09E8",
    thirteen: "\u09E7\u09E9",
    fourteen: "\u09E7\u09EA",
    fifteen: "\u09E7\u09EB",
    sixteen: "\u09E7\u09EC",
    seventeen: "\u09E7\u09ED",
    eighteen: "\u09E7\u09EE",
    nineteen: "\u09E7\u09EF",
    twenty: "\u09E8\u09E6",
    twenty_one: "\u09E8\u09E7",
    twenty_two: "\u09E8\u09E8",
    twenty_three: "\u09E8\u09E9",
    twenty_four: "\u09E8\u09EA",
    twenty_five: "\u09E8\u09EB",
    twenty_six: "\u09E8\u09EC",
    twenty_seven: "\u09E8\u09ED",
    twenty_eight: "\u09E8\u09EE",
    twenty_nine: "\u09E8\u09EF",
    thirty: "\u09E9\u09E6",
    thirty_one: "\u09E9\u09E7"
};
const $ddff9b86434e3f59$var$Tamil$4 = {
    zero: "\u0BE6",
    one: "\u0BE7",
    two: "\u0BE8",
    three: "\u0BE9",
    four: "\u0BEA",
    five: "\u0BEB",
    six: "\u0BEC",
    seven: "\u0BED",
    eight: "\u0BEE",
    nine: "\u0BEF",
    ten: "\u0BE7\u0BE6",
    eleven: "\u0BE7\u0BE7",
    twelve: "\u0BE7\u0BE8",
    thirteen: "\u0BE7\u0BE9",
    fourteen: "\u0BE7\u0BEA",
    fifteen: "\u0BE7\u0BEB",
    sixteen: "\u0BE7\u0BEC",
    seventeen: "\u0BE7\u0BED",
    eighteen: "\u0BE7\u0BEE",
    nineteen: "\u0BE7\u0BEF",
    twenty: "\u0BE8\u0BE6",
    twenty_one: "\u0BE8\u0BE7",
    twenty_two: "\u0BE8\u0BE8",
    twenty_three: "\u0BE8\u0BE9",
    twenty_four: "\u0BE8\u0BEA",
    twenty_five: "\u0BE8\u0BEB",
    twenty_six: "\u0BE8\u0BEC",
    twenty_seven: "\u0BE8\u0BED",
    twenty_eight: "\u0BE8\u0BEE",
    twenty_nine: "\u0BE8\u0BEF",
    thirty: "\u0BE9\u0BE6",
    thirty_one: "\u0BE9\u0BE7"
};
const $ddff9b86434e3f59$var$Telugu$4 = {
    zero: "\u0C66",
    one: "\u0C67",
    two: "\u0C68",
    three: "\u0C69",
    four: "\u0C6A",
    five: "\u0C6B",
    six: "\u0C6C",
    seven: "\u0C6D",
    eight: "\u0C6E",
    nine: "\u0C6F",
    ten: "\u0C67\u0C66",
    eleven: "\u0C67\u0C67",
    twelve: "\u0C67\u0C68",
    thirteen: "\u0C67\u0C69",
    fourteen: "\u0C67\u0C6A",
    fifteen: "\u0C67\u0C6B",
    sixteen: "\u0C67\u0C6C",
    seventeen: "\u0C67\u0C6D",
    eighteen: "\u0C67\u0C6E",
    nineteen: "\u0C67\u0C6F",
    twenty: "\u0C68\u0C66",
    twenty_one: "\u0C68\u0C67",
    twenty_two: "\u0C68\u0C68",
    twenty_three: "\u0C68\u0C69",
    twenty_four: "\u0C68\u0C6A",
    twenty_five: "\u0C68\u0C6B",
    twenty_six: "\u0C68\u0C6C",
    twenty_seven: "\u0C68\u0C6D",
    twenty_eight: "\u0C68\u0C6E",
    twenty_nine: "\u0C68\u0C6F",
    thirty: "\u0C69\u0C66",
    thirty_one: "\u0C69\u0C67"
};
const $ddff9b86434e3f59$var$Kannada$4 = {
    zero: "\u0CE6",
    one: "\u0CE7",
    two: "\u0CE8",
    three: "\u0CE9",
    four: "\u0CEA",
    five: "\u0CEB",
    six: "\u0CEC",
    seven: "\u0CED",
    eight: "\u0CEE",
    nine: "\u0CEF",
    ten: "\u0CE7\u0CE6",
    eleven: "\u0CE7\u0CE7",
    twelve: "\u0CE7\u0CE8",
    thirteen: "\u0CE7\u0CE9",
    fourteen: "\u0CE7\u0CEA",
    fifteen: "\u0CE7\u0CEB",
    sixteen: "\u0CE7\u0CEC",
    seventeen: "\u0CE7\u0CED",
    eighteen: "\u0CE7\u0CEE",
    nineteen: "\u0CE7\u0CEF",
    twenty: "\u0CE8\u0CE6",
    twenty_one: "\u0CE8\u0CE7",
    twenty_two: "\u0CE8\u0CE8",
    twenty_three: "\u0CE8\u0CE9",
    twenty_four: "\u0CE8\u0CEA",
    twenty_five: "\u0CE8\u0CEB",
    twenty_six: "\u0CE8\u0CEC",
    twenty_seven: "\u0CE8\u0CED",
    twenty_eight: "\u0CE8\u0CEE",
    twenty_nine: "\u0CE8\u0CEF",
    thirty: "\u0CE9\u0CE6",
    thirty_one: "\u0CE9\u0CE7"
};
const $ddff9b86434e3f59$var$Assamese$4 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF",
    ten: "\u09E7\u09E6",
    eleven: "\u09E7\u09E7",
    twelve: "\u09E7\u09E8",
    thirteen: "\u09E7\u09E9",
    fourteen: "\u09E7\u09EA",
    fifteen: "\u09E7\u09EB",
    sixteen: "\u09E7\u09EC",
    seventeen: "\u09E7\u09ED",
    eighteen: "\u09E7\u09EE",
    nineteen: "\u09E7\u09EF",
    twenty: "\u09E8\u09E6",
    twenty_one: "\u09E8\u09E7",
    twenty_two: "\u09E8\u09E8",
    twenty_three: "\u09E8\u09E9",
    twenty_four: "\u09E8\u09EA",
    twenty_five: "\u09E8\u09EB",
    twenty_six: "\u09E8\u09EC",
    twenty_seven: "\u09E8\u09ED",
    twenty_eight: "\u09E8\u09EE",
    twenty_nine: "\u09E8\u09EF",
    thirty: "\u09E9\u09E6",
    thirty_one: "\u09E9\u09E7"
};
const $ddff9b86434e3f59$var$Malayalam$4 = {
    zero: "\u0D66",
    one: "\u0D67",
    two: "\u0D68",
    three: "\u0D69",
    four: "\u0D6A",
    five: "\u0D6B",
    six: "\u0D6C",
    seven: "\u0D6D",
    eight: "\u0D6E",
    nine: "\u0D6F",
    ten: "\u0D67\u0D66",
    eleven: "\u0D67\u0D67",
    twelve: "\u0D67\u0D68",
    thirteen: "\u0D67\u0D69",
    fourteen: "\u0D67\u0D6A",
    fifteen: "\u0D67\u0D6B",
    sixteen: "\u0D67\u0D6C",
    seventeen: "\u0D67\u0D6D",
    eighteen: "\u0D67\u0D6E",
    nineteen: "\u0D67\u0D6F",
    twenty: "\u0D68\u0D66",
    twenty_one: "\u0D68\u0D67",
    twenty_two: "\u0D68\u0D68",
    twenty_three: "\u0D68\u0D69",
    twenty_four: "\u0D68\u0D6A",
    twenty_five: "\u0D68\u0D6B",
    twenty_six: "\u0D68\u0D6C",
    twenty_seven: "\u0D68\u0D6D",
    twenty_eight: "\u0D68\u0D6E",
    twenty_nine: "\u0D68\u0D6F",
    thirty: "\u0D69\u0D66",
    thirty_one: "\u0D69\u0D67"
};
const $ddff9b86434e3f59$var$Oriya$4 = {
    zero: "\u0B66",
    one: "\u0B67",
    two: "\u0B68",
    three: "\u0B69",
    four: "\u0B6A",
    five: "\u0B6B",
    six: "\u0B6C",
    seven: "\u0B6D",
    eight: "\u0B6E",
    nine: "\u0B6F",
    ten: "\u0B67\u0B66",
    eleven: "\u0B67\u0B67",
    twelve: "\u0B67\u0B68",
    thirteen: "\u0B67\u0B69",
    fourteen: "\u0B67\u0B6A",
    fifteen: "\u0B67\u0B6B",
    sixteen: "\u0B67\u0B6C",
    seventeen: "\u0B67\u0B6D",
    eighteen: "\u0B67\u0B6E",
    nineteen: "\u0B67\u0B6F",
    twenty: "\u0B68\u0B66",
    twenty_one: "\u0B68\u0B67",
    twenty_two: "\u0B68\u0B68",
    twenty_three: "\u0B68\u0B69",
    twenty_four: "\u0B68\u0B6A",
    twenty_five: "\u0B68\u0B6B",
    twenty_six: "\u0B68\u0B6C",
    twenty_seven: "\u0B68\u0B6D",
    twenty_eight: "\u0B68\u0B6E",
    twenty_nine: "\u0B68\u0B6F",
    thirty: "\u0B69\u0B66",
    thirty_one: "\u0B69\u0B67"
};
const $ddff9b86434e3f59$var$monthDatesData = {
    English: $ddff9b86434e3f59$var$English$4,
    Hindi: $ddff9b86434e3f59$var$Hindi$4,
    Marathi: $ddff9b86434e3f59$var$Marathi$4,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$4,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$4,
    Bengali: $ddff9b86434e3f59$var$Bengali$4,
    Tamil: $ddff9b86434e3f59$var$Tamil$4,
    Telugu: $ddff9b86434e3f59$var$Telugu$4,
    Kannada: $ddff9b86434e3f59$var$Kannada$4,
    Assamese: $ddff9b86434e3f59$var$Assamese$4,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$4,
    Oriya: $ddff9b86434e3f59$var$Oriya$4
};
const $ddff9b86434e3f59$var$English$3 = {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December"
};
const $ddff9b86434e3f59$var$Hindi$3 = {
    January: "\u091C\u0928\u0935\u0930\u0940",
    February: "\u092B\u0930\u0935\u0930\u0940",
    March: "\u092E\u093E\u0930\u094D\u091A",
    April: "\u0905\u092A\u094D\u0930\u0948\u0932",
    May: "\u092E\u0908",
    June: "\u091C\u0942\u0928",
    July: "\u091C\u0941\u0932\u093E\u0908",
    August: "\u0905\u0917\u0938\u094D\u0924",
    September: "\u0938\u093F\u0924\u0902\u092C\u0930",
    October: "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
    November: "\u0928\u0935\u0902\u092C\u0930",
    December: "\u0926\u093F\u0938\u0902\u092C\u0930"
};
const $ddff9b86434e3f59$var$Marathi$3 = {
    January: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940",
    February: "\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940",
    March: "\u092E\u093E\u0930\u094D\u091A",
    April: "\u090F\u092A\u094D\u0930\u093F\u0932",
    May: "\u092E\u0947",
    June: "\u091C\u0942\u0928",
    July: "\u091C\u0941\u0932\u0948",
    August: "\u0911\u0917\u0938\u094D\u091F",
    September: "\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930",
    October: "\u0911\u0915\u094D\u091F\u094B\u092C\u0930",
    November: "\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930",
    December: "\u0921\u093F\u0938\u0947\u0902\u092C\u0930"
};
const $ddff9b86434e3f59$var$Gujarati$3 = {
    January: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
    February: "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
    March: "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
    April: "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
    May: "\u0AAE\u0AC7",
    June: "\u0A9C\u0AC2\u0AA8",
    July: "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
    August: "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
    September: "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
    October: "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
    November: "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
    December: "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
};
const $ddff9b86434e3f59$var$Punjabi$3 = {
    January: "\u0A1C\u0A28\u0A35\u0A30\u0A40",
    February: "\u0A2B\u0A30\u0A35\u0A30\u0A40",
    March: "\u0A2E\u0A3E\u0A30\u0A1A",
    April: "\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32",
    May: "\u0A2E\u0A08",
    June: "\u0A1C\u0A42\u0A28",
    July: "\u0A1C\u0A41\u0A32\u0A3E\u0A08",
    August: "\u0A05\u0A17\u0A38\u0A24",
    September: "\u0A38\u0A24\u0A70\u0A2C\u0A30",
    October: "\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30",
    November: "\u0A28\u0A35\u0A70\u0A2C\u0A30",
    December: "\u0A26\u0A38\u0A70\u0A2C\u0A30"
};
const $ddff9b86434e3f59$var$Bengali$3 = {
    January: "\u099C\u09BE\u09A8\u09C1\u09AF\u09BC\u09BE\u09B0\u09BF",
    February: "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09AF\u09BC\u09BE\u09B0\u09BF",
    March: "\u09AE\u09BE\u09B0\u09CD\u099A",
    April: "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
    May: "\u09AE\u09C7",
    June: "\u099C\u09C1\u09A8",
    July: "\u099C\u09C1\u09B2\u09BE\u0987",
    August: "\u0985\u0997\u09BE\u09B8\u09CD\u099F",
    September: "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
    October: "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
    November: "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
    December: "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
};
const $ddff9b86434e3f59$var$Tamil$3 = {
    January: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
    February: "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
    March: "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
    April: "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
    May: "\u0BAE\u0BC7",
    June: "\u0B9C\u0BC2\u0BA9\u0BCD",
    July: "\u0B9C\u0BC2\u0BB2\u0BC8",
    August: "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BC1",
    September: "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
    October: "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
    November: "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
    December: "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
};
const $ddff9b86434e3f59$var$Telugu$3 = {
    January: "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
    February: "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
    March: "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
    April: "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
    May: "\u0C2E\u0C47",
    June: "\u0C1C\u0C42\u0C28\u0C4D",
    July: "\u0C1C\u0C41\u0C32\u0C48",
    August: "\u0C06\u0C17\u0C37\u0C4D\u0C1F\u0C41",
    September: "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
    October: "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
    November: "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
    December: "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
};
const $ddff9b86434e3f59$var$Kannada$3 = {
    January: "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
    February: "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
    March: "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
    April: "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
    May: "\u0CAE\u0CC7",
    June: "\u0C9C\u0CC2\u0CA8\u0CCD",
    July: "\u0C9C\u0CC1\u0CB2\u0CC8",
    August: "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
    September: "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
    October: "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
    November: "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
    December: "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
};
const $ddff9b86434e3f59$var$Assamese$3 = {
    January: "\u099C\u09BE\u09A8\u09C1\u09F1\u09BE\u09F0\u09C0",
    February: "\u09AB\u09C7\u09AC\u09CD\u09F0\u09C1\u09F1\u09BE\u09F0\u09C0",
    March: "\u09AE\u09BE\u09F0\u09CD\u099A",
    April: "\u098F\u09AA\u09CD\u09F0\u09BF\u09B2",
    May: "\u09AE\u09C7",
    June: "\u099C\u09C1\u09A8",
    July: "\u099C\u09C1\u09B2\u09BE\u0987",
    August: "\u0986\u0997\u09B7\u09CD\u099F",
    September: "\u099B\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09F0",
    October: "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09F0",
    November: "\u09A8\u09F1\u09C7\u09AE\u09CD\u09AC\u09F0",
    December: "\u09A1\u09BF\u099A\u09C7\u09AE\u09CD\u09AC\u09F0"
};
const $ddff9b86434e3f59$var$Malayalam$3 = {
    January: "\u0D1C\u0D28\u0D41\u0D35\u0D30\u0D3F",
    February: "\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41\u0D35\u0D30\u0D3F",
    March: "\u0D2E\u0D3E\u0D7C\u0D1A\u0D4D\u0D1A\u0D4D",
    April: "\u0D0F\u0D2A\u0D4D\u0D30\u0D3F\u0D7D",
    May: "\u0D2E\u0D47\u0D2F\u0D4D",
    June: "\u0D1C\u0D42\u0D7A",
    July: "\u0D1C\u0D42\u0D32\u0D48",
    August: "\u0D13\u0D17\u0D38\u0D4D\u0D31\u0D4D\u0D31\u0D4D",
    September: "\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31\u0D02\u0D2C\u0D7C",
    October: "\u0D12\u0D15\u0D4D\u0D1F\u0D4B\u0D2C\u0D7C",
    November: "\u0D28\u0D35\u0D02\u0D2C\u0D7C",
    December: "\u0D21\u0D3F\u0D38\u0D02\u0D2C\u0D7C"
};
const $ddff9b86434e3f59$var$Oriya$3 = {
    January: "\u0B1C\u0B3E\u0B28\u0B41\u0B06\u0B30\u0B40",
    February: "\u0B2B\u0B47\u0B2C\u0B43\u0B5F\u0B3E\u0B30\u0B40",
    March: "\u0B2E\u0B3E\u0B30\u0B4D\u0B1A\u0B4D",
    April: "\u0B0F\u0B2A\u0B4D\u0B30\u0B3F\u0B32",
    May: "\u0B2E\u0B47",
    June: "\u0B1C\u0B41\u0B28",
    July: "\u0B1C\u0B41\u0B32\u0B3E\u0B07",
    August: "\u0B05\u0B17\u0B37\u0B4D\u0B1F",
    September: "\u0B38\u0B47\u0B2A\u0B4D\u0B1F\u0B47\u0B2E\u0B4D\u0B2C\u0B30",
    October: "\u0B05\u0B15\u0B4D\u0B1F\u0B4B\u0B2C\u0B30",
    November: "\u0B28\u0B2D\u0B47\u0B2E\u0B4D\u0B2C\u0B30",
    December: "\u0B21\u0B3F\u0B38\u0B47\u0B2E\u0B4D\u0B2C\u0B30"
};
const $ddff9b86434e3f59$var$monthNamesData = {
    English: $ddff9b86434e3f59$var$English$3,
    Hindi: $ddff9b86434e3f59$var$Hindi$3,
    Marathi: $ddff9b86434e3f59$var$Marathi$3,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$3,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$3,
    Bengali: $ddff9b86434e3f59$var$Bengali$3,
    Tamil: $ddff9b86434e3f59$var$Tamil$3,
    Telugu: $ddff9b86434e3f59$var$Telugu$3,
    Kannada: $ddff9b86434e3f59$var$Kannada$3,
    Assamese: $ddff9b86434e3f59$var$Assamese$3,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$3,
    Oriya: $ddff9b86434e3f59$var$Oriya$3
};
const $ddff9b86434e3f59$var$English$2 = {
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
    five: "5",
    six: "6",
    seven: "7",
    eight: "8",
    nine: "9"
};
const $ddff9b86434e3f59$var$Hindi$2 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F"
};
const $ddff9b86434e3f59$var$Marathi$2 = {
    zero: "\u0966",
    one: "\u0967",
    two: "\u0968",
    three: "\u0969",
    four: "\u096A",
    five: "\u096B",
    six: "\u096C",
    seven: "\u096D",
    eight: "\u096E",
    nine: "\u096F"
};
const $ddff9b86434e3f59$var$Gujarati$2 = {
    zero: "\u0AE6",
    one: "\u0AE7",
    two: "\u0AE8",
    three: "\u0AE9",
    four: "\u0AEA",
    five: "\u0AEB",
    six: "\u0AEC",
    seven: "\u0AED",
    eight: "\u0AEE",
    nine: "\u0AEF"
};
const $ddff9b86434e3f59$var$Punjabi$2 = {
    zero: "\u0A66",
    one: "\u0A67",
    two: "\u0A68",
    three: "\u0A69",
    four: "\u0A6A",
    five: "\u0A6B",
    six: "\u0A6C",
    seven: "\u0A6D",
    eight: "\u0A6E",
    nine: "\u0A6F"
};
const $ddff9b86434e3f59$var$Bengali$2 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF"
};
const $ddff9b86434e3f59$var$Tamil$2 = {
    zero: "\u0BE6",
    one: "\u0BE7",
    two: "\u0BE8",
    three: "\u0BE9",
    four: "\u0BEA",
    five: "\u0BEB",
    six: "\u0BEC",
    seven: "\u0BED",
    eight: "\u0BEE",
    nine: "\u0BEF"
};
const $ddff9b86434e3f59$var$Telugu$2 = {
    zero: "\u0C66",
    one: "\u0C67",
    two: "\u0C68",
    three: "\u0C69",
    four: "\u0C6A",
    five: "\u0C6B",
    six: "\u0C6C",
    seven: "\u0C6D",
    eight: "\u0C6E",
    nine: "\u0C6F"
};
const $ddff9b86434e3f59$var$Kannada$2 = {
    zero: "\u0CE6",
    one: "\u0CE7",
    two: "\u0CE8",
    three: "\u0CE9",
    four: "\u0CEA",
    five: "\u0CEB",
    six: "\u0CEC",
    seven: "\u0CED",
    eight: "\u0CEE",
    nine: "\u0CEF"
};
const $ddff9b86434e3f59$var$Assamese$2 = {
    zero: "\u09E6",
    one: "\u09E7",
    two: "\u09E8",
    three: "\u09E9",
    four: "\u09EA",
    five: "\u09EB",
    six: "\u09EC",
    seven: "\u09ED",
    eight: "\u09EE",
    nine: "\u09EF"
};
const $ddff9b86434e3f59$var$Malayalam$2 = {
    zero: "\u0D66",
    one: "\u0D67",
    two: "\u0D68",
    three: "\u0D69",
    four: "\u0D6A",
    five: "\u0D6B",
    six: "\u0D6C",
    seven: "\u0D6D",
    eight: "\u0D6E",
    nine: "\u0D6F"
};
const $ddff9b86434e3f59$var$Oriya$2 = {
    zero: "\u0B66",
    one: "\u0B67",
    two: "\u0B68",
    three: "\u0B69",
    four: "\u0B6A",
    five: "\u0B6B",
    six: "\u0B6C",
    seven: "\u0B6D",
    eight: "\u0B6E",
    nine: "\u0B6F"
};
const $ddff9b86434e3f59$var$numberData = {
    English: $ddff9b86434e3f59$var$English$2,
    Hindi: $ddff9b86434e3f59$var$Hindi$2,
    Marathi: $ddff9b86434e3f59$var$Marathi$2,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$2,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$2,
    Bengali: $ddff9b86434e3f59$var$Bengali$2,
    Tamil: $ddff9b86434e3f59$var$Tamil$2,
    Telugu: $ddff9b86434e3f59$var$Telugu$2,
    Kannada: $ddff9b86434e3f59$var$Kannada$2,
    Assamese: $ddff9b86434e3f59$var$Assamese$2,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$2,
    Oriya: $ddff9b86434e3f59$var$Oriya$2
};
const $ddff9b86434e3f59$var$English$1 = {
    Sunday: "S",
    Monday: "M",
    Tuesday: "T",
    Wednesday: "W",
    Thursday: "T",
    Friday: "F",
    Saturday: "S"
};
const $ddff9b86434e3f59$var$Hindi$1 = {
    Sunday: "\u0930",
    Monday: "\u0938\u094B",
    Tuesday: "\u092E\u0902",
    Wednesday: "\u092C\u0941",
    Thursday: "\u0917\u0941",
    Friday: "\u0936\u0941",
    Saturday: "\u0936"
};
const $ddff9b86434e3f59$var$Marathi$1 = {
    Sunday: "\u0930",
    Monday: "\u0938\u094B",
    Tuesday: "\u092E\u0902",
    Wednesday: "\u092C\u0941",
    Thursday: "\u0917\u0941",
    Friday: "\u0936\u0941",
    Saturday: "\u0936"
};
const $ddff9b86434e3f59$var$Gujarati$1 = {
    Sunday: "\u0AB0",
    Monday: "\u0AB8\u0ACB",
    Tuesday: "\u0AAE\u0A82",
    Wednesday: "\u0AAC\u0AC1",
    Thursday: "\u0A97\u0AC1",
    Friday: "\u0AB6\u0AC1",
    Saturday: "\u0AB6"
};
const $ddff9b86434e3f59$var$Punjabi$1 = {
    Sunday: "\u0A10",
    Monday: "\u0A38\u0A4B",
    Tuesday: "\u0A2E\u0A70",
    Wednesday: "\u0A2C\u0A41",
    Thursday: "\u0A35\u0A40",
    Friday: "\u0A36\u0A41",
    Saturday: "\u0A38\u0A3C"
};
const $ddff9b86434e3f59$var$Bengali$1 = {
    Sunday: "\u09B0",
    Monday: "\u09B8\u09CB",
    Tuesday: "\u09AE\u0982",
    Wednesday: "\u09AC\u09C1",
    Thursday: "\u09AC\u09C3",
    Friday: "\u09B6\u09C1",
    Saturday: "\u09B6"
};
const $ddff9b86434e3f59$var$Tamil$1 = {
    Sunday: "\u0B9E\u0BBE",
    Monday: "\u0BA4\u0BBF",
    Tuesday: "\u0B9A\u0BC6",
    Wednesday: "\u0BAA\u0BC1",
    Thursday: "\u0BB5\u0BBF",
    Friday: "\u0BB5\u0BC6",
    Saturday: "\u0B9A"
};
const $ddff9b86434e3f59$var$Telugu$1 = {
    Sunday: "\u0C06",
    Monday: "\u0C38\u0C4B",
    Tuesday: "\u0C2E\u0C02",
    Wednesday: "\u0C2C\u0C41",
    Thursday: "\u0C17\u0C41",
    Friday: "\u0C36\u0C41",
    Saturday: "\u0C36"
};
const $ddff9b86434e3f59$var$Kannada$1 = {
    Sunday: "\u0CAD\u0CBE",
    Monday: "\u0CB8\u0CCB",
    Tuesday: "\u0CAE\u0C82",
    Wednesday: "\u0CAC\u0CC1",
    Thursday: "\u0C97\u0CC1",
    Friday: "\u0CB6\u0CC1",
    Saturday: "\u0CB6"
};
const $ddff9b86434e3f59$var$Assamese$1 = {
    Sunday: "\u09F0",
    Monday: "\u09B8\u09CB",
    Tuesday: "\u09AE\u0982",
    Wednesday: "\u09AC\u09C1",
    Thursday: "\u09AC\u09C3",
    Friday: "\u09B6\u09C1",
    Saturday: "\u09B6"
};
const $ddff9b86434e3f59$var$Malayalam$1 = {
    Sunday: "\u0D1E\u0D3E",
    Monday: "\u0D24\u0D3F",
    Tuesday: "\u0D1A\u0D4A",
    Wednesday: "\u0D2C\u0D41",
    Thursday: "\u0D35\u0D4D\u0D2F",
    Friday: "\u0D35\u0D46",
    Saturday: "\u0D36"
};
const $ddff9b86434e3f59$var$Oriya$1 = {
    Sunday: "\u0B30",
    Monday: "\u0B38\u0B4B",
    Tuesday: "\u0B2E\u0B02",
    Wednesday: "\u0B2C\u0B41",
    Thursday: "\u0B2C\u0B3F",
    Friday: "\u0B36\u0B41",
    Saturday: "\u0B36"
};
const $ddff9b86434e3f59$var$weekdayInitialsData = {
    English: $ddff9b86434e3f59$var$English$1,
    Hindi: $ddff9b86434e3f59$var$Hindi$1,
    Marathi: $ddff9b86434e3f59$var$Marathi$1,
    Gujarati: $ddff9b86434e3f59$var$Gujarati$1,
    Punjabi: $ddff9b86434e3f59$var$Punjabi$1,
    Bengali: $ddff9b86434e3f59$var$Bengali$1,
    Tamil: $ddff9b86434e3f59$var$Tamil$1,
    Telugu: $ddff9b86434e3f59$var$Telugu$1,
    Kannada: $ddff9b86434e3f59$var$Kannada$1,
    Assamese: $ddff9b86434e3f59$var$Assamese$1,
    Malayalam: $ddff9b86434e3f59$var$Malayalam$1,
    Oriya: $ddff9b86434e3f59$var$Oriya$1
};
const $ddff9b86434e3f59$var$English = {
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday"
};
const $ddff9b86434e3f59$var$Hindi = {
    Sunday: "\u0930\u0935\u093F\u0935\u093E\u0930",
    Monday: "\u0938\u094B\u092E\u0935\u093E\u0930",
    Tuesday: "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
    Wednesday: "\u092C\u0941\u0927\u0935\u093E\u0930",
    Thursday: "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
    Friday: "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
    Saturday: "\u0936\u0928\u093F\u0935\u093E\u0930"
};
const $ddff9b86434e3f59$var$Marathi = {
    Sunday: "\u0930\u0935\u093F\u0935\u093E\u0930",
    Monday: "\u0938\u094B\u092E\u0935\u093E\u0930",
    Tuesday: "\u092E\u0902\u0917\u0933\u0935\u093E\u0930",
    Wednesday: "\u092C\u0941\u0927\u0935\u093E\u0930",
    Thursday: "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
    Friday: "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
    Saturday: "\u0936\u0928\u093F\u0935\u093E\u0930"
};
const $ddff9b86434e3f59$var$Gujarati = {
    Sunday: "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0",
    Monday: "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0",
    Tuesday: "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0",
    Wednesday: "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0",
    Thursday: "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0",
    Friday: "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0",
    Saturday: "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0"
};
const $ddff9b86434e3f59$var$Punjabi = {
    Sunday: "\u0A10\u0A24\u0A35\u0A3E\u0A30",
    Monday: "\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30",
    Tuesday: "\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30",
    Wednesday: "\u0A2C\u0A41\u0A71\u0A27\u0A35\u0A3E\u0A30",
    Thursday: "\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30",
    Friday: "\u0A36\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30",
    Saturday: "\u0A38\u0A3C\u0A28\u0A3F\u0A35\u0A3E\u0A30"
};
const $ddff9b86434e3f59$var$Bengali = {
    Sunday: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
    Monday: "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
    Tuesday: "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
    Wednesday: "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
    Thursday: "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
    Friday: "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
    Saturday: "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
};
const $ddff9b86434e3f59$var$Tamil = {
    Sunday: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
    Monday: "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
    Tuesday: "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
    Wednesday: "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
    Thursday: "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
    Friday: "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
    Saturday: "\u0B9A\u0BA9\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8"
};
const $ddff9b86434e3f59$var$Telugu = {
    Sunday: "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
    Monday: "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
    Tuesday: "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
    Wednesday: "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
    Thursday: "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
    Friday: "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
    Saturday: "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
};
const $ddff9b86434e3f59$var$Kannada = {
    Sunday: "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
    Monday: "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
    Tuesday: "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
    Wednesday: "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
    Thursday: "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
    Friday: "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
    Saturday: "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
};
const $ddff9b86434e3f59$var$Assamese = {
    Sunday: "\u09AD\u09BE\u09A8\u09C1\u09F1\u09BE\u09B0",
    Monday: "\u09B8\u09CB\u09AE\u09AC\u09BE\u09F0",
    Tuesday: "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09F0",
    Wednesday: "\u09AC\u09C1\u09A7\u09AC\u09BE\u09F0",
    Thursday: "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09F0",
    Friday: "\u09B6\u09C1\u0995\u09CD\u09F0\u09AC\u09BE\u09F0",
    Saturday: "\u09B6\u09A8\u09BF\u09AC\u09BE\u09F0"
};
const $ddff9b86434e3f59$var$Malayalam = {
    Sunday: "\u0D1E\u0D3E\u0D2F\u0D31\u0D3E\u0D34\u0D4D\u0D1A",
    Monday: "\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D33\u0D3E\u0D34\u0D4D\u0D1A",
    Tuesday: "\u0D1A\u0D4A\u0D35\u0D4D\u0D35\u0D3E\u0D34\u0D4D\u0D1A",
    Wednesday: "\u0D2C\u0D41\u0D27\u0D28\u0D3E\u0D34\u0D4D\u0D1A",
    Thursday: "\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D3E\u0D34\u0D4D\u0D1A",
    Friday: "\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A",
    Saturday: "\u0D36\u0D28\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A"
};
const $ddff9b86434e3f59$var$Oriya = {
    Sunday: "\u0B30\u0B2C\u0B3F\u0B2C\u0B3E\u0B30",
    Monday: "\u0B38\u0B4B\u0B2E\u0B2C\u0B3E\u0B30",
    Tuesday: "\u0B2E\u0B19\u0B4D\u0B17\u0B33\u0B2C\u0B3E\u0B30",
    Wednesday: "\u0B2C\u0B41\u0B27\u0B2C\u0B3E\u0B30",
    Thursday: "\u0B2C\u0B43\u0B39\u0B38\u0B4D\u0B2A\u0B24\u0B3F\u0B2C\u0B3E\u0B30",
    Friday: "\u0B36\u0B41\u0B15\u0B4D\u0B30\u0B2C\u0B3E\u0B30",
    Saturday: "\u0B36\u0B28\u0B3F\u0B2C\u0B3E\u0B30"
};
const $ddff9b86434e3f59$var$weekdayNamesData = {
    English: $ddff9b86434e3f59$var$English,
    Hindi: $ddff9b86434e3f59$var$Hindi,
    Marathi: $ddff9b86434e3f59$var$Marathi,
    Gujarati: $ddff9b86434e3f59$var$Gujarati,
    Punjabi: $ddff9b86434e3f59$var$Punjabi,
    Bengali: $ddff9b86434e3f59$var$Bengali,
    Tamil: $ddff9b86434e3f59$var$Tamil,
    Telugu: $ddff9b86434e3f59$var$Telugu,
    Kannada: $ddff9b86434e3f59$var$Kannada,
    Assamese: $ddff9b86434e3f59$var$Assamese,
    Malayalam: $ddff9b86434e3f59$var$Malayalam,
    Oriya: $ddff9b86434e3f59$var$Oriya
};
const $ddff9b86434e3f59$var$LOCALE_LANGUAGE_MAP = $ddff9b86434e3f59$var$localeLanguageData;
const $ddff9b86434e3f59$var$MONTH_DATES = $ddff9b86434e3f59$var$monthDatesData;
const $ddff9b86434e3f59$var$NUMBERS = $ddff9b86434e3f59$var$numberData;
const $ddff9b86434e3f59$var$WEEKDAY_INITIALS = $ddff9b86434e3f59$var$weekdayInitialsData;
const $ddff9b86434e3f59$var$WEEKDAY_NAMES = $ddff9b86434e3f59$var$weekdayNamesData;
const $ddff9b86434e3f59$var$MONTH_NAMES = $ddff9b86434e3f59$var$monthNamesData;
const $ddff9b86434e3f59$var$CONFIRM_BUTTON = $ddff9b86434e3f59$var$confirmButtonData;
const $ddff9b86434e3f59$var$OF = $ddff9b86434e3f59$var$ofData;
const $ddff9b86434e3f59$var$weekdayKeys = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $ddff9b86434e3f59$var$monthKeys = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $ddff9b86434e3f59$var$monthDateKeys = [
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
    "twenty",
    "twenty_one",
    "twenty_two",
    "twenty_three",
    "twenty_four",
    "twenty_five",
    "twenty_six",
    "twenty_seven",
    "twenty_eight",
    "twenty_nine",
    "thirty",
    "thirty_one"
];
const $ddff9b86434e3f59$var$numberKeys = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine"
];
function $ddff9b86434e3f59$export$e085862dfb8d71(locale) {
    return $ddff9b86434e3f59$var$LOCALE_LANGUAGE_MAP[locale];
}
function $ddff9b86434e3f59$export$4ee93fd31f185549(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const dates = $ddff9b86434e3f59$var$MONTH_DATES[language];
    return $ddff9b86434e3f59$var$monthDateKeys.map((key)=>dates[key]);
}
function $ddff9b86434e3f59$export$cae41416faa27367(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const names = $ddff9b86434e3f59$var$MONTH_NAMES[language];
    return $ddff9b86434e3f59$var$monthKeys.map((key)=>names[key]);
}
function $ddff9b86434e3f59$export$3f81e69b9bc596cd(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const numbers = $ddff9b86434e3f59$var$NUMBERS[language];
    return $ddff9b86434e3f59$var$numberKeys.map((key)=>numbers[key]);
}
function $ddff9b86434e3f59$export$3d12634d88530fee(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const initials = $ddff9b86434e3f59$var$WEEKDAY_INITIALS[language];
    return $ddff9b86434e3f59$var$weekdayKeys.map((key)=>initials[key]);
}
function $ddff9b86434e3f59$export$bd4a8430f86abf7b(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const names = $ddff9b86434e3f59$var$WEEKDAY_NAMES[language];
    return $ddff9b86434e3f59$var$weekdayKeys.map((key)=>names[key]);
}
function $ddff9b86434e3f59$export$6d8d0ec03e692fdc(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const labelObj = $ddff9b86434e3f59$var$CONFIRM_BUTTON[language];
    return Object.values(labelObj)[0];
}
function $ddff9b86434e3f59$export$fb5267b92d6c6cd3(locale = "en") {
    const language = $ddff9b86434e3f59$export$e085862dfb8d71(locale);
    const ofObj = $ddff9b86434e3f59$var$OF[language];
    return Object.values(ofObj)[0];
}
const $ddff9b86434e3f59$export$8793edee2d425525 = ()=>{};
const $ddff9b86434e3f59$export$b806f3e5b648e4a8 = (cb, deps = [])=>{
    const [element, setElement] = (0, $1OEoy.useState)(null);
    const rootRef = (0, $1OEoy.useCallback)((element2)=>{
        setElement(element2);
        cb?.(element2);
    }, [
        ...deps
    ]);
    return {
        element: element,
        rootRef: rootRef
    };
};



var $1OEoy = parcelRequire("1OEoy");
const $451487d20aa3eb8a$var$sdl$2c = {
    "metadata": {
        "version": "1.0.0",
        "id": "icon-1.0.0",
        "name": "JDSIcon",
        "layerName": "jds_icon"
    },
    "hierarchy": {
        "container": [
            "icon",
            "lottie"
        ]
    },
    "base": {
        "container": {
            "background-color": "{icon_0}",
            "border-radius": "{icon_1}",
            "size": "{icon_2}",
            "justify-content": "{icon_3}",
            "align-items": "{icon_4}"
        },
        "icon": {
            "size": "{icon_5}",
            "color": "{icon_6}"
        },
        "lottie": {
            "hidden": true,
            "size": "{icon_5}",
            "repeat": true
        }
    },
    "variant": {
        "kind": {
            "background": {},
            "background_bold": {},
            "inverse": {}
        },
        "color": {
            "primary_50": {
                "icon": {
                    "color": "{icon_7}"
                }
            },
            "primary_30": {
                "icon": {
                    "color": "{icon_8}"
                }
            },
            "primary_60": {
                "icon": {
                    "color": "{icon_9}"
                }
            },
            "primary_70": {
                "icon": {
                    "color": "{icon_10}"
                }
            },
            "primary_background": {
                "icon": {
                    "color": "{icon_11}"
                }
            },
            "secondary_50": {
                "icon": {
                    "color": "{icon_12}"
                }
            },
            "sparkle_50": {
                "icon": {
                    "color": "{icon_13}"
                }
            },
            "primary_grey_60": {
                "icon": {
                    "color": "{icon_14}"
                }
            },
            "primary_grey_80": {
                "icon": {
                    "color": "{icon_15}"
                }
            },
            "primary_grey_100": {
                "icon": {
                    "color": "{icon_16}"
                }
            },
            "feedback_success": {
                "icon": {
                    "color": "{icon_17}",
                    "value": "ic_success_colored"
                }
            },
            "feedback_error": {
                "icon": {
                    "color": "{icon_18}",
                    "value": "ic_error_colored"
                }
            },
            "feedback_warning": {
                "icon": {
                    "color": "{icon_19}",
                    "value": "ic_warning_colored"
                }
            },
            "feedback_success_50": {
                "icon": {
                    "color": "{icon_17}"
                }
            },
            "feedback_error_50": {
                "icon": {
                    "color": "{icon_18}"
                }
            },
            "feedback_warning_50": {
                "icon": {
                    "color": "{icon_19}"
                }
            },
            "white": {
                "icon": {
                    "color": "{icon_20}"
                }
            },
            "none": {
                "icon": {
                    "color": ""
                }
            }
        },
        "size": {
            "small": {
                "container": {
                    "size": "{icon_21}"
                },
                "icon": {
                    "size": "{icon_22}"
                },
                "lottie": {
                    "size": "{icon_22}"
                }
            },
            "large": {
                "container": {
                    "size": "{icon_23}"
                },
                "icon": {
                    "size": "{icon_24}"
                },
                "lottie": {
                    "size": "{icon_24}"
                }
            },
            "xtra-large": {
                "container": {
                    "size": "{icon_25}"
                },
                "icon": {
                    "size": "{icon_26}"
                },
                "lottie": {
                    "size": "{icon_26}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "size": "{icon_27}"
                },
                "icon": {
                    "size": "{icon_28}"
                },
                "lottie": {
                    "size": "{icon_28}"
                }
            }
        },
        "_isLottieVisible": {
            "true": {
                "lottie": {
                    "hidden": false
                },
                "icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "background": {
                "primary_50": {
                    "container": {
                        "background-color": "{icon_31}"
                    }
                },
                "primary_30": {
                    "container": {
                        "background-color": "{icon_32}"
                    }
                },
                "primary_60": {
                    "container": {
                        "background-color": "{icon_33}"
                    }
                },
                "primary_70": {
                    "container": {
                        "background-color": "{icon_34}"
                    }
                },
                "primary_background": {
                    "container": {
                        "background-color": "{icon_35}"
                    }
                },
                "secondary_50": {
                    "container": {
                        "background-color": "{icon_36}"
                    }
                },
                "sparkle_50": {
                    "container": {
                        "background-color": "{icon_37}"
                    }
                },
                "primary_grey_60": {
                    "container": {
                        "background-color": "{icon_38}"
                    }
                },
                "primary_grey_80": {
                    "container": {
                        "background-color": "{icon_39}"
                    }
                },
                "primary_grey_100": {
                    "container": {
                        "background-color": "{icon_40}"
                    }
                },
                "white": {
                    "container": {
                        "background-color": "{icon_41}"
                    }
                },
                "feedback_success_50": {
                    "container": {
                        "background-color": "{icon_42}"
                    }
                },
                "feedback_error_50": {
                    "container": {
                        "background-color": "{icon_43}"
                    }
                },
                "feedback_warning_50": {
                    "container": {
                        "background-color": "{icon_44}"
                    }
                }
            },
            "background_bold": {
                "primary_50": {
                    "container": {
                        "background-color": "{icon_45}"
                    },
                    "icon": {
                        "color": "{icon_46}"
                    }
                },
                "primary_30": {
                    "container": {
                        "background-color": "{icon_47}"
                    },
                    "icon": {
                        "color": "{icon_48}"
                    }
                },
                "primary_60": {
                    "container": {
                        "background-color": "{icon_49}"
                    },
                    "icon": {
                        "color": "{icon_50}"
                    }
                },
                "primary_70": {
                    "container": {
                        "background-color": "{icon_51}"
                    },
                    "icon": {
                        "color": "{icon_52}"
                    }
                },
                "primary_background": {
                    "container": {
                        "background-color": "{icon_53}"
                    },
                    "icon": {
                        "color": "{icon_54}"
                    }
                },
                "secondary_50": {
                    "container": {
                        "background-color": "{icon_55}"
                    },
                    "icon": {
                        "color": "{icon_56}"
                    }
                },
                "sparkle_50": {
                    "container": {
                        "background-color": "{icon_57}"
                    },
                    "icon": {
                        "color": "{icon_58}"
                    }
                },
                "primary_grey_60": {
                    "container": {
                        "background-color": "{icon_59}"
                    },
                    "icon": {
                        "color": "{icon_60}"
                    }
                },
                "primary_grey_80": {
                    "container": {
                        "background-color": "{icon_61}"
                    },
                    "icon": {
                        "color": "{icon_62}"
                    }
                },
                "primary_grey_100": {
                    "container": {
                        "background-color": "{icon_63}"
                    },
                    "icon": {
                        "color": "{icon_64}"
                    }
                },
                "white": {
                    "container": {
                        "background-color": "{icon_65}"
                    },
                    "icon": {
                        "color": "{icon_66}"
                    }
                },
                "feedback_success_50": {
                    "container": {
                        "background-color": "{icon_67}"
                    },
                    "icon": {
                        "color": "{icon_68}"
                    }
                },
                "feedback_error_50": {
                    "container": {
                        "background-color": "{icon_69}"
                    },
                    "icon": {
                        "color": "{icon_70}"
                    }
                },
                "feedback_warning_50": {
                    "container": {
                        "background-color": "{icon_71}"
                    },
                    "icon": {
                        "color": "{icon_72}"
                    }
                }
            },
            "inverse": {
                "primary_50": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_30": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_60": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_70": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_background": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "secondary_50": {
                    "icon": {
                        "color": "{icon_171}"
                    }
                },
                "sparkle_50": {
                    "icon": {
                        "color": "{icon_172}"
                    }
                },
                "primary_grey_60": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_grey_80": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "primary_grey_100": {
                    "icon": {
                        "color": "{icon_170}"
                    }
                },
                "feedback_success_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                },
                "feedback_error_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                },
                "feedback_warning_50": {
                    "icon": {
                        "color": "{icon_173}"
                    }
                }
            }
        },
        {
            "medium": {
                "background": {
                    "container": {
                        "size": "{icon_73}"
                    },
                    "icon": {
                        "size": "{icon_74}"
                    },
                    "lottie": {
                        "size": "{icon_74}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_112}"
                    },
                    "icon": {
                        "size": "{icon_113}"
                    },
                    "lottie": {
                        "size": "{icon_113}"
                    }
                }
            },
            "small": {
                "background": {
                    "container": {
                        "size": "{icon_75}",
                        "background-color": "{icon_76}"
                    },
                    "icon": {
                        "size": "{icon_77}"
                    },
                    "lottie": {
                        "size": "{icon_77}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_114}"
                    },
                    "icon": {
                        "size": "{icon_115}"
                    },
                    "lottie": {
                        "size": "{icon_115}"
                    }
                }
            },
            "large": {
                "background": {
                    "container": {
                        "size": "{icon_78}"
                    },
                    "icon": {
                        "size": "{icon_79}"
                    },
                    "lottie": {
                        "size": "{icon_79}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_116}"
                    },
                    "icon": {
                        "size": "{icon_117}"
                    },
                    "lottie": {
                        "size": "{icon_117}"
                    }
                }
            },
            "xtra-large": {
                "background": {
                    "container": {
                        "size": "{icon_80}"
                    },
                    "icon": {
                        "size": "{icon_81}"
                    },
                    "lottie": {
                        "size": "{icon_81}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_118}"
                    },
                    "icon": {
                        "size": "{icon_119}"
                    },
                    "lottie": {
                        "size": "{icon_119}"
                    }
                }
            },
            "xtra-xtra-large": {
                "background": {
                    "container": {
                        "size": "{icon_82}"
                    },
                    "icon": {
                        "size": "{icon_83}"
                    },
                    "lottie": {
                        "size": "{icon_83}"
                    }
                },
                "background_bold": {
                    "container": {
                        "size": "{icon_120}"
                    },
                    "icon": {
                        "size": "{icon_121}"
                    },
                    "lottie": {
                        "size": "{icon_121}"
                    }
                }
            }
        },
        {
            "small": {
                "background_bold": {
                    "primary_50": {
                        "container": {
                            "background-color": "{icon_84}"
                        },
                        "icon": {
                            "color": "{icon_85}"
                        }
                    },
                    "primary_30": {
                        "container": {
                            "background-color": "{icon_86}"
                        },
                        "icon": {
                            "color": "{icon_87}"
                        }
                    },
                    "primary_60": {
                        "container": {
                            "background-color": "{icon_88}"
                        },
                        "icon": {
                            "color": "{icon_89}"
                        }
                    },
                    "primary_70": {
                        "container": {
                            "background-color": "{icon_90}"
                        },
                        "icon": {
                            "color": "{icon_91}"
                        }
                    },
                    "primary_background": {
                        "container": {
                            "background-color": "{icon_92}"
                        },
                        "icon": {
                            "color": "{icon_93}"
                        }
                    },
                    "secondary_50": {
                        "container": {
                            "background-color": "{icon_94}"
                        },
                        "icon": {
                            "color": "{icon_95}"
                        }
                    },
                    "sparkle_50": {
                        "container": {
                            "background-color": "{icon_96}"
                        },
                        "icon": {
                            "color": "{icon_97}"
                        }
                    },
                    "primary_grey_60": {
                        "container": {
                            "background-color": "{icon_98}"
                        },
                        "icon": {
                            "color": "{icon_99}"
                        }
                    },
                    "primary_grey_80": {
                        "container": {
                            "background-color": "{icon_100}"
                        },
                        "icon": {
                            "color": "{icon_101}"
                        }
                    },
                    "primary_grey_100": {
                        "container": {
                            "background-color": "{icon_102}"
                        },
                        "icon": {
                            "color": "{icon_103}"
                        }
                    },
                    "white": {
                        "container": {
                            "background-color": "{icon_104}"
                        },
                        "icon": {
                            "color": "{icon_105}"
                        }
                    },
                    "feedback_success_50": {
                        "container": {
                            "background-color": "{icon_106}"
                        },
                        "icon": {
                            "color": "{icon_107}"
                        }
                    },
                    "feedback_error_50": {
                        "container": {
                            "background-color": "{icon_108}"
                        },
                        "icon": {
                            "color": "{icon_109}"
                        }
                    },
                    "feedback_warning_50": {
                        "container": {
                            "background-color": "{icon_110}"
                        },
                        "icon": {
                            "color": "{icon_111}"
                        }
                    }
                }
            },
            "medium": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_122}"
                        },
                        "icon": {
                            "size": "{icon_125}"
                        },
                        "lottie": {
                            "size": "{icon_125}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_123}"
                        },
                        "icon": {
                            "size": "{icon_126}"
                        },
                        "lottie": {
                            "size": "{icon_126}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_124}"
                        },
                        "icon": {
                            "size": "{icon_127}"
                        },
                        "lottie": {
                            "size": "{icon_127}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_128}"
                        },
                        "icon": {
                            "size": "{icon_131}"
                        },
                        "lottie": {
                            "size": "{icon_131}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_129}"
                        },
                        "icon": {
                            "size": "{icon_132}"
                        },
                        "lottie": {
                            "size": "{icon_132}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_130}"
                        },
                        "icon": {
                            "size": "{icon_133}"
                        },
                        "lottie": {
                            "size": "{icon_133}"
                        }
                    }
                }
            },
            "large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_135}"
                        },
                        "icon": {
                            "size": "{icon_137}"
                        },
                        "lottie": {
                            "size": "{icon_137}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_136}"
                        },
                        "icon": {
                            "size": "{icon_138}"
                        },
                        "lottie": {
                            "size": "{icon_138}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_136}"
                        },
                        "icon": {
                            "size": "{icon_139}"
                        },
                        "lottie": {
                            "size": "{icon_139}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_140}"
                        },
                        "icon": {
                            "size": "{icon_143}"
                        },
                        "lottie": {
                            "size": "{icon_143}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_141}"
                        },
                        "icon": {
                            "size": "{icon_144}"
                        },
                        "lottie": {
                            "size": "{icon_144}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_142}"
                        },
                        "icon": {
                            "size": "{icon_145}"
                        },
                        "lottie": {
                            "size": "{icon_145}"
                        }
                    }
                }
            },
            "xtra-large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_146}"
                        },
                        "icon": {
                            "size": "{icon_149}"
                        },
                        "lottie": {
                            "size": "{icon_149}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_147}"
                        },
                        "icon": {
                            "size": "{icon_150}"
                        },
                        "lottie": {
                            "size": "{icon_150}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_148}"
                        },
                        "icon": {
                            "size": "{icon_151}"
                        },
                        "lottie": {
                            "size": "{icon_151}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_152}"
                        },
                        "icon": {
                            "size": "{icon_155}"
                        },
                        "lottie": {
                            "size": "{icon_155}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_153}"
                        },
                        "icon": {
                            "size": "{icon_156}"
                        },
                        "lottie": {
                            "size": "{icon_156}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_154}"
                        },
                        "icon": {
                            "size": "{icon_157}"
                        },
                        "lottie": {
                            "size": "{icon_157}"
                        }
                    }
                }
            },
            "xtra-xtra-large": {
                "background": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_158}"
                        },
                        "icon": {
                            "size": "{icon_161}"
                        },
                        "lottie": {
                            "size": "{icon_161}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_159}"
                        },
                        "icon": {
                            "size": "{icon_162}"
                        },
                        "lottie": {
                            "size": "{icon_162}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_160}"
                        },
                        "icon": {
                            "size": "{icon_163}"
                        },
                        "lottie": {
                            "size": "{icon_163}"
                        }
                    }
                },
                "background_bold": {
                    "feedback_success": {
                        "container": {
                            "size": "{icon_164}"
                        },
                        "icon": {
                            "size": "{icon_167}"
                        },
                        "lottie": {
                            "size": "{icon_167}"
                        }
                    },
                    "feedback_error": {
                        "container": {
                            "size": "{icon_165}"
                        },
                        "icon": {
                            "size": "{icon_168}"
                        },
                        "lottie": {
                            "size": "{icon_168}"
                        }
                    },
                    "feedback_warning": {
                        "container": {
                            "size": "{icon_166}"
                        },
                        "icon": {
                            "size": "{icon_169}"
                        },
                        "lottie": {
                            "size": "{icon_169}"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "color"
        ],
        [
            "size",
            "kind"
        ],
        [
            "size",
            "kind",
            "color"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ],
                "doc_description": "It can be used to control size of icon. Please note that the actual size of the icon inside will vary based on the `kind` selected."
            },
            "color": {
                "values": [
                    "primary_50",
                    "primary_30",
                    "primary_60",
                    "primary_70",
                    "primary_background",
                    "secondary_50",
                    "sparkle_50",
                    "primary_grey_60",
                    "primary_grey_80",
                    "primary_grey_100",
                    "feedback_success",
                    "feedback_error",
                    "feedback_warning",
                    "feedback_success_50",
                    "feedback_error_50",
                    "feedback_warning_50",
                    "white",
                    "none"
                ]
            },
            "kind": {
                "values": [
                    "default",
                    "background",
                    "background_bold",
                    "inverse"
                ],
                "doc_description": "It can be used to switch between 3 variants of Icon. 'background-bold' sets color prop as bg, Icon color is inverse of that."
            },
            "_isLottieVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "size": {
                    "type": "size",
                    "name": "customSize",
                    "function": true
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "required": false
                },
                "size": {
                    "type": "size",
                    "name": "_size",
                    "function": true
                }
            },
            "lottie": {
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
                },
                "attributes": {
                    "type": "object",
                    "name": "lottieAttributes",
                    "platform": "android, ios",
                    "required": false,
                    "object": {
                        "repeatCount": "number",
                        "maxRetryCount": "number",
                        "speed": "float",
                        "isPlaying": "boolean",
                        "reverseOnRepeat": "boolean",
                        "clipSpec": "LottieClipSpec"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$sdl$2b = {
    "metadata": {
        "version": "1.0.0",
        "id": "accordion-1.0.0",
        "name": "JDSAccordion",
        "layerName": "jds_accordion",
        "description": "An accordion is a list of headers that hide or reveal additional content when expanded.",
        "usage": "Accordion is used when users only need a few specific pieces of content within a page."
    },
    "hierarchy": {
        "container": [
            {
                "accordion-header-container": [
                    "prefix-slot",
                    {
                        "text-container": [
                            "title-jds-text",
                            "subtitle-jds-text"
                        ]
                    },
                    "jds_button"
                ]
            },
            {
                "children-container": [
                    {
                        "child-content-container": [
                            "content-slot"
                        ]
                    }
                ]
            },
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{a_0}",
            "opacity": "{a_15}",
            "width": "{a_1}"
        },
        "accordion-header-container": {
            "flex-direction": "{a_2}",
            "align-items": "{a_3}",
            "justify-content": "{a_4}",
            "width": "{a_5}",
            "padding-top": "{a_6}",
            "gap": "{a_7}"
        },
        "text-container": {
            "flex-direction": "{a_8}",
            "justify-content": "{a_9}",
            "align-items": "{a_10}",
            "gap": "{a_11}",
            "flex": 1
        },
        "jds_button": {
            "icon": "ic_add",
            "kind": "tertiary",
            "size": "medium",
            "state": "normal"
        },
        "children-container": {
            "hidden": true,
            "padding-top": "{a_12}",
            "width": "{a_13}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "overflow": "hidden",
            "transition": {
                "property": [
                    "max-height",
                    "padding-top"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        },
        "child-content-container": {
            "width": "{a_14}"
        },
        "jds_divider": {
            "orientation": "horizontal",
            "pad": "xtra-xtra-small",
            "padPosition": "top"
        },
        "title-jds-text": {
            "font-family": "{listTitle}",
            "color": "{primaryGrey100}",
            "font-size": "{listTitle}",
            "line-height": "{listTitle}",
            "letter-spacing": "{listTitle}",
            "font-weight": "{listTitle}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "subtitle-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_17}"
                },
                "accordion-header-container": {
                    "disabled": true
                },
                "jds_button": {
                    "disabled": true
                }
            }
        },
        "expandedPanel": {
            "true": {
                "children-container": {
                    "hidden": false,
                    "padding-top": "{a_16}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "showDivider": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "plus": {
                "true": {
                    "jds_button": {
                        "icon": "{a_18}"
                    }
                },
                "false": {
                    "jds_button": {
                        "icon": "{a_19}"
                    }
                }
            },
            "chevron": {
                "true": {
                    "jds_button": {
                        "icon": "{a_20}"
                    }
                },
                "false": {
                    "jds_button": {
                        "icon": "{a_21}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "iconType",
            "expandedPanel"
        ]
    ],
    "api": {
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "It can be used to display content as children of Accordion."
            },
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1,
                "doc_description": "It can be used to display `avatar` or `icon` to the left of text."
            }
        },
        "config": {
            "expandedPanel": {
                "values": [
                    false,
                    true
                ],
                "doc-description": "If false/undefined, only allows one accordionPanel to be expanded by collapsing others on each click."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Accordion."
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            },
            "iconType": {
                "values": [
                    "chevron",
                    "plus"
                ],
                "doc_description": "The icon to be displayed. The plus icon changes to a minus icon when the corresponding panel is expanded."
            }
        },
        "data": {
            "children-container": {
                "max-height": {
                    "name": "_childrenHeight",
                    "type": "size"
                }
            },
            "title-jds-text": {
                "value": {
                    "name": "title",
                    "type": "string",
                    "doc_description": "This displays the title of Accordion."
                }
            },
            "subtitle-jds-text": {
                "value": {
                    "name": "subtitle",
                    "type": "string",
                    "doc_description": "This displays the subtitle of Accordion."
                }
            }
        },
        "events": {
            "accordion-header-container": {
                "onClick": "onClick"
            },
            "jds_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "accordion-header-container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "expandedPanel"
                    },
                    "aria-controls": {
                        "name": "_ariaControls"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $451487d20aa3eb8a$var$getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
const $451487d20aa3eb8a$var$modifyProps = (props, map)=>{
    if (!props) return {};
    if (!map) return props;
    let finalProps = {
        ...props
    };
    const modifedProps = map(props);
    Object.entries(modifedProps).forEach(([key, obj])=>{
        const { properties: properties, variations: variations, defaultValue: defaultValue } = obj;
        const currentValue = props[key];
        if (typeof currentValue !== "undefined") {
            if (Object.keys(properties || {}).length) finalProps = {
                ...finalProps,
                ...properties
            };
            if (variations?.[currentValue]) finalProps = {
                ...finalProps,
                ...variations?.[currentValue]
            };
        } else if (defaultValue) finalProps = {
            ...finalProps,
            ...variations?.[defaultValue]
        };
    });
    return finalProps;
};
const $451487d20aa3eb8a$var$withModifiedProps = (Component, map)=>(props)=>{
        if (!map) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
        Component.displayName = $451487d20aa3eb8a$var$getDisplayName(Component);
        const finalProps = $451487d20aa3eb8a$var$modifyProps(props, map);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            ...finalProps
        });
    };
const $451487d20aa3eb8a$var$get = (obj, path, defValue)=>{
    if (!path) return void 0;
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    const result = pathArray?.reduce((prevObj, key)=>prevObj && prevObj[key], obj);
    return result === void 0 ? defValue : result;
};
const $451487d20aa3eb8a$var$debounce = (fn, wait, immediate = false)=>{
    let timeoutId;
    return function(...args) {
        const later = ()=>{
            timeoutId = null;
            if (!immediate) fn.apply(this, args);
        };
        const callNow = immediate && !timeoutId;
        timeoutId !== null && clearTimeout(timeoutId);
        timeoutId = setTimeout(later, wait);
        if (callNow) fn.apply(this, args);
    };
};
const $451487d20aa3eb8a$var$convertTextToComponent = (children)=>{
    if (typeof children === "string" && children.length) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$5f1af8db9871e1d6, {
        text: children
    });
    return children || null;
};
const $451487d20aa3eb8a$var$resolvePropObjectKeys = (prop, objPath, defValue)=>{
    if (!prop) return void 0;
    if (typeof prop === "string") return prop;
    return $451487d20aa3eb8a$var$get(prop, objPath, defValue);
};
const $451487d20aa3eb8a$var$useRootRef = (cb, deps = [])=>{
    const [element, setElement] = (0, $1OEoy.useState)(null);
    const rootRef = (0, $1OEoy.useCallback)((element2)=>{
        setElement(element2);
        cb?.(element2);
    }, [
        ...deps
    ]);
    return {
        element: element,
        rootRef: rootRef
    };
};
const $451487d20aa3eb8a$var$PROP_MAP$v = (props)=>{
    return {
        header: {
            properties: {
                title: props.title || props.header?.title || props.header?.titleBlock?.text || props.header,
                subtitle: props.subtitle || props.header?.titleBlock?.helper,
                prefix: props.prefix || props.header?.prefix
            }
        },
        children: {
            properties: {
                children: $451487d20aa3eb8a$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$2f = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$v);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const childContainer = element?.querySelector('div[data-testid="JDSAccordion-child-content-container"]');
        const [childrenHeight, setChildrenHeight] = (0, $1OEoy.useState)(0);
        (0, $1OEoy.useEffect)(()=>{
            if (!childContainer || !props.expandedPanel) return;
            const updateHeight = ()=>{
                requestAnimationFrame(()=>{
                    setChildrenHeight(childContainer.offsetHeight + 16);
                });
            };
            updateHeight();
            const resizeObserver = new ResizeObserver(updateHeight);
            resizeObserver.observe(childContainer);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            childContainer,
            props.expandedPanel,
            props.children
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _ariaControls: "children-container",
                _childrenHeight: props.expandedPanel ? childrenHeight : 0
            }
        });
    };
const $451487d20aa3eb8a$var$Component$2g = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$2b;
    const { expandedPanel: expandedPanel = false, disabled: disabled = false, showDivider: showDivider = true, iconType: iconType = "chevron", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), _ariaExpanded: _ariaExpanded = props.expandedPanel?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            expandedPanel: expandedPanel,
            disabled: disabled,
            showDivider: showDivider,
            iconType: iconType,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAccordion", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$7cad6f17fd6e117b = $451487d20aa3eb8a$var$withLogic$2f($451487d20aa3eb8a$var$Component$2g);
$451487d20aa3eb8a$export$7cad6f17fd6e117b.displayName = "AccordionPanel";
$451487d20aa3eb8a$export$7cad6f17fd6e117b.slotName = "jds_accordion";
const $451487d20aa3eb8a$var$sdl$2a = {
    "metadata": {
        "version": "1.0.0",
        "id": "action-button-1.0.0",
        "name": "JDSActionButton",
        "layerName": "jds_action_button"
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    "left-icon",
                    "jds-text",
                    "right-icon"
                ]
            },
            "loader"
        ]
    },
    "base": {
        "container": {
            "background-color": "{a_0}",
            "opacity": "{a_1}",
            "flex-direction": "{a_2}",
            "align-items": "{a_3}",
            "justify-content": "{a_4}",
            "border-radius": "{a_5}"
        },
        "inner-container": {
            "opacity": "{a_64}",
            "border-width": "{a_24}",
            "background-color": "{a_6}",
            "flex-direction": "{a_7}",
            "align-items": "{a_8}",
            "justify-content": "{a_9}",
            "border-radius": "{a_10}",
            "padding-top": "{a_11}",
            "padding-right": "{a_12}",
            "padding-bottom": "{a_13}",
            "padding-left": "{a_14}",
            "gap": "{a_15}",
            "transition": {
                "property": [
                    "background-color",
                    "border-width",
                    "border-color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "background-color": "{a_16}"
                },
                "active": {
                    "background-color": "{a_17}"
                },
                "focus": {
                    "border-width": "{a_18}",
                    "border-color": "{a_19}"
                }
            }
        },
        "loader": {
            "hidden": true,
            "color": "{a_20}",
            "background-color": "{a_21}",
            "track-color": "{a_22}",
            "border-width": "{a_23}",
            "opacity": "{a_25}",
            "size": "{a_26}",
            "z-index": 1
        },
        "left-icon": {
            "size": "{a_27}",
            "color": "{a_28}",
            "hidden": false,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{a_29}"
                },
                "active": {
                    "color": "{a_30}"
                }
            }
        },
        "right-icon": {
            "size": "{a_31}",
            "color": "{a_32}",
            "hidden": true,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{a_33}"
                },
                "active": {
                    "color": "{a_34}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2,
            "hidden": false,
            "transition": {
                "property": [
                    "color"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            },
            "behavior": {
                "hover": {
                    "color": "{primary70}",
                    "transition": {
                        "property": [
                            "color"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeQuick}"
                    }
                },
                "active": {
                    "transition": {
                        "property": [
                            "color"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeQuick}"
                    }
                }
            }
        }
    },
    "variant": {
        "size": {
            "small": {
                "inner-container": {
                    "padding-top": "{a_35}",
                    "padding-right": "{a_36}",
                    "padding-bottom": "{a_37}",
                    "padding-left": "{a_38}",
                    "gap": "{a_39}"
                },
                "left-icon": {
                    "size": "{a_40}"
                },
                "right-icon": {
                    "size": "{a_41}"
                },
                "loader": {
                    "size": "{a_42}"
                }
            },
            "large": {
                "inner-container": {
                    "padding-top": "{a_43}",
                    "padding-left": "{a_44}",
                    "padding-bottom": "{a_45}",
                    "padding-right": "{a_46}",
                    "gap": "{a_47}"
                },
                "left-icon": {
                    "size": "{a_48}"
                },
                "right-icon": {
                    "size": "{a_49}"
                },
                "loader": {
                    "size": "{a_50}"
                },
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "extra-large": {
                "inner-container": {
                    "padding-top": "{a_51}",
                    "padding-right": "{a_52}",
                    "padding-bottom": "{a_53}",
                    "padding-left": "{a_54}",
                    "gap": "{a_55}"
                },
                "left-icon": {
                    "size": "{a_56}"
                },
                "right-icon": {
                    "size": "{a_57}"
                },
                "loader": {
                    "size": "{a_58}"
                },
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "iconPosition": {
            "right": {
                "left-icon": {
                    "hidden": true
                },
                "right-icon": {
                    "hidden": false
                }
            }
        },
        "state": {
            "loading": {
                "inner-container": {
                    "disabled": true,
                    "opacity": "{a_59}"
                },
                "left-icon": {
                    "opacity": "{a_60}"
                },
                "right-icon": {
                    "opacity": "{a_61}"
                },
                "loader": {
                    "hidden": false
                },
                "jds-text": {
                    "opacity": "{a_62}"
                }
            },
            "disabled": {
                "inner-container": {
                    "opacity": "{a_63}",
                    "disabled": true
                }
            }
        },
        "_hasIcon": {
            "false": {
                "left-icon": {
                    "hidden": true
                },
                "right-icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_65}",
                        "border-width": "{a_66}",
                        "border-color": "{a_67}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_68}"
                            },
                            "active": {
                                "background-color": "{a_69}"
                            },
                            "focus": {
                                "border-width": "{a_70}",
                                "border-color": "{a_71}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_72}",
                        "behavior": {
                            "hover": {
                                "color": "{a_73}"
                            },
                            "active": {
                                "color": "{a_74}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_75}",
                        "behavior": {
                            "hover": {
                                "color": "{a_76}"
                            },
                            "active": {
                                "color": "{a_77}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primary60}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primary70}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_78}",
                        "padding-right": "{a_79}",
                        "background-color": "{a_82}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_83}"
                            },
                            "active": {
                                "background-color": "{a_84}"
                            },
                            "focus": {
                                "border-width": "{a_85}",
                                "border-radius": "{a_86}",
                                "border-color": "{a_87}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_88}",
                        "behavior": {
                            "hover": {
                                "color": "{a_89}"
                            },
                            "active": {
                                "color": "{a_90}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_91}",
                        "behavior": {
                            "hover": {
                                "color": "{a_92}"
                            },
                            "active": {
                                "color": "{a_93}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primary60}",
                        "behavior": {
                            "hover": {
                                "color": "{primary50}"
                            },
                            "active": {
                                "color": "{primary70}"
                            }
                        }
                    }
                }
            },
            "positive": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_94}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_95}"
                            },
                            "active": {
                                "background-color": "{a_96}"
                            },
                            "focus": {
                                "border-color": "{a_97}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_98}",
                        "behavior": {
                            "hover": {
                                "color": "{a_99}"
                            },
                            "active": {
                                "color": "{a_100}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_101}",
                        "behavior": {
                            "hover": {
                                "color": "{a_102}"
                            },
                            "active": {
                                "color": "{a_103}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{global.white}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackSuccess80}"
                            },
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_104}",
                        "border-width": "{a_105}",
                        "border-color": "{a_106}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_107}"
                            },
                            "active": {
                                "background-color": "{a_108}"
                            },
                            "focus": {
                                "border-color": "{a_109}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_110}",
                        "behavior": {
                            "hover": {
                                "color": "{a_111}"
                            },
                            "active": {
                                "color": "{a_112}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_113}",
                        "behavior": {
                            "hover": {
                                "color": "{a_114}"
                            },
                            "active": {
                                "color": "{a_115}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_80}",
                        "padding-right": "{a_81}",
                        "background-color": "{a_116}",
                        "border-radius": "{a_117}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_118}"
                            },
                            "active": {
                                "background-color": "{a_119}"
                            },
                            "focus": {
                                "border-color": "{a_120}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_121}",
                        "behavior": {
                            "hover": {
                                "color": "{a_122}"
                            },
                            "active": {
                                "color": "{a_123}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_124}",
                        "behavior": {
                            "hover": {
                                "color": "{a_125}"
                            },
                            "active": {
                                "color": "{a_126}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackSuccess50}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            },
            "negative": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_129}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_130}"
                            },
                            "active": {
                                "background-color": "{a_131}"
                            },
                            "focus": {
                                "border-color": "{a_132}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_133}",
                        "behavior": {
                            "hover": {
                                "color": "{a_134}"
                            },
                            "active": {
                                "color": "{a_135}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_136}",
                        "behavior": {
                            "hover": {
                                "color": "{a_137}"
                            },
                            "active": {
                                "color": "{a_138}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{global.white}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackError80}"
                            },
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_139}",
                        "border-width": "{a_140}",
                        "border-color": "{a_141}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_142}"
                            },
                            "active": {
                                "background-color": "{a_143}"
                            },
                            "focus": {
                                "border-color": "{a_144}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_145}",
                        "behavior": {
                            "hover": {
                                "color": "{a_146}"
                            },
                            "active": {
                                "color": "{a_147}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_148}",
                        "behavior": {
                            "hover": {
                                "color": "{a_149}"
                            },
                            "active": {
                                "color": "{a_150}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primaryBackground}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_127}",
                        "padding-right": "{a_128}",
                        "background-color": "{a_151}",
                        "border-radius": "{a_152}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_153}"
                            },
                            "active": {
                                "background-color": "{a_154}"
                            },
                            "focus": {
                                "border-color": "{a_155}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_156}",
                        "behavior": {
                            "hover": {
                                "color": "{a_157}"
                            },
                            "active": {
                                "color": "{a_158}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_159}",
                        "behavior": {
                            "hover": {
                                "color": "{a_160}"
                            },
                            "active": {
                                "color": "{a_161}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {
                                "color": "{feedbackError50}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            },
            "contrast": {
                "primary": {
                    "inner-container": {
                        "background-color": "{a_164}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_165}"
                            },
                            "active": {
                                "background-color": "{a_166}"
                            },
                            "focus": {
                                "border-color": "{a_167}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_168}",
                        "behavior": {
                            "hover": {
                                "color": "{a_169}"
                            },
                            "active": {
                                "color": "{a_170}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_171}",
                        "behavior": {
                            "hover": {
                                "color": "{a_172}"
                            },
                            "active": {
                                "color": "{a_173}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryGrey100}",
                        "behavior": {
                            "hover": {},
                            "active": {}
                        }
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{a_174}",
                        "border-width": "{a_175}",
                        "border-color": "{a_176}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_177}"
                            },
                            "active": {
                                "background-color": "{a_178}"
                            },
                            "focus": {
                                "border-width": "{a_179}",
                                "border-color": "{a_180}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_181}",
                        "behavior": {
                            "hover": {
                                "color": "{a_182}"
                            },
                            "active": {
                                "color": "{a_183}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_184}",
                        "behavior": {
                            "hover": {
                                "color": "{a_185}"
                            },
                            "active": {
                                "color": "{a_186}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryBackground}",
                        "behavior": {
                            "hover": {
                                "color": "{primaryGrey100}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                },
                "tertiary": {
                    "inner-container": {
                        "padding-left": "{a_162}",
                        "padding-right": "{a_163}",
                        "background-color": "{a_187}",
                        "border-radius": "{a_188}",
                        "behavior": {
                            "hover": {
                                "background-color": "{a_189}"
                            },
                            "active": {
                                "background-color": "{a_190}"
                            },
                            "focus": {
                                "border-width": "{a_191}",
                                "border-color": "{a_192}"
                            }
                        }
                    },
                    "left-icon": {
                        "color": "{a_193}",
                        "behavior": {
                            "hover": {
                                "color": "{a_194}"
                            },
                            "active": {
                                "color": "{a_195}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{a_196}",
                        "behavior": {
                            "hover": {
                                "color": "{a_197}"
                            },
                            "active": {
                                "color": "{a_198}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{primaryBackground}",
                        "behavior": {
                            "hover": {
                                "color": "{primaryGrey100}"
                            },
                            "active": {
                                "color": "{primaryGrey100}"
                            }
                        }
                    }
                }
            }
        },
        {
            "false": {
                "small": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 32,
                        "height": 32
                    },
                    "left-icon": {
                        "size": "{a_199}"
                    },
                    "loader": {
                        "size": "{a_200}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 40,
                        "height": 40
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 48,
                        "height": 48
                    },
                    "left-icon": {
                        "size": "{a_201}"
                    },
                    "loader": {
                        "size": "{a_202}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "extra-large": {
                    "inner-container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "width": 64,
                        "height": 64
                    },
                    "left-icon": {
                        "size": "{a_203}"
                    },
                    "loader": {
                        "size": "{a_204}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "container": {
                        "width": "{a_205}"
                    },
                    "inner-container": {
                        "width": "{a_206}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "appearance",
            "kind"
        ],
        [
            "_hasLabel",
            "size"
        ],
        [
            "_hasLabel",
            "stretch"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary"
                ],
                "doc_description": "It can be used to switch between 3 variants of ActionButton which is by default 'primary'."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "extra-large"
                ],
                "doc_description": "it can be used to control the size of ActionButton."
            },
            "appearance": {
                "values": [
                    "normal",
                    "positive",
                    "negative",
                    "contrast"
                ],
                "doc_description": "It can be used to set the appearance of ActionButton."
            },
            "state": {
                "values": [
                    "normal",
                    "disabled",
                    "loading"
                ],
                "doc_description": "It can be used to change the state of ActionButton."
            },
            "iconPosition": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "It can be used to psoition icon."
            },
            "stretch": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to fill the container with ActionButton."
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasIcon": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of ActionButton."
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of ActionButton."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of ActionButton."
                }
            }
        },
        "events": {
            "inner-container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "inner-container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-hidden": "ariaHidden"
                }
            },
            "left-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            },
            "right-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacyKinds = [
    "icon-only",
    "background-bold"
];
const $451487d20aa3eb8a$var$legacySizes$4 = [
    "m",
    "s",
    "l",
    "xl",
    "xxl"
];
const $451487d20aa3eb8a$var$PROP_MAP$u = (props)=>{
    if ($451487d20aa3eb8a$var$legacyKinds.includes(props.kind)) console.warn("these values for the kind prop are deprecated", $451487d20aa3eb8a$var$legacyKinds);
    if ($451487d20aa3eb8a$var$legacySizes$4.includes(props.size)) console.warn("these values for the size prop are deprecated", $451487d20aa3eb8a$var$legacySizes$4);
    return {
        ic: {
            properties: {
                ic: props.ic
            }
        },
        size: {
            defaultValue: "medium",
            variations: {
                m: {
                    size: "medium"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                },
                xxl: {
                    size: "xtra-xtra-large"
                },
                s: {
                    size: "small"
                }
            }
        },
        color: {
            variations: {
                primary: {
                    color: "primary_50"
                },
                secondary: {
                    color: "secondary_50"
                },
                sparkle: {
                    color: "sparkle_50"
                },
                "grey-100": {
                    color: "primary_grey_100"
                },
                "grey-80": {
                    color: "primary_grey_80"
                },
                "grey-60": {
                    color: "primary_grey_60"
                },
                success: {
                    color: "feedback_success"
                },
                error: {
                    color: "feedback_error"
                },
                warning: {
                    color: "feedback_warning"
                }
            }
        },
        kind: {
            defaultValue: "icon-only",
            variations: {
                "icon-only": {
                    kind: "default"
                },
                background: {
                    kind: "background"
                },
                "background-bold": {
                    kind: "background_bold"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$feedbackIcons = {
    feedback_success: "IcSuccessColored",
    feedback_error: "IcErrorColored",
    feedback_warning: "IcWarningColored"
};
const $451487d20aa3eb8a$var$formatIconName = (iconName)=>{
    if (typeof iconName === "string" && iconName.startsWith("Ic")) {
        const words = iconName.slice(2).match(/[A-Z][a-z]+/g);
        return words ? words.join(" ").toLowerCase() + " icon" : iconName;
    } else if (typeof iconName === "string" && iconName.startsWith("ic_")) {
        const words = iconName.slice(3).split("_");
        return words ? words.join(" ").toLowerCase() + " icon" : iconName;
    }
    return iconName;
};
const $451487d20aa3eb8a$var$withLogic$2e = (Component)=>(0, $1OEoy.forwardRef)((userProps, ref)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$u);
        let iconComponent = props.ic;
        if (typeof props.ic === "string") {
            if (props.color && Object.keys($451487d20aa3eb8a$var$feedbackIcons).includes(props.color)) iconComponent = $451487d20aa3eb8a$var$feedbackIcons[props.color] || props.ic;
        }
        let getCustomSize = props.customSize || void 0;
        if (getCustomSize) {
            const sizeInPx = /^(\d+)(px)?$/.exec(getCustomSize);
            if (sizeInPx) getCustomSize = sizeInPx[1];
            else {
                console.warn("customSize should only be provided in pixels (px) or as a number.");
                getCustomSize = void 0;
            }
            if (Number.parseInt(getCustomSize) > 1080) getCustomSize = "1080";
            else if (Number.parseInt(getCustomSize) < 8) getCustomSize = "8";
        }
        const iconSize = props.kind === "default" ? getCustomSize : getCustomSize !== void 0 ? 2 / 3 * Number.parseInt(getCustomSize) : getCustomSize;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                ariaLabel: props.ariaLabel || $451487d20aa3eb8a$var$formatIconName(props.ic),
                _size: iconSize,
                customSize: getCustomSize
            },
            ic: iconComponent
        });
    });
const $451487d20aa3eb8a$var$withLogic$2d = (Component)=>(0, $1OEoy.forwardRef)((props, ref)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasLabel: Boolean(props.label?.length),
                rootRef: ref,
                iconAriaLabel: props.iconAriaLabel || $451487d20aa3eb8a$var$formatIconName(props.icon)
            }
        });
    });
const $451487d20aa3eb8a$var$Component$2f = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$2a;
    const { kind: kind = "primary", size: size = "medium", appearance: appearance = "normal", state: state = "normal", iconPosition: iconPosition = "left", stretch: stretch = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            appearance: appearance,
            state: state,
            iconPosition: iconPosition,
            stretch: stretch,
            onClick: onClick,
            onFocus: onFocus,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSActionButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$cfc7921d29ef7b80 = $451487d20aa3eb8a$var$withLogic$2d($451487d20aa3eb8a$var$Component$2f);
$451487d20aa3eb8a$export$cfc7921d29ef7b80.displayName = "ActionButton";
$451487d20aa3eb8a$export$cfc7921d29ef7b80.slotName = "jds_action_button";
const $451487d20aa3eb8a$var$sdl$29 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar-1.0.0",
        "name": "JDSAvatar",
        "layerName": "jds_avatar",
        "description": "Avatars are used to show a thumbnail representation of an individual or business in the interface.",
        "usage": "Avatars can either be custom images uploaded by users, or default themed images, or automatically populated user initials."
    },
    "hierarchy": {
        "container": [
            "jds_image",
            "jds-text",
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "opacity": "{a_17}",
            "width": "{a_0}",
            "height": "{a_1}",
            "display": "flex",
            "flex-direction": "{a_2}",
            "justify-content": "{a_3}",
            "align-items": "{a_4}",
            "background-color": "{a_5}",
            "border-radius": "{a_6}",
            "border-width": "{a_7}",
            "border-color": "{a_8}"
        },
        "jds_image": {
            "hidden": true,
            "aspectRatio": "round"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{sparkle60}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{primary50}",
            "value": "ic_profile",
            "hidden": false,
            "ic": "ic_profile"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": false,
            "ic": "ic_profile"
        }
    },
    "variant": {
        "size": {
            "xtra-small": {
                "container": {
                    "width": "{a_9}",
                    "height": "{a_10}"
                },
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "jds-icon": {
                    "size": "{base}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{base}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "small": {
                "container": {
                    "width": "{a_11}",
                    "height": "{a_12}"
                },
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "jds-icon": {
                    "size": "{m}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "large": {
                "container": {
                    "width": "{a_13}",
                    "height": "{a_14}"
                },
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                },
                "jds-icon": {
                    "size": "{xl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "xtra-large": {
                "container": {
                    "width": 56,
                    "height": 56
                },
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                },
                "jds-icon": {
                    "size": "{xxl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xxl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "width": "{a_15}",
                    "height": "{a_16}"
                },
                "jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                },
                "jds-icon": {
                    "size": "{xxl}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{xxl}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_18}"
                }
            }
        },
        "isClickable": {
            "false": {
                "container": {
                    "disabled": true
                }
            }
        },
        "kind": {
            "image": {
                "jds_image": {
                    "hidden": false
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{l}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                },
                "jds-text": {}
            },
            "initials": {
                "container": {
                    "background-color": "{a_19}"
                },
                "jds_image": {
                    "hidden": true
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{l}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                },
                "jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "icon": {
                    "container": {
                        "behavior": {
                            "focus": {
                                "border-width": "{a_20}"
                            }
                        }
                    },
                    "jds-icon": {
                        "behavior": {
                            "hover": {
                                "color": "{primary60}"
                            },
                            "focus": {
                                "color": "{primary60}"
                            }
                        }
                    },
                    "jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{l}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "behavior": {
                            "hover": {
                                "background-color": "{global.transparent}",
                                "border-radius": "{pill}",
                                "size": "{l}",
                                "justify-content": "{justifyContent.center}",
                                "align-items": "{alignItems.center}"
                            },
                            "focus": {
                                "background-color": "{global.transparent}",
                                "border-radius": "{pill}",
                                "size": "{l}",
                                "justify-content": "{justifyContent.center}",
                                "align-items": "{alignItems.center}"
                            }
                        }
                    }
                },
                "initials": {
                    "container": {
                        "behavior": {
                            "hover": {
                                "background-color": "{a_21}"
                            },
                            "focus": {
                                "border-width": "{a_22}",
                                "background-color": "{a_23}"
                            }
                        }
                    },
                    "jds-text": {
                        "behavior": {
                            "hover": {
                                "color": "{sparkle70}"
                            },
                            "focus": {
                                "color": "{sparkle70}"
                            }
                        }
                    }
                },
                "image": {
                    "container": {
                        "behavior": {
                            "hover": {
                                "opacity": "{a_24}"
                            },
                            "focus": {
                                "border-width": "{a_25}",
                                "opacity": "{a_26}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "isClickable",
            "kind"
        ]
    ],
    "api": {
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image",
                    "doc_description": "This is a user uploaded image. It will be used, when [kind] is set to image."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "initials",
                    "function": true,
                    "doc_description": "This is the two initials of user name. It will be used, when [kind] is set to initials."
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ],
                "doc_description": "This can be used to control the size of Avatar."
            },
            "kind": {
                "values": [
                    "icon",
                    "initials",
                    "image"
                ],
                "doc_description": "It can be used to switch between 3 variants of Avatar."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Avatar."
            },
            "isClickable": {
                "values": [
                    false,
                    true
                ],
                "platform": "web",
                "doc_description": "It can be used to make Avatar Clickable"
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "avatar"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "role": {
                        "name": "role",
                        "platform": "web"
                    },
                    "aria-haspopup": {
                        "name": "ariaHaspopup",
                        "platform": "web"
                    },
                    "aria-expanded": {
                        "name": "ariaExpanded",
                        "platform": "web"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "platform": "web"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacySizes$3 = [
    "x-small",
    "x-large",
    "xx-large"
];
const $451487d20aa3eb8a$var$PROP_MAP$t = (props)=>{
    if ($451487d20aa3eb8a$var$legacySizes$3.includes(props.size)) console.warn("these sizes are not deprecated. use sizes starting with `xtra`");
    if (typeof props.image === "object") console.warn("Image as an element is deprecated. Pass a string instead");
    return {
        size: {
            properties: {
                size: props.size
            },
            defaultValue: "medium",
            variations: {
                "x-small": {
                    size: "xtra-small"
                },
                small: {
                    size: "small"
                },
                medium: {
                    size: "medium"
                },
                large: {
                    size: "large"
                },
                "x-large": {
                    size: "xtra-large"
                },
                "xx-large": {
                    size: "xtra-xtra-large"
                }
            }
        },
        kind: {
            properties: {
                kind: props.kind
            },
            defaultValue: "default",
            variations: {
                default: {
                    icon: "ic_profile"
                }
            }
        },
        onClick: {
            properties: {
                onClick: props.onClick
            }
        }
    };
};
const $451487d20aa3eb8a$var$extractInitials = (value = "A", size)=>{
    const trimmedValue = value?.trim();
    if (size === "xtra-small") return (trimmedValue[0] || "A").toUpperCase();
    if (trimmedValue.indexOf(" ") >= 0) {
        const strMatch = trimmedValue?.trim().match(/\b(\w)/g) || [
            ""
        ];
        const strJoin = strMatch.join("") || trimmedValue;
        return strJoin.toUpperCase().trim().substring(0, 2);
    }
    return trimmedValue.toUpperCase().trim().substring(0, 2);
};
const $451487d20aa3eb8a$var$withLogic$2c = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$t);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            image: typeof props.image === "string" ? props.image : props.image?.props?.src,
            initials: $451487d20aa3eb8a$var$extractInitials(props.initials, props.size || "")
        });
    };
const $451487d20aa3eb8a$var$Component$2e = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$29;
    const { size: size = "medium", kind: kind = "icon", disabled: disabled = false, isClickable: isClickable = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "avatar", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            isClickable: isClickable,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatar", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$e2255cf6045e8d47 = $451487d20aa3eb8a$var$withLogic$2c($451487d20aa3eb8a$var$Component$2e);
$451487d20aa3eb8a$export$e2255cf6045e8d47.displayName = "Avatar";
$451487d20aa3eb8a$export$e2255cf6045e8d47.slotName = "jds_avatar";
const $451487d20aa3eb8a$var$sdl$28 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-2.0.0",
        "name": "JDSAvatarV2",
        "layerName": "jds_avatar_v2"
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            "jds_avatar_v2_status",
            "jds_avatar_v2_notification",
            "jds_avatar_v2_information",
            "jds_avatar_v2_complete_ring",
            "jds_avatar_v2_segmented_ring",
            "jds_avatar_v2_progress_ring"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "behavior": {
                "focus": {
                    "background-color": "{primary60}",
                    "border-radius": "{pill}",
                    "padding-left": "{xxs}",
                    "padding-right": "{xxs}",
                    "padding-top": "{xxs}",
                    "padding-bottom": "{xxs}"
                }
            }
        },
        "jds_avatar_v2_default": {
            "hidden": false,
            "size": "medium"
        },
        "jds_avatar_v2_status": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_notification": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_information": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_complete_ring": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_segmented_ring": {
            "hidden": true,
            "size": "medium"
        },
        "jds_avatar_v2_progress_ring": {
            "hidden": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "status": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_status": {
                    "hidden": false
                }
            },
            "notification": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_notification": {
                    "hidden": false
                }
            },
            "information": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_information": {
                    "hidden": false
                }
            },
            "complete-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_complete_ring": {
                    "hidden": false
                }
            },
            "segmented-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_segmented_ring": {
                    "hidden": false
                }
            },
            "progress-ring": {
                "jds_avatar_v2_default": {
                    "hidden": true
                },
                "jds_avatar_v2_progress_ring": {
                    "hidden": false
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-small"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_avatar_v2_status": {
                    "size": "small"
                },
                "jds_avatar_v2_notification": {
                    "size": "small"
                },
                "jds_avatar_v2_information": {
                    "size": "small"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "small"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "small"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "small"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_avatar_v2_status": {
                    "size": "large"
                },
                "jds_avatar_v2_notification": {
                    "size": "large"
                },
                "jds_avatar_v2_information": {
                    "size": "large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-large"
                }
            },
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_status": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_notification": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_information": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_complete_ring": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_segmented_ring": {
                    "size": "xtra-xtra-large"
                },
                "jds_avatar_v2_progress_ring": {
                    "size": "xtra-xtra-large"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "default",
                    "status",
                    "notification",
                    "information",
                    "complete-ring",
                    "segmented-ring",
                    "progress-ring"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "initials": {
                    "type": "string",
                    "name": "initials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_status": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "badgeStatus": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "statusBadgeStatus"
                },
                "kind": {
                    "type": "JDSAvatarV2Status.kind",
                    "name": "statusBadgeKind"
                },
                "placement": {
                    "type": "JDSAvatarV2Status.placement",
                    "name": "statusBadgePlacement"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_notification": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "kind": {
                    "type": "JDSAvatarV2Notification.kind",
                    "name": "notificationBadgeKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_information": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "badgeBorder": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "badgeIcon": {
                    "type": "icon",
                    "name": "informationBadgeIcon"
                },
                "badgeColor": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "informationBadgeColor"
                },
                "badgeAppearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "informationBadgeAppearance"
                },
                "kind": {
                    "type": "JDSAvatarV2Information.kind",
                    "name": "informationBadgeKind"
                },
                "placement": {
                    "type": "JDSAvatarV2Information.placement",
                    "name": "informationBadgePlacement"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_complete_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            },
            "jds_avatar_v2_segmented_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "count": {
                    "type": "number",
                    "name": "segmentCount",
                    "doc_description": "It can be used to control count of segments."
                }
            },
            "jds_avatar_v2_progress_ring": {
                "avatarImage": {
                    "type": "image",
                    "name": "image"
                },
                "avatarInitials": {
                    "type": "string",
                    "name": "initials"
                },
                "avatarKind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "progress": {
                    "type": "number",
                    "name": "progress"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "jds_avatar_v2_default": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_status": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_notification": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_information": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_complete_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_segmented_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_avatar_v2_progress_ring": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$2b = (Component)=>(props)=>{
        const trimChars = (initials2, size)=>{
            if (!initials2 || typeof initials2 !== "string" || initials2.trim() === "") return "";
            let initialsText = "";
            const array = initials2.trim().split(" ");
            if (array.length <= 1) initialsText = array[0].substring(0, 2);
            else initialsText = array[0][0] + array[1][0];
            initialsText = initialsText.substring(0, size);
            return initialsText.toUpperCase();
        };
        const initials = (item)=>{
            return trimChars(item.initials, item.size === "xtra-small" ? 1 : 2);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            initials: initials(props)
        });
    };
const $451487d20aa3eb8a$var$Component$2d = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$28;
    const { kind: kind = "default", size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ac4313c0728f5b84 = $451487d20aa3eb8a$var$withLogic$2b($451487d20aa3eb8a$var$Component$2d);
$451487d20aa3eb8a$export$ac4313c0728f5b84.displayName = "AvatarV2";
$451487d20aa3eb8a$export$ac4313c0728f5b84.slotName = "jds_avatar_v2";
const $451487d20aa3eb8a$var$sdl$27 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-complete-ring-2.0.0",
        "name": "JDSAvatarV2CompleteRing",
        "layerName": "jds_avatar_v2_complete_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "ring-arc",
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "ring-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 360,
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "ring-arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "ring-arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "ring-arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "ring-arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "ring-arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$2a = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$2c = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$27;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2CompleteRing", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$70f728d68d57ace9 = $451487d20aa3eb8a$var$withLogic$2a($451487d20aa3eb8a$var$Component$2c);
$451487d20aa3eb8a$export$70f728d68d57ace9.displayName = "AvatarV2CompleteRing";
$451487d20aa3eb8a$export$70f728d68d57ace9.slotName = "jds_avatar_v2_complete_ring";
const $451487d20aa3eb8a$var$sdl$26 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-default-2.0.0",
        "name": "JDSAvatarV2Default",
        "layerName": "jds_avatar_v2_default",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_image",
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "opacity": "{a_9}",
            "width": "{a_0}",
            "height": "{a_1}",
            "flex-direction": "{a_2}",
            "justify-content": "{a_3}",
            "align-items": "{a_4}",
            "background-color": "{a_5}",
            "border-radius": "{a_6}",
            "behavior": {
                "active": {
                    "background-color": "{a_10}"
                }
            }
        },
        "jds_image": {
            "hidden": true,
            "aspectRatio": "round"
        },
        "icon": {
            "hidden": false,
            "size": "{a_12}",
            "color": "{a_13}",
            "value": "ic_profile",
            "behavior": {
                "hover": {
                    "color": "{a_14}"
                },
                "active": {
                    "color": "{a_15}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary70}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "behavior": {
                "hover": {
                    "color": "{primary50}"
                }
            }
        }
    },
    "variant": {
        "size": {
            "xtra-small": {
                "container": {
                    "width": "{a_16}",
                    "height": "{a_17}"
                },
                "icon": {
                    "size": "{a_26}"
                },
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "container": {
                    "width": "{a_18}",
                    "height": "{a_19}"
                },
                "icon": {
                    "size": "{a_27}"
                },
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "container": {
                    "width": "{a_20}",
                    "height": "{a_21}"
                },
                "icon": {
                    "size": "{a_28}"
                },
                "jds-text": {}
            },
            "xtra-large": {
                "container": {
                    "width": "{a_22}",
                    "height": "{a_23}"
                },
                "icon": {
                    "size": "{a_29}"
                },
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "width": "{a_24}",
                    "height": "{a_25}"
                },
                "icon": {
                    "size": "{a_30}"
                },
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{a_31}"
                }
            }
        },
        "kind": {
            "initials": {
                "jds_image": {
                    "hidden": true
                },
                "icon": {
                    "hidden": true
                },
                "jds-text": {
                    "hidden": false
                }
            },
            "image": {
                "container": {
                    "behavior": {
                        "hover": {
                            "background-color": "{a_34}"
                        },
                        "active": {
                            "background-color": "{a_36}"
                        }
                    }
                },
                "jds_image": {
                    "hidden": false,
                    "behavior": {
                        "hover": {
                            "opacity": "{a_33}"
                        },
                        "active": {
                            "opacity": "{a_35}"
                        }
                    }
                },
                "icon": {
                    "hidden": true
                },
                "jds-text": {}
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "initials",
                    "function": true
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "kind": {
                "values": [
                    "icon",
                    "initials",
                    "image"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$29 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$2b = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$26;
    const { size: size = "medium", kind: kind = "icon", disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "Avatar", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Default", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$4860988e9a471058 = $451487d20aa3eb8a$var$withLogic$29($451487d20aa3eb8a$var$Component$2b);
$451487d20aa3eb8a$export$4860988e9a471058.displayName = "AvatarV2Default";
$451487d20aa3eb8a$export$4860988e9a471058.slotName = "jds_avatar_v2_default";
const $451487d20aa3eb8a$var$sdl$25 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-information-2.0.0",
        "name": "JDSAvatarV2Information",
        "layerName": "jds_avatar_v2_information",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "badge-container": {
            "padding-left": "{custom_11}",
            "padding-top": "{custom_11}",
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "jds_badge_v2": {
            "size": "small",
            "kind": "information",
            "informationKind": "icon-circle",
            "border": true
        }
    },
    "variant": {
        "kind": {
            "label": {
                "jds_badge_v2": {
                    "informationKind": "label"
                }
            }
        },
        "size": {
            "xtra-small": {
                "container": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "small": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_15}",
                            "padding-top": "{custom_15}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "small"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "small"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "hidden": true
                        }
                    }
                }
            },
            "medium": {
                "icon": {
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "small"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_11}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "medium"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{l}",
                            "padding-top": "{l}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{xxl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{l}",
                            "padding-top": "{custom_10}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{xxl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "xtra-large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{xl}",
                            "padding-top": "{xl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "large"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_19}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "large"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_8}",
                            "padding-top": "{xl}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_19}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "xtra-xtra-large": {
                "icon": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_7}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_21}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    }
                },
                "label": {
                    "bottom-right": {
                        "badge-container": {
                            "padding-left": "{custom_6}",
                            "padding-top": "{custom_7}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    },
                    "bottom-center": {
                        "container": {
                            "justify-content": "{justifyContent.center}",
                            "align-items": "{alignItems.center}"
                        },
                        "badge-container": {
                            "align-self": "flex-end",
                            "padding-left": "{custom_5}",
                            "padding-top": "{custom_22}"
                        },
                        "jds_avatar_v2_default": {
                            "size": "xtra-xtra-large"
                        },
                        "jds_badge_v2": {
                            "size": "medium"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "size",
            "kind",
            "placement"
        ]
    ],
    "api": {
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                }
            },
            "jds_badge_v2": {
                "icon": {
                    "type": "icon",
                    "name": "badgeIcon"
                },
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "color": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "badgeColor"
                },
                "appearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "badgeAppearance"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "icon",
                    "label"
                ]
            },
            "placement": {
                "values": [
                    "bottom-right",
                    "bottom-center"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Information Badge"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$28 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$2a = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$25;
    const { kind: kind = "icon", placement: placement = "bottom-right", size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Information Badge", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            placement: placement,
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Information", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$dbc79143cb6c67cb = $451487d20aa3eb8a$var$withLogic$28($451487d20aa3eb8a$var$Component$2a);
$451487d20aa3eb8a$export$dbc79143cb6c67cb.displayName = "AvatarV2Information";
$451487d20aa3eb8a$export$dbc79143cb6c67cb.slotName = "jds_avatar_v2_information";
const $451487d20aa3eb8a$var$sdl$24 = {
    "metadata": {
        "version": "2.0.0",
        "id": "avatar-notification-2.0.0",
        "name": "JDSAvatarV2Notification",
        "layerName": "jds_avatar_v2_notification",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.end}",
            "opacity": "{opacity.enabled}"
        },
        "badge-container": {
            "padding-left": 28,
            "padding-bottom": 28,
            "z-index": 1,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "jds_badge_v2": {
            "kind": "notification",
            "notificationKind": "dot",
            "size": "small"
        }
    },
    "variant": {
        "kind": {
            "number": {
                "jds_badge_v2": {
                    "notificationKind": "number"
                }
            },
            "number-symbol": {
                "jds_badge_v2": {
                    "notificationKind": "number-symbol"
                }
            }
        },
        "size": {
            "xtra-small": {
                "badge-container": {
                    "padding-left": 16,
                    "padding-bottom": 16
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_badge_v2": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "badge-container": {
                    "padding-left": 20,
                    "padding-bottom": 20
                },
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_badge_v2": {
                    "size": "small"
                }
            },
            "large": {
                "badge-container": {
                    "padding-left": 32,
                    "padding-bottom": 32
                },
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_badge_v2": {
                    "size": "medium"
                }
            },
            "xtra-large": {
                "badge-container": {
                    "padding-left": 37,
                    "padding-bottom": 37
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_badge_v2": {
                    "size": "large"
                }
            },
            "xtra-xtra-large": {
                "badge-container": {
                    "padding-left": 87,
                    "padding-bottom": 87
                },
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2": {
                    "size": "xtra-xtra-xtra-large"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "number": {
                "xtra-small": {
                    "badge-container": {
                        "padding-left": 15,
                        "padding-bottom": 15
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "small": {
                    "badge-container": {
                        "padding-left": 19,
                        "padding-bottom": 19
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "medium": {
                    "badge-container": {
                        "padding-left": 23,
                        "padding-bottom": 27
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "large": {
                    "badge-container": {
                        "padding-left": 27,
                        "padding-bottom": 35
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "xtra-large": {
                    "badge-container": {
                        "padding-left": 35,
                        "padding-bottom": 39
                    },
                    "jds_badge_v2": {
                        "size": "xtra-large"
                    }
                }
            },
            "number-symbol": {
                "xtra-small": {
                    "badge-container": {
                        "padding-left": 10,
                        "padding-bottom": 23
                    },
                    "jds_avatar_v2_default": {
                        "size": "small"
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "small": {
                    "badge-container": {
                        "padding-left": 10,
                        "padding-bottom": 23
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "medium": {
                    "badge-container": {
                        "padding-left": 18,
                        "padding-bottom": 31
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "large": {
                    "badge-container": {
                        "padding-left": 22,
                        "padding-bottom": 39
                    },
                    "jds_badge_v2": {
                        "size": "medium"
                    }
                },
                "xtra-large": {
                    "badge-container": {
                        "padding-left": 28,
                        "padding-bottom": 43
                    },
                    "jds_badge_v2": {
                        "size": "large"
                    }
                },
                "xtra-xtra-large": {
                    "badge-container": {
                        "padding-left": 75,
                        "padding-bottom": 87
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "number",
                    "number-symbol"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "jds_badge_v2": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Active Notifications"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$27 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$29 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$24;
    const { kind: kind = "dot", size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Active Notifications", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Notification", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$c906bb7932dd69e9 = $451487d20aa3eb8a$var$withLogic$27($451487d20aa3eb8a$var$Component$29);
$451487d20aa3eb8a$export$c906bb7932dd69e9.displayName = "AvatarV2Notification";
$451487d20aa3eb8a$export$c906bb7932dd69e9.slotName = "jds_avatar_v2_notification";
const $451487d20aa3eb8a$var$sdl$23 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar_progress_ring-1.0.0",
        "name": "JDSAvatarV2ProgressRing",
        "layerName": "jds_avatar_v2_progress_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "base-arc",
            "ring-arc",
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "base-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primaryGrey40}",
            "start": 0,
            "end": 360,
            "z-index": 1,
            "disabled": true
        },
        "ring-arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 270,
            "z-index": 2,
            "disabled": true
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "base-arc": {
                    "radius": 68,
                    "arcWidth": 4
                },
                "ring-arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "base-arc": {
                    "radius": 34,
                    "arcWidth": 3
                },
                "ring-arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "base-arc": {
                    "radius": 30,
                    "arcWidth": 3
                },
                "ring-arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "base-arc": {
                    "radius": 20,
                    "arcWidth": 2
                },
                "ring-arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "base-arc": {
                    "radius": 16,
                    "arcWidth": 2
                },
                "ring-arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "ring-arc": {
                "end": {
                    "type": "number",
                    "name": "progress",
                    "function": true
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Progress Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$26 = (Component)=>(props)=>{
        const progress = (items)=>{
            let percent = items.progress ?? 0;
            if (percent < 0) percent = Math.abs(percent);
            if (percent > 100) percent = percent % 100;
            return percent * 3.6;
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            progress: progress(props)
        });
    };
const $451487d20aa3eb8a$var$Component$28 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$23;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Progress Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2ProgressRing", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$add0715ef3cff303 = $451487d20aa3eb8a$var$withLogic$26($451487d20aa3eb8a$var$Component$28);
$451487d20aa3eb8a$export$add0715ef3cff303.displayName = "AvatarV2ProgressRing";
$451487d20aa3eb8a$export$add0715ef3cff303.slotName = "jds_avatar_v2_progress_ring";
const $451487d20aa3eb8a$var$sdl$22 = {
    "metadata": {
        "version": "1.0.0",
        "id": "avatar_segmented_ring-1.0.0",
        "name": "JDSAvatarV2SegmentedRing",
        "layerName": "jds_avatar_v2_segmented_ring",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "ring-container": [
                    "jds_segmented_ring_item"
                ]
            },
            "jds_avatar_v2_default"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "ring-container": {
            "hidden": false,
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "z-index": 1,
            "disabled": true
        },
        "jds_segmented_ring_item": {
            "size": "medium",
            "z-index": 1
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-large"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_segmented_ring_item": {
                    "size": "large"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_segmented_ring_item": {
                    "size": "small"
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "jds_segmented_ring_item": {
                    "size": "xtra-small"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_ring.startAngle": {
                    "type": "string",
                    "name": "startAngle"
                },
                "_ring.endAngle": {
                    "type": "string",
                    "name": "endAngle"
                }
            },
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "ring-container": {
                "value": {
                    "type": "list",
                    "name": "_ring",
                    "object": {
                        "startAngle": "number",
                        "endAngle": "number"
                    }
                },
                "length": {
                    "type": "number",
                    "name": "count",
                    "doc_description": "It can be used to control count of segments."
                }
            },
            "jds_segmented_ring_item": {
                "startAngle": {
                    "type": "string",
                    "name": "ring.startAngle"
                },
                "endAngle": {
                    "type": "string",
                    "name": "ring.endAngle"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Activity Ring"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$25 = (Component)=>(props)=>{
        const defaultRingCount = 4;
        const startAngle = (index, len)=>{
            if (len === 1) return 0;
            const gap = 5;
            const portion = 360 / len;
            return portion * index + gap;
        };
        const endAngle = (index, len)=>{
            if (len === 1) return 360;
            const gap = 5;
            const portion = 360 / len;
            return portion * (index + 1) - gap;
        };
        const ring = (item)=>{
            const rings = [];
            const len = item.count || defaultRingCount;
            for(let index = 0; index < len; index++)rings.push({
                startAngle: startAngle(index, len),
                endAngle: endAngle(index, len)
            });
            return rings;
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _ring: ring(props)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$27 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$22;
    const { size: size = "medium", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Activity Ring", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2SegmentedRing", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$9b02a99b26bc2fb = $451487d20aa3eb8a$var$withLogic$25($451487d20aa3eb8a$var$Component$27);
$451487d20aa3eb8a$export$9b02a99b26bc2fb.displayName = "AvatarV2SegmentedRing";
$451487d20aa3eb8a$export$9b02a99b26bc2fb.slotName = "jds_avatar_v2_segmented_ring";
const $451487d20aa3eb8a$var$sdl$21 = {
    "metadata": {
        "version": "1.0.0",
        "name": "JDSAvatarV2Status",
        "layerName": "jds_avatar_v2_status",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_avatar_v2_default",
            {
                "badge-container": [
                    "jds_badge_v2"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "opacity": "{opacity.enabled}",
            "hidden": false
        },
        "jds_avatar_v2_default": {
            "size": "medium"
        },
        "badge-container": {
            "padding-top": "{custom_11}",
            "padding-left": "{custom_11}",
            "padding-bottom": "{custom_5}",
            "z-index": 1,
            "disabled": true
        },
        "jds_badge_v2": {
            "kind": "status",
            "statusKind": "dot",
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "icon": {
                "jds_badge_v2": {
                    "statusKind": "icon",
                    "size": "medium"
                },
                "badge-container": {
                    "padding-top": "{custom_11}",
                    "padding-left": "{custom_11}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "text": {
                "jds_badge_v2": {
                    "statusKind": "label-container",
                    "size": "xtra-small"
                },
                "badge-container": {
                    "padding-top": "{l}",
                    "padding-left": "{base}",
                    "padding-bottom": "{custom_5}"
                }
            }
        },
        "size": {
            "xtra-xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-xtra-large"
                },
                "badge-container": {
                    "padding-top": "{custom_7}",
                    "padding-left": "{custom_7}",
                    "padding-bottom": "{custom_5}"
                },
                "jds_badge_v2": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-large": {
                "jds_avatar_v2_default": {
                    "size": "xtra-large"
                },
                "jds_badge_v2": {
                    "size": "large"
                },
                "badge-container": {
                    "padding-top": "{custom_10}",
                    "padding-left": "{custom_10}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "large": {
                "jds_avatar_v2_default": {
                    "size": "large"
                },
                "jds_badge_v2": {
                    "size": "medium"
                },
                "badge-container": {
                    "padding-top": "{l}",
                    "padding-left": "{l}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "small": {
                "jds_avatar_v2_default": {
                    "size": "small"
                },
                "jds_badge_v2": {
                    "size": "small"
                },
                "badge-container": {
                    "padding-top": "{custom_13}",
                    "padding-left": "{custom_13}",
                    "padding-bottom": "{custom_5}"
                }
            },
            "xtra-small": {
                "jds_avatar_v2_default": {
                    "size": "xtra-small"
                },
                "badge-container": {
                    "padding-top": "{base}",
                    "padding-left": "{base}",
                    "padding-bottom": "{custom_5}"
                },
                "jds_badge_v2": {
                    "size": "xtra-small"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{opacity.disabled}"
                }
            }
        }
    },
    "combination": [
        {
            "icon": {
                "xtra-xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        },
                        "badge-container": {
                            "padding-top": "{custom_7}",
                            "padding-left": "{custom_7}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-top": "{custom_10}",
                            "padding-left": "{custom_10}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_10}",
                            "padding-left": "{custom_10}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-top": "{l}",
                            "padding-left": "{l}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{l}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_11}",
                            "padding-left": "{custom_11}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-top": "{custom_13}",
                            "padding-left": "{custom_13}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_13}",
                            "padding-left": "{custom_13}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-small": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{base}",
                            "padding-left": "{base}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{base}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        }
                    }
                }
            },
            "dot": {
                "xtra-xtra-large": {
                    "top": {
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{custom_7}",
                            "padding-top": "{custom_5}"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-xtra-large"
                        }
                    }
                },
                "xtra-large": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "large"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_10}",
                            "padding-left": "{custom_10}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{l}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{l}",
                            "padding-left": "{custom_11}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_13}",
                            "padding-left": "{custom_13}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-small": {
                    "top": {
                        "badge-container": {
                            "padding-bottom": "{base}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        },
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        }
                    }
                }
            },
            "text": {
                "xtra-xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-top": "{custom_7}",
                            "padding-left": "{huge}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "medium"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_7}",
                            "padding-left": "{huge}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "xtra-large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{xl}",
                            "padding-left": "{custom_12}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_8}",
                            "padding-left": "{custom_12}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "large": {
                    "bottom": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-top": "{custom_10}",
                            "padding-left": "{m}"
                        }
                    },
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_20}",
                            "padding-left": "{m}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "medium": {
                    "top": {
                        "jds_badge_v2": {
                            "size": "xtra-small"
                        },
                        "badge-container": {
                            "padding-bottom": "{custom_8}",
                            "padding-left": "{base}",
                            "padding-top": "{custom_5}"
                        }
                    }
                },
                "small": {
                    "bottom": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "top": {
                        "container": {
                            "hidden": true
                        }
                    }
                },
                "xtra-small": {
                    "bottom": {
                        "container": {
                            "hidden": true
                        }
                    },
                    "top": {
                        "container": {
                            "hidden": true
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size",
            "placement"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "icon",
                    "text"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            },
            "placement": {
                "values": [
                    "bottom",
                    "top"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_avatar_v2_default": {
                "image": {
                    "type": "image",
                    "name": "avatarImage"
                },
                "initials": {
                    "type": "string",
                    "name": "avatarInitials"
                },
                "kind": {
                    "type": "JDSAvatarV2Default.kind",
                    "name": "avatarKind"
                }
            },
            "jds_badge_v2": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "border": {
                    "type": "boolean",
                    "name": "badgeBorder"
                },
                "status": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "badgeStatus"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Avatar with Status Badge"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$24 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$26 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$21;
    const { kind: kind = "dot", size: size = "medium", placement: placement = "bottom", disabled: disabled = false, ariaLabel: ariaLabel = "Avatar with Status Badge", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            placement: placement,
            disabled: disabled,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAvatarV2Status", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$6c44d71f4e8d3278 = $451487d20aa3eb8a$var$withLogic$24($451487d20aa3eb8a$var$Component$26);
$451487d20aa3eb8a$export$6c44d71f4e8d3278.displayName = "AvatarV2Status";
$451487d20aa3eb8a$export$6c44d71f4e8d3278.slotName = "jds_avatar_v2_status";
const $451487d20aa3eb8a$var$sdl$20 = {
    "metadata": {
        "version": "1.0.0",
        "id": "badge-1.0.0",
        "name": "JDSBadge",
        "layerName": "jds_badge",
        "description": "A Badge is used to draw attention to new or categorized content elements.",
        "usage": "Badges are not interactive. They are only used to describe a category or feature of the content they associate with."
    },
    "hierarchy": {
        "container": [
            "icon",
            "text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "padding-top": "{b_3}",
            "padding-left": "{b_4}",
            "padding-right": "{b_5}",
            "padding-bottom": "{b_6}",
            "gap": "{b_7}",
            "background-color": "{b_8}",
            "border-radius": "{b_9}"
        },
        "icon": {
            "hidden": false,
            "size": "{b_10}",
            "color": "{b_11}",
            "justify-content": "{b_12}",
            "align-items": "{b_13}"
        },
        "text": {
            "hidden": false,
            "font-family": "{b_14}",
            "font-size": "{b_15}",
            "line-height": "{b_16}",
            "letter-spacing": "{b_17}",
            "font-weight": "{b_18}",
            "color": "{b_19}",
            "max-lines": 1,
            "text-transform": "{b_20}"
        }
    },
    "variant": {
        "kind": {
            "service": {
                "container": {
                    "border-radius": "{b_21}",
                    "background-color": "{b_22}",
                    "padding-top": "{b_23}",
                    "padding-left": "{b_24}",
                    "padding-right": "{b_25}",
                    "padding-bottom": "{b_26}",
                    "gap": "{b_27}"
                },
                "text": {
                    "font-family": "{b_28}",
                    "font-size": "{b_29}",
                    "line-height": "{b_30}",
                    "letter-spacing": "{b_31}",
                    "font-weight": "{b_32}",
                    "color": "{b_33}",
                    "text-transform": "{badge_variant_kind_service_text_text-transform}"
                },
                "icon": {
                    "size": "{b_34}",
                    "color": "{b_35}"
                }
            }
        },
        "_hasIcon": {
            "false": {
                "icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "small": {
                    "container": {
                        "border-radius": "{b_36}"
                    },
                    "icon": {
                        "size": "{b_37}"
                    },
                    "text": {
                        "font-family": "{b_38}",
                        "font-size": "{b_39}",
                        "line-height": "{b_40}",
                        "letter-spacing": "{b_41}",
                        "font-weight": "{b_42}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_43}",
                        "padding-right": "{b_44}",
                        "gap": "{b_45}"
                    },
                    "icon": {
                        "size": "{b_46}"
                    },
                    "text": {
                        "font-family": "{b_47}",
                        "font-size": "{b_48}",
                        "line-height": "{b_49}",
                        "letter-spacing": "{b_50}",
                        "font-weight": "{b_51}"
                    }
                }
            }
        },
        {
            "service": {
                "false": {
                    "container": {
                        "padding-left": "{b_25}",
                        "padding-right": "{b_25}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "kind",
            "_hasIcon"
        ]
    ],
    "api": {
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It is used to display label of badge."
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon on the left with text."
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "service"
                ],
                "doc_description": "It can be used to switch between 2 variants of Badge."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ],
                "doc_description": "It can be used to adjust the size of Badge."
            },
            "_hasIcon": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$modifyIcon = ({ kind: kind, icon: icon })=>{
    if (kind !== "service" || !icon) return icon;
    if (typeof icon === "string") {
        if (!icon.toString().toLowerCase().startsWith("ps")) return void 0;
        return icon;
    }
    return icon;
};
const $451487d20aa3eb8a$var$withLogic$23 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            icon: $451487d20aa3eb8a$var$modifyIcon(props)
        });
    };
const $451487d20aa3eb8a$var$Component$25 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$20;
    const { kind: kind = "normal", size: size = "medium", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadge", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$37acb3580601e69a = $451487d20aa3eb8a$var$withLogic$23($451487d20aa3eb8a$var$Component$25);
$451487d20aa3eb8a$export$37acb3580601e69a.displayName = "Badge";
$451487d20aa3eb8a$export$37acb3580601e69a.slotName = "jds_badge";
const $451487d20aa3eb8a$var$sdl$1$ = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-2.0.0",
        "name": "JDSBadgeV2",
        "layerName": "jds_badge_v2"
    },
    "hierarchy": {
        "container": [
            {
                "children-container": [
                    "children-slot"
                ]
            },
            {
                "badge-container": [
                    "jds_badge_v2_information",
                    "jds_badge_v2_brand",
                    "jds_badge_v2_notification",
                    "jds_badge_v2_status"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "hidden": false
        },
        "badge-container": {
            "z-index": 1
        },
        "jds_badge_v2_information": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_brand": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_notification": {
            "hidden": true,
            "size": "medium"
        },
        "jds_badge_v2_status": {
            "hidden": true,
            "size": "medium"
        },
        "children-container": {
            "hidden": false,
            "z-index": 0
        }
    },
    "variant": {
        "kind": {
            "information": {
                "jds_badge_v2_information": {
                    "hidden": false
                }
            },
            "brand": {
                "jds_badge_v2_brand": {
                    "hidden": false
                }
            },
            "notification": {
                "jds_badge_v2_notification": {
                    "hidden": false
                }
            },
            "status": {
                "jds_badge_v2_status": {
                    "hidden": false
                }
            }
        },
        "placement": {
            "top": {
                "container": {
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.start}"
                }
            },
            "top_end": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.start}"
                }
            },
            "bottom_start": {
                "container": {
                    "justify-content": "{justifyContent.start}",
                    "align-items": "{alignItems.end}"
                }
            },
            "bottom": {
                "container": {
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.end}"
                }
            },
            "bottom_end": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.end}"
                }
            },
            "left": {
                "container": {
                    "justify-content": "{justifyContent.start}",
                    "align-items": "{alignItems.center}"
                }
            },
            "right": {
                "container": {
                    "justify-content": "{justifyContent.end}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_badge_v2_information": {
                    "size": "xtra-small"
                },
                "jds_badge_v2_brand": {
                    "size": "medium"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-small"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_badge_v2_information": {
                    "size": "small"
                },
                "jds_badge_v2_brand": {
                    "size": "medium"
                },
                "jds_badge_v2_notification": {
                    "size": "small"
                },
                "jds_badge_v2_status": {
                    "size": "small"
                }
            },
            "large": {
                "jds_badge_v2_information": {
                    "size": "large"
                },
                "jds_badge_v2_brand": {
                    "size": "large"
                },
                "jds_badge_v2_notification": {
                    "size": "large"
                },
                "jds_badge_v2_status": {
                    "size": "large"
                }
            },
            "xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-large"
                }
            },
            "xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-large"
                }
            },
            "xtra-xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-xtra-large"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "jds_badge_v2_information": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_brand": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_notification": {
                    "size": "xtra-xtra-xtra-xtra-large"
                },
                "jds_badge_v2_status": {
                    "size": "xtra-xtra-xtra-xtra-large"
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                },
                "badge-container": {
                    "z-index": 0
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "information",
                    "brand",
                    "notification",
                    "status"
                ]
            },
            "placement": {
                "values": [
                    "top_start",
                    "top",
                    "top_end",
                    "bottom_start",
                    "bottom",
                    "bottom_end",
                    "left",
                    "right"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "xtra-small",
                    "small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "badge-container": {
                "translate-x": {
                    "type": "size",
                    "name": "offsetLeft"
                },
                "translate-y": {
                    "type": "size",
                    "name": "offsetTop"
                }
            },
            "jds_badge_v2_information": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "background": {
                    "type": "color",
                    "name": "backgroundInfoColor"
                },
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "kind": {
                    "type": "JDSBadgeV2Information.kind",
                    "name": "informationKind"
                },
                "color": {
                    "type": "JDSBadgeV2Information.color",
                    "name": "color"
                },
                "appearance": {
                    "type": "JDSBadgeV2Information.appearance",
                    "name": "appearance"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            },
            "jds_badge_v2_brand": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "image": {
                    "type": "image",
                    "name": "image"
                },
                "kind": {
                    "type": "JDSBadgeV2Brand.kind",
                    "name": "brandKind"
                },
                "emphasis": {
                    "type": "JDSBadgeV2Brand.emphasis",
                    "name": "brandEmphasis"
                }
            },
            "jds_badge_v2_notification": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "kind": {
                    "type": "JDSBadgeV2Notification.kind",
                    "name": "notificationKind"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            },
            "jds_badge_v2_status": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "kind": {
                    "type": "JDSBadgeV2Status.kind",
                    "name": "statusKind"
                },
                "status": {
                    "type": "JDSBadgeV2Status.status",
                    "name": "status"
                },
                "border": {
                    "type": "boolean",
                    "name": "border"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "a11y": {
            "jds_badge_v2_information": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_brand": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_status": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge_v2_notification": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$22 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasChildrenSlot: Boolean(props.children)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$24 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1$;
    const { kind: kind = "information", placement: placement = "top_start", size: size = "medium", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            placement: placement,
            size: size,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$561b3597d6384588 = $451487d20aa3eb8a$var$withLogic$22($451487d20aa3eb8a$var$Component$24);
$451487d20aa3eb8a$export$561b3597d6384588.displayName = "BadgeV2";
$451487d20aa3eb8a$export$561b3597d6384588.slotName = "jds_badge_v2";
const $451487d20aa3eb8a$var$sdl$1_ = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-brand-2.0.0",
        "name": "JDSBadgeV2Brand",
        "layerName": "jds_badge_v2_brand",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "image-container": [
                    "brand-jds_image"
                ]
            },
            "label-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{b_3}",
            "gap": "{b_4}",
            "border-radius": "{b_5}",
            "padding-left": "{b_6}",
            "padding-right": "{b_7}",
            "padding-top": "{b_8}",
            "padding-bottom": "{b_9}"
        },
        "image-container": {
            "border-radius": "{b_10}",
            "size": "{b_11}",
            "overflow": "hidden"
        },
        "brand-jds_image": {
            "aspectRatio": "round",
            "roundedCorner": false
        },
        "label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{global.white}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "circle": {
                "container": {
                    "padding-left": "{b_40}",
                    "padding-right": "{b_40}",
                    "padding-top": "{b_40}",
                    "padding-bottom": "{b_40}"
                },
                "label-jds-text": {
                    "hidden": true
                }
            },
            "square": {
                "container": {
                    "border-radius": "{b_13}",
                    "padding-left": "{b_41}",
                    "padding-right": "{b_41}",
                    "padding-top": "{b_41}",
                    "padding-bottom": "{b_41}"
                },
                "image-container": {
                    "border-radius": "{b_12}"
                },
                "brand-jds_image": {
                    "aspectRatio": "square"
                },
                "label-jds-text": {
                    "hidden": true
                }
            },
            "square-label": {
                "container": {
                    "border-radius": "{b_15}"
                },
                "image-container": {
                    "border-radius": "{b_16}"
                },
                "brand-jds_image": {
                    "aspectRatio": "square"
                }
            }
        },
        "size": {
            "medium": {
                "container": {
                    "padding-left": "{b_17}",
                    "padding-right": "{b_18}",
                    "padding-top": "{b_19}",
                    "padding-bottom": "{b_20}"
                },
                "image-container": {
                    "size": "{b_21}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "container": {
                    "padding-left": "{b_22}",
                    "padding-right": "{b_23}",
                    "padding-top": "{b_24}",
                    "padding-bottom": "{b_25}"
                },
                "image-container": {
                    "size": "{b_26}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-large": {
                "container": {
                    "padding-left": "{b_27}",
                    "padding-right": "{b_28}",
                    "padding-top": "{b_29}",
                    "padding-bottom": "{b_30}"
                },
                "image-container": {
                    "size": "{b_31}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-large": {
                "container": {
                    "padding-left": "{b_32}",
                    "padding-right": "{b_33}",
                    "padding-top": "{b_34}",
                    "padding-bottom": "{b_35}"
                },
                "image-container": {
                    "size": "{b_36}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "container": {
                    "gap": "{b_37}"
                },
                "image-container": {
                    "size": "{b_38}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "emphasis": {
            "bold": {
                "container": {
                    "background-color": "{b_39}"
                }
            }
        }
    },
    "combination": [
        {
            "circle": {
                "medium": {
                    "container": {
                        "padding-left": "{b_42}",
                        "padding-right": "{b_42}",
                        "padding-top": "{b_42}",
                        "padding-bottom": "{b_42}"
                    },
                    "image-container": {
                        "size": "{b_43}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_44}",
                        "padding-right": "{b_44}",
                        "padding-top": "{b_44}",
                        "padding-bottom": "{b_44}"
                    },
                    "image-container": {
                        "size": "{b_45}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "padding-left": "{b_46}",
                        "padding-right": "{b_46}",
                        "padding-top": "{b_46}",
                        "padding-bottom": "{b_46}"
                    },
                    "image-container": {
                        "size": "{b_47}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_48}",
                        "padding-right": "{b_48}",
                        "padding-top": "{b_48}",
                        "padding-bottom": "{b_48}"
                    },
                    "image-container": {
                        "size": "{b_49}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_51}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_53}"
                    }
                }
            },
            "square": {
                "medium": {
                    "container": {
                        "border-radius": "{b_54}",
                        "padding-left": "{b_55}",
                        "padding-right": "{b_55}",
                        "padding-top": "{b_55}",
                        "padding-bottom": "{b_55}"
                    },
                    "image-container": {
                        "size": "{b_56}",
                        "border-radius": "{b_57}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_58}",
                        "padding-left": "{b_59}",
                        "padding-right": "{b_59}",
                        "padding-top": "{b_59}",
                        "padding-bottom": "{b_59}"
                    },
                    "image-container": {
                        "size": "{b_60}",
                        "border-radius": "{b_61}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_62}",
                        "padding-left": "{b_63}",
                        "padding-right": "{b_63}",
                        "padding-top": "{b_63}",
                        "padding-bottom": "{b_63}"
                    },
                    "image-container": {
                        "size": "{b_64}",
                        "border-radius": "{b_65}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_66}",
                        "padding-left": "{b_67}",
                        "padding-right": "{b_67}",
                        "padding-top": "{b_67}",
                        "padding-bottom": "{b_67}"
                    },
                    "image-container": {
                        "size": "{b_68}",
                        "border-radius": "{b_69}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_70}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "image-container": {
                        "size": "{b_71}"
                    }
                }
            },
            "square-label": {
                "medium": {
                    "container": {
                        "border-radius": "{b_73}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_74}",
                        "padding-right": "{b_75}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_76}",
                        "padding-right": "{b_77}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_81}",
                        "padding-left": "{b_78}"
                    },
                    "image-container": {
                        "size": "{b_79}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "padding-right": "{b_80}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "padding-right": "{b_82}"
                    },
                    "image-container": {
                        "border-radius": "{b_72}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "circle-label",
                    "circle",
                    "square",
                    "square-label"
                ]
            },
            "size": {
                "values": [
                    "xtra-xtra-xtra-large",
                    "medium",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "emphasis": {
                "values": [
                    "light",
                    "bold"
                ]
            }
        },
        "data": {
            "brand-jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$21 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$23 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1_;
    const { kind: kind = "circle-label", size: size = "xtra-xtra-xtra-large", emphasis: emphasis = "light", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            emphasis: emphasis,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Brand", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3b623c6160d8d9d1 = $451487d20aa3eb8a$var$withLogic$21($451487d20aa3eb8a$var$Component$23);
$451487d20aa3eb8a$export$3b623c6160d8d9d1.displayName = "BadgeV2Brand";
$451487d20aa3eb8a$export$3b623c6160d8d9d1.slotName = "jds_badge_v2_brand";
const $451487d20aa3eb8a$var$sdl$1Z = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-information-2.0.0",
        "name": "JDSBadgeV2Information",
        "layerName": "jds_badge_v2_information",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    {
                        "image-container": [
                            "jds_image"
                        ]
                    },
                    {
                        "icon-container": [
                            "icon"
                        ]
                    },
                    "label-jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "border-radius": "{b_0}"
        },
        "inner-container": {
            "flex-direction": "{b_2}",
            "justify-content": "{b_3}",
            "align-items": "{b_4}",
            "background-color": "{b_5}",
            "gap": "{b_6}",
            "border-radius": "{b_7}",
            "padding-left": "{b_8}",
            "padding-right": "{b_9}",
            "padding-top": "{b_10}",
            "padding-bottom": "{b_11}"
        },
        "icon-container": {
            "hidden": false,
            "show": true,
            "flex-direction": "{b_12}",
            "justify-content": "{b_13}",
            "align-items": "{b_14}",
            "size": "{b_15}"
        },
        "icon": {
            "color": "{b_16}",
            "size": "{b_17}"
        },
        "image-container": {
            "hidden": true,
            "show": true,
            "flex-direction": "{b_18}",
            "justify-content": "{b_19}",
            "align-items": "{b_20}",
            "size": "{b_21}",
            "overflow": "hidden"
        },
        "jds_image": {
            "aspectRatio": "round"
        },
        "label-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "label": {
                "icon-container": {
                    "hidden": true
                }
            },
            "label-image": {
                "icon-container": {
                    "hidden": true
                },
                "image-container": {
                    "hidden": false
                }
            },
            "icon": {
                "label-jds-text": {
                    "hidden": true
                }
            },
            "icon-circle": {
                "label-jds-text": {
                    "hidden": true
                }
            },
            "icon-square": {
                "label-jds-text": {
                    "hidden": true
                }
            }
        },
        "size": {
            "xtra-small": {
                "inner-container": {
                    "padding-right": "{b_25}",
                    "padding-top": "{b_26}",
                    "padding-bottom": "{b_27}"
                },
                "icon-container": {
                    "size": "{b_28}"
                },
                "icon": {
                    "size": "{b_29}"
                },
                "image-container": {
                    "size": "{b_30}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "inner-container": {
                    "padding-right": "{b_31}",
                    "padding-top": "{b_32}",
                    "padding-bottom": "{b_33}"
                },
                "icon-container": {
                    "size": "{b_34}"
                },
                "icon": {
                    "size": "{b_35}"
                },
                "image-container": {
                    "size": "{b_36}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "medium": {
                "inner-container": {
                    "padding-right": "{b_37}",
                    "padding-top": "{b_38}",
                    "padding-bottom": "{b_39}"
                },
                "icon-container": {
                    "size": "{b_40}"
                },
                "icon": {
                    "size": "{b_41}"
                },
                "image-container": {
                    "size": "{b_42}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-xtra-large": {
                "inner-container": {
                    "padding-left": "{b_43}",
                    "padding-top": "{b_44}",
                    "padding-bottom": "{b_45}"
                }
            },
            "xtra-xtra-xtra-large": {
                "container": {
                    "border-radius": "{b_46}"
                },
                "inner-container": {
                    "border-radius": "{b_47}",
                    "padding-left": "{b_48}",
                    "padding-top": "{b_49}",
                    "padding-bottom": "{b_50}"
                },
                "icon-container": {
                    "size": "{b_51}"
                },
                "icon": {
                    "size": "{b_52}"
                },
                "image-container": {
                    "size": "{b_53}"
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "container": {
                    "border-radius": "{b_54}"
                },
                "inner-container": {
                    "border-radius": "{b_55}",
                    "padding-left": "{b_56}",
                    "padding-right": "{b_57}",
                    "padding-top": "{b_58}",
                    "padding-bottom": "{b_59}"
                },
                "icon-container": {
                    "size": "{b_60}"
                },
                "icon": {
                    "size": "{b_61}"
                },
                "image-container": {
                    "size": "{b_62}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "color": {
            "secondary": {
                "inner-container": {
                    "background-color": "{b_22}"
                },
                "icon-container": {
                    "background-color": "{b_23}"
                },
                "icon": {
                    "color": "{b_24}"
                }
            },
            "positive": {
                "inner-container": {
                    "background-color": "{b_63}"
                },
                "icon-container": {
                    "background-color": "{b_64}"
                }
            },
            "warning": {
                "inner-container": {
                    "background-color": "{b_65}"
                },
                "icon-container": {
                    "background-color": "{b_66}"
                }
            },
            "negative": {
                "inner-container": {
                    "background-color": "{b_67}"
                },
                "icon-container": {
                    "background-color": "{b_68}"
                }
            },
            "neutral": {
                "inner-container": {
                    "background-color": "{b_69}"
                },
                "icon-container": {
                    "background-color": "{b_70}"
                }
            }
        },
        "border": {
            "true": {
                "container": {
                    "background-color": "{b_72}",
                    "padding-top": "{b_71}",
                    "padding-bottom": "{b_71}",
                    "padding-left": "{b_71}",
                    "padding-right": "{b_71}"
                }
            }
        }
    },
    "combination": [
        {
            "icon": {
                "xtra-small": {
                    "inner-container": {
                        "padding-left": "{b_73}",
                        "padding-right": "{b_73}",
                        "padding-top": "{b_73}",
                        "padding-bottom": "{b_73}"
                    },
                    "icon-container": {
                        "size": "{b_74}"
                    },
                    "icon": {
                        "size": "{b_75}"
                    }
                },
                "small": {
                    "inner-container": {
                        "padding-left": "{b_76}",
                        "padding-right": "{b_76}",
                        "padding-top": "{b_76}",
                        "padding-bottom": "{b_76}"
                    },
                    "icon-container": {
                        "size": "{b_77}"
                    },
                    "icon": {
                        "size": "{b_78}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "padding-left": "{b_79}",
                        "padding-right": "{b_79}",
                        "padding-top": "{b_79}",
                        "padding-bottom": "{b_79}"
                    },
                    "icon-container": {
                        "size": "{b_80}"
                    },
                    "icon": {
                        "size": "{b_81}"
                    }
                },
                "large": {
                    "inner-container": {
                        "padding-left": "{b_82}",
                        "padding-right": "{b_82}",
                        "padding-top": "{b_82}",
                        "padding-bottom": "{b_82}"
                    },
                    "icon-container": {
                        "size": "{b_87}"
                    },
                    "icon": {
                        "size": "{b_88}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_83}",
                        "padding-right": "{b_83}",
                        "padding-top": "{b_83}",
                        "padding-bottom": "{b_83}"
                    },
                    "icon-container": {
                        "size": "{b_89}"
                    },
                    "icon": {
                        "size": "{b_90}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_84}",
                        "padding-right": "{b_84}",
                        "padding-top": "{b_84}",
                        "padding-bottom": "{b_84}"
                    },
                    "icon-container": {
                        "size": "{b_91}"
                    },
                    "icon": {
                        "size": "{b_92}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_85}",
                        "padding-right": "{b_85}",
                        "padding-top": "{b_85}",
                        "padding-bottom": "{b_85}"
                    },
                    "icon-container": {
                        "size": "{b_93}"
                    },
                    "icon": {
                        "size": "{b_94}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "padding-left": "{b_86}",
                        "padding-right": "{b_86}",
                        "padding-top": "{b_86}",
                        "padding-bottom": "{b_86}"
                    },
                    "icon-container": {
                        "size": "{b_95}"
                    },
                    "icon": {
                        "size": "{b_96}"
                    }
                }
            },
            "icon-circle": {
                "xtra-small": {
                    "container": {
                        "border-radius": "{b_97}"
                    },
                    "inner-container": {
                        "border-radius": "{b_98}",
                        "padding-left": "{b_99}",
                        "padding-right": "{b_99}",
                        "padding-top": "{b_99}",
                        "padding-bottom": "{b_99}"
                    },
                    "icon-container": {
                        "size": "{b_100}",
                        "border-radius": "{b_101}"
                    },
                    "icon": {
                        "size": "{b_102}"
                    }
                },
                "small": {
                    "container": {
                        "border-radius": "{b_103}"
                    },
                    "inner-container": {
                        "border-radius": "{b_104}",
                        "padding-left": "{b_105}",
                        "padding-right": "{b_105}",
                        "padding-top": "{b_105}",
                        "padding-bottom": "{b_105}"
                    },
                    "icon-container": {
                        "size": "{b_106}",
                        "border-radius": "{b_107}"
                    },
                    "icon": {
                        "size": "{b_108}"
                    }
                },
                "medium": {
                    "container": {
                        "border-radius": "{b_109}"
                    },
                    "inner-container": {
                        "border-radius": "{b_109}",
                        "padding-left": "{b_110}",
                        "padding-right": "{b_110}",
                        "padding-top": "{b_110}",
                        "padding-bottom": "{b_110}"
                    },
                    "icon-container": {
                        "size": "{b_111}",
                        "border-radius": "{b_112}"
                    },
                    "icon": {
                        "size": "{b_113}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_114}"
                    },
                    "inner-container": {
                        "border-radius": "{b_114}",
                        "padding-left": "{b_115}",
                        "padding-right": "{b_115}",
                        "padding-top": "{b_115}",
                        "padding-bottom": "{b_115}"
                    },
                    "icon-container": {
                        "size": "{b_116}",
                        "border-radius": "{b_117}"
                    },
                    "icon": {
                        "size": "{b_118}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_119}"
                    },
                    "inner-container": {
                        "border-radius": "{b_119}",
                        "padding-left": "{b_120}",
                        "padding-right": "{b_120}",
                        "padding-top": "{b_120}",
                        "padding-bottom": "{b_120}"
                    },
                    "icon-container": {
                        "size": "{b_121}",
                        "border-radius": "{b_122}"
                    },
                    "icon": {
                        "size": "{b_123}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_124}"
                    },
                    "inner-container": {
                        "border-radius": "{b_124}",
                        "padding-left": "{b_125}",
                        "padding-right": "{b_125}",
                        "padding-top": "{b_125}",
                        "padding-bottom": "{b_125}"
                    },
                    "icon-container": {
                        "size": "{b_126}",
                        "border-radius": "{b_127}"
                    },
                    "icon": {
                        "size": "{b_128}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_129}"
                    },
                    "inner-container": {
                        "border-radius": "{b_129}",
                        "padding-left": "{b_130}",
                        "padding-right": "{b_130}",
                        "padding-top": "{b_130}",
                        "padding-bottom": "{b_130}"
                    },
                    "icon-container": {
                        "size": "{b_131}",
                        "border-radius": "{b_132}"
                    },
                    "icon": {
                        "size": "{b_133}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_134}"
                    },
                    "inner-container": {
                        "border-radius": "{b_134}",
                        "padding-left": "{b_135}",
                        "padding-right": "{b_135}",
                        "padding-top": "{b_135}",
                        "padding-bottom": "{b_135}"
                    },
                    "icon-container": {
                        "size": "{b_136}",
                        "border-radius": "{b_137}"
                    },
                    "icon": {
                        "size": "{b_138}"
                    }
                }
            },
            "icon-square": {
                "xtra-small": {
                    "container": {
                        "border-radius": "{b_139}"
                    },
                    "inner-container": {
                        "border-radius": "{b_140}",
                        "padding-left": "{b_141}",
                        "padding-right": "{b_141}",
                        "padding-top": "{b_141}",
                        "padding-bottom": "{b_141}"
                    },
                    "icon-container": {
                        "size": "{b_142}",
                        "border-radius": "{b_143}"
                    },
                    "icon": {
                        "size": "{b_144}"
                    }
                },
                "small": {
                    "container": {
                        "border-radius": "{b_145}"
                    },
                    "inner-container": {
                        "border-radius": "{b_145}",
                        "padding-left": "{b_146}",
                        "padding-right": "{b_146}",
                        "padding-top": "{b_146}",
                        "padding-bottom": "{b_146}"
                    },
                    "icon-container": {
                        "size": "{b_147}",
                        "border-radius": "{b_148}"
                    },
                    "icon": {
                        "size": "{b_149}"
                    }
                },
                "medium": {
                    "container": {
                        "border-radius": "{b_150}"
                    },
                    "inner-container": {
                        "border-radius": "{b_150}",
                        "padding-left": "{b_151}",
                        "padding-right": "{b_151}",
                        "padding-top": "{b_151}",
                        "padding-bottom": "{b_151}"
                    },
                    "icon-container": {
                        "size": "{b_152}",
                        "border-radius": "{b_153}"
                    },
                    "icon": {
                        "size": "{b_154}"
                    }
                },
                "large": {
                    "container": {
                        "border-radius": "{b_155}"
                    },
                    "inner-container": {
                        "border-radius": "{b_155}",
                        "padding-left": "{b_156}",
                        "padding-right": "{b_156}",
                        "padding-top": "{b_156}",
                        "padding-bottom": "{b_156}"
                    },
                    "icon-container": {
                        "size": "{b_157}",
                        "border-radius": "{b_158}"
                    },
                    "icon": {
                        "size": "{b_159}"
                    }
                },
                "xtra-large": {
                    "container": {
                        "border-radius": "{b_160}"
                    },
                    "inner-container": {
                        "border-radius": "{b_160}",
                        "padding-left": "{b_161}",
                        "padding-right": "{b_161}",
                        "padding-top": "{b_161}",
                        "padding-bottom": "{b_161}"
                    },
                    "icon-container": {
                        "size": "{b_162}",
                        "border-radius": "{b_163}"
                    },
                    "icon": {
                        "size": "{b_164}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_165}"
                    },
                    "inner-container": {
                        "border-radius": "{b_165}",
                        "padding-left": "{b_166}",
                        "padding-right": "{b_166}",
                        "padding-top": "{b_166}",
                        "padding-bottom": "{b_166}"
                    },
                    "icon-container": {
                        "size": "{b_167}",
                        "border-radius": "{b_168}"
                    },
                    "icon": {
                        "size": "{b_169}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_170}"
                    },
                    "inner-container": {
                        "border-radius": "{b_170}",
                        "padding-left": "{b_171}",
                        "padding-right": "{b_171}",
                        "padding-top": "{b_171}",
                        "padding-bottom": "{b_171}"
                    },
                    "icon-container": {
                        "size": "{b_172}",
                        "border-radius": "{b_173}"
                    },
                    "icon": {
                        "size": "{b_174}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "border-radius": "{b_175}"
                    },
                    "inner-container": {
                        "border-radius": "{b_175}",
                        "padding-left": "{b_176}",
                        "padding-right": "{b_176}",
                        "padding-top": "{b_176}",
                        "padding-bottom": "{b_176}"
                    },
                    "icon-container": {
                        "size": "{b_177}",
                        "border-radius": "{b_173}"
                    },
                    "icon": {
                        "size": "{b_179}"
                    }
                }
            },
            "label": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{b_180}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{b_181}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{b_182}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{b_183}",
                        "padding-left": "{b_184}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{b_185}",
                        "padding-left": "{b_186}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_187}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_188}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_189}",
                        "padding-left": "{b_190}"
                    }
                }
            },
            "label-icon": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{b_202}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{b_203}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_204}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_205}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_206}"
                    }
                }
            },
            "label-image": {
                "xtra-small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "small": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "medium": {
                    "inner-container": {
                        "height": "{b_201}"
                    }
                },
                "large": {
                    "inner-container": {
                        "height": "{b_202}"
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "height": "{b_203}"
                    }
                },
                "xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_204}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_205}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "inner-container": {
                        "height": "{b_206}"
                    }
                }
            }
        },
        {
            "subtle": {
                "default": {
                    "inner-container": {
                        "background-color": "{b_207}"
                    },
                    "icon-container": {
                        "background-color": "{b_208}"
                    },
                    "icon": {
                        "color": "{b_209}"
                    },
                    "label-jds-text": {
                        "color": "{sparkle60}"
                    }
                },
                "secondary": {
                    "inner-container": {
                        "background-color": "{b_267}"
                    },
                    "icon-container": {
                        "background-color": "{b_268}"
                    },
                    "icon": {
                        "color": "{b_269}"
                    },
                    "label-jds-text": {
                        "color": "{secondary60}"
                    }
                },
                "positive": {
                    "inner-container": {
                        "background-color": "{b_210}"
                    },
                    "icon-container": {
                        "background-color": "{b_211}"
                    },
                    "icon": {
                        "color": "{b_212}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackSuccess50}"
                    }
                },
                "warning": {
                    "inner-container": {
                        "background-color": "{b_213}"
                    },
                    "icon-container": {
                        "background-color": "{b_214}"
                    },
                    "icon": {
                        "color": "{b_215}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackWarning50}"
                    }
                },
                "negative": {
                    "inner-container": {
                        "background-color": "{b_216}"
                    },
                    "icon-container": {
                        "background-color": "{b_217}"
                    },
                    "icon": {
                        "color": "{b_218}"
                    },
                    "label-jds-text": {
                        "color": "{feedbackError50}"
                    }
                },
                "neutral": {
                    "inner-container": {
                        "background-color": "{b_219}"
                    },
                    "icon-container": {
                        "background-color": "{b_220}"
                    },
                    "icon": {
                        "color": "{b_221}"
                    },
                    "label-jds-text": {
                        "color": "{primaryGrey80}"
                    }
                }
            }
        },
        {
            "icon": {
                "bold": {
                    "default": {
                        "inner-container": {
                            "background-color": "{b_222}"
                        },
                        "icon-container": {
                            "background-color": "{b_223}"
                        },
                        "icon": {
                            "color": "{b_224}"
                        }
                    },
                    "secondary": {
                        "inner-container": {
                            "background-color": "{b_264}"
                        },
                        "icon-container": {
                            "background-color": "{b_265}"
                        },
                        "icon": {
                            "color": "{b_266}"
                        }
                    },
                    "positive": {
                        "inner-container": {
                            "background-color": "{b_225}"
                        },
                        "icon-container": {
                            "background-color": "{b_226}"
                        },
                        "icon": {
                            "color": "{b_227}"
                        }
                    },
                    "warning": {
                        "inner-container": {
                            "background-color": "{b_228}"
                        },
                        "icon-container": {
                            "background-color": "{b_229}"
                        },
                        "icon": {
                            "color": "{b_230}"
                        }
                    },
                    "negative": {
                        "inner-container": {
                            "background-color": "{b_231}"
                        },
                        "icon-container": {
                            "background-color": "{b_232}"
                        },
                        "icon": {
                            "color": "{b_233}"
                        }
                    },
                    "neutral": {
                        "inner-container": {
                            "background-color": "{b_234}"
                        },
                        "icon-container": {
                            "background-color": "{b_235}"
                        },
                        "icon": {
                            "color": "{b_236}"
                        }
                    }
                },
                "subtle": {
                    "default": {
                        "inner-container": {
                            "background-color": "{b_237}"
                        },
                        "icon-container": {
                            "background-color": "{b_238}"
                        },
                        "icon": {
                            "color": "{b_239}"
                        }
                    },
                    "secondary": {
                        "inner-container": {
                            "background-color": "{b_261}"
                        },
                        "icon-container": {
                            "background-color": "{b_262}"
                        },
                        "icon": {
                            "color": "{b_263}"
                        }
                    },
                    "positive": {
                        "inner-container": {
                            "background-color": "{b_240}"
                        },
                        "icon-container": {
                            "background-color": "{b_241}"
                        },
                        "icon": {
                            "color": "{b_242}"
                        }
                    },
                    "warning": {
                        "inner-container": {
                            "background-color": "{b_243}"
                        },
                        "icon-container": {
                            "background-color": "{b_244}"
                        },
                        "icon": {
                            "color": "{b_245}"
                        }
                    },
                    "negative": {
                        "inner-container": {
                            "background-color": "{b_246}"
                        },
                        "icon-container": {
                            "background-color": "{b_247}"
                        },
                        "icon": {
                            "color": "{b_248}"
                        }
                    },
                    "neutral": {
                        "inner-container": {
                            "background-color": "{b_249}"
                        },
                        "icon-container": {
                            "background-color": "{b_250}"
                        },
                        "icon": {
                            "color": "{b_251}"
                        }
                    }
                }
            }
        },
        {
            "true": {
                "xtra-small": {
                    "container": {
                        "padding-left": "{b_252}",
                        "padding-right": "{b_252}",
                        "padding-top": "{b_252}",
                        "padding-bottom": "{b_252}"
                    }
                },
                "small": {
                    "container": {
                        "padding-left": "{b_253}",
                        "padding-right": "{b_253}",
                        "padding-top": "{b_253}",
                        "padding-bottom": "{b_253}"
                    }
                },
                "medium": {
                    "container": {
                        "padding-left": "{b_254}",
                        "padding-right": "{b_254}",
                        "padding-top": "{b_254}",
                        "padding-bottom": "{b_254}"
                    }
                },
                "large": {
                    "container": {
                        "padding-left": "{b_255}",
                        "padding-right": "{b_255}",
                        "padding-top": "{b_255}",
                        "padding-bottom": "{b_255}"
                    }
                },
                "xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_256}",
                        "padding-right": "{b_256}",
                        "padding-top": "{b_256}",
                        "padding-bottom": "{b_256}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_257}",
                        "padding-right": "{b_257}",
                        "padding-top": "{b_257}",
                        "padding-bottom": "{b_257}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "container": {
                        "padding-left": "{b_258}",
                        "padding-right": "{b_258}",
                        "padding-top": "{b_258}",
                        "padding-bottom": "{b_258}"
                    }
                }
            }
        },
        {
            "true": {
                "icon": {
                    "container": {
                        "background-color": "{b_270}",
                        "padding-top": "{b_271}",
                        "padding-bottom": "{b_271}",
                        "padding-left": "{b_271}",
                        "padding-right": "{b_271}"
                    }
                }
            }
        },
        {
            "true": {
                "icon-circle": {
                    "large": {
                        "container": {
                            "padding-left": "{b_259}",
                            "padding-right": "{b_259}",
                            "padding-top": "{b_259}",
                            "padding-bottom": "{b_259}"
                        }
                    }
                },
                "icon-square": {
                    "large": {
                        "container": {
                            "padding-left": "{b_260}",
                            "padding-right": "{b_260}",
                            "padding-top": "{b_260}",
                            "padding-bottom": "{b_260}"
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "appearance",
            "color"
        ],
        [
            "kind",
            "appearance",
            "color"
        ],
        [
            "border",
            "size"
        ],
        [
            "border",
            "kind"
        ],
        [
            "border",
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "label-icon",
                    "label-image",
                    "label",
                    "icon",
                    "icon-circle",
                    "icon-square"
                ]
            },
            "size": {
                "values": [
                    "xtra-large",
                    "small",
                    "xtra-small",
                    "medium",
                    "large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "color": {
                "values": [
                    "default",
                    "secondary",
                    "positive",
                    "warning",
                    "negative",
                    "neutral"
                ]
            },
            "appearance": {
                "values": [
                    "bold",
                    "subtle"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "inner-container": {
                "background-color": {
                    "type": "color",
                    "name": "background"
                }
            },
            "icon-container": {
                "background-color": {
                    "type": "color",
                    "name": "background"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$20 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$22 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1Z;
    const { kind: kind = "label-icon", size: size = "xtra-large", color: color = "default", appearance: appearance = "bold", border: border = false, ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            color: color,
            appearance: appearance,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Information", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$50fcc0de7334f647 = $451487d20aa3eb8a$var$withLogic$20($451487d20aa3eb8a$var$Component$22);
$451487d20aa3eb8a$export$50fcc0de7334f647.displayName = "BadgeV2Information";
$451487d20aa3eb8a$export$50fcc0de7334f647.slotName = "jds_badge_v2_information";
const $451487d20aa3eb8a$var$sdl$1Y = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-notification-2.0.0",
        "name": "JDSBadgeV2Notification",
        "layerName": "jds_badge_v2_notification",
        "internal": true
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    {
                        "inner-container": [
                            "label-jds-text",
                            "symbol-jds-text"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "width": 10,
            "height": 10,
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{global.transparent}",
            "border-radius": "{b_6}"
        },
        "container": {
            "width": 8,
            "height": 8,
            "background-color": "{b_8}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "border-radius": "{b_6}",
            "padding-left": "{b_7}",
            "padding-right": "{b_7}",
            "padding-top": "{b_7}",
            "padding-bottom": "{b_7}"
        },
        "inner-container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "width": 7,
            "height": 7,
            "background-color": "{b_5}",
            "border-radius": "{b_6}"
        },
        "label-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{global.white}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "symbol-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{global.white}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "value": "+",
            "hidden": true,
            "text": "+"
        }
    },
    "variant": {
        "kind": {
            "dot": {
                "inner-container": {
                    "show": true
                }
            },
            "number": {
                "label-jds-text": {
                    "hidden": false
                }
            },
            "number-symbol": {
                "outer-container": {
                    "border-radius": 5,
                    "width": "",
                    "height": 18,
                    "padding-left": 1,
                    "padding-right": 1
                },
                "container": {
                    "border-radius": "{b_49}",
                    "width": "",
                    "height": 16,
                    "padding-left": 1,
                    "padding-right": 1
                },
                "inner-container": {
                    "width": "",
                    "height": 14,
                    "border-radius": "{b_49}",
                    "padding-left": 3,
                    "padding-right": 3
                },
                "label-jds-text": {
                    "hidden": false
                },
                "symbol-jds-text": {
                    "hidden": false
                }
            }
        },
        "size": {
            "small": {
                "outer-container": {
                    "width": 14,
                    "height": 14
                },
                "container": {
                    "width": 12,
                    "height": 12
                },
                "inner-container": {
                    "width": 10,
                    "height": 10
                },
                "label-jds-text": {
                    "trimLinePadding": "both"
                },
                "symbol-jds-text": {
                    "trimLinePadding": "both"
                }
            },
            "medium": {
                "outer-container": {
                    "width": 18,
                    "height": 18
                },
                "container": {
                    "width": 16,
                    "height": 16
                },
                "inner-container": {
                    "width": 13,
                    "height": 13
                },
                "label-jds-text": {
                    "trimLinePadding": "both"
                },
                "symbol-jds-text": {
                    "trimLinePadding": "both"
                }
            },
            "large": {
                "outer-container": {
                    "width": 22,
                    "height": 22
                },
                "container": {
                    "width": 20,
                    "height": 20
                },
                "inner-container": {
                    "width": 17,
                    "height": 17
                }
            },
            "xtra-large": {
                "outer-container": {
                    "width": 26,
                    "height": 26
                },
                "container": {
                    "width": 24,
                    "height": 24
                },
                "inner-container": {
                    "width": 20,
                    "height": 20
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-large": {
                "outer-container": {
                    "width": 30,
                    "height": 30
                },
                "container": {
                    "width": 28,
                    "height": 28
                },
                "inner-container": {
                    "width": 24,
                    "height": 24
                },
                "label-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 34,
                    "height": 34
                },
                "container": {
                    "width": 32,
                    "height": 32
                },
                "inner-container": {
                    "width": 27,
                    "height": 27
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 42,
                    "height": 42
                },
                "container": {
                    "width": 40,
                    "height": 40
                },
                "inner-container": {
                    "width": 34,
                    "height": 34
                },
                "label-jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                },
                "symbol-jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            }
        },
        "border": {
            "true": {
                "outer-container": {
                    "background-color": "{primaryBackground}"
                },
                "container": {
                    "background-color": "{b_9}"
                }
            }
        }
    },
    "combination": [
        {
            "number": {
                "xtra-small": {
                    "outer-container": {
                        "width": 18,
                        "height": 18
                    },
                    "container": {
                        "width": 16,
                        "height": 16
                    },
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "small": {
                    "outer-container": {
                        "width": 18,
                        "height": 18
                    },
                    "container": {
                        "width": 16,
                        "height": 16
                    },
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "medium": {
                    "inner-container": {
                        "width": 14,
                        "height": 14
                    }
                },
                "large": {
                    "inner-container": {
                        "width": 18,
                        "height": 18
                    }
                },
                "xtra-large": {
                    "inner-container": {
                        "width": 21,
                        "height": 21
                    }
                }
            },
            "number-symbol": {
                "small": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 18,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_53}",
                        "width": "",
                        "height": 16,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 14,
                        "border-radius": "{b_53}",
                        "padding-left": 3,
                        "padding-right": 3
                    }
                },
                "medium": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_57}",
                        "width": "",
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 14,
                        "border-radius": "{b_57}",
                        "padding-left": 3,
                        "padding-right": 3
                    }
                },
                "large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 22,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_61}",
                        "width": "",
                        "height": 20,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "inner-container": {
                        "width": "",
                        "height": 18,
                        "border-radius": "{b_61}",
                        "padding-left": 5,
                        "padding-right": 3
                    }
                },
                "xtra-large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 26,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_65}",
                        "width": "",
                        "height": 24,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 20,
                        "border-radius": "{b_65}",
                        "padding-left": 4,
                        "padding-right": 4
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 5,
                        "width": "",
                        "height": 30,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_69}",
                        "width": "",
                        "height": 28,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 24,
                        "border-radius": "{b_69}",
                        "padding-left": 5,
                        "padding-right": 3
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 9,
                        "width": "",
                        "height": 34,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_73}",
                        "width": "",
                        "height": 32,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "inner-container": {
                        "width": "",
                        "height": 28,
                        "border-radius": "{b_73}",
                        "padding-left": 5,
                        "padding-right": 5
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 9,
                        "width": "",
                        "height": 42,
                        "padding-left": 1,
                        "padding-right": 1
                    },
                    "container": {
                        "border-radius": "{b_77}",
                        "width": "",
                        "height": 40,
                        "padding-left": 3,
                        "padding-right": 3
                    },
                    "inner-container": {
                        "width": "",
                        "height": 34,
                        "border-radius": "{b_77}",
                        "padding-left": "{b_78}",
                        "padding-right": 6
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dot",
                    "number",
                    "number-symbol"
                ]
            },
            "size": {
                "values": [
                    "xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Active Notification"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1$ = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$21 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1Y;
    const { kind: kind = "dot", size: size = "xtra-small", border: border = false, ariaLabel: ariaLabel = "Active Notification", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Notification", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$5217f316f51857f9 = $451487d20aa3eb8a$var$withLogic$1$($451487d20aa3eb8a$var$Component$21);
$451487d20aa3eb8a$export$5217f316f51857f9.displayName = "BadgeV2Notification";
$451487d20aa3eb8a$export$5217f316f51857f9.slotName = "jds_badge_v2_notification";
const $451487d20aa3eb8a$var$sdl$1X = {
    "metadata": {
        "version": "2.0.0",
        "id": "badge-status-2.0.0",
        "name": "JDSBadgeV2Status",
        "layerName": "jds_badge_v2_status",
        "internal": true
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    {
                        "inner-container": [
                            {
                                "status-container": [
                                    "status-icon"
                                ]
                            }
                        ]
                    },
                    "label-jds-text"
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "width": 26,
            "height": 26,
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "background-color": "{global.transparent}",
            "border-radius": "{b_8}"
        },
        "container": {
            "width": 24,
            "height": 24,
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "gap": "{custom_5}"
        },
        "inner-container": {
            "width": 24,
            "height": 24,
            "justify-content": "{b_1}",
            "align-items": "{b_2}"
        },
        "status-container": {
            "width": 20,
            "height": 20,
            "hidden": false,
            "show": true,
            "flex-direction": "{b_4}",
            "justify-content": "{b_5}",
            "align-items": "{b_6}",
            "border-radius": "{b_8}",
            "background-color": "{b_9}"
        },
        "status-icon": {
            "value": "ic_message_send",
            "color": "{b_10}",
            "size": "{s}"
        },
        "label-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{feedbackSuccess50}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "kind": {
            "dot": {
                "status-icon": {
                    "hidden": true
                }
            },
            "label": {
                "outer-container": {
                    "background-color": "{global.transparent}",
                    "width": ""
                },
                "container": {
                    "width": ""
                },
                "inner-container": {
                    "hidden": true
                },
                "status-container": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "dot-label": {
                "outer-container": {
                    "border-radius": 0,
                    "width": "",
                    "height": ""
                },
                "container": {
                    "width": "",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "icon-label": {
                "outer-container": {
                    "border-radius": 0,
                    "width": "",
                    "height": ""
                },
                "container": {
                    "width": "",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "label-container": {
                "outer-container": {
                    "border-radius": 6,
                    "width": "",
                    "height": 30,
                    "padding-left": 3,
                    "padding-right": 3
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}"
                },
                "inner-container": {
                    "hidden": true
                },
                "status-container": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "dot-label-container": {
                "outer-container": {
                    "border-radius": "{small}",
                    "width": "",
                    "height": 24
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xxs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "hidden": true
                },
                "label-jds-text": {
                    "hidden": false
                }
            },
            "icon-label-container": {
                "outer-container": {
                    "border-radius": "{small}",
                    "width": "",
                    "height": 24
                },
                "container": {
                    "border-radius": "{small}",
                    "width": "",
                    "padding-left": "{xxs}",
                    "padding-right": "{xs}",
                    "padding-top": "{custom_4}",
                    "padding-bottom": "{custom_4}",
                    "gap": 4
                },
                "status-container": {
                    "size": "{custom_24}"
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "hidden": false
                }
            }
        },
        "size": {
            "xtra-small": {
                "outer-container": {
                    "width": 10,
                    "height": 10
                },
                "container": {
                    "width": 8,
                    "height": 8
                },
                "inner-container": {
                    "width": 8,
                    "height": 8
                },
                "status-container": {
                    "width": 7,
                    "height": 7
                },
                "status-icon": {
                    "size": "{xxs}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "small": {
                "outer-container": {
                    "width": 14,
                    "height": 14
                },
                "container": {
                    "width": 12,
                    "height": 12
                },
                "inner-container": {
                    "width": 12,
                    "height": 12
                },
                "status-container": {
                    "width": 10,
                    "height": 10
                },
                "status-icon": {
                    "size": "{custom_15}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "medium": {
                "outer-container": {
                    "width": 18,
                    "height": 18
                },
                "container": {
                    "width": 16,
                    "height": 16
                },
                "inner-container": {
                    "width": 16,
                    "height": 16
                },
                "status-container": {
                    "width": 13,
                    "height": 13
                },
                "status-icon": {
                    "size": "{xs}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "large": {
                "outer-container": {
                    "width": 22,
                    "height": 22
                },
                "container": {
                    "width": 20,
                    "height": 20
                },
                "inner-container": {
                    "width": 20,
                    "height": 20
                },
                "status-container": {
                    "width": 17,
                    "height": 17
                },
                "status-icon": {
                    "size": "{custom_19}"
                },
                "label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "xtra-xtra-large": {
                "outer-container": {
                    "width": 30,
                    "height": 30
                },
                "container": {
                    "width": 28,
                    "height": 28
                },
                "inner-container": {
                    "width": 28,
                    "height": 28
                },
                "status-container": {
                    "width": 23,
                    "height": 23
                },
                "status-icon": {
                    "size": "{custom_24}"
                }
            },
            "xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 34,
                    "height": 34
                },
                "container": {
                    "width": 32,
                    "height": 32
                },
                "inner-container": {
                    "width": 32,
                    "height": 32
                },
                "status-container": {
                    "width": 27,
                    "height": 27
                },
                "status-icon": {
                    "size": "{base}"
                },
                "label-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "xtra-xtra-xtra-xtra-large": {
                "outer-container": {
                    "width": 42,
                    "height": 42
                },
                "container": {
                    "width": 40,
                    "height": 40
                },
                "inner-container": {
                    "width": 40,
                    "height": 40
                },
                "status-container": {
                    "width": 33,
                    "height": 33
                },
                "status-icon": {
                    "size": "{custom_18}"
                },
                "label-jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            }
        },
        "status": {
            "error": {
                "status-container": {
                    "background-color": "{b_30}"
                },
                "status-icon": {
                    "value": "ic_close"
                },
                "label-jds-text": {
                    "color": "{feedbackError50}"
                }
            },
            "warning": {
                "status-container": {
                    "background-color": "{b_31}"
                },
                "status-icon": {
                    "value": "ic_exclamation"
                },
                "label-jds-text": {
                    "color": "{feedbackWarning50}"
                }
            },
            "disabled": {
                "container": {
                    "disabled": true
                },
                "status-container": {
                    "background-color": "{b_32}"
                },
                "status-icon": {
                    "value": "ic_close"
                },
                "label-jds-text": {
                    "color": "{primaryGrey60}"
                }
            }
        },
        "border": {
            "true": {
                "outer-container": {
                    "background-color": "{primaryBackground}"
                }
            }
        }
    },
    "combination": [
        {
            "label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 18
                    },
                    "container": {
                        "width": "",
                        "height": 16
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 18
                    },
                    "container": {
                        "width": "",
                        "height": 16
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": 2,
                        "padding-bottom": 2
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": ""
                    },
                    "container": {
                        "width": ""
                    }
                }
            },
            "dot": {
                "xtra-xtra-large": {
                    "status-container": {
                        "width": 24,
                        "height": 24
                    }
                }
            },
            "dot-label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": ""
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "gap": "{custom_18}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    }
                }
            },
            "icon-label": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": ""
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 16,
                        "height": 16
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    },
                    "status-icon": {
                        "size": "{custom_19}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": ""
                    },
                    "container": {
                        "width": "",
                        "gap": "{custom_18}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    },
                    "status-icon": {
                        "size": "{custom_24}"
                    }
                }
            },
            "label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 20,
                        "padding-left": 2,
                        "padding-right": 2
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 26
                    },
                    "container": {
                        "width": ""
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 34
                    },
                    "container": {
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 10,
                        "width": "",
                        "height": 38
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": 12,
                        "width": "",
                        "height": 48,
                        "padding-left": 4,
                        "padding-right": 4
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{s}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    }
                }
            },
            "dot-label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 20
                    },
                    "container": {
                        "width": ""
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 28
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 32
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 40
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    }
                }
            },
            "icon-label-container": {
                "xtra-small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "small": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "height": 16,
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "medium": {
                    "outer-container": {
                        "width": "",
                        "height": 16
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xxs}",
                        "padding-right": "{xxs}",
                        "padding-top": "{custom_5}",
                        "padding-bottom": "{custom_5}"
                    },
                    "inner-container": {
                        "width": 12,
                        "height": 12
                    },
                    "status-container": {
                        "size": "{custom_19}"
                    },
                    "status-icon": {
                        "size": "{custom_15}"
                    }
                },
                "large": {
                    "outer-container": {
                        "width": "",
                        "height": 20
                    },
                    "container": {
                        "width": ""
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-large": {
                    "outer-container": {
                        "width": "",
                        "height": 28
                    },
                    "container": {
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "status-container": {
                        "size": "{custom_24}"
                    },
                    "status-icon": {
                        "size": "{xs}"
                    }
                },
                "xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 32
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 20,
                        "height": 20
                    },
                    "status-container": {
                        "size": "{custom_22}"
                    },
                    "status-icon": {
                        "size": "{custom_19}"
                    }
                },
                "xtra-xtra-xtra-xtra-large": {
                    "outer-container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "height": 40
                    },
                    "container": {
                        "border-radius": "{medium}",
                        "width": "",
                        "padding-left": "{xs}",
                        "padding-right": "{s}",
                        "padding-top": "{xxs}",
                        "padding-bottom": "{xxs}"
                    },
                    "inner-container": {
                        "width": 28,
                        "height": 28
                    },
                    "status-container": {
                        "size": "{custom_30}"
                    },
                    "status-icon": {
                        "size": "{custom_24}"
                    }
                }
            }
        },
        {
            "label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_61}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_62}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_63}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_64}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            },
            "dot-label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_65}"
                    },
                    "status-container": {
                        "background-color": "{b_66}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_67}"
                    },
                    "status-container": {
                        "background-color": "{b_68}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_69}"
                    },
                    "status-container": {
                        "background-color": "{b_70}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_71}"
                    },
                    "status-container": {
                        "background-color": "{b_72}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            },
            "icon-label-container": {
                "success": {
                    "container": {
                        "background-color": "{b_73}"
                    },
                    "status-container": {
                        "background-color": "{b_74}"
                    },
                    "status-icon": {
                        "color": "{b_75}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "error": {
                    "container": {
                        "background-color": "{b_76}"
                    },
                    "status-container": {
                        "background-color": "{b_77}"
                    },
                    "status-icon": {
                        "color": "{b_78}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "warning": {
                    "container": {
                        "background-color": "{b_79}"
                    },
                    "status-container": {
                        "background-color": "{b_80}"
                    },
                    "status-icon": {
                        "color": "{b_81}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                },
                "disabled": {
                    "container": {
                        "background-color": "{b_82}"
                    },
                    "status-container": {
                        "background-color": "{b_83}"
                    },
                    "status-icon": {
                        "color": "{b_84}"
                    },
                    "label-jds-text": {
                        "color": "{global.white}"
                    }
                }
            }
        },
        {
            "true": {
                "label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                },
                "dot-label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                },
                "icon-label": {
                    "outer-container": {
                        "background-color": "{global.transparent}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "size"
        ],
        [
            "kind",
            "status"
        ],
        [
            "border",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "icon",
                    "dot",
                    "label",
                    "dot-label",
                    "icon-label",
                    "label-container",
                    "dot-label-container",
                    "icon-label-container"
                ]
            },
            "size": {
                "values": [
                    "xtra-large",
                    "small",
                    "xtra-small",
                    "medium",
                    "large",
                    "xtra-xtra-large",
                    "xtra-xtra-xtra-large",
                    "xtra-xtra-xtra-xtra-large"
                ]
            },
            "status": {
                "values": [
                    "success",
                    "error",
                    "warning",
                    "disabled"
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1_ = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$20 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1X;
    const { kind: kind = "icon", size: size = "xtra-large", status: status = "success", border: border = false, ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            status: status,
            border: border,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBadgeV2Status", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$87daca618cc26b9 = $451487d20aa3eb8a$var$withLogic$1_($451487d20aa3eb8a$var$Component$20);
$451487d20aa3eb8a$export$87daca618cc26b9.displayName = "BadgeV2Status";
$451487d20aa3eb8a$export$87daca618cc26b9.slotName = "jds_badge_v2_status";
const $451487d20aa3eb8a$var$sdl$1W = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-footer-1.0.0",
        "name": "JDSBottomFooter",
        "layerName": "jds_bottom_footer",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "copyright-container": [
                    {
                        "logo-container": [
                            {
                                "jds-icon-container": [
                                    "jds-icon"
                                ]
                            }
                        ]
                    },
                    {
                        "copyright-text-container": [
                            "jds_link",
                            "jds-text"
                        ]
                    }
                ]
            },
            {
                "informational-links-container": [
                    "jds_bottom_footer_link_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "padding-top": "{b_3}",
            "padding-right": "{b_4}",
            "padding-bottom": "{b_5}",
            "padding-left": "{b_6}",
            "background": "{b_7}"
        },
        "jds_link": {
            "textAppearance": "body_xxs",
            "kind": "submenu",
            "hidden": true
        },
        "copyright-container": {
            "gap": "{b_8}",
            "flex-direction": "{b_9}",
            "align-items": "{b_10}",
            "flex": 1
        },
        "informational-links-container": {
            "flex-direction": "row",
            "align-items": "{b_11}",
            "gap": 10
        },
        "jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{secondary50}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        }
    },
    "variant": {
        "_hasLink": {
            "true": {
                "jds_link": {
                    "hidden": false
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_platform": {
            "desktop": {
                "container": {
                    "width": "{b_12}"
                }
            },
            "mobile": {
                "container": {
                    "flex-direction": "{b_13}",
                    "justify-content": "{b_14}",
                    "align-items": "{b_15}",
                    "padding-top": 0,
                    "padding-right": "{b_16}",
                    "padding-bottom": "{b_17}",
                    "padding-left": "{b_18}",
                    "gap": "{b_19}"
                },
                "copyright-container": {
                    "flex-direction": "{b_20}",
                    "align-items": "{b_21}",
                    "gap": "{b_22}"
                }
            }
        }
    },
    "api": {
        "config": {
            "_hasLink": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "informational-links-container": {
                "value": {
                    "name": "informationalLinks",
                    "type": "list",
                    "object": {
                        "title": "string",
                        "href": "string",
                        "separator": "boolean"
                    }
                }
            },
            "copyright-text-container": {
                "value": {
                    "name": "copyright",
                    "type": "object",
                    "object": {
                        "title": "string",
                        "href": "string",
                        "newTab": "boolean"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "copyright.title"
                },
                "href": {
                    "type": "string",
                    "name": "copyright.href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "copyright.newTab"
                }
            },
            "jds_bottom_footer_link_item": {
                "title": {
                    "type": "string",
                    "name": "informationalLinks.title"
                },
                "href": {
                    "type": "string",
                    "name": "informationalLinks.href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "informationalLinks.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "string",
                    "name": "informationalLinks.routerLinkProps",
                    "platform": "angular"
                },
                "provider": {
                    "type": "string",
                    "name": "informationalLinks.provider",
                    "platform": "react"
                },
                "onClick": {
                    "type": "string",
                    "name": "informationalLinks.onClick"
                },
                "separator": {
                    "name": "informationalLinks.separator",
                    "type": "boolean"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "copyrightText"
                }
            },
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "logo"
                },
                "ic": {
                    "type": "icon",
                    "name": "logo"
                }
            }
        },
        "a11y": {
            "jds_link": {
                "properties": {
                    "ariaLabel": "copyRightAriaLabel",
                    "ariaDescribedby": {
                        "name": "copyRightAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "informational-links-container": {
                "name": "informationalLinks",
                "repeating": {
                    "ariaLabel": "bottomlinkAriaLabel",
                    "ariaDescribedby": {
                        "name": "bottomlinkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_bottom_footer_link_item": {
                "properties": {
                    "role": "informationalLinks.bottomlinkRole",
                    "ariaLabel": "informationalLinks.bottomlinkAriaLabel",
                    "ariaDescribedby": "informationalLinks.bottomlinkAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1Z = (Component)=>(props)=>{
        const length = props.informationalLinks?.length;
        const informationalLinks = props.informationalLinks?.map((item, i)=>({
                ...item,
                separator: i !== length - 1
            }));
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            _hasLink: Boolean(props.copyright?.href),
            informationalLinks: informationalLinks
        });
    };
const $451487d20aa3eb8a$var$Component$1$ = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1W;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSBottomFooter", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$72ab4ebd04fea6e2 = $451487d20aa3eb8a$var$withLogic$1Z($451487d20aa3eb8a$var$Component$1$);
$451487d20aa3eb8a$export$72ab4ebd04fea6e2.displayName = "BottomFooter";
$451487d20aa3eb8a$export$72ab4ebd04fea6e2.slotName = "jds_bottom_footer";
const $451487d20aa3eb8a$var$sdl$1V = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-footer-link-item-1.0.0",
        "name": "JDSBottomFooterLinkItem",
        "layerName": "jds_bottom_footer_link_item",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_link",
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "gap": "{b_0}"
        },
        "jds_divider": {
            "pad": "none",
            "orientation": "vertical"
        },
        "jds_link": {
            "kind": "submenu",
            "textAppearance": "body_xxs"
        }
    },
    "variant": {
        "separator": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "config": {
            "separator": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "event",
                    "name": "onClick"
                },
                "provider": {
                    "type": "object",
                    "name": "provider",
                    "platform": "react"
                }
            }
        },
        "a11y": {
            "jds_link": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1Y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1_ = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1V;
    const { separator: separator = true, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            separator: separator,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomFooterLinkItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$b592413d575db486 = $451487d20aa3eb8a$var$withLogic$1Y($451487d20aa3eb8a$var$Component$1_);
$451487d20aa3eb8a$export$b592413d575db486.displayName = "BottomFooterLinkItem";
$451487d20aa3eb8a$export$b592413d575db486.slotName = "jds_bottom_footer_link_item";
const $451487d20aa3eb8a$var$sdl$1U = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-navigation-item-1.0.0",
        "name": "JDSBottomNavigationItem",
        "layerName": "jds_bottom_navigation_item"
    },
    "hierarchy": {
        "container": [
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "width": "{b_0}",
            "flex-direction": "{b_1}",
            "justify-content": "{b_2}",
            "align-items": "{b_3}",
            "gap": "{b_4}",
            "opacity": "{b_6}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "center",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        }
    },
    "variant": {
        "showLabel": {
            "true": {
                "jds-text": {
                    "hidden": false
                }
            }
        },
        "active": {
            "true": {
                "jds-icon": {
                    "color": "{secondary50}"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                },
                "jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{b_5}"
                }
            }
        },
        "multiLine": {
            "true": {
                "jds-text": {
                    "max-lines": 2,
                    "maxLines": 2
                }
            }
        }
    },
    "api": {
        "config": {
            "showLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "active": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "multiLine": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                },
                "ic": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onItemClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tab"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected",
                        "prop": "active"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1X = (Component)=>({ selectedIndex: selectedIndex, internalIndex: internalIndex, ...rest })=>{
        const active = typeof selectedIndex === "number" && internalIndex === selectedIndex;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                active: active,
                onChange: (ev)=>{
                    if (internalIndex) rest.onClick?.(ev, internalIndex);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1Z = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1U;
    const { showLabel: showLabel = false, active: active = false, disabled: disabled = false, multiLine: multiLine = false, onItemClick: onItemClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaSelected: _ariaSelected = props.active?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            showLabel: showLabel,
            active: active,
            disabled: disabled,
            multiLine: multiLine,
            onItemClick: onItemClick,
            ariaLabel: ariaLabel,
            _ariaSelected: _ariaSelected,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomNavigationItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$f5e7567009f715b2 = $451487d20aa3eb8a$var$withLogic$1X($451487d20aa3eb8a$var$Component$1Z);
$451487d20aa3eb8a$export$f5e7567009f715b2.displayName = "BottomNavigationItem";
$451487d20aa3eb8a$export$f5e7567009f715b2.slotName = "jds_bottom_navigation_item";
const $451487d20aa3eb8a$var$sdl$1T = {
    "metadata": {
        "version": "1.0.0",
        "id": "desktop-bottom-sheet-1.0.0",
        "name": "JDSDesktopBottomSheet",
        "layerName": "jds_desktop_bottom_sheet",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_desktop_bottom_sheet_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "background-color": "{d_3}",
            "size": "{d_4}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "padding-right": 90,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "jds_desktop_bottom_sheet_internal": {
            "close": true
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "popup": {
                    "passive": true,
                    "background-color": "transparent"
                },
                "popup-container": {
                    "background-color": "transparent"
                }
            }
        },
        "isCustom": {
            "true": {
                "jds_desktop_bottom_sheet_internal": {
                    "isCustom": true
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "jds_mobile_bottom_sheet_internal": {
                    "buttonOrientation": "horizontal"
                }
            }
        },
        "close": {
            "false": {
                "popup-container": {
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeExit}"
                    }
                },
                "jds_desktop_bottom_sheet_internal": {
                    "close": false
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "overlay": {
                    "popup": {
                        "passive": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_desktop_bottom_sheet_internal": {
                "height": {
                    "type": "number",
                    "name": "height"
                },
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "step_label": {
                    "type": "string",
                    "name": "label"
                },
                "children": {
                    "name": "children",
                    "type": "slot"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_desktop_bottom_sheet_internal": {
                "onBottomSheetClick": "_onBottomSheetClick",
                "onClose": "onClose",
                "onCancel": "onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onBack": "onBack"
            }
        },
        "a11y": {
            "jds_desktop_bottom_sheet_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonAriaLabel": "cancelButtonAriaLabel",
                    "backButtonAriaLabel": "backButtonAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$WINDOW = typeof window === "object" && window || void 0;
const $451487d20aa3eb8a$var$defaultBreakpoints = {
    xmobile: 323,
    mobile: 619,
    tablet: 991,
    desktop: 992,
    widescreen: 1280,
    hd: 1920
};
class $451487d20aa3eb8a$var$Devices {
    static withSizes(breakpoints) {
        this.breakpoints = Object.assign(this.breakpoints, breakpoints);
        return this;
    }
    /**
   * is width xmobile and below
   */ static isXMobile() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.xmobile;
    }
    /**
   * is width mobile and below. returns true even on xmobile
   */ static isMobile() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.mobile;
    }
    /**
   * is width above mobile and below desktop
   */ static isTabletOnly() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
    }
    /**
   * is width less than tablet? returns true even on mobile and xmobile
   */ static isTablet() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 1e3;
        return width <= this.breakpoints.tablet;
    }
    /**
   * is width greater than tablet?
   */ static isDesktop() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 1e3;
        return width >= this.breakpoints.tablet;
    }
    /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */ static isWidescreen() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.widescreen;
    }
    /**
   * is width greater than or equal to HD.
   */ static isHD() {
        const width = $451487d20aa3eb8a$var$WINDOW?.innerWidth || 0;
        return width >= this.breakpoints.hd;
    }
    /**
   * Re-renders functional component at Breakpoints from defaultBreakpoints.
   * @returns ```
   {
        xmobile: boolean,
        mobile: boolean,
        tablet: boolean,
        desktop: boolean,
        widescreen: boolean,
        hd: boolean
    }
   ```
   * [xmobile < mobile < tablet] [desktop > widescreen > HD]
   * tablet will be true even when xmobile and mobile are true.
   * desktop will be true even when widescreen and hd are true.
   *
   *
   * Breakpoints can be overridden by calling withSizes() first.
   * e.g. Devices.withSizes(mySize).useMedia()
   */ static useMedia() {
        const queries = [
            `(max-width: ${this.breakpoints.xmobile}px)`,
            `(max-width: ${this.breakpoints.mobile}px)`,
            `(max-width: ${this.breakpoints.tablet}px)`,
            `(min-width: ${this.breakpoints.desktop}px)`,
            `(min-width: ${this.breakpoints.widescreen}px)`,
            `(min-width: ${this.breakpoints.hd}px)`
        ];
        const mediaQueryLists = queries.map((q)=>$451487d20aa3eb8a$var$WINDOW?.matchMedia && $451487d20aa3eb8a$var$WINDOW.matchMedia(q));
        const getValue = ()=>{
            const matchedResults = mediaQueryLists.map((mql)=>mql?.matches);
            const valObj = {
                xmobile: false,
                mobile: false,
                tablet: false,
                desktop: false,
                widescreen: false,
                hd: false
            };
            Object.keys(this.breakpoints).forEach((key, i)=>{
                valObj[key] = matchedResults[i];
            });
            return valObj;
        };
        const [value, setValue] = (0, $1OEoy.useState)(getValue);
        (0, $1OEoy.useEffect)(()=>{
            const handler = ()=>setValue(getValue);
            mediaQueryLists.forEach((mql)=>mql?.addListener(handler));
            return ()=>mediaQueryLists.forEach((mql)=>mql?.removeListener(handler));
        }, []);
        return value;
    }
}
$451487d20aa3eb8a$var$Devices.breakpoints = $451487d20aa3eb8a$var$defaultBreakpoints;
const $451487d20aa3eb8a$var$sdl$1S = {
    "metadata": {
        "version": "1.0.0",
        "id": "mobile-bottom-sheet-1.0.0",
        "name": "JDSMobileBottomSheet",
        "layerName": "jds_mobile_bottom_sheet"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_mobile_bottom_sheet_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "background-color": "{m_4}",
            "opacity": "{m_5}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{m_6}",
                "timing-function": "{m_7}"
            }
        },
        "jds_mobile_bottom_sheet_internal": {
            "hidden": false
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "popup": {
                    "passive": true,
                    "background-color": "{m_8}"
                },
                "popup-container": {
                    "background-color": "{m_9}"
                },
                "jds_mobile_bottom_sheet_internal": {
                    "kind": "passive"
                }
            }
        },
        "isCustom": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "isCustom": true
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "jds_mobile_bottom_sheet_internal": {
                    "buttonOrientation": "horizontal"
                }
            }
        },
        "close": {
            "false": {
                "popup-container": {
                    "opacity": "{m_10}",
                    "transition": {
                        "timing-function": "{m_11}"
                    }
                },
                "jds_mobile_bottom_sheet_internal": {
                    "close": false
                }
            }
        },
        "controlType": {
            "stepper": {
                "jds_mobile_bottom_sheet_internal": {
                    "controlType": "stepper"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "primaryCtaDisabled": true
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "jds_mobile_bottom_sheet_internal": {
                    "secondaryCtaDisabled": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "overlay": {
                    "popup": {
                        "passive": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_mobile_bottom_sheet_internal": {
                "maxHeight": {
                    "type": "size",
                    "name": "height",
                    "function": true
                },
                "stepLabel": {
                    "type": "string",
                    "name": "label"
                },
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "children": {
                    "name": "children",
                    "type": "slot"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_mobile_bottom_sheet_internal": {
                "onBottomSheetClick": "_onBottomSheetClick",
                "onClose": "onClose",
                "onBack": "onBack",
                "onCancel": "onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onAppear": {
                    "name": "_onContainerAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "jds_mobile_bottom_sheet_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonAriaLabel": "cancelButtonAriaLabel",
                    "backButtonAriaLabel": "backButtonAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$useEscapeClose = (handler, condition)=>{
    const escapeListener = (0, $1OEoy.useCallback)(()=>handler(), [
        handler
    ]);
    (0, $1OEoy.useEffect)(()=>{
        document.addEventListener("keydown", (ev)=>{
            if ((condition || typeof condition === "undefined") && ev.key === "Escape") escapeListener();
        });
        return ()=>{
            document.removeEventListener("keydown", escapeListener);
        };
    }, [
        condition,
        escapeListener
    ]);
};
const $451487d20aa3eb8a$var$useTransition = (externalOpen, cb, duration = 50)=>{
    const [open, setOpen] = (0, $1OEoy.useState)(externalOpen);
    const [internalOpen, setInternalOpen] = (0, $1OEoy.useState)(externalOpen);
    (0, $1OEoy.useEffect)(()=>{
        if (externalOpen) {
            setOpen(true);
            setTimeout(()=>{
                setInternalOpen(true);
            }, 10);
        } else {
            setOpen(false);
            setTimeout(()=>{
                setInternalOpen(false);
            }, 500);
        }
    }, [
        externalOpen
    ]);
    return {
        className: internalOpen && open ? "expanded" : "",
        open: internalOpen || open,
        close: ()=>{
            setOpen(false);
            setTimeout(()=>{
                setInternalOpen(false);
                cb?.();
            }, duration);
        }
    };
};
const $451487d20aa3eb8a$var$PROP_MAP$s = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: props.primaryCTA?.title,
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: props.secondaryCTA?.title,
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $451487d20aa3eb8a$var$BOTTOMSHEET_SELECTOR$1 = "div.j-JDSMobileBottomSheetInternal-root-container";
const $451487d20aa3eb8a$var$withLogic$1W = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$s);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const { open: open, className: className, close: closeFn } = $451487d20aa3eb8a$var$useTransition(Boolean(!close), ()=>{
            if (allowClose) onClose?.();
        });
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const bottomsheetRef = element?.querySelector($451487d20aa3eb8a$var$BOTTOMSHEET_SELECTOR$1);
        (0, $1OEoy.useEffect)(()=>{
            if (!close && bottomsheetRef) bottomsheetRef.focus();
        }, [
            close
        ]);
        $451487d20aa3eb8a$var$useEscapeClose(closeFn, allowClose);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: !open,
                className: className,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1Y = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1S;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBack: onBack = (0, $ddff9b86434e3f59$export$8793edee2d425525), onCancel: onCancel = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onClose: onClose,
            onBack: onBack,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMobileBottomSheet", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$BottomSheet$1 = $451487d20aa3eb8a$var$withLogic$1W($451487d20aa3eb8a$var$Component$1Y);
$451487d20aa3eb8a$var$BottomSheet$1.displayName = "BottomSheet";
$451487d20aa3eb8a$var$BottomSheet$1.slotName = "jds_mobile_bottom_sheet";
const $451487d20aa3eb8a$var$PROP_MAP$r = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryclick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryclick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $451487d20aa3eb8a$var$BOTTOMSHEET_SELECTOR = "div.j-JDSDesktopBottomSheetInternal-root-container";
const $451487d20aa3eb8a$var$withLogic$1V = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$r);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const closeFn = ()=>{
            if (allowClose) onClose?.();
        };
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const bottomsheetRef = element?.querySelector($451487d20aa3eb8a$var$BOTTOMSHEET_SELECTOR);
        (0, $1OEoy.useEffect)(()=>{
            if (!close && bottomsheetRef) bottomsheetRef.focus();
        }, [
            close
        ]);
        const { mobile: mobile } = $451487d20aa3eb8a$var$Devices.useMedia();
        $451487d20aa3eb8a$var$useEscapeClose(closeFn, allowClose);
        if (mobile) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$BottomSheet$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: close,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1X = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1T;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onCancel: onCancel = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBack: onBack = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onClose: onClose,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onBack: onBack,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDesktopBottomSheet", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2058ef1a26004a97 = $451487d20aa3eb8a$var$withLogic$1V($451487d20aa3eb8a$var$Component$1X);
$451487d20aa3eb8a$export$2058ef1a26004a97.displayName = "BottomSheet";
$451487d20aa3eb8a$export$2058ef1a26004a97.slotName = "jds_desktop_bottom_sheet";
const $451487d20aa3eb8a$var$sdl$1R = {
    "metadata": {
        "version": "1.0.0",
        "id": "button-1.0.0",
        "name": "JDSButton",
        "layerName": "jds_button",
        "description": "A button is an interactive control that allows the user to perform a specific action.",
        "usage": "A button accepts a user choice, response or command."
    },
    "hierarchy": {
        "container": [
            {
                "left-container": [
                    "left-icon",
                    "jds-text"
                ]
            },
            "right-icon",
            "loader"
        ]
    },
    "base": {
        "container": {
            "opacity": "{b_0}",
            "background-color": "{b_1}",
            "flex-direction": "{b_2}",
            "align-items": "{b_3}",
            "justify-content": "{b_4}",
            "border-radius": "{b_5}",
            "border-width": "{b_6}",
            "border-color": "{b_7}",
            "gap": "{b_8}",
            "behavior": {
                "hover": {
                    "background-color": "{b_10}"
                },
                "active": {
                    "background-color": "{b_11}"
                },
                "focus": {
                    "border-width": "{b_12}",
                    "border-color": "{b_13}"
                }
            }
        },
        "left-container": {
            "hidden": false,
            "flex-direction": "{b_14}",
            "align-items": "{b_15}",
            "justify-content": "{b_16}",
            "gap": "{b_17}",
            "flex-fill-android": false
        },
        "loader": {
            "color": "{b_18}",
            "background-color": "{b_19}",
            "border-width": "{b_20}",
            "hidden": true,
            "opacity": "{b_21}",
            "size": "{b_22}"
        },
        "left-icon": {
            "size": "{b_23}",
            "color": "{b_24}",
            "hidden": false
        },
        "right-icon": {
            "size": "{b_25}",
            "color": "{b_26}",
            "hidden": false
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primaryInverse}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en"
        }
    },
    "variant": {
        "_hasLabel": {
            "false": {
                "left-container": {
                    "hidden": true
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "justify-content": "{b_28}",
                    "width": "{b_27}",
                    "gap": 0
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{b_29}"
                }
            }
        },
        "loading": {
            "true": {
                "container": {
                    "disabled": true
                },
                "loader": {
                    "hidden": false
                },
                "right-icon": {
                    "hidden": true
                }
            }
        },
        "_hasRightIcon": {
            "false": {
                "right-icon": {
                    "hidden": true
                }
            }
        },
        "_hasLeftIcon": {
            "false": {
                "left-icon": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "primary": {
                "normal": {
                    "left-icon": {
                        "behavior": {
                            "active": {
                                "color": "{b_30}"
                            }
                        }
                    },
                    "right-icon": {
                        "behavior": {
                            "active": {
                                "color": "{b_31}"
                            }
                        }
                    },
                    "jds-text": {
                        "behavior": {
                            "hover": {},
                            "active": {
                                "color": "{primary30}"
                            }
                        }
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_32}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_33}"
                            },
                            "active": {
                                "background-color": "{b_34}"
                            },
                            "focus": {
                                "border-color": "{b_35}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_36}"
                    },
                    "left-icon": {
                        "color": "{b_37}",
                        "behavior": {
                            "hover": {
                                "color": "{b_38}"
                            },
                            "active": {
                                "color": "{b_39}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{b_41}",
                        "behavior": {
                            "hover": {
                                "color": "{b_40}"
                            },
                            "active": {
                                "color": "{b_42}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackError80}",
                        "behavior": {
                            "hover": {
                                "color": "{global.white}"
                            },
                            "active": {
                                "color": "{feedbackError20}"
                            }
                        }
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_43}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_44}"
                            },
                            "active": {
                                "background-color": "{b_45}"
                            },
                            "focus": {
                                "border-color": "{b_46}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_47}"
                    },
                    "left-icon": {
                        "color": "{b_48}",
                        "behavior": {
                            "hover": {
                                "color": "{b_49}"
                            },
                            "active": {
                                "color": "{b_50}"
                            }
                        }
                    },
                    "right-icon": {
                        "color": "{b_51}",
                        "behavior": {
                            "hover": {
                                "color": "{b_52}"
                            },
                            "active": {
                                "color": "{b_53}"
                            }
                        }
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}",
                        "behavior": {
                            "hover": {
                                "color": "{global.white}"
                            },
                            "active": {
                                "color": "{feedbackSuccess20}"
                            }
                        }
                    }
                }
            },
            "secondary": {
                "normal": {
                    "container": {
                        "background-color": "{b_54}",
                        "border-width": "{b_55}",
                        "border-color": "{b_56}",
                        "behavior": {
                            "hover": {
                                "border-color": "{b_57}",
                                "background-color": "{b_58}"
                            },
                            "active": {
                                "background-color": "{b_59}",
                                "border-color": "{b_60}"
                            },
                            "focus": {
                                "border-color": "{b_61}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_62}"
                    },
                    "left-icon": {
                        "color": "{b_63}"
                    },
                    "right-icon": {
                        "color": "{b_64}"
                    },
                    "jds-text": {
                        "color": "{primary60}"
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_65}",
                        "border-width": "{b_66}",
                        "border-color": "{b_67}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_68}",
                                "border-color": "{b_69}"
                            },
                            "focus": {
                                "border-color": "{b_70}",
                                "border-width": "{b_71}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_72}"
                    },
                    "left-icon": {
                        "color": "{b_73}"
                    },
                    "right-icon": {
                        "color": "{b_74}"
                    },
                    "jds-text": {
                        "color": "{feedbackError80}"
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_75}",
                        "border-width": "{b_76}",
                        "border-color": "{b_77}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_78}",
                                "border-color": "{b_79}"
                            },
                            "focus": {
                                "border-color": "{b_80}",
                                "border-width": "{b_81}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_82}"
                    },
                    "left-icon": {
                        "color": "{b_83}"
                    },
                    "right-icon": {
                        "color": "{b_84}"
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}"
                    }
                }
            },
            "tertiary": {
                "normal": {
                    "container": {
                        "border-width": "{b_9}",
                        "background-color": "{b_85}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_86}"
                            },
                            "active": {
                                "background-color": "{b_87}"
                            },
                            "focus": {
                                "border-color": "{b_88}",
                                "background-color": "{b_89}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_90}"
                    },
                    "left-icon": {
                        "color": "{b_91}"
                    },
                    "right-icon": {
                        "color": "{b_92}"
                    },
                    "jds-text": {
                        "color": "{primary60}"
                    }
                },
                "destructive": {
                    "container": {
                        "background-color": "{b_93}",
                        "behavior": {
                            "hover": {
                                "background-color": "{b_94}"
                            },
                            "active": {
                                "background-color": "{b_95}"
                            },
                            "focus": {
                                "border-color": "{b_96}",
                                "border-width": "{b_97}",
                                "background-color": "{b_98}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_99}"
                    },
                    "left-icon": {
                        "color": "{b_100}"
                    },
                    "right-icon": {
                        "color": "{b_101}"
                    },
                    "jds-text": {
                        "color": "{feedbackError80}"
                    }
                },
                "positive": {
                    "container": {
                        "background-color": "{b_102}",
                        "behavior": {
                            "active": {
                                "background-color": "{b_103}"
                            },
                            "focus": {
                                "border-color": "{b_104}",
                                "border-width": "{b_105}"
                            }
                        }
                    },
                    "loader": {
                        "color": "{b_106}"
                    },
                    "left-icon": {
                        "color": "{b_107}"
                    },
                    "right-icon": {
                        "color": "{b_108}"
                    },
                    "jds-text": {
                        "color": "{feedbackSuccess80}"
                    }
                }
            }
        },
        {
            "true": {
                "small": {
                    "container": {
                        "padding-top": "{b_109}",
                        "padding-right": "{b_110}",
                        "padding-bottom": "{b_111}",
                        "padding-left": "{b_112}"
                    },
                    "left-icon": {
                        "size": "{b_113}"
                    },
                    "right-icon": {
                        "size": "{b_114}"
                    },
                    "loader": {
                        "size": "{b_115}"
                    }
                },
                "medium": {
                    "container": {
                        "padding-top": "{b_116}",
                        "padding-right": "{b_117}",
                        "padding-bottom": "{b_118}",
                        "padding-left": "{b_119}"
                    },
                    "left-icon": {
                        "size": "{b_120}"
                    },
                    "right-icon": {
                        "size": "{b_121}"
                    },
                    "loader": {
                        "size": "{b_122}"
                    }
                },
                "large": {
                    "container": {
                        "padding-top": "{b_123}",
                        "padding-left": "{b_124}",
                        "padding-bottom": "{b_125}",
                        "padding-right": "{b_126}"
                    },
                    "left-icon": {
                        "size": "{b_127}"
                    },
                    "right-icon": {
                        "size": "{b_128}"
                    },
                    "loader": {
                        "size": "{b_129}"
                    }
                }
            },
            "false": {
                "small": {
                    "container": {
                        "min-height": "{b_130}",
                        "min-width": "{b_131}"
                    },
                    "left-icon": {
                        "size": "{b_132}"
                    },
                    "right-icon": {
                        "size": "{b_133}"
                    },
                    "loader": {
                        "size": "{b_134}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "container": {
                        "min-height": "{b_135}",
                        "min-width": "{b_136}"
                    },
                    "left-icon": {
                        "size": "{b_137}"
                    },
                    "right-icon": {
                        "size": "{b_138}"
                    },
                    "loader": {
                        "size": "{b_139}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "container": {
                        "min-height": 56,
                        "min-width": 56
                    },
                    "left-icon": {
                        "size": "{b_140}"
                    },
                    "right-icon": {
                        "size": "{b_141}"
                    },
                    "loader": {
                        "size": "{b_142}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "true": {
                        "false": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_143}"
                                }
                            },
                            "true": {
                                "container": {
                                    "justify-content": "{b_144}"
                                }
                            }
                        }
                    }
                },
                "false": {
                    "false": {
                        "true": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_145}"
                                }
                            }
                        },
                        "false": {
                            "true": {
                                "container": {
                                    "justify-content": "{b_146}"
                                }
                            }
                        }
                    },
                    "true": {
                        "true": {
                            "false": {
                                "container": {
                                    "justify-content": "{b_147}"
                                }
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "state"
        ],
        [
            "_hasLabel",
            "size"
        ],
        [
            "fullWidth",
            "_hasRightIcon",
            "_hasLeftIcon",
            "_hasLabel",
            "loading"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary"
                ],
                "doc_description": "It can be used to switch between 3 variants of Button which is by default 'primary'."
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ],
                "doc_description": "it can be used to control the size of Button."
            },
            "state": {
                "values": [
                    "normal",
                    "destructive",
                    "positive"
                ],
                "doc_description": "It can be used to change the state of Button."
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to make Button full-width."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Button."
            },
            "_hasRightIcon": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasLeftIcon": {
                "values": [
                    true,
                    false
                ]
            },
            "loading": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to add loading spinner to the right of label in Button."
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "iconLeft",
                    "doc_description": "It can be used to add icon to the left of the text of Button."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "required": false
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It adds icon to the right of the text of Button."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "required": false
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Button."
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": "ariaExpanded",
                    "aria-controls": "ariaControls"
                }
            },
            "right-icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1U = (Component)=>(0, $1OEoy.forwardRef)((props, ref)=>{
        const hasLabel = Boolean(props.children || props.title || props.label);
        if (props.children) console.warn("children prop is deprecated. Use label instead");
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                label: props.children || props.label || props.title,
                _hasRightIcon: Boolean(props.icon),
                _hasLabel: hasLabel,
                iconAriaLabel: props.iconAriaLabel || $451487d20aa3eb8a$var$formatIconName(props.icon)
            }
        });
    });
const $451487d20aa3eb8a$var$Component$1W = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1R;
    const { kind: kind = "primary", size: size = "medium", state: state = "normal", fullWidth: fullWidth = false, disabled: disabled = false, loading: loading = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            state: state,
            fullWidth: fullWidth,
            disabled: disabled,
            loading: loading,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$353f5b6fc5456de1 = $451487d20aa3eb8a$var$withLogic$1U($451487d20aa3eb8a$var$Component$1W);
$451487d20aa3eb8a$export$353f5b6fc5456de1.displayName = "Button";
$451487d20aa3eb8a$export$353f5b6fc5456de1.slotName = "jds_button";
const $451487d20aa3eb8a$var$sdl$1Q = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-pagination-1.0.0",
        "name": "JDSCarouselPagination",
        "layerName": "jds_carousel_pagination"
    },
    "hierarchy": {
        "container": [
            "jds_carousel_pagination_item"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "padding-top": "{c_4}",
            "padding-bottom": "{c_6}"
        },
        "jds_carousel_pagination_item": {
            "density": "relaxed"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "gap": "{c_7}"
                },
                "jds_carousel_pagination_item": {
                    "density": "condensed"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "density": {
                "type": "JDSCarouselPaginationItem.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "active": "boolean",
                        "kind": "JDSCarouselPaginationItem.kind"
                    }
                }
            },
            "jds_carousel_pagination_item": {
                "active": {
                    "type": "boolean",
                    "name": "items.active"
                },
                "kind": {
                    "type": "JDSCarouselPaginationItem.kind",
                    "name": "items.kind"
                }
            }
        },
        "events": {
            "jds_carousel_pagination_item": {
                "onDotClick": "onDotClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    }
                }
            }
        }
    }
};
function $451487d20aa3eb8a$var$getPaginationItemKind(currentIndex, kind, visibleArray, selectedIndex, total) {
    if (kind !== "diminishing") return "normal";
    if (visibleArray[0] === currentIndex && selectedIndex > 4 || visibleArray[visibleArray.length - 1] === currentIndex && selectedIndex < total - 3) return "tail_dot_small";
    if (visibleArray[1] === currentIndex && selectedIndex > 4 || visibleArray[visibleArray.length - 2] === currentIndex && selectedIndex < total - 3) return "tail_dot_large";
    return "normal";
}
const $451487d20aa3eb8a$var$getVisibleItems = (selectedIndex, total)=>{
    let leftCount, rightCount;
    if (selectedIndex === total - 1) {
        leftCount = 6;
        rightCount = 0;
    } else if (selectedIndex === total - 2) {
        leftCount = 5;
        rightCount = 2;
    } else {
        leftCount = Math.min(selectedIndex, 4);
        leftCount = leftCount < 0 ? 0 : leftCount;
        rightCount = 7 - leftCount;
        rightCount = rightCount > total ? total : rightCount;
    }
    let left = Array.from({
        length: leftCount + 1
    }).map((_, i)=>selectedIndex - i);
    left.reverse();
    const right = Array.from({
        length: rightCount
    }).map((_, i)=>selectedIndex + i);
    return Array.from(/* @__PURE__ */ new Set([
        ...left,
        selectedIndex,
        ...right
    ]));
};
const $451487d20aa3eb8a$var$withLogic$1T = (Component)=>(props)=>{
        const { selectedIndex: selectedIndex = 0, count: count, kind: kind } = props;
        const visibleItems = $451487d20aa3eb8a$var$getVisibleItems(selectedIndex, count);
        const items = Array.from({
            length: count
        }).map((_, index)=>{
            const itemKind = $451487d20aa3eb8a$var$getPaginationItemKind(index, count > 7 ? "diminishing" : "normal", visibleItems, selectedIndex, count);
            const isHidden = count > 7 && !visibleItems.includes(index);
            return {
                active: selectedIndex === index,
                kind: itemKind,
                internalClasses: [
                    isHidden ? "hide" : ""
                ].join(" ")
            };
        });
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
            style: {
                position: "relative"
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...{
                    ...props,
                    items: items
                }
            })
        });
    };
const $451487d20aa3eb8a$var$Component$1V = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1Q;
    const { density: density = "undefined", onDotClick: onDotClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            onDotClick: onDotClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselPagination", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$CarouselPagination = $451487d20aa3eb8a$var$withLogic$1T($451487d20aa3eb8a$var$Component$1V);
$451487d20aa3eb8a$var$CarouselPagination.displayName = "CarouselPagination";
$451487d20aa3eb8a$var$CarouselPagination.slotName = "jds_carousel_pagination";
const $451487d20aa3eb8a$var$sdl$1P = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-pagination-item-1.0.0",
        "name": "JDSCarouselPaginationItem",
        "layerName": "jds_carousel_pagination_item",
        "internal": true
    },
    "hierarchy": {
        "container": []
    },
    "base": {
        "container": {
            "width": "{c_0}",
            "height": "{c_1}",
            "background-color": "{c_2}",
            "opacity": "{c_3}",
            "border-radius": "{c_4}",
            "show": true,
            "behavior": {
                "hover": {
                    "background-color": "{c_5}",
                    "opacity": "{c_6}"
                },
                "active": {
                    "background-color": "{c_7}",
                    "opacity": "{c_8}"
                }
            }
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "height": "{c_9}"
                }
            }
        },
        "active": {
            "true": {
                "container": {
                    "opacity": "{c_10}",
                    "behavior": {
                        "hover": {
                            "background-color": "{c_11}"
                        },
                        "active": {
                            "background-color": "{c_12}"
                        }
                    }
                }
            }
        },
        "kind": {
            "label": {
                "container": {
                    "hidden": true
                }
            },
            "none": {
                "container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "condensed": {
                "false": {
                    "normal": {
                        "container": {
                            "width": "{c_18}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_19}",
                            "height": "{c_20}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_21}",
                            "height": "{c_22}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                },
                "true": {
                    "normal": {
                        "container": {
                            "width": "{c_23}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_24}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_25}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                }
            },
            "relaxed": {
                "false": {
                    "normal": {
                        "container": {
                            "width": "{c_13}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_14}",
                            "height": "{c_15}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_16}",
                            "height": "{c_17}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                },
                "true": {
                    "normal": {
                        "container": {
                            "width": "{c_26}"
                        }
                    },
                    "tail_dot_large": {
                        "container": {
                            "width": "{c_27}"
                        }
                    },
                    "tail_dot_small": {
                        "container": {
                            "width": "{c_28}"
                        }
                    },
                    "invisible": {
                        "container": {
                            "show": false
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "density",
            "active",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "tail_dot_large",
                    "tail_dot_small",
                    "invisible"
                ]
            },
            "density": {
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "active": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onDotClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    }
                }
            }
        },
        "data": {}
    }
};
const $451487d20aa3eb8a$var$withLogic$1S = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                onDotClick: ()=>props.onDotClick?.(props.internalIndex),
                className: props.internalClasses
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1U = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1P;
    const { kind: kind = "normal", density: density = "relaxed", active: active = false, onDotClick: onDotClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            density: density,
            active: active,
            onDotClick: onDotClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselPaginationItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$CarouselPaginationItem = $451487d20aa3eb8a$var$withLogic$1S($451487d20aa3eb8a$var$Component$1U);
$451487d20aa3eb8a$var$CarouselPaginationItem.displayName = "CarouselPaginationItem";
$451487d20aa3eb8a$var$CarouselPaginationItem.slotName = "jds_carousel_pagination_item";
const $451487d20aa3eb8a$var$sdl$1O = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-slide-1.0.0",
        "name": "JDSCarouselSlide",
        "layerName": "jds_carousel_slide"
    },
    "hierarchy": {
        "container": [
            "slide-slot"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "width": "{c_0}",
            "border-radius": "{c_1}",
            "enter-animation-name": "slideHorizontallyToLeft",
            "exit-animation-name": "slideHorizontallyToLeft",
            "padding-left": "{xxs}",
            "padding-right": "{xxs}",
            "web-cursor": "pointer"
        }
    },
    "variant": {
        "active": {
            "true": {
                "container": {
                    "hidden": false
                }
            }
        },
        "forward": {
            "false": {
                "container": {
                    "enter-animation-name": "slideHorizontallyToRight",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "_platform": {
            "desktop": {
                "container": {
                    "padding-left": 0,
                    "padding-right": 0
                }
            }
        }
    },
    "api": {
        "config": {
            "active": {
                "values": [
                    false,
                    true
                ]
            },
            "forward": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "tablet",
                    "desktop"
                ]
            }
        },
        "children": {
            "slide-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onSwipeLeft": "onSwipeLeft",
                "onSwipeRight": "onSwipeRight"
            }
        },
        "data": {}
    }
};
const $451487d20aa3eb8a$var$makeClass = (classes)=>classes.filter((e)=>e).join(" ").trim();
const $451487d20aa3eb8a$var$setCSSVar = (obj)=>{
    Object.keys(obj).forEach((key)=>obj[key] === void 0 && delete obj[key]);
    return obj;
};
const $451487d20aa3eb8a$var$getPlatform = ()=>{
    if ($451487d20aa3eb8a$var$Devices.isMobile()) return "mobile";
    if ($451487d20aa3eb8a$var$Devices.isTablet()) return "tablet";
    return "desktop";
};
const $451487d20aa3eb8a$var$withLogic$1R = (Component)=>(props)=>{
        const internalProps = props;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                active: true,
                platform: $451487d20aa3eb8a$var$getPlatform(),
                onPointerDown: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchdown"
                    });
                },
                onPointerMove: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchmove"
                    });
                },
                onPointerUp: (ev)=>{
                    internalProps?.onSwipeLeft?.(ev, {
                        type: "touchup"
                    });
                },
                onDragStart: (ev)=>{
                    ev.preventDefault();
                },
                onDragEnd: (ev)=>{
                    ev.preventDefault();
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1T = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1O;
    const { active: active = false, forward: forward = true, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSwipeLeft: onSwipeLeft = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSwipeRight: onSwipeRight = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            active: active,
            forward: forward,
            onClick: onClick,
            onSwipeLeft: onSwipeLeft,
            onSwipeRight: onSwipeRight,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarouselSlide", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$cabb5ccfbd60cbd4 = $451487d20aa3eb8a$var$withLogic$1R($451487d20aa3eb8a$var$Component$1T);
$451487d20aa3eb8a$export$cabb5ccfbd60cbd4.displayName = "CarouselSlide";
$451487d20aa3eb8a$export$cabb5ccfbd60cbd4.slotName = "jds_carousel_slide";
const $451487d20aa3eb8a$var$sdl$1N = {
    "metadata": {
        "version": "1.0.0",
        "id": "content-block-1.0.0",
        "name": "JDSContentBlock",
        "layerName": "jds_content_block"
    },
    "hierarchy": {
        "root-container": [
            {
                "inner-container": [
                    {
                        "caption-container": [
                            "caption-slot"
                        ]
                    },
                    "title-jds-text",
                    "description-jds-text",
                    {
                        "children-container": [
                            "children-slot"
                        ]
                    }
                ]
            },
            {
                "button-container": [
                    "primary-jds_button",
                    "secondary-jds_button",
                    "primary-inverted-jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{c_0}",
            "align-items": "{c_1}",
            "justify-content": "{c_2}",
            "width": "{c_3}",
            "gap": "{m}"
        },
        "inner-container": {
            "flex-direction": "{c_4}",
            "align-items": "{c_5}",
            "justify-content": "{c_6}"
        },
        "caption-container": {
            "padding-bottom": "{c_8}",
            "hidden": false
        },
        "children-container": {
            "hidden": false
        },
        "button-container": {
            "flex-direction": "{c_12}",
            "gap": "{c_14}"
        },
        "primary-jds_button": {
            "kind": "primary",
            "size": "small",
            "hidden": false
        },
        "secondary-jds_button": {
            "kind": "secondary",
            "size": "small"
        },
        "primary-inverted-jds_button": {
            "kind": "primary",
            "size": "small",
            "hidden": true
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{c_9}"
        },
        "description-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{c_10}"
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-small": {
                "title-jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            },
            "small": {
                "title-jds-text": {
                    "font-family": "{headingS}",
                    "font-size": "{headingS}",
                    "line-height": "{headingS}",
                    "letter-spacing": "{headingS}",
                    "font-weight": "{headingS}",
                    "padding-bottom": "{c_15}"
                },
                "description-jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "medium": {
                "caption-container": {
                    "padding-bottom": "{c_16}"
                },
                "button-container": {
                    "gap": "{c_18}"
                },
                "primary-jds_button": {
                    "size": "medium"
                },
                "secondary-jds_button": {
                    "size": "medium"
                },
                "primary-inverted-jds_button": {
                    "size": "medium"
                },
                "title-jds-text": {
                    "font-family": "{headingM}",
                    "font-size": "{headingM}",
                    "line-height": "{headingM}",
                    "letter-spacing": "{headingM}",
                    "font-weight": "{headingM}",
                    "padding-bottom": "{c_17}"
                },
                "description-jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "large": {
                "caption-container": {
                    "padding-bottom": "{c_19}"
                },
                "button-container": {
                    "gap": "{c_22}"
                },
                "primary-jds_button": {
                    "size": "large"
                },
                "secondary-jds_button": {
                    "size": "large"
                },
                "primary-inverted-jds_button": {
                    "size": "large"
                },
                "title-jds-text": {
                    "font-family": "{headingL}",
                    "font-size": "{headingL}",
                    "line-height": "{headingL}",
                    "letter-spacing": "{headingL}",
                    "font-weight": "{headingL}",
                    "padding-bottom": "{c_20}"
                },
                "description-jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            },
            "xtra-large": {
                "caption-container": {
                    "padding-bottom": "{c_23}"
                },
                "button-container": {
                    "gap": "{c_26}"
                },
                "primary-jds_button": {
                    "size": "large"
                },
                "secondary-jds_button": {
                    "size": "large"
                },
                "primary-inverted-jds_button": {
                    "size": "large"
                },
                "title-jds-text": {
                    "font-family": "{headingXl}",
                    "font-size": "{headingXl}",
                    "line-height": "{headingXl}",
                    "letter-spacing": "{headingXl}",
                    "font-weight": "{headingXl}",
                    "padding-bottom": "{c_24}"
                },
                "description-jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            }
        },
        "invertCTA": {
            "true": {
                "primary-jds_button": {
                    "hidden": true
                },
                "primary-inverted-jds_button": {
                    "hidden": false
                }
            }
        },
        "ctaWrap": {
            "vertical": {
                "button-container": {
                    "flex-direction": "{c_27}"
                },
                "primary-jds_button": {
                    "fullWidth": true
                },
                "secondary-jds_button": {
                    "fullWidth": true
                },
                "primary-inverted-jds_button": {
                    "fullWidth": true
                }
            }
        },
        "shouldOverrideColor": {
            "true": {
                "title-jds-text": {
                    "color": "{global.white}"
                },
                "description-jds-text": {
                    "color": "{global.white}"
                }
            }
        },
        "singleButton": {
            "false": {
                "inner-container": {
                    "width": "{c_28}"
                },
                "button-container": {
                    "width": "{c_29}"
                }
            }
        },
        "isTertiary": {
            "true": {
                "secondary-jds_button": {
                    "kind": "tertiary"
                }
            }
        },
        "_hasCaptionSlot": {
            "false": {
                "caption-container": {
                    "hidden": true
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                },
                "description-jds-text": {
                    "padding-bottom": "{custom_5}"
                }
            }
        },
        "_hasDescription": {
            "false": {
                "description-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "desktop": {
                "medium": {
                    "title-jds-text": {
                        "padding-bottom": "{c_30}"
                    }
                },
                "large": {
                    "title-jds-text": {
                        "padding-bottom": "{c_31}"
                    }
                },
                "xtra-large": {
                    "title-jds-text": {
                        "padding-bottom": "{c_32}"
                    }
                }
            }
        },
        {
            "true": {
                "xtra-xtra-small": {
                    "root-container": {
                        "flex-direction": "{c_33}",
                        "justify-content": "{c_34}",
                        "align-items": "{c_35}"
                    },
                    "button-container": {
                        "flex-direction": "{c_36}",
                        "justify-content": "{c_37}",
                        "align-items": "{c_38}"
                    },
                    "inner-container": {
                        "flex": 1
                    },
                    "primary-jds_button": {
                        "hidden": false
                    },
                    "secondary-jds_button": {
                        "hidden": true
                    },
                    "primary-inverted-jds_button": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "false": {
                "false": {
                    "title-jds-text": {
                        "padding-bottom": "{custom_5}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_platform",
            "size"
        ],
        [
            "singleButton",
            "size"
        ],
        [
            "_hasChildrenSlot",
            "_hasDescription"
        ]
    ],
    "api": {
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "size": {
                "values": [
                    "xtra-small",
                    "xtra-xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large"
                ],
                "doc_description": "It can be used to control the size of ContentBlock."
            },
            "ctaWrap": {
                "values": [
                    "horizontal",
                    "vertical"
                ],
                "doc_description": "It can be used to either wrap the primary button, secondary button horizontally or vertically."
            },
            "invertCTA": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It inverts the order of the CTAs if true."
            },
            "shouldOverrideColor": {
                "values": [
                    false,
                    true
                ]
            },
            "singleButton": {
                "values": [
                    false,
                    true
                ]
            },
            "isTertiary": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasCaptionSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "secondary-jds_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of primary button of Toast."
                }
            },
            "primary-inverted-jds_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of ContentBlock."
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the ContentBlock."
                }
            }
        },
        "children": {
            "caption-slot": {
                "name": "caption",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1,
                "doc_description": "It displays the header of the ContentBlock. Can be 'badge', 'text', 'tag'."
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "primary-jds_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-inverted-jds_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "primary-jds_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "primary-inverted-jds_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacySizes$2 = [
    "m",
    "l",
    "xl",
    "s",
    "xs",
    "xxs"
];
const $451487d20aa3eb8a$var$PROP_MAP$q = (props)=>{
    if ($451487d20aa3eb8a$var$legacySizes$2.includes(props.size)) console.warn($451487d20aa3eb8a$var$legacySizes$2.join(","), "are deprecated. Use sizes staring with xtra, large, small");
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.onPrimaryClick || props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.onSecondaryClick || props.secondaryCTA?.onClick
            }
        },
        size: {
            defaultValue: "xtra-small",
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$sizeMap = {
    xxs: "small",
    xs: "small",
    s: "small",
    m: "medium",
    l: "large",
    xl: "xtra-large",
    "xtra-small": "small",
    "xtra-xtra-small": "small",
    "xtra-large": "large"
};
const $451487d20aa3eb8a$var$withLogic$1Q = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$q);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                caption: props.caption ? (0, $1OEoy.cloneElement)(props.caption, {
                    size: $451487d20aa3eb8a$var$sizeMap[props.size] || props.size
                }) : void 0,
                _hasCaptionSlot: Boolean(props.caption),
                _hasChildrenSlot: Boolean(props.children),
                _platform: $451487d20aa3eb8a$var$Devices.isDesktop() ? "desktop" : "mobile"
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1S = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1N;
    const { size: size = "xtra-small", ctaWrap: ctaWrap = "horizontal", invertCTA: invertCTA = false, shouldOverrideColor: shouldOverrideColor = false, singleButton: singleButton = false, isTertiary: isTertiary = false, onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            ctaWrap: ctaWrap,
            invertCTA: invertCTA,
            shouldOverrideColor: shouldOverrideColor,
            singleButton: singleButton,
            isTertiary: isTertiary,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContentBlock", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$eb38b3b9c7f5f31b = $451487d20aa3eb8a$var$withLogic$1Q($451487d20aa3eb8a$var$Component$1S);
$451487d20aa3eb8a$export$eb38b3b9c7f5f31b.displayName = "ContentBlock";
$451487d20aa3eb8a$export$eb38b3b9c7f5f31b.slotName = "jds_content_block";
const $451487d20aa3eb8a$var$JDSDatepickerDesktop = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-desktop-1.0.0",
        "name": "JDSDatepickerDesktop",
        "layerName": "jds_datepicker_desktop",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_datepicker_desktop_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "hidden": true,
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "popup-container": {
                    "hidden": false,
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            },
            "jds_datepicker_desktop_internal": {
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "monthName": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                },
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "current": {
                    "type": "number",
                    "name": "year"
                },
                "yearData": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "date": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "value": {
                    "type": "date",
                    "name": "value"
                },
                "calendarData": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "yearLoadCount": {
                    "type": "number",
                    "platform": "web",
                    "name": "yearLoadCount"
                },
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                },
                "row": {
                    "type": "list",
                    "name": "rows.row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state"
                    }
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_datepicker_desktop_internal": {
                "onClose": "onClose",
                "onSelect": "onSelect"
            }
        },
        "a11y": {
            "jds_datepicker_desktop_internal": {
                "properties": {
                    "previousButtonAriaLabel": "previousButtonAriaLabel",
                    "closeAriaLabel": "closeAriaLabel",
                    "previousMonthAriaLabel": "previousMonthAriaLabel",
                    "nextMonthAriaLabel": "nextMonthAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$sdl$1M = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-mobile-1.0.0",
        "name": "JDSDatepickerMobile",
        "layerName": "jds_datepicker_mobile"
    },
    "hierarchy": {
        "popup": [
            "jds_datepicker_mobile_internal"
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "jds_datepicker_mobile_internal": {
            "state": "default",
            "open": false
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "jds_datepicker_mobile_internal": {
                    "state": "month_view"
                }
            },
            "year_view": {
                "jds_datepicker_mobile_internal": {
                    "state": "year_view"
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "jds_datepicker_mobile_internal": {
                    "open": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_datepicker_mobile_internal": {
                "monthName": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "string",
                    "name": "year"
                },
                "showArrows": {
                    "type": "boolean",
                    "name": "showArrows"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                },
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "current": {
                    "type": "number",
                    "name": "year"
                },
                "yearData": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "date": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "value": {
                    "type": "date",
                    "name": "value"
                },
                "calendarData": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "calendarDays": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "_calendarDays"
                },
                "calendarRows": {
                    "type": "JDSDatepickerCalendar.rows",
                    "name": "_calendarRows"
                },
                "confirmDate": {
                    "type": "string",
                    "name": "confirmDate"
                }
            }
        },
        "events": {
            "jds_datepicker_mobile_internal": {
                "onClose": "onClose",
                "onConfirm": "onConfirm"
            }
        },
        "a11y": {
            "jds_datepicker_mobile_internal": {
                "properties": {
                    "previousButtonAriaLabel": "previousButtonAriaLabel",
                    "closeAriaLabel": "closeAriaLabel",
                    "previousMonthAriaLabel": "previousMonthAriaLabel",
                    "nextMonthAriaLabel": "nextMonthAriaLabel",
                    "confirmAriaLabel": "confirmAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$DatePickerWidth = 384;
const $451487d20aa3eb8a$var$setPositions$1 = (position = "left-end", container, trigger)=>{
    if (!trigger || !container) return {
        left: 0,
        top: 0
    };
    const triggerBounds = trigger.getBoundingClientRect();
    const triggerOffsetTop = trigger.getBoundingClientRect()?.top;
    const triggerOffsetLeft = trigger.getBoundingClientRect()?.left;
    const bodyHeight = document.body.clientHeight;
    const bodyWidth = document.body.clientWidth;
    const datePickerHeight = 484;
    let left = 0;
    let top;
    let height;
    let width;
    switch(position){
        case "right-start":
        case "left-start":
            top = triggerOffsetTop;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            break;
        case "right-end":
        case "left-end":
            top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            if (top < 0) top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (top < 0) top = triggerOffsetTop;
            if (left + $451487d20aa3eb8a$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft - $451487d20aa3eb8a$var$DatePickerWidth;
            break;
        case "right":
        case "left":
            top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            if (triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2 < 0) top = triggerOffsetTop;
            if (triggerOffsetTop + triggerBounds.height / 2 + datePickerHeight / 2 > bodyHeight) top = triggerOffsetTop + triggerBounds.height - datePickerHeight;
            break;
        case "top-start":
        case "bottom-start":
            left = triggerOffsetLeft;
            if (left + $451487d20aa3eb8a$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width / 2 - $451487d20aa3eb8a$var$DatePickerWidth / 2;
            if (left + $451487d20aa3eb8a$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width - $451487d20aa3eb8a$var$DatePickerWidth;
            break;
        case "top-end":
        case "bottom-end":
            left = triggerOffsetLeft + triggerBounds.width - $451487d20aa3eb8a$var$DatePickerWidth;
            if (left < 0) left = triggerOffsetLeft + triggerBounds.width / 2 - $451487d20aa3eb8a$var$DatePickerWidth / 2;
            if (left < 0) left = triggerOffsetLeft;
            break;
        case "top":
        case "bottom":
            left = triggerOffsetLeft + triggerBounds.width / 2 - $451487d20aa3eb8a$var$DatePickerWidth / 2;
            if (left < 0) left = triggerOffsetLeft;
            if (left + $451487d20aa3eb8a$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft + triggerBounds.width - $451487d20aa3eb8a$var$DatePickerWidth;
            break;
    }
    switch(position){
        case "right":
        case "right-start":
        case "right-end":
            left = triggerOffsetLeft + triggerBounds.width;
            if (left + $451487d20aa3eb8a$var$DatePickerWidth > bodyWidth) left = triggerOffsetLeft - $451487d20aa3eb8a$var$DatePickerWidth;
            break;
        case "left":
        case "left-start":
        case "left-end":
            left = triggerOffsetLeft - $451487d20aa3eb8a$var$DatePickerWidth;
            if (left < 0) left = triggerOffsetLeft + triggerBounds.width;
            break;
        case "top-start":
        case "top":
        case "top-end":
            top = triggerOffsetTop - datePickerHeight;
            if (top < 0) top = triggerOffsetTop + triggerBounds.height;
            break;
        case "bottom-start":
        case "bottom":
        case "bottom-end":
            top = triggerOffsetTop + triggerBounds.height;
            if (top + datePickerHeight > bodyHeight) top = triggerOffsetTop - datePickerHeight;
            break;
        default:
            top = triggerOffsetTop + triggerBounds.height / 2 - datePickerHeight / 2;
            left = triggerOffsetLeft + triggerBounds.width;
    }
    return {
        left: left,
        top: top,
        maxHeight: height,
        maxWidth: width
    };
};
const $451487d20aa3eb8a$var$useToggle = (value, condition, listener)=>{
    const [selected, setSelected] = (0, $1OEoy.useState)(value);
    (0, $1OEoy.useEffect)(()=>{
        setSelected(value);
    }, [
        value
    ]);
    const toggle = (e)=>{
        listener?.(e);
        if (condition || typeof condition === "undefined") setSelected(!selected);
    };
    const close = ()=>{
        if (selected) setSelected(false);
    };
    return {
        selected: selected,
        toggle: toggle,
        close: close
    };
};
const $451487d20aa3eb8a$var$DEBOUNCE_TIME = 400;
const $451487d20aa3eb8a$var$DATEPICKERINTERNAL_SELECTOR = "div.j-JDSDatepickerDesktopInternal-container";
const $451487d20aa3eb8a$var$withLogic$1P = (Component)=>(props)=>{
        const { onClose: onClose, close: userClose = true, open: open, ...rest } = props;
        const closeProp = typeof open === "undefined" ? userClose : !open;
        const [containerElement, setContainerElement] = (0, $1OEoy.useState)();
        const anchorRef = (0, $1OEoy.useRef)(null);
        const trigger = props.triggerRef || anchorRef;
        const { selected: selected, toggle: toggle, close: close } = $451487d20aa3eb8a$var$useToggle(!closeProp, true, props.onClose);
        const [coords, setCoords] = (0, $1OEoy.useState)({
            left: 0,
            top: 0
        });
        const calculateInitialPosition = (0, $1OEoy.useCallback)(()=>{
            if (trigger.current && containerElement) {
                const { left: left, top: top } = $451487d20aa3eb8a$var$setPositions$1(props.position, containerElement, trigger.current);
                setCoords({
                    left: left,
                    top: top || 0
                });
            }
        }, [
            trigger,
            containerElement,
            props.position
        ]);
        const [shouldRender, setShouldRender] = (0, $1OEoy.useState)(selected);
        (0, $1OEoy.useEffect)(()=>{
            if (!shouldRender) return;
            calculateInitialPosition();
        }, [
            shouldRender,
            calculateInitialPosition
        ]);
        const containerRef = (0, $1OEoy.useCallback)((ref)=>{
            setContainerElement(ref);
        }, []);
        (0, $1OEoy.useEffect)(()=>{
            const resizeObserver = new ResizeObserver(()=>{
                calculateInitialPosition();
            });
            if (trigger.current) resizeObserver.observe(trigger.current);
            return ()=>{
                if (trigger.current) resizeObserver.unobserve(trigger.current);
            };
        }, [
            trigger,
            calculateInitialPosition
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window?.addEventListener("resize", $451487d20aa3eb8a$var$debounce(calculateInitialPosition, $451487d20aa3eb8a$var$DEBOUNCE_TIME));
            return ()=>window?.removeEventListener("resize", $451487d20aa3eb8a$var$debounce(calculateInitialPosition, $451487d20aa3eb8a$var$DEBOUNCE_TIME));
        }, [
            calculateInitialPosition
        ]);
        const scrollCloseListener = (0, $1OEoy.useCallback)(()=>{
            close();
            onClose?.();
        }, [
            close,
            onClose
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window.addEventListener("scroll", scrollCloseListener);
            return ()=>{
                window.removeEventListener("scroll", scrollCloseListener);
            };
        }, [
            scrollCloseListener
        ]);
        const [firstChild = /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("span", {}), ...restChildren] = (0, $1OEoy.Children).toArray(props.children);
        (0, $1OEoy.useEffect)(()=>{
            let timeout;
            if (selected) setShouldRender(true);
            else timeout = setTimeout(()=>{
                setShouldRender(false);
                setCoords(null);
            }, $451487d20aa3eb8a$var$DEBOUNCE_TIME);
            return ()=>clearTimeout(timeout);
        }, [
            selected
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (!shouldRender || !selected) return;
            const timer = setTimeout(()=>{
                const datePickerInternalRef = document.querySelector($451487d20aa3eb8a$var$DATEPICKERINTERNAL_SELECTOR);
                datePickerInternalRef?.setAttribute("tabindex", "0");
                datePickerInternalRef?.focus();
            }, $451487d20aa3eb8a$var$DEBOUNCE_TIME);
            return ()=>clearTimeout(timer);
        }, [
            shouldRender,
            selected
        ]);
        (0, $1OEoy.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (selected && event.key === "Escape") {
                    close();
                    onClose?.();
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            close,
            onClose,
            selected
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
            children: [
                shouldRender && /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        open: selected,
                        triggerRef: containerRef,
                        onClose: ()=>{
                            if (selected) toggle();
                            onClose?.();
                        },
                        calendarData: {
                            disabledDates: props.disabledDates,
                            dateFilter: props.dateFilter,
                            min: props.min,
                            max: props.max
                        },
                        onClick: (ev)=>ev.stopPropagation(),
                        offsetX: coords?.left,
                        offsetY: coords?.top,
                        _onMonthSelect: (i)=>{
                            props.onMonthSelect?.();
                        },
                        _onYearSelect: (i)=>{
                            props.onYearSelect?.();
                        },
                        style: coords ? void 0 : {
                            visibility: "hidden"
                        }
                    }
                }),
                (0, $1OEoy.cloneElement)(firstChild, {
                    ref: anchorRef
                }),
                restChildren
            ]
        });
    };
const $451487d20aa3eb8a$var$Component$1R = (props)=>{
    const { platform: platform, ...restSwitchables } = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = platform === "desktop" ? $451487d20aa3eb8a$var$JDSDatepickerDesktop : $451487d20aa3eb8a$var$sdl$1M;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerDesktop", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$5109c6dd95d8fb00 = $451487d20aa3eb8a$var$withLogic$1P($451487d20aa3eb8a$var$Component$1R);
$451487d20aa3eb8a$export$5109c6dd95d8fb00.displayName = "DatePicker";
$451487d20aa3eb8a$export$5109c6dd95d8fb00.slotName = "jds_datepicker_desktop";
const $451487d20aa3eb8a$var$sdl$1L = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-button-1.0.0",
        "name": "JDSDatepickerButton",
        "layerName": "jds_datepicker_button",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text",
            {
                "jds-icon-container": [
                    "jds-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "disabled": false,
            "height": "{d_0}",
            "border-radius": "{d_2}",
            "background-color": "{d_3}",
            "border-width": "{d_4}",
            "border-color": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}",
            "gap": "{d_9}",
            "padding-right": "{d_10}",
            "padding-left": "{d_11}",
            "behavior": {
                "hover": {
                    "border-color": "{d_12}"
                },
                "focus": {
                    "border-color": "{d_13}",
                    "border-width": "{d_14}"
                },
                "active": {
                    "border-color": "{d_15}",
                    "background-color": "{d_16}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary60}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primary60}",
            "value": "ic_chevron_down",
            "hidden": false,
            "ic": "ic_chevron_down"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": false,
            "ic": "ic_chevron_down"
        }
    },
    "variant": {
        "state": {
            "selected": {
                "container": {
                    "background-color": "{d_17}",
                    "border-color": "{d_18}"
                },
                "jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            },
            "disabled": {
                "container": {
                    "disabled": true,
                    "border-width": "{d_19}",
                    "opacity": "{d_20}"
                }
            },
            "text_only": {
                "container": {
                    "disabled": true,
                    "border-width": "{d_21}"
                },
                "jds-text": {
                    "color": "{primaryGrey100}"
                },
                "jds-icon": {
                    "hidden": true
                },
                "jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "selected",
                    "disabled",
                    "text_only"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "text"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1O = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaExpanded: props.state === "selected" ? "true" : "false"
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1Q = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1L;
    const { state: state = "default", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.text?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$395dd20d84297b30 = $451487d20aa3eb8a$var$withLogic$1O($451487d20aa3eb8a$var$Component$1Q);
$451487d20aa3eb8a$export$395dd20d84297b30.displayName = "DatepickerButton";
$451487d20aa3eb8a$export$395dd20d84297b30.slotName = "jds_datepicker_button";
const $451487d20aa3eb8a$var$sdl$1K = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-1.0.0",
        "name": "JDSDatepickerCalendar",
        "layerName": "jds_datepicker_calendar",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_header",
            {
                "rows-container": [
                    "jds_datepicker_calendar_row"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "gap": "{d_3}"
        },
        "rows-container": {
            "flex-direction": "{d_4}",
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_datepicker_calendar_header": {
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                }
            },
            "rows-container": {
                "rows.day": {
                    "type": "date",
                    "name": "day"
                },
                "rows.month": {
                    "type": "number",
                    "name": "month"
                },
                "rows.year": {
                    "type": "number",
                    "name": "year"
                },
                "rows.selected": {
                    "type": "date",
                    "name": "selected"
                },
                "rows.disabled": {
                    "type": "object",
                    "name": "disabled",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "rows.loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "selected": "boolean",
                        "disabled": "boolean"
                    }
                },
                "value": {
                    "type": "list",
                    "name": "rows",
                    "object": {
                        "row": "JDSDatepickerCalendarRow.row"
                    }
                }
            },
            "jds_datepicker_calendar_row": {
                "row": {
                    "type": "list",
                    "name": "rows.row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onSwipeLeft": "onSwipeLeft",
                "onSwipeRight": "onSwipeRight"
            },
            "jds_datepicker_calendar_row": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "_calendarAriaLabel",
                        "value": "Select date from calendar"
                    }
                }
            },
            "jds_datepicker_calendar_row": {
                "properties": {
                    "dateAriaLabel": {
                        "name": "dateAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$getNormalisedDate$1 = (value)=>{
    const date = new Date(value || /* @__PURE__ */ new Date());
    if (!date.getTime()) return {
        day: 0,
        month: 0,
        year: 0
    };
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
function $451487d20aa3eb8a$var$removeTime(d) {
    d.setHours(0, 0, 0, 0);
    return d;
}
const $451487d20aa3eb8a$var$isToday = (date, month, year, day)=>{
    if (year !== date.getFullYear()) return false;
    if (month !== date.getMonth()) return false;
    if (day !== date.getDate()) return false;
    return true;
};
const $451487d20aa3eb8a$var$isDateDisabled = (value, disabled, dateFilter, min, max)=>{
    if (dateFilter) return dateFilter(value);
    const { day: day, month: month, year: year } = $451487d20aa3eb8a$var$getNormalisedDate$1(value);
    const disabledData = disabled.map((d)=>$451487d20aa3eb8a$var$getNormalisedDate$1(d));
    const disabledIndex = disabledData.findIndex((d)=>{
        if (!(d.day === day)) return false;
        if (!(d.month === month)) return false;
        if (!(d.year === year)) return false;
        return true;
    });
    if (disabledIndex >= 0) return true;
    if (min && max) {
        const minDate = $451487d20aa3eb8a$var$removeTime(new Date(min));
        const maxDate = $451487d20aa3eb8a$var$removeTime(new Date(max));
        const currentValue = $451487d20aa3eb8a$var$removeTime(new Date(value));
        return !(currentValue <= maxDate && currentValue >= minDate);
    }
    if (min) {
        const minDate = $451487d20aa3eb8a$var$removeTime(new Date(min));
        const currentValue = $451487d20aa3eb8a$var$removeTime(new Date(value));
        return !(currentValue >= minDate);
    }
    if (max) {
        const maxDate = $451487d20aa3eb8a$var$removeTime(new Date(max));
        const currentValue = $451487d20aa3eb8a$var$removeTime(new Date(value));
        return !(currentValue <= maxDate);
    }
};
const $451487d20aa3eb8a$var$getDayState = (day, month, year, currentCount, selected)=>{
    const today = /* @__PURE__ */ new Date();
    const selectedDate = $451487d20aa3eb8a$var$getNormalisedDate$1(selected);
    if (day - 1 === currentCount && selectedDate.month === month && selectedDate.year === year) return "selected";
    if ($451487d20aa3eb8a$var$isToday(today, month - 1, year, currentCount + 1)) return "current";
    return "default";
};
const $451487d20aa3eb8a$var$createRows = (month = 0, year = 0, day = 0, disabled = [], dateFilter, selected, min, max)=>{
    const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const language = tokens.lang;
    const getMonthDatesFromLocale = (0, $1OEoy.useMemo)(()=>{
        return (0, $ddff9b86434e3f59$export$4ee93fd31f185549)(language);
    }, [
        language
    ]);
    const visibleMonth = $451487d20aa3eb8a$var$removeTime(new Date(year, month - 1, 1));
    const firstDayOfMonth = visibleMonth.getDay();
    const daysInMonth = new Date(year, month, 0).getDate();
    const blanks = [];
    for(let i = 0; i < firstDayOfMonth; i++)blanks.push({
        state: "empty"
    });
    const finalRows = [];
    const rows = Array.from({
        length: daysInMonth
    }).map((_, i)=>{
        return {
            value: i + 1,
            internalIndex: i + 1,
            state: $451487d20aa3eb8a$var$getDayState(day, month, year, i, selected),
            disabled: $451487d20aa3eb8a$var$isDateDisabled(new Date(year, month - 1, i + 1), disabled, dateFilter, min, max)
        };
    });
    const rowsWithBlanks = blanks.concat(rows);
    while(rowsWithBlanks.length % 7 !== 0)rowsWithBlanks.push({
        state: "empty"
    });
    let sum = 0;
    while(sum <= daysInMonth + 7){
        const localizedRows = rowsWithBlanks.slice(sum, sum + 7).map(({ value: value, state: state, disabled: disabled2, ...rest })=>({
                value: value ? getMonthDatesFromLocale[value - 1] : void 0,
                state: // Adjust index
                state,
                disabled: disabled2,
                ...rest
            }));
        finalRows.push({
            row: localizedRows
        });
        sum = sum + 7;
    }
    return finalRows;
};
const $451487d20aa3eb8a$var$loadedYears = (max = 0, min = 0, selected, disabled)=>{
    const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const language = tokens.lang;
    const numeralList = (0, $1OEoy.useMemo)(()=>{
        return (0, $ddff9b86434e3f59$export$3f81e69b9bc596cd)(language);
    }, [
        language
    ]);
    const getLocaleYear = (year)=>{
        const yearString = year?.toString();
        return yearString?.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
    };
    return Array.from({
        length: max - min
    }).map((_, i)=>{
        return {
            name: getLocaleYear(min + i),
            value: min + i,
            selected: min + i === selected,
            disabled: disabled?.[i] === true
        };
    });
};
const $451487d20aa3eb8a$var$loadedMonths = (selected, selectedYear, selectable, min, max)=>{
    const { month: minMonth, year: minYear } = $451487d20aa3eb8a$var$getNormalisedDate$1(min);
    const { month: maxMonth, year: maxYear } = $451487d20aa3eb8a$var$getNormalisedDate$1(max);
    const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const language = tokens?.lang;
    const getMonthNamesFromLocale = (0, $1OEoy.useMemo)(()=>{
        return (0, $ddff9b86434e3f59$export$cae41416faa27367)(language);
    }, [
        language
    ]);
    return getMonthNamesFromLocale.map((month, i)=>{
        let disabled = false;
        if (selectedYear === minYear && min) disabled = i + 1 < minMonth;
        if (selectedYear === maxYear && max) disabled = disabled || i + 1 > maxMonth;
        return {
            name: month,
            value: i + 1,
            selected: selected === i + 1,
            disabled: !selectable || disabled
        };
    });
};
const $451487d20aa3eb8a$var$getDisabledYears = (minYear, maxYear, minDate, maxDate)=>{
    if (!minDate && !maxDate) return [];
    const { year: currentMinYear } = $451487d20aa3eb8a$var$getNormalisedDate$1(minDate);
    const { year: currentMaxYear } = $451487d20aa3eb8a$var$getNormalisedDate$1(maxDate);
    const years = Array.from({
        length: maxYear - minYear
    }).map((_, i)=>{
        const year = minYear + i;
        if (minDate && maxDate) return year < currentMinYear || year > currentMaxYear;
        if (minDate) return year < currentMinYear;
        if (maxDate) return year > currentMaxYear;
        return false;
    });
    return years;
};
const $451487d20aa3eb8a$var$withLogic$1N = (Component)=>(props)=>{
        const { month: month, year: year, day: day } = props;
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const getWeekdayInitialsFromLocale = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$3d12634d88530fee)(language);
        }, [
            language
        ]);
        const rows = $451487d20aa3eb8a$var$createRows(month, year, day, props.disabled.disabledDates, props.disabled.dateFilter, props.selected, props.disabled?.min, props.disabled?.max);
        const selectedDate = props.selected;
        const options = {
            weekday: "long",
            month: "long",
            day: "numeric",
            year: "numeric"
        };
        const dateWithoutTime = selectedDate.toLocaleDateString("en-US", options);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rows: rows,
                dateAriaLabel: `Selected date ${dateWithoutTime}`,
                days: getWeekdayInitialsFromLocale.map((d)=>({
                        letter: d[0]
                    }))
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1P = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1K;
    const { onSwipeLeft: onSwipeLeft = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSwipeRight: onSwipeRight = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onSwipeLeft: onSwipeLeft,
            onSwipeRight: onSwipeRight,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendar", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$cfdbf347b14a0a8d = $451487d20aa3eb8a$var$withLogic$1N($451487d20aa3eb8a$var$Component$1P);
$451487d20aa3eb8a$export$cfdbf347b14a0a8d.displayName = "DatepickerCalendar";
$451487d20aa3eb8a$export$cfdbf347b14a0a8d.slotName = "jds_datepicker_calendar";
const $451487d20aa3eb8a$var$sdl$1J = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-button-1.0.0",
        "name": "JDSDatepickerCalendarButton",
        "layerName": "jds_datepicker_calendar_button",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "button-container": [
                    "jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "height": "{d_6}",
            "show": true
        },
        "button-container": {
            "hidden": false,
            "flex-direction": "{d_8}",
            "justify-content": "{d_9}",
            "align-items": "{d_10}",
            "height": "{d_13}",
            "border-radius": "{d_14}",
            "border-width": 0,
            "border-color": "{d_15}",
            "background-color": "{d_16}",
            "behavior": {
                "hover": {
                    "background-color": "{d_17}"
                },
                "active": {
                    "background-color": "{d_18}"
                },
                "focus": {
                    "background-color": "{d_19}",
                    "border-width": "{d_20}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary60}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_type": {
            "rounded": {
                "container": {
                    "width": "{d_11}"
                },
                "button-container": {
                    "width": "{d_11}"
                }
            },
            "rectangular": {
                "container": {
                    "width": "{d_5}"
                },
                "button-container": {
                    "height": "{d_6}",
                    "width": "{d_3}",
                    "flex-direction": "{d_0}",
                    "justify-content": "{d_1}",
                    "align-items": "{d_2}"
                }
            }
        },
        "state": {
            "selected": {
                "button-container": {
                    "background-color": "{d_21}"
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {
                            "color": "{primary60}"
                        },
                        "focus": {
                            "color": "{primary60}"
                        }
                    }
                }
            },
            "current": {
                "button-container": {
                    "background-color": "{d_22}"
                }
            },
            "empty": {
                "button-container": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_23}"
                },
                "button-container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "_type": {
                "values": [
                    "rounded",
                    "rectangular"
                ]
            },
            "state": {
                "values": [
                    "default",
                    "selected",
                    "current",
                    "empty"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "value"
                }
            }
        },
        "events": {
            "button-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "button-container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    },
                    "aria-current": "_ariaCurrent",
                    "aria-checked": "_ariaChecked"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1M = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                ariaLabel: props.state === "selected" ? props.ariaLabel : `${props.value}`,
                _ariaCurrent: props.state === "current" ? "date" : void 0,
                _ariaChecked: props.state === "selected" ? "true" : "false",
                onClick: ()=>{
                    props.onClick?.(props.internalIndex, props.disabled);
                },
                _type: (props.value?.length ?? -1) > 2 ? "rectangular" : "rounded"
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1O = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1J;
    const { state: state = "default", disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            disabled: disabled,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendarButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2d81f864fd880f98 = $451487d20aa3eb8a$var$withLogic$1M($451487d20aa3eb8a$var$Component$1O);
$451487d20aa3eb8a$export$2d81f864fd880f98.displayName = "DatepickerCalendarButton";
$451487d20aa3eb8a$export$2d81f864fd880f98.slotName = "jds_datepicker_calendar_button";
const $451487d20aa3eb8a$var$sdl$1I = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-header-1.0.0",
        "name": "JDSDatepickerCalendarHeader",
        "layerName": "jds_datepicker_calendar_header",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "width": "{d_3}",
            "show": true
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "center",
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "days",
                    "object": {
                        "letter": "string"
                    }
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "days.letter"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "presentation"
                    },
                    "aria-label": "_weekDayAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1L = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1N = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1I;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSDatepickerCalendarHeader", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2d5e85746b19c19b = $451487d20aa3eb8a$var$withLogic$1L($451487d20aa3eb8a$var$Component$1N);
$451487d20aa3eb8a$export$2d5e85746b19c19b.displayName = "DatepickerCalendarHeader";
$451487d20aa3eb8a$export$2d5e85746b19c19b.slotName = "jds_datepicker_calendar_header";
const $451487d20aa3eb8a$var$sdl$1H = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-calender-row-1.0.0",
        "name": "JDSDatepickerCalendarRow",
        "layerName": "jds_datepicker_calendar_row",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_1}",
            "align-items": "{d_2}",
            "width": "{d_3}"
        },
        "jds_datepicker_calendar_button": {
            "flex": 1
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "row",
                    "object": {
                        "value": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "row.value"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "row.state"
                },
                "disabled": {
                    "type": "string",
                    "name": "row.disabled"
                }
            }
        },
        "events": {
            "jds_datepicker_calendar_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "radiogroup"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "properties": {
                    "ariaLabel": "dateAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1K = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1M = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1H;
    const { onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerCalendarRow", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$703dfd9521d4b08a = $451487d20aa3eb8a$var$withLogic$1K($451487d20aa3eb8a$var$Component$1M);
$451487d20aa3eb8a$export$703dfd9521d4b08a.displayName = "DatepickerCalendarRow";
$451487d20aa3eb8a$export$703dfd9521d4b08a.slotName = "jds_datepicker_calendar_row";
const $451487d20aa3eb8a$var$JDSDatepickerDesktopInternal = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-desktop-1.0.0",
        "name": "JDSDatepickerDesktopInternal",
        "platform": "web",
        "layerName": "jds_datepicker_desktop_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "left-jds_button",
                    "close-jds_button"
                ]
            },
            {
                "controls-container": [
                    "jds_datepicker_header",
                    {
                        "calender-view-container": [
                            "top-jds_divider",
                            "jds_datepicker_calendar",
                            "jds_datepicker_month_view",
                            "jds_datepicker_year_view"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{d_4}",
            "flex-direction": "{d_5}",
            "justify-content": "{d_6}",
            "align-items": "{d_7}",
            "border-radius": "{d_8}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000029"
            }
        },
        "top-container": {
            "flex-direction": "{d_9}",
            "justify-content": "{d_10}",
            "align-items": "{d_11}",
            "padding-top": "{d_12}",
            "padding-right": "{d_13}",
            "padding-bottom": "{d_14}",
            "padding-left": "{d_15}",
            "width": "{d_16}"
        },
        "jds_datepicker_header": {
            "state": "default",
            "padding-right": "{d_17}",
            "padding-left": "{d_18}"
        },
        "left-jds_button": {
            "hidden": true,
            "kind": "tertiary",
            "icon": "ic_back",
            "size": "medium"
        },
        "close-jds_button": {
            "kind": "tertiary",
            "icon": "ic_close",
            "size": "medium"
        },
        "controls-container": {
            "flex-direction": "{d_19}",
            "justify-content": "{d_20}",
            "align-items": "{d_21}",
            "gap": "{d_22}"
        },
        "calender-view-container": {
            "flex-direction": "{d_23}",
            "justify-content": "{d_24}",
            "align-items": "{d_25}",
            "height": "{d_26}",
            "width": "{d_27}"
        },
        "top-jds_divider": {
            "pad": "none",
            "orientation": "horizontal",
            "hidden": true
        },
        "jds_datepicker_calendar": {
            "hidden": false,
            "padding-right": "{d_28}",
            "padding-left": "{d_29}",
            "padding-bottom": "{d_30}"
        },
        "jds_datepicker_month_view": {
            "hidden": true
        },
        "jds_datepicker_year_view": {
            "hidden": true
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{d_32}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_month_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "month"
                }
            },
            "year_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{d_33}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_year_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "year"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            }
        },
        "data": {
            "container": {
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "_years.yearLoadCount": {
                    "type": "number",
                    "name": "yearLoadCount"
                }
            },
            "jds_datepicker_header": {
                "month": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                }
            },
            "jds_datepicker_month_view": {
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_year_view": {
                "current": {
                    "type": "number",
                    "name": "current"
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar": {
                "day": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "selected": {
                    "type": "date",
                    "name": "value"
                },
                "disabled": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                }
            }
        },
        "events": {
            "container": {
                "onClick": "_onContainerClick"
            },
            "left-jds_button": {
                "onClick": "_onBack"
            },
            "close-jds_button": {
                "onClick": "onClose"
            },
            "jds_datepicker_header": {
                "onMonthClick": "_onMonthClick",
                "onYearClick": "_onYearClick",
                "onPrev": "_onPrev",
                "onNext": "_onNext"
            },
            "jds_datepicker_month_view": {
                "onSelect": "_onMonthSelect"
            },
            "jds_datepicker_year_view": {
                "onSelect": "_onYearSelect"
            },
            "jds_datepicker_calendar": {
                "onSelect": "onSelect",
                "onSwipeLeft": "_onNextCalendar",
                "onSwipeRight": "_onPrevCalendar"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "value": "Date Picker"
                    }
                }
            },
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Click to Return"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeAriaLabel",
                        "value": "Click to Close"
                    }
                }
            },
            "jds_datepicker_header": {
                "properties": {
                    "previousAriaLabel": "previousMonthAriaLabel",
                    "nextAriaLabel": "nextMonthAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$sdl$1G = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-mobile-1.0.0",
        "name": "JDSDatepickerMobileInternal",
        "layerName": "jds_datepicker_mobile_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "left-jds_button",
                    "close-jds_button"
                ]
            },
            {
                "controls-container": [
                    "jds_datepicker_header",
                    "top-jds_divider",
                    "jds_datepicker_calendar",
                    "jds_datepicker_month_view",
                    "jds_datepicker_year_view"
                ]
            },
            {
                "confirmation-container": [
                    "bottom-jds_divider",
                    {
                        "confirmation-group-container": [
                            "confirm-jds-text",
                            "confirm-jds_button"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "size": "{size.max}",
            "translate-y": "{size.max}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeQuick}"
            }
        },
        "top-container": {
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.end}",
            "align-items": "{alignItems.center}",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "padding-left": "{s}",
            "padding-right": "{s}",
            "width": "{size.max}"
        },
        "left-jds_button": {
            "hidden": true,
            "kind": "tertiary",
            "icon": "ic_back",
            "size": "medium"
        },
        "close-jds_button": {
            "kind": "tertiary",
            "icon": "ic_close",
            "size": "medium"
        },
        "controls-container": {
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "gap": "{m}",
            "flex": 1
        },
        "jds_datepicker_header": {
            "state": "default",
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "top-jds_divider": {
            "pad": "none",
            "orientation": "horizontal",
            "hidden": true
        },
        "jds_datepicker_calendar": {
            "hidden": false,
            "padding-left": "{s}",
            "padding-right": "{s}",
            "padding-bottom": "{m}"
        },
        "jds_datepicker_month_view": {
            "hidden": true,
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "jds_datepicker_year_view": {
            "hidden": true,
            "padding-left": "{s}",
            "padding-right": "{s}"
        },
        "confirmation-container": {
            "padding-top": 0,
            "padding-bottom": "{m}",
            "flex-direction": "{flexDirection.column}",
            "gap": "{s}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "width": "{size.max}"
        },
        "bottom-jds_divider": {
            "pad": "none",
            "orientation": "horizontal"
        },
        "confirmation-group-container": {
            "padding-top": 0,
            "padding-right": "{m}",
            "padding-bottom": 0,
            "padding-left": "{m}",
            "flex-direction": "{flexDirection.column}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.center}",
            "gap": "{s}",
            "width": "{size.max}"
        },
        "confirm-jds_button": {
            "fullWidth": true,
            "kind": "primary",
            "size": "medium"
        },
        "confirm-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "state": {
            "month_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{justifyContent.spaceBetween}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_month_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "month",
                    "showArrows": false
                }
            },
            "year_view": {
                "top-jds_divider": {
                    "hidden": false
                },
                "top-container": {
                    "justify-content": "{justifyContent.spaceBetween}"
                },
                "left-jds_button": {
                    "hidden": false
                },
                "jds_datepicker_calendar": {
                    "hidden": true
                },
                "jds_datepicker_year_view": {
                    "hidden": false
                },
                "jds_datepicker_header": {
                    "state": "year",
                    "showArrows": false
                }
            }
        },
        "open": {
            "true": {
                "container": {
                    "translate-y": 0
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month_view",
                    "year_view"
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_datepicker_header": {
                "month": {
                    "type": "string",
                    "name": "monthName"
                },
                "year": {
                    "type": "string",
                    "name": "year"
                },
                "showArrows": {
                    "type": "boolean",
                    "name": "showArrows"
                },
                "yearSelectable": {
                    "type": "boolean",
                    "name": "yearSelectable"
                },
                "monthSelectable": {
                    "type": "boolean",
                    "name": "monthSelectable"
                }
            },
            "jds_datepicker_month_view": {
                "months": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_year_view": {
                "current": {
                    "type": "number",
                    "name": "current"
                },
                "data": {
                    "type": "object",
                    "name": "yearData",
                    "object": {
                        "count": "number",
                        "disabled": "list",
                        "min": "number",
                        "max": "number"
                    }
                },
                "loadedYears": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar": {
                "day": {
                    "type": "number",
                    "name": "date"
                },
                "month": {
                    "type": "number",
                    "name": "month"
                },
                "year": {
                    "type": "number",
                    "name": "year"
                },
                "selected": {
                    "type": "date",
                    "name": "value"
                },
                "disabled": {
                    "type": "object",
                    "name": "calendarData",
                    "object": {
                        "disabledDays": "list",
                        "disabledDates": "list",
                        "max": "date",
                        "min": "date"
                    }
                },
                "days": {
                    "type": "JDSDatepickerCalendarHeader.days",
                    "name": "calendarDays"
                },
                "rows": {
                    "type": "JDSDatepickerCalendar.rows",
                    "name": "calendarRows"
                }
            },
            "confirm-jds_button": {
                "label": {
                    "type": "string",
                    "name": "_confirmLabel"
                }
            },
            "confirm-jds-text": {
                "value": {
                    "type": "string",
                    "name": "confirmDate"
                }
            }
        },
        "events": {
            "left-jds_button": {
                "onClick": "_onBack"
            },
            "close-jds_button": {
                "onClick": "onClose"
            },
            "jds_datepicker_header": {
                "onMonthClick": "_onMonthClick",
                "onYearClick": "_onYearClick",
                "onPrev": "_onPrev",
                "onNext": "_onNext"
            },
            "jds_datepicker_month_view": {
                "onSelect": "_onMonthSelect"
            },
            "jds_datepicker_year_view": {
                "onSelect": "_onYearSelect"
            },
            "jds_datepicker_calendar": {
                "onSelect": "_onSelect",
                "onSwipeLeft": "_onNextCalendar",
                "onSwipeRight": "_onPrevCalendar"
            },
            "confirm-jds_button": {
                "onClick": "onConfirm"
            }
        },
        "a11y": {
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Tap to Return"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeAriaLabel",
                        "value": "Tap to Close"
                    }
                }
            },
            "jds_datepicker_header": {
                "properties": {
                    "previousAriaLabel": "previousMonthAriaLabel",
                    "nextAriaLabel": "nextMonthAriaLabel"
                }
            },
            "confirm-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "confirmAriaLabel",
                        "value": "Tap to Confirm"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$YEAR_COUNT$1 = 50;
const $451487d20aa3eb8a$var$withLogic$1J = (Component)=>(props)=>{
        const { yearSelectable: yearSelectable = true, monthSelectable: monthSelectable = true, ...rest } = props;
        const { lang: lang, platform: platform } = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const confirmLabelLocal = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$6d8d0ec03e692fdc)(lang);
        }, [
            lang
        ]);
        const [state, setState] = (0, $1OEoy.useState)("default");
        const anchorRef = (0, $1OEoy.useRef)(null);
        const { day: day, month: month, year: year } = $451487d20aa3eb8a$var$getNormalisedDate$1(props.value);
        const [selectedMonth, setSelectedMonth] = (0, $1OEoy.useState)(month);
        const [selectedDate, setSelectedDate] = (0, $1OEoy.useState)({
            date: day,
            month: month,
            year: year
        });
        const [selectedYear, setSelectedYear] = (0, $1OEoy.useState)(year);
        (0, $1OEoy.useEffect)(()=>{
            const { day: day2, month: month2, year: year2 } = $451487d20aa3eb8a$var$getNormalisedDate$1(props.value);
            setSelectedDate({
                date: day2,
                month: month2,
                year: year2
            });
            setSelectedYear(year2);
            setSelectedMonth(month2);
        }, [
            props.value
        ]);
        const [firstChild = /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("span", {}), ...restChildren] = (0, $1OEoy.Children).toArray(props.children);
        const formattedConfirmDate = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date).toLocaleDateString(lang, {
            weekday: "short",
            day: "2-digit",
            month: "long",
            year: "numeric"
        });
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        onClose: ()=>{
                            props.onClose?.();
                            setState("default");
                        },
                        yearSelectable: yearSelectable,
                        monthSelectable: monthSelectable,
                        confirmDate: formattedConfirmDate,
                        _confirmLabel: confirmLabelLocal,
                        value: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date),
                        onClick: (ev)=>ev.stopPropagation(),
                        date: selectedDate.date,
                        month: selectedMonth,
                        year: selectedYear,
                        monthName: selectedMonth - 1,
                        months: $451487d20aa3eb8a$var$loadedMonths(selectedMonth - 1, selectedYear, monthSelectable, props.calendarData?.min, props.calendarData?.max),
                        loadedYears: $451487d20aa3eb8a$var$loadedYears(selectedYear + $451487d20aa3eb8a$var$YEAR_COUNT$1 / 2, selectedYear - $451487d20aa3eb8a$var$YEAR_COUNT$1 / 2, selectedYear, $451487d20aa3eb8a$var$getDisabledYears(selectedYear - $451487d20aa3eb8a$var$YEAR_COUNT$1 / 2, selectedYear + $451487d20aa3eb8a$var$YEAR_COUNT$1 / 2, props.calendarData?.min, props.calendarData?.max)),
                        current: selectedYear,
                        state: state,
                        onConfirm: ()=>{
                            const date = new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date);
                            props.onSelect?.(date);
                            props.onConfirm?.(date);
                            props?.onClose?.();
                        },
                        _onYearClick: ()=>setState("year_view"),
                        _onMonthClick: ()=>setState("month_view"),
                        _onBack: ()=>setState("default"),
                        _onSelect: (num)=>{
                            setSelectedDate({
                                date: num,
                                month: selectedMonth,
                                year: selectedYear
                            });
                            setState("default");
                        },
                        onSelect: (num, disabled)=>{
                            setSelectedDate({
                                date: num,
                                month: selectedMonth,
                                year: selectedYear
                            });
                            if (!disabled && platform === "desktop") {
                                props.onSelect?.(new Date(selectedYear, selectedMonth - 1, num));
                                props.onClose?.();
                            }
                            setState("default");
                        },
                        _onMonthSelect: (i)=>{
                            if (monthSelectable) {
                                setSelectedMonth(i);
                                setState("default");
                            }
                        },
                        _onYearSelect: (i)=>{
                            if (yearSelectable) {
                                setSelectedYear(i);
                                setState("default");
                            }
                        },
                        _onPrev: ()=>setSelectedMonth((m)=>{
                                if (m === 1) {
                                    setSelectedYear(selectedYear - 1);
                                    return 12;
                                }
                                return m - 1;
                            }),
                        _onNext: ()=>setSelectedMonth((m)=>{
                                if (m === 12) {
                                    setSelectedYear(selectedYear + 1);
                                    return 1;
                                }
                                return m + 1;
                            })
                    }
                }),
                (0, $1OEoy.cloneElement)(firstChild, {
                    ref: anchorRef
                }),
                restChildren
            ]
        });
    };
const $451487d20aa3eb8a$var$Component$1L = (props)=>{
    const { platform: platform, ...restSwitchables } = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = platform === "desktop" ? $451487d20aa3eb8a$var$JDSDatepickerDesktopInternal : $451487d20aa3eb8a$var$sdl$1G;
    const { state: state = "default", onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Click to Return", closeAriaLabel: closeAriaLabel = "Click to Close", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClose: onClose,
            onSelect: onSelect,
            previousButtonAriaLabel: previousButtonAriaLabel,
            closeAriaLabel: closeAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerDesktopInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$1f2289af8fea154d = $451487d20aa3eb8a$var$withLogic$1J($451487d20aa3eb8a$var$Component$1L);
$451487d20aa3eb8a$export$1f2289af8fea154d.displayName = "DatepickerDesktopInternal";
$451487d20aa3eb8a$export$1f2289af8fea154d.slotName = "jds_datepicker_desktop_internal";
const $451487d20aa3eb8a$var$sdl$1F = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-header-1.0.0",
        "name": "JDSDatepickerHeader",
        "layerName": "jds_datepicker_header",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "left-jds_button",
            {
                "inner-container": [
                    "month-jds_datepicker_button",
                    "year-jds_datepicker_button"
                ]
            },
            "right-jds_button"
        ]
    },
    "base": {
        "container": {
            "width": "{d_0}",
            "height": "{d_1}",
            "flex-direction": "{d_2}",
            "justify-content": "{d_3}",
            "align-items": "{d_4}"
        },
        "inner-container": {
            "height": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}",
            "gap": "{d_9}",
            "flex": 1
        },
        "left-jds_button": {
            "hidden": false,
            "kind": "tertiary",
            "icon": "ic_chevron_left",
            "size": "medium"
        },
        "right-jds_button": {
            "hidden": false,
            "kind": "tertiary",
            "icon": "ic_chevron_right",
            "size": "medium"
        },
        "month-jds_datepicker_button": {
            "state": "default"
        },
        "year-jds_datepicker_button": {
            "state": "default"
        }
    },
    "variant": {
        "state": {
            "month": {
                "month-jds_datepicker_button": {
                    "state": "selected"
                }
            },
            "year": {
                "year-jds_datepicker_button": {
                    "state": "selected"
                }
            }
        },
        "showArrows": {
            "false": {
                "left-jds_button": {
                    "hidden": true
                },
                "right-jds_button": {
                    "hidden": true
                }
            }
        },
        "monthSelectable": {
            "false": {
                "month-jds_datepicker_button": {
                    "state": "disabled"
                }
            }
        },
        "yearSelectable": {
            "false": {
                "year-jds_datepicker_button": {
                    "state": "disabled"
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "false": {
                    "month-jds_datepicker_button": {
                        "state": "text_only"
                    },
                    "year-jds_datepicker_button": {
                        "state": "text_only"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "monthSelectable",
            "yearSelectable"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "month",
                    "year"
                ]
            },
            "showArrows": {
                "values": [
                    true,
                    false
                ]
            },
            "monthSelectable": {
                "values": [
                    true,
                    false
                ]
            },
            "yearSelectable": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "month-jds_datepicker_button": {
                "text": {
                    "type": "string",
                    "name": "month"
                }
            },
            "year-jds_datepicker_button": {
                "text": {
                    "type": "string",
                    "name": "year"
                }
            }
        },
        "events": {
            "left-jds_button": {
                "onClick": "onPrev"
            },
            "month-jds_datepicker_button": {
                "onClick": "onMonthClick"
            },
            "year-jds_datepicker_button": {
                "onClick": "onYearClick"
            },
            "right-jds_button": {
                "onClick": "onNext"
            }
        },
        "a11y": {
            "left-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousAriaLabel",
                        "value": "Navigate to previous month"
                    }
                }
            },
            "right-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextAriaLabel",
                        "value": "Navigate to next month"
                    }
                }
            },
            "month-jds_datepicker_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "_monthAriaLabel"
                    }
                }
            },
            "year-jds_datepicker_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "_yearAriaLabel"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1I = (Component)=>(props)=>{
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocaleYear = (year)=>{
            const yearString = year?.toString();
            return yearString?.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const getMonthNamesFromLocale = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$cae41416faa27367)(language);
        }, [
            language
        ]);
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _monthAriaLabel: props.state === "month" ? "Select month" : `${monthNames[Number(props.month)]}, Select month`,
                _yearAriaLabel: props.state === "year" ? "Select year" : `${props.year}, Select year`
            },
            year: getLocaleYear(Number(props.year)),
            month: getMonthNamesFromLocale[Number(props.month)]
        });
    };
const $451487d20aa3eb8a$var$Component$1K = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1F;
    const { state: state = "default", showArrows: showArrows = true, monthSelectable: monthSelectable = true, yearSelectable: yearSelectable = true, onPrev: onPrev = (0, $ddff9b86434e3f59$export$8793edee2d425525), onMonthClick: onMonthClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onYearClick: onYearClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onNext: onNext = (0, $ddff9b86434e3f59$export$8793edee2d425525), previousAriaLabel: previousAriaLabel = "Navigate to previous month", nextAriaLabel: nextAriaLabel = "Navigate to next month", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            showArrows: showArrows,
            monthSelectable: monthSelectable,
            yearSelectable: yearSelectable,
            onPrev: onPrev,
            onMonthClick: onMonthClick,
            onYearClick: onYearClick,
            onNext: onNext,
            previousAriaLabel: previousAriaLabel,
            nextAriaLabel: nextAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerHeader", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$4677d90cce08ec53 = $451487d20aa3eb8a$var$withLogic$1I($451487d20aa3eb8a$var$Component$1K);
$451487d20aa3eb8a$export$4677d90cce08ec53.displayName = "DatepickerHeader";
$451487d20aa3eb8a$export$4677d90cce08ec53.slotName = "jds_datepicker_header";
const $451487d20aa3eb8a$var$sdl$1E = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-month-view-1.0.0",
        "name": "JDSDatepickerMonthView",
        "layerName": "jds_datepicker_month_view",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "height": "{d_1}",
            "width": "{d_2}",
            "align-items": "{d_3}",
            "overflow": "scroll"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "months",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "months.name"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "months.state"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "months.disabled"
                }
            }
        },
        "events": {
            "jds_datepicker_calendar_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1H = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: (i)=>{
                    props?.onSelect?.(props.months?.[i]?.value);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1J = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1E;
    const { onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMonthView", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$df8c284ffe0bf6ce = $451487d20aa3eb8a$var$withLogic$1H($451487d20aa3eb8a$var$Component$1J);
$451487d20aa3eb8a$export$df8c284ffe0bf6ce.displayName = "DatepickerMonthView";
$451487d20aa3eb8a$export$df8c284ffe0bf6ce.slotName = "jds_datepicker_month_view";
const $451487d20aa3eb8a$var$sdl$1D = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-view-button-1.0.0",
        "name": "JDSDatepickerViewButton",
        "layerName": "jds_datepicker_view_button",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{d_0}",
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}"
        },
        "container": {
            "height": "{d_4}",
            "width": "{d_5}",
            "flex-direction": "{d_6}",
            "justify-content": "{d_7}",
            "align-items": "{d_8}"
        },
        "jds_button": {
            "kind": "tertiary",
            "size": "medium",
            "fullWidth": true,
            "state": "normal"
        }
    },
    "variant": {
        "selected": {
            "true": {
                "jds_button": {
                    "kind": "primary"
                }
            }
        },
        "disabled": {
            "true": {
                "jds_button": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_button": {
                "label": {
                    "type": "string",
                    "name": "name"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                }
            }
        },
        "events": {
            "jds_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "jds_button": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1G = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: ()=>{
                    props?.onSelect?.(props.internalIndex + 1);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1I = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1D;
    const { disabled: disabled = false, selected: selected = false, onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            selected: selected,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerViewButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$99c3540c4320b145 = $451487d20aa3eb8a$var$withLogic$1G($451487d20aa3eb8a$var$Component$1I);
$451487d20aa3eb8a$export$99c3540c4320b145.displayName = "DatepickerViewButton";
$451487d20aa3eb8a$export$99c3540c4320b145.slotName = "jds_datepicker_view_button";
const $451487d20aa3eb8a$var$sdl$1C = {
    "metadata": {
        "version": "1.0.0",
        "id": "date-picker-year-view-1.0.0",
        "name": "JDSDatepickerYearView",
        "layerName": "jds_datepicker_year_view",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_datepicker_calendar_button"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "height": 300,
            "width": "{d_1}",
            "align-items": "{d_2}",
            "overflow": "scroll"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "loadedYears",
                    "object": {
                        "name": "string",
                        "state": "JDSDatepickerCalendarButton.state",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_datepicker_calendar_button": {
                "value": {
                    "type": "string",
                    "name": "loadedYears.name"
                },
                "state": {
                    "type": "JDSDatepickerCalendarButton.state",
                    "name": "loadedYears.state"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "loadedYears.disabled"
                }
            }
        },
        "events": {
            "container": {
                "onScroll": {
                    "name": "onScroll",
                    "platform": "web"
                }
            },
            "jds_datepicker_calendar_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1F = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                onSelect: (i)=>{
                    props?.onSelect?.(props.loadedYears?.[i]?.value);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1H = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1C;
    const { onScroll: onScroll = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onScroll: onScroll,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerYearView", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$59892f17b1991230 = $451487d20aa3eb8a$var$withLogic$1F($451487d20aa3eb8a$var$Component$1H);
$451487d20aa3eb8a$export$59892f17b1991230.displayName = "DatepickerYearView";
$451487d20aa3eb8a$export$59892f17b1991230.slotName = "jds_datepicker_year_view";
const $451487d20aa3eb8a$var$sdl$1B = {
    "metadata": {
        "version": "1.0.0",
        "id": "desktop-bottom-sheet-1.0.0",
        "name": "JDSDesktopBottomSheetInternal",
        "layerName": "jds_desktop_bottom_sheet_internal",
        "platform": "web",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "root-container": [
                    {
                        "cancel-container": [
                            {
                                "back-container": [
                                    "back-jds_button"
                                ]
                            },
                            "cancel-jds_button",
                            "step-jds-text"
                        ]
                    },
                    {
                        "vertical-container": [
                            "title-jds-text",
                            "description-jds-text",
                            "children-slot",
                            {
                                "cta-container": [
                                    "primary-jds_action_button",
                                    "secondary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "justify-content": "{d_13}",
            "align-items": "{d_14}"
        },
        "root-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{d_24}",
            "justify-content": "{d_25}",
            "background-color": "{d_26}",
            "align-items": "{d_27}",
            "border-top-left-radius": "{d_28}",
            "border-top-right-radius": "{d_29}",
            "width": "{d_15}",
            "translate-y": "{d_16}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{d_17}",
                "timing-function": "{d_18}"
            }
        },
        "cancel-container": {
            "hidden": false,
            "flex-direction": "{d_30}",
            "justify-content": "{d_31}",
            "align-items": "{d_32}",
            "width": "{d_33}",
            "padding-top": "{d_34}",
            "padding-bottom": "{d_35}",
            "padding-left": "{d_36}",
            "padding-right": "{d_37}",
            "gap": "{d_38}"
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "size": "medium",
            "kind": "tertiary"
        },
        "vertical-container": {
            "flex-direction": "{d_39}",
            "justify-content": "{d_40}",
            "align-items": "{d_41}",
            "padding-left": "{d_42}",
            "padding-right": "{d_43}",
            "width": "{d_44}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "medium",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "medium",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "cta-container": {
            "flex-direction": "{d_47}",
            "gap": "{d_48}",
            "width": "{d_49}",
            "padding-bottom": "{d_50}",
            "padding-top": "{d_51}"
        },
        "back-container": {
            "flex": 1,
            "hidden": true
        },
        "back-jds_button": {
            "kind": "tertiary",
            "icon": "ic_back"
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}",
            "background-color": "{d_4}",
            "border-top-left-radius": "{d_5}",
            "border-top-right-radius": "{d_6}",
            "padding-left": "{d_7}",
            "padding-right": "{d_8}",
            "padding-top": "{d_9}",
            "padding-bottom": "{d_10}",
            "width": "{d_11}",
            "translate-y": "{d_12}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "padding-bottom": "{d_45}",
            "maxLines": 2
        },
        "description-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{d_46}"
        },
        "step-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-right": "{d_52}"
        }
    },
    "variant": {
        "controlType": {
            "stepper": {
                "back-container": {
                    "hidden": false
                },
                "cancel-jds_button": {
                    "hidden": true
                },
                "step-jds-text": {
                    "hidden": false
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "cta-container": {
                    "flex-direction": "{flexDirection.row}"
                }
            }
        },
        "kind": {
            "passive": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "{d_53}"
                    }
                }
            }
        },
        "close": {
            "false": {
                "root-container": {
                    "translate-y": 0,
                    "hidden": false
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "true": {
                    "custom-container": {
                        "hidden": false,
                        "translate-y": 0
                    },
                    "root-container": {
                        "hidden": true,
                        "translate-y": "{size.max}"
                    },
                    "vertical-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "isCustom"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "max-height": {
                    "type": "number",
                    "name": "height"
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "step-jds-text": {
                "value": {
                    "type": "string",
                    "name": "step_label"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "root-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "custom-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            },
            "back-jds_button": {
                "onClick": "onBack"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Bottom Sheet Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "back-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Click to go Back"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$p = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$1E = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$p);
        const { close: close, onRequestClose: onRequestClose, onClose: onClose, ...rest } = props;
        const allowClose = !onRequestClose || onRequestClose();
        const closeFn = ()=>{
            if (allowClose) onClose?.();
        };
        const { mobile: mobile } = $451487d20aa3eb8a$var$Devices.useMedia();
        $451487d20aa3eb8a$var$useEscapeClose(closeFn, allowClose);
        if (mobile) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$BottomSheet$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                onBack: ()=>{
                    props.stepperConfig?.onBack?.(props.stepperConfig.activeStep);
                },
                label: props.stepperConfig?.indicatorText,
                _ariaModal: props.kind === "overlay" || !props.close ? "true" : "false",
                _onBottomSheetClick: (ev)=>ev.stopPropagation(),
                close: close,
                onCancel: ()=>{
                    if (allowClose) closeFn();
                },
                onClose: ()=>{
                    if (allowClose) closeFn();
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1G = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1B;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onBottomSheetClick: onBottomSheetClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onCancel: onCancel = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBack: onBack = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "Bottom Sheet Content", cancelButtonAriaLabel: cancelButtonAriaLabel = "Close Modal", backButtonAriaLabel: backButtonAriaLabel = "Click to go Back", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onBottomSheetClick: onBottomSheetClick,
            onClose: onClose,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onBack: onBack,
            ariaLabel: ariaLabel,
            cancelButtonAriaLabel: cancelButtonAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDesktopBottomSheetInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$a20173db319b8774 = $451487d20aa3eb8a$var$withLogic$1E($451487d20aa3eb8a$var$Component$1G);
$451487d20aa3eb8a$export$a20173db319b8774.displayName = "DesktopBottomSheetInternal";
$451487d20aa3eb8a$export$a20173db319b8774.slotName = "jds_desktop_bottom_sheet_internal";
const $451487d20aa3eb8a$var$sdl$1A = {
    "metadata": {
        "version": "1.0.0",
        "id": "divider-1.0.0",
        "name": "JDSDivider",
        "layerName": "jds_divider",
        "description": "Dividers are used to group and divide contents within a page.",
        "usage": "Dividers are used inorder to establish clear grouping of content or emphasize the in-between boundaries of a list of content."
    },
    "hierarchy": {
        "container": [
            "start-container",
            "jds-text",
            "end-container"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{d_0}",
            "flex-direction": "{d_1}",
            "justify-content": "{d_2}",
            "align-items": "{d_3}",
            "gap": "{d_4}",
            "flex": 1,
            "padding-left": "{d_5}",
            "padding-right": "{d_6}",
            "padding-top": "{d_7}",
            "padding-bottom": "{d_8}"
        },
        "start-container": {
            "hidden": false,
            "min-height": "{d_9}",
            "min-width": "{d_10}",
            "flex-direction": "{d_11}",
            "flex": 1,
            "background-color": "{d_12}",
            "border-radius": "{d_13}",
            "show": true
        },
        "end-container": {
            "hidden": true,
            "min-height": "{d_14}",
            "min-width": "{d_15}",
            "flex-direction": "{d_16}",
            "flex": 1,
            "background-color": "{d_17}",
            "border-radius": "{d_18}",
            "show": true
        },
        "jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "variant": {
            "stepper": {
                "start-container": {
                    "background-color": "{d_19}"
                },
                "end-container": {
                    "background-color": "{d_20}"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "container": {
                    "width": "{d_21}"
                },
                "start-container": {
                    "height": 1
                },
                "end-container": {
                    "height": 1
                }
            },
            "vertical": {
                "container": {
                    "height": "{d_22}",
                    "flex-direction": "{d_23}"
                },
                "start-container": {
                    "width": 1,
                    "flex-direction": "{d_24}",
                    "flex": 1
                },
                "end-container": {
                    "width": 1,
                    "flex-direction": "{d_25}",
                    "flex": 1
                }
            }
        },
        "pad": {
            "none": {
                "container": {
                    "padding-top": 0,
                    "padding-bottom": 0,
                    "padding-right": 0,
                    "padding-left": 0
                }
            }
        },
        "_withLabel": {
            "true": {
                "end-container": {
                    "hidden": false
                },
                "jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "base": {
                "all": {
                    "container": {
                        "padding-left": "{d_26}",
                        "padding-right": "{d_27}",
                        "padding-top": "{d_28}",
                        "padding-bottom": "{d_29}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_30}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_31}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-top": "{d_32}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": "{d_33}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_34}",
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": "{d_35}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_36}",
                        "padding-right": "{d_37}"
                    }
                }
            },
            "medium": {
                "all": {
                    "container": {
                        "padding-left": "{d_38}",
                        "padding-right": "{d_39}",
                        "padding-top": "{d_40}",
                        "padding-bottom": "{d_41}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_42}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_43}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-bottom": 0,
                        "padding-top": "{d_44}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-right": 0,
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": "{d_45}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_46}",
                        "padding-bottom": "{d_47}",
                        "padding-right": 0,
                        "padding-left": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_48}",
                        "padding-right": "{d_49}"
                    }
                }
            },
            "xtra-small": {
                "all": {
                    "container": {
                        "padding-left": "{d_50}",
                        "padding-right": "{d_51}",
                        "padding-top": "{d_52}",
                        "padding-bottom": "{d_53}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_54}",
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-right": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_55}",
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_56}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_57}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_58}",
                        "padding-bottom": "{d_59}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_60}",
                        "padding-right": "{d_61}"
                    }
                }
            },
            "xtra-xtra-small": {
                "all": {
                    "container": {
                        "padding-left": "{d_62}",
                        "padding-right": "{d_63}",
                        "padding-top": "{d_64}",
                        "padding-bottom": "{d_65}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_66}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_67}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_68}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_69}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_70}",
                        "padding-bottom": "{d_71}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-left": "{d_72}",
                        "padding-bottom": "{d_73}"
                    }
                }
            },
            "xtra-xtra-large": {
                "all": {
                    "container": {
                        "padding-left": "{d_74}",
                        "padding-right": "{d_75}",
                        "padding-top": "{d_76}",
                        "padding-bottom": "{d_77}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_78}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_79}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_80}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_81}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_82}",
                        "padding-bottom": "{d_83}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_84}",
                        "padding-right": "{d_85}"
                    }
                }
            },
            "xtra-large": {
                "all": {
                    "container": {
                        "padding-left": "{d_86}",
                        "padding-right": "{d_87}",
                        "padding-top": "{d_88}",
                        "padding-bottom": "{d_89}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_90}",
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_91}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-top": "{d_92}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_93}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_94}",
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_95}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_96}",
                        "padding-right": "{d_97}"
                    }
                }
            },
            "large": {
                "all": {
                    "container": {
                        "padding-left": "{d_98}",
                        "padding-right": "{d_99}",
                        "padding-top": "{d_100}",
                        "padding-bottom": "{d_101}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_102}",
                        "padding-right": "0",
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_103}",
                        "padding-left": "0",
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-top": "{d_104}"
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_105}"
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_106}",
                        "padding-left": 0,
                        "padding-right": 0,
                        "padding-bottom": "{d_107}"
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_108}",
                        "padding-right": "{d_109}"
                    }
                }
            },
            "huge": {
                "all": {
                    "container": {
                        "padding-left": "{d_110}",
                        "padding-right": "{d_111}",
                        "padding-top": "{d_112}",
                        "padding-bottom": "{d_113}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_114}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_115}",
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_116}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_117}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_118}",
                        "padding-bottom": "{d_119}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_120}",
                        "padding-right": "{d_121}"
                    }
                }
            },
            "massive": {
                "all": {
                    "container": {
                        "padding-left": "{d_122}",
                        "padding-right": "{d_123}",
                        "padding-top": "{d_124}",
                        "padding-bottom": "{d_125}"
                    }
                },
                "left": {
                    "container": {
                        "padding-left": "{d_126}",
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-right": "{d_127}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-top": "{d_128}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": "{d_129}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-top": "{d_130}",
                        "padding-bottom": "{d_131}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0,
                        "padding-left": "{d_132}",
                        "padding-right": "{d_133}"
                    }
                }
            },
            "small": {
                "left": {
                    "container": {
                        "padding-right": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "right": {
                    "container": {
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                },
                "top": {
                    "container": {
                        "padding-bottom": 0,
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "bottom": {
                    "container": {
                        "padding-top": 0,
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "vertical": {
                    "container": {
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "horizontal": {
                    "container": {
                        "padding-top": 0,
                        "padding-bottom": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "pad",
            "padPosition"
        ]
    ],
    "api": {
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "orientation": {
                "values": [
                    "horizontal",
                    "vertical"
                ],
                "doc_description": "Determines the view styles i.e. horizontal or vertical."
            },
            "variant": {
                "values": [
                    "default",
                    "stepper"
                ]
            },
            "_withLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "padPosition": {
                "values": [
                    "all",
                    "vertical",
                    "horizontal",
                    "bottom",
                    "top",
                    "left",
                    "right"
                ],
                "doc_description": "Sets the position of padding defined as part of `padding` property. If `padding` property present, this default to `all`."
            },
            "pad": {
                "values": [
                    "small",
                    "base",
                    "medium",
                    "xtra-small",
                    "large",
                    "xtra-large",
                    "xtra-xtra-large",
                    "xtra-xtra-small",
                    "huge",
                    "massive",
                    "none"
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "separator"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-orientation": {
                        "name": "_ariaOrientation",
                        "prop": "orientation"
                    },
                    "aria-hidden": {
                        "name": "ariaHidden"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacyPadding = [
    "xx-small",
    "x-small",
    "x-large",
    "xx-large"
];
const $451487d20aa3eb8a$var$PROP_MAP$o = (props)=>{
    if ($451487d20aa3eb8a$var$legacyPadding.includes(props.pad)) console.warn("sizes starting with xx- are deprecated. Use sizes starting with `xtra`. Ex: x-small => xtra-small");
    return {
        pad: {
            variations: {
                base: {
                    pad: "base"
                },
                huge: {
                    pad: "huge"
                },
                medium: {
                    pad: "medium"
                },
                small: {
                    pad: "small"
                },
                large: {
                    pad: "large"
                },
                "x-small": {
                    pad: "xtra-small"
                },
                "xx-small": {
                    pad: "xtra-xtra-small"
                },
                "x-large": {
                    pad: "xtra-large"
                },
                "xx-large": {
                    pad: "xtra-xtra-large"
                },
                massive: {
                    pad: "massive"
                }
            }
        },
        appearance: {
            properties: {
                orientation: props.appearance || props.orientation
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$1D = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$o);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _withLabel: Boolean(props.label?.length),
                orientation: props.orientation || props.appearance
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1F = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1A;
    const { orientation: orientation = "horizontal", variant: variant = "default", padPosition: padPosition = "all", pad: pad = "small", _ariaLabel: _ariaLabel = props.label?.toString(), _ariaOrientation: _ariaOrientation = props.orientation?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            orientation: orientation,
            variant: variant,
            padPosition: padPosition,
            pad: pad,
            _ariaLabel: _ariaLabel,
            _ariaOrientation: _ariaOrientation,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDivider", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2e0a83ec2e27ecbb = $451487d20aa3eb8a$var$withLogic$1D($451487d20aa3eb8a$var$Component$1F);
$451487d20aa3eb8a$export$2e0a83ec2e27ecbb.displayName = "Divider";
$451487d20aa3eb8a$export$2e0a83ec2e27ecbb.slotName = "jds_divider";
const $451487d20aa3eb8a$var$sdl$1z = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-1.0.0",
        "name": "JDSDropdownMenu",
        "layerName": "jds_dropdown_menu"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_dropdown_menu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "background-color": "{global.transparent}",
            "hidden": true
        },
        "popup-container": {
            "hidden": false
        },
        "jds_dropdown_menu_internal": {
            "hidden": false,
            "kind": "single-select"
        }
    },
    "variant": {
        "kind": {
            "multi-select": {
                "jds_dropdown_menu_internal": {
                    "kind": "multi-select",
                    "showCTAButtons": true
                }
            }
        },
        "_menuFullScreen": {
            "true": {
                "popup-container": {
                    "size": "{size.max}"
                },
                "jds_dropdown_menu_internal": {
                    "menuFullScreen": true
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                },
                "jds_dropdown_menu_internal": {
                    "open": true
                }
            }
        },
        "searchTrigger": {
            "true": {
                "jds_dropdown_menu_internal": {
                    "searchTrigger": true
                }
            }
        },
        "showCTAButtons": {
            "false": {
                "jds_dropdown_menu_internal": {
                    "showCTAButtons": false
                }
            }
        },
        "labelTextWrap": {
            "true": {
                "jds_dropdown_menu_internal": {
                    "labelTextWrap": true
                }
            }
        },
        "width": {
            "trigger": {
                "jds_dropdown_menu_internal": {
                    "menuWidthConfig": "trigger"
                }
            }
        },
        "position": {
            "bottom_start": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_start"
                }
            },
            "bottom_end": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_end"
                }
            },
            "top_start": {
                "jds_dropdown_menu_internal": {
                    "position": "top_start"
                }
            },
            "top_end": {
                "jds_dropdown_menu_internal": {
                    "position": "top_end"
                }
            },
            "right_start": {
                "jds_dropdown_menu_internal": {
                    "position": "right_start"
                }
            },
            "right_end": {
                "jds_dropdown_menu_internal": {
                    "position": "right_end"
                }
            },
            "left_start": {
                "jds_dropdown_menu_internal": {
                    "position": "left_start"
                }
            },
            "left_end": {
                "jds_dropdown_menu_internal": {
                    "position": "left_end"
                }
            },
            "bottom_centre": {
                "jds_dropdown_menu_internal": {
                    "position": "bottom_centre"
                }
            },
            "top_centre": {
                "jds_dropdown_menu_internal": {
                    "position": "top_centre"
                }
            }
        }
    },
    "api": {
        "events": {
            "jds_dropdown_menu_internal": {
                "onSuffixClick": "onSuffixClick",
                "onSearchChange": "onSearchChange",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onContainerClick": "_onContainerClick",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "data": {
            "jds_dropdown_menu_internal": {
                "searchLabel": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "searchValue": {
                    "type": "string",
                    "name": "searchValue"
                },
                "searchSuffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                },
                "menuWidth": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "menuMaxHeight": {
                    "type": "string",
                    "name": "_menuMaxHeight"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "searchTrigger": {
                "values": [
                    false,
                    true
                ]
            },
            "showCTAButtons": {
                "values": [
                    true,
                    false
                ]
            },
            "labelTextWrap": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "width": {
                "values": [
                    "max-content",
                    "trigger"
                ]
            },
            "position": {
                "values": [
                    "bottom_start",
                    "bottom_end",
                    "top_start",
                    "top_end",
                    "right_start",
                    "right_end",
                    "left_start",
                    "left_end",
                    "bottom_centre",
                    "top_centre"
                ]
            },
            "_menuFullScreen": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "jds_dropdown_menu_internal": {
                "properties": {
                    "searchAriaLabel": "searchAriaLabel"
                }
            }
        }
    }
};
function $451487d20aa3eb8a$var$findFocusedIndex(menuItems) {
    const focusedElement = document.activeElement;
    const index = menuItems.findIndex((item)=>item === focusedElement);
    return index;
}
function $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(focusIndex, containerDomRef, itemSelector) {
    const menuItems = containerDomRef?.querySelectorAll?.(itemSelector);
    if (!menuItems?.length) return;
    const currentFocusIndex = $451487d20aa3eb8a$var$findFocusedIndex(Array.from(menuItems));
    if (focusIndex === 1) {
        if (currentFocusIndex < menuItems.length - 1) menuItems[currentFocusIndex + 1].focus();
        else menuItems[0].focus();
    } else if (focusIndex === -1) {
        if (currentFocusIndex > 0) menuItems[currentFocusIndex - 1].focus();
        else menuItems[menuItems.length - 1].focus();
    }
}
const $451487d20aa3eb8a$var$spaceAvailabilityOrder = {
    "bottom-start": [
        "bottom-end",
        "bottom-center",
        "top-start",
        "top-end",
        "top-center"
    ],
    "bottom-end": [
        "bottom-start",
        "bottom-center",
        "top-end",
        "top-start",
        "top-center"
    ],
    "top-start": [
        "top-end",
        "top-center",
        "bottom-start",
        "bottom-end",
        "bottom-center"
    ],
    "top-end": [
        "top-start",
        "top-center",
        "bottom-end",
        "bottom-start",
        "bottom-center"
    ],
    "right-end": [
        "right-start",
        "left-end",
        "left-start"
    ],
    "right-start": [
        "right-end",
        "left-start",
        "left-end",
        "bottom-end",
        "bottom-center"
    ],
    "left-end": [
        "left-start",
        "right-end",
        "right-start"
    ],
    "left-start": [
        "left-end",
        "right-start",
        "right-end"
    ],
    "top-center": [
        "top-start",
        "top-end",
        "bottom-center",
        "bottom-start",
        "bottom-end"
    ],
    "bottom-center": [
        "bottom-start",
        "bottom-end",
        "top-center",
        "top-start",
        "top-end"
    ]
};
function $451487d20aa3eb8a$var$getCalculatedPosition(position, anchorRect, containerDomRect) {
    if (!(position && anchorRect && containerDomRect)) return position;
    if ($451487d20aa3eb8a$var$checkSpaceAvailability(position, anchorRect, containerDomRect)) return position;
    let alternativePosition = $451487d20aa3eb8a$var$spaceAvailabilityOrder[position].find((alternativePosition2)=>{
        return $451487d20aa3eb8a$var$checkSpaceAvailability(alternativePosition2, anchorRect, containerDomRect);
    });
    if (!alternativePosition) alternativePosition = $451487d20aa3eb8a$var$checkBestAvailablePosition(anchorRect);
    return alternativePosition || position;
}
function $451487d20aa3eb8a$var$checkBestAvailablePosition(anchorRect) {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const { bottom: bottom, top: top, left: left, right: right } = anchorRect;
    const positionWidthHeightRatios = {
        "bottom-start": (windowWidth - left) * (windowHeight - bottom),
        "bottom-end": right * (windowHeight - bottom),
        "top-start": (windowWidth - left) * top,
        "top-end": right * top,
        "right-start": (windowWidth - right) * (windowHeight - top),
        "right-end": (windowWidth - right) * bottom,
        "left-start": left * (windowHeight - top),
        "left-end": left * bottom,
        "top-center": 0,
        "bottom-center": 0
    };
    let bestPosition = "bottom-start";
    let bestAvailableSpace = 0;
    for (const [position, availableSpace] of Object.entries(positionWidthHeightRatios))if (availableSpace > bestAvailableSpace) {
        bestPosition = position;
        bestAvailableSpace = availableSpace;
    }
    return bestPosition;
}
function $451487d20aa3eb8a$var$checkSpaceAvailability(position, anchorRect, containerDomRect) {
    const { width: anchorWidth, top: anchorTop, bottom: anchorBottom, right: anchorRight, left: anchorLeft } = anchorRect;
    const { width: containerWidth, height: containerHeight } = containerDomRect;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const screenStart = 0;
    switch(position){
        case "bottom-start":
            return anchorBottom + containerHeight < screenHeight && anchorLeft + containerWidth < screenWidth;
        case "bottom-end":
            return anchorBottom + containerHeight < screenHeight && anchorRight - containerWidth > screenStart;
        case "top-start":
            return anchorLeft + containerWidth < screenWidth && anchorTop - containerHeight > 0;
        case "top-end":
            return anchorRight - containerWidth > screenStart && anchorTop - containerHeight > 0;
        case "right-end":
            return anchorRight + containerWidth < screenWidth && anchorBottom - containerHeight > 0;
        case "right-start":
            return anchorRight + containerWidth < screenWidth && anchorTop + containerHeight < screenHeight;
        case "left-end":
            return anchorLeft - containerWidth > screenStart && anchorBottom - containerHeight > 0;
        case "left-start":
            return anchorTop + containerHeight < screenHeight && anchorLeft - containerWidth > screenStart;
        case "top-center":
            return anchorTop - containerHeight > 0 && anchorLeft + anchorWidth / 2 - containerWidth / 2 > screenStart && anchorLeft + anchorWidth / 2 + containerWidth / 2 < screenWidth;
        case "bottom-center":
            return anchorBottom + containerHeight < screenHeight && anchorLeft + anchorWidth / 2 - containerWidth / 2 > screenStart && anchorLeft + anchorWidth / 2 + containerWidth / 2 < screenWidth;
        default:
            return true;
    }
}
const $451487d20aa3eb8a$var$DropdownMenuContext = (0, $1OEoy.createContext)({
    activeMenuId: void 0,
    setActiveMenuId () {},
    labelTextWrap: true,
    selectedValue: void 0,
    setSelectedValue () {},
    selectedValues: [],
    setSelectedValues () {},
    isNested: false,
    setIsNested () {},
    resetSelections () {},
    applySelections () {}
});
const $451487d20aa3eb8a$var$useScrollClose = (callback)=>{
    (0, $1OEoy.useEffect)(()=>{
        document.addEventListener("scroll", callback);
        return ()=>{
            document.removeEventListener("scroll", callback);
        };
    }, [
        callback
    ]);
};
const $451487d20aa3eb8a$var$MENU_MARGIN = 4;
const $451487d20aa3eb8a$var$getIcon$1 = (icon)=>{
    if (!icon) return void 0;
    if (typeof icon === "string") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        ic: icon,
        color: "grey-80"
    });
    if (icon.props?.ic) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        ic: icon.props.ic,
        color: "grey-80"
    });
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        ic: icon,
        color: "grey-80"
    });
};
function $451487d20aa3eb8a$var$getPositionCoordinates(position, anchorRect, containerDomRect) {
    const { top: anchorTop, bottom: anchorBottom, right: anchorRight, left: anchorLeft, width: anchorWidth } = anchorRect;
    const { width: containerWidth, height: containerHeight } = containerDomRect;
    const screenHeight = window.innerHeight;
    const screenWidth = window.innerWidth;
    let left = 0;
    let top = 0;
    let maxHeight;
    let maxWidth;
    switch(position){
        case "bottom-start":
            left = anchorLeft;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = screenWidth - anchorLeft;
            break;
        case "bottom-end":
            left = anchorRight - containerWidth;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = anchorRight;
            break;
        case "top-start":
            left = anchorLeft;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = screenWidth - anchorLeft;
            break;
        case "top-end":
            left = anchorRight - containerWidth;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = anchorRight;
            break;
        case "right-end":
            left = anchorRight;
            top = anchorBottom - containerHeight;
            maxHeight = anchorBottom;
            maxWidth = screenWidth - anchorRight;
            break;
        case "right-start":
            left = anchorRight;
            top = anchorTop;
            maxHeight = screenHeight - anchorTop;
            maxWidth = screenWidth - anchorRight;
            break;
        case "left-end":
            left = anchorLeft - containerWidth;
            top = anchorBottom - containerHeight;
            maxHeight = anchorBottom;
            maxWidth = anchorLeft;
            break;
        case "left-start":
            left = anchorLeft - containerWidth;
            top = anchorTop;
            maxHeight = screenHeight - anchorTop;
            maxWidth = anchorLeft;
            break;
        case "top-center":
            left = anchorLeft + anchorWidth / 2 - containerWidth / 2;
            top = anchorTop - containerHeight;
            maxHeight = anchorTop;
            maxWidth = screenWidth;
            break;
        case "bottom-center":
            left = anchorLeft + anchorWidth / 2 - containerWidth / 2;
            top = anchorBottom;
            maxHeight = screenHeight - anchorBottom;
            maxWidth = screenWidth;
            break;
    }
    if (position.includes("top")) top -= $451487d20aa3eb8a$var$MENU_MARGIN;
    else if (position.includes("bottom")) top += $451487d20aa3eb8a$var$MENU_MARGIN;
    else if (position.includes("right")) left += $451487d20aa3eb8a$var$MENU_MARGIN;
    else if (position.includes("left")) left -= $451487d20aa3eb8a$var$MENU_MARGIN;
    return {
        left: Math.round(left < 0 ? 0 : left),
        top: Math.round(top < 0 ? 0 : top),
        maxHeight: maxHeight,
        maxWidth: maxWidth
    };
}
const $451487d20aa3eb8a$var$DROPDOWNMENU_SELECTOR$1 = "div.j-JDSDropdownMenuInternal-menu-container";
const $451487d20aa3eb8a$var$SEARCH_BAR_HEIGHT = 56;
const $451487d20aa3eb8a$var$withLogic$1C = (Component)=>(props)=>{
        const [activeMenuId, setActiveMenuId] = (0, $1OEoy.useState)(void 0);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const [labelTextWrap, setLabelTextWrap] = (0, $1OEoy.useState)(true);
        const [selectedValue, setSelectedValue] = (0, $1OEoy.useState)(void 0);
        const [selectedValues, setSelectedValues] = (0, $1OEoy.useState)([]);
        const [menuVisible, setMenuVisible] = (0, $1OEoy.useState)(false);
        const [internalOpen, setInternalOpen] = (0, $1OEoy.useState)(false);
        const [isNested, setIsNested] = (0, $1OEoy.useState)(false);
        const [fullScreen, setFullScreen] = (0, $1OEoy.useState)(false);
        const [menuWidth, setMenuWidth] = (0, $1OEoy.useState)("max-content");
        const internalProps = props;
        const { anchorEl: anchorEl, position: position } = props;
        const dropdownMenuRef = element?.querySelector($451487d20aa3eb8a$var$DROPDOWNMENU_SELECTOR$1);
        const [coords, setCoords] = (0, $1OEoy.useState)({
            left: 0,
            top: 0,
            maxHeight: 0,
            maxWidth: void 0
        });
        const defaultValue = {
            activeMenuId: void 0,
            setActiveMenuId: setActiveMenuId,
            labelTextWrap: labelTextWrap,
            selectedValue: selectedValue,
            setSelectedValue (value) {
                setSelectedValue(value);
                if (props.value !== value) {
                    props?.onSelect?.(value);
                    props?.onClose?.();
                    setActiveMenuId(void 0);
                }
            },
            selectedValues: selectedValues,
            setSelectedValues: (values)=>setSelectedValues([
                    ...values
                ]),
            isNested: isNested,
            setIsNested: setIsNested,
            resetSelections: ()=>{
                setSelectedValues([]);
            },
            applySelections: ()=>{
                props?.onSelect?.(selectedValues);
                props?.onClose?.();
            }
        };
        (0, $1OEoy.useEffect)(()=>{
            if (props.open) {
                setInternalOpen(true);
                if (dropdownMenuRef && anchorEl?.current) {
                    setFullScreen(false);
                    setMenuWidth("max-content");
                    setTimeout(()=>{
                        const anchorDomRect = anchorEl.current?.getBoundingClientRect();
                        const containerDomRect = dropdownMenuRef?.getBoundingClientRect();
                        if (anchorDomRect && containerDomRect) {
                            const calculatedPosition = $451487d20aa3eb8a$var$getCalculatedPosition(position || "bottom-start", anchorDomRect, containerDomRect);
                            const { left: left, top: top, maxHeight: maxHeight, maxWidth: maxWidth } = $451487d20aa3eb8a$var$getPositionCoordinates(calculatedPosition, anchorDomRect, containerDomRect);
                            const menuItems = dropdownMenuRef.querySelectorAll(".j-JDSDropdownMenuItem-container");
                            const isFullScreen = $451487d20aa3eb8a$var$Devices.isMobile() ? isNested || (menuItems?.length || 0) > 7 : false;
                            setFullScreen(isFullScreen);
                            if (isFullScreen) setCoords({
                                left: 0,
                                top: 0,
                                maxHeight: maxHeight,
                                maxWidth: maxWidth
                            });
                            else setCoords({
                                left: left,
                                top: top,
                                maxHeight: maxHeight,
                                maxWidth: maxWidth
                            });
                            setMenuVisible(true);
                            if (props.width === "trigger") setMenuWidth(`${anchorDomRect.width}px`);
                            else setMenuWidth(maxWidth && containerDomRect.width > maxWidth ? `${maxWidth}px` : "max-content");
                        }
                    }, 10);
                }
            } else {
                setMenuVisible(false);
                setTimeout(()=>{
                    setInternalOpen(false);
                }, 300);
            }
        }, [
            props.open,
            anchorEl,
            position,
            dropdownMenuRef,
            isNested
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (props.kind === "multi-select") setSelectedValues(props.value ? [
                props.value
            ] : []);
            else setSelectedValue(props.value);
        }, [
            props.value
        ]);
        (0, $1OEoy.useEffect)(()=>{
            setLabelTextWrap(!!props.labelTextWrap);
        }, [
            props.labelTextWrap
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (props.open && dropdownMenuRef) dropdownMenuRef.focus();
        }, [
            props.open,
            dropdownMenuRef
        ]);
        (0, $1OEoy.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (props.open && !activeMenuId) switch(event.key){
                    case "ArrowUp":
                        $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(-1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "Escape":
                        props?.onClose?.();
                        anchorEl?.current?.focus?.();
                        break;
                }
            };
            if (props.open) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            props.open,
            dropdownMenuRef,
            activeMenuId
        ]);
        const shouldShowSuffix = props?.searchConfig?.suffix !== false;
        const close = ()=>{
            props?.onClose?.();
            setMenuVisible(false);
            setActiveMenuId(void 0);
        };
        $451487d20aa3eb8a$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$DropdownMenuContext.Provider, {
            value: {
                ...defaultValue,
                setActiveMenuId: setActiveMenuId,
                setIsNested: setIsNested,
                activeMenuId: activeMenuId,
                labelTextWrap: labelTextWrap,
                selectedValue: selectedValue,
                selectedValues: selectedValues,
                isNested: isNested
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...{
                    ...props,
                    open: internalOpen,
                    onClose: ()=>{
                        props?.onClose?.();
                        setMenuVisible(false);
                        setActiveMenuId(void 0);
                    },
                    rootRef: rootRef,
                    offsetX: internalProps.offsetX || `${coords.left}px`,
                    _menuWidth: fullScreen ? "100%" : menuWidth,
                    _menuFullScreen: fullScreen,
                    _menuMaxHeight: coords.maxHeight === 0 ? "unset" : props.searchTrigger ? `${coords.maxHeight - $451487d20aa3eb8a$var$SEARCH_BAR_HEIGHT}px` : `${coords.maxHeight}px`,
                    offsetY: internalProps.offsetY || `${coords.top}px`,
                    searchSuffix: shouldShowSuffix ? "IcMic" : void 0,
                    searchLabel: props.searchLabel || "Search",
                    searchValue: props.searchValue,
                    onSuffixClick: props.onSuffixClick,
                    onSearchChange: props?.onSearchChange,
                    _onContainerClick: (event)=>{
                        event.stopPropagation();
                    },
                    onPrimaryClick: ()=>{
                        props.onPrimaryClick?.();
                        defaultValue.applySelections();
                    },
                    onSecondaryClick: ()=>{
                        props.onSecondaryClick?.();
                        defaultValue.resetSelections();
                    },
                    _menuContainerVisible: menuVisible
                }
            })
        });
    };
const $451487d20aa3eb8a$var$Component$1E = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1z;
    const { kind: kind = "single-select", searchTrigger: searchTrigger = false, showCTAButtons: showCTAButtons = true, labelTextWrap: labelTextWrap = false, open: open = false, width: width = "max-content", position: position = "bottom_start", onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            searchTrigger: searchTrigger,
            showCTAButtons: showCTAButtons,
            labelTextWrap: labelTextWrap,
            open: open,
            width: width,
            position: position,
            onSuffixClick: onSuffixClick,
            onSearchChange: onSearchChange,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenu", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$e44a253a59704894 = $451487d20aa3eb8a$var$withLogic$1C($451487d20aa3eb8a$var$Component$1E);
$451487d20aa3eb8a$export$e44a253a59704894.displayName = "DropdownMenu";
$451487d20aa3eb8a$export$e44a253a59704894.slotName = "jds_dropdown_menu";
const $451487d20aa3eb8a$var$sdl$1y = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-group-1.0.0",
        "name": "JDSDropdownMenuGroup",
        "layerName": "jds_dropdown_menu_group",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "top-jds_divider",
            {
                "label-container": [
                    "label-jds-text"
                ]
            },
            {
                "menu-item-container": [
                    "menu-item-slot"
                ]
            },
            "bottom-jds_divider"
        ]
    },
    "base": {
        "top-jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "xtra-small",
            "padPosition": "top"
        },
        "bottom-jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "none",
            "padPosition": "all"
        },
        "label-container": {
            "width": "{d_6}",
            "padding-top": "{d_3}",
            "padding-right": "{d_5}",
            "padding-left": "{d_4}"
        },
        "container": {
            "hidden": false,
            "width": "{d_0}",
            "background-color": "{d_7}",
            "flex-direction": "{d_1}"
        },
        "menu-item-container": {
            "width": "{d_8}",
            "flex-direction": "{d_2}"
        },
        "menu-item-slot": {
            "hidden": false
        },
        "label-jds-text": {
            "font-family": "{bodyXxsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxsBold}",
            "line-height": "{bodyXxsBold}",
            "letter-spacing": "{bodyXxsBold}",
            "font-weight": "{bodyXxsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "_hideTopDivider": {
            "true": {
                "top-jds_divider": {
                    "hidden": true
                },
                "label-container": {
                    "hidden": true
                }
            }
        },
        "hideBottomDivider": {
            "true": {
                "bottom-jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "children": {
            "menu-item-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_item"
                ]
            }
        },
        "data": {
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "hideBottomDivider": {
                "values": [
                    false,
                    true
                ]
            },
            "_hideTopDivider": {
                "values": [
                    false,
                    true
                ]
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1B = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hideTopDivider: !props.label
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1D = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1y;
    const { hideBottomDivider: hideBottomDivider = false, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            hideBottomDivider: hideBottomDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuGroup", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$246bebaba3a2f70e = $451487d20aa3eb8a$var$withLogic$1B($451487d20aa3eb8a$var$Component$1D);
$451487d20aa3eb8a$export$246bebaba3a2f70e.displayName = "DropdownMenuGroup";
$451487d20aa3eb8a$export$246bebaba3a2f70e.slotName = "jds_dropdown_menu_group";
const $451487d20aa3eb8a$var$sdl$1x = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-1.0.0",
        "name": "JDSDropdownMenuInternal",
        "layerName": "jds_dropdown_menu_internal",
        "internal": true
    },
    "hierarchy": {
        "menu-container": [
            {
                "search-container": [
                    "jds_search_box"
                ]
            },
            {
                "menu-group-container": [
                    "menu-group-slot"
                ]
            },
            {
                "botton-container": [
                    "secondary-jds_action_button",
                    "primary-jds_action_button"
                ]
            }
        ]
    },
    "base": {
        "menu-container": {
            "hidden": false,
            "background-color": "{primaryGrey20}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{large}",
            "pointer-events": "auto",
            "overflow": "hidden",
            "opacity": "{opacity.invisible}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "{custom_color_5}"
            }
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "light_background",
            "width": "{size.max}"
        },
        "menu-group-container": {
            "hidden": false,
            "width": "{size.max}",
            "flex-direction": "{flexDirection.column}",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "overflow-y": "auto"
        },
        "search-container": {
            "hidden": true,
            "width": "{size.max}",
            "padding-top": "{base}",
            "padding-left": "{base}",
            "padding-right": "{base}"
        },
        "menu-group-slot": {
            "hidden": false
        },
        "botton-container": {
            "hidden": true,
            "width": "{size.max}",
            "padding-top": "{base}",
            "padding-bottom": "{m}",
            "padding-left": "{base}",
            "padding-right": "{base}",
            "flex-direction": "{flexDirection.row}",
            "gap": "{s}"
        },
        "primary-jds_action_button": {
            "kind": "primary",
            "size": "medium",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "kind": "secondary",
            "size": "medium",
            "stretch": true
        }
    },
    "variant": {
        "menuFullScreen": {
            "true": {
                "menu-container": {
                    "size": "{size.max}"
                }
            }
        },
        "_menuContainerVisible": {
            "true": {
                "menu-container": {
                    "opacity": "{opacity.enabled}"
                }
            }
        },
        "searchTrigger": {
            "true": {
                "search-container": {
                    "hidden": false
                }
            }
        },
        "kind": {
            "multi-select": {
                "botton-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "multi-select": {
                "false": {
                    "botton-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "showCTAButtons"
        ]
    ],
    "api": {
        "children": {
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "jds_search_box": {
                "onSuffixClick": "onSuffixClick",
                "onChange": "onSearchChange"
            },
            "menu-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onContainerClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "data": {
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "value": {
                    "type": "string",
                    "name": "searchValue"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                }
            },
            "menu-container": {
                "width": {
                    "type": "size",
                    "name": "menuWidth"
                },
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                }
            },
            "menu-group-container": {
                "max-height": {
                    "type": "string",
                    "name": "menuMaxHeight"
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "searchTrigger": {
                "values": [
                    false,
                    true
                ]
            },
            "showCTAButtons": {
                "values": [
                    true,
                    false
                ]
            },
            "labelTextWrap": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "menuWidthConfig": {
                "values": [
                    "max-content",
                    "trigger"
                ]
            },
            "position": {
                "values": [
                    "bottom_start",
                    "bottom_end",
                    "top_start",
                    "top_end",
                    "right_start",
                    "right_end",
                    "left_start",
                    "left_end",
                    "bottom_centre",
                    "top_centre"
                ]
            },
            "menuFullScreen": {
                "values": [
                    false,
                    true
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "menu-container": {
                "properties": {
                    "role": {
                        "value": "menu"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "ariaLabel": "searchAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$DROPDOWNMENU_SELECTOR = "div.j-JDSDropdownMenuInternal-menu-container";
const $451487d20aa3eb8a$var$withLogic$1A = (Component)=>(props)=>{
        const { activeMenuId: activeMenuId, setActiveMenuId: setActiveMenuId } = (0, $1OEoy.useContext)($451487d20aa3eb8a$var$DropdownMenuContext);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const [menuVisible, setMenuVisible] = (0, $1OEoy.useState)(false);
        const [internalOpen, setInternalOpen] = (0, $1OEoy.useState)(false);
        const { anchorEl: anchorEl, position: position } = props;
        const dropdownMenuRef = element?.querySelector($451487d20aa3eb8a$var$DROPDOWNMENU_SELECTOR);
        (0, $1OEoy.useEffect)(()=>{
            if (props.open) setTimeout(()=>{
                setInternalOpen(true);
                setMenuVisible(true);
            }, 10);
            else {
                setMenuVisible(false);
                setTimeout(()=>{
                    setInternalOpen(false);
                }, 300);
            }
        }, [
            props.open,
            anchorEl,
            position,
            dropdownMenuRef
        ]);
        (0, $1OEoy.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                if (props.open && !activeMenuId) switch(event.key){
                    case "ArrowUp":
                        $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(-1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(1, dropdownMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "Escape":
                        props?.onClose?.();
                        anchorEl?.current?.focus?.();
                        break;
                }
            };
            if (props.open) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            props.open,
            dropdownMenuRef,
            activeMenuId
        ]);
        const shouldShowSuffix = props?.searchConfig?.suffix !== false;
        const close = ()=>{
            props?.onClose?.();
            setMenuVisible(false);
            setActiveMenuId(void 0);
        };
        $451487d20aa3eb8a$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                open: internalOpen,
                onClose: ()=>{
                    props?.onClose?.();
                    setMenuVisible(false);
                    setActiveMenuId(void 0);
                },
                rootRef: rootRef,
                searchSuffix: shouldShowSuffix ? "IcMic" : void 0,
                searchLabel: props.searchLabel || "Search",
                searchValue: props.searchValue,
                onSuffixClick: props.onSuffixClick,
                onSearchChange: props?.onSearchChange,
                _onContainerClick: (event)=>{
                    event.stopPropagation();
                },
                _menuContainerVisible: menuVisible
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1C = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1x;
    const { kind: kind = "single-select", searchTrigger: searchTrigger = false, showCTAButtons: showCTAButtons = true, labelTextWrap: labelTextWrap = false, open: open = false, menuWidthConfig: menuWidthConfig = "max-content", position: position = "bottom_start", menuFullScreen: menuFullScreen = false, onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            searchTrigger: searchTrigger,
            showCTAButtons: showCTAButtons,
            labelTextWrap: labelTextWrap,
            open: open,
            menuWidthConfig: menuWidthConfig,
            position: position,
            menuFullScreen: menuFullScreen,
            onSuffixClick: onSuffixClick,
            onSearchChange: onSearchChange,
            onAppear: onAppear,
            onContainerClick: onContainerClick,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$5a9d97cdadce1b72 = $451487d20aa3eb8a$var$withLogic$1A($451487d20aa3eb8a$var$Component$1C);
$451487d20aa3eb8a$export$5a9d97cdadce1b72.displayName = "DropdownMenuInternal";
$451487d20aa3eb8a$export$5a9d97cdadce1b72.slotName = "jds_dropdown_menu_internal";
const $451487d20aa3eb8a$var$sdl$1w = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-item-1.0.0",
        "name": "JDSDropdownMenuItem",
        "layerName": "jds_dropdown_menu_item",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_checkbox",
                    {
                        "prefix-container": [
                            "prefix-slot"
                        ]
                    },
                    {
                        "content-container": [
                            "label-jds-text",
                            "description-jds-text"
                        ]
                    },
                    {
                        "suffix-container": [
                            "suffix-jds-text",
                            "icon"
                        ]
                    }
                ]
            },
            {
                "jds_dropdown_menu_submenu": [
                    "menu-group-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "width": "{d_24}"
        },
        "container": {
            "hidden": false,
            "flex-direction": "{d_1}",
            "align-items": "{d_16}",
            "gap": "{d_3}",
            "background-color": "{d_4}",
            "width": "{d_0}",
            "padding-top": "{d_8}",
            "padding-right": "{d_9}",
            "padding-bottom": "{d_10}",
            "padding-left": "{d_11}",
            "opacity": "",
            "behavior": {
                "hover": {
                    "background-color": "{d_5}"
                },
                "active": {
                    "background-color": "{d_6}"
                },
                "focus": {
                    "border-radius": "{d_23}"
                }
            }
        },
        "menu-group-slot": {
            "hidden": false
        },
        "suffix-container": {
            "hidden": false
        },
        "prefix-container": {
            "hidden": false,
            "align-self": "{d_17}"
        },
        "prefix-slot": {
            "hidden": false
        },
        "content-container": {
            "hidden": false,
            "flex": 1,
            "overflow": "hidden",
            "justify-content": "{d_14}",
            "align-items": "{d_15}",
            "flex-direction": "{d_2}"
        },
        "icon": {
            "size": "{d_19}",
            "color": "{d_18}",
            "value": "ic_chevron_right",
            "behavior": {
                "active": {
                    "color": "{d_20}"
                }
            },
            "hidden": true
        },
        "jds_dropdown_menu_submenu": {
            "hidden": true
        },
        "jds_checkbox": {
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "description-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "suffix-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "multi-select": {
                "jds_checkbox": {
                    "hidden": false,
                    "checked": false
                },
                "container": {
                    "behavior": {
                        "active": {
                            "background-color": "{primaryGrey40}"
                        }
                    }
                },
                "icon": {
                    "behavior": {
                        "active": {
                            "color": "{primaryGrey80}"
                        }
                    }
                },
                "label-jds-text": {
                    "behavior": {
                        "active": {}
                    }
                },
                "description-jds-text": {
                    "behavior": {
                        "active": {}
                    }
                },
                "suffix-jds-text": {
                    "behavior": {
                        "active": {
                            "color": "{primaryGrey100}"
                        }
                    }
                }
            }
        },
        "_labelTextWrap": {
            "false": {
                "label-jds-text": {
                    "max-lines": 1,
                    "maxLines": 1
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_22}"
                }
            }
        },
        "selected": {
            "true": {
                "jds_dropdown_menu_submenu": {
                    "hidden": false
                },
                "container": {
                    "background-color": "{d_12}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_13}"
                        }
                    }
                },
                "icon": {
                    "color": "{d_21}"
                },
                "label-jds-text": {
                    "color": "{primaryInverse}"
                },
                "description-jds-text": {
                    "color": "{primaryInverse}"
                },
                "suffix-jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_hasSubMenu": {
            "true": {
                "icon": {
                    "hidden": false
                },
                "suffix-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "multi-select": {
                "true": {
                    "container": {
                        "background-color": "{primaryGrey20}",
                        "behavior": {
                            "hover": {
                                "background-color": "{primaryGrey20}"
                            }
                        }
                    },
                    "icon": {
                        "color": "{primaryGrey80}"
                    },
                    "label-jds-text": {},
                    "description-jds-text": {},
                    "suffix-jds-text": {
                        "color": "{primaryGrey100}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "selected"
        ]
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_image",
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1
            },
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            },
            "jds_checkbox": {
                "onClick": "onItemSelect"
            }
        },
        "data": {
            "jds_dropdown_menu_submenu": {
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "children": {
                    "type": "slot",
                    "name": "children",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            },
            "jds_checkbox": {
                "indeterminate": {
                    "type": "boolean",
                    "name": "_indeterminate"
                },
                "checked": {
                    "type": "boolean",
                    "name": "_checked"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "suffix-jds-text": {
                "value": {
                    "type": "string",
                    "name": "suffix"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "single-select",
                    "multi-select"
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSubMenu": {
                "values": [
                    false,
                    true
                ]
            },
            "_labelTextWrap": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "menuitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-haspopup": {
                        "name": "_ariaHaspopup",
                        "prop": "_hasSubMenu"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded"
                    }
                }
            }
        }
    }
};
function $451487d20aa3eb8a$var$getUniqueId() {
    return $451487d20aa3eb8a$var$generateId() + "-" + $451487d20aa3eb8a$var$generateId() + "-" + $451487d20aa3eb8a$var$generateId();
}
const $451487d20aa3eb8a$var$generateId = function() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
};
const $451487d20aa3eb8a$var$DROPDOWNMENUITEM_SELECTOR = "div.j-JDSDropdownMenuItem-container";
const $451487d20aa3eb8a$var$SUBMENU_OFFSET_TOP = 8;
const $451487d20aa3eb8a$var$SUBMENU_MARGIN = 4;
const $451487d20aa3eb8a$var$getPrefixComponent = (prefix)=>{
    if (typeof prefix === "string") return $451487d20aa3eb8a$var$getIcon$1(prefix);
    if (prefix?.props?.src) return (0, $1OEoy.cloneElement)(prefix, {
        ...prefix.props,
        roundedCorner: true,
        aspectRatio: "square",
        style: {
            width: "24px",
            height: "24px"
        }
    });
    if (prefix?.props?.initials || prefix?.props?.kind) return (0, $1OEoy.cloneElement)(prefix, {
        ...prefix.props,
        size: "x-small"
    });
    return void 0;
};
const $451487d20aa3eb8a$var$withLogic$1z = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const [selected, setSelected] = (0, $1OEoy.useState)(false);
        const [menuItemId, setMenuItemId] = (0, $1OEoy.useState)("");
        const context = (0, $1OEoy.useContext)($451487d20aa3eb8a$var$DropdownMenuContext);
        const [offset, setOffset] = (0, $1OEoy.useState)({
            offsetX: 0,
            offsetY: 0
        });
        (0, $1OEoy.useEffect)(()=>{
            setMenuItemId($451487d20aa3eb8a$var$getUniqueId());
        }, []);
        (0, $1OEoy.useEffect)(()=>{
            if (context.isNested && !props.children) {
                if (selected) setSelected(false);
                return;
            }
            if (props.children) {
                context.setIsNested(true);
                setSelected(context.activeMenuId === menuItemId);
            } else if (props.kind === "multi-select") setSelected(context.selectedValues.includes(props.value || ""));
            else setSelected(context.selectedValue !== void 0 && context.selectedValue === props.value);
        }, [
            selected,
            context.activeMenuId,
            menuItemId,
            context.selectedValue,
            context.selectedValues,
            context.isNested,
            props.value,
            props.children
        ]);
        const handleSubMenuPositioning = ()=>{
            const dropdownMenuItemRef2 = element?.querySelector($451487d20aa3eb8a$var$DROPDOWNMENUITEM_SELECTOR);
            if (dropdownMenuItemRef2) {
                const { right: right, top: top, bottom: bottom, left: left } = dropdownMenuItemRef2.getBoundingClientRect();
                setOffset({
                    offsetX: `${right + $451487d20aa3eb8a$var$SUBMENU_MARGIN}px`,
                    offsetY: `${top - $451487d20aa3eb8a$var$SUBMENU_OFFSET_TOP}px`
                });
                setTimeout(()=>{
                    const subMenuRef = document.querySelector(".j-jds-JDSDropdownMenuSubMenu-menu-container");
                    if (!subMenuRef) return;
                    const subMenuDomRect = subMenuRef.getBoundingClientRect();
                    if (subMenuDomRect.right < window.innerWidth) return;
                    if (subMenuDomRect.width < left) setOffset(({ offsetY: offsetY })=>({
                            offsetX: `${left - (subMenuDomRect.width + $451487d20aa3eb8a$var$SUBMENU_MARGIN)}px`,
                            offsetY: offsetY
                        }));
                    else setOffset({
                        offsetX: `${window.innerWidth - subMenuDomRect.width}px`,
                        offsetY: `${bottom + $451487d20aa3eb8a$var$SUBMENU_MARGIN}px`
                    });
                }, 50);
            }
        };
        const dropdownMenuItemRef = element?.querySelector($451487d20aa3eb8a$var$DROPDOWNMENUITEM_SELECTOR);
        (0, $1OEoy.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                switch(event.key){
                    case "ArrowRight":
                        if (document.activeElement === dropdownMenuItemRef) {
                            if (Boolean(props.children) && !selected) {
                                context.setActiveMenuId(menuItemId);
                                handleSubMenuPositioning();
                                setTimeout(()=>{
                                    const subMenuRef = document.querySelector(".j-JDSDropdownMenuSubMenu-menu-container");
                                    if (subMenuRef) $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(1, subMenuRef, ".j-JDSDropdownMenuItem-container");
                                }, 10);
                            }
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        break;
                    case "ArrowLeft":
                    case "Escape":
                        if (selected && context.activeMenuId) {
                            setSelected(false);
                            context.setActiveMenuId("");
                            dropdownMenuItemRef?.focus?.();
                        }
                        break;
                }
            };
            window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            context.activeMenuId,
            selected,
            dropdownMenuItemRef,
            menuItemId
        ]);
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).Children.toArray(props.children?.props?.children);
        const selectedItems = (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).Children.toArray(props.children?.props?.children).filter((child)=>{
            if (!(typeof child === "object")) return false;
            if (!("props" in child)) return false;
            return child.props.selected;
        });
        const isSelected = children.length ? selectedItems.length === children.length : props.selected;
        const handleClick = (event)=>{
            const updatedSelectedValues = [
                ...context.selectedValues
            ];
            if (props.children) {
                context.setActiveMenuId(menuItemId);
                handleSubMenuPositioning();
            } else if (props.kind === "multi-select") {
                const isChecked = event.target.checked;
                if (isChecked) {
                    if (!updatedSelectedValues.includes(props.value ?? "")) updatedSelectedValues.push(props.value ?? "");
                } else {
                    const index = updatedSelectedValues.indexOf(props.value ?? "");
                    if (index > -1) updatedSelectedValues.splice(index, 1);
                }
            } else context.setSelectedValue(props.value ?? "");
            if (props.kind === "multi-select") {
                children.forEach((child)=>{
                    if (typeof child === "object" && "props" in child) {
                        if (child.props.selected) {
                            if (!updatedSelectedValues.includes(child.props.value)) updatedSelectedValues.push(child.props.value);
                        } else {
                            const index = updatedSelectedValues.indexOf(child.props.value);
                            if (index > -1) updatedSelectedValues.splice(index, 1);
                        }
                    }
                });
                context.setSelectedValues(updatedSelectedValues);
            }
            props?.onClick?.(props.value);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                prefix: $451487d20aa3eb8a$var$getPrefixComponent(props.prefix),
                disabled: Boolean(props.disabled),
                _labelTextWrap: context.labelTextWrap,
                _offsetX: offset.offsetX,
                _offsetY: offset.offsetY,
                _hasSubMenu: Boolean(props.children),
                selected: selected,
                _checked: isSelected,
                _indeterminate: !isSelected && selectedItems.length > 0,
                className: selected ? "selected" : "",
                onClick: handleClick,
                tabIndex: 0,
                _ariaExpanded: !props.children ? void 0 : selected ? "true" : "false"
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1B = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1w;
    const { kind: kind = "single-select", selected: selected = false, disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onItemSelect: onItemSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaHaspopup: _ariaHaspopup = props._hasSubMenu?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            selected: selected,
            disabled: disabled,
            onClick: onClick,
            onItemSelect: onItemSelect,
            ariaLabel: ariaLabel,
            _ariaHaspopup: _ariaHaspopup,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ed97964d1871885d = $451487d20aa3eb8a$var$withLogic$1z($451487d20aa3eb8a$var$Component$1B);
$451487d20aa3eb8a$export$ed97964d1871885d.displayName = "DropdownMenuItem";
$451487d20aa3eb8a$export$ed97964d1871885d.slotName = "jds_dropdown_menu_item";
const $451487d20aa3eb8a$var$sdl$1v = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-submenu-1.0.0",
        "name": "JDSDropdownMenuSubMenu",
        "layerName": "jds_dropdown_menu_sub_menu",
        "internal": true
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_dropdown_menu_sub_menu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 65,
            "background-color": "{global.transparent}",
            "passive": true
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "popup-container": {
                    "size": "{size.max}"
                }
            }
        }
    },
    "api": {
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            },
            "jds_dropdown_menu_sub_menu_internal": {
                "_menuWidth": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "_menuMaxHeight": {
                    "type": "size",
                    "name": "_menuMaxHeight"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "accepts": [
                        "jds_dropdown_menu_group"
                    ]
                }
            }
        },
        "events": {
            "jds_dropdown_menu_sub_menu_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onSelect": "onSelect"
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        }
    }
};
const $451487d20aa3eb8a$var$DROPDOWNMENUSUBMENU_SELECTOR = "div.j-JDSDropdownMenuSubMenuInternal-menu-container";
const $451487d20aa3eb8a$var$withLogic$1y = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const context = (0, $1OEoy.useContext)($451487d20aa3eb8a$var$DropdownMenuContext);
        const [visible, setVisible] = (0, $1OEoy.useState)(false);
        const childArray = (0, $1OEoy.Children).toArray(props.children);
        const firstChild = childArray[0];
        const dropdownMenuSubMenuRef = element?.querySelector($451487d20aa3eb8a$var$DROPDOWNMENUSUBMENU_SELECTOR);
        (0, $1OEoy.useEffect)(()=>{
            if (dropdownMenuSubMenuRef) setTimeout(()=>{
                dropdownMenuSubMenuRef.focus();
            });
        }, [
            dropdownMenuSubMenuRef,
            visible
        ]);
        (0, $1OEoy.useEffect)(()=>{
            const handleKeyDown = (event)=>{
                const isOpen = dropdownMenuSubMenuRef?.contains(document.activeElement);
                if (isOpen) switch(event.key){
                    case "ArrowUp":
                        $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(-1, dropdownMenuSubMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case "ArrowDown":
                        $451487d20aa3eb8a$var$handlePrevOrNextItemFocus(1, dropdownMenuSubMenuRef, ".j-JDSDropdownMenuItem-container");
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                }
            };
            if (context.activeMenuId) window.addEventListener("keydown", handleKeyDown);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
            };
        }, [
            context.activeMenuId,
            dropdownMenuSubMenuRef
        ]);
        (0, $1OEoy.useEffect)(()=>{
            setTimeout(()=>{
                setVisible(true);
            }, 50);
        }, []);
        const isMobile = $451487d20aa3eb8a$var$Devices.isMobile();
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _menuContainerVisible: visible,
                _menuWidth: "max-content",
                offsetX: isMobile ? 0 : props.offsetX,
                offsetY: isMobile ? 0 : props.offsetY,
                _platform: isMobile ? "mobile" : "desktop",
                children: (0, $1OEoy.isValidElement)(firstChild) ? firstChild.props._childrenProps.props.children : null
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1A = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1v;
    const { onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuSubMenu", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$51cd9091d2dcc10a = $451487d20aa3eb8a$var$withLogic$1y($451487d20aa3eb8a$var$Component$1A);
$451487d20aa3eb8a$export$51cd9091d2dcc10a.displayName = "DropdownMenuSubMenu";
$451487d20aa3eb8a$export$51cd9091d2dcc10a.slotName = "jds_dropdown_menu_sub_menu";
const $451487d20aa3eb8a$var$sdl$1u = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-submenu-1.0.0",
        "name": "JDSDropdownMenuSubMenuInternal",
        "layerName": "jds_dropdown_menu_sub_menu_internal",
        "internal": true
    },
    "hierarchy": {
        "menu-container": [
            "menu-group-slot"
        ]
    },
    "base": {
        "menu-container": {
            "hidden": false,
            "background-color": "{primaryGrey20}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{large}",
            "pointer-events": "auto",
            "overflow": "hidden",
            "padding-top": "{xs}",
            "padding-bottom": "{xs}",
            "overflow-y": "auto",
            "opacity": "{opacity.invisible}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "{custom_color_5}"
            }
        },
        "menu-group-slot": {
            "hidden": false
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "menu-container": {
                    "size": "{size.max}"
                }
            }
        },
        "_menuContainerVisible": {
            "true": {
                "menu-container": {
                    "opacity": "{opacity.enabled}"
                }
            }
        }
    },
    "api": {
        "children": {
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "data": {
            "menu-container": {
                "width": {
                    "type": "size",
                    "name": "_menuWidth"
                },
                "max-height": {
                    "type": "size",
                    "name": "_menuMaxHeight"
                },
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                }
            }
        },
        "events": {
            "menu-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onSelect"
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            },
            "_menuContainerVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "menu-container": {
                "properties": {
                    "role": {
                        "value": "menu"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1x = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1z = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1u;
    const { onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onAppear: onAppear,
            onSelect: onSelect,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuSubMenuInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$897b7938c608ac58 = $451487d20aa3eb8a$var$withLogic$1x($451487d20aa3eb8a$var$Component$1z);
$451487d20aa3eb8a$export$897b7938c608ac58.displayName = "DropdownMenuSubMenuInternal";
$451487d20aa3eb8a$export$897b7938c608ac58.slotName = "jds_dropdown_menu_sub_menu_internal";
const $451487d20aa3eb8a$var$sdl$1t = {
    "metadata": {
        "version": "1.0.0",
        "id": "fab-1.0.0",
        "name": "JDSFAB",
        "layerName": "jds_fab",
        "description": "The Floating Action Button(FAB) performs the primary, or most common, action on a screen.",
        "usage": "It places the key user action within easy reach by being persistently visible at a fixed point on a screen."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_fab_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 50,
            "passive": true
        },
        "popup-container": {
            "show": true,
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "size": "{f_3}",
            "padding-right": "{f_4}",
            "padding-bottom": "{f_5}"
        },
        "jds_fab_internal": {
            "hidden": false
        }
    },
    "variant": {
        "show": {
            "false": {
                "popup-container": {
                    "padding-bottom": "0"
                },
                "jds_fab_internal": {
                    "show": false
                }
            }
        },
        "extend": {
            "false": {
                "jds_fab_internal": {
                    "extend": false
                }
            }
        },
        "disableAnimation": {
            "false": {
                "popup-container": {
                    "transition": {
                        "property": [
                            "padding-bottom"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                },
                "jds_fab_internal": {
                    "disableAnimation": false
                }
            },
            "true": {
                "jds_fab_internal": {
                    "disableAnimation": true
                }
            }
        }
    },
    "api": {
        "data": {
            "jds_fab_internal": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of FAB."
                },
                "icon": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of FAB."
                }
            }
        },
        "config": {
            "show": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to show or hide FAB."
            },
            "extend": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "When false, shows only icon."
            },
            "disableAnimation": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to control the entry animation of FAB"
            }
        },
        "events": {
            "jds_fab_internal": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "jds_fab_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1w = (Component)=>(props)=>{
        const [scroll, setScroll] = (0, $1OEoy.useState)(false);
        const [hovered, setHovered] = (0, $1OEoy.useState)(false);
        const { extend: extend, extendOnHover: extendOnHover, shrinkOnScroll: shrinkOnScroll, onHide: onHide, onShow: onShow, onUnmount: onUnmount } = props;
        const scrollListener = (0, $1OEoy.useCallback)((ev)=>{
            if (shrinkOnScroll) setScroll(ev.currentTarget.scrollY !== 0);
        }, [
            shrinkOnScroll
        ]);
        (0, $1OEoy.useEffect)(()=>{
            return ()=>{
                onUnmount?.();
            };
        }, [
            onUnmount
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window.addEventListener("scroll", scrollListener);
            return ()=>{
                window.removeEventListener("scroll", scrollListener);
            };
        }, [
            scrollListener
        ]);
        const internalExtend = (0, $1OEoy.useCallback)(()=>{
            if (!props.title) return false;
            if (scroll) {
                if (shrinkOnScroll) {
                    onHide?.();
                    return false;
                }
            }
            if (extend) {
                onShow?.();
                return true;
            }
            if (hovered) onShow?.();
            return hovered;
        }, [
            extend,
            scroll,
            hovered,
            onHide,
            onShow,
            shrinkOnScroll
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                className: "fab-pointer",
                extend: internalExtend(),
                _hasTitle: Boolean(props.title),
                onHover: (ev)=>{
                    ev.stopPropagation();
                    if (extendOnHover) setHovered(true);
                },
                onHoverEnd: (ev)=>{
                    ev.stopPropagation();
                    setHovered(false);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1y = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1t;
    const { show: show = true, extend: extend = true, disableAnimation: disableAnimation = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            show: show,
            extend: extend,
            disableAnimation: disableAnimation,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFAB", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$72beae6a392d0fc6 = $451487d20aa3eb8a$var$withLogic$1w($451487d20aa3eb8a$var$Component$1y);
$451487d20aa3eb8a$export$72beae6a392d0fc6.displayName = "FAB";
$451487d20aa3eb8a$export$72beae6a392d0fc6.slotName = "jds_fab";
const $451487d20aa3eb8a$var$sdl$1s = {
    "metadata": {
        "version": "1.0.0",
        "id": "fab-1.0.0",
        "name": "JDSFABInternal",
        "layerName": "jds_fab_internal",
        "description": "The Floating Action Button(FAB) performs the primary, or most common, action on a screen.",
        "usage": "It places the key user action within easy reach by being persistently visible at a fixed point on a screen.",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "icon",
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{f_6}",
            "display": "flex",
            "flex-direction": "{f_7}",
            "justify-content": "{f_8}",
            "align-items": "{f_9}",
            "gap": "{f_10}",
            "border-radius": "{f_11}",
            "padding-top": "{f_12}",
            "padding-left": "{f_13}",
            "padding-right": "{f_14}",
            "padding-bottom": "{f_15}",
            "border-color": "{f_16}",
            "border-width": "{f_17}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "behavior": {
                "hover": {
                    "background-color": "{f_18}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000029"
                    }
                },
                "active": {
                    "background-color": "{f_19}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#0000003D"
                    }
                },
                "focus": {
                    "background-color": "{f_20}",
                    "border-width": "{f_21}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000029"
                    }
                }
            }
        },
        "icon": {
            "hidden": false,
            "size": "{f_22}",
            "color": "{f_23}",
            "border-radius": "{f_24}",
            "behavior": {
                "active": {
                    "color": "{f_25}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{secondaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{secondary30}"
                }
            }
        }
    },
    "variant": {
        "show": {
            "false": {
                "container": {
                    "hidden": true,
                    "translate-y": "{size.max}"
                }
            }
        },
        "extend": {
            "false": {
                "container": {
                    "padding-left": "{f_26}",
                    "padding-right": "{f_27}"
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "disableAnimation": {
            "false": {
                "container": {
                    "enter-animation-name": "slideVerticallyUp",
                    "exit-animation-name": "slideVerticallyDown",
                    "enter-animation-curve": "entrance_ease",
                    "exit-animation-curve": "exit_ease",
                    "enter-animation-duration": 500,
                    "exit-animation-duration": 500,
                    "translate-y": "0",
                    "transition": {
                        "property": [
                            "background-color",
                            "box-shadow",
                            "padding-left",
                            "padding-right",
                            "translate-y"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            },
            "true": {
                "container": {
                    "transition": {
                        "property": [
                            "background-color",
                            "box-shadow",
                            "padding-left",
                            "padding-right"
                        ],
                        "duration": "{rapid}",
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "_hasTitle": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "It displays icon of FAB."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of FAB."
                }
            }
        },
        "config": {
            "show": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to show or hide FAB."
            },
            "extend": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "When false, shows only icon."
            },
            "disableAnimation": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasTitle": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1v = (Component)=>(props)=>{
        const [scroll, setScroll] = (0, $1OEoy.useState)(false);
        const [hovered, setHovered] = (0, $1OEoy.useState)(false);
        const { extend: extend, extendOnHover: extendOnHover, shrinkOnScroll: shrinkOnScroll, onHide: onHide, onShow: onShow, onUnmount: onUnmount } = props;
        const scrollListener = (0, $1OEoy.useCallback)((ev)=>{
            if (shrinkOnScroll) setScroll(ev.currentTarget.scrollY !== 0);
        }, [
            shrinkOnScroll
        ]);
        (0, $1OEoy.useEffect)(()=>{
            return ()=>{
                onUnmount?.();
            };
        }, [
            onUnmount
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window.addEventListener("scroll", scrollListener);
            return ()=>{
                window.removeEventListener("scroll", scrollListener);
            };
        }, [
            scrollListener
        ]);
        const internalExtend = (0, $1OEoy.useCallback)(()=>{
            if (!props.title) return false;
            if (scroll) {
                if (shrinkOnScroll) {
                    onHide?.();
                    return false;
                }
            }
            if (extend) {
                onShow?.();
                return true;
            }
            if (hovered) onShow?.();
            return hovered;
        }, [
            extend,
            scroll,
            hovered,
            onHide,
            onShow,
            shrinkOnScroll
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                className: "fabinternal-pointer",
                extend: internalExtend(),
                _hasTitle: Boolean(props.title),
                iconAriaLabel: props.iconAriaLabel || $451487d20aa3eb8a$var$formatIconName(props.icon),
                onHover: (ev)=>{
                    ev.stopPropagation();
                    if (extendOnHover) setHovered(true);
                },
                onHoverEnd: (ev)=>{
                    ev.stopPropagation();
                    setHovered(false);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1x = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1s;
    const { show: show = true, extend: extend = true, disableAnimation: disableAnimation = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            show: show,
            extend: extend,
            disableAnimation: disableAnimation,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFABInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$f3670f01e3026458 = $451487d20aa3eb8a$var$withLogic$1v($451487d20aa3eb8a$var$Component$1x);
$451487d20aa3eb8a$export$f3670f01e3026458.displayName = "FABInternal";
$451487d20aa3eb8a$export$f3670f01e3026458.slotName = "jds_fab_internal";
const $451487d20aa3eb8a$var$sdl$1r = {
    "metadata": {
        "version": "1.0.0",
        "id": "feedback-block-1.0.0",
        "name": "JDSFeedbackBlock",
        "layerName": "jds_feedback_block"
    },
    "hierarchy": {
        "container": [
            {
                "icon-container": [
                    "icon"
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "gap": "{f_3}"
        },
        "icon-container": {
            "flex-direction": "{f_5}",
            "justify-content": "{f_6}",
            "align-items": "{f_7}",
            "height": "{f_8}"
        },
        "icon": {
            "size": "{f_9}"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "size": {
            "s": {
                "icon-container": {
                    "height": "{f_10}"
                },
                "icon": {
                    "size": "{f_11}"
                },
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "state": {
            "success": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_success_colored",
                    "color": "{feedbackSuccess50}"
                },
                "jds-text": {
                    "color": "{feedbackSuccess80}"
                }
            },
            "error": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_error_colored",
                    "color": "{feedbackError50}"
                },
                "jds-text": {
                    "color": "{feedbackError80}"
                }
            },
            "warning": {
                "container": {
                    "hidden": false
                },
                "icon": {
                    "value": "ic_warning_colored",
                    "color": "{feedbackWarning50}"
                },
                "jds-text": {
                    "color": "{feedbackWarning80}"
                }
            }
        },
        "alignment": {
            "top": {
                "container": {
                    "align-items": "{f_4}"
                }
            }
        }
    },
    "api": {
        "config": {
            "size": {
                "values": [
                    "l",
                    "s"
                ]
            },
            "state": {
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "alignment": {
                "values": [
                    "center",
                    "top"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "stateText"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1u = (Component)=>(props)=>{
        if (!props.stateText) return null;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1w = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1r;
    const { size: size = "l", state: state = "none", alignment: alignment = "center", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            state: state,
            alignment: alignment,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFeedbackBlock", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$FeedbackBlock = $451487d20aa3eb8a$var$withLogic$1u($451487d20aa3eb8a$var$Component$1w);
$451487d20aa3eb8a$var$FeedbackBlock.displayName = "FeedbackBlock";
$451487d20aa3eb8a$var$FeedbackBlock.slotName = "jds_feedback_block";
const $451487d20aa3eb8a$var$sdl$1q = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-control-1.0.0",
        "name": "JDSFileUploaderControl",
        "layerName": "jds_file_uploader_control",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "label-container": [
                    "label-jds-text",
                    {
                        "info-jds-icon-container": [
                            "info-jds-icon"
                        ]
                    }
                ]
            },
            "upload-jds_button",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "gap": "{f_3}",
            "width": "{f_4}",
            "opacity": "{f_5}"
        },
        "label-container": {
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "gap": "{f_9}"
        },
        "upload-jds_button": {
            "iconLeft": "ic_upload",
            "kind": "secondary",
            "size": "medium",
            "fullWidth": true
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "textType": "label"
        },
        "info-jds-icon": {
            "size": "{base}",
            "color": "{primaryGrey80}",
            "value": "ic_info",
            "ic": "ic_info"
        },
        "info-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{base}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_info"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "upload-jds_button": {
                "label": {
                    "type": "string",
                    "name": "uploadButtonLabel"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "upload-jds_button": {
                "onClick": "onClick"
            },
            "info-jds-icon": {
                "onClick": "onInfoClick"
            }
        },
        "a11y": {
            "upload-jds_button": {
                "properties": {
                    "ariaLabel": "uploadButtonAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1t = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1v = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1q;
    const { onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInfoClick: onInfoClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            onInfoClick: onInfoClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderControl", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2548bc68b9cf13da = $451487d20aa3eb8a$var$withLogic$1t($451487d20aa3eb8a$var$Component$1v);
$451487d20aa3eb8a$export$2548bc68b9cf13da.displayName = "FileUploaderControl";
$451487d20aa3eb8a$export$2548bc68b9cf13da.slotName = "jds_file_uploader_control";
const $451487d20aa3eb8a$var$sdl$1p = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-item-1.0.0",
        "name": "JDSFileUploaderItem",
        "layerName": "jds_file_uploader_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "file-container": [
                    {
                        "state-container": [
                            "jds_spinner",
                            {
                                "state-jds-icon-container": [
                                    "state-jds-icon"
                                ]
                            },
                            "message-jds-text"
                        ]
                    },
                    {
                        "button-container": [
                            "suffix-jds_button"
                        ]
                    }
                ]
            },
            "jds_divider"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}"
        },
        "file-container": {
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "gap": "{f_9}",
            "padding-left": "{f_10}",
            "width": "{f_11}"
        },
        "state-container": {
            "flex-direction": "{f_12}",
            "justify-content": "{f_13}",
            "align-items": "{f_14}",
            "gap": "{f_15}"
        },
        "jds_spinner": {
            "hidden": true,
            "kind": "normal",
            "size": "small"
        },
        "button-container": {
            "show": true,
            "size": "48",
            "align-items": "{f_16}"
        },
        "suffix-jds_button": {
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "small"
        },
        "jds_divider": {
            "hidden": false,
            "orientation": "horizontal",
            "pad": "none"
        },
        "state-jds-icon": {
            "size": "{m}",
            "color": "{primary50}",
            "hidden": true
        },
        "state-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": true
        },
        "message-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "textType": "label"
        }
    },
    "variant": {
        "kind": {
            "collapsed": {
                "suffix-jds_button": {
                    "icon": "ic_chevron_down"
                },
                "jds_divider": {
                    "hidden": true
                }
            },
            "expanded": {
                "suffix-jds_button": {
                    "icon": "ic_chevron_up"
                },
                "jds_divider": {
                    "hidden": true
                }
            }
        },
        "showDivider": {
            "false": {
                "jds_divider": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "loading": {
                    "jds_spinner": {
                        "hidden": false
                    },
                    "state-jds-icon": {},
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": true
                    }
                },
                "success": {
                    "jds_spinner": {
                        "hidden": true
                    },
                    "state-jds-icon": {
                        "color": "{feedbackSuccess50}",
                        "value": "ic_success_colored",
                        "hidden": false,
                        "ic": "ic_success_colored"
                    },
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": false,
                        "ic": "ic_success_colored"
                    },
                    "message-jds-text": {
                        "color": "{feedbackSuccess50}"
                    }
                },
                "error": {
                    "jds_spinner": {
                        "hidden": true
                    },
                    "suffix-jds_button": {
                        "hidden": true
                    },
                    "state-jds-icon": {
                        "color": "{feedbackError50}",
                        "value": "ic_error_colored",
                        "hidden": false,
                        "ic": "ic_error_colored"
                    },
                    "state-jds-icon-container": {
                        "background-color": "{global.transparent}",
                        "border-radius": "{pill}",
                        "size": "{m}",
                        "justify-content": "{justifyContent.center}",
                        "align-items": "{alignItems.center}",
                        "hidden": false,
                        "ic": "ic_error_colored"
                    },
                    "message-jds-text": {
                        "color": "{feedbackError50}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "state"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "loading",
                    "success",
                    "error"
                ]
            },
            "kind": {
                "values": [
                    "normal",
                    "collapsed",
                    "expanded"
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "message-jds-text": {
                "value": {
                    "type": "string",
                    "name": "message"
                }
            }
        },
        "events": {
            "suffix-jds_button": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "message"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "suffixAriaLabel",
                        "value": "Remove File"
                    },
                    "ariaExpanded": "ariaExpanded"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1s = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            onClick: ()=>{
                props.onClick?.(props.internalIndex);
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1u = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1p;
    const { state: state = "loading", kind: kind = "normal", showDivider: showDivider = true, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.message?.toString(), suffixAriaLabel: suffixAriaLabel = "Remove File", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            kind: kind,
            showDivider: showDivider,
            onClick: onClick,
            ariaLabel: ariaLabel,
            suffixAriaLabel: suffixAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$b41bb47bfc36c3b4 = $451487d20aa3eb8a$var$withLogic$1s($451487d20aa3eb8a$var$Component$1u);
$451487d20aa3eb8a$export$b41bb47bfc36c3b4.displayName = "FileUploaderItem";
$451487d20aa3eb8a$export$b41bb47bfc36c3b4.slotName = "jds_file_uploader_item";
const $451487d20aa3eb8a$var$sdl$1o = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-list-1.0.0",
        "name": "JDSFileUploaderList",
        "layerName": "jds_file_uploader_list",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_item"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}",
            "border-radius": "{f_6}"
        },
        "jds_file_uploader_item": {
            "kind": "normal",
            "showDivider": true
        }
    },
    "variant": {
        "showDivider": {
            "false": {
                "jds_file_uploader_item": {
                    "showDivider": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            },
            "jds_file_uploader_item": {
                "state": {
                    "type": "number",
                    "name": "items.state"
                },
                "message": {
                    "type": "string",
                    "name": "items.message"
                }
            }
        },
        "events": {
            "jds_file_uploader_item": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_file_uploader_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1r = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1t = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1o;
    const { showDivider: showDivider = true, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            showDivider: showDivider,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderList", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3d00ed40fd09f854 = $451487d20aa3eb8a$var$withLogic$1r($451487d20aa3eb8a$var$Component$1t);
$451487d20aa3eb8a$export$3d00ed40fd09f854.displayName = "FileUploaderList";
$451487d20aa3eb8a$export$3d00ed40fd09f854.slotName = "jds_file_uploader_list";
const $451487d20aa3eb8a$var$sdl$1n = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-panel-1.0.0",
        "name": "JDSFileUploaderPanel",
        "layerName": "jds_file_uploader_panel",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_item",
            {
                "inner-container": [
                    "jds_progress_bar"
                ]
            },
            "jds_file_uploader_list"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "opacity": "{f_4}",
            "background-color": "{f_5}",
            "border-radius": "{f_6}",
            "padding-top": "{f_7}",
            "padding-bottom": "{f_8}"
        },
        "inner-container": {
            "hidden": true,
            "padding-top": "{f_9}",
            "padding-bottom": "{f_10}",
            "padding-left": "{f_11}",
            "padding-right": "{f_12}",
            "width": "{f_13}"
        },
        "jds_file_uploader_item": {
            "hidden": true
        },
        "jds_progress_bar": {
            "kind": "determinate",
            "flex": 1
        }
    },
    "variant": {
        "kind": {
            "collapsible": {
                "jds_file_uploader_item": {
                    "hidden": false
                },
                "inner-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "collapsible": {
                "false": {
                    "jds_file_uploader_item": {
                        "kind": "collapsed"
                    },
                    "jds_file_uploader_list": {
                        "hidden": true
                    }
                },
                "true": {
                    "jds_file_uploader_item": {
                        "kind": "expanded"
                    },
                    "jds_file_uploader_list": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "expanded"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "classic",
                    "collapsible"
                ]
            },
            "expanded": {
                "values": [
                    false,
                    true
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_file_uploader_item": {
                "message": {
                    "type": "string",
                    "name": "message"
                }
            },
            "jds_progress_bar": {
                "value": {
                    "type": "float",
                    "name": "value"
                }
            },
            "jds_file_uploader_list": {
                "showDivider": {
                    "type": "boolean",
                    "name": "showDivider"
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            }
        },
        "events": {
            "jds_file_uploader_item": {
                "onClick": "onClick"
            },
            "jds_file_uploader_list": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_file_uploader_list": {
                "name": "items",
                "repeating": {
                    "itemAriaLabel": "itemAriaLabel",
                    "itemAriaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_file_uploader_item": {
                "properties": {
                    "ariaLabel": "panelAriaLabel",
                    "ariaDescribedby": {
                        "name": "panelAriaDescribedBy",
                        "platform": "web,ios"
                    },
                    "suffixAriaLabel": {
                        "name": "panelSuffixAriaLabel",
                        "value": "Toggle Files List"
                    },
                    "ariaExpanded": {
                        "name": "_ariaExpanded",
                        "prop": "expanded"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1q = (Component)=>(props)=>{
        const { toggle: toggle, selected: selected } = $451487d20aa3eb8a$var$useToggle(props.expanded, true);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                expanded: selected,
                onClick: (ev)=>{
                    if (selected) props.onClose?.();
                    else props.onClick?.(ev);
                    toggle();
                },
                onClose: (index)=>{
                    props.onClose?.(index);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1s = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1n;
    const { kind: kind = "classic", expanded: expanded = false, showDivider: showDivider = true, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), panelSuffixAriaLabel: panelSuffixAriaLabel = "Toggle Files List", _ariaExpanded: _ariaExpanded = props.expanded?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            expanded: expanded,
            showDivider: showDivider,
            onClick: onClick,
            onClose: onClose,
            panelSuffixAriaLabel: panelSuffixAriaLabel,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploaderPanel", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$4089cd2315da078 = $451487d20aa3eb8a$var$withLogic$1q($451487d20aa3eb8a$var$Component$1s);
$451487d20aa3eb8a$export$4089cd2315da078.displayName = "FileUploaderPanel";
$451487d20aa3eb8a$export$4089cd2315da078.slotName = "jds_file_uploader_panel";
const $451487d20aa3eb8a$var$sdl$1m = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-icon-link-1.0.0",
        "name": "JDSFooterIconLinks",
        "layerName": "jds_footer_icon_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "icons-container": [
                    "jds_button"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{f_0}",
            "flex-direction": "{f_1}",
            "align-items": "{f_2}"
        },
        "jds_button": {
            "size": "small"
        },
        "icons-container": {
            "flex-direction": "{f_3}",
            "gap": "{f_4}"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en"
        }
    },
    "api": {
        "data": {
            "icons-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "icon": "string",
                        "href": "string"
                    }
                }
            },
            "jds_button": {
                "icon": {
                    "name": "links.icon",
                    "type": "string"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "icons-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "iconAriaLabel",
                    "ariaDescribedby": {
                        "name": "iconAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_button": {
                "properties": {
                    "ariaLabel": "links.iconAriaLabel",
                    "ariaDescribedby": "links.iconAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1p = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1r = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1m;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterIconLinks", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ce48424ab2a5a45 = $451487d20aa3eb8a$var$withLogic$1p($451487d20aa3eb8a$var$Component$1r);
$451487d20aa3eb8a$export$ce48424ab2a5a45.displayName = "FooterIconLinks";
$451487d20aa3eb8a$export$ce48424ab2a5a45.slotName = "jds_footer_icon_links";
const $451487d20aa3eb8a$var$sdl$1l = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-links-1.0.0",
        "name": "JDSFooterLinks",
        "layerName": "jds_footer_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "links-container": [
                    {
                        "link-item-container": [
                            "jds_link"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "align-items": "{f_1}",
            "size": "{f_2}"
        },
        "link-item-container": {
            "size": "{f_3}",
            "padding-top": "{f_4}",
            "padding-bottom": "{f_5}",
            "flex-direction": "{f_6}",
            "justify-content": "{f_7}",
            "align-items": "{f_8}",
            "background-color": "{f_9}",
            "behavior": {
                "hover": {
                    "background-color": "{f_10}"
                }
            }
        },
        "links-container": {
            "padding-top": "{f_13}",
            "size": "{f_14}",
            "flex-direction": "{f_15}"
        },
        "jds_link": {
            "kind": "submenu",
            "textAppearance": "body_s"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-top": "{f_11}",
            "padding-bottom": "{f_12}"
        }
    },
    "api": {
        "config": {},
        "data": {
            "links-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "onClick": "event"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                },
                "newTab": {
                    "type": "string",
                    "name": "links.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "links.routerLinkProps",
                    "platform": "angular"
                },
                "provider": {
                    "type": "object",
                    "name": "links.provider",
                    "platform": "react"
                },
                "onClick": {
                    "type": "string",
                    "name": "links.onClick"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "links-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1o = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1q = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1l;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterLinks", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$553910ef0cc96026 = $451487d20aa3eb8a$var$withLogic$1o($451487d20aa3eb8a$var$Component$1q);
$451487d20aa3eb8a$export$553910ef0cc96026.displayName = "FooterLinks";
$451487d20aa3eb8a$export$553910ef0cc96026.slotName = "jds_footer_links";
const $451487d20aa3eb8a$var$sdl$1k = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-links-grid-1.0.0",
        "name": "JDSFooterLinksGrid",
        "layerName": "jds_footer_links_grid",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_footer_links"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "size": "{f_1}",
            "gap": "{f_2}",
            "flex": 1
        }
    },
    "api": {
        "config": {},
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "links",
                    "object": {
                        "title": "string",
                        "provider": "object",
                        "subLinks": "list"
                    }
                }
            },
            "jds_footer_links": {
                "links": {
                    "type": "list",
                    "name": "links.subLinks"
                },
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "provider": {
                    "type": "object",
                    "name": "links.provider"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1n = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1p = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1k;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterLinksGrid", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$e5275d44ac937bc0 = $451487d20aa3eb8a$var$withLogic$1n($451487d20aa3eb8a$var$Component$1p);
$451487d20aa3eb8a$export$e5275d44ac937bc0.displayName = "FooterLinksGrid";
$451487d20aa3eb8a$export$e5275d44ac937bc0.slotName = "jds_footer_links_grid";
const $451487d20aa3eb8a$var$sdl$1j = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-market-links-1.0.0",
        "name": "JDSFooterMarketLinks",
        "layerName": "jds_footer_market_links",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "title-jds-text",
            {
                "assets-container": [
                    "image"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{f_0}",
            "flex-direction": "{f_1}",
            "align-items": "{f_2}"
        },
        "assets-container": {
            "flex-direction": "{f_3}",
            "align-items": "{f_4}",
            "gap": "{f_5}"
        },
        "image": {
            "height": 40,
            "object-fit": "contain"
        },
        "title-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "api": {
        "data": {
            "assets-container": {
                "value": {
                    "name": "assets",
                    "type": "list",
                    "object": {
                        "image": "image"
                    }
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "assets.image"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1m = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1o = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1j;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSFooterMarketLinks", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$4e70d4e1c9ec4c90 = $451487d20aa3eb8a$var$withLogic$1m($451487d20aa3eb8a$var$Component$1o);
$451487d20aa3eb8a$export$4e70d4e1c9ec4c90.displayName = "FooterMarketLinks";
$451487d20aa3eb8a$export$4e70d4e1c9ec4c90.slotName = "jds_footer_market_links";
const $451487d20aa3eb8a$var$sdl$1i = {
    "metadata": {
        "version": "1.0.0",
        "id": "header-desktop-1.0.0",
        "name": "JDSHeaderDesktop",
        "layerName": "jds_header_desktop",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            {
                                "prefix-container": [
                                    "prefix-jds_button",
                                    {
                                        "logo-container": [
                                            "logo-slot",
                                            "logo-jds-text"
                                        ]
                                    },
                                    "prefix-slot",
                                    "name-jds-text"
                                ]
                            },
                            {
                                "links-container": [
                                    "link-jds_link"
                                ]
                            }
                        ]
                    },
                    "jds_search_box",
                    {
                        "right-container": [
                            {
                                "suffix-container": [
                                    "search-jds_action_button",
                                    {
                                        "icon-links-container": [
                                            "icon-links-slot"
                                        ]
                                    },
                                    "avatar-slot"
                                ]
                            },
                            "suffix-jds_action_button",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            "jds_mega_menu",
            "jds_search_results",
            "tabs-slot"
        ]
    },
    "base": {
        "container": {
            "min-width": "{h_0}",
            "flex-direction": "{h_1}"
        },
        "prefix-container": {
            "flex-direction": "{h_2}",
            "justify-content": "{h_3}",
            "align-items": "{h_4}",
            "gap": "{h_5}"
        },
        "header-container": {
            "min-width": "{h_6}",
            "background-color": "{h_7}",
            "flex-direction": "{h_8}",
            "justify-content": "{h_9}",
            "align-items": "{h_10}",
            "padding-left": "{h_11}",
            "padding-top": "{h_12}",
            "padding-right": "{h_13}",
            "padding-bottom": "{h_14}",
            "gap": "{h_15}",
            "height": "{h_16}"
        },
        "left-container": {
            "flex-direction": "{h_17}",
            "justify-content": "{h_18}",
            "align-items": "{h_19}",
            "gap": "{h_20}"
        },
        "logo-container": {
            "flex-direction": "{h_21}",
            "justify-content": "{h_22}",
            "align-items": "{h_23}",
            "gap": "{h_24}"
        },
        "profile-container": {
            "hidden": true,
            "flex-direction": "{h_25}",
            "justify-content": "{h_26}",
            "align-items": "{h_27}",
            "gap": "{h_28}"
        },
        "links-container": {
            "flex-direction": "{h_29}",
            "justify-content": "{h_30}",
            "align-items": "{h_31}",
            "gap": "{h_32}",
            "padding-left": "{h_33}",
            "flex": 1,
            "hidden": false
        },
        "right-container": {
            "flex-direction": "{h_34}",
            "justify-content": "{h_35}",
            "align-items": "{h_36}",
            "gap": "{h_37}"
        },
        "suffix-container": {
            "flex-direction": "{h_38}",
            "justify-content": "{h_39}",
            "align-items": "{h_40}",
            "gap": "{h_41}",
            "width": "{h_42}"
        },
        "icon-links-container": {
            "flex-direction": "{h_43}",
            "justify-content": "{h_44}",
            "align-items": "{h_45}",
            "gap": "{h_46}",
            "hidden": false
        },
        "prefix-jds_button": {
            "size": "medium",
            "fullWidth": false
        },
        "search-jds_action_button": {
            "hidden": true,
            "icon": "ic_search",
            "size": "medium"
        },
        "icon-links-jds_link": {
            "size": "medium"
        },
        "suffix-jds_action_button": {
            "hidden": true,
            "icon": "ic_close",
            "size": "medium"
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "header",
            "max-width": "312",
            "width": "{h_47}"
        },
        "link-jds_link": {
            "kind": "header"
        },
        "jds_search_results": {
            "open": false,
            "hidden": false,
            "_maxWidth": 784
        },
        "logo-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryInverse}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "name-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryInverse}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "link-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "links-container": {
                    "hidden": true
                },
                "profile-container": {
                    "hidden": false
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "jds_mega_menu": {
                    "hidden": true
                },
                "header-container": {
                    "padding-left": "{h_49}",
                    "padding-right": "{h_50}",
                    "gap": "{h_51}",
                    "height": "{h_48}"
                },
                "left-container": {
                    "gap": "{h_52}"
                },
                "right-container": {
                    "gap": "{h_53}"
                },
                "suffix-container": {
                    "gap": "{h_54}"
                }
            }
        },
        "_variant": {
            "active_search": {
                "header-container": {
                    "justify-content": "{h_56}"
                },
                "profile-container": {
                    "hidden": true
                },
                "links-container": {
                    "hidden": true
                },
                "avatar-slot": {
                    "hidden": true
                },
                "prefix-slot": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": false
                },
                "icon-links-container": {
                    "hidden": true
                },
                "jds_search_box": {
                    "max-width": "784",
                    "width": "{h_57}"
                },
                "suffix-slot": {
                    "hidden": true
                },
                "jds_search_results": {
                    "open": true
                },
                "prefix-jds_button": {
                    "hidden": true
                },
                "name-jds-text": {
                    "hidden": true
                },
                "logo-jds-text": {
                    "hidden": true
                }
            }
        },
        "search": {
            "false": {
                "jds_search_box": {
                    "hidden": true
                },
                "search-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "fullWidth": {
            "false": {
                "container": {
                    "width": "{h_58}"
                }
            }
        },
        "_IsLinksEmpty": {
            "true": {
                "icon-links-container": {
                    "hidden": true
                }
            }
        },
        "_hasSearchResults": {
            "false": {
                "jds_search_results": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "false": {
                    "jds_search_box": {
                        "hidden": true
                    },
                    "search-jds_action_button": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "mobile": {
                "active_search": {
                    "suffix-jds_action_button": {
                        "hidden": false
                    }
                }
            },
            "desktop": {
                "default": {
                    "left-container": {
                        "width": "{h_55}"
                    }
                }
            }
        },
        {
            "mobile": {
                "false": {
                    "header-container": {
                        "justify-content": "{h_59}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "search",
            "expandedSearch"
        ],
        [
            "_platform",
            "_variant"
        ],
        [
            "_platform",
            "search"
        ]
    ],
    "api": {
        "config": {
            "_variant": {
                "values": [
                    "default",
                    "active_search"
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "search": {
                "values": [
                    true,
                    false
                ]
            },
            "expandedSearch": {
                "values": [
                    true,
                    false
                ]
            },
            "searchActive": {
                "values": [
                    false,
                    true
                ]
            },
            "fullWidth": {
                "values": [
                    true,
                    false
                ]
            },
            "_IsLinksEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSearchResults": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "prefix-jds_button": {
                "icon": {
                    "name": "prefix",
                    "type": "icon"
                }
            },
            "links-container": {
                "value": {
                    "type": "list",
                    "name": "links",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "onClick": "event",
                        "subLinks": "list",
                        "active": "boolean"
                    }
                }
            },
            "link-jds_link": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                },
                "newTab": {
                    "type": "string",
                    "name": "links.newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "string",
                    "name": "links.routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "string",
                    "name": "links.onClick"
                },
                "_active": {
                    "type": "string",
                    "name": "links.active"
                }
            },
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix"
                },
                "value": {
                    "type": "string",
                    "name": "query"
                },
                "showBack": {
                    "type": "boolean",
                    "name": "searchShowBack"
                }
            },
            "header-container": {
                "elementRef": {
                    "type": "ref",
                    "name": "elementRef"
                }
            },
            "container": {
                "value": {
                    "type": "object",
                    "name": "megaMenuProps",
                    "object": {
                        "subLinks": "list",
                        "offsetX": "size",
                        "offsetY": "size",
                        "width": "size",
                        "open": "boolean"
                    }
                }
            },
            "jds_search_results": {
                "offsetX": {
                    "type": "size",
                    "name": "megaMenuProps.offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "megaMenuProps.offsetY"
                },
                "_maxWidth": {
                    "type": "size",
                    "name": "megaMenuProps.width"
                },
                "results": {
                    "type": "list",
                    "name": "searchResults"
                },
                "header": {
                    "type": "string",
                    "name": "searchResultHeader"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                },
                "headerAction": {
                    "type": "string",
                    "name": "searchResultHeaderAction"
                }
            },
            "jds_mega_menu": {
                "items": {
                    "type": "object",
                    "name": "megaMenuProps.subLinks"
                },
                "offsetX": {
                    "type": "size",
                    "name": "megaMenuProps.offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "megaMenuProps.offsetY"
                },
                "width": {
                    "type": "size",
                    "name": "megaMenuProps.width"
                },
                "open": {
                    "type": "boolean",
                    "name": "megaMenuProps.open"
                }
            },
            "search-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "dynamicButtonText"
                }
            },
            "logo-jds-text": {
                "value": {
                    "type": "string",
                    "name": "brandLabel"
                }
            },
            "name-jds-text": {
                "value": {
                    "type": "string",
                    "name": "pageTitle"
                }
            }
        },
        "children": {
            "avatar-slot": {
                "name": "avatar",
                "accepts": [
                    "jds_avatar",
                    "jds_link"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "pageTitlePrefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_image"
                ],
                "max": 1
            },
            "tabs-slot": {
                "name": "tabs",
                "accepts": [
                    "jds_tabs_desktop"
                ],
                "max": 1
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1
            },
            "logo-slot": {
                "name": "logo",
                "accepts": [
                    "jds_icon",
                    "jds_image",
                    "jds_link"
                ],
                "max": 1
            },
            "icon-links-slot": {
                "name": "iconLinks",
                "accepts": [
                    "jds_link"
                ]
            }
        },
        "events": {
            "container": {
                "_searchActive.onSearchActiveChange": "onSearchActiveChange"
            },
            "logo-container": {
                "onClick": "logoOnClick"
            },
            "avatar-slot": {
                "onClick": "avatarOnClick"
            },
            "prefix-jds_button": {
                "onClick": "prefixOnClick"
            },
            "suffix-jds_action_button": {
                "onClick": "suffixOnClick"
            },
            "link-jds_link": {
                "onHover": "onHover"
            },
            "jds_mega_menu": {
                "onHoverEnd": "onMenuHoverEnd"
            },
            "jds_search_box": {
                "onBlur": "onSearchBlur",
                "onFocus": "onSearchFocus",
                "onChange": "onSearchChange",
                "onSuffixClick": "onSearchBoxSuffixClick",
                "onKeydown": "onSearchKeydown"
            },
            "search-jds_action_button": {
                "onClick": "onSearchIconClick"
            },
            "jds_search_results": {
                "onHeaderActionClick": "onSearchResultHeaderActionClick",
                "onClick": "onSearchResultClick"
            }
        },
        "a11y": {
            "container": {
                "name": "megaMenuProps",
                "repeating": {
                    "ariaLabel": "menuItemAriaLabel",
                    "ariaDescribedby": {
                        "name": "menuItemAriaDescribedby",
                        "platform": "web,ios"
                    }
                },
                "properties": {
                    "role": {
                        "name": "role"
                    }
                }
            },
            "links-container": {
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "link-jds_link": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            },
            "prefix-jds_button": {
                "properties": {
                    "ariaLabel": "prefixAriaLabel",
                    "ariaDescribedby": {
                        "name": "prefixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "suffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "suffixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "prefixAriaLabel": "searchBoxPrefixAriaLabel",
                    "suffixAriaLabel": "searchBoxSuffixAriaLabel",
                    "ariaLabel": "searchAriaLabel"
                }
            },
            "search-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "searchButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "searchButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$Jdstext = {
    "metadata": {
        "version": "1.0.0",
        "id": "text-1.0.0",
        "name": "JDSText",
        "layerName": "jds_text"
    },
    "hierarchy": {
        "text": []
    },
    "base": {
        "text": {
            "font-family": "{text_1}",
            "color": "{text_2}",
            "font-size": "{text_3}",
            "line-height": "{text_4}",
            "letter-spacing": "{text_5}",
            "font-weight": "{text_6}",
            "text-decoration": "{text_7}",
            "text-transform": "{text_8}"
        }
    },
    "variant": {
        "textAlign": {
            "center": {
                "text": {
                    "text-align": "center"
                }
            },
            "right": {
                "text": {
                    "text-align": "right"
                }
            }
        },
        "textDecoration": {
            "underline": {
                "text": {
                    "text-decoration": "{text_9}"
                }
            },
            "line-through": {
                "text": {
                    "text-decoration": "{text_10}"
                }
            },
            "overline": {
                "text": {
                    "text-decoration": "{text_11}"
                }
            }
        },
        "color": {
            "primary_80": {
                "text": {
                    "color": "{text_12}"
                }
            },
            "primary_70": {
                "text": {
                    "color": "{text_13}"
                }
            },
            "primary_60": {
                "text": {
                    "color": "{text_14}"
                }
            },
            "primary_50": {
                "text": {
                    "color": "{text_15}"
                }
            },
            "primary_40": {
                "text": {
                    "color": "{text_16}"
                }
            },
            "primary_30": {
                "text": {
                    "color": "{text_17}"
                }
            },
            "primary_20": {
                "text": {
                    "color": "{text_18}"
                }
            },
            "primary_inverse": {
                "text": {
                    "color": "{text_19}"
                }
            },
            "primary_background": {
                "text": {
                    "color": "{text_20}"
                }
            },
            "primary_grey_100": {
                "text": {
                    "color": "{text_21}"
                }
            },
            "primary_grey_80": {
                "text": {
                    "color": "{text_22}"
                }
            },
            "primary_grey_60": {
                "text": {
                    "color": "{text_23}"
                }
            },
            "primary_grey_40": {
                "text": {
                    "color": "{text_24}"
                }
            },
            "primary_grey_20": {
                "text": {
                    "color": "{text_25}"
                }
            },
            "secondary_80": {
                "text": {
                    "color": "{text_26}"
                }
            },
            "secondary_70": {
                "text": {
                    "color": "{text_27}"
                }
            },
            "secondary_60": {
                "text": {
                    "color": "{text_28}"
                }
            },
            "secondary_50": {
                "text": {
                    "color": "{text_29}"
                }
            },
            "secondary_40": {
                "text": {
                    "color": "{text_30}"
                }
            },
            "secondary_30": {
                "text": {
                    "color": "{text_31}"
                }
            },
            "secondary_20": {
                "text": {
                    "color": "{text_32}"
                }
            },
            "secondary_inverse": {
                "text": {
                    "color": "{text_33}"
                }
            },
            "secondary_background": {
                "text": {
                    "color": "{text_34}"
                }
            },
            "secondary_grey_100": {
                "text": {
                    "color": "{text_35}"
                }
            },
            "secondary_grey_80": {
                "text": {
                    "color": "{text_36}"
                }
            },
            "secondary_grey_60": {
                "text": {
                    "color": "{text_37}"
                }
            },
            "secondary_grey_40": {
                "text": {
                    "color": "{text_38}"
                }
            },
            "secondary_grey_20": {
                "text": {
                    "color": "{text_39}"
                }
            },
            "sparkle_80": {
                "text": {
                    "color": "{text_40}"
                }
            },
            "sparkle_70": {
                "text": {
                    "color": "{text_41}"
                }
            },
            "sparkle_60": {
                "text": {
                    "color": "{text_42}"
                }
            },
            "sparkle_50": {
                "text": {
                    "color": "{text_43}"
                }
            },
            "sparkle_40": {
                "text": {
                    "color": "{text_44}"
                }
            },
            "sparkle_30": {
                "text": {
                    "color": "{text_45}"
                }
            },
            "sparkle_20": {
                "text": {
                    "color": "{text_46}"
                }
            },
            "sparkle_inverse": {
                "text": {
                    "color": "{text_47}"
                }
            },
            "sparkle_background": {
                "text": {
                    "color": "{text_48}"
                }
            },
            "sparkle_grey_100": {
                "text": {
                    "color": "{text_49}"
                }
            },
            "sparkle_grey_80": {
                "text": {
                    "color": "{text_50}"
                }
            },
            "sparkle_grey_60": {
                "text": {
                    "color": "{text_51}"
                }
            },
            "sparkle_grey_40": {
                "text": {
                    "color": "{text_52}"
                }
            },
            "sparkle_grey_20": {
                "text": {
                    "color": "{text_53}"
                }
            },
            "feedback_error_80": {
                "text": {
                    "color": "{text_54}"
                }
            },
            "feedback_error_50": {
                "text": {
                    "color": "{text_55}"
                }
            },
            "feedback_error_20": {
                "text": {
                    "color": "{text_56}"
                }
            },
            "feedback_warning_80": {
                "text": {
                    "color": "{text_57}"
                }
            },
            "feedback_warning_50": {
                "text": {
                    "color": "{text_58}"
                }
            },
            "feedback_warning_20": {
                "text": {
                    "color": "{text_59}"
                }
            },
            "feedback_success_80": {
                "text": {
                    "color": "{text_60}"
                }
            },
            "feedback_success_50": {
                "text": {
                    "color": "{text_61}"
                }
            },
            "feedback_success_20": {
                "text": {
                    "color": "{text_62}"
                }
            },
            "white": {
                "text": {
                    "color": "{text_63}"
                }
            },
            "black": {
                "text": {
                    "color": "{text_64}"
                }
            },
            "transparent": {
                "text": {
                    "color": "{text_65}"
                }
            }
        },
        "appearance": {
            "heading_xl": {
                "text": {
                    "font-size": "{text_66}",
                    "line-height": "{text_68}",
                    "letter-spacing": "{text_69}",
                    "font-weight": "{text_70}",
                    "font-family": "{text_67}"
                }
            },
            "heading_l": {
                "text": {
                    "font-size": "{text_71}",
                    "line-height": "{text_73}",
                    "letter-spacing": "{text_74}",
                    "font-weight": "{text_75}",
                    "font-family": "{text_72}"
                }
            },
            "heading_m": {
                "text": {
                    "font-size": "{text_76}",
                    "line-height": "{text_78}",
                    "letter-spacing": "{text_79}",
                    "font-weight": "{text_80}",
                    "font-family": "{text_77}"
                }
            },
            "heading_s": {
                "text": {
                    "font-size": "{text_81}",
                    "font-family": "{text_82}",
                    "line-height": "{text_83}",
                    "letter-spacing": "{text_84}",
                    "font-weight": "{text_85}"
                }
            },
            "heading_xs": {
                "text": {
                    "font-size": "{text_86}",
                    "font-family": "{text_87}",
                    "line-height": "{text_88}",
                    "letter-spacing": "{text_89}",
                    "font-weight": "{text_90}"
                }
            },
            "heading_xxs": {
                "text": {
                    "font-size": "{text_91}",
                    "line-height": "{text_93}",
                    "letter-spacing": "{text_94}",
                    "font-weight": "{text_95}",
                    "font-family": "{text_92}"
                }
            },
            "overline": {
                "text": {
                    "font-size": "{text_96}",
                    "font-family": "{text_97}",
                    "line-height": "{text_98}",
                    "letter-spacing": "{text_99}",
                    "font-weight": "{text_100}",
                    "text-transform": "{text_101}"
                }
            },
            "body_l": {
                "text": {
                    "font-size": "{text_102}",
                    "font-family": "{text_103}",
                    "line-height": "{text_104}",
                    "letter-spacing": "{text_105}",
                    "font-weight": "{text_106}"
                }
            },
            "body_l_bold": {
                "text": {
                    "font-size": "{text_107}",
                    "font-family": "{text_108}",
                    "line-height": "{text_109}",
                    "letter-spacing": "{text_110}",
                    "font-weight": "{text_111}"
                }
            },
            "body_l_link": {
                "text": {
                    "font-size": "{text_112}",
                    "font-family": "{text_113}",
                    "line-height": "{text_114}",
                    "letter-spacing": "{text_115}",
                    "font-weight": "{text_116}",
                    "color": "{text_0}"
                }
            },
            "body_m": {
                "text": {
                    "font-size": "{text_117}",
                    "font-family": "{text_118}",
                    "line-height": "{text_119}",
                    "letter-spacing": "{text_120}",
                    "font-weight": "{text_121}"
                }
            },
            "body_m_bold": {
                "text": {
                    "font-size": "{text_122}",
                    "font-family": "{text_123}",
                    "line-height": "{text_124}",
                    "letter-spacing": "{text_125}",
                    "font-weight": "{text_126}"
                }
            },
            "body_m_link": {
                "text": {
                    "font-size": "{text_127}",
                    "font-family": "{text_128}",
                    "line-height": "{text_129}",
                    "letter-spacing": "{text_130}",
                    "font-weight": "{text_131}",
                    "color": "{text_0}"
                }
            },
            "body_s": {
                "text": {
                    "font-size": "{text_132}",
                    "font-family": "{text_133}",
                    "line-height": "{text_134}",
                    "letter-spacing": "{text_135}",
                    "font-weight": "{text_136}"
                }
            },
            "body_s_bold": {
                "text": {
                    "font-size": "{text_137}",
                    "font-family": "{text_138}",
                    "line-height": "{text_139}",
                    "letter-spacing": "{text_140}",
                    "font-weight": "{text_141}"
                }
            },
            "body_s_link": {
                "text": {
                    "font-size": "{text_142}",
                    "font-family": "{text_143}",
                    "line-height": "{text_144}",
                    "letter-spacing": "{text_145}",
                    "font-weight": "{text_146}",
                    "color": "{text_0}"
                }
            },
            "body_xs": {
                "text": {
                    "font-size": "{text_147}",
                    "font-family": "{text_148}",
                    "line-height": "{text_149}",
                    "letter-spacing": "{text_150}",
                    "font-weight": "{text_151}"
                }
            },
            "body_xs_bold": {
                "text": {
                    "font-size": "{text_152}",
                    "font-family": "{text_153}",
                    "line-height": "{text_154}",
                    "letter-spacing": "{text_155}",
                    "font-weight": "{text_156}"
                }
            },
            "body_xs_link": {
                "text": {
                    "font-size": "{text_157}",
                    "font-family": "{text_158}",
                    "line-height": "{text_159}",
                    "letter-spacing": "{text_160}",
                    "font-weight": "{text_161}",
                    "color": "{text_0}"
                }
            },
            "body_xxs": {
                "text": {
                    "font-size": "{text_167}",
                    "font-family": "{text_168}",
                    "line-height": "{text_169}",
                    "letter-spacing": "{text_170}",
                    "font-weight": "{text_171}"
                }
            },
            "body_xxs_bold": {
                "text": {
                    "font-size": "{text_172}",
                    "font-family": "{text_173}",
                    "line-height": "{text_174}",
                    "letter-spacing": "{text_175}",
                    "font-weight": "{text_176}"
                }
            },
            "body_xxs_link": {
                "text": {
                    "font-size": "{text_177}",
                    "font-family": "{text_178}",
                    "line-height": "{text_179}",
                    "letter-spacing": "{text_180}",
                    "font-weight": "{text_181}",
                    "color": "{text_0}"
                }
            },
            "body_3xs": {
                "text": {
                    "font-size": "{text_182}",
                    "font-family": "{text_183}",
                    "line-height": "{text_184}",
                    "letter-spacing": "{text_185}",
                    "font-weight": "{text_186}"
                }
            },
            "body_3xs_bold": {
                "text": {
                    "font-size": "{text_187}",
                    "font-family": "{text_188}",
                    "line-height": "{text_189}",
                    "letter-spacing": "{text_190}",
                    "font-weight": "{text_191}"
                }
            },
            "body_3xs_link": {
                "text": {
                    "font-size": "{text_192}",
                    "font-family": "{text_193}",
                    "line-height": "{text_194}",
                    "letter-spacing": "{text_195}",
                    "font-weight": "{text_196}",
                    "color": "{text_0}"
                }
            },
            "list_title": {
                "text": {
                    "font-size": "{text_197}",
                    "font-family": "{text_198}",
                    "line-height": "{text_199}",
                    "letter-spacing": "{text_200}",
                    "font-weight": "{text_201}"
                }
            },
            "button": {
                "text": {
                    "font-size": "{text_202}",
                    "font-family": "{text_203}",
                    "line-height": "{text_204}",
                    "letter-spacing": "{text_205}",
                    "font-weight": "{text_206}"
                }
            },
            "code": {
                "text": {
                    "font-size": "{text_207}",
                    "font-family": "{text_208}",
                    "line-height": "{text_209}",
                    "letter-spacing": "{text_210}",
                    "font-weight": "{text_211}"
                }
            },
            "body_xs_caps": {
                "text": {
                    "font-size": "{text_variant_appearance_body_xs_caps_text_font-size}",
                    "line-height": "{text_163}",
                    "letter-spacing": "{text_165}",
                    "font-weight": "{text_166}",
                    "text-transform": "{text_164}",
                    "font-family": "{text_162}"
                }
            },
            "body_s_regular_para": {
                "text": {
                    "font-size": "{text_212}",
                    "line-height": "{text_213}",
                    "letter-spacing": "{text_214}",
                    "font-weight": "{text_215}",
                    "font-family": "{text_216}"
                }
            }
        }
    },
    "api": {
        "config": {
            "color": {
                "values": [
                    "primary_grey_100",
                    "primary_80",
                    "primary_70",
                    "primary_60",
                    "primary_50",
                    "primary_40",
                    "primary_30",
                    "primary_20",
                    "primary_inverse",
                    "primary_background",
                    "primary_grey_80",
                    "primary_grey_60",
                    "primary_grey_40",
                    "primary_grey_20",
                    "secondary_80",
                    "secondary_70",
                    "secondary_60",
                    "secondary_50",
                    "secondary_40",
                    "secondary_30",
                    "secondary_20",
                    "secondary_inverse",
                    "secondary_background",
                    "secondary_grey_100",
                    "secondary_grey_80",
                    "secondary_grey_60",
                    "secondary_grey_40",
                    "secondary_grey_20",
                    "sparkle_80",
                    "sparkle_70",
                    "sparkle_60",
                    "sparkle_50",
                    "sparkle_40",
                    "sparkle_30",
                    "sparkle_20",
                    "sparkle_inverse",
                    "sparkle_background",
                    "sparkle_grey_100",
                    "sparkle_grey_80",
                    "sparkle_grey_60",
                    "sparkle_grey_40",
                    "sparkle_grey_20",
                    "feedback_error_80",
                    "feedback_error_50",
                    "feedback_error_20",
                    "feedback_warning_80",
                    "feedback_warning_50",
                    "feedback_warning_20",
                    "feedback_success_80",
                    "feedback_success_50",
                    "feedback_success_20",
                    "white",
                    "black",
                    "transparent"
                ],
                "doc_description": "It can be used to add font-color to text.",
                "function": true
            },
            "textAlign": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It aligns text to left, center, right."
            },
            "textDecoration": {
                "values": [
                    "none",
                    "underline",
                    "line-through",
                    "overline"
                ],
                "doc_description": "It can be used to decorate text eg. 'underline', 'line-through', 'overline'."
            },
            "appearance": {
                "values": [
                    "body_s",
                    "heading_xl",
                    "heading_l",
                    "heading_m",
                    "heading_s",
                    "heading_xs",
                    "heading_xxs",
                    "overline",
                    "body_l",
                    "body_l_bold",
                    "body_l_link",
                    "body_m",
                    "body_m_bold",
                    "body_m_link",
                    "body_s_bold",
                    "body_s_link",
                    "body_xs",
                    "body_xs_bold",
                    "body_xs_link",
                    "body_xxs",
                    "body_xxs_bold",
                    "body_xxs_link",
                    "body_3xs",
                    "body_3xs_bold",
                    "body_3xs_link",
                    "list_title",
                    "button",
                    "code",
                    "body_xs_caps",
                    "body_s_regular_para"
                ],
                "doc_description": "It can be used to set a font appearance based on our typography rules."
            }
        },
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "text",
                    "doc_description": "It the user input text."
                },
                "max-lines": {
                    "type": "number",
                    "name": "maxLines",
                    "function": true,
                    "required": false,
                    "doc_description": "It determines the maximum lines of text the user can pass as input."
                },
                "min-lines": {
                    "type": "number",
                    "name": "minLines",
                    "platform": "android",
                    "required": false,
                    "doc_description": "It determines the minimum lines of text the user can pass as input."
                },
                "trim-line-padding": {
                    "type": "string",
                    "name": "trimLinePadding",
                    "required": false,
                    "platform": "android",
                    "doc_description": "Defines whether the space that would be added to the top of first line, and bottom of the last line should be trimmed or not."
                },
                "textType": {
                    "type": "string",
                    "name": "textType",
                    "platform": "web"
                },
                "custom-color": {
                    "type": "color",
                    "name": "customColor",
                    "required": false,
                    "platform": "android"
                }
            }
        },
        "events": {
            "text": {
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacyTextColors = [
    "primary-grey-100",
    "primary-80",
    "primary-70",
    "primary-60",
    "primary-50",
    "primary-40",
    "primary-30",
    "primary-20",
    "primary-inverse",
    "primary-background",
    "primary-grey-80",
    "primary-grey-60",
    "primary-grey-40",
    "primary-grey-20",
    "secondary-80",
    "secondary-70",
    "secondary-60",
    "secondary-50",
    "secondary-40",
    "secondary-30",
    "secondary-20",
    "secondary-inverse",
    "secondary-background",
    "secondary-grey-100",
    "secondary-grey-80",
    "secondary-grey-60",
    "secondary-grey-40",
    "secondary-grey-20",
    "sparkle-80",
    "sparkle-70",
    "sparkle-60",
    "sparkle-50",
    "sparkle-40",
    "sparkle-30",
    "sparkle-20",
    "sparkle-inverse",
    "sparkle-background",
    "sparkle-grey-100",
    "sparkle-grey-80",
    "sparkle-grey-60",
    "sparkle-grey-40",
    "sparkle-grey-20",
    "feedback-error-80",
    "feedback-error-50",
    "feedback-error-20",
    "feedback-warning-80",
    "feedback-warning-50",
    "feedback-warning-20",
    "feedback-success-80",
    "feedback-success-50",
    "feedback-success-20"
];
const $451487d20aa3eb8a$var$legacyAppearance = [
    "body-s",
    "heading-xl",
    "heading-l",
    "heading-m",
    "heading-s",
    "heading-xs",
    "heading-xxs",
    "overline",
    "body-l",
    "body-l-bold",
    "body-l-link",
    "body-m",
    "body-m-bold",
    "body-m-link",
    "body-s-bold",
    "body-s-link",
    "body-xs",
    "body-xs-bold",
    "body-xs-link",
    "body-xxs",
    "body-xxs-bold",
    "body-xxs-link",
    "list-title",
    "body_xs_caps"
];
const $451487d20aa3eb8a$var$PROP_MAP$n = (props)=>{
    if ($451487d20aa3eb8a$var$legacyAppearance.includes(props.appearance)) console.warn("these values for appearance prop are deprecated", $451487d20aa3eb8a$var$legacyAppearance);
    if ($451487d20aa3eb8a$var$legacyTextColors.includes(props.color)) console.warn("these values for color are deprecated", $451487d20aa3eb8a$var$legacyTextColors);
    return {
        color: {
            properties: {},
            variations: {
                "primary-grey-100": {
                    color: "primary_grey_100"
                },
                "primary-80": {
                    color: "primary_80"
                },
                "primary-70": {
                    color: "primary_70"
                },
                "primary-60": {
                    color: "primary_60"
                },
                "primary-50": {
                    color: "primary_50"
                },
                "primary-40": {
                    color: "primary_40"
                },
                "primary-30": {
                    color: "primary_30"
                },
                "primary-20": {
                    color: "primary_20"
                },
                "primary-inverse": {
                    color: "primary_inverse"
                },
                "primary-background": {
                    color: "primary_background"
                },
                "primary-grey-80": {
                    color: "primary_grey_80"
                },
                "primary-grey-60": {
                    color: "primary_grey_60"
                },
                "primary-grey-40": {
                    color: "primary_grey_40"
                },
                "primary-grey-20": {
                    color: "primary_grey_20"
                },
                "secondary-80": {
                    color: "secondary_80"
                },
                "secondary-70": {
                    color: "secondary_70"
                },
                "secondary-60": {
                    color: "secondary_60"
                },
                "secondary-50": {
                    color: "secondary_50"
                },
                "secondary-40": {
                    color: "secondary_40"
                },
                "secondary-30": {
                    color: "secondary_30"
                },
                "secondary-20": {
                    color: "secondary_20"
                },
                "secondary-inverse": {
                    color: "secondary_inverse"
                },
                "secondary-background": {
                    color: "secondary_background"
                },
                "secondary-grey-100": {
                    color: "secondary_grey_100"
                },
                "secondary-grey-80": {
                    color: "secondary_grey_80"
                },
                "secondary-grey-60": {
                    color: "secondary_grey_60"
                },
                "secondary-grey-40": {
                    color: "secondary_grey_40"
                },
                "secondary-grey-20": {
                    color: "secondary_grey_20"
                },
                "sparkle-80": {
                    color: "sparkle_80"
                },
                "sparkle-70": {
                    color: "sparkle_70"
                },
                "sparkle-60": {
                    color: "sparkle_60"
                },
                "sparkle-50": {
                    color: "sparkle_50"
                },
                "sparkle-40": {
                    color: "sparkle_40"
                },
                "sparkle-30": {
                    color: "sparkle_30"
                },
                "sparkle-20": {
                    color: "sparkle_20"
                },
                "sparkle-inverse": {
                    color: "sparkle_inverse"
                },
                "sparkle-background": {
                    color: "sparkle_background"
                },
                "sparkle-grey-100": {
                    color: "sparkle_grey_100"
                },
                "sparkle-grey-80": {
                    color: "sparkle_grey_80"
                },
                "SPARKLE-GREY-60": {
                    color: "sparkle_grey_60"
                },
                "sparkle-grey-40": {
                    color: "sparkle_grey_40"
                },
                "sparkle-grey-20": {
                    color: "sparkle_grey_20"
                },
                "feedback-error-80": {
                    color: "feedback_error_80"
                },
                "feedback-error-50": {
                    color: "feedback_error_50"
                },
                "feedback-error-20": {
                    color: "feedback_error_20"
                },
                "feedback-warning-80": {
                    color: "feedback_warning_80"
                },
                "feedback-warning-50": {
                    color: "feedback_warning_50"
                },
                "feedback-warning-20": {
                    color: "feedback_warning_20"
                },
                "feedback-success-80": {
                    color: "feedback_success_80"
                },
                "feedback-success-50": {
                    color: "feedback_success_50"
                },
                "feedback-success-20": {
                    color: "feedback_success_20"
                },
                white: {
                    color: "white"
                },
                black: {
                    color: "black"
                },
                transparent: {
                    color: "transparent"
                }
            }
        },
        children: {
            properties: {
                text: props.text || props.children
            }
        },
        text: {
            properties: {
                text: props.text || props.children
            }
        },
        as: {
            properties: {
                textType: props.as
            }
        },
        appearance: {
            properties: {},
            variations: {
                "body-s": {
                    appearance: "body-s"
                },
                "heading-xl": {
                    appearance: "heading_xl"
                },
                "heading-l": {
                    appearance: "heading_l"
                },
                "heading-m": {
                    appearance: "heading_m"
                },
                "heading-s": {
                    appearance: "heading_s"
                },
                "heading-xs": {
                    appearance: "heading_xs"
                },
                "heading-xxs": {
                    appearance: "heading_xxs"
                },
                overline: {
                    appearance: "overline"
                },
                "body-l": {
                    appearance: "body_l"
                },
                "body-l-bold": {
                    appearance: "body_l_bold"
                },
                "body-l-link": {
                    appearance: "body_l_link"
                },
                "body-m": {
                    appearance: "body_m"
                },
                "body-m-bold": {
                    appearance: "body_m_bold"
                },
                "body-m-link": {
                    appearance: "body_m_link"
                },
                "body-s-bold": {
                    appearance: "body_s_bold"
                },
                "body-s-link": {
                    appearance: "body_s_link"
                },
                "body-xs": {
                    appearance: "body_xs"
                },
                "body-xs-bold": {
                    appearance: "body_xs_bold"
                },
                "body-xs-link": {
                    appearance: "body_xs_link"
                },
                "body-xxs": {
                    appearance: "body_xxs"
                },
                "body-xxs-bold": {
                    appearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    appearance: "body_xxs_link"
                },
                "list-title": {
                    appearance: "list_title"
                },
                button: {
                    appearance: "button"
                },
                code: {
                    appearance: "code"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$1l = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$n);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1n = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$Jdstext;
    const { color: color = "primary_grey_100", textAlign: textAlign = "left", textDecoration: textDecoration = "none", appearance: appearance = "body_s", onTextLayout: onTextLayout = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            color: color,
            textAlign: textAlign,
            textDecoration: textDecoration,
            appearance: appearance,
            onTextLayout: onTextLayout,
            ...rest
        },
        componentTag: componentTag
    }, "JDSText", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$5f1af8db9871e1d6 = $451487d20aa3eb8a$var$withLogic$1l($451487d20aa3eb8a$var$Component$1n);
$451487d20aa3eb8a$export$5f1af8db9871e1d6.displayName = "Text";
$451487d20aa3eb8a$export$5f1af8db9871e1d6.slotName = "jds_text";
const $451487d20aa3eb8a$var$PROP_MAP$m = (props)=>({
        searchConfig: {
            properties: {
                searchResults: props.searchConfig?.searchResults?.sections?.[0].results?.map((c)=>({
                        ...c,
                        label: c.title
                    })),
                searchResultHeader: props.searchConfig?.searchResults?.sections?.[0].header,
                searchLabel: props.searchConfig?.searchInput?.label,
                searchSuffix: props.searchConfig?.searchInput?.suffix,
                searchShowBack: props.searchConfig?.searchInput?.showBack,
                query: props.searchConfig?.searchInput?.value,
                searchResultHeaderAction: props.searchConfig?.searchResults?.sections?.[0]?.headerAction?.title,
                onSearchResultClick: props.searchConfig?.searchResults?.onResultsItemClick,
                onSearchResultHeaderActionClick: props.searchConfig?.searchResults?.sections?.[0]?.headerAction?.onClick
            }
        },
        suffix: {
            properties: {
                suffix: typeof props.suffix === "string" ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$5f1af8db9871e1d6, {
                    children: props.suffix
                }) : props.suffix
            }
        }
    });
const $451487d20aa3eb8a$var$sdl$1h = {
    "metadata": {
        "version": "1.0.0",
        "id": "link-1.0.0",
        "name": "JDSLink",
        "layerName": "jds_link"
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "children-slot"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{l_0}",
            "flex-direction": "{l_1}",
            "justify-content": "{l_2}",
            "align-items": "{l_3}",
            "behavior": {
                "hover": {},
                "visited": {},
                "active": {},
                "focus": {
                    "border-radius": "{l_4}",
                    "border-width": "{l_5}",
                    "border-color": "{l_6}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary60}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-color": "primary_grey_60"
        }
    },
    "variant": {
        "_hasText": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasChildren": {
            "false": {
                "children-slot": {
                    "hidden": true
                }
            },
            "true": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "textAppearance": {
            "body_s": {
                "jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            },
            "body_s_bold": {
                "jds-text": {}
            },
            "body_m": {
                "jds-text": {
                    "font-family": "{bodyM}",
                    "font-size": "{bodyM}",
                    "line-height": "{bodyM}",
                    "letter-spacing": "{bodyM}",
                    "font-weight": "{bodyM}"
                }
            },
            "body_m_bold": {
                "jds-text": {
                    "font-family": "{bodyMBold}",
                    "font-size": "{bodyMBold}",
                    "line-height": "{bodyMBold}",
                    "letter-spacing": "{bodyMBold}",
                    "font-weight": "{bodyMBold}"
                }
            },
            "body_l": {
                "jds-text": {
                    "font-family": "{bodyL}",
                    "font-size": "{bodyL}",
                    "line-height": "{bodyL}",
                    "letter-spacing": "{bodyL}",
                    "font-weight": "{bodyL}"
                }
            },
            "body_l_bold": {
                "jds-text": {
                    "font-family": "{bodyLBold}",
                    "font-size": "{bodyLBold}",
                    "line-height": "{bodyLBold}",
                    "letter-spacing": "{bodyLBold}",
                    "font-weight": "{bodyLBold}"
                }
            },
            "body_l_link": {
                "jds-text": {
                    "font-family": "{bodyLLink}",
                    "font-size": "{bodyLLink}",
                    "line-height": "{bodyLLink}",
                    "letter-spacing": "{bodyLLink}",
                    "font-weight": "{bodyLLink}"
                }
            },
            "body_xs": {
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            },
            "body_xxs": {
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            },
            "body_s_link": {
                "jds-text": {
                    "font-family": "{bodySLink}",
                    "font-size": "{bodySLink}",
                    "line-height": "{bodySLink}",
                    "letter-spacing": "{bodySLink}",
                    "font-weight": "{bodySLink}"
                }
            },
            "body_m_link": {
                "jds-text": {
                    "font-family": "{bodyMLink}",
                    "font-size": "{bodyMLink}",
                    "line-height": "{bodyMLink}",
                    "letter-spacing": "{bodyMLink}",
                    "font-weight": "{bodyMLink}"
                }
            },
            "body_xxs_link": {
                "jds-text": {
                    "font-family": "{bodyXxsLink}",
                    "font-size": "{bodyXxsLink}",
                    "line-height": "{bodyXxsLink}",
                    "letter-spacing": "{bodyXxsLink}",
                    "font-weight": "{bodyXxsLink}"
                }
            },
            "body_xs_link": {
                "jds-text": {
                    "font-family": "{bodyXsLink}",
                    "font-size": "{bodyXsLink}",
                    "line-height": "{bodyXsLink}",
                    "letter-spacing": "{bodyXsLink}",
                    "font-weight": "{bodyXsLink}"
                }
            },
            "body_xs_bold": {
                "jds-text": {
                    "font-family": "{bodyXsBold}",
                    "font-size": "{bodyXsBold}",
                    "line-height": "{bodyXsBold}",
                    "letter-spacing": "{bodyXsBold}",
                    "font-weight": "{bodyXsBold}"
                }
            },
            "body_xxs_bold": {
                "jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                }
            },
            "heading_s": {
                "jds-text": {
                    "font-family": "{headingS}",
                    "font-size": "{headingS}",
                    "line-height": "{headingS}",
                    "letter-spacing": "{headingS}",
                    "font-weight": "{headingS}"
                }
            },
            "overline": {
                "jds-text": {
                    "font-family": "{overline}",
                    "font-size": "{overline}",
                    "line-height": "{overline}",
                    "letter-spacing": "{overline}",
                    "font-weight": "{overline}",
                    "text-transform": "{overline}"
                }
            },
            "heading_xs": {
                "jds-text": {
                    "font-family": "{headingXs}",
                    "font-size": "{headingXs}",
                    "line-height": "{headingXs}",
                    "letter-spacing": "{headingXs}",
                    "font-weight": "{headingXs}"
                }
            },
            "heading_xxs": {
                "jds-text": {
                    "font-family": "{headingXxs}",
                    "font-size": "{headingXxs}",
                    "line-height": "{headingXxs}",
                    "letter-spacing": "{headingXxs}",
                    "font-weight": "{headingXxs}"
                }
            },
            "heading_l": {
                "jds-text": {
                    "font-family": "{headingL}",
                    "font-size": "{headingL}",
                    "line-height": "{headingL}",
                    "letter-spacing": "{headingL}",
                    "font-weight": "{headingL}"
                }
            },
            "heading_m": {
                "jds-text": {
                    "font-family": "{headingM}",
                    "font-size": "{headingM}",
                    "line-height": "{headingM}",
                    "letter-spacing": "{headingM}",
                    "font-weight": "{headingM}"
                }
            },
            "heading_xl": {
                "jds-text": {
                    "font-family": "{headingXl}",
                    "font-size": "{headingXl}",
                    "line-height": "{headingXl}",
                    "letter-spacing": "{headingXl}",
                    "font-weight": "{headingXl}"
                }
            },
            "list_title": {
                "jds-text": {
                    "font-family": "{listTitle}",
                    "font-size": "{listTitle}",
                    "line-height": "{listTitle}",
                    "letter-spacing": "{listTitle}",
                    "font-weight": "{listTitle}"
                }
            },
            "button": {
                "jds-text": {
                    "font-family": "{button}",
                    "font-size": "{button}",
                    "line-height": "{button}",
                    "letter-spacing": "{button}",
                    "font-weight": "{button}"
                }
            },
            "code": {
                "jds-text": {
                    "font-family": "{code}",
                    "font-size": "{code}",
                    "line-height": "{code}",
                    "letter-spacing": "{code}",
                    "font-weight": "{code}"
                }
            }
        },
        "kind": {
            "default": {
                "jds-text": {
                    "behavior": {
                        "hover": {
                            "color": "{primary50}"
                        },
                        "visited": {
                            "color": "{primaryGrey80}"
                        }
                    }
                }
            },
            "header": {
                "container": {
                    "behavior": {
                        "focus": {
                            "border-color": "{l_7}"
                        }
                    }
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {
                            "text-decoration": "{text-decoration.underline}"
                        }
                    }
                }
            },
            "submenu": {
                "jds-text": {
                    "color": "{primaryGrey80}",
                    "behavior": {
                        "hover": {
                            "color": "{primaryGrey100}",
                            "text-decoration": "{text-decoration.underline}"
                        }
                    }
                }
            },
            "rich_text": {
                "jds-text": {
                    "color": "{primaryGrey100}",
                    "text-decoration": "{text-decoration.underline}",
                    "behavior": {
                        "hover": {
                            "text-decoration": "{text-decoration.none}"
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "header": {
                    "jds-text": {
                        "text-decoration": "{text-decoration.underline}"
                    }
                }
            }
        },
        {
            "header": {
                "none": {
                    "jds-text": {
                        "color": "{primaryInverse}",
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySLink}",
                                "color": "{primary60}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            },
                            "active": {
                                "font-family": "{bodySLink}",
                                "color": "{primary60}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            }
                        }
                    }
                }
            },
            "submenu": {
                "none": {
                    "jds-text": {}
                }
            },
            "rich_text": {
                "none": {
                    "jds-text": {
                        "font-family": "{bodySLink}",
                        "font-size": "{bodySLink}",
                        "line-height": "{bodySLink}",
                        "letter-spacing": "{bodySLink}",
                        "font-weight": "{bodySLink}",
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySBold}",
                                "color": "{primaryGrey100}",
                                "font-size": "{bodySBold}",
                                "line-height": "{bodySBold}",
                                "letter-spacing": "{bodySBold}",
                                "font-weight": "{bodySBold}",
                                "text-decoration": "{text-decoration.underline}"
                            }
                        }
                    }
                }
            },
            "default": {
                "none": {
                    "jds-text": {
                        "behavior": {
                            "hover": {
                                "font-family": "{bodySLink}",
                                "font-size": "{bodySLink}",
                                "line-height": "{bodySLink}",
                                "letter-spacing": "{bodySLink}",
                                "font-weight": "{bodySLink}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_active",
            "kind"
        ],
        [
            "kind",
            "textAppearance"
        ]
    ],
    "api": {
        "data": {
            "container": {
                "href": {
                    "type": "string",
                    "name": "href",
                    "doc_description": "User provided href of the Link."
                },
                "target": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displayes the title of Link."
                }
            }
        },
        "config": {
            "_hasText": {
                "values": [
                    true,
                    false
                ]
            },
            "_active": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasChildren": {
                "values": [
                    true,
                    false
                ]
            },
            "textAppearance": {
                "type": "JDSText.appearance",
                "doc_description": "It can be used to apply certain style to the title of the link.",
                "values": [
                    "body_s",
                    "heading_xl",
                    "heading_l",
                    "heading_m",
                    "heading_s",
                    "heading_xs",
                    "heading_xxs",
                    "overline",
                    "body_l",
                    "body_l_bold",
                    "body_l_link",
                    "body_m",
                    "body_m_bold",
                    "body_m_link",
                    "body_s_bold",
                    "body_s_link",
                    "body_xs",
                    "body_xs_bold",
                    "body_xs_link",
                    "body_xxs",
                    "body_xxs_bold",
                    "body_xxs_link",
                    "body_3xs",
                    "body_3xs_bold",
                    "body_3xs_link",
                    "list_title",
                    "button",
                    "code",
                    "body_xs_caps",
                    "body_s_regular_para"
                ]
            },
            "kind": {
                "values": [
                    "default",
                    "header",
                    "submenu",
                    "rich_text"
                ],
                "doc_description": "It can be used to switch between 4 variants of Link."
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "link"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-haspopup": {
                        "name": "ariaHaspopup",
                        "platform": "web"
                    },
                    "aria-expanded": {
                        "name": "ariaExpanded",
                        "platform": "web"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withProviderProps = (Component)=>({ provider: provider = /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("a", {}), ...rest })=>{
        const currentProvider = provider || rest?.href ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("a", {
            href: rest?.href
        }) : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {});
        if (!Component) return null;
        return (0, $1OEoy.cloneElement)(currentProvider, {
            ...{
                ...provider?.props,
                target: rest.newTab ? "_blank" : void 0,
                tabIndex: -1,
                style: {
                    ...provider?.props?.style || {},
                    display: "inline-flex"
                }
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...rest
            })
        });
    };
const $451487d20aa3eb8a$var$PROP_MAP$l = (props)=>{
    if (props.kind === "rich-text") console.warn("rich-text is deprecated, use rich_text instead");
    return {
        newTab: {
            properties: {
                newTab: props.newTab ? "_blank" : void 0
            }
        },
        kind: {
            variations: {
                default: {
                    kind: "default"
                },
                "rich-text": {
                    kind: "rich_text"
                }
            }
        },
        textAppearance: {
            properties: {},
            variations: {
                "body-s": {
                    textAppearance: "body-s"
                },
                "heading-xl": {
                    textAppearance: "heading_xl"
                },
                "heading-l": {
                    textAppearance: "heading_l"
                },
                "heading-m": {
                    textAppearance: "heading_m"
                },
                "heading-s": {
                    textAppearance: "heading_s"
                },
                "heading-xs": {
                    textAppearance: "heading_xs"
                },
                "heading-xxs": {
                    textAppearance: "heading_xxs"
                },
                overline: {
                    textAppearance: "overline"
                },
                "body-l": {
                    textAppearance: "body_l"
                },
                "body-l-bold": {
                    textAppearance: "body_l_bold"
                },
                "body-l-link": {
                    textAppearance: "body_l_link"
                },
                "body-m": {
                    textAppearance: "body_m"
                },
                "body-m-bold": {
                    textAppearance: "body_m_bold"
                },
                "body-m-link": {
                    textAppearance: "body_m_link"
                },
                "body-s-bold": {
                    textAppearance: "body_s_bold"
                },
                "body-s-link": {
                    textAppearance: "body_s_link"
                },
                "body-xs": {
                    textAppearance: "body_xs"
                },
                "body-xs-bold": {
                    textAppearance: "body_xs_bold"
                },
                "body-xs-link": {
                    textAppearance: "body_xs_link"
                },
                "body-xxs": {
                    textAppearance: "body_xxs"
                },
                "body-xxs-bold": {
                    textAppearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    textAppearance: "body_xxs_link"
                },
                "list-title": {
                    textAppearance: "list_title"
                },
                button: {
                    textAppearance: "button"
                },
                code: {
                    textAppearance: "code"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$1k = (Component)=>(0, $1OEoy.forwardRef)((userProps, ref)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$l);
        const ComponentWithProvider = (0, $1OEoy.useMemo)(()=>$451487d20aa3eb8a$var$withProviderProps(Component), []);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(ComponentWithProvider, {
            ...{
                ...props,
                rootRef: ref,
                textAppearance: props.textAppearance || "body_s",
                _hasText: Boolean(props.title),
                _hasChildren: Boolean(props.children) && !props.title,
                children: $451487d20aa3eb8a$var$convertTextToComponent(props.children)
            }
        });
    });
const $451487d20aa3eb8a$var$Component$1m = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1h;
    const { textAppearance: textAppearance = "undefined", kind: kind = "default", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            textAppearance: textAppearance,
            kind: kind,
            onClick: onClick,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSLink", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$a6c7ac8248d6e38a = $451487d20aa3eb8a$var$withLogic$1k($451487d20aa3eb8a$var$Component$1m);
$451487d20aa3eb8a$export$a6c7ac8248d6e38a.displayName = "Link";
$451487d20aa3eb8a$export$a6c7ac8248d6e38a.slotName = "jds_link";
const $451487d20aa3eb8a$var$sdl$1g = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-1.0.0",
        "name": "JDSSidePanel",
        "description": "",
        "layerName": "jds_side_panel"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_side_panel_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 40,
            "passive": true,
            "show": true
        },
        "popup-container": {
            "background-color": "#141414D9",
            "height": "{s_0}",
            "width": "{s_1}",
            "flex-direction": "{s_2}",
            "justify-content": "{s_3}",
            "align-items": "{s_4}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeRapid}"
            }
        },
        "jds_side_panel_internal": {
            "open": false,
            "maxWidth": false
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{opacity.enabled}"
                },
                "jds_side_panel_internal": {
                    "open": true
                }
            }
        },
        "direction": {
            "right": {
                "popup-container": {
                    "justify-content": "{s_27}"
                },
                "jds_side_panel_internal": {
                    "direction": "right"
                }
            }
        },
        "maxWidth": {
            "true": {
                "jds_side_panel_internal": {
                    "maxWidth": true
                }
            }
        },
        "showClose": {
            "false": {
                "jds_side_panel_internal": {
                    "showClose": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [],
    "api": {
        "config": {
            "direction": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "Determines whether open/close should happen from left or right."
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Whether a close on the right should be shown."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Can be used to programatically open/close the drawer with animation and selected direction."
            },
            "maxWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "If set it will limit max width of the panel to 412px.",
                "function": true
            },
            "disableTransition": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            }
        },
        "data": {
            "jds_side_panel_internal": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "title": "string",
                        "prefix": "icon",
                        "showSuffix": "boolean",
                        "type": "JDSSidePanelItem.type"
                    }
                },
                "items.prefix": {
                    "type": "string",
                    "name": "items.prefix"
                },
                "items.title": {
                    "type": "string",
                    "name": "items.title"
                },
                "links.showSuffix": {
                    "type": "boolean",
                    "name": "links.showSuffix"
                },
                "items.type": {
                    "type": "string",
                    "name": "items.type"
                },
                "prefix": {
                    "name": "prefix",
                    "type": "slot",
                    "accepts": [
                        "jds_avatar",
                        "jds_icon",
                        "jds_button"
                    ],
                    "max": 1
                },
                "header": {
                    "name": "header",
                    "type": "slot",
                    "doc_description": "Has pre-defined suffix as close button.",
                    "accepts": [
                        "jds_text"
                    ],
                    "max": 1
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "doc_description": "Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks.",
                    "accepts": [
                        "any"
                    ]
                }
            }
        },
        "events": {
            "jds_side_panel_internal": {
                "onClose": "onClose",
                "onContainerClick": "_onContainerClick",
                "onSwipeLeft": "onClose",
                "onSidePanelSuffixClick": "onSidePanelSuffixClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_side_panel_internal": {
                "name": "items",
                "repeating": {
                    "itemAriaLabel": "itemAriaLabel",
                    "itemSuffixAriaLabel": "itemSuffixAriaLabel",
                    "itemAriaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$k = (props)=>{
    if (props.header?.title) console.warn("passing listblock props to header is deprecated");
    return {
        header: {
            properties: {
                prefix: props.header?.prefix,
                header: props.header?.titleBlock?.text || (props.header?.title ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$5f1af8db9871e1d6, {
                    children: props.header?.title
                }) : props.header)
            }
        },
        maxWidth: {
            properties: {
                maxWidth: !props.maxWidth
            }
        }
    };
};
const $451487d20aa3eb8a$var$SIDEPANEL_SELECTOR = "div.j-JDSSidePanelInternal-container";
const $451487d20aa3eb8a$var$withLogic$1j = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$k);
        const { className: className, open: open, close: close } = $451487d20aa3eb8a$var$useTransition(Boolean(props.open), props.onClose, 500);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const sidepanelRef = element?.querySelector($451487d20aa3eb8a$var$SIDEPANEL_SELECTOR);
        (0, $1OEoy.useEffect)(()=>{
            if (props.open && sidepanelRef) sidepanelRef.focus();
        }, [
            props.open
        ]);
        const directionClass = props.direction === "right" ? "right" : "";
        const classes = [
            directionClass,
            className,
            !props.disableTransition ? "enable-transition" : ""
        ];
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                maxWidth: props.maxWidth || props.maxWidth === void 0,
                platform: $451487d20aa3eb8a$var$getPlatform(),
                children: $451487d20aa3eb8a$var$convertTextToComponent(props.children),
                className: classes.join(" "),
                _onContainerClick: (ev)=>{
                    ev.stopPropagation();
                },
                onClose: close
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1l = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1g;
    const { direction: direction = "left", showClose: showClose = true, open: open = false, maxWidth: maxWidth = false, disableTransition: disableTransition = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSidePanelSuffixClick: onSidePanelSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            direction: direction,
            showClose: showClose,
            open: open,
            maxWidth: maxWidth,
            disableTransition: disableTransition,
            onClose: onClose,
            onSidePanelSuffixClick: onSidePanelSuffixClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanel", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$8689d3888980b1f3 = $451487d20aa3eb8a$var$withLogic$1j($451487d20aa3eb8a$var$Component$1l);
$451487d20aa3eb8a$export$8689d3888980b1f3.displayName = "SidePanel";
$451487d20aa3eb8a$export$8689d3888980b1f3.slotName = "jds_side_panel";
const $451487d20aa3eb8a$var$sdl$1f = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-item-1.0.0",
        "name": "JDSSidePanelItem",
        "layerName": "jds_side_panel_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    {
                        "prefix-jds-icon-container": [
                            "prefix-jds-icon"
                        ]
                    },
                    "title-jds_link"
                ]
            },
            "suffix-jds_action_button",
            "heading-jds-text",
            "jds_divider"
        ]
    },
    "base": {
        "jds_divider": {
            "hidden": true,
            "pad": "none",
            "orientation": "horizontal"
        },
        "container": {
            "flex-direction": "{s_2}",
            "justify-content": "{s_3}",
            "align-items": "{s_4}",
            "width": "{s_5}"
        },
        "inner-container": {
            "flex-direction": "{s_6}",
            "justify-content": "{s_7}",
            "align-items": "{s_8}",
            "gap": "{s_9}",
            "padding-top": "{s_10}",
            "padding-bottom": "{s_11}",
            "flex": 1
        },
        "title-jds_link": {
            "kind": "submenu",
            "textAppearance": "body_s"
        },
        "suffix-jds_action_button": {
            "hidden": false,
            "icon": "ic_next",
            "size": "medium",
            "kind": "tertiary"
        },
        "heading-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-top": "{s_0}",
            "padding-bottom": "{s_1}"
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primary50}"
        },
        "prefix-jds-icon-container": {
            "background-color": "{primary20}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        }
    },
    "variant": {
        "showSuffix": {
            "false": {
                "suffix-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "type": {
            "divider": {
                "container": {
                    "padding-top": "0",
                    "padding-bottom": "0"
                },
                "inner-container": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "jds_divider": {
                    "hidden": false
                }
            },
            "heading": {
                "container": {
                    "padding-top": "0",
                    "padding-bottom": "0"
                },
                "inner-container": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": true
                },
                "heading-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "type": {
                "values": [
                    "entry",
                    "divider",
                    "heading"
                ]
            },
            "showSuffix": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "title-jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "events": {
            "suffix-jds_action_button": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "itemSuffixAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1i = (Component)=>(props)=>{
        const { prefix: prefix, ...rest } = props;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                onSuffixClick: ()=>{
                    rest.onSuffixClick?.(rest.internalIndex);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1k = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1f;
    const { type: type = "entry", showSuffix: showSuffix = true, onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            showSuffix: showSuffix,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanelItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$500ae19c14a3c46 = $451487d20aa3eb8a$var$withLogic$1i($451487d20aa3eb8a$var$Component$1k);
$451487d20aa3eb8a$export$500ae19c14a3c46.displayName = "SidePanelItem";
$451487d20aa3eb8a$export$500ae19c14a3c46.slotName = "jds_side_panel_item";
const $451487d20aa3eb8a$var$createIconLinks = (iconLinks)=>{
    return iconLinks?.map((iconLink, i)=>{
        const { icon: icon, ...rest } = iconLink;
        return /* @__PURE__ */ (0, $1OEoy.createElement)($451487d20aa3eb8a$export$a6c7ac8248d6e38a, {
            ...rest,
            key: iconLink.href || i
        }, /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$353f5b6fc5456de1, {
            icon: icon
        }));
    });
};
const $451487d20aa3eb8a$var$useResponsiveDevice = ()=>{
    const [isDesktop, setIsDesktop] = (0, $1OEoy.useState)(true);
    const handleResize = (0, $1OEoy.useCallback)(()=>{
        setIsDesktop($451487d20aa3eb8a$var$Devices.isDesktop());
    }, []);
    (0, $1OEoy.useEffect)(()=>{
        setIsDesktop($451487d20aa3eb8a$var$Devices.isDesktop());
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        handleResize
    ]);
    return isDesktop;
};
const $451487d20aa3eb8a$var$withLogic$1h = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$m);
        const isDesktop = $451487d20aa3eb8a$var$useResponsiveDevice();
        const links = props.links?.map((link, i)=>({
                ...link,
                active: props.activeLink === i,
                showSuffix: link.subLinks?.length,
                onHover: ()=>{
                    if (isDesktop) {
                        setSelectedLink(i);
                        setOpen(true);
                    }
                }
            }));
        const [distance, setDistance] = (0, $1OEoy.useState)({
            x: 0,
            y: 0,
            width: 0
        });
        const [selectedLink, setSelectedLink] = (0, $1OEoy.useState)();
        const [open, setOpen] = (0, $1OEoy.useState)(false);
        const [internalSearchActive, setInternalSearchActive] = (0, $1OEoy.useState)(props.variant === "active_search");
        const [element, setElement] = (0, $1OEoy.useState)(null);
        const [searchValue, setSearchValue] = (0, $1OEoy.useState)(props.searchConfig?.searchInput?.value);
        const [currentLinks, setCurrentLinks] = (0, $1OEoy.useState)(links || []);
        const [sidePanelLinkIndex, setSidePanelLinkIndex] = (0, $1OEoy.useState)(0);
        const [lastSidePanelItems, setLastSidePanelItems] = (0, $1OEoy.useState)([
            links || []
        ]);
        const [sidePanelOpen, setSidePanelOpen] = (0, $1OEoy.useState)(false);
        const [sidePanelTitle, setSidePanelTitle] = (0, $1OEoy.useState)("");
        const updatePosition = (0, $1OEoy.useCallback)($451487d20aa3eb8a$var$debounce((element2)=>{
            if (element2) {
                const { x: x, y: y, width: width, height: height } = element2.getBoundingClientRect();
                setDistance({
                    x: x,
                    y: y + height,
                    width: width
                });
            }
        }, 100), []);
        const ref = (0, $1OEoy.useCallback)((ref2)=>{
            if (ref2 && (open || internalSearchActive)) {
                setElement(ref2);
                updatePosition(ref2);
            }
        }, [
            updatePosition,
            open,
            internalSearchActive
        ]);
        const currentSelectedLinkIndex = typeof selectedLink === "number" ? selectedLink : -1;
        const megaMenuLinks = links?.[currentSelectedLinkIndex]?.subLinks?.map((t)=>({
                ...t,
                links: t.subLinks
            }));
        const handleSearchActiveChange = (val)=>{
            props?.onSearchStateChange?.(val ? "open" : "closed");
            setInternalSearchActive(val);
        };
        const listener = ()=>{
            setOpen(false);
            handleSearchActiveChange(false);
        };
        (0, $1OEoy.useEffect)(()=>{
            setInternalSearchActive(props.variant === "active_search");
        }, [
            props.variant
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window.addEventListener("scroll", listener);
            return ()=>{
                window.removeEventListener("scroll", listener);
            };
        }, []);
        (0, $1OEoy.useEffect)(()=>{
            const targetLogo = document.querySelector('div[data-testid="JDSHeaderDesktop-logo-container"] > a > div[data-testid="JDSLink-container"] > div[data-testid="JDSIcon-container"]');
            const targetAvatar = document.querySelector('div[data-testid="JDSHeaderDesktop-suffix-container"] > a > div[data-testid="JDSLink-container"] > div[data-testid="JDSAvatar-container"]');
            const targetIconLinks = document.querySelectorAll(' a > div[data-testid="JDSLink-container"] > button[data-testid="JDSButton-container"]');
            if (targetLogo) targetLogo.setAttribute("tabindex", "-1");
            if (targetAvatar) targetAvatar.setAttribute("tabindex", "-1");
            if (targetIconLinks) targetIconLinks.forEach((el)=>el.setAttribute("tabindex", "-1"));
        }, []);
        const LogoItem = props.logo === null ? void 0 : props.logo?.props?.src || props.logo?.props?.ic ? props.logo : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
            ic: "IcJioDot",
            size: "xtra-large",
            color: "secondary_50"
        });
        const logoSlot = props.logoLink === null || props.logoLink === void 0 ? LogoItem : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$a6c7ac8248d6e38a, {
            ...props.logoLink,
            children: LogoItem
        });
        const AvatarItem = props.avatar ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$e2255cf6045e8d47, {
            ...props.avatar
        }) : void 0;
        const avatarSlot = props.avatarLink === null || props.avatarLink === void 0 ? AvatarItem : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$a6c7ac8248d6e38a, {
            ...props.avatarLink,
            children: AvatarItem
        });
        const suffixSlot = props.suffixLink === null || props.suffixLink === void 0 ? props.suffix : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$a6c7ac8248d6e38a, {
            ...props.suffixLink,
            children: props.suffix
        });
        const { onFocus: onFocus, onSuffixClick: onSuffixClick, onChange: onChange, onKeyDown: onKeyDown, ...rest } = (props.searchConfig || {}).searchInput || {};
        (0, $1OEoy.useEffect)(()=>{
            if (open) updatePosition(element);
        }, [
            open,
            element
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                    ...{
                        ...props,
                        ...rest,
                        onSearchBoxSuffixClick: onSuffixClick,
                        onSearchKeydown: onKeyDown || props.searchConfig?.onSearchKeyDown,
                        _hasSearchResults: Boolean(props.searchConfig?.searchResults),
                        suffix: suffixSlot,
                        prefixOnClick: ()=>{
                            if (!isDesktop && props.links?.length) setSidePanelOpen(true);
                        },
                        prefix: isDesktop || !props.links?.length ? props.prefix : "ic_burger_menu",
                        logo: logoSlot,
                        avatar: avatarSlot,
                        avatarOnClick: props.avatarOnClick || props.avatarLink,
                        onSearchIconClick: ()=>handleSearchActiveChange(true),
                        expandedSearch: internalSearchActive || props.expandedSearch,
                        onSearchResultContainerClick: (ev)=>ev.stopPropagation(),
                        tabs: props.tabs ? (0, $1OEoy.cloneElement)(props.tabs, {
                            appearance: "tab-bar"
                        }) : null,
                        onSearchResultClick: (ev)=>{
                            setSearchValue(ev.label);
                            handleSearchActiveChange(false);
                            props.searchConfig?.onSearchResultClick?.(ev);
                            props.searchConfig?.searchResults?.onResultsItemClick?.(ev);
                        },
                        _platform: isDesktop ? "desktop" : "mobile",
                        links: isDesktop ? links : void 0,
                        query: searchValue,
                        onSearchChange: (ev)=>{
                            setSearchValue(ev.target.value);
                            props.searchConfig?.onSearchChange?.(ev.target.value);
                            onChange?.(ev);
                        },
                        iconLinks: $451487d20aa3eb8a$var$createIconLinks(props.iconLinks),
                        _variant: internalSearchActive ? "active_search" : "default",
                        onSearchFocus: (ev)=>{
                            handleSearchActiveChange(true);
                            props.searchConfig?.onSearchFocus?.();
                            onFocus?.(ev);
                        },
                        suffixOnClick: ()=>handleSearchActiveChange(false),
                        megaMenuProps: {
                            subLinks: megaMenuLinks,
                            offsetX: distance.x,
                            offsetY: distance.y,
                            width: distance.width + distance.x,
                            open: open
                        },
                        onMenuHoverEnd: ()=>setOpen(false),
                        onSearchClose: ()=>handleSearchActiveChange(false),
                        elementRef: ref
                    }
                }),
                /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$8689d3888980b1f3, {
                    open: sidePanelOpen,
                    onClose: ()=>setSidePanelOpen(false),
                    header: {
                        titleBlock: {
                            text: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$5f1af8db9871e1d6, {
                                color: "primary_inverse",
                                children: sidePanelTitle
                            })
                        },
                        prefix: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$353f5b6fc5456de1, {
                            icon: "ic_back",
                            onClick: ()=>{
                                const currentIndex = sidePanelLinkIndex;
                                const actualIndex = currentIndex < 0 ? 0 : currentIndex;
                                const currentItems = [
                                    ...lastSidePanelItems
                                ];
                                const lastItems = currentItems.splice(actualIndex, 1);
                                setSidePanelLinkIndex(actualIndex - 1);
                                if (lastItems?.[0]) setCurrentLinks(lastItems[0]);
                                setLastSidePanelItems(currentItems);
                            }
                        })
                    },
                    maxWidth: true,
                    children: currentLinks?.map((item, index)=>/* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$500ae19c14a3c46, {
                            type: item.type,
                            showSuffix: !!item.showSuffix,
                            prefix: item.prefix,
                            title: item.title,
                            ariaLabel: item.ariaLabel,
                            ariaDescribedby: item.ariaDescribedby,
                            itemSuffixAriaLabel: item.itemSuffixAriaLabel,
                            onSuffixClick: ()=>{
                                const subLinks = item.subLinks?.map((l)=>({
                                        ...l,
                                        showSuffix: Boolean(l.subLinks?.length)
                                    }));
                                if (subLinks) {
                                    setCurrentLinks(subLinks);
                                    setSidePanelLinkIndex(sidePanelLinkIndex + 1);
                                    setLastSidePanelItems((link)=>[
                                            ...link,
                                            currentLinks
                                        ]);
                                    setSidePanelTitle(item.title || "");
                                }
                                item.onSuffixClick?.();
                            },
                            custom: item.custom,
                            href: item.href,
                            newTab: true
                        }, index))
                })
            ]
        });
    };
const $451487d20aa3eb8a$var$Component$1j = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1i;
    const { search: search = true, expandedSearch: expandedSearch = true, searchActive: searchActive = false, fullWidth: fullWidth = true, onSearchActiveChange: onSearchActiveChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), logoOnClick: logoOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), avatarOnClick: avatarOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), prefixOnClick: prefixOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), suffixOnClick: suffixOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onMenuHoverEnd: onMenuHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchBlur: onSearchBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchFocus: onSearchFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchBoxSuffixClick: onSearchBoxSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchKeydown: onSearchKeydown = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchIconClick: onSearchIconClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchResultHeaderActionClick: onSearchResultHeaderActionClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchResultClick: onSearchResultClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), searchButtonAriaLabel: searchButtonAriaLabel = props.dynamicButtonText?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            search: search,
            expandedSearch: expandedSearch,
            searchActive: searchActive,
            fullWidth: fullWidth,
            onSearchActiveChange: onSearchActiveChange,
            logoOnClick: logoOnClick,
            avatarOnClick: avatarOnClick,
            prefixOnClick: prefixOnClick,
            suffixOnClick: suffixOnClick,
            onHover: onHover,
            onMenuHoverEnd: onMenuHoverEnd,
            onSearchBlur: onSearchBlur,
            onSearchFocus: onSearchFocus,
            onSearchChange: onSearchChange,
            onSearchBoxSuffixClick: onSearchBoxSuffixClick,
            onSearchKeydown: onSearchKeydown,
            onSearchIconClick: onSearchIconClick,
            onSearchResultHeaderActionClick: onSearchResultHeaderActionClick,
            onSearchResultClick: onSearchResultClick,
            searchButtonAriaLabel: searchButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHeaderDesktop", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$8b251419efc915eb = $451487d20aa3eb8a$var$withLogic$1h($451487d20aa3eb8a$var$Component$1j);
$451487d20aa3eb8a$export$8b251419efc915eb.displayName = "Header";
$451487d20aa3eb8a$export$8b251419efc915eb.slotName = "jds_header_desktop";
const $451487d20aa3eb8a$var$sdl$1e = {
    "metadata": {
        "version": "1.0.0",
        "id": "stepper-dot-1.0.0",
        "name": "JDSHorizontalStepItem",
        "layerName": "jds_horizontal_step_item",
        "internal": true
    },
    "hierarchy": {
        "stepper-outer-container": [
            {
                "stepper-inner-container": [
                    "start-jds_divider",
                    "jds_stepper_dot",
                    "end-jds_divider"
                ]
            },
            "label-jds-text"
        ]
    },
    "base": {
        "stepper-outer-container": {
            "flex-direction": "{h_0}",
            "align-items": "{h_1}",
            "justify-content": "{h_2}",
            "size": "{h_3}",
            "gap": "{h_4}"
        },
        "stepper-inner-container": {
            "flex-direction": "{h_5}",
            "width": "{h_6}",
            "align-items": "{h_7}",
            "gap": "{h_8}"
        },
        "start-jds_divider": {
            "pad": "none",
            "flex": 1,
            "withLabel": false,
            "hidden": false,
            "opacity": "{h_11}"
        },
        "end-jds_divider": {
            "pad": "none",
            "withLabel": false,
            "hidden": false,
            "flex": 1,
            "opacity": "{h_12}"
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-right": "{h_9}",
            "padding-left": "{h_10}"
        }
    },
    "variant": {
        "state": {
            "complete": {
                "end-jds_divider": {
                    "variant": "stepper"
                },
                "start-jds_divider": {
                    "variant": "stepper"
                }
            },
            "active": {
                "start-jds_divider": {
                    "variant": "stepper"
                }
            },
            "disabled": {
                "stepper-outer-container": {
                    "disabled": true
                },
                "jds_stepper_dot": {
                    "state": "disabled"
                }
            }
        },
        "direction": {
            "start": {
                "end-jds_divider": {
                    "opacity": "{h_13}"
                }
            },
            "end": {
                "start-jds_divider": {
                    "opacity": "{h_14}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "type": "JDSStepperDot.state",
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "itemsType": {
                "type": "JDSStepperDot.itemsType",
                "values": [
                    "numbered",
                    "icon",
                    "dot"
                ]
            },
            "direction": {
                "values": [
                    "both",
                    "start",
                    "end"
                ]
            }
        },
        "data": {
            "jds_stepper_dot": {
                "index": {
                    "type": "string",
                    "name": "index"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "state"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "activeState"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "a11y": {
            "stepper-outer-container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-current": {
                        "name": "ariaCurrent"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1g = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1i = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1e;
    const { state: state = "undefined", itemsType: itemsType = "undefined", direction: direction = "both", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            itemsType: itemsType,
            direction: direction,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHorizontalStepItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$210661c11db5ef0f = $451487d20aa3eb8a$var$withLogic$1g($451487d20aa3eb8a$var$Component$1i);
$451487d20aa3eb8a$export$210661c11db5ef0f.displayName = "HorizontalStepItem";
$451487d20aa3eb8a$export$210661c11db5ef0f.slotName = "jds_horizontal_step_item";
const $451487d20aa3eb8a$var$sdl$1d = {
    "metadata": {
        "version": "1.0.0",
        "id": "image-1.0.0",
        "name": "JDSImage",
        "layerName": "jds_image"
    },
    "hierarchy": {
        "container": [
            "image",
            "lottie",
            "icon",
            "provider-slot",
            {
                "skeleton-container": [
                    "skeleton-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "background-color": "{i_0}",
            "flex-direction": "{i_1}",
            "justify-content": "{i_2}",
            "align-items": "{i_3}",
            "width": "{i_4}",
            "height": "{i_5}",
            "border-radius": "{i_6}",
            "overflow": "hidden"
        },
        "image": {
            "hidden": false,
            "width": "{i_9}",
            "object-position": "center",
            "object-fit": "cover",
            "aspect-ratio": "{i_7}",
            "border-radius": "{i_8}",
            "z-index": 0
        },
        "lottie": {
            "hidden": true,
            "size": "{i_10}",
            "repeat": true
        },
        "icon": {
            "hidden": true,
            "value": "ic_broken_image",
            "size": "{i_11}",
            "color": "{i_12}",
            "z-index": 1
        },
        "provider-slot": {
            "hidden": true,
            "width": "{i_13}"
        },
        "skeleton-container": {
            "hidden": true,
            "z-index": 1,
            "aspect-ratio": "{i_14}",
            "width": "{i_15}"
        },
        "skeleton-slot": {
            "size": "{i_16}"
        }
    },
    "variant": {
        "contentScale": {
            "contain": {
                "image": {
                    "object-fit": "contain"
                }
            },
            "fill": {
                "image": {
                    "object-fit": "fill"
                }
            },
            "fit": {
                "image": {
                    "object-fit": "fit"
                }
            },
            "fill_height": {
                "image": {
                    "object-fit": "fill_height"
                }
            },
            "fill_width": {
                "image": {
                    "object-fit": "fill_width"
                }
            },
            "none": {
                "image": {
                    "object-fit": "none"
                }
            }
        },
        "imageFocus": {
            "left": {
                "image": {
                    "object-position": "left"
                }
            },
            "right": {
                "image": {
                    "object-position": "right"
                }
            },
            "top": {
                "image": {
                    "object-position": "top"
                }
            },
            "bottom": {
                "image": {
                    "object-position": "bottom"
                }
            }
        },
        "_state": {
            "loading": {
                "container": {
                    "background-color": "{i_17}"
                },
                "image": {
                    "opacity": "{i_18}"
                },
                "skeleton-container": {
                    "hidden": false
                }
            },
            "empty": {
                "container": {
                    "background-color": "{i_19}"
                },
                "image": {
                    "opacity": "{i_20}"
                },
                "icon": {
                    "hidden": false,
                    "value": "ic_image"
                }
            },
            "error": {
                "container": {
                    "background-color": "{i_21}"
                },
                "image": {
                    "opacity": "{i_22}"
                },
                "icon": {
                    "hidden": false
                }
            }
        },
        "_isLottieVisible": {
            "true": {
                "lottie": {
                    "hidden": false
                },
                "image": {
                    "hidden": true
                },
                "icon": {
                    "hidden": true
                },
                "skeleton-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "round": {
                "true": {
                    "container": {
                        "border-radius": "1000"
                    },
                    "image": {
                        "border-radius": "1000"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "1000"
                    },
                    "image": {
                        "border-radius": "1000"
                    }
                }
            },
            "square": {
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0"
                    }
                }
            },
            "horizontal_4_3": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_23}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_24}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_25}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_26}"
                    }
                }
            },
            "horizontal_5_4": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_27}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_28}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_29}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_30}"
                    }
                }
            },
            "horizontal_16_9": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_31}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_32}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_33}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_34}"
                    }
                }
            },
            "vertical_4_5": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_35}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_36}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_37}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_38}"
                    }
                }
            },
            "vertical_3_4": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_39}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_40}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_41}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_42}"
                    }
                }
            },
            "vertical_9_16": {
                "true": {
                    "image": {
                        "aspect-ratio": "{i_43}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_44}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_45}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_46}"
                    }
                }
            },
            "horizontal_2_75__1": {
                "true": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_47}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_48}"
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": "{i_49}"
                    },
                    "skeleton-container": {
                        "aspect-ratio": "{i_50}"
                    }
                }
            },
            "none": {
                "true": {
                    "image": {
                        "aspect-ratio": ""
                    },
                    "skeleton-container": {
                        "aspect-ratio": ""
                    }
                },
                "false": {
                    "container": {
                        "border-radius": "0"
                    },
                    "image": {
                        "border-radius": "0",
                        "aspect-ratio": ""
                    },
                    "skeleton-container": {
                        "aspect-ratio": ""
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "aspectRatio",
            "roundedCorner"
        ]
    ],
    "api": {
        "config": {
            "aspectRatio": {
                "values": [
                    "square",
                    "round",
                    "horizontal_4_3",
                    "horizontal_5_4",
                    "horizontal_16_9",
                    "vertical_4_5",
                    "vertical_3_4",
                    "vertical_9_16",
                    "horizontal_2_75__1",
                    "none"
                ],
                "doc_description": "It can be used to change the aspect ratio of Image. 'round' takes the '1:1' aspect ratio as default."
            },
            "roundedCorner": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Border radius on image. This is `True` by default for all aspect ratios except `aspectRatio='horizontal_2_75__1'`. `horizontal_2_75__1` doesn't accept rounded corner."
            },
            "contentScale": {
                "values": [
                    "cover",
                    "contain",
                    "fit",
                    "fill",
                    "fill_height",
                    "fill_width",
                    "none"
                ]
            },
            "imageFocus": {
                "values": [
                    "center",
                    "left",
                    "right",
                    "top",
                    "bottom"
                ],
                "doc_description": "It can be used for reposition of the Image."
            },
            "_state": {
                "values": [
                    "loaded",
                    "loading",
                    "empty",
                    "error"
                ]
            },
            "_isLottieVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_image.alt": {
                    "type": "string",
                    "name": "alt",
                    "platform": "web",
                    "function": true
                },
                "width": {
                    "type": "size",
                    "name": "width",
                    "platform": "ios"
                },
                "height": {
                    "type": "size",
                    "name": "height",
                    "platform": "ios"
                },
                "border-radius": {
                    "type": "size",
                    "name": "borderRadius",
                    "function": true,
                    "required": false
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "src",
                    "function": true
                },
                "border-radius": {
                    "type": "size",
                    "name": "borderRadius",
                    "function": true,
                    "required": false
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android",
                    "required": false
                },
                "coil_image_loader": {
                    "type": "imageLoader",
                    "name": "imageLoader",
                    "required": false,
                    "platform": "android"
                },
                "title": {
                    "type": "string",
                    "name": "title",
                    "platform": "web"
                }
            },
            "lottie": {
                "value": {
                    "type": "image",
                    "name": "src",
                    "function": true
                },
                "attributes": {
                    "type": "object",
                    "name": "lottieAttributes",
                    "platform": "android, ios",
                    "required": false,
                    "object": {
                        "repeatCount": "number",
                        "maxRetryCount": "number",
                        "speed": "float",
                        "isPlaying": "boolean",
                        "reverseOnRepeat": "boolean",
                        "clipSpec": "LottieClipSpec"
                    }
                }
            }
        },
        "events": {
            "image": {
                "onClick": "onClick",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onError": "onError",
                "onLoad": "onLoad",
                "onEmpty": "onEmpty",
                "onLoading": "onLoading"
            }
        },
        "children": {
            "provider-slot": {
                "name": "provider",
                "accepts": [
                    "any"
                ],
                "max": 1
            },
            "skeleton-slot": {
                "name": "skeleton",
                "accepts": [
                    "jds_skeleton"
                ],
                "max": 1
            }
        },
        "a11y": {
            "image": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$sdl$1c = {
    "metadata": {
        "version": "1.0.0",
        "id": "skeleton-1.0.0",
        "name": "JDSSkeleton",
        "layerName": "jds_skeleton"
    },
    "hierarchy": {
        "container": [
            "skeletonLoader"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{s_0}",
            "show": true,
            "overflow": "hidden"
        },
        "skeletonLoader": {
            "primary-color": "{s_1}",
            "secondary-color": "{s_2}",
            "hidden": true
        }
    },
    "variant": {
        "shape": {
            "circle": {
                "container": {
                    "aspect-ratio": "1",
                    "border-radius": "{s_3}"
                }
            },
            "heading": {
                "container": {
                    "height": "{s_4}",
                    "border-radius": "{s_5}"
                }
            },
            "paragraph": {
                "container": {
                    "border-radius": "{s_6}",
                    "height": "{s_7}"
                }
            },
            "rectangle": {
                "container": {
                    "border-radius": "{s_8}",
                    "aspect-ratio": "1.77"
                }
            },
            "square": {
                "container": {
                    "border-radius": "{s_9}",
                    "aspect-ratio": "1"
                }
            },
            "custom": {
                "container": {
                    "width": "{s_10}",
                    "height": "{s_11}"
                }
            }
        },
        "animated": {
            "true": {
                "skeletonLoader": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "width": {
                    "type": "size",
                    "name": "width",
                    "function": true,
                    "doc_description": "It can be used to determine width of all shapes od Skeleton."
                }
            }
        },
        "config": {
            "shape": {
                "values": [
                    "circle",
                    "heading",
                    "paragraph",
                    "rectangle",
                    "square",
                    "custom"
                ],
                "doc_description": "It is used to determine the shape of Skeleton."
            },
            "animated": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to add animantionto Skeleton."
            }
        },
        "a11y": {
            "container": {
                "name": "skeleton",
                "properties": {
                    "aria-busy": {
                        "name": "_ariaBusy",
                        "prop": "animated"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1f = (Component)=>(props)=>{
        if (props.shape === "custom" && !props.__noCustomWarn__) console.warn("shape=custom is an internal variant. Please do not use it");
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props
            },
            width: props.width
        });
    };
const $451487d20aa3eb8a$var$Component$1h = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1c;
    const { shape: shape = "circle", animated: animated = false, _ariaBusy: _ariaBusy = props.animated?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            shape: shape,
            animated: animated,
            _ariaBusy: _ariaBusy,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSkeleton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$8f31e4c4a37b8e9c = $451487d20aa3eb8a$var$withLogic$1f($451487d20aa3eb8a$var$Component$1h);
$451487d20aa3eb8a$export$8f31e4c4a37b8e9c.displayName = "Skeleton";
$451487d20aa3eb8a$export$8f31e4c4a37b8e9c.slotName = "jds_skeleton";
const $451487d20aa3eb8a$var$legacyAspectRatios = [
    "1:1",
    "round",
    "4:3",
    "5:4",
    "16:9",
    "4:5",
    "3:4",
    "9:16",
    "2.75:1"
];
const $451487d20aa3eb8a$var$PROP_MAP$j = (props)=>{
    if ($451487d20aa3eb8a$var$legacyAspectRatios.includes(props.aspectRatio)) console.warn("these values for aspect ratios are deprectaed", $451487d20aa3eb8a$var$legacyAspectRatios);
    return {
        aspectRatio: {
            variations: {
                "1:1": {
                    aspectRatio: "square"
                },
                "4:3": {
                    aspectRatio: "horizontal_4_3"
                },
                "5:4": {
                    aspectRatio: "horizontal_5_4"
                },
                "16:9": {
                    aspectRatio: "horizontal_16_9"
                },
                "4:5": {
                    aspectRatio: "vertical_4_5"
                },
                "3:4": {
                    aspectRatio: "vertical_3_4"
                },
                "9:16": {
                    aspectRatio: "vertical_9_16"
                },
                "2.75:1": {
                    aspectRatio: "horizontal_2_75__1"
                }
            }
        },
        src: {
            properties: {
                src: props.src
            }
        },
        alt: {
            properties: {
                semantics: props.alt
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$1e = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$j);
        const { src: src, onLoad: onLoad, onError: onError, ...rest } = props;
        const [imageStates, setImageStates] = (0, $1OEoy.useState)({
            error: false,
            loaded: false
        });
        const { error: error, loaded: loaded } = imageStates;
        const hasSrc = Boolean(src);
        const isBroken = hasSrc && loaded && error;
        const handleLoad = (e)=>{
            setImageStates({
                error: false,
                loaded: true
            });
            onLoad?.(e);
        };
        const handleError = (e)=>{
            if (!imageStates.error) {
                setImageStates({
                    error: true,
                    loaded: true
                });
                onError?.(e);
            }
        };
        const provider = ()=>{
            if (rest.provider) {
                const provider2 = rest.provider;
                return (0, $1OEoy.cloneElement)(rest?.provider, {
                    onLoad: (e)=>{
                        handleLoad(e);
                        provider2?.onLoad?.(e);
                    },
                    onError: (e)=>{
                        handleError(e);
                        provider2?.onError?.(e);
                    },
                    src: rest.provider?.props?.src || src
                });
            }
            return null;
        };
        const currentState = !hasSrc ? "empty" : isBroken ? "error" : loaded ? "loaded" : "loading";
        const formatImageName = (imagePath = props.src || "")=>{
            const parts = imagePath.split("/");
            const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
            if (imageName) {
                const formattedName = imageName.replace(/\..*$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
                return formattedName;
            }
            return "Image name not found";
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                skeleton: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$8f31e4c4a37b8e9c, {
                    shape: "custom",
                    animated: true,
                    width: "100%",
                    __noCustomWarn__: true
                }),
                _state: currentState,
                _loaderWidth: "100%",
                title: props.title || formatImageName(props.src),
                onLoad: handleLoad,
                onError: handleError,
                provider: provider() ?? void 0,
                _hasProvider: Boolean(rest.provider && currentState === "loaded"),
                src: rest?.provider?.props?.src || src || {},
                ariaLabel: props.ariaLabel || formatImageName(props.src)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1g = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1d;
    const { aspectRatio: aspectRatio = "square", roundedCorner: roundedCorner = true, contentScale: contentScale = "cover", imageFocus: imageFocus = "center", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onError: onError = (0, $ddff9b86434e3f59$export$8793edee2d425525), onLoad: onLoad = (0, $ddff9b86434e3f59$export$8793edee2d425525), onEmpty: onEmpty = (0, $ddff9b86434e3f59$export$8793edee2d425525), onLoading: onLoading = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            aspectRatio: aspectRatio,
            roundedCorner: roundedCorner,
            contentScale: contentScale,
            imageFocus: imageFocus,
            onClick: onClick,
            onHover: onHover,
            onError: onError,
            onLoad: onLoad,
            onEmpty: onEmpty,
            onLoading: onLoading,
            ...rest
        },
        componentTag: componentTag
    }, "JDSImage", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3e431a229df88919 = $451487d20aa3eb8a$var$withLogic$1e($451487d20aa3eb8a$var$Component$1g);
$451487d20aa3eb8a$export$3e431a229df88919.displayName = "Image";
$451487d20aa3eb8a$export$3e431a229df88919.slotName = "jds_image";
const $451487d20aa3eb8a$var$sdl$1b = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-1.0.0",
        "name": "JDSInput",
        "layerName": "jds_input"
    },
    "hierarchy": {
        "input": []
    },
    "base": {
        "input": {
            "type": "text",
            "text-align": "{i_0}",
            "placeholder-color": "{i_1}",
            "placeholder-font-family": "{i_2}",
            "placeholder-font-size": "{i_3}",
            "placeholder-line-height": "{i_5}",
            "placeholder-font-weight": "{i_4}",
            "input-color": "{i_7}",
            "input-font-family": "{i_8}",
            "input-font-size": "{i_9}",
            "input-line-height": "{i_11}",
            "input-font-weight": "{i_10}",
            "cursor-color": "{i_13}",
            "disabled": false,
            "width": "{i_14}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "input": {
                    "opacity": "{i_15}",
                    "disabled": true
                }
            }
        },
        "type": {
            "email": {
                "input": {
                    "type": "email"
                }
            },
            "number": {
                "input": {
                    "type": "number"
                }
            },
            "password": {
                "input": {
                    "type": "password"
                }
            },
            "textarea": {
                "input": {
                    "type": "textarea"
                }
            },
            "pin": {
                "input": {
                    "type": "pin"
                }
            },
            "phone": {
                "input": {
                    "type": "phone"
                }
            }
        },
        "color": {
            "primary_80": {
                "input": {
                    "input-color": "{i_27}"
                }
            },
            "primary_70": {
                "input": {
                    "input-color": "{i_28}"
                }
            },
            "primary_60": {
                "input": {
                    "input-color": "{i_29}"
                }
            },
            "primary_50": {
                "input": {
                    "input-color": "{i_30}"
                }
            },
            "primary_40": {
                "input": {
                    "input-color": "{i_31}"
                }
            },
            "primary_30": {
                "input": {
                    "input-color": "{i_32}"
                }
            },
            "primary_20": {
                "input": {
                    "input-color": "{i_33}"
                }
            },
            "primary_inverse": {
                "input": {
                    "input-color": "{i_34}"
                }
            },
            "primary_background": {
                "input": {
                    "input-color": "{i_35}"
                }
            },
            "primary_grey_100": {
                "input": {
                    "input-color": "{i_36}"
                }
            },
            "primary_grey_80": {
                "input": {
                    "input-color": "{i_37}"
                }
            },
            "primary_grey_60": {
                "input": {
                    "input-color": "{i_38}"
                }
            },
            "primary_grey_40": {
                "input": {
                    "input-color": "{i_39}"
                }
            },
            "primary_grey_20": {
                "input": {
                    "input-color": "{i_40}"
                }
            },
            "secondary_80": {
                "input": {
                    "input-color": "{i_41}"
                }
            },
            "secondary_70": {
                "input": {
                    "input-color": "{i_42}"
                }
            },
            "secondary_60": {
                "input": {
                    "input-color": "{i_43}"
                }
            },
            "secondary_50": {
                "input": {
                    "input-color": "{i_44}"
                }
            },
            "secondary_40": {
                "input": {
                    "input-color": "{i_45}"
                }
            },
            "secondary_30": {
                "input": {
                    "input-color": "{i_46}"
                }
            },
            "secondary_20": {
                "input": {
                    "input-color": "{i_47}"
                }
            },
            "secondary_inverse": {
                "input": {
                    "input-color": "{i_48}"
                }
            },
            "secondary_background": {
                "input": {
                    "input-color": "{i_49}"
                }
            },
            "secondary_grey_100": {
                "input": {
                    "input-color": "{i_50}"
                }
            },
            "secondary_grey_80": {
                "input": {
                    "input-color": "{i_51}"
                }
            },
            "secondary_grey_60": {
                "input": {
                    "input-color": "{i_52}"
                }
            },
            "secondary_grey_40": {
                "input": {
                    "input-color": "{i_53}"
                }
            },
            "secondary_grey_20": {
                "input": {
                    "input-color": "{i_54}"
                }
            },
            "sparkle_80": {
                "input": {
                    "input-color": "{i_55}"
                }
            },
            "sparkle_70": {
                "input": {
                    "input-color": "{i_56}"
                }
            },
            "sparkle_60": {
                "input": {
                    "input-color": "{i_57}"
                }
            },
            "sparkle_50": {
                "input": {
                    "input-color": "{i_58}"
                }
            },
            "sparkle_40": {
                "input": {
                    "input-color": "{i_59}"
                }
            },
            "sparkle_30": {
                "input": {
                    "input-color": "{i_60}"
                }
            },
            "sparkle_20": {
                "input": {
                    "input-color": "{i_61}"
                }
            },
            "sparkle_inverse": {
                "input": {
                    "input-color": "{i_62}"
                }
            },
            "sparkle_background": {
                "input": {
                    "input-color": "{i_63}"
                }
            },
            "sparkle_grey_100": {
                "input": {
                    "input-color": "{i_64}"
                }
            },
            "sparkle_grey_80": {
                "input": {
                    "input-color": "{i_65}"
                }
            },
            "sparkle_grey_60": {
                "input": {
                    "input-color": "{i_66}"
                }
            },
            "sparkle_grey_40": {
                "input": {
                    "input-color": "{i_67}"
                }
            },
            "sparkle_grey_20": {
                "input": {
                    "input-color": "{i_68}"
                }
            },
            "feedback_error_80": {
                "input": {
                    "input-color": "{i_69}"
                }
            },
            "feedback_error_50": {
                "input": {
                    "input-color": "{i_70}"
                }
            },
            "feedback_error_20": {
                "input": {
                    "input-color": "{i_71}"
                }
            },
            "feedback_warning_80": {
                "input": {
                    "input-color": "{i_72}"
                }
            },
            "feedback_warning_50": {
                "input": {
                    "input-color": "{i_73}"
                }
            },
            "feedback_warning_20": {
                "input": {
                    "input-color": "{i_74}"
                }
            },
            "feedback_success_80": {
                "input": {
                    "input-color": "{i_75}"
                }
            },
            "feedback_success_50": {
                "input": {
                    "input-color": "{i_76}"
                }
            },
            "feedback_success_20": {
                "input": {
                    "input-color": "{i_77}"
                }
            },
            "white": {
                "input": {
                    "input-color": "{i_78}"
                }
            },
            "black": {
                "input": {
                    "input-color": "{i_79}"
                }
            },
            "transparent": {
                "input": {
                    "input-color": "{i_80}"
                }
            }
        },
        "textAlign": {
            "center": {
                "input": {
                    "text-align": "{i_16}"
                }
            },
            "end": {
                "input": {
                    "text-align": "{i_17}"
                }
            },
            "justify": {
                "input": {
                    "text-align": "{i_18}"
                }
            }
        },
        "textSize": {
            "large": {
                "input": {
                    "placeholder-font-family": "{i_19}",
                    "placeholder-font-size": "{i_20}",
                    "placeholder-line-height": "{i_21}",
                    "placeholder-font-weight": "{i_22}",
                    "input-font-family": "{i_23}",
                    "input-font-size": "{i_24}",
                    "input-line-height": "{i_25}",
                    "input-font-weight": "{i_26}"
                }
            }
        },
        "readOnly": {
            "true": {
                "container": {
                    "disabled": true
                },
                "input": {
                    "disabled": true
                }
            }
        }
    },
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Input."
            },
            "color": {
                "values": [
                    "primary_grey_100",
                    "primary_80",
                    "primary_70",
                    "primary_60",
                    "primary_50",
                    "primary_40",
                    "primary_30",
                    "primary_20",
                    "primary_inverse",
                    "primary_background",
                    "primary_grey_80",
                    "primary_grey_60",
                    "primary_grey_40",
                    "primary_grey_20",
                    "secondary_80",
                    "secondary_70",
                    "secondary_60",
                    "secondary_50",
                    "secondary_40",
                    "secondary_30",
                    "secondary_20",
                    "secondary_inverse",
                    "secondary_background",
                    "secondary_grey_100",
                    "secondary_grey_80",
                    "secondary_grey_60",
                    "secondary_grey_40",
                    "secondary_grey_20",
                    "sparkle_80",
                    "sparkle_70",
                    "sparkle_60",
                    "sparkle_50",
                    "sparkle_40",
                    "sparkle_30",
                    "sparkle_20",
                    "sparkle_inverse",
                    "sparkle_background",
                    "sparkle_grey_100",
                    "sparkle_grey_80",
                    "sparkle_grey_60",
                    "sparkle_grey_40",
                    "sparkle_grey_20",
                    "feedback_error_80",
                    "feedback_error_50",
                    "feedback_error_20",
                    "feedback_warning_80",
                    "feedback_warning_50",
                    "feedback_warning_20",
                    "feedback_success_80",
                    "feedback_success_50",
                    "feedback_success_20",
                    "white",
                    "black",
                    "transparent"
                ],
                "doc_description": "It can be used to add font-color to Input text."
            },
            "type": {
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "textarea",
                    "pin",
                    "phone"
                ],
                "doc_description": "This is used to specify the type of input."
            },
            "textAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "justify"
                ],
                "doc_description": "It can be used to align text of the Input."
            },
            "textSize": {
                "values": [
                    "small",
                    "large"
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "rows": {
                    "type": "number",
                    "name": "rows"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "min": {
                    "type": "number",
                    "name": "min"
                },
                "placeholder-letter-spacing": {
                    "type": "double",
                    "name": "letterSpacing",
                    "default": -0.5
                },
                "input-letter-spacing": {
                    "type": "double",
                    "name": "letterSpacing",
                    "default": -0.5
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "max": {
                    "type": "number",
                    "name": "max"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeyup": {
                    "name": "onKeyup",
                    "platform": "web"
                },
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "input": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-invalid": {
                        "name": "ariaInvalid"
                    },
                    "aria-placeholder": {
                        "name": "ariaPlaceholder",
                        "prop": "placeholder"
                    },
                    "aria-required": {
                        "name": "ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1d = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1f = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1b;
    const { disabled: disabled = false, color: color = "primary_grey_100", type: type = "text", textAlign: textAlign = "start", textSize: textSize = "small", readOnly: readOnly = false, onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onKeyup: onKeyup = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPaste: onPaste = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInvalid: onInvalid = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaPlaceholder: ariaPlaceholder = props.placeholder?.toString(), ariaRequired: ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            color: color,
            type: type,
            textAlign: textAlign,
            textSize: textSize,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onKeyup: onKeyup,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ariaPlaceholder: ariaPlaceholder,
            ariaRequired: ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInput", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$Input = $451487d20aa3eb8a$var$withLogic$1d($451487d20aa3eb8a$var$Component$1f);
$451487d20aa3eb8a$var$Input.displayName = "Input";
$451487d20aa3eb8a$var$Input.slotName = "jds_input";
const $451487d20aa3eb8a$var$sdl$1a = {
    "metadata": {
        "version": "1.0.0",
        "id": "checkbox-1.0.0",
        "name": "JDSCheckbox",
        "layerName": "jds_checkbox",
        "description": "Checkboxes are used within an interface to allow the user to select between one or more options."
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "control-container": [
                            "control-icon"
                        ]
                    },
                    "label-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "opacity": "{c_38}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{c_4}",
            "justify-content": "{c_5}",
            "align-items": "{c_6}",
            "gap": "{c_7}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "control-container": {
            "hidden": false,
            "min-width": "{c_8}",
            "min-height": "{c_9}",
            "flex-direction": "{c_10}",
            "justify-content": "{c_11}",
            "align-items": "{c_12}",
            "background-color": "{c_13}",
            "border-radius": "{c_14}",
            "border-width": "{c_15}",
            "border-color": "{c_16}",
            "show": true,
            "behavior": {
                "hover": {
                    "border-color": "{c_17}"
                },
                "active": {
                    "border-color": "{c_18}"
                },
                "focus": {
                    "border-width": "{c_19}",
                    "box-sizing": "content-box",
                    "border-color": "{c_20}"
                }
            }
        },
        "control-icon": {
            "hidden": true,
            "size": "{c_21}"
        },
        "jds_feedback_block": {
            "hidden": true,
            "state": "none",
            "size": "l"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "text-align": "{c_22}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "control-container": {
                    "min-width": "{c_23}",
                    "min-height": "{c_24}"
                },
                "vertical-container": {
                    "gap": "{c_25}"
                },
                "control-icon": {
                    "size": "{c_26}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "checked": {
            "true": {
                "control-container": {
                    "background-color": "{c_28}",
                    "border-width": 0,
                    "behavior": {
                        "hover": {
                            "background-color": "{c_29}"
                        },
                        "active": {
                            "background-color": "{c_30}"
                        }
                    }
                },
                "control-icon": {
                    "hidden": false,
                    "value": "{c_27}",
                    "color": "{c_31}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "indeterminate": {
            "true": {
                "control-container": {
                    "background-color": "{c_33}",
                    "border-width": 0,
                    "behavior": {
                        "hover": {
                            "background-color": "{c_34}"
                        },
                        "focus": {
                            "background-color": "{c_35}"
                        }
                    }
                },
                "control-icon": {
                    "hidden": false,
                    "value": "{c_32}",
                    "color": "{c_36}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "opacity": "{c_37}"
                },
                "horizontal-container": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to programmatically make input active/inactive."
            },
            "indeterminate": {
                "values": [
                    false,
                    true
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used control the size of Checkbox."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Checkbox."
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'."
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Checkbox."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Checkbox."
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "horizontal-container": {
                "properties": {
                    "role": {
                        "value": "checkbox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $451487d20aa3eb8a$var$checkInputMask(event, value, textMask, readonly, pattern) {
    if (readonly || !textMask) return "noop";
    if (!textMask && !pattern) return "noop";
    if ([
        "Tab",
        "Enter",
        "ArrowLeft",
        "ArrowRight"
    ].indexOf(event.key) > -1) return "noop";
    const prevValue = value || "";
    if (textMask && typeof prevValue === "string" || pattern) {
        if (event.code === "Backspace") return "back";
        const regex = textMask ? new RegExp($451487d20aa3eb8a$var$getTextMaskValue(textMask)) : pattern ? new RegExp(pattern) : void 0;
        if (!regex?.test(event.key) || textMask && (event.currentTarget.value?.length || 0) >= textMask.length) return "prevent";
    }
    return "noop";
}
const $451487d20aa3eb8a$var$maskCharToRegexMap = {
    "#": "\\d",
    "&": "[A-Za-z]",
    "*": "[A-Za-z\\d]"
};
const $451487d20aa3eb8a$var$getTextMask = (textMask)=>{
    if (!textMask) return void 0;
    if (typeof textMask === "string") return textMask;
    if (typeof textMask[0] === "object") return new RegExp(textMask[0]).source;
    return textMask[0];
};
const $451487d20aa3eb8a$var$getTextMaskValue = (textMask)=>{
    return textMask.split("").map((t)=>`(${$451487d20aa3eb8a$var$maskCharToRegexMap[t] || t})`).join("|");
};
const $451487d20aa3eb8a$var$stateValues = {
    error: {
        state: "error",
        stateText: "errorText"
    },
    success: {
        state: "success",
        stateText: "successText"
    },
    warning: {
        state: "warning",
        stateText: "warningText"
    },
    required: {
        state: "error",
        stateText: "requiredText"
    }
};
const $451487d20aa3eb8a$var$injectAutofillCSS = ()=>{
    const style = document.createElement("style");
    style.textContent = `
    input:-webkit-autofill {
      animation-name: autofill-start;
      animation-duration: 0.01s;
      animation-iteration-count: 1;
    }
    @keyframes autofill-start { from {} to {} }
  `;
    document.head.appendChild(style);
};
const $451487d20aa3eb8a$var$useFocusedLabel = (props, ref)=>{
    const [focused, setFocused] = (0, $1OEoy.useState)(false);
    const [inputFocused, setInputFocused] = (0, $1OEoy.useState)(false);
    const labelRef = ref?.querySelector(".j-JDSInputField-input_label-jds-text") || ref?.querySelector(".j-JDSTextarea-input_label-jds-text");
    (0, $1OEoy.useEffect)(()=>{
        $451487d20aa3eb8a$var$injectAutofillCSS();
        const input = ref?.querySelector("input");
        const onAutoFill = (e)=>{
            if (e.animationName === "autofill-start") {
                labelRef?.classList?.add("position-top");
                setFocused(true);
            }
        };
        input?.addEventListener("animationstart", onAutoFill);
        return ()=>input?.removeEventListener("animationstart", onAutoFill);
    }, [
        ref
    ]);
    (0, $1OEoy.useEffect)(()=>{
        if (props.placeholder || props.value) labelRef?.classList?.add("position-top");
    }, [
        props.placeholder,
        labelRef,
        props.value
    ]);
    return {
        onChange: (ev)=>{
            setFocused(true);
            labelRef?.classList.add("position-top");
            props.onChange?.(ev);
        },
        onBlur: (ev)=>{
            if (!(ev.target.value || props.placeholder)) {
                setFocused(false);
                labelRef?.classList.remove("position-top");
            }
            props.onBlur?.(ev);
            setInputFocused(false);
        },
        onFocus: (ev)=>{
            setFocused(true);
            setInputFocused(true);
            props.onFocus?.(ev);
            labelRef?.classList.add("position-top");
        },
        focused: Boolean(props.value) || Boolean(props.placeholder) || focused,
        _inputFocused: inputFocused
    };
};
const $451487d20aa3eb8a$var$useInputState = (state, required, onInvalid, stateConfig = {}, stateText)=>{
    const [inputState, setInputState] = (0, $1OEoy.useState)("none");
    (0, $1OEoy.useEffect)(()=>{
        if (!required) setInputState(state || "none");
    }, [
        state,
        required
    ]);
    const stateKey = $451487d20aa3eb8a$var$stateValues?.[inputState || "none"]?.state;
    const stateTextKey = $451487d20aa3eb8a$var$stateValues[inputState]?.stateText;
    return {
        onInvalid: (ev)=>{
            onInvalid?.(ev);
            if (required) setInputState("required");
            else setInputState("error");
        },
        inputState: state || stateKey,
        stateText: stateText || stateConfig?.[stateTextKey]
    };
};
const $451487d20aa3eb8a$var$getRequiredLabel = (label = "", required)=>{
    return label + (required ? " *" : "");
};
const $451487d20aa3eb8a$var$getIcon = (icon, onClick)=>{
    if (!icon) return void 0;
    if (typeof icon === "string") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon,
        color: "grey-80"
    });
    if (typeof icon === "object" && icon.component === "Icon") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        onClick: onClick,
        ...icon.props,
        color: "grey-80"
    });
    if (icon.type?.displayName) return (0, $1OEoy.cloneElement)(icon, {
        color: "grey-80"
    });
    if (icon.props?.ic) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon.props.ic,
        color: "grey-80",
        ...icon.props
    });
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        onClick: onClick,
        ic: icon,
        color: "grey-80"
    });
};
const $451487d20aa3eb8a$var$getPrefixWidth = (element)=>{
    const prefixContainer = element?.querySelector('div[data-testid="JDSInputField-prefix-container"]');
    const { width: width } = prefixContainer?.getBoundingClientRect() || {};
    return width || 0;
};
const $451487d20aa3eb8a$var$withLogic$1c = (Component)=>(0, $1OEoy.forwardRef)((props, ref)=>{
        const { rootRef: rootRef, element: element } = $451487d20aa3eb8a$var$useRootRef();
        const { focused: focused, _inputFocused: _inputFocused, ...rest } = $451487d20aa3eb8a$var$useFocusedLabel(props, element);
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $451487d20aa3eb8a$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig);
        const handlePrefixClick = (event)=>{
            props.onPrefixClick?.(event);
        };
        const handleSuffixClick = (event)=>{
            props.onSuffixClick?.(event);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                ...rest,
                rootRef: rootRef,
                prefix: $451487d20aa3eb8a$var$getIcon(props.prefix, handlePrefixClick),
                suffix: $451487d20aa3eb8a$var$getIcon(props.suffix, handleSuffixClick),
                onInvalid: onInvalid,
                _labelOffset: $451487d20aa3eb8a$var$getPrefixWidth(element) + 8,
                onKeydown: (ev)=>{
                    const allowedCharsForNumber = [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "0",
                        "e",
                        "-",
                        "+",
                        "."
                    ];
                    const allowedCharsForPhone = [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "0",
                        "(",
                        ")",
                        "-",
                        " ",
                        "+"
                    ];
                    if ([
                        "number",
                        "phone"
                    ].includes(props.type)) {
                        if ([
                            "Backspace",
                            "Enter",
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(ev.key)) return;
                        const allowedChars = props.type === "number" ? allowedCharsForNumber : allowedCharsForPhone;
                        !allowedChars.includes(ev.key) && ev.preventDefault();
                    }
                    if (props.pattern && typeof props.value === "string" || props.textMask) {
                        const action = $451487d20aa3eb8a$var$checkInputMask(ev, props.value, $451487d20aa3eb8a$var$getTextMask(props.textMask), props.readonly, props.pattern);
                        if (action === "prevent" || action === "back") {
                            ev.preventDefault();
                            if (action === "back") {
                                const currentValue = (ev.currentTarget.value || "")?.slice(0, -1);
                                const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                                tracker?.call(ev.target, currentValue);
                                const event = {
                                    ...ev,
                                    target: {
                                        ...ev.target,
                                        value: currentValue
                                    }
                                };
                                props.onChange?.(event);
                            }
                            return;
                        }
                    }
                    props.onKeyDown?.(ev);
                },
                label: $451487d20aa3eb8a$var$getRequiredLabel(props.label, props.required),
                _inputFocus: _inputFocused,
                state: inputState,
                stateText: props.stateText || stateText,
                _hasPrefix: Boolean(props.prefix),
                _hasSuffix: Boolean(props.suffix),
                _labelFocus: focused,
                layerRefs: {
                    input: ref
                }
            }
        });
    });
const $451487d20aa3eb8a$var$withLogic$1b = (Component)=>(props)=>{
        const { stateText: stateText, inputState: inputState } = $451487d20aa3eb8a$var$useInputState(props.state, false, void 0, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaChecked: props.indeterminate ? "mixed" : props.checked === true ? "true" : "false",
                _hasHelper: Boolean(props.helperText),
                state: inputState,
                stateText: stateText
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1e = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1a;
    const { checked: checked = false, indeterminate: indeterminate = false, size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            indeterminate: indeterminate,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCheckbox", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$fa1253a65a9e747d = $451487d20aa3eb8a$var$withLogic$1b($451487d20aa3eb8a$var$Component$1e);
$451487d20aa3eb8a$export$fa1253a65a9e747d.displayName = "InputCheckbox";
$451487d20aa3eb8a$export$fa1253a65a9e747d.slotName = "jds_checkbox";
const $451487d20aa3eb8a$var$sdl$19 = {
    "metadata": {
        "version": "1.0.0",
        "id": "Input-code-item-1.0.0",
        "name": "JDSInputCodeItem",
        "layerName": "jds_input_code_item",
        "internal": true
    },
    "hierarchy": {
        "input-container": [
            "jds_input",
            {
                "active-line-container": [
                    "feedback-container"
                ]
            }
        ]
    },
    "base": {
        "input-container": {
            "flex-direction": "{i_0}",
            "justify-content": "{i_1}",
            "align-items": "{i_2}",
            "gap": "{i_3}",
            "width": "{i_4}",
            "behavior": {
                "hover": {}
            }
        },
        "jds_input": {
            "width": "{i_5}",
            "type": "phone",
            "textAlign": "center",
            "textSize": "large",
            "maxLength": 1
        },
        "active-line-container": {
            "flex-direction": "{i_6}",
            "justify-content": "{i_7}",
            "align-items": "{i_8}",
            "width": "{i_9}",
            "padding-top": "{i_10}",
            "padding-bottom": "{i_11}"
        },
        "feedback-container": {
            "width": "{i_12}",
            "height": "{i_13}",
            "background-color": "{i_14}",
            "border-radius": "{i_15}",
            "show": true,
            "behavior": {
                "focus": {
                    "background-color": "{i_17}"
                },
                "active": {
                    "background-color": "{i_18}"
                }
            }
        }
    },
    "variant": {
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{i_19}"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{i_20}"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{i_21}"
                }
            }
        },
        "disabled": {
            "true": {
                "jds_input": {
                    "disabled": true
                }
            }
        },
        "secureText": {
            "true": {
                "jds_input": {
                    "type": "pin"
                }
            }
        },
        "autoComplete": {
            "true": {
                "jds_input": {
                    "autoComplete": "true"
                }
            }
        }
    },
    "combination": [
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{i_22}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "_inputFocus"
        ]
    ],
    "api": {
        "config": {
            "autoComplete": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            },
            "secureText": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                }
            }
        },
        "events": {
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$1a = (Component)=>(props)=>{
        const [inputFocus, setInputFocus] = (0, $1OEoy.useState)(false);
        const handleFocus = (0, $1OEoy.useCallback)((ev)=>{
            setInputFocus(true);
            if (props.onFocus) props.onFocus(ev);
        }, [
            props.onFocus
        ]);
        const handleBlur = (0, $1OEoy.useCallback)((ev)=>{
            setInputFocus(false);
            if (props.onBlur) props.onBlur(ev);
        }, [
            props.onBlur
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            _inputFocus: inputFocus,
            onFocus: handleFocus,
            onBlur: handleBlur
        });
    };
const $451487d20aa3eb8a$var$Component$1d = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$19;
    const { autoComplete: autoComplete = false, secureText: secureText = false, state: state = "undefined", disabled: disabled = false, onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPaste: onPaste = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInvalid: onInvalid = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            autoComplete: autoComplete,
            secureText: secureText,
            state: state,
            disabled: disabled,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputCodeItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$963da1aad44be4c4 = $451487d20aa3eb8a$var$withLogic$1a($451487d20aa3eb8a$var$Component$1d);
$451487d20aa3eb8a$export$963da1aad44be4c4.displayName = "InputCodeItem";
$451487d20aa3eb8a$export$963da1aad44be4c4.slotName = "jds_input_code_item";
const $451487d20aa3eb8a$var$sdl$18 = {
    "metadata": {
        "version": "1.0.0",
        "id": "input_phone_dropdown-1.0.0",
        "name": "JDSInputPhoneDropdown",
        "layerName": "jds_input_phone_dropdown"
    },
    "hierarchy": {
        "vertical-container": [
            {
                "container": [
                    {
                        "prefix-jds-icon-container": [
                            "prefix-jds-icon"
                        ]
                    },
                    "country_code-jds-text",
                    {
                        "chevron-jds-icon-container": [
                            "chevron-jds-icon"
                        ]
                    }
                ]
            },
            "jds_menu_block"
        ]
    },
    "base": {
        "vertical-container": {
            "flex-direction": "{flexDirection.column}"
        },
        "container": {
            "flex-direction": "{flexDirection.row}",
            "gap": "{xxs}"
        },
        "jds_menu_block": {
            "open": false
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primary50}"
        },
        "prefix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "country_code-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "chevron-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_down",
            "ic": "ic_chevron_down"
        },
        "chevron-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_down"
        }
    },
    "variant": {
        "open": {
            "true": {
                "jds_menu_block": {
                    "open": true
                },
                "chevron-jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "chevron-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true
                }
            }
        }
    },
    "combination": [],
    "combination_config": [],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "minWidth": {
                    "type": "size",
                    "name": "_minWidth"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "country_code-jds-text": {
                "value": {
                    "type": "string",
                    "name": "countryCode"
                },
                "color": {
                    "type": "JDSText.color",
                    "name": "countryCodeColor"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "countryFlag"
                },
                "ic": {
                    "type": "icon",
                    "name": "countryFlag"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onOpen",
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_menu_block": {
                "onSelect": {
                    "name": "onSelect",
                    "object": {
                        "index": "number",
                        "value": "string"
                    }
                },
                "onClose": "onClose"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "combobox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Select Country Code"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "open"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "value": "container"
                    }
                }
            },
            "jds_menu_block": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$setPositions = (anchorEl, menuBlockref, stringMaxHeight)=>{
    let menuItemPositionY = 0;
    let menuItemPositionX;
    let maxCalculatedHeight = 0;
    if (anchorEl && window) {
        const { y: anchorTop, height: anchorHeight, x: anchorLeft, width: anchorWidth } = anchorEl.getBoundingClientRect();
        const { innerWidth: overlayWidth, innerHeight: overlayHeight } = window;
        let maxHeight = parseInt(stringMaxHeight || "");
        maxHeight = isNaN(maxHeight) ? overlayHeight - anchorTop : maxHeight;
        const { scrollHeight: menuHeight, scrollWidth: menuWidth } = menuBlockref || {
            scrollWidth: 0,
            scrollHeight: maxHeight || 0
        };
        const sectionBelowAnchor = overlayHeight - (anchorTop + anchorHeight);
        const sectionAboveAnchor = anchorTop;
        if (menuBlockref && sectionBelowAnchor <= (maxHeight || menuHeight) && sectionAboveAnchor > sectionBelowAnchor) {
            menuItemPositionY = anchorTop - menuHeight;
            if (menuItemPositionY < 0) {
                maxCalculatedHeight = anchorTop;
                menuItemPositionY = maxHeight ? anchorTop - maxHeight : menuHeight < anchorTop ? anchorTop - menuHeight : 0;
            }
        } else {
            maxCalculatedHeight = sectionBelowAnchor;
            menuItemPositionY = anchorTop + anchorHeight;
        }
        const availableHeight = sectionBelowAnchor > 0 ? sectionBelowAnchor : overlayHeight - anchorTop;
        maxHeight = Math.min(maxHeight, availableHeight);
        const hasHitRight = overlayWidth <= anchorLeft + menuWidth;
        menuItemPositionX = hasHitRight ? Math.max(anchorLeft + anchorWidth - menuWidth, 0) : anchorLeft;
        return {
            left: menuItemPositionX || 0,
            top: menuItemPositionY || 0,
            width: anchorWidth,
            height: (maxHeight || maxCalculatedHeight) - 10 - 14,
            maxHeight: (maxHeight || maxCalculatedHeight) - 10,
            overflowY: "auto"
        };
    }
    return {
        left: 0,
        top: 0,
        maxWidth: "fit-content",
        height: (maxCalculatedHeight || menuBlockref?.getBoundingClientRect()?.height || 0) - 10
    };
};
const $451487d20aa3eb8a$var$withLogic$19 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const [position, setPosition] = (0, $1OEoy.useState)({
            left: 0,
            top: 0
        });
        const updatePosition = ()=>{
            const menuBlockEl = element?.querySelector("div.j-JDSMenuBlock-container");
            return $451487d20aa3eb8a$var$setPositions(element, menuBlockEl);
        };
        const { close: close, selected: selected, toggle: toggle } = $451487d20aa3eb8a$var$useToggle(props.open, true);
        (0, $1OEoy.useEffect)(()=>{
            if (element && selected) {
                const { left: left, top: top } = updatePosition();
                setPosition({
                    left: left,
                    top: top
                });
            }
        }, [
            element,
            selected
        ]);
        const [selectedItem, setSelectedItem] = (0, $1OEoy.useState)(props.items?.[props.selectedIndex || 0]);
        const handleOnSelect = (selectedIndex)=>{
            const selectedData = props.items?.[selectedIndex];
            toggle();
            setSelectedItem(selectedData);
            props.onSelect?.(selectedIndex, selectedData?.value);
        };
        $451487d20aa3eb8a$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _offsetX: position.left,
                _offsetY: position.top,
                _maxWidth: "fit-content",
                open: selected,
                items: props.items,
                countryCode: selectedItem?.label,
                countryFlag: selectedItem?.prefix,
                onSelect: handleOnSelect,
                onOpen: ()=>{
                    toggle();
                    props.onOpen?.();
                },
                onClose: ()=>{
                    close();
                    props.onClose?.();
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1c = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$18;
    const { open: open = false, disabled: disabled = false, onOpen: onOpen = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "Select Country Code", ariaControls: ariaControls = "container", _ariaExpanded: _ariaExpanded = props.open?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            disabled: disabled,
            onOpen: onOpen,
            onSelect: onSelect,
            onClose: onClose,
            ariaLabel: ariaLabel,
            ariaControls: ariaControls,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputPhoneDropdown", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$770f20817cf88abc = $451487d20aa3eb8a$var$withLogic$19($451487d20aa3eb8a$var$Component$1c);
$451487d20aa3eb8a$export$770f20817cf88abc.displayName = "InputPhoneDropdown";
$451487d20aa3eb8a$export$770f20817cf88abc.slotName = "jds_input_phone_dropdown";
const $451487d20aa3eb8a$var$sdl$17 = {
    "metadata": {
        "version": "1.0.0",
        "id": "list-block-1.0.0",
        "name": "JDSListBlock",
        "layerName": "jds_list_block",
        "description": "",
        "usage": ""
    },
    "hierarchy": {
        "root-container": [
            "top-slot",
            {
                "main-container": [
                    "prefix-slot",
                    {
                        "block-container": [
                            "title-jds-text",
                            {
                                "caption-container": [
                                    {
                                        "inner-caption-container": [
                                            "caption-block-text-slot",
                                            "caption-block-helper-slot"
                                        ]
                                    },
                                    "caption-block-value-slot"
                                ]
                            },
                            {
                                "title-container": [
                                    {
                                        "inner-title-container": [
                                            "title-block-text-slot",
                                            "title-block-helper-slot"
                                        ]
                                    },
                                    "title-block-value-slot"
                                ]
                            },
                            {
                                "helper-container": [
                                    {
                                        "inner-helper-container": [
                                            "helper-block-text-slot",
                                            "helper-block-helper-slot"
                                        ]
                                    },
                                    "helper-block-value-slot"
                                ]
                            }
                        ]
                    },
                    "suffix-slot"
                ]
            },
            "children-slot"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{l_0}",
            "width": "{l_1}",
            "justify-content": "{l_2}",
            "align-items": "{l_3}",
            "gap": "{l_4}",
            "padding-top": "{l_5}",
            "padding-bottom": "{l_6}"
        },
        "main-container": {
            "flex-direction": "{l_7}",
            "width": "{l_8}",
            "gap": "{l_9}",
            "justify-content": "{l_10}",
            "align-items": "{l_11}"
        },
        "block-container": {
            "flex-direction": "{l_12}",
            "flex": 1,
            "gap": "{l_13}",
            "justify-content": "{l_14}",
            "align-items": "{l_15}"
        },
        "caption-container": {
            "flex-direction": "{l_16}",
            "width": "{l_17}",
            "justify-content": "{l_18}",
            "align-items": "{l_19}",
            "gap": "{l_20}"
        },
        "inner-caption-container": {
            "flex-direction": "{l_21}",
            "justify-content": "{l_22}",
            "align-items": "{l_23}",
            "gap": "{l_24}"
        },
        "title-container": {
            "flex-direction": "{l_25}",
            "width": "{l_26}",
            "justify-content": "{l_27}",
            "align-items": "{l_28}",
            "gap": "{l_29}"
        },
        "inner-title-container": {
            "flex-direction": "{l_30}",
            "justify-content": "{l_31}",
            "align-items": "{l_32}",
            "gap": "{l_33}"
        },
        "helper-container": {
            "flex-direction": "{l_34}",
            "width": "{l_35}",
            "justify-content": "{l_36}",
            "align-items": "{l_37}",
            "gap": "{l_38}"
        },
        "inner-helper-container": {
            "flex-direction": "{l_39}",
            "justify-content": "{l_40}",
            "align-items": "{l_41}",
            "gap": "{l_42}"
        },
        "title-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        }
    },
    "variant": {
        "spacing": {
            "small": {
                "main-container": {
                    "gap": "{l_43}"
                },
                "root-container": {
                    "gap": "{l_44}"
                }
            }
        },
        "verticalAlignment": {
            "top": {
                "main-container": {
                    "align-items": "{l_45}"
                }
            }
        },
        "_isTitleVisible": {
            "true": {
                "caption-container": {
                    "hidden": true
                },
                "title-container": {
                    "hidden": true
                },
                "title-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "children": {
            "top-slot": {
                "name": "top",
                "accepts": [
                    "any"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_icon",
                    "jds_avatar",
                    "jds_image"
                ],
                "max": 1,
                "doc_description": "It can take 'icon', 'avtar', 'image' as prefix for Listblock."
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_icon",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1,
                "doc_description": "It can take 'icon', 'text', 'button', 'link' as suffix for Listblock."
            },
            "caption-block-text-slot": {
                "name": "captionBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "caption-block-helper-slot": {
                "name": "captionBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "caption-block-value-slot": {
                "name": "captionBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "title-block-text-slot": {
                "name": "titleBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "title-block-helper-slot": {
                "name": "titleBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "title-block-value-slot": {
                "name": "titleBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "helper-block-text-slot": {
                "name": "helperBlockText",
                "accepts": [
                    "jds_text"
                ],
                "max": 1
            },
            "helper-block-helper-slot": {
                "name": "helperBlockHelper",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "helper-block-value-slot": {
                "name": "helperBlockValue",
                "accepts": [
                    "jds_text",
                    "jds_badge",
                    "jds_tag"
                ],
                "max": 1
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "spacing": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "Adjusts the spacing between ListBlock contents"
            },
            "verticalAlignment": {
                "values": [
                    "middle",
                    "top"
                ],
                "doc_description": "Vertical alignment for Prefix and Suffix."
            },
            "_isTitleVisible": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick"
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacySpacing = [
    "m",
    "s"
];
const $451487d20aa3eb8a$var$PROP_MAP$i = (props)=>{
    if ($451487d20aa3eb8a$var$legacySpacing.includes(props.spacing)) console.warn("these values for the spacing prop are deprecated", $451487d20aa3eb8a$var$legacySpacing);
    return {
        captionBlock: {
            properties: {
                captionBlockText: $451487d20aa3eb8a$var$convertTextToComponent(props.captionBlock?.text),
                captionBlockHelper: $451487d20aa3eb8a$var$convertTextToComponent(props.captionBlock?.helper),
                captionBlockValue: $451487d20aa3eb8a$var$convertTextToComponent(props.captionBlock?.value)
            }
        },
        titleBlock: {
            properties: {
                titleBlockText: $451487d20aa3eb8a$var$convertTextToComponent(props.titleBlock?.text),
                titleBlockHelper: $451487d20aa3eb8a$var$convertTextToComponent(props.titleBlock?.helper),
                titleBlockValue: $451487d20aa3eb8a$var$convertTextToComponent(props.titleBlock?.value)
            }
        },
        helperBlock: {
            properties: {
                helperBlockText: $451487d20aa3eb8a$var$convertTextToComponent(props.helperBlock?.text),
                helperBlockHelper: $451487d20aa3eb8a$var$convertTextToComponent(props.helperBlock?.helper),
                helperBlockValue: $451487d20aa3eb8a$var$convertTextToComponent(props.helperBlock?.value)
            }
        },
        spacing: {
            properties: {
                spacing: props.spacing
            },
            defaultValue: "s",
            variations: {
                s: {
                    spacing: "small"
                },
                m: {
                    spacing: "medium"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$18 = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$i);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _isTitleVisible: !(props.titleBlock?.text || props.titleBlockText)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$1b = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$17;
    const { spacing: spacing = "medium", verticalAlignment: verticalAlignment = "middle", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            spacing: spacing,
            verticalAlignment: verticalAlignment,
            onClick: onClick,
            onPrefixClick: onPrefixClick,
            onSuffixClick: onSuffixClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSListBlock", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$7c8f337671b808e4 = $451487d20aa3eb8a$var$withLogic$18($451487d20aa3eb8a$var$Component$1b);
$451487d20aa3eb8a$export$7c8f337671b808e4.displayName = "ListBlock";
$451487d20aa3eb8a$export$7c8f337671b808e4.slotName = "jds_list_block";
const $451487d20aa3eb8a$var$sdl$16 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-1.0.0",
        "name": "JDSMegaMenu",
        "layerName": "jds_mega_menu",
        "platform": "web"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_megamenu_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 40,
            "hidden": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}"
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "popup-container": {
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                },
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "width": {
                    "type": "size",
                    "name": "width"
                }
            },
            "jds_megamenu_internal": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "heading": "string",
                        "subLinks": "list"
                    }
                },
                "items.heading": {
                    "type": "string",
                    "name": "items.heading"
                },
                "items.subLinks": {
                    "type": "list",
                    "name": "items.subLinks"
                }
            }
        },
        "events": {
            "jds_megamenu_internal": {
                "onHoverEnd": "onHoverEnd"
            }
        },
        "a11y": {
            "jds_megamenu_internal": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$17 = (Component)=>(props)=>{
        if (!props.open || !props.items?.length) return null;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$1a = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$16;
    const { open: open = false, onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMegaMenu", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$aee42d298194d478 = $451487d20aa3eb8a$var$withLogic$17($451487d20aa3eb8a$var$Component$1a);
$451487d20aa3eb8a$export$aee42d298194d478.displayName = "MegaMenu";
$451487d20aa3eb8a$export$aee42d298194d478.slotName = "jds_mega_menu";
const $451487d20aa3eb8a$var$sdl$15 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-block-1.0.0",
        "name": "JDSMegaMenuBlock",
        "layerName": "jds_mega_menu_block",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "heading-jds-text",
            {
                "links-container": [
                    "jds_mega_menu_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "gap": "{m_3}"
        },
        "links-container": {
            "flex-direction": "{m_4}",
            "justify-content": "{m_5}",
            "align-items": "{m_6}"
        },
        "heading-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-top": "{m_7}"
        }
    },
    "api": {
        "data": {
            "links-container": {
                "value": {
                    "name": "links",
                    "type": "list",
                    "object": {
                        "title": "string",
                        "href": "string"
                    }
                }
            },
            "jds_mega_menu_item": {
                "title": {
                    "type": "string",
                    "name": "links.title"
                },
                "href": {
                    "type": "string",
                    "name": "links.href"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            }
        },
        "a11y": {
            "links-container": {
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "name": "links",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_mega_menu_item": {
                "properties": {
                    "ariaLabel": "links.linkAriaLabel",
                    "ariaDescribedby": "links.linkAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$16 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$19 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$15;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSMegaMenuBlock", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$5e96c1cbae381c93 = $451487d20aa3eb8a$var$withLogic$16($451487d20aa3eb8a$var$Component$19);
$451487d20aa3eb8a$export$5e96c1cbae381c93.displayName = "MegaMenuBlock";
$451487d20aa3eb8a$export$5e96c1cbae381c93.slotName = "jds_mega_menu_block";
const $451487d20aa3eb8a$var$sdl$14 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-1.0.0",
        "name": "JDSMegaMenuInternal",
        "layerName": "jds_mega_menu_internal",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_mega_menu_block"
        ]
    },
    "base": {
        "container": {
            "width": "{m_1}",
            "flex-direction": "{m_2}",
            "justify-content": "{m_3}",
            "align-items": "{m_4}",
            "background-color": "{m_5}",
            "padding-top": "{m_6}",
            "padding-bottom": "{m_7}",
            "padding-right": "{m_8}",
            "padding-left": "{m_9}",
            "gap": "{m_10}"
        }
    },
    "variant": {},
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "heading": "string",
                        "subLinks": "list"
                    }
                }
            },
            "jds_mega_menu_block": {
                "title": {
                    "type": "string",
                    "name": "items.heading"
                },
                "links": {
                    "type": "list",
                    "name": "items.subLinks"
                }
            }
        },
        "events": {
            "container": {
                "onHoverEnd": "onHoverEnd"
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$15 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$18 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$14;
    const { open: open = false, onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMegaMenuInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$d7717d03c9caf572 = $451487d20aa3eb8a$var$withLogic$15($451487d20aa3eb8a$var$Component$18);
$451487d20aa3eb8a$export$d7717d03c9caf572.displayName = "MegaMenuInternal";
$451487d20aa3eb8a$export$d7717d03c9caf572.slotName = "jds_mega_menu_internal";
const $451487d20aa3eb8a$var$sdl$13 = {
    "metadata": {
        "version": "1.0.0",
        "id": "mega-menu-item-1.0.0",
        "name": "JDSMegaMenuItem",
        "layerName": "jds_mega_menu_item",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            "jds_link"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "padding-top": "{m_3}",
            "padding-bottom": "{m_4}"
        },
        "jds_link": {
            "kind": "submenu"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "href": {
                    "type": "string",
                    "name": "href"
                },
                "newTab": {
                    "type": "boolean",
                    "name": "newTab",
                    "platform": "web"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "string",
                    "name": "onClick"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$14 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$17 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$13;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSMegaMenuItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$cc2d7d7492914f14 = $451487d20aa3eb8a$var$withLogic$14($451487d20aa3eb8a$var$Component$17);
$451487d20aa3eb8a$export$cc2d7d7492914f14.displayName = "MegaMenuItem";
$451487d20aa3eb8a$export$cc2d7d7492914f14.slotName = "jds_mega_menu_item";
const $451487d20aa3eb8a$var$sdl$12 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-1.0.0",
        "name": "JDSMenuBlock",
        "layerName": "jds_menu_block"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_menu_block_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "background-color": "{global.transparent}",
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{flexDirection.stack}",
            "padding-bottom": "{m_3}",
            "max-height": "{m_9}"
        },
        "jds_menu_block_internal": {
            "hidden": false
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "passive": false
                },
                "jds_menu_block_internal": {
                    "open": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to open or close the modal programatically."
            }
        },
        "data": {
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX",
                    "function": true
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY",
                    "function": true
                }
            },
            "jds_menu_block_internal": {
                "maxHeight": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                },
                "maxWidth": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "minWidth": {
                    "type": "size",
                    "name": "minWidth",
                    "function": true
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "Used to programatically change current selected Index"
                },
                "items.type": {
                    "type": "string",
                    "name": "items.type"
                },
                "items.label": {
                    "type": "string",
                    "name": "items.label"
                },
                "items.value": {
                    "type": "string",
                    "name": "items.value"
                },
                "items.prefix": {
                    "type": "icon",
                    "name": "items.prefix"
                },
                "items.suffix": {
                    "type": "icon",
                    "name": "items.suffix"
                },
                "items.disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "items.selected": {
                    "type": "boolean",
                    "name": "items.selected"
                }
            }
        },
        "events": {
            "jds_menu_block_internal": {
                "onSelect": {
                    "name": "onSelect",
                    "doc_description": "onClick event that triggers upon click or tap of the chosen entry."
                },
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_menu_block_internal": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$useSelected = (selected)=>{
    const [selectedIndex, setSelectedIndex] = (0, $1OEoy.useState)(-1);
    (0, $1OEoy.useEffect)(()=>{
        if (typeof selected === "number") setSelectedIndex(selected);
    }, [
        selected
    ]);
    const updateIndex = (index)=>setSelectedIndex(index);
    return {
        index: selectedIndex,
        onClick: (index)=>{
            setSelectedIndex(index);
        },
        updateIndex: updateIndex
    };
};
const $451487d20aa3eb8a$var$MENUBLOCK_SELECTOR$1 = "div#container.j-jds-menu-block-container";
const $451487d20aa3eb8a$var$MENUBLOCKINTERNAL_SELECTOR$1 = "div.j-JDSMenuBlockInternal-container";
const $451487d20aa3eb8a$var$ANIMATION_DURATION$1 = 250;
const $451487d20aa3eb8a$var$withLogic$13 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const { index: index, onClick: onClick } = $451487d20aa3eb8a$var$useSelected(props.selectedIndex);
        const [shouldRender, setShouldRender] = (0, $1OEoy.useState)(props.open);
        const internalProps = props;
        const { items: items = props.items ?? [], anchorEl: anchorEl, open: open } = props;
        const menublockRef = element?.querySelector($451487d20aa3eb8a$var$MENUBLOCK_SELECTOR$1);
        $451487d20aa3eb8a$var$useEscapeClose(props.onClose, true);
        $451487d20aa3eb8a$var$useScrollClose(props.onClose);
        (0, $1OEoy.useEffect)(()=>{
            if (open) props.onOpen?.();
        }, [
            open
        ]);
        const { left: left, top: top, height: height, width: width } = $451487d20aa3eb8a$var$setPositions(anchorEl?.current, menublockRef, String(props.maxHeight));
        (0, $1OEoy.useEffect)(()=>{
            let timeout;
            if (props.open) {
                setShouldRender(true);
                props.onOpen?.();
            } else timeout = setTimeout(()=>{
                setShouldRender(false);
            }, $451487d20aa3eb8a$var$ANIMATION_DURATION$1);
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }, [
            props.open
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (shouldRender && props.open) {
                const menublockInternalRef = element?.querySelector($451487d20aa3eb8a$var$MENUBLOCKINTERNAL_SELECTOR$1);
                if (menublockInternalRef) menublockInternalRef.focus();
            } else anchorEl?.current?.focus();
        }, [
            shouldRender,
            props.open,
            element
        ]);
        if (!shouldRender) return null;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                selectedIndex: index,
                items: items,
                offsetX: internalProps.offsetX || left,
                maxHeight: !open ? 0 : props.maxHeight || height,
                offsetY: internalProps.offsetY || top,
                _hasIcon: items.some((i)=>Boolean(i.prefix)),
                onSelect: (index2)=>{
                    props.onSelect?.(index2, items?.[index2].value || "");
                    onClick?.(index2);
                    props.onClose?.();
                },
                onClick: (ev)=>{
                    ev.stopPropagation();
                    props.onClick?.(ev);
                },
                minWidth: internalProps.maxWidth || Math.max(width || 0, 250)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$16 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$12;
    const { open: open = false, onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onSelect: onSelect,
            onClick: onClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlock", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3a7690908a5e9b5 = $451487d20aa3eb8a$var$withLogic$13($451487d20aa3eb8a$var$Component$16);
$451487d20aa3eb8a$export$3a7690908a5e9b5.displayName = "MenuBlock";
$451487d20aa3eb8a$export$3a7690908a5e9b5.slotName = "jds_menu_block";
const $451487d20aa3eb8a$var$sdl$11 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-1.0.0",
        "name": "JDSMenuBlockInternal",
        "layerName": "jds_menu_block_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_menu_block_item"
        ]
    },
    "base": {
        "container": {
            "hidden": true,
            "width": "{intrinsicSize.max}",
            "lazy-scroll-android": false,
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "border-radius": "{medium}",
            "overflow": "auto",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "transition": {
                "property": [
                    "max-height"
                ],
                "duration": "{slow}",
                "timing-function": "{easeExit}"
            }
        },
        "jds_menu_block_item": {
            "width": "{size.max}"
        }
    },
    "variant": {
        "open": {
            "true": {
                "container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to open or close the modal programatically."
            }
        },
        "data": {
            "container": {
                "max-height": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                },
                "max-width": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "min-width": {
                    "type": "size",
                    "name": "minWidth",
                    "function": true
                },
                "value": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean",
                        "selected": "boolean"
                    }
                }
            },
            "jds_menu_block_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "Used to programatically change current selected Index"
                },
                "type": {
                    "type": "string",
                    "name": "items.type"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "value": {
                    "type": "string",
                    "name": "items.value"
                },
                "prefix": {
                    "type": "icon",
                    "name": "items.prefix"
                },
                "suffix": {
                    "type": "icon",
                    "name": "items.suffix"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "hasIcon": {
                    "type": "boolean",
                    "name": "_hasIcon"
                },
                "selected": {
                    "type": "boolean",
                    "name": "items.selected"
                }
            }
        },
        "events": {
            "jds_menu_block_item": {
                "onSelect": {
                    "name": "onSelect",
                    "doc_description": "onClick event that triggers upon click or tap of the chosen entry."
                }
            },
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "listbox"
                    },
                    "aria-label": {
                        "name": "_ariaLabel",
                        "value": "Choose an item"
                    }
                },
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_menu_block_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$MENUBLOCK_SELECTOR = "div#container.j-jds-menu-block-container";
const $451487d20aa3eb8a$var$MENUBLOCKINTERNAL_SELECTOR = "div.j-JDSMenuBlockInternal-container";
const $451487d20aa3eb8a$var$ANIMATION_DURATION = 250;
const $451487d20aa3eb8a$var$withLogic$12 = (Component)=>(props)=>{
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const { index: index, onClick: onClick } = $451487d20aa3eb8a$var$useSelected(props.selectedIndex);
        const internalProps = props;
        const { items: items = [], anchorEl: anchorEl, open: open } = props;
        const [shouldRender, setShouldRender] = (0, $1OEoy.useState)(props.open);
        const menublockRef = element?.querySelector($451487d20aa3eb8a$var$MENUBLOCK_SELECTOR);
        $451487d20aa3eb8a$var$useEscapeClose(props.onClose, true);
        $451487d20aa3eb8a$var$useScrollClose(props.onClose);
        (0, $1OEoy.useEffect)(()=>{
            if (open) props.onOpen?.();
        }, [
            open
        ]);
        const { left: left, top: top, height: height, width: width } = $451487d20aa3eb8a$var$setPositions(anchorEl?.current, menublockRef, String(props.maxHeight));
        (0, $1OEoy.useEffect)(()=>{
            let timeout;
            if (open) {
                setShouldRender(true);
                props.onOpen?.();
            } else timeout = setTimeout(()=>{
                setShouldRender(false);
            }, $451487d20aa3eb8a$var$ANIMATION_DURATION);
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }, [
            props.open
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (!shouldRender || !props.open) return;
            const timeout = setTimeout(()=>{
                const menublockInternalRef = document.querySelector($451487d20aa3eb8a$var$MENUBLOCKINTERNAL_SELECTOR);
                menublockInternalRef?.focus();
            }, $451487d20aa3eb8a$var$ANIMATION_DURATION);
            return ()=>clearTimeout(timeout);
        }, [
            shouldRender,
            props.open
        ]);
        if (!shouldRender) return null;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                open: open,
                rootRef: rootRef,
                selectedIndex: index,
                items: items,
                offsetX: internalProps.offsetX || left,
                maxHeight: !open ? 0 : props.maxHeight || height,
                offsetY: internalProps.offsetY || top,
                _hasIcon: items.some((i)=>Boolean(i.prefix)),
                onSelect: (index2)=>{
                    props.onSelect?.(index2, items?.[index2].value || "");
                    onClick?.(index2);
                    props.onClose?.();
                },
                onClick: (ev)=>{
                    ev.stopPropagation();
                    props.onClick?.(ev);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$15 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$11;
    const { open: open = false, onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), _ariaLabel: _ariaLabel = "Choose an item", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            onSelect: onSelect,
            onAppear: onAppear,
            onClick: onClick,
            _ariaLabel: _ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlockInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$f9b98c24bc73aa75 = $451487d20aa3eb8a$var$withLogic$12($451487d20aa3eb8a$var$Component$15);
$451487d20aa3eb8a$export$f9b98c24bc73aa75.displayName = "MenuBlockInternal";
$451487d20aa3eb8a$export$f9b98c24bc73aa75.slotName = "jds_menu_block_internal";
const $451487d20aa3eb8a$var$sdl$10 = {
    "metadata": {
        "version": "1.0.0",
        "id": "menu-block-item-1.0.0",
        "name": "JDSMenuBlockItem",
        "layerName": "jds_menu_block_item"
    },
    "hierarchy": {
        "container": [
            {
                "entry-container": [
                    {
                        "left-container": [
                            {
                                "prefix-jds-icon-container": [
                                    "prefix-jds-icon"
                                ]
                            },
                            "entry-jds-text"
                        ]
                    },
                    {
                        "suffix-jds-icon-container": [
                            "suffix-jds-icon"
                        ]
                    }
                ]
            },
            {
                "divider-container": [
                    "jds_divider"
                ]
            },
            {
                "heading-container": [
                    "heading-jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "opacity": "{m_0}",
            "background-color": "{m_1}",
            "width": "{m_2}"
        },
        "entry-container": {
            "hidden": false,
            "background-color": "{m_3}",
            "width": "{m_4}",
            "padding-top": "{m_5}",
            "padding-right": "{m_6}",
            "padding-bottom": "{m_7}",
            "padding-left": "{m_8}",
            "flex-direction": "{m_9}",
            "align-items": "{m_10}",
            "justify-content": "{m_11}",
            "border-width": 0,
            "border-color": "{m_12}",
            "border-radius": 0,
            "behavior": {
                "hover": {
                    "background-color": "{m_13}"
                },
                "focus": {
                    "border-width": 2,
                    "border-color": "{m_14}",
                    "border-radius": "{m_15}"
                }
            }
        },
        "divider-container": {
            "hidden": true,
            "width": "{m_16}"
        },
        "jds_divider": {
            "pad": "none",
            "orientation": "horizontal"
        },
        "heading-container": {
            "hidden": true,
            "padding-top": "{m_17}",
            "padding-right": "{m_18}",
            "padding-bottom": "{m_19}",
            "padding-left": "{m_20}",
            "width": "{m_21}",
            "align-items": "{m_22}",
            "justify-content": "{m_23}"
        },
        "left-container": {
            "gap": "{m_24}",
            "flex-direction": "{m_25}",
            "align-items": "{m_26}"
        },
        "prefix-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "hidden": true
        },
        "prefix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "hidden": true
        },
        "entry-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "suffix-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "suffix-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "heading-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "type": {
            "divider": {
                "entry-container": {
                    "hidden": true
                },
                "divider-container": {
                    "hidden": false
                }
            },
            "heading": {
                "entry-container": {
                    "hidden": true
                },
                "heading-container": {
                    "hidden": false
                }
            }
        },
        "selected": {
            "true": {
                "container": {
                    "background-color": "{m_27}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{m_28}"
                }
            }
        },
        "hasIcon": {
            "true": {
                "heading-container": {
                    "padding-left": "{m_29}"
                },
                "prefix-jds-icon": {
                    "hidden": false
                },
                "prefix-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "type": {
                "values": [
                    "entry",
                    "divider",
                    "heading"
                ]
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "hasIcon": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "_item.value": {
                    "type": "string",
                    "name": "value"
                }
            },
            "entry-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "prefix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "suffix-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "suffix"
                },
                "ic": {
                    "type": "icon",
                    "name": "suffix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "entry-container": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "option"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected",
                        "prop": "selected"
                    },
                    "aria-hidden": {
                        "name": "_ariaHidden",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$11 = (Component)=>(props)=>{
        const internalProps = props;
        const selected = internalProps.internalIndex === props.selectedIndex;
        const handleSelect = ()=>{
            props.onSelect?.(internalProps.internalIndex);
        };
        const handleKeyDown = (event)=>{
            if (event.key === "Enter" && internalProps.internalIndex === props.selectedIndex) handleSelect();
        };
        const handleClick = ()=>{
            handleSelect();
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                selected: selected,
                ariaLabel: props.type === "heading" ? props.ariaLabel || `${props.label} heading` : props.ariaLabel,
                _ariaHidden: props.type === "divider" ? "true" : void 0,
                _ariaSelected: props.type === "entry" ? selected : void 0,
                _hasIcon: internalProps._hasIcon || Boolean(props.prefix),
                onSelect: !props.type || props.type === "entry" ? handleSelect : void 0,
                prefix: props.prefix || (internalProps._hasIcon ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {}) : void 0)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$14 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$10;
    const { type: type = "entry", selected: selected = false, disabled: disabled = false, hasIcon: hasIcon = false, onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaSelected: _ariaSelected = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            selected: selected,
            disabled: disabled,
            hasIcon: hasIcon,
            onSelect: onSelect,
            ariaLabel: ariaLabel,
            _ariaSelected: _ariaSelected,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMenuBlockItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3789e0cd450be8da = $451487d20aa3eb8a$var$withLogic$11($451487d20aa3eb8a$var$Component$14);
$451487d20aa3eb8a$export$3789e0cd450be8da.displayName = "MenuBlockItem";
$451487d20aa3eb8a$export$3789e0cd450be8da.slotName = "jds_menu_block_item";
const $451487d20aa3eb8a$var$sdl$$ = {
    "metadata": {
        "version": "1.0.0",
        "id": "mobile-bottom-sheet-1.0.0",
        "name": "JDSMobileBottomSheetInternal",
        "layerName": "jds_mobile_bottom_sheet_internal",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "root-container": [
                    {
                        "cancel-container": [
                            {
                                "back-container": [
                                    "back-jds_action_button"
                                ]
                            },
                            "empty-container",
                            "step-jds-text",
                            "cancel-jds_button"
                        ]
                    },
                    {
                        "vertical-container": [
                            "title-jds-text",
                            "description-jds-text",
                            "children-slot",
                            {
                                "cta-container": [
                                    "primary-jds_action_button",
                                    "secondary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "width": "{m_3}"
        },
        "root-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_4}",
            "justify-content": "{m_5}",
            "background-color": "{m_6}",
            "align-items": "{m_7}",
            "border-top-left-radius": "{m_8}",
            "border-top-right-radius": "{m_9}",
            "width": "{m_10}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "translate-y": "{m_11}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{m_12}",
                "timing-function": "{m_13}"
            }
        },
        "cancel-container": {
            "hidden": false,
            "flex-direction": "{m_14}",
            "justify-content": "{m_15}",
            "align-items": "{m_16}",
            "width": "{m_17}",
            "padding-top": "{m_18}",
            "padding-bottom": "{m_19}",
            "padding-left": "{m_20}",
            "padding-right": "{m_21}",
            "gap": "{m_22}"
        },
        "back-container": {
            "flex": "{m_23}",
            "hidden": true
        },
        "back-jds_action_button": {
            "padding-top": "{xs}",
            "icon": "ic_back",
            "size": "medium",
            "kind": "tertiary"
        },
        "empty-container": {
            "flex": "{m_24}"
        },
        "cancel-jds_button": {
            "padding-top": "{xs}",
            "hidden": false,
            "icon": "ic_close",
            "size": "large",
            "kind": "tertiary"
        },
        "vertical-container": {
            "flex-direction": "{m_26}",
            "justify-content": "{m_27}",
            "align-items": "{m_28}",
            "padding-left": "{m_29}",
            "padding-right": "{m_30}",
            "width": "{m_31}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "appearance": "normal",
            "state": "normal",
            "stretch": true
        },
        "cta-container": {
            "flex-direction": "{m_34}",
            "gap": "{m_35}",
            "width": "{m_36}",
            "padding-bottom": "{m_37}",
            "padding-top": "{m_38}"
        },
        "children-slot": {
            "flex-fill-android": false
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_39}",
            "justify-content": "{m_40}",
            "align-items": "{m_41}",
            "background-color": "{m_42}",
            "border-top-left-radius": "{m_43}",
            "border-top-right-radius": "{m_44}",
            "padding-left": "{m_45}",
            "padding-right": "{m_46}",
            "padding-top": "{m_47}",
            "padding-bottom": "{m_48}",
            "width": "{m_49}",
            "translate-y": "{m_50}",
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{m_51}",
                "timing-function": "{m_52}"
            }
        },
        "step-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "padding-right": "{m_25}"
        },
        "title-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "padding-bottom": "{xs}",
            "maxLines": 2
        },
        "description-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-bottom": "{m_33}"
        }
    },
    "variant": {
        "kind": {
            "passive": {
                "root-container": {
                    "box-shadow": {
                        "x": "{m_53}",
                        "y": "{m_54}",
                        "blur": "{m_55}",
                        "spread": "{m_56}",
                        "color": "{m_57}"
                    }
                }
            }
        },
        "close": {
            "false": {
                "root-container": {
                    "translate-y": "{m_58}",
                    "hidden": false
                }
            }
        },
        "buttonOrientation": {
            "horizontal": {
                "cta-container": {
                    "flex-direction": "{flexDirection.row}"
                }
            }
        },
        "controlType": {
            "stepper": {
                "cancel-jds_button": {
                    "hidden": true
                },
                "back-container": {
                    "hidden": false
                },
                "step-jds-text": {
                    "hidden": false
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_noButton": {
            "true": {
                "root-container": {
                    "padding-bottom": "{m_59}"
                },
                "cta-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "true": {
                    "custom-container": {
                        "hidden": false,
                        "translate-y": "{m_60}"
                    },
                    "root-container": {
                        "hidden": true,
                        "translate-y": "{m_61}"
                    },
                    "vertical-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "close",
            "isCustom"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "overlay",
                    "passive"
                ]
            },
            "controlType": {
                "values": [
                    "normal",
                    "stepper"
                ]
            },
            "buttonOrientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ]
            },
            "isCustom": {
                "values": [
                    false,
                    true
                ]
            },
            "close": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_noButton": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "max-height": {
                    "type": "size",
                    "name": "maxHeight",
                    "function": true
                }
            },
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "step-jds-text": {
                "value": {
                    "type": "string",
                    "name": "stepLabel"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "root-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "custom-container": {
                "onClick": "onBottomSheetClick",
                "onSwipeDown": "onClose"
            },
            "back-jds_action_button": {
                "onClick": "onBack"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Bottom Sheet Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "back-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Tap to go back"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$10 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaModal: props.kind === "overlay" || !props.close ? "true" : "false"
            }
        });
    };
const $451487d20aa3eb8a$var$Component$13 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$$;
    const { kind: kind = "overlay", controlType: controlType = "normal", buttonOrientation: buttonOrientation = "vertical", isCustom: isCustom = false, close: close = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBottomSheetClick: onBottomSheetClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBack: onBack = (0, $ddff9b86434e3f59$export$8793edee2d425525), onCancel: onCancel = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "Bottom Sheet Content", cancelButtonAriaLabel: cancelButtonAriaLabel = "Close Modal", backButtonAriaLabel: backButtonAriaLabel = "Tap to go back", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            controlType: controlType,
            buttonOrientation: buttonOrientation,
            isCustom: isCustom,
            close: close,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onAppear: onAppear,
            onBottomSheetClick: onBottomSheetClick,
            onClose: onClose,
            onBack: onBack,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonAriaLabel: cancelButtonAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSMobileBottomSheetInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$9ac5eac5233c654 = $451487d20aa3eb8a$var$withLogic$10($451487d20aa3eb8a$var$Component$13);
$451487d20aa3eb8a$export$9ac5eac5233c654.displayName = "MobileBottomSheetInternal";
$451487d20aa3eb8a$export$9ac5eac5233c654.slotName = "jds_mobile_bottom_sheet_internal";
const $451487d20aa3eb8a$var$sdl$_ = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-desktop-1.0.0",
        "name": "JDSModalDesktop",
        "layerName": "jds_modal_desktop",
        "platform": "web",
        "description": "Modals focus the user\u2019s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.",
        "usage": "A dialog modal uses two buttons and requires immediate user response."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_modal_desktop_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "full-width": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_3}",
            "align-items": "{m_4}",
            "size": "{m_5}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{opacity.invisible}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{medium}",
                "timing-function": "{easeEntrance}"
            }
        },
        "jds_modal_desktop_internal": {
            "kind": "dialog",
            "headerAlignment": "left",
            "isCloseable": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "jds_modal_desktop_internal": {
                    "kind": "acknowledgement"
                }
            },
            "informational": {
                "jds_modal_desktop_internal": {
                    "kind": "informational"
                }
            },
            "custom": {
                "jds_modal_desktop_internal": {
                    "kind": "custom"
                }
            }
        },
        "headerAlignment": {
            "right": {
                "jds_modal_desktop_internal": {
                    "headerAlignment": "right"
                }
            },
            "center": {
                "jds_modal_desktop_internal": {
                    "headerAlignment": "center"
                }
            }
        },
        "size": {
            "small": {
                "jds_modal_desktop_internal": {
                    "size": "small"
                }
            }
        },
        "close": {
            "false": {
                "popup": {
                    "hidden": false,
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{opacity.enabled}",
                    "transition": {
                        "timing-function": "{easeExit}"
                    }
                }
            }
        },
        "isCloseable": {
            "false": {
                "jds_modal_desktop_internal": {
                    "isCloseable": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "close": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It is used to close the Modal."
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet"
                ]
            }
        },
        "data": {
            "jds_modal_desktop_internal": {
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                },
                "primaryCtaDisabled": {
                    "type": "boolean",
                    "name": "primaryCtaDisabled"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                },
                "secondaryCtaDisabled": {
                    "type": "boolean",
                    "name": "secondaryCtaDisabled"
                },
                "children": {
                    "name": "children",
                    "type": "slot",
                    "doc_description": "This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_modal_desktop_internal": {
                "onModalClick": "_onModalClick",
                "onCancel": "_onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_modal_desktop_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonCtaAriaLabel": "cancelButtonCtaAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$sdl$Z = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-mobile-1.0.0",
        "name": "JDSModalMobile",
        "layerName": "jds_modal_mobile"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_modal_mobile_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 60,
            "full-width": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}",
            "enter-animation-name": "fadeIn",
            "exit-animation-name": "fadeOut",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "opacity": "{m_4}",
            "transition": {
                "property": [
                    "opacity"
                ],
                "duration": "{m_5}",
                "timing-function": "{m_6}"
            }
        },
        "jds_modal_mobile_internal": {
            "kind": "dialog",
            "headerAlignment": "left",
            "isCloseable": true,
            "size": "medium"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "jds_modal_mobile_internal": {
                    "kind": "acknowledgement"
                }
            },
            "informational": {
                "jds_modal_mobile_internal": {
                    "kind": "informational"
                }
            },
            "custom": {
                "jds_modal_mobile_internal": {
                    "kind": "custom"
                }
            }
        },
        "headerAlignment": {
            "right": {
                "jds_modal_mobile_internal": {
                    "headerAlignment": "right"
                }
            },
            "center": {
                "jds_modal_mobile_internal": {
                    "headerAlignment": "center"
                }
            }
        },
        "size": {
            "small": {
                "jds_modal_mobile_internal": {
                    "size": "small"
                }
            }
        },
        "close": {
            "false": {
                "popup": {
                    "hidden": false,
                    "passive": false
                },
                "popup-container": {
                    "opacity": "{m_7}",
                    "transition": {
                        "timing-function": "{m_8}"
                    }
                }
            }
        },
        "isCloseable": {
            "false": {
                "jds_modal_mobile_internal": {
                    "isCloseable": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "close": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It is used to close the Modal."
            },
            "disableOutsideClick": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It determines whether modal should close and the onClose event should be triggered when clicking outside modal.",
                "function": true
            }
        },
        "data": {
            "jds_modal_mobile_internal": {
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                },
                "primaryCtaDisabled": {
                    "type": "boolean",
                    "name": "primaryCtaDisabled"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                },
                "secondaryCtaDisabled": {
                    "type": "boolean",
                    "name": "secondaryCtaDisabled"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            }
        },
        "events": {
            "popup": {
                "onClick": "onClose"
            },
            "jds_modal_mobile_internal": {
                "onModalClick": "_onModalClick",
                "onCancel": "_onCancel",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_modal_mobile_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "cancelButtonCtaAriaLabel": "cancelButtonCtaAriaLabel",
                    "headerAriaLabel": "headerAriaLabel",
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$legacySizes$1 = [
    "s",
    "m"
];
const $451487d20aa3eb8a$var$PROP_MAP$h = (props)=>{
    if ($451487d20aa3eb8a$var$legacySizes$1.includes(props.size)) console.warn("these values for the size prop are deprecated");
    if (typeof props.header === "object") console.warn("passing listblock to the header is deprecated. Please pass a string");
    return {
        onCloseCallback: {
            properties: {
                onClose: props.onCloseCallback,
                onCloseCallback: props.onCloseCallback
            }
        },
        primaryCTA: {
            properties: {
                primaryCTA: props.primaryCTA?.title || props.primaryCTA,
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: props.secondaryCTA?.title || props.secondaryCTA,
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        },
        isClosable: {
            properties: {
                isCloseable: typeof props.isCloseable === "undefined" ? props.isClosable : props.isCloseable
            }
        },
        size: {
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                }
            }
        },
        children: {
            properties: {
                children: $451487d20aa3eb8a$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $451487d20aa3eb8a$var$MODAL_SELECTOR$1 = "div.j-JDSModalMobileInternal-root-container";
const $451487d20aa3eb8a$var$withLogic$$ = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$h);
        const { onRequestClose: onRequestClose, onCloseCallback: onCloseCallback, kind: kind, isClosable: isClosable, close: userCloseProp, closed: closed, ...rest } = props;
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const modalRef = element?.querySelector($451487d20aa3eb8a$var$MODAL_SELECTOR$1);
        const closeProp = typeof userCloseProp === "undefined" ? closed : userCloseProp;
        const allowClose = !onRequestClose || onRequestClose();
        const close = ()=>{
            if (allowClose) {
                onCloseCallback?.();
                rest.onClose?.();
            }
        };
        $451487d20aa3eb8a$var$useEscapeClose(close, kind === "informational");
        const handleClose = ()=>{
            if (kind === "informational") close();
        };
        (0, $1OEoy.useEffect)(()=>{
            if (!closeProp && modalRef) modalRef.focus();
        }, [
            closeProp
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                kind: kind,
                rootRef: rootRef,
                _onModalClick: (ev)=>ev.stopPropagation(),
                close: closeProp,
                _onCancel: close,
                onClose: handleClose,
                isCloseable: isClosable || props.isCloseable
            }
        });
    };
const $451487d20aa3eb8a$var$Component$12 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$Z;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, close: close = true, disableOutsideClick: disableOutsideClick = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            close: close,
            disableOutsideClick: disableOutsideClick,
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalMobile", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$Modal$1 = $451487d20aa3eb8a$var$withLogic$$($451487d20aa3eb8a$var$Component$12);
$451487d20aa3eb8a$var$Modal$1.displayName = "Modal";
$451487d20aa3eb8a$var$Modal$1.slotName = "jds_modal_mobile";
const $451487d20aa3eb8a$var$legacySizes = [
    "s",
    "m"
];
const $451487d20aa3eb8a$var$PROP_MAP$g = (props)=>{
    if ($451487d20aa3eb8a$var$legacySizes.includes(props.size)) console.warn("these values for the size prop are deprecated");
    if (typeof props.header === "object") console.warn("passing listblock to the header is deprecated. Please pass a string");
    return {
        onCloseCallback: {
            properties: {
                onClose: props.onCloseCallback,
                onCloseCallback: props.onCloseCallback
            }
        },
        onClose: {
            properties: {
                onCloseCallback: props.onClose
            }
        },
        primaryCTA: {
            properties: {
                primaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick || props.onPrimaryClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onSecondaryClick: props.secondaryCTA?.onClick || props.onSecondaryClick
            }
        },
        isClosable: {
            properties: {
                isCloseable: typeof props.isCloseable === "undefined" ? props.isClosable : props.isCloseable
            }
        },
        size: {
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                }
            }
        },
        children: {
            properties: {
                children: $451487d20aa3eb8a$var$convertTextToComponent(props.children)
            }
        }
    };
};
const $451487d20aa3eb8a$var$MODAL_SELECTOR = "div.j-JDSModalDesktopInternal-root-container";
const $451487d20aa3eb8a$var$withLogic$_ = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$g);
        const { onRequestClose: onRequestClose, onCloseCallback: onCloseCallback, kind: kind = "dialog", isClosable: isClosable, close: userCloseProp, closed: closed, ...rest } = props;
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const modalRef = element?.querySelector($451487d20aa3eb8a$var$MODAL_SELECTOR);
        const closeProp = typeof userCloseProp === "undefined" ? closed : userCloseProp;
        const { mobile: mobile } = $451487d20aa3eb8a$var$Devices.useMedia();
        const allowClose = !onRequestClose || onRequestClose();
        const close = ()=>{
            if (allowClose) {
                onCloseCallback?.();
                rest?.onClose?.();
            }
        };
        $451487d20aa3eb8a$var$useEscapeClose(close, kind === "informational");
        const handleClose = ()=>{
            if (kind === "informational") close();
        };
        (0, $1OEoy.useEffect)(()=>{
            if (!closeProp && modalRef) modalRef.focus();
            if (!closeProp) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
            return ()=>{
                document.body.style.overflow = "";
            };
        }, [
            closeProp
        ]);
        if (mobile) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$Modal$1, {
            ...userProps
        });
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                kind: kind,
                rootRef: rootRef,
                _onModalClick: (ev)=>ev.stopPropagation(),
                close: closeProp,
                _onCancel: close,
                onClose: handleClose
            }
        });
    };
const $451487d20aa3eb8a$var$Component$11 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$_;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, close: close = true, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            close: close,
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalDesktop", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2b77a92f1a5ad772 = $451487d20aa3eb8a$var$withLogic$_($451487d20aa3eb8a$var$Component$11);
$451487d20aa3eb8a$export$2b77a92f1a5ad772.displayName = "Modal";
$451487d20aa3eb8a$export$2b77a92f1a5ad772.slotName = "jds_modal_desktop";
const $451487d20aa3eb8a$var$sdl$Y = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-desktop-1.0.0",
        "name": "JDSModalDesktopInternal",
        "layerName": "jds_modal_desktop_internal",
        "platform": "web",
        "description": "Modals focus the user\u2019s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.",
        "usage": "A dialog modal uses two buttons and requires immediate user response."
    },
    "hierarchy": {
        "container": [
            "overlay-container",
            {
                "root-container": [
                    {
                        "cancel-container": [
                            "cancel-jds_button"
                        ]
                    },
                    {
                        "vertical-container": [
                            {
                                "header-container": [
                                    "header-jds-text"
                                ]
                            },
                            {
                                "children-container": [
                                    "children-slot"
                                ]
                            },
                            {
                                "button-container": [
                                    "secondary-jds_action_button",
                                    "primary-jds_action_button"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "custom-container": [
                    "children-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}"
        },
        "overlay-container": {
            "show": true,
            "size": "{m_7}",
            "background-color": "{m_8}",
            "opacity": "{m_9}"
        },
        "root-container": {
            "z-index": 1,
            "flex-direction": "{m_10}",
            "justify-content": "{m_11}",
            "align-items": "{m_12}",
            "border-radius": "{m_13}",
            "background-color": "{m_14}",
            "width": "{m_15}",
            "max-height": "{m_16}"
        },
        "cancel-container": {
            "flex-direction": "{m_17}",
            "justify-content": "{m_18}",
            "align-items": "{m_19}",
            "width": "{m_20}",
            "padding-top": "{m_21}",
            "padding-bottom": "{m_22}",
            "padding-left": "{m_23}",
            "padding-right": "{m_24}",
            "hidden": false
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "medium"
        },
        "vertical-container": {
            "flex-direction": "{m_25}",
            "justify-content": "{m_26}",
            "align-items": "{m_27}",
            "padding-left": "{m_28}",
            "padding-right": "{m_29}",
            "padding-bottom": "{m_30}",
            "width": "{m_31}",
            "overflow": "{m_32}"
        },
        "header-container": {
            "flex-direction": "{m_34}",
            "justify-content": "{m_35}",
            "align-items": "{m_36}",
            "width": "{m_37}",
            "padding-bottom": "{m_38}"
        },
        "children-container": {
            "width": "{m_39}",
            "overflow": "{m_40}"
        },
        "button-container": {
            "width": "{m_41}",
            "justify-content": "{m_42}",
            "align-items": "{m_43}",
            "flex-direction": "{m_44}",
            "gap": "{m_45}",
            "padding-top": "{m_46}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "stretch": false
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "stretch": false
        },
        "custom-container": {
            "hidden": true,
            "z-index": 1,
            "flex-direction": "{m_47}",
            "justify-content": "{m_48}",
            "align-items": "{m_49}",
            "border-radius": "{m_50}",
            "background-color": "{elevation1}",
            "padding-left": "{m_52}",
            "padding-right": "{m_53}",
            "padding-top": "{m_54}",
            "padding-bottom": "{m_55}",
            "max-width": "{m_56}",
            "max-height": "{m_57}",
            "overflow": "{m_33}"
        },
        "header-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "primary-jds_action_button": {
                    "stretch": true
                },
                "secondary-jds_action_button": {
                    "hidden": true
                }
            },
            "informational": {
                "button-container": {
                    "hidden": true
                }
            },
            "custom": {
                "custom-container": {
                    "hidden": false
                },
                "root-container": {
                    "hidden": true
                }
            }
        },
        "headerAlignment": {
            "right": {
                "header-container": {
                    "justify-content": "{m_58}"
                }
            },
            "center": {
                "header-container": {
                    "justify-content": "{m_59}"
                }
            }
        },
        "size": {
            "small": {
                "vertical-container": {
                    "padding-left": "{m_60}",
                    "padding-right": "{m_61}",
                    "padding-bottom": "{m_62}"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_hasCta": {
            "false": {
                "button-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "dialog": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_63}"
                    }
                }
            },
            "acknowledgement": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_64}"
                    }
                }
            }
        },
        {
            "medium": {
                "desktop": {
                    "root-container": {
                        "width": "584"
                    }
                },
                "tablet": {
                    "root-container": {
                        "width": "464"
                    }
                }
            },
            "small": {
                "desktop": {
                    "root-container": {
                        "width": "412"
                    }
                },
                "tablet": {
                    "root-container": {
                        "width": "412"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "isCloseable"
        ],
        [
            "size",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ],
                "doc_description": "It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control the size of popup container."
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ],
                "doc_description": "It is used to align header of Modal."
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "It can be used to makes Modal closeable, displays close icon button on popup."
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet"
                ]
            },
            "_hasCta": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Modal."
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Modal."
                }
            },
            "header-jds-text": {
                "value": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It displays the title of modal."
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`"
            }
        },
        "events": {
            "root-container": {
                "onClick": "onModalClick"
            },
            "custom-container": {
                "onClick": "onModalClick"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Modal Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal",
                        "value": "true"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonCtaAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$Z = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$10 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$Y;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onModalClick: onModalClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onCancel: onCancel = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "Modal Content", cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel = "Close Modal", _ariaModal: _ariaModal = "true", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onModalClick: onModalClick,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel,
            _ariaModal: _ariaModal,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalDesktopInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3e0ada2dd34546e6 = $451487d20aa3eb8a$var$withLogic$Z($451487d20aa3eb8a$var$Component$10);
$451487d20aa3eb8a$export$3e0ada2dd34546e6.displayName = "ModalDesktopInternal";
$451487d20aa3eb8a$export$3e0ada2dd34546e6.slotName = "jds_modal_desktop_internal";
const $451487d20aa3eb8a$var$sdl$X = {
    "metadata": {
        "version": "1.0.0",
        "id": "modal-mobile-1.0.0",
        "name": "JDSModalMobileInternal",
        "layerName": "jds_modal_mobile_internal"
    },
    "hierarchy": {
        "container": [
            "overlay-container",
            {
                "outer-container": [
                    {
                        "root-container": [
                            {
                                "cancel-container": [
                                    "cancel-jds_button"
                                ]
                            },
                            {
                                "vertical-container": [
                                    {
                                        "header-container": [
                                            "header-jds-text"
                                        ]
                                    },
                                    {
                                        "children-container": [
                                            "children-slot"
                                        ]
                                    },
                                    {
                                        "button-container": [
                                            "primary-jds_action_button",
                                            "secondary-jds_action_button"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "custom-container": [
                            "children-slot"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{m_0}",
            "justify-content": "{m_1}",
            "align-items": "{m_2}",
            "size": "{m_3}"
        },
        "overlay-container": {
            "show": true,
            "size": "{m_4}",
            "background-color": "{m_5}",
            "opacity": "{m_6}"
        },
        "outer-container": {
            "z-index": 1,
            "flex-direction": "{m_14}",
            "justify-content": "{m_15}",
            "align-items": "{m_16}",
            "max-height": "{m_19}",
            "width": "{m_18}",
            "padding-top": "{m_20}",
            "padding-bottom": "{m_21}",
            "padding-left": "{m_22}",
            "padding-right": "{m_23}"
        },
        "root-container": {
            "flex-direction": "{m_7}",
            "justify-content": "{m_8}",
            "align-items": "{m_9}",
            "border-radius": "{m_10}",
            "width": "{m_11}",
            "background-color": "{m_13}",
            "max-height": "{m_12}"
        },
        "cancel-container": {
            "flex-direction": "{m_24}",
            "justify-content": "{m_25}",
            "align-items": "{m_26}",
            "width": "{m_27}",
            "padding-top": "{m_28}",
            "padding-bottom": "{m_29}",
            "padding-left": "{m_30}",
            "padding-right": "{m_31}",
            "hidden": false
        },
        "cancel-jds_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary",
            "size": "medium"
        },
        "vertical-container": {
            "flex-direction": "{m_32}",
            "justify-content": "{m_33}",
            "align-items": "{m_34}",
            "width": "{m_35}",
            "padding-left": "{m_36}",
            "padding-right": "{m_37}",
            "padding-bottom": "{m_38}",
            "overflow": "{m_39}"
        },
        "header-container": {
            "flex-direction": "{m_40}",
            "justify-content": "{m_41}",
            "align-items": "{m_42}",
            "width": "{m_43}",
            "padding-bottom": "{m_44}"
        },
        "children-container": {
            "width": "{m_46}",
            "overflow": "{m_47}",
            "flex-direction": "{m_48}",
            "align-items": "{m_45}",
            "flex-fill-android": false
        },
        "button-container": {
            "width": "{m_49}",
            "justify-content": "{m_50}",
            "align-items": "{m_51}",
            "flex-direction": "{m_52}",
            "gap": "{m_53}",
            "padding-top": "{m_54}"
        },
        "primary-jds_action_button": {
            "hidden": false,
            "kind": "primary",
            "size": "large",
            "stretch": true
        },
        "secondary-jds_action_button": {
            "hidden": false,
            "kind": "secondary",
            "size": "large",
            "stretch": true
        },
        "custom-container": {
            "hidden": true,
            "flex-direction": "{m_55}",
            "justify-content": "{m_56}",
            "align-items": "{m_57}",
            "border-radius": "{m_58}",
            "background-color": "{elevation1}",
            "padding-left": "{m_60}",
            "padding-right": "{m_61}",
            "padding-top": "{m_62}",
            "padding-bottom": "{m_63}",
            "width": "{m_64}"
        },
        "header-jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "acknowledgement": {
                "primary-jds_action_button": {
                    "stretch": true
                },
                "secondary-jds_action_button": {
                    "hidden": true
                }
            },
            "informational": {
                "button-container": {
                    "hidden": true
                }
            },
            "custom": {
                "custom-container": {
                    "hidden": false
                },
                "root-container": {
                    "hidden": true
                }
            }
        },
        "headerAlignment": {
            "right": {
                "header-container": {
                    "justify-content": "{m_65}"
                }
            },
            "center": {
                "header-container": {
                    "justify-content": "{m_66}"
                }
            }
        },
        "size": {
            "small": {
                "vertical-container": {
                    "padding-left": "{m_67}",
                    "padding-right": "{m_68}",
                    "padding-bottom": "{m_69}"
                }
            }
        },
        "primaryCtaDisabled": {
            "true": {
                "primary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "secondaryCtaDisabled": {
            "true": {
                "secondary-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "_hasCta": {
            "false": {
                "button-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "dialog": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_70}"
                    }
                }
            },
            "acknowledgement": {
                "false": {
                    "cancel-container": {
                        "hidden": true
                    },
                    "vertical-container": {
                        "padding-top": "{m_71}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "isCloseable"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "dialog",
                    "acknowledgement",
                    "informational",
                    "custom"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ]
            },
            "headerAlignment": {
                "values": [
                    "left",
                    "right",
                    "center"
                ]
            },
            "isCloseable": {
                "values": [
                    true,
                    false
                ]
            },
            "primaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "secondaryCtaDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasCta": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "primary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA"
                }
            },
            "secondary-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA"
                }
            },
            "header-jds-text": {
                "value": {
                    "type": "string",
                    "name": "header"
                }
            }
        },
        "children": {
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1,
                "doc_description": "This sets Modal content as a children elements."
            }
        },
        "events": {
            "root-container": {
                "onClick": "onModalClick"
            },
            "cancel-jds_button": {
                "onClick": "onCancel"
            },
            "primary-jds_action_button": {
                "onClick": "onPrimaryClick"
            },
            "secondary-jds_action_button": {
                "onClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "dialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Modal Content"
                    },
                    "aria-modal": {
                        "name": "_ariaModal",
                        "value": "true"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cancel-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "cancelButtonCtaAriaLabel",
                        "value": "Close Modal"
                    }
                }
            },
            "header-jds_text": {
                "properties": {
                    "aria-label": {
                        "name": "headerAriaLabel",
                        "prop": "header"
                    }
                }
            },
            "primary-jds_action_button": {
                "properties": {
                    "ariaLabel": "primaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "secondary-jds_action_button": {
                "properties": {
                    "ariaLabel": "secondaryCtaAriaLabel",
                    "ariaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$Y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasCta: Boolean(props.primaryCTA || props.secondaryCTA)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$$ = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$X;
    const { kind: kind = "dialog", size: size = "medium", headerAlignment: headerAlignment = "left", isCloseable: isCloseable = true, primaryCtaDisabled: primaryCtaDisabled = false, secondaryCtaDisabled: secondaryCtaDisabled = false, onModalClick: onModalClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onCancel: onCancel = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = "Modal Content", cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel = "Close Modal", headerAriaLabel: headerAriaLabel = props.header?.toString(), _ariaModal: _ariaModal = "true", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            size: size,
            headerAlignment: headerAlignment,
            isCloseable: isCloseable,
            primaryCtaDisabled: primaryCtaDisabled,
            secondaryCtaDisabled: secondaryCtaDisabled,
            onModalClick: onModalClick,
            onCancel: onCancel,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ariaLabel: ariaLabel,
            cancelButtonCtaAriaLabel: cancelButtonCtaAriaLabel,
            headerAriaLabel: headerAriaLabel,
            _ariaModal: _ariaModal,
            ...rest
        },
        componentTag: componentTag
    }, "JDSModalMobileInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$e70e9b240ff3bbbf = $451487d20aa3eb8a$var$withLogic$Y($451487d20aa3eb8a$var$Component$$);
$451487d20aa3eb8a$export$e70e9b240ff3bbbf.displayName = "ModalMobileInternal";
$451487d20aa3eb8a$export$e70e9b240ff3bbbf.slotName = "jds_modal_mobile_internal";
const $451487d20aa3eb8a$var$sdl$W = {
    "metadata": {
        "version": "1.0.0",
        "id": "notification-button-1.0.0",
        "name": "JDSNotificationButton",
        "layerName": "jds_notification_button"
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "padding-top": "{n_0}",
            "padding-right": "{n_1}",
            "padding-bottom": "{n_2}",
            "padding-left": "{n_3}",
            "background-color": "{n_4}",
            "border-radius": 1e3,
            "border-width": "1",
            "border-color": "{n_5}",
            "behavior": {
                "hover": {
                    "border-color": "{n_6}"
                },
                "active": {
                    "background-color": "{n_7}"
                },
                "focus": {
                    "border-width": "4",
                    "border-color": "{n_8}"
                }
            }
        },
        "icon": {
            "size": "{n_14}",
            "color": "{n_13}"
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary20}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "isDisabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{n_9}"
                }
            }
        },
        "kind": {
            "tertiary": {
                "container": {
                    "border-width": "0",
                    "behavior": {
                        "hover": {
                            "background-color": "{n_10}"
                        },
                        "active": {
                            "background-color": "{n_11}"
                        },
                        "focus": {
                            "background-color": "{n_12}"
                        }
                    }
                }
            }
        },
        "_hasLabel": {
            "false": {
                "container": {
                    "padding-top": "{n_15}",
                    "padding-bottom": "{n_16}",
                    "padding-left": "{n_17}",
                    "padding-right": "{n_18}"
                },
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasIcon": {
            "true": {
                "icon": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "isDisabled": {
                "values": [
                    false,
                    true
                ]
            },
            "kind": {
                "values": [
                    "secondary",
                    "tertiary"
                ]
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasIcon": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$X = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasLabel: Boolean(props.label),
                tabIndex: 0
            }
        });
    };
const $451487d20aa3eb8a$var$Component$_ = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$W;
    const { isDisabled: isDisabled = false, kind: kind = "secondary", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            isDisabled: isDisabled,
            kind: kind,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNotificationButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$NotificationButton = $451487d20aa3eb8a$var$withLogic$X($451487d20aa3eb8a$var$Component$_);
$451487d20aa3eb8a$var$NotificationButton.displayName = "NotificationButton";
$451487d20aa3eb8a$var$NotificationButton.slotName = "jds_notification_button";
const $451487d20aa3eb8a$var$sdl$V = {
    "metadata": {
        "version": "1.0.0",
        "id": "nudge-1.0.0",
        "name": "JDSNudge",
        "layerName": "jds_nudge"
    },
    "hierarchy": {
        "root-container": [
            {
                "base-container": [
                    "left-slot",
                    {
                        "center-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    "close-jds_notification_button",
                    "right-slot"
                ]
            },
            {
                "buttons-container": [
                    "secondary-jds_notification_button",
                    "primary-jds_notification_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{n_0}",
            "max-width": "{n_1}",
            "border-radius": "{n_2}",
            "background-color": "{n_3}",
            "flex-direction": "{n_4}",
            "gap": "{n_5}",
            "padding-top": "{n_6}",
            "padding-right": "{n_7}",
            "padding-bottom": "{n_8}",
            "padding-left": "{n_9}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-x",
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulExit}"
            },
            "hidden": true
        },
        "base-container": {
            "gap": "{n_10}",
            "flex-direction": "{n_12}",
            "justify-content": "{n_13}",
            "align-items": "{n_14}",
            "width": "{n_11}"
        },
        "center-container": {
            "flex-direction": "{n_15}",
            "justify-content": "{n_16}",
            "align-items": "{n_17}",
            "gap": "{n_18}",
            "flex": 1
        },
        "close-jds_notification_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary"
        },
        "buttons-container": {
            "show": false,
            "gap": "{n_20}",
            "flex-direction": "{n_21}",
            "justify-content": "{n_22}",
            "width": "{n_19}"
        },
        "secondary-jds_notification_button": {
            "kind": "tertiary"
        },
        "right-slot": {
            "hidden": true
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey20}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "open": {
            "true": {
                "root-container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "showClose": {
            "false": {
                "close-jds_notification_button": {
                    "hidden": true
                },
                "right-slot": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "tablet": {
                "root-container": {
                    "max-width": "{n_23}",
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            },
            "desktop": {
                "root-container": {
                    "max-width": "{n_24}",
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "_hasCTA": {
            "false": {
                "buttons-container": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "support-jds-text": {
                    "hidden": true
                },
                "heading-jds-text": {
                    "max-lines": 2,
                    "maxLines": 2
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "mobile": {
                    "root-container": {
                        "translate-y": "{size.negativeMax}"
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": "{size.max}"
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": "{size.max}"
                    }
                }
            },
            "true": {
                "mobile": {
                    "root-container": {
                        "translate-y": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": 0
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "open",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "This shows close button on Nudge when true."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "tablet",
                    "desktop"
                ]
            },
            "_hasCTA": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "root-container": {
                "_nudge.id": {
                    "type": "NotificationId",
                    "name": "id",
                    "required": true,
                    "doc_description": "It will hold the reference of Nudge"
                }
            },
            "secondary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Nudge."
                }
            },
            "primary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Nudge."
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of Nudge."
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the Nudge."
                },
                "maxLines": {
                    "type": "number",
                    "name": "maxLines",
                    "doc_description": "Allows customization of max lines for the description text."
                }
            }
        },
        "events": {
            "root-container": {
                "onShow": "onShow",
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onUpdate": {
                    "name": "onUpdate",
                    "platform": "android"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                },
                "onSwipeUp": "onClose"
            },
            "close-jds_notification_button": {
                "onClick": "onClose"
            },
            "secondary-jds_notification_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_notification_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "children": {
            "left-slot": {
                "accepts": [
                    "jds_icon",
                    "jds_avatar"
                ],
                "max": 1,
                "name": "prefix",
                "doc_description": "It takes 'icon', 'avatar' as prefix."
            },
            "right-slot": {
                "accepts": [
                    "jds_notification_button"
                ],
                "max": 1,
                "name": "suffix",
                "doc_description": "It takes 'jds_notification_button' as suffix."
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "alertdialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            },
            "base-container": {
                "properties": {
                    "aria-hidden": {
                        "value": "true"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$f = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onPrimaryClick: props.secondaryCTA?.onClick
            }
        }
    };
};
function $451487d20aa3eb8a$var$subscribe(eventClass, func) {
    const handler = function() {
        func(eventClass.args);
    };
    document.addEventListener(eventClass.eventName, handler, {
        passive: true
    });
    return {
        unsubscribe: function unsubscribe() {
            document.removeEventListener(eventClass.eventName, handler);
        }
    };
}
function $451487d20aa3eb8a$var$publish(event) {
    const nativeEvent = new CustomEvent(event.constructor.eventName, {
        detail: event.constructor.args
    });
    document.dispatchEvent(nativeEvent);
}
const $451487d20aa3eb8a$var$DEFAULT_DISMISS_WITH_CTA = 10;
const $451487d20aa3eb8a$var$DEFAULT_DISMISS_WITHOUT_CTA = 5;
const $451487d20aa3eb8a$var$TOAST_SELECTOR = "div.j-JDSToast-root-container";
const $451487d20aa3eb8a$var$resolvePrefixIcon = (props)=>{
    if (typeof props.prefix === "string") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
        ic: props.prefix
    });
    return props.prefix;
};
function $451487d20aa3eb8a$var$getDismissTime(isCTAPresent, dismissAfter) {
    let timer = $451487d20aa3eb8a$var$DEFAULT_DISMISS_WITHOUT_CTA;
    if (isCTAPresent) timer = $451487d20aa3eb8a$var$DEFAULT_DISMISS_WITH_CTA;
    if (dismissAfter !== void 0) {
        const defaultMinTimer = 2;
        const defaultMaxTimer = isCTAPresent ? $451487d20aa3eb8a$var$DEFAULT_DISMISS_WITH_CTA : $451487d20aa3eb8a$var$DEFAULT_DISMISS_WITHOUT_CTA;
        if (dismissAfter < defaultMinTimer) timer = defaultMinTimer;
        else if (dismissAfter < defaultMaxTimer) timer = dismissAfter;
    }
    return timer;
}
const $451487d20aa3eb8a$var$withLogic$W = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$f);
        const { onClose: onClose, onShow: onShow, primaryCTA: primaryCTA, secondaryCTA: secondaryCTA, showClose: showClose, id: userId, suffix: suffix, dismissAfter: dismissAfter, ...rest } = props;
        const uniqueId = userId || `toast-${Math.random().toString(36).substr(2, 9)}`;
        const [closeToast, setCloseToast] = (0, $1OEoy.useState)();
        const [timeToClose, setTimeToClose] = (0, $1OEoy.useState)(0);
        const [intervalID, setIntervalID] = (0, $1OEoy.useState)();
        const { rootRef: rootRef, element: element } = $451487d20aa3eb8a$var$useRootRef();
        const isCTAPresent = !!(primaryCTA || secondaryCTA);
        const TOAST_CLOSING_TIME = $451487d20aa3eb8a$var$getDismissTime(isCTAPresent, dismissAfter);
        const platformClass = $451487d20aa3eb8a$var$getPlatform() === "mobile" ? "mobile-toast" : "desktop-toast";
        const [toastQueue, setToastQueue] = (0, $1OEoy.useState)([]);
        const [timeouts, setTimeouts] = (0, $1OEoy.useState)({});
        (0, $1OEoy.useEffect)(()=>{
            if (!toastQueue.includes(uniqueId)) setToastQueue((prevQueue)=>[
                    ...prevQueue,
                    uniqueId
                ]);
            const dismissTimer = setTimeout(()=>{
                setToastQueue((prevQueue)=>prevQueue.filter((id)=>id !== uniqueId));
                handleToastUnmount();
            }, TOAST_CLOSING_TIME * 1e3);
            setTimeouts((prevTimeouts)=>({
                    ...prevTimeouts,
                    [uniqueId]: dismissTimer
                }));
            return ()=>{
                clearTimeout(dismissTimer);
                setTimeouts((prevTimeouts)=>{
                    const newTimeouts = {
                        ...prevTimeouts
                    };
                    delete newTimeouts[uniqueId];
                    return newTimeouts;
                });
            };
        }, [
            uniqueId,
            TOAST_CLOSING_TIME
        ]);
        const handleToastUnmount = (0, $1OEoy.useCallback)(()=>{
            console.log("unmount");
            setToastQueue((prevQueue)=>prevQueue.filter((id)=>id !== uniqueId));
            if ($451487d20aa3eb8a$var$toast && typeof $451487d20aa3eb8a$var$toast.dismiss === "function") $451487d20aa3eb8a$var$toast.dismiss(uniqueId);
            onClose?.(uniqueId);
            if (timeouts[uniqueId]) {
                clearTimeout(timeouts[uniqueId]);
                setTimeouts((prevTimeouts)=>{
                    const newTimeouts = {
                        ...prevTimeouts
                    };
                    delete newTimeouts[uniqueId];
                    return newTimeouts;
                });
            }
            if (element?.classList.contains("visible") && timeouts[uniqueId]) element.classList.remove("visible");
            setCloseToast(true);
        }, [
            uniqueId,
            onClose,
            timeouts
        ]);
        const handleToastStart = (0, $1OEoy.useCallback)(()=>{
            console.log("mount");
            if (timeToClose <= TOAST_CLOSING_TIME) {
                const intervalID2 = setInterval(()=>{
                    setTimeToClose((time)=>{
                        if (time === 10) clearInterval(intervalID2);
                        return time + 0.5;
                    });
                }, 500);
                setIntervalID(intervalID2);
            }
        }, [
            TOAST_CLOSING_TIME,
            timeToClose
        ]);
        const handleToastPause = (0, $1OEoy.useCallback)(()=>{
            if (timeToClose !== TOAST_CLOSING_TIME) clearInterval(intervalID);
        }, [
            timeToClose,
            TOAST_CLOSING_TIME,
            intervalID
        ]);
        (0, $1OEoy.useEffect)(()=>{
            uniqueId && onShow && onShow(uniqueId);
            setTimeout(()=>setCloseToast(false), 10);
            const toastElement = document.querySelector($451487d20aa3eb8a$var$TOAST_SELECTOR);
            if (toastElement) {
                toastElement.setAttribute("tabindex", "0");
                toastElement.focus();
            }
            const { unsubscribe: toastCloseUnsubscribe } = $451487d20aa3eb8a$var$subscribe($451487d20aa3eb8a$var$NotificationCloseService, (data)=>{
                if (uniqueId && data[uniqueId] === "toast") handleToastClose();
            });
            if (window) {
                handleToastStart();
                window.addEventListener("blur", handleToastPause);
                window.addEventListener("focus", handleToastStart);
            }
            return ()=>{
                if (window) {
                    window.removeEventListener("blur", handleToastPause);
                    window.removeEventListener("focus", handleToastStart);
                }
                uniqueId && onClose && onClose(uniqueId);
                toastCloseUnsubscribe();
            };
        }, [
            uniqueId
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (timeToClose === TOAST_CLOSING_TIME) handleToastClose();
        }, [
            timeToClose,
            TOAST_CLOSING_TIME
        ]);
        const handleToastClose = ()=>{
            setCloseToast(true);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                onClose: handleToastUnmount,
                onMouseEnter: ()=>{
                    handleToastPause();
                },
                onMouseLeave: ()=>{
                    handleToastStart();
                },
                ...rest,
                prefix: $451487d20aa3eb8a$var$resolvePrefixIcon(props),
                open: true,
                suffix: suffix?.props ? suffix : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$NotificationButton, {
                    ...suffix
                }),
                className: `v1 ${closeToast === false ? "visible" : ""} ${platformClass}`,
                rootRef: rootRef,
                _hasCTA: Boolean(primaryCTA || secondaryCTA),
                _hasDescription: Boolean(rest.description),
                _platform: $451487d20aa3eb8a$var$getPlatform(),
                showClose: showClose,
                primaryCTA: primaryCTA,
                secondaryCTA: secondaryCTA
            }
        });
    };
const $451487d20aa3eb8a$var$PROP_MAP$e = (props)=>{
    return {
        primaryCTA: {
            properties: {
                primaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.primaryCTA, "title", ""),
                onPrimaryClick: props.primaryCTA?.onClick
            }
        },
        secondaryCTA: {
            properties: {
                secondaryCTA: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.secondaryCTA, "title", ""),
                onPrimaryClick: props.secondaryCTA?.onClick
            }
        }
    };
};
const $451487d20aa3eb8a$var$NUDGE_CLOSING_TIME = 5;
const $451487d20aa3eb8a$var$withLogic$V = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$e);
        const { primaryCTA: primaryCTA, secondaryCTA: secondaryCTA, showClose: showClose, id: id, onShow: onShow, onClose: onClose, suffix: suffix, maxLines: maxLines, ...rest } = props;
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const [closeNudge, setCloseNudge] = (0, $1OEoy.useState)(true);
        const [timeToClose, setTimeToClose] = (0, $1OEoy.useState)(0);
        const [intervalID, setIntervalID] = (0, $1OEoy.useState)();
        const defaultMaxLine = 1;
        const isCTAGroupAbsent = !(primaryCTA && secondaryCTA || (primaryCTA || secondaryCTA) && showClose);
        const handleNudgeUnmount = (0, $1OEoy.useCallback)(()=>{
            if (id) {
                $451487d20aa3eb8a$var$nudge.dismiss(id);
                if (element?.classList.contains("visible")) element.classList.remove("visible");
                onClose?.(id);
                setCloseNudge(true);
            }
        }, [
            id,
            onClose
        ]);
        (0, $1OEoy.useEffect)(()=>{
            id && onShow && onShow(id);
            setTimeout(()=>setCloseNudge(false), 10);
            const { unsubscribe: nudgeCloseUnsubscribe } = $451487d20aa3eb8a$var$subscribe($451487d20aa3eb8a$var$NotificationCloseService, (data)=>{
                if (id && data[id] === "nudge") handleNudgeClose();
            });
            if (window) {
                handleNudgeStart();
                window.addEventListener("blur", handleNudgePause);
                window.addEventListener("focus", handleNudgeStart);
            }
            return ()=>{
                if (window) {
                    window.removeEventListener("blur", handleNudgePause);
                    window.removeEventListener("focus", handleNudgeStart);
                }
                id && onClose && onClose(id);
                nudgeCloseUnsubscribe();
            };
        }, [
            id
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (isCTAGroupAbsent && timeToClose >= $451487d20aa3eb8a$var$NUDGE_CLOSING_TIME) handleNudgeUnmount();
        }, [
            timeToClose,
            handleNudgeUnmount,
            isCTAGroupAbsent
        ]);
        const handleNudgeStart = ()=>{
            if (isCTAGroupAbsent && timeToClose !== $451487d20aa3eb8a$var$NUDGE_CLOSING_TIME) {
                const intervalID2 = setInterval(()=>{
                    setTimeToClose((time)=>{
                        if (time === 10) {
                            clearInterval(intervalID2);
                            return time;
                        }
                        return time + 0.5;
                    });
                }, 500);
                setIntervalID(intervalID2);
            }
        };
        const handleNudgePause = ()=>{
            if (isCTAGroupAbsent && timeToClose !== $451487d20aa3eb8a$var$NUDGE_CLOSING_TIME) clearInterval(intervalID);
        };
        const handleNudgeClose = ()=>{
            setCloseNudge(true);
        };
        (0, $1OEoy.useEffect)(()=>{
            if (element) {
                const el = element.querySelector('[data-testid="JDSNudge-support-jds-text"]');
                if (el) el.style.setProperty("--max-lines", `${maxLines || defaultMaxLine}`);
            }
        }, [
            element,
            maxLines
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                onClose: handleNudgeUnmount,
                onMouseEnter: ()=>{
                    handleNudgePause();
                },
                onMouseLeave: ()=>{
                    handleNudgeStart();
                },
                ...rest,
                prefix: $451487d20aa3eb8a$var$resolvePrefixIcon(props),
                suffix: suffix?.props ? suffix : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$NotificationButton, {
                    ...suffix
                }),
                rootRef: rootRef,
                open: true,
                className: closeNudge === false ? "visible" : "",
                showClose: showClose,
                primaryCTA: primaryCTA,
                secondaryCTA: secondaryCTA,
                maxLines: maxLines ?? defaultMaxLine,
                _platform: $451487d20aa3eb8a$var$getPlatform(),
                _hasCTA: Boolean(primaryCTA || secondaryCTA),
                _hasDescription: Boolean(rest.description)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$Z = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$V;
    const { open: open = false, showClose: showClose = true, onShow: onShow = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onUpdate: onUpdate = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            showClose: showClose,
            onShow: onShow,
            onHover: onHover,
            onUpdate: onUpdate,
            onHoverEnd: onHoverEnd,
            onClose: onClose,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNudge", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$Nudge = $451487d20aa3eb8a$var$withLogic$V($451487d20aa3eb8a$var$Component$Z);
$451487d20aa3eb8a$var$Nudge.displayName = "Nudge";
$451487d20aa3eb8a$var$Nudge.slotName = "jds_nudge";
const $451487d20aa3eb8a$var$sdl$U = {
    "metadata": {
        "version": "1.0.0",
        "id": "pagination-button-1.0.0",
        "name": "JDSPaginationButton",
        "layerName": "jds_pagination_button"
    },
    "hierarchy": {
        "container": [
            {
                "inner-container": [
                    "jds-text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "size": "{p_0}",
            "justify-content": "{p_1}",
            "align-items": "{p_2}",
            "behavior": {
                "hover": {},
                "focus": {},
                "active": {}
            }
        },
        "inner-container": {
            "background-color": "{p_3}",
            "flex-direction": "{p_4}",
            "justify-content": "{p_5}",
            "align-items": "{p_6}",
            "border-radius": "{p_7}",
            "width": "{p_8}",
            "height": "{p_9}",
            "opacity": "{p_10}",
            "gap": "{p_11}",
            "border-color": "{p_12}",
            "behavior": {
                "hover": {
                    "background-color": "{p_13}"
                },
                "active": {
                    "background-color": "{p_14}"
                },
                "focus": {
                    "border-width": "{p_15}"
                }
            }
        },
        "jds-text": {
            "font-family": "{button}",
            "color": "{primary40}",
            "font-size": "{button}",
            "line-height": "{button}",
            "letter-spacing": "{button}",
            "font-weight": "{button}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "hover": {
                    "color": "{primary60}"
                },
                "active": {
                    "color": "{primary60}"
                },
                "focus": {
                    "color": "{primary60}"
                }
            }
        }
    },
    "variant": {
        "state": {
            "selected": {
                "inner-container": {
                    "background-color": "{p_16}"
                },
                "jds-text": {
                    "color": "{primary30}"
                }
            },
            "ellipsis": {
                "container": {
                    "disabled": true
                },
                "inner-container": {
                    "background-color": "{p_17}"
                },
                "jds-text": {
                    "color": "{primaryGrey80}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "default",
                    "selected",
                    "ellipsis"
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-current": "_ariaCurrent"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$U = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _ariaCurrent: props.state === "selected" ? "page" : void 0
            }
        });
    };
const $451487d20aa3eb8a$var$Component$Y = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$U;
    const { state: state = "default", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPaginationButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$c3639e97caabff2c = $451487d20aa3eb8a$var$withLogic$U($451487d20aa3eb8a$var$Component$Y);
$451487d20aa3eb8a$export$c3639e97caabff2c.displayName = "PaginationButton";
$451487d20aa3eb8a$export$c3639e97caabff2c.slotName = "jds_pagination_button";
const $451487d20aa3eb8a$var$sdl$T = {
    "metadata": {
        "version": "1.0.0",
        "id": "progress-bar-1.0.0",
        "name": "JDSProgressBar",
        "layerName": "jds_progress_bar"
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "jds-text",
                    "value-jds-text"
                ]
            },
            {
                "determinate-container": [
                    "active-container",
                    "invisible-container"
                ]
            },
            {
                "indeterminate-container": [
                    "track-container",
                    "active-animatedContainer"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{p_0}",
            "justify-content": "{p_1}",
            "align-items": "{p_2}",
            "gap": "{p_3}",
            "width": "{p_4}",
            "background-color": "{p_5}"
        },
        "top-container": {
            "hidden": false,
            "show": false,
            "background-color": "{p_6}",
            "flex-direction": "{p_7}",
            "justify-content": "{p_8}",
            "align-items": "{p_9}",
            "width": "{p_10}",
            "gap": "{p_11}"
        },
        "determinate-container": {
            "hidden": false,
            "background-color": "{p_12}",
            "height": "{p_13}",
            "width": "{p_14}",
            "flex-direction": "{p_15}",
            "justify-content": "{p_16}",
            "align-items": "{p_17}",
            "border-radius": "{p_18}"
        },
        "active-container": {
            "background-color": "{p_19}",
            "height": "{p_20}",
            "border-radius": "{p_21}",
            "show": true
        },
        "invisible-container": {
            "height": "{p_22}",
            "show": true
        },
        "indeterminate-container": {
            "hidden": true,
            "flex-direction": "{p_23}",
            "background-color": "{p_24}",
            "height": "{p_25}",
            "width": "{p_26}",
            "border-radius": "{p_27}",
            "overflow": "hidden"
        },
        "track-container": {
            "height": "{p_28}",
            "show": true
        },
        "active-animatedContainer": {
            "height": "{p_29}",
            "width": "{p_30}",
            "background-color": "{p_31}",
            "z-index": 1,
            "border-radius": "{p_32}",
            "animation-curve": "entrance_ease",
            "animation-duration": 1e3
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "value-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primary60}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "indeterminate": {
                "determinate-container": {
                    "hidden": true
                },
                "indeterminate-container": {
                    "hidden": false
                }
            }
        },
        "state": {
            "success": {
                "active-container": {
                    "background-color": "{p_33}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_34}"
                }
            },
            "error": {
                "active-container": {
                    "background-color": "{p_35}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_36}"
                }
            },
            "warning": {
                "active-container": {
                    "background-color": "{p_37}"
                },
                "active-animatedContainer": {
                    "background-color": "{p_38}"
                }
            }
        },
        "labelPosition": {
            "center": {
                "top-container": {
                    "justify-content": "{p_39}"
                }
            }
        },
        "_hasValueLabel": {
            "false": {
                "value-jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasLabel": {
            "false": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "_hasLabelOrValueLabel": {
            "false": {
                "top-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "stretch": {
                "false": {
                    "top-container": {
                        "justify-content": "{justifyContent.start}"
                    },
                    "value-jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "stretch": {
                "false": {
                    "top-container": {
                        "justify-content": "{justifyContent.end}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "labelPosition",
            "_hasValueLabel"
        ],
        [
            "labelPosition",
            "_hasLabel"
        ]
    ],
    "api": {
        "data": {
            "active-container": {
                "flex": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It takes user input for value of progress bar."
                }
            },
            "invisible-container": {
                "flex": {
                    "type": "float",
                    "name": "_invisible"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays the main label of Progess Bar."
                }
            },
            "value-jds-text": {
                "value": {
                    "type": "string",
                    "name": "valueLabel",
                    "doc_description": "It displays the support label of Progess Bar."
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "determinate",
                    "indeterminate"
                ],
                "doc_description": "It can be used to switch between 2 variants of progess bar."
            },
            "labelPosition": {
                "values": [
                    "stretch",
                    "center"
                ],
                "doc_description": "It can be used align label of progress bar to center or at the ends of progress bar."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.This can be dynamically changed as per user's form handling.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_hasLabelOrValueLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasLabel": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasValueLabel": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "progressbar"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-valuenow": {
                        "name": "_ariaValuenow",
                        "platform": "web,ios"
                    },
                    "aria-valuemin": {
                        "name": "_ariaValuemin",
                        "platform": "web,ios"
                    },
                    "aria-valuemax": {
                        "name": "_ariaValuemax",
                        "platform": "web,ios"
                    },
                    "aria-busy": {
                        "name": "ariaBusy",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$d = (props)=>({
        type: {
            properties: {
                kind: props.type
            }
        }
    });
const $451487d20aa3eb8a$var$withLogic$T = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$d);
        const { value: value = 0, ...rest } = props;
        const min = 0;
        const max = value < 1 ? 1 : 100;
        const calculatedValue = value / (max - min);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                value: calculatedValue,
                _invisible: 1 - calculatedValue,
                _ariaValuenow: props.kind === "indeterminate" ? void 0 : props.value,
                _ariaValuemin: props.kind === "indeterminate" ? void 0 : "0",
                _ariaValuemax: props.kind === "indeterminate" ? void 0 : "100",
                ariaBusy: props.kind === "indeterminate" ? "true" : props.ariaBusy
            }
        });
    };
const $451487d20aa3eb8a$var$Component$X = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$T;
    const { kind: kind = "determinate", labelPosition: labelPosition = "stretch", state: state = "undefined", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            labelPosition: labelPosition,
            state: state,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSProgressBar", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$c17561cb55d4db30 = $451487d20aa3eb8a$var$withLogic$T($451487d20aa3eb8a$var$Component$X);
$451487d20aa3eb8a$export$c17561cb55d4db30.displayName = "ProgressBar";
$451487d20aa3eb8a$export$c17561cb55d4db30.slotName = "jds_progress_bar";
const $451487d20aa3eb8a$var$sdl$S = {
    "metadata": {
        "version": "1.0.0",
        "id": "Rating-bar-item-1.0.0",
        "name": "JDSRatingBarItem",
        "layerName": "jds_rating_bar_item"
    },
    "hierarchy": {
        "container": [
            {
                "start-container": [
                    "start-icon"
                ]
            },
            {
                "end-container": [
                    "end-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{r_0}",
            "behavior": {
                "focus": {
                    "border-width": "{r_1}",
                    "border-color": "{r_2}"
                }
            }
        },
        "start-container": {
            "clip-first-half": true
        },
        "start-icon": {
            "size": "{l}",
            "color": "{primaryGrey80}",
            "value": "ic_star"
        },
        "end-container": {
            "hidden": true,
            "clip-first-half": false,
            "z-index": 1
        },
        "end-icon": {
            "size": "{l}",
            "color": "{primaryGrey80}",
            "value": "ic_star"
        }
    },
    "variant": {
        "size": {
            "small": {
                "start-icon": {
                    "size": "{r_3}"
                },
                "end-icon": {
                    "size": "{r_4}"
                }
            },
            "large": {
                "start-icon": {
                    "size": "{r_5}"
                },
                "end-icon": {
                    "size": "{r_6}"
                }
            }
        },
        "isInteractive": {
            "false": {
                "container": {
                    "disabled": true
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{r_7}"
                }
            }
        },
        "isHalfRated": {
            "true": {
                "end-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "false": {
                    "false": {
                        "start-icon": {
                            "color": "{r_8}"
                        },
                        "end-icon": {
                            "color": "{r_9}"
                        }
                    },
                    "true": {
                        "start-icon": {
                            "color": "{r_10}"
                        },
                        "end-icon": {
                            "color": "{r_11}"
                        }
                    }
                },
                "true": {
                    "false": {
                        "start-icon": {
                            "color": "{r_12}"
                        },
                        "end-icon": {
                            "color": "{r_13}"
                        }
                    },
                    "true": {
                        "start-icon": {
                            "color": "{r_14}"
                        },
                        "end-icon": {
                            "color": "{r_15}"
                        }
                    }
                }
            },
            "true": {
                "false": {
                    "false": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_16}",
                                    "border-color": "{r_18}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_20}",
                            "behavior": {
                                "active": {
                                    "color": "{r_24}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_21}",
                            "behavior": {
                                "active": {
                                    "color": "{r_25}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_17}",
                                    "border-color": "{r_19}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{primary50}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{primary50}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "true": {
                    "false": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_28}",
                                    "border-color": "{r_26}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_30}",
                            "behavior": {
                                "active": {
                                    "color": "{r_34}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_31}",
                            "behavior": {
                                "active": {
                                    "color": "{r_35}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "behavior": {
                                "focus": {
                                    "border-width": "{r_29}",
                                    "border-color": "{r_27}"
                                }
                            }
                        },
                        "start-icon": {
                            "color": "{r_32}",
                            "behavior": {
                                "active": {
                                    "color": "{r_34}"
                                }
                            }
                        },
                        "end-icon": {
                            "color": "{r_33}",
                            "behavior": {
                                "active": {
                                    "color": "{r_35}"
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            "false": {
                "true": {
                    "start-icon": {
                        "color": "{r_38}"
                    },
                    "end-icon": {
                        "color": "{r_39}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "isInteractive",
            "isActive",
            "isHovered"
        ],
        [
            "isInteractive",
            "isHalfRated"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "isInteractive": {
                "values": [
                    false,
                    true
                ]
            },
            "isActive": {
                "values": [
                    false,
                    true
                ]
            },
            "isHovered": {
                "values": [
                    false,
                    true
                ]
            },
            "isHalfRated": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "start-container": {
                "clip-value": {
                    "type": "clipValueSize",
                    "name": "clipValue",
                    "function": true
                }
            },
            "end-container": {
                "clip-value": {
                    "type": "clipValueSize",
                    "name": "_updatedClipValue"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                },
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-checked": {
                        "name": "ariaChecked"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$S = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _role: props.type === "interactive" ? "radio" : void 0
            },
            onHover: ()=>{
                props.onMouseEnter?.(props.internalIndex);
            },
            onHoverEnd: ()=>{
                props.onMouseLeave?.(-1);
            },
            onClick: ()=>{
                props.onClick?.(props.internalIndex);
            },
            _updatedClipValue: props.clipValue !== void 0 ? `${((1 - Number(props.clipValue?.slice(0, -1)) / 100) * 100).toString()}%` : void 0
        });
    };
const $451487d20aa3eb8a$var$Component$W = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$S;
    const { size: size = "medium", isInteractive: isInteractive = false, isActive: isActive = false, isHovered: isHovered = false, isHalfRated: isHalfRated = false, disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            isInteractive: isInteractive,
            isActive: isActive,
            isHovered: isHovered,
            isHalfRated: isHalfRated,
            disabled: disabled,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRatingBarItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$b473c78e8d3557fd = $451487d20aa3eb8a$var$withLogic$S($451487d20aa3eb8a$var$Component$W);
$451487d20aa3eb8a$export$b473c78e8d3557fd.displayName = "RatingBarItem";
$451487d20aa3eb8a$export$b473c78e8d3557fd.slotName = "jds_rating_bar_item";
const $451487d20aa3eb8a$var$sdl$R = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-box-1.0.0",
        "name": "JDSSearchBox",
        "layerName": "jds_search_box",
        "description": "The search pattern allows users to quickly find relevant content by typing a querry",
        "usage": "The Search function is triggered as soon as the user focuses in the search field or hits on the search icon. Initially he can see a list of recent searches and quick links but as soon as he starts typing he would see suggestions relevant with his querry."
    },
    "hierarchy": {
        "container": [
            {
                "prefix-container": [
                    "prefix-icon"
                ]
            },
            "input",
            {
                "suffix-container": [
                    "suffix-icon"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "opacity": "{s_10}",
            "background-color": "{s_0}",
            "flex-direction": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "padding-right": "{s_4}",
            "padding-left": "{s_5}",
            "width": "{s_6}",
            "height": "{s_7}",
            "border-radius": "{s_8}",
            "gap": "{s_9}",
            "behavior": {
                "focus": {
                    "border-color": "{s_11}",
                    "border-width": "{s_12}"
                },
                "active": {
                    "background-color": "{s_13}"
                }
            }
        },
        "input": {
            "type": "search",
            "text-align": "{s_14}",
            "placeholder-color": "{s_15}",
            "placeholder-font-family": "{s_16}",
            "placeholder-font-size": "{s_17}",
            "placeholder-line-height": "{s_18}",
            "placeholder-letter-spacing": "{s_19}",
            "placeholder-font-weight": "{s_20}",
            "input-color": "{s_21}",
            "input-font-family": "{s_22}",
            "input-font-size": "{s_23}",
            "input-line-height": "{s_24}",
            "input-letter-spacing": "{s_25}",
            "input-font-weight": "{s_26}",
            "cursor-color": "{s_27}",
            "width": "{size.max}",
            "disabled": false,
            "flex": 1,
            "behavior": {
                "hover": {
                    "placeholder-color": "{s_28}"
                },
                "focus": {
                    "placeholder-color": "{s_29}"
                },
                "active": {
                    "placeholder-color": "{s_30}"
                }
            }
        },
        "prefix-container": {
            "flex-direction": "{s_31}",
            "justify-content": "{s_32}",
            "align-items": "{s_33}"
        },
        "prefix-icon": {
            "size": "{s_34}",
            "color": "{s_35}",
            "behavior": {
                "hover": {
                    "color": "{s_36}"
                },
                "focus": {
                    "color": "{s_37}"
                },
                "active": {
                    "color": "{s_38}"
                }
            }
        },
        "suffix-container": {
            "flex-direction": "{s_39}",
            "justify-content": "{s_40}",
            "align-items": "{s_41}"
        },
        "suffix-icon": {
            "size": "{s_42}",
            "color": "{s_43}",
            "behavior": {
                "hover": {
                    "color": "{s_44}"
                },
                "focus": {
                    "color": "{s_45}"
                },
                "active": {
                    "color": "{s_46}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "header": {
                "container": {
                    "background-color": "{s_47}",
                    "behavior": {
                        "focus": {
                            "border-color": "{s_48}",
                            "border-width": 4
                        },
                        "active": {
                            "background-color": "{s_49}"
                        }
                    }
                },
                "prefix-icon": {
                    "color": "{s_50}",
                    "behavior": {
                        "hover": {
                            "color": "{s_51}"
                        },
                        "active": {
                            "color": "{s_52}"
                        }
                    }
                },
                "suffix-icon": {
                    "color": "{s_53}",
                    "behavior": {
                        "hover": {
                            "color": "{s_54}"
                        },
                        "active": {
                            "color": "{s_55}"
                        }
                    }
                },
                "input": {
                    "input-color": "{s_56}",
                    "placeholder-color": "{s_57}",
                    "cursor-color": "{s_58}",
                    "behavior": {
                        "hover": {
                            "placeholder-color": "{s_59}"
                        }
                    }
                }
            },
            "light_background": {
                "container": {
                    "background-color": "{s_60}",
                    "border-color": "{s_61}",
                    "border-width": "{s_65}",
                    "behavior": {
                        "hover": {
                            "background-color": "{s_60}",
                            "border-color": "{s_62}"
                        },
                        "focus": {
                            "background-color": "{s_60}",
                            "border-color": "{s_63}",
                            "border-width": "{s_66}"
                        },
                        "active": {
                            "background-color": "{s_60}",
                            "border-color": "{s_64}"
                        }
                    }
                },
                "input": {
                    "input-color": "{s_67}",
                    "cursor-color": "{s_68}",
                    "behavior": {
                        "active": {
                            "placeholder-color": "{s_69}"
                        }
                    }
                },
                "prefix-icon": {
                    "color": "{s_70}",
                    "behavior": {
                        "hover": {
                            "color": "{s_71}"
                        },
                        "focus": {
                            "color": "{s_72}"
                        },
                        "active": {
                            "color": "{s_73}"
                        }
                    }
                },
                "suffix-icon": {
                    "color": "{s_74}",
                    "behavior": {
                        "active": {
                            "color": "{s_75}"
                        }
                    }
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_76}"
                },
                "prefix-container": {
                    "disabled": true
                },
                "suffix-container": {
                    "disabled": true
                },
                "input": {
                    "disabled": true
                }
            }
        },
        "_isValueEmpty": {
            "false": {
                "suffix-icon": {
                    "color": "{s_77}"
                }
            }
        },
        "_inputFocus": {
            "true": {
                "input": {
                    "placeholder-color": "{s_79}"
                }
            }
        }
    },
    "combination": [
        {
            "header": {
                "false": {
                    "suffix-icon": {
                        "color": "{s_78}"
                    }
                }
            },
            "light_background": {
                "false": {
                    "suffix-icon": {
                        "color": "{s_80}"
                    }
                }
            }
        },
        {
            "light_background": {
                "true": {
                    "container": {
                        "border-color": "{s_81}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "kind",
            "_isValueEmpty"
        ],
        [
            "kind",
            "_inputFocus"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "normal",
                    "header",
                    "light_background"
                ],
                "doc_description": "It determines if SearchBox is to be used on header or normal background."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            },
            "_isValueEmpty": {
                "values": [
                    true,
                    false
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "input": {
                "value": {
                    "type": "string",
                    "name": "value",
                    "doc_description": "It takes user input for text to be searched."
                },
                "name": {
                    "type": "string",
                    "name": "name",
                    "doc_description": "It displays name of search box."
                },
                "placeholder": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays placeholder text of search box."
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                }
            },
            "prefix-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix",
                    "function": true,
                    "doc_description": "It can be used to pass icon as prefix."
                }
            },
            "suffix-icon": {
                "value": {
                    "type": "icon",
                    "name": "suffix",
                    "doc_description": "It can be used to display icon on the right of search box."
                }
            },
            "container": {
                "_prefix.showBack": {
                    "type": "boolean",
                    "name": "showBack"
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeyup": {
                    "name": "onKeyup",
                    "platform": "web"
                },
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                }
            },
            "prefix-container": {
                "onClick": "onBack"
            },
            "suffix-container": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "prefix-icon": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "prefixAriaLabel"
                    }
                }
            },
            "suffix-icon": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "suffixAriaLabel"
                    }
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "search"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    }
                }
            },
            "input": {
                "name": "input",
                "properties": {
                    "role": {
                        "value": "searchbox"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$R = (Component)=>(props)=>{
        const { onBack: onBack, ...rest } = props;
        const [typing, setTyping] = (0, $1OEoy.useState)(false);
        const [value, setValue] = (0, $1OEoy.useState)(props.value);
        const element = (0, $1OEoy.useRef)(null);
        const [focused, setFocused] = (0, $1OEoy.useState)(false);
        (0, $1OEoy.useEffect)(()=>{
            setValue(props.value);
        }, [
            props.value
        ]);
        const triggerChange = (value2 = "")=>{
            if (element) {
                const input = element?.current;
                const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                tracker?.call(input, value2);
                const event = new Event("input", {
                    bubbles: true
                });
                input?.dispatchEvent(event);
            }
        };
        const formatIconName = (iconName)=>{
            if (typeof iconName === "string" && iconName.startsWith("Ic")) {
                const words = iconName.slice(2).match(/[A-Z][a-z]+/g);
                return words ? words.join(" ").toLowerCase() + " icon" : iconName;
            } else if (typeof iconName === "string" && iconName.startsWith("ic_")) {
                const words = iconName.slice(3).split("_");
                return words ? words.join(" ").toLowerCase() + " icon" : iconName;
            }
            return iconName;
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                value: value,
                prefixAriaLabel: props.prefixAriaLabel || formatIconName(props.prefix),
                suffixAriaLabel: props.suffixAriaLabel || formatIconName(props.suffix),
                onBack: ()=>{
                    if (focused && props.showBack) onBack?.(value || "");
                    else props.onPrefixClick?.(value);
                },
                prefix: props.showBack && focused ? "IcBack" : props.prefix,
                suffix: typing ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                    id: "suffix-container",
                    onMouseDown: (e)=>e.preventDefault(),
                    onClick: (e)=>{
                        e.stopPropagation();
                        props.onSuffixClick?.();
                    },
                    children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $6d68c299e9b46980$export$464f071bbd2cc5e5), {})
                }) : props.suffix,
                onFocus: (ev)=>{
                    props.onFocus?.(ev);
                    setFocused(true);
                    setTyping(Boolean(ev.target.value));
                },
                _isValueEmpty: !typing,
                onBlur: (ev)=>{
                    props.onBlur?.(ev);
                    if (!ev.target.value) setFocused(false);
                    if (!(ev.relatedTarget?.id === "suffix-container")) setTyping(false);
                },
                onChange: (ev)=>{
                    setTyping(Boolean(ev.target.value));
                    props.onChange?.(ev);
                    setValue(ev.target.value);
                },
                layerRefs: {
                    input: element
                },
                _inputFocus: focused,
                onSuffixClick: ()=>{
                    props?.onSuffixClick?.();
                    if (typing) {
                        setValue("");
                        triggerChange("");
                        setTyping(false);
                    }
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$V = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$R;
    const { kind: kind = "normal", disabled: disabled = false, onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onKeyup: onKeyup = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBack: onBack = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            disabled: disabled,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            onKeyup: onKeyup,
            onBack: onBack,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchBox", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$5a58787633b0b5d8 = $451487d20aa3eb8a$var$withLogic$R($451487d20aa3eb8a$var$Component$V);
$451487d20aa3eb8a$export$5a58787633b0b5d8.displayName = "SearchBox";
$451487d20aa3eb8a$export$5a58787633b0b5d8.slotName = "jds_search_box";
const $451487d20aa3eb8a$var$sdl$Q = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-results-1.0.0",
        "name": "JDSSearchResults",
        "layerName": "jds_search_results"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_search_results_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "background-color": "{global.transparent}",
            "priority": 40,
            "hidden": true,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{flexDirection.stack}",
            "justify-content": "{justifyContent.center}",
            "width": "{size.max}",
            "background-color": "{global.transparent}",
            "border-radius": 0
        }
    },
    "variant": {
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        },
        "appearance": {
            "box": {
                "jds_search_results_internal": {
                    "appearance": "box"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "appearance": {
                "values": [
                    "normal",
                    "box"
                ],
                "doc_description": "This determines the appearance of search results, it can be 'normal or 'box'."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to open or close search result items."
            }
        },
        "data": {
            "jds_search_results_internal": {
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "header": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It is a heading that will display in the Header of the SearchResults."
                },
                "headerAction": {
                    "type": "string",
                    "name": "headerAction",
                    "doc_description": "If this is passed a button will appear on the right side of the Heading in the Header."
                },
                "results": {
                    "type": "list",
                    "name": "results",
                    "function": true,
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                },
                "results.label": {
                    "type": "string",
                    "name": "results.label"
                },
                "results.icon": {
                    "type": "icon",
                    "name": "results.icon"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "events": {
            "jds_search_results_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onClick": "onClick",
                "onHeaderActionClick": "onHeaderActionClick",
                "onContainerClick": "_onContainerClick"
            },
            "popup": {
                "onClick": "onClose"
            }
        },
        "a11y": {
            "jds_search_results_internal": {
                "name": "results",
                "repeating": {
                    "ariaLabel": "resultAriaLabel",
                    "ariaDescribedby": {
                        "name": "resultAriaDescribedby",
                        "platform": "web,ios"
                    }
                },
                "properties": {
                    "headerActionAriaLabel": "headerActionAriaLabel",
                    "headerActionAriaDescribedby": {
                        "name": "headerActionAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaHidden": "headerActionAriaHidden"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$c = (props)=>({
        properties: {
            results: props.results?.map((r)=>({
                    ...r,
                    title: r.label,
                    icon: r.icon
                })),
            header: props.header,
            headerAction: props.headerAction?.title,
            onHeaderActionClick: props.headerAction?.onClick
        }
    });
const $451487d20aa3eb8a$var$withLogic$Q = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$c);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $7a9adcfb845e594f$exports.Fragment), {
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...{
                    ...props,
                    _onContainerClick: (ev)=>ev.stopPropagation()
                }
            })
        });
    };
const $451487d20aa3eb8a$var$Component$U = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$Q;
    const { appearance: appearance = "normal", open: open = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHeaderActionClick: onHeaderActionClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            appearance: appearance,
            open: open,
            onClick: onClick,
            onHeaderActionClick: onHeaderActionClick,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResults", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$aee53da69e9839be = $451487d20aa3eb8a$var$withLogic$Q($451487d20aa3eb8a$var$Component$U);
$451487d20aa3eb8a$export$aee53da69e9839be.displayName = "SearchResults";
$451487d20aa3eb8a$export$aee53da69e9839be.slotName = "jds_search_results";
const $451487d20aa3eb8a$var$sdl$P = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-results-1.0.0",
        "name": "JDSSearchResultsInternal",
        "layerName": "jds_search_results_internal"
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    {
                        "heading-container": [
                            "jds-text",
                            "jds_action_button"
                        ]
                    },
                    {
                        "results-container": [
                            "jds_search_result_item"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "background-color": "{primaryBackground}",
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.center}",
            "padding-top": "{base}",
            "padding-right": "{base}",
            "padding-bottom": "{base}",
            "padding-left": "{base}",
            "gap": "{base}",
            "width": "{size.max}"
        },
        "container": {
            "width": "{size.max}",
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.center}"
        },
        "heading-container": {
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.spaceBetween}",
            "align-items": "{alignItems.start}",
            "width": "{size.max}"
        },
        "jds_action_button": {
            "kind": "tertiary",
            "size": "small",
            "appearance": "normal",
            "state": "normal",
            "iconPosition": "left",
            "stretch": false
        },
        "results-container": {
            "flex-direction": "{flexDirection.column}",
            "align-items": "{alignItems.start}",
            "gap": "{base}",
            "width": "{size.max}"
        },
        "jds-text": {
            "font-family": "{headingXs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXs}",
            "line-height": "{headingXs}",
            "letter-spacing": "{headingXs}",
            "font-weight": "{headingXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "appearance": {
            "box": {
                "root-container": {
                    "border-radius": "{xl}",
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000014"
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "appearance": {
                "values": [
                    "normal",
                    "box"
                ],
                "doc_description": "This determines the appearance of search results, it can be 'normal or 'box'."
            }
        },
        "data": {
            "container": {
                "max-width": {
                    "type": "size",
                    "name": "maxWidth"
                }
            },
            "jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "headerAction",
                    "doc_description": "If this is passed a button will appear on the right side of the Heading in the Header."
                }
            },
            "results-container": {
                "value": {
                    "type": "list",
                    "name": "results",
                    "function": true,
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                }
            },
            "jds_search_result_item": {
                "label": {
                    "type": "string",
                    "name": "results.label"
                },
                "icon": {
                    "type": "icon",
                    "name": "results.icon"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "header",
                    "doc_description": "It is a heading that will display in the Header of the SearchResults."
                }
            }
        },
        "events": {
            "root-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "jds_search_result_item": {
                "onClick": "onClick"
            },
            "jds_action_button": {
                "onClick": "onHeaderActionClick"
            },
            "container": {
                "onClick": "onContainerClick"
            }
        },
        "a11y": {
            "jds_action_button": {
                "properties": {
                    "ariaLabel": "headerActionAriaLabel",
                    "ariaDescribedby": {
                        "name": "headerActionAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaHidden": {
                        "name": "ariaHidden",
                        "value": "true"
                    }
                }
            },
            "results-container": {
                "name": "results",
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "repeating": {
                    "ariaLabel": "resultAriaLabel",
                    "ariaDescribedby": {
                        "name": "resultAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_result_item": {
                "properties": {
                    "ariaLabel": "results.resultAriaLabel",
                    "ariaDescribedby": "results.resultAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$P = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$T = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$P;
    const { appearance: appearance = "normal", onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHeaderActionClick: onHeaderActionClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaHidden: ariaHidden = "true", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            appearance: appearance,
            onAppear: onAppear,
            onClick: onClick,
            onHeaderActionClick: onHeaderActionClick,
            onContainerClick: onContainerClick,
            ariaHidden: ariaHidden,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultsInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$49b46bbe543bdb4b = $451487d20aa3eb8a$var$withLogic$P($451487d20aa3eb8a$var$Component$T);
$451487d20aa3eb8a$export$49b46bbe543bdb4b.displayName = "SearchResultsInternal";
$451487d20aa3eb8a$export$49b46bbe543bdb4b.slotName = "jds_search_results_internal";
const $451487d20aa3eb8a$var$sdl$O = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-result-item-1.0.0",
        "name": "JDSSearchResultItem",
        "layerName": "jds_search_result_item"
    },
    "hierarchy": {
        "container": [
            "icon",
            {
                "text-container": [
                    "jds_search_result_text"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{s_0}",
            "gap": "{s_1}",
            "padding-top": "{s_2}",
            "padding-bottom": "{s_3}",
            "align-items": "{s_4}",
            "width": "{s_5}",
            "behavior": {
                "hover": {
                    "background-color": "{s_6}"
                },
                "active": {
                    "background-color": "{s_7}"
                },
                "focus": {
                    "background-color": "{s_8}"
                }
            }
        },
        "icon": {
            "size": "{s_9}",
            "color": "{s_10}"
        },
        "text-container": {
            "flex-direction": "{s_11}",
            "justify-content": "{s_12}",
            "align-items": "{s_13}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "container": {
                "_splitLabel.label": {
                    "type": "string",
                    "name": "label"
                },
                "_splitLabel.query": {
                    "type": "string",
                    "name": "query"
                }
            },
            "text-container": {
                "value": {
                    "type": "list",
                    "name": "_splitLabel",
                    "object": {
                        "bold": "boolean",
                        "text": "string"
                    }
                }
            },
            "jds_search_result_text": {
                "text": {
                    "type": "string",
                    "name": "_splitLabel.text"
                },
                "bold": {
                    "type": "boolean",
                    "name": "_splitLabel.bold"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$O = (Component)=>(props)=>{
        const { query: query = "", label: label = "", ...rest } = props;
        const index = label.indexOf(query);
        const leftPart = label.slice(0, index);
        const rightPart = label.slice(index + query.length, label.length);
        const labels = index >= 0 ? [
            leftPart,
            query,
            rightPart
        ] : [
            label
        ];
        const _splitLabel = labels.map((l)=>({
                text: l.replace(" ", "\xa0"),
                bold: query === l
            }));
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                _splitLabel: _splitLabel,
                ariaLabel: props.ariaLabel || label,
                onClick: ()=>{
                    rest?.onClick?.({
                        label: label,
                        icon: rest.icon,
                        index: rest.internalIndex
                    });
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$S = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$O;
    const { onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$56e008c8bd1ccf7c = $451487d20aa3eb8a$var$withLogic$O($451487d20aa3eb8a$var$Component$S);
$451487d20aa3eb8a$export$56e008c8bd1ccf7c.displayName = "SearchResultItem";
$451487d20aa3eb8a$export$56e008c8bd1ccf7c.slotName = "jds_search_result_item";
const $451487d20aa3eb8a$var$sdl$N = {
    "metadata": {
        "version": "1.0.0",
        "id": "search-result-text-1.0.0",
        "name": "JDSSearchResultText",
        "layerName": "jds_search_result_text"
    },
    "hierarchy": {
        "jds-text": []
    },
    "base": {
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey80}"
                }
            }
        }
    },
    "variant": {
        "bold": {
            "true": {
                "jds-text": {
                    "font-family": "{bodySBold}",
                    "font-size": "{bodySBold}",
                    "line-height": "{bodySBold}",
                    "letter-spacing": "{bodySBold}",
                    "font-weight": "{bodySBold}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "bold": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$N = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$R = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$N;
    const { bold: bold = false, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            bold: bold,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSearchResultText", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2a7e910d17016306 = $451487d20aa3eb8a$var$withLogic$N($451487d20aa3eb8a$var$Component$R);
$451487d20aa3eb8a$export$2a7e910d17016306.displayName = "SearchResultText";
$451487d20aa3eb8a$export$2a7e910d17016306.slotName = "jds_search_result_text";
const $451487d20aa3eb8a$var$sdl$M = {
    "metadata": {
        "version": "1.0.0",
        "id": "Segmented-ring-item-1.0.0",
        "name": "JDSSegmentedRingItem",
        "layerName": "jds_segmented_ring_item",
        "internal": true
    },
    "hierarchy": {
        "arc": []
    },
    "base": {
        "arc": {
            "radius": 24,
            "arcWidth": 2,
            "fill": "{primary50}",
            "start": 0,
            "end": 360
        }
    },
    "variant": {
        "size": {
            "xtra-xtra-large": {
                "arc": {
                    "radius": 68,
                    "arcWidth": 4
                }
            },
            "xtra-large": {
                "arc": {
                    "radius": 34,
                    "arcWidth": 3
                }
            },
            "large": {
                "arc": {
                    "radius": 30,
                    "arcWidth": 3
                }
            },
            "small": {
                "arc": {
                    "radius": 20,
                    "arcWidth": 2
                }
            },
            "xtra-small": {
                "arc": {
                    "radius": 16,
                    "arcWidth": 2
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "size": {
                "values": [
                    "medium",
                    "xtra-xtra-large",
                    "xtra-large",
                    "large",
                    "small",
                    "xtra-small"
                ]
            }
        },
        "data": {
            "arc": {
                "start": {
                    "type": "number",
                    "name": "startAngle"
                },
                "end": {
                    "type": "number",
                    "name": "endAngle"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$M = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$Q = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$M;
    const { size: size = "medium", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSegmentedRingItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$28d80c087760154d = $451487d20aa3eb8a$var$withLogic$M($451487d20aa3eb8a$var$Component$Q);
$451487d20aa3eb8a$export$28d80c087760154d.displayName = "SegmentedRingItem";
$451487d20aa3eb8a$export$28d80c087760154d.slotName = "jds_segmented_ring_item";
const $451487d20aa3eb8a$var$sdl$L = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-button-1.0.0",
        "name": "JDSSelectorButton",
        "layerName": "jds_selector_button",
        "description": "A selector button is an interactive control that allows the user to perform a selection action."
    },
    "hierarchy": {
        "container": [
            "left-icon",
            "jds-text",
            "right-icon"
        ]
    },
    "base": {
        "container": {
            "background-color": "{s_0}",
            "flex-direction": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "border-radius": "{s_4}",
            "padding-bottom": "{s_5}",
            "padding-top": "{s_6}",
            "padding-left": "{s_7}",
            "padding-right": "{s_8}",
            "border-width": "{s_9}",
            "gap": "{s_10}",
            "opacity": "{s_11}",
            "behavior": {
                "hover": {
                    "background-color": "{s_12}"
                },
                "active": {
                    "background-color": "{s_13}"
                },
                "focus": {
                    "border-width": "{s_14}",
                    "border-color": "{s_15}"
                }
            }
        },
        "left-icon": {
            "hidden": false,
            "size": "{s_16}",
            "color": "{s_17}",
            "behavior": {
                "hover": {
                    "color": "{s_18}"
                }
            }
        },
        "right-icon": {
            "hidden": true,
            "size": "{s_19}",
            "color": "{s_20}",
            "behavior": {
                "hover": {
                    "color": "{s_21}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryInverse}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_22}"
                }
            }
        }
    },
    "combination": [
        {
            "normal": {
                "primary": {
                    "true": {
                        "container": {
                            "background-color": "{s_23}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_24}"
                                },
                                "active": {
                                    "background-color": "{s_25}"
                                },
                                "focus": {
                                    "border-color": "{s_26}"
                                }
                            }
                        }
                    },
                    "false": {
                        "jds-text": {
                            "behavior": {
                                "hover": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_27}",
                            "border-width": "{s_28}",
                            "border-color": "{s_29}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_30}",
                                    "border-color": "{s_31}"
                                },
                                "active": {
                                    "background-color": "{s_32}"
                                },
                                "focus": {
                                    "border-width": "{s_33}",
                                    "border-color": "{s_34}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_35}"
                        },
                        "right-icon": {
                            "color": "{s_36}"
                        },
                        "jds-text": {
                            "color": "{primary60}"
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_37}",
                            "border-width": "{s_38}",
                            "border-color": "{s_39}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_40}"
                                },
                                "active": {
                                    "background-color": "{s_41}"
                                },
                                "focus": {
                                    "border-width": "{s_42}",
                                    "border-color": "{s_43}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_44}",
                            "behavior": {
                                "active": {
                                    "color": "{s_45}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_46}",
                            "behavior": {
                                "active": {
                                    "color": "{s_47}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "true": {
                        "container": {
                            "background-color": "{s_48}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_49}",
                                    "border-color": "{s_50}",
                                    "border-width": "{s_51}"
                                },
                                "active": {
                                    "background-color": "{s_52}"
                                },
                                "focus": {
                                    "border-width": "{s_53}",
                                    "border-color": "{s_54}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_55}",
                            "behavior": {
                                "active": {
                                    "color": "{s_56}"
                                },
                                "hover": {
                                    "color": "{s_57}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_58}",
                            "behavior": {
                                "active": {
                                    "color": "{s_59}"
                                },
                                "hover": {
                                    "color": "{s_60}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                },
                                "hover": {}
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_61}",
                            "behavior": {
                                "hover": {
                                    "border-width": "{s_62}",
                                    "border-color": "{s_63}",
                                    "background-color": "{s_64}"
                                },
                                "active": {
                                    "background-color": "{s_65}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_66}",
                            "behavior": {
                                "active": {
                                    "color": "{s_67}"
                                },
                                "hover": {
                                    "color": "{s_68}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_69}",
                            "behavior": {
                                "active": {
                                    "color": "{s_70}"
                                },
                                "hover": {
                                    "color": "{s_71}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}"
                        }
                    }
                },
                "tertiary_narrow": {
                    "true": {
                        "container": {
                            "background-color": "{s_72}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_73}",
                                    "border-color": "{s_74}"
                                },
                                "hover": {
                                    "background-color": "{s_75}"
                                },
                                "active": {
                                    "background-color": "{s_76}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_77}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_78}"
                                },
                                "active": {
                                    "color": "{s_79}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_80}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_81}"
                                },
                                "active": {
                                    "color": "{s_82}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary70}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                },
                                "active": {
                                    "color": "{primary80}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_83}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_84}"
                                },
                                "active": {
                                    "background-color": "{s_85}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_86}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_87}"
                                },
                                "active": {
                                    "color": "{s_88}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_89}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_90}"
                                },
                                "active": {
                                    "color": "{s_91}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                }
            },
            "grey_scale": {
                "primary": {
                    "false": {
                        "container": {
                            "background-color": "{s_92}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_93}"
                                },
                                "active": {
                                    "background-color": "{s_94}"
                                },
                                "focus": {
                                    "border-width": "{s_95}",
                                    "border-color": "{s_96}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_97}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_98}"
                                },
                                "active": {
                                    "color": "{s_99}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_100}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_101}"
                                },
                                "active": {
                                    "color": "{s_102}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary70}"
                                },
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_103}",
                            "border-width": "{s_104}",
                            "border-color": "{s_105}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_106}",
                                    "border-color": "{s_107}"
                                },
                                "active": {
                                    "background-color": "{s_108}"
                                },
                                "focus": {
                                    "border-width": "{s_109}",
                                    "border-color": "{s_110}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_111}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_295}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_112}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_296}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_113}",
                            "border-width": 1,
                            "border-color": "{s_114}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_115}"
                                },
                                "active": {
                                    "background-color": "{s_116}"
                                },
                                "focus": {
                                    "border-width": "{s_117}",
                                    "border-color": "{s_118}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_119}",
                            "behavior": {
                                "active": {
                                    "color": "{s_120}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_121}",
                            "behavior": {
                                "active": {
                                    "color": "{s_122}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "true": {
                        "container": {
                            "background-color": "{s_123}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_124}",
                                    "border-width": "{s_125}"
                                },
                                "active": {
                                    "background-color": "{s_126}"
                                },
                                "focus": {
                                    "border-width": "{s_127}",
                                    "border-color": "{s_128}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_129}",
                            "behavior": {
                                "active": {
                                    "color": "{s_130}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_131}",
                            "behavior": {
                                "active": {
                                    "color": "{s_132}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "active": {
                                    "color": "{primary70}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_133}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_134}",
                                    "border-width": "{s_135}",
                                    "background-color": "{s_136}"
                                },
                                "active": {
                                    "background-color": "{s_137}"
                                },
                                "focus": {
                                    "border-width": "{s_138}",
                                    "border-color": "{s_139}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_140}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_141}"
                                },
                                "active": {
                                    "color": "{s_142}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_143}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_144}"
                                },
                                "active": {
                                    "color": "{s_145}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary60}"
                                },
                                "active": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    }
                },
                "tertiary_narrow": {
                    "true": {
                        "container": {
                            "background-color": "{s_146}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_147}"
                                },
                                "focus": {
                                    "border-width": "{s_148}",
                                    "border-color": "{s_149}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_150}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_151}"
                                },
                                "active": {
                                    "color": "{s_152}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_153}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_154}"
                                },
                                "active": {
                                    "color": "{s_155}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary60}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary80}"
                                }
                            }
                        }
                    },
                    "false": {
                        "container": {
                            "background-color": "{s_156}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_157}"
                                },
                                "focus": {
                                    "border-width": "{s_158}",
                                    "border-color": "{s_159}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_160}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_161}"
                                },
                                "active": {
                                    "color": "{s_162}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_163}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_164}"
                                },
                                "active": {
                                    "color": "{s_165}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey80}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary50}"
                                },
                                "active": {
                                    "color": "{primary60}"
                                }
                            }
                        }
                    }
                }
            },
            "contrast": {
                "primary": {
                    "false": {
                        "container": {
                            "background-color": "{s_166}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_167}"
                                },
                                "active": {
                                    "background-color": "{s_168}"
                                },
                                "focus": {
                                    "border-width": "{s_169}",
                                    "border-color": "{s_170}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_171}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_172}"
                                },
                                "focus": {
                                    "color": "{s_173}"
                                },
                                "active": {
                                    "color": "{s_174}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_175}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_176}"
                                },
                                "focus": {
                                    "color": "{s_177}"
                                },
                                "active": {
                                    "color": "{s_178}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "hover": {},
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_179}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_180}"
                                },
                                "active": {
                                    "background-color": "{s_181}"
                                },
                                "focus": {
                                    "background-color": "{s_182}",
                                    "border-width": "{s_183}",
                                    "border-color": "{s_184}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_185}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_186}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_187}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_188}"
                                }
                            }
                        },
                        "jds-text": {
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    }
                },
                "secondary": {
                    "false": {
                        "container": {
                            "background-color": "{s_189}",
                            "border-width": "{s_190}",
                            "border-color": "{s_191}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_192}",
                                    "border-color": "{s_193}"
                                },
                                "active": {
                                    "background-color": "{s_194}"
                                },
                                "focus": {
                                    "border-width": "{s_195}",
                                    "border-color": "{s_196}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_197}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_198}"
                                },
                                "active": {
                                    "color": "{s_199}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_200}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_201}"
                                },
                                "active": {
                                    "color": "{s_202}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                },
                                "active": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_203}",
                            "border-width": 1,
                            "border-color": "{s_204}",
                            "behavior": {
                                "hover": {
                                    "border-color": "{s_205}"
                                },
                                "active": {
                                    "background-color": "{s_206}"
                                },
                                "focus": {
                                    "border-width": "{s_207}",
                                    "border-color": "{s_208}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_209}",
                            "behavior": {
                                "active": {
                                    "color": "{s_210}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_211}",
                            "behavior": {
                                "active": {
                                    "color": "{s_212}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "active": {
                                    "color": "{primaryInverse}"
                                }
                            }
                        }
                    }
                },
                "tertiary": {
                    "false": {
                        "container": {
                            "background-color": "{s_213}",
                            "behavior": {
                                "hover": {
                                    "background-color": "{s_214}",
                                    "border-width": 1,
                                    "border-color": "{s_215}"
                                },
                                "active": {
                                    "background-color": "{s_216}"
                                },
                                "focus": {
                                    "border-width": "{s_217}",
                                    "border-color": "{s_218}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_219}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_220}"
                                },
                                "active": {
                                    "color": "{s_221}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_222}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_223}"
                                },
                                "active": {
                                    "color": "{s_224}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primaryGrey100}"
                                },
                                "active": {
                                    "color": "{primaryGrey100}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_225}",
                            "behavior": {
                                "hover": {
                                    "border-width": 1,
                                    "border-color": "{s_226}"
                                },
                                "focus": {
                                    "border-width": "{s_227}",
                                    "border-color": "{s_228}"
                                },
                                "active": {
                                    "background-color": "{s_229}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_230}",
                            "behavior": {
                                "active": {
                                    "background-color": "{s_231}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_232}",
                            "behavior": {
                                "active": {
                                    "background-color": "{s_233}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryGrey100}",
                            "behavior": {
                                "active": {
                                    "background-color": "primary_inverse"
                                }
                            }
                        }
                    }
                },
                "tertiary_narrow": {
                    "false": {
                        "container": {
                            "background-color": "{s_234}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_235}",
                                    "border-color": "{s_236}"
                                },
                                "hover": {
                                    "background-color": "{s_237}"
                                },
                                "active": {
                                    "background-color": "{s_238}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_239}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_240}"
                                },
                                "active": {
                                    "color": "{s_241}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_242}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_243}"
                                },
                                "active": {
                                    "color": "{s_244}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primaryBackground}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary20}"
                                },
                                "active": {
                                    "color": "{primary30}"
                                }
                            }
                        }
                    },
                    "true": {
                        "container": {
                            "background-color": "{s_245}",
                            "behavior": {
                                "focus": {
                                    "border-width": "{s_246}",
                                    "border-color": "{s_247}"
                                },
                                "hover": {
                                    "background-color": "{s_248}"
                                },
                                "active": {
                                    "background-color": "{s_249}"
                                }
                            }
                        },
                        "left-icon": {
                            "color": "{s_250}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_251}"
                                },
                                "active": {
                                    "color": "{s_252}"
                                },
                                "focus": {
                                    "color": "{s_253}"
                                }
                            }
                        },
                        "right-icon": {
                            "color": "{s_254}",
                            "behavior": {
                                "hover": {
                                    "color": "{s_255}"
                                },
                                "active": {
                                    "color": "{s_256}"
                                },
                                "focus": {
                                    "color": "{s_257}"
                                }
                            }
                        },
                        "jds-text": {
                            "color": "{primary30}",
                            "behavior": {
                                "hover": {
                                    "color": "{primary20}"
                                },
                                "active": {},
                                "focus": {}
                            }
                        }
                    }
                }
            }
        },
        {
            "tertiary_narrow": {
                "small": {
                    "container": {
                        "padding-bottom": "{s_258}",
                        "padding-top": "{s_259}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "medium": {
                    "container": {
                        "padding-bottom": "{s_260}",
                        "padding-top": "{s_261}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "large": {
                    "container": {
                        "padding-bottom": "{s_262}",
                        "padding-top": "{s_263}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                },
                "extra_large": {
                    "container": {
                        "padding-bottom": "{s_264}",
                        "padding-top": "{s_265}",
                        "padding-left": 0,
                        "padding-right": 0
                    }
                }
            }
        },
        {
            "true": {
                "small": {
                    "container": {
                        "padding-top": "{s_266}",
                        "padding-bottom": "{s_267}"
                    },
                    "left-icon": {
                        "size": "{s_268}"
                    },
                    "right-icon": {
                        "size": "{s_269}"
                    },
                    "jds-text": {}
                },
                "large": {
                    "container": {
                        "padding-top": "{s_270}",
                        "padding-left": "{s_271}",
                        "padding-bottom": "{s_272}",
                        "padding-right": "{s_273}"
                    },
                    "left-icon": {
                        "size": "{s_274}"
                    },
                    "right-icon": {
                        "size": "{s_275}"
                    },
                    "jds-text": {
                        "font-family": "{bodyMBold}",
                        "font-size": "{bodyMBold}",
                        "line-height": "{bodyMBold}",
                        "letter-spacing": "{bodyMBold}",
                        "font-weight": "{bodyMBold}"
                    }
                },
                "extra_large": {
                    "container": {
                        "padding-top": "{s_276}",
                        "padding-right": "{s_277}",
                        "padding-bottom": "{s_278}",
                        "padding-left": "{s_279}"
                    },
                    "left-icon": {
                        "size": "{s_280}"
                    },
                    "right-icon": {
                        "size": "{s_281}"
                    },
                    "jds-text": {
                        "font-family": "{bodyLBold}",
                        "font-size": "{bodyLBold}",
                        "line-height": "{bodyLBold}",
                        "letter-spacing": "{bodyLBold}",
                        "font-weight": "{bodyLBold}"
                    }
                }
            },
            "false": {
                "small": {
                    "container": {
                        "width": "{s_282}",
                        "height": "{s_283}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_284}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "medium": {
                    "container": {
                        "width": "{s_285}",
                        "height": "{s_286}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "large": {
                    "container": {
                        "width": "{s_287}",
                        "height": "{s_288}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_289}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                },
                "extra_large": {
                    "container": {
                        "width": "{s_290}",
                        "height": "{s_291}",
                        "padding-left": 0,
                        "padding-top": 0,
                        "padding-right": 0,
                        "padding-bottom": 0
                    },
                    "left-icon": {
                        "size": "{s_292}"
                    },
                    "jds-text": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "right": {
                    "left-icon": {
                        "hidden": true
                    },
                    "right-icon": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "container": {
                        "width": "{s_293}",
                        "justify-content": "{s_294}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "appearance",
            "kind",
            "selected"
        ],
        [
            "kind",
            "size"
        ],
        [
            "_hasText",
            "size"
        ],
        [
            "_hasText",
            "iconPosition"
        ],
        [
            "_hasText",
            "stretch"
        ]
    ],
    "api": {
        "config": {
            "kind": {
                "values": [
                    "primary",
                    "secondary",
                    "tertiary",
                    "tertiary_narrow"
                ]
            },
            "iconPosition": {
                "values": [
                    "left",
                    "right"
                ]
            },
            "appearance": {
                "values": [
                    "normal",
                    "grey_scale",
                    "contrast"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large",
                    "extra_large"
                ],
                "doc_description": "Sizes of the button"
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SelectorButton."
            },
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "stretch": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasText": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "container": {
                "type": {
                    "name": "type",
                    "type": "string",
                    "platform": "web"
                }
            },
            "left-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "right-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "text"
                }
            }
        },
        "events": {
            "container": {
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                },
                "onBlur": {
                    "name": "onBlur",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "text"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-pressed": {
                        "name": "_ariaPressed",
                        "prop": "selected"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$b = (props)=>{
    if (props.size === "extra-large") console.warn("extra-large size is deprecated. use `extra_large`");
    if (props.appearance === "grey-scale") console.warn("grey-scale appearance is deprecated. use `grey_scale`");
    if (props.kind === "tertiary-narrow") console.warn("tertiary-narrow prop of kind is deprecated. Use `tertirary_narrow`");
    return {
        appearance: {
            properties: {
                appearance: props.appearance
            },
            variations: {
                "grey-scale": {
                    appearance: "grey_scale"
                },
                contrast: {
                    appearance: "contrast"
                },
                normal: {
                    appearance: "normal"
                }
            }
        },
        size: {
            properties: {
                size: props.size
            },
            variations: {
                medium: {
                    size: "medium"
                },
                small: {
                    size: "small"
                },
                large: {
                    size: "large"
                },
                "extra-large": {
                    size: "extra_large"
                }
            }
        },
        label: {
            properties: {
                text: props.label
            }
        },
        children: {
            properties: {
                text: props.children
            }
        },
        icon: {
            properties: {
                icon: props.icon
            }
        },
        kind: {
            properties: {
                kind: props.kind
            },
            variations: {
                primary: {
                    kind: "primary"
                },
                secondary: {
                    kind: "secondary"
                },
                tertiary: {
                    kind: "tertiary"
                },
                "tertiary-narrow": {
                    kind: "tertiary_narrow"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$L = (Component)=>(0, $1OEoy.forwardRef)((userProps, ref)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$b);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasText: Boolean(props.text?.length || props?.children),
                rootRef: ref
            }
        });
    });
const $451487d20aa3eb8a$var$Component$P = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$L;
    const { kind: kind = "primary", iconPosition: iconPosition = "left", appearance: appearance = "normal", size: size = "medium", disabled: disabled = false, selected: selected = false, stretch: stretch = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.text?.toString(), _ariaPressed: _ariaPressed = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            iconPosition: iconPosition,
            appearance: appearance,
            size: size,
            disabled: disabled,
            selected: selected,
            stretch: stretch,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            ariaLabel: ariaLabel,
            _ariaPressed: _ariaPressed,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelectorButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$880a7f9ee0ea89e0 = $451487d20aa3eb8a$var$withLogic$L($451487d20aa3eb8a$var$Component$P);
$451487d20aa3eb8a$export$880a7f9ee0ea89e0.displayName = "SelectorButton";
$451487d20aa3eb8a$export$880a7f9ee0ea89e0.slotName = "jds_selector_button";
const $451487d20aa3eb8a$var$sdl$K = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-item-1.0.0",
        "name": "JDSSelectorItem",
        "layerName": "jds_selector_item",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "icon",
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "opacity": "{s_0}",
            "background-color": "{s_1}",
            "flex-direction": "{s_2}",
            "align-items": "{s_3}",
            "justify-content": "{s_4}",
            "border-radius": "{s_5}",
            "gap": "{s_6}",
            "padding-top": "{s_7}",
            "padding-right": "{s_8}",
            "padding-bottom": "{s_9}",
            "padding-left": "{s_10}",
            "behavior": {
                "focus": {
                    "background-color": "{s_11}",
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": "{s_12}",
                        "color": "{s_13}"
                    }
                },
                "hover": {
                    "background-color": "{s_14}"
                },
                "active": {
                    "background-color": "{s_15}"
                }
            }
        },
        "icon": {
            "size": "{s_16}",
            "color": "{s_17}",
            "hidden": false
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primary60}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "selected": {
            "true": {
                "container": {
                    "behavior": {
                        "hover": {
                            "background-color": "{s_19}"
                        },
                        "active": {
                            "background-color": "{s_20}"
                        },
                        "focus": {
                            "background-color": "{s_21}"
                        }
                    }
                },
                "icon": {
                    "color": "{s_22}",
                    "behavior": {
                        "active": {
                            "color": "{s_23}"
                        }
                    }
                },
                "jds-text": {
                    "color": "{primaryInverse}",
                    "behavior": {
                        "hover": {},
                        "active": {
                            "color": "{primary30}"
                        }
                    }
                }
            }
        },
        "kind": {
            "label": {
                "icon": {
                    "hidden": true
                }
            },
            "icon": {
                "jds-text": {
                    "hidden": true
                }
            }
        },
        "wrap": {
            "vertical": {
                "container": {
                    "flex-direction": "{s_24}",
                    "gap": "{s_27}"
                }
            }
        },
        "stretch": {
            "true": {
                "container": {
                    "width": "{s_25}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_26}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "stretch": {
                "values": [
                    false,
                    true
                ]
            },
            "kind": {
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "wrap": {
                "values": [
                    "horizontal",
                    "vertical"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "events": {
            "container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onClick",
                "onFocus": {
                    "name": "onFocus",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "selected"
                    }
                }
            },
            "icon": {
                "properties": {
                    "role": {
                        "value": "img"
                    },
                    "aria-label": {
                        "name": "iconAriaLabel",
                        "function": true
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$K = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                selected: props.check || props.selectedIndex === props.internalIndex,
                iconAriaLabel: props.iconAriaLabel || $451487d20aa3eb8a$var$formatIconName(props.icon)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$O = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$K;
    const { selected: selected = false, stretch: stretch = false, kind: kind = "label_icon", wrap: wrap = "horizontal", disabled: disabled = false, onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            selected: selected,
            stretch: stretch,
            kind: kind,
            wrap: wrap,
            disabled: disabled,
            onAppear: onAppear,
            onClick: onClick,
            onFocus: onFocus,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelectorItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ec8540225d9cc6a2 = $451487d20aa3eb8a$var$withLogic$K($451487d20aa3eb8a$var$Component$O);
$451487d20aa3eb8a$export$ec8540225d9cc6a2.displayName = "SelectorItem";
$451487d20aa3eb8a$export$ec8540225d9cc6a2.slotName = "jds_selector_item";
const $451487d20aa3eb8a$var$sdl$J = {
    "metadata": {
        "version": "1.0.0",
        "id": "side-panel-1.0.0",
        "layerName": "jds_side_panel_internal",
        "name": "JDSSidePanelInternal",
        "description": "",
        "internal": true
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            "avatar-slot",
                            "header-text-slot"
                        ]
                    },
                    "suffix-jds_action_button"
                ]
            },
            "children-slot",
            {
                "section-container": [
                    "jds_side_panel_item"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "width": 412,
            "height": "{s_5}",
            "flex-direction": "{s_6}",
            "background-color": "{s_7}",
            "enter-animation-name": "slideHorizontallyToRight",
            "exit-animation-name": "slideHorizontallyToLeft",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "hidden": true,
            "translate-x": "{size.negativeMax}",
            "transition": {
                "property": [
                    "translate-x"
                ],
                "duration": "{medium}",
                "timing-function": "{easeRapid}"
            }
        },
        "section-container": {
            "hidden": true,
            "height": "{s_8}",
            "width": "{s_9}",
            "flex-direction": "{s_10}",
            "justify-content": "{s_11}",
            "align-items": "{s_12}",
            "padding-left": "{s_13}",
            "padding-top": "{s_14}",
            "padding-right": "{s_15}"
        },
        "header-container": {
            "background-color": "{s_16}",
            "padding-top": "{s_17}",
            "padding-bottom": "{s_18}",
            "padding-right": "{s_19}",
            "padding-left": "{s_20}",
            "width": "{s_21}",
            "justify-content": "{s_22}",
            "align-items": "{s_23}"
        },
        "left-container": {
            "flex-direction": "{s_24}",
            "gap": "{s_25}",
            "align-items": "{s_26}"
        },
        "suffix-jds_action_button": {
            "hidden": false,
            "icon": "ic_close",
            "size": "large"
        }
    },
    "variant": {
        "open": {
            "true": {
                "container": {
                    "hidden": false,
                    "translate-x": 0,
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "direction": {
            "right": {
                "container": {
                    "enter-animation-name": "slideHorizontallyToLeft",
                    "exit-animation-name": "slideHorizontallyToRight"
                }
            }
        },
        "showClose": {
            "false": {
                "suffix-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "_hasChildren": {
            "true": {
                "section-container": {
                    "hidden": false
                },
                "children-slot": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "desktop": {
                    "container": {
                        "width": "{s_28}"
                    }
                },
                "mobile": {
                    "container": {
                        "width": "{s_29}"
                    }
                }
            },
            "false": {
                "desktop": {
                    "container": {
                        "width": 412
                    }
                },
                "mobile": {
                    "container": {
                        "width": "{s_30}"
                    }
                }
            }
        },
        {
            "false": {
                "right": {
                    "container": {
                        "translate-x": "{size.max}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "maxWidth",
            "_platform"
        ],
        [
            "open",
            "direction"
        ]
    ],
    "api": {
        "children": {
            "avatar-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_button"
                ],
                "max": 1
            },
            "header-text-slot": {
                "name": "header",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "Has pre-defined suffix as close button."
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "doc_description": "Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks."
            }
        },
        "config": {
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "direction": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "Determines whether open/close should happen from left or right."
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Whether a close on the right should be shown."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Can be used to programatically open/close the drawer with animation and selected direction."
            },
            "maxWidth": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "If set it will limit max width of the panel to 412px.",
                "function": true
            },
            "_hasChildren": {
                "values": [
                    false,
                    true
                ]
            },
            "disableTransition": {
                "values": [
                    false,
                    true
                ],
                "platform": "web"
            }
        },
        "data": {
            "section-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "title": "string",
                        "prefix": "icon",
                        "showSuffix": "boolean",
                        "type": "JDSSidePanelItem.type"
                    }
                }
            },
            "jds_side_panel_item": {
                "prefix": {
                    "type": "string",
                    "name": "items.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "items.title"
                },
                "showSuffix": {
                    "type": "boolean",
                    "name": "links.showSuffix"
                },
                "type": {
                    "type": "string",
                    "name": "items.type"
                }
            }
        },
        "events": {
            "suffix-jds_action_button": {
                "onClick": "onClose"
            },
            "container": {
                "onClick": "onContainerClick",
                "onSwipeLeft": "onSwipeLeft"
            },
            "jds_side_panel_item": {
                "onSuffixClick": "onSidePanelSuffixClick"
            }
        },
        "a11y": {
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "suffixAriaLabel",
                        "value": "Close Side Panel"
                    }
                }
            },
            "section-container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "list"
                    }
                },
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "itemSuffixAriaLabel": "itemSuffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_side_panel_item": {
                "properties": {
                    "ariaLabel": "items.itemAriaLabel",
                    "itemSuffixAriaLabel": "items.itemSuffixAriaLabel",
                    "ariaDescribedby": "items.itemAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$J = (Component)=>(props)=>{
        const { onSwipeLeft: onSwipeLeft, ...rest } = props;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...rest
        });
    };
const $451487d20aa3eb8a$var$Component$N = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$J;
    const { direction: direction = "left", showClose: showClose = true, open: open = false, maxWidth: maxWidth = false, disableTransition: disableTransition = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onContainerClick: onContainerClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSwipeLeft: onSwipeLeft = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSidePanelSuffixClick: onSidePanelSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), suffixAriaLabel: suffixAriaLabel = "Close Side Panel", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            direction: direction,
            showClose: showClose,
            open: open,
            maxWidth: maxWidth,
            disableTransition: disableTransition,
            onClose: onClose,
            onContainerClick: onContainerClick,
            onSwipeLeft: onSwipeLeft,
            onSidePanelSuffixClick: onSidePanelSuffixClick,
            suffixAriaLabel: suffixAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSidePanelInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$8b5d5577a4deadf6 = $451487d20aa3eb8a$var$withLogic$J($451487d20aa3eb8a$var$Component$N);
$451487d20aa3eb8a$export$8b5d5577a4deadf6.displayName = "SidePanelInternal";
$451487d20aa3eb8a$export$8b5d5577a4deadf6.slotName = "jds_side_panel_internal";
const $451487d20aa3eb8a$var$sdl$I = {
    "metadata": {
        "version": "1.0.0",
        "id": "spinner-1.0.0",
        "name": "JDSSpinner",
        "layerName": "jds_spinner"
    },
    "hierarchy": {
        "container": [
            {
                "spinner-container": [
                    {
                        "arc-container": [
                            "base-arc",
                            "normal-arc",
                            "third-arc",
                            "second-arc",
                            "first-arc"
                        ]
                    }
                ]
            },
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "background-color": "{s_0}",
            "gap": "{s_1}",
            "justify-content": "{s_2}",
            "align-items": "{s_3}",
            "flex-direction": "{s_4}"
        },
        "spinner-container": {
            "size": "{s_5}"
        },
        "arc-container": {
            "flex-direction": "{s_6}",
            "justify-content": "{s_7}",
            "align-items": "{s_8}",
            "size": "{s_9}"
        },
        "base-arc": {
            "fill": "{s_10}",
            "radius": "{s_11}",
            "arcWidth": "{s_12}",
            "start": "{s_13}",
            "end": "{s_14}",
            "z-index": 0
        },
        "normal-arc": {
            "fill": "{s_15}",
            "radius": "{s_16}",
            "arcWidth": "{s_17}",
            "start": "{s_18}",
            "end": "{s_19}",
            "z-index": 1,
            "animation-duration": "{s_20}",
            "animate": true
        },
        "first-arc": {
            "hidden": true,
            "fill": "{s_21}",
            "radius": "{s_22}",
            "arcWidth": "{s_23}",
            "start": "{s_24}",
            "end": "{s_25}",
            "z-index": 3,
            "animation-delay": "{s_26}",
            "animation-duration": "{s_27}",
            "animate": true
        },
        "second-arc": {
            "hidden": true,
            "fill": "{s_28}",
            "radius": "{s_29}",
            "arcWidth": "{s_30}",
            "start": "{s_31}",
            "end": "{s_32}",
            "z-index": 2,
            "animation-delay": "{s_33}",
            "animation-duration": "{s_34}",
            "animate": true
        },
        "third-arc": {
            "hidden": true,
            "fill": "{s_35}",
            "radius": "{s_36}",
            "arcWidth": "{s_37}",
            "start": "{s_38}",
            "end": "{s_39}",
            "z-index": 1,
            "animation-duration": "{s_40}",
            "animate": true
        },
        "jds-text": {
            "font-family": "{bodyM}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyM}",
            "line-height": "{bodyM}",
            "letter-spacing": "{bodyM}",
            "font-weight": "{bodyM}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "labelPosition": {
            "bottom": {
                "container": {
                    "flex-direction": "{s_41}"
                }
            }
        },
        "size": {
            "small": {
                "container": {
                    "gap": "{s_42}"
                },
                "spinner-container": {
                    "size": "{s_43}"
                },
                "base-arc": {
                    "arcWidth": "{s_44}",
                    "radius": "{s_45}"
                },
                "normal-arc": {
                    "arcWidth": "{s_46}",
                    "radius": "{s_47}"
                },
                "first-arc": {
                    "arcWidth": "{s_48}",
                    "radius": "{s_49}"
                },
                "second-arc": {
                    "arcWidth": "{s_50}",
                    "radius": "{s_51}"
                },
                "third-arc": {
                    "arcWidth": "{s_52}",
                    "radius": "{s_53}"
                },
                "jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            }
        },
        "isOverlay": {
            "true": {
                "jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_determinate": {
            "true": {
                "normal-arc": {
                    "animate": false
                }
            }
        }
    },
    "combination": [
        {
            "small": {
                "bottom": {
                    "container": {
                        "flex-direction": "{s_55}"
                    }
                }
            }
        },
        {
            "false": {
                "inline": {
                    "normal-arc": {
                        "fill": "{s_54}"
                    }
                },
                "vibrant": {
                    "normal-arc": {
                        "hidden": true
                    },
                    "first-arc": {
                        "hidden": false
                    },
                    "second-arc": {
                        "hidden": false
                    },
                    "third-arc": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "size",
            "labelPosition"
        ],
        [
            "_determinate",
            "kind"
        ]
    ],
    "api": {
        "config": {
            "labelPosition": {
                "values": [
                    "right",
                    "bottom"
                ],
                "doc_description": "It determines the position of the label. Note: if using a small spinner, the label can only be positioned on the right."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control size od Spinner."
            },
            "kind": {
                "values": [
                    "normal",
                    "inline",
                    "vibrant"
                ],
                "doc_description": "It determines the appearance of the spinner .`inline` inherits from text color,`normal`: single color, `vibrant`: three color."
            },
            "isOverlay": {
                "values": [
                    false,
                    true
                ]
            },
            "_determinate": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "normal-arc": {
                "end": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It can be used to take value of spinner from user."
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays the label of Spinner."
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Loading"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-live": {
                        "name": "ariaLive",
                        "value": "polite"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$a = (props)=>({
        appearance: {
            properties: {
                kind: props.appearance
            }
        }
    });
const $451487d20aa3eb8a$var$withLogic$I = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$a);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            appearance: props.appearance || "normal",
            ...{
                ...props,
                _determinate: props.value !== void 0
            }
        });
    };
const $451487d20aa3eb8a$var$Component$M = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$I;
    const { labelPosition: labelPosition = "right", size: size = "medium", kind: kind = "normal", isOverlay: isOverlay = false, ariaLabel: ariaLabel = "Loading", ariaLive: ariaLive = "polite", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            labelPosition: labelPosition,
            size: size,
            kind: kind,
            isOverlay: isOverlay,
            ariaLabel: ariaLabel,
            ariaLive: ariaLive,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSpinner", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$7f7cbe89f1eacd2 = $451487d20aa3eb8a$var$withLogic$I($451487d20aa3eb8a$var$Component$M);
$451487d20aa3eb8a$export$7f7cbe89f1eacd2.displayName = "Spinner";
$451487d20aa3eb8a$export$7f7cbe89f1eacd2.slotName = "jds_spinner";
const $451487d20aa3eb8a$var$sdl$H = {
    "metadata": {
        "name": "JDSStepperDot",
        "version": "1.0.0",
        "layerName": "jds_stepper_dot",
        "description": "Steppers help break a complex task into a series of manageable steps and guides useres through each step of their progress.",
        "usage": "Steppers are used to support new and improve existing processes such as checkout and account application journeys.",
        "internal": true
    },
    "hierarchy": {
        "step-icon-container": [
            "count-jds-text",
            "icon",
            "complete-icon",
            "dot-container"
        ]
    },
    "base": {
        "step-icon-container": {
            "background-color": "{s_0}",
            "border-width": "{s_1}",
            "border-color": "{s_2}",
            "min-height": "{s_3}",
            "min-width": "{s_4}",
            "justify-content": "{s_5}",
            "align-items": "{s_6}",
            "border-radius": "{s_7}",
            "show": true
        },
        "icon": {
            "hidden": true,
            "color": "{s_8}",
            "size": "{s_9}"
        },
        "complete-icon": {
            "hidden": true,
            "value": "ic_confirm",
            "color": "{s_10}",
            "size": "{s_11}"
        },
        "dot-container": {
            "hidden": true,
            "background-color": "{s_12}",
            "width": "{s_13}",
            "height": "{s_14}",
            "border-radius": "{s_15}",
            "show": true
        },
        "count-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{sparkleGrey60}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "state": {
            "active": {
                "step-icon-container": {
                    "background-color": "{s_16}",
                    "border-color": "{s_17}"
                },
                "icon": {
                    "color": "{s_18}"
                },
                "dot-container": {
                    "background-color": "{s_19}"
                },
                "count-jds-text": {
                    "color": "{sparkleInverse}"
                }
            },
            "complete": {
                "step-icon-container": {
                    "background-color": "{s_20}",
                    "border-color": "{s_21}"
                },
                "complete-icon": {
                    "hidden": false
                },
                "count-jds-text": {
                    "hidden": true
                }
            },
            "disabled": {
                "step-icon-container": {
                    "disabled": true,
                    "opacity": "{s_26}"
                }
            }
        },
        "itemsType": {
            "icon": {
                "dot-container": {
                    "hidden": true
                },
                "step-icon-container": {
                    "height": "{s_22}",
                    "width": "{s_23}"
                },
                "count-jds-text": {
                    "hidden": true
                }
            },
            "dot": {
                "icon": {
                    "hidden": true
                },
                "dot-container": {
                    "hidden": false
                },
                "count-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "complete": {
                "icon": {
                    "icon": {
                        "hidden": true
                    }
                },
                "dot": {
                    "dot-container": {
                        "hidden": true
                    }
                }
            },
            "active": {
                "icon": {
                    "icon": {
                        "hidden": false
                    }
                }
            },
            "inactive": {
                "icon": {
                    "icon": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "warning": {
                "active": {
                    "icon": {
                        "hidden": false,
                        "value": "ic_exclamation",
                        "color": "{s_24}"
                    },
                    "dot-container": {
                        "hidden": true
                    },
                    "count-jds-text": {
                        "hidden": true
                    }
                },
                "complete": {
                    "icon": {
                        "hidden": false,
                        "value": "ic_exclamation",
                        "color": "{s_25}"
                    },
                    "complete-icon": {
                        "hidden": true
                    },
                    "dot-container": {
                        "hidden": true
                    },
                    "count-jds-text": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "itemsType"
        ],
        [
            "activeState",
            "state"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "itemsType": {
                "values": [
                    "numbered",
                    "icon",
                    "dot"
                ],
                "doc_description": "Represents the type of Stepper indication."
            },
            "activeState": {
                "values": [
                    "normal",
                    "warning"
                ],
                "doc_description": "Devs will set this to show the warning states for active index only."
            }
        },
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "function": true,
                    "doc_description": "Optional icon. Only shows if parent stepper type is icon."
                }
            },
            "count-jds-text": {
                "value": {
                    "type": "string",
                    "name": "index"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$H = (Component)=>(props)=>{
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props,
            index: numeralList[Number(props.index ?? 0)]
        });
    };
const $451487d20aa3eb8a$var$Component$L = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$H;
    const { state: state = "inactive", itemsType: itemsType = "numbered", activeState: activeState = "normal", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            itemsType: itemsType,
            activeState: activeState,
            ...rest
        },
        componentTag: componentTag
    }, "JDSStepperDot", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$435f28d5690c41ca = $451487d20aa3eb8a$var$withLogic$H($451487d20aa3eb8a$var$Component$L);
$451487d20aa3eb8a$export$435f28d5690c41ca.displayName = "StepperDot";
$451487d20aa3eb8a$export$435f28d5690c41ca.slotName = "jds_stepper_dot";
const $451487d20aa3eb8a$var$sdl$G = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-1.0.0",
        "name": "JDSTabBar",
        "layerName": "jds_tab_bar"
    },
    "hierarchy": {
        "container": [
            {
                "tab-container": [
                    "jds_tab_item"
                ]
            },
            {
                "indicator-container": [
                    {
                        "outer-container": [
                            "inner-container"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_3}",
            "align-items": "{t_4}",
            "width": "{t_1}"
        },
        "indicator-container": {
            "z-index": 1,
            "show": true,
            "width": "{t_2}"
        },
        "tab-container": {
            "width": "{t_5}",
            "opacity": "{t_6}",
            "background-color": "{t_7}",
            "align-items": "{t_8}",
            "justify-content": "{t_9}",
            "gap": "{t_10}",
            "flex-direction": "{t_11}"
        },
        "jds_tab_item": {
            "kind": "label_icon",
            "appearance": "normal"
        },
        "outer-container": {
            "flex-direction": "{t_12}",
            "justify-content": "{t_13}",
            "align-items": "{t_14}",
            "width": "{t_15}",
            "transition": {
                "property": [
                    "padding-left"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeRapid}"
            }
        },
        "inner-container": {
            "background-color": "{t_17}",
            "border-radius": "{t_16}",
            "height": "{t_18}",
            "show": true,
            "transition": {
                "property": [
                    "width"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeRapid}"
            }
        }
    },
    "variant": {
        "overflow": {
            "fit": {
                "tab-container": {
                    "width": "{t_19}",
                    "justify-content": "{t_20}"
                },
                "jds_tab_item": {
                    "flex": 1
                }
            }
        },
        "kind": {
            "label": {
                "jds_tab_item": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_tab_item": {
                    "kind": "icon"
                }
            }
        },
        "appearance": {
            "tab_bar": {
                "tab-container": {
                    "background-color": "{t_21}",
                    "padding-right": "{t_22}",
                    "padding-left": "{t_23}"
                },
                "jds_tab_item": {
                    "appearance": "tab_bar"
                },
                "inner-container": {
                    "mode": "dark",
                    "background-color": "{t_24}"
                }
            }
        }
    },
    "combination": [
        {
            "mobile": {
                "tab_bar": {
                    "indicator-container": {
                        "padding-right": "{t_25}",
                        "padding-left": "{t_26}"
                    },
                    "tab-container": {
                        "padding-right": "{t_25}",
                        "padding-left": "{t_26}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_platform",
            "appearance"
        ]
    ],
    "api": {
        "config": {
            "overflow": {
                "values": [
                    "scroll",
                    "fit"
                ]
            },
            "kind": {
                "type": "JDSTabItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "appearance": {
                "type": "JDSTabItem.appearance",
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "tab-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "label": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                }
            },
            "outer-container": {
                "padding-left": {
                    "type": "size",
                    "name": "_left"
                }
            },
            "inner-container": {
                "width": {
                    "type": "size",
                    "name": "_width"
                }
            },
            "jds_tab_item": {
                "activeTab": {
                    "type": "number",
                    "name": "activeTab"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                }
            }
        },
        "events": {
            "jds_tab_item": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onChange"
            },
            "container": {
                "onScroll": {
                    "name": "onScroll",
                    "platform": "web"
                },
                "onAppear": {
                    "name": "_onTabAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "tab-container": {
                "properties": {
                    "role": {
                        "value": "tablist"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "tabAriaLabel",
                    "ariaDescribedby": {
                        "name": "tabAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_tab_item": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": "ariaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$G = (Component)=>(props)=>{
        const { rootRef: rootRef, element: element } = $451487d20aa3eb8a$var$useRootRef();
        const [activeTabStyles, setActiveTabStyles] = (0, $1OEoy.useState)({
            _left: void 0,
            _width: void 0
        });
        const calculateStyles = (0, $1OEoy.useCallback)(()=>{
            const tabContainers = Array.from(element?.querySelectorAll("div.j-JDSTabItem-outer-container") || []);
            const active = tabContainers[props.activeTab || 0];
            setActiveTabStyles({
                _left: active?.offsetLeft,
                _width: active?.offsetWidth
            });
        }, [
            element,
            props.activeTab
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (element) {
                calculateStyles();
                const resizeObserver = new ResizeObserver(()=>{
                    calculateStyles();
                });
                element.querySelectorAll("div.j-JDSTabItem-outer-container").forEach((tabContainer)=>{
                    resizeObserver.observe(tabContainer);
                });
                return ()=>{
                    resizeObserver.disconnect();
                };
            }
        }, [
            element,
            calculateStyles
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window.addEventListener("resize", calculateStyles);
            return ()=>{
                window.removeEventListener("resize", calculateStyles);
            };
        }, [
            calculateStyles
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _left: activeTabStyles._left,
                _width: activeTabStyles._width
            }
        });
    };
const $451487d20aa3eb8a$var$Component$K = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$G;
    const { overflow: overflow = "scroll", kind: kind = "undefined", appearance: appearance = "undefined", onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onScroll: onScroll = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            overflow: overflow,
            kind: kind,
            appearance: appearance,
            onChange: onChange,
            onScroll: onScroll,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabBar", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$f97dc4a5a0177256 = $451487d20aa3eb8a$var$withLogic$G($451487d20aa3eb8a$var$Component$K);
$451487d20aa3eb8a$export$f97dc4a5a0177256.displayName = "TabBar";
$451487d20aa3eb8a$export$f97dc4a5a0177256.slotName = "jds_tab_bar";
const $451487d20aa3eb8a$var$sdl$F = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-item-1.0.0",
        "name": "JDSTabItem",
        "layerName": "jds_tab_item"
    },
    "hierarchy": {
        "outer-container": [
            {
                "container": [
                    "icon",
                    "text"
                ]
            }
        ]
    },
    "base": {
        "outer-container": {
            "background-color": "{t_0}",
            "flex-direction": "{t_1}",
            "align-items": "{t_2}",
            "justify-content": "{t_3}",
            "min-height": "{t_4}",
            "height": "{t_6}",
            "width": "{t_5}",
            "opacity": "{t_33}",
            "behavior": {
                "hover": {},
                "active": {}
            }
        },
        "container": {
            "flex-direction": "{t_7}",
            "align-items": "{t_8}",
            "justify-content": "{t_9}",
            "gap": "{t_10}",
            "flex": 1,
            "padding-top": "{t_11}",
            "padding-bottom": "{t_12}",
            "padding-right": "{t_13}",
            "padding-left": "{t_14}",
            "behavior": {
                "focus": {
                    "border-width": "{t_15}",
                    "border-color": "{t_16}",
                    "border-radius": "{t_17}"
                }
            }
        },
        "text": {
            "color": "{t_22}",
            "font-family": "{t_24}",
            "font-size": "{t_23}",
            "line-height": "{t_26}",
            "letter-spacing": "{t_27}",
            "font-weight": "{t_25}",
            "max-lines": 2,
            "behavior": {
                "hover": {
                    "color": "{t_28}"
                },
                "active": {
                    "color": "{tabitem_base_text_behavior_active_color}"
                }
            }
        },
        "icon": {
            "size": "{t_18}",
            "color": "{t_19}",
            "hidden": false,
            "behavior": {
                "hover": {
                    "color": "{t_20}"
                },
                "active": {
                    "color": "{t_21}"
                }
            }
        }
    },
    "variant": {
        "kind": {
            "label": {
                "icon": {
                    "hidden": true
                }
            },
            "icon": {
                "text": {
                    "hidden": true
                }
            }
        },
        "disabled": {
            "true": {
                "outer-container": {
                    "disabled": true,
                    "opacity": "{t_34}"
                },
                "container": {
                    "disabled": true
                }
            }
        },
        "appearance": {
            "normal": {
                "text": {
                    "behavior": {
                        "hover": {
                            "color": "{t_35}"
                        },
                        "active": {
                            "color": "{t_36}"
                        }
                    }
                }
            },
            "tab_bar": {
                "container": {
                    "mode": "dark",
                    "behavior": {
                        "active": {
                            "background-color": "{t_37}"
                        },
                        "focus": {
                            "border-color": "{t_38}"
                        }
                    }
                },
                "text": {
                    "color": "{t_42}",
                    "behavior": {
                        "hover": {
                            "color": "{t_43}"
                        },
                        "active": {
                            "color": "{t_44}"
                        }
                    }
                },
                "icon": {
                    "color": "{t_39}",
                    "behavior": {
                        "hover": {
                            "color": "{t_40}"
                        },
                        "active": {
                            "color": "{t_41}"
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {
            "active": {
                "normal": {
                    "text": {
                        "color": "{t_46}"
                    },
                    "icon": {
                        "color": "{t_45}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "appearance"
        ]
    ],
    "api": {
        "config": {
            "state": {
                "values": [
                    "inactive",
                    "active"
                ]
            },
            "kind": {
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "appearance": {
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            }
        },
        "events": {
            "outer-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios, android"
                }
            },
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tab"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-selected": {
                        "name": "_ariaSelected"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$F = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $ddff9b86434e3f59$export$e5cf4eff53e7947d), {
            value: {
                mode: props.appearance === "tab_bar" ? "dark" : void 0
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...{
                    ...props,
                    onClick: ()=>{
                        if (!props.disabled) props.onClick?.(props.internalIndex);
                    },
                    state: props.activeTab === props.internalIndex ? "active" : "default",
                    _ariaSelected: props.activeTab === props.internalIndex
                }
            })
        });
    };
const $451487d20aa3eb8a$var$Component$J = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$F;
    const { state: state = "inactive", kind: kind = "label_icon", appearance: appearance = "normal", disabled: disabled = false, onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            kind: kind,
            appearance: appearance,
            disabled: disabled,
            onAppear: onAppear,
            onClick: onClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$17043b9d35150718 = $451487d20aa3eb8a$var$withLogic$F($451487d20aa3eb8a$var$Component$J);
$451487d20aa3eb8a$export$17043b9d35150718.displayName = "TabItem";
$451487d20aa3eb8a$export$17043b9d35150718.slotName = "jds_tab_item";
const $451487d20aa3eb8a$var$sdl$E = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-body-1.0.0",
        "name": "JDSTableBody",
        "layerName": "jds_table_body",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_table_row"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_1}"
        },
        "jds_table_row": {}
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_row": {
                    "density": "condensed"
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "width": "{t_2}"
                },
                "jds_table_row": {
                    "flex": 1
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_row": {
                    "columnDivider": true
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ],
                "function": true
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ]
            },
            "zebra": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "rows",
                    "function": true,
                    "object": {
                        "cells": "JDSTableRow.cells"
                    }
                }
            },
            "jds_table_row": {
                "cells": {
                    "name": "rows.cells",
                    "type": "list"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$E = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$I = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$E;
    const { density: density = "undefined", columnDivider: columnDivider = false, fullWidth: fullWidth = false, zebra: zebra = false, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            columnDivider: columnDivider,
            fullWidth: fullWidth,
            zebra: zebra,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableBody", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$76ccd210b9029917 = $451487d20aa3eb8a$var$withLogic$E($451487d20aa3eb8a$var$Component$I);
$451487d20aa3eb8a$export$76ccd210b9029917.displayName = "TableBody";
$451487d20aa3eb8a$export$76ccd210b9029917.slotName = "jds_table_body";
const $451487d20aa3eb8a$var$sdl$D = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-cell-1.0.0",
        "name": "JDSTableCell",
        "layerName": "jds_table_cell",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "background-color": "{t_3}",
            "padding-left": "{t_4}",
            "padding-right": "{t_5}",
            "padding-top": "{t_6}",
            "padding-bottom": "{t_7}",
            "border-color": "{t_8}",
            "border-bottom-width": 1,
            "width": "{t_9}"
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "padding-left": "{t_10}",
                    "padding-right": "{t_11}",
                    "padding-top": "{t_12}",
                    "padding-bottom": "{t_13}"
                }
            }
        },
        "columnDivider": {
            "true": {
                "container": {
                    "border-color": "{t_14}",
                    "border-right-width": "{t_15}"
                }
            }
        }
    },
    "combination": [
        {
            "header": {
                "true": {
                    "container": {
                        "background-color": "{t_16}",
                        "border-color": "{t_17}",
                        "border-bottom-width": "{t_19}"
                    },
                    "jds-text": {
                        "font-family": "{headingXxs}",
                        "color": "{primaryInverse}",
                        "font-size": "{headingXxs}",
                        "line-height": "{headingXxs}",
                        "letter-spacing": "{headingXxs}",
                        "font-weight": "{headingXxs}"
                    }
                },
                "false": {
                    "container": {
                        "border-bottom-width": "{t_20}"
                    },
                    "jds-text": {
                        "font-family": "{headingXxs}",
                        "font-size": "{headingXxs}",
                        "line-height": "{headingXxs}",
                        "letter-spacing": "{headingXxs}",
                        "font-weight": "{headingXxs}"
                    }
                }
            },
            "cell": {
                "true": {
                    "container": {
                        "background-color": "{t_18}",
                        "border-bottom-width": "{t_21}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "type",
            "background"
        ]
    ],
    "api": {
        "data": {
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            }
        },
        "config": {
            "type": {
                "values": [
                    "cell",
                    "header"
                ]
            },
            "density": {
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "background": {
                "values": [
                    false,
                    true
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$D = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _role: props.type === "header" ? "columnheader" : "cell"
            }
        });
    };
const $451487d20aa3eb8a$var$Component$H = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$D;
    const { type: type = "cell", density: density = "relaxed", background: background = false, columnDivider: columnDivider = false, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            type: type,
            density: density,
            background: background,
            columnDivider: columnDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableCell", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$1e4baea7053fc0e3 = $451487d20aa3eb8a$var$withLogic$D($451487d20aa3eb8a$var$Component$H);
$451487d20aa3eb8a$export$1e4baea7053fc0e3.displayName = "TableCell";
$451487d20aa3eb8a$export$1e4baea7053fc0e3.slotName = "jds_table_cell";
const $451487d20aa3eb8a$var$sdl$C = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-row-1.0.0",
        "name": "JDSTableRow",
        "layerName": "jds_table_row",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "jds_table_cell"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "lazy-scroll-android": false,
            "width": "{intrinsicSize.max}"
        },
        "jds_table_cell": {
            "width": "{size.max}"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_cell": {
                    "density": "condensed"
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_cell": {
                    "columnDivider": true
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "cells",
                    "object": {
                        "text": "string",
                        "type": "JDSTableCell.type",
                        "background": "boolean"
                    }
                }
            },
            "jds_table_cell": {
                "label": {
                    "name": "cells.text",
                    "type": "string"
                },
                "type": {
                    "name": "cells.type",
                    "type": "JDSTableCell.type"
                },
                "background": {
                    "name": "cells.background",
                    "type": "boolean"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "row"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$C = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$G = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$C;
    const { density: density = "undefined", columnDivider: columnDivider = false, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            columnDivider: columnDivider,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTableRow", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$b05581f4e764e162 = $451487d20aa3eb8a$var$withLogic$C($451487d20aa3eb8a$var$Component$G);
$451487d20aa3eb8a$export$b05581f4e764e162.displayName = "TableRow";
$451487d20aa3eb8a$export$b05581f4e764e162.slotName = "jds_table_row";
const $451487d20aa3eb8a$var$sdl$B = {
    "metadata": {
        "version": "1.0.0",
        "id": "tab-desktop-1.0.0",
        "name": "JDSTabsDesktop",
        "platform": "web",
        "layerName": "jds_tabs_desktop",
        "description": "Horizontal scrollable tabs is a navigation  device placed at the top of a page or content area that they relate to and can be separated into smaller groups of related information",
        "usage": "Use this type of tabs to organize related product information on a model landing page."
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    "prev-jds_button",
                    {
                        "tablist-container": [
                            "jds_tab_bar"
                        ]
                    },
                    "next-jds_button"
                ]
            },
            "content-slot"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "width": "{t_1}"
        },
        "jds_tab_bar": {
            "width": "{t_2}",
            "overflow": "scroll",
            "appearance": "normal",
            "kind": "label_icon"
        },
        "header-container": {
            "flex-direction": "{t_3}",
            "width": "{t_4}",
            "align-items": "{t_5}"
        },
        "prev-jds_button": {
            "icon": "ic_back",
            "kind": "tertiary",
            "hidden": true
        },
        "next-jds_button": {
            "icon": "ic_next",
            "kind": "tertiary",
            "hidden": true
        },
        "tablist-container": {
            "width": "{t_6}",
            "overflow": "auto"
        }
    },
    "variant": {
        "overflow": {
            "fit": {
                "jds_tab_bar": {
                    "overflow": "fit"
                },
                "tablist-container": {
                    "overflow": "hidden"
                }
            },
            "arrows": {
                "prev-jds_button": {
                    "hidden": false
                },
                "next-jds_button": {
                    "hidden": false
                },
                "header-container": {
                    "gap": "{t_7}"
                }
            }
        },
        "appearance": {
            "tab_bar": {
                "jds_tab_bar": {
                    "appearance": "tab_bar"
                },
                "header-container": {
                    "background-color": "{t_8}"
                }
            }
        },
        "_kind": {
            "label": {
                "jds_tab_bar": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_tab_bar": {
                    "kind": "icon"
                }
            }
        },
        "_hideNextBtn": {
            "true": {
                "next-jds_button": {
                    "hidden": true
                }
            }
        },
        "_hidePrevBtn": {
            "true": {
                "prev-jds_button": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "overflow": {
                "values": [
                    "scroll",
                    "fit",
                    "arrows"
                ],
                "doc_dscription": "Setting this to true makes the Tab fit the available width."
            },
            "appearance": {
                "type": "JDSTabItem.appearance",
                "values": [
                    "normal",
                    "tab_bar"
                ]
            },
            "_kind": {
                "type": "JDSTabItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "_hideNextBtn": {
                "values": [
                    false,
                    true
                ]
            },
            "_hidePrevBtn": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_tab_bar": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "label": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                },
                "activeTab": {
                    "type": "number",
                    "name": "activeTab",
                    "doc_description": "Changes programatically the active tab with animation."
                }
            }
        },
        "events": {
            "jds_tab_bar": {
                "onChange": "onChange",
                "onScroll": "onScroll"
            },
            "prev-jds_button": {
                "onClick": "onPrevClick"
            },
            "next-jds_button": {
                "onClick": "onNextClick"
            }
        },
        "children": {
            "content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ]
            }
        },
        "a11y": {
            "jds_tab_bar": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "tabAriaLabel",
                    "ariaDescribedby": {
                        "name": "tabAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "prev-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Previous Tab"
                    }
                }
            },
            "next-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Tab"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$getOverflow = (props)=>{
    if ([
        "tab-bar",
        "tab_bar"
    ].includes(props.appearance)) {
        if ([
            "arrow",
            "arrows"
        ].includes(props.overflow)) return "scroll";
    }
    return props.overflow;
};
const $451487d20aa3eb8a$var$PROP_MAP$9 = (props)=>{
    if (props.appearance === "tab-bar") console.warn("appearance tab-bar is deprecated. Use tab_bar instead");
    if (props.overflow === "arrow") console.warn("overflow arrrow is deprecated. Use arrow instead");
    return {
        appearance: {
            variations: {
                normal: {
                    appearance: "normal"
                },
                "tab-bar": {
                    appearance: "tab_bar"
                }
            }
        },
        overflow: {
            variations: {
                arrow: {
                    overflow: "arrows"
                }
            },
            normal: {
                overflow: "normal"
            }
        }
    };
};
const $451487d20aa3eb8a$var$TAB_LIST_CLASS = 'div[data-testid="JDSTabsDesktop-tablist-container"]';
const $451487d20aa3eb8a$var$SCROLLABLE_CLASS = ".j-JDSTabBar-tab-container";
const $451487d20aa3eb8a$var$withLogic$B = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$9);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const { index: index, onClick: onClick } = $451487d20aa3eb8a$var$useSelected(props.activeTab || 0);
        const items = props.items || props.children?.map((c)=>c.props);
        const tabListElement = element?.querySelector($451487d20aa3eb8a$var$TAB_LIST_CLASS);
        const scrollableELement = element?.querySelector($451487d20aa3eb8a$var$SCROLLABLE_CLASS);
        const hasIcon = items?.every((i)=>i?.icon);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                items: items,
                rootRef: rootRef,
                _kind: hasIcon ? "label_icon" : "label",
                activeTab: index,
                overflow: $451487d20aa3eb8a$var$getOverflow(props),
                onNextClick: ()=>{
                    if (tabListElement && scrollableELement) {
                        const scrollValue = Math.min(tabListElement.scrollWidth, tabListElement.scrollLeft + tabListElement.clientWidth);
                        tabListElement.scrollTo({
                            left: scrollValue,
                            behavior: "smooth"
                        });
                    }
                },
                onPrevClick: ()=>{
                    if (tabListElement) {
                        const scrollValue = Math.max(0, tabListElement.scrollLeft - tabListElement.clientWidth);
                        tabListElement.scrollTo({
                            left: scrollValue,
                            behavior: "smooth"
                        });
                    }
                },
                content: items?.[index]?.children,
                onChange: (i)=>{
                    onClick(i);
                    props.onChange?.(i);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$F = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$B;
    const { overflow: overflow = "scroll", appearance: appearance = "undefined", onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onScroll: onScroll = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrevClick: onPrevClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onNextClick: onNextClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Previous Tab", nextButtonAriaLabel: nextButtonAriaLabel = "Next Tab", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            overflow: overflow,
            appearance: appearance,
            onChange: onChange,
            onScroll: onScroll,
            onPrevClick: onPrevClick,
            onNextClick: onNextClick,
            previousButtonAriaLabel: previousButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTabsDesktop", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$b2539bed5023c21c = $451487d20aa3eb8a$var$withLogic$B($451487d20aa3eb8a$var$Component$F);
$451487d20aa3eb8a$export$b2539bed5023c21c.displayName = "Tabs";
$451487d20aa3eb8a$export$b2539bed5023c21c.slotName = "jds_tabs_desktop";
const $451487d20aa3eb8a$var$sdl$A = {
    "metadata": {
        "version": "1.0.0",
        "id": "tag-1.0.0",
        "name": "JDSTag",
        "layerName": "jds_tag",
        "description": "Tags are keywords used to describe, categorize, or filter content.",
        "usage": "Use tags when content is mapped to multiple categories, and the user needs a way to differentiate between them."
    },
    "hierarchy": {
        "container": [
            "jds-text",
            "icon"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "display": "flex",
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "padding-top": "{t_3}",
            "padding-left": "{t_4}",
            "padding-right": "{t_5}",
            "padding-bottom": "{t_6}",
            "gap": "{t_7}",
            "background-color": "{t_8}",
            "border-radius": "{t_9}",
            "border-width": "{t_10}",
            "border-color": "{t_11}",
            "opacity": "{t_30}",
            "behavior": {
                "active": {
                    "border-color": "{t_13}"
                },
                "focus": {
                    "border-color": "{t_14}",
                    "border-width": "{t_15}"
                },
                "hover": {
                    "border-color": "{t_12}"
                }
            }
        },
        "icon": {
            "hidden": true,
            "size": "{t_16}",
            "color": "{t_17}",
            "behavior": {
                "hover": {
                    "color": "{t_18}"
                },
                "active": {
                    "color": "{t_19}"
                },
                "focus": {
                    "color": "{t_20}"
                }
            }
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": false,
            "maxLines": 1,
            "behavior": {
                "hover": {
                    "color": "{sparkle80}"
                },
                "active": {
                    "color": "{sparkle80}"
                },
                "focus": {
                    "color": "{sparkle80}"
                }
            }
        }
    },
    "variant": {
        "size": {
            "small": {
                "container": {
                    "padding-top": "{t_31}",
                    "padding-left": "{t_32}",
                    "padding-right": "{t_33}",
                    "padding-bottom": "{t_34}"
                },
                "jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "kind": {
            "filter": {
                "icon": {
                    "hidden": false
                }
            }
        },
        "active": {
            "true": {
                "container": {
                    "background-color": "{t_23}",
                    "border-width": "{t_21}",
                    "border-color": "{t_22}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_24}"
                        },
                        "active": {
                            "background-color": "{t_25}",
                            "border-color": "{t_26}",
                            "border-width": 1
                        },
                        "focus": {
                            "background-color": "{t_27}"
                        }
                    }
                },
                "icon": {
                    "color": "{t_28}",
                    "value": "ic_close"
                },
                "jds-text": {
                    "color": "{sparkle80}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{t_29}"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "function": true
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tag."
                }
            }
        },
        "config": {
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used to control size of Tag."
            },
            "kind": {
                "values": [
                    "toggle",
                    "filter"
                ],
                "doc_description": "It can be used to switch between 2 variants of Tag."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Tag."
            },
            "active": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "This can be used to activate Tag."
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "button"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-pressed": {
                        "name": "_ariaPressed",
                        "prop": "active"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$A = (Component)=>(props)=>{
        const { selected: selected, toggle: toggle } = $451487d20aa3eb8a$var$useToggle(props.active, props.kind !== "normal", props.onClick);
        const icon = selected ? "IcClose" : typeof props.icon === "string" ? props.icon : "IcAdd";
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                onClick: toggle,
                active: selected,
                icon: icon
            }
        });
    };
const $451487d20aa3eb8a$var$Component$E = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$A;
    const { size: size = "medium", kind: kind = "toggle", disabled: disabled = false, active: active = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaPressed: _ariaPressed = props.active?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            kind: kind,
            disabled: disabled,
            active: active,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaPressed: _ariaPressed,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTag", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3288d34c523a1192 = $451487d20aa3eb8a$var$withLogic$A($451487d20aa3eb8a$var$Component$E);
$451487d20aa3eb8a$export$3288d34c523a1192.displayName = "Tag";
$451487d20aa3eb8a$export$3288d34c523a1192.slotName = "jds_tag";
const $451487d20aa3eb8a$var$sdl$z = {
    "metadata": {
        "version": "1.0.0",
        "id": "toast-1.0.0",
        "name": "JDSToast",
        "layerName": "jds_toast"
    },
    "hierarchy": {
        "root-container": [
            {
                "base-container": [
                    "left-slot",
                    {
                        "center-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    "close-jds_notification_button",
                    "right-slot"
                ]
            },
            {
                "buttons-container": [
                    "secondary-jds_notification_button",
                    "primary-jds_notification_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "width": "{t_0}",
            "max-width": "{t_1}",
            "border-radius": "{t_2}",
            "background-color": "{t_3}",
            "flex-direction": "{t_4}",
            "gap": "{t_5}",
            "padding-top": "{t_6}",
            "padding-right": "{t_7}",
            "padding-bottom": "{t_8}",
            "padding-left": "{t_9}",
            "enter-animation-name": "slideVerticallyUp",
            "exit-animation-name": "slideVerticallyDown",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "transition": {
                "property": [
                    "translate-x",
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulExit}"
            },
            "hidden": true
        },
        "base-container": {
            "gap": "{t_10}",
            "flex-direction": "{t_12}",
            "justify-content": "{t_13}",
            "align-items": "{t_14}",
            "width": "{t_11}"
        },
        "center-container": {
            "flex-direction": "{t_15}",
            "justify-content": "{t_16}",
            "align-items": "{t_17}",
            "gap": "{t_18}",
            "flex": 1
        },
        "close-jds_notification_button": {
            "hidden": false,
            "icon": "ic_close",
            "kind": "tertiary"
        },
        "buttons-container": {
            "gap": "{t_20}",
            "flex-direction": "{t_21}",
            "justify-content": "{t_22}",
            "width": "{t_19}"
        },
        "secondary-jds_notification_button": {
            "kind": "tertiary"
        },
        "right-slot": {
            "hidden": true
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryBackground}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey20}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 2,
            "maxLines": 2
        }
    },
    "variant": {
        "open": {
            "true": {
                "root-container": {
                    "hidden": false,
                    "transition": {
                        "timing-function": "{easeJoyfulEntrance}"
                    }
                }
            }
        },
        "showClose": {
            "false": {
                "close-jds_notification_button": {
                    "hidden": true
                },
                "right-slot": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "tablet": {
                "root-container": {
                    "max-width": "{t_23}"
                }
            },
            "desktop": {
                "root-container": {
                    "max-width": "{t_24}"
                }
            }
        },
        "_hasCTA": {
            "false": {
                "buttons-container": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "support-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "mobile": {
                    "root-container": {
                        "translate-y": "{size.max}"
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": "{size.negativeMax}"
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": "{size.negativeMax}"
                    }
                }
            },
            "true": {
                "mobile": {
                    "root-container": {
                        "translate-y": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "translate-x": 0
                    }
                },
                "desktop": {
                    "root-container": {
                        "translate-x": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "open",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "showClose": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "This shows close button on Toast when true."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "tablet",
                    "desktop"
                ]
            },
            "_hasCTA": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "root-container": {
                "_nudge.id": {
                    "type": "NotificationId",
                    "name": "id",
                    "required": true,
                    "doc_description": "It will hold the reference of Toast"
                },
                "dismissAfter": {
                    "type": "number",
                    "name": "dismissAfter"
                }
            },
            "secondary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "secondaryCTA",
                    "doc_description": "It displays label of secondary button of Toast."
                }
            },
            "primary-jds_notification_button": {
                "label": {
                    "type": "string",
                    "name": "primaryCTA",
                    "doc_description": "It displays label of primary button of Toast."
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "It displays the title of Toast."
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "It can be used to add description to the Toast."
                }
            }
        },
        "events": {
            "root-container": {
                "onShow": "onShow",
                "onUpdate": {
                    "name": "onUpdate",
                    "platform": "android"
                },
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "onHoverEnd",
                    "platform": "web"
                },
                "onSwipeDown": "onClose"
            },
            "close-jds_notification_button": {
                "onClick": "onClose"
            },
            "secondary-jds_notification_button": {
                "onClick": "onSecondaryClick"
            },
            "primary-jds_notification_button": {
                "onClick": "onPrimaryClick"
            }
        },
        "children": {
            "left-slot": {
                "accepts": [
                    "jds_icon",
                    "jds_avatar"
                ],
                "max": 1,
                "name": "prefix",
                "doc_description": "It takes 'icon', 'avatar' as prefix."
            },
            "right-slot": {
                "accepts": [
                    "jds_notification_button"
                ],
                "max": 1,
                "name": "suffix",
                "doc_description": "It takes 'jds_notification_button' as suffix."
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "alertdialog"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$Component$D = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$z;
    const { open: open = false, showClose: showClose = true, onShow: onShow = (0, $ddff9b86434e3f59$export$8793edee2d425525), onUpdate: onUpdate = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHoverEnd: onHoverEnd = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            showClose: showClose,
            onShow: onShow,
            onUpdate: onUpdate,
            onHover: onHover,
            onHoverEnd: onHoverEnd,
            onClose: onClose,
            onSecondaryClick: onSecondaryClick,
            onPrimaryClick: onPrimaryClick,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToast", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$Toast = $451487d20aa3eb8a$var$withLogic$W($451487d20aa3eb8a$var$Component$D);
$451487d20aa3eb8a$var$Toast.displayName = "Toast";
$451487d20aa3eb8a$var$Toast.slotName = "jds_toast";
const $451487d20aa3eb8a$var$sdl$y = {
    "metadata": {
        "version": "1.0.0",
        "id": "tooltip-1.0.0",
        "name": "JDSTooltip",
        "layerName": "jds_tooltip",
        "description": "Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.",
        "usage": "The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user."
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    "jds_tooltip_internal"
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "passive": true,
            "hidden": true,
            "priority": 30
        },
        "popup-container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}"
        },
        "jds_tooltip_internal": {}
    },
    "variant": {
        "position": {
            "right_start": {
                "jds_tooltip_internal": {
                    "position": "right_start"
                }
            },
            "right_end": {
                "jds_tooltip_internal": {
                    "position": "right_end"
                }
            },
            "left": {
                "jds_tooltip_internal": {
                    "position": "left"
                }
            },
            "left_start": {
                "jds_tooltip_internal": {
                    "position": "left_start"
                }
            },
            "left_end": {
                "jds_tooltip_internal": {
                    "position": "left_end"
                }
            },
            "top": {
                "jds_tooltip_internal": {
                    "position": "top"
                }
            },
            "top_start": {
                "jds_tooltip_internal": {
                    "position": "top_start"
                }
            },
            "top_end": {
                "jds_tooltip_internal": {
                    "position": "top_end"
                }
            },
            "bottom": {
                "jds_tooltip_internal": {
                    "position": "bottom"
                }
            },
            "bottom_start": {
                "jds_tooltip_internal": {
                    "position": "bottom_start"
                }
            },
            "bottom_end": {
                "jds_tooltip_internal": {
                    "position": "bottom_end"
                }
            }
        },
        "open": {
            "true": {
                "popup": {
                    "hidden": false
                }
            }
        },
        "_platform": {
            "desktop": {
                "jds_tooltip_internal": {
                    "_platform": "desktop"
                }
            }
        }
    },
    "api": {
        "config": {
            "position": {
                "values": [
                    "right",
                    "right_start",
                    "right_end",
                    "bottom",
                    "bottom_start",
                    "bottom_end",
                    "left",
                    "left_start",
                    "left_end",
                    "top",
                    "top_start",
                    "top_end"
                ],
                "doc-description": "It can be used to give certain position to the Tooltip."
            },
            "open": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to progamtically open and close Tooltip."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            }
        },
        "data": {
            "jds_tooltip_internal": {
                "label": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tooltip."
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "width": {
                    "type": "size",
                    "name": "width"
                },
                "triggerSpacing": {
                    "type": "size",
                    "name": "triggerSpacing",
                    "function": true
                }
            },
            "popup-container": {
                "padding-left": {
                    "type": "size",
                    "name": "offsetX"
                },
                "padding-top": {
                    "type": "size",
                    "name": "offsetY"
                }
            }
        },
        "events": {
            "jds_tooltip_internal": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                },
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            },
            "popup": {
                "onHover": {
                    "name": "onHover",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "jds_tooltip_internal": {
                "properties": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
function $451487d20aa3eb8a$var$calculateOffsets(position, anchorRect, tooltipRect, gap) {
    let offsetX = "";
    let offsetY = "";
    const halfAnchorWidth = anchorRect.width / 2;
    const halfAnchorHeight = anchorRect.height / 2;
    const halfTooltipWidth = tooltipRect.width / 2;
    const halfTooltipHeight = tooltipRect.height / 2;
    const tipSize = 24;
    const tipSpace = 4;
    const verticalCenterX = anchorRect.left + halfAnchorWidth - halfTooltipWidth;
    const verticalEndX = anchorRect.right - tooltipRect.width - tipSpace;
    const verticalStartX = anchorRect.left + halfAnchorWidth - tipSize + tipSpace;
    const horizontalCenterY = anchorRect.top + halfAnchorHeight - halfTooltipHeight;
    const horizontalEndY = anchorRect.bottom - tooltipRect.height - tipSpace;
    const horizontalStartY = anchorRect.top + halfAnchorHeight - tipSize + tipSpace;
    const bottomY = anchorRect.bottom + gap;
    const topY = anchorRect.top - tooltipRect.height - gap;
    const leftX = anchorRect.left - tooltipRect.width - gap;
    const rightX = anchorRect.right + gap;
    switch(position){
        case "bottom":
            offsetX = `${verticalCenterX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "bottom_end":
            offsetX = `${verticalEndX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "bottom_start":
            offsetX = `${verticalStartX}px`;
            offsetY = `${bottomY}px`;
            break;
        case "top":
            offsetX = `${verticalCenterX}px`;
            offsetY = `${topY}px`;
            break;
        case "top_end":
            offsetX = `${verticalEndX}px`;
            offsetY = `${topY}px`;
            break;
        case "top_start":
            offsetX = `${verticalStartX}px`;
            offsetY = `${topY}px`;
            break;
        case "left":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalCenterY}px`;
            break;
        case "left_end":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalEndY}px`;
            break;
        case "left_start":
            offsetX = `${leftX}px`;
            offsetY = `${horizontalStartY}px`;
            break;
        case "right":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalCenterY}px`;
            break;
        case "right_end":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalEndY}px`;
            break;
        case "right_start":
            offsetX = `${rightX}px`;
            offsetY = `${horizontalStartY}px`;
            break;
    }
    return {
        offsetX: offsetX,
        offsetY: offsetY
    };
}
const $451487d20aa3eb8a$var$SPACE_AVAILABILITY_ORDER = {
    bottom_start: [
        "top_start",
        "bottom",
        "bottom_end",
        "top",
        "top_end"
    ],
    bottom_end: [
        "top_end",
        "bottom",
        "bottom_start",
        "top",
        "top_start"
    ],
    top_start: [
        "bottom_start",
        "top",
        "top_end",
        "bottom",
        "bottom_end"
    ],
    top_end: [
        "bottom_end",
        "top",
        "top_start",
        "bottom",
        "bottom_start"
    ],
    right_end: [
        "left_end",
        "right",
        "right_start",
        "left",
        "left_start"
    ],
    right_start: [
        "left_start",
        "right",
        "right_end",
        "left",
        "left_end"
    ],
    left_end: [
        "right_end",
        "left",
        "left_start",
        "right",
        "right_start"
    ],
    left_start: [
        "right_start",
        "left",
        "left_end",
        "right",
        "right_end"
    ],
    top: [
        "bottom",
        "top_start",
        "top_end",
        "bottom_start",
        "bottom_end"
    ],
    bottom: [
        "top",
        "bottom_start",
        "bottom_end",
        "top_start",
        "top_end"
    ],
    left: [
        "right",
        "left_start",
        "left_end",
        "right_start",
        "right_end"
    ],
    right: [
        "left",
        "right_start",
        "right_end",
        "left_start",
        "left_end"
    ]
};
function $451487d20aa3eb8a$var$isTooltipPositionFit(position, anchorRect, tooltipRect, gap) {
    const { offsetX: offsetX, offsetY: offsetY } = $451487d20aa3eb8a$var$calculateOffsets(position, anchorRect, tooltipRect, gap);
    const positionX = parseInt(offsetX);
    const positionY = parseInt(offsetY);
    const { right: right, bottom: bottom } = tooltipRect;
    const { innerWidth: screenWidth, innerHeight: screenHeight } = window;
    switch(position){
        case "top":
            return positionY > 0 && positionX > 0 && right < screenWidth;
        case "top_start":
            return positionY > 0 && right < screenWidth;
        case "top_end":
            return positionY > 0 && positionX > 0;
        case "right_start":
            return bottom < screenHeight && right < screenWidth;
        case "right_end":
            return positionY > 0 && right < screenWidth;
        case "right":
            return positionY > 0 && bottom < screenHeight && right < screenWidth;
        case "bottom_start":
            return bottom < screenHeight && right < screenWidth;
        case "bottom_end":
            return bottom < screenHeight && positionX > 0;
        case "bottom":
            return bottom < screenHeight && positionX > 0 && right < screenWidth;
        case "left_start":
            return bottom < screenHeight && positionX > 0;
        case "left_end":
            return positionY > 0 && positionX > 0;
        case "left":
            return bottom < screenHeight && positionY > 0 && positionX > 0;
        default:
            return true;
    }
}
function $451487d20aa3eb8a$var$getFlippedPosition(position, anchorRect, tooltipRect, gap) {
    if ($451487d20aa3eb8a$var$isTooltipPositionFit(position, anchorRect, tooltipRect, gap)) return position;
    const alternativePosition = $451487d20aa3eb8a$var$SPACE_AVAILABILITY_ORDER[position].find((alternativePosition2)=>{
        return $451487d20aa3eb8a$var$isTooltipPositionFit(alternativePosition2, anchorRect, tooltipRect, gap);
    });
    return alternativePosition || position;
}
const $451487d20aa3eb8a$var$LONG_PRESS_DELAY = 1e3;
const $451487d20aa3eb8a$var$SUSTAIN_TIME = 3e3;
const $451487d20aa3eb8a$var$getPosition = (anchor, tooltip, position = "right", TIP_OFFSET = $451487d20aa3eb8a$var$Devices.isTablet() ? 20 : 8, isDesktop)=>{
    if (anchor && tooltip) {
        const anchorRect = anchor.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const resolvedOffset = typeof TIP_OFFSET === "string" ? parseInt(TIP_OFFSET.replace("px", "")) : TIP_OFFSET;
        const maxOffset = isDesktop ? 8 : 20;
        const clampedffset = (0, $ddff9b86434e3f59$export$7d15b64cf5a3a4c4)(resolvedOffset, 0, maxOffset);
        const currentPosition = $451487d20aa3eb8a$var$getFlippedPosition(position, anchorRect, tooltipRect, clampedffset);
        const { offsetX: offsetX, offsetY: offsetY } = $451487d20aa3eb8a$var$calculateOffsets(currentPosition, anchorRect, tooltipRect, clampedffset);
        return {
            offsetX: offsetX.replace("px", ""),
            offsetY: offsetY.replace("px", ""),
            newPosition: currentPosition
        };
    }
    return {
        offsetX: 0,
        offsetY: 0
    };
};
const $451487d20aa3eb8a$var$legacyTooltipPositions = [
    "right-start",
    "right-end",
    "bottom-start",
    "bottom-end",
    "left-start",
    "left-end",
    "top-start",
    "top-end"
];
const $451487d20aa3eb8a$var$PROP_MAP$8 = (props)=>{
    if ($451487d20aa3eb8a$var$legacyTooltipPositions.includes(props.position)) console.warn("these values for the position prop are deprecated", $451487d20aa3eb8a$var$legacyTooltipPositions);
    return {
        position: {
            variations: {
                "right-start": {
                    position: "right_start"
                },
                "left-start": {
                    position: "left_start"
                },
                "bottom-start": {
                    position: "bottom_start"
                },
                "top-start": {
                    position: "top_start"
                },
                "left-end": {
                    position: "left_end"
                },
                "right-end": {
                    position: "right_end"
                },
                "top-end": {
                    position: "top_end"
                },
                "bottom-end": {
                    position: "bottom_end"
                },
                left: {
                    position: "left"
                },
                right: {
                    position: "right"
                },
                top: {
                    position: "top"
                },
                bottom: {
                    position: "bottom"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$z = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$8);
        const { children: children, ...rest } = props;
        const ref = (0, $1OEoy.useRef)(null);
        const { toggle: toggle, selected: selected, close: close } = $451487d20aa3eb8a$var$useToggle(props.open);
        const [element, setElement] = (0, $1OEoy.useState)(null);
        const triggerRef = (0, $1OEoy.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const { desktop: desktop } = $451487d20aa3eb8a$var$Devices.useMedia();
        const { offsetX: offsetX, offsetY: offsetY, newPosition: newPosition } = $451487d20aa3eb8a$var$getPosition(ref.current, element, rest.position, props.triggerSpacing, desktop);
        const timerRef = (0, $1OEoy.useRef)();
        const isTouchActive = (0, $1OEoy.useRef)(false);
        $451487d20aa3eb8a$var$useScrollClose(close);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
            children: [
                /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                    ...{
                        ...rest,
                        offsetX: offsetX,
                        offsetY: offsetY,
                        _platform: $451487d20aa3eb8a$var$getPlatform(),
                        width: "300px",
                        position: newPosition || props.position,
                        open: Boolean(selected),
                        triggerRef: triggerRef
                    }
                }),
                /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                    onMouseEnter: ()=>{
                        if (!(window && "ontouchstart" in window)) toggle();
                    },
                    onMouseLeave: close,
                    onTouchStart: ()=>{
                        if (window && "ontouchstart" in window && $451487d20aa3eb8a$var$Devices.isMobile()) {
                            isTouchActive.current = true;
                            timerRef.current = setTimeout(toggle, $451487d20aa3eb8a$var$LONG_PRESS_DELAY);
                        }
                    },
                    onTouchEnd: ()=>{
                        if ($451487d20aa3eb8a$var$Devices.isMobile()) {
                            isTouchActive.current = false;
                            if (selected) setTimeout(close, $451487d20aa3eb8a$var$SUSTAIN_TIME);
                            else if (timerRef.current) clearTimeout(timerRef.current);
                        }
                    },
                    ref: ref,
                    style: {
                        width: "fit-content"
                    },
                    children: children
                })
            ]
        });
    };
const $451487d20aa3eb8a$var$Component$C = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$y;
    const { position: position = "right", open: open = false, onTextLayout: onTextLayout = (0, $ddff9b86434e3f59$export$8793edee2d425525), onHover: onHover = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            position: position,
            open: open,
            onTextLayout: onTextLayout,
            onHover: onHover,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTooltip", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$28c660c63b792dea = $451487d20aa3eb8a$var$withLogic$z($451487d20aa3eb8a$var$Component$C);
$451487d20aa3eb8a$export$28c660c63b792dea.displayName = "Tooltip";
$451487d20aa3eb8a$export$28c660c63b792dea.slotName = "jds_tooltip";
const $451487d20aa3eb8a$var$sdl$x = {
    "metadata": {
        "version": "1.0.0",
        "id": "tooltip-1.0.0",
        "name": "JDSTooltipInternal",
        "layerName": "jds_tooltip_internal",
        "description": "Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.",
        "usage": "The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user.",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            "start-tooltip",
            {
                "text-container": [
                    "jds-text"
                ]
            },
            "end-tooltip"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{t_3}",
            "justify-content": "{t_4}",
            "align-items": "{t_5}",
            "overflow": "{tooltip_base_root-container-overflow}"
        },
        "text-container": {
            "border-radius": "{t_7}",
            "border-width": "{t_8}",
            "background-color": "{t_9}",
            "padding-left": "{t_12}",
            "padding-right": "{t_13}",
            "padding-top": "{t_14}",
            "padding-bottom": "{t_15}",
            "min-height": "{t_40}",
            "align-items": "{t_41}"
        },
        "start-tooltip": {
            "color": "{t_10}",
            "position": "right",
            "hidden": false
        },
        "end-tooltip": {
            "color": "{t_11}",
            "position": "right",
            "hidden": true
        },
        "jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryBackground}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "position": {
            "right_start": {
                "root-container": {
                    "align-items": "{t_16}"
                },
                "start-tooltip": {
                    "position": "right_start",
                    "padding-top": "{t_17}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "right_end": {
                "root-container": {
                    "align-items": "{t_18}"
                },
                "start-tooltip": {
                    "position": "right_end",
                    "padding-bottom": "{t_19}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "left": {
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left",
                    "hidden": false
                }
            },
            "left_start": {
                "root-container": {
                    "align-items": "{t_20}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left_start",
                    "padding-top": "{t_21}",
                    "hidden": false
                }
            },
            "left_end": {
                "root-container": {
                    "align-items": "{t_22}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "left_end",
                    "padding-bottom": "{t_23}",
                    "hidden": false
                }
            },
            "top": {
                "root-container": {
                    "flex-direction": "{t_24}",
                    "align-items": "{t_25}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top",
                    "hidden": false
                }
            },
            "top_start": {
                "root-container": {
                    "flex-direction": "{t_26}",
                    "align-items": "{t_27}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top_start",
                    "padding-left": "{t_28}",
                    "hidden": false
                }
            },
            "top_end": {
                "root-container": {
                    "flex-direction": "{t_29}",
                    "align-items": "{t_30}"
                },
                "start-tooltip": {
                    "hidden": true
                },
                "end-tooltip": {
                    "position": "top_end",
                    "padding-right": "{t_31}",
                    "hidden": false
                }
            },
            "bottom": {
                "root-container": {
                    "flex-direction": "{t_32}",
                    "align-items": "{t_33}"
                },
                "start-tooltip": {
                    "position": "bottom",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "bottom_start": {
                "root-container": {
                    "flex-direction": "{t_34}",
                    "align-items": "{t_35}"
                },
                "start-tooltip": {
                    "padding-left": "{t_36}",
                    "position": "bottom_start",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            },
            "bottom_end": {
                "root-container": {
                    "flex-direction": "{t_37}",
                    "align-items": "{t_38}"
                },
                "start-tooltip": {
                    "position": "bottom_end",
                    "padding-right": "{t_39}",
                    "hidden": false
                },
                "end-tooltip": {
                    "hidden": true
                }
            }
        },
        "_platform": {
            "desktop": {
                "jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            }
        }
    },
    "api": {
        "config": {
            "position": {
                "values": [
                    "right",
                    "right_start",
                    "right_end",
                    "bottom",
                    "bottom_start",
                    "bottom_end",
                    "left",
                    "left_start",
                    "left_end",
                    "top",
                    "top_start",
                    "top_end"
                ],
                "doc-description": "It can be used to give certain position to the Tooltip."
            },
            "_platform": {
                "values": [
                    "mobile",
                    "desktop"
                ]
            }
        },
        "data": {
            "root-container": {
                "elementRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "max-width": {
                    "type": "size",
                    "name": "width"
                },
                "spacing": {
                    "type": "size",
                    "name": "triggerSpacing",
                    "function": true
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Tooltip."
                }
            }
        },
        "events": {
            "root-container": {
                "onAppear": {
                    "name": "onAppear",
                    "platform": "ios"
                }
            },
            "jds-text": {
                "onTextLayout": {
                    "name": "onTextLayout",
                    "platform": "android"
                }
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "tooltip"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$y = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$B = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$x;
    const { position: position = "right", onAppear: onAppear = (0, $ddff9b86434e3f59$export$8793edee2d425525), onTextLayout: onTextLayout = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            position: position,
            onAppear: onAppear,
            onTextLayout: onTextLayout,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTooltipInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$d8d56a9a74e44761 = $451487d20aa3eb8a$var$withLogic$y($451487d20aa3eb8a$var$Component$B);
$451487d20aa3eb8a$export$d8d56a9a74e44761.displayName = "TooltipInternal";
$451487d20aa3eb8a$export$d8d56a9a74e44761.slotName = "jds_tooltip_internal";
const $451487d20aa3eb8a$var$sdl$w = {
    "metadata": {
        "version": "1.0.0",
        "id": "stepper-vertical-step-item-1.0.0",
        "name": "JDSVerticalStepItem",
        "layerName": "jds_vertical_step_item",
        "internal": true
    },
    "hierarchy": {
        "stepper-outer-container": [
            {
                "step-dot-container": [
                    "jds_stepper_dot",
                    "label-jds-text"
                ]
            },
            {
                "step-indicator-container": [
                    "end-jds_divider",
                    {
                        "content-container": [
                            {
                                "content-child-container": [
                                    "content-slot"
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "stepper-outer-container": {
            "flex-direction": "{v_0}",
            "justify-content": "{v_1}",
            "align-items": "{v_2}",
            "gap": "{v_3}",
            "size": "{v_4}"
        },
        "end-container": {
            "hidden": false,
            "flex": 1,
            "opacity": "{v_5}"
        },
        "content-child-container": {
            "flex-direction": "{v_6}",
            "justify-content": "{v_7}",
            "align-items": "{v_8}",
            "hidden": false
        },
        "end-jds_divider": {
            "pad": "none",
            "withLabel": false,
            "orientation": "vertical"
        },
        "step-indicator-container": {
            "height": "{v_9}",
            "flex-direction": "{v_10}",
            "justify-content": "{v_11}",
            "align-items": "{v_12}",
            "padding-left": 15,
            "min-height": "{v_13}"
        },
        "step-dot-container": {
            "flex-direction": "{v_15}",
            "justify-content": "{v_16}",
            "align-items": "{v_17}",
            "gap": "{v_18}"
        },
        "content-container": {
            "padding-top": "{v_19}",
            "padding-left": 31,
            "padding-bottom": "{v_20}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "hidden": true,
            "overflow": "hidden",
            "transition": {
                "property": [
                    "max-height",
                    "padding-top",
                    "padding-bottom"
                ],
                "duration": "{medium}",
                "timing-function": "{easeExit}"
            }
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en",
            "padding-top": 0
        }
    },
    "variant": {
        "_hideChild": {
            "true": {
                "content-container": {
                    "hidden": false,
                    "padding-top": "{verticalstepitem_variant__hideChild_true_content-container_padding-top}",
                    "padding-bottom": "{verticalstepitem_variant__hideChild_true_content-container_padding-bottom}",
                    "transition": {
                        "timing-function": "{easeEntrance}"
                    }
                }
            }
        },
        "state": {
            "complete": {
                "end-jds_divider": {
                    "variant": "stepper"
                }
            },
            "disabled": {
                "stepper-outer-container": {
                    "disabled": true
                },
                "jds_stepper_dot": {
                    "state": "disabled"
                }
            }
        },
        "direction": {
            "start": {
                "end-jds_divider": {
                    "opacity": "{v_24}"
                }
            }
        }
    },
    "api": {
        "children": {
            "content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ],
                "max": 1
            }
        },
        "config": {
            "state": {
                "type": "JDSStepperDot.state",
                "values": [
                    "inactive",
                    "active",
                    "complete",
                    "disabled"
                ]
            },
            "direction": {
                "values": [
                    "both",
                    "start",
                    "end"
                ]
            },
            "_hideChild": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_stepper_dot": {
                "index": {
                    "type": "string",
                    "name": "index"
                },
                "icon": {
                    "type": "icon",
                    "name": "icon"
                },
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "state"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "activeState"
                }
            },
            "content-container": {
                "max-height": {
                    "name": "_contentHeight",
                    "type": "size"
                }
            },
            "label-jds-text": {
                "value": {
                    "name": "label",
                    "type": "string"
                }
            }
        },
        "a11y": {
            "stepper-outer-container": {
                "properties": {
                    "role": {
                        "value": "listitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-current": {
                        "name": "ariaCurrent"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$x = (Component)=>(props)=>{
        const active = props.state === "active";
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: rootRef,
                _hideChild: active,
                _contentHeight: active ? element?.querySelector('div[data-testid="JDSVerticalStepItem-content-container"]')?.scrollHeight : 0
            }
        });
    };
const $451487d20aa3eb8a$var$Component$A = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$w;
    const { state: state = "undefined", direction: direction = "both", ariaLabel: ariaLabel = props.label?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            direction: direction,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSVerticalStepItem", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$c4bee818be0dfd5a = $451487d20aa3eb8a$var$withLogic$x($451487d20aa3eb8a$var$Component$A);
$451487d20aa3eb8a$export$c4bee818be0dfd5a.displayName = "VerticalStepItem";
$451487d20aa3eb8a$export$c4bee818be0dfd5a.slotName = "jds_vertical_step_item";
const $451487d20aa3eb8a$var$v1Map = {
    jds_text: ()=>$451487d20aa3eb8a$export$5f1af8db9871e1d6,
    jds_tag: ()=>$451487d20aa3eb8a$export$3288d34c523a1192,
    jds_icon: ()=>$451487d20aa3eb8a$export$f04a61298a47a40f,
    jds_skeleton: ()=>$451487d20aa3eb8a$export$8f31e4c4a37b8e9c,
    jds_badge: ()=>$451487d20aa3eb8a$export$37acb3580601e69a,
    jds_toast: ()=>$451487d20aa3eb8a$var$Toast,
    jds_nudge: ()=>$451487d20aa3eb8a$var$Nudge,
    jds_fab: ()=>$451487d20aa3eb8a$export$72beae6a392d0fc6,
    jds_fab_internal: ()=>$451487d20aa3eb8a$export$f3670f01e3026458,
    jds_selector_item: ()=>$451487d20aa3eb8a$export$ec8540225d9cc6a2,
    jds_table_cell: ()=>$451487d20aa3eb8a$export$1e4baea7053fc0e3,
    jds_table_row: ()=>$451487d20aa3eb8a$export$b05581f4e764e162,
    jds_table_body: ()=>$451487d20aa3eb8a$export$76ccd210b9029917,
    jds_selector_button: ()=>$451487d20aa3eb8a$export$880a7f9ee0ea89e0,
    jds_menu_block_item: ()=>$451487d20aa3eb8a$export$3789e0cd450be8da,
    jds_notification_button: ()=>$451487d20aa3eb8a$var$NotificationButton,
    jds_action_button: ()=>$451487d20aa3eb8a$export$cfc7921d29ef7b80,
    jds_tab_item: ()=>$451487d20aa3eb8a$export$17043b9d35150718,
    jds_feedback_block: ()=>$451487d20aa3eb8a$var$FeedbackBlock,
    jds_link: ()=>$451487d20aa3eb8a$export$a6c7ac8248d6e38a,
    jds_bottom_footer_link_item: ()=>$451487d20aa3eb8a$export$b592413d575db486,
    jds_bottom_sheet: ()=>$451487d20aa3eb8a$export$2058ef1a26004a97,
    jds_desktop_bottom_sheet_internal: ()=>$451487d20aa3eb8a$export$a20173db319b8774,
    jds_mobile_bottom_sheet_internal: ()=>$451487d20aa3eb8a$export$9ac5eac5233c654,
    jds_divider: ()=>$451487d20aa3eb8a$export$2e0a83ec2e27ecbb,
    jds_image: ()=>$451487d20aa3eb8a$export$3e431a229df88919,
    jds_footer_links: ()=>$451487d20aa3eb8a$export$553910ef0cc96026,
    jds_footer_icon_links: ()=>$451487d20aa3eb8a$export$ce48424ab2a5a45,
    jds_footer_market_links: ()=>$451487d20aa3eb8a$export$4e70d4e1c9ec4c90,
    jds_footer_links_grid: ()=>$451487d20aa3eb8a$export$e5275d44ac937bc0,
    jds_bottom_footer: ()=>$451487d20aa3eb8a$export$72ab4ebd04fea6e2,
    jds_content_block: ()=>$451487d20aa3eb8a$export$eb38b3b9c7f5f31b,
    jds_search_result_item: ()=>$451487d20aa3eb8a$export$56e008c8bd1ccf7c,
    jds_search_results_internal: ()=>$451487d20aa3eb8a$export$49b46bbe543bdb4b,
    jds_avatar: ()=>$451487d20aa3eb8a$export$e2255cf6045e8d47,
    jds_segmented_ring_item: ()=>$451487d20aa3eb8a$export$28d80c087760154d,
    jds_avatar_v2: ()=>$451487d20aa3eb8a$export$ac4313c0728f5b84,
    jds_avatar_v2_segmented_ring: ()=>$451487d20aa3eb8a$export$9b02a99b26bc2fb,
    jds_avatar_v2_progress_ring: ()=>$451487d20aa3eb8a$export$add0715ef3cff303,
    jds_avatar_v2_complete_ring: ()=>$451487d20aa3eb8a$export$70f728d68d57ace9,
    jds_avatar_v2_default: ()=>$451487d20aa3eb8a$export$4860988e9a471058,
    jds_avatar_v2_information: ()=>$451487d20aa3eb8a$export$dbc79143cb6c67cb,
    jds_avatar_v2_status: ()=>$451487d20aa3eb8a$export$6c44d71f4e8d3278,
    jds_avatar_v2_notification: ()=>$451487d20aa3eb8a$export$c906bb7932dd69e9,
    jds_button: ()=>$451487d20aa3eb8a$export$353f5b6fc5456de1,
    jds_accordion: ()=>$451487d20aa3eb8a$export$7cad6f17fd6e117b,
    jds_mega_menu_item: ()=>$451487d20aa3eb8a$export$cc2d7d7492914f14,
    jds_mega_menu_block: ()=>$451487d20aa3eb8a$export$5e96c1cbae381c93,
    jds_search_box: ()=>$451487d20aa3eb8a$export$5a58787633b0b5d8,
    jds_modal_desktop_internal: ()=>$451487d20aa3eb8a$export$3e0ada2dd34546e6,
    jds_modal_mobile_internal: ()=>$451487d20aa3eb8a$export$e70e9b240ff3bbbf,
    jds_modal_desktop: ()=>$451487d20aa3eb8a$export$2b77a92f1a5ad772,
    jds_side_panel_item: ()=>$451487d20aa3eb8a$export$500ae19c14a3c46,
    jds_side_panel_internal: ()=>$451487d20aa3eb8a$export$8b5d5577a4deadf6,
    jds_header: ()=>$451487d20aa3eb8a$export$8b251419efc915eb,
    jds_mega_menu: ()=>$451487d20aa3eb8a$export$aee42d298194d478,
    jds_bottom_navigation_item: ()=>$451487d20aa3eb8a$export$f5e7567009f715b2,
    jds_bottom_navigation2: ()=>BottomNavigation2,
    jds_carousel_pagination_item: ()=>$451487d20aa3eb8a$var$CarouselPaginationItem,
    jds_carousel_pagination: ()=>$451487d20aa3eb8a$var$CarouselPagination,
    jds_carousel_slide: ()=>$451487d20aa3eb8a$export$cabb5ccfbd60cbd4,
    jds_datepicker_button: ()=>$451487d20aa3eb8a$export$395dd20d84297b30,
    jds_datepicker_calendar_button: ()=>$451487d20aa3eb8a$export$2d81f864fd880f98,
    jds_datepicker_view_button: ()=>$451487d20aa3eb8a$export$99c3540c4320b145,
    jds_datepicker_calendar_row: ()=>$451487d20aa3eb8a$export$703dfd9521d4b08a,
    jds_datepicker_calendar: ()=>$451487d20aa3eb8a$export$cfdbf347b14a0a8d,
    jds_datepicker_year_view: ()=>$451487d20aa3eb8a$export$59892f17b1991230,
    jds_datepicker_calendar_header: ()=>$451487d20aa3eb8a$export$2d5e85746b19c19b,
    jds_datepicker_header: ()=>$451487d20aa3eb8a$export$4677d90cce08ec53,
    jds_datepicker_month_view: ()=>$451487d20aa3eb8a$export$df8c284ffe0bf6ce,
    jds_dropdown_menu_item: ()=>$451487d20aa3eb8a$export$ed97964d1871885d,
    jds_dropdown_menu_group: ()=>$451487d20aa3eb8a$export$246bebaba3a2f70e,
    jds_dropdown_menu: ()=>$451487d20aa3eb8a$export$e44a253a59704894,
    jds_dropdown_menu_submenu: ()=>$451487d20aa3eb8a$export$51cd9091d2dcc10a,
    jds_dropdown_menu_sub_menu_internal: ()=>$451487d20aa3eb8a$export$897b7938c608ac58,
    jds_dropdown_menu_internal: ()=>$451487d20aa3eb8a$export$5a9d97cdadce1b72,
    jds_pagination_button: ()=>$451487d20aa3eb8a$export$c3639e97caabff2c,
    jds_datepicker: ()=>$451487d20aa3eb8a$export$5109c6dd95d8fb00,
    jds_datepicker_desktop_internal: ()=>$451487d20aa3eb8a$export$1f2289af8fea154d,
    jds_datepicker_mobile_internal: ()=>$451487d20aa3eb8a$export$1f2289af8fea154d,
    jds_menu_block: ()=>$451487d20aa3eb8a$export$3a7690908a5e9b5,
    jds_menu_block_internal: ()=>$451487d20aa3eb8a$export$f9b98c24bc73aa75,
    jds_list_block: ()=>$451487d20aa3eb8a$export$7c8f337671b808e4,
    jds_input: ()=>$451487d20aa3eb8a$var$Input,
    jds_input_code_item: ()=>$451487d20aa3eb8a$export$963da1aad44be4c4,
    jds_tab_bar: ()=>$451487d20aa3eb8a$export$f97dc4a5a0177256,
    jds_search_results: ()=>$451487d20aa3eb8a$export$aee53da69e9839be,
    jds_search_result_text: ()=>$451487d20aa3eb8a$export$2a7e910d17016306,
    jds_stepper_dot: ()=>$451487d20aa3eb8a$export$435f28d5690c41ca,
    jds_step_item_vertical: ()=>$451487d20aa3eb8a$export$c4bee818be0dfd5a,
    jds_step_item_horizontal: ()=>$451487d20aa3eb8a$export$210661c11db5ef0f,
    jds_spinner: ()=>$451487d20aa3eb8a$export$7f7cbe89f1eacd2,
    jds_tooltip: ()=>$451487d20aa3eb8a$export$28c660c63b792dea,
    jds_tooltip_internal: ()=>$451487d20aa3eb8a$export$d8d56a9a74e44761,
    jds_checkbox: ()=>$451487d20aa3eb8a$export$fa1253a65a9e747d,
    swadesh_checkbox: ()=>$451487d20aa3eb8a$export$fa1253a65a9e747d,
    swadesh_text: ()=>$451487d20aa3eb8a$export$5f1af8db9871e1d6,
    jds_rating_bar_item: ()=>$451487d20aa3eb8a$export$b473c78e8d3557fd,
    jds_file_uploader_control: ()=>$451487d20aa3eb8a$export$2548bc68b9cf13da,
    jds_file_uploader_panel: ()=>$451487d20aa3eb8a$export$4089cd2315da078,
    jds_file_uploader_item: ()=>$451487d20aa3eb8a$export$b41bb47bfc36c3b4,
    jds_file_uploader_list: ()=>$451487d20aa3eb8a$export$3d00ed40fd09f854,
    jds_progress_bar: ()=>$451487d20aa3eb8a$export$c17561cb55d4db30,
    jds_input_phone_dropdown: ()=>$451487d20aa3eb8a$export$770f20817cf88abc,
    jds_badge_v2: ()=>$451487d20aa3eb8a$export$561b3597d6384588,
    jds_badge_v2_status: ()=>$451487d20aa3eb8a$export$87daca618cc26b9,
    jds_badge_v2_information: ()=>$451487d20aa3eb8a$export$50fcc0de7334f647,
    jds_badge_v2_notification: ()=>$451487d20aa3eb8a$export$5217f316f51857f9,
    jds_badge_v2_brand: ()=>$451487d20aa3eb8a$export$3b623c6160d8d9d1,
    jds_tabs_desktop: ()=>$451487d20aa3eb8a$export$b2539bed5023c21c,
    jds_megamenu_internal: ()=>$451487d20aa3eb8a$export$d7717d03c9caf572
};
const $451487d20aa3eb8a$var$componentsMap = {
    ...$451487d20aa3eb8a$var$v1Map
};
const $451487d20aa3eb8a$var$Component$z = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$2c;
    const { size: size = "medium", color: color = "primary_50", kind: kind = "default", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            color: color,
            kind: kind,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSIcon", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$f04a61298a47a40f = $451487d20aa3eb8a$var$withLogic$2e($451487d20aa3eb8a$var$Component$z);
$451487d20aa3eb8a$export$f04a61298a47a40f.displayName = "Icon";
$451487d20aa3eb8a$export$f04a61298a47a40f.slotName = "jds_icon";
const $451487d20aa3eb8a$var$_NotificationService = class {
    constructor(args){
        $451487d20aa3eb8a$var$_NotificationService.args = args;
    }
};
let $451487d20aa3eb8a$var$NotificationService = $451487d20aa3eb8a$var$_NotificationService;
$451487d20aa3eb8a$var$NotificationService.eventName = "notification";
const $451487d20aa3eb8a$var$_NotificationCloseService = class {
    constructor(args){
        $451487d20aa3eb8a$var$_NotificationCloseService.args = args;
    }
};
let $451487d20aa3eb8a$var$NotificationCloseService = $451487d20aa3eb8a$var$_NotificationCloseService;
$451487d20aa3eb8a$var$NotificationCloseService.eventName = "close-notifications";
const $451487d20aa3eb8a$var$_NotificationController = class {
    static updateNotifications(type) {
        if (type === "nudge") {
            $451487d20aa3eb8a$var$publish(new $451487d20aa3eb8a$var$NotificationService({
                type: type,
                notifications: [
                    ...$451487d20aa3eb8a$var$_NotificationController.nudges
                ]
            }));
            return;
        }
        $451487d20aa3eb8a$var$publish(new $451487d20aa3eb8a$var$NotificationService({
            type: type,
            notifications: [
                ...$451487d20aa3eb8a$var$_NotificationController.toasts
            ]
        }));
    }
    static createID(type) {
        const id = /* @__PURE__ */ new Date().getTime() + Math.random().toString();
        return this.getNotificationIndex(type, id) < 0 ? id : this.createID(type);
    }
    static getNotificationIndex(type, id) {
        if (type === "nudge") return $451487d20aa3eb8a$var$_NotificationController.nudges.findIndex((item)=>item.id === id);
        return $451487d20aa3eb8a$var$_NotificationController.toasts.findIndex((item)=>item.id === id);
    }
    static getNotification(id, type) {
        const index = $451487d20aa3eb8a$var$_NotificationController.getNotificationIndex(type, id);
        if (this.isActive(id, type) && index >= 0) {
            if (type === "nudge") return $451487d20aa3eb8a$var$_NotificationController.nudges[index];
            return $451487d20aa3eb8a$var$_NotificationController.toasts[index];
        }
    }
    static nudge(props) {
        if (!props.title) {
            console.warn("Notification: [Nudge] cannot be created as title was not provided");
            return "";
        }
        const index = this.getNotificationIndex("nudge", props.id);
        let ID = props.id;
        if (index < 0) {
            ID = props.id || this.createID("nudge");
            if (!$451487d20aa3eb8a$var$_NotificationController.isActive(ID, "nudge")) {
                const nudgeItem = {
                    showClose: true,
                    ...props,
                    id: ID
                };
                $451487d20aa3eb8a$var$_NotificationController.nudges.push(nudgeItem);
                this.updateNotifications("nudge");
            }
            return ID;
        }
        return ID;
    }
    static toast(props) {
        if (!props.title) {
            console.warn("Notification: [Toast] cannot be created as title was not provided");
            return "";
        }
        const index = this.getNotificationIndex("toast", props.id);
        let ID = props.id;
        if (index < 0) {
            ID = props.id || this.createID("toast");
            if (!$451487d20aa3eb8a$var$_NotificationController.isActive(ID, "toast")) {
                const toastItem = {
                    showClose: true,
                    ...props,
                    id: ID
                };
                $451487d20aa3eb8a$var$_NotificationController.toasts.push(toastItem);
                this.updateNotifications("toast");
            }
            return ID;
        }
        return ID;
    }
    static dismiss(id, type) {
        if (this.isActive(id, type)) {
            $451487d20aa3eb8a$var$publish(new $451487d20aa3eb8a$var$NotificationCloseService({
                [id]: type
            }));
            setTimeout(()=>{
                if (type === "nudge") {
                    const newNudgeList = $451487d20aa3eb8a$var$_NotificationController.nudges.filter((item)=>item.id !== id);
                    $451487d20aa3eb8a$var$_NotificationController.nudges = newNudgeList;
                } else {
                    const newToastList = $451487d20aa3eb8a$var$_NotificationController.toasts.filter((item)=>item.id !== id);
                    $451487d20aa3eb8a$var$_NotificationController.toasts = newToastList;
                }
                this.updateNotifications(type);
            }, 500);
        }
        return id;
    }
    static update(id, type, props) {
        const notificationIndex = this.getNotificationIndex(type, id);
        if (notificationIndex >= 0) {
            if (this.isActive(id, type)) {
                if (type === "nudge") {
                    const currentNudge = $451487d20aa3eb8a$var$_NotificationController.nudges.findIndex((nudge2)=>nudge2.id === id);
                    const updatedNudgeItem = {
                        ...$451487d20aa3eb8a$var$_NotificationController.nudges[currentNudge],
                        ...props
                    };
                    $451487d20aa3eb8a$var$_NotificationController.nudges[currentNudge] = updatedNudgeItem;
                } else {
                    const currentToast = $451487d20aa3eb8a$var$_NotificationController.toasts.findIndex((toast2)=>toast2.id === id);
                    const updatedToastItem = {
                        ...$451487d20aa3eb8a$var$_NotificationController.toasts[currentToast],
                        ...props
                    };
                    $451487d20aa3eb8a$var$_NotificationController.toasts[currentToast] = updatedToastItem;
                }
                this.updateNotifications(type);
            }
        }
    }
    static isActive(id, type) {
        const exists = type === "nudge" ? $451487d20aa3eb8a$var$_NotificationController.nudges.findIndex((nudgeItem)=>nudgeItem.id === id) >= 0 : $451487d20aa3eb8a$var$_NotificationController.toasts.findIndex((toastItem)=>toastItem.id === id) >= 0;
        return exists;
    }
    static dismissAll(type) {
        const activeIds = {};
        $451487d20aa3eb8a$var$_NotificationController.nudges.forEach((noti)=>{
            if (noti.id) activeIds[noti.id] = "nudge";
        });
        $451487d20aa3eb8a$var$_NotificationController.toasts.forEach((noti)=>{
            if (noti.id) activeIds[noti.id] = "toast";
        });
        $451487d20aa3eb8a$var$publish(new $451487d20aa3eb8a$var$NotificationCloseService(activeIds));
        setTimeout(()=>{
            if (type === "nudge") $451487d20aa3eb8a$var$_NotificationController.nudges = [];
            else $451487d20aa3eb8a$var$_NotificationController.toasts = [];
            this.updateNotifications(type);
        }, 500);
    }
};
let $451487d20aa3eb8a$var$NotificationController = $451487d20aa3eb8a$var$_NotificationController;
$451487d20aa3eb8a$var$NotificationController.nudges = [];
$451487d20aa3eb8a$var$NotificationController.toasts = [];
const $451487d20aa3eb8a$var$createProps = (props)=>typeof props === "string" ? {
        title: props
    } : props;
const $451487d20aa3eb8a$var$nudge = (props)=>$451487d20aa3eb8a$var$NotificationController.nudge($451487d20aa3eb8a$var$createProps(props));
$451487d20aa3eb8a$var$nudge.update = (id, props)=>$451487d20aa3eb8a$var$NotificationController.update(id, "nudge", $451487d20aa3eb8a$var$createProps(props));
$451487d20aa3eb8a$var$nudge.dismiss = (id)=>$451487d20aa3eb8a$var$NotificationController.dismiss(id, "nudge");
$451487d20aa3eb8a$var$nudge.dismissAll = ()=>$451487d20aa3eb8a$var$NotificationController.dismissAll("nudge");
$451487d20aa3eb8a$var$nudge.isActive = (id)=>$451487d20aa3eb8a$var$NotificationController.isActive(id, "nudge");
$451487d20aa3eb8a$var$nudge.get = (id)=>$451487d20aa3eb8a$var$NotificationController.getNotification(id, "nudge");
const $451487d20aa3eb8a$var$toast = (props)=>$451487d20aa3eb8a$var$NotificationController.toast($451487d20aa3eb8a$var$createProps(props));
$451487d20aa3eb8a$var$toast.update = (id, props)=>$451487d20aa3eb8a$var$NotificationController.update(id, "toast", $451487d20aa3eb8a$var$createProps(props));
$451487d20aa3eb8a$var$toast.dismissAll = ()=>$451487d20aa3eb8a$var$NotificationController.dismissAll("toast");
$451487d20aa3eb8a$var$toast.dismiss = (id)=>$451487d20aa3eb8a$var$NotificationController.dismiss(id, "toast");
$451487d20aa3eb8a$var$toast.info = (props)=>$451487d20aa3eb8a$var$NotificationController.toast({
        ...$451487d20aa3eb8a$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $8944871133dad5b7$export$556fe0871d9b7899), {}),
            size: "l"
        })
    });
$451487d20aa3eb8a$var$toast.error = (props)=>$451487d20aa3eb8a$var$NotificationController.toast({
        ...$451487d20aa3eb8a$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $f0c43238eeefce3e$export$ed1619aa732c6643), {}),
            size: "l"
        })
    });
$451487d20aa3eb8a$var$toast.success = (props)=>$451487d20aa3eb8a$var$NotificationController.toast({
        ...$451487d20aa3eb8a$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $a80d6d0eaf25f114$export$50c1b72d39add9), {}),
            size: "l"
        })
    });
$451487d20aa3eb8a$var$toast.warning = (props)=>$451487d20aa3eb8a$var$NotificationController.toast({
        ...$451487d20aa3eb8a$var$createProps(props),
        icon: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$f04a61298a47a40f, {
            ic: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $9802b0598e6eade4$export$47407925ae9f1f0e), {}),
            size: "l"
        })
    });
$451487d20aa3eb8a$var$toast.isActive = (id)=>$451487d20aa3eb8a$var$NotificationController.isActive(id, "toast");
$451487d20aa3eb8a$var$toast.get = (id)=>$451487d20aa3eb8a$var$NotificationController.getNotification(id, "toast");
const $451487d20aa3eb8a$var$sdl$v = {
    "metadata": {
        "version": "1.0.0",
        "id": "notification-banner-1.0.0",
        "name": "JDSNotificationBanner",
        "layerName": "jds_notification_banner"
    },
    "hierarchy": {
        "root-container": [
            {
                "main-container": [
                    {
                        "jds-icon-container": [
                            "jds-icon"
                        ]
                    },
                    {
                        "text-container": [
                            "heading-jds-text",
                            "support-jds-text"
                        ]
                    },
                    {
                        "button-container": [
                            "cta-jds_button",
                            "close-jds_button"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "bottom-cta-jds_button"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "min-height": "{n_0}",
            "width": "{n_1}",
            "flex-direction": "{n_2}",
            "justify-content": "{n_3}",
            "align-items": "{n_4}",
            "padding-top": "{n_5}",
            "padding-right": "{n_6}",
            "padding-bottom": "{n_7}",
            "padding-left": "{n_8}",
            "gap": "{n_9}",
            "border-radius": "{n_10}",
            "background-color": "{n_11}",
            "enter-animation-name": "slideVerticallyDown",
            "exit-animation-name": "slideVerticallyUp",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500,
            "translate-y": 0,
            "transition": {
                "property": [
                    "translate-y"
                ],
                "duration": "{medium}",
                "timing-function": "{easeJoyfulEntrance}"
            }
        },
        "main-container": {
            "flex-direction": "{n_12}",
            "justify-content": "{n_13}",
            "align-items": "{n_14}",
            "width": "{n_15}",
            "gap": "{n_16}"
        },
        "text-container": {
            "flex": 1,
            "justify-content": "{n_17}",
            "align-items": "{n_18}",
            "flex-direction": "{n_19}",
            "gap": "{n_20}"
        },
        "button-container": {
            "flex-direction": "{n_21}",
            "gap": "{n_22}"
        },
        "cta-jds_button": {
            "hidden": false,
            "size": "small",
            "kind": "secondary"
        },
        "close-jds_button": {
            "size": "small",
            "kind": "tertiary",
            "icon": "ic_close"
        },
        "bottom-container": {
            "hidden": true,
            "flex-direction": "{n_24}",
            "justify-content": "{n_25}",
            "align-items": "{n_26}",
            "width": "{n_23}"
        },
        "bottom-cta-jds_button": {
            "size": "small",
            "kind": "secondary"
        },
        "jds-icon": {
            "size": "{l}",
            "color": "{primary50}"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{l}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "heading-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "support-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 4,
            "maxLines": 4
        }
    },
    "variant": {
        "ctaPosition": {
            "bottom": {
                "cta-jds_button": {
                    "hidden": true
                },
                "bottom-container": {
                    "hidden": false
                }
            }
        },
        "open": {
            "false": {
                "root-container": {
                    "hidden": true,
                    "translate-y": "{size.negativeMax}",
                    "transition": {
                        "timing-function": "{easeJoyfulExit}"
                    }
                }
            }
        },
        "_showClose": {
            "false": {
                "close-jds_button": {
                    "hidden": true
                }
            }
        },
        "_hasDescription": {
            "false": {
                "main-container": {
                    "align-items": "{n_27}"
                },
                "support-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "desktop": {
                    "root-container": {
                        "padding-left": "{n_28}",
                        "padding-right": "{n_29}",
                        "border-radius": 0
                    }
                },
                "mobile": {
                    "root-container": {
                        "padding-left": "{n_30}",
                        "padding-right": "{n_31}",
                        "border-radius": 0
                    }
                },
                "tablet": {
                    "root-container": {
                        "padding-left": "{n_32}",
                        "padding-right": "{n_33}",
                        "border-radius": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "global",
            "_platform"
        ]
    ],
    "api": {
        "config": {
            "global": {
                "values": [
                    false,
                    true
                ]
            },
            "open": {
                "values": [
                    true,
                    false
                ]
            },
            "closeOnSuffixClick": {
                "values": [
                    true,
                    false
                ]
            },
            "ctaPosition": {
                "values": [
                    "inline",
                    "bottom"
                ]
            },
            "_showClose": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "tablet",
                    "mobile"
                ]
            },
            "_hasDescription": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "cta-jds_button": {
                "label": {
                    "type": "string",
                    "name": "cta"
                }
            },
            "close-jds_button": {
                "icon": {
                    "type": "icon",
                    "name": "suffix"
                }
            },
            "bottom-cta-jds_button": {
                "label": {
                    "type": "string",
                    "name": "cta"
                }
            },
            "jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                },
                "ic": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "heading-jds-text": {
                "value": {
                    "type": "string",
                    "name": "title"
                }
            },
            "support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            }
        },
        "events": {
            "cta-jds_button": {
                "onClick": "onCTAClick"
            },
            "bottom-cta-jds_button": {
                "onClick": "onCTAClick"
            },
            "close-jds_button": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "root-container": {
                "properties": {
                    "role": {
                        "value": "banner"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "title"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "cta-jds_button": {
                "properties": {
                    "ariaLabel": "ctaAriaLabel",
                    "ariaDescribedby": {
                        "name": "ctaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "close-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "closeButtonAriaLabel",
                        "value": "Close Button"
                    },
                    "ariaDescribedby": {
                        "name": "closeButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "bottom-cta-jds_button": {
                "properties": {
                    "ariaLabel": "ctaAriaLabel",
                    "ariaDescribedby": {
                        "name": "ctaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$7 = (props)=>{
    if (typeof props.description === "object") console.warn("Passing Listblock props is deprecated. Please pass a string");
    return {
        cta: {
            properties: {
                cta: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.cta, "title", ""),
                onCTAClick: props.cta?.onClick ?? props.onCTAClick
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$w = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$7);
        const [open, setOpen] = (0, $1OEoy.useState)(props.open);
        const [internalOpen, setInternalOpen] = (0, $1OEoy.useState)(props.open);
        (0, $1OEoy.useEffect)(()=>{
            if (props.open) {
                setOpen(true);
                setTimeout(()=>{
                    setInternalOpen(true);
                }, 10);
            } else {
                setOpen(false);
                setTimeout(()=>setInternalOpen(false), 500);
            }
        }, [
            props.open
        ]);
        const getPlatform = ()=>{
            if ($451487d20aa3eb8a$var$Devices.isMobile()) return "mobile";
            if ($451487d20aa3eb8a$var$Devices.isTablet()) return "tablet";
            return "desktop";
        };
        const expandedClass = internalOpen && open ? "expanded" : "";
        const classes = [
            expandedClass
        ];
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                open: open || internalOpen,
                _showClose: !(props.suffix === null),
                _platform: getPlatform(),
                className: classes.join(" "),
                suffix: [
                    "",
                    void 0
                ].includes(props.suffix) ? "IcClose" : props.suffix,
                onSuffixClick: (ev)=>{
                    if (props.closeOnSuffixClick) {
                        setOpen(false);
                        setTimeout(()=>{
                            setInternalOpen(false);
                        }, 500);
                    }
                    props.onSuffixClick?.(ev);
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$y = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$v;
    const { global: global = false, open: open = true, closeOnSuffixClick: closeOnSuffixClick = true, ctaPosition: ctaPosition = "inline", onCTAClick: onCTAClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.title?.toString(), closeButtonAriaLabel: closeButtonAriaLabel = "Close Button", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            global: global,
            open: open,
            closeOnSuffixClick: closeOnSuffixClick,
            ctaPosition: ctaPosition,
            onCTAClick: onCTAClick,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            closeButtonAriaLabel: closeButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNotificationBanner", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$NotificationBanner = $451487d20aa3eb8a$var$withLogic$w($451487d20aa3eb8a$var$Component$y);
$451487d20aa3eb8a$var$NotificationBanner.displayName = "NotificationBanner";
$451487d20aa3eb8a$var$NotificationBanner.slotName = "jds_notification_banner";
const $451487d20aa3eb8a$var$sdl$u = {
    "metadata": {
        "version": "1.0.0",
        "id": "nudge-1.0.0",
        "name": "JDSNudgeContainer",
        "layerName": "jds_nudge_container"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    {
                        "root-container": [
                            "jds_nudge"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{n_0}",
            "size": "{n_1}",
            "padding-top": "{n_2}",
            "padding-right": "{n_3}",
            "padding-bottom": "{n_4}",
            "padding-left": "{n_5}"
        },
        "root-container": {
            "flex-direction": "{n_6}",
            "justify-content": "{n_7}",
            "align-items": "{n_8}",
            "size": "{n_9}",
            "gap": "{n_10}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "root-container": {
                "value": {
                    "type": "list",
                    "name": "activeNudges",
                    "object": {
                        "title": "string",
                        "description": "string",
                        "primaryCTA": "string",
                        "secondaryCTA": "string",
                        "showClose": "boolean",
                        "id": "string",
                        "prefix": "string"
                    }
                }
            },
            "jds_nudge": {
                "prefix": {
                    "type": "string",
                    "name": "activeNudges.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "activeNudges.title"
                },
                "description": {
                    "type": "string",
                    "name": "activeNudges.description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "activeNudges.primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "activeNudges.secondaryCTA"
                },
                "showClose": {
                    "type": "string",
                    "name": "activeNudges.showClose"
                },
                "id": {
                    "type": "string",
                    "name": "activeNudges.id"
                },
                "suffix": {
                    "type": "slot",
                    "name": "activeNudges.suffix"
                },
                "maxLines": {
                    "type": "number",
                    "name": "activeNudges.maxLines"
                }
            }
        },
        "events": {
            "jds_nudge": {
                "onClose": "onClose",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onShow": "onShow"
            }
        },
        "a11y": {
            "jds_nudge": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$v = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                activeNudges: props.nudges.map((n)=>({
                        ...n,
                        prefix: n.prefix || n.icon
                    }))
            }
        });
    };
const $451487d20aa3eb8a$var$Component$x = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$u;
    const { onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onShow: onShow = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onShow: onShow,
            ...rest
        },
        componentTag: componentTag
    }, "JDSNudgeContainer", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$NudgeContainer = $451487d20aa3eb8a$var$withLogic$v($451487d20aa3eb8a$var$Component$x);
$451487d20aa3eb8a$var$NudgeContainer.displayName = "NudgeContainer";
$451487d20aa3eb8a$var$NudgeContainer.slotName = "jds_nudge_container";
const $451487d20aa3eb8a$var$sdl$t = {
    "metadata": {
        "version": "1.0.0",
        "id": "toast-1.0.0",
        "name": "JDSToastContainer",
        "layerName": "jds_toast_container"
    },
    "hierarchy": {
        "popup": [
            {
                "popup-container": [
                    {
                        "root-container": [
                            "jds_toast"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "popup": {
            "priority": 70,
            "passive": true
        },
        "popup-container": {
            "flex-direction": "{t_0}",
            "size": "{t_1}",
            "padding-top": "{t_2}",
            "padding-right": "{t_3}",
            "padding-bottom": "{t_4}",
            "padding-left": "{t_5}"
        },
        "root-container": {
            "flex-direction": "{t_6}",
            "justify-content": "{t_7}",
            "align-items": "{t_8}",
            "size": "{t_9}",
            "gap": "{t_10}"
        }
    },
    "variant": {},
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "data": {
            "root-container": {
                "value": {
                    "type": "list",
                    "name": "activeToasts",
                    "object": {
                        "title": "string",
                        "description": "string",
                        "primaryCTA": "string",
                        "secondaryCTA": "string",
                        "showClose": "boolean",
                        "dismissAfter": "number",
                        "id": "string",
                        "prefix": "string"
                    }
                }
            },
            "jds_toast": {
                "prefix": {
                    "type": "string",
                    "name": "activeToasts.prefix"
                },
                "title": {
                    "type": "string",
                    "name": "activeToasts.title"
                },
                "description": {
                    "type": "string",
                    "name": "activeToasts.description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "activeToasts.primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "activeToasts.secondaryCTA"
                },
                "showClose": {
                    "type": "string",
                    "name": "activeToasts.showClose"
                },
                "id": {
                    "type": "string",
                    "name": "activeToasts.id"
                },
                "dismissAfter": {
                    "type": "number",
                    "name": "activeToasts.dismissAfter"
                },
                "suffix": {
                    "type": "slot",
                    "name": "activeToasts.suffix"
                }
            }
        },
        "events": {
            "jds_toast": {
                "onClose": "onClose",
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick",
                "onShow": "onShow"
            }
        },
        "a11y": {
            "jds_toast": {
                "properties": {
                    "ariaLabel": "ariaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$u = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                activeToasts: props.toasts.map((t)=>({
                        ...t,
                        prefix: t.prefix || t.icon
                    }))
            }
        });
    };
const $451487d20aa3eb8a$var$Component$w = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$t;
    const { onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onShow: onShow = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onClose: onClose,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            onShow: onShow,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToastContainer", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$ToastContainer = $451487d20aa3eb8a$var$withLogic$u($451487d20aa3eb8a$var$Component$w);
$451487d20aa3eb8a$var$ToastContainer.displayName = "ToastContainer";
$451487d20aa3eb8a$var$ToastContainer.slotName = "jds_toast_container";
const $451487d20aa3eb8a$var$NotificationContainer = (props)=>{
    const { className: className, onShow: onShow, onClose: onClose, ...rest } = props;
    const classes = [
        className,
        "j-notificationContainer"
    ].join(" ");
    const notificationContRef = (0, $1OEoy.useRef)(null);
    const [nudges, setNudges] = (0, $1OEoy.useState)([]);
    const [toasts, setToasts] = (0, $1OEoy.useState)([]);
    const maxOnScreen = $451487d20aa3eb8a$var$Devices.isMobile() ? 1 : 5;
    (0, $1OEoy.useEffect)(()=>{
        const { unsubscribe: nudgeUnsubscribe } = $451487d20aa3eb8a$var$subscribe($451487d20aa3eb8a$var$NotificationService, (data)=>{
            if (data.type === "nudge") setNudges(data.notifications);
        });
        const { unsubscribe: toastUnsubscribe } = $451487d20aa3eb8a$var$subscribe($451487d20aa3eb8a$var$NotificationService, (data)=>{
            if (data.type === "toast") setToasts(data.notifications);
        });
        return ()=>{
            $451487d20aa3eb8a$var$nudge.dismissAll();
            nudgeUnsubscribe();
            $451487d20aa3eb8a$var$toast.dismissAll();
            toastUnsubscribe();
        };
    }, []);
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
        className: classes,
        ...rest,
        ref: notificationContRef,
        children: [
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$NudgeContainer, {
                onShow: onShow,
                onClose: onClose,
                nudges: nudges.slice(0, maxOnScreen).reverse()
            }),
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$ToastContainer, {
                onShow: onShow,
                onClose: onClose,
                toasts: toasts.slice(0, maxOnScreen).reverse()
            })
        ]
    });
};
$451487d20aa3eb8a$var$NotificationContainer.displayName = "NotificationContainer";
$451487d20aa3eb8a$var$NotificationContainer.defaultProps = {};
const $451487d20aa3eb8a$var$sdl$s = {
    "metadata": {
        "version": "1.0.0",
        "id": "accordion-list-1.0.0",
        "name": "JDSAccordionList",
        "layerName": "jds_accordion_list"
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    "jds_accordion"
                ]
            },
            "content-slot"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{a_0}",
            "width": "{a_1}"
        },
        "container": {
            "hidden": true,
            "flex-direction": "{a_2}",
            "width": "{a_3}"
        },
        "content-slot": {
            "hidden": false
        }
    },
    "variant": {
        "_hasItems": {
            "true": {
                "content-slot": {
                    "hidden": true
                },
                "container": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "function": true,
                    "object": {
                        "children": "slot",
                        "prefix": "slot",
                        "expandedPanel": "boolean",
                        "showDivider": "boolean",
                        "disabled": "boolean",
                        "title": "string",
                        "subtitle": "string",
                        "onClick": "event"
                    }
                }
            },
            "jds_accordion": {
                "iconType": {
                    "type": "JDSAccordion.iconType",
                    "name": "iconType"
                },
                "children": {
                    "type": "slot",
                    "name": "items.children"
                },
                "prefix": {
                    "type": "slot",
                    "name": "items.prefix"
                },
                "expandedPanel": {
                    "type": "boolean",
                    "name": "items.expandedPanel"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "title": {
                    "type": "string",
                    "name": "items.title"
                },
                "showDivider": {
                    "type": "boolean",
                    "name": "items.showDivider"
                },
                "subtitle": {
                    "type": "string",
                    "name": "items.subtitle"
                },
                "onClick": {
                    "type": "event",
                    "name": "items.onClick"
                }
            }
        },
        "config": {
            "iconType": {
                "type": "JDSAccordion.iconType",
                "values": [
                    "chevron",
                    "plus"
                ]
            },
            "allowMultiple": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasItems": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "jds_accordion"
                ]
            }
        },
        "a11y": {
            "container": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": "ariaDescribedby"
                }
            },
            "jds_accordion": {
                "properties": {
                    "ariaLabel": "items.ariaLabel",
                    "ariaDescribedby": "items.ariaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$getAllowedPanels = (panels, allowMultiple)=>{
    if (!panels) return [];
    if (allowMultiple) return panels;
    return [
        panels[0]
    ];
};
const $451487d20aa3eb8a$var$withLogic$t = (Component)=>(props)=>{
        const { allowMultiple: allowMultiple, children: children, onChange: onChange, iconType: iconType } = props;
        const [selected, setSelected] = (0, $1OEoy.useState)($451487d20aa3eb8a$var$getAllowedPanels(props.expanded, allowMultiple));
        (0, $1OEoy.useEffect)(()=>{
            setSelected($451487d20aa3eb8a$var$getAllowedPanels(props.expanded, allowMultiple));
        }, [
            props.expanded,
            allowMultiple
        ]);
        const childrenArray = (0, $1OEoy.useMemo)(()=>{
            if (!children) return [];
            if (Array.isArray(children)) return children;
            if (children.type === Symbol.for("react.fragment")) {
                const validChild = children.props.children;
                return Array.isArray(validChild) ? validChild : [
                    validChild
                ];
            }
            return [
                children
            ];
        }, [
            children
        ]);
        const handleSelected = (0, $1OEoy.useCallback)((i)=>{
            let newSelected = [
                ...selected
            ];
            if (selected.includes(i)) {
                const idx = newSelected.findIndex((s)=>s === i);
                if (allowMultiple) {
                    if (idx >= 0) newSelected.splice(idx, 1);
                } else newSelected = [];
            } else if (!allowMultiple) newSelected = [
                i
            ];
            else newSelected.push(i);
            setSelected(newSelected);
            onChange?.(newSelected);
        }, [
            selected,
            allowMultiple,
            onChange
        ]);
        const expandedChildren = (0, $1OEoy.useMemo)(()=>childrenArray?.map((c, i)=>{
                return (0, $1OEoy.cloneElement)(c, {
                    ...c.props,
                    iconType: iconType || c.props.iconType,
                    onClick: (e)=>{
                        handleSelected(i);
                        c.props.onClick?.(e);
                    },
                    expandedPanel: c?.props?.expandedPanel || selected.includes(i),
                    disabled: Boolean(c.props?.disabled)
                });
            }), [
            childrenArray,
            handleSelected,
            iconType,
            selected
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasItems: Boolean(props.items?.length),
                items: props?.items?.map((item, i)=>{
                    return {
                        ...item,
                        key: item?.title ?? "" + i,
                        iconType: iconType,
                        onClick: (e)=>{
                            handleSelected(i);
                            item.onClick?.(e);
                        },
                        expandedPanel: item?.expandedPanel || selected.includes(i),
                        disabled: Boolean(item?.disabled)
                    };
                })
            },
            children: expandedChildren
        });
    };
const $451487d20aa3eb8a$var$Component$v = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$s;
    const { iconType: iconType = "undefined", allowMultiple: allowMultiple = false, custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            iconType: iconType,
            allowMultiple: allowMultiple,
            ...rest
        },
        componentTag: componentTag
    }, "JDSAccordionList", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$a766cd26d0d69044 = $451487d20aa3eb8a$var$withLogic$t($451487d20aa3eb8a$var$Component$v);
$451487d20aa3eb8a$export$a766cd26d0d69044.displayName = "Accordion";
$451487d20aa3eb8a$export$a766cd26d0d69044.slotName = "jds_accordion_list";
const $451487d20aa3eb8a$var$sdl$r = {
    "metadata": {
        "version": "1.0.0",
        "id": "base-icon-1.0.0",
        "name": "JDSBaseIcon",
        "layerName": "jds_base_icon"
    },
    "hierarchy": {
        "icon": []
    },
    "base": {
        "icon": {
            "size": "{b_0}",
            "color": "{b_1}"
        }
    },
    "variant": {
        "color": {
            "primary_30": {
                "icon": {
                    "color": "{b_2}"
                }
            },
            "primary_60": {
                "icon": {
                    "color": "{b_3}"
                }
            },
            "primary_70": {
                "icon": {
                    "color": "{b_4}"
                }
            },
            "primary_background": {
                "icon": {
                    "color": "{b_5}"
                }
            },
            "secondary_50": {
                "icon": {
                    "color": "{b_6}"
                }
            },
            "sparkle_50": {
                "icon": {
                    "color": "{b_7}"
                }
            },
            "primary_grey_60": {
                "icon": {
                    "color": "{b_8}"
                }
            },
            "primary_grey_80": {
                "icon": {
                    "color": "{b_9}"
                }
            },
            "primary_grey_100": {
                "icon": {
                    "color": "{b_10}"
                }
            },
            "feedback_success": {
                "icon": {
                    "color": "{b_11}",
                    "value": "ic_success_colored"
                }
            },
            "feedback_error": {
                "icon": {
                    "color": "{b_12}",
                    "value": "ic_error_colored"
                }
            },
            "feedback_warning": {
                "icon": {
                    "color": "{b_13}",
                    "value": "ic_warning_colored"
                }
            },
            "feedback_success_50": {
                "icon": {
                    "color": "{b_11}"
                }
            },
            "feedback_error_50": {
                "icon": {
                    "color": "{b_12}"
                }
            },
            "feedback_warning_50": {
                "icon": {
                    "color": "{b_13}"
                }
            },
            "white": {
                "icon": {
                    "color": "{b_14}"
                }
            },
            "none": {
                "icon": {
                    "color": "{b_15}"
                }
            }
        }
    },
    "api": {
        "config": {
            "color": {
                "values": [
                    "primary_50",
                    "primary_30",
                    "primary_60",
                    "primary_70",
                    "primary_background",
                    "secondary_50",
                    "sparkle_50",
                    "primary_grey_60",
                    "primary_grey_80",
                    "primary_grey_100",
                    "feedback_success",
                    "feedback_error",
                    "feedback_warning",
                    "feedback_success_50",
                    "feedback_error_50",
                    "feedback_warning_50",
                    "white",
                    "none"
                ]
            }
        },
        "data": {
            "icon": {
                "size": {
                    "type": "size",
                    "default": 16,
                    "name": "size",
                    "function": true,
                    "doc_description": "It can take the integer size user wants to pass."
                },
                "value": {
                    "type": "icon",
                    "name": "ic",
                    "function": true,
                    "doc_description": "It can take the icon user wants to pass or the name of icon. e.g. `ic='IcFavorite'`. User can also pass any custom icon he may have stored locally."
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$s = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$u = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$r;
    const { color: color = "primary_50", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            color: color,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBaseIcon", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$20931e2295160b07 = $451487d20aa3eb8a$var$withLogic$s($451487d20aa3eb8a$var$Component$u);
$451487d20aa3eb8a$export$20931e2295160b07.displayName = "BaseIcon";
$451487d20aa3eb8a$export$20931e2295160b07.slotName = "jds_base_icon";
const $451487d20aa3eb8a$var$sdl$q = {
    "metadata": {
        "version": "1.0.0",
        "id": "bottom-navigation-1.0.0",
        "name": "JDSBottomNavigation",
        "layerName": "jds_bottom_navigation"
    },
    "hierarchy": {
        "container": [
            "jds_bottom_navigation_item"
        ]
    },
    "base": {
        "container": {
            "width": "{b_0}",
            "flex-direction": "{b_1}",
            "justify-content": "{b_2}",
            "align-items": "{b_3}",
            "background-color": "{b_4}",
            "padding-left": "{b_5}",
            "padding-top": "{b_6}",
            "padding-right": "{b_7}",
            "padding-bottom": "{b_8}",
            "gap": "{b_9}",
            "box-shadow": {
                "x": "{b_10}",
                "y": "{b_11}",
                "blur": "{b_12}",
                "spread": "{b_13}",
                "color": "{b_15}"
            }
        },
        "jds_bottom_navigation_item": {
            "flex": "{b_14}"
        }
    },
    "variant": {
        "multiLine": {
            "true": {
                "jds_bottom_navigation_item": {
                    "multiLine": true
                }
            },
            "false": {
                "jds_bottom_navigation_item": {
                    "multiLine": false
                }
            }
        }
    },
    "api": {
        "config": {
            "multiLine": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "icon": "icon",
                        "label": "string",
                        "disabled": "boolean"
                    },
                    "doc_description": "It shows list of items."
                }
            },
            "jds_bottom_navigation_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "activeIndex",
                    "doc_description": "It can be used to change the current active index."
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                },
                "linkProps": {
                    "type": "object",
                    "name": "items.linkProps"
                },
                "showLabel": {
                    "type": "boolean",
                    "name": "showLabel",
                    "doc_description": "Shows label below icon if true,by default it is false."
                }
            }
        },
        "events": {
            "jds_bottom_navigation_item": {
                "onItemClick": "onChange"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "tablist"
                    }
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "navAriaLabel",
                    "ariaDescribedby": {
                        "name": "navAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_bottom_navigation_item": {
                "properties": {
                    "ariaLabel": "items.navAriaLabel",
                    "ariaDescribedby": "items.navAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$6 = (props = {})=>{
    return {
        items: {
            properties: {
                items: props?.items?.map((i)=>({
                        ...i,
                        label: i.label || i.title
                    }))
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$r = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$6);
        const { activeIndex: activeIndex, items: items = [], onChange: onChange, ...rest } = props;
        const { index: index, onClick: onClick } = $451487d20aa3eb8a$var$useSelected(activeIndex);
        const navItems = items.map((item, i)=>({
                ...item,
                linkProps: {
                    href: item["href"],
                    provider: item["provider"],
                    target: item["target"],
                    newTab: item["newTab"]
                },
                showLabel: props.showLabel,
                onClick: (ev)=>{
                    if (!item.disabled) {
                        item["onClick"]?.(ev);
                        onClick(i);
                        onChange?.(i);
                    }
                }
            }));
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                items: navItems,
                activeIndex: index,
                selectedIndex: index
            }
        });
    };
const $451487d20aa3eb8a$var$Component$t = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$q;
    const { multiLine: multiLine = false, onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            multiLine: multiLine,
            onChange: onChange,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBottomNavigation", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$b77dc13a7753f3ee = $451487d20aa3eb8a$var$withLogic$r($451487d20aa3eb8a$var$Component$t);
$451487d20aa3eb8a$export$b77dc13a7753f3ee.displayName = "BottomNav";
$451487d20aa3eb8a$export$b77dc13a7753f3ee.slotName = "jds_bottom_navigation";
const $451487d20aa3eb8a$var$sdl$p = {
    "metadata": {
        "version": "1.0.0",
        "id": "breadcrumbs-1.0.0",
        "name": "JDSBreadcrumbs",
        "layerName": "jds_breadcrumbs",
        "platform": "web",
        "description": "Breadcrumbs are a navigation system used to show hierarchy and navigational context for a user's location on a website. It helps users to understand where they are within a website's structure and move between levels.",
        "usage": "Breadcrumbs are used to categorize information in the search results and thus help the SEO of the site."
    },
    "hierarchy": {
        "container": [
            {
                "link-container": [
                    "jds_link",
                    {
                        "jds-icon-container": [
                            "jds-icon"
                        ]
                    }
                ]
            },
            "jds-text",
            "jds_menu_block"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{b_0}",
            "justify-content": "{b_1}",
            "align-items": "{b_2}",
            "height": "{b_3}"
        },
        "link-container": {
            "flex-direction": "{b_4}",
            "justify-content": "{b_5}",
            "align-items": "{b_6}"
        },
        "jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_right",
            "ic": "ic_chevron_right"
        },
        "jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_right"
        },
        "jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey80}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "api": {
        "data": {
            "link-container": {
                "value": {
                    "type": "list",
                    "name": "shownLinks",
                    "object": {
                        "newTab": "boolean",
                        "href": "string",
                        "title": "string",
                        "routerLinkProps": "object",
                        "provider": "object",
                        "onClick": "event"
                    }
                }
            },
            "jds_link": {
                "title": {
                    "type": "string",
                    "name": "shownLinks.title"
                },
                "newTab": {
                    "type": "string",
                    "name": "shownLinks.newTab",
                    "platform": "web"
                },
                "href": {
                    "type": "string",
                    "name": "shownLinks.href"
                },
                "routerLinkProps": {
                    "type": "RouterLinkProps",
                    "name": "shownLinks.routerLinkProps",
                    "platform": "angular"
                },
                "onClick": {
                    "type": "event",
                    "name": "shownLinks.onClick"
                },
                "provider": {
                    "type": "event",
                    "name": "shownLinks.provider",
                    "platform": "react"
                }
            },
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "hiddenLinks"
                },
                "open": {
                    "type": "boolean",
                    "name": "open"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "maxWidth"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "jds-text": {
                "value": {
                    "type": "string",
                    "name": "currentPage"
                }
            }
        },
        "events": {
            "jds_link": {
                "onClick": "onClick"
            },
            "jds_menu_block": {
                "onSelect": "onSelect",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "navigation"
                    }
                }
            },
            "link-container": {
                "name": "shownLinks",
                "repeating": {
                    "ariaLabel": "linkAriaLabel",
                    "ariaDescribedby": {
                        "name": "linkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_link": {
                "properties": {
                    "ariaLabel": "shownLinks.linkAriaLabel",
                    "ariaDescribedby": "shownLinks.linkAriaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$q = (Component)=>(props)=>{
        const { children: children = [], links: linksArray = [] } = props;
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const [open, setOpen] = (0, $1OEoy.useState)(false);
        const truncatedRef = (0, $1OEoy.useRef)(false);
        const [position, setPosition] = (0, $1OEoy.useState)({
            x: 0,
            y: 0,
            height: 0
        });
        const normalizedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).Children.toArray(children);
        const allowedLinkIndices = (0, $1OEoy.useMemo)(()=>{
            const lastIndex = normalizedChildren.length - 1 || linksArray.length - 1 || 0;
            return [
                0,
                lastIndex
            ];
        }, [
            normalizedChildren,
            linksArray
        ]);
        const hiddenLinks = normalizedChildren.map((l, i)=>{
            if (!allowedLinkIndices.includes(i)) return {
                label: l.props?.title || linksArray?.[i]?.title
            };
            return null;
        }).filter((i)=>!!i);
        const getShownLinks = (0, $1OEoy.useMemo)(()=>{
            if (normalizedChildren.length > 1 && (element?.offsetWidth && element.offsetWidth > window.innerWidth / 2 || truncatedRef.current)) {
                truncatedRef.current = true;
                return allowedLinkIndices.map((index, i)=>{
                    if (i === 1) return {
                        title: "...",
                        onClick: (ev)=>{
                            setOpen(true);
                            const { target: target } = ev;
                            const { left: left, top: top, height: height } = $451487d20aa3eb8a$var$setPositions(target, void 0);
                            setPosition({
                                x: left,
                                y: top,
                                height: height
                            });
                        }
                    };
                    return normalizedChildren[index]?.props || linksArray?.[index];
                });
            } else if (!truncatedRef.current) {
                truncatedRef.current = false;
                return linksArray.length ? linksArray : normalizedChildren.map((l)=>l.props);
            }
        }, [
            element,
            normalizedChildren,
            allowedLinkIndices,
            linksArray
        ]);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                hiddenLinks: hiddenLinks,
                shownLinks: getShownLinks,
                rootRef: rootRef,
                open: open,
                _offsetX: position.x,
                _offsetY: position.y,
                _maxHeight: position.height,
                maxWidth: "fit-content",
                onClose: ()=>setOpen(false),
                children: null
            }
        });
    };
const $451487d20aa3eb8a$var$Component$s = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$p;
    const { onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            onClick: onClick,
            onSelect: onSelect,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSBreadcrumbs", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$2dc68d50d56fbbd = $451487d20aa3eb8a$var$withLogic$q($451487d20aa3eb8a$var$Component$s);
$451487d20aa3eb8a$export$2dc68d50d56fbbd.displayName = "Breadcrumbs";
$451487d20aa3eb8a$export$2dc68d50d56fbbd.slotName = "jds_breadcrumbs";
const $451487d20aa3eb8a$var$sdl$o = {
    "metadata": {
        "version": "1.0.0",
        "id": "carousel-1.0.0",
        "name": "JDSCarousel",
        "layerName": "jds_carousel",
        "description": "Carousel is a component for cycling through a series of content slides that can be composed of a combination of images, text and cards.",
        "usage": "Carousels are used to promote multiple items of conent within a single area on a screen."
    },
    "hierarchy": {
        "container": [
            {
                "slider-container": [
                    "carousel-slot"
                ]
            },
            {
                "control-container": [
                    {
                        "left-container": [
                            {
                                "progress-container": [
                                    "jds_spinner",
                                    "prefix-jds_action_button"
                                ]
                            },
                            {
                                "prefix-container": [
                                    "title-jds-text",
                                    "subtitle-jds-text"
                                ]
                            }
                        ]
                    },
                    "jds_carousel_pagination",
                    {
                        "right-container": [
                            "back-jds_action_button",
                            "next-jds_action_button"
                        ]
                    }
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{c_0}",
            "justify-content": "{c_1}",
            "align-items": "{c_2}",
            "gap": "{c_3}",
            "width": "{c_4}"
        },
        "slider-container": {
            "width": "{c_5}"
        },
        "control-container": {
            "flex-direction": "{c_6}",
            "justify-content": "{c_7}",
            "align-items": "{c_8}",
            "gap": "{c_9}",
            "width": "{c_10}"
        },
        "left-container": {
            "flex": 1,
            "max-width": "{c_11}",
            "flex-direction": "{c_12}",
            "justify-content": "{c_13}",
            "align-items": "{c_14}",
            "gap": "{c_15}",
            "padding-top": "{c_16}",
            "padding-bottom": "{c_17}",
            "show": true
        },
        "progress-container": {
            "hidden": true,
            "flex-direction": "{c_21}",
            "justify-content": "{c_22}",
            "align-items": "{c_23}"
        },
        "prefix-jds_action_button": {
            "icon": "ic_play",
            "size": "medium",
            "kind": "secondary",
            "z-index": 0
        },
        "jds_spinner": {
            "hidden": true,
            "kind": "normal",
            "z-index": 0
        },
        "prefix-container": {
            "hidden": true,
            "flex-direction": "{c_18}",
            "justify-content": "{c_19}",
            "align-items": "{c_20}"
        },
        "right-container": {
            "flex": 1,
            "max-width": "{c_27}",
            "flex-direction": "{c_28}",
            "justify-content": "{c_29}",
            "align-items": "{c_30}",
            "gap": "{c_31}",
            "padding-top": "{c_32}",
            "padding-bottom": "{c_33}",
            "show": true
        },
        "back-jds_action_button": {
            "hidden": true,
            "icon": "ic_back",
            "size": "medium",
            "kind": "secondary"
        },
        "next-jds_action_button": {
            "hidden": true,
            "icon": "ic_next",
            "size": "medium",
            "kind": "secondary"
        },
        "jds_carousel_pagination": {
            "hidden": false
        },
        "title-jds-text": {
            "font-family": "{bodyXsBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXsBold}",
            "line-height": "{bodyXsBold}",
            "letter-spacing": "{bodyXsBold}",
            "font-weight": "{bodyXsBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "value": "Label",
            "text": "Label"
        },
        "subtitle-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "container": {
                    "gap": "{c_34}"
                },
                "prefix-jds_action_button": {
                    "size": "small"
                },
                "back-jds_action_button": {
                    "size": "small"
                },
                "next-jds_action_button": {
                    "size": "small"
                },
                "jds_carousel_pagination": {
                    "density": "condensed"
                }
            }
        },
        "indicatorType": {
            "label": {
                "left-container": {
                    "hidden": false
                },
                "prefix-container": {
                    "hidden": false
                },
                "jds_carousel_pagination": {
                    "hidden": true
                }
            },
            "dot_label": {
                "left-container": {
                    "hidden": false
                },
                "prefix-container": {
                    "hidden": false
                },
                "jds_carousel_pagination": {
                    "hidden": false
                }
            },
            "none": {
                "prefix-container": {
                    "hidden": true
                },
                "jds_carousel_pagination": {
                    "hidden": true
                }
            }
        },
        "autoPlay": {
            "false": {
                "left-container": {
                    "hidden": false
                }
            },
            "true": {
                "progress-container": {
                    "hidden": false
                }
            }
        },
        "showArrows": {
            "true": {
                "back-jds_action_button": {
                    "hidden": false
                },
                "next-jds_action_button": {
                    "hidden": false
                }
            }
        },
        "playing": {
            "true": {
                "prefix-jds_action_button": {
                    "icon": "ic_pause"
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "prefix-jds_action_button": {
                        "z-index": 1,
                        "kind": "tertiary"
                    },
                    "jds_spinner": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "back-jds_action_button": {
                        "hidden": true
                    }
                }
            }
        },
        {
            "true": {
                "false": {
                    "progress-container": {
                        "hidden": true
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "autoPlay",
            "showDurationProgress"
        ],
        [
            "showArrows",
            "hideLeftArrow"
        ],
        [
            "playing",
            "showPlayPause"
        ]
    ],
    "api": {
        "config": {
            "density": {
                "type": "JDSCarouselPaginationItem.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "indicatorType": {
                "values": [
                    "dot",
                    "label",
                    "dot_label",
                    "none"
                ]
            },
            "showArrows": {
                "values": [
                    false,
                    true
                ]
            },
            "hideLeftArrow": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "only used to hide the left arrow, no op when showArrows = false"
            },
            "hideNextSlide": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "only used to hide the left arrow, no op when showArrows = false"
            },
            "autoPlay": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "hide autoplay button when autoPlay=false"
            },
            "showPlayPause": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "hide autoplay button when showPlayPause=false"
            },
            "playing": {
                "values": [
                    false,
                    true
                ]
            },
            "showDurationProgress": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_carousel_pagination": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "count": {
                    "type": "number",
                    "name": "totalSlides",
                    "doc_description": "to be used when number of children != total slides (e.g. when lazyloading or server pagination)"
                },
                "items": {
                    "type": "list",
                    "name": "_paginationItems"
                }
            },
            "jds_spinner": {
                "value": {
                    "type": "number",
                    "name": "_value"
                }
            },
            "slider-container": {
                "customHeight": {
                    "type": "number",
                    "name": "customHeight",
                    "platform": "ios",
                    "doc_description": "This can be used to set a custom user provided height for carousel container, instead of default height(200) rendered from engine"
                }
            },
            "title-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                }
            },
            "subtitle-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_subtitle"
                }
            }
        },
        "children": {
            "carousel-slot": {
                "name": "children",
                "accepts": [
                    "jds_carousel_slide"
                ]
            }
        },
        "events": {
            "prefix-jds_action_button": {
                "onClick": {
                    "name": "onPlayPause",
                    "doc_description": "Triggered on resume/play/pause of auto playing slides."
                }
            },
            "back-jds_action_button": {
                "onClick": "onBackBtn"
            },
            "next-jds_action_button": {
                "onClick": "onNextBtn"
            },
            "jds_carousel_pagination": {
                "onDotClick": {
                    "name": "onDotClick",
                    "doc_description": "Triggerred on click of pagination dot"
                }
            },
            "slider-container": {
                "onClick": "onClick",
                "onSwipeLeft": "onNext",
                "onSwipeRight": "onBack"
            },
            "carousel-slot": {
                "onClick": "onClick",
                "onSwipeLeft": "onNext",
                "onSwipeRight": "onBack"
            }
        },
        "a11y": {
            "prefix-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "PlayPauseAriaLabel",
                        "value": "Pause or Play Auto slide rotation"
                    }
                }
            },
            "back-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "backButtonAriaLabel",
                        "value": "Previous Slide"
                    }
                }
            },
            "next-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Slide"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$clampValue = (index, total)=>{
    if (index < 0) return total - 1;
    if (index >= total) return 0;
    return index;
};
const $451487d20aa3eb8a$var$sortedOrder = (children)=>{
    children.sort((a, b)=>{
        const elementA = a;
        const elementB = b;
        return (elementA.props.order || -1) - (elementB.props.order || -1);
    });
    return children;
};
const $451487d20aa3eb8a$var$AUTOPLAY_DURATION = 3e3;
const $451487d20aa3eb8a$var$TRANSITION_DURATION = 300;
const $451487d20aa3eb8a$var$TOTALSPINNER_VALUE = 360;
const $451487d20aa3eb8a$var$withLogic$p = (Component)=>(0, $1OEoy.forwardRef)((userProps, ref)=>{
        const { activeIndex: activeIndex = -1, initialIndex: initialIndex = 0, slideDuration: slideDuration = $451487d20aa3eb8a$var$AUTOPLAY_DURATION, hideNextSlide: hideNextSlide, totalSlides: slideCount = 0, ...props } = userProps;
        const SLIDE_PERCENT = $451487d20aa3eb8a$var$Devices.isMobile() && !hideNextSlide ? 92 : 100;
        const totalSlides = slideCount || (0, $1OEoy.Children).count(props.children);
        const [spinnerValue, setSpinnerValue] = (0, $1OEoy.useState)($451487d20aa3eb8a$var$TOTALSPINNER_VALUE);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const transitionProgressRef = (0, $1OEoy.useRef)(false);
        const intervalRef = (0, $1OEoy.useRef)();
        const spinnerIntervalRef = (0, $1OEoy.useRef)();
        const [selected, setSelected] = (0, $1OEoy.useState)(props.playing);
        (0, $1OEoy.useEffect)(()=>{
            handleAutoPlay(Boolean(props.playing));
            return ()=>{
                clearInterval(intervalRef.current);
                clearInterval(spinnerIntervalRef.current);
            };
        }, [
            props.playing
        ]);
        const [index, setIndex] = (0, $1OEoy.useState)(0);
        const touchRef = (0, $1OEoy.useRef)({
            start: 0,
            end: 0,
            started: false,
            id: 0
        });
        const totalDistance = (0, $1OEoy.useRef)(0);
        const [totalTouchDistance, setTotalDistance] = (0, $1OEoy.useState)(0);
        (0, $1OEoy.useEffect)(()=>{
            if (typeof initialIndex !== "undefined") jumpToSlide(initialIndex);
        }, [
            initialIndex
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (element) jumpToSlide(activeIndex);
        }, [
            activeIndex
        ]);
        const handleEndSlidePositions = (idx)=>{
            const currentIndex = idx === void 0 ? index : idx;
            const slides = Array.from(element?.querySelectorAll("div.j-jds-carousel-slide-container") || []);
            const firstSlide = slides[0];
            const lastSlide = slides[slides.length - 1];
            if (firstSlide) {
                if (currentIndex === totalSlides - 1) firstSlide.style.transform = `translateX(${(totalSlides || 1) * 100}%)`;
                else firstSlide.style.transform = "unset";
            }
            if (lastSlide) {
                if (currentIndex === 0) lastSlide.style.transform = `translateX(-${(totalSlides || 1) * 100}%)`;
                else lastSlide.style.transform = "unset";
            }
        };
        const enableTransition = ()=>{
            const containerRef = element?.querySelector('div[data-testid="JDSCarousel-slider-container"]');
            if (!containerRef) return;
            containerRef.style.transitionDuration = $451487d20aa3eb8a$var$TRANSITION_DURATION + "ms";
        };
        const next = ()=>{
            if (transitionProgressRef.current) return;
            const nextIndex = $451487d20aa3eb8a$var$clampValue(index + 1, totalSlides);
            moveToPanel(nextIndex, 1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $451487d20aa3eb8a$var$TRANSITION_DURATION);
        };
        const prev = ()=>{
            if (transitionProgressRef.current) return;
            const nextIndex = $451487d20aa3eb8a$var$clampValue(index - 1, totalSlides);
            moveToPanel(nextIndex, -1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $451487d20aa3eb8a$var$TRANSITION_DURATION);
        };
        function handleImmediateTransitionToSlide(slideIndex) {
            const containerRef = element?.querySelector('div[data-testid="JDSCarousel-slider-container"]');
            if (!containerRef) return;
            containerRef.style.transitionDuration = "0ms";
            handleEndSlidePositions(totalSlides - 1);
            setTotalDistance(slideIndex * -1 * SLIDE_PERCENT);
            setTimeout(enableTransition, $451487d20aa3eb8a$var$TRANSITION_DURATION);
        }
        const jumpToSlide = (idx)=>{
            if (transitionProgressRef.current) return;
            const clampedIndex = $451487d20aa3eb8a$var$clampValue(idx, totalSlides);
            if (clampedIndex === index) return;
            moveToPanel(clampedIndex, 1);
            setTimeout(()=>{
                handleEndSlidePositions(touchRef.current.id);
            }, $451487d20aa3eb8a$var$TRANSITION_DURATION);
        };
        (0, $1OEoy.useImperativeHandle)(ref, ()=>({
                getCurrentIndex: ()=>touchRef.current.id,
                goToSlide: jumpToSlide,
                next: next,
                prev: prev,
                getCaption: (currentIndex, _)=>{
                    return (0, $1OEoy.Children).toArray(props.children)[currentIndex].props.label || "";
                }
            }));
        const moveToPanel = (index2, dir = 1)=>{
            let distance = 0;
            if (dir > 0) {
                if (index2 === 0) {
                    distance = 0;
                    transitionProgressRef.current = true;
                    setTimeout(()=>{
                        handleImmediateTransitionToSlide(0);
                        transitionProgressRef.current = false;
                    }, $451487d20aa3eb8a$var$TRANSITION_DURATION);
                } else distance = index2 * -1 * SLIDE_PERCENT;
            } else if (totalSlides - 1 === index2) {
                distance = SLIDE_PERCENT;
                transitionProgressRef.current = true;
                setTimeout(()=>{
                    handleImmediateTransitionToSlide(totalSlides - 1);
                    transitionProgressRef.current = false;
                }, $451487d20aa3eb8a$var$TRANSITION_DURATION);
            } else distance = index2 * -1 * SLIDE_PERCENT;
            setTotalDistance(distance);
            setIndex(index2);
            touchRef.current.id = index2;
        };
        const handlePointerStart = (e)=>{
            handleEndSlidePositions();
            touchRef.current.started = true;
            touchRef.current.start = e.clientX;
            totalDistance.current = totalTouchDistance;
        };
        const handlePointerMove = (ev)=>{
            const containerWidth = element?.offsetWidth || 1;
            if (touchRef.current.started) {
                touchRef.current.end = ev.clientX;
                const difference = 100 / containerWidth * (touchRef.current.end - touchRef.current.start);
                const aactiveSlideDistance = index * -1 * SLIDE_PERCENT;
                setTotalDistance(aactiveSlideDistance + difference);
            }
        };
        const handlePointerEnd = (ev)=>{
            const difference = touchRef.current.end - touchRef.current.start;
            const diff = Math.abs(difference) / ev.currentTarget.offsetWidth * 100;
            touchRef.current = {
                start: 0,
                started: false,
                end: 0,
                id: touchRef.current.id
            };
            if (Math.abs(diff) > 30) {
                if (difference < 0) next();
                else prev();
            } else setTotalDistance(totalDistance.current);
        };
        (0, $1OEoy.useEffect)(()=>{
            if (!props.autoPlay) {
                if (intervalRef.current) clearInterval(intervalRef.current);
                if (spinnerIntervalRef.current) clearInterval(spinnerIntervalRef.current);
            }
        }, [
            props.autoPlay
        ]);
        const handleAutoPlay = (selected2)=>{
            console.log("handleAutoPlay called", selected2);
            setSelected(selected2);
            if (!selected2) {
                clearInterval(intervalRef.current);
                clearInterval(spinnerIntervalRef.current);
                props?.onPause?.(index);
                setSpinnerValue(0);
            } else {
                props?.onPlay?.(index);
                const animationDuration = slideDuration;
                let startTimestamp;
                const animate = (timestamp)=>{
                    if (!startTimestamp) startTimestamp = timestamp;
                    const progress = timestamp - startTimestamp;
                    const percentage = Math.min(progress / animationDuration, 1);
                    const newValue = percentage * 360;
                    setSpinnerValue(newValue);
                    if (progress < animationDuration) requestAnimationFrame(animate);
                    else {
                        startTimestamp = 0;
                        setTimeout(animate, slideDuration);
                    }
                };
                intervalRef.current = setInterval(()=>{
                    if (transitionProgressRef.current) return;
                    const nextIndex = $451487d20aa3eb8a$var$clampValue(touchRef.current.id + 1, totalSlides);
                    moveToPanel(nextIndex, 1);
                    setTimeout(()=>{
                        handleEndSlidePositions(touchRef.current.id);
                    }, $451487d20aa3eb8a$var$TRANSITION_DURATION);
                }, slideDuration);
                animate(performance.now());
                spinnerIntervalRef.current = setInterval(()=>{
                    animate(performance.now());
                }, slideDuration);
            }
        };
        const handleDotClick = (idx)=>{
            let dir = -1;
            if (idx < index) dir = -1;
            else dir = 1;
            moveToPanel(idx, dir);
            props.onPaginationClick?.();
            handleEndSlidePositions(idx);
        };
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const localOf = (0, $ddff9b86434e3f59$export$fb5267b92d6c6cd3)(language);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
            style: {
                "--move": totalTouchDistance + "%",
                "--slide-width": SLIDE_PERCENT + "%"
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...{
                    ...props,
                    totalSlides: totalSlides,
                    rootRef: rootRef,
                    children: $451487d20aa3eb8a$var$sortedOrder((0, $1OEoy.Children).toArray(props.children)),
                    selectedIndex: index,
                    count: totalSlides,
                    _subtitle: `${getLocalNumber(index + 1)} ${localOf ?? "of"} ${getLocalNumber(totalSlides)}`,
                    onNextBtn: ()=>{
                        next();
                    },
                    onBackBtn: prev,
                    onNext: (ev, { type: type })=>{
                        if (type === "touchdown") handlePointerStart(ev);
                        else if (type === "touchmove") handlePointerMove(ev);
                        else handlePointerEnd(ev);
                    },
                    playing: selected,
                    _value: spinnerValue,
                    onPlayPause: ()=>handleAutoPlay(!selected),
                    onDotClick: handleDotClick
                }
            })
        });
    });
const $451487d20aa3eb8a$var$Component$r = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$o;
    const { density: density = "undefined", indicatorType: indicatorType = "dot", showArrows: showArrows = false, hideLeftArrow: hideLeftArrow = false, hideNextSlide: hideNextSlide = false, autoPlay: autoPlay = false, showPlayPause: showPlayPause = true, playing: playing = false, showDurationProgress: showDurationProgress = false, onPlayPause: onPlayPause = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBackBtn: onBackBtn = (0, $ddff9b86434e3f59$export$8793edee2d425525), onNextBtn: onNextBtn = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDotClick: onDotClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onNext: onNext = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBack: onBack = (0, $ddff9b86434e3f59$export$8793edee2d425525), PlayPauseAriaLabel: PlayPauseAriaLabel = "Pause or Play Auto slide rotation", backButtonAriaLabel: backButtonAriaLabel = "Previous Slide", nextButtonAriaLabel: nextButtonAriaLabel = "Next Slide", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            indicatorType: indicatorType,
            showArrows: showArrows,
            hideLeftArrow: hideLeftArrow,
            hideNextSlide: hideNextSlide,
            autoPlay: autoPlay,
            showPlayPause: showPlayPause,
            playing: playing,
            showDurationProgress: showDurationProgress,
            onPlayPause: onPlayPause,
            onBackBtn: onBackBtn,
            onNextBtn: onNextBtn,
            onDotClick: onDotClick,
            onClick: onClick,
            onNext: onNext,
            onBack: onBack,
            PlayPauseAriaLabel: PlayPauseAriaLabel,
            backButtonAriaLabel: backButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSCarousel", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$144901db2ea8e967 = $451487d20aa3eb8a$var$withLogic$p($451487d20aa3eb8a$var$Component$r);
$451487d20aa3eb8a$export$144901db2ea8e967.displayName = "Carousel";
$451487d20aa3eb8a$export$144901db2ea8e967.slotName = "jds_carousel";
const $451487d20aa3eb8a$var$sdl$n = {
    "metadata": {
        "version": "1.0.0",
        "id": "container-1.0.0",
        "name": "JDSContainer",
        "layerName": "jds_container"
    },
    "hierarchy": {
        "container": [
            "content-slot"
        ]
    },
    "base": {
        "container": {
            "show": true,
            "background-color": "{global.transparent}",
            "flex-direction": "{flexDirection.row}",
            "justify-content": "{justifyContent.start}",
            "align-items": "{alignItems.start}",
            "padding-left": 0,
            "padding-top": 0,
            "padding-bottom": 0,
            "padding-right": 0,
            "border-bottom-width": 0,
            "border-top-width": 0,
            "border-right-width": 0,
            "border-left-width": 0,
            "border-top-left-radius": 0,
            "border-top-right-radius": 0,
            "border-bottom-left-radius": 0,
            "border-bottom-right-radius": 0
        }
    },
    "variant": {
        "direction": {
            "column": {
                "container": {
                    "flex-direction": "{flexDirection.column}"
                }
            },
            "stack": {
                "container": {
                    "flex-direction": "{flexDirection.stack}"
                }
            }
        }
    },
    "combination": [
        {
            "row": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "align-items": "{alignItems.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "align-items": "{alignItems.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "align-items": "{alignItems.spaceEvenly}"
                    }
                }
            },
            "column": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "justify-content": "{justifyContent.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "justify-content": "{justifyContent.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "justify-content": "{justifyContent.spaceEvenly}"
                    }
                }
            },
            "stack": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                }
            }
        },
        {
            "row": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "justify-content": "{justifyContent.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "justify-content": "{justifyContent.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "justify-content": "{justifyContent.spaceEvenly}"
                    }
                }
            },
            "column": {
                "center": {
                    "container": {
                        "align-items": "{alignItems.center}"
                    }
                },
                "end": {
                    "container": {
                        "align-items": "{alignItems.end}"
                    }
                },
                "space-between": {
                    "container": {
                        "align-items": "{alignItems.spaceBetween}"
                    }
                },
                "space-around": {
                    "container": {
                        "align-items": "{alignItems.spaceAround}"
                    }
                },
                "space-evenly": {
                    "container": {
                        "align-items": "{alignItems.spaceEvenly}"
                    }
                }
            },
            "stack": {
                "center": {
                    "container": {
                        "justify-content": "{justifyContent.center}"
                    }
                },
                "end": {
                    "container": {
                        "justify-content": "{justifyContent.end}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "direction",
            "verticalAlign"
        ],
        [
            "direction",
            "horizontalAlign"
        ]
    ],
    "api": {
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "config": {
            "verticalAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "space-between",
                    "space-around",
                    "space-evenly"
                ]
            },
            "horizontalAlign": {
                "values": [
                    "start",
                    "center",
                    "end",
                    "space-between",
                    "space-around",
                    "space-evenly"
                ]
            },
            "direction": {
                "values": [
                    "row",
                    "column",
                    "stack"
                ]
            }
        },
        "data": {
            "container": {
                "width": {
                    "type": "token",
                    "name": "width"
                },
                "height": {
                    "type": "token",
                    "name": "height"
                },
                "background-color": {
                    "type": "string",
                    "name": "backgroundColor"
                },
                "border-radius": {
                    "type": "token",
                    "name": "radius"
                },
                "padding-left": {
                    "type": "token",
                    "name": "paddingLeft"
                },
                "padding-right": {
                    "type": "token",
                    "name": "paddingRight"
                },
                "padding-top": {
                    "type": "token",
                    "name": "paddingTop"
                },
                "padding-bottom": {
                    "type": "token",
                    "name": "paddingBottom"
                },
                "flex": {
                    "type": "number",
                    "name": "flex"
                },
                "border-left-width": {
                    "type": "token",
                    "name": "borderLeftWidth"
                },
                "border-right-width": {
                    "type": "token",
                    "name": "borderRightWidth"
                },
                "border-top-width": {
                    "type": "token",
                    "name": "borderTopWidth"
                },
                "border-bottom-width": {
                    "type": "token",
                    "name": "borderBottomWidth"
                },
                "border-top-left-radius": {
                    "type": "token",
                    "name": "borderTopLeftRadius"
                },
                "border-top-right-radius": {
                    "type": "token",
                    "name": "borderTopRightRadius"
                },
                "border-bottom-left-radius": {
                    "type": "token",
                    "name": "borderBottomLeftRadius"
                },
                "border-bottom-right-radius": {
                    "type": "token",
                    "name": "borderBottomRightRadius"
                },
                "border-color": {
                    "type": "string",
                    "name": "borderColor"
                },
                "gap": {
                    "type": "token",
                    "name": "gap"
                },
                "overflow": {
                    "type": "string",
                    "name": "overflow",
                    "platform": "web"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$o = (Component)=>(0, $1OEoy.forwardRef)((props, ref)=>{
        const [borderTop, borderRight, borderBottom, borderLeft] = props.borderWidth || [];
        const allSides = props.padding?.length === 1 ? Array.from({
            length: 4
        }).map(()=>props.padding?.[0]) : props.padding;
        const [paddingTop, paddingRight, paddingBottom, paddingLeft] = allSides || [];
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rootRef: ref,
                children: $451487d20aa3eb8a$var$convertTextToComponent(props.children),
                width: props.fullWidth ? "{size.max}" : props.width,
                borderTopWidth: borderTop || props.borderTopWidth,
                borderLeftWidth: borderLeft || props.borderLeftWidth,
                borderRightWidth: borderRight || props.borderLeftWidth,
                borderBottomWidth: borderBottom || props.borderLeftWidth,
                paddingTop: paddingTop || props.paddingTop,
                paddingBottom: paddingBottom || props.paddingBottom,
                paddingRight: paddingRight || props.paddingRight,
                paddingLeft: paddingLeft || props.paddingLeft,
                gap: props.gap ?? 0,
                borderBottomLeftRadius: props.borderBottomLeftRadius || props.radius,
                borderBottomRightRadius: props.borderBottomRightRadius || props.radius,
                borderTopLeftRadius: props.borderTopLeftRadius || props.radius,
                borderTopRightRadius: props.borderTopRightRadius || props.radius
            }
        });
    });
const $451487d20aa3eb8a$var$Component$q = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$n;
    const { verticalAlign: verticalAlign = "start", horizontalAlign: horizontalAlign = "start", direction: direction = "row", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            verticalAlign: verticalAlign,
            horizontalAlign: horizontalAlign,
            direction: direction,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContainer", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$42a852a2b6b56249 = $451487d20aa3eb8a$var$withLogic$o($451487d20aa3eb8a$var$Component$q);
$451487d20aa3eb8a$export$42a852a2b6b56249.displayName = "Container";
$451487d20aa3eb8a$export$42a852a2b6b56249.slotName = "jds_container";
const $451487d20aa3eb8a$var$sdl$m = {
    "metadata": {
        "version": "1.0.0",
        "id": "content-card-1.0.0",
        "name": "JDSContentCard",
        "layerName": "jds_content_card",
        "description": "Content cards are blocks of content that contain various combinations of components in different structures.",
        "usage": "Content cards are used to organise content in meaningful blocks within a page."
    },
    "hierarchy": {
        "root-container": [
            {
                "header-container": [
                    "header-slot"
                ]
            },
            {
                "image-content-container": [
                    "jds_image",
                    "jds_content_block"
                ]
            },
            {
                "children-container": [
                    "children-slot"
                ]
            },
            "footer-jds-text"
        ]
    },
    "base": {
        "root-container": {
            "overflow": "hidden",
            "width": "{c_0}",
            "border-radius": "{c_1}",
            "flex-direction": "{c_2}",
            "justify-content": "{c_3}",
            "align-items": "{c_4}",
            "background-color": "{c_5}",
            "padding-bottom": "{c_29}",
            "gap": "{base}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "behavior": {
                "hover": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#0000000E"
                    }
                }
            }
        },
        "header-container": {
            "hidden": false,
            "justify-content": "{c_6}",
            "align-items": "{c_7}",
            "width": "{c_8}",
            "padding-left": "{c_9}",
            "padding-right": "{c_10}"
        },
        "children-container": {
            "hidden": false,
            "justify-content": "{c_12}",
            "align-items": "{c_13}",
            "width": "{c_14}",
            "padding-left": "{c_15}"
        },
        "image-content-container": {
            "flex-direction": "{c_18}",
            "width": "{c_19}",
            "justify-content": "{c_20}",
            "align-items": "{c_21}",
            "gap": "{base}"
        },
        "jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": true,
            "imageFocus": "center"
        },
        "jds_content_block": {
            "size": "xtra-small",
            "padding-left": "{c_24}",
            "padding-right": "{c_25}"
        },
        "footer-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-left": "{c_27}",
            "padding-right": "{c_28}"
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "jds_image": {
                    "aspectRatio": "square"
                }
            },
            "landscape": {
                "jds_image": {
                    "aspectRatio": "horizontal_4_3"
                }
            },
            "portrait": {
                "jds_image": {
                    "aspectRatio": "vertical_4_5"
                }
            }
        },
        "shadow": {
            "false": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": 0,
                        "color": "#00000000"
                    }
                }
            }
        },
        "_hasHeaderSlot": {
            "false": {
                "header-container": {
                    "hidden": true
                },
                "image-content-container": {
                    "padding-top": 0
                }
            }
        },
        "_hasChildrenSlot": {
            "false": {
                "children-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentBlockAndImageProps": {
            "false": {
                "image-content-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentBlockProps": {
            "false": {
                "jds_content_block": {
                    "hidden": true
                }
            }
        },
        "_hasImageProps": {
            "false": {
                "image-content-container": {
                    "padding-top": 0
                },
                "jds_image": {
                    "hidden": true
                },
                "jds_content_block": {
                    "padding-top": 0
                }
            }
        },
        "condensed": {
            "true": {
                "jds_content_block": {
                    "ctaWrap": "vertical"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "jds_content_block": {
                    "padding-left": 0
                }
            }
        }
    },
    "combination": [
        {
            "false": {
                "xtra-xtra-small": {
                    "jds_content_block": {
                        "size": "xtra-xtra-small"
                    }
                },
                "small": {
                    "jds_content_block": {
                        "size": "small"
                    }
                },
                "medium": {
                    "jds_content_block": {
                        "size": "medium"
                    }
                },
                "large": {
                    "jds_content_block": {
                        "size": "large"
                    }
                },
                "xtra-large": {
                    "jds_content_block": {
                        "size": "xtra-large"
                    }
                }
            }
        },
        {
            "true": {
                "horizontal": {
                    "image-content-container": {
                        "padding-left": "{c_30}",
                        "padding-top": "{c_31}",
                        "flex-direction": "{c_32}"
                    },
                    "jds_image": {
                        "flex": "0.2",
                        "aspectRatio": "square"
                    },
                    "jds_content_block": {
                        "flex": "0.8",
                        "size": "xtra-xtra-small"
                    }
                },
                "vertical": {
                    "root-container": {
                        "width": "{c_33}"
                    },
                    "jds_image": {
                        "aspectRatio": "square"
                    },
                    "jds_content_block": {
                        "size": "xtra-xtra-small"
                    }
                }
            },
            "false": {
                "horizontal": {
                    "root-container": {
                        "width": "{c_34}"
                    },
                    "image-content-container": {
                        "padding-left": "{c_35}",
                        "padding-top": "{c_36}",
                        "flex-direction": "{c_37}"
                    },
                    "jds_image": {
                        "flex": "0.3"
                    },
                    "jds_content_block": {
                        "flex": "0.7"
                    }
                }
            }
        },
        {
            "true": {
                "vertical": {
                    "mobile": {
                        "root-container": {
                            "width": "{c_38}"
                        }
                    }
                }
            }
        },
        {
            "horizontal": {
                "false": {
                    "jds_content_block": {
                        "flex": 1,
                        "padding-left": 0
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "condensed",
            "size"
        ],
        [
            "condensed",
            "orientation"
        ],
        [
            "condensed",
            "orientation",
            "_platform"
        ],
        [
            "orientation",
            "_hasImageProps"
        ]
    ],
    "api": {
        "children": {
            "header-slot": {
                "name": "header",
                "accepts": [
                    "jds_list_block"
                ],
                "max": 1
            },
            "children-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "size": {
                "values": [
                    "xtra-small",
                    "xtra-xtra-small",
                    "small",
                    "medium",
                    "large",
                    "xtra-large"
                ]
            },
            "orientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ],
                "doc_description": "Horizontal orientation puts image and content side by side."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "shadow": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Toggle drop shadow"
            },
            "condensed": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasHeaderSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasChildrenSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentBlockAndImageProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentBlockProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasImageProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            }
        },
        "data": {
            "root-container": {
                "fullCardCTA": {
                    "type": "string",
                    "name": "fullCardCTA",
                    "doc_description": "When present, the entire card is clickable. If any other CTAs are sent, they will not be clickable."
                }
            },
            "jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title"
                },
                "description": {
                    "type": "string",
                    "name": "description"
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "secondaryCTA": {
                    "type": "string",
                    "name": "secondaryCTA"
                },
                "caption": {
                    "type": "slot",
                    "name": "caption",
                    "accepts": [
                        "jds_badge",
                        "jds_text",
                        "jds_tag"
                    ],
                    "function": true
                },
                "ctaWrap": {
                    "type": "JDSContentBlock.ctaWrap",
                    "name": "ctaWrap"
                },
                "isTertiary": {
                    "type": "boolean",
                    "name": "isTertiary"
                }
            },
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                },
                "alt": {
                    "type": "string",
                    "name": "imgAlt"
                },
                "title": {
                    "type": "string",
                    "name": "imgTitle"
                },
                "borderRadius": {
                    "type": "size",
                    "default": 24,
                    "name": "borderRadius"
                },
                "imageFocus": {
                    "type": "JDSImage.imageFocus",
                    "name": "imageFocus"
                }
            },
            "footer-jds-text": {
                "value": {
                    "type": "string",
                    "name": "footer"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "jds_content_block": {
                "onPrimaryClick": "onPrimaryClick",
                "onSecondaryClick": "onSecondaryClick"
            }
        },
        "a11y": {
            "jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$5 = (props)=>{
    if (typeof props.image === "object") console.warn("passing a JSX element is deprecated. pass the image source as as string");
    if (typeof props.footer === "object") console.warn("Passing JSX.Element is deprecated. Please pass a string");
    return {
        image: {
            properties: {
                image: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.image, "props.src", "")
            }
        },
        size: {
            defaultValue: "xtra-small",
            variations: {
                s: {
                    size: "small"
                },
                m: {
                    size: "medium"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                },
                l: {
                    size: "large"
                },
                xl: {
                    size: "xtra-large"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$n = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$5);
        const hasContentBlockProps = Boolean(props.title || props.description || props.primaryCTA || props.secondaryCTA || props.caption);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasHeaderSlot: Boolean(props.header),
                _hasChildrenSlot: Boolean(props.children),
                _hasContentBlockProps: hasContentBlockProps,
                _hasImageProps: Boolean(props.image),
                _hasContentBlockAndImageProps: Boolean(hasContentBlockProps || props.image),
                _platform: $451487d20aa3eb8a$var$Devices.isDesktop() ? "desktop" : "mobile",
                children: props.children ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                    style: {
                        width: "100%"
                    },
                    children: props.children
                }) : void 0
            }
        });
    };
const $451487d20aa3eb8a$var$Component$p = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$m;
    const { size: size = "xtra-small", orientation: orientation = "vertical", imageRatio: imageRatio = "wide", shadow: shadow = true, condensed: condensed = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSecondaryClick: onSecondaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            orientation: orientation,
            imageRatio: imageRatio,
            shadow: shadow,
            condensed: condensed,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            onSecondaryClick: onSecondaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSContentCard", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$60332b2344f7fe41 = $451487d20aa3eb8a$var$withLogic$n($451487d20aa3eb8a$var$Component$p);
$451487d20aa3eb8a$export$60332b2344f7fe41.displayName = "Card";
$451487d20aa3eb8a$export$60332b2344f7fe41.slotName = "jds_content_card";
const $451487d20aa3eb8a$var$YEAR_COUNT = 50;
const $451487d20aa3eb8a$var$withLogic$m = (Component)=>(props)=>{
        const { onClose: onClose, monthSelectable: monthSelectable = true, yearSelectable: yearSelectable = true, close: userClose = true, open: open, ...rest } = props;
        const closeProp = typeof open === "undefined" ? userClose : !open;
        const [state, setState] = (0, $1OEoy.useState)("default");
        const { day: day, month: month, year: year } = $451487d20aa3eb8a$var$getNormalisedDate$1(props.value);
        const [selectedMonth, setSelectedMonth] = (0, $1OEoy.useState)(month);
        const [selectedDate, setSelectedDate] = (0, $1OEoy.useState)({
            date: day,
            month: month,
            year: year
        });
        const [selectedYear, setSelectedYear] = (0, $1OEoy.useState)(year);
        const { selected: selected, toggle: toggle, close: close } = $451487d20aa3eb8a$var$useToggle(props.open, !closeProp);
        const scrollCloseListener = (0, $1OEoy.useCallback)(()=>{
            close();
            onClose?.();
        }, [
            close,
            onClose
        ]);
        (0, $1OEoy.useEffect)(()=>{
            window.addEventListener("scroll", scrollCloseListener);
            return ()=>{
                window.removeEventListener("scroll", scrollCloseListener);
            };
        }, [
            scrollCloseListener
        ]);
        (0, $1OEoy.useEffect)(()=>{
            const { day: day2, month: month2, year: year2 } = $451487d20aa3eb8a$var$getNormalisedDate$1(props.value);
            setSelectedDate({
                date: day2,
                month: month2,
                year: year2
            });
            setSelectedYear(year2);
            setSelectedMonth(month2);
        }, [
            props.value
        ]);
        const months = $451487d20aa3eb8a$var$loadedMonths(selectedMonth - 1, selectedYear, monthSelectable, props.min, props.max);
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const confirmLabelLocal = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$6d8d0ec03e692fdc)(language);
        }, [
            language
        ]);
        if (!selected) return props.children;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                confirmDate: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date).toLocaleDateString("en-GB", {
                    weekday: "short",
                    day: "2-digit",
                    month: "long",
                    year: "numeric"
                }),
                _confirmLabel: confirmLabelLocal,
                calendarData: {
                    disabledDates: props.disabledDates,
                    dateFilter: props.dateFilter,
                    min: props.min,
                    max: props.max
                },
                open: selected,
                value: new Date(selectedDate.year, selectedDate.month - 1, selectedDate.date),
                onClose: ()=>{
                    if (selected) toggle();
                    onClose?.();
                },
                onClick: (ev)=>ev.stopPropagation(),
                date: selectedDate.date,
                month: selectedMonth,
                year: selectedYear,
                monthName: [
                    selectedMonth - 1
                ]?.slice(0, 3),
                months: months,
                state: state,
                offsetX: 0,
                offsetY: 0,
                yearData: {
                    count: $451487d20aa3eb8a$var$YEAR_COUNT,
                    min: selectedYear - $451487d20aa3eb8a$var$YEAR_COUNT / 2,
                    max: selectedYear + $451487d20aa3eb8a$var$YEAR_COUNT / 2,
                    disabled: $451487d20aa3eb8a$var$getDisabledYears(selectedYear - $451487d20aa3eb8a$var$YEAR_COUNT / 2, selectedYear + $451487d20aa3eb8a$var$YEAR_COUNT / 2, props.min, props.max)
                },
                _onYearClick: ()=>setState("year_view"),
                _onMonthClick: ()=>setState("month_view"),
                _onBack: ()=>setState("default"),
                onSelect: (num, disabled)=>{
                    if (!disabled) setSelectedDate({
                        date: num,
                        month: selectedMonth,
                        year: selectedYear
                    });
                    setState("default");
                },
                _onConfirm: ()=>{
                    props.onSelect?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    props.onChange?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    props.onConfirm?.(new Date(selectedDate.year, selectedDate.month, selectedDate.date));
                    close();
                    onClose?.();
                },
                _onMonthSelect: (i)=>{
                    if (monthSelectable) {
                        setSelectedMonth(i);
                        setState("default");
                        props.onMonthSelect?.();
                    }
                },
                _onYearSelect: (i)=>{
                    if (yearSelectable) {
                        setSelectedYear(i);
                        setState("default");
                        props.onYearSelect?.();
                    }
                },
                _onPrev: ()=>setSelectedMonth((m)=>{
                        if (m === 1) {
                            setSelectedYear(selectedYear - 1);
                            return 12;
                        }
                        return m - 1;
                    }),
                _onNext: ()=>setSelectedMonth((m)=>{
                        if (m === 12) {
                            setSelectedYear(selectedYear + 1);
                            return 1;
                        }
                        return m + 1;
                    })
            },
            children: props.children
        });
    };
const $451487d20aa3eb8a$var$Component$o = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1M;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onConfirm: onConfirm = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onConfirm: onConfirm,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMobile", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$92b06b9488028257 = $451487d20aa3eb8a$var$withLogic$m($451487d20aa3eb8a$var$Component$o);
$451487d20aa3eb8a$export$92b06b9488028257.displayName = "DatepickerMobile";
$451487d20aa3eb8a$export$92b06b9488028257.slotName = "jds_datepicker_mobile";
const $451487d20aa3eb8a$var$withLogic$l = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$n = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1G;
    const { state: state = "default", open: open = false, onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onConfirm: onConfirm = (0, $ddff9b86434e3f59$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Tap to Return", closeAriaLabel: closeAriaLabel = "Tap to Close", confirmAriaLabel: confirmAriaLabel = "Tap to Confirm", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            open: open,
            onClose: onClose,
            onConfirm: onConfirm,
            previousButtonAriaLabel: previousButtonAriaLabel,
            closeAriaLabel: closeAriaLabel,
            confirmAriaLabel: confirmAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDatepickerMobileInternal", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$8d28dfe32d652778 = $451487d20aa3eb8a$var$withLogic$l($451487d20aa3eb8a$var$Component$n);
$451487d20aa3eb8a$export$8d28dfe32d652778.displayName = "DatepickerMobileInternal";
$451487d20aa3eb8a$export$8d28dfe32d652778.slotName = "jds_datepicker_mobile_internal";
const $451487d20aa3eb8a$var$sdl$l = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-1.0.0",
        "name": "JDSDropdown",
        "layerName": "jds_dropdown",
        "description": "Dropdowns allow users to choose from a list of options presented contextually as a list. A dropdown in this document is a combination of a trigger and an options popup.",
        "usage": "Dropdowns are used when you want users to take an action or provide input."
    },
    "hierarchy": {
        "container": [
            "label-border-jds-text",
            {
                "field-container": [
                    "label-jds-text",
                    {
                        "select-container": [
                            {
                                "text-container": [
                                    {
                                        "prefix-icon-container": [
                                            "prefix-icon"
                                        ]
                                    },
                                    "current-jds-text",
                                    "placeholder-jds-text"
                                ]
                            },
                            {
                                "chevron-jds-icon-container": [
                                    "chevron-jds-icon"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text",
            "jds_menu_block"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{d_0}",
            "gap": "{d_1}",
            "width": "{d_2}",
            "justify-content": "{d_3}",
            "align-items": "{d_4}",
            "behavior": {
                "hover": {}
            },
            "opacity": "{d_37}"
        },
        "field-container": {
            "flex-direction": "{d_5}",
            "width": "{d_6}",
            "align-items": "{d_7}",
            "justify-content": "{d_8}",
            "padding-bottom": "{d_9}"
        },
        "text-container": {
            "flex-direction": "{d_10}",
            "overflow": "hidden",
            "flex": 1,
            "hidden": false,
            "gap": "{d_11}"
        },
        "select-container": {
            "flex-direction": "{d_12}",
            "justify-content": "{d_13}",
            "width": "{d_14}",
            "padding-top": 20,
            "align-items": "{d_15}",
            "z-index": 0
        },
        "active-line-container": {
            "flex-direction": "{d_16}",
            "width": "{d_17}",
            "align-items": "{d_18}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "feedback-container": {
            "width": "{d_19}",
            "height": 2,
            "background-color": "{d_20}",
            "border-radius": 48,
            "show": true,
            "hidden": false,
            "behavior": {
                "hover": {
                    "background-color": "{d_21}"
                },
                "focus": {
                    "background-color": "{d_22}"
                },
                "active": {
                    "background-color": "{d_23}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "jds_menu_block": {
            "open": false
        },
        "prefix-icon-container": {
            "hidden": true
        },
        "prefix-icon": {
            "size": "{d_34}",
            "color": "{d_35}"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1,
            "z-index": 1
        },
        "label-border-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        },
        "current-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "hidden": true,
            "maxLines": 1
        },
        "placeholder-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "chevron-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}",
            "value": "ic_chevron_down",
            "ic": "ic_chevron_down"
        },
        "chevron-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}",
            "ic": "ic_chevron_down"
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "border": {
            "true": {
                "feedback-container": {
                    "hidden": true
                },
                "field-container": {
                    "label-jds_text": {
                        "hidden": true
                    }
                },
                "select-container": {
                    "height": "{d_51}",
                    "border-width": "{d_24}",
                    "border-color": "{d_25}",
                    "border-radius": "{d_26}",
                    "background-color": "{d_50}",
                    "padding-top": "{d_27}",
                    "padding-bottom": "{d_28}",
                    "padding-left": "{d_29}",
                    "padding-right": "{d_30}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_31}"
                        },
                        "focus": {
                            "background-color": "{d_32}"
                        },
                        "active": {
                            "background-color": "{d_33}"
                        }
                    }
                },
                "label-jds-text": {
                    "hidden": true
                },
                "label-border-jds-text": {
                    "hidden": false
                }
            }
        },
        "open": {
            "true": {
                "jds_menu_block": {
                    "open": true
                },
                "chevron-jds-icon": {
                    "value": "ic_chevron_up",
                    "ic": "ic_chevron_up"
                },
                "chevron-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}",
                    "ic": "ic_chevron_up"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_36}"
                },
                "select-container": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{d_38}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_39}"
                        },
                        "focus": {
                            "background-color": "{d_40}"
                        },
                        "active": {
                            "background-color": "{d_41}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_38}"
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{d_42}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_43}"
                        },
                        "focus": {
                            "background-color": "{d_44}"
                        },
                        "active": {
                            "background-color": "{d_45}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_42}"
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{d_46}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_47}"
                        },
                        "focus": {
                            "background-color": "{d_48}"
                        },
                        "active": {
                            "background-color": "{d_49}"
                        }
                    }
                },
                "select-container": {
                    "border-color": "{d_46}"
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "_isLabelEmpty": {
            "true": {
                "label-jds-text": {
                    "hidden": true
                }
            }
        },
        "_isPlaceHolderEmpty": {
            "true": {
                "placeholder-jds-text": {
                    "hidden": true
                }
            }
        },
        "_isValueEmpty": {
            "false": {
                "current-jds-text": {
                    "hidden": false
                },
                "placeholder-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "field-container": {
                        "align-items": "{d_52}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{d_53}"
                    },
                    "label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                }
            },
            "false": {
                "true": {
                    "field-container": {
                        "align-items": "{d_54}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "label-jds-text": {
                        "padding-left": "{d_55}"
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{d_56}"
                    },
                    "label-jds-text": {
                        "padding-left": 0
                    }
                }
            }
        },
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{d_58}"
                    }
                }
            }
        },
        {
            "false": {
                "true": {
                    "select-container": {
                        "padding-left": "{d_57}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_labelFocus",
            "_hasPrefix"
        ],
        [
            "state",
            "_inputFocus"
        ],
        [
            "_hasPrefix",
            "border"
        ]
    ],
    "api": {
        "config": {
            "open": {
                "values": [
                    false,
                    true
                ]
            },
            "border": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasPrefix": {
                "values": [
                    false,
                    true
                ]
            },
            "_isLabelEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isPlaceHolderEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isValueEmpty": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                }
            },
            "prefix-icon": {
                "value": {
                    "type": "icon",
                    "name": "prefix"
                }
            },
            "jds_menu_block": {
                "items": {
                    "type": "list",
                    "name": "items",
                    "doc_description": "This should pass down values to MenuBlock\u2019s items prop. selected determines the default selected value currently.",
                    "object": {
                        "type": "JDSMenuBlockItem.type",
                        "label": "string",
                        "value": "string",
                        "prefix": "icon",
                        "suffix": "icon",
                        "disabled": "boolean"
                    }
                },
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex"
                },
                "offsetX": {
                    "type": "size",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "size",
                    "name": "_offsetY"
                },
                "minWidth": {
                    "type": "size",
                    "name": "_minWidth"
                },
                "maxWidth": {
                    "type": "size",
                    "name": "_maxWidth"
                },
                "maxHeight": {
                    "type": "size",
                    "name": "_maxHeight"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "label-border-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "current-jds-text": {
                "value": {
                    "type": "string",
                    "name": "current"
                }
            },
            "placeholder-jds-text": {
                "value": {
                    "type": "string",
                    "name": "placeholder"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "active-line-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "select-container": {
                "onClick": "onOpen"
            },
            "jds_menu_block": {
                "onSelect": "onSelect",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "select-container": {
                "properties": {
                    "role": {
                        "value": "combobox"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "open"
                    },
                    "aria-controls": {
                        "name": "ariaControls",
                        "value": "container"
                    }
                }
            },
            "jds_menu_block": {
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$4 = (props)=>{
    return {
        state: {
            properties: {
                state: props.state
            },
            variations: {
                error: {
                    stateText: props.stateConfig?.errorText || props.stateText
                },
                success: {
                    stateText: props.stateConfig?.successText || props.stateText
                },
                warning: {
                    stateText: props.stateConfig?.warningText || props.stateText
                },
                required: {
                    stateText: props.stateConfig?.requiredText
                }
            }
        },
        items: {
            properties: {
                items: props.items || []
            }
        }
    };
};
const $451487d20aa3eb8a$var$SELECT_CONTAINER_SELECTOR = 'div[data-testid="JDSDropdown-select-container"]';
const $451487d20aa3eb8a$var$OFFSET = 12;
const $451487d20aa3eb8a$var$withLogic$k = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$4);
        const [distance, setDistance] = (0, $1OEoy.useState)({
            x: 0,
            y: 0,
            width: 0,
            height: 0
        });
        const [isPositionReady, setIsPositionReady] = (0, $1OEoy.useState)(false);
        const { selectedIndex: selectedIndex, items: items = [], onSelect: onSelect } = props;
        const { index: index, onClick: onClick } = $451487d20aa3eb8a$var$useSelected(selectedIndex);
        const { selected: selected, toggle: toggle, close: close } = $451487d20aa3eb8a$var$useToggle(false);
        const { element: element, rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef();
        const selectContainer = element?.querySelector($451487d20aa3eb8a$var$SELECT_CONTAINER_SELECTOR);
        const calculatePositions = ()=>{
            if (selectContainer) {
                const { height: height, left: x, top: y, width: width = 0 } = $451487d20aa3eb8a$var$setPositions(selectContainer, void 0);
                setDistance({
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
                setIsPositionReady(true);
            }
        };
        const handleOpen = ()=>{
            calculatePositions();
            toggle(true);
        };
        (0, $1OEoy.useEffect)(()=>{
            if (!selected) {
                setIsPositionReady(false);
                selectContainer?.focus?.();
            }
        }, [
            selected
        ]);
        const hasPrefix = Boolean(props.prefix);
        const currentIdx = props.value ? items.findIndex((item)=>item.value === props.value) : index;
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                label: $451487d20aa3eb8a$var$getRequiredLabel(props.label, props.required),
                current: items[currentIdx]?.label,
                open: selected && isPositionReady,
                onSelect: (index2)=>{
                    onClick(index2);
                    onSelect?.(index2, items[index2]?.value || items[index2]?.label);
                },
                rootRef: rootRef,
                _hasPrefix: hasPrefix,
                _inputFocus: currentIdx >= 0,
                selectedIndex: currentIdx,
                onClose: ()=>{
                    close();
                    props.onClose?.();
                },
                onOpen: ()=>{
                    handleOpen();
                    props.onOpen?.();
                },
                _labelFocus: Boolean(currentIdx >= 0 || props.placeholder),
                _offsetX: distance.x,
                _offsetY: distance.y + $451487d20aa3eb8a$var$OFFSET,
                _maxWidth: distance.width,
                _maxHeight: distance.height,
                _isValueEmpty: !items[currentIdx]?.label,
                _isPlaceHolderEmpty: !props.placeholder
            }
        });
    };
const $451487d20aa3eb8a$var$Component$m = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$l;
    const { open: open = false, border: border = false, disabled: disabled = false, state: state = "undefined", onOpen: onOpen = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), ariaControls: ariaControls = "container", _ariaExpanded: _ariaExpanded = props.open?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            open: open,
            border: border,
            disabled: disabled,
            state: state,
            onOpen: onOpen,
            onSelect: onSelect,
            onClose: onClose,
            ariaLabel: ariaLabel,
            ariaControls: ariaControls,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdown", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$4ca664383a1d455a = $451487d20aa3eb8a$var$withLogic$k($451487d20aa3eb8a$var$Component$m);
$451487d20aa3eb8a$export$4ca664383a1d455a.displayName = "InputDropdown";
$451487d20aa3eb8a$export$4ca664383a1d455a.slotName = "jds_dropdown";
const $451487d20aa3eb8a$var$sdl$k = {
    "metadata": {
        "version": "1.0.0",
        "id": "dropdown-menu-item-1.0.0",
        "name": "JDSDropdownMenuItemMobile",
        "platform": "android",
        "layerName": "jds_dropdown_menu_item_mobile",
        "internal": true
    },
    "hierarchy": {
        "root-container": [
            {
                "container": [
                    {
                        "prefix-container": [
                            "prefix-slot"
                        ]
                    },
                    {
                        "content-container": [
                            "label-jds-text",
                            "description-jds-text"
                        ]
                    },
                    {
                        "suffix-container": [
                            "suffix-jds-text",
                            "icon"
                        ]
                    }
                ]
            },
            {
                "jds_dropdown_menu_submenu": [
                    "menu-group-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "hidden": false,
            "width": "{d_24}"
        },
        "container": {
            "hidden": false,
            "flex-direction": "{d_1}",
            "align-items": "{d_16}",
            "gap": "{d_3}",
            "background-color": "{d_4}",
            "width": "{d_0}",
            "padding-top": "{d_8}",
            "padding-right": "{d_9}",
            "padding-bottom": "{d_10}",
            "padding-left": "{d_11}",
            "opacity": "",
            "behavior": {
                "hover": {
                    "background-color": "{d_5}"
                },
                "active": {
                    "background-color": "{d_6}"
                },
                "focus": {
                    "border-radius": "{d_23}"
                }
            }
        },
        "menu-group-slot": {
            "hidden": false
        },
        "suffix-container": {
            "hidden": false
        },
        "prefix-container": {
            "hidden": false,
            "align-self": "{d_17}"
        },
        "prefix-slot": {
            "hidden": false
        },
        "content-container": {
            "hidden": false,
            "flex": 1,
            "overflow": "hidden",
            "justify-content": "{d_14}",
            "align-items": "{d_15}",
            "flex-direction": "{d_2}"
        },
        "icon": {
            "size": "{d_19}",
            "color": "{d_18}",
            "value": "ic_chevron_right",
            "behavior": {
                "active": {
                    "color": "{d_20}"
                }
            },
            "hidden": true
        },
        "jds_dropdown_menu_submenu": {
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "description-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "suffix-jds-text": {
            "font-family": "{bodyXxs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXxs}",
            "line-height": "{bodyXxs}",
            "letter-spacing": "{bodyXxs}",
            "font-weight": "{bodyXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "behavior": {
                "active": {
                    "color": "{primaryInverse}"
                }
            }
        }
    },
    "variant": {
        "_labelTextWrap": {
            "false": {
                "label-jds-text": {
                    "max-lines": 1,
                    "maxLines": 1
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{d_22}"
                }
            }
        },
        "selected": {
            "true": {
                "container": {
                    "background-color": "{d_12}",
                    "behavior": {
                        "hover": {
                            "background-color": "{d_13}"
                        }
                    }
                },
                "icon": {
                    "color": "{d_21}"
                },
                "label-jds-text": {
                    "color": "{primaryInverse}"
                },
                "description-jds-text": {
                    "color": "{primaryInverse}"
                },
                "suffix-jds-text": {
                    "color": "{primaryInverse}"
                }
            }
        },
        "_hasSubMenu": {
            "true": {
                "icon": {
                    "hidden": false
                },
                "suffix-jds-text": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_image",
                    "jds_avatar",
                    "jds_icon"
                ],
                "max": 1
            },
            "menu-group-slot": {
                "name": "children",
                "accepts": [
                    "jds_dropdown_menu_group"
                ]
            }
        },
        "events": {
            "container": {
                "onClick": "onClick"
            }
        },
        "data": {
            "jds_dropdown_menu_submenu": {
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "description-jds-text": {
                "value": {
                    "type": "string",
                    "name": "description"
                }
            },
            "suffix-jds-text": {
                "value": {
                    "type": "string",
                    "name": "suffix"
                }
            }
        },
        "config": {
            "selected": {
                "values": [
                    false,
                    true
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSubMenu": {
                "values": [
                    false,
                    true
                ]
            },
            "_labelTextWrap": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "menuitem"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-haspopup": {
                        "name": "_ariaHaspopup",
                        "prop": "_hasSubMenu"
                    },
                    "aria-expanded": {
                        "name": "_ariaExpanded",
                        "prop": "selected"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$j = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$l = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$k;
    const { selected: selected = false, disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaHaspopup: _ariaHaspopup = props._hasSubMenu?.toString(), _ariaExpanded: _ariaExpanded = props.selected?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            selected: selected,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaHaspopup: _ariaHaspopup,
            _ariaExpanded: _ariaExpanded,
            ...rest
        },
        componentTag: componentTag
    }, "JDSDropdownMenuItemMobile", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$7d15013c6b8c3bad = $451487d20aa3eb8a$var$withLogic$j($451487d20aa3eb8a$var$Component$l);
$451487d20aa3eb8a$export$7d15013c6b8c3bad.displayName = "DropdownMenuItemMobile";
$451487d20aa3eb8a$export$7d15013c6b8c3bad.slotName = "jds_dropdown_menu_item_mobile";
const $451487d20aa3eb8a$var$sdl$j = {
    "metadata": {
        "version": "1.0.0",
        "id": "file-uploader-1.0.0",
        "name": "JDSFileUploader",
        "layerName": "jds_file_uploader"
    },
    "hierarchy": {
        "container": [
            "jds_file_uploader_control",
            "jds_file_uploader_panel"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "justify-content": "{f_1}",
            "align-items": "{f_2}",
            "width": "{f_3}",
            "gap": "{f_4}",
            "opacity": "{f_5}"
        }
    },
    "variant": {
        "kind": {
            "collapsible": {
                "jds_file_uploader_panel": {
                    "kind": "collapsible"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "kind": {
                "type": "JDSFileUploaderPanel.kind",
                "values": [
                    "classic",
                    "collapsible"
                ]
            },
            "expanded": {
                "values": [
                    false,
                    true
                ]
            },
            "showDivider": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "jds_file_uploader_control": {
                "label": {
                    "type": "string",
                    "name": "label"
                },
                "helperText": {
                    "type": "string",
                    "name": "helperText"
                },
                "uploadButtonLabel": {
                    "type": "string",
                    "name": "uploadButtonLabel"
                }
            },
            "jds_file_uploader_panel": {
                "message": {
                    "type": "string",
                    "name": "message"
                },
                "value": {
                    "type": "float",
                    "name": "value"
                },
                "showDivider": {
                    "type": "boolean",
                    "name": "showDivider"
                },
                "expanded": {
                    "type": "boolean",
                    "name": "expanded"
                },
                "items": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "state": "JDSFileUploaderItem.state",
                        "message": "string"
                    }
                }
            }
        },
        "events": {
            "jds_file_uploader_control": {
                "onInfoClick": "onInfoClick",
                "onClick": "onClick"
            },
            "jds_file_uploader_panel": {
                "onClick": "onExpand",
                "onClose": "onClose"
            }
        },
        "a11y": {
            "jds_file_uploader_control": {
                "properties": {
                    "uploadButtonAriaLabel": "uploadButtonAriaLabel"
                }
            },
            "jds_file_uploader_panel": {
                "properties": {
                    "panelAriaLabel": "panelAriaLabel",
                    "panelAriaDescribedBy": {
                        "name": "panelAriaDescribedBy",
                        "platform": "web,ios"
                    },
                    "panelSuffixAriaLabel": "panelSuffixAriaLabel"
                },
                "name": "items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaDescribedby": {
                        "name": "itemAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$i = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$k = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$j;
    const { kind: kind = "undefined", expanded: expanded = false, showDivider: showDivider = true, onInfoClick: onInfoClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onExpand: onExpand = (0, $ddff9b86434e3f59$export$8793edee2d425525), onClose: onClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            expanded: expanded,
            showDivider: showDivider,
            onInfoClick: onInfoClick,
            onClick: onClick,
            onExpand: onExpand,
            onClose: onClose,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFileUploader", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$1a5cb5295a7d2749 = $451487d20aa3eb8a$var$withLogic$i($451487d20aa3eb8a$var$Component$k);
$451487d20aa3eb8a$export$1a5cb5295a7d2749.displayName = "FileUploader";
$451487d20aa3eb8a$export$1a5cb5295a7d2749.slotName = "jds_file_uploader";
const $451487d20aa3eb8a$var$sdl$i = {
    "metadata": {
        "version": "1.0.0",
        "id": "footer-1.0.0",
        "name": "JDSFooter",
        "layerName": "jds_footer",
        "platform": "web"
    },
    "hierarchy": {
        "container": [
            {
                "main-container": [
                    {
                        "content-container": [
                            "content-slot"
                        ]
                    },
                    {
                        "social-links-container": [
                            "jds_footer_icon_links",
                            "jds_footer_market_links"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "jds_divider",
                    "jds_bottom_footer"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{f_0}",
            "align-items": "{f_1}",
            "size": "{f_2}",
            "background-color": "{f_3}"
        },
        "main-container": {
            "flex-direction": "{f_4}",
            "justify-content": "{f_5}",
            "align-items": "{f_6}",
            "gap": "{f_7}",
            "size": "{f_8}",
            "padding-top": "{f_9}",
            "padding-bottom": "{f_10}",
            "padding-left": "{f_11}",
            "padding-right": "{f_12}"
        },
        "social-links-container": {
            "padding-top": "{f_13}",
            "flex-direction": "{f_14}",
            "gap": "{f_15}",
            "width": "{f_28}"
        },
        "bottom-container": {
            "flex-direction": "{f_16}",
            "align-items": "{f_17}",
            "width": "{f_18}",
            "gap": 0
        },
        "jds_divider": {
            "pad": "none"
        },
        "jds_bottom_footer": {
            "_platform": "desktop"
        },
        "content-container": {
            "width": "{f_19}"
        },
        "content-slot": {
            "width": "{f_20}"
        }
    },
    "variant": {
        "_platform": {
            "mobile": {
                "bottom-container": {
                    "gap": "{f_21}"
                },
                "jds_bottom_footer": {
                    "_platform": "mobile"
                },
                "main-container": {
                    "flex-direction": "{f_22}",
                    "justify-content": "{f_23}",
                    "padding-top": "{f_24}",
                    "padding-bottom": "{f_25}",
                    "padding-left": "{f_26}",
                    "padding-right": "{f_27}"
                }
            }
        },
        "_hasMainContainerProps": {
            "false": {
                "main-container": {
                    "hidden": true
                }
            }
        },
        "_hasContentSlot": {
            "false": {
                "content-container": {
                    "hidden": true
                }
            }
        },
        "_hasSocialLinksContainer": {
            "false": {
                "social-links-container": {
                    "hidden": true
                }
            }
        },
        "_hasFooterIconLinks": {
            "false": {
                "jds_footer_icon_links": {
                    "hidden": true
                }
            }
        }
    },
    "api": {
        "config": {
            "_platform": {
                "values": [
                    "desktop",
                    "mobile"
                ]
            },
            "_hasMainContainerProps": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasContentSlot": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasSocialLinksContainer": {
                "values": [
                    true,
                    false
                ]
            },
            "_hasFooterIconLinks": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "children": {
            "content-slot": {
                "name": "children",
                "accepts": [
                    "any"
                ]
            }
        },
        "data": {
            "main_container": {
                "value": {
                    "name": "links",
                    "type": "object",
                    "object": {
                        "links": "list"
                    }
                }
            },
            "social-links-container": {
                "marketplace": {
                    "type": "object",
                    "name": "marketplace",
                    "object": {
                        "assets": "JDSFooterMarketLinks.assets",
                        "title": "string"
                    }
                },
                "social": {
                    "type": "object",
                    "name": "social",
                    "object": {
                        "links": "JDSFooterIconLinks.links",
                        "title": "string"
                    }
                }
            },
            "jds_footer_icon_links": {
                "links": {
                    "name": "social.links",
                    "type": "list"
                },
                "title": {
                    "name": "social.title",
                    "type": "string"
                }
            },
            "jds_footer_market_links": {
                "assets": {
                    "name": "marketplace.assets",
                    "type": "list"
                },
                "title": {
                    "name": "marketplace.title",
                    "type": "string"
                }
            },
            "jds_bottom_footer": {
                "copyright": {
                    "type": "JDSBottomFooter.copyright",
                    "name": "copyright"
                },
                "copyrightText": {
                    "type": "string",
                    "name": "copyrightText"
                },
                "informationalLinks": {
                    "type": "JDSBottomFooter.informationalLinks",
                    "name": "bottomLinks"
                },
                "logo": {
                    "type": "icon",
                    "name": "logo"
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "name": "role"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Footer"
                    }
                }
            },
            "jds_bottom_footer": {
                "properties": {
                    "copyRightAriaLabel": "copyRightAriaLabel",
                    "copyRightAriaDescribedby": {
                        "name": "copyRightAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$3 = (props)=>({
        marketplace: {
            properties: {
                title: props.marketplace?.title,
                assets: props.marketplace?.stores?.map((store)=>({
                        image: store.badgeAsset,
                        href: store.href
                    }))
            }
        },
        mainLinks: {
            properties: {
                links: props.mainLinks?.map((l)=>({
                        title: l.heading,
                        subLinks: l.links
                    }))
            }
        }
    });
const $451487d20aa3eb8a$var$FooterAccordion = (props)=>{
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$a766cd26d0d69044, {
        allowMultiple: true,
        children: props.links?.map((link)=>/* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$7cad6f17fd6e117b, {
                header: link.title,
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$553910ef0cc96026, {
                    links: link.subLinks
                })
            }, link.title))
    });
};
const $451487d20aa3eb8a$var$withLogic$h = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$3);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _platform: $451487d20aa3eb8a$var$Devices.isDesktop() ? "desktop" : "mobile",
                _hasMainContainerProps: Boolean(props.marketplace || props.links || props.social),
                copyright: props.copyright,
                _hasContentSlot: Boolean(props.links),
                _hasFooterIconLinks: Boolean(props.social),
                _hasSocialLinksContainer: Boolean(props.social || props.marketplace),
                children: $451487d20aa3eb8a$var$Devices.isDesktop() ? /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$e5275d44ac937bc0, {
                    links: props.links
                }) : /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$FooterAccordion, {
                    links: props.links
                })
            }
        });
    };
const $451487d20aa3eb8a$var$Component$j = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$i;
    const { ariaLabel: ariaLabel = "Footer", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSFooter", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$a06f1c675e846f6f = $451487d20aa3eb8a$var$withLogic$h($451487d20aa3eb8a$var$Component$j);
$451487d20aa3eb8a$export$a06f1c675e846f6f.displayName = "Footer";
$451487d20aa3eb8a$export$a06f1c675e846f6f.slotName = "jds_footer";
const $451487d20aa3eb8a$var$sdl$h = {
    "metadata": {
        "version": "1.0.0",
        "id": "header-mobile-1.0.0",
        "name": "JDSHeaderMobile",
        "layerName": "jds_header_mobile"
    },
    "hierarchy": {
        "container": [
            {
                "header-container": [
                    {
                        "left-container": [
                            "prefix-jds_button",
                            {
                                "prefix-container": [
                                    {
                                        "logo-container": [
                                            "logo-slot",
                                            "logo-jds-text"
                                        ]
                                    },
                                    "prefix-slot",
                                    "name-jds-text"
                                ]
                            }
                        ]
                    },
                    {
                        "right-container": [
                            "jds_search_box",
                            {
                                "suffix-container": [
                                    "search-jds_action_button",
                                    {
                                        "icon-links-container": [
                                            "icon-links-jds_button"
                                        ]
                                    },
                                    "avatar-slot"
                                ]
                            },
                            "suffix-jds_action_button",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            "jds_search_results",
            "tabs-slot"
        ]
    },
    "base": {
        "container": {
            "min-width": "{h_0}",
            "flex-direction": "{h_1}"
        },
        "header-container": {
            "min-width": "{h_2}",
            "width": "{h_3}",
            "background-color": "{h_4}",
            "flex-direction": "{h_5}",
            "justify-content": "{h_6}",
            "align-items": "{h_7}",
            "padding-left": "{h_43}",
            "padding-top": "{h_9}",
            "padding-right": "{h_44}",
            "padding-bottom": "{h_11}",
            "height": "{h_13}",
            "gap": "{h_45}"
        },
        "left-container": {
            "flex-direction": "{h_14}",
            "justify-content": "{h_15}",
            "align-items": "{h_16}"
        },
        "prefix-container": {
            "flex-direction": "{h_18}",
            "justify-content": "{h_19}",
            "align-items": "{h_20}",
            "gap": "{h_21}"
        },
        "prefix-jds_button": {
            "size": "medium"
        },
        "logo-container": {
            "hidden": false,
            "flex-direction": "{h_22}",
            "justify-content": "{h_23}",
            "align-items": "{h_24}",
            "gap": "{h_25}"
        },
        "jds_search_box": {
            "prefix": "ic_search",
            "kind": "header",
            "flex": 1
        },
        "right-container": {
            "flex-direction": "{h_31}",
            "justify-content": "{h_32}",
            "align-items": "{h_33}",
            "gap": "{h_47}"
        },
        "suffix-container": {
            "flex-direction": "{h_35}",
            "justify-content": "{h_36}",
            "align-items": "{h_37}",
            "gap": "{h_48}"
        },
        "suffix-jds_action_button": {
            "hidden": true,
            "icon": "ic_close",
            "size": "medium"
        },
        "icon-links-container": {
            "flex-direction": "{h_39}",
            "justify-content": "{h_40}",
            "align-items": "{h_41}",
            "gap": "{h_42}",
            "hidden": false
        },
        "icon-links-jds_button": {
            "size": "medium"
        },
        "search-jds_action_button": {
            "hidden": true,
            "icon": "ic_search",
            "size": "medium"
        },
        "jds_search_results": {
            "open": false,
            "_maxWidth": 784
        },
        "logo-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryInverse}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "name-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryInverse}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        }
    },
    "variant": {
        "_variant": {
            "active_search": {
                "prefix-slot": {
                    "hidden": true
                },
                "avatar-slot": {
                    "hidden": true
                },
                "suffix-jds_action_button": {
                    "hidden": false
                },
                "jds_search_box": {
                    "prefix": "ic_search",
                    "flex": 1
                },
                "left-container": {
                    "hidden": true
                },
                "icon-links-container": {
                    "hidden": true
                },
                "suffix-slot": {
                    "hidden": true
                },
                "jds_search_results": {
                    "open": true
                },
                "prefix-jds_button": {
                    "hidden": true
                },
                "name-jds-text": {
                    "hidden": true
                },
                "logo-jds-text": {
                    "hidden": true
                }
            }
        },
        "search": {
            "false": {
                "left-container": {
                    "flex": 1
                },
                "jds_search_box": {
                    "hidden": true
                },
                "search-jds_action_button": {
                    "hidden": true
                }
            }
        },
        "_IsLinksEmpty": {
            "true": {
                "icon-links-container": {
                    "hidden": true
                }
            }
        },
        "_isBrandMissing": {
            "true": {
                "logo-container": {
                    "hidden": true
                }
            }
        },
        "_isPrefixButtonMissing": {
            "true": {
                "header-container": {
                    "padding-left": "{h_50}"
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "false": {
                    "left-container": {
                        "flex": 1
                    },
                    "jds_search_box": {
                        "hidden": true
                    },
                    "search-jds_action_button": {
                        "hidden": false
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "search",
            "expandedSearch"
        ]
    ],
    "api": {
        "config": {
            "_variant": {
                "values": [
                    "default",
                    "active_search"
                ]
            },
            "search": {
                "values": [
                    true,
                    false
                ]
            },
            "expandedSearch": {
                "values": [
                    true,
                    false
                ]
            },
            "searchActive": {
                "values": [
                    false,
                    true
                ]
            },
            "_IsLinksEmpty": {
                "values": [
                    false,
                    true
                ]
            },
            "_isBrandMissing": {
                "values": [
                    false,
                    true
                ]
            },
            "_isPrefixButtonMissing": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "prefix-jds_button": {
                "icon": {
                    "name": "prefix",
                    "type": "icon"
                }
            },
            "icon-links-container": {
                "value": {
                    "type": "list",
                    "name": "icons",
                    "object": {
                        "icon": "icon",
                        "onClick": "event"
                    }
                }
            },
            "icon-links-jds_button": {
                "icon": {
                    "name": "icons.icon",
                    "type": "icon"
                }
            },
            "jds_search_box": {
                "label": {
                    "type": "string",
                    "name": "searchLabel"
                },
                "suffix": {
                    "type": "icon",
                    "name": "searchSuffix",
                    "function": true
                },
                "value": {
                    "type": "string",
                    "name": "query"
                },
                "showBack": {
                    "type": "boolean",
                    "name": "searchShowBack"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                }
            },
            "jds_search_results": {
                "offsetX": {
                    "type": "number",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "number",
                    "name": "_offsetY"
                },
                "results": {
                    "type": "list",
                    "name": "searchResults",
                    "object": {
                        "icon": "icon",
                        "label": "string"
                    }
                },
                "header": {
                    "type": "string",
                    "name": "searchResultHeader"
                },
                "query": {
                    "type": "string",
                    "name": "query"
                },
                "headerAction": {
                    "type": "string",
                    "name": "searchResultHeaderAction"
                }
            },
            "logo-jds-text": {
                "value": {
                    "type": "string",
                    "name": "brandLabel"
                }
            },
            "name-jds-text": {
                "value": {
                    "type": "string",
                    "name": "pageTitle"
                }
            }
        },
        "children": {
            "avatar-slot": {
                "name": "avatar",
                "accepts": [
                    "jds_avatar",
                    "jds_link"
                ],
                "max": 1
            },
            "prefix-slot": {
                "name": "pageTitlePrefix",
                "accepts": [
                    "jds_avatar",
                    "jds_icon",
                    "jds_image"
                ],
                "max": 1
            },
            "tabs-slot": {
                "name": "tabs",
                "accepts": [
                    "jds_tab"
                ],
                "max": 1
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_text",
                    "jds_button",
                    "jds_link"
                ],
                "max": 1
            },
            "logo-slot": {
                "name": "logo",
                "accepts": [
                    "jds_icon",
                    "jds_image",
                    "jds_link"
                ],
                "max": 1
            }
        },
        "events": {
            "container": {
                "_searchActive.onSearchActiveChange": "onSearchActiveChange"
            },
            "header-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "logo-container": {
                "onClick": "logoOnClick"
            },
            "avatar-slot": {
                "onClick": "avatarOnClick"
            },
            "prefix-jds_button": {
                "onClick": "prefixOnClick"
            },
            "suffix-jds_action_button": {
                "onClick": "suffixOnClick"
            },
            "jds_search_box": {
                "onBlur": "onSearchBlur",
                "onFocus": "onSearchFocus",
                "onChange": "onSearchChange",
                "onSuffixClick": "onSearchBoxSuffixClick",
                "onBack": "onSearchBoxPrefixClick"
            },
            "search-jds_action_button": {
                "onClick": "onSearchIconClick"
            },
            "jds_search_results": {
                "onHeaderActionClick": "onSearchResultHeaderActionClick",
                "onClick": "onSearchResultClick"
            }
        },
        "a11y": {
            "icon-links-container": {
                "name": "icons",
                "repeating": {
                    "ariaLabel": "iconLinkAriaLabel",
                    "ariaDescribedby": {
                        "name": "iconLinkAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_results": {
                "name": "searchResults",
                "repeating": {
                    "ariaLabel": "searchResultAriaLabel",
                    "ariaDescribedby": {
                        "name": "searchResultAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "icon-links-jds_button": {
                "properties": {
                    "ariaLabel": "icons.iconLinkAriaLabel",
                    "ariaDescribedby": "icons.iconLinkAriaDescribedby"
                }
            },
            "prefix-jds_button": {
                "properties": {
                    "ariaLabel": "prefixAriaLabel",
                    "ariaDescribedby": {
                        "name": "prefixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "suffix-jds_action_button": {
                "properties": {
                    "ariaLabel": "suffixAriaLabel",
                    "ariaDescribedby": {
                        "name": "suffixAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_search_box": {
                "properties": {
                    "prefixAriaLabel": "searchBoxPrefixAriaLabel",
                    "suffixAriaLabel": "searchBoxSuffixAriaLabel",
                    "ariaLabel": "searchAriaLabel"
                }
            },
            "search-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "searchButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "searchButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$g = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$i = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$h;
    const { search: search = true, expandedSearch: expandedSearch = true, searchActive: searchActive = false, onSearchActiveChange: onSearchActiveChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), logoOnClick: logoOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), avatarOnClick: avatarOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), prefixOnClick: prefixOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), suffixOnClick: suffixOnClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchBlur: onSearchBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchFocus: onSearchFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchChange: onSearchChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchBoxSuffixClick: onSearchBoxSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchBoxPrefixClick: onSearchBoxPrefixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchIconClick: onSearchIconClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchResultHeaderActionClick: onSearchResultHeaderActionClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSearchResultClick: onSearchResultClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), searchButtonAriaLabel: searchButtonAriaLabel = props.dynamicButtonText?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            search: search,
            expandedSearch: expandedSearch,
            searchActive: searchActive,
            onSearchActiveChange: onSearchActiveChange,
            logoOnClick: logoOnClick,
            avatarOnClick: avatarOnClick,
            prefixOnClick: prefixOnClick,
            suffixOnClick: suffixOnClick,
            onSearchBlur: onSearchBlur,
            onSearchFocus: onSearchFocus,
            onSearchChange: onSearchChange,
            onSearchBoxSuffixClick: onSearchBoxSuffixClick,
            onSearchBoxPrefixClick: onSearchBoxPrefixClick,
            onSearchIconClick: onSearchIconClick,
            onSearchResultHeaderActionClick: onSearchResultHeaderActionClick,
            onSearchResultClick: onSearchResultClick,
            searchButtonAriaLabel: searchButtonAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSHeaderMobile", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$9f3d994e721c19d3 = $451487d20aa3eb8a$var$withLogic$g($451487d20aa3eb8a$var$Component$i);
$451487d20aa3eb8a$export$9f3d994e721c19d3.displayName = "HeaderMobile";
$451487d20aa3eb8a$export$9f3d994e721c19d3.slotName = "jds_header_mobile";
const $451487d20aa3eb8a$var$sdl$g = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-code-1.0.0",
        "name": "JDSInputCode",
        "layerName": "jds_input_code"
    },
    "hierarchy": {
        "container": [
            {
                "field-container": [
                    "jds_input_code_item"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "justify-content": "{i_1}",
            "align-items": "{i_2}",
            "width": "{i_3}",
            "gap": "{i_4}",
            "opacity": "{i_11}"
        },
        "field-container": {
            "flex-direction": "{i_5}",
            "justify-content": "{i_6}",
            "align-items": "{i_7}",
            "width": "{i_8}",
            "gap": "{i_9}"
        },
        "jds_input_code_item": {
            "flex": 1
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{i_10}"
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "autoComplete": {
            "true": {
                "jds_input_code_item": {
                    "autoComplete": "true"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "autoComplete": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable the autocomplete feature in the inputcode.",
                "platform": "web"
            },
            "autofocus": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to Focus on the Inputcode.",
                "platform": "web"
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            }
        },
        "data": {
            "container": {
                "_codes.value": {
                    "type": "string",
                    "name": "value"
                },
                "_codes.placeholder": {
                    "type": "string",
                    "name": "placeholder"
                }
            },
            "field-container": {
                "value": {
                    "type": "list",
                    "name": "_codes",
                    "object": {
                        "value": "string",
                        "placeholder": "string"
                    }
                },
                "length": {
                    "type": "number",
                    "name": "codeLength",
                    "doc_description": "It can be used to control length of Code."
                }
            },
            "jds_input_code_item": {
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'."
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled",
                    "doc_description": "It can be used to enable or disable Code."
                },
                "autofocus": {
                    "type": "boolean",
                    "name": "autofocus",
                    "doc_description": "It can be used to enable the autoFocus on InputCode.",
                    "platform": "web,ios"
                },
                "value": {
                    "type": "string",
                    "name": "codes.value"
                },
                "placeholder": {
                    "type": "string",
                    "name": "codes.placeholder"
                },
                "required": {
                    "type": "boolean",
                    "name": "required",
                    "doc_description": "It can be used to make input required."
                },
                "secureText": {
                    "type": "boolean",
                    "name": "secureText"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Code."
                }
            }
        },
        "events": {
            "jds_input_code_item": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onBackPress": {
                    "name": "onBackPress",
                    "platform": "android"
                },
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onPaste": "onPaste",
                "onInvalid": "onInvalid"
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "input"
                    },
                    "aria-label": {
                        "name": "ariaLabel"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_input_code_item": {
                "properties": {
                    "ariaLabel": {
                        "name": "codeAriaLabel",
                        "platform": "android"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$f = (Component)=>(props)=>{
        const { value: propValue, onChange: onChange, autofocus: autofocus, ...rest } = props;
        const [element, setElement] = (0, $1OEoy.useState)(null);
        const rootRef = (0, $1OEoy.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const { inputState: inputState, stateText: stateText, onInvalid: onInvalid } = $451487d20aa3eb8a$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig, props.stateText);
        const [value, setValue] = (0, $1OEoy.useState)(propValue?.split("") || []);
        (0, $1OEoy.useState)(propValue || "");
        const [updatedValue, setUpdatedValue] = (0, $1OEoy.useState)("");
        const inputs = Array.from(element?.getElementsByTagName("input") || []);
        const autofocusExecuted = (0, $1OEoy.useRef)(false);
        (0, $1OEoy.useEffect)(()=>{
            if (autofocus && !autofocusExecuted.current && inputs.length > 0) {
                autofocusExecuted.current = true;
                inputs[0]?.focus();
                inputs[0]?.select();
            }
        }, [
            autofocus,
            inputs
        ]);
        (0, $1OEoy.useEffect)(()=>{
            setValue(propValue?.split("") || []);
            setUpdatedValue(propValue || "");
        }, [
            propValue
        ]);
        const focusNext = (i)=>{
            if (i + 1 < inputs.length) {
                inputs[i + 1]?.focus();
                inputs[i + 1]?.select();
            }
        };
        const focusPrev = (i)=>{
            if (i > 0) {
                inputs[i - 1]?.focus();
                inputs[i - 1]?.select();
            } else {
                inputs[0]?.focus();
                inputs[0]?.select();
            }
        };
        const handleChange = (ev, i)=>{
            const inputValue = ev.target.value;
            const newValue = [
                ...value
            ];
            if (inputValue.length > 1) {
                Array.from({
                    length: inputValue.length
                }).forEach((_, idx)=>{
                    newValue[idx] = inputValue[idx];
                });
                const lastUpdatedIndex = i + inputValue.length - 1;
                inputs[lastUpdatedIndex]?.focus();
                inputs[lastUpdatedIndex]?.select();
            } else {
                newValue[i] = inputValue.slice(-1) || "";
                focusNext(i);
            }
            setValue(newValue);
            setUpdatedValue(newValue.join(""));
            if (props.onChange) {
                const event = {
                    ...ev,
                    target: {
                        ...ev.target,
                        value: newValue.join("")
                    }
                };
                props.onChange(event);
            }
        };
        const handleFocus = (ev, i)=>{
            const target = ev.target;
            const selectValue = ()=>{
                if (document.activeElement === target) {
                    target.select();
                    setTimeout(selectValue, 0);
                }
            };
            selectValue();
        };
        const handleKeyDown = (ev, i)=>{
            const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Tab"
            ];
            const isPasteShortcut = (ev.ctrlKey || ev.metaKey) && ev.key.toLowerCase() === "v";
            if (!/^\d$/.test(ev.key) && !allowedKeys.includes(ev.key) && !isPasteShortcut) {
                ev.preventDefault();
                return;
            }
            switch(ev.key){
                case "Backspace":
                case "Delete":
                    {
                        const newValue = [
                            ...value
                        ];
                        if (!ev.currentTarget.value && i > 0) {
                            newValue[i - 1] = "";
                            focusPrev(i);
                        } else newValue[i] = "";
                        setValue(newValue);
                        setUpdatedValue(newValue.join(""));
                        if (props.onChange) props.onChange({
                            ...ev,
                            target: {
                                ...ev.target,
                                value: newValue.join("")
                            }
                        });
                        ev.preventDefault();
                        break;
                    }
                case "ArrowLeft":
                    focusPrev(i);
                    ev.preventDefault();
                    break;
                case "ArrowRight":
                    focusNext(i);
                    ev.preventDefault();
                    break;
                case "Tab":
                    if (ev.shiftKey) focusPrev(i);
                    else focusNext(i);
                    ev.preventDefault();
                    break;
            }
        };
        const handlePaste = (ev, i)=>{
            ev.preventDefault();
            const clipboardValue = ev.clipboardData.getData("text").replace(/\D/g, "").split("").slice(0, props.codeLength);
            const newValue = [
                ...Array(props.codeLength).fill(""),
                ...value
            ].slice(0, props.codeLength);
            let lastIndex = i;
            clipboardValue.forEach((char, idx)=>{
                if (i + idx < newValue.length) {
                    newValue[i + idx] = char;
                    lastIndex = i + idx;
                }
            });
            setValue(newValue);
            setUpdatedValue(newValue.join(""));
            if (props.onChange) props.onChange({
                ...ev,
                target: {
                    ...ev.target,
                    value: newValue.join("")
                }
            });
            setTimeout(()=>{
                inputs[lastIndex]?.focus();
                inputs[lastIndex]?.select();
            }, 0);
        };
        const handleInput = (ev, i)=>{
            const inputValue = ev.target.value;
            if (inputValue.length > 1) {
                const autofillValues = inputValue.split("").slice(0, props.codeLength);
                const newValue = autofillValues.concat(value.slice(autofillValues.length));
                setValue(newValue);
                setUpdatedValue(newValue.join(""));
                const lastIndex = autofillValues.length - 1;
                inputs[lastIndex]?.focus();
                inputs[lastIndex]?.select();
                if (props.onChange) {
                    const event = {
                        ...ev,
                        target: {
                            ...ev.target,
                            value: newValue.join("")
                        }
                    };
                    props.onChange(event);
                }
            } else if (inputValue) {
                const newValue = [
                    ...value
                ];
                newValue[i] = inputValue.slice(-1);
                setValue(newValue);
                setUpdatedValue(newValue.join(""));
                const nextFocusIndex = Math.min(newValue.join("").length, props.codeLength - 1);
                inputs[nextFocusIndex]?.focus();
                inputs[nextFocusIndex]?.select();
                if (props.onChange) {
                    const event = {
                        ...ev,
                        target: {
                            ...ev.target,
                            value: newValue.join("")
                        }
                    };
                    props.onChange(event);
                }
            } else handleChange(ev, i);
        };
        const codes = Array.from({
            length: props.codeLength || 6
        }).map((_, i)=>({
                placeholder: props.placeholder?.[i] || (i + 1).toString(),
                value: value[i] || "",
                onChange: (ev)=>handleChange(ev, i),
                onFocus: (ev)=>handleFocus(ev),
                onKeyDown: (ev)=>handleKeyDown(ev, i),
                onPaste: (ev)=>handlePaste(ev, i),
                onInput: (ev)=>handleInput(ev, i)
            }));
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                rootRef: rootRef,
                state: inputState,
                stateText: stateText,
                onInvalid: onInvalid,
                _codes: codes,
                ariaLabel: props.ariaLabel || `Input code of length ${props.codeLength}`
            }
        });
    };
const $451487d20aa3eb8a$var$Component$h = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$g;
    const { disabled: disabled = false, autoComplete: autoComplete = false, autofocus: autofocus = false, state: state = "undefined", onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBackPress: onBackPress = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPaste: onPaste = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInvalid: onInvalid = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            autoComplete: autoComplete,
            autofocus: autofocus,
            state: state,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onBackPress: onBackPress,
            onSubmit: onSubmit,
            onPaste: onPaste,
            onInvalid: onInvalid,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputCode", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$6d59a84bf808ad3a = $451487d20aa3eb8a$var$withLogic$f($451487d20aa3eb8a$var$Component$h);
$451487d20aa3eb8a$export$6d59a84bf808ad3a.displayName = "InputCode";
$451487d20aa3eb8a$export$6d59a84bf808ad3a.slotName = "jds_input_code";
const $451487d20aa3eb8a$var$sdl$f = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-date-1.0.0",
        "name": "JDSInputDate",
        "layerName": "jds_input_date",
        "description": "",
        "usage": "Input date component is used to help users enter a memorable date or one they can easily look up for example a date of birth or an expiration date of the credit card."
    },
    "hierarchy": {
        "container": [
            {
                "outer-container": [
                    {
                        "field-container": [
                            "label-jds-text",
                            {
                                "input-container": [
                                    {
                                        "dd-container": [
                                            "dd-jds_input",
                                            {
                                                "dd-active-line-container": [
                                                    "dd-feedback-container"
                                                ]
                                            }
                                        ]
                                    },
                                    "left-slash-container",
                                    {
                                        "mm-container": [
                                            "mm-jds_input",
                                            {
                                                "mm-active-line-container": [
                                                    "mm-feedback-container"
                                                ]
                                            }
                                        ]
                                    },
                                    "right-slash-container",
                                    {
                                        "yy-container": [
                                            "yy-jds_input",
                                            {
                                                "yy-active-line-container": [
                                                    "yy-feedback-container"
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "calendar-container": [
                            "calendar-jds_action_button"
                        ]
                    }
                ]
            },
            {
                "bottom-container": [
                    "jds_feedback_block",
                    "helper-jds-text",
                    "jds_datepicker"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "align-items": "{i_1}",
            "gap": "{i_2}",
            "width": "{i_3}"
        },
        "outer-container": {
            "flex-direction": "{i_4}",
            "width": "{i_5}",
            "align-items": "{i_6}"
        },
        "field-container": {
            "flex": 1,
            "flex-direction": "{i_7}",
            "width": "{i_8}",
            "align-items": "{i_9}"
        },
        "input-container": {
            "width": "{i_10}",
            "gap": "{i_11}",
            "height": 36,
            "align-items": "{i_12}"
        },
        "dd-container": {
            "flex-direction": "{i_13}",
            "flex": 1,
            "gap": "{i_14}",
            "align-items": "{i_15}"
        },
        "dd-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_16}",
            "maxLength": 2,
            "placeholder": "dd"
        },
        "dd-active-line-container": {
            "width": "{i_17}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "dd-feedback-container": {
            "height": 2,
            "width": "{i_18}",
            "background-color": "{i_19}",
            "show": true
        },
        "left-slash-container": {
            "width": 1,
            "height": 35,
            "rotate": 10,
            "background-color": "{i_20}",
            "show": true
        },
        "mm-container": {
            "flex-direction": "{i_21}",
            "flex": 1,
            "gap": "{i_22}",
            "align-items": "{i_23}"
        },
        "mm-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_24}",
            "maxLength": 2,
            "placeholder": "mm"
        },
        "mm-active-line-container": {
            "width": "{i_25}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "mm-feedback-container": {
            "height": 2,
            "width": "{i_26}",
            "background-color": "{i_27}",
            "show": true
        },
        "right-slash-container": {
            "width": 1,
            "height": 35,
            "rotate": 10,
            "background-color": "{i_28}",
            "show": true
        },
        "yy-container": {
            "flex-direction": "{i_29}",
            "flex": 1,
            "gap": "{i_30}",
            "align-items": "{i_31}"
        },
        "yy-jds_input": {
            "disabled": false,
            "type": "number",
            "textAlign": "{i_32}",
            "maxLength": 4,
            "placeholder": "yyyy"
        },
        "yy-active-line-container": {
            "width": "{i_33}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "yy-feedback-container": {
            "height": 2,
            "width": "{i_34}",
            "background-color": "{i_35}",
            "show": true
        },
        "calendar-container": {
            "hidden": false,
            "justify-content": "{i_36}",
            "align-items": "{i_37}"
        },
        "calendar-jds_action_button": {
            "kind": "tertiary",
            "size": "medium",
            "icon": "ic_calendar"
        },
        "bottom-container": {
            "flex-direction": "{i_38}",
            "align-items": "{i_39}",
            "gap": "{i_40}",
            "width": "{i_41}"
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "maxLines": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "field-container": {
                    "opacity": "{i_42}",
                    "disabled": true
                },
                "bottom-container": {
                    "opacity": "{i_43}",
                    "disabled": true
                },
                "dd-jds_input": {
                    "disabled": true
                },
                "mm-jds_input": {
                    "disabled": true
                },
                "yy-jds_input": {
                    "disabled": true
                },
                "calendar-jds_action_button": {
                    "state": "disabled"
                }
            }
        },
        "error": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "dd-feedback-container": {
                    "background-color": "{i_44}"
                },
                "mm-feedback-container": {
                    "background-color": "{i_45}"
                },
                "yy-feedback-container": {
                    "background-color": "{i_46}"
                }
            }
        },
        "ddError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "dd-feedback-container": {
                    "background-color": "{i_47}"
                }
            }
        },
        "mmError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "mm-feedback-container": {
                    "background-color": "{i_48}"
                }
            }
        },
        "yyError": {
            "true": {
                "jds_feedback_block": {
                    "state": "error"
                },
                "yy-feedback-container": {
                    "background-color": "{i_49}"
                }
            }
        },
        "showCalendar": {
            "false": {
                "calendar-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Determines the disabled input field"
            },
            "error": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "The error state of the input"
            },
            "ddError": {
                "values": [
                    false,
                    true
                ]
            },
            "mmError": {
                "values": [
                    false,
                    true
                ]
            },
            "yyError": {
                "values": [
                    false,
                    true
                ]
            },
            "showCalendar": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "dd-jds_input": {
                "value": {
                    "type": "number",
                    "name": "ddValue"
                }
            },
            "mm-jds_input": {
                "value": {
                    "type": "number",
                    "name": "mmValue"
                }
            },
            "yy-jds_input": {
                "value": {
                    "type": "number",
                    "name": "yyValue"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "errorText",
                    "doc_description": "The error text to display"
                }
            },
            "jds_datepicker": {
                "open": {
                    "type": "boolean",
                    "name": "_datepickerOpen"
                },
                "offsetX": {
                    "type": "string",
                    "name": "_offsetX"
                },
                "offsetY": {
                    "type": "string",
                    "name": "_offsetY"
                },
                "triggerRef": {
                    "type": "ref",
                    "name": "triggerRef"
                },
                "min": {
                    "type": "date",
                    "name": "min",
                    "doc_description": "Defines the min date possible"
                },
                "max": {
                    "type": "date",
                    "name": "max",
                    "doc_description": "Defines the max date possible"
                },
                "value": {
                    "type": "date",
                    "name": "_calendarValue"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "Determines the label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "The helper text to display"
                }
            }
        },
        "events": {
            "calendar-jds_action_button": {
                "onClick": "onCalendarClick"
            },
            "dd-jds_input": {
                "onChange": "onDateChange",
                "onSubmit": "onDateSubmit",
                "onKeydown": {
                    "name": "onDateKeydown",
                    "platform": "web"
                },
                "onBlur": "onDateBlur"
            },
            "mm-jds_input": {
                "onChange": "onMonthChange",
                "onSubmit": "onMonthSubmit",
                "onKeydown": {
                    "name": "onMonthKeydown",
                    "platform": "web"
                },
                "onBlur": "onMonthBlur"
            },
            "yy-jds_input": {
                "onChange": "onYearChange",
                "onSubmit": "onYearSubmit",
                "onKeydown": {
                    "name": "onYearKeydown",
                    "platform": "web"
                },
                "onBlur": "onYearBlur"
            },
            "jds_datepicker": {
                "onClose": "onDatepickerClose",
                "onSelect": "onDatepickerSelect",
                "onConfirm": "onDatepickerSelect"
            }
        },
        "a11y": {
            "dd-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "dateAriaLabel",
                        "value": "Insert day"
                    }
                }
            },
            "mm-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "monthAriaLabel",
                        "value": "Insert month"
                    }
                }
            },
            "yy-jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "yearAriaLabel",
                        "value": "Insert year"
                    }
                }
            },
            "calendar-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "datepickerAriaLabel",
                        "value": "Launch datepicker"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$DATEPICKER_LAYER_ID = ".j-JDSInputDate-calendar-container";
const $451487d20aa3eb8a$var$getNormalisedDate = (value)=>{
    if (!value) return {
        day: void 0,
        month: void 0,
        year: void 0
    };
    const date = new Date(value);
    if (!date.getTime()) return {
        day: void 0,
        month: void 0,
        year: void 0
    };
    return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
};
const $451487d20aa3eb8a$var$validateYear = (value, min, max)=>{
    const { year: year = 0 } = value;
    const { year: minYear = 0 } = $451487d20aa3eb8a$var$getNormalisedDate(min);
    const { year: maxYear = 0 } = $451487d20aa3eb8a$var$getNormalisedDate(max);
    if (min && year) {
        if (year < minYear) return false;
    }
    if (max && year) {
        if (year > maxYear) return false;
    }
    return true;
};
const $451487d20aa3eb8a$var$validateMonth = (value, min, max)=>{
    if (!$451487d20aa3eb8a$var$validateYear(value, min, max)) return false;
    const { year: year, month: month } = value;
    if (!month || month < 1 || month > 12) return false;
    const { year: minYear, month: minMonth = 0 } = $451487d20aa3eb8a$var$getNormalisedDate(min);
    const { year: maxYear, month: maxMonth = 0 } = $451487d20aa3eb8a$var$getNormalisedDate(max);
    if (year === minYear && month < minMonth) return false;
    if (year === maxYear && month > maxMonth) return false;
    return true;
};
const $451487d20aa3eb8a$var$validateDate = (value, min, max)=>{
    const { day: day, month: month, year: year } = value;
    if (!day || !month || !year) return true;
    const currentDate = new Date(year, month - 1, day);
    const minDate = min ? new Date(min) : null;
    const maxDate = max ? new Date(max) : null;
    const isLeapYear = (year2)=>{
        return year2 % 4 === 0;
    };
    const monthsWith30Days = [
        4,
        6,
        9,
        11
    ];
    if (month < 1 || month > 12 || day < 1) return false;
    if (monthsWith30Days.includes(month) && day > 30) return false;
    if (month === 2) {
        if (isLeapYear(year) && day > 29) return false;
        if (!isLeapYear(year) && day > 28) return false;
    } else if (day > 31) return false;
    if (minDate && currentDate < minDate) return false;
    if (maxDate && currentDate > maxDate) return false;
    if (minDate && year === minDate.getFullYear()) {
        if (month < minDate.getMonth() + 1) return false;
        if (month === minDate.getMonth() + 1 && day < minDate.getDate()) return false;
    }
    if (maxDate && year === maxDate.getFullYear()) {
        if (month > maxDate.getMonth() + 1) return false;
        if (month === maxDate.getMonth() + 1 && day > maxDate.getDate()) return false;
    }
    return true;
};
const $451487d20aa3eb8a$var$nodeJump = (key, sourceNode, nextNode, prevNode, sourceNodeError)=>{
    switch(key){
        case "Backspace":
            if (!sourceNode?.value && !sourceNodeError) setTimeout(()=>prevNode?.select());
            break;
        case "ArrowLeft":
            if (document.getSelection()?.toString() === sourceNode?.value && !sourceNodeError) setTimeout(()=>prevNode?.select?.());
            break;
        case "ArrowRight":
            if (document.getSelection()?.toString() === sourceNode?.value && !sourceNodeError) setTimeout(()=>nextNode?.select?.());
            break;
    }
};
const $451487d20aa3eb8a$var$getDateFromObject = (obj)=>new Date(obj.year || 0, obj.month || 0, obj.day);
const $451487d20aa3eb8a$var$getDateStringFromObject = (obj)=>`${obj.year || ""}/${(obj.month || "").toString().padStart(2, "0")}/${(obj.day || "").toString().padStart(2, "0")}`;
const $451487d20aa3eb8a$var$getDisabledsDays = (date, step)=>{
    if (!step) return [];
    const { month: month = 0, year: year = 0 } = date;
    const daysInMonth = new Date(year, month, 0).getDate();
    const numbers = Array.from({
        length: daysInMonth
    }).map((_, i)=>i + 1);
    const filteredNumbers = numbers.filter((i)=>{
        return i % step === 0;
    });
    return filteredNumbers.map((i)=>new Date(year, month - 1, i));
};
const $451487d20aa3eb8a$var$withLogic$e = (Component)=>(props)=>{
        const { value: value, datePicker: datePicker, min: min, max: max, error: error, errorText: errorText, errorFieldsObject: errorFieldsObject, setValidity: setValidity, setCustomValidity: setCustomValidity, onChange: onChange, step: step, ...rest } = props;
        const { selected: selected, toggle: toggle, close: close } = $451487d20aa3eb8a$var$useToggle(false);
        const [date, setDate] = (0, $1OEoy.useState)($451487d20aa3eb8a$var$getNormalisedDate(value));
        const [element, setElement] = (0, $1OEoy.useState)(null);
        (0, $1OEoy.useEffect)(()=>{
            if (value === "") setDate({
                day: void 0,
                month: void 0,
                year: void 0
            });
            else setDate($451487d20aa3eb8a$var$getNormalisedDate(value));
        }, [
            value
        ]);
        const [focus, setFocus] = (0, $1OEoy.useState)({
            dd: false,
            mm: false,
            yy: false
        });
        const { day: day, month: month, year: year } = date;
        const rootRef = (0, $1OEoy.useCallback)((element2)=>{
            if (element2) setElement(element2);
        }, []);
        const datePickerLayer = element?.querySelector($451487d20aa3eb8a$var$DATEPICKER_LAYER_ID);
        const inputs = Array.from(element?.querySelectorAll("input") || []);
        const ddInput = inputs.find((input)=>input.placeholder === "dd");
        const mmInput = inputs.find((input)=>input.placeholder === "mm");
        const yyyInput = inputs.find((input)=>input.placeholder === "yyyy");
        const { dd: dd, mm: mm, yyyy: yyyy, errorLocalText: errorLocalText } = setCustomValidity?.(new Date(date.year || 0, date.month || 0, date.day)) || {};
        const userValidated = setValidity?.($451487d20aa3eb8a$var$getDateFromObject(date));
        const dayError = !focus.dd && (userValidated || dd || errorFieldsObject?.dd || error || date.day && !$451487d20aa3eb8a$var$validateDate(date, min, max) || rest.required && !date.day);
        const monthError = !focus.mm && (userValidated || mm || errorFieldsObject?.mm || error || date.month && !$451487d20aa3eb8a$var$validateMonth(date, min, max) || rest.required && !date.month);
        const yearError = !focus.yy && (userValidated || yyyy || errorFieldsObject?.yyyy || error || date.year && !$451487d20aa3eb8a$var$validateYear(date, min, max) || rest.required && !date.year);
        const getCurrentDate = ()=>{
            const now = /* @__PURE__ */ new Date();
            return {
                day: now.getDate(),
                month: now.getMonth() + 1,
                year: now.getFullYear()
            };
        };
        const isInvalidDate = (date2)=>{
            return !date2 || isNaN(date2.day ?? NaN) || date2.day === 0 || !$451487d20aa3eb8a$var$validateDate(date2) || !$451487d20aa3eb8a$var$validateMonth(date2) || isNaN(date2.month ?? NaN) || date2.month === 0 || isNaN(date2.year ?? NaN) || date2.year === 0;
        };
        const formatDate = (date2)=>{
            const mm2 = String(date2.month).padStart(2, "0");
            const dd2 = String(date2.day).padStart(2, "0");
            const yyyy2 = date2.year;
            return `${mm2}-${dd2}-${yyyy2}`;
        };
        const [calendarValue, setCalendarValue] = (0, $1OEoy.useState)(formatDate(getCurrentDate()));
        (0, $1OEoy.useEffect)(()=>{
            setCalendarValue(formatDate(isInvalidDate(date) ? getCurrentDate() : date));
        }, [
            date
        ]);
        console.log(date, "test 1");
        console.log(calendarValue, "test 2");
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                min: min,
                max: max,
                errorText: errorLocalText || errorText,
                _datepickerOpen: selected,
                dateAriaLabel: props.dateAriaLabel || "Input date",
                monthAriaLabel: props.monthAriaLabel || "Input month",
                yearAriaLabel: props.yearAriaLabel || "Input year",
                datepickerAriaLabel: props.datepickerAriaLabel || "Launch datepicker",
                onMonthKeydown: (ev)=>{
                    $451487d20aa3eb8a$var$nodeJump(ev.key, mmInput, yyyInput, ddInput, monthError);
                },
                onDateKeydown: (ev)=>{
                    $451487d20aa3eb8a$var$nodeJump(ev.key, ddInput, mmInput, void 0, dayError);
                },
                onYearKeydown: (ev)=>{
                    $451487d20aa3eb8a$var$nodeJump(ev.key, yyyInput, void 0, mmInput, yearError);
                },
                showCalendar: datePicker,
                onCalendarClick: toggle,
                onDatepickerClose: close,
                rootRef: rootRef,
                disabledDates: $451487d20aa3eb8a$var$getDisabledsDays(date, parseInt(step)),
                ddValue: focus.dd ? day : day?.toString().padStart(2, "0") || "",
                mmValue: focus.mm ? month : month?.toString().padStart(2, "0") || "",
                yyValue: focus.yy ? year : year?.toString().padStart(4, "0") || "",
                _calendarValue: calendarValue,
                onDatepickerSelect: (value2)=>{
                    const date2 = $451487d20aa3eb8a$var$getNormalisedDate(value2);
                    setDate(date2);
                    onChange?.($451487d20aa3eb8a$var$getDateStringFromObject(date2));
                },
                triggerRef: {
                    current: datePickerLayer
                },
                ddError: dayError,
                mmError: monthError,
                yyError: yearError,
                onDateChange: (ev)=>{
                    setFocus({
                        ...focus,
                        dd: true
                    });
                    const currentValue = {
                        ...date,
                        day: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($451487d20aa3eb8a$var$getDateStringFromObject(currentValue));
                    if (ev.target.value.length === 2 && !dayError) setTimeout(()=>mmInput?.select?.());
                },
                onMonthChange: (ev)=>{
                    setFocus({
                        ...focus,
                        mm: true
                    });
                    const currentValue = {
                        ...date,
                        month: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($451487d20aa3eb8a$var$getDateStringFromObject(currentValue));
                    if (ev.target.value.length === 2 && !monthError) setTimeout(()=>yyyInput?.select?.());
                },
                onYearChange: (ev)=>{
                    setFocus({
                        ...focus,
                        yy: true
                    });
                    const currentValue = {
                        ...date,
                        year: parseInt(ev.target.value)
                    };
                    setDate(currentValue);
                    onChange?.($451487d20aa3eb8a$var$getDateStringFromObject(currentValue));
                },
                onDateBlur: ()=>{
                    setFocus({
                        ...focus,
                        dd: false
                    });
                },
                onMonthBlur: ()=>{
                    setFocus({
                        ...focus,
                        mm: false
                    });
                },
                onYearBlur: ()=>{
                    setFocus({
                        ...focus,
                        yy: false
                    });
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$g = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$f;
    const { disabled: disabled = false, error: error = false, ddError: ddError = false, mmError: mmError = false, yyError: yyError = false, showCalendar: showCalendar = true, onCalendarClick: onCalendarClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDateChange: onDateChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDateSubmit: onDateSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDateKeydown: onDateKeydown = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDateBlur: onDateBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onMonthChange: onMonthChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onMonthSubmit: onMonthSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onMonthKeydown: onMonthKeydown = (0, $ddff9b86434e3f59$export$8793edee2d425525), onMonthBlur: onMonthBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onYearChange: onYearChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onYearSubmit: onYearSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onYearKeydown: onYearKeydown = (0, $ddff9b86434e3f59$export$8793edee2d425525), onYearBlur: onYearBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDatepickerClose: onDatepickerClose = (0, $ddff9b86434e3f59$export$8793edee2d425525), onDatepickerSelect: onDatepickerSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), dateAriaLabel: dateAriaLabel = "Insert day", monthAriaLabel: monthAriaLabel = "Insert month", yearAriaLabel: yearAriaLabel = "Insert year", datepickerAriaLabel: datepickerAriaLabel = "Launch datepicker", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            error: error,
            ddError: ddError,
            mmError: mmError,
            yyError: yyError,
            showCalendar: showCalendar,
            onCalendarClick: onCalendarClick,
            onDateChange: onDateChange,
            onDateSubmit: onDateSubmit,
            onDateKeydown: onDateKeydown,
            onDateBlur: onDateBlur,
            onMonthChange: onMonthChange,
            onMonthSubmit: onMonthSubmit,
            onMonthKeydown: onMonthKeydown,
            onMonthBlur: onMonthBlur,
            onYearChange: onYearChange,
            onYearSubmit: onYearSubmit,
            onYearKeydown: onYearKeydown,
            onYearBlur: onYearBlur,
            onDatepickerClose: onDatepickerClose,
            onDatepickerSelect: onDatepickerSelect,
            dateAriaLabel: dateAriaLabel,
            monthAriaLabel: monthAriaLabel,
            yearAriaLabel: yearAriaLabel,
            datepickerAriaLabel: datepickerAriaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputDate", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$7ac9d04ce3f22c96 = $451487d20aa3eb8a$var$withLogic$e($451487d20aa3eb8a$var$Component$g);
$451487d20aa3eb8a$export$7ac9d04ce3f22c96.displayName = "InputDate";
$451487d20aa3eb8a$export$7ac9d04ce3f22c96.slotName = "jds_input_date";
const $451487d20aa3eb8a$var$sdl$e = {
    "metadata": {
        "version": "1.0.0",
        "id": "input-field-1.0.0",
        "name": "JDSInputField",
        "layerName": "jds_input_field",
        "description": "A input field give context to the information that a user needs to input. They're commonly used in forms."
    },
    "hierarchy": {
        "container": [
            {
                "field-container": [
                    "input_label-jds-text",
                    {
                        "input-container": [
                            {
                                "prefix-container": [
                                    "prefix-slot"
                                ]
                            },
                            "jds_input",
                            "suffix-slot"
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_0}",
            "gap": "{i_1}",
            "width": "{i_2}",
            "justify-content": "{i_3}",
            "align-items": "{i_4}",
            "opacity": "{i_30}",
            "behavior": {
                "hover": {}
            }
        },
        "field-container": {
            "flex-direction": "{i_5}",
            "width": "{i_6}",
            "align-items": "{i_7}",
            "justify-content": "{i_8}",
            "padding-bottom": "{i_9}",
            "animate-stack-alignment": true
        },
        "input-container": {
            "flex-direction": "{i_10}",
            "justify-content": "{i_11}",
            "width": "{i_12}",
            "gap": "{i_13}",
            "padding-top": 20,
            "align-items": "{i_14}",
            "z-index": 0
        },
        "prefix-container": {
            "hidden": false
        },
        "jds_input": {
            "disabled": false,
            "type": "text",
            "textAlign": "{i_17}",
            "rows": 1,
            "flex": 1
        },
        "active-line-container": {
            "flex-direction": "{i_21}",
            "width": "{i_22}",
            "align-items": "{i_23}",
            "padding-bottom": 1,
            "padding-top": 1
        },
        "feedback-container": {
            "width": "{i_24}",
            "height": 2,
            "background-color": "{i_25}",
            "border-radius": 48,
            "show": true,
            "behavior": {
                "hover": {
                    "background-color": "{i_26}"
                },
                "focus": {
                    "background-color": "{i_27}"
                },
                "active": {
                    "background-color": "{i_28}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "prefix-slot": {
            "disabled": false
        },
        "suffix-slot": {
            "disabled": false
        },
        "input_label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1,
            "z-index": 1,
            "animate-padding-left": true
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{i_29}",
                    "disabled": true
                },
                "jds_input": {
                    "disabled": true
                },
                "prefix-slot": {
                    "disabled": true
                },
                "suffix-slot": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{i_31}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_32}"
                        },
                        "focus": {
                            "background-color": "{i_33}"
                        },
                        "active": {
                            "background-color": "{i_34}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{i_35}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_36}"
                        },
                        "focus": {
                            "background-color": "{i_37}"
                        },
                        "active": {
                            "background-color": "{i_38}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{i_39}",
                    "behavior": {
                        "hover": {
                            "background-color": "{i_40}"
                        },
                        "focus": {
                            "background-color": "{i_41}"
                        },
                        "active": {
                            "background-color": "{i_42}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "type": {
            "email": {
                "jds_input": {
                    "type": "email"
                }
            },
            "number": {
                "jds_input": {
                    "type": "number"
                }
            },
            "password": {
                "jds_input": {
                    "type": "password"
                }
            },
            "phone": {
                "jds_input": {
                    "type": "phone"
                }
            }
        },
        "_hasSuffix": {
            "true": {
                "suffix-icon-container": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "true": {
                "true": {
                    "field-container": {
                        "align-items": "{i_43}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    },
                    "input_label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{i_44}"
                    },
                    "input_label-jds-text": {
                        "font-family": "{bodyXs}",
                        "font-size": "{bodyXs}",
                        "line-height": "{bodyXs}",
                        "letter-spacing": "{bodyXs}",
                        "font-weight": "{bodyXs}",
                        "padding-left": 0
                    }
                }
            },
            "false": {
                "true": {
                    "field-container": {
                        "align-items": "{i_45}"
                    },
                    "prefix-icon-container": {
                        "hidden": false
                    }
                },
                "false": {
                    "field-container": {
                        "align-items": "{i_47}"
                    },
                    "input_label-jds-text": {
                        "padding-left": 0
                    }
                }
            }
        },
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{i_48}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "_labelFocus",
            "_hasPrefix"
        ],
        [
            "state",
            "_inputFocus"
        ]
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_dropdown",
                    "jds_icon",
                    "jds_input_phone_dropdown",
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "It takes 'icon' or 'dropdown' as prefix."
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_dropdown",
                    "jds_icon",
                    "jds_spinner"
                ],
                "max": 1,
                "doc_description": "It takes 'icon' or 'dropdown' as suffix."
            }
        },
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable InputField."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.By default it is 'none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "type": {
                "type": "JDSInput.type",
                "function": true,
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "textarea",
                    "pin",
                    "phone"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasPrefix": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasSuffix": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value",
                    "doc_description": "It takes value from user for the Input field."
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder",
                    "doc_description": "It displays the placeholder of Input field."
                },
                "maxLength": {
                    "type": "number",
                    "name": "maxLength",
                    "doc_description": "It can be used to bound user's input within a maximum character limit."
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "required": {
                    "type": "boolean",
                    "name": "required",
                    "doc_description": "It can be used to make input field required."
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "padding-left": {
                    "type": "size",
                    "name": "_labelOffset"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It dispalys helper text of the input field."
                }
            }
        },
        "events": {
            "prefix-container": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios"
                }
            },
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick",
                "onSlotMeasure": {
                    "name": "onPrefixSlotWidth",
                    "platform": "android"
                }
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaInvalid": "ariaInvalid",
                    "ariaPlaceholder": {
                        "name": "_ariaPlaceholder"
                    },
                    "ariaRequired": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$Component$f = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$e;
    const { disabled: disabled = false, state: state = "undefined", type: type = "undefined", onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInvalid: onInvalid = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrefixSlotWidth: onPrefixSlotWidth = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            state: state,
            type: type,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            onPrefixClick: onPrefixClick,
            onPrefixSlotWidth: onPrefixSlotWidth,
            onSuffixClick: onSuffixClick,
            ariaLabel: ariaLabel,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputField", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$dd2171e2b7d3bc5b = $451487d20aa3eb8a$var$withLogic$1c($451487d20aa3eb8a$var$Component$f);
$451487d20aa3eb8a$export$dd2171e2b7d3bc5b.displayName = "InputField";
$451487d20aa3eb8a$export$dd2171e2b7d3bc5b.slotName = "jds_input_field";
const $451487d20aa3eb8a$var$sdl$d = {
    "metadata": {
        "version": "1.0.0",
        "id": "pagination-1.0.0",
        "name": "JDSPagination",
        "layerName": "jds_pagination"
    },
    "hierarchy": {
        "container": [
            "first-jds_button",
            "previous-jds_button",
            {
                "basic-container": [
                    "data-jds_pagination_button"
                ]
            },
            {
                "compact-container": [
                    "helper-jds-text"
                ]
            },
            "next-jds_button",
            "last-jds_button"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "background-color": "{p_0}",
            "flex-direction": "{p_1}",
            "justify-content": "{p_2}",
            "align-items": "{p_3}",
            "padding-left": "{p_4}",
            "padding-right": "{p_5}",
            "width": "{p_6}",
            "min-height": "{p_7}"
        },
        "basic-container": {
            "flex-direction": "{p_8}"
        },
        "previous-jds_button": {
            "icon": "ic_back",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "next-jds_button": {
            "icon": "ic_next",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "last-jds_button": {
            "hidden": true,
            "icon": "ic_lastpage",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "first-jds_button": {
            "hidden": true,
            "icon": "ic_firstpage",
            "kind": "tertiary",
            "size": "small",
            "_hasLabel": false
        },
        "compact-container": {
            "flex-direction": "{p_9}",
            "hidden": true,
            "gap": "{p_10}",
            "padding-left": "{p_11}",
            "padding-right": "{p_12}"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "kind": {
            "compact": {
                "compact-container": {
                    "hidden": false
                },
                "basic-container": {
                    "hidden": true
                },
                "last-jds_button": {
                    "hidden": false
                },
                "first-jds_button": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "kind": {
                "values": [
                    "basic",
                    "compact"
                ]
            }
        },
        "data": {
            "container": {
                "_items.page": {
                    "type": "number",
                    "name": "page"
                },
                "_items.totalPages": {
                    "type": "number",
                    "name": "totalPages"
                }
            },
            "basic-container": {
                "value": {
                    "type": "list",
                    "name": "_items",
                    "object": {
                        "text": "string",
                        "state": "JDSPaginationButton.state"
                    }
                }
            },
            "data-jds_pagination_button": {
                "text": {
                    "type": "string",
                    "name": "_items.text"
                },
                "state": {
                    "type": "JDSPaginationButton.state",
                    "name": "_items.state"
                }
            },
            "first-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_firstDisabled"
                }
            },
            "previous-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_previousDisabled"
                }
            },
            "next-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_nextDisabled"
                }
            },
            "last-jds_button": {
                "disabled": {
                    "type": "boolean",
                    "name": "_lastDisabled"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_helperText"
                }
            }
        },
        "events": {
            "first-jds_button": {
                "onClick": "onFirst"
            },
            "previous-jds_button": {
                "onClick": "onPrevious"
            },
            "next-jds_button": {
                "onClick": "onNext"
            },
            "last-jds_button": {
                "onClick": "onLast"
            },
            "data-jds_pagination_button": {
                "onClick": "onSelect"
            }
        },
        "a11y": {
            "previous-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "previousButtonAriaLabel",
                        "value": "Previous Page"
                    }
                }
            },
            "next-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "nextButtonAriaLabel",
                        "value": "Next Page"
                    }
                }
            },
            "last-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "lastButtonAriaLabel",
                        "value": "Last Page"
                    }
                }
            },
            "first-jds_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "firstButtonAriaLabel",
                        "value": "First Page"
                    }
                }
            },
            "container": {
                "properties": {
                    "role": {
                        "value": "navigation"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "Pagination navigation"
                    },
                    "aria-describedby": "ariaDescribedby"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$ellipsis = {
    state: "ellipsis",
    text: "..."
};
function $451487d20aa3eb8a$var$getTruncatedFiniteItems(length, page) {
    if (page <= 4) {
        const start2 = Array.from({
            length: 5
        }).map((_, index)=>({
                state: index + 1 === page ? "selected" : "default",
                text: `${index + 1}`
            }));
        const end2 = {
            state: page === length ? "selected" : "default",
            text: length.toString()
        };
        return [
            ...start2,
            $451487d20aa3eb8a$var$ellipsis,
            end2
        ];
    } else if (page >= length - 3) {
        const start2 = {
            state: page === 1 ? "selected" : "default",
            text: "1"
        };
        const end2 = Array.from({
            length: 5
        }).map((_, index)=>({
                state: page === index + length - 4 ? "selected" : "default",
                text: `${index + length - 4}`
            }));
        return [
            start2,
            $451487d20aa3eb8a$var$ellipsis,
            ...end2
        ];
    }
    const start = {
        state: page === 1 ? "selected" : "default",
        text: "1"
    };
    const end = {
        state: page === length ? "selected" : "default",
        text: length.toString()
    };
    const mid = Array.from({
        length: 3
    }).map((_, index)=>({
            state: index + page - 1 === page ? "selected" : "default",
            text: `${index + page - 1}`
        }));
    return [
        start,
        $451487d20aa3eb8a$var$ellipsis,
        ...mid,
        $451487d20aa3eb8a$var$ellipsis,
        end
    ];
}
function $451487d20aa3eb8a$var$getInfiniteItems(page) {
    if (page <= 5) {
        const start2 = Array.from({
            length: 6
        }).map((_, index)=>({
                state: index + 1 === page ? "selected" : "default",
                text: `${index + 1}`
            }));
        return [
            ...start2,
            $451487d20aa3eb8a$var$ellipsis
        ];
    }
    const start = {
        state: page === 1 ? "selected" : "default",
        text: "1"
    };
    const mid = Array.from({
        length: 4
    }).map((_, index)=>({
            state: index + page - 2 === page ? "selected" : "default",
            text: `${index + page - 2}`
        }));
    return [
        start,
        $451487d20aa3eb8a$var$ellipsis,
        ...mid,
        $451487d20aa3eb8a$var$ellipsis
    ];
}
function $451487d20aa3eb8a$var$getBasicItems(length, page) {
    return Array.from({
        length: length
    }).map((_, index)=>({
            text: `${index + 1}`,
            state: index + 1 === page ? "selected" : "default"
        }));
}
const $451487d20aa3eb8a$var$withLogic$d = (Component)=>(props)=>{
        const { page: page, totalPages: totalPages = 0, onPageChange: onPageChange, kind: kind, ...rest } = props;
        const { index: index, onClick: onClick, updateIndex: updateIndex } = $451487d20aa3eb8a$var$useSelected(page);
        const handlePrev = ()=>{
            if (index !== 0) {
                updateIndex(index - 1);
                onPageChange?.(index - 1);
            }
        };
        const handleNext = ()=>{
            if (index !== totalPages) {
                updateIndex(index + 1);
                onPageChange?.(index + 1);
            }
        };
        const handleOnLast = ()=>{
            updateIndex(totalPages);
            onPageChange?.(totalPages);
        };
        const handleOnFirst = ()=>{
            updateIndex(1);
            onPageChange?.(1);
        };
        const items = ()=>{
            const length = totalPages ?? 0;
            const page2 = index ?? 0;
            if (length > 0 && length <= 7) return $451487d20aa3eb8a$var$getBasicItems(length, page2);
            else if (length > 7) return $451487d20aa3eb8a$var$getTruncatedFiniteItems(length, page2);
            else if (length < 1) return $451487d20aa3eb8a$var$getInfiniteItems(page2);
            return [];
        };
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const currentItems = items().map((item, i)=>({
                ...item,
                text: item.text !== "..." ? getLocalNumber(Number(item.text)) : item.text,
                onSelect: ()=>{
                    const { text: text } = item;
                    if (text !== "...") {
                        const currentPage = parseInt(text);
                        onClick(currentPage);
                        onPageChange?.(currentPage);
                    }
                }
            }));
        const firstButtonState = index === 1;
        const lastButtonState = index === totalPages;
        console.log(lastButtonState, 205);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...rest,
                _items: currentItems,
                kind: kind,
                onPrevious: handlePrev,
                onNext: handleNext,
                _helperText: `${getLocalNumber(index)} / ${getLocalNumber(totalPages)}`,
                onFirst: handleOnFirst,
                onLast: handleOnLast,
                _previousDisabled: firstButtonState,
                _firstDisabled: firstButtonState,
                _lastDisabled: lastButtonState,
                _nextDisabled: lastButtonState
            }
        });
    };
const $451487d20aa3eb8a$var$Component$e = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$d;
    const { kind: kind = "basic", onFirst: onFirst = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrevious: onPrevious = (0, $ddff9b86434e3f59$export$8793edee2d425525), onNext: onNext = (0, $ddff9b86434e3f59$export$8793edee2d425525), onLast: onLast = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSelect: onSelect = (0, $ddff9b86434e3f59$export$8793edee2d425525), previousButtonAriaLabel: previousButtonAriaLabel = "Previous Page", nextButtonAriaLabel: nextButtonAriaLabel = "Next Page", lastButtonAriaLabel: lastButtonAriaLabel = "Last Page", firstButtonAriaLabel: firstButtonAriaLabel = "First Page", ariaLabel: ariaLabel = "Pagination navigation", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            onFirst: onFirst,
            onPrevious: onPrevious,
            onNext: onNext,
            onLast: onLast,
            onSelect: onSelect,
            previousButtonAriaLabel: previousButtonAriaLabel,
            nextButtonAriaLabel: nextButtonAriaLabel,
            lastButtonAriaLabel: lastButtonAriaLabel,
            firstButtonAriaLabel: firstButtonAriaLabel,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPagination", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$68f5e1453c188a82 = $451487d20aa3eb8a$var$withLogic$d($451487d20aa3eb8a$var$Component$e);
$451487d20aa3eb8a$export$68f5e1453c188a82.displayName = "Pagination";
$451487d20aa3eb8a$export$68f5e1453c188a82.slotName = "jds_pagination";
const $451487d20aa3eb8a$var$sdl$c = {
    "metadata": {
        "version": "1.0.0",
        "id": "promo-card-1.0.0",
        "name": "JDSPromoCard",
        "layerName": "jds_promo_card",
        "description": "Promotional cards are compositions of text and images intended to promote a specific service or feature.",
        "usage": "Promotional cards are used to announce a new feature or motivate users to take an action."
    },
    "hierarchy": {
        "root-container": [
            {
                "vertical-container": [
                    {
                        "vertical-image-container": [
                            "vertical-jds_image",
                            "vertical-promoCardArc"
                        ]
                    },
                    {
                        "vertical-content-container": [
                            "vertical-jds_content_block"
                        ]
                    }
                ]
            },
            {
                "horizontal-container": [
                    {
                        "horizontal-content-container": [
                            "horizontal-jds_content_block"
                        ]
                    },
                    {
                        "horizontal-image-container": [
                            "horizontal-image",
                            "horizontal-promoCardArc"
                        ]
                    }
                ]
            },
            {
                "footer-container": [
                    "prefix-slot",
                    "suffix-slot"
                ]
            }
        ]
    },
    "base": {
        "root-container": {
            "background-color": "{p_0}",
            "flex-direction": "{p_1}",
            "width": "{p_2}",
            "justify-content": "{p_3}",
            "align-items": "{p_4}",
            "border-radius": "{p_5}",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            }
        },
        "vertical-container": {
            "mode": "bold",
            "flex-direction": "{p_6}",
            "align-items": "{p_7}",
            "justify-content": "{p_8}",
            "width": "{p_9}",
            "border-radius": "{p_10}",
            "background-color": "{p_11}",
            "overflow": "hidden"
        },
        "horizontal-container": {
            "hidden": true,
            "mode": "bold",
            "flex-direction": "{p_12}",
            "align-items": "{p_13}",
            "justify-content": "{p_14}",
            "width": "{p_15}",
            "border-radius": "{p_16}",
            "height": "{p_17}",
            "background-color": "{p_18}",
            "overflow": "hidden"
        },
        "vertical-content-container": {
            "flex-direction": "{p_19}",
            "align-items": "{p_20}",
            "justify-content": "{p_21}",
            "width": "{p_22}",
            "mode": "bold",
            "background-color": "{p_23}",
            "border-bottom-left-radius": "{p_24}",
            "border-bottom-right-radius": "{p_25}",
            "padding-right": "{p_26}",
            "padding-bottom": "{p_27}",
            "padding-left": "{p_28}"
        },
        "horizontal-content-container": {
            "flex-direction": "{p_29}",
            "align-items": "{p_30}",
            "justify-content": "{p_31}",
            "height": "{p_32}",
            "mode": "bold",
            "background-color": "{p_33}",
            "flex": 1,
            "padding-top": "{p_34}",
            "padding-right": "{p_35}",
            "padding-bottom": "{p_36}",
            "padding-left": "{p_37}"
        },
        "vertical-jds_content_block": {
            "mode": "bold",
            "size": "small"
        },
        "horizontal-jds_content_block": {
            "mode": "bold",
            "size": "small"
        },
        "vertical-image-container": {
            "width": "{p_38}",
            "flex-direction": "{p_39}",
            "align-items": "{p_40}"
        },
        "horizontal-image-container": {
            "flex": 1,
            "height": "{p_41}",
            "flex-direction": "{p_42}",
            "align-items": "{p_43}",
            "justify-content": "{p_44}"
        },
        "vertical-jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": false
        },
        "horizontal-image": {
            "overflow": "hidden",
            "height": "{p_45}",
            "object-position": "center",
            "object-fit": "cover",
            "aspect-ratio": "{aspect_ratio.16.9}"
        },
        "vertical-promoCardArc": {
            "mode": "bold",
            "color": "{p_46}",
            "orientation": "vertical",
            "width": "{p_47}",
            "height": "{p_48}",
            "z-index": 1
        },
        "horizontal-promoCardArc": {
            "mode": "bold",
            "color": "{p_49}",
            "orientation": "horizontal",
            "height": "{p_50}",
            "width": "{p_51}",
            "z-index": 1
        },
        "footer-container": {
            "color": "{p_52}",
            "width": "{p_53}",
            "justify-content": "{p_54}",
            "align-items": "{p_55}",
            "flex-direction": "{p_56}",
            "gap": "{p_57}",
            "padding-left": "{p_58}",
            "padding-right": "{p_59}",
            "padding-top": "{p_60}",
            "padding-bottom": "{p_61}",
            "mode": "light",
            "show": false
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "vertical-jds_image": {
                    "aspectRatio": "square"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.1.1}"
                }
            },
            "landscape": {
                "vertical-jds_image": {
                    "aspectRatio": "horizontal_4_3"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.4.3}"
                }
            },
            "portrait": {
                "vertical-jds_image": {
                    "aspectRatio": "vertical_4_5"
                },
                "horizontal-image": {
                    "aspect-ratio": "{aspect_ratio.4.5}"
                }
            }
        },
        "imageFocus": {
            "left": {
                "vertical-jds_image": {
                    "imageFocus": "left"
                },
                "horizontal-image": {
                    "object-position": "left"
                }
            },
            "right": {
                "vertical-jds_image": {
                    "imageFocus": "right"
                },
                "horizontal-image": {
                    "object-position": "right"
                }
            },
            "top": {
                "vertical-jds_image": {
                    "imageFocus": "top"
                },
                "horizontal-image": {
                    "object-position": "top"
                }
            },
            "bottom": {
                "vertical-jds_image": {
                    "imageFocus": "bottom"
                },
                "horizontal-image": {
                    "object-position": "bottom"
                }
            }
        },
        "shadow": {
            "false": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": 0,
                        "color": "#00000000"
                    }
                }
            }
        },
        "size": {
            "xtra-small": {
                "vertical-jds_content_block": {
                    "size": "xtra-small"
                },
                "horizontal-jds_content_block": {
                    "size": "xtra-small"
                }
            },
            "medium": {
                "vertical-jds_content_block": {
                    "size": "medium"
                },
                "horizontal-jds_content_block": {
                    "size": "medium"
                },
                "horizontal-content-container": {
                    "padding-top": "{p_62}",
                    "padding-right": "{p_63}",
                    "padding-bottom": "{p_64}",
                    "padding-left": "{p_65}"
                }
            },
            "large": {
                "vertical-jds_content_block": {
                    "size": "large"
                },
                "horizontal-jds_content_block": {
                    "size": "large"
                },
                "horizontal-content-container": {
                    "padding-top": "{p_66}",
                    "padding-right": "{p_67}",
                    "padding-bottom": "{p_68}",
                    "padding-left": "{p_69}"
                }
            }
        },
        "orientation": {
            "horizontal": {
                "vertical-container": {
                    "hidden": true
                },
                "horizontal-container": {
                    "hidden": false
                }
            }
        },
        "_hasFooter": {
            "false": {
                "footer-container": {
                    "hidden": true
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "children": {
            "prefix-slot": {
                "name": "footerPrefix",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "footerPrefix corresponds to the left part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown"
            },
            "suffix-slot": {
                "name": "footerSuffix",
                "accepts": [
                    "jds_text"
                ],
                "max": 1,
                "doc_description": "footerSuffix corresponds to the right part of the footer. Incase of a String, a text with style body-xxs with grey-100 color is shown"
            }
        },
        "config": {
            "size": {
                "values": [
                    "small",
                    "xtra-small",
                    "medium",
                    "large"
                ],
                "doc_description": "Determines the size of the PromoCard. Size dictates the text and spacing."
            },
            "orientation": {
                "values": [
                    "vertical",
                    "horizontal"
                ],
                "doc_description": "Horizontal orientation puts image and content side by side."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "imageFocus": {
                "type": "JDSImage.imageFocus",
                "values": [
                    "center",
                    "left",
                    "right",
                    "top",
                    "bottom"
                ]
            },
            "shadow": {
                "values": [
                    true,
                    false
                ],
                "doc_description": "Toggle drop shadow"
            },
            "_hasFooter": {
                "values": [
                    true,
                    false
                ]
            }
        },
        "data": {
            "horizontal-jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "vertical-jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "horizontal-image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            },
            "vertical-jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "horizontal-jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            },
            "vertical-jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "horizontal-jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "vertical-jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    },
                    "secondaryCtaAriaLabel": "secondaryCtaAriaLabel",
                    "secondaryCtaAriaDescribedby": {
                        "name": "secondaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "vertical-jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "horizontal-image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$c = (Component)=>(props)=>{
        const { footerPrefix: footerPrefix, footerSuffix: footerSuffix, ...rest } = props;
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const formatImageName = (imagePath = props.src || "")=>{
            const parts = imagePath.split("/");
            const imageName = parts.length > 0 ? parts[parts.length - 1] : "";
            if (imageName) {
                const formattedName = imageName.replace(/\.\w+$/, "").replace(/([A-Z])/g, " $1").toLowerCase() + " image";
                return formattedName;
            }
            return "Image name not found";
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)((0, $ddff9b86434e3f59$export$e5cf4eff53e7947d), {
            value: {
                ...tokens,
                mode: "bold"
            },
            children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
                ...{
                    ...rest,
                    _hasChildren: Boolean(rest.children),
                    _hasFooter: Boolean(footerPrefix || footerSuffix),
                    children: $451487d20aa3eb8a$var$convertTextToComponent(rest.children),
                    footerPrefix: $451487d20aa3eb8a$var$convertTextToComponent(footerPrefix),
                    footerSuffix: $451487d20aa3eb8a$var$convertTextToComponent(footerSuffix),
                    _imageAriaLabel: formatImageName(props.image)
                }
            })
        });
    };
const $451487d20aa3eb8a$var$Component$d = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$c;
    const { size: size = "small", orientation: orientation = "vertical", imageRatio: imageRatio = "wide", imageFocus: imageFocus = "undefined", shadow: shadow = true, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            orientation: orientation,
            imageRatio: imageRatio,
            imageFocus: imageFocus,
            shadow: shadow,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSPromoCard", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ad00a5af021e778b = $451487d20aa3eb8a$var$withLogic$c($451487d20aa3eb8a$var$Component$d);
$451487d20aa3eb8a$export$ad00a5af021e778b.displayName = "PromoCard";
$451487d20aa3eb8a$export$ad00a5af021e778b.slotName = "jds_promo_card";
const $451487d20aa3eb8a$var$sdl$b = {
    "metadata": {
        "version": "1.0.0",
        "id": "radio-button-1.0.0",
        "name": "JDSRadioButton",
        "layerName": "jds_radio_button",
        "description": "Radio buttons are used when there is alist of two or more options that are mutually exclusive and the user must select exactly one choice.",
        "usage": ""
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "outer-container": [
                            "inner-container"
                        ]
                    },
                    "label-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{r_0}",
            "justify-content": "{r_1}",
            "align-items": "{r_2}",
            "gap": "{r_3}",
            "opacity": "{r_36}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{r_4}",
            "justify-content": "{r_5}",
            "align-items": "{r_6}",
            "gap": "{r_7}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "outer-container": {
            "hidden": false,
            "min-width": "{r_8}",
            "min-height": "{r_9}",
            "flex-direction": "{r_10}",
            "justify-content": "{r_11}",
            "align-items": "{r_12}",
            "background-color": "{r_13}",
            "border-radius": "{r_14}",
            "border-width": "{r_16}",
            "border-color": "{r_15}",
            "show": true,
            "behavior": {
                "hover": {
                    "border-color": "{r_18}"
                },
                "active": {
                    "border-color": "{r_19}"
                },
                "focus": {
                    "border-width": 4,
                    "box-sizing": "content-box",
                    "border-color": "{r_20}"
                }
            }
        },
        "inner-container": {
            "hidden": true,
            "min-width": "{r_21}",
            "min-height": "{r_22}",
            "border-radius": "{r_23}",
            "show": true
        },
        "jds_feedback_block": {
            "size": "l"
        },
        "label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "text-align": "{r_24}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "size": {
            "small": {
                "outer-container": {
                    "min-width": "{r_25}",
                    "min-height": "{r_26}"
                },
                "vertical-container": {
                    "gap": "{r_27}"
                },
                "inner-container": {
                    "min-width": "{r_28}",
                    "min-height": "{r_29}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "checked": {
            "true": {
                "outer-container": {
                    "background-color": "{r_30}",
                    "border-width": "{r_17}",
                    "behavior": {
                        "hover": {
                            "background-color": "{r_31}"
                        },
                        "active": {
                            "background-color": "{r_32}"
                        },
                        "focus": {
                            "background-color": "{r_33}"
                        }
                    }
                },
                "inner-container": {
                    "hidden": false,
                    "background-color": "{r_34}"
                },
                "label-jds-text": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "opacity": "{r_35}"
                },
                "horizontal-container": {
                    "disabled": true
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Used to programatically make input active/inactive."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "value": "radio"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "checked"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$b = (Component)=>(props)=>{
        const handleClick = (ev)=>{
            if (props.onClick) props.onClick({
                ...ev,
                currentTarget: {
                    value: props.value
                },
                target: {
                    value: props.value
                }
            });
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                checked: props.checked,
                onClick: handleClick
            }
        });
    };
const $451487d20aa3eb8a$var$Component$c = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$b;
    const { checked: checked = false, size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.checked?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            size: size,
            disabled: disabled,
            onClick: onClick,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRadioButton", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$324f219e224c2ba4 = $451487d20aa3eb8a$var$withLogic$b($451487d20aa3eb8a$var$Component$c);
$451487d20aa3eb8a$export$324f219e224c2ba4.displayName = "InputRadio";
$451487d20aa3eb8a$export$324f219e224c2ba4.slotName = "jds_radio_button";
const $451487d20aa3eb8a$var$sdl$a = {
    "metadata": {
        "version": "1.0.0",
        "id": "Rating-bar-1.0.0",
        "name": "JDSRatingBar",
        "layerName": "jds_rating_bar"
    },
    "hierarchy": {
        "vertical-container": [
            "top_label-jds-text",
            {
                "horizontal-container": [
                    "left_label-jds-text",
                    "compact-jds_rating_bar_item",
                    {
                        "rating-bar-container": [
                            "jds_rating_bar_item"
                        ]
                    },
                    "right_label-jds-text",
                    "right_support-jds-text"
                ]
            },
            "bottom_label-jds-text",
            "bottom_support-jds-text",
            "jds_feedback_block"
        ]
    },
    "base": {
        "vertical-container": {
            "flex-direction": "{r_0}",
            "align-items": "{r_1}",
            "justify-content": "{r_2}",
            "gap": "{r_3}"
        },
        "horizontal-container": {
            "flex-direction": "{r_4}",
            "align-items": "{r_26}",
            "justify-content": "{r_6}",
            "gap": "{r_7}"
        },
        "compact-jds_rating_bar_item": {
            "hidden": true,
            "isInteractive": false,
            "isActive": true,
            "isHalfRated": false,
            "size": "medium"
        },
        "rating-bar-container": {
            "flex-direction": "{r_8}"
        },
        "jds_feedback_block": {
            "size": "l",
            "hidden": true
        },
        "top_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "left_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "right_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "bottom_label-jds-text": {
            "font-family": "{bodySBold}",
            "color": "{primaryGrey100}",
            "font-size": "{bodySBold}",
            "line-height": "{bodySBold}",
            "letter-spacing": "{bodySBold}",
            "font-weight": "{bodySBold}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "right_support-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true
        },
        "bottom_support-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "vertical-container": {
                    "gap": "{r_9}"
                },
                "horizontal-container": {
                    "gap": "{r_10}"
                },
                "compact-jds_rating_bar_item": {
                    "size": "small"
                },
                "top_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "left_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "right_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "bottom_label-jds-text": {
                    "font-family": "{bodyXxsBold}",
                    "font-size": "{bodyXxsBold}",
                    "line-height": "{bodyXxsBold}",
                    "letter-spacing": "{bodyXxsBold}",
                    "font-weight": "{bodyXxsBold}"
                },
                "right_support-jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                },
                "bottom_support-jds-text": {
                    "font-family": "{bodyXxs}",
                    "font-size": "{bodyXxs}",
                    "line-height": "{bodyXxs}",
                    "letter-spacing": "{bodyXxs}",
                    "font-weight": "{bodyXxs}"
                }
            },
            "large": {
                "compact-jds_rating_bar_item": {
                    "size": "large"
                }
            }
        },
        "labelPosition": {
            "bottom_center": {
                "vertical-container": {
                    "align-items": "{r_11}"
                },
                "top_label-jds-text": {
                    "hidden": true
                },
                "bottom_label-jds-text": {
                    "hidden": false
                }
            },
            "bottom_left": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "bottom_label-jds-text": {
                    "hidden": false
                }
            },
            "top_center": {
                "vertical-container": {
                    "align-items": "{r_12}"
                }
            },
            "right": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "right_label-jds-text": {
                    "hidden": false
                },
                "bottom_support-jds-text": {
                    "hidden": true
                },
                "right_support-jds-text": {
                    "hidden": false
                }
            },
            "left": {
                "top_label-jds-text": {
                    "hidden": true
                },
                "left_label-jds-text": {
                    "hidden": false
                },
                "bottom_support-jds-text": {
                    "hidden": true
                },
                "right_support-jds-text": {
                    "hidden": false
                }
            }
        },
        "type": {
            "read_only_expanded": {
                "rating-bar-container": {
                    "disabled": true
                },
                "jds_rating_bar_item": {
                    "isInteractive": false
                }
            },
            "read_only_compact": {
                "rating-bar-container": {
                    "hidden": true
                },
                "compact-jds_rating_bar_item": {
                    "hidden": false
                }
            }
        },
        "disabled": {
            "true": {
                "vertical-container": {
                    "disabled": true,
                    "opacity": "{r_13}"
                }
            }
        },
        "state": {
            "success": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        }
    },
    "combination": [
        {
            "read_only_compact": {
                "top_left": {
                    "top_label-jds-text": {
                        "hidden": true
                    },
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "top_center": {
                    "top_label-jds-text": {
                        "hidden": true
                    },
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "bottom_left": {
                    "bottom_label-jds-text": {},
                    "right_label-jds-text": {
                        "hidden": false
                    }
                },
                "bottom_center": {
                    "bottom_label-jds-text": {},
                    "right_label-jds-text": {
                        "hidden": false
                    }
                }
            }
        },
        {
            "read_only_expanded": {
                "small": {
                    "vertical-container": {
                        "gap": "{r_15}"
                    },
                    "horizontal-container": {
                        "gap": "{r_14}"
                    }
                },
                "medium": {
                    "vertical-container": {
                        "gap": "{r_16}"
                    },
                    "horizontal-container": {
                        "gap": "{r_17}"
                    }
                },
                "large": {
                    "vertical-container": {
                        "gap": "{r_18}"
                    },
                    "horizontal-container": {
                        "gap": "{r_19}"
                    }
                }
            },
            "read_only_compact": {
                "small": {
                    "vertical-container": {
                        "gap": "{r_21}"
                    },
                    "horizontal-container": {
                        "gap": "{r_20}"
                    }
                },
                "medium": {
                    "vertical-container": {
                        "gap": "{r_22}"
                    },
                    "horizontal-container": {
                        "gap": "{r_23}"
                    }
                },
                "large": {
                    "vertical-container": {
                        "gap": "{r_24}"
                    },
                    "horizontal-container": {
                        "gap": "{r_25}"
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "type",
            "labelPosition"
        ],
        [
            "type",
            "size"
        ]
    ],
    "api": {
        "config": {
            "size": {
                "type": "JDSRatingBarItem.size",
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "labelPosition": {
                "values": [
                    "top_left",
                    "bottom_left",
                    "top_center",
                    "bottom_center",
                    "right",
                    "left"
                ]
            },
            "type": {
                "values": [
                    "interactive",
                    "read_only_expanded",
                    "read_only_compact"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            }
        },
        "data": {
            "rating-bar-container": {
                "value": {
                    "type": "list",
                    "name": "_items",
                    "object": {
                        "isInteractive": "boolean",
                        "isActive": "boolean",
                        "isHalfRated": "boolean",
                        "isHovered": "boolean",
                        "rating": "clipValueSize"
                    }
                },
                "_items.rating": {
                    "type": "float",
                    "name": "rating"
                },
                "_items.count": {
                    "type": "number",
                    "name": "count"
                }
            },
            "jds_rating_bar_item": {
                "size": {
                    "type": "JDSRatingBarItem.size",
                    "name": "size"
                },
                "isInteractive": {
                    "type": "boolean",
                    "name": "_items.isInteractive"
                },
                "isActive": {
                    "type": "boolean",
                    "name": "_items.isActive"
                },
                "isHovered": {
                    "type": "boolean",
                    "name": "_items.isHovered"
                },
                "isHalfRated": {
                    "type": "boolean",
                    "name": "_items.isHalfRated"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "disabled"
                },
                "clipValue": {
                    "type": "clipValueSize",
                    "name": "_items.rating"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "top_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "left_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_label"
                }
            },
            "right_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "_label"
                }
            },
            "bottom_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "right_support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "supportText"
                }
            },
            "bottom_support-jds-text": {
                "value": {
                    "type": "string",
                    "name": "supportText"
                }
            }
        },
        "events": {
            "jds_rating_bar_item": {
                "onClick": "onChange",
                "onHover": {
                    "name": "_onHover",
                    "platform": "web"
                },
                "onHoverEnd": {
                    "name": "_onHoverEnd",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "name": "_role"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "rating-bar-container": {
                "name": "_items",
                "repeating": {
                    "ariaLabel": "itemAriaLabel",
                    "ariaChecked": "itemAriaChecked"
                }
            },
            "jds_rating_bar_item": {
                "properties": {
                    "ariaLabel": "_items.itemAriaLabel",
                    "ariaChecked": "_items.itemAriaChecked"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$EPSILON = 5e-3;
const $451487d20aa3eb8a$var$withLogic$a = (Component)=>({ rating: rating = -1, ...props })=>{
        const { index: userRating, updateIndex: updateIndex } = $451487d20aa3eb8a$var$useSelected(rating);
        const ratingIsInt = Math.abs(Math.floor(userRating) - userRating) < $451487d20aa3eb8a$var$EPSILON;
        const [hoverIndex, setHoverIndex] = (0, $1OEoy.useState)(-1);
        const decimalPart = Math.abs(Math.floor(userRating) - userRating);
        const tokens = (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
        const language = tokens.lang;
        const numeralList = (0, $1OEoy.useMemo)(()=>{
            return (0, $ddff9b86434e3f59$export$3f81e69b9bc596cd)(language);
        }, [
            language
        ]);
        const getLocalNumber = (number)=>{
            const numString = number.toString();
            return numString.replace(/\d/g, (num)=>numeralList[parseInt(num, 10)] ?? num);
        };
        const roundedUserRating = Math.round(userRating);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rating: userRating,
                _role: props.type === "interactive" ? "radiogroup" : "img",
                ariaLabel: props.type === "interactive" ? `${roundedUserRating} star` : `Rated ${roundedUserRating} out of ${props.count} star`,
                _label: props.type === "read_only_compact" ? getLocalNumber(rating) : props.label,
                _onHover: (idx)=>{
                    setHoverIndex(idx);
                },
                _onHoverEnd: (idx)=>{
                    setHoverIndex(idx);
                },
                _items: Array.from({
                    length: props.count || 0
                }).map((_, i)=>{
                    const isHalfRated = !ratingIsInt && i + 1 === Math.ceil(userRating);
                    return {
                        isInteractive: props.type === "interactive",
                        itemAriaLabel: props.type === "interactive" ? `${i + 1} star` : void 0,
                        itemAriaChecked: props.type === "interactive" ? userRating === i + 1 ? "true" : "false" : void 0,
                        isActive: hoverIndex === -1 ? i + 1 <= userRating : i <= hoverIndex,
                        isHalfRated: isHalfRated,
                        rating: isHalfRated ? 100 * (1 - decimalPart) + "%" : void 0,
                        onChange: (index)=>{
                            if (props.type === "interactive") {
                                updateIndex(index + 1);
                                props.onChange?.(index + 1);
                            }
                        }
                    };
                })
            }
        });
    };
const $451487d20aa3eb8a$var$Component$b = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$a;
    const { size: size = "undefined", labelPosition: labelPosition = "top_left", type: type = "interactive", disabled: disabled = false, state: state = "undefined", onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            labelPosition: labelPosition,
            type: type,
            disabled: disabled,
            state: state,
            onChange: onChange,
            ...rest
        },
        componentTag: componentTag
    }, "JDSRatingBar", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$43a203ef9d36f4e4 = $451487d20aa3eb8a$var$withLogic$a($451487d20aa3eb8a$var$Component$b);
$451487d20aa3eb8a$export$43a203ef9d36f4e4.displayName = "RatingBar";
$451487d20aa3eb8a$export$43a203ef9d36f4e4.slotName = "jds_rating_bar";
const $451487d20aa3eb8a$var$sdl$9 = {
    "metadata": {
        "version": "1.0.0",
        "id": "selector-1.0.0",
        "layerName": "jds_selector",
        "name": "JDSSelector",
        "description": "A selector is a control that allows the user choose a value from a range of options."
    },
    "hierarchy": {
        "container": [
            {
                "selector-container": [
                    "jds_selector_item"
                ]
            },
            {
                "outer-container": [
                    "inner-container"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{s_0}"
        },
        "selector-container": {
            "opacity": "{s_1}",
            "align-items": "{s_2}",
            "justify-content": "{s_3}",
            "border-radius": "{s_4}",
            "padding-top": "{s_5}",
            "padding-right": "{s_6}",
            "padding-bottom": "{s_7}",
            "padding-left": "{s_8}",
            "gap": "{s_15}",
            "flex-direction": "{s_16}"
        },
        "jds_selector_item": {
            "wrap": "horizontal",
            "kind": "label_icon"
        },
        "outer-container": {
            "z-index": -1,
            "justify-content": "{s_19}",
            "background-color": "{s_13}",
            "border-radius": "{s_4}",
            "align-items": "{s_20}",
            "padding-top": "{s_9}",
            "padding-right": "{s_10}",
            "padding-bottom": "{s_11}",
            "padding-left": "{s_12}",
            "width": "{s_17}",
            "height": "{s_18}",
            "disabled": true,
            "transition": {
                "property": [
                    "padding-left"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeJoyful}"
            }
        },
        "inner-container": {
            "background-color": "{s_21}",
            "border-radius": "{s_22}",
            "show": true,
            "transition": {
                "property": [
                    "width"
                ],
                "duration": "{rapid}",
                "timing-function": "{easeJoyful}"
            }
        }
    },
    "variant": {
        "stretch": {
            "true": {
                "container": {
                    "width": "{s_23}"
                },
                "selector-container": {
                    "width": "{s_24}"
                },
                "jds_selector_item": {
                    "flex": 1,
                    "stretch": true
                }
            }
        },
        "wrap": {
            "vertical": {
                "jds_selector_item": {
                    "wrap": "vertical"
                }
            }
        },
        "kind": {
            "label": {
                "jds_selector_item": {
                    "kind": "label"
                }
            },
            "icon": {
                "jds_selector_item": {
                    "kind": "icon"
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "stretch": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to fill the container in which Selector is present."
            },
            "kind": {
                "type": "JDSSelectorItem.kind",
                "values": [
                    "label_icon",
                    "label",
                    "icon"
                ]
            },
            "wrap": {
                "type": "JDSSelectorItem.wrap",
                "values": [
                    "horizontal",
                    "vertical"
                ]
            }
        },
        "data": {
            "selector-container": {
                "value": {
                    "type": "list",
                    "name": "items",
                    "object": {
                        "value": "string",
                        "label": "string",
                        "id": "string",
                        "icon": "icon",
                        "disabled": "boolean"
                    }
                }
            },
            "jds_selector_item": {
                "selectedIndex": {
                    "type": "number",
                    "name": "selectedIndex",
                    "doc_description": "It gives the current index of selected button of Selector. User can overwrite it by passing a new value."
                },
                "value": {
                    "type": "string",
                    "name": "items.value"
                },
                "label": {
                    "type": "string",
                    "name": "items.label"
                },
                "id": {
                    "type": "string",
                    "name": "items.id"
                },
                "icon": {
                    "type": "icon",
                    "name": "items.icon"
                },
                "disabled": {
                    "type": "boolean",
                    "name": "items.disabled"
                }
            },
            "outer-container": {
                "padding-left": {
                    "type": "size",
                    "name": "_left"
                }
            },
            "inner-container": {
                "width": {
                    "type": "size",
                    "name": "_width"
                },
                "height": {
                    "type": "size",
                    "name": "_height"
                }
            }
        },
        "events": {
            "jds_selector_item": {
                "onAppear": {
                    "name": "_onAppear",
                    "platform": "ios, android"
                },
                "onClick": "onClick"
            },
            "container": {
                "onAppear": {
                    "name": "_onSelectorAppear",
                    "platform": "ios"
                }
            }
        },
        "a11y": {
            "selector-container": {
                "name": "items",
                "properties": {
                    "role": {
                        "value": "radiogroup"
                    }
                },
                "repeating": {
                    "ariaLabel": "ariaLabel",
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "iconAriaLabel": "iconAriaLabel"
                }
            },
            "jds_selector_item": {
                "properties": {
                    "ariaLabel": "items.ariaLabel",
                    "ariaDescribedby": "items.ariaDescribedby",
                    "iconAriaLabel": "items.iconAriaLabel"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$9 = (Component)=>({ items: userItems = [], ...props })=>{
        const [selectedIndex, setSelectedIndex] = (0, $1OEoy.useState)(props.selectedIndex || 0);
        const [dimensions, setDimensions] = (0, $1OEoy.useState)({
            left: 0,
            width: 0,
            height: 0
        });
        const { rootRef: rootRef } = $451487d20aa3eb8a$var$useRootRef((element)=>{
            const updateDimensions = ()=>{
                const selectorContainers2 = Array.from(element?.querySelectorAll("div.j-JDSSelectorItem-container") || []);
                const selectedContainer = selectorContainers2[selectedIndex];
                if (selectedContainer) setDimensions({
                    left: selectedContainer?.offsetLeft,
                    width: selectedContainer?.offsetWidth,
                    height: selectedContainer?.offsetHeight
                });
            };
            updateDimensions();
            const resizeObserver = new ResizeObserver(()=>{
                updateDimensions();
            });
            const selectorContainers = element?.querySelectorAll("div.j-JDSSelectorItem-container") || [];
            selectorContainers.forEach((container)=>{
                resizeObserver.observe(container);
            });
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            selectedIndex,
            props.stretch,
            props.wrap
        ]);
        (0, $1OEoy.useEffect)(()=>{
            if (typeof props.selectedIndex === "number") setSelectedIndex(props.selectedIndex);
            else setSelectedIndex(0);
        }, [
            props.selectedIndex
        ]);
        const items = userItems.map((item, i)=>({
                ...item,
                selected: selectedIndex === i,
                selectedIndex: selectedIndex,
                onClick: (ev)=>{
                    setSelectedIndex(i);
                    props.onChange?.(item.value, i, ev);
                }
            }));
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                selectedIndex: selectedIndex,
                items: items,
                rootRef: rootRef,
                _left: dimensions.left,
                _width: dimensions.width,
                _height: dimensions.height
            }
        });
    };
const $451487d20aa3eb8a$var$Component$a = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$9;
    const { stretch: stretch = false, kind: kind = "undefined", wrap: wrap = "undefined", onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            stretch: stretch,
            kind: kind,
            wrap: wrap,
            onClick: onClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSelector", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$87e9c2ff338a8575 = $451487d20aa3eb8a$var$withLogic$9($451487d20aa3eb8a$var$Component$a);
$451487d20aa3eb8a$export$87e9c2ff338a8575.displayName = "Selectors";
$451487d20aa3eb8a$export$87e9c2ff338a8575.slotName = "jds_selector";
const $451487d20aa3eb8a$var$sdl$8 = {
    "metadata": {
        "version": "1.0.0",
        "id": "service-card-1.0.0",
        "name": "JDSServiceCard",
        "layerName": "jds_service_card",
        "description": "Service cards are blocks of images and text aiming to promote and connect services.",
        "usage": "Service cards are used to drive users from one Jio service to another."
    },
    "hierarchy": {
        "root-container": [
            {
                "inner-stack-container": [
                    "blur-image",
                    {
                        "internal-vertical-container": [
                            {
                                "image-container": [
                                    "jds_image"
                                ]
                            },
                            {
                                "content-block-container": [
                                    "jds_content_block"
                                ]
                            }
                        ]
                    }
                ]
            },
            "jds_badge"
        ]
    },
    "base": {
        "root-container": {
            "flex-direction": "{s_0}",
            "size": "{s_2}",
            "justify-content": "{s_4}",
            "align-items": "{s_6}",
            "border-radius": "{s_7}",
            "overflow": "hidden"
        },
        "inner-stack-container": {
            "flex-direction": "{s_1}",
            "size": "{s_3}",
            "justify-content": "{s_5}",
            "align-items": "{alignItems.end}",
            "overflow": "hidden"
        },
        "blur-image": {
            "height": "{s_8}",
            "width": "{s_9}",
            "object-fit": "cover",
            "blur-radius": "{s_10}",
            "z-index": 0
        },
        "internal-vertical-container": {
            "flex-direction": "{s_12}",
            "size": "{s_13}",
            "justify-content": "{s_14}",
            "align-items": "{s_15}",
            "z-index": 1
        },
        "image-container": {
            "flex-direction": "{s_16}",
            "justify-content": "{s_17}",
            "align-items": "{s_18}",
            "height": "{s_19}",
            "width": "{s_20}",
            "overflow": "hidden"
        },
        "jds_image": {
            "aspectRatio": "horizontal_16_9",
            "roundedCorner": false,
            "imageFocus": "center"
        },
        "jds_badge": {
            "kind": "service",
            "padding-top": "{s_21}",
            "padding-left": "{s_22}",
            "z-index": 1
        },
        "content-block-container": {
            "background-color": "{s_23}",
            "width": "{s_24}",
            "padding-top": "{s_25}",
            "padding-bottom": "{s_26}",
            "padding-left": "{s_27}",
            "padding-right": "{s_28}"
        },
        "jds_content_block": {
            "size": "xtra-xtra-small",
            "invertCTA": false,
            "ctaWrap": "horizontal",
            "shouldOverrideColor": true,
            "singleButton": true,
            "width": "{s_29}"
        }
    },
    "variant": {
        "imageRatio": {
            "square": {
                "jds_image": {
                    "aspectRatio": "square"
                }
            },
            "landscape": {
                "jds_image": {
                    "aspectRatio": "horizontal_4_3"
                }
            },
            "portrait": {
                "jds_image": {
                    "aspectRatio": "vertical_4_5"
                }
            }
        },
        "shadow": {
            "true": {
                "root-container": {
                    "box-shadow": {
                        "x": 0,
                        "y": 4,
                        "blur": 16,
                        "spread": 0,
                        "color": "#00000014"
                    }
                }
            }
        },
        "size": {
            "xtra-small": {
                "jds_content_block": {
                    "size": "xtra-small"
                }
            },
            "small": {
                "jds_content_block": {
                    "size": "small"
                }
            }
        },
        "_hasFullCardCTA": {
            "true": {
                "root-container": {
                    "behavior": {
                        "hover": {
                            "box-shadow": {
                                "x": 0,
                                "y": 4,
                                "blur": 16,
                                "spread": 0,
                                "color": "#00000014"
                            }
                        }
                    }
                }
            }
        }
    },
    "api": {
        "config": {
            "size": {
                "values": [
                    "xtra-xtra-small",
                    "xtra-small",
                    "small"
                ],
                "doc_description": "Determines the size of the ContentBlock. Size dictates the text and spacing. For size=`xxs`, the layout also changes if only a single CTA is sent."
            },
            "imageRatio": {
                "values": [
                    "wide",
                    "square",
                    "landscape",
                    "portrait"
                ]
            },
            "shadow": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Toggle drop shadow"
            },
            "_hasFullCardCTA": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "root-container": {
                "fullCardCTA": {
                    "type": "string",
                    "name": "fullCardCTA",
                    "doc_description": "When present, the entire card is clickable."
                }
            },
            "jds_content_block": {
                "title": {
                    "type": "string",
                    "name": "title",
                    "doc_description": "The main title copy."
                },
                "description": {
                    "type": "string",
                    "name": "description",
                    "doc_description": "Accepts description as string. JSX.Element is also allowed in case you have anchor tags inside your richtext."
                },
                "primaryCTA": {
                    "type": "string",
                    "name": "primaryCTA"
                },
                "children": {
                    "type": "slot",
                    "name": "children"
                }
            },
            "jds_image": {
                "src": {
                    "type": "image",
                    "name": "image"
                },
                "imageFocus": {
                    "type": "JDSImage.imageFocus",
                    "name": "imageFocus"
                }
            },
            "blur-image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            },
            "jds_badge": {
                "label": {
                    "type": "string",
                    "name": "badgeLabel"
                },
                "icon": {
                    "type": "icon",
                    "name": "badgeIcon"
                }
            }
        },
        "events": {
            "root-container": {
                "onClick": "onClick"
            },
            "jds_content_block": {
                "onPrimaryClick": "onPrimaryClick"
            }
        },
        "a11y": {
            "root-container": {
                "name": "serviceCard"
            },
            "jds_content_block": {
                "properties": {
                    "primaryCtaAriaLabel": "primaryCtaAriaLabel",
                    "primaryCtaAriaDescribedby": {
                        "name": "primaryCtaAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_image": {
                "properties": {
                    "ariaLabel": "imageAriaLabel",
                    "ariaDescribedby": {
                        "name": "imageAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            },
            "jds_badge": {
                "properties": {
                    "ariaLabel": "badgeAriaLabel",
                    "ariaDescribedby": {
                        "name": "badgeAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$2 = (props)=>{
    if (typeof props.description === "object") console.warn("passing description as an element is deprecated");
    if (typeof props.image === "object") console.warn("passing image as an element is deprecated");
    return {
        image: {
            properties: {
                image: $451487d20aa3eb8a$var$resolvePropObjectKeys(props.image, "props.src", "")
            }
        },
        caption: {
            properties: {
                badgeLabel: props.caption?.label,
                badgeIcon: props.caption?.icon
            }
        },
        size: {
            defaultValue: "xxs",
            variations: {
                s: {
                    size: "small"
                },
                xs: {
                    size: "xtra-small"
                },
                xxs: {
                    size: "xtra-xtra-small"
                }
            }
        }
    };
};
const $451487d20aa3eb8a$var$withLogic$8 = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$2);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$9 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$8;
    const { size: size = "xtra-xtra-small", imageRatio: imageRatio = "wide", shadow: shadow = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrimaryClick: onPrimaryClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            size: size,
            imageRatio: imageRatio,
            shadow: shadow,
            onClick: onClick,
            onPrimaryClick: onPrimaryClick,
            ...rest
        },
        componentTag: componentTag
    }, "JDSServiceCard", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$47e19cb482b7c646 = $451487d20aa3eb8a$var$withLogic$8($451487d20aa3eb8a$var$Component$9);
$451487d20aa3eb8a$export$47e19cb482b7c646.displayName = "ServiceCard";
$451487d20aa3eb8a$export$47e19cb482b7c646.slotName = "jds_service_card";
const $451487d20aa3eb8a$var$sdl$7 = {
    "metadata": {
        "version": "1.0.0",
        "id": "slider-1.0.0",
        "name": "JDSSlider",
        "layerName": "jds_slider",
        "description": "Continuous Sliders allow the selection of a value within a given range.",
        "usage": "Use Continuous Sliders whenever it makes easy for the user to select a value within a minimum and maximum range. Sliders work best when the specific value does not matter to the user, but an approximate value is good enough."
    },
    "hierarchy": {
        "container": [
            {
                "top-container": [
                    "label-jds-text",
                    {
                        "inner-container": [
                            "value-jds-text",
                            "jds_input"
                        ]
                    }
                ]
            },
            "slider",
            {
                "bottom-container": [
                    "min-jds-text",
                    "max-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "hidden": false,
            "flex-direction": "{s_0}",
            "justify-content": "{s_1}",
            "align-items": "{s_2}",
            "width": "{s_3}",
            "gap": "{s_4}"
        },
        "top-container": {
            "hidden": false,
            "flex-direction": "{s_5}",
            "justify-content": "{s_6}",
            "align-items": "{s_7}",
            "width": "{s_8}",
            "gap": "{s_9}"
        },
        "inner-container": {
            "hidden": false,
            "height": 32,
            "align-items": "{s_12}",
            "padding-left": "{s_13}",
            "padding-right": "{s_14}",
            "border-width": "{s_15}",
            "border-color": "{s_16}",
            "border-radius": "{s_17}"
        },
        "jds_input": {
            "disabled": false,
            "hidden": true,
            "type": "number",
            "textAlign": "end",
            "rows": 1,
            "width": 93
        },
        "slider": {
            "width": "{s_18}",
            "track-height": "{s_19}",
            "inactive-color": "{s_20}",
            "active-color": "{s_21}",
            "ball-size": 20,
            "ball-color": "{s_22}",
            "ball-border-color": "{s_23}",
            "ball-border-width": 0,
            "border-radius": "{s_24}",
            "behavior": {
                "hover": {
                    "ball-color": "{s_25}"
                },
                "active": {
                    "active-color": "{s_26}",
                    "ball-color": "{s_27}"
                },
                "focus": {
                    "ball-border-width": "{s_28}"
                }
            }
        },
        "bottom-container": {
            "hidden": false,
            "show": false,
            "flex-direction": "{s_29}",
            "justify-content": "{s_30}",
            "align-items": "{s_31}",
            "width": "{s_32}"
        },
        "jds_feedback_block": {
            "size": "s",
            "hidden": true
        },
        "label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "flex": 1,
            "justify-content": "{s_10}",
            "align-items": "{s_11}",
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "value-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        },
        "min-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "max-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "_hideMinMaxLabel": {
            "true": {
                "bottom-container": {
                    "hidden": true
                }
            }
        },
        "editableTextBox": {
            "true": {
                "jds_input": {
                    "hidden": false
                },
                "value-jds-text": {
                    "hidden": true
                }
            }
        },
        "state": {
            "success": {
                "inner-container": {
                    "border-color": "{s_33}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "error": {
                "inner-container": {
                    "border-color": "{s_34}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            },
            "warning": {
                "inner-container": {
                    "border-color": "{s_35}"
                },
                "jds_feedback_block": {
                    "hidden": false
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "disabled": true,
                    "opacity": "{s_36}"
                },
                "jds_input": {
                    "disabled": true
                },
                "slider": {
                    "disabled": true,
                    "behavior": {
                        "hover": {
                            "ball-color": "{s_37}"
                        },
                        "active": {
                            "active-color": "{s_38}",
                            "ball-color": "{s_39}"
                        },
                        "focus": {
                            "ball-border-width": 0
                        }
                    }
                }
            }
        }
    },
    "combination": [
        {}
    ],
    "combination_config": [
        []
    ],
    "api": {
        "config": {
            "_hideMinMaxLabel": {
                "values": [
                    false,
                    true
                ]
            },
            "editableTextBox": {
                "values": [
                    false,
                    true
                ],
                "doc_description": " It allows user to input their own number in the text box that moves the slider value. By default this textbox is in readonly mode."
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "value": {
                    "type": "string",
                    "name": "valueSuffix",
                    "function": true
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "min": {
                    "type": "float",
                    "name": "min",
                    "function": true,
                    "doc_description": "It is minimum value for Slider."
                },
                "max": {
                    "type": "float",
                    "name": "max",
                    "function": true,
                    "doc_description": "It is maximum value for Slider."
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                }
            },
            "slider": {
                "step": {
                    "type": "number",
                    "name": "step",
                    "doc_description": "It determines number of divisions slider should slide by."
                },
                "min": {
                    "type": "float",
                    "name": "min",
                    "function": true,
                    "doc_description": "It is minimum value for Slider."
                },
                "max": {
                    "type": "float",
                    "name": "max",
                    "function": true,
                    "doc_description": "It is maximum value for Slider."
                },
                "value": {
                    "type": "float",
                    "name": "value",
                    "function": true,
                    "doc_description": "It takes user input for value of Slider."
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state"
                }
            },
            "label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Slider."
                }
            },
            "value-jds-text": {
                "value": {
                    "type": "string",
                    "name": "valueSuffix",
                    "function": true
                }
            },
            "min-jds-text": {
                "value": {
                    "type": "string",
                    "name": "labelMin"
                }
            },
            "max-jds-text": {
                "value": {
                    "type": "string",
                    "name": "labelMax"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Slider."
                }
            }
        },
        "events": {
            "slider": {
                "onChange": "onValueChange",
                "onEditChange": {
                    "name": "onEditChange",
                    "platform": "ios"
                }
            },
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onSubmit": "onSubmit",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                }
            }
        },
        "a11y": {
            "slider": {
                "name": "container",
                "properties": {
                    "role": {
                        "value": "slider"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label",
                        "function": true
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-valuenow": {
                        "name": "_ariaValuenow",
                        "prop": "value",
                        "platform": "web,ios"
                    },
                    "aria-valuemin": {
                        "name": "_ariaValuemin",
                        "prop": "min",
                        "platform": "web,ios"
                    },
                    "aria-valuemax": {
                        "name": "_ariaValuemax",
                        "prop": "max",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$PROP_MAP$1 = (props)=>({
        onChange: {
            properties: {
                onChange: props.onChange,
                onValueChange: props.onChange
            }
        }
    });
function $451487d20aa3eb8a$var$getSteppedValue(value, step = 1, min = 0, max = 100) {
    if (typeof value !== "number") return min;
    step = step > 0 ? step : 1;
    const clamped = $451487d20aa3eb8a$var$clamp(value, min, max);
    return Math.round((clamped - min) / step) * step + min;
}
const $451487d20aa3eb8a$var$clamp = (value, min, max)=>Math.max(min, Math.min(value, max));
const $451487d20aa3eb8a$var$withLogic$7 = (Component)=>(userProps)=>{
        const props = $451487d20aa3eb8a$var$modifyProps(userProps, $451487d20aa3eb8a$var$PROP_MAP$1);
        const { value: userValue = 0 } = props;
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $451487d20aa3eb8a$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig);
        const [value, setValue] = (0, $1OEoy.useState)(userValue);
        const [inputValue, setInputValue] = (0, $1OEoy.useState)(userValue);
        (0, $1OEoy.useEffect)(()=>{
            setValue(userValue);
            setInputValue(userValue);
        }, [
            userValue
        ]);
        const getSuffixValue = (value2, editable)=>{
            if (editable) return value2;
            return Intl.NumberFormat().format(value2);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                value: value,
                valueSuffix: getSuffixValue(inputValue, props.editableTextBox),
                state: inputState,
                stateText: stateText || props.stateText,
                onInvalid: onInvalid,
                label: $451487d20aa3eb8a$var$getRequiredLabel(props.label, props.required),
                max: props.max || 100,
                min: props.min || 0,
                onBlur: (ev)=>{
                    const currentValue = ev.target.value ? parseInt(ev.target.value) : value;
                    const steppedValue = $451487d20aa3eb8a$var$getSteppedValue(currentValue, props.step, props.min, props.max);
                    setValue(steppedValue);
                    const tracker = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
                    tracker?.call(ev.target, currentValue);
                    setInputValue(steppedValue);
                    props?.onChange?.({
                        ...ev,
                        target: {
                            ...ev.target,
                            value: steppedValue
                        }
                    });
                },
                onChange: (ev)=>{
                    setInputValue(parseInt(ev.target.value));
                },
                onValueChange: (ev)=>{
                    setValue(parseInt(ev.target.value));
                    setInputValue(ev.target.value);
                    props?.onChange?.(ev);
                },
                labelMin: Intl.NumberFormat().format(props.min || 0),
                labelMax: Intl.NumberFormat().format(props.max || 100)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$8 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$7;
    const { editableTextBox: editableTextBox = false, state: state = "undefined", disabled: disabled = false, onValueChange: onValueChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onEditChange: onEditChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaValuenow: _ariaValuenow = props.value?.toString(), _ariaValuemin: _ariaValuemin = props.min?.toString(), _ariaValuemax: _ariaValuemax = props.max?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            editableTextBox: editableTextBox,
            state: state,
            disabled: disabled,
            onValueChange: onValueChange,
            onEditChange: onEditChange,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onSubmit: onSubmit,
            ariaLabel: ariaLabel,
            _ariaValuenow: _ariaValuenow,
            _ariaValuemin: _ariaValuemin,
            _ariaValuemax: _ariaValuemax,
            ...rest
        },
        componentTag: componentTag
    }, "JDSSlider", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$97be854b3aad3c92 = $451487d20aa3eb8a$var$withLogic$7($451487d20aa3eb8a$var$Component$8);
$451487d20aa3eb8a$export$97be854b3aad3c92.displayName = "InputSlider";
$451487d20aa3eb8a$export$97be854b3aad3c92.slotName = "jds_slider";
const $451487d20aa3eb8a$var$sdl$6 = {
    "metadata": {
        "version": "1.0.0",
        "id": "table-1.0.0",
        "name": "JDSTable",
        "layerName": "jds_table",
        "description": "Simple tables display information in a tabular data format with rows and columns. The organize information in a way that's easy to scan so that users can look for patterns and develop insights from data.",
        "usage": "Simple tables are used on wide viewports only or whenever their layout can easily fit in the screen - not too many columns."
    },
    "hierarchy": {
        "container": [
            "jds_table_body",
            "footer-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "border-radius": "{t_2}",
            "border-width": "{t_3}",
            "border-color": "{t_4}",
            "overflow": "hidden",
            "align-items": "{t_6}"
        },
        "footer-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey100}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "padding-left": "{t_7}",
            "padding-right": "{t_8}",
            "padding-top": "{t_9}",
            "padding-bottom": "{t_10}",
            "hidden": true
        }
    },
    "variant": {
        "density": {
            "condensed": {
                "jds_table_body": {
                    "density": "condensed"
                },
                "footer-jds-text": {
                    "padding-left": "{t_11}",
                    "padding-right": "{t_12}",
                    "padding-top": "{t_13}",
                    "padding-bottom": "{t_14}"
                }
            }
        },
        "columnDivider": {
            "true": {
                "jds_table_body": {
                    "columnDivider": true
                }
            }
        },
        "fullWidth": {
            "true": {
                "container": {
                    "width": "{t_5}"
                },
                "jds_table_body": {
                    "fullWidth": true
                }
            }
        },
        "_hasFooter": {
            "true": {
                "footer-jds-text": {
                    "hidden": false
                }
            }
        }
    },
    "api": {
        "config": {
            "density": {
                "type": "JDSTableCell.density",
                "values": [
                    "relaxed",
                    "condensed"
                ]
            },
            "background": {
                "values": [
                    false,
                    true
                ]
            },
            "columnDivider": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "Show/hide border between columns."
            },
            "fullWidth": {
                "values": [
                    false,
                    true
                ]
            },
            "_hasFooter": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_table_body": {
                "rows": {
                    "name": "rows",
                    "type": "list",
                    "object": {
                        "cells": "list"
                    },
                    "doc_description": "Pass rows as an array of objects {[HEADER_NAME_1]?: , [HEADER_NAME_2]?:...}, where each row is an object where:\n- the properties are equal to header names\n- values are displayed in columns\n- properties for non-existent header.name are ignored, warning is displayed\n- missing header property results in empty column"
                },
                "zebra": {
                    "type": "boolean",
                    "name": "zebra"
                },
                "background": {
                    "type": "boolean",
                    "name": "background"
                }
            },
            "footer-jds-text": {
                "value": {
                    "type": "string",
                    "name": "footer",
                    "doc_description": "Optional text at the bottom."
                }
            }
        },
        "a11y": {
            "container": {
                "properties": {
                    "role": {
                        "value": "table"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "value": "table"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$6 = (Component)=>(props)=>{
        const isZebra = props.rowStyle === "zebra" || props.zebra;
        const rows = props.headers.map((header)=>({
                cells: [
                    {
                        text: header.value,
                        type: "header",
                        background: props.headerBackground || props.background
                    },
                    ...props.rows.map((row, i)=>({
                            text: row[header.name] || `\xa0`,
                            background: isZebra && i % 2 === 0
                        }))
                ]
            }));
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                rows: rows,
                background: Boolean(props.headerBackground),
                _hasFooter: Boolean(props.footer)
            }
        });
    };
const $451487d20aa3eb8a$var$Component$7 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$6;
    const { density: density = "undefined", background: background = false, columnDivider: columnDivider = false, fullWidth: fullWidth = false, ariaLabel: ariaLabel = "table", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            density: density,
            background: background,
            columnDivider: columnDivider,
            fullWidth: fullWidth,
            ariaLabel: ariaLabel,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTable", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$54ec01a60f47d33d = $451487d20aa3eb8a$var$withLogic$6($451487d20aa3eb8a$var$Component$7);
$451487d20aa3eb8a$export$54ec01a60f47d33d.displayName = "Table";
$451487d20aa3eb8a$export$54ec01a60f47d33d.slotName = "jds_table";
const $451487d20aa3eb8a$var$sdl$5 = {
    "metadata": {
        "version": "1.0.1",
        "id": "test-1.0.1",
        "name": "TestComponent",
        "layerName": "test_component",
        "internal": true
    },
    "hierarchy": {
        "container": [
            "heading-text",
            "icon",
            "image"
        ]
    },
    "base": {
        "container": {
            "padding-top": "50",
            "padding-right": "50",
            "padding-bottom": "50",
            "padding-left": "50",
            "background-color": "blue",
            "border-color": "",
            "border-radius": "",
            "border-width": "",
            "border-style": "",
            "height": "",
            "width": "",
            "max-height": "",
            "min-height": "",
            "max-width": "",
            "min-width": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "opacity": "",
            "align-items": "",
            "justify-content": "",
            "flex-direction": "",
            "gap": "",
            "display": "",
            "outline": "",
            "pointer-events": "",
            "cursor": "",
            "z-index": ""
        },
        "heading-text": {
            "color": "#f4f4f4",
            "align-items": "",
            "flex-direction": "",
            "font-family": "",
            "font-size": "",
            "font-weight": "",
            "gap": "",
            "justify-content": "",
            "letter-spacing": "",
            "line-height": "",
            "opacity": "",
            "outline": "",
            "padding-top": 50,
            "padding-right": 50,
            "padding-bottom": 50,
            "padding-left": 50,
            "pointer-events": "",
            "width": "",
            "z-index": "",
            "text-decoration": "",
            "text-overflow": "",
            "text-transform": ""
        },
        "icon": {
            "background-color": "",
            "color": "",
            "padding-top": 50,
            "padding-right": 50,
            "padding-bottom": 50,
            "padding-left": 50,
            "height": "24",
            "width": "24",
            "size": "{m}",
            "opacity": "",
            "outline": "",
            "justify-content": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "align-items": "",
            "box-sizing": ""
        },
        "image": {
            "align-items": "",
            "aspect-ratio": "{aspect_ratio.1.1}",
            "border-radius": "",
            "opacity": "",
            "hidden": true,
            "padding-top": "50",
            "padding-right": "50",
            "padding-bottom": "50",
            "padding-left": "50",
            "pointer-events": "",
            "box-shadow": {
                "x": 0,
                "y": 4,
                "blur": 16,
                "spread": 0,
                "color": "#00000014"
            },
            "object-fit": "",
            "object-position": ""
        }
    },
    "variant": {
        "kind": {
            "SERVICE": {
                "container": {
                    "border-radius": "{pill}",
                    "background-color": "#75757580",
                    "padding-top": "{xxs}",
                    "padding-left": "{xxs}",
                    "padding-right": "{s}",
                    "padding-bottom": "{xxs}",
                    "gap": "{xs}"
                },
                "heading-text": {
                    "appearance": "BODY_M_BOLD",
                    "color": "WHITE"
                },
                "icon": {
                    "size": "{m}",
                    "color": "{global.transparent}"
                }
            }
        }
    },
    "api": {
        "data": {
            "heading-text": {
                "value": {
                    "type": "string",
                    "name": "label"
                }
            },
            "icon": {
                "value": {
                    "type": "icon",
                    "name": "icon"
                }
            },
            "image": {
                "value": {
                    "type": "image",
                    "name": "image"
                }
            }
        },
        "config": {
            "kind": {
                "values": [
                    "NORMAL",
                    "SERVICE"
                ]
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$5 = (Component)=>(props)=>{
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...props
        });
    };
const $451487d20aa3eb8a$var$Component$6 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$5;
    const { kind: kind = "NORMAL", custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            kind: kind,
            ...rest
        },
        componentTag: componentTag
    }, "TestComponent", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$d8fd24743e1b801f = $451487d20aa3eb8a$var$withLogic$5($451487d20aa3eb8a$var$Component$6);
$451487d20aa3eb8a$export$d8fd24743e1b801f.displayName = "TestComponent";
$451487d20aa3eb8a$export$d8fd24743e1b801f.slotName = "test_component";
const $451487d20aa3eb8a$var$sdl$4 = {
    "metadata": {
        "version": "1.0.0",
        "id": "textarea-1.0.0",
        "name": "JDSTextarea",
        "layerName": "jds_textarea",
        "description": "A Textarea lets a user input a longer amount of text than an input field, typically spanning across multiple lines.",
        "usage": "Use a textarea when the input being expected is likely to extend beyond one line."
    },
    "hierarchy": {
        "container": [
            "label-border-jds-text",
            {
                "field-container": [
                    "input_label-jds-text",
                    {
                        "input-container": [
                            "input"
                        ]
                    }
                ]
            },
            {
                "active-line-container": [
                    "feedback-container"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{t_0}",
            "justify-content": "{t_1}",
            "align-items": "{t_2}",
            "gap": "{t_3}",
            "width": "{t_4}",
            "opacity": "{t_42}",
            "behavior": {
                "hover": {}
            }
        },
        "field-container": {
            "flex-direction": "{t_5}",
            "width": "{t_6}",
            "padding-bottom": "{t_7}",
            "justify-content": "{t_8}",
            "align-items": "{t_9}"
        },
        "input-container": {
            "flex-direction": "{t_10}",
            "justify-content": "{t_11}",
            "width": "{t_12}",
            "padding-top": 20,
            "align-items": "{t_13}",
            "z-index": 0
        },
        "input": {
            "disabled": false,
            "type": "textarea",
            "flex": 1,
            "text-align": "{t_14}",
            "placeholder-color": "{t_15}",
            "placeholder-font-family": "{t_16}",
            "placeholder-font-size": "{t_17}",
            "placeholder-line-height": "{t_18}",
            "placeholder-letter-spacing": "{t_19}",
            "placeholder-font-weight": "{t_20}",
            "input-color": "{t_21}",
            "input-font-family": "{t_22}",
            "input-font-size": "{t_23}",
            "input-line-height": "{t_24}",
            "input-letter-spacing": "{t_25}",
            "input-font-weight": "{t_26}",
            "resize-color": "{t_27}",
            "cursor-color": "{t_28}",
            "width": "{t_29}",
            "behavior": {
                "hover": {
                    "resize-color": "{t_30}"
                },
                "focus": {
                    "resize-color": "{t_31}"
                },
                "active": {
                    "resize-color": "{t_32}"
                }
            }
        },
        "active-line-container": {
            "flex-direction": "{t_33}",
            "width": "{t_34}",
            "align-items": "{t_35}",
            "padding-top": 1,
            "padding-bottom": 1
        },
        "feedback-container": {
            "width": "{t_36}",
            "height": 2,
            "background-color": "{t_37}",
            "border-radius": 48,
            "show": true,
            "hidden": false,
            "behavior": {
                "hover": {
                    "background-color": "{t_38}"
                },
                "focus": {
                    "background-color": "{t_39}"
                },
                "active": {
                    "background-color": "{t_40}"
                }
            }
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none"
        },
        "label-border-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "hidden": true,
            "maxLines": 1
        },
        "input_label-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1,
            "z-index": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{t_41}"
                },
                "input": {
                    "disabled": true
                }
            }
        },
        "border": {
            "true": {
                "feedback-container": {
                    "hidden": true
                },
                "input-container": {
                    "padding-top": "{t_45}"
                },
                "field-container": {
                    "border-width": "{t_43}",
                    "border-color": "{t_44}",
                    "border-radius": "{t_46}",
                    "padding-top": "{t_45}",
                    "padding-bottom": "{t_47}",
                    "padding-left": "{t_48}",
                    "padding-right": "{t_49}"
                },
                "input_label-jds-text": {
                    "hidden": true
                },
                "label-border-jds-text": {
                    "hidden": false
                }
            }
        },
        "state": {
            "success": {
                "feedback-container": {
                    "background-color": "{t_50}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_51}"
                        },
                        "focus": {
                            "background-color": "{t_52}"
                        },
                        "active": {
                            "background-color": "{t_53}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_50}"
                },
                "input": {
                    "resize-color": "{t_54}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_55}"
                        },
                        "focus": {
                            "resize-color": "{t_56}"
                        },
                        "active": {
                            "resize-color": "{t_57}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "feedback-container": {
                    "background-color": "{t_58}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_59}"
                        },
                        "focus": {
                            "background-color": "{t_60}"
                        },
                        "active": {
                            "background-color": "{t_61}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_58}"
                },
                "input": {
                    "resize-color": "{t_62}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_63}"
                        },
                        "focus": {
                            "resize-color": "{t_64}"
                        },
                        "active": {
                            "resize-color": "{t_65}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "feedback-container": {
                    "background-color": "{t_66}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_67}"
                        },
                        "focus": {
                            "background-color": "{t_68}"
                        },
                        "active": {
                            "background-color": "{t_69}"
                        }
                    }
                },
                "field-container": {
                    "border-color": "{t_66}"
                },
                "input": {
                    "resize-color": "{t_70}",
                    "behavior": {
                        "hover": {
                            "resize-color": "{t_71}"
                        },
                        "focus": {
                            "resize-color": "{t_72}"
                        },
                        "active": {
                            "resize-color": "{t_73}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "_labelFocus": {
            "true": {
                "field-container": {
                    "align-items": "{t_74}"
                },
                "input_label-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}",
                    "padding-top": 0
                }
            }
        }
    },
    "combination": [
        {
            "none": {
                "true": {
                    "feedback-container": {
                        "background-color": "{t_75}"
                    },
                    "input": {
                        "resize-color": "{t_76}"
                    }
                }
            }
        },
        {
            "true": {
                "true": {
                    "field-container": {
                        "border-color": "{t_77}"
                    },
                    "input": {
                        "input-color": "{t_79}",
                        "disabled": true,
                        "resize-color": "{t_78}",
                        "behavior": {
                            "hover": {
                                "resize-color": "{t_78}"
                            },
                            "focus": {
                                "resize-color": "{t_78}"
                            },
                            "active": {
                                "resize-color": "{t_78}"
                            }
                        }
                    }
                }
            }
        }
    ],
    "combination_config": [
        [
            "state",
            "_inputFocus"
        ],
        [
            "border",
            "readOnly"
        ]
    ],
    "api": {
        "config": {
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable SearchBox."
            },
            "border": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can change the border of textArea"
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'.",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "_labelFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "_inputFocus": {
                "values": [
                    false,
                    true
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It is used when border is set to true"
            }
        },
        "data": {
            "input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "rows": {
                    "type": "number",
                    "name": "rows"
                },
                "minLines": {
                    "type": "number",
                    "name": "minLines"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "max-length": {
                    "type": "number",
                    "name": "maxLength"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                },
                "semantics": {
                    "type": "string",
                    "name": "semantics",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                }
            },
            "label-border-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Textarea."
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Textarea."
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Textarea."
                }
            }
        },
        "events": {
            "input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            }
        },
        "a11y": {
            "input": {
                "properties": {
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-invalid": "ariaInvalid",
                    "aria-placeholder": {
                        "name": "_ariaPlaceholder",
                        "prop": "placeholder"
                    },
                    "aria-required": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$4 = (Component)=>(0, $1OEoy.forwardRef)((props, ref)=>{
        const { rootRef: rootRef, element: element } = $451487d20aa3eb8a$var$useRootRef();
        const { focused: focused, _inputFocused: _inputFocused, ...rest } = $451487d20aa3eb8a$var$useFocusedLabel(props, element);
        const { inputState: inputState, onInvalid: onInvalid, stateText: stateText } = $451487d20aa3eb8a$var$useInputState(props.state, props.required, props.onInvalid, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                ...rest,
                rootRef: rootRef,
                label: $451487d20aa3eb8a$var$getRequiredLabel(props.label, props.required),
                _labelFocus: focused,
                _inputFocus: _inputFocused,
                state: inputState,
                stateText: stateText,
                onInvalid: onInvalid,
                layerRefs: {
                    input: ref
                }
            }
        });
    });
const $451487d20aa3eb8a$var$Component$5 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$4;
    const { disabled: disabled = false, border: border = false, state: state = "undefined", readOnly: readOnly = false, onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInvalid: onInvalid = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaPlaceholder: _ariaPlaceholder = props.placeholder?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            disabled: disabled,
            border: border,
            state: state,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            ariaLabel: ariaLabel,
            _ariaPlaceholder: _ariaPlaceholder,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSTextarea", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$3d88bd58d836b21e = $451487d20aa3eb8a$var$withLogic$4($451487d20aa3eb8a$var$Component$5);
$451487d20aa3eb8a$export$3d88bd58d836b21e.displayName = "InputTextarea";
$451487d20aa3eb8a$export$3d88bd58d836b21e.slotName = "jds_textarea";
const $451487d20aa3eb8a$var$sdl$3 = {
    "metadata": {
        "version": "1.0.0",
        "id": "toggle-1.0.0",
        "name": "JDSToggle",
        "description": "Interaction element for decision making that may or may not be accompanied by a label, depending on the context of use.",
        "layerName": "jds_toggle"
    },
    "hierarchy": {
        "vertical-container": [
            {
                "horizontal-container": [
                    {
                        "prefix-icon-container": [
                            {
                                "toggle-jds-icon-container": [
                                    "toggle-jds-icon"
                                ]
                            }
                        ]
                    },
                    "left-jds-text",
                    {
                        "pill-container": [
                            "ball-container"
                        ]
                    },
                    "right-jds-text"
                ]
            },
            "jds_feedback_block",
            "helper-jds-text"
        ]
    },
    "base": {
        "vertical-container": {
            "hidden": false,
            "flex-direction": "{t_1}",
            "justify-content": "{t_2}",
            "align-items": "{t_3}",
            "gap": "{t_4}",
            "opacity": "{t_42}"
        },
        "horizontal-container": {
            "hidden": false,
            "flex-direction": "{t_5}",
            "justify-content": "{t_6}",
            "align-items": "{t_7}",
            "gap": "{t_8}",
            "behavior": {
                "hover": {},
                "active": {},
                "focus": {}
            }
        },
        "pill-container": {
            "hidden": false,
            "min-width": "{t_9}",
            "min-height": "{t_10}",
            "flex-direction": "{t_11}",
            "justify-content": "{t_12}",
            "align-items": "{t_13}",
            "padding-left": "{t_14}",
            "padding-right": "{t_15}",
            "background-color": "{t_16}",
            "border-radius": "{t_17}",
            "border-width": "{t_18}",
            "border-color": "{t_19}",
            "behavior": {
                "hover": {
                    "border-color": "{t_20}"
                },
                "active": {
                    "border-color": "{t_21}"
                },
                "focus": {
                    "border-width": "{t_24}",
                    "box-shadow": {
                        "x": 0,
                        "y": 0,
                        "blur": 0,
                        "spread": "{t_22}",
                        "color": "{t_23}"
                    }
                }
            }
        },
        "ball-container": {
            "hidden": false,
            "min-width": "{t_25}",
            "min-height": "{t_26}",
            "background-color": "{t_27}",
            "border-radius": "{t_28}",
            "show": true
        },
        "prefix-icon-container": {
            "flex-direction": "{t_0}"
        },
        "jds_feedback_block": {
            "size": "l"
        },
        "left-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false,
            "text-align": "{t_29}",
            "flex-fill-android": false,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "right-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": true,
            "behavior": {
                "hover": {
                    "color": "{primaryGrey100}"
                },
                "focus": {
                    "color": "{primaryGrey100}"
                }
            }
        },
        "toggle-jds-icon": {
            "size": "{m}",
            "color": "{primaryGrey80}"
        },
        "toggle-jds-icon-container": {
            "background-color": "{global.transparent}",
            "border-radius": "{pill}",
            "size": "{m}",
            "justify-content": "{justifyContent.center}",
            "align-items": "{alignItems.center}"
        },
        "helper-jds-text": {
            "font-family": "{bodyS}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyS}",
            "line-height": "{bodyS}",
            "letter-spacing": "{bodyS}",
            "font-weight": "{bodyS}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "hidden": false
        }
    },
    "variant": {
        "size": {
            "small": {
                "pill-container": {
                    "min-width": "{t_30}",
                    "min-height": "{t_31}"
                },
                "vertical-container": {
                    "gap": "{t_32}"
                },
                "ball-container": {
                    "min-width": "{t_33}",
                    "min-height": "{t_34}"
                },
                "jds_feedback_block": {
                    "size": "s"
                },
                "left-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "right-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                },
                "toggle-jds-icon": {
                    "size": "{base}"
                },
                "toggle-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{base}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyXs}",
                    "font-size": "{bodyXs}",
                    "line-height": "{bodyXs}",
                    "letter-spacing": "{bodyXs}",
                    "font-weight": "{bodyXs}"
                }
            }
        },
        "labelPosition": {
            "right": {
                "left-jds-text": {
                    "hidden": true
                },
                "right-jds-text": {
                    "hidden": false
                }
            }
        },
        "_hasIcon": {
            "false": {
                "prefix-icon-container": {
                    "hidden": true
                }
            }
        },
        "checked": {
            "true": {
                "pill-container": {
                    "justify-content": "{t_35}",
                    "background-color": "{t_36}",
                    "border-width": "{t_37}",
                    "behavior": {
                        "hover": {
                            "background-color": "{t_38}"
                        },
                        "active": {
                            "background-color": "{t_39}"
                        }
                    }
                },
                "ball-container": {
                    "background-color": "{t_40}"
                },
                "left-jds-text": {
                    "color": "{primaryGrey100}"
                },
                "right-jds-text": {
                    "color": "{primaryGrey100}"
                },
                "toggle-jds-icon": {},
                "toggle-jds-icon-container": {
                    "background-color": "{global.transparent}",
                    "border-radius": "{pill}",
                    "size": "{m}",
                    "justify-content": "{justifyContent.center}",
                    "align-items": "{alignItems.center}"
                }
            }
        },
        "disabled": {
            "true": {
                "horizontal-container": {
                    "disabled": true
                },
                "prefix-icon-container": {
                    "disabled": true
                },
                "vertical-container": {
                    "opacity": "{t_41}"
                }
            }
        }
    },
    "api": {
        "config": {
            "checked": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to programatically make input active/inactive."
            },
            "labelPosition": {
                "values": [
                    "left",
                    "right"
                ],
                "doc_description": "It can be used to position lable to either left or right of Toggle."
            },
            "size": {
                "values": [
                    "medium",
                    "small"
                ],
                "doc_description": "It can be used control the size of Toggle."
            },
            "disabled": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to enable or disable Toggle."
            },
            "_hasIcon": {
                "values": [
                    false,
                    true
                ],
                "doc_description": "It can be used to show or hide the prefix icon container."
            }
        },
        "data": {
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText",
                    "doc_description": "It displays message with respect to its [state] selected."
                },
                "state": {
                    "type": "JDSFeedbackBlock.state",
                    "name": "state",
                    "doc_description": "It can be used to choose between states i.e. 'success','warning','error','none'."
                }
            },
            "left-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Toggle."
                }
            },
            "right-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "doc_description": "It displays label of Toggle."
                }
            },
            "toggle-jds-icon": {
                "value": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "Take icon input for Toggle."
                },
                "ic": {
                    "type": "icon",
                    "name": "icon",
                    "doc_description": "Take icon input for Toggle."
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText",
                    "doc_description": "It displays helper text of Toggle."
                }
            }
        },
        "events": {
            "horizontal-container": {
                "onClick": "onClick"
            },
            "prefix-icon-container": {
                "onClick": "onPrefixClick"
            }
        },
        "a11y": {
            "vertical-container": {
                "properties": {
                    "role": {
                        "value": "switch"
                    },
                    "aria-label": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "aria-describedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "aria-checked": {
                        "name": "_ariaChecked",
                        "prop": "checked"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$useSwitch = (value)=>{
    const [switchState, setSwitchState] = (0, $1OEoy.useState)(false);
    (0, $1OEoy.useEffect)(()=>{
        setSwitchState(Boolean(value));
    }, [
        value
    ]);
    return {
        switchState: switchState,
        onChange: (value2)=>setSwitchState(value2)
    };
};
const $451487d20aa3eb8a$var$withLogic$3 = (Component)=>(props)=>{
        const { switchState: switchState, onChange: onChange } = $451487d20aa3eb8a$var$useSwitch(props.checked);
        const { stateText: stateText, inputState: inputState } = $451487d20aa3eb8a$var$useInputState(props.state, false, void 0, props.stateConfig, props.stateText);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                _hasIcon: Boolean(props.icon || props.prefix),
                state: inputState,
                stateText: stateText,
                icon: props.icon,
                checked: switchState,
                onClick: (ev)=>{
                    onChange?.(!switchState);
                    props.onChange?.({
                        ...ev,
                        target: {
                            ...ev.target,
                            value: props.value || "",
                            checked: !switchState
                        }
                    });
                }
            }
        });
    };
const $451487d20aa3eb8a$var$Component$4 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$3;
    const { checked: checked = false, labelPosition: labelPosition = "left", size: size = "medium", disabled: disabled = false, onClick: onClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), _ariaChecked: _ariaChecked = props.checked?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            checked: checked,
            labelPosition: labelPosition,
            size: size,
            disabled: disabled,
            onClick: onClick,
            onPrefixClick: onPrefixClick,
            ariaLabel: ariaLabel,
            _ariaChecked: _ariaChecked,
            ...rest
        },
        componentTag: componentTag
    }, "JDSToggle", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ed3c6fc36a947b6a = $451487d20aa3eb8a$var$withLogic$3($451487d20aa3eb8a$var$Component$4);
$451487d20aa3eb8a$export$ed3c6fc36a947b6a.displayName = "InputToggle";
$451487d20aa3eb8a$export$ed3c6fc36a947b6a.slotName = "jds_toggle";
const $451487d20aa3eb8a$var$sdl$2 = {
    "metadata": {
        "version": "2.0.0",
        "id": "input-field-2.0.0",
        "name": "JDSInputFieldV2",
        "layerName": "jds_input_field_v2"
    },
    "hierarchy": {
        "container": [
            {
                "label-container": [
                    "input_label-jds-text",
                    "info-slot"
                ]
            },
            {
                "input-container": [
                    "prefix-slot",
                    "jds_input",
                    "suffix-slot"
                ]
            },
            {
                "helper-container": [
                    "jds_feedback_block",
                    "helper-jds-text"
                ]
            },
            {
                "dynamic-container": [
                    "dynamic-jds-text",
                    "dynamic-jds_action_button"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{i_1}",
            "width": "{i_2}",
            "justify-content": "{i_3}",
            "align-items": "{i_4}",
            "opacity": "{i_5}",
            "gap": "{i_9}"
        },
        "label-container": {
            "flex-direction": "{i_6}",
            "justify-content": "{i_7}",
            "align-items": "{i_8}",
            "gap": "{i_9}"
        },
        "input-container": {
            "flex-direction": "{i_13}",
            "justify-content": "{i_14}",
            "align-items": "{i_15}",
            "width": "{i_16}",
            "height": "{i_17}",
            "gap": "{i_18}",
            "padding-left": "{i_19}",
            "padding-right": "{i_20}",
            "border-width": "{i_23}",
            "border-color": "{i_24}",
            "border-radius": "{i_26}",
            "behavior": {
                "hover": {
                    "border-color": "{i_27}"
                },
                "active": {
                    "border-color": "{i_28}"
                },
                "focus": {
                    "border-color": "{i_29}"
                }
            }
        },
        "jds_input": {
            "type": "text",
            "textAlign": "{i_30}",
            "rows": 1,
            "flex": "{i_31}"
        },
        "helper-container": {
            "flex-direction": "{i_32}",
            "justify-content": "{i_33}",
            "align-items": "{i_34}",
            "gap": "{i_35}"
        },
        "jds_feedback_block": {
            "size": "s",
            "state": "none",
            "alignment": "top"
        },
        "dynamic-container": {
            "flex-direction": "{i_40}",
            "justify-content": "{i_41}",
            "align-items": "{i_42}",
            "gap": "{i_36}",
            "hidden": false
        },
        "dynamic-jds_action_button": {
            "kind": "tertiary",
            "size": "small"
        },
        "input_label-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "max-lines": 1,
            "textType": "label",
            "maxLines": 1
        },
        "helper-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey80}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        },
        "dynamic-jds-text": {
            "font-family": "{bodyXs}",
            "color": "{primaryGrey60}",
            "font-size": "{bodyXs}",
            "line-height": "{bodyXs}",
            "letter-spacing": "{bodyXs}",
            "font-weight": "{bodyXs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}"
        }
    },
    "variant": {
        "_hasDynamic": {
            "false": {
                "dynamic-container": {
                    "hidden": true
                }
            }
        },
        "_noPrefix": {
            "true": {
                "input-container": {
                    "padding-left": "{i_0}"
                }
            }
        },
        "disabled": {
            "true": {
                "container": {
                    "opacity": "{i_45}",
                    "disabled": true
                },
                "jds_input": {
                    "disabled": true
                },
                "prefix-slot": {
                    "disabled": true
                },
                "suffix-slot": {
                    "disabled": true
                }
            }
        },
        "state": {
            "success": {
                "input-container": {
                    "border-color": "{i_46}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_47}"
                        },
                        "focus": {
                            "border-color": "{i_48}"
                        },
                        "active": {
                            "border-color": "{i_49}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "success"
                }
            },
            "error": {
                "input-container": {
                    "border-color": "{i_50}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_51}"
                        },
                        "focus": {
                            "border-color": "{i_52}"
                        },
                        "active": {
                            "border-color": "{i_53}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "error"
                }
            },
            "warning": {
                "input-container": {
                    "border-color": "{i_54}",
                    "behavior": {
                        "hover": {
                            "border-color": "{i_55}"
                        },
                        "focus": {
                            "border-color": "{i_56}"
                        },
                        "active": {
                            "border-color": "{i_57}"
                        }
                    }
                },
                "jds_feedback_block": {
                    "state": "warning"
                }
            }
        },
        "size": {
            "small": {
                "input-container": {
                    "height": "{i_58}"
                }
            },
            "large": {
                "input-container": {
                    "height": "{i_61}",
                    "gap": "{i_62}",
                    "padding-left": "{i_63}",
                    "padding-right": "{i_64}"
                },
                "jds_feedback_block": {
                    "size": "l"
                },
                "input_label-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                },
                "helper-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                },
                "dynamic-jds-text": {
                    "font-family": "{bodyS}",
                    "font-size": "{bodyS}",
                    "line-height": "{bodyS}",
                    "letter-spacing": "{bodyS}",
                    "font-weight": "{bodyS}"
                }
            }
        },
        "type": {
            "email": {
                "jds_input": {
                    "type": "email"
                }
            },
            "number": {
                "jds_input": {
                    "type": "number"
                }
            },
            "password": {
                "jds_input": {
                    "type": "password"
                }
            },
            "pin": {
                "jds_input": {
                    "type": "number",
                    "letterSpacing": 12,
                    "textAlign": "center"
                }
            },
            "phone": {
                "jds_input": {
                    "type": "phone"
                }
            }
        },
        "readOnly": {
            "true": {
                "jds_input": {
                    "readOnly": true,
                    "color": "primary_grey_80"
                },
                "input-container": {
                    "border-color": "{i_25}"
                }
            }
        }
    },
    "api": {
        "children": {
            "prefix-slot": {
                "name": "prefix",
                "accepts": [
                    "jds_text",
                    "jds_icon",
                    "jds_input_phone_dropdown"
                ],
                "function": true
            },
            "suffix-slot": {
                "name": "suffix",
                "accepts": [
                    "jds_button",
                    "jds_icon",
                    "jds_spinner"
                ],
                "function": true
            },
            "info-slot": {
                "name": "info",
                "accepts": [
                    "any"
                ],
                "max": 1
            }
        },
        "config": {
            "_hasDynamic": {
                "values": [
                    true,
                    false
                ]
            },
            "_noPrefix": {
                "values": [
                    true,
                    false
                ]
            },
            "state": {
                "type": "JDSFeedbackBlock.state",
                "values": [
                    "none",
                    "success",
                    "error",
                    "warning"
                ]
            },
            "size": {
                "values": [
                    "medium",
                    "small",
                    "large"
                ]
            },
            "type": {
                "values": [
                    "text",
                    "email",
                    "number",
                    "password",
                    "pin",
                    "phone"
                ]
            },
            "disabled": {
                "values": [
                    false,
                    true
                ]
            },
            "readOnly": {
                "values": [
                    false,
                    true
                ]
            }
        },
        "data": {
            "jds_input": {
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                },
                "value": {
                    "type": "string",
                    "name": "value"
                },
                "autocomplete": {
                    "type": "string",
                    "name": "autocomplete",
                    "platform": "web"
                },
                "name": {
                    "type": "string",
                    "name": "name"
                },
                "autoFocus": {
                    "type": "boolean",
                    "name": "autoFocus",
                    "platform": "web,ios"
                },
                "placeholder": {
                    "type": "string",
                    "name": "placeholder"
                },
                "maxLength": {
                    "type": "number",
                    "name": "maxLength"
                },
                "pattern": {
                    "type": "string",
                    "name": "pattern"
                },
                "required": {
                    "type": "boolean",
                    "name": "required"
                },
                "focusRequester": {
                    "type": "focusRequester",
                    "name": "focusRequester",
                    "platform": "android"
                },
                "imeAction": {
                    "type": "imeAction",
                    "name": "imeAction",
                    "platform": "android"
                },
                "capitalization": {
                    "type": "keyboardCapitalization",
                    "name": "capitalization",
                    "platform": "android"
                }
            },
            "jds_feedback_block": {
                "stateText": {
                    "type": "string",
                    "name": "stateText"
                }
            },
            "dynamic-jds_action_button": {
                "label": {
                    "type": "string",
                    "name": "dynamicButtonText"
                }
            },
            "input_label-jds-text": {
                "value": {
                    "type": "string",
                    "name": "label",
                    "function": true
                },
                "id": {
                    "type": "string",
                    "name": "id",
                    "platform": "web"
                }
            },
            "helper-jds-text": {
                "value": {
                    "type": "string",
                    "name": "helperText"
                }
            },
            "dynamic-jds-text": {
                "value": {
                    "type": "string",
                    "name": "dynamicText"
                }
            }
        },
        "events": {
            "jds_input": {
                "onFocus": "onFocus",
                "onBlur": "onBlur",
                "onChange": "onChange",
                "onKeydown": {
                    "name": "onKeydown",
                    "platform": "web"
                },
                "onInvalid": "onInvalid",
                "onSubmit": "onSubmit"
            },
            "prefix-slot": {
                "onClick": "onPrefixClick"
            },
            "suffix-slot": {
                "onClick": "onSuffixClick"
            },
            "dynamic-jds_action_button": {
                "onClick": "onButtonClick"
            }
        },
        "a11y": {
            "jds_input": {
                "properties": {
                    "ariaLabel": {
                        "name": "ariaLabel",
                        "prop": "label"
                    },
                    "ariaDescribedby": {
                        "name": "ariaDescribedby",
                        "platform": "web,ios"
                    },
                    "ariaInvalid": "ariaInvalid",
                    "ariaPlaceholder": {
                        "name": "_ariaPlaceholder"
                    },
                    "ariaRequired": {
                        "name": "_ariaRequired",
                        "prop": "required"
                    }
                }
            },
            "dynamic-jds_action_button": {
                "properties": {
                    "ariaLabel": {
                        "name": "dynamicButtonAriaLabel",
                        "prop": "dynamicButtonText"
                    },
                    "ariaDescribedby": {
                        "name": "dynamicButtonAriaDescribedby",
                        "platform": "web,ios"
                    }
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic$2 = (Component)=>(0, $1OEoy.forwardRef)((props, ref)=>{
        const handlePrefixClick = (event)=>{
            props.onPrefixClick?.(event);
        };
        const handleSuffixClick = (event)=>{
            props.onSuffixClick?.(event);
        };
        const handlephonetype = (event)=>{
            const { value: value } = event.target;
            if (props.type === "phone") {
                const filteredValue = value.replace(/[^\d+]/g, "");
                event.target.value = filteredValue;
            }
            props.onChange?.(event);
        };
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                layerRefs: {
                    input: ref
                }
            },
            prefix: $451487d20aa3eb8a$var$getIcon(props.prefix, handlePrefixClick),
            suffix: $451487d20aa3eb8a$var$getIcon(props.suffix, handleSuffixClick),
            label: $451487d20aa3eb8a$var$getRequiredLabel(props.label, props.required),
            _hasDynamic: Boolean(props.dynamicText || props.dynamicButtonText),
            _noPrefix: !props.prefix,
            onChange: handlephonetype
        });
    });
const $451487d20aa3eb8a$var$Component$3 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$2;
    const { state: state = "undefined", size: size = "medium", type: type = "text", disabled: disabled = false, readOnly: readOnly = false, onFocus: onFocus = (0, $ddff9b86434e3f59$export$8793edee2d425525), onBlur: onBlur = (0, $ddff9b86434e3f59$export$8793edee2d425525), onChange: onChange = (0, $ddff9b86434e3f59$export$8793edee2d425525), onInvalid: onInvalid = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSubmit: onSubmit = (0, $ddff9b86434e3f59$export$8793edee2d425525), onPrefixClick: onPrefixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onSuffixClick: onSuffixClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), onButtonClick: onButtonClick = (0, $ddff9b86434e3f59$export$8793edee2d425525), ariaLabel: ariaLabel = props.label?.toString(), dynamicButtonAriaLabel: dynamicButtonAriaLabel = props.dynamicButtonText?.toString(), _ariaRequired: _ariaRequired = props.required?.toString(), custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...{
            state: state,
            size: size,
            type: type,
            disabled: disabled,
            readOnly: readOnly,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            onInvalid: onInvalid,
            onSubmit: onSubmit,
            onPrefixClick: onPrefixClick,
            onSuffixClick: onSuffixClick,
            onButtonClick: onButtonClick,
            ariaLabel: ariaLabel,
            dynamicButtonAriaLabel: dynamicButtonAriaLabel,
            _ariaRequired: _ariaRequired,
            ...rest
        },
        componentTag: componentTag
    }, "JDSInputFieldV2", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$export$ac0438506784559a = $451487d20aa3eb8a$var$withLogic$2($451487d20aa3eb8a$var$Component$3);
$451487d20aa3eb8a$export$ac0438506784559a.displayName = "InputFieldV2";
$451487d20aa3eb8a$export$ac0438506784559a.slotName = "jds_input_field_v2";
const $451487d20aa3eb8a$var$PROP_MAP = (props)=>({
        color: {
            properties: {},
            variations: {
                "primary-grey-100": {
                    color: "primary_grey_100"
                },
                "primary-80": {
                    color: "primary_80"
                },
                "primary-70": {
                    color: "primary_70"
                },
                "primary-60": {
                    color: "primary_60"
                },
                "primary-50": {
                    color: "primary_50"
                },
                "primary-40": {
                    color: "primary_40"
                },
                "primary-30": {
                    color: "primary_30"
                },
                "primary-20": {
                    color: "primary_20"
                },
                "primary-inverse": {
                    color: "primary_inverse"
                },
                "primary-background": {
                    color: "primary_background"
                },
                "primary-grey-80": {
                    color: "primary_grey_80"
                },
                "primary-grey-60": {
                    color: "primary_grey_60"
                },
                "primary-grey-40": {
                    color: "primary_grey_40"
                },
                "primary-grey-20": {
                    color: "primary_grey_20"
                },
                "secondary-80": {
                    color: "secondary_80"
                },
                "secondary-70": {
                    color: "secondary_70"
                },
                "secondary-60": {
                    color: "secondary_60"
                },
                "secondary-50": {
                    color: "secondary_50"
                },
                "secondary-40": {
                    color: "secondary_40"
                },
                "secondary-30": {
                    color: "secondary_30"
                },
                "secondary-20": {
                    color: "secondary_20"
                },
                "secondary-inverse": {
                    color: "secondary_inverse"
                },
                "secondary-background": {
                    color: "secondary_background"
                },
                "secondary-grey-100": {
                    color: "secondary_grey_100"
                },
                "secondary-grey-80": {
                    color: "secondary_grey_80"
                },
                "secondary-grey-60": {
                    color: "secondary_grey_60"
                },
                "secondary-grey-40": {
                    color: "secondary_grey_40"
                },
                "secondary-grey-20": {
                    color: "secondary_grey_20"
                },
                "sparkle-80": {
                    color: "sparkle_80"
                },
                "sparkle-70": {
                    color: "sparkle_70"
                },
                "sparkle-60": {
                    color: "sparkle_60"
                },
                "sparkle-50": {
                    color: "sparkle_50"
                },
                "sparkle-40": {
                    color: "sparkle_40"
                },
                "sparkle-30": {
                    color: "sparkle_30"
                },
                "sparkle-20": {
                    color: "sparkle_20"
                },
                "sparkle-inverse": {
                    color: "sparkle_inverse"
                },
                "sparkle-background": {
                    color: "sparkle_background"
                },
                "sparkle-grey-100": {
                    color: "sparkle_grey_100"
                },
                "sparkle-grey-80": {
                    color: "sparkle_grey_80"
                },
                "SPARKLE-GREY-60": {
                    color: "sparkle_grey_60"
                },
                "sparkle-grey-40": {
                    color: "sparkle_grey_40"
                },
                "sparkle-grey-20": {
                    color: "sparkle_grey_20"
                },
                feedback_error_80: {
                    color: "feedback_error_80"
                },
                "feedback-error_50": {
                    color: "feedback_error_50"
                },
                "feedback-error-20": {
                    color: "feedback_error_20"
                },
                "feedback-warning-80": {
                    color: "feedback_warning_80"
                },
                "feedback-warning-50": {
                    color: "feedback_warning_50"
                },
                "feedback-warning-20": {
                    color: "feedback_warning_20"
                },
                "feedback-success-80": {
                    color: "feedback_success_80"
                },
                "feedback-success-50": {
                    color: "feedback_success_50"
                },
                "feedback-success-20": {
                    color: "feedback_success_20"
                },
                white: {
                    color: "white"
                },
                black: {
                    color: "black"
                },
                transparent: {
                    color: "transparent"
                }
            }
        },
        children: {
            properties: {
                text: props.children
            }
        },
        text: {
            properties: {
                text: props.text
            }
        },
        as: {
            properties: {
                textType: props.as
            }
        },
        appearance: {
            properties: {},
            variations: {
                "body-s": {
                    appearance: "body-s"
                },
                "heading-xl": {
                    appearance: "heading_xl"
                },
                "heading-l": {
                    appearance: "heading_l"
                },
                "heading-m": {
                    appearance: "heading_m"
                },
                "heading-s": {
                    appearance: "heading_s"
                },
                "heading-xs": {
                    appearance: "heading_xs"
                },
                "heading-xxs": {
                    appearance: "heading_xxs"
                },
                overline: {
                    appearance: "overline"
                },
                "body-l": {
                    appearance: "body_l"
                },
                "body-l-bold": {
                    appearance: "body_l_bold"
                },
                "body-l-link": {
                    appearance: "body_l_link"
                },
                "body-m": {
                    appearance: "body_m"
                },
                "body-m-bold": {
                    appearance: "body_m_bold"
                },
                "body-m-link": {
                    appearance: "body_m_link"
                },
                "body-s-bold": {
                    appearance: "body_s_bold"
                },
                "body-s-link": {
                    appearance: "body_s_link"
                },
                "body-xs": {
                    appearance: "body_xs"
                },
                "body-xs-bold": {
                    appearance: "body_xs_bold"
                },
                "body-xs-link": {
                    appearance: "body_xs_link"
                },
                "body-xxs": {
                    appearance: "body_xxs"
                },
                "body-xxs-bold": {
                    appearance: "body_xxs-bold"
                },
                "body-xxs-link": {
                    appearance: "body_xxs_link"
                },
                "list-title": {
                    appearance: "list_title"
                },
                button: {
                    appearance: "button"
                },
                code: {
                    appearance: "code"
                }
            }
        }
    });
const $451487d20aa3eb8a$var$Component$2 = ({ children: children, ...props })=>{
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)($451487d20aa3eb8a$var$Jdstext, {
        ...props,
        text: props.text || children
    }, "JDSText", $451487d20aa3eb8a$var$componentsMap);
};
const $451487d20aa3eb8a$export$a8a3e93435678ff9 = $451487d20aa3eb8a$var$withModifiedProps($451487d20aa3eb8a$var$Component$2, $451487d20aa3eb8a$var$PROP_MAP);
$451487d20aa3eb8a$export$a8a3e93435678ff9.defaultProps = {
    as: "h1"
};
const $451487d20aa3eb8a$var$CSSTransition = (props)=>{
    const { in: _in, appear: appear, children: children, className: className, timeout: timeout = 150, onEntered: onEntered, onExited: onExited, unmountOnExit: unmountOnExit, enter: enter, exit: exit, ...rest } = props;
    const rootPrefixedClassNames = (root, ...classList)=>$451487d20aa3eb8a$var$makeClass([
            root,
            ...classList.map((classN)=>`${root}-${classN}`)
        ]);
    const [classes, setClasses] = (0, $1OEoy.useState)(rootPrefixedClassNames(className, "initial"));
    const [status, setStatus] = (0, $1OEoy.useState)(_in ? 1 /* ENTERING */  : 3 /* EXITED */ );
    const [_appear, setAppear] = (0, $1OEoy.useState)(appear);
    (0, $1OEoy.useEffect)(()=>{
        if (_in && (appear || enter)) {
            setStatus(1 /* ENTERING */ );
            setTimeout(()=>setStatus(0 /* ENTERED */ ), timeout);
            setAppear(false);
        } else if (!_appear || exit) {
            setAppear(appear);
            setStatus(2 /* EXITING */ );
            setTimeout(()=>setStatus(3 /* EXITED */ ), timeout);
        }
        return ()=>{
            setStatus(3 /* EXITED */ );
        };
    }, [
        _in
    ]);
    (0, $1OEoy.useEffect)(()=>{
        switch(status){
            case 1 /* ENTERING */ :
                setClasses($451487d20aa3eb8a$var$makeClass([
                    className,
                    `${className}-enter`,
                    "enter-active"
                ]));
                break;
            case 0 /* ENTERED */ :
                onEntered?.(true);
                setClasses(rootPrefixedClassNames(className, "initial", "enter", "enter-done"));
                break;
            case 2 /* EXITING */ :
                setClasses(rootPrefixedClassNames(className, `exit`, "exit-active"));
                break;
            case 3 /* EXITED */ :
                onExited?.(true);
                setClasses(rootPrefixedClassNames(className, "initial", "exit", "exit-done"));
                break;
        }
    }, [
        status
    ]);
    const shouldUnMount = unmountOnExit && status === 3 /* EXITED */ ;
    return shouldUnMount ? null : (0, $1OEoy.cloneElement)(children, {
        className: $451487d20aa3eb8a$var$makeClass([
            classes,
            children.props.className
        ]),
        ...rest
    });
};
const $451487d20aa3eb8a$var$OnVisible = (props)=>{
    const { onChange: onChange, children: children, percent: percent = 50, visibleClassName: visibleClassName, wrappingElement: wrappingElement = "div", ...rest } = props;
    const [visible, setVisible] = (0, $1OEoy.useState)(false);
    const intersectionObserverRef = (0, $1OEoy.useRef)(null);
    const handleInteraction = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                onChange?.(true);
                setVisible(true);
                intersectionObserverRef?.current?.disconnect();
            }
        });
    };
    const domRef = (0, $1OEoy.useCallback)((ref)=>{
        const intersectionObserver = new IntersectionObserver(handleInteraction, {
            threshold: percent / 100
        });
        intersectionObserverRef.current = intersectionObserver;
        if (ref) intersectionObserver.observe(ref);
        return ()=>intersectionObserver.disconnect();
    }, []);
    return (0, $1OEoy.createElement)(wrappingElement, {
        ref: domRef,
        ...rest,
        className: visible ? visibleClassName : void 0
    }, children);
};
const $451487d20aa3eb8a$var$FadeOnScroll = (props)=>{
    const [isVisible, setVisible] = (0, $1OEoy.useState)(false);
    const uniqKey = props.uniqueKey || "-no-key";
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$OnVisible, {
        onChange: (val)=>{
            setVisible(val);
            props.onVisible && props.onVisible(false);
        },
        visibleClassName: "fadeup-visible",
        percent: 5,
        children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$CSSTransition, {
            in: props.enter === void 0 ? isVisible : isVisible && props.enter,
            appear: true,
            className: props.animationClass || "fadeup",
            onEntered: ()=>{
                props.onVisible && props.onVisible(true);
            },
            timeout: 150,
            ...props.transitionProps,
            children: props.children
        }, uniqKey)
    });
};
$451487d20aa3eb8a$var$FadeOnScroll.defaultProps = {
    animateClass: "fadeup"
};
const $451487d20aa3eb8a$var$Container = (0, $1OEoy.forwardRef)((props, ref)=>{
    const { padPosition: padPosition, displayOn: displayOn, animateIn: animateIn, animateNow: animateNow, layout: layout, pad: pad, as: as = "section", rounded: rounded, onVisible: onVisible, background: background, mode: mode, ...rest } = props;
    const classNames = $451487d20aa3eb8a$var$makeClass([
        props.className,
        "j-container",
        pad && `sp--${pad}`,
        (pad || padPosition) && `pd--${padPosition || "all"}`,
        layout && `l-layout--${layout}`,
        displayOn && `l-breakpoint--${displayOn}`,
        background && `bg--${background}`,
        rounded && `l-radius--${rounded}`,
        animateIn && "fadeup-initial"
    ]);
    const modeProp = {};
    if (mode) modeProp["data-mode"] = mode || "light";
    const ContainerTag = as;
    const containerDom = /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(ContainerTag, {
        ref: ref,
        ...modeProp,
        ...rest,
        className: classNames,
        children: props.children
    });
    if (!(animateIn === true || animateNow === true)) return containerDom;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$FadeOnScroll, {
        animate: animateIn,
        uniqueKey: classNames + "-" + props.id,
        onVisible: onVisible,
        enter: animateNow,
        children: containerDom
    });
});
$451487d20aa3eb8a$var$Container.defaultProps = {
    as: "section"
};
const $451487d20aa3eb8a$var$FULL_LAYOUTS = [
    "full-width"
];
const $451487d20aa3eb8a$var$VerticalAlignmentCSSCustomMapping = {
    top: "start",
    bottom: "end"
};
const $451487d20aa3eb8a$export$ce6636bfa4e9f0e8 = (props)=>{
    const { className: className, children: children, layout: layout = "1-col-even", verticalAlignment: verticalAlignment = "stretch", horizontalAlignment: horizontalAlignment = "stretch", margin: margin, marginPosition: marginPosition, ...rest } = props;
    const SLIDER_ENABLED_PANELS = [
        "2-col-overflow",
        "3-col-overflow",
        "4-col-overflow"
    ];
    const { tablet: tablet } = $451487d20aa3eb8a$var$Devices.useMedia();
    const hasSlider = SLIDER_ENABLED_PANELS.includes(layout) && tablet;
    const classes = $451487d20aa3eb8a$var$makeClass([
        className,
        $451487d20aa3eb8a$var$FULL_LAYOUTS.includes(layout) ? "l-layout--full" : "l-layout--max-width",
        "j-content-layout",
        `j-content-layout__layout-${layout}`,
        margin && `sp--${margin}`,
        margin && marginPosition && `mg--${marginPosition}`,
        hasSlider && "j-content-layout__slider"
    ]);
    const [activeIndex, setActiveIndex] = (0, $1OEoy.useState)(0);
    const styleVars = $451487d20aa3eb8a$var$setCSSVar({
        "--content-layout-horizontal-alignment": horizontalAlignment,
        "--content-layout-vertical-alignment": Object.keys($451487d20aa3eb8a$var$VerticalAlignmentCSSCustomMapping).includes(verticalAlignment) ? $451487d20aa3eb8a$var$VerticalAlignmentCSSCustomMapping[verticalAlignment] : verticalAlignment
    });
    const modifiedStyles = {
        ...props.style || {},
        ...styleVars
    };
    const contentPanelClasses = $451487d20aa3eb8a$var$makeClass([
        "j-content-layout-panel"
    ]);
    const GAP_SIZE = 16;
    const TOUCH_THRESHOLD = 20;
    const touchRef = (0, $1OEoy.useRef)({
        start: 0,
        end: 0,
        id: 0
    });
    const contentLayoutRef = (0, $1OEoy.useRef)(null);
    const moveToPanel = (scrollValue)=>{
        const currentActiveIndex = touchRef.current.id >= 0 ? touchRef.current.id : 0;
        Array.from(contentLayoutRef.current?.children || []).forEach((item)=>{
            item.style.transform = "translateX(-" + scrollValue + "px)";
        });
        setActiveIndex(currentActiveIndex);
    };
    const handlePointerStart = (e)=>{
        if (hasSlider) touchRef.current.start = e.clientX;
    };
    const getScrolledValue = (panelItemIndex)=>{
        let totalScrolled = 0;
        const items = Array.from(contentLayoutRef.current?.children || []);
        const panelIndexDifference = Math.abs(touchRef.current.id - panelItemIndex);
        items.length = panelItemIndex > 0 ? panelIndexDifference === 0 ? panelItemIndex : panelItemIndex - panelIndexDifference : 0;
        items.forEach((_, elIndex)=>{
            totalScrolled = totalScrolled + items[elIndex].offsetWidth + GAP_SIZE;
        });
        return totalScrolled;
    };
    const handlePointerMove = (ev)=>{
        if (hasSlider && touchRef.current.start) {
            touchRef.current.end = ev.clientX;
            if (ev.cancelable) ev.preventDefault();
            const touchDistance = touchRef.current.end - touchRef.current.start;
            const panelItemIndex = parseInt(ev.currentTarget.getAttribute("data-index") || "0");
            const totalScrolled = getScrolledValue(panelItemIndex);
            const scrollValue = totalScrolled + -1 * touchDistance;
            moveToPanel(scrollValue);
        }
    };
    const handlePointerEnd = (ev)=>{
        if (hasSlider && touchRef.current.end) {
            const touchDistance = touchRef.current.end - touchRef.current.start;
            const childItemsLength = contentLayoutRef.current?.children.length || 0;
            const touchDistancePercent = 100 / ev.currentTarget.offsetWidth * Math.abs(touchDistance);
            let nextPanelID = touchRef.current.id < 0 ? 1 : touchRef.current.id;
            if (touchDistancePercent > TOUCH_THRESHOLD) nextPanelID += touchDistance < 0 ? 1 : -1;
            nextPanelID = nextPanelID >= childItemsLength ? nextPanelID - 1 : nextPanelID;
            touchRef.current.start = 0;
            slideToPanel(nextPanelID);
        }
    };
    const handlePointerOut = ()=>{
        touchRef.current.start = 0;
        slideToPanel(touchRef.current.id);
        touchRef.current.end = 0;
    };
    const slideToPanel = (index)=>{
        touchRef.current.id = index;
        const scrollValue = getScrolledValue(index);
        moveToPanel(scrollValue);
    };
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                ...rest,
                ref: contentLayoutRef,
                className: classes,
                style: modifiedStyles,
                children: (0, $1OEoy.Children).map(children, (child, index)=>/* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                        onPointerDown: handlePointerStart,
                        onPointerUp: handlePointerEnd,
                        onPointerMove: handlePointerMove,
                        onPointerOut: handlePointerOut,
                        "data-index": index,
                        className: contentPanelClasses,
                        children: child
                    }))
            }),
            hasSlider && /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$Container, {
                className: "pagination__wrapper",
                layout: "centered",
                pad: "xs",
                padPosition: "vertical",
                children: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$CarouselPagination, {
                    clickable: true,
                    onDotClick: slideToPanel,
                    count: (0, $1OEoy.Children).count(children),
                    selectedIndex: activeIndex
                })
            })
        ]
    });
};
$451487d20aa3eb8a$export$ce6636bfa4e9f0e8.defaultProps = {
    layout: "1-col-even",
    horizontalAlignment: "stretch",
    verticalAlignment: "stretch",
    margin: "layout"
};
const $451487d20aa3eb8a$export$ef2184bd89960b14 = (props)=>{
    const { template: template, templateTablet: templateTablet, templateMobile: templateMobile, gap: gap, align: align, justify: justify, ...rest } = props;
    const classNames = $451487d20aa3eb8a$var$makeClass([
        props.className,
        "j-grid"
    ]);
    const styleVars = $451487d20aa3eb8a$var$setCSSVar({
        "--grid-template": template,
        "--grid-template-tablet": templateTablet,
        "--grid-template-mobile": templateMobile || templateTablet,
        "--grid-gap": gap,
        "--grid-align": align,
        "--grid-justify": justify
    });
    const modifiedStyles = Object.assign(props.style || {}, styleVars);
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        ...rest,
        className: classNames,
        style: modifiedStyles,
        children: props.children
    });
};
$451487d20aa3eb8a$export$ef2184bd89960b14.defaultProps = {
    template: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "var(--spacing-base)",
    align: "center"
};
const $451487d20aa3eb8a$var$Horizontal = (props)=>/* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$eef1e68107c58ef2, {
        ...props,
        direction: "horizontal"
    });
const $451487d20aa3eb8a$var$Vertical = (props)=>/* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$export$eef1e68107c58ef2, {
        ...props,
        direction: "vertical"
    });
const $451487d20aa3eb8a$export$eef1e68107c58ef2 = (props)=>{
    const { className: className, value: value, direction: direction, ...rest } = props;
    const classes = $451487d20aa3eb8a$var$makeClass([
        className,
        value && `sp--${value}`,
        direction === "horizontal" ? "pd--right" : "pd--bottom",
        `j-Space__${direction}`,
        "j-Space"
    ]);
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("span", {
        className: classes,
        ...rest
    });
};
$451487d20aa3eb8a$export$eef1e68107c58ef2.H = $451487d20aa3eb8a$var$Horizontal;
$451487d20aa3eb8a$export$eef1e68107c58ef2.V = $451487d20aa3eb8a$var$Vertical;
$451487d20aa3eb8a$export$eef1e68107c58ef2.displayName = "Space";
$451487d20aa3eb8a$export$eef1e68107c58ef2.defaultProps = {
    direction: "vertical",
    value: "s"
};
const $451487d20aa3eb8a$var$sdl$1 = {
    "metadata": {
        "version": "1.0.0",
        "id": "horizontal-stepper-1.0.0",
        "name": "JDSHorizontalStepper",
        "layerName": "jds_horizontal_stepper"
    },
    "hierarchy": {
        "container": [
            {
                "step-indicator-container": [
                    "jds_step_item_horizontal"
                ]
            },
            {
                "stepper-children-container": [
                    "stepper-content-slot"
                ]
            }
        ]
    },
    "base": {
        "container": {
            "gap": "{h_0}",
            "flex-direction": "{h_1}",
            "size": "{h_2}"
        },
        "step-indicator-container": {
            "flex-direction": "{h_3}",
            "justify-content": "{h_4}",
            "align-items": "{h_5}",
            "size": "{h_6}",
            "padding-left": "{h_7}",
            "padding-right": "{h_8}"
        },
        "jds_step_item_horizontal": {
            "flex": 1
        },
        "stepper-children-container": {
            "size": "{h_9}",
            "flex-direction": "{h_10}",
            "justify-content": "{h_11}",
            "align-items": "{h_12}",
            "enter-animation-name": "slideHorizontallyToRight",
            "exit-animation-name": "slideHorizontallyToLeft",
            "enter-animation-curve": "entrance_ease",
            "exit-animation-curve": "exit_ease",
            "enter-animation-duration": 500,
            "exit-animation-duration": 500
        }
    },
    "api": {
        "data": {
            "container": {
                "max-width": {
                    "name": "maxWidth",
                    "type": "size"
                }
            },
            "step-indicator-container": {
                "value": {
                    "name": "stepItems",
                    "type": "list",
                    "object": {
                        "state": "JDSStepperDot.state",
                        "label": "string",
                        "index": "string",
                        "icon": "icon",
                        "activeState": "JDSStepperDot.activeState",
                        "direction": "JDSHorizontalStepItem.direction"
                    }
                }
            },
            "jds_step_item_horizontal": {
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "stepItems.state"
                },
                "label": {
                    "type": "string",
                    "name": "stepItems.label"
                },
                "index": {
                    "type": "string",
                    "name": "stepItems.index"
                },
                "icon": {
                    "type": "icon",
                    "name": "stepItems.icon"
                },
                "direction": {
                    "type": "JDSHorizontalStepItem.direction",
                    "name": "stepItems.direction"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "stepItems.activeState"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                }
            }
        },
        "children": {
            "stepper-content-slot": {
                "name": "content",
                "accepts": [
                    "template"
                ],
                "max": 1
            }
        },
        "a11y": {
            "step-indicator-container": {
                "name": "stepItems",
                "repeating": {
                    "ariaLabel": "stepItemAriaLabel",
                    "ariaCurrent": "_ariaCurrent"
                },
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            },
            "jds_step_item_horizontal": {
                "properties": {
                    "ariaLabel": "stepItems.stepItemAriaLabel",
                    "ariaCurrent": "stepItems._ariaCurrent"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$AnimatedStepItem = ({ children: children, show: show, animateState: animateState })=>{
    const { className: className } = $451487d20aa3eb8a$var$useTransition(Boolean(show));
    if (!show) return null;
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: [
            className,
            "animate-step-item",
            animateState
        ].join(" "),
        children: children
    });
};
const $451487d20aa3eb8a$var$getCompletedStepItems = (stepItems)=>{
    const filteredList = stepItems.filter((item)=>item.complete);
    if (!filteredList.length) return [
        -1
    ];
    return filteredList.map((_, i)=>i);
};
const $451487d20aa3eb8a$var$getState = (idx, stepItems, completedList)=>{
    if (stepItems[idx]?.disabled) return "disabled";
    if (completedList.includes(idx)) return "complete";
    const activeItems = stepItems.findIndex((t, i)=>!completedList.includes(i) && !t.disabled);
    return activeItems === idx ? "active" : "inactive";
};
const $451487d20aa3eb8a$var$useStepper = (props, stepperRef)=>{
    const { children: children, onActiveChange: onActiveChange, onComplete: onComplete, orientation: orientation } = props;
    const stepItems = children.map((c)=>c.props);
    const [animateState, setAnimateState] = (0, $1OEoy.useState)("next");
    const [completedList, setCompletedList] = (0, $1OEoy.useState)($451487d20aa3eb8a$var$getCompletedStepItems(stepItems));
    const completeIndex = completedList.sort()[completedList.length - 1];
    (0, $1OEoy.useImperativeHandle)(stepperRef, ()=>({
            next: ()=>{
                const nextIndex = completeIndex === stepItems.length ? stepItems.length - 1 : completeIndex + 1;
                const actualIndex = stepItems[nextIndex].disabled ? nextIndex + 1 : nextIndex;
                setCompletedList([
                    ...completedList,
                    actualIndex
                ]);
                stepItems?.[completeIndex]?.onComplete?.();
                onActiveChange?.(actualIndex);
                setAnimateState("next");
                if (nextIndex === stepItems.length - 1) onComplete?.();
            },
            prev: ()=>{
                const prevIndex = completeIndex === stepItems.length - 1 ? [
                    completeIndex,
                    completeIndex - 1
                ] : [
                    completeIndex
                ];
                const currentList = completedList.filter((t)=>!prevIndex.includes(t));
                setCompletedList(currentList);
                setAnimateState("prev");
            }
        }), [
        completeIndex,
        completedList,
        stepItems,
        onActiveChange,
        onComplete
    ]);
    const updatedStepItems = stepItems.map((item, i)=>{
        const direction = i === 0 || orientation === "vertical" && i !== stepItems.length - 1 ? "end" : i === stepItems.length - 1 ? "start" : "both";
        const state = $451487d20aa3eb8a$var$getState(i, stepItems, completedList);
        return {
            ...item,
            content: item.children,
            itemsType: props.itemsType,
            icon: item.activeState === "warning" ? void 0 : item.icon,
            _compeleteDivider: i >= completeIndex && orientation === "horizontal",
            direction: direction,
            index: i + 1,
            state: state,
            _ariaCurrent: state === "active" ? "step" : void 0
        };
    });
    return {
        stepItems: updatedStepItems,
        completeIndex: completeIndex,
        animateState: animateState
    };
};
const $451487d20aa3eb8a$var$withLogic$1 = (Component)=>(0, $1OEoy.forwardRef)((props, stepperRef)=>{
        const { stepItems: stepItems, animateState: animateState } = $451487d20aa3eb8a$var$useStepper(props, stepperRef);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                stepItems: stepItems,
                content: /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                    children: stepItems.map((item, i)=>/* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$AnimatedStepItem, {
                            animateState: animateState,
                            show: item.state === "active",
                            children: item.children
                        }, i))
                })
            }
        });
    });
const $451487d20aa3eb8a$var$Component$1 = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl$1;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSHorizontalStepper", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$HorizontalStepper = $451487d20aa3eb8a$var$withLogic$1($451487d20aa3eb8a$var$Component$1);
$451487d20aa3eb8a$var$HorizontalStepper.displayName = "HorizontalStepper";
$451487d20aa3eb8a$var$HorizontalStepper.slotName = "jds_horizontal_stepper";
const $451487d20aa3eb8a$export$3ced97e5087256a2 = (props)=>null;
const $451487d20aa3eb8a$var$sdl = {
    "metadata": {
        "version": "1.0.0",
        "id": "vertical-stepper-1.0.0",
        "name": "JDSVerticalStepper",
        "layerName": "jds_vertical_stepper"
    },
    "hierarchy": {
        "container": [
            "jds_step_item_vertical"
        ]
    },
    "base": {
        "container": {
            "flex-direction": "{v_0}",
            "justify-content": "{v_1}",
            "align-items": "{v_2}",
            "size": "{v_3}",
            "gap": "{v_4}"
        },
        "label-jds-text": {
            "font-family": "{headingXxs}",
            "color": "{primaryGrey100}",
            "font-size": "{headingXxs}",
            "line-height": "{headingXxs}",
            "letter-spacing": "{headingXxs}",
            "font-weight": "{headingXxs}",
            "text-decoration": "{text-decoration.none}",
            "text-transform": "{text-case.none}",
            "language": "en",
            "padding-top": 0
        }
    },
    "api": {
        "data": {
            "container": {
                "value": {
                    "type": "list",
                    "name": "stepItems",
                    "object": {
                        "state": "JDSStepperDot.state",
                        "label": "string",
                        "index": "string",
                        "icon": "icon",
                        "direction": "JDSVerticalStepItem.direction",
                        "content": "template",
                        "activeState": "JDSStepperDot.activeState"
                    }
                },
                "max-width": {
                    "name": "maxWidth",
                    "type": "size"
                }
            },
            "jds_step_item_vertical": {
                "state": {
                    "type": "JDSStepperDot.state",
                    "name": "stepItems.state"
                },
                "label": {
                    "type": "string",
                    "name": "stepItems.label"
                },
                "index": {
                    "type": "string",
                    "name": "stepItems.index"
                },
                "icon": {
                    "type": "icon",
                    "name": "stepItems.icon"
                },
                "direction": {
                    "type": "JDSVerticalStepItem.direction",
                    "name": "stepItems.direction"
                },
                "content": {
                    "type": "template",
                    "name": "stepItems.content"
                },
                "activeState": {
                    "type": "JDSStepperDot.activeState",
                    "name": "stepItems.activeState"
                },
                "itemsType": {
                    "type": "JDSStepperDot.itemsType",
                    "name": "itemsType"
                }
            }
        },
        "a11y": {
            "container": {
                "name": "stepItems",
                "repeating": {
                    "ariaLabel": "stepItemAriaLabel",
                    "ariaCurrent": "_ariaCurrent"
                },
                "properties": {
                    "role": {
                        "value": "list"
                    }
                }
            },
            "jds_step_item_vertical": {
                "properties": {
                    "ariaLabel": "stepItems.stepItemAriaLabel",
                    "ariaCurrent": "stepItems._ariaCurrent"
                }
            }
        }
    }
};
const $451487d20aa3eb8a$var$withLogic = (Component)=>(0, $1OEoy.forwardRef)((props, stepperRef)=>{
        const { stepItems: stepItems } = $451487d20aa3eb8a$var$useStepper(props, stepperRef);
        return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)(Component, {
            ...{
                ...props,
                stepItems: stepItems
            }
        });
    });
const $451487d20aa3eb8a$var$Component = (props)=>{
    (0, $ddff9b86434e3f59$export$f34d637a75323a1e)();
    const componentTag = "undefined";
    const json = $451487d20aa3eb8a$var$sdl;
    const { custom: custom = "", ...rest } = props;
    return (0, $ddff9b86434e3f59$export$60e54eaca7e7fb38)(json, {
        ...rest,
        componentTag: componentTag
    }, "JDSVerticalStepper", $451487d20aa3eb8a$var$componentsMap, (0, $ddff9b86434e3f59$export$d72eddc0980b68c9)(custom || "") || {});
};
const $451487d20aa3eb8a$var$VerticalStepper = $451487d20aa3eb8a$var$withLogic($451487d20aa3eb8a$var$Component);
$451487d20aa3eb8a$var$VerticalStepper.displayName = "VerticalStepper";
$451487d20aa3eb8a$var$VerticalStepper.slotName = "jds_vertical_stepper";
const $451487d20aa3eb8a$export$ed8ca599049e8881 = (0, $1OEoy.forwardRef)(({ orientation: orientation, ...rest }, ref)=>{
    if (orientation === "vertical") return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$VerticalStepper, {
        ...rest,
        ref: ref,
        orientation: "vertical"
    });
    if (orientation === "auto") {
        const isVertical = $451487d20aa3eb8a$var$Devices.isMobile() && rest.children?.length > 6;
        if (isVertical) return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$VerticalStepper, {
            ref: ref,
            ...rest,
            orientation: "vertical"
        });
    }
    return /* @__PURE__ */ (0, $7a9adcfb845e594f$exports.jsx)($451487d20aa3eb8a$var$HorizontalStepper, {
        ...rest,
        ref: ref,
        orientation: "horizontal"
    });
});
const $451487d20aa3eb8a$export$c13f210c706eb549 = (props)=>null;
const $451487d20aa3eb8a$export$36ba2f559d49a8f6 = {
    nudge: $451487d20aa3eb8a$var$nudge,
    toast: $451487d20aa3eb8a$var$toast,
    Container: $451487d20aa3eb8a$var$NotificationContainer,
    Banner: $451487d20aa3eb8a$var$NotificationBanner
};



parcelRequire("1OEoy");
/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1OEoy = parcelRequire("1OEoy");
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e87dbc164c36d527$var$_extends() {
    return $e87dbc164c36d527$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e87dbc164c36d527$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e87dbc164c36d527$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e87dbc164c36d527$export$e19cd5f9376f8cee || ($e87dbc164c36d527$export$e19cd5f9376f8cee = {}));
const $e87dbc164c36d527$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e87dbc164c36d527$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e87dbc164c36d527$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e87dbc164c36d527$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e87dbc164c36d527$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e87dbc164c36d527$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e87dbc164c36d527$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e87dbc164c36d527$export$fe53371bee54353d(to);
    }
    return $e87dbc164c36d527$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e87dbc164c36d527$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e87dbc164c36d527$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e87dbc164c36d527$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e87dbc164c36d527$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e87dbc164c36d527$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e87dbc164c36d527$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e87dbc164c36d527$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e87dbc164c36d527$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e87dbc164c36d527$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e87dbc164c36d527$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e87dbc164c36d527$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e87dbc164c36d527$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e87dbc164c36d527$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e87dbc164c36d527$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e87dbc164c36d527$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e87dbc164c36d527$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e87dbc164c36d527$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Push;
        let location = $e87dbc164c36d527$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e87dbc164c36d527$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e87dbc164c36d527$export$e19cd5f9376f8cee.Replace;
        let location = $e87dbc164c36d527$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e87dbc164c36d527$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e87dbc164c36d527$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e87dbc164c36d527$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e87dbc164c36d527$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e87dbc164c36d527$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e87dbc164c36d527$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e87dbc164c36d527$var$ResultType || ($e87dbc164c36d527$var$ResultType = {}));
const $e87dbc164c36d527$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e87dbc164c36d527$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e87dbc164c36d527$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e87dbc164c36d527$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e87dbc164c36d527$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($e87dbc164c36d527$var$isIndexRoute(route)) {
            let indexRoute = $e87dbc164c36d527$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e87dbc164c36d527$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e87dbc164c36d527$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $e87dbc164c36d527$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $e87dbc164c36d527$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $e87dbc164c36d527$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e87dbc164c36d527$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e87dbc164c36d527$var$flattenRoutes(routes);
    $e87dbc164c36d527$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $e87dbc164c36d527$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $e87dbc164c36d527$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $e87dbc164c36d527$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e87dbc164c36d527$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e87dbc164c36d527$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e87dbc164c36d527$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e87dbc164c36d527$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $e87dbc164c36d527$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e87dbc164c36d527$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e87dbc164c36d527$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e87dbc164c36d527$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e87dbc164c36d527$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e87dbc164c36d527$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e87dbc164c36d527$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e87dbc164c36d527$var$paramRe = /^:[\w-]+$/;
const $e87dbc164c36d527$var$dynamicSegmentValue = 3;
const $e87dbc164c36d527$var$indexRouteValue = 2;
const $e87dbc164c36d527$var$emptySegmentValue = 1;
const $e87dbc164c36d527$var$staticSegmentValue = 10;
const $e87dbc164c36d527$var$splatPenalty = -2;
const $e87dbc164c36d527$var$isSplat = (s)=>s === "*";
function $e87dbc164c36d527$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e87dbc164c36d527$var$isSplat)) initialScore += $e87dbc164c36d527$var$splatPenalty;
    if (index) initialScore += $e87dbc164c36d527$var$indexRouteValue;
    return segments.filter((s)=>!$e87dbc164c36d527$var$isSplat(s)).reduce((score, segment)=>score + ($e87dbc164c36d527$var$paramRe.test(segment) ? $e87dbc164c36d527$var$dynamicSegmentValue : segment === "" ? $e87dbc164c36d527$var$emptySegmentValue : $e87dbc164c36d527$var$staticSegmentValue), initialScore);
}
function $e87dbc164c36d527$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e87dbc164c36d527$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e87dbc164c36d527$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $e87dbc164c36d527$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e87dbc164c36d527$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e87dbc164c36d527$export$a5c6d149b50c1d86($e87dbc164c36d527$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e87dbc164c36d527$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $e87dbc164c36d527$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e87dbc164c36d527$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e87dbc164c36d527$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $e87dbc164c36d527$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e87dbc164c36d527$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e87dbc164c36d527$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e87dbc164c36d527$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e87dbc164c36d527$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e87dbc164c36d527$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e87dbc164c36d527$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $e87dbc164c36d527$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $e87dbc164c36d527$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $e87dbc164c36d527$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $e87dbc164c36d527$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $e87dbc164c36d527$var$normalizeSearch(search),
        hash: $e87dbc164c36d527$var$normalizeHash(hash)
    };
}
function $e87dbc164c36d527$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e87dbc164c36d527$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e87dbc164c36d527$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e87dbc164c36d527$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e87dbc164c36d527$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e87dbc164c36d527$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e87dbc164c36d527$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e87dbc164c36d527$var$_extends({}, toArg);
        $e87dbc164c36d527$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e87dbc164c36d527$var$getInvalidPathError("?", "pathname", "search", to));
        $e87dbc164c36d527$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e87dbc164c36d527$var$getInvalidPathError("#", "pathname", "hash", to));
        $e87dbc164c36d527$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e87dbc164c36d527$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e87dbc164c36d527$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e87dbc164c36d527$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $e87dbc164c36d527$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e87dbc164c36d527$export$86d9a7913e44197e = (paths)=>$e87dbc164c36d527$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $e87dbc164c36d527$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e87dbc164c36d527$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e87dbc164c36d527$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $e87dbc164c36d527$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e87dbc164c36d527$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e87dbc164c36d527$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $e87dbc164c36d527$export$4051a07651545597(data, init) {
    return new $e87dbc164c36d527$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $e87dbc164c36d527$export$42a99a7a4bc0e76a extends Error {
}
class $e87dbc164c36d527$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e87dbc164c36d527$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e87dbc164c36d527$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e87dbc164c36d527$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e87dbc164c36d527$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e87dbc164c36d527$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e87dbc164c36d527$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e87dbc164c36d527$var$unwrapTrackedPromise(value) {
    if (!$e87dbc164c36d527$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $e87dbc164c36d527$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e87dbc164c36d527$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e87dbc164c36d527$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e87dbc164c36d527$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e87dbc164c36d527$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e87dbc164c36d527$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e87dbc164c36d527$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $e87dbc164c36d527$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e87dbc164c36d527$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e87dbc164c36d527$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e87dbc164c36d527$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e87dbc164c36d527$var$validMutationMethods = new Set($e87dbc164c36d527$var$validMutationMethodsArr);
const $e87dbc164c36d527$var$validRequestMethodsArr = [
    "get",
    ...$e87dbc164c36d527$var$validMutationMethodsArr
];
const $e87dbc164c36d527$var$validRequestMethods = new Set($e87dbc164c36d527$var$validRequestMethodsArr);
const $e87dbc164c36d527$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e87dbc164c36d527$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e87dbc164c36d527$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e87dbc164c36d527$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e87dbc164c36d527$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e87dbc164c36d527$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e87dbc164c36d527$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e87dbc164c36d527$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e87dbc164c36d527$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e87dbc164c36d527$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e87dbc164c36d527$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e87dbc164c36d527$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $e87dbc164c36d527$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $e87dbc164c36d527$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e87dbc164c36d527$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e87dbc164c36d527$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e87dbc164c36d527$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$e87dbc164c36d527$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$e87dbc164c36d527$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e87dbc164c36d527$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $e87dbc164c36d527$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e87dbc164c36d527$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e87dbc164c36d527$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e87dbc164c36d527$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e87dbc164c36d527$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e87dbc164c36d527$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e87dbc164c36d527$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e87dbc164c36d527$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e87dbc164c36d527$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e87dbc164c36d527$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e87dbc164c36d527$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e87dbc164c36d527$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e87dbc164c36d527$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e87dbc164c36d527$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e87dbc164c36d527$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e87dbc164c36d527$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e87dbc164c36d527$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e87dbc164c36d527$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e87dbc164c36d527$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e87dbc164c36d527$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e87dbc164c36d527$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e87dbc164c36d527$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e87dbc164c36d527$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e87dbc164c36d527$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $e87dbc164c36d527$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $e87dbc164c36d527$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e87dbc164c36d527$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e87dbc164c36d527$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e87dbc164c36d527$var$findNearestBoundary(matches).route.id,
            {
                type: $e87dbc164c36d527$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e87dbc164c36d527$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($e87dbc164c36d527$var$isErrorResult(result) && $e87dbc164c36d527$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e87dbc164c36d527$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $e87dbc164c36d527$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e87dbc164c36d527$var$_extends({
            matches: updatedMatches || matches
        }, $e87dbc164c36d527$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e87dbc164c36d527$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e87dbc164c36d527$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $e87dbc164c36d527$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $e87dbc164c36d527$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $e87dbc164c36d527$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e87dbc164c36d527$var$ResultType.error,
            error: $e87dbc164c36d527$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e87dbc164c36d527$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e87dbc164c36d527$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e87dbc164c36d527$var$isDeferredResult(result)) throw $e87dbc164c36d527$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e87dbc164c36d527$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e87dbc164c36d527$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $e87dbc164c36d527$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e87dbc164c36d527$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e87dbc164c36d527$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($e87dbc164c36d527$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $e87dbc164c36d527$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e87dbc164c36d527$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e87dbc164c36d527$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e87dbc164c36d527$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e87dbc164c36d527$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $e87dbc164c36d527$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e87dbc164c36d527$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $e87dbc164c36d527$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e87dbc164c36d527$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$e87dbc164c36d527$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $e87dbc164c36d527$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e87dbc164c36d527$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e87dbc164c36d527$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $e87dbc164c36d527$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e87dbc164c36d527$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e87dbc164c36d527$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e87dbc164c36d527$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $e87dbc164c36d527$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e87dbc164c36d527$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e87dbc164c36d527$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e87dbc164c36d527$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $e87dbc164c36d527$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e87dbc164c36d527$var$isRedirectResult(actionResult) || $e87dbc164c36d527$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e87dbc164c36d527$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e87dbc164c36d527$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e87dbc164c36d527$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e87dbc164c36d527$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e87dbc164c36d527$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e87dbc164c36d527$var$isDeferredResult(actionResult)) throw $e87dbc164c36d527$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e87dbc164c36d527$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e87dbc164c36d527$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e87dbc164c36d527$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e87dbc164c36d527$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e87dbc164c36d527$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e87dbc164c36d527$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e87dbc164c36d527$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $e87dbc164c36d527$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e87dbc164c36d527$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e87dbc164c36d527$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e87dbc164c36d527$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e87dbc164c36d527$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e87dbc164c36d527$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $e87dbc164c36d527$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $e87dbc164c36d527$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $e87dbc164c36d527$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e87dbc164c36d527$var$isDeferredResult(result)) result = await $e87dbc164c36d527$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e87dbc164c36d527$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e87dbc164c36d527$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e87dbc164c36d527$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e87dbc164c36d527$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e87dbc164c36d527$export$3e9cee6b33872309(!$e87dbc164c36d527$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e87dbc164c36d527$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e87dbc164c36d527$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e87dbc164c36d527$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $e87dbc164c36d527$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e87dbc164c36d527$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e87dbc164c36d527$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $e87dbc164c36d527$export$e19cd5f9376f8cee.Replace : $e87dbc164c36d527$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e87dbc164c36d527$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e87dbc164c36d527$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e87dbc164c36d527$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e87dbc164c36d527$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e87dbc164c36d527$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $e87dbc164c36d527$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $e87dbc164c36d527$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($e87dbc164c36d527$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $e87dbc164c36d527$var$ResultType.redirect,
                response: $e87dbc164c36d527$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $e87dbc164c36d527$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $e87dbc164c36d527$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $e87dbc164c36d527$var$ResultType.error,
                    error: $e87dbc164c36d527$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $e87dbc164c36d527$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $e87dbc164c36d527$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e87dbc164c36d527$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $e87dbc164c36d527$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e87dbc164c36d527$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e87dbc164c36d527$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e87dbc164c36d527$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e87dbc164c36d527$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e87dbc164c36d527$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e87dbc164c36d527$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e87dbc164c36d527$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $e87dbc164c36d527$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $e87dbc164c36d527$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e87dbc164c36d527$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e87dbc164c36d527$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $e87dbc164c36d527$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $e87dbc164c36d527$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $e87dbc164c36d527$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $e87dbc164c36d527$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $e87dbc164c36d527$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e87dbc164c36d527$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $e87dbc164c36d527$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e87dbc164c36d527$export$4d0306f8f6a4585b = Symbol("deferred");
function $e87dbc164c36d527$export$3336b097a6fbc59a(routes, opts) {
    $e87dbc164c36d527$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e87dbc164c36d527$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e87dbc164c36d527$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e87dbc164c36d527$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e87dbc164c36d527$var$createLocation("", $e87dbc164c36d527$export$fe53371bee54353d(url), null, "default");
        let matches = $e87dbc164c36d527$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e87dbc164c36d527$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e87dbc164c36d527$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e87dbc164c36d527$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e87dbc164c36d527$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e87dbc164c36d527$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e87dbc164c36d527$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e87dbc164c36d527$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e87dbc164c36d527$var$createLocation("", $e87dbc164c36d527$export$fe53371bee54353d(url), null, "default");
        let matches = $e87dbc164c36d527$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e87dbc164c36d527$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e87dbc164c36d527$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e87dbc164c36d527$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e87dbc164c36d527$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e87dbc164c36d527$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e87dbc164c36d527$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($e87dbc164c36d527$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e87dbc164c36d527$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e87dbc164c36d527$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e87dbc164c36d527$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e87dbc164c36d527$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e87dbc164c36d527$var$isResponse(result) ? result : $e87dbc164c36d527$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e87dbc164c36d527$var$isDataStrategyResult(e) && $e87dbc164c36d527$var$isResponse(e.result)) {
                if (e.type === $e87dbc164c36d527$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e87dbc164c36d527$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e87dbc164c36d527$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e87dbc164c36d527$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $e87dbc164c36d527$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e87dbc164c36d527$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e87dbc164c36d527$var$isDeferredResult(result)) {
            let error = $e87dbc164c36d527$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e87dbc164c36d527$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e87dbc164c36d527$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e87dbc164c36d527$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e87dbc164c36d527$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e87dbc164c36d527$var$_extends({}, context, {
                statusCode: $e87dbc164c36d527$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e87dbc164c36d527$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $e87dbc164c36d527$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e87dbc164c36d527$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1]) ? $e87dbc164c36d527$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $e87dbc164c36d527$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e87dbc164c36d527$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e87dbc164c36d527$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $e87dbc164c36d527$var$callDataStrategyImpl(dataStrategy || $e87dbc164c36d527$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($e87dbc164c36d527$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e87dbc164c36d527$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e87dbc164c36d527$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $e87dbc164c36d527$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e87dbc164c36d527$export$fec11da027c70692(routes, context, error) {
    let newContext = $e87dbc164c36d527$var$_extends({}, context, {
        statusCode: $e87dbc164c36d527$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e87dbc164c36d527$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e87dbc164c36d527$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e87dbc164c36d527$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e87dbc164c36d527$export$cae722b0cc860f13(to ? to : ".", $e87dbc164c36d527$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e87dbc164c36d527$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $e87dbc164c36d527$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e87dbc164c36d527$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e87dbc164c36d527$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e87dbc164c36d527$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e87dbc164c36d527$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e87dbc164c36d527$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e87dbc164c36d527$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e87dbc164c36d527$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e87dbc164c36d527$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e87dbc164c36d527$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e87dbc164c36d527$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e87dbc164c36d527$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e87dbc164c36d527$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e87dbc164c36d527$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e87dbc164c36d527$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e87dbc164c36d527$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e87dbc164c36d527$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e87dbc164c36d527$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e87dbc164c36d527$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e87dbc164c36d527$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $e87dbc164c36d527$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $e87dbc164c36d527$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $e87dbc164c36d527$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $e87dbc164c36d527$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $e87dbc164c36d527$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($e87dbc164c36d527$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e87dbc164c36d527$var$shouldRevalidateLoader(match, $e87dbc164c36d527$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e87dbc164c36d527$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e87dbc164c36d527$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e87dbc164c36d527$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e87dbc164c36d527$var$shouldRevalidateLoader(fetcherMatch, $e87dbc164c36d527$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e87dbc164c36d527$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $e87dbc164c36d527$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e87dbc164c36d527$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e87dbc164c36d527$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $e87dbc164c36d527$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $e87dbc164c36d527$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$e87dbc164c36d527$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $e87dbc164c36d527$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $e87dbc164c36d527$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$e87dbc164c36d527$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e87dbc164c36d527$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e87dbc164c36d527$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e87dbc164c36d527$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$e87dbc164c36d527$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e87dbc164c36d527$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $e87dbc164c36d527$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $e87dbc164c36d527$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $e87dbc164c36d527$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $e87dbc164c36d527$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $e87dbc164c36d527$var$ResultType.data,
                result: undefined
            });
        };
        return $e87dbc164c36d527$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e87dbc164c36d527$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e87dbc164c36d527$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e87dbc164c36d527$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e87dbc164c36d527$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e87dbc164c36d527$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e87dbc164c36d527$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e87dbc164c36d527$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($e87dbc164c36d527$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e87dbc164c36d527$var$ResultType.error,
                error: e
            };
        }
        if (type === $e87dbc164c36d527$var$ResultType.error) return {
            type: $e87dbc164c36d527$var$ResultType.error,
            error: new $e87dbc164c36d527$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e87dbc164c36d527$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e87dbc164c36d527$var$ResultType.error) {
        if ($e87dbc164c36d527$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $e87dbc164c36d527$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $e87dbc164c36d527$var$ResultType.error,
                error: new $e87dbc164c36d527$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $e87dbc164c36d527$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $e87dbc164c36d527$var$ResultType.error,
            error: result,
            statusCode: $e87dbc164c36d527$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($e87dbc164c36d527$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $e87dbc164c36d527$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($e87dbc164c36d527$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $e87dbc164c36d527$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $e87dbc164c36d527$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $e87dbc164c36d527$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e87dbc164c36d527$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e87dbc164c36d527$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e87dbc164c36d527$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e87dbc164c36d527$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($e87dbc164c36d527$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $e87dbc164c36d527$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $e87dbc164c36d527$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e87dbc164c36d527$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e87dbc164c36d527$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e87dbc164c36d527$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e87dbc164c36d527$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e87dbc164c36d527$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e87dbc164c36d527$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e87dbc164c36d527$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $e87dbc164c36d527$export$3e9cee6b33872309(!$e87dbc164c36d527$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e87dbc164c36d527$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e87dbc164c36d527$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e87dbc164c36d527$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e87dbc164c36d527$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e87dbc164c36d527$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e87dbc164c36d527$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $e87dbc164c36d527$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($e87dbc164c36d527$var$isErrorResult(result)) {
            let boundaryMatch = $e87dbc164c36d527$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e87dbc164c36d527$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e87dbc164c36d527$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e87dbc164c36d527$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e87dbc164c36d527$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e87dbc164c36d527$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e87dbc164c36d527$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e87dbc164c36d527$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e87dbc164c36d527$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e87dbc164c36d527$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e87dbc164c36d527$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e87dbc164c36d527$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e87dbc164c36d527$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e87dbc164c36d527$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $e87dbc164c36d527$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e87dbc164c36d527$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($e87dbc164c36d527$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $e87dbc164c36d527$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(path) : path;
    return $e87dbc164c36d527$export$fe53371bee54353d($e87dbc164c36d527$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e87dbc164c36d527$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e87dbc164c36d527$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e87dbc164c36d527$var$ResultType.data || result.type === $e87dbc164c36d527$var$ResultType.error);
}
function $e87dbc164c36d527$var$isRedirectDataStrategyResultResult(result) {
    return $e87dbc164c36d527$var$isResponse(result.result) && $e87dbc164c36d527$var$redirectStatusCodes.has(result.result.status);
}
function $e87dbc164c36d527$var$isDeferredResult(result) {
    return result.type === $e87dbc164c36d527$var$ResultType.deferred;
}
function $e87dbc164c36d527$var$isErrorResult(result) {
    return result.type === $e87dbc164c36d527$var$ResultType.error;
}
function $e87dbc164c36d527$var$isRedirectResult(result) {
    return (result && result.type) === $e87dbc164c36d527$var$ResultType.redirect;
}
function $e87dbc164c36d527$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $e87dbc164c36d527$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e87dbc164c36d527$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e87dbc164c36d527$var$isRedirectResponse(result) {
    if (!$e87dbc164c36d527$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e87dbc164c36d527$var$isValidMethod(method) {
    return $e87dbc164c36d527$var$validRequestMethods.has(method.toLowerCase());
}
function $e87dbc164c36d527$var$isMutationMethod(method) {
    return $e87dbc164c36d527$var$validMutationMethods.has(method.toLowerCase());
}
async function $e87dbc164c36d527$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e87dbc164c36d527$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e87dbc164c36d527$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $e87dbc164c36d527$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $e87dbc164c36d527$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($e87dbc164c36d527$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $e87dbc164c36d527$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $e87dbc164c36d527$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $e87dbc164c36d527$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e87dbc164c36d527$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e87dbc164c36d527$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e87dbc164c36d527$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e87dbc164c36d527$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e87dbc164c36d527$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e87dbc164c36d527$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e87dbc164c36d527$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e87dbc164c36d527$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e87dbc164c36d527$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e87dbc164c36d527$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e87dbc164c36d527$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e87dbc164c36d527$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e87dbc164c36d527$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e87dbc164c36d527$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e87dbc164c36d527$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e87dbc164c36d527$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e87dbc164c36d527$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e87dbc164c36d527$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e87dbc164c36d527$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $68bc5e6b1c17c80f$var$_extends() {
    return $68bc5e6b1c17c80f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $68bc5e6b1c17c80f$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $68bc5e6b1c17c80f$export$3add0d5dce533e2e = /*#__PURE__*/ $1OEoy.createContext(null);
const $68bc5e6b1c17c80f$export$145dfa71566a64dc = /*#__PURE__*/ $1OEoy.createContext(null);
const $68bc5e6b1c17c80f$var$AwaitContext = /*#__PURE__*/ $1OEoy.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $68bc5e6b1c17c80f$export$26749e8557646306 = /*#__PURE__*/ $1OEoy.createContext(null);
const $68bc5e6b1c17c80f$export$c7914228fb69b0f5 = /*#__PURE__*/ $1OEoy.createContext(null);
const $68bc5e6b1c17c80f$export$9072aa6dd1f93057 = /*#__PURE__*/ $1OEoy.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $68bc5e6b1c17c80f$var$RouteErrorContext = /*#__PURE__*/ $1OEoy.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $68bc5e6b1c17c80f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $1OEoy.useContext($68bc5e6b1c17c80f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $68bc5e6b1c17c80f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e87dbc164c36d527$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $68bc5e6b1c17c80f$export$9c954a9d03d32f4a() {
    return $1OEoy.useContext($68bc5e6b1c17c80f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $68bc5e6b1c17c80f$export$45d76561a5302f2b() {
    !$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return $1OEoy.useContext($68bc5e6b1c17c80f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $68bc5e6b1c17c80f$export$1b3f31771c5d07c() {
    return $1OEoy.useContext($68bc5e6b1c17c80f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $68bc5e6b1c17c80f$export$6c330e8992e8a295(pattern) {
    !$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $68bc5e6b1c17c80f$export$45d76561a5302f2b();
    return $1OEoy.useMemo(()=>(0, $e87dbc164c36d527$export$81336c211d5ff295)(pattern, (0, $e87dbc164c36d527$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $68bc5e6b1c17c80f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $68bc5e6b1c17c80f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $1OEoy.useContext($68bc5e6b1c17c80f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1OEoy.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $68bc5e6b1c17c80f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $68bc5e6b1c17c80f$var$useNavigateStable() : $68bc5e6b1c17c80f$var$useNavigateUnstable();
}
function $68bc5e6b1c17c80f$var$useNavigateUnstable() {
    !$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let dataRouterContext = $1OEoy.useContext($68bc5e6b1c17c80f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $1OEoy.useContext($68bc5e6b1c17c80f$export$26749e8557646306);
    let { matches: matches } = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $68bc5e6b1c17c80f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e87dbc164c36d527$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $1OEoy.useRef(false);
    $68bc5e6b1c17c80f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1OEoy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e87dbc164c36d527$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e87dbc164c36d527$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $68bc5e6b1c17c80f$var$OutletContext = /*#__PURE__*/ $1OEoy.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $68bc5e6b1c17c80f$export$4138103a3ae699cc() {
    return $1OEoy.useContext($68bc5e6b1c17c80f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $68bc5e6b1c17c80f$export$a3be3530d8e40d0b(context) {
    let outlet = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $68bc5e6b1c17c80f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $68bc5e6b1c17c80f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $1OEoy.useContext($68bc5e6b1c17c80f$export$26749e8557646306);
    let { matches: matches } = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $68bc5e6b1c17c80f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e87dbc164c36d527$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $1OEoy.useMemo(()=>(0, $e87dbc164c36d527$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $68bc5e6b1c17c80f$export$5d3fca4a98652595(routes, locationArg) {
    return $68bc5e6b1c17c80f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $68bc5e6b1c17c80f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $1OEoy.useContext($68bc5e6b1c17c80f$export$26749e8557646306);
    let { matches: parentMatches } = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $68bc5e6b1c17c80f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e87dbc164c36d527$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $e87dbc164c36d527$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $68bc5e6b1c17c80f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e87dbc164c36d527$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e87dbc164c36d527$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $68bc5e6b1c17c80f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e87dbc164c36d527$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $68bc5e6b1c17c80f$var$DefaultErrorComponent() {
    let error = $68bc5e6b1c17c80f$export$ed527bf60f6e05f2();
    let message = (0, $e87dbc164c36d527$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $1OEoy.createElement($1OEoy.Fragment, null, /*#__PURE__*/ $1OEoy.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $1OEoy.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $1OEoy.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $68bc5e6b1c17c80f$var$defaultErrorElement = /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$DefaultErrorComponent, null);
class $68bc5e6b1c17c80f$var$RenderErrorBoundary extends $1OEoy.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $68bc5e6b1c17c80f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $1OEoy.useContext($68bc5e6b1c17c80f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $68bc5e6b1c17c80f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $68bc5e6b1c17c80f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $68bc5e6b1c17c80f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $1OEoy.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $68bc5e6b1c17c80f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($68bc5e6b1c17c80f$var$DataRouterHook || {});
var $68bc5e6b1c17c80f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($68bc5e6b1c17c80f$var$DataRouterStateHook || {});
function $68bc5e6b1c17c80f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $68bc5e6b1c17c80f$var$useDataRouterContext(hookName) {
    let ctx = $1OEoy.useContext($68bc5e6b1c17c80f$export$3add0d5dce533e2e);
    !ctx && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return ctx;
}
function $68bc5e6b1c17c80f$var$useDataRouterState(hookName) {
    let state = $1OEoy.useContext($68bc5e6b1c17c80f$export$145dfa71566a64dc);
    !state && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return state;
}
function $68bc5e6b1c17c80f$var$useRouteContext(hookName) {
    let route = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    !route && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $68bc5e6b1c17c80f$var$useCurrentRouteId(hookName) {
    let route = $68bc5e6b1c17c80f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $68bc5e6b1c17c80f$export$5fc8298006ad9e58() {
    return $68bc5e6b1c17c80f$var$useCurrentRouteId($68bc5e6b1c17c80f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $68bc5e6b1c17c80f$export$d0fd4b7106de2769() {
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $68bc5e6b1c17c80f$export$600dc272ed516c15() {
    let dataRouterContext = $68bc5e6b1c17c80f$var$useDataRouterContext($68bc5e6b1c17c80f$var$DataRouterHook.UseRevalidator);
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseRevalidator);
    return $1OEoy.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $68bc5e6b1c17c80f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseMatches);
    return $1OEoy.useMemo(()=>matches.map((m)=>(0, $e87dbc164c36d527$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $68bc5e6b1c17c80f$export$1448a5050d252c4d() {
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $68bc5e6b1c17c80f$var$useCurrentRouteId($68bc5e6b1c17c80f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $68bc5e6b1c17c80f$export$fd5d37484eab868d(routeId) {
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $68bc5e6b1c17c80f$export$fdc00f3f26066d5e() {
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseActionData);
    let routeId = $68bc5e6b1c17c80f$var$useCurrentRouteId($68bc5e6b1c17c80f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $68bc5e6b1c17c80f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $1OEoy.useContext($68bc5e6b1c17c80f$var$RouteErrorContext);
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseRouteError);
    let routeId = $68bc5e6b1c17c80f$var$useCurrentRouteId($68bc5e6b1c17c80f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $68bc5e6b1c17c80f$export$78a72ddb39bdd145() {
    let value = $1OEoy.useContext($68bc5e6b1c17c80f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $68bc5e6b1c17c80f$export$17f53340677d5831() {
    let value = $1OEoy.useContext($68bc5e6b1c17c80f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $68bc5e6b1c17c80f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $68bc5e6b1c17c80f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $68bc5e6b1c17c80f$var$useDataRouterContext($68bc5e6b1c17c80f$var$DataRouterHook.UseBlocker);
    let state = $68bc5e6b1c17c80f$var$useDataRouterState($68bc5e6b1c17c80f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $1OEoy.useState("");
    let blockerFunction = $1OEoy.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $68bc5e6b1c17c80f$var$_extends({}, currentLocation, {
                pathname: (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $68bc5e6b1c17c80f$var$_extends({}, nextLocation, {
                pathname: (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $1OEoy.useEffect(()=>{
        let key = String(++$68bc5e6b1c17c80f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $1OEoy.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e87dbc164c36d527$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $68bc5e6b1c17c80f$var$useNavigateStable() {
    let { router: router } = $68bc5e6b1c17c80f$var$useDataRouterContext($68bc5e6b1c17c80f$var$DataRouterHook.UseNavigateStable);
    let id = $68bc5e6b1c17c80f$var$useCurrentRouteId($68bc5e6b1c17c80f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $1OEoy.useRef(false);
    $68bc5e6b1c17c80f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1OEoy.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $68bc5e6b1c17c80f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $68bc5e6b1c17c80f$var$alreadyWarned$1 = {};
function $68bc5e6b1c17c80f$var$warningOnce(key, cond, message) {
    if (!cond && !$68bc5e6b1c17c80f$var$alreadyWarned$1[key]) $68bc5e6b1c17c80f$var$alreadyWarned$1[key] = true;
}
const $68bc5e6b1c17c80f$var$alreadyWarned = {};
function $68bc5e6b1c17c80f$var$warnOnce(key, message) {}
const $68bc5e6b1c17c80f$var$logDeprecation = (flag, msg, link)=>$68bc5e6b1c17c80f$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $68bc5e6b1c17c80f$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $68bc5e6b1c17c80f$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $68bc5e6b1c17c80f$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $68bc5e6b1c17c80f$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $68bc5e6b1c17c80f$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $68bc5e6b1c17c80f$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $68bc5e6b1c17c80f$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $68bc5e6b1c17c80f$var$START_TRANSITION = "startTransition";
const $68bc5e6b1c17c80f$var$startTransitionImpl = $1OEoy[$68bc5e6b1c17c80f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $68bc5e6b1c17c80f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1OEoy.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1OEoy.useCallback((newState)=>{
        if (v7_startTransition && $68bc5e6b1c17c80f$var$startTransitionImpl) $68bc5e6b1c17c80f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1OEoy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $1OEoy.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1OEoy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1OEoy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $1OEoy.useEffect(()=>$68bc5e6b1c17c80f$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1OEoy.createElement($1OEoy.Fragment, null, /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $68bc5e6b1c17c80f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $68bc5e6b1c17c80f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $68bc5e6b1c17c80f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $1OEoy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e87dbc164c36d527$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1OEoy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1OEoy.useCallback((newState)=>{
        v7_startTransition && $68bc5e6b1c17c80f$var$startTransitionImpl ? $68bc5e6b1c17c80f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1OEoy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1OEoy.useEffect(()=>$68bc5e6b1c17c80f$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $68bc5e6b1c17c80f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $1OEoy.useContext($68bc5e6b1c17c80f$export$26749e8557646306);
    let { matches: matches } = $1OEoy.useContext($68bc5e6b1c17c80f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $68bc5e6b1c17c80f$export$45d76561a5302f2b();
    let navigate = $68bc5e6b1c17c80f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e87dbc164c36d527$export$cae722b0cc860f13)(to, (0, $e87dbc164c36d527$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $1OEoy.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $68bc5e6b1c17c80f$export$910ae8079b2c2852(props) {
    return $68bc5e6b1c17c80f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $68bc5e6b1c17c80f$export$e7b0ac011bb776c6(_props) {
    (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $68bc5e6b1c17c80f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e87dbc164c36d527$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$68bc5e6b1c17c80f$export$9c954a9d03d32f4a() && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $1OEoy.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $68bc5e6b1c17c80f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e87dbc164c36d527$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $1OEoy.useMemo(()=>{
        let trailingPathname = (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $68bc5e6b1c17c80f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $68bc5e6b1c17c80f$export$5d3fca4a98652595($68bc5e6b1c17c80f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $68bc5e6b1c17c80f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$ResolveAwait, null, children));
}
var $68bc5e6b1c17c80f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($68bc5e6b1c17c80f$var$AwaitRenderStatus || {});
const $68bc5e6b1c17c80f$var$neverSettledPromise = new Promise(()=>{});
class $68bc5e6b1c17c80f$var$AwaitErrorBoundary extends $1OEoy.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $68bc5e6b1c17c80f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $68bc5e6b1c17c80f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $68bc5e6b1c17c80f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $68bc5e6b1c17c80f$var$AwaitRenderStatus.error : "_data" in promise ? $68bc5e6b1c17c80f$var$AwaitRenderStatus.success : $68bc5e6b1c17c80f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $68bc5e6b1c17c80f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $68bc5e6b1c17c80f$var$AwaitRenderStatus.error && promise._error instanceof (0, $e87dbc164c36d527$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $68bc5e6b1c17c80f$var$neverSettledPromise;
        if (status === $68bc5e6b1c17c80f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $68bc5e6b1c17c80f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $68bc5e6b1c17c80f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $1OEoy.createElement($68bc5e6b1c17c80f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $68bc5e6b1c17c80f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $68bc5e6b1c17c80f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $1OEoy.createElement($1OEoy.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $68bc5e6b1c17c80f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $1OEoy.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $1OEoy.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $1OEoy.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $68bc5e6b1c17c80f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $68bc5e6b1c17c80f$export$e7b0ac011bb776c6) && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $68bc5e6b1c17c80f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $68bc5e6b1c17c80f$export$daf73786167a7f72(matches) {
    return $68bc5e6b1c17c80f$var$_renderMatches(matches);
}
function $68bc5e6b1c17c80f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $1OEoy.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $1OEoy.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $1OEoy.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $68bc5e6b1c17c80f$export$f30f7e456d254e83(routes, opts) {
    return (0, $e87dbc164c36d527$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $68bc5e6b1c17c80f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e87dbc164c36d527$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $68bc5e6b1c17c80f$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



parcelRequire("1OEoy");
/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1OEoy = parcelRequire("1OEoy");



function $2bcf391f4c2cee24$var$_extends() {
    return $2bcf391f4c2cee24$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2bcf391f4c2cee24$var$_extends.apply(null, arguments);
}
function $2bcf391f4c2cee24$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $2bcf391f4c2cee24$var$defaultMethod = "get";
const $2bcf391f4c2cee24$var$defaultEncType = "application/x-www-form-urlencoded";
function $2bcf391f4c2cee24$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $2bcf391f4c2cee24$var$isButtonElement(object) {
    return $2bcf391f4c2cee24$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $2bcf391f4c2cee24$var$isFormElement(object) {
    return $2bcf391f4c2cee24$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $2bcf391f4c2cee24$var$isInputElement(object) {
    return $2bcf391f4c2cee24$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $2bcf391f4c2cee24$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $2bcf391f4c2cee24$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$2bcf391f4c2cee24$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $2bcf391f4c2cee24$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $2bcf391f4c2cee24$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $2bcf391f4c2cee24$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $2bcf391f4c2cee24$var$_formDataSupportsSubmitter = null;
function $2bcf391f4c2cee24$var$isFormDataSubmitterSupported() {
    if ($2bcf391f4c2cee24$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $2bcf391f4c2cee24$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $2bcf391f4c2cee24$var$_formDataSupportsSubmitter = true;
    }
    return $2bcf391f4c2cee24$var$_formDataSupportsSubmitter;
}
const $2bcf391f4c2cee24$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $2bcf391f4c2cee24$var$getFormEncType(encType) {
    if (encType != null && !$2bcf391f4c2cee24$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $2bcf391f4c2cee24$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($2bcf391f4c2cee24$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $2bcf391f4c2cee24$var$defaultMethod;
        encType = $2bcf391f4c2cee24$var$getFormEncType(target.getAttribute("enctype")) || $2bcf391f4c2cee24$var$defaultEncType;
        formData = new FormData(target);
    } else if ($2bcf391f4c2cee24$var$isButtonElement(target) || $2bcf391f4c2cee24$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $2bcf391f4c2cee24$var$defaultMethod;
        encType = $2bcf391f4c2cee24$var$getFormEncType(target.getAttribute("formenctype")) || $2bcf391f4c2cee24$var$getFormEncType(form.getAttribute("enctype")) || $2bcf391f4c2cee24$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$2bcf391f4c2cee24$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($2bcf391f4c2cee24$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $2bcf391f4c2cee24$var$defaultMethod;
        action = null;
        encType = $2bcf391f4c2cee24$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $2bcf391f4c2cee24$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $2bcf391f4c2cee24$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $2bcf391f4c2cee24$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $2bcf391f4c2cee24$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $2bcf391f4c2cee24$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $2bcf391f4c2cee24$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e87dbc164c36d527$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2bcf391f4c2cee24$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e87dbc164c36d527$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2bcf391f4c2cee24$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $68bc5e6b1c17c80f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2bcf391f4c2cee24$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e87dbc164c36d527$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2bcf391f4c2cee24$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e87dbc164c36d527$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2bcf391f4c2cee24$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $68bc5e6b1c17c80f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2bcf391f4c2cee24$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $2bcf391f4c2cee24$var$_extends({}, state, {
        errors: $2bcf391f4c2cee24$var$deserializeErrors(state.errors)
    });
    return state;
}
function $2bcf391f4c2cee24$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e87dbc164c36d527$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $2bcf391f4c2cee24$export$7ad602f0e94e62d1 = /*#__PURE__*/ $1OEoy.createContext({
    isTransitioning: false
});
const $2bcf391f4c2cee24$export$148fd98d095596d4 = /*#__PURE__*/ $1OEoy.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2bcf391f4c2cee24$var$START_TRANSITION = "startTransition";
const $2bcf391f4c2cee24$var$startTransitionImpl = $1OEoy[$2bcf391f4c2cee24$var$START_TRANSITION];
const $2bcf391f4c2cee24$var$FLUSH_SYNC = "flushSync";
const $2bcf391f4c2cee24$var$flushSyncImpl = $4ed43828a92c8386$exports[$2bcf391f4c2cee24$var$FLUSH_SYNC];
const $2bcf391f4c2cee24$var$USE_ID = "useId";
const $2bcf391f4c2cee24$var$useIdImpl = $1OEoy[$2bcf391f4c2cee24$var$USE_ID];
function $2bcf391f4c2cee24$var$startTransitionSafe(cb) {
    if ($2bcf391f4c2cee24$var$startTransitionImpl) $2bcf391f4c2cee24$var$startTransitionImpl(cb);
    else cb();
}
function $2bcf391f4c2cee24$var$flushSyncSafe(cb) {
    if ($2bcf391f4c2cee24$var$flushSyncImpl) $2bcf391f4c2cee24$var$flushSyncImpl(cb);
    else cb();
}
class $2bcf391f4c2cee24$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2bcf391f4c2cee24$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1OEoy.useState(router.state);
    let [pendingState, setPendingState] = $1OEoy.useState();
    let [vtContext, setVtContext] = $1OEoy.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $1OEoy.useState();
    let [transition, setTransition] = $1OEoy.useState();
    let [interruption, setInterruption] = $1OEoy.useState();
    let fetcherData = $1OEoy.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $1OEoy.useCallback((cb)=>{
        if (v7_startTransition) $2bcf391f4c2cee24$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $1OEoy.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $2bcf391f4c2cee24$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $2bcf391f4c2cee24$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $2bcf391f4c2cee24$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $2bcf391f4c2cee24$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $2bcf391f4c2cee24$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1OEoy.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $1OEoy.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $2bcf391f4c2cee24$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $1OEoy.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $1OEoy.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $1OEoy.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $1OEoy.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1OEoy.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1OEoy.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $1OEoy.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $1OEoy.useEffect(()=>(0, $68bc5e6b1c17c80f$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1OEoy.createElement($1OEoy.Fragment, null, /*#__PURE__*/ $1OEoy.createElement((0, $68bc5e6b1c17c80f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1OEoy.createElement((0, $68bc5e6b1c17c80f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $1OEoy.createElement($2bcf391f4c2cee24$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $1OEoy.createElement($2bcf391f4c2cee24$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $1OEoy.createElement((0, $68bc5e6b1c17c80f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1OEoy.createElement($2bcf391f4c2cee24$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $2bcf391f4c2cee24$var$MemoizedDataRoutes = /*#__PURE__*/ $1OEoy.memo($2bcf391f4c2cee24$var$DataRoutes);
function $2bcf391f4c2cee24$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $68bc5e6b1c17c80f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $2bcf391f4c2cee24$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $1OEoy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e87dbc164c36d527$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1OEoy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1OEoy.useCallback((newState)=>{
        v7_startTransition && $2bcf391f4c2cee24$var$startTransitionImpl ? $2bcf391f4c2cee24$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1OEoy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1OEoy.useEffect(()=>(0, $68bc5e6b1c17c80f$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $1OEoy.createElement((0, $68bc5e6b1c17c80f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $2bcf391f4c2cee24$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $1OEoy.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e87dbc164c36d527$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1OEoy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1OEoy.useCallback((newState)=>{
        v7_startTransition && $2bcf391f4c2cee24$var$startTransitionImpl ? $2bcf391f4c2cee24$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1OEoy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1OEoy.useEffect(()=>(0, $68bc5e6b1c17c80f$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $1OEoy.createElement((0, $68bc5e6b1c17c80f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $2bcf391f4c2cee24$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $1OEoy.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1OEoy.useCallback((newState)=>{
        v7_startTransition && $2bcf391f4c2cee24$var$startTransitionImpl ? $2bcf391f4c2cee24$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1OEoy.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $1OEoy.useEffect(()=>(0, $68bc5e6b1c17c80f$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $1OEoy.createElement((0, $68bc5e6b1c17c80f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $2bcf391f4c2cee24$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $2bcf391f4c2cee24$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $2bcf391f4c2cee24$export$a6c7ac8248d6e38a = /*#__PURE__*/ $1OEoy.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $2bcf391f4c2cee24$var$_objectWithoutPropertiesLoose(_ref7, $2bcf391f4c2cee24$var$_excluded);
    let { basename: basename } = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $2bcf391f4c2cee24$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($2bcf391f4c2cee24$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $68bc5e6b1c17c80f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $2bcf391f4c2cee24$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $1OEoy.createElement("a", $2bcf391f4c2cee24$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $2bcf391f4c2cee24$export$b0d92dbee9b5b60d = /*#__PURE__*/ $1OEoy.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $2bcf391f4c2cee24$var$_objectWithoutPropertiesLoose(_ref8, $2bcf391f4c2cee24$var$_excluded2);
    let path = (0, $68bc5e6b1c17c80f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    let routerState = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2bcf391f4c2cee24$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $1OEoy.createElement($2bcf391f4c2cee24$export$a6c7ac8248d6e38a, $2bcf391f4c2cee24$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $2bcf391f4c2cee24$export$a7fed597f4b8afd8 = /*#__PURE__*/ $1OEoy.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $2bcf391f4c2cee24$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $2bcf391f4c2cee24$var$_objectWithoutPropertiesLoose(_ref9, $2bcf391f4c2cee24$var$_excluded3);
    let submit = $2bcf391f4c2cee24$export$47c85c6e3a081d3();
    let formAction = $2bcf391f4c2cee24$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $1OEoy.createElement("form", $2bcf391f4c2cee24$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $2bcf391f4c2cee24$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $2bcf391f4c2cee24$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $2bcf391f4c2cee24$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($2bcf391f4c2cee24$var$DataRouterHook || ($2bcf391f4c2cee24$var$DataRouterHook = {}));
var $2bcf391f4c2cee24$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($2bcf391f4c2cee24$var$DataRouterStateHook || ($2bcf391f4c2cee24$var$DataRouterStateHook = {}));
// Internal hooks
function $2bcf391f4c2cee24$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $2bcf391f4c2cee24$var$useDataRouterContext(hookName) {
    let ctx = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$3add0d5dce533e2e));
    !ctx && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2bcf391f4c2cee24$var$useDataRouterState(hookName) {
    let state = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$145dfa71566a64dc));
    !state && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $2bcf391f4c2cee24$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $68bc5e6b1c17c80f$export$9770f232ac06a008)();
    let location = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    let path = (0, $68bc5e6b1c17c80f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $1OEoy.useCallback((event)=>{
        if ($2bcf391f4c2cee24$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e87dbc164c36d527$export$fe53371bee54353d)(location) === (0, $e87dbc164c36d527$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $2bcf391f4c2cee24$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $1OEoy.useRef($2bcf391f4c2cee24$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $1OEoy.useRef(false);
    let location = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    let searchParams = $1OEoy.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $2bcf391f4c2cee24$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $68bc5e6b1c17c80f$export$9770f232ac06a008)();
    let setSearchParams = $1OEoy.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $2bcf391f4c2cee24$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $2bcf391f4c2cee24$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $2bcf391f4c2cee24$var$fetcherId = 0;
let $2bcf391f4c2cee24$var$getUniqueFetcherId = ()=>"__" + String(++$2bcf391f4c2cee24$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $2bcf391f4c2cee24$export$47c85c6e3a081d3() {
    let { router: router } = $2bcf391f4c2cee24$var$useDataRouterContext($2bcf391f4c2cee24$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$26749e8557646306));
    let currentRouteId = (0, $68bc5e6b1c17c80f$export$5fc8298006ad9e58)();
    return $1OEoy.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2bcf391f4c2cee24$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2bcf391f4c2cee24$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $2bcf391f4c2cee24$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $2bcf391f4c2cee24$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$26749e8557646306));
    let routeContext = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$9072aa6dd1f93057));
    !routeContext && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $2bcf391f4c2cee24$var$_extends({}, (0, $68bc5e6b1c17c80f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e87dbc164c36d527$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e87dbc164c36d527$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $2bcf391f4c2cee24$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $2bcf391f4c2cee24$var$useDataRouterContext($2bcf391f4c2cee24$var$DataRouterHook.UseFetcher);
    let state = $2bcf391f4c2cee24$var$useDataRouterState($2bcf391f4c2cee24$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $1OEoy.useContext($2bcf391f4c2cee24$export$148fd98d095596d4);
    let route = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    !route && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $2bcf391f4c2cee24$var$useIdImpl ? $2bcf391f4c2cee24$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $1OEoy.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($2bcf391f4c2cee24$var$getUniqueFetcherId());
    // Registration/cleanup
    $1OEoy.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $1OEoy.useCallback((href, opts)=>{
        !routeId && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $2bcf391f4c2cee24$export$47c85c6e3a081d3();
    let submit = $1OEoy.useCallback((target, opts)=>{
        submitImpl(target, $2bcf391f4c2cee24$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $1OEoy.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $1OEoy.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $1OEoy.createElement($2bcf391f4c2cee24$export$a7fed597f4b8afd8, $2bcf391f4c2cee24$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $e87dbc164c36d527$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $1OEoy.useMemo(()=>$2bcf391f4c2cee24$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $2bcf391f4c2cee24$export$fa996778a3a31087() {
    let state = $2bcf391f4c2cee24$var$useDataRouterState($2bcf391f4c2cee24$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $2bcf391f4c2cee24$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $2bcf391f4c2cee24$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $2bcf391f4c2cee24$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $2bcf391f4c2cee24$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $2bcf391f4c2cee24$var$useDataRouterContext($2bcf391f4c2cee24$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $2bcf391f4c2cee24$var$useDataRouterState($2bcf391f4c2cee24$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $1OEoy.useContext((0, $68bc5e6b1c17c80f$export$26749e8557646306));
    let location = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    let matches = (0, $68bc5e6b1c17c80f$export$2378eb7f5ff86053)();
    let navigation = (0, $68bc5e6b1c17c80f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $1OEoy.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $2bcf391f4c2cee24$var$usePageHide($1OEoy.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $2bcf391f4c2cee24$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $2bcf391f4c2cee24$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($2bcf391f4c2cee24$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1OEoy.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $2bcf391f4c2cee24$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $2bcf391f4c2cee24$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1OEoy.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($2bcf391f4c2cee24$var$_extends({}, location, {
                    pathname: (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($2bcf391f4c2cee24$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1OEoy.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2bcf391f4c2cee24$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $1OEoy.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2bcf391f4c2cee24$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $1OEoy.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $2bcf391f4c2cee24$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $68bc5e6b1c17c80f$export$b273b3273281a049)(when);
    $1OEoy.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $1OEoy.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $2bcf391f4c2cee24$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $1OEoy.useContext($2bcf391f4c2cee24$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e87dbc164c36d527$export$3e9cee6b33872309)(false);
    let { basename: basename } = $2bcf391f4c2cee24$var$useDataRouterContext($2bcf391f4c2cee24$var$DataRouterHook.useViewTransitionState);
    let path = (0, $68bc5e6b1c17c80f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e87dbc164c36d527$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e87dbc164c36d527$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e87dbc164c36d527$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}





const $bbcaa7587c1517b4$var$config = {
    loginUrl: "https://portal.consent.jio.com",
    loginUrl2: "https://consent.jio.com/v2/",
    signupLoginUrl: "http://10.144.116.42:9012/login",
    docsUrl: "https://developer.consent.jio.com"
};
var $bbcaa7587c1517b4$export$2e2bcd8739ae039 = $bbcaa7587c1517b4$var$config;


const $6a50ea83fde84983$var$SignUp = ()=>{
    const navigate = (0, $68bc5e6b1c17c80f$export$9770f232ac06a008)();
    const handleLogin = ()=>{
        if (!(0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).signupLoginUrl) {
            console.warn("REACT_APP_SIGNUP_LOGIN_URL is not configured");
            return;
        }
        window.location.href = (0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).signupLoginUrl;
    };
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: "contact-page",
        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
            className: "contact-card",
            children: [
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                    className: "logoDiv",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            className: "logoStyle",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $04fc5138b12d9c4c$export$faf9e552d710fc5c), {
                                width: 40,
                                height: 40
                            })
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                            appearance: "heading-xxs",
                            children: "Consent Management"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                    className: "contact-content",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            className: "container-header",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                appearance: "heading-xs",
                                children: "Sign up"
                            })
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            className: "contact-box",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                appearance: "body-s",
                                color: "primary-grey-80",
                                children: "Organisation onboarding is handled through your administrator. If you already have access, sign in below."
                            })
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$cfc7921d29ef7b80), {
                            label: "Log in",
                            onClick: handleLogin,
                            stretch: true
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            style: {
                                marginTop: 12
                            },
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$cfc7921d29ef7b80), {
                                label: "Back to home",
                                onClick: ()=>navigate("/"),
                                stretch: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $6a50ea83fde84983$export$2e2bcd8739ae039 = $6a50ea83fde84983$var$SignUp;




var $1OEoy = parcelRequire("1OEoy");






var $e35c2be7584c895e$exports = {};
$e35c2be7584c895e$exports = import.meta.resolve("lvwc7");


var $af1149c758aedf06$exports = {};
$af1149c758aedf06$exports = import.meta.resolve("64xWI");


var $7a3e33b8fddfe1c3$exports = {};
$7a3e33b8fddfe1c3$exports = import.meta.resolve("aSwOT");


var $4a0264fa8790dbd9$exports = {};
$4a0264fa8790dbd9$exports = import.meta.resolve("1JkB5");


var $d6a4f94e4d48befa$exports = {};
$d6a4f94e4d48befa$exports = import.meta.resolve("44Kqs");


var $ffd2848f0f304742$exports = {};
$ffd2848f0f304742$exports = import.meta.resolve("eMhEf");


var $d7bc9d3e0c846881$exports = {};
$d7bc9d3e0c846881$exports = import.meta.resolve("KLZUa");


var $8dac715920530391$exports = {};
$8dac715920530391$exports = import.meta.resolve("lCDLo");


var $383bd2520a9baf55$exports = {};
$383bd2520a9baf55$exports = import.meta.resolve("ixsjo");


var $202495ba22096c1d$exports = {};
$202495ba22096c1d$exports = import.meta.resolve("hdosE");


var $97225e6c04be7242$exports = {};
$97225e6c04be7242$exports = import.meta.resolve("kTeno");


var $c2027efb4c3be92a$exports = {};
$c2027efb4c3be92a$exports = import.meta.resolve("4RZMS");


var $95805b726ec151be$exports = {};
$95805b726ec151be$exports = import.meta.resolve("7IKfl");


var $b42af5140253d38f$exports = {};
$b42af5140253d38f$exports = import.meta.resolve("cJF7G");


var $11234c708a7aa4a0$exports = {};
$11234c708a7aa4a0$exports = import.meta.resolve("kF15c");


// ─── SVG helpers ────────────────────────────────────────────────────────────
function $50e4f2d0505d6b18$var$JioLogoSVG({ width: width = 36, height: height = 36 }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("g", {
                clipPath: "url(#jio-logo-clip)",
                children: [
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("mask", {
                        id: "jio-logo-mask",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "36",
                        height: "36",
                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                            d: "M0 0H36V36H0V0Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("g", {
                        mask: "url(#jio-logo-mask)",
                        children: [
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                                d: "M18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05888 8.05888 0 18 0Z",
                                fill: "#0F3CC9"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                                d: "M12.7173 10.857H12.1173C10.9787 10.857 10.3567 11.4991 10.3567 12.7834V18.9774C10.3567 20.5721 9.81802 21.1317 8.55432 21.1317C7.56032 21.1317 6.75265 20.6964 6.11032 19.9094C6.04799 19.8267 4.74365 20.4477 4.74365 21.981C4.74365 23.638 6.29631 24.6534 9.17695 24.6534C12.677 24.6534 14.5217 22.8924 14.5217 19.0397V12.7834C14.5196 11.5007 13.8984 10.857 12.7173 10.857ZM26.6673 13.8814C23.2697 13.8814 21.012 16.0357 21.012 19.2481C21.012 22.5421 23.1864 24.6554 26.6046 24.6554C30.0013 24.6554 32.238 22.5421 32.238 19.2694C32.24 16.0357 30.023 13.8814 26.6673 13.8814ZM26.6256 21.6077C25.2993 21.6077 24.3883 20.6343 24.3883 19.2464C24.3883 17.8797 25.3217 16.9057 26.6256 16.9057C27.9296 16.9057 28.8627 17.8797 28.8627 19.2673C28.863 20.6134 27.9104 21.6077 26.626 21.6077H26.6256ZM18.1413 13.9847H17.7263C16.712 13.9847 15.9457 14.4607 15.9457 15.9113V22.54C15.9457 24.0111 16.6917 24.467 17.7684 24.467H18.183C19.198 24.467 19.9227 23.9694 19.9227 22.54V15.9113C19.9227 14.42 19.219 13.9847 18.1413 13.9847ZM17.9136 9.17969C16.629 9.17969 15.8213 9.905 15.8213 11.0444C15.8213 12.2037 16.6503 12.9287 17.9756 12.9287C19.26 12.9287 20.0679 12.2037 20.0679 11.0444C20.0679 9.88502 19.2393 9.17969 17.9136 9.17969Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("clipPath", {
                    id: "jio-logo-clip",
                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                        width: "36",
                        height: "36",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
function $50e4f2d0505d6b18$var$ArrowRightSVG({ width: width = 16, height: height = 16, stroke: stroke = "white" }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        style: {
            display: "block",
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M3.3335 8H12.6668",
                stroke: stroke,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M8 3.33301L12.6667 7.99967L8 12.6663",
                stroke: stroke,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
/** FAQ screen 6 — Figma: 20×20, stroke 1.67px, arm length ~11.67px (IcAdd is fill-based 24 viewBox, not this spec). */ function $50e4f2d0505d6b18$var$FaqTogglePlus({ className: className = "" }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        className: className ? `lp-faq-icon-svg ${className}` : "lp-faq-icon-svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M10 4.165V15.835",
                stroke: "currentColor",
                strokeWidth: 1.67,
                strokeLinecap: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M4.165 10H15.835",
                stroke: "currentColor",
                strokeWidth: 1.67,
                strokeLinecap: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    });
}
function $50e4f2d0505d6b18$var$FaqToggleMinus({ className: className = "" }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
        className: className ? `lp-faq-icon-svg ${className}` : "lp-faq-icon-svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M4.165 10H15.835",
            stroke: "currentColor",
            strokeWidth: 1.67,
            strokeLinecap: "round",
            vectorEffect: "non-scaling-stroke"
        })
    });
}
/** Last screen — DPDPA trust tile (Figma asset, unique filter id per instance). */ function $50e4f2d0505d6b18$var$FinalTrustDpdpaShieldIcon() {
    const filterId = `lp-ft-dpdpa-dd-${(0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).useId().replace(/:/g, "")}`;
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 54 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                x: "3",
                y: "2",
                width: "48",
                height: "48",
                rx: "12",
                fill: "#0F3CC9"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("g", {
                filter: `url(#${filterId})`,
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                    x: "3",
                    y: "2",
                    width: "48",
                    height: "48",
                    rx: "12",
                    fill: "white",
                    fillOpacity: "0.01",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M33.6663 26.8331C33.6663 30.9997 30.7497 33.0831 27.283 34.2914C27.1015 34.3529 26.9043 34.35 26.7247 34.2831C23.2497 33.0831 20.333 30.9997 20.333 26.8331V20.9997C20.333 20.5395 20.7061 20.1664 21.1663 20.1664C22.833 20.1664 24.9163 19.1664 26.3663 17.8997C26.7311 17.5881 27.2683 17.5881 27.633 17.8997C29.0913 19.1747 31.1663 20.1664 32.833 20.1664C33.2932 20.1664 33.6663 20.5395 33.6663 20.9997V26.8331",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("filter", {
                    id: filterId,
                    x: "0",
                    y: "0",
                    width: "54",
                    height: "54",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feMorphology", {
                            radius: "1",
                            operator: "erode",
                            in: "SourceAlpha",
                            result: "dpdpa_fs1_morph"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                            dy: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha2"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                            dy: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                            in2: "hardAlpha2",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow",
                            result: "effect2_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
}
/** Last screen — MeitY trust tile (Figma asset). */ function $50e4f2d0505d6b18$var$FinalTrustMeitYBuildingIcon() {
    const filterId = `lp-ft-meity-dd-${(0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).useId().replace(/:/g, "")}`;
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 54 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                x: "3",
                y: "2",
                width: "48",
                height: "48",
                rx: "12",
                fill: "#B45309"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("g", {
                filter: `url(#${filterId})`,
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                    x: "3",
                    y: "2",
                    width: "48",
                    height: "48",
                    rx: "12",
                    fill: "white",
                    fillOpacity: "0.01",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M25.333 31.0003V25.167",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M26.2663 17.8316C26.7297 17.6065 27.2711 17.6083 27.7329 17.8366L34.2879 21.0424C34.6846 21.2366 34.5463 21.8332 34.1046 21.8332H19.8946C19.4529 21.8332 19.3154 21.2366 19.7113 21.0424L26.2663 17.8316",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M28.667 31.0003V25.167",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M32 31.0003V25.167",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M19.5 34.333H34.5",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M22 31.0003V25.167",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("filter", {
                    id: filterId,
                    x: "0",
                    y: "0",
                    width: "54",
                    height: "54",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feMorphology", {
                            radius: "1",
                            operator: "erode",
                            in: "SourceAlpha",
                            result: "meity_fs1_morph"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                            dy: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha2"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                            dy: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                            in2: "hardAlpha2",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow",
                            result: "effect2_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
}
/** Last screen — SOC 2 trust tile (Figma asset). */ function $50e4f2d0505d6b18$var$FinalTrustSoc2VerifiedIcon() {
    const uid = (0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).useId().replace(/:/g, "");
    const filterId = `lp-ft-soc2-dd-${uid}`;
    const clipId = `lp-ft-soc2-clip-${uid}`;
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 54 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                x: "3",
                y: "2",
                width: "48",
                height: "48",
                rx: "12",
                fill: "#7C3AED"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("g", {
                filter: `url(#${filterId})`,
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                    x: "3",
                    y: "2",
                    width: "48",
                    height: "48",
                    rx: "12",
                    fill: "white",
                    fillOpacity: "0.01",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("g", {
                clipPath: `url(#${clipId})`,
                children: [
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                        d: "M20.208 23.1836C19.9608 22.07 20.3002 20.9074 21.1076 20.1017C21.915 19.296 23.0783 18.959 24.1913 19.2086C24.8039 18.2506 25.8626 17.6709 26.9997 17.6709C28.1368 17.6709 29.1954 18.2506 29.808 19.2086C30.9228 18.9579 32.0883 19.2958 32.8962 20.1037C33.7042 20.9117 34.042 22.0771 33.7913 23.1919C34.7494 23.8045 35.329 24.8631 35.329 26.0002C35.329 27.1374 34.7494 28.196 33.7913 28.8086C34.0409 29.9216 33.704 31.0849 32.8982 31.8924C32.0925 32.6998 30.9299 33.0391 29.8163 32.7919C29.2045 33.7537 28.1437 34.3361 27.0038 34.3361C25.864 34.3361 24.8031 33.7537 24.1913 32.7919C23.0783 33.0414 21.915 32.7045 21.1076 31.8988C20.3002 31.0931 19.9608 29.9305 20.208 28.8169C19.2425 28.2059 18.6572 27.1429 18.6572 26.0002C18.6572 24.8576 19.2425 23.7946 20.208 23.1836V23.1836",
                        stroke: "white",
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                        d: "M24.5 25.9997L26.1667 27.6663L29.5 24.333",
                        stroke: "white",
                        strokeWidth: "1.66667",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("filter", {
                        id: filterId,
                        x: "0",
                        y: "0",
                        width: "54",
                        height: "54",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feMorphology", {
                                radius: "1",
                                operator: "erode",
                                in: "SourceAlpha",
                                result: "soc2_fs1_morph"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha2"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                                stdDeviation: "1.5"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                                in2: "hardAlpha2",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow",
                                result: "effect2_dropShadow"
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("clipPath", {
                        id: clipId,
                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(17 16)"
                        })
                    })
                ]
            })
        ]
    });
}
/** Last screen — ISO 27001 trust tile (Figma asset). */ function $50e4f2d0505d6b18$var$FinalTrustIsoPersonStarIcon() {
    const filterId = `lp-ft-iso-dd-${(0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).useId().replace(/:/g, "")}`;
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 54 54",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                x: "3",
                y: "2",
                width: "48",
                height: "48",
                rx: "12",
                fill: "#0EA5E9"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("g", {
                filter: `url(#${filterId})`,
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                    x: "3",
                    y: "2",
                    width: "48",
                    height: "48",
                    rx: "12",
                    fill: "white",
                    fillOpacity: "0.01",
                    shapeRendering: "crispEdges"
                })
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M29.8973 26.7412L31.1598 33.8462C31.1888 34.0175 31.1084 34.1888 30.9581 34.276C30.8078 34.3632 30.6192 34.348 30.4848 34.2379L27.5015 31.9987C27.2057 31.7777 26.7998 31.7777 26.504 31.9987L23.5156 34.237C23.3814 34.347 23.193 34.3622 23.0429 34.2753C22.8927 34.1883 22.8121 34.0174 22.8406 33.8462L24.1023 26.7412",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M22 22.667C22 25.4266 24.2404 27.667 27 27.667C29.7596 27.667 32 25.4266 32 22.667C32 19.9074 29.7596 17.667 27 17.667C24.2404 17.667 22 19.9074 22 22.667V22.667",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("filter", {
                    id: filterId,
                    x: "0",
                    y: "0",
                    width: "54",
                    height: "54",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feMorphology", {
                            radius: "1",
                            operator: "erode",
                            in: "SourceAlpha",
                            result: "iso_fs1_morph"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                            dy: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha2"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feOffset", {
                            dy: "1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feGaussianBlur", {
                            stdDeviation: "1.5"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feComposite", {
                            in2: "hardAlpha2",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow",
                            result: "effect2_dropShadow"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
}
/** Figma trusted bar — Facebook icon (28×28) */ function $50e4f2d0505d6b18$var$TrustedFacebookIcon({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        className: className,
        width: 28,
        height: 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("g", {
                clipPath: "url(#trusted_fb_icon_clip)",
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                    d: "M28 14.0859C28 6.35444 21.7315 0.0859375 14 0.0859375C6.2685 0.0859375 0 6.35444 0 14.0859C0 21.0743 5.11933 26.8656 11.8125 27.9156V18.1331H8.25767V14.0848H11.8125V11.0024C11.8125 7.49427 13.9032 5.55527 17.101 5.55527C18.6317 5.55527 20.2347 5.82944 20.2347 5.82944V9.2746H18.4683C16.7288 9.2746 16.1863 10.3538 16.1863 11.4609V14.0859H20.069L19.4483 18.1343H16.1863V27.9168C22.8807 26.8656 28 21.0731 28 14.0859Z",
                    fill: "#1877F2"
                })
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("clipPath", {
                    id: "trusted_fb_icon_clip",
                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
/** Figma trusted bar — Reliance Jewels (175×40) */ function $50e4f2d0505d6b18$var$TrustedRelianceJewelsLogo({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
        className: className,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4a0264fa8790dbd9$exports))),
        alt: "Reliance Jewels",
        width: 175,
        height: 40,
        loading: "lazy",
        decoding: "async"
    });
}
/** Figma trusted bar — Reliance MedLab (assetsM) */ function $50e4f2d0505d6b18$var$TrustedRelianceMedicalLogo({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
        className: className,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($d6a4f94e4d48befa$exports))),
        alt: "Reliance MedLab",
        width: 104,
        height: 48,
        loading: "lazy",
        decoding: "async"
    });
}
/** Figma trusted bar — Facebook wordmark (89×28) */ function $50e4f2d0505d6b18$var$TrustedFacebookWordmark({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
        className: className,
        width: 89,
        height: 28,
        viewBox: "0 0 89 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
            d: "M7.32251 10.082V12.3137H0.195312V10.082H7.32251ZM2.12225 21V9.24399C2.12225 8.46833 2.27651 7.8232 2.58504 7.30861C2.89357 6.79402 3.31535 6.40821 3.85038 6.15118C4.38541 5.89414 4.98868 5.76562 5.66017 5.76562C6.12254 5.76562 6.54407 5.80244 6.92474 5.87607C7.30541 5.94971 7.58546 6.01406 7.76489 6.06914L7.23442 8.27974C7.11515 8.24367 6.97172 8.20962 6.80414 8.17759C6.63656 8.14556 6.45544 8.12955 6.26079 8.12955C5.81535 8.12955 5.50058 8.23537 5.31647 8.44702C5.13236 8.65867 5.0403 8.95609 5.0403 9.33928V21H2.12225ZM11.3674 21.2117C10.6737 21.2117 10.0524 21.0894 9.5033 20.8448C8.95421 20.6002 8.52244 20.2361 8.20799 19.7523C7.89354 19.2686 7.73631 18.6669 7.73631 17.9473C7.73631 17.3363 7.84771 16.8268 8.07049 16.4186C8.29327 16.0104 8.59819 15.6816 8.98523 15.4324C9.37227 15.1832 9.81205 14.9936 10.3046 14.8636C10.7971 14.7336 11.3131 14.643 11.8525 14.592C12.4825 14.5284 12.9911 14.4686 13.3784 14.4125C13.7657 14.3564 14.0498 14.2686 14.2308 14.1491C14.4118 14.0296 14.5023 13.8523 14.5023 13.617V13.5689C14.5023 13.2574 14.4361 12.9938 14.3038 12.7782C14.1714 12.5627 13.9782 12.3975 13.724 12.2828C13.4698 12.168 13.1574 12.1106 12.7867 12.1106C12.4136 12.1106 12.0871 12.1674 11.8075 12.2809C11.5278 12.3944 11.2987 12.546 11.1204 12.7357C10.942 12.9253 10.8135 13.1383 10.735 13.3746L8.04881 12.9287C8.23383 12.2928 8.54463 11.7534 8.98122 11.3105C9.41781 10.8676 9.96035 10.5293 10.6089 10.2957C11.2574 10.0621 11.9864 9.94531 12.7959 9.94531C13.382 9.94531 13.9517 10.0147 14.5051 10.1536C15.0585 10.2925 15.5552 10.5097 15.9952 10.8053C16.4351 11.1009 16.7844 11.4831 17.043 11.952C17.3016 12.4208 17.4309 12.9868 17.4309 13.6498V21H14.6529V19.484H14.5568C14.3804 19.8223 14.1458 20.1212 13.853 20.3809C13.5602 20.6405 13.208 20.8439 12.7965 20.991C12.3849 21.1381 11.9085 21.2117 11.3674 21.2117ZM12.1922 19.158C12.6534 19.158 13.0585 19.0662 13.4075 18.8826C13.7565 18.699 14.0298 18.4512 14.2272 18.1392C14.4247 17.8273 14.5234 17.4798 14.5234 17.0969V15.9155C14.4342 15.9755 14.3026 16.0318 14.1285 16.0843C13.9544 16.1368 13.7602 16.1839 13.5459 16.2254C13.3316 16.2669 13.12 16.303 12.9111 16.3335C12.7023 16.364 12.5167 16.3908 12.3545 16.4139C11.9946 16.4625 11.6782 16.5449 11.4053 16.6613C11.1324 16.7778 10.9204 16.9334 10.7694 17.1283C10.6184 17.3232 10.5428 17.5675 10.5428 17.8611C10.5428 18.1438 10.6141 18.3813 10.7567 18.5737C10.8993 18.7661 11.0941 18.9116 11.3412 19.0101C11.5884 19.1087 11.872 19.158 12.1922 19.158ZM24.3084 21.2133C23.2133 21.2133 22.2667 20.978 21.4685 20.5075C20.6704 20.037 20.055 19.3795 19.6225 18.5349C19.1901 17.6903 18.9738 16.7081 18.9738 15.5883C18.9738 14.4595 19.1901 13.4721 19.6225 12.626C20.055 11.7799 20.6704 11.1216 21.4685 10.6511C22.2667 10.1806 23.2133 9.94531 24.3084 9.94531C24.9588 9.94531 25.5571 10.0295 26.1032 10.1979C26.6493 10.3662 27.1336 10.6071 27.5561 10.9205C27.9786 11.2339 28.3263 11.6147 28.5993 12.0629C28.8722 12.5111 29.0607 13.015 29.1647 13.5747L26.4416 14.0848C26.381 13.8013 26.2896 13.5468 26.1673 13.3212C26.0449 13.0957 25.8955 12.9028 25.7188 12.7425C25.5422 12.5823 25.3384 12.4603 25.1075 12.3764C24.8766 12.2926 24.6208 12.2506 24.3401 12.2506C23.8183 12.2506 23.3811 12.391 23.0284 12.6716C22.6756 12.9523 22.4091 13.3421 22.2287 13.841C22.0483 14.34 21.9581 14.9189 21.9581 15.5777C21.9581 16.2271 22.0483 16.8022 22.2287 17.3032C22.4091 17.8042 22.6756 18.1969 23.0284 18.4813C23.3811 18.7657 23.8183 18.908 24.3401 18.908C24.6238 18.908 24.8826 18.8644 25.1165 18.7773C25.3504 18.6902 25.5581 18.5641 25.7394 18.3992C25.9208 18.2342 26.0727 18.0333 26.195 17.7964C26.3173 17.5596 26.407 17.2947 26.464 17.0017L29.1827 17.5066C29.0816 18.0828 28.8939 18.5982 28.6195 19.0529C28.3451 19.5076 27.9967 19.8964 27.5745 20.2193C27.1522 20.5422 26.6656 20.7886 26.1148 20.9585C25.5639 21.1284 24.9618 21.2133 24.3084 21.2133ZM35.6328 21.2133C34.5184 21.2133 33.5575 20.9851 32.7504 20.5286C31.9432 20.0722 31.3233 19.424 30.8905 18.5842C30.4578 17.7443 30.2414 16.7487 30.2414 15.5973C30.2414 14.474 30.4564 13.4885 30.8864 12.6409C31.3164 11.7933 31.9246 11.1322 32.711 10.6574C33.4974 10.1827 34.4223 9.94531 35.4858 9.94531C36.1988 9.94531 36.865 10.0589 37.4844 10.2861C38.1038 10.5134 38.6474 10.856 39.1152 11.3141C39.5829 11.7721 39.9483 12.3477 40.2112 13.0408C40.4741 13.7339 40.6055 14.5481 40.6055 15.4834V16.3055H31.4433V14.4625H39.1783L37.8095 14.9566C37.8095 14.3881 37.7227 13.8941 37.5491 13.4746C37.3755 13.0551 37.1183 12.7297 36.7775 12.4983C36.4368 12.2669 36.0132 12.1512 35.5068 12.1512C35.0005 12.1512 34.5709 12.2684 34.2182 12.5028C33.8655 12.7371 33.5971 13.0551 33.4129 13.4567C33.2288 13.8582 33.1368 14.3148 33.1368 14.8264V16.1238C33.1368 16.7553 33.2425 17.2859 33.4539 17.7154C33.6653 18.145 33.9626 18.4677 34.3458 18.6836C34.7291 18.8994 35.1737 19.0074 35.6795 19.0074C36.0213 19.0074 36.3319 18.9587 36.6114 18.8614C36.8909 18.7641 37.1312 18.6199 37.3324 18.4291C37.5336 18.2382 37.6867 18.0029 37.7918 17.7232L40.4403 18.2131C40.264 18.8162 39.9582 19.3428 39.5229 19.7929C39.0876 20.2429 38.5422 20.5922 37.8867 20.8406C37.2313 21.0891 36.48 21.2133 35.6328 21.2133ZM48.2268 21.1816C47.6352 21.1816 47.1339 21.0813 46.723 20.8806C46.3121 20.6799 45.9787 20.4316 45.7227 20.1359C45.4667 19.8402 45.2699 19.5458 45.1321 19.2525H44.9895V21H42.109V6.44922H45.0376V11.9197H45.1321C45.2663 11.6295 45.4582 11.3319 45.7077 11.0269C45.9572 10.7218 46.2876 10.4653 46.699 10.2573C47.1104 10.0493 47.6252 9.94531 48.2434 9.94531C49.0529 9.94531 49.792 10.1538 50.4608 10.5709C51.1295 10.9879 51.6652 11.6128 52.0679 12.4453C52.4706 13.2779 52.6719 14.316 52.6719 15.5598C52.6719 16.7714 52.4766 17.7951 52.086 18.6309C51.6954 19.4667 51.1648 20.1008 50.4943 20.5331C49.8238 20.9655 49.068 21.1816 48.2268 21.1816ZM47.325 18.8341C47.8363 18.8341 48.2652 18.6941 48.6117 18.4142C48.9582 18.1343 49.2206 17.7467 49.399 17.2515C49.5774 16.7564 49.6666 16.1894 49.6666 15.5508C49.6666 14.9116 49.5781 14.3474 49.4012 13.8582C49.2243 13.369 48.9627 12.9858 48.6162 12.7086C48.2697 12.4314 47.8393 12.2928 47.325 12.2928C46.8232 12.2928 46.3972 12.4269 46.0469 12.6952C45.6967 12.9634 45.4306 13.3406 45.2487 13.8268C45.0668 14.313 44.9758 14.8876 44.9758 15.5508C44.9758 16.2069 45.0675 16.7809 45.2509 17.2728C45.4343 17.7647 45.7019 18.1479 46.0537 18.4224C46.4054 18.6969 46.8292 18.8341 47.325 18.8341ZM59.1027 21.2133C58.0077 21.2133 57.0602 20.978 56.2602 20.5075C55.4603 20.037 54.8441 19.3795 54.4116 18.5349C53.9791 17.6903 53.7629 16.7081 53.7629 15.5883C53.7629 14.4595 53.9791 13.4721 54.4116 12.626C54.8441 11.7799 55.4603 11.1216 56.2602 10.6511C57.0602 10.1806 58.0077 9.94531 59.1027 9.94531C60.2008 9.94531 61.1488 10.1806 61.9467 10.6511C62.7446 11.1216 63.3598 11.7799 63.7923 12.626C64.2248 13.4721 64.4411 14.4595 64.4411 15.5883C64.4411 16.7081 64.2248 17.6903 63.7923 18.5349C63.3598 19.3795 62.7446 20.037 61.9467 20.5075C61.1488 20.978 60.2008 21.2133 59.1027 21.2133ZM59.1027 18.908C59.624 18.908 60.0598 18.7631 60.4102 18.4734C60.7607 18.1837 61.0235 17.7875 61.1986 17.2847C61.3737 16.782 61.4613 16.213 61.4613 15.5777C61.4613 14.9359 61.3737 14.3648 61.1986 13.8644C61.0235 13.3639 60.7607 12.9699 60.4102 12.6822C60.0598 12.3945 59.624 12.2506 59.1027 12.2506C58.581 12.2506 58.1455 12.3945 57.7963 12.6822C57.4471 12.9699 57.185 13.3632 57.0098 13.8621C56.8347 14.3611 56.7471 14.9329 56.7471 15.5777C56.7471 16.213 56.8347 16.782 57.0098 17.2847C57.185 17.7875 57.4471 18.1837 57.7963 18.4734C58.1455 18.7631 58.581 18.908 59.1027 18.908ZM70.8684 21.2133C69.7733 21.2133 68.8258 20.978 68.0259 20.5075C67.2259 20.037 66.6097 19.3795 66.1772 18.5349C65.7447 17.6903 65.5285 16.7081 65.5285 15.5883C65.5285 14.4595 65.7447 13.4721 66.1772 12.626C66.6097 11.7799 67.2259 11.1216 68.0259 10.6511C68.8258 10.1806 69.7733 9.94531 70.8684 9.94531C71.9664 9.94531 72.9144 10.1806 73.7123 10.6511C74.5103 11.1216 75.1255 11.7799 75.5579 12.626C75.9904 13.4721 76.2067 14.4595 76.2067 15.5883C76.2067 16.7081 75.9904 17.6903 75.5579 18.5349C75.1255 19.3795 74.5103 20.037 73.7123 20.5075C72.9144 20.978 71.9664 21.2133 70.8684 21.2133ZM70.8684 18.908C71.3896 18.908 71.8254 18.7631 72.1759 18.4734C72.5263 18.1837 72.7891 17.7875 72.9642 17.2847C73.1393 16.782 73.2269 16.213 73.2269 15.5777C73.2269 14.9359 73.1393 14.3648 72.9642 13.8644C72.7891 13.3639 72.5263 12.9699 72.1759 12.6822C71.8254 12.3945 71.3896 12.2506 70.8684 12.2506C70.3466 12.2506 69.9112 12.3945 69.562 12.6822C69.2128 12.9699 68.9506 13.3632 68.7755 13.8621C68.6003 14.3611 68.5128 14.9329 68.5128 15.5777C68.5128 16.213 68.6003 16.782 68.7755 17.2847C68.9506 17.7875 69.2128 18.1837 69.562 18.4734C69.9112 18.7631 70.3466 18.908 70.8684 18.908ZM80.4053 17.802V14.2794H80.8489L84.4199 10.082H87.8053L83.0888 15.5576H82.3977L80.4053 17.802ZM77.7476 21V6.44922H80.6762V21H77.7476ZM84.5623 21L81.2897 16.212L83.2464 14.1332L88.0153 21H84.5623Z",
            fill: "#1877F2"
        })
    });
}
/** Figma MeitY stat tiles — 44×48, gradient squircle + blue glyph */ function $50e4f2d0505d6b18$var$MeityStatDocumentLogo({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        className: className,
        width: 44,
        height: 48,
        viewBox: "0 0 44 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                y: "4",
                width: "44",
                height: "44",
                rx: "12",
                fill: "url(#meity_stat_doc_grad)"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M23.9698 27.3618C23.7717 27.5598 23.6267 27.8046 23.5482 28.0735L22.8507 30.4651C22.8081 30.6112 22.8485 30.7688 22.956 30.8764C23.0636 30.984 23.2213 31.0244 23.3673 30.9818L25.759 30.2843C26.0279 30.2058 26.2726 30.0608 26.4707 29.8626L29.8148 26.5218C30.5061 25.8305 30.5061 24.7097 29.8148 24.0185C29.1236 23.3272 28.0028 23.3272 27.3115 24.0185L23.9698 27.3618",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M24.0728 22.5477C23.8212 22.3973 23.6671 22.1258 23.667 21.8327V17.666",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M28.6663 32.3702V32.666C28.6663 33.5865 27.9201 34.3327 26.9997 34.3327H16.9997C16.0792 34.3327 15.333 33.5865 15.333 32.666V19.3327C15.333 18.4122 16.0792 17.666 16.9997 17.666H23.6663C24.1991 17.6652 24.7103 17.8769 25.0863 18.2544L27.183 20.351",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M18.667 31H19.5003",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("linearGradient", {
                    id: "meity_stat_doc_grad",
                    x1: "0",
                    y1: "4",
                    x2: "44",
                    y2: "48",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            stopColor: "#0F3CC9",
                            stopOpacity: "0.1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8E51FF",
                            stopOpacity: "0.1"
                        })
                    ]
                })
            })
        ]
    });
}
function $50e4f2d0505d6b18$var$MeityStatRefreshLogo({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        className: className,
        width: 44,
        height: 48,
        viewBox: "0 0 44 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                y: "4",
                width: "44",
                height: "44",
                rx: "12",
                fill: "url(#meity_stat_refresh_grad)"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M14.5 26C14.5 30.1394 17.8606 33.5 22 33.5C26.1394 33.5 29.5 30.1394 29.5 26C29.5 21.8606 26.1394 18.5 22 18.5C19.9033 18.5079 17.8908 19.326 16.3833 20.7833L14.5 22.6667",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M14.5 18.5V22.6667H18.6667",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("linearGradient", {
                    id: "meity_stat_refresh_grad",
                    x1: "0",
                    y1: "4",
                    x2: "44",
                    y2: "48",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            stopColor: "#0F3CC9",
                            stopOpacity: "0.1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8E51FF",
                            stopOpacity: "0.1"
                        })
                    ]
                })
            })
        ]
    });
}
function $50e4f2d0505d6b18$var$MeityStatChecklistLogo({ className: className }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("svg", {
        className: className,
        width: 44,
        height: 48,
        viewBox: "0 0 44 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("rect", {
                y: "4",
                width: "44",
                height: "44",
                rx: "12",
                fill: "url(#meity_stat_list_grad)"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M22.833 20.166H29.4997",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M22.833 26H29.4997",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M22.833 31.834H29.4997",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M14.5 30.1667L16.1667 31.8333L19.5 28.5",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                d: "M14.5 21.8327L16.1667 23.4993L19.5 20.166",
                stroke: "#0F3CC9",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("linearGradient", {
                    id: "meity_stat_list_grad",
                    x1: "0",
                    y1: "4",
                    x2: "44",
                    y2: "48",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            stopColor: "#0F3CC9",
                            stopOpacity: "0.1"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#8E51FF",
                            stopOpacity: "0.1"
                        })
                    ]
                })
            })
        ]
    });
}
// ─── Data ───────────────────────────────────────────────────────────────────
/* Desktop keeps Figma <br> lines; mobile joins with spaces so words are not glued. */ function $50e4f2d0505d6b18$var$ResponsiveCopy({ lines: lines }) {
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                className: "lp-copy-desktop",
                children: lines.map((line, index)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1OEoy))).Fragment, {
                        children: [
                            index > 0 ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("br", {}) : null,
                            line
                        ]
                    }, `${index}-${line}`))
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                className: "lp-copy-mobile",
                children: lines.join(" ")
            })
        ]
    });
}
const $50e4f2d0505d6b18$var$scrollToSection = (id)=>document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
const $50e4f2d0505d6b18$var$INITIAL_DEMO_FORM = {
    fullName: "",
    workEmail: "",
    company: "",
    phone: "",
    jobTitle: "",
    message: "",
    consent: false
};
const $50e4f2d0505d6b18$var$MEITY_STATS = [
    {
        value: "50+ Million",
        label: "Consents created successfully",
        Icon: $50e4f2d0505d6b18$var$MeityStatDocumentLogo,
        figmaLogo: true
    },
    {
        value: "3+ Lakh",
        label: "Consents revoked transparently by users",
        Icon: $50e4f2d0505d6b18$var$MeityStatRefreshLogo,
        figmaLogo: true
    },
    {
        value: "1.2 Billion",
        label: "Consents validated & tracked securely",
        Icon: $50e4f2d0505d6b18$var$MeityStatChecklistLogo,
        figmaLogo: true
    }
];
/* Figma platform grid: row1 = Consent + Cookie (3+3 cols); row2 = Grievance + Breach + ROPA (2+2+2 cols). Order must match CSS nth-child placement. */ const $50e4f2d0505d6b18$var$PLATFORM_FEATURES = [
    {
        id: "consent",
        title: "Consent Management",
        description: "Capture, store, and manage user consent across all touchpoints with tamper-proof audit trails and purpose-linked records built for DPDP Act.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($ffd2848f0f304742$exports)))
    },
    {
        id: "cookie",
        title: "Cookie Consent",
        description: "Deploy regulation-aware cookie banners with auto-scan, script blocking, and geo-aware display rules. Fully customizable to match\u00A0your\u00A0brand.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($8dac715920530391$exports)))
    },
    {
        id: "grievance",
        /* Line 1 / line 2 per layout spec (Figma) */ title: "Grievance Redressal and\nData Principal Rights",
        description: "Give users a structured channel to raise concerns and exercise their rights. Every request can be tracked from submission to resolution, within statutory timelines.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($202495ba22096c1d$exports)))
    },
    {
        id: "breach",
        title: "Breach Notifications",
        description: "Log incidents, classify risk, and manage data breach notifications from a single workflow. Every breach is recorded with full metadata and routed to your DPO (Data Protection Officer) for review before any notification goes out.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($383bd2520a9baf55$exports))),
        hideReadMore: true
    },
    {
        title: "Record of Processing Activities (ROPA)",
        description: "Maintain a comprehensive Record of Processing Activities. Auto-generate and keep your ROPA up to date with real-time data flow mapping. Always audit-ready, never out of date.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($97225e6c04be7242$exports))),
        hideReadMore: true
    }
];
/* Figma: Consent Management “Read more” modal (first platform card only) */ const $50e4f2d0505d6b18$var$CONSENT_READ_MORE_MODAL = {
    eyebrow: "CONSENT MANAGEMENT",
    title: "Collect, manage, and prove user consent at scale",
    lead: "Every consent interaction is captured, stored and linked to a purpose with tamper-proof audit trails that hold up under scrutiny. Manage the full lifecycle from collection to withdrawal, across every channel your users touch.",
    bullets: [
        "Granular consent capture linked to specific purposes, durations, and processing activities",
        "Automated lifecycle management \u2014 renewals, withdrawals, and expiry handled without manual intervention",
        "Multi-language support and templates aligned to DPDPA notice requirements",
        "Real-time consent status dashboard with compliance scoring",
        "Integrates with any platforms like CRMs, CDPs, etc."
    ]
};
/* Figma: Cookie Consent “Read more” modal (second platform card) — art: assetsM/illustration-02-cookie-consent.svg */ const $50e4f2d0505d6b18$var$COOKIE_READ_MORE_MODAL = {
    eyebrow: "COOKIE CONSENT",
    title: "Cookie compliance that enforces itself",
    lead: "Deploy a fully configurable consent banner across your websites and apps. Every preference is captured immutably, enforced consistently, and logged for audit without engineering overhead.",
    bullets: [
        "Configurable banner with category-based consent: Essential, Functional, Analytics, Marketing",
        "Preference recall across sessions and devices",
        "Multi-language support and branding customisation",
        "Script blocking so third-party trackers don't fire until consent is given",
        "Immutable audit log of every preference change"
    ]
};
/* Grievance (third platform card) “Read more” — art: assetsM/illustration-03-grievance-redressal.svg; same modal shell as Consent/Cookie */ const $50e4f2d0505d6b18$var$GRIEVANCE_READ_MORE_MODAL = {
    eyebrow: "GRIEVANCE & PRINCIPAL RIGHTS",
    title: "Every rights request handled on time and on record",
    leadParagraphs: [
        "Data Principals submit requests - access, correction, erasure, withdrawal - through a structured embedded journey. Each request becomes a digitally signed, immutable record.",
        "Your team works through requests based on defined workflows with SLA tracking, escalation paths, automated notifications and complete audit tracking."
    ],
    bullets: [
        {
            head: "Full rights coverage:",
            tail: " access, correction, erasure, objection, withdrawal"
        },
        {
            head: "Digitally signed, tamper-proof grievance records",
            tail: " from submission"
        },
        {
            head: "SLA-based workflows",
            tail: " with automatic escalation and deadline tracking"
        },
        {
            head: "Automated notifications",
            tail: " keeping Data Principals informed at every stage"
        },
        {
            head: "Complete audit trail",
            tail: " on every action taken against every request"
        }
    ]
};
/* How it works — “Read more” modals (fourth screen); same shell as platform modals; art from assetsM */ const $50e4f2d0505d6b18$var$HOW_READ_MORE_STEP1 = {
    eyebrow: "STEP 1",
    title: "Connect & Configure",
    lead: "Integrate across your Data Fiduciary portals, processor systems, and user-facing applications using standard APIs and pre-built UI components. Authentication runs on OAuth. Once connected, Secure Code and Consent Handle identifiers map every session to the right tenant, business unit, and purpose across web, mobile, WebView, and POS. Every user action is recorded with a digital signature and an immutable transaction log. Signed callbacks keep your downstream systems in sync in real time.",
    bullets: [
        "OAuth-based authentication and secure API integration",
        "Secure Code and Consent Handle generation for accurate session mapping",
        "SDK and embedded UI components for web, mobile, WebView, and POS",
        "Digitally signed, immutable transaction recording",
        "Real-time signed callbacks for system synchronisation"
    ]
};
const $50e4f2d0505d6b18$var$HOW_READ_MORE_STEP2 = {
    eyebrow: "STEP 2",
    title: "Monitor & Manage",
    lead: "Every system event \u2014 consent, grievance, configuration change, login, notification \u2014 is written to an append-only, cryptographically verifiable audit ledger. Hash-chaining and encrypted payload references ensure records cannot be altered after the fact. Compliance teams, internal auditors, and regulators can search, verify, and export activity across the full event history.",
    bullets: [
        "Immutable, append-only audit ledger with hash-chaining",
        "Cryptographically verifiable records across all event types",
        "Advanced search and reporting for compliance and audit teams"
    ]
};
const $50e4f2d0505d6b18$var$HOW_READ_MORE_STEP3 = {
    eyebrow: "STEP 3",
    title: "Report & Certify",
    lead: "Dashboards and reports covering key compliance and operational metrics such as consent trends, withdrawal patterns, SLA performance, purpose-level analytics, parental consent activity, and grievance resolution timelines. These insights support governance, compliance tracking, and privacy strategy by enabling data-driven decision-making, improving visibility into system performance, and ensuring regulatory readiness. Key capabilities:",
    bullets: [
        "Real-time dashboards and comprehensive scheduled reports",
        "Consent and withdrawal trend analysis",
        "SLA performance monitoring",
        "Purpose-level analytics",
        "Parental consent tracking",
        "Grievance resolution insights",
        "Designed for governance, compliance, and decision-making"
    ]
};
function $50e4f2d0505d6b18$var$getReadMoreModalBundle(modal) {
    if (!modal) return null;
    const bundles = {
        consent: {
            copy: $50e4f2d0505d6b18$var$CONSENT_READ_MORE_MODAL,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($d7bc9d3e0c846881$exports))),
            titleId: "lp-consent-modal-title"
        },
        cookie: {
            copy: $50e4f2d0505d6b18$var$COOKIE_READ_MORE_MODAL,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($8dac715920530391$exports))),
            titleId: "lp-cookie-modal-title"
        },
        grievance: {
            copy: $50e4f2d0505d6b18$var$GRIEVANCE_READ_MORE_MODAL,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($202495ba22096c1d$exports))),
            titleId: "lp-grievance-modal-title"
        },
        howStep1: {
            copy: $50e4f2d0505d6b18$var$HOW_READ_MORE_STEP1,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($c2027efb4c3be92a$exports))),
            titleId: "lp-how-modal-title-step1"
        },
        howStep2: {
            copy: $50e4f2d0505d6b18$var$HOW_READ_MORE_STEP2,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($95805b726ec151be$exports))),
            titleId: "lp-how-modal-title-step2"
        },
        howStep3: {
            copy: $50e4f2d0505d6b18$var$HOW_READ_MORE_STEP3,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($b42af5140253d38f$exports))),
            titleId: "lp-how-modal-title-step3"
        }
    };
    return bundles[modal] ?? null;
}
const $50e4f2d0505d6b18$var$HOW_STEPS = [
    {
        badge: "Step 1",
        title: "Connect & Configure",
        readMoreKey: "howStep1",
        description: "One integration covers web, mobile, WebView, and POS. Sessions are mapped to the right tenant, purpose, and user.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($c2027efb4c3be92a$exports)))
    },
    {
        badge: "Step 2",
        title: "Monitor & Manage",
        readMoreKey: "howStep2",
        description: "Every system event is written to a tamper-evident, cryptographically verifiable audit ledger.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($95805b726ec151be$exports)))
    },
    {
        badge: "Step 3",
        title: "Report & Certify",
        readMoreKey: "howStep3",
        description: "Dashboards and scheduled reports built for compliance teams, auditors, and regulators.",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($b42af5140253d38f$exports)))
    }
];
const $50e4f2d0505d6b18$var$FAQ_LIST = [
    {
        question: "What is a Consent Management System (CMS)?",
        answer: "A Consent Management System is a platform that helps organizations collect, store, manage, and track user consent for personal data processing. It ensures that businesses remain compliant with data privacy regulations like the DPDP Act, 2023."
    },
    {
        question: "Why is consent management important under the DPDP Act 2023?",
        answer: "The DPDP Act, 2023 mandates that organizations obtain explicit, informed consent before collecting or processing personal data. A CMS ensures you capture valid consent, maintain audit trails, and respond to user requests within regulatory timelines."
    },
    {
        question: "Can a Data Fiduciary update a consent once it has been given?",
        answer: "A Data Fiduciary can request updated consent if the purpose of data processing changes. The CMS facilitates this by notifying the Data Principal and capturing fresh consent with a clear audit trail of the change."
    },
    {
        question: "What happens if a Data Principal withdraws consent?",
        answer: "When a Data Principal withdraws consent, the CMS immediately updates the consent status and triggers downstream workflows to stop data processing. All withdrawal actions are logged with timestamps for compliance records."
    },
    {
        question: "How are grievances handled in the CMS?",
        answer: "The CMS provides a dedicated grievance portal where Data Principals can raise privacy concerns. Each grievance is tracked from submission to resolution with SLA monitoring and automated escalation workflows."
    },
    {
        question: "Does the CMS support multi language consent collection?",
        answer: "Yes. The CMS supports multi language consent forms, banners, and preference centers, allowing organizations to communicate with users in their preferred language across all touchpoints."
    },
    {
        question: "How does CMS handle cookie consent?",
        answer: "The CMS automatically scans your website for cookies and trackers, categorizes them, and deploys customizable consent banners. Non-essential cookies are blocked until the user provides explicit consent."
    }
];
const $50e4f2d0505d6b18$var$FINAL_TRUST_BADGES = [
    {
        label: "DPDPA Compliant",
        IconComponent: $50e4f2d0505d6b18$var$FinalTrustDpdpaShieldIcon
    },
    {
        label: "MeitY Approved",
        IconComponent: $50e4f2d0505d6b18$var$FinalTrustMeitYBuildingIcon
    },
    {
        label: "SOC 2 Audited",
        IconComponent: $50e4f2d0505d6b18$var$FinalTrustSoc2VerifiedIcon
    },
    {
        label: "ISO 27001 Certified",
        IconComponent: $50e4f2d0505d6b18$var$FinalTrustIsoPersonStarIcon
    }
];
// ─── Sub-components ─────────────────────────────────────────────────────────
function $50e4f2d0505d6b18$var$PlatformFeatureCard({ id: id, title: title, description: description, renderIcon: renderIcon, illustration: illustration, showReadMore: showReadMore, hideReadMore: hideReadMore, onReadMoreClick: onReadMoreClick }) {
    const cardClass = [
        "lp-platform-card",
        id && `lp-platform-card--${id}`,
        illustration && "lp-platform-card--illustration"
    ].filter(Boolean).join(" ");
    const showLink = illustration && !hideReadMore || showReadMore;
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("article", {
        className: cardClass,
        children: [
            illustration ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "lp-platform-card-visual",
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                    className: "lp-platform-card-visual-img",
                    src: illustration,
                    alt: "",
                    width: 578,
                    height: 180,
                    decoding: "async"
                })
            }) : /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "lp-platform-icon",
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$f04a61298a47a40f), {
                    color: "primary",
                    ic: renderIcon(),
                    kind: "background",
                    size: "medium"
                })
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                appearance: "heading-xs",
                color: "primary_grey_100",
                className: "lp-platform-card-title",
                children: title
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                appearance: "body-s",
                color: "primary_grey_80",
                className: "lp-platform-card-body",
                children: description
            }),
            showLink ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("a", {
                className: "lp-platform-read-more",
                href: onReadMoreClick ? "#" : "#lp-section-features",
                onClick: (e)=>{
                    e.preventDefault();
                    if (onReadMoreClick) onReadMoreClick();
                    else $50e4f2d0505d6b18$var$scrollToSection("lp-section-features");
                },
                children: [
                    "Read more",
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ArrowRightSVG, {
                        width: 20,
                        height: 20,
                        stroke: "#0A2885"
                    })
                ]
            }) : null
        ]
    });
}
// ─── Main component ──────────────────────────────────────────────────────────
const $50e4f2d0505d6b18$var$LandingPage = ()=>{
    const navigate = (0, $68bc5e6b1c17c80f$export$9770f232ac06a008)();
    const rootRef = (0, $1OEoy.useRef)(null);
    const sectionRefs = (0, $1OEoy.useRef)([]);
    const [faqOpen, setFaqOpen] = (0, $1OEoy.useState)(-1);
    const [readMoreModal, setReadMoreModal] = (0, $1OEoy.useState)(null); /* "consent" | "cookie" | "grievance" | "howStep1" | "howStep2" | "howStep3" | null */ 
    const [demoModal, setDemoModal] = (0, $1OEoy.useState)(null); /* null | "form" | "success" */ 
    const [demoForm, setDemoForm] = (0, $1OEoy.useState)($50e4f2d0505d6b18$var$INITIAL_DEMO_FORM);
    const [loginMenuOpen, setLoginMenuOpen] = (0, $1OEoy.useState)(false);
    const loginMenuRef = (0, $1OEoy.useRef)(null);
    const [mobileNavOpen, setMobileNavOpen] = (0, $1OEoy.useState)(false); /* ≤640px: nav links live behind the ☰ toggle */ 
    const mobileNavRef = (0, $1OEoy.useRef)(null);
    const closeDemoModal = ()=>{
        setDemoModal(null);
        setDemoForm($50e4f2d0505d6b18$var$INITIAL_DEMO_FORM);
    };
    const handleBookDemo = ()=>{
        setDemoForm($50e4f2d0505d6b18$var$INITIAL_DEMO_FORM);
        setDemoModal("form");
    };
    const handleDemoFormSubmit = (e)=>{
        e.preventDefault();
        const { fullName: fullName, workEmail: workEmail, company: company, consent: consent } = demoForm;
        if (!String(fullName).trim() || !String(workEmail).trim() || !String(company).trim() || !consent) return;
        setDemoModal("success");
    };
    const goToLogin = (url, envName)=>{
        if (!url) {
            console.warn(`${envName} is not configured`);
            return;
        }
        setLoginMenuOpen(false);
        window.location.href = url;
    };
    const handleLogin1 = ()=>goToLogin((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).loginUrl, "REACT_APP_LOGIN_URL");
    const handleLogin2 = ()=>goToLogin((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).loginUrl2, "REACT_APP_LOGIN_URL_2");
    const loginHint = (url)=>{
        if (!url) return "Not configured";
        try {
            return new URL(url).host || url;
        } catch  {
            return url;
        }
    };
    const handleDevDocs = ()=>{
        const docsUrl = ((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).docsUrl || "").trim();
        if (docsUrl) {
            window.location.assign(docsUrl);
            return;
        }
        console.warn("REACT_APP_DOCS_URL is not configured");
        navigate("/contact");
    };
    const arrowIcon = (px)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $a3134278bf70d277$export$a1075cdfac2f932), {
            width: px,
            height: px,
            style: {
                display: "block"
            },
            "aria-hidden": true
        });
    /* Single source for the primary nav so the desktop row and the ≤640px menu never drift apart. */ const navItems = [
        {
            label: "Features",
            id: "lp-section-features"
        },
        {
            label: "How It Works",
            id: "lp-section-how"
        },
        {
            label: "For Developers",
            onNavigate: handleDevDocs
        },
        {
            label: "FAQs",
            id: "lp-section-faq"
        }
    ];
    const goToNavItem = (item)=>{
        if (item.onNavigate) item.onNavigate();
        else $50e4f2d0505d6b18$var$scrollToSection(item.id);
    };
    (0, $1OEoy.useEffect)(()=>{
        if (!loginMenuOpen) return undefined;
        const onPointerDown = (e)=>{
            if (loginMenuRef.current && !loginMenuRef.current.contains(e.target)) setLoginMenuOpen(false);
        };
        const onKey = (e)=>{
            if (e.key === "Escape") setLoginMenuOpen(false);
        };
        document.addEventListener("mousedown", onPointerDown);
        window.addEventListener("keydown", onKey);
        return ()=>{
            document.removeEventListener("mousedown", onPointerDown);
            window.removeEventListener("keydown", onKey);
        };
    }, [
        loginMenuOpen
    ]);
    /* Mirrors the Log In dropdown: close on outside tap, Escape, or when the
     viewport grows past the mobile breakpoint (so it can't stay stuck open). */ (0, $1OEoy.useEffect)(()=>{
        if (!mobileNavOpen) return undefined;
        const onPointerDown = (e)=>{
            if (mobileNavRef.current && !mobileNavRef.current.contains(e.target)) setMobileNavOpen(false);
        };
        const onKey = (e)=>{
            if (e.key === "Escape") setMobileNavOpen(false);
        };
        const onResize = ()=>{
            if (window.innerWidth > 640) setMobileNavOpen(false);
        };
        document.addEventListener("mousedown", onPointerDown);
        window.addEventListener("keydown", onKey);
        window.addEventListener("resize", onResize);
        return ()=>{
            document.removeEventListener("mousedown", onPointerDown);
            window.removeEventListener("keydown", onKey);
            window.removeEventListener("resize", onResize);
        };
    }, [
        mobileNavOpen
    ]);
    (0, $1OEoy.useEffect)(()=>{
        if (!readMoreModal) return undefined;
        const onKey = (e)=>{
            if (e.key === "Escape") setReadMoreModal(null);
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        readMoreModal
    ]);
    (0, $1OEoy.useEffect)(()=>{
        if (!demoModal) return undefined;
        const onKey = (e)=>{
            if (e.key === "Escape") {
                setDemoModal(null);
                setDemoForm($50e4f2d0505d6b18$var$INITIAL_DEMO_FORM);
            }
        };
        window.addEventListener("keydown", onKey);
        return ()=>window.removeEventListener("keydown", onKey);
    }, [
        demoModal
    ]);
    (0, $1OEoy.useEffect)(()=>{
        const root = rootRef.current;
        if (!root) return;
        const prevBody = document.body.style.overflow;
        const prevHtml = document.documentElement.style.overflow;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        const sections = sectionRefs.current.filter(Boolean);
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("is-visible");
            });
        }, {
            threshold: [
                0.05,
                0.35,
                0.65
            ],
            root: root
        });
        sections.forEach((s)=>observer.observe(s));
        return ()=>{
            observer.disconnect();
            document.body.style.overflow = prevBody;
            document.documentElement.style.overflow = prevHtml;
        };
    }, []);
    const readMoreBundle = $50e4f2d0505d6b18$var$getReadMoreModalBundle(readMoreModal);
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)((0, $ddff9b86434e3f59$export$e5cf4eff53e7947d), {
        value: {
            theme: "JioBase",
            mode: "light"
        },
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                className: "lp-root",
                ref: rootRef,
                role: "main",
                children: [
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                        className: "lp-scroll-section",
                        ref: (el)=>{
                            sectionRefs.current[0] = el;
                        },
                        "aria-label": "Introduction",
                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("section", {
                            className: "lp-hero",
                            "aria-label": "Introduction",
                            children: [
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                    className: "lp-hero-blobs",
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("header", {
                                    className: "lp-navbar",
                                    role: "banner",
                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                        className: "lp-navbar-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                className: "lp-brand",
                                                children: [
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                        className: "lp-brand-logo",
                                                        "aria-label": "Jio",
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$JioLogoSVG, {
                                                            width: 36,
                                                            height: 36
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                        className: "lp-brand-title",
                                                        children: "Consent Management"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("nav", {
                                                className: "lp-hero-nav",
                                                "aria-label": "Primary navigation",
                                                children: navItems.map((item)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "lp-hero-nav-link",
                                                        onClick: ()=>goToNavItem(item),
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                            className: "lp-nav-label",
                                                            children: item.label
                                                        })
                                                    }, item.id || item.label))
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                className: "lp-navbar-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                        className: "lp-login-menu",
                                                        ref: loginMenuRef,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                                type: "button",
                                                                className: `lp-nav-btn lp-nav-btn--login${loginMenuOpen ? " is-open" : ""}`,
                                                                onClick: ()=>setLoginMenuOpen((open)=>!open),
                                                                "aria-haspopup": "menu",
                                                                "aria-expanded": loginMenuOpen,
                                                                "aria-controls": "lp-login-menu",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                        className: "lp-nav-btn-label lp-nav-btn-label--login",
                                                                        children: "Log In"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                        className: "lp-login-caret",
                                                                        "aria-hidden": true,
                                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("svg", {
                                                                            width: "12",
                                                                            height: "12",
                                                                            viewBox: "0 0 12 12",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("path", {
                                                                                d: "M2.5 4.5L6 8L9.5 4.5",
                                                                                stroke: "#0A2885",
                                                                                strokeWidth: "1.5",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            loginMenuOpen ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                                className: "lp-login-dropdown",
                                                                id: "lp-login-menu",
                                                                role: "menu",
                                                                "aria-label": "Choose login destination",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "lp-login-option",
                                                                        role: "menuitem",
                                                                        onClick: handleLogin1,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                className: "lp-login-option-title",
                                                                                children: "V1"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                className: "lp-login-option-hint",
                                                                                children: loginHint((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).loginUrl)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "lp-login-option",
                                                                        role: "menuitem",
                                                                        onClick: handleLogin2,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                className: "lp-login-option-title",
                                                                                children: "V2"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                className: "lp-login-option-hint",
                                                                                children: loginHint((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).loginUrl2)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "lp-nav-btn lp-nav-btn--demo",
                                                        onClick: handleBookDemo,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-nav-btn-label lp-nav-btn-label--demo",
                                                                children: "Request Demo"
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-nav-btn-icon",
                                                                "aria-hidden": true,
                                                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ArrowRightSVG, {
                                                                    width: 16,
                                                                    height: 16,
                                                                    stroke: "white"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                        className: "lp-mobile-nav",
                                                        ref: mobileNavRef,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                                                type: "button",
                                                                className: `lp-nav-toggle${mobileNavOpen ? " is-open" : ""}`,
                                                                onClick: ()=>setMobileNavOpen((open)=>!open),
                                                                "aria-haspopup": "menu",
                                                                "aria-expanded": mobileNavOpen,
                                                                "aria-controls": "lp-mobile-nav-menu",
                                                                "aria-label": mobileNavOpen ? "Close menu" : "Open menu",
                                                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("span", {
                                                                    className: "lp-nav-toggle-bars",
                                                                    "aria-hidden": true,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {}),
                                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {}),
                                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {})
                                                                    ]
                                                                })
                                                            }),
                                                            mobileNavOpen ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                                className: "lp-mobile-nav-menu",
                                                                id: "lp-mobile-nav-menu",
                                                                role: "menu",
                                                                "aria-label": "Primary navigation",
                                                                children: [
                                                                    navItems.map((item)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                                                            type: "button",
                                                                            className: "lp-mobile-nav-link",
                                                                            role: "menuitem",
                                                                            onClick: ()=>{
                                                                                setMobileNavOpen(false);
                                                                                goToNavItem(item);
                                                                            },
                                                                            children: item.label
                                                                        }, item.id || item.label)),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                                        className: "lp-mobile-nav-divider",
                                                                        role: "separator"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "lp-mobile-nav-link",
                                                                        role: "menuitem",
                                                                        onClick: ()=>{
                                                                            setMobileNavOpen(false);
                                                                            handleLogin1();
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                children: "Log In \u2014 V1"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                className: "lp-mobile-nav-hint",
                                                                                children: loginHint((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).loginUrl)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "lp-mobile-nav-link",
                                                                        role: "menuitem",
                                                                        onClick: ()=>{
                                                                            setMobileNavOpen(false);
                                                                            handleLogin2();
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                children: "Log In \u2014 V2"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                                className: "lp-mobile-nav-hint",
                                                                                children: loginHint((0, $bbcaa7587c1517b4$export$2e2bcd8739ae039).loginUrl2)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                                                        type: "button",
                                                                        className: "lp-mobile-nav-link lp-mobile-nav-link--demo",
                                                                        role: "menuitem",
                                                                        onClick: ()=>{
                                                                            setMobileNavOpen(false);
                                                                            handleBookDemo();
                                                                        },
                                                                        children: "Request Demo"
                                                                    })
                                                                ]
                                                            }) : null
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-hero-columns",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                            className: "lp-hero-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-hero-title-wrap",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("h1", {
                                                        className: "lp-hero-h1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("span", {
                                                                className: "lp-copy-desktop",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                        className: "lp-hero-h1-line",
                                                                        children: "Built for DPDPA."
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                        className: "lp-hero-h1-line",
                                                                        children: "Ready for any"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                        className: "lp-hero-h1-line",
                                                                        children: "organisation."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-copy-mobile",
                                                                children: "Built for DPDPA. Ready for any organisation."
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-hero-sub-wrap",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("p", {
                                                        className: "lp-hero-lead",
                                                        children: "From a single module to the full compliance suite \u2014 consent, cookie consent, rights, grievances, records, and breach management, all in one place. Whether you're getting started or managing compliance at scale, it fits."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-hero-cta",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "lp-hero-cta-btn",
                                                        onClick: handleBookDemo,
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-hero-cta-label",
                                                                children: "Request Demo"
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-hero-cta-icon",
                                                                "aria-hidden": true,
                                                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ArrowRightSVG, {
                                                                    width: 16,
                                                                    height: 16,
                                                                    stroke: "white"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                            className: "lp-hero-right",
                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e35c2be7584c895e$exports))),
                                                alt: "Consent management dashboard",
                                                className: "lp-hero-image",
                                                width: 592,
                                                height: 568,
                                                draggable: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                        className: "lp-scroll-section",
                        ref: (el)=>{
                            sectionRefs.current[1] = el;
                        },
                        "aria-label": "Trust and recognition",
                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("section", {
                            className: "lp-social-proof",
                            "aria-label": "Trust and recognition",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                className: "lp-social-proof-inner",
                                children: [
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                        className: "lp-meity-title-block",
                                        children: [
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h2", {
                                                className: "lp-meity-section-title",
                                                children: "Winners of MeitY Code for Consent Challenge"
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7a3e33b8fddfe1c3$exports))),
                                                alt: "Winners of MeitY Code for Consent Challenge",
                                                className: "lp-meity-winners-img",
                                                draggable: false
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                        className: "lp-meity-layout",
                                        children: [
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                className: "lp-meity-left",
                                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                    className: "lp-meity-left-content",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                            className: "lp-meity-ribbon",
                                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($af1149c758aedf06$exports))),
                                                                alt: "MeitY recognised",
                                                                className: "lp-meity-figma-ribbon",
                                                                width: 219,
                                                                height: 64,
                                                                draggable: false
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h3", {
                                                            className: "lp-proven-headline",
                                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ResponsiveCopy, {
                                                                lines: [
                                                                    "Proven at scale, recognised at the",
                                                                    "highest level"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("p", {
                                                            className: "lp-meity-desc",
                                                            children: "Selected among the top 2 solutions in India at MeitY's DPDP Code for Consent Challenge, competing against 65+ entries from across the country."
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                className: "lp-meity-right",
                                                children: $50e4f2d0505d6b18$var$MEITY_STATS.map((row)=>{
                                                    const StatIco = row.Icon;
                                                    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                        className: "lp-stat-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                                className: "lp-stat-icon",
                                                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                    className: `lp-stat-icon-box${row.figmaLogo ? " lp-stat-icon-box--figma" : ""}`,
                                                                    children: row.figmaLogo ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)(StatIco, {
                                                                        className: "lp-stat-figma-logo"
                                                                    }) : /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$f04a61298a47a40f), {
                                                                        color: "primary",
                                                                        ic: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)(StatIco, {}),
                                                                        kind: "background",
                                                                        size: "small"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                                className: "lp-stat-copy",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                                        appearance: "heading-xs",
                                                                        color: "primary_grey_100",
                                                                        className: "lp-stat-value",
                                                                        children: row.value
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                                        appearance: "body-s",
                                                                        color: "primary_grey_80",
                                                                        className: "lp-stat-desc",
                                                                        children: row.label
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, row.value);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                        className: "lp-trusted-block",
                                        children: [
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                appearance: "body-s-bold",
                                                color: "primary_grey_100",
                                                className: "lp-trusted-eyebrow",
                                                children: "TRUSTED BY BUSINESSES"
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                className: "lp-trusted-logos-row",
                                                role: "list",
                                                "aria-label": "Partner brands",
                                                children: [
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                        className: "lp-trusted-logo-slot lp-trusted-logo-slot--facebook",
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("span", {
                                                            className: "lp-trusted-fb-logo",
                                                            "aria-label": "Facebook",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$TrustedFacebookIcon, {
                                                                    className: "lp-trusted-fb-icon"
                                                                }),
                                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$TrustedFacebookWordmark, {
                                                                    className: "lp-trusted-fb-wordmark-svg"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                        className: "lp-trusted-logo-slot lp-trusted-logo-slot--jewels",
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$TrustedRelianceJewelsLogo, {
                                                            className: "lp-trusted-jewels-logo"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                        className: "lp-trusted-logo-slot lp-trusted-logo-slot--medical",
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$TrustedRelianceMedicalLogo, {
                                                            className: "lp-trusted-medical-logo"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                        className: "lp-scroll-section",
                        ref: (el)=>{
                            sectionRefs.current[2] = el;
                        },
                        "aria-label": "Platform features and how it works",
                        children: [
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("section", {
                                className: "lp-platform",
                                id: "lp-section-features",
                                "aria-label": "Platform features",
                                children: [
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                        className: "lp-platform-glow",
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                        className: "lp-platform-intro",
                                        children: [
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                appearance: "body-xs-bold",
                                                color: "primary_grey_60",
                                                className: "lp-platform-eyebrow",
                                                children: "PLATFORM FEATURES & MODULES"
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("h2", {
                                                className: "lp-platform-headline",
                                                children: [
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("span", {
                                                        className: "lp-copy-desktop",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-platform-headline-line lp-platform-headline-line--1",
                                                                children: "Complete compliance suite covering"
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-platform-headline-line lp-platform-headline-line--2",
                                                                children: "every obligation"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("span", {
                                                        className: "lp-copy-mobile",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-platform-headline-line",
                                                                children: "Complete compliance suite"
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-platform-headline-line",
                                                                children: "covering every obligation"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("p", {
                                                className: "lp-platform-lead",
                                                children: "Designed to work for teams of all sizes and connect with your existing systems and processes"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                        className: "lp-platform-grid lp-platform-grid--five",
                                        children: $50e4f2d0505d6b18$var$PLATFORM_FEATURES.map((card)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$PlatformFeatureCard, {
                                                ...card,
                                                onReadMoreClick: card.id === "consent" ? ()=>setReadMoreModal("consent") : card.id === "cookie" ? ()=>setReadMoreModal("cookie") : card.id === "grievance" ? ()=>setReadMoreModal("grievance") : undefined
                                            }, card.title))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("section", {
                                className: "lp-how",
                                id: "lp-section-how",
                                "aria-label": "How it works",
                                children: [
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                        appearance: "body-xs-bold",
                                        color: "primary_grey_60",
                                        children: "HOW IT WORKS"
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                        className: "lp-how-title",
                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h2", {
                                            className: "lp-how-headline",
                                            children: "Up and running in days, not months"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                        className: "lp-how-sub",
                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                            appearance: "body-m",
                                            color: "primary_grey_80",
                                            children: "Built on open standards and a modular API architecture, so your team can integrate, monitor, and report without rebuilding what you already have."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                        className: "lp-how-cards",
                                        children: $50e4f2d0505d6b18$var$HOW_STEPS.map((step)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("article", {
                                                className: "lp-how-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                        className: "lp-how-card-visual",
                                                        "aria-hidden": true,
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                                                            className: "lp-how-card-img",
                                                            src: step.illustration,
                                                            alt: "",
                                                            width: 410,
                                                            height: 280,
                                                            loading: "lazy",
                                                            decoding: "async"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                        className: "lp-how-card-body",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                className: "lp-how-step-badge",
                                                                children: step.badge
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                                appearance: "heading-xs",
                                                                color: "primary_grey_100",
                                                                className: "lp-how-card-title",
                                                                children: step.title
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                                appearance: "body-s",
                                                                color: "primary_grey_80",
                                                                className: "lp-how-card-desc",
                                                                children: step.description
                                                            }),
                                                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("a", {
                                                                className: "lp-how-read-more",
                                                                href: "#",
                                                                onClick: (e)=>{
                                                                    e.preventDefault();
                                                                    setReadMoreModal(step.readMoreKey);
                                                                },
                                                                children: [
                                                                    "Read more",
                                                                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ArrowRightSVG, {
                                                                        width: 20,
                                                                        height: 20,
                                                                        stroke: "#0A2885"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, step.badge))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                        className: "lp-scroll-section",
                        ref: (el)=>{
                            sectionRefs.current[3] = el;
                        },
                        "aria-label": "Developer hub, FAQ and contact",
                        children: [
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("section", {
                                className: "lp-dev-hub",
                                id: "lp-section-developers",
                                "aria-labelledby": "lp-dev-hub-heading",
                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-dev-hub-inner",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                            className: "lp-dev-hub-intro",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-dev-hub-head",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                        appearance: "body-xs-bold",
                                                        color: "primary_grey_60",
                                                        className: "lp-dev-hub-eyebrow",
                                                        children: "FOR DEVELOPERS"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-dev-hub-title",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("h2", {
                                                        id: "lp-dev-hub-heading",
                                                        className: "lp-dev-hub-heading",
                                                        children: [
                                                            "Detailed API references, SDK documentation, authentication",
                                                            "\u00A0",
                                                            "flows, and integration guides are in the Developer Hub"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-dev-hub-cta",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$353f5b6fc5456de1), {
                                                        kind: "secondary",
                                                        label: "Go to Developer Documentation \u2192",
                                                        size: "large",
                                                        onClick: handleDevDocs
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                            className: "lp-dev-graphic",
                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                                                className: "lp-dev-hub-illustration",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($11234c708a7aa4a0$exports))),
                                                alt: "",
                                                width: 1152,
                                                height: 330,
                                                decoding: "async",
                                                loading: "lazy"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("section", {
                                className: "lp-faq-section",
                                id: "lp-section-faq",
                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-faq-inner",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                            className: "lp-faq-head",
                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h2", {
                                                className: "lp-faq-headline",
                                                children: "Frequently asked questions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                            className: "lp-faq-list lp-faq-list--minimal",
                                            children: $50e4f2d0505d6b18$var$FAQ_LIST.map((item, index)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                    className: "lp-faq-item lp-faq-item--minimal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                            className: "lp-faq-q",
                                                            role: "button",
                                                            tabIndex: 0,
                                                            onClick: ()=>setFaqOpen(faqOpen === index ? -1 : index),
                                                            onKeyDown: (e)=>{
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    setFaqOpen(faqOpen === index ? -1 : index);
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                                    appearance: "body-s-bold",
                                                                    color: "primary_grey_100",
                                                                    children: item.question
                                                                }),
                                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                                    className: "lp-faq-plus",
                                                                    "aria-hidden": true,
                                                                    children: faqOpen === index ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$FaqToggleMinus, {}) : /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$FaqTogglePlus, {})
                                                                })
                                                            ]
                                                        }),
                                                        faqOpen === index && /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                            className: "lp-faq-a",
                                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                                appearance: "body-s",
                                                                color: "primary_grey_80",
                                                                children: item.answer
                                                            })
                                                        })
                                                    ]
                                                }, item.question))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("section", {
                                className: "lp-final-cta lp-final-cta--surface",
                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-final-inner",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                            className: "lp-final-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                    appearance: "heading-l",
                                                    color: "primary_grey_100",
                                                    className: "lp-final-headline",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ResponsiveCopy, {
                                                        lines: [
                                                            "Ready to simplify your",
                                                            "compliance journey?"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                                    className: "lp-final-sub",
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                        appearance: "body-m",
                                                        color: "primary_grey_80",
                                                        className: "lp-final-sub-lead",
                                                        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$ResponsiveCopy, {
                                                            lines: [
                                                                "Join leading enterprises that trust Jio Consent Management",
                                                                "to handle their data privacy effortlessly."
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                            className: "lp-final-cta-btn",
                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$353f5b6fc5456de1), {
                                                kind: "primary",
                                                label: "Request Demo",
                                                size: "medium",
                                                className: "lp-final-demo-btn",
                                                icon: arrowIcon(20),
                                                onClick: handleBookDemo
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                            className: "lp-final-trust-grid",
                                            children: $50e4f2d0505d6b18$var$FINAL_TRUST_BADGES.map((b)=>{
                                                const Ico = b.IconComponent;
                                                return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                                    className: "lp-final-trust-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                            className: "lp-final-trust-icon",
                                                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)(Ico, {})
                                                        }),
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                                            appearance: "body-s-bold",
                                                            color: "primary_grey_100",
                                                            children: b.label
                                                        })
                                                    ]
                                                }, b.label);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("footer", {
                                className: "lp-footer",
                                role: "contentinfo",
                                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-footer-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                            className: "lp-footer-brand",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                    className: "lp-footer-logo",
                                                    "aria-hidden": true,
                                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)($50e4f2d0505d6b18$var$JioLogoSVG, {
                                                        width: 32,
                                                        height: 32
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                    className: "lp-footer-copyright",
                                                    children: "Copyright \xa9 2026 Reliance Jio Infocomm Ltd. All rights reserved."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("nav", {
                                            className: "lp-footer-links",
                                            "aria-label": "Legal",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("a", {
                                                    className: "lp-footer-link",
                                                    href: "/pdf/privacy-policy",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        navigate("/pdf/privacy-policy");
                                                    },
                                                    children: "Policies"
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("a", {
                                                    className: "lp-footer-link",
                                                    href: "/pdf/terms-of-use",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        navigate("/pdf/terms-of-use");
                                                    },
                                                    children: "Terms & Conditions"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            readMoreModal && readMoreBundle ? /*#__PURE__*/ (0, $4ed43828a92c8386$exports.createPortal)(/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "lp-consent-modal-backdrop",
                role: "presentation",
                onClick: ()=>setReadMoreModal(null),
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                    className: "lp-consent-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": readMoreBundle.titleId,
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                            type: "button",
                            className: "lp-consent-modal-close",
                            "aria-label": "Close",
                            onClick: ()=>setReadMoreModal(null),
                            children: "\xd7"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                            className: "lp-consent-modal-grid",
                            children: [
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-consent-modal-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                            className: "lp-consent-modal-eyebrow",
                                            children: readMoreBundle.copy.eyebrow
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h2", {
                                            id: readMoreBundle.titleId,
                                            className: "lp-consent-modal-title",
                                            children: readMoreBundle.copy.title
                                        }),
                                        Array.isArray(readMoreBundle.copy.leadParagraphs) && readMoreBundle.copy.leadParagraphs.length > 0 ? readMoreBundle.copy.leadParagraphs.map((para, idx)=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("p", {
                                                className: "lp-consent-modal-lead",
                                                children: para
                                            }, idx)) : /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("p", {
                                            className: "lp-consent-modal-lead",
                                            children: readMoreBundle.copy.lead
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("ul", {
                                            className: "lp-consent-modal-list",
                                            children: readMoreBundle.copy.bullets.map((item, idx)=>{
                                                const key = typeof item === "string" ? item : `lp-modal-bullet-${idx}`;
                                                const line = typeof item === "string" ? item : /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)((0, $7a9adcfb845e594f$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("strong", {
                                                            children: item.head
                                                        }),
                                                        item.tail
                                                    ]
                                                });
                                                return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("li", {
                                                    className: "lp-consent-modal-li",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                            className: "lp-consent-modal-check",
                                                            "aria-hidden": true,
                                                            children: "\u2713"
                                                        }),
                                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                            className: "lp-consent-modal-li-text",
                                                            children: line
                                                        })
                                                    ]
                                                }, key);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                                    className: "lp-consent-modal-visual",
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("img", {
                                        className: readMoreModal === "cookie" ? "lp-consent-modal-visual-img lp-consent-modal-visual-img--cookie" : "lp-consent-modal-visual-img",
                                        src: readMoreBundle.illustration,
                                        alt: "",
                                        width: readMoreModal === "cookie" ? 360 : 480,
                                        height: readMoreModal === "cookie" ? 232 : 520,
                                        decoding: "async"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }), document.body) : null,
            demoModal ? /*#__PURE__*/ (0, $4ed43828a92c8386$exports.createPortal)(/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "lp-demo-modal-backdrop",
                role: "presentation",
                onClick: closeDemoModal,
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                    className: "lp-demo-modal",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "lp-demo-modal-title",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                            type: "button",
                            className: "lp-demo-modal-close",
                            "aria-label": "Close",
                            onClick: closeDemoModal,
                            children: "\xd7"
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            className: "lp-demo-modal-head",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h2", {
                                id: "lp-demo-modal-title",
                                className: "lp-demo-modal-title",
                                children: "Request a demo"
                            })
                        }),
                        demoModal === "form" ? /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("form", {
                            className: "lp-demo-modal-body",
                            onSubmit: handleDemoFormSubmit,
                            noValidate: true,
                            children: [
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("label", {
                                            className: "lp-demo-modal-label",
                                            htmlFor: "lp-demo-fullname",
                                            children: [
                                                "Full name ",
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                    className: "lp-demo-modal-star",
                                                    "aria-hidden": true,
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                                            id: "lp-demo-fullname",
                                            className: "lp-demo-modal-input",
                                            name: "fullName",
                                            autoComplete: "name",
                                            placeholder: "e.g. Priya Sharma",
                                            value: demoForm.fullName,
                                            onChange: (e)=>setDemoForm((p)=>({
                                                        ...p,
                                                        fullName: e.target.value
                                                    }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("label", {
                                            className: "lp-demo-modal-label",
                                            htmlFor: "lp-demo-email",
                                            children: [
                                                "Work email ",
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                    className: "lp-demo-modal-star",
                                                    "aria-hidden": true,
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                                            id: "lp-demo-email",
                                            className: "lp-demo-modal-input",
                                            name: "email",
                                            type: "email",
                                            autoComplete: "email",
                                            placeholder: "you@company.com",
                                            value: demoForm.workEmail,
                                            onChange: (e)=>setDemoForm((p)=>({
                                                        ...p,
                                                        workEmail: e.target.value
                                                    }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("label", {
                                            className: "lp-demo-modal-label",
                                            htmlFor: "lp-demo-company",
                                            children: [
                                                "Company ",
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("span", {
                                                    className: "lp-demo-modal-star",
                                                    "aria-hidden": true,
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                                            id: "lp-demo-company",
                                            className: "lp-demo-modal-input",
                                            name: "organization",
                                            autoComplete: "organization",
                                            placeholder: "Organisation name",
                                            value: demoForm.company,
                                            onChange: (e)=>setDemoForm((p)=>({
                                                        ...p,
                                                        company: e.target.value
                                                    }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-row2",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                            className: "lp-demo-modal-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("label", {
                                                    className: "lp-demo-modal-label",
                                                    htmlFor: "lp-demo-phone",
                                                    children: "Phone"
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                                                    id: "lp-demo-phone",
                                                    className: "lp-demo-modal-input",
                                                    name: "tel",
                                                    type: "tel",
                                                    autoComplete: "tel",
                                                    placeholder: "Optional",
                                                    value: demoForm.phone,
                                                    onChange: (e)=>setDemoForm((p)=>({
                                                                ...p,
                                                                phone: e.target.value
                                                            }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                            className: "lp-demo-modal-field",
                                            children: [
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("label", {
                                                    className: "lp-demo-modal-label",
                                                    htmlFor: "lp-demo-job",
                                                    children: "Job title"
                                                }),
                                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                                                    id: "lp-demo-job",
                                                    className: "lp-demo-modal-input",
                                                    name: "jobTitle",
                                                    autoComplete: "organization-title",
                                                    placeholder: "Optional",
                                                    value: demoForm.jobTitle,
                                                    onChange: (e)=>setDemoForm((p)=>({
                                                                ...p,
                                                                jobTitle: e.target.value
                                                            }))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-field",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("label", {
                                            className: "lp-demo-modal-label",
                                            htmlFor: "lp-demo-message",
                                            children: "What would you like to see?"
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("textarea", {
                                            id: "lp-demo-message",
                                            className: "lp-demo-modal-textarea",
                                            name: "message",
                                            rows: 4,
                                            placeholder: "Modules of interest, timeline, or questions",
                                            value: demoForm.message,
                                            onChange: (e)=>setDemoForm((p)=>({
                                                        ...p,
                                                        message: e.target.value
                                                    }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-consent",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("input", {
                                            id: "lp-demo-consent",
                                            className: "lp-demo-modal-checkbox",
                                            type: "checkbox",
                                            checked: demoForm.consent,
                                            onChange: (e)=>setDemoForm((p)=>({
                                                        ...p,
                                                        consent: e.target.checked
                                                    }))
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("label", {
                                            htmlFor: "lp-demo-consent",
                                            className: "lp-demo-modal-consent-label",
                                            children: "I agree to be contacted about Jio Consent Management and understand I can withdraw this request at any time."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "lp-demo-modal-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                            type: "button",
                                            className: "lp-demo-modal-btn lp-demo-modal-btn--cancel",
                                            onClick: closeDemoModal,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                            type: "submit",
                                            className: "lp-demo-modal-btn lp-demo-modal-btn--submit",
                                            children: "Submit request"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                            className: "lp-demo-modal-success",
                            children: [
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("h3", {
                                    className: "lp-demo-modal-thanks",
                                    children: "Thank you"
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("p", {
                                    className: "lp-demo-modal-success-msg",
                                    children: "We've received your request. A member of our team will contact you shortly."
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("button", {
                                    type: "button",
                                    className: "lp-demo-modal-btn lp-demo-modal-btn--close-pill",
                                    onClick: closeDemoModal,
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            }), document.body) : null
        ]
    });
};
var $50e4f2d0505d6b18$export$2e2bcd8739ae039 = $50e4f2d0505d6b18$var$LandingPage;



parcelRequire("1OEoy");




const $4c31ff5029b1716c$var$ContactUs = ()=>{
    const navigate = (0, $68bc5e6b1c17c80f$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: "contact-page",
        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
            className: "contact-card",
            children: [
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                    className: "logoDiv",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            className: "logoStyle",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $04fc5138b12d9c4c$export$faf9e552d710fc5c), {})
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                            appearance: "heading-xxs",
                            children: "Consent Management"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                    className: "contact-content",
                    children: [
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                            className: "container-header",
                            children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                appearance: "heading-xs",
                                children: "Contact Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                            className: "contact-box",
                            children: [
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "contact-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                            appearance: "body-s-bold",
                                            color: "primary-80",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                            appearance: "body-s",
                                            color: "primary-grey-80",
                                            children: "support-consent@ril.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                                    className: "contact-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                            appearance: "body-s-bold",
                                            color: "primary-80",
                                            children: "Team Name"
                                        }),
                                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                                            appearance: "body-s",
                                            color: "primary-grey-80",
                                            children: "Consent Management Team"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$cfc7921d29ef7b80), {
                            label: "Back to Home",
                            onClick: ()=>navigate("/"),
                            stretch: true
                        })
                    ]
                })
            ]
        })
    });
};
var $4c31ff5029b1716c$export$2e2bcd8739ae039 = $4c31ff5029b1716c$var$ContactUs;




var $1OEoy = parcelRequire("1OEoy");




var $b8f12fe0859c7053$exports = {};
$b8f12fe0859c7053$exports = import.meta.resolve("5W97f");


var $0e070012a8d114b2$exports = {};
$0e070012a8d114b2$exports = import.meta.resolve("jIumq");


const $1f025e76048676c0$var$PDFViewer = ()=>{
    const { documentType: documentType } = (0, $68bc5e6b1c17c80f$export$99eaa27ddbbb95ef)();
    const navigate = (0, $68bc5e6b1c17c80f$export$9770f232ac06a008)();
    const [pdfUrl, setPdfUrl] = (0, $1OEoy.useState)(null);
    const [loading, setLoading] = (0, $1OEoy.useState)(true);
    const [error, setError] = (0, $1OEoy.useState)(null);
    (0, $1OEoy.useEffect)(()=>{
        let url = null;
        if (documentType === "terms-of-use" || documentType === "terms") url = (0, (/*@__PURE__*/$parcel$interopDefault($b8f12fe0859c7053$exports)));
        else if (documentType === "privacy-policy" || documentType === "privacy") url = (0, (/*@__PURE__*/$parcel$interopDefault($0e070012a8d114b2$exports)));
        if (url) {
            setPdfUrl(url);
            setLoading(false);
        } else {
            setError("Document not found");
            setLoading(false);
        }
    }, [
        documentType
    ]);
    (0, $1OEoy.useEffect)(()=>{
        if (!window._originalWindowOpen) window._originalWindowOpen = window.open.bind(window);
        const handlePDFLink = (url)=>{
            if (url && typeof url === "string") {
                if (url.includes("/pdf/privacy-policy") || url.includes("/pdf/terms-of-use")) {
                    if (url.includes("/pdf/privacy-policy")) {
                        navigate("/pdf/privacy-policy");
                        return true;
                    }
                    if (url.includes("/pdf/terms-of-use")) {
                        navigate("/pdf/terms-of-use");
                        return true;
                    }
                }
                if (url.includes("PrivacyPracticeStatementCMS") || url.includes("PrivacyPracticeStatement") || url.endsWith("PrivacyPracticeStatementCMS.pdf") || url.includes("/PrivacyPracticeStatementCMS.pdf")) {
                    navigate("/pdf/privacy-policy");
                    return true;
                }
                if (url.includes("TermsofUseCMS") || url.includes("TermsOfUse") || url.endsWith("TermsofUseCMS.pdf") || url.includes("/TermsofUseCMS.pdf")) {
                    navigate("/pdf/terms-of-use");
                    return true;
                }
            }
            return false;
        };
        window.open = function(url, target, features) {
            if (handlePDFLink(url)) return null;
            return window._originalWindowOpen.call(this, url, target, features);
        };
        return ()=>{
            window.open = window._originalWindowOpen;
        };
    }, [
        navigate
    ]);
    const handleClose = ()=>{
        navigate(-1);
    };
    const documentTitle = documentType === "terms-of-use" || documentType === "terms" ? "Terms of Use" : documentType === "privacy-policy" || documentType === "privacy" ? "Privacy Policy" : "Document";
    if (loading) return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: "pdf-viewer-container",
        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
            className: "pdf-viewer-loading",
            children: [
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$7f7cbe89f1eacd2), {
                    size: "large"
                }),
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                    appearance: "body-m",
                    color: "primary-grey-60",
                    children: "Loading document..."
                })
            ]
        })
    });
    if (error || !pdfUrl) return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
        className: "pdf-viewer-container",
        children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
            className: "pdf-viewer-error",
            children: [
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                    appearance: "heading-s",
                    color: "primary-grey-100",
                    children: "Document Not Found"
                }),
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                    appearance: "body-m",
                    color: "primary-grey-80",
                    children: error || "The requested document could not be loaded."
                }),
                /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$cfc7921d29ef7b80), {
                    label: "Go Back",
                    onClick: handleClose,
                    kind: "primary",
                    size: "medium"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
        className: "pdf-viewer-container",
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)("div", {
                className: "pdf-viewer-header",
                children: [
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$5f1af8db9871e1d6), {
                        appearance: "heading-s",
                        color: "primary-grey-100",
                        children: documentTitle
                    }),
                    /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$cfc7921d29ef7b80), {
                        icon: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $d3033cfe8927e2c5$export$48672c81f0c3f574), {}),
                        onClick: handleClose,
                        kind: "tertiary",
                        size: "medium",
                        label: "Close"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("div", {
                className: "pdf-viewer-content",
                children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)("iframe", {
                    src: pdfUrl,
                    title: documentTitle,
                    className: "pdf-iframe",
                    style: {
                        width: "100%",
                        height: "100%",
                        border: "none"
                    }
                })
            })
        ]
    });
};
var $1f025e76048676c0$export$2e2bcd8739ae039 = $1f025e76048676c0$var$PDFViewer;


const $032f0e83031b9978$var$Nav = ()=>{
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)((0, $68bc5e6b1c17c80f$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $68bc5e6b1c17c80f$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $50e4f2d0505d6b18$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $68bc5e6b1c17c80f$export$e7b0ac011bb776c6), {
                path: "/contact",
                element: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $4c31ff5029b1716c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $68bc5e6b1c17c80f$export$e7b0ac011bb776c6), {
                path: "/signup",
                element: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $6a50ea83fde84983$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $68bc5e6b1c17c80f$export$e7b0ac011bb776c6), {
                path: "/pdf/:documentType",
                element: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $1f025e76048676c0$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $68bc5e6b1c17c80f$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $68bc5e6b1c17c80f$export$444b3ab0cb9aec40), {
                    to: "/",
                    replace: true
                })
            })
        ]
    });
};
var $032f0e83031b9978$export$2e2bcd8739ae039 = $032f0e83031b9978$var$Nav;



parcelRequire("1OEoy");

const $4b3835dd041e93c8$var$FooterComponent = ()=>/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $451487d20aa3eb8a$export$a06f1c675e846f6f), {});
var $4b3835dd041e93c8$export$2e2bcd8739ae039 = $4b3835dd041e93c8$var$FooterComponent;



var $1OEoy = parcelRequire("1OEoy");

function $925704b0f0b3825d$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    (0, $1OEoy.useEffect)(()=>{
        // Scroll to the top of the page when the route changes
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        pathname
    ]);
    return null;
}




const $357ae01352eb1233$var$MARKETING_PATHS = new Set([
    "/",
    "/contact",
    "/signup"
]);
const $357ae01352eb1233$var$App = ()=>{
    const location = (0, $68bc5e6b1c17c80f$export$45d76561a5302f2b)();
    const showFooter = $357ae01352eb1233$var$MARKETING_PATHS.has(location.pathname) && location.pathname !== "/" && !location.pathname.startsWith("/pdf/");
    return /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsxs)((0, $ddff9b86434e3f59$export$e5cf4eff53e7947d), {
        value: {
            theme: "JioBase",
            mode: "light"
        },
        children: [
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $925704b0f0b3825d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $032f0e83031b9978$export$2e2bcd8739ae039), {}),
            showFooter && /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $4b3835dd041e93c8$export$2e2bcd8739ae039), {})
        ]
    });
};
var $357ae01352eb1233$export$2e2bcd8739ae039 = $357ae01352eb1233$var$App;



/* ==================================================================
 * COOKIE INJECTOR (for cookie scanning)
 * Auto-injects a fixed cookie set on EVERY page load — no click, no
 * consent gate — so a scanner opening this page in a fresh session can
 * discover the cookies. Uses the native cookie setter, so it works even
 * if the page has a consent blocker overriding document.cookie.
 * ================================================================== */ function $abe2c524a40ecb59$var$injectCookies() {
    // Cookies to inject, grouped by category. Edit to match your template.
    const SEED = {
        Necessary: [
            "session_id",
            "csrftoken",
            "XSRF-TOKEN"
        ],
        Analytics: [
            "_ga",
            "_gid",
            "_gat",
            "_clck"
        ],
        Advertisement: [
            "_fbp",
            "_gcl_au",
            "IDE",
            "MUID"
        ],
        Functional: [
            "lang",
            "pref_theme"
        ],
        Others: [
            "widget_state",
            "ab_variant"
        ]
    };
    const MAX_AGE = 31536000; // 1 year
    // Native (prototype-level) cookie setter — bypasses any document.cookie override.
    const desc = Object.getOwnPropertyDescriptor(Document.prototype, "cookie") || typeof HTMLDocument !== "undefined" && Object.getOwnPropertyDescriptor(HTMLDocument.prototype, "cookie");
    const set = desc && desc.set ? (s)=>desc.set.call(document, s) : (s)=>{
        document.cookie = s;
    };
    const secure = location.protocol === "https:" ? "; secure" : "";
    const names = [];
    Object.values(SEED).forEach((list)=>list.forEach((name)=>{
            const val = `${name}_${Math.random().toString(36).slice(2, 12)}`;
            set(`${name}=${encodeURIComponent(val)}; path=/; max-age=${MAX_AGE}; SameSite=Lax${secure}`);
            names.push(name);
        }));
    console.log(`[CookieInjector] injected ${names.length} cookies`, names);
}
try {
    $abe2c524a40ecb59$var$injectCookies();
} catch (e) {
    console.warn("[CookieInjector] failed:", e);
}
const $abe2c524a40ecb59$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($bb1dc4e9d49b5eb9$exports))).createRoot(document.getElementById("root"));
$abe2c524a40ecb59$var$root.render(/*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $2bcf391f4c2cee24$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7a9adcfb845e594f$exports.jsx)((0, $357ae01352eb1233$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=s.7d236b96.js.map
